/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: string | number;
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: string | number;
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: unknown;
  /** The day, does not include a time. */
  Date: Date | string;
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: Date | string;
  FullText: unknown;
  /** An IPv4 or IPv6 host address, and optionally its subnet. */
  InternetAddress: unknown;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  SqlIdentifier: unknown;
  /** The exact time of day, does not include the date. May or may not have a timezone offset. */
  Time: string;
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: string;
  /** The `Upload` scalar type represents a file upload. */
  Upload: unknown;
};

/** All input for the `addCompanyRoleToUser` mutation. */
export type AddCompanyRoleToUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our `addCompanyRoleToUser` mutation. */
export type AddCompanyRoleToUserPayload = {
  __typename?: 'AddCompanyRoleToUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserCompanyRole`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Role` that is related to this `UserCompanyRole`. */
  role?: Maybe<Role>;
  /** Reads a single `User` that is related to this `UserCompanyRole`. */
  user?: Maybe<User>;
  userCompanyRole?: Maybe<UserCompanyRole>;
  /** An edge for our `UserCompanyRole`. May be used by Relay 1. */
  userCompanyRoleEdge?: Maybe<UserCompanyRolesEdge>;
};


/** The output of our `addCompanyRoleToUser` mutation. */
export type AddCompanyRoleToUserPayloadUserCompanyRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCompanyRolesOrderBy>>;
};

/** All input for the `addDepartmentRoleToUser` mutation. */
export type AddDepartmentRoleToUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  departmentId: Scalars['UUID'];
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our `addDepartmentRoleToUser` mutation. */
export type AddDepartmentRoleToUserPayload = {
  __typename?: 'AddDepartmentRoleToUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserDepartmentRole`. */
  company?: Maybe<Company>;
  /** Reads a single `Department` that is related to this `UserDepartmentRole`. */
  department?: Maybe<Department>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Role` that is related to this `UserDepartmentRole`. */
  role?: Maybe<Role>;
  /** Reads a single `User` that is related to this `UserDepartmentRole`. */
  user?: Maybe<User>;
  userDepartmentRole?: Maybe<UserDepartmentRole>;
  /** An edge for our `UserDepartmentRole`. May be used by Relay 1. */
  userDepartmentRoleEdge?: Maybe<UserDepartmentRolesEdge>;
};


/** The output of our `addDepartmentRoleToUser` mutation. */
export type AddDepartmentRoleToUserPayloadUserDepartmentRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserDepartmentRolesOrderBy>>;
};

/** All input for the `addRoleToGroup` mutation. */
export type AddRoleToGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupId: Scalars['UUID'];
  roleId: Scalars['UUID'];
};

/** The output of our `addRoleToGroup` mutation. */
export type AddRoleToGroupPayload = {
  __typename?: 'AddRoleToGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `GroupRole`. */
  company?: Maybe<Company>;
  /** Reads a single `Group` that is related to this `GroupRole`. */
  group?: Maybe<Group>;
  groupRole?: Maybe<GroupRole>;
  /** An edge for our `GroupRole`. May be used by Relay 1. */
  groupRoleEdge?: Maybe<GroupRolesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Role` that is related to this `GroupRole`. */
  role?: Maybe<Role>;
};


/** The output of our `addRoleToGroup` mutation. */
export type AddRoleToGroupPayloadGroupRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupRolesOrderBy>>;
};

/** All input for the `addRoleToUser` mutation. */
export type AddRoleToUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our `addRoleToUser` mutation. */
export type AddRoleToUserPayload = {
  __typename?: 'AddRoleToUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserRole`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Role` that is related to this `UserRole`. */
  role?: Maybe<Role>;
  /** Reads a single `User` that is related to this `UserRole`. */
  user?: Maybe<User>;
  userRole?: Maybe<UserRole>;
  /** An edge for our `UserRole`. May be used by Relay 1. */
  userRoleEdge?: Maybe<UserRolesEdge>;
};


/** The output of our `addRoleToUser` mutation. */
export type AddRoleToUserPayloadUserRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
};

/** All input for the `adminCreateCompanyWithRelations` mutation. */
export type AdminCreateCompanyWithRelationsInput = {
  argAddress?: InputMaybe<Scalars['String']>;
  argCity?: InputMaybe<Scalars['String']>;
  argCompanyBindingId?: InputMaybe<Scalars['Int']>;
  argCompanyTypeId?: InputMaybe<Scalars['UUID']>;
  argCvr?: InputMaybe<Scalars['String']>;
  argEmail?: InputMaybe<Scalars['String']>;
  argFirstName?: InputMaybe<Scalars['String']>;
  argJobPositionTitle?: InputMaybe<Scalars['String']>;
  argJobPositionType?: InputMaybe<Scalars['String']>;
  argLastName?: InputMaybe<Scalars['String']>;
  argLocale?: InputMaybe<Scalars['String']>;
  argMobile?: InputMaybe<Scalars['String']>;
  argName?: InputMaybe<Scalars['String']>;
  argPNumber?: InputMaybe<Scalars['Int']>;
  argPostalCode?: InputMaybe<Scalars['String']>;
  argUrl?: InputMaybe<Scalars['String']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `adminCreateCompanyWithRelations` mutation. */
export type AdminCreateCompanyWithRelationsPayload = {
  __typename?: 'AdminCreateCompanyWithRelationsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  /** An edge for our `Company`. May be used by Relay 1. */
  companyEdge?: Maybe<CompaniesEdge>;
  /** Reads a single `Company` that is related to this `Company`. */
  masterForCompany?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `adminCreateCompanyWithRelations` mutation. */
export type AdminCreateCompanyWithRelationsPayloadCompanyEdgeArgs = {
  orderBy?: InputMaybe<Array<CompaniesOrderBy>>;
};

export type AnalyseCsvEmployeeRecordUpdateFileInput = {
  csvFile: Scalars['Upload'];
  delimiter?: InputMaybe<Scalars['String']>;
  employeeRecordFieldId: Scalars['UUID'];
};

export type AnalyseCsvEmployeeRecordUpdateFilePayload = {
  __typename?: 'AnalyseCsvEmployeeRecordUpdateFilePayload';
  errors: Array<ErrorMessage>;
};

export type AnalyseCsvEmployeeUpdateFileInput = {
  clearFieldValuesWhenEmpty?: InputMaybe<Scalars['Boolean']>;
  csvFile: Scalars['Upload'];
  delimiter?: InputMaybe<Scalars['String']>;
  mappings: Array<CsvMappingInput>;
};

export type AnalyseCsvEmployeeUpdateFilePayload = {
  __typename?: 'AnalyseCsvEmployeeUpdateFilePayload';
  errors: Array<ErrorMessage>;
};

export type AnalyseImportEmployeesFromFileInput = {
  delimiter?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  mappings: Array<CsvMappingInput>;
  useDefaultCustomFieldValues?: InputMaybe<Scalars['Boolean']>;
};

export type AnalyseImportEmployeesFromFilePayload = {
  __typename?: 'AnalyseImportEmployeesFromFilePayload';
  errors: Array<ErrorMessage>;
};

export type AnalyseImportEquipmentFromFileInput = {
  file: Scalars['Upload'];
};

export type AnalyseImportEquipmentFromFilePayload = {
  __typename?: 'AnalyseImportEquipmentFromFilePayload';
  errors: Array<ErrorMessage>;
};

export type Announcement = {
  __typename?: 'Announcement';
  active: Scalars['Boolean'];
  addPlayIcon: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `Announcement`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  departmentIds: Array<Maybe<Scalars['UUID']>>;
  expireAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  locales: Array<Maybe<Scalars['String']>>;
  popup: Scalars['Boolean'];
  publishAt?: Maybe<Scalars['Datetime']>;
  publishAtReminded: Scalars['Boolean'];
  published: Scalars['Boolean'];
  read?: Maybe<Scalars['Boolean']>;
  systemAnnouncement: Scalars['Boolean'];
  teaser?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  url?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Announcement`. */
  user?: Maybe<User>;
  /** Reads and enables pagination through a set of `UserAnnouncement`. */
  userAnnouncements: UserAnnouncementsConnection;
  userId?: Maybe<Scalars['UUID']>;
};


export type AnnouncementUserAnnouncementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserAnnouncementCondition>;
  filter?: InputMaybe<UserAnnouncementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserAnnouncementsOrderBy>>;
};

/** The fields on `announcement` to look up the row to connect. */
export type AnnouncementAnnouncementPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `announcement` to be created by this mutation. */
export type AnnouncementCompanyIdForeignConnectionAnnouncementCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addPlayIcon?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<AnnouncementCompanyIdForeignInput>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  popup?: InputMaybe<Scalars['Boolean']>;
  publishAt?: InputMaybe<Scalars['Datetime']>;
  publishAtReminded?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  systemAnnouncement?: InputMaybe<Scalars['Boolean']>;
  teaser?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<AnnouncementUserIdForeignInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementAnnouncementIdForeignInverseInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `AnnouncementInput` mutation. */
export type AnnouncementCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnAnnouncementForAnnouncementCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `announcement` in the `CompanyInput` mutation. */
export type AnnouncementCompanyIdForeignInverseInput = {
  /** The primary key(s) for `announcement` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AnnouncementAnnouncementPkeyConnect>>;
  /** A `AnnouncementInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AnnouncementCompanyIdForeignConnectionAnnouncementCreateInput>>;
  /** The primary key(s) and patch data for `announcement` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AnnouncementOnAnnouncementForAnnouncementCompanyIdForeignUsingAnnouncementPkeyUpdate>>;
};

/**
 * A condition to be used against `Announcement` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AnnouncementCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `addPlayIcon` field. */
  addPlayIcon?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `content` field. */
  content?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `expireAt` field. */
  expireAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `locales` field. */
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `popup` field. */
  popup?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `publishAt` field. */
  publishAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `publishAtReminded` field. */
  publishAtReminded?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `published` field. */
  published?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `systemAnnouncement` field. */
  systemAnnouncement?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `teaser` field. */
  teaser?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `url` field. */
  url?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `Announcement` object types. All fields are combined with a logical ‘and.’ */
export type AnnouncementFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `addPlayIcon` field. */
  addPlayIcon?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AnnouncementFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `content` field. */
  content?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `expireAt` field. */
  expireAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `locales` field. */
  locales?: InputMaybe<StringListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AnnouncementFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AnnouncementFilter>>;
  /** Filter by the object’s `popup` field. */
  popup?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `publishAt` field. */
  publishAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `publishAtReminded` field. */
  publishAtReminded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `published` field. */
  published?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `read` field. */
  read?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `systemAnnouncement` field. */
  systemAnnouncement?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `teaser` field. */
  teaser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `url` field. */
  url?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userAnnouncements` relation. */
  userAnnouncements?: InputMaybe<AnnouncementToManyUserAnnouncementFilter>;
  /** Some related `userAnnouncements` exist. */
  userAnnouncementsExist?: InputMaybe<Scalars['Boolean']>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `Announcement` */
export type AnnouncementInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addPlayIcon?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<AnnouncementCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  popup?: InputMaybe<Scalars['Boolean']>;
  publishAt?: InputMaybe<Scalars['Datetime']>;
  publishAtReminded?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  systemAnnouncement?: InputMaybe<Scalars['Boolean']>;
  teaser?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<AnnouncementUserIdForeignInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementAnnouncementIdForeignInverseInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `announcement` to look up the row to update. */
export type AnnouncementOnAnnouncementForAnnouncementCompanyIdForeignUsingAnnouncementPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `announcement` being updated. */
  patch: UpdateAnnouncementOnAnnouncementForAnnouncementCompanyIdForeignPatch;
};

/** The fields on `announcement` to look up the row to update. */
export type AnnouncementOnAnnouncementForAnnouncementUserIdForeignUsingAnnouncementPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `announcement` being updated. */
  patch: UpdateAnnouncementOnAnnouncementForAnnouncementUserIdForeignPatch;
};

/** The fields on `announcement` to look up the row to update. */
export type AnnouncementOnUserAnnouncementForUserAnnouncementAnnouncementIdForeignUsingAnnouncementPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `announcement` being updated. */
  patch: UpdateAnnouncementOnUserAnnouncementForUserAnnouncementAnnouncementIdForeignPatch;
};

/** Represents an update to a `Announcement`. Fields that are set will be updated. */
export type AnnouncementPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addPlayIcon?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<AnnouncementCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  popup?: InputMaybe<Scalars['Boolean']>;
  publishAt?: InputMaybe<Scalars['Datetime']>;
  publishAtReminded?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  systemAnnouncement?: InputMaybe<Scalars['Boolean']>;
  teaser?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<AnnouncementUserIdForeignInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementAnnouncementIdForeignInverseInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** All input for the `announcementReadAll` mutation. */
export type AnnouncementReadAllInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `announcementReadAll` mutation. */
export type AnnouncementReadAllPayload = {
  __typename?: 'AnnouncementReadAllPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A filter to be used against many `UserAnnouncement` object types. All fields are combined with a logical ‘and.’ */
export type AnnouncementToManyUserAnnouncementFilter = {
  /** Every related `UserAnnouncement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserAnnouncementFilter>;
  /** No related `UserAnnouncement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserAnnouncementFilter>;
  /** Some related `UserAnnouncement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserAnnouncementFilter>;
};

/** The `announcement` to be created by this mutation. */
export type AnnouncementUserIdForeignConnectionAnnouncementCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addPlayIcon?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<AnnouncementCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  popup?: InputMaybe<Scalars['Boolean']>;
  publishAt?: InputMaybe<Scalars['Datetime']>;
  publishAtReminded?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  systemAnnouncement?: InputMaybe<Scalars['Boolean']>;
  teaser?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<AnnouncementUserIdForeignInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementAnnouncementIdForeignInverseInput>;
};

/** Input for the nested mutation of `user` in the `AnnouncementInput` mutation. */
export type AnnouncementUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnAnnouncementForAnnouncementUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `announcement` in the `UserInput` mutation. */
export type AnnouncementUserIdForeignInverseInput = {
  /** The primary key(s) for `announcement` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AnnouncementAnnouncementPkeyConnect>>;
  /** A `AnnouncementInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AnnouncementUserIdForeignConnectionAnnouncementCreateInput>>;
  /** The primary key(s) and patch data for `announcement` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AnnouncementOnAnnouncementForAnnouncementUserIdForeignUsingAnnouncementPkeyUpdate>>;
};

/** A connection to a list of `Announcement` values. */
export type AnnouncementsConnection = {
  __typename?: 'AnnouncementsConnection';
  /** A list of edges which contains the `Announcement` and cursor to aid in pagination. */
  edges: Array<AnnouncementsEdge>;
  /** A list of `Announcement` objects. */
  nodes: Array<Maybe<Announcement>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Announcement` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Announcement` edge in the connection. */
export type AnnouncementsEdge = {
  __typename?: 'AnnouncementsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Announcement` at the end of the edge. */
  node?: Maybe<Announcement>;
};

/** Methods to use when ordering `Announcement`. */
export type AnnouncementsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ADD_PLAY_ICON_ASC'
  | 'ADD_PLAY_ICON_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CONTENT_ASC'
  | 'CONTENT_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'EXPIRE_AT_ASC'
  | 'EXPIRE_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALES_ASC'
  | 'LOCALES_DESC'
  | 'NATURAL'
  | 'POPUP_ASC'
  | 'POPUP_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PUBLISHED_ASC'
  | 'PUBLISHED_DESC'
  | 'PUBLISH_AT_ASC'
  | 'PUBLISH_AT_DESC'
  | 'PUBLISH_AT_REMINDED_ASC'
  | 'PUBLISH_AT_REMINDED_DESC'
  | 'SYSTEM_ANNOUNCEMENT_ASC'
  | 'SYSTEM_ANNOUNCEMENT_DESC'
  | 'TEASER_ASC'
  | 'TEASER_DESC'
  | 'TITLE_ASC'
  | 'TITLE_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'URL_ASC'
  | 'URL_DESC'
  | 'USER_ANNOUNCEMENTS_BY_ANNOUNCEMENT_ID__COUNT_ASC'
  | 'USER_ANNOUNCEMENTS_BY_ANNOUNCEMENT_ID__COUNT_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type ApplicationConnection = {
  __typename?: 'ApplicationConnection';
  edges?: Maybe<Array<Maybe<ApplicationEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ApplicationEdge = {
  __typename?: 'ApplicationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<ApplicationPayload>;
};

export type ApplicationFieldMapping = {
  __typename?: 'ApplicationFieldMapping';
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ApplicationFileType = {
  __typename?: 'ApplicationFileType';
  cache?: Maybe<Scalars['String']>;
  hashid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ApplicationPayload = {
  __typename?: 'ApplicationPayload';
  address?: Maybe<Scalars['String']>;
  caseFileIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  city?: Maybe<Scalars['String']>;
  companyId: Scalars['Int'];
  country?: Maybe<Scalars['String']>;
  customFieldValues?: Maybe<Array<Maybe<CustomFieldValueType>>>;
  email: Scalars['String'];
  emailWork: Scalars['String'];
  files?: Maybe<Array<Maybe<ApplicationFileType>>>;
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['String'];
  jobPositionTitle?: Maybe<Scalars['String']>;
  jobPositionType?: Maybe<Array<Scalars['String']>>;
  lastName: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  mappedFields?: Maybe<Array<Maybe<ApplicationFieldMapping>>>;
  mobilePrivate?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
};

export type ApplyTimeRegistrationTemplateInput = {
  timeRegistrationTemplateId: Scalars['UUID'];
};

export type Approval = {
  __typename?: 'Approval';
  active: Scalars['Boolean'];
  /** Reads a single `User` that is related to this `Approval`. */
  affectedUser?: Maybe<User>;
  affectedUserDepartmentIds: Array<Maybe<Scalars['UUID']>>;
  affectedUserId?: Maybe<Scalars['UUID']>;
  approvedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `User` that is related to this `Approval`. */
  approvingUser?: Maybe<User>;
  approvingUserId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Company` that is related to this `Approval`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  deadline?: Maybe<Scalars['Datetime']>;
  deniedAt?: Maybe<Scalars['Datetime']>;
  /**
   * Reads and enables pagination through a set of `FutureDatum`.
   * @deprecated Please use futureDatumByApprovalId instead
   */
  futureData: FutureDataConnection;
  /** Reads a single `FutureDatum` that is related to this `Approval`. */
  futureDatumByApprovalId?: Maybe<FutureDatum>;
  id: Scalars['UUID'];
  isDeletionRequest: Scalars['Boolean'];
  itemId?: Maybe<Scalars['UUID']>;
  /** Reads a single `User` that is related to this `Approval`. */
  requestingUser?: Maybe<User>;
  requestingUserId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `TimeRegistrationPresence`. */
  timeRegistrationPresences: TimeRegistrationPresencesConnection;
  type: ApprovalType;
  /** Reads a single `VacationUser` that is related to this `Approval`. */
  vacationUserByApprovalId?: Maybe<VacationUser>;
  /** Reads a single `VacationUser` that is related to this `Approval`. */
  vacationUserByDeletionApprovalId?: Maybe<VacationUser>;
  /**
   * Reads and enables pagination through a set of `VacationUser`.
   * @deprecated Please use vacationUserByApprovalId instead
   */
  vacationUsers: VacationUsersConnection;
  /**
   * Reads and enables pagination through a set of `VacationUser`.
   * @deprecated Please use vacationUserByDeletionApprovalId instead
   */
  vacationUsersByDeletionApprovalId: VacationUsersConnection;
};


export type ApprovalFutureDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FutureDatumCondition>;
  filter?: InputMaybe<FutureDatumFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FutureDataOrderBy>>;
};


export type ApprovalTimeRegistrationPresencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationPresenceCondition>;
  filter?: InputMaybe<TimeRegistrationPresenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationPresencesOrderBy>>;
};


export type ApprovalVacationUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VacationUserCondition>;
  filter?: InputMaybe<VacationUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VacationUsersOrderBy>>;
};


export type ApprovalVacationUsersByDeletionApprovalIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VacationUserCondition>;
  filter?: InputMaybe<VacationUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VacationUsersOrderBy>>;
};

/** The `approval` to be created by this mutation. */
export type ApprovalAffectedUserIdForeignConnectionApprovalCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  affectedUserDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  approvingUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<ApprovalCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  deniedAt?: InputMaybe<Scalars['Datetime']>;
  futureDatum?: InputMaybe<FutureDataApprovalIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isDeletionRequest?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['UUID']>;
  requestingUserId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInverseInput>;
  type: ApprovalType;
  user?: InputMaybe<ApprovalRequestingUserIdForeignInput>;
  vacationUserToApprovalIdUsingId?: InputMaybe<VacationUserApprovalIdForeignInverseInput>;
  vacationUserToDeletionApprovalIdUsingId?: InputMaybe<VacationUserDeletionApprovalIdForeignInverseInput>;
};

/** Input for the nested mutation of `approval` in the `UserInput` mutation. */
export type ApprovalAffectedUserIdForeignInverseInput = {
  /** The primary key(s) for `approval` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ApprovalApprovalPkeyConnect>>;
  /** A `ApprovalInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ApprovalAffectedUserIdForeignConnectionApprovalCreateInput>>;
  /** The primary key(s) and patch data for `approval` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ApprovalOnApprovalForApprovalAffectedUserIdForeignUsingApprovalPkeyUpdate>>;
};

/** The fields on `approval` to look up the row to connect. */
export type ApprovalApprovalPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `approval` to be created by this mutation. */
export type ApprovalApprovingUserIdForeignConnectionApprovalCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  affectedUserDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  affectedUserId?: InputMaybe<Scalars['UUID']>;
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<ApprovalCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  deniedAt?: InputMaybe<Scalars['Datetime']>;
  futureDatum?: InputMaybe<FutureDataApprovalIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isDeletionRequest?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['UUID']>;
  requestingUserId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInverseInput>;
  type: ApprovalType;
  user?: InputMaybe<ApprovalRequestingUserIdForeignInput>;
  vacationUserToApprovalIdUsingId?: InputMaybe<VacationUserApprovalIdForeignInverseInput>;
  vacationUserToDeletionApprovalIdUsingId?: InputMaybe<VacationUserDeletionApprovalIdForeignInverseInput>;
};

/** Input for the nested mutation of `approval` in the `UserInput` mutation. */
export type ApprovalApprovingUserIdForeignInverseInput = {
  /** The primary key(s) for `approval` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ApprovalApprovalPkeyConnect>>;
  /** A `ApprovalInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ApprovalApprovingUserIdForeignConnectionApprovalCreateInput>>;
  /** The primary key(s) and patch data for `approval` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ApprovalOnApprovalForApprovalApprovingUserIdForeignUsingApprovalPkeyUpdate>>;
};

/** The `approval` to be created by this mutation. */
export type ApprovalCompanyIdForeignConnectionApprovalCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  affectedUserDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  affectedUserId?: InputMaybe<Scalars['UUID']>;
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  approvingUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<ApprovalCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  deniedAt?: InputMaybe<Scalars['Datetime']>;
  futureDatum?: InputMaybe<FutureDataApprovalIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isDeletionRequest?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['UUID']>;
  requestingUserId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInverseInput>;
  type: ApprovalType;
  user?: InputMaybe<ApprovalRequestingUserIdForeignInput>;
  vacationUserToApprovalIdUsingId?: InputMaybe<VacationUserApprovalIdForeignInverseInput>;
  vacationUserToDeletionApprovalIdUsingId?: InputMaybe<VacationUserDeletionApprovalIdForeignInverseInput>;
};

/** Input for the nested mutation of `company` in the `ApprovalInput` mutation. */
export type ApprovalCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnApprovalForApprovalCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `approval` in the `CompanyInput` mutation. */
export type ApprovalCompanyIdForeignInverseInput = {
  /** The primary key(s) for `approval` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ApprovalApprovalPkeyConnect>>;
  /** A `ApprovalInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ApprovalCompanyIdForeignConnectionApprovalCreateInput>>;
  /** The primary key(s) and patch data for `approval` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ApprovalOnApprovalForApprovalCompanyIdForeignUsingApprovalPkeyUpdate>>;
};

/**
 * A condition to be used against `Approval` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ApprovalCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `affectedUserDepartmentIds` field. */
  affectedUserDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `affectedUserId` field. */
  affectedUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `approvedAt` field. */
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `approvingUserId` field. */
  approvingUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deadline` field. */
  deadline?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deniedAt` field. */
  deniedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isDeletionRequest` field. */
  isDeletionRequest?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `itemId` field. */
  itemId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `requestingUserId` field. */
  requestingUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<ApprovalType>;
};

/** A filter to be used against `Approval` object types. All fields are combined with a logical ‘and.’ */
export type ApprovalFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `affectedUser` relation. */
  affectedUser?: InputMaybe<UserFilter>;
  /** Filter by the object’s `affectedUserDepartmentIds` field. */
  affectedUserDepartmentIds?: InputMaybe<UuidListFilter>;
  /** A related `affectedUser` exists. */
  affectedUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `affectedUserId` field. */
  affectedUserId?: InputMaybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ApprovalFilter>>;
  /** Filter by the object’s `approvedAt` field. */
  approvedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `approvingUser` relation. */
  approvingUser?: InputMaybe<UserFilter>;
  /** A related `approvingUser` exists. */
  approvingUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `approvingUserId` field. */
  approvingUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deadline` field. */
  deadline?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deniedAt` field. */
  deniedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `futureDatumByApprovalId` relation. */
  futureDatumByApprovalId?: InputMaybe<FutureDatumFilter>;
  /** A related `futureDatumByApprovalId` exists. */
  futureDatumByApprovalIdExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isDeletionRequest` field. */
  isDeletionRequest?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `itemId` field. */
  itemId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ApprovalFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ApprovalFilter>>;
  /** Filter by the object’s `requestingUser` relation. */
  requestingUser?: InputMaybe<UserFilter>;
  /** A related `requestingUser` exists. */
  requestingUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `requestingUserId` field. */
  requestingUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `timeRegistrationPresences` relation. */
  timeRegistrationPresences?: InputMaybe<ApprovalToManyTimeRegistrationPresenceFilter>;
  /** Some related `timeRegistrationPresences` exist. */
  timeRegistrationPresencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<ApprovalTypeFilter>;
  /** Filter by the object’s `vacationUserByApprovalId` relation. */
  vacationUserByApprovalId?: InputMaybe<VacationUserFilter>;
  /** A related `vacationUserByApprovalId` exists. */
  vacationUserByApprovalIdExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `vacationUserByDeletionApprovalId` relation. */
  vacationUserByDeletionApprovalId?: InputMaybe<VacationUserFilter>;
  /** A related `vacationUserByDeletionApprovalId` exists. */
  vacationUserByDeletionApprovalIdExists?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `Approval` */
export type ApprovalInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  affectedUserDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  affectedUserId?: InputMaybe<Scalars['UUID']>;
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  approvingUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<ApprovalCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  deniedAt?: InputMaybe<Scalars['Datetime']>;
  futureDatum?: InputMaybe<FutureDataApprovalIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isDeletionRequest?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['UUID']>;
  requestingUserId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInverseInput>;
  type: ApprovalType;
  user?: InputMaybe<ApprovalRequestingUserIdForeignInput>;
  vacationUserToApprovalIdUsingId?: InputMaybe<VacationUserApprovalIdForeignInverseInput>;
  vacationUserToDeletionApprovalIdUsingId?: InputMaybe<VacationUserDeletionApprovalIdForeignInverseInput>;
};

/** The fields on `approval` to look up the row to update. */
export type ApprovalOnApprovalForApprovalAffectedUserIdForeignUsingApprovalPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `approval` being updated. */
  patch: UpdateApprovalOnApprovalForApprovalAffectedUserIdForeignPatch;
};

/** The fields on `approval` to look up the row to update. */
export type ApprovalOnApprovalForApprovalApprovingUserIdForeignUsingApprovalPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `approval` being updated. */
  patch: UpdateApprovalOnApprovalForApprovalApprovingUserIdForeignPatch;
};

/** The fields on `approval` to look up the row to update. */
export type ApprovalOnApprovalForApprovalCompanyIdForeignUsingApprovalPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `approval` being updated. */
  patch: UpdateApprovalOnApprovalForApprovalCompanyIdForeignPatch;
};

/** The fields on `approval` to look up the row to update. */
export type ApprovalOnApprovalForApprovalRequestingUserIdForeignUsingApprovalPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `approval` being updated. */
  patch: UpdateApprovalOnApprovalForApprovalRequestingUserIdForeignPatch;
};

/** The fields on `approval` to look up the row to update. */
export type ApprovalOnFutureDatumForFutureDataApprovalIdForeignUsingApprovalPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `approval` being updated. */
  patch: UpdateApprovalOnFutureDatumForFutureDataApprovalIdForeignPatch;
};

/** The fields on `approval` to look up the row to update. */
export type ApprovalOnTimeRegistrationPresenceForTimeRegistrationPresenceApprovalIdForeignUsingApprovalPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `approval` being updated. */
  patch: UpdateApprovalOnTimeRegistrationPresenceForTimeRegistrationPresenceApprovalIdForeignPatch;
};

/** The fields on `approval` to look up the row to update. */
export type ApprovalOnVacationUserForVacationUserDeletionApprovalIdForeignUsingApprovalPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `approval` being updated. */
  patch: UpdateApprovalOnVacationUserForVacationUserDeletionApprovalIdForeignPatch;
};

/** Represents an update to a `Approval`. Fields that are set will be updated. */
export type ApprovalPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  affectedUserDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  affectedUserId?: InputMaybe<Scalars['UUID']>;
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  approvingUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<ApprovalCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  deniedAt?: InputMaybe<Scalars['Datetime']>;
  futureDatum?: InputMaybe<FutureDataApprovalIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isDeletionRequest?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['UUID']>;
  requestingUserId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInverseInput>;
  type?: InputMaybe<ApprovalType>;
  user?: InputMaybe<ApprovalRequestingUserIdForeignInput>;
  vacationUserToApprovalIdUsingId?: InputMaybe<VacationUserApprovalIdForeignInverseInput>;
  vacationUserToDeletionApprovalIdUsingId?: InputMaybe<VacationUserDeletionApprovalIdForeignInverseInput>;
};

/** The `approval` to be created by this mutation. */
export type ApprovalRequestingUserIdForeignConnectionApprovalCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  affectedUserDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  affectedUserId?: InputMaybe<Scalars['UUID']>;
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  approvingUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<ApprovalCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  deniedAt?: InputMaybe<Scalars['Datetime']>;
  futureDatum?: InputMaybe<FutureDataApprovalIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isDeletionRequest?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInverseInput>;
  type: ApprovalType;
  user?: InputMaybe<ApprovalRequestingUserIdForeignInput>;
  vacationUserToApprovalIdUsingId?: InputMaybe<VacationUserApprovalIdForeignInverseInput>;
  vacationUserToDeletionApprovalIdUsingId?: InputMaybe<VacationUserDeletionApprovalIdForeignInverseInput>;
};

/** Input for the nested mutation of `user` in the `ApprovalInput` mutation. */
export type ApprovalRequestingUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnApprovalForApprovalRequestingUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `approval` in the `UserInput` mutation. */
export type ApprovalRequestingUserIdForeignInverseInput = {
  /** The primary key(s) for `approval` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ApprovalApprovalPkeyConnect>>;
  /** A `ApprovalInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ApprovalRequestingUserIdForeignConnectionApprovalCreateInput>>;
  /** The primary key(s) and patch data for `approval` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ApprovalOnApprovalForApprovalRequestingUserIdForeignUsingApprovalPkeyUpdate>>;
};

/** A filter to be used against many `TimeRegistrationPresence` object types. All fields are combined with a logical ‘and.’ */
export type ApprovalToManyTimeRegistrationPresenceFilter = {
  /** Every related `TimeRegistrationPresence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationPresenceFilter>;
  /** No related `TimeRegistrationPresence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationPresenceFilter>;
  /** Some related `TimeRegistrationPresence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationPresenceFilter>;
};

export type ApprovalType =
  /** Approval of updates to system field and form field values */
  | 'FIELD_UPDATE'
  /** Approval of time registrations */
  | 'TIME_REGISTRATION'
  /** Approval of requested vacation and absence */
  | 'VACATION';

/** A filter to be used against ApprovalType fields. All fields are combined with a logical ‘and.’ */
export type ApprovalTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ApprovalType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ApprovalType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ApprovalType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ApprovalType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ApprovalType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ApprovalType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ApprovalType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ApprovalType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ApprovalType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ApprovalType>>;
};

/** A connection to a list of `Approval` values. */
export type ApprovalsConnection = {
  __typename?: 'ApprovalsConnection';
  /** A list of edges which contains the `Approval` and cursor to aid in pagination. */
  edges: Array<ApprovalsEdge>;
  /** A list of `Approval` objects. */
  nodes: Array<Maybe<Approval>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Approval` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Approval` edge in the connection. */
export type ApprovalsEdge = {
  __typename?: 'ApprovalsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Approval` at the end of the edge. */
  node?: Maybe<Approval>;
};

/** Methods to use when ordering `Approval`. */
export type ApprovalsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'AFFECTED_USER_DEPARTMENT_IDS_ASC'
  | 'AFFECTED_USER_DEPARTMENT_IDS_DESC'
  | 'AFFECTED_USER_ID_ASC'
  | 'AFFECTED_USER_ID_DESC'
  | 'APPROVED_AT_ASC'
  | 'APPROVED_AT_DESC'
  | 'APPROVING_USER_ID_ASC'
  | 'APPROVING_USER_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEADLINE_ASC'
  | 'DEADLINE_DESC'
  | 'DENIED_AT_ASC'
  | 'DENIED_AT_DESC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__ACTIVE_ASC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__ACTIVE_DESC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__APPROVAL_ID_ASC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__APPROVAL_ID_DESC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__COMPANY_ID_ASC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__COMPANY_ID_DESC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__CREATED_AT_ASC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__CREATED_AT_DESC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__CREATOR_USER_ID_ASC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__CREATOR_USER_ID_DESC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__DEPARTMENT_IDS_ASC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__DEPARTMENT_IDS_DESC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__FIELD_GROUP_ID_ASC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__FIELD_GROUP_ID_DESC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__FORM_FIELD_ID_ASC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__FORM_FIELD_ID_DESC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__ID_ASC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__ID_DESC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__LEADER_DEPARTMENT_IDS_ASC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__LEADER_DEPARTMENT_IDS_DESC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__SYSTEM_FIELD_ID_ASC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__SYSTEM_FIELD_ID_DESC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__UNIQUE_KEY_ASC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__UNIQUE_KEY_DESC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__UPDATE_VALUE_AT_ASC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__UPDATE_VALUE_AT_DESC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__USER_ID_ASC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__USER_ID_DESC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__VALUE_ASC'
  | 'FUTURE_DATUM_BY_APPROVAL_ID__VALUE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IS_DELETION_REQUEST_ASC'
  | 'IS_DELETION_REQUEST_DESC'
  | 'ITEM_ID_ASC'
  | 'ITEM_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REQUESTING_USER_ID_ASC'
  | 'REQUESTING_USER_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCES_BY_APPROVAL_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_PRESENCES_BY_APPROVAL_ID__COUNT_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | 'USER_BY_AFFECTED_USER_ID__ACTIVE_ASC'
  | 'USER_BY_AFFECTED_USER_ID__ACTIVE_DESC'
  | 'USER_BY_AFFECTED_USER_ID__ADDRESS_ASC'
  | 'USER_BY_AFFECTED_USER_ID__ADDRESS_DESC'
  | 'USER_BY_AFFECTED_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_AFFECTED_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_AFFECTED_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_AFFECTED_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_AFFECTED_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_AFFECTED_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_AFFECTED_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_AFFECTED_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_AFFECTED_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_AFFECTED_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_AFFECTED_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_AFFECTED_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_AFFECTED_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_AFFECTED_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_AFFECTED_USER_ID__CITY_ASC'
  | 'USER_BY_AFFECTED_USER_ID__CITY_DESC'
  | 'USER_BY_AFFECTED_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_AFFECTED_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_AFFECTED_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_AFFECTED_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_AFFECTED_USER_ID__CPR_ASC'
  | 'USER_BY_AFFECTED_USER_ID__CPR_DESC'
  | 'USER_BY_AFFECTED_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_AFFECTED_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_AFFECTED_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_AFFECTED_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_AFFECTED_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_AFFECTED_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_AFFECTED_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_AFFECTED_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_AFFECTED_USER_ID__EMAIL_ASC'
  | 'USER_BY_AFFECTED_USER_ID__EMAIL_DESC'
  | 'USER_BY_AFFECTED_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_AFFECTED_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_AFFECTED_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_AFFECTED_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_AFFECTED_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_AFFECTED_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_AFFECTED_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_AFFECTED_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_AFFECTED_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_AFFECTED_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_AFFECTED_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_AFFECTED_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_AFFECTED_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_AFFECTED_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_AFFECTED_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_AFFECTED_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_AFFECTED_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_AFFECTED_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_AFFECTED_USER_ID__GODMODE_ASC'
  | 'USER_BY_AFFECTED_USER_ID__GODMODE_DESC'
  | 'USER_BY_AFFECTED_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_AFFECTED_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_AFFECTED_USER_ID__ID_ASC'
  | 'USER_BY_AFFECTED_USER_ID__ID_DESC'
  | 'USER_BY_AFFECTED_USER_ID__INITIALS_ASC'
  | 'USER_BY_AFFECTED_USER_ID__INITIALS_DESC'
  | 'USER_BY_AFFECTED_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_AFFECTED_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_AFFECTED_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_AFFECTED_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_AFFECTED_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_AFFECTED_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_AFFECTED_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_AFFECTED_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_AFFECTED_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_AFFECTED_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_AFFECTED_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_AFFECTED_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_AFFECTED_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_AFFECTED_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_AFFECTED_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_AFFECTED_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_AFFECTED_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_AFFECTED_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_AFFECTED_USER_ID__MOBILE_ASC'
  | 'USER_BY_AFFECTED_USER_ID__MOBILE_DESC'
  | 'USER_BY_AFFECTED_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_AFFECTED_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_AFFECTED_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_AFFECTED_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_AFFECTED_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_AFFECTED_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_AFFECTED_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_AFFECTED_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_AFFECTED_USER_ID__PHONE_ASC'
  | 'USER_BY_AFFECTED_USER_ID__PHONE_DESC'
  | 'USER_BY_AFFECTED_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_AFFECTED_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_AFFECTED_USER_ID__SENIORITY_ASC'
  | 'USER_BY_AFFECTED_USER_ID__SENIORITY_DESC'
  | 'USER_BY_APPROVING_USER_ID__ACTIVE_ASC'
  | 'USER_BY_APPROVING_USER_ID__ACTIVE_DESC'
  | 'USER_BY_APPROVING_USER_ID__ADDRESS_ASC'
  | 'USER_BY_APPROVING_USER_ID__ADDRESS_DESC'
  | 'USER_BY_APPROVING_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_APPROVING_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_APPROVING_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_APPROVING_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_APPROVING_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_APPROVING_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_APPROVING_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_APPROVING_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_APPROVING_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_APPROVING_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_APPROVING_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_APPROVING_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_APPROVING_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_APPROVING_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_APPROVING_USER_ID__CITY_ASC'
  | 'USER_BY_APPROVING_USER_ID__CITY_DESC'
  | 'USER_BY_APPROVING_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_APPROVING_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_APPROVING_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_APPROVING_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_APPROVING_USER_ID__CPR_ASC'
  | 'USER_BY_APPROVING_USER_ID__CPR_DESC'
  | 'USER_BY_APPROVING_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_APPROVING_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_APPROVING_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_APPROVING_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_APPROVING_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_APPROVING_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_APPROVING_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_APPROVING_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_APPROVING_USER_ID__EMAIL_ASC'
  | 'USER_BY_APPROVING_USER_ID__EMAIL_DESC'
  | 'USER_BY_APPROVING_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_APPROVING_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_APPROVING_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_APPROVING_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_APPROVING_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_APPROVING_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_APPROVING_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_APPROVING_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_APPROVING_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_APPROVING_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_APPROVING_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_APPROVING_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_APPROVING_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_APPROVING_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_APPROVING_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_APPROVING_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_APPROVING_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_APPROVING_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_APPROVING_USER_ID__GODMODE_ASC'
  | 'USER_BY_APPROVING_USER_ID__GODMODE_DESC'
  | 'USER_BY_APPROVING_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_APPROVING_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_APPROVING_USER_ID__ID_ASC'
  | 'USER_BY_APPROVING_USER_ID__ID_DESC'
  | 'USER_BY_APPROVING_USER_ID__INITIALS_ASC'
  | 'USER_BY_APPROVING_USER_ID__INITIALS_DESC'
  | 'USER_BY_APPROVING_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_APPROVING_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_APPROVING_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_APPROVING_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_APPROVING_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_APPROVING_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_APPROVING_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_APPROVING_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_APPROVING_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_APPROVING_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_APPROVING_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_APPROVING_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_APPROVING_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_APPROVING_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_APPROVING_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_APPROVING_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_APPROVING_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_APPROVING_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_APPROVING_USER_ID__MOBILE_ASC'
  | 'USER_BY_APPROVING_USER_ID__MOBILE_DESC'
  | 'USER_BY_APPROVING_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_APPROVING_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_APPROVING_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_APPROVING_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_APPROVING_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_APPROVING_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_APPROVING_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_APPROVING_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_APPROVING_USER_ID__PHONE_ASC'
  | 'USER_BY_APPROVING_USER_ID__PHONE_DESC'
  | 'USER_BY_APPROVING_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_APPROVING_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_APPROVING_USER_ID__SENIORITY_ASC'
  | 'USER_BY_APPROVING_USER_ID__SENIORITY_DESC'
  | 'USER_BY_REQUESTING_USER_ID__ACTIVE_ASC'
  | 'USER_BY_REQUESTING_USER_ID__ACTIVE_DESC'
  | 'USER_BY_REQUESTING_USER_ID__ADDRESS_ASC'
  | 'USER_BY_REQUESTING_USER_ID__ADDRESS_DESC'
  | 'USER_BY_REQUESTING_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_REQUESTING_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_REQUESTING_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_REQUESTING_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_REQUESTING_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_REQUESTING_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_REQUESTING_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_REQUESTING_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_REQUESTING_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_REQUESTING_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_REQUESTING_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_REQUESTING_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_REQUESTING_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_REQUESTING_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_REQUESTING_USER_ID__CITY_ASC'
  | 'USER_BY_REQUESTING_USER_ID__CITY_DESC'
  | 'USER_BY_REQUESTING_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_REQUESTING_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_REQUESTING_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_REQUESTING_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_REQUESTING_USER_ID__CPR_ASC'
  | 'USER_BY_REQUESTING_USER_ID__CPR_DESC'
  | 'USER_BY_REQUESTING_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_REQUESTING_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_REQUESTING_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_REQUESTING_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_REQUESTING_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_REQUESTING_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_REQUESTING_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_REQUESTING_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_REQUESTING_USER_ID__EMAIL_ASC'
  | 'USER_BY_REQUESTING_USER_ID__EMAIL_DESC'
  | 'USER_BY_REQUESTING_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_REQUESTING_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_REQUESTING_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_REQUESTING_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_REQUESTING_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_REQUESTING_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_REQUESTING_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_REQUESTING_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_REQUESTING_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_REQUESTING_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_REQUESTING_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_REQUESTING_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_REQUESTING_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_REQUESTING_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_REQUESTING_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_REQUESTING_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_REQUESTING_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_REQUESTING_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_REQUESTING_USER_ID__GODMODE_ASC'
  | 'USER_BY_REQUESTING_USER_ID__GODMODE_DESC'
  | 'USER_BY_REQUESTING_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_REQUESTING_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_REQUESTING_USER_ID__ID_ASC'
  | 'USER_BY_REQUESTING_USER_ID__ID_DESC'
  | 'USER_BY_REQUESTING_USER_ID__INITIALS_ASC'
  | 'USER_BY_REQUESTING_USER_ID__INITIALS_DESC'
  | 'USER_BY_REQUESTING_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_REQUESTING_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_REQUESTING_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_REQUESTING_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_REQUESTING_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_REQUESTING_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_REQUESTING_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_REQUESTING_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_REQUESTING_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_REQUESTING_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_REQUESTING_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_REQUESTING_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_REQUESTING_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_REQUESTING_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_REQUESTING_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_REQUESTING_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_REQUESTING_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_REQUESTING_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_REQUESTING_USER_ID__MOBILE_ASC'
  | 'USER_BY_REQUESTING_USER_ID__MOBILE_DESC'
  | 'USER_BY_REQUESTING_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_REQUESTING_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_REQUESTING_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_REQUESTING_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_REQUESTING_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_REQUESTING_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_REQUESTING_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_REQUESTING_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_REQUESTING_USER_ID__PHONE_ASC'
  | 'USER_BY_REQUESTING_USER_ID__PHONE_DESC'
  | 'USER_BY_REQUESTING_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_REQUESTING_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_REQUESTING_USER_ID__SENIORITY_ASC'
  | 'USER_BY_REQUESTING_USER_ID__SENIORITY_DESC'
  | 'VACATION_USER_BY_APPROVAL_ID__ACTIVE_ASC'
  | 'VACATION_USER_BY_APPROVAL_ID__ACTIVE_DESC'
  | 'VACATION_USER_BY_APPROVAL_ID__ALL_DAY_ASC'
  | 'VACATION_USER_BY_APPROVAL_ID__ALL_DAY_DESC'
  | 'VACATION_USER_BY_APPROVAL_ID__APPROVAL_ID_ASC'
  | 'VACATION_USER_BY_APPROVAL_ID__APPROVAL_ID_DESC'
  | 'VACATION_USER_BY_APPROVAL_ID__CALENDAR_EVENT_REVISIONS_ASC'
  | 'VACATION_USER_BY_APPROVAL_ID__CALENDAR_EVENT_REVISIONS_DESC'
  | 'VACATION_USER_BY_APPROVAL_ID__COMPANY_ID_ASC'
  | 'VACATION_USER_BY_APPROVAL_ID__COMPANY_ID_DESC'
  | 'VACATION_USER_BY_APPROVAL_ID__CREATOR_USER_ID_ASC'
  | 'VACATION_USER_BY_APPROVAL_ID__CREATOR_USER_ID_DESC'
  | 'VACATION_USER_BY_APPROVAL_ID__CUSTOM_ID_ASC'
  | 'VACATION_USER_BY_APPROVAL_ID__CUSTOM_ID_DESC'
  | 'VACATION_USER_BY_APPROVAL_ID__DELETION_APPROVAL_ID_ASC'
  | 'VACATION_USER_BY_APPROVAL_ID__DELETION_APPROVAL_ID_DESC'
  | 'VACATION_USER_BY_APPROVAL_ID__DEPARTMENT_IDS_ASC'
  | 'VACATION_USER_BY_APPROVAL_ID__DEPARTMENT_IDS_DESC'
  | 'VACATION_USER_BY_APPROVAL_ID__DURATION_DAYS_ASC'
  | 'VACATION_USER_BY_APPROVAL_ID__DURATION_DAYS_DESC'
  | 'VACATION_USER_BY_APPROVAL_ID__END_DATE_ASC'
  | 'VACATION_USER_BY_APPROVAL_ID__END_DATE_DESC'
  | 'VACATION_USER_BY_APPROVAL_ID__ID_ASC'
  | 'VACATION_USER_BY_APPROVAL_ID__ID_DESC'
  | 'VACATION_USER_BY_APPROVAL_ID__NOTE_ASC'
  | 'VACATION_USER_BY_APPROVAL_ID__NOTE_DESC'
  | 'VACATION_USER_BY_APPROVAL_ID__START_DATE_ASC'
  | 'VACATION_USER_BY_APPROVAL_ID__START_DATE_DESC'
  | 'VACATION_USER_BY_APPROVAL_ID__USER_ID_ASC'
  | 'VACATION_USER_BY_APPROVAL_ID__USER_ID_DESC'
  | 'VACATION_USER_BY_APPROVAL_ID__VACATION_TYPE_ID_ASC'
  | 'VACATION_USER_BY_APPROVAL_ID__VACATION_TYPE_ID_DESC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__ACTIVE_ASC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__ACTIVE_DESC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__ALL_DAY_ASC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__ALL_DAY_DESC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__APPROVAL_ID_ASC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__APPROVAL_ID_DESC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__CALENDAR_EVENT_REVISIONS_ASC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__CALENDAR_EVENT_REVISIONS_DESC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__COMPANY_ID_ASC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__COMPANY_ID_DESC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__CREATOR_USER_ID_ASC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__CREATOR_USER_ID_DESC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__CUSTOM_ID_ASC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__CUSTOM_ID_DESC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__DELETION_APPROVAL_ID_ASC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__DELETION_APPROVAL_ID_DESC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__DEPARTMENT_IDS_ASC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__DEPARTMENT_IDS_DESC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__DURATION_DAYS_ASC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__DURATION_DAYS_DESC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__END_DATE_ASC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__END_DATE_DESC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__ID_ASC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__ID_DESC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__NOTE_ASC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__NOTE_DESC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__START_DATE_ASC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__START_DATE_DESC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__USER_ID_ASC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__USER_ID_DESC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__VACATION_TYPE_ID_ASC'
  | 'VACATION_USER_BY_DELETION_APPROVAL_ID__VACATION_TYPE_ID_DESC';

/** All input for the `approveTimeRegistrationsByDeadline` mutation. */
export type ApproveTimeRegistrationsByDeadlineInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deadline: Scalars['Datetime'];
};

/** The output of our `approveTimeRegistrationsByDeadline` mutation. */
export type ApproveTimeRegistrationsByDeadlinePayload = {
  __typename?: 'ApproveTimeRegistrationsByDeadlinePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `arrayIntersect` mutation. */
export type ArrayIntersectInput = {
  a1?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  a2?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `arrayIntersect` mutation. */
export type ArrayIntersectPayload = {
  __typename?: 'ArrayIntersectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  strings?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AsyncJob = {
  __typename?: 'AsyncJob';
  active: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `AsyncJobItem`. */
  asyncJobItems: AsyncJobItemsConnection;
  /** Reads a single `Company` that is related to this `AsyncJob`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  completionDate?: Maybe<Scalars['Datetime']>;
  departmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  duration?: Maybe<Interval>;
  id: Scalars['UUID'];
  startDate: Scalars['Datetime'];
  type: AsyncJobType;
  /** Reads a single `User` that is related to this `AsyncJob`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};


export type AsyncJobAsyncJobItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AsyncJobItemCondition>;
  filter?: InputMaybe<AsyncJobItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AsyncJobItemsOrderBy>>;
};

/** The fields on `asyncJob` to look up the row to connect. */
export type AsyncJobAsyncJobPkeyConnect = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `company` in the `AsyncJobInput` mutation. */
export type AsyncJobCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnAsyncJobForAsyncJobCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `asyncJob` in the `CompanyInput` mutation. */
export type AsyncJobCompanyIdForeignInverseInput = {
  /** The primary key(s) for `asyncJob` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AsyncJobAsyncJobPkeyConnect>>;
  /** The primary key(s) and patch data for `asyncJob` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AsyncJobOnAsyncJobForAsyncJobCompanyIdForeignUsingAsyncJobPkeyUpdate>>;
};

/**
 * A condition to be used against `AsyncJob` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AsyncJobCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `completionDate` field. */
  completionDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<AsyncJobType>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `AsyncJob` object types. All fields are combined with a logical ‘and.’ */
export type AsyncJobFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AsyncJobFilter>>;
  /** Filter by the object’s `asyncJobItems` relation. */
  asyncJobItems?: InputMaybe<AsyncJobToManyAsyncJobItemFilter>;
  /** Some related `asyncJobItems` exist. */
  asyncJobItemsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `completionDate` field. */
  completionDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AsyncJobFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AsyncJobFilter>>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<AsyncJobTypeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

export type AsyncJobItem = {
  __typename?: 'AsyncJobItem';
  /** Reads a single `AsyncJob` that is related to this `AsyncJobItem`. */
  asyncJob?: Maybe<AsyncJob>;
  asyncJobId: Scalars['UUID'];
  /** Reads a single `Company` that is related to this `AsyncJobItem`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  completionDate: Scalars['Datetime'];
  departmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  id: Scalars['UUID'];
  message?: Maybe<Scalars['String']>;
  messageVariables?: Maybe<Scalars['JSON']>;
  tabulation: Scalars['Int'];
  /** Reads a single `User` that is related to this `AsyncJobItem`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** Input for the nested mutation of `asyncJob` in the `AsyncJobItemInput` mutation. */
export type AsyncJobItemAsyncJobIdForeignInput = {
  /** The primary key(s) for `asyncJob` for the far side of the relationship. */
  connectById?: InputMaybe<AsyncJobAsyncJobPkeyConnect>;
  /** The primary key(s) and patch data for `asyncJob` for the far side of the relationship. */
  updateById?: InputMaybe<AsyncJobOnAsyncJobItemForAsyncJobItemAsyncJobIdForeignUsingAsyncJobPkeyUpdate>;
};

/** Input for the nested mutation of `asyncJobItem` in the `AsyncJobInput` mutation. */
export type AsyncJobItemAsyncJobIdForeignInverseInput = {
  /** The primary key(s) for `asyncJobItem` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AsyncJobItemAsyncJobItemPkeyConnect>>;
  /** The primary key(s) and patch data for `asyncJobItem` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AsyncJobItemOnAsyncJobItemForAsyncJobItemAsyncJobIdForeignUsingAsyncJobItemPkeyUpdate>>;
};

/** The fields on `asyncJobItem` to look up the row to connect. */
export type AsyncJobItemAsyncJobItemPkeyConnect = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `company` in the `AsyncJobItemInput` mutation. */
export type AsyncJobItemCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnAsyncJobItemForAsyncJobItemCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `asyncJobItem` in the `CompanyInput` mutation. */
export type AsyncJobItemCompanyIdForeignInverseInput = {
  /** The primary key(s) for `asyncJobItem` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AsyncJobItemAsyncJobItemPkeyConnect>>;
  /** The primary key(s) and patch data for `asyncJobItem` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AsyncJobItemOnAsyncJobItemForAsyncJobItemCompanyIdForeignUsingAsyncJobItemPkeyUpdate>>;
};

/**
 * A condition to be used against `AsyncJobItem` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AsyncJobItemCondition = {
  /** Checks for equality with the object’s `asyncJobId` field. */
  asyncJobId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `completionDate` field. */
  completionDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `messageVariables` field. */
  messageVariables?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `tabulation` field. */
  tabulation?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `AsyncJobItem` object types. All fields are combined with a logical ‘and.’ */
export type AsyncJobItemFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AsyncJobItemFilter>>;
  /** Filter by the object’s `asyncJob` relation. */
  asyncJob?: InputMaybe<AsyncJobFilter>;
  /** Filter by the object’s `asyncJobId` field. */
  asyncJobId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `completionDate` field. */
  completionDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `message` field. */
  message?: InputMaybe<StringFilter>;
  /** Filter by the object’s `messageVariables` field. */
  messageVariables?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AsyncJobItemFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AsyncJobItemFilter>>;
  /** Filter by the object’s `tabulation` field. */
  tabulation?: InputMaybe<IntFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `asyncJobItem` to look up the row to update. */
export type AsyncJobItemOnAsyncJobItemForAsyncJobItemAsyncJobIdForeignUsingAsyncJobItemPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `asyncJobItem` being updated. */
  patch: UpdateAsyncJobItemOnAsyncJobItemForAsyncJobItemAsyncJobIdForeignPatch;
};

/** The fields on `asyncJobItem` to look up the row to update. */
export type AsyncJobItemOnAsyncJobItemForAsyncJobItemCompanyIdForeignUsingAsyncJobItemPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `asyncJobItem` being updated. */
  patch: UpdateAsyncJobItemOnAsyncJobItemForAsyncJobItemCompanyIdForeignPatch;
};

/** The fields on `asyncJobItem` to look up the row to update. */
export type AsyncJobItemOnAsyncJobItemForAsyncJobItemUserIdForeignUsingAsyncJobItemPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `asyncJobItem` being updated. */
  patch: UpdateAsyncJobItemOnAsyncJobItemForAsyncJobItemUserIdForeignPatch;
};

/** Input for the nested mutation of `user` in the `AsyncJobItemInput` mutation. */
export type AsyncJobItemUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnAsyncJobItemForAsyncJobItemUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `asyncJobItem` in the `UserInput` mutation. */
export type AsyncJobItemUserIdForeignInverseInput = {
  /** The primary key(s) for `asyncJobItem` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AsyncJobItemAsyncJobItemPkeyConnect>>;
  /** The primary key(s) and patch data for `asyncJobItem` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AsyncJobItemOnAsyncJobItemForAsyncJobItemUserIdForeignUsingAsyncJobItemPkeyUpdate>>;
};

/** A connection to a list of `AsyncJobItem` values. */
export type AsyncJobItemsConnection = {
  __typename?: 'AsyncJobItemsConnection';
  /** A list of edges which contains the `AsyncJobItem` and cursor to aid in pagination. */
  edges: Array<AsyncJobItemsEdge>;
  /** A list of `AsyncJobItem` objects. */
  nodes: Array<Maybe<AsyncJobItem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AsyncJobItem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AsyncJobItem` edge in the connection. */
export type AsyncJobItemsEdge = {
  __typename?: 'AsyncJobItemsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AsyncJobItem` at the end of the edge. */
  node?: Maybe<AsyncJobItem>;
};

/** Methods to use when ordering `AsyncJobItem`. */
export type AsyncJobItemsOrderBy =
  | 'ASYNC_JOB_BY_ASYNC_JOB_ID__ACTIVE_ASC'
  | 'ASYNC_JOB_BY_ASYNC_JOB_ID__ACTIVE_DESC'
  | 'ASYNC_JOB_BY_ASYNC_JOB_ID__COMPANY_ID_ASC'
  | 'ASYNC_JOB_BY_ASYNC_JOB_ID__COMPANY_ID_DESC'
  | 'ASYNC_JOB_BY_ASYNC_JOB_ID__COMPLETION_DATE_ASC'
  | 'ASYNC_JOB_BY_ASYNC_JOB_ID__COMPLETION_DATE_DESC'
  | 'ASYNC_JOB_BY_ASYNC_JOB_ID__DEPARTMENT_IDS_ASC'
  | 'ASYNC_JOB_BY_ASYNC_JOB_ID__DEPARTMENT_IDS_DESC'
  | 'ASYNC_JOB_BY_ASYNC_JOB_ID__ID_ASC'
  | 'ASYNC_JOB_BY_ASYNC_JOB_ID__ID_DESC'
  | 'ASYNC_JOB_BY_ASYNC_JOB_ID__START_DATE_ASC'
  | 'ASYNC_JOB_BY_ASYNC_JOB_ID__START_DATE_DESC'
  | 'ASYNC_JOB_BY_ASYNC_JOB_ID__TYPE_ASC'
  | 'ASYNC_JOB_BY_ASYNC_JOB_ID__TYPE_DESC'
  | 'ASYNC_JOB_BY_ASYNC_JOB_ID__USER_ID_ASC'
  | 'ASYNC_JOB_BY_ASYNC_JOB_ID__USER_ID_DESC'
  | 'ASYNC_JOB_ID_ASC'
  | 'ASYNC_JOB_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPLETION_DATE_ASC'
  | 'COMPLETION_DATE_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MESSAGE_ASC'
  | 'MESSAGE_DESC'
  | 'MESSAGE_VARIABLES_ASC'
  | 'MESSAGE_VARIABLES_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TABULATION_ASC'
  | 'TABULATION_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** The fields on `asyncJob` to look up the row to update. */
export type AsyncJobOnAsyncJobForAsyncJobCompanyIdForeignUsingAsyncJobPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `asyncJob` being updated. */
  patch: UpdateAsyncJobOnAsyncJobForAsyncJobCompanyIdForeignPatch;
};

/** The fields on `asyncJob` to look up the row to update. */
export type AsyncJobOnAsyncJobForAsyncJobUserIdForeignUsingAsyncJobPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `asyncJob` being updated. */
  patch: UpdateAsyncJobOnAsyncJobForAsyncJobUserIdForeignPatch;
};

/** The fields on `asyncJob` to look up the row to update. */
export type AsyncJobOnAsyncJobItemForAsyncJobItemAsyncJobIdForeignUsingAsyncJobPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `asyncJob` being updated. */
  patch: UpdateAsyncJobOnAsyncJobItemForAsyncJobItemAsyncJobIdForeignPatch;
};

/** Represents an update to a `AsyncJob`. Fields that are set will be updated. */
export type AsyncJobPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  asyncJobItems?: InputMaybe<AsyncJobItemAsyncJobIdForeignInverseInput>;
  company?: InputMaybe<AsyncJobCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completionDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  type?: InputMaybe<AsyncJobType>;
  user?: InputMaybe<AsyncJobUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type AsyncJobSubscriptionInput = {
  asyncJobId?: InputMaybe<Scalars['UUID']>;
};

export type AsyncJobSubscriptionPayload = {
  __typename?: 'AsyncJobSubscriptionPayload';
  asyncJobItem?: Maybe<AsyncJobItem>;
  event?: Maybe<Scalars['String']>;
};

/** A filter to be used against many `AsyncJobItem` object types. All fields are combined with a logical ‘and.’ */
export type AsyncJobToManyAsyncJobItemFilter = {
  /** Every related `AsyncJobItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AsyncJobItemFilter>;
  /** No related `AsyncJobItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AsyncJobItemFilter>;
  /** Some related `AsyncJobItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AsyncJobItemFilter>;
};

export type AsyncJobType =
  /** Copy company */
  | 'COPY_COMPANY'
  /** Update employees from CSV */
  | 'CSV_UPDATE_EMPLOYEES'
  /** Update employee records from CSV */
  | 'CSV_UPDATE_EMPLOYEE_RECORDS'
  /** Import employees */
  | 'IMPORT_EMPLOYEES';

/** A filter to be used against AsyncJobType fields. All fields are combined with a logical ‘and.’ */
export type AsyncJobTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AsyncJobType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AsyncJobType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AsyncJobType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AsyncJobType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AsyncJobType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AsyncJobType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AsyncJobType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AsyncJobType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AsyncJobType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AsyncJobType>>;
};

/** Input for the nested mutation of `user` in the `AsyncJobInput` mutation. */
export type AsyncJobUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnAsyncJobForAsyncJobUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `asyncJob` in the `UserInput` mutation. */
export type AsyncJobUserIdForeignInverseInput = {
  /** The primary key(s) for `asyncJob` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AsyncJobAsyncJobPkeyConnect>>;
  /** The primary key(s) and patch data for `asyncJob` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AsyncJobOnAsyncJobForAsyncJobUserIdForeignUsingAsyncJobPkeyUpdate>>;
};

/** A connection to a list of `AsyncJob` values. */
export type AsyncJobsConnection = {
  __typename?: 'AsyncJobsConnection';
  /** A list of edges which contains the `AsyncJob` and cursor to aid in pagination. */
  edges: Array<AsyncJobsEdge>;
  /** A list of `AsyncJob` objects. */
  nodes: Array<Maybe<AsyncJob>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AsyncJob` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AsyncJob` edge in the connection. */
export type AsyncJobsEdge = {
  __typename?: 'AsyncJobsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AsyncJob` at the end of the edge. */
  node?: Maybe<AsyncJob>;
};

/** Methods to use when ordering `AsyncJob`. */
export type AsyncJobsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ASYNC_JOB_ITEMS_BY_ASYNC_JOB_ID__COUNT_ASC'
  | 'ASYNC_JOB_ITEMS_BY_ASYNC_JOB_ID__COUNT_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPLETION_DATE_ASC'
  | 'COMPLETION_DATE_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'START_DATE_ASC'
  | 'START_DATE_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type AttachmentInput = {
  base64: Scalars['String'];
  fileName: Scalars['String'];
};

export type Attendee = {
  __typename?: 'Attendee';
  attending?: Maybe<Scalars['Boolean']>;
  employeeId?: Maybe<Scalars['UUID']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  jobPositionTitle?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['UUID']>;
};

/** A filter to be used against `Attendee` object types. All fields are combined with a logical ‘and.’ */
export type AttendeeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AttendeeFilter>>;
  /** Filter by the object’s `attending` field. */
  attending?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `jobPositionTitle` field. */
  jobPositionTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `logo` field. */
  logo?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AttendeeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AttendeeFilter>>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** A connection to a list of `Attendee` values. */
export type AttendeesConnection = {
  __typename?: 'AttendeesConnection';
  /** A list of edges which contains the `Attendee` and cursor to aid in pagination. */
  edges: Array<AttendeesEdge>;
  /** A list of `Attendee` objects. */
  nodes: Array<Maybe<Attendee>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Attendee` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Attendee` edge in the connection. */
export type AttendeesEdge = {
  __typename?: 'AttendeesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Attendee` at the end of the edge. */
  node?: Maybe<Attendee>;
};

export type AuthApp = {
  __typename?: 'AuthApp';
  apiKey?: Maybe<Scalars['JSON']>;
  appType: Scalars['Int'];
  /** Reads a single `AuthAppType` that is related to this `AuthApp`. */
  authAppTypeByAppType?: Maybe<AuthAppType>;
  clientId: Scalars['String'];
  clientSecret?: Maybe<Scalars['String']>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `ExternalIntegration`. */
  externalIntegrations: ExternalIntegrationsConnection;
  /** Reads a single `Group` that is related to this `AuthApp`. */
  group?: Maybe<Group>;
  groupId?: Maybe<Scalars['UUID']>;
  homepageUri: Scalars['String'];
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `IntegrationFieldMarking`. */
  integrationFieldMarkings: IntegrationFieldMarkingsConnection;
  name: Scalars['String'];
  redirectUris: Array<Maybe<Scalars['String']>>;
  /** Reads a single `Storage` that is related to this `AuthApp`. */
  storage?: Maybe<Storage>;
  storageId?: Maybe<Scalars['UUID']>;
  tokensRevokedAt?: Maybe<Scalars['Datetime']>;
  updatedAt: Scalars['Datetime'];
};


export type AuthAppExternalIntegrationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalIntegrationCondition>;
  filter?: InputMaybe<ExternalIntegrationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalIntegrationsOrderBy>>;
};


export type AuthAppIntegrationFieldMarkingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<IntegrationFieldMarkingCondition>;
  filter?: InputMaybe<IntegrationFieldMarkingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegrationFieldMarkingsOrderBy>>;
};

/** The `authAppType` to be created by this mutation. */
export type AuthAppAppTypeFkeyConnectionAuthAppTypeCreateInput = {
  authApps?: InputMaybe<AuthAppAppTypeFkeyInverseInput>;
  createdAt: Scalars['Datetime'];
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

/** Input for the nested mutation of `authAppType` in the `AuthAppInput` mutation. */
export type AuthAppAppTypeFkeyInput = {
  /** The primary key(s) for `authAppType` for the far side of the relationship. */
  connectById?: InputMaybe<AuthAppTypeAuthAppTypePkeyConnect>;
  /** A `AuthAppTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<AuthAppAppTypeFkeyConnectionAuthAppTypeCreateInput>;
  /** The primary key(s) for `authAppType` for the far side of the relationship. */
  deleteById?: InputMaybe<AuthAppTypeAuthAppTypePkeyDelete>;
  /** The primary key(s) and patch data for `authAppType` for the far side of the relationship. */
  updateById?: InputMaybe<AuthAppTypeOnAuthAppForAuthAppAppTypeFkeyUsingAuthAppTypePkeyUpdate>;
};

/** Input for the nested mutation of `authApp` in the `AuthAppTypeInput` mutation. */
export type AuthAppAppTypeFkeyInverseInput = {
  /** The primary key(s) for `authApp` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AuthAppAuthAppPkeyConnect>>;
  /** The primary key(s) and patch data for `authApp` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AuthAppOnAuthAppForAuthAppAppTypeFkeyUsingAuthAppPkeyUpdate>>;
};

/** The fields on `authApp` to look up the row to connect. */
export type AuthAppAuthAppPkeyConnect = {
  id: Scalars['UUID'];
};

/** A condition to be used against `AuthApp` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AuthAppCondition = {
  /** Checks for equality with the object’s `apiKey` field. */
  apiKey?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `appType` field. */
  appType?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `clientSecret` field. */
  clientSecret?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `homepageUri` field. */
  homepageUri?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `redirectUris` field. */
  redirectUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `storageId` field. */
  storageId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `tokensRevokedAt` field. */
  tokensRevokedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `AuthApp` object types. All fields are combined with a logical ‘and.’ */
export type AuthAppFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuthAppFilter>>;
  /** Filter by the object’s `appType` field. */
  appType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `authAppTypeByAppType` relation. */
  authAppTypeByAppType?: InputMaybe<AuthAppTypeFilter>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `clientSecret` field. */
  clientSecret?: InputMaybe<StringFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalIntegrations` relation. */
  externalIntegrations?: InputMaybe<AuthAppToManyExternalIntegrationFilter>;
  /** Some related `externalIntegrations` exist. */
  externalIntegrationsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `group` relation. */
  group?: InputMaybe<GroupFilter>;
  /** A related `group` exists. */
  groupExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `homepageUri` field. */
  homepageUri?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `integrationFieldMarkings` relation. */
  integrationFieldMarkings?: InputMaybe<AuthAppToManyIntegrationFieldMarkingFilter>;
  /** Some related `integrationFieldMarkings` exist. */
  integrationFieldMarkingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuthAppFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuthAppFilter>>;
  /** Filter by the object’s `redirectUris` field. */
  redirectUris?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `storage` relation. */
  storage?: InputMaybe<StorageFilter>;
  /** A related `storage` exists. */
  storageExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `storageId` field. */
  storageId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tokensRevokedAt` field. */
  tokensRevokedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** The fields on `authApp` to look up the row to update. */
export type AuthAppOnAuthAppForAuthAppAppTypeFkeyUsingAuthAppPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `authApp` being updated. */
  patch: UpdateAuthAppOnAuthAppForAuthAppAppTypeFkeyPatch;
};

/** The fields on `authApp` to look up the row to update. */
export type AuthAppOnAuthAppForAuthAppStorageIdFkeyUsingAuthAppPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `authApp` being updated. */
  patch: UpdateAuthAppOnAuthAppForAuthAppStorageIdFkeyPatch;
};

/** The fields on `authApp` to look up the row to update. */
export type AuthAppOnAuthAppForAuthAppTableGroupIdFkUsingAuthAppPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `authApp` being updated. */
  patch: UpdateAuthAppOnAuthAppForAuthAppTableGroupIdFkPatch;
};

/** The fields on `authApp` to look up the row to update. */
export type AuthAppOnExternalIntegrationForExternalIntegrationAuthAppIdFkeyUsingAuthAppPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `authApp` being updated. */
  patch: UpdateAuthAppOnExternalIntegrationForExternalIntegrationAuthAppIdFkeyPatch;
};

/** The fields on `authApp` to look up the row to update. */
export type AuthAppOnIntegrationFieldMarkingForIntegrationFieldMarkingAuthAppIdFkeyUsingAuthAppPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `authApp` being updated. */
  patch: UpdateAuthAppOnIntegrationFieldMarkingForIntegrationFieldMarkingAuthAppIdFkeyPatch;
};

export type AuthAppPayload = {
  __typename?: 'AuthAppPayload';
  response?: Maybe<Scalars['JSON']>;
};

/** The `storage` to be created by this mutation. */
export type AuthAppStorageIdFkeyConnectionStorageCreateInput = {
  access: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createCopy?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path: Scalars['String'];
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `storage` in the `AuthAppInput` mutation. */
export type AuthAppStorageIdFkeyInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<StorageStoragePkeyConnect>;
  /** A `StorageInput` object that will be created and connected to this object. */
  create?: InputMaybe<AuthAppStorageIdFkeyConnectionStorageCreateInput>;
  /** The primary key(s) and patch data for `storage` for the far side of the relationship. */
  updateById?: InputMaybe<StorageOnAuthAppForAuthAppStorageIdFkeyUsingStoragePkeyUpdate>;
};

/** Input for the nested mutation of `authApp` in the `StorageInput` mutation. */
export type AuthAppStorageIdFkeyInverseInput = {
  /** The primary key(s) for `authApp` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AuthAppAuthAppPkeyConnect>>;
  /** The primary key(s) and patch data for `authApp` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AuthAppOnAuthAppForAuthAppStorageIdFkeyUsingAuthAppPkeyUpdate>>;
};

/** The `group` to be created by this mutation. */
export type AuthAppTableGroupIdFkConnectionGroupCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppTableGroupIdFkInverseInput>;
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  autoInherit?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  copyFromGroupId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientGroupIdForeignInverseInput>;
  scope?: InputMaybe<RoleScope>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupGroupIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupGroupIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupGroupIdForeignInverseInput>;
};

/** Input for the nested mutation of `group` in the `AuthAppInput` mutation. */
export type AuthAppTableGroupIdFkInput = {
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectById?: InputMaybe<GroupGroupPkeyConnect>;
  /** A `GroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<AuthAppTableGroupIdFkConnectionGroupCreateInput>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateById?: InputMaybe<GroupOnAuthAppForAuthAppTableGroupIdFkUsingGroupPkeyUpdate>;
};

/** Input for the nested mutation of `authApp` in the `GroupInput` mutation. */
export type AuthAppTableGroupIdFkInverseInput = {
  /** The primary key(s) for `authApp` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AuthAppAuthAppPkeyConnect>>;
  /** The primary key(s) and patch data for `authApp` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AuthAppOnAuthAppForAuthAppTableGroupIdFkUsingAuthAppPkeyUpdate>>;
};

/** A filter to be used against many `ExternalIntegration` object types. All fields are combined with a logical ‘and.’ */
export type AuthAppToManyExternalIntegrationFilter = {
  /** Every related `ExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalIntegrationFilter>;
  /** No related `ExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalIntegrationFilter>;
  /** Some related `ExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalIntegrationFilter>;
};

/** A filter to be used against many `IntegrationFieldMarking` object types. All fields are combined with a logical ‘and.’ */
export type AuthAppToManyIntegrationFieldMarkingFilter = {
  /** Every related `IntegrationFieldMarking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<IntegrationFieldMarkingFilter>;
  /** No related `IntegrationFieldMarking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<IntegrationFieldMarkingFilter>;
  /** Some related `IntegrationFieldMarking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<IntegrationFieldMarkingFilter>;
};

export type AuthAppType = {
  __typename?: 'AuthAppType';
  /** Reads and enables pagination through a set of `AuthApp`. */
  authAppsByAppType: AuthAppsConnection;
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};


export type AuthAppTypeAuthAppsByAppTypeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AuthAppCondition>;
  filter?: InputMaybe<AuthAppFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AuthAppsOrderBy>>;
};

/** The fields on `authAppType` to look up the row to connect. */
export type AuthAppTypeAuthAppTypePkeyConnect = {
  id: Scalars['Int'];
};

/** The fields on `authAppType` to look up the row to delete. */
export type AuthAppTypeAuthAppTypePkeyDelete = {
  id: Scalars['Int'];
};

/**
 * A condition to be used against `AuthAppType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AuthAppTypeCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `AuthAppType` object types. All fields are combined with a logical ‘and.’ */
export type AuthAppTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuthAppTypeFilter>>;
  /** Filter by the object’s `authAppsByAppType` relation. */
  authAppsByAppType?: InputMaybe<AuthAppTypeToManyAuthAppFilter>;
  /** Some related `authAppsByAppType` exist. */
  authAppsByAppTypeExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuthAppTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuthAppTypeFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `AuthAppType` */
export type AuthAppTypeInput = {
  authApps?: InputMaybe<AuthAppAppTypeFkeyInverseInput>;
  createdAt: Scalars['Datetime'];
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

/** The fields on `authAppType` to look up the row to update. */
export type AuthAppTypeOnAuthAppForAuthAppAppTypeFkeyUsingAuthAppTypePkeyUpdate = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `authAppType` being updated. */
  patch: UpdateAuthAppTypeOnAuthAppForAuthAppAppTypeFkeyPatch;
};

/** Represents an update to a `AuthAppType`. Fields that are set will be updated. */
export type AuthAppTypePatch = {
  authApps?: InputMaybe<AuthAppAppTypeFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against many `AuthApp` object types. All fields are combined with a logical ‘and.’ */
export type AuthAppTypeToManyAuthAppFilter = {
  /** Every related `AuthApp` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuthAppFilter>;
  /** No related `AuthApp` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuthAppFilter>;
  /** Some related `AuthApp` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuthAppFilter>;
};

/** A connection to a list of `AuthAppType` values. */
export type AuthAppTypesConnection = {
  __typename?: 'AuthAppTypesConnection';
  /** A list of edges which contains the `AuthAppType` and cursor to aid in pagination. */
  edges: Array<AuthAppTypesEdge>;
  /** A list of `AuthAppType` objects. */
  nodes: Array<Maybe<AuthAppType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuthAppType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AuthAppType` edge in the connection. */
export type AuthAppTypesEdge = {
  __typename?: 'AuthAppTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AuthAppType` at the end of the edge. */
  node?: Maybe<AuthAppType>;
};

/** Methods to use when ordering `AuthAppType`. */
export type AuthAppTypesOrderBy =
  | 'AUTH_APPS_BY_APP_TYPE__COUNT_ASC'
  | 'AUTH_APPS_BY_APP_TYPE__COUNT_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DELETED_AT_ASC'
  | 'DELETED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** A connection to a list of `AuthApp` values. */
export type AuthAppsConnection = {
  __typename?: 'AuthAppsConnection';
  /** A list of edges which contains the `AuthApp` and cursor to aid in pagination. */
  edges: Array<AuthAppsEdge>;
  /** A list of `AuthApp` objects. */
  nodes: Array<Maybe<AuthApp>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuthApp` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AuthApp` edge in the connection. */
export type AuthAppsEdge = {
  __typename?: 'AuthAppsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AuthApp` at the end of the edge. */
  node?: Maybe<AuthApp>;
};

/** Methods to use when ordering `AuthApp`. */
export type AuthAppsOrderBy =
  | 'API_KEY_ASC'
  | 'API_KEY_DESC'
  | 'APP_TYPE_ASC'
  | 'APP_TYPE_DESC'
  | 'AUTH_APP_TYPE_BY_APP_TYPE__CREATED_AT_ASC'
  | 'AUTH_APP_TYPE_BY_APP_TYPE__CREATED_AT_DESC'
  | 'AUTH_APP_TYPE_BY_APP_TYPE__DELETED_AT_ASC'
  | 'AUTH_APP_TYPE_BY_APP_TYPE__DELETED_AT_DESC'
  | 'AUTH_APP_TYPE_BY_APP_TYPE__ID_ASC'
  | 'AUTH_APP_TYPE_BY_APP_TYPE__ID_DESC'
  | 'AUTH_APP_TYPE_BY_APP_TYPE__NAME_ASC'
  | 'AUTH_APP_TYPE_BY_APP_TYPE__NAME_DESC'
  | 'AUTH_APP_TYPE_BY_APP_TYPE__UPDATED_AT_ASC'
  | 'AUTH_APP_TYPE_BY_APP_TYPE__UPDATED_AT_DESC'
  | 'CLIENT_ID_ASC'
  | 'CLIENT_ID_DESC'
  | 'CLIENT_SECRET_ASC'
  | 'CLIENT_SECRET_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DELETED_AT_ASC'
  | 'DELETED_AT_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'EXTERNAL_INTEGRATIONS_BY_AUTH_APP_ID__COUNT_ASC'
  | 'EXTERNAL_INTEGRATIONS_BY_AUTH_APP_ID__COUNT_DESC'
  | 'GROUP_BY_GROUP_ID__ACTIVE_ASC'
  | 'GROUP_BY_GROUP_ID__ACTIVE_DESC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_ASC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_DESC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_NEW_PERMISSIONS_ASC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_NEW_PERMISSIONS_DESC'
  | 'GROUP_BY_GROUP_ID__AUTO_INHERIT_ASC'
  | 'GROUP_BY_GROUP_ID__AUTO_INHERIT_DESC'
  | 'GROUP_BY_GROUP_ID__COMPANY_ID_ASC'
  | 'GROUP_BY_GROUP_ID__COMPANY_ID_DESC'
  | 'GROUP_BY_GROUP_ID__DESCRIPTION_ASC'
  | 'GROUP_BY_GROUP_ID__DESCRIPTION_DESC'
  | 'GROUP_BY_GROUP_ID__ID_ASC'
  | 'GROUP_BY_GROUP_ID__ID_DESC'
  | 'GROUP_BY_GROUP_ID__LOCALIZED_NAME_ASC'
  | 'GROUP_BY_GROUP_ID__LOCALIZED_NAME_DESC'
  | 'GROUP_BY_GROUP_ID__NAME_ASC'
  | 'GROUP_BY_GROUP_ID__NAME_DESC'
  | 'GROUP_BY_GROUP_ID__SCOPE_ASC'
  | 'GROUP_BY_GROUP_ID__SCOPE_DESC'
  | 'GROUP_ID_ASC'
  | 'GROUP_ID_DESC'
  | 'HOMEPAGE_URI_ASC'
  | 'HOMEPAGE_URI_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INTEGRATION_FIELD_MARKINGS_BY_AUTH_APP_ID__COUNT_ASC'
  | 'INTEGRATION_FIELD_MARKINGS_BY_AUTH_APP_ID__COUNT_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REDIRECT_URIS_ASC'
  | 'REDIRECT_URIS_DESC'
  | 'STORAGE_BY_STORAGE_ID__ACCESS_ASC'
  | 'STORAGE_BY_STORAGE_ID__ACCESS_DESC'
  | 'STORAGE_BY_STORAGE_ID__ACTIVE_ASC'
  | 'STORAGE_BY_STORAGE_ID__ACTIVE_DESC'
  | 'STORAGE_BY_STORAGE_ID__BELONGS_TO_LEADER_ASC'
  | 'STORAGE_BY_STORAGE_ID__BELONGS_TO_LEADER_DESC'
  | 'STORAGE_BY_STORAGE_ID__COMPANY_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__COMPANY_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__CREATED_AT_ASC'
  | 'STORAGE_BY_STORAGE_ID__CREATED_AT_DESC'
  | 'STORAGE_BY_STORAGE_ID__DELETE_AT_ASC'
  | 'STORAGE_BY_STORAGE_ID__DELETE_AT_DESC'
  | 'STORAGE_BY_STORAGE_ID__DEPARTMENTS_ASC'
  | 'STORAGE_BY_STORAGE_ID__DEPARTMENTS_DESC'
  | 'STORAGE_BY_STORAGE_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'STORAGE_BY_STORAGE_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'STORAGE_BY_STORAGE_ID__DOCUMENT_FOLDER_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__DOCUMENT_FOLDER_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__DOCUMENT_TEMPLATE_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__DOCUMENT_TEMPLATE_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__DOCUMENT_TYPE_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__DOCUMENT_TYPE_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__EMPLOYEE_CASEFILE_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__EMPLOYEE_CASEFILE_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__EXPIRED_REMINDED_ASC'
  | 'STORAGE_BY_STORAGE_ID__EXPIRED_REMINDED_DESC'
  | 'STORAGE_BY_STORAGE_ID__EXPIRE_AT_ASC'
  | 'STORAGE_BY_STORAGE_ID__EXPIRE_AT_DESC'
  | 'STORAGE_BY_STORAGE_ID__FILENAME_ASC'
  | 'STORAGE_BY_STORAGE_ID__FILENAME_DESC'
  | 'STORAGE_BY_STORAGE_ID__FILE_EXTENSION_ASC'
  | 'STORAGE_BY_STORAGE_ID__FILE_EXTENSION_DESC'
  | 'STORAGE_BY_STORAGE_ID__FILE_OWNER_ASC'
  | 'STORAGE_BY_STORAGE_ID__FILE_OWNER_DESC'
  | 'STORAGE_BY_STORAGE_ID__FILE_OWNER_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__FILE_OWNER_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__FILE_SIZE_ASC'
  | 'STORAGE_BY_STORAGE_ID__FILE_SIZE_DESC'
  | 'STORAGE_BY_STORAGE_ID__FILE_TYPE_ASC'
  | 'STORAGE_BY_STORAGE_ID__FILE_TYPE_DESC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_DEPARTMENT_IDS_ASC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_DEPARTMENT_IDS_DESC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_OWNER_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_OWNER_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_USER_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_USER_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_STORAGE_ID__HTML_ASC'
  | 'STORAGE_BY_STORAGE_ID__HTML_DESC'
  | 'STORAGE_BY_STORAGE_ID__ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__MIMETYPE_ASC'
  | 'STORAGE_BY_STORAGE_ID__MIMETYPE_DESC'
  | 'STORAGE_BY_STORAGE_ID__OWNER_NAME_ASC'
  | 'STORAGE_BY_STORAGE_ID__OWNER_NAME_DESC'
  | 'STORAGE_BY_STORAGE_ID__PATH_ASC'
  | 'STORAGE_BY_STORAGE_ID__PATH_DESC'
  | 'STORAGE_BY_STORAGE_ID__PENNEO_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__PENNEO_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__PLACEHOLDER_VALUES_ASC'
  | 'STORAGE_BY_STORAGE_ID__PLACEHOLDER_VALUES_DESC'
  | 'STORAGE_BY_STORAGE_ID__PROCESS_TYPE_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__PROCESS_TYPE_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__REMINDED_ASC'
  | 'STORAGE_BY_STORAGE_ID__REMINDED_DESC'
  | 'STORAGE_BY_STORAGE_ID__REMIND_AT_ASC'
  | 'STORAGE_BY_STORAGE_ID__REMIND_AT_DESC'
  | 'STORAGE_BY_STORAGE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__TEMPLATING_SERVICE_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__TEMPLATING_SERVICE_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__USERS_RESPONSIBLE_ASC'
  | 'STORAGE_BY_STORAGE_ID__USERS_RESPONSIBLE_DESC'
  | 'STORAGE_BY_STORAGE_ID__USERS_SHARED_WITH_ASC'
  | 'STORAGE_BY_STORAGE_ID__USERS_SHARED_WITH_DEPARTMENTS_ASC'
  | 'STORAGE_BY_STORAGE_ID__USERS_SHARED_WITH_DEPARTMENTS_DESC'
  | 'STORAGE_BY_STORAGE_ID__USERS_SHARED_WITH_DESC'
  | 'STORAGE_ID_ASC'
  | 'STORAGE_ID_DESC'
  | 'TOKENS_REVOKED_AT_ASC'
  | 'TOKENS_REVOKED_AT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

export type AuthCode = {
  __typename?: 'AuthCode';
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `AuthCode` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AuthCodeCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `AuthCode` object types. All fields are combined with a logical ‘and.’ */
export type AuthCodeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuthCodeFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuthCodeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuthCodeFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `AuthCode` */
export type AuthCodeInput = {
  createdAt: Scalars['Datetime'];
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

/** Represents an update to a `AuthCode`. Fields that are set will be updated. */
export type AuthCodePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `AuthCode` values. */
export type AuthCodesConnection = {
  __typename?: 'AuthCodesConnection';
  /** A list of edges which contains the `AuthCode` and cursor to aid in pagination. */
  edges: Array<AuthCodesEdge>;
  /** A list of `AuthCode` objects. */
  nodes: Array<Maybe<AuthCode>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuthCode` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AuthCode` edge in the connection. */
export type AuthCodesEdge = {
  __typename?: 'AuthCodesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AuthCode` at the end of the edge. */
  node?: Maybe<AuthCode>;
};

/** Methods to use when ordering `AuthCode`. */
export type AuthCodesOrderBy =
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DELETED_AT_ASC'
  | 'DELETED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** All input for the `autoAddPermissionGroups` mutation. */
export type AutoAddPermissionGroupsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `autoAddPermissionGroups` mutation. */
export type AutoAddPermissionGroupsPayload = {
  __typename?: 'AutoAddPermissionGroupsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type BlacklistedField = {
  formFieldId?: InputMaybe<Scalars['UUID']>;
  systemFieldName?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type BulkApplyTimeRegistrationTemplateInput = {
  employeeIds: Array<Scalars['UUID']>;
  timeRegistrationTemplateId: Scalars['UUID'];
};

export type CasefileDocumentInput = {
  pdfFile: Scalars['String'];
  title: Scalars['String'];
};

export type CasefileRecipientInput = {
  id: Scalars['UUID'];
  useEmailWork?: InputMaybe<Scalars['Boolean']>;
};

export type CasefileSignerInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  onBehalfOf?: InputMaybe<Scalars['String']>;
  role: Scalars['String'];
  signOrder: Scalars['Int'];
  socialSecurityNumberPlain?: InputMaybe<Scalars['String']>;
  useEmailWork?: InputMaybe<Scalars['Boolean']>;
  vatin?: InputMaybe<Scalars['String']>;
};

export type ChangeGodModeStatusInput = {
  enable: Scalars['Boolean'];
  userId: Scalars['UUID'];
};

export type ChangeGodModeStatusPayload = {
  __typename?: 'ChangeGodModeStatusPayload';
  user?: Maybe<User>;
};

export type ChangeTimeRegistrationBreakTypeInput = {
  timeRegistrationBreakTypeId: Scalars['UUID'];
};

export type ChangeTimeRegistrationPresenceInput = {
  timeRegistrationPresenceTypeId: Scalars['UUID'];
};

export type ChangeTimeRegistrationProjectInput = {
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
};

export type Changelog = {
  __typename?: 'Changelog';
  /** Reads and enables pagination through a set of `ChangelogUser`. */
  changelogUsers: ChangelogUsersConnection;
  guides?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isAppNotes: Scalars['Boolean'];
  locale: Scalars['String'];
  major?: Maybe<Scalars['String']>;
  minor?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  releaseDate: Scalars['Date'];
  system: SystemType;
  version: Scalars['String'];
};


export type ChangelogChangelogUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ChangelogUserCondition>;
  filter?: InputMaybe<ChangelogUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChangelogUsersOrderBy>>;
};

/** The fields on `changelog` to look up the row to connect. */
export type ChangelogChangelogPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `changelog` to look up the row to delete. */
export type ChangelogChangelogPkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `Changelog` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ChangelogCondition = {
  /** Checks for equality with the object’s `guides` field. */
  guides?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isAppNotes` field. */
  isAppNotes?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `locale` field. */
  locale?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `major` field. */
  major?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `minor` field. */
  minor?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `published` field. */
  published?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `releaseDate` field. */
  releaseDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `system` field. */
  system?: InputMaybe<SystemType>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Changelog` object types. All fields are combined with a logical ‘and.’ */
export type ChangelogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ChangelogFilter>>;
  /** Filter by the object’s `changelogUsers` relation. */
  changelogUsers?: InputMaybe<ChangelogToManyChangelogUserFilter>;
  /** Some related `changelogUsers` exist. */
  changelogUsersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `guides` field. */
  guides?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isAppNotes` field. */
  isAppNotes?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `locale` field. */
  locale?: InputMaybe<StringFilter>;
  /** Filter by the object’s `major` field. */
  major?: InputMaybe<StringFilter>;
  /** Filter by the object’s `minor` field. */
  minor?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ChangelogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ChangelogFilter>>;
  /** Filter by the object’s `published` field. */
  published?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `releaseDate` field. */
  releaseDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `system` field. */
  system?: InputMaybe<SystemTypeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Changelog` */
export type ChangelogInput = {
  changelogUsers?: InputMaybe<ChangelogUserChangelogIdForeignInverseInput>;
  guides?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAppNotes?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  major?: InputMaybe<Scalars['String']>;
  minor?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  releaseDate: Scalars['Date'];
  system: SystemType;
  version: Scalars['String'];
};

/** The fields on `changelog` to look up the row to update. */
export type ChangelogOnChangelogUserForChangelogUserChangelogIdForeignUsingChangelogPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `changelog` being updated. */
  patch: UpdateChangelogOnChangelogUserForChangelogUserChangelogIdForeignPatch;
};

/** Represents an update to a `Changelog`. Fields that are set will be updated. */
export type ChangelogPatch = {
  changelogUsers?: InputMaybe<ChangelogUserChangelogIdForeignInverseInput>;
  guides?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAppNotes?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  major?: InputMaybe<Scalars['String']>;
  minor?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  releaseDate?: InputMaybe<Scalars['Date']>;
  system?: InputMaybe<SystemType>;
  version?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against many `ChangelogUser` object types. All fields are combined with a logical ‘and.’ */
export type ChangelogToManyChangelogUserFilter = {
  /** Every related `ChangelogUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ChangelogUserFilter>;
  /** No related `ChangelogUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ChangelogUserFilter>;
  /** Some related `ChangelogUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ChangelogUserFilter>;
};

export type ChangelogUser = {
  __typename?: 'ChangelogUser';
  /** Reads a single `Changelog` that is related to this `ChangelogUser`. */
  changelog?: Maybe<Changelog>;
  changelogId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `ChangelogUser`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The `changelog` to be created by this mutation. */
export type ChangelogUserChangelogIdForeignConnectionChangelogCreateInput = {
  changelogUsers?: InputMaybe<ChangelogUserChangelogIdForeignInverseInput>;
  guides?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAppNotes?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  major?: InputMaybe<Scalars['String']>;
  minor?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  releaseDate: Scalars['Date'];
  system: SystemType;
  version: Scalars['String'];
};

/** The `changelogUser` to be created by this mutation. */
export type ChangelogUserChangelogIdForeignConnectionChangelogUserCreateInput = {
  changelog?: InputMaybe<ChangelogUserChangelogIdForeignInput>;
  user?: InputMaybe<ChangelogUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `changelog` in the `ChangelogUserInput` mutation. */
export type ChangelogUserChangelogIdForeignInput = {
  /** The primary key(s) for `changelog` for the far side of the relationship. */
  connectById?: InputMaybe<ChangelogChangelogPkeyConnect>;
  /** A `ChangelogInput` object that will be created and connected to this object. */
  create?: InputMaybe<ChangelogUserChangelogIdForeignConnectionChangelogCreateInput>;
  /** The primary key(s) for `changelog` for the far side of the relationship. */
  deleteById?: InputMaybe<ChangelogChangelogPkeyDelete>;
  /** The primary key(s) and patch data for `changelog` for the far side of the relationship. */
  updateById?: InputMaybe<ChangelogOnChangelogUserForChangelogUserChangelogIdForeignUsingChangelogPkeyUpdate>;
};

/** Input for the nested mutation of `changelogUser` in the `ChangelogInput` mutation. */
export type ChangelogUserChangelogIdForeignInverseInput = {
  /** The primary key(s) for `changelogUser` for the far side of the relationship. */
  connectByChangelogIdAndUserId?: InputMaybe<Array<ChangelogUserChangelogUserPkeyConnect>>;
  /** A `ChangelogUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ChangelogUserChangelogIdForeignConnectionChangelogUserCreateInput>>;
  /** The primary key(s) for `changelogUser` for the far side of the relationship. */
  deleteByChangelogIdAndUserId?: InputMaybe<Array<ChangelogUserChangelogUserPkeyDelete>>;
  /** Flag indicating whether all other `changelogUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `changelogUser` for the far side of the relationship. */
  updateByChangelogIdAndUserId?: InputMaybe<Array<ChangelogUserOnChangelogUserForChangelogUserChangelogIdForeignUsingChangelogUserPkeyUpdate>>;
};

/** The fields on `changelogUser` to look up the row to connect. */
export type ChangelogUserChangelogUserPkeyConnect = {
  changelogId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `changelogUser` to look up the row to delete. */
export type ChangelogUserChangelogUserPkeyDelete = {
  changelogId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/**
 * A condition to be used against `ChangelogUser` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ChangelogUserCondition = {
  /** Checks for equality with the object’s `changelogId` field. */
  changelogId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ChangelogUser` object types. All fields are combined with a logical ‘and.’ */
export type ChangelogUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ChangelogUserFilter>>;
  /** Filter by the object’s `changelog` relation. */
  changelog?: InputMaybe<ChangelogFilter>;
  /** Filter by the object’s `changelogId` field. */
  changelogId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ChangelogUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ChangelogUserFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ChangelogUser` */
export type ChangelogUserInput = {
  changelog?: InputMaybe<ChangelogUserChangelogIdForeignInput>;
  changelogId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<ChangelogUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `changelogUser` to look up the row to update. */
export type ChangelogUserOnChangelogUserForChangelogUserChangelogIdForeignUsingChangelogUserPkeyUpdate = {
  changelogId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `changelogUser` being updated. */
  patch: UpdateChangelogUserOnChangelogUserForChangelogUserChangelogIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `changelogUser` to look up the row to update. */
export type ChangelogUserOnChangelogUserForChangelogUserUserIdForeignUsingChangelogUserPkeyUpdate = {
  changelogId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `changelogUser` being updated. */
  patch: UpdateChangelogUserOnChangelogUserForChangelogUserUserIdForeignPatch;
  userId: Scalars['UUID'];
};

/** Represents an update to a `ChangelogUser`. Fields that are set will be updated. */
export type ChangelogUserPatch = {
  changelog?: InputMaybe<ChangelogUserChangelogIdForeignInput>;
  changelogId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<ChangelogUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `changelogUser` to be created by this mutation. */
export type ChangelogUserUserIdForeignConnectionChangelogUserCreateInput = {
  changelog?: InputMaybe<ChangelogUserChangelogIdForeignInput>;
  changelogId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<ChangelogUserUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `ChangelogUserInput` mutation. */
export type ChangelogUserUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnChangelogUserForChangelogUserUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `changelogUser` in the `UserInput` mutation. */
export type ChangelogUserUserIdForeignInverseInput = {
  /** The primary key(s) for `changelogUser` for the far side of the relationship. */
  connectByChangelogIdAndUserId?: InputMaybe<Array<ChangelogUserChangelogUserPkeyConnect>>;
  /** A `ChangelogUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ChangelogUserUserIdForeignConnectionChangelogUserCreateInput>>;
  /** The primary key(s) for `changelogUser` for the far side of the relationship. */
  deleteByChangelogIdAndUserId?: InputMaybe<Array<ChangelogUserChangelogUserPkeyDelete>>;
  /** Flag indicating whether all other `changelogUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `changelogUser` for the far side of the relationship. */
  updateByChangelogIdAndUserId?: InputMaybe<Array<ChangelogUserOnChangelogUserForChangelogUserUserIdForeignUsingChangelogUserPkeyUpdate>>;
};

/** A connection to a list of `ChangelogUser` values. */
export type ChangelogUsersConnection = {
  __typename?: 'ChangelogUsersConnection';
  /** A list of edges which contains the `ChangelogUser` and cursor to aid in pagination. */
  edges: Array<ChangelogUsersEdge>;
  /** A list of `ChangelogUser` objects. */
  nodes: Array<Maybe<ChangelogUser>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ChangelogUser` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ChangelogUser` edge in the connection. */
export type ChangelogUsersEdge = {
  __typename?: 'ChangelogUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ChangelogUser` at the end of the edge. */
  node?: Maybe<ChangelogUser>;
};

/** Methods to use when ordering `ChangelogUser`. */
export type ChangelogUsersOrderBy =
  | 'CHANGELOG_BY_CHANGELOG_ID__GUIDES_ASC'
  | 'CHANGELOG_BY_CHANGELOG_ID__GUIDES_DESC'
  | 'CHANGELOG_BY_CHANGELOG_ID__ID_ASC'
  | 'CHANGELOG_BY_CHANGELOG_ID__ID_DESC'
  | 'CHANGELOG_BY_CHANGELOG_ID__IS_APP_NOTES_ASC'
  | 'CHANGELOG_BY_CHANGELOG_ID__IS_APP_NOTES_DESC'
  | 'CHANGELOG_BY_CHANGELOG_ID__LOCALE_ASC'
  | 'CHANGELOG_BY_CHANGELOG_ID__LOCALE_DESC'
  | 'CHANGELOG_BY_CHANGELOG_ID__MAJOR_ASC'
  | 'CHANGELOG_BY_CHANGELOG_ID__MAJOR_DESC'
  | 'CHANGELOG_BY_CHANGELOG_ID__MINOR_ASC'
  | 'CHANGELOG_BY_CHANGELOG_ID__MINOR_DESC'
  | 'CHANGELOG_BY_CHANGELOG_ID__PUBLISHED_ASC'
  | 'CHANGELOG_BY_CHANGELOG_ID__PUBLISHED_DESC'
  | 'CHANGELOG_BY_CHANGELOG_ID__RELEASE_DATE_ASC'
  | 'CHANGELOG_BY_CHANGELOG_ID__RELEASE_DATE_DESC'
  | 'CHANGELOG_BY_CHANGELOG_ID__SYSTEM_ASC'
  | 'CHANGELOG_BY_CHANGELOG_ID__SYSTEM_DESC'
  | 'CHANGELOG_BY_CHANGELOG_ID__VERSION_ASC'
  | 'CHANGELOG_BY_CHANGELOG_ID__VERSION_DESC'
  | 'CHANGELOG_ID_ASC'
  | 'CHANGELOG_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** A connection to a list of `Changelog` values. */
export type ChangelogsConnection = {
  __typename?: 'ChangelogsConnection';
  /** A list of edges which contains the `Changelog` and cursor to aid in pagination. */
  edges: Array<ChangelogsEdge>;
  /** A list of `Changelog` objects. */
  nodes: Array<Maybe<Changelog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Changelog` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Changelog` edge in the connection. */
export type ChangelogsEdge = {
  __typename?: 'ChangelogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Changelog` at the end of the edge. */
  node?: Maybe<Changelog>;
};

/** Methods to use when ordering `Changelog`. */
export type ChangelogsOrderBy =
  | 'CHANGELOG_USERS_BY_CHANGELOG_ID__COUNT_ASC'
  | 'CHANGELOG_USERS_BY_CHANGELOG_ID__COUNT_DESC'
  | 'GUIDES_ASC'
  | 'GUIDES_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IS_APP_NOTES_ASC'
  | 'IS_APP_NOTES_DESC'
  | 'LOCALE_ASC'
  | 'LOCALE_DESC'
  | 'MAJOR_ASC'
  | 'MAJOR_DESC'
  | 'MINOR_ASC'
  | 'MINOR_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PUBLISHED_ASC'
  | 'PUBLISHED_DESC'
  | 'RELEASE_DATE_ASC'
  | 'RELEASE_DATE_DESC'
  | 'SYSTEM_ASC'
  | 'SYSTEM_DESC'
  | 'VERSION_ASC'
  | 'VERSION_DESC';

export type ChannelType = {
  __typename?: 'ChannelType';
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `NotificationTypeChannelType`. */
  notificationTypeChannelTypes: NotificationTypeChannelTypesConnection;
};


export type ChannelTypeNotificationTypeChannelTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationTypeChannelTypeCondition>;
  filter?: InputMaybe<NotificationTypeChannelTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationTypeChannelTypesOrderBy>>;
};

/** The fields on `channelType` to look up the row to connect. */
export type ChannelTypeChannelTypeNameUniqueConnect = {
  name: Scalars['String'];
};

/** The fields on `channelType` to look up the row to connect. */
export type ChannelTypeChannelTypePkeyConnect = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `ChannelType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ChannelTypeCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `ChannelType` object types. All fields are combined with a logical ‘and.’ */
export type ChannelTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ChannelTypeFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ChannelTypeFilter>;
  /** Filter by the object’s `notificationTypeChannelTypes` relation. */
  notificationTypeChannelTypes?: InputMaybe<ChannelTypeToManyNotificationTypeChannelTypeFilter>;
  /** Some related `notificationTypeChannelTypes` exist. */
  notificationTypeChannelTypesExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ChannelTypeFilter>>;
};

/** The fields on `channelType` to look up the row to update. */
export type ChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeChannelTypeIdForeignUsingChannelTypeNameUniqueUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `channelType` being updated. */
  patch: UpdateChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeChannelTypeIdForeignPatch;
};

/** The fields on `channelType` to look up the row to update. */
export type ChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeChannelTypeIdForeignUsingChannelTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `channelType` being updated. */
  patch: UpdateChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeChannelTypeIdForeignPatch;
};

/** A filter to be used against many `NotificationTypeChannelType` object types. All fields are combined with a logical ‘and.’ */
export type ChannelTypeToManyNotificationTypeChannelTypeFilter = {
  /** Every related `NotificationTypeChannelType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationTypeChannelTypeFilter>;
  /** No related `NotificationTypeChannelType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationTypeChannelTypeFilter>;
  /** Some related `NotificationTypeChannelType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationTypeChannelTypeFilter>;
};

/** A connection to a list of `ChannelType` values. */
export type ChannelTypesConnection = {
  __typename?: 'ChannelTypesConnection';
  /** A list of edges which contains the `ChannelType` and cursor to aid in pagination. */
  edges: Array<ChannelTypesEdge>;
  /** A list of `ChannelType` objects. */
  nodes: Array<Maybe<ChannelType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ChannelType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ChannelType` edge in the connection. */
export type ChannelTypesEdge = {
  __typename?: 'ChannelTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ChannelType` at the end of the edge. */
  node?: Maybe<ChannelType>;
};

/** Methods to use when ordering `ChannelType`. */
export type ChannelTypesOrderBy =
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_TYPE_CHANNEL_TYPES_BY_CHANNEL_TYPE_ID__COUNT_ASC'
  | 'NOTIFICATION_TYPE_CHANNEL_TYPES_BY_CHANNEL_TYPE_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/** All input for the `checkCompanyGrowthPermissions` mutation. */
export type CheckCompanyGrowthPermissionsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `checkCompanyGrowthPermissions` mutation. */
export type CheckCompanyGrowthPermissionsPayload = {
  __typename?: 'CheckCompanyGrowthPermissionsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `checkLogPermission` mutation. */
export type CheckLogPermissionInput = {
  argDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  argUserId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `checkLogPermission` mutation. */
export type CheckLogPermissionPayload = {
  __typename?: 'CheckLogPermissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `checkPublishedAnnouncements` mutation. */
export type CheckPublishedAnnouncementsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `checkPublishedAnnouncements` mutation. */
export type CheckPublishedAnnouncementsPayload = {
  __typename?: 'CheckPublishedAnnouncementsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type ChosenColumn = {
  __typename?: 'ChosenColumn';
  chosenColumns?: Maybe<Scalars['JSON']>;
  filters?: Maybe<Scalars['JSON']>;
  miscellaneousFilters?: Maybe<Scalars['JSON']>;
  tableName: Scalars['String'];
  /** Reads a single `User` that is related to this `ChosenColumn`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The fields on `chosenColumn` to look up the row to connect. */
export type ChosenColumnChosenColumnsPkeyConnect = {
  tableName: Scalars['String'];
  userId: Scalars['UUID'];
};

/** The fields on `chosenColumn` to look up the row to delete. */
export type ChosenColumnChosenColumnsPkeyDelete = {
  tableName: Scalars['String'];
  userId: Scalars['UUID'];
};

/**
 * A condition to be used against `ChosenColumn` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ChosenColumnCondition = {
  /** Checks for equality with the object’s `chosenColumns` field. */
  chosenColumns?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `filters` field. */
  filters?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `miscellaneousFilters` field. */
  miscellaneousFilters?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `tableName` field. */
  tableName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ChosenColumn` object types. All fields are combined with a logical ‘and.’ */
export type ChosenColumnFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ChosenColumnFilter>>;
  /** Filter by the object’s `chosenColumns` field. */
  chosenColumns?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `filters` field. */
  filters?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `miscellaneousFilters` field. */
  miscellaneousFilters?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ChosenColumnFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ChosenColumnFilter>>;
  /** Filter by the object’s `tableName` field. */
  tableName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ChosenColumn` */
export type ChosenColumnInput = {
  chosenColumns?: InputMaybe<Scalars['JSON']>;
  filters?: InputMaybe<Scalars['JSON']>;
  miscellaneousFilters?: InputMaybe<Scalars['JSON']>;
  tableName: Scalars['String'];
  user?: InputMaybe<ChosenColumnsUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `chosenColumn` to look up the row to update. */
export type ChosenColumnOnChosenColumnForChosenColumnsUserIdForeignUsingChosenColumnsPkeyUpdate = {
  /** An object where the defined keys will be set on the `chosenColumn` being updated. */
  patch: UpdateChosenColumnOnChosenColumnForChosenColumnsUserIdForeignPatch;
  tableName: Scalars['String'];
  userId: Scalars['UUID'];
};

/** Represents an update to a `ChosenColumn`. Fields that are set will be updated. */
export type ChosenColumnPatch = {
  chosenColumns?: InputMaybe<Scalars['JSON']>;
  filters?: InputMaybe<Scalars['JSON']>;
  miscellaneousFilters?: InputMaybe<Scalars['JSON']>;
  tableName?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<ChosenColumnsUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `ChosenColumn` values. */
export type ChosenColumnsConnection = {
  __typename?: 'ChosenColumnsConnection';
  /** A list of edges which contains the `ChosenColumn` and cursor to aid in pagination. */
  edges: Array<ChosenColumnsEdge>;
  /** A list of `ChosenColumn` objects. */
  nodes: Array<Maybe<ChosenColumn>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ChosenColumn` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ChosenColumn` edge in the connection. */
export type ChosenColumnsEdge = {
  __typename?: 'ChosenColumnsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ChosenColumn` at the end of the edge. */
  node?: Maybe<ChosenColumn>;
};

/** Methods to use when ordering `ChosenColumn`. */
export type ChosenColumnsOrderBy =
  | 'CHOSEN_COLUMNS_ASC'
  | 'CHOSEN_COLUMNS_DESC'
  | 'FILTERS_ASC'
  | 'FILTERS_DESC'
  | 'MISCELLANEOUS_FILTERS_ASC'
  | 'MISCELLANEOUS_FILTERS_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TABLE_NAME_ASC'
  | 'TABLE_NAME_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** The `chosenColumn` to be created by this mutation. */
export type ChosenColumnsUserIdForeignConnectionChosenColumnsCreateInput = {
  chosenColumns?: InputMaybe<Scalars['JSON']>;
  filters?: InputMaybe<Scalars['JSON']>;
  miscellaneousFilters?: InputMaybe<Scalars['JSON']>;
  tableName: Scalars['String'];
  user?: InputMaybe<ChosenColumnsUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `ChosenColumnInput` mutation. */
export type ChosenColumnsUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnChosenColumnForChosenColumnsUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `chosenColumn` in the `UserInput` mutation. */
export type ChosenColumnsUserIdForeignInverseInput = {
  /** The primary key(s) for `chosenColumn` for the far side of the relationship. */
  connectByUserIdAndTableName?: InputMaybe<Array<ChosenColumnChosenColumnsPkeyConnect>>;
  /** A `ChosenColumnInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ChosenColumnsUserIdForeignConnectionChosenColumnsCreateInput>>;
  /** The primary key(s) for `chosenColumn` for the far side of the relationship. */
  deleteByUserIdAndTableName?: InputMaybe<Array<ChosenColumnChosenColumnsPkeyDelete>>;
  /** Flag indicating whether all other `chosenColumn` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `chosenColumn` for the far side of the relationship. */
  updateByUserIdAndTableName?: InputMaybe<Array<ChosenColumnOnChosenColumnForChosenColumnsUserIdForeignUsingChosenColumnsPkeyUpdate>>;
};

/** All input for the `cleanupEmptyGroups` mutation. */
export type CleanupEmptyGroupsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `cleanupEmptyGroups` mutation. */
export type CleanupEmptyGroupsPayload = {
  __typename?: 'CleanupEmptyGroupsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `clearTimeRegistrationPresenceTemplateDay` mutation. */
export type ClearTimeRegistrationPresenceTemplateDayInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dayOfWeek?: InputMaybe<Scalars['Int']>;
  timeRegistrationTemplateWeekId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `clearTimeRegistrationPresenceTemplateDay` mutation. */
export type ClearTimeRegistrationPresenceTemplateDayPayload = {
  __typename?: 'ClearTimeRegistrationPresenceTemplateDayPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  timeRegistrationPresenceTemplates?: Maybe<Array<Maybe<TimeRegistrationPresenceTemplate>>>;
};

export type ClockInInput = {
  timeRegistrationPresenceTypeId: Scalars['UUID'];
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
};

/** All input for the `cloneContractTemplate` mutation. */
export type CloneContractTemplateInput = {
  argDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  argId?: InputMaybe<Scalars['UUID']>;
  argName?: InputMaybe<Scalars['String']>;
  argSignable?: InputMaybe<Scalars['Boolean']>;
  argUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `cloneContractTemplate` mutation. */
export type CloneContractTemplatePayload = {
  __typename?: 'CloneContractTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  contractTemplate?: Maybe<ContractTemplate>;
  /** An edge for our `ContractTemplate`. May be used by Relay 1. */
  contractTemplateEdge?: Maybe<ContractTemplatesEdge>;
  /** Reads a single `DocumentType` that is related to this `ContractTemplate`. */
  documentType?: Maybe<DocumentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `cloneContractTemplate` mutation. */
export type CloneContractTemplatePayloadContractTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractTemplatesOrderBy>>;
};

export type CloneProcessInput = {
  departmentIds?: InputMaybe<Array<Scalars['UUID']>>;
  name: Scalars['String'];
  processId: Scalars['UUID'];
};

export type CommunicationLogItem = {
  __typename?: 'CommunicationLogItem';
  companyId?: Maybe<Scalars['String']>;
  dispatchId?: Maybe<Scalars['Int']>;
  emailBcc?: Maybe<Array<Maybe<Scalars['String']>>>;
  emailCc?: Maybe<Array<Maybe<Scalars['String']>>>;
  emailCreatedAt?: Maybe<Scalars['Datetime']>;
  emailFrom?: Maybe<Scalars['String']>;
  emailHtml?: Maybe<Scalars['String']>;
  emailReplyTo?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  emailText?: Maybe<Scalars['String']>;
  emailTo?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['Int']>;
  latestEvent?: Maybe<Scalars['Datetime']>;
  receiverId?: Maybe<Scalars['String']>;
  receiverRole?: Maybe<Scalars['String']>;
  senderId?: Maybe<Scalars['String']>;
  senderRole?: Maybe<Scalars['String']>;
  status?: Maybe<CommunicationLogStatusType>;
  system?: Maybe<Scalars['String']>;
};

export type CommunicationLogItemEdge = {
  __typename?: 'CommunicationLogItemEdge';
  node?: Maybe<CommunicationLogItem>;
};

export type CommunicationLogOrderBy =
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC';

export type CommunicationLogResponse = {
  __typename?: 'CommunicationLogResponse';
  edges: Array<CommunicationLogItemEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CommunicationLogStatusType =
  | 'BOUNCE'
  | 'CLICK'
  | 'COMPLAINT'
  | 'DELIVERY'
  | 'OPEN'
  | 'REJECT'
  | 'RENDERING_FAILURE'
  | 'SEND';

/** A connection to a list of `Company` values. */
export type CompaniesConnection = {
  __typename?: 'CompaniesConnection';
  /** A list of edges which contains the `Company` and cursor to aid in pagination. */
  edges: Array<CompaniesEdge>;
  /** A list of `Company` objects. */
  nodes: Array<Maybe<Company>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Company` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Company` edge in the connection. */
export type CompaniesEdge = {
  __typename?: 'CompaniesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Company` at the end of the edge. */
  node?: Maybe<Company>;
};

/** Methods to use when ordering `Company`. */
export type CompaniesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ANNOUNCEMENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'ANNOUNCEMENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'APPROVALS_BY_COMPANY_ID__COUNT_ASC'
  | 'APPROVALS_BY_COMPANY_ID__COUNT_DESC'
  | 'ASYNC_JOBS_BY_COMPANY_ID__COUNT_ASC'
  | 'ASYNC_JOBS_BY_COMPANY_ID__COUNT_DESC'
  | 'ASYNC_JOB_ITEMS_BY_COMPANY_ID__COUNT_ASC'
  | 'ASYNC_JOB_ITEMS_BY_COMPANY_ID__COUNT_DESC'
  | 'AVAILABLE_LOCALES_ASC'
  | 'AVAILABLE_LOCALES_DESC'
  | 'COMPANIES_BY_MASTER_FOR_COMPANY_ID__COUNT_ASC'
  | 'COMPANIES_BY_MASTER_FOR_COMPANY_ID__COUNT_DESC'
  | 'COMPANY_BINDINGS_BY_COMPANY_ID__COUNT_ASC'
  | 'COMPANY_BINDINGS_BY_COMPANY_ID__COUNT_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_MASTER_FOR_COMPANY_ID__URL_DESC'
  | 'COMPANY_COMPANY_TYPE_BY_COMPANY_ID__COMPANY_ID_ASC'
  | 'COMPANY_COMPANY_TYPE_BY_COMPANY_ID__COMPANY_ID_DESC'
  | 'COMPANY_COMPANY_TYPE_BY_COMPANY_ID__COMPANY_TYPE_ID_ASC'
  | 'COMPANY_COMPANY_TYPE_BY_COMPANY_ID__COMPANY_TYPE_ID_DESC'
  | 'COMPANY_SETTINGS_BY_COMPANY_ID__COUNT_ASC'
  | 'COMPANY_SETTINGS_BY_COMPANY_ID__COUNT_DESC'
  | 'COMPANY_SYSTEM_FIELDS_BY_COMPANY_ID__COUNT_ASC'
  | 'COMPANY_SYSTEM_FIELDS_BY_COMPANY_ID__COUNT_DESC'
  | 'COMPANY_SYSTEM_FIELD_OPTIONS_BY_COMPANY_ID__COUNT_ASC'
  | 'COMPANY_SYSTEM_FIELD_OPTIONS_BY_COMPANY_ID__COUNT_DESC'
  | 'COMPETENCES_BY_COMPANY_ID__COUNT_ASC'
  | 'COMPETENCES_BY_COMPANY_ID__COUNT_DESC'
  | 'COMPETENCE_FORM_FIELDS_BY_COMPANY_ID__COUNT_ASC'
  | 'COMPETENCE_FORM_FIELDS_BY_COMPANY_ID__COUNT_DESC'
  | 'COMPETENCE_GROUPS_BY_COMPANY_ID__COUNT_ASC'
  | 'COMPETENCE_GROUPS_BY_COMPANY_ID__COUNT_DESC'
  | 'COMPETENCE_REQUESTS_BY_COMPANY_ID__COUNT_ASC'
  | 'COMPETENCE_REQUESTS_BY_COMPANY_ID__COUNT_DESC'
  | 'CONTRACT_SIGN_PENDINGS_BY_COMPANY_ID__COUNT_ASC'
  | 'CONTRACT_SIGN_PENDINGS_BY_COMPANY_ID__COUNT_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'CONTRACT_SIGN_PENDING_SIGNERS_BY_COMPANY_ID__COUNT_ASC'
  | 'CONTRACT_SIGN_PENDING_SIGNERS_BY_COMPANY_ID__COUNT_DESC'
  | 'CONTRACT_TEMPLATE_DEPARTMENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'CONTRACT_TEMPLATE_DEPARTMENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'CONTRACT_TEMPLATE_USERS_BY_COMPANY_ID__COUNT_ASC'
  | 'CONTRACT_TEMPLATE_USERS_BY_COMPANY_ID__COUNT_DESC'
  | 'COPY_IN_PROGRESS_ASC'
  | 'COPY_IN_PROGRESS_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CUSTOM_WIDGETS_BY_COMPANY_ID__COUNT_ASC'
  | 'CUSTOM_WIDGETS_BY_COMPANY_ID__COUNT_DESC'
  | 'CUSTOM_WIDGET_CONTENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'CUSTOM_WIDGET_CONTENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'CVR_ASC'
  | 'CVR_DESC'
  | 'CV_TEMPLATE_FIELD_MAPPINGS_BY_COMPANY_ID__COUNT_ASC'
  | 'CV_TEMPLATE_FIELD_MAPPINGS_BY_COMPANY_ID__COUNT_DESC'
  | 'DASHBOARD_CARDS_BY_COMPANY_ID__COUNT_ASC'
  | 'DASHBOARD_CARDS_BY_COMPANY_ID__COUNT_DESC'
  | 'DASHBOARD_CARD_STATISTICS_BY_COMPANY_ID__COUNT_ASC'
  | 'DASHBOARD_CARD_STATISTICS_BY_COMPANY_ID__COUNT_DESC'
  | 'DASHBOARD_CONFIG_BY_COMPANY_ID__COMPANY_ID_ASC'
  | 'DASHBOARD_CONFIG_BY_COMPANY_ID__COMPANY_ID_DESC'
  | 'DASHBOARD_CONFIG_BY_COMPANY_ID__PAGE_TITLE_ASC'
  | 'DASHBOARD_CONFIG_BY_COMPANY_ID__PAGE_TITLE_DESC'
  | 'DASHBOARD_VIEWS_BY_COMPANY_ID__COUNT_ASC'
  | 'DASHBOARD_VIEWS_BY_COMPANY_ID__COUNT_DESC'
  | 'DELETE_AT_ASC'
  | 'DELETE_AT_DESC'
  | 'DEPARTMENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'DEPARTMENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'DEPARTMENT_TYPES_BY_COMPANY_ID__COUNT_ASC'
  | 'DEPARTMENT_TYPES_BY_COMPANY_ID__COUNT_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'DOCUMENT_DEPARTMENT_PERMISSIONS_BY_COMPANY_ID__COUNT_ASC'
  | 'DOCUMENT_DEPARTMENT_PERMISSIONS_BY_COMPANY_ID__COUNT_DESC'
  | 'DOCUMENT_FOLDERS_BY_COMPANY_ID__COUNT_ASC'
  | 'DOCUMENT_FOLDERS_BY_COMPANY_ID__COUNT_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINTS_BY_COMPANY_ID__COUNT_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINTS_BY_COMPANY_ID__COUNT_DESC'
  | 'DOCUMENT_FOLDER_DEPARTMENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'DOCUMENT_FOLDER_DEPARTMENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'DOCUMENT_FOLDER_USERS_BY_COMPANY_ID__COUNT_ASC'
  | 'DOCUMENT_FOLDER_USERS_BY_COMPANY_ID__COUNT_DESC'
  | 'DOCUMENT_USER_PERMISSIONS_BY_COMPANY_ID__COUNT_ASC'
  | 'DOCUMENT_USER_PERMISSIONS_BY_COMPANY_ID__COUNT_DESC'
  | 'DOCUMENT_USER_RESPONSIBLES_BY_COMPANY_ID__COUNT_ASC'
  | 'DOCUMENT_USER_RESPONSIBLES_BY_COMPANY_ID__COUNT_DESC'
  | 'EMPLOYEES_BY_COMPANY_ID__COUNT_ASC'
  | 'EMPLOYEES_BY_COMPANY_ID__COUNT_DESC'
  | 'EMPLOYEE_CASEFILES_BY_COMPANY_ID__COUNT_ASC'
  | 'EMPLOYEE_CASEFILES_BY_COMPANY_ID__COUNT_DESC'
  | 'EMPLOYEE_EXTERNAL_INTEGRATIONS_BY_COMPANY_ID__COUNT_ASC'
  | 'EMPLOYEE_EXTERNAL_INTEGRATIONS_BY_COMPANY_ID__COUNT_DESC'
  | 'ENGAGEMENT_TYPES_BY_COMPANY_ID__COUNT_ASC'
  | 'ENGAGEMENT_TYPES_BY_COMPANY_ID__COUNT_DESC'
  | 'EQUIPMENT_BY_COMPANY_ID__COUNT_ASC'
  | 'EQUIPMENT_BY_COMPANY_ID__COUNT_DESC'
  | 'EVENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'EVENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'EVENT_USERS_BY_COMPANY_ID__COUNT_ASC'
  | 'EVENT_USERS_BY_COMPANY_ID__COUNT_DESC'
  | 'EXTERNAL_INTEGRATIONS_BY_COMPANY_ID__COUNT_ASC'
  | 'EXTERNAL_INTEGRATIONS_BY_COMPANY_ID__COUNT_DESC'
  | 'FIELD_GROUPS_BY_COMPANY_ID__COUNT_ASC'
  | 'FIELD_GROUPS_BY_COMPANY_ID__COUNT_DESC'
  | 'FIELD_GROUP_CARDS_BY_COMPANY_ID__COUNT_ASC'
  | 'FIELD_GROUP_CARDS_BY_COMPANY_ID__COUNT_DESC'
  | 'FIELD_GROUP_CARD_COLUMNS_BY_COMPANY_ID__COUNT_ASC'
  | 'FIELD_GROUP_CARD_COLUMNS_BY_COMPANY_ID__COUNT_DESC'
  | 'FILTER_PRESETS_BY_COMPANY_ID__COUNT_ASC'
  | 'FILTER_PRESETS_BY_COMPANY_ID__COUNT_DESC'
  | 'FORM_FIELD_AGREEMENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'FORM_FIELD_AGREEMENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'FORM_FIELD_ENTRIES_BY_COMPANY_ID__COUNT_ASC'
  | 'FORM_FIELD_ENTRIES_BY_COMPANY_ID__COUNT_DESC'
  | 'FORM_FIELD_OPTIONS_BY_COMPANY_ID__COUNT_ASC'
  | 'FORM_FIELD_OPTIONS_BY_COMPANY_ID__COUNT_DESC'
  | 'FROALA_STYLES_BY_COMPANY_ID__COUNT_ASC'
  | 'FROALA_STYLES_BY_COMPANY_ID__COUNT_DESC'
  | 'FUTURE_DATA_BY_COMPANY_ID__COUNT_ASC'
  | 'FUTURE_DATA_BY_COMPANY_ID__COUNT_DESC'
  | 'GROUP_ROLES_BY_COMPANY_ID__COUNT_ASC'
  | 'GROUP_ROLES_BY_COMPANY_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INTEGRATION_FIELD_MARKINGS_BY_COMPANY_ID__COUNT_ASC'
  | 'INTEGRATION_FIELD_MARKINGS_BY_COMPANY_ID__COUNT_DESC'
  | 'LAST_LOGIN_ASC'
  | 'LAST_LOGIN_DESC'
  | 'LATEST_MESSAGES_BY_COMPANY_ID__COUNT_ASC'
  | 'LATEST_MESSAGES_BY_COMPANY_ID__COUNT_DESC'
  | 'LOCALE_ASC'
  | 'LOCALE_DESC'
  | 'LOGGED_ACTION_NOTES_BY_COMPANY_ID__COUNT_ASC'
  | 'LOGGED_ACTION_NOTES_BY_COMPANY_ID__COUNT_DESC'
  | 'LOGIN_LOGS_BY_COMPANY_ID__COUNT_ASC'
  | 'LOGIN_LOGS_BY_COMPANY_ID__COUNT_DESC'
  | 'MASTER_FOR_COMPANY_ID_ASC'
  | 'MASTER_FOR_COMPANY_ID_DESC'
  | 'MASTER_TEMPLATE_ASC'
  | 'MASTER_TEMPLATE_DESC'
  | 'MESSAGES_BY_COMPANY_ID__COUNT_ASC'
  | 'MESSAGES_BY_COMPANY_ID__COUNT_DESC'
  | 'MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'MODE_ASC'
  | 'MODE_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATIVE_APP_ACCESS_ASC'
  | 'NATIVE_APP_ACCESS_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_CUSTOM_EMPLOYEE_FIELD_RECIPIENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'NOTIFICATION_CUSTOM_EMPLOYEE_FIELD_RECIPIENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'NOTIFICATION_CUSTOM_RECIPIENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'NOTIFICATION_CUSTOM_RECIPIENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'NOTIFICATION_EMPLOYEES_BY_COMPANY_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEES_BY_COMPANY_ID__COUNT_DESC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_COMPANY_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_COMPANY_ID__COUNT_DESC'
  | 'NOTIFICATION_GROUP_RECIPIENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'NOTIFICATION_GROUP_RECIPIENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'NOTIFICATION_TYPE_CHANNEL_TYPES_BY_COMPANY_ID__COUNT_ASC'
  | 'NOTIFICATION_TYPE_CHANNEL_TYPES_BY_COMPANY_ID__COUNT_DESC'
  | 'NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'POSTS_BY_COMPANY_ID__COUNT_ASC'
  | 'POSTS_BY_COMPANY_ID__COUNT_DESC'
  | 'POST_TYPES_BY_COMPANY_ID__COUNT_ASC'
  | 'POST_TYPES_BY_COMPANY_ID__COUNT_DESC'
  | 'PREBOARDINGS_BY_COMPANY_ID__COUNT_ASC'
  | 'PREBOARDINGS_BY_COMPANY_ID__COUNT_DESC'
  | 'PREBOARDING_COMMENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'PREBOARDING_COMMENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'PREBOARDING_EMAIL_LOGS_BY_COMPANY_ID__COUNT_ASC'
  | 'PREBOARDING_EMAIL_LOGS_BY_COMPANY_ID__COUNT_DESC'
  | 'PREBOARDING_EMPLOYEES_BY_COMPANY_ID__COUNT_ASC'
  | 'PREBOARDING_EMPLOYEES_BY_COMPANY_ID__COUNT_DESC'
  | 'PREBOARDING_PROCESSES_BY_COMPANY_ID__COUNT_ASC'
  | 'PREBOARDING_PROCESSES_BY_COMPANY_ID__COUNT_DESC'
  | 'PREBOARDING_RESULTS_BY_COMPANY_ID__COUNT_ASC'
  | 'PREBOARDING_RESULTS_BY_COMPANY_ID__COUNT_DESC'
  | 'PREBOARDING_RESULT_SLIDE_COMMENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'PREBOARDING_RESULT_SLIDE_COMMENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'PREBOARDING_SLIDES_BY_COMPANY_ID__COUNT_ASC'
  | 'PREBOARDING_SLIDES_BY_COMPANY_ID__COUNT_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELDS_BY_COMPANY_ID__COUNT_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELDS_BY_COMPANY_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESS_DEPARTMENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'PROCESS_DEPARTMENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'PROCESS_RESPONSIBLES_BY_COMPANY_ID__COUNT_ASC'
  | 'PROCESS_RESPONSIBLES_BY_COMPANY_ID__COUNT_DESC'
  | 'PROCESS_TYPES_BY_COMPANY_ID__COUNT_ASC'
  | 'PROCESS_TYPES_BY_COMPANY_ID__COUNT_DESC'
  | 'PROJECTS_BY_COMPANY_ID__COUNT_ASC'
  | 'PROJECTS_BY_COMPANY_ID__COUNT_DESC'
  | 'PROJECT_TEMPLATES_BY_COMPANY_ID__COUNT_ASC'
  | 'PROJECT_TEMPLATES_BY_COMPANY_ID__COUNT_DESC'
  | 'PULSE_SURVEYS_BY_COMPANY_ID__COUNT_ASC'
  | 'PULSE_SURVEYS_BY_COMPANY_ID__COUNT_DESC'
  | 'PULSE_SURVEY_ANSWERS_BY_COMPANY_ID__COUNT_ASC'
  | 'PULSE_SURVEY_ANSWERS_BY_COMPANY_ID__COUNT_DESC'
  | 'PULSE_SURVEY_CHOICES_BY_COMPANY_ID__COUNT_ASC'
  | 'PULSE_SURVEY_CHOICES_BY_COMPANY_ID__COUNT_DESC'
  | 'PULSE_TYPES_BY_COMPANY_ID__COUNT_ASC'
  | 'PULSE_TYPES_BY_COMPANY_ID__COUNT_DESC'
  | 'RECURRENCE_RULES_BY_COMPANY_ID__COUNT_ASC'
  | 'RECURRENCE_RULES_BY_COMPANY_ID__COUNT_DESC'
  | 'REFERENCE_TOKENS_BY_COMPANY_ID__COUNT_ASC'
  | 'REFERENCE_TOKENS_BY_COMPANY_ID__COUNT_DESC'
  | 'RELATION_ROLES_BY_COMPANY_ID__COUNT_ASC'
  | 'RELATION_ROLES_BY_COMPANY_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGES_BY_COMPANY_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGES_BY_COMPANY_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGE_EXTERNAL_RECIPIENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGE_EXTERNAL_RECIPIENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGE_RECIPIENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGE_RECIPIENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATES_BY_COMPANY_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATES_BY_COMPANY_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_EXTERNAL_RECIPIENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_EXTERNAL_RECIPIENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_RECIPIENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_RECIPIENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'SSO_ASC'
  | 'SSO_DESC'
  | 'SUPER_USER_ALLOWED_USERS_BY_COMPANY_ID__COUNT_ASC'
  | 'SUPER_USER_ALLOWED_USERS_BY_COMPANY_ID__COUNT_DESC'
  | 'TASKS_BY_COMPANY_ID__COUNT_ASC'
  | 'TASKS_BY_COMPANY_ID__COUNT_DESC'
  | 'TASK_EMPLOYEES_BY_COMPANY_ID__COUNT_ASC'
  | 'TASK_EMPLOYEES_BY_COMPANY_ID__COUNT_DESC'
  | 'TASK_RESPONSIBLES_BY_COMPANY_ID__COUNT_ASC'
  | 'TASK_RESPONSIBLES_BY_COMPANY_ID__COUNT_DESC'
  | 'TASK_TEMPLATES_BY_COMPANY_ID__COUNT_ASC'
  | 'TASK_TEMPLATES_BY_COMPANY_ID__COUNT_DESC'
  | 'TASK_TEMPLATE_EMPLOYEES_BY_COMPANY_ID__COUNT_ASC'
  | 'TASK_TEMPLATE_EMPLOYEES_BY_COMPANY_ID__COUNT_DESC'
  | 'TASK_TEMPLATE_RESPONSIBLES_BY_COMPANY_ID__COUNT_ASC'
  | 'TASK_TEMPLATE_RESPONSIBLES_BY_COMPANY_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPES_BY_COMPANY_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPES_BY_COMPANY_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_ENTRIES_BY_COMPANY_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_ENTRIES_BY_COMPANY_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_ENTRY_TEMPLATES_BY_COMPANY_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_ENTRY_TEMPLATES_BY_COMPANY_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_PRESENCES_BY_COMPANY_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_PRESENCES_BY_COMPANY_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATES_BY_COMPANY_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATES_BY_COMPANY_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TYPES_BY_COMPANY_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TYPES_BY_COMPANY_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_PROJECTS_BY_COMPANY_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_PROJECTS_BY_COMPANY_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_TEMPLATES_BY_COMPANY_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_TEMPLATES_BY_COMPANY_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEKS_BY_COMPANY_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEKS_BY_COMPANY_ID__COUNT_DESC'
  | 'TRANSLATED_ENTITIES_BY_COMPANY_ID__COUNT_ASC'
  | 'TRANSLATED_ENTITIES_BY_COMPANY_ID__COUNT_DESC'
  | 'TRANSLATED_ENTITY_LOCALIZATIONS_BY_COMPANY_ID__COUNT_ASC'
  | 'TRANSLATED_ENTITY_LOCALIZATIONS_BY_COMPANY_ID__COUNT_DESC'
  | 'TRANSLATIONS_BY_COMPANY_ID__COUNT_ASC'
  | 'TRANSLATIONS_BY_COMPANY_ID__COUNT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'URL_ASC'
  | 'URL_DESC'
  | 'USERS_BY_COMPANY_ID__COUNT_ASC'
  | 'USERS_BY_COMPANY_ID__COUNT_DESC'
  | 'USER_COMPANY_GROUPS_BY_COMPANY_ID__COUNT_ASC'
  | 'USER_COMPANY_GROUPS_BY_COMPANY_ID__COUNT_DESC'
  | 'USER_COMPANY_ROLES_BY_COMPANY_ID__COUNT_ASC'
  | 'USER_COMPANY_ROLES_BY_COMPANY_ID__COUNT_DESC'
  | 'USER_COMPETENCES_BY_COMPANY_ID__COUNT_ASC'
  | 'USER_COMPETENCES_BY_COMPANY_ID__COUNT_DESC'
  | 'USER_COMPETENCE_EVALUATIONS_BY_COMPANY_ID__COUNT_ASC'
  | 'USER_COMPETENCE_EVALUATIONS_BY_COMPANY_ID__COUNT_DESC'
  | 'USER_COMPETENCE_EVALUATION_COMMENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'USER_COMPETENCE_EVALUATION_COMMENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'USER_DEPARTMENTS_BY_COMPANY_ID__COUNT_ASC'
  | 'USER_DEPARTMENTS_BY_COMPANY_ID__COUNT_DESC'
  | 'USER_DEPARTMENT_GROUPS_BY_COMPANY_ID__COUNT_ASC'
  | 'USER_DEPARTMENT_GROUPS_BY_COMPANY_ID__COUNT_DESC'
  | 'USER_DEPARTMENT_ROLES_BY_COMPANY_ID__COUNT_ASC'
  | 'USER_DEPARTMENT_ROLES_BY_COMPANY_ID__COUNT_DESC'
  | 'USER_GROUPS_BY_COMPANY_ID__COUNT_ASC'
  | 'USER_GROUPS_BY_COMPANY_ID__COUNT_DESC'
  | 'USER_ON_BEHALF_PERMISSIONS_BY_COMPANY_ID__COUNT_ASC'
  | 'USER_ON_BEHALF_PERMISSIONS_BY_COMPANY_ID__COUNT_DESC'
  | 'USER_ROLES_BY_COMPANY_ID__COUNT_ASC'
  | 'USER_ROLES_BY_COMPANY_ID__COUNT_DESC'
  | 'USER_SYSTEM_FIELDS_BY_COMPANY_ID__COUNT_ASC'
  | 'USER_SYSTEM_FIELDS_BY_COMPANY_ID__COUNT_DESC'
  | 'VACATION_TYPES_BY_COMPANY_ID__COUNT_ASC'
  | 'VACATION_TYPES_BY_COMPANY_ID__COUNT_DESC'
  | 'VACATION_USERS_BY_COMPANY_ID__COUNT_ASC'
  | 'VACATION_USERS_BY_COMPANY_ID__COUNT_DESC';

export type Company = {
  __typename?: 'Company';
  active: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `Announcement`. */
  announcements: AnnouncementsConnection;
  /** Reads and enables pagination through a set of `Approval`. */
  approvals: ApprovalsConnection;
  /** Reads and enables pagination through a set of `AsyncJobItem`. */
  asyncJobItems: AsyncJobItemsConnection;
  /** Reads and enables pagination through a set of `AsyncJob`. */
  asyncJobs: AsyncJobsConnection;
  availableLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Reads and enables pagination through a set of `Company`. */
  companiesByMasterForCompanyId: CompaniesConnection;
  /** Reads and enables pagination through a set of `CompanyBinding`. */
  companyBindings: CompanyBindingsConnection;
  /** Reads a single `CompanyCompanyType` that is related to this `Company`. */
  companyCompanyTypeByCompanyId?: Maybe<CompanyCompanyType>;
  /**
   * Reads and enables pagination through a set of `CompanyCompanyType`.
   * @deprecated Please use companyCompanyTypeByCompanyId instead
   */
  companyCompanyTypes: CompanyCompanyTypesConnection;
  /** Reads and enables pagination through a set of `CompanySetting`. */
  companySettings: CompanySettingsConnection;
  /** Reads and enables pagination through a set of `CompanySystemFieldOption`. */
  companySystemFieldOptions: CompanySystemFieldOptionsConnection;
  /** Reads and enables pagination through a set of `CompanySystemField`. */
  companySystemFields: CompanySystemFieldsConnection;
  /** Reads and enables pagination through a set of `CompetenceFormField`. */
  competenceFormFields: CompetenceFormFieldsConnection;
  /** Reads and enables pagination through a set of `CompetenceGroup`. */
  competenceGroups: CompetenceGroupsConnection;
  /** Reads and enables pagination through a set of `CompetenceRequest`. */
  competenceRequests: CompetenceRequestsConnection;
  /** Reads and enables pagination through a set of `Competence`. */
  competences: CompetencesConnection;
  /** Reads and enables pagination through a set of `ContractSignPendingDocument`. */
  contractSignPendingDocuments: ContractSignPendingDocumentsConnection;
  /** Reads and enables pagination through a set of `ContractSignPendingSigner`. */
  contractSignPendingSigners: ContractSignPendingSignersConnection;
  /** Reads and enables pagination through a set of `ContractSignPending`. */
  contractSignPendings: ContractSignPendingsConnection;
  /** Reads and enables pagination through a set of `ContractTemplateDepartment`. */
  contractTemplateDepartments: ContractTemplateDepartmentsConnection;
  /** Reads and enables pagination through a set of `ContractTemplateUser`. */
  contractTemplateUsers: ContractTemplateUsersConnection;
  copyInProgress: Scalars['Boolean'];
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `CustomWidgetContent`. */
  customWidgetContents: CustomWidgetContentsConnection;
  /** Reads and enables pagination through a set of `CustomWidget`. */
  customWidgets: CustomWidgetsConnection;
  /** Reads and enables pagination through a set of `CvTemplateFieldMapping`. */
  cvTemplateFieldMappings: CvTemplateFieldMappingsConnection;
  cvr?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `DashboardCardStatistic`. */
  dashboardCardStatistics: DashboardCardStatisticsConnection;
  /** Reads and enables pagination through a set of `DashboardCard`. */
  dashboardCards: DashboardCardsConnection;
  /** Reads a single `DashboardConfig` that is related to this `Company`. */
  dashboardConfigByCompanyId?: Maybe<DashboardConfig>;
  /**
   * Reads and enables pagination through a set of `DashboardConfig`.
   * @deprecated Please use dashboardConfigByCompanyId instead
   */
  dashboardConfigs: DashboardConfigsConnection;
  /** Reads and enables pagination through a set of `DashboardView`. */
  dashboardViews: DashboardViewsConnection;
  deleteAt?: Maybe<Scalars['Date']>;
  /** Reads and enables pagination through a set of `DepartmentType`. */
  departmentTypes: DepartmentTypesConnection;
  /** Reads and enables pagination through a set of `Department`. */
  departments: DepartmentsConnection;
  description?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `DocumentDepartmentPermission`. */
  documentDepartmentPermissions: DocumentDepartmentPermissionsConnection;
  /** Reads and enables pagination through a set of `DocumentFolderBlueprint`. */
  documentFolderBlueprints: DocumentFolderBlueprintsConnection;
  /** Reads and enables pagination through a set of `DocumentFolderDepartment`. */
  documentFolderDepartments: DocumentFolderDepartmentsConnection;
  /** Reads and enables pagination through a set of `DocumentFolderUser`. */
  documentFolderUsers: DocumentFolderUsersConnection;
  /** Reads and enables pagination through a set of `DocumentFolder`. */
  documentFolders: DocumentFoldersConnection;
  /** Reads and enables pagination through a set of `DocumentUserPermission`. */
  documentUserPermissions: DocumentUserPermissionsConnection;
  /** Reads and enables pagination through a set of `DocumentUserResponsible`. */
  documentUserResponsibles: DocumentUserResponsiblesConnection;
  /** Reads and enables pagination through a set of `EmployeeCasefile`. */
  employeeCasefiles: EmployeeCasefilesConnection;
  /** Reads and enables pagination through a set of `EmployeeExternalIntegration`. */
  employeeExternalIntegrations: EmployeeExternalIntegrationsConnection;
  /** Reads and enables pagination through a set of `Employee`. */
  employees: EmployeesConnection;
  /** Reads and enables pagination through a set of `EngagementType`. */
  engagementTypes: EngagementTypesConnection;
  /** Reads and enables pagination through a set of `Equipment`. */
  equipments: EquipmentConnection;
  /** Reads and enables pagination through a set of `EventUser`. */
  eventUsers: EventUsersConnection;
  /** Reads and enables pagination through a set of `Event`. */
  events: EventsConnection;
  /** Reads and enables pagination through a set of `ExternalIntegration`. */
  externalIntegrations: ExternalIntegrationsConnection;
  /** Reads and enables pagination through a set of `FieldGroupCardColumn`. */
  fieldGroupCardColumns: FieldGroupCardColumnsConnection;
  /** Reads and enables pagination through a set of `FieldGroupCard`. */
  fieldGroupCards: FieldGroupCardsConnection;
  /** Reads and enables pagination through a set of `FieldGroup`. */
  fieldGroups: FieldGroupsConnection;
  /** Reads and enables pagination through a set of `FilterPreset`. */
  filterPresets: FilterPresetsConnection;
  /** Reads and enables pagination through a set of `FormFieldAgreement`. */
  formFieldAgreements: FormFieldAgreementsConnection;
  /** Reads and enables pagination through a set of `FormFieldEntry`. */
  formFieldEntries: FormFieldEntriesConnection;
  /** Reads and enables pagination through a set of `FormFieldOption`. */
  formFieldOptions: FormFieldOptionsConnection;
  /** Reads and enables pagination through a set of `FroalaStyle`. */
  froalaStyles: FroalaStylesConnection;
  /** Reads and enables pagination through a set of `FutureDatum`. */
  futureData: FutureDataConnection;
  /** Reads and enables pagination through a set of `GroupRole`. */
  groupRoles: GroupRolesConnection;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `IntegrationFieldMarking`. */
  integrationFieldMarkings: IntegrationFieldMarkingsConnection;
  lastLogin?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `LatestMessage`. */
  latestMessages: LatestMessagesConnection;
  locale?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `LoggedActionNote`. */
  loggedActionNotes: LoggedActionNotesConnection;
  /** Reads and enables pagination through a set of `LoginLog`. */
  loginLogs: LoginLogsConnection;
  logo?: Maybe<Scalars['String']>;
  mainDepartment?: Maybe<Department>;
  /** Reads a single `Company` that is related to this `Company`. */
  masterForCompany?: Maybe<Company>;
  masterForCompanyId?: Maybe<Scalars['UUID']>;
  masterTemplate: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `Message`. */
  messages: MessagesConnection;
  minimumEmployeeNumber: Scalars['Int'];
  mode: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  nativeAppAccess?: Maybe<Scalars['Boolean']>;
  /** Reads and enables pagination through a set of `NotificationCustomEmployeeFieldRecipient`. */
  notificationCustomEmployeeFieldRecipients: NotificationCustomEmployeeFieldRecipientsConnection;
  /** Reads and enables pagination through a set of `NotificationCustomRecipient`. */
  notificationCustomRecipients: NotificationCustomRecipientsConnection;
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferences: NotificationEmployeeReferencesConnection;
  /** Reads and enables pagination through a set of `NotificationEmployee`. */
  notificationEmployees: NotificationEmployeesConnection;
  /** Reads and enables pagination through a set of `NotificationGroupRecipient`. */
  notificationGroupRecipients: NotificationGroupRecipientsConnection;
  /** Reads and enables pagination through a set of `NotificationTypeChannelType`. */
  notificationTypeChannelTypes: NotificationTypeChannelTypesConnection;
  numberOfCurrentlyEmployedEmployees?: Maybe<Scalars['BigInt']>;
  /** Reads and enables pagination through a set of `PostType`. */
  postTypes: PostTypesConnection;
  /** Reads and enables pagination through a set of `Post`. */
  posts: PostsConnection;
  /** Reads and enables pagination through a set of `PreboardingComment`. */
  preboardingComments: PreboardingCommentsConnection;
  /** Reads and enables pagination through a set of `PreboardingEmailLog`. */
  preboardingEmailLogs: PreboardingEmailLogsConnection;
  /** Reads and enables pagination through a set of `PreboardingEmployee`. */
  preboardingEmployees: PreboardingEmployeesConnection;
  /** Reads and enables pagination through a set of `PreboardingProcess`. */
  preboardingProcesses: PreboardingProcessesConnection;
  /** Reads and enables pagination through a set of `PreboardingResultSlideComment`. */
  preboardingResultSlideComments: PreboardingResultSlideCommentsConnection;
  /** Reads and enables pagination through a set of `PreboardingResult`. */
  preboardingResults: PreboardingResultsConnection;
  /** Reads and enables pagination through a set of `PreboardingSlideFormField`. */
  preboardingSlideFormFields: PreboardingSlideFormFieldsConnection;
  /** Reads and enables pagination through a set of `PreboardingSlide`. */
  preboardingSlides: PreboardingSlidesConnection;
  /** Reads and enables pagination through a set of `Preboarding`. */
  preboardings: PreboardingsConnection;
  /** Reads and enables pagination through a set of `ProcessDepartment`. */
  processDepartments: ProcessDepartmentsConnection;
  /** Reads and enables pagination through a set of `ProcessResponsible`. */
  processResponsibles: ProcessResponsiblesConnection;
  /** Reads and enables pagination through a set of `ProcessType`. */
  processTypes: ProcessTypesConnection;
  /** Reads and enables pagination through a set of `ProjectTemplate`. */
  projectTemplates: ProjectTemplatesConnection;
  /** Reads and enables pagination through a set of `Project`. */
  projects: ProjectsConnection;
  /** Reads and enables pagination through a set of `PulseSurveyAnswer`. */
  pulseSurveyAnswers: PulseSurveyAnswersConnection;
  /** Reads and enables pagination through a set of `PulseSurveyChoice`. */
  pulseSurveyChoices: PulseSurveyChoicesConnection;
  /** Reads and enables pagination through a set of `PulseSurvey`. */
  pulseSurveys: PulseSurveysConnection;
  /** Reads and enables pagination through a set of `PulseType`. */
  pulseTypes: PulseTypesConnection;
  /** Reads and enables pagination through a set of `RecurrenceRule`. */
  recurrenceRules: RecurrenceRulesConnection;
  /** Reads and enables pagination through a set of `ReferenceToken`. */
  referenceTokens: ReferenceTokensConnection;
  /** Reads and enables pagination through a set of `RelationRole`. */
  relationRoles: RelationRolesConnection;
  /** Reads and enables pagination through a set of `ScheduledMessageExternalRecipient`. */
  scheduledMessageExternalRecipients: ScheduledMessageExternalRecipientsConnection;
  /** Reads and enables pagination through a set of `ScheduledMessageRecipient`. */
  scheduledMessageRecipients: ScheduledMessageRecipientsConnection;
  /** Reads and enables pagination through a set of `ScheduledMessageTemplateExternalRecipient`. */
  scheduledMessageTemplateExternalRecipients: ScheduledMessageTemplateExternalRecipientsConnection;
  /** Reads and enables pagination through a set of `ScheduledMessageTemplateRecipient`. */
  scheduledMessageTemplateRecipients: ScheduledMessageTemplateRecipientsConnection;
  /** Reads and enables pagination through a set of `ScheduledMessageTemplate`. */
  scheduledMessageTemplates: ScheduledMessageTemplatesConnection;
  /** Reads and enables pagination through a set of `ScheduledMessage`. */
  scheduledMessages: ScheduledMessagesConnection;
  sso?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `SuperUserAllowedUser`. */
  superUserAllowedUsers: SuperUserAllowedUsersConnection;
  superadminUserList: CompanySuperadminUserListConnection;
  /** Reads and enables pagination through a set of `TaskEmployee`. */
  taskEmployees: TaskEmployeesConnection;
  /** Reads and enables pagination through a set of `TaskResponsible`. */
  taskResponsibles: TaskResponsiblesConnection;
  /** Reads and enables pagination through a set of `TaskTemplateEmployee`. */
  taskTemplateEmployees: TaskTemplateEmployeesConnection;
  /** Reads and enables pagination through a set of `TaskTemplateResponsible`. */
  taskTemplateResponsibles: TaskTemplateResponsiblesConnection;
  /** Reads and enables pagination through a set of `TaskTemplate`. */
  taskTemplates: TaskTemplatesConnection;
  /** Reads and enables pagination through a set of `Task`. */
  tasks: TasksConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationBreakType`. */
  timeRegistrationBreakTypes: TimeRegistrationBreakTypesConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationEntry`. */
  timeRegistrationEntries: TimeRegistrationEntriesConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationEntryTemplate`. */
  timeRegistrationEntryTemplates: TimeRegistrationEntryTemplatesConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationPresenceTemplate`. */
  timeRegistrationPresenceTemplates: TimeRegistrationPresenceTemplatesConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationPresenceType`. */
  timeRegistrationPresenceTypes: TimeRegistrationPresenceTypesConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationPresence`. */
  timeRegistrationPresences: TimeRegistrationPresencesConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationProject`. */
  timeRegistrationProjects: TimeRegistrationProjectsConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationTemplateWeek`. */
  timeRegistrationTemplateWeeks: TimeRegistrationTemplateWeeksConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationTemplate`. */
  timeRegistrationTemplates: TimeRegistrationTemplatesConnection;
  /** Reads and enables pagination through a set of `TranslatedEntity`. */
  translatedEntities: TranslatedEntitiesConnection;
  /** Reads and enables pagination through a set of `TranslatedEntityLocalization`. */
  translatedEntityLocalizations: TranslatedEntityLocalizationsConnection;
  /** Reads and enables pagination through a set of `Translation`. */
  translations: TranslationsConnection;
  updatedAt: Scalars['Datetime'];
  url?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `UserCompanyGroup`. */
  userCompanyGroups: UserCompanyGroupsConnection;
  /** Reads and enables pagination through a set of `UserCompanyRole`. */
  userCompanyRoles: UserCompanyRolesConnection;
  /** Reads and enables pagination through a set of `UserCompetenceEvaluationComment`. */
  userCompetenceEvaluationComments: UserCompetenceEvaluationCommentsConnection;
  /** Reads and enables pagination through a set of `UserCompetenceEvaluation`. */
  userCompetenceEvaluations: UserCompetenceEvaluationsConnection;
  /** Reads and enables pagination through a set of `UserCompetence`. */
  userCompetences: UserCompetencesConnection;
  /** Reads and enables pagination through a set of `UserDepartmentGroup`. */
  userDepartmentGroups: UserDepartmentGroupsConnection;
  /** Reads and enables pagination through a set of `UserDepartmentRole`. */
  userDepartmentRoles: UserDepartmentRolesConnection;
  /** Reads and enables pagination through a set of `UserDepartment`. */
  userDepartments: UserDepartmentsConnection;
  /** Reads and enables pagination through a set of `UserGroup`. */
  userGroups: UserGroupsConnection;
  /** Reads and enables pagination through a set of `UserOnBehalfPermission`. */
  userOnBehalfPermissions: UserOnBehalfPermissionsConnection;
  /** Reads and enables pagination through a set of `UserRole`. */
  userRoles: UserRolesConnection;
  /** Reads and enables pagination through a set of `UserSystemField`. */
  userSystemFields: UserSystemFieldsConnection;
  /** Reads and enables pagination through a set of `User`. */
  users: UsersConnection;
  /** Reads and enables pagination through a set of `VacationType`. */
  vacationTypes: VacationTypesConnection;
  /** Reads and enables pagination through a set of `VacationUser`. */
  vacationUsers: VacationUsersConnection;
};


export type CompanyAnnouncementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AnnouncementCondition>;
  filter?: InputMaybe<AnnouncementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AnnouncementsOrderBy>>;
};


export type CompanyApprovalsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ApprovalCondition>;
  filter?: InputMaybe<ApprovalFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ApprovalsOrderBy>>;
};


export type CompanyAsyncJobItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AsyncJobItemCondition>;
  filter?: InputMaybe<AsyncJobItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AsyncJobItemsOrderBy>>;
};


export type CompanyAsyncJobsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AsyncJobCondition>;
  filter?: InputMaybe<AsyncJobFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AsyncJobsOrderBy>>;
};


export type CompanyCompaniesByMasterForCompanyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyCondition>;
  filter?: InputMaybe<CompanyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompaniesOrderBy>>;
};


export type CompanyCompanyBindingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyBindingCondition>;
  filter?: InputMaybe<CompanyBindingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyBindingsOrderBy>>;
};


export type CompanyCompanyCompanyTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyCompanyTypeCondition>;
  filter?: InputMaybe<CompanyCompanyTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyCompanyTypesOrderBy>>;
};


export type CompanyCompanySettingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanySettingCondition>;
  filter?: InputMaybe<CompanySettingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanySettingsOrderBy>>;
};


export type CompanyCompanySystemFieldOptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanySystemFieldOptionCondition>;
  filter?: InputMaybe<CompanySystemFieldOptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanySystemFieldOptionsOrderBy>>;
};


export type CompanyCompanySystemFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanySystemFieldCondition>;
  filter?: InputMaybe<CompanySystemFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanySystemFieldsOrderBy>>;
};


export type CompanyCompetenceFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompetenceFormFieldCondition>;
  filter?: InputMaybe<CompetenceFormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetenceFormFieldsOrderBy>>;
};


export type CompanyCompetenceGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompetenceGroupCondition>;
  filter?: InputMaybe<CompetenceGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetenceGroupsOrderBy>>;
};


export type CompanyCompetenceRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompetenceRequestCondition>;
  filter?: InputMaybe<CompetenceRequestFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetenceRequestsOrderBy>>;
};


export type CompanyCompetencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompetenceCondition>;
  filter?: InputMaybe<CompetenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetencesOrderBy>>;
};


export type CompanyContractSignPendingDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingDocumentCondition>;
  filter?: InputMaybe<ContractSignPendingDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingDocumentsOrderBy>>;
};


export type CompanyContractSignPendingSignersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingSignerCondition>;
  filter?: InputMaybe<ContractSignPendingSignerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingSignersOrderBy>>;
};


export type CompanyContractSignPendingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingCondition>;
  filter?: InputMaybe<ContractSignPendingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingsOrderBy>>;
};


export type CompanyContractTemplateDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractTemplateDepartmentCondition>;
  filter?: InputMaybe<ContractTemplateDepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractTemplateDepartmentsOrderBy>>;
};


export type CompanyContractTemplateUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractTemplateUserCondition>;
  filter?: InputMaybe<ContractTemplateUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractTemplateUsersOrderBy>>;
};


export type CompanyCustomWidgetContentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CustomWidgetContentCondition>;
  filter?: InputMaybe<CustomWidgetContentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomWidgetContentsOrderBy>>;
};


export type CompanyCustomWidgetsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CustomWidgetCondition>;
  filter?: InputMaybe<CustomWidgetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomWidgetsOrderBy>>;
};


export type CompanyCvTemplateFieldMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CvTemplateFieldMappingCondition>;
  filter?: InputMaybe<CvTemplateFieldMappingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CvTemplateFieldMappingsOrderBy>>;
};


export type CompanyDashboardCardStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DashboardCardStatisticCondition>;
  filter?: InputMaybe<DashboardCardStatisticFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DashboardCardStatisticsOrderBy>>;
};


export type CompanyDashboardCardsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DashboardCardCondition>;
  filter?: InputMaybe<DashboardCardFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DashboardCardsOrderBy>>;
};


export type CompanyDashboardConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DashboardConfigCondition>;
  filter?: InputMaybe<DashboardConfigFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DashboardConfigsOrderBy>>;
};


export type CompanyDashboardViewsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DashboardViewCondition>;
  filter?: InputMaybe<DashboardViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DashboardViewsOrderBy>>;
};


export type CompanyDepartmentTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DepartmentTypeCondition>;
  filter?: InputMaybe<DepartmentTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DepartmentTypesOrderBy>>;
};


export type CompanyDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DepartmentCondition>;
  filter?: InputMaybe<DepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DepartmentsOrderBy>>;
};


export type CompanyDocumentDepartmentPermissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentDepartmentPermissionCondition>;
  filter?: InputMaybe<DocumentDepartmentPermissionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentDepartmentPermissionsOrderBy>>;
};


export type CompanyDocumentFolderBlueprintsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentFolderBlueprintCondition>;
  filter?: InputMaybe<DocumentFolderBlueprintFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentFolderBlueprintsOrderBy>>;
};


export type CompanyDocumentFolderDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentFolderDepartmentCondition>;
  filter?: InputMaybe<DocumentFolderDepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentFolderDepartmentsOrderBy>>;
};


export type CompanyDocumentFolderUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentFolderUserCondition>;
  filter?: InputMaybe<DocumentFolderUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentFolderUsersOrderBy>>;
};


export type CompanyDocumentFoldersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentFolderCondition>;
  filter?: InputMaybe<DocumentFolderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentFoldersOrderBy>>;
};


export type CompanyDocumentUserPermissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentUserPermissionCondition>;
  filter?: InputMaybe<DocumentUserPermissionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentUserPermissionsOrderBy>>;
};


export type CompanyDocumentUserResponsiblesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentUserResponsibleCondition>;
  filter?: InputMaybe<DocumentUserResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentUserResponsiblesOrderBy>>;
};


export type CompanyEmployeeCasefilesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmployeeCasefileCondition>;
  filter?: InputMaybe<EmployeeCasefileFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmployeeCasefilesOrderBy>>;
};


export type CompanyEmployeeExternalIntegrationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmployeeExternalIntegrationCondition>;
  filter?: InputMaybe<EmployeeExternalIntegrationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmployeeExternalIntegrationsOrderBy>>;
};


export type CompanyEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmployeeCondition>;
  filter?: InputMaybe<EmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  includeArchived?: InputMaybe<IncludeArchivedOption>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmployeesOrderBy>>;
};


export type CompanyEngagementTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EngagementTypeCondition>;
  filter?: InputMaybe<EngagementTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementTypesOrderBy>>;
};


export type CompanyEquipmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EquipmentCondition>;
  filter?: InputMaybe<EquipmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentOrderBy>>;
};


export type CompanyEventUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventUserCondition>;
  filter?: InputMaybe<EventUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventUsersOrderBy>>;
};


export type CompanyEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type CompanyExternalIntegrationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalIntegrationCondition>;
  filter?: InputMaybe<ExternalIntegrationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalIntegrationsOrderBy>>;
};


export type CompanyFieldGroupCardColumnsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FieldGroupCardColumnCondition>;
  filter?: InputMaybe<FieldGroupCardColumnFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FieldGroupCardColumnsOrderBy>>;
};


export type CompanyFieldGroupCardsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FieldGroupCardCondition>;
  filter?: InputMaybe<FieldGroupCardFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FieldGroupCardsOrderBy>>;
};


export type CompanyFieldGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FieldGroupCondition>;
  filter?: InputMaybe<FieldGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FieldGroupsOrderBy>>;
};


export type CompanyFilterPresetsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FilterPresetCondition>;
  filter?: InputMaybe<FilterPresetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FilterPresetsOrderBy>>;
};


export type CompanyFormFieldAgreementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldAgreementCondition>;
  filter?: InputMaybe<FormFieldAgreementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldAgreementsOrderBy>>;
};


export type CompanyFormFieldEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldEntryCondition>;
  filter?: InputMaybe<FormFieldEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldEntriesOrderBy>>;
};


export type CompanyFormFieldOptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldOptionCondition>;
  filter?: InputMaybe<FormFieldOptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldOptionsOrderBy>>;
};


export type CompanyFroalaStylesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FroalaStyleCondition>;
  filter?: InputMaybe<FroalaStyleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FroalaStylesOrderBy>>;
};


export type CompanyFutureDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FutureDatumCondition>;
  filter?: InputMaybe<FutureDatumFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FutureDataOrderBy>>;
};


export type CompanyGroupRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupRoleCondition>;
  filter?: InputMaybe<GroupRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupRolesOrderBy>>;
};


export type CompanyIntegrationFieldMarkingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<IntegrationFieldMarkingCondition>;
  filter?: InputMaybe<IntegrationFieldMarkingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegrationFieldMarkingsOrderBy>>;
};


export type CompanyLatestMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LatestMessageCondition>;
  filter?: InputMaybe<LatestMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LatestMessagesOrderBy>>;
};


export type CompanyLoggedActionNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LoggedActionNoteCondition>;
  filter?: InputMaybe<LoggedActionNoteFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LoggedActionNotesOrderBy>>;
};


export type CompanyLoginLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LoginLogCondition>;
  filter?: InputMaybe<LoginLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LoginLogsOrderBy>>;
};


export type CompanyMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MessageCondition>;
  filter?: InputMaybe<MessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};


export type CompanyNotificationCustomEmployeeFieldRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationCustomEmployeeFieldRecipientCondition>;
  filter?: InputMaybe<NotificationCustomEmployeeFieldRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientsOrderBy>>;
};


export type CompanyNotificationCustomRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationCustomRecipientCondition>;
  filter?: InputMaybe<NotificationCustomRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationCustomRecipientsOrderBy>>;
};


export type CompanyNotificationEmployeeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};


export type CompanyNotificationEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeCondition>;
  filter?: InputMaybe<NotificationEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeesOrderBy>>;
};


export type CompanyNotificationGroupRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationGroupRecipientCondition>;
  filter?: InputMaybe<NotificationGroupRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationGroupRecipientsOrderBy>>;
};


export type CompanyNotificationTypeChannelTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationTypeChannelTypeCondition>;
  filter?: InputMaybe<NotificationTypeChannelTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationTypeChannelTypesOrderBy>>;
};


export type CompanyPostTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PostTypeCondition>;
  filter?: InputMaybe<PostTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PostTypesOrderBy>>;
};


export type CompanyPostsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PostCondition>;
  filter?: InputMaybe<PostFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PostsOrderBy>>;
};


export type CompanyPreboardingCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingCommentCondition>;
  filter?: InputMaybe<PreboardingCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingCommentsOrderBy>>;
};


export type CompanyPreboardingEmailLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingEmailLogCondition>;
  filter?: InputMaybe<PreboardingEmailLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingEmailLogsOrderBy>>;
};


export type CompanyPreboardingEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingEmployeeCondition>;
  filter?: InputMaybe<PreboardingEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingEmployeesOrderBy>>;
};


export type CompanyPreboardingProcessesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingProcessCondition>;
  filter?: InputMaybe<PreboardingProcessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingProcessesOrderBy>>;
};


export type CompanyPreboardingResultSlideCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingResultSlideCommentCondition>;
  filter?: InputMaybe<PreboardingResultSlideCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingResultSlideCommentsOrderBy>>;
};


export type CompanyPreboardingResultsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingResultCondition>;
  filter?: InputMaybe<PreboardingResultFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingResultsOrderBy>>;
};


export type CompanyPreboardingSlideFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingSlideFormFieldCondition>;
  filter?: InputMaybe<PreboardingSlideFormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingSlideFormFieldsOrderBy>>;
};


export type CompanyPreboardingSlidesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingSlideCondition>;
  filter?: InputMaybe<PreboardingSlideFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingSlidesOrderBy>>;
};


export type CompanyPreboardingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingCondition>;
  filter?: InputMaybe<PreboardingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingsOrderBy>>;
};


export type CompanyProcessDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcessDepartmentCondition>;
  filter?: InputMaybe<ProcessDepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcessDepartmentsOrderBy>>;
};


export type CompanyProcessResponsiblesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcessResponsibleCondition>;
  filter?: InputMaybe<ProcessResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcessResponsiblesOrderBy>>;
};


export type CompanyProcessTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcessTypeCondition>;
  filter?: InputMaybe<ProcessTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcessTypesOrderBy>>;
};


export type CompanyProjectTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectTemplateCondition>;
  filter?: InputMaybe<ProjectTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplatesOrderBy>>;
};


export type CompanyProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};


export type CompanyPulseSurveyAnswersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseSurveyAnswerCondition>;
  filter?: InputMaybe<PulseSurveyAnswerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseSurveyAnswersOrderBy>>;
};


export type CompanyPulseSurveyChoicesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseSurveyChoiceCondition>;
  filter?: InputMaybe<PulseSurveyChoiceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseSurveyChoicesOrderBy>>;
};


export type CompanyPulseSurveysArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseSurveyCondition>;
  filter?: InputMaybe<PulseSurveyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseSurveysOrderBy>>;
};


export type CompanyPulseTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseTypeCondition>;
  filter?: InputMaybe<PulseTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseTypesOrderBy>>;
};


export type CompanyRecurrenceRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RecurrenceRuleCondition>;
  filter?: InputMaybe<RecurrenceRuleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurrenceRulesOrderBy>>;
};


export type CompanyReferenceTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReferenceTokenCondition>;
  filter?: InputMaybe<ReferenceTokenFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReferenceTokensOrderBy>>;
};


export type CompanyRelationRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RelationRoleCondition>;
  filter?: InputMaybe<RelationRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RelationRolesOrderBy>>;
};


export type CompanyScheduledMessageExternalRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageExternalRecipientCondition>;
  filter?: InputMaybe<ScheduledMessageExternalRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageExternalRecipientsOrderBy>>;
};


export type CompanyScheduledMessageRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageRecipientCondition>;
  filter?: InputMaybe<ScheduledMessageRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageRecipientsOrderBy>>;
};


export type CompanyScheduledMessageTemplateExternalRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageTemplateExternalRecipientCondition>;
  filter?: InputMaybe<ScheduledMessageTemplateExternalRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageTemplateExternalRecipientsOrderBy>>;
};


export type CompanyScheduledMessageTemplateRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageTemplateRecipientCondition>;
  filter?: InputMaybe<ScheduledMessageTemplateRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageTemplateRecipientsOrderBy>>;
};


export type CompanyScheduledMessageTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageTemplateCondition>;
  filter?: InputMaybe<ScheduledMessageTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageTemplatesOrderBy>>;
};


export type CompanyScheduledMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageCondition>;
  filter?: InputMaybe<ScheduledMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessagesOrderBy>>;
};


export type CompanySuperUserAllowedUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SuperUserAllowedUserCondition>;
  filter?: InputMaybe<SuperUserAllowedUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuperUserAllowedUsersOrderBy>>;
};


export type CompanySuperadminUserListArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<CompanySuperadminUserListRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CompanyTaskEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskEmployeeCondition>;
  filter?: InputMaybe<TaskEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskEmployeesOrderBy>>;
};


export type CompanyTaskResponsiblesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskResponsibleCondition>;
  filter?: InputMaybe<TaskResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskResponsiblesOrderBy>>;
};


export type CompanyTaskTemplateEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskTemplateEmployeeCondition>;
  filter?: InputMaybe<TaskTemplateEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskTemplateEmployeesOrderBy>>;
};


export type CompanyTaskTemplateResponsiblesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskTemplateResponsibleCondition>;
  filter?: InputMaybe<TaskTemplateResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskTemplateResponsiblesOrderBy>>;
};


export type CompanyTaskTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskTemplateCondition>;
  filter?: InputMaybe<TaskTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskTemplatesOrderBy>>;
};


export type CompanyTasksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};


export type CompanyTimeRegistrationBreakTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationBreakTypeCondition>;
  filter?: InputMaybe<TimeRegistrationBreakTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationBreakTypesOrderBy>>;
};


export type CompanyTimeRegistrationEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationEntryCondition>;
  filter?: InputMaybe<TimeRegistrationEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationEntriesOrderBy>>;
};


export type CompanyTimeRegistrationEntryTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationEntryTemplateCondition>;
  filter?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationEntryTemplatesOrderBy>>;
};


export type CompanyTimeRegistrationPresenceTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationPresenceTemplateCondition>;
  filter?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationPresenceTemplatesOrderBy>>;
};


export type CompanyTimeRegistrationPresenceTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationPresenceTypeCondition>;
  filter?: InputMaybe<TimeRegistrationPresenceTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationPresenceTypesOrderBy>>;
};


export type CompanyTimeRegistrationPresencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationPresenceCondition>;
  filter?: InputMaybe<TimeRegistrationPresenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationPresencesOrderBy>>;
};


export type CompanyTimeRegistrationProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationProjectCondition>;
  filter?: InputMaybe<TimeRegistrationProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationProjectsOrderBy>>;
};


export type CompanyTimeRegistrationTemplateWeeksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationTemplateWeekCondition>;
  filter?: InputMaybe<TimeRegistrationTemplateWeekFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationTemplateWeeksOrderBy>>;
};


export type CompanyTimeRegistrationTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationTemplateCondition>;
  filter?: InputMaybe<TimeRegistrationTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationTemplatesOrderBy>>;
};


export type CompanyTranslatedEntitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TranslatedEntityCondition>;
  filter?: InputMaybe<TranslatedEntityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TranslatedEntitiesOrderBy>>;
};


export type CompanyTranslatedEntityLocalizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TranslatedEntityLocalizationCondition>;
  filter?: InputMaybe<TranslatedEntityLocalizationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TranslatedEntityLocalizationsOrderBy>>;
};


export type CompanyTranslationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TranslationCondition>;
  filter?: InputMaybe<TranslationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TranslationsOrderBy>>;
};


export type CompanyUserCompanyGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompanyGroupCondition>;
  filter?: InputMaybe<UserCompanyGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompanyGroupsOrderBy>>;
};


export type CompanyUserCompanyRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompanyRoleCondition>;
  filter?: InputMaybe<UserCompanyRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompanyRolesOrderBy>>;
};


export type CompanyUserCompetenceEvaluationCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompetenceEvaluationCommentCondition>;
  filter?: InputMaybe<UserCompetenceEvaluationCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompetenceEvaluationCommentsOrderBy>>;
};


export type CompanyUserCompetenceEvaluationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompetenceEvaluationCondition>;
  filter?: InputMaybe<UserCompetenceEvaluationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompetenceEvaluationsOrderBy>>;
};


export type CompanyUserCompetencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompetenceCondition>;
  filter?: InputMaybe<UserCompetenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompetencesOrderBy>>;
};


export type CompanyUserDepartmentGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserDepartmentGroupCondition>;
  filter?: InputMaybe<UserDepartmentGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserDepartmentGroupsOrderBy>>;
};


export type CompanyUserDepartmentRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserDepartmentRoleCondition>;
  filter?: InputMaybe<UserDepartmentRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserDepartmentRolesOrderBy>>;
};


export type CompanyUserDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserDepartmentCondition>;
  filter?: InputMaybe<UserDepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserDepartmentsOrderBy>>;
};


export type CompanyUserGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserGroupCondition>;
  filter?: InputMaybe<UserGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserGroupsOrderBy>>;
};


export type CompanyUserOnBehalfPermissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserOnBehalfPermissionCondition>;
  filter?: InputMaybe<UserOnBehalfPermissionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserOnBehalfPermissionsOrderBy>>;
};


export type CompanyUserRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserRoleCondition>;
  filter?: InputMaybe<UserRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
};


export type CompanyUserSystemFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserSystemFieldCondition>;
  filter?: InputMaybe<UserSystemFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSystemFieldsOrderBy>>;
};


export type CompanyUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  includeArchived?: InputMaybe<IncludeArchivedOption>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type CompanyVacationTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VacationTypeCondition>;
  filter?: InputMaybe<VacationTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VacationTypesOrderBy>>;
};


export type CompanyVacationUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VacationUserCondition>;
  filter?: InputMaybe<VacationUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VacationUsersOrderBy>>;
};

export type CompanyBinding = {
  __typename?: 'CompanyBinding';
  /** Reads a single `Company` that is related to this `CompanyBinding`. */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['UUID']>;
  legacyCompanyId?: Maybe<Scalars['Int']>;
};

/** The fields on `companyBinding` to look up the row to connect. */
export type CompanyBindingCompanyBindingCompanyIdLegacyCompanyIdUniqueConnect = {
  companyId: Scalars['UUID'];
  legacyCompanyId: Scalars['Int'];
};

/** Input for the nested mutation of `company` in the `CompanyBindingInput` mutation. */
export type CompanyBindingCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnCompanyBindingForCompanyBindingCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `companyBinding` in the `CompanyInput` mutation. */
export type CompanyBindingCompanyIdForeignInverseInput = {
  /** The primary key(s) for `companyBinding` for the far side of the relationship. */
  connectByCompanyIdAndLegacyCompanyId?: InputMaybe<Array<CompanyBindingCompanyBindingCompanyIdLegacyCompanyIdUniqueConnect>>;
  /** The primary key(s) and patch data for `companyBinding` for the far side of the relationship. */
  updateByCompanyIdAndLegacyCompanyId?: InputMaybe<Array<CompanyBindingOnCompanyBindingForCompanyBindingCompanyIdForeignUsingCompanyBindingCompanyIdLegacyCompanyIdUniqueUpdate>>;
};

/**
 * A condition to be used against `CompanyBinding` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CompanyBindingCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `legacyCompanyId` field. */
  legacyCompanyId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `CompanyBinding` object types. All fields are combined with a logical ‘and.’ */
export type CompanyBindingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompanyBindingFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** A related `company` exists. */
  companyExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `legacyCompanyId` field. */
  legacyCompanyId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompanyBindingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompanyBindingFilter>>;
};

/** The fields on `companyBinding` to look up the row to update. */
export type CompanyBindingOnCompanyBindingForCompanyBindingCompanyIdForeignUsingCompanyBindingCompanyIdLegacyCompanyIdUniqueUpdate = {
  companyId: Scalars['UUID'];
  legacyCompanyId: Scalars['Int'];
  /** An object where the defined keys will be set on the `companyBinding` being updated. */
  patch: UpdateCompanyBindingOnCompanyBindingForCompanyBindingCompanyIdForeignPatch;
};

/** A connection to a list of `CompanyBinding` values. */
export type CompanyBindingsConnection = {
  __typename?: 'CompanyBindingsConnection';
  /** A list of edges which contains the `CompanyBinding` and cursor to aid in pagination. */
  edges: Array<CompanyBindingsEdge>;
  /** A list of `CompanyBinding` objects. */
  nodes: Array<Maybe<CompanyBinding>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CompanyBinding` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CompanyBinding` edge in the connection. */
export type CompanyBindingsEdge = {
  __typename?: 'CompanyBindingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompanyBinding` at the end of the edge. */
  node?: Maybe<CompanyBinding>;
};

/** Methods to use when ordering `CompanyBinding`. */
export type CompanyBindingsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'LEGACY_COMPANY_ID_ASC'
  | 'LEGACY_COMPANY_ID_DESC'
  | 'NATURAL';

/** The fields on `company` to look up the row to connect. */
export type CompanyCompanyPkeyConnect = {
  id: Scalars['UUID'];
};

export type CompanyCompanyType = {
  __typename?: 'CompanyCompanyType';
  /** Reads a single `Company` that is related to this `CompanyCompanyType`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `CompanyType` that is related to this `CompanyCompanyType`. */
  companyType?: Maybe<CompanyType>;
  companyTypeId: Scalars['UUID'];
};

/** The fields on `companyCompanyType` to look up the row to connect. */
export type CompanyCompanyTypeCompanyCompanyTypePkeyConnect = {
  companyId: Scalars['UUID'];
};

/** The fields on `companyCompanyType` to look up the row to delete. */
export type CompanyCompanyTypeCompanyCompanyTypePkeyDelete = {
  companyId: Scalars['UUID'];
};

/** The `companyCompanyType` to be created by this mutation. */
export type CompanyCompanyTypeCompanyIdForeignConnectionCompanyCompanyTypeCreateInput = {
  company?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInput>;
  companyType?: InputMaybe<CompanyCompanyTypeCompanyTypeIdForeignInput>;
  companyTypeId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `CompanyCompanyTypeInput` mutation. */
export type CompanyCompanyTypeCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnCompanyCompanyTypeForCompanyCompanyTypeCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `companyCompanyType` in the `CompanyInput` mutation. */
export type CompanyCompanyTypeCompanyIdForeignInverseInput = {
  /** The primary key(s) for `companyCompanyType` for the far side of the relationship. */
  connectByCompanyId?: InputMaybe<CompanyCompanyTypeCompanyCompanyTypePkeyConnect>;
  /** A `CompanyCompanyTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanyCompanyTypeCompanyIdForeignConnectionCompanyCompanyTypeCreateInput>>;
  /** The primary key(s) for `companyCompanyType` for the far side of the relationship. */
  deleteByCompanyId?: InputMaybe<CompanyCompanyTypeCompanyCompanyTypePkeyDelete>;
  /** Flag indicating whether all other `companyCompanyType` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companyCompanyType` for the far side of the relationship. */
  updateByCompanyId?: InputMaybe<CompanyCompanyTypeOnCompanyCompanyTypeForCompanyCompanyTypeCompanyIdForeignUsingCompanyCompanyTypePkeyUpdate>;
};

/** The `companyCompanyType` to be created by this mutation. */
export type CompanyCompanyTypeCompanyTypeIdForeignConnectionCompanyCompanyTypeCreateInput = {
  company?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companyType?: InputMaybe<CompanyCompanyTypeCompanyTypeIdForeignInput>;
};

/** The `companyType` to be created by this mutation. */
export type CompanyCompanyTypeCompanyTypeIdForeignConnectionCompanyTypeCreateInput = {
  companyCompanyTypes?: InputMaybe<CompanyCompanyTypeCompanyTypeIdForeignInverseInput>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
};

/** Input for the nested mutation of `companyType` in the `CompanyCompanyTypeInput` mutation. */
export type CompanyCompanyTypeCompanyTypeIdForeignInput = {
  /** The primary key(s) for `companyType` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyTypeCompanyTypePkeyConnect>;
  /** A `CompanyTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanyCompanyTypeCompanyTypeIdForeignConnectionCompanyTypeCreateInput>;
  /** The primary key(s) for `companyType` for the far side of the relationship. */
  deleteById?: InputMaybe<CompanyTypeCompanyTypePkeyDelete>;
  /** The primary key(s) and patch data for `companyType` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyTypeOnCompanyCompanyTypeForCompanyCompanyTypeCompanyTypeIdForeignUsingCompanyTypePkeyUpdate>;
};

/** Input for the nested mutation of `companyCompanyType` in the `CompanyTypeInput` mutation. */
export type CompanyCompanyTypeCompanyTypeIdForeignInverseInput = {
  /** The primary key(s) for `companyCompanyType` for the far side of the relationship. */
  connectByCompanyId?: InputMaybe<Array<CompanyCompanyTypeCompanyCompanyTypePkeyConnect>>;
  /** A `CompanyCompanyTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanyCompanyTypeCompanyTypeIdForeignConnectionCompanyCompanyTypeCreateInput>>;
  /** The primary key(s) for `companyCompanyType` for the far side of the relationship. */
  deleteByCompanyId?: InputMaybe<Array<CompanyCompanyTypeCompanyCompanyTypePkeyDelete>>;
  /** Flag indicating whether all other `companyCompanyType` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companyCompanyType` for the far side of the relationship. */
  updateByCompanyId?: InputMaybe<Array<CompanyCompanyTypeOnCompanyCompanyTypeForCompanyCompanyTypeCompanyTypeIdForeignUsingCompanyCompanyTypePkeyUpdate>>;
};

/**
 * A condition to be used against `CompanyCompanyType` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CompanyCompanyTypeCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `companyTypeId` field. */
  companyTypeId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `CompanyCompanyType` object types. All fields are combined with a logical ‘and.’ */
export type CompanyCompanyTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompanyCompanyTypeFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `companyType` relation. */
  companyType?: InputMaybe<CompanyTypeFilter>;
  /** Filter by the object’s `companyTypeId` field. */
  companyTypeId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompanyCompanyTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompanyCompanyTypeFilter>>;
};

/** An input for mutations affecting `CompanyCompanyType` */
export type CompanyCompanyTypeInput = {
  company?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companyType?: InputMaybe<CompanyCompanyTypeCompanyTypeIdForeignInput>;
  companyTypeId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `companyCompanyType` to look up the row to update. */
export type CompanyCompanyTypeOnCompanyCompanyTypeForCompanyCompanyTypeCompanyIdForeignUsingCompanyCompanyTypePkeyUpdate = {
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyCompanyType` being updated. */
  patch: UpdateCompanyCompanyTypeOnCompanyCompanyTypeForCompanyCompanyTypeCompanyIdForeignPatch;
};

/** The fields on `companyCompanyType` to look up the row to update. */
export type CompanyCompanyTypeOnCompanyCompanyTypeForCompanyCompanyTypeCompanyTypeIdForeignUsingCompanyCompanyTypePkeyUpdate = {
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyCompanyType` being updated. */
  patch: UpdateCompanyCompanyTypeOnCompanyCompanyTypeForCompanyCompanyTypeCompanyTypeIdForeignPatch;
};

/** Represents an update to a `CompanyCompanyType`. Fields that are set will be updated. */
export type CompanyCompanyTypePatch = {
  company?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companyType?: InputMaybe<CompanyCompanyTypeCompanyTypeIdForeignInput>;
  companyTypeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `CompanyCompanyType` values. */
export type CompanyCompanyTypesConnection = {
  __typename?: 'CompanyCompanyTypesConnection';
  /** A list of edges which contains the `CompanyCompanyType` and cursor to aid in pagination. */
  edges: Array<CompanyCompanyTypesEdge>;
  /** A list of `CompanyCompanyType` objects. */
  nodes: Array<Maybe<CompanyCompanyType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CompanyCompanyType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CompanyCompanyType` edge in the connection. */
export type CompanyCompanyTypesEdge = {
  __typename?: 'CompanyCompanyTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompanyCompanyType` at the end of the edge. */
  node?: Maybe<CompanyCompanyType>;
};

/** Methods to use when ordering `CompanyCompanyType`. */
export type CompanyCompanyTypesOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPANY_TYPE_BY_COMPANY_TYPE_ID__DISABLE_2FA_ASC'
  | 'COMPANY_TYPE_BY_COMPANY_TYPE_ID__DISABLE_2FA_DESC'
  | 'COMPANY_TYPE_BY_COMPANY_TYPE_ID__ID_ASC'
  | 'COMPANY_TYPE_BY_COMPANY_TYPE_ID__ID_DESC'
  | 'COMPANY_TYPE_BY_COMPANY_TYPE_ID__NAME_ASC'
  | 'COMPANY_TYPE_BY_COMPANY_TYPE_ID__NAME_DESC'
  | 'COMPANY_TYPE_ID_ASC'
  | 'COMPANY_TYPE_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/** A condition to be used against `Company` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type CompanyCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `availableLocales` field. */
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `copyInProgress` field. */
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `cvr` field. */
  cvr?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `deleteAt` field. */
  deleteAt?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `locale` field. */
  locale?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `masterForCompanyId` field. */
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `masterTemplate` field. */
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `minimumEmployeeNumber` field. */
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `mode` field. */
  mode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nativeAppAccess` field. */
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `sso` field. */
  sso?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `url` field. */
  url?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Company` object types. All fields are combined with a logical ‘and.’ */
export type CompanyFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompanyFilter>>;
  /** Filter by the object’s `announcements` relation. */
  announcements?: InputMaybe<CompanyToManyAnnouncementFilter>;
  /** Some related `announcements` exist. */
  announcementsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `approvals` relation. */
  approvals?: InputMaybe<CompanyToManyApprovalFilter>;
  /** Some related `approvals` exist. */
  approvalsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `asyncJobItems` relation. */
  asyncJobItems?: InputMaybe<CompanyToManyAsyncJobItemFilter>;
  /** Some related `asyncJobItems` exist. */
  asyncJobItemsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `asyncJobs` relation. */
  asyncJobs?: InputMaybe<CompanyToManyAsyncJobFilter>;
  /** Some related `asyncJobs` exist. */
  asyncJobsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `availableLocales` field. */
  availableLocales?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `companiesByMasterForCompanyId` relation. */
  companiesByMasterForCompanyId?: InputMaybe<CompanyToManyCompanyFilter>;
  /** Some related `companiesByMasterForCompanyId` exist. */
  companiesByMasterForCompanyIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companyBindings` relation. */
  companyBindings?: InputMaybe<CompanyToManyCompanyBindingFilter>;
  /** Some related `companyBindings` exist. */
  companyBindingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companyCompanyTypeByCompanyId` relation. */
  companyCompanyTypeByCompanyId?: InputMaybe<CompanyCompanyTypeFilter>;
  /** A related `companyCompanyTypeByCompanyId` exists. */
  companyCompanyTypeByCompanyIdExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companySettings` relation. */
  companySettings?: InputMaybe<CompanyToManyCompanySettingFilter>;
  /** Some related `companySettings` exist. */
  companySettingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companySystemFieldOptions` relation. */
  companySystemFieldOptions?: InputMaybe<CompanyToManyCompanySystemFieldOptionFilter>;
  /** Some related `companySystemFieldOptions` exist. */
  companySystemFieldOptionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companySystemFields` relation. */
  companySystemFields?: InputMaybe<CompanyToManyCompanySystemFieldFilter>;
  /** Some related `companySystemFields` exist. */
  companySystemFieldsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `competenceFormFields` relation. */
  competenceFormFields?: InputMaybe<CompanyToManyCompetenceFormFieldFilter>;
  /** Some related `competenceFormFields` exist. */
  competenceFormFieldsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `competenceGroups` relation. */
  competenceGroups?: InputMaybe<CompanyToManyCompetenceGroupFilter>;
  /** Some related `competenceGroups` exist. */
  competenceGroupsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `competenceRequests` relation. */
  competenceRequests?: InputMaybe<CompanyToManyCompetenceRequestFilter>;
  /** Some related `competenceRequests` exist. */
  competenceRequestsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `competences` relation. */
  competences?: InputMaybe<CompanyToManyCompetenceFilter>;
  /** Some related `competences` exist. */
  competencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractSignPendingDocuments` relation. */
  contractSignPendingDocuments?: InputMaybe<CompanyToManyContractSignPendingDocumentFilter>;
  /** Some related `contractSignPendingDocuments` exist. */
  contractSignPendingDocumentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractSignPendingSigners` relation. */
  contractSignPendingSigners?: InputMaybe<CompanyToManyContractSignPendingSignerFilter>;
  /** Some related `contractSignPendingSigners` exist. */
  contractSignPendingSignersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractSignPendings` relation. */
  contractSignPendings?: InputMaybe<CompanyToManyContractSignPendingFilter>;
  /** Some related `contractSignPendings` exist. */
  contractSignPendingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractTemplateDepartments` relation. */
  contractTemplateDepartments?: InputMaybe<CompanyToManyContractTemplateDepartmentFilter>;
  /** Some related `contractTemplateDepartments` exist. */
  contractTemplateDepartmentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractTemplateUsers` relation. */
  contractTemplateUsers?: InputMaybe<CompanyToManyContractTemplateUserFilter>;
  /** Some related `contractTemplateUsers` exist. */
  contractTemplateUsersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `copyInProgress` field. */
  copyInProgress?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `customWidgetContents` relation. */
  customWidgetContents?: InputMaybe<CompanyToManyCustomWidgetContentFilter>;
  /** Some related `customWidgetContents` exist. */
  customWidgetContentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `customWidgets` relation. */
  customWidgets?: InputMaybe<CompanyToManyCustomWidgetFilter>;
  /** Some related `customWidgets` exist. */
  customWidgetsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `cvTemplateFieldMappings` relation. */
  cvTemplateFieldMappings?: InputMaybe<CompanyToManyCvTemplateFieldMappingFilter>;
  /** Some related `cvTemplateFieldMappings` exist. */
  cvTemplateFieldMappingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `cvr` field. */
  cvr?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dashboardCardStatistics` relation. */
  dashboardCardStatistics?: InputMaybe<CompanyToManyDashboardCardStatisticFilter>;
  /** Some related `dashboardCardStatistics` exist. */
  dashboardCardStatisticsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `dashboardCards` relation. */
  dashboardCards?: InputMaybe<CompanyToManyDashboardCardFilter>;
  /** Some related `dashboardCards` exist. */
  dashboardCardsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `dashboardConfigByCompanyId` relation. */
  dashboardConfigByCompanyId?: InputMaybe<DashboardConfigFilter>;
  /** A related `dashboardConfigByCompanyId` exists. */
  dashboardConfigByCompanyIdExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `dashboardViews` relation. */
  dashboardViews?: InputMaybe<CompanyToManyDashboardViewFilter>;
  /** Some related `dashboardViews` exist. */
  dashboardViewsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `deleteAt` field. */
  deleteAt?: InputMaybe<DateFilter>;
  /** Filter by the object’s `departmentTypes` relation. */
  departmentTypes?: InputMaybe<CompanyToManyDepartmentTypeFilter>;
  /** Some related `departmentTypes` exist. */
  departmentTypesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `departments` relation. */
  departments?: InputMaybe<CompanyToManyDepartmentFilter>;
  /** Some related `departments` exist. */
  departmentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `documentDepartmentPermissions` relation. */
  documentDepartmentPermissions?: InputMaybe<CompanyToManyDocumentDepartmentPermissionFilter>;
  /** Some related `documentDepartmentPermissions` exist. */
  documentDepartmentPermissionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentFolderBlueprints` relation. */
  documentFolderBlueprints?: InputMaybe<CompanyToManyDocumentFolderBlueprintFilter>;
  /** Some related `documentFolderBlueprints` exist. */
  documentFolderBlueprintsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentFolderDepartments` relation. */
  documentFolderDepartments?: InputMaybe<CompanyToManyDocumentFolderDepartmentFilter>;
  /** Some related `documentFolderDepartments` exist. */
  documentFolderDepartmentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentFolderUsers` relation. */
  documentFolderUsers?: InputMaybe<CompanyToManyDocumentFolderUserFilter>;
  /** Some related `documentFolderUsers` exist. */
  documentFolderUsersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentFolders` relation. */
  documentFolders?: InputMaybe<CompanyToManyDocumentFolderFilter>;
  /** Some related `documentFolders` exist. */
  documentFoldersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentUserPermissions` relation. */
  documentUserPermissions?: InputMaybe<CompanyToManyDocumentUserPermissionFilter>;
  /** Some related `documentUserPermissions` exist. */
  documentUserPermissionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentUserResponsibles` relation. */
  documentUserResponsibles?: InputMaybe<CompanyToManyDocumentUserResponsibleFilter>;
  /** Some related `documentUserResponsibles` exist. */
  documentUserResponsiblesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `employeeCasefiles` relation. */
  employeeCasefiles?: InputMaybe<CompanyToManyEmployeeCasefileFilter>;
  /** Some related `employeeCasefiles` exist. */
  employeeCasefilesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `employeeExternalIntegrations` relation. */
  employeeExternalIntegrations?: InputMaybe<CompanyToManyEmployeeExternalIntegrationFilter>;
  /** Some related `employeeExternalIntegrations` exist. */
  employeeExternalIntegrationsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `employees` relation. */
  employees?: InputMaybe<CompanyToManyEmployeeFilter>;
  /** Some related `employees` exist. */
  employeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `engagementTypes` relation. */
  engagementTypes?: InputMaybe<CompanyToManyEngagementTypeFilter>;
  /** Some related `engagementTypes` exist. */
  engagementTypesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `equipments` relation. */
  equipments?: InputMaybe<CompanyToManyEquipmentFilter>;
  /** Some related `equipments` exist. */
  equipmentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventUsers` relation. */
  eventUsers?: InputMaybe<CompanyToManyEventUserFilter>;
  /** Some related `eventUsers` exist. */
  eventUsersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `events` relation. */
  events?: InputMaybe<CompanyToManyEventFilter>;
  /** Some related `events` exist. */
  eventsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `externalIntegrations` relation. */
  externalIntegrations?: InputMaybe<CompanyToManyExternalIntegrationFilter>;
  /** Some related `externalIntegrations` exist. */
  externalIntegrationsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `fieldGroupCardColumns` relation. */
  fieldGroupCardColumns?: InputMaybe<CompanyToManyFieldGroupCardColumnFilter>;
  /** Some related `fieldGroupCardColumns` exist. */
  fieldGroupCardColumnsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `fieldGroupCards` relation. */
  fieldGroupCards?: InputMaybe<CompanyToManyFieldGroupCardFilter>;
  /** Some related `fieldGroupCards` exist. */
  fieldGroupCardsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `fieldGroups` relation. */
  fieldGroups?: InputMaybe<CompanyToManyFieldGroupFilter>;
  /** Some related `fieldGroups` exist. */
  fieldGroupsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `filterPresets` relation. */
  filterPresets?: InputMaybe<CompanyToManyFilterPresetFilter>;
  /** Some related `filterPresets` exist. */
  filterPresetsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFieldAgreements` relation. */
  formFieldAgreements?: InputMaybe<CompanyToManyFormFieldAgreementFilter>;
  /** Some related `formFieldAgreements` exist. */
  formFieldAgreementsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFieldEntries` relation. */
  formFieldEntries?: InputMaybe<CompanyToManyFormFieldEntryFilter>;
  /** Some related `formFieldEntries` exist. */
  formFieldEntriesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFieldOptions` relation. */
  formFieldOptions?: InputMaybe<CompanyToManyFormFieldOptionFilter>;
  /** Some related `formFieldOptions` exist. */
  formFieldOptionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `froalaStyles` relation. */
  froalaStyles?: InputMaybe<CompanyToManyFroalaStyleFilter>;
  /** Some related `froalaStyles` exist. */
  froalaStylesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `futureData` relation. */
  futureData?: InputMaybe<CompanyToManyFutureDatumFilter>;
  /** Some related `futureData` exist. */
  futureDataExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `groupRoles` relation. */
  groupRoles?: InputMaybe<CompanyToManyGroupRoleFilter>;
  /** Some related `groupRoles` exist. */
  groupRolesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `integrationFieldMarkings` relation. */
  integrationFieldMarkings?: InputMaybe<CompanyToManyIntegrationFieldMarkingFilter>;
  /** Some related `integrationFieldMarkings` exist. */
  integrationFieldMarkingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `lastLogin` field. */
  lastLogin?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `latestMessages` relation. */
  latestMessages?: InputMaybe<CompanyToManyLatestMessageFilter>;
  /** Some related `latestMessages` exist. */
  latestMessagesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `locale` field. */
  locale?: InputMaybe<StringFilter>;
  /** Filter by the object’s `loggedActionNotes` relation. */
  loggedActionNotes?: InputMaybe<CompanyToManyLoggedActionNoteFilter>;
  /** Some related `loggedActionNotes` exist. */
  loggedActionNotesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `loginLogs` relation. */
  loginLogs?: InputMaybe<CompanyToManyLoginLogFilter>;
  /** Some related `loginLogs` exist. */
  loginLogsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `logo` field. */
  logo?: InputMaybe<StringFilter>;
  /** Filter by the object’s `masterForCompany` relation. */
  masterForCompany?: InputMaybe<CompanyFilter>;
  /** A related `masterForCompany` exists. */
  masterForCompanyExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `masterForCompanyId` field. */
  masterForCompanyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `masterTemplate` field. */
  masterTemplate?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `messages` relation. */
  messages?: InputMaybe<CompanyToManyMessageFilter>;
  /** Some related `messages` exist. */
  messagesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `minimumEmployeeNumber` field. */
  minimumEmployeeNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `mode` field. */
  mode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nativeAppAccess` field. */
  nativeAppAccess?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `notificationCustomEmployeeFieldRecipients` relation. */
  notificationCustomEmployeeFieldRecipients?: InputMaybe<CompanyToManyNotificationCustomEmployeeFieldRecipientFilter>;
  /** Some related `notificationCustomEmployeeFieldRecipients` exist. */
  notificationCustomEmployeeFieldRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `notificationCustomRecipients` relation. */
  notificationCustomRecipients?: InputMaybe<CompanyToManyNotificationCustomRecipientFilter>;
  /** Some related `notificationCustomRecipients` exist. */
  notificationCustomRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `notificationEmployeeReferences` relation. */
  notificationEmployeeReferences?: InputMaybe<CompanyToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferences` exist. */
  notificationEmployeeReferencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `notificationEmployees` relation. */
  notificationEmployees?: InputMaybe<CompanyToManyNotificationEmployeeFilter>;
  /** Some related `notificationEmployees` exist. */
  notificationEmployeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `notificationGroupRecipients` relation. */
  notificationGroupRecipients?: InputMaybe<CompanyToManyNotificationGroupRecipientFilter>;
  /** Some related `notificationGroupRecipients` exist. */
  notificationGroupRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `notificationTypeChannelTypes` relation. */
  notificationTypeChannelTypes?: InputMaybe<CompanyToManyNotificationTypeChannelTypeFilter>;
  /** Some related `notificationTypeChannelTypes` exist. */
  notificationTypeChannelTypesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `numberOfCurrentlyEmployedEmployees` field. */
  numberOfCurrentlyEmployedEmployees?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompanyFilter>>;
  /** Filter by the object’s `postTypes` relation. */
  postTypes?: InputMaybe<CompanyToManyPostTypeFilter>;
  /** Some related `postTypes` exist. */
  postTypesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `posts` relation. */
  posts?: InputMaybe<CompanyToManyPostFilter>;
  /** Some related `posts` exist. */
  postsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingComments` relation. */
  preboardingComments?: InputMaybe<CompanyToManyPreboardingCommentFilter>;
  /** Some related `preboardingComments` exist. */
  preboardingCommentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingEmailLogs` relation. */
  preboardingEmailLogs?: InputMaybe<CompanyToManyPreboardingEmailLogFilter>;
  /** Some related `preboardingEmailLogs` exist. */
  preboardingEmailLogsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingEmployees` relation. */
  preboardingEmployees?: InputMaybe<CompanyToManyPreboardingEmployeeFilter>;
  /** Some related `preboardingEmployees` exist. */
  preboardingEmployeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingProcesses` relation. */
  preboardingProcesses?: InputMaybe<CompanyToManyPreboardingProcessFilter>;
  /** Some related `preboardingProcesses` exist. */
  preboardingProcessesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingResultSlideComments` relation. */
  preboardingResultSlideComments?: InputMaybe<CompanyToManyPreboardingResultSlideCommentFilter>;
  /** Some related `preboardingResultSlideComments` exist. */
  preboardingResultSlideCommentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingResults` relation. */
  preboardingResults?: InputMaybe<CompanyToManyPreboardingResultFilter>;
  /** Some related `preboardingResults` exist. */
  preboardingResultsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingSlideFormFields` relation. */
  preboardingSlideFormFields?: InputMaybe<CompanyToManyPreboardingSlideFormFieldFilter>;
  /** Some related `preboardingSlideFormFields` exist. */
  preboardingSlideFormFieldsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingSlides` relation. */
  preboardingSlides?: InputMaybe<CompanyToManyPreboardingSlideFilter>;
  /** Some related `preboardingSlides` exist. */
  preboardingSlidesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardings` relation. */
  preboardings?: InputMaybe<CompanyToManyPreboardingFilter>;
  /** Some related `preboardings` exist. */
  preboardingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processDepartments` relation. */
  processDepartments?: InputMaybe<CompanyToManyProcessDepartmentFilter>;
  /** Some related `processDepartments` exist. */
  processDepartmentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processResponsibles` relation. */
  processResponsibles?: InputMaybe<CompanyToManyProcessResponsibleFilter>;
  /** Some related `processResponsibles` exist. */
  processResponsiblesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processTypes` relation. */
  processTypes?: InputMaybe<CompanyToManyProcessTypeFilter>;
  /** Some related `processTypes` exist. */
  processTypesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectTemplates` relation. */
  projectTemplates?: InputMaybe<CompanyToManyProjectTemplateFilter>;
  /** Some related `projectTemplates` exist. */
  projectTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projects` relation. */
  projects?: InputMaybe<CompanyToManyProjectFilter>;
  /** Some related `projects` exist. */
  projectsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseSurveyAnswers` relation. */
  pulseSurveyAnswers?: InputMaybe<CompanyToManyPulseSurveyAnswerFilter>;
  /** Some related `pulseSurveyAnswers` exist. */
  pulseSurveyAnswersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseSurveyChoices` relation. */
  pulseSurveyChoices?: InputMaybe<CompanyToManyPulseSurveyChoiceFilter>;
  /** Some related `pulseSurveyChoices` exist. */
  pulseSurveyChoicesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseSurveys` relation. */
  pulseSurveys?: InputMaybe<CompanyToManyPulseSurveyFilter>;
  /** Some related `pulseSurveys` exist. */
  pulseSurveysExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseTypes` relation. */
  pulseTypes?: InputMaybe<CompanyToManyPulseTypeFilter>;
  /** Some related `pulseTypes` exist. */
  pulseTypesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `recurrenceRules` relation. */
  recurrenceRules?: InputMaybe<CompanyToManyRecurrenceRuleFilter>;
  /** Some related `recurrenceRules` exist. */
  recurrenceRulesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `referenceTokens` relation. */
  referenceTokens?: InputMaybe<CompanyToManyReferenceTokenFilter>;
  /** Some related `referenceTokens` exist. */
  referenceTokensExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `relationRoles` relation. */
  relationRoles?: InputMaybe<CompanyToManyRelationRoleFilter>;
  /** Some related `relationRoles` exist. */
  relationRolesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scheduledMessageExternalRecipients` relation. */
  scheduledMessageExternalRecipients?: InputMaybe<CompanyToManyScheduledMessageExternalRecipientFilter>;
  /** Some related `scheduledMessageExternalRecipients` exist. */
  scheduledMessageExternalRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scheduledMessageRecipients` relation. */
  scheduledMessageRecipients?: InputMaybe<CompanyToManyScheduledMessageRecipientFilter>;
  /** Some related `scheduledMessageRecipients` exist. */
  scheduledMessageRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scheduledMessageTemplateExternalRecipients` relation. */
  scheduledMessageTemplateExternalRecipients?: InputMaybe<CompanyToManyScheduledMessageTemplateExternalRecipientFilter>;
  /** Some related `scheduledMessageTemplateExternalRecipients` exist. */
  scheduledMessageTemplateExternalRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scheduledMessageTemplateRecipients` relation. */
  scheduledMessageTemplateRecipients?: InputMaybe<CompanyToManyScheduledMessageTemplateRecipientFilter>;
  /** Some related `scheduledMessageTemplateRecipients` exist. */
  scheduledMessageTemplateRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scheduledMessageTemplates` relation. */
  scheduledMessageTemplates?: InputMaybe<CompanyToManyScheduledMessageTemplateFilter>;
  /** Some related `scheduledMessageTemplates` exist. */
  scheduledMessageTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scheduledMessages` relation. */
  scheduledMessages?: InputMaybe<CompanyToManyScheduledMessageFilter>;
  /** Some related `scheduledMessages` exist. */
  scheduledMessagesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `sso` field. */
  sso?: InputMaybe<StringFilter>;
  /** Filter by the object’s `superUserAllowedUsers` relation. */
  superUserAllowedUsers?: InputMaybe<CompanyToManySuperUserAllowedUserFilter>;
  /** Some related `superUserAllowedUsers` exist. */
  superUserAllowedUsersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskEmployees` relation. */
  taskEmployees?: InputMaybe<CompanyToManyTaskEmployeeFilter>;
  /** Some related `taskEmployees` exist. */
  taskEmployeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskResponsibles` relation. */
  taskResponsibles?: InputMaybe<CompanyToManyTaskResponsibleFilter>;
  /** Some related `taskResponsibles` exist. */
  taskResponsiblesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskTemplateEmployees` relation. */
  taskTemplateEmployees?: InputMaybe<CompanyToManyTaskTemplateEmployeeFilter>;
  /** Some related `taskTemplateEmployees` exist. */
  taskTemplateEmployeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskTemplateResponsibles` relation. */
  taskTemplateResponsibles?: InputMaybe<CompanyToManyTaskTemplateResponsibleFilter>;
  /** Some related `taskTemplateResponsibles` exist. */
  taskTemplateResponsiblesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskTemplates` relation. */
  taskTemplates?: InputMaybe<CompanyToManyTaskTemplateFilter>;
  /** Some related `taskTemplates` exist. */
  taskTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `tasks` relation. */
  tasks?: InputMaybe<CompanyToManyTaskFilter>;
  /** Some related `tasks` exist. */
  tasksExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationBreakTypes` relation. */
  timeRegistrationBreakTypes?: InputMaybe<CompanyToManyTimeRegistrationBreakTypeFilter>;
  /** Some related `timeRegistrationBreakTypes` exist. */
  timeRegistrationBreakTypesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationEntries` relation. */
  timeRegistrationEntries?: InputMaybe<CompanyToManyTimeRegistrationEntryFilter>;
  /** Some related `timeRegistrationEntries` exist. */
  timeRegistrationEntriesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationEntryTemplates` relation. */
  timeRegistrationEntryTemplates?: InputMaybe<CompanyToManyTimeRegistrationEntryTemplateFilter>;
  /** Some related `timeRegistrationEntryTemplates` exist. */
  timeRegistrationEntryTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationPresenceTemplates` relation. */
  timeRegistrationPresenceTemplates?: InputMaybe<CompanyToManyTimeRegistrationPresenceTemplateFilter>;
  /** Some related `timeRegistrationPresenceTemplates` exist. */
  timeRegistrationPresenceTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationPresenceTypes` relation. */
  timeRegistrationPresenceTypes?: InputMaybe<CompanyToManyTimeRegistrationPresenceTypeFilter>;
  /** Some related `timeRegistrationPresenceTypes` exist. */
  timeRegistrationPresenceTypesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationPresences` relation. */
  timeRegistrationPresences?: InputMaybe<CompanyToManyTimeRegistrationPresenceFilter>;
  /** Some related `timeRegistrationPresences` exist. */
  timeRegistrationPresencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationProjects` relation. */
  timeRegistrationProjects?: InputMaybe<CompanyToManyTimeRegistrationProjectFilter>;
  /** Some related `timeRegistrationProjects` exist. */
  timeRegistrationProjectsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationTemplateWeeks` relation. */
  timeRegistrationTemplateWeeks?: InputMaybe<CompanyToManyTimeRegistrationTemplateWeekFilter>;
  /** Some related `timeRegistrationTemplateWeeks` exist. */
  timeRegistrationTemplateWeeksExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationTemplates` relation. */
  timeRegistrationTemplates?: InputMaybe<CompanyToManyTimeRegistrationTemplateFilter>;
  /** Some related `timeRegistrationTemplates` exist. */
  timeRegistrationTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `translatedEntities` relation. */
  translatedEntities?: InputMaybe<CompanyToManyTranslatedEntityFilter>;
  /** Some related `translatedEntities` exist. */
  translatedEntitiesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `translatedEntityLocalizations` relation. */
  translatedEntityLocalizations?: InputMaybe<CompanyToManyTranslatedEntityLocalizationFilter>;
  /** Some related `translatedEntityLocalizations` exist. */
  translatedEntityLocalizationsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `translations` relation. */
  translations?: InputMaybe<CompanyToManyTranslationFilter>;
  /** Some related `translations` exist. */
  translationsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `url` field. */
  url?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userCompanyGroups` relation. */
  userCompanyGroups?: InputMaybe<CompanyToManyUserCompanyGroupFilter>;
  /** Some related `userCompanyGroups` exist. */
  userCompanyGroupsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userCompanyRoles` relation. */
  userCompanyRoles?: InputMaybe<CompanyToManyUserCompanyRoleFilter>;
  /** Some related `userCompanyRoles` exist. */
  userCompanyRolesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userCompetenceEvaluationComments` relation. */
  userCompetenceEvaluationComments?: InputMaybe<CompanyToManyUserCompetenceEvaluationCommentFilter>;
  /** Some related `userCompetenceEvaluationComments` exist. */
  userCompetenceEvaluationCommentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userCompetenceEvaluations` relation. */
  userCompetenceEvaluations?: InputMaybe<CompanyToManyUserCompetenceEvaluationFilter>;
  /** Some related `userCompetenceEvaluations` exist. */
  userCompetenceEvaluationsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userCompetences` relation. */
  userCompetences?: InputMaybe<CompanyToManyUserCompetenceFilter>;
  /** Some related `userCompetences` exist. */
  userCompetencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userDepartmentGroups` relation. */
  userDepartmentGroups?: InputMaybe<CompanyToManyUserDepartmentGroupFilter>;
  /** Some related `userDepartmentGroups` exist. */
  userDepartmentGroupsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userDepartmentRoles` relation. */
  userDepartmentRoles?: InputMaybe<CompanyToManyUserDepartmentRoleFilter>;
  /** Some related `userDepartmentRoles` exist. */
  userDepartmentRolesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userDepartments` relation. */
  userDepartments?: InputMaybe<CompanyToManyUserDepartmentFilter>;
  /** Some related `userDepartments` exist. */
  userDepartmentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userGroups` relation. */
  userGroups?: InputMaybe<CompanyToManyUserGroupFilter>;
  /** Some related `userGroups` exist. */
  userGroupsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userOnBehalfPermissions` relation. */
  userOnBehalfPermissions?: InputMaybe<CompanyToManyUserOnBehalfPermissionFilter>;
  /** Some related `userOnBehalfPermissions` exist. */
  userOnBehalfPermissionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userRoles` relation. */
  userRoles?: InputMaybe<CompanyToManyUserRoleFilter>;
  /** Some related `userRoles` exist. */
  userRolesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userSystemFields` relation. */
  userSystemFields?: InputMaybe<CompanyToManyUserSystemFieldFilter>;
  /** Some related `userSystemFields` exist. */
  userSystemFieldsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `users` relation. */
  users?: InputMaybe<CompanyToManyUserFilter>;
  /** Some related `users` exist. */
  usersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `vacationTypes` relation. */
  vacationTypes?: InputMaybe<CompanyToManyVacationTypeFilter>;
  /** Some related `vacationTypes` exist. */
  vacationTypesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `vacationUsers` relation. */
  vacationUsers?: InputMaybe<CompanyToManyVacationUserFilter>;
  /** Some related `vacationUsers` exist. */
  vacationUsersExist?: InputMaybe<Scalars['Boolean']>;
};

/** Input for the nested mutation of `company` in the `CompanyInput` mutation. */
export type CompanyMasterForCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnCompanyForCompanyMasterForCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnAnnouncementForAnnouncementCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnAnnouncementForAnnouncementCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnApprovalForApprovalCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnApprovalForApprovalCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnAsyncJobForAsyncJobCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnAsyncJobForAsyncJobCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnAsyncJobItemForAsyncJobItemCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnAsyncJobItemForAsyncJobItemCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnCompanyBindingForCompanyBindingCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnCompanyBindingForCompanyBindingCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnCompanyCompanyTypeForCompanyCompanyTypeCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnCompanyCompanyTypeForCompanyCompanyTypeCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnCompanyForCompanyMasterForCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnCompanyForCompanyMasterForCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnCompanySettingForCompanySettingCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnCompanySettingForCompanySettingCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnCompanySystemFieldForCompanySystemFieldCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnCompanySystemFieldForCompanySystemFieldCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnCompetenceForCompetenceCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnCompetenceForCompetenceCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnCompetenceFormFieldForCompetenceFormFieldCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnCompetenceFormFieldForCompetenceFormFieldCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnCompetenceGroupForCompetenceGroupCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnCompetenceGroupForCompetenceGroupCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnCompetenceRequestForCompetenceRequestCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnCompetenceRequestForCompetenceRequestCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnContractSignPendingDocumentForContractSignPendingDocumentCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnContractSignPendingDocumentForContractSignPendingDocumentCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnContractSignPendingForContractSignPendingCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnContractSignPendingForContractSignPendingCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnContractSignPendingSignerForContractSignPendingSignerCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnContractSignPendingSignerForContractSignPendingSignerCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnContractTemplateDepartmentForContractTemplateDepartmentsCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnContractTemplateDepartmentForContractTemplateDepartmentsCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnContractTemplateUserForContractTemplateUsersCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnContractTemplateUserForContractTemplateUsersCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnCustomWidgetContentForCustomWidgetContentCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnCustomWidgetContentForCustomWidgetContentCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnCustomWidgetForCustomWidgetCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnCustomWidgetForCustomWidgetCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnCvTemplateFieldMappingForCvTemplateFieldMappingCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnCvTemplateFieldMappingForCvTemplateFieldMappingCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnDashboardCardForDashboardCardCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnDashboardCardForDashboardCardCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnDashboardCardStatisticForDashboardCardStatisticCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnDashboardCardStatisticForDashboardCardStatisticCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnDashboardConfigForDashboardConfigCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnDashboardConfigForDashboardConfigCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnDashboardViewForDashboardViewCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnDashboardViewForDashboardViewCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnDepartmentForDepartmentCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnDepartmentForDepartmentCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnDepartmentTypeForDepartmentTypeCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnDepartmentTypeForDepartmentTypeCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnDocumentFolderBlueprintForDocumentFolderBlueprintCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnDocumentFolderBlueprintForDocumentFolderBlueprintCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnDocumentFolderDepartmentForDocumentFolderDepartmentCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnDocumentFolderDepartmentForDocumentFolderDepartmentCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnDocumentFolderForDocumentFolderCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnDocumentFolderForDocumentFolderCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnDocumentFolderUserForDocumentFolderUserCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnDocumentFolderUserForDocumentFolderUserCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnDocumentUserPermissionForDocumentUserPermissionsCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnDocumentUserPermissionForDocumentUserPermissionsCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnDocumentUserResponsibleForDocumentUserResponsibleCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnDocumentUserResponsibleForDocumentUserResponsibleCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnEmployeeCasefileForEmployeeCasefileCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnEmployeeCasefileForEmployeeCasefileCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnEmployeeExternalIntegrationForEmployeeExternalIntegrationCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnEmployeeExternalIntegrationForEmployeeExternalIntegrationCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnEmployeeForEmployeeCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnEmployeeForEmployeeCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnEngagementTypeForEngagementTypeCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnEngagementTypeForEngagementTypeCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnEquipmentForEquipmentCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnEquipmentForEquipmentCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnEventForEventCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnEventForEventCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnEventUserForEventUserCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnEventUserForEventUserCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnExternalIntegrationForExternalIntegrationCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnExternalIntegrationForExternalIntegrationCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnFieldGroupCardColumnForFieldGroupCardColumnCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnFieldGroupCardColumnForFieldGroupCardColumnCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnFieldGroupCardForFieldGroupCardCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnFieldGroupCardForFieldGroupCardCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnFieldGroupForFormFieldTypeCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnFieldGroupForFormFieldTypeCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnFilterPresetForFilterPresetCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnFilterPresetForFilterPresetCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnFormFieldAgreementForFormFieldAgreementCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnFormFieldAgreementForFormFieldAgreementCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnFormFieldEntryForFormFieldEntryCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnFormFieldEntryForFormFieldEntryCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnFormFieldOptionForFormFieldOptionCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnFormFieldOptionForFormFieldOptionCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnFroalaStyleForFroalaStylesCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnFroalaStyleForFroalaStylesCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnFutureDatumForFutureDataCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnFutureDatumForFutureDataCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnGroupRoleForGroupRoleCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnGroupRoleForGroupRoleCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnIntegrationFieldMarkingForIntegrationFieldMarkingCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnIntegrationFieldMarkingForIntegrationFieldMarkingCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnLatestMessageForLatestMessageCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnLatestMessageForLatestMessageCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnLoggedActionNoteForLoggedActionNoteCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnLoggedActionNoteForLoggedActionNoteCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnLoginLogForLoginLogCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnLoginLogForLoginLogCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnMessageForMessageCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnMessageForMessageCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnNotificationCustomRecipientForNotificationCustomRecipientCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnNotificationCustomRecipientForNotificationCustomRecipientCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnNotificationEmployeeForNotificationEmployeeCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnNotificationEmployeeForNotificationEmployeeCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnNotificationGroupRecipientForNotificationGroupRecipientCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnNotificationGroupRecipientForNotificationGroupRecipientCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnNotificationTypeChannelTypeForNotificationTypeChannelTypeCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnNotificationTypeChannelTypeForNotificationTypeChannelTypeCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnPostForPostCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnPostForPostCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnPostTypeForPostTypeCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnPostTypeForPostTypeCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnPreboardingCommentForPreboardingCommentCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnPreboardingCommentForPreboardingCommentCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnPreboardingEmailLogForPreboardingEmailLogCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnPreboardingEmailLogForPreboardingEmailLogCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnPreboardingEmployeeForPreboardingEmployeeCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnPreboardingEmployeeForPreboardingEmployeeCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnPreboardingForPreboardingCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnPreboardingForPreboardingCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnPreboardingProcessForPreboardingProcessCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnPreboardingProcessForPreboardingProcessCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnPreboardingResultForPreboardingResultCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnPreboardingResultForPreboardingResultCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnPreboardingResultSlideCommentForPreboardingResultSlideCommentCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnPreboardingResultSlideCommentForPreboardingResultSlideCommentCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnPreboardingSlideForPreboardingSlideCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnPreboardingSlideForPreboardingSlideCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnPreboardingSlideFormFieldForPreboardingSlideFormFieldCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnPreboardingSlideFormFieldForPreboardingSlideFormFieldCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnProcessDepartmentForProcessDepartmentCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnProcessDepartmentForProcessDepartmentCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnProcessResponsibleForProcessResponsibleCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnProcessResponsibleForProcessResponsibleCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnProcessTypeForProcessTypeCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnProcessTypeForProcessTypeCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnProjectForProjectCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnProjectForProjectCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnProjectTemplateForProjectTemplateCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnProjectTemplateForProjectTemplateCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnPulseSurveyAnswerForPulseSurveyAnswerCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnPulseSurveyAnswerForPulseSurveyAnswerCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnPulseSurveyChoiceForPulseSurveyChoiceCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnPulseSurveyChoiceForPulseSurveyChoiceCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnPulseSurveyForPulseSurveyCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnPulseSurveyForPulseSurveyCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnPulseTypeForPulseTypeCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnPulseTypeForPulseTypeCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnRecurrenceRuleForRecurrenceRuleCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnRecurrenceRuleForRecurrenceRuleCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnReferenceTokenForReferenceTokenCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnReferenceTokenForReferenceTokenCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnRelationRoleForRelationRoleCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnRelationRoleForRelationRoleCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnScheduledMessageForScheduledMessageCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnScheduledMessageForScheduledMessageCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnScheduledMessageRecipientForScheduledMessageRecipientCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnScheduledMessageRecipientForScheduledMessageRecipientCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnScheduledMessageTemplateExternalRecipientForScheduledMessageTemplateExternalRecipientCompanyIdForeigUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnScheduledMessageTemplateExternalRecipientForScheduledMessageTemplateExternalRecipientCompanyIdForeigPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnScheduledMessageTemplateForScheduledMessageTemplateCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnScheduledMessageTemplateForScheduledMessageTemplateCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnSuperUserAllowedUserForSuperUserAllowedUsersCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnSuperUserAllowedUserForSuperUserAllowedUsersCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnTaskEmployeeForTaskEmployeeCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnTaskEmployeeForTaskEmployeeCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnTaskForTaskCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnTaskForTaskCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnTaskResponsibleForTaskResponsibleCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnTaskResponsibleForTaskResponsibleCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnTaskTemplateEmployeeForTaskTemplateEmployeeCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnTaskTemplateEmployeeForTaskTemplateEmployeeCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnTaskTemplateForTaskTemplateCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnTaskTemplateForTaskTemplateCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnTaskTemplateResponsibleForTaskTemplateResponsibleCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnTaskTemplateResponsibleForTaskTemplateResponsibleCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnTimeRegistrationBreakTypeForTimeRegistrationBreakTypeCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnTimeRegistrationBreakTypeForTimeRegistrationBreakTypeCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnTimeRegistrationEntryForTimeRegistrationEntryCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnTimeRegistrationEntryForTimeRegistrationEntryCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnTimeRegistrationPresenceForTimeRegistrationPresenceCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnTimeRegistrationPresenceForTimeRegistrationPresenceCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnTimeRegistrationPresenceTypeForTimeRegistrationPresenceTypeCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnTimeRegistrationPresenceTypeForTimeRegistrationPresenceTypeCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnTimeRegistrationProjectForTimeRegistrationProjectCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnTimeRegistrationProjectForTimeRegistrationProjectCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnTimeRegistrationTemplateForTimeRegistrationTemplateCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnTimeRegistrationTemplateForTimeRegistrationTemplateCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnTranslatedEntityForTranslatedEntityCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnTranslatedEntityForTranslatedEntityCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnTranslatedEntityLocalizationForTranslatedEntityLocalizationCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnTranslatedEntityLocalizationForTranslatedEntityLocalizationCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnTranslationForTranslationCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnTranslationForTranslationCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnUserCompanyGroupForUserCompanyGroupCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnUserCompanyGroupForUserCompanyGroupCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnUserCompanyRoleForUserCompanyRoleCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnUserCompanyRoleForUserCompanyRoleCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnUserCompetenceEvaluationForUserCompetenceEvaluationCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnUserCompetenceEvaluationForUserCompetenceEvaluationCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnUserCompetenceForUserCompetenceCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnUserCompetenceForUserCompetenceCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnUserDepartmentForUserDepartmentCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnUserDepartmentForUserDepartmentCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnUserDepartmentGroupForUserDepartmentGroupCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnUserDepartmentGroupForUserDepartmentGroupCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnUserDepartmentRoleForUserDepartmentRoleCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnUserDepartmentRoleForUserDepartmentRoleCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnUserForUserCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnUserForUserCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnUserGroupForUserGroupCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnUserGroupForUserGroupCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnUserOnBehalfPermissionForUserOnBehalfPermissionsCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnUserOnBehalfPermissionForUserOnBehalfPermissionsCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnUserRoleForUserRoleCompanyIdFkeyUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnUserRoleForUserRoleCompanyIdFkeyPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnUserSystemFieldForUserSystemFieldCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnUserSystemFieldForUserSystemFieldCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnVacationTypeForVacationTypeCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnVacationTypeForVacationTypeCompanyIdForeignPatch;
};

/** The fields on `company` to look up the row to update. */
export type CompanyOnVacationUserForVacationUserCompanyIdForeignUsingCompanyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `company` being updated. */
  patch: UpdateCompanyOnVacationUserForVacationUserCompanyIdForeignPatch;
};

/** Represents an update to a `Company`. Fields that are set will be updated. */
export type CompanyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

export type CompanySetting = {
  __typename?: 'CompanySetting';
  /** Reads a single `Company` that is related to this `CompanySetting`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  id: Scalars['UUID'];
  key: CompanySettingKey;
  value?: Maybe<Scalars['String']>;
  valueBoolean?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Storage` that is related to this `CompanySetting`. */
  valueStorage?: Maybe<Storage>;
  valueStorageId?: Maybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `CompanySettingInput` mutation. */
export type CompanySettingCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnCompanySettingForCompanySettingCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `companySetting` in the `CompanyInput` mutation. */
export type CompanySettingCompanyIdForeignInverseInput = {
  /** The primary key(s) for `companySetting` for the far side of the relationship. */
  connectByCompanyIdAndKey?: InputMaybe<Array<CompanySettingCompanySettingCompanyIdKeyUniqueConnect>>;
  /** The primary key(s) for `companySetting` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanySettingCompanySettingPkeyConnect>>;
  /** The primary key(s) and patch data for `companySetting` for the far side of the relationship. */
  updateByCompanyIdAndKey?: InputMaybe<Array<CompanySettingOnCompanySettingForCompanySettingCompanyIdForeignUsingCompanySettingCompanyIdKeyUniqueUpdate>>;
  /** The primary key(s) and patch data for `companySetting` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanySettingOnCompanySettingForCompanySettingCompanyIdForeignUsingCompanySettingPkeyUpdate>>;
};

/** The fields on `companySetting` to look up the row to connect. */
export type CompanySettingCompanySettingCompanyIdKeyUniqueConnect = {
  companyId: Scalars['UUID'];
  key: CompanySettingKey;
};

/** The fields on `companySetting` to look up the row to connect. */
export type CompanySettingCompanySettingPkeyConnect = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `CompanySetting` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CompanySettingCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<CompanySettingKey>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `valueBoolean` field. */
  valueBoolean?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `valueStorageId` field. */
  valueStorageId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `CompanySetting` object types. All fields are combined with a logical ‘and.’ */
export type CompanySettingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompanySettingFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<CompanySettingKeyFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompanySettingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompanySettingFilter>>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
  /** Filter by the object’s `valueBoolean` field. */
  valueBoolean?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `valueStorage` relation. */
  valueStorage?: InputMaybe<StorageFilter>;
  /** A related `valueStorage` exists. */
  valueStorageExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `valueStorageId` field. */
  valueStorageId?: InputMaybe<UuidFilter>;
};

export type CompanySettingKey =
  /** Whether or not employees should be allowed to log in on the last day of their employment */
  | 'ALLOW_LOGGING_IN_ON_LAST_DAY_OF_EMPLOYMENT'
  /** Whether or not an email should be automatically generated when creating new employees */
  | 'AUTO_GENERATE_EMAIL'
  | 'CONTRACT_REMINDER_INTERVAL'
  | 'DEACTIVATE_CELEBRATIONS_WIDGET'
  | 'DEACTIVATE_CHAT'
  | 'DEACTIVATE_FEED'
  | 'DEACTIVATE_PULSE'
  | 'DEFAULT_CAN_LOGIN'
  | 'DEFAULT_CAN_LOGIN_APP'
  | 'DEFAULT_CAN_LOGIN_SSO'
  /** The default time zone to be used when a user does not have their own time zone set */
  | 'DEFAULT_TIME_ZONE'
  | 'DIGITAL_SIGNATURE_DEFAULT_EMAIL_BODY'
  | 'DIGITAL_SIGNATURE_DEFAULT_EMAIL_SUBJECT'
  | 'DIGITAL_SIGNATURE_DEFAULT_RECIPIENTS'
  /** The default reminder interval value when creating new digital signatures. */
  | 'DIGITAL_SIGNATURE_DEFAULT_REMINDER_INTERVAL'
  | 'EMPLOYEE_DELETE_DAYS'
  | 'EMPLOYMENT_END_REMINDER_DAYS'
  | 'ENABLE_TIME_REGISTRATION'
  | 'FAVICON'
  /** The default email body when sending a document to hand signature */
  | 'HAND_SIGNATURE_DEFAULT_EMAIL_BODY'
  | 'HIDE_DIGITAL_SIGNATURE'
  /** Hide the time registration clock */
  | 'HIDE_TIME_REGISTRATION_CLOCK'
  | 'MAIL_SENDER_NAME'
  | 'RECRUIT_APPLICANT_IMPORT_DOCUMENT_TYPE'
  | 'RECRUIT_APPLICANT_IMPORT_USE_PRIMARY_EMAIL'
  /** Whether or not notifications should be send to users that have never logged into the system */
  | 'SEND_NOTIFICATIONS_TO_NEVER_LOGGED_IN_USERS'
  | 'STORAGE_DELETE_DAYS'
  | 'THEME_FONT_SECONDARY_COLOR'
  | 'THEME_PRIMARY_COLOR'
  | 'WINDOW_TITLE';

/** A filter to be used against CompanySettingKey fields. All fields are combined with a logical ‘and.’ */
export type CompanySettingKeyFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CompanySettingKey>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CompanySettingKey>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CompanySettingKey>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CompanySettingKey>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CompanySettingKey>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CompanySettingKey>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CompanySettingKey>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CompanySettingKey>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CompanySettingKey>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CompanySettingKey>>;
};

/** The fields on `companySetting` to look up the row to update. */
export type CompanySettingOnCompanySettingForCompanySettingCompanyIdForeignUsingCompanySettingCompanyIdKeyUniqueUpdate = {
  companyId: Scalars['UUID'];
  key: CompanySettingKey;
  /** An object where the defined keys will be set on the `companySetting` being updated. */
  patch: UpdateCompanySettingOnCompanySettingForCompanySettingCompanyIdForeignPatch;
};

/** The fields on `companySetting` to look up the row to update. */
export type CompanySettingOnCompanySettingForCompanySettingCompanyIdForeignUsingCompanySettingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companySetting` being updated. */
  patch: UpdateCompanySettingOnCompanySettingForCompanySettingCompanyIdForeignPatch;
};

/** The fields on `companySetting` to look up the row to update. */
export type CompanySettingOnCompanySettingForCompanySettingValueStorageIdForeignUsingCompanySettingCompanyIdKeyUniqueUpdate = {
  companyId: Scalars['UUID'];
  key: CompanySettingKey;
  /** An object where the defined keys will be set on the `companySetting` being updated. */
  patch: UpdateCompanySettingOnCompanySettingForCompanySettingValueStorageIdForeignPatch;
};

/** The fields on `companySetting` to look up the row to update. */
export type CompanySettingOnCompanySettingForCompanySettingValueStorageIdForeignUsingCompanySettingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companySetting` being updated. */
  patch: UpdateCompanySettingOnCompanySettingForCompanySettingValueStorageIdForeignPatch;
};

/** The `storage` to be created by this mutation. */
export type CompanySettingValueStorageIdForeignConnectionStorageCreateInput = {
  access: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createCopy?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path: Scalars['String'];
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `storage` in the `CompanySettingInput` mutation. */
export type CompanySettingValueStorageIdForeignInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<StorageStoragePkeyConnect>;
  /** A `StorageInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanySettingValueStorageIdForeignConnectionStorageCreateInput>;
  /** The primary key(s) and patch data for `storage` for the far side of the relationship. */
  updateById?: InputMaybe<StorageOnCompanySettingForCompanySettingValueStorageIdForeignUsingStoragePkeyUpdate>;
};

/** Input for the nested mutation of `companySetting` in the `StorageInput` mutation. */
export type CompanySettingValueStorageIdForeignInverseInput = {
  /** The primary key(s) for `companySetting` for the far side of the relationship. */
  connectByCompanyIdAndKey?: InputMaybe<Array<CompanySettingCompanySettingCompanyIdKeyUniqueConnect>>;
  /** The primary key(s) for `companySetting` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanySettingCompanySettingPkeyConnect>>;
  /** The primary key(s) and patch data for `companySetting` for the far side of the relationship. */
  updateByCompanyIdAndKey?: InputMaybe<Array<CompanySettingOnCompanySettingForCompanySettingValueStorageIdForeignUsingCompanySettingCompanyIdKeyUniqueUpdate>>;
  /** The primary key(s) and patch data for `companySetting` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanySettingOnCompanySettingForCompanySettingValueStorageIdForeignUsingCompanySettingPkeyUpdate>>;
};

/** A connection to a list of `CompanySetting` values. */
export type CompanySettingsConnection = {
  __typename?: 'CompanySettingsConnection';
  /** A list of edges which contains the `CompanySetting` and cursor to aid in pagination. */
  edges: Array<CompanySettingsEdge>;
  /** A list of `CompanySetting` objects. */
  nodes: Array<Maybe<CompanySetting>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CompanySetting` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CompanySetting` edge in the connection. */
export type CompanySettingsEdge = {
  __typename?: 'CompanySettingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompanySetting` at the end of the edge. */
  node?: Maybe<CompanySetting>;
};

/** Methods to use when ordering `CompanySetting`. */
export type CompanySettingsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'KEY_ASC'
  | 'KEY_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__ACCESS_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__ACCESS_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__ACTIVE_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__ACTIVE_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__BELONGS_TO_LEADER_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__BELONGS_TO_LEADER_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__COMPANY_ID_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__COMPANY_ID_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__CREATED_AT_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__CREATED_AT_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__DELETE_AT_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__DELETE_AT_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__DEPARTMENTS_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__DEPARTMENTS_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__DOCUMENT_FOLDER_ID_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__DOCUMENT_FOLDER_ID_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__DOCUMENT_TEMPLATE_ID_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__DOCUMENT_TEMPLATE_ID_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__DOCUMENT_TYPE_ID_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__DOCUMENT_TYPE_ID_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__EMPLOYEE_CASEFILE_ID_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__EMPLOYEE_CASEFILE_ID_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__EXPIRED_REMINDED_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__EXPIRED_REMINDED_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__EXPIRE_AT_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__EXPIRE_AT_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FILENAME_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FILENAME_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FILE_EXTENSION_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FILE_EXTENSION_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FILE_OWNER_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FILE_OWNER_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FILE_OWNER_ID_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FILE_OWNER_ID_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FILE_SIZE_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FILE_SIZE_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FILE_TYPE_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FILE_TYPE_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FOLDER_DEPARTMENT_IDS_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FOLDER_DEPARTMENT_IDS_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FOLDER_OWNER_ID_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FOLDER_OWNER_ID_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FOLDER_USER_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__FOLDER_USER_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__HTML_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__HTML_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__ID_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__ID_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__MIMETYPE_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__MIMETYPE_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__OWNER_NAME_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__OWNER_NAME_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__PATH_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__PATH_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__PENNEO_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__PENNEO_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__PLACEHOLDER_VALUES_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__PLACEHOLDER_VALUES_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__PROCESS_TYPE_ID_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__PROCESS_TYPE_ID_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__REMINDED_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__REMINDED_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__REMIND_AT_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__REMIND_AT_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__TEMPLATING_SERVICE_ID_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__TEMPLATING_SERVICE_ID_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__USERS_RESPONSIBLE_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__USERS_RESPONSIBLE_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__USERS_SHARED_WITH_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__USERS_SHARED_WITH_DEPARTMENTS_ASC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__USERS_SHARED_WITH_DEPARTMENTS_DESC'
  | 'STORAGE_BY_VALUE_STORAGE_ID__USERS_SHARED_WITH_DESC'
  | 'VALUE_ASC'
  | 'VALUE_BOOLEAN_ASC'
  | 'VALUE_BOOLEAN_DESC'
  | 'VALUE_DESC'
  | 'VALUE_STORAGE_ID_ASC'
  | 'VALUE_STORAGE_ID_DESC';

/** A connection to a list of `CompanySuperadminUserListRecord` values. */
export type CompanySuperadminUserListConnection = {
  __typename?: 'CompanySuperadminUserListConnection';
  /** A list of edges which contains the `CompanySuperadminUserListRecord` and cursor to aid in pagination. */
  edges: Array<CompanySuperadminUserListEdge>;
  /** A list of `CompanySuperadminUserListRecord` objects. */
  nodes: Array<Maybe<CompanySuperadminUserListRecord>>;
  /** The count of *all* `CompanySuperadminUserListRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CompanySuperadminUserListRecord` edge in the connection. */
export type CompanySuperadminUserListEdge = {
  __typename?: 'CompanySuperadminUserListEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompanySuperadminUserListRecord` at the end of the edge. */
  node?: Maybe<CompanySuperadminUserListRecord>;
};

/** The return type of our `superadminUserList` query. */
export type CompanySuperadminUserListRecord = {
  __typename?: 'CompanySuperadminUserListRecord';
  companyAdmin?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  lastLogin?: Maybe<Scalars['Datetime']>;
  superUser?: Maybe<SuperUser>;
};

/** A filter to be used against `CompanySuperadminUserListRecord` object types. All fields are combined with a logical ‘and.’ */
export type CompanySuperadminUserListRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompanySuperadminUserListRecordFilter>>;
  /** Filter by the object’s `companyAdmin` field. */
  companyAdmin?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `lastLogin` field. */
  lastLogin?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompanySuperadminUserListRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompanySuperadminUserListRecordFilter>>;
};

export type CompanySystemField = {
  __typename?: 'CompanySystemField';
  alias?: Maybe<Scalars['String']>;
  /** Reads a single `TranslatedEntity` that is related to this `CompanySystemField`. */
  aliasTranslatedEntity?: Maybe<TranslatedEntity>;
  aliasTranslatedEntityId: Scalars['UUID'];
  approverFormFieldIds: Array<Maybe<Scalars['UUID']>>;
  /** Reads and enables pagination through a set of `FormField`. */
  approverFormFields: FormFieldsConnection;
  approverGroupIds: Array<Maybe<Scalars['UUID']>>;
  /** Reads and enables pagination through a set of `Group`. */
  approverGroups: GroupsConnection;
  approverSystemFieldIds: Array<Maybe<Scalars['UUID']>>;
  /** Reads and enables pagination through a set of `SystemField`. */
  approverSystemFields: SystemFieldsConnection;
  approverUserIds: Array<Maybe<Scalars['UUID']>>;
  /** Reads and enables pagination through a set of `User`. */
  approverUsers: UsersConnection;
  cardOrder?: Maybe<Scalars['Int']>;
  changesMustBeApproved: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `CompanySystemField`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `CompanySystemFieldOption`. */
  companySystemFieldOptions: CompanySystemFieldOptionsConnection;
  defaultValue?: Maybe<Scalars['String']>;
  excludedRoleIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `FieldGroup` that is related to this `CompanySystemField`. */
  fieldGroup?: Maybe<FieldGroup>;
  /** Reads a single `FieldGroupCardColumn` that is related to this `CompanySystemField`. */
  fieldGroupCardColumn?: Maybe<FieldGroupCardColumn>;
  fieldGroupCardColumnId?: Maybe<Scalars['UUID']>;
  fieldGroupId?: Maybe<Scalars['UUID']>;
  helpText?: Maybe<Scalars['String']>;
  /** Reads a single `TranslatedEntity` that is related to this `CompanySystemField`. */
  helpTextTranslatedEntity?: Maybe<TranslatedEntity>;
  helpTextTranslatedEntityId: Scalars['UUID'];
  id: Scalars['UUID'];
  localizedAlias?: Maybe<Scalars['String']>;
  localizedHelpText?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  order: Scalars['Int'];
  required: Scalars['Boolean'];
  sensitive: Scalars['Boolean'];
  supportsFutureData: Scalars['Boolean'];
  /** Reads a single `SystemField` that is related to this `CompanySystemField`. */
  systemField?: Maybe<SystemField>;
  systemFieldId: Scalars['UUID'];
  uniqueValue?: Maybe<Scalars['Boolean']>;
};


export type CompanySystemFieldApproverFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<FormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CompanySystemFieldApproverGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CompanySystemFieldApproverSystemFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<SystemFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CompanySystemFieldApproverUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CompanySystemFieldCompanySystemFieldOptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanySystemFieldOptionCondition>;
  filter?: InputMaybe<CompanySystemFieldOptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanySystemFieldOptionsOrderBy>>;
};

/** Input for the nested mutation of `companySystemField` in the `TranslatedEntityInput` mutation. */
export type CompanySystemFieldAliasTranslatedEntityIdForeignInverseInput = {
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldPkeyConnect>>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  connectBySystemFieldIdAndCompanyId?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldUniqueConnect>>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldPkeyDelete>>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  deleteBySystemFieldIdAndCompanyId?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldUniqueDelete>>;
  /** Flag indicating whether all other `companySystemField` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companySystemField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldAliasTranslatedEntityIdForeignUsingCompanySystemFieldPkeyUpdate>>;
  /** The primary key(s) and patch data for `companySystemField` for the far side of the relationship. */
  updateBySystemFieldIdAndCompanyId?: InputMaybe<Array<CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldAliasTranslatedEntityIdForeignUsingCompanySystemFieldUniqueUpdate>>;
};

/** The `companySystemField` to be created by this mutation. */
export type CompanySystemFieldCompanyIdForeignConnectionCompanySystemFieldCreateInput = {
  alias?: InputMaybe<Scalars['String']>;
  aliasLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  aliasTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldCompanyIdForeignInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  helpText?: InputMaybe<Scalars['String']>;
  helpTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  helpTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  order?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  systemField?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInput>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
};

/** Input for the nested mutation of `company` in the `CompanySystemFieldInput` mutation. */
export type CompanySystemFieldCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnCompanySystemFieldForCompanySystemFieldCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `companySystemField` in the `CompanyInput` mutation. */
export type CompanySystemFieldCompanyIdForeignInverseInput = {
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldPkeyConnect>>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  connectBySystemFieldIdAndCompanyId?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldUniqueConnect>>;
  /** A `CompanySystemFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanySystemFieldCompanyIdForeignConnectionCompanySystemFieldCreateInput>>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldPkeyDelete>>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  deleteBySystemFieldIdAndCompanyId?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldUniqueDelete>>;
  /** Flag indicating whether all other `companySystemField` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companySystemField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldCompanyIdForeignUsingCompanySystemFieldPkeyUpdate>>;
  /** The primary key(s) and patch data for `companySystemField` for the far side of the relationship. */
  updateBySystemFieldIdAndCompanyId?: InputMaybe<Array<CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldCompanyIdForeignUsingCompanySystemFieldUniqueUpdate>>;
};

/** The fields on `companySystemField` to look up the row to connect. */
export type CompanySystemFieldCompanySystemFieldPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `companySystemField` to look up the row to delete. */
export type CompanySystemFieldCompanySystemFieldPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `companySystemField` to look up the row to connect. */
export type CompanySystemFieldCompanySystemFieldUniqueConnect = {
  companyId: Scalars['UUID'];
  systemFieldId: Scalars['UUID'];
};

/** The fields on `companySystemField` to look up the row to delete. */
export type CompanySystemFieldCompanySystemFieldUniqueDelete = {
  companyId: Scalars['UUID'];
  systemFieldId: Scalars['UUID'];
};

/**
 * A condition to be used against `CompanySystemField` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CompanySystemFieldCondition = {
  /** Checks for equality with the object’s `aliasTranslatedEntityId` field. */
  aliasTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `approverFormFieldIds` field. */
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `approverGroupIds` field. */
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `approverSystemFieldIds` field. */
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `approverUserIds` field. */
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `changesMustBeApproved` field. */
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `defaultValue` field. */
  defaultValue?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `excludedRoleIds` field. */
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `fieldGroupCardColumnId` field. */
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fieldGroupId` field. */
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `helpTextTranslatedEntityId` field. */
  helpTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `required` field. */
  required?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `sensitive` field. */
  sensitive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `supportsFutureData` field. */
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `systemFieldId` field. */
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `uniqueValue` field. */
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
};

/** The `companySystemField` to be created by this mutation. */
export type CompanySystemFieldFieldGroupCardColumnIdForeignConnectionCompanySystemFieldCreateInput = {
  alias?: InputMaybe<Scalars['String']>;
  aliasLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  aliasTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  helpText?: InputMaybe<Scalars['String']>;
  helpTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  helpTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  order?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  systemField?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInput>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
};

/** The `fieldGroupCardColumn` to be created by this mutation. */
export type CompanySystemFieldFieldGroupCardColumnIdForeignConnectionFieldGroupCardColumnCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  fieldGroupCard?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignInput>;
  fieldGroupCardId?: InputMaybe<Scalars['UUID']>;
  formFields?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** Input for the nested mutation of `fieldGroupCardColumn` in the `CompanySystemFieldInput` mutation. */
export type CompanySystemFieldFieldGroupCardColumnIdForeignInput = {
  /** The primary key(s) for `fieldGroupCardColumn` for the far side of the relationship. */
  connectById?: InputMaybe<FieldGroupCardColumnFieldGroupCardColumnPkeyConnect>;
  /** A `FieldGroupCardColumnInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignConnectionFieldGroupCardColumnCreateInput>;
  /** The primary key(s) and patch data for `fieldGroupCardColumn` for the far side of the relationship. */
  updateById?: InputMaybe<FieldGroupCardColumnOnCompanySystemFieldForCompanySystemFieldFieldGroupCardColumnIdForeignUsingFieldGroupCardColumnPkeyUpdate>;
};

/** Input for the nested mutation of `companySystemField` in the `FieldGroupCardColumnInput` mutation. */
export type CompanySystemFieldFieldGroupCardColumnIdForeignInverseInput = {
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldPkeyConnect>>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  connectBySystemFieldIdAndCompanyId?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldUniqueConnect>>;
  /** A `CompanySystemFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanySystemFieldFieldGroupCardColumnIdForeignConnectionCompanySystemFieldCreateInput>>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldPkeyDelete>>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  deleteBySystemFieldIdAndCompanyId?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldUniqueDelete>>;
  /** Flag indicating whether all other `companySystemField` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companySystemField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldFieldGroupCardColumnIdForeignUsingCompanySystemFieldPkeyUpdate>>;
  /** The primary key(s) and patch data for `companySystemField` for the far side of the relationship. */
  updateBySystemFieldIdAndCompanyId?: InputMaybe<Array<CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldFieldGroupCardColumnIdForeignUsingCompanySystemFieldUniqueUpdate>>;
};

/** A filter to be used against `CompanySystemField` object types. All fields are combined with a logical ‘and.’ */
export type CompanySystemFieldFilter = {
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Filter by the object’s `aliasTranslatedEntity` relation. */
  aliasTranslatedEntity?: InputMaybe<TranslatedEntityFilter>;
  /** Filter by the object’s `aliasTranslatedEntityId` field. */
  aliasTranslatedEntityId?: InputMaybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompanySystemFieldFilter>>;
  /** Filter by the object’s `approverFormFieldIds` field. */
  approverFormFieldIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `approverGroupIds` field. */
  approverGroupIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `approverSystemFieldIds` field. */
  approverSystemFieldIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `approverUserIds` field. */
  approverUserIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `cardOrder` field. */
  cardOrder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `changesMustBeApproved` field. */
  changesMustBeApproved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `companySystemFieldOptions` relation. */
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldToManyCompanySystemFieldOptionFilter>;
  /** Some related `companySystemFieldOptions` exist. */
  companySystemFieldOptionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `defaultValue` field. */
  defaultValue?: InputMaybe<StringFilter>;
  /** Filter by the object’s `excludedRoleIds` field. */
  excludedRoleIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `fieldGroup` relation. */
  fieldGroup?: InputMaybe<FieldGroupFilter>;
  /** Filter by the object’s `fieldGroupCardColumn` relation. */
  fieldGroupCardColumn?: InputMaybe<FieldGroupCardColumnFilter>;
  /** A related `fieldGroupCardColumn` exists. */
  fieldGroupCardColumnExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `fieldGroupCardColumnId` field. */
  fieldGroupCardColumnId?: InputMaybe<UuidFilter>;
  /** A related `fieldGroup` exists. */
  fieldGroupExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `fieldGroupId` field. */
  fieldGroupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `helpText` field. */
  helpText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `helpTextTranslatedEntity` relation. */
  helpTextTranslatedEntity?: InputMaybe<TranslatedEntityFilter>;
  /** Filter by the object’s `helpTextTranslatedEntityId` field. */
  helpTextTranslatedEntityId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedAlias` field. */
  localizedAlias?: InputMaybe<StringFilter>;
  /** Filter by the object’s `localizedHelpText` field. */
  localizedHelpText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompanySystemFieldFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompanySystemFieldFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `required` field. */
  required?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sensitive` field. */
  sensitive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `supportsFutureData` field. */
  supportsFutureData?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `systemField` relation. */
  systemField?: InputMaybe<SystemFieldFilter>;
  /** Filter by the object’s `systemFieldId` field. */
  systemFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `uniqueValue` field. */
  uniqueValue?: InputMaybe<BooleanFilter>;
};

/** The `companySystemField` to be created by this mutation. */
export type CompanySystemFieldFormFieldTypeIdForeignConnectionCompanySystemFieldCreateInput = {
  alias?: InputMaybe<Scalars['String']>;
  aliasLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  aliasTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  helpText?: InputMaybe<Scalars['String']>;
  helpTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  helpTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  order?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  systemField?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInput>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
};

/** The `fieldGroup` to be created by this mutation. */
export type CompanySystemFieldFormFieldTypeIdForeignConnectionFieldGroupCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  fieldGroupCards?: InputMaybe<FieldGroupCardFieldGroupIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFieldGroupIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldFormFieldTypeIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFieldGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  userSystemFields?: InputMaybe<UserSystemFieldFieldGroupIdForeignInverseInput>;
};

/** Input for the nested mutation of `fieldGroup` in the `CompanySystemFieldInput` mutation. */
export type CompanySystemFieldFormFieldTypeIdForeignInput = {
  /** The primary key(s) for `fieldGroup` for the far side of the relationship. */
  connectById?: InputMaybe<FieldGroupFormFieldTypePkeyConnect>;
  /** A `FieldGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignConnectionFieldGroupCreateInput>;
  /** The primary key(s) and patch data for `fieldGroup` for the far side of the relationship. */
  updateById?: InputMaybe<FieldGroupOnCompanySystemFieldForCompanySystemFieldFormFieldTypeIdForeignUsingFormFieldTypePkeyUpdate>;
};

/** Input for the nested mutation of `companySystemField` in the `FieldGroupInput` mutation. */
export type CompanySystemFieldFormFieldTypeIdForeignInverseInput = {
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldPkeyConnect>>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  connectBySystemFieldIdAndCompanyId?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldUniqueConnect>>;
  /** A `CompanySystemFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanySystemFieldFormFieldTypeIdForeignConnectionCompanySystemFieldCreateInput>>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldPkeyDelete>>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  deleteBySystemFieldIdAndCompanyId?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldUniqueDelete>>;
  /** Flag indicating whether all other `companySystemField` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companySystemField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldFormFieldTypeIdForeignUsingCompanySystemFieldPkeyUpdate>>;
  /** The primary key(s) and patch data for `companySystemField` for the far side of the relationship. */
  updateBySystemFieldIdAndCompanyId?: InputMaybe<Array<CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldFormFieldTypeIdForeignUsingCompanySystemFieldUniqueUpdate>>;
};

/** Input for the nested mutation of `translatedEntity` in the `CompanySystemFieldInput` mutation. */
export type CompanySystemFieldHelpTextTranslatedEntityIdForeignInput = {
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  connectById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyConnect>;
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  deleteById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyDelete>;
  /** The primary key(s) and patch data for `translatedEntity` for the far side of the relationship. */
  updateById?: InputMaybe<TranslatedEntityOnCompanySystemFieldForCompanySystemFieldHelpTextTranslatedEntityIdForeignUsingTranslatedEntityPkeyUpdate>;
};

/** Input for the nested mutation of `companySystemField` in the `TranslatedEntityInput` mutation. */
export type CompanySystemFieldHelpTextTranslatedEntityIdForeignInverseInput = {
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldPkeyConnect>>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  connectBySystemFieldIdAndCompanyId?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldUniqueConnect>>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldPkeyDelete>>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  deleteBySystemFieldIdAndCompanyId?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldUniqueDelete>>;
  /** Flag indicating whether all other `companySystemField` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companySystemField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldHelpTextTranslatedEntityIdForeignUsingCompanySystemFieldPkeyUpdate>>;
  /** The primary key(s) and patch data for `companySystemField` for the far side of the relationship. */
  updateBySystemFieldIdAndCompanyId?: InputMaybe<Array<CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldHelpTextTranslatedEntityIdForeignUsingCompanySystemFieldUniqueUpdate>>;
};

/** An input for mutations affecting `CompanySystemField` */
export type CompanySystemFieldInput = {
  alias?: InputMaybe<Scalars['String']>;
  aliasLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  aliasTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  helpText?: InputMaybe<Scalars['String']>;
  helpTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  helpTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  order?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  systemField?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInput>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
};

/** The fields on `companySystemField` to look up the row to update. */
export type CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldAliasTranslatedEntityIdForeignUsingCompanySystemFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companySystemField` being updated. */
  patch: UpdateCompanySystemFieldOnCompanySystemFieldForCompanySystemFieldAliasTranslatedEntityIdForeignPatch;
};

/** The fields on `companySystemField` to look up the row to update. */
export type CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldAliasTranslatedEntityIdForeignUsingCompanySystemFieldUniqueUpdate = {
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companySystemField` being updated. */
  patch: UpdateCompanySystemFieldOnCompanySystemFieldForCompanySystemFieldAliasTranslatedEntityIdForeignPatch;
  systemFieldId: Scalars['UUID'];
};

/** The fields on `companySystemField` to look up the row to update. */
export type CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldCompanyIdForeignUsingCompanySystemFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companySystemField` being updated. */
  patch: UpdateCompanySystemFieldOnCompanySystemFieldForCompanySystemFieldCompanyIdForeignPatch;
};

/** The fields on `companySystemField` to look up the row to update. */
export type CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldCompanyIdForeignUsingCompanySystemFieldUniqueUpdate = {
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companySystemField` being updated. */
  patch: UpdateCompanySystemFieldOnCompanySystemFieldForCompanySystemFieldCompanyIdForeignPatch;
  systemFieldId: Scalars['UUID'];
};

/** The fields on `companySystemField` to look up the row to update. */
export type CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldFieldGroupCardColumnIdForeignUsingCompanySystemFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companySystemField` being updated. */
  patch: UpdateCompanySystemFieldOnCompanySystemFieldForCompanySystemFieldFieldGroupCardColumnIdForeignPatch;
};

/** The fields on `companySystemField` to look up the row to update. */
export type CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldFieldGroupCardColumnIdForeignUsingCompanySystemFieldUniqueUpdate = {
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companySystemField` being updated. */
  patch: UpdateCompanySystemFieldOnCompanySystemFieldForCompanySystemFieldFieldGroupCardColumnIdForeignPatch;
  systemFieldId: Scalars['UUID'];
};

/** The fields on `companySystemField` to look up the row to update. */
export type CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldFormFieldTypeIdForeignUsingCompanySystemFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companySystemField` being updated. */
  patch: UpdateCompanySystemFieldOnCompanySystemFieldForCompanySystemFieldFormFieldTypeIdForeignPatch;
};

/** The fields on `companySystemField` to look up the row to update. */
export type CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldFormFieldTypeIdForeignUsingCompanySystemFieldUniqueUpdate = {
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companySystemField` being updated. */
  patch: UpdateCompanySystemFieldOnCompanySystemFieldForCompanySystemFieldFormFieldTypeIdForeignPatch;
  systemFieldId: Scalars['UUID'];
};

/** The fields on `companySystemField` to look up the row to update. */
export type CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldHelpTextTranslatedEntityIdForeignUsingCompanySystemFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companySystemField` being updated. */
  patch: UpdateCompanySystemFieldOnCompanySystemFieldForCompanySystemFieldHelpTextTranslatedEntityIdForeignPatch;
};

/** The fields on `companySystemField` to look up the row to update. */
export type CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldHelpTextTranslatedEntityIdForeignUsingCompanySystemFieldUniqueUpdate = {
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companySystemField` being updated. */
  patch: UpdateCompanySystemFieldOnCompanySystemFieldForCompanySystemFieldHelpTextTranslatedEntityIdForeignPatch;
  systemFieldId: Scalars['UUID'];
};

/** The fields on `companySystemField` to look up the row to update. */
export type CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldSystemFieldIdForeignUsingCompanySystemFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companySystemField` being updated. */
  patch: UpdateCompanySystemFieldOnCompanySystemFieldForCompanySystemFieldSystemFieldIdForeignPatch;
};

/** The fields on `companySystemField` to look up the row to update. */
export type CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldSystemFieldIdForeignUsingCompanySystemFieldUniqueUpdate = {
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companySystemField` being updated. */
  patch: UpdateCompanySystemFieldOnCompanySystemFieldForCompanySystemFieldSystemFieldIdForeignPatch;
  systemFieldId: Scalars['UUID'];
};

/** The fields on `companySystemField` to look up the row to update. */
export type CompanySystemFieldOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanySystemFieldIdForeignUsingCompanySystemFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companySystemField` being updated. */
  patch: UpdateCompanySystemFieldOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanySystemFieldIdForeignPatch;
};

/** The fields on `companySystemField` to look up the row to update. */
export type CompanySystemFieldOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanySystemFieldIdForeignUsingCompanySystemFieldUniqueUpdate = {
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companySystemField` being updated. */
  patch: UpdateCompanySystemFieldOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanySystemFieldIdForeignPatch;
  systemFieldId: Scalars['UUID'];
};

export type CompanySystemFieldOption = {
  __typename?: 'CompanySystemFieldOption';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `CompanySystemFieldOption`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `CompanySystemField` that is related to this `CompanySystemFieldOption`. */
  companySystemField?: Maybe<CompanySystemField>;
  companySystemFieldId: Scalars['UUID'];
  id: Scalars['UUID'];
  localizedValue?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  value: Scalars['String'];
};


export type CompanySystemFieldOptionLocalizedValueArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

/** The `companySystemFieldOption` to be created by this mutation. */
export type CompanySystemFieldOptionCompanyIdForeignConnectionCompanySystemFieldOptionCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInput>;
  companySystemField?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInput>;
  companySystemFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `company` in the `CompanySystemFieldOptionInput` mutation. */
export type CompanySystemFieldOptionCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `companySystemFieldOption` in the `CompanyInput` mutation. */
export type CompanySystemFieldOptionCompanyIdForeignInverseInput = {
  /** The primary key(s) for `companySystemFieldOption` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanySystemFieldOptionCompanySystemFieldOptionPkeyConnect>>;
  /** A `CompanySystemFieldOptionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanySystemFieldOptionCompanyIdForeignConnectionCompanySystemFieldOptionCreateInput>>;
  /** The primary key(s) and patch data for `companySystemFieldOption` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanySystemFieldOptionOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanyIdForeignUsingCompanySystemFieldOptionPkeyUpdate>>;
};

/** The `companySystemField` to be created by this mutation. */
export type CompanySystemFieldOptionCompanySystemFieldIdForeignConnectionCompanySystemFieldCreateInput = {
  alias?: InputMaybe<Scalars['String']>;
  aliasLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  aliasTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  helpText?: InputMaybe<Scalars['String']>;
  helpTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  helpTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  order?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  systemField?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInput>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
};

/** The `companySystemFieldOption` to be created by this mutation. */
export type CompanySystemFieldOptionCompanySystemFieldIdForeignConnectionCompanySystemFieldOptionCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemField?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `companySystemField` in the `CompanySystemFieldOptionInput` mutation. */
export type CompanySystemFieldOptionCompanySystemFieldIdForeignInput = {
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  connectById?: InputMaybe<CompanySystemFieldCompanySystemFieldPkeyConnect>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  connectBySystemFieldIdAndCompanyId?: InputMaybe<CompanySystemFieldCompanySystemFieldUniqueConnect>;
  /** A `CompanySystemFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignConnectionCompanySystemFieldCreateInput>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  deleteById?: InputMaybe<CompanySystemFieldCompanySystemFieldPkeyDelete>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  deleteBySystemFieldIdAndCompanyId?: InputMaybe<CompanySystemFieldCompanySystemFieldUniqueDelete>;
  /** The primary key(s) and patch data for `companySystemField` for the far side of the relationship. */
  updateById?: InputMaybe<CompanySystemFieldOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanySystemFieldIdForeignUsingCompanySystemFieldPkeyUpdate>;
  /** The primary key(s) and patch data for `companySystemField` for the far side of the relationship. */
  updateBySystemFieldIdAndCompanyId?: InputMaybe<CompanySystemFieldOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanySystemFieldIdForeignUsingCompanySystemFieldUniqueUpdate>;
};

/** Input for the nested mutation of `companySystemFieldOption` in the `CompanySystemFieldInput` mutation. */
export type CompanySystemFieldOptionCompanySystemFieldIdForeignInverseInput = {
  /** The primary key(s) for `companySystemFieldOption` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanySystemFieldOptionCompanySystemFieldOptionPkeyConnect>>;
  /** A `CompanySystemFieldOptionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanySystemFieldOptionCompanySystemFieldIdForeignConnectionCompanySystemFieldOptionCreateInput>>;
  /** The primary key(s) and patch data for `companySystemFieldOption` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanySystemFieldOptionOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanySystemFieldIdForeignUsingCompanySystemFieldOptionPkeyUpdate>>;
};

/** The fields on `companySystemFieldOption` to look up the row to connect. */
export type CompanySystemFieldOptionCompanySystemFieldOptionPkeyConnect = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `CompanySystemFieldOption` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type CompanySystemFieldOptionCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `companySystemFieldId` field. */
  companySystemFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `CompanySystemFieldOption` object types. All fields are combined with a logical ‘and.’ */
export type CompanySystemFieldOptionFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompanySystemFieldOptionFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `companySystemField` relation. */
  companySystemField?: InputMaybe<CompanySystemFieldFilter>;
  /** Filter by the object’s `companySystemFieldId` field. */
  companySystemFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedValue` field. */
  localizedValue?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompanySystemFieldOptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompanySystemFieldOptionFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `CompanySystemFieldOption` */
export type CompanySystemFieldOptionInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemField?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInput>;
  companySystemFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
};

/** The fields on `companySystemFieldOption` to look up the row to update. */
export type CompanySystemFieldOptionOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanyIdForeignUsingCompanySystemFieldOptionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companySystemFieldOption` being updated. */
  patch: UpdateCompanySystemFieldOptionOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanyIdForeignPatch;
};

/** The fields on `companySystemFieldOption` to look up the row to update. */
export type CompanySystemFieldOptionOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanySystemFieldIdForeignUsingCompanySystemFieldOptionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companySystemFieldOption` being updated. */
  patch: UpdateCompanySystemFieldOptionOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanySystemFieldIdForeignPatch;
};

/** Represents an update to a `CompanySystemFieldOption`. Fields that are set will be updated. */
export type CompanySystemFieldOptionPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemField?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInput>;
  companySystemFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `CompanySystemFieldOption` values. */
export type CompanySystemFieldOptionsConnection = {
  __typename?: 'CompanySystemFieldOptionsConnection';
  /** A list of edges which contains the `CompanySystemFieldOption` and cursor to aid in pagination. */
  edges: Array<CompanySystemFieldOptionsEdge>;
  /** A list of `CompanySystemFieldOption` objects. */
  nodes: Array<Maybe<CompanySystemFieldOption>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CompanySystemFieldOption` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CompanySystemFieldOption` edge in the connection. */
export type CompanySystemFieldOptionsEdge = {
  __typename?: 'CompanySystemFieldOptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompanySystemFieldOption` at the end of the edge. */
  node?: Maybe<CompanySystemFieldOption>;
};

/** Methods to use when ordering `CompanySystemFieldOption`. */
export type CompanySystemFieldOptionsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__ALIAS_TRANSLATED_ENTITY_ID_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__ALIAS_TRANSLATED_ENTITY_ID_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__APPROVER_FORM_FIELD_IDS_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__APPROVER_FORM_FIELD_IDS_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__APPROVER_GROUP_IDS_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__APPROVER_GROUP_IDS_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__APPROVER_USER_IDS_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__APPROVER_USER_IDS_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__CARD_ORDER_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__CARD_ORDER_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__CHANGES_MUST_BE_APPROVED_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__CHANGES_MUST_BE_APPROVED_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__COMPANY_ID_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__COMPANY_ID_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__DEFAULT_VALUE_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__DEFAULT_VALUE_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__EXCLUDED_ROLE_IDS_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__EXCLUDED_ROLE_IDS_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__FIELD_GROUP_ID_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__FIELD_GROUP_ID_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__HELP_TEXT_TRANSLATED_ENTITY_ID_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__HELP_TEXT_TRANSLATED_ENTITY_ID_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__ID_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__ID_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__METADATA_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__METADATA_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__ORDER_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__ORDER_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__REQUIRED_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__REQUIRED_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__SENSITIVE_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__SENSITIVE_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__SUPPORTS_FUTURE_DATA_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__SUPPORTS_FUTURE_DATA_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__SYSTEM_FIELD_ID_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__SYSTEM_FIELD_ID_DESC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__UNIQUE_VALUE_ASC'
  | 'COMPANY_SYSTEM_FIELD_BY_COMPANY_SYSTEM_FIELD_ID__UNIQUE_VALUE_DESC'
  | 'COMPANY_SYSTEM_FIELD_ID_ASC'
  | 'COMPANY_SYSTEM_FIELD_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'VALUE_ASC'
  | 'VALUE_DESC';

/** Represents an update to a `CompanySystemField`. Fields that are set will be updated. */
export type CompanySystemFieldPatch = {
  alias?: InputMaybe<Scalars['String']>;
  aliasLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  aliasTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  helpText?: InputMaybe<Scalars['String']>;
  helpTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  helpTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  order?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  systemField?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInput>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
};

/** The `companySystemField` to be created by this mutation. */
export type CompanySystemFieldSystemFieldIdForeignConnectionCompanySystemFieldCreateInput = {
  alias?: InputMaybe<Scalars['String']>;
  aliasLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  aliasTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  helpText?: InputMaybe<Scalars['String']>;
  helpTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  helpTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  order?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  systemField?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInput>;
  translatedEntity?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInput>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
};

/** Input for the nested mutation of `systemField` in the `CompanySystemFieldInput` mutation. */
export type CompanySystemFieldSystemFieldIdForeignInput = {
  /** The primary key(s) for `systemField` for the far side of the relationship. */
  connectById?: InputMaybe<SystemFieldSystemFieldPkeyConnect>;
  /** The primary key(s) for `systemField` for the far side of the relationship. */
  connectByName?: InputMaybe<SystemFieldSystemFieldNameUniqueConnect>;
  /** The primary key(s) and patch data for `systemField` for the far side of the relationship. */
  updateById?: InputMaybe<SystemFieldOnCompanySystemFieldForCompanySystemFieldSystemFieldIdForeignUsingSystemFieldPkeyUpdate>;
  /** The primary key(s) and patch data for `systemField` for the far side of the relationship. */
  updateByName?: InputMaybe<SystemFieldOnCompanySystemFieldForCompanySystemFieldSystemFieldIdForeignUsingSystemFieldNameUniqueUpdate>;
};

/** Input for the nested mutation of `companySystemField` in the `SystemFieldInput` mutation. */
export type CompanySystemFieldSystemFieldIdForeignInverseInput = {
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldPkeyConnect>>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  connectBySystemFieldIdAndCompanyId?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldUniqueConnect>>;
  /** A `CompanySystemFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompanySystemFieldSystemFieldIdForeignConnectionCompanySystemFieldCreateInput>>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldPkeyDelete>>;
  /** The primary key(s) for `companySystemField` for the far side of the relationship. */
  deleteBySystemFieldIdAndCompanyId?: InputMaybe<Array<CompanySystemFieldCompanySystemFieldUniqueDelete>>;
  /** Flag indicating whether all other `companySystemField` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `companySystemField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldSystemFieldIdForeignUsingCompanySystemFieldPkeyUpdate>>;
  /** The primary key(s) and patch data for `companySystemField` for the far side of the relationship. */
  updateBySystemFieldIdAndCompanyId?: InputMaybe<Array<CompanySystemFieldOnCompanySystemFieldForCompanySystemFieldSystemFieldIdForeignUsingCompanySystemFieldUniqueUpdate>>;
};

/** A filter to be used against many `CompanySystemFieldOption` object types. All fields are combined with a logical ‘and.’ */
export type CompanySystemFieldToManyCompanySystemFieldOptionFilter = {
  /** Every related `CompanySystemFieldOption` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompanySystemFieldOptionFilter>;
  /** No related `CompanySystemFieldOption` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompanySystemFieldOptionFilter>;
  /** Some related `CompanySystemFieldOption` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompanySystemFieldOptionFilter>;
};

/** A connection to a list of `CompanySystemField` values. */
export type CompanySystemFieldsConnection = {
  __typename?: 'CompanySystemFieldsConnection';
  /** A list of edges which contains the `CompanySystemField` and cursor to aid in pagination. */
  edges: Array<CompanySystemFieldsEdge>;
  /** A list of `CompanySystemField` objects. */
  nodes: Array<Maybe<CompanySystemField>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CompanySystemField` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CompanySystemField` edge in the connection. */
export type CompanySystemFieldsEdge = {
  __typename?: 'CompanySystemFieldsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompanySystemField` at the end of the edge. */
  node?: Maybe<CompanySystemField>;
};

/** Methods to use when ordering `CompanySystemField`. */
export type CompanySystemFieldsOrderBy =
  | 'ALIAS_TRANSLATED_ENTITY_ID_ASC'
  | 'ALIAS_TRANSLATED_ENTITY_ID_DESC'
  | 'APPROVER_FORM_FIELD_IDS_ASC'
  | 'APPROVER_FORM_FIELD_IDS_DESC'
  | 'APPROVER_GROUP_IDS_ASC'
  | 'APPROVER_GROUP_IDS_DESC'
  | 'APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'APPROVER_USER_IDS_ASC'
  | 'APPROVER_USER_IDS_DESC'
  | 'CARD_ORDER_ASC'
  | 'CARD_ORDER_DESC'
  | 'CHANGES_MUST_BE_APPROVED_ASC'
  | 'CHANGES_MUST_BE_APPROVED_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPANY_SYSTEM_FIELD_OPTIONS_BY_COMPANY_SYSTEM_FIELD_ID__COUNT_ASC'
  | 'COMPANY_SYSTEM_FIELD_OPTIONS_BY_COMPANY_SYSTEM_FIELD_ID__COUNT_DESC'
  | 'DEFAULT_VALUE_ASC'
  | 'DEFAULT_VALUE_DESC'
  | 'EXCLUDED_ROLE_IDS_ASC'
  | 'EXCLUDED_ROLE_IDS_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ACTIVE_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ACTIVE_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__COMPANY_ID_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__COMPANY_ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__CUSTOM_ID_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__CUSTOM_ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ID_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__LOCALIZED_NAME_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__LOCALIZED_NAME_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__NAME_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__NAME_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ORDER_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ORDER_DESC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__ACTIVE_ASC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__ACTIVE_DESC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__COMPANY_ID_ASC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__COMPANY_ID_DESC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__CREATED_AT_ASC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__CREATED_AT_DESC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__FIELD_GROUP_CARD_ID_ASC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__FIELD_GROUP_CARD_ID_DESC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__ID_ASC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__ID_DESC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__NAME_ASC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__NAME_DESC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__ORDER_ASC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__ORDER_DESC'
  | 'FIELD_GROUP_CARD_COLUMN_ID_ASC'
  | 'FIELD_GROUP_CARD_COLUMN_ID_DESC'
  | 'FIELD_GROUP_ID_ASC'
  | 'FIELD_GROUP_ID_DESC'
  | 'HELP_TEXT_TRANSLATED_ENTITY_ID_ASC'
  | 'HELP_TEXT_TRANSLATED_ENTITY_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'METADATA_ASC'
  | 'METADATA_DESC'
  | 'NATURAL'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REQUIRED_ASC'
  | 'REQUIRED_DESC'
  | 'SENSITIVE_ASC'
  | 'SENSITIVE_DESC'
  | 'SUPPORTS_FUTURE_DATA_ASC'
  | 'SUPPORTS_FUTURE_DATA_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ALWAYS_REQUIRED_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ALWAYS_REQUIRED_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__DOCUMENT_TEMPLATE_PLACEHOLDER_NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__DOCUMENT_TEMPLATE_PLACEHOLDER_NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__EXCLUDE_FROM_PLACEHOLDER_FORM_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__EXCLUDE_FROM_PLACEHOLDER_FORM_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ID_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ID_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READABLE_NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READABLE_NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READ_ONLY_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READ_ONLY_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__TYPE_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__TYPE_DESC'
  | 'SYSTEM_FIELD_ID_ASC'
  | 'SYSTEM_FIELD_ID_DESC'
  | 'TRANSLATED_ENTITY_BY_ALIAS_TRANSLATED_ENTITY_ID__COMPANY_ID_ASC'
  | 'TRANSLATED_ENTITY_BY_ALIAS_TRANSLATED_ENTITY_ID__COMPANY_ID_DESC'
  | 'TRANSLATED_ENTITY_BY_ALIAS_TRANSLATED_ENTITY_ID__ID_ASC'
  | 'TRANSLATED_ENTITY_BY_ALIAS_TRANSLATED_ENTITY_ID__ID_DESC'
  | 'TRANSLATED_ENTITY_BY_HELP_TEXT_TRANSLATED_ENTITY_ID__COMPANY_ID_ASC'
  | 'TRANSLATED_ENTITY_BY_HELP_TEXT_TRANSLATED_ENTITY_ID__COMPANY_ID_DESC'
  | 'TRANSLATED_ENTITY_BY_HELP_TEXT_TRANSLATED_ENTITY_ID__ID_ASC'
  | 'TRANSLATED_ENTITY_BY_HELP_TEXT_TRANSLATED_ENTITY_ID__ID_DESC'
  | 'UNIQUE_VALUE_ASC'
  | 'UNIQUE_VALUE_DESC';

/** A filter to be used against many `Announcement` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyAnnouncementFilter = {
  /** Every related `Announcement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AnnouncementFilter>;
  /** No related `Announcement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AnnouncementFilter>;
  /** Some related `Announcement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AnnouncementFilter>;
};

/** A filter to be used against many `Approval` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyApprovalFilter = {
  /** Every related `Approval` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ApprovalFilter>;
  /** No related `Approval` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ApprovalFilter>;
  /** Some related `Approval` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ApprovalFilter>;
};

/** A filter to be used against many `AsyncJob` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyAsyncJobFilter = {
  /** Every related `AsyncJob` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AsyncJobFilter>;
  /** No related `AsyncJob` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AsyncJobFilter>;
  /** Some related `AsyncJob` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AsyncJobFilter>;
};

/** A filter to be used against many `AsyncJobItem` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyAsyncJobItemFilter = {
  /** Every related `AsyncJobItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AsyncJobItemFilter>;
  /** No related `AsyncJobItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AsyncJobItemFilter>;
  /** Some related `AsyncJobItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AsyncJobItemFilter>;
};

/** A filter to be used against many `CompanyBinding` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyCompanyBindingFilter = {
  /** Every related `CompanyBinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompanyBindingFilter>;
  /** No related `CompanyBinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompanyBindingFilter>;
  /** Some related `CompanyBinding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompanyBindingFilter>;
};

/** A filter to be used against many `Company` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyCompanyFilter = {
  /** Every related `Company` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompanyFilter>;
  /** No related `Company` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompanyFilter>;
  /** Some related `Company` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompanyFilter>;
};

/** A filter to be used against many `CompanySetting` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyCompanySettingFilter = {
  /** Every related `CompanySetting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompanySettingFilter>;
  /** No related `CompanySetting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompanySettingFilter>;
  /** Some related `CompanySetting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompanySettingFilter>;
};

/** A filter to be used against many `CompanySystemField` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyCompanySystemFieldFilter = {
  /** Every related `CompanySystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompanySystemFieldFilter>;
  /** No related `CompanySystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompanySystemFieldFilter>;
  /** Some related `CompanySystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompanySystemFieldFilter>;
};

/** A filter to be used against many `CompanySystemFieldOption` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyCompanySystemFieldOptionFilter = {
  /** Every related `CompanySystemFieldOption` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompanySystemFieldOptionFilter>;
  /** No related `CompanySystemFieldOption` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompanySystemFieldOptionFilter>;
  /** Some related `CompanySystemFieldOption` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompanySystemFieldOptionFilter>;
};

/** A filter to be used against many `Competence` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyCompetenceFilter = {
  /** Every related `Competence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompetenceFilter>;
  /** No related `Competence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompetenceFilter>;
  /** Some related `Competence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompetenceFilter>;
};

/** A filter to be used against many `CompetenceFormField` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyCompetenceFormFieldFilter = {
  /** Every related `CompetenceFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompetenceFormFieldFilter>;
  /** No related `CompetenceFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompetenceFormFieldFilter>;
  /** Some related `CompetenceFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompetenceFormFieldFilter>;
};

/** A filter to be used against many `CompetenceGroup` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyCompetenceGroupFilter = {
  /** Every related `CompetenceGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompetenceGroupFilter>;
  /** No related `CompetenceGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompetenceGroupFilter>;
  /** Some related `CompetenceGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompetenceGroupFilter>;
};

/** A filter to be used against many `CompetenceRequest` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyCompetenceRequestFilter = {
  /** Every related `CompetenceRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompetenceRequestFilter>;
  /** No related `CompetenceRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompetenceRequestFilter>;
  /** Some related `CompetenceRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompetenceRequestFilter>;
};

/** A filter to be used against many `ContractSignPendingDocument` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyContractSignPendingDocumentFilter = {
  /** Every related `ContractSignPendingDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractSignPendingDocumentFilter>;
  /** No related `ContractSignPendingDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractSignPendingDocumentFilter>;
  /** Some related `ContractSignPendingDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractSignPendingDocumentFilter>;
};

/** A filter to be used against many `ContractSignPending` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyContractSignPendingFilter = {
  /** Every related `ContractSignPending` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractSignPendingFilter>;
  /** No related `ContractSignPending` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractSignPendingFilter>;
  /** Some related `ContractSignPending` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractSignPendingFilter>;
};

/** A filter to be used against many `ContractSignPendingSigner` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyContractSignPendingSignerFilter = {
  /** Every related `ContractSignPendingSigner` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractSignPendingSignerFilter>;
  /** No related `ContractSignPendingSigner` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractSignPendingSignerFilter>;
  /** Some related `ContractSignPendingSigner` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractSignPendingSignerFilter>;
};

/** A filter to be used against many `ContractTemplateDepartment` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyContractTemplateDepartmentFilter = {
  /** Every related `ContractTemplateDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractTemplateDepartmentFilter>;
  /** No related `ContractTemplateDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractTemplateDepartmentFilter>;
  /** Some related `ContractTemplateDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractTemplateDepartmentFilter>;
};

/** A filter to be used against many `ContractTemplateUser` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyContractTemplateUserFilter = {
  /** Every related `ContractTemplateUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractTemplateUserFilter>;
  /** No related `ContractTemplateUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractTemplateUserFilter>;
  /** Some related `ContractTemplateUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractTemplateUserFilter>;
};

/** A filter to be used against many `CustomWidgetContent` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyCustomWidgetContentFilter = {
  /** Every related `CustomWidgetContent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CustomWidgetContentFilter>;
  /** No related `CustomWidgetContent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CustomWidgetContentFilter>;
  /** Some related `CustomWidgetContent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CustomWidgetContentFilter>;
};

/** A filter to be used against many `CustomWidget` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyCustomWidgetFilter = {
  /** Every related `CustomWidget` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CustomWidgetFilter>;
  /** No related `CustomWidget` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CustomWidgetFilter>;
  /** Some related `CustomWidget` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CustomWidgetFilter>;
};

/** A filter to be used against many `CvTemplateFieldMapping` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyCvTemplateFieldMappingFilter = {
  /** Every related `CvTemplateFieldMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CvTemplateFieldMappingFilter>;
  /** No related `CvTemplateFieldMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CvTemplateFieldMappingFilter>;
  /** Some related `CvTemplateFieldMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CvTemplateFieldMappingFilter>;
};

/** A filter to be used against many `DashboardCard` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyDashboardCardFilter = {
  /** Every related `DashboardCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DashboardCardFilter>;
  /** No related `DashboardCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DashboardCardFilter>;
  /** Some related `DashboardCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DashboardCardFilter>;
};

/** A filter to be used against many `DashboardCardStatistic` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyDashboardCardStatisticFilter = {
  /** Every related `DashboardCardStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DashboardCardStatisticFilter>;
  /** No related `DashboardCardStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DashboardCardStatisticFilter>;
  /** Some related `DashboardCardStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DashboardCardStatisticFilter>;
};

/** A filter to be used against many `DashboardView` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyDashboardViewFilter = {
  /** Every related `DashboardView` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DashboardViewFilter>;
  /** No related `DashboardView` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DashboardViewFilter>;
  /** Some related `DashboardView` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DashboardViewFilter>;
};

/** A filter to be used against many `Department` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyDepartmentFilter = {
  /** Every related `Department` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DepartmentFilter>;
  /** No related `Department` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DepartmentFilter>;
  /** Some related `Department` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DepartmentFilter>;
};

/** A filter to be used against many `DepartmentType` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyDepartmentTypeFilter = {
  /** Every related `DepartmentType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DepartmentTypeFilter>;
  /** No related `DepartmentType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DepartmentTypeFilter>;
  /** Some related `DepartmentType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DepartmentTypeFilter>;
};

/** A filter to be used against many `DocumentDepartmentPermission` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyDocumentDepartmentPermissionFilter = {
  /** Every related `DocumentDepartmentPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentDepartmentPermissionFilter>;
  /** No related `DocumentDepartmentPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentDepartmentPermissionFilter>;
  /** Some related `DocumentDepartmentPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentDepartmentPermissionFilter>;
};

/** A filter to be used against many `DocumentFolderBlueprint` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyDocumentFolderBlueprintFilter = {
  /** Every related `DocumentFolderBlueprint` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentFolderBlueprintFilter>;
  /** No related `DocumentFolderBlueprint` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentFolderBlueprintFilter>;
  /** Some related `DocumentFolderBlueprint` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentFolderBlueprintFilter>;
};

/** A filter to be used against many `DocumentFolderDepartment` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyDocumentFolderDepartmentFilter = {
  /** Every related `DocumentFolderDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentFolderDepartmentFilter>;
  /** No related `DocumentFolderDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentFolderDepartmentFilter>;
  /** Some related `DocumentFolderDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentFolderDepartmentFilter>;
};

/** A filter to be used against many `DocumentFolder` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyDocumentFolderFilter = {
  /** Every related `DocumentFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentFolderFilter>;
  /** No related `DocumentFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentFolderFilter>;
  /** Some related `DocumentFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentFolderFilter>;
};

/** A filter to be used against many `DocumentFolderUser` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyDocumentFolderUserFilter = {
  /** Every related `DocumentFolderUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentFolderUserFilter>;
  /** No related `DocumentFolderUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentFolderUserFilter>;
  /** Some related `DocumentFolderUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentFolderUserFilter>;
};

/** A filter to be used against many `DocumentUserPermission` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyDocumentUserPermissionFilter = {
  /** Every related `DocumentUserPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentUserPermissionFilter>;
  /** No related `DocumentUserPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentUserPermissionFilter>;
  /** Some related `DocumentUserPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentUserPermissionFilter>;
};

/** A filter to be used against many `DocumentUserResponsible` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyDocumentUserResponsibleFilter = {
  /** Every related `DocumentUserResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentUserResponsibleFilter>;
  /** No related `DocumentUserResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentUserResponsibleFilter>;
  /** Some related `DocumentUserResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentUserResponsibleFilter>;
};

/** A filter to be used against many `EmployeeCasefile` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyEmployeeCasefileFilter = {
  /** Every related `EmployeeCasefile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmployeeCasefileFilter>;
  /** No related `EmployeeCasefile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmployeeCasefileFilter>;
  /** Some related `EmployeeCasefile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmployeeCasefileFilter>;
};

/** A filter to be used against many `EmployeeExternalIntegration` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyEmployeeExternalIntegrationFilter = {
  /** Every related `EmployeeExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmployeeExternalIntegrationFilter>;
  /** No related `EmployeeExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmployeeExternalIntegrationFilter>;
  /** Some related `EmployeeExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmployeeExternalIntegrationFilter>;
};

/** A filter to be used against many `Employee` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyEmployeeFilter = {
  /** Every related `Employee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmployeeFilter>;
  /** No related `Employee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmployeeFilter>;
  /** Some related `Employee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmployeeFilter>;
};

/** A filter to be used against many `EngagementType` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyEngagementTypeFilter = {
  /** Every related `EngagementType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EngagementTypeFilter>;
  /** No related `EngagementType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EngagementTypeFilter>;
  /** Some related `EngagementType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EngagementTypeFilter>;
};

/** A filter to be used against many `Equipment` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyEquipmentFilter = {
  /** Every related `Equipment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EquipmentFilter>;
  /** No related `Equipment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EquipmentFilter>;
  /** Some related `Equipment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EquipmentFilter>;
};

/** A filter to be used against many `Event` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyEventFilter = {
  /** Every related `Event` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EventFilter>;
  /** No related `Event` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EventFilter>;
  /** Some related `Event` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EventFilter>;
};

/** A filter to be used against many `EventUser` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyEventUserFilter = {
  /** Every related `EventUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EventUserFilter>;
  /** No related `EventUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EventUserFilter>;
  /** Some related `EventUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EventUserFilter>;
};

/** A filter to be used against many `ExternalIntegration` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyExternalIntegrationFilter = {
  /** Every related `ExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalIntegrationFilter>;
  /** No related `ExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalIntegrationFilter>;
  /** Some related `ExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalIntegrationFilter>;
};

/** A filter to be used against many `FieldGroupCardColumn` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyFieldGroupCardColumnFilter = {
  /** Every related `FieldGroupCardColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FieldGroupCardColumnFilter>;
  /** No related `FieldGroupCardColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FieldGroupCardColumnFilter>;
  /** Some related `FieldGroupCardColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FieldGroupCardColumnFilter>;
};

/** A filter to be used against many `FieldGroupCard` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyFieldGroupCardFilter = {
  /** Every related `FieldGroupCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FieldGroupCardFilter>;
  /** No related `FieldGroupCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FieldGroupCardFilter>;
  /** Some related `FieldGroupCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FieldGroupCardFilter>;
};

/** A filter to be used against many `FieldGroup` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyFieldGroupFilter = {
  /** Every related `FieldGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FieldGroupFilter>;
  /** No related `FieldGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FieldGroupFilter>;
  /** Some related `FieldGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FieldGroupFilter>;
};

/** A filter to be used against many `FilterPreset` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyFilterPresetFilter = {
  /** Every related `FilterPreset` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FilterPresetFilter>;
  /** No related `FilterPreset` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FilterPresetFilter>;
  /** Some related `FilterPreset` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FilterPresetFilter>;
};

/** A filter to be used against many `FormFieldAgreement` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyFormFieldAgreementFilter = {
  /** Every related `FormFieldAgreement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FormFieldAgreementFilter>;
  /** No related `FormFieldAgreement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FormFieldAgreementFilter>;
  /** Some related `FormFieldAgreement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FormFieldAgreementFilter>;
};

/** A filter to be used against many `FormFieldEntry` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyFormFieldEntryFilter = {
  /** Every related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FormFieldEntryFilter>;
  /** No related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FormFieldEntryFilter>;
  /** Some related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FormFieldEntryFilter>;
};

/** A filter to be used against many `FormFieldOption` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyFormFieldOptionFilter = {
  /** Every related `FormFieldOption` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FormFieldOptionFilter>;
  /** No related `FormFieldOption` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FormFieldOptionFilter>;
  /** Some related `FormFieldOption` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FormFieldOptionFilter>;
};

/** A filter to be used against many `FroalaStyle` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyFroalaStyleFilter = {
  /** Every related `FroalaStyle` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FroalaStyleFilter>;
  /** No related `FroalaStyle` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FroalaStyleFilter>;
  /** Some related `FroalaStyle` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FroalaStyleFilter>;
};

/** A filter to be used against many `FutureDatum` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyFutureDatumFilter = {
  /** Every related `FutureDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FutureDatumFilter>;
  /** No related `FutureDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FutureDatumFilter>;
  /** Some related `FutureDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FutureDatumFilter>;
};

/** A filter to be used against many `GroupRole` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyGroupRoleFilter = {
  /** Every related `GroupRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GroupRoleFilter>;
  /** No related `GroupRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GroupRoleFilter>;
  /** Some related `GroupRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GroupRoleFilter>;
};

/** A filter to be used against many `IntegrationFieldMarking` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyIntegrationFieldMarkingFilter = {
  /** Every related `IntegrationFieldMarking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<IntegrationFieldMarkingFilter>;
  /** No related `IntegrationFieldMarking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<IntegrationFieldMarkingFilter>;
  /** Some related `IntegrationFieldMarking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<IntegrationFieldMarkingFilter>;
};

/** A filter to be used against many `LatestMessage` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyLatestMessageFilter = {
  /** Every related `LatestMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LatestMessageFilter>;
  /** No related `LatestMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LatestMessageFilter>;
  /** Some related `LatestMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LatestMessageFilter>;
};

/** A filter to be used against many `LoggedActionNote` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyLoggedActionNoteFilter = {
  /** Every related `LoggedActionNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LoggedActionNoteFilter>;
  /** No related `LoggedActionNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LoggedActionNoteFilter>;
  /** Some related `LoggedActionNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LoggedActionNoteFilter>;
};

/** A filter to be used against many `LoginLog` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyLoginLogFilter = {
  /** Every related `LoginLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LoginLogFilter>;
  /** No related `LoginLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LoginLogFilter>;
  /** Some related `LoginLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LoginLogFilter>;
};

/** A filter to be used against many `Message` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyMessageFilter = {
  /** Every related `Message` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MessageFilter>;
  /** No related `Message` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MessageFilter>;
  /** Some related `Message` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MessageFilter>;
};

/** A filter to be used against many `NotificationCustomEmployeeFieldRecipient` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyNotificationCustomEmployeeFieldRecipientFilter = {
  /** Every related `NotificationCustomEmployeeFieldRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationCustomEmployeeFieldRecipientFilter>;
  /** No related `NotificationCustomEmployeeFieldRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationCustomEmployeeFieldRecipientFilter>;
  /** Some related `NotificationCustomEmployeeFieldRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationCustomEmployeeFieldRecipientFilter>;
};

/** A filter to be used against many `NotificationCustomRecipient` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyNotificationCustomRecipientFilter = {
  /** Every related `NotificationCustomRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationCustomRecipientFilter>;
  /** No related `NotificationCustomRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationCustomRecipientFilter>;
  /** Some related `NotificationCustomRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationCustomRecipientFilter>;
};

/** A filter to be used against many `NotificationEmployee` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyNotificationEmployeeFilter = {
  /** Every related `NotificationEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeFilter>;
  /** No related `NotificationEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeFilter>;
  /** Some related `NotificationEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeFilter>;
};

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

/** A filter to be used against many `NotificationGroupRecipient` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyNotificationGroupRecipientFilter = {
  /** Every related `NotificationGroupRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationGroupRecipientFilter>;
  /** No related `NotificationGroupRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationGroupRecipientFilter>;
  /** Some related `NotificationGroupRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationGroupRecipientFilter>;
};

/** A filter to be used against many `NotificationTypeChannelType` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyNotificationTypeChannelTypeFilter = {
  /** Every related `NotificationTypeChannelType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationTypeChannelTypeFilter>;
  /** No related `NotificationTypeChannelType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationTypeChannelTypeFilter>;
  /** Some related `NotificationTypeChannelType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationTypeChannelTypeFilter>;
};

/** A filter to be used against many `Post` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyPostFilter = {
  /** Every related `Post` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PostFilter>;
  /** No related `Post` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PostFilter>;
  /** Some related `Post` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PostFilter>;
};

/** A filter to be used against many `PostType` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyPostTypeFilter = {
  /** Every related `PostType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PostTypeFilter>;
  /** No related `PostType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PostTypeFilter>;
  /** Some related `PostType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PostTypeFilter>;
};

/** A filter to be used against many `PreboardingComment` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyPreboardingCommentFilter = {
  /** Every related `PreboardingComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingCommentFilter>;
  /** No related `PreboardingComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingCommentFilter>;
  /** Some related `PreboardingComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingCommentFilter>;
};

/** A filter to be used against many `PreboardingEmailLog` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyPreboardingEmailLogFilter = {
  /** Every related `PreboardingEmailLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingEmailLogFilter>;
  /** No related `PreboardingEmailLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingEmailLogFilter>;
  /** Some related `PreboardingEmailLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingEmailLogFilter>;
};

/** A filter to be used against many `PreboardingEmployee` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyPreboardingEmployeeFilter = {
  /** Every related `PreboardingEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingEmployeeFilter>;
  /** No related `PreboardingEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingEmployeeFilter>;
  /** Some related `PreboardingEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingEmployeeFilter>;
};

/** A filter to be used against many `Preboarding` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyPreboardingFilter = {
  /** Every related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingFilter>;
  /** No related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingFilter>;
  /** Some related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingFilter>;
};

/** A filter to be used against many `PreboardingProcess` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyPreboardingProcessFilter = {
  /** Every related `PreboardingProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingProcessFilter>;
  /** No related `PreboardingProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingProcessFilter>;
  /** Some related `PreboardingProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingProcessFilter>;
};

/** A filter to be used against many `PreboardingResult` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyPreboardingResultFilter = {
  /** Every related `PreboardingResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingResultFilter>;
  /** No related `PreboardingResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingResultFilter>;
  /** Some related `PreboardingResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingResultFilter>;
};

/** A filter to be used against many `PreboardingResultSlideComment` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyPreboardingResultSlideCommentFilter = {
  /** Every related `PreboardingResultSlideComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingResultSlideCommentFilter>;
  /** No related `PreboardingResultSlideComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingResultSlideCommentFilter>;
  /** Some related `PreboardingResultSlideComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingResultSlideCommentFilter>;
};

/** A filter to be used against many `PreboardingSlide` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyPreboardingSlideFilter = {
  /** Every related `PreboardingSlide` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingSlideFilter>;
  /** No related `PreboardingSlide` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingSlideFilter>;
  /** Some related `PreboardingSlide` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingSlideFilter>;
};

/** A filter to be used against many `PreboardingSlideFormField` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyPreboardingSlideFormFieldFilter = {
  /** Every related `PreboardingSlideFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingSlideFormFieldFilter>;
  /** No related `PreboardingSlideFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingSlideFormFieldFilter>;
  /** Some related `PreboardingSlideFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingSlideFormFieldFilter>;
};

/** A filter to be used against many `ProcessDepartment` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyProcessDepartmentFilter = {
  /** Every related `ProcessDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProcessDepartmentFilter>;
  /** No related `ProcessDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProcessDepartmentFilter>;
  /** Some related `ProcessDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProcessDepartmentFilter>;
};

/** A filter to be used against many `ProcessResponsible` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyProcessResponsibleFilter = {
  /** Every related `ProcessResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProcessResponsibleFilter>;
  /** No related `ProcessResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProcessResponsibleFilter>;
  /** Some related `ProcessResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProcessResponsibleFilter>;
};

/** A filter to be used against many `ProcessType` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyProcessTypeFilter = {
  /** Every related `ProcessType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProcessTypeFilter>;
  /** No related `ProcessType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProcessTypeFilter>;
  /** Some related `ProcessType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProcessTypeFilter>;
};

/** A filter to be used against many `Project` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyProjectFilter = {
  /** Every related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectFilter>;
  /** No related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectFilter>;
  /** Some related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectFilter>;
};

/** A filter to be used against many `ProjectTemplate` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyProjectTemplateFilter = {
  /** Every related `ProjectTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectTemplateFilter>;
  /** No related `ProjectTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectTemplateFilter>;
  /** Some related `ProjectTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectTemplateFilter>;
};

/** A filter to be used against many `PulseSurveyAnswer` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyPulseSurveyAnswerFilter = {
  /** Every related `PulseSurveyAnswer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PulseSurveyAnswerFilter>;
  /** No related `PulseSurveyAnswer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PulseSurveyAnswerFilter>;
  /** Some related `PulseSurveyAnswer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PulseSurveyAnswerFilter>;
};

/** A filter to be used against many `PulseSurveyChoice` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyPulseSurveyChoiceFilter = {
  /** Every related `PulseSurveyChoice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PulseSurveyChoiceFilter>;
  /** No related `PulseSurveyChoice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PulseSurveyChoiceFilter>;
  /** Some related `PulseSurveyChoice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PulseSurveyChoiceFilter>;
};

/** A filter to be used against many `PulseSurvey` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyPulseSurveyFilter = {
  /** Every related `PulseSurvey` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PulseSurveyFilter>;
  /** No related `PulseSurvey` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PulseSurveyFilter>;
  /** Some related `PulseSurvey` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PulseSurveyFilter>;
};

/** A filter to be used against many `PulseType` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyPulseTypeFilter = {
  /** Every related `PulseType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PulseTypeFilter>;
  /** No related `PulseType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PulseTypeFilter>;
  /** Some related `PulseType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PulseTypeFilter>;
};

/** A filter to be used against many `RecurrenceRule` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyRecurrenceRuleFilter = {
  /** Every related `RecurrenceRule` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RecurrenceRuleFilter>;
  /** No related `RecurrenceRule` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RecurrenceRuleFilter>;
  /** Some related `RecurrenceRule` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RecurrenceRuleFilter>;
};

/** A filter to be used against many `ReferenceToken` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyReferenceTokenFilter = {
  /** Every related `ReferenceToken` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ReferenceTokenFilter>;
  /** No related `ReferenceToken` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ReferenceTokenFilter>;
  /** Some related `ReferenceToken` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ReferenceTokenFilter>;
};

/** A filter to be used against many `RelationRole` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyRelationRoleFilter = {
  /** Every related `RelationRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RelationRoleFilter>;
  /** No related `RelationRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RelationRoleFilter>;
  /** Some related `RelationRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RelationRoleFilter>;
};

/** A filter to be used against many `ScheduledMessageExternalRecipient` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyScheduledMessageExternalRecipientFilter = {
  /** Every related `ScheduledMessageExternalRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageExternalRecipientFilter>;
  /** No related `ScheduledMessageExternalRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageExternalRecipientFilter>;
  /** Some related `ScheduledMessageExternalRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageExternalRecipientFilter>;
};

/** A filter to be used against many `ScheduledMessage` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyScheduledMessageFilter = {
  /** Every related `ScheduledMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageFilter>;
  /** No related `ScheduledMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageFilter>;
  /** Some related `ScheduledMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageFilter>;
};

/** A filter to be used against many `ScheduledMessageRecipient` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyScheduledMessageRecipientFilter = {
  /** Every related `ScheduledMessageRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageRecipientFilter>;
  /** No related `ScheduledMessageRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageRecipientFilter>;
  /** Some related `ScheduledMessageRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageRecipientFilter>;
};

/** A filter to be used against many `ScheduledMessageTemplateExternalRecipient` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyScheduledMessageTemplateExternalRecipientFilter = {
  /** Every related `ScheduledMessageTemplateExternalRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageTemplateExternalRecipientFilter>;
  /** No related `ScheduledMessageTemplateExternalRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageTemplateExternalRecipientFilter>;
  /** Some related `ScheduledMessageTemplateExternalRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageTemplateExternalRecipientFilter>;
};

/** A filter to be used against many `ScheduledMessageTemplate` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyScheduledMessageTemplateFilter = {
  /** Every related `ScheduledMessageTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageTemplateFilter>;
  /** No related `ScheduledMessageTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageTemplateFilter>;
  /** Some related `ScheduledMessageTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageTemplateFilter>;
};

/** A filter to be used against many `ScheduledMessageTemplateRecipient` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyScheduledMessageTemplateRecipientFilter = {
  /** Every related `ScheduledMessageTemplateRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageTemplateRecipientFilter>;
  /** No related `ScheduledMessageTemplateRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageTemplateRecipientFilter>;
  /** Some related `ScheduledMessageTemplateRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageTemplateRecipientFilter>;
};

/** A filter to be used against many `SuperUserAllowedUser` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManySuperUserAllowedUserFilter = {
  /** Every related `SuperUserAllowedUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SuperUserAllowedUserFilter>;
  /** No related `SuperUserAllowedUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SuperUserAllowedUserFilter>;
  /** Some related `SuperUserAllowedUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SuperUserAllowedUserFilter>;
};

/** A filter to be used against many `TaskEmployee` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyTaskEmployeeFilter = {
  /** Every related `TaskEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskEmployeeFilter>;
  /** No related `TaskEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskEmployeeFilter>;
  /** Some related `TaskEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskEmployeeFilter>;
};

/** A filter to be used against many `Task` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyTaskFilter = {
  /** Every related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskFilter>;
  /** No related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskFilter>;
  /** Some related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskFilter>;
};

/** A filter to be used against many `TaskResponsible` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyTaskResponsibleFilter = {
  /** Every related `TaskResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskResponsibleFilter>;
  /** No related `TaskResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskResponsibleFilter>;
  /** Some related `TaskResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskResponsibleFilter>;
};

/** A filter to be used against many `TaskTemplateEmployee` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyTaskTemplateEmployeeFilter = {
  /** Every related `TaskTemplateEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskTemplateEmployeeFilter>;
  /** No related `TaskTemplateEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskTemplateEmployeeFilter>;
  /** Some related `TaskTemplateEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskTemplateEmployeeFilter>;
};

/** A filter to be used against many `TaskTemplate` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyTaskTemplateFilter = {
  /** Every related `TaskTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskTemplateFilter>;
  /** No related `TaskTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskTemplateFilter>;
  /** Some related `TaskTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskTemplateFilter>;
};

/** A filter to be used against many `TaskTemplateResponsible` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyTaskTemplateResponsibleFilter = {
  /** Every related `TaskTemplateResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskTemplateResponsibleFilter>;
  /** No related `TaskTemplateResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskTemplateResponsibleFilter>;
  /** Some related `TaskTemplateResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskTemplateResponsibleFilter>;
};

/** A filter to be used against many `TimeRegistrationBreakType` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyTimeRegistrationBreakTypeFilter = {
  /** Every related `TimeRegistrationBreakType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationBreakTypeFilter>;
  /** No related `TimeRegistrationBreakType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationBreakTypeFilter>;
  /** Some related `TimeRegistrationBreakType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationBreakTypeFilter>;
};

/** A filter to be used against many `TimeRegistrationEntry` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyTimeRegistrationEntryFilter = {
  /** Every related `TimeRegistrationEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationEntryFilter>;
  /** No related `TimeRegistrationEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationEntryFilter>;
  /** Some related `TimeRegistrationEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationEntryFilter>;
};

/** A filter to be used against many `TimeRegistrationEntryTemplate` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyTimeRegistrationEntryTemplateFilter = {
  /** Every related `TimeRegistrationEntryTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  /** No related `TimeRegistrationEntryTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  /** Some related `TimeRegistrationEntryTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
};

/** A filter to be used against many `TimeRegistrationPresence` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyTimeRegistrationPresenceFilter = {
  /** Every related `TimeRegistrationPresence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationPresenceFilter>;
  /** No related `TimeRegistrationPresence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationPresenceFilter>;
  /** Some related `TimeRegistrationPresence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationPresenceFilter>;
};

/** A filter to be used against many `TimeRegistrationPresenceTemplate` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyTimeRegistrationPresenceTemplateFilter = {
  /** Every related `TimeRegistrationPresenceTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
  /** No related `TimeRegistrationPresenceTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
  /** Some related `TimeRegistrationPresenceTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
};

/** A filter to be used against many `TimeRegistrationPresenceType` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyTimeRegistrationPresenceTypeFilter = {
  /** Every related `TimeRegistrationPresenceType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationPresenceTypeFilter>;
  /** No related `TimeRegistrationPresenceType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationPresenceTypeFilter>;
  /** Some related `TimeRegistrationPresenceType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationPresenceTypeFilter>;
};

/** A filter to be used against many `TimeRegistrationProject` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyTimeRegistrationProjectFilter = {
  /** Every related `TimeRegistrationProject` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationProjectFilter>;
  /** No related `TimeRegistrationProject` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationProjectFilter>;
  /** Some related `TimeRegistrationProject` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationProjectFilter>;
};

/** A filter to be used against many `TimeRegistrationTemplate` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyTimeRegistrationTemplateFilter = {
  /** Every related `TimeRegistrationTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationTemplateFilter>;
  /** No related `TimeRegistrationTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationTemplateFilter>;
  /** Some related `TimeRegistrationTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationTemplateFilter>;
};

/** A filter to be used against many `TimeRegistrationTemplateWeek` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyTimeRegistrationTemplateWeekFilter = {
  /** Every related `TimeRegistrationTemplateWeek` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationTemplateWeekFilter>;
  /** No related `TimeRegistrationTemplateWeek` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationTemplateWeekFilter>;
  /** Some related `TimeRegistrationTemplateWeek` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationTemplateWeekFilter>;
};

/** A filter to be used against many `TranslatedEntity` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyTranslatedEntityFilter = {
  /** Every related `TranslatedEntity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TranslatedEntityFilter>;
  /** No related `TranslatedEntity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TranslatedEntityFilter>;
  /** Some related `TranslatedEntity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TranslatedEntityFilter>;
};

/** A filter to be used against many `TranslatedEntityLocalization` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyTranslatedEntityLocalizationFilter = {
  /** Every related `TranslatedEntityLocalization` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TranslatedEntityLocalizationFilter>;
  /** No related `TranslatedEntityLocalization` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TranslatedEntityLocalizationFilter>;
  /** Some related `TranslatedEntityLocalization` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TranslatedEntityLocalizationFilter>;
};

/** A filter to be used against many `Translation` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyTranslationFilter = {
  /** Every related `Translation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TranslationFilter>;
  /** No related `Translation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TranslationFilter>;
  /** Some related `Translation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TranslationFilter>;
};

/** A filter to be used against many `UserCompanyGroup` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyUserCompanyGroupFilter = {
  /** Every related `UserCompanyGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCompanyGroupFilter>;
  /** No related `UserCompanyGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCompanyGroupFilter>;
  /** Some related `UserCompanyGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCompanyGroupFilter>;
};

/** A filter to be used against many `UserCompanyRole` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyUserCompanyRoleFilter = {
  /** Every related `UserCompanyRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCompanyRoleFilter>;
  /** No related `UserCompanyRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCompanyRoleFilter>;
  /** Some related `UserCompanyRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCompanyRoleFilter>;
};

/** A filter to be used against many `UserCompetenceEvaluationComment` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyUserCompetenceEvaluationCommentFilter = {
  /** Every related `UserCompetenceEvaluationComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCompetenceEvaluationCommentFilter>;
  /** No related `UserCompetenceEvaluationComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCompetenceEvaluationCommentFilter>;
  /** Some related `UserCompetenceEvaluationComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCompetenceEvaluationCommentFilter>;
};

/** A filter to be used against many `UserCompetenceEvaluation` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyUserCompetenceEvaluationFilter = {
  /** Every related `UserCompetenceEvaluation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCompetenceEvaluationFilter>;
  /** No related `UserCompetenceEvaluation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCompetenceEvaluationFilter>;
  /** Some related `UserCompetenceEvaluation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCompetenceEvaluationFilter>;
};

/** A filter to be used against many `UserCompetence` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyUserCompetenceFilter = {
  /** Every related `UserCompetence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCompetenceFilter>;
  /** No related `UserCompetence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCompetenceFilter>;
  /** Some related `UserCompetence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCompetenceFilter>;
};

/** A filter to be used against many `UserDepartment` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyUserDepartmentFilter = {
  /** Every related `UserDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserDepartmentFilter>;
  /** No related `UserDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserDepartmentFilter>;
  /** Some related `UserDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserDepartmentFilter>;
};

/** A filter to be used against many `UserDepartmentGroup` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyUserDepartmentGroupFilter = {
  /** Every related `UserDepartmentGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserDepartmentGroupFilter>;
  /** No related `UserDepartmentGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserDepartmentGroupFilter>;
  /** Some related `UserDepartmentGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserDepartmentGroupFilter>;
};

/** A filter to be used against many `UserDepartmentRole` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyUserDepartmentRoleFilter = {
  /** Every related `UserDepartmentRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserDepartmentRoleFilter>;
  /** No related `UserDepartmentRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserDepartmentRoleFilter>;
  /** Some related `UserDepartmentRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserDepartmentRoleFilter>;
};

/** A filter to be used against many `User` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyUserFilter = {
  /** Every related `User` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserFilter>;
  /** No related `User` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserFilter>;
  /** Some related `User` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserFilter>;
};

/** A filter to be used against many `UserGroup` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyUserGroupFilter = {
  /** Every related `UserGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserGroupFilter>;
  /** No related `UserGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserGroupFilter>;
  /** Some related `UserGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserGroupFilter>;
};

/** A filter to be used against many `UserOnBehalfPermission` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyUserOnBehalfPermissionFilter = {
  /** Every related `UserOnBehalfPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserOnBehalfPermissionFilter>;
  /** No related `UserOnBehalfPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserOnBehalfPermissionFilter>;
  /** Some related `UserOnBehalfPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserOnBehalfPermissionFilter>;
};

/** A filter to be used against many `UserRole` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyUserRoleFilter = {
  /** Every related `UserRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserRoleFilter>;
  /** No related `UserRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserRoleFilter>;
  /** Some related `UserRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserRoleFilter>;
};

/** A filter to be used against many `UserSystemField` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyUserSystemFieldFilter = {
  /** Every related `UserSystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserSystemFieldFilter>;
  /** No related `UserSystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserSystemFieldFilter>;
  /** Some related `UserSystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserSystemFieldFilter>;
};

/** A filter to be used against many `VacationType` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyVacationTypeFilter = {
  /** Every related `VacationType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<VacationTypeFilter>;
  /** No related `VacationType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<VacationTypeFilter>;
  /** Some related `VacationType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<VacationTypeFilter>;
};

/** A filter to be used against many `VacationUser` object types. All fields are combined with a logical ‘and.’ */
export type CompanyToManyVacationUserFilter = {
  /** Every related `VacationUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<VacationUserFilter>;
  /** No related `VacationUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<VacationUserFilter>;
  /** Some related `VacationUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<VacationUserFilter>;
};

export type CompanyType = {
  __typename?: 'CompanyType';
  /** Reads and enables pagination through a set of `CompanyCompanyType`. */
  companyCompanyTypes: CompanyCompanyTypesConnection;
  disable2Fa: Scalars['Boolean'];
  id: Scalars['UUID'];
  name: Scalars['String'];
};


export type CompanyTypeCompanyCompanyTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyCompanyTypeCondition>;
  filter?: InputMaybe<CompanyCompanyTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyCompanyTypesOrderBy>>;
};

/** The fields on `companyType` to look up the row to connect. */
export type CompanyTypeCompanyTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `companyType` to look up the row to delete. */
export type CompanyTypeCompanyTypePkeyDelete = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `CompanyType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CompanyTypeCondition = {
  /** Checks for equality with the object’s `disable2Fa` field. */
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `CompanyType` object types. All fields are combined with a logical ‘and.’ */
export type CompanyTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompanyTypeFilter>>;
  /** Filter by the object’s `companyCompanyTypes` relation. */
  companyCompanyTypes?: InputMaybe<CompanyTypeToManyCompanyCompanyTypeFilter>;
  /** Some related `companyCompanyTypes` exist. */
  companyCompanyTypesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `disable2Fa` field. */
  disable2Fa?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompanyTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompanyTypeFilter>>;
};

/** An input for mutations affecting `CompanyType` */
export type CompanyTypeInput = {
  companyCompanyTypes?: InputMaybe<CompanyCompanyTypeCompanyTypeIdForeignInverseInput>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
};

/** The fields on `companyType` to look up the row to update. */
export type CompanyTypeOnCompanyCompanyTypeForCompanyCompanyTypeCompanyTypeIdForeignUsingCompanyTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `companyType` being updated. */
  patch: UpdateCompanyTypeOnCompanyCompanyTypeForCompanyCompanyTypeCompanyTypeIdForeignPatch;
};

/** Represents an update to a `CompanyType`. Fields that are set will be updated. */
export type CompanyTypePatch = {
  companyCompanyTypes?: InputMaybe<CompanyCompanyTypeCompanyTypeIdForeignInverseInput>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against many `CompanyCompanyType` object types. All fields are combined with a logical ‘and.’ */
export type CompanyTypeToManyCompanyCompanyTypeFilter = {
  /** Every related `CompanyCompanyType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompanyCompanyTypeFilter>;
  /** No related `CompanyCompanyType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompanyCompanyTypeFilter>;
  /** Some related `CompanyCompanyType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompanyCompanyTypeFilter>;
};

/** A connection to a list of `CompanyType` values. */
export type CompanyTypesConnection = {
  __typename?: 'CompanyTypesConnection';
  /** A list of edges which contains the `CompanyType` and cursor to aid in pagination. */
  edges: Array<CompanyTypesEdge>;
  /** A list of `CompanyType` objects. */
  nodes: Array<Maybe<CompanyType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CompanyType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CompanyType` edge in the connection. */
export type CompanyTypesEdge = {
  __typename?: 'CompanyTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompanyType` at the end of the edge. */
  node?: Maybe<CompanyType>;
};

/** Methods to use when ordering `CompanyType`. */
export type CompanyTypesOrderBy =
  | 'COMPANY_COMPANY_TYPES_BY_COMPANY_TYPE_ID__COUNT_ASC'
  | 'COMPANY_COMPANY_TYPES_BY_COMPANY_TYPE_ID__COUNT_DESC'
  | 'DISABLE_2FA_ASC'
  | 'DISABLE_2FA_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type Competence = {
  __typename?: 'Competence';
  active: Scalars['Boolean'];
  assigneeCount?: Maybe<Scalars['Int']>;
  /** Reads a single `Company` that is related to this `Competence`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `CompetenceFormField`. */
  competenceFormFields: CompetenceFormFieldsConnection;
  /** Reads a single `CompetenceGroup` that is related to this `Competence`. */
  competenceGroup?: Maybe<CompetenceGroup>;
  competenceGroupId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `CompetenceRequest`. */
  competenceRequests: CompetenceRequestsConnection;
  createdAt: Scalars['Datetime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  localizedDescription?: Maybe<Scalars['String']>;
  localizedName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferences: NotificationEmployeeReferencesConnection;
  onlyManagerShouldEvaluate: Scalars['Boolean'];
  outdateAt?: Maybe<Scalars['Datetime']>;
  outdateCompetence: Scalars['Boolean'];
  outdateInterval?: Maybe<Interval>;
  /** Reads a single `FormField` that is related to this `Competence`. */
  ratingFormField?: Maybe<FormField>;
  ratingFormFieldId?: Maybe<Scalars['UUID']>;
  reminderInterval: Interval;
  /** Reads and enables pagination through a set of `Storage`. */
  storages: StoragesConnection;
  updateReminder: Scalars['Boolean'];
  updatedAt: Scalars['Datetime'];
  useRating: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `UserCompetence`. */
  userCompetences: UserCompetencesConnection;
};


export type CompetenceCompetenceFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompetenceFormFieldCondition>;
  filter?: InputMaybe<CompetenceFormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetenceFormFieldsOrderBy>>;
};


export type CompetenceCompetenceRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompetenceRequestCondition>;
  filter?: InputMaybe<CompetenceRequestFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetenceRequestsOrderBy>>;
};


export type CompetenceNotificationEmployeeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};


export type CompetenceStoragesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CompetenceUserCompetencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompetenceCondition>;
  filter?: InputMaybe<UserCompetenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompetencesOrderBy>>;
};

/** The `competence` to be created by this mutation. */
export type CompetenceCompanyIdForeignConnectionCompetenceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceCompanyIdForeignInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInverseInput>;
  competenceGroup?: InputMaybe<CompetenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceRequests?: InputMaybe<CompetenceRequestCompetenceIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CompetenceRatingFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInverseInput>;
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
  outdateAt?: InputMaybe<Scalars['Datetime']>;
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  outdateInterval?: InputMaybe<IntervalInput>;
  ratingFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval: IntervalInput;
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useRating?: InputMaybe<Scalars['Boolean']>;
  userCompetences?: InputMaybe<UserCompetenceCompetenceIdForeignInverseInput>;
};

/** Input for the nested mutation of `company` in the `CompetenceInput` mutation. */
export type CompetenceCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnCompetenceForCompetenceCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `competence` in the `CompanyInput` mutation. */
export type CompetenceCompanyIdForeignInverseInput = {
  /** The primary key(s) for `competence` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompetenceCompetencePkeyConnect>>;
  /** A `CompetenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompetenceCompanyIdForeignConnectionCompetenceCreateInput>>;
  /** The primary key(s) and patch data for `competence` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompetenceOnCompetenceForCompetenceCompanyIdForeignUsingCompetencePkeyUpdate>>;
};

/** The `competence` to be created by this mutation. */
export type CompetenceCompetenceGroupIdForeignConnectionCompetenceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInverseInput>;
  competenceGroup?: InputMaybe<CompetenceCompetenceGroupIdForeignInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompetenceIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CompetenceRatingFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInverseInput>;
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
  outdateAt?: InputMaybe<Scalars['Datetime']>;
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  outdateInterval?: InputMaybe<IntervalInput>;
  ratingFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval: IntervalInput;
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useRating?: InputMaybe<Scalars['Boolean']>;
  userCompetences?: InputMaybe<UserCompetenceCompetenceIdForeignInverseInput>;
};

/** The `competenceGroup` to be created by this mutation. */
export type CompetenceCompetenceGroupIdForeignConnectionCompetenceGroupCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competences?: InputMaybe<CompetenceCompetenceGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInverseInput>;
};

/** Input for the nested mutation of `competenceGroup` in the `CompetenceInput` mutation. */
export type CompetenceCompetenceGroupIdForeignInput = {
  /** The primary key(s) for `competenceGroup` for the far side of the relationship. */
  connectById?: InputMaybe<CompetenceGroupCompetenceGroupPkeyConnect>;
  /** A `CompetenceGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompetenceCompetenceGroupIdForeignConnectionCompetenceGroupCreateInput>;
  /** The primary key(s) and patch data for `competenceGroup` for the far side of the relationship. */
  updateById?: InputMaybe<CompetenceGroupOnCompetenceForCompetenceCompetenceGroupIdForeignUsingCompetenceGroupPkeyUpdate>;
};

/** Input for the nested mutation of `competence` in the `CompetenceGroupInput` mutation. */
export type CompetenceCompetenceGroupIdForeignInverseInput = {
  /** The primary key(s) for `competence` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompetenceCompetencePkeyConnect>>;
  /** A `CompetenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompetenceCompetenceGroupIdForeignConnectionCompetenceCreateInput>>;
  /** The primary key(s) and patch data for `competence` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompetenceOnCompetenceForCompetenceCompetenceGroupIdForeignUsingCompetencePkeyUpdate>>;
};

/** The fields on `competence` to look up the row to connect. */
export type CompetenceCompetencePkeyConnect = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `Competence` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CompetenceCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `competenceGroupId` field. */
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `onlyManagerShouldEvaluate` field. */
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `outdateAt` field. */
  outdateAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `outdateCompetence` field. */
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `outdateInterval` field. */
  outdateInterval?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `ratingFormFieldId` field. */
  ratingFormFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `reminderInterval` field. */
  reminderInterval?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `updateReminder` field. */
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `useRating` field. */
  useRating?: InputMaybe<Scalars['Boolean']>;
};

/** A filter to be used against `Competence` object types. All fields are combined with a logical ‘and.’ */
export type CompetenceFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompetenceFilter>>;
  /** Filter by the object’s `assigneeCount` field. */
  assigneeCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `competenceFormFields` relation. */
  competenceFormFields?: InputMaybe<CompetenceToManyCompetenceFormFieldFilter>;
  /** Some related `competenceFormFields` exist. */
  competenceFormFieldsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `competenceGroup` relation. */
  competenceGroup?: InputMaybe<CompetenceGroupFilter>;
  /** Filter by the object’s `competenceGroupId` field. */
  competenceGroupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `competenceRequests` relation. */
  competenceRequests?: InputMaybe<CompetenceToManyCompetenceRequestFilter>;
  /** Some related `competenceRequests` exist. */
  competenceRequestsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedDescription` field. */
  localizedDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompetenceFilter>;
  /** Filter by the object’s `notificationEmployeeReferences` relation. */
  notificationEmployeeReferences?: InputMaybe<CompetenceToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferences` exist. */
  notificationEmployeeReferencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `onlyManagerShouldEvaluate` field. */
  onlyManagerShouldEvaluate?: InputMaybe<BooleanFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompetenceFilter>>;
  /** Filter by the object’s `outdateAt` field. */
  outdateAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `outdateCompetence` field. */
  outdateCompetence?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `outdateInterval` field. */
  outdateInterval?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `ratingFormField` relation. */
  ratingFormField?: InputMaybe<FormFieldFilter>;
  /** A related `ratingFormField` exists. */
  ratingFormFieldExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `ratingFormFieldId` field. */
  ratingFormFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `reminderInterval` field. */
  reminderInterval?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `updateReminder` field. */
  updateReminder?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `useRating` field. */
  useRating?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `userCompetences` relation. */
  userCompetences?: InputMaybe<CompetenceToManyUserCompetenceFilter>;
  /** Some related `userCompetences` exist. */
  userCompetencesExist?: InputMaybe<Scalars['Boolean']>;
};

export type CompetenceFormField = {
  __typename?: 'CompetenceFormField';
  /** Reads a single `Company` that is related to this `CompetenceFormField`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `Competence` that is related to this `CompetenceFormField`. */
  competence?: Maybe<Competence>;
  competenceId: Scalars['UUID'];
  /** Reads a single `FormField` that is related to this `CompetenceFormField`. */
  formField?: Maybe<FormField>;
  formFieldId: Scalars['UUID'];
  id: Scalars['UUID'];
};

/** The `competenceFormField` to be created by this mutation. */
export type CompetenceFormFieldCompanyIdForeignConnectionCompetenceFormFieldCreateInput = {
  company?: InputMaybe<CompetenceFormFieldCompanyIdForeignInput>;
  competence?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `CompetenceFormFieldInput` mutation. */
export type CompetenceFormFieldCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnCompetenceFormFieldForCompetenceFormFieldCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `competenceFormField` in the `CompanyInput` mutation. */
export type CompetenceFormFieldCompanyIdForeignInverseInput = {
  /** The primary key(s) for `competenceFormField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompetenceFormFieldCompetenceFormFieldPkeyConnect>>;
  /** A `CompetenceFormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompetenceFormFieldCompanyIdForeignConnectionCompetenceFormFieldCreateInput>>;
  /** The primary key(s) for `competenceFormField` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompetenceFormFieldCompetenceFormFieldPkeyDelete>>;
  /** Flag indicating whether all other `competenceFormField` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `competenceFormField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompetenceFormFieldOnCompetenceFormFieldForCompetenceFormFieldCompanyIdForeignUsingCompetenceFormFieldPkeyUpdate>>;
};

/** The fields on `competenceFormField` to look up the row to connect. */
export type CompetenceFormFieldCompetenceFormFieldPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `competenceFormField` to look up the row to delete. */
export type CompetenceFormFieldCompetenceFormFieldPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `competence` to be created by this mutation. */
export type CompetenceFormFieldCompetenceIdForeignConnectionCompetenceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInverseInput>;
  competenceGroup?: InputMaybe<CompetenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceRequests?: InputMaybe<CompetenceRequestCompetenceIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CompetenceRatingFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInverseInput>;
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
  outdateAt?: InputMaybe<Scalars['Datetime']>;
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  outdateInterval?: InputMaybe<IntervalInput>;
  ratingFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval: IntervalInput;
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useRating?: InputMaybe<Scalars['Boolean']>;
  userCompetences?: InputMaybe<UserCompetenceCompetenceIdForeignInverseInput>;
};

/** The `competenceFormField` to be created by this mutation. */
export type CompetenceFormFieldCompetenceIdForeignConnectionCompetenceFormFieldCreateInput = {
  company?: InputMaybe<CompetenceFormFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInput>;
  formField?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `competence` in the `CompetenceFormFieldInput` mutation. */
export type CompetenceFormFieldCompetenceIdForeignInput = {
  /** The primary key(s) for `competence` for the far side of the relationship. */
  connectById?: InputMaybe<CompetenceCompetencePkeyConnect>;
  /** A `CompetenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompetenceFormFieldCompetenceIdForeignConnectionCompetenceCreateInput>;
  /** The primary key(s) and patch data for `competence` for the far side of the relationship. */
  updateById?: InputMaybe<CompetenceOnCompetenceFormFieldForCompetenceFormFieldCompetenceIdForeignUsingCompetencePkeyUpdate>;
};

/** Input for the nested mutation of `competenceFormField` in the `CompetenceInput` mutation. */
export type CompetenceFormFieldCompetenceIdForeignInverseInput = {
  /** The primary key(s) for `competenceFormField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompetenceFormFieldCompetenceFormFieldPkeyConnect>>;
  /** A `CompetenceFormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompetenceFormFieldCompetenceIdForeignConnectionCompetenceFormFieldCreateInput>>;
  /** The primary key(s) for `competenceFormField` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompetenceFormFieldCompetenceFormFieldPkeyDelete>>;
  /** Flag indicating whether all other `competenceFormField` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `competenceFormField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompetenceFormFieldOnCompetenceFormFieldForCompetenceFormFieldCompetenceIdForeignUsingCompetenceFormFieldPkeyUpdate>>;
};

/**
 * A condition to be used against `CompetenceFormField` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CompetenceFormFieldCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `competenceId` field. */
  competenceId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `CompetenceFormField` object types. All fields are combined with a logical ‘and.’ */
export type CompetenceFormFieldFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompetenceFormFieldFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `competence` relation. */
  competence?: InputMaybe<CompetenceFilter>;
  /** Filter by the object’s `competenceId` field. */
  competenceId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `formField` relation. */
  formField?: InputMaybe<FormFieldFilter>;
  /** Filter by the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompetenceFormFieldFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompetenceFormFieldFilter>>;
};

/** The `competenceFormField` to be created by this mutation. */
export type CompetenceFormFieldFormFieldIdForeignConnectionCompetenceFormFieldCreateInput = {
  company?: InputMaybe<CompetenceFormFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** The `formField` to be created by this mutation. */
export type CompetenceFormFieldFormFieldIdForeignConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `formField` in the `CompetenceFormFieldInput` mutation. */
export type CompetenceFormFieldFormFieldIdForeignInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<FormFieldFormFieldPkeyConnect>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompetenceFormFieldFormFieldIdForeignConnectionFormFieldCreateInput>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<FormFieldOnCompetenceFormFieldForCompetenceFormFieldFormFieldIdForeignUsingFormFieldPkeyUpdate>;
};

/** Input for the nested mutation of `competenceFormField` in the `FormFieldInput` mutation. */
export type CompetenceFormFieldFormFieldIdForeignInverseInput = {
  /** The primary key(s) for `competenceFormField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompetenceFormFieldCompetenceFormFieldPkeyConnect>>;
  /** A `CompetenceFormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompetenceFormFieldFormFieldIdForeignConnectionCompetenceFormFieldCreateInput>>;
  /** The primary key(s) for `competenceFormField` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CompetenceFormFieldCompetenceFormFieldPkeyDelete>>;
  /** Flag indicating whether all other `competenceFormField` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `competenceFormField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompetenceFormFieldOnCompetenceFormFieldForCompetenceFormFieldFormFieldIdForeignUsingCompetenceFormFieldPkeyUpdate>>;
};

/** An input for mutations affecting `CompetenceFormField` */
export type CompetenceFormFieldInput = {
  company?: InputMaybe<CompetenceFormFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `competenceFormField` to look up the row to update. */
export type CompetenceFormFieldOnCompetenceFormFieldForCompetenceFormFieldCompanyIdForeignUsingCompetenceFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `competenceFormField` being updated. */
  patch: UpdateCompetenceFormFieldOnCompetenceFormFieldForCompetenceFormFieldCompanyIdForeignPatch;
};

/** The fields on `competenceFormField` to look up the row to update. */
export type CompetenceFormFieldOnCompetenceFormFieldForCompetenceFormFieldCompetenceIdForeignUsingCompetenceFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `competenceFormField` being updated. */
  patch: UpdateCompetenceFormFieldOnCompetenceFormFieldForCompetenceFormFieldCompetenceIdForeignPatch;
};

/** The fields on `competenceFormField` to look up the row to update. */
export type CompetenceFormFieldOnCompetenceFormFieldForCompetenceFormFieldFormFieldIdForeignUsingCompetenceFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `competenceFormField` being updated. */
  patch: UpdateCompetenceFormFieldOnCompetenceFormFieldForCompetenceFormFieldFormFieldIdForeignPatch;
};

/** Represents an update to a `CompetenceFormField`. Fields that are set will be updated. */
export type CompetenceFormFieldPatch = {
  company?: InputMaybe<CompetenceFormFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `CompetenceFormField` values. */
export type CompetenceFormFieldsConnection = {
  __typename?: 'CompetenceFormFieldsConnection';
  /** A list of edges which contains the `CompetenceFormField` and cursor to aid in pagination. */
  edges: Array<CompetenceFormFieldsEdge>;
  /** A list of `CompetenceFormField` objects. */
  nodes: Array<Maybe<CompetenceFormField>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CompetenceFormField` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CompetenceFormField` edge in the connection. */
export type CompetenceFormFieldsEdge = {
  __typename?: 'CompetenceFormFieldsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompetenceFormField` at the end of the edge. */
  node?: Maybe<CompetenceFormField>;
};

/** Methods to use when ordering `CompetenceFormField`. */
export type CompetenceFormFieldsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ACTIVE_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ACTIVE_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__COMPANY_ID_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__COMPANY_ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__COMPETENCE_GROUP_ID_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__COMPETENCE_GROUP_ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__CREATED_AT_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__CREATED_AT_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__DESCRIPTION_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__DESCRIPTION_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ID_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__LOCALIZED_NAME_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__LOCALIZED_NAME_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__NAME_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__NAME_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ONLY_MANAGER_SHOULD_EVALUATE_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ONLY_MANAGER_SHOULD_EVALUATE_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_AT_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_AT_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_COMPETENCE_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_COMPETENCE_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_INTERVAL_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_INTERVAL_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__RATING_FORM_FIELD_ID_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__RATING_FORM_FIELD_ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__REMINDER_INTERVAL_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__REMINDER_INTERVAL_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__UPDATED_AT_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__UPDATED_AT_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__UPDATE_REMINDER_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__UPDATE_REMINDER_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__USE_RATING_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__USE_RATING_DESC'
  | 'COMPETENCE_ID_ASC'
  | 'COMPETENCE_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_DESC'
  | 'FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type CompetenceGroup = {
  __typename?: 'CompetenceGroup';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `CompetenceGroup`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `Competence`. */
  competences: CompetencesConnection;
  id: Scalars['UUID'];
  localizedName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferences: NotificationEmployeeReferencesConnection;
};


export type CompetenceGroupCompetencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompetenceCondition>;
  filter?: InputMaybe<CompetenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetencesOrderBy>>;
};


export type CompetenceGroupNotificationEmployeeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};

/** The `competenceGroup` to be created by this mutation. */
export type CompetenceGroupCompanyIdForeignConnectionCompetenceGroupCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceGroupCompanyIdForeignInput>;
  competences?: InputMaybe<CompetenceCompetenceGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInverseInput>;
};

/** Input for the nested mutation of `company` in the `CompetenceGroupInput` mutation. */
export type CompetenceGroupCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnCompetenceGroupForCompetenceGroupCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `competenceGroup` in the `CompanyInput` mutation. */
export type CompetenceGroupCompanyIdForeignInverseInput = {
  /** The primary key(s) for `competenceGroup` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompetenceGroupCompetenceGroupPkeyConnect>>;
  /** A `CompetenceGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompetenceGroupCompanyIdForeignConnectionCompetenceGroupCreateInput>>;
  /** The primary key(s) and patch data for `competenceGroup` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompetenceGroupOnCompetenceGroupForCompetenceGroupCompanyIdForeignUsingCompetenceGroupPkeyUpdate>>;
};

/** The fields on `competenceGroup` to look up the row to connect. */
export type CompetenceGroupCompetenceGroupPkeyConnect = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `CompetenceGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CompetenceGroupCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `CompetenceGroup` object types. All fields are combined with a logical ‘and.’ */
export type CompetenceGroupFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompetenceGroupFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `competences` relation. */
  competences?: InputMaybe<CompetenceGroupToManyCompetenceFilter>;
  /** Some related `competences` exist. */
  competencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompetenceGroupFilter>;
  /** Filter by the object’s `notificationEmployeeReferences` relation. */
  notificationEmployeeReferences?: InputMaybe<CompetenceGroupToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferences` exist. */
  notificationEmployeeReferencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompetenceGroupFilter>>;
};

/** An input for mutations affecting `CompetenceGroup` */
export type CompetenceGroupInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competences?: InputMaybe<CompetenceCompetenceGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInverseInput>;
};

/** The fields on `competenceGroup` to look up the row to update. */
export type CompetenceGroupOnCompetenceForCompetenceCompetenceGroupIdForeignUsingCompetenceGroupPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `competenceGroup` being updated. */
  patch: UpdateCompetenceGroupOnCompetenceForCompetenceCompetenceGroupIdForeignPatch;
};

/** The fields on `competenceGroup` to look up the row to update. */
export type CompetenceGroupOnCompetenceGroupForCompetenceGroupCompanyIdForeignUsingCompetenceGroupPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `competenceGroup` being updated. */
  patch: UpdateCompetenceGroupOnCompetenceGroupForCompetenceGroupCompanyIdForeignPatch;
};

/** The fields on `competenceGroup` to look up the row to update. */
export type CompetenceGroupOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompetenceGroupIdForeignUsingCompetenceGroupPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `competenceGroup` being updated. */
  patch: UpdateCompetenceGroupOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompetenceGroupIdForeignPatch;
};

/** Represents an update to a `CompetenceGroup`. Fields that are set will be updated. */
export type CompetenceGroupPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competences?: InputMaybe<CompetenceCompetenceGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInverseInput>;
};

/** A filter to be used against many `Competence` object types. All fields are combined with a logical ‘and.’ */
export type CompetenceGroupToManyCompetenceFilter = {
  /** Every related `Competence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompetenceFilter>;
  /** No related `Competence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompetenceFilter>;
  /** Some related `Competence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompetenceFilter>;
};

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type CompetenceGroupToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

/** A connection to a list of `CompetenceGroup` values. */
export type CompetenceGroupsConnection = {
  __typename?: 'CompetenceGroupsConnection';
  /** A list of edges which contains the `CompetenceGroup` and cursor to aid in pagination. */
  edges: Array<CompetenceGroupsEdge>;
  /** A list of `CompetenceGroup` objects. */
  nodes: Array<Maybe<CompetenceGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CompetenceGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CompetenceGroup` edge in the connection. */
export type CompetenceGroupsEdge = {
  __typename?: 'CompetenceGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompetenceGroup` at the end of the edge. */
  node?: Maybe<CompetenceGroup>;
};

/** Methods to use when ordering `CompetenceGroup`. */
export type CompetenceGroupsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPETENCES_BY_COMPETENCE_GROUP_ID__COUNT_ASC'
  | 'COMPETENCES_BY_COMPETENCE_GROUP_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALIZED_NAME_ASC'
  | 'LOCALIZED_NAME_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_COMPETENCE_GROUP_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_COMPETENCE_GROUP_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/** An input for mutations affecting `Competence` */
export type CompetenceInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInverseInput>;
  competenceGroup?: InputMaybe<CompetenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceRequests?: InputMaybe<CompetenceRequestCompetenceIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CompetenceRatingFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInverseInput>;
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
  outdateAt?: InputMaybe<Scalars['Datetime']>;
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  outdateInterval?: InputMaybe<IntervalInput>;
  ratingFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval: IntervalInput;
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useRating?: InputMaybe<Scalars['Boolean']>;
  userCompetences?: InputMaybe<UserCompetenceCompetenceIdForeignInverseInput>;
};

/** The fields on `competence` to look up the row to update. */
export type CompetenceOnCompetenceForCompetenceCompanyIdForeignUsingCompetencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `competence` being updated. */
  patch: UpdateCompetenceOnCompetenceForCompetenceCompanyIdForeignPatch;
};

/** The fields on `competence` to look up the row to update. */
export type CompetenceOnCompetenceForCompetenceCompetenceGroupIdForeignUsingCompetencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `competence` being updated. */
  patch: UpdateCompetenceOnCompetenceForCompetenceCompetenceGroupIdForeignPatch;
};

/** The fields on `competence` to look up the row to update. */
export type CompetenceOnCompetenceForCompetenceRatingFormFieldIdForeignUsingCompetencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `competence` being updated. */
  patch: UpdateCompetenceOnCompetenceForCompetenceRatingFormFieldIdForeignPatch;
};

/** The fields on `competence` to look up the row to update. */
export type CompetenceOnCompetenceFormFieldForCompetenceFormFieldCompetenceIdForeignUsingCompetencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `competence` being updated. */
  patch: UpdateCompetenceOnCompetenceFormFieldForCompetenceFormFieldCompetenceIdForeignPatch;
};

/** The fields on `competence` to look up the row to update. */
export type CompetenceOnCompetenceRequestForCompetenceRequestCompetenceIdForeignUsingCompetencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `competence` being updated. */
  patch: UpdateCompetenceOnCompetenceRequestForCompetenceRequestCompetenceIdForeignPatch;
};

/** The fields on `competence` to look up the row to update. */
export type CompetenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompetenceIdForeignUsingCompetencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `competence` being updated. */
  patch: UpdateCompetenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompetenceIdForeignPatch;
};

/** The fields on `competence` to look up the row to update. */
export type CompetenceOnUserCompetenceForUserCompetenceCompetenceIdForeignUsingCompetencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `competence` being updated. */
  patch: UpdateCompetenceOnUserCompetenceForUserCompetenceCompetenceIdForeignPatch;
};

/** Represents an update to a `Competence`. Fields that are set will be updated. */
export type CompetencePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInverseInput>;
  competenceGroup?: InputMaybe<CompetenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceRequests?: InputMaybe<CompetenceRequestCompetenceIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CompetenceRatingFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInverseInput>;
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
  outdateAt?: InputMaybe<Scalars['Datetime']>;
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  outdateInterval?: InputMaybe<IntervalInput>;
  ratingFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<IntervalInput>;
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useRating?: InputMaybe<Scalars['Boolean']>;
  userCompetences?: InputMaybe<UserCompetenceCompetenceIdForeignInverseInput>;
};

/** The `competence` to be created by this mutation. */
export type CompetenceRatingFormFieldIdForeignConnectionCompetenceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInverseInput>;
  competenceGroup?: InputMaybe<CompetenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceRequests?: InputMaybe<CompetenceRequestCompetenceIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CompetenceRatingFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInverseInput>;
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
  outdateAt?: InputMaybe<Scalars['Datetime']>;
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  outdateInterval?: InputMaybe<IntervalInput>;
  reminderInterval: IntervalInput;
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useRating?: InputMaybe<Scalars['Boolean']>;
  userCompetences?: InputMaybe<UserCompetenceCompetenceIdForeignInverseInput>;
};

/** The `formField` to be created by this mutation. */
export type CompetenceRatingFormFieldIdForeignConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `formField` in the `CompetenceInput` mutation. */
export type CompetenceRatingFormFieldIdForeignInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<FormFieldFormFieldPkeyConnect>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompetenceRatingFormFieldIdForeignConnectionFormFieldCreateInput>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<FormFieldOnCompetenceForCompetenceRatingFormFieldIdForeignUsingFormFieldPkeyUpdate>;
};

/** Input for the nested mutation of `competence` in the `FormFieldInput` mutation. */
export type CompetenceRatingFormFieldIdForeignInverseInput = {
  /** The primary key(s) for `competence` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompetenceCompetencePkeyConnect>>;
  /** A `CompetenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompetenceRatingFormFieldIdForeignConnectionCompetenceCreateInput>>;
  /** The primary key(s) and patch data for `competence` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompetenceOnCompetenceForCompetenceRatingFormFieldIdForeignUsingCompetencePkeyUpdate>>;
};

export type CompetenceRequest = {
  __typename?: 'CompetenceRequest';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `CompetenceRequest`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `Competence` that is related to this `CompetenceRequest`. */
  competence?: Maybe<Competence>;
  competenceId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
};

/** The `competenceRequest` to be created by this mutation. */
export type CompetenceRequestCompanyIdForeignConnectionCompetenceRequestCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceRequestCompanyIdForeignInput>;
  competence?: InputMaybe<CompetenceRequestCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `CompetenceRequestInput` mutation. */
export type CompetenceRequestCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnCompetenceRequestForCompetenceRequestCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `competenceRequest` in the `CompanyInput` mutation. */
export type CompetenceRequestCompanyIdForeignInverseInput = {
  /** The primary key(s) for `competenceRequest` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompetenceRequestCompetenceRequestPkeyConnect>>;
  /** A `CompetenceRequestInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompetenceRequestCompanyIdForeignConnectionCompetenceRequestCreateInput>>;
  /** The primary key(s) and patch data for `competenceRequest` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompetenceRequestOnCompetenceRequestForCompetenceRequestCompanyIdForeignUsingCompetenceRequestPkeyUpdate>>;
};

/** The `competence` to be created by this mutation. */
export type CompetenceRequestCompetenceIdForeignConnectionCompetenceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInverseInput>;
  competenceGroup?: InputMaybe<CompetenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceRequests?: InputMaybe<CompetenceRequestCompetenceIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CompetenceRatingFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInverseInput>;
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
  outdateAt?: InputMaybe<Scalars['Datetime']>;
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  outdateInterval?: InputMaybe<IntervalInput>;
  ratingFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval: IntervalInput;
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useRating?: InputMaybe<Scalars['Boolean']>;
  userCompetences?: InputMaybe<UserCompetenceCompetenceIdForeignInverseInput>;
};

/** The `competenceRequest` to be created by this mutation. */
export type CompetenceRequestCompetenceIdForeignConnectionCompetenceRequestCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceRequestCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<CompetenceRequestCompetenceIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `competence` in the `CompetenceRequestInput` mutation. */
export type CompetenceRequestCompetenceIdForeignInput = {
  /** The primary key(s) for `competence` for the far side of the relationship. */
  connectById?: InputMaybe<CompetenceCompetencePkeyConnect>;
  /** A `CompetenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<CompetenceRequestCompetenceIdForeignConnectionCompetenceCreateInput>;
  /** The primary key(s) and patch data for `competence` for the far side of the relationship. */
  updateById?: InputMaybe<CompetenceOnCompetenceRequestForCompetenceRequestCompetenceIdForeignUsingCompetencePkeyUpdate>;
};

/** Input for the nested mutation of `competenceRequest` in the `CompetenceInput` mutation. */
export type CompetenceRequestCompetenceIdForeignInverseInput = {
  /** The primary key(s) for `competenceRequest` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CompetenceRequestCompetenceRequestPkeyConnect>>;
  /** A `CompetenceRequestInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CompetenceRequestCompetenceIdForeignConnectionCompetenceRequestCreateInput>>;
  /** The primary key(s) and patch data for `competenceRequest` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CompetenceRequestOnCompetenceRequestForCompetenceRequestCompetenceIdForeignUsingCompetenceRequestPkeyUpdate>>;
};

/** The fields on `competenceRequest` to look up the row to connect. */
export type CompetenceRequestCompetenceRequestPkeyConnect = {
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `CompetenceRequest` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CompetenceRequestCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `competenceId` field. */
  competenceId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `CompetenceRequest` object types. All fields are combined with a logical ‘and.’ */
export type CompetenceRequestFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CompetenceRequestFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `competence` relation. */
  competence?: InputMaybe<CompetenceFilter>;
  /** Filter by the object’s `competenceId` field. */
  competenceId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CompetenceRequestFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CompetenceRequestFilter>>;
};

/** An input for mutations affecting `CompetenceRequest` */
export type CompetenceRequestInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceRequestCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<CompetenceRequestCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `competenceRequest` to look up the row to update. */
export type CompetenceRequestOnCompetenceRequestForCompetenceRequestCompanyIdForeignUsingCompetenceRequestPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `competenceRequest` being updated. */
  patch: UpdateCompetenceRequestOnCompetenceRequestForCompetenceRequestCompanyIdForeignPatch;
};

/** The fields on `competenceRequest` to look up the row to update. */
export type CompetenceRequestOnCompetenceRequestForCompetenceRequestCompetenceIdForeignUsingCompetenceRequestPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `competenceRequest` being updated. */
  patch: UpdateCompetenceRequestOnCompetenceRequestForCompetenceRequestCompetenceIdForeignPatch;
};

/** Represents an update to a `CompetenceRequest`. Fields that are set will be updated. */
export type CompetenceRequestPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceRequestCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<CompetenceRequestCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `CompetenceRequest` values. */
export type CompetenceRequestsConnection = {
  __typename?: 'CompetenceRequestsConnection';
  /** A list of edges which contains the `CompetenceRequest` and cursor to aid in pagination. */
  edges: Array<CompetenceRequestsEdge>;
  /** A list of `CompetenceRequest` objects. */
  nodes: Array<Maybe<CompetenceRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CompetenceRequest` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CompetenceRequest` edge in the connection. */
export type CompetenceRequestsEdge = {
  __typename?: 'CompetenceRequestsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CompetenceRequest` at the end of the edge. */
  node?: Maybe<CompetenceRequest>;
};

/** Methods to use when ordering `CompetenceRequest`. */
export type CompetenceRequestsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ACTIVE_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ACTIVE_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__COMPANY_ID_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__COMPANY_ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__COMPETENCE_GROUP_ID_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__COMPETENCE_GROUP_ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__CREATED_AT_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__CREATED_AT_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__DESCRIPTION_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__DESCRIPTION_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ID_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__LOCALIZED_NAME_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__LOCALIZED_NAME_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__NAME_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__NAME_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ONLY_MANAGER_SHOULD_EVALUATE_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ONLY_MANAGER_SHOULD_EVALUATE_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_AT_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_AT_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_COMPETENCE_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_COMPETENCE_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_INTERVAL_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_INTERVAL_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__RATING_FORM_FIELD_ID_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__RATING_FORM_FIELD_ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__REMINDER_INTERVAL_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__REMINDER_INTERVAL_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__UPDATED_AT_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__UPDATED_AT_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__UPDATE_REMINDER_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__UPDATE_REMINDER_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__USE_RATING_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__USE_RATING_DESC'
  | 'COMPETENCE_ID_ASC'
  | 'COMPETENCE_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/** A filter to be used against many `CompetenceFormField` object types. All fields are combined with a logical ‘and.’ */
export type CompetenceToManyCompetenceFormFieldFilter = {
  /** Every related `CompetenceFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompetenceFormFieldFilter>;
  /** No related `CompetenceFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompetenceFormFieldFilter>;
  /** Some related `CompetenceFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompetenceFormFieldFilter>;
};

/** A filter to be used against many `CompetenceRequest` object types. All fields are combined with a logical ‘and.’ */
export type CompetenceToManyCompetenceRequestFilter = {
  /** Every related `CompetenceRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompetenceRequestFilter>;
  /** No related `CompetenceRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompetenceRequestFilter>;
  /** Some related `CompetenceRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompetenceRequestFilter>;
};

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type CompetenceToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

/** A filter to be used against many `UserCompetence` object types. All fields are combined with a logical ‘and.’ */
export type CompetenceToManyUserCompetenceFilter = {
  /** Every related `UserCompetence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCompetenceFilter>;
  /** No related `UserCompetence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCompetenceFilter>;
  /** Some related `UserCompetence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCompetenceFilter>;
};

/** A connection to a list of `Competence` values. */
export type CompetencesConnection = {
  __typename?: 'CompetencesConnection';
  /** A list of edges which contains the `Competence` and cursor to aid in pagination. */
  edges: Array<CompetencesEdge>;
  /** A list of `Competence` objects. */
  nodes: Array<Maybe<Competence>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Competence` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Competence` edge in the connection. */
export type CompetencesEdge = {
  __typename?: 'CompetencesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Competence` at the end of the edge. */
  node?: Maybe<Competence>;
};

/** Methods to use when ordering `Competence`. */
export type CompetencesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPETENCE_FORM_FIELDS_BY_COMPETENCE_ID__COUNT_ASC'
  | 'COMPETENCE_FORM_FIELDS_BY_COMPETENCE_ID__COUNT_DESC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__ACTIVE_ASC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__ACTIVE_DESC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__COMPANY_ID_ASC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__COMPANY_ID_DESC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__ID_ASC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__ID_DESC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__LOCALIZED_NAME_ASC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__LOCALIZED_NAME_DESC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__NAME_ASC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__NAME_DESC'
  | 'COMPETENCE_GROUP_ID_ASC'
  | 'COMPETENCE_GROUP_ID_DESC'
  | 'COMPETENCE_REQUESTS_BY_COMPETENCE_ID__COUNT_ASC'
  | 'COMPETENCE_REQUESTS_BY_COMPETENCE_ID__COUNT_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__ACTIVE_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__ACTIVE_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__APPROVER_GROUP_IDS_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__APPROVER_GROUP_IDS_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__APPROVER_USER_IDS_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__APPROVER_USER_IDS_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__CARD_ORDER_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__CARD_ORDER_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__COMPANY_ID_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__COMPANY_ID_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__CREATED_AT_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__CREATED_AT_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__CUSTOM_ID_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__CUSTOM_ID_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__DEFAULT_VALUE_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__DEFAULT_VALUE_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__DEPARTMENTS_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__DEPARTMENTS_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__EVENT_ID_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__EVENT_ID_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__FIELD_GROUP_ID_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__FIELD_GROUP_ID_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__FIELD_TYPE_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__FIELD_TYPE_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__HELP_TEXT_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__HELP_TEXT_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__ID_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__ID_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__LOCALIZED_NAME_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__LOCALIZED_NAME_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__METADATA_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__METADATA_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__MULTIPLE_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__MULTIPLE_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__NAME_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__NAME_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__OBJECT_TYPE_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__OBJECT_TYPE_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__ORDER_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__ORDER_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__PRODUCT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__PRODUCT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__REQUIRED_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__REQUIRED_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__SENSITIVE_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__SENSITIVE_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__UNIQUE_VALUE_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__UNIQUE_VALUE_DESC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__UPDATED_AT_ASC'
  | 'FORM_FIELD_BY_RATING_FORM_FIELD_ID__UPDATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALIZED_NAME_ASC'
  | 'LOCALIZED_NAME_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_COMPETENCE_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_COMPETENCE_ID__COUNT_DESC'
  | 'ONLY_MANAGER_SHOULD_EVALUATE_ASC'
  | 'ONLY_MANAGER_SHOULD_EVALUATE_DESC'
  | 'OUTDATE_AT_ASC'
  | 'OUTDATE_AT_DESC'
  | 'OUTDATE_COMPETENCE_ASC'
  | 'OUTDATE_COMPETENCE_DESC'
  | 'OUTDATE_INTERVAL_ASC'
  | 'OUTDATE_INTERVAL_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RATING_FORM_FIELD_ID_ASC'
  | 'RATING_FORM_FIELD_ID_DESC'
  | 'REMINDER_INTERVAL_ASC'
  | 'REMINDER_INTERVAL_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'UPDATE_REMINDER_ASC'
  | 'UPDATE_REMINDER_DESC'
  | 'USER_COMPETENCES_BY_COMPETENCE_ID__COUNT_ASC'
  | 'USER_COMPETENCES_BY_COMPETENCE_ID__COUNT_DESC'
  | 'USE_RATING_ASC'
  | 'USE_RATING_DESC';

export type CompetencesSearchInput = {
  page: Scalars['Int'];
  searchQuery: Scalars['String'];
};

export type CompetencesSearchPayload = {
  __typename?: 'CompetencesSearchPayload';
  results?: Maybe<Array<Maybe<EscoSearchResult>>>;
  totalCount?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

/** All input for the `completeTask` mutation. */
export type CompleteTaskInput = {
  argTaskId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `completeTask` mutation. */
export type CompleteTaskPayload = {
  __typename?: 'CompleteTaskPayload';
  /** Reads a single `User` that is related to this `Task`. */
  assignedProcessUser?: Maybe<User>;
  /** Reads a single `User` that is related to this `Task`. */
  calendarEventOrganizer?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Task`. */
  company?: Maybe<Company>;
  /** Reads a single `Task` that is related to this `Task`. */
  parentTask?: Maybe<Task>;
  /** Reads a single `Process` that is related to this `Task`. */
  process?: Maybe<Process>;
  /** Reads a single `ProcessType` that is related to this `Task`. */
  processType?: Maybe<ProcessType>;
  /** Reads a single `Project` that is related to this `Task`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  task?: Maybe<Task>;
  /** An edge for our `Task`. May be used by Relay 1. */
  taskEdge?: Maybe<TasksEdge>;
  /** Reads a single `User` that is related to this `Task`. */
  userByCompletedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `Task`. */
  userByCreatedBy?: Maybe<User>;
};


/** The output of our `completeTask` mutation. */
export type CompleteTaskPayloadTaskEdgeArgs = {
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};

export type ContractExistingDocumentInput = {
  deleteExistingStorage: Scalars['Boolean'];
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export type ContractGeneratedDocumentInput = {
  contractTemplateId: Scalars['UUID'];
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  placeholderValues?: InputMaybe<Scalars['JSON']>;
};

export type ContractPredefinedPlaceholder = {
  __typename?: 'ContractPredefinedPlaceholder';
  active: Scalars['Boolean'];
  alias?: Maybe<Scalars['String']>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  departmentId?: Maybe<Scalars['UUID']>;
  /** Reads a single `FormField` that is related to this `ContractPredefinedPlaceholder`. */
  formField?: Maybe<FormField>;
  formFieldId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  placeholder?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `ContractPredefinedPlaceholder` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ContractPredefinedPlaceholderCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `alias` field. */
  alias?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departmentId` field. */
  departmentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `placeholder` field. */
  placeholder?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `contractPredefinedPlaceholder` to look up the row to connect. */
export type ContractPredefinedPlaceholderContractPredefinedPlaceholderPkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against `ContractPredefinedPlaceholder` object types. All fields are combined with a logical ‘and.’ */
export type ContractPredefinedPlaceholderFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ContractPredefinedPlaceholderFilter>>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departmentId` field. */
  departmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `formField` relation. */
  formField?: InputMaybe<FormFieldFilter>;
  /** A related `formField` exists. */
  formFieldExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ContractPredefinedPlaceholderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ContractPredefinedPlaceholderFilter>>;
  /** Filter by the object’s `placeholder` field. */
  placeholder?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** The `contractPredefinedPlaceholder` to be created by this mutation. */
export type ContractPredefinedPlaceholderFormFieldIdForeignConnectionContractPredefinedPlaceholderCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  alias?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  placeholder?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `formField` to be created by this mutation. */
export type ContractPredefinedPlaceholderFormFieldIdForeignConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `formField` in the `ContractPredefinedPlaceholderInput` mutation. */
export type ContractPredefinedPlaceholderFormFieldIdForeignInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<FormFieldFormFieldPkeyConnect>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignConnectionFormFieldCreateInput>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<FormFieldOnContractPredefinedPlaceholderForContractPredefinedPlaceholderFormFieldIdForeignUsingFormFieldPkeyUpdate>;
};

/** Input for the nested mutation of `contractPredefinedPlaceholder` in the `FormFieldInput` mutation. */
export type ContractPredefinedPlaceholderFormFieldIdForeignInverseInput = {
  /** The primary key(s) for `contractPredefinedPlaceholder` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractPredefinedPlaceholderContractPredefinedPlaceholderPkeyConnect>>;
  /** A `ContractPredefinedPlaceholderInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractPredefinedPlaceholderFormFieldIdForeignConnectionContractPredefinedPlaceholderCreateInput>>;
  /** The primary key(s) and patch data for `contractPredefinedPlaceholder` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractPredefinedPlaceholderOnContractPredefinedPlaceholderForContractPredefinedPlaceholderFormFieldIdForeignUsingContractPredefinedPlaceholderPkeyUpdate>>;
};

/** An input for mutations affecting `ContractPredefinedPlaceholder` */
export type ContractPredefinedPlaceholderInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  alias?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  placeholder?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `contractPredefinedPlaceholder` to look up the row to update. */
export type ContractPredefinedPlaceholderOnContractPredefinedPlaceholderForContractPredefinedPlaceholderFormFieldIdForeignUsingContractPredefinedPlaceholderPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractPredefinedPlaceholder` being updated. */
  patch: UpdateContractPredefinedPlaceholderOnContractPredefinedPlaceholderForContractPredefinedPlaceholderFormFieldIdForeignPatch;
};

/** Represents an update to a `ContractPredefinedPlaceholder`. Fields that are set will be updated. */
export type ContractPredefinedPlaceholderPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  alias?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  placeholder?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `ContractPredefinedPlaceholder` values. */
export type ContractPredefinedPlaceholdersConnection = {
  __typename?: 'ContractPredefinedPlaceholdersConnection';
  /** A list of edges which contains the `ContractPredefinedPlaceholder` and cursor to aid in pagination. */
  edges: Array<ContractPredefinedPlaceholdersEdge>;
  /** A list of `ContractPredefinedPlaceholder` objects. */
  nodes: Array<Maybe<ContractPredefinedPlaceholder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ContractPredefinedPlaceholder` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ContractPredefinedPlaceholder` edge in the connection. */
export type ContractPredefinedPlaceholdersEdge = {
  __typename?: 'ContractPredefinedPlaceholdersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ContractPredefinedPlaceholder` at the end of the edge. */
  node?: Maybe<ContractPredefinedPlaceholder>;
};

/** Methods to use when ordering `ContractPredefinedPlaceholder`. */
export type ContractPredefinedPlaceholdersOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ALIAS_ASC'
  | 'ALIAS_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_DESC'
  | 'FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PLACEHOLDER_ASC'
  | 'PLACEHOLDER_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** Contracts sent for hand signature. */
export type ContractSignPending = {
  __typename?: 'ContractSignPending';
  active: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `ContractSignPending`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `ContractSignPendingDocument`. */
  contractSignPendingDocuments: ContractSignPendingDocumentsConnection;
  /** Reads and enables pagination through a set of `ContractSignPendingSigner`. */
  contractSignPendingSigners: ContractSignPendingSignersConnection;
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `User` that is related to this `ContractSignPending`. */
  creatorUser?: Maybe<User>;
  creatorUserId?: Maybe<Scalars['UUID']>;
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  emailText?: Maybe<Scalars['String']>;
  /** Reads a single `Employee` that is related to this `ContractSignPending`. */
  employee?: Maybe<Employee>;
  employeeId: Scalars['UUID'];
  enforceSignOrder: Scalars['Boolean'];
  id: Scalars['UUID'];
  mergeIntoOneDocument: Scalars['Boolean'];
  /** Reads a single `DocumentType` that is related to this `ContractSignPending`. */
  mergedDocumentDocumentType?: Maybe<DocumentType>;
  mergedDocumentDocumentTypeId?: Maybe<Scalars['UUID']>;
  mergedDocumentName?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `ContractSignPending`. */
  nextSigningUser?: Maybe<User>;
  nextSigningUserId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferences: NotificationEmployeeReferencesConnection;
  /** Reads a single `PreboardingEmployee` that is related to this `ContractSignPending`. */
  preboardingEmployee?: Maybe<PreboardingEmployee>;
  preboardingEmployeeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `PreboardingSlideFormField` that is related to this `ContractSignPending`. */
  preboardingSlideFormField?: Maybe<PreboardingSlideFormField>;
  preboardingSlideFormFieldId?: Maybe<Scalars['UUID']>;
  refused?: Maybe<Scalars['Boolean']>;
  reminderInterval?: Maybe<Scalars['Int']>;
  signDate?: Maybe<Scalars['Datetime']>;
  signedUserIds: Array<Maybe<Scalars['UUID']>>;
  signingUserIds: Array<Maybe<Scalars['UUID']>>;
  /** Reads a single `User` that is related to this `ContractSignPending`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};


/** Contracts sent for hand signature. */
export type ContractSignPendingContractSignPendingDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingDocumentCondition>;
  filter?: InputMaybe<ContractSignPendingDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingDocumentsOrderBy>>;
};


/** Contracts sent for hand signature. */
export type ContractSignPendingContractSignPendingSignersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingSignerCondition>;
  filter?: InputMaybe<ContractSignPendingSignerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingSignersOrderBy>>;
};


/** Contracts sent for hand signature. */
export type ContractSignPendingNotificationEmployeeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};

/** Input for the nested mutation of `company` in the `ContractSignPendingInput` mutation. */
export type ContractSignPendingCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnContractSignPendingForContractSignPendingCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `contractSignPending` in the `CompanyInput` mutation. */
export type ContractSignPendingCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `contractSignPending` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractSignPendingContractSignPendingPkeyConnect>>;
  /** The primary key(s) and patch data for `contractSignPending` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractSignPendingOnContractSignPendingForContractSignPendingCompanyIdFkeyUsingContractSignPendingPkeyUpdate>>;
};

/**
 * A condition to be used against `ContractSignPending` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ContractSignPendingCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `creatorUserId` field. */
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `emailText` field. */
  emailText?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `enforceSignOrder` field. */
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `mergeIntoOneDocument` field. */
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `mergedDocumentDocumentTypeId` field. */
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `mergedDocumentName` field. */
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nextSigningUserId` field. */
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `preboardingEmployeeId` field. */
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `preboardingSlideFormFieldId` field. */
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `reminderInterval` field. */
  reminderInterval?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `signDate` field. */
  signDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `signedUserIds` field. */
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `signingUserIds` field. */
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `contractSignPending` to look up the row to connect. */
export type ContractSignPendingContractSignPendingPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `contractSignPending` to be created by this mutation. */
export type ContractSignPendingCreatorUserIdForeignConnectionContractSignPendingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  existingDocuments?: InputMaybe<Array<InputMaybe<ContractExistingDocumentInput>>>;
  generatedDocuments?: InputMaybe<Array<InputMaybe<ContractGeneratedDocumentInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUsers: Array<ContractSignerInput>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `contractSignPending` in the `UserInput` mutation. */
export type ContractSignPendingCreatorUserIdForeignInverseInput = {
  /** The primary key(s) for `contractSignPending` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractSignPendingContractSignPendingPkeyConnect>>;
  /** A `ContractSignPendingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractSignPendingCreatorUserIdForeignConnectionContractSignPendingCreateInput>>;
  /** The primary key(s) and patch data for `contractSignPending` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractSignPendingOnContractSignPendingForContractSignPendingCreatorUserIdForeignUsingContractSignPendingPkeyUpdate>>;
};

export type ContractSignPendingDocument = {
  __typename?: 'ContractSignPendingDocument';
  /** Reads a single `Company` that is related to this `ContractSignPendingDocument`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  contractName: Scalars['String'];
  /** Reads a single `ContractSignPending` that is related to this `ContractSignPendingDocument`. */
  contractSignPending?: Maybe<ContractSignPending>;
  contractSignPendingId: Scalars['UUID'];
  /** Reads a single `ContractTemplate` that is related to this `ContractSignPendingDocument`. */
  contractTemplate?: Maybe<ContractTemplate>;
  contractTemplateId?: Maybe<Scalars['UUID']>;
  deleteExistingStorage: Scalars['Boolean'];
  departmentIds: Array<Maybe<Scalars['UUID']>>;
  /** Reads a single `DocumentType` that is related to this `ContractSignPendingDocument`. */
  documentType?: Maybe<DocumentType>;
  documentTypeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Storage` that is related to this `ContractSignPendingDocument`. */
  existingStorage?: Maybe<Storage>;
  existingStorageId?: Maybe<Scalars['UUID']>;
  fieldMappings?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  order: Scalars['Int'];
  placeholderValues?: Maybe<Scalars['JSON']>;
  signingUserIds: Array<Maybe<Scalars['UUID']>>;
  storageId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `Storage`. */
  storages: StoragesConnection;
};


export type ContractSignPendingDocumentStoragesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<StorageCondition>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StoragesOrderBy>>;
};

/** The `contractSignPendingDocument` to be created by this mutation. */
export type ContractSignPendingDocumentCompanyIdForeignConnectionContractSignPendingDocumentCreateInput = {
  company?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInput>;
  contractName: Scalars['String'];
  contractSignPending?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  deleteExistingStorage?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  existingStorageId?: InputMaybe<Scalars['UUID']>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  signingUserIds: Array<InputMaybe<Scalars['UUID']>>;
  storage?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInput>;
  storages?: InputMaybe<StorageContractSignPendingDocumentIdForeignInverseInput>;
};

/** Input for the nested mutation of `company` in the `ContractSignPendingDocumentInput` mutation. */
export type ContractSignPendingDocumentCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnContractSignPendingDocumentForContractSignPendingDocumentCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `contractSignPendingDocument` in the `CompanyInput` mutation. */
export type ContractSignPendingDocumentCompanyIdForeignInverseInput = {
  /** The primary key(s) for `contractSignPendingDocument` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractSignPendingDocumentContractSignPendingDocumentPkeyConnect>>;
  /** A `ContractSignPendingDocumentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractSignPendingDocumentCompanyIdForeignConnectionContractSignPendingDocumentCreateInput>>;
  /** The primary key(s) for `contractSignPendingDocument` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ContractSignPendingDocumentContractSignPendingDocumentPkeyDelete>>;
  /** Flag indicating whether all other `contractSignPendingDocument` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `contractSignPendingDocument` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentCompanyIdForeignUsingContractSignPendingDocumentPkeyUpdate>>;
};

/**
 * A condition to be used against `ContractSignPendingDocument` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ContractSignPendingDocumentCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `contractName` field. */
  contractName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `contractSignPendingId` field. */
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `contractTemplateId` field. */
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `deleteExistingStorage` field. */
  deleteExistingStorage?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `documentTypeId` field. */
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `existingStorageId` field. */
  existingStorageId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fieldMappings` field. */
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `placeholderValues` field. */
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `signingUserIds` field. */
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The fields on `contractSignPendingDocument` to look up the row to connect. */
export type ContractSignPendingDocumentContractSignPendingDocumentPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `contractSignPendingDocument` to look up the row to delete. */
export type ContractSignPendingDocumentContractSignPendingDocumentPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `contractSignPending` to be created by this mutation. */
export type ContractSignPendingDocumentContractSignPendingIdForeignConnectionContractSignPendingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  existingDocuments?: InputMaybe<Array<InputMaybe<ContractExistingDocumentInput>>>;
  generatedDocuments?: InputMaybe<Array<InputMaybe<ContractGeneratedDocumentInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUsers: Array<ContractSignerInput>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `contractSignPendingDocument` to be created by this mutation. */
export type ContractSignPendingDocumentContractSignPendingIdForeignConnectionContractSignPendingDocumentCreateInput = {
  company?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractName: Scalars['String'];
  contractSignPending?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInput>;
  contractTemplate?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  deleteExistingStorage?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  existingStorageId?: InputMaybe<Scalars['UUID']>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  signingUserIds: Array<InputMaybe<Scalars['UUID']>>;
  storage?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInput>;
  storages?: InputMaybe<StorageContractSignPendingDocumentIdForeignInverseInput>;
};

/** Input for the nested mutation of `contractSignPending` in the `ContractSignPendingDocumentInput` mutation. */
export type ContractSignPendingDocumentContractSignPendingIdForeignInput = {
  /** The primary key(s) for `contractSignPending` for the far side of the relationship. */
  connectById?: InputMaybe<ContractSignPendingContractSignPendingPkeyConnect>;
  /** A `ContractSignPendingInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignConnectionContractSignPendingCreateInput>;
  /** The primary key(s) and patch data for `contractSignPending` for the far side of the relationship. */
  updateById?: InputMaybe<ContractSignPendingOnContractSignPendingDocumentForContractSignPendingDocumentContractSignPendingIdForeignUsingContractSignPendingPkeyUpdate>;
};

/** Input for the nested mutation of `contractSignPendingDocument` in the `ContractSignPendingInput` mutation. */
export type ContractSignPendingDocumentContractSignPendingIdForeignInverseInput = {
  /** The primary key(s) for `contractSignPendingDocument` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractSignPendingDocumentContractSignPendingDocumentPkeyConnect>>;
  /** A `ContractSignPendingDocumentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractSignPendingDocumentContractSignPendingIdForeignConnectionContractSignPendingDocumentCreateInput>>;
  /** The primary key(s) for `contractSignPendingDocument` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ContractSignPendingDocumentContractSignPendingDocumentPkeyDelete>>;
  /** Flag indicating whether all other `contractSignPendingDocument` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `contractSignPendingDocument` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentContractSignPendingIdForeignUsingContractSignPendingDocumentPkeyUpdate>>;
};

/** The `contractSignPendingDocument` to be created by this mutation. */
export type ContractSignPendingDocumentContractTemplateIdForeignConnectionContractSignPendingDocumentCreateInput = {
  company?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractName: Scalars['String'];
  contractSignPending?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInput>;
  deleteExistingStorage?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  existingStorageId?: InputMaybe<Scalars['UUID']>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  signingUserIds: Array<InputMaybe<Scalars['UUID']>>;
  storage?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInput>;
  storages?: InputMaybe<StorageContractSignPendingDocumentIdForeignInverseInput>;
};

/** The `contractTemplate` to be created by this mutation. */
export type ContractSignPendingDocumentContractTemplateIdForeignConnectionContractTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInverseInput>;
  contractSignPendingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInverseInput>;
  contractTemplateFormFields?: InputMaybe<ContractTemplateFormFieldContractTemplateIdForeignInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<ContractTemplateDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  footer?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  htmlPlaceholders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  jobPositionTypes?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  placeholders?: InputMaybe<Scalars['JSON']>;
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
  signable?: InputMaybe<Scalars['Boolean']>;
  storages?: InputMaybe<StorageDocumentTemplateIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `contractTemplate` in the `ContractSignPendingDocumentInput` mutation. */
export type ContractSignPendingDocumentContractTemplateIdForeignInput = {
  /** The primary key(s) for `contractTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<ContractTemplateContractTemplatePkeyConnect>;
  /** A `ContractTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignConnectionContractTemplateCreateInput>;
  /** The primary key(s) and patch data for `contractTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<ContractTemplateOnContractSignPendingDocumentForContractSignPendingDocumentContractTemplateIdForeignUsingContractTemplatePkeyUpdate>;
};

/** Input for the nested mutation of `contractSignPendingDocument` in the `ContractTemplateInput` mutation. */
export type ContractSignPendingDocumentContractTemplateIdForeignInverseInput = {
  /** The primary key(s) for `contractSignPendingDocument` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractSignPendingDocumentContractSignPendingDocumentPkeyConnect>>;
  /** A `ContractSignPendingDocumentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractSignPendingDocumentContractTemplateIdForeignConnectionContractSignPendingDocumentCreateInput>>;
  /** The primary key(s) for `contractSignPendingDocument` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ContractSignPendingDocumentContractSignPendingDocumentPkeyDelete>>;
  /** Flag indicating whether all other `contractSignPendingDocument` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `contractSignPendingDocument` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentContractTemplateIdForeignUsingContractSignPendingDocumentPkeyUpdate>>;
};

/** The `contractSignPendingDocument` to be created by this mutation. */
export type ContractSignPendingDocumentDocumentTypeIdForeignConnectionContractSignPendingDocumentCreateInput = {
  company?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractName: Scalars['String'];
  contractSignPending?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  deleteExistingStorage?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInput>;
  existingStorageId?: InputMaybe<Scalars['UUID']>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  signingUserIds: Array<InputMaybe<Scalars['UUID']>>;
  storage?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInput>;
  storages?: InputMaybe<StorageContractSignPendingDocumentIdForeignInverseInput>;
};

/** The `documentType` to be created by this mutation. */
export type ContractSignPendingDocumentDocumentTypeIdForeignConnectionDocumentTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput>;
  contractTemplates?: InputMaybe<ContractTemplateDocumentTypeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lifetime?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  storages?: InputMaybe<StorageDocumentTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `documentType` in the `ContractSignPendingDocumentInput` mutation. */
export type ContractSignPendingDocumentDocumentTypeIdForeignInput = {
  /** The primary key(s) for `documentType` for the far side of the relationship. */
  connectByCompanyIdAndDepartmentIdAndName?: InputMaybe<DocumentTypeDocumentTypeCompanyIdDepartmentIdNameUniqueConnect>;
  /** The primary key(s) for `documentType` for the far side of the relationship. */
  connectById?: InputMaybe<DocumentTypeDocumentTypePkeyConnect>;
  /** A `DocumentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignConnectionDocumentTypeCreateInput>;
  /** The primary key(s) and patch data for `documentType` for the far side of the relationship. */
  updateByCompanyIdAndDepartmentIdAndName?: InputMaybe<DocumentTypeOnContractSignPendingDocumentForContractSignPendingDocumentDocumentTypeIdForeignUsingDocumentTypeCompanyIdDepartmentIdNameUniqueUpdate>;
  /** The primary key(s) and patch data for `documentType` for the far side of the relationship. */
  updateById?: InputMaybe<DocumentTypeOnContractSignPendingDocumentForContractSignPendingDocumentDocumentTypeIdForeignUsingDocumentTypePkeyUpdate>;
};

/** Input for the nested mutation of `contractSignPendingDocument` in the `DocumentTypeInput` mutation. */
export type ContractSignPendingDocumentDocumentTypeIdForeignInverseInput = {
  /** The primary key(s) for `contractSignPendingDocument` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractSignPendingDocumentContractSignPendingDocumentPkeyConnect>>;
  /** A `ContractSignPendingDocumentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractSignPendingDocumentDocumentTypeIdForeignConnectionContractSignPendingDocumentCreateInput>>;
  /** The primary key(s) for `contractSignPendingDocument` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ContractSignPendingDocumentContractSignPendingDocumentPkeyDelete>>;
  /** Flag indicating whether all other `contractSignPendingDocument` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `contractSignPendingDocument` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentDocumentTypeIdForeignUsingContractSignPendingDocumentPkeyUpdate>>;
};

/** The `contractSignPendingDocument` to be created by this mutation. */
export type ContractSignPendingDocumentExistingStorageIdForeignConnectionContractSignPendingDocumentCreateInput = {
  company?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractName: Scalars['String'];
  contractSignPending?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  deleteExistingStorage?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  signingUserIds: Array<InputMaybe<Scalars['UUID']>>;
  storage?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInput>;
  storages?: InputMaybe<StorageContractSignPendingDocumentIdForeignInverseInput>;
};

/** The `storage` to be created by this mutation. */
export type ContractSignPendingDocumentExistingStorageIdForeignConnectionStorageCreateInput = {
  access: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createCopy?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path: Scalars['String'];
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `storage` in the `ContractSignPendingDocumentInput` mutation. */
export type ContractSignPendingDocumentExistingStorageIdForeignInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<StorageStoragePkeyConnect>;
  /** A `StorageInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignConnectionStorageCreateInput>;
  /** The primary key(s) and patch data for `storage` for the far side of the relationship. */
  updateById?: InputMaybe<StorageOnContractSignPendingDocumentForContractSignPendingDocumentExistingStorageIdForeignUsingStoragePkeyUpdate>;
};

/** Input for the nested mutation of `contractSignPendingDocument` in the `StorageInput` mutation. */
export type ContractSignPendingDocumentExistingStorageIdForeignInverseInput = {
  /** The primary key(s) for `contractSignPendingDocument` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractSignPendingDocumentContractSignPendingDocumentPkeyConnect>>;
  /** A `ContractSignPendingDocumentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractSignPendingDocumentExistingStorageIdForeignConnectionContractSignPendingDocumentCreateInput>>;
  /** The primary key(s) for `contractSignPendingDocument` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ContractSignPendingDocumentContractSignPendingDocumentPkeyDelete>>;
  /** Flag indicating whether all other `contractSignPendingDocument` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `contractSignPendingDocument` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentExistingStorageIdForeignUsingContractSignPendingDocumentPkeyUpdate>>;
};

/** A filter to be used against `ContractSignPendingDocument` object types. All fields are combined with a logical ‘and.’ */
export type ContractSignPendingDocumentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ContractSignPendingDocumentFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `contractName` field. */
  contractName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `contractSignPending` relation. */
  contractSignPending?: InputMaybe<ContractSignPendingFilter>;
  /** Filter by the object’s `contractSignPendingId` field. */
  contractSignPendingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `contractTemplate` relation. */
  contractTemplate?: InputMaybe<ContractTemplateFilter>;
  /** A related `contractTemplate` exists. */
  contractTemplateExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractTemplateId` field. */
  contractTemplateId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `deleteExistingStorage` field. */
  deleteExistingStorage?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `documentType` relation. */
  documentType?: InputMaybe<DocumentTypeFilter>;
  /** A related `documentType` exists. */
  documentTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentTypeId` field. */
  documentTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `existingStorage` relation. */
  existingStorage?: InputMaybe<StorageFilter>;
  /** A related `existingStorage` exists. */
  existingStorageExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `existingStorageId` field. */
  existingStorageId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fieldMappings` field. */
  fieldMappings?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ContractSignPendingDocumentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ContractSignPendingDocumentFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `placeholderValues` field. */
  placeholderValues?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `signingUserIds` field. */
  signingUserIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `storageId` field. */
  storageId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `storages` relation. */
  storages?: InputMaybe<ContractSignPendingDocumentToManyStorageFilter>;
  /** Some related `storages` exist. */
  storagesExist?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `ContractSignPendingDocument` */
export type ContractSignPendingDocumentInput = {
  company?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractName: Scalars['String'];
  contractSignPending?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  deleteExistingStorage?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  existingStorageId?: InputMaybe<Scalars['UUID']>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  signingUserIds: Array<InputMaybe<Scalars['UUID']>>;
  storage?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInput>;
  storages?: InputMaybe<StorageContractSignPendingDocumentIdForeignInverseInput>;
};

/** The fields on `contractSignPendingDocument` to look up the row to update. */
export type ContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentCompanyIdForeignUsingContractSignPendingDocumentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPendingDocument` being updated. */
  patch: UpdateContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentCompanyIdForeignPatch;
};

/** The fields on `contractSignPendingDocument` to look up the row to update. */
export type ContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentContractSignPendingIdForeignUsingContractSignPendingDocumentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPendingDocument` being updated. */
  patch: UpdateContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentContractSignPendingIdForeignPatch;
};

/** The fields on `contractSignPendingDocument` to look up the row to update. */
export type ContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentContractTemplateIdForeignUsingContractSignPendingDocumentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPendingDocument` being updated. */
  patch: UpdateContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentContractTemplateIdForeignPatch;
};

/** The fields on `contractSignPendingDocument` to look up the row to update. */
export type ContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentDocumentTypeIdForeignUsingContractSignPendingDocumentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPendingDocument` being updated. */
  patch: UpdateContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentDocumentTypeIdForeignPatch;
};

/** The fields on `contractSignPendingDocument` to look up the row to update. */
export type ContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentExistingStorageIdForeignUsingContractSignPendingDocumentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPendingDocument` being updated. */
  patch: UpdateContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentExistingStorageIdForeignPatch;
};

/** The fields on `contractSignPendingDocument` to look up the row to update. */
export type ContractSignPendingDocumentOnStorageForStorageContractSignPendingDocumentIdForeignUsingContractSignPendingDocumentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPendingDocument` being updated. */
  patch: UpdateContractSignPendingDocumentOnStorageForStorageContractSignPendingDocumentIdForeignPatch;
};

/** Represents an update to a `ContractSignPendingDocument`. Fields that are set will be updated. */
export type ContractSignPendingDocumentPatch = {
  company?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractName?: InputMaybe<Scalars['String']>;
  contractSignPending?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  deleteExistingStorage?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  existingStorageId?: InputMaybe<Scalars['UUID']>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  storage?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInput>;
  storages?: InputMaybe<StorageContractSignPendingDocumentIdForeignInverseInput>;
};

/** A filter to be used against many `Storage` object types. All fields are combined with a logical ‘and.’ */
export type ContractSignPendingDocumentToManyStorageFilter = {
  /** Every related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<StorageFilter>;
  /** No related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<StorageFilter>;
  /** Some related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<StorageFilter>;
};

/** A connection to a list of `ContractSignPendingDocument` values. */
export type ContractSignPendingDocumentsConnection = {
  __typename?: 'ContractSignPendingDocumentsConnection';
  /** A list of edges which contains the `ContractSignPendingDocument` and cursor to aid in pagination. */
  edges: Array<ContractSignPendingDocumentsEdge>;
  /** A list of `ContractSignPendingDocument` objects. */
  nodes: Array<Maybe<ContractSignPendingDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ContractSignPendingDocument` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ContractSignPendingDocument` edge in the connection. */
export type ContractSignPendingDocumentsEdge = {
  __typename?: 'ContractSignPendingDocumentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ContractSignPendingDocument` at the end of the edge. */
  node?: Maybe<ContractSignPendingDocument>;
};

/** Methods to use when ordering `ContractSignPendingDocument`. */
export type ContractSignPendingDocumentsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CONTRACT_NAME_ASC'
  | 'CONTRACT_NAME_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ACTIVE_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ACTIVE_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ARCHIVED_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ARCHIVED_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__COMPANY_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__COMPANY_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__CREATED_AT_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__CREATED_AT_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__CREATOR_USER_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__CREATOR_USER_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__DEPARTMENTS_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__DEPARTMENTS_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__EMAIL_TEXT_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__EMAIL_TEXT_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__EMPLOYEE_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__EMPLOYEE_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ENFORCE_SIGN_ORDER_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ENFORCE_SIGN_ORDER_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__MERGED_DOCUMENT_DOCUMENT_TYPE_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__MERGED_DOCUMENT_DOCUMENT_TYPE_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__MERGED_DOCUMENT_NAME_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__MERGED_DOCUMENT_NAME_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__MERGE_INTO_ONE_DOCUMENT_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__MERGE_INTO_ONE_DOCUMENT_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__NEXT_SIGNING_USER_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__NEXT_SIGNING_USER_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__PREBOARDING_EMPLOYEE_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__PREBOARDING_EMPLOYEE_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__PREBOARDING_SLIDE_FORM_FIELD_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__PREBOARDING_SLIDE_FORM_FIELD_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__REMINDER_INTERVAL_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__REMINDER_INTERVAL_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__SIGNED_USER_IDS_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__SIGNED_USER_IDS_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__SIGNING_USER_IDS_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__SIGNING_USER_IDS_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__SIGN_DATE_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__SIGN_DATE_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__USER_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__USER_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__ACTIVE_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__ACTIVE_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__BOTTOM_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__BOTTOM_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__COMPANY_ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__COMPANY_ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__CONTRACT_SIGN_PENDING_USER_IDS_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__CONTRACT_SIGN_PENDING_USER_IDS_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__CREATED_AT_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__CREATED_AT_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DATE_FORMAT_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DATE_FORMAT_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DESCRIPTION_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DESCRIPTION_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DOCUMENT_TYPE_ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DOCUMENT_TYPE_ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__FOOTER_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__FOOTER_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HEADER_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HEADER_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HTML_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HTML_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HTML_PLACEHOLDERS_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HTML_PLACEHOLDERS_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__IS_GLOBAL_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__IS_GLOBAL_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__JOB_POSITION_TYPES_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__JOB_POSITION_TYPES_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__LEFT_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__LEFT_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__LOCALE_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__LOCALE_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__NAME_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__NAME_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__PAGE_NUMBER_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__PAGE_NUMBER_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__PLACEHOLDERS_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__PLACEHOLDERS_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__RIGHT_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__RIGHT_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__SIGNABLE_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__SIGNABLE_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__TEMPLATING_SERVICE_ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__TEMPLATING_SERVICE_ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__TOP_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__TOP_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__UPDATED_AT_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__UPDATED_AT_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__USERS_SHARED_WITH_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__USERS_SHARED_WITH_DESC'
  | 'CONTRACT_TEMPLATE_ID_ASC'
  | 'CONTRACT_TEMPLATE_ID_DESC'
  | 'DELETE_EXISTING_STORAGE_ASC'
  | 'DELETE_EXISTING_STORAGE_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ACTIVE_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ACTIVE_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__AUTO_DELETE_DAYS_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__AUTO_DELETE_DAYS_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__CREATED_AT_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__CREATED_AT_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DEPARTMENT_ID_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DEPARTMENT_ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ID_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LIFETIME_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LIFETIME_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__NAME_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__NAME_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'DOCUMENT_TYPE_ID_ASC'
  | 'DOCUMENT_TYPE_ID_DESC'
  | 'EXISTING_STORAGE_ID_ASC'
  | 'EXISTING_STORAGE_ID_DESC'
  | 'FIELD_MAPPINGS_ASC'
  | 'FIELD_MAPPINGS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PLACEHOLDER_VALUES_ASC'
  | 'PLACEHOLDER_VALUES_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SIGNING_USER_IDS_ASC'
  | 'SIGNING_USER_IDS_DESC'
  | 'STORAGES_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__COUNT_ASC'
  | 'STORAGES_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__COUNT_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__ACCESS_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__ACCESS_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__ACTIVE_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__ACTIVE_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__BELONGS_TO_LEADER_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__BELONGS_TO_LEADER_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__COMPANY_ID_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__COMPANY_ID_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__CREATED_AT_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__CREATED_AT_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__DELETE_AT_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__DELETE_AT_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__DEPARTMENTS_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__DEPARTMENTS_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__DOCUMENT_FOLDER_ID_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__DOCUMENT_FOLDER_ID_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__DOCUMENT_TEMPLATE_ID_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__DOCUMENT_TEMPLATE_ID_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__DOCUMENT_TYPE_ID_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__DOCUMENT_TYPE_ID_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__EMPLOYEE_CASEFILE_ID_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__EMPLOYEE_CASEFILE_ID_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__EXPIRED_REMINDED_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__EXPIRED_REMINDED_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__EXPIRE_AT_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__EXPIRE_AT_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FILENAME_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FILENAME_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FILE_EXTENSION_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FILE_EXTENSION_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FILE_OWNER_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FILE_OWNER_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FILE_OWNER_ID_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FILE_OWNER_ID_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FILE_SIZE_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FILE_SIZE_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FILE_TYPE_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FILE_TYPE_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FOLDER_DEPARTMENT_IDS_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FOLDER_DEPARTMENT_IDS_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FOLDER_OWNER_ID_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FOLDER_OWNER_ID_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FOLDER_USER_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__FOLDER_USER_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__HTML_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__HTML_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__ID_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__ID_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__MIMETYPE_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__MIMETYPE_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__OWNER_NAME_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__OWNER_NAME_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__PATH_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__PATH_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__PENNEO_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__PENNEO_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__PLACEHOLDER_VALUES_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__PLACEHOLDER_VALUES_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__PROCESS_TYPE_ID_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__PROCESS_TYPE_ID_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__REMINDED_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__REMINDED_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__REMIND_AT_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__REMIND_AT_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__TEMPLATING_SERVICE_ID_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__TEMPLATING_SERVICE_ID_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__USERS_RESPONSIBLE_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__USERS_RESPONSIBLE_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__USERS_SHARED_WITH_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__USERS_SHARED_WITH_DEPARTMENTS_ASC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__USERS_SHARED_WITH_DEPARTMENTS_DESC'
  | 'STORAGE_BY_EXISTING_STORAGE_ID__USERS_SHARED_WITH_DESC';

/** The `contractSignPending` to be created by this mutation. */
export type ContractSignPendingEmployeeIdForeignConnectionContractSignPendingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  existingDocuments?: InputMaybe<Array<InputMaybe<ContractExistingDocumentInput>>>;
  generatedDocuments?: InputMaybe<Array<InputMaybe<ContractGeneratedDocumentInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUsers: Array<ContractSignerInput>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `employee` in the `ContractSignPendingInput` mutation. */
export type ContractSignPendingEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnContractSignPendingForContractSignPendingEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnContractSignPendingForContractSignPendingEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `contractSignPending` in the `EmployeeInput` mutation. */
export type ContractSignPendingEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `contractSignPending` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractSignPendingContractSignPendingPkeyConnect>>;
  /** A `ContractSignPendingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractSignPendingEmployeeIdForeignConnectionContractSignPendingCreateInput>>;
  /** The primary key(s) and patch data for `contractSignPending` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractSignPendingOnContractSignPendingForContractSignPendingEmployeeIdForeignUsingContractSignPendingPkeyUpdate>>;
};

/** A filter to be used against `ContractSignPending` object types. All fields are combined with a logical ‘and.’ */
export type ContractSignPendingFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ContractSignPendingFilter>>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `contractSignPendingDocuments` relation. */
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingToManyContractSignPendingDocumentFilter>;
  /** Some related `contractSignPendingDocuments` exist. */
  contractSignPendingDocumentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractSignPendingSigners` relation. */
  contractSignPendingSigners?: InputMaybe<ContractSignPendingToManyContractSignPendingSignerFilter>;
  /** Some related `contractSignPendingSigners` exist. */
  contractSignPendingSignersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `creatorUser` relation. */
  creatorUser?: InputMaybe<UserFilter>;
  /** A related `creatorUser` exists. */
  creatorUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `creatorUserId` field. */
  creatorUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `emailText` field. */
  emailText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `enforceSignOrder` field. */
  enforceSignOrder?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `mergeIntoOneDocument` field. */
  mergeIntoOneDocument?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mergedDocumentDocumentType` relation. */
  mergedDocumentDocumentType?: InputMaybe<DocumentTypeFilter>;
  /** A related `mergedDocumentDocumentType` exists. */
  mergedDocumentDocumentTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `mergedDocumentDocumentTypeId` field. */
  mergedDocumentDocumentTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `mergedDocumentName` field. */
  mergedDocumentName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nextSigningUser` relation. */
  nextSigningUser?: InputMaybe<UserFilter>;
  /** A related `nextSigningUser` exists. */
  nextSigningUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `nextSigningUserId` field. */
  nextSigningUserId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ContractSignPendingFilter>;
  /** Filter by the object’s `notificationEmployeeReferences` relation. */
  notificationEmployeeReferences?: InputMaybe<ContractSignPendingToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferences` exist. */
  notificationEmployeeReferencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ContractSignPendingFilter>>;
  /** Filter by the object’s `preboardingEmployee` relation. */
  preboardingEmployee?: InputMaybe<PreboardingEmployeeFilter>;
  /** A related `preboardingEmployee` exists. */
  preboardingEmployeeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingEmployeeId` field. */
  preboardingEmployeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `preboardingSlideFormField` relation. */
  preboardingSlideFormField?: InputMaybe<PreboardingSlideFormFieldFilter>;
  /** A related `preboardingSlideFormField` exists. */
  preboardingSlideFormFieldExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingSlideFormFieldId` field. */
  preboardingSlideFormFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `refused` field. */
  refused?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `reminderInterval` field. */
  reminderInterval?: InputMaybe<IntFilter>;
  /** Filter by the object’s `signDate` field. */
  signDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `signedUserIds` field. */
  signedUserIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `signingUserIds` field. */
  signingUserIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ContractSignPending` */
export type ContractSignPendingInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  existingDocuments?: InputMaybe<Array<InputMaybe<ContractExistingDocumentInput>>>;
  generatedDocuments?: InputMaybe<Array<InputMaybe<ContractGeneratedDocumentInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUsers: Array<ContractSignerInput>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `contractSignPending` to be created by this mutation. */
export type ContractSignPendingMergedDocumentDocumentTypeIdForeignConnectionContractSignPendingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  existingDocuments?: InputMaybe<Array<InputMaybe<ContractExistingDocumentInput>>>;
  generatedDocuments?: InputMaybe<Array<InputMaybe<ContractGeneratedDocumentInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUsers: Array<ContractSignerInput>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `documentType` to be created by this mutation. */
export type ContractSignPendingMergedDocumentDocumentTypeIdForeignConnectionDocumentTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput>;
  contractTemplates?: InputMaybe<ContractTemplateDocumentTypeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lifetime?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  storages?: InputMaybe<StorageDocumentTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `documentType` in the `ContractSignPendingInput` mutation. */
export type ContractSignPendingMergedDocumentDocumentTypeIdForeignInput = {
  /** The primary key(s) for `documentType` for the far side of the relationship. */
  connectByCompanyIdAndDepartmentIdAndName?: InputMaybe<DocumentTypeDocumentTypeCompanyIdDepartmentIdNameUniqueConnect>;
  /** The primary key(s) for `documentType` for the far side of the relationship. */
  connectById?: InputMaybe<DocumentTypeDocumentTypePkeyConnect>;
  /** A `DocumentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignConnectionDocumentTypeCreateInput>;
  /** The primary key(s) and patch data for `documentType` for the far side of the relationship. */
  updateByCompanyIdAndDepartmentIdAndName?: InputMaybe<DocumentTypeOnContractSignPendingForContractSignPendingMergedDocumentDocumentTypeIdForeignUsingDocumentTypeCompanyIdDepartmentIdNameUniqueUpdate>;
  /** The primary key(s) and patch data for `documentType` for the far side of the relationship. */
  updateById?: InputMaybe<DocumentTypeOnContractSignPendingForContractSignPendingMergedDocumentDocumentTypeIdForeignUsingDocumentTypePkeyUpdate>;
};

/** Input for the nested mutation of `contractSignPending` in the `DocumentTypeInput` mutation. */
export type ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput = {
  /** The primary key(s) for `contractSignPending` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractSignPendingContractSignPendingPkeyConnect>>;
  /** A `ContractSignPendingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractSignPendingMergedDocumentDocumentTypeIdForeignConnectionContractSignPendingCreateInput>>;
  /** The primary key(s) and patch data for `contractSignPending` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractSignPendingOnContractSignPendingForContractSignPendingMergedDocumentDocumentTypeIdForeignUsingContractSignPendingPkeyUpdate>>;
};

/** The `contractSignPending` to be created by this mutation. */
export type ContractSignPendingNextSigningUserIdForeignConnectionContractSignPendingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  existingDocuments?: InputMaybe<Array<InputMaybe<ContractExistingDocumentInput>>>;
  generatedDocuments?: InputMaybe<Array<InputMaybe<ContractGeneratedDocumentInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUsers: Array<ContractSignerInput>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `user` in the `ContractSignPendingInput` mutation. */
export type ContractSignPendingNextSigningUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnContractSignPendingForContractSignPendingNextSigningUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `contractSignPending` in the `UserInput` mutation. */
export type ContractSignPendingNextSigningUserIdForeignInverseInput = {
  /** The primary key(s) for `contractSignPending` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractSignPendingContractSignPendingPkeyConnect>>;
  /** A `ContractSignPendingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractSignPendingNextSigningUserIdForeignConnectionContractSignPendingCreateInput>>;
  /** The primary key(s) and patch data for `contractSignPending` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractSignPendingOnContractSignPendingForContractSignPendingNextSigningUserIdForeignUsingContractSignPendingPkeyUpdate>>;
};

/** The fields on `contractSignPending` to look up the row to update. */
export type ContractSignPendingOnContractSignPendingDocumentForContractSignPendingDocumentContractSignPendingIdForeignUsingContractSignPendingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPending` being updated. */
  patch: UpdateContractSignPendingOnContractSignPendingDocumentForContractSignPendingDocumentContractSignPendingIdForeignPatch;
};

/** The fields on `contractSignPending` to look up the row to update. */
export type ContractSignPendingOnContractSignPendingForContractSignPendingCompanyIdFkeyUsingContractSignPendingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPending` being updated. */
  patch: UpdateContractSignPendingOnContractSignPendingForContractSignPendingCompanyIdFkeyPatch;
};

/** The fields on `contractSignPending` to look up the row to update. */
export type ContractSignPendingOnContractSignPendingForContractSignPendingCreatorUserIdForeignUsingContractSignPendingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPending` being updated. */
  patch: UpdateContractSignPendingOnContractSignPendingForContractSignPendingCreatorUserIdForeignPatch;
};

/** The fields on `contractSignPending` to look up the row to update. */
export type ContractSignPendingOnContractSignPendingForContractSignPendingEmployeeIdForeignUsingContractSignPendingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPending` being updated. */
  patch: UpdateContractSignPendingOnContractSignPendingForContractSignPendingEmployeeIdForeignPatch;
};

/** The fields on `contractSignPending` to look up the row to update. */
export type ContractSignPendingOnContractSignPendingForContractSignPendingMergedDocumentDocumentTypeIdForeignUsingContractSignPendingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPending` being updated. */
  patch: UpdateContractSignPendingOnContractSignPendingForContractSignPendingMergedDocumentDocumentTypeIdForeignPatch;
};

/** The fields on `contractSignPending` to look up the row to update. */
export type ContractSignPendingOnContractSignPendingForContractSignPendingNextSigningUserIdForeignUsingContractSignPendingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPending` being updated. */
  patch: UpdateContractSignPendingOnContractSignPendingForContractSignPendingNextSigningUserIdForeignPatch;
};

/** The fields on `contractSignPending` to look up the row to update. */
export type ContractSignPendingOnContractSignPendingForContractSignPendingPreboardingEmployeeIdForeignUsingContractSignPendingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPending` being updated. */
  patch: UpdateContractSignPendingOnContractSignPendingForContractSignPendingPreboardingEmployeeIdForeignPatch;
};

/** The fields on `contractSignPending` to look up the row to update. */
export type ContractSignPendingOnContractSignPendingForContractSignPendingPreboardingSlideFormFieldIdForeignUsingContractSignPendingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPending` being updated. */
  patch: UpdateContractSignPendingOnContractSignPendingForContractSignPendingPreboardingSlideFormFieldIdForeignPatch;
};

/** The fields on `contractSignPending` to look up the row to update. */
export type ContractSignPendingOnContractSignPendingForContractSignPendingUserIdFkeyUsingContractSignPendingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPending` being updated. */
  patch: UpdateContractSignPendingOnContractSignPendingForContractSignPendingUserIdFkeyPatch;
};

/** The fields on `contractSignPending` to look up the row to update. */
export type ContractSignPendingOnContractSignPendingSignerForContractSignPendingSignerContractSignPendingIdForeignUsingContractSignPendingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPending` being updated. */
  patch: UpdateContractSignPendingOnContractSignPendingSignerForContractSignPendingSignerContractSignPendingIdForeignPatch;
};

/** The fields on `contractSignPending` to look up the row to update. */
export type ContractSignPendingOnNotificationEmployeeReferenceForNotificationEmployeeReferenceContractSignPendingIdForeigUsingContractSignPendingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPending` being updated. */
  patch: UpdateContractSignPendingOnNotificationEmployeeReferenceForNotificationEmployeeReferenceContractSignPendingIdForeigPatch;
};

/** Represents an update to a `ContractSignPending`. Fields that are set will be updated. */
export type ContractSignPendingPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `contractSignPending` to be created by this mutation. */
export type ContractSignPendingPreboardingEmployeeIdForeignConnectionContractSignPendingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  existingDocuments?: InputMaybe<Array<InputMaybe<ContractExistingDocumentInput>>>;
  generatedDocuments?: InputMaybe<Array<InputMaybe<ContractGeneratedDocumentInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUsers: Array<ContractSignerInput>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `preboardingEmployee` to be created by this mutation. */
export type ContractSignPendingPreboardingEmployeeIdForeignConnectionPreboardingEmployeeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `preboardingEmployee` in the `ContractSignPendingInput` mutation. */
export type ContractSignPendingPreboardingEmployeeIdForeignInput = {
  /** The primary key(s) for `preboardingEmployee` for the far side of the relationship. */
  connectById?: InputMaybe<PreboardingEmployeePreboardingEmployeePkeyConnect>;
  /** A `PreboardingEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignConnectionPreboardingEmployeeCreateInput>;
  /** The primary key(s) and patch data for `preboardingEmployee` for the far side of the relationship. */
  updateById?: InputMaybe<PreboardingEmployeeOnContractSignPendingForContractSignPendingPreboardingEmployeeIdForeignUsingPreboardingEmployeePkeyUpdate>;
};

/** Input for the nested mutation of `contractSignPending` in the `PreboardingEmployeeInput` mutation. */
export type ContractSignPendingPreboardingEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `contractSignPending` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractSignPendingContractSignPendingPkeyConnect>>;
  /** A `ContractSignPendingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractSignPendingPreboardingEmployeeIdForeignConnectionContractSignPendingCreateInput>>;
  /** The primary key(s) and patch data for `contractSignPending` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractSignPendingOnContractSignPendingForContractSignPendingPreboardingEmployeeIdForeignUsingContractSignPendingPkeyUpdate>>;
};

/** The `contractSignPending` to be created by this mutation. */
export type ContractSignPendingPreboardingSlideFormFieldIdForeignConnectionContractSignPendingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  existingDocuments?: InputMaybe<Array<InputMaybe<ContractExistingDocumentInput>>>;
  generatedDocuments?: InputMaybe<Array<InputMaybe<ContractGeneratedDocumentInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUsers: Array<ContractSignerInput>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `preboardingSlideFormField` to be created by this mutation. */
export type ContractSignPendingPreboardingSlideFormFieldIdForeignConnectionPreboardingSlideFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInverseInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingSlide?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInput>;
  preboardingSlideFormField?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldIdChInput>;
  preboardingSlideFormFieldIdParent?: InputMaybe<Scalars['UUID']>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  required?: InputMaybe<Scalars['Boolean']>;
  systemFieldName?: InputMaybe<UserEmployeeFields>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `preboardingSlideFormField` in the `ContractSignPendingInput` mutation. */
export type ContractSignPendingPreboardingSlideFormFieldIdForeignInput = {
  /** The primary key(s) for `preboardingSlideFormField` for the far side of the relationship. */
  connectById?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldPkeyConnect>;
  /** A `PreboardingSlideFormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignConnectionPreboardingSlideFormFieldCreateInput>;
  /** The primary key(s) for `preboardingSlideFormField` for the far side of the relationship. */
  deleteById?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldPkeyDelete>;
  /** The primary key(s) and patch data for `preboardingSlideFormField` for the far side of the relationship. */
  updateById?: InputMaybe<PreboardingSlideFormFieldOnContractSignPendingForContractSignPendingPreboardingSlideFormFieldIdForeignUsingPreboardingSlideFormFieldPkeyUpdate>;
};

/** Input for the nested mutation of `contractSignPending` in the `PreboardingSlideFormFieldInput` mutation. */
export type ContractSignPendingPreboardingSlideFormFieldIdForeignInverseInput = {
  /** The primary key(s) for `contractSignPending` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractSignPendingContractSignPendingPkeyConnect>>;
  /** A `ContractSignPendingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractSignPendingPreboardingSlideFormFieldIdForeignConnectionContractSignPendingCreateInput>>;
  /** The primary key(s) and patch data for `contractSignPending` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractSignPendingOnContractSignPendingForContractSignPendingPreboardingSlideFormFieldIdForeignUsingContractSignPendingPkeyUpdate>>;
};

export type ContractSignPendingSigner = {
  __typename?: 'ContractSignPendingSigner';
  coSigningUserIds: Array<Maybe<Scalars['UUID']>>;
  /** Reads a single `Company` that is related to this `ContractSignPendingSigner`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `ContractSignPending` that is related to this `ContractSignPendingSigner`. */
  contractSignPending?: Maybe<ContractSignPending>;
  contractSignPendingId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  departmentIds: Array<Maybe<Scalars['UUID']>>;
  id: Scalars['UUID'];
  ip?: Maybe<Scalars['String']>;
  lastReminded: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `ContractSignPendingSigner`. */
  onBehalfOfUser?: Maybe<User>;
  onBehalfOfUserId?: Maybe<Scalars['UUID']>;
  refusalReason?: Maybe<Scalars['String']>;
  refused: Scalars['Boolean'];
  signDate?: Maybe<Scalars['Datetime']>;
  signOrder: Scalars['Int'];
  /** Reads a single `Storage` that is related to this `ContractSignPendingSigner`. */
  signatureFile?: Maybe<Storage>;
  signatureFileId?: Maybe<Scalars['UUID']>;
  signatureImage?: Maybe<Scalars['String']>;
  signed: Scalars['Boolean'];
  useSecondaryEmail: Scalars['Boolean'];
  /** Reads a single `User` that is related to this `ContractSignPendingSigner`. */
  user?: Maybe<User>;
  userAgent?: Maybe<Scalars['String']>;
  userId: Scalars['UUID'];
};

/** The `contractSignPendingSigner` to be created by this mutation. */
export type ContractSignPendingSignerCompanyIdForeignConnectionContractSignPendingSignerCreateInput = {
  coSigningUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  company?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInput>;
  contractSignPending?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  ip?: InputMaybe<Scalars['String']>;
  lastReminded?: InputMaybe<Scalars['Datetime']>;
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  refusalReason?: InputMaybe<Scalars['String']>;
  refused?: InputMaybe<Scalars['Boolean']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signOrder?: InputMaybe<Scalars['Int']>;
  signatureFileId?: InputMaybe<Scalars['UUID']>;
  signed?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInput>;
  useSecondaryEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInput>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `ContractSignPendingSignerInput` mutation. */
export type ContractSignPendingSignerCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnContractSignPendingSignerForContractSignPendingSignerCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `contractSignPendingSigner` in the `CompanyInput` mutation. */
export type ContractSignPendingSignerCompanyIdForeignInverseInput = {
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  connectByContractSignPendingIdAndUserId?: InputMaybe<Array<ContractSignPendingSignerUniqueSignerConnect>>;
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractSignPendingSignerContractSignPendingSignerPkeyConnect>>;
  /** A `ContractSignPendingSignerInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractSignPendingSignerCompanyIdForeignConnectionContractSignPendingSignerCreateInput>>;
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  deleteByContractSignPendingIdAndUserId?: InputMaybe<Array<ContractSignPendingSignerUniqueSignerDelete>>;
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ContractSignPendingSignerContractSignPendingSignerPkeyDelete>>;
  /** Flag indicating whether all other `contractSignPendingSigner` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `contractSignPendingSigner` for the far side of the relationship. */
  updateByContractSignPendingIdAndUserId?: InputMaybe<Array<ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerCompanyIdForeignUsingUniqueSignerUpdate>>;
  /** The primary key(s) and patch data for `contractSignPendingSigner` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerCompanyIdForeignUsingContractSignPendingSignerPkeyUpdate>>;
};

/**
 * A condition to be used against `ContractSignPendingSigner` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ContractSignPendingSignerCondition = {
  /** Checks for equality with the object’s `coSigningUserIds` field. */
  coSigningUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `contractSignPendingId` field. */
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `ip` field. */
  ip?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lastReminded` field. */
  lastReminded?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `onBehalfOfUserId` field. */
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `refusalReason` field. */
  refusalReason?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `refused` field. */
  refused?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `signDate` field. */
  signDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `signOrder` field. */
  signOrder?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `signatureFileId` field. */
  signatureFileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `signed` field. */
  signed?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `useSecondaryEmail` field. */
  useSecondaryEmail?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `userAgent` field. */
  userAgent?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `contractSignPending` to be created by this mutation. */
export type ContractSignPendingSignerContractSignPendingIdForeignConnectionContractSignPendingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  existingDocuments?: InputMaybe<Array<InputMaybe<ContractExistingDocumentInput>>>;
  generatedDocuments?: InputMaybe<Array<InputMaybe<ContractGeneratedDocumentInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUsers: Array<ContractSignerInput>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `contractSignPendingSigner` to be created by this mutation. */
export type ContractSignPendingSignerContractSignPendingIdForeignConnectionContractSignPendingSignerCreateInput = {
  coSigningUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  company?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  ip?: InputMaybe<Scalars['String']>;
  lastReminded?: InputMaybe<Scalars['Datetime']>;
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  refusalReason?: InputMaybe<Scalars['String']>;
  refused?: InputMaybe<Scalars['Boolean']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signOrder?: InputMaybe<Scalars['Int']>;
  signatureFileId?: InputMaybe<Scalars['UUID']>;
  signed?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInput>;
  useSecondaryEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInput>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `contractSignPending` in the `ContractSignPendingSignerInput` mutation. */
export type ContractSignPendingSignerContractSignPendingIdForeignInput = {
  /** The primary key(s) for `contractSignPending` for the far side of the relationship. */
  connectById?: InputMaybe<ContractSignPendingContractSignPendingPkeyConnect>;
  /** A `ContractSignPendingInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignConnectionContractSignPendingCreateInput>;
  /** The primary key(s) and patch data for `contractSignPending` for the far side of the relationship. */
  updateById?: InputMaybe<ContractSignPendingOnContractSignPendingSignerForContractSignPendingSignerContractSignPendingIdForeignUsingContractSignPendingPkeyUpdate>;
};

/** Input for the nested mutation of `contractSignPendingSigner` in the `ContractSignPendingInput` mutation. */
export type ContractSignPendingSignerContractSignPendingIdForeignInverseInput = {
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  connectByContractSignPendingIdAndUserId?: InputMaybe<Array<ContractSignPendingSignerUniqueSignerConnect>>;
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractSignPendingSignerContractSignPendingSignerPkeyConnect>>;
  /** A `ContractSignPendingSignerInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractSignPendingSignerContractSignPendingIdForeignConnectionContractSignPendingSignerCreateInput>>;
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  deleteByContractSignPendingIdAndUserId?: InputMaybe<Array<ContractSignPendingSignerUniqueSignerDelete>>;
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ContractSignPendingSignerContractSignPendingSignerPkeyDelete>>;
  /** Flag indicating whether all other `contractSignPendingSigner` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `contractSignPendingSigner` for the far side of the relationship. */
  updateByContractSignPendingIdAndUserId?: InputMaybe<Array<ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerContractSignPendingIdForeignUsingUniqueSignerUpdate>>;
  /** The primary key(s) and patch data for `contractSignPendingSigner` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerContractSignPendingIdForeignUsingContractSignPendingSignerPkeyUpdate>>;
};

/** The fields on `contractSignPendingSigner` to look up the row to connect. */
export type ContractSignPendingSignerContractSignPendingSignerPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `contractSignPendingSigner` to look up the row to delete. */
export type ContractSignPendingSignerContractSignPendingSignerPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against `ContractSignPendingSigner` object types. All fields are combined with a logical ‘and.’ */
export type ContractSignPendingSignerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ContractSignPendingSignerFilter>>;
  /** Filter by the object’s `coSigningUserIds` field. */
  coSigningUserIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `contractSignPending` relation. */
  contractSignPending?: InputMaybe<ContractSignPendingFilter>;
  /** Filter by the object’s `contractSignPendingId` field. */
  contractSignPendingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `ip` field. */
  ip?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lastReminded` field. */
  lastReminded?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ContractSignPendingSignerFilter>;
  /** Filter by the object’s `onBehalfOfUser` relation. */
  onBehalfOfUser?: InputMaybe<UserFilter>;
  /** A related `onBehalfOfUser` exists. */
  onBehalfOfUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `onBehalfOfUserId` field. */
  onBehalfOfUserId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ContractSignPendingSignerFilter>>;
  /** Filter by the object’s `refusalReason` field. */
  refusalReason?: InputMaybe<StringFilter>;
  /** Filter by the object’s `refused` field. */
  refused?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `signDate` field. */
  signDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `signOrder` field. */
  signOrder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `signatureFile` relation. */
  signatureFile?: InputMaybe<StorageFilter>;
  /** A related `signatureFile` exists. */
  signatureFileExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `signatureFileId` field. */
  signatureFileId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `signatureImage` field. */
  signatureImage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `signed` field. */
  signed?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `useSecondaryEmail` field. */
  useSecondaryEmail?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userAgent` field. */
  userAgent?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ContractSignPendingSigner` */
export type ContractSignPendingSignerInput = {
  coSigningUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  company?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  ip?: InputMaybe<Scalars['String']>;
  lastReminded?: InputMaybe<Scalars['Datetime']>;
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  refusalReason?: InputMaybe<Scalars['String']>;
  refused?: InputMaybe<Scalars['Boolean']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signOrder?: InputMaybe<Scalars['Int']>;
  signatureFileId?: InputMaybe<Scalars['UUID']>;
  signed?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInput>;
  useSecondaryEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInput>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `contractSignPendingSigner` to be created by this mutation. */
export type ContractSignPendingSignerOnBehalfOfUserIdForeignConnectionContractSignPendingSignerCreateInput = {
  coSigningUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  company?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  ip?: InputMaybe<Scalars['String']>;
  lastReminded?: InputMaybe<Scalars['Datetime']>;
  refusalReason?: InputMaybe<Scalars['String']>;
  refused?: InputMaybe<Scalars['Boolean']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signOrder?: InputMaybe<Scalars['Int']>;
  signatureFileId?: InputMaybe<Scalars['UUID']>;
  signed?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInput>;
  useSecondaryEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInput>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `user` in the `ContractSignPendingSignerInput` mutation. */
export type ContractSignPendingSignerOnBehalfOfUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnContractSignPendingSignerForContractSignPendingSignerOnBehalfOfUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `contractSignPendingSigner` in the `UserInput` mutation. */
export type ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput = {
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  connectByContractSignPendingIdAndUserId?: InputMaybe<Array<ContractSignPendingSignerUniqueSignerConnect>>;
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractSignPendingSignerContractSignPendingSignerPkeyConnect>>;
  /** A `ContractSignPendingSignerInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractSignPendingSignerOnBehalfOfUserIdForeignConnectionContractSignPendingSignerCreateInput>>;
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  deleteByContractSignPendingIdAndUserId?: InputMaybe<Array<ContractSignPendingSignerUniqueSignerDelete>>;
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ContractSignPendingSignerContractSignPendingSignerPkeyDelete>>;
  /** Flag indicating whether all other `contractSignPendingSigner` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `contractSignPendingSigner` for the far side of the relationship. */
  updateByContractSignPendingIdAndUserId?: InputMaybe<Array<ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerOnBehalfOfUserIdForeignUsingUniqueSignerUpdate>>;
  /** The primary key(s) and patch data for `contractSignPendingSigner` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerOnBehalfOfUserIdForeignUsingContractSignPendingSignerPkeyUpdate>>;
};

/** The fields on `contractSignPendingSigner` to look up the row to update. */
export type ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerCompanyIdForeignUsingContractSignPendingSignerPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPendingSigner` being updated. */
  patch: UpdateContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerCompanyIdForeignPatch;
};

/** The fields on `contractSignPendingSigner` to look up the row to update. */
export type ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerCompanyIdForeignUsingUniqueSignerUpdate = {
  contractSignPendingId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPendingSigner` being updated. */
  patch: UpdateContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerCompanyIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `contractSignPendingSigner` to look up the row to update. */
export type ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerContractSignPendingIdForeignUsingContractSignPendingSignerPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPendingSigner` being updated. */
  patch: UpdateContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerContractSignPendingIdForeignPatch;
};

/** The fields on `contractSignPendingSigner` to look up the row to update. */
export type ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerContractSignPendingIdForeignUsingUniqueSignerUpdate = {
  contractSignPendingId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPendingSigner` being updated. */
  patch: UpdateContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerContractSignPendingIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `contractSignPendingSigner` to look up the row to update. */
export type ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerOnBehalfOfUserIdForeignUsingContractSignPendingSignerPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPendingSigner` being updated. */
  patch: UpdateContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerOnBehalfOfUserIdForeignPatch;
};

/** The fields on `contractSignPendingSigner` to look up the row to update. */
export type ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerOnBehalfOfUserIdForeignUsingUniqueSignerUpdate = {
  contractSignPendingId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPendingSigner` being updated. */
  patch: UpdateContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerOnBehalfOfUserIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `contractSignPendingSigner` to look up the row to update. */
export type ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerSignatureFileIdForeignUsingContractSignPendingSignerPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPendingSigner` being updated. */
  patch: UpdateContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerSignatureFileIdForeignPatch;
};

/** The fields on `contractSignPendingSigner` to look up the row to update. */
export type ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerSignatureFileIdForeignUsingUniqueSignerUpdate = {
  contractSignPendingId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPendingSigner` being updated. */
  patch: UpdateContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerSignatureFileIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `contractSignPendingSigner` to look up the row to update. */
export type ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerUserIdForeignUsingContractSignPendingSignerPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPendingSigner` being updated. */
  patch: UpdateContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerUserIdForeignPatch;
};

/** The fields on `contractSignPendingSigner` to look up the row to update. */
export type ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerUserIdForeignUsingUniqueSignerUpdate = {
  contractSignPendingId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractSignPendingSigner` being updated. */
  patch: UpdateContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerUserIdForeignPatch;
  userId: Scalars['UUID'];
};

/** Represents an update to a `ContractSignPendingSigner`. Fields that are set will be updated. */
export type ContractSignPendingSignerPatch = {
  coSigningUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  company?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  ip?: InputMaybe<Scalars['String']>;
  lastReminded?: InputMaybe<Scalars['Datetime']>;
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  refusalReason?: InputMaybe<Scalars['String']>;
  refused?: InputMaybe<Scalars['Boolean']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signOrder?: InputMaybe<Scalars['Int']>;
  signatureFileId?: InputMaybe<Scalars['UUID']>;
  signed?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInput>;
  useSecondaryEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInput>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `contractSignPendingSigner` to be created by this mutation. */
export type ContractSignPendingSignerSignatureFileIdForeignConnectionContractSignPendingSignerCreateInput = {
  coSigningUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  company?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  ip?: InputMaybe<Scalars['String']>;
  lastReminded?: InputMaybe<Scalars['Datetime']>;
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  refusalReason?: InputMaybe<Scalars['String']>;
  refused?: InputMaybe<Scalars['Boolean']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signOrder?: InputMaybe<Scalars['Int']>;
  signed?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInput>;
  useSecondaryEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInput>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `storage` to be created by this mutation. */
export type ContractSignPendingSignerSignatureFileIdForeignConnectionStorageCreateInput = {
  access: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createCopy?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path: Scalars['String'];
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `storage` in the `ContractSignPendingSignerInput` mutation. */
export type ContractSignPendingSignerSignatureFileIdForeignInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<StorageStoragePkeyConnect>;
  /** A `StorageInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignConnectionStorageCreateInput>;
  /** The primary key(s) and patch data for `storage` for the far side of the relationship. */
  updateById?: InputMaybe<StorageOnContractSignPendingSignerForContractSignPendingSignerSignatureFileIdForeignUsingStoragePkeyUpdate>;
};

/** Input for the nested mutation of `contractSignPendingSigner` in the `StorageInput` mutation. */
export type ContractSignPendingSignerSignatureFileIdForeignInverseInput = {
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  connectByContractSignPendingIdAndUserId?: InputMaybe<Array<ContractSignPendingSignerUniqueSignerConnect>>;
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractSignPendingSignerContractSignPendingSignerPkeyConnect>>;
  /** A `ContractSignPendingSignerInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractSignPendingSignerSignatureFileIdForeignConnectionContractSignPendingSignerCreateInput>>;
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  deleteByContractSignPendingIdAndUserId?: InputMaybe<Array<ContractSignPendingSignerUniqueSignerDelete>>;
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ContractSignPendingSignerContractSignPendingSignerPkeyDelete>>;
  /** Flag indicating whether all other `contractSignPendingSigner` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `contractSignPendingSigner` for the far side of the relationship. */
  updateByContractSignPendingIdAndUserId?: InputMaybe<Array<ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerSignatureFileIdForeignUsingUniqueSignerUpdate>>;
  /** The primary key(s) and patch data for `contractSignPendingSigner` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerSignatureFileIdForeignUsingContractSignPendingSignerPkeyUpdate>>;
};

/** The fields on `contractSignPendingSigner` to look up the row to connect. */
export type ContractSignPendingSignerUniqueSignerConnect = {
  contractSignPendingId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `contractSignPendingSigner` to look up the row to delete. */
export type ContractSignPendingSignerUniqueSignerDelete = {
  contractSignPendingId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The `contractSignPendingSigner` to be created by this mutation. */
export type ContractSignPendingSignerUserIdForeignConnectionContractSignPendingSignerCreateInput = {
  coSigningUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  company?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  ip?: InputMaybe<Scalars['String']>;
  lastReminded?: InputMaybe<Scalars['Datetime']>;
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  refusalReason?: InputMaybe<Scalars['String']>;
  refused?: InputMaybe<Scalars['Boolean']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signOrder?: InputMaybe<Scalars['Int']>;
  signatureFileId?: InputMaybe<Scalars['UUID']>;
  signed?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInput>;
  useSecondaryEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInput>;
  userAgent?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `contractSignPendingSigner` in the `UserInput` mutation. */
export type ContractSignPendingSignerUserIdForeignInverseInput = {
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  connectByContractSignPendingIdAndUserId?: InputMaybe<Array<ContractSignPendingSignerUniqueSignerConnect>>;
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractSignPendingSignerContractSignPendingSignerPkeyConnect>>;
  /** A `ContractSignPendingSignerInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractSignPendingSignerUserIdForeignConnectionContractSignPendingSignerCreateInput>>;
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  deleteByContractSignPendingIdAndUserId?: InputMaybe<Array<ContractSignPendingSignerUniqueSignerDelete>>;
  /** The primary key(s) for `contractSignPendingSigner` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ContractSignPendingSignerContractSignPendingSignerPkeyDelete>>;
  /** Flag indicating whether all other `contractSignPendingSigner` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `contractSignPendingSigner` for the far side of the relationship. */
  updateByContractSignPendingIdAndUserId?: InputMaybe<Array<ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerUserIdForeignUsingUniqueSignerUpdate>>;
  /** The primary key(s) and patch data for `contractSignPendingSigner` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerUserIdForeignUsingContractSignPendingSignerPkeyUpdate>>;
};

/** A connection to a list of `ContractSignPendingSigner` values. */
export type ContractSignPendingSignersConnection = {
  __typename?: 'ContractSignPendingSignersConnection';
  /** A list of edges which contains the `ContractSignPendingSigner` and cursor to aid in pagination. */
  edges: Array<ContractSignPendingSignersEdge>;
  /** A list of `ContractSignPendingSigner` objects. */
  nodes: Array<Maybe<ContractSignPendingSigner>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ContractSignPendingSigner` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ContractSignPendingSigner` edge in the connection. */
export type ContractSignPendingSignersEdge = {
  __typename?: 'ContractSignPendingSignersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ContractSignPendingSigner` at the end of the edge. */
  node?: Maybe<ContractSignPendingSigner>;
};

/** Methods to use when ordering `ContractSignPendingSigner`. */
export type ContractSignPendingSignersOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ACTIVE_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ACTIVE_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ARCHIVED_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ARCHIVED_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__COMPANY_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__COMPANY_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__CREATED_AT_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__CREATED_AT_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__CREATOR_USER_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__CREATOR_USER_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__DEPARTMENTS_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__DEPARTMENTS_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__EMAIL_TEXT_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__EMAIL_TEXT_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__EMPLOYEE_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__EMPLOYEE_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ENFORCE_SIGN_ORDER_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ENFORCE_SIGN_ORDER_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__MERGED_DOCUMENT_DOCUMENT_TYPE_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__MERGED_DOCUMENT_DOCUMENT_TYPE_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__MERGED_DOCUMENT_NAME_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__MERGED_DOCUMENT_NAME_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__MERGE_INTO_ONE_DOCUMENT_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__MERGE_INTO_ONE_DOCUMENT_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__NEXT_SIGNING_USER_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__NEXT_SIGNING_USER_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__PREBOARDING_EMPLOYEE_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__PREBOARDING_EMPLOYEE_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__PREBOARDING_SLIDE_FORM_FIELD_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__PREBOARDING_SLIDE_FORM_FIELD_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__REMINDER_INTERVAL_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__REMINDER_INTERVAL_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__SIGNED_USER_IDS_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__SIGNED_USER_IDS_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__SIGNING_USER_IDS_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__SIGNING_USER_IDS_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__SIGN_DATE_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__SIGN_DATE_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__USER_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__USER_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_ID_DESC'
  | 'CO_SIGNING_USER_IDS_ASC'
  | 'CO_SIGNING_USER_IDS_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IP_ASC'
  | 'IP_DESC'
  | 'LAST_REMINDED_ASC'
  | 'LAST_REMINDED_DESC'
  | 'NATURAL'
  | 'ON_BEHALF_OF_USER_ID_ASC'
  | 'ON_BEHALF_OF_USER_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REFUSAL_REASON_ASC'
  | 'REFUSAL_REASON_DESC'
  | 'REFUSED_ASC'
  | 'REFUSED_DESC'
  | 'SIGNATURE_FILE_ID_ASC'
  | 'SIGNATURE_FILE_ID_DESC'
  | 'SIGNED_ASC'
  | 'SIGNED_DESC'
  | 'SIGN_DATE_ASC'
  | 'SIGN_DATE_DESC'
  | 'SIGN_ORDER_ASC'
  | 'SIGN_ORDER_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__ACCESS_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__ACCESS_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__ACTIVE_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__ACTIVE_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__BELONGS_TO_LEADER_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__BELONGS_TO_LEADER_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__COMPANY_ID_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__COMPANY_ID_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__CREATED_AT_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__CREATED_AT_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__DELETE_AT_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__DELETE_AT_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__DEPARTMENTS_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__DEPARTMENTS_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__DOCUMENT_FOLDER_ID_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__DOCUMENT_FOLDER_ID_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__DOCUMENT_TEMPLATE_ID_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__DOCUMENT_TEMPLATE_ID_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__DOCUMENT_TYPE_ID_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__DOCUMENT_TYPE_ID_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__EMPLOYEE_CASEFILE_ID_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__EMPLOYEE_CASEFILE_ID_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__EXPIRED_REMINDED_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__EXPIRED_REMINDED_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__EXPIRE_AT_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__EXPIRE_AT_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FILENAME_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FILENAME_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FILE_EXTENSION_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FILE_EXTENSION_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FILE_OWNER_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FILE_OWNER_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FILE_OWNER_ID_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FILE_OWNER_ID_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FILE_SIZE_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FILE_SIZE_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FILE_TYPE_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FILE_TYPE_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FOLDER_DEPARTMENT_IDS_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FOLDER_DEPARTMENT_IDS_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FOLDER_OWNER_ID_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FOLDER_OWNER_ID_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FOLDER_USER_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__FOLDER_USER_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__HTML_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__HTML_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__ID_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__ID_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__MIMETYPE_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__MIMETYPE_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__OWNER_NAME_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__OWNER_NAME_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__PATH_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__PATH_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__PENNEO_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__PENNEO_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__PLACEHOLDER_VALUES_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__PLACEHOLDER_VALUES_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__PROCESS_TYPE_ID_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__PROCESS_TYPE_ID_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__REMINDED_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__REMINDED_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__REMIND_AT_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__REMIND_AT_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__TEMPLATING_SERVICE_ID_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__TEMPLATING_SERVICE_ID_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__USERS_RESPONSIBLE_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__USERS_RESPONSIBLE_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__USERS_SHARED_WITH_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__USERS_SHARED_WITH_DEPARTMENTS_ASC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__USERS_SHARED_WITH_DEPARTMENTS_DESC'
  | 'STORAGE_BY_SIGNATURE_FILE_ID__USERS_SHARED_WITH_DESC'
  | 'USER_AGENT_ASC'
  | 'USER_AGENT_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__ACTIVE_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__ACTIVE_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__ADDRESS_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__ADDRESS_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CITY_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CITY_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CPR_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CPR_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMAIL_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMAIL_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__GODMODE_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__GODMODE_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__ID_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__ID_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__INITIALS_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__INITIALS_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__MOBILE_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__MOBILE_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__PHONE_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__PHONE_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__SENIORITY_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__SENIORITY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC'
  | 'USE_SECONDARY_EMAIL_ASC'
  | 'USE_SECONDARY_EMAIL_DESC';

/** A filter to be used against many `ContractSignPendingDocument` object types. All fields are combined with a logical ‘and.’ */
export type ContractSignPendingToManyContractSignPendingDocumentFilter = {
  /** Every related `ContractSignPendingDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractSignPendingDocumentFilter>;
  /** No related `ContractSignPendingDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractSignPendingDocumentFilter>;
  /** Some related `ContractSignPendingDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractSignPendingDocumentFilter>;
};

/** A filter to be used against many `ContractSignPendingSigner` object types. All fields are combined with a logical ‘and.’ */
export type ContractSignPendingToManyContractSignPendingSignerFilter = {
  /** Every related `ContractSignPendingSigner` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractSignPendingSignerFilter>;
  /** No related `ContractSignPendingSigner` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractSignPendingSignerFilter>;
  /** Some related `ContractSignPendingSigner` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractSignPendingSignerFilter>;
};

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type ContractSignPendingToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

/** Input for the nested mutation of `contractSignPending` in the `UserInput` mutation. */
export type ContractSignPendingUserIdFkeyInverseInput = {
  /** The primary key(s) for `contractSignPending` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractSignPendingContractSignPendingPkeyConnect>>;
  /** The primary key(s) and patch data for `contractSignPending` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractSignPendingOnContractSignPendingForContractSignPendingUserIdFkeyUsingContractSignPendingPkeyUpdate>>;
};

/** A connection to a list of `ContractSignPending` values. */
export type ContractSignPendingsConnection = {
  __typename?: 'ContractSignPendingsConnection';
  /** A list of edges which contains the `ContractSignPending` and cursor to aid in pagination. */
  edges: Array<ContractSignPendingsEdge>;
  /** A list of `ContractSignPending` objects. */
  nodes: Array<Maybe<ContractSignPending>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ContractSignPending` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ContractSignPending` edge in the connection. */
export type ContractSignPendingsEdge = {
  __typename?: 'ContractSignPendingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ContractSignPending` at the end of the edge. */
  node?: Maybe<ContractSignPending>;
};

/** Methods to use when ordering `ContractSignPending`. */
export type ContractSignPendingsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ARCHIVED_ASC'
  | 'ARCHIVED_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENTS_BY_CONTRACT_SIGN_PENDING_ID__COUNT_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENTS_BY_CONTRACT_SIGN_PENDING_ID__COUNT_DESC'
  | 'CONTRACT_SIGN_PENDING_SIGNERS_BY_CONTRACT_SIGN_PENDING_ID__COUNT_ASC'
  | 'CONTRACT_SIGN_PENDING_SIGNERS_BY_CONTRACT_SIGN_PENDING_ID__COUNT_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CREATOR_USER_ID_ASC'
  | 'CREATOR_USER_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__ACTIVE_ASC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__ACTIVE_DESC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__AUTO_DELETE_DAYS_ASC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__AUTO_DELETE_DAYS_DESC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__CREATED_AT_ASC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__CREATED_AT_DESC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__DEPARTMENT_ID_ASC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__DEPARTMENT_ID_DESC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__ID_ASC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__ID_DESC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__LIFETIME_ASC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__LIFETIME_DESC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__NAME_ASC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__NAME_DESC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'DOCUMENT_TYPE_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'EMAIL_TEXT_ASC'
  | 'EMAIL_TEXT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'ENFORCE_SIGN_ORDER_ASC'
  | 'ENFORCE_SIGN_ORDER_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MERGED_DOCUMENT_DOCUMENT_TYPE_ID_ASC'
  | 'MERGED_DOCUMENT_DOCUMENT_TYPE_ID_DESC'
  | 'MERGED_DOCUMENT_NAME_ASC'
  | 'MERGED_DOCUMENT_NAME_DESC'
  | 'MERGE_INTO_ONE_DOCUMENT_ASC'
  | 'MERGE_INTO_ONE_DOCUMENT_DESC'
  | 'NATURAL'
  | 'NEXT_SIGNING_USER_ID_ASC'
  | 'NEXT_SIGNING_USER_ID_DESC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_CONTRACT_SIGN_PENDING_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_CONTRACT_SIGN_PENDING_ID__COUNT_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ACTIVE_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ACTIVE_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ARCHIVED_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ARCHIVED_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__COMPLETED_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__COMPLETED_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__COMPLETED_REMINDED_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__COMPLETED_REMINDED_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__CONCLUSION_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__CONCLUSION_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__DEADLINE_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__DEADLINE_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__EMPLOYEE_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__EMPLOYEE_ID_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ID_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__MANAGER_IDS_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__MANAGER_IDS_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__NAME_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__NAME_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__PREBOARDING_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__PREBOARDING_ID_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__PUBLISHED_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__PUBLISHED_DATE_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__PUBLISHED_DATE_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__PUBLISHED_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__RECIPIENT_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__RECIPIENT_ID_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__REMINDER_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__REMINDER_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__RESPONSIBLE_IDS_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__RESPONSIBLE_IDS_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__USER_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__USER_ID_DESC'
  | 'PREBOARDING_EMPLOYEE_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_ID_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__ACTIVE_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__ACTIVE_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__COMPANY_ID_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__COMPANY_ID_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__DEPARTMENTS_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__DEPARTMENTS_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__FORM_FIELD_ID_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__FORM_FIELD_ID_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__ID_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__ID_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__ORDER_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__ORDER_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__PREBOARDING_SLIDE_ID_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__PREBOARDING_SLIDE_ID_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__REQUIRED_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__REQUIRED_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__SYSTEM_FIELD_NAME_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__SYSTEM_FIELD_NAME_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__USER_IDS_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__USER_IDS_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_ID_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REMINDER_INTERVAL_ASC'
  | 'REMINDER_INTERVAL_DESC'
  | 'SIGNED_USER_IDS_ASC'
  | 'SIGNED_USER_IDS_DESC'
  | 'SIGNING_USER_IDS_ASC'
  | 'SIGNING_USER_IDS_DESC'
  | 'SIGN_DATE_ASC'
  | 'SIGN_DATE_DESC'
  | 'USER_BY_CREATOR_USER_ID__ACTIVE_ASC'
  | 'USER_BY_CREATOR_USER_ID__ACTIVE_DESC'
  | 'USER_BY_CREATOR_USER_ID__ADDRESS_ASC'
  | 'USER_BY_CREATOR_USER_ID__ADDRESS_DESC'
  | 'USER_BY_CREATOR_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_CREATOR_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_CREATOR_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_CREATOR_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_CREATOR_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_CREATOR_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_CREATOR_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_CREATOR_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_CREATOR_USER_ID__CITY_ASC'
  | 'USER_BY_CREATOR_USER_ID__CITY_DESC'
  | 'USER_BY_CREATOR_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_CREATOR_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_CREATOR_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_CREATOR_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_CREATOR_USER_ID__CPR_ASC'
  | 'USER_BY_CREATOR_USER_ID__CPR_DESC'
  | 'USER_BY_CREATOR_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_CREATOR_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_CREATOR_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_CREATOR_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_CREATOR_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_CREATOR_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_CREATOR_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_CREATOR_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMAIL_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMAIL_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_CREATOR_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_CREATOR_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_CREATOR_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_CREATOR_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_CREATOR_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_CREATOR_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_CREATOR_USER_ID__GODMODE_ASC'
  | 'USER_BY_CREATOR_USER_ID__GODMODE_DESC'
  | 'USER_BY_CREATOR_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_CREATOR_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_CREATOR_USER_ID__ID_ASC'
  | 'USER_BY_CREATOR_USER_ID__ID_DESC'
  | 'USER_BY_CREATOR_USER_ID__INITIALS_ASC'
  | 'USER_BY_CREATOR_USER_ID__INITIALS_DESC'
  | 'USER_BY_CREATOR_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_CREATOR_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_CREATOR_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_CREATOR_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_CREATOR_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_CREATOR_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_CREATOR_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_CREATOR_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_CREATOR_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_CREATOR_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_CREATOR_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_CREATOR_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_CREATOR_USER_ID__MOBILE_ASC'
  | 'USER_BY_CREATOR_USER_ID__MOBILE_DESC'
  | 'USER_BY_CREATOR_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_CREATOR_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_CREATOR_USER_ID__PHONE_ASC'
  | 'USER_BY_CREATOR_USER_ID__PHONE_DESC'
  | 'USER_BY_CREATOR_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_CREATOR_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_CREATOR_USER_ID__SENIORITY_ASC'
  | 'USER_BY_CREATOR_USER_ID__SENIORITY_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__ACTIVE_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__ACTIVE_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__ADDRESS_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__ADDRESS_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CITY_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CITY_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CPR_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CPR_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMAIL_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMAIL_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__GODMODE_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__GODMODE_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__ID_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__ID_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__INITIALS_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__INITIALS_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__MOBILE_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__MOBILE_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__PHONE_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__PHONE_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__SENIORITY_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__SENIORITY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type ContractSignerInput = {
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  signingUserId: Scalars['UUID'];
  useSecondaryEmail?: InputMaybe<Scalars['Boolean']>;
};

export type ContractTemplate = {
  __typename?: 'ContractTemplate';
  active: Scalars['Boolean'];
  bottomMargin: Scalars['BigFloat'];
  companyId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `ContractSignPendingDocument`. */
  contractSignPendingDocuments: ContractSignPendingDocumentsConnection;
  contractSignPendingUserIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads and enables pagination through a set of `ContractTemplateDepartment`. */
  contractTemplateDepartments: ContractTemplateDepartmentsConnection;
  /** Reads and enables pagination through a set of `ContractTemplateFormField`. */
  contractTemplateFormFields: ContractTemplateFormFieldsConnection;
  /** Reads and enables pagination through a set of `ContractTemplateUser`. */
  contractTemplateUsers: ContractTemplateUsersConnection;
  createdAt: Scalars['Datetime'];
  dateFormat: Scalars['String'];
  departmentsSharedWith?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  description?: Maybe<Scalars['String']>;
  /** Reads a single `DocumentType` that is related to this `ContractTemplate`. */
  documentType?: Maybe<DocumentType>;
  documentTypeId?: Maybe<Scalars['UUID']>;
  footer?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  htmlPlaceholders?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['UUID'];
  isGlobal?: Maybe<Scalars['Boolean']>;
  jobPositionTypes?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  leftMargin: Scalars['BigFloat'];
  locale: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  pageNumber: Scalars['Boolean'];
  placeholders?: Maybe<Scalars['JSON']>;
  rightMargin: Scalars['BigFloat'];
  signable: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `Storage`. */
  storagesByDocumentTemplateId: StoragesConnection;
  templatingServiceId?: Maybe<Scalars['UUID']>;
  topMargin: Scalars['BigFloat'];
  updatedAt: Scalars['Datetime'];
  usersSharedWith?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};


export type ContractTemplateContractSignPendingDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingDocumentCondition>;
  filter?: InputMaybe<ContractSignPendingDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingDocumentsOrderBy>>;
};


export type ContractTemplateContractTemplateDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractTemplateDepartmentCondition>;
  filter?: InputMaybe<ContractTemplateDepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractTemplateDepartmentsOrderBy>>;
};


export type ContractTemplateContractTemplateFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractTemplateFormFieldCondition>;
  filter?: InputMaybe<ContractTemplateFormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractTemplateFormFieldsOrderBy>>;
};


export type ContractTemplateContractTemplateUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractTemplateUserCondition>;
  filter?: InputMaybe<ContractTemplateUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractTemplateUsersOrderBy>>;
};


export type ContractTemplateStoragesByDocumentTemplateIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<StorageCondition>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StoragesOrderBy>>;
};

/**
 * A condition to be used against `ContractTemplate` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ContractTemplateCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `bottomMargin` field. */
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `contractSignPendingUserIds` field. */
  contractSignPendingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `dateFormat` field. */
  dateFormat?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `departmentsSharedWith` field. */
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `documentTypeId` field. */
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `footer` field. */
  footer?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `header` field. */
  header?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `html` field. */
  html?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `htmlPlaceholders` field. */
  htmlPlaceholders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isGlobal` field. */
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `jobPositionTypes` field. */
  jobPositionTypes?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `leftMargin` field. */
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `locale` field. */
  locale?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `placeholders` field. */
  placeholders?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `rightMargin` field. */
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `signable` field. */
  signable?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `templatingServiceId` field. */
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `topMargin` field. */
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `usersSharedWith` field. */
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The fields on `contractTemplate` to look up the row to connect. */
export type ContractTemplateContractTemplatePkeyConnect = {
  id: Scalars['UUID'];
};

export type ContractTemplateDepartment = {
  __typename?: 'ContractTemplateDepartment';
  /** Reads a single `Company` that is related to this `ContractTemplateDepartment`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `ContractTemplate` that is related to this `ContractTemplateDepartment`. */
  contractTemplate?: Maybe<ContractTemplate>;
  contractTemplateId: Scalars['UUID'];
  contractTemplateIsSignable?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Datetime'];
  /** Reads a single `Department` that is related to this `ContractTemplateDepartment`. */
  department?: Maybe<Department>;
  departmentId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `ContractTemplateDepartment` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ContractTemplateDepartmentCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `contractTemplateId` field. */
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `contractTemplateIsSignable` field. */
  contractTemplateIsSignable?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departmentId` field. */
  departmentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `contractTemplateDepartment` to look up the row to connect. */
export type ContractTemplateDepartmentContractTemplateDepartmentsPkeyConnect = {
  contractTemplateId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
};

/** The fields on `contractTemplateDepartment` to look up the row to delete. */
export type ContractTemplateDepartmentContractTemplateDepartmentsPkeyDelete = {
  contractTemplateId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
};

/** A filter to be used against `ContractTemplateDepartment` object types. All fields are combined with a logical ‘and.’ */
export type ContractTemplateDepartmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ContractTemplateDepartmentFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `contractTemplate` relation. */
  contractTemplate?: InputMaybe<ContractTemplateFilter>;
  /** Filter by the object’s `contractTemplateId` field. */
  contractTemplateId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `contractTemplateIsSignable` field. */
  contractTemplateIsSignable?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `department` relation. */
  department?: InputMaybe<DepartmentFilter>;
  /** Filter by the object’s `departmentId` field. */
  departmentId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ContractTemplateDepartmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ContractTemplateDepartmentFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ContractTemplateDepartment` */
export type ContractTemplateDepartmentInput = {
  company?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  contractTemplateIsSignable?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `contractTemplateDepartment` to look up the row to update. */
export type ContractTemplateDepartmentOnContractTemplateDepartmentForContractTemplateDepartmentsCompanyIdFkeyUsingContractTemplateDepartmentsPkeyUpdate = {
  contractTemplateId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractTemplateDepartment` being updated. */
  patch: UpdateContractTemplateDepartmentOnContractTemplateDepartmentForContractTemplateDepartmentsCompanyIdFkeyPatch;
};

/** The fields on `contractTemplateDepartment` to look up the row to update. */
export type ContractTemplateDepartmentOnContractTemplateDepartmentForContractTemplateDepartmentsContractTemplateIdForeignUsingContractTemplateDepartmentsPkeyUpdate = {
  contractTemplateId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractTemplateDepartment` being updated. */
  patch: UpdateContractTemplateDepartmentOnContractTemplateDepartmentForContractTemplateDepartmentsContractTemplateIdForeignPatch;
};

/** The fields on `contractTemplateDepartment` to look up the row to update. */
export type ContractTemplateDepartmentOnContractTemplateDepartmentForContractTemplateDepartmentsDepartmentIdForeignUsingContractTemplateDepartmentsPkeyUpdate = {
  contractTemplateId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractTemplateDepartment` being updated. */
  patch: UpdateContractTemplateDepartmentOnContractTemplateDepartmentForContractTemplateDepartmentsDepartmentIdForeignPatch;
};

/** Represents an update to a `ContractTemplateDepartment`. Fields that are set will be updated. */
export type ContractTemplateDepartmentPatch = {
  company?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  contractTemplateIsSignable?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `contractTemplateDepartment` to be created by this mutation. */
export type ContractTemplateDepartmentsCompanyIdFkeyConnectionContractTemplateDepartmentsCreateInput = {
  company?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInput>;
  contractTemplate?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  contractTemplateIsSignable?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `company` in the `ContractTemplateDepartmentInput` mutation. */
export type ContractTemplateDepartmentsCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnContractTemplateDepartmentForContractTemplateDepartmentsCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `contractTemplateDepartment` in the `CompanyInput` mutation. */
export type ContractTemplateDepartmentsCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `contractTemplateDepartment` for the far side of the relationship. */
  connectByContractTemplateIdAndDepartmentId?: InputMaybe<Array<ContractTemplateDepartmentContractTemplateDepartmentsPkeyConnect>>;
  /** A `ContractTemplateDepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractTemplateDepartmentsCompanyIdFkeyConnectionContractTemplateDepartmentsCreateInput>>;
  /** The primary key(s) for `contractTemplateDepartment` for the far side of the relationship. */
  deleteByContractTemplateIdAndDepartmentId?: InputMaybe<Array<ContractTemplateDepartmentContractTemplateDepartmentsPkeyDelete>>;
  /** Flag indicating whether all other `contractTemplateDepartment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `contractTemplateDepartment` for the far side of the relationship. */
  updateByContractTemplateIdAndDepartmentId?: InputMaybe<Array<ContractTemplateDepartmentOnContractTemplateDepartmentForContractTemplateDepartmentsCompanyIdFkeyUsingContractTemplateDepartmentsPkeyUpdate>>;
};

/** A connection to a list of `ContractTemplateDepartment` values. */
export type ContractTemplateDepartmentsConnection = {
  __typename?: 'ContractTemplateDepartmentsConnection';
  /** A list of edges which contains the `ContractTemplateDepartment` and cursor to aid in pagination. */
  edges: Array<ContractTemplateDepartmentsEdge>;
  /** A list of `ContractTemplateDepartment` objects. */
  nodes: Array<Maybe<ContractTemplateDepartment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ContractTemplateDepartment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The `contractTemplate` to be created by this mutation. */
export type ContractTemplateDepartmentsContractTemplateIdForeignConnectionContractTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInverseInput>;
  contractSignPendingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInverseInput>;
  contractTemplateFormFields?: InputMaybe<ContractTemplateFormFieldContractTemplateIdForeignInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<ContractTemplateDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  footer?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  htmlPlaceholders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  jobPositionTypes?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  placeholders?: InputMaybe<Scalars['JSON']>;
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
  signable?: InputMaybe<Scalars['Boolean']>;
  storages?: InputMaybe<StorageDocumentTemplateIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `contractTemplateDepartment` to be created by this mutation. */
export type ContractTemplateDepartmentsContractTemplateIdForeignConnectionContractTemplateDepartmentsCreateInput = {
  company?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInput>;
  contractTemplateIsSignable?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `contractTemplate` in the `ContractTemplateDepartmentInput` mutation. */
export type ContractTemplateDepartmentsContractTemplateIdForeignInput = {
  /** The primary key(s) for `contractTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<ContractTemplateContractTemplatePkeyConnect>;
  /** A `ContractTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignConnectionContractTemplateCreateInput>;
  /** The primary key(s) and patch data for `contractTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<ContractTemplateOnContractTemplateDepartmentForContractTemplateDepartmentsContractTemplateIdForeignUsingContractTemplatePkeyUpdate>;
};

/** Input for the nested mutation of `contractTemplateDepartment` in the `ContractTemplateInput` mutation. */
export type ContractTemplateDepartmentsContractTemplateIdForeignInverseInput = {
  /** The primary key(s) for `contractTemplateDepartment` for the far side of the relationship. */
  connectByContractTemplateIdAndDepartmentId?: InputMaybe<Array<ContractTemplateDepartmentContractTemplateDepartmentsPkeyConnect>>;
  /** A `ContractTemplateDepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractTemplateDepartmentsContractTemplateIdForeignConnectionContractTemplateDepartmentsCreateInput>>;
  /** The primary key(s) for `contractTemplateDepartment` for the far side of the relationship. */
  deleteByContractTemplateIdAndDepartmentId?: InputMaybe<Array<ContractTemplateDepartmentContractTemplateDepartmentsPkeyDelete>>;
  /** Flag indicating whether all other `contractTemplateDepartment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `contractTemplateDepartment` for the far side of the relationship. */
  updateByContractTemplateIdAndDepartmentId?: InputMaybe<Array<ContractTemplateDepartmentOnContractTemplateDepartmentForContractTemplateDepartmentsContractTemplateIdForeignUsingContractTemplateDepartmentsPkeyUpdate>>;
};

/** The `contractTemplateDepartment` to be created by this mutation. */
export type ContractTemplateDepartmentsDepartmentIdForeignConnectionContractTemplateDepartmentsCreateInput = {
  company?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  contractTemplateIsSignable?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `department` to be created by this mutation. */
export type ContractTemplateDepartmentsDepartmentIdForeignConnectionDepartmentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** Input for the nested mutation of `department` in the `ContractTemplateDepartmentInput` mutation. */
export type ContractTemplateDepartmentsDepartmentIdForeignInput = {
  /** The primary key(s) for `department` for the far side of the relationship. */
  connectById?: InputMaybe<DepartmentDepartmentPkeyConnect>;
  /** A `DepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignConnectionDepartmentCreateInput>;
  /** The primary key(s) and patch data for `department` for the far side of the relationship. */
  updateById?: InputMaybe<DepartmentOnContractTemplateDepartmentForContractTemplateDepartmentsDepartmentIdForeignUsingDepartmentPkeyUpdate>;
};

/** Input for the nested mutation of `contractTemplateDepartment` in the `DepartmentInput` mutation. */
export type ContractTemplateDepartmentsDepartmentIdForeignInverseInput = {
  /** The primary key(s) for `contractTemplateDepartment` for the far side of the relationship. */
  connectByContractTemplateIdAndDepartmentId?: InputMaybe<Array<ContractTemplateDepartmentContractTemplateDepartmentsPkeyConnect>>;
  /** A `ContractTemplateDepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractTemplateDepartmentsDepartmentIdForeignConnectionContractTemplateDepartmentsCreateInput>>;
  /** The primary key(s) for `contractTemplateDepartment` for the far side of the relationship. */
  deleteByContractTemplateIdAndDepartmentId?: InputMaybe<Array<ContractTemplateDepartmentContractTemplateDepartmentsPkeyDelete>>;
  /** Flag indicating whether all other `contractTemplateDepartment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `contractTemplateDepartment` for the far side of the relationship. */
  updateByContractTemplateIdAndDepartmentId?: InputMaybe<Array<ContractTemplateDepartmentOnContractTemplateDepartmentForContractTemplateDepartmentsDepartmentIdForeignUsingContractTemplateDepartmentsPkeyUpdate>>;
};

/** A `ContractTemplateDepartment` edge in the connection. */
export type ContractTemplateDepartmentsEdge = {
  __typename?: 'ContractTemplateDepartmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ContractTemplateDepartment` at the end of the edge. */
  node?: Maybe<ContractTemplateDepartment>;
};

/** Methods to use when ordering `ContractTemplateDepartment`. */
export type ContractTemplateDepartmentsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__ACTIVE_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__ACTIVE_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__BOTTOM_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__BOTTOM_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__COMPANY_ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__COMPANY_ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__CONTRACT_SIGN_PENDING_USER_IDS_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__CONTRACT_SIGN_PENDING_USER_IDS_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__CREATED_AT_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__CREATED_AT_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DATE_FORMAT_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DATE_FORMAT_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DESCRIPTION_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DESCRIPTION_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DOCUMENT_TYPE_ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DOCUMENT_TYPE_ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__FOOTER_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__FOOTER_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HEADER_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HEADER_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HTML_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HTML_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HTML_PLACEHOLDERS_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HTML_PLACEHOLDERS_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__IS_GLOBAL_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__IS_GLOBAL_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__JOB_POSITION_TYPES_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__JOB_POSITION_TYPES_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__LEFT_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__LEFT_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__LOCALE_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__LOCALE_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__NAME_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__NAME_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__PAGE_NUMBER_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__PAGE_NUMBER_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__PLACEHOLDERS_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__PLACEHOLDERS_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__RIGHT_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__RIGHT_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__SIGNABLE_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__SIGNABLE_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__TEMPLATING_SERVICE_ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__TEMPLATING_SERVICE_ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__TOP_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__TOP_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__UPDATED_AT_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__UPDATED_AT_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__USERS_SHARED_WITH_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__USERS_SHARED_WITH_DESC'
  | 'CONTRACT_TEMPLATE_ID_ASC'
  | 'CONTRACT_TEMPLATE_ID_DESC'
  | 'CONTRACT_TEMPLATE_IS_SIGNABLE_ASC'
  | 'CONTRACT_TEMPLATE_IS_SIGNABLE_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ACTIVE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ACTIVE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ADDRESS_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ADDRESS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ALIAS_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ALIAS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CITY_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CITY_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COMPANY_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COMPANY_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COUNTRY_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COUNTRY_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CREATED_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CREATED_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CUSTOM_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CUSTOM_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CVR_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CVR_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DELETE_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DELETE_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_NUMBER_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_NUMBER_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DESCRIPTION_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DESCRIPTION_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EAN_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EAN_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EMAIL_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EMAIL_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__MAIN_DEPARTMENT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__MAIN_DEPARTMENT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__NAME_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__NAME_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PHONE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PHONE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__POSTAL_CODE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__POSTAL_CODE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__P_NUMBER_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__P_NUMBER_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__UPDATED_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__UPDATED_AT_DESC'
  | 'DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** The `contractTemplate` to be created by this mutation. */
export type ContractTemplateDocumentTypeIdForeignConnectionContractTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInverseInput>;
  contractSignPendingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInverseInput>;
  contractTemplateFormFields?: InputMaybe<ContractTemplateFormFieldContractTemplateIdForeignInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<ContractTemplateDocumentTypeIdForeignInput>;
  footer?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  htmlPlaceholders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  jobPositionTypes?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  placeholders?: InputMaybe<Scalars['JSON']>;
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
  signable?: InputMaybe<Scalars['Boolean']>;
  storages?: InputMaybe<StorageDocumentTemplateIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `documentType` to be created by this mutation. */
export type ContractTemplateDocumentTypeIdForeignConnectionDocumentTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput>;
  contractTemplates?: InputMaybe<ContractTemplateDocumentTypeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lifetime?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  storages?: InputMaybe<StorageDocumentTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `documentType` in the `ContractTemplateInput` mutation. */
export type ContractTemplateDocumentTypeIdForeignInput = {
  /** The primary key(s) for `documentType` for the far side of the relationship. */
  connectByCompanyIdAndDepartmentIdAndName?: InputMaybe<DocumentTypeDocumentTypeCompanyIdDepartmentIdNameUniqueConnect>;
  /** The primary key(s) for `documentType` for the far side of the relationship. */
  connectById?: InputMaybe<DocumentTypeDocumentTypePkeyConnect>;
  /** A `DocumentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContractTemplateDocumentTypeIdForeignConnectionDocumentTypeCreateInput>;
  /** The primary key(s) and patch data for `documentType` for the far side of the relationship. */
  updateByCompanyIdAndDepartmentIdAndName?: InputMaybe<DocumentTypeOnContractTemplateForContractTemplateDocumentTypeIdForeignUsingDocumentTypeCompanyIdDepartmentIdNameUniqueUpdate>;
  /** The primary key(s) and patch data for `documentType` for the far side of the relationship. */
  updateById?: InputMaybe<DocumentTypeOnContractTemplateForContractTemplateDocumentTypeIdForeignUsingDocumentTypePkeyUpdate>;
};

/** Input for the nested mutation of `contractTemplate` in the `DocumentTypeInput` mutation. */
export type ContractTemplateDocumentTypeIdForeignInverseInput = {
  /** The primary key(s) for `contractTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContractTemplateContractTemplatePkeyConnect>>;
  /** A `ContractTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractTemplateDocumentTypeIdForeignConnectionContractTemplateCreateInput>>;
  /** The primary key(s) and patch data for `contractTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ContractTemplateOnContractTemplateForContractTemplateDocumentTypeIdForeignUsingContractTemplatePkeyUpdate>>;
};

/** A filter to be used against `ContractTemplate` object types. All fields are combined with a logical ‘and.’ */
export type ContractTemplateFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ContractTemplateFilter>>;
  /** Filter by the object’s `bottomMargin` field. */
  bottomMargin?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `contractSignPendingDocuments` relation. */
  contractSignPendingDocuments?: InputMaybe<ContractTemplateToManyContractSignPendingDocumentFilter>;
  /** Some related `contractSignPendingDocuments` exist. */
  contractSignPendingDocumentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractSignPendingUserIds` field. */
  contractSignPendingUserIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `contractTemplateDepartments` relation. */
  contractTemplateDepartments?: InputMaybe<ContractTemplateToManyContractTemplateDepartmentFilter>;
  /** Some related `contractTemplateDepartments` exist. */
  contractTemplateDepartmentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractTemplateFormFields` relation. */
  contractTemplateFormFields?: InputMaybe<ContractTemplateToManyContractTemplateFormFieldFilter>;
  /** Some related `contractTemplateFormFields` exist. */
  contractTemplateFormFieldsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractTemplateUsers` relation. */
  contractTemplateUsers?: InputMaybe<ContractTemplateToManyContractTemplateUserFilter>;
  /** Some related `contractTemplateUsers` exist. */
  contractTemplateUsersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateFormat` field. */
  dateFormat?: InputMaybe<StringFilter>;
  /** Filter by the object’s `departmentsSharedWith` field. */
  departmentsSharedWith?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `documentType` relation. */
  documentType?: InputMaybe<DocumentTypeFilter>;
  /** A related `documentType` exists. */
  documentTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentTypeId` field. */
  documentTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `footer` field. */
  footer?: InputMaybe<StringFilter>;
  /** Filter by the object’s `header` field. */
  header?: InputMaybe<StringFilter>;
  /** Filter by the object’s `html` field. */
  html?: InputMaybe<StringFilter>;
  /** Filter by the object’s `htmlPlaceholders` field. */
  htmlPlaceholders?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isGlobal` field. */
  isGlobal?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `jobPositionTypes` field. */
  jobPositionTypes?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `leftMargin` field. */
  leftMargin?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `locale` field. */
  locale?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ContractTemplateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ContractTemplateFilter>>;
  /** Filter by the object’s `pageNumber` field. */
  pageNumber?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `placeholders` field. */
  placeholders?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `rightMargin` field. */
  rightMargin?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `signable` field. */
  signable?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `storagesByDocumentTemplateId` relation. */
  storagesByDocumentTemplateId?: InputMaybe<ContractTemplateToManyStorageFilter>;
  /** Some related `storagesByDocumentTemplateId` exist. */
  storagesByDocumentTemplateIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `templatingServiceId` field. */
  templatingServiceId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `topMargin` field. */
  topMargin?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `usersSharedWith` field. */
  usersSharedWith?: InputMaybe<UuidListFilter>;
};

export type ContractTemplateFormField = {
  __typename?: 'ContractTemplateFormField';
  /** Reads a single `ContractTemplate` that is related to this `ContractTemplateFormField`. */
  contractTemplate?: Maybe<ContractTemplate>;
  contractTemplateId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  formFieldId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `ContractTemplateFormField` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ContractTemplateFormFieldCondition = {
  /** Checks for equality with the object’s `contractTemplateId` field. */
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `contractTemplate` to be created by this mutation. */
export type ContractTemplateFormFieldContractTemplateIdForeignConnectionContractTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInverseInput>;
  contractSignPendingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInverseInput>;
  contractTemplateFormFields?: InputMaybe<ContractTemplateFormFieldContractTemplateIdForeignInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<ContractTemplateDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  footer?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  htmlPlaceholders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  jobPositionTypes?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  placeholders?: InputMaybe<Scalars['JSON']>;
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
  signable?: InputMaybe<Scalars['Boolean']>;
  storages?: InputMaybe<StorageDocumentTemplateIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `contractTemplateFormField` to be created by this mutation. */
export type ContractTemplateFormFieldContractTemplateIdForeignConnectionContractTemplateFormFieldCreateInput = {
  contractTemplate?: InputMaybe<ContractTemplateFormFieldContractTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldId: Scalars['UUID'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `contractTemplate` in the `ContractTemplateFormFieldInput` mutation. */
export type ContractTemplateFormFieldContractTemplateIdForeignInput = {
  /** The primary key(s) for `contractTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<ContractTemplateContractTemplatePkeyConnect>;
  /** A `ContractTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContractTemplateFormFieldContractTemplateIdForeignConnectionContractTemplateCreateInput>;
  /** The primary key(s) and patch data for `contractTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<ContractTemplateOnContractTemplateFormFieldForContractTemplateFormFieldContractTemplateIdForeignUsingContractTemplatePkeyUpdate>;
};

/** Input for the nested mutation of `contractTemplateFormField` in the `ContractTemplateInput` mutation. */
export type ContractTemplateFormFieldContractTemplateIdForeignInverseInput = {
  /** A `ContractTemplateFormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractTemplateFormFieldContractTemplateIdForeignConnectionContractTemplateFormFieldCreateInput>>;
};

/** A filter to be used against `ContractTemplateFormField` object types. All fields are combined with a logical ‘and.’ */
export type ContractTemplateFormFieldFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ContractTemplateFormFieldFilter>>;
  /** Filter by the object’s `contractTemplate` relation. */
  contractTemplate?: InputMaybe<ContractTemplateFilter>;
  /** Filter by the object’s `contractTemplateId` field. */
  contractTemplateId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ContractTemplateFormFieldFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ContractTemplateFormFieldFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ContractTemplateFormField` */
export type ContractTemplateFormFieldInput = {
  contractTemplate?: InputMaybe<ContractTemplateFormFieldContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldId: Scalars['UUID'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `ContractTemplateFormField` values. */
export type ContractTemplateFormFieldsConnection = {
  __typename?: 'ContractTemplateFormFieldsConnection';
  /** A list of edges which contains the `ContractTemplateFormField` and cursor to aid in pagination. */
  edges: Array<ContractTemplateFormFieldsEdge>;
  /** A list of `ContractTemplateFormField` objects. */
  nodes: Array<Maybe<ContractTemplateFormField>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ContractTemplateFormField` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ContractTemplateFormField` edge in the connection. */
export type ContractTemplateFormFieldsEdge = {
  __typename?: 'ContractTemplateFormFieldsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ContractTemplateFormField` at the end of the edge. */
  node?: Maybe<ContractTemplateFormField>;
};

/** Methods to use when ordering `ContractTemplateFormField`. */
export type ContractTemplateFormFieldsOrderBy =
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__ACTIVE_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__ACTIVE_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__BOTTOM_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__BOTTOM_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__COMPANY_ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__COMPANY_ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__CONTRACT_SIGN_PENDING_USER_IDS_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__CONTRACT_SIGN_PENDING_USER_IDS_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__CREATED_AT_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__CREATED_AT_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DATE_FORMAT_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DATE_FORMAT_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DESCRIPTION_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DESCRIPTION_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DOCUMENT_TYPE_ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DOCUMENT_TYPE_ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__FOOTER_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__FOOTER_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HEADER_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HEADER_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HTML_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HTML_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HTML_PLACEHOLDERS_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HTML_PLACEHOLDERS_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__IS_GLOBAL_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__IS_GLOBAL_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__JOB_POSITION_TYPES_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__JOB_POSITION_TYPES_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__LEFT_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__LEFT_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__LOCALE_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__LOCALE_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__NAME_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__NAME_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__PAGE_NUMBER_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__PAGE_NUMBER_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__PLACEHOLDERS_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__PLACEHOLDERS_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__RIGHT_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__RIGHT_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__SIGNABLE_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__SIGNABLE_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__TEMPLATING_SERVICE_ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__TEMPLATING_SERVICE_ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__TOP_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__TOP_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__UPDATED_AT_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__UPDATED_AT_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__USERS_SHARED_WITH_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__USERS_SHARED_WITH_DESC'
  | 'CONTRACT_TEMPLATE_ID_ASC'
  | 'CONTRACT_TEMPLATE_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_ID_DESC'
  | 'NATURAL'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** An input for mutations affecting `ContractTemplate` */
export type ContractTemplateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInverseInput>;
  contractSignPendingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInverseInput>;
  contractTemplateFormFields?: InputMaybe<ContractTemplateFormFieldContractTemplateIdForeignInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<ContractTemplateDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  footer?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  htmlPlaceholders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  jobPositionTypes?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  placeholders?: InputMaybe<Scalars['JSON']>;
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
  signable?: InputMaybe<Scalars['Boolean']>;
  storages?: InputMaybe<StorageDocumentTemplateIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The fields on `contractTemplate` to look up the row to update. */
export type ContractTemplateOnContractSignPendingDocumentForContractSignPendingDocumentContractTemplateIdForeignUsingContractTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractTemplate` being updated. */
  patch: UpdateContractTemplateOnContractSignPendingDocumentForContractSignPendingDocumentContractTemplateIdForeignPatch;
};

/** The fields on `contractTemplate` to look up the row to update. */
export type ContractTemplateOnContractTemplateDepartmentForContractTemplateDepartmentsContractTemplateIdForeignUsingContractTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractTemplate` being updated. */
  patch: UpdateContractTemplateOnContractTemplateDepartmentForContractTemplateDepartmentsContractTemplateIdForeignPatch;
};

/** The fields on `contractTemplate` to look up the row to update. */
export type ContractTemplateOnContractTemplateForContractTemplateDocumentTypeIdForeignUsingContractTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractTemplate` being updated. */
  patch: UpdateContractTemplateOnContractTemplateForContractTemplateDocumentTypeIdForeignPatch;
};

/** The fields on `contractTemplate` to look up the row to update. */
export type ContractTemplateOnContractTemplateFormFieldForContractTemplateFormFieldContractTemplateIdForeignUsingContractTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractTemplate` being updated. */
  patch: UpdateContractTemplateOnContractTemplateFormFieldForContractTemplateFormFieldContractTemplateIdForeignPatch;
};

/** The fields on `contractTemplate` to look up the row to update. */
export type ContractTemplateOnContractTemplateUserForContractTemplateUsersContractTemplateIdForeignUsingContractTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractTemplate` being updated. */
  patch: UpdateContractTemplateOnContractTemplateUserForContractTemplateUsersContractTemplateIdForeignPatch;
};

/** The fields on `contractTemplate` to look up the row to update. */
export type ContractTemplateOnStorageForStorageDocumentTemplateIdForeignUsingContractTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractTemplate` being updated. */
  patch: UpdateContractTemplateOnStorageForStorageDocumentTemplateIdForeignPatch;
};

/** Represents an update to a `ContractTemplate`. Fields that are set will be updated. */
export type ContractTemplatePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInverseInput>;
  contractSignPendingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInverseInput>;
  contractTemplateFormFields?: InputMaybe<ContractTemplateFormFieldContractTemplateIdForeignInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<ContractTemplateDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  footer?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  htmlPlaceholders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  jobPositionTypes?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  placeholders?: InputMaybe<Scalars['JSON']>;
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
  signable?: InputMaybe<Scalars['Boolean']>;
  storages?: InputMaybe<StorageDocumentTemplateIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** A filter to be used against many `ContractSignPendingDocument` object types. All fields are combined with a logical ‘and.’ */
export type ContractTemplateToManyContractSignPendingDocumentFilter = {
  /** Every related `ContractSignPendingDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractSignPendingDocumentFilter>;
  /** No related `ContractSignPendingDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractSignPendingDocumentFilter>;
  /** Some related `ContractSignPendingDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractSignPendingDocumentFilter>;
};

/** A filter to be used against many `ContractTemplateDepartment` object types. All fields are combined with a logical ‘and.’ */
export type ContractTemplateToManyContractTemplateDepartmentFilter = {
  /** Every related `ContractTemplateDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractTemplateDepartmentFilter>;
  /** No related `ContractTemplateDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractTemplateDepartmentFilter>;
  /** Some related `ContractTemplateDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractTemplateDepartmentFilter>;
};

/** A filter to be used against many `ContractTemplateFormField` object types. All fields are combined with a logical ‘and.’ */
export type ContractTemplateToManyContractTemplateFormFieldFilter = {
  /** Every related `ContractTemplateFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractTemplateFormFieldFilter>;
  /** No related `ContractTemplateFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractTemplateFormFieldFilter>;
  /** Some related `ContractTemplateFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractTemplateFormFieldFilter>;
};

/** A filter to be used against many `ContractTemplateUser` object types. All fields are combined with a logical ‘and.’ */
export type ContractTemplateToManyContractTemplateUserFilter = {
  /** Every related `ContractTemplateUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractTemplateUserFilter>;
  /** No related `ContractTemplateUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractTemplateUserFilter>;
  /** Some related `ContractTemplateUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractTemplateUserFilter>;
};

/** A filter to be used against many `Storage` object types. All fields are combined with a logical ‘and.’ */
export type ContractTemplateToManyStorageFilter = {
  /** Every related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<StorageFilter>;
  /** No related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<StorageFilter>;
  /** Some related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<StorageFilter>;
};

export type ContractTemplateUser = {
  __typename?: 'ContractTemplateUser';
  /** Reads a single `Company` that is related to this `ContractTemplateUser`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `ContractTemplate` that is related to this `ContractTemplateUser`. */
  contractTemplate?: Maybe<ContractTemplate>;
  contractTemplateId: Scalars['UUID'];
  contractTemplateIsSignable?: Maybe<Scalars['Boolean']>;
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `User` that is related to this `ContractTemplateUser`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/**
 * A condition to be used against `ContractTemplateUser` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ContractTemplateUserCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `contractTemplateId` field. */
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `contractTemplateIsSignable` field. */
  contractTemplateIsSignable?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `contractTemplateUser` to look up the row to connect. */
export type ContractTemplateUserContractTemplateUsersPkeyConnect = {
  contractTemplateId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `contractTemplateUser` to look up the row to delete. */
export type ContractTemplateUserContractTemplateUsersPkeyDelete = {
  contractTemplateId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** A filter to be used against `ContractTemplateUser` object types. All fields are combined with a logical ‘and.’ */
export type ContractTemplateUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ContractTemplateUserFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `contractTemplate` relation. */
  contractTemplate?: InputMaybe<ContractTemplateFilter>;
  /** Filter by the object’s `contractTemplateId` field. */
  contractTemplateId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `contractTemplateIsSignable` field. */
  contractTemplateIsSignable?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ContractTemplateUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ContractTemplateUserFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ContractTemplateUser` */
export type ContractTemplateUserInput = {
  company?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  contractTemplateIsSignable?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractTemplateUsersUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `contractTemplateUser` to look up the row to update. */
export type ContractTemplateUserOnContractTemplateUserForContractTemplateUsersCompanyIdFkeyUsingContractTemplateUsersPkeyUpdate = {
  contractTemplateId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractTemplateUser` being updated. */
  patch: UpdateContractTemplateUserOnContractTemplateUserForContractTemplateUsersCompanyIdFkeyPatch;
  userId: Scalars['UUID'];
};

/** The fields on `contractTemplateUser` to look up the row to update. */
export type ContractTemplateUserOnContractTemplateUserForContractTemplateUsersContractTemplateIdForeignUsingContractTemplateUsersPkeyUpdate = {
  contractTemplateId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractTemplateUser` being updated. */
  patch: UpdateContractTemplateUserOnContractTemplateUserForContractTemplateUsersContractTemplateIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `contractTemplateUser` to look up the row to update. */
export type ContractTemplateUserOnContractTemplateUserForContractTemplateUsersUserIdForeignUsingContractTemplateUsersPkeyUpdate = {
  contractTemplateId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `contractTemplateUser` being updated. */
  patch: UpdateContractTemplateUserOnContractTemplateUserForContractTemplateUsersUserIdForeignPatch;
  userId: Scalars['UUID'];
};

/** Represents an update to a `ContractTemplateUser`. Fields that are set will be updated. */
export type ContractTemplateUserPatch = {
  company?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  contractTemplateIsSignable?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractTemplateUsersUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `contractTemplateUser` to be created by this mutation. */
export type ContractTemplateUsersCompanyIdFkeyConnectionContractTemplateUsersCreateInput = {
  company?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInput>;
  contractTemplate?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  contractTemplateIsSignable?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractTemplateUsersUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `ContractTemplateUserInput` mutation. */
export type ContractTemplateUsersCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnContractTemplateUserForContractTemplateUsersCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `contractTemplateUser` in the `CompanyInput` mutation. */
export type ContractTemplateUsersCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `contractTemplateUser` for the far side of the relationship. */
  connectByUserIdAndContractTemplateId?: InputMaybe<Array<ContractTemplateUserContractTemplateUsersPkeyConnect>>;
  /** A `ContractTemplateUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractTemplateUsersCompanyIdFkeyConnectionContractTemplateUsersCreateInput>>;
  /** The primary key(s) for `contractTemplateUser` for the far side of the relationship. */
  deleteByUserIdAndContractTemplateId?: InputMaybe<Array<ContractTemplateUserContractTemplateUsersPkeyDelete>>;
  /** Flag indicating whether all other `contractTemplateUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `contractTemplateUser` for the far side of the relationship. */
  updateByUserIdAndContractTemplateId?: InputMaybe<Array<ContractTemplateUserOnContractTemplateUserForContractTemplateUsersCompanyIdFkeyUsingContractTemplateUsersPkeyUpdate>>;
};

/** A connection to a list of `ContractTemplateUser` values. */
export type ContractTemplateUsersConnection = {
  __typename?: 'ContractTemplateUsersConnection';
  /** A list of edges which contains the `ContractTemplateUser` and cursor to aid in pagination. */
  edges: Array<ContractTemplateUsersEdge>;
  /** A list of `ContractTemplateUser` objects. */
  nodes: Array<Maybe<ContractTemplateUser>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ContractTemplateUser` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The `contractTemplate` to be created by this mutation. */
export type ContractTemplateUsersContractTemplateIdForeignConnectionContractTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInverseInput>;
  contractSignPendingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInverseInput>;
  contractTemplateFormFields?: InputMaybe<ContractTemplateFormFieldContractTemplateIdForeignInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<ContractTemplateDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  footer?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  htmlPlaceholders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  jobPositionTypes?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  placeholders?: InputMaybe<Scalars['JSON']>;
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
  signable?: InputMaybe<Scalars['Boolean']>;
  storages?: InputMaybe<StorageDocumentTemplateIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `contractTemplateUser` to be created by this mutation. */
export type ContractTemplateUsersContractTemplateIdForeignConnectionContractTemplateUsersCreateInput = {
  company?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInput>;
  contractTemplateIsSignable?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractTemplateUsersUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `contractTemplate` in the `ContractTemplateUserInput` mutation. */
export type ContractTemplateUsersContractTemplateIdForeignInput = {
  /** The primary key(s) for `contractTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<ContractTemplateContractTemplatePkeyConnect>;
  /** A `ContractTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignConnectionContractTemplateCreateInput>;
  /** The primary key(s) and patch data for `contractTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<ContractTemplateOnContractTemplateUserForContractTemplateUsersContractTemplateIdForeignUsingContractTemplatePkeyUpdate>;
};

/** Input for the nested mutation of `contractTemplateUser` in the `ContractTemplateInput` mutation. */
export type ContractTemplateUsersContractTemplateIdForeignInverseInput = {
  /** The primary key(s) for `contractTemplateUser` for the far side of the relationship. */
  connectByUserIdAndContractTemplateId?: InputMaybe<Array<ContractTemplateUserContractTemplateUsersPkeyConnect>>;
  /** A `ContractTemplateUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractTemplateUsersContractTemplateIdForeignConnectionContractTemplateUsersCreateInput>>;
  /** The primary key(s) for `contractTemplateUser` for the far side of the relationship. */
  deleteByUserIdAndContractTemplateId?: InputMaybe<Array<ContractTemplateUserContractTemplateUsersPkeyDelete>>;
  /** Flag indicating whether all other `contractTemplateUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `contractTemplateUser` for the far side of the relationship. */
  updateByUserIdAndContractTemplateId?: InputMaybe<Array<ContractTemplateUserOnContractTemplateUserForContractTemplateUsersContractTemplateIdForeignUsingContractTemplateUsersPkeyUpdate>>;
};

/** A `ContractTemplateUser` edge in the connection. */
export type ContractTemplateUsersEdge = {
  __typename?: 'ContractTemplateUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ContractTemplateUser` at the end of the edge. */
  node?: Maybe<ContractTemplateUser>;
};

/** Methods to use when ordering `ContractTemplateUser`. */
export type ContractTemplateUsersOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__ACTIVE_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__ACTIVE_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__BOTTOM_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__BOTTOM_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__COMPANY_ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__COMPANY_ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__CONTRACT_SIGN_PENDING_USER_IDS_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__CONTRACT_SIGN_PENDING_USER_IDS_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__CREATED_AT_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__CREATED_AT_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DATE_FORMAT_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DATE_FORMAT_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DESCRIPTION_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DESCRIPTION_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DOCUMENT_TYPE_ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__DOCUMENT_TYPE_ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__FOOTER_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__FOOTER_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HEADER_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HEADER_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HTML_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HTML_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HTML_PLACEHOLDERS_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__HTML_PLACEHOLDERS_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__IS_GLOBAL_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__IS_GLOBAL_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__JOB_POSITION_TYPES_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__JOB_POSITION_TYPES_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__LEFT_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__LEFT_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__LOCALE_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__LOCALE_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__NAME_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__NAME_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__PAGE_NUMBER_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__PAGE_NUMBER_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__PLACEHOLDERS_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__PLACEHOLDERS_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__RIGHT_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__RIGHT_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__SIGNABLE_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__SIGNABLE_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__TEMPLATING_SERVICE_ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__TEMPLATING_SERVICE_ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__TOP_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__TOP_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__UPDATED_AT_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__UPDATED_AT_DESC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__USERS_SHARED_WITH_ASC'
  | 'CONTRACT_TEMPLATE_BY_CONTRACT_TEMPLATE_ID__USERS_SHARED_WITH_DESC'
  | 'CONTRACT_TEMPLATE_ID_ASC'
  | 'CONTRACT_TEMPLATE_ID_DESC'
  | 'CONTRACT_TEMPLATE_IS_SIGNABLE_ASC'
  | 'CONTRACT_TEMPLATE_IS_SIGNABLE_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** The `contractTemplateUser` to be created by this mutation. */
export type ContractTemplateUsersUserIdForeignConnectionContractTemplateUsersCreateInput = {
  company?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  contractTemplateIsSignable?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractTemplateUsersUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `ContractTemplateUserInput` mutation. */
export type ContractTemplateUsersUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnContractTemplateUserForContractTemplateUsersUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `contractTemplateUser` in the `UserInput` mutation. */
export type ContractTemplateUsersUserIdForeignInverseInput = {
  /** The primary key(s) for `contractTemplateUser` for the far side of the relationship. */
  connectByUserIdAndContractTemplateId?: InputMaybe<Array<ContractTemplateUserContractTemplateUsersPkeyConnect>>;
  /** A `ContractTemplateUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ContractTemplateUsersUserIdForeignConnectionContractTemplateUsersCreateInput>>;
  /** The primary key(s) for `contractTemplateUser` for the far side of the relationship. */
  deleteByUserIdAndContractTemplateId?: InputMaybe<Array<ContractTemplateUserContractTemplateUsersPkeyDelete>>;
  /** Flag indicating whether all other `contractTemplateUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `contractTemplateUser` for the far side of the relationship. */
  updateByUserIdAndContractTemplateId?: InputMaybe<Array<ContractTemplateUserOnContractTemplateUserForContractTemplateUsersUserIdForeignUsingContractTemplateUsersPkeyUpdate>>;
};

/** A connection to a list of `ContractTemplate` values. */
export type ContractTemplatesConnection = {
  __typename?: 'ContractTemplatesConnection';
  /** A list of edges which contains the `ContractTemplate` and cursor to aid in pagination. */
  edges: Array<ContractTemplatesEdge>;
  /** A list of `ContractTemplate` objects. */
  nodes: Array<Maybe<ContractTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ContractTemplate` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ContractTemplate` edge in the connection. */
export type ContractTemplatesEdge = {
  __typename?: 'ContractTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ContractTemplate` at the end of the edge. */
  node?: Maybe<ContractTemplate>;
};

/** Methods to use when ordering `ContractTemplate`. */
export type ContractTemplatesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'BOTTOM_MARGIN_ASC'
  | 'BOTTOM_MARGIN_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENTS_BY_CONTRACT_TEMPLATE_ID__COUNT_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENTS_BY_CONTRACT_TEMPLATE_ID__COUNT_DESC'
  | 'CONTRACT_SIGN_PENDING_USER_IDS_ASC'
  | 'CONTRACT_SIGN_PENDING_USER_IDS_DESC'
  | 'CONTRACT_TEMPLATE_DEPARTMENTS_BY_CONTRACT_TEMPLATE_ID__COUNT_ASC'
  | 'CONTRACT_TEMPLATE_DEPARTMENTS_BY_CONTRACT_TEMPLATE_ID__COUNT_DESC'
  | 'CONTRACT_TEMPLATE_FORM_FIELDS_BY_CONTRACT_TEMPLATE_ID__COUNT_ASC'
  | 'CONTRACT_TEMPLATE_FORM_FIELDS_BY_CONTRACT_TEMPLATE_ID__COUNT_DESC'
  | 'CONTRACT_TEMPLATE_USERS_BY_CONTRACT_TEMPLATE_ID__COUNT_ASC'
  | 'CONTRACT_TEMPLATE_USERS_BY_CONTRACT_TEMPLATE_ID__COUNT_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DATE_FORMAT_ASC'
  | 'DATE_FORMAT_DESC'
  | 'DEPARTMENTS_SHARED_WITH_ASC'
  | 'DEPARTMENTS_SHARED_WITH_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ACTIVE_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ACTIVE_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__AUTO_DELETE_DAYS_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__AUTO_DELETE_DAYS_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__CREATED_AT_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__CREATED_AT_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DEPARTMENT_ID_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DEPARTMENT_ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ID_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LIFETIME_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LIFETIME_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__NAME_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__NAME_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'DOCUMENT_TYPE_ID_ASC'
  | 'DOCUMENT_TYPE_ID_DESC'
  | 'FOOTER_ASC'
  | 'FOOTER_DESC'
  | 'HEADER_ASC'
  | 'HEADER_DESC'
  | 'HTML_ASC'
  | 'HTML_DESC'
  | 'HTML_PLACEHOLDERS_ASC'
  | 'HTML_PLACEHOLDERS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IS_GLOBAL_ASC'
  | 'IS_GLOBAL_DESC'
  | 'JOB_POSITION_TYPES_ASC'
  | 'JOB_POSITION_TYPES_DESC'
  | 'LEFT_MARGIN_ASC'
  | 'LEFT_MARGIN_DESC'
  | 'LOCALE_ASC'
  | 'LOCALE_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PAGE_NUMBER_ASC'
  | 'PAGE_NUMBER_DESC'
  | 'PLACEHOLDERS_ASC'
  | 'PLACEHOLDERS_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RIGHT_MARGIN_ASC'
  | 'RIGHT_MARGIN_DESC'
  | 'SIGNABLE_ASC'
  | 'SIGNABLE_DESC'
  | 'STORAGES_BY_DOCUMENT_TEMPLATE_ID__COUNT_ASC'
  | 'STORAGES_BY_DOCUMENT_TEMPLATE_ID__COUNT_DESC'
  | 'TEMPLATING_SERVICE_ID_ASC'
  | 'TEMPLATING_SERVICE_ID_DESC'
  | 'TOP_MARGIN_ASC'
  | 'TOP_MARGIN_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'USERS_SHARED_WITH_ASC'
  | 'USERS_SHARED_WITH_DESC';

/** All input for the `convertformfieldentrytoemail` mutation. */
export type ConvertformfieldentrytoemailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `convertformfieldentrytoemail` mutation. */
export type ConvertformfieldentrytoemailPayload = {
  __typename?: 'ConvertformfieldentrytoemailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type CopyCompanyPayload = {
  __typename?: 'CopyCompanyPayload';
  company?: Maybe<Company>;
};

/** All input for the `copyUserGroupToUserCompanyGroup` mutation. */
export type CopyUserGroupToUserCompanyGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `copyUserGroupToUserCompanyGroup` mutation. */
export type CopyUserGroupToUserCompanyGroupPayload = {
  __typename?: 'CopyUserGroupToUserCompanyGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `copyUserGroupToUserDepartmentGroup` mutation. */
export type CopyUserGroupToUserDepartmentGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `copyUserGroupToUserDepartmentGroup` mutation. */
export type CopyUserGroupToUserDepartmentGroupPayload = {
  __typename?: 'CopyUserGroupToUserDepartmentGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A connection to a list of `CountryOptionsInUseRecord` values. */
export type CountryOptionsInUseConnection = {
  __typename?: 'CountryOptionsInUseConnection';
  /** A list of edges which contains the `CountryOptionsInUseRecord` and cursor to aid in pagination. */
  edges: Array<CountryOptionsInUseEdge>;
  /** A list of `CountryOptionsInUseRecord` objects. */
  nodes: Array<Maybe<CountryOptionsInUseRecord>>;
  /** The count of *all* `CountryOptionsInUseRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CountryOptionsInUseRecord` edge in the connection. */
export type CountryOptionsInUseEdge = {
  __typename?: 'CountryOptionsInUseEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CountryOptionsInUseRecord` at the end of the edge. */
  node?: Maybe<CountryOptionsInUseRecord>;
};

/** The return type of our `countryOptionsInUse` query. */
export type CountryOptionsInUseRecord = {
  __typename?: 'CountryOptionsInUseRecord';
  id?: Maybe<Scalars['UUID']>;
  value?: Maybe<Scalars['String']>;
};

/** A filter to be used against `CountryOptionsInUseRecord` object types. All fields are combined with a logical ‘and.’ */
export type CountryOptionsInUseRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CountryOptionsInUseRecordFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CountryOptionsInUseRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CountryOptionsInUseRecordFilter>>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** All input for the create `Announcement` mutation. */
export type CreateAnnouncementInput = {
  /** The `Announcement` to be created by this mutation. */
  announcement: AnnouncementInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `Announcement` mutation. */
export type CreateAnnouncementPayload = {
  __typename?: 'CreateAnnouncementPayload';
  /** The `Announcement` that was created by this mutation. */
  announcement?: Maybe<Announcement>;
  /** An edge for our `Announcement`. May be used by Relay 1. */
  announcementEdge?: Maybe<AnnouncementsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Announcement`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Announcement`. */
  user?: Maybe<User>;
};


/** The output of our create `Announcement` mutation. */
export type CreateAnnouncementPayloadAnnouncementEdgeArgs = {
  orderBy?: InputMaybe<Array<AnnouncementsOrderBy>>;
};

/** All input for the create `Approval` mutation. */
export type CreateApprovalInput = {
  /** The `Approval` to be created by this mutation. */
  approval: ApprovalInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `Approval` mutation. */
export type CreateApprovalPayload = {
  __typename?: 'CreateApprovalPayload';
  /** Reads a single `User` that is related to this `Approval`. */
  affectedUser?: Maybe<User>;
  /** The `Approval` that was created by this mutation. */
  approval?: Maybe<Approval>;
  /** An edge for our `Approval`. May be used by Relay 1. */
  approvalEdge?: Maybe<ApprovalsEdge>;
  /** Reads a single `User` that is related to this `Approval`. */
  approvingUser?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Approval`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Approval`. */
  requestingUser?: Maybe<User>;
};


/** The output of our create `Approval` mutation. */
export type CreateApprovalPayloadApprovalEdgeArgs = {
  orderBy?: InputMaybe<Array<ApprovalsOrderBy>>;
};

/** All input for the create `AuthAppType` mutation. */
export type CreateAuthAppTypeInput = {
  /** The `AuthAppType` to be created by this mutation. */
  authAppType: AuthAppTypeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AuthAppType` mutation. */
export type CreateAuthAppTypePayload = {
  __typename?: 'CreateAuthAppTypePayload';
  /** The `AuthAppType` that was created by this mutation. */
  authAppType?: Maybe<AuthAppType>;
  /** An edge for our `AuthAppType`. May be used by Relay 1. */
  authAppTypeEdge?: Maybe<AuthAppTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AuthAppType` mutation. */
export type CreateAuthAppTypePayloadAuthAppTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<AuthAppTypesOrderBy>>;
};

/** All input for the create `AuthCode` mutation. */
export type CreateAuthCodeInput = {
  /** The `AuthCode` to be created by this mutation. */
  authCode: AuthCodeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AuthCode` mutation. */
export type CreateAuthCodePayload = {
  __typename?: 'CreateAuthCodePayload';
  /** The `AuthCode` that was created by this mutation. */
  authCode?: Maybe<AuthCode>;
  /** An edge for our `AuthCode`. May be used by Relay 1. */
  authCodeEdge?: Maybe<AuthCodesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AuthCode` mutation. */
export type CreateAuthCodePayloadAuthCodeEdgeArgs = {
  orderBy?: InputMaybe<Array<AuthCodesOrderBy>>;
};

/** All input for the create `Changelog` mutation. */
export type CreateChangelogInput = {
  /** The `Changelog` to be created by this mutation. */
  changelog: ChangelogInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `Changelog` mutation. */
export type CreateChangelogPayload = {
  __typename?: 'CreateChangelogPayload';
  /** The `Changelog` that was created by this mutation. */
  changelog?: Maybe<Changelog>;
  /** An edge for our `Changelog`. May be used by Relay 1. */
  changelogEdge?: Maybe<ChangelogsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Changelog` mutation. */
export type CreateChangelogPayloadChangelogEdgeArgs = {
  orderBy?: InputMaybe<Array<ChangelogsOrderBy>>;
};

/** All input for the create `ChangelogUser` mutation. */
export type CreateChangelogUserInput = {
  /** The `ChangelogUser` to be created by this mutation. */
  changelogUser: ChangelogUserInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `ChangelogUser` mutation. */
export type CreateChangelogUserPayload = {
  __typename?: 'CreateChangelogUserPayload';
  /** Reads a single `Changelog` that is related to this `ChangelogUser`. */
  changelog?: Maybe<Changelog>;
  /** The `ChangelogUser` that was created by this mutation. */
  changelogUser?: Maybe<ChangelogUser>;
  /** An edge for our `ChangelogUser`. May be used by Relay 1. */
  changelogUserEdge?: Maybe<ChangelogUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ChangelogUser`. */
  user?: Maybe<User>;
};


/** The output of our create `ChangelogUser` mutation. */
export type CreateChangelogUserPayloadChangelogUserEdgeArgs = {
  orderBy?: InputMaybe<Array<ChangelogUsersOrderBy>>;
};

/** All input for the create `ChosenColumn` mutation. */
export type CreateChosenColumnInput = {
  /** The `ChosenColumn` to be created by this mutation. */
  chosenColumn: ChosenColumnInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `ChosenColumn` mutation. */
export type CreateChosenColumnPayload = {
  __typename?: 'CreateChosenColumnPayload';
  /** The `ChosenColumn` that was created by this mutation. */
  chosenColumn?: Maybe<ChosenColumn>;
  /** An edge for our `ChosenColumn`. May be used by Relay 1. */
  chosenColumnEdge?: Maybe<ChosenColumnsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ChosenColumn`. */
  user?: Maybe<User>;
};


/** The output of our create `ChosenColumn` mutation. */
export type CreateChosenColumnPayloadChosenColumnEdgeArgs = {
  orderBy?: InputMaybe<Array<ChosenColumnsOrderBy>>;
};

/** All input for the create `CompanyCompanyType` mutation. */
export type CreateCompanyCompanyTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CompanyCompanyType` to be created by this mutation. */
  companyCompanyType: CompanyCompanyTypeInput;
};

/** The output of our create `CompanyCompanyType` mutation. */
export type CreateCompanyCompanyTypePayload = {
  __typename?: 'CreateCompanyCompanyTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CompanyCompanyType`. */
  company?: Maybe<Company>;
  /** The `CompanyCompanyType` that was created by this mutation. */
  companyCompanyType?: Maybe<CompanyCompanyType>;
  /** An edge for our `CompanyCompanyType`. May be used by Relay 1. */
  companyCompanyTypeEdge?: Maybe<CompanyCompanyTypesEdge>;
  /** Reads a single `CompanyType` that is related to this `CompanyCompanyType`. */
  companyType?: Maybe<CompanyType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CompanyCompanyType` mutation. */
export type CreateCompanyCompanyTypePayloadCompanyCompanyTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyCompanyTypesOrderBy>>;
};

/** All input for the create `CompanySystemField` mutation. */
export type CreateCompanySystemFieldInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CompanySystemField` to be created by this mutation. */
  companySystemField: CompanySystemFieldInput;
};

/** All input for the create `CompanySystemFieldOption` mutation. */
export type CreateCompanySystemFieldOptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CompanySystemFieldOption` to be created by this mutation. */
  companySystemFieldOption: CompanySystemFieldOptionInput;
};

/** The output of our create `CompanySystemFieldOption` mutation. */
export type CreateCompanySystemFieldOptionPayload = {
  __typename?: 'CreateCompanySystemFieldOptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CompanySystemFieldOption`. */
  company?: Maybe<Company>;
  /** Reads a single `CompanySystemField` that is related to this `CompanySystemFieldOption`. */
  companySystemField?: Maybe<CompanySystemField>;
  /** The `CompanySystemFieldOption` that was created by this mutation. */
  companySystemFieldOption?: Maybe<CompanySystemFieldOption>;
  /** An edge for our `CompanySystemFieldOption`. May be used by Relay 1. */
  companySystemFieldOptionEdge?: Maybe<CompanySystemFieldOptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CompanySystemFieldOption` mutation. */
export type CreateCompanySystemFieldOptionPayloadCompanySystemFieldOptionEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanySystemFieldOptionsOrderBy>>;
};

/** The output of our create `CompanySystemField` mutation. */
export type CreateCompanySystemFieldPayload = {
  __typename?: 'CreateCompanySystemFieldPayload';
  /** Reads a single `TranslatedEntity` that is related to this `CompanySystemField`. */
  aliasTranslatedEntity?: Maybe<TranslatedEntity>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CompanySystemField`. */
  company?: Maybe<Company>;
  /** The `CompanySystemField` that was created by this mutation. */
  companySystemField?: Maybe<CompanySystemField>;
  /** An edge for our `CompanySystemField`. May be used by Relay 1. */
  companySystemFieldEdge?: Maybe<CompanySystemFieldsEdge>;
  /** Reads a single `FieldGroup` that is related to this `CompanySystemField`. */
  fieldGroup?: Maybe<FieldGroup>;
  /** Reads a single `FieldGroupCardColumn` that is related to this `CompanySystemField`. */
  fieldGroupCardColumn?: Maybe<FieldGroupCardColumn>;
  /** Reads a single `TranslatedEntity` that is related to this `CompanySystemField`. */
  helpTextTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SystemField` that is related to this `CompanySystemField`. */
  systemField?: Maybe<SystemField>;
};


/** The output of our create `CompanySystemField` mutation. */
export type CreateCompanySystemFieldPayloadCompanySystemFieldEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanySystemFieldsOrderBy>>;
};

/** All input for the create `CompanyType` mutation. */
export type CreateCompanyTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CompanyType` to be created by this mutation. */
  companyType: CompanyTypeInput;
};

/** The output of our create `CompanyType` mutation. */
export type CreateCompanyTypePayload = {
  __typename?: 'CreateCompanyTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyType` that was created by this mutation. */
  companyType?: Maybe<CompanyType>;
  /** An edge for our `CompanyType`. May be used by Relay 1. */
  companyTypeEdge?: Maybe<CompanyTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CompanyType` mutation. */
export type CreateCompanyTypePayloadCompanyTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyTypesOrderBy>>;
};

/** All input for the create `CompetenceFormField` mutation. */
export type CreateCompetenceFormFieldInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CompetenceFormField` to be created by this mutation. */
  competenceFormField: CompetenceFormFieldInput;
};

/** The output of our create `CompetenceFormField` mutation. */
export type CreateCompetenceFormFieldPayload = {
  __typename?: 'CreateCompetenceFormFieldPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CompetenceFormField`. */
  company?: Maybe<Company>;
  /** Reads a single `Competence` that is related to this `CompetenceFormField`. */
  competence?: Maybe<Competence>;
  /** The `CompetenceFormField` that was created by this mutation. */
  competenceFormField?: Maybe<CompetenceFormField>;
  /** An edge for our `CompetenceFormField`. May be used by Relay 1. */
  competenceFormFieldEdge?: Maybe<CompetenceFormFieldsEdge>;
  /** Reads a single `FormField` that is related to this `CompetenceFormField`. */
  formField?: Maybe<FormField>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CompetenceFormField` mutation. */
export type CreateCompetenceFormFieldPayloadCompetenceFormFieldEdgeArgs = {
  orderBy?: InputMaybe<Array<CompetenceFormFieldsOrderBy>>;
};

/** All input for the create `CompetenceGroup` mutation. */
export type CreateCompetenceGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CompetenceGroup` to be created by this mutation. */
  competenceGroup: CompetenceGroupInput;
};

/** The output of our create `CompetenceGroup` mutation. */
export type CreateCompetenceGroupPayload = {
  __typename?: 'CreateCompetenceGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CompetenceGroup`. */
  company?: Maybe<Company>;
  /** The `CompetenceGroup` that was created by this mutation. */
  competenceGroup?: Maybe<CompetenceGroup>;
  /** An edge for our `CompetenceGroup`. May be used by Relay 1. */
  competenceGroupEdge?: Maybe<CompetenceGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CompetenceGroup` mutation. */
export type CreateCompetenceGroupPayloadCompetenceGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<CompetenceGroupsOrderBy>>;
};

/** All input for the create `Competence` mutation. */
export type CreateCompetenceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Competence` to be created by this mutation. */
  competence: CompetenceInput;
};

/** The output of our create `Competence` mutation. */
export type CreateCompetencePayload = {
  __typename?: 'CreateCompetencePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Competence`. */
  company?: Maybe<Company>;
  /** The `Competence` that was created by this mutation. */
  competence?: Maybe<Competence>;
  /** An edge for our `Competence`. May be used by Relay 1. */
  competenceEdge?: Maybe<CompetencesEdge>;
  /** Reads a single `CompetenceGroup` that is related to this `Competence`. */
  competenceGroup?: Maybe<CompetenceGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `FormField` that is related to this `Competence`. */
  ratingFormField?: Maybe<FormField>;
};


/** The output of our create `Competence` mutation. */
export type CreateCompetencePayloadCompetenceEdgeArgs = {
  orderBy?: InputMaybe<Array<CompetencesOrderBy>>;
};

/** All input for the create `CompetenceRequest` mutation. */
export type CreateCompetenceRequestInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CompetenceRequest` to be created by this mutation. */
  competenceRequest: CompetenceRequestInput;
};

/** The output of our create `CompetenceRequest` mutation. */
export type CreateCompetenceRequestPayload = {
  __typename?: 'CreateCompetenceRequestPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CompetenceRequest`. */
  company?: Maybe<Company>;
  /** Reads a single `Competence` that is related to this `CompetenceRequest`. */
  competence?: Maybe<Competence>;
  /** The `CompetenceRequest` that was created by this mutation. */
  competenceRequest?: Maybe<CompetenceRequest>;
  /** An edge for our `CompetenceRequest`. May be used by Relay 1. */
  competenceRequestEdge?: Maybe<CompetenceRequestsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CompetenceRequest` mutation. */
export type CreateCompetenceRequestPayloadCompetenceRequestEdgeArgs = {
  orderBy?: InputMaybe<Array<CompetenceRequestsOrderBy>>;
};

/** All input for the create `ContractPredefinedPlaceholder` mutation. */
export type CreateContractPredefinedPlaceholderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ContractPredefinedPlaceholder` to be created by this mutation. */
  contractPredefinedPlaceholder: ContractPredefinedPlaceholderInput;
};

/** The output of our create `ContractPredefinedPlaceholder` mutation. */
export type CreateContractPredefinedPlaceholderPayload = {
  __typename?: 'CreateContractPredefinedPlaceholderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ContractPredefinedPlaceholder` that was created by this mutation. */
  contractPredefinedPlaceholder?: Maybe<ContractPredefinedPlaceholder>;
  /** An edge for our `ContractPredefinedPlaceholder`. May be used by Relay 1. */
  contractPredefinedPlaceholderEdge?: Maybe<ContractPredefinedPlaceholdersEdge>;
  /** Reads a single `FormField` that is related to this `ContractPredefinedPlaceholder`. */
  formField?: Maybe<FormField>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ContractPredefinedPlaceholder` mutation. */
export type CreateContractPredefinedPlaceholderPayloadContractPredefinedPlaceholderEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractPredefinedPlaceholdersOrderBy>>;
};

/** All input for the create `ContractSignPendingDocument` mutation. */
export type CreateContractSignPendingDocumentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ContractSignPendingDocument` to be created by this mutation. */
  contractSignPendingDocument: ContractSignPendingDocumentInput;
};

/** The output of our create `ContractSignPendingDocument` mutation. */
export type CreateContractSignPendingDocumentPayload = {
  __typename?: 'CreateContractSignPendingDocumentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ContractSignPendingDocument`. */
  company?: Maybe<Company>;
  /** Reads a single `ContractSignPending` that is related to this `ContractSignPendingDocument`. */
  contractSignPending?: Maybe<ContractSignPending>;
  /** The `ContractSignPendingDocument` that was created by this mutation. */
  contractSignPendingDocument?: Maybe<ContractSignPendingDocument>;
  /** An edge for our `ContractSignPendingDocument`. May be used by Relay 1. */
  contractSignPendingDocumentEdge?: Maybe<ContractSignPendingDocumentsEdge>;
  /** Reads a single `ContractTemplate` that is related to this `ContractSignPendingDocument`. */
  contractTemplate?: Maybe<ContractTemplate>;
  /** Reads a single `DocumentType` that is related to this `ContractSignPendingDocument`. */
  documentType?: Maybe<DocumentType>;
  /** Reads a single `Storage` that is related to this `ContractSignPendingDocument`. */
  existingStorage?: Maybe<Storage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ContractSignPendingDocument` mutation. */
export type CreateContractSignPendingDocumentPayloadContractSignPendingDocumentEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractSignPendingDocumentsOrderBy>>;
};

/** All input for the create `ContractSignPending` mutation. */
export type CreateContractSignPendingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ContractSignPending` to be created by this mutation. */
  contractSignPending: ContractSignPendingInput;
};

/** The output of our create `ContractSignPending` mutation. */
export type CreateContractSignPendingPayload = {
  __typename?: 'CreateContractSignPendingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ContractSignPending`. */
  company?: Maybe<Company>;
  /** The `ContractSignPending` that was created by this mutation. */
  contractSignPending?: Maybe<ContractSignPending>;
  /** An edge for our `ContractSignPending`. May be used by Relay 1. */
  contractSignPendingEdge?: Maybe<ContractSignPendingsEdge>;
  /** Reads a single `User` that is related to this `ContractSignPending`. */
  creatorUser?: Maybe<User>;
  /** Reads a single `Employee` that is related to this `ContractSignPending`. */
  employee?: Maybe<Employee>;
  /** Reads a single `DocumentType` that is related to this `ContractSignPending`. */
  mergedDocumentDocumentType?: Maybe<DocumentType>;
  /** Reads a single `User` that is related to this `ContractSignPending`. */
  nextSigningUser?: Maybe<User>;
  /** Reads a single `PreboardingEmployee` that is related to this `ContractSignPending`. */
  preboardingEmployee?: Maybe<PreboardingEmployee>;
  /** Reads a single `PreboardingSlideFormField` that is related to this `ContractSignPending`. */
  preboardingSlideFormField?: Maybe<PreboardingSlideFormField>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ContractSignPending`. */
  user?: Maybe<User>;
};


/** The output of our create `ContractSignPending` mutation. */
export type CreateContractSignPendingPayloadContractSignPendingEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractSignPendingsOrderBy>>;
};

/** All input for the create `ContractSignPendingSigner` mutation. */
export type CreateContractSignPendingSignerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ContractSignPendingSigner` to be created by this mutation. */
  contractSignPendingSigner: ContractSignPendingSignerInput;
};

/** The output of our create `ContractSignPendingSigner` mutation. */
export type CreateContractSignPendingSignerPayload = {
  __typename?: 'CreateContractSignPendingSignerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ContractSignPendingSigner`. */
  company?: Maybe<Company>;
  /** Reads a single `ContractSignPending` that is related to this `ContractSignPendingSigner`. */
  contractSignPending?: Maybe<ContractSignPending>;
  /** The `ContractSignPendingSigner` that was created by this mutation. */
  contractSignPendingSigner?: Maybe<ContractSignPendingSigner>;
  /** An edge for our `ContractSignPendingSigner`. May be used by Relay 1. */
  contractSignPendingSignerEdge?: Maybe<ContractSignPendingSignersEdge>;
  /** Reads a single `User` that is related to this `ContractSignPendingSigner`. */
  onBehalfOfUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Storage` that is related to this `ContractSignPendingSigner`. */
  signatureFile?: Maybe<Storage>;
  /** Reads a single `User` that is related to this `ContractSignPendingSigner`. */
  user?: Maybe<User>;
};


/** The output of our create `ContractSignPendingSigner` mutation. */
export type CreateContractSignPendingSignerPayloadContractSignPendingSignerEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractSignPendingSignersOrderBy>>;
};

/** All input for the create `ContractTemplateDepartment` mutation. */
export type CreateContractTemplateDepartmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ContractTemplateDepartment` to be created by this mutation. */
  contractTemplateDepartment: ContractTemplateDepartmentInput;
};

/** The output of our create `ContractTemplateDepartment` mutation. */
export type CreateContractTemplateDepartmentPayload = {
  __typename?: 'CreateContractTemplateDepartmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ContractTemplateDepartment`. */
  company?: Maybe<Company>;
  /** Reads a single `ContractTemplate` that is related to this `ContractTemplateDepartment`. */
  contractTemplate?: Maybe<ContractTemplate>;
  /** The `ContractTemplateDepartment` that was created by this mutation. */
  contractTemplateDepartment?: Maybe<ContractTemplateDepartment>;
  /** An edge for our `ContractTemplateDepartment`. May be used by Relay 1. */
  contractTemplateDepartmentEdge?: Maybe<ContractTemplateDepartmentsEdge>;
  /** Reads a single `Department` that is related to this `ContractTemplateDepartment`. */
  department?: Maybe<Department>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ContractTemplateDepartment` mutation. */
export type CreateContractTemplateDepartmentPayloadContractTemplateDepartmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractTemplateDepartmentsOrderBy>>;
};

/** All input for the create `ContractTemplateFormField` mutation. */
export type CreateContractTemplateFormFieldInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ContractTemplateFormField` to be created by this mutation. */
  contractTemplateFormField: ContractTemplateFormFieldInput;
};

/** The output of our create `ContractTemplateFormField` mutation. */
export type CreateContractTemplateFormFieldPayload = {
  __typename?: 'CreateContractTemplateFormFieldPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ContractTemplate` that is related to this `ContractTemplateFormField`. */
  contractTemplate?: Maybe<ContractTemplate>;
  /** The `ContractTemplateFormField` that was created by this mutation. */
  contractTemplateFormField?: Maybe<ContractTemplateFormField>;
  /** An edge for our `ContractTemplateFormField`. May be used by Relay 1. */
  contractTemplateFormFieldEdge?: Maybe<ContractTemplateFormFieldsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ContractTemplateFormField` mutation. */
export type CreateContractTemplateFormFieldPayloadContractTemplateFormFieldEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractTemplateFormFieldsOrderBy>>;
};

/** All input for the create `ContractTemplate` mutation. */
export type CreateContractTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ContractTemplate` to be created by this mutation. */
  contractTemplate: ContractTemplateInput;
};

/** The output of our create `ContractTemplate` mutation. */
export type CreateContractTemplatePayload = {
  __typename?: 'CreateContractTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ContractTemplate` that was created by this mutation. */
  contractTemplate?: Maybe<ContractTemplate>;
  /** An edge for our `ContractTemplate`. May be used by Relay 1. */
  contractTemplateEdge?: Maybe<ContractTemplatesEdge>;
  /** Reads a single `DocumentType` that is related to this `ContractTemplate`. */
  documentType?: Maybe<DocumentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ContractTemplate` mutation. */
export type CreateContractTemplatePayloadContractTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractTemplatesOrderBy>>;
};

/** All input for the create `ContractTemplateUser` mutation. */
export type CreateContractTemplateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ContractTemplateUser` to be created by this mutation. */
  contractTemplateUser: ContractTemplateUserInput;
};

/** The output of our create `ContractTemplateUser` mutation. */
export type CreateContractTemplateUserPayload = {
  __typename?: 'CreateContractTemplateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ContractTemplateUser`. */
  company?: Maybe<Company>;
  /** Reads a single `ContractTemplate` that is related to this `ContractTemplateUser`. */
  contractTemplate?: Maybe<ContractTemplate>;
  /** The `ContractTemplateUser` that was created by this mutation. */
  contractTemplateUser?: Maybe<ContractTemplateUser>;
  /** An edge for our `ContractTemplateUser`. May be used by Relay 1. */
  contractTemplateUserEdge?: Maybe<ContractTemplateUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ContractTemplateUser`. */
  user?: Maybe<User>;
};


/** The output of our create `ContractTemplateUser` mutation. */
export type CreateContractTemplateUserPayloadContractTemplateUserEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractTemplateUsersOrderBy>>;
};

/** All input for the create `CustomWidgetContent` mutation. */
export type CreateCustomWidgetContentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CustomWidgetContent` to be created by this mutation. */
  customWidgetContent: CustomWidgetContentInput;
};

/** The output of our create `CustomWidgetContent` mutation. */
export type CreateCustomWidgetContentPayload = {
  __typename?: 'CreateCustomWidgetContentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CustomWidgetContent`. */
  company?: Maybe<Company>;
  /** Reads a single `CustomWidget` that is related to this `CustomWidgetContent`. */
  customWidget?: Maybe<CustomWidget>;
  /** The `CustomWidgetContent` that was created by this mutation. */
  customWidgetContent?: Maybe<CustomWidgetContent>;
  /** An edge for our `CustomWidgetContent`. May be used by Relay 1. */
  customWidgetContentEdge?: Maybe<CustomWidgetContentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CustomWidgetContent` mutation. */
export type CreateCustomWidgetContentPayloadCustomWidgetContentEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomWidgetContentsOrderBy>>;
};

/** All input for the create `CustomWidget` mutation. */
export type CreateCustomWidgetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CustomWidget` to be created by this mutation. */
  customWidget: CustomWidgetInput;
};

/** The output of our create `CustomWidget` mutation. */
export type CreateCustomWidgetPayload = {
  __typename?: 'CreateCustomWidgetPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CustomWidget`. */
  company?: Maybe<Company>;
  /** The `CustomWidget` that was created by this mutation. */
  customWidget?: Maybe<CustomWidget>;
  /** An edge for our `CustomWidget`. May be used by Relay 1. */
  customWidgetEdge?: Maybe<CustomWidgetsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CustomWidget` mutation. */
export type CreateCustomWidgetPayloadCustomWidgetEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomWidgetsOrderBy>>;
};

/** All input for the create `CvTemplateFieldMapping` mutation. */
export type CreateCvTemplateFieldMappingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CvTemplateFieldMapping` to be created by this mutation. */
  cvTemplateFieldMapping: CvTemplateFieldMappingInput;
};

/** The output of our create `CvTemplateFieldMapping` mutation. */
export type CreateCvTemplateFieldMappingPayload = {
  __typename?: 'CreateCvTemplateFieldMappingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CvTemplateFieldMapping`. */
  company?: Maybe<Company>;
  /** The `CvTemplateFieldMapping` that was created by this mutation. */
  cvTemplateFieldMapping?: Maybe<CvTemplateFieldMapping>;
  /** An edge for our `CvTemplateFieldMapping`. May be used by Relay 1. */
  cvTemplateFieldMappingEdge?: Maybe<CvTemplateFieldMappingsEdge>;
  /** Reads a single `FormField` that is related to this `CvTemplateFieldMapping`. */
  formField?: Maybe<FormField>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SystemField` that is related to this `CvTemplateFieldMapping`. */
  systemField?: Maybe<SystemField>;
};


/** The output of our create `CvTemplateFieldMapping` mutation. */
export type CreateCvTemplateFieldMappingPayloadCvTemplateFieldMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<CvTemplateFieldMappingsOrderBy>>;
};

/** All input for the create `DashboardCard` mutation. */
export type CreateDashboardCardInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DashboardCard` to be created by this mutation. */
  dashboardCard: DashboardCardInput;
};

/** The output of our create `DashboardCard` mutation. */
export type CreateDashboardCardPayload = {
  __typename?: 'CreateDashboardCardPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DashboardCard`. */
  company?: Maybe<Company>;
  /** Reads a single `CustomWidget` that is related to this `DashboardCard`. */
  customWidget?: Maybe<CustomWidget>;
  /** The `DashboardCard` that was created by this mutation. */
  dashboardCard?: Maybe<DashboardCard>;
  /** An edge for our `DashboardCard`. May be used by Relay 1. */
  dashboardCardEdge?: Maybe<DashboardCardsEdge>;
  /** Reads a single `DashboardView` that is related to this `DashboardCard`. */
  dashboardView?: Maybe<DashboardView>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DashboardCard` mutation. */
export type CreateDashboardCardPayloadDashboardCardEdgeArgs = {
  orderBy?: InputMaybe<Array<DashboardCardsOrderBy>>;
};

/** All input for the create `DashboardCardStatistic` mutation. */
export type CreateDashboardCardStatisticInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DashboardCardStatistic` to be created by this mutation. */
  dashboardCardStatistic: DashboardCardStatisticInput;
};

/** The output of our create `DashboardCardStatistic` mutation. */
export type CreateDashboardCardStatisticPayload = {
  __typename?: 'CreateDashboardCardStatisticPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DashboardCardStatistic`. */
  company?: Maybe<Company>;
  /** Reads a single `DashboardCard` that is related to this `DashboardCardStatistic`. */
  dashboardCard?: Maybe<DashboardCard>;
  /** The `DashboardCardStatistic` that was created by this mutation. */
  dashboardCardStatistic?: Maybe<DashboardCardStatistic>;
  /** An edge for our `DashboardCardStatistic`. May be used by Relay 1. */
  dashboardCardStatisticEdge?: Maybe<DashboardCardStatisticsEdge>;
  /** Reads a single `DashboardView` that is related to this `DashboardCardStatistic`. */
  dashboardView?: Maybe<DashboardView>;
  /** Reads a single `FormField` that is related to this `DashboardCardStatistic`. */
  formField?: Maybe<FormField>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SystemField` that is related to this `DashboardCardStatistic`. */
  systemField?: Maybe<SystemField>;
};


/** The output of our create `DashboardCardStatistic` mutation. */
export type CreateDashboardCardStatisticPayloadDashboardCardStatisticEdgeArgs = {
  orderBy?: InputMaybe<Array<DashboardCardStatisticsOrderBy>>;
};

/** All input for the create `DashboardConfig` mutation. */
export type CreateDashboardConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DashboardConfig` to be created by this mutation. */
  dashboardConfig: DashboardConfigInput;
};

/** The output of our create `DashboardConfig` mutation. */
export type CreateDashboardConfigPayload = {
  __typename?: 'CreateDashboardConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DashboardConfig`. */
  company?: Maybe<Company>;
  /** The `DashboardConfig` that was created by this mutation. */
  dashboardConfig?: Maybe<DashboardConfig>;
  /** An edge for our `DashboardConfig`. May be used by Relay 1. */
  dashboardConfigEdge?: Maybe<DashboardConfigsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DashboardConfig` mutation. */
export type CreateDashboardConfigPayloadDashboardConfigEdgeArgs = {
  orderBy?: InputMaybe<Array<DashboardConfigsOrderBy>>;
};

/** All input for the create `DashboardView` mutation. */
export type CreateDashboardViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DashboardView` to be created by this mutation. */
  dashboardView: DashboardViewInput;
};

/** The output of our create `DashboardView` mutation. */
export type CreateDashboardViewPayload = {
  __typename?: 'CreateDashboardViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DashboardView`. */
  company?: Maybe<Company>;
  /** The `DashboardView` that was created by this mutation. */
  dashboardView?: Maybe<DashboardView>;
  /** An edge for our `DashboardView`. May be used by Relay 1. */
  dashboardViewEdge?: Maybe<DashboardViewsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DashboardView` mutation. */
export type CreateDashboardViewPayloadDashboardViewEdgeArgs = {
  orderBy?: InputMaybe<Array<DashboardViewsOrderBy>>;
};

/** All input for the create `Department` mutation. */
export type CreateDepartmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Department` to be created by this mutation. */
  department: DepartmentInput;
};

/** The output of our create `Department` mutation. */
export type CreateDepartmentPayload = {
  __typename?: 'CreateDepartmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Department`. */
  company?: Maybe<Company>;
  /** The `Department` that was created by this mutation. */
  department?: Maybe<Department>;
  /** An edge for our `Department`. May be used by Relay 1. */
  departmentEdge?: Maybe<DepartmentsEdge>;
  /** Reads a single `DepartmentType` that is related to this `Department`. */
  departmentType?: Maybe<DepartmentType>;
  /** Reads a single `Department` that is related to this `Department`. */
  parentDepartment?: Maybe<Department>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Department` mutation. */
export type CreateDepartmentPayloadDepartmentEdgeArgs = {
  orderBy?: InputMaybe<Array<DepartmentsOrderBy>>;
};

/** All input for the create `DepartmentType` mutation. */
export type CreateDepartmentTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DepartmentType` to be created by this mutation. */
  departmentType: DepartmentTypeInput;
};

/** The output of our create `DepartmentType` mutation. */
export type CreateDepartmentTypePayload = {
  __typename?: 'CreateDepartmentTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DepartmentType`. */
  company?: Maybe<Company>;
  /** The `DepartmentType` that was created by this mutation. */
  departmentType?: Maybe<DepartmentType>;
  /** An edge for our `DepartmentType`. May be used by Relay 1. */
  departmentTypeEdge?: Maybe<DepartmentTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DepartmentType` mutation. */
export type CreateDepartmentTypePayloadDepartmentTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<DepartmentTypesOrderBy>>;
};

/** All input for the create `DocumentDepartmentPermission` mutation. */
export type CreateDocumentDepartmentPermissionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DocumentDepartmentPermission` to be created by this mutation. */
  documentDepartmentPermission: DocumentDepartmentPermissionInput;
};

/** The output of our create `DocumentDepartmentPermission` mutation. */
export type CreateDocumentDepartmentPermissionPayload = {
  __typename?: 'CreateDocumentDepartmentPermissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentDepartmentPermission`. */
  company?: Maybe<Company>;
  /** Reads a single `Department` that is related to this `DocumentDepartmentPermission`. */
  department?: Maybe<Department>;
  /** The `DocumentDepartmentPermission` that was created by this mutation. */
  documentDepartmentPermission?: Maybe<DocumentDepartmentPermission>;
  /** An edge for our `DocumentDepartmentPermission`. May be used by Relay 1. */
  documentDepartmentPermissionEdge?: Maybe<DocumentDepartmentPermissionsEdge>;
  /** Reads a single `Storage` that is related to this `DocumentDepartmentPermission`. */
  file?: Maybe<Storage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DocumentDepartmentPermission` mutation. */
export type CreateDocumentDepartmentPermissionPayloadDocumentDepartmentPermissionEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentDepartmentPermissionsOrderBy>>;
};

/** All input for the create `DocumentFolderBlueprint` mutation. */
export type CreateDocumentFolderBlueprintInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DocumentFolderBlueprint` to be created by this mutation. */
  documentFolderBlueprint: DocumentFolderBlueprintInput;
};

/** The output of our create `DocumentFolderBlueprint` mutation. */
export type CreateDocumentFolderBlueprintPayload = {
  __typename?: 'CreateDocumentFolderBlueprintPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentFolderBlueprint`. */
  company?: Maybe<Company>;
  /** The `DocumentFolderBlueprint` that was created by this mutation. */
  documentFolderBlueprint?: Maybe<DocumentFolderBlueprint>;
  /** An edge for our `DocumentFolderBlueprint`. May be used by Relay 1. */
  documentFolderBlueprintEdge?: Maybe<DocumentFolderBlueprintsEdge>;
  /** Reads a single `DocumentFolderBlueprint` that is related to this `DocumentFolderBlueprint`. */
  parentDocumentFolderBlueprint?: Maybe<DocumentFolderBlueprint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DocumentFolderBlueprint` mutation. */
export type CreateDocumentFolderBlueprintPayloadDocumentFolderBlueprintEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentFolderBlueprintsOrderBy>>;
};

/** All input for the create `DocumentFolderDepartment` mutation. */
export type CreateDocumentFolderDepartmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DocumentFolderDepartment` to be created by this mutation. */
  documentFolderDepartment: DocumentFolderDepartmentInput;
};

/** The output of our create `DocumentFolderDepartment` mutation. */
export type CreateDocumentFolderDepartmentPayload = {
  __typename?: 'CreateDocumentFolderDepartmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentFolderDepartment`. */
  company?: Maybe<Company>;
  /** Reads a single `Department` that is related to this `DocumentFolderDepartment`. */
  department?: Maybe<Department>;
  /** Reads a single `DocumentFolder` that is related to this `DocumentFolderDepartment`. */
  documentFolder?: Maybe<DocumentFolder>;
  /** The `DocumentFolderDepartment` that was created by this mutation. */
  documentFolderDepartment?: Maybe<DocumentFolderDepartment>;
  /** An edge for our `DocumentFolderDepartment`. May be used by Relay 1. */
  documentFolderDepartmentEdge?: Maybe<DocumentFolderDepartmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DocumentFolderDepartment` mutation. */
export type CreateDocumentFolderDepartmentPayloadDocumentFolderDepartmentEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentFolderDepartmentsOrderBy>>;
};

/** All input for the create `DocumentFolder` mutation. */
export type CreateDocumentFolderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DocumentFolder` to be created by this mutation. */
  documentFolder: DocumentFolderInput;
};

/** The output of our create `DocumentFolder` mutation. */
export type CreateDocumentFolderPayload = {
  __typename?: 'CreateDocumentFolderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentFolder`. */
  company?: Maybe<Company>;
  /** The `DocumentFolder` that was created by this mutation. */
  documentFolder?: Maybe<DocumentFolder>;
  /** Reads a single `DocumentFolderBlueprint` that is related to this `DocumentFolder`. */
  documentFolderBlueprint?: Maybe<DocumentFolderBlueprint>;
  /** An edge for our `DocumentFolder`. May be used by Relay 1. */
  documentFolderEdge?: Maybe<DocumentFoldersEdge>;
  /** Reads a single `DocumentFolder` that is related to this `DocumentFolder`. */
  parentDocumentFolder?: Maybe<DocumentFolder>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentFolderBlueprint` that is related to this `DocumentFolder`. */
  rootDocumentFolderBlueprint?: Maybe<DocumentFolderBlueprint>;
};


/** The output of our create `DocumentFolder` mutation. */
export type CreateDocumentFolderPayloadDocumentFolderEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentFoldersOrderBy>>;
};

/** All input for the create `DocumentFolderUser` mutation. */
export type CreateDocumentFolderUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DocumentFolderUser` to be created by this mutation. */
  documentFolderUser: DocumentFolderUserInput;
};

/** The output of our create `DocumentFolderUser` mutation. */
export type CreateDocumentFolderUserPayload = {
  __typename?: 'CreateDocumentFolderUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentFolderUser`. */
  company?: Maybe<Company>;
  /** Reads a single `DocumentFolder` that is related to this `DocumentFolderUser`. */
  documentFolder?: Maybe<DocumentFolder>;
  /** The `DocumentFolderUser` that was created by this mutation. */
  documentFolderUser?: Maybe<DocumentFolderUser>;
  /** An edge for our `DocumentFolderUser`. May be used by Relay 1. */
  documentFolderUserEdge?: Maybe<DocumentFolderUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `DocumentFolderUser`. */
  user?: Maybe<User>;
};


/** The output of our create `DocumentFolderUser` mutation. */
export type CreateDocumentFolderUserPayloadDocumentFolderUserEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentFolderUsersOrderBy>>;
};

/** All input for the create `DocumentType` mutation. */
export type CreateDocumentTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DocumentType` to be created by this mutation. */
  documentType: DocumentTypeInput;
};

/** The output of our create `DocumentType` mutation. */
export type CreateDocumentTypePayload = {
  __typename?: 'CreateDocumentTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `DocumentType` that was created by this mutation. */
  documentType?: Maybe<DocumentType>;
  /** An edge for our `DocumentType`. May be used by Relay 1. */
  documentTypeEdge?: Maybe<DocumentTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `DocumentType` mutation. */
export type CreateDocumentTypePayloadDocumentTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentTypesOrderBy>>;
};

/** All input for the create `DocumentUserPermission` mutation. */
export type CreateDocumentUserPermissionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DocumentUserPermission` to be created by this mutation. */
  documentUserPermission: DocumentUserPermissionInput;
};

/** The output of our create `DocumentUserPermission` mutation. */
export type CreateDocumentUserPermissionPayload = {
  __typename?: 'CreateDocumentUserPermissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentUserPermission`. */
  company?: Maybe<Company>;
  /** Reads a single `DocumentType` that is related to this `DocumentUserPermission`. */
  documentType?: Maybe<DocumentType>;
  /** The `DocumentUserPermission` that was created by this mutation. */
  documentUserPermission?: Maybe<DocumentUserPermission>;
  /** An edge for our `DocumentUserPermission`. May be used by Relay 1. */
  documentUserPermissionEdge?: Maybe<DocumentUserPermissionsEdge>;
  /** Reads a single `Storage` that is related to this `DocumentUserPermission`. */
  file?: Maybe<Storage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `DocumentUserPermission`. */
  user?: Maybe<User>;
};


/** The output of our create `DocumentUserPermission` mutation. */
export type CreateDocumentUserPermissionPayloadDocumentUserPermissionEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentUserPermissionsOrderBy>>;
};

/** All input for the create `DocumentUserResponsible` mutation. */
export type CreateDocumentUserResponsibleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DocumentUserResponsible` to be created by this mutation. */
  documentUserResponsible: DocumentUserResponsibleInput;
};

/** The output of our create `DocumentUserResponsible` mutation. */
export type CreateDocumentUserResponsiblePayload = {
  __typename?: 'CreateDocumentUserResponsiblePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentUserResponsible`. */
  company?: Maybe<Company>;
  /** Reads a single `DocumentType` that is related to this `DocumentUserResponsible`. */
  documentType?: Maybe<DocumentType>;
  /** The `DocumentUserResponsible` that was created by this mutation. */
  documentUserResponsible?: Maybe<DocumentUserResponsible>;
  /** An edge for our `DocumentUserResponsible`. May be used by Relay 1. */
  documentUserResponsibleEdge?: Maybe<DocumentUserResponsiblesEdge>;
  /** Reads a single `Storage` that is related to this `DocumentUserResponsible`. */
  file?: Maybe<Storage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `DocumentUserResponsible`. */
  user?: Maybe<User>;
  /** Reads a single `User` that is related to this `DocumentUserResponsible`. */
  userByAssignedBy?: Maybe<User>;
};


/** The output of our create `DocumentUserResponsible` mutation. */
export type CreateDocumentUserResponsiblePayloadDocumentUserResponsibleEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentUserResponsiblesOrderBy>>;
};

/** All input for the create `EmployeeExternalIntegration` mutation. */
export type CreateEmployeeExternalIntegrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `EmployeeExternalIntegration` to be created by this mutation. */
  employeeExternalIntegration: EmployeeExternalIntegrationInput;
};

/** The output of our create `EmployeeExternalIntegration` mutation. */
export type CreateEmployeeExternalIntegrationPayload = {
  __typename?: 'CreateEmployeeExternalIntegrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `EmployeeExternalIntegration`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `EmployeeExternalIntegration`. */
  employee?: Maybe<Employee>;
  /** The `EmployeeExternalIntegration` that was created by this mutation. */
  employeeExternalIntegration?: Maybe<EmployeeExternalIntegration>;
  /** An edge for our `EmployeeExternalIntegration`. May be used by Relay 1. */
  employeeExternalIntegrationEdge?: Maybe<EmployeeExternalIntegrationsEdge>;
  /** Reads a single `ExternalIntegration` that is related to this `EmployeeExternalIntegration`. */
  externalIntegration?: Maybe<ExternalIntegration>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `EmployeeExternalIntegration` mutation. */
export type CreateEmployeeExternalIntegrationPayloadEmployeeExternalIntegrationEdgeArgs = {
  orderBy?: InputMaybe<Array<EmployeeExternalIntegrationsOrderBy>>;
};

/** All input for the create `EngagementType` mutation. */
export type CreateEngagementTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `EngagementType` to be created by this mutation. */
  engagementType: EngagementTypeInput;
};

/** The output of our create `EngagementType` mutation. */
export type CreateEngagementTypePayload = {
  __typename?: 'CreateEngagementTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `EngagementType`. */
  company?: Maybe<Company>;
  /** The `EngagementType` that was created by this mutation. */
  engagementType?: Maybe<EngagementType>;
  /** An edge for our `EngagementType`. May be used by Relay 1. */
  engagementTypeEdge?: Maybe<EngagementTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `EngagementType` mutation. */
export type CreateEngagementTypePayloadEngagementTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<EngagementTypesOrderBy>>;
};

/** All input for the create `Equipment` mutation. */
export type CreateEquipmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Equipment` to be created by this mutation. */
  equipment: EquipmentInput;
};

/** The output of our create `Equipment` mutation. */
export type CreateEquipmentPayload = {
  __typename?: 'CreateEquipmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Equipment`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `Equipment`. */
  employee?: Maybe<Employee>;
  /** The `Equipment` that was created by this mutation. */
  equipment?: Maybe<Equipment>;
  /** An edge for our `Equipment`. May be used by Relay 1. */
  equipmentEdge?: Maybe<EquipmentEdge>;
  /** Reads a single `Product` that is related to this `Equipment`. */
  product?: Maybe<Product>;
  /** Reads a single `ProductType` that is related to this `Equipment`. */
  productType?: Maybe<ProductType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Equipment`. */
  user?: Maybe<User>;
};


/** The output of our create `Equipment` mutation. */
export type CreateEquipmentPayloadEquipmentEdgeArgs = {
  orderBy?: InputMaybe<Array<EquipmentOrderBy>>;
};

/** All input for the create `Event` mutation. */
export type CreateEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Event` to be created by this mutation. */
  event: EventInput;
};

/** The output of our create `Event` mutation. */
export type CreateEventPayload = {
  __typename?: 'CreateEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Event`. */
  company?: Maybe<Company>;
  /** The `Event` that was created by this mutation. */
  event?: Maybe<Event>;
  /** An edge for our `Event`. May be used by Relay 1. */
  eventEdge?: Maybe<EventsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Event` mutation. */
export type CreateEventPayloadEventEdgeArgs = {
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};

/** All input for the create `EventUser` mutation. */
export type CreateEventUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `EventUser` to be created by this mutation. */
  eventUser: EventUserInput;
};

/** The output of our create `EventUser` mutation. */
export type CreateEventUserPayload = {
  __typename?: 'CreateEventUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `EventUser`. */
  company?: Maybe<Company>;
  /** Reads a single `Event` that is related to this `EventUser`. */
  event?: Maybe<Event>;
  /** The `EventUser` that was created by this mutation. */
  eventUser?: Maybe<EventUser>;
  /** An edge for our `EventUser`. May be used by Relay 1. */
  eventUserEdge?: Maybe<EventUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EventUser`. */
  user?: Maybe<User>;
};


/** The output of our create `EventUser` mutation. */
export type CreateEventUserPayloadEventUserEdgeArgs = {
  orderBy?: InputMaybe<Array<EventUsersOrderBy>>;
};

/** All input for the create `ExternalIntegration` mutation. */
export type CreateExternalIntegrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ExternalIntegration` to be created by this mutation. */
  externalIntegration: ExternalIntegrationInput;
};

/** The output of our create `ExternalIntegration` mutation. */
export type CreateExternalIntegrationPayload = {
  __typename?: 'CreateExternalIntegrationPayload';
  /** Reads a single `AuthApp` that is related to this `ExternalIntegration`. */
  authApp?: Maybe<AuthApp>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ExternalIntegration`. */
  company?: Maybe<Company>;
  /** The `ExternalIntegration` that was created by this mutation. */
  externalIntegration?: Maybe<ExternalIntegration>;
  /** An edge for our `ExternalIntegration`. May be used by Relay 1. */
  externalIntegrationEdge?: Maybe<ExternalIntegrationsEdge>;
  /** Reads a single `IntegrableSystem` that is related to this `ExternalIntegration`. */
  integrableSystem?: Maybe<IntegrableSystem>;
  /** Reads a single `DocumentFolderBlueprint` that is related to this `ExternalIntegration`. */
  payslipDocumentBlueprintFolder?: Maybe<DocumentFolderBlueprint>;
  /** Reads a single `DocumentType` that is related to this `ExternalIntegration`. */
  payslipDocumentType?: Maybe<DocumentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalSystem` that is related to this `ExternalIntegration`. */
  system?: Maybe<ExternalSystem>;
};


/** The output of our create `ExternalIntegration` mutation. */
export type CreateExternalIntegrationPayloadExternalIntegrationEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalIntegrationsOrderBy>>;
};

/** All input for the create `FieldGroupCardColumn` mutation. */
export type CreateFieldGroupCardColumnInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FieldGroupCardColumn` to be created by this mutation. */
  fieldGroupCardColumn: FieldGroupCardColumnInput;
};

/** The output of our create `FieldGroupCardColumn` mutation. */
export type CreateFieldGroupCardColumnPayload = {
  __typename?: 'CreateFieldGroupCardColumnPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FieldGroupCardColumn`. */
  company?: Maybe<Company>;
  /** Reads a single `FieldGroupCard` that is related to this `FieldGroupCardColumn`. */
  fieldGroupCard?: Maybe<FieldGroupCard>;
  /** The `FieldGroupCardColumn` that was created by this mutation. */
  fieldGroupCardColumn?: Maybe<FieldGroupCardColumn>;
  /** An edge for our `FieldGroupCardColumn`. May be used by Relay 1. */
  fieldGroupCardColumnEdge?: Maybe<FieldGroupCardColumnsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `FieldGroupCardColumn` mutation. */
export type CreateFieldGroupCardColumnPayloadFieldGroupCardColumnEdgeArgs = {
  orderBy?: InputMaybe<Array<FieldGroupCardColumnsOrderBy>>;
};

/** All input for the create `FieldGroupCard` mutation. */
export type CreateFieldGroupCardInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FieldGroupCard` to be created by this mutation. */
  fieldGroupCard: FieldGroupCardInput;
};

/** The output of our create `FieldGroupCard` mutation. */
export type CreateFieldGroupCardPayload = {
  __typename?: 'CreateFieldGroupCardPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FieldGroupCard`. */
  company?: Maybe<Company>;
  /** Reads a single `FieldGroup` that is related to this `FieldGroupCard`. */
  fieldGroup?: Maybe<FieldGroup>;
  /** The `FieldGroupCard` that was created by this mutation. */
  fieldGroupCard?: Maybe<FieldGroupCard>;
  /** An edge for our `FieldGroupCard`. May be used by Relay 1. */
  fieldGroupCardEdge?: Maybe<FieldGroupCardsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `FieldGroupCard` mutation. */
export type CreateFieldGroupCardPayloadFieldGroupCardEdgeArgs = {
  orderBy?: InputMaybe<Array<FieldGroupCardsOrderBy>>;
};

/** All input for the create `FieldGroup` mutation. */
export type CreateFieldGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FieldGroup` to be created by this mutation. */
  fieldGroup: FieldGroupInput;
};

/** The output of our create `FieldGroup` mutation. */
export type CreateFieldGroupPayload = {
  __typename?: 'CreateFieldGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FieldGroup`. */
  company?: Maybe<Company>;
  /** The `FieldGroup` that was created by this mutation. */
  fieldGroup?: Maybe<FieldGroup>;
  /** An edge for our `FieldGroup`. May be used by Relay 1. */
  fieldGroupEdge?: Maybe<FieldGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `FieldGroup` mutation. */
export type CreateFieldGroupPayloadFieldGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<FieldGroupsOrderBy>>;
};

/** All input for the create `FilterPreset` mutation. */
export type CreateFilterPresetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FilterPreset` to be created by this mutation. */
  filterPreset: FilterPresetInput;
};

/** The output of our create `FilterPreset` mutation. */
export type CreateFilterPresetPayload = {
  __typename?: 'CreateFilterPresetPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FilterPreset`. */
  company?: Maybe<Company>;
  /** The `FilterPreset` that was created by this mutation. */
  filterPreset?: Maybe<FilterPreset>;
  /** An edge for our `FilterPreset`. May be used by Relay 1. */
  filterPresetEdge?: Maybe<FilterPresetsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `FilterPreset`. */
  user?: Maybe<User>;
};


/** The output of our create `FilterPreset` mutation. */
export type CreateFilterPresetPayloadFilterPresetEdgeArgs = {
  orderBy?: InputMaybe<Array<FilterPresetsOrderBy>>;
};

/** All input for the create `FilterView` mutation. */
export type CreateFilterViewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FilterView` to be created by this mutation. */
  filterView: FilterViewInput;
};

/** The output of our create `FilterView` mutation. */
export type CreateFilterViewPayload = {
  __typename?: 'CreateFilterViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `FilterView` that was created by this mutation. */
  filterView?: Maybe<FilterView>;
  /** An edge for our `FilterView`. May be used by Relay 1. */
  filterViewEdge?: Maybe<FilterViewsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `FilterView`. */
  user?: Maybe<User>;
};


/** The output of our create `FilterView` mutation. */
export type CreateFilterViewPayloadFilterViewEdgeArgs = {
  orderBy?: InputMaybe<Array<FilterViewsOrderBy>>;
};

/** All input for the create `FormFieldAgreement` mutation. */
export type CreateFormFieldAgreementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FormFieldAgreement` to be created by this mutation. */
  formFieldAgreement: FormFieldAgreementInput;
};

/** The output of our create `FormFieldAgreement` mutation. */
export type CreateFormFieldAgreementPayload = {
  __typename?: 'CreateFormFieldAgreementPayload';
  /** Reads a single `TranslatedEntity` that is related to this `FormFieldAgreement`. */
  agreementTextTranslatedEntity?: Maybe<TranslatedEntity>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FormFieldAgreement`. */
  company?: Maybe<Company>;
  /** Reads a single `FormField` that is related to this `FormFieldAgreement`. */
  formField?: Maybe<FormField>;
  /** The `FormFieldAgreement` that was created by this mutation. */
  formFieldAgreement?: Maybe<FormFieldAgreement>;
  /** An edge for our `FormFieldAgreement`. May be used by Relay 1. */
  formFieldAgreementEdge?: Maybe<FormFieldAgreementsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `FormFieldAgreement` mutation. */
export type CreateFormFieldAgreementPayloadFormFieldAgreementEdgeArgs = {
  orderBy?: InputMaybe<Array<FormFieldAgreementsOrderBy>>;
};

/** All input for the create `FormFieldEntry` mutation. */
export type CreateFormFieldEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FormFieldEntry` to be created by this mutation. */
  formFieldEntry: FormFieldEntryInput;
};

/** The output of our create `FormFieldEntry` mutation. */
export type CreateFormFieldEntryPayload = {
  __typename?: 'CreateFormFieldEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FormFieldEntry`. */
  company?: Maybe<Company>;
  /** Reads a single `Department` that is related to this `FormFieldEntry`. */
  department?: Maybe<Department>;
  /** Reads a single `Employee` that is related to this `FormFieldEntry`. */
  employee?: Maybe<Employee>;
  /** Reads a single `FieldGroup` that is related to this `FormFieldEntry`. */
  fieldGroup?: Maybe<FieldGroup>;
  /** Reads a single `FormField` that is related to this `FormFieldEntry`. */
  formField?: Maybe<FormField>;
  /** The `FormFieldEntry` that was created by this mutation. */
  formFieldEntry?: Maybe<FormFieldEntry>;
  /** An edge for our `FormFieldEntry`. May be used by Relay 1. */
  formFieldEntryEdge?: Maybe<FormFieldEntriesEdge>;
  /** Reads a single `Product` that is related to this `FormFieldEntry`. */
  product?: Maybe<Product>;
  /** Reads a single `Department` that is related to this `FormFieldEntry`. */
  productDepartment?: Maybe<Department>;
  /** Reads a single `User` that is related to this `FormFieldEntry`. */
  productUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `FormFieldEntry`. */
  user?: Maybe<User>;
  /** Reads a single `UserCompetenceEvaluation` that is related to this `FormFieldEntry`. */
  userCompetenceEvaluation?: Maybe<UserCompetenceEvaluation>;
};


/** The output of our create `FormFieldEntry` mutation. */
export type CreateFormFieldEntryPayloadFormFieldEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<FormFieldEntriesOrderBy>>;
};

/** All input for the create `FormField` mutation. */
export type CreateFormFieldInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FormField` to be created by this mutation. */
  formField: FormFieldInput;
};

/** All input for the create `FormFieldOption` mutation. */
export type CreateFormFieldOptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FormFieldOption` to be created by this mutation. */
  formFieldOption: FormFieldOptionInput;
};

/** The output of our create `FormFieldOption` mutation. */
export type CreateFormFieldOptionPayload = {
  __typename?: 'CreateFormFieldOptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FormFieldOption`. */
  company?: Maybe<Company>;
  /** Reads a single `EngagementType` that is related to this `FormFieldOption`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `FormField` that is related to this `FormFieldOption`. */
  formField?: Maybe<FormField>;
  /** The `FormFieldOption` that was created by this mutation. */
  formFieldOption?: Maybe<FormFieldOption>;
  /** An edge for our `FormFieldOption`. May be used by Relay 1. */
  formFieldOptionEdge?: Maybe<FormFieldOptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `FormFieldOption` mutation. */
export type CreateFormFieldOptionPayloadFormFieldOptionEdgeArgs = {
  orderBy?: InputMaybe<Array<FormFieldOptionsOrderBy>>;
};

/** The output of our create `FormField` mutation. */
export type CreateFormFieldPayload = {
  __typename?: 'CreateFormFieldPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EngagementType` that is related to this `FormField`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `Event` that is related to this `FormField`. */
  event?: Maybe<Event>;
  /** Reads a single `FieldGroup` that is related to this `FormField`. */
  fieldGroup?: Maybe<FieldGroup>;
  /** Reads a single `FieldGroupCardColumn` that is related to this `FormField`. */
  fieldGroupCardColumn?: Maybe<FieldGroupCardColumn>;
  /** The `FormField` that was created by this mutation. */
  formField?: Maybe<FormField>;
  /** An edge for our `FormField`. May be used by Relay 1. */
  formFieldEdge?: Maybe<FormFieldsEdge>;
  /** Reads a single `FormField` that is related to this `FormField`. */
  parentFormField?: Maybe<FormField>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `FormField` mutation. */
export type CreateFormFieldPayloadFormFieldEdgeArgs = {
  orderBy?: InputMaybe<Array<FormFieldsOrderBy>>;
};

/** All input for the create `FroalaStyle` mutation. */
export type CreateFroalaStyleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FroalaStyle` to be created by this mutation. */
  froalaStyle: FroalaStyleInput;
};

/** The output of our create `FroalaStyle` mutation. */
export type CreateFroalaStylePayload = {
  __typename?: 'CreateFroalaStylePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FroalaStyle`. */
  company?: Maybe<Company>;
  /** The `FroalaStyle` that was created by this mutation. */
  froalaStyle?: Maybe<FroalaStyle>;
  /** An edge for our `FroalaStyle`. May be used by Relay 1. */
  froalaStyleEdge?: Maybe<FroalaStylesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `FroalaStyle` mutation. */
export type CreateFroalaStylePayloadFroalaStyleEdgeArgs = {
  orderBy?: InputMaybe<Array<FroalaStylesOrderBy>>;
};

/** All input for the `createFutureDatum` mutation. */
export type CreateFutureDatumInput = {
  argFormFieldId?: InputMaybe<Scalars['UUID']>;
  argSystemFieldId?: InputMaybe<Scalars['UUID']>;
  argUniqueKey?: InputMaybe<Scalars['UUID']>;
  argUpdateValueAt?: InputMaybe<Scalars['Datetime']>;
  argUserId?: InputMaybe<Scalars['UUID']>;
  argValue?: InputMaybe<Scalars['JSON']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `createFutureDatum` mutation. */
export type CreateFutureDatumPayload = {
  __typename?: 'CreateFutureDatumPayload';
  /** Reads a single `Approval` that is related to this `FutureDatum`. */
  approval?: Maybe<Approval>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FutureDatum`. */
  company?: Maybe<Company>;
  /** Reads a single `User` that is related to this `FutureDatum`. */
  creatorUser?: Maybe<User>;
  /** Reads a single `FieldGroup` that is related to this `FutureDatum`. */
  fieldGroup?: Maybe<FieldGroup>;
  /** Reads a single `FormField` that is related to this `FutureDatum`. */
  formField?: Maybe<FormField>;
  futureDatum?: Maybe<FutureDatum>;
  /** An edge for our `FutureDatum`. May be used by Relay 1. */
  futureDatumEdge?: Maybe<FutureDataEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SystemField` that is related to this `FutureDatum`. */
  systemField?: Maybe<SystemField>;
  /** Reads a single `User` that is related to this `FutureDatum`. */
  user?: Maybe<User>;
};


/** The output of our `createFutureDatum` mutation. */
export type CreateFutureDatumPayloadFutureDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<FutureDataOrderBy>>;
};

/** All input for the create `Group` mutation. */
export type CreateGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Group` to be created by this mutation. */
  group: GroupInput;
};

/** The output of our create `Group` mutation. */
export type CreateGroupPayload = {
  __typename?: 'CreateGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Group` that was created by this mutation. */
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Group` mutation. */
export type CreateGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

/** All input for the create `GroupRole` mutation. */
export type CreateGroupRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `GroupRole` to be created by this mutation. */
  groupRole: GroupRoleInput;
};

/** The output of our create `GroupRole` mutation. */
export type CreateGroupRolePayload = {
  __typename?: 'CreateGroupRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `GroupRole`. */
  company?: Maybe<Company>;
  /** Reads a single `Group` that is related to this `GroupRole`. */
  group?: Maybe<Group>;
  /** The `GroupRole` that was created by this mutation. */
  groupRole?: Maybe<GroupRole>;
  /** An edge for our `GroupRole`. May be used by Relay 1. */
  groupRoleEdge?: Maybe<GroupRolesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Role` that is related to this `GroupRole`. */
  role?: Maybe<Role>;
};


/** The output of our create `GroupRole` mutation. */
export type CreateGroupRolePayloadGroupRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupRolesOrderBy>>;
};

/** All input for the create `IntegrableSystem` mutation. */
export type CreateIntegrableSystemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `IntegrableSystem` to be created by this mutation. */
  integrableSystem: IntegrableSystemInput;
};

/** The output of our create `IntegrableSystem` mutation. */
export type CreateIntegrableSystemPayload = {
  __typename?: 'CreateIntegrableSystemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `IntegrableSystem` that was created by this mutation. */
  integrableSystem?: Maybe<IntegrableSystem>;
  /** An edge for our `IntegrableSystem`. May be used by Relay 1. */
  integrableSystemEdge?: Maybe<IntegrableSystemsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `IntegrableSystem` mutation. */
export type CreateIntegrableSystemPayloadIntegrableSystemEdgeArgs = {
  orderBy?: InputMaybe<Array<IntegrableSystemsOrderBy>>;
};

/** All input for the create `IntegrationFieldMarking` mutation. */
export type CreateIntegrationFieldMarkingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `IntegrationFieldMarking` to be created by this mutation. */
  integrationFieldMarking: IntegrationFieldMarkingInput;
};

/** The output of our create `IntegrationFieldMarking` mutation. */
export type CreateIntegrationFieldMarkingPayload = {
  __typename?: 'CreateIntegrationFieldMarkingPayload';
  /** Reads a single `AuthApp` that is related to this `IntegrationFieldMarking`. */
  authApp?: Maybe<AuthApp>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `IntegrationFieldMarking`. */
  company?: Maybe<Company>;
  /** Reads a single `ExternalIntegration` that is related to this `IntegrationFieldMarking`. */
  externalIntegration?: Maybe<ExternalIntegration>;
  /** Reads a single `FormField` that is related to this `IntegrationFieldMarking`. */
  formField?: Maybe<FormField>;
  /** The `IntegrationFieldMarking` that was created by this mutation. */
  integrationFieldMarking?: Maybe<IntegrationFieldMarking>;
  /** An edge for our `IntegrationFieldMarking`. May be used by Relay 1. */
  integrationFieldMarkingEdge?: Maybe<IntegrationFieldMarkingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Storage` that is related to this `IntegrationFieldMarking`. */
  storage?: Maybe<Storage>;
  /** Reads a single `SystemField` that is related to this `IntegrationFieldMarking`. */
  systemField?: Maybe<SystemField>;
};


/** The output of our create `IntegrationFieldMarking` mutation. */
export type CreateIntegrationFieldMarkingPayloadIntegrationFieldMarkingEdgeArgs = {
  orderBy?: InputMaybe<Array<IntegrationFieldMarkingsOrderBy>>;
};

export type CreateIntegrationInput = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  accessToken?: InputMaybe<Scalars['String']>;
  apiKey?: InputMaybe<Scalars['String']>;
  blacklistedFields?: InputMaybe<Array<BlacklistedField>>;
  companyId: Scalars['UUID'];
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  copyEmployees?: InputMaybe<Scalars['Boolean']>;
  departmentId?: InputMaybe<Scalars['String']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  externalAdditionId?: InputMaybe<Scalars['String']>;
  externalCompanyId: Scalars['String'];
  fieldMappings?: InputMaybe<Array<FieldMapping>>;
  overwriteExternalData?: InputMaybe<Scalars['Boolean']>;
  payslipDocumentFolderId?: InputMaybe<Scalars['String']>;
  payslipDocumentTypeId?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  system: IntegrationSystemInput;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Array<WhitelistedField>>;
};

export type CreateIntegrationResponse = {
  __typename?: 'CreateIntegrationResponse';
  message: Scalars['String'];
};

/** All input for the `createLoggedAction` mutation. */
export type CreateLoggedActionInput = {
  affectedId?: InputMaybe<Scalars['String']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  selectedFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  tableName?: InputMaybe<Scalars['String']>;
};

/** All input for the create `LoggedActionNote` mutation. */
export type CreateLoggedActionNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LoggedActionNote` to be created by this mutation. */
  loggedActionNote: LoggedActionNoteInput;
};

/** The output of our create `LoggedActionNote` mutation. */
export type CreateLoggedActionNotePayload = {
  __typename?: 'CreateLoggedActionNotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `LoggedActionNote`. */
  company?: Maybe<Company>;
  /** The `LoggedActionNote` that was created by this mutation. */
  loggedActionNote?: Maybe<LoggedActionNote>;
  /** An edge for our `LoggedActionNote`. May be used by Relay 1. */
  loggedActionNoteEdge?: Maybe<LoggedActionNotesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `LoggedActionNote`. */
  superUser?: Maybe<User>;
  /** Reads a single `User` that is related to this `LoggedActionNote`. */
  user?: Maybe<User>;
};


/** The output of our create `LoggedActionNote` mutation. */
export type CreateLoggedActionNotePayloadLoggedActionNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<LoggedActionNotesOrderBy>>;
};

/** The output of our `createLoggedAction` mutation. */
export type CreateLoggedActionPayload = {
  __typename?: 'CreateLoggedActionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the create `Message` mutation. */
export type CreateMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Message` to be created by this mutation. */
  message: MessageInput;
};

/** The output of our create `Message` mutation. */
export type CreateMessagePayload = {
  __typename?: 'CreateMessagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Message`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `Message`. */
  fromEmployee?: Maybe<Employee>;
  /** The `Message` that was created by this mutation. */
  message?: Maybe<Message>;
  /** An edge for our `Message`. May be used by Relay 1. */
  messageEdge?: Maybe<MessagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Employee` that is related to this `Message`. */
  toEmployee?: Maybe<Employee>;
};


/** The output of our create `Message` mutation. */
export type CreateMessagePayloadMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};

/** All input for the create `MessageRecipient` mutation. */
export type CreateMessageRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MessageRecipient` to be created by this mutation. */
  messageRecipient: MessageRecipientInput;
};

/** The output of our create `MessageRecipient` mutation. */
export type CreateMessageRecipientPayload = {
  __typename?: 'CreateMessageRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Employee` that is related to this `MessageRecipient`. */
  employee?: Maybe<Employee>;
  /** Reads a single `Message` that is related to this `MessageRecipient`. */
  message?: Maybe<Message>;
  /** The `MessageRecipient` that was created by this mutation. */
  messageRecipient?: Maybe<MessageRecipient>;
  /** An edge for our `MessageRecipient`. May be used by Relay 1. */
  messageRecipientEdge?: Maybe<MessageRecipientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `MessageRecipient` mutation. */
export type CreateMessageRecipientPayloadMessageRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<MessageRecipientsOrderBy>>;
};

/** All input for the create `NotificationCustomEmployeeFieldRecipient` mutation. */
export type CreateNotificationCustomEmployeeFieldRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `NotificationCustomEmployeeFieldRecipient` to be created by this mutation. */
  notificationCustomEmployeeFieldRecipient: NotificationCustomEmployeeFieldRecipientInput;
};

/** The output of our create `NotificationCustomEmployeeFieldRecipient` mutation. */
export type CreateNotificationCustomEmployeeFieldRecipientPayload = {
  __typename?: 'CreateNotificationCustomEmployeeFieldRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `NotificationCustomEmployeeFieldRecipient`. */
  company?: Maybe<Company>;
  /** Reads a single `FormField` that is related to this `NotificationCustomEmployeeFieldRecipient`. */
  formField?: Maybe<FormField>;
  /** Reads a single `Notification` that is related to this `NotificationCustomEmployeeFieldRecipient`. */
  notification?: Maybe<Notification>;
  /** The `NotificationCustomEmployeeFieldRecipient` that was created by this mutation. */
  notificationCustomEmployeeFieldRecipient?: Maybe<NotificationCustomEmployeeFieldRecipient>;
  /** An edge for our `NotificationCustomEmployeeFieldRecipient`. May be used by Relay 1. */
  notificationCustomEmployeeFieldRecipientEdge?: Maybe<NotificationCustomEmployeeFieldRecipientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `NotificationCustomEmployeeFieldRecipient` mutation. */
export type CreateNotificationCustomEmployeeFieldRecipientPayloadNotificationCustomEmployeeFieldRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientsOrderBy>>;
};

/** All input for the create `NotificationCustomRecipient` mutation. */
export type CreateNotificationCustomRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `NotificationCustomRecipient` to be created by this mutation. */
  notificationCustomRecipient: NotificationCustomRecipientInput;
};

/** The output of our create `NotificationCustomRecipient` mutation. */
export type CreateNotificationCustomRecipientPayload = {
  __typename?: 'CreateNotificationCustomRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `NotificationCustomRecipient`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `NotificationCustomRecipient`. */
  employee?: Maybe<Employee>;
  /** Reads a single `Notification` that is related to this `NotificationCustomRecipient`. */
  notification?: Maybe<Notification>;
  /** The `NotificationCustomRecipient` that was created by this mutation. */
  notificationCustomRecipient?: Maybe<NotificationCustomRecipient>;
  /** An edge for our `NotificationCustomRecipient`. May be used by Relay 1. */
  notificationCustomRecipientEdge?: Maybe<NotificationCustomRecipientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `NotificationCustomRecipient`. */
  user?: Maybe<User>;
};


/** The output of our create `NotificationCustomRecipient` mutation. */
export type CreateNotificationCustomRecipientPayloadNotificationCustomRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationCustomRecipientsOrderBy>>;
};

/** All input for the create `NotificationEmployee` mutation. */
export type CreateNotificationEmployeeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `NotificationEmployee` to be created by this mutation. */
  notificationEmployee: NotificationEmployeeInput;
};

/** The output of our create `NotificationEmployee` mutation. */
export type CreateNotificationEmployeePayload = {
  __typename?: 'CreateNotificationEmployeePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `NotificationEmployee`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `NotificationEmployee`. */
  employee?: Maybe<Employee>;
  /** Reads a single `Notification` that is related to this `NotificationEmployee`. */
  notification?: Maybe<Notification>;
  /** The `NotificationEmployee` that was created by this mutation. */
  notificationEmployee?: Maybe<NotificationEmployee>;
  /** An edge for our `NotificationEmployee`. May be used by Relay 1. */
  notificationEmployeeEdge?: Maybe<NotificationEmployeesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Employee` that is related to this `NotificationEmployee`. */
  recipient?: Maybe<Employee>;
  /** Reads a single `Employee` that is related to this `NotificationEmployee`. */
  sender?: Maybe<Employee>;
};


/** The output of our create `NotificationEmployee` mutation. */
export type CreateNotificationEmployeePayloadNotificationEmployeeEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationEmployeesOrderBy>>;
};

/** All input for the create `NotificationEmployeeReference` mutation. */
export type CreateNotificationEmployeeReferenceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `NotificationEmployeeReference` to be created by this mutation. */
  notificationEmployeeReference: NotificationEmployeeReferenceInput;
};

/** The output of our create `NotificationEmployeeReference` mutation. */
export type CreateNotificationEmployeeReferencePayload = {
  __typename?: 'CreateNotificationEmployeeReferencePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `NotificationEmployeeReference`. */
  company?: Maybe<Company>;
  /** Reads a single `Competence` that is related to this `NotificationEmployeeReference`. */
  competence?: Maybe<Competence>;
  /** Reads a single `CompetenceGroup` that is related to this `NotificationEmployeeReference`. */
  competenceGroup?: Maybe<CompetenceGroup>;
  /** Reads a single `ContractSignPending` that is related to this `NotificationEmployeeReference`. */
  contractSignPending?: Maybe<ContractSignPending>;
  /** Reads a single `Department` that is related to this `NotificationEmployeeReference`. */
  department?: Maybe<Department>;
  /** Reads a single `Employee` that is related to this `NotificationEmployeeReference`. */
  employee?: Maybe<Employee>;
  /** Reads a single `Storage` that is related to this `NotificationEmployeeReference`. */
  file?: Maybe<Storage>;
  /** Reads a single `FutureDatum` that is related to this `NotificationEmployeeReference`. */
  futureData?: Maybe<FutureDatum>;
  /** Reads a single `Message` that is related to this `NotificationEmployeeReference`. */
  message?: Maybe<Message>;
  /** Reads a single `NotificationEmployee` that is related to this `NotificationEmployeeReference`. */
  notificationEmployee?: Maybe<NotificationEmployee>;
  /** The `NotificationEmployeeReference` that was created by this mutation. */
  notificationEmployeeReference?: Maybe<NotificationEmployeeReference>;
  /** An edge for our `NotificationEmployeeReference`. May be used by Relay 1. */
  notificationEmployeeReferenceEdge?: Maybe<NotificationEmployeeReferencesEdge>;
  /** Reads a single `Preboarding` that is related to this `NotificationEmployeeReference`. */
  preboarding?: Maybe<Preboarding>;
  /** Reads a single `Process` that is related to this `NotificationEmployeeReference`. */
  process?: Maybe<Process>;
  /** Reads a single `Product` that is related to this `NotificationEmployeeReference`. */
  product?: Maybe<Product>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `NotificationEmployeeReference`. */
  recipientUser?: Maybe<User>;
  /** Reads a single `Task` that is related to this `NotificationEmployeeReference`. */
  task?: Maybe<Task>;
  /** Reads a single `TaskTemplate` that is related to this `NotificationEmployeeReference`. */
  taskTemplate?: Maybe<TaskTemplate>;
  /** Reads a single `TimeRegistrationPresence` that is related to this `NotificationEmployeeReference`. */
  timeRegistrationPresence?: Maybe<TimeRegistrationPresence>;
  /** Reads a single `UserCompetence` that is related to this `NotificationEmployeeReference`. */
  userCompetence?: Maybe<UserCompetence>;
  /** Reads a single `VacationType` that is related to this `NotificationEmployeeReference`. */
  vacationType?: Maybe<VacationType>;
  /** Reads a single `VacationUser` that is related to this `NotificationEmployeeReference`. */
  vacationUser?: Maybe<VacationUser>;
};


/** The output of our create `NotificationEmployeeReference` mutation. */
export type CreateNotificationEmployeeReferencePayloadNotificationEmployeeReferenceEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};

/** All input for the create `NotificationGroupRecipient` mutation. */
export type CreateNotificationGroupRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `NotificationGroupRecipient` to be created by this mutation. */
  notificationGroupRecipient: NotificationGroupRecipientInput;
};

/** The output of our create `NotificationGroupRecipient` mutation. */
export type CreateNotificationGroupRecipientPayload = {
  __typename?: 'CreateNotificationGroupRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `NotificationGroupRecipient`. */
  company?: Maybe<Company>;
  /** Reads a single `Group` that is related to this `NotificationGroupRecipient`. */
  group?: Maybe<Group>;
  /** Reads a single `Notification` that is related to this `NotificationGroupRecipient`. */
  notification?: Maybe<Notification>;
  /** The `NotificationGroupRecipient` that was created by this mutation. */
  notificationGroupRecipient?: Maybe<NotificationGroupRecipient>;
  /** An edge for our `NotificationGroupRecipient`. May be used by Relay 1. */
  notificationGroupRecipientEdge?: Maybe<NotificationGroupRecipientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `NotificationGroupRecipient` mutation. */
export type CreateNotificationGroupRecipientPayloadNotificationGroupRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationGroupRecipientsOrderBy>>;
};

/** All input for the create `Notification` mutation. */
export type CreateNotificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Notification` to be created by this mutation. */
  notification: NotificationInput;
};

/** The output of our create `Notification` mutation. */
export type CreateNotificationPayload = {
  __typename?: 'CreateNotificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Hook` that is related to this `Notification`. */
  hook?: Maybe<Hook>;
  /** The `Notification` that was created by this mutation. */
  notification?: Maybe<Notification>;
  /** An edge for our `Notification`. May be used by Relay 1. */
  notificationEdge?: Maybe<NotificationsEdge>;
  /** Reads a single `NotificationType` that is related to this `Notification`. */
  notificationType?: Maybe<NotificationType>;
  /** Reads a single `Preboarding` that is related to this `Notification`. */
  preboarding?: Maybe<Preboarding>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Notification` mutation. */
export type CreateNotificationPayloadNotificationEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** All input for the create `NotificationTypeChannelType` mutation. */
export type CreateNotificationTypeChannelTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `NotificationTypeChannelType` to be created by this mutation. */
  notificationTypeChannelType: NotificationTypeChannelTypeInput;
};

/** The output of our create `NotificationTypeChannelType` mutation. */
export type CreateNotificationTypeChannelTypePayload = {
  __typename?: 'CreateNotificationTypeChannelTypePayload';
  /** Reads a single `ChannelType` that is related to this `NotificationTypeChannelType`. */
  channelType?: Maybe<ChannelType>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `NotificationTypeChannelType`. */
  company?: Maybe<Company>;
  /** Reads a single `NotificationType` that is related to this `NotificationTypeChannelType`. */
  notificationType?: Maybe<NotificationType>;
  /** The `NotificationTypeChannelType` that was created by this mutation. */
  notificationTypeChannelType?: Maybe<NotificationTypeChannelType>;
  /** An edge for our `NotificationTypeChannelType`. May be used by Relay 1. */
  notificationTypeChannelTypeEdge?: Maybe<NotificationTypeChannelTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `NotificationTypeChannelType` mutation. */
export type CreateNotificationTypeChannelTypePayloadNotificationTypeChannelTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationTypeChannelTypesOrderBy>>;
};

/** All input for the create `NotificationType` mutation. */
export type CreateNotificationTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `NotificationType` to be created by this mutation. */
  notificationType: NotificationTypeInput;
};

/** The output of our create `NotificationType` mutation. */
export type CreateNotificationTypePayload = {
  __typename?: 'CreateNotificationTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `NotificationType` that was created by this mutation. */
  notificationType?: Maybe<NotificationType>;
  /** An edge for our `NotificationType`. May be used by Relay 1. */
  notificationTypeEdge?: Maybe<NotificationTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `NotificationType` mutation. */
export type CreateNotificationTypePayloadNotificationTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationTypesOrderBy>>;
};

export type CreatePostCommentInput = {
  postId?: InputMaybe<Scalars['UUID']>;
  text?: InputMaybe<Scalars['String']>;
};

/** All input for the create `Post` mutation. */
export type CreatePostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Post` to be created by this mutation. */
  post: PostInput;
};

/** The output of our create `Post` mutation. */
export type CreatePostPayload = {
  __typename?: 'CreatePostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Post`. */
  company?: Maybe<Company>;
  /** The `Post` that was created by this mutation. */
  post?: Maybe<Post>;
  /** An edge for our `Post`. May be used by Relay 1. */
  postEdge?: Maybe<PostsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Post`. */
  user?: Maybe<User>;
};


/** The output of our create `Post` mutation. */
export type CreatePostPayloadPostEdgeArgs = {
  orderBy?: InputMaybe<Array<PostsOrderBy>>;
};

/** All input for the create `PostType` mutation. */
export type CreatePostTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PostType` to be created by this mutation. */
  postType: PostTypeInput;
};

/** The output of our create `PostType` mutation. */
export type CreatePostTypePayload = {
  __typename?: 'CreatePostTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PostType`. */
  company?: Maybe<Company>;
  /** Reads a single `TranslatedEntity` that is related to this `PostType`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** The `PostType` that was created by this mutation. */
  postType?: Maybe<PostType>;
  /** An edge for our `PostType`. May be used by Relay 1. */
  postTypeEdge?: Maybe<PostTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PostType` mutation. */
export type CreatePostTypePayloadPostTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<PostTypesOrderBy>>;
};

/** All input for the create `PreboardingComment` mutation. */
export type CreatePreboardingCommentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PreboardingComment` to be created by this mutation. */
  preboardingComment: PreboardingCommentInput;
};

/** The output of our create `PreboardingComment` mutation. */
export type CreatePreboardingCommentPayload = {
  __typename?: 'CreatePreboardingCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingComment`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `PreboardingComment`. */
  employee?: Maybe<Employee>;
  /** Reads a single `EngagementType` that is related to this `PreboardingComment`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `Preboarding` that is related to this `PreboardingComment`. */
  preboarding?: Maybe<Preboarding>;
  /** The `PreboardingComment` that was created by this mutation. */
  preboardingComment?: Maybe<PreboardingComment>;
  /** An edge for our `PreboardingComment`. May be used by Relay 1. */
  preboardingCommentEdge?: Maybe<PreboardingCommentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PreboardingComment`. */
  user?: Maybe<User>;
};


/** The output of our create `PreboardingComment` mutation. */
export type CreatePreboardingCommentPayloadPreboardingCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingCommentsOrderBy>>;
};

/** All input for the create `PreboardingEmployee` mutation. */
export type CreatePreboardingEmployeeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PreboardingEmployee` to be created by this mutation. */
  preboardingEmployee: PreboardingEmployeeInput;
};

/** The output of our create `PreboardingEmployee` mutation. */
export type CreatePreboardingEmployeePayload = {
  __typename?: 'CreatePreboardingEmployeePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingEmployee`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `PreboardingEmployee`. */
  employee?: Maybe<Employee>;
  /** Reads a single `EngagementType` that is related to this `PreboardingEmployee`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `Preboarding` that is related to this `PreboardingEmployee`. */
  preboarding?: Maybe<Preboarding>;
  /** The `PreboardingEmployee` that was created by this mutation. */
  preboardingEmployee?: Maybe<PreboardingEmployee>;
  /** An edge for our `PreboardingEmployee`. May be used by Relay 1. */
  preboardingEmployeeEdge?: Maybe<PreboardingEmployeesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PreboardingEmployee`. */
  recipient?: Maybe<User>;
  /** Reads a single `User` that is related to this `PreboardingEmployee`. */
  user?: Maybe<User>;
};


/** The output of our create `PreboardingEmployee` mutation. */
export type CreatePreboardingEmployeePayloadPreboardingEmployeeEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingEmployeesOrderBy>>;
};

/** All input for the create `PreboardingFormCache` mutation. */
export type CreatePreboardingFormCacheInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PreboardingFormCache` to be created by this mutation. */
  preboardingFormCache: PreboardingFormCacheInput;
};

/** The output of our create `PreboardingFormCache` mutation. */
export type CreatePreboardingFormCachePayload = {
  __typename?: 'CreatePreboardingFormCachePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Preboarding` that is related to this `PreboardingFormCache`. */
  preboarding?: Maybe<Preboarding>;
  /** The `PreboardingFormCache` that was created by this mutation. */
  preboardingFormCache?: Maybe<PreboardingFormCache>;
  /** An edge for our `PreboardingFormCache`. May be used by Relay 1. */
  preboardingFormCacheEdge?: Maybe<PreboardingFormCachesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PreboardingFormCache`. */
  user?: Maybe<User>;
};


/** The output of our create `PreboardingFormCache` mutation. */
export type CreatePreboardingFormCachePayloadPreboardingFormCacheEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingFormCachesOrderBy>>;
};

/** All input for the create `Preboarding` mutation. */
export type CreatePreboardingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Preboarding` to be created by this mutation. */
  preboarding: PreboardingInput;
};

/** The output of our create `Preboarding` mutation. */
export type CreatePreboardingPayload = {
  __typename?: 'CreatePreboardingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Preboarding`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `Preboarding`. */
  employee?: Maybe<Employee>;
  /** Reads a single `EngagementType` that is related to this `Preboarding`. */
  engagementType?: Maybe<EngagementType>;
  /** The `Preboarding` that was created by this mutation. */
  preboarding?: Maybe<Preboarding>;
  /** Reads a single `Preboarding` that is related to this `Preboarding`. */
  preboardingByCreatedFrom?: Maybe<Preboarding>;
  /** An edge for our `Preboarding`. May be used by Relay 1. */
  preboardingEdge?: Maybe<PreboardingsEdge>;
  /** Reads a single `Preboarding` that is related to this `Preboarding`. */
  predecessor?: Maybe<Preboarding>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Preboarding`. */
  recipient?: Maybe<User>;
  /** Reads a single `FormField` that is related to this `Preboarding`. */
  recipientCustomEmployeeField?: Maybe<FormField>;
  /** Reads a single `Group` that is related to this `Preboarding`. */
  recipientGroup?: Maybe<Group>;
};


/** The output of our create `Preboarding` mutation. */
export type CreatePreboardingPayloadPreboardingEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingsOrderBy>>;
};

/** All input for the create `PreboardingProcess` mutation. */
export type CreatePreboardingProcessInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PreboardingProcess` to be created by this mutation. */
  preboardingProcess: PreboardingProcessInput;
};

/** The output of our create `PreboardingProcess` mutation. */
export type CreatePreboardingProcessPayload = {
  __typename?: 'CreatePreboardingProcessPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingProcess`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `PreboardingProcess`. */
  employee?: Maybe<Employee>;
  /** Reads a single `EngagementType` that is related to this `PreboardingProcess`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `Preboarding` that is related to this `PreboardingProcess`. */
  preboarding?: Maybe<Preboarding>;
  /** The `PreboardingProcess` that was created by this mutation. */
  preboardingProcess?: Maybe<PreboardingProcess>;
  /** An edge for our `PreboardingProcess`. May be used by Relay 1. */
  preboardingProcessEdge?: Maybe<PreboardingProcessesEdge>;
  /** Reads a single `Process` that is related to this `PreboardingProcess`. */
  process?: Maybe<Process>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PreboardingProcess`. */
  user?: Maybe<User>;
};


/** The output of our create `PreboardingProcess` mutation. */
export type CreatePreboardingProcessPayloadPreboardingProcessEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingProcessesOrderBy>>;
};

/** All input for the create `PreboardingResult` mutation. */
export type CreatePreboardingResultInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PreboardingResult` to be created by this mutation. */
  preboardingResult: PreboardingResultInput;
};

/** The output of our create `PreboardingResult` mutation. */
export type CreatePreboardingResultPayload = {
  __typename?: 'CreatePreboardingResultPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingResult`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `PreboardingResult`. */
  employee?: Maybe<Employee>;
  /** Reads a single `EngagementType` that is related to this `PreboardingResult`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `PreboardingEmployee` that is related to this `PreboardingResult`. */
  preboardingEmployee?: Maybe<PreboardingEmployee>;
  /** The `PreboardingResult` that was created by this mutation. */
  preboardingResult?: Maybe<PreboardingResult>;
  /** An edge for our `PreboardingResult`. May be used by Relay 1. */
  preboardingResultEdge?: Maybe<PreboardingResultsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PreboardingResult`. */
  user?: Maybe<User>;
};


/** The output of our create `PreboardingResult` mutation. */
export type CreatePreboardingResultPayloadPreboardingResultEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingResultsOrderBy>>;
};

/** All input for the create `PreboardingResultSlideComment` mutation. */
export type CreatePreboardingResultSlideCommentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PreboardingResultSlideComment` to be created by this mutation. */
  preboardingResultSlideComment: PreboardingResultSlideCommentInput;
};

/** The output of our create `PreboardingResultSlideComment` mutation. */
export type CreatePreboardingResultSlideCommentPayload = {
  __typename?: 'CreatePreboardingResultSlideCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingResultSlideComment`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `PreboardingResultSlideComment`. */
  employee?: Maybe<Employee>;
  /** Reads a single `EngagementType` that is related to this `PreboardingResultSlideComment`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `PreboardingResult` that is related to this `PreboardingResultSlideComment`. */
  preboardingResult?: Maybe<PreboardingResult>;
  /** The `PreboardingResultSlideComment` that was created by this mutation. */
  preboardingResultSlideComment?: Maybe<PreboardingResultSlideComment>;
  /** An edge for our `PreboardingResultSlideComment`. May be used by Relay 1. */
  preboardingResultSlideCommentEdge?: Maybe<PreboardingResultSlideCommentsEdge>;
  /** Reads a single `PreboardingSlide` that is related to this `PreboardingResultSlideComment`. */
  preboardingSlide?: Maybe<PreboardingSlide>;
  /** Reads a single `User` that is related to this `PreboardingResultSlideComment`. */
  preboardingUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PreboardingResultSlideComment`. */
  user?: Maybe<User>;
};


/** The output of our create `PreboardingResultSlideComment` mutation. */
export type CreatePreboardingResultSlideCommentPayloadPreboardingResultSlideCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingResultSlideCommentsOrderBy>>;
};

/** All input for the create `PreboardingSlideFormField` mutation. */
export type CreatePreboardingSlideFormFieldInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PreboardingSlideFormField` to be created by this mutation. */
  preboardingSlideFormField: PreboardingSlideFormFieldInput;
};

/** The output of our create `PreboardingSlideFormField` mutation. */
export type CreatePreboardingSlideFormFieldPayload = {
  __typename?: 'CreatePreboardingSlideFormFieldPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingSlideFormField`. */
  company?: Maybe<Company>;
  /** Reads a single `EngagementType` that is related to this `PreboardingSlideFormField`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `FormField` that is related to this `PreboardingSlideFormField`. */
  formField?: Maybe<FormField>;
  /** Reads a single `PreboardingSlide` that is related to this `PreboardingSlideFormField`. */
  preboardingSlide?: Maybe<PreboardingSlide>;
  /** The `PreboardingSlideFormField` that was created by this mutation. */
  preboardingSlideFormField?: Maybe<PreboardingSlideFormField>;
  /** Reads a single `PreboardingSlideFormField` that is related to this `PreboardingSlideFormField`. */
  preboardingSlideFormFieldByPreboardingSlideFormFieldIdParent?: Maybe<PreboardingSlideFormField>;
  /** An edge for our `PreboardingSlideFormField`. May be used by Relay 1. */
  preboardingSlideFormFieldEdge?: Maybe<PreboardingSlideFormFieldsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PreboardingSlideFormField` mutation. */
export type CreatePreboardingSlideFormFieldPayloadPreboardingSlideFormFieldEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingSlideFormFieldsOrderBy>>;
};

/** All input for the create `PreboardingSlide` mutation. */
export type CreatePreboardingSlideInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PreboardingSlide` to be created by this mutation. */
  preboardingSlide: PreboardingSlideInput;
};

/** The output of our create `PreboardingSlide` mutation. */
export type CreatePreboardingSlidePayload = {
  __typename?: 'CreatePreboardingSlidePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingSlide`. */
  company?: Maybe<Company>;
  /** Reads a single `EngagementType` that is related to this `PreboardingSlide`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `Preboarding` that is related to this `PreboardingSlide`. */
  preboarding?: Maybe<Preboarding>;
  /** The `PreboardingSlide` that was created by this mutation. */
  preboardingSlide?: Maybe<PreboardingSlide>;
  /** An edge for our `PreboardingSlide`. May be used by Relay 1. */
  preboardingSlideEdge?: Maybe<PreboardingSlidesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PreboardingSlide` mutation. */
export type CreatePreboardingSlidePayloadPreboardingSlideEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingSlidesOrderBy>>;
};

/** All input for the create `ProcessDepartment` mutation. */
export type CreateProcessDepartmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProcessDepartment` to be created by this mutation. */
  processDepartment: ProcessDepartmentInput;
};

/** The output of our create `ProcessDepartment` mutation. */
export type CreateProcessDepartmentPayload = {
  __typename?: 'CreateProcessDepartmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ProcessDepartment`. */
  company?: Maybe<Company>;
  /** Reads a single `Process` that is related to this `ProcessDepartment`. */
  process?: Maybe<Process>;
  /** The `ProcessDepartment` that was created by this mutation. */
  processDepartment?: Maybe<ProcessDepartment>;
  /** An edge for our `ProcessDepartment`. May be used by Relay 1. */
  processDepartmentEdge?: Maybe<ProcessDepartmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ProcessDepartment` mutation. */
export type CreateProcessDepartmentPayloadProcessDepartmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ProcessDepartmentsOrderBy>>;
};

/** All input for the create `ProcessEmployee` mutation. */
export type CreateProcessEmployeeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProcessEmployee` to be created by this mutation. */
  processEmployee: ProcessEmployeeInput;
};

/** The output of our create `ProcessEmployee` mutation. */
export type CreateProcessEmployeePayload = {
  __typename?: 'CreateProcessEmployeePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Employee` that is related to this `ProcessEmployee`. */
  employee?: Maybe<Employee>;
  /** Reads a single `Process` that is related to this `ProcessEmployee`. */
  process?: Maybe<Process>;
  /** The `ProcessEmployee` that was created by this mutation. */
  processEmployee?: Maybe<ProcessEmployee>;
  /** An edge for our `ProcessEmployee`. May be used by Relay 1. */
  processEmployeeEdge?: Maybe<ProcessEmployeesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ProcessEmployee` mutation. */
export type CreateProcessEmployeePayloadProcessEmployeeEdgeArgs = {
  orderBy?: InputMaybe<Array<ProcessEmployeesOrderBy>>;
};

/** All input for the create `Process` mutation. */
export type CreateProcessInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Process` to be created by this mutation. */
  process: ProcessInput;
};

/** The output of our create `Process` mutation. */
export type CreateProcessPayload = {
  __typename?: 'CreateProcessPayload';
  /** Reads a single `User` that is related to this `Process`. */
  assignedUser?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Employee` that is related to this `Process`. */
  employee?: Maybe<Employee>;
  /** The `Process` that was created by this mutation. */
  process?: Maybe<Process>;
  /** An edge for our `Process`. May be used by Relay 1. */
  processEdge?: Maybe<ProcessesEdge>;
  /** Reads a single `ProcessType` that is related to this `Process`. */
  processType?: Maybe<ProcessType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Process` mutation. */
export type CreateProcessPayloadProcessEdgeArgs = {
  orderBy?: InputMaybe<Array<ProcessesOrderBy>>;
};

/** All input for the create `ProcessResponsible` mutation. */
export type CreateProcessResponsibleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProcessResponsible` to be created by this mutation. */
  processResponsible: ProcessResponsibleInput;
};

/** The output of our create `ProcessResponsible` mutation. */
export type CreateProcessResponsiblePayload = {
  __typename?: 'CreateProcessResponsiblePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ProcessResponsible`. */
  company?: Maybe<Company>;
  /** Reads a single `Process` that is related to this `ProcessResponsible`. */
  process?: Maybe<Process>;
  /** The `ProcessResponsible` that was created by this mutation. */
  processResponsible?: Maybe<ProcessResponsible>;
  /** An edge for our `ProcessResponsible`. May be used by Relay 1. */
  processResponsibleEdge?: Maybe<ProcessResponsiblesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Employee` that is related to this `ProcessResponsible`. */
  responsible?: Maybe<Employee>;
  /** Reads a single `User` that is related to this `ProcessResponsible`. */
  responsibleUser?: Maybe<User>;
};


/** The output of our create `ProcessResponsible` mutation. */
export type CreateProcessResponsiblePayloadProcessResponsibleEdgeArgs = {
  orderBy?: InputMaybe<Array<ProcessResponsiblesOrderBy>>;
};

/** All input for the create `ProcessType` mutation. */
export type CreateProcessTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProcessType` to be created by this mutation. */
  processType: ProcessTypeInput;
};

/** The output of our create `ProcessType` mutation. */
export type CreateProcessTypePayload = {
  __typename?: 'CreateProcessTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ProcessType`. */
  company?: Maybe<Company>;
  /** The `ProcessType` that was created by this mutation. */
  processType?: Maybe<ProcessType>;
  /** An edge for our `ProcessType`. May be used by Relay 1. */
  processTypeEdge?: Maybe<ProcessTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ProcessType` mutation. */
export type CreateProcessTypePayloadProcessTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<ProcessTypesOrderBy>>;
};

/** All input for the create `Product` mutation. */
export type CreateProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Product` to be created by this mutation. */
  product: ProductInput;
};

/** The output of our create `Product` mutation. */
export type CreateProductPayload = {
  __typename?: 'CreateProductPayload';
  /** Reads a single `User` that is related to this `Product`. */
  assignedUser?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Department` that is related to this `Product`. */
  department?: Maybe<Department>;
  /** The `Product` that was created by this mutation. */
  product?: Maybe<Product>;
  /** An edge for our `Product`. May be used by Relay 1. */
  productEdge?: Maybe<ProductsEdge>;
  /** Reads a single `ProductType` that is related to this `Product`. */
  productType?: Maybe<ProductType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Product`. */
  user?: Maybe<User>;
};


/** The output of our create `Product` mutation. */
export type CreateProductPayloadProductEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** All input for the create `ProductType` mutation. */
export type CreateProductTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductType` to be created by this mutation. */
  productType: ProductTypeInput;
};

/** The output of our create `ProductType` mutation. */
export type CreateProductTypePayload = {
  __typename?: 'CreateProductTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProductType` that was created by this mutation. */
  productType?: Maybe<ProductType>;
  /** An edge for our `ProductType`. May be used by Relay 1. */
  productTypeEdge?: Maybe<ProductTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ProductType` mutation. */
export type CreateProductTypePayloadProductTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductTypesOrderBy>>;
};

/** All input for the create `Project` mutation. */
export type CreateProjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Project` to be created by this mutation. */
  project: ProjectInput;
};

/** The output of our create `Project` mutation. */
export type CreateProjectPayload = {
  __typename?: 'CreateProjectPayload';
  /** Reads a single `User` that is related to this `Project`. */
  assignedProcessUser?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Project`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `Project`. */
  employee?: Maybe<Employee>;
  /** Reads a single `Process` that is related to this `Project`. */
  process?: Maybe<Process>;
  /** Reads a single `ProcessType` that is related to this `Project`. */
  processType?: Maybe<ProcessType>;
  /** The `Project` that was created by this mutation. */
  project?: Maybe<Project>;
  /** An edge for our `Project`. May be used by Relay 1. */
  projectEdge?: Maybe<ProjectsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Project` mutation. */
export type CreateProjectPayloadProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** All input for the create `ProjectTemplate` mutation. */
export type CreateProjectTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProjectTemplate` to be created by this mutation. */
  projectTemplate: ProjectTemplateInput;
};

/** The output of our create `ProjectTemplate` mutation. */
export type CreateProjectTemplatePayload = {
  __typename?: 'CreateProjectTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ProjectTemplate`. */
  company?: Maybe<Company>;
  /** Reads a single `Process` that is related to this `ProjectTemplate`. */
  process?: Maybe<Process>;
  /** Reads a single `ProcessType` that is related to this `ProjectTemplate`. */
  processType?: Maybe<ProcessType>;
  /** The `ProjectTemplate` that was created by this mutation. */
  projectTemplate?: Maybe<ProjectTemplate>;
  /** An edge for our `ProjectTemplate`. May be used by Relay 1. */
  projectTemplateEdge?: Maybe<ProjectTemplatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ProjectTemplate` mutation. */
export type CreateProjectTemplatePayloadProjectTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTemplatesOrderBy>>;
};

export type CreatePulseSurveyChoiceInput = {
  emoji?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  text: Scalars['String'];
};

export type CreatePulseSurveyInput = {
  anonymous?: InputMaybe<Scalars['Boolean']>;
  choiceIndicator?: InputMaybe<PulseSurveyChoiceIndicator>;
  endDate?: InputMaybe<Scalars['Date']>;
  highestRating?: InputMaybe<Scalars['Int']>;
  highestRatingLabel?: InputMaybe<Scalars['String']>;
  highestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  horizontal?: InputMaybe<Scalars['Boolean']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<Scalars['UUID']>>;
  invitedUserIds?: InputMaybe<Array<Scalars['UUID']>>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  lowestRating?: InputMaybe<Scalars['Int']>;
  lowestRatingLabel?: InputMaybe<Scalars['String']>;
  lowestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  pulseSurveyChoices?: InputMaybe<Array<CreatePulseSurveyChoiceInput>>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  question: Scalars['String'];
  questionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  questionType: PulseSurveyQuestionType;
  ratingType?: InputMaybe<RatingType>;
  recurrenceRule: RecurrenceRuleInput;
  reminders?: InputMaybe<Array<IntervalInput>>;
  startDate: Scalars['Date'];
  surveyTime: Scalars['Time'];
  timezoneName: Scalars['String'];
};

/** All input for the create `PulseType` mutation. */
export type CreatePulseTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PulseType` to be created by this mutation. */
  pulseType: PulseTypeInput;
};

/** The output of our create `PulseType` mutation. */
export type CreatePulseTypePayload = {
  __typename?: 'CreatePulseTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PulseType`. */
  company?: Maybe<Company>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseType`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** The `PulseType` that was created by this mutation. */
  pulseType?: Maybe<PulseType>;
  /** An edge for our `PulseType`. May be used by Relay 1. */
  pulseTypeEdge?: Maybe<PulseTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PulseType` mutation. */
export type CreatePulseTypePayloadPulseTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<PulseTypesOrderBy>>;
};

/** All input for the create `RecurrenceRule` mutation. */
export type CreateRecurrenceRuleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RecurrenceRule` to be created by this mutation. */
  recurrenceRule: RecurrenceRuleInput;
};

/** The output of our create `RecurrenceRule` mutation. */
export type CreateRecurrenceRulePayload = {
  __typename?: 'CreateRecurrenceRulePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `RecurrenceRule`. */
  company?: Maybe<Company>;
  /** Reads a single `PulseSurvey` that is related to this `RecurrenceRule`. */
  pulseSurvey?: Maybe<PulseSurvey>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RecurrenceRule` that was created by this mutation. */
  recurrenceRule?: Maybe<RecurrenceRule>;
  /** An edge for our `RecurrenceRule`. May be used by Relay 1. */
  recurrenceRuleEdge?: Maybe<RecurrenceRulesEdge>;
};


/** The output of our create `RecurrenceRule` mutation. */
export type CreateRecurrenceRulePayloadRecurrenceRuleEdgeArgs = {
  orderBy?: InputMaybe<Array<RecurrenceRulesOrderBy>>;
};

/** All input for the create `RoadmapItemComment` mutation. */
export type CreateRoadmapItemCommentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoadmapItemComment` to be created by this mutation. */
  roadmapItemComment: RoadmapItemCommentInput;
};

/** The output of our create `RoadmapItemComment` mutation. */
export type CreateRoadmapItemCommentPayload = {
  __typename?: 'CreateRoadmapItemCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `RoadmapItemComment`. */
  oldUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoadmapItem` that is related to this `RoadmapItemComment`. */
  roadmapItem?: Maybe<RoadmapItem>;
  /** The `RoadmapItemComment` that was created by this mutation. */
  roadmapItemComment?: Maybe<RoadmapItemComment>;
  /** An edge for our `RoadmapItemComment`. May be used by Relay 1. */
  roadmapItemCommentEdge?: Maybe<RoadmapItemCommentsEdge>;
};


/** The output of our create `RoadmapItemComment` mutation. */
export type CreateRoadmapItemCommentPayloadRoadmapItemCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<RoadmapItemCommentsOrderBy>>;
};

/** All input for the create `RoadmapItem` mutation. */
export type CreateRoadmapItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoadmapItem` to be created by this mutation. */
  roadmapItem: RoadmapItemInput;
};

/** All input for the create `RoadmapItemLocalization` mutation. */
export type CreateRoadmapItemLocalizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoadmapItemLocalization` to be created by this mutation. */
  roadmapItemLocalization: RoadmapItemLocalizationInput;
};

/** The output of our create `RoadmapItemLocalization` mutation. */
export type CreateRoadmapItemLocalizationPayload = {
  __typename?: 'CreateRoadmapItemLocalizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoadmapItem` that is related to this `RoadmapItemLocalization`. */
  roadmapItem?: Maybe<RoadmapItem>;
  /** The `RoadmapItemLocalization` that was created by this mutation. */
  roadmapItemLocalization?: Maybe<RoadmapItemLocalization>;
  /** An edge for our `RoadmapItemLocalization`. May be used by Relay 1. */
  roadmapItemLocalizationEdge?: Maybe<RoadmapItemLocalizationsEdge>;
};


/** The output of our create `RoadmapItemLocalization` mutation. */
export type CreateRoadmapItemLocalizationPayloadRoadmapItemLocalizationEdgeArgs = {
  orderBy?: InputMaybe<Array<RoadmapItemLocalizationsOrderBy>>;
};

/** The output of our create `RoadmapItem` mutation. */
export type CreateRoadmapItemPayload = {
  __typename?: 'CreateRoadmapItemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RoadmapItem` that was created by this mutation. */
  roadmapItem?: Maybe<RoadmapItem>;
  /** An edge for our `RoadmapItem`. May be used by Relay 1. */
  roadmapItemEdge?: Maybe<RoadmapItemsEdge>;
};


/** The output of our create `RoadmapItem` mutation. */
export type CreateRoadmapItemPayloadRoadmapItemEdgeArgs = {
  orderBy?: InputMaybe<Array<RoadmapItemsOrderBy>>;
};

/** All input for the create `RoadmapItemVote` mutation. */
export type CreateRoadmapItemVoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RoadmapItemVote` to be created by this mutation. */
  roadmapItemVote: RoadmapItemVoteInput;
};

/** The output of our create `RoadmapItemVote` mutation. */
export type CreateRoadmapItemVotePayload = {
  __typename?: 'CreateRoadmapItemVotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoadmapItem` that is related to this `RoadmapItemVote`. */
  roadmapItem?: Maybe<RoadmapItem>;
  /** The `RoadmapItemVote` that was created by this mutation. */
  roadmapItemVote?: Maybe<RoadmapItemVote>;
  /** An edge for our `RoadmapItemVote`. May be used by Relay 1. */
  roadmapItemVoteEdge?: Maybe<RoadmapItemVotesEdge>;
  /** Reads a single `User` that is related to this `RoadmapItemVote`. */
  user?: Maybe<User>;
};


/** The output of our create `RoadmapItemVote` mutation. */
export type CreateRoadmapItemVotePayloadRoadmapItemVoteEdgeArgs = {
  orderBy?: InputMaybe<Array<RoadmapItemVotesOrderBy>>;
};

/** All input for the create `Role` mutation. */
export type CreateRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Role` to be created by this mutation. */
  role: RoleInput;
};

/** The output of our create `Role` mutation. */
export type CreateRolePayload = {
  __typename?: 'CreateRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Role` that was created by this mutation. */
  role?: Maybe<Role>;
  /** An edge for our `Role`. May be used by Relay 1. */
  roleEdge?: Maybe<RolesEdge>;
};


/** The output of our create `Role` mutation. */
export type CreateRolePayloadRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<RolesOrderBy>>;
};

/** All input for the create `SavedSignature` mutation. */
export type CreateSavedSignatureInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SavedSignature` to be created by this mutation. */
  savedSignature: SavedSignatureInput;
};

/** The output of our create `SavedSignature` mutation. */
export type CreateSavedSignaturePayload = {
  __typename?: 'CreateSavedSignaturePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Employee` that is related to this `SavedSignature`. */
  employee?: Maybe<Employee>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SavedSignature` that was created by this mutation. */
  savedSignature?: Maybe<SavedSignature>;
  /** An edge for our `SavedSignature`. May be used by Relay 1. */
  savedSignatureEdge?: Maybe<SavedSignaturesEdge>;
  /** Reads a single `Storage` that is related to this `SavedSignature`. */
  storage?: Maybe<Storage>;
};


/** The output of our create `SavedSignature` mutation. */
export type CreateSavedSignaturePayloadSavedSignatureEdgeArgs = {
  orderBy?: InputMaybe<Array<SavedSignaturesOrderBy>>;
};

/** All input for the create `ScheduledMessageExternalRecipient` mutation. */
export type CreateScheduledMessageExternalRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ScheduledMessageExternalRecipient` to be created by this mutation. */
  scheduledMessageExternalRecipient: ScheduledMessageExternalRecipientInput;
};

/** The output of our create `ScheduledMessageExternalRecipient` mutation. */
export type CreateScheduledMessageExternalRecipientPayload = {
  __typename?: 'CreateScheduledMessageExternalRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ScheduledMessageExternalRecipient`. */
  company?: Maybe<Company>;
  /** Reads a single `ProcessType` that is related to this `ScheduledMessageExternalRecipient`. */
  processType?: Maybe<ProcessType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ScheduledMessage` that is related to this `ScheduledMessageExternalRecipient`. */
  scheduledMessage?: Maybe<ScheduledMessage>;
  /** The `ScheduledMessageExternalRecipient` that was created by this mutation. */
  scheduledMessageExternalRecipient?: Maybe<ScheduledMessageExternalRecipient>;
  /** An edge for our `ScheduledMessageExternalRecipient`. May be used by Relay 1. */
  scheduledMessageExternalRecipientEdge?: Maybe<ScheduledMessageExternalRecipientsEdge>;
};


/** The output of our create `ScheduledMessageExternalRecipient` mutation. */
export type CreateScheduledMessageExternalRecipientPayloadScheduledMessageExternalRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledMessageExternalRecipientsOrderBy>>;
};

/** All input for the create `ScheduledMessage` mutation. */
export type CreateScheduledMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ScheduledMessage` to be created by this mutation. */
  scheduledMessage: ScheduledMessageInput;
};

/** The output of our create `ScheduledMessage` mutation. */
export type CreateScheduledMessagePayload = {
  __typename?: 'CreateScheduledMessagePayload';
  /** Reads a single `User` that is related to this `ScheduledMessage`. */
  assignedProcessUser?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ScheduledMessage`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `ScheduledMessage`. */
  employee?: Maybe<Employee>;
  /** Reads a single `Process` that is related to this `ScheduledMessage`. */
  process?: Maybe<Process>;
  /** Reads a single `ProcessType` that is related to this `ScheduledMessage`. */
  processType?: Maybe<ProcessType>;
  /** Reads a single `Project` that is related to this `ScheduledMessage`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ScheduledMessage` that was created by this mutation. */
  scheduledMessage?: Maybe<ScheduledMessage>;
  /** An edge for our `ScheduledMessage`. May be used by Relay 1. */
  scheduledMessageEdge?: Maybe<ScheduledMessagesEdge>;
  /** Reads a single `Employee` that is related to this `ScheduledMessage`. */
  senderEmployee?: Maybe<Employee>;
};


/** The output of our create `ScheduledMessage` mutation. */
export type CreateScheduledMessagePayloadScheduledMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledMessagesOrderBy>>;
};

/** All input for the create `ScheduledMessageRecipient` mutation. */
export type CreateScheduledMessageRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ScheduledMessageRecipient` to be created by this mutation. */
  scheduledMessageRecipient: ScheduledMessageRecipientInput;
};

/** The output of our create `ScheduledMessageRecipient` mutation. */
export type CreateScheduledMessageRecipientPayload = {
  __typename?: 'CreateScheduledMessageRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ScheduledMessageRecipient`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `ScheduledMessageRecipient`. */
  employee?: Maybe<Employee>;
  /** Reads a single `ProcessType` that is related to this `ScheduledMessageRecipient`. */
  processType?: Maybe<ProcessType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ScheduledMessage` that is related to this `ScheduledMessageRecipient`. */
  scheduledMessage?: Maybe<ScheduledMessage>;
  /** The `ScheduledMessageRecipient` that was created by this mutation. */
  scheduledMessageRecipient?: Maybe<ScheduledMessageRecipient>;
  /** An edge for our `ScheduledMessageRecipient`. May be used by Relay 1. */
  scheduledMessageRecipientEdge?: Maybe<ScheduledMessageRecipientsEdge>;
};


/** The output of our create `ScheduledMessageRecipient` mutation. */
export type CreateScheduledMessageRecipientPayloadScheduledMessageRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledMessageRecipientsOrderBy>>;
};

/** All input for the create `ScheduledMessageTemplateExternalRecipient` mutation. */
export type CreateScheduledMessageTemplateExternalRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ScheduledMessageTemplateExternalRecipient` to be created by this mutation. */
  scheduledMessageTemplateExternalRecipient: ScheduledMessageTemplateExternalRecipientInput;
};

/** The output of our create `ScheduledMessageTemplateExternalRecipient` mutation. */
export type CreateScheduledMessageTemplateExternalRecipientPayload = {
  __typename?: 'CreateScheduledMessageTemplateExternalRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ScheduledMessageTemplateExternalRecipient`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ScheduledMessageTemplate` that is related to this `ScheduledMessageTemplateExternalRecipient`. */
  scheduledMessageTemplate?: Maybe<ScheduledMessageTemplate>;
  /** The `ScheduledMessageTemplateExternalRecipient` that was created by this mutation. */
  scheduledMessageTemplateExternalRecipient?: Maybe<ScheduledMessageTemplateExternalRecipient>;
  /** An edge for our `ScheduledMessageTemplateExternalRecipient`. May be used by Relay 1. */
  scheduledMessageTemplateExternalRecipientEdge?: Maybe<ScheduledMessageTemplateExternalRecipientsEdge>;
};


/** The output of our create `ScheduledMessageTemplateExternalRecipient` mutation. */
export type CreateScheduledMessageTemplateExternalRecipientPayloadScheduledMessageTemplateExternalRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledMessageTemplateExternalRecipientsOrderBy>>;
};

/** All input for the create `ScheduledMessageTemplate` mutation. */
export type CreateScheduledMessageTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ScheduledMessageTemplate` to be created by this mutation. */
  scheduledMessageTemplate: ScheduledMessageTemplateInput;
};

/** The output of our create `ScheduledMessageTemplate` mutation. */
export type CreateScheduledMessageTemplatePayload = {
  __typename?: 'CreateScheduledMessageTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ScheduledMessageTemplate`. */
  company?: Maybe<Company>;
  /** Reads a single `Process` that is related to this `ScheduledMessageTemplate`. */
  process?: Maybe<Process>;
  /** Reads a single `ProcessType` that is related to this `ScheduledMessageTemplate`. */
  processType?: Maybe<ProcessType>;
  /** Reads a single `ProjectTemplate` that is related to this `ScheduledMessageTemplate`. */
  project?: Maybe<ProjectTemplate>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ScheduledMessageTemplate` that was created by this mutation. */
  scheduledMessageTemplate?: Maybe<ScheduledMessageTemplate>;
  /** An edge for our `ScheduledMessageTemplate`. May be used by Relay 1. */
  scheduledMessageTemplateEdge?: Maybe<ScheduledMessageTemplatesEdge>;
};


/** The output of our create `ScheduledMessageTemplate` mutation. */
export type CreateScheduledMessageTemplatePayloadScheduledMessageTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledMessageTemplatesOrderBy>>;
};

/** All input for the create `ScheduledMessageTemplateRecipient` mutation. */
export type CreateScheduledMessageTemplateRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ScheduledMessageTemplateRecipient` to be created by this mutation. */
  scheduledMessageTemplateRecipient: ScheduledMessageTemplateRecipientInput;
};

/** The output of our create `ScheduledMessageTemplateRecipient` mutation. */
export type CreateScheduledMessageTemplateRecipientPayload = {
  __typename?: 'CreateScheduledMessageTemplateRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ScheduledMessageTemplateRecipient`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `ScheduledMessageTemplateRecipient`. */
  employee?: Maybe<Employee>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ScheduledMessageTemplate` that is related to this `ScheduledMessageTemplateRecipient`. */
  scheduledMessageTemplate?: Maybe<ScheduledMessageTemplate>;
  /** The `ScheduledMessageTemplateRecipient` that was created by this mutation. */
  scheduledMessageTemplateRecipient?: Maybe<ScheduledMessageTemplateRecipient>;
  /** An edge for our `ScheduledMessageTemplateRecipient`. May be used by Relay 1. */
  scheduledMessageTemplateRecipientEdge?: Maybe<ScheduledMessageTemplateRecipientsEdge>;
};


/** The output of our create `ScheduledMessageTemplateRecipient` mutation. */
export type CreateScheduledMessageTemplateRecipientPayloadScheduledMessageTemplateRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledMessageTemplateRecipientsOrderBy>>;
};

/** All input for the create `Storage` mutation. */
export type CreateStorageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Storage` to be created by this mutation. */
  storage: StorageInput;
};

/** The output of our create `Storage` mutation. */
export type CreateStoragePayload = {
  __typename?: 'CreateStoragePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ContractSignPendingDocument` that is related to this `Storage`. */
  contractSignPendingDocument?: Maybe<ContractSignPendingDocument>;
  /** Reads a single `DocumentFolder` that is related to this `Storage`. */
  documentFolder?: Maybe<DocumentFolder>;
  /** Reads a single `ContractTemplate` that is related to this `Storage`. */
  documentTemplate?: Maybe<ContractTemplate>;
  /** Reads a single `DocumentType` that is related to this `Storage`. */
  documentType?: Maybe<DocumentType>;
  /** Reads a single `EmployeeCasefile` that is related to this `Storage`. */
  employeeCasefile?: Maybe<EmployeeCasefile>;
  /** Reads a single `ProcessType` that is related to this `Storage`. */
  processType?: Maybe<ProcessType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentFolderBlueprint` that is related to this `Storage`. */
  rootDocumentFolderBlueprint?: Maybe<DocumentFolderBlueprint>;
  /** The `Storage` that was created by this mutation. */
  storage?: Maybe<Storage>;
  /** An edge for our `Storage`. May be used by Relay 1. */
  storageEdge?: Maybe<StoragesEdge>;
};


/** The output of our create `Storage` mutation. */
export type CreateStoragePayloadStorageEdgeArgs = {
  orderBy?: InputMaybe<Array<StoragesOrderBy>>;
};

/** All input for the create `SuperUserAllowedUser` mutation. */
export type CreateSuperUserAllowedUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SuperUserAllowedUser` to be created by this mutation. */
  superUserAllowedUser: SuperUserAllowedUserInput;
};

/** The output of our create `SuperUserAllowedUser` mutation. */
export type CreateSuperUserAllowedUserPayload = {
  __typename?: 'CreateSuperUserAllowedUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `SuperUserAllowedUser`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SuperUser` that is related to this `SuperUserAllowedUser`. */
  superUser?: Maybe<SuperUser>;
  /** The `SuperUserAllowedUser` that was created by this mutation. */
  superUserAllowedUser?: Maybe<SuperUserAllowedUser>;
  /** An edge for our `SuperUserAllowedUser`. May be used by Relay 1. */
  superUserAllowedUserEdge?: Maybe<SuperUserAllowedUsersEdge>;
};


/** The output of our create `SuperUserAllowedUser` mutation. */
export type CreateSuperUserAllowedUserPayloadSuperUserAllowedUserEdgeArgs = {
  orderBy?: InputMaybe<Array<SuperUserAllowedUsersOrderBy>>;
};

/** All input for the create `SuperUser` mutation. */
export type CreateSuperUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SuperUser` to be created by this mutation. */
  superUser: SuperUserInput;
};

/** The output of our create `SuperUser` mutation. */
export type CreateSuperUserPayload = {
  __typename?: 'CreateSuperUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SuperUser` that was created by this mutation. */
  superUser?: Maybe<SuperUser>;
  /** An edge for our `SuperUser`. May be used by Relay 1. */
  superUserEdge?: Maybe<SuperUsersEdge>;
  /** Reads a single `User` that is related to this `SuperUser`. */
  user?: Maybe<User>;
};


/** The output of our create `SuperUser` mutation. */
export type CreateSuperUserPayloadSuperUserEdgeArgs = {
  orderBy?: InputMaybe<Array<SuperUsersOrderBy>>;
};

/** All input for the create `SystemFieldType` mutation. */
export type CreateSystemFieldTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SystemFieldType` to be created by this mutation. */
  systemFieldType: SystemFieldTypeInput;
};

/** The output of our create `SystemFieldType` mutation. */
export type CreateSystemFieldTypePayload = {
  __typename?: 'CreateSystemFieldTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SystemFieldType` that was created by this mutation. */
  systemFieldType?: Maybe<SystemFieldType>;
  /** An edge for our `SystemFieldType`. May be used by Relay 1. */
  systemFieldTypeEdge?: Maybe<SystemFieldTypesEdge>;
};


/** The output of our create `SystemFieldType` mutation. */
export type CreateSystemFieldTypePayloadSystemFieldTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<SystemFieldTypesOrderBy>>;
};

/** All input for the create `TaskEmployee` mutation. */
export type CreateTaskEmployeeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TaskEmployee` to be created by this mutation. */
  taskEmployee: TaskEmployeeInput;
};

/** The output of our create `TaskEmployee` mutation. */
export type CreateTaskEmployeePayload = {
  __typename?: 'CreateTaskEmployeePayload';
  /** Reads a single `User` that is related to this `TaskEmployee`. */
  assignedProcessUser?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TaskEmployee`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `TaskEmployee`. */
  employee?: Maybe<Employee>;
  /** Reads a single `ProcessType` that is related to this `TaskEmployee`. */
  processType?: Maybe<ProcessType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Task` that is related to this `TaskEmployee`. */
  task?: Maybe<Task>;
  /** The `TaskEmployee` that was created by this mutation. */
  taskEmployee?: Maybe<TaskEmployee>;
  /** An edge for our `TaskEmployee`. May be used by Relay 1. */
  taskEmployeeEdge?: Maybe<TaskEmployeesEdge>;
  /** Reads a single `User` that is related to this `TaskEmployee`. */
  user?: Maybe<User>;
};


/** The output of our create `TaskEmployee` mutation. */
export type CreateTaskEmployeePayloadTaskEmployeeEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskEmployeesOrderBy>>;
};

/** All input for the create `Task` mutation. */
export type CreateTaskInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Task` to be created by this mutation. */
  task: TaskInput;
};

/** The output of our create `Task` mutation. */
export type CreateTaskPayload = {
  __typename?: 'CreateTaskPayload';
  /** Reads a single `User` that is related to this `Task`. */
  assignedProcessUser?: Maybe<User>;
  /** Reads a single `User` that is related to this `Task`. */
  calendarEventOrganizer?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Task`. */
  company?: Maybe<Company>;
  /** Reads a single `Task` that is related to this `Task`. */
  parentTask?: Maybe<Task>;
  /** Reads a single `Process` that is related to this `Task`. */
  process?: Maybe<Process>;
  /** Reads a single `ProcessType` that is related to this `Task`. */
  processType?: Maybe<ProcessType>;
  /** Reads a single `Project` that is related to this `Task`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Task` that was created by this mutation. */
  task?: Maybe<Task>;
  /** An edge for our `Task`. May be used by Relay 1. */
  taskEdge?: Maybe<TasksEdge>;
  /** Reads a single `User` that is related to this `Task`. */
  userByCompletedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `Task`. */
  userByCreatedBy?: Maybe<User>;
};


/** The output of our create `Task` mutation. */
export type CreateTaskPayloadTaskEdgeArgs = {
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};

/** All input for the create `TaskResponsible` mutation. */
export type CreateTaskResponsibleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TaskResponsible` to be created by this mutation. */
  taskResponsible: TaskResponsibleInput;
};

/** The output of our create `TaskResponsible` mutation. */
export type CreateTaskResponsiblePayload = {
  __typename?: 'CreateTaskResponsiblePayload';
  /** Reads a single `User` that is related to this `TaskResponsible`. */
  assignedProcessUser?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TaskResponsible`. */
  company?: Maybe<Company>;
  /** Reads a single `ProcessType` that is related to this `TaskResponsible`. */
  processType?: Maybe<ProcessType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Employee` that is related to this `TaskResponsible`. */
  responsible?: Maybe<Employee>;
  /** Reads a single `Task` that is related to this `TaskResponsible`. */
  task?: Maybe<Task>;
  /** The `TaskResponsible` that was created by this mutation. */
  taskResponsible?: Maybe<TaskResponsible>;
  /** An edge for our `TaskResponsible`. May be used by Relay 1. */
  taskResponsibleEdge?: Maybe<TaskResponsiblesEdge>;
  /** Reads a single `User` that is related to this `TaskResponsible`. */
  user?: Maybe<User>;
};


/** The output of our create `TaskResponsible` mutation. */
export type CreateTaskResponsiblePayloadTaskResponsibleEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskResponsiblesOrderBy>>;
};

/** All input for the create `TaskTemplateEmployee` mutation. */
export type CreateTaskTemplateEmployeeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TaskTemplateEmployee` to be created by this mutation. */
  taskTemplateEmployee: TaskTemplateEmployeeInput;
};

/** The output of our create `TaskTemplateEmployee` mutation. */
export type CreateTaskTemplateEmployeePayload = {
  __typename?: 'CreateTaskTemplateEmployeePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TaskTemplateEmployee`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `TaskTemplateEmployee`. */
  employee?: Maybe<Employee>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TaskTemplate` that is related to this `TaskTemplateEmployee`. */
  taskTemplate?: Maybe<TaskTemplate>;
  /** The `TaskTemplateEmployee` that was created by this mutation. */
  taskTemplateEmployee?: Maybe<TaskTemplateEmployee>;
  /** An edge for our `TaskTemplateEmployee`. May be used by Relay 1. */
  taskTemplateEmployeeEdge?: Maybe<TaskTemplateEmployeesEdge>;
};


/** The output of our create `TaskTemplateEmployee` mutation. */
export type CreateTaskTemplateEmployeePayloadTaskTemplateEmployeeEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskTemplateEmployeesOrderBy>>;
};

/** All input for the create `TaskTemplate` mutation. */
export type CreateTaskTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TaskTemplate` to be created by this mutation. */
  taskTemplate: TaskTemplateInput;
};

/** The output of our create `TaskTemplate` mutation. */
export type CreateTaskTemplatePayload = {
  __typename?: 'CreateTaskTemplatePayload';
  /** Reads a single `User` that is related to this `TaskTemplate`. */
  calendarEventOrganizer?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TaskTemplate`. */
  company?: Maybe<Company>;
  /** Reads a single `TaskTemplate` that is related to this `TaskTemplate`. */
  parentTask?: Maybe<TaskTemplate>;
  /** Reads a single `Process` that is related to this `TaskTemplate`. */
  process?: Maybe<Process>;
  /** Reads a single `ProcessType` that is related to this `TaskTemplate`. */
  processType?: Maybe<ProcessType>;
  /** Reads a single `ProjectTemplate` that is related to this `TaskTemplate`. */
  project?: Maybe<ProjectTemplate>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TaskTemplate` that was created by this mutation. */
  taskTemplate?: Maybe<TaskTemplate>;
  /** An edge for our `TaskTemplate`. May be used by Relay 1. */
  taskTemplateEdge?: Maybe<TaskTemplatesEdge>;
};


/** The output of our create `TaskTemplate` mutation. */
export type CreateTaskTemplatePayloadTaskTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskTemplatesOrderBy>>;
};

/** All input for the create `TaskTemplateResponsible` mutation. */
export type CreateTaskTemplateResponsibleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TaskTemplateResponsible` to be created by this mutation. */
  taskTemplateResponsible: TaskTemplateResponsibleInput;
};

/** The output of our create `TaskTemplateResponsible` mutation. */
export type CreateTaskTemplateResponsiblePayload = {
  __typename?: 'CreateTaskTemplateResponsiblePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TaskTemplateResponsible`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Employee` that is related to this `TaskTemplateResponsible`. */
  responsible?: Maybe<Employee>;
  /** Reads a single `TaskTemplate` that is related to this `TaskTemplateResponsible`. */
  taskTemplate?: Maybe<TaskTemplate>;
  /** The `TaskTemplateResponsible` that was created by this mutation. */
  taskTemplateResponsible?: Maybe<TaskTemplateResponsible>;
  /** An edge for our `TaskTemplateResponsible`. May be used by Relay 1. */
  taskTemplateResponsibleEdge?: Maybe<TaskTemplateResponsiblesEdge>;
};


/** The output of our create `TaskTemplateResponsible` mutation. */
export type CreateTaskTemplateResponsiblePayloadTaskTemplateResponsibleEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskTemplateResponsiblesOrderBy>>;
};

/** All input for the create `TimeRegistrationBreakType` mutation. */
export type CreateTimeRegistrationBreakTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TimeRegistrationBreakType` to be created by this mutation. */
  timeRegistrationBreakType: TimeRegistrationBreakTypeInput;
};

/** The output of our create `TimeRegistrationBreakType` mutation. */
export type CreateTimeRegistrationBreakTypePayload = {
  __typename?: 'CreateTimeRegistrationBreakTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationBreakType`. */
  company?: Maybe<Company>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationBreakType`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TimeRegistrationBreakType` that was created by this mutation. */
  timeRegistrationBreakType?: Maybe<TimeRegistrationBreakType>;
  /** An edge for our `TimeRegistrationBreakType`. May be used by Relay 1. */
  timeRegistrationBreakTypeEdge?: Maybe<TimeRegistrationBreakTypesEdge>;
};


/** The output of our create `TimeRegistrationBreakType` mutation. */
export type CreateTimeRegistrationBreakTypePayloadTimeRegistrationBreakTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationBreakTypesOrderBy>>;
};

/** All input for the create `TimeRegistrationEntry` mutation. */
export type CreateTimeRegistrationEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TimeRegistrationEntry` to be created by this mutation. */
  timeRegistrationEntry: TimeRegistrationEntryInput;
};

/** The output of our create `TimeRegistrationEntry` mutation. */
export type CreateTimeRegistrationEntryPayload = {
  __typename?: 'CreateTimeRegistrationEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationEntry`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TimeRegistrationBreakType` that is related to this `TimeRegistrationEntry`. */
  timeRegistrationBreakType?: Maybe<TimeRegistrationBreakType>;
  /** The `TimeRegistrationEntry` that was created by this mutation. */
  timeRegistrationEntry?: Maybe<TimeRegistrationEntry>;
  /** An edge for our `TimeRegistrationEntry`. May be used by Relay 1. */
  timeRegistrationEntryEdge?: Maybe<TimeRegistrationEntriesEdge>;
  /** Reads a single `TimeRegistrationPresence` that is related to this `TimeRegistrationEntry`. */
  timeRegistrationPresence?: Maybe<TimeRegistrationPresence>;
  /** Reads a single `TimeRegistrationProject` that is related to this `TimeRegistrationEntry`. */
  timeRegistrationProject?: Maybe<TimeRegistrationProject>;
  /** Reads a single `User` that is related to this `TimeRegistrationEntry`. */
  user?: Maybe<User>;
};


/** The output of our create `TimeRegistrationEntry` mutation. */
export type CreateTimeRegistrationEntryPayloadTimeRegistrationEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationEntriesOrderBy>>;
};

/** All input for the create `TimeRegistrationEntryTemplate` mutation. */
export type CreateTimeRegistrationEntryTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TimeRegistrationEntryTemplate` to be created by this mutation. */
  timeRegistrationEntryTemplate: TimeRegistrationEntryTemplateInput;
};

/** The output of our create `TimeRegistrationEntryTemplate` mutation. */
export type CreateTimeRegistrationEntryTemplatePayload = {
  __typename?: 'CreateTimeRegistrationEntryTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationEntryTemplate`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TimeRegistrationBreakType` that is related to this `TimeRegistrationEntryTemplate`. */
  timeRegistrationBreakType?: Maybe<TimeRegistrationBreakType>;
  /** The `TimeRegistrationEntryTemplate` that was created by this mutation. */
  timeRegistrationEntryTemplate?: Maybe<TimeRegistrationEntryTemplate>;
  /** An edge for our `TimeRegistrationEntryTemplate`. May be used by Relay 1. */
  timeRegistrationEntryTemplateEdge?: Maybe<TimeRegistrationEntryTemplatesEdge>;
  /** Reads a single `TimeRegistrationPresenceTemplate` that is related to this `TimeRegistrationEntryTemplate`. */
  timeRegistrationPresenceTemplate?: Maybe<TimeRegistrationPresenceTemplate>;
  /** Reads a single `TimeRegistrationProject` that is related to this `TimeRegistrationEntryTemplate`. */
  timeRegistrationProject?: Maybe<TimeRegistrationProject>;
  /** Reads a single `TimeRegistrationTemplate` that is related to this `TimeRegistrationEntryTemplate`. */
  timeRegistrationTemplate?: Maybe<TimeRegistrationTemplate>;
  /** Reads a single `User` that is related to this `TimeRegistrationEntryTemplate`. */
  user?: Maybe<User>;
};


/** The output of our create `TimeRegistrationEntryTemplate` mutation. */
export type CreateTimeRegistrationEntryTemplatePayloadTimeRegistrationEntryTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationEntryTemplatesOrderBy>>;
};

/** All input for the create `TimeRegistrationPresence` mutation. */
export type CreateTimeRegistrationPresenceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TimeRegistrationPresence` to be created by this mutation. */
  timeRegistrationPresence: TimeRegistrationPresenceInput;
};

/** The output of our create `TimeRegistrationPresence` mutation. */
export type CreateTimeRegistrationPresencePayload = {
  __typename?: 'CreateTimeRegistrationPresencePayload';
  /** Reads a single `Approval` that is related to this `TimeRegistrationPresence`. */
  approval?: Maybe<Approval>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationPresence`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TimeRegistrationPresence` that was created by this mutation. */
  timeRegistrationPresence?: Maybe<TimeRegistrationPresence>;
  /** An edge for our `TimeRegistrationPresence`. May be used by Relay 1. */
  timeRegistrationPresenceEdge?: Maybe<TimeRegistrationPresencesEdge>;
  /** Reads a single `TimeRegistrationPresenceType` that is related to this `TimeRegistrationPresence`. */
  timeRegistrationPresenceType?: Maybe<TimeRegistrationPresenceType>;
  /** Reads a single `User` that is related to this `TimeRegistrationPresence`. */
  user?: Maybe<User>;
};


/** The output of our create `TimeRegistrationPresence` mutation. */
export type CreateTimeRegistrationPresencePayloadTimeRegistrationPresenceEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationPresencesOrderBy>>;
};

/** All input for the create `TimeRegistrationPresenceTemplate` mutation. */
export type CreateTimeRegistrationPresenceTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TimeRegistrationPresenceTemplate` to be created by this mutation. */
  timeRegistrationPresenceTemplate: TimeRegistrationPresenceTemplateInput;
};

/** The output of our create `TimeRegistrationPresenceTemplate` mutation. */
export type CreateTimeRegistrationPresenceTemplatePayload = {
  __typename?: 'CreateTimeRegistrationPresenceTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationPresenceTemplate`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TimeRegistrationPresenceTemplate` that was created by this mutation. */
  timeRegistrationPresenceTemplate?: Maybe<TimeRegistrationPresenceTemplate>;
  /** An edge for our `TimeRegistrationPresenceTemplate`. May be used by Relay 1. */
  timeRegistrationPresenceTemplateEdge?: Maybe<TimeRegistrationPresenceTemplatesEdge>;
  /** Reads a single `TimeRegistrationPresenceType` that is related to this `TimeRegistrationPresenceTemplate`. */
  timeRegistrationPresenceType?: Maybe<TimeRegistrationPresenceType>;
  /** Reads a single `TimeRegistrationTemplate` that is related to this `TimeRegistrationPresenceTemplate`. */
  timeRegistrationTemplate?: Maybe<TimeRegistrationTemplate>;
  /** Reads a single `TimeRegistrationTemplateWeek` that is related to this `TimeRegistrationPresenceTemplate`. */
  timeRegistrationTemplateWeek?: Maybe<TimeRegistrationTemplateWeek>;
  /** Reads a single `User` that is related to this `TimeRegistrationPresenceTemplate`. */
  user?: Maybe<User>;
};


/** The output of our create `TimeRegistrationPresenceTemplate` mutation. */
export type CreateTimeRegistrationPresenceTemplatePayloadTimeRegistrationPresenceTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationPresenceTemplatesOrderBy>>;
};

/** All input for the create `TimeRegistrationPresenceType` mutation. */
export type CreateTimeRegistrationPresenceTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TimeRegistrationPresenceType` to be created by this mutation. */
  timeRegistrationPresenceType: TimeRegistrationPresenceTypeInput;
};

/** The output of our create `TimeRegistrationPresenceType` mutation. */
export type CreateTimeRegistrationPresenceTypePayload = {
  __typename?: 'CreateTimeRegistrationPresenceTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationPresenceType`. */
  company?: Maybe<Company>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationPresenceType`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TimeRegistrationPresenceType` that was created by this mutation. */
  timeRegistrationPresenceType?: Maybe<TimeRegistrationPresenceType>;
  /** An edge for our `TimeRegistrationPresenceType`. May be used by Relay 1. */
  timeRegistrationPresenceTypeEdge?: Maybe<TimeRegistrationPresenceTypesEdge>;
};


/** The output of our create `TimeRegistrationPresenceType` mutation. */
export type CreateTimeRegistrationPresenceTypePayloadTimeRegistrationPresenceTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationPresenceTypesOrderBy>>;
};

/** All input for the create `TimeRegistrationProject` mutation. */
export type CreateTimeRegistrationProjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TimeRegistrationProject` to be created by this mutation. */
  timeRegistrationProject: TimeRegistrationProjectInput;
};

/** The output of our create `TimeRegistrationProject` mutation. */
export type CreateTimeRegistrationProjectPayload = {
  __typename?: 'CreateTimeRegistrationProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationProject`. */
  company?: Maybe<Company>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationProject`. */
  descriptionTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationProject`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TimeRegistrationProject` that was created by this mutation. */
  timeRegistrationProject?: Maybe<TimeRegistrationProject>;
  /** An edge for our `TimeRegistrationProject`. May be used by Relay 1. */
  timeRegistrationProjectEdge?: Maybe<TimeRegistrationProjectsEdge>;
};


/** The output of our create `TimeRegistrationProject` mutation. */
export type CreateTimeRegistrationProjectPayloadTimeRegistrationProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationProjectsOrderBy>>;
};

/** All input for the create `TimeRegistrationTemplate` mutation. */
export type CreateTimeRegistrationTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TimeRegistrationTemplate` to be created by this mutation. */
  timeRegistrationTemplate: TimeRegistrationTemplateInput;
};

/** The output of our create `TimeRegistrationTemplate` mutation. */
export type CreateTimeRegistrationTemplatePayload = {
  __typename?: 'CreateTimeRegistrationTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationTemplate`. */
  company?: Maybe<Company>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationTemplate`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TimeRegistrationTemplate` that was created by this mutation. */
  timeRegistrationTemplate?: Maybe<TimeRegistrationTemplate>;
  /** An edge for our `TimeRegistrationTemplate`. May be used by Relay 1. */
  timeRegistrationTemplateEdge?: Maybe<TimeRegistrationTemplatesEdge>;
};


/** The output of our create `TimeRegistrationTemplate` mutation. */
export type CreateTimeRegistrationTemplatePayloadTimeRegistrationTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationTemplatesOrderBy>>;
};

/** All input for the create `TimeRegistrationTemplateWeek` mutation. */
export type CreateTimeRegistrationTemplateWeekInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TimeRegistrationTemplateWeek` to be created by this mutation. */
  timeRegistrationTemplateWeek: TimeRegistrationTemplateWeekInput;
};

/** The output of our create `TimeRegistrationTemplateWeek` mutation. */
export type CreateTimeRegistrationTemplateWeekPayload = {
  __typename?: 'CreateTimeRegistrationTemplateWeekPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationTemplateWeek`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TimeRegistrationTemplate` that is related to this `TimeRegistrationTemplateWeek`. */
  timeRegistrationTemplate?: Maybe<TimeRegistrationTemplate>;
  /** The `TimeRegistrationTemplateWeek` that was created by this mutation. */
  timeRegistrationTemplateWeek?: Maybe<TimeRegistrationTemplateWeek>;
  /** An edge for our `TimeRegistrationTemplateWeek`. May be used by Relay 1. */
  timeRegistrationTemplateWeekEdge?: Maybe<TimeRegistrationTemplateWeeksEdge>;
  /** Reads a single `User` that is related to this `TimeRegistrationTemplateWeek`. */
  user?: Maybe<User>;
};


/** The output of our create `TimeRegistrationTemplateWeek` mutation. */
export type CreateTimeRegistrationTemplateWeekPayloadTimeRegistrationTemplateWeekEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationTemplateWeeksOrderBy>>;
};

/** All input for the create `TranslatedEntity` mutation. */
export type CreateTranslatedEntityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TranslatedEntity` to be created by this mutation. */
  translatedEntity: TranslatedEntityInput;
};

/** All input for the create `TranslatedEntityLocalization` mutation. */
export type CreateTranslatedEntityLocalizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TranslatedEntityLocalization` to be created by this mutation. */
  translatedEntityLocalization: TranslatedEntityLocalizationInput;
};

/** The output of our create `TranslatedEntityLocalization` mutation. */
export type CreateTranslatedEntityLocalizationPayload = {
  __typename?: 'CreateTranslatedEntityLocalizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TranslatedEntityLocalization`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TranslatedEntity` that is related to this `TranslatedEntityLocalization`. */
  translatedEntity?: Maybe<TranslatedEntity>;
  /** The `TranslatedEntityLocalization` that was created by this mutation. */
  translatedEntityLocalization?: Maybe<TranslatedEntityLocalization>;
  /** An edge for our `TranslatedEntityLocalization`. May be used by Relay 1. */
  translatedEntityLocalizationEdge?: Maybe<TranslatedEntityLocalizationsEdge>;
};


/** The output of our create `TranslatedEntityLocalization` mutation. */
export type CreateTranslatedEntityLocalizationPayloadTranslatedEntityLocalizationEdgeArgs = {
  orderBy?: InputMaybe<Array<TranslatedEntityLocalizationsOrderBy>>;
};

/** The output of our create `TranslatedEntity` mutation. */
export type CreateTranslatedEntityPayload = {
  __typename?: 'CreateTranslatedEntityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TranslatedEntity`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TranslatedEntity` that was created by this mutation. */
  translatedEntity?: Maybe<TranslatedEntity>;
  /** An edge for our `TranslatedEntity`. May be used by Relay 1. */
  translatedEntityEdge?: Maybe<TranslatedEntitiesEdge>;
};


/** The output of our create `TranslatedEntity` mutation. */
export type CreateTranslatedEntityPayloadTranslatedEntityEdgeArgs = {
  orderBy?: InputMaybe<Array<TranslatedEntitiesOrderBy>>;
};

/** All input for the create `Translation` mutation. */
export type CreateTranslationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Translation` to be created by this mutation. */
  translation: TranslationInput;
};

/** The output of our create `Translation` mutation. */
export type CreateTranslationPayload = {
  __typename?: 'CreateTranslationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Translation`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Translation` that was created by this mutation. */
  translation?: Maybe<Translation>;
  /** An edge for our `Translation`. May be used by Relay 1. */
  translationEdge?: Maybe<TranslationsEdge>;
};


/** The output of our create `Translation` mutation. */
export type CreateTranslationPayloadTranslationEdgeArgs = {
  orderBy?: InputMaybe<Array<TranslationsOrderBy>>;
};

/** All input for the create `UserAnnouncement` mutation. */
export type CreateUserAnnouncementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserAnnouncement` to be created by this mutation. */
  userAnnouncement: UserAnnouncementInput;
};

/** The output of our create `UserAnnouncement` mutation. */
export type CreateUserAnnouncementPayload = {
  __typename?: 'CreateUserAnnouncementPayload';
  /** Reads a single `Announcement` that is related to this `UserAnnouncement`. */
  announcement?: Maybe<Announcement>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserAnnouncement`. */
  user?: Maybe<User>;
  /** The `UserAnnouncement` that was created by this mutation. */
  userAnnouncement?: Maybe<UserAnnouncement>;
  /** An edge for our `UserAnnouncement`. May be used by Relay 1. */
  userAnnouncementEdge?: Maybe<UserAnnouncementsEdge>;
};


/** The output of our create `UserAnnouncement` mutation. */
export type CreateUserAnnouncementPayloadUserAnnouncementEdgeArgs = {
  orderBy?: InputMaybe<Array<UserAnnouncementsOrderBy>>;
};

/** All input for the create `UserCompanyGroup` mutation. */
export type CreateUserCompanyGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserCompanyGroup` to be created by this mutation. */
  userCompanyGroup: UserCompanyGroupInput;
};

/** The output of our create `UserCompanyGroup` mutation. */
export type CreateUserCompanyGroupPayload = {
  __typename?: 'CreateUserCompanyGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserCompanyGroup`. */
  company?: Maybe<Company>;
  /** Reads a single `Group` that is related to this `UserCompanyGroup`. */
  group?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserCompanyGroup`. */
  user?: Maybe<User>;
  /** The `UserCompanyGroup` that was created by this mutation. */
  userCompanyGroup?: Maybe<UserCompanyGroup>;
  /** An edge for our `UserCompanyGroup`. May be used by Relay 1. */
  userCompanyGroupEdge?: Maybe<UserCompanyGroupsEdge>;
};


/** The output of our create `UserCompanyGroup` mutation. */
export type CreateUserCompanyGroupPayloadUserCompanyGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCompanyGroupsOrderBy>>;
};

/** All input for the create `UserCompanyRole` mutation. */
export type CreateUserCompanyRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserCompanyRole` to be created by this mutation. */
  userCompanyRole: UserCompanyRoleInput;
};

/** The output of our create `UserCompanyRole` mutation. */
export type CreateUserCompanyRolePayload = {
  __typename?: 'CreateUserCompanyRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserCompanyRole`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Role` that is related to this `UserCompanyRole`. */
  role?: Maybe<Role>;
  /** Reads a single `User` that is related to this `UserCompanyRole`. */
  user?: Maybe<User>;
  /** The `UserCompanyRole` that was created by this mutation. */
  userCompanyRole?: Maybe<UserCompanyRole>;
  /** An edge for our `UserCompanyRole`. May be used by Relay 1. */
  userCompanyRoleEdge?: Maybe<UserCompanyRolesEdge>;
};


/** The output of our create `UserCompanyRole` mutation. */
export type CreateUserCompanyRolePayloadUserCompanyRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCompanyRolesOrderBy>>;
};

/** All input for the create `UserCompetenceEvaluationComment` mutation. */
export type CreateUserCompetenceEvaluationCommentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserCompetenceEvaluationComment` to be created by this mutation. */
  userCompetenceEvaluationComment: UserCompetenceEvaluationCommentInput;
};

/** The output of our create `UserCompetenceEvaluationComment` mutation. */
export type CreateUserCompetenceEvaluationCommentPayload = {
  __typename?: 'CreateUserCompetenceEvaluationCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserCompetenceEvaluationComment`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserCompetenceEvaluationComment`. */
  user?: Maybe<User>;
  /** Reads a single `UserCompetenceEvaluation` that is related to this `UserCompetenceEvaluationComment`. */
  userCompetenceEvaluation?: Maybe<UserCompetenceEvaluation>;
  /** The `UserCompetenceEvaluationComment` that was created by this mutation. */
  userCompetenceEvaluationComment?: Maybe<UserCompetenceEvaluationComment>;
  /** An edge for our `UserCompetenceEvaluationComment`. May be used by Relay 1. */
  userCompetenceEvaluationCommentEdge?: Maybe<UserCompetenceEvaluationCommentsEdge>;
};


/** The output of our create `UserCompetenceEvaluationComment` mutation. */
export type CreateUserCompetenceEvaluationCommentPayloadUserCompetenceEvaluationCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCompetenceEvaluationCommentsOrderBy>>;
};

/** All input for the create `UserCompetenceEvaluation` mutation. */
export type CreateUserCompetenceEvaluationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserCompetenceEvaluation` to be created by this mutation. */
  userCompetenceEvaluation: UserCompetenceEvaluationInput;
};

/** The output of our create `UserCompetenceEvaluation` mutation. */
export type CreateUserCompetenceEvaluationPayload = {
  __typename?: 'CreateUserCompetenceEvaluationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserCompetenceEvaluation`. */
  company?: Maybe<Company>;
  /** Reads a single `User` that is related to this `UserCompetenceEvaluation`. */
  evaluatingUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UserCompetence` that is related to this `UserCompetenceEvaluation`. */
  userCompetence?: Maybe<UserCompetence>;
  /** The `UserCompetenceEvaluation` that was created by this mutation. */
  userCompetenceEvaluation?: Maybe<UserCompetenceEvaluation>;
  /** An edge for our `UserCompetenceEvaluation`. May be used by Relay 1. */
  userCompetenceEvaluationEdge?: Maybe<UserCompetenceEvaluationsEdge>;
};


/** The output of our create `UserCompetenceEvaluation` mutation. */
export type CreateUserCompetenceEvaluationPayloadUserCompetenceEvaluationEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCompetenceEvaluationsOrderBy>>;
};

/** All input for the create `UserCompetence` mutation. */
export type CreateUserCompetenceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserCompetence` to be created by this mutation. */
  userCompetence: UserCompetenceInput;
};

/** The output of our create `UserCompetence` mutation. */
export type CreateUserCompetencePayload = {
  __typename?: 'CreateUserCompetencePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserCompetence`. */
  company?: Maybe<Company>;
  /** Reads a single `Competence` that is related to this `UserCompetence`. */
  competence?: Maybe<Competence>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserCompetence`. */
  user?: Maybe<User>;
  /** The `UserCompetence` that was created by this mutation. */
  userCompetence?: Maybe<UserCompetence>;
  /** An edge for our `UserCompetence`. May be used by Relay 1. */
  userCompetenceEdge?: Maybe<UserCompetencesEdge>;
};


/** The output of our create `UserCompetence` mutation. */
export type CreateUserCompetencePayloadUserCompetenceEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCompetencesOrderBy>>;
};

/** All input for the create `UserDepartmentGroup` mutation. */
export type CreateUserDepartmentGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserDepartmentGroup` to be created by this mutation. */
  userDepartmentGroup: UserDepartmentGroupInput;
};

/** The output of our create `UserDepartmentGroup` mutation. */
export type CreateUserDepartmentGroupPayload = {
  __typename?: 'CreateUserDepartmentGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserDepartmentGroup`. */
  company?: Maybe<Company>;
  /** Reads a single `Department` that is related to this `UserDepartmentGroup`. */
  department?: Maybe<Department>;
  /** Reads a single `Group` that is related to this `UserDepartmentGroup`. */
  group?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserDepartmentGroup`. */
  user?: Maybe<User>;
  /** The `UserDepartmentGroup` that was created by this mutation. */
  userDepartmentGroup?: Maybe<UserDepartmentGroup>;
  /** An edge for our `UserDepartmentGroup`. May be used by Relay 1. */
  userDepartmentGroupEdge?: Maybe<UserDepartmentGroupsEdge>;
};


/** The output of our create `UserDepartmentGroup` mutation. */
export type CreateUserDepartmentGroupPayloadUserDepartmentGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UserDepartmentGroupsOrderBy>>;
};

/** All input for the create `UserDepartment` mutation. */
export type CreateUserDepartmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserDepartment` to be created by this mutation. */
  userDepartment: UserDepartmentInput;
};

/** The output of our create `UserDepartment` mutation. */
export type CreateUserDepartmentPayload = {
  __typename?: 'CreateUserDepartmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserDepartment`. */
  company?: Maybe<Company>;
  /** Reads a single `Department` that is related to this `UserDepartment`. */
  department?: Maybe<Department>;
  /** Reads a single `UserDepartment` that is related to this `UserDepartment`. */
  parentUserDepartment?: Maybe<UserDepartment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Rank` that is related to this `UserDepartment`. */
  rank?: Maybe<Rank>;
  /** Reads a single `User` that is related to this `UserDepartment`. */
  user?: Maybe<User>;
  /** The `UserDepartment` that was created by this mutation. */
  userDepartment?: Maybe<UserDepartment>;
  /** An edge for our `UserDepartment`. May be used by Relay 1. */
  userDepartmentEdge?: Maybe<UserDepartmentsEdge>;
};


/** The output of our create `UserDepartment` mutation. */
export type CreateUserDepartmentPayloadUserDepartmentEdgeArgs = {
  orderBy?: InputMaybe<Array<UserDepartmentsOrderBy>>;
};

/** All input for the create `UserDepartmentRole` mutation. */
export type CreateUserDepartmentRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserDepartmentRole` to be created by this mutation. */
  userDepartmentRole: UserDepartmentRoleInput;
};

/** The output of our create `UserDepartmentRole` mutation. */
export type CreateUserDepartmentRolePayload = {
  __typename?: 'CreateUserDepartmentRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserDepartmentRole`. */
  company?: Maybe<Company>;
  /** Reads a single `Department` that is related to this `UserDepartmentRole`. */
  department?: Maybe<Department>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Role` that is related to this `UserDepartmentRole`. */
  role?: Maybe<Role>;
  /** Reads a single `User` that is related to this `UserDepartmentRole`. */
  user?: Maybe<User>;
  /** The `UserDepartmentRole` that was created by this mutation. */
  userDepartmentRole?: Maybe<UserDepartmentRole>;
  /** An edge for our `UserDepartmentRole`. May be used by Relay 1. */
  userDepartmentRoleEdge?: Maybe<UserDepartmentRolesEdge>;
};


/** The output of our create `UserDepartmentRole` mutation. */
export type CreateUserDepartmentRolePayloadUserDepartmentRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserDepartmentRolesOrderBy>>;
};

/** All input for the create `UserGroup` mutation. */
export type CreateUserGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserGroup` to be created by this mutation. */
  userGroup: UserGroupInput;
};

/** The output of our create `UserGroup` mutation. */
export type CreateUserGroupPayload = {
  __typename?: 'CreateUserGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserGroup`. */
  company?: Maybe<Company>;
  /** Reads a single `Group` that is related to this `UserGroup`. */
  group?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserGroup`. */
  user?: Maybe<User>;
  /** The `UserGroup` that was created by this mutation. */
  userGroup?: Maybe<UserGroup>;
  /** An edge for our `UserGroup`. May be used by Relay 1. */
  userGroupEdge?: Maybe<UserGroupsEdge>;
};


/** The output of our create `UserGroup` mutation. */
export type CreateUserGroupPayloadUserGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UserGroupsOrderBy>>;
};

/** All input for the create `UserOnBehalfPermission` mutation. */
export type CreateUserOnBehalfPermissionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserOnBehalfPermission` to be created by this mutation. */
  userOnBehalfPermission: UserOnBehalfPermissionInput;
};

/** The output of our create `UserOnBehalfPermission` mutation. */
export type CreateUserOnBehalfPermissionPayload = {
  __typename?: 'CreateUserOnBehalfPermissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserOnBehalfPermission`. */
  company?: Maybe<Company>;
  /** Reads a single `User` that is related to this `UserOnBehalfPermission`. */
  onBehalfOfUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserOnBehalfPermission`. */
  user?: Maybe<User>;
  /** The `UserOnBehalfPermission` that was created by this mutation. */
  userOnBehalfPermission?: Maybe<UserOnBehalfPermission>;
  /** An edge for our `UserOnBehalfPermission`. May be used by Relay 1. */
  userOnBehalfPermissionEdge?: Maybe<UserOnBehalfPermissionsEdge>;
};


/** The output of our create `UserOnBehalfPermission` mutation. */
export type CreateUserOnBehalfPermissionPayloadUserOnBehalfPermissionEdgeArgs = {
  orderBy?: InputMaybe<Array<UserOnBehalfPermissionsOrderBy>>;
};

/** All input for the create `UserRole` mutation. */
export type CreateUserRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserRole` to be created by this mutation. */
  userRole: UserRoleInput;
};

/** The output of our create `UserRole` mutation. */
export type CreateUserRolePayload = {
  __typename?: 'CreateUserRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserRole`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Role` that is related to this `UserRole`. */
  role?: Maybe<Role>;
  /** Reads a single `User` that is related to this `UserRole`. */
  user?: Maybe<User>;
  /** The `UserRole` that was created by this mutation. */
  userRole?: Maybe<UserRole>;
  /** An edge for our `UserRole`. May be used by Relay 1. */
  userRoleEdge?: Maybe<UserRolesEdge>;
};


/** The output of our create `UserRole` mutation. */
export type CreateUserRolePayloadUserRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
};

/** All input for the create `UserSetting` mutation. */
export type CreateUserSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserSetting` to be created by this mutation. */
  userSetting: UserSettingInput;
};

/** The output of our create `UserSetting` mutation. */
export type CreateUserSettingPayload = {
  __typename?: 'CreateUserSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserSetting`. */
  user?: Maybe<User>;
  /** The `UserSetting` that was created by this mutation. */
  userSetting?: Maybe<UserSetting>;
  /** An edge for our `UserSetting`. May be used by Relay 1. */
  userSettingEdge?: Maybe<UserSettingsEdge>;
};


/** The output of our create `UserSetting` mutation. */
export type CreateUserSettingPayloadUserSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
};

/** All input for the create `VacationType` mutation. */
export type CreateVacationTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `VacationType` to be created by this mutation. */
  vacationType: VacationTypeInput;
};

/** The output of our create `VacationType` mutation. */
export type CreateVacationTypePayload = {
  __typename?: 'CreateVacationTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `VacationType`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VacationType` that was created by this mutation. */
  vacationType?: Maybe<VacationType>;
  /** An edge for our `VacationType`. May be used by Relay 1. */
  vacationTypeEdge?: Maybe<VacationTypesEdge>;
};


/** The output of our create `VacationType` mutation. */
export type CreateVacationTypePayloadVacationTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<VacationTypesOrderBy>>;
};

/** All input for the create `VacationUser` mutation. */
export type CreateVacationUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `VacationUser` to be created by this mutation. */
  vacationUser: VacationUserInput;
};

/** The output of our create `VacationUser` mutation. */
export type CreateVacationUserPayload = {
  __typename?: 'CreateVacationUserPayload';
  /** Reads a single `Approval` that is related to this `VacationUser`. */
  approval?: Maybe<Approval>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `VacationUser`. */
  company?: Maybe<Company>;
  /** Reads a single `User` that is related to this `VacationUser`. */
  creatorUser?: Maybe<User>;
  /** Reads a single `Approval` that is related to this `VacationUser`. */
  deletionApproval?: Maybe<Approval>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `VacationUser`. */
  user?: Maybe<User>;
  /** Reads a single `VacationType` that is related to this `VacationUser`. */
  vacationType?: Maybe<VacationType>;
  /** The `VacationUser` that was created by this mutation. */
  vacationUser?: Maybe<VacationUser>;
  /** An edge for our `VacationUser`. May be used by Relay 1. */
  vacationUserEdge?: Maybe<VacationUsersEdge>;
};


/** The output of our create `VacationUser` mutation. */
export type CreateVacationUserPayloadVacationUserEdgeArgs = {
  orderBy?: InputMaybe<Array<VacationUsersOrderBy>>;
};

export type CsvMapping = {
  __typename?: 'CsvMapping';
  columnName?: Maybe<Scalars['String']>;
  fieldId?: Maybe<Scalars['UUID']>;
  fieldName?: Maybe<Scalars['String']>;
  fieldType?: Maybe<FieldType>;
  options?: Maybe<Array<Maybe<FieldMappingOption>>>;
};

export type CsvMappingInput = {
  columnName?: InputMaybe<Scalars['String']>;
  fieldId?: InputMaybe<Scalars['UUID']>;
  fieldName?: InputMaybe<Scalars['String']>;
  fieldType?: InputMaybe<FieldType>;
};

export type CustomEmployeeCasefileInput = {
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documents: Array<InputMaybe<CasefileDocumentInput>>;
  emailSubject: Scalars['String'];
  emailText: Scalars['String'];
  employeeId: Scalars['UUID'];
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  expireAt?: InputMaybe<Scalars['Int']>;
  locale: Scalars['String'];
  recipients: Array<InputMaybe<CasefileRecipientInput>>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signers: Array<InputMaybe<CasefileSignerInput>>;
  signingUserIds: Array<InputMaybe<Scalars['UUID']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type CustomFieldValueType = {
  __typename?: 'CustomFieldValueType';
  customField?: Maybe<CustomFieldType>;
  value?: Maybe<Scalars['String']>;
};

export type CustomWidget = {
  __typename?: 'CustomWidget';
  active: Scalars['Boolean'];
  backgroundColor: Scalars['String'];
  buttonBackgroundColor: Scalars['String'];
  buttonBorder: Scalars['Boolean'];
  buttonTextColor: Scalars['String'];
  /** Reads a single `Company` that is related to this `CustomWidget`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `CustomWidgetContent`. */
  customWidgetContents: CustomWidgetContentsConnection;
  /** Reads and enables pagination through a set of `DashboardCard`. */
  dashboardCards: DashboardCardsConnection;
  id: Scalars['UUID'];
  image?: Maybe<Storage>;
  imageLayout: Scalars['String'];
  useImage: Scalars['Boolean'];
  widgetSize: Scalars['Int'];
  widgetTextColor: Scalars['String'];
};


export type CustomWidgetCustomWidgetContentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CustomWidgetContentCondition>;
  filter?: InputMaybe<CustomWidgetContentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomWidgetContentsOrderBy>>;
};


export type CustomWidgetDashboardCardsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DashboardCardCondition>;
  filter?: InputMaybe<DashboardCardFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DashboardCardsOrderBy>>;
};

/** The `customWidget` to be created by this mutation. */
export type CustomWidgetCompanyIdForeignConnectionCustomWidgetCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  backgroundColor: Scalars['String'];
  buttonBackgroundColor: Scalars['String'];
  buttonBorder?: InputMaybe<Scalars['Boolean']>;
  buttonTextColor: Scalars['String'];
  company?: InputMaybe<CustomWidgetCompanyIdForeignInput>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCustomWidgetIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCustomWidgetIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  imageLayout?: InputMaybe<Scalars['String']>;
  useImage?: InputMaybe<Scalars['Boolean']>;
  widgetSize?: InputMaybe<Scalars['Int']>;
  widgetTextColor: Scalars['String'];
};

/** Input for the nested mutation of `company` in the `CustomWidgetInput` mutation. */
export type CustomWidgetCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnCustomWidgetForCustomWidgetCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `customWidget` in the `CompanyInput` mutation. */
export type CustomWidgetCompanyIdForeignInverseInput = {
  /** The primary key(s) for `customWidget` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CustomWidgetCustomWidgetPkeyConnect>>;
  /** A `CustomWidgetInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CustomWidgetCompanyIdForeignConnectionCustomWidgetCreateInput>>;
  /** The primary key(s) and patch data for `customWidget` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CustomWidgetOnCustomWidgetForCustomWidgetCompanyIdForeignUsingCustomWidgetPkeyUpdate>>;
};

/**
 * A condition to be used against `CustomWidget` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CustomWidgetCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `backgroundColor` field. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `buttonBackgroundColor` field. */
  buttonBackgroundColor?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `buttonBorder` field. */
  buttonBorder?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `buttonTextColor` field. */
  buttonTextColor?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `imageLayout` field. */
  imageLayout?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `useImage` field. */
  useImage?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `widgetSize` field. */
  widgetSize?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `widgetTextColor` field. */
  widgetTextColor?: InputMaybe<Scalars['String']>;
};

export type CustomWidgetContent = {
  __typename?: 'CustomWidgetContent';
  active: Scalars['Boolean'];
  addButton: Scalars['Boolean'];
  buttonLink?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CustomWidgetContent`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  content: Scalars['String'];
  /** Reads a single `CustomWidget` that is related to this `CustomWidgetContent`. */
  customWidget?: Maybe<CustomWidget>;
  customWidgetId: Scalars['UUID'];
  id: Scalars['UUID'];
  isInternalButtonLink?: Maybe<Scalars['Boolean']>;
  locale: Scalars['String'];
  title: Scalars['String'];
};

/** The `customWidgetContent` to be created by this mutation. */
export type CustomWidgetContentCompanyIdForeignConnectionCustomWidgetContentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addButton?: InputMaybe<Scalars['Boolean']>;
  buttonLink?: InputMaybe<Scalars['String']>;
  buttonText?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CustomWidgetContentCompanyIdForeignInput>;
  content: Scalars['String'];
  customWidget?: InputMaybe<CustomWidgetContentCustomWidgetIdForeignInput>;
  customWidgetId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  isInternalButtonLink?: InputMaybe<Scalars['Boolean']>;
  locale: Scalars['String'];
  title: Scalars['String'];
};

/** Input for the nested mutation of `company` in the `CustomWidgetContentInput` mutation. */
export type CustomWidgetContentCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnCustomWidgetContentForCustomWidgetContentCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `customWidgetContent` in the `CompanyInput` mutation. */
export type CustomWidgetContentCompanyIdForeignInverseInput = {
  /** The primary key(s) for `customWidgetContent` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CustomWidgetContentCustomWidgetContentPkeyConnect>>;
  /** A `CustomWidgetContentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CustomWidgetContentCompanyIdForeignConnectionCustomWidgetContentCreateInput>>;
  /** The primary key(s) and patch data for `customWidgetContent` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CustomWidgetContentOnCustomWidgetContentForCustomWidgetContentCompanyIdForeignUsingCustomWidgetContentPkeyUpdate>>;
};

/**
 * A condition to be used against `CustomWidgetContent` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CustomWidgetContentCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `addButton` field. */
  addButton?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `buttonLink` field. */
  buttonLink?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `buttonText` field. */
  buttonText?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `content` field. */
  content?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `customWidgetId` field. */
  customWidgetId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isInternalButtonLink` field. */
  isInternalButtonLink?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `locale` field. */
  locale?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>;
};

/** The fields on `customWidgetContent` to look up the row to connect. */
export type CustomWidgetContentCustomWidgetContentPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `customWidgetContent` to be created by this mutation. */
export type CustomWidgetContentCustomWidgetIdForeignConnectionCustomWidgetContentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addButton?: InputMaybe<Scalars['Boolean']>;
  buttonLink?: InputMaybe<Scalars['String']>;
  buttonText?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CustomWidgetContentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  content: Scalars['String'];
  customWidget?: InputMaybe<CustomWidgetContentCustomWidgetIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isInternalButtonLink?: InputMaybe<Scalars['Boolean']>;
  locale: Scalars['String'];
  title: Scalars['String'];
};

/** The `customWidget` to be created by this mutation. */
export type CustomWidgetContentCustomWidgetIdForeignConnectionCustomWidgetCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  backgroundColor: Scalars['String'];
  buttonBackgroundColor: Scalars['String'];
  buttonBorder?: InputMaybe<Scalars['Boolean']>;
  buttonTextColor: Scalars['String'];
  company?: InputMaybe<CustomWidgetCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCustomWidgetIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCustomWidgetIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  imageLayout?: InputMaybe<Scalars['String']>;
  useImage?: InputMaybe<Scalars['Boolean']>;
  widgetSize?: InputMaybe<Scalars['Int']>;
  widgetTextColor: Scalars['String'];
};

/** Input for the nested mutation of `customWidget` in the `CustomWidgetContentInput` mutation. */
export type CustomWidgetContentCustomWidgetIdForeignInput = {
  /** The primary key(s) for `customWidget` for the far side of the relationship. */
  connectById?: InputMaybe<CustomWidgetCustomWidgetPkeyConnect>;
  /** A `CustomWidgetInput` object that will be created and connected to this object. */
  create?: InputMaybe<CustomWidgetContentCustomWidgetIdForeignConnectionCustomWidgetCreateInput>;
  /** The primary key(s) and patch data for `customWidget` for the far side of the relationship. */
  updateById?: InputMaybe<CustomWidgetOnCustomWidgetContentForCustomWidgetContentCustomWidgetIdForeignUsingCustomWidgetPkeyUpdate>;
};

/** Input for the nested mutation of `customWidgetContent` in the `CustomWidgetInput` mutation. */
export type CustomWidgetContentCustomWidgetIdForeignInverseInput = {
  /** The primary key(s) for `customWidgetContent` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CustomWidgetContentCustomWidgetContentPkeyConnect>>;
  /** A `CustomWidgetContentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CustomWidgetContentCustomWidgetIdForeignConnectionCustomWidgetContentCreateInput>>;
  /** The primary key(s) and patch data for `customWidgetContent` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CustomWidgetContentOnCustomWidgetContentForCustomWidgetContentCustomWidgetIdForeignUsingCustomWidgetContentPkeyUpdate>>;
};

/** A filter to be used against `CustomWidgetContent` object types. All fields are combined with a logical ‘and.’ */
export type CustomWidgetContentFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `addButton` field. */
  addButton?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CustomWidgetContentFilter>>;
  /** Filter by the object’s `buttonLink` field. */
  buttonLink?: InputMaybe<StringFilter>;
  /** Filter by the object’s `buttonText` field. */
  buttonText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `content` field. */
  content?: InputMaybe<StringFilter>;
  /** Filter by the object’s `customWidget` relation. */
  customWidget?: InputMaybe<CustomWidgetFilter>;
  /** Filter by the object’s `customWidgetId` field. */
  customWidgetId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isInternalButtonLink` field. */
  isInternalButtonLink?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `locale` field. */
  locale?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CustomWidgetContentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CustomWidgetContentFilter>>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `CustomWidgetContent` */
export type CustomWidgetContentInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addButton?: InputMaybe<Scalars['Boolean']>;
  buttonLink?: InputMaybe<Scalars['String']>;
  buttonText?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CustomWidgetContentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  content: Scalars['String'];
  customWidget?: InputMaybe<CustomWidgetContentCustomWidgetIdForeignInput>;
  customWidgetId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  isInternalButtonLink?: InputMaybe<Scalars['Boolean']>;
  locale: Scalars['String'];
  title: Scalars['String'];
};

/** The fields on `customWidgetContent` to look up the row to update. */
export type CustomWidgetContentOnCustomWidgetContentForCustomWidgetContentCompanyIdForeignUsingCustomWidgetContentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `customWidgetContent` being updated. */
  patch: UpdateCustomWidgetContentOnCustomWidgetContentForCustomWidgetContentCompanyIdForeignPatch;
};

/** The fields on `customWidgetContent` to look up the row to update. */
export type CustomWidgetContentOnCustomWidgetContentForCustomWidgetContentCustomWidgetIdForeignUsingCustomWidgetContentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `customWidgetContent` being updated. */
  patch: UpdateCustomWidgetContentOnCustomWidgetContentForCustomWidgetContentCustomWidgetIdForeignPatch;
};

/** Represents an update to a `CustomWidgetContent`. Fields that are set will be updated. */
export type CustomWidgetContentPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addButton?: InputMaybe<Scalars['Boolean']>;
  buttonLink?: InputMaybe<Scalars['String']>;
  buttonText?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CustomWidgetContentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  content?: InputMaybe<Scalars['String']>;
  customWidget?: InputMaybe<CustomWidgetContentCustomWidgetIdForeignInput>;
  customWidgetId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  isInternalButtonLink?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `CustomWidgetContent` values. */
export type CustomWidgetContentsConnection = {
  __typename?: 'CustomWidgetContentsConnection';
  /** A list of edges which contains the `CustomWidgetContent` and cursor to aid in pagination. */
  edges: Array<CustomWidgetContentsEdge>;
  /** A list of `CustomWidgetContent` objects. */
  nodes: Array<Maybe<CustomWidgetContent>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CustomWidgetContent` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CustomWidgetContent` edge in the connection. */
export type CustomWidgetContentsEdge = {
  __typename?: 'CustomWidgetContentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CustomWidgetContent` at the end of the edge. */
  node?: Maybe<CustomWidgetContent>;
};

/** Methods to use when ordering `CustomWidgetContent`. */
export type CustomWidgetContentsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ADD_BUTTON_ASC'
  | 'ADD_BUTTON_DESC'
  | 'BUTTON_LINK_ASC'
  | 'BUTTON_LINK_DESC'
  | 'BUTTON_TEXT_ASC'
  | 'BUTTON_TEXT_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CONTENT_ASC'
  | 'CONTENT_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__ACTIVE_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__ACTIVE_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__BACKGROUND_COLOR_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__BACKGROUND_COLOR_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__BUTTON_BACKGROUND_COLOR_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__BUTTON_BACKGROUND_COLOR_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__BUTTON_BORDER_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__BUTTON_BORDER_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__BUTTON_TEXT_COLOR_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__BUTTON_TEXT_COLOR_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__COMPANY_ID_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__COMPANY_ID_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__ID_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__ID_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__IMAGE_LAYOUT_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__IMAGE_LAYOUT_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__USE_IMAGE_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__USE_IMAGE_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__WIDGET_SIZE_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__WIDGET_SIZE_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__WIDGET_TEXT_COLOR_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__WIDGET_TEXT_COLOR_DESC'
  | 'CUSTOM_WIDGET_ID_ASC'
  | 'CUSTOM_WIDGET_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IS_INTERNAL_BUTTON_LINK_ASC'
  | 'IS_INTERNAL_BUTTON_LINK_DESC'
  | 'LOCALE_ASC'
  | 'LOCALE_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TITLE_ASC'
  | 'TITLE_DESC';

/** The fields on `customWidget` to look up the row to connect. */
export type CustomWidgetCustomWidgetPkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against `CustomWidget` object types. All fields are combined with a logical ‘and.’ */
export type CustomWidgetFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CustomWidgetFilter>>;
  /** Filter by the object’s `backgroundColor` field. */
  backgroundColor?: InputMaybe<StringFilter>;
  /** Filter by the object’s `buttonBackgroundColor` field. */
  buttonBackgroundColor?: InputMaybe<StringFilter>;
  /** Filter by the object’s `buttonBorder` field. */
  buttonBorder?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `buttonTextColor` field. */
  buttonTextColor?: InputMaybe<StringFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `customWidgetContents` relation. */
  customWidgetContents?: InputMaybe<CustomWidgetToManyCustomWidgetContentFilter>;
  /** Some related `customWidgetContents` exist. */
  customWidgetContentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `dashboardCards` relation. */
  dashboardCards?: InputMaybe<CustomWidgetToManyDashboardCardFilter>;
  /** Some related `dashboardCards` exist. */
  dashboardCardsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `imageLayout` field. */
  imageLayout?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CustomWidgetFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CustomWidgetFilter>>;
  /** Filter by the object’s `useImage` field. */
  useImage?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `widgetSize` field. */
  widgetSize?: InputMaybe<IntFilter>;
  /** Filter by the object’s `widgetTextColor` field. */
  widgetTextColor?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `CustomWidget` */
export type CustomWidgetInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  backgroundColor: Scalars['String'];
  buttonBackgroundColor: Scalars['String'];
  buttonBorder?: InputMaybe<Scalars['Boolean']>;
  buttonTextColor: Scalars['String'];
  company?: InputMaybe<CustomWidgetCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCustomWidgetIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCustomWidgetIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  imageLayout?: InputMaybe<Scalars['String']>;
  useImage?: InputMaybe<Scalars['Boolean']>;
  widgetSize?: InputMaybe<Scalars['Int']>;
  widgetTextColor: Scalars['String'];
};

/** The fields on `customWidget` to look up the row to update. */
export type CustomWidgetOnCustomWidgetContentForCustomWidgetContentCustomWidgetIdForeignUsingCustomWidgetPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `customWidget` being updated. */
  patch: UpdateCustomWidgetOnCustomWidgetContentForCustomWidgetContentCustomWidgetIdForeignPatch;
};

/** The fields on `customWidget` to look up the row to update. */
export type CustomWidgetOnCustomWidgetForCustomWidgetCompanyIdForeignUsingCustomWidgetPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `customWidget` being updated. */
  patch: UpdateCustomWidgetOnCustomWidgetForCustomWidgetCompanyIdForeignPatch;
};

/** The fields on `customWidget` to look up the row to update. */
export type CustomWidgetOnDashboardCardForDashboardCardCustomWidgetIdForeignUsingCustomWidgetPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `customWidget` being updated. */
  patch: UpdateCustomWidgetOnDashboardCardForDashboardCardCustomWidgetIdForeignPatch;
};

/** Represents an update to a `CustomWidget`. Fields that are set will be updated. */
export type CustomWidgetPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  buttonBackgroundColor?: InputMaybe<Scalars['String']>;
  buttonBorder?: InputMaybe<Scalars['Boolean']>;
  buttonTextColor?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CustomWidgetCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCustomWidgetIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCustomWidgetIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  imageLayout?: InputMaybe<Scalars['String']>;
  useImage?: InputMaybe<Scalars['Boolean']>;
  widgetSize?: InputMaybe<Scalars['Int']>;
  widgetTextColor?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against many `CustomWidgetContent` object types. All fields are combined with a logical ‘and.’ */
export type CustomWidgetToManyCustomWidgetContentFilter = {
  /** Every related `CustomWidgetContent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CustomWidgetContentFilter>;
  /** No related `CustomWidgetContent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CustomWidgetContentFilter>;
  /** Some related `CustomWidgetContent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CustomWidgetContentFilter>;
};

/** A filter to be used against many `DashboardCard` object types. All fields are combined with a logical ‘and.’ */
export type CustomWidgetToManyDashboardCardFilter = {
  /** Every related `DashboardCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DashboardCardFilter>;
  /** No related `DashboardCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DashboardCardFilter>;
  /** Some related `DashboardCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DashboardCardFilter>;
};

/** A connection to a list of `CustomWidget` values. */
export type CustomWidgetsConnection = {
  __typename?: 'CustomWidgetsConnection';
  /** A list of edges which contains the `CustomWidget` and cursor to aid in pagination. */
  edges: Array<CustomWidgetsEdge>;
  /** A list of `CustomWidget` objects. */
  nodes: Array<Maybe<CustomWidget>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CustomWidget` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CustomWidget` edge in the connection. */
export type CustomWidgetsEdge = {
  __typename?: 'CustomWidgetsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CustomWidget` at the end of the edge. */
  node?: Maybe<CustomWidget>;
};

/** Methods to use when ordering `CustomWidget`. */
export type CustomWidgetsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'BACKGROUND_COLOR_ASC'
  | 'BACKGROUND_COLOR_DESC'
  | 'BUTTON_BACKGROUND_COLOR_ASC'
  | 'BUTTON_BACKGROUND_COLOR_DESC'
  | 'BUTTON_BORDER_ASC'
  | 'BUTTON_BORDER_DESC'
  | 'BUTTON_TEXT_COLOR_ASC'
  | 'BUTTON_TEXT_COLOR_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CUSTOM_WIDGET_CONTENTS_BY_CUSTOM_WIDGET_ID__COUNT_ASC'
  | 'CUSTOM_WIDGET_CONTENTS_BY_CUSTOM_WIDGET_ID__COUNT_DESC'
  | 'DASHBOARD_CARDS_BY_CUSTOM_WIDGET_ID__COUNT_ASC'
  | 'DASHBOARD_CARDS_BY_CUSTOM_WIDGET_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IMAGE_LAYOUT_ASC'
  | 'IMAGE_LAYOUT_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'USE_IMAGE_ASC'
  | 'USE_IMAGE_DESC'
  | 'WIDGET_SIZE_ASC'
  | 'WIDGET_SIZE_DESC'
  | 'WIDGET_TEXT_COLOR_ASC'
  | 'WIDGET_TEXT_COLOR_DESC';

export type CvTemplateFieldMapping = {
  __typename?: 'CvTemplateFieldMapping';
  /** Reads a single `Company` that is related to this `CvTemplateFieldMapping`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  cvTemplateField: Scalars['String'];
  /** Reads a single `FormField` that is related to this `CvTemplateFieldMapping`. */
  formField?: Maybe<FormField>;
  formFieldId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  /** Reads a single `SystemField` that is related to this `CvTemplateFieldMapping`. */
  systemField?: Maybe<SystemField>;
  systemFieldId?: Maybe<Scalars['UUID']>;
};

/** The `cvTemplateFieldMapping` to be created by this mutation. */
export type CvTemplateFieldMappingCompanyIdForeignConnectionCvTemplateFieldMappingCreateInput = {
  company?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInput>;
  cvTemplateField: Scalars['String'];
  formField?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<CvTemplateFieldMappingSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `CvTemplateFieldMappingInput` mutation. */
export type CvTemplateFieldMappingCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnCvTemplateFieldMappingForCvTemplateFieldMappingCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `cvTemplateFieldMapping` in the `CompanyInput` mutation. */
export type CvTemplateFieldMappingCompanyIdForeignInverseInput = {
  /** The primary key(s) for `cvTemplateFieldMapping` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CvTemplateFieldMappingCvTemplateFieldMappingPkeyConnect>>;
  /** A `CvTemplateFieldMappingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CvTemplateFieldMappingCompanyIdForeignConnectionCvTemplateFieldMappingCreateInput>>;
  /** The primary key(s) for `cvTemplateFieldMapping` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CvTemplateFieldMappingCvTemplateFieldMappingPkeyDelete>>;
  /** Flag indicating whether all other `cvTemplateFieldMapping` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `cvTemplateFieldMapping` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CvTemplateFieldMappingOnCvTemplateFieldMappingForCvTemplateFieldMappingCompanyIdForeignUsingCvTemplateFieldMappingPkeyUpdate>>;
};

/**
 * A condition to be used against `CvTemplateFieldMapping` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CvTemplateFieldMappingCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `cvTemplateField` field. */
  cvTemplateField?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `systemFieldId` field. */
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `cvTemplateFieldMapping` to look up the row to connect. */
export type CvTemplateFieldMappingCvTemplateFieldMappingPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `cvTemplateFieldMapping` to look up the row to delete. */
export type CvTemplateFieldMappingCvTemplateFieldMappingPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against `CvTemplateFieldMapping` object types. All fields are combined with a logical ‘and.’ */
export type CvTemplateFieldMappingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CvTemplateFieldMappingFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `cvTemplateField` field. */
  cvTemplateField?: InputMaybe<StringFilter>;
  /** Filter by the object’s `formField` relation. */
  formField?: InputMaybe<FormFieldFilter>;
  /** A related `formField` exists. */
  formFieldExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CvTemplateFieldMappingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CvTemplateFieldMappingFilter>>;
  /** Filter by the object’s `systemField` relation. */
  systemField?: InputMaybe<SystemFieldFilter>;
  /** A related `systemField` exists. */
  systemFieldExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `systemFieldId` field. */
  systemFieldId?: InputMaybe<UuidFilter>;
};

/** The `cvTemplateFieldMapping` to be created by this mutation. */
export type CvTemplateFieldMappingFormFieldIdForeignConnectionCvTemplateFieldMappingCreateInput = {
  company?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  cvTemplateField: Scalars['String'];
  formField?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<CvTemplateFieldMappingSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** The `formField` to be created by this mutation. */
export type CvTemplateFieldMappingFormFieldIdForeignConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `formField` in the `CvTemplateFieldMappingInput` mutation. */
export type CvTemplateFieldMappingFormFieldIdForeignInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<FormFieldFormFieldPkeyConnect>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignConnectionFormFieldCreateInput>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<FormFieldOnCvTemplateFieldMappingForCvTemplateFieldMappingFormFieldIdForeignUsingFormFieldPkeyUpdate>;
};

/** Input for the nested mutation of `cvTemplateFieldMapping` in the `FormFieldInput` mutation. */
export type CvTemplateFieldMappingFormFieldIdForeignInverseInput = {
  /** The primary key(s) for `cvTemplateFieldMapping` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CvTemplateFieldMappingCvTemplateFieldMappingPkeyConnect>>;
  /** A `CvTemplateFieldMappingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CvTemplateFieldMappingFormFieldIdForeignConnectionCvTemplateFieldMappingCreateInput>>;
  /** The primary key(s) for `cvTemplateFieldMapping` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CvTemplateFieldMappingCvTemplateFieldMappingPkeyDelete>>;
  /** Flag indicating whether all other `cvTemplateFieldMapping` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `cvTemplateFieldMapping` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CvTemplateFieldMappingOnCvTemplateFieldMappingForCvTemplateFieldMappingFormFieldIdForeignUsingCvTemplateFieldMappingPkeyUpdate>>;
};

/** An input for mutations affecting `CvTemplateFieldMapping` */
export type CvTemplateFieldMappingInput = {
  company?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  cvTemplateField: Scalars['String'];
  formField?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<CvTemplateFieldMappingSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `cvTemplateFieldMapping` to look up the row to update. */
export type CvTemplateFieldMappingOnCvTemplateFieldMappingForCvTemplateFieldMappingCompanyIdForeignUsingCvTemplateFieldMappingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `cvTemplateFieldMapping` being updated. */
  patch: UpdateCvTemplateFieldMappingOnCvTemplateFieldMappingForCvTemplateFieldMappingCompanyIdForeignPatch;
};

/** The fields on `cvTemplateFieldMapping` to look up the row to update. */
export type CvTemplateFieldMappingOnCvTemplateFieldMappingForCvTemplateFieldMappingFormFieldIdForeignUsingCvTemplateFieldMappingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `cvTemplateFieldMapping` being updated. */
  patch: UpdateCvTemplateFieldMappingOnCvTemplateFieldMappingForCvTemplateFieldMappingFormFieldIdForeignPatch;
};

/** The fields on `cvTemplateFieldMapping` to look up the row to update. */
export type CvTemplateFieldMappingOnCvTemplateFieldMappingForCvTemplateFieldMappingSystemFieldIdForeignUsingCvTemplateFieldMappingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `cvTemplateFieldMapping` being updated. */
  patch: UpdateCvTemplateFieldMappingOnCvTemplateFieldMappingForCvTemplateFieldMappingSystemFieldIdForeignPatch;
};

/** Represents an update to a `CvTemplateFieldMapping`. Fields that are set will be updated. */
export type CvTemplateFieldMappingPatch = {
  company?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  cvTemplateField?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<CvTemplateFieldMappingSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** The `cvTemplateFieldMapping` to be created by this mutation. */
export type CvTemplateFieldMappingSystemFieldIdForeignConnectionCvTemplateFieldMappingCreateInput = {
  company?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  cvTemplateField: Scalars['String'];
  formField?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<CvTemplateFieldMappingSystemFieldIdForeignInput>;
};

/** Input for the nested mutation of `systemField` in the `CvTemplateFieldMappingInput` mutation. */
export type CvTemplateFieldMappingSystemFieldIdForeignInput = {
  /** The primary key(s) for `systemField` for the far side of the relationship. */
  connectById?: InputMaybe<SystemFieldSystemFieldPkeyConnect>;
  /** The primary key(s) for `systemField` for the far side of the relationship. */
  connectByName?: InputMaybe<SystemFieldSystemFieldNameUniqueConnect>;
  /** The primary key(s) and patch data for `systemField` for the far side of the relationship. */
  updateById?: InputMaybe<SystemFieldOnCvTemplateFieldMappingForCvTemplateFieldMappingSystemFieldIdForeignUsingSystemFieldPkeyUpdate>;
  /** The primary key(s) and patch data for `systemField` for the far side of the relationship. */
  updateByName?: InputMaybe<SystemFieldOnCvTemplateFieldMappingForCvTemplateFieldMappingSystemFieldIdForeignUsingSystemFieldNameUniqueUpdate>;
};

/** Input for the nested mutation of `cvTemplateFieldMapping` in the `SystemFieldInput` mutation. */
export type CvTemplateFieldMappingSystemFieldIdForeignInverseInput = {
  /** The primary key(s) for `cvTemplateFieldMapping` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CvTemplateFieldMappingCvTemplateFieldMappingPkeyConnect>>;
  /** A `CvTemplateFieldMappingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CvTemplateFieldMappingSystemFieldIdForeignConnectionCvTemplateFieldMappingCreateInput>>;
  /** The primary key(s) for `cvTemplateFieldMapping` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CvTemplateFieldMappingCvTemplateFieldMappingPkeyDelete>>;
  /** Flag indicating whether all other `cvTemplateFieldMapping` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `cvTemplateFieldMapping` for the far side of the relationship. */
  updateById?: InputMaybe<Array<CvTemplateFieldMappingOnCvTemplateFieldMappingForCvTemplateFieldMappingSystemFieldIdForeignUsingCvTemplateFieldMappingPkeyUpdate>>;
};

/** A connection to a list of `CvTemplateFieldMapping` values. */
export type CvTemplateFieldMappingsConnection = {
  __typename?: 'CvTemplateFieldMappingsConnection';
  /** A list of edges which contains the `CvTemplateFieldMapping` and cursor to aid in pagination. */
  edges: Array<CvTemplateFieldMappingsEdge>;
  /** A list of `CvTemplateFieldMapping` objects. */
  nodes: Array<Maybe<CvTemplateFieldMapping>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CvTemplateFieldMapping` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CvTemplateFieldMapping` edge in the connection. */
export type CvTemplateFieldMappingsEdge = {
  __typename?: 'CvTemplateFieldMappingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CvTemplateFieldMapping` at the end of the edge. */
  node?: Maybe<CvTemplateFieldMapping>;
};

/** Methods to use when ordering `CvTemplateFieldMapping`. */
export type CvTemplateFieldMappingsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CV_TEMPLATE_FIELD_ASC'
  | 'CV_TEMPLATE_FIELD_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_DESC'
  | 'FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ALWAYS_REQUIRED_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ALWAYS_REQUIRED_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__DOCUMENT_TEMPLATE_PLACEHOLDER_NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__DOCUMENT_TEMPLATE_PLACEHOLDER_NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__EXCLUDE_FROM_PLACEHOLDER_FORM_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__EXCLUDE_FROM_PLACEHOLDER_FORM_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ID_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ID_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READABLE_NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READABLE_NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READ_ONLY_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READ_ONLY_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__TYPE_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__TYPE_DESC'
  | 'SYSTEM_FIELD_ID_ASC'
  | 'SYSTEM_FIELD_ID_DESC';

export type DashboardCard = {
  __typename?: 'DashboardCard';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `DashboardCard`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `CustomWidget` that is related to this `DashboardCard`. */
  customWidget?: Maybe<CustomWidget>;
  customWidgetId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `DashboardCardStatistic`. */
  dashboardCardStatistics: DashboardCardStatisticsConnection;
  /** Reads a single `DashboardView` that is related to this `DashboardCard`. */
  dashboardView?: Maybe<DashboardView>;
  dashboardViewId: Scalars['UUID'];
  departmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  id: Scalars['UUID'];
  jobPositionTypeIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  order?: Maybe<Scalars['Int']>;
  type: DashboardCardType;
};


export type DashboardCardDashboardCardStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DashboardCardStatisticCondition>;
  filter?: InputMaybe<DashboardCardStatisticFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DashboardCardStatisticsOrderBy>>;
};

export type DashboardCardChartInput = {
  dashboardCardId: Scalars['UUID'];
  dashboardCardStatisticId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
};

export type DashboardCardChartPayload = {
  __typename?: 'DashboardCardChartPayload';
  data?: Maybe<Scalars['JSON']>;
};

/** The `dashboardCard` to be created by this mutation. */
export type DashboardCardCompanyIdForeignConnectionDashboardCardCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DashboardCardCompanyIdForeignInput>;
  customWidget?: InputMaybe<DashboardCardCustomWidgetIdForeignInput>;
  customWidgetId?: InputMaybe<Scalars['UUID']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInverseInput>;
  dashboardView?: InputMaybe<DashboardCardDashboardViewIdForeignInput>;
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  jobPositionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  order?: InputMaybe<Scalars['Int']>;
  type: DashboardCardType;
};

/** Input for the nested mutation of `company` in the `DashboardCardInput` mutation. */
export type DashboardCardCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnDashboardCardForDashboardCardCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `dashboardCard` in the `CompanyInput` mutation. */
export type DashboardCardCompanyIdForeignInverseInput = {
  /** The primary key(s) for `dashboardCard` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DashboardCardDashboardCardPkeyConnect>>;
  /** A `DashboardCardInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DashboardCardCompanyIdForeignConnectionDashboardCardCreateInput>>;
  /** The primary key(s) and patch data for `dashboardCard` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DashboardCardOnDashboardCardForDashboardCardCompanyIdForeignUsingDashboardCardPkeyUpdate>>;
};

/**
 * A condition to be used against `DashboardCard` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DashboardCardCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `customWidgetId` field. */
  customWidgetId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `dashboardViewId` field. */
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `jobPositionTypeIds` field. */
  jobPositionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<DashboardCardType>;
};

/** The `customWidget` to be created by this mutation. */
export type DashboardCardCustomWidgetIdForeignConnectionCustomWidgetCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  backgroundColor: Scalars['String'];
  buttonBackgroundColor: Scalars['String'];
  buttonBorder?: InputMaybe<Scalars['Boolean']>;
  buttonTextColor: Scalars['String'];
  company?: InputMaybe<CustomWidgetCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCustomWidgetIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCustomWidgetIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  imageLayout?: InputMaybe<Scalars['String']>;
  useImage?: InputMaybe<Scalars['Boolean']>;
  widgetSize?: InputMaybe<Scalars['Int']>;
  widgetTextColor: Scalars['String'];
};

/** The `dashboardCard` to be created by this mutation. */
export type DashboardCardCustomWidgetIdForeignConnectionDashboardCardCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DashboardCardCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  customWidget?: InputMaybe<DashboardCardCustomWidgetIdForeignInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInverseInput>;
  dashboardView?: InputMaybe<DashboardCardDashboardViewIdForeignInput>;
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  jobPositionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  order?: InputMaybe<Scalars['Int']>;
  type: DashboardCardType;
};

/** Input for the nested mutation of `customWidget` in the `DashboardCardInput` mutation. */
export type DashboardCardCustomWidgetIdForeignInput = {
  /** The primary key(s) for `customWidget` for the far side of the relationship. */
  connectById?: InputMaybe<CustomWidgetCustomWidgetPkeyConnect>;
  /** A `CustomWidgetInput` object that will be created and connected to this object. */
  create?: InputMaybe<DashboardCardCustomWidgetIdForeignConnectionCustomWidgetCreateInput>;
  /** The primary key(s) and patch data for `customWidget` for the far side of the relationship. */
  updateById?: InputMaybe<CustomWidgetOnDashboardCardForDashboardCardCustomWidgetIdForeignUsingCustomWidgetPkeyUpdate>;
};

/** Input for the nested mutation of `dashboardCard` in the `CustomWidgetInput` mutation. */
export type DashboardCardCustomWidgetIdForeignInverseInput = {
  /** The primary key(s) for `dashboardCard` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DashboardCardDashboardCardPkeyConnect>>;
  /** A `DashboardCardInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DashboardCardCustomWidgetIdForeignConnectionDashboardCardCreateInput>>;
  /** The primary key(s) and patch data for `dashboardCard` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DashboardCardOnDashboardCardForDashboardCardCustomWidgetIdForeignUsingDashboardCardPkeyUpdate>>;
};

/** The fields on `dashboardCard` to look up the row to connect. */
export type DashboardCardDashboardCardPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `dashboardCard` to be created by this mutation. */
export type DashboardCardDashboardViewIdForeignConnectionDashboardCardCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DashboardCardCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  customWidget?: InputMaybe<DashboardCardCustomWidgetIdForeignInput>;
  customWidgetId?: InputMaybe<Scalars['UUID']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInverseInput>;
  dashboardView?: InputMaybe<DashboardCardDashboardViewIdForeignInput>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  jobPositionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  order?: InputMaybe<Scalars['Int']>;
  type: DashboardCardType;
};

/** The `dashboardView` to be created by this mutation. */
export type DashboardCardDashboardViewIdForeignConnectionDashboardViewCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DashboardViewCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  copyDashboardViewId?: InputMaybe<Scalars['UUID']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardDashboardViewIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `dashboardView` in the `DashboardCardInput` mutation. */
export type DashboardCardDashboardViewIdForeignInput = {
  /** The primary key(s) for `dashboardView` for the far side of the relationship. */
  connectById?: InputMaybe<DashboardViewDashboardViewPkeyConnect>;
  /** A `DashboardViewInput` object that will be created and connected to this object. */
  create?: InputMaybe<DashboardCardDashboardViewIdForeignConnectionDashboardViewCreateInput>;
  /** The primary key(s) and patch data for `dashboardView` for the far side of the relationship. */
  updateById?: InputMaybe<DashboardViewOnDashboardCardForDashboardCardDashboardViewIdForeignUsingDashboardViewPkeyUpdate>;
};

/** Input for the nested mutation of `dashboardCard` in the `DashboardViewInput` mutation. */
export type DashboardCardDashboardViewIdForeignInverseInput = {
  /** The primary key(s) for `dashboardCard` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DashboardCardDashboardCardPkeyConnect>>;
  /** A `DashboardCardInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DashboardCardDashboardViewIdForeignConnectionDashboardCardCreateInput>>;
  /** The primary key(s) and patch data for `dashboardCard` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DashboardCardOnDashboardCardForDashboardCardDashboardViewIdForeignUsingDashboardCardPkeyUpdate>>;
};

/** A filter to be used against `DashboardCard` object types. All fields are combined with a logical ‘and.’ */
export type DashboardCardFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DashboardCardFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `customWidget` relation. */
  customWidget?: InputMaybe<CustomWidgetFilter>;
  /** A related `customWidget` exists. */
  customWidgetExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `customWidgetId` field. */
  customWidgetId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `dashboardCardStatistics` relation. */
  dashboardCardStatistics?: InputMaybe<DashboardCardToManyDashboardCardStatisticFilter>;
  /** Some related `dashboardCardStatistics` exist. */
  dashboardCardStatisticsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `dashboardView` relation. */
  dashboardView?: InputMaybe<DashboardViewFilter>;
  /** Filter by the object’s `dashboardViewId` field. */
  dashboardViewId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `jobPositionTypeIds` field. */
  jobPositionTypeIds?: InputMaybe<UuidListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DashboardCardFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DashboardCardFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<DashboardCardTypeFilter>;
};

/** An input for mutations affecting `DashboardCard` */
export type DashboardCardInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DashboardCardCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  customWidget?: InputMaybe<DashboardCardCustomWidgetIdForeignInput>;
  customWidgetId?: InputMaybe<Scalars['UUID']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInverseInput>;
  dashboardView?: InputMaybe<DashboardCardDashboardViewIdForeignInput>;
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  jobPositionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  order?: InputMaybe<Scalars['Int']>;
  type: DashboardCardType;
};

/** The fields on `dashboardCard` to look up the row to update. */
export type DashboardCardOnDashboardCardForDashboardCardCompanyIdForeignUsingDashboardCardPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `dashboardCard` being updated. */
  patch: UpdateDashboardCardOnDashboardCardForDashboardCardCompanyIdForeignPatch;
};

/** The fields on `dashboardCard` to look up the row to update. */
export type DashboardCardOnDashboardCardForDashboardCardCustomWidgetIdForeignUsingDashboardCardPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `dashboardCard` being updated. */
  patch: UpdateDashboardCardOnDashboardCardForDashboardCardCustomWidgetIdForeignPatch;
};

/** The fields on `dashboardCard` to look up the row to update. */
export type DashboardCardOnDashboardCardForDashboardCardDashboardViewIdForeignUsingDashboardCardPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `dashboardCard` being updated. */
  patch: UpdateDashboardCardOnDashboardCardForDashboardCardDashboardViewIdForeignPatch;
};

/** The fields on `dashboardCard` to look up the row to update. */
export type DashboardCardOnDashboardCardStatisticForDashboardCardStatisticDashboardCardIdForeignUsingDashboardCardPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `dashboardCard` being updated. */
  patch: UpdateDashboardCardOnDashboardCardStatisticForDashboardCardStatisticDashboardCardIdForeignPatch;
};

/** Represents an update to a `DashboardCard`. Fields that are set will be updated. */
export type DashboardCardPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DashboardCardCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  customWidget?: InputMaybe<DashboardCardCustomWidgetIdForeignInput>;
  customWidgetId?: InputMaybe<Scalars['UUID']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInverseInput>;
  dashboardView?: InputMaybe<DashboardCardDashboardViewIdForeignInput>;
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  jobPositionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  order?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<DashboardCardType>;
};

export type DashboardCardStatistic = {
  __typename?: 'DashboardCardStatistic';
  active: Scalars['Boolean'];
  chartType: DashboardCardStatisticChartType;
  /** Reads a single `Company` that is related to this `DashboardCardStatistic`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `DashboardCard` that is related to this `DashboardCardStatistic`. */
  dashboardCard?: Maybe<DashboardCard>;
  dashboardCardId: Scalars['UUID'];
  /** Reads a single `DashboardView` that is related to this `DashboardCardStatistic`. */
  dashboardView?: Maybe<DashboardView>;
  dashboardViewId: Scalars['UUID'];
  /** Reads a single `FormField` that is related to this `DashboardCardStatistic`. */
  formField?: Maybe<FormField>;
  formFieldId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  order?: Maybe<Scalars['Int']>;
  /** Reads a single `SystemField` that is related to this `DashboardCardStatistic`. */
  systemField?: Maybe<SystemField>;
  systemFieldId?: Maybe<Scalars['UUID']>;
};

export type DashboardCardStatisticChartType =
  | 'BAR'
  | 'DONUT';

/** A filter to be used against DashboardCardStatisticChartType fields. All fields are combined with a logical ‘and.’ */
export type DashboardCardStatisticChartTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DashboardCardStatisticChartType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DashboardCardStatisticChartType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DashboardCardStatisticChartType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DashboardCardStatisticChartType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DashboardCardStatisticChartType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DashboardCardStatisticChartType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DashboardCardStatisticChartType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DashboardCardStatisticChartType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DashboardCardStatisticChartType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DashboardCardStatisticChartType>>;
};

/** The `dashboardCardStatistic` to be created by this mutation. */
export type DashboardCardStatisticCompanyIdForeignConnectionDashboardCardStatisticCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  chartType: DashboardCardStatisticChartType;
  company?: InputMaybe<DashboardCardStatisticCompanyIdForeignInput>;
  dashboardCard?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInput>;
  dashboardCardId?: InputMaybe<Scalars['UUID']>;
  dashboardView?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInput>;
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  systemField?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `DashboardCardStatisticInput` mutation. */
export type DashboardCardStatisticCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnDashboardCardStatisticForDashboardCardStatisticCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `dashboardCardStatistic` in the `CompanyInput` mutation. */
export type DashboardCardStatisticCompanyIdForeignInverseInput = {
  /** The primary key(s) for `dashboardCardStatistic` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DashboardCardStatisticDashboardCardStatisticPkeyConnect>>;
  /** A `DashboardCardStatisticInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DashboardCardStatisticCompanyIdForeignConnectionDashboardCardStatisticCreateInput>>;
  /** The primary key(s) and patch data for `dashboardCardStatistic` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticCompanyIdForeignUsingDashboardCardStatisticPkeyUpdate>>;
};

/**
 * A condition to be used against `DashboardCardStatistic` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DashboardCardStatisticCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `chartType` field. */
  chartType?: InputMaybe<DashboardCardStatisticChartType>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `dashboardCardId` field. */
  dashboardCardId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `dashboardViewId` field. */
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `systemFieldId` field. */
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** The `dashboardCard` to be created by this mutation. */
export type DashboardCardStatisticDashboardCardIdForeignConnectionDashboardCardCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DashboardCardCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  customWidget?: InputMaybe<DashboardCardCustomWidgetIdForeignInput>;
  customWidgetId?: InputMaybe<Scalars['UUID']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInverseInput>;
  dashboardView?: InputMaybe<DashboardCardDashboardViewIdForeignInput>;
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  jobPositionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  order?: InputMaybe<Scalars['Int']>;
  type: DashboardCardType;
};

/** The `dashboardCardStatistic` to be created by this mutation. */
export type DashboardCardStatisticDashboardCardIdForeignConnectionDashboardCardStatisticCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  chartType: DashboardCardStatisticChartType;
  company?: InputMaybe<DashboardCardStatisticCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dashboardCard?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInput>;
  dashboardView?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInput>;
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  systemField?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `dashboardCard` in the `DashboardCardStatisticInput` mutation. */
export type DashboardCardStatisticDashboardCardIdForeignInput = {
  /** The primary key(s) for `dashboardCard` for the far side of the relationship. */
  connectById?: InputMaybe<DashboardCardDashboardCardPkeyConnect>;
  /** A `DashboardCardInput` object that will be created and connected to this object. */
  create?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignConnectionDashboardCardCreateInput>;
  /** The primary key(s) and patch data for `dashboardCard` for the far side of the relationship. */
  updateById?: InputMaybe<DashboardCardOnDashboardCardStatisticForDashboardCardStatisticDashboardCardIdForeignUsingDashboardCardPkeyUpdate>;
};

/** Input for the nested mutation of `dashboardCardStatistic` in the `DashboardCardInput` mutation. */
export type DashboardCardStatisticDashboardCardIdForeignInverseInput = {
  /** The primary key(s) for `dashboardCardStatistic` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DashboardCardStatisticDashboardCardStatisticPkeyConnect>>;
  /** A `DashboardCardStatisticInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DashboardCardStatisticDashboardCardIdForeignConnectionDashboardCardStatisticCreateInput>>;
  /** The primary key(s) and patch data for `dashboardCardStatistic` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticDashboardCardIdForeignUsingDashboardCardStatisticPkeyUpdate>>;
};

/** The fields on `dashboardCardStatistic` to look up the row to connect. */
export type DashboardCardStatisticDashboardCardStatisticPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `dashboardCardStatistic` to be created by this mutation. */
export type DashboardCardStatisticDashboardViewIdForeignConnectionDashboardCardStatisticCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  chartType: DashboardCardStatisticChartType;
  company?: InputMaybe<DashboardCardStatisticCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dashboardCard?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInput>;
  dashboardCardId?: InputMaybe<Scalars['UUID']>;
  dashboardView?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInput>;
  formField?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  systemField?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** The `dashboardView` to be created by this mutation. */
export type DashboardCardStatisticDashboardViewIdForeignConnectionDashboardViewCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DashboardViewCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  copyDashboardViewId?: InputMaybe<Scalars['UUID']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardDashboardViewIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `dashboardView` in the `DashboardCardStatisticInput` mutation. */
export type DashboardCardStatisticDashboardViewIdForeignInput = {
  /** The primary key(s) for `dashboardView` for the far side of the relationship. */
  connectById?: InputMaybe<DashboardViewDashboardViewPkeyConnect>;
  /** A `DashboardViewInput` object that will be created and connected to this object. */
  create?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignConnectionDashboardViewCreateInput>;
  /** The primary key(s) and patch data for `dashboardView` for the far side of the relationship. */
  updateById?: InputMaybe<DashboardViewOnDashboardCardStatisticForDashboardCardStatisticDashboardViewIdForeignUsingDashboardViewPkeyUpdate>;
};

/** Input for the nested mutation of `dashboardCardStatistic` in the `DashboardViewInput` mutation. */
export type DashboardCardStatisticDashboardViewIdForeignInverseInput = {
  /** The primary key(s) for `dashboardCardStatistic` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DashboardCardStatisticDashboardCardStatisticPkeyConnect>>;
  /** A `DashboardCardStatisticInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DashboardCardStatisticDashboardViewIdForeignConnectionDashboardCardStatisticCreateInput>>;
  /** The primary key(s) and patch data for `dashboardCardStatistic` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticDashboardViewIdForeignUsingDashboardCardStatisticPkeyUpdate>>;
};

/** A filter to be used against `DashboardCardStatistic` object types. All fields are combined with a logical ‘and.’ */
export type DashboardCardStatisticFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DashboardCardStatisticFilter>>;
  /** Filter by the object’s `chartType` field. */
  chartType?: InputMaybe<DashboardCardStatisticChartTypeFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `dashboardCard` relation. */
  dashboardCard?: InputMaybe<DashboardCardFilter>;
  /** Filter by the object’s `dashboardCardId` field. */
  dashboardCardId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `dashboardView` relation. */
  dashboardView?: InputMaybe<DashboardViewFilter>;
  /** Filter by the object’s `dashboardViewId` field. */
  dashboardViewId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `formField` relation. */
  formField?: InputMaybe<FormFieldFilter>;
  /** A related `formField` exists. */
  formFieldExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DashboardCardStatisticFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DashboardCardStatisticFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `systemField` relation. */
  systemField?: InputMaybe<SystemFieldFilter>;
  /** A related `systemField` exists. */
  systemFieldExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `systemFieldId` field. */
  systemFieldId?: InputMaybe<UuidFilter>;
};

/** The `dashboardCardStatistic` to be created by this mutation. */
export type DashboardCardStatisticFormFieldIdForeignConnectionDashboardCardStatisticCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  chartType: DashboardCardStatisticChartType;
  company?: InputMaybe<DashboardCardStatisticCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dashboardCard?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInput>;
  dashboardCardId?: InputMaybe<Scalars['UUID']>;
  dashboardView?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInput>;
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  systemField?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** The `formField` to be created by this mutation. */
export type DashboardCardStatisticFormFieldIdForeignConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `formField` in the `DashboardCardStatisticInput` mutation. */
export type DashboardCardStatisticFormFieldIdForeignInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<FormFieldFormFieldPkeyConnect>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<DashboardCardStatisticFormFieldIdForeignConnectionFormFieldCreateInput>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<FormFieldOnDashboardCardStatisticForDashboardCardStatisticFormFieldIdForeignUsingFormFieldPkeyUpdate>;
};

/** Input for the nested mutation of `dashboardCardStatistic` in the `FormFieldInput` mutation. */
export type DashboardCardStatisticFormFieldIdForeignInverseInput = {
  /** The primary key(s) for `dashboardCardStatistic` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DashboardCardStatisticDashboardCardStatisticPkeyConnect>>;
  /** A `DashboardCardStatisticInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DashboardCardStatisticFormFieldIdForeignConnectionDashboardCardStatisticCreateInput>>;
  /** The primary key(s) and patch data for `dashboardCardStatistic` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticFormFieldIdForeignUsingDashboardCardStatisticPkeyUpdate>>;
};

/** An input for mutations affecting `DashboardCardStatistic` */
export type DashboardCardStatisticInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  chartType: DashboardCardStatisticChartType;
  company?: InputMaybe<DashboardCardStatisticCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dashboardCard?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInput>;
  dashboardCardId?: InputMaybe<Scalars['UUID']>;
  dashboardView?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInput>;
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  systemField?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `dashboardCardStatistic` to look up the row to update. */
export type DashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticCompanyIdForeignUsingDashboardCardStatisticPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `dashboardCardStatistic` being updated. */
  patch: UpdateDashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticCompanyIdForeignPatch;
};

/** The fields on `dashboardCardStatistic` to look up the row to update. */
export type DashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticDashboardCardIdForeignUsingDashboardCardStatisticPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `dashboardCardStatistic` being updated. */
  patch: UpdateDashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticDashboardCardIdForeignPatch;
};

/** The fields on `dashboardCardStatistic` to look up the row to update. */
export type DashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticDashboardViewIdForeignUsingDashboardCardStatisticPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `dashboardCardStatistic` being updated. */
  patch: UpdateDashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticDashboardViewIdForeignPatch;
};

/** The fields on `dashboardCardStatistic` to look up the row to update. */
export type DashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticFormFieldIdForeignUsingDashboardCardStatisticPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `dashboardCardStatistic` being updated. */
  patch: UpdateDashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticFormFieldIdForeignPatch;
};

/** The fields on `dashboardCardStatistic` to look up the row to update. */
export type DashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticSystemFieldIdForeignUsingDashboardCardStatisticPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `dashboardCardStatistic` being updated. */
  patch: UpdateDashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticSystemFieldIdForeignPatch;
};

/** Represents an update to a `DashboardCardStatistic`. Fields that are set will be updated. */
export type DashboardCardStatisticPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  chartType?: InputMaybe<DashboardCardStatisticChartType>;
  company?: InputMaybe<DashboardCardStatisticCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dashboardCard?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInput>;
  dashboardCardId?: InputMaybe<Scalars['UUID']>;
  dashboardView?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInput>;
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  systemField?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** The `dashboardCardStatistic` to be created by this mutation. */
export type DashboardCardStatisticSystemFieldIdForeignConnectionDashboardCardStatisticCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  chartType: DashboardCardStatisticChartType;
  company?: InputMaybe<DashboardCardStatisticCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dashboardCard?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInput>;
  dashboardCardId?: InputMaybe<Scalars['UUID']>;
  dashboardView?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInput>;
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  systemField?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInput>;
};

/** Input for the nested mutation of `systemField` in the `DashboardCardStatisticInput` mutation. */
export type DashboardCardStatisticSystemFieldIdForeignInput = {
  /** The primary key(s) for `systemField` for the far side of the relationship. */
  connectById?: InputMaybe<SystemFieldSystemFieldPkeyConnect>;
  /** The primary key(s) for `systemField` for the far side of the relationship. */
  connectByName?: InputMaybe<SystemFieldSystemFieldNameUniqueConnect>;
  /** The primary key(s) and patch data for `systemField` for the far side of the relationship. */
  updateById?: InputMaybe<SystemFieldOnDashboardCardStatisticForDashboardCardStatisticSystemFieldIdForeignUsingSystemFieldPkeyUpdate>;
  /** The primary key(s) and patch data for `systemField` for the far side of the relationship. */
  updateByName?: InputMaybe<SystemFieldOnDashboardCardStatisticForDashboardCardStatisticSystemFieldIdForeignUsingSystemFieldNameUniqueUpdate>;
};

/** Input for the nested mutation of `dashboardCardStatistic` in the `SystemFieldInput` mutation. */
export type DashboardCardStatisticSystemFieldIdForeignInverseInput = {
  /** The primary key(s) for `dashboardCardStatistic` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DashboardCardStatisticDashboardCardStatisticPkeyConnect>>;
  /** A `DashboardCardStatisticInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DashboardCardStatisticSystemFieldIdForeignConnectionDashboardCardStatisticCreateInput>>;
  /** The primary key(s) and patch data for `dashboardCardStatistic` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticSystemFieldIdForeignUsingDashboardCardStatisticPkeyUpdate>>;
};

/** A connection to a list of `DashboardCardStatistic` values. */
export type DashboardCardStatisticsConnection = {
  __typename?: 'DashboardCardStatisticsConnection';
  /** A list of edges which contains the `DashboardCardStatistic` and cursor to aid in pagination. */
  edges: Array<DashboardCardStatisticsEdge>;
  /** A list of `DashboardCardStatistic` objects. */
  nodes: Array<Maybe<DashboardCardStatistic>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DashboardCardStatistic` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DashboardCardStatistic` edge in the connection. */
export type DashboardCardStatisticsEdge = {
  __typename?: 'DashboardCardStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DashboardCardStatistic` at the end of the edge. */
  node?: Maybe<DashboardCardStatistic>;
};

/** Methods to use when ordering `DashboardCardStatistic`. */
export type DashboardCardStatisticsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'CHART_TYPE_ASC'
  | 'CHART_TYPE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DASHBOARD_CARD_BY_DASHBOARD_CARD_ID__ACTIVE_ASC'
  | 'DASHBOARD_CARD_BY_DASHBOARD_CARD_ID__ACTIVE_DESC'
  | 'DASHBOARD_CARD_BY_DASHBOARD_CARD_ID__COMPANY_ID_ASC'
  | 'DASHBOARD_CARD_BY_DASHBOARD_CARD_ID__COMPANY_ID_DESC'
  | 'DASHBOARD_CARD_BY_DASHBOARD_CARD_ID__CUSTOM_WIDGET_ID_ASC'
  | 'DASHBOARD_CARD_BY_DASHBOARD_CARD_ID__CUSTOM_WIDGET_ID_DESC'
  | 'DASHBOARD_CARD_BY_DASHBOARD_CARD_ID__DASHBOARD_VIEW_ID_ASC'
  | 'DASHBOARD_CARD_BY_DASHBOARD_CARD_ID__DASHBOARD_VIEW_ID_DESC'
  | 'DASHBOARD_CARD_BY_DASHBOARD_CARD_ID__DEPARTMENT_IDS_ASC'
  | 'DASHBOARD_CARD_BY_DASHBOARD_CARD_ID__DEPARTMENT_IDS_DESC'
  | 'DASHBOARD_CARD_BY_DASHBOARD_CARD_ID__ID_ASC'
  | 'DASHBOARD_CARD_BY_DASHBOARD_CARD_ID__ID_DESC'
  | 'DASHBOARD_CARD_BY_DASHBOARD_CARD_ID__JOB_POSITION_TYPE_IDS_ASC'
  | 'DASHBOARD_CARD_BY_DASHBOARD_CARD_ID__JOB_POSITION_TYPE_IDS_DESC'
  | 'DASHBOARD_CARD_BY_DASHBOARD_CARD_ID__ORDER_ASC'
  | 'DASHBOARD_CARD_BY_DASHBOARD_CARD_ID__ORDER_DESC'
  | 'DASHBOARD_CARD_BY_DASHBOARD_CARD_ID__TYPE_ASC'
  | 'DASHBOARD_CARD_BY_DASHBOARD_CARD_ID__TYPE_DESC'
  | 'DASHBOARD_CARD_ID_ASC'
  | 'DASHBOARD_CARD_ID_DESC'
  | 'DASHBOARD_VIEW_BY_DASHBOARD_VIEW_ID__ACTIVE_ASC'
  | 'DASHBOARD_VIEW_BY_DASHBOARD_VIEW_ID__ACTIVE_DESC'
  | 'DASHBOARD_VIEW_BY_DASHBOARD_VIEW_ID__COMPANY_ID_ASC'
  | 'DASHBOARD_VIEW_BY_DASHBOARD_VIEW_ID__COMPANY_ID_DESC'
  | 'DASHBOARD_VIEW_BY_DASHBOARD_VIEW_ID__ID_ASC'
  | 'DASHBOARD_VIEW_BY_DASHBOARD_VIEW_ID__ID_DESC'
  | 'DASHBOARD_VIEW_BY_DASHBOARD_VIEW_ID__NAME_ASC'
  | 'DASHBOARD_VIEW_BY_DASHBOARD_VIEW_ID__NAME_DESC'
  | 'DASHBOARD_VIEW_ID_ASC'
  | 'DASHBOARD_VIEW_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_DESC'
  | 'FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ALWAYS_REQUIRED_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ALWAYS_REQUIRED_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__DOCUMENT_TEMPLATE_PLACEHOLDER_NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__DOCUMENT_TEMPLATE_PLACEHOLDER_NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__EXCLUDE_FROM_PLACEHOLDER_FORM_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__EXCLUDE_FROM_PLACEHOLDER_FORM_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ID_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ID_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READABLE_NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READABLE_NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READ_ONLY_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READ_ONLY_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__TYPE_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__TYPE_DESC'
  | 'SYSTEM_FIELD_ID_ASC'
  | 'SYSTEM_FIELD_ID_DESC';

/** A filter to be used against many `DashboardCardStatistic` object types. All fields are combined with a logical ‘and.’ */
export type DashboardCardToManyDashboardCardStatisticFilter = {
  /** Every related `DashboardCardStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DashboardCardStatisticFilter>;
  /** No related `DashboardCardStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DashboardCardStatisticFilter>;
  /** Some related `DashboardCardStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DashboardCardStatisticFilter>;
};

export type DashboardCardType =
  /** Calendar */
  | 'CALENDAR'
  /** Company growth */
  | 'COMPANY_GROWTH'
  /** Custom widget */
  | 'CUSTOM_WIDGET'
  /** Pending engagements */
  | 'ENGAGEMENTS'
  /** Expiring documents */
  | 'EXPIRING_DOCUMENTS'
  /** Statistics */
  | 'STATISTICS'
  /** Tasks widget */
  | 'TASKS'
  /** Unsigned documents widget */
  | 'UNSIGNED_DOCUMENTS'
  /** Vacation & absence */
  | 'VACATION';

/** A filter to be used against DashboardCardType fields. All fields are combined with a logical ‘and.’ */
export type DashboardCardTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DashboardCardType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DashboardCardType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DashboardCardType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DashboardCardType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DashboardCardType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DashboardCardType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DashboardCardType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DashboardCardType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DashboardCardType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DashboardCardType>>;
};

/** A connection to a list of `DashboardCard` values. */
export type DashboardCardsConnection = {
  __typename?: 'DashboardCardsConnection';
  /** A list of edges which contains the `DashboardCard` and cursor to aid in pagination. */
  edges: Array<DashboardCardsEdge>;
  /** A list of `DashboardCard` objects. */
  nodes: Array<Maybe<DashboardCard>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DashboardCard` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DashboardCard` edge in the connection. */
export type DashboardCardsEdge = {
  __typename?: 'DashboardCardsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DashboardCard` at the end of the edge. */
  node?: Maybe<DashboardCard>;
};

/** Methods to use when ordering `DashboardCard`. */
export type DashboardCardsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__ACTIVE_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__ACTIVE_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__BACKGROUND_COLOR_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__BACKGROUND_COLOR_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__BUTTON_BACKGROUND_COLOR_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__BUTTON_BACKGROUND_COLOR_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__BUTTON_BORDER_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__BUTTON_BORDER_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__BUTTON_TEXT_COLOR_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__BUTTON_TEXT_COLOR_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__COMPANY_ID_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__COMPANY_ID_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__ID_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__ID_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__IMAGE_LAYOUT_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__IMAGE_LAYOUT_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__USE_IMAGE_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__USE_IMAGE_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__WIDGET_SIZE_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__WIDGET_SIZE_DESC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__WIDGET_TEXT_COLOR_ASC'
  | 'CUSTOM_WIDGET_BY_CUSTOM_WIDGET_ID__WIDGET_TEXT_COLOR_DESC'
  | 'CUSTOM_WIDGET_ID_ASC'
  | 'CUSTOM_WIDGET_ID_DESC'
  | 'DASHBOARD_CARD_STATISTICS_BY_DASHBOARD_CARD_ID__COUNT_ASC'
  | 'DASHBOARD_CARD_STATISTICS_BY_DASHBOARD_CARD_ID__COUNT_DESC'
  | 'DASHBOARD_VIEW_BY_DASHBOARD_VIEW_ID__ACTIVE_ASC'
  | 'DASHBOARD_VIEW_BY_DASHBOARD_VIEW_ID__ACTIVE_DESC'
  | 'DASHBOARD_VIEW_BY_DASHBOARD_VIEW_ID__COMPANY_ID_ASC'
  | 'DASHBOARD_VIEW_BY_DASHBOARD_VIEW_ID__COMPANY_ID_DESC'
  | 'DASHBOARD_VIEW_BY_DASHBOARD_VIEW_ID__ID_ASC'
  | 'DASHBOARD_VIEW_BY_DASHBOARD_VIEW_ID__ID_DESC'
  | 'DASHBOARD_VIEW_BY_DASHBOARD_VIEW_ID__NAME_ASC'
  | 'DASHBOARD_VIEW_BY_DASHBOARD_VIEW_ID__NAME_DESC'
  | 'DASHBOARD_VIEW_ID_ASC'
  | 'DASHBOARD_VIEW_ID_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'JOB_POSITION_TYPE_IDS_ASC'
  | 'JOB_POSITION_TYPE_IDS_DESC'
  | 'NATURAL'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

export type DashboardConfig = {
  __typename?: 'DashboardConfig';
  /** Reads a single `Company` that is related to this `DashboardConfig`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  localizedPageTitle?: Maybe<Scalars['String']>;
  pageTitle: Scalars['String'];
};

/** The `dashboardConfig` to be created by this mutation. */
export type DashboardConfigCompanyIdForeignConnectionDashboardConfigCreateInput = {
  company?: InputMaybe<DashboardConfigCompanyIdForeignInput>;
  pageTitle?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `company` in the `DashboardConfigInput` mutation. */
export type DashboardConfigCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnDashboardConfigForDashboardConfigCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `dashboardConfig` in the `CompanyInput` mutation. */
export type DashboardConfigCompanyIdForeignInverseInput = {
  /** The primary key(s) for `dashboardConfig` for the far side of the relationship. */
  connectByCompanyId?: InputMaybe<DashboardConfigDashboardConfigPkeyConnect>;
  /** A `DashboardConfigInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DashboardConfigCompanyIdForeignConnectionDashboardConfigCreateInput>>;
  /** The primary key(s) for `dashboardConfig` for the far side of the relationship. */
  deleteByCompanyId?: InputMaybe<DashboardConfigDashboardConfigPkeyDelete>;
  /** Flag indicating whether all other `dashboardConfig` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `dashboardConfig` for the far side of the relationship. */
  updateByCompanyId?: InputMaybe<DashboardConfigOnDashboardConfigForDashboardConfigCompanyIdForeignUsingDashboardConfigPkeyUpdate>;
};

/**
 * A condition to be used against `DashboardConfig` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DashboardConfigCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `pageTitle` field. */
  pageTitle?: InputMaybe<Scalars['String']>;
};

/** The fields on `dashboardConfig` to look up the row to connect. */
export type DashboardConfigDashboardConfigPkeyConnect = {
  companyId: Scalars['UUID'];
};

/** The fields on `dashboardConfig` to look up the row to delete. */
export type DashboardConfigDashboardConfigPkeyDelete = {
  companyId: Scalars['UUID'];
};

/** A filter to be used against `DashboardConfig` object types. All fields are combined with a logical ‘and.’ */
export type DashboardConfigFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DashboardConfigFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedPageTitle` field. */
  localizedPageTitle?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DashboardConfigFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DashboardConfigFilter>>;
  /** Filter by the object’s `pageTitle` field. */
  pageTitle?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `DashboardConfig` */
export type DashboardConfigInput = {
  company?: InputMaybe<DashboardConfigCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  pageTitle?: InputMaybe<Scalars['String']>;
};

/** The fields on `dashboardConfig` to look up the row to update. */
export type DashboardConfigOnDashboardConfigForDashboardConfigCompanyIdForeignUsingDashboardConfigPkeyUpdate = {
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `dashboardConfig` being updated. */
  patch: UpdateDashboardConfigOnDashboardConfigForDashboardConfigCompanyIdForeignPatch;
};

/** Represents an update to a `DashboardConfig`. Fields that are set will be updated. */
export type DashboardConfigPatch = {
  company?: InputMaybe<DashboardConfigCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  pageTitle?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `DashboardConfig` values. */
export type DashboardConfigsConnection = {
  __typename?: 'DashboardConfigsConnection';
  /** A list of edges which contains the `DashboardConfig` and cursor to aid in pagination. */
  edges: Array<DashboardConfigsEdge>;
  /** A list of `DashboardConfig` objects. */
  nodes: Array<Maybe<DashboardConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DashboardConfig` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DashboardConfig` edge in the connection. */
export type DashboardConfigsEdge = {
  __typename?: 'DashboardConfigsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DashboardConfig` at the end of the edge. */
  node?: Maybe<DashboardConfig>;
};

/** Methods to use when ordering `DashboardConfig`. */
export type DashboardConfigsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'NATURAL'
  | 'PAGE_TITLE_ASC'
  | 'PAGE_TITLE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type DashboardView = {
  __typename?: 'DashboardView';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `DashboardView`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `DashboardCardStatistic`. */
  dashboardCardStatistics: DashboardCardStatisticsConnection;
  /** Reads and enables pagination through a set of `DashboardCard`. */
  dashboardCards: DashboardCardsConnection;
  id: Scalars['UUID'];
  name: Scalars['String'];
};


export type DashboardViewDashboardCardStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DashboardCardStatisticCondition>;
  filter?: InputMaybe<DashboardCardStatisticFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DashboardCardStatisticsOrderBy>>;
};


export type DashboardViewDashboardCardsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DashboardCardCondition>;
  filter?: InputMaybe<DashboardCardFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DashboardCardsOrderBy>>;
};

/** The `dashboardView` to be created by this mutation. */
export type DashboardViewCompanyIdForeignConnectionDashboardViewCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DashboardViewCompanyIdForeignInput>;
  copyDashboardViewId?: InputMaybe<Scalars['UUID']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardDashboardViewIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `company` in the `DashboardViewInput` mutation. */
export type DashboardViewCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnDashboardViewForDashboardViewCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `dashboardView` in the `CompanyInput` mutation. */
export type DashboardViewCompanyIdForeignInverseInput = {
  /** The primary key(s) for `dashboardView` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DashboardViewDashboardViewPkeyConnect>>;
  /** A `DashboardViewInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DashboardViewCompanyIdForeignConnectionDashboardViewCreateInput>>;
  /** The primary key(s) and patch data for `dashboardView` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DashboardViewOnDashboardViewForDashboardViewCompanyIdForeignUsingDashboardViewPkeyUpdate>>;
};

/**
 * A condition to be used against `DashboardView` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DashboardViewCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** The fields on `dashboardView` to look up the row to connect. */
export type DashboardViewDashboardViewPkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against `DashboardView` object types. All fields are combined with a logical ‘and.’ */
export type DashboardViewFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DashboardViewFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `dashboardCardStatistics` relation. */
  dashboardCardStatistics?: InputMaybe<DashboardViewToManyDashboardCardStatisticFilter>;
  /** Some related `dashboardCardStatistics` exist. */
  dashboardCardStatisticsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `dashboardCards` relation. */
  dashboardCards?: InputMaybe<DashboardViewToManyDashboardCardFilter>;
  /** Some related `dashboardCards` exist. */
  dashboardCardsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DashboardViewFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DashboardViewFilter>>;
};

/** An input for mutations affecting `DashboardView` */
export type DashboardViewInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DashboardViewCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  copyDashboardViewId?: InputMaybe<Scalars['UUID']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardDashboardViewIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The fields on `dashboardView` to look up the row to update. */
export type DashboardViewOnDashboardCardForDashboardCardDashboardViewIdForeignUsingDashboardViewPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `dashboardView` being updated. */
  patch: UpdateDashboardViewOnDashboardCardForDashboardCardDashboardViewIdForeignPatch;
};

/** The fields on `dashboardView` to look up the row to update. */
export type DashboardViewOnDashboardCardStatisticForDashboardCardStatisticDashboardViewIdForeignUsingDashboardViewPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `dashboardView` being updated. */
  patch: UpdateDashboardViewOnDashboardCardStatisticForDashboardCardStatisticDashboardViewIdForeignPatch;
};

/** The fields on `dashboardView` to look up the row to update. */
export type DashboardViewOnDashboardViewForDashboardViewCompanyIdForeignUsingDashboardViewPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `dashboardView` being updated. */
  patch: UpdateDashboardViewOnDashboardViewForDashboardViewCompanyIdForeignPatch;
};

/** Represents an update to a `DashboardView`. Fields that are set will be updated. */
export type DashboardViewPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DashboardViewCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardDashboardViewIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against many `DashboardCard` object types. All fields are combined with a logical ‘and.’ */
export type DashboardViewToManyDashboardCardFilter = {
  /** Every related `DashboardCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DashboardCardFilter>;
  /** No related `DashboardCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DashboardCardFilter>;
  /** Some related `DashboardCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DashboardCardFilter>;
};

/** A filter to be used against many `DashboardCardStatistic` object types. All fields are combined with a logical ‘and.’ */
export type DashboardViewToManyDashboardCardStatisticFilter = {
  /** Every related `DashboardCardStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DashboardCardStatisticFilter>;
  /** No related `DashboardCardStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DashboardCardStatisticFilter>;
  /** Some related `DashboardCardStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DashboardCardStatisticFilter>;
};

/** A connection to a list of `DashboardView` values. */
export type DashboardViewsConnection = {
  __typename?: 'DashboardViewsConnection';
  /** A list of edges which contains the `DashboardView` and cursor to aid in pagination. */
  edges: Array<DashboardViewsEdge>;
  /** A list of `DashboardView` objects. */
  nodes: Array<Maybe<DashboardView>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DashboardView` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DashboardView` edge in the connection. */
export type DashboardViewsEdge = {
  __typename?: 'DashboardViewsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DashboardView` at the end of the edge. */
  node?: Maybe<DashboardView>;
};

/** Methods to use when ordering `DashboardView`. */
export type DashboardViewsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DASHBOARD_CARDS_BY_DASHBOARD_VIEW_ID__COUNT_ASC'
  | 'DASHBOARD_CARDS_BY_DASHBOARD_VIEW_ID__COUNT_DESC'
  | 'DASHBOARD_CARD_STATISTICS_BY_DASHBOARD_VIEW_ID__COUNT_ASC'
  | 'DASHBOARD_CARD_STATISTICS_BY_DASHBOARD_VIEW_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/** A filter to be used against Date fields. All fields are combined with a logical ‘and.’ */
export type DateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Date']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Date']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Date']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Date']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Date']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Date']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Date']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Date']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Date']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Date']>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']>>;
};

/** All input for the `deactivateOldCompanyLogo` mutation. */
export type DeactivateOldCompanyLogoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
};

/** The output of our `deactivateOldCompanyLogo` mutation. */
export type DeactivateOldCompanyLogoPayload = {
  __typename?: 'DeactivateOldCompanyLogoPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deactivateOldContractsOnSign` mutation. */
export type DeactivateOldContractsOnSignInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `deactivateOldContractsOnSign` mutation. */
export type DeactivateOldContractsOnSignPayload = {
  __typename?: 'DeactivateOldContractsOnSignPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteAllCompanyEmployeeNotifications` mutation. */
export type DeleteAllCompanyEmployeeNotificationsInput = {
  argCompanyId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `deleteAllCompanyEmployeeNotifications` mutation. */
export type DeleteAllCompanyEmployeeNotificationsPayload = {
  __typename?: 'DeleteAllCompanyEmployeeNotificationsPayload';
  boolean?: Maybe<Scalars['Boolean']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteAuthAppTypeById` mutation. */
export type DeleteAuthAppTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `AuthAppType` mutation. */
export type DeleteAuthAppTypePayload = {
  __typename?: 'DeleteAuthAppTypePayload';
  /** The `AuthAppType` that was deleted by this mutation. */
  authAppType?: Maybe<AuthAppType>;
  /** An edge for our `AuthAppType`. May be used by Relay 1. */
  authAppTypeEdge?: Maybe<AuthAppTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAuthAppTypeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AuthAppType` mutation. */
export type DeleteAuthAppTypePayloadAuthAppTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<AuthAppTypesOrderBy>>;
};

/** All input for the `deleteAuthCodeById` mutation. */
export type DeleteAuthCodeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

/** The output of our delete `AuthCode` mutation. */
export type DeleteAuthCodePayload = {
  __typename?: 'DeleteAuthCodePayload';
  /** The `AuthCode` that was deleted by this mutation. */
  authCode?: Maybe<AuthCode>;
  /** An edge for our `AuthCode`. May be used by Relay 1. */
  authCodeEdge?: Maybe<AuthCodesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAuthCodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AuthCode` mutation. */
export type DeleteAuthCodePayloadAuthCodeEdgeArgs = {
  orderBy?: InputMaybe<Array<AuthCodesOrderBy>>;
};

/** All input for the `deleteChangelogById` mutation. */
export type DeleteChangelogByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Changelog` mutation. */
export type DeleteChangelogPayload = {
  __typename?: 'DeleteChangelogPayload';
  /** The `Changelog` that was deleted by this mutation. */
  changelog?: Maybe<Changelog>;
  /** An edge for our `Changelog`. May be used by Relay 1. */
  changelogEdge?: Maybe<ChangelogsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedChangelogId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Changelog` mutation. */
export type DeleteChangelogPayloadChangelogEdgeArgs = {
  orderBy?: InputMaybe<Array<ChangelogsOrderBy>>;
};

/** All input for the `deleteChangelogUserByChangelogIdAndUserId` mutation. */
export type DeleteChangelogUserByChangelogIdAndUserIdInput = {
  changelogId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  userId: Scalars['UUID'];
};

/** The output of our delete `ChangelogUser` mutation. */
export type DeleteChangelogUserPayload = {
  __typename?: 'DeleteChangelogUserPayload';
  /** Reads a single `Changelog` that is related to this `ChangelogUser`. */
  changelog?: Maybe<Changelog>;
  /** The `ChangelogUser` that was deleted by this mutation. */
  changelogUser?: Maybe<ChangelogUser>;
  /** An edge for our `ChangelogUser`. May be used by Relay 1. */
  changelogUserEdge?: Maybe<ChangelogUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedChangelogUserId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ChangelogUser`. */
  user?: Maybe<User>;
};


/** The output of our delete `ChangelogUser` mutation. */
export type DeleteChangelogUserPayloadChangelogUserEdgeArgs = {
  orderBy?: InputMaybe<Array<ChangelogUsersOrderBy>>;
};

/** All input for the `deleteChosenColumnByUserIdAndTableName` mutation. */
export type DeleteChosenColumnByUserIdAndTableNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  tableName: Scalars['String'];
  userId: Scalars['UUID'];
};

/** The output of our delete `ChosenColumn` mutation. */
export type DeleteChosenColumnPayload = {
  __typename?: 'DeleteChosenColumnPayload';
  /** The `ChosenColumn` that was deleted by this mutation. */
  chosenColumn?: Maybe<ChosenColumn>;
  /** An edge for our `ChosenColumn`. May be used by Relay 1. */
  chosenColumnEdge?: Maybe<ChosenColumnsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedChosenColumnId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ChosenColumn`. */
  user?: Maybe<User>;
};


/** The output of our delete `ChosenColumn` mutation. */
export type DeleteChosenColumnPayloadChosenColumnEdgeArgs = {
  orderBy?: InputMaybe<Array<ChosenColumnsOrderBy>>;
};

/** All input for the `deleteCompanyCompanyTypeByCompanyId` mutation. */
export type DeleteCompanyCompanyTypeByCompanyIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
};

/** The output of our delete `CompanyCompanyType` mutation. */
export type DeleteCompanyCompanyTypePayload = {
  __typename?: 'DeleteCompanyCompanyTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CompanyCompanyType`. */
  company?: Maybe<Company>;
  /** The `CompanyCompanyType` that was deleted by this mutation. */
  companyCompanyType?: Maybe<CompanyCompanyType>;
  /** An edge for our `CompanyCompanyType`. May be used by Relay 1. */
  companyCompanyTypeEdge?: Maybe<CompanyCompanyTypesEdge>;
  /** Reads a single `CompanyType` that is related to this `CompanyCompanyType`. */
  companyType?: Maybe<CompanyType>;
  deletedCompanyCompanyTypeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CompanyCompanyType` mutation. */
export type DeleteCompanyCompanyTypePayloadCompanyCompanyTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyCompanyTypesOrderBy>>;
};

/** All input for the `deleteCompanySystemFieldById` mutation. */
export type DeleteCompanySystemFieldByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteCompanySystemFieldBySystemFieldIdAndCompanyId` mutation. */
export type DeleteCompanySystemFieldBySystemFieldIdAndCompanyIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
  systemFieldId: Scalars['UUID'];
};

/** The output of our delete `CompanySystemField` mutation. */
export type DeleteCompanySystemFieldPayload = {
  __typename?: 'DeleteCompanySystemFieldPayload';
  /** Reads a single `TranslatedEntity` that is related to this `CompanySystemField`. */
  aliasTranslatedEntity?: Maybe<TranslatedEntity>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CompanySystemField`. */
  company?: Maybe<Company>;
  /** The `CompanySystemField` that was deleted by this mutation. */
  companySystemField?: Maybe<CompanySystemField>;
  /** An edge for our `CompanySystemField`. May be used by Relay 1. */
  companySystemFieldEdge?: Maybe<CompanySystemFieldsEdge>;
  deletedCompanySystemFieldId?: Maybe<Scalars['ID']>;
  /** Reads a single `FieldGroup` that is related to this `CompanySystemField`. */
  fieldGroup?: Maybe<FieldGroup>;
  /** Reads a single `FieldGroupCardColumn` that is related to this `CompanySystemField`. */
  fieldGroupCardColumn?: Maybe<FieldGroupCardColumn>;
  /** Reads a single `TranslatedEntity` that is related to this `CompanySystemField`. */
  helpTextTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SystemField` that is related to this `CompanySystemField`. */
  systemField?: Maybe<SystemField>;
};


/** The output of our delete `CompanySystemField` mutation. */
export type DeleteCompanySystemFieldPayloadCompanySystemFieldEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanySystemFieldsOrderBy>>;
};

/** All input for the `deleteCompanyTypeById` mutation. */
export type DeleteCompanyTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `CompanyType` mutation. */
export type DeleteCompanyTypePayload = {
  __typename?: 'DeleteCompanyTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyType` that was deleted by this mutation. */
  companyType?: Maybe<CompanyType>;
  /** An edge for our `CompanyType`. May be used by Relay 1. */
  companyTypeEdge?: Maybe<CompanyTypesEdge>;
  deletedCompanyTypeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CompanyType` mutation. */
export type DeleteCompanyTypePayloadCompanyTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyTypesOrderBy>>;
};

/** All input for the `deleteCompetenceFormFieldById` mutation. */
export type DeleteCompetenceFormFieldByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `CompetenceFormField` mutation. */
export type DeleteCompetenceFormFieldPayload = {
  __typename?: 'DeleteCompetenceFormFieldPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CompetenceFormField`. */
  company?: Maybe<Company>;
  /** Reads a single `Competence` that is related to this `CompetenceFormField`. */
  competence?: Maybe<Competence>;
  /** The `CompetenceFormField` that was deleted by this mutation. */
  competenceFormField?: Maybe<CompetenceFormField>;
  /** An edge for our `CompetenceFormField`. May be used by Relay 1. */
  competenceFormFieldEdge?: Maybe<CompetenceFormFieldsEdge>;
  deletedCompetenceFormFieldId?: Maybe<Scalars['ID']>;
  /** Reads a single `FormField` that is related to this `CompetenceFormField`. */
  formField?: Maybe<FormField>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CompetenceFormField` mutation. */
export type DeleteCompetenceFormFieldPayloadCompetenceFormFieldEdgeArgs = {
  orderBy?: InputMaybe<Array<CompetenceFormFieldsOrderBy>>;
};

/** All input for the `deleteContractSignPendingByContractTemplateIds` mutation. */
export type DeleteContractSignPendingByContractTemplateIdsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contractTemplateIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The output of our `deleteContractSignPendingByContractTemplateIds` mutation. */
export type DeleteContractSignPendingByContractTemplateIdsPayload = {
  __typename?: 'DeleteContractSignPendingByContractTemplateIdsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  contractSignPendings?: Maybe<Array<Maybe<ContractSignPending>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteContractSignPendingDocumentById` mutation. */
export type DeleteContractSignPendingDocumentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ContractSignPendingDocument` mutation. */
export type DeleteContractSignPendingDocumentPayload = {
  __typename?: 'DeleteContractSignPendingDocumentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ContractSignPendingDocument`. */
  company?: Maybe<Company>;
  /** Reads a single `ContractSignPending` that is related to this `ContractSignPendingDocument`. */
  contractSignPending?: Maybe<ContractSignPending>;
  /** The `ContractSignPendingDocument` that was deleted by this mutation. */
  contractSignPendingDocument?: Maybe<ContractSignPendingDocument>;
  /** An edge for our `ContractSignPendingDocument`. May be used by Relay 1. */
  contractSignPendingDocumentEdge?: Maybe<ContractSignPendingDocumentsEdge>;
  /** Reads a single `ContractTemplate` that is related to this `ContractSignPendingDocument`. */
  contractTemplate?: Maybe<ContractTemplate>;
  deletedContractSignPendingDocumentId?: Maybe<Scalars['ID']>;
  /** Reads a single `DocumentType` that is related to this `ContractSignPendingDocument`. */
  documentType?: Maybe<DocumentType>;
  /** Reads a single `Storage` that is related to this `ContractSignPendingDocument`. */
  existingStorage?: Maybe<Storage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ContractSignPendingDocument` mutation. */
export type DeleteContractSignPendingDocumentPayloadContractSignPendingDocumentEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractSignPendingDocumentsOrderBy>>;
};

/** All input for the `deleteContractSignPendingSignerByContractSignPendingIdAndUserId` mutation. */
export type DeleteContractSignPendingSignerByContractSignPendingIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contractSignPendingId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** All input for the `deleteContractSignPendingSignerById` mutation. */
export type DeleteContractSignPendingSignerByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ContractSignPendingSigner` mutation. */
export type DeleteContractSignPendingSignerPayload = {
  __typename?: 'DeleteContractSignPendingSignerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ContractSignPendingSigner`. */
  company?: Maybe<Company>;
  /** Reads a single `ContractSignPending` that is related to this `ContractSignPendingSigner`. */
  contractSignPending?: Maybe<ContractSignPending>;
  /** The `ContractSignPendingSigner` that was deleted by this mutation. */
  contractSignPendingSigner?: Maybe<ContractSignPendingSigner>;
  /** An edge for our `ContractSignPendingSigner`. May be used by Relay 1. */
  contractSignPendingSignerEdge?: Maybe<ContractSignPendingSignersEdge>;
  deletedContractSignPendingSignerId?: Maybe<Scalars['ID']>;
  /** Reads a single `User` that is related to this `ContractSignPendingSigner`. */
  onBehalfOfUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Storage` that is related to this `ContractSignPendingSigner`. */
  signatureFile?: Maybe<Storage>;
  /** Reads a single `User` that is related to this `ContractSignPendingSigner`. */
  user?: Maybe<User>;
};


/** The output of our delete `ContractSignPendingSigner` mutation. */
export type DeleteContractSignPendingSignerPayloadContractSignPendingSignerEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractSignPendingSignersOrderBy>>;
};

/** All input for the `deleteContractTemplateDepartmentByContractTemplateIdAndDepartmentId` mutation. */
export type DeleteContractTemplateDepartmentByContractTemplateIdAndDepartmentIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contractTemplateId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
};

/** The output of our delete `ContractTemplateDepartment` mutation. */
export type DeleteContractTemplateDepartmentPayload = {
  __typename?: 'DeleteContractTemplateDepartmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ContractTemplateDepartment`. */
  company?: Maybe<Company>;
  /** Reads a single `ContractTemplate` that is related to this `ContractTemplateDepartment`. */
  contractTemplate?: Maybe<ContractTemplate>;
  /** The `ContractTemplateDepartment` that was deleted by this mutation. */
  contractTemplateDepartment?: Maybe<ContractTemplateDepartment>;
  /** An edge for our `ContractTemplateDepartment`. May be used by Relay 1. */
  contractTemplateDepartmentEdge?: Maybe<ContractTemplateDepartmentsEdge>;
  deletedContractTemplateDepartmentId?: Maybe<Scalars['ID']>;
  /** Reads a single `Department` that is related to this `ContractTemplateDepartment`. */
  department?: Maybe<Department>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ContractTemplateDepartment` mutation. */
export type DeleteContractTemplateDepartmentPayloadContractTemplateDepartmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractTemplateDepartmentsOrderBy>>;
};

/** All input for the `deleteContractTemplateUserByUserIdAndContractTemplateId` mutation. */
export type DeleteContractTemplateUserByUserIdAndContractTemplateIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contractTemplateId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our delete `ContractTemplateUser` mutation. */
export type DeleteContractTemplateUserPayload = {
  __typename?: 'DeleteContractTemplateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ContractTemplateUser`. */
  company?: Maybe<Company>;
  /** Reads a single `ContractTemplate` that is related to this `ContractTemplateUser`. */
  contractTemplate?: Maybe<ContractTemplate>;
  /** The `ContractTemplateUser` that was deleted by this mutation. */
  contractTemplateUser?: Maybe<ContractTemplateUser>;
  /** An edge for our `ContractTemplateUser`. May be used by Relay 1. */
  contractTemplateUserEdge?: Maybe<ContractTemplateUsersEdge>;
  deletedContractTemplateUserId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ContractTemplateUser`. */
  user?: Maybe<User>;
};


/** The output of our delete `ContractTemplateUser` mutation. */
export type DeleteContractTemplateUserPayloadContractTemplateUserEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractTemplateUsersOrderBy>>;
};

/** All input for the `deleteCvTemplateFieldMappingById` mutation. */
export type DeleteCvTemplateFieldMappingByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `CvTemplateFieldMapping` mutation. */
export type DeleteCvTemplateFieldMappingPayload = {
  __typename?: 'DeleteCvTemplateFieldMappingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CvTemplateFieldMapping`. */
  company?: Maybe<Company>;
  /** The `CvTemplateFieldMapping` that was deleted by this mutation. */
  cvTemplateFieldMapping?: Maybe<CvTemplateFieldMapping>;
  /** An edge for our `CvTemplateFieldMapping`. May be used by Relay 1. */
  cvTemplateFieldMappingEdge?: Maybe<CvTemplateFieldMappingsEdge>;
  deletedCvTemplateFieldMappingId?: Maybe<Scalars['ID']>;
  /** Reads a single `FormField` that is related to this `CvTemplateFieldMapping`. */
  formField?: Maybe<FormField>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SystemField` that is related to this `CvTemplateFieldMapping`. */
  systemField?: Maybe<SystemField>;
};


/** The output of our delete `CvTemplateFieldMapping` mutation. */
export type DeleteCvTemplateFieldMappingPayloadCvTemplateFieldMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<CvTemplateFieldMappingsOrderBy>>;
};

/** All input for the `deleteDashboardConfigByCompanyId` mutation. */
export type DeleteDashboardConfigByCompanyIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
};

/** The output of our delete `DashboardConfig` mutation. */
export type DeleteDashboardConfigPayload = {
  __typename?: 'DeleteDashboardConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DashboardConfig`. */
  company?: Maybe<Company>;
  /** The `DashboardConfig` that was deleted by this mutation. */
  dashboardConfig?: Maybe<DashboardConfig>;
  /** An edge for our `DashboardConfig`. May be used by Relay 1. */
  dashboardConfigEdge?: Maybe<DashboardConfigsEdge>;
  deletedDashboardConfigId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `DashboardConfig` mutation. */
export type DeleteDashboardConfigPayloadDashboardConfigEdgeArgs = {
  orderBy?: InputMaybe<Array<DashboardConfigsOrderBy>>;
};

/** All input for the `deleteDocumentDepartmentPermissionByFileIdAndDepartmentId` mutation. */
export type DeleteDocumentDepartmentPermissionByFileIdAndDepartmentIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  departmentId: Scalars['UUID'];
  fileId: Scalars['UUID'];
};

/** The output of our delete `DocumentDepartmentPermission` mutation. */
export type DeleteDocumentDepartmentPermissionPayload = {
  __typename?: 'DeleteDocumentDepartmentPermissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentDepartmentPermission`. */
  company?: Maybe<Company>;
  deletedDocumentDepartmentPermissionId?: Maybe<Scalars['ID']>;
  /** Reads a single `Department` that is related to this `DocumentDepartmentPermission`. */
  department?: Maybe<Department>;
  /** The `DocumentDepartmentPermission` that was deleted by this mutation. */
  documentDepartmentPermission?: Maybe<DocumentDepartmentPermission>;
  /** An edge for our `DocumentDepartmentPermission`. May be used by Relay 1. */
  documentDepartmentPermissionEdge?: Maybe<DocumentDepartmentPermissionsEdge>;
  /** Reads a single `Storage` that is related to this `DocumentDepartmentPermission`. */
  file?: Maybe<Storage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `DocumentDepartmentPermission` mutation. */
export type DeleteDocumentDepartmentPermissionPayloadDocumentDepartmentPermissionEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentDepartmentPermissionsOrderBy>>;
};

/** All input for the `deleteDocumentFolderDepartmentByDocumentFolderIdAndDepartmentId` mutation. */
export type DeleteDocumentFolderDepartmentByDocumentFolderIdAndDepartmentIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  departmentId: Scalars['UUID'];
  documentFolderId: Scalars['UUID'];
};

/** The output of our delete `DocumentFolderDepartment` mutation. */
export type DeleteDocumentFolderDepartmentPayload = {
  __typename?: 'DeleteDocumentFolderDepartmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentFolderDepartment`. */
  company?: Maybe<Company>;
  deletedDocumentFolderDepartmentId?: Maybe<Scalars['ID']>;
  /** Reads a single `Department` that is related to this `DocumentFolderDepartment`. */
  department?: Maybe<Department>;
  /** Reads a single `DocumentFolder` that is related to this `DocumentFolderDepartment`. */
  documentFolder?: Maybe<DocumentFolder>;
  /** The `DocumentFolderDepartment` that was deleted by this mutation. */
  documentFolderDepartment?: Maybe<DocumentFolderDepartment>;
  /** An edge for our `DocumentFolderDepartment`. May be used by Relay 1. */
  documentFolderDepartmentEdge?: Maybe<DocumentFolderDepartmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `DocumentFolderDepartment` mutation. */
export type DeleteDocumentFolderDepartmentPayloadDocumentFolderDepartmentEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentFolderDepartmentsOrderBy>>;
};

/** All input for the `deleteDocumentFolderUserByDocumentFolderIdAndUserId` mutation. */
export type DeleteDocumentFolderUserByDocumentFolderIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  documentFolderId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our delete `DocumentFolderUser` mutation. */
export type DeleteDocumentFolderUserPayload = {
  __typename?: 'DeleteDocumentFolderUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentFolderUser`. */
  company?: Maybe<Company>;
  deletedDocumentFolderUserId?: Maybe<Scalars['ID']>;
  /** Reads a single `DocumentFolder` that is related to this `DocumentFolderUser`. */
  documentFolder?: Maybe<DocumentFolder>;
  /** The `DocumentFolderUser` that was deleted by this mutation. */
  documentFolderUser?: Maybe<DocumentFolderUser>;
  /** An edge for our `DocumentFolderUser`. May be used by Relay 1. */
  documentFolderUserEdge?: Maybe<DocumentFolderUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `DocumentFolderUser`. */
  user?: Maybe<User>;
};


/** The output of our delete `DocumentFolderUser` mutation. */
export type DeleteDocumentFolderUserPayloadDocumentFolderUserEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentFolderUsersOrderBy>>;
};

/** All input for the `deleteDocumentUserPermissionByFileIdAndUserId` mutation. */
export type DeleteDocumentUserPermissionByFileIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fileId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our delete `DocumentUserPermission` mutation. */
export type DeleteDocumentUserPermissionPayload = {
  __typename?: 'DeleteDocumentUserPermissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentUserPermission`. */
  company?: Maybe<Company>;
  deletedDocumentUserPermissionId?: Maybe<Scalars['ID']>;
  /** Reads a single `DocumentType` that is related to this `DocumentUserPermission`. */
  documentType?: Maybe<DocumentType>;
  /** The `DocumentUserPermission` that was deleted by this mutation. */
  documentUserPermission?: Maybe<DocumentUserPermission>;
  /** An edge for our `DocumentUserPermission`. May be used by Relay 1. */
  documentUserPermissionEdge?: Maybe<DocumentUserPermissionsEdge>;
  /** Reads a single `Storage` that is related to this `DocumentUserPermission`. */
  file?: Maybe<Storage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `DocumentUserPermission`. */
  user?: Maybe<User>;
};


/** The output of our delete `DocumentUserPermission` mutation. */
export type DeleteDocumentUserPermissionPayloadDocumentUserPermissionEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentUserPermissionsOrderBy>>;
};

/** All input for the `deleteDocumentUserResponsibleByFileIdAndUserId` mutation. */
export type DeleteDocumentUserResponsibleByFileIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fileId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our delete `DocumentUserResponsible` mutation. */
export type DeleteDocumentUserResponsiblePayload = {
  __typename?: 'DeleteDocumentUserResponsiblePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentUserResponsible`. */
  company?: Maybe<Company>;
  deletedDocumentUserResponsibleId?: Maybe<Scalars['ID']>;
  /** Reads a single `DocumentType` that is related to this `DocumentUserResponsible`. */
  documentType?: Maybe<DocumentType>;
  /** The `DocumentUserResponsible` that was deleted by this mutation. */
  documentUserResponsible?: Maybe<DocumentUserResponsible>;
  /** An edge for our `DocumentUserResponsible`. May be used by Relay 1. */
  documentUserResponsibleEdge?: Maybe<DocumentUserResponsiblesEdge>;
  /** Reads a single `Storage` that is related to this `DocumentUserResponsible`. */
  file?: Maybe<Storage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `DocumentUserResponsible`. */
  user?: Maybe<User>;
  /** Reads a single `User` that is related to this `DocumentUserResponsible`. */
  userByAssignedBy?: Maybe<User>;
};


/** The output of our delete `DocumentUserResponsible` mutation. */
export type DeleteDocumentUserResponsiblePayloadDocumentUserResponsibleEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentUserResponsiblesOrderBy>>;
};

/** All input for the `deleteEmployeeExternalIntegrationByEmployeeIdAndExternalIntegrationId` mutation. */
export type DeleteEmployeeExternalIntegrationByEmployeeIdAndExternalIntegrationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
};

/** All input for the `deleteEmployeeExternalIntegrationBySameSystem` mutation. */
export type DeleteEmployeeExternalIntegrationBySameSystemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  sameSystem: Scalars['String'];
};

/** The output of our delete `EmployeeExternalIntegration` mutation. */
export type DeleteEmployeeExternalIntegrationPayload = {
  __typename?: 'DeleteEmployeeExternalIntegrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `EmployeeExternalIntegration`. */
  company?: Maybe<Company>;
  deletedEmployeeExternalIntegrationId?: Maybe<Scalars['ID']>;
  /** Reads a single `Employee` that is related to this `EmployeeExternalIntegration`. */
  employee?: Maybe<Employee>;
  /** The `EmployeeExternalIntegration` that was deleted by this mutation. */
  employeeExternalIntegration?: Maybe<EmployeeExternalIntegration>;
  /** An edge for our `EmployeeExternalIntegration`. May be used by Relay 1. */
  employeeExternalIntegrationEdge?: Maybe<EmployeeExternalIntegrationsEdge>;
  /** Reads a single `ExternalIntegration` that is related to this `EmployeeExternalIntegration`. */
  externalIntegration?: Maybe<ExternalIntegration>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `EmployeeExternalIntegration` mutation. */
export type DeleteEmployeeExternalIntegrationPayloadEmployeeExternalIntegrationEdgeArgs = {
  orderBy?: InputMaybe<Array<EmployeeExternalIntegrationsOrderBy>>;
};

/** All input for the `deleteEquipmentById` mutation. */
export type DeleteEquipmentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Equipment` mutation. */
export type DeleteEquipmentPayload = {
  __typename?: 'DeleteEquipmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Equipment`. */
  company?: Maybe<Company>;
  deletedEquipmentId?: Maybe<Scalars['ID']>;
  /** Reads a single `Employee` that is related to this `Equipment`. */
  employee?: Maybe<Employee>;
  /** The `Equipment` that was deleted by this mutation. */
  equipment?: Maybe<Equipment>;
  /** An edge for our `Equipment`. May be used by Relay 1. */
  equipmentEdge?: Maybe<EquipmentEdge>;
  /** Reads a single `Product` that is related to this `Equipment`. */
  product?: Maybe<Product>;
  /** Reads a single `ProductType` that is related to this `Equipment`. */
  productType?: Maybe<ProductType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Equipment`. */
  user?: Maybe<User>;
};


/** The output of our delete `Equipment` mutation. */
export type DeleteEquipmentPayloadEquipmentEdgeArgs = {
  orderBy?: InputMaybe<Array<EquipmentOrderBy>>;
};

/** All input for the `deleteEventUserByEventIdAndUserId` mutation. */
export type DeleteEventUserByEventIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** All input for the `deleteEventUserById` mutation. */
export type DeleteEventUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `EventUser` mutation. */
export type DeleteEventUserPayload = {
  __typename?: 'DeleteEventUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `EventUser`. */
  company?: Maybe<Company>;
  deletedEventUserId?: Maybe<Scalars['ID']>;
  /** Reads a single `Event` that is related to this `EventUser`. */
  event?: Maybe<Event>;
  /** The `EventUser` that was deleted by this mutation. */
  eventUser?: Maybe<EventUser>;
  /** An edge for our `EventUser`. May be used by Relay 1. */
  eventUserEdge?: Maybe<EventUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EventUser`. */
  user?: Maybe<User>;
};


/** The output of our delete `EventUser` mutation. */
export type DeleteEventUserPayloadEventUserEdgeArgs = {
  orderBy?: InputMaybe<Array<EventUsersOrderBy>>;
};

/** All input for the `deleteExternalIntegrationById` mutation. */
export type DeleteExternalIntegrationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `ExternalIntegration` mutation. */
export type DeleteExternalIntegrationPayload = {
  __typename?: 'DeleteExternalIntegrationPayload';
  /** Reads a single `AuthApp` that is related to this `ExternalIntegration`. */
  authApp?: Maybe<AuthApp>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ExternalIntegration`. */
  company?: Maybe<Company>;
  deletedExternalIntegrationId?: Maybe<Scalars['ID']>;
  /** The `ExternalIntegration` that was deleted by this mutation. */
  externalIntegration?: Maybe<ExternalIntegration>;
  /** An edge for our `ExternalIntegration`. May be used by Relay 1. */
  externalIntegrationEdge?: Maybe<ExternalIntegrationsEdge>;
  /** Reads a single `IntegrableSystem` that is related to this `ExternalIntegration`. */
  integrableSystem?: Maybe<IntegrableSystem>;
  /** Reads a single `DocumentFolderBlueprint` that is related to this `ExternalIntegration`. */
  payslipDocumentBlueprintFolder?: Maybe<DocumentFolderBlueprint>;
  /** Reads a single `DocumentType` that is related to this `ExternalIntegration`. */
  payslipDocumentType?: Maybe<DocumentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalSystem` that is related to this `ExternalIntegration`. */
  system?: Maybe<ExternalSystem>;
};


/** The output of our delete `ExternalIntegration` mutation. */
export type DeleteExternalIntegrationPayloadExternalIntegrationEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalIntegrationsOrderBy>>;
};

/** All input for the `deleteFilterViewById` mutation. */
export type DeleteFilterViewByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `FilterView` mutation. */
export type DeleteFilterViewPayload = {
  __typename?: 'DeleteFilterViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedFilterViewId?: Maybe<Scalars['ID']>;
  /** The `FilterView` that was deleted by this mutation. */
  filterView?: Maybe<FilterView>;
  /** An edge for our `FilterView`. May be used by Relay 1. */
  filterViewEdge?: Maybe<FilterViewsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `FilterView`. */
  user?: Maybe<User>;
};


/** The output of our delete `FilterView` mutation. */
export type DeleteFilterViewPayloadFilterViewEdgeArgs = {
  orderBy?: InputMaybe<Array<FilterViewsOrderBy>>;
};

/** All input for the `deleteFormFieldAgreementByFormFieldId` mutation. */
export type DeleteFormFieldAgreementByFormFieldIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  formFieldId: Scalars['UUID'];
};

/** All input for the `deleteFormFieldAgreementById` mutation. */
export type DeleteFormFieldAgreementByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `FormFieldAgreement` mutation. */
export type DeleteFormFieldAgreementPayload = {
  __typename?: 'DeleteFormFieldAgreementPayload';
  /** Reads a single `TranslatedEntity` that is related to this `FormFieldAgreement`. */
  agreementTextTranslatedEntity?: Maybe<TranslatedEntity>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FormFieldAgreement`. */
  company?: Maybe<Company>;
  deletedFormFieldAgreementId?: Maybe<Scalars['ID']>;
  /** Reads a single `FormField` that is related to this `FormFieldAgreement`. */
  formField?: Maybe<FormField>;
  /** The `FormFieldAgreement` that was deleted by this mutation. */
  formFieldAgreement?: Maybe<FormFieldAgreement>;
  /** An edge for our `FormFieldAgreement`. May be used by Relay 1. */
  formFieldAgreementEdge?: Maybe<FormFieldAgreementsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `FormFieldAgreement` mutation. */
export type DeleteFormFieldAgreementPayloadFormFieldAgreementEdgeArgs = {
  orderBy?: InputMaybe<Array<FormFieldAgreementsOrderBy>>;
};

/** All input for the `deleteGroupRoleByGroupIdAndRoleId` mutation. */
export type DeleteGroupRoleByGroupIdAndRoleIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupId: Scalars['UUID'];
  roleId: Scalars['UUID'];
};

/** The output of our delete `GroupRole` mutation. */
export type DeleteGroupRolePayload = {
  __typename?: 'DeleteGroupRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `GroupRole`. */
  company?: Maybe<Company>;
  deletedGroupRoleId?: Maybe<Scalars['ID']>;
  /** Reads a single `Group` that is related to this `GroupRole`. */
  group?: Maybe<Group>;
  /** The `GroupRole` that was deleted by this mutation. */
  groupRole?: Maybe<GroupRole>;
  /** An edge for our `GroupRole`. May be used by Relay 1. */
  groupRoleEdge?: Maybe<GroupRolesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Role` that is related to this `GroupRole`. */
  role?: Maybe<Role>;
};


/** The output of our delete `GroupRole` mutation. */
export type DeleteGroupRolePayloadGroupRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupRolesOrderBy>>;
};

/** All input for the `deleteIntegrableSystemById` mutation. */
export type DeleteIntegrableSystemByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `IntegrableSystem` mutation. */
export type DeleteIntegrableSystemPayload = {
  __typename?: 'DeleteIntegrableSystemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedIntegrableSystemId?: Maybe<Scalars['ID']>;
  /** The `IntegrableSystem` that was deleted by this mutation. */
  integrableSystem?: Maybe<IntegrableSystem>;
  /** An edge for our `IntegrableSystem`. May be used by Relay 1. */
  integrableSystemEdge?: Maybe<IntegrableSystemsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `IntegrableSystem` mutation. */
export type DeleteIntegrableSystemPayloadIntegrableSystemEdgeArgs = {
  orderBy?: InputMaybe<Array<IntegrableSystemsOrderBy>>;
};

export type DeleteIntegrationInput = {
  companyId: Scalars['UUID'];
  id: Scalars['UUID'];
};

export type DeleteIntegrationResponse = {
  __typename?: 'DeleteIntegrationResponse';
  message: Scalars['String'];
};

/** All input for the `deleteNotificationCustomEmployeeFieldRecipientById` mutation. */
export type DeleteNotificationCustomEmployeeFieldRecipientByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `NotificationCustomEmployeeFieldRecipient` mutation. */
export type DeleteNotificationCustomEmployeeFieldRecipientPayload = {
  __typename?: 'DeleteNotificationCustomEmployeeFieldRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `NotificationCustomEmployeeFieldRecipient`. */
  company?: Maybe<Company>;
  deletedNotificationCustomEmployeeFieldRecipientId?: Maybe<Scalars['ID']>;
  /** Reads a single `FormField` that is related to this `NotificationCustomEmployeeFieldRecipient`. */
  formField?: Maybe<FormField>;
  /** Reads a single `Notification` that is related to this `NotificationCustomEmployeeFieldRecipient`. */
  notification?: Maybe<Notification>;
  /** The `NotificationCustomEmployeeFieldRecipient` that was deleted by this mutation. */
  notificationCustomEmployeeFieldRecipient?: Maybe<NotificationCustomEmployeeFieldRecipient>;
  /** An edge for our `NotificationCustomEmployeeFieldRecipient`. May be used by Relay 1. */
  notificationCustomEmployeeFieldRecipientEdge?: Maybe<NotificationCustomEmployeeFieldRecipientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `NotificationCustomEmployeeFieldRecipient` mutation. */
export type DeleteNotificationCustomEmployeeFieldRecipientPayloadNotificationCustomEmployeeFieldRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientsOrderBy>>;
};

/** All input for the `deleteNotificationCustomRecipientByNotificationIdAndEmployeeId` mutation. */
export type DeleteNotificationCustomRecipientByNotificationIdAndEmployeeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['UUID'];
  notificationId: Scalars['UUID'];
};

/** The output of our delete `NotificationCustomRecipient` mutation. */
export type DeleteNotificationCustomRecipientPayload = {
  __typename?: 'DeleteNotificationCustomRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `NotificationCustomRecipient`. */
  company?: Maybe<Company>;
  deletedNotificationCustomRecipientId?: Maybe<Scalars['ID']>;
  /** Reads a single `Employee` that is related to this `NotificationCustomRecipient`. */
  employee?: Maybe<Employee>;
  /** Reads a single `Notification` that is related to this `NotificationCustomRecipient`. */
  notification?: Maybe<Notification>;
  /** The `NotificationCustomRecipient` that was deleted by this mutation. */
  notificationCustomRecipient?: Maybe<NotificationCustomRecipient>;
  /** An edge for our `NotificationCustomRecipient`. May be used by Relay 1. */
  notificationCustomRecipientEdge?: Maybe<NotificationCustomRecipientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `NotificationCustomRecipient`. */
  user?: Maybe<User>;
};


/** The output of our delete `NotificationCustomRecipient` mutation. */
export type DeleteNotificationCustomRecipientPayloadNotificationCustomRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationCustomRecipientsOrderBy>>;
};

/** All input for the `deleteNotificationEmployeeById` mutation. */
export type DeleteNotificationEmployeeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `NotificationEmployee` mutation. */
export type DeleteNotificationEmployeePayload = {
  __typename?: 'DeleteNotificationEmployeePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `NotificationEmployee`. */
  company?: Maybe<Company>;
  deletedNotificationEmployeeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Employee` that is related to this `NotificationEmployee`. */
  employee?: Maybe<Employee>;
  /** Reads a single `Notification` that is related to this `NotificationEmployee`. */
  notification?: Maybe<Notification>;
  /** The `NotificationEmployee` that was deleted by this mutation. */
  notificationEmployee?: Maybe<NotificationEmployee>;
  /** An edge for our `NotificationEmployee`. May be used by Relay 1. */
  notificationEmployeeEdge?: Maybe<NotificationEmployeesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Employee` that is related to this `NotificationEmployee`. */
  recipient?: Maybe<Employee>;
  /** Reads a single `Employee` that is related to this `NotificationEmployee`. */
  sender?: Maybe<Employee>;
};


/** The output of our delete `NotificationEmployee` mutation. */
export type DeleteNotificationEmployeePayloadNotificationEmployeeEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationEmployeesOrderBy>>;
};

/** All input for the `deleteNotificationEmployeeReferenceById` mutation. */
export type DeleteNotificationEmployeeReferenceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `NotificationEmployeeReference` mutation. */
export type DeleteNotificationEmployeeReferencePayload = {
  __typename?: 'DeleteNotificationEmployeeReferencePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `NotificationEmployeeReference`. */
  company?: Maybe<Company>;
  /** Reads a single `Competence` that is related to this `NotificationEmployeeReference`. */
  competence?: Maybe<Competence>;
  /** Reads a single `CompetenceGroup` that is related to this `NotificationEmployeeReference`. */
  competenceGroup?: Maybe<CompetenceGroup>;
  /** Reads a single `ContractSignPending` that is related to this `NotificationEmployeeReference`. */
  contractSignPending?: Maybe<ContractSignPending>;
  deletedNotificationEmployeeReferenceId?: Maybe<Scalars['ID']>;
  /** Reads a single `Department` that is related to this `NotificationEmployeeReference`. */
  department?: Maybe<Department>;
  /** Reads a single `Employee` that is related to this `NotificationEmployeeReference`. */
  employee?: Maybe<Employee>;
  /** Reads a single `Storage` that is related to this `NotificationEmployeeReference`. */
  file?: Maybe<Storage>;
  /** Reads a single `FutureDatum` that is related to this `NotificationEmployeeReference`. */
  futureData?: Maybe<FutureDatum>;
  /** Reads a single `Message` that is related to this `NotificationEmployeeReference`. */
  message?: Maybe<Message>;
  /** Reads a single `NotificationEmployee` that is related to this `NotificationEmployeeReference`. */
  notificationEmployee?: Maybe<NotificationEmployee>;
  /** The `NotificationEmployeeReference` that was deleted by this mutation. */
  notificationEmployeeReference?: Maybe<NotificationEmployeeReference>;
  /** An edge for our `NotificationEmployeeReference`. May be used by Relay 1. */
  notificationEmployeeReferenceEdge?: Maybe<NotificationEmployeeReferencesEdge>;
  /** Reads a single `Preboarding` that is related to this `NotificationEmployeeReference`. */
  preboarding?: Maybe<Preboarding>;
  /** Reads a single `Process` that is related to this `NotificationEmployeeReference`. */
  process?: Maybe<Process>;
  /** Reads a single `Product` that is related to this `NotificationEmployeeReference`. */
  product?: Maybe<Product>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `NotificationEmployeeReference`. */
  recipientUser?: Maybe<User>;
  /** Reads a single `Task` that is related to this `NotificationEmployeeReference`. */
  task?: Maybe<Task>;
  /** Reads a single `TaskTemplate` that is related to this `NotificationEmployeeReference`. */
  taskTemplate?: Maybe<TaskTemplate>;
  /** Reads a single `TimeRegistrationPresence` that is related to this `NotificationEmployeeReference`. */
  timeRegistrationPresence?: Maybe<TimeRegistrationPresence>;
  /** Reads a single `UserCompetence` that is related to this `NotificationEmployeeReference`. */
  userCompetence?: Maybe<UserCompetence>;
  /** Reads a single `VacationType` that is related to this `NotificationEmployeeReference`. */
  vacationType?: Maybe<VacationType>;
  /** Reads a single `VacationUser` that is related to this `NotificationEmployeeReference`. */
  vacationUser?: Maybe<VacationUser>;
};


/** The output of our delete `NotificationEmployeeReference` mutation. */
export type DeleteNotificationEmployeeReferencePayloadNotificationEmployeeReferenceEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};

/** All input for the `deleteNotificationGroupRecipientByNotificationIdAndGroupId` mutation. */
export type DeleteNotificationGroupRecipientByNotificationIdAndGroupIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupId: Scalars['UUID'];
  notificationId: Scalars['UUID'];
};

/** The output of our delete `NotificationGroupRecipient` mutation. */
export type DeleteNotificationGroupRecipientPayload = {
  __typename?: 'DeleteNotificationGroupRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `NotificationGroupRecipient`. */
  company?: Maybe<Company>;
  deletedNotificationGroupRecipientId?: Maybe<Scalars['ID']>;
  /** Reads a single `Group` that is related to this `NotificationGroupRecipient`. */
  group?: Maybe<Group>;
  /** Reads a single `Notification` that is related to this `NotificationGroupRecipient`. */
  notification?: Maybe<Notification>;
  /** The `NotificationGroupRecipient` that was deleted by this mutation. */
  notificationGroupRecipient?: Maybe<NotificationGroupRecipient>;
  /** An edge for our `NotificationGroupRecipient`. May be used by Relay 1. */
  notificationGroupRecipientEdge?: Maybe<NotificationGroupRecipientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `NotificationGroupRecipient` mutation. */
export type DeleteNotificationGroupRecipientPayloadNotificationGroupRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationGroupRecipientsOrderBy>>;
};

/** All input for the `deleteNotificationTypeChannelTypeByNotificationTypeIdAndChannelTypeId` mutation. */
export type DeleteNotificationTypeChannelTypeByNotificationTypeIdAndChannelTypeIdInput = {
  channelTypeId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  notificationTypeId: Scalars['UUID'];
};

/** All input for the `deleteNotificationTypeChannelTypeByNotificationTypeId` mutation. */
export type DeleteNotificationTypeChannelTypeByNotificationTypeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `deleteNotificationTypeChannelTypeByNotificationTypeId` mutation. */
export type DeleteNotificationTypeChannelTypeByNotificationTypeIdPayload = {
  __typename?: 'DeleteNotificationTypeChannelTypeByNotificationTypeIdPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  notificationTypeChannelTypes?: Maybe<Array<Maybe<NotificationTypeChannelType>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our delete `NotificationTypeChannelType` mutation. */
export type DeleteNotificationTypeChannelTypePayload = {
  __typename?: 'DeleteNotificationTypeChannelTypePayload';
  /** Reads a single `ChannelType` that is related to this `NotificationTypeChannelType`. */
  channelType?: Maybe<ChannelType>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `NotificationTypeChannelType`. */
  company?: Maybe<Company>;
  deletedNotificationTypeChannelTypeId?: Maybe<Scalars['ID']>;
  /** Reads a single `NotificationType` that is related to this `NotificationTypeChannelType`. */
  notificationType?: Maybe<NotificationType>;
  /** The `NotificationTypeChannelType` that was deleted by this mutation. */
  notificationTypeChannelType?: Maybe<NotificationTypeChannelType>;
  /** An edge for our `NotificationTypeChannelType`. May be used by Relay 1. */
  notificationTypeChannelTypeEdge?: Maybe<NotificationTypeChannelTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `NotificationTypeChannelType` mutation. */
export type DeleteNotificationTypeChannelTypePayloadNotificationTypeChannelTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationTypeChannelTypesOrderBy>>;
};

/** All input for the `deleteOldRole` mutation. */
export type DeleteOldRoleInput = {
  argRole?: InputMaybe<Scalars['String']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `deleteOldRole` mutation. */
export type DeleteOldRolePayload = {
  __typename?: 'DeleteOldRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteOldRoles` mutation. */
export type DeleteOldRolesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `deleteOldRoles` mutation. */
export type DeleteOldRolesPayload = {
  __typename?: 'DeleteOldRolesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type DeletePostCommentInput = {
  postCommentId?: InputMaybe<Scalars['UUID']>;
};

/** All input for the `deletePostTypeById` mutation. */
export type DeletePostTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PostType` mutation. */
export type DeletePostTypePayload = {
  __typename?: 'DeletePostTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PostType`. */
  company?: Maybe<Company>;
  deletedPostTypeId?: Maybe<Scalars['ID']>;
  /** Reads a single `TranslatedEntity` that is related to this `PostType`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** The `PostType` that was deleted by this mutation. */
  postType?: Maybe<PostType>;
  /** An edge for our `PostType`. May be used by Relay 1. */
  postTypeEdge?: Maybe<PostTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PostType` mutation. */
export type DeletePostTypePayloadPostTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<PostTypesOrderBy>>;
};

/** All input for the `deletePreboardingCommentById` mutation. */
export type DeletePreboardingCommentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PreboardingComment` mutation. */
export type DeletePreboardingCommentPayload = {
  __typename?: 'DeletePreboardingCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingComment`. */
  company?: Maybe<Company>;
  deletedPreboardingCommentId?: Maybe<Scalars['ID']>;
  /** Reads a single `Employee` that is related to this `PreboardingComment`. */
  employee?: Maybe<Employee>;
  /** Reads a single `EngagementType` that is related to this `PreboardingComment`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `Preboarding` that is related to this `PreboardingComment`. */
  preboarding?: Maybe<Preboarding>;
  /** The `PreboardingComment` that was deleted by this mutation. */
  preboardingComment?: Maybe<PreboardingComment>;
  /** An edge for our `PreboardingComment`. May be used by Relay 1. */
  preboardingCommentEdge?: Maybe<PreboardingCommentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PreboardingComment`. */
  user?: Maybe<User>;
};


/** The output of our delete `PreboardingComment` mutation. */
export type DeletePreboardingCommentPayloadPreboardingCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingCommentsOrderBy>>;
};

/** All input for the `deletePreboardingProcessByPreboardingIdAndProcessId` mutation. */
export type DeletePreboardingProcessByPreboardingIdAndProcessIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  preboardingId: Scalars['UUID'];
  processId: Scalars['UUID'];
};

/** The output of our delete `PreboardingProcess` mutation. */
export type DeletePreboardingProcessPayload = {
  __typename?: 'DeletePreboardingProcessPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingProcess`. */
  company?: Maybe<Company>;
  deletedPreboardingProcessId?: Maybe<Scalars['ID']>;
  /** Reads a single `Employee` that is related to this `PreboardingProcess`. */
  employee?: Maybe<Employee>;
  /** Reads a single `EngagementType` that is related to this `PreboardingProcess`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `Preboarding` that is related to this `PreboardingProcess`. */
  preboarding?: Maybe<Preboarding>;
  /** The `PreboardingProcess` that was deleted by this mutation. */
  preboardingProcess?: Maybe<PreboardingProcess>;
  /** An edge for our `PreboardingProcess`. May be used by Relay 1. */
  preboardingProcessEdge?: Maybe<PreboardingProcessesEdge>;
  /** Reads a single `Process` that is related to this `PreboardingProcess`. */
  process?: Maybe<Process>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PreboardingProcess`. */
  user?: Maybe<User>;
};


/** The output of our delete `PreboardingProcess` mutation. */
export type DeletePreboardingProcessPayloadPreboardingProcessEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingProcessesOrderBy>>;
};

/** All input for the `deletePreboardingResultById` mutation. */
export type DeletePreboardingResultByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PreboardingResult` mutation. */
export type DeletePreboardingResultPayload = {
  __typename?: 'DeletePreboardingResultPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingResult`. */
  company?: Maybe<Company>;
  deletedPreboardingResultId?: Maybe<Scalars['ID']>;
  /** Reads a single `Employee` that is related to this `PreboardingResult`. */
  employee?: Maybe<Employee>;
  /** Reads a single `EngagementType` that is related to this `PreboardingResult`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `PreboardingEmployee` that is related to this `PreboardingResult`. */
  preboardingEmployee?: Maybe<PreboardingEmployee>;
  /** The `PreboardingResult` that was deleted by this mutation. */
  preboardingResult?: Maybe<PreboardingResult>;
  /** An edge for our `PreboardingResult`. May be used by Relay 1. */
  preboardingResultEdge?: Maybe<PreboardingResultsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PreboardingResult`. */
  user?: Maybe<User>;
};


/** The output of our delete `PreboardingResult` mutation. */
export type DeletePreboardingResultPayloadPreboardingResultEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingResultsOrderBy>>;
};

/** All input for the `deletePreboardingResultSlideCommentById` mutation. */
export type DeletePreboardingResultSlideCommentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PreboardingResultSlideComment` mutation. */
export type DeletePreboardingResultSlideCommentPayload = {
  __typename?: 'DeletePreboardingResultSlideCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingResultSlideComment`. */
  company?: Maybe<Company>;
  deletedPreboardingResultSlideCommentId?: Maybe<Scalars['ID']>;
  /** Reads a single `Employee` that is related to this `PreboardingResultSlideComment`. */
  employee?: Maybe<Employee>;
  /** Reads a single `EngagementType` that is related to this `PreboardingResultSlideComment`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `PreboardingResult` that is related to this `PreboardingResultSlideComment`. */
  preboardingResult?: Maybe<PreboardingResult>;
  /** The `PreboardingResultSlideComment` that was deleted by this mutation. */
  preboardingResultSlideComment?: Maybe<PreboardingResultSlideComment>;
  /** An edge for our `PreboardingResultSlideComment`. May be used by Relay 1. */
  preboardingResultSlideCommentEdge?: Maybe<PreboardingResultSlideCommentsEdge>;
  /** Reads a single `PreboardingSlide` that is related to this `PreboardingResultSlideComment`. */
  preboardingSlide?: Maybe<PreboardingSlide>;
  /** Reads a single `User` that is related to this `PreboardingResultSlideComment`. */
  preboardingUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PreboardingResultSlideComment`. */
  user?: Maybe<User>;
};


/** The output of our delete `PreboardingResultSlideComment` mutation. */
export type DeletePreboardingResultSlideCommentPayloadPreboardingResultSlideCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingResultSlideCommentsOrderBy>>;
};

/** All input for the `deletePreboardingSlideFormFieldById` mutation. */
export type DeletePreboardingSlideFormFieldByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PreboardingSlideFormField` mutation. */
export type DeletePreboardingSlideFormFieldPayload = {
  __typename?: 'DeletePreboardingSlideFormFieldPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingSlideFormField`. */
  company?: Maybe<Company>;
  deletedPreboardingSlideFormFieldId?: Maybe<Scalars['ID']>;
  /** Reads a single `EngagementType` that is related to this `PreboardingSlideFormField`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `FormField` that is related to this `PreboardingSlideFormField`. */
  formField?: Maybe<FormField>;
  /** Reads a single `PreboardingSlide` that is related to this `PreboardingSlideFormField`. */
  preboardingSlide?: Maybe<PreboardingSlide>;
  /** The `PreboardingSlideFormField` that was deleted by this mutation. */
  preboardingSlideFormField?: Maybe<PreboardingSlideFormField>;
  /** Reads a single `PreboardingSlideFormField` that is related to this `PreboardingSlideFormField`. */
  preboardingSlideFormFieldByPreboardingSlideFormFieldIdParent?: Maybe<PreboardingSlideFormField>;
  /** An edge for our `PreboardingSlideFormField`. May be used by Relay 1. */
  preboardingSlideFormFieldEdge?: Maybe<PreboardingSlideFormFieldsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PreboardingSlideFormField` mutation. */
export type DeletePreboardingSlideFormFieldPayloadPreboardingSlideFormFieldEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingSlideFormFieldsOrderBy>>;
};

/** All input for the `deleteProcessResponsibleByProcessIdAndResponsibleId` mutation. */
export type DeleteProcessResponsibleByProcessIdAndResponsibleIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  processId: Scalars['UUID'];
  responsibleId: Scalars['UUID'];
};

/** The output of our delete `ProcessResponsible` mutation. */
export type DeleteProcessResponsiblePayload = {
  __typename?: 'DeleteProcessResponsiblePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ProcessResponsible`. */
  company?: Maybe<Company>;
  deletedProcessResponsibleId?: Maybe<Scalars['ID']>;
  /** Reads a single `Process` that is related to this `ProcessResponsible`. */
  process?: Maybe<Process>;
  /** The `ProcessResponsible` that was deleted by this mutation. */
  processResponsible?: Maybe<ProcessResponsible>;
  /** An edge for our `ProcessResponsible`. May be used by Relay 1. */
  processResponsibleEdge?: Maybe<ProcessResponsiblesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Employee` that is related to this `ProcessResponsible`. */
  responsible?: Maybe<Employee>;
  /** Reads a single `User` that is related to this `ProcessResponsible`. */
  responsibleUser?: Maybe<User>;
};


/** The output of our delete `ProcessResponsible` mutation. */
export type DeleteProcessResponsiblePayloadProcessResponsibleEdgeArgs = {
  orderBy?: InputMaybe<Array<ProcessResponsiblesOrderBy>>;
};

/** All input for the `deletePulseSurveyAnswerById` mutation. */
export type DeletePulseSurveyAnswerByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deletePulseSurveyAnswerByUserIdAndPulseSurveyIdAndDate` mutation. */
export type DeletePulseSurveyAnswerByUserIdAndPulseSurveyIdAndDateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  date: Scalars['Date'];
  pulseSurveyId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our delete `PulseSurveyAnswer` mutation. */
export type DeletePulseSurveyAnswerPayload = {
  __typename?: 'DeletePulseSurveyAnswerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PulseSurveyAnswer`. */
  company?: Maybe<Company>;
  deletedPulseSurveyAnswerId?: Maybe<Scalars['ID']>;
  /** Reads a single `PulseSurvey` that is related to this `PulseSurveyAnswer`. */
  pulseSurvey?: Maybe<PulseSurvey>;
  /** The `PulseSurveyAnswer` that was deleted by this mutation. */
  pulseSurveyAnswer?: Maybe<PulseSurveyAnswer>;
  /** An edge for our `PulseSurveyAnswer`. May be used by Relay 1. */
  pulseSurveyAnswerEdge?: Maybe<PulseSurveyAnswersEdge>;
  /** Reads a single `PulseType` that is related to this `PulseSurveyAnswer`. */
  pulseType?: Maybe<PulseType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PulseSurveyAnswer`. */
  user?: Maybe<User>;
};


/** The output of our delete `PulseSurveyAnswer` mutation. */
export type DeletePulseSurveyAnswerPayloadPulseSurveyAnswerEdgeArgs = {
  orderBy?: InputMaybe<Array<PulseSurveyAnswersOrderBy>>;
};

/** All input for the `deletePulseSurveyById` mutation. */
export type DeletePulseSurveyByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deletePulseSurveyChoiceById` mutation. */
export type DeletePulseSurveyChoiceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PulseSurveyChoice` mutation. */
export type DeletePulseSurveyChoicePayload = {
  __typename?: 'DeletePulseSurveyChoicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PulseSurveyChoice`. */
  company?: Maybe<Company>;
  deletedPulseSurveyChoiceId?: Maybe<Scalars['ID']>;
  /** Reads a single `PulseSurvey` that is related to this `PulseSurveyChoice`. */
  pulseSurvey?: Maybe<PulseSurvey>;
  /** The `PulseSurveyChoice` that was deleted by this mutation. */
  pulseSurveyChoice?: Maybe<PulseSurveyChoice>;
  /** An edge for our `PulseSurveyChoice`. May be used by Relay 1. */
  pulseSurveyChoiceEdge?: Maybe<PulseSurveyChoicesEdge>;
  /** Reads a single `PulseType` that is related to this `PulseSurveyChoice`. */
  pulseType?: Maybe<PulseType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseSurveyChoice`. */
  textTranslatedEntity?: Maybe<TranslatedEntity>;
};


/** The output of our delete `PulseSurveyChoice` mutation. */
export type DeletePulseSurveyChoicePayloadPulseSurveyChoiceEdgeArgs = {
  orderBy?: InputMaybe<Array<PulseSurveyChoicesOrderBy>>;
};

/** The output of our delete `PulseSurvey` mutation. */
export type DeletePulseSurveyPayload = {
  __typename?: 'DeletePulseSurveyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PulseSurvey`. */
  company?: Maybe<Company>;
  deletedPulseSurveyId?: Maybe<Scalars['ID']>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseSurvey`. */
  highestRatingLabelTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseSurvey`. */
  lowestRatingLabelTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseSurvey`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** The `PulseSurvey` that was deleted by this mutation. */
  pulseSurvey?: Maybe<PulseSurvey>;
  /** An edge for our `PulseSurvey`. May be used by Relay 1. */
  pulseSurveyEdge?: Maybe<PulseSurveysEdge>;
  /** Reads a single `PulseType` that is related to this `PulseSurvey`. */
  pulseType?: Maybe<PulseType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseSurvey`. */
  questionTranslatedEntity?: Maybe<TranslatedEntity>;
};


/** The output of our delete `PulseSurvey` mutation. */
export type DeletePulseSurveyPayloadPulseSurveyEdgeArgs = {
  orderBy?: InputMaybe<Array<PulseSurveysOrderBy>>;
};

/** All input for the `deletePulseTypeById` mutation. */
export type DeletePulseTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PulseType` mutation. */
export type DeletePulseTypePayload = {
  __typename?: 'DeletePulseTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PulseType`. */
  company?: Maybe<Company>;
  deletedPulseTypeId?: Maybe<Scalars['ID']>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseType`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** The `PulseType` that was deleted by this mutation. */
  pulseType?: Maybe<PulseType>;
  /** An edge for our `PulseType`. May be used by Relay 1. */
  pulseTypeEdge?: Maybe<PulseTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PulseType` mutation. */
export type DeletePulseTypePayloadPulseTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<PulseTypesOrderBy>>;
};

/** All input for the `deletePushTokenByUserId` mutation. */
export type DeletePushTokenByUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  userId: Scalars['UUID'];
};

/** The output of our delete `PushToken` mutation. */
export type DeletePushTokenPayload = {
  __typename?: 'DeletePushTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPushTokenId?: Maybe<Scalars['ID']>;
  /** The `PushToken` that was deleted by this mutation. */
  pushToken?: Maybe<PushToken>;
  /** An edge for our `PushToken`. May be used by Relay 1. */
  pushTokenEdge?: Maybe<PushTokensEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PushToken`. */
  user?: Maybe<User>;
};


/** The output of our delete `PushToken` mutation. */
export type DeletePushTokenPayloadPushTokenEdgeArgs = {
  orderBy?: InputMaybe<Array<PushTokensOrderBy>>;
};

/** All input for the `deleteRecurrenceRuleById` mutation. */
export type DeleteRecurrenceRuleByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteRecurrenceRuleByPulseSurveyId` mutation. */
export type DeleteRecurrenceRuleByPulseSurveyIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  pulseSurveyId: Scalars['UUID'];
};

/** The output of our delete `RecurrenceRule` mutation. */
export type DeleteRecurrenceRulePayload = {
  __typename?: 'DeleteRecurrenceRulePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `RecurrenceRule`. */
  company?: Maybe<Company>;
  deletedRecurrenceRuleId?: Maybe<Scalars['ID']>;
  /** Reads a single `PulseSurvey` that is related to this `RecurrenceRule`. */
  pulseSurvey?: Maybe<PulseSurvey>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RecurrenceRule` that was deleted by this mutation. */
  recurrenceRule?: Maybe<RecurrenceRule>;
  /** An edge for our `RecurrenceRule`. May be used by Relay 1. */
  recurrenceRuleEdge?: Maybe<RecurrenceRulesEdge>;
};


/** The output of our delete `RecurrenceRule` mutation. */
export type DeleteRecurrenceRulePayloadRecurrenceRuleEdgeArgs = {
  orderBy?: InputMaybe<Array<RecurrenceRulesOrderBy>>;
};

/** All input for the `deleteRoadmapItemLocalizationById` mutation. */
export type DeleteRoadmapItemLocalizationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteRoadmapItemLocalizationByRoadmapItemIdAndLocale` mutation. */
export type DeleteRoadmapItemLocalizationByRoadmapItemIdAndLocaleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locale: Scalars['String'];
  roadmapItemId: Scalars['UUID'];
};

/** The output of our delete `RoadmapItemLocalization` mutation. */
export type DeleteRoadmapItemLocalizationPayload = {
  __typename?: 'DeleteRoadmapItemLocalizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoadmapItemLocalizationId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoadmapItem` that is related to this `RoadmapItemLocalization`. */
  roadmapItem?: Maybe<RoadmapItem>;
  /** The `RoadmapItemLocalization` that was deleted by this mutation. */
  roadmapItemLocalization?: Maybe<RoadmapItemLocalization>;
  /** An edge for our `RoadmapItemLocalization`. May be used by Relay 1. */
  roadmapItemLocalizationEdge?: Maybe<RoadmapItemLocalizationsEdge>;
};


/** The output of our delete `RoadmapItemLocalization` mutation. */
export type DeleteRoadmapItemLocalizationPayloadRoadmapItemLocalizationEdgeArgs = {
  orderBy?: InputMaybe<Array<RoadmapItemLocalizationsOrderBy>>;
};

/** All input for the `deleteRoadmapItemVoteById` mutation. */
export type DeleteRoadmapItemVoteByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteRoadmapItemVoteByUserIdAndRoadmapItemId` mutation. */
export type DeleteRoadmapItemVoteByUserIdAndRoadmapItemIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  roadmapItemId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our delete `RoadmapItemVote` mutation. */
export type DeleteRoadmapItemVotePayload = {
  __typename?: 'DeleteRoadmapItemVotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoadmapItemVoteId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoadmapItem` that is related to this `RoadmapItemVote`. */
  roadmapItem?: Maybe<RoadmapItem>;
  /** The `RoadmapItemVote` that was deleted by this mutation. */
  roadmapItemVote?: Maybe<RoadmapItemVote>;
  /** An edge for our `RoadmapItemVote`. May be used by Relay 1. */
  roadmapItemVoteEdge?: Maybe<RoadmapItemVotesEdge>;
  /** Reads a single `User` that is related to this `RoadmapItemVote`. */
  user?: Maybe<User>;
};


/** The output of our delete `RoadmapItemVote` mutation. */
export type DeleteRoadmapItemVotePayloadRoadmapItemVoteEdgeArgs = {
  orderBy?: InputMaybe<Array<RoadmapItemVotesOrderBy>>;
};

/** All input for the `deleteRoleById` mutation. */
export type DeleteRoleByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Role` mutation. */
export type DeleteRolePayload = {
  __typename?: 'DeleteRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRoleId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Role` that was deleted by this mutation. */
  role?: Maybe<Role>;
  /** An edge for our `Role`. May be used by Relay 1. */
  roleEdge?: Maybe<RolesEdge>;
};


/** The output of our delete `Role` mutation. */
export type DeleteRolePayloadRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<RolesOrderBy>>;
};

/** All input for the `deleteSavedSignatureById` mutation. */
export type DeleteSavedSignatureByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `SavedSignature` mutation. */
export type DeleteSavedSignaturePayload = {
  __typename?: 'DeleteSavedSignaturePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSavedSignatureId?: Maybe<Scalars['ID']>;
  /** Reads a single `Employee` that is related to this `SavedSignature`. */
  employee?: Maybe<Employee>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SavedSignature` that was deleted by this mutation. */
  savedSignature?: Maybe<SavedSignature>;
  /** An edge for our `SavedSignature`. May be used by Relay 1. */
  savedSignatureEdge?: Maybe<SavedSignaturesEdge>;
  /** Reads a single `Storage` that is related to this `SavedSignature`. */
  storage?: Maybe<Storage>;
};


/** The output of our delete `SavedSignature` mutation. */
export type DeleteSavedSignaturePayloadSavedSignatureEdgeArgs = {
  orderBy?: InputMaybe<Array<SavedSignaturesOrderBy>>;
};

/** All input for the `deleteScheduledMessageExternalRecipientByScheduledMessageIdAndEmail` mutation. */
export type DeleteScheduledMessageExternalRecipientByScheduledMessageIdAndEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  scheduledMessageId: Scalars['UUID'];
};

/** The output of our delete `ScheduledMessageExternalRecipient` mutation. */
export type DeleteScheduledMessageExternalRecipientPayload = {
  __typename?: 'DeleteScheduledMessageExternalRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ScheduledMessageExternalRecipient`. */
  company?: Maybe<Company>;
  deletedScheduledMessageExternalRecipientId?: Maybe<Scalars['ID']>;
  /** Reads a single `ProcessType` that is related to this `ScheduledMessageExternalRecipient`. */
  processType?: Maybe<ProcessType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ScheduledMessage` that is related to this `ScheduledMessageExternalRecipient`. */
  scheduledMessage?: Maybe<ScheduledMessage>;
  /** The `ScheduledMessageExternalRecipient` that was deleted by this mutation. */
  scheduledMessageExternalRecipient?: Maybe<ScheduledMessageExternalRecipient>;
  /** An edge for our `ScheduledMessageExternalRecipient`. May be used by Relay 1. */
  scheduledMessageExternalRecipientEdge?: Maybe<ScheduledMessageExternalRecipientsEdge>;
};


/** The output of our delete `ScheduledMessageExternalRecipient` mutation. */
export type DeleteScheduledMessageExternalRecipientPayloadScheduledMessageExternalRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledMessageExternalRecipientsOrderBy>>;
};

/** All input for the `deleteScheduledMessageRecipientByScheduledMessageIdAndEmployeeId` mutation. */
export type DeleteScheduledMessageRecipientByScheduledMessageIdAndEmployeeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['UUID'];
  scheduledMessageId: Scalars['UUID'];
};

/** The output of our delete `ScheduledMessageRecipient` mutation. */
export type DeleteScheduledMessageRecipientPayload = {
  __typename?: 'DeleteScheduledMessageRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ScheduledMessageRecipient`. */
  company?: Maybe<Company>;
  deletedScheduledMessageRecipientId?: Maybe<Scalars['ID']>;
  /** Reads a single `Employee` that is related to this `ScheduledMessageRecipient`. */
  employee?: Maybe<Employee>;
  /** Reads a single `ProcessType` that is related to this `ScheduledMessageRecipient`. */
  processType?: Maybe<ProcessType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ScheduledMessage` that is related to this `ScheduledMessageRecipient`. */
  scheduledMessage?: Maybe<ScheduledMessage>;
  /** The `ScheduledMessageRecipient` that was deleted by this mutation. */
  scheduledMessageRecipient?: Maybe<ScheduledMessageRecipient>;
  /** An edge for our `ScheduledMessageRecipient`. May be used by Relay 1. */
  scheduledMessageRecipientEdge?: Maybe<ScheduledMessageRecipientsEdge>;
};


/** The output of our delete `ScheduledMessageRecipient` mutation. */
export type DeleteScheduledMessageRecipientPayloadScheduledMessageRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledMessageRecipientsOrderBy>>;
};

/** All input for the `deleteScheduledMessageTemplateExternalRecipientByScheduledMessageTemplateIdAndEmail` mutation. */
export type DeleteScheduledMessageTemplateExternalRecipientByScheduledMessageTemplateIdAndEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  scheduledMessageTemplateId: Scalars['UUID'];
};

/** The output of our delete `ScheduledMessageTemplateExternalRecipient` mutation. */
export type DeleteScheduledMessageTemplateExternalRecipientPayload = {
  __typename?: 'DeleteScheduledMessageTemplateExternalRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ScheduledMessageTemplateExternalRecipient`. */
  company?: Maybe<Company>;
  deletedScheduledMessageTemplateExternalRecipientId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ScheduledMessageTemplate` that is related to this `ScheduledMessageTemplateExternalRecipient`. */
  scheduledMessageTemplate?: Maybe<ScheduledMessageTemplate>;
  /** The `ScheduledMessageTemplateExternalRecipient` that was deleted by this mutation. */
  scheduledMessageTemplateExternalRecipient?: Maybe<ScheduledMessageTemplateExternalRecipient>;
  /** An edge for our `ScheduledMessageTemplateExternalRecipient`. May be used by Relay 1. */
  scheduledMessageTemplateExternalRecipientEdge?: Maybe<ScheduledMessageTemplateExternalRecipientsEdge>;
};


/** The output of our delete `ScheduledMessageTemplateExternalRecipient` mutation. */
export type DeleteScheduledMessageTemplateExternalRecipientPayloadScheduledMessageTemplateExternalRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledMessageTemplateExternalRecipientsOrderBy>>;
};

/** All input for the `deleteScheduledMessageTemplateRecipientByScheduledMessageTemplateIdAndEmployeeId` mutation. */
export type DeleteScheduledMessageTemplateRecipientByScheduledMessageTemplateIdAndEmployeeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['UUID'];
  scheduledMessageTemplateId: Scalars['UUID'];
};

/** The output of our delete `ScheduledMessageTemplateRecipient` mutation. */
export type DeleteScheduledMessageTemplateRecipientPayload = {
  __typename?: 'DeleteScheduledMessageTemplateRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ScheduledMessageTemplateRecipient`. */
  company?: Maybe<Company>;
  deletedScheduledMessageTemplateRecipientId?: Maybe<Scalars['ID']>;
  /** Reads a single `Employee` that is related to this `ScheduledMessageTemplateRecipient`. */
  employee?: Maybe<Employee>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ScheduledMessageTemplate` that is related to this `ScheduledMessageTemplateRecipient`. */
  scheduledMessageTemplate?: Maybe<ScheduledMessageTemplate>;
  /** The `ScheduledMessageTemplateRecipient` that was deleted by this mutation. */
  scheduledMessageTemplateRecipient?: Maybe<ScheduledMessageTemplateRecipient>;
  /** An edge for our `ScheduledMessageTemplateRecipient`. May be used by Relay 1. */
  scheduledMessageTemplateRecipientEdge?: Maybe<ScheduledMessageTemplateRecipientsEdge>;
};


/** The output of our delete `ScheduledMessageTemplateRecipient` mutation. */
export type DeleteScheduledMessageTemplateRecipientPayloadScheduledMessageTemplateRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledMessageTemplateRecipientsOrderBy>>;
};

/** All input for the `deleteSuperUserAllowedUserById` mutation. */
export type DeleteSuperUserAllowedUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteSuperUserAllowedUserBySuperUserIdAndCompanyId` mutation. */
export type DeleteSuperUserAllowedUserBySuperUserIdAndCompanyIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
  superUserId: Scalars['UUID'];
};

/** The output of our delete `SuperUserAllowedUser` mutation. */
export type DeleteSuperUserAllowedUserPayload = {
  __typename?: 'DeleteSuperUserAllowedUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `SuperUserAllowedUser`. */
  company?: Maybe<Company>;
  deletedSuperUserAllowedUserId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SuperUser` that is related to this `SuperUserAllowedUser`. */
  superUser?: Maybe<SuperUser>;
  /** The `SuperUserAllowedUser` that was deleted by this mutation. */
  superUserAllowedUser?: Maybe<SuperUserAllowedUser>;
  /** An edge for our `SuperUserAllowedUser`. May be used by Relay 1. */
  superUserAllowedUserEdge?: Maybe<SuperUserAllowedUsersEdge>;
};


/** The output of our delete `SuperUserAllowedUser` mutation. */
export type DeleteSuperUserAllowedUserPayloadSuperUserAllowedUserEdgeArgs = {
  orderBy?: InputMaybe<Array<SuperUserAllowedUsersOrderBy>>;
};

/** All input for the `deleteSuperUserById` mutation. */
export type DeleteSuperUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteSuperUserByUserId` mutation. */
export type DeleteSuperUserByUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  userId: Scalars['UUID'];
};

/** The output of our delete `SuperUser` mutation. */
export type DeleteSuperUserPayload = {
  __typename?: 'DeleteSuperUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSuperUserId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SuperUser` that was deleted by this mutation. */
  superUser?: Maybe<SuperUser>;
  /** An edge for our `SuperUser`. May be used by Relay 1. */
  superUserEdge?: Maybe<SuperUsersEdge>;
  /** Reads a single `User` that is related to this `SuperUser`. */
  user?: Maybe<User>;
};


/** The output of our delete `SuperUser` mutation. */
export type DeleteSuperUserPayloadSuperUserEdgeArgs = {
  orderBy?: InputMaybe<Array<SuperUsersOrderBy>>;
};

/** All input for the `deleteSystemFieldTypeByType` mutation. */
export type DeleteSystemFieldTypeByTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

/** The output of our delete `SystemFieldType` mutation. */
export type DeleteSystemFieldTypePayload = {
  __typename?: 'DeleteSystemFieldTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSystemFieldTypeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SystemFieldType` that was deleted by this mutation. */
  systemFieldType?: Maybe<SystemFieldType>;
  /** An edge for our `SystemFieldType`. May be used by Relay 1. */
  systemFieldTypeEdge?: Maybe<SystemFieldTypesEdge>;
};


/** The output of our delete `SystemFieldType` mutation. */
export type DeleteSystemFieldTypePayloadSystemFieldTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<SystemFieldTypesOrderBy>>;
};

/** All input for the `deleteTaskEmployeeByTaskIdAndEmployeeId` mutation. */
export type DeleteTaskEmployeeByTaskIdAndEmployeeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['UUID'];
  taskId: Scalars['UUID'];
};

/** The output of our delete `TaskEmployee` mutation. */
export type DeleteTaskEmployeePayload = {
  __typename?: 'DeleteTaskEmployeePayload';
  /** Reads a single `User` that is related to this `TaskEmployee`. */
  assignedProcessUser?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TaskEmployee`. */
  company?: Maybe<Company>;
  deletedTaskEmployeeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Employee` that is related to this `TaskEmployee`. */
  employee?: Maybe<Employee>;
  /** Reads a single `ProcessType` that is related to this `TaskEmployee`. */
  processType?: Maybe<ProcessType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Task` that is related to this `TaskEmployee`. */
  task?: Maybe<Task>;
  /** The `TaskEmployee` that was deleted by this mutation. */
  taskEmployee?: Maybe<TaskEmployee>;
  /** An edge for our `TaskEmployee`. May be used by Relay 1. */
  taskEmployeeEdge?: Maybe<TaskEmployeesEdge>;
  /** Reads a single `User` that is related to this `TaskEmployee`. */
  user?: Maybe<User>;
};


/** The output of our delete `TaskEmployee` mutation. */
export type DeleteTaskEmployeePayloadTaskEmployeeEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskEmployeesOrderBy>>;
};

/** All input for the `deleteTaskResponsibleByTaskIdAndResponsibleId` mutation. */
export type DeleteTaskResponsibleByTaskIdAndResponsibleIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  responsibleId: Scalars['UUID'];
  taskId: Scalars['UUID'];
};

/** The output of our delete `TaskResponsible` mutation. */
export type DeleteTaskResponsiblePayload = {
  __typename?: 'DeleteTaskResponsiblePayload';
  /** Reads a single `User` that is related to this `TaskResponsible`. */
  assignedProcessUser?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TaskResponsible`. */
  company?: Maybe<Company>;
  deletedTaskResponsibleId?: Maybe<Scalars['ID']>;
  /** Reads a single `ProcessType` that is related to this `TaskResponsible`. */
  processType?: Maybe<ProcessType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Employee` that is related to this `TaskResponsible`. */
  responsible?: Maybe<Employee>;
  /** Reads a single `Task` that is related to this `TaskResponsible`. */
  task?: Maybe<Task>;
  /** The `TaskResponsible` that was deleted by this mutation. */
  taskResponsible?: Maybe<TaskResponsible>;
  /** An edge for our `TaskResponsible`. May be used by Relay 1. */
  taskResponsibleEdge?: Maybe<TaskResponsiblesEdge>;
  /** Reads a single `User` that is related to this `TaskResponsible`. */
  user?: Maybe<User>;
};


/** The output of our delete `TaskResponsible` mutation. */
export type DeleteTaskResponsiblePayloadTaskResponsibleEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskResponsiblesOrderBy>>;
};

/** All input for the `deleteTaskTemplateEmployeeByTaskTemplateIdAndEmployeeId` mutation. */
export type DeleteTaskTemplateEmployeeByTaskTemplateIdAndEmployeeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['UUID'];
  taskTemplateId: Scalars['UUID'];
};

/** The output of our delete `TaskTemplateEmployee` mutation. */
export type DeleteTaskTemplateEmployeePayload = {
  __typename?: 'DeleteTaskTemplateEmployeePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TaskTemplateEmployee`. */
  company?: Maybe<Company>;
  deletedTaskTemplateEmployeeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Employee` that is related to this `TaskTemplateEmployee`. */
  employee?: Maybe<Employee>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TaskTemplate` that is related to this `TaskTemplateEmployee`. */
  taskTemplate?: Maybe<TaskTemplate>;
  /** The `TaskTemplateEmployee` that was deleted by this mutation. */
  taskTemplateEmployee?: Maybe<TaskTemplateEmployee>;
  /** An edge for our `TaskTemplateEmployee`. May be used by Relay 1. */
  taskTemplateEmployeeEdge?: Maybe<TaskTemplateEmployeesEdge>;
};


/** The output of our delete `TaskTemplateEmployee` mutation. */
export type DeleteTaskTemplateEmployeePayloadTaskTemplateEmployeeEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskTemplateEmployeesOrderBy>>;
};

/** All input for the `deleteTaskTemplateResponsibleByTaskTemplateIdAndResponsibleId` mutation. */
export type DeleteTaskTemplateResponsibleByTaskTemplateIdAndResponsibleIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  responsibleId: Scalars['UUID'];
  taskTemplateId: Scalars['UUID'];
};

/** The output of our delete `TaskTemplateResponsible` mutation. */
export type DeleteTaskTemplateResponsiblePayload = {
  __typename?: 'DeleteTaskTemplateResponsiblePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TaskTemplateResponsible`. */
  company?: Maybe<Company>;
  deletedTaskTemplateResponsibleId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Employee` that is related to this `TaskTemplateResponsible`. */
  responsible?: Maybe<Employee>;
  /** Reads a single `TaskTemplate` that is related to this `TaskTemplateResponsible`. */
  taskTemplate?: Maybe<TaskTemplate>;
  /** The `TaskTemplateResponsible` that was deleted by this mutation. */
  taskTemplateResponsible?: Maybe<TaskTemplateResponsible>;
  /** An edge for our `TaskTemplateResponsible`. May be used by Relay 1. */
  taskTemplateResponsibleEdge?: Maybe<TaskTemplateResponsiblesEdge>;
};


/** The output of our delete `TaskTemplateResponsible` mutation. */
export type DeleteTaskTemplateResponsiblePayloadTaskTemplateResponsibleEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskTemplateResponsiblesOrderBy>>;
};

/** All input for the `deleteTemporaryCasefile` mutation. */
export type DeleteTemporaryCasefileInput = {
  _employeeId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `deleteTemporaryCasefile` mutation. */
export type DeleteTemporaryCasefilePayload = {
  __typename?: 'DeleteTemporaryCasefilePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteTimeRegistrationBreakTypeById` mutation. */
export type DeleteTimeRegistrationBreakTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `TimeRegistrationBreakType` mutation. */
export type DeleteTimeRegistrationBreakTypePayload = {
  __typename?: 'DeleteTimeRegistrationBreakTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationBreakType`. */
  company?: Maybe<Company>;
  deletedTimeRegistrationBreakTypeId?: Maybe<Scalars['ID']>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationBreakType`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TimeRegistrationBreakType` that was deleted by this mutation. */
  timeRegistrationBreakType?: Maybe<TimeRegistrationBreakType>;
  /** An edge for our `TimeRegistrationBreakType`. May be used by Relay 1. */
  timeRegistrationBreakTypeEdge?: Maybe<TimeRegistrationBreakTypesEdge>;
};


/** The output of our delete `TimeRegistrationBreakType` mutation. */
export type DeleteTimeRegistrationBreakTypePayloadTimeRegistrationBreakTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationBreakTypesOrderBy>>;
};

/** All input for the `deleteTimeRegistrationEntryById` mutation. */
export type DeleteTimeRegistrationEntryByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `TimeRegistrationEntry` mutation. */
export type DeleteTimeRegistrationEntryPayload = {
  __typename?: 'DeleteTimeRegistrationEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationEntry`. */
  company?: Maybe<Company>;
  deletedTimeRegistrationEntryId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TimeRegistrationBreakType` that is related to this `TimeRegistrationEntry`. */
  timeRegistrationBreakType?: Maybe<TimeRegistrationBreakType>;
  /** The `TimeRegistrationEntry` that was deleted by this mutation. */
  timeRegistrationEntry?: Maybe<TimeRegistrationEntry>;
  /** An edge for our `TimeRegistrationEntry`. May be used by Relay 1. */
  timeRegistrationEntryEdge?: Maybe<TimeRegistrationEntriesEdge>;
  /** Reads a single `TimeRegistrationPresence` that is related to this `TimeRegistrationEntry`. */
  timeRegistrationPresence?: Maybe<TimeRegistrationPresence>;
  /** Reads a single `TimeRegistrationProject` that is related to this `TimeRegistrationEntry`. */
  timeRegistrationProject?: Maybe<TimeRegistrationProject>;
  /** Reads a single `User` that is related to this `TimeRegistrationEntry`. */
  user?: Maybe<User>;
};


/** The output of our delete `TimeRegistrationEntry` mutation. */
export type DeleteTimeRegistrationEntryPayloadTimeRegistrationEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationEntriesOrderBy>>;
};

/** All input for the `deleteTimeRegistrationEntryTemplateById` mutation. */
export type DeleteTimeRegistrationEntryTemplateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `TimeRegistrationEntryTemplate` mutation. */
export type DeleteTimeRegistrationEntryTemplatePayload = {
  __typename?: 'DeleteTimeRegistrationEntryTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationEntryTemplate`. */
  company?: Maybe<Company>;
  deletedTimeRegistrationEntryTemplateId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TimeRegistrationBreakType` that is related to this `TimeRegistrationEntryTemplate`. */
  timeRegistrationBreakType?: Maybe<TimeRegistrationBreakType>;
  /** The `TimeRegistrationEntryTemplate` that was deleted by this mutation. */
  timeRegistrationEntryTemplate?: Maybe<TimeRegistrationEntryTemplate>;
  /** An edge for our `TimeRegistrationEntryTemplate`. May be used by Relay 1. */
  timeRegistrationEntryTemplateEdge?: Maybe<TimeRegistrationEntryTemplatesEdge>;
  /** Reads a single `TimeRegistrationPresenceTemplate` that is related to this `TimeRegistrationEntryTemplate`. */
  timeRegistrationPresenceTemplate?: Maybe<TimeRegistrationPresenceTemplate>;
  /** Reads a single `TimeRegistrationProject` that is related to this `TimeRegistrationEntryTemplate`. */
  timeRegistrationProject?: Maybe<TimeRegistrationProject>;
  /** Reads a single `TimeRegistrationTemplate` that is related to this `TimeRegistrationEntryTemplate`. */
  timeRegistrationTemplate?: Maybe<TimeRegistrationTemplate>;
  /** Reads a single `User` that is related to this `TimeRegistrationEntryTemplate`. */
  user?: Maybe<User>;
};


/** The output of our delete `TimeRegistrationEntryTemplate` mutation. */
export type DeleteTimeRegistrationEntryTemplatePayloadTimeRegistrationEntryTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationEntryTemplatesOrderBy>>;
};

/** All input for the `deleteTimeRegistrationPresenceById` mutation. */
export type DeleteTimeRegistrationPresenceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `TimeRegistrationPresence` mutation. */
export type DeleteTimeRegistrationPresencePayload = {
  __typename?: 'DeleteTimeRegistrationPresencePayload';
  /** Reads a single `Approval` that is related to this `TimeRegistrationPresence`. */
  approval?: Maybe<Approval>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationPresence`. */
  company?: Maybe<Company>;
  deletedTimeRegistrationPresenceId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TimeRegistrationPresence` that was deleted by this mutation. */
  timeRegistrationPresence?: Maybe<TimeRegistrationPresence>;
  /** An edge for our `TimeRegistrationPresence`. May be used by Relay 1. */
  timeRegistrationPresenceEdge?: Maybe<TimeRegistrationPresencesEdge>;
  /** Reads a single `TimeRegistrationPresenceType` that is related to this `TimeRegistrationPresence`. */
  timeRegistrationPresenceType?: Maybe<TimeRegistrationPresenceType>;
  /** Reads a single `User` that is related to this `TimeRegistrationPresence`. */
  user?: Maybe<User>;
};


/** The output of our delete `TimeRegistrationPresence` mutation. */
export type DeleteTimeRegistrationPresencePayloadTimeRegistrationPresenceEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationPresencesOrderBy>>;
};

/** All input for the `deleteTimeRegistrationPresenceTemplateById` mutation. */
export type DeleteTimeRegistrationPresenceTemplateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `TimeRegistrationPresenceTemplate` mutation. */
export type DeleteTimeRegistrationPresenceTemplatePayload = {
  __typename?: 'DeleteTimeRegistrationPresenceTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationPresenceTemplate`. */
  company?: Maybe<Company>;
  deletedTimeRegistrationPresenceTemplateId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TimeRegistrationPresenceTemplate` that was deleted by this mutation. */
  timeRegistrationPresenceTemplate?: Maybe<TimeRegistrationPresenceTemplate>;
  /** An edge for our `TimeRegistrationPresenceTemplate`. May be used by Relay 1. */
  timeRegistrationPresenceTemplateEdge?: Maybe<TimeRegistrationPresenceTemplatesEdge>;
  /** Reads a single `TimeRegistrationPresenceType` that is related to this `TimeRegistrationPresenceTemplate`. */
  timeRegistrationPresenceType?: Maybe<TimeRegistrationPresenceType>;
  /** Reads a single `TimeRegistrationTemplate` that is related to this `TimeRegistrationPresenceTemplate`. */
  timeRegistrationTemplate?: Maybe<TimeRegistrationTemplate>;
  /** Reads a single `TimeRegistrationTemplateWeek` that is related to this `TimeRegistrationPresenceTemplate`. */
  timeRegistrationTemplateWeek?: Maybe<TimeRegistrationTemplateWeek>;
  /** Reads a single `User` that is related to this `TimeRegistrationPresenceTemplate`. */
  user?: Maybe<User>;
};


/** The output of our delete `TimeRegistrationPresenceTemplate` mutation. */
export type DeleteTimeRegistrationPresenceTemplatePayloadTimeRegistrationPresenceTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationPresenceTemplatesOrderBy>>;
};

/** All input for the `deleteTimeRegistrationPresenceTypeById` mutation. */
export type DeleteTimeRegistrationPresenceTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `TimeRegistrationPresenceType` mutation. */
export type DeleteTimeRegistrationPresenceTypePayload = {
  __typename?: 'DeleteTimeRegistrationPresenceTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationPresenceType`. */
  company?: Maybe<Company>;
  deletedTimeRegistrationPresenceTypeId?: Maybe<Scalars['ID']>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationPresenceType`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TimeRegistrationPresenceType` that was deleted by this mutation. */
  timeRegistrationPresenceType?: Maybe<TimeRegistrationPresenceType>;
  /** An edge for our `TimeRegistrationPresenceType`. May be used by Relay 1. */
  timeRegistrationPresenceTypeEdge?: Maybe<TimeRegistrationPresenceTypesEdge>;
};


/** The output of our delete `TimeRegistrationPresenceType` mutation. */
export type DeleteTimeRegistrationPresenceTypePayloadTimeRegistrationPresenceTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationPresenceTypesOrderBy>>;
};

/** All input for the `deleteTimeRegistrationProjectById` mutation. */
export type DeleteTimeRegistrationProjectByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `TimeRegistrationProject` mutation. */
export type DeleteTimeRegistrationProjectPayload = {
  __typename?: 'DeleteTimeRegistrationProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationProject`. */
  company?: Maybe<Company>;
  deletedTimeRegistrationProjectId?: Maybe<Scalars['ID']>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationProject`. */
  descriptionTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationProject`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TimeRegistrationProject` that was deleted by this mutation. */
  timeRegistrationProject?: Maybe<TimeRegistrationProject>;
  /** An edge for our `TimeRegistrationProject`. May be used by Relay 1. */
  timeRegistrationProjectEdge?: Maybe<TimeRegistrationProjectsEdge>;
};


/** The output of our delete `TimeRegistrationProject` mutation. */
export type DeleteTimeRegistrationProjectPayloadTimeRegistrationProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationProjectsOrderBy>>;
};

/** All input for the `deleteTimeRegistrationTemplateById` mutation. */
export type DeleteTimeRegistrationTemplateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `TimeRegistrationTemplate` mutation. */
export type DeleteTimeRegistrationTemplatePayload = {
  __typename?: 'DeleteTimeRegistrationTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationTemplate`. */
  company?: Maybe<Company>;
  deletedTimeRegistrationTemplateId?: Maybe<Scalars['ID']>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationTemplate`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TimeRegistrationTemplate` that was deleted by this mutation. */
  timeRegistrationTemplate?: Maybe<TimeRegistrationTemplate>;
  /** An edge for our `TimeRegistrationTemplate`. May be used by Relay 1. */
  timeRegistrationTemplateEdge?: Maybe<TimeRegistrationTemplatesEdge>;
};


/** The output of our delete `TimeRegistrationTemplate` mutation. */
export type DeleteTimeRegistrationTemplatePayloadTimeRegistrationTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationTemplatesOrderBy>>;
};

/** All input for the `deleteTimeRegistrationTemplateWeekById` mutation. */
export type DeleteTimeRegistrationTemplateWeekByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `TimeRegistrationTemplateWeek` mutation. */
export type DeleteTimeRegistrationTemplateWeekPayload = {
  __typename?: 'DeleteTimeRegistrationTemplateWeekPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationTemplateWeek`. */
  company?: Maybe<Company>;
  deletedTimeRegistrationTemplateWeekId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TimeRegistrationTemplate` that is related to this `TimeRegistrationTemplateWeek`. */
  timeRegistrationTemplate?: Maybe<TimeRegistrationTemplate>;
  /** The `TimeRegistrationTemplateWeek` that was deleted by this mutation. */
  timeRegistrationTemplateWeek?: Maybe<TimeRegistrationTemplateWeek>;
  /** An edge for our `TimeRegistrationTemplateWeek`. May be used by Relay 1. */
  timeRegistrationTemplateWeekEdge?: Maybe<TimeRegistrationTemplateWeeksEdge>;
  /** Reads a single `User` that is related to this `TimeRegistrationTemplateWeek`. */
  user?: Maybe<User>;
};


/** The output of our delete `TimeRegistrationTemplateWeek` mutation. */
export type DeleteTimeRegistrationTemplateWeekPayloadTimeRegistrationTemplateWeekEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationTemplateWeeksOrderBy>>;
};

/** All input for the `deleteTranslatedEntityById` mutation. */
export type DeleteTranslatedEntityByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteTranslatedEntityLocalizationById` mutation. */
export type DeleteTranslatedEntityLocalizationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteTranslatedEntityLocalizationByTranslatedEntityIdAndLocale` mutation. */
export type DeleteTranslatedEntityLocalizationByTranslatedEntityIdAndLocaleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locale: Scalars['String'];
  translatedEntityId: Scalars['UUID'];
};

/** The output of our delete `TranslatedEntityLocalization` mutation. */
export type DeleteTranslatedEntityLocalizationPayload = {
  __typename?: 'DeleteTranslatedEntityLocalizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TranslatedEntityLocalization`. */
  company?: Maybe<Company>;
  deletedTranslatedEntityLocalizationId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TranslatedEntity` that is related to this `TranslatedEntityLocalization`. */
  translatedEntity?: Maybe<TranslatedEntity>;
  /** The `TranslatedEntityLocalization` that was deleted by this mutation. */
  translatedEntityLocalization?: Maybe<TranslatedEntityLocalization>;
  /** An edge for our `TranslatedEntityLocalization`. May be used by Relay 1. */
  translatedEntityLocalizationEdge?: Maybe<TranslatedEntityLocalizationsEdge>;
};


/** The output of our delete `TranslatedEntityLocalization` mutation. */
export type DeleteTranslatedEntityLocalizationPayloadTranslatedEntityLocalizationEdgeArgs = {
  orderBy?: InputMaybe<Array<TranslatedEntityLocalizationsOrderBy>>;
};

/** The output of our delete `TranslatedEntity` mutation. */
export type DeleteTranslatedEntityPayload = {
  __typename?: 'DeleteTranslatedEntityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TranslatedEntity`. */
  company?: Maybe<Company>;
  deletedTranslatedEntityId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TranslatedEntity` that was deleted by this mutation. */
  translatedEntity?: Maybe<TranslatedEntity>;
  /** An edge for our `TranslatedEntity`. May be used by Relay 1. */
  translatedEntityEdge?: Maybe<TranslatedEntitiesEdge>;
};


/** The output of our delete `TranslatedEntity` mutation. */
export type DeleteTranslatedEntityPayloadTranslatedEntityEdgeArgs = {
  orderBy?: InputMaybe<Array<TranslatedEntitiesOrderBy>>;
};

/** All input for the `deleteTranslationById` mutation. */
export type DeleteTranslationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Translation` mutation. */
export type DeleteTranslationPayload = {
  __typename?: 'DeleteTranslationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Translation`. */
  company?: Maybe<Company>;
  deletedTranslationId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Translation` that was deleted by this mutation. */
  translation?: Maybe<Translation>;
  /** An edge for our `Translation`. May be used by Relay 1. */
  translationEdge?: Maybe<TranslationsEdge>;
};


/** The output of our delete `Translation` mutation. */
export type DeleteTranslationPayloadTranslationEdgeArgs = {
  orderBy?: InputMaybe<Array<TranslationsOrderBy>>;
};

/** All input for the `deleteUserAnnouncementByUserIdAndAnnouncementId` mutation. */
export type DeleteUserAnnouncementByUserIdAndAnnouncementIdInput = {
  announcementId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  userId: Scalars['UUID'];
};

/** The output of our delete `UserAnnouncement` mutation. */
export type DeleteUserAnnouncementPayload = {
  __typename?: 'DeleteUserAnnouncementPayload';
  /** Reads a single `Announcement` that is related to this `UserAnnouncement`. */
  announcement?: Maybe<Announcement>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUserAnnouncementId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserAnnouncement`. */
  user?: Maybe<User>;
  /** The `UserAnnouncement` that was deleted by this mutation. */
  userAnnouncement?: Maybe<UserAnnouncement>;
  /** An edge for our `UserAnnouncement`. May be used by Relay 1. */
  userAnnouncementEdge?: Maybe<UserAnnouncementsEdge>;
};


/** The output of our delete `UserAnnouncement` mutation. */
export type DeleteUserAnnouncementPayloadUserAnnouncementEdgeArgs = {
  orderBy?: InputMaybe<Array<UserAnnouncementsOrderBy>>;
};

/** All input for the `deleteUserCompanyGroupByUserIdAndGroupIdAndCompanyId` mutation. */
export type DeleteUserCompanyGroupByUserIdAndGroupIdAndCompanyIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our delete `UserCompanyGroup` mutation. */
export type DeleteUserCompanyGroupPayload = {
  __typename?: 'DeleteUserCompanyGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserCompanyGroup`. */
  company?: Maybe<Company>;
  deletedUserCompanyGroupId?: Maybe<Scalars['ID']>;
  /** Reads a single `Group` that is related to this `UserCompanyGroup`. */
  group?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserCompanyGroup`. */
  user?: Maybe<User>;
  /** The `UserCompanyGroup` that was deleted by this mutation. */
  userCompanyGroup?: Maybe<UserCompanyGroup>;
  /** An edge for our `UserCompanyGroup`. May be used by Relay 1. */
  userCompanyGroupEdge?: Maybe<UserCompanyGroupsEdge>;
};


/** The output of our delete `UserCompanyGroup` mutation. */
export type DeleteUserCompanyGroupPayloadUserCompanyGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCompanyGroupsOrderBy>>;
};

/** All input for the `deleteUserCompanyRoleByUserIdAndRoleIdAndCompanyId` mutation. */
export type DeleteUserCompanyRoleByUserIdAndRoleIdAndCompanyIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our delete `UserCompanyRole` mutation. */
export type DeleteUserCompanyRolePayload = {
  __typename?: 'DeleteUserCompanyRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserCompanyRole`. */
  company?: Maybe<Company>;
  deletedUserCompanyRoleId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Role` that is related to this `UserCompanyRole`. */
  role?: Maybe<Role>;
  /** Reads a single `User` that is related to this `UserCompanyRole`. */
  user?: Maybe<User>;
  /** The `UserCompanyRole` that was deleted by this mutation. */
  userCompanyRole?: Maybe<UserCompanyRole>;
  /** An edge for our `UserCompanyRole`. May be used by Relay 1. */
  userCompanyRoleEdge?: Maybe<UserCompanyRolesEdge>;
};


/** The output of our delete `UserCompanyRole` mutation. */
export type DeleteUserCompanyRolePayloadUserCompanyRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCompanyRolesOrderBy>>;
};

/** All input for the `deleteUserDepartmentByDepartmentIdAndUserId` mutation. */
export type DeleteUserDepartmentByDepartmentIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  departmentId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** All input for the `deleteUserDepartmentById` mutation. */
export type DeleteUserDepartmentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteUserDepartmentGroupByUserIdAndDepartmentIdAndGroupId` mutation. */
export type DeleteUserDepartmentGroupByUserIdAndDepartmentIdAndGroupIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  departmentId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our delete `UserDepartmentGroup` mutation. */
export type DeleteUserDepartmentGroupPayload = {
  __typename?: 'DeleteUserDepartmentGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserDepartmentGroup`. */
  company?: Maybe<Company>;
  deletedUserDepartmentGroupId?: Maybe<Scalars['ID']>;
  /** Reads a single `Department` that is related to this `UserDepartmentGroup`. */
  department?: Maybe<Department>;
  /** Reads a single `Group` that is related to this `UserDepartmentGroup`. */
  group?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserDepartmentGroup`. */
  user?: Maybe<User>;
  /** The `UserDepartmentGroup` that was deleted by this mutation. */
  userDepartmentGroup?: Maybe<UserDepartmentGroup>;
  /** An edge for our `UserDepartmentGroup`. May be used by Relay 1. */
  userDepartmentGroupEdge?: Maybe<UserDepartmentGroupsEdge>;
};


/** The output of our delete `UserDepartmentGroup` mutation. */
export type DeleteUserDepartmentGroupPayloadUserDepartmentGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UserDepartmentGroupsOrderBy>>;
};

/** The output of our delete `UserDepartment` mutation. */
export type DeleteUserDepartmentPayload = {
  __typename?: 'DeleteUserDepartmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserDepartment`. */
  company?: Maybe<Company>;
  deletedUserDepartmentId?: Maybe<Scalars['ID']>;
  /** Reads a single `Department` that is related to this `UserDepartment`. */
  department?: Maybe<Department>;
  /** Reads a single `UserDepartment` that is related to this `UserDepartment`. */
  parentUserDepartment?: Maybe<UserDepartment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Rank` that is related to this `UserDepartment`. */
  rank?: Maybe<Rank>;
  /** Reads a single `User` that is related to this `UserDepartment`. */
  user?: Maybe<User>;
  /** The `UserDepartment` that was deleted by this mutation. */
  userDepartment?: Maybe<UserDepartment>;
  /** An edge for our `UserDepartment`. May be used by Relay 1. */
  userDepartmentEdge?: Maybe<UserDepartmentsEdge>;
};


/** The output of our delete `UserDepartment` mutation. */
export type DeleteUserDepartmentPayloadUserDepartmentEdgeArgs = {
  orderBy?: InputMaybe<Array<UserDepartmentsOrderBy>>;
};

/** All input for the `deleteUserDepartmentRoleByUserIdAndDepartmentIdAndRoleId` mutation. */
export type DeleteUserDepartmentRoleByUserIdAndDepartmentIdAndRoleIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  departmentId: Scalars['UUID'];
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our delete `UserDepartmentRole` mutation. */
export type DeleteUserDepartmentRolePayload = {
  __typename?: 'DeleteUserDepartmentRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserDepartmentRole`. */
  company?: Maybe<Company>;
  deletedUserDepartmentRoleId?: Maybe<Scalars['ID']>;
  /** Reads a single `Department` that is related to this `UserDepartmentRole`. */
  department?: Maybe<Department>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Role` that is related to this `UserDepartmentRole`. */
  role?: Maybe<Role>;
  /** Reads a single `User` that is related to this `UserDepartmentRole`. */
  user?: Maybe<User>;
  /** The `UserDepartmentRole` that was deleted by this mutation. */
  userDepartmentRole?: Maybe<UserDepartmentRole>;
  /** An edge for our `UserDepartmentRole`. May be used by Relay 1. */
  userDepartmentRoleEdge?: Maybe<UserDepartmentRolesEdge>;
};


/** The output of our delete `UserDepartmentRole` mutation. */
export type DeleteUserDepartmentRolePayloadUserDepartmentRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserDepartmentRolesOrderBy>>;
};

/** All input for the `deleteUserGroupByUserIdAndGroupId` mutation. */
export type DeleteUserGroupByUserIdAndGroupIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our delete `UserGroup` mutation. */
export type DeleteUserGroupPayload = {
  __typename?: 'DeleteUserGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserGroup`. */
  company?: Maybe<Company>;
  deletedUserGroupId?: Maybe<Scalars['ID']>;
  /** Reads a single `Group` that is related to this `UserGroup`. */
  group?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserGroup`. */
  user?: Maybe<User>;
  /** The `UserGroup` that was deleted by this mutation. */
  userGroup?: Maybe<UserGroup>;
  /** An edge for our `UserGroup`. May be used by Relay 1. */
  userGroupEdge?: Maybe<UserGroupsEdge>;
};


/** The output of our delete `UserGroup` mutation. */
export type DeleteUserGroupPayloadUserGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UserGroupsOrderBy>>;
};

/** All input for the `deleteUserOnBehalfPermissionById` mutation. */
export type DeleteUserOnBehalfPermissionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `UserOnBehalfPermission` mutation. */
export type DeleteUserOnBehalfPermissionPayload = {
  __typename?: 'DeleteUserOnBehalfPermissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserOnBehalfPermission`. */
  company?: Maybe<Company>;
  deletedUserOnBehalfPermissionId?: Maybe<Scalars['ID']>;
  /** Reads a single `User` that is related to this `UserOnBehalfPermission`. */
  onBehalfOfUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserOnBehalfPermission`. */
  user?: Maybe<User>;
  /** The `UserOnBehalfPermission` that was deleted by this mutation. */
  userOnBehalfPermission?: Maybe<UserOnBehalfPermission>;
  /** An edge for our `UserOnBehalfPermission`. May be used by Relay 1. */
  userOnBehalfPermissionEdge?: Maybe<UserOnBehalfPermissionsEdge>;
};


/** The output of our delete `UserOnBehalfPermission` mutation. */
export type DeleteUserOnBehalfPermissionPayloadUserOnBehalfPermissionEdgeArgs = {
  orderBy?: InputMaybe<Array<UserOnBehalfPermissionsOrderBy>>;
};

/** All input for the `deleteUserRoleByUserIdAndRoleId` mutation. */
export type DeleteUserRoleByUserIdAndRoleIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our delete `UserRole` mutation. */
export type DeleteUserRolePayload = {
  __typename?: 'DeleteUserRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserRole`. */
  company?: Maybe<Company>;
  deletedUserRoleId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Role` that is related to this `UserRole`. */
  role?: Maybe<Role>;
  /** Reads a single `User` that is related to this `UserRole`. */
  user?: Maybe<User>;
  /** The `UserRole` that was deleted by this mutation. */
  userRole?: Maybe<UserRole>;
  /** An edge for our `UserRole`. May be used by Relay 1. */
  userRoleEdge?: Maybe<UserRolesEdge>;
};


/** The output of our delete `UserRole` mutation. */
export type DeleteUserRolePayloadUserRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
};

/** All input for the `deleteUserSettingByUserIdAndKey` mutation. */
export type DeleteUserSettingByUserIdAndKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: UserSettingKey;
  userId: Scalars['UUID'];
};

/** The output of our delete `UserSetting` mutation. */
export type DeleteUserSettingPayload = {
  __typename?: 'DeleteUserSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUserSettingId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserSetting`. */
  user?: Maybe<User>;
  /** The `UserSetting` that was deleted by this mutation. */
  userSetting?: Maybe<UserSetting>;
  /** An edge for our `UserSetting`. May be used by Relay 1. */
  userSettingEdge?: Maybe<UserSettingsEdge>;
};


/** The output of our delete `UserSetting` mutation. */
export type DeleteUserSettingPayloadUserSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
};

export type Department = {
  __typename?: 'Department';
  active: Scalars['Boolean'];
  address: Scalars['String'];
  alias?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  /** Reads a single `Company` that is related to this `Department`. */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `ContractTemplateDepartment`. */
  contractTemplateDepartments: ContractTemplateDepartmentsConnection;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  customId?: Maybe<Scalars['String']>;
  cvr?: Maybe<Scalars['String']>;
  deleteAt?: Maybe<Scalars['Date']>;
  departmentNumber?: Maybe<Scalars['String']>;
  /** Reads a single `DepartmentType` that is related to this `Department`. */
  departmentType?: Maybe<DepartmentType>;
  departmentTypeId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `Department`. */
  departmentsByParentDepartmentId: DepartmentsConnection;
  description?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `DocumentDepartmentPermission`. */
  documentDepartmentPermissions: DocumentDepartmentPermissionsConnection;
  /** Reads and enables pagination through a set of `DocumentFolderDepartment`. */
  documentFolderDepartments: DocumentFolderDepartmentsConnection;
  ean?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  /** Reads and enables pagination through a set of `FormFieldEntry`. */
  formFieldEntries: FormFieldEntriesConnection;
  /** Reads and enables pagination through a set of `FormFieldEntry`. */
  formFieldEntriesByProductDepartmentId: FormFieldEntriesConnection;
  hasChildren?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  leaderUserIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  mainDepartment: Scalars['Boolean'];
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferences: NotificationEmployeeReferencesConnection;
  numberOfActiveEmployees?: Maybe<Scalars['BigInt']>;
  pNumber?: Maybe<Scalars['Int']>;
  /** Reads a single `Department` that is related to this `Department`. */
  parentDepartment?: Maybe<Department>;
  parentDepartmentId?: Maybe<Scalars['UUID']>;
  phone: Scalars['String'];
  postalCode: Scalars['String'];
  /** Reads and enables pagination through a set of `Product`. */
  products: ProductsConnection;
  ruleBreachesSummary: DepartmentRuleBreachesSummaryConnection;
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `UserDepartmentGroup`. */
  userDepartmentGroups: UserDepartmentGroupsConnection;
  /** Reads and enables pagination through a set of `UserDepartmentRole`. */
  userDepartmentRoles: UserDepartmentRolesConnection;
  /** Reads and enables pagination through a set of `UserDepartment`. */
  userDepartments: UserDepartmentsConnection;
};


export type DepartmentContractTemplateDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractTemplateDepartmentCondition>;
  filter?: InputMaybe<ContractTemplateDepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractTemplateDepartmentsOrderBy>>;
};


export type DepartmentDepartmentsByParentDepartmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DepartmentCondition>;
  filter?: InputMaybe<DepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DepartmentsOrderBy>>;
};


export type DepartmentDocumentDepartmentPermissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentDepartmentPermissionCondition>;
  filter?: InputMaybe<DocumentDepartmentPermissionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentDepartmentPermissionsOrderBy>>;
};


export type DepartmentDocumentFolderDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentFolderDepartmentCondition>;
  filter?: InputMaybe<DocumentFolderDepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentFolderDepartmentsOrderBy>>;
};


export type DepartmentFormFieldEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldEntryCondition>;
  filter?: InputMaybe<FormFieldEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldEntriesOrderBy>>;
};


export type DepartmentFormFieldEntriesByProductDepartmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldEntryCondition>;
  filter?: InputMaybe<FormFieldEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldEntriesOrderBy>>;
};


export type DepartmentNotificationEmployeeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};


export type DepartmentProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProductCondition>;
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type DepartmentRuleBreachesSummaryArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<DepartmentRuleBreachesSummaryRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  fromDate?: InputMaybe<Scalars['Datetime']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type DepartmentUserDepartmentGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserDepartmentGroupCondition>;
  filter?: InputMaybe<UserDepartmentGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserDepartmentGroupsOrderBy>>;
};


export type DepartmentUserDepartmentRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserDepartmentRoleCondition>;
  filter?: InputMaybe<UserDepartmentRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserDepartmentRolesOrderBy>>;
};


export type DepartmentUserDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserDepartmentCondition>;
  filter?: InputMaybe<UserDepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserDepartmentsOrderBy>>;
};

/** The `department` to be created by this mutation. */
export type DepartmentCompanyIdForeignConnectionDepartmentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** Input for the nested mutation of `company` in the `DepartmentInput` mutation. */
export type DepartmentCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnDepartmentForDepartmentCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `department` in the `CompanyInput` mutation. */
export type DepartmentCompanyIdForeignInverseInput = {
  /** The primary key(s) for `department` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DepartmentDepartmentPkeyConnect>>;
  /** A `DepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DepartmentCompanyIdForeignConnectionDepartmentCreateInput>>;
  /** The primary key(s) and patch data for `department` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DepartmentOnDepartmentForDepartmentCompanyIdForeignUsingDepartmentPkeyUpdate>>;
};

/**
 * A condition to be used against `Department` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type DepartmentCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `address` field. */
  address?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `alias` field. */
  alias?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `country` field. */
  country?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `customId` field. */
  customId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `cvr` field. */
  cvr?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `deleteAt` field. */
  deleteAt?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `departmentNumber` field. */
  departmentNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `departmentTypeId` field. */
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `ean` field. */
  ean?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `mainDepartment` field. */
  mainDepartment?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `pNumber` field. */
  pNumber?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `parentDepartmentId` field. */
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `phone` field. */
  phone?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `postalCode` field. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `department` to look up the row to connect. */
export type DepartmentDepartmentPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `department` to be created by this mutation. */
export type DepartmentDepartmentTypeIdForeignConnectionDepartmentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** The `departmentType` to be created by this mutation. */
export type DepartmentDepartmentTypeIdForeignConnectionDepartmentTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<DepartmentDepartmentTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
};

/** Input for the nested mutation of `departmentType` in the `DepartmentInput` mutation. */
export type DepartmentDepartmentTypeIdForeignInput = {
  /** The primary key(s) for `departmentType` for the far side of the relationship. */
  connectById?: InputMaybe<DepartmentTypeDepartmentTypePkeyConnect>;
  /** A `DepartmentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<DepartmentDepartmentTypeIdForeignConnectionDepartmentTypeCreateInput>;
  /** The primary key(s) and patch data for `departmentType` for the far side of the relationship. */
  updateById?: InputMaybe<DepartmentTypeOnDepartmentForDepartmentDepartmentTypeIdForeignUsingDepartmentTypePkeyUpdate>;
};

/** Input for the nested mutation of `department` in the `DepartmentTypeInput` mutation. */
export type DepartmentDepartmentTypeIdForeignInverseInput = {
  /** The primary key(s) for `department` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DepartmentDepartmentPkeyConnect>>;
  /** A `DepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DepartmentDepartmentTypeIdForeignConnectionDepartmentCreateInput>>;
  /** The primary key(s) and patch data for `department` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DepartmentOnDepartmentForDepartmentDepartmentTypeIdForeignUsingDepartmentPkeyUpdate>>;
};

/** All input for the `departmentDescendants` mutation. */
export type DepartmentDescendantsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `departmentDescendants` mutation. */
export type DepartmentDescendantsPayload = {
  __typename?: 'DepartmentDescendantsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  uuids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};

/** A connection to a list of `JSON` values. */
export type DepartmentEmployeeHierarchyConnection = {
  __typename?: 'DepartmentEmployeeHierarchyConnection';
  /** A list of edges which contains the `JSON` and cursor to aid in pagination. */
  edges: Array<DepartmentEmployeeHierarchyEdge>;
  /** A list of `JSON` objects. */
  nodes: Array<Maybe<Scalars['JSON']>>;
  /** The count of *all* `JSON` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `JSON` edge in the connection. */
export type DepartmentEmployeeHierarchyEdge = {
  __typename?: 'DepartmentEmployeeHierarchyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `JSON` at the end of the edge. */
  node?: Maybe<Scalars['JSON']>;
};

/** A filter to be used against `Department` object types. All fields are combined with a logical ‘and.’ */
export type DepartmentFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `address` field. */
  address?: InputMaybe<StringFilter>;
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DepartmentFilter>>;
  /** Filter by the object’s `city` field. */
  city?: InputMaybe<StringFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** A related `company` exists. */
  companyExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `contractTemplateDepartments` relation. */
  contractTemplateDepartments?: InputMaybe<DepartmentToManyContractTemplateDepartmentFilter>;
  /** Some related `contractTemplateDepartments` exist. */
  contractTemplateDepartmentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `country` field. */
  country?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `customId` field. */
  customId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `cvr` field. */
  cvr?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deleteAt` field. */
  deleteAt?: InputMaybe<DateFilter>;
  /** Filter by the object’s `departmentNumber` field. */
  departmentNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `departmentType` relation. */
  departmentType?: InputMaybe<DepartmentTypeFilter>;
  /** A related `departmentType` exists. */
  departmentTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `departmentTypeId` field. */
  departmentTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departmentsByParentDepartmentId` relation. */
  departmentsByParentDepartmentId?: InputMaybe<DepartmentToManyDepartmentFilter>;
  /** Some related `departmentsByParentDepartmentId` exist. */
  departmentsByParentDepartmentIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `documentDepartmentPermissions` relation. */
  documentDepartmentPermissions?: InputMaybe<DepartmentToManyDocumentDepartmentPermissionFilter>;
  /** Some related `documentDepartmentPermissions` exist. */
  documentDepartmentPermissionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentFolderDepartments` relation. */
  documentFolderDepartments?: InputMaybe<DepartmentToManyDocumentFolderDepartmentFilter>;
  /** Some related `documentFolderDepartments` exist. */
  documentFolderDepartmentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `ean` field. */
  ean?: InputMaybe<StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `formFieldEntries` relation. */
  formFieldEntries?: InputMaybe<DepartmentToManyFormFieldEntryFilter>;
  /** Filter by the object’s `formFieldEntriesByProductDepartmentId` relation. */
  formFieldEntriesByProductDepartmentId?: InputMaybe<DepartmentToManyFormFieldEntryFilter>;
  /** Some related `formFieldEntriesByProductDepartmentId` exist. */
  formFieldEntriesByProductDepartmentIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `formFieldEntries` exist. */
  formFieldEntriesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `hasChildren` field. */
  hasChildren?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `leaderUserIds` field. */
  leaderUserIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `mainDepartment` field. */
  mainDepartment?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DepartmentFilter>;
  /** Filter by the object’s `notificationEmployeeReferences` relation. */
  notificationEmployeeReferences?: InputMaybe<DepartmentToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferences` exist. */
  notificationEmployeeReferencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `numberOfActiveEmployees` field. */
  numberOfActiveEmployees?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DepartmentFilter>>;
  /** Filter by the object’s `pNumber` field. */
  pNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `parentDepartment` relation. */
  parentDepartment?: InputMaybe<DepartmentFilter>;
  /** A related `parentDepartment` exists. */
  parentDepartmentExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `parentDepartmentId` field. */
  parentDepartmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `phone` field. */
  phone?: InputMaybe<StringFilter>;
  /** Filter by the object’s `postalCode` field. */
  postalCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `products` relation. */
  products?: InputMaybe<DepartmentToManyProductFilter>;
  /** Some related `products` exist. */
  productsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userDepartmentGroups` relation. */
  userDepartmentGroups?: InputMaybe<DepartmentToManyUserDepartmentGroupFilter>;
  /** Some related `userDepartmentGroups` exist. */
  userDepartmentGroupsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userDepartmentRoles` relation. */
  userDepartmentRoles?: InputMaybe<DepartmentToManyUserDepartmentRoleFilter>;
  /** Some related `userDepartmentRoles` exist. */
  userDepartmentRolesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userDepartments` relation. */
  userDepartments?: InputMaybe<DepartmentToManyUserDepartmentFilter>;
  /** Some related `userDepartments` exist. */
  userDepartmentsExist?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `Department` */
export type DepartmentInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** The fields on `department` to look up the row to update. */
export type DepartmentOnContractTemplateDepartmentForContractTemplateDepartmentsDepartmentIdForeignUsingDepartmentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `department` being updated. */
  patch: UpdateDepartmentOnContractTemplateDepartmentForContractTemplateDepartmentsDepartmentIdForeignPatch;
};

/** The fields on `department` to look up the row to update. */
export type DepartmentOnDepartmentForDepartmentCompanyIdForeignUsingDepartmentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `department` being updated. */
  patch: UpdateDepartmentOnDepartmentForDepartmentCompanyIdForeignPatch;
};

/** The fields on `department` to look up the row to update. */
export type DepartmentOnDepartmentForDepartmentDepartmentTypeIdForeignUsingDepartmentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `department` being updated. */
  patch: UpdateDepartmentOnDepartmentForDepartmentDepartmentTypeIdForeignPatch;
};

/** The fields on `department` to look up the row to update. */
export type DepartmentOnDepartmentForDepartmentParentDepartmentIdForeignUsingDepartmentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `department` being updated. */
  patch: UpdateDepartmentOnDepartmentForDepartmentParentDepartmentIdForeignPatch;
};

/** The fields on `department` to look up the row to update. */
export type DepartmentOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsDepartmentIdForeignUsingDepartmentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `department` being updated. */
  patch: UpdateDepartmentOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsDepartmentIdForeignPatch;
};

/** The fields on `department` to look up the row to update. */
export type DepartmentOnDocumentFolderDepartmentForDocumentFolderDepartmentDepartmentIdForeignUsingDepartmentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `department` being updated. */
  patch: UpdateDepartmentOnDocumentFolderDepartmentForDocumentFolderDepartmentDepartmentIdForeignPatch;
};

/** The fields on `department` to look up the row to update. */
export type DepartmentOnFormFieldEntryForFormFieldEntryDepartmentIdForeignUsingDepartmentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `department` being updated. */
  patch: UpdateDepartmentOnFormFieldEntryForFormFieldEntryDepartmentIdForeignPatch;
};

/** The fields on `department` to look up the row to update. */
export type DepartmentOnNotificationEmployeeReferenceForNotificationEmployeeReferenceDepartmentIdForeignUsingDepartmentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `department` being updated. */
  patch: UpdateDepartmentOnNotificationEmployeeReferenceForNotificationEmployeeReferenceDepartmentIdForeignPatch;
};

/** The fields on `department` to look up the row to update. */
export type DepartmentOnProductForProductDepartmentIdForeignUsingDepartmentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `department` being updated. */
  patch: UpdateDepartmentOnProductForProductDepartmentIdForeignPatch;
};

/** The fields on `department` to look up the row to update. */
export type DepartmentOnUserDepartmentForUserDepartmentDepartmentIdForeignUsingDepartmentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `department` being updated. */
  patch: UpdateDepartmentOnUserDepartmentForUserDepartmentDepartmentIdForeignPatch;
};

/** The fields on `department` to look up the row to update. */
export type DepartmentOnUserDepartmentGroupForUserDepartmentGroupDepartmentIdForeignUsingDepartmentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `department` being updated. */
  patch: UpdateDepartmentOnUserDepartmentGroupForUserDepartmentGroupDepartmentIdForeignPatch;
};

/** The fields on `department` to look up the row to update. */
export type DepartmentOnUserDepartmentRoleForUserDepartmentRoleDepartmentIdForeignUsingDepartmentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `department` being updated. */
  patch: UpdateDepartmentOnUserDepartmentRoleForUserDepartmentRoleDepartmentIdForeignPatch;
};

/** The `department` to be created by this mutation. */
export type DepartmentParentDepartmentIdForeignConnectionDepartmentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** Input for the nested mutation of `department` in the `DepartmentInput` mutation. */
export type DepartmentParentDepartmentIdForeignInput = {
  /** The primary key(s) for `department` for the far side of the relationship. */
  connectById?: InputMaybe<DepartmentDepartmentPkeyConnect>;
  /** A `DepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<DepartmentParentDepartmentIdForeignConnectionDepartmentCreateInput>;
  /** The primary key(s) and patch data for `department` for the far side of the relationship. */
  updateById?: InputMaybe<DepartmentOnDepartmentForDepartmentParentDepartmentIdForeignUsingDepartmentPkeyUpdate>;
};

/** Represents an update to a `Department`. Fields that are set will be updated. */
export type DepartmentPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** A connection to a list of `DepartmentRuleBreachesSummaryRecord` values. */
export type DepartmentRuleBreachesSummaryConnection = {
  __typename?: 'DepartmentRuleBreachesSummaryConnection';
  /** A list of edges which contains the `DepartmentRuleBreachesSummaryRecord` and cursor to aid in pagination. */
  edges: Array<DepartmentRuleBreachesSummaryEdge>;
  /** A list of `DepartmentRuleBreachesSummaryRecord` objects. */
  nodes: Array<Maybe<DepartmentRuleBreachesSummaryRecord>>;
  /** The count of *all* `DepartmentRuleBreachesSummaryRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DepartmentRuleBreachesSummaryRecord` edge in the connection. */
export type DepartmentRuleBreachesSummaryEdge = {
  __typename?: 'DepartmentRuleBreachesSummaryEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DepartmentRuleBreachesSummaryRecord` at the end of the edge. */
  node?: Maybe<DepartmentRuleBreachesSummaryRecord>;
};

/** The return type of our `ruleBreachesSummary` query. */
export type DepartmentRuleBreachesSummaryRecord = {
  __typename?: 'DepartmentRuleBreachesSummaryRecord';
  date?: Maybe<Scalars['Datetime']>;
  fullName?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  rule?: Maybe<Scalars['String']>;
};

/** A filter to be used against `DepartmentRuleBreachesSummaryRecord` object types. All fields are combined with a logical ‘and.’ */
export type DepartmentRuleBreachesSummaryRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DepartmentRuleBreachesSummaryRecordFilter>>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `jobTitle` field. */
  jobTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `logo` field. */
  logo?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DepartmentRuleBreachesSummaryRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DepartmentRuleBreachesSummaryRecordFilter>>;
  /** Filter by the object’s `rule` field. */
  rule?: InputMaybe<StringFilter>;
};

/** A filter to be used against many `ContractTemplateDepartment` object types. All fields are combined with a logical ‘and.’ */
export type DepartmentToManyContractTemplateDepartmentFilter = {
  /** Every related `ContractTemplateDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractTemplateDepartmentFilter>;
  /** No related `ContractTemplateDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractTemplateDepartmentFilter>;
  /** Some related `ContractTemplateDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractTemplateDepartmentFilter>;
};

/** A filter to be used against many `Department` object types. All fields are combined with a logical ‘and.’ */
export type DepartmentToManyDepartmentFilter = {
  /** Every related `Department` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DepartmentFilter>;
  /** No related `Department` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DepartmentFilter>;
  /** Some related `Department` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DepartmentFilter>;
};

/** A filter to be used against many `DocumentDepartmentPermission` object types. All fields are combined with a logical ‘and.’ */
export type DepartmentToManyDocumentDepartmentPermissionFilter = {
  /** Every related `DocumentDepartmentPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentDepartmentPermissionFilter>;
  /** No related `DocumentDepartmentPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentDepartmentPermissionFilter>;
  /** Some related `DocumentDepartmentPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentDepartmentPermissionFilter>;
};

/** A filter to be used against many `DocumentFolderDepartment` object types. All fields are combined with a logical ‘and.’ */
export type DepartmentToManyDocumentFolderDepartmentFilter = {
  /** Every related `DocumentFolderDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentFolderDepartmentFilter>;
  /** No related `DocumentFolderDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentFolderDepartmentFilter>;
  /** Some related `DocumentFolderDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentFolderDepartmentFilter>;
};

/** A filter to be used against many `FormFieldEntry` object types. All fields are combined with a logical ‘and.’ */
export type DepartmentToManyFormFieldEntryFilter = {
  /** Every related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FormFieldEntryFilter>;
  /** No related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FormFieldEntryFilter>;
  /** Some related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FormFieldEntryFilter>;
};

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type DepartmentToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

/** A filter to be used against many `Product` object types. All fields are combined with a logical ‘and.’ */
export type DepartmentToManyProductFilter = {
  /** Every related `Product` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProductFilter>;
  /** No related `Product` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProductFilter>;
  /** Some related `Product` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProductFilter>;
};

/** A filter to be used against many `UserDepartment` object types. All fields are combined with a logical ‘and.’ */
export type DepartmentToManyUserDepartmentFilter = {
  /** Every related `UserDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserDepartmentFilter>;
  /** No related `UserDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserDepartmentFilter>;
  /** Some related `UserDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserDepartmentFilter>;
};

/** A filter to be used against many `UserDepartmentGroup` object types. All fields are combined with a logical ‘and.’ */
export type DepartmentToManyUserDepartmentGroupFilter = {
  /** Every related `UserDepartmentGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserDepartmentGroupFilter>;
  /** No related `UserDepartmentGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserDepartmentGroupFilter>;
  /** Some related `UserDepartmentGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserDepartmentGroupFilter>;
};

/** A filter to be used against many `UserDepartmentRole` object types. All fields are combined with a logical ‘and.’ */
export type DepartmentToManyUserDepartmentRoleFilter = {
  /** Every related `UserDepartmentRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserDepartmentRoleFilter>;
  /** No related `UserDepartmentRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserDepartmentRoleFilter>;
  /** Some related `UserDepartmentRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserDepartmentRoleFilter>;
};

export type DepartmentType = {
  __typename?: 'DepartmentType';
  active: Scalars['Boolean'];
  color?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DepartmentType`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `Department`. */
  departments: DepartmentsConnection;
  id: Scalars['UUID'];
  localizedName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};


export type DepartmentTypeDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DepartmentCondition>;
  filter?: InputMaybe<DepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DepartmentsOrderBy>>;
};

/** The `departmentType` to be created by this mutation. */
export type DepartmentTypeCompanyIdForeignConnectionDepartmentTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentTypeCompanyIdForeignInput>;
  departments?: InputMaybe<DepartmentDepartmentTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
};

/** Input for the nested mutation of `company` in the `DepartmentTypeInput` mutation. */
export type DepartmentTypeCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnDepartmentTypeForDepartmentTypeCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `departmentType` in the `CompanyInput` mutation. */
export type DepartmentTypeCompanyIdForeignInverseInput = {
  /** The primary key(s) for `departmentType` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DepartmentTypeDepartmentTypePkeyConnect>>;
  /** A `DepartmentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DepartmentTypeCompanyIdForeignConnectionDepartmentTypeCreateInput>>;
  /** The primary key(s) and patch data for `departmentType` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DepartmentTypeOnDepartmentTypeForDepartmentTypeCompanyIdForeignUsingDepartmentTypePkeyUpdate>>;
};

/**
 * A condition to be used against `DepartmentType` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DepartmentTypeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `color` field. */
  color?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** The fields on `departmentType` to look up the row to connect. */
export type DepartmentTypeDepartmentTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against `DepartmentType` object types. All fields are combined with a logical ‘and.’ */
export type DepartmentTypeFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DepartmentTypeFilter>>;
  /** Filter by the object’s `color` field. */
  color?: InputMaybe<StringFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` relation. */
  departments?: InputMaybe<DepartmentTypeToManyDepartmentFilter>;
  /** Some related `departments` exist. */
  departmentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DepartmentTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DepartmentTypeFilter>>;
};

/** An input for mutations affecting `DepartmentType` */
export type DepartmentTypeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<DepartmentDepartmentTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
};

/** The fields on `departmentType` to look up the row to update. */
export type DepartmentTypeOnDepartmentForDepartmentDepartmentTypeIdForeignUsingDepartmentTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `departmentType` being updated. */
  patch: UpdateDepartmentTypeOnDepartmentForDepartmentDepartmentTypeIdForeignPatch;
};

/** The fields on `departmentType` to look up the row to update. */
export type DepartmentTypeOnDepartmentTypeForDepartmentTypeCompanyIdForeignUsingDepartmentTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `departmentType` being updated. */
  patch: UpdateDepartmentTypeOnDepartmentTypeForDepartmentTypeCompanyIdForeignPatch;
};

/** Represents an update to a `DepartmentType`. Fields that are set will be updated. */
export type DepartmentTypePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<DepartmentDepartmentTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against many `Department` object types. All fields are combined with a logical ‘and.’ */
export type DepartmentTypeToManyDepartmentFilter = {
  /** Every related `Department` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DepartmentFilter>;
  /** No related `Department` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DepartmentFilter>;
  /** Some related `Department` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DepartmentFilter>;
};

/** A connection to a list of `DepartmentType` values. */
export type DepartmentTypesConnection = {
  __typename?: 'DepartmentTypesConnection';
  /** A list of edges which contains the `DepartmentType` and cursor to aid in pagination. */
  edges: Array<DepartmentTypesEdge>;
  /** A list of `DepartmentType` objects. */
  nodes: Array<Maybe<DepartmentType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DepartmentType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DepartmentType` edge in the connection. */
export type DepartmentTypesEdge = {
  __typename?: 'DepartmentTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DepartmentType` at the end of the edge. */
  node?: Maybe<DepartmentType>;
};

/** Methods to use when ordering `DepartmentType`. */
export type DepartmentTypesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COLOR_ASC'
  | 'COLOR_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENTS_BY_DEPARTMENT_TYPE_ID__COUNT_ASC'
  | 'DEPARTMENTS_BY_DEPARTMENT_TYPE_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALIZED_NAME_ASC'
  | 'LOCALIZED_NAME_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/** A connection to a list of `Department` values. */
export type DepartmentsConnection = {
  __typename?: 'DepartmentsConnection';
  /** A list of edges which contains the `Department` and cursor to aid in pagination. */
  edges: Array<DepartmentsEdge>;
  /** A list of `Department` objects. */
  nodes: Array<Maybe<Department>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Department` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Department` edge in the connection. */
export type DepartmentsEdge = {
  __typename?: 'DepartmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Department` at the end of the edge. */
  node?: Maybe<Department>;
};

/** Methods to use when ordering `Department`. */
export type DepartmentsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ADDRESS_ASC'
  | 'ADDRESS_DESC'
  | 'ALIAS_ASC'
  | 'ALIAS_DESC'
  | 'CITY_ASC'
  | 'CITY_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CONTRACT_TEMPLATE_DEPARTMENTS_BY_DEPARTMENT_ID__COUNT_ASC'
  | 'CONTRACT_TEMPLATE_DEPARTMENTS_BY_DEPARTMENT_ID__COUNT_DESC'
  | 'COUNTRY_ASC'
  | 'COUNTRY_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CUSTOM_ID_ASC'
  | 'CUSTOM_ID_DESC'
  | 'CVR_ASC'
  | 'CVR_DESC'
  | 'DELETE_AT_ASC'
  | 'DELETE_AT_DESC'
  | 'DEPARTMENTS_BY_PARENT_DEPARTMENT_ID__COUNT_ASC'
  | 'DEPARTMENTS_BY_PARENT_DEPARTMENT_ID__COUNT_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__ACTIVE_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__ACTIVE_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__ADDRESS_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__ADDRESS_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__ALIAS_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__ALIAS_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__CITY_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__CITY_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__COMPANY_ID_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__COMPANY_ID_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__COUNTRY_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__COUNTRY_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__CREATED_AT_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__CREATED_AT_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__CUSTOM_ID_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__CUSTOM_ID_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__CVR_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__CVR_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__DELETE_AT_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__DELETE_AT_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__DEPARTMENT_NUMBER_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__DEPARTMENT_NUMBER_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__DESCRIPTION_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__DESCRIPTION_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__EAN_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__EAN_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__EMAIL_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__EMAIL_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__ID_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__ID_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__MAIN_DEPARTMENT_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__MAIN_DEPARTMENT_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__NAME_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__NAME_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__PHONE_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__PHONE_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__POSTAL_CODE_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__POSTAL_CODE_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__P_NUMBER_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__P_NUMBER_DESC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__UPDATED_AT_ASC'
  | 'DEPARTMENT_BY_PARENT_DEPARTMENT_ID__UPDATED_AT_DESC'
  | 'DEPARTMENT_NUMBER_ASC'
  | 'DEPARTMENT_NUMBER_DESC'
  | 'DEPARTMENT_TYPE_BY_DEPARTMENT_TYPE_ID__ACTIVE_ASC'
  | 'DEPARTMENT_TYPE_BY_DEPARTMENT_TYPE_ID__ACTIVE_DESC'
  | 'DEPARTMENT_TYPE_BY_DEPARTMENT_TYPE_ID__COLOR_ASC'
  | 'DEPARTMENT_TYPE_BY_DEPARTMENT_TYPE_ID__COLOR_DESC'
  | 'DEPARTMENT_TYPE_BY_DEPARTMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'DEPARTMENT_TYPE_BY_DEPARTMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'DEPARTMENT_TYPE_BY_DEPARTMENT_TYPE_ID__ID_ASC'
  | 'DEPARTMENT_TYPE_BY_DEPARTMENT_TYPE_ID__ID_DESC'
  | 'DEPARTMENT_TYPE_BY_DEPARTMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'DEPARTMENT_TYPE_BY_DEPARTMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'DEPARTMENT_TYPE_BY_DEPARTMENT_TYPE_ID__NAME_ASC'
  | 'DEPARTMENT_TYPE_BY_DEPARTMENT_TYPE_ID__NAME_DESC'
  | 'DEPARTMENT_TYPE_ID_ASC'
  | 'DEPARTMENT_TYPE_ID_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'DOCUMENT_DEPARTMENT_PERMISSIONS_BY_DEPARTMENT_ID__COUNT_ASC'
  | 'DOCUMENT_DEPARTMENT_PERMISSIONS_BY_DEPARTMENT_ID__COUNT_DESC'
  | 'DOCUMENT_FOLDER_DEPARTMENTS_BY_DEPARTMENT_ID__COUNT_ASC'
  | 'DOCUMENT_FOLDER_DEPARTMENTS_BY_DEPARTMENT_ID__COUNT_DESC'
  | 'EAN_ASC'
  | 'EAN_DESC'
  | 'EMAIL_ASC'
  | 'EMAIL_DESC'
  | 'FORM_FIELD_ENTRIES_BY_DEPARTMENT_ID__COUNT_ASC'
  | 'FORM_FIELD_ENTRIES_BY_DEPARTMENT_ID__COUNT_DESC'
  | 'FORM_FIELD_ENTRIES_BY_PRODUCT_DEPARTMENT_ID__COUNT_ASC'
  | 'FORM_FIELD_ENTRIES_BY_PRODUCT_DEPARTMENT_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MAIN_DEPARTMENT_ASC'
  | 'MAIN_DEPARTMENT_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_DEPARTMENT_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_DEPARTMENT_ID__COUNT_DESC'
  | 'PARENT_DEPARTMENT_ID_ASC'
  | 'PARENT_DEPARTMENT_ID_DESC'
  | 'PHONE_ASC'
  | 'PHONE_DESC'
  | 'POSTAL_CODE_ASC'
  | 'POSTAL_CODE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PRODUCTS_BY_DEPARTMENT_ID__COUNT_ASC'
  | 'PRODUCTS_BY_DEPARTMENT_ID__COUNT_DESC'
  | 'P_NUMBER_ASC'
  | 'P_NUMBER_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'USER_DEPARTMENTS_BY_DEPARTMENT_ID__COUNT_ASC'
  | 'USER_DEPARTMENTS_BY_DEPARTMENT_ID__COUNT_DESC'
  | 'USER_DEPARTMENT_GROUPS_BY_DEPARTMENT_ID__COUNT_ASC'
  | 'USER_DEPARTMENT_GROUPS_BY_DEPARTMENT_ID__COUNT_DESC'
  | 'USER_DEPARTMENT_ROLES_BY_DEPARTMENT_ID__COUNT_ASC'
  | 'USER_DEPARTMENT_ROLES_BY_DEPARTMENT_ID__COUNT_DESC';

export type DocumentDepartmentPermission = {
  __typename?: 'DocumentDepartmentPermission';
  /** Reads a single `Company` that is related to this `DocumentDepartmentPermission`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `Department` that is related to this `DocumentDepartmentPermission`. */
  department?: Maybe<Department>;
  departmentId: Scalars['UUID'];
  /** Reads a single `Storage` that is related to this `DocumentDepartmentPermission`. */
  file?: Maybe<Storage>;
  fileId: Scalars['UUID'];
};

/**
 * A condition to be used against `DocumentDepartmentPermission` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DocumentDepartmentPermissionCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departmentId` field. */
  departmentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fileId` field. */
  fileId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `documentDepartmentPermission` to look up the row to connect. */
export type DocumentDepartmentPermissionDocumentDepartmentPermissionsFileIdDepartmentIdUniqueConnect = {
  departmentId: Scalars['UUID'];
  fileId: Scalars['UUID'];
};

/** A filter to be used against `DocumentDepartmentPermission` object types. All fields are combined with a logical ‘and.’ */
export type DocumentDepartmentPermissionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentDepartmentPermissionFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `department` relation. */
  department?: InputMaybe<DepartmentFilter>;
  /** Filter by the object’s `departmentId` field. */
  departmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `file` relation. */
  file?: InputMaybe<StorageFilter>;
  /** Filter by the object’s `fileId` field. */
  fileId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentDepartmentPermissionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentDepartmentPermissionFilter>>;
};

/** An input for mutations affecting `DocumentDepartmentPermission` */
export type DocumentDepartmentPermissionInput = {
  company?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInput>;
};

/** The fields on `documentDepartmentPermission` to look up the row to update. */
export type DocumentDepartmentPermissionOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsCompanyIdFkeyUsingDocumentDepartmentPermissionsFileIdDepartmentIdUniqueUpdate = {
  departmentId: Scalars['UUID'];
  fileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentDepartmentPermission` being updated. */
  patch: UpdateDocumentDepartmentPermissionOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsCompanyIdFkeyPatch;
};

/** The fields on `documentDepartmentPermission` to look up the row to update. */
export type DocumentDepartmentPermissionOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsDepartmentIdForeignUsingDocumentDepartmentPermissionsFileIdDepartmentIdUniqueUpdate = {
  departmentId: Scalars['UUID'];
  fileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentDepartmentPermission` being updated. */
  patch: UpdateDocumentDepartmentPermissionOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsDepartmentIdForeignPatch;
};

/** The fields on `documentDepartmentPermission` to look up the row to update. */
export type DocumentDepartmentPermissionOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsFileIdForeignUsingDocumentDepartmentPermissionsFileIdDepartmentIdUniqueUpdate = {
  departmentId: Scalars['UUID'];
  fileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentDepartmentPermission` being updated. */
  patch: UpdateDocumentDepartmentPermissionOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsFileIdForeignPatch;
};

/** Represents an update to a `DocumentDepartmentPermission`. Fields that are set will be updated. */
export type DocumentDepartmentPermissionPatch = {
  company?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInput>;
};

/** The `documentDepartmentPermission` to be created by this mutation. */
export type DocumentDepartmentPermissionsCompanyIdFkeyConnectionDocumentDepartmentPermissionsCreateInput = {
  company?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInput>;
  department?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInput>;
};

/** Input for the nested mutation of `company` in the `DocumentDepartmentPermissionInput` mutation. */
export type DocumentDepartmentPermissionsCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `documentDepartmentPermission` in the `CompanyInput` mutation. */
export type DocumentDepartmentPermissionsCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `documentDepartmentPermission` for the far side of the relationship. */
  connectByFileIdAndDepartmentId?: InputMaybe<Array<DocumentDepartmentPermissionDocumentDepartmentPermissionsFileIdDepartmentIdUniqueConnect>>;
  /** A `DocumentDepartmentPermissionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentDepartmentPermissionsCompanyIdFkeyConnectionDocumentDepartmentPermissionsCreateInput>>;
  /** The primary key(s) and patch data for `documentDepartmentPermission` for the far side of the relationship. */
  updateByFileIdAndDepartmentId?: InputMaybe<Array<DocumentDepartmentPermissionOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsCompanyIdFkeyUsingDocumentDepartmentPermissionsFileIdDepartmentIdUniqueUpdate>>;
};

/** A connection to a list of `DocumentDepartmentPermission` values. */
export type DocumentDepartmentPermissionsConnection = {
  __typename?: 'DocumentDepartmentPermissionsConnection';
  /** A list of edges which contains the `DocumentDepartmentPermission` and cursor to aid in pagination. */
  edges: Array<DocumentDepartmentPermissionsEdge>;
  /** A list of `DocumentDepartmentPermission` objects. */
  nodes: Array<Maybe<DocumentDepartmentPermission>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentDepartmentPermission` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The `department` to be created by this mutation. */
export type DocumentDepartmentPermissionsDepartmentIdForeignConnectionDepartmentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** The `documentDepartmentPermission` to be created by this mutation. */
export type DocumentDepartmentPermissionsDepartmentIdForeignConnectionDocumentDepartmentPermissionsCreateInput = {
  company?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInput>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInput>;
};

/** Input for the nested mutation of `department` in the `DocumentDepartmentPermissionInput` mutation. */
export type DocumentDepartmentPermissionsDepartmentIdForeignInput = {
  /** The primary key(s) for `department` for the far side of the relationship. */
  connectById?: InputMaybe<DepartmentDepartmentPkeyConnect>;
  /** A `DepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignConnectionDepartmentCreateInput>;
  /** The primary key(s) and patch data for `department` for the far side of the relationship. */
  updateById?: InputMaybe<DepartmentOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsDepartmentIdForeignUsingDepartmentPkeyUpdate>;
};

/** Input for the nested mutation of `documentDepartmentPermission` in the `DepartmentInput` mutation. */
export type DocumentDepartmentPermissionsDepartmentIdForeignInverseInput = {
  /** The primary key(s) for `documentDepartmentPermission` for the far side of the relationship. */
  connectByFileIdAndDepartmentId?: InputMaybe<Array<DocumentDepartmentPermissionDocumentDepartmentPermissionsFileIdDepartmentIdUniqueConnect>>;
  /** A `DocumentDepartmentPermissionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentDepartmentPermissionsDepartmentIdForeignConnectionDocumentDepartmentPermissionsCreateInput>>;
  /** The primary key(s) and patch data for `documentDepartmentPermission` for the far side of the relationship. */
  updateByFileIdAndDepartmentId?: InputMaybe<Array<DocumentDepartmentPermissionOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsDepartmentIdForeignUsingDocumentDepartmentPermissionsFileIdDepartmentIdUniqueUpdate>>;
};

/** A `DocumentDepartmentPermission` edge in the connection. */
export type DocumentDepartmentPermissionsEdge = {
  __typename?: 'DocumentDepartmentPermissionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DocumentDepartmentPermission` at the end of the edge. */
  node?: Maybe<DocumentDepartmentPermission>;
};

/** The `documentDepartmentPermission` to be created by this mutation. */
export type DocumentDepartmentPermissionsFileIdForeignConnectionDocumentDepartmentPermissionsCreateInput = {
  company?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInput>;
};

/** The `storage` to be created by this mutation. */
export type DocumentDepartmentPermissionsFileIdForeignConnectionStorageCreateInput = {
  access: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createCopy?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path: Scalars['String'];
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `storage` in the `DocumentDepartmentPermissionInput` mutation. */
export type DocumentDepartmentPermissionsFileIdForeignInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<StorageStoragePkeyConnect>;
  /** A `StorageInput` object that will be created and connected to this object. */
  create?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignConnectionStorageCreateInput>;
  /** The primary key(s) and patch data for `storage` for the far side of the relationship. */
  updateById?: InputMaybe<StorageOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsFileIdForeignUsingStoragePkeyUpdate>;
};

/** Input for the nested mutation of `documentDepartmentPermission` in the `StorageInput` mutation. */
export type DocumentDepartmentPermissionsFileIdForeignInverseInput = {
  /** The primary key(s) for `documentDepartmentPermission` for the far side of the relationship. */
  connectByFileIdAndDepartmentId?: InputMaybe<Array<DocumentDepartmentPermissionDocumentDepartmentPermissionsFileIdDepartmentIdUniqueConnect>>;
  /** A `DocumentDepartmentPermissionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentDepartmentPermissionsFileIdForeignConnectionDocumentDepartmentPermissionsCreateInput>>;
  /** The primary key(s) and patch data for `documentDepartmentPermission` for the far side of the relationship. */
  updateByFileIdAndDepartmentId?: InputMaybe<Array<DocumentDepartmentPermissionOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsFileIdForeignUsingDocumentDepartmentPermissionsFileIdDepartmentIdUniqueUpdate>>;
};

/** Methods to use when ordering `DocumentDepartmentPermission`. */
export type DocumentDepartmentPermissionsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ACTIVE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ACTIVE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ADDRESS_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ADDRESS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ALIAS_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ALIAS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CITY_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CITY_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COMPANY_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COMPANY_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COUNTRY_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COUNTRY_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CREATED_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CREATED_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CUSTOM_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CUSTOM_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CVR_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CVR_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DELETE_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DELETE_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_NUMBER_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_NUMBER_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DESCRIPTION_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DESCRIPTION_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EAN_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EAN_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EMAIL_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EMAIL_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__MAIN_DEPARTMENT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__MAIN_DEPARTMENT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__NAME_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__NAME_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PHONE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PHONE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__POSTAL_CODE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__POSTAL_CODE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__P_NUMBER_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__P_NUMBER_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__UPDATED_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__UPDATED_AT_DESC'
  | 'DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_ID_DESC'
  | 'FILE_ID_ASC'
  | 'FILE_ID_DESC'
  | 'NATURAL'
  | 'STORAGE_BY_FILE_ID__ACCESS_ASC'
  | 'STORAGE_BY_FILE_ID__ACCESS_DESC'
  | 'STORAGE_BY_FILE_ID__ACTIVE_ASC'
  | 'STORAGE_BY_FILE_ID__ACTIVE_DESC'
  | 'STORAGE_BY_FILE_ID__BELONGS_TO_LEADER_ASC'
  | 'STORAGE_BY_FILE_ID__BELONGS_TO_LEADER_DESC'
  | 'STORAGE_BY_FILE_ID__COMPANY_ID_ASC'
  | 'STORAGE_BY_FILE_ID__COMPANY_ID_DESC'
  | 'STORAGE_BY_FILE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_FILE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_FILE_ID__CREATED_AT_ASC'
  | 'STORAGE_BY_FILE_ID__CREATED_AT_DESC'
  | 'STORAGE_BY_FILE_ID__DELETE_AT_ASC'
  | 'STORAGE_BY_FILE_ID__DELETE_AT_DESC'
  | 'STORAGE_BY_FILE_ID__DEPARTMENTS_ASC'
  | 'STORAGE_BY_FILE_ID__DEPARTMENTS_DESC'
  | 'STORAGE_BY_FILE_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'STORAGE_BY_FILE_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_FOLDER_ID_ASC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_FOLDER_ID_DESC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_TEMPLATE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_TEMPLATE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_TYPE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_TYPE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__EMPLOYEE_CASEFILE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__EMPLOYEE_CASEFILE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__EXPIRED_REMINDED_ASC'
  | 'STORAGE_BY_FILE_ID__EXPIRED_REMINDED_DESC'
  | 'STORAGE_BY_FILE_ID__EXPIRE_AT_ASC'
  | 'STORAGE_BY_FILE_ID__EXPIRE_AT_DESC'
  | 'STORAGE_BY_FILE_ID__FILENAME_ASC'
  | 'STORAGE_BY_FILE_ID__FILENAME_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_EXTENSION_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_EXTENSION_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_OWNER_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_OWNER_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_OWNER_ID_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_OWNER_ID_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_SIZE_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_SIZE_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_TYPE_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_TYPE_DESC'
  | 'STORAGE_BY_FILE_ID__FOLDER_DEPARTMENT_IDS_ASC'
  | 'STORAGE_BY_FILE_ID__FOLDER_DEPARTMENT_IDS_DESC'
  | 'STORAGE_BY_FILE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_FILE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_FILE_ID__FOLDER_OWNER_ID_ASC'
  | 'STORAGE_BY_FILE_ID__FOLDER_OWNER_ID_DESC'
  | 'STORAGE_BY_FILE_ID__FOLDER_USER_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_FILE_ID__FOLDER_USER_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_FILE_ID__HTML_ASC'
  | 'STORAGE_BY_FILE_ID__HTML_DESC'
  | 'STORAGE_BY_FILE_ID__ID_ASC'
  | 'STORAGE_BY_FILE_ID__ID_DESC'
  | 'STORAGE_BY_FILE_ID__MIMETYPE_ASC'
  | 'STORAGE_BY_FILE_ID__MIMETYPE_DESC'
  | 'STORAGE_BY_FILE_ID__OWNER_NAME_ASC'
  | 'STORAGE_BY_FILE_ID__OWNER_NAME_DESC'
  | 'STORAGE_BY_FILE_ID__PATH_ASC'
  | 'STORAGE_BY_FILE_ID__PATH_DESC'
  | 'STORAGE_BY_FILE_ID__PENNEO_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_FILE_ID__PENNEO_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_FILE_ID__PLACEHOLDER_VALUES_ASC'
  | 'STORAGE_BY_FILE_ID__PLACEHOLDER_VALUES_DESC'
  | 'STORAGE_BY_FILE_ID__PROCESS_TYPE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__PROCESS_TYPE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__REMINDED_ASC'
  | 'STORAGE_BY_FILE_ID__REMINDED_DESC'
  | 'STORAGE_BY_FILE_ID__REMIND_AT_ASC'
  | 'STORAGE_BY_FILE_ID__REMIND_AT_DESC'
  | 'STORAGE_BY_FILE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'STORAGE_BY_FILE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'STORAGE_BY_FILE_ID__TEMPLATING_SERVICE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__TEMPLATING_SERVICE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__USERS_RESPONSIBLE_ASC'
  | 'STORAGE_BY_FILE_ID__USERS_RESPONSIBLE_DESC'
  | 'STORAGE_BY_FILE_ID__USERS_SHARED_WITH_ASC'
  | 'STORAGE_BY_FILE_ID__USERS_SHARED_WITH_DEPARTMENTS_ASC'
  | 'STORAGE_BY_FILE_ID__USERS_SHARED_WITH_DEPARTMENTS_DESC'
  | 'STORAGE_BY_FILE_ID__USERS_SHARED_WITH_DESC';

export type DocumentFolder = {
  __typename?: 'DocumentFolder';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `DocumentFolder`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  departmentsSharedWith?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `DocumentFolderBlueprint` that is related to this `DocumentFolder`. */
  documentFolderBlueprint?: Maybe<DocumentFolderBlueprint>;
  documentFolderBlueprintId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `DocumentFolderDepartment`. */
  documentFolderDepartments: DocumentFolderDepartmentsConnection;
  /** Reads and enables pagination through a set of `DocumentFolderUser`. */
  documentFolderUsers: DocumentFolderUsersConnection;
  /** Reads and enables pagination through a set of `DocumentFolder`. */
  documentFoldersByParentDocumentFolderId: DocumentFoldersConnection;
  id: Scalars['UUID'];
  lastEdited?: Maybe<Scalars['Datetime']>;
  name: Scalars['String'];
  ownerId: Scalars['UUID'];
  ownerType: DocumentFolderOwnerType;
  /** Reads a single `DocumentFolder` that is related to this `DocumentFolder`. */
  parentDocumentFolder?: Maybe<DocumentFolder>;
  parentDocumentFolderId?: Maybe<Scalars['UUID']>;
  /** Reads a single `DocumentFolderBlueprint` that is related to this `DocumentFolder`. */
  rootDocumentFolderBlueprint?: Maybe<DocumentFolderBlueprint>;
  rootDocumentFolderBlueprintId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `Storage`. */
  storages: StoragesConnection;
  usersSharedWith?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};


export type DocumentFolderDocumentFolderDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentFolderDepartmentCondition>;
  filter?: InputMaybe<DocumentFolderDepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentFolderDepartmentsOrderBy>>;
};


export type DocumentFolderDocumentFolderUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentFolderUserCondition>;
  filter?: InputMaybe<DocumentFolderUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentFolderUsersOrderBy>>;
};


export type DocumentFolderDocumentFoldersByParentDocumentFolderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentFolderCondition>;
  filter?: InputMaybe<DocumentFolderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentFoldersOrderBy>>;
};


export type DocumentFolderStoragesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<StorageCondition>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StoragesOrderBy>>;
};

export type DocumentFolderBlueprint = {
  __typename?: 'DocumentFolderBlueprint';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `DocumentFolderBlueprint`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `DocumentFolderBlueprint`. */
  documentFolderBlueprintsByParentDocumentFolderBlueprintId: DocumentFolderBlueprintsConnection;
  /** Reads and enables pagination through a set of `DocumentFolder`. */
  documentFolders: DocumentFoldersConnection;
  /** Reads and enables pagination through a set of `DocumentFolder`. */
  documentFoldersByRootDocumentFolderBlueprintId: DocumentFoldersConnection;
  /** Reads and enables pagination through a set of `ExternalIntegration`. */
  externalIntegrationsByPayslipDocumentBlueprintFolderId: ExternalIntegrationsConnection;
  id: Scalars['UUID'];
  name: Scalars['String'];
  numberOfFiles?: Maybe<Scalars['BigInt']>;
  /** Reads a single `DocumentFolderBlueprint` that is related to this `DocumentFolderBlueprint`. */
  parentDocumentFolderBlueprint?: Maybe<DocumentFolderBlueprint>;
  parentDocumentFolderBlueprintId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `Storage`. */
  storagesByRootDocumentFolderBlueprintId: StoragesConnection;
};


export type DocumentFolderBlueprintDocumentFolderBlueprintsByParentDocumentFolderBlueprintIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentFolderBlueprintCondition>;
  filter?: InputMaybe<DocumentFolderBlueprintFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentFolderBlueprintsOrderBy>>;
};


export type DocumentFolderBlueprintDocumentFoldersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentFolderCondition>;
  filter?: InputMaybe<DocumentFolderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentFoldersOrderBy>>;
};


export type DocumentFolderBlueprintDocumentFoldersByRootDocumentFolderBlueprintIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentFolderCondition>;
  filter?: InputMaybe<DocumentFolderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentFoldersOrderBy>>;
};


export type DocumentFolderBlueprintExternalIntegrationsByPayslipDocumentBlueprintFolderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalIntegrationCondition>;
  filter?: InputMaybe<ExternalIntegrationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalIntegrationsOrderBy>>;
};


export type DocumentFolderBlueprintStoragesByRootDocumentFolderBlueprintIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<StorageCondition>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StoragesOrderBy>>;
};

/** The `documentFolderBlueprint` to be created by this mutation. */
export type DocumentFolderBlueprintCompanyIdForeignConnectionDocumentFolderBlueprintCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderBlueprintParentDocumentFolderBlueprintIdFInput>;
  documentFoldersToDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderDocumentFolderBlueprintIdForeignInverseInput>;
  documentFoldersToRootDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  parentDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInverseInput>;
};

/** Input for the nested mutation of `company` in the `DocumentFolderBlueprintInput` mutation. */
export type DocumentFolderBlueprintCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnDocumentFolderBlueprintForDocumentFolderBlueprintCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `documentFolderBlueprint` in the `CompanyInput` mutation. */
export type DocumentFolderBlueprintCompanyIdForeignInverseInput = {
  /** The primary key(s) for `documentFolderBlueprint` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DocumentFolderBlueprintDocumentFolderBlueprintPkeyConnect>>;
  /** A `DocumentFolderBlueprintInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentFolderBlueprintCompanyIdForeignConnectionDocumentFolderBlueprintCreateInput>>;
  /** The primary key(s) and patch data for `documentFolderBlueprint` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DocumentFolderBlueprintOnDocumentFolderBlueprintForDocumentFolderBlueprintCompanyIdForeignUsingDocumentFolderBlueprintPkeyUpdate>>;
};

/**
 * A condition to be used against `DocumentFolderBlueprint` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DocumentFolderBlueprintCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `parentDocumentFolderBlueprintId` field. */
  parentDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
};

export type DocumentFolderBlueprintDependant = {
  __typename?: 'DocumentFolderBlueprintDependant';
  numberOfEmployees?: Maybe<Scalars['BigInt']>;
  numberOfFiles?: Maybe<Scalars['BigInt']>;
};

/** The fields on `documentFolderBlueprint` to look up the row to connect. */
export type DocumentFolderBlueprintDocumentFolderBlueprintPkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against `DocumentFolderBlueprint` object types. All fields are combined with a logical ‘and.’ */
export type DocumentFolderBlueprintFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentFolderBlueprintFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `documentFolderBlueprintsByParentDocumentFolderBlueprintId` relation. */
  documentFolderBlueprintsByParentDocumentFolderBlueprintId?: InputMaybe<DocumentFolderBlueprintToManyDocumentFolderBlueprintFilter>;
  /** Some related `documentFolderBlueprintsByParentDocumentFolderBlueprintId` exist. */
  documentFolderBlueprintsByParentDocumentFolderBlueprintIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentFolders` relation. */
  documentFolders?: InputMaybe<DocumentFolderBlueprintToManyDocumentFolderFilter>;
  /** Filter by the object’s `documentFoldersByRootDocumentFolderBlueprintId` relation. */
  documentFoldersByRootDocumentFolderBlueprintId?: InputMaybe<DocumentFolderBlueprintToManyDocumentFolderFilter>;
  /** Some related `documentFoldersByRootDocumentFolderBlueprintId` exist. */
  documentFoldersByRootDocumentFolderBlueprintIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `documentFolders` exist. */
  documentFoldersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `externalIntegrationsByPayslipDocumentBlueprintFolderId` relation. */
  externalIntegrationsByPayslipDocumentBlueprintFolderId?: InputMaybe<DocumentFolderBlueprintToManyExternalIntegrationFilter>;
  /** Some related `externalIntegrationsByPayslipDocumentBlueprintFolderId` exist. */
  externalIntegrationsByPayslipDocumentBlueprintFolderIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentFolderBlueprintFilter>;
  /** Filter by the object’s `numberOfFiles` field. */
  numberOfFiles?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentFolderBlueprintFilter>>;
  /** Filter by the object’s `parentDocumentFolderBlueprint` relation. */
  parentDocumentFolderBlueprint?: InputMaybe<DocumentFolderBlueprintFilter>;
  /** A related `parentDocumentFolderBlueprint` exists. */
  parentDocumentFolderBlueprintExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `parentDocumentFolderBlueprintId` field. */
  parentDocumentFolderBlueprintId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `storagesByRootDocumentFolderBlueprintId` relation. */
  storagesByRootDocumentFolderBlueprintId?: InputMaybe<DocumentFolderBlueprintToManyStorageFilter>;
  /** Some related `storagesByRootDocumentFolderBlueprintId` exist. */
  storagesByRootDocumentFolderBlueprintIdExist?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `DocumentFolderBlueprint` */
export type DocumentFolderBlueprintInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderBlueprintParentDocumentFolderBlueprintIdFInput>;
  documentFoldersToDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderDocumentFolderBlueprintIdForeignInverseInput>;
  documentFoldersToRootDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  parentDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInverseInput>;
};

/** The fields on `documentFolderBlueprint` to look up the row to update. */
export type DocumentFolderBlueprintOnDocumentFolderBlueprintForDocumentFolderBlueprintCompanyIdForeignUsingDocumentFolderBlueprintPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentFolderBlueprint` being updated. */
  patch: UpdateDocumentFolderBlueprintOnDocumentFolderBlueprintForDocumentFolderBlueprintCompanyIdForeignPatch;
};

/** The fields on `documentFolderBlueprint` to look up the row to update. */
export type DocumentFolderBlueprintOnDocumentFolderBlueprintForDocumentFolderBlueprintParentDocumentFolderBlueprintIdFUsingDocumentFolderBlueprintPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentFolderBlueprint` being updated. */
  patch: UpdateDocumentFolderBlueprintOnDocumentFolderBlueprintForDocumentFolderBlueprintParentDocumentFolderBlueprintIdFPatch;
};

/** The fields on `documentFolderBlueprint` to look up the row to update. */
export type DocumentFolderBlueprintOnDocumentFolderForDocumentFolderRootDocumentFolderBlueprintIdForeignUsingDocumentFolderBlueprintPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentFolderBlueprint` being updated. */
  patch: UpdateDocumentFolderBlueprintOnDocumentFolderForDocumentFolderRootDocumentFolderBlueprintIdForeignPatch;
};

/** The fields on `documentFolderBlueprint` to look up the row to update. */
export type DocumentFolderBlueprintOnExternalIntegrationForExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyUsingDocumentFolderBlueprintPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentFolderBlueprint` being updated. */
  patch: UpdateDocumentFolderBlueprintOnExternalIntegrationForExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyPatch;
};

/** The fields on `documentFolderBlueprint` to look up the row to update. */
export type DocumentFolderBlueprintOnStorageForStorageRootDocumentFolderBlueprintIdForeignUsingDocumentFolderBlueprintPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentFolderBlueprint` being updated. */
  patch: UpdateDocumentFolderBlueprintOnStorageForStorageRootDocumentFolderBlueprintIdForeignPatch;
};

/** The `documentFolderBlueprint` to be created by this mutation. */
export type DocumentFolderBlueprintParentDocumentFolderBlueprintIdFConnectionDocumentFolderBlueprintCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderBlueprintParentDocumentFolderBlueprintIdFInput>;
  documentFoldersToDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderDocumentFolderBlueprintIdForeignInverseInput>;
  documentFoldersToRootDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  storages?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInverseInput>;
};

/** Input for the nested mutation of `documentFolderBlueprint` in the `DocumentFolderBlueprintInput` mutation. */
export type DocumentFolderBlueprintParentDocumentFolderBlueprintIdFInput = {
  /** The primary key(s) for `documentFolderBlueprint` for the far side of the relationship. */
  connectById?: InputMaybe<DocumentFolderBlueprintDocumentFolderBlueprintPkeyConnect>;
  /** A `DocumentFolderBlueprintInput` object that will be created and connected to this object. */
  create?: InputMaybe<DocumentFolderBlueprintParentDocumentFolderBlueprintIdFConnectionDocumentFolderBlueprintCreateInput>;
  /** The primary key(s) and patch data for `documentFolderBlueprint` for the far side of the relationship. */
  updateById?: InputMaybe<DocumentFolderBlueprintOnDocumentFolderBlueprintForDocumentFolderBlueprintParentDocumentFolderBlueprintIdFUsingDocumentFolderBlueprintPkeyUpdate>;
};

/** Represents an update to a `DocumentFolderBlueprint`. Fields that are set will be updated. */
export type DocumentFolderBlueprintPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderBlueprintParentDocumentFolderBlueprintIdFInput>;
  documentFoldersToDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderDocumentFolderBlueprintIdForeignInverseInput>;
  documentFoldersToRootDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  parentDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInverseInput>;
};

/** A filter to be used against many `DocumentFolderBlueprint` object types. All fields are combined with a logical ‘and.’ */
export type DocumentFolderBlueprintToManyDocumentFolderBlueprintFilter = {
  /** Every related `DocumentFolderBlueprint` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentFolderBlueprintFilter>;
  /** No related `DocumentFolderBlueprint` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentFolderBlueprintFilter>;
  /** Some related `DocumentFolderBlueprint` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentFolderBlueprintFilter>;
};

/** A filter to be used against many `DocumentFolder` object types. All fields are combined with a logical ‘and.’ */
export type DocumentFolderBlueprintToManyDocumentFolderFilter = {
  /** Every related `DocumentFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentFolderFilter>;
  /** No related `DocumentFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentFolderFilter>;
  /** Some related `DocumentFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentFolderFilter>;
};

/** A filter to be used against many `ExternalIntegration` object types. All fields are combined with a logical ‘and.’ */
export type DocumentFolderBlueprintToManyExternalIntegrationFilter = {
  /** Every related `ExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalIntegrationFilter>;
  /** No related `ExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalIntegrationFilter>;
  /** Some related `ExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalIntegrationFilter>;
};

/** A filter to be used against many `Storage` object types. All fields are combined with a logical ‘and.’ */
export type DocumentFolderBlueprintToManyStorageFilter = {
  /** Every related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<StorageFilter>;
  /** No related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<StorageFilter>;
  /** Some related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<StorageFilter>;
};

/** A connection to a list of `DocumentFolderBlueprint` values. */
export type DocumentFolderBlueprintsConnection = {
  __typename?: 'DocumentFolderBlueprintsConnection';
  /** A list of edges which contains the `DocumentFolderBlueprint` and cursor to aid in pagination. */
  edges: Array<DocumentFolderBlueprintsEdge>;
  /** A list of `DocumentFolderBlueprint` objects. */
  nodes: Array<Maybe<DocumentFolderBlueprint>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentFolderBlueprint` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DocumentFolderBlueprint` edge in the connection. */
export type DocumentFolderBlueprintsEdge = {
  __typename?: 'DocumentFolderBlueprintsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DocumentFolderBlueprint` at the end of the edge. */
  node?: Maybe<DocumentFolderBlueprint>;
};

/** Methods to use when ordering `DocumentFolderBlueprint`. */
export type DocumentFolderBlueprintsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DOCUMENT_FOLDERS_BY_DOCUMENT_FOLDER_BLUEPRINT_ID__COUNT_ASC'
  | 'DOCUMENT_FOLDERS_BY_DOCUMENT_FOLDER_BLUEPRINT_ID__COUNT_DESC'
  | 'DOCUMENT_FOLDERS_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__COUNT_ASC'
  | 'DOCUMENT_FOLDERS_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__COUNT_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINTS_BY_PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID__COUNT_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINTS_BY_PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID__COUNT_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID__ACTIVE_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID__ACTIVE_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID__COMPANY_ID_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID__COMPANY_ID_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID__ID_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID__ID_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID__NAME_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID__NAME_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID__PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID__PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'EXTERNAL_INTEGRATIONS_BY_PAYSLIP_DOCUMENT_BLUEPRINT_FOLDER_ID__COUNT_ASC'
  | 'EXTERNAL_INTEGRATIONS_BY_PAYSLIP_DOCUMENT_BLUEPRINT_FOLDER_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'STORAGES_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__COUNT_ASC'
  | 'STORAGES_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__COUNT_DESC';

/** The `documentFolder` to be created by this mutation. */
export type DocumentFolderCompanyIdForeignConnectionDocumentFolderCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderCompanyIdForeignInput>;
  departmentIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolder?: InputMaybe<DocumentFolderParentDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastEdited?: InputMaybe<Scalars['Datetime']>;
  name: Scalars['String'];
  ownerId: Scalars['UUID'];
  ownerType: DocumentFolderOwnerType;
  parentDocumentFolderId?: InputMaybe<Scalars['UUID']>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageDocumentFolderIdForeignInverseInput>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `company` in the `DocumentFolderInput` mutation. */
export type DocumentFolderCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnDocumentFolderForDocumentFolderCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `documentFolder` in the `CompanyInput` mutation. */
export type DocumentFolderCompanyIdForeignInverseInput = {
  /** The primary key(s) for `documentFolder` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DocumentFolderDocumentFolderPkeyConnect>>;
  /** A `DocumentFolderInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentFolderCompanyIdForeignConnectionDocumentFolderCreateInput>>;
  /** The primary key(s) and patch data for `documentFolder` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DocumentFolderOnDocumentFolderForDocumentFolderCompanyIdForeignUsingDocumentFolderPkeyUpdate>>;
};

/**
 * A condition to be used against `DocumentFolder` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DocumentFolderCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `departmentsSharedWith` field. */
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `documentFolderBlueprintId` field. */
  documentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `lastEdited` field. */
  lastEdited?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `ownerId` field. */
  ownerId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `ownerType` field. */
  ownerType?: InputMaybe<DocumentFolderOwnerType>;
  /** Checks for equality with the object’s `parentDocumentFolderId` field. */
  parentDocumentFolderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `rootDocumentFolderBlueprintId` field. */
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `usersSharedWith` field. */
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

export type DocumentFolderDepartment = {
  __typename?: 'DocumentFolderDepartment';
  /** Reads a single `Company` that is related to this `DocumentFolderDepartment`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `Department` that is related to this `DocumentFolderDepartment`. */
  department?: Maybe<Department>;
  departmentId: Scalars['UUID'];
  /** Reads a single `DocumentFolder` that is related to this `DocumentFolderDepartment`. */
  documentFolder?: Maybe<DocumentFolder>;
  documentFolderId: Scalars['UUID'];
};

/** The `documentFolderDepartment` to be created by this mutation. */
export type DocumentFolderDepartmentCompanyIdForeignConnectionDocumentFolderDepartmentCreateInput = {
  company?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInput>;
  department?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentFolder?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `DocumentFolderDepartmentInput` mutation. */
export type DocumentFolderDepartmentCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnDocumentFolderDepartmentForDocumentFolderDepartmentCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `documentFolderDepartment` in the `CompanyInput` mutation. */
export type DocumentFolderDepartmentCompanyIdForeignInverseInput = {
  /** The primary key(s) for `documentFolderDepartment` for the far side of the relationship. */
  connectByDocumentFolderIdAndDepartmentId?: InputMaybe<Array<DocumentFolderDepartmentDocumentFolderDepartmentPkeyConnect>>;
  /** A `DocumentFolderDepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentFolderDepartmentCompanyIdForeignConnectionDocumentFolderDepartmentCreateInput>>;
  /** The primary key(s) for `documentFolderDepartment` for the far side of the relationship. */
  deleteByDocumentFolderIdAndDepartmentId?: InputMaybe<Array<DocumentFolderDepartmentDocumentFolderDepartmentPkeyDelete>>;
  /** Flag indicating whether all other `documentFolderDepartment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `documentFolderDepartment` for the far side of the relationship. */
  updateByDocumentFolderIdAndDepartmentId?: InputMaybe<Array<DocumentFolderDepartmentOnDocumentFolderDepartmentForDocumentFolderDepartmentCompanyIdForeignUsingDocumentFolderDepartmentPkeyUpdate>>;
};

/**
 * A condition to be used against `DocumentFolderDepartment` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DocumentFolderDepartmentCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departmentId` field. */
  departmentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `documentFolderId` field. */
  documentFolderId?: InputMaybe<Scalars['UUID']>;
};

/** The `department` to be created by this mutation. */
export type DocumentFolderDepartmentDepartmentIdForeignConnectionDepartmentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** The `documentFolderDepartment` to be created by this mutation. */
export type DocumentFolderDepartmentDepartmentIdForeignConnectionDocumentFolderDepartmentCreateInput = {
  company?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInput>;
  documentFolder?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `department` in the `DocumentFolderDepartmentInput` mutation. */
export type DocumentFolderDepartmentDepartmentIdForeignInput = {
  /** The primary key(s) for `department` for the far side of the relationship. */
  connectById?: InputMaybe<DepartmentDepartmentPkeyConnect>;
  /** A `DepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignConnectionDepartmentCreateInput>;
  /** The primary key(s) and patch data for `department` for the far side of the relationship. */
  updateById?: InputMaybe<DepartmentOnDocumentFolderDepartmentForDocumentFolderDepartmentDepartmentIdForeignUsingDepartmentPkeyUpdate>;
};

/** Input for the nested mutation of `documentFolderDepartment` in the `DepartmentInput` mutation. */
export type DocumentFolderDepartmentDepartmentIdForeignInverseInput = {
  /** The primary key(s) for `documentFolderDepartment` for the far side of the relationship. */
  connectByDocumentFolderIdAndDepartmentId?: InputMaybe<Array<DocumentFolderDepartmentDocumentFolderDepartmentPkeyConnect>>;
  /** A `DocumentFolderDepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentFolderDepartmentDepartmentIdForeignConnectionDocumentFolderDepartmentCreateInput>>;
  /** The primary key(s) for `documentFolderDepartment` for the far side of the relationship. */
  deleteByDocumentFolderIdAndDepartmentId?: InputMaybe<Array<DocumentFolderDepartmentDocumentFolderDepartmentPkeyDelete>>;
  /** Flag indicating whether all other `documentFolderDepartment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `documentFolderDepartment` for the far side of the relationship. */
  updateByDocumentFolderIdAndDepartmentId?: InputMaybe<Array<DocumentFolderDepartmentOnDocumentFolderDepartmentForDocumentFolderDepartmentDepartmentIdForeignUsingDocumentFolderDepartmentPkeyUpdate>>;
};

/** The fields on `documentFolderDepartment` to look up the row to connect. */
export type DocumentFolderDepartmentDocumentFolderDepartmentPkeyConnect = {
  departmentId: Scalars['UUID'];
  documentFolderId: Scalars['UUID'];
};

/** The fields on `documentFolderDepartment` to look up the row to delete. */
export type DocumentFolderDepartmentDocumentFolderDepartmentPkeyDelete = {
  departmentId: Scalars['UUID'];
  documentFolderId: Scalars['UUID'];
};

/** The `documentFolder` to be created by this mutation. */
export type DocumentFolderDepartmentDocumentFolderIdForeignConnectionDocumentFolderCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolder?: InputMaybe<DocumentFolderParentDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastEdited?: InputMaybe<Scalars['Datetime']>;
  name: Scalars['String'];
  ownerId: Scalars['UUID'];
  ownerType: DocumentFolderOwnerType;
  parentDocumentFolderId?: InputMaybe<Scalars['UUID']>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageDocumentFolderIdForeignInverseInput>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `documentFolderDepartment` to be created by this mutation. */
export type DocumentFolderDepartmentDocumentFolderIdForeignConnectionDocumentFolderDepartmentCreateInput = {
  company?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentFolder?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInput>;
};

/** Input for the nested mutation of `documentFolder` in the `DocumentFolderDepartmentInput` mutation. */
export type DocumentFolderDepartmentDocumentFolderIdForeignInput = {
  /** The primary key(s) for `documentFolder` for the far side of the relationship. */
  connectById?: InputMaybe<DocumentFolderDocumentFolderPkeyConnect>;
  /** A `DocumentFolderInput` object that will be created and connected to this object. */
  create?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignConnectionDocumentFolderCreateInput>;
  /** The primary key(s) and patch data for `documentFolder` for the far side of the relationship. */
  updateById?: InputMaybe<DocumentFolderOnDocumentFolderDepartmentForDocumentFolderDepartmentDocumentFolderIdForeignUsingDocumentFolderPkeyUpdate>;
};

/** Input for the nested mutation of `documentFolderDepartment` in the `DocumentFolderInput` mutation. */
export type DocumentFolderDepartmentDocumentFolderIdForeignInverseInput = {
  /** The primary key(s) for `documentFolderDepartment` for the far side of the relationship. */
  connectByDocumentFolderIdAndDepartmentId?: InputMaybe<Array<DocumentFolderDepartmentDocumentFolderDepartmentPkeyConnect>>;
  /** A `DocumentFolderDepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentFolderDepartmentDocumentFolderIdForeignConnectionDocumentFolderDepartmentCreateInput>>;
  /** The primary key(s) for `documentFolderDepartment` for the far side of the relationship. */
  deleteByDocumentFolderIdAndDepartmentId?: InputMaybe<Array<DocumentFolderDepartmentDocumentFolderDepartmentPkeyDelete>>;
  /** Flag indicating whether all other `documentFolderDepartment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `documentFolderDepartment` for the far side of the relationship. */
  updateByDocumentFolderIdAndDepartmentId?: InputMaybe<Array<DocumentFolderDepartmentOnDocumentFolderDepartmentForDocumentFolderDepartmentDocumentFolderIdForeignUsingDocumentFolderDepartmentPkeyUpdate>>;
};

/** A filter to be used against `DocumentFolderDepartment` object types. All fields are combined with a logical ‘and.’ */
export type DocumentFolderDepartmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentFolderDepartmentFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `department` relation. */
  department?: InputMaybe<DepartmentFilter>;
  /** Filter by the object’s `departmentId` field. */
  departmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `documentFolder` relation. */
  documentFolder?: InputMaybe<DocumentFolderFilter>;
  /** Filter by the object’s `documentFolderId` field. */
  documentFolderId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentFolderDepartmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentFolderDepartmentFilter>>;
};

/** An input for mutations affecting `DocumentFolderDepartment` */
export type DocumentFolderDepartmentInput = {
  company?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentFolder?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `documentFolderDepartment` to look up the row to update. */
export type DocumentFolderDepartmentOnDocumentFolderDepartmentForDocumentFolderDepartmentCompanyIdForeignUsingDocumentFolderDepartmentPkeyUpdate = {
  departmentId: Scalars['UUID'];
  documentFolderId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentFolderDepartment` being updated. */
  patch: UpdateDocumentFolderDepartmentOnDocumentFolderDepartmentForDocumentFolderDepartmentCompanyIdForeignPatch;
};

/** The fields on `documentFolderDepartment` to look up the row to update. */
export type DocumentFolderDepartmentOnDocumentFolderDepartmentForDocumentFolderDepartmentDepartmentIdForeignUsingDocumentFolderDepartmentPkeyUpdate = {
  departmentId: Scalars['UUID'];
  documentFolderId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentFolderDepartment` being updated. */
  patch: UpdateDocumentFolderDepartmentOnDocumentFolderDepartmentForDocumentFolderDepartmentDepartmentIdForeignPatch;
};

/** The fields on `documentFolderDepartment` to look up the row to update. */
export type DocumentFolderDepartmentOnDocumentFolderDepartmentForDocumentFolderDepartmentDocumentFolderIdForeignUsingDocumentFolderDepartmentPkeyUpdate = {
  departmentId: Scalars['UUID'];
  documentFolderId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentFolderDepartment` being updated. */
  patch: UpdateDocumentFolderDepartmentOnDocumentFolderDepartmentForDocumentFolderDepartmentDocumentFolderIdForeignPatch;
};

/** Represents an update to a `DocumentFolderDepartment`. Fields that are set will be updated. */
export type DocumentFolderDepartmentPatch = {
  company?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentFolder?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `DocumentFolderDepartment` values. */
export type DocumentFolderDepartmentsConnection = {
  __typename?: 'DocumentFolderDepartmentsConnection';
  /** A list of edges which contains the `DocumentFolderDepartment` and cursor to aid in pagination. */
  edges: Array<DocumentFolderDepartmentsEdge>;
  /** A list of `DocumentFolderDepartment` objects. */
  nodes: Array<Maybe<DocumentFolderDepartment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentFolderDepartment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DocumentFolderDepartment` edge in the connection. */
export type DocumentFolderDepartmentsEdge = {
  __typename?: 'DocumentFolderDepartmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DocumentFolderDepartment` at the end of the edge. */
  node?: Maybe<DocumentFolderDepartment>;
};

/** Methods to use when ordering `DocumentFolderDepartment`. */
export type DocumentFolderDepartmentsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ACTIVE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ACTIVE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ADDRESS_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ADDRESS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ALIAS_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ALIAS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CITY_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CITY_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COMPANY_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COMPANY_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COUNTRY_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COUNTRY_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CREATED_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CREATED_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CUSTOM_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CUSTOM_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CVR_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CVR_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DELETE_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DELETE_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_NUMBER_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_NUMBER_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DESCRIPTION_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DESCRIPTION_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EAN_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EAN_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EMAIL_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EMAIL_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__MAIN_DEPARTMENT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__MAIN_DEPARTMENT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__NAME_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__NAME_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PHONE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PHONE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__POSTAL_CODE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__POSTAL_CODE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__P_NUMBER_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__P_NUMBER_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__UPDATED_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__UPDATED_AT_DESC'
  | 'DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__ACTIVE_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__ACTIVE_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__COMPANY_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__COMPANY_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__DEPARTMENTS_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__DEPARTMENTS_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__ID_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__LAST_EDITED_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__LAST_EDITED_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__NAME_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__NAME_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__OWNER_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__OWNER_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__OWNER_TYPE_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__OWNER_TYPE_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__PARENT_DOCUMENT_FOLDER_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__PARENT_DOCUMENT_FOLDER_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__USERS_SHARED_WITH_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__USERS_SHARED_WITH_DESC'
  | 'DOCUMENT_FOLDER_ID_ASC'
  | 'DOCUMENT_FOLDER_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/** The `documentFolder` to be created by this mutation. */
export type DocumentFolderDocumentFolderBlueprintIdForeignConnectionDocumentFolderCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolder?: InputMaybe<DocumentFolderParentDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastEdited?: InputMaybe<Scalars['Datetime']>;
  name: Scalars['String'];
  ownerId: Scalars['UUID'];
  ownerType: DocumentFolderOwnerType;
  parentDocumentFolderId?: InputMaybe<Scalars['UUID']>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageDocumentFolderIdForeignInverseInput>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `documentFolder` in the `DocumentFolderBlueprintInput` mutation. */
export type DocumentFolderDocumentFolderBlueprintIdForeignInverseInput = {
  /** The primary key(s) for `documentFolder` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DocumentFolderDocumentFolderPkeyConnect>>;
  /** A `DocumentFolderInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentFolderDocumentFolderBlueprintIdForeignConnectionDocumentFolderCreateInput>>;
  /** The primary key(s) and patch data for `documentFolder` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DocumentFolderOnDocumentFolderForDocumentFolderDocumentFolderBlueprintIdForeignUsingDocumentFolderPkeyUpdate>>;
};

/** The fields on `documentFolder` to look up the row to connect. */
export type DocumentFolderDocumentFolderPkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against `DocumentFolder` object types. All fields are combined with a logical ‘and.’ */
export type DocumentFolderFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentFolderFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `departmentsSharedWith` field. */
  departmentsSharedWith?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `documentFolderBlueprint` relation. */
  documentFolderBlueprint?: InputMaybe<DocumentFolderBlueprintFilter>;
  /** A related `documentFolderBlueprint` exists. */
  documentFolderBlueprintExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentFolderBlueprintId` field. */
  documentFolderBlueprintId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `documentFolderDepartments` relation. */
  documentFolderDepartments?: InputMaybe<DocumentFolderToManyDocumentFolderDepartmentFilter>;
  /** Some related `documentFolderDepartments` exist. */
  documentFolderDepartmentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentFolderUsers` relation. */
  documentFolderUsers?: InputMaybe<DocumentFolderToManyDocumentFolderUserFilter>;
  /** Some related `documentFolderUsers` exist. */
  documentFolderUsersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentFoldersByParentDocumentFolderId` relation. */
  documentFoldersByParentDocumentFolderId?: InputMaybe<DocumentFolderToManyDocumentFolderFilter>;
  /** Some related `documentFoldersByParentDocumentFolderId` exist. */
  documentFoldersByParentDocumentFolderIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `lastEdited` field. */
  lastEdited?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentFolderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentFolderFilter>>;
  /** Filter by the object’s `ownerId` field. */
  ownerId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `ownerType` field. */
  ownerType?: InputMaybe<DocumentFolderOwnerTypeFilter>;
  /** Filter by the object’s `parentDocumentFolder` relation. */
  parentDocumentFolder?: InputMaybe<DocumentFolderFilter>;
  /** A related `parentDocumentFolder` exists. */
  parentDocumentFolderExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `parentDocumentFolderId` field. */
  parentDocumentFolderId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `rootDocumentFolderBlueprint` relation. */
  rootDocumentFolderBlueprint?: InputMaybe<DocumentFolderBlueprintFilter>;
  /** A related `rootDocumentFolderBlueprint` exists. */
  rootDocumentFolderBlueprintExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `rootDocumentFolderBlueprintId` field. */
  rootDocumentFolderBlueprintId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `storages` relation. */
  storages?: InputMaybe<DocumentFolderToManyStorageFilter>;
  /** Some related `storages` exist. */
  storagesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `usersSharedWith` field. */
  usersSharedWith?: InputMaybe<UuidListFilter>;
};

/** An input for mutations affecting `DocumentFolder` */
export type DocumentFolderInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolder?: InputMaybe<DocumentFolderParentDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastEdited?: InputMaybe<Scalars['Datetime']>;
  name: Scalars['String'];
  ownerId: Scalars['UUID'];
  ownerType: DocumentFolderOwnerType;
  parentDocumentFolderId?: InputMaybe<Scalars['UUID']>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageDocumentFolderIdForeignInverseInput>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The fields on `documentFolder` to look up the row to update. */
export type DocumentFolderOnDocumentFolderDepartmentForDocumentFolderDepartmentDocumentFolderIdForeignUsingDocumentFolderPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentFolder` being updated. */
  patch: UpdateDocumentFolderOnDocumentFolderDepartmentForDocumentFolderDepartmentDocumentFolderIdForeignPatch;
};

/** The fields on `documentFolder` to look up the row to update. */
export type DocumentFolderOnDocumentFolderForDocumentFolderCompanyIdForeignUsingDocumentFolderPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentFolder` being updated. */
  patch: UpdateDocumentFolderOnDocumentFolderForDocumentFolderCompanyIdForeignPatch;
};

/** The fields on `documentFolder` to look up the row to update. */
export type DocumentFolderOnDocumentFolderForDocumentFolderDocumentFolderBlueprintIdForeignUsingDocumentFolderPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentFolder` being updated. */
  patch: UpdateDocumentFolderOnDocumentFolderForDocumentFolderDocumentFolderBlueprintIdForeignPatch;
};

/** The fields on `documentFolder` to look up the row to update. */
export type DocumentFolderOnDocumentFolderForDocumentFolderParentDocumentFolderIdForeignUsingDocumentFolderPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentFolder` being updated. */
  patch: UpdateDocumentFolderOnDocumentFolderForDocumentFolderParentDocumentFolderIdForeignPatch;
};

/** The fields on `documentFolder` to look up the row to update. */
export type DocumentFolderOnDocumentFolderForDocumentFolderRootDocumentFolderBlueprintIdForeignUsingDocumentFolderPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentFolder` being updated. */
  patch: UpdateDocumentFolderOnDocumentFolderForDocumentFolderRootDocumentFolderBlueprintIdForeignPatch;
};

/** The fields on `documentFolder` to look up the row to update. */
export type DocumentFolderOnDocumentFolderUserForDocumentFolderUserDocumentFolderIdForeignUsingDocumentFolderPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentFolder` being updated. */
  patch: UpdateDocumentFolderOnDocumentFolderUserForDocumentFolderUserDocumentFolderIdForeignPatch;
};

/** The fields on `documentFolder` to look up the row to update. */
export type DocumentFolderOnStorageForStorageDocumentFolderIdForeignUsingDocumentFolderPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentFolder` being updated. */
  patch: UpdateDocumentFolderOnStorageForStorageDocumentFolderIdForeignPatch;
};

export type DocumentFolderOwnerType =
  | 'COMPANY'
  | 'DEPARTMENT'
  | 'USER';

/** A filter to be used against DocumentFolderOwnerType fields. All fields are combined with a logical ‘and.’ */
export type DocumentFolderOwnerTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DocumentFolderOwnerType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DocumentFolderOwnerType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DocumentFolderOwnerType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DocumentFolderOwnerType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DocumentFolderOwnerType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DocumentFolderOwnerType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DocumentFolderOwnerType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DocumentFolderOwnerType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DocumentFolderOwnerType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DocumentFolderOwnerType>>;
};

/** The `documentFolder` to be created by this mutation. */
export type DocumentFolderParentDocumentFolderIdForeignConnectionDocumentFolderCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolder?: InputMaybe<DocumentFolderParentDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastEdited?: InputMaybe<Scalars['Datetime']>;
  name: Scalars['String'];
  ownerId: Scalars['UUID'];
  ownerType: DocumentFolderOwnerType;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageDocumentFolderIdForeignInverseInput>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `documentFolder` in the `DocumentFolderInput` mutation. */
export type DocumentFolderParentDocumentFolderIdForeignInput = {
  /** The primary key(s) for `documentFolder` for the far side of the relationship. */
  connectById?: InputMaybe<DocumentFolderDocumentFolderPkeyConnect>;
  /** A `DocumentFolderInput` object that will be created and connected to this object. */
  create?: InputMaybe<DocumentFolderParentDocumentFolderIdForeignConnectionDocumentFolderCreateInput>;
  /** The primary key(s) and patch data for `documentFolder` for the far side of the relationship. */
  updateById?: InputMaybe<DocumentFolderOnDocumentFolderForDocumentFolderParentDocumentFolderIdForeignUsingDocumentFolderPkeyUpdate>;
};

/** Represents an update to a `DocumentFolder`. Fields that are set will be updated. */
export type DocumentFolderPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolder?: InputMaybe<DocumentFolderParentDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastEdited?: InputMaybe<Scalars['Datetime']>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['UUID']>;
  ownerType?: InputMaybe<DocumentFolderOwnerType>;
  parentDocumentFolderId?: InputMaybe<Scalars['UUID']>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageDocumentFolderIdForeignInverseInput>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `documentFolderBlueprint` to be created by this mutation. */
export type DocumentFolderRootDocumentFolderBlueprintIdForeignConnectionDocumentFolderBlueprintCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderBlueprintParentDocumentFolderBlueprintIdFInput>;
  documentFoldersToDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderDocumentFolderBlueprintIdForeignInverseInput>;
  documentFoldersToRootDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  parentDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInverseInput>;
};

/** The `documentFolder` to be created by this mutation. */
export type DocumentFolderRootDocumentFolderBlueprintIdForeignConnectionDocumentFolderCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolder?: InputMaybe<DocumentFolderParentDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastEdited?: InputMaybe<Scalars['Datetime']>;
  name: Scalars['String'];
  ownerId: Scalars['UUID'];
  ownerType: DocumentFolderOwnerType;
  parentDocumentFolderId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageDocumentFolderIdForeignInverseInput>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `documentFolderBlueprint` in the `DocumentFolderInput` mutation. */
export type DocumentFolderRootDocumentFolderBlueprintIdForeignInput = {
  /** The primary key(s) for `documentFolderBlueprint` for the far side of the relationship. */
  connectById?: InputMaybe<DocumentFolderBlueprintDocumentFolderBlueprintPkeyConnect>;
  /** A `DocumentFolderBlueprintInput` object that will be created and connected to this object. */
  create?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignConnectionDocumentFolderBlueprintCreateInput>;
  /** The primary key(s) and patch data for `documentFolderBlueprint` for the far side of the relationship. */
  updateById?: InputMaybe<DocumentFolderBlueprintOnDocumentFolderForDocumentFolderRootDocumentFolderBlueprintIdForeignUsingDocumentFolderBlueprintPkeyUpdate>;
};

/** Input for the nested mutation of `documentFolder` in the `DocumentFolderBlueprintInput` mutation. */
export type DocumentFolderRootDocumentFolderBlueprintIdForeignInverseInput = {
  /** The primary key(s) for `documentFolder` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DocumentFolderDocumentFolderPkeyConnect>>;
  /** A `DocumentFolderInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentFolderRootDocumentFolderBlueprintIdForeignConnectionDocumentFolderCreateInput>>;
  /** The primary key(s) and patch data for `documentFolder` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DocumentFolderOnDocumentFolderForDocumentFolderRootDocumentFolderBlueprintIdForeignUsingDocumentFolderPkeyUpdate>>;
};

/** A filter to be used against many `DocumentFolderDepartment` object types. All fields are combined with a logical ‘and.’ */
export type DocumentFolderToManyDocumentFolderDepartmentFilter = {
  /** Every related `DocumentFolderDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentFolderDepartmentFilter>;
  /** No related `DocumentFolderDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentFolderDepartmentFilter>;
  /** Some related `DocumentFolderDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentFolderDepartmentFilter>;
};

/** A filter to be used against many `DocumentFolder` object types. All fields are combined with a logical ‘and.’ */
export type DocumentFolderToManyDocumentFolderFilter = {
  /** Every related `DocumentFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentFolderFilter>;
  /** No related `DocumentFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentFolderFilter>;
  /** Some related `DocumentFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentFolderFilter>;
};

/** A filter to be used against many `DocumentFolderUser` object types. All fields are combined with a logical ‘and.’ */
export type DocumentFolderToManyDocumentFolderUserFilter = {
  /** Every related `DocumentFolderUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentFolderUserFilter>;
  /** No related `DocumentFolderUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentFolderUserFilter>;
  /** Some related `DocumentFolderUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentFolderUserFilter>;
};

/** A filter to be used against many `Storage` object types. All fields are combined with a logical ‘and.’ */
export type DocumentFolderToManyStorageFilter = {
  /** Every related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<StorageFilter>;
  /** No related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<StorageFilter>;
  /** Some related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<StorageFilter>;
};

export type DocumentFolderUser = {
  __typename?: 'DocumentFolderUser';
  /** Reads a single `Company` that is related to this `DocumentFolderUser`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `DocumentFolder` that is related to this `DocumentFolderUser`. */
  documentFolder?: Maybe<DocumentFolder>;
  documentFolderId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `DocumentFolderUser`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The `documentFolderUser` to be created by this mutation. */
export type DocumentFolderUserCompanyIdForeignConnectionDocumentFolderUserCreateInput = {
  company?: InputMaybe<DocumentFolderUserCompanyIdForeignInput>;
  documentFolder?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<DocumentFolderUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `DocumentFolderUserInput` mutation. */
export type DocumentFolderUserCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnDocumentFolderUserForDocumentFolderUserCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `documentFolderUser` in the `CompanyInput` mutation. */
export type DocumentFolderUserCompanyIdForeignInverseInput = {
  /** The primary key(s) for `documentFolderUser` for the far side of the relationship. */
  connectByDocumentFolderIdAndUserId?: InputMaybe<Array<DocumentFolderUserDocumentFolderUserPkeyConnect>>;
  /** A `DocumentFolderUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentFolderUserCompanyIdForeignConnectionDocumentFolderUserCreateInput>>;
  /** The primary key(s) for `documentFolderUser` for the far side of the relationship. */
  deleteByDocumentFolderIdAndUserId?: InputMaybe<Array<DocumentFolderUserDocumentFolderUserPkeyDelete>>;
  /** Flag indicating whether all other `documentFolderUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `documentFolderUser` for the far side of the relationship. */
  updateByDocumentFolderIdAndUserId?: InputMaybe<Array<DocumentFolderUserOnDocumentFolderUserForDocumentFolderUserCompanyIdForeignUsingDocumentFolderUserPkeyUpdate>>;
};

/**
 * A condition to be used against `DocumentFolderUser` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DocumentFolderUserCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `documentFolderId` field. */
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `documentFolder` to be created by this mutation. */
export type DocumentFolderUserDocumentFolderIdForeignConnectionDocumentFolderCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolder?: InputMaybe<DocumentFolderParentDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastEdited?: InputMaybe<Scalars['Datetime']>;
  name: Scalars['String'];
  ownerId: Scalars['UUID'];
  ownerType: DocumentFolderOwnerType;
  parentDocumentFolderId?: InputMaybe<Scalars['UUID']>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageDocumentFolderIdForeignInverseInput>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `documentFolderUser` to be created by this mutation. */
export type DocumentFolderUserDocumentFolderIdForeignConnectionDocumentFolderUserCreateInput = {
  company?: InputMaybe<DocumentFolderUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  documentFolder?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInput>;
  user?: InputMaybe<DocumentFolderUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `documentFolder` in the `DocumentFolderUserInput` mutation. */
export type DocumentFolderUserDocumentFolderIdForeignInput = {
  /** The primary key(s) for `documentFolder` for the far side of the relationship. */
  connectById?: InputMaybe<DocumentFolderDocumentFolderPkeyConnect>;
  /** A `DocumentFolderInput` object that will be created and connected to this object. */
  create?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignConnectionDocumentFolderCreateInput>;
  /** The primary key(s) and patch data for `documentFolder` for the far side of the relationship. */
  updateById?: InputMaybe<DocumentFolderOnDocumentFolderUserForDocumentFolderUserDocumentFolderIdForeignUsingDocumentFolderPkeyUpdate>;
};

/** Input for the nested mutation of `documentFolderUser` in the `DocumentFolderInput` mutation. */
export type DocumentFolderUserDocumentFolderIdForeignInverseInput = {
  /** The primary key(s) for `documentFolderUser` for the far side of the relationship. */
  connectByDocumentFolderIdAndUserId?: InputMaybe<Array<DocumentFolderUserDocumentFolderUserPkeyConnect>>;
  /** A `DocumentFolderUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentFolderUserDocumentFolderIdForeignConnectionDocumentFolderUserCreateInput>>;
  /** The primary key(s) for `documentFolderUser` for the far side of the relationship. */
  deleteByDocumentFolderIdAndUserId?: InputMaybe<Array<DocumentFolderUserDocumentFolderUserPkeyDelete>>;
  /** Flag indicating whether all other `documentFolderUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `documentFolderUser` for the far side of the relationship. */
  updateByDocumentFolderIdAndUserId?: InputMaybe<Array<DocumentFolderUserOnDocumentFolderUserForDocumentFolderUserDocumentFolderIdForeignUsingDocumentFolderUserPkeyUpdate>>;
};

/** The fields on `documentFolderUser` to look up the row to connect. */
export type DocumentFolderUserDocumentFolderUserPkeyConnect = {
  documentFolderId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `documentFolderUser` to look up the row to delete. */
export type DocumentFolderUserDocumentFolderUserPkeyDelete = {
  documentFolderId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** A filter to be used against `DocumentFolderUser` object types. All fields are combined with a logical ‘and.’ */
export type DocumentFolderUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentFolderUserFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `documentFolder` relation. */
  documentFolder?: InputMaybe<DocumentFolderFilter>;
  /** Filter by the object’s `documentFolderId` field. */
  documentFolderId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentFolderUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentFolderUserFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `DocumentFolderUser` */
export type DocumentFolderUserInput = {
  company?: InputMaybe<DocumentFolderUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  documentFolder?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<DocumentFolderUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `documentFolderUser` to look up the row to update. */
export type DocumentFolderUserOnDocumentFolderUserForDocumentFolderUserCompanyIdForeignUsingDocumentFolderUserPkeyUpdate = {
  documentFolderId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentFolderUser` being updated. */
  patch: UpdateDocumentFolderUserOnDocumentFolderUserForDocumentFolderUserCompanyIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `documentFolderUser` to look up the row to update. */
export type DocumentFolderUserOnDocumentFolderUserForDocumentFolderUserDocumentFolderIdForeignUsingDocumentFolderUserPkeyUpdate = {
  documentFolderId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentFolderUser` being updated. */
  patch: UpdateDocumentFolderUserOnDocumentFolderUserForDocumentFolderUserDocumentFolderIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `documentFolderUser` to look up the row to update. */
export type DocumentFolderUserOnDocumentFolderUserForDocumentFolderUserUserIdForeignUsingDocumentFolderUserPkeyUpdate = {
  documentFolderId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentFolderUser` being updated. */
  patch: UpdateDocumentFolderUserOnDocumentFolderUserForDocumentFolderUserUserIdForeignPatch;
  userId: Scalars['UUID'];
};

/** Represents an update to a `DocumentFolderUser`. Fields that are set will be updated. */
export type DocumentFolderUserPatch = {
  company?: InputMaybe<DocumentFolderUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  documentFolder?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<DocumentFolderUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `documentFolderUser` to be created by this mutation. */
export type DocumentFolderUserUserIdForeignConnectionDocumentFolderUserCreateInput = {
  company?: InputMaybe<DocumentFolderUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  documentFolder?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<DocumentFolderUserUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `DocumentFolderUserInput` mutation. */
export type DocumentFolderUserUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnDocumentFolderUserForDocumentFolderUserUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `documentFolderUser` in the `UserInput` mutation. */
export type DocumentFolderUserUserIdForeignInverseInput = {
  /** The primary key(s) for `documentFolderUser` for the far side of the relationship. */
  connectByDocumentFolderIdAndUserId?: InputMaybe<Array<DocumentFolderUserDocumentFolderUserPkeyConnect>>;
  /** A `DocumentFolderUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentFolderUserUserIdForeignConnectionDocumentFolderUserCreateInput>>;
  /** The primary key(s) for `documentFolderUser` for the far side of the relationship. */
  deleteByDocumentFolderIdAndUserId?: InputMaybe<Array<DocumentFolderUserDocumentFolderUserPkeyDelete>>;
  /** Flag indicating whether all other `documentFolderUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `documentFolderUser` for the far side of the relationship. */
  updateByDocumentFolderIdAndUserId?: InputMaybe<Array<DocumentFolderUserOnDocumentFolderUserForDocumentFolderUserUserIdForeignUsingDocumentFolderUserPkeyUpdate>>;
};

/** A connection to a list of `DocumentFolderUser` values. */
export type DocumentFolderUsersConnection = {
  __typename?: 'DocumentFolderUsersConnection';
  /** A list of edges which contains the `DocumentFolderUser` and cursor to aid in pagination. */
  edges: Array<DocumentFolderUsersEdge>;
  /** A list of `DocumentFolderUser` objects. */
  nodes: Array<Maybe<DocumentFolderUser>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentFolderUser` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DocumentFolderUser` edge in the connection. */
export type DocumentFolderUsersEdge = {
  __typename?: 'DocumentFolderUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DocumentFolderUser` at the end of the edge. */
  node?: Maybe<DocumentFolderUser>;
};

/** Methods to use when ordering `DocumentFolderUser`. */
export type DocumentFolderUsersOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__ACTIVE_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__ACTIVE_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__COMPANY_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__COMPANY_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__DEPARTMENTS_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__DEPARTMENTS_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__ID_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__LAST_EDITED_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__LAST_EDITED_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__NAME_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__NAME_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__OWNER_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__OWNER_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__OWNER_TYPE_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__OWNER_TYPE_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__PARENT_DOCUMENT_FOLDER_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__PARENT_DOCUMENT_FOLDER_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__USERS_SHARED_WITH_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__USERS_SHARED_WITH_DESC'
  | 'DOCUMENT_FOLDER_ID_ASC'
  | 'DOCUMENT_FOLDER_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** A connection to a list of `DocumentFolder` values. */
export type DocumentFoldersConnection = {
  __typename?: 'DocumentFoldersConnection';
  /** A list of edges which contains the `DocumentFolder` and cursor to aid in pagination. */
  edges: Array<DocumentFoldersEdge>;
  /** A list of `DocumentFolder` objects. */
  nodes: Array<Maybe<DocumentFolder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentFolder` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DocumentFolder` edge in the connection. */
export type DocumentFoldersEdge = {
  __typename?: 'DocumentFoldersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DocumentFolder` at the end of the edge. */
  node?: Maybe<DocumentFolder>;
};

/** Methods to use when ordering `DocumentFolder`. */
export type DocumentFoldersOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'DEPARTMENTS_SHARED_WITH_ASC'
  | 'DEPARTMENTS_SHARED_WITH_DESC'
  | 'DOCUMENT_FOLDERS_BY_PARENT_DOCUMENT_FOLDER_ID__COUNT_ASC'
  | 'DOCUMENT_FOLDERS_BY_PARENT_DOCUMENT_FOLDER_ID__COUNT_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_DOCUMENT_FOLDER_BLUEPRINT_ID__ACTIVE_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_DOCUMENT_FOLDER_BLUEPRINT_ID__ACTIVE_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_DOCUMENT_FOLDER_BLUEPRINT_ID__COMPANY_ID_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_DOCUMENT_FOLDER_BLUEPRINT_ID__COMPANY_ID_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_DOCUMENT_FOLDER_BLUEPRINT_ID__ID_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_DOCUMENT_FOLDER_BLUEPRINT_ID__ID_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_DOCUMENT_FOLDER_BLUEPRINT_ID__NAME_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_DOCUMENT_FOLDER_BLUEPRINT_ID__NAME_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_DOCUMENT_FOLDER_BLUEPRINT_ID__PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_DOCUMENT_FOLDER_BLUEPRINT_ID__PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__ACTIVE_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__ACTIVE_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__COMPANY_ID_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__COMPANY_ID_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__ID_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__ID_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__NAME_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__NAME_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__ACTIVE_ASC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__ACTIVE_DESC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__COMPANY_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__COMPANY_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__DEPARTMENTS_ASC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__DEPARTMENTS_DESC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__ID_ASC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__ID_DESC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__LAST_EDITED_ASC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__LAST_EDITED_DESC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__NAME_ASC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__NAME_DESC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__OWNER_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__OWNER_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__OWNER_TYPE_ASC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__OWNER_TYPE_DESC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__PARENT_DOCUMENT_FOLDER_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__PARENT_DOCUMENT_FOLDER_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__USERS_SHARED_WITH_ASC'
  | 'DOCUMENT_FOLDER_BY_PARENT_DOCUMENT_FOLDER_ID__USERS_SHARED_WITH_DESC'
  | 'DOCUMENT_FOLDER_DEPARTMENTS_BY_DOCUMENT_FOLDER_ID__COUNT_ASC'
  | 'DOCUMENT_FOLDER_DEPARTMENTS_BY_DOCUMENT_FOLDER_ID__COUNT_DESC'
  | 'DOCUMENT_FOLDER_USERS_BY_DOCUMENT_FOLDER_ID__COUNT_ASC'
  | 'DOCUMENT_FOLDER_USERS_BY_DOCUMENT_FOLDER_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LAST_EDITED_ASC'
  | 'LAST_EDITED_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'OWNER_ID_ASC'
  | 'OWNER_ID_DESC'
  | 'OWNER_TYPE_ASC'
  | 'OWNER_TYPE_DESC'
  | 'PARENT_DOCUMENT_FOLDER_ID_ASC'
  | 'PARENT_DOCUMENT_FOLDER_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'STORAGES_BY_DOCUMENT_FOLDER_ID__COUNT_ASC'
  | 'STORAGES_BY_DOCUMENT_FOLDER_ID__COUNT_DESC'
  | 'USERS_SHARED_WITH_ASC'
  | 'USERS_SHARED_WITH_DESC';

/** A connection to a list of `DocumentFoldersWithPathRecord` values. */
export type DocumentFoldersWithPathConnection = {
  __typename?: 'DocumentFoldersWithPathConnection';
  /** A list of edges which contains the `DocumentFoldersWithPathRecord` and cursor to aid in pagination. */
  edges: Array<DocumentFoldersWithPathEdge>;
  /** A list of `DocumentFoldersWithPathRecord` objects. */
  nodes: Array<Maybe<DocumentFoldersWithPathRecord>>;
  /** The count of *all* `DocumentFoldersWithPathRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DocumentFoldersWithPathRecord` edge in the connection. */
export type DocumentFoldersWithPathEdge = {
  __typename?: 'DocumentFoldersWithPathEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DocumentFoldersWithPathRecord` at the end of the edge. */
  node?: Maybe<DocumentFoldersWithPathRecord>;
};

/** The return type of our `documentFoldersWithPath` query. */
export type DocumentFoldersWithPathRecord = {
  __typename?: 'DocumentFoldersWithPathRecord';
  documentFolderBlueprintId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  ownerId?: Maybe<Scalars['UUID']>;
  path?: Maybe<Scalars['String']>;
};

/** A filter to be used against `DocumentFoldersWithPathRecord` object types. All fields are combined with a logical ‘and.’ */
export type DocumentFoldersWithPathRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentFoldersWithPathRecordFilter>>;
  /** Filter by the object’s `documentFolderBlueprintId` field. */
  documentFolderBlueprintId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentFoldersWithPathRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentFoldersWithPathRecordFilter>>;
  /** Filter by the object’s `ownerId` field. */
  ownerId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `path` field. */
  path?: InputMaybe<StringFilter>;
};

export type DocumentType = {
  __typename?: 'DocumentType';
  active: Scalars['Boolean'];
  autoDeleteDays?: Maybe<Scalars['Int']>;
  companyId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `ContractSignPendingDocument`. */
  contractSignPendingDocuments: ContractSignPendingDocumentsConnection;
  /** Reads and enables pagination through a set of `ContractSignPending`. */
  contractSignPendingsByMergedDocumentDocumentTypeId: ContractSignPendingsConnection;
  /** Reads and enables pagination through a set of `ContractTemplate`. */
  contractTemplates: ContractTemplatesConnection;
  createdAt: Scalars['Datetime'];
  departmentId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `DocumentUserPermission`. */
  documentUserPermissions: DocumentUserPermissionsConnection;
  /** Reads and enables pagination through a set of `DocumentUserResponsible`. */
  documentUserResponsibles: DocumentUserResponsiblesConnection;
  /** Reads and enables pagination through a set of `EmployeeCasefile`. */
  employeeCasefiles: EmployeeCasefilesConnection;
  /** Reads and enables pagination through a set of `ExternalIntegration`. */
  externalIntegrationsByPayslipDocumentTypeId: ExternalIntegrationsConnection;
  /** Reads and enables pagination through a set of `Group`. */
  groupsWithAccess: GroupsConnection;
  id: Scalars['UUID'];
  lifetime?: Maybe<Scalars['Int']>;
  localizedName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `Storage`. */
  storages: StoragesConnection;
  updatedAt: Scalars['Datetime'];
};


export type DocumentTypeContractSignPendingDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingDocumentCondition>;
  filter?: InputMaybe<ContractSignPendingDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingDocumentsOrderBy>>;
};


export type DocumentTypeContractSignPendingsByMergedDocumentDocumentTypeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingCondition>;
  filter?: InputMaybe<ContractSignPendingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingsOrderBy>>;
};


export type DocumentTypeContractTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractTemplateCondition>;
  filter?: InputMaybe<ContractTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractTemplatesOrderBy>>;
};


export type DocumentTypeDocumentUserPermissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentUserPermissionCondition>;
  filter?: InputMaybe<DocumentUserPermissionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentUserPermissionsOrderBy>>;
};


export type DocumentTypeDocumentUserResponsiblesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentUserResponsibleCondition>;
  filter?: InputMaybe<DocumentUserResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentUserResponsiblesOrderBy>>;
};


export type DocumentTypeEmployeeCasefilesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmployeeCasefileCondition>;
  filter?: InputMaybe<EmployeeCasefileFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmployeeCasefilesOrderBy>>;
};


export type DocumentTypeExternalIntegrationsByPayslipDocumentTypeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalIntegrationCondition>;
  filter?: InputMaybe<ExternalIntegrationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalIntegrationsOrderBy>>;
};


export type DocumentTypeGroupsWithAccessArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


export type DocumentTypeStoragesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<StorageCondition>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StoragesOrderBy>>;
};

/**
 * A condition to be used against `DocumentType` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DocumentTypeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `autoDeleteDays` field. */
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departmentId` field. */
  departmentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `lifetime` field. */
  lifetime?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `documentType` to look up the row to connect. */
export type DocumentTypeDocumentTypeCompanyIdDepartmentIdNameUniqueConnect = {
  companyId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  name: Scalars['String'];
};

/** The fields on `documentType` to look up the row to connect. */
export type DocumentTypeDocumentTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against `DocumentType` object types. All fields are combined with a logical ‘and.’ */
export type DocumentTypeFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentTypeFilter>>;
  /** Filter by the object’s `autoDeleteDays` field. */
  autoDeleteDays?: InputMaybe<IntFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `contractSignPendingDocuments` relation. */
  contractSignPendingDocuments?: InputMaybe<DocumentTypeToManyContractSignPendingDocumentFilter>;
  /** Some related `contractSignPendingDocuments` exist. */
  contractSignPendingDocumentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractSignPendingsByMergedDocumentDocumentTypeId` relation. */
  contractSignPendingsByMergedDocumentDocumentTypeId?: InputMaybe<DocumentTypeToManyContractSignPendingFilter>;
  /** Some related `contractSignPendingsByMergedDocumentDocumentTypeId` exist. */
  contractSignPendingsByMergedDocumentDocumentTypeIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractTemplates` relation. */
  contractTemplates?: InputMaybe<DocumentTypeToManyContractTemplateFilter>;
  /** Some related `contractTemplates` exist. */
  contractTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departmentId` field. */
  departmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `documentUserPermissions` relation. */
  documentUserPermissions?: InputMaybe<DocumentTypeToManyDocumentUserPermissionFilter>;
  /** Some related `documentUserPermissions` exist. */
  documentUserPermissionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentUserResponsibles` relation. */
  documentUserResponsibles?: InputMaybe<DocumentTypeToManyDocumentUserResponsibleFilter>;
  /** Some related `documentUserResponsibles` exist. */
  documentUserResponsiblesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `employeeCasefiles` relation. */
  employeeCasefiles?: InputMaybe<DocumentTypeToManyEmployeeCasefileFilter>;
  /** Some related `employeeCasefiles` exist. */
  employeeCasefilesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `externalIntegrationsByPayslipDocumentTypeId` relation. */
  externalIntegrationsByPayslipDocumentTypeId?: InputMaybe<DocumentTypeToManyExternalIntegrationFilter>;
  /** Some related `externalIntegrationsByPayslipDocumentTypeId` exist. */
  externalIntegrationsByPayslipDocumentTypeIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `lifetime` field. */
  lifetime?: InputMaybe<IntFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentTypeFilter>>;
  /** Filter by the object’s `storages` relation. */
  storages?: InputMaybe<DocumentTypeToManyStorageFilter>;
  /** Some related `storages` exist. */
  storagesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `DocumentType` */
export type DocumentTypeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput>;
  contractTemplates?: InputMaybe<ContractTemplateDocumentTypeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lifetime?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  storages?: InputMaybe<StorageDocumentTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `documentType` to look up the row to update. */
export type DocumentTypeOnContractSignPendingDocumentForContractSignPendingDocumentDocumentTypeIdForeignUsingDocumentTypeCompanyIdDepartmentIdNameUniqueUpdate = {
  companyId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `documentType` being updated. */
  patch: UpdateDocumentTypeOnContractSignPendingDocumentForContractSignPendingDocumentDocumentTypeIdForeignPatch;
};

/** The fields on `documentType` to look up the row to update. */
export type DocumentTypeOnContractSignPendingDocumentForContractSignPendingDocumentDocumentTypeIdForeignUsingDocumentTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentType` being updated. */
  patch: UpdateDocumentTypeOnContractSignPendingDocumentForContractSignPendingDocumentDocumentTypeIdForeignPatch;
};

/** The fields on `documentType` to look up the row to update. */
export type DocumentTypeOnContractSignPendingForContractSignPendingMergedDocumentDocumentTypeIdForeignUsingDocumentTypeCompanyIdDepartmentIdNameUniqueUpdate = {
  companyId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `documentType` being updated. */
  patch: UpdateDocumentTypeOnContractSignPendingForContractSignPendingMergedDocumentDocumentTypeIdForeignPatch;
};

/** The fields on `documentType` to look up the row to update. */
export type DocumentTypeOnContractSignPendingForContractSignPendingMergedDocumentDocumentTypeIdForeignUsingDocumentTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentType` being updated. */
  patch: UpdateDocumentTypeOnContractSignPendingForContractSignPendingMergedDocumentDocumentTypeIdForeignPatch;
};

/** The fields on `documentType` to look up the row to update. */
export type DocumentTypeOnContractTemplateForContractTemplateDocumentTypeIdForeignUsingDocumentTypeCompanyIdDepartmentIdNameUniqueUpdate = {
  companyId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `documentType` being updated. */
  patch: UpdateDocumentTypeOnContractTemplateForContractTemplateDocumentTypeIdForeignPatch;
};

/** The fields on `documentType` to look up the row to update. */
export type DocumentTypeOnContractTemplateForContractTemplateDocumentTypeIdForeignUsingDocumentTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentType` being updated. */
  patch: UpdateDocumentTypeOnContractTemplateForContractTemplateDocumentTypeIdForeignPatch;
};

/** The fields on `documentType` to look up the row to update. */
export type DocumentTypeOnDocumentUserPermissionForDocumentUserPermissionsDocumentTypeIdForeignUsingDocumentTypeCompanyIdDepartmentIdNameUniqueUpdate = {
  companyId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `documentType` being updated. */
  patch: UpdateDocumentTypeOnDocumentUserPermissionForDocumentUserPermissionsDocumentTypeIdForeignPatch;
};

/** The fields on `documentType` to look up the row to update. */
export type DocumentTypeOnDocumentUserPermissionForDocumentUserPermissionsDocumentTypeIdForeignUsingDocumentTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentType` being updated. */
  patch: UpdateDocumentTypeOnDocumentUserPermissionForDocumentUserPermissionsDocumentTypeIdForeignPatch;
};

/** The fields on `documentType` to look up the row to update. */
export type DocumentTypeOnDocumentUserResponsibleForDocumentUserResponsibleDocumentTypeIdForeignUsingDocumentTypeCompanyIdDepartmentIdNameUniqueUpdate = {
  companyId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `documentType` being updated. */
  patch: UpdateDocumentTypeOnDocumentUserResponsibleForDocumentUserResponsibleDocumentTypeIdForeignPatch;
};

/** The fields on `documentType` to look up the row to update. */
export type DocumentTypeOnDocumentUserResponsibleForDocumentUserResponsibleDocumentTypeIdForeignUsingDocumentTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentType` being updated. */
  patch: UpdateDocumentTypeOnDocumentUserResponsibleForDocumentUserResponsibleDocumentTypeIdForeignPatch;
};

/** The fields on `documentType` to look up the row to update. */
export type DocumentTypeOnEmployeeCasefileForEmployeeCasefileDocumentTypeIdForeignUsingDocumentTypeCompanyIdDepartmentIdNameUniqueUpdate = {
  companyId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `documentType` being updated. */
  patch: UpdateDocumentTypeOnEmployeeCasefileForEmployeeCasefileDocumentTypeIdForeignPatch;
};

/** The fields on `documentType` to look up the row to update. */
export type DocumentTypeOnEmployeeCasefileForEmployeeCasefileDocumentTypeIdForeignUsingDocumentTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentType` being updated. */
  patch: UpdateDocumentTypeOnEmployeeCasefileForEmployeeCasefileDocumentTypeIdForeignPatch;
};

/** The fields on `documentType` to look up the row to update. */
export type DocumentTypeOnExternalIntegrationForExternalIntegrationPayslipDocumentTypeIdFkeyUsingDocumentTypeCompanyIdDepartmentIdNameUniqueUpdate = {
  companyId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `documentType` being updated. */
  patch: UpdateDocumentTypeOnExternalIntegrationForExternalIntegrationPayslipDocumentTypeIdFkeyPatch;
};

/** The fields on `documentType` to look up the row to update. */
export type DocumentTypeOnExternalIntegrationForExternalIntegrationPayslipDocumentTypeIdFkeyUsingDocumentTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentType` being updated. */
  patch: UpdateDocumentTypeOnExternalIntegrationForExternalIntegrationPayslipDocumentTypeIdFkeyPatch;
};

/** The fields on `documentType` to look up the row to update. */
export type DocumentTypeOnStorageForStorageDocumentTypeIdForeignUsingDocumentTypeCompanyIdDepartmentIdNameUniqueUpdate = {
  companyId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `documentType` being updated. */
  patch: UpdateDocumentTypeOnStorageForStorageDocumentTypeIdForeignPatch;
};

/** The fields on `documentType` to look up the row to update. */
export type DocumentTypeOnStorageForStorageDocumentTypeIdForeignUsingDocumentTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentType` being updated. */
  patch: UpdateDocumentTypeOnStorageForStorageDocumentTypeIdForeignPatch;
};

/** Represents an update to a `DocumentType`. Fields that are set will be updated. */
export type DocumentTypePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput>;
  contractTemplates?: InputMaybe<ContractTemplateDocumentTypeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lifetime?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  storages?: InputMaybe<StorageDocumentTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against many `ContractSignPendingDocument` object types. All fields are combined with a logical ‘and.’ */
export type DocumentTypeToManyContractSignPendingDocumentFilter = {
  /** Every related `ContractSignPendingDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractSignPendingDocumentFilter>;
  /** No related `ContractSignPendingDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractSignPendingDocumentFilter>;
  /** Some related `ContractSignPendingDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractSignPendingDocumentFilter>;
};

/** A filter to be used against many `ContractSignPending` object types. All fields are combined with a logical ‘and.’ */
export type DocumentTypeToManyContractSignPendingFilter = {
  /** Every related `ContractSignPending` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractSignPendingFilter>;
  /** No related `ContractSignPending` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractSignPendingFilter>;
  /** Some related `ContractSignPending` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractSignPendingFilter>;
};

/** A filter to be used against many `ContractTemplate` object types. All fields are combined with a logical ‘and.’ */
export type DocumentTypeToManyContractTemplateFilter = {
  /** Every related `ContractTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractTemplateFilter>;
  /** No related `ContractTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractTemplateFilter>;
  /** Some related `ContractTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractTemplateFilter>;
};

/** A filter to be used against many `DocumentUserPermission` object types. All fields are combined with a logical ‘and.’ */
export type DocumentTypeToManyDocumentUserPermissionFilter = {
  /** Every related `DocumentUserPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentUserPermissionFilter>;
  /** No related `DocumentUserPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentUserPermissionFilter>;
  /** Some related `DocumentUserPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentUserPermissionFilter>;
};

/** A filter to be used against many `DocumentUserResponsible` object types. All fields are combined with a logical ‘and.’ */
export type DocumentTypeToManyDocumentUserResponsibleFilter = {
  /** Every related `DocumentUserResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentUserResponsibleFilter>;
  /** No related `DocumentUserResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentUserResponsibleFilter>;
  /** Some related `DocumentUserResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentUserResponsibleFilter>;
};

/** A filter to be used against many `EmployeeCasefile` object types. All fields are combined with a logical ‘and.’ */
export type DocumentTypeToManyEmployeeCasefileFilter = {
  /** Every related `EmployeeCasefile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmployeeCasefileFilter>;
  /** No related `EmployeeCasefile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmployeeCasefileFilter>;
  /** Some related `EmployeeCasefile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmployeeCasefileFilter>;
};

/** A filter to be used against many `ExternalIntegration` object types. All fields are combined with a logical ‘and.’ */
export type DocumentTypeToManyExternalIntegrationFilter = {
  /** Every related `ExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalIntegrationFilter>;
  /** No related `ExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalIntegrationFilter>;
  /** Some related `ExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalIntegrationFilter>;
};

/** A filter to be used against many `Storage` object types. All fields are combined with a logical ‘and.’ */
export type DocumentTypeToManyStorageFilter = {
  /** Every related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<StorageFilter>;
  /** No related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<StorageFilter>;
  /** Some related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<StorageFilter>;
};

/** A connection to a list of `DocumentType` values. */
export type DocumentTypesConnection = {
  __typename?: 'DocumentTypesConnection';
  /** A list of edges which contains the `DocumentType` and cursor to aid in pagination. */
  edges: Array<DocumentTypesEdge>;
  /** A list of `DocumentType` objects. */
  nodes: Array<Maybe<DocumentType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DocumentType` edge in the connection. */
export type DocumentTypesEdge = {
  __typename?: 'DocumentTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DocumentType` at the end of the edge. */
  node?: Maybe<DocumentType>;
};

/** Methods to use when ordering `DocumentType`. */
export type DocumentTypesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'AUTO_DELETE_DAYS_ASC'
  | 'AUTO_DELETE_DAYS_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CONTRACT_SIGN_PENDINGS_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__COUNT_ASC'
  | 'CONTRACT_SIGN_PENDINGS_BY_MERGED_DOCUMENT_DOCUMENT_TYPE_ID__COUNT_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENTS_BY_DOCUMENT_TYPE_ID__COUNT_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENTS_BY_DOCUMENT_TYPE_ID__COUNT_DESC'
  | 'CONTRACT_TEMPLATES_BY_DOCUMENT_TYPE_ID__COUNT_ASC'
  | 'CONTRACT_TEMPLATES_BY_DOCUMENT_TYPE_ID__COUNT_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_ID_DESC'
  | 'DOCUMENT_USER_PERMISSIONS_BY_DOCUMENT_TYPE_ID__COUNT_ASC'
  | 'DOCUMENT_USER_PERMISSIONS_BY_DOCUMENT_TYPE_ID__COUNT_DESC'
  | 'DOCUMENT_USER_RESPONSIBLES_BY_DOCUMENT_TYPE_ID__COUNT_ASC'
  | 'DOCUMENT_USER_RESPONSIBLES_BY_DOCUMENT_TYPE_ID__COUNT_DESC'
  | 'EMPLOYEE_CASEFILES_BY_DOCUMENT_TYPE_ID__COUNT_ASC'
  | 'EMPLOYEE_CASEFILES_BY_DOCUMENT_TYPE_ID__COUNT_DESC'
  | 'EXTERNAL_INTEGRATIONS_BY_PAYSLIP_DOCUMENT_TYPE_ID__COUNT_ASC'
  | 'EXTERNAL_INTEGRATIONS_BY_PAYSLIP_DOCUMENT_TYPE_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIFETIME_ASC'
  | 'LIFETIME_DESC'
  | 'LOCALIZED_NAME_ASC'
  | 'LOCALIZED_NAME_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'STORAGES_BY_DOCUMENT_TYPE_ID__COUNT_ASC'
  | 'STORAGES_BY_DOCUMENT_TYPE_ID__COUNT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

export type DocumentUserPermission = {
  __typename?: 'DocumentUserPermission';
  /** Reads a single `Company` that is related to this `DocumentUserPermission`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `DocumentType` that is related to this `DocumentUserPermission`. */
  documentType?: Maybe<DocumentType>;
  documentTypeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Storage` that is related to this `DocumentUserPermission`. */
  file?: Maybe<Storage>;
  fileId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `DocumentUserPermission`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/**
 * A condition to be used against `DocumentUserPermission` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DocumentUserPermissionCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `documentTypeId` field. */
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fileId` field. */
  fileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `documentUserPermission` to look up the row to connect. */
export type DocumentUserPermissionDocumentUserPermissionsFileIdUserIdUniqueConnect = {
  fileId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** A filter to be used against `DocumentUserPermission` object types. All fields are combined with a logical ‘and.’ */
export type DocumentUserPermissionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentUserPermissionFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `documentType` relation. */
  documentType?: InputMaybe<DocumentTypeFilter>;
  /** A related `documentType` exists. */
  documentTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentTypeId` field. */
  documentTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `file` relation. */
  file?: InputMaybe<StorageFilter>;
  /** Filter by the object’s `fileId` field. */
  fileId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentUserPermissionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentUserPermissionFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `DocumentUserPermission` */
export type DocumentUserPermissionInput = {
  company?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserPermissionsFileIdForeignInput>;
  user?: InputMaybe<DocumentUserPermissionsUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `documentUserPermission` to look up the row to update. */
export type DocumentUserPermissionOnDocumentUserPermissionForDocumentUserPermissionsCompanyIdFkeyUsingDocumentUserPermissionsFileIdUserIdUniqueUpdate = {
  fileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentUserPermission` being updated. */
  patch: UpdateDocumentUserPermissionOnDocumentUserPermissionForDocumentUserPermissionsCompanyIdFkeyPatch;
  userId: Scalars['UUID'];
};

/** The fields on `documentUserPermission` to look up the row to update. */
export type DocumentUserPermissionOnDocumentUserPermissionForDocumentUserPermissionsDocumentTypeIdForeignUsingDocumentUserPermissionsFileIdUserIdUniqueUpdate = {
  fileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentUserPermission` being updated. */
  patch: UpdateDocumentUserPermissionOnDocumentUserPermissionForDocumentUserPermissionsDocumentTypeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `documentUserPermission` to look up the row to update. */
export type DocumentUserPermissionOnDocumentUserPermissionForDocumentUserPermissionsFileIdForeignUsingDocumentUserPermissionsFileIdUserIdUniqueUpdate = {
  fileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentUserPermission` being updated. */
  patch: UpdateDocumentUserPermissionOnDocumentUserPermissionForDocumentUserPermissionsFileIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `documentUserPermission` to look up the row to update. */
export type DocumentUserPermissionOnDocumentUserPermissionForDocumentUserPermissionsUserIdForeignUsingDocumentUserPermissionsFileIdUserIdUniqueUpdate = {
  fileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentUserPermission` being updated. */
  patch: UpdateDocumentUserPermissionOnDocumentUserPermissionForDocumentUserPermissionsUserIdForeignPatch;
  userId: Scalars['UUID'];
};

/** Represents an update to a `DocumentUserPermission`. Fields that are set will be updated. */
export type DocumentUserPermissionPatch = {
  company?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserPermissionsFileIdForeignInput>;
  user?: InputMaybe<DocumentUserPermissionsUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `documentUserPermission` to be created by this mutation. */
export type DocumentUserPermissionsCompanyIdFkeyConnectionDocumentUserPermissionsCreateInput = {
  company?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserPermissionsFileIdForeignInput>;
  user?: InputMaybe<DocumentUserPermissionsUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `DocumentUserPermissionInput` mutation. */
export type DocumentUserPermissionsCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnDocumentUserPermissionForDocumentUserPermissionsCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `documentUserPermission` in the `CompanyInput` mutation. */
export type DocumentUserPermissionsCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `documentUserPermission` for the far side of the relationship. */
  connectByFileIdAndUserId?: InputMaybe<Array<DocumentUserPermissionDocumentUserPermissionsFileIdUserIdUniqueConnect>>;
  /** A `DocumentUserPermissionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentUserPermissionsCompanyIdFkeyConnectionDocumentUserPermissionsCreateInput>>;
  /** The primary key(s) and patch data for `documentUserPermission` for the far side of the relationship. */
  updateByFileIdAndUserId?: InputMaybe<Array<DocumentUserPermissionOnDocumentUserPermissionForDocumentUserPermissionsCompanyIdFkeyUsingDocumentUserPermissionsFileIdUserIdUniqueUpdate>>;
};

/** A connection to a list of `DocumentUserPermission` values. */
export type DocumentUserPermissionsConnection = {
  __typename?: 'DocumentUserPermissionsConnection';
  /** A list of edges which contains the `DocumentUserPermission` and cursor to aid in pagination. */
  edges: Array<DocumentUserPermissionsEdge>;
  /** A list of `DocumentUserPermission` objects. */
  nodes: Array<Maybe<DocumentUserPermission>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentUserPermission` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The `documentType` to be created by this mutation. */
export type DocumentUserPermissionsDocumentTypeIdForeignConnectionDocumentTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput>;
  contractTemplates?: InputMaybe<ContractTemplateDocumentTypeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lifetime?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  storages?: InputMaybe<StorageDocumentTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `documentUserPermission` to be created by this mutation. */
export type DocumentUserPermissionsDocumentTypeIdForeignConnectionDocumentUserPermissionsCreateInput = {
  company?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInput>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserPermissionsFileIdForeignInput>;
  user?: InputMaybe<DocumentUserPermissionsUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `documentType` in the `DocumentUserPermissionInput` mutation. */
export type DocumentUserPermissionsDocumentTypeIdForeignInput = {
  /** The primary key(s) for `documentType` for the far side of the relationship. */
  connectByCompanyIdAndDepartmentIdAndName?: InputMaybe<DocumentTypeDocumentTypeCompanyIdDepartmentIdNameUniqueConnect>;
  /** The primary key(s) for `documentType` for the far side of the relationship. */
  connectById?: InputMaybe<DocumentTypeDocumentTypePkeyConnect>;
  /** A `DocumentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignConnectionDocumentTypeCreateInput>;
  /** The primary key(s) and patch data for `documentType` for the far side of the relationship. */
  updateByCompanyIdAndDepartmentIdAndName?: InputMaybe<DocumentTypeOnDocumentUserPermissionForDocumentUserPermissionsDocumentTypeIdForeignUsingDocumentTypeCompanyIdDepartmentIdNameUniqueUpdate>;
  /** The primary key(s) and patch data for `documentType` for the far side of the relationship. */
  updateById?: InputMaybe<DocumentTypeOnDocumentUserPermissionForDocumentUserPermissionsDocumentTypeIdForeignUsingDocumentTypePkeyUpdate>;
};

/** Input for the nested mutation of `documentUserPermission` in the `DocumentTypeInput` mutation. */
export type DocumentUserPermissionsDocumentTypeIdForeignInverseInput = {
  /** The primary key(s) for `documentUserPermission` for the far side of the relationship. */
  connectByFileIdAndUserId?: InputMaybe<Array<DocumentUserPermissionDocumentUserPermissionsFileIdUserIdUniqueConnect>>;
  /** A `DocumentUserPermissionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentUserPermissionsDocumentTypeIdForeignConnectionDocumentUserPermissionsCreateInput>>;
  /** The primary key(s) and patch data for `documentUserPermission` for the far side of the relationship. */
  updateByFileIdAndUserId?: InputMaybe<Array<DocumentUserPermissionOnDocumentUserPermissionForDocumentUserPermissionsDocumentTypeIdForeignUsingDocumentUserPermissionsFileIdUserIdUniqueUpdate>>;
};

/** A `DocumentUserPermission` edge in the connection. */
export type DocumentUserPermissionsEdge = {
  __typename?: 'DocumentUserPermissionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DocumentUserPermission` at the end of the edge. */
  node?: Maybe<DocumentUserPermission>;
};

/** The `documentUserPermission` to be created by this mutation. */
export type DocumentUserPermissionsFileIdForeignConnectionDocumentUserPermissionsCreateInput = {
  company?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserPermissionsFileIdForeignInput>;
  user?: InputMaybe<DocumentUserPermissionsUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `storage` to be created by this mutation. */
export type DocumentUserPermissionsFileIdForeignConnectionStorageCreateInput = {
  access: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createCopy?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path: Scalars['String'];
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `storage` in the `DocumentUserPermissionInput` mutation. */
export type DocumentUserPermissionsFileIdForeignInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<StorageStoragePkeyConnect>;
  /** A `StorageInput` object that will be created and connected to this object. */
  create?: InputMaybe<DocumentUserPermissionsFileIdForeignConnectionStorageCreateInput>;
  /** The primary key(s) and patch data for `storage` for the far side of the relationship. */
  updateById?: InputMaybe<StorageOnDocumentUserPermissionForDocumentUserPermissionsFileIdForeignUsingStoragePkeyUpdate>;
};

/** Input for the nested mutation of `documentUserPermission` in the `StorageInput` mutation. */
export type DocumentUserPermissionsFileIdForeignInverseInput = {
  /** The primary key(s) for `documentUserPermission` for the far side of the relationship. */
  connectByFileIdAndUserId?: InputMaybe<Array<DocumentUserPermissionDocumentUserPermissionsFileIdUserIdUniqueConnect>>;
  /** A `DocumentUserPermissionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentUserPermissionsFileIdForeignConnectionDocumentUserPermissionsCreateInput>>;
  /** The primary key(s) and patch data for `documentUserPermission` for the far side of the relationship. */
  updateByFileIdAndUserId?: InputMaybe<Array<DocumentUserPermissionOnDocumentUserPermissionForDocumentUserPermissionsFileIdForeignUsingDocumentUserPermissionsFileIdUserIdUniqueUpdate>>;
};

/** Methods to use when ordering `DocumentUserPermission`. */
export type DocumentUserPermissionsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ACTIVE_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ACTIVE_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__AUTO_DELETE_DAYS_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__AUTO_DELETE_DAYS_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__CREATED_AT_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__CREATED_AT_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DEPARTMENT_ID_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DEPARTMENT_ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ID_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LIFETIME_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LIFETIME_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__NAME_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__NAME_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'DOCUMENT_TYPE_ID_ASC'
  | 'DOCUMENT_TYPE_ID_DESC'
  | 'FILE_ID_ASC'
  | 'FILE_ID_DESC'
  | 'NATURAL'
  | 'STORAGE_BY_FILE_ID__ACCESS_ASC'
  | 'STORAGE_BY_FILE_ID__ACCESS_DESC'
  | 'STORAGE_BY_FILE_ID__ACTIVE_ASC'
  | 'STORAGE_BY_FILE_ID__ACTIVE_DESC'
  | 'STORAGE_BY_FILE_ID__BELONGS_TO_LEADER_ASC'
  | 'STORAGE_BY_FILE_ID__BELONGS_TO_LEADER_DESC'
  | 'STORAGE_BY_FILE_ID__COMPANY_ID_ASC'
  | 'STORAGE_BY_FILE_ID__COMPANY_ID_DESC'
  | 'STORAGE_BY_FILE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_FILE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_FILE_ID__CREATED_AT_ASC'
  | 'STORAGE_BY_FILE_ID__CREATED_AT_DESC'
  | 'STORAGE_BY_FILE_ID__DELETE_AT_ASC'
  | 'STORAGE_BY_FILE_ID__DELETE_AT_DESC'
  | 'STORAGE_BY_FILE_ID__DEPARTMENTS_ASC'
  | 'STORAGE_BY_FILE_ID__DEPARTMENTS_DESC'
  | 'STORAGE_BY_FILE_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'STORAGE_BY_FILE_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_FOLDER_ID_ASC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_FOLDER_ID_DESC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_TEMPLATE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_TEMPLATE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_TYPE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_TYPE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__EMPLOYEE_CASEFILE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__EMPLOYEE_CASEFILE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__EXPIRED_REMINDED_ASC'
  | 'STORAGE_BY_FILE_ID__EXPIRED_REMINDED_DESC'
  | 'STORAGE_BY_FILE_ID__EXPIRE_AT_ASC'
  | 'STORAGE_BY_FILE_ID__EXPIRE_AT_DESC'
  | 'STORAGE_BY_FILE_ID__FILENAME_ASC'
  | 'STORAGE_BY_FILE_ID__FILENAME_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_EXTENSION_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_EXTENSION_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_OWNER_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_OWNER_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_OWNER_ID_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_OWNER_ID_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_SIZE_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_SIZE_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_TYPE_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_TYPE_DESC'
  | 'STORAGE_BY_FILE_ID__FOLDER_DEPARTMENT_IDS_ASC'
  | 'STORAGE_BY_FILE_ID__FOLDER_DEPARTMENT_IDS_DESC'
  | 'STORAGE_BY_FILE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_FILE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_FILE_ID__FOLDER_OWNER_ID_ASC'
  | 'STORAGE_BY_FILE_ID__FOLDER_OWNER_ID_DESC'
  | 'STORAGE_BY_FILE_ID__FOLDER_USER_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_FILE_ID__FOLDER_USER_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_FILE_ID__HTML_ASC'
  | 'STORAGE_BY_FILE_ID__HTML_DESC'
  | 'STORAGE_BY_FILE_ID__ID_ASC'
  | 'STORAGE_BY_FILE_ID__ID_DESC'
  | 'STORAGE_BY_FILE_ID__MIMETYPE_ASC'
  | 'STORAGE_BY_FILE_ID__MIMETYPE_DESC'
  | 'STORAGE_BY_FILE_ID__OWNER_NAME_ASC'
  | 'STORAGE_BY_FILE_ID__OWNER_NAME_DESC'
  | 'STORAGE_BY_FILE_ID__PATH_ASC'
  | 'STORAGE_BY_FILE_ID__PATH_DESC'
  | 'STORAGE_BY_FILE_ID__PENNEO_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_FILE_ID__PENNEO_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_FILE_ID__PLACEHOLDER_VALUES_ASC'
  | 'STORAGE_BY_FILE_ID__PLACEHOLDER_VALUES_DESC'
  | 'STORAGE_BY_FILE_ID__PROCESS_TYPE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__PROCESS_TYPE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__REMINDED_ASC'
  | 'STORAGE_BY_FILE_ID__REMINDED_DESC'
  | 'STORAGE_BY_FILE_ID__REMIND_AT_ASC'
  | 'STORAGE_BY_FILE_ID__REMIND_AT_DESC'
  | 'STORAGE_BY_FILE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'STORAGE_BY_FILE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'STORAGE_BY_FILE_ID__TEMPLATING_SERVICE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__TEMPLATING_SERVICE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__USERS_RESPONSIBLE_ASC'
  | 'STORAGE_BY_FILE_ID__USERS_RESPONSIBLE_DESC'
  | 'STORAGE_BY_FILE_ID__USERS_SHARED_WITH_ASC'
  | 'STORAGE_BY_FILE_ID__USERS_SHARED_WITH_DEPARTMENTS_ASC'
  | 'STORAGE_BY_FILE_ID__USERS_SHARED_WITH_DEPARTMENTS_DESC'
  | 'STORAGE_BY_FILE_ID__USERS_SHARED_WITH_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** The `documentUserPermission` to be created by this mutation. */
export type DocumentUserPermissionsUserIdForeignConnectionDocumentUserPermissionsCreateInput = {
  company?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserPermissionsFileIdForeignInput>;
  user?: InputMaybe<DocumentUserPermissionsUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `DocumentUserPermissionInput` mutation. */
export type DocumentUserPermissionsUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnDocumentUserPermissionForDocumentUserPermissionsUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `documentUserPermission` in the `UserInput` mutation. */
export type DocumentUserPermissionsUserIdForeignInverseInput = {
  /** The primary key(s) for `documentUserPermission` for the far side of the relationship. */
  connectByFileIdAndUserId?: InputMaybe<Array<DocumentUserPermissionDocumentUserPermissionsFileIdUserIdUniqueConnect>>;
  /** A `DocumentUserPermissionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentUserPermissionsUserIdForeignConnectionDocumentUserPermissionsCreateInput>>;
  /** The primary key(s) and patch data for `documentUserPermission` for the far side of the relationship. */
  updateByFileIdAndUserId?: InputMaybe<Array<DocumentUserPermissionOnDocumentUserPermissionForDocumentUserPermissionsUserIdForeignUsingDocumentUserPermissionsFileIdUserIdUniqueUpdate>>;
};

export type DocumentUserResponsible = {
  __typename?: 'DocumentUserResponsible';
  assignedBy?: Maybe<Scalars['UUID']>;
  /** Reads a single `Company` that is related to this `DocumentUserResponsible`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  documentOwnerDepartmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  documentOwnerId?: Maybe<Scalars['UUID']>;
  /** Reads a single `DocumentType` that is related to this `DocumentUserResponsible`. */
  documentType?: Maybe<DocumentType>;
  documentTypeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Storage` that is related to this `DocumentUserResponsible`. */
  file?: Maybe<Storage>;
  fileId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `DocumentUserResponsible`. */
  user?: Maybe<User>;
  /** Reads a single `User` that is related to this `DocumentUserResponsible`. */
  userByAssignedBy?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The `documentUserResponsible` to be created by this mutation. */
export type DocumentUserResponsibleAssignedByForeignConnectionDocumentUserResponsibleCreateInput = {
  company?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserResponsibleFileIdForeignInput>;
  user?: InputMaybe<DocumentUserResponsibleAssignedByForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `user` in the `DocumentUserResponsibleInput` mutation. */
export type DocumentUserResponsibleAssignedByForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnDocumentUserResponsibleForDocumentUserResponsibleAssignedByForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `documentUserResponsible` in the `UserInput` mutation. */
export type DocumentUserResponsibleAssignedByForeignInverseInput = {
  /** The primary key(s) for `documentUserResponsible` for the far side of the relationship. */
  connectByFileIdAndUserId?: InputMaybe<Array<DocumentUserResponsibleDocumentUserResponsiblePkeyConnect>>;
  /** A `DocumentUserResponsibleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentUserResponsibleAssignedByForeignConnectionDocumentUserResponsibleCreateInput>>;
  /** The primary key(s) for `documentUserResponsible` for the far side of the relationship. */
  deleteByFileIdAndUserId?: InputMaybe<Array<DocumentUserResponsibleDocumentUserResponsiblePkeyDelete>>;
  /** Flag indicating whether all other `documentUserResponsible` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `documentUserResponsible` for the far side of the relationship. */
  updateByFileIdAndUserId?: InputMaybe<Array<DocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleAssignedByForeignUsingDocumentUserResponsiblePkeyUpdate>>;
};

/** The `documentUserResponsible` to be created by this mutation. */
export type DocumentUserResponsibleCompanyIdFkeyConnectionDocumentUserResponsibleCreateInput = {
  assignedBy?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserResponsibleFileIdForeignInput>;
  user?: InputMaybe<DocumentUserResponsibleAssignedByForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `DocumentUserResponsibleInput` mutation. */
export type DocumentUserResponsibleCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnDocumentUserResponsibleForDocumentUserResponsibleCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `documentUserResponsible` in the `CompanyInput` mutation. */
export type DocumentUserResponsibleCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `documentUserResponsible` for the far side of the relationship. */
  connectByFileIdAndUserId?: InputMaybe<Array<DocumentUserResponsibleDocumentUserResponsiblePkeyConnect>>;
  /** A `DocumentUserResponsibleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentUserResponsibleCompanyIdFkeyConnectionDocumentUserResponsibleCreateInput>>;
  /** The primary key(s) for `documentUserResponsible` for the far side of the relationship. */
  deleteByFileIdAndUserId?: InputMaybe<Array<DocumentUserResponsibleDocumentUserResponsiblePkeyDelete>>;
  /** Flag indicating whether all other `documentUserResponsible` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `documentUserResponsible` for the far side of the relationship. */
  updateByFileIdAndUserId?: InputMaybe<Array<DocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleCompanyIdFkeyUsingDocumentUserResponsiblePkeyUpdate>>;
};

/**
 * A condition to be used against `DocumentUserResponsible` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DocumentUserResponsibleCondition = {
  /** Checks for equality with the object’s `assignedBy` field. */
  assignedBy?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `documentOwnerDepartmentIds` field. */
  documentOwnerDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `documentOwnerId` field. */
  documentOwnerId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `documentTypeId` field. */
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fileId` field. */
  fileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `documentType` to be created by this mutation. */
export type DocumentUserResponsibleDocumentTypeIdForeignConnectionDocumentTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput>;
  contractTemplates?: InputMaybe<ContractTemplateDocumentTypeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lifetime?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  storages?: InputMaybe<StorageDocumentTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `documentUserResponsible` to be created by this mutation. */
export type DocumentUserResponsibleDocumentTypeIdForeignConnectionDocumentUserResponsibleCreateInput = {
  assignedBy?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInput>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserResponsibleFileIdForeignInput>;
  user?: InputMaybe<DocumentUserResponsibleAssignedByForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `documentType` in the `DocumentUserResponsibleInput` mutation. */
export type DocumentUserResponsibleDocumentTypeIdForeignInput = {
  /** The primary key(s) for `documentType` for the far side of the relationship. */
  connectByCompanyIdAndDepartmentIdAndName?: InputMaybe<DocumentTypeDocumentTypeCompanyIdDepartmentIdNameUniqueConnect>;
  /** The primary key(s) for `documentType` for the far side of the relationship. */
  connectById?: InputMaybe<DocumentTypeDocumentTypePkeyConnect>;
  /** A `DocumentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignConnectionDocumentTypeCreateInput>;
  /** The primary key(s) and patch data for `documentType` for the far side of the relationship. */
  updateByCompanyIdAndDepartmentIdAndName?: InputMaybe<DocumentTypeOnDocumentUserResponsibleForDocumentUserResponsibleDocumentTypeIdForeignUsingDocumentTypeCompanyIdDepartmentIdNameUniqueUpdate>;
  /** The primary key(s) and patch data for `documentType` for the far side of the relationship. */
  updateById?: InputMaybe<DocumentTypeOnDocumentUserResponsibleForDocumentUserResponsibleDocumentTypeIdForeignUsingDocumentTypePkeyUpdate>;
};

/** Input for the nested mutation of `documentUserResponsible` in the `DocumentTypeInput` mutation. */
export type DocumentUserResponsibleDocumentTypeIdForeignInverseInput = {
  /** The primary key(s) for `documentUserResponsible` for the far side of the relationship. */
  connectByFileIdAndUserId?: InputMaybe<Array<DocumentUserResponsibleDocumentUserResponsiblePkeyConnect>>;
  /** A `DocumentUserResponsibleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentUserResponsibleDocumentTypeIdForeignConnectionDocumentUserResponsibleCreateInput>>;
  /** The primary key(s) for `documentUserResponsible` for the far side of the relationship. */
  deleteByFileIdAndUserId?: InputMaybe<Array<DocumentUserResponsibleDocumentUserResponsiblePkeyDelete>>;
  /** Flag indicating whether all other `documentUserResponsible` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `documentUserResponsible` for the far side of the relationship. */
  updateByFileIdAndUserId?: InputMaybe<Array<DocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleDocumentTypeIdForeignUsingDocumentUserResponsiblePkeyUpdate>>;
};

/** The fields on `documentUserResponsible` to look up the row to connect. */
export type DocumentUserResponsibleDocumentUserResponsiblePkeyConnect = {
  fileId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `documentUserResponsible` to look up the row to delete. */
export type DocumentUserResponsibleDocumentUserResponsiblePkeyDelete = {
  fileId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The `documentUserResponsible` to be created by this mutation. */
export type DocumentUserResponsibleFileIdForeignConnectionDocumentUserResponsibleCreateInput = {
  assignedBy?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserResponsibleFileIdForeignInput>;
  user?: InputMaybe<DocumentUserResponsibleAssignedByForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `storage` to be created by this mutation. */
export type DocumentUserResponsibleFileIdForeignConnectionStorageCreateInput = {
  access: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createCopy?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path: Scalars['String'];
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `storage` in the `DocumentUserResponsibleInput` mutation. */
export type DocumentUserResponsibleFileIdForeignInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<StorageStoragePkeyConnect>;
  /** A `StorageInput` object that will be created and connected to this object. */
  create?: InputMaybe<DocumentUserResponsibleFileIdForeignConnectionStorageCreateInput>;
  /** The primary key(s) and patch data for `storage` for the far side of the relationship. */
  updateById?: InputMaybe<StorageOnDocumentUserResponsibleForDocumentUserResponsibleFileIdForeignUsingStoragePkeyUpdate>;
};

/** Input for the nested mutation of `documentUserResponsible` in the `StorageInput` mutation. */
export type DocumentUserResponsibleFileIdForeignInverseInput = {
  /** The primary key(s) for `documentUserResponsible` for the far side of the relationship. */
  connectByFileIdAndUserId?: InputMaybe<Array<DocumentUserResponsibleDocumentUserResponsiblePkeyConnect>>;
  /** A `DocumentUserResponsibleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentUserResponsibleFileIdForeignConnectionDocumentUserResponsibleCreateInput>>;
  /** The primary key(s) for `documentUserResponsible` for the far side of the relationship. */
  deleteByFileIdAndUserId?: InputMaybe<Array<DocumentUserResponsibleDocumentUserResponsiblePkeyDelete>>;
  /** Flag indicating whether all other `documentUserResponsible` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `documentUserResponsible` for the far side of the relationship. */
  updateByFileIdAndUserId?: InputMaybe<Array<DocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleFileIdForeignUsingDocumentUserResponsiblePkeyUpdate>>;
};

/** A filter to be used against `DocumentUserResponsible` object types. All fields are combined with a logical ‘and.’ */
export type DocumentUserResponsibleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DocumentUserResponsibleFilter>>;
  /** Filter by the object’s `assignedBy` field. */
  assignedBy?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `documentOwnerDepartmentIds` field. */
  documentOwnerDepartmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `documentOwnerId` field. */
  documentOwnerId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `documentType` relation. */
  documentType?: InputMaybe<DocumentTypeFilter>;
  /** A related `documentType` exists. */
  documentTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentTypeId` field. */
  documentTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `file` relation. */
  file?: InputMaybe<StorageFilter>;
  /** Filter by the object’s `fileId` field. */
  fileId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DocumentUserResponsibleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DocumentUserResponsibleFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userByAssignedBy` relation. */
  userByAssignedBy?: InputMaybe<UserFilter>;
  /** A related `userByAssignedBy` exists. */
  userByAssignedByExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `DocumentUserResponsible` */
export type DocumentUserResponsibleInput = {
  assignedBy?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserResponsibleFileIdForeignInput>;
  user?: InputMaybe<DocumentUserResponsibleAssignedByForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `documentUserResponsible` to look up the row to update. */
export type DocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleAssignedByForeignUsingDocumentUserResponsiblePkeyUpdate = {
  fileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentUserResponsible` being updated. */
  patch: UpdateDocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleAssignedByForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `documentUserResponsible` to look up the row to update. */
export type DocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleCompanyIdFkeyUsingDocumentUserResponsiblePkeyUpdate = {
  fileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentUserResponsible` being updated. */
  patch: UpdateDocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleCompanyIdFkeyPatch;
  userId: Scalars['UUID'];
};

/** The fields on `documentUserResponsible` to look up the row to update. */
export type DocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleDocumentTypeIdForeignUsingDocumentUserResponsiblePkeyUpdate = {
  fileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentUserResponsible` being updated. */
  patch: UpdateDocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleDocumentTypeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `documentUserResponsible` to look up the row to update. */
export type DocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleFileIdForeignUsingDocumentUserResponsiblePkeyUpdate = {
  fileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentUserResponsible` being updated. */
  patch: UpdateDocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleFileIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `documentUserResponsible` to look up the row to update. */
export type DocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleUserIdForeignUsingDocumentUserResponsiblePkeyUpdate = {
  fileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `documentUserResponsible` being updated. */
  patch: UpdateDocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleUserIdForeignPatch;
  userId: Scalars['UUID'];
};

/** Represents an update to a `DocumentUserResponsible`. Fields that are set will be updated. */
export type DocumentUserResponsiblePatch = {
  assignedBy?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserResponsibleFileIdForeignInput>;
  user?: InputMaybe<DocumentUserResponsibleAssignedByForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `documentUserResponsible` to be created by this mutation. */
export type DocumentUserResponsibleUserIdForeignConnectionDocumentUserResponsibleCreateInput = {
  assignedBy?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserResponsibleFileIdForeignInput>;
  user?: InputMaybe<DocumentUserResponsibleAssignedByForeignInput>;
};

/** Input for the nested mutation of `documentUserResponsible` in the `UserInput` mutation. */
export type DocumentUserResponsibleUserIdForeignInverseInput = {
  /** The primary key(s) for `documentUserResponsible` for the far side of the relationship. */
  connectByFileIdAndUserId?: InputMaybe<Array<DocumentUserResponsibleDocumentUserResponsiblePkeyConnect>>;
  /** A `DocumentUserResponsibleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<DocumentUserResponsibleUserIdForeignConnectionDocumentUserResponsibleCreateInput>>;
  /** The primary key(s) for `documentUserResponsible` for the far side of the relationship. */
  deleteByFileIdAndUserId?: InputMaybe<Array<DocumentUserResponsibleDocumentUserResponsiblePkeyDelete>>;
  /** Flag indicating whether all other `documentUserResponsible` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `documentUserResponsible` for the far side of the relationship. */
  updateByFileIdAndUserId?: InputMaybe<Array<DocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleUserIdForeignUsingDocumentUserResponsiblePkeyUpdate>>;
};

/** A connection to a list of `DocumentUserResponsible` values. */
export type DocumentUserResponsiblesConnection = {
  __typename?: 'DocumentUserResponsiblesConnection';
  /** A list of edges which contains the `DocumentUserResponsible` and cursor to aid in pagination. */
  edges: Array<DocumentUserResponsiblesEdge>;
  /** A list of `DocumentUserResponsible` objects. */
  nodes: Array<Maybe<DocumentUserResponsible>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DocumentUserResponsible` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DocumentUserResponsible` edge in the connection. */
export type DocumentUserResponsiblesEdge = {
  __typename?: 'DocumentUserResponsiblesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DocumentUserResponsible` at the end of the edge. */
  node?: Maybe<DocumentUserResponsible>;
};

/** Methods to use when ordering `DocumentUserResponsible`. */
export type DocumentUserResponsiblesOrderBy =
  | 'ASSIGNED_BY_ASC'
  | 'ASSIGNED_BY_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'DOCUMENT_OWNER_DEPARTMENT_IDS_ASC'
  | 'DOCUMENT_OWNER_DEPARTMENT_IDS_DESC'
  | 'DOCUMENT_OWNER_ID_ASC'
  | 'DOCUMENT_OWNER_ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ACTIVE_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ACTIVE_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__AUTO_DELETE_DAYS_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__AUTO_DELETE_DAYS_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__CREATED_AT_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__CREATED_AT_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DEPARTMENT_ID_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DEPARTMENT_ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ID_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LIFETIME_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LIFETIME_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__NAME_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__NAME_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'DOCUMENT_TYPE_ID_ASC'
  | 'DOCUMENT_TYPE_ID_DESC'
  | 'FILE_ID_ASC'
  | 'FILE_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'STORAGE_BY_FILE_ID__ACCESS_ASC'
  | 'STORAGE_BY_FILE_ID__ACCESS_DESC'
  | 'STORAGE_BY_FILE_ID__ACTIVE_ASC'
  | 'STORAGE_BY_FILE_ID__ACTIVE_DESC'
  | 'STORAGE_BY_FILE_ID__BELONGS_TO_LEADER_ASC'
  | 'STORAGE_BY_FILE_ID__BELONGS_TO_LEADER_DESC'
  | 'STORAGE_BY_FILE_ID__COMPANY_ID_ASC'
  | 'STORAGE_BY_FILE_ID__COMPANY_ID_DESC'
  | 'STORAGE_BY_FILE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_FILE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_FILE_ID__CREATED_AT_ASC'
  | 'STORAGE_BY_FILE_ID__CREATED_AT_DESC'
  | 'STORAGE_BY_FILE_ID__DELETE_AT_ASC'
  | 'STORAGE_BY_FILE_ID__DELETE_AT_DESC'
  | 'STORAGE_BY_FILE_ID__DEPARTMENTS_ASC'
  | 'STORAGE_BY_FILE_ID__DEPARTMENTS_DESC'
  | 'STORAGE_BY_FILE_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'STORAGE_BY_FILE_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_FOLDER_ID_ASC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_FOLDER_ID_DESC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_TEMPLATE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_TEMPLATE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_TYPE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_TYPE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__EMPLOYEE_CASEFILE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__EMPLOYEE_CASEFILE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__EXPIRED_REMINDED_ASC'
  | 'STORAGE_BY_FILE_ID__EXPIRED_REMINDED_DESC'
  | 'STORAGE_BY_FILE_ID__EXPIRE_AT_ASC'
  | 'STORAGE_BY_FILE_ID__EXPIRE_AT_DESC'
  | 'STORAGE_BY_FILE_ID__FILENAME_ASC'
  | 'STORAGE_BY_FILE_ID__FILENAME_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_EXTENSION_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_EXTENSION_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_OWNER_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_OWNER_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_OWNER_ID_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_OWNER_ID_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_SIZE_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_SIZE_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_TYPE_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_TYPE_DESC'
  | 'STORAGE_BY_FILE_ID__FOLDER_DEPARTMENT_IDS_ASC'
  | 'STORAGE_BY_FILE_ID__FOLDER_DEPARTMENT_IDS_DESC'
  | 'STORAGE_BY_FILE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_FILE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_FILE_ID__FOLDER_OWNER_ID_ASC'
  | 'STORAGE_BY_FILE_ID__FOLDER_OWNER_ID_DESC'
  | 'STORAGE_BY_FILE_ID__FOLDER_USER_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_FILE_ID__FOLDER_USER_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_FILE_ID__HTML_ASC'
  | 'STORAGE_BY_FILE_ID__HTML_DESC'
  | 'STORAGE_BY_FILE_ID__ID_ASC'
  | 'STORAGE_BY_FILE_ID__ID_DESC'
  | 'STORAGE_BY_FILE_ID__MIMETYPE_ASC'
  | 'STORAGE_BY_FILE_ID__MIMETYPE_DESC'
  | 'STORAGE_BY_FILE_ID__OWNER_NAME_ASC'
  | 'STORAGE_BY_FILE_ID__OWNER_NAME_DESC'
  | 'STORAGE_BY_FILE_ID__PATH_ASC'
  | 'STORAGE_BY_FILE_ID__PATH_DESC'
  | 'STORAGE_BY_FILE_ID__PENNEO_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_FILE_ID__PENNEO_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_FILE_ID__PLACEHOLDER_VALUES_ASC'
  | 'STORAGE_BY_FILE_ID__PLACEHOLDER_VALUES_DESC'
  | 'STORAGE_BY_FILE_ID__PROCESS_TYPE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__PROCESS_TYPE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__REMINDED_ASC'
  | 'STORAGE_BY_FILE_ID__REMINDED_DESC'
  | 'STORAGE_BY_FILE_ID__REMIND_AT_ASC'
  | 'STORAGE_BY_FILE_ID__REMIND_AT_DESC'
  | 'STORAGE_BY_FILE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'STORAGE_BY_FILE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'STORAGE_BY_FILE_ID__TEMPLATING_SERVICE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__TEMPLATING_SERVICE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__USERS_RESPONSIBLE_ASC'
  | 'STORAGE_BY_FILE_ID__USERS_RESPONSIBLE_DESC'
  | 'STORAGE_BY_FILE_ID__USERS_SHARED_WITH_ASC'
  | 'STORAGE_BY_FILE_ID__USERS_SHARED_WITH_DEPARTMENTS_ASC'
  | 'STORAGE_BY_FILE_ID__USERS_SHARED_WITH_DEPARTMENTS_DESC'
  | 'STORAGE_BY_FILE_ID__USERS_SHARED_WITH_DESC'
  | 'USER_BY_ASSIGNED_BY__ACTIVE_ASC'
  | 'USER_BY_ASSIGNED_BY__ACTIVE_DESC'
  | 'USER_BY_ASSIGNED_BY__ADDRESS_ASC'
  | 'USER_BY_ASSIGNED_BY__ADDRESS_DESC'
  | 'USER_BY_ASSIGNED_BY__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_BY__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_BY__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_BY__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_BY__BIRTHDATE_ASC'
  | 'USER_BY_ASSIGNED_BY__BIRTHDATE_DESC'
  | 'USER_BY_ASSIGNED_BY__CAN_LOGIN_APP_ASC'
  | 'USER_BY_ASSIGNED_BY__CAN_LOGIN_APP_DESC'
  | 'USER_BY_ASSIGNED_BY__CAN_LOGIN_ASC'
  | 'USER_BY_ASSIGNED_BY__CAN_LOGIN_DESC'
  | 'USER_BY_ASSIGNED_BY__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_ASSIGNED_BY__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_ASSIGNED_BY__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_ASSIGNED_BY__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_ASSIGNED_BY__CITY_ASC'
  | 'USER_BY_ASSIGNED_BY__CITY_DESC'
  | 'USER_BY_ASSIGNED_BY__COMPANY_ADMIN_ASC'
  | 'USER_BY_ASSIGNED_BY__COMPANY_ADMIN_DESC'
  | 'USER_BY_ASSIGNED_BY__COMPANY_ID_ASC'
  | 'USER_BY_ASSIGNED_BY__COMPANY_ID_DESC'
  | 'USER_BY_ASSIGNED_BY__CPR_ASC'
  | 'USER_BY_ASSIGNED_BY__CPR_DESC'
  | 'USER_BY_ASSIGNED_BY__CUSTOM_ID_ASC'
  | 'USER_BY_ASSIGNED_BY__CUSTOM_ID_DESC'
  | 'USER_BY_ASSIGNED_BY__DELETE_AT_ASC'
  | 'USER_BY_ASSIGNED_BY__DELETE_AT_DESC'
  | 'USER_BY_ASSIGNED_BY__DELETE_REMINDED_ASC'
  | 'USER_BY_ASSIGNED_BY__DELETE_REMINDED_DESC'
  | 'USER_BY_ASSIGNED_BY__DEPARTMENTS_ASC'
  | 'USER_BY_ASSIGNED_BY__DEPARTMENTS_DESC'
  | 'USER_BY_ASSIGNED_BY__EMAIL_ASC'
  | 'USER_BY_ASSIGNED_BY__EMAIL_DESC'
  | 'USER_BY_ASSIGNED_BY__EMAIL_WORK_ASC'
  | 'USER_BY_ASSIGNED_BY__EMAIL_WORK_DESC'
  | 'USER_BY_ASSIGNED_BY__EMPLOYEE_ID_ASC'
  | 'USER_BY_ASSIGNED_BY__EMPLOYEE_ID_DESC'
  | 'USER_BY_ASSIGNED_BY__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_BY__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_BY__EMPLOYMENT_END_ASC'
  | 'USER_BY_ASSIGNED_BY__EMPLOYMENT_END_DESC'
  | 'USER_BY_ASSIGNED_BY__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_ASSIGNED_BY__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_ASSIGNED_BY__EMPLOYMENT_START_ASC'
  | 'USER_BY_ASSIGNED_BY__EMPLOYMENT_START_DESC'
  | 'USER_BY_ASSIGNED_BY__FIRST_NAME_ASC'
  | 'USER_BY_ASSIGNED_BY__FIRST_NAME_DESC'
  | 'USER_BY_ASSIGNED_BY__FULL_NAME_ASC'
  | 'USER_BY_ASSIGNED_BY__FULL_NAME_DESC'
  | 'USER_BY_ASSIGNED_BY__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_ASSIGNED_BY__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_ASSIGNED_BY__GODMODE_ASC'
  | 'USER_BY_ASSIGNED_BY__GODMODE_DESC'
  | 'USER_BY_ASSIGNED_BY__GROUP_IDS_ASC'
  | 'USER_BY_ASSIGNED_BY__GROUP_IDS_DESC'
  | 'USER_BY_ASSIGNED_BY__ID_ASC'
  | 'USER_BY_ASSIGNED_BY__ID_DESC'
  | 'USER_BY_ASSIGNED_BY__INITIALS_ASC'
  | 'USER_BY_ASSIGNED_BY__INITIALS_DESC'
  | 'USER_BY_ASSIGNED_BY__IS_ARCHIVED_ASC'
  | 'USER_BY_ASSIGNED_BY__IS_ARCHIVED_DESC'
  | 'USER_BY_ASSIGNED_BY__IS_LEADER_ASC'
  | 'USER_BY_ASSIGNED_BY__IS_LEADER_DESC'
  | 'USER_BY_ASSIGNED_BY__IS_SYSTEM_USER_ASC'
  | 'USER_BY_ASSIGNED_BY__IS_SYSTEM_USER_DESC'
  | 'USER_BY_ASSIGNED_BY__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_ASSIGNED_BY__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_ASSIGNED_BY__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_ASSIGNED_BY__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_ASSIGNED_BY__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_ASSIGNED_BY__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_ASSIGNED_BY__LAST_LOGIN_ASC'
  | 'USER_BY_ASSIGNED_BY__LAST_LOGIN_DESC'
  | 'USER_BY_ASSIGNED_BY__LAST_NAME_ASC'
  | 'USER_BY_ASSIGNED_BY__LAST_NAME_DESC'
  | 'USER_BY_ASSIGNED_BY__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_ASSIGNED_BY__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_ASSIGNED_BY__MOBILE_ASC'
  | 'USER_BY_ASSIGNED_BY__MOBILE_DESC'
  | 'USER_BY_ASSIGNED_BY__MOBILE_PRIVATE_ASC'
  | 'USER_BY_ASSIGNED_BY__MOBILE_PRIVATE_DESC'
  | 'USER_BY_ASSIGNED_BY__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_ASSIGNED_BY__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_ASSIGNED_BY__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_ASSIGNED_BY__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_ASSIGNED_BY__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_ASSIGNED_BY__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_ASSIGNED_BY__PHONE_ASC'
  | 'USER_BY_ASSIGNED_BY__PHONE_DESC'
  | 'USER_BY_ASSIGNED_BY__POSTAL_CODE_ASC'
  | 'USER_BY_ASSIGNED_BY__POSTAL_CODE_DESC'
  | 'USER_BY_ASSIGNED_BY__SENIORITY_ASC'
  | 'USER_BY_ASSIGNED_BY__SENIORITY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type DocxToHtmlInput = {
  base64: Scalars['String'];
};

export type DocxToHtmlPayload = {
  __typename?: 'DocxToHtmlPayload';
  html: Scalars['String'];
};

export type DownloadCasefileDocumentInput = {
  casefileId: Scalars['Int'];
  documentId: Scalars['Int'];
};

export type DownloadCasefileDocumentPayload = {
  __typename?: 'DownloadCasefileDocumentPayload';
  base64: Scalars['String'];
};

export type DownloadEmployeeRecordUpdateTemplateInput = {
  delimiter: Scalars['String'];
  employeeRecordFieldId: Scalars['UUID'];
};

export type DownloadEmployeeRecordUpdateTemplatePayload = {
  __typename?: 'DownloadEmployeeRecordUpdateTemplatePayload';
  base64?: Maybe<Scalars['String']>;
};

export type DownloadEmployeesFileInput = {
  delimiter: Scalars['String'];
  onlyIncludeRequiredFields?: InputMaybe<Scalars['Boolean']>;
};

export type DownloadEmployeesFilePayload = {
  __typename?: 'DownloadEmployeesFilePayload';
  file: Scalars['String'];
};

export type DownloadEquipmentFileInput = {
  delimiter: Scalars['String'];
};

export type DownloadEquipmentFilePayload = {
  __typename?: 'DownloadEquipmentFilePayload';
  file: Scalars['String'];
};

export type EscoSearchResult = {
  __typename?: 'ESCOSearchResult';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type Employee = {
  __typename?: 'Employee';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `Employee`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  competenceIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads and enables pagination through a set of `ContractSignPending`. */
  contractSignPendings: ContractSignPendingsConnection;
  createdAt: Scalars['Datetime'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads and enables pagination through a set of `EmployeeCasefile`. */
  employeeCasefiles: EmployeeCasefilesConnection;
  /** Reads and enables pagination through a set of `EmployeeExternalIntegration`. */
  employeeExternalIntegrations: EmployeeExternalIntegrationsConnection;
  /** Reads and enables pagination through a set of `Equipment`. */
  equipments: EquipmentConnection;
  /** Reads and enables pagination through a set of `FormFieldEntry`. */
  formFieldEntries: FormFieldEntriesConnection;
  groupIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  id: Scalars['UUID'];
  isArchived: Scalars['Boolean'];
  isLeader: Scalars['Boolean'];
  isSystemUser: Scalars['Boolean'];
  jobPositionDescription?: Maybe<Scalars['String']>;
  jobPositionTitle?: Maybe<Scalars['String']>;
  jobPositionType?: Maybe<Scalars['String']>;
  jobPositionWorkingHours?: Maybe<Scalars['String']>;
  latestFormFieldsEntries?: Maybe<Array<Maybe<FormFieldEntry>>>;
  latestMessage?: Maybe<Message>;
  /** Reads and enables pagination through a set of `LatestMessage`. */
  latestMessagesByEmployeeId1: LatestMessagesConnection;
  /** Reads and enables pagination through a set of `LatestMessage`. */
  latestMessagesByEmployeeId2: LatestMessagesConnection;
  leaderDepartments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  logo?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `MessageRecipient`. */
  messageRecipients: MessageRecipientsConnection;
  /** Reads and enables pagination through a set of `Message`. */
  messagesByFromEmployeeId: MessagesConnection;
  /** Reads and enables pagination through a set of `Message`. */
  messagesByToEmployeeId: MessagesConnection;
  /** Reads and enables pagination through a set of `NotificationCustomRecipient`. */
  notificationCustomRecipients: NotificationCustomRecipientsConnection;
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferences: NotificationEmployeeReferencesConnection;
  /** Reads and enables pagination through a set of `NotificationEmployee`. */
  notificationEmployees: NotificationEmployeesConnection;
  /** Reads and enables pagination through a set of `NotificationEmployee`. */
  notificationEmployeesByRecipientId: NotificationEmployeesConnection;
  /** Reads and enables pagination through a set of `NotificationEmployee`. */
  notificationEmployeesBySenderId: NotificationEmployeesConnection;
  /** Reads and enables pagination through a set of `PreboardingComment`. */
  preboardingComments: PreboardingCommentsConnection;
  /** Reads and enables pagination through a set of `PreboardingEmailLog`. */
  preboardingEmailLogsByFromEmployeeId: PreboardingEmailLogsConnection;
  /** Reads and enables pagination through a set of `PreboardingEmployee`. */
  preboardingEmployees: PreboardingEmployeesConnection;
  /** Reads and enables pagination through a set of `PreboardingProcess`. */
  preboardingProcesses: PreboardingProcessesConnection;
  /** Reads and enables pagination through a set of `PreboardingResultSlideComment`. */
  preboardingResultSlideComments: PreboardingResultSlideCommentsConnection;
  /** Reads and enables pagination through a set of `PreboardingResult`. */
  preboardingResults: PreboardingResultsConnection;
  /** Reads and enables pagination through a set of `Preboarding`. */
  preboardings: PreboardingsConnection;
  /** Reads and enables pagination through a set of `ProcessEmployee`. */
  processEmployees: ProcessEmployeesConnection;
  /** Reads and enables pagination through a set of `ProcessResponsible`. */
  processResponsiblesByResponsibleId: ProcessResponsiblesConnection;
  /** Reads and enables pagination through a set of `Process`. */
  processes: ProcessesConnection;
  /** Reads and enables pagination through a set of `Project`. */
  projects: ProjectsConnection;
  /** Reads and enables pagination through a set of `SavedSignature`. */
  savedSignatures: SavedSignaturesConnection;
  /** Reads and enables pagination through a set of `ScheduledMessageRecipient`. */
  scheduledMessageRecipients: ScheduledMessageRecipientsConnection;
  /** Reads and enables pagination through a set of `ScheduledMessageTemplateRecipient`. */
  scheduledMessageTemplateRecipients: ScheduledMessageTemplateRecipientsConnection;
  /** Reads and enables pagination through a set of `ScheduledMessage`. */
  scheduledMessages: ScheduledMessagesConnection;
  /** Reads and enables pagination through a set of `ScheduledMessage`. */
  scheduledMessagesBySenderEmployeeId: ScheduledMessagesConnection;
  /** Reads and enables pagination through a set of `TaskEmployee`. */
  taskEmployees: TaskEmployeesConnection;
  /** Reads and enables pagination through a set of `TaskResponsible`. */
  taskResponsiblesByResponsibleId: TaskResponsiblesConnection;
  /** Reads and enables pagination through a set of `TaskTemplateEmployee`. */
  taskTemplateEmployees: TaskTemplateEmployeesConnection;
  /** Reads and enables pagination through a set of `TaskTemplateResponsible`. */
  taskTemplateResponsiblesByResponsibleId: TaskTemplateResponsiblesConnection;
  unreadMessageThreadCount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `Employee`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `User`. */
  users: UsersConnection;
};


export type EmployeeContractSignPendingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingCondition>;
  filter?: InputMaybe<ContractSignPendingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingsOrderBy>>;
};


export type EmployeeEmployeeCasefilesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmployeeCasefileCondition>;
  filter?: InputMaybe<EmployeeCasefileFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmployeeCasefilesOrderBy>>;
};


export type EmployeeEmployeeExternalIntegrationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmployeeExternalIntegrationCondition>;
  filter?: InputMaybe<EmployeeExternalIntegrationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmployeeExternalIntegrationsOrderBy>>;
};


export type EmployeeEquipmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EquipmentCondition>;
  filter?: InputMaybe<EquipmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentOrderBy>>;
};


export type EmployeeFormFieldEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldEntryCondition>;
  filter?: InputMaybe<FormFieldEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldEntriesOrderBy>>;
};


export type EmployeeLatestMessagesByEmployeeId1Args = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LatestMessageCondition>;
  filter?: InputMaybe<LatestMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LatestMessagesOrderBy>>;
};


export type EmployeeLatestMessagesByEmployeeId2Args = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LatestMessageCondition>;
  filter?: InputMaybe<LatestMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LatestMessagesOrderBy>>;
};


export type EmployeeMessageRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MessageRecipientCondition>;
  filter?: InputMaybe<MessageRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessageRecipientsOrderBy>>;
};


export type EmployeeMessagesByFromEmployeeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MessageCondition>;
  filter?: InputMaybe<MessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};


export type EmployeeMessagesByToEmployeeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MessageCondition>;
  filter?: InputMaybe<MessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};


export type EmployeeNotificationCustomRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationCustomRecipientCondition>;
  filter?: InputMaybe<NotificationCustomRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationCustomRecipientsOrderBy>>;
};


export type EmployeeNotificationEmployeeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};


export type EmployeeNotificationEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeCondition>;
  filter?: InputMaybe<NotificationEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeesOrderBy>>;
};


export type EmployeeNotificationEmployeesByRecipientIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeCondition>;
  filter?: InputMaybe<NotificationEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeesOrderBy>>;
};


export type EmployeeNotificationEmployeesBySenderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeCondition>;
  filter?: InputMaybe<NotificationEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeesOrderBy>>;
};


export type EmployeePreboardingCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingCommentCondition>;
  filter?: InputMaybe<PreboardingCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingCommentsOrderBy>>;
};


export type EmployeePreboardingEmailLogsByFromEmployeeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingEmailLogCondition>;
  filter?: InputMaybe<PreboardingEmailLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingEmailLogsOrderBy>>;
};


export type EmployeePreboardingEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingEmployeeCondition>;
  filter?: InputMaybe<PreboardingEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingEmployeesOrderBy>>;
};


export type EmployeePreboardingProcessesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingProcessCondition>;
  filter?: InputMaybe<PreboardingProcessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingProcessesOrderBy>>;
};


export type EmployeePreboardingResultSlideCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingResultSlideCommentCondition>;
  filter?: InputMaybe<PreboardingResultSlideCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingResultSlideCommentsOrderBy>>;
};


export type EmployeePreboardingResultsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingResultCondition>;
  filter?: InputMaybe<PreboardingResultFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingResultsOrderBy>>;
};


export type EmployeePreboardingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingCondition>;
  filter?: InputMaybe<PreboardingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingsOrderBy>>;
};


export type EmployeeProcessEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcessEmployeeCondition>;
  filter?: InputMaybe<ProcessEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcessEmployeesOrderBy>>;
};


export type EmployeeProcessResponsiblesByResponsibleIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcessResponsibleCondition>;
  filter?: InputMaybe<ProcessResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcessResponsiblesOrderBy>>;
};


export type EmployeeProcessesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcessCondition>;
  filter?: InputMaybe<ProcessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcessesOrderBy>>;
};


export type EmployeeProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};


export type EmployeeSavedSignaturesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SavedSignatureCondition>;
  filter?: InputMaybe<SavedSignatureFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SavedSignaturesOrderBy>>;
};


export type EmployeeScheduledMessageRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageRecipientCondition>;
  filter?: InputMaybe<ScheduledMessageRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageRecipientsOrderBy>>;
};


export type EmployeeScheduledMessageTemplateRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageTemplateRecipientCondition>;
  filter?: InputMaybe<ScheduledMessageTemplateRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageTemplateRecipientsOrderBy>>;
};


export type EmployeeScheduledMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageCondition>;
  filter?: InputMaybe<ScheduledMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessagesOrderBy>>;
};


export type EmployeeScheduledMessagesBySenderEmployeeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageCondition>;
  filter?: InputMaybe<ScheduledMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessagesOrderBy>>;
};


export type EmployeeTaskEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskEmployeeCondition>;
  filter?: InputMaybe<TaskEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskEmployeesOrderBy>>;
};


export type EmployeeTaskResponsiblesByResponsibleIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskResponsibleCondition>;
  filter?: InputMaybe<TaskResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskResponsiblesOrderBy>>;
};


export type EmployeeTaskTemplateEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskTemplateEmployeeCondition>;
  filter?: InputMaybe<TaskTemplateEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskTemplateEmployeesOrderBy>>;
};


export type EmployeeTaskTemplateResponsiblesByResponsibleIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskTemplateResponsibleCondition>;
  filter?: InputMaybe<TaskTemplateResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskTemplateResponsiblesOrderBy>>;
};


export type EmployeeUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  includeArchived?: InputMaybe<IncludeArchivedOption>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type EmployeeCasefile = {
  __typename?: 'EmployeeCasefile';
  active: Scalars['Boolean'];
  belongsToLeader: Scalars['Boolean'];
  casefileId: Scalars['Int'];
  /** Reads a single `Company` that is related to this `EmployeeCasefile`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `User` that is related to this `EmployeeCasefile`. */
  creatorUser?: Maybe<User>;
  creatorUserId?: Maybe<Scalars['UUID']>;
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `DocumentType` that is related to this `EmployeeCasefile`. */
  documentType?: Maybe<DocumentType>;
  documentTypeId?: Maybe<Scalars['UUID']>;
  documents?: Maybe<Scalars['JSON']>;
  /** Reads a single `Employee` that is related to this `EmployeeCasefile`. */
  employee?: Maybe<Employee>;
  employeeId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `Employee`. */
  employeeSigners: EmployeesConnection;
  enforceSignOrder: Scalars['Boolean'];
  expireAt?: Maybe<Scalars['Int']>;
  failedSync?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  locale: Scalars['String'];
  /** Reads a single `User` that is related to this `EmployeeCasefile`. */
  nextSigningUser?: Maybe<User>;
  nextSigningUserId?: Maybe<Scalars['UUID']>;
  notified: Scalars['Boolean'];
  recipients?: Maybe<Scalars['JSON']>;
  signedUserIds: Array<Maybe<Scalars['UUID']>>;
  signers?: Maybe<Scalars['JSON']>;
  signingUserIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  status?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Storage`. */
  storages: StoragesConnection;
  tempCasefileId?: Maybe<Scalars['UUID']>;
  title?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `EmployeeCasefile`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};


export type EmployeeCasefileEmployeeSignersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<EmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EmployeeCasefileStoragesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<StorageCondition>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StoragesOrderBy>>;
};

/** Input for the nested mutation of `company` in the `EmployeeCasefileInput` mutation. */
export type EmployeeCasefileCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnEmployeeCasefileForEmployeeCasefileCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `employeeCasefile` in the `CompanyInput` mutation. */
export type EmployeeCasefileCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `employeeCasefile` for the far side of the relationship. */
  connectByEmployeeIdAndCasefileId?: InputMaybe<Array<EmployeeCasefileEmployeeCasefileEmployeeIdCasefileIdUniqueConnect>>;
  /** The primary key(s) for `employeeCasefile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EmployeeCasefileEmployeeCasefilePkeyConnect>>;
  /** The primary key(s) and patch data for `employeeCasefile` for the far side of the relationship. */
  updateByEmployeeIdAndCasefileId?: InputMaybe<Array<EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileCompanyIdFkeyUsingEmployeeCasefileEmployeeIdCasefileIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `employeeCasefile` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileCompanyIdFkeyUsingEmployeeCasefilePkeyUpdate>>;
};

/**
 * A condition to be used against `EmployeeCasefile` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EmployeeCasefileCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `belongsToLeader` field. */
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `casefileId` field. */
  casefileId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `creatorUserId` field. */
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `documentTypeId` field. */
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `documents` field. */
  documents?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `enforceSignOrder` field. */
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `expireAt` field. */
  expireAt?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `failedSync` field. */
  failedSync?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `locale` field. */
  locale?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nextSigningUserId` field. */
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `notified` field. */
  notified?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `recipients` field. */
  recipients?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `signedUserIds` field. */
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `signers` field. */
  signers?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `signingUserIds` field. */
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `tempCasefileId` field. */
  tempCasefileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `user` in the `EmployeeCasefileInput` mutation. */
export type EmployeeCasefileCreatorUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnEmployeeCasefileForEmployeeCasefileCreatorUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `employeeCasefile` in the `UserInput` mutation. */
export type EmployeeCasefileCreatorUserIdForeignInverseInput = {
  /** The primary key(s) for `employeeCasefile` for the far side of the relationship. */
  connectByEmployeeIdAndCasefileId?: InputMaybe<Array<EmployeeCasefileEmployeeCasefileEmployeeIdCasefileIdUniqueConnect>>;
  /** The primary key(s) for `employeeCasefile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EmployeeCasefileEmployeeCasefilePkeyConnect>>;
  /** The primary key(s) and patch data for `employeeCasefile` for the far side of the relationship. */
  updateByEmployeeIdAndCasefileId?: InputMaybe<Array<EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileCreatorUserIdForeignUsingEmployeeCasefileEmployeeIdCasefileIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `employeeCasefile` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileCreatorUserIdForeignUsingEmployeeCasefilePkeyUpdate>>;
};

/** The `documentType` to be created by this mutation. */
export type EmployeeCasefileDocumentTypeIdForeignConnectionDocumentTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput>;
  contractTemplates?: InputMaybe<ContractTemplateDocumentTypeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lifetime?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  storages?: InputMaybe<StorageDocumentTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `documentType` in the `EmployeeCasefileInput` mutation. */
export type EmployeeCasefileDocumentTypeIdForeignInput = {
  /** The primary key(s) for `documentType` for the far side of the relationship. */
  connectByCompanyIdAndDepartmentIdAndName?: InputMaybe<DocumentTypeDocumentTypeCompanyIdDepartmentIdNameUniqueConnect>;
  /** The primary key(s) for `documentType` for the far side of the relationship. */
  connectById?: InputMaybe<DocumentTypeDocumentTypePkeyConnect>;
  /** A `DocumentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignConnectionDocumentTypeCreateInput>;
  /** The primary key(s) and patch data for `documentType` for the far side of the relationship. */
  updateByCompanyIdAndDepartmentIdAndName?: InputMaybe<DocumentTypeOnEmployeeCasefileForEmployeeCasefileDocumentTypeIdForeignUsingDocumentTypeCompanyIdDepartmentIdNameUniqueUpdate>;
  /** The primary key(s) and patch data for `documentType` for the far side of the relationship. */
  updateById?: InputMaybe<DocumentTypeOnEmployeeCasefileForEmployeeCasefileDocumentTypeIdForeignUsingDocumentTypePkeyUpdate>;
};

/** Input for the nested mutation of `employeeCasefile` in the `DocumentTypeInput` mutation. */
export type EmployeeCasefileDocumentTypeIdForeignInverseInput = {
  /** The primary key(s) for `employeeCasefile` for the far side of the relationship. */
  connectByEmployeeIdAndCasefileId?: InputMaybe<Array<EmployeeCasefileEmployeeCasefileEmployeeIdCasefileIdUniqueConnect>>;
  /** The primary key(s) for `employeeCasefile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EmployeeCasefileEmployeeCasefilePkeyConnect>>;
  /** The primary key(s) and patch data for `employeeCasefile` for the far side of the relationship. */
  updateByEmployeeIdAndCasefileId?: InputMaybe<Array<EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileDocumentTypeIdForeignUsingEmployeeCasefileEmployeeIdCasefileIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `employeeCasefile` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileDocumentTypeIdForeignUsingEmployeeCasefilePkeyUpdate>>;
};

/** The fields on `employeeCasefile` to look up the row to connect. */
export type EmployeeCasefileEmployeeCasefileEmployeeIdCasefileIdUniqueConnect = {
  casefileId: Scalars['Int'];
  employeeId: Scalars['UUID'];
};

/** The fields on `employeeCasefile` to look up the row to connect. */
export type EmployeeCasefileEmployeeCasefilePkeyConnect = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `employee` in the `EmployeeCasefileInput` mutation. */
export type EmployeeCasefileEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnEmployeeCasefileForEmployeeCasefileEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnEmployeeCasefileForEmployeeCasefileEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `employeeCasefile` in the `EmployeeInput` mutation. */
export type EmployeeCasefileEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `employeeCasefile` for the far side of the relationship. */
  connectByEmployeeIdAndCasefileId?: InputMaybe<Array<EmployeeCasefileEmployeeCasefileEmployeeIdCasefileIdUniqueConnect>>;
  /** The primary key(s) for `employeeCasefile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EmployeeCasefileEmployeeCasefilePkeyConnect>>;
  /** The primary key(s) and patch data for `employeeCasefile` for the far side of the relationship. */
  updateByEmployeeIdAndCasefileId?: InputMaybe<Array<EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileEmployeeIdForeignUsingEmployeeCasefileEmployeeIdCasefileIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `employeeCasefile` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileEmployeeIdForeignUsingEmployeeCasefilePkeyUpdate>>;
};

/** A filter to be used against `EmployeeCasefile` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeCasefileFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EmployeeCasefileFilter>>;
  /** Filter by the object’s `belongsToLeader` field. */
  belongsToLeader?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `casefileId` field. */
  casefileId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `creatorUser` relation. */
  creatorUser?: InputMaybe<UserFilter>;
  /** A related `creatorUser` exists. */
  creatorUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `creatorUserId` field. */
  creatorUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `documentType` relation. */
  documentType?: InputMaybe<DocumentTypeFilter>;
  /** A related `documentType` exists. */
  documentTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentTypeId` field. */
  documentTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `documents` field. */
  documents?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `enforceSignOrder` field. */
  enforceSignOrder?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `expireAt` field. */
  expireAt?: InputMaybe<IntFilter>;
  /** Filter by the object’s `failedSync` field. */
  failedSync?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `locale` field. */
  locale?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nextSigningUser` relation. */
  nextSigningUser?: InputMaybe<UserFilter>;
  /** A related `nextSigningUser` exists. */
  nextSigningUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `nextSigningUserId` field. */
  nextSigningUserId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EmployeeCasefileFilter>;
  /** Filter by the object’s `notified` field. */
  notified?: InputMaybe<BooleanFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EmployeeCasefileFilter>>;
  /** Filter by the object’s `recipients` field. */
  recipients?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `signedUserIds` field. */
  signedUserIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `signers` field. */
  signers?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `signingUserIds` field. */
  signingUserIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StringFilter>;
  /** Filter by the object’s `storages` relation. */
  storages?: InputMaybe<EmployeeCasefileToManyStorageFilter>;
  /** Some related `storages` exist. */
  storagesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `tempCasefileId` field. */
  tempCasefileId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** Input for the nested mutation of `employeeCasefile` in the `UserInput` mutation. */
export type EmployeeCasefileNextSigningUserIdForeignInverseInput = {
  /** The primary key(s) for `employeeCasefile` for the far side of the relationship. */
  connectByEmployeeIdAndCasefileId?: InputMaybe<Array<EmployeeCasefileEmployeeCasefileEmployeeIdCasefileIdUniqueConnect>>;
  /** The primary key(s) for `employeeCasefile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EmployeeCasefileEmployeeCasefilePkeyConnect>>;
  /** The primary key(s) and patch data for `employeeCasefile` for the far side of the relationship. */
  updateByEmployeeIdAndCasefileId?: InputMaybe<Array<EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileNextSigningUserIdForeignUsingEmployeeCasefileEmployeeIdCasefileIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `employeeCasefile` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileNextSigningUserIdForeignUsingEmployeeCasefilePkeyUpdate>>;
};

/** The fields on `employeeCasefile` to look up the row to update. */
export type EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileCompanyIdFkeyUsingEmployeeCasefileEmployeeIdCasefileIdUniqueUpdate = {
  casefileId: Scalars['Int'];
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employeeCasefile` being updated. */
  patch: UpdateEmployeeCasefileOnEmployeeCasefileForEmployeeCasefileCompanyIdFkeyPatch;
};

/** The fields on `employeeCasefile` to look up the row to update. */
export type EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileCompanyIdFkeyUsingEmployeeCasefilePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employeeCasefile` being updated. */
  patch: UpdateEmployeeCasefileOnEmployeeCasefileForEmployeeCasefileCompanyIdFkeyPatch;
};

/** The fields on `employeeCasefile` to look up the row to update. */
export type EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileCreatorUserIdForeignUsingEmployeeCasefileEmployeeIdCasefileIdUniqueUpdate = {
  casefileId: Scalars['Int'];
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employeeCasefile` being updated. */
  patch: UpdateEmployeeCasefileOnEmployeeCasefileForEmployeeCasefileCreatorUserIdForeignPatch;
};

/** The fields on `employeeCasefile` to look up the row to update. */
export type EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileCreatorUserIdForeignUsingEmployeeCasefilePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employeeCasefile` being updated. */
  patch: UpdateEmployeeCasefileOnEmployeeCasefileForEmployeeCasefileCreatorUserIdForeignPatch;
};

/** The fields on `employeeCasefile` to look up the row to update. */
export type EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileDocumentTypeIdForeignUsingEmployeeCasefileEmployeeIdCasefileIdUniqueUpdate = {
  casefileId: Scalars['Int'];
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employeeCasefile` being updated. */
  patch: UpdateEmployeeCasefileOnEmployeeCasefileForEmployeeCasefileDocumentTypeIdForeignPatch;
};

/** The fields on `employeeCasefile` to look up the row to update. */
export type EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileDocumentTypeIdForeignUsingEmployeeCasefilePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employeeCasefile` being updated. */
  patch: UpdateEmployeeCasefileOnEmployeeCasefileForEmployeeCasefileDocumentTypeIdForeignPatch;
};

/** The fields on `employeeCasefile` to look up the row to update. */
export type EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileEmployeeIdForeignUsingEmployeeCasefileEmployeeIdCasefileIdUniqueUpdate = {
  casefileId: Scalars['Int'];
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employeeCasefile` being updated. */
  patch: UpdateEmployeeCasefileOnEmployeeCasefileForEmployeeCasefileEmployeeIdForeignPatch;
};

/** The fields on `employeeCasefile` to look up the row to update. */
export type EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileEmployeeIdForeignUsingEmployeeCasefilePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employeeCasefile` being updated. */
  patch: UpdateEmployeeCasefileOnEmployeeCasefileForEmployeeCasefileEmployeeIdForeignPatch;
};

/** The fields on `employeeCasefile` to look up the row to update. */
export type EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileNextSigningUserIdForeignUsingEmployeeCasefileEmployeeIdCasefileIdUniqueUpdate = {
  casefileId: Scalars['Int'];
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employeeCasefile` being updated. */
  patch: UpdateEmployeeCasefileOnEmployeeCasefileForEmployeeCasefileNextSigningUserIdForeignPatch;
};

/** The fields on `employeeCasefile` to look up the row to update. */
export type EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileNextSigningUserIdForeignUsingEmployeeCasefilePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employeeCasefile` being updated. */
  patch: UpdateEmployeeCasefileOnEmployeeCasefileForEmployeeCasefileNextSigningUserIdForeignPatch;
};

/** The fields on `employeeCasefile` to look up the row to update. */
export type EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileUserIdFkeyUsingEmployeeCasefileEmployeeIdCasefileIdUniqueUpdate = {
  casefileId: Scalars['Int'];
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employeeCasefile` being updated. */
  patch: UpdateEmployeeCasefileOnEmployeeCasefileForEmployeeCasefileUserIdFkeyPatch;
};

/** The fields on `employeeCasefile` to look up the row to update. */
export type EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileUserIdFkeyUsingEmployeeCasefilePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employeeCasefile` being updated. */
  patch: UpdateEmployeeCasefileOnEmployeeCasefileForEmployeeCasefileUserIdFkeyPatch;
};

/** The fields on `employeeCasefile` to look up the row to update. */
export type EmployeeCasefileOnStorageForStorageEmployeeCasefileIdForeignUsingEmployeeCasefileEmployeeIdCasefileIdUniqueUpdate = {
  casefileId: Scalars['Int'];
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employeeCasefile` being updated. */
  patch: UpdateEmployeeCasefileOnStorageForStorageEmployeeCasefileIdForeignPatch;
};

/** The fields on `employeeCasefile` to look up the row to update. */
export type EmployeeCasefileOnStorageForStorageEmployeeCasefileIdForeignUsingEmployeeCasefilePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employeeCasefile` being updated. */
  patch: UpdateEmployeeCasefileOnStorageForStorageEmployeeCasefileIdForeignPatch;
};

/** Represents an update to a `EmployeeCasefile`. Fields that are set will be updated. */
export type EmployeeCasefilePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<EmployeeCasefileCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documents?: InputMaybe<Scalars['JSON']>;
  employee?: InputMaybe<EmployeeCasefileEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  expireAt?: InputMaybe<Scalars['Int']>;
  failedSync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  locale?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notified?: InputMaybe<Scalars['Boolean']>;
  recipients?: InputMaybe<Scalars['JSON']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signers?: InputMaybe<Scalars['JSON']>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  status?: InputMaybe<Scalars['String']>;
  storages?: InputMaybe<StorageEmployeeCasefileIdForeignInverseInput>;
  tempCasefileId?: InputMaybe<Scalars['UUID']>;
  title?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against many `Storage` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeCasefileToManyStorageFilter = {
  /** Every related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<StorageFilter>;
  /** No related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<StorageFilter>;
  /** Some related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<StorageFilter>;
};

/** Input for the nested mutation of `employeeCasefile` in the `UserInput` mutation. */
export type EmployeeCasefileUserIdFkeyInverseInput = {
  /** The primary key(s) for `employeeCasefile` for the far side of the relationship. */
  connectByEmployeeIdAndCasefileId?: InputMaybe<Array<EmployeeCasefileEmployeeCasefileEmployeeIdCasefileIdUniqueConnect>>;
  /** The primary key(s) for `employeeCasefile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EmployeeCasefileEmployeeCasefilePkeyConnect>>;
  /** The primary key(s) and patch data for `employeeCasefile` for the far side of the relationship. */
  updateByEmployeeIdAndCasefileId?: InputMaybe<Array<EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileUserIdFkeyUsingEmployeeCasefileEmployeeIdCasefileIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `employeeCasefile` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EmployeeCasefileOnEmployeeCasefileForEmployeeCasefileUserIdFkeyUsingEmployeeCasefilePkeyUpdate>>;
};

/** A connection to a list of `EmployeeCasefile` values. */
export type EmployeeCasefilesConnection = {
  __typename?: 'EmployeeCasefilesConnection';
  /** A list of edges which contains the `EmployeeCasefile` and cursor to aid in pagination. */
  edges: Array<EmployeeCasefilesEdge>;
  /** A list of `EmployeeCasefile` objects. */
  nodes: Array<Maybe<EmployeeCasefile>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EmployeeCasefile` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EmployeeCasefile` edge in the connection. */
export type EmployeeCasefilesEdge = {
  __typename?: 'EmployeeCasefilesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EmployeeCasefile` at the end of the edge. */
  node?: Maybe<EmployeeCasefile>;
};

/** Methods to use when ordering `EmployeeCasefile`. */
export type EmployeeCasefilesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'BELONGS_TO_LEADER_ASC'
  | 'BELONGS_TO_LEADER_DESC'
  | 'CASEFILE_ID_ASC'
  | 'CASEFILE_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CREATOR_USER_ID_ASC'
  | 'CREATOR_USER_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'DOCUMENTS_ASC'
  | 'DOCUMENTS_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ACTIVE_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ACTIVE_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__AUTO_DELETE_DAYS_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__AUTO_DELETE_DAYS_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__CREATED_AT_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__CREATED_AT_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DEPARTMENT_ID_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DEPARTMENT_ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ID_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LIFETIME_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LIFETIME_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__NAME_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__NAME_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'DOCUMENT_TYPE_ID_ASC'
  | 'DOCUMENT_TYPE_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'ENFORCE_SIGN_ORDER_ASC'
  | 'ENFORCE_SIGN_ORDER_DESC'
  | 'EXPIRE_AT_ASC'
  | 'EXPIRE_AT_DESC'
  | 'FAILED_SYNC_ASC'
  | 'FAILED_SYNC_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALE_ASC'
  | 'LOCALE_DESC'
  | 'NATURAL'
  | 'NEXT_SIGNING_USER_ID_ASC'
  | 'NEXT_SIGNING_USER_ID_DESC'
  | 'NOTIFIED_ASC'
  | 'NOTIFIED_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RECIPIENTS_ASC'
  | 'RECIPIENTS_DESC'
  | 'SIGNED_USER_IDS_ASC'
  | 'SIGNED_USER_IDS_DESC'
  | 'SIGNERS_ASC'
  | 'SIGNERS_DESC'
  | 'SIGNING_USER_IDS_ASC'
  | 'SIGNING_USER_IDS_DESC'
  | 'STATUS_ASC'
  | 'STATUS_DESC'
  | 'STORAGES_BY_EMPLOYEE_CASEFILE_ID__COUNT_ASC'
  | 'STORAGES_BY_EMPLOYEE_CASEFILE_ID__COUNT_DESC'
  | 'TEMP_CASEFILE_ID_ASC'
  | 'TEMP_CASEFILE_ID_DESC'
  | 'TITLE_ASC'
  | 'TITLE_DESC'
  | 'USER_BY_CREATOR_USER_ID__ACTIVE_ASC'
  | 'USER_BY_CREATOR_USER_ID__ACTIVE_DESC'
  | 'USER_BY_CREATOR_USER_ID__ADDRESS_ASC'
  | 'USER_BY_CREATOR_USER_ID__ADDRESS_DESC'
  | 'USER_BY_CREATOR_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_CREATOR_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_CREATOR_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_CREATOR_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_CREATOR_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_CREATOR_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_CREATOR_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_CREATOR_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_CREATOR_USER_ID__CITY_ASC'
  | 'USER_BY_CREATOR_USER_ID__CITY_DESC'
  | 'USER_BY_CREATOR_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_CREATOR_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_CREATOR_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_CREATOR_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_CREATOR_USER_ID__CPR_ASC'
  | 'USER_BY_CREATOR_USER_ID__CPR_DESC'
  | 'USER_BY_CREATOR_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_CREATOR_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_CREATOR_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_CREATOR_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_CREATOR_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_CREATOR_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_CREATOR_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_CREATOR_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMAIL_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMAIL_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_CREATOR_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_CREATOR_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_CREATOR_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_CREATOR_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_CREATOR_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_CREATOR_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_CREATOR_USER_ID__GODMODE_ASC'
  | 'USER_BY_CREATOR_USER_ID__GODMODE_DESC'
  | 'USER_BY_CREATOR_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_CREATOR_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_CREATOR_USER_ID__ID_ASC'
  | 'USER_BY_CREATOR_USER_ID__ID_DESC'
  | 'USER_BY_CREATOR_USER_ID__INITIALS_ASC'
  | 'USER_BY_CREATOR_USER_ID__INITIALS_DESC'
  | 'USER_BY_CREATOR_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_CREATOR_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_CREATOR_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_CREATOR_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_CREATOR_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_CREATOR_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_CREATOR_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_CREATOR_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_CREATOR_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_CREATOR_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_CREATOR_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_CREATOR_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_CREATOR_USER_ID__MOBILE_ASC'
  | 'USER_BY_CREATOR_USER_ID__MOBILE_DESC'
  | 'USER_BY_CREATOR_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_CREATOR_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_CREATOR_USER_ID__PHONE_ASC'
  | 'USER_BY_CREATOR_USER_ID__PHONE_DESC'
  | 'USER_BY_CREATOR_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_CREATOR_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_CREATOR_USER_ID__SENIORITY_ASC'
  | 'USER_BY_CREATOR_USER_ID__SENIORITY_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__ACTIVE_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__ACTIVE_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__ADDRESS_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__ADDRESS_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CITY_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CITY_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CPR_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CPR_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMAIL_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMAIL_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__GODMODE_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__GODMODE_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__ID_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__ID_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__INITIALS_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__INITIALS_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__MOBILE_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__MOBILE_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__PHONE_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__PHONE_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__SENIORITY_ASC'
  | 'USER_BY_NEXT_SIGNING_USER_ID__SENIORITY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** Input for the nested mutation of `company` in the `EmployeeInput` mutation. */
export type EmployeeCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnEmployeeForEmployeeCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `employee` in the `CompanyInput` mutation. */
export type EmployeeCompanyIdForeignInverseInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EmployeeEmployeePkeyConnect>>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<Array<EmployeeEmployeeUserIdUniqueConnect>>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EmployeeOnEmployeeForEmployeeCompanyIdForeignUsingEmployeePkeyUpdate>>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<Array<EmployeeOnEmployeeForEmployeeCompanyIdForeignUsingEmployeeUserIdUniqueUpdate>>;
};

/**
 * A condition to be used against `Employee` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type EmployeeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `groupIds` field. */
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isArchived` field. */
  isArchived?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isLeader` field. */
  isLeader?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isSystemUser` field. */
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `leaderDepartments` field. */
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `employee` to look up the row to connect. */
export type EmployeeEmployeePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to connect. */
export type EmployeeEmployeeUserIdUniqueConnect = {
  userId: Scalars['UUID'];
};

export type EmployeeExternalIntegration = {
  __typename?: 'EmployeeExternalIntegration';
  /** Reads a single `Company` that is related to this `EmployeeExternalIntegration`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Employee` that is related to this `EmployeeExternalIntegration`. */
  employee?: Maybe<Employee>;
  employeeId: Scalars['UUID'];
  externalEmployeeId?: Maybe<Scalars['String']>;
  /** Reads a single `ExternalIntegration` that is related to this `EmployeeExternalIntegration`. */
  externalIntegration?: Maybe<ExternalIntegration>;
  externalIntegrationId?: Maybe<Scalars['UUID']>;
  sameSystem?: Maybe<Scalars['String']>;
};

/** The `employeeExternalIntegration` to be created by this mutation. */
export type EmployeeExternalIntegrationCompanyIdFkeyConnectionEmployeeExternalIntegrationCreateInput = {
  company?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  externalEmployeeId?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInput>;
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  sameSystem?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `company` in the `EmployeeExternalIntegrationInput` mutation. */
export type EmployeeExternalIntegrationCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnEmployeeExternalIntegrationForEmployeeExternalIntegrationCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `employeeExternalIntegration` in the `CompanyInput` mutation. */
export type EmployeeExternalIntegrationCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `employeeExternalIntegration` for the far side of the relationship. */
  connectByEmployeeIdAndExternalIntegrationId?: InputMaybe<Array<EmployeeExternalIntegrationIntegrationEmployeeUniqueConnect>>;
  /** The primary key(s) for `employeeExternalIntegration` for the far side of the relationship. */
  connectBySameSystem?: InputMaybe<Array<EmployeeExternalIntegrationEmployeeExternalIntegrationSameSystemUniqueConnect>>;
  /** A `EmployeeExternalIntegrationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EmployeeExternalIntegrationCompanyIdFkeyConnectionEmployeeExternalIntegrationCreateInput>>;
  /** The primary key(s) and patch data for `employeeExternalIntegration` for the far side of the relationship. */
  updateByEmployeeIdAndExternalIntegrationId?: InputMaybe<Array<EmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationCompanyIdFkeyUsingIntegrationEmployeeUniqueUpdate>>;
  /** The primary key(s) and patch data for `employeeExternalIntegration` for the far side of the relationship. */
  updateBySameSystem?: InputMaybe<Array<EmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationCompanyIdFkeyUsingEmployeeExternalIntegrationSameSystemUniqueUpdate>>;
};

/**
 * A condition to be used against `EmployeeExternalIntegration` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type EmployeeExternalIntegrationCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `externalEmployeeId` field. */
  externalEmployeeId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `externalIntegrationId` field. */
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `sameSystem` field. */
  sameSystem?: InputMaybe<Scalars['String']>;
};

/** The fields on `employeeExternalIntegration` to look up the row to connect. */
export type EmployeeExternalIntegrationEmployeeExternalIntegrationSameSystemUniqueConnect = {
  sameSystem: Scalars['String'];
};

/** The `employeeExternalIntegration` to be created by this mutation. */
export type EmployeeExternalIntegrationEmployeeIdForeignConnectionEmployeeExternalIntegrationCreateInput = {
  company?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInput>;
  externalEmployeeId?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInput>;
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  sameSystem?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `employee` in the `EmployeeExternalIntegrationInput` mutation. */
export type EmployeeExternalIntegrationEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnEmployeeExternalIntegrationForEmployeeExternalIntegrationEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnEmployeeExternalIntegrationForEmployeeExternalIntegrationEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `employeeExternalIntegration` in the `EmployeeInput` mutation. */
export type EmployeeExternalIntegrationEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `employeeExternalIntegration` for the far side of the relationship. */
  connectByEmployeeIdAndExternalIntegrationId?: InputMaybe<Array<EmployeeExternalIntegrationIntegrationEmployeeUniqueConnect>>;
  /** The primary key(s) for `employeeExternalIntegration` for the far side of the relationship. */
  connectBySameSystem?: InputMaybe<Array<EmployeeExternalIntegrationEmployeeExternalIntegrationSameSystemUniqueConnect>>;
  /** A `EmployeeExternalIntegrationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EmployeeExternalIntegrationEmployeeIdForeignConnectionEmployeeExternalIntegrationCreateInput>>;
  /** The primary key(s) and patch data for `employeeExternalIntegration` for the far side of the relationship. */
  updateByEmployeeIdAndExternalIntegrationId?: InputMaybe<Array<EmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationEmployeeIdForeignUsingIntegrationEmployeeUniqueUpdate>>;
  /** The primary key(s) and patch data for `employeeExternalIntegration` for the far side of the relationship. */
  updateBySameSystem?: InputMaybe<Array<EmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationEmployeeIdForeignUsingEmployeeExternalIntegrationSameSystemUniqueUpdate>>;
};

/** The `employeeExternalIntegration` to be created by this mutation. */
export type EmployeeExternalIntegrationExternalIntegrationIdForeignConnectionEmployeeExternalIntegrationCreateInput = {
  company?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  externalEmployeeId?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInput>;
  sameSystem?: InputMaybe<Scalars['String']>;
};

/** The `externalIntegration` to be created by this mutation. */
export type EmployeeExternalIntegrationExternalIntegrationIdForeignConnectionExternalIntegrationCreateInput = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<ExternalIntegrationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  documentFolderBlueprint?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput>;
  documentType?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput>;
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  externalCompanyId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInput>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrableSystem?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInput>;
  integrableSystemId?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput>;
  payslipDocumentBlueprintFolderId?: InputMaybe<Scalars['UUID']>;
  payslipDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** Input for the nested mutation of `externalIntegration` in the `EmployeeExternalIntegrationInput` mutation. */
export type EmployeeExternalIntegrationExternalIntegrationIdForeignInput = {
  /** The primary key(s) for `externalIntegration` for the far side of the relationship. */
  connectById?: InputMaybe<ExternalIntegrationExternalIntegrationPkeyConnect>;
  /** A `ExternalIntegrationInput` object that will be created and connected to this object. */
  create?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignConnectionExternalIntegrationCreateInput>;
  /** The primary key(s) for `externalIntegration` for the far side of the relationship. */
  deleteById?: InputMaybe<ExternalIntegrationExternalIntegrationPkeyDelete>;
  /** The primary key(s) and patch data for `externalIntegration` for the far side of the relationship. */
  updateById?: InputMaybe<ExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationExternalIntegrationIdForeignUsingExternalIntegrationPkeyUpdate>;
};

/** Input for the nested mutation of `employeeExternalIntegration` in the `ExternalIntegrationInput` mutation. */
export type EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput = {
  /** The primary key(s) for `employeeExternalIntegration` for the far side of the relationship. */
  connectByEmployeeIdAndExternalIntegrationId?: InputMaybe<Array<EmployeeExternalIntegrationIntegrationEmployeeUniqueConnect>>;
  /** The primary key(s) for `employeeExternalIntegration` for the far side of the relationship. */
  connectBySameSystem?: InputMaybe<Array<EmployeeExternalIntegrationEmployeeExternalIntegrationSameSystemUniqueConnect>>;
  /** A `EmployeeExternalIntegrationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EmployeeExternalIntegrationExternalIntegrationIdForeignConnectionEmployeeExternalIntegrationCreateInput>>;
  /** The primary key(s) and patch data for `employeeExternalIntegration` for the far side of the relationship. */
  updateByEmployeeIdAndExternalIntegrationId?: InputMaybe<Array<EmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationExternalIntegrationIdForeignUsingIntegrationEmployeeUniqueUpdate>>;
  /** The primary key(s) and patch data for `employeeExternalIntegration` for the far side of the relationship. */
  updateBySameSystem?: InputMaybe<Array<EmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationExternalIntegrationIdForeignUsingEmployeeExternalIntegrationSameSystemUniqueUpdate>>;
};

/** A filter to be used against `EmployeeExternalIntegration` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeExternalIntegrationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EmployeeExternalIntegrationFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `externalEmployeeId` field. */
  externalEmployeeId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalIntegration` relation. */
  externalIntegration?: InputMaybe<ExternalIntegrationFilter>;
  /** A related `externalIntegration` exists. */
  externalIntegrationExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `externalIntegrationId` field. */
  externalIntegrationId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EmployeeExternalIntegrationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EmployeeExternalIntegrationFilter>>;
  /** Filter by the object’s `sameSystem` field. */
  sameSystem?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `EmployeeExternalIntegration` */
export type EmployeeExternalIntegrationInput = {
  company?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  externalEmployeeId?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInput>;
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  sameSystem?: InputMaybe<Scalars['String']>;
};

/** The fields on `employeeExternalIntegration` to look up the row to connect. */
export type EmployeeExternalIntegrationIntegrationEmployeeUniqueConnect = {
  employeeId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
};

/** The fields on `employeeExternalIntegration` to look up the row to update. */
export type EmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationCompanyIdFkeyUsingEmployeeExternalIntegrationSameSystemUniqueUpdate = {
  /** An object where the defined keys will be set on the `employeeExternalIntegration` being updated. */
  patch: UpdateEmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationCompanyIdFkeyPatch;
  sameSystem: Scalars['String'];
};

/** The fields on `employeeExternalIntegration` to look up the row to update. */
export type EmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationCompanyIdFkeyUsingIntegrationEmployeeUniqueUpdate = {
  employeeId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employeeExternalIntegration` being updated. */
  patch: UpdateEmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationCompanyIdFkeyPatch;
};

/** The fields on `employeeExternalIntegration` to look up the row to update. */
export type EmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationEmployeeIdForeignUsingEmployeeExternalIntegrationSameSystemUniqueUpdate = {
  /** An object where the defined keys will be set on the `employeeExternalIntegration` being updated. */
  patch: UpdateEmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationEmployeeIdForeignPatch;
  sameSystem: Scalars['String'];
};

/** The fields on `employeeExternalIntegration` to look up the row to update. */
export type EmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationEmployeeIdForeignUsingIntegrationEmployeeUniqueUpdate = {
  employeeId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employeeExternalIntegration` being updated. */
  patch: UpdateEmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationEmployeeIdForeignPatch;
};

/** The fields on `employeeExternalIntegration` to look up the row to update. */
export type EmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationExternalIntegrationIdForeignUsingEmployeeExternalIntegrationSameSystemUniqueUpdate = {
  /** An object where the defined keys will be set on the `employeeExternalIntegration` being updated. */
  patch: UpdateEmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationExternalIntegrationIdForeignPatch;
  sameSystem: Scalars['String'];
};

/** The fields on `employeeExternalIntegration` to look up the row to update. */
export type EmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationExternalIntegrationIdForeignUsingIntegrationEmployeeUniqueUpdate = {
  employeeId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employeeExternalIntegration` being updated. */
  patch: UpdateEmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationExternalIntegrationIdForeignPatch;
};

/** Represents an update to a `EmployeeExternalIntegration`. Fields that are set will be updated. */
export type EmployeeExternalIntegrationPatch = {
  company?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  externalEmployeeId?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInput>;
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  sameSystem?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `EmployeeExternalIntegration` values. */
export type EmployeeExternalIntegrationsConnection = {
  __typename?: 'EmployeeExternalIntegrationsConnection';
  /** A list of edges which contains the `EmployeeExternalIntegration` and cursor to aid in pagination. */
  edges: Array<EmployeeExternalIntegrationsEdge>;
  /** A list of `EmployeeExternalIntegration` objects. */
  nodes: Array<Maybe<EmployeeExternalIntegration>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EmployeeExternalIntegration` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EmployeeExternalIntegration` edge in the connection. */
export type EmployeeExternalIntegrationsEdge = {
  __typename?: 'EmployeeExternalIntegrationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EmployeeExternalIntegration` at the end of the edge. */
  node?: Maybe<EmployeeExternalIntegration>;
};

/** Methods to use when ordering `EmployeeExternalIntegration`. */
export type EmployeeExternalIntegrationsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'EXTERNAL_EMPLOYEE_ID_ASC'
  | 'EXTERNAL_EMPLOYEE_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__ABSENCE_MAPPINGS_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__ABSENCE_MAPPINGS_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__ABSENCE_SYNC_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__ABSENCE_SYNC_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__ACTIVE_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__ACTIVE_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__AUTH_APP_ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__AUTH_APP_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__BLACKLISTED_FIELDS_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__BLACKLISTED_FIELDS_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__COMPANY_ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__COMPANY_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__CONFIG_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__CONFIG_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__CONTINUOUS_SYNC_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__CONTINUOUS_SYNC_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__CREATED_AT_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__CREATED_AT_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__CREDENTIALS_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__CREDENTIALS_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__DEPARTMENT_ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__DEPARTMENT_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__DEPARTMENT_INHERITANCE_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__DEPARTMENT_INHERITANCE_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__EXTERNAL_ADDITIONAL_ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__EXTERNAL_ADDITIONAL_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__EXTERNAL_COMPANY_ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__EXTERNAL_COMPANY_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__FIELD_MAPPINGS_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__FIELD_MAPPINGS_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__INTEGRABLE_SYSTEM_ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__INTEGRABLE_SYSTEM_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__PAYSLIP_DOCUMENT_BLUEPRINT_FOLDER_ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__PAYSLIP_DOCUMENT_BLUEPRINT_FOLDER_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__PAYSLIP_DOCUMENT_TYPE_ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__PAYSLIP_DOCUMENT_TYPE_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__SYSTEM_ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__SYSTEM_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__TITLE_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__TITLE_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__WHITELISTED_FIELDS_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__WHITELISTED_FIELDS_DESC'
  | 'EXTERNAL_INTEGRATION_ID_ASC'
  | 'EXTERNAL_INTEGRATION_ID_DESC'
  | 'NATURAL'
  | 'SAME_SYSTEM_ASC'
  | 'SAME_SYSTEM_DESC';

/** A filter to be used against `Employee` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EmployeeFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `competenceIds` field. */
  competenceIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `contractSignPendings` relation. */
  contractSignPendings?: InputMaybe<EmployeeToManyContractSignPendingFilter>;
  /** Some related `contractSignPendings` exist. */
  contractSignPendingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `employeeCasefiles` relation. */
  employeeCasefiles?: InputMaybe<EmployeeToManyEmployeeCasefileFilter>;
  /** Some related `employeeCasefiles` exist. */
  employeeCasefilesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `employeeExternalIntegrations` relation. */
  employeeExternalIntegrations?: InputMaybe<EmployeeToManyEmployeeExternalIntegrationFilter>;
  /** Some related `employeeExternalIntegrations` exist. */
  employeeExternalIntegrationsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `equipments` relation. */
  equipments?: InputMaybe<EmployeeToManyEquipmentFilter>;
  /** Some related `equipments` exist. */
  equipmentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFieldEntries` relation. */
  formFieldEntries?: InputMaybe<EmployeeToManyFormFieldEntryFilter>;
  /** Some related `formFieldEntries` exist. */
  formFieldEntriesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `groupIds` field. */
  groupIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isArchived` field. */
  isArchived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isLeader` field. */
  isLeader?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isSystemUser` field. */
  isSystemUser?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `jobPositionDescription` field. */
  jobPositionDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `jobPositionTitle` field. */
  jobPositionTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `jobPositionType` field. */
  jobPositionType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `jobPositionWorkingHours` field. */
  jobPositionWorkingHours?: InputMaybe<StringFilter>;
  /** Filter by the object’s `latestMessagesByEmployeeId1` relation. */
  latestMessagesByEmployeeId1?: InputMaybe<EmployeeToManyLatestMessageFilter>;
  /** Some related `latestMessagesByEmployeeId1` exist. */
  latestMessagesByEmployeeId1Exist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `latestMessagesByEmployeeId2` relation. */
  latestMessagesByEmployeeId2?: InputMaybe<EmployeeToManyLatestMessageFilter>;
  /** Some related `latestMessagesByEmployeeId2` exist. */
  latestMessagesByEmployeeId2Exist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `leaderDepartments` field. */
  leaderDepartments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `logo` field. */
  logo?: InputMaybe<StringFilter>;
  /** Filter by the object’s `messageRecipients` relation. */
  messageRecipients?: InputMaybe<EmployeeToManyMessageRecipientFilter>;
  /** Some related `messageRecipients` exist. */
  messageRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `messagesByFromEmployeeId` relation. */
  messagesByFromEmployeeId?: InputMaybe<EmployeeToManyMessageFilter>;
  /** Some related `messagesByFromEmployeeId` exist. */
  messagesByFromEmployeeIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `messagesByToEmployeeId` relation. */
  messagesByToEmployeeId?: InputMaybe<EmployeeToManyMessageFilter>;
  /** Some related `messagesByToEmployeeId` exist. */
  messagesByToEmployeeIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Negates the expression. */
  not?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `notificationCustomRecipients` relation. */
  notificationCustomRecipients?: InputMaybe<EmployeeToManyNotificationCustomRecipientFilter>;
  /** Some related `notificationCustomRecipients` exist. */
  notificationCustomRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `notificationEmployeeReferences` relation. */
  notificationEmployeeReferences?: InputMaybe<EmployeeToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferences` exist. */
  notificationEmployeeReferencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `notificationEmployees` relation. */
  notificationEmployees?: InputMaybe<EmployeeToManyNotificationEmployeeFilter>;
  /** Filter by the object’s `notificationEmployeesByRecipientId` relation. */
  notificationEmployeesByRecipientId?: InputMaybe<EmployeeToManyNotificationEmployeeFilter>;
  /** Some related `notificationEmployeesByRecipientId` exist. */
  notificationEmployeesByRecipientIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `notificationEmployeesBySenderId` relation. */
  notificationEmployeesBySenderId?: InputMaybe<EmployeeToManyNotificationEmployeeFilter>;
  /** Some related `notificationEmployeesBySenderId` exist. */
  notificationEmployeesBySenderIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `notificationEmployees` exist. */
  notificationEmployeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EmployeeFilter>>;
  /** Filter by the object’s `preboardingComments` relation. */
  preboardingComments?: InputMaybe<EmployeeToManyPreboardingCommentFilter>;
  /** Some related `preboardingComments` exist. */
  preboardingCommentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingEmailLogsByFromEmployeeId` relation. */
  preboardingEmailLogsByFromEmployeeId?: InputMaybe<EmployeeToManyPreboardingEmailLogFilter>;
  /** Some related `preboardingEmailLogsByFromEmployeeId` exist. */
  preboardingEmailLogsByFromEmployeeIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingEmployees` relation. */
  preboardingEmployees?: InputMaybe<EmployeeToManyPreboardingEmployeeFilter>;
  /** Some related `preboardingEmployees` exist. */
  preboardingEmployeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingProcesses` relation. */
  preboardingProcesses?: InputMaybe<EmployeeToManyPreboardingProcessFilter>;
  /** Some related `preboardingProcesses` exist. */
  preboardingProcessesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingResultSlideComments` relation. */
  preboardingResultSlideComments?: InputMaybe<EmployeeToManyPreboardingResultSlideCommentFilter>;
  /** Some related `preboardingResultSlideComments` exist. */
  preboardingResultSlideCommentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingResults` relation. */
  preboardingResults?: InputMaybe<EmployeeToManyPreboardingResultFilter>;
  /** Some related `preboardingResults` exist. */
  preboardingResultsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardings` relation. */
  preboardings?: InputMaybe<EmployeeToManyPreboardingFilter>;
  /** Some related `preboardings` exist. */
  preboardingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processEmployees` relation. */
  processEmployees?: InputMaybe<EmployeeToManyProcessEmployeeFilter>;
  /** Some related `processEmployees` exist. */
  processEmployeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processResponsiblesByResponsibleId` relation. */
  processResponsiblesByResponsibleId?: InputMaybe<EmployeeToManyProcessResponsibleFilter>;
  /** Some related `processResponsiblesByResponsibleId` exist. */
  processResponsiblesByResponsibleIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processes` relation. */
  processes?: InputMaybe<EmployeeToManyProcessFilter>;
  /** Some related `processes` exist. */
  processesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projects` relation. */
  projects?: InputMaybe<EmployeeToManyProjectFilter>;
  /** Some related `projects` exist. */
  projectsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `savedSignatures` relation. */
  savedSignatures?: InputMaybe<EmployeeToManySavedSignatureFilter>;
  /** Some related `savedSignatures` exist. */
  savedSignaturesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scheduledMessageRecipients` relation. */
  scheduledMessageRecipients?: InputMaybe<EmployeeToManyScheduledMessageRecipientFilter>;
  /** Some related `scheduledMessageRecipients` exist. */
  scheduledMessageRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scheduledMessageTemplateRecipients` relation. */
  scheduledMessageTemplateRecipients?: InputMaybe<EmployeeToManyScheduledMessageTemplateRecipientFilter>;
  /** Some related `scheduledMessageTemplateRecipients` exist. */
  scheduledMessageTemplateRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scheduledMessages` relation. */
  scheduledMessages?: InputMaybe<EmployeeToManyScheduledMessageFilter>;
  /** Filter by the object’s `scheduledMessagesBySenderEmployeeId` relation. */
  scheduledMessagesBySenderEmployeeId?: InputMaybe<EmployeeToManyScheduledMessageFilter>;
  /** Some related `scheduledMessagesBySenderEmployeeId` exist. */
  scheduledMessagesBySenderEmployeeIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `scheduledMessages` exist. */
  scheduledMessagesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskEmployees` relation. */
  taskEmployees?: InputMaybe<EmployeeToManyTaskEmployeeFilter>;
  /** Some related `taskEmployees` exist. */
  taskEmployeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskResponsiblesByResponsibleId` relation. */
  taskResponsiblesByResponsibleId?: InputMaybe<EmployeeToManyTaskResponsibleFilter>;
  /** Some related `taskResponsiblesByResponsibleId` exist. */
  taskResponsiblesByResponsibleIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskTemplateEmployees` relation. */
  taskTemplateEmployees?: InputMaybe<EmployeeToManyTaskTemplateEmployeeFilter>;
  /** Some related `taskTemplateEmployees` exist. */
  taskTemplateEmployeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskTemplateResponsiblesByResponsibleId` relation. */
  taskTemplateResponsiblesByResponsibleId?: InputMaybe<EmployeeToManyTaskTemplateResponsibleFilter>;
  /** Some related `taskTemplateResponsiblesByResponsibleId` exist. */
  taskTemplateResponsiblesByResponsibleIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `unreadMessageThreadCount` field. */
  unreadMessageThreadCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `users` relation. */
  users?: InputMaybe<EmployeeToManyUserFilter>;
  /** Some related `users` exist. */
  usersExist?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `Employee` */
export type EmployeeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** All input for the `employeeLatestMessageTimestamp` mutation. */
export type EmployeeLatestMessageTimestampInput = {
  argEmployee?: InputMaybe<EmployeeInput>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `employeeLatestMessageTimestamp` mutation. */
export type EmployeeLatestMessageTimestampPayload = {
  __typename?: 'EmployeeLatestMessageTimestampPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  datetime?: Maybe<Scalars['Datetime']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnContractSignPendingForContractSignPendingEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnContractSignPendingForContractSignPendingEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnContractSignPendingForContractSignPendingEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnContractSignPendingForContractSignPendingEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnEmployeeCasefileForEmployeeCasefileEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnEmployeeCasefileForEmployeeCasefileEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnEmployeeCasefileForEmployeeCasefileEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnEmployeeCasefileForEmployeeCasefileEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnEmployeeExternalIntegrationForEmployeeExternalIntegrationEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnEmployeeExternalIntegrationForEmployeeExternalIntegrationEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnEmployeeExternalIntegrationForEmployeeExternalIntegrationEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnEmployeeExternalIntegrationForEmployeeExternalIntegrationEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnEmployeeForEmployeeCompanyIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnEmployeeForEmployeeCompanyIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnEmployeeForEmployeeCompanyIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnEmployeeForEmployeeCompanyIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnEmployeeForEmployeeUserIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnEmployeeForEmployeeUserIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnEmployeeForEmployeeUserIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnEmployeeForEmployeeUserIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnEquipmentForEquipmentEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnEquipmentForEquipmentEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnEquipmentForEquipmentEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnEquipmentForEquipmentEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnFormFieldEntryForFormFieldEntryEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnFormFieldEntryForFormFieldEntryEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnFormFieldEntryForFormFieldEntryEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnFormFieldEntryForFormFieldEntryEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnLatestMessageForLatestMessageEmployeeId2ForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnLatestMessageForLatestMessageEmployeeId2ForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnLatestMessageForLatestMessageEmployeeId2ForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnLatestMessageForLatestMessageEmployeeId2ForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnMessageForMessageToEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnMessageForMessageToEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnMessageForMessageToEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnMessageForMessageToEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnMessageRecipientForMessageRecipientEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnMessageRecipientForMessageRecipientEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnMessageRecipientForMessageRecipientEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnMessageRecipientForMessageRecipientEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnNotificationCustomRecipientForNotificationCustomRecipientEmployeeIdFkeyUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnNotificationCustomRecipientForNotificationCustomRecipientEmployeeIdFkeyPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnNotificationCustomRecipientForNotificationCustomRecipientEmployeeIdFkeyUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnNotificationCustomRecipientForNotificationCustomRecipientEmployeeIdFkeyPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnNotificationEmployeeForNotificationEmployeeEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnNotificationEmployeeForNotificationEmployeeEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnNotificationEmployeeForNotificationEmployeeEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnNotificationEmployeeForNotificationEmployeeEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnNotificationEmployeeReferenceForNotificationEmployeeReferenceEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnNotificationEmployeeReferenceForNotificationEmployeeReferenceEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnNotificationEmployeeReferenceForNotificationEmployeeReferenceEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnNotificationEmployeeReferenceForNotificationEmployeeReferenceEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnPreboardingCommentForPreboardingCommentEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnPreboardingCommentForPreboardingCommentEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnPreboardingCommentForPreboardingCommentEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnPreboardingCommentForPreboardingCommentEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnPreboardingEmailLogForPreboardingEmailLogFromEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnPreboardingEmailLogForPreboardingEmailLogFromEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnPreboardingEmailLogForPreboardingEmailLogFromEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnPreboardingEmailLogForPreboardingEmailLogFromEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnPreboardingEmployeeForPreboardingEmployeeEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnPreboardingEmployeeForPreboardingEmployeeEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnPreboardingEmployeeForPreboardingEmployeeEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnPreboardingEmployeeForPreboardingEmployeeEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnPreboardingForPreboardingEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnPreboardingForPreboardingEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnPreboardingForPreboardingEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnPreboardingForPreboardingEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnPreboardingProcessForPreboardingProcessEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnPreboardingProcessForPreboardingProcessEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnPreboardingProcessForPreboardingProcessEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnPreboardingProcessForPreboardingProcessEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnPreboardingResultForPreboardingResultEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnPreboardingResultForPreboardingResultEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnPreboardingResultForPreboardingResultEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnPreboardingResultForPreboardingResultEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnProcessEmployeeForProcessEmployeeEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnProcessEmployeeForProcessEmployeeEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnProcessEmployeeForProcessEmployeeEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnProcessEmployeeForProcessEmployeeEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnProcessForProcessEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnProcessForProcessEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnProcessForProcessEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnProcessForProcessEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnProcessResponsibleForProcessResponsibleResponsibleIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnProcessResponsibleForProcessResponsibleResponsibleIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnProcessResponsibleForProcessResponsibleResponsibleIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnProcessResponsibleForProcessResponsibleResponsibleIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnProjectForProjectEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnProjectForProjectEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnProjectForProjectEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnProjectForProjectEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnSavedSignatureForSavedSignatureEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnSavedSignatureForSavedSignatureEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnSavedSignatureForSavedSignatureEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnSavedSignatureForSavedSignatureEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnScheduledMessageForScheduledMessageEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnScheduledMessageForScheduledMessageEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnScheduledMessageForScheduledMessageEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnScheduledMessageForScheduledMessageEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnScheduledMessageRecipientForScheduledMessageRecipientEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnScheduledMessageRecipientForScheduledMessageRecipientEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnScheduledMessageRecipientForScheduledMessageRecipientEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnScheduledMessageRecipientForScheduledMessageRecipientEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnTaskEmployeeForTaskEmployeeEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnTaskEmployeeForTaskEmployeeEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnTaskEmployeeForTaskEmployeeEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnTaskEmployeeForTaskEmployeeEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnTaskResponsibleForTaskResponsibleResponsibleIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnTaskResponsibleForTaskResponsibleResponsibleIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnTaskResponsibleForTaskResponsibleResponsibleIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnTaskResponsibleForTaskResponsibleResponsibleIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeEmployeeIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeEmployeeIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeEmployeeIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnTaskTemplateResponsibleForTaskTemplateResponsibleResponsibleIdForeignUsingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnTaskTemplateResponsibleForTaskTemplateResponsibleResponsibleIdForeignPatch;
};

/** The fields on `employee` to look up the row to update. */
export type EmployeeOnTaskTemplateResponsibleForTaskTemplateResponsibleResponsibleIdForeignUsingEmployeeUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `employee` being updated. */
  patch: UpdateEmployeeOnTaskTemplateResponsibleForTaskTemplateResponsibleResponsibleIdForeignPatch;
  userId: Scalars['UUID'];
};

/** Represents an update to a `Employee`. Fields that are set will be updated. */
export type EmployeePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** A filter to be used against many `ContractSignPending` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyContractSignPendingFilter = {
  /** Every related `ContractSignPending` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractSignPendingFilter>;
  /** No related `ContractSignPending` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractSignPendingFilter>;
  /** Some related `ContractSignPending` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractSignPendingFilter>;
};

/** A filter to be used against many `EmployeeCasefile` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyEmployeeCasefileFilter = {
  /** Every related `EmployeeCasefile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmployeeCasefileFilter>;
  /** No related `EmployeeCasefile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmployeeCasefileFilter>;
  /** Some related `EmployeeCasefile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmployeeCasefileFilter>;
};

/** A filter to be used against many `EmployeeExternalIntegration` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyEmployeeExternalIntegrationFilter = {
  /** Every related `EmployeeExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmployeeExternalIntegrationFilter>;
  /** No related `EmployeeExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmployeeExternalIntegrationFilter>;
  /** Some related `EmployeeExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmployeeExternalIntegrationFilter>;
};

/** A filter to be used against many `Equipment` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyEquipmentFilter = {
  /** Every related `Equipment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EquipmentFilter>;
  /** No related `Equipment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EquipmentFilter>;
  /** Some related `Equipment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EquipmentFilter>;
};

/** A filter to be used against many `FormFieldEntry` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyFormFieldEntryFilter = {
  /** Every related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FormFieldEntryFilter>;
  /** No related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FormFieldEntryFilter>;
  /** Some related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FormFieldEntryFilter>;
};

/** A filter to be used against many `LatestMessage` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyLatestMessageFilter = {
  /** Every related `LatestMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LatestMessageFilter>;
  /** No related `LatestMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LatestMessageFilter>;
  /** Some related `LatestMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LatestMessageFilter>;
};

/** A filter to be used against many `Message` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyMessageFilter = {
  /** Every related `Message` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MessageFilter>;
  /** No related `Message` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MessageFilter>;
  /** Some related `Message` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MessageFilter>;
};

/** A filter to be used against many `MessageRecipient` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyMessageRecipientFilter = {
  /** Every related `MessageRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MessageRecipientFilter>;
  /** No related `MessageRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MessageRecipientFilter>;
  /** Some related `MessageRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MessageRecipientFilter>;
};

/** A filter to be used against many `NotificationCustomRecipient` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyNotificationCustomRecipientFilter = {
  /** Every related `NotificationCustomRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationCustomRecipientFilter>;
  /** No related `NotificationCustomRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationCustomRecipientFilter>;
  /** Some related `NotificationCustomRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationCustomRecipientFilter>;
};

/** A filter to be used against many `NotificationEmployee` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyNotificationEmployeeFilter = {
  /** Every related `NotificationEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeFilter>;
  /** No related `NotificationEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeFilter>;
  /** Some related `NotificationEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeFilter>;
};

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

/** A filter to be used against many `PreboardingComment` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyPreboardingCommentFilter = {
  /** Every related `PreboardingComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingCommentFilter>;
  /** No related `PreboardingComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingCommentFilter>;
  /** Some related `PreboardingComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingCommentFilter>;
};

/** A filter to be used against many `PreboardingEmailLog` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyPreboardingEmailLogFilter = {
  /** Every related `PreboardingEmailLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingEmailLogFilter>;
  /** No related `PreboardingEmailLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingEmailLogFilter>;
  /** Some related `PreboardingEmailLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingEmailLogFilter>;
};

/** A filter to be used against many `PreboardingEmployee` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyPreboardingEmployeeFilter = {
  /** Every related `PreboardingEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingEmployeeFilter>;
  /** No related `PreboardingEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingEmployeeFilter>;
  /** Some related `PreboardingEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingEmployeeFilter>;
};

/** A filter to be used against many `Preboarding` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyPreboardingFilter = {
  /** Every related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingFilter>;
  /** No related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingFilter>;
  /** Some related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingFilter>;
};

/** A filter to be used against many `PreboardingProcess` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyPreboardingProcessFilter = {
  /** Every related `PreboardingProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingProcessFilter>;
  /** No related `PreboardingProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingProcessFilter>;
  /** Some related `PreboardingProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingProcessFilter>;
};

/** A filter to be used against many `PreboardingResult` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyPreboardingResultFilter = {
  /** Every related `PreboardingResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingResultFilter>;
  /** No related `PreboardingResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingResultFilter>;
  /** Some related `PreboardingResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingResultFilter>;
};

/** A filter to be used against many `PreboardingResultSlideComment` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyPreboardingResultSlideCommentFilter = {
  /** Every related `PreboardingResultSlideComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingResultSlideCommentFilter>;
  /** No related `PreboardingResultSlideComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingResultSlideCommentFilter>;
  /** Some related `PreboardingResultSlideComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingResultSlideCommentFilter>;
};

/** A filter to be used against many `ProcessEmployee` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyProcessEmployeeFilter = {
  /** Every related `ProcessEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProcessEmployeeFilter>;
  /** No related `ProcessEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProcessEmployeeFilter>;
  /** Some related `ProcessEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProcessEmployeeFilter>;
};

/** A filter to be used against many `Process` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyProcessFilter = {
  /** Every related `Process` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProcessFilter>;
  /** No related `Process` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProcessFilter>;
  /** Some related `Process` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProcessFilter>;
};

/** A filter to be used against many `ProcessResponsible` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyProcessResponsibleFilter = {
  /** Every related `ProcessResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProcessResponsibleFilter>;
  /** No related `ProcessResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProcessResponsibleFilter>;
  /** Some related `ProcessResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProcessResponsibleFilter>;
};

/** A filter to be used against many `Project` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyProjectFilter = {
  /** Every related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectFilter>;
  /** No related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectFilter>;
  /** Some related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectFilter>;
};

/** A filter to be used against many `SavedSignature` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManySavedSignatureFilter = {
  /** Every related `SavedSignature` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SavedSignatureFilter>;
  /** No related `SavedSignature` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SavedSignatureFilter>;
  /** Some related `SavedSignature` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SavedSignatureFilter>;
};

/** A filter to be used against many `ScheduledMessage` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyScheduledMessageFilter = {
  /** Every related `ScheduledMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageFilter>;
  /** No related `ScheduledMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageFilter>;
  /** Some related `ScheduledMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageFilter>;
};

/** A filter to be used against many `ScheduledMessageRecipient` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyScheduledMessageRecipientFilter = {
  /** Every related `ScheduledMessageRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageRecipientFilter>;
  /** No related `ScheduledMessageRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageRecipientFilter>;
  /** Some related `ScheduledMessageRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageRecipientFilter>;
};

/** A filter to be used against many `ScheduledMessageTemplateRecipient` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyScheduledMessageTemplateRecipientFilter = {
  /** Every related `ScheduledMessageTemplateRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageTemplateRecipientFilter>;
  /** No related `ScheduledMessageTemplateRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageTemplateRecipientFilter>;
  /** Some related `ScheduledMessageTemplateRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageTemplateRecipientFilter>;
};

/** A filter to be used against many `TaskEmployee` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyTaskEmployeeFilter = {
  /** Every related `TaskEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskEmployeeFilter>;
  /** No related `TaskEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskEmployeeFilter>;
  /** Some related `TaskEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskEmployeeFilter>;
};

/** A filter to be used against many `TaskResponsible` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyTaskResponsibleFilter = {
  /** Every related `TaskResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskResponsibleFilter>;
  /** No related `TaskResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskResponsibleFilter>;
  /** Some related `TaskResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskResponsibleFilter>;
};

/** A filter to be used against many `TaskTemplateEmployee` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyTaskTemplateEmployeeFilter = {
  /** Every related `TaskTemplateEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskTemplateEmployeeFilter>;
  /** No related `TaskTemplateEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskTemplateEmployeeFilter>;
  /** Some related `TaskTemplateEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskTemplateEmployeeFilter>;
};

/** A filter to be used against many `TaskTemplateResponsible` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyTaskTemplateResponsibleFilter = {
  /** Every related `TaskTemplateResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskTemplateResponsibleFilter>;
  /** No related `TaskTemplateResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskTemplateResponsibleFilter>;
  /** Some related `TaskTemplateResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskTemplateResponsibleFilter>;
};

/** A filter to be used against many `User` object types. All fields are combined with a logical ‘and.’ */
export type EmployeeToManyUserFilter = {
  /** Every related `User` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserFilter>;
  /** No related `User` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserFilter>;
  /** Some related `User` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserFilter>;
};

/** Input for the nested mutation of `user` in the `EmployeeInput` mutation. */
export type EmployeeUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnEmployeeForEmployeeUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `employee` in the `UserInput` mutation. */
export type EmployeeUserIdForeignInverseInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnEmployeeForEmployeeUserIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnEmployeeForEmployeeUserIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** A connection to a list of `Employee` values. */
export type EmployeesConnection = {
  __typename?: 'EmployeesConnection';
  /** A list of edges which contains the `Employee` and cursor to aid in pagination. */
  edges: Array<EmployeesEdge>;
  /** A list of `Employee` objects. */
  nodes: Array<Maybe<Employee>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Employee` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Employee` edge in the connection. */
export type EmployeesEdge = {
  __typename?: 'EmployeesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Employee` at the end of the edge. */
  node?: Maybe<Employee>;
};

/** Methods to use when ordering `Employee`. */
export type EmployeesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CONTRACT_SIGN_PENDINGS_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'CONTRACT_SIGN_PENDINGS_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EMPLOYEE_CASEFILES_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'EMPLOYEE_CASEFILES_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'EMPLOYEE_EXTERNAL_INTEGRATIONS_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'EMPLOYEE_EXTERNAL_INTEGRATIONS_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'EQUIPMENT_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'EQUIPMENT_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'FORM_FIELD_ENTRIES_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'FORM_FIELD_ENTRIES_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'GROUP_IDS_ASC'
  | 'GROUP_IDS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IS_ARCHIVED_ASC'
  | 'IS_ARCHIVED_DESC'
  | 'IS_LEADER_ASC'
  | 'IS_LEADER_DESC'
  | 'IS_SYSTEM_USER_ASC'
  | 'IS_SYSTEM_USER_DESC'
  | 'LATEST_MESSAGES_BY_EMPLOYEE_ID_1__COUNT_ASC'
  | 'LATEST_MESSAGES_BY_EMPLOYEE_ID_1__COUNT_DESC'
  | 'LATEST_MESSAGES_BY_EMPLOYEE_ID_2__COUNT_ASC'
  | 'LATEST_MESSAGES_BY_EMPLOYEE_ID_2__COUNT_DESC'
  | 'LEADER_DEPARTMENTS_ASC'
  | 'LEADER_DEPARTMENTS_DESC'
  | 'MESSAGES_BY_FROM_EMPLOYEE_ID__COUNT_ASC'
  | 'MESSAGES_BY_FROM_EMPLOYEE_ID__COUNT_DESC'
  | 'MESSAGES_BY_TO_EMPLOYEE_ID__COUNT_ASC'
  | 'MESSAGES_BY_TO_EMPLOYEE_ID__COUNT_DESC'
  | 'MESSAGE_RECIPIENTS_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'MESSAGE_RECIPIENTS_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_CUSTOM_RECIPIENTS_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'NOTIFICATION_CUSTOM_RECIPIENTS_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'NOTIFICATION_EMPLOYEES_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEES_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'NOTIFICATION_EMPLOYEES_BY_RECIPIENT_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEES_BY_RECIPIENT_ID__COUNT_DESC'
  | 'NOTIFICATION_EMPLOYEES_BY_SENDER_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEES_BY_SENDER_ID__COUNT_DESC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'PREBOARDINGS_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'PREBOARDINGS_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'PREBOARDING_COMMENTS_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'PREBOARDING_COMMENTS_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'PREBOARDING_EMAIL_LOGS_BY_FROM_EMPLOYEE_ID__COUNT_ASC'
  | 'PREBOARDING_EMAIL_LOGS_BY_FROM_EMPLOYEE_ID__COUNT_DESC'
  | 'PREBOARDING_EMPLOYEES_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'PREBOARDING_EMPLOYEES_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'PREBOARDING_PROCESSES_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'PREBOARDING_PROCESSES_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'PREBOARDING_RESULTS_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'PREBOARDING_RESULTS_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'PREBOARDING_RESULT_SLIDE_COMMENTS_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'PREBOARDING_RESULT_SLIDE_COMMENTS_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESSES_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'PROCESSES_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'PROCESS_EMPLOYEES_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'PROCESS_EMPLOYEES_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'PROCESS_RESPONSIBLES_BY_RESPONSIBLE_ID__COUNT_ASC'
  | 'PROCESS_RESPONSIBLES_BY_RESPONSIBLE_ID__COUNT_DESC'
  | 'PROJECTS_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'PROJECTS_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'SAVED_SIGNATURES_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'SAVED_SIGNATURES_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGES_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGES_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGES_BY_SENDER_EMPLOYEE_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGES_BY_SENDER_EMPLOYEE_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGE_RECIPIENTS_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGE_RECIPIENTS_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_RECIPIENTS_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_RECIPIENTS_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'TASK_EMPLOYEES_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'TASK_EMPLOYEES_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'TASK_RESPONSIBLES_BY_RESPONSIBLE_ID__COUNT_ASC'
  | 'TASK_RESPONSIBLES_BY_RESPONSIBLE_ID__COUNT_DESC'
  | 'TASK_TEMPLATE_EMPLOYEES_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'TASK_TEMPLATE_EMPLOYEES_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'TASK_TEMPLATE_RESPONSIBLES_BY_RESPONSIBLE_ID__COUNT_ASC'
  | 'TASK_TEMPLATE_RESPONSIBLES_BY_RESPONSIBLE_ID__COUNT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'USERS_BY_EMPLOYEE_ID__COUNT_ASC'
  | 'USERS_BY_EMPLOYEE_ID__COUNT_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type EndBreakInput = {
  resumeTimeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
};

export type EngagementType = {
  __typename?: 'EngagementType';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `EngagementType`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `FormFieldOption`. */
  formFieldOptions: FormFieldOptionsConnection;
  /** Reads and enables pagination through a set of `FormField`. */
  formFields: FormFieldsConnection;
  id: Scalars['UUID'];
  localizedName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `PreboardingComment`. */
  preboardingComments: PreboardingCommentsConnection;
  /** Reads and enables pagination through a set of `PreboardingEmailLog`. */
  preboardingEmailLogs: PreboardingEmailLogsConnection;
  /** Reads and enables pagination through a set of `PreboardingEmployee`. */
  preboardingEmployees: PreboardingEmployeesConnection;
  /** Reads and enables pagination through a set of `PreboardingProcess`. */
  preboardingProcesses: PreboardingProcessesConnection;
  /** Reads and enables pagination through a set of `PreboardingResultSlideComment`. */
  preboardingResultSlideComments: PreboardingResultSlideCommentsConnection;
  /** Reads and enables pagination through a set of `PreboardingResult`. */
  preboardingResults: PreboardingResultsConnection;
  /** Reads and enables pagination through a set of `PreboardingSlideFormField`. */
  preboardingSlideFormFields: PreboardingSlideFormFieldsConnection;
  /** Reads and enables pagination through a set of `PreboardingSlide`. */
  preboardingSlides: PreboardingSlidesConnection;
  /** Reads and enables pagination through a set of `Preboarding`. */
  preboardings: PreboardingsConnection;
  updatedAt: Scalars['Datetime'];
};


export type EngagementTypeFormFieldOptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldOptionCondition>;
  filter?: InputMaybe<FormFieldOptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldOptionsOrderBy>>;
};


export type EngagementTypeFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldCondition>;
  filter?: InputMaybe<FormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldsOrderBy>>;
};


export type EngagementTypePreboardingCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingCommentCondition>;
  filter?: InputMaybe<PreboardingCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingCommentsOrderBy>>;
};


export type EngagementTypePreboardingEmailLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingEmailLogCondition>;
  filter?: InputMaybe<PreboardingEmailLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingEmailLogsOrderBy>>;
};


export type EngagementTypePreboardingEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingEmployeeCondition>;
  filter?: InputMaybe<PreboardingEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingEmployeesOrderBy>>;
};


export type EngagementTypePreboardingProcessesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingProcessCondition>;
  filter?: InputMaybe<PreboardingProcessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingProcessesOrderBy>>;
};


export type EngagementTypePreboardingResultSlideCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingResultSlideCommentCondition>;
  filter?: InputMaybe<PreboardingResultSlideCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingResultSlideCommentsOrderBy>>;
};


export type EngagementTypePreboardingResultsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingResultCondition>;
  filter?: InputMaybe<PreboardingResultFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingResultsOrderBy>>;
};


export type EngagementTypePreboardingSlideFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingSlideFormFieldCondition>;
  filter?: InputMaybe<PreboardingSlideFormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingSlideFormFieldsOrderBy>>;
};


export type EngagementTypePreboardingSlidesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingSlideCondition>;
  filter?: InputMaybe<PreboardingSlideFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingSlidesOrderBy>>;
};


export type EngagementTypePreboardingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingCondition>;
  filter?: InputMaybe<PreboardingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingsOrderBy>>;
};

/** The `engagementType` to be created by this mutation. */
export type EngagementTypeCompanyIdForeignConnectionEngagementTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `company` in the `EngagementTypeInput` mutation. */
export type EngagementTypeCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnEngagementTypeForEngagementTypeCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `engagementType` in the `CompanyInput` mutation. */
export type EngagementTypeCompanyIdForeignInverseInput = {
  /** The primary key(s) for `engagementType` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EngagementTypeEngagementTypePkeyConnect>>;
  /** A `EngagementTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EngagementTypeCompanyIdForeignConnectionEngagementTypeCreateInput>>;
  /** The primary key(s) and patch data for `engagementType` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EngagementTypeOnEngagementTypeForEngagementTypeCompanyIdForeignUsingEngagementTypePkeyUpdate>>;
};

/**
 * A condition to be used against `EngagementType` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EngagementTypeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `engagementType` to look up the row to connect. */
export type EngagementTypeEngagementTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against `EngagementType` object types. All fields are combined with a logical ‘and.’ */
export type EngagementTypeFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EngagementTypeFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `formFieldOptions` relation. */
  formFieldOptions?: InputMaybe<EngagementTypeToManyFormFieldOptionFilter>;
  /** Some related `formFieldOptions` exist. */
  formFieldOptionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFields` relation. */
  formFields?: InputMaybe<EngagementTypeToManyFormFieldFilter>;
  /** Some related `formFields` exist. */
  formFieldsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EngagementTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EngagementTypeFilter>>;
  /** Filter by the object’s `preboardingComments` relation. */
  preboardingComments?: InputMaybe<EngagementTypeToManyPreboardingCommentFilter>;
  /** Some related `preboardingComments` exist. */
  preboardingCommentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingEmailLogs` relation. */
  preboardingEmailLogs?: InputMaybe<EngagementTypeToManyPreboardingEmailLogFilter>;
  /** Some related `preboardingEmailLogs` exist. */
  preboardingEmailLogsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingEmployees` relation. */
  preboardingEmployees?: InputMaybe<EngagementTypeToManyPreboardingEmployeeFilter>;
  /** Some related `preboardingEmployees` exist. */
  preboardingEmployeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingProcesses` relation. */
  preboardingProcesses?: InputMaybe<EngagementTypeToManyPreboardingProcessFilter>;
  /** Some related `preboardingProcesses` exist. */
  preboardingProcessesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingResultSlideComments` relation. */
  preboardingResultSlideComments?: InputMaybe<EngagementTypeToManyPreboardingResultSlideCommentFilter>;
  /** Some related `preboardingResultSlideComments` exist. */
  preboardingResultSlideCommentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingResults` relation. */
  preboardingResults?: InputMaybe<EngagementTypeToManyPreboardingResultFilter>;
  /** Some related `preboardingResults` exist. */
  preboardingResultsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingSlideFormFields` relation. */
  preboardingSlideFormFields?: InputMaybe<EngagementTypeToManyPreboardingSlideFormFieldFilter>;
  /** Some related `preboardingSlideFormFields` exist. */
  preboardingSlideFormFieldsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingSlides` relation. */
  preboardingSlides?: InputMaybe<EngagementTypeToManyPreboardingSlideFilter>;
  /** Some related `preboardingSlides` exist. */
  preboardingSlidesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardings` relation. */
  preboardings?: InputMaybe<EngagementTypeToManyPreboardingFilter>;
  /** Some related `preboardings` exist. */
  preboardingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `EngagementType` */
export type EngagementTypeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `engagementType` to look up the row to update. */
export type EngagementTypeOnEngagementTypeForEngagementTypeCompanyIdForeignUsingEngagementTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `engagementType` being updated. */
  patch: UpdateEngagementTypeOnEngagementTypeForEngagementTypeCompanyIdForeignPatch;
};

/** The fields on `engagementType` to look up the row to update. */
export type EngagementTypeOnFormFieldForFormFieldEngagementTypeIdForeignUsingEngagementTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `engagementType` being updated. */
  patch: UpdateEngagementTypeOnFormFieldForFormFieldEngagementTypeIdForeignPatch;
};

/** The fields on `engagementType` to look up the row to update. */
export type EngagementTypeOnFormFieldOptionForFormFieldOptionEngagementTypeIdForeignUsingEngagementTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `engagementType` being updated. */
  patch: UpdateEngagementTypeOnFormFieldOptionForFormFieldOptionEngagementTypeIdForeignPatch;
};

/** The fields on `engagementType` to look up the row to update. */
export type EngagementTypeOnPreboardingCommentForPreboardingCommentEngagementTypeIdForeignUsingEngagementTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `engagementType` being updated. */
  patch: UpdateEngagementTypeOnPreboardingCommentForPreboardingCommentEngagementTypeIdForeignPatch;
};

/** The fields on `engagementType` to look up the row to update. */
export type EngagementTypeOnPreboardingEmailLogForPreboardingEmailLogEngagementTypeIdForeignUsingEngagementTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `engagementType` being updated. */
  patch: UpdateEngagementTypeOnPreboardingEmailLogForPreboardingEmailLogEngagementTypeIdForeignPatch;
};

/** The fields on `engagementType` to look up the row to update. */
export type EngagementTypeOnPreboardingEmployeeForPreboardingEmployeeEngagementTypeIdForeignUsingEngagementTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `engagementType` being updated. */
  patch: UpdateEngagementTypeOnPreboardingEmployeeForPreboardingEmployeeEngagementTypeIdForeignPatch;
};

/** The fields on `engagementType` to look up the row to update. */
export type EngagementTypeOnPreboardingForPreboardingEngagementTypeIdForeignUsingEngagementTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `engagementType` being updated. */
  patch: UpdateEngagementTypeOnPreboardingForPreboardingEngagementTypeIdForeignPatch;
};

/** The fields on `engagementType` to look up the row to update. */
export type EngagementTypeOnPreboardingProcessForPreboardingProcessEngagementTypeIdForeignUsingEngagementTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `engagementType` being updated. */
  patch: UpdateEngagementTypeOnPreboardingProcessForPreboardingProcessEngagementTypeIdForeignPatch;
};

/** The fields on `engagementType` to look up the row to update. */
export type EngagementTypeOnPreboardingResultForPreboardingResultEngagementTypeIdForeignUsingEngagementTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `engagementType` being updated. */
  patch: UpdateEngagementTypeOnPreboardingResultForPreboardingResultEngagementTypeIdForeignPatch;
};

/** The fields on `engagementType` to look up the row to update. */
export type EngagementTypeOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEngagementTypeIdForeignUsingEngagementTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `engagementType` being updated. */
  patch: UpdateEngagementTypeOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEngagementTypeIdForeignPatch;
};

/** The fields on `engagementType` to look up the row to update. */
export type EngagementTypeOnPreboardingSlideForPreboardingSlideEngagementTypeIdForeignUsingEngagementTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `engagementType` being updated. */
  patch: UpdateEngagementTypeOnPreboardingSlideForPreboardingSlideEngagementTypeIdForeignPatch;
};

/** The fields on `engagementType` to look up the row to update. */
export type EngagementTypeOnPreboardingSlideFormFieldForPreboardingSlideFormFieldEngagementTypeIdForeignUsingEngagementTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `engagementType` being updated. */
  patch: UpdateEngagementTypeOnPreboardingSlideFormFieldForPreboardingSlideFormFieldEngagementTypeIdForeignPatch;
};

/** Represents an update to a `EngagementType`. Fields that are set will be updated. */
export type EngagementTypePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against many `FormField` object types. All fields are combined with a logical ‘and.’ */
export type EngagementTypeToManyFormFieldFilter = {
  /** Every related `FormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FormFieldFilter>;
  /** No related `FormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FormFieldFilter>;
  /** Some related `FormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FormFieldFilter>;
};

/** A filter to be used against many `FormFieldOption` object types. All fields are combined with a logical ‘and.’ */
export type EngagementTypeToManyFormFieldOptionFilter = {
  /** Every related `FormFieldOption` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FormFieldOptionFilter>;
  /** No related `FormFieldOption` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FormFieldOptionFilter>;
  /** Some related `FormFieldOption` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FormFieldOptionFilter>;
};

/** A filter to be used against many `PreboardingComment` object types. All fields are combined with a logical ‘and.’ */
export type EngagementTypeToManyPreboardingCommentFilter = {
  /** Every related `PreboardingComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingCommentFilter>;
  /** No related `PreboardingComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingCommentFilter>;
  /** Some related `PreboardingComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingCommentFilter>;
};

/** A filter to be used against many `PreboardingEmailLog` object types. All fields are combined with a logical ‘and.’ */
export type EngagementTypeToManyPreboardingEmailLogFilter = {
  /** Every related `PreboardingEmailLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingEmailLogFilter>;
  /** No related `PreboardingEmailLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingEmailLogFilter>;
  /** Some related `PreboardingEmailLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingEmailLogFilter>;
};

/** A filter to be used against many `PreboardingEmployee` object types. All fields are combined with a logical ‘and.’ */
export type EngagementTypeToManyPreboardingEmployeeFilter = {
  /** Every related `PreboardingEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingEmployeeFilter>;
  /** No related `PreboardingEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingEmployeeFilter>;
  /** Some related `PreboardingEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingEmployeeFilter>;
};

/** A filter to be used against many `Preboarding` object types. All fields are combined with a logical ‘and.’ */
export type EngagementTypeToManyPreboardingFilter = {
  /** Every related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingFilter>;
  /** No related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingFilter>;
  /** Some related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingFilter>;
};

/** A filter to be used against many `PreboardingProcess` object types. All fields are combined with a logical ‘and.’ */
export type EngagementTypeToManyPreboardingProcessFilter = {
  /** Every related `PreboardingProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingProcessFilter>;
  /** No related `PreboardingProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingProcessFilter>;
  /** Some related `PreboardingProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingProcessFilter>;
};

/** A filter to be used against many `PreboardingResult` object types. All fields are combined with a logical ‘and.’ */
export type EngagementTypeToManyPreboardingResultFilter = {
  /** Every related `PreboardingResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingResultFilter>;
  /** No related `PreboardingResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingResultFilter>;
  /** Some related `PreboardingResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingResultFilter>;
};

/** A filter to be used against many `PreboardingResultSlideComment` object types. All fields are combined with a logical ‘and.’ */
export type EngagementTypeToManyPreboardingResultSlideCommentFilter = {
  /** Every related `PreboardingResultSlideComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingResultSlideCommentFilter>;
  /** No related `PreboardingResultSlideComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingResultSlideCommentFilter>;
  /** Some related `PreboardingResultSlideComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingResultSlideCommentFilter>;
};

/** A filter to be used against many `PreboardingSlide` object types. All fields are combined with a logical ‘and.’ */
export type EngagementTypeToManyPreboardingSlideFilter = {
  /** Every related `PreboardingSlide` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingSlideFilter>;
  /** No related `PreboardingSlide` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingSlideFilter>;
  /** Some related `PreboardingSlide` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingSlideFilter>;
};

/** A filter to be used against many `PreboardingSlideFormField` object types. All fields are combined with a logical ‘and.’ */
export type EngagementTypeToManyPreboardingSlideFormFieldFilter = {
  /** Every related `PreboardingSlideFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingSlideFormFieldFilter>;
  /** No related `PreboardingSlideFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingSlideFormFieldFilter>;
  /** Some related `PreboardingSlideFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingSlideFormFieldFilter>;
};

/** A connection to a list of `EngagementType` values. */
export type EngagementTypesConnection = {
  __typename?: 'EngagementTypesConnection';
  /** A list of edges which contains the `EngagementType` and cursor to aid in pagination. */
  edges: Array<EngagementTypesEdge>;
  /** A list of `EngagementType` objects. */
  nodes: Array<Maybe<EngagementType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EngagementType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EngagementType` edge in the connection. */
export type EngagementTypesEdge = {
  __typename?: 'EngagementTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EngagementType` at the end of the edge. */
  node?: Maybe<EngagementType>;
};

/** Methods to use when ordering `EngagementType`. */
export type EngagementTypesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'FORM_FIELDS_BY_ENGAGEMENT_TYPE_ID__COUNT_ASC'
  | 'FORM_FIELDS_BY_ENGAGEMENT_TYPE_ID__COUNT_DESC'
  | 'FORM_FIELD_OPTIONS_BY_ENGAGEMENT_TYPE_ID__COUNT_ASC'
  | 'FORM_FIELD_OPTIONS_BY_ENGAGEMENT_TYPE_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALIZED_NAME_ASC'
  | 'LOCALIZED_NAME_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PREBOARDINGS_BY_ENGAGEMENT_TYPE_ID__COUNT_ASC'
  | 'PREBOARDINGS_BY_ENGAGEMENT_TYPE_ID__COUNT_DESC'
  | 'PREBOARDING_COMMENTS_BY_ENGAGEMENT_TYPE_ID__COUNT_ASC'
  | 'PREBOARDING_COMMENTS_BY_ENGAGEMENT_TYPE_ID__COUNT_DESC'
  | 'PREBOARDING_EMAIL_LOGS_BY_ENGAGEMENT_TYPE_ID__COUNT_ASC'
  | 'PREBOARDING_EMAIL_LOGS_BY_ENGAGEMENT_TYPE_ID__COUNT_DESC'
  | 'PREBOARDING_EMPLOYEES_BY_ENGAGEMENT_TYPE_ID__COUNT_ASC'
  | 'PREBOARDING_EMPLOYEES_BY_ENGAGEMENT_TYPE_ID__COUNT_DESC'
  | 'PREBOARDING_PROCESSES_BY_ENGAGEMENT_TYPE_ID__COUNT_ASC'
  | 'PREBOARDING_PROCESSES_BY_ENGAGEMENT_TYPE_ID__COUNT_DESC'
  | 'PREBOARDING_RESULTS_BY_ENGAGEMENT_TYPE_ID__COUNT_ASC'
  | 'PREBOARDING_RESULTS_BY_ENGAGEMENT_TYPE_ID__COUNT_DESC'
  | 'PREBOARDING_RESULT_SLIDE_COMMENTS_BY_ENGAGEMENT_TYPE_ID__COUNT_ASC'
  | 'PREBOARDING_RESULT_SLIDE_COMMENTS_BY_ENGAGEMENT_TYPE_ID__COUNT_DESC'
  | 'PREBOARDING_SLIDES_BY_ENGAGEMENT_TYPE_ID__COUNT_ASC'
  | 'PREBOARDING_SLIDES_BY_ENGAGEMENT_TYPE_ID__COUNT_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELDS_BY_ENGAGEMENT_TYPE_ID__COUNT_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELDS_BY_ENGAGEMENT_TYPE_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

export type Equipment = {
  __typename?: 'Equipment';
  addedBy?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Equipment`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Employee` that is related to this `Equipment`. */
  employee?: Maybe<Employee>;
  employeeId: Scalars['UUID'];
  endDate?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** Reads a single `Product` that is related to this `Equipment`. */
  product?: Maybe<Product>;
  productId: Scalars['UUID'];
  /** Reads a single `ProductType` that is related to this `Equipment`. */
  productType?: Maybe<ProductType>;
  productTypeId?: Maybe<Scalars['UUID']>;
  removedBy?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Datetime']>;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `Equipment`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The `equipment` to be created by this mutation. */
export type EquipmentCompanyIdFkeyConnectionEquipmentCreateInput = {
  company?: InputMaybe<EquipmentCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EquipmentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<EquipmentProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<EquipmentProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EquipmentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `EquipmentInput` mutation. */
export type EquipmentCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnEquipmentForEquipmentCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `equipment` in the `CompanyInput` mutation. */
export type EquipmentCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `equipment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EquipmentEquipmentPkeyConnect>>;
  /** A `EquipmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EquipmentCompanyIdFkeyConnectionEquipmentCreateInput>>;
  /** The primary key(s) for `equipment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EquipmentEquipmentPkeyDelete>>;
  /** Flag indicating whether all other `equipment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `equipment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EquipmentOnEquipmentForEquipmentCompanyIdFkeyUsingEquipmentPkeyUpdate>>;
};

/**
 * A condition to be used against `Equipment` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type EquipmentCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `productTypeId` field. */
  productTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `Equipment` values. */
export type EquipmentConnection = {
  __typename?: 'EquipmentConnection';
  /** A list of edges which contains the `Equipment` and cursor to aid in pagination. */
  edges: Array<EquipmentEdge>;
  /** A list of `Equipment` objects. */
  nodes: Array<Maybe<Equipment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Equipment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Equipment` edge in the connection. */
export type EquipmentEdge = {
  __typename?: 'EquipmentEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Equipment` at the end of the edge. */
  node?: Maybe<Equipment>;
};

/** The `equipment` to be created by this mutation. */
export type EquipmentEmployeeIdForeignConnectionEquipmentCreateInput = {
  company?: InputMaybe<EquipmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EquipmentEmployeeIdForeignInput>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<EquipmentProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<EquipmentProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EquipmentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `employee` in the `EquipmentInput` mutation. */
export type EquipmentEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnEquipmentForEquipmentEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnEquipmentForEquipmentEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `equipment` in the `EmployeeInput` mutation. */
export type EquipmentEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `equipment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EquipmentEquipmentPkeyConnect>>;
  /** A `EquipmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EquipmentEmployeeIdForeignConnectionEquipmentCreateInput>>;
  /** The primary key(s) for `equipment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EquipmentEquipmentPkeyDelete>>;
  /** Flag indicating whether all other `equipment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `equipment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EquipmentOnEquipmentForEquipmentEmployeeIdForeignUsingEquipmentPkeyUpdate>>;
};

/** The fields on `equipment` to look up the row to connect. */
export type EquipmentEquipmentPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `equipment` to look up the row to delete. */
export type EquipmentEquipmentPkeyDelete = {
  id: Scalars['UUID'];
};

export type EquipmentFieldOrder = {
  formFieldId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `Equipment` object types. All fields are combined with a logical ‘and.’ */
export type EquipmentFilter = {
  /** Filter by the object’s `addedBy` field. */
  addedBy?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EquipmentFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EquipmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EquipmentFilter>>;
  /** Filter by the object’s `product` relation. */
  product?: InputMaybe<ProductFilter>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `productType` relation. */
  productType?: InputMaybe<ProductTypeFilter>;
  /** A related `productType` exists. */
  productTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `productTypeId` field. */
  productTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `removedBy` field. */
  removedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `Equipment` */
export type EquipmentInput = {
  company?: InputMaybe<EquipmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EquipmentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<EquipmentProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<EquipmentProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EquipmentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `equipment` to look up the row to update. */
export type EquipmentOnEquipmentForEquipmentCompanyIdFkeyUsingEquipmentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `equipment` being updated. */
  patch: UpdateEquipmentOnEquipmentForEquipmentCompanyIdFkeyPatch;
};

/** The fields on `equipment` to look up the row to update. */
export type EquipmentOnEquipmentForEquipmentEmployeeIdForeignUsingEquipmentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `equipment` being updated. */
  patch: UpdateEquipmentOnEquipmentForEquipmentEmployeeIdForeignPatch;
};

/** The fields on `equipment` to look up the row to update. */
export type EquipmentOnEquipmentForEquipmentProductIdForeignUsingEquipmentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `equipment` being updated. */
  patch: UpdateEquipmentOnEquipmentForEquipmentProductIdForeignPatch;
};

/** The fields on `equipment` to look up the row to update. */
export type EquipmentOnEquipmentForEquipmentProductTypeIdForeignUsingEquipmentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `equipment` being updated. */
  patch: UpdateEquipmentOnEquipmentForEquipmentProductTypeIdForeignPatch;
};

/** The fields on `equipment` to look up the row to update. */
export type EquipmentOnEquipmentForEquipmentUserIdFkeyUsingEquipmentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `equipment` being updated. */
  patch: UpdateEquipmentOnEquipmentForEquipmentUserIdFkeyPatch;
};

/** Methods to use when ordering `Equipment`. */
export type EquipmentOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'END_DATE_ASC'
  | 'END_DATE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__ACQUISITION_DATE_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__ACQUISITION_DATE_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__ACTIVE_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__ACTIVE_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__ASSIGNED_USER_DEPARTMENTS_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__ASSIGNED_USER_DEPARTMENTS_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__ASSIGNED_USER_ID_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__ASSIGNED_USER_ID_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__COMPANY_ID_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__COMPANY_ID_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__CREATED_AT_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__CREATED_AT_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__DEPARTMENT_ID_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__DEPARTMENT_ID_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__DESCRIPTION_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__DESCRIPTION_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__ID_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__ID_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__NAME_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__NAME_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__OCCUPIED_BY_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__OCCUPIED_BY_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__PRODUCT_TYPE_ID_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__PRODUCT_TYPE_ID_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__PURCHASE_DATE_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__PURCHASE_DATE_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__SEARCH_TERMS_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__SEARCH_TERMS_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__SERIAL_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__SERIAL_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__UPDATED_AT_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__UPDATED_AT_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__USER_ID_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__USER_ID_DESC'
  | 'PRODUCT_ID_ASC'
  | 'PRODUCT_ID_DESC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__ACTIVE_ASC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__ACTIVE_DESC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__COMPANY_ID_ASC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__COMPANY_ID_DESC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__CREATED_AT_ASC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__CREATED_AT_DESC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__DEPARTMENT_ID_ASC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__DEPARTMENT_ID_DESC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__ID_ASC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__ID_DESC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__NAME_ASC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__NAME_DESC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__UPDATED_AT_ASC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__UPDATED_AT_DESC'
  | 'PRODUCT_TYPE_ID_ASC'
  | 'PRODUCT_TYPE_ID_DESC'
  | 'START_DATE_ASC'
  | 'START_DATE_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** Represents an update to a `Equipment`. Fields that are set will be updated. */
export type EquipmentPatch = {
  company?: InputMaybe<EquipmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EquipmentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<EquipmentProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<EquipmentProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EquipmentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `equipment` to be created by this mutation. */
export type EquipmentProductIdForeignConnectionEquipmentCreateInput = {
  company?: InputMaybe<EquipmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EquipmentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<EquipmentProductIdForeignInput>;
  productType?: InputMaybe<EquipmentProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EquipmentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `product` to be created by this mutation. */
export type EquipmentProductIdForeignConnectionProductCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ProductDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<EquipmentProductIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInverseInput>;
  productType?: InputMaybe<ProductProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  searchTerms?: InputMaybe<Scalars['FullText']>;
  serial?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProductAssignedUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `product` in the `EquipmentInput` mutation. */
export type EquipmentProductIdForeignInput = {
  /** The primary key(s) for `product` for the far side of the relationship. */
  connectById?: InputMaybe<ProductProductPkeyConnect>;
  /** A `ProductInput` object that will be created and connected to this object. */
  create?: InputMaybe<EquipmentProductIdForeignConnectionProductCreateInput>;
  /** The primary key(s) and patch data for `product` for the far side of the relationship. */
  updateById?: InputMaybe<ProductOnEquipmentForEquipmentProductIdForeignUsingProductPkeyUpdate>;
};

/** Input for the nested mutation of `equipment` in the `ProductInput` mutation. */
export type EquipmentProductIdForeignInverseInput = {
  /** The primary key(s) for `equipment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EquipmentEquipmentPkeyConnect>>;
  /** A `EquipmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EquipmentProductIdForeignConnectionEquipmentCreateInput>>;
  /** The primary key(s) for `equipment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EquipmentEquipmentPkeyDelete>>;
  /** Flag indicating whether all other `equipment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `equipment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EquipmentOnEquipmentForEquipmentProductIdForeignUsingEquipmentPkeyUpdate>>;
};

/** The `equipment` to be created by this mutation. */
export type EquipmentProductTypeIdForeignConnectionEquipmentCreateInput = {
  company?: InputMaybe<EquipmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EquipmentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<EquipmentProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<EquipmentProductTypeIdForeignInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EquipmentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `productType` to be created by this mutation. */
export type EquipmentProductTypeIdForeignConnectionProductTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  equipment?: InputMaybe<EquipmentProductTypeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  products?: InputMaybe<ProductProductTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `productType` in the `EquipmentInput` mutation. */
export type EquipmentProductTypeIdForeignInput = {
  /** The primary key(s) for `productType` for the far side of the relationship. */
  connectByCompanyIdAndDepartmentIdAndName?: InputMaybe<ProductTypeProductTypeCompanyIdDepartmentIdNameUniqueConnect>;
  /** The primary key(s) for `productType` for the far side of the relationship. */
  connectById?: InputMaybe<ProductTypeProductTypePkeyConnect>;
  /** A `ProductTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<EquipmentProductTypeIdForeignConnectionProductTypeCreateInput>;
  /** The primary key(s) and patch data for `productType` for the far side of the relationship. */
  updateByCompanyIdAndDepartmentIdAndName?: InputMaybe<ProductTypeOnEquipmentForEquipmentProductTypeIdForeignUsingProductTypeCompanyIdDepartmentIdNameUniqueUpdate>;
  /** The primary key(s) and patch data for `productType` for the far side of the relationship. */
  updateById?: InputMaybe<ProductTypeOnEquipmentForEquipmentProductTypeIdForeignUsingProductTypePkeyUpdate>;
};

/** Input for the nested mutation of `equipment` in the `ProductTypeInput` mutation. */
export type EquipmentProductTypeIdForeignInverseInput = {
  /** The primary key(s) for `equipment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EquipmentEquipmentPkeyConnect>>;
  /** A `EquipmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EquipmentProductTypeIdForeignConnectionEquipmentCreateInput>>;
  /** The primary key(s) for `equipment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EquipmentEquipmentPkeyDelete>>;
  /** Flag indicating whether all other `equipment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `equipment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EquipmentOnEquipmentForEquipmentProductTypeIdForeignUsingEquipmentPkeyUpdate>>;
};

/** The `equipment` to be created by this mutation. */
export type EquipmentUserIdFkeyConnectionEquipmentCreateInput = {
  company?: InputMaybe<EquipmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EquipmentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<EquipmentProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<EquipmentProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EquipmentUserIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `EquipmentInput` mutation. */
export type EquipmentUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnEquipmentForEquipmentUserIdFkeyUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `equipment` in the `UserInput` mutation. */
export type EquipmentUserIdFkeyInverseInput = {
  /** The primary key(s) for `equipment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EquipmentEquipmentPkeyConnect>>;
  /** A `EquipmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EquipmentUserIdFkeyConnectionEquipmentCreateInput>>;
  /** The primary key(s) for `equipment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EquipmentEquipmentPkeyDelete>>;
  /** Flag indicating whether all other `equipment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `equipment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EquipmentOnEquipmentForEquipmentUserIdFkeyUsingEquipmentPkeyUpdate>>;
};

export type ErrorMessage = {
  __typename?: 'ErrorMessage';
  id?: Maybe<Scalars['UUID']>;
  messageCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type ErrorReportInput = {
  error: Scalars['String'];
  grantAccess?: InputMaybe<Scalars['Boolean']>;
  isCrash?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  routeName: Scalars['String'];
  useEmail?: InputMaybe<Scalars['Boolean']>;
  userAgent: Scalars['JSON'];
};

export type ErrorReportResponse = {
  __typename?: 'ErrorReportResponse';
  response: Scalars['String'];
};

export type Event = {
  __typename?: 'Event';
  active: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `Attendee`. */
  attendees: AttendeesConnection;
  /** Reads a single `Company` that is related to this `Event`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  contactPersonIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  createdAt: Scalars['Datetime'];
  deadline?: Maybe<Scalars['Datetime']>;
  description: Scalars['String'];
  endDate?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `EventUser`. */
  eventUsers: EventUsersConnection;
  /** Reads and enables pagination through a set of `FormField`. */
  formFields: FormFieldsConnection;
  geography?: Maybe<Point>;
  id: Scalars['UUID'];
  image?: Maybe<Storage>;
  invitedAll: Scalars['Boolean'];
  invitedDepartmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  invitedUserIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  location: Scalars['String'];
  name: Scalars['String'];
  organizerIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads and enables pagination through a set of `User`. */
  organizers: UsersConnection;
  startDate: Scalars['Datetime'];
};


export type EventAttendeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<AttendeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EventEventUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventUserCondition>;
  filter?: InputMaybe<EventUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventUsersOrderBy>>;
};


export type EventFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldCondition>;
  filter?: InputMaybe<FormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldsOrderBy>>;
};


export type EventOrganizersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** The `event` to be created by this mutation. */
export type EventCompanyIdForeignConnectionEventCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EventCompanyIdForeignInput>;
  contactPersonIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  description: Scalars['String'];
  endDate?: InputMaybe<Scalars['Datetime']>;
  eventUsers?: InputMaybe<EventUserEventIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEventIdForeignInverseInput>;
  geography?: InputMaybe<PointInput>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  location: Scalars['String'];
  name: Scalars['String'];
  organizerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  startDate: Scalars['Datetime'];
};

/** Input for the nested mutation of `company` in the `EventInput` mutation. */
export type EventCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnEventForEventCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `event` in the `CompanyInput` mutation. */
export type EventCompanyIdForeignInverseInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventEventPkeyConnect>>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventCompanyIdForeignConnectionEventCreateInput>>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventOnEventForEventCompanyIdForeignUsingEventPkeyUpdate>>;
};

/** A condition to be used against `Event` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type EventCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `contactPersonIds` field. */
  contactPersonIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deadline` field. */
  deadline?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `geography` field. */
  geography?: InputMaybe<PointInput>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `invitedAll` field. */
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `invitedDepartmentIds` field. */
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `invitedUserIds` field. */
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `location` field. */
  location?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `organizerIds` field. */
  organizerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `event` to look up the row to connect. */
export type EventEventPkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against `Event` object types. All fields are combined with a logical ‘and.’ */
export type EventFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EventFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `contactPersonIds` field. */
  contactPersonIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deadline` field. */
  deadline?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eventUsers` relation. */
  eventUsers?: InputMaybe<EventToManyEventUserFilter>;
  /** Some related `eventUsers` exist. */
  eventUsersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFields` relation. */
  formFields?: InputMaybe<EventToManyFormFieldFilter>;
  /** Some related `formFields` exist. */
  formFieldsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `invitedAll` field. */
  invitedAll?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `invitedDepartmentIds` field. */
  invitedDepartmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `invitedUserIds` field. */
  invitedUserIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `location` field. */
  location?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EventFilter>>;
  /** Filter by the object’s `organizerIds` field. */
  organizerIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Event` */
export type EventInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EventCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contactPersonIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  description: Scalars['String'];
  endDate?: InputMaybe<Scalars['Datetime']>;
  eventUsers?: InputMaybe<EventUserEventIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEventIdForeignInverseInput>;
  geography?: InputMaybe<PointInput>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  location: Scalars['String'];
  name: Scalars['String'];
  organizerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  startDate: Scalars['Datetime'];
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventForEventCompanyIdForeignUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventForEventCompanyIdForeignPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnEventUserForEventUserEventIdForeignUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnEventUserForEventUserEventIdForeignPatch;
};

/** The fields on `event` to look up the row to update. */
export type EventOnFormFieldForFormFieldEventIdForeignUsingEventPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `event` being updated. */
  patch: UpdateEventOnFormFieldForFormFieldEventIdForeignPatch;
};

/** Represents an update to a `Event`. Fields that are set will be updated. */
export type EventPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EventCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contactPersonIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  eventUsers?: InputMaybe<EventUserEventIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEventIdForeignInverseInput>;
  geography?: InputMaybe<PointInput>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  startDate?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against many `EventUser` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyEventUserFilter = {
  /** Every related `EventUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EventUserFilter>;
  /** No related `EventUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EventUserFilter>;
  /** Some related `EventUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EventUserFilter>;
};

/** A filter to be used against many `FormField` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyFormFieldFilter = {
  /** Every related `FormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FormFieldFilter>;
  /** No related `FormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FormFieldFilter>;
  /** Some related `FormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FormFieldFilter>;
};

export type EventUser = {
  __typename?: 'EventUser';
  attending?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Company` that is related to this `EventUser`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `Event` that is related to this `EventUser`. */
  event?: Maybe<Event>;
  eventId: Scalars['UUID'];
  id: Scalars['UUID'];
  /** Reads a single `User` that is related to this `EventUser`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The `eventUser` to be created by this mutation. */
export type EventUserCompanyIdForeignConnectionEventUserCreateInput = {
  attending?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EventUserCompanyIdForeignInput>;
  event?: InputMaybe<EventUserEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<EventUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `EventUserInput` mutation. */
export type EventUserCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnEventUserForEventUserCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `eventUser` in the `CompanyInput` mutation. */
export type EventUserCompanyIdForeignInverseInput = {
  /** The primary key(s) for `eventUser` for the far side of the relationship. */
  connectByEventIdAndUserId?: InputMaybe<Array<EventUserEventUserEventIdUserIdUniqueConnect>>;
  /** The primary key(s) for `eventUser` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventUserEventUserPkeyConnect>>;
  /** A `EventUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventUserCompanyIdForeignConnectionEventUserCreateInput>>;
  /** The primary key(s) for `eventUser` for the far side of the relationship. */
  deleteByEventIdAndUserId?: InputMaybe<Array<EventUserEventUserEventIdUserIdUniqueDelete>>;
  /** The primary key(s) for `eventUser` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventUserEventUserPkeyDelete>>;
  /** Flag indicating whether all other `eventUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventUser` for the far side of the relationship. */
  updateByEventIdAndUserId?: InputMaybe<Array<EventUserOnEventUserForEventUserCompanyIdForeignUsingEventUserEventIdUserIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `eventUser` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventUserOnEventUserForEventUserCompanyIdForeignUsingEventUserPkeyUpdate>>;
};

/**
 * A condition to be used against `EventUser` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type EventUserCondition = {
  /** Checks for equality with the object’s `attending` field. */
  attending?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `event` to be created by this mutation. */
export type EventUserEventIdForeignConnectionEventCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EventCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contactPersonIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  description: Scalars['String'];
  endDate?: InputMaybe<Scalars['Datetime']>;
  eventUsers?: InputMaybe<EventUserEventIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEventIdForeignInverseInput>;
  geography?: InputMaybe<PointInput>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  location: Scalars['String'];
  name: Scalars['String'];
  organizerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  startDate: Scalars['Datetime'];
};

/** The `eventUser` to be created by this mutation. */
export type EventUserEventIdForeignConnectionEventUserCreateInput = {
  attending?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EventUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<EventUserEventIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<EventUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `event` in the `EventUserInput` mutation. */
export type EventUserEventIdForeignInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<EventEventPkeyConnect>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<EventUserEventIdForeignConnectionEventCreateInput>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<EventOnEventUserForEventUserEventIdForeignUsingEventPkeyUpdate>;
};

/** Input for the nested mutation of `eventUser` in the `EventInput` mutation. */
export type EventUserEventIdForeignInverseInput = {
  /** The primary key(s) for `eventUser` for the far side of the relationship. */
  connectByEventIdAndUserId?: InputMaybe<Array<EventUserEventUserEventIdUserIdUniqueConnect>>;
  /** The primary key(s) for `eventUser` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventUserEventUserPkeyConnect>>;
  /** A `EventUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventUserEventIdForeignConnectionEventUserCreateInput>>;
  /** The primary key(s) for `eventUser` for the far side of the relationship. */
  deleteByEventIdAndUserId?: InputMaybe<Array<EventUserEventUserEventIdUserIdUniqueDelete>>;
  /** The primary key(s) for `eventUser` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventUserEventUserPkeyDelete>>;
  /** Flag indicating whether all other `eventUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventUser` for the far side of the relationship. */
  updateByEventIdAndUserId?: InputMaybe<Array<EventUserOnEventUserForEventUserEventIdForeignUsingEventUserEventIdUserIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `eventUser` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventUserOnEventUserForEventUserEventIdForeignUsingEventUserPkeyUpdate>>;
};

/** The fields on `eventUser` to look up the row to connect. */
export type EventUserEventUserEventIdUserIdUniqueConnect = {
  eventId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `eventUser` to look up the row to delete. */
export type EventUserEventUserEventIdUserIdUniqueDelete = {
  eventId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `eventUser` to look up the row to connect. */
export type EventUserEventUserPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `eventUser` to look up the row to delete. */
export type EventUserEventUserPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against `EventUser` object types. All fields are combined with a logical ‘and.’ */
export type EventUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EventUserFilter>>;
  /** Filter by the object’s `attending` field. */
  attending?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `event` relation. */
  event?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EventUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EventUserFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `EventUser` */
export type EventUserInput = {
  attending?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EventUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<EventUserEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<EventUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `eventUser` to look up the row to update. */
export type EventUserOnEventUserForEventUserCompanyIdForeignUsingEventUserEventIdUserIdUniqueUpdate = {
  eventId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventUser` being updated. */
  patch: UpdateEventUserOnEventUserForEventUserCompanyIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `eventUser` to look up the row to update. */
export type EventUserOnEventUserForEventUserCompanyIdForeignUsingEventUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventUser` being updated. */
  patch: UpdateEventUserOnEventUserForEventUserCompanyIdForeignPatch;
};

/** The fields on `eventUser` to look up the row to update. */
export type EventUserOnEventUserForEventUserEventIdForeignUsingEventUserEventIdUserIdUniqueUpdate = {
  eventId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventUser` being updated. */
  patch: UpdateEventUserOnEventUserForEventUserEventIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `eventUser` to look up the row to update. */
export type EventUserOnEventUserForEventUserEventIdForeignUsingEventUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventUser` being updated. */
  patch: UpdateEventUserOnEventUserForEventUserEventIdForeignPatch;
};

/** The fields on `eventUser` to look up the row to update. */
export type EventUserOnEventUserForEventUserUserIdForeignUsingEventUserEventIdUserIdUniqueUpdate = {
  eventId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventUser` being updated. */
  patch: UpdateEventUserOnEventUserForEventUserUserIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `eventUser` to look up the row to update. */
export type EventUserOnEventUserForEventUserUserIdForeignUsingEventUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `eventUser` being updated. */
  patch: UpdateEventUserOnEventUserForEventUserUserIdForeignPatch;
};

/** Represents an update to a `EventUser`. Fields that are set will be updated. */
export type EventUserPatch = {
  attending?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EventUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<EventUserEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<EventUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `eventUser` to be created by this mutation. */
export type EventUserUserIdForeignConnectionEventUserCreateInput = {
  attending?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EventUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<EventUserEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<EventUserUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `EventUserInput` mutation. */
export type EventUserUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnEventUserForEventUserUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `eventUser` in the `UserInput` mutation. */
export type EventUserUserIdForeignInverseInput = {
  /** The primary key(s) for `eventUser` for the far side of the relationship. */
  connectByEventIdAndUserId?: InputMaybe<Array<EventUserEventUserEventIdUserIdUniqueConnect>>;
  /** The primary key(s) for `eventUser` for the far side of the relationship. */
  connectById?: InputMaybe<Array<EventUserEventUserPkeyConnect>>;
  /** A `EventUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<EventUserUserIdForeignConnectionEventUserCreateInput>>;
  /** The primary key(s) for `eventUser` for the far side of the relationship. */
  deleteByEventIdAndUserId?: InputMaybe<Array<EventUserEventUserEventIdUserIdUniqueDelete>>;
  /** The primary key(s) for `eventUser` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<EventUserEventUserPkeyDelete>>;
  /** Flag indicating whether all other `eventUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `eventUser` for the far side of the relationship. */
  updateByEventIdAndUserId?: InputMaybe<Array<EventUserOnEventUserForEventUserUserIdForeignUsingEventUserEventIdUserIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `eventUser` for the far side of the relationship. */
  updateById?: InputMaybe<Array<EventUserOnEventUserForEventUserUserIdForeignUsingEventUserPkeyUpdate>>;
};

/** A connection to a list of `EventUser` values. */
export type EventUsersConnection = {
  __typename?: 'EventUsersConnection';
  /** A list of edges which contains the `EventUser` and cursor to aid in pagination. */
  edges: Array<EventUsersEdge>;
  /** A list of `EventUser` objects. */
  nodes: Array<Maybe<EventUser>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EventUser` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EventUser` edge in the connection. */
export type EventUsersEdge = {
  __typename?: 'EventUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EventUser` at the end of the edge. */
  node?: Maybe<EventUser>;
};

/** Methods to use when ordering `EventUser`. */
export type EventUsersOrderBy =
  | 'ATTENDING_ASC'
  | 'ATTENDING_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'EVENT_BY_EVENT_ID__ACTIVE_ASC'
  | 'EVENT_BY_EVENT_ID__ACTIVE_DESC'
  | 'EVENT_BY_EVENT_ID__COMPANY_ID_ASC'
  | 'EVENT_BY_EVENT_ID__COMPANY_ID_DESC'
  | 'EVENT_BY_EVENT_ID__CONTACT_PERSON_IDS_ASC'
  | 'EVENT_BY_EVENT_ID__CONTACT_PERSON_IDS_DESC'
  | 'EVENT_BY_EVENT_ID__CREATED_AT_ASC'
  | 'EVENT_BY_EVENT_ID__CREATED_AT_DESC'
  | 'EVENT_BY_EVENT_ID__DEADLINE_ASC'
  | 'EVENT_BY_EVENT_ID__DEADLINE_DESC'
  | 'EVENT_BY_EVENT_ID__DESCRIPTION_ASC'
  | 'EVENT_BY_EVENT_ID__DESCRIPTION_DESC'
  | 'EVENT_BY_EVENT_ID__END_DATE_ASC'
  | 'EVENT_BY_EVENT_ID__END_DATE_DESC'
  | 'EVENT_BY_EVENT_ID__GEOGRAPHY_ASC'
  | 'EVENT_BY_EVENT_ID__GEOGRAPHY_DESC'
  | 'EVENT_BY_EVENT_ID__ID_ASC'
  | 'EVENT_BY_EVENT_ID__ID_DESC'
  | 'EVENT_BY_EVENT_ID__INVITED_ALL_ASC'
  | 'EVENT_BY_EVENT_ID__INVITED_ALL_DESC'
  | 'EVENT_BY_EVENT_ID__INVITED_DEPARTMENT_IDS_ASC'
  | 'EVENT_BY_EVENT_ID__INVITED_DEPARTMENT_IDS_DESC'
  | 'EVENT_BY_EVENT_ID__INVITED_USER_IDS_ASC'
  | 'EVENT_BY_EVENT_ID__INVITED_USER_IDS_DESC'
  | 'EVENT_BY_EVENT_ID__LOCATION_ASC'
  | 'EVENT_BY_EVENT_ID__LOCATION_DESC'
  | 'EVENT_BY_EVENT_ID__NAME_ASC'
  | 'EVENT_BY_EVENT_ID__NAME_DESC'
  | 'EVENT_BY_EVENT_ID__ORGANIZER_IDS_ASC'
  | 'EVENT_BY_EVENT_ID__ORGANIZER_IDS_DESC'
  | 'EVENT_BY_EVENT_ID__START_DATE_ASC'
  | 'EVENT_BY_EVENT_ID__START_DATE_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** A connection to a list of `Event` values. */
export type EventsConnection = {
  __typename?: 'EventsConnection';
  /** A list of edges which contains the `Event` and cursor to aid in pagination. */
  edges: Array<EventsEdge>;
  /** A list of `Event` objects. */
  nodes: Array<Maybe<Event>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Event` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Event` edge in the connection. */
export type EventsEdge = {
  __typename?: 'EventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Event` at the end of the edge. */
  node?: Maybe<Event>;
};

/** Methods to use when ordering `Event`. */
export type EventsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CONTACT_PERSON_IDS_ASC'
  | 'CONTACT_PERSON_IDS_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEADLINE_ASC'
  | 'DEADLINE_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'END_DATE_ASC'
  | 'END_DATE_DESC'
  | 'EVENT_USERS_BY_EVENT_ID__COUNT_ASC'
  | 'EVENT_USERS_BY_EVENT_ID__COUNT_DESC'
  | 'FORM_FIELDS_BY_EVENT_ID__COUNT_ASC'
  | 'FORM_FIELDS_BY_EVENT_ID__COUNT_DESC'
  | 'GEOGRAPHY_ASC'
  | 'GEOGRAPHY_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INVITED_ALL_ASC'
  | 'INVITED_ALL_DESC'
  | 'INVITED_DEPARTMENT_IDS_ASC'
  | 'INVITED_DEPARTMENT_IDS_DESC'
  | 'INVITED_USER_IDS_ASC'
  | 'INVITED_USER_IDS_DESC'
  | 'LOCATION_ASC'
  | 'LOCATION_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'ORGANIZER_IDS_ASC'
  | 'ORGANIZER_IDS_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'START_DATE_ASC'
  | 'START_DATE_DESC';

export type ExportCompetencesToExcelPayload = {
  __typename?: 'ExportCompetencesToExcelPayload';
  base64?: Maybe<Scalars['String']>;
};

export type ExportDashboardCardToExcelInput = {
  dashboardCardId: Scalars['UUID'];
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
};

export type ExportDashboardCardToExcelPayload = {
  __typename?: 'ExportDashboardCardToExcelPayload';
  base64?: Maybe<Scalars['String']>;
};

export type ExportDepartmentsToExcelInput = {
  departmentIds: Array<Scalars['UUID']>;
  fields: Array<Scalars['String']>;
};

export type ExportDepartmentsToExcelPayload = {
  __typename?: 'ExportDepartmentsToExcelPayload';
  base64?: Maybe<Scalars['String']>;
};

export type ExportDocumentsToExcelInput = {
  ids?: InputMaybe<Array<Scalars['UUID']>>;
};

export type ExportDocumentsToExcelPayload = {
  __typename?: 'ExportDocumentsToExcelPayload';
  base64?: Maybe<Scalars['String']>;
};

export type ExportEmployeesToExcelInput = {
  csv?: InputMaybe<Scalars['Boolean']>;
  delimiter?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['UUID']>;
  fields: Array<Scalars['String']>;
  useImportCompatibleFormat?: InputMaybe<Scalars['Boolean']>;
};

export type ExportEmployeesToExcelPayload = {
  __typename?: 'ExportEmployeesToExcelPayload';
  base64?: Maybe<Scalars['String']>;
};

export type ExportEquipmentInput = {
  fields: Array<Scalars['String']>;
  productIds: Array<Scalars['UUID']>;
};

export type ExportEquipmentPayload = {
  __typename?: 'ExportEquipmentPayload';
  excelFile: Scalars['String'];
};

export type ExportFieldLogToExcelPayload = {
  __typename?: 'ExportFieldLogToExcelPayload';
  base64?: Maybe<Scalars['String']>;
};

export type ExportPreboardingResultsToExcelInput = {
  includeDepartments?: InputMaybe<Scalars['Boolean']>;
  preboardingId: Scalars['UUID'];
};

export type ExportPreboardingResultsToExcelPayload = {
  __typename?: 'ExportPreboardingResultsToExcelPayload';
  base64?: Maybe<Scalars['String']>;
};

export type ExportVacationToExcelInput = {
  dataType: Scalars['String'];
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Date'];
  formFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  groupedByEmployee?: InputMaybe<Scalars['Boolean']>;
  holidayCountry?: InputMaybe<Scalars['String']>;
  includeApprovedAbsence?: InputMaybe<Scalars['Boolean']>;
  includeHolidays?: InputMaybe<Scalars['Boolean']>;
  includeRejectedAbsence?: InputMaybe<Scalars['Boolean']>;
  includeUnapprovedAbsence?: InputMaybe<Scalars['Boolean']>;
  includeWeekends?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['Date'];
  systemFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  vacationTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

export type ExportVacationToExcelPayload = {
  __typename?: 'ExportVacationToExcelPayload';
  base64?: Maybe<Scalars['String']>;
};

export type ExternalIntegration = {
  __typename?: 'ExternalIntegration';
  absenceMappings?: Maybe<Scalars['JSON']>;
  absenceSync?: Maybe<Scalars['Boolean']>;
  active: Scalars['Boolean'];
  /** Reads a single `AuthApp` that is related to this `ExternalIntegration`. */
  authApp?: Maybe<AuthApp>;
  authAppId?: Maybe<Scalars['UUID']>;
  blacklistedFields?: Maybe<Scalars['JSON']>;
  /** Reads a single `Company` that is related to this `ExternalIntegration`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  config?: Maybe<Scalars['JSON']>;
  continuousSync?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Datetime'];
  credentials?: Maybe<Scalars['JSON']>;
  departmentId?: Maybe<Scalars['UUID']>;
  departmentInheritance?: Maybe<Scalars['Boolean']>;
  /** Reads and enables pagination through a set of `EmployeeExternalIntegration`. */
  employeeExternalIntegrations: EmployeeExternalIntegrationsConnection;
  externalAdditionalId?: Maybe<Scalars['String']>;
  externalCompanyId?: Maybe<Scalars['String']>;
  fieldMappings?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  /** Reads a single `IntegrableSystem` that is related to this `ExternalIntegration`. */
  integrableSystem?: Maybe<IntegrableSystem>;
  integrableSystemId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `IntegrationFieldMarking`. */
  integrationFieldMarkings: IntegrationFieldMarkingsConnection;
  /** Reads a single `DocumentFolderBlueprint` that is related to this `ExternalIntegration`. */
  payslipDocumentBlueprintFolder?: Maybe<DocumentFolderBlueprint>;
  payslipDocumentBlueprintFolderId?: Maybe<Scalars['UUID']>;
  /** Reads a single `DocumentType` that is related to this `ExternalIntegration`. */
  payslipDocumentType?: Maybe<DocumentType>;
  payslipDocumentTypeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ExternalSystem` that is related to this `ExternalIntegration`. */
  system?: Maybe<ExternalSystem>;
  systemId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  whitelistedFields?: Maybe<Scalars['JSON']>;
};


export type ExternalIntegrationEmployeeExternalIntegrationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmployeeExternalIntegrationCondition>;
  filter?: InputMaybe<EmployeeExternalIntegrationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmployeeExternalIntegrationsOrderBy>>;
};


export type ExternalIntegrationIntegrationFieldMarkingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<IntegrationFieldMarkingCondition>;
  filter?: InputMaybe<IntegrationFieldMarkingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegrationFieldMarkingsOrderBy>>;
};

/** The `externalIntegration` to be created by this mutation. */
export type ExternalIntegrationAuthAppIdFkeyConnectionExternalIntegrationCreateInput = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInput>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<ExternalIntegrationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  documentFolderBlueprint?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput>;
  documentType?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput>;
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  externalCompanyId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInput>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrableSystem?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInput>;
  integrableSystemId?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput>;
  payslipDocumentBlueprintFolderId?: InputMaybe<Scalars['UUID']>;
  payslipDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** Input for the nested mutation of `authApp` in the `ExternalIntegrationInput` mutation. */
export type ExternalIntegrationAuthAppIdFkeyInput = {
  /** The primary key(s) for `authApp` for the far side of the relationship. */
  connectById?: InputMaybe<AuthAppAuthAppPkeyConnect>;
  /** The primary key(s) and patch data for `authApp` for the far side of the relationship. */
  updateById?: InputMaybe<AuthAppOnExternalIntegrationForExternalIntegrationAuthAppIdFkeyUsingAuthAppPkeyUpdate>;
};

/** Input for the nested mutation of `externalIntegration` in the `AuthAppInput` mutation. */
export type ExternalIntegrationAuthAppIdFkeyInverseInput = {
  /** The primary key(s) for `externalIntegration` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalIntegrationExternalIntegrationPkeyConnect>>;
  /** A `ExternalIntegrationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalIntegrationAuthAppIdFkeyConnectionExternalIntegrationCreateInput>>;
  /** The primary key(s) for `externalIntegration` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalIntegrationExternalIntegrationPkeyDelete>>;
  /** Flag indicating whether all other `externalIntegration` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalIntegration` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalIntegrationOnExternalIntegrationForExternalIntegrationAuthAppIdFkeyUsingExternalIntegrationPkeyUpdate>>;
};

/** The `externalIntegration` to be created by this mutation. */
export type ExternalIntegrationCompanyIdForeignConnectionExternalIntegrationCreateInput = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<ExternalIntegrationCompanyIdForeignInput>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  documentFolderBlueprint?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput>;
  documentType?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput>;
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  externalCompanyId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInput>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrableSystem?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInput>;
  integrableSystemId?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput>;
  payslipDocumentBlueprintFolderId?: InputMaybe<Scalars['UUID']>;
  payslipDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** Input for the nested mutation of `company` in the `ExternalIntegrationInput` mutation. */
export type ExternalIntegrationCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnExternalIntegrationForExternalIntegrationCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `externalIntegration` in the `CompanyInput` mutation. */
export type ExternalIntegrationCompanyIdForeignInverseInput = {
  /** The primary key(s) for `externalIntegration` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalIntegrationExternalIntegrationPkeyConnect>>;
  /** A `ExternalIntegrationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalIntegrationCompanyIdForeignConnectionExternalIntegrationCreateInput>>;
  /** The primary key(s) for `externalIntegration` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalIntegrationExternalIntegrationPkeyDelete>>;
  /** Flag indicating whether all other `externalIntegration` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalIntegration` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalIntegrationOnExternalIntegrationForExternalIntegrationCompanyIdForeignUsingExternalIntegrationPkeyUpdate>>;
};

/**
 * A condition to be used against `ExternalIntegration` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ExternalIntegrationCondition = {
  /** Checks for equality with the object’s `absenceMappings` field. */
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `absenceSync` field. */
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `authAppId` field. */
  authAppId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `blacklistedFields` field. */
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `config` field. */
  config?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `continuousSync` field. */
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `credentials` field. */
  credentials?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `departmentId` field. */
  departmentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departmentInheritance` field. */
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `externalAdditionalId` field. */
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `externalCompanyId` field. */
  externalCompanyId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fieldMappings` field. */
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `integrableSystemId` field. */
  integrableSystemId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `payslipDocumentBlueprintFolderId` field. */
  payslipDocumentBlueprintFolderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `payslipDocumentTypeId` field. */
  payslipDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `systemId` field. */
  systemId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `whitelistedFields` field. */
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** The fields on `externalIntegration` to look up the row to connect. */
export type ExternalIntegrationExternalIntegrationPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `externalIntegration` to look up the row to delete. */
export type ExternalIntegrationExternalIntegrationPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `externalIntegration` to be created by this mutation. */
export type ExternalIntegrationExternalSystemIdFkeyConnectionExternalIntegrationCreateInput = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<ExternalIntegrationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  documentFolderBlueprint?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput>;
  documentType?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput>;
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  externalCompanyId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInput>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrableSystem?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInput>;
  integrableSystemId?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput>;
  payslipDocumentBlueprintFolderId?: InputMaybe<Scalars['UUID']>;
  payslipDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** Input for the nested mutation of `externalSystem` in the `ExternalIntegrationInput` mutation. */
export type ExternalIntegrationExternalSystemIdFkeyInput = {
  /** The primary key(s) for `externalSystem` for the far side of the relationship. */
  connectById?: InputMaybe<ExternalSystemExternalSystemPkeyConnect>;
  /** The primary key(s) and patch data for `externalSystem` for the far side of the relationship. */
  updateById?: InputMaybe<ExternalSystemOnExternalIntegrationForExternalIntegrationExternalSystemIdFkeyUsingExternalSystemPkeyUpdate>;
};

/** Input for the nested mutation of `externalIntegration` in the `ExternalSystemInput` mutation. */
export type ExternalIntegrationExternalSystemIdFkeyInverseInput = {
  /** The primary key(s) for `externalIntegration` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalIntegrationExternalIntegrationPkeyConnect>>;
  /** A `ExternalIntegrationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalIntegrationExternalSystemIdFkeyConnectionExternalIntegrationCreateInput>>;
  /** The primary key(s) for `externalIntegration` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalIntegrationExternalIntegrationPkeyDelete>>;
  /** Flag indicating whether all other `externalIntegration` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalIntegration` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalIntegrationOnExternalIntegrationForExternalIntegrationExternalSystemIdFkeyUsingExternalIntegrationPkeyUpdate>>;
};

/** A filter to be used against `ExternalIntegration` object types. All fields are combined with a logical ‘and.’ */
export type ExternalIntegrationFilter = {
  /** Filter by the object’s `absenceMappings` field. */
  absenceMappings?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `absenceSync` field. */
  absenceSync?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ExternalIntegrationFilter>>;
  /** Filter by the object’s `authApp` relation. */
  authApp?: InputMaybe<AuthAppFilter>;
  /** A related `authApp` exists. */
  authAppExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `authAppId` field. */
  authAppId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `blacklistedFields` field. */
  blacklistedFields?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `config` field. */
  config?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `continuousSync` field. */
  continuousSync?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `credentials` field. */
  credentials?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `departmentId` field. */
  departmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departmentInheritance` field. */
  departmentInheritance?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `employeeExternalIntegrations` relation. */
  employeeExternalIntegrations?: InputMaybe<ExternalIntegrationToManyEmployeeExternalIntegrationFilter>;
  /** Some related `employeeExternalIntegrations` exist. */
  employeeExternalIntegrationsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `externalAdditionalId` field. */
  externalAdditionalId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalCompanyId` field. */
  externalCompanyId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fieldMappings` field. */
  fieldMappings?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `integrableSystem` relation. */
  integrableSystem?: InputMaybe<IntegrableSystemFilter>;
  /** A related `integrableSystem` exists. */
  integrableSystemExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `integrableSystemId` field. */
  integrableSystemId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `integrationFieldMarkings` relation. */
  integrationFieldMarkings?: InputMaybe<ExternalIntegrationToManyIntegrationFieldMarkingFilter>;
  /** Some related `integrationFieldMarkings` exist. */
  integrationFieldMarkingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Negates the expression. */
  not?: InputMaybe<ExternalIntegrationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ExternalIntegrationFilter>>;
  /** Filter by the object’s `payslipDocumentBlueprintFolder` relation. */
  payslipDocumentBlueprintFolder?: InputMaybe<DocumentFolderBlueprintFilter>;
  /** A related `payslipDocumentBlueprintFolder` exists. */
  payslipDocumentBlueprintFolderExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `payslipDocumentBlueprintFolderId` field. */
  payslipDocumentBlueprintFolderId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `payslipDocumentType` relation. */
  payslipDocumentType?: InputMaybe<DocumentTypeFilter>;
  /** A related `payslipDocumentType` exists. */
  payslipDocumentTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `payslipDocumentTypeId` field. */
  payslipDocumentTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `system` relation. */
  system?: InputMaybe<ExternalSystemFilter>;
  /** A related `system` exists. */
  systemExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `systemId` field. */
  systemId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `whitelistedFields` field. */
  whitelistedFields?: InputMaybe<JsonFilter>;
};

/** An input for mutations affecting `ExternalIntegration` */
export type ExternalIntegrationInput = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<ExternalIntegrationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  documentFolderBlueprint?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput>;
  documentType?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput>;
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  externalCompanyId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInput>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrableSystem?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInput>;
  integrableSystemId?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput>;
  payslipDocumentBlueprintFolderId?: InputMaybe<Scalars['UUID']>;
  payslipDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** The `externalIntegration` to be created by this mutation. */
export type ExternalIntegrationIntegrableSystemIdFkeyConnectionExternalIntegrationCreateInput = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<ExternalIntegrationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  documentFolderBlueprint?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput>;
  documentType?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput>;
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  externalCompanyId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInput>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrableSystem?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInput>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput>;
  payslipDocumentBlueprintFolderId?: InputMaybe<Scalars['UUID']>;
  payslipDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** The `integrableSystem` to be created by this mutation. */
export type ExternalIntegrationIntegrableSystemIdFkeyConnectionIntegrableSystemCreateInput = {
  authUrl: Scalars['String'];
  createUrl: Scalars['String'];
  deleteUrl: Scalars['String'];
  description: Scalars['String'];
  externalIntegrations?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInverseInput>;
  homepageUrl: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  isBeta?: InputMaybe<Scalars['Boolean']>;
  legalDescription?: InputMaybe<Scalars['String']>;
  loginUrl?: InputMaybe<Scalars['String']>;
  logo: Scalars['String'];
  name: Scalars['String'];
  settingsUrl?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `integrableSystem` in the `ExternalIntegrationInput` mutation. */
export type ExternalIntegrationIntegrableSystemIdFkeyInput = {
  /** The primary key(s) for `integrableSystem` for the far side of the relationship. */
  connectById?: InputMaybe<IntegrableSystemIntegrableSystemPkeyConnect>;
  /** A `IntegrableSystemInput` object that will be created and connected to this object. */
  create?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyConnectionIntegrableSystemCreateInput>;
  /** The primary key(s) for `integrableSystem` for the far side of the relationship. */
  deleteById?: InputMaybe<IntegrableSystemIntegrableSystemPkeyDelete>;
  /** The primary key(s) and patch data for `integrableSystem` for the far side of the relationship. */
  updateById?: InputMaybe<IntegrableSystemOnExternalIntegrationForExternalIntegrationIntegrableSystemIdFkeyUsingIntegrableSystemPkeyUpdate>;
};

/** Input for the nested mutation of `externalIntegration` in the `IntegrableSystemInput` mutation. */
export type ExternalIntegrationIntegrableSystemIdFkeyInverseInput = {
  /** The primary key(s) for `externalIntegration` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalIntegrationExternalIntegrationPkeyConnect>>;
  /** A `ExternalIntegrationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalIntegrationIntegrableSystemIdFkeyConnectionExternalIntegrationCreateInput>>;
  /** The primary key(s) for `externalIntegration` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalIntegrationExternalIntegrationPkeyDelete>>;
  /** Flag indicating whether all other `externalIntegration` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalIntegration` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalIntegrationOnExternalIntegrationForExternalIntegrationIntegrableSystemIdFkeyUsingExternalIntegrationPkeyUpdate>>;
};

/** The fields on `externalIntegration` to look up the row to update. */
export type ExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationExternalIntegrationIdForeignUsingExternalIntegrationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalIntegration` being updated. */
  patch: UpdateExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationExternalIntegrationIdForeignPatch;
};

/** The fields on `externalIntegration` to look up the row to update. */
export type ExternalIntegrationOnExternalIntegrationForExternalIntegrationAuthAppIdFkeyUsingExternalIntegrationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalIntegration` being updated. */
  patch: UpdateExternalIntegrationOnExternalIntegrationForExternalIntegrationAuthAppIdFkeyPatch;
};

/** The fields on `externalIntegration` to look up the row to update. */
export type ExternalIntegrationOnExternalIntegrationForExternalIntegrationCompanyIdForeignUsingExternalIntegrationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalIntegration` being updated. */
  patch: UpdateExternalIntegrationOnExternalIntegrationForExternalIntegrationCompanyIdForeignPatch;
};

/** The fields on `externalIntegration` to look up the row to update. */
export type ExternalIntegrationOnExternalIntegrationForExternalIntegrationExternalSystemIdFkeyUsingExternalIntegrationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalIntegration` being updated. */
  patch: UpdateExternalIntegrationOnExternalIntegrationForExternalIntegrationExternalSystemIdFkeyPatch;
};

/** The fields on `externalIntegration` to look up the row to update. */
export type ExternalIntegrationOnExternalIntegrationForExternalIntegrationIntegrableSystemIdFkeyUsingExternalIntegrationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalIntegration` being updated. */
  patch: UpdateExternalIntegrationOnExternalIntegrationForExternalIntegrationIntegrableSystemIdFkeyPatch;
};

/** The fields on `externalIntegration` to look up the row to update. */
export type ExternalIntegrationOnExternalIntegrationForExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyUsingExternalIntegrationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalIntegration` being updated. */
  patch: UpdateExternalIntegrationOnExternalIntegrationForExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyPatch;
};

/** The fields on `externalIntegration` to look up the row to update. */
export type ExternalIntegrationOnExternalIntegrationForExternalIntegrationPayslipDocumentTypeIdFkeyUsingExternalIntegrationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalIntegration` being updated. */
  patch: UpdateExternalIntegrationOnExternalIntegrationForExternalIntegrationPayslipDocumentTypeIdFkeyPatch;
};

/** The fields on `externalIntegration` to look up the row to update. */
export type ExternalIntegrationOnIntegrationFieldMarkingForIntegrationFieldMarkingExternalIntegrationIdFkeyUsingExternalIntegrationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `externalIntegration` being updated. */
  patch: UpdateExternalIntegrationOnIntegrationFieldMarkingForIntegrationFieldMarkingExternalIntegrationIdFkeyPatch;
};

/** Represents an update to a `ExternalIntegration`. Fields that are set will be updated. */
export type ExternalIntegrationPatch = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<ExternalIntegrationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  documentFolderBlueprint?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput>;
  documentType?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput>;
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  externalCompanyId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInput>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrableSystem?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInput>;
  integrableSystemId?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput>;
  payslipDocumentBlueprintFolderId?: InputMaybe<Scalars['UUID']>;
  payslipDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** The `documentFolderBlueprint` to be created by this mutation. */
export type ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyConnectionDocumentFolderBlueprintCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderBlueprintParentDocumentFolderBlueprintIdFInput>;
  documentFoldersToDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderDocumentFolderBlueprintIdForeignInverseInput>;
  documentFoldersToRootDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  parentDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInverseInput>;
};

/** The `externalIntegration` to be created by this mutation. */
export type ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyConnectionExternalIntegrationCreateInput = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<ExternalIntegrationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  documentFolderBlueprint?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput>;
  documentType?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput>;
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  externalCompanyId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInput>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrableSystem?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInput>;
  integrableSystemId?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput>;
  payslipDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** Input for the nested mutation of `documentFolderBlueprint` in the `ExternalIntegrationInput` mutation. */
export type ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput = {
  /** The primary key(s) for `documentFolderBlueprint` for the far side of the relationship. */
  connectById?: InputMaybe<DocumentFolderBlueprintDocumentFolderBlueprintPkeyConnect>;
  /** A `DocumentFolderBlueprintInput` object that will be created and connected to this object. */
  create?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyConnectionDocumentFolderBlueprintCreateInput>;
  /** The primary key(s) and patch data for `documentFolderBlueprint` for the far side of the relationship. */
  updateById?: InputMaybe<DocumentFolderBlueprintOnExternalIntegrationForExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyUsingDocumentFolderBlueprintPkeyUpdate>;
};

/** Input for the nested mutation of `externalIntegration` in the `DocumentFolderBlueprintInput` mutation. */
export type ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInverseInput = {
  /** The primary key(s) for `externalIntegration` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalIntegrationExternalIntegrationPkeyConnect>>;
  /** A `ExternalIntegrationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyConnectionExternalIntegrationCreateInput>>;
  /** The primary key(s) for `externalIntegration` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalIntegrationExternalIntegrationPkeyDelete>>;
  /** Flag indicating whether all other `externalIntegration` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalIntegration` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalIntegrationOnExternalIntegrationForExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyUsingExternalIntegrationPkeyUpdate>>;
};

/** The `documentType` to be created by this mutation. */
export type ExternalIntegrationPayslipDocumentTypeIdFkeyConnectionDocumentTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput>;
  contractTemplates?: InputMaybe<ContractTemplateDocumentTypeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lifetime?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  storages?: InputMaybe<StorageDocumentTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `externalIntegration` to be created by this mutation. */
export type ExternalIntegrationPayslipDocumentTypeIdFkeyConnectionExternalIntegrationCreateInput = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<ExternalIntegrationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  documentFolderBlueprint?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput>;
  documentType?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput>;
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  externalCompanyId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInput>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrableSystem?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInput>;
  integrableSystemId?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput>;
  payslipDocumentBlueprintFolderId?: InputMaybe<Scalars['UUID']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** Input for the nested mutation of `documentType` in the `ExternalIntegrationInput` mutation. */
export type ExternalIntegrationPayslipDocumentTypeIdFkeyInput = {
  /** The primary key(s) for `documentType` for the far side of the relationship. */
  connectByCompanyIdAndDepartmentIdAndName?: InputMaybe<DocumentTypeDocumentTypeCompanyIdDepartmentIdNameUniqueConnect>;
  /** The primary key(s) for `documentType` for the far side of the relationship. */
  connectById?: InputMaybe<DocumentTypeDocumentTypePkeyConnect>;
  /** A `DocumentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyConnectionDocumentTypeCreateInput>;
  /** The primary key(s) and patch data for `documentType` for the far side of the relationship. */
  updateByCompanyIdAndDepartmentIdAndName?: InputMaybe<DocumentTypeOnExternalIntegrationForExternalIntegrationPayslipDocumentTypeIdFkeyUsingDocumentTypeCompanyIdDepartmentIdNameUniqueUpdate>;
  /** The primary key(s) and patch data for `documentType` for the far side of the relationship. */
  updateById?: InputMaybe<DocumentTypeOnExternalIntegrationForExternalIntegrationPayslipDocumentTypeIdFkeyUsingDocumentTypePkeyUpdate>;
};

/** Input for the nested mutation of `externalIntegration` in the `DocumentTypeInput` mutation. */
export type ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput = {
  /** The primary key(s) for `externalIntegration` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ExternalIntegrationExternalIntegrationPkeyConnect>>;
  /** A `ExternalIntegrationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ExternalIntegrationPayslipDocumentTypeIdFkeyConnectionExternalIntegrationCreateInput>>;
  /** The primary key(s) for `externalIntegration` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ExternalIntegrationExternalIntegrationPkeyDelete>>;
  /** Flag indicating whether all other `externalIntegration` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `externalIntegration` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ExternalIntegrationOnExternalIntegrationForExternalIntegrationPayslipDocumentTypeIdFkeyUsingExternalIntegrationPkeyUpdate>>;
};

/** A filter to be used against many `EmployeeExternalIntegration` object types. All fields are combined with a logical ‘and.’ */
export type ExternalIntegrationToManyEmployeeExternalIntegrationFilter = {
  /** Every related `EmployeeExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmployeeExternalIntegrationFilter>;
  /** No related `EmployeeExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmployeeExternalIntegrationFilter>;
  /** Some related `EmployeeExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmployeeExternalIntegrationFilter>;
};

/** A filter to be used against many `IntegrationFieldMarking` object types. All fields are combined with a logical ‘and.’ */
export type ExternalIntegrationToManyIntegrationFieldMarkingFilter = {
  /** Every related `IntegrationFieldMarking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<IntegrationFieldMarkingFilter>;
  /** No related `IntegrationFieldMarking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<IntegrationFieldMarkingFilter>;
  /** Some related `IntegrationFieldMarking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<IntegrationFieldMarkingFilter>;
};

/** A connection to a list of `ExternalIntegration` values. */
export type ExternalIntegrationsConnection = {
  __typename?: 'ExternalIntegrationsConnection';
  /** A list of edges which contains the `ExternalIntegration` and cursor to aid in pagination. */
  edges: Array<ExternalIntegrationsEdge>;
  /** A list of `ExternalIntegration` objects. */
  nodes: Array<Maybe<ExternalIntegration>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ExternalIntegration` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ExternalIntegration` edge in the connection. */
export type ExternalIntegrationsEdge = {
  __typename?: 'ExternalIntegrationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ExternalIntegration` at the end of the edge. */
  node?: Maybe<ExternalIntegration>;
};

/** Methods to use when ordering `ExternalIntegration`. */
export type ExternalIntegrationsOrderBy =
  | 'ABSENCE_MAPPINGS_ASC'
  | 'ABSENCE_MAPPINGS_DESC'
  | 'ABSENCE_SYNC_ASC'
  | 'ABSENCE_SYNC_DESC'
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__API_KEY_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__API_KEY_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__APP_TYPE_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__APP_TYPE_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__CLIENT_ID_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__CLIENT_ID_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__CLIENT_SECRET_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__CLIENT_SECRET_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__COMPANY_ID_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__COMPANY_ID_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__CREATED_AT_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__CREATED_AT_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__DELETED_AT_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__DELETED_AT_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__DESCRIPTION_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__DESCRIPTION_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__GROUP_ID_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__GROUP_ID_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__HOMEPAGE_URI_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__HOMEPAGE_URI_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__ID_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__ID_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__NAME_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__NAME_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__REDIRECT_URIS_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__REDIRECT_URIS_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__STORAGE_ID_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__STORAGE_ID_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__TOKENS_REVOKED_AT_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__TOKENS_REVOKED_AT_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__UPDATED_AT_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__UPDATED_AT_DESC'
  | 'AUTH_APP_ID_ASC'
  | 'AUTH_APP_ID_DESC'
  | 'BLACKLISTED_FIELDS_ASC'
  | 'BLACKLISTED_FIELDS_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CONFIG_ASC'
  | 'CONFIG_DESC'
  | 'CONTINUOUS_SYNC_ASC'
  | 'CONTINUOUS_SYNC_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CREDENTIALS_ASC'
  | 'CREDENTIALS_DESC'
  | 'DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_ID_DESC'
  | 'DEPARTMENT_INHERITANCE_ASC'
  | 'DEPARTMENT_INHERITANCE_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PAYSLIP_DOCUMENT_BLUEPRINT_FOLDER_ID__ACTIVE_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PAYSLIP_DOCUMENT_BLUEPRINT_FOLDER_ID__ACTIVE_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PAYSLIP_DOCUMENT_BLUEPRINT_FOLDER_ID__COMPANY_ID_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PAYSLIP_DOCUMENT_BLUEPRINT_FOLDER_ID__COMPANY_ID_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PAYSLIP_DOCUMENT_BLUEPRINT_FOLDER_ID__ID_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PAYSLIP_DOCUMENT_BLUEPRINT_FOLDER_ID__ID_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PAYSLIP_DOCUMENT_BLUEPRINT_FOLDER_ID__NAME_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PAYSLIP_DOCUMENT_BLUEPRINT_FOLDER_ID__NAME_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PAYSLIP_DOCUMENT_BLUEPRINT_FOLDER_ID__PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_PAYSLIP_DOCUMENT_BLUEPRINT_FOLDER_ID__PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__ACTIVE_ASC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__ACTIVE_DESC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__AUTO_DELETE_DAYS_ASC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__AUTO_DELETE_DAYS_DESC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__CREATED_AT_ASC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__CREATED_AT_DESC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__DEPARTMENT_ID_ASC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__DEPARTMENT_ID_DESC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__ID_ASC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__ID_DESC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__LIFETIME_ASC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__LIFETIME_DESC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__NAME_ASC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__NAME_DESC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'DOCUMENT_TYPE_BY_PAYSLIP_DOCUMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_EXTERNAL_INTEGRATIONS_BY_EXTERNAL_INTEGRATION_ID__COUNT_ASC'
  | 'EMPLOYEE_EXTERNAL_INTEGRATIONS_BY_EXTERNAL_INTEGRATION_ID__COUNT_DESC'
  | 'EXTERNAL_ADDITIONAL_ID_ASC'
  | 'EXTERNAL_ADDITIONAL_ID_DESC'
  | 'EXTERNAL_COMPANY_ID_ASC'
  | 'EXTERNAL_COMPANY_ID_DESC'
  | 'EXTERNAL_SYSTEM_BY_SYSTEM_ID__CREATED_AT_ASC'
  | 'EXTERNAL_SYSTEM_BY_SYSTEM_ID__CREATED_AT_DESC'
  | 'EXTERNAL_SYSTEM_BY_SYSTEM_ID__ID_ASC'
  | 'EXTERNAL_SYSTEM_BY_SYSTEM_ID__ID_DESC'
  | 'EXTERNAL_SYSTEM_BY_SYSTEM_ID__NAME_ASC'
  | 'EXTERNAL_SYSTEM_BY_SYSTEM_ID__NAME_DESC'
  | 'EXTERNAL_SYSTEM_BY_SYSTEM_ID__UPDATED_AT_ASC'
  | 'EXTERNAL_SYSTEM_BY_SYSTEM_ID__UPDATED_AT_DESC'
  | 'FIELD_MAPPINGS_ASC'
  | 'FIELD_MAPPINGS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__AUTH_URL_ASC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__AUTH_URL_DESC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__CREATE_URL_ASC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__CREATE_URL_DESC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__DELETE_URL_ASC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__DELETE_URL_DESC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__DESCRIPTION_ASC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__DESCRIPTION_DESC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__HOMEPAGE_URL_ASC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__HOMEPAGE_URL_DESC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__ID_ASC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__ID_DESC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__IS_BETA_ASC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__IS_BETA_DESC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__LEGAL_DESCRIPTION_ASC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__LEGAL_DESCRIPTION_DESC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__LOGIN_URL_ASC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__LOGIN_URL_DESC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__LOGO_ASC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__LOGO_DESC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__NAME_ASC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__NAME_DESC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__SETTINGS_URL_ASC'
  | 'INTEGRABLE_SYSTEM_BY_INTEGRABLE_SYSTEM_ID__SETTINGS_URL_DESC'
  | 'INTEGRABLE_SYSTEM_ID_ASC'
  | 'INTEGRABLE_SYSTEM_ID_DESC'
  | 'INTEGRATION_FIELD_MARKINGS_BY_EXTERNAL_INTEGRATION_ID__COUNT_ASC'
  | 'INTEGRATION_FIELD_MARKINGS_BY_EXTERNAL_INTEGRATION_ID__COUNT_DESC'
  | 'NATURAL'
  | 'PAYSLIP_DOCUMENT_BLUEPRINT_FOLDER_ID_ASC'
  | 'PAYSLIP_DOCUMENT_BLUEPRINT_FOLDER_ID_DESC'
  | 'PAYSLIP_DOCUMENT_TYPE_ID_ASC'
  | 'PAYSLIP_DOCUMENT_TYPE_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SYSTEM_ID_ASC'
  | 'SYSTEM_ID_DESC'
  | 'TITLE_ASC'
  | 'TITLE_DESC'
  | 'WHITELISTED_FIELDS_ASC'
  | 'WHITELISTED_FIELDS_DESC';

export type ExternalSystem = {
  __typename?: 'ExternalSystem';
  createdAt?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `ExternalIntegration`. */
  externalIntegrationsBySystemId: ExternalIntegrationsConnection;
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['Datetime']>;
};


export type ExternalSystemExternalIntegrationsBySystemIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalIntegrationCondition>;
  filter?: InputMaybe<ExternalIntegrationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalIntegrationsOrderBy>>;
};

/**
 * A condition to be used against `ExternalSystem` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ExternalSystemCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `externalSystem` to look up the row to connect. */
export type ExternalSystemExternalSystemPkeyConnect = {
  id: Scalars['Int'];
};

/** A filter to be used against `ExternalSystem` object types. All fields are combined with a logical ‘and.’ */
export type ExternalSystemFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ExternalSystemFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `externalIntegrationsBySystemId` relation. */
  externalIntegrationsBySystemId?: InputMaybe<ExternalSystemToManyExternalIntegrationFilter>;
  /** Some related `externalIntegrationsBySystemId` exist. */
  externalIntegrationsBySystemIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ExternalSystemFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ExternalSystemFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** The fields on `externalSystem` to look up the row to update. */
export type ExternalSystemOnExternalIntegrationForExternalIntegrationExternalSystemIdFkeyUsingExternalSystemPkeyUpdate = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `externalSystem` being updated. */
  patch: UpdateExternalSystemOnExternalIntegrationForExternalIntegrationExternalSystemIdFkeyPatch;
};

/** A filter to be used against many `ExternalIntegration` object types. All fields are combined with a logical ‘and.’ */
export type ExternalSystemToManyExternalIntegrationFilter = {
  /** Every related `ExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalIntegrationFilter>;
  /** No related `ExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalIntegrationFilter>;
  /** Some related `ExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalIntegrationFilter>;
};

/** A connection to a list of `ExternalSystem` values. */
export type ExternalSystemsConnection = {
  __typename?: 'ExternalSystemsConnection';
  /** A list of edges which contains the `ExternalSystem` and cursor to aid in pagination. */
  edges: Array<ExternalSystemsEdge>;
  /** A list of `ExternalSystem` objects. */
  nodes: Array<Maybe<ExternalSystem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ExternalSystem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ExternalSystem` edge in the connection. */
export type ExternalSystemsEdge = {
  __typename?: 'ExternalSystemsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ExternalSystem` at the end of the edge. */
  node?: Maybe<ExternalSystem>;
};

/** Methods to use when ordering `ExternalSystem`. */
export type ExternalSystemsOrderBy =
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'EXTERNAL_INTEGRATIONS_BY_SYSTEM_ID__COUNT_ASC'
  | 'EXTERNAL_INTEGRATIONS_BY_SYSTEM_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

export type FieldGroup = {
  __typename?: 'FieldGroup';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `FieldGroup`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `CompanySystemField`. */
  companySystemFields: CompanySystemFieldsConnection;
  customId?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `FieldGroupCard`. */
  fieldGroupCards: FieldGroupCardsConnection;
  /** Reads and enables pagination through a set of `FormFieldEntry`. */
  formFieldEntries: FormFieldEntriesConnection;
  /** Reads and enables pagination through a set of `FormField`. */
  formFields: FormFieldsConnection;
  /** Reads and enables pagination through a set of `FutureDatum`. */
  futureData: FutureDataConnection;
  id: Scalars['UUID'];
  localizedName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  /** Reads and enables pagination through a set of `UserSystemField`. */
  userSystemFields: UserSystemFieldsConnection;
};


export type FieldGroupCompanySystemFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanySystemFieldCondition>;
  filter?: InputMaybe<CompanySystemFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanySystemFieldsOrderBy>>;
};


export type FieldGroupFieldGroupCardsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FieldGroupCardCondition>;
  filter?: InputMaybe<FieldGroupCardFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FieldGroupCardsOrderBy>>;
};


export type FieldGroupFormFieldEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldEntryCondition>;
  filter?: InputMaybe<FormFieldEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldEntriesOrderBy>>;
};


export type FieldGroupFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldCondition>;
  filter?: InputMaybe<FormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldsOrderBy>>;
};


export type FieldGroupFutureDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FutureDatumCondition>;
  filter?: InputMaybe<FutureDatumFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FutureDataOrderBy>>;
};


export type FieldGroupUserSystemFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserSystemFieldCondition>;
  filter?: InputMaybe<UserSystemFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSystemFieldsOrderBy>>;
};

export type FieldGroupCard = {
  __typename?: 'FieldGroupCard';
  active: Scalars['Boolean'];
  columns: Scalars['Int'];
  /** Reads a single `Company` that is related to this `FieldGroupCard`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  description?: Maybe<Scalars['String']>;
  /** Reads a single `FieldGroup` that is related to this `FieldGroupCard`. */
  fieldGroup?: Maybe<FieldGroup>;
  /** Reads and enables pagination through a set of `FieldGroupCardColumn`. */
  fieldGroupCardColumns: FieldGroupCardColumnsConnection;
  fieldGroupId: Scalars['UUID'];
  id: Scalars['UUID'];
  localizedDescription?: Maybe<Scalars['String']>;
  localizedName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
};


export type FieldGroupCardFieldGroupCardColumnsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FieldGroupCardColumnCondition>;
  filter?: InputMaybe<FieldGroupCardColumnFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FieldGroupCardColumnsOrderBy>>;
};

export type FieldGroupCardAction = {
  columnCount: Scalars['Int'];
  columns?: InputMaybe<Array<FieldGroupCardColumnAction>>;
  description?: InputMaybe<Scalars['String']>;
  fieldGroupId: Scalars['UUID'];
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  order: Scalars['Int'];
};

export type FieldGroupCardColumn = {
  __typename?: 'FieldGroupCardColumn';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `FieldGroupCardColumn`. */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `CompanySystemField`. */
  companySystemFields: CompanySystemFieldsConnection;
  createdAt: Scalars['Datetime'];
  /** Reads a single `FieldGroupCard` that is related to this `FieldGroupCardColumn`. */
  fieldGroupCard?: Maybe<FieldGroupCard>;
  fieldGroupCardId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `FormField`. */
  formFields: FormFieldsConnection;
  id: Scalars['UUID'];
  localizedName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
};


export type FieldGroupCardColumnCompanySystemFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanySystemFieldCondition>;
  filter?: InputMaybe<CompanySystemFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanySystemFieldsOrderBy>>;
};


export type FieldGroupCardColumnFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldCondition>;
  filter?: InputMaybe<FormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldsOrderBy>>;
};

export type FieldGroupCardColumnAction = {
  fields?: InputMaybe<Array<PersonalDataCardField>>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};

/** The `fieldGroupCardColumn` to be created by this mutation. */
export type FieldGroupCardColumnCompanyIdForeignConnectionFieldGroupCardColumnCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  fieldGroupCard?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignInput>;
  fieldGroupCardId?: InputMaybe<Scalars['UUID']>;
  formFields?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** Input for the nested mutation of `company` in the `FieldGroupCardColumnInput` mutation. */
export type FieldGroupCardColumnCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnFieldGroupCardColumnForFieldGroupCardColumnCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `fieldGroupCardColumn` in the `CompanyInput` mutation. */
export type FieldGroupCardColumnCompanyIdForeignInverseInput = {
  /** The primary key(s) for `fieldGroupCardColumn` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FieldGroupCardColumnFieldGroupCardColumnPkeyConnect>>;
  /** A `FieldGroupCardColumnInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FieldGroupCardColumnCompanyIdForeignConnectionFieldGroupCardColumnCreateInput>>;
  /** The primary key(s) and patch data for `fieldGroupCardColumn` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FieldGroupCardColumnOnFieldGroupCardColumnForFieldGroupCardColumnCompanyIdForeignUsingFieldGroupCardColumnPkeyUpdate>>;
};

/**
 * A condition to be used against `FieldGroupCardColumn` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type FieldGroupCardColumnCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `fieldGroupCardId` field. */
  fieldGroupCardId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
};

/** The fields on `fieldGroupCardColumn` to look up the row to connect. */
export type FieldGroupCardColumnFieldGroupCardColumnPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `fieldGroupCardColumn` to be created by this mutation. */
export type FieldGroupCardColumnFieldGroupCardIdForeignConnectionFieldGroupCardColumnCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  fieldGroupCard?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignInput>;
  formFields?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** The `fieldGroupCard` to be created by this mutation. */
export type FieldGroupCardColumnFieldGroupCardIdForeignConnectionFieldGroupCardCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  columns?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<FieldGroupCardCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  fieldGroup?: InputMaybe<FieldGroupCardFieldGroupIdForeignInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignInverseInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** Input for the nested mutation of `fieldGroupCard` in the `FieldGroupCardColumnInput` mutation. */
export type FieldGroupCardColumnFieldGroupCardIdForeignInput = {
  /** The primary key(s) for `fieldGroupCard` for the far side of the relationship. */
  connectById?: InputMaybe<FieldGroupCardFieldGroupCardPkeyConnect>;
  /** A `FieldGroupCardInput` object that will be created and connected to this object. */
  create?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignConnectionFieldGroupCardCreateInput>;
  /** The primary key(s) and patch data for `fieldGroupCard` for the far side of the relationship. */
  updateById?: InputMaybe<FieldGroupCardOnFieldGroupCardColumnForFieldGroupCardColumnFieldGroupCardIdForeignUsingFieldGroupCardPkeyUpdate>;
};

/** Input for the nested mutation of `fieldGroupCardColumn` in the `FieldGroupCardInput` mutation. */
export type FieldGroupCardColumnFieldGroupCardIdForeignInverseInput = {
  /** The primary key(s) for `fieldGroupCardColumn` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FieldGroupCardColumnFieldGroupCardColumnPkeyConnect>>;
  /** A `FieldGroupCardColumnInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FieldGroupCardColumnFieldGroupCardIdForeignConnectionFieldGroupCardColumnCreateInput>>;
  /** The primary key(s) and patch data for `fieldGroupCardColumn` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FieldGroupCardColumnOnFieldGroupCardColumnForFieldGroupCardColumnFieldGroupCardIdForeignUsingFieldGroupCardColumnPkeyUpdate>>;
};

/** A filter to be used against `FieldGroupCardColumn` object types. All fields are combined with a logical ‘and.’ */
export type FieldGroupCardColumnFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FieldGroupCardColumnFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** A related `company` exists. */
  companyExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `companySystemFields` relation. */
  companySystemFields?: InputMaybe<FieldGroupCardColumnToManyCompanySystemFieldFilter>;
  /** Some related `companySystemFields` exist. */
  companySystemFieldsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fieldGroupCard` relation. */
  fieldGroupCard?: InputMaybe<FieldGroupCardFilter>;
  /** A related `fieldGroupCard` exists. */
  fieldGroupCardExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `fieldGroupCardId` field. */
  fieldGroupCardId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `formFields` relation. */
  formFields?: InputMaybe<FieldGroupCardColumnToManyFormFieldFilter>;
  /** Some related `formFields` exist. */
  formFieldsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FieldGroupCardColumnFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FieldGroupCardColumnFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `FieldGroupCardColumn` */
export type FieldGroupCardColumnInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  fieldGroupCard?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignInput>;
  fieldGroupCardId?: InputMaybe<Scalars['UUID']>;
  formFields?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** The fields on `fieldGroupCardColumn` to look up the row to update. */
export type FieldGroupCardColumnOnCompanySystemFieldForCompanySystemFieldFieldGroupCardColumnIdForeignUsingFieldGroupCardColumnPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `fieldGroupCardColumn` being updated. */
  patch: UpdateFieldGroupCardColumnOnCompanySystemFieldForCompanySystemFieldFieldGroupCardColumnIdForeignPatch;
};

/** The fields on `fieldGroupCardColumn` to look up the row to update. */
export type FieldGroupCardColumnOnFieldGroupCardColumnForFieldGroupCardColumnCompanyIdForeignUsingFieldGroupCardColumnPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `fieldGroupCardColumn` being updated. */
  patch: UpdateFieldGroupCardColumnOnFieldGroupCardColumnForFieldGroupCardColumnCompanyIdForeignPatch;
};

/** The fields on `fieldGroupCardColumn` to look up the row to update. */
export type FieldGroupCardColumnOnFieldGroupCardColumnForFieldGroupCardColumnFieldGroupCardIdForeignUsingFieldGroupCardColumnPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `fieldGroupCardColumn` being updated. */
  patch: UpdateFieldGroupCardColumnOnFieldGroupCardColumnForFieldGroupCardColumnFieldGroupCardIdForeignPatch;
};

/** The fields on `fieldGroupCardColumn` to look up the row to update. */
export type FieldGroupCardColumnOnFormFieldForFormFieldFieldGroupCardColumnIdForeignUsingFieldGroupCardColumnPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `fieldGroupCardColumn` being updated. */
  patch: UpdateFieldGroupCardColumnOnFormFieldForFormFieldFieldGroupCardColumnIdForeignPatch;
};

/** Represents an update to a `FieldGroupCardColumn`. Fields that are set will be updated. */
export type FieldGroupCardColumnPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  fieldGroupCard?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignInput>;
  fieldGroupCardId?: InputMaybe<Scalars['UUID']>;
  formFields?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against many `CompanySystemField` object types. All fields are combined with a logical ‘and.’ */
export type FieldGroupCardColumnToManyCompanySystemFieldFilter = {
  /** Every related `CompanySystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompanySystemFieldFilter>;
  /** No related `CompanySystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompanySystemFieldFilter>;
  /** Some related `CompanySystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompanySystemFieldFilter>;
};

/** A filter to be used against many `FormField` object types. All fields are combined with a logical ‘and.’ */
export type FieldGroupCardColumnToManyFormFieldFilter = {
  /** Every related `FormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FormFieldFilter>;
  /** No related `FormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FormFieldFilter>;
  /** Some related `FormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FormFieldFilter>;
};

/** A connection to a list of `FieldGroupCardColumn` values. */
export type FieldGroupCardColumnsConnection = {
  __typename?: 'FieldGroupCardColumnsConnection';
  /** A list of edges which contains the `FieldGroupCardColumn` and cursor to aid in pagination. */
  edges: Array<FieldGroupCardColumnsEdge>;
  /** A list of `FieldGroupCardColumn` objects. */
  nodes: Array<Maybe<FieldGroupCardColumn>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FieldGroupCardColumn` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FieldGroupCardColumn` edge in the connection. */
export type FieldGroupCardColumnsEdge = {
  __typename?: 'FieldGroupCardColumnsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FieldGroupCardColumn` at the end of the edge. */
  node?: Maybe<FieldGroupCardColumn>;
};

/** Methods to use when ordering `FieldGroupCardColumn`. */
export type FieldGroupCardColumnsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPANY_SYSTEM_FIELDS_BY_FIELD_GROUP_CARD_COLUMN_ID__COUNT_ASC'
  | 'COMPANY_SYSTEM_FIELDS_BY_FIELD_GROUP_CARD_COLUMN_ID__COUNT_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'FIELD_GROUP_CARD_BY_FIELD_GROUP_CARD_ID__ACTIVE_ASC'
  | 'FIELD_GROUP_CARD_BY_FIELD_GROUP_CARD_ID__ACTIVE_DESC'
  | 'FIELD_GROUP_CARD_BY_FIELD_GROUP_CARD_ID__COLUMNS_ASC'
  | 'FIELD_GROUP_CARD_BY_FIELD_GROUP_CARD_ID__COLUMNS_DESC'
  | 'FIELD_GROUP_CARD_BY_FIELD_GROUP_CARD_ID__COMPANY_ID_ASC'
  | 'FIELD_GROUP_CARD_BY_FIELD_GROUP_CARD_ID__COMPANY_ID_DESC'
  | 'FIELD_GROUP_CARD_BY_FIELD_GROUP_CARD_ID__CREATED_AT_ASC'
  | 'FIELD_GROUP_CARD_BY_FIELD_GROUP_CARD_ID__CREATED_AT_DESC'
  | 'FIELD_GROUP_CARD_BY_FIELD_GROUP_CARD_ID__DESCRIPTION_ASC'
  | 'FIELD_GROUP_CARD_BY_FIELD_GROUP_CARD_ID__DESCRIPTION_DESC'
  | 'FIELD_GROUP_CARD_BY_FIELD_GROUP_CARD_ID__FIELD_GROUP_ID_ASC'
  | 'FIELD_GROUP_CARD_BY_FIELD_GROUP_CARD_ID__FIELD_GROUP_ID_DESC'
  | 'FIELD_GROUP_CARD_BY_FIELD_GROUP_CARD_ID__ID_ASC'
  | 'FIELD_GROUP_CARD_BY_FIELD_GROUP_CARD_ID__ID_DESC'
  | 'FIELD_GROUP_CARD_BY_FIELD_GROUP_CARD_ID__NAME_ASC'
  | 'FIELD_GROUP_CARD_BY_FIELD_GROUP_CARD_ID__NAME_DESC'
  | 'FIELD_GROUP_CARD_BY_FIELD_GROUP_CARD_ID__ORDER_ASC'
  | 'FIELD_GROUP_CARD_BY_FIELD_GROUP_CARD_ID__ORDER_DESC'
  | 'FIELD_GROUP_CARD_ID_ASC'
  | 'FIELD_GROUP_CARD_ID_DESC'
  | 'FORM_FIELDS_BY_FIELD_GROUP_CARD_COLUMN_ID__COUNT_ASC'
  | 'FORM_FIELDS_BY_FIELD_GROUP_CARD_COLUMN_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/** The `fieldGroupCard` to be created by this mutation. */
export type FieldGroupCardCompanyIdForeignConnectionFieldGroupCardCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  columns?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<FieldGroupCardCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  fieldGroup?: InputMaybe<FieldGroupCardFieldGroupIdForeignInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignInverseInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** Input for the nested mutation of `company` in the `FieldGroupCardInput` mutation. */
export type FieldGroupCardCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnFieldGroupCardForFieldGroupCardCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `fieldGroupCard` in the `CompanyInput` mutation. */
export type FieldGroupCardCompanyIdForeignInverseInput = {
  /** The primary key(s) for `fieldGroupCard` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FieldGroupCardFieldGroupCardPkeyConnect>>;
  /** A `FieldGroupCardInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FieldGroupCardCompanyIdForeignConnectionFieldGroupCardCreateInput>>;
  /** The primary key(s) and patch data for `fieldGroupCard` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FieldGroupCardOnFieldGroupCardForFieldGroupCardCompanyIdForeignUsingFieldGroupCardPkeyUpdate>>;
};

/**
 * A condition to be used against `FieldGroupCard` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FieldGroupCardCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `columns` field. */
  columns?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fieldGroupId` field. */
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
};

/** The fields on `fieldGroupCard` to look up the row to connect. */
export type FieldGroupCardFieldGroupCardPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `fieldGroupCard` to be created by this mutation. */
export type FieldGroupCardFieldGroupIdForeignConnectionFieldGroupCardCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  columns?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<FieldGroupCardCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  fieldGroup?: InputMaybe<FieldGroupCardFieldGroupIdForeignInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** The `fieldGroup` to be created by this mutation. */
export type FieldGroupCardFieldGroupIdForeignConnectionFieldGroupCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  fieldGroupCards?: InputMaybe<FieldGroupCardFieldGroupIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFieldGroupIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldFormFieldTypeIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFieldGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  userSystemFields?: InputMaybe<UserSystemFieldFieldGroupIdForeignInverseInput>;
};

/** Input for the nested mutation of `fieldGroup` in the `FieldGroupCardInput` mutation. */
export type FieldGroupCardFieldGroupIdForeignInput = {
  /** The primary key(s) for `fieldGroup` for the far side of the relationship. */
  connectById?: InputMaybe<FieldGroupFormFieldTypePkeyConnect>;
  /** A `FieldGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<FieldGroupCardFieldGroupIdForeignConnectionFieldGroupCreateInput>;
  /** The primary key(s) and patch data for `fieldGroup` for the far side of the relationship. */
  updateById?: InputMaybe<FieldGroupOnFieldGroupCardForFieldGroupCardFieldGroupIdForeignUsingFormFieldTypePkeyUpdate>;
};

/** Input for the nested mutation of `fieldGroupCard` in the `FieldGroupInput` mutation. */
export type FieldGroupCardFieldGroupIdForeignInverseInput = {
  /** The primary key(s) for `fieldGroupCard` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FieldGroupCardFieldGroupCardPkeyConnect>>;
  /** A `FieldGroupCardInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FieldGroupCardFieldGroupIdForeignConnectionFieldGroupCardCreateInput>>;
  /** The primary key(s) and patch data for `fieldGroupCard` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FieldGroupCardOnFieldGroupCardForFieldGroupCardFieldGroupIdForeignUsingFieldGroupCardPkeyUpdate>>;
};

/** A filter to be used against `FieldGroupCard` object types. All fields are combined with a logical ‘and.’ */
export type FieldGroupCardFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FieldGroupCardFilter>>;
  /** Filter by the object’s `columns` field. */
  columns?: InputMaybe<IntFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fieldGroup` relation. */
  fieldGroup?: InputMaybe<FieldGroupFilter>;
  /** Filter by the object’s `fieldGroupCardColumns` relation. */
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardToManyFieldGroupCardColumnFilter>;
  /** Some related `fieldGroupCardColumns` exist. */
  fieldGroupCardColumnsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `fieldGroupId` field. */
  fieldGroupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedDescription` field. */
  localizedDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FieldGroupCardFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FieldGroupCardFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `FieldGroupCard` */
export type FieldGroupCardInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  columns?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<FieldGroupCardCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  fieldGroup?: InputMaybe<FieldGroupCardFieldGroupIdForeignInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignInverseInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** The fields on `fieldGroupCard` to look up the row to update. */
export type FieldGroupCardOnFieldGroupCardColumnForFieldGroupCardColumnFieldGroupCardIdForeignUsingFieldGroupCardPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `fieldGroupCard` being updated. */
  patch: UpdateFieldGroupCardOnFieldGroupCardColumnForFieldGroupCardColumnFieldGroupCardIdForeignPatch;
};

/** The fields on `fieldGroupCard` to look up the row to update. */
export type FieldGroupCardOnFieldGroupCardForFieldGroupCardCompanyIdForeignUsingFieldGroupCardPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `fieldGroupCard` being updated. */
  patch: UpdateFieldGroupCardOnFieldGroupCardForFieldGroupCardCompanyIdForeignPatch;
};

/** The fields on `fieldGroupCard` to look up the row to update. */
export type FieldGroupCardOnFieldGroupCardForFieldGroupCardFieldGroupIdForeignUsingFieldGroupCardPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `fieldGroupCard` being updated. */
  patch: UpdateFieldGroupCardOnFieldGroupCardForFieldGroupCardFieldGroupIdForeignPatch;
};

/** Represents an update to a `FieldGroupCard`. Fields that are set will be updated. */
export type FieldGroupCardPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  columns?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<FieldGroupCardCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  fieldGroup?: InputMaybe<FieldGroupCardFieldGroupIdForeignInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignInverseInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against many `FieldGroupCardColumn` object types. All fields are combined with a logical ‘and.’ */
export type FieldGroupCardToManyFieldGroupCardColumnFilter = {
  /** Every related `FieldGroupCardColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FieldGroupCardColumnFilter>;
  /** No related `FieldGroupCardColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FieldGroupCardColumnFilter>;
  /** Some related `FieldGroupCardColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FieldGroupCardColumnFilter>;
};

/** A connection to a list of `FieldGroupCard` values. */
export type FieldGroupCardsConnection = {
  __typename?: 'FieldGroupCardsConnection';
  /** A list of edges which contains the `FieldGroupCard` and cursor to aid in pagination. */
  edges: Array<FieldGroupCardsEdge>;
  /** A list of `FieldGroupCard` objects. */
  nodes: Array<Maybe<FieldGroupCard>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FieldGroupCard` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FieldGroupCard` edge in the connection. */
export type FieldGroupCardsEdge = {
  __typename?: 'FieldGroupCardsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FieldGroupCard` at the end of the edge. */
  node?: Maybe<FieldGroupCard>;
};

/** Methods to use when ordering `FieldGroupCard`. */
export type FieldGroupCardsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COLUMNS_ASC'
  | 'COLUMNS_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ACTIVE_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ACTIVE_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__COMPANY_ID_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__COMPANY_ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__CUSTOM_ID_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__CUSTOM_ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ID_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__LOCALIZED_NAME_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__LOCALIZED_NAME_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__NAME_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__NAME_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ORDER_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ORDER_DESC'
  | 'FIELD_GROUP_CARD_COLUMNS_BY_FIELD_GROUP_CARD_ID__COUNT_ASC'
  | 'FIELD_GROUP_CARD_COLUMNS_BY_FIELD_GROUP_CARD_ID__COUNT_DESC'
  | 'FIELD_GROUP_ID_ASC'
  | 'FIELD_GROUP_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/**
 * A condition to be used against `FieldGroup` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FieldGroupCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `customId` field. */
  customId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `FieldGroup` object types. All fields are combined with a logical ‘and.’ */
export type FieldGroupFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FieldGroupFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `companySystemFields` relation. */
  companySystemFields?: InputMaybe<FieldGroupToManyCompanySystemFieldFilter>;
  /** Some related `companySystemFields` exist. */
  companySystemFieldsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `customId` field. */
  customId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fieldGroupCards` relation. */
  fieldGroupCards?: InputMaybe<FieldGroupToManyFieldGroupCardFilter>;
  /** Some related `fieldGroupCards` exist. */
  fieldGroupCardsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFieldEntries` relation. */
  formFieldEntries?: InputMaybe<FieldGroupToManyFormFieldEntryFilter>;
  /** Some related `formFieldEntries` exist. */
  formFieldEntriesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFields` relation. */
  formFields?: InputMaybe<FieldGroupToManyFormFieldFilter>;
  /** Some related `formFields` exist. */
  formFieldsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `futureData` relation. */
  futureData?: InputMaybe<FieldGroupToManyFutureDatumFilter>;
  /** Some related `futureData` exist. */
  futureDataExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FieldGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FieldGroupFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userSystemFields` relation. */
  userSystemFields?: InputMaybe<FieldGroupToManyUserSystemFieldFilter>;
  /** Some related `userSystemFields` exist. */
  userSystemFieldsExist?: InputMaybe<Scalars['Boolean']>;
};

/** The fields on `fieldGroup` to look up the row to connect. */
export type FieldGroupFormFieldTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** An input for mutations affecting `FieldGroup` */
export type FieldGroupInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  fieldGroupCards?: InputMaybe<FieldGroupCardFieldGroupIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFieldGroupIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldFormFieldTypeIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFieldGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  userSystemFields?: InputMaybe<UserSystemFieldFieldGroupIdForeignInverseInput>;
};

/** The fields on `fieldGroup` to look up the row to update. */
export type FieldGroupOnCompanySystemFieldForCompanySystemFieldFormFieldTypeIdForeignUsingFormFieldTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `fieldGroup` being updated. */
  patch: UpdateFieldGroupOnCompanySystemFieldForCompanySystemFieldFormFieldTypeIdForeignPatch;
};

/** The fields on `fieldGroup` to look up the row to update. */
export type FieldGroupOnFieldGroupCardForFieldGroupCardFieldGroupIdForeignUsingFormFieldTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `fieldGroup` being updated. */
  patch: UpdateFieldGroupOnFieldGroupCardForFieldGroupCardFieldGroupIdForeignPatch;
};

/** The fields on `fieldGroup` to look up the row to update. */
export type FieldGroupOnFieldGroupForFormFieldTypeCompanyIdForeignUsingFormFieldTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `fieldGroup` being updated. */
  patch: UpdateFieldGroupOnFieldGroupForFormFieldTypeCompanyIdForeignPatch;
};

/** The fields on `fieldGroup` to look up the row to update. */
export type FieldGroupOnFormFieldEntryForFormFieldEntryFieldGroupIdForeignUsingFormFieldTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `fieldGroup` being updated. */
  patch: UpdateFieldGroupOnFormFieldEntryForFormFieldEntryFieldGroupIdForeignPatch;
};

/** The fields on `fieldGroup` to look up the row to update. */
export type FieldGroupOnFormFieldForFormFieldFormFieldTypeIdForeignUsingFormFieldTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `fieldGroup` being updated. */
  patch: UpdateFieldGroupOnFormFieldForFormFieldFormFieldTypeIdForeignPatch;
};

/** The fields on `fieldGroup` to look up the row to update. */
export type FieldGroupOnFutureDatumForFutureDataFieldGroupIdForeignUsingFormFieldTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `fieldGroup` being updated. */
  patch: UpdateFieldGroupOnFutureDatumForFutureDataFieldGroupIdForeignPatch;
};

/** The fields on `fieldGroup` to look up the row to update. */
export type FieldGroupOnUserSystemFieldForUserSystemFieldFieldGroupIdForeignUsingFormFieldTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `fieldGroup` being updated. */
  patch: UpdateFieldGroupOnUserSystemFieldForUserSystemFieldFieldGroupIdForeignPatch;
};

/** Represents an update to a `FieldGroup`. Fields that are set will be updated. */
export type FieldGroupPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  fieldGroupCards?: InputMaybe<FieldGroupCardFieldGroupIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFieldGroupIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldFormFieldTypeIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFieldGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  userSystemFields?: InputMaybe<UserSystemFieldFieldGroupIdForeignInverseInput>;
};

/** A filter to be used against many `CompanySystemField` object types. All fields are combined with a logical ‘and.’ */
export type FieldGroupToManyCompanySystemFieldFilter = {
  /** Every related `CompanySystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompanySystemFieldFilter>;
  /** No related `CompanySystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompanySystemFieldFilter>;
  /** Some related `CompanySystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompanySystemFieldFilter>;
};

/** A filter to be used against many `FieldGroupCard` object types. All fields are combined with a logical ‘and.’ */
export type FieldGroupToManyFieldGroupCardFilter = {
  /** Every related `FieldGroupCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FieldGroupCardFilter>;
  /** No related `FieldGroupCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FieldGroupCardFilter>;
  /** Some related `FieldGroupCard` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FieldGroupCardFilter>;
};

/** A filter to be used against many `FormFieldEntry` object types. All fields are combined with a logical ‘and.’ */
export type FieldGroupToManyFormFieldEntryFilter = {
  /** Every related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FormFieldEntryFilter>;
  /** No related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FormFieldEntryFilter>;
  /** Some related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FormFieldEntryFilter>;
};

/** A filter to be used against many `FormField` object types. All fields are combined with a logical ‘and.’ */
export type FieldGroupToManyFormFieldFilter = {
  /** Every related `FormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FormFieldFilter>;
  /** No related `FormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FormFieldFilter>;
  /** Some related `FormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FormFieldFilter>;
};

/** A filter to be used against many `FutureDatum` object types. All fields are combined with a logical ‘and.’ */
export type FieldGroupToManyFutureDatumFilter = {
  /** Every related `FutureDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FutureDatumFilter>;
  /** No related `FutureDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FutureDatumFilter>;
  /** Some related `FutureDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FutureDatumFilter>;
};

/** A filter to be used against many `UserSystemField` object types. All fields are combined with a logical ‘and.’ */
export type FieldGroupToManyUserSystemFieldFilter = {
  /** Every related `UserSystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserSystemFieldFilter>;
  /** No related `UserSystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserSystemFieldFilter>;
  /** Some related `UserSystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserSystemFieldFilter>;
};

/** A connection to a list of `FieldGroup` values. */
export type FieldGroupsConnection = {
  __typename?: 'FieldGroupsConnection';
  /** A list of edges which contains the `FieldGroup` and cursor to aid in pagination. */
  edges: Array<FieldGroupsEdge>;
  /** A list of `FieldGroup` objects. */
  nodes: Array<Maybe<FieldGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FieldGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FieldGroup` edge in the connection. */
export type FieldGroupsEdge = {
  __typename?: 'FieldGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FieldGroup` at the end of the edge. */
  node?: Maybe<FieldGroup>;
};

/** Methods to use when ordering `FieldGroup`. */
export type FieldGroupsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPANY_SYSTEM_FIELDS_BY_FIELD_GROUP_ID__COUNT_ASC'
  | 'COMPANY_SYSTEM_FIELDS_BY_FIELD_GROUP_ID__COUNT_DESC'
  | 'CUSTOM_ID_ASC'
  | 'CUSTOM_ID_DESC'
  | 'FIELD_GROUP_CARDS_BY_FIELD_GROUP_ID__COUNT_ASC'
  | 'FIELD_GROUP_CARDS_BY_FIELD_GROUP_ID__COUNT_DESC'
  | 'FORM_FIELDS_BY_FIELD_GROUP_ID__COUNT_ASC'
  | 'FORM_FIELDS_BY_FIELD_GROUP_ID__COUNT_DESC'
  | 'FORM_FIELD_ENTRIES_BY_FIELD_GROUP_ID__COUNT_ASC'
  | 'FORM_FIELD_ENTRIES_BY_FIELD_GROUP_ID__COUNT_DESC'
  | 'FUTURE_DATA_BY_FIELD_GROUP_ID__COUNT_ASC'
  | 'FUTURE_DATA_BY_FIELD_GROUP_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALIZED_NAME_ASC'
  | 'LOCALIZED_NAME_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'USER_SYSTEM_FIELDS_BY_FIELD_GROUP_ID__COUNT_ASC'
  | 'USER_SYSTEM_FIELDS_BY_FIELD_GROUP_ID__COUNT_DESC';

export type FieldLogInput = {
  formFieldEntryId?: InputMaybe<Scalars['UUID']>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  type: FieldLogType;
  userId: Scalars['UUID'];
};

export type FieldLogType =
  | 'DEPARTMENTS'
  | 'EMPLOYEE_FIELD'
  | 'FORM_FIELD'
  | 'SYSTEM_FIELD';

export type FieldLogValue = {
  __typename?: 'FieldLogValue';
  action?: Maybe<LogAction>;
  context?: Maybe<LoggedActionContext>;
  creator?: Maybe<Scalars['JSON']>;
  date?: Maybe<Scalars['Datetime']>;
  id?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['JSON']>;
  value?: Maybe<Scalars['JSON']>;
};

export type FieldMapping = {
  externalFieldCreate: Scalars['String'];
  externalFieldUpdate: Scalars['String'];
  formFieldId: Scalars['UUID'];
};

export type FieldMappingOption = {
  __typename?: 'FieldMappingOption';
  fieldId?: Maybe<Scalars['UUID']>;
  fieldName?: Maybe<Scalars['String']>;
  fieldType?: Maybe<FieldType>;
};

export type FieldType =
  | 'FORM_FIELD'
  | 'NONE'
  | 'SYSTEM_FIELD';

export type FileDeleteInput = {
  id: Scalars['UUID'];
};

export type FileDeletePayload = {
  __typename?: 'FileDeletePayload';
  base64?: Maybe<Scalars['String']>;
  documentTypeId?: Maybe<Scalars['UUID']>;
  fileOwner?: Maybe<StorageFileOwner>;
  fileOwnerId?: Maybe<Scalars['UUID']>;
  fileType?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  mimetype?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
};

export type FileDownloadInput = {
  convertToPdf?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type FileDownloadPayload = {
  __typename?: 'FileDownloadPayload';
  base64?: Maybe<Scalars['String']>;
  documentTypeId?: Maybe<Scalars['UUID']>;
  fileExtension?: Maybe<Scalars['String']>;
  fileOwner?: Maybe<StorageFileOwner>;
  fileOwnerId?: Maybe<Scalars['UUID']>;
  fileType?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  mimetype?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
};

export type FileUpdateInput = {
  base64?: InputMaybe<Scalars['String']>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fileAccess?: InputMaybe<Scalars['String']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  mimetype?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
};

export type FileUpdatePayload = {
  __typename?: 'FileUpdatePayload';
  base64?: Maybe<Scalars['String']>;
  documentTypeId?: Maybe<Scalars['UUID']>;
  fileOwner?: Maybe<StorageFileOwner>;
  fileOwnerId?: Maybe<Scalars['UUID']>;
  fileType?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  mimetype?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
};

export type FileUploadInput = {
  base64?: InputMaybe<Scalars['String']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  fileAccess?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  mimetype?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  sendNotification?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

export type FileUploadLogoInput = {
  base64?: InputMaybe<Scalars['String']>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  filename?: InputMaybe<Scalars['String']>;
  mimetype?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
};

export type FileUploadPayload = {
  __typename?: 'FileUploadPayload';
  base64?: Maybe<Scalars['String']>;
  documentTypeId?: Maybe<Scalars['UUID']>;
  expireAt?: Maybe<Scalars['Datetime']>;
  fileOwner?: Maybe<StorageFileOwner>;
  fileOwnerId?: Maybe<Scalars['UUID']>;
  fileType?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  mimetype?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  remindAt?: Maybe<Scalars['Datetime']>;
};

export type FileUploadPublicInput = {
  base64?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  mimetype?: InputMaybe<Scalars['String']>;
};

export type FileUploadPublicPayload = {
  __typename?: 'FileUploadPublicPayload';
  filename?: Maybe<Scalars['String']>;
  mimetype?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type FilterPreset = {
  __typename?: 'FilterPreset';
  active: Scalars['Boolean'];
  columns: Scalars['JSON'];
  /** Reads a single `Company` that is related to this `FilterPreset`. */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['UUID']>;
  filters?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  miscellaneousFilters?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  tableName: Scalars['String'];
  /** Reads a single `User` that is related to this `FilterPreset`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

/** The `filterPreset` to be created by this mutation. */
export type FilterPresetCompanyIdForeignConnectionFilterPresetCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  columns: Scalars['JSON'];
  company?: InputMaybe<FilterPresetCompanyIdForeignInput>;
  filters?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  miscellaneousFilters?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  tableName: Scalars['String'];
  user?: InputMaybe<FilterPresetUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `FilterPresetInput` mutation. */
export type FilterPresetCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnFilterPresetForFilterPresetCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `filterPreset` in the `CompanyInput` mutation. */
export type FilterPresetCompanyIdForeignInverseInput = {
  /** The primary key(s) for `filterPreset` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FilterPresetFilterPresetPkeyConnect>>;
  /** A `FilterPresetInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FilterPresetCompanyIdForeignConnectionFilterPresetCreateInput>>;
  /** The primary key(s) and patch data for `filterPreset` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FilterPresetOnFilterPresetForFilterPresetCompanyIdForeignUsingFilterPresetPkeyUpdate>>;
};

/**
 * A condition to be used against `FilterPreset` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FilterPresetCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `columns` field. */
  columns?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `filters` field. */
  filters?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `miscellaneousFilters` field. */
  miscellaneousFilters?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `tableName` field. */
  tableName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `FilterPreset` object types. All fields are combined with a logical ‘and.’ */
export type FilterPresetFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FilterPresetFilter>>;
  /** Filter by the object’s `columns` field. */
  columns?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** A related `company` exists. */
  companyExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `filters` field. */
  filters?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `miscellaneousFilters` field. */
  miscellaneousFilters?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FilterPresetFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FilterPresetFilter>>;
  /** Filter by the object’s `tableName` field. */
  tableName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `filterPreset` to look up the row to connect. */
export type FilterPresetFilterPresetPkeyConnect = {
  id: Scalars['UUID'];
};

/** An input for mutations affecting `FilterPreset` */
export type FilterPresetInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  columns: Scalars['JSON'];
  company?: InputMaybe<FilterPresetCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  filters?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  miscellaneousFilters?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  tableName: Scalars['String'];
  user?: InputMaybe<FilterPresetUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `filterPreset` to look up the row to update. */
export type FilterPresetOnFilterPresetForFilterPresetCompanyIdForeignUsingFilterPresetPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `filterPreset` being updated. */
  patch: UpdateFilterPresetOnFilterPresetForFilterPresetCompanyIdForeignPatch;
};

/** The fields on `filterPreset` to look up the row to update. */
export type FilterPresetOnFilterPresetForFilterPresetUserIdForeignUsingFilterPresetPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `filterPreset` being updated. */
  patch: UpdateFilterPresetOnFilterPresetForFilterPresetUserIdForeignPatch;
};

/** Represents an update to a `FilterPreset`. Fields that are set will be updated. */
export type FilterPresetPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  columns?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<FilterPresetCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  filters?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  miscellaneousFilters?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  tableName?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<FilterPresetUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `filterPreset` to be created by this mutation. */
export type FilterPresetUserIdForeignConnectionFilterPresetCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  columns: Scalars['JSON'];
  company?: InputMaybe<FilterPresetCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  filters?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  miscellaneousFilters?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  tableName: Scalars['String'];
  user?: InputMaybe<FilterPresetUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `FilterPresetInput` mutation. */
export type FilterPresetUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnFilterPresetForFilterPresetUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `filterPreset` in the `UserInput` mutation. */
export type FilterPresetUserIdForeignInverseInput = {
  /** The primary key(s) for `filterPreset` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FilterPresetFilterPresetPkeyConnect>>;
  /** A `FilterPresetInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FilterPresetUserIdForeignConnectionFilterPresetCreateInput>>;
  /** The primary key(s) and patch data for `filterPreset` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FilterPresetOnFilterPresetForFilterPresetUserIdForeignUsingFilterPresetPkeyUpdate>>;
};

/** A connection to a list of `FilterPreset` values. */
export type FilterPresetsConnection = {
  __typename?: 'FilterPresetsConnection';
  /** A list of edges which contains the `FilterPreset` and cursor to aid in pagination. */
  edges: Array<FilterPresetsEdge>;
  /** A list of `FilterPreset` objects. */
  nodes: Array<Maybe<FilterPreset>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FilterPreset` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FilterPreset` edge in the connection. */
export type FilterPresetsEdge = {
  __typename?: 'FilterPresetsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FilterPreset` at the end of the edge. */
  node?: Maybe<FilterPreset>;
};

/** Methods to use when ordering `FilterPreset`. */
export type FilterPresetsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COLUMNS_ASC'
  | 'COLUMNS_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'FILTERS_ASC'
  | 'FILTERS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MISCELLANEOUS_FILTERS_ASC'
  | 'MISCELLANEOUS_FILTERS_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TABLE_NAME_ASC'
  | 'TABLE_NAME_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type FilterView = {
  __typename?: 'FilterView';
  filterViewData: Scalars['JSON'];
  filterViewName: Scalars['String'];
  id: Scalars['UUID'];
  tableName: Scalars['String'];
  /** Reads a single `User` that is related to this `FilterView`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/**
 * A condition to be used against `FilterView` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FilterViewCondition = {
  /** Checks for equality with the object’s `filterViewData` field. */
  filterViewData?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `filterViewName` field. */
  filterViewName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `tableName` field. */
  tableName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `FilterView` object types. All fields are combined with a logical ‘and.’ */
export type FilterViewFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FilterViewFilter>>;
  /** Filter by the object’s `filterViewName` field. */
  filterViewName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FilterViewFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FilterViewFilter>>;
  /** Filter by the object’s `tableName` field. */
  tableName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `filterView` to look up the row to connect. */
export type FilterViewFilterViewPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `filterView` to look up the row to delete. */
export type FilterViewFilterViewPkeyDelete = {
  id: Scalars['UUID'];
};

/** An input for mutations affecting `FilterView` */
export type FilterViewInput = {
  filterViewData?: InputMaybe<Scalars['JSON']>;
  filterViewName: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  tableName: Scalars['String'];
  user?: InputMaybe<FilterViewUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `filterView` to look up the row to update. */
export type FilterViewOnFilterViewForFilterViewUserIdFkeyUsingFilterViewPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `filterView` being updated. */
  patch: UpdateFilterViewOnFilterViewForFilterViewUserIdFkeyPatch;
};

/** Represents an update to a `FilterView`. Fields that are set will be updated. */
export type FilterViewPatch = {
  filterViewData?: InputMaybe<Scalars['JSON']>;
  filterViewName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  tableName?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<FilterViewUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `filterView` to be created by this mutation. */
export type FilterViewUserIdFkeyConnectionFilterViewCreateInput = {
  filterViewData?: InputMaybe<Scalars['JSON']>;
  filterViewName: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  tableName: Scalars['String'];
  user?: InputMaybe<FilterViewUserIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `FilterViewInput` mutation. */
export type FilterViewUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnFilterViewForFilterViewUserIdFkeyUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `filterView` in the `UserInput` mutation. */
export type FilterViewUserIdFkeyInverseInput = {
  /** The primary key(s) for `filterView` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FilterViewFilterViewPkeyConnect>>;
  /** A `FilterViewInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FilterViewUserIdFkeyConnectionFilterViewCreateInput>>;
  /** The primary key(s) for `filterView` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FilterViewFilterViewPkeyDelete>>;
  /** Flag indicating whether all other `filterView` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `filterView` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FilterViewOnFilterViewForFilterViewUserIdFkeyUsingFilterViewPkeyUpdate>>;
};

/** A connection to a list of `FilterView` values. */
export type FilterViewsConnection = {
  __typename?: 'FilterViewsConnection';
  /** A list of edges which contains the `FilterView` and cursor to aid in pagination. */
  edges: Array<FilterViewsEdge>;
  /** A list of `FilterView` objects. */
  nodes: Array<Maybe<FilterView>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FilterView` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FilterView` edge in the connection. */
export type FilterViewsEdge = {
  __typename?: 'FilterViewsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FilterView` at the end of the edge. */
  node?: Maybe<FilterView>;
};

/** Methods to use when ordering `FilterView`. */
export type FilterViewsOrderBy =
  | 'FILTER_VIEW_DATA_ASC'
  | 'FILTER_VIEW_DATA_DESC'
  | 'FILTER_VIEW_NAME_ASC'
  | 'FILTER_VIEW_NAME_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TABLE_NAME_ASC'
  | 'TABLE_NAME_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type FixBrokenContractInput = {
  contractSignPendingId: Scalars['UUID'];
};

/** A filter to be used against Float fields. All fields are combined with a logical ‘and.’ */
export type FloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Float']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Float']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Float']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Float']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Float']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Float']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Float']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

/** All input for the `formEntryTxtToTsvector` mutation. */
export type FormEntryTxtToTsvectorInput = {
  argId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

/** The output of our `formEntryTxtToTsvector` mutation. */
export type FormEntryTxtToTsvectorPayload = {
  __typename?: 'FormEntryTxtToTsvectorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type FormField = {
  __typename?: 'FormField';
  active: Scalars['Boolean'];
  agreementText?: Maybe<Scalars['String']>;
  approverFormFieldIds: Array<Maybe<Scalars['UUID']>>;
  /** Reads and enables pagination through a set of `FormField`. */
  approverFormFields: FormFieldsConnection;
  approverGroupIds: Array<Maybe<Scalars['UUID']>>;
  /** Reads and enables pagination through a set of `Group`. */
  approverGroups: GroupsConnection;
  approverSystemFieldIds: Array<Maybe<Scalars['UUID']>>;
  /** Reads and enables pagination through a set of `SystemField`. */
  approverSystemFields: SystemFieldsConnection;
  approverUserIds: Array<Maybe<Scalars['UUID']>>;
  /** Reads and enables pagination through a set of `User`. */
  approverUsers: UsersConnection;
  cardOrder?: Maybe<Scalars['Int']>;
  changesMustBeApproved: Scalars['Boolean'];
  companyId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `CompetenceFormField`. */
  competenceFormFields: CompetenceFormFieldsConnection;
  /** Reads and enables pagination through a set of `Competence`. */
  competencesByRatingFormFieldId: CompetencesConnection;
  contacts: FormFieldContactsConnection;
  /** Reads and enables pagination through a set of `ContractPredefinedPlaceholder`. */
  contractPredefinedPlaceholders: ContractPredefinedPlaceholdersConnection;
  createdAt: Scalars['Datetime'];
  customId?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `CvTemplateFieldMapping`. */
  cvTemplateFieldMappings: CvTemplateFieldMappingsConnection;
  /** Reads and enables pagination through a set of `DashboardCardStatistic`. */
  dashboardCardStatistics: DashboardCardStatisticsConnection;
  defaultValue?: Maybe<Scalars['String']>;
  departmentTypeIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `EngagementType` that is related to this `FormField`. */
  engagementType?: Maybe<EngagementType>;
  engagementTypeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Event` that is related to this `FormField`. */
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['UUID']>;
  excludedRoleIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `FieldGroup` that is related to this `FormField`. */
  fieldGroup?: Maybe<FieldGroup>;
  /** Reads a single `FieldGroupCardColumn` that is related to this `FormField`. */
  fieldGroupCardColumn?: Maybe<FieldGroupCardColumn>;
  fieldGroupCardColumnId?: Maybe<Scalars['UUID']>;
  fieldGroupId?: Maybe<Scalars['UUID']>;
  fieldType?: Maybe<Scalars['String']>;
  /** Reads a single `FormFieldAgreement` that is related to this `FormField`. */
  formFieldAgreementByFormFieldId?: Maybe<FormFieldAgreement>;
  /**
   * Reads and enables pagination through a set of `FormFieldAgreement`.
   * @deprecated Please use formFieldAgreementByFormFieldId instead
   */
  formFieldAgreements: FormFieldAgreementsConnection;
  /** Reads and enables pagination through a set of `FormFieldEntry`. */
  formFieldEntries: FormFieldEntriesConnection;
  /** Reads and enables pagination through a set of `FormFieldOption`. */
  formFieldOptions: FormFieldOptionsConnection;
  /** Reads and enables pagination through a set of `FormField`. */
  formFieldsByParentFormFieldId: FormFieldsConnection;
  /** Reads and enables pagination through a set of `FutureDatum`. */
  futureData: FutureDataConnection;
  helpText?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `IntegrationFieldMarking`. */
  integrationFieldMarkings: IntegrationFieldMarkingsConnection;
  localizedAgreementText?: Maybe<Scalars['String']>;
  localizedHelpText?: Maybe<Scalars['String']>;
  localizedName?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  multiple: Scalars['Boolean'];
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `NotificationCustomEmployeeFieldRecipient`. */
  notificationCustomEmployeeFieldRecipients: NotificationCustomEmployeeFieldRecipientsConnection;
  objectType: Scalars['String'];
  order: Scalars['Int'];
  /** Reads a single `FormField` that is related to this `FormField`. */
  parentFormField?: Maybe<FormField>;
  parentFormFieldId?: Maybe<Scalars['UUID']>;
  /** Parsed variables from metadata->descriptionText */
  parsedDescriptionText?: Maybe<Scalars['String']>;
  preboardingAssignedUserIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads and enables pagination through a set of `PreboardingSlideFormField`. */
  preboardingSlideFormFields: PreboardingSlideFormFieldsConnection;
  /** Reads and enables pagination through a set of `Preboarding`. */
  preboardingsByRecipientCustomEmployeeFieldId: PreboardingsConnection;
  productTypeIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads and enables pagination through a set of `RelationRole`. */
  relationRoles: RelationRolesConnection;
  required: Scalars['Boolean'];
  sensitive?: Maybe<Scalars['Boolean']>;
  supportsFutureData: Scalars['Boolean'];
  uniqueValue: Scalars['Boolean'];
  updatedAt: Scalars['Datetime'];
};


export type FormFieldApproverFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<FormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type FormFieldApproverGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type FormFieldApproverSystemFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<SystemFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type FormFieldApproverUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type FormFieldCompetenceFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompetenceFormFieldCondition>;
  filter?: InputMaybe<CompetenceFormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetenceFormFieldsOrderBy>>;
};


export type FormFieldCompetencesByRatingFormFieldIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompetenceCondition>;
  filter?: InputMaybe<CompetenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetencesOrderBy>>;
};


export type FormFieldContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<FormFieldContactsRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type FormFieldContractPredefinedPlaceholdersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractPredefinedPlaceholderCondition>;
  filter?: InputMaybe<ContractPredefinedPlaceholderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPredefinedPlaceholdersOrderBy>>;
};


export type FormFieldCvTemplateFieldMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CvTemplateFieldMappingCondition>;
  filter?: InputMaybe<CvTemplateFieldMappingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CvTemplateFieldMappingsOrderBy>>;
};


export type FormFieldDashboardCardStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DashboardCardStatisticCondition>;
  filter?: InputMaybe<DashboardCardStatisticFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DashboardCardStatisticsOrderBy>>;
};


export type FormFieldFormFieldAgreementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldAgreementCondition>;
  filter?: InputMaybe<FormFieldAgreementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldAgreementsOrderBy>>;
};


export type FormFieldFormFieldEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldEntryCondition>;
  filter?: InputMaybe<FormFieldEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldEntriesOrderBy>>;
};


export type FormFieldFormFieldOptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldOptionCondition>;
  filter?: InputMaybe<FormFieldOptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldOptionsOrderBy>>;
};


export type FormFieldFormFieldsByParentFormFieldIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldCondition>;
  filter?: InputMaybe<FormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldsOrderBy>>;
};


export type FormFieldFutureDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FutureDatumCondition>;
  filter?: InputMaybe<FutureDatumFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FutureDataOrderBy>>;
};


export type FormFieldIntegrationFieldMarkingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<IntegrationFieldMarkingCondition>;
  filter?: InputMaybe<IntegrationFieldMarkingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegrationFieldMarkingsOrderBy>>;
};


export type FormFieldNotificationCustomEmployeeFieldRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationCustomEmployeeFieldRecipientCondition>;
  filter?: InputMaybe<NotificationCustomEmployeeFieldRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientsOrderBy>>;
};


export type FormFieldParsedDescriptionTextArgs = {
  preboardingEmployeeId: Scalars['UUID'];
};


export type FormFieldPreboardingSlideFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingSlideFormFieldCondition>;
  filter?: InputMaybe<PreboardingSlideFormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingSlideFormFieldsOrderBy>>;
};


export type FormFieldPreboardingsByRecipientCustomEmployeeFieldIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingCondition>;
  filter?: InputMaybe<PreboardingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingsOrderBy>>;
};


export type FormFieldRelationRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RelationRoleCondition>;
  filter?: InputMaybe<RelationRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RelationRolesOrderBy>>;
};

export type FormFieldAgreement = {
  __typename?: 'FormFieldAgreement';
  /** Reads a single `TranslatedEntity` that is related to this `FormFieldAgreement`. */
  agreementTextTranslatedEntity?: Maybe<TranslatedEntity>;
  agreementTextTranslatedEntityId: Scalars['UUID'];
  /** Reads a single `Company` that is related to this `FormFieldAgreement`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `FormField` that is related to this `FormFieldAgreement`. */
  formField?: Maybe<FormField>;
  formFieldId: Scalars['UUID'];
  id: Scalars['UUID'];
};

/** The `formFieldAgreement` to be created by this mutation. */
export type FormFieldAgreementAgreementTextTranslatedEntityIdForeigConnectionFormFieldAgreementCreateInput = {
  company?: InputMaybe<FormFieldAgreementCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldAgreementFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInput>;
};

/** The `translatedEntity` to be created by this mutation. */
export type FormFieldAgreementAgreementTextTranslatedEntityIdForeigConnectionTranslatedEntityCreateInput = {
  company?: InputMaybe<TranslatedEntityCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldsToAliasTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldAliasTranslatedEntityIdForeignInverseInput>;
  companySystemFieldsToHelpTextTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  postTypes?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToHighestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToLowestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyLowestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToNameTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToQuestionTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyQuestionTranslatedEntityIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInverseInput>;
  timeRegistrationProjectsToDescriptionTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInverseInput>;
  timeRegistrationProjectsToNameTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInverseInput>;
};

/** Input for the nested mutation of `translatedEntity` in the `FormFieldAgreementInput` mutation. */
export type FormFieldAgreementAgreementTextTranslatedEntityIdForeigInput = {
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  connectById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyConnect>;
  /** A `TranslatedEntityInput` object that will be created and connected to this object. */
  create?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigConnectionTranslatedEntityCreateInput>;
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  deleteById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyDelete>;
  /** The primary key(s) and patch data for `translatedEntity` for the far side of the relationship. */
  updateById?: InputMaybe<TranslatedEntityOnFormFieldAgreementForFormFieldAgreementAgreementTextTranslatedEntityIdForeigUsingTranslatedEntityPkeyUpdate>;
};

/** Input for the nested mutation of `formFieldAgreement` in the `TranslatedEntityInput` mutation. */
export type FormFieldAgreementAgreementTextTranslatedEntityIdForeigInverseInput = {
  /** The primary key(s) for `formFieldAgreement` for the far side of the relationship. */
  connectByFormFieldId?: InputMaybe<Array<FormFieldAgreementFormFieldAgreementFormFieldIdUniqueConnect>>;
  /** The primary key(s) for `formFieldAgreement` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldAgreementFormFieldAgreementPkeyConnect>>;
  /** A `FormFieldAgreementInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldAgreementAgreementTextTranslatedEntityIdForeigConnectionFormFieldAgreementCreateInput>>;
  /** The primary key(s) for `formFieldAgreement` for the far side of the relationship. */
  deleteByFormFieldId?: InputMaybe<Array<FormFieldAgreementFormFieldAgreementFormFieldIdUniqueDelete>>;
  /** The primary key(s) for `formFieldAgreement` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FormFieldAgreementFormFieldAgreementPkeyDelete>>;
  /** Flag indicating whether all other `formFieldAgreement` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `formFieldAgreement` for the far side of the relationship. */
  updateByFormFieldId?: InputMaybe<Array<FormFieldAgreementOnFormFieldAgreementForFormFieldAgreementAgreementTextTranslatedEntityIdForeigUsingFormFieldAgreementFormFieldIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `formFieldAgreement` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldAgreementOnFormFieldAgreementForFormFieldAgreementAgreementTextTranslatedEntityIdForeigUsingFormFieldAgreementPkeyUpdate>>;
};

/** The `formFieldAgreement` to be created by this mutation. */
export type FormFieldAgreementCompanyIdForeignConnectionFormFieldAgreementCreateInput = {
  agreementTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<FormFieldAgreementCompanyIdForeignInput>;
  formField?: InputMaybe<FormFieldAgreementFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInput>;
};

/** Input for the nested mutation of `company` in the `FormFieldAgreementInput` mutation. */
export type FormFieldAgreementCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnFormFieldAgreementForFormFieldAgreementCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `formFieldAgreement` in the `CompanyInput` mutation. */
export type FormFieldAgreementCompanyIdForeignInverseInput = {
  /** The primary key(s) for `formFieldAgreement` for the far side of the relationship. */
  connectByFormFieldId?: InputMaybe<Array<FormFieldAgreementFormFieldAgreementFormFieldIdUniqueConnect>>;
  /** The primary key(s) for `formFieldAgreement` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldAgreementFormFieldAgreementPkeyConnect>>;
  /** A `FormFieldAgreementInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldAgreementCompanyIdForeignConnectionFormFieldAgreementCreateInput>>;
  /** The primary key(s) for `formFieldAgreement` for the far side of the relationship. */
  deleteByFormFieldId?: InputMaybe<Array<FormFieldAgreementFormFieldAgreementFormFieldIdUniqueDelete>>;
  /** The primary key(s) for `formFieldAgreement` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FormFieldAgreementFormFieldAgreementPkeyDelete>>;
  /** Flag indicating whether all other `formFieldAgreement` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `formFieldAgreement` for the far side of the relationship. */
  updateByFormFieldId?: InputMaybe<Array<FormFieldAgreementOnFormFieldAgreementForFormFieldAgreementCompanyIdForeignUsingFormFieldAgreementFormFieldIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `formFieldAgreement` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldAgreementOnFormFieldAgreementForFormFieldAgreementCompanyIdForeignUsingFormFieldAgreementPkeyUpdate>>;
};

/**
 * A condition to be used against `FormFieldAgreement` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FormFieldAgreementCondition = {
  /** Checks for equality with the object’s `agreementTextTranslatedEntityId` field. */
  agreementTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `FormFieldAgreement` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldAgreementFilter = {
  /** Filter by the object’s `agreementTextTranslatedEntity` relation. */
  agreementTextTranslatedEntity?: InputMaybe<TranslatedEntityFilter>;
  /** Filter by the object’s `agreementTextTranslatedEntityId` field. */
  agreementTextTranslatedEntityId?: InputMaybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FormFieldAgreementFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `formField` relation. */
  formField?: InputMaybe<FormFieldFilter>;
  /** Filter by the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FormFieldAgreementFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FormFieldAgreementFilter>>;
};

/** The fields on `formFieldAgreement` to look up the row to connect. */
export type FormFieldAgreementFormFieldAgreementFormFieldIdUniqueConnect = {
  formFieldId: Scalars['UUID'];
};

/** The fields on `formFieldAgreement` to look up the row to delete. */
export type FormFieldAgreementFormFieldAgreementFormFieldIdUniqueDelete = {
  formFieldId: Scalars['UUID'];
};

/** The fields on `formFieldAgreement` to look up the row to connect. */
export type FormFieldAgreementFormFieldAgreementPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `formFieldAgreement` to look up the row to delete. */
export type FormFieldAgreementFormFieldAgreementPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `formFieldAgreement` to be created by this mutation. */
export type FormFieldAgreementFormFieldIdForeignConnectionFormFieldAgreementCreateInput = {
  agreementTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<FormFieldAgreementCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldAgreementFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInput>;
};

/** The `formField` to be created by this mutation. */
export type FormFieldAgreementFormFieldIdForeignConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `formField` in the `FormFieldAgreementInput` mutation. */
export type FormFieldAgreementFormFieldIdForeignInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<FormFieldFormFieldPkeyConnect>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<FormFieldAgreementFormFieldIdForeignConnectionFormFieldCreateInput>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<FormFieldOnFormFieldAgreementForFormFieldAgreementFormFieldIdForeignUsingFormFieldPkeyUpdate>;
};

/** Input for the nested mutation of `formFieldAgreement` in the `FormFieldInput` mutation. */
export type FormFieldAgreementFormFieldIdForeignInverseInput = {
  /** The primary key(s) for `formFieldAgreement` for the far side of the relationship. */
  connectByFormFieldId?: InputMaybe<FormFieldAgreementFormFieldAgreementFormFieldIdUniqueConnect>;
  /** The primary key(s) for `formFieldAgreement` for the far side of the relationship. */
  connectById?: InputMaybe<FormFieldAgreementFormFieldAgreementPkeyConnect>;
  /** A `FormFieldAgreementInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldAgreementFormFieldIdForeignConnectionFormFieldAgreementCreateInput>>;
  /** The primary key(s) for `formFieldAgreement` for the far side of the relationship. */
  deleteByFormFieldId?: InputMaybe<FormFieldAgreementFormFieldAgreementFormFieldIdUniqueDelete>;
  /** The primary key(s) for `formFieldAgreement` for the far side of the relationship. */
  deleteById?: InputMaybe<FormFieldAgreementFormFieldAgreementPkeyDelete>;
  /** Flag indicating whether all other `formFieldAgreement` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `formFieldAgreement` for the far side of the relationship. */
  updateByFormFieldId?: InputMaybe<FormFieldAgreementOnFormFieldAgreementForFormFieldAgreementFormFieldIdForeignUsingFormFieldAgreementFormFieldIdUniqueUpdate>;
  /** The primary key(s) and patch data for `formFieldAgreement` for the far side of the relationship. */
  updateById?: InputMaybe<FormFieldAgreementOnFormFieldAgreementForFormFieldAgreementFormFieldIdForeignUsingFormFieldAgreementPkeyUpdate>;
};

/** An input for mutations affecting `FormFieldAgreement` */
export type FormFieldAgreementInput = {
  agreementTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<FormFieldAgreementCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldAgreementFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInput>;
};

/** The fields on `formFieldAgreement` to look up the row to update. */
export type FormFieldAgreementOnFormFieldAgreementForFormFieldAgreementAgreementTextTranslatedEntityIdForeigUsingFormFieldAgreementFormFieldIdUniqueUpdate = {
  formFieldId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldAgreement` being updated. */
  patch: UpdateFormFieldAgreementOnFormFieldAgreementForFormFieldAgreementAgreementTextTranslatedEntityIdForeigPatch;
};

/** The fields on `formFieldAgreement` to look up the row to update. */
export type FormFieldAgreementOnFormFieldAgreementForFormFieldAgreementAgreementTextTranslatedEntityIdForeigUsingFormFieldAgreementPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldAgreement` being updated. */
  patch: UpdateFormFieldAgreementOnFormFieldAgreementForFormFieldAgreementAgreementTextTranslatedEntityIdForeigPatch;
};

/** The fields on `formFieldAgreement` to look up the row to update. */
export type FormFieldAgreementOnFormFieldAgreementForFormFieldAgreementCompanyIdForeignUsingFormFieldAgreementFormFieldIdUniqueUpdate = {
  formFieldId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldAgreement` being updated. */
  patch: UpdateFormFieldAgreementOnFormFieldAgreementForFormFieldAgreementCompanyIdForeignPatch;
};

/** The fields on `formFieldAgreement` to look up the row to update. */
export type FormFieldAgreementOnFormFieldAgreementForFormFieldAgreementCompanyIdForeignUsingFormFieldAgreementPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldAgreement` being updated. */
  patch: UpdateFormFieldAgreementOnFormFieldAgreementForFormFieldAgreementCompanyIdForeignPatch;
};

/** The fields on `formFieldAgreement` to look up the row to update. */
export type FormFieldAgreementOnFormFieldAgreementForFormFieldAgreementFormFieldIdForeignUsingFormFieldAgreementFormFieldIdUniqueUpdate = {
  formFieldId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldAgreement` being updated. */
  patch: UpdateFormFieldAgreementOnFormFieldAgreementForFormFieldAgreementFormFieldIdForeignPatch;
};

/** The fields on `formFieldAgreement` to look up the row to update. */
export type FormFieldAgreementOnFormFieldAgreementForFormFieldAgreementFormFieldIdForeignUsingFormFieldAgreementPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldAgreement` being updated. */
  patch: UpdateFormFieldAgreementOnFormFieldAgreementForFormFieldAgreementFormFieldIdForeignPatch;
};

/** Represents an update to a `FormFieldAgreement`. Fields that are set will be updated. */
export type FormFieldAgreementPatch = {
  agreementTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<FormFieldAgreementCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldAgreementFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInput>;
};

/** A connection to a list of `FormFieldAgreement` values. */
export type FormFieldAgreementsConnection = {
  __typename?: 'FormFieldAgreementsConnection';
  /** A list of edges which contains the `FormFieldAgreement` and cursor to aid in pagination. */
  edges: Array<FormFieldAgreementsEdge>;
  /** A list of `FormFieldAgreement` objects. */
  nodes: Array<Maybe<FormFieldAgreement>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FormFieldAgreement` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FormFieldAgreement` edge in the connection. */
export type FormFieldAgreementsEdge = {
  __typename?: 'FormFieldAgreementsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FormFieldAgreement` at the end of the edge. */
  node?: Maybe<FormFieldAgreement>;
};

/** Methods to use when ordering `FormFieldAgreement`. */
export type FormFieldAgreementsOrderBy =
  | 'AGREEMENT_TEXT_TRANSLATED_ENTITY_ID_ASC'
  | 'AGREEMENT_TEXT_TRANSLATED_ENTITY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_DESC'
  | 'FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TRANSLATED_ENTITY_BY_AGREEMENT_TEXT_TRANSLATED_ENTITY_ID__COMPANY_ID_ASC'
  | 'TRANSLATED_ENTITY_BY_AGREEMENT_TEXT_TRANSLATED_ENTITY_ID__COMPANY_ID_DESC'
  | 'TRANSLATED_ENTITY_BY_AGREEMENT_TEXT_TRANSLATED_ENTITY_ID__ID_ASC'
  | 'TRANSLATED_ENTITY_BY_AGREEMENT_TEXT_TRANSLATED_ENTITY_ID__ID_DESC';

/**
 * A condition to be used against `FormField` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FormFieldCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `approverFormFieldIds` field. */
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `approverGroupIds` field. */
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `approverSystemFieldIds` field. */
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `approverUserIds` field. */
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `changesMustBeApproved` field. */
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `customId` field. */
  customId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `defaultValue` field. */
  defaultValue?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `departmentTypeIds` field. */
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `excludedRoleIds` field. */
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `fieldGroupCardColumnId` field. */
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fieldGroupId` field. */
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fieldType` field. */
  fieldType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `helpText` field. */
  helpText?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `localizedName` field. */
  localizedName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `multiple` field. */
  multiple?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `objectType` field. */
  objectType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `parentFormFieldId` field. */
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `preboardingAssignedUserIds` field. */
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `productTypeIds` field. */
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `required` field. */
  required?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `sensitive` field. */
  sensitive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `supportsFutureData` field. */
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `uniqueValue` field. */
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A `FormFieldContactsRecord` edge in the connection. */
export type FormFieldContactEdge = {
  __typename?: 'FormFieldContactEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FormFieldContactsRecord` at the end of the edge. */
  node?: Maybe<FormFieldContactsRecord>;
};

/** A connection to a list of `FormFieldContactsRecord` values. */
export type FormFieldContactsConnection = {
  __typename?: 'FormFieldContactsConnection';
  /** A list of edges which contains the `FormFieldContactsRecord` and cursor to aid in pagination. */
  edges: Array<FormFieldContactEdge>;
  /** A list of `FormFieldContactsRecord` objects. */
  nodes: Array<Maybe<FormFieldContactsRecord>>;
  /** The count of *all* `FormFieldContactsRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The return type of our `contacts` query. */
export type FormFieldContactsRecord = {
  __typename?: 'FormFieldContactsRecord';
  email?: Maybe<Scalars['String']>;
  emailWork?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  jobPositionTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  mobilePrivate?: Maybe<Scalars['String']>;
};

/** A filter to be used against `FormFieldContactsRecord` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldContactsRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FormFieldContactsRecordFilter>>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emailWork` field. */
  emailWork?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `jobPositionTitle` field. */
  jobPositionTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `logo` field. */
  logo?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mobile` field. */
  mobile?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mobilePrivate` field. */
  mobilePrivate?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FormFieldContactsRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FormFieldContactsRecordFilter>>;
};

/** The `engagementType` to be created by this mutation. */
export type FormFieldEngagementTypeIdForeignConnectionEngagementTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `formField` to be created by this mutation. */
export type FormFieldEngagementTypeIdForeignConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `engagementType` in the `FormFieldInput` mutation. */
export type FormFieldEngagementTypeIdForeignInput = {
  /** The primary key(s) for `engagementType` for the far side of the relationship. */
  connectById?: InputMaybe<EngagementTypeEngagementTypePkeyConnect>;
  /** A `EngagementTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<FormFieldEngagementTypeIdForeignConnectionEngagementTypeCreateInput>;
  /** The primary key(s) and patch data for `engagementType` for the far side of the relationship. */
  updateById?: InputMaybe<EngagementTypeOnFormFieldForFormFieldEngagementTypeIdForeignUsingEngagementTypePkeyUpdate>;
};

/** Input for the nested mutation of `formField` in the `EngagementTypeInput` mutation. */
export type FormFieldEngagementTypeIdForeignInverseInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldFormFieldPkeyConnect>>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldEngagementTypeIdForeignConnectionFormFieldCreateInput>>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldOnFormFieldForFormFieldEngagementTypeIdForeignUsingFormFieldPkeyUpdate>>;
};

/** A connection to a list of `FormFieldEntry` values. */
export type FormFieldEntriesConnection = {
  __typename?: 'FormFieldEntriesConnection';
  /** A list of edges which contains the `FormFieldEntry` and cursor to aid in pagination. */
  edges: Array<FormFieldEntriesEdge>;
  /** A list of `FormFieldEntry` objects. */
  nodes: Array<Maybe<FormFieldEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FormFieldEntry` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FormFieldEntry` edge in the connection. */
export type FormFieldEntriesEdge = {
  __typename?: 'FormFieldEntriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FormFieldEntry` at the end of the edge. */
  node?: Maybe<FormFieldEntry>;
};

/** Methods to use when ordering `FormFieldEntry`. */
export type FormFieldEntriesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'APPROVAL_IS_REQUIRED_ASC'
  | 'APPROVAL_IS_REQUIRED_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ACTIVE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ACTIVE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ADDRESS_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ADDRESS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ALIAS_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ALIAS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CITY_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CITY_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COMPANY_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COMPANY_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COUNTRY_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COUNTRY_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CREATED_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CREATED_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CUSTOM_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CUSTOM_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CVR_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CVR_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DELETE_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DELETE_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_NUMBER_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_NUMBER_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DESCRIPTION_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DESCRIPTION_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EAN_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EAN_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EMAIL_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EMAIL_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__MAIN_DEPARTMENT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__MAIN_DEPARTMENT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__NAME_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__NAME_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PHONE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PHONE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__POSTAL_CODE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__POSTAL_CODE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__P_NUMBER_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__P_NUMBER_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__UPDATED_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__UPDATED_AT_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__ACTIVE_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__ACTIVE_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__ADDRESS_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__ADDRESS_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__ALIAS_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__ALIAS_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__CITY_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__CITY_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__COMPANY_ID_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__COMPANY_ID_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__COUNTRY_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__COUNTRY_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__CREATED_AT_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__CREATED_AT_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__CUSTOM_ID_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__CUSTOM_ID_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__CVR_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__CVR_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__DELETE_AT_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__DELETE_AT_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__DEPARTMENT_NUMBER_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__DEPARTMENT_NUMBER_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__DESCRIPTION_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__DESCRIPTION_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__EAN_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__EAN_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__EMAIL_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__EMAIL_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__ID_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__ID_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__MAIN_DEPARTMENT_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__MAIN_DEPARTMENT_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__NAME_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__NAME_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__PHONE_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__PHONE_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__POSTAL_CODE_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__POSTAL_CODE_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__P_NUMBER_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__P_NUMBER_DESC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__UPDATED_AT_ASC'
  | 'DEPARTMENT_BY_PRODUCT_DEPARTMENT_ID__UPDATED_AT_DESC'
  | 'DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ACTIVE_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ACTIVE_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__COMPANY_ID_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__COMPANY_ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__CUSTOM_ID_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__CUSTOM_ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ID_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__LOCALIZED_NAME_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__LOCALIZED_NAME_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__NAME_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__NAME_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ORDER_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ORDER_DESC'
  | 'FIELD_GROUP_ID_ASC'
  | 'FIELD_GROUP_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_DESC'
  | 'FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_ID_DESC'
  | 'FORM_FIELD_OPTION_IDS_ASC'
  | 'FORM_FIELD_OPTION_IDS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'KEYWORDS_ASC'
  | 'KEYWORDS_DESC'
  | 'KEYWORDS_RANK_ASC'
  | 'KEYWORDS_RANK_DESC'
  | 'LEADER_DEPARTMENT_IDS_ASC'
  | 'LEADER_DEPARTMENT_IDS_DESC'
  | 'NATURAL'
  | 'OBJECT_TYPE_ASC'
  | 'OBJECT_TYPE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__ACQUISITION_DATE_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__ACQUISITION_DATE_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__ACTIVE_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__ACTIVE_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__ASSIGNED_USER_DEPARTMENTS_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__ASSIGNED_USER_DEPARTMENTS_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__ASSIGNED_USER_ID_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__ASSIGNED_USER_ID_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__COMPANY_ID_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__COMPANY_ID_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__CREATED_AT_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__CREATED_AT_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__DEPARTMENT_ID_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__DEPARTMENT_ID_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__DESCRIPTION_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__DESCRIPTION_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__ID_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__ID_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__NAME_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__NAME_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__OCCUPIED_BY_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__OCCUPIED_BY_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__PRODUCT_TYPE_ID_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__PRODUCT_TYPE_ID_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__PURCHASE_DATE_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__PURCHASE_DATE_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__SEARCH_TERMS_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__SEARCH_TERMS_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__SERIAL_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__SERIAL_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__UPDATED_AT_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__UPDATED_AT_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__USER_ID_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__USER_ID_DESC'
  | 'PRODUCT_DEPARTMENT_ID_ASC'
  | 'PRODUCT_DEPARTMENT_ID_DESC'
  | 'PRODUCT_ID_ASC'
  | 'PRODUCT_ID_DESC'
  | 'PRODUCT_USER_ID_ASC'
  | 'PRODUCT_USER_ID_DESC'
  | 'SENSITIVE_ASC'
  | 'SENSITIVE_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'USER_BY_PRODUCT_USER_ID__ACTIVE_ASC'
  | 'USER_BY_PRODUCT_USER_ID__ACTIVE_DESC'
  | 'USER_BY_PRODUCT_USER_ID__ADDRESS_ASC'
  | 'USER_BY_PRODUCT_USER_ID__ADDRESS_DESC'
  | 'USER_BY_PRODUCT_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_PRODUCT_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_PRODUCT_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_PRODUCT_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_PRODUCT_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_PRODUCT_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_PRODUCT_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_PRODUCT_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_PRODUCT_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_PRODUCT_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_PRODUCT_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_PRODUCT_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_PRODUCT_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_PRODUCT_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_PRODUCT_USER_ID__CITY_ASC'
  | 'USER_BY_PRODUCT_USER_ID__CITY_DESC'
  | 'USER_BY_PRODUCT_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_PRODUCT_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_PRODUCT_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_PRODUCT_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_PRODUCT_USER_ID__CPR_ASC'
  | 'USER_BY_PRODUCT_USER_ID__CPR_DESC'
  | 'USER_BY_PRODUCT_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_PRODUCT_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_PRODUCT_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_PRODUCT_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_PRODUCT_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_PRODUCT_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_PRODUCT_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_PRODUCT_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_PRODUCT_USER_ID__EMAIL_ASC'
  | 'USER_BY_PRODUCT_USER_ID__EMAIL_DESC'
  | 'USER_BY_PRODUCT_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_PRODUCT_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_PRODUCT_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_PRODUCT_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_PRODUCT_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_PRODUCT_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_PRODUCT_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_PRODUCT_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_PRODUCT_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_PRODUCT_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_PRODUCT_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_PRODUCT_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_PRODUCT_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_PRODUCT_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_PRODUCT_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_PRODUCT_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_PRODUCT_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_PRODUCT_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_PRODUCT_USER_ID__GODMODE_ASC'
  | 'USER_BY_PRODUCT_USER_ID__GODMODE_DESC'
  | 'USER_BY_PRODUCT_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_PRODUCT_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_PRODUCT_USER_ID__ID_ASC'
  | 'USER_BY_PRODUCT_USER_ID__ID_DESC'
  | 'USER_BY_PRODUCT_USER_ID__INITIALS_ASC'
  | 'USER_BY_PRODUCT_USER_ID__INITIALS_DESC'
  | 'USER_BY_PRODUCT_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_PRODUCT_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_PRODUCT_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_PRODUCT_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_PRODUCT_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_PRODUCT_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_PRODUCT_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_PRODUCT_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_PRODUCT_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_PRODUCT_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_PRODUCT_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_PRODUCT_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_PRODUCT_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_PRODUCT_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_PRODUCT_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_PRODUCT_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_PRODUCT_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_PRODUCT_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_PRODUCT_USER_ID__MOBILE_ASC'
  | 'USER_BY_PRODUCT_USER_ID__MOBILE_DESC'
  | 'USER_BY_PRODUCT_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_PRODUCT_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_PRODUCT_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_PRODUCT_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_PRODUCT_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_PRODUCT_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_PRODUCT_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_PRODUCT_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_PRODUCT_USER_ID__PHONE_ASC'
  | 'USER_BY_PRODUCT_USER_ID__PHONE_DESC'
  | 'USER_BY_PRODUCT_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_PRODUCT_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_PRODUCT_USER_ID__SENIORITY_ASC'
  | 'USER_BY_PRODUCT_USER_ID__SENIORITY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__ACTIVE_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__ACTIVE_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__COMPANY_ID_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__COMPANY_ID_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__DEPARTMENT_IDS_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__DEPARTMENT_IDS_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__EVALUATING_USER_ID_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__EVALUATING_USER_ID_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__EVALUATION_DATE_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__EVALUATION_DATE_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__ID_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__ID_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__NEXT_UPDATE_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__NEXT_UPDATE_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__REMINDED_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__REMINDED_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__USER_COMPETENCE_ID_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__USER_COMPETENCE_ID_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__USER_ID_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__USER_ID_DESC'
  | 'USER_COMPETENCE_EVALUATION_ID_ASC'
  | 'USER_COMPETENCE_EVALUATION_ID_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC'
  | 'VALUE_ASC'
  | 'VALUE_DESC';

export type FormFieldEntry = {
  __typename?: 'FormFieldEntry';
  active: Scalars['Boolean'];
  approvalIsRequired: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `FormFieldEntry`. */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['Datetime'];
  /** Reads a single `Department` that is related to this `FormFieldEntry`. */
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['UUID']>;
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Employee` that is related to this `FormFieldEntry`. */
  employee?: Maybe<Employee>;
  employeeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `FieldGroup` that is related to this `FormFieldEntry`. */
  fieldGroup?: Maybe<FieldGroup>;
  fieldGroupId?: Maybe<Scalars['UUID']>;
  /** Reads a single `FormField` that is related to this `FormFieldEntry`. */
  formField?: Maybe<FormField>;
  formFieldId: Scalars['UUID'];
  formFieldOptionIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads and enables pagination through a set of `FutureDatum`. */
  futureData: FutureDataConnection;
  humanReadableValue?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  keywords?: Maybe<Scalars['FullText']>;
  /** Full-text search ranking when filtered by `keywords`. */
  keywordsRank?: Maybe<Scalars['Float']>;
  leaderDepartmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  numericValue?: Maybe<Scalars['BigFloat']>;
  objectType?: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `FormFieldEntry`. */
  product?: Maybe<Product>;
  /** Reads a single `Department` that is related to this `FormFieldEntry`. */
  productDepartment?: Maybe<Department>;
  productDepartmentId?: Maybe<Scalars['UUID']>;
  productId?: Maybe<Scalars['UUID']>;
  /** Reads a single `User` that is related to this `FormFieldEntry`. */
  productUser?: Maybe<User>;
  productUserId?: Maybe<Scalars['UUID']>;
  sensitive?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `FormFieldEntry`. */
  user?: Maybe<User>;
  /** Reads a single `UserCompetenceEvaluation` that is related to this `FormFieldEntry`. */
  userCompetenceEvaluation?: Maybe<UserCompetenceEvaluation>;
  userCompetenceEvaluationId?: Maybe<Scalars['UUID']>;
  userId?: Maybe<Scalars['UUID']>;
  value?: Maybe<Scalars['String']>;
};


export type FormFieldEntryFutureDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<FutureDatumFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FutureDataOrderBy>>;
};

/** The `formFieldEntry` to be created by this mutation. */
export type FormFieldEntryCompanyIdFkeyConnectionFormFieldEntryCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `company` in the `FormFieldEntryInput` mutation. */
export type FormFieldEntryCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnFormFieldEntryForFormFieldEntryCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `formFieldEntry` in the `CompanyInput` mutation. */
export type FormFieldEntryCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `formFieldEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldEntryFormFieldEntryPkeyConnect>>;
  /** A `FormFieldEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldEntryCompanyIdFkeyConnectionFormFieldEntryCreateInput>>;
  /** The primary key(s) and patch data for `formFieldEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldEntryOnFormFieldEntryForFormFieldEntryCompanyIdFkeyUsingFormFieldEntryPkeyUpdate>>;
};

/**
 * A condition to be used against `FormFieldEntry` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FormFieldEntryCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `approvalIsRequired` field. */
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departmentId` field. */
  departmentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fieldGroupId` field. */
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `formFieldOptionIds` field. */
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `keywords` field. */
  keywords?: InputMaybe<Scalars['FullText']>;
  /** Checks for equality with the object’s `leaderDepartmentIds` field. */
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `objectType` field. */
  objectType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `productDepartmentId` field. */
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `productUserId` field. */
  productUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `sensitive` field. */
  sensitive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userCompetenceEvaluationId` field. */
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `FormFieldEntryCountRecord` values. */
export type FormFieldEntryCountConnection = {
  __typename?: 'FormFieldEntryCountConnection';
  /** A list of edges which contains the `FormFieldEntryCountRecord` and cursor to aid in pagination. */
  edges: Array<FormFieldEntryCountEdge>;
  /** A list of `FormFieldEntryCountRecord` objects. */
  nodes: Array<Maybe<FormFieldEntryCountRecord>>;
  /** The count of *all* `FormFieldEntryCountRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FormFieldEntryCountRecord` edge in the connection. */
export type FormFieldEntryCountEdge = {
  __typename?: 'FormFieldEntryCountEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FormFieldEntryCountRecord` at the end of the edge. */
  node?: Maybe<FormFieldEntryCountRecord>;
};

/** The return type of our `formFieldEntryCount` query. */
export type FormFieldEntryCountRecord = {
  __typename?: 'FormFieldEntryCountRecord';
  count?: Maybe<Scalars['BigInt']>;
  value?: Maybe<Scalars['UUID']>;
};

/** A filter to be used against `FormFieldEntryCountRecord` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldEntryCountRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FormFieldEntryCountRecordFilter>>;
  /** Filter by the object’s `count` field. */
  count?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FormFieldEntryCountRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FormFieldEntryCountRecordFilter>>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<UuidFilter>;
};

/** The `department` to be created by this mutation. */
export type FormFieldEntryDepartmentIdForeignConnectionDepartmentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** The `formFieldEntry` to be created by this mutation. */
export type FormFieldEntryDepartmentIdForeignConnectionFormFieldEntryCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `department` in the `FormFieldEntryInput` mutation. */
export type FormFieldEntryDepartmentIdForeignInput = {
  /** The primary key(s) for `department` for the far side of the relationship. */
  connectById?: InputMaybe<DepartmentDepartmentPkeyConnect>;
  /** A `DepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<FormFieldEntryDepartmentIdForeignConnectionDepartmentCreateInput>;
  /** The primary key(s) and patch data for `department` for the far side of the relationship. */
  updateById?: InputMaybe<DepartmentOnFormFieldEntryForFormFieldEntryDepartmentIdForeignUsingDepartmentPkeyUpdate>;
};

/** Input for the nested mutation of `formFieldEntry` in the `DepartmentInput` mutation. */
export type FormFieldEntryDepartmentIdForeignInverseInput = {
  /** The primary key(s) for `formFieldEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldEntryFormFieldEntryPkeyConnect>>;
  /** A `FormFieldEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldEntryDepartmentIdForeignConnectionFormFieldEntryCreateInput>>;
  /** The primary key(s) and patch data for `formFieldEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldEntryOnFormFieldEntryForFormFieldEntryDepartmentIdForeignUsingFormFieldEntryPkeyUpdate>>;
};

/** The `formFieldEntry` to be created by this mutation. */
export type FormFieldEntryEmployeeIdForeignConnectionFormFieldEntryCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `employee` in the `FormFieldEntryInput` mutation. */
export type FormFieldEntryEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnFormFieldEntryForFormFieldEntryEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnFormFieldEntryForFormFieldEntryEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `formFieldEntry` in the `EmployeeInput` mutation. */
export type FormFieldEntryEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `formFieldEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldEntryFormFieldEntryPkeyConnect>>;
  /** A `FormFieldEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldEntryEmployeeIdForeignConnectionFormFieldEntryCreateInput>>;
  /** The primary key(s) and patch data for `formFieldEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldEntryOnFormFieldEntryForFormFieldEntryEmployeeIdForeignUsingFormFieldEntryPkeyUpdate>>;
};

/** The `fieldGroup` to be created by this mutation. */
export type FormFieldEntryFieldGroupIdForeignConnectionFieldGroupCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  fieldGroupCards?: InputMaybe<FieldGroupCardFieldGroupIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFieldGroupIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldFormFieldTypeIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFieldGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  userSystemFields?: InputMaybe<UserSystemFieldFieldGroupIdForeignInverseInput>;
};

/** The `formFieldEntry` to be created by this mutation. */
export type FormFieldEntryFieldGroupIdForeignConnectionFormFieldEntryCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `fieldGroup` in the `FormFieldEntryInput` mutation. */
export type FormFieldEntryFieldGroupIdForeignInput = {
  /** The primary key(s) for `fieldGroup` for the far side of the relationship. */
  connectById?: InputMaybe<FieldGroupFormFieldTypePkeyConnect>;
  /** A `FieldGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<FormFieldEntryFieldGroupIdForeignConnectionFieldGroupCreateInput>;
  /** The primary key(s) and patch data for `fieldGroup` for the far side of the relationship. */
  updateById?: InputMaybe<FieldGroupOnFormFieldEntryForFormFieldEntryFieldGroupIdForeignUsingFormFieldTypePkeyUpdate>;
};

/** Input for the nested mutation of `formFieldEntry` in the `FieldGroupInput` mutation. */
export type FormFieldEntryFieldGroupIdForeignInverseInput = {
  /** The primary key(s) for `formFieldEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldEntryFormFieldEntryPkeyConnect>>;
  /** A `FormFieldEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldEntryFieldGroupIdForeignConnectionFormFieldEntryCreateInput>>;
  /** The primary key(s) and patch data for `formFieldEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldEntryOnFormFieldEntryForFormFieldEntryFieldGroupIdForeignUsingFormFieldEntryPkeyUpdate>>;
};

/** A filter to be used against `FormFieldEntry` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldEntryFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FormFieldEntryFilter>>;
  /** Filter by the object’s `approvalIsRequired` field. */
  approvalIsRequired?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** A related `company` exists. */
  companyExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `department` relation. */
  department?: InputMaybe<DepartmentFilter>;
  /** A related `department` exists. */
  departmentExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `departmentId` field. */
  departmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** A related `employee` exists. */
  employeeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fieldGroup` relation. */
  fieldGroup?: InputMaybe<FieldGroupFilter>;
  /** A related `fieldGroup` exists. */
  fieldGroupExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `fieldGroupId` field. */
  fieldGroupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `formField` relation. */
  formField?: InputMaybe<FormFieldFilter>;
  /** Filter by the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `formFieldOptionIds` field. */
  formFieldOptionIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `keywords` field. */
  keywords?: InputMaybe<FullTextFilter>;
  /** Filter by the object’s `leaderDepartmentIds` field. */
  leaderDepartmentIds?: InputMaybe<UuidListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FormFieldEntryFilter>;
  /** Filter by the object’s `numericValue` field. */
  numericValue?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `objectType` field. */
  objectType?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FormFieldEntryFilter>>;
  /** Filter by the object’s `product` relation. */
  product?: InputMaybe<ProductFilter>;
  /** Filter by the object’s `productDepartment` relation. */
  productDepartment?: InputMaybe<DepartmentFilter>;
  /** A related `productDepartment` exists. */
  productDepartmentExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `productDepartmentId` field. */
  productDepartmentId?: InputMaybe<UuidFilter>;
  /** A related `product` exists. */
  productExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `productUser` relation. */
  productUser?: InputMaybe<UserFilter>;
  /** A related `productUser` exists. */
  productUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `productUserId` field. */
  productUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `sensitive` field. */
  sensitive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userCompetenceEvaluation` relation. */
  userCompetenceEvaluation?: InputMaybe<UserCompetenceEvaluationFilter>;
  /** A related `userCompetenceEvaluation` exists. */
  userCompetenceEvaluationExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userCompetenceEvaluationId` field. */
  userCompetenceEvaluationId?: InputMaybe<UuidFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** The fields on `formFieldEntry` to look up the row to connect. */
export type FormFieldEntryFormFieldEntryPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `formField` to be created by this mutation. */
export type FormFieldEntryFormFieldIdForeignConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `formFieldEntry` to be created by this mutation. */
export type FormFieldEntryFormFieldIdForeignConnectionFormFieldEntryCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `formField` in the `FormFieldEntryInput` mutation. */
export type FormFieldEntryFormFieldIdForeignInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<FormFieldFormFieldPkeyConnect>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<FormFieldEntryFormFieldIdForeignConnectionFormFieldCreateInput>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<FormFieldOnFormFieldEntryForFormFieldEntryFormFieldIdForeignUsingFormFieldPkeyUpdate>;
};

/** Input for the nested mutation of `formFieldEntry` in the `FormFieldInput` mutation. */
export type FormFieldEntryFormFieldIdForeignInverseInput = {
  /** The primary key(s) for `formFieldEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldEntryFormFieldEntryPkeyConnect>>;
  /** A `FormFieldEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldEntryFormFieldIdForeignConnectionFormFieldEntryCreateInput>>;
  /** The primary key(s) and patch data for `formFieldEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldEntryOnFormFieldEntryForFormFieldEntryFormFieldIdForeignUsingFormFieldEntryPkeyUpdate>>;
};

/** An input for mutations affecting `FormFieldEntry` */
export type FormFieldEntryInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The fields on `formFieldEntry` to look up the row to update. */
export type FormFieldEntryOnFormFieldEntryForFormFieldEntryCompanyIdFkeyUsingFormFieldEntryPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldEntry` being updated. */
  patch: UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryCompanyIdFkeyPatch;
};

/** The fields on `formFieldEntry` to look up the row to update. */
export type FormFieldEntryOnFormFieldEntryForFormFieldEntryDepartmentIdForeignUsingFormFieldEntryPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldEntry` being updated. */
  patch: UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryDepartmentIdForeignPatch;
};

/** The fields on `formFieldEntry` to look up the row to update. */
export type FormFieldEntryOnFormFieldEntryForFormFieldEntryEmployeeIdForeignUsingFormFieldEntryPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldEntry` being updated. */
  patch: UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryEmployeeIdForeignPatch;
};

/** The fields on `formFieldEntry` to look up the row to update. */
export type FormFieldEntryOnFormFieldEntryForFormFieldEntryFieldGroupIdForeignUsingFormFieldEntryPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldEntry` being updated. */
  patch: UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryFieldGroupIdForeignPatch;
};

/** The fields on `formFieldEntry` to look up the row to update. */
export type FormFieldEntryOnFormFieldEntryForFormFieldEntryFormFieldIdForeignUsingFormFieldEntryPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldEntry` being updated. */
  patch: UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryFormFieldIdForeignPatch;
};

/** The fields on `formFieldEntry` to look up the row to update. */
export type FormFieldEntryOnFormFieldEntryForFormFieldEntryProductDepartmentIdForeignUsingFormFieldEntryPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldEntry` being updated. */
  patch: UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryProductDepartmentIdForeignPatch;
};

/** The fields on `formFieldEntry` to look up the row to update. */
export type FormFieldEntryOnFormFieldEntryForFormFieldEntryProductIdForeignUsingFormFieldEntryPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldEntry` being updated. */
  patch: UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryProductIdForeignPatch;
};

/** The fields on `formFieldEntry` to look up the row to update. */
export type FormFieldEntryOnFormFieldEntryForFormFieldEntryProductUserIdForeignUsingFormFieldEntryPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldEntry` being updated. */
  patch: UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryProductUserIdForeignPatch;
};

/** The fields on `formFieldEntry` to look up the row to update. */
export type FormFieldEntryOnFormFieldEntryForFormFieldEntryUserCompetenceEvaluationIdForeignUsingFormFieldEntryPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldEntry` being updated. */
  patch: UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryUserCompetenceEvaluationIdForeignPatch;
};

/** The fields on `formFieldEntry` to look up the row to update. */
export type FormFieldEntryOnFormFieldEntryForFormFieldEntryUserIdFkeyUsingFormFieldEntryPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldEntry` being updated. */
  patch: UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryUserIdFkeyPatch;
};

/** Represents an update to a `FormFieldEntry`. Fields that are set will be updated. */
export type FormFieldEntryPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The `formFieldEntry` to be created by this mutation. */
export type FormFieldEntryProductDepartmentIdForeignConnectionFormFieldEntryCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `formFieldEntry` in the `DepartmentInput` mutation. */
export type FormFieldEntryProductDepartmentIdForeignInverseInput = {
  /** The primary key(s) for `formFieldEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldEntryFormFieldEntryPkeyConnect>>;
  /** A `FormFieldEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldEntryProductDepartmentIdForeignConnectionFormFieldEntryCreateInput>>;
  /** The primary key(s) and patch data for `formFieldEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldEntryOnFormFieldEntryForFormFieldEntryProductDepartmentIdForeignUsingFormFieldEntryPkeyUpdate>>;
};

/** The `formFieldEntry` to be created by this mutation. */
export type FormFieldEntryProductIdForeignConnectionFormFieldEntryCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The `product` to be created by this mutation. */
export type FormFieldEntryProductIdForeignConnectionProductCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ProductDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<EquipmentProductIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInverseInput>;
  productType?: InputMaybe<ProductProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  searchTerms?: InputMaybe<Scalars['FullText']>;
  serial?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProductAssignedUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `product` in the `FormFieldEntryInput` mutation. */
export type FormFieldEntryProductIdForeignInput = {
  /** The primary key(s) for `product` for the far side of the relationship. */
  connectById?: InputMaybe<ProductProductPkeyConnect>;
  /** A `ProductInput` object that will be created and connected to this object. */
  create?: InputMaybe<FormFieldEntryProductIdForeignConnectionProductCreateInput>;
  /** The primary key(s) and patch data for `product` for the far side of the relationship. */
  updateById?: InputMaybe<ProductOnFormFieldEntryForFormFieldEntryProductIdForeignUsingProductPkeyUpdate>;
};

/** Input for the nested mutation of `formFieldEntry` in the `ProductInput` mutation. */
export type FormFieldEntryProductIdForeignInverseInput = {
  /** The primary key(s) for `formFieldEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldEntryFormFieldEntryPkeyConnect>>;
  /** A `FormFieldEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldEntryProductIdForeignConnectionFormFieldEntryCreateInput>>;
  /** The primary key(s) and patch data for `formFieldEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldEntryOnFormFieldEntryForFormFieldEntryProductIdForeignUsingFormFieldEntryPkeyUpdate>>;
};

/** Input for the nested mutation of `productType` in the `FormFieldEntryInput` mutation. */
export type FormFieldEntryProductTypeIdForeignInput = {
  /** The primary key(s) for `productType` for the far side of the relationship. */
  connectByCompanyIdAndDepartmentIdAndName?: InputMaybe<ProductTypeProductTypeCompanyIdDepartmentIdNameUniqueConnect>;
  /** The primary key(s) for `productType` for the far side of the relationship. */
  connectById?: InputMaybe<ProductTypeProductTypePkeyConnect>;
};

/** Input for the nested mutation of `formFieldEntry` in the `ProductTypeInput` mutation. */
export type FormFieldEntryProductTypeIdForeignInverseInput = {
  /** The primary key(s) for `formFieldEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldEntryFormFieldEntryPkeyConnect>>;
};

/** The `formFieldEntry` to be created by this mutation. */
export type FormFieldEntryProductUserIdForeignConnectionFormFieldEntryCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `user` in the `FormFieldEntryInput` mutation. */
export type FormFieldEntryProductUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnFormFieldEntryForFormFieldEntryProductUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `formFieldEntry` in the `UserInput` mutation. */
export type FormFieldEntryProductUserIdForeignInverseInput = {
  /** The primary key(s) for `formFieldEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldEntryFormFieldEntryPkeyConnect>>;
  /** A `FormFieldEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldEntryProductUserIdForeignConnectionFormFieldEntryCreateInput>>;
  /** The primary key(s) and patch data for `formFieldEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldEntryOnFormFieldEntryForFormFieldEntryProductUserIdForeignUsingFormFieldEntryPkeyUpdate>>;
};

/** The `formFieldEntry` to be created by this mutation. */
export type FormFieldEntryUserCompetenceEvaluationIdForeignConnectionFormFieldEntryCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The `userCompetenceEvaluation` to be created by this mutation. */
export type FormFieldEntryUserCompetenceEvaluationIdForeignConnectionUserCompetenceEvaluationCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  evaluatingUserId?: InputMaybe<Scalars['UUID']>;
  evaluationDate?: InputMaybe<Scalars['Datetime']>;
  formFieldEntries?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  nextUpdate?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInput>;
  userCompetence?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInverseInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
};

/** Input for the nested mutation of `userCompetenceEvaluation` in the `FormFieldEntryInput` mutation. */
export type FormFieldEntryUserCompetenceEvaluationIdForeignInput = {
  /** The primary key(s) for `userCompetenceEvaluation` for the far side of the relationship. */
  connectById?: InputMaybe<UserCompetenceEvaluationUserCompetenceEvaluationPkeyConnect>;
  /** A `UserCompetenceEvaluationInput` object that will be created and connected to this object. */
  create?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignConnectionUserCompetenceEvaluationCreateInput>;
  /** The primary key(s) and patch data for `userCompetenceEvaluation` for the far side of the relationship. */
  updateById?: InputMaybe<UserCompetenceEvaluationOnFormFieldEntryForFormFieldEntryUserCompetenceEvaluationIdForeignUsingUserCompetenceEvaluationPkeyUpdate>;
};

/** Input for the nested mutation of `formFieldEntry` in the `UserCompetenceEvaluationInput` mutation. */
export type FormFieldEntryUserCompetenceEvaluationIdForeignInverseInput = {
  /** The primary key(s) for `formFieldEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldEntryFormFieldEntryPkeyConnect>>;
  /** A `FormFieldEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldEntryUserCompetenceEvaluationIdForeignConnectionFormFieldEntryCreateInput>>;
  /** The primary key(s) and patch data for `formFieldEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldEntryOnFormFieldEntryForFormFieldEntryUserCompetenceEvaluationIdForeignUsingFormFieldEntryPkeyUpdate>>;
};

/** The `formFieldEntry` to be created by this mutation. */
export type FormFieldEntryUserIdFkeyConnectionFormFieldEntryCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `formFieldEntry` in the `UserInput` mutation. */
export type FormFieldEntryUserIdFkeyInverseInput = {
  /** The primary key(s) for `formFieldEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldEntryFormFieldEntryPkeyConnect>>;
  /** A `FormFieldEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldEntryUserIdFkeyConnectionFormFieldEntryCreateInput>>;
  /** The primary key(s) and patch data for `formFieldEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldEntryOnFormFieldEntryForFormFieldEntryUserIdFkeyUsingFormFieldEntryPkeyUpdate>>;
};

/** The `event` to be created by this mutation. */
export type FormFieldEventIdForeignConnectionEventCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EventCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contactPersonIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  description: Scalars['String'];
  endDate?: InputMaybe<Scalars['Datetime']>;
  eventUsers?: InputMaybe<EventUserEventIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEventIdForeignInverseInput>;
  geography?: InputMaybe<PointInput>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  location: Scalars['String'];
  name: Scalars['String'];
  organizerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  startDate: Scalars['Datetime'];
};

/** The `formField` to be created by this mutation. */
export type FormFieldEventIdForeignConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `event` in the `FormFieldInput` mutation. */
export type FormFieldEventIdForeignInput = {
  /** The primary key(s) for `event` for the far side of the relationship. */
  connectById?: InputMaybe<EventEventPkeyConnect>;
  /** A `EventInput` object that will be created and connected to this object. */
  create?: InputMaybe<FormFieldEventIdForeignConnectionEventCreateInput>;
  /** The primary key(s) and patch data for `event` for the far side of the relationship. */
  updateById?: InputMaybe<EventOnFormFieldForFormFieldEventIdForeignUsingEventPkeyUpdate>;
};

/** Input for the nested mutation of `formField` in the `EventInput` mutation. */
export type FormFieldEventIdForeignInverseInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldFormFieldPkeyConnect>>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldEventIdForeignConnectionFormFieldCreateInput>>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldOnFormFieldForFormFieldEventIdForeignUsingFormFieldPkeyUpdate>>;
};

/** The `fieldGroupCardColumn` to be created by this mutation. */
export type FormFieldFieldGroupCardColumnIdForeignConnectionFieldGroupCardColumnCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  fieldGroupCard?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignInput>;
  fieldGroupCardId?: InputMaybe<Scalars['UUID']>;
  formFields?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** The `formField` to be created by this mutation. */
export type FormFieldFieldGroupCardColumnIdForeignConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `fieldGroupCardColumn` in the `FormFieldInput` mutation. */
export type FormFieldFieldGroupCardColumnIdForeignInput = {
  /** The primary key(s) for `fieldGroupCardColumn` for the far side of the relationship. */
  connectById?: InputMaybe<FieldGroupCardColumnFieldGroupCardColumnPkeyConnect>;
  /** A `FieldGroupCardColumnInput` object that will be created and connected to this object. */
  create?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignConnectionFieldGroupCardColumnCreateInput>;
  /** The primary key(s) and patch data for `fieldGroupCardColumn` for the far side of the relationship. */
  updateById?: InputMaybe<FieldGroupCardColumnOnFormFieldForFormFieldFieldGroupCardColumnIdForeignUsingFieldGroupCardColumnPkeyUpdate>;
};

/** Input for the nested mutation of `formField` in the `FieldGroupCardColumnInput` mutation. */
export type FormFieldFieldGroupCardColumnIdForeignInverseInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldFormFieldPkeyConnect>>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldFieldGroupCardColumnIdForeignConnectionFormFieldCreateInput>>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldOnFormFieldForFormFieldFieldGroupCardColumnIdForeignUsingFormFieldPkeyUpdate>>;
};

/** A filter to be used against `FormField` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `agreementText` field. */
  agreementText?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FormFieldFilter>>;
  /** Filter by the object’s `approverFormFieldIds` field. */
  approverFormFieldIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `approverGroupIds` field. */
  approverGroupIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `approverSystemFieldIds` field. */
  approverSystemFieldIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `approverUserIds` field. */
  approverUserIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `cardOrder` field. */
  cardOrder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `changesMustBeApproved` field. */
  changesMustBeApproved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `competenceFormFields` relation. */
  competenceFormFields?: InputMaybe<FormFieldToManyCompetenceFormFieldFilter>;
  /** Some related `competenceFormFields` exist. */
  competenceFormFieldsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `competencesByRatingFormFieldId` relation. */
  competencesByRatingFormFieldId?: InputMaybe<FormFieldToManyCompetenceFilter>;
  /** Some related `competencesByRatingFormFieldId` exist. */
  competencesByRatingFormFieldIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractPredefinedPlaceholders` relation. */
  contractPredefinedPlaceholders?: InputMaybe<FormFieldToManyContractPredefinedPlaceholderFilter>;
  /** Some related `contractPredefinedPlaceholders` exist. */
  contractPredefinedPlaceholdersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `customId` field. */
  customId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `cvTemplateFieldMappings` relation. */
  cvTemplateFieldMappings?: InputMaybe<FormFieldToManyCvTemplateFieldMappingFilter>;
  /** Some related `cvTemplateFieldMappings` exist. */
  cvTemplateFieldMappingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `dashboardCardStatistics` relation. */
  dashboardCardStatistics?: InputMaybe<FormFieldToManyDashboardCardStatisticFilter>;
  /** Some related `dashboardCardStatistics` exist. */
  dashboardCardStatisticsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `defaultValue` field. */
  defaultValue?: InputMaybe<StringFilter>;
  /** Filter by the object’s `departmentTypeIds` field. */
  departmentTypeIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `engagementType` relation. */
  engagementType?: InputMaybe<EngagementTypeFilter>;
  /** A related `engagementType` exists. */
  engagementTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `event` relation. */
  event?: InputMaybe<EventFilter>;
  /** A related `event` exists. */
  eventExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `excludedRoleIds` field. */
  excludedRoleIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `fieldGroup` relation. */
  fieldGroup?: InputMaybe<FieldGroupFilter>;
  /** Filter by the object’s `fieldGroupCardColumn` relation. */
  fieldGroupCardColumn?: InputMaybe<FieldGroupCardColumnFilter>;
  /** A related `fieldGroupCardColumn` exists. */
  fieldGroupCardColumnExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `fieldGroupCardColumnId` field. */
  fieldGroupCardColumnId?: InputMaybe<UuidFilter>;
  /** A related `fieldGroup` exists. */
  fieldGroupExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `fieldGroupId` field. */
  fieldGroupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fieldType` field. */
  fieldType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `formFieldAgreementByFormFieldId` relation. */
  formFieldAgreementByFormFieldId?: InputMaybe<FormFieldAgreementFilter>;
  /** A related `formFieldAgreementByFormFieldId` exists. */
  formFieldAgreementByFormFieldIdExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFieldEntries` relation. */
  formFieldEntries?: InputMaybe<FormFieldToManyFormFieldEntryFilter>;
  /** Some related `formFieldEntries` exist. */
  formFieldEntriesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFieldOptions` relation. */
  formFieldOptions?: InputMaybe<FormFieldToManyFormFieldOptionFilter>;
  /** Some related `formFieldOptions` exist. */
  formFieldOptionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFieldsByParentFormFieldId` relation. */
  formFieldsByParentFormFieldId?: InputMaybe<FormFieldToManyFormFieldFilter>;
  /** Some related `formFieldsByParentFormFieldId` exist. */
  formFieldsByParentFormFieldIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `futureData` relation. */
  futureData?: InputMaybe<FormFieldToManyFutureDatumFilter>;
  /** Some related `futureData` exist. */
  futureDataExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `helpText` field. */
  helpText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `integrationFieldMarkings` relation. */
  integrationFieldMarkings?: InputMaybe<FormFieldToManyIntegrationFieldMarkingFilter>;
  /** Some related `integrationFieldMarkings` exist. */
  integrationFieldMarkingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `localizedAgreementText` field. */
  localizedAgreementText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `localizedHelpText` field. */
  localizedHelpText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `multiple` field. */
  multiple?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FormFieldFilter>;
  /** Filter by the object’s `notificationCustomEmployeeFieldRecipients` relation. */
  notificationCustomEmployeeFieldRecipients?: InputMaybe<FormFieldToManyNotificationCustomEmployeeFieldRecipientFilter>;
  /** Some related `notificationCustomEmployeeFieldRecipients` exist. */
  notificationCustomEmployeeFieldRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `objectType` field. */
  objectType?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FormFieldFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `parentFormField` relation. */
  parentFormField?: InputMaybe<FormFieldFilter>;
  /** A related `parentFormField` exists. */
  parentFormFieldExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `parentFormFieldId` field. */
  parentFormFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `preboardingAssignedUserIds` field. */
  preboardingAssignedUserIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `preboardingSlideFormFields` relation. */
  preboardingSlideFormFields?: InputMaybe<FormFieldToManyPreboardingSlideFormFieldFilter>;
  /** Some related `preboardingSlideFormFields` exist. */
  preboardingSlideFormFieldsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingsByRecipientCustomEmployeeFieldId` relation. */
  preboardingsByRecipientCustomEmployeeFieldId?: InputMaybe<FormFieldToManyPreboardingFilter>;
  /** Some related `preboardingsByRecipientCustomEmployeeFieldId` exist. */
  preboardingsByRecipientCustomEmployeeFieldIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `productTypeIds` field. */
  productTypeIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `relationRoles` relation. */
  relationRoles?: InputMaybe<FormFieldToManyRelationRoleFilter>;
  /** Some related `relationRoles` exist. */
  relationRolesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `required` field. */
  required?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sensitive` field. */
  sensitive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `supportsFutureData` field. */
  supportsFutureData?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `uniqueValue` field. */
  uniqueValue?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** The fields on `formField` to look up the row to connect. */
export type FormFieldFormFieldPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `fieldGroup` to be created by this mutation. */
export type FormFieldFormFieldTypeIdForeignConnectionFieldGroupCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  fieldGroupCards?: InputMaybe<FieldGroupCardFieldGroupIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFieldGroupIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldFormFieldTypeIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFieldGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  userSystemFields?: InputMaybe<UserSystemFieldFieldGroupIdForeignInverseInput>;
};

/** The `formField` to be created by this mutation. */
export type FormFieldFormFieldTypeIdForeignConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `fieldGroup` in the `FormFieldInput` mutation. */
export type FormFieldFormFieldTypeIdForeignInput = {
  /** The primary key(s) for `fieldGroup` for the far side of the relationship. */
  connectById?: InputMaybe<FieldGroupFormFieldTypePkeyConnect>;
  /** A `FieldGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<FormFieldFormFieldTypeIdForeignConnectionFieldGroupCreateInput>;
  /** The primary key(s) and patch data for `fieldGroup` for the far side of the relationship. */
  updateById?: InputMaybe<FieldGroupOnFormFieldForFormFieldFormFieldTypeIdForeignUsingFormFieldTypePkeyUpdate>;
};

/** Input for the nested mutation of `formField` in the `FieldGroupInput` mutation. */
export type FormFieldFormFieldTypeIdForeignInverseInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldFormFieldPkeyConnect>>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldFormFieldTypeIdForeignConnectionFormFieldCreateInput>>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldOnFormFieldForFormFieldFormFieldTypeIdForeignUsingFormFieldPkeyUpdate>>;
};

/** An input for mutations affecting `FormField` */
export type FormFieldInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnCompetenceForCompetenceRatingFormFieldIdForeignUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnCompetenceForCompetenceRatingFormFieldIdForeignPatch;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnCompetenceFormFieldForCompetenceFormFieldFormFieldIdForeignUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnCompetenceFormFieldForCompetenceFormFieldFormFieldIdForeignPatch;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnContractPredefinedPlaceholderForContractPredefinedPlaceholderFormFieldIdForeignUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnContractPredefinedPlaceholderForContractPredefinedPlaceholderFormFieldIdForeignPatch;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnCvTemplateFieldMappingForCvTemplateFieldMappingFormFieldIdForeignUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnCvTemplateFieldMappingForCvTemplateFieldMappingFormFieldIdForeignPatch;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnDashboardCardStatisticForDashboardCardStatisticFormFieldIdForeignUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnDashboardCardStatisticForDashboardCardStatisticFormFieldIdForeignPatch;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnFormFieldAgreementForFormFieldAgreementFormFieldIdForeignUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnFormFieldAgreementForFormFieldAgreementFormFieldIdForeignPatch;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnFormFieldEntryForFormFieldEntryFormFieldIdForeignUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnFormFieldEntryForFormFieldEntryFormFieldIdForeignPatch;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnFormFieldForFormFieldEngagementTypeIdForeignUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnFormFieldForFormFieldEngagementTypeIdForeignPatch;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnFormFieldForFormFieldEventIdForeignUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnFormFieldForFormFieldEventIdForeignPatch;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnFormFieldForFormFieldFieldGroupCardColumnIdForeignUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnFormFieldForFormFieldFieldGroupCardColumnIdForeignPatch;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnFormFieldForFormFieldFormFieldTypeIdForeignUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnFormFieldForFormFieldFormFieldTypeIdForeignPatch;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnFormFieldForFormFieldParentFormFieldIdForeignUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnFormFieldForFormFieldParentFormFieldIdForeignPatch;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnFormFieldOptionForFormFieldOptionFormFieldIdForeignUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnFormFieldOptionForFormFieldOptionFormFieldIdForeignPatch;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnFutureDatumForFutureDataFormFieldIdForeignUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnFutureDatumForFutureDataFormFieldIdForeignPatch;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnIntegrationFieldMarkingForIntegrationFieldMarkingFormFieldIdFkeyUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnIntegrationFieldMarkingForIntegrationFieldMarkingFormFieldIdFkeyPatch;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientFormFieldIdForeUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientFormFieldIdForePatch;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnPreboardingForPreboardingRecipientCustomEmployeeFieldIdForeignUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnPreboardingForPreboardingRecipientCustomEmployeeFieldIdForeignPatch;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldFormFieldIdForeignUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldFormFieldIdForeignPatch;
};

/** The fields on `formField` to look up the row to update. */
export type FormFieldOnRelationRoleForRelationRoleFormFieldIdForeignUsingFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formField` being updated. */
  patch: UpdateFormFieldOnRelationRoleForRelationRoleFormFieldIdForeignPatch;
};

export type FormFieldOption = {
  __typename?: 'FormFieldOption';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `FormFieldOption`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  customId?: Maybe<Scalars['String']>;
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `EngagementType` that is related to this `FormFieldOption`. */
  engagementType?: Maybe<EngagementType>;
  engagementTypeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `FormField` that is related to this `FormFieldOption`. */
  formField?: Maybe<FormField>;
  formFieldId: Scalars['UUID'];
  id: Scalars['UUID'];
  localizedValue?: Maybe<Scalars['String']>;
  objectType: Scalars['String'];
  order: Scalars['Int'];
  preboardingAssignedUserIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  predefined?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['Datetime'];
  value: Scalars['String'];
};


export type FormFieldOptionLocalizedValueArgs = {
  argLocale?: InputMaybe<Scalars['String']>;
};

/** The `formFieldOption` to be created by this mutation. */
export type FormFieldOptionCompanyIdFkeyConnectionFormFieldOptionCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldOptionCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldOptionFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  predefined?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `company` in the `FormFieldOptionInput` mutation. */
export type FormFieldOptionCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnFormFieldOptionForFormFieldOptionCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `formFieldOption` in the `CompanyInput` mutation. */
export type FormFieldOptionCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `formFieldOption` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldOptionFormFieldOptionPkeyConnect>>;
  /** A `FormFieldOptionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldOptionCompanyIdFkeyConnectionFormFieldOptionCreateInput>>;
  /** The primary key(s) and patch data for `formFieldOption` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldOptionOnFormFieldOptionForFormFieldOptionCompanyIdFkeyUsingFormFieldOptionPkeyUpdate>>;
};

/**
 * A condition to be used against `FormFieldOption` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FormFieldOptionCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `customId` field. */
  customId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `objectType` field. */
  objectType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `preboardingAssignedUserIds` field. */
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `predefined` field. */
  predefined?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** The `engagementType` to be created by this mutation. */
export type FormFieldOptionEngagementTypeIdForeignConnectionEngagementTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `formFieldOption` to be created by this mutation. */
export type FormFieldOptionEngagementTypeIdForeignConnectionFormFieldOptionCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldOptionCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInput>;
  formField?: InputMaybe<FormFieldOptionFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  predefined?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `engagementType` in the `FormFieldOptionInput` mutation. */
export type FormFieldOptionEngagementTypeIdForeignInput = {
  /** The primary key(s) for `engagementType` for the far side of the relationship. */
  connectById?: InputMaybe<EngagementTypeEngagementTypePkeyConnect>;
  /** A `EngagementTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<FormFieldOptionEngagementTypeIdForeignConnectionEngagementTypeCreateInput>;
  /** The primary key(s) and patch data for `engagementType` for the far side of the relationship. */
  updateById?: InputMaybe<EngagementTypeOnFormFieldOptionForFormFieldOptionEngagementTypeIdForeignUsingEngagementTypePkeyUpdate>;
};

/** Input for the nested mutation of `formFieldOption` in the `EngagementTypeInput` mutation. */
export type FormFieldOptionEngagementTypeIdForeignInverseInput = {
  /** The primary key(s) for `formFieldOption` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldOptionFormFieldOptionPkeyConnect>>;
  /** A `FormFieldOptionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldOptionEngagementTypeIdForeignConnectionFormFieldOptionCreateInput>>;
  /** The primary key(s) and patch data for `formFieldOption` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldOptionOnFormFieldOptionForFormFieldOptionEngagementTypeIdForeignUsingFormFieldOptionPkeyUpdate>>;
};

/** A filter to be used against `FormFieldOption` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldOptionFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FormFieldOptionFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `customId` field. */
  customId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `engagementType` relation. */
  engagementType?: InputMaybe<EngagementTypeFilter>;
  /** A related `engagementType` exists. */
  engagementTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `formField` relation. */
  formField?: InputMaybe<FormFieldFilter>;
  /** Filter by the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FormFieldOptionFilter>;
  /** Filter by the object’s `objectType` field. */
  objectType?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FormFieldOptionFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `preboardingAssignedUserIds` field. */
  preboardingAssignedUserIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `predefined` field. */
  predefined?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** The `formField` to be created by this mutation. */
export type FormFieldOptionFormFieldIdForeignConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `formFieldOption` to be created by this mutation. */
export type FormFieldOptionFormFieldIdForeignConnectionFormFieldOptionCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldOptionCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldOptionFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  predefined?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** Input for the nested mutation of `formField` in the `FormFieldOptionInput` mutation. */
export type FormFieldOptionFormFieldIdForeignInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<FormFieldFormFieldPkeyConnect>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<FormFieldOptionFormFieldIdForeignConnectionFormFieldCreateInput>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<FormFieldOnFormFieldOptionForFormFieldOptionFormFieldIdForeignUsingFormFieldPkeyUpdate>;
};

/** Input for the nested mutation of `formFieldOption` in the `FormFieldInput` mutation. */
export type FormFieldOptionFormFieldIdForeignInverseInput = {
  /** The primary key(s) for `formFieldOption` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FormFieldOptionFormFieldOptionPkeyConnect>>;
  /** A `FormFieldOptionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldOptionFormFieldIdForeignConnectionFormFieldOptionCreateInput>>;
  /** The primary key(s) and patch data for `formFieldOption` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FormFieldOptionOnFormFieldOptionForFormFieldOptionFormFieldIdForeignUsingFormFieldOptionPkeyUpdate>>;
};

/** The fields on `formFieldOption` to look up the row to connect. */
export type FormFieldOptionFormFieldOptionPkeyConnect = {
  id: Scalars['UUID'];
};

/** An input for mutations affecting `FormFieldOption` */
export type FormFieldOptionInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldOptionCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldOptionFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  predefined?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value: Scalars['String'];
};

/** The fields on `formFieldOption` to look up the row to update. */
export type FormFieldOptionOnFormFieldOptionForFormFieldOptionCompanyIdFkeyUsingFormFieldOptionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldOption` being updated. */
  patch: UpdateFormFieldOptionOnFormFieldOptionForFormFieldOptionCompanyIdFkeyPatch;
};

/** The fields on `formFieldOption` to look up the row to update. */
export type FormFieldOptionOnFormFieldOptionForFormFieldOptionEngagementTypeIdForeignUsingFormFieldOptionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldOption` being updated. */
  patch: UpdateFormFieldOptionOnFormFieldOptionForFormFieldOptionEngagementTypeIdForeignPatch;
};

/** The fields on `formFieldOption` to look up the row to update. */
export type FormFieldOptionOnFormFieldOptionForFormFieldOptionFormFieldIdForeignUsingFormFieldOptionPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `formFieldOption` being updated. */
  patch: UpdateFormFieldOptionOnFormFieldOptionForFormFieldOptionFormFieldIdForeignPatch;
};

/** Represents an update to a `FormFieldOption`. Fields that are set will be updated. */
export type FormFieldOptionPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldOptionCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldOptionFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  predefined?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `FormFieldOption` values. */
export type FormFieldOptionsConnection = {
  __typename?: 'FormFieldOptionsConnection';
  /** A list of edges which contains the `FormFieldOption` and cursor to aid in pagination. */
  edges: Array<FormFieldOptionsEdge>;
  /** A list of `FormFieldOption` objects. */
  nodes: Array<Maybe<FormFieldOption>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FormFieldOption` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FormFieldOption` edge in the connection. */
export type FormFieldOptionsEdge = {
  __typename?: 'FormFieldOptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FormFieldOption` at the end of the edge. */
  node?: Maybe<FormFieldOption>;
};

/** Methods to use when ordering `FormFieldOption`. */
export type FormFieldOptionsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CUSTOM_ID_ASC'
  | 'CUSTOM_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_ID_ASC'
  | 'ENGAGEMENT_TYPE_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_DESC'
  | 'FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'OBJECT_TYPE_ASC'
  | 'OBJECT_TYPE_DESC'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PREBOARDING_ASSIGNED_USER_IDS_ASC'
  | 'PREBOARDING_ASSIGNED_USER_IDS_DESC'
  | 'PREDEFINED_ASC'
  | 'PREDEFINED_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'VALUE_ASC'
  | 'VALUE_DESC';

/** The `formField` to be created by this mutation. */
export type FormFieldParentFormFieldIdForeignConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `formField` in the `FormFieldInput` mutation. */
export type FormFieldParentFormFieldIdForeignInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<FormFieldFormFieldPkeyConnect>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<FormFieldParentFormFieldIdForeignConnectionFormFieldCreateInput>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<FormFieldOnFormFieldForFormFieldParentFormFieldIdForeignUsingFormFieldPkeyUpdate>;
};

/** Represents an update to a `FormField`. Fields that are set will be updated. */
export type FormFieldPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against many `Competence` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldToManyCompetenceFilter = {
  /** Every related `Competence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompetenceFilter>;
  /** No related `Competence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompetenceFilter>;
  /** Some related `Competence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompetenceFilter>;
};

/** A filter to be used against many `CompetenceFormField` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldToManyCompetenceFormFieldFilter = {
  /** Every related `CompetenceFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompetenceFormFieldFilter>;
  /** No related `CompetenceFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompetenceFormFieldFilter>;
  /** Some related `CompetenceFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompetenceFormFieldFilter>;
};

/** A filter to be used against many `ContractPredefinedPlaceholder` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldToManyContractPredefinedPlaceholderFilter = {
  /** Every related `ContractPredefinedPlaceholder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractPredefinedPlaceholderFilter>;
  /** No related `ContractPredefinedPlaceholder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractPredefinedPlaceholderFilter>;
  /** Some related `ContractPredefinedPlaceholder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractPredefinedPlaceholderFilter>;
};

/** A filter to be used against many `CvTemplateFieldMapping` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldToManyCvTemplateFieldMappingFilter = {
  /** Every related `CvTemplateFieldMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CvTemplateFieldMappingFilter>;
  /** No related `CvTemplateFieldMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CvTemplateFieldMappingFilter>;
  /** Some related `CvTemplateFieldMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CvTemplateFieldMappingFilter>;
};

/** A filter to be used against many `DashboardCardStatistic` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldToManyDashboardCardStatisticFilter = {
  /** Every related `DashboardCardStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DashboardCardStatisticFilter>;
  /** No related `DashboardCardStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DashboardCardStatisticFilter>;
  /** Some related `DashboardCardStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DashboardCardStatisticFilter>;
};

/** A filter to be used against many `FormFieldEntry` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldToManyFormFieldEntryFilter = {
  /** Every related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FormFieldEntryFilter>;
  /** No related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FormFieldEntryFilter>;
  /** Some related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FormFieldEntryFilter>;
};

/** A filter to be used against many `FormField` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldToManyFormFieldFilter = {
  /** Every related `FormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FormFieldFilter>;
  /** No related `FormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FormFieldFilter>;
  /** Some related `FormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FormFieldFilter>;
};

/** A filter to be used against many `FormFieldOption` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldToManyFormFieldOptionFilter = {
  /** Every related `FormFieldOption` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FormFieldOptionFilter>;
  /** No related `FormFieldOption` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FormFieldOptionFilter>;
  /** Some related `FormFieldOption` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FormFieldOptionFilter>;
};

/** A filter to be used against many `FutureDatum` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldToManyFutureDatumFilter = {
  /** Every related `FutureDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FutureDatumFilter>;
  /** No related `FutureDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FutureDatumFilter>;
  /** Some related `FutureDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FutureDatumFilter>;
};

/** A filter to be used against many `IntegrationFieldMarking` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldToManyIntegrationFieldMarkingFilter = {
  /** Every related `IntegrationFieldMarking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<IntegrationFieldMarkingFilter>;
  /** No related `IntegrationFieldMarking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<IntegrationFieldMarkingFilter>;
  /** Some related `IntegrationFieldMarking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<IntegrationFieldMarkingFilter>;
};

/** A filter to be used against many `NotificationCustomEmployeeFieldRecipient` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldToManyNotificationCustomEmployeeFieldRecipientFilter = {
  /** Every related `NotificationCustomEmployeeFieldRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationCustomEmployeeFieldRecipientFilter>;
  /** No related `NotificationCustomEmployeeFieldRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationCustomEmployeeFieldRecipientFilter>;
  /** Some related `NotificationCustomEmployeeFieldRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationCustomEmployeeFieldRecipientFilter>;
};

/** A filter to be used against many `Preboarding` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldToManyPreboardingFilter = {
  /** Every related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingFilter>;
  /** No related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingFilter>;
  /** Some related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingFilter>;
};

/** A filter to be used against many `PreboardingSlideFormField` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldToManyPreboardingSlideFormFieldFilter = {
  /** Every related `PreboardingSlideFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingSlideFormFieldFilter>;
  /** No related `PreboardingSlideFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingSlideFormFieldFilter>;
  /** Some related `PreboardingSlideFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingSlideFormFieldFilter>;
};

/** A filter to be used against many `RelationRole` object types. All fields are combined with a logical ‘and.’ */
export type FormFieldToManyRelationRoleFilter = {
  /** Every related `RelationRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RelationRoleFilter>;
  /** No related `RelationRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RelationRoleFilter>;
  /** Some related `RelationRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RelationRoleFilter>;
};

/** The `fieldGroup` to be created by this mutation. */
export type FormFieldTypeCompanyIdForeignConnectionFieldGroupCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldTypeCompanyIdForeignInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  fieldGroupCards?: InputMaybe<FieldGroupCardFieldGroupIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFieldGroupIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldFormFieldTypeIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFieldGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  userSystemFields?: InputMaybe<UserSystemFieldFieldGroupIdForeignInverseInput>;
};

/** Input for the nested mutation of `company` in the `FieldGroupInput` mutation. */
export type FormFieldTypeCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnFieldGroupForFormFieldTypeCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `fieldGroup` in the `CompanyInput` mutation. */
export type FormFieldTypeCompanyIdForeignInverseInput = {
  /** The primary key(s) for `fieldGroup` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FieldGroupFormFieldTypePkeyConnect>>;
  /** A `FieldGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FormFieldTypeCompanyIdForeignConnectionFieldGroupCreateInput>>;
  /** The primary key(s) and patch data for `fieldGroup` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FieldGroupOnFieldGroupForFormFieldTypeCompanyIdForeignUsingFormFieldTypePkeyUpdate>>;
};

/** A connection to a list of `FormField` values. */
export type FormFieldsConnection = {
  __typename?: 'FormFieldsConnection';
  /** A list of edges which contains the `FormField` and cursor to aid in pagination. */
  edges: Array<FormFieldsEdge>;
  /** A list of `FormField` objects. */
  nodes: Array<Maybe<FormField>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FormField` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FormField` edge in the connection. */
export type FormFieldsEdge = {
  __typename?: 'FormFieldsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FormField` at the end of the edge. */
  node?: Maybe<FormField>;
};

/** Methods to use when ordering `FormField`. */
export type FormFieldsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'APPROVER_FORM_FIELD_IDS_ASC'
  | 'APPROVER_FORM_FIELD_IDS_DESC'
  | 'APPROVER_GROUP_IDS_ASC'
  | 'APPROVER_GROUP_IDS_DESC'
  | 'APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'APPROVER_USER_IDS_ASC'
  | 'APPROVER_USER_IDS_DESC'
  | 'CARD_ORDER_ASC'
  | 'CARD_ORDER_DESC'
  | 'CHANGES_MUST_BE_APPROVED_ASC'
  | 'CHANGES_MUST_BE_APPROVED_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPETENCES_BY_RATING_FORM_FIELD_ID__COUNT_ASC'
  | 'COMPETENCES_BY_RATING_FORM_FIELD_ID__COUNT_DESC'
  | 'COMPETENCE_FORM_FIELDS_BY_FORM_FIELD_ID__COUNT_ASC'
  | 'COMPETENCE_FORM_FIELDS_BY_FORM_FIELD_ID__COUNT_DESC'
  | 'CONTRACT_PREDEFINED_PLACEHOLDERS_BY_FORM_FIELD_ID__COUNT_ASC'
  | 'CONTRACT_PREDEFINED_PLACEHOLDERS_BY_FORM_FIELD_ID__COUNT_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CUSTOM_ID_ASC'
  | 'CUSTOM_ID_DESC'
  | 'CV_TEMPLATE_FIELD_MAPPINGS_BY_FORM_FIELD_ID__COUNT_ASC'
  | 'CV_TEMPLATE_FIELD_MAPPINGS_BY_FORM_FIELD_ID__COUNT_DESC'
  | 'DASHBOARD_CARD_STATISTICS_BY_FORM_FIELD_ID__COUNT_ASC'
  | 'DASHBOARD_CARD_STATISTICS_BY_FORM_FIELD_ID__COUNT_DESC'
  | 'DEFAULT_VALUE_ASC'
  | 'DEFAULT_VALUE_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'DEPARTMENT_TYPE_IDS_ASC'
  | 'DEPARTMENT_TYPE_IDS_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_ID_ASC'
  | 'ENGAGEMENT_TYPE_ID_DESC'
  | 'EVENT_BY_EVENT_ID__ACTIVE_ASC'
  | 'EVENT_BY_EVENT_ID__ACTIVE_DESC'
  | 'EVENT_BY_EVENT_ID__COMPANY_ID_ASC'
  | 'EVENT_BY_EVENT_ID__COMPANY_ID_DESC'
  | 'EVENT_BY_EVENT_ID__CONTACT_PERSON_IDS_ASC'
  | 'EVENT_BY_EVENT_ID__CONTACT_PERSON_IDS_DESC'
  | 'EVENT_BY_EVENT_ID__CREATED_AT_ASC'
  | 'EVENT_BY_EVENT_ID__CREATED_AT_DESC'
  | 'EVENT_BY_EVENT_ID__DEADLINE_ASC'
  | 'EVENT_BY_EVENT_ID__DEADLINE_DESC'
  | 'EVENT_BY_EVENT_ID__DESCRIPTION_ASC'
  | 'EVENT_BY_EVENT_ID__DESCRIPTION_DESC'
  | 'EVENT_BY_EVENT_ID__END_DATE_ASC'
  | 'EVENT_BY_EVENT_ID__END_DATE_DESC'
  | 'EVENT_BY_EVENT_ID__GEOGRAPHY_ASC'
  | 'EVENT_BY_EVENT_ID__GEOGRAPHY_DESC'
  | 'EVENT_BY_EVENT_ID__ID_ASC'
  | 'EVENT_BY_EVENT_ID__ID_DESC'
  | 'EVENT_BY_EVENT_ID__INVITED_ALL_ASC'
  | 'EVENT_BY_EVENT_ID__INVITED_ALL_DESC'
  | 'EVENT_BY_EVENT_ID__INVITED_DEPARTMENT_IDS_ASC'
  | 'EVENT_BY_EVENT_ID__INVITED_DEPARTMENT_IDS_DESC'
  | 'EVENT_BY_EVENT_ID__INVITED_USER_IDS_ASC'
  | 'EVENT_BY_EVENT_ID__INVITED_USER_IDS_DESC'
  | 'EVENT_BY_EVENT_ID__LOCATION_ASC'
  | 'EVENT_BY_EVENT_ID__LOCATION_DESC'
  | 'EVENT_BY_EVENT_ID__NAME_ASC'
  | 'EVENT_BY_EVENT_ID__NAME_DESC'
  | 'EVENT_BY_EVENT_ID__ORGANIZER_IDS_ASC'
  | 'EVENT_BY_EVENT_ID__ORGANIZER_IDS_DESC'
  | 'EVENT_BY_EVENT_ID__START_DATE_ASC'
  | 'EVENT_BY_EVENT_ID__START_DATE_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'EXCLUDED_ROLE_IDS_ASC'
  | 'EXCLUDED_ROLE_IDS_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ACTIVE_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ACTIVE_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__COMPANY_ID_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__COMPANY_ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__CUSTOM_ID_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__CUSTOM_ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ID_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__LOCALIZED_NAME_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__LOCALIZED_NAME_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__NAME_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__NAME_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ORDER_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ORDER_DESC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__ACTIVE_ASC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__ACTIVE_DESC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__COMPANY_ID_ASC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__COMPANY_ID_DESC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__CREATED_AT_ASC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__CREATED_AT_DESC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__FIELD_GROUP_CARD_ID_ASC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__FIELD_GROUP_CARD_ID_DESC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__ID_ASC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__ID_DESC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__NAME_ASC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__NAME_DESC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__ORDER_ASC'
  | 'FIELD_GROUP_CARD_COLUMN_BY_FIELD_GROUP_CARD_COLUMN_ID__ORDER_DESC'
  | 'FIELD_GROUP_CARD_COLUMN_ID_ASC'
  | 'FIELD_GROUP_CARD_COLUMN_ID_DESC'
  | 'FIELD_GROUP_ID_ASC'
  | 'FIELD_GROUP_ID_DESC'
  | 'FIELD_TYPE_ASC'
  | 'FIELD_TYPE_DESC'
  | 'FORM_FIELDS_BY_PARENT_FORM_FIELD_ID__COUNT_ASC'
  | 'FORM_FIELDS_BY_PARENT_FORM_FIELD_ID__COUNT_DESC'
  | 'FORM_FIELD_AGREEMENT_BY_FORM_FIELD_ID__AGREEMENT_TEXT_TRANSLATED_ENTITY_ID_ASC'
  | 'FORM_FIELD_AGREEMENT_BY_FORM_FIELD_ID__AGREEMENT_TEXT_TRANSLATED_ENTITY_ID_DESC'
  | 'FORM_FIELD_AGREEMENT_BY_FORM_FIELD_ID__COMPANY_ID_ASC'
  | 'FORM_FIELD_AGREEMENT_BY_FORM_FIELD_ID__COMPANY_ID_DESC'
  | 'FORM_FIELD_AGREEMENT_BY_FORM_FIELD_ID__FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_AGREEMENT_BY_FORM_FIELD_ID__FORM_FIELD_ID_DESC'
  | 'FORM_FIELD_AGREEMENT_BY_FORM_FIELD_ID__ID_ASC'
  | 'FORM_FIELD_AGREEMENT_BY_FORM_FIELD_ID__ID_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__ACTIVE_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__ACTIVE_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__APPROVER_GROUP_IDS_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__APPROVER_GROUP_IDS_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__APPROVER_USER_IDS_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__APPROVER_USER_IDS_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__CARD_ORDER_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__CARD_ORDER_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__COMPANY_ID_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__COMPANY_ID_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__CREATED_AT_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__CREATED_AT_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__CUSTOM_ID_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__CUSTOM_ID_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__DEFAULT_VALUE_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__DEFAULT_VALUE_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__DEPARTMENTS_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__DEPARTMENTS_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__EVENT_ID_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__EVENT_ID_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__FIELD_GROUP_ID_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__FIELD_GROUP_ID_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__FIELD_TYPE_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__FIELD_TYPE_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__HELP_TEXT_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__HELP_TEXT_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__ID_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__ID_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__LOCALIZED_NAME_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__LOCALIZED_NAME_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__METADATA_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__METADATA_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__MULTIPLE_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__MULTIPLE_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__NAME_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__NAME_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__OBJECT_TYPE_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__OBJECT_TYPE_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__ORDER_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__ORDER_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__PRODUCT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__PRODUCT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__REQUIRED_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__REQUIRED_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__SENSITIVE_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__SENSITIVE_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__UNIQUE_VALUE_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__UNIQUE_VALUE_DESC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__UPDATED_AT_ASC'
  | 'FORM_FIELD_BY_PARENT_FORM_FIELD_ID__UPDATED_AT_DESC'
  | 'FORM_FIELD_ENTRIES_BY_FORM_FIELD_ID__COUNT_ASC'
  | 'FORM_FIELD_ENTRIES_BY_FORM_FIELD_ID__COUNT_DESC'
  | 'FORM_FIELD_OPTIONS_BY_FORM_FIELD_ID__COUNT_ASC'
  | 'FORM_FIELD_OPTIONS_BY_FORM_FIELD_ID__COUNT_DESC'
  | 'FUTURE_DATA_BY_FORM_FIELD_ID__COUNT_ASC'
  | 'FUTURE_DATA_BY_FORM_FIELD_ID__COUNT_DESC'
  | 'HELP_TEXT_ASC'
  | 'HELP_TEXT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INTEGRATION_FIELD_MARKINGS_BY_FORM_FIELD_ID__COUNT_ASC'
  | 'INTEGRATION_FIELD_MARKINGS_BY_FORM_FIELD_ID__COUNT_DESC'
  | 'LOCALIZED_NAME_ASC'
  | 'LOCALIZED_NAME_DESC'
  | 'METADATA_ASC'
  | 'METADATA_DESC'
  | 'MULTIPLE_ASC'
  | 'MULTIPLE_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_CUSTOM_EMPLOYEE_FIELD_RECIPIENTS_BY_FORM_FIELD_ID__COUNT_ASC'
  | 'NOTIFICATION_CUSTOM_EMPLOYEE_FIELD_RECIPIENTS_BY_FORM_FIELD_ID__COUNT_DESC'
  | 'OBJECT_TYPE_ASC'
  | 'OBJECT_TYPE_DESC'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PARENT_FORM_FIELD_ID_ASC'
  | 'PARENT_FORM_FIELD_ID_DESC'
  | 'PREBOARDINGS_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__COUNT_ASC'
  | 'PREBOARDINGS_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__COUNT_DESC'
  | 'PREBOARDING_ASSIGNED_USER_IDS_ASC'
  | 'PREBOARDING_ASSIGNED_USER_IDS_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELDS_BY_FORM_FIELD_ID__COUNT_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELDS_BY_FORM_FIELD_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PRODUCT_TYPE_IDS_ASC'
  | 'PRODUCT_TYPE_IDS_DESC'
  | 'RELATION_ROLES_BY_FORM_FIELD_ID__COUNT_ASC'
  | 'RELATION_ROLES_BY_FORM_FIELD_ID__COUNT_DESC'
  | 'REQUIRED_ASC'
  | 'REQUIRED_DESC'
  | 'SENSITIVE_ASC'
  | 'SENSITIVE_DESC'
  | 'SUPPORTS_FUTURE_DATA_ASC'
  | 'SUPPORTS_FUTURE_DATA_DESC'
  | 'UNIQUE_VALUE_ASC'
  | 'UNIQUE_VALUE_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

export type FroalaStyle = {
  __typename?: 'FroalaStyle';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `FroalaStyle`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  css?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  values?: Maybe<Scalars['JSON']>;
};

/**
 * A condition to be used against `FroalaStyle` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FroalaStyleCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `css` field. */
  css?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `values` field. */
  values?: InputMaybe<Scalars['JSON']>;
};

/** A filter to be used against `FroalaStyle` object types. All fields are combined with a logical ‘and.’ */
export type FroalaStyleFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FroalaStyleFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `css` field. */
  css?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FroalaStyleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FroalaStyleFilter>>;
  /** Filter by the object’s `values` field. */
  values?: InputMaybe<JsonFilter>;
};

/** The fields on `froalaStyle` to look up the row to connect. */
export type FroalaStyleFroalaStylesPkeyConnect = {
  id: Scalars['UUID'];
};

/** An input for mutations affecting `FroalaStyle` */
export type FroalaStyleInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FroalaStylesCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  css?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  values?: InputMaybe<Scalars['JSON']>;
};

/** The fields on `froalaStyle` to look up the row to update. */
export type FroalaStyleOnFroalaStyleForFroalaStylesCompanyIdForeignUsingFroalaStylesPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `froalaStyle` being updated. */
  patch: UpdateFroalaStyleOnFroalaStyleForFroalaStylesCompanyIdForeignPatch;
};

/** Represents an update to a `FroalaStyle`. Fields that are set will be updated. */
export type FroalaStylePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FroalaStylesCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  css?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Scalars['JSON']>;
};

/** The `froalaStyle` to be created by this mutation. */
export type FroalaStylesCompanyIdForeignConnectionFroalaStylesCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FroalaStylesCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  css?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  values?: InputMaybe<Scalars['JSON']>;
};

/** Input for the nested mutation of `company` in the `FroalaStyleInput` mutation. */
export type FroalaStylesCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnFroalaStyleForFroalaStylesCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `froalaStyle` in the `CompanyInput` mutation. */
export type FroalaStylesCompanyIdForeignInverseInput = {
  /** The primary key(s) for `froalaStyle` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FroalaStyleFroalaStylesPkeyConnect>>;
  /** A `FroalaStyleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FroalaStylesCompanyIdForeignConnectionFroalaStylesCreateInput>>;
  /** The primary key(s) and patch data for `froalaStyle` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FroalaStyleOnFroalaStyleForFroalaStylesCompanyIdForeignUsingFroalaStylesPkeyUpdate>>;
};

/** A connection to a list of `FroalaStyle` values. */
export type FroalaStylesConnection = {
  __typename?: 'FroalaStylesConnection';
  /** A list of edges which contains the `FroalaStyle` and cursor to aid in pagination. */
  edges: Array<FroalaStylesEdge>;
  /** A list of `FroalaStyle` objects. */
  nodes: Array<Maybe<FroalaStyle>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FroalaStyle` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FroalaStyle` edge in the connection. */
export type FroalaStylesEdge = {
  __typename?: 'FroalaStylesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FroalaStyle` at the end of the edge. */
  node?: Maybe<FroalaStyle>;
};

/** Methods to use when ordering `FroalaStyle`. */
export type FroalaStylesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CSS_ASC'
  | 'CSS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'VALUES_ASC'
  | 'VALUES_DESC';

/** A filter to be used against FullText fields. All fields are combined with a logical ‘and.’ */
export type FullTextFilter = {
  /** Performs a full text search on the field. */
  matches?: InputMaybe<Scalars['String']>;
};

/** The `approval` to be created by this mutation. */
export type FutureDataApprovalIdForeignConnectionApprovalCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  affectedUserDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  affectedUserId?: InputMaybe<Scalars['UUID']>;
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  approvingUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<ApprovalCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  deniedAt?: InputMaybe<Scalars['Datetime']>;
  futureDatum?: InputMaybe<FutureDataApprovalIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isDeletionRequest?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['UUID']>;
  requestingUserId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInverseInput>;
  type: ApprovalType;
  user?: InputMaybe<ApprovalRequestingUserIdForeignInput>;
  vacationUserToApprovalIdUsingId?: InputMaybe<VacationUserApprovalIdForeignInverseInput>;
  vacationUserToDeletionApprovalIdUsingId?: InputMaybe<VacationUserDeletionApprovalIdForeignInverseInput>;
};

/** Input for the nested mutation of `approval` in the `FutureDatumInput` mutation. */
export type FutureDataApprovalIdForeignInput = {
  /** The primary key(s) for `approval` for the far side of the relationship. */
  connectById?: InputMaybe<ApprovalApprovalPkeyConnect>;
  /** A `ApprovalInput` object that will be created and connected to this object. */
  create?: InputMaybe<FutureDataApprovalIdForeignConnectionApprovalCreateInput>;
  /** The primary key(s) and patch data for `approval` for the far side of the relationship. */
  updateById?: InputMaybe<ApprovalOnFutureDatumForFutureDataApprovalIdForeignUsingApprovalPkeyUpdate>;
};

/** Input for the nested mutation of `futureDatum` in the `ApprovalInput` mutation. */
export type FutureDataApprovalIdForeignInverseInput = {
  /** The primary key(s) for `futureDatum` for the far side of the relationship. */
  connectByApprovalId?: InputMaybe<FutureDatumFutureDataApprovalIdUniqueConnect>;
  /** The primary key(s) for `futureDatum` for the far side of the relationship. */
  connectById?: InputMaybe<FutureDatumFutureDataPkeyConnect>;
  /** The primary key(s) and patch data for `futureDatum` for the far side of the relationship. */
  updateByApprovalId?: InputMaybe<FutureDatumOnFutureDatumForFutureDataApprovalIdForeignUsingFutureDataApprovalIdUniqueUpdate>;
  /** The primary key(s) and patch data for `futureDatum` for the far side of the relationship. */
  updateById?: InputMaybe<FutureDatumOnFutureDatumForFutureDataApprovalIdForeignUsingFutureDataPkeyUpdate>;
};

/** Input for the nested mutation of `company` in the `FutureDatumInput` mutation. */
export type FutureDataCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnFutureDatumForFutureDataCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `futureDatum` in the `CompanyInput` mutation. */
export type FutureDataCompanyIdForeignInverseInput = {
  /** The primary key(s) for `futureDatum` for the far side of the relationship. */
  connectByApprovalId?: InputMaybe<Array<FutureDatumFutureDataApprovalIdUniqueConnect>>;
  /** The primary key(s) for `futureDatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FutureDatumFutureDataPkeyConnect>>;
  /** The primary key(s) and patch data for `futureDatum` for the far side of the relationship. */
  updateByApprovalId?: InputMaybe<Array<FutureDatumOnFutureDatumForFutureDataCompanyIdForeignUsingFutureDataApprovalIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `futureDatum` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FutureDatumOnFutureDatumForFutureDataCompanyIdForeignUsingFutureDataPkeyUpdate>>;
};

/** A connection to a list of `FutureDatum` values. */
export type FutureDataConnection = {
  __typename?: 'FutureDataConnection';
  /** A list of edges which contains the `FutureDatum` and cursor to aid in pagination. */
  edges: Array<FutureDataEdge>;
  /** A list of `FutureDatum` objects. */
  nodes: Array<Maybe<FutureDatum>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FutureDatum` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** Input for the nested mutation of `user` in the `FutureDatumInput` mutation. */
export type FutureDataCreatorUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnFutureDatumForFutureDataCreatorUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `futureDatum` in the `UserInput` mutation. */
export type FutureDataCreatorUserIdForeignInverseInput = {
  /** The primary key(s) for `futureDatum` for the far side of the relationship. */
  connectByApprovalId?: InputMaybe<Array<FutureDatumFutureDataApprovalIdUniqueConnect>>;
  /** The primary key(s) for `futureDatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FutureDatumFutureDataPkeyConnect>>;
  /** The primary key(s) and patch data for `futureDatum` for the far side of the relationship. */
  updateByApprovalId?: InputMaybe<Array<FutureDatumOnFutureDatumForFutureDataCreatorUserIdForeignUsingFutureDataApprovalIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `futureDatum` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FutureDatumOnFutureDatumForFutureDataCreatorUserIdForeignUsingFutureDataPkeyUpdate>>;
};

/** A `FutureDatum` edge in the connection. */
export type FutureDataEdge = {
  __typename?: 'FutureDataEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FutureDatum` at the end of the edge. */
  node?: Maybe<FutureDatum>;
};

/** The `fieldGroup` to be created by this mutation. */
export type FutureDataFieldGroupIdForeignConnectionFieldGroupCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  fieldGroupCards?: InputMaybe<FieldGroupCardFieldGroupIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFieldGroupIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldFormFieldTypeIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFieldGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  userSystemFields?: InputMaybe<UserSystemFieldFieldGroupIdForeignInverseInput>;
};

/** Input for the nested mutation of `fieldGroup` in the `FutureDatumInput` mutation. */
export type FutureDataFieldGroupIdForeignInput = {
  /** The primary key(s) for `fieldGroup` for the far side of the relationship. */
  connectById?: InputMaybe<FieldGroupFormFieldTypePkeyConnect>;
  /** A `FieldGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<FutureDataFieldGroupIdForeignConnectionFieldGroupCreateInput>;
  /** The primary key(s) and patch data for `fieldGroup` for the far side of the relationship. */
  updateById?: InputMaybe<FieldGroupOnFutureDatumForFutureDataFieldGroupIdForeignUsingFormFieldTypePkeyUpdate>;
};

/** Input for the nested mutation of `futureDatum` in the `FieldGroupInput` mutation. */
export type FutureDataFieldGroupIdForeignInverseInput = {
  /** The primary key(s) for `futureDatum` for the far side of the relationship. */
  connectByApprovalId?: InputMaybe<Array<FutureDatumFutureDataApprovalIdUniqueConnect>>;
  /** The primary key(s) for `futureDatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FutureDatumFutureDataPkeyConnect>>;
  /** The primary key(s) and patch data for `futureDatum` for the far side of the relationship. */
  updateByApprovalId?: InputMaybe<Array<FutureDatumOnFutureDatumForFutureDataFieldGroupIdForeignUsingFutureDataApprovalIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `futureDatum` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FutureDatumOnFutureDatumForFutureDataFieldGroupIdForeignUsingFutureDataPkeyUpdate>>;
};

/** A connection to a list of `FutureDataFieldsInUseRecord` values. */
export type FutureDataFieldsInUseConnection = {
  __typename?: 'FutureDataFieldsInUseConnection';
  /** A list of edges which contains the `FutureDataFieldsInUseRecord` and cursor to aid in pagination. */
  edges: Array<FutureDataFieldsInUseEdge>;
  /** A list of `FutureDataFieldsInUseRecord` objects. */
  nodes: Array<Maybe<FutureDataFieldsInUseRecord>>;
  /** The count of *all* `FutureDataFieldsInUseRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FutureDataFieldsInUseRecord` edge in the connection. */
export type FutureDataFieldsInUseEdge = {
  __typename?: 'FutureDataFieldsInUseEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FutureDataFieldsInUseRecord` at the end of the edge. */
  node?: Maybe<FutureDataFieldsInUseRecord>;
};

/** The return type of our `futureDataFieldsInUse` query. */
export type FutureDataFieldsInUseRecord = {
  __typename?: 'FutureDataFieldsInUseRecord';
  id?: Maybe<Scalars['UUID']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** A filter to be used against `FutureDataFieldsInUseRecord` object types. All fields are combined with a logical ‘and.’ */
export type FutureDataFieldsInUseRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FutureDataFieldsInUseRecordFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FutureDataFieldsInUseRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FutureDataFieldsInUseRecordFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** The `formField` to be created by this mutation. */
export type FutureDataFormFieldIdForeignConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `formField` in the `FutureDatumInput` mutation. */
export type FutureDataFormFieldIdForeignInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<FormFieldFormFieldPkeyConnect>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<FutureDataFormFieldIdForeignConnectionFormFieldCreateInput>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<FormFieldOnFutureDatumForFutureDataFormFieldIdForeignUsingFormFieldPkeyUpdate>;
};

/** Input for the nested mutation of `futureDatum` in the `FormFieldInput` mutation. */
export type FutureDataFormFieldIdForeignInverseInput = {
  /** The primary key(s) for `futureDatum` for the far side of the relationship. */
  connectByApprovalId?: InputMaybe<Array<FutureDatumFutureDataApprovalIdUniqueConnect>>;
  /** The primary key(s) for `futureDatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FutureDatumFutureDataPkeyConnect>>;
  /** The primary key(s) and patch data for `futureDatum` for the far side of the relationship. */
  updateByApprovalId?: InputMaybe<Array<FutureDatumOnFutureDatumForFutureDataFormFieldIdForeignUsingFutureDataApprovalIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `futureDatum` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FutureDatumOnFutureDatumForFutureDataFormFieldIdForeignUsingFutureDataPkeyUpdate>>;
};

/** Methods to use when ordering `FutureDatum`. */
export type FutureDataOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__ACTIVE_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__ACTIVE_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__AFFECTED_USER_DEPARTMENT_IDS_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__AFFECTED_USER_DEPARTMENT_IDS_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__AFFECTED_USER_ID_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__AFFECTED_USER_ID_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__APPROVED_AT_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__APPROVED_AT_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__APPROVING_USER_ID_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__APPROVING_USER_ID_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__COMPANY_ID_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__COMPANY_ID_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__CREATED_AT_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__CREATED_AT_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__DEADLINE_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__DEADLINE_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__DENIED_AT_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__DENIED_AT_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__ID_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__ID_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__IS_DELETION_REQUEST_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__IS_DELETION_REQUEST_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__ITEM_ID_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__ITEM_ID_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__REQUESTING_USER_ID_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__REQUESTING_USER_ID_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__TYPE_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__TYPE_DESC'
  | 'APPROVAL_ID_ASC'
  | 'APPROVAL_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CREATOR_USER_ID_ASC'
  | 'CREATOR_USER_ID_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ACTIVE_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ACTIVE_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__COMPANY_ID_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__COMPANY_ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__CUSTOM_ID_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__CUSTOM_ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ID_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__LOCALIZED_NAME_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__LOCALIZED_NAME_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__NAME_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__NAME_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ORDER_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ORDER_DESC'
  | 'FIELD_GROUP_ID_ASC'
  | 'FIELD_GROUP_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_DESC'
  | 'FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LEADER_DEPARTMENT_IDS_ASC'
  | 'LEADER_DEPARTMENT_IDS_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_FUTURE_DATA_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_FUTURE_DATA_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ALWAYS_REQUIRED_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ALWAYS_REQUIRED_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__DOCUMENT_TEMPLATE_PLACEHOLDER_NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__DOCUMENT_TEMPLATE_PLACEHOLDER_NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__EXCLUDE_FROM_PLACEHOLDER_FORM_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__EXCLUDE_FROM_PLACEHOLDER_FORM_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ID_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ID_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READABLE_NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READABLE_NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READ_ONLY_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READ_ONLY_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__TYPE_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__TYPE_DESC'
  | 'SYSTEM_FIELD_ID_ASC'
  | 'SYSTEM_FIELD_ID_DESC'
  | 'UNIQUE_KEY_ASC'
  | 'UNIQUE_KEY_DESC'
  | 'UPDATE_VALUE_AT_ASC'
  | 'UPDATE_VALUE_AT_DESC'
  | 'USER_BY_CREATOR_USER_ID__ACTIVE_ASC'
  | 'USER_BY_CREATOR_USER_ID__ACTIVE_DESC'
  | 'USER_BY_CREATOR_USER_ID__ADDRESS_ASC'
  | 'USER_BY_CREATOR_USER_ID__ADDRESS_DESC'
  | 'USER_BY_CREATOR_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_CREATOR_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_CREATOR_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_CREATOR_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_CREATOR_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_CREATOR_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_CREATOR_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_CREATOR_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_CREATOR_USER_ID__CITY_ASC'
  | 'USER_BY_CREATOR_USER_ID__CITY_DESC'
  | 'USER_BY_CREATOR_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_CREATOR_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_CREATOR_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_CREATOR_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_CREATOR_USER_ID__CPR_ASC'
  | 'USER_BY_CREATOR_USER_ID__CPR_DESC'
  | 'USER_BY_CREATOR_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_CREATOR_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_CREATOR_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_CREATOR_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_CREATOR_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_CREATOR_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_CREATOR_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_CREATOR_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMAIL_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMAIL_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_CREATOR_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_CREATOR_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_CREATOR_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_CREATOR_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_CREATOR_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_CREATOR_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_CREATOR_USER_ID__GODMODE_ASC'
  | 'USER_BY_CREATOR_USER_ID__GODMODE_DESC'
  | 'USER_BY_CREATOR_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_CREATOR_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_CREATOR_USER_ID__ID_ASC'
  | 'USER_BY_CREATOR_USER_ID__ID_DESC'
  | 'USER_BY_CREATOR_USER_ID__INITIALS_ASC'
  | 'USER_BY_CREATOR_USER_ID__INITIALS_DESC'
  | 'USER_BY_CREATOR_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_CREATOR_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_CREATOR_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_CREATOR_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_CREATOR_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_CREATOR_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_CREATOR_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_CREATOR_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_CREATOR_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_CREATOR_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_CREATOR_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_CREATOR_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_CREATOR_USER_ID__MOBILE_ASC'
  | 'USER_BY_CREATOR_USER_ID__MOBILE_DESC'
  | 'USER_BY_CREATOR_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_CREATOR_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_CREATOR_USER_ID__PHONE_ASC'
  | 'USER_BY_CREATOR_USER_ID__PHONE_DESC'
  | 'USER_BY_CREATOR_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_CREATOR_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_CREATOR_USER_ID__SENIORITY_ASC'
  | 'USER_BY_CREATOR_USER_ID__SENIORITY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC'
  | 'VALUE_ASC'
  | 'VALUE_DESC';

/** Input for the nested mutation of `systemField` in the `FutureDatumInput` mutation. */
export type FutureDataSystemFieldIdForeignInput = {
  /** The primary key(s) for `systemField` for the far side of the relationship. */
  connectById?: InputMaybe<SystemFieldSystemFieldPkeyConnect>;
  /** The primary key(s) for `systemField` for the far side of the relationship. */
  connectByName?: InputMaybe<SystemFieldSystemFieldNameUniqueConnect>;
  /** The primary key(s) and patch data for `systemField` for the far side of the relationship. */
  updateById?: InputMaybe<SystemFieldOnFutureDatumForFutureDataSystemFieldIdForeignUsingSystemFieldPkeyUpdate>;
  /** The primary key(s) and patch data for `systemField` for the far side of the relationship. */
  updateByName?: InputMaybe<SystemFieldOnFutureDatumForFutureDataSystemFieldIdForeignUsingSystemFieldNameUniqueUpdate>;
};

/** Input for the nested mutation of `futureDatum` in the `SystemFieldInput` mutation. */
export type FutureDataSystemFieldIdForeignInverseInput = {
  /** The primary key(s) for `futureDatum` for the far side of the relationship. */
  connectByApprovalId?: InputMaybe<Array<FutureDatumFutureDataApprovalIdUniqueConnect>>;
  /** The primary key(s) for `futureDatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FutureDatumFutureDataPkeyConnect>>;
  /** The primary key(s) and patch data for `futureDatum` for the far side of the relationship. */
  updateByApprovalId?: InputMaybe<Array<FutureDatumOnFutureDatumForFutureDataSystemFieldIdForeignUsingFutureDataApprovalIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `futureDatum` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FutureDatumOnFutureDatumForFutureDataSystemFieldIdForeignUsingFutureDataPkeyUpdate>>;
};

/** Input for the nested mutation of `futureDatum` in the `UserInput` mutation. */
export type FutureDataUserIdForeignInverseInput = {
  /** The primary key(s) for `futureDatum` for the far side of the relationship. */
  connectByApprovalId?: InputMaybe<Array<FutureDatumFutureDataApprovalIdUniqueConnect>>;
  /** The primary key(s) for `futureDatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FutureDatumFutureDataPkeyConnect>>;
  /** The primary key(s) and patch data for `futureDatum` for the far side of the relationship. */
  updateByApprovalId?: InputMaybe<Array<FutureDatumOnFutureDatumForFutureDataUserIdForeignUsingFutureDataApprovalIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `futureDatum` for the far side of the relationship. */
  updateById?: InputMaybe<Array<FutureDatumOnFutureDatumForFutureDataUserIdForeignUsingFutureDataPkeyUpdate>>;
};

export type FutureDatum = {
  __typename?: 'FutureDatum';
  active: Scalars['Boolean'];
  applyImmediatelyOnApproval?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Approval` that is related to this `FutureDatum`. */
  approval?: Maybe<Approval>;
  approvalId?: Maybe<Scalars['UUID']>;
  approvalIsRequired?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Company` that is related to this `FutureDatum`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `FutureDatum`. */
  creatorUser?: Maybe<User>;
  creatorUserId: Scalars['UUID'];
  departmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `FieldGroup` that is related to this `FutureDatum`. */
  fieldGroup?: Maybe<FieldGroup>;
  fieldGroupId?: Maybe<Scalars['UUID']>;
  fieldId?: Maybe<Scalars['UUID']>;
  /** Reads a single `FormField` that is related to this `FutureDatum`. */
  formField?: Maybe<FormField>;
  formFieldEntryId?: Maybe<Scalars['UUID']>;
  formFieldId?: Maybe<Scalars['UUID']>;
  hasBeenApproved?: Maybe<Scalars['Boolean']>;
  hasBeenDenied?: Maybe<Scalars['Boolean']>;
  humanReadableValue?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  lastProcessedBy?: Maybe<User>;
  leaderDepartmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferencesByFutureDataId: NotificationEmployeeReferencesConnection;
  previousHumanReadableValue?: Maybe<Scalars['String']>;
  /** Reads a single `SystemField` that is related to this `FutureDatum`. */
  systemField?: Maybe<SystemField>;
  systemFieldId?: Maybe<Scalars['UUID']>;
  uniqueKey?: Maybe<Scalars['UUID']>;
  updateValueAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `User` that is related to this `FutureDatum`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
  value: Scalars['JSON'];
};


export type FutureDatumNotificationEmployeeReferencesByFutureDataIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};

/**
 * A condition to be used against `FutureDatum` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FutureDatumCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `approvalId` field. */
  approvalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `creatorUserId` field. */
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `fieldGroupId` field. */
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `leaderDepartmentIds` field. */
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `systemFieldId` field. */
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `uniqueKey` field. */
  uniqueKey?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updateValueAt` field. */
  updateValueAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['JSON']>;
};

/** A filter to be used against `FutureDatum` object types. All fields are combined with a logical ‘and.’ */
export type FutureDatumFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FutureDatumFilter>>;
  /** Filter by the object’s `applyImmediatelyOnApproval` field. */
  applyImmediatelyOnApproval?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `approval` relation. */
  approval?: InputMaybe<ApprovalFilter>;
  /** A related `approval` exists. */
  approvalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `approvalId` field. */
  approvalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `approvalIsRequired` field. */
  approvalIsRequired?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `creatorUser` relation. */
  creatorUser?: InputMaybe<UserFilter>;
  /** Filter by the object’s `creatorUserId` field. */
  creatorUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `fieldGroup` relation. */
  fieldGroup?: InputMaybe<FieldGroupFilter>;
  /** A related `fieldGroup` exists. */
  fieldGroupExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `fieldGroupId` field. */
  fieldGroupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fieldId` field. */
  fieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `formField` relation. */
  formField?: InputMaybe<FormFieldFilter>;
  /** Filter by the object’s `formFieldEntryId` field. */
  formFieldEntryId?: InputMaybe<UuidFilter>;
  /** A related `formField` exists. */
  formFieldExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `hasBeenApproved` field. */
  hasBeenApproved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `hasBeenDenied` field. */
  hasBeenDenied?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `leaderDepartmentIds` field. */
  leaderDepartmentIds?: InputMaybe<UuidListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FutureDatumFilter>;
  /** Filter by the object’s `notificationEmployeeReferencesByFutureDataId` relation. */
  notificationEmployeeReferencesByFutureDataId?: InputMaybe<FutureDatumToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferencesByFutureDataId` exist. */
  notificationEmployeeReferencesByFutureDataIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FutureDatumFilter>>;
  /** Filter by the object’s `systemField` relation. */
  systemField?: InputMaybe<SystemFieldFilter>;
  /** A related `systemField` exists. */
  systemFieldExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `systemFieldId` field. */
  systemFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `uniqueKey` field. */
  uniqueKey?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updateValueAt` field. */
  updateValueAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<JsonFilter>;
};

/** The fields on `futureDatum` to look up the row to connect. */
export type FutureDatumFutureDataApprovalIdUniqueConnect = {
  approvalId: Scalars['UUID'];
};

/** The fields on `futureDatum` to look up the row to connect. */
export type FutureDatumFutureDataPkeyConnect = {
  id: Scalars['UUID'];
};

/** An input for mutations affecting `FutureDatum` */
export type FutureDatumInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<FutureDataApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<FutureDataCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FutureDataFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FutureDataFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInverseInput>;
  systemField?: InputMaybe<FutureDataSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  uniqueKey?: InputMaybe<Scalars['UUID']>;
  updateValueAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FutureDataCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  value: Scalars['JSON'];
};

/** The fields on `futureDatum` to look up the row to update. */
export type FutureDatumOnFutureDatumForFutureDataApprovalIdForeignUsingFutureDataApprovalIdUniqueUpdate = {
  approvalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `futureDatum` being updated. */
  patch: UpdateFutureDatumOnFutureDatumForFutureDataApprovalIdForeignPatch;
};

/** The fields on `futureDatum` to look up the row to update. */
export type FutureDatumOnFutureDatumForFutureDataApprovalIdForeignUsingFutureDataPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `futureDatum` being updated. */
  patch: UpdateFutureDatumOnFutureDatumForFutureDataApprovalIdForeignPatch;
};

/** The fields on `futureDatum` to look up the row to update. */
export type FutureDatumOnFutureDatumForFutureDataCompanyIdForeignUsingFutureDataApprovalIdUniqueUpdate = {
  approvalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `futureDatum` being updated. */
  patch: UpdateFutureDatumOnFutureDatumForFutureDataCompanyIdForeignPatch;
};

/** The fields on `futureDatum` to look up the row to update. */
export type FutureDatumOnFutureDatumForFutureDataCompanyIdForeignUsingFutureDataPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `futureDatum` being updated. */
  patch: UpdateFutureDatumOnFutureDatumForFutureDataCompanyIdForeignPatch;
};

/** The fields on `futureDatum` to look up the row to update. */
export type FutureDatumOnFutureDatumForFutureDataCreatorUserIdForeignUsingFutureDataApprovalIdUniqueUpdate = {
  approvalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `futureDatum` being updated. */
  patch: UpdateFutureDatumOnFutureDatumForFutureDataCreatorUserIdForeignPatch;
};

/** The fields on `futureDatum` to look up the row to update. */
export type FutureDatumOnFutureDatumForFutureDataCreatorUserIdForeignUsingFutureDataPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `futureDatum` being updated. */
  patch: UpdateFutureDatumOnFutureDatumForFutureDataCreatorUserIdForeignPatch;
};

/** The fields on `futureDatum` to look up the row to update. */
export type FutureDatumOnFutureDatumForFutureDataFieldGroupIdForeignUsingFutureDataApprovalIdUniqueUpdate = {
  approvalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `futureDatum` being updated. */
  patch: UpdateFutureDatumOnFutureDatumForFutureDataFieldGroupIdForeignPatch;
};

/** The fields on `futureDatum` to look up the row to update. */
export type FutureDatumOnFutureDatumForFutureDataFieldGroupIdForeignUsingFutureDataPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `futureDatum` being updated. */
  patch: UpdateFutureDatumOnFutureDatumForFutureDataFieldGroupIdForeignPatch;
};

/** The fields on `futureDatum` to look up the row to update. */
export type FutureDatumOnFutureDatumForFutureDataFormFieldIdForeignUsingFutureDataApprovalIdUniqueUpdate = {
  approvalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `futureDatum` being updated. */
  patch: UpdateFutureDatumOnFutureDatumForFutureDataFormFieldIdForeignPatch;
};

/** The fields on `futureDatum` to look up the row to update. */
export type FutureDatumOnFutureDatumForFutureDataFormFieldIdForeignUsingFutureDataPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `futureDatum` being updated. */
  patch: UpdateFutureDatumOnFutureDatumForFutureDataFormFieldIdForeignPatch;
};

/** The fields on `futureDatum` to look up the row to update. */
export type FutureDatumOnFutureDatumForFutureDataSystemFieldIdForeignUsingFutureDataApprovalIdUniqueUpdate = {
  approvalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `futureDatum` being updated. */
  patch: UpdateFutureDatumOnFutureDatumForFutureDataSystemFieldIdForeignPatch;
};

/** The fields on `futureDatum` to look up the row to update. */
export type FutureDatumOnFutureDatumForFutureDataSystemFieldIdForeignUsingFutureDataPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `futureDatum` being updated. */
  patch: UpdateFutureDatumOnFutureDatumForFutureDataSystemFieldIdForeignPatch;
};

/** The fields on `futureDatum` to look up the row to update. */
export type FutureDatumOnFutureDatumForFutureDataUserIdForeignUsingFutureDataApprovalIdUniqueUpdate = {
  approvalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `futureDatum` being updated. */
  patch: UpdateFutureDatumOnFutureDatumForFutureDataUserIdForeignPatch;
};

/** The fields on `futureDatum` to look up the row to update. */
export type FutureDatumOnFutureDatumForFutureDataUserIdForeignUsingFutureDataPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `futureDatum` being updated. */
  patch: UpdateFutureDatumOnFutureDatumForFutureDataUserIdForeignPatch;
};

/** The fields on `futureDatum` to look up the row to update. */
export type FutureDatumOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFutureDataIdForeignUsingFutureDataApprovalIdUniqueUpdate = {
  approvalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `futureDatum` being updated. */
  patch: UpdateFutureDatumOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFutureDataIdForeignPatch;
};

/** The fields on `futureDatum` to look up the row to update. */
export type FutureDatumOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFutureDataIdForeignUsingFutureDataPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `futureDatum` being updated. */
  patch: UpdateFutureDatumOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFutureDataIdForeignPatch;
};

/** Represents an update to a `FutureDatum`. Fields that are set will be updated. */
export type FutureDatumPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<FutureDataApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<FutureDataCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FutureDataFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FutureDataFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInverseInput>;
  systemField?: InputMaybe<FutureDataSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  uniqueKey?: InputMaybe<Scalars['UUID']>;
  updateValueAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FutureDataCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['JSON']>;
};

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type FutureDatumToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

export type GeneratePdfInput = {
  base64: Scalars['String'];
};

export type GeneratePdfPayload = {
  __typename?: 'GeneratePDFPayload';
  pdf: Scalars['String'];
};

/** All input for the `getAnnouncementRecipients` mutation. */
export type GetAnnouncementRecipientsInput = {
  argAnnouncementId?: InputMaybe<Scalars['UUID']>;
  argCompanyId?: InputMaybe<Scalars['UUID']>;
  argNotificationId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `getAnnouncementRecipients` mutation. */
export type GetAnnouncementRecipientsPayload = {
  __typename?: 'GetAnnouncementRecipientsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  uuids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};

/** All input for the `getContractSignPendingSignatures` mutation. */
export type GetContractSignPendingSignaturesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `getContractSignPendingSignatures` mutation. */
export type GetContractSignPendingSignaturesPayload = {
  __typename?: 'GetContractSignPendingSignaturesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  results?: Maybe<Array<Maybe<GetContractSignPendingSignaturesRecord>>>;
};

/** The return type of our `getContractSignPendingSignatures` mutation. */
export type GetContractSignPendingSignaturesRecord = {
  __typename?: 'GetContractSignPendingSignaturesRecord';
  behalfFullName?: Maybe<Scalars['String']>;
  signDate?: Maybe<Scalars['Datetime']>;
  signOrder?: Maybe<Scalars['Int']>;
  signatureFileId?: Maybe<Scalars['UUID']>;
  userFullName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['UUID']>;
};

/** A connection to a list of `GetDirectManagerBasicInfoRecord` values. */
export type GetDirectManagerBasicInfoConnection = {
  __typename?: 'GetDirectManagerBasicInfoConnection';
  /** A list of edges which contains the `GetDirectManagerBasicInfoRecord` and cursor to aid in pagination. */
  edges: Array<GetDirectManagerBasicInfoEdge>;
  /** A list of `GetDirectManagerBasicInfoRecord` objects. */
  nodes: Array<Maybe<GetDirectManagerBasicInfoRecord>>;
  /** The count of *all* `GetDirectManagerBasicInfoRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GetDirectManagerBasicInfoRecord` edge in the connection. */
export type GetDirectManagerBasicInfoEdge = {
  __typename?: 'GetDirectManagerBasicInfoEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GetDirectManagerBasicInfoRecord` at the end of the edge. */
  node?: Maybe<GetDirectManagerBasicInfoRecord>;
};

/** The return type of our `getDirectManagerBasicInfo` query. */
export type GetDirectManagerBasicInfoRecord = {
  __typename?: 'GetDirectManagerBasicInfoRecord';
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  logo?: Maybe<Scalars['String']>;
};

/** A filter to be used against `GetDirectManagerBasicInfoRecord` object types. All fields are combined with a logical ‘and.’ */
export type GetDirectManagerBasicInfoRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GetDirectManagerBasicInfoRecordFilter>>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `logo` field. */
  logo?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GetDirectManagerBasicInfoRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GetDirectManagerBasicInfoRecordFilter>>;
};

export type GetEmployeeCsvFieldMappingInput = {
  csvFile: Scalars['Upload'];
  delimiter?: InputMaybe<Scalars['String']>;
};

export type GetEmployeeCsvFieldMappingPayload = {
  __typename?: 'GetEmployeeCsvFieldMappingPayload';
  mappings?: Maybe<Array<Maybe<CsvMapping>>>;
};

/** A connection to a list of `GetEmployeesBasicInfoRecord` values. */
export type GetEmployeesBasicInfoConnection = {
  __typename?: 'GetEmployeesBasicInfoConnection';
  /** A list of edges which contains the `GetEmployeesBasicInfoRecord` and cursor to aid in pagination. */
  edges: Array<GetEmployeesBasicInfoEdge>;
  /** A list of `GetEmployeesBasicInfoRecord` objects. */
  nodes: Array<Maybe<GetEmployeesBasicInfoRecord>>;
  /** The count of *all* `GetEmployeesBasicInfoRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GetEmployeesBasicInfoRecord` edge in the connection. */
export type GetEmployeesBasicInfoEdge = {
  __typename?: 'GetEmployeesBasicInfoEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GetEmployeesBasicInfoRecord` at the end of the edge. */
  node?: Maybe<GetEmployeesBasicInfoRecord>;
};

/** The return type of our `getEmployeesBasicInfo` query. */
export type GetEmployeesBasicInfoRecord = {
  __typename?: 'GetEmployeesBasicInfoRecord';
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  logo?: Maybe<Scalars['String']>;
};

/** A filter to be used against `GetEmployeesBasicInfoRecord` object types. All fields are combined with a logical ‘and.’ */
export type GetEmployeesBasicInfoRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GetEmployeesBasicInfoRecordFilter>>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `logo` field. */
  logo?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GetEmployeesBasicInfoRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GetEmployeesBasicInfoRecordFilter>>;
};

/** All input for the `getExternalEmployeeId` mutation. */
export type GetExternalEmployeeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `getExternalEmployeeId` mutation. */
export type GetExternalEmployeeIdPayload = {
  __typename?: 'GetExternalEmployeeIdPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  uuid?: Maybe<Scalars['UUID']>;
};

/** All input for the `getExternalIntegrations` mutation. */
export type GetExternalIntegrationsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `getExternalIntegrations` mutation. */
export type GetExternalIntegrationsPayload = {
  __typename?: 'GetExternalIntegrationsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  jsons?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type GetFieldLogPayload = {
  __typename?: 'GetFieldLogPayload';
  entries?: Maybe<Array<Maybe<FieldLogValue>>>;
};

export type GetGeneralHolidaysInput = {
  country: Scalars['String'];
  year?: InputMaybe<Scalars['Int']>;
};

export type GetGeneralHolidaysPayload = {
  __typename?: 'GetGeneralHolidaysPayload';
  holidays?: Maybe<Array<Maybe<Holiday>>>;
};

export type GetPlaceholdersWithInitialValuesInput = {
  date?: InputMaybe<Scalars['Date']>;
  documentTemplateId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

export type GetPlaceholdersWithInitialValuesPayload = {
  __typename?: 'GetPlaceholdersWithInitialValuesPayload';
  placeholders?: Maybe<Scalars['JSON']>;
};

/** All input for the `getPreboardingEmployeeProcesses` mutation. */
export type GetPreboardingEmployeeProcessesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `getPreboardingEmployeeProcesses` mutation. */
export type GetPreboardingEmployeeProcessesPayload = {
  __typename?: 'GetPreboardingEmployeeProcessesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  results?: Maybe<Array<Maybe<GetPreboardingEmployeeProcessesRecord>>>;
};

/** The return type of our `getPreboardingEmployeeProcesses` mutation. */
export type GetPreboardingEmployeeProcessesRecord = {
  __typename?: 'GetPreboardingEmployeeProcessesRecord';
  metadata?: Maybe<Scalars['JSON']>;
  value?: Maybe<Scalars['String']>;
};

/** A connection to a list of `GetPulseSurveyChartDataRecord` values. */
export type GetPulseSurveyChartDataConnection = {
  __typename?: 'GetPulseSurveyChartDataConnection';
  /** A list of edges which contains the `GetPulseSurveyChartDataRecord` and cursor to aid in pagination. */
  edges: Array<GetPulseSurveyChartDatumEdge>;
  /** A list of `GetPulseSurveyChartDataRecord` objects. */
  nodes: Array<Maybe<GetPulseSurveyChartDataRecord>>;
  /** The count of *all* `GetPulseSurveyChartDataRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The return type of our `getPulseSurveyChartData` query. */
export type GetPulseSurveyChartDataRecord = {
  __typename?: 'GetPulseSurveyChartDataRecord';
  average?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['Date']>;
  numberOfAnswers?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `GetPulseSurveyChartDataRecord` object types. All fields are combined with a logical ‘and.’ */
export type GetPulseSurveyChartDataRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GetPulseSurveyChartDataRecordFilter>>;
  /** Filter by the object’s `average` field. */
  average?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DateFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GetPulseSurveyChartDataRecordFilter>;
  /** Filter by the object’s `numberOfAnswers` field. */
  numberOfAnswers?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GetPulseSurveyChartDataRecordFilter>>;
};

/** A `GetPulseSurveyChartDataRecord` edge in the connection. */
export type GetPulseSurveyChartDatumEdge = {
  __typename?: 'GetPulseSurveyChartDatumEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GetPulseSurveyChartDataRecord` at the end of the edge. */
  node?: Maybe<GetPulseSurveyChartDataRecord>;
};

export type GetSupportedHolidayCountriesPayload = {
  __typename?: 'GetSupportedHolidayCountriesPayload';
  countries?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** A `GetWorkHoursLogsRecord` edge in the connection. */
export type GetWorkHoursLogEdge = {
  __typename?: 'GetWorkHoursLogEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GetWorkHoursLogsRecord` at the end of the edge. */
  node?: Maybe<GetWorkHoursLogsRecord>;
};

/** A connection to a list of `GetWorkHoursLogsRecord` values. */
export type GetWorkHoursLogsConnection = {
  __typename?: 'GetWorkHoursLogsConnection';
  /** A list of edges which contains the `GetWorkHoursLogsRecord` and cursor to aid in pagination. */
  edges: Array<GetWorkHoursLogEdge>;
  /** A list of `GetWorkHoursLogsRecord` objects. */
  nodes: Array<Maybe<GetWorkHoursLogsRecord>>;
  /** The count of *all* `GetWorkHoursLogsRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The return type of our `getWorkHoursLogs` query. */
export type GetWorkHoursLogsRecord = {
  __typename?: 'GetWorkHoursLogsRecord';
  actionTstampTx?: Maybe<Scalars['Datetime']>;
  id?: Maybe<Scalars['BigInt']>;
  loggedActionContext?: Maybe<Scalars['String']>;
  user?: Maybe<SimpleUser>;
};

/** A filter to be used against `GetWorkHoursLogsRecord` object types. All fields are combined with a logical ‘and.’ */
export type GetWorkHoursLogsRecordFilter = {
  /** Filter by the object’s `actionTstampTx` field. */
  actionTstampTx?: InputMaybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GetWorkHoursLogsRecordFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loggedActionContext` field. */
  loggedActionContext?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GetWorkHoursLogsRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GetWorkHoursLogsRecordFilter>>;
};

/** All input for the `giveDepartmentAdministratorsRank` mutation. */
export type GiveDepartmentAdministratorsRankInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `giveDepartmentAdministratorsRank` mutation. */
export type GiveDepartmentAdministratorsRankPayload = {
  __typename?: 'GiveDepartmentAdministratorsRankPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type GoogleFontsPayload = {
  __typename?: 'GoogleFontsPayload';
  fontFamilies?: Maybe<Scalars['JSON']>;
};

/** All input for the `grantAdditionalRole` mutation. */
export type GrantAdditionalRoleInput = {
  argAdditionalRole?: InputMaybe<Scalars['String']>;
  argExistingRole?: InputMaybe<Scalars['String']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `grantAdditionalRole` mutation. */
export type GrantAdditionalRolePayload = {
  __typename?: 'GrantAdditionalRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `grantAdditionalRoles` mutation. */
export type GrantAdditionalRolesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `grantAdditionalRoles` mutation. */
export type GrantAdditionalRolesPayload = {
  __typename?: 'GrantAdditionalRolesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type Group = {
  __typename?: 'Group';
  active: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `AuthApp`. */
  authApps: AuthAppsConnection;
  autoAdd?: Maybe<Scalars['Boolean']>;
  autoAddNewPermissions: Scalars['Boolean'];
  autoInherit: Scalars['Boolean'];
  companyId: Scalars['UUID'];
  description?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `GroupRole`. */
  groupRoles: GroupRolesConnection;
  id: Scalars['UUID'];
  localizedName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `NotificationGroupRecipient`. */
  notificationGroupRecipients: NotificationGroupRecipientsConnection;
  /** Reads and enables pagination through a set of `Preboarding`. */
  preboardingsByRecipientGroupId: PreboardingsConnection;
  scope?: Maybe<RoleScope>;
  scopeName?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `UserCompanyGroup`. */
  userCompanyGroups: UserCompanyGroupsConnection;
  /** Reads and enables pagination through a set of `UserDepartmentGroup`. */
  userDepartmentGroups: UserDepartmentGroupsConnection;
  /** Reads and enables pagination through a set of `UserGroup`. */
  userGroups: UserGroupsConnection;
};


export type GroupAuthAppsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AuthAppCondition>;
  filter?: InputMaybe<AuthAppFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AuthAppsOrderBy>>;
};


export type GroupGroupRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupRoleCondition>;
  filter?: InputMaybe<GroupRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupRolesOrderBy>>;
};


export type GroupNotificationGroupRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationGroupRecipientCondition>;
  filter?: InputMaybe<NotificationGroupRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationGroupRecipientsOrderBy>>;
};


export type GroupPreboardingsByRecipientGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingCondition>;
  filter?: InputMaybe<PreboardingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingsOrderBy>>;
};


export type GroupUserCompanyGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompanyGroupCondition>;
  filter?: InputMaybe<UserCompanyGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompanyGroupsOrderBy>>;
};


export type GroupUserDepartmentGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserDepartmentGroupCondition>;
  filter?: InputMaybe<UserDepartmentGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserDepartmentGroupsOrderBy>>;
};


export type GroupUserGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserGroupCondition>;
  filter?: InputMaybe<UserGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserGroupsOrderBy>>;
};

/** A condition to be used against `Group` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type GroupCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `autoAdd` field. */
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `autoAddNewPermissions` field. */
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `autoInherit` field. */
  autoInherit?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `localizedName` field. */
  localizedName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `scope` field. */
  scope?: InputMaybe<RoleScope>;
};

/** A filter to be used against `Group` object types. All fields are combined with a logical ‘and.’ */
export type GroupFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GroupFilter>>;
  /** Filter by the object’s `authApps` relation. */
  authApps?: InputMaybe<GroupToManyAuthAppFilter>;
  /** Some related `authApps` exist. */
  authAppsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `autoAdd` field. */
  autoAdd?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `autoAddNewPermissions` field. */
  autoAddNewPermissions?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `autoInherit` field. */
  autoInherit?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `groupRoles` relation. */
  groupRoles?: InputMaybe<GroupToManyGroupRoleFilter>;
  /** Some related `groupRoles` exist. */
  groupRolesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GroupFilter>;
  /** Filter by the object’s `notificationGroupRecipients` relation. */
  notificationGroupRecipients?: InputMaybe<GroupToManyNotificationGroupRecipientFilter>;
  /** Some related `notificationGroupRecipients` exist. */
  notificationGroupRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GroupFilter>>;
  /** Filter by the object’s `preboardingsByRecipientGroupId` relation. */
  preboardingsByRecipientGroupId?: InputMaybe<GroupToManyPreboardingFilter>;
  /** Some related `preboardingsByRecipientGroupId` exist. */
  preboardingsByRecipientGroupIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scope` field. */
  scope?: InputMaybe<RoleScopeFilter>;
  /** Filter by the object’s `userCompanyGroups` relation. */
  userCompanyGroups?: InputMaybe<GroupToManyUserCompanyGroupFilter>;
  /** Some related `userCompanyGroups` exist. */
  userCompanyGroupsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userDepartmentGroups` relation. */
  userDepartmentGroups?: InputMaybe<GroupToManyUserDepartmentGroupFilter>;
  /** Some related `userDepartmentGroups` exist. */
  userDepartmentGroupsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userGroups` relation. */
  userGroups?: InputMaybe<GroupToManyUserGroupFilter>;
  /** Some related `userGroups` exist. */
  userGroupsExist?: InputMaybe<Scalars['Boolean']>;
};

/** The fields on `group` to look up the row to connect. */
export type GroupGroupPkeyConnect = {
  id: Scalars['UUID'];
};

/** An input for mutations affecting `Group` */
export type GroupInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppTableGroupIdFkInverseInput>;
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  autoInherit?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  copyFromGroupId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientGroupIdForeignInverseInput>;
  scope?: InputMaybe<RoleScope>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupGroupIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupGroupIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupGroupIdForeignInverseInput>;
};

/** The fields on `group` to look up the row to update. */
export type GroupOnAuthAppForAuthAppTableGroupIdFkUsingGroupPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: UpdateGroupOnAuthAppForAuthAppTableGroupIdFkPatch;
};

/** The fields on `group` to look up the row to update. */
export type GroupOnGroupRoleForGroupRoleGroupIdForeignUsingGroupPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: UpdateGroupOnGroupRoleForGroupRoleGroupIdForeignPatch;
};

/** The fields on `group` to look up the row to update. */
export type GroupOnNotificationGroupRecipientForNotificationGroupRecipientGroupIdFkeyUsingGroupPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: UpdateGroupOnNotificationGroupRecipientForNotificationGroupRecipientGroupIdFkeyPatch;
};

/** The fields on `group` to look up the row to update. */
export type GroupOnPreboardingForPreboardingRecipientGroupIdForeignUsingGroupPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: UpdateGroupOnPreboardingForPreboardingRecipientGroupIdForeignPatch;
};

/** The fields on `group` to look up the row to update. */
export type GroupOnUserCompanyGroupForUserCompanyGroupGroupIdForeignUsingGroupPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: UpdateGroupOnUserCompanyGroupForUserCompanyGroupGroupIdForeignPatch;
};

/** The fields on `group` to look up the row to update. */
export type GroupOnUserDepartmentGroupForUserDepartmentGroupGroupIdForeignUsingGroupPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: UpdateGroupOnUserDepartmentGroupForUserDepartmentGroupGroupIdForeignPatch;
};

/** The fields on `group` to look up the row to update. */
export type GroupOnUserGroupForUserGroupGroupIdForeignUsingGroupPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: UpdateGroupOnUserGroupForUserGroupGroupIdForeignPatch;
};

/** Represents an update to a `Group`. Fields that are set will be updated. */
export type GroupPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppTableGroupIdFkInverseInput>;
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  autoInherit?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientGroupIdForeignInverseInput>;
  scope?: InputMaybe<RoleScope>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupGroupIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupGroupIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupGroupIdForeignInverseInput>;
};

export type GroupRole = {
  __typename?: 'GroupRole';
  /** Reads a single `Company` that is related to this `GroupRole`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `Group` that is related to this `GroupRole`. */
  group?: Maybe<Group>;
  groupId: Scalars['UUID'];
  itemIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Role` that is related to this `GroupRole`. */
  role?: Maybe<Role>;
  roleId: Scalars['UUID'];
};

/** The `groupRole` to be created by this mutation. */
export type GroupRoleCompanyIdFkeyConnectionGroupRoleCreateInput = {
  company?: InputMaybe<GroupRoleCompanyIdFkeyInput>;
  group?: InputMaybe<GroupRoleGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<GroupRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `GroupRoleInput` mutation. */
export type GroupRoleCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnGroupRoleForGroupRoleCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `groupRole` in the `CompanyInput` mutation. */
export type GroupRoleCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `groupRole` for the far side of the relationship. */
  connectByGroupIdAndRoleId?: InputMaybe<Array<GroupRoleGroupRolePkeyConnect>>;
  /** A `GroupRoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<GroupRoleCompanyIdFkeyConnectionGroupRoleCreateInput>>;
  /** The primary key(s) for `groupRole` for the far side of the relationship. */
  deleteByGroupIdAndRoleId?: InputMaybe<Array<GroupRoleGroupRolePkeyDelete>>;
  /** Flag indicating whether all other `groupRole` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `groupRole` for the far side of the relationship. */
  updateByGroupIdAndRoleId?: InputMaybe<Array<GroupRoleOnGroupRoleForGroupRoleCompanyIdFkeyUsingGroupRolePkeyUpdate>>;
};

/**
 * A condition to be used against `GroupRole` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GroupRoleCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `itemIds` field. */
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `roleId` field. */
  roleId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `GroupRole` object types. All fields are combined with a logical ‘and.’ */
export type GroupRoleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GroupRoleFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `group` relation. */
  group?: InputMaybe<GroupFilter>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `itemIds` field. */
  itemIds?: InputMaybe<UuidListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GroupRoleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GroupRoleFilter>>;
  /** Filter by the object’s `role` relation. */
  role?: InputMaybe<RoleFilter>;
  /** Filter by the object’s `roleId` field. */
  roleId?: InputMaybe<UuidFilter>;
};

/** The `group` to be created by this mutation. */
export type GroupRoleGroupIdForeignConnectionGroupCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppTableGroupIdFkInverseInput>;
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  autoInherit?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  copyFromGroupId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientGroupIdForeignInverseInput>;
  scope?: InputMaybe<RoleScope>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupGroupIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupGroupIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupGroupIdForeignInverseInput>;
};

/** The `groupRole` to be created by this mutation. */
export type GroupRoleGroupIdForeignConnectionGroupRoleCreateInput = {
  company?: InputMaybe<GroupRoleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<GroupRoleGroupIdForeignInput>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<GroupRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `group` in the `GroupRoleInput` mutation. */
export type GroupRoleGroupIdForeignInput = {
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectById?: InputMaybe<GroupGroupPkeyConnect>;
  /** A `GroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<GroupRoleGroupIdForeignConnectionGroupCreateInput>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateById?: InputMaybe<GroupOnGroupRoleForGroupRoleGroupIdForeignUsingGroupPkeyUpdate>;
};

/** Input for the nested mutation of `groupRole` in the `GroupInput` mutation. */
export type GroupRoleGroupIdForeignInverseInput = {
  /** The primary key(s) for `groupRole` for the far side of the relationship. */
  connectByGroupIdAndRoleId?: InputMaybe<Array<GroupRoleGroupRolePkeyConnect>>;
  /** A `GroupRoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<GroupRoleGroupIdForeignConnectionGroupRoleCreateInput>>;
  /** The primary key(s) for `groupRole` for the far side of the relationship. */
  deleteByGroupIdAndRoleId?: InputMaybe<Array<GroupRoleGroupRolePkeyDelete>>;
  /** Flag indicating whether all other `groupRole` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `groupRole` for the far side of the relationship. */
  updateByGroupIdAndRoleId?: InputMaybe<Array<GroupRoleOnGroupRoleForGroupRoleGroupIdForeignUsingGroupRolePkeyUpdate>>;
};

/** The fields on `groupRole` to look up the row to connect. */
export type GroupRoleGroupRolePkeyConnect = {
  groupId: Scalars['UUID'];
  roleId: Scalars['UUID'];
};

/** The fields on `groupRole` to look up the row to delete. */
export type GroupRoleGroupRolePkeyDelete = {
  groupId: Scalars['UUID'];
  roleId: Scalars['UUID'];
};

/** An input for mutations affecting `GroupRole` */
export type GroupRoleInput = {
  company?: InputMaybe<GroupRoleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<GroupRoleGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<GroupRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `groupRole` to look up the row to update. */
export type GroupRoleOnGroupRoleForGroupRoleCompanyIdFkeyUsingGroupRolePkeyUpdate = {
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `groupRole` being updated. */
  patch: UpdateGroupRoleOnGroupRoleForGroupRoleCompanyIdFkeyPatch;
  roleId: Scalars['UUID'];
};

/** The fields on `groupRole` to look up the row to update. */
export type GroupRoleOnGroupRoleForGroupRoleGroupIdForeignUsingGroupRolePkeyUpdate = {
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `groupRole` being updated. */
  patch: UpdateGroupRoleOnGroupRoleForGroupRoleGroupIdForeignPatch;
  roleId: Scalars['UUID'];
};

/** The fields on `groupRole` to look up the row to update. */
export type GroupRoleOnGroupRoleForGroupRoleRoleIdForeignUsingGroupRolePkeyUpdate = {
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `groupRole` being updated. */
  patch: UpdateGroupRoleOnGroupRoleForGroupRoleRoleIdForeignPatch;
  roleId: Scalars['UUID'];
};

/** Represents an update to a `GroupRole`. Fields that are set will be updated. */
export type GroupRolePatch = {
  company?: InputMaybe<GroupRoleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<GroupRoleGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<GroupRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
};

/** The `groupRole` to be created by this mutation. */
export type GroupRoleRoleIdForeignConnectionGroupRoleCreateInput = {
  company?: InputMaybe<GroupRoleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<GroupRoleGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<GroupRoleRoleIdForeignInput>;
};

/** The `role` to be created by this mutation. */
export type GroupRoleRoleIdForeignConnectionRoleCreateInput = {
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleRoleIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  info: Scalars['String'];
  name: Scalars['String'];
  relationRoles?: InputMaybe<RelationRoleRoleIdForeignInverseInput>;
  roleDependenciesToDependentOnUsingId?: InputMaybe<RoleDependencyDependentOnForeignInverseInput>;
  roleDependenciesToRoleIdUsingId?: InputMaybe<RoleDependencyRoleIdForeignInverseInput>;
  scopes?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleRoleIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleRoleIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleRoleIdForeignInverseInput>;
  usesItemIds?: InputMaybe<Scalars['Boolean']>;
};

/** Input for the nested mutation of `role` in the `GroupRoleInput` mutation. */
export type GroupRoleRoleIdForeignInput = {
  /** The primary key(s) for `role` for the far side of the relationship. */
  connectById?: InputMaybe<RoleRolePkeyConnect>;
  /** A `RoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<GroupRoleRoleIdForeignConnectionRoleCreateInput>;
  /** The primary key(s) for `role` for the far side of the relationship. */
  deleteById?: InputMaybe<RoleRolePkeyDelete>;
  /** The primary key(s) and patch data for `role` for the far side of the relationship. */
  updateById?: InputMaybe<RoleOnGroupRoleForGroupRoleRoleIdForeignUsingRolePkeyUpdate>;
};

/** Input for the nested mutation of `groupRole` in the `RoleInput` mutation. */
export type GroupRoleRoleIdForeignInverseInput = {
  /** The primary key(s) for `groupRole` for the far side of the relationship. */
  connectByGroupIdAndRoleId?: InputMaybe<Array<GroupRoleGroupRolePkeyConnect>>;
  /** A `GroupRoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<GroupRoleRoleIdForeignConnectionGroupRoleCreateInput>>;
  /** The primary key(s) for `groupRole` for the far side of the relationship. */
  deleteByGroupIdAndRoleId?: InputMaybe<Array<GroupRoleGroupRolePkeyDelete>>;
  /** Flag indicating whether all other `groupRole` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `groupRole` for the far side of the relationship. */
  updateByGroupIdAndRoleId?: InputMaybe<Array<GroupRoleOnGroupRoleForGroupRoleRoleIdForeignUsingGroupRolePkeyUpdate>>;
};

/** A connection to a list of `GroupRole` values. */
export type GroupRolesConnection = {
  __typename?: 'GroupRolesConnection';
  /** A list of edges which contains the `GroupRole` and cursor to aid in pagination. */
  edges: Array<GroupRolesEdge>;
  /** A list of `GroupRole` objects. */
  nodes: Array<Maybe<GroupRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GroupRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GroupRole` edge in the connection. */
export type GroupRolesEdge = {
  __typename?: 'GroupRolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GroupRole` at the end of the edge. */
  node?: Maybe<GroupRole>;
};

/** Methods to use when ordering `GroupRole`. */
export type GroupRolesOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'GROUP_BY_GROUP_ID__ACTIVE_ASC'
  | 'GROUP_BY_GROUP_ID__ACTIVE_DESC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_ASC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_DESC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_NEW_PERMISSIONS_ASC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_NEW_PERMISSIONS_DESC'
  | 'GROUP_BY_GROUP_ID__AUTO_INHERIT_ASC'
  | 'GROUP_BY_GROUP_ID__AUTO_INHERIT_DESC'
  | 'GROUP_BY_GROUP_ID__COMPANY_ID_ASC'
  | 'GROUP_BY_GROUP_ID__COMPANY_ID_DESC'
  | 'GROUP_BY_GROUP_ID__DESCRIPTION_ASC'
  | 'GROUP_BY_GROUP_ID__DESCRIPTION_DESC'
  | 'GROUP_BY_GROUP_ID__ID_ASC'
  | 'GROUP_BY_GROUP_ID__ID_DESC'
  | 'GROUP_BY_GROUP_ID__LOCALIZED_NAME_ASC'
  | 'GROUP_BY_GROUP_ID__LOCALIZED_NAME_DESC'
  | 'GROUP_BY_GROUP_ID__NAME_ASC'
  | 'GROUP_BY_GROUP_ID__NAME_DESC'
  | 'GROUP_BY_GROUP_ID__SCOPE_ASC'
  | 'GROUP_BY_GROUP_ID__SCOPE_DESC'
  | 'GROUP_ID_ASC'
  | 'GROUP_ID_DESC'
  | 'ITEM_IDS_ASC'
  | 'ITEM_IDS_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROLE_BY_ROLE_ID__COMPANY_ID_ASC'
  | 'ROLE_BY_ROLE_ID__COMPANY_ID_DESC'
  | 'ROLE_BY_ROLE_ID__DESCRIPTION_ASC'
  | 'ROLE_BY_ROLE_ID__DESCRIPTION_DESC'
  | 'ROLE_BY_ROLE_ID__ID_ASC'
  | 'ROLE_BY_ROLE_ID__ID_DESC'
  | 'ROLE_BY_ROLE_ID__INFO_ASC'
  | 'ROLE_BY_ROLE_ID__INFO_DESC'
  | 'ROLE_BY_ROLE_ID__NAME_ASC'
  | 'ROLE_BY_ROLE_ID__NAME_DESC'
  | 'ROLE_BY_ROLE_ID__SCOPES_ASC'
  | 'ROLE_BY_ROLE_ID__SCOPES_DESC'
  | 'ROLE_BY_ROLE_ID__USES_ITEM_IDS_ASC'
  | 'ROLE_BY_ROLE_ID__USES_ITEM_IDS_DESC'
  | 'ROLE_ID_ASC'
  | 'ROLE_ID_DESC';

/** A filter to be used against many `AuthApp` object types. All fields are combined with a logical ‘and.’ */
export type GroupToManyAuthAppFilter = {
  /** Every related `AuthApp` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuthAppFilter>;
  /** No related `AuthApp` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuthAppFilter>;
  /** Some related `AuthApp` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuthAppFilter>;
};

/** A filter to be used against many `GroupRole` object types. All fields are combined with a logical ‘and.’ */
export type GroupToManyGroupRoleFilter = {
  /** Every related `GroupRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GroupRoleFilter>;
  /** No related `GroupRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GroupRoleFilter>;
  /** Some related `GroupRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GroupRoleFilter>;
};

/** A filter to be used against many `NotificationGroupRecipient` object types. All fields are combined with a logical ‘and.’ */
export type GroupToManyNotificationGroupRecipientFilter = {
  /** Every related `NotificationGroupRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationGroupRecipientFilter>;
  /** No related `NotificationGroupRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationGroupRecipientFilter>;
  /** Some related `NotificationGroupRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationGroupRecipientFilter>;
};

/** A filter to be used against many `Preboarding` object types. All fields are combined with a logical ‘and.’ */
export type GroupToManyPreboardingFilter = {
  /** Every related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingFilter>;
  /** No related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingFilter>;
  /** Some related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingFilter>;
};

/** A filter to be used against many `UserCompanyGroup` object types. All fields are combined with a logical ‘and.’ */
export type GroupToManyUserCompanyGroupFilter = {
  /** Every related `UserCompanyGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCompanyGroupFilter>;
  /** No related `UserCompanyGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCompanyGroupFilter>;
  /** Some related `UserCompanyGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCompanyGroupFilter>;
};

/** A filter to be used against many `UserDepartmentGroup` object types. All fields are combined with a logical ‘and.’ */
export type GroupToManyUserDepartmentGroupFilter = {
  /** Every related `UserDepartmentGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserDepartmentGroupFilter>;
  /** No related `UserDepartmentGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserDepartmentGroupFilter>;
  /** Some related `UserDepartmentGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserDepartmentGroupFilter>;
};

/** A filter to be used against many `UserGroup` object types. All fields are combined with a logical ‘and.’ */
export type GroupToManyUserGroupFilter = {
  /** Every related `UserGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserGroupFilter>;
  /** No related `UserGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserGroupFilter>;
  /** Some related `UserGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserGroupFilter>;
};

/** A connection to a list of `Group` values. */
export type GroupsConnection = {
  __typename?: 'GroupsConnection';
  /** A list of edges which contains the `Group` and cursor to aid in pagination. */
  edges: Array<GroupsEdge>;
  /** A list of `Group` objects. */
  nodes: Array<Maybe<Group>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Group` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Group` edge in the connection. */
export type GroupsEdge = {
  __typename?: 'GroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Group` at the end of the edge. */
  node?: Maybe<Group>;
};

/** Methods to use when ordering `Group`. */
export type GroupsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'AUTH_APPS_BY_GROUP_ID__COUNT_ASC'
  | 'AUTH_APPS_BY_GROUP_ID__COUNT_DESC'
  | 'AUTO_ADD_ASC'
  | 'AUTO_ADD_DESC'
  | 'AUTO_ADD_NEW_PERMISSIONS_ASC'
  | 'AUTO_ADD_NEW_PERMISSIONS_DESC'
  | 'AUTO_INHERIT_ASC'
  | 'AUTO_INHERIT_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'GROUP_ROLES_BY_GROUP_ID__COUNT_ASC'
  | 'GROUP_ROLES_BY_GROUP_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALIZED_NAME_ASC'
  | 'LOCALIZED_NAME_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_GROUP_RECIPIENTS_BY_GROUP_ID__COUNT_ASC'
  | 'NOTIFICATION_GROUP_RECIPIENTS_BY_GROUP_ID__COUNT_DESC'
  | 'PREBOARDINGS_BY_RECIPIENT_GROUP_ID__COUNT_ASC'
  | 'PREBOARDINGS_BY_RECIPIENT_GROUP_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SCOPE_ASC'
  | 'SCOPE_DESC'
  | 'USER_COMPANY_GROUPS_BY_GROUP_ID__COUNT_ASC'
  | 'USER_COMPANY_GROUPS_BY_GROUP_ID__COUNT_DESC'
  | 'USER_DEPARTMENT_GROUPS_BY_GROUP_ID__COUNT_ASC'
  | 'USER_DEPARTMENT_GROUPS_BY_GROUP_ID__COUNT_DESC'
  | 'USER_GROUPS_BY_GROUP_ID__COUNT_ASC'
  | 'USER_GROUPS_BY_GROUP_ID__COUNT_DESC';

/** All input for the `hasSuperUserAccess` mutation. */
export type HasSuperUserAccessInput = {
  argCompanyBlacklist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  argCompanyWhitelist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `hasSuperUserAccess` mutation. */
export type HasSuperUserAccessPayload = {
  __typename?: 'HasSuperUserAccessPayload';
  boolean?: Maybe<Scalars['Boolean']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type Holiday = {
  __typename?: 'Holiday';
  date?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Datetime']>;
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Datetime']>;
};

export type Hook = {
  __typename?: 'Hook';
  alwaysSend: Scalars['Boolean'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `Notification`. */
  notifications: NotificationsConnection;
};


export type HookNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** A condition to be used against `Hook` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type HookCondition = {
  /** Checks for equality with the object’s `alwaysSend` field. */
  alwaysSend?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Hook` object types. All fields are combined with a logical ‘and.’ */
export type HookFilter = {
  /** Filter by the object’s `alwaysSend` field. */
  alwaysSend?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<HookFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<HookFilter>;
  /** Filter by the object’s `notifications` relation. */
  notifications?: InputMaybe<HookToManyNotificationFilter>;
  /** Some related `notifications` exist. */
  notificationsExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<HookFilter>>;
};

/** The fields on `hook` to look up the row to connect. */
export type HookHookNameUniqueConnect = {
  name: Scalars['String'];
};

/** The fields on `hook` to look up the row to connect. */
export type HookHookPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `hook` to look up the row to update. */
export type HookOnNotificationForNotificationHookIdForeignUsingHookNameUniqueUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `hook` being updated. */
  patch: UpdateHookOnNotificationForNotificationHookIdForeignPatch;
};

/** The fields on `hook` to look up the row to update. */
export type HookOnNotificationForNotificationHookIdForeignUsingHookPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `hook` being updated. */
  patch: UpdateHookOnNotificationForNotificationHookIdForeignPatch;
};

/** A filter to be used against many `Notification` object types. All fields are combined with a logical ‘and.’ */
export type HookToManyNotificationFilter = {
  /** Every related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationFilter>;
  /** No related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationFilter>;
  /** Some related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationFilter>;
};

/** A connection to a list of `Hook` values. */
export type HooksConnection = {
  __typename?: 'HooksConnection';
  /** A list of edges which contains the `Hook` and cursor to aid in pagination. */
  edges: Array<HooksEdge>;
  /** A list of `Hook` objects. */
  nodes: Array<Maybe<Hook>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Hook` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Hook` edge in the connection. */
export type HooksEdge = {
  __typename?: 'HooksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Hook` at the end of the edge. */
  node?: Maybe<Hook>;
};

/** Methods to use when ordering `Hook`. */
export type HooksOrderBy =
  | 'ALWAYS_SEND_ASC'
  | 'ALWAYS_SEND_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'NOTIFICATIONS_BY_HOOK_ID__COUNT_ASC'
  | 'NOTIFICATIONS_BY_HOOK_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type HtmlToPdfInput = {
  appendSignaturePage?: InputMaybe<Scalars['Boolean']>;
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  existingStorageId?: InputMaybe<Scalars['UUID']>;
  footer?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  html: Scalars['String'];
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  placeholders?: InputMaybe<Scalars['JSON']>;
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
  signatureBase64?: InputMaybe<Scalars['String']>;
  signatureFileId?: InputMaybe<Scalars['UUID']>;
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type HtmlToPdfPayload = {
  __typename?: 'HtmlToPdfPayload';
  base64: Scalars['String'];
  errors?: Maybe<Array<Scalars['String']>>;
};

export type I18onInput = {
  locale: Scalars['String'];
  strings: Array<Scalars['String']>;
};

export type ImportEmployeesFromFileInput = {
  delimiter?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  mappings: Array<CsvMappingInput>;
  sendPasswordToEmails: Scalars['Boolean'];
  useDefaultCustomFieldValues: Scalars['Boolean'];
};

export type ImportEquipmentFromFileInput = {
  file: Scalars['Upload'];
  overwrite: Scalars['Boolean'];
  useDefaultCustomFieldValues: Scalars['Boolean'];
};

/** Indicates whether archived items should be included in the results or not. */
export type IncludeArchivedOption =
  /** Only include archived items (i.e. exclude non-archived items). */
  | 'EXCLUSIVELY'
  /** If there is a parent GraphQL record and it is archived then this is equivalent to YES, in all other cases this is equivalent to NO. */
  | 'INHERIT'
  /** Exclude archived items. */
  | 'NO'
  /** Include archived items. */
  | 'YES';

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

/** A filter to be used against Int List fields. All fields are combined with a logical ‘and.’ */
export type IntListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['Int']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['Int']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['Int']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['Int']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type IntegrableSystem = {
  __typename?: 'IntegrableSystem';
  authUrl: Scalars['String'];
  createUrl: Scalars['String'];
  deleteUrl: Scalars['String'];
  description: Scalars['String'];
  /** Reads and enables pagination through a set of `ExternalIntegration`. */
  externalIntegrations: ExternalIntegrationsConnection;
  homepageUrl: Scalars['String'];
  id: Scalars['UUID'];
  isBeta: Scalars['Boolean'];
  legalDescription?: Maybe<Scalars['String']>;
  loginUrl?: Maybe<Scalars['String']>;
  logo: Scalars['String'];
  name: Scalars['String'];
  settingsUrl?: Maybe<Scalars['String']>;
};


export type IntegrableSystemExternalIntegrationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalIntegrationCondition>;
  filter?: InputMaybe<ExternalIntegrationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalIntegrationsOrderBy>>;
};

/**
 * A condition to be used against `IntegrableSystem` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type IntegrableSystemCondition = {
  /** Checks for equality with the object’s `authUrl` field. */
  authUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createUrl` field. */
  createUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `deleteUrl` field. */
  deleteUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `homepageUrl` field. */
  homepageUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isBeta` field. */
  isBeta?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `legalDescription` field. */
  legalDescription?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `loginUrl` field. */
  loginUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `logo` field. */
  logo?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `settingsUrl` field. */
  settingsUrl?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `IntegrableSystem` object types. All fields are combined with a logical ‘and.’ */
export type IntegrableSystemFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IntegrableSystemFilter>>;
  /** Filter by the object’s `authUrl` field. */
  authUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createUrl` field. */
  createUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deleteUrl` field. */
  deleteUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalIntegrations` relation. */
  externalIntegrations?: InputMaybe<IntegrableSystemToManyExternalIntegrationFilter>;
  /** Some related `externalIntegrations` exist. */
  externalIntegrationsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `homepageUrl` field. */
  homepageUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isBeta` field. */
  isBeta?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `legalDescription` field. */
  legalDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `loginUrl` field. */
  loginUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `logo` field. */
  logo?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<IntegrableSystemFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IntegrableSystemFilter>>;
  /** Filter by the object’s `settingsUrl` field. */
  settingsUrl?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `IntegrableSystem` */
export type IntegrableSystemInput = {
  authUrl: Scalars['String'];
  createUrl: Scalars['String'];
  deleteUrl: Scalars['String'];
  description: Scalars['String'];
  externalIntegrations?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInverseInput>;
  homepageUrl: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  isBeta?: InputMaybe<Scalars['Boolean']>;
  legalDescription?: InputMaybe<Scalars['String']>;
  loginUrl?: InputMaybe<Scalars['String']>;
  logo: Scalars['String'];
  name: Scalars['String'];
  settingsUrl?: InputMaybe<Scalars['String']>;
};

/** The fields on `integrableSystem` to look up the row to connect. */
export type IntegrableSystemIntegrableSystemPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `integrableSystem` to look up the row to delete. */
export type IntegrableSystemIntegrableSystemPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `integrableSystem` to look up the row to update. */
export type IntegrableSystemOnExternalIntegrationForExternalIntegrationIntegrableSystemIdFkeyUsingIntegrableSystemPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrableSystem` being updated. */
  patch: UpdateIntegrableSystemOnExternalIntegrationForExternalIntegrationIntegrableSystemIdFkeyPatch;
};

/** Represents an update to a `IntegrableSystem`. Fields that are set will be updated. */
export type IntegrableSystemPatch = {
  authUrl?: InputMaybe<Scalars['String']>;
  createUrl?: InputMaybe<Scalars['String']>;
  deleteUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegrations?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInverseInput>;
  homepageUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isBeta?: InputMaybe<Scalars['Boolean']>;
  legalDescription?: InputMaybe<Scalars['String']>;
  loginUrl?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  settingsUrl?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against many `ExternalIntegration` object types. All fields are combined with a logical ‘and.’ */
export type IntegrableSystemToManyExternalIntegrationFilter = {
  /** Every related `ExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExternalIntegrationFilter>;
  /** No related `ExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExternalIntegrationFilter>;
  /** Some related `ExternalIntegration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExternalIntegrationFilter>;
};

/** A connection to a list of `IntegrableSystem` values. */
export type IntegrableSystemsConnection = {
  __typename?: 'IntegrableSystemsConnection';
  /** A list of edges which contains the `IntegrableSystem` and cursor to aid in pagination. */
  edges: Array<IntegrableSystemsEdge>;
  /** A list of `IntegrableSystem` objects. */
  nodes: Array<Maybe<IntegrableSystem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IntegrableSystem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `IntegrableSystem` edge in the connection. */
export type IntegrableSystemsEdge = {
  __typename?: 'IntegrableSystemsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `IntegrableSystem` at the end of the edge. */
  node?: Maybe<IntegrableSystem>;
};

/** Methods to use when ordering `IntegrableSystem`. */
export type IntegrableSystemsOrderBy =
  | 'AUTH_URL_ASC'
  | 'AUTH_URL_DESC'
  | 'CREATE_URL_ASC'
  | 'CREATE_URL_DESC'
  | 'DELETE_URL_ASC'
  | 'DELETE_URL_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'EXTERNAL_INTEGRATIONS_BY_INTEGRABLE_SYSTEM_ID__COUNT_ASC'
  | 'EXTERNAL_INTEGRATIONS_BY_INTEGRABLE_SYSTEM_ID__COUNT_DESC'
  | 'HOMEPAGE_URL_ASC'
  | 'HOMEPAGE_URL_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IS_BETA_ASC'
  | 'IS_BETA_DESC'
  | 'LEGAL_DESCRIPTION_ASC'
  | 'LEGAL_DESCRIPTION_DESC'
  | 'LOGIN_URL_ASC'
  | 'LOGIN_URL_DESC'
  | 'LOGO_ASC'
  | 'LOGO_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SETTINGS_URL_ASC'
  | 'SETTINGS_URL_DESC';

export type IntegrationFieldMarking = {
  __typename?: 'IntegrationFieldMarking';
  active: Scalars['Boolean'];
  /** Reads a single `AuthApp` that is related to this `IntegrationFieldMarking`. */
  authApp?: Maybe<AuthApp>;
  authAppId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Company` that is related to this `IntegrationFieldMarking`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  departmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  description?: Maybe<Scalars['String']>;
  /** Reads a single `ExternalIntegration` that is related to this `IntegrationFieldMarking`. */
  externalIntegration?: Maybe<ExternalIntegration>;
  externalIntegrationId?: Maybe<Scalars['UUID']>;
  /** Reads a single `FormField` that is related to this `IntegrationFieldMarking`. */
  formField?: Maybe<FormField>;
  formFieldId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  integrationName: Scalars['String'];
  receivesData: Scalars['Boolean'];
  sendsData: Scalars['Boolean'];
  /** Reads a single `Storage` that is related to this `IntegrationFieldMarking`. */
  storage?: Maybe<Storage>;
  storageId?: Maybe<Scalars['UUID']>;
  /** Reads a single `SystemField` that is related to this `IntegrationFieldMarking`. */
  systemField?: Maybe<SystemField>;
  systemFieldId?: Maybe<Scalars['UUID']>;
  updatedAt: Scalars['Datetime'];
};

/** The `integrationFieldMarking` to be created by this mutation. */
export type IntegrationFieldMarkingAuthAppIdFkeyConnectionIntegrationFieldMarkingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInput>;
  company?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInput>;
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationName: Scalars['String'];
  receivesData?: InputMaybe<Scalars['Boolean']>;
  sendsData?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `authApp` in the `IntegrationFieldMarkingInput` mutation. */
export type IntegrationFieldMarkingAuthAppIdFkeyInput = {
  /** The primary key(s) for `authApp` for the far side of the relationship. */
  connectById?: InputMaybe<AuthAppAuthAppPkeyConnect>;
  /** The primary key(s) and patch data for `authApp` for the far side of the relationship. */
  updateById?: InputMaybe<AuthAppOnIntegrationFieldMarkingForIntegrationFieldMarkingAuthAppIdFkeyUsingAuthAppPkeyUpdate>;
};

/** Input for the nested mutation of `integrationFieldMarking` in the `AuthAppInput` mutation. */
export type IntegrationFieldMarkingAuthAppIdFkeyInverseInput = {
  /** The primary key(s) for `integrationFieldMarking` for the far side of the relationship. */
  connectByCompanyIdAndExternalIntegrationIdAndFormFieldId?: InputMaybe<Array<IntegrationFieldMarkingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyConnect>>;
  /** The primary key(s) for `integrationFieldMarking` for the far side of the relationship. */
  connectByCompanyIdAndExternalIntegrationIdAndSystemFieldId?: InputMaybe<Array<IntegrationFieldMarkingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Connect>>;
  /** The primary key(s) for `integrationFieldMarking` for the far side of the relationship. */
  connectById?: InputMaybe<Array<IntegrationFieldMarkingIntegrationFieldMarkingPkeyConnect>>;
  /** A `IntegrationFieldMarkingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<IntegrationFieldMarkingAuthAppIdFkeyConnectionIntegrationFieldMarkingCreateInput>>;
  /** The primary key(s) and patch data for `integrationFieldMarking` for the far side of the relationship. */
  updateByCompanyIdAndExternalIntegrationIdAndFormFieldId?: InputMaybe<Array<IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingAuthAppIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyUpdate>>;
  /** The primary key(s) and patch data for `integrationFieldMarking` for the far side of the relationship. */
  updateByCompanyIdAndExternalIntegrationIdAndSystemFieldId?: InputMaybe<Array<IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingAuthAppIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Update>>;
  /** The primary key(s) and patch data for `integrationFieldMarking` for the far side of the relationship. */
  updateById?: InputMaybe<Array<IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingAuthAppIdFkeyUsingIntegrationFieldMarkingPkeyUpdate>>;
};

/** The `integrationFieldMarking` to be created by this mutation. */
export type IntegrationFieldMarkingCompanyIdFkeyConnectionIntegrationFieldMarkingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInput>;
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationName: Scalars['String'];
  receivesData?: InputMaybe<Scalars['Boolean']>;
  sendsData?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `company` in the `IntegrationFieldMarkingInput` mutation. */
export type IntegrationFieldMarkingCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnIntegrationFieldMarkingForIntegrationFieldMarkingCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `integrationFieldMarking` in the `CompanyInput` mutation. */
export type IntegrationFieldMarkingCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `integrationFieldMarking` for the far side of the relationship. */
  connectByCompanyIdAndExternalIntegrationIdAndFormFieldId?: InputMaybe<Array<IntegrationFieldMarkingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyConnect>>;
  /** The primary key(s) for `integrationFieldMarking` for the far side of the relationship. */
  connectByCompanyIdAndExternalIntegrationIdAndSystemFieldId?: InputMaybe<Array<IntegrationFieldMarkingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Connect>>;
  /** The primary key(s) for `integrationFieldMarking` for the far side of the relationship. */
  connectById?: InputMaybe<Array<IntegrationFieldMarkingIntegrationFieldMarkingPkeyConnect>>;
  /** A `IntegrationFieldMarkingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<IntegrationFieldMarkingCompanyIdFkeyConnectionIntegrationFieldMarkingCreateInput>>;
  /** The primary key(s) and patch data for `integrationFieldMarking` for the far side of the relationship. */
  updateByCompanyIdAndExternalIntegrationIdAndFormFieldId?: InputMaybe<Array<IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingCompanyIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyUpdate>>;
  /** The primary key(s) and patch data for `integrationFieldMarking` for the far side of the relationship. */
  updateByCompanyIdAndExternalIntegrationIdAndSystemFieldId?: InputMaybe<Array<IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingCompanyIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Update>>;
  /** The primary key(s) and patch data for `integrationFieldMarking` for the far side of the relationship. */
  updateById?: InputMaybe<Array<IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingCompanyIdFkeyUsingIntegrationFieldMarkingPkeyUpdate>>;
};

/**
 * A condition to be used against `IntegrationFieldMarking` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type IntegrationFieldMarkingCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `authAppId` field. */
  authAppId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `externalIntegrationId` field. */
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `integrationName` field. */
  integrationName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `receivesData` field. */
  receivesData?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `sendsData` field. */
  sendsData?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `storageId` field. */
  storageId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `systemFieldId` field. */
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `externalIntegration` to be created by this mutation. */
export type IntegrationFieldMarkingExternalIntegrationIdFkeyConnectionExternalIntegrationCreateInput = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<ExternalIntegrationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  documentFolderBlueprint?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput>;
  documentType?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput>;
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  externalCompanyId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInput>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrableSystem?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInput>;
  integrableSystemId?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput>;
  payslipDocumentBlueprintFolderId?: InputMaybe<Scalars['UUID']>;
  payslipDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** The `integrationFieldMarking` to be created by this mutation. */
export type IntegrationFieldMarkingExternalIntegrationIdFkeyConnectionIntegrationFieldMarkingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInput>;
  formField?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationName: Scalars['String'];
  receivesData?: InputMaybe<Scalars['Boolean']>;
  sendsData?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `externalIntegration` in the `IntegrationFieldMarkingInput` mutation. */
export type IntegrationFieldMarkingExternalIntegrationIdFkeyInput = {
  /** The primary key(s) for `externalIntegration` for the far side of the relationship. */
  connectById?: InputMaybe<ExternalIntegrationExternalIntegrationPkeyConnect>;
  /** A `ExternalIntegrationInput` object that will be created and connected to this object. */
  create?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyConnectionExternalIntegrationCreateInput>;
  /** The primary key(s) for `externalIntegration` for the far side of the relationship. */
  deleteById?: InputMaybe<ExternalIntegrationExternalIntegrationPkeyDelete>;
  /** The primary key(s) and patch data for `externalIntegration` for the far side of the relationship. */
  updateById?: InputMaybe<ExternalIntegrationOnIntegrationFieldMarkingForIntegrationFieldMarkingExternalIntegrationIdFkeyUsingExternalIntegrationPkeyUpdate>;
};

/** Input for the nested mutation of `integrationFieldMarking` in the `ExternalIntegrationInput` mutation. */
export type IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput = {
  /** The primary key(s) for `integrationFieldMarking` for the far side of the relationship. */
  connectByCompanyIdAndExternalIntegrationIdAndFormFieldId?: InputMaybe<Array<IntegrationFieldMarkingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyConnect>>;
  /** The primary key(s) for `integrationFieldMarking` for the far side of the relationship. */
  connectByCompanyIdAndExternalIntegrationIdAndSystemFieldId?: InputMaybe<Array<IntegrationFieldMarkingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Connect>>;
  /** The primary key(s) for `integrationFieldMarking` for the far side of the relationship. */
  connectById?: InputMaybe<Array<IntegrationFieldMarkingIntegrationFieldMarkingPkeyConnect>>;
  /** A `IntegrationFieldMarkingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<IntegrationFieldMarkingExternalIntegrationIdFkeyConnectionIntegrationFieldMarkingCreateInput>>;
  /** The primary key(s) and patch data for `integrationFieldMarking` for the far side of the relationship. */
  updateByCompanyIdAndExternalIntegrationIdAndFormFieldId?: InputMaybe<Array<IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingExternalIntegrationIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyUpdate>>;
  /** The primary key(s) and patch data for `integrationFieldMarking` for the far side of the relationship. */
  updateByCompanyIdAndExternalIntegrationIdAndSystemFieldId?: InputMaybe<Array<IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingExternalIntegrationIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Update>>;
  /** The primary key(s) and patch data for `integrationFieldMarking` for the far side of the relationship. */
  updateById?: InputMaybe<Array<IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingExternalIntegrationIdFkeyUsingIntegrationFieldMarkingPkeyUpdate>>;
};

/** A filter to be used against `IntegrationFieldMarking` object types. All fields are combined with a logical ‘and.’ */
export type IntegrationFieldMarkingFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IntegrationFieldMarkingFilter>>;
  /** Filter by the object’s `authApp` relation. */
  authApp?: InputMaybe<AuthAppFilter>;
  /** A related `authApp` exists. */
  authAppExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `authAppId` field. */
  authAppId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalIntegration` relation. */
  externalIntegration?: InputMaybe<ExternalIntegrationFilter>;
  /** A related `externalIntegration` exists. */
  externalIntegrationExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `externalIntegrationId` field. */
  externalIntegrationId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `formField` relation. */
  formField?: InputMaybe<FormFieldFilter>;
  /** A related `formField` exists. */
  formFieldExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `integrationName` field. */
  integrationName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<IntegrationFieldMarkingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IntegrationFieldMarkingFilter>>;
  /** Filter by the object’s `receivesData` field. */
  receivesData?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sendsData` field. */
  sendsData?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `storage` relation. */
  storage?: InputMaybe<StorageFilter>;
  /** A related `storage` exists. */
  storageExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `storageId` field. */
  storageId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `systemField` relation. */
  systemField?: InputMaybe<SystemFieldFilter>;
  /** A related `systemField` exists. */
  systemFieldExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `systemFieldId` field. */
  systemFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** The `formField` to be created by this mutation. */
export type IntegrationFieldMarkingFormFieldIdFkeyConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `integrationFieldMarking` to be created by this mutation. */
export type IntegrationFieldMarkingFormFieldIdFkeyConnectionIntegrationFieldMarkingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInput>;
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationName: Scalars['String'];
  receivesData?: InputMaybe<Scalars['Boolean']>;
  sendsData?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `formField` in the `IntegrationFieldMarkingInput` mutation. */
export type IntegrationFieldMarkingFormFieldIdFkeyInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<FormFieldFormFieldPkeyConnect>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyConnectionFormFieldCreateInput>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<FormFieldOnIntegrationFieldMarkingForIntegrationFieldMarkingFormFieldIdFkeyUsingFormFieldPkeyUpdate>;
};

/** Input for the nested mutation of `integrationFieldMarking` in the `FormFieldInput` mutation. */
export type IntegrationFieldMarkingFormFieldIdFkeyInverseInput = {
  /** The primary key(s) for `integrationFieldMarking` for the far side of the relationship. */
  connectByCompanyIdAndExternalIntegrationIdAndFormFieldId?: InputMaybe<Array<IntegrationFieldMarkingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyConnect>>;
  /** The primary key(s) for `integrationFieldMarking` for the far side of the relationship. */
  connectByCompanyIdAndExternalIntegrationIdAndSystemFieldId?: InputMaybe<Array<IntegrationFieldMarkingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Connect>>;
  /** The primary key(s) for `integrationFieldMarking` for the far side of the relationship. */
  connectById?: InputMaybe<Array<IntegrationFieldMarkingIntegrationFieldMarkingPkeyConnect>>;
  /** A `IntegrationFieldMarkingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<IntegrationFieldMarkingFormFieldIdFkeyConnectionIntegrationFieldMarkingCreateInput>>;
  /** The primary key(s) and patch data for `integrationFieldMarking` for the far side of the relationship. */
  updateByCompanyIdAndExternalIntegrationIdAndFormFieldId?: InputMaybe<Array<IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingFormFieldIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyUpdate>>;
  /** The primary key(s) and patch data for `integrationFieldMarking` for the far side of the relationship. */
  updateByCompanyIdAndExternalIntegrationIdAndSystemFieldId?: InputMaybe<Array<IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingFormFieldIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Update>>;
  /** The primary key(s) and patch data for `integrationFieldMarking` for the far side of the relationship. */
  updateById?: InputMaybe<Array<IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingFormFieldIdFkeyUsingIntegrationFieldMarkingPkeyUpdate>>;
};

/** An input for mutations affecting `IntegrationFieldMarking` */
export type IntegrationFieldMarkingInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInput>;
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationName: Scalars['String'];
  receivesData?: InputMaybe<Scalars['Boolean']>;
  sendsData?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `integrationFieldMarking` to look up the row to connect. */
export type IntegrationFieldMarkingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyConnect = {
  companyId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  formFieldId: Scalars['UUID'];
};

/** The fields on `integrationFieldMarking` to look up the row to connect. */
export type IntegrationFieldMarkingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Connect = {
  companyId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  systemFieldId: Scalars['UUID'];
};

/** The fields on `integrationFieldMarking` to look up the row to connect. */
export type IntegrationFieldMarkingIntegrationFieldMarkingPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `integrationFieldMarking` to look up the row to update. */
export type IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingAuthAppIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyUpdate = {
  companyId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  formFieldId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
  patch: UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingAuthAppIdFkeyPatch;
};

/** The fields on `integrationFieldMarking` to look up the row to update. */
export type IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingAuthAppIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Update = {
  companyId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
  patch: UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingAuthAppIdFkeyPatch;
  systemFieldId: Scalars['UUID'];
};

/** The fields on `integrationFieldMarking` to look up the row to update. */
export type IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingAuthAppIdFkeyUsingIntegrationFieldMarkingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
  patch: UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingAuthAppIdFkeyPatch;
};

/** The fields on `integrationFieldMarking` to look up the row to update. */
export type IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingCompanyIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyUpdate = {
  companyId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  formFieldId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
  patch: UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingCompanyIdFkeyPatch;
};

/** The fields on `integrationFieldMarking` to look up the row to update. */
export type IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingCompanyIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Update = {
  companyId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
  patch: UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingCompanyIdFkeyPatch;
  systemFieldId: Scalars['UUID'];
};

/** The fields on `integrationFieldMarking` to look up the row to update. */
export type IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingCompanyIdFkeyUsingIntegrationFieldMarkingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
  patch: UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingCompanyIdFkeyPatch;
};

/** The fields on `integrationFieldMarking` to look up the row to update. */
export type IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingExternalIntegrationIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyUpdate = {
  companyId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  formFieldId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
  patch: UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingExternalIntegrationIdFkeyPatch;
};

/** The fields on `integrationFieldMarking` to look up the row to update. */
export type IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingExternalIntegrationIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Update = {
  companyId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
  patch: UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingExternalIntegrationIdFkeyPatch;
  systemFieldId: Scalars['UUID'];
};

/** The fields on `integrationFieldMarking` to look up the row to update. */
export type IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingExternalIntegrationIdFkeyUsingIntegrationFieldMarkingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
  patch: UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingExternalIntegrationIdFkeyPatch;
};

/** The fields on `integrationFieldMarking` to look up the row to update. */
export type IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingFormFieldIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyUpdate = {
  companyId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  formFieldId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
  patch: UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingFormFieldIdFkeyPatch;
};

/** The fields on `integrationFieldMarking` to look up the row to update. */
export type IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingFormFieldIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Update = {
  companyId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
  patch: UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingFormFieldIdFkeyPatch;
  systemFieldId: Scalars['UUID'];
};

/** The fields on `integrationFieldMarking` to look up the row to update. */
export type IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingFormFieldIdFkeyUsingIntegrationFieldMarkingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
  patch: UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingFormFieldIdFkeyPatch;
};

/** The fields on `integrationFieldMarking` to look up the row to update. */
export type IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingStorageIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyUpdate = {
  companyId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  formFieldId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
  patch: UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingStorageIdFkeyPatch;
};

/** The fields on `integrationFieldMarking` to look up the row to update. */
export type IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingStorageIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Update = {
  companyId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
  patch: UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingStorageIdFkeyPatch;
  systemFieldId: Scalars['UUID'];
};

/** The fields on `integrationFieldMarking` to look up the row to update. */
export type IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingStorageIdFkeyUsingIntegrationFieldMarkingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
  patch: UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingStorageIdFkeyPatch;
};

/** The fields on `integrationFieldMarking` to look up the row to update. */
export type IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingSystemFieldIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyUpdate = {
  companyId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  formFieldId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
  patch: UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingSystemFieldIdFkeyPatch;
};

/** The fields on `integrationFieldMarking` to look up the row to update. */
export type IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingSystemFieldIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Update = {
  companyId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
  patch: UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingSystemFieldIdFkeyPatch;
  systemFieldId: Scalars['UUID'];
};

/** The fields on `integrationFieldMarking` to look up the row to update. */
export type IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingSystemFieldIdFkeyUsingIntegrationFieldMarkingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
  patch: UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingSystemFieldIdFkeyPatch;
};

/** Represents an update to a `IntegrationFieldMarking`. Fields that are set will be updated. */
export type IntegrationFieldMarkingPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInput>;
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationName?: InputMaybe<Scalars['String']>;
  receivesData?: InputMaybe<Scalars['Boolean']>;
  sendsData?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `integrationFieldMarking` to be created by this mutation. */
export type IntegrationFieldMarkingStorageIdFkeyConnectionIntegrationFieldMarkingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInput>;
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationName: Scalars['String'];
  receivesData?: InputMaybe<Scalars['Boolean']>;
  sendsData?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInput>;
  systemField?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `storage` to be created by this mutation. */
export type IntegrationFieldMarkingStorageIdFkeyConnectionStorageCreateInput = {
  access: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createCopy?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path: Scalars['String'];
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `storage` in the `IntegrationFieldMarkingInput` mutation. */
export type IntegrationFieldMarkingStorageIdFkeyInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<StorageStoragePkeyConnect>;
  /** A `StorageInput` object that will be created and connected to this object. */
  create?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyConnectionStorageCreateInput>;
  /** The primary key(s) and patch data for `storage` for the far side of the relationship. */
  updateById?: InputMaybe<StorageOnIntegrationFieldMarkingForIntegrationFieldMarkingStorageIdFkeyUsingStoragePkeyUpdate>;
};

/** Input for the nested mutation of `integrationFieldMarking` in the `StorageInput` mutation. */
export type IntegrationFieldMarkingStorageIdFkeyInverseInput = {
  /** The primary key(s) for `integrationFieldMarking` for the far side of the relationship. */
  connectByCompanyIdAndExternalIntegrationIdAndFormFieldId?: InputMaybe<Array<IntegrationFieldMarkingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyConnect>>;
  /** The primary key(s) for `integrationFieldMarking` for the far side of the relationship. */
  connectByCompanyIdAndExternalIntegrationIdAndSystemFieldId?: InputMaybe<Array<IntegrationFieldMarkingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Connect>>;
  /** The primary key(s) for `integrationFieldMarking` for the far side of the relationship. */
  connectById?: InputMaybe<Array<IntegrationFieldMarkingIntegrationFieldMarkingPkeyConnect>>;
  /** A `IntegrationFieldMarkingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<IntegrationFieldMarkingStorageIdFkeyConnectionIntegrationFieldMarkingCreateInput>>;
  /** The primary key(s) and patch data for `integrationFieldMarking` for the far side of the relationship. */
  updateByCompanyIdAndExternalIntegrationIdAndFormFieldId?: InputMaybe<Array<IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingStorageIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyUpdate>>;
  /** The primary key(s) and patch data for `integrationFieldMarking` for the far side of the relationship. */
  updateByCompanyIdAndExternalIntegrationIdAndSystemFieldId?: InputMaybe<Array<IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingStorageIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Update>>;
  /** The primary key(s) and patch data for `integrationFieldMarking` for the far side of the relationship. */
  updateById?: InputMaybe<Array<IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingStorageIdFkeyUsingIntegrationFieldMarkingPkeyUpdate>>;
};

/** The `integrationFieldMarking` to be created by this mutation. */
export type IntegrationFieldMarkingSystemFieldIdFkeyConnectionIntegrationFieldMarkingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInput>;
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationName: Scalars['String'];
  receivesData?: InputMaybe<Scalars['Boolean']>;
  sendsData?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `systemField` in the `IntegrationFieldMarkingInput` mutation. */
export type IntegrationFieldMarkingSystemFieldIdFkeyInput = {
  /** The primary key(s) for `systemField` for the far side of the relationship. */
  connectById?: InputMaybe<SystemFieldSystemFieldPkeyConnect>;
  /** The primary key(s) for `systemField` for the far side of the relationship. */
  connectByName?: InputMaybe<SystemFieldSystemFieldNameUniqueConnect>;
  /** The primary key(s) and patch data for `systemField` for the far side of the relationship. */
  updateById?: InputMaybe<SystemFieldOnIntegrationFieldMarkingForIntegrationFieldMarkingSystemFieldIdFkeyUsingSystemFieldPkeyUpdate>;
  /** The primary key(s) and patch data for `systemField` for the far side of the relationship. */
  updateByName?: InputMaybe<SystemFieldOnIntegrationFieldMarkingForIntegrationFieldMarkingSystemFieldIdFkeyUsingSystemFieldNameUniqueUpdate>;
};

/** Input for the nested mutation of `integrationFieldMarking` in the `SystemFieldInput` mutation. */
export type IntegrationFieldMarkingSystemFieldIdFkeyInverseInput = {
  /** The primary key(s) for `integrationFieldMarking` for the far side of the relationship. */
  connectByCompanyIdAndExternalIntegrationIdAndFormFieldId?: InputMaybe<Array<IntegrationFieldMarkingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyConnect>>;
  /** The primary key(s) for `integrationFieldMarking` for the far side of the relationship. */
  connectByCompanyIdAndExternalIntegrationIdAndSystemFieldId?: InputMaybe<Array<IntegrationFieldMarkingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Connect>>;
  /** The primary key(s) for `integrationFieldMarking` for the far side of the relationship. */
  connectById?: InputMaybe<Array<IntegrationFieldMarkingIntegrationFieldMarkingPkeyConnect>>;
  /** A `IntegrationFieldMarkingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<IntegrationFieldMarkingSystemFieldIdFkeyConnectionIntegrationFieldMarkingCreateInput>>;
  /** The primary key(s) and patch data for `integrationFieldMarking` for the far side of the relationship. */
  updateByCompanyIdAndExternalIntegrationIdAndFormFieldId?: InputMaybe<Array<IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingSystemFieldIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationIKeyUpdate>>;
  /** The primary key(s) and patch data for `integrationFieldMarking` for the far side of the relationship. */
  updateByCompanyIdAndExternalIntegrationIdAndSystemFieldId?: InputMaybe<Array<IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingSystemFieldIdFkeyUsingIntegrationFieldMarkingCompanyIdExternalIntegrationKey1Update>>;
  /** The primary key(s) and patch data for `integrationFieldMarking` for the far side of the relationship. */
  updateById?: InputMaybe<Array<IntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingSystemFieldIdFkeyUsingIntegrationFieldMarkingPkeyUpdate>>;
};

/** A connection to a list of `IntegrationFieldMarking` values. */
export type IntegrationFieldMarkingsConnection = {
  __typename?: 'IntegrationFieldMarkingsConnection';
  /** A list of edges which contains the `IntegrationFieldMarking` and cursor to aid in pagination. */
  edges: Array<IntegrationFieldMarkingsEdge>;
  /** A list of `IntegrationFieldMarking` objects. */
  nodes: Array<Maybe<IntegrationFieldMarking>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IntegrationFieldMarking` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `IntegrationFieldMarking` edge in the connection. */
export type IntegrationFieldMarkingsEdge = {
  __typename?: 'IntegrationFieldMarkingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `IntegrationFieldMarking` at the end of the edge. */
  node?: Maybe<IntegrationFieldMarking>;
};

/** Methods to use when ordering `IntegrationFieldMarking`. */
export type IntegrationFieldMarkingsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__API_KEY_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__API_KEY_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__APP_TYPE_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__APP_TYPE_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__CLIENT_ID_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__CLIENT_ID_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__CLIENT_SECRET_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__CLIENT_SECRET_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__COMPANY_ID_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__COMPANY_ID_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__CREATED_AT_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__CREATED_AT_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__DELETED_AT_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__DELETED_AT_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__DESCRIPTION_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__DESCRIPTION_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__GROUP_ID_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__GROUP_ID_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__HOMEPAGE_URI_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__HOMEPAGE_URI_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__ID_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__ID_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__NAME_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__NAME_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__REDIRECT_URIS_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__REDIRECT_URIS_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__STORAGE_ID_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__STORAGE_ID_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__TOKENS_REVOKED_AT_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__TOKENS_REVOKED_AT_DESC'
  | 'AUTH_APP_BY_AUTH_APP_ID__UPDATED_AT_ASC'
  | 'AUTH_APP_BY_AUTH_APP_ID__UPDATED_AT_DESC'
  | 'AUTH_APP_ID_ASC'
  | 'AUTH_APP_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DELETED_AT_ASC'
  | 'DELETED_AT_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__ABSENCE_MAPPINGS_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__ABSENCE_MAPPINGS_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__ABSENCE_SYNC_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__ABSENCE_SYNC_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__ACTIVE_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__ACTIVE_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__AUTH_APP_ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__AUTH_APP_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__BLACKLISTED_FIELDS_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__BLACKLISTED_FIELDS_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__COMPANY_ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__COMPANY_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__CONFIG_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__CONFIG_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__CONTINUOUS_SYNC_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__CONTINUOUS_SYNC_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__CREATED_AT_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__CREATED_AT_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__CREDENTIALS_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__CREDENTIALS_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__DEPARTMENT_ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__DEPARTMENT_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__DEPARTMENT_INHERITANCE_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__DEPARTMENT_INHERITANCE_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__EXTERNAL_ADDITIONAL_ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__EXTERNAL_ADDITIONAL_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__EXTERNAL_COMPANY_ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__EXTERNAL_COMPANY_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__FIELD_MAPPINGS_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__FIELD_MAPPINGS_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__INTEGRABLE_SYSTEM_ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__INTEGRABLE_SYSTEM_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__PAYSLIP_DOCUMENT_BLUEPRINT_FOLDER_ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__PAYSLIP_DOCUMENT_BLUEPRINT_FOLDER_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__PAYSLIP_DOCUMENT_TYPE_ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__PAYSLIP_DOCUMENT_TYPE_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__SYSTEM_ID_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__SYSTEM_ID_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__TITLE_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__TITLE_DESC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__WHITELISTED_FIELDS_ASC'
  | 'EXTERNAL_INTEGRATION_BY_EXTERNAL_INTEGRATION_ID__WHITELISTED_FIELDS_DESC'
  | 'EXTERNAL_INTEGRATION_ID_ASC'
  | 'EXTERNAL_INTEGRATION_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_DESC'
  | 'FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INTEGRATION_NAME_ASC'
  | 'INTEGRATION_NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RECEIVES_DATA_ASC'
  | 'RECEIVES_DATA_DESC'
  | 'SENDS_DATA_ASC'
  | 'SENDS_DATA_DESC'
  | 'STORAGE_BY_STORAGE_ID__ACCESS_ASC'
  | 'STORAGE_BY_STORAGE_ID__ACCESS_DESC'
  | 'STORAGE_BY_STORAGE_ID__ACTIVE_ASC'
  | 'STORAGE_BY_STORAGE_ID__ACTIVE_DESC'
  | 'STORAGE_BY_STORAGE_ID__BELONGS_TO_LEADER_ASC'
  | 'STORAGE_BY_STORAGE_ID__BELONGS_TO_LEADER_DESC'
  | 'STORAGE_BY_STORAGE_ID__COMPANY_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__COMPANY_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__CREATED_AT_ASC'
  | 'STORAGE_BY_STORAGE_ID__CREATED_AT_DESC'
  | 'STORAGE_BY_STORAGE_ID__DELETE_AT_ASC'
  | 'STORAGE_BY_STORAGE_ID__DELETE_AT_DESC'
  | 'STORAGE_BY_STORAGE_ID__DEPARTMENTS_ASC'
  | 'STORAGE_BY_STORAGE_ID__DEPARTMENTS_DESC'
  | 'STORAGE_BY_STORAGE_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'STORAGE_BY_STORAGE_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'STORAGE_BY_STORAGE_ID__DOCUMENT_FOLDER_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__DOCUMENT_FOLDER_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__DOCUMENT_TEMPLATE_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__DOCUMENT_TEMPLATE_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__DOCUMENT_TYPE_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__DOCUMENT_TYPE_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__EMPLOYEE_CASEFILE_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__EMPLOYEE_CASEFILE_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__EXPIRED_REMINDED_ASC'
  | 'STORAGE_BY_STORAGE_ID__EXPIRED_REMINDED_DESC'
  | 'STORAGE_BY_STORAGE_ID__EXPIRE_AT_ASC'
  | 'STORAGE_BY_STORAGE_ID__EXPIRE_AT_DESC'
  | 'STORAGE_BY_STORAGE_ID__FILENAME_ASC'
  | 'STORAGE_BY_STORAGE_ID__FILENAME_DESC'
  | 'STORAGE_BY_STORAGE_ID__FILE_EXTENSION_ASC'
  | 'STORAGE_BY_STORAGE_ID__FILE_EXTENSION_DESC'
  | 'STORAGE_BY_STORAGE_ID__FILE_OWNER_ASC'
  | 'STORAGE_BY_STORAGE_ID__FILE_OWNER_DESC'
  | 'STORAGE_BY_STORAGE_ID__FILE_OWNER_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__FILE_OWNER_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__FILE_SIZE_ASC'
  | 'STORAGE_BY_STORAGE_ID__FILE_SIZE_DESC'
  | 'STORAGE_BY_STORAGE_ID__FILE_TYPE_ASC'
  | 'STORAGE_BY_STORAGE_ID__FILE_TYPE_DESC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_DEPARTMENT_IDS_ASC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_DEPARTMENT_IDS_DESC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_OWNER_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_OWNER_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_USER_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_USER_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_STORAGE_ID__HTML_ASC'
  | 'STORAGE_BY_STORAGE_ID__HTML_DESC'
  | 'STORAGE_BY_STORAGE_ID__ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__MIMETYPE_ASC'
  | 'STORAGE_BY_STORAGE_ID__MIMETYPE_DESC'
  | 'STORAGE_BY_STORAGE_ID__OWNER_NAME_ASC'
  | 'STORAGE_BY_STORAGE_ID__OWNER_NAME_DESC'
  | 'STORAGE_BY_STORAGE_ID__PATH_ASC'
  | 'STORAGE_BY_STORAGE_ID__PATH_DESC'
  | 'STORAGE_BY_STORAGE_ID__PENNEO_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__PENNEO_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__PLACEHOLDER_VALUES_ASC'
  | 'STORAGE_BY_STORAGE_ID__PLACEHOLDER_VALUES_DESC'
  | 'STORAGE_BY_STORAGE_ID__PROCESS_TYPE_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__PROCESS_TYPE_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__REMINDED_ASC'
  | 'STORAGE_BY_STORAGE_ID__REMINDED_DESC'
  | 'STORAGE_BY_STORAGE_ID__REMIND_AT_ASC'
  | 'STORAGE_BY_STORAGE_ID__REMIND_AT_DESC'
  | 'STORAGE_BY_STORAGE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__TEMPLATING_SERVICE_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__TEMPLATING_SERVICE_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__USERS_RESPONSIBLE_ASC'
  | 'STORAGE_BY_STORAGE_ID__USERS_RESPONSIBLE_DESC'
  | 'STORAGE_BY_STORAGE_ID__USERS_SHARED_WITH_ASC'
  | 'STORAGE_BY_STORAGE_ID__USERS_SHARED_WITH_DEPARTMENTS_ASC'
  | 'STORAGE_BY_STORAGE_ID__USERS_SHARED_WITH_DEPARTMENTS_DESC'
  | 'STORAGE_BY_STORAGE_ID__USERS_SHARED_WITH_DESC'
  | 'STORAGE_ID_ASC'
  | 'STORAGE_ID_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ALWAYS_REQUIRED_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ALWAYS_REQUIRED_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__DOCUMENT_TEMPLATE_PLACEHOLDER_NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__DOCUMENT_TEMPLATE_PLACEHOLDER_NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__EXCLUDE_FROM_PLACEHOLDER_FORM_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__EXCLUDE_FROM_PLACEHOLDER_FORM_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ID_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ID_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READABLE_NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READABLE_NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READ_ONLY_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READ_ONLY_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__TYPE_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__TYPE_DESC'
  | 'SYSTEM_FIELD_ID_ASC'
  | 'SYSTEM_FIELD_ID_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

export type IntegrationSystemInput =
  | 'Dynamics'
  | 'EazyProject'
  | 'Zenegy';

/** A filter to be used against InternetAddress fields. All fields are combined with a logical ‘and.’ */
export type InternetAddressFilter = {
  /** Contained by the specified internet address. */
  containedBy?: InputMaybe<Scalars['InternetAddress']>;
  /** Contained by or equal to the specified internet address. */
  containedByOrEqualTo?: InputMaybe<Scalars['InternetAddress']>;
  /** Contains the specified internet address. */
  contains?: InputMaybe<Scalars['InternetAddress']>;
  /** Contains or contained by the specified internet address. */
  containsOrContainedBy?: InputMaybe<Scalars['InternetAddress']>;
  /** Contains or equal to the specified internet address. */
  containsOrEqualTo?: InputMaybe<Scalars['InternetAddress']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['InternetAddress']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['InternetAddress']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['InternetAddress']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['InternetAddress']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['InternetAddress']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['InternetAddress']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['InternetAddress']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['InternetAddress']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['InternetAddress']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['InternetAddress']>>;
};

/** All input for the `intersection` mutation. */
export type IntersectionInput = {
  arg0?: InputMaybe<Scalars['String']>;
  arg1?: InputMaybe<Scalars['String']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `intersection` mutation. */
export type IntersectionPayload = {
  __typename?: 'IntersectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  string?: Maybe<Scalars['String']>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type Interval = {
  __typename?: 'Interval';
  /** A quantity of days. */
  days?: Maybe<Scalars['Int']>;
  /** A quantity of hours. */
  hours?: Maybe<Scalars['Int']>;
  /** A quantity of minutes. */
  minutes?: Maybe<Scalars['Int']>;
  /** A quantity of months. */
  months?: Maybe<Scalars['Int']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: Maybe<Scalars['Float']>;
  /** A quantity of years. */
  years?: Maybe<Scalars['Int']>;
};

/** A filter to be used against Interval fields. All fields are combined with a logical ‘and.’ */
export type IntervalFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IntervalInput>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IntervalInput>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IntervalInput>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IntervalInput>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IntervalInput>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IntervalInput>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IntervalInput>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IntervalInput>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type IntervalInput = {
  /** A quantity of days. */
  days?: InputMaybe<Scalars['Int']>;
  /** A quantity of hours. */
  hours?: InputMaybe<Scalars['Int']>;
  /** A quantity of minutes. */
  minutes?: InputMaybe<Scalars['Int']>;
  /** A quantity of months. */
  months?: InputMaybe<Scalars['Int']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: InputMaybe<Scalars['Float']>;
  /** A quantity of years. */
  years?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against Interval List fields. All fields are combined with a logical ‘and.’ */
export type IntervalListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<IntervalInput>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<IntervalInput>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<IntervalInput>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<IntervalInput>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']>>;
};

export type Jwt = {
  __typename?: 'JWT';
  accessToken: Scalars['String'];
  externalCompanyId?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
};

/** A `JSON` edge in the connection. */
export type JobPositionTitleEdge = {
  __typename?: 'JobPositionTitleEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `JSON` at the end of the edge. */
  node?: Maybe<Scalars['JSON']>;
};

/** A connection to a list of `JSON` values. */
export type JobPositionTitlesConnection = {
  __typename?: 'JobPositionTitlesConnection';
  /** A list of edges which contains the `JSON` and cursor to aid in pagination. */
  edges: Array<JobPositionTitleEdge>;
  /** A list of `JSON` objects. */
  nodes: Array<Maybe<Scalars['JSON']>>;
  /** The count of *all* `JSON` you could get from the connection. */
  totalCount: Scalars['Int'];
};

export type LatestMessage = {
  __typename?: 'LatestMessage';
  /** Reads a single `Company` that is related to this `LatestMessage`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `Employee` that is related to this `LatestMessage`. */
  employeeByEmployeeId1?: Maybe<Employee>;
  /** Reads a single `Employee` that is related to this `LatestMessage`. */
  employeeByEmployeeId2?: Maybe<Employee>;
  employeeId1: Scalars['UUID'];
  employeeId2: Scalars['UUID'];
  id: Scalars['UUID'];
  /** Reads a single `Message` that is related to this `LatestMessage`. */
  message?: Maybe<Message>;
  messageId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
};

/** Input for the nested mutation of `company` in the `LatestMessageInput` mutation. */
export type LatestMessageCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnLatestMessageForLatestMessageCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `latestMessage` in the `CompanyInput` mutation. */
export type LatestMessageCompanyIdForeignInverseInput = {
  /** The primary key(s) for `latestMessage` for the far side of the relationship. */
  connectByEmployeeId1AndEmployeeId2?: InputMaybe<Array<LatestMessageLatestMessageEmployeeId1EmployeeId2UniqueConnect>>;
  /** The primary key(s) for `latestMessage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LatestMessageLatestMessagePkeyConnect>>;
  /** The primary key(s) and patch data for `latestMessage` for the far side of the relationship. */
  updateByEmployeeId1AndEmployeeId2?: InputMaybe<Array<LatestMessageOnLatestMessageForLatestMessageCompanyIdForeignUsingLatestMessageEmployeeId1EmployeeId2UniqueUpdate>>;
  /** The primary key(s) and patch data for `latestMessage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LatestMessageOnLatestMessageForLatestMessageCompanyIdForeignUsingLatestMessagePkeyUpdate>>;
};

/**
 * A condition to be used against `LatestMessage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LatestMessageCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `employeeId1` field. */
  employeeId1?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `employeeId2` field. */
  employeeId2?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `messageId` field. */
  messageId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `latestMessage` in the `EmployeeInput` mutation. */
export type LatestMessageEmployeeId1ForeignInverseInput = {
  /** The primary key(s) for `latestMessage` for the far side of the relationship. */
  connectByEmployeeId1AndEmployeeId2?: InputMaybe<Array<LatestMessageLatestMessageEmployeeId1EmployeeId2UniqueConnect>>;
  /** The primary key(s) for `latestMessage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LatestMessageLatestMessagePkeyConnect>>;
  /** The primary key(s) and patch data for `latestMessage` for the far side of the relationship. */
  updateByEmployeeId1AndEmployeeId2?: InputMaybe<Array<LatestMessageOnLatestMessageForLatestMessageEmployeeId1ForeignUsingLatestMessageEmployeeId1EmployeeId2UniqueUpdate>>;
  /** The primary key(s) and patch data for `latestMessage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LatestMessageOnLatestMessageForLatestMessageEmployeeId1ForeignUsingLatestMessagePkeyUpdate>>;
};

/** Input for the nested mutation of `employee` in the `LatestMessageInput` mutation. */
export type LatestMessageEmployeeId2ForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnLatestMessageForLatestMessageEmployeeId2ForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnLatestMessageForLatestMessageEmployeeId2ForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `latestMessage` in the `EmployeeInput` mutation. */
export type LatestMessageEmployeeId2ForeignInverseInput = {
  /** The primary key(s) for `latestMessage` for the far side of the relationship. */
  connectByEmployeeId1AndEmployeeId2?: InputMaybe<Array<LatestMessageLatestMessageEmployeeId1EmployeeId2UniqueConnect>>;
  /** The primary key(s) for `latestMessage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LatestMessageLatestMessagePkeyConnect>>;
  /** The primary key(s) and patch data for `latestMessage` for the far side of the relationship. */
  updateByEmployeeId1AndEmployeeId2?: InputMaybe<Array<LatestMessageOnLatestMessageForLatestMessageEmployeeId2ForeignUsingLatestMessageEmployeeId1EmployeeId2UniqueUpdate>>;
  /** The primary key(s) and patch data for `latestMessage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LatestMessageOnLatestMessageForLatestMessageEmployeeId2ForeignUsingLatestMessagePkeyUpdate>>;
};

/** A filter to be used against `LatestMessage` object types. All fields are combined with a logical ‘and.’ */
export type LatestMessageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LatestMessageFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `employeeByEmployeeId1` relation. */
  employeeByEmployeeId1?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeByEmployeeId2` relation. */
  employeeByEmployeeId2?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeId1` field. */
  employeeId1?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `employeeId2` field. */
  employeeId2?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `message` relation. */
  message?: InputMaybe<MessageFilter>;
  /** Filter by the object’s `messageId` field. */
  messageId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LatestMessageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LatestMessageFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** The fields on `latestMessage` to look up the row to connect. */
export type LatestMessageLatestMessageEmployeeId1EmployeeId2UniqueConnect = {
  employeeId1: Scalars['UUID'];
  employeeId2: Scalars['UUID'];
};

/** The fields on `latestMessage` to look up the row to connect. */
export type LatestMessageLatestMessagePkeyConnect = {
  id: Scalars['UUID'];
};

/** The `message` to be created by this mutation. */
export type LatestMessageMessageIdForeignConnectionMessageCreateInput = {
  audioFile?: InputMaybe<Scalars['String']>;
  body: Scalars['String'];
  company?: InputMaybe<MessageCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<MessageToEmployeeIdForeignInput>;
  fromEmployeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  latestMessages?: InputMaybe<LatestMessageMessageIdForeignInverseInput>;
  messageRecipients?: InputMaybe<MessageRecipientMessageIdForeignInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInverseInput>;
  readByFrom?: InputMaybe<Scalars['Boolean']>;
  readByTo?: InputMaybe<Scalars['Boolean']>;
  subject: Scalars['String'];
  toEmployeeId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<MessageType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `message` in the `LatestMessageInput` mutation. */
export type LatestMessageMessageIdForeignInput = {
  /** The primary key(s) for `message` for the far side of the relationship. */
  connectById?: InputMaybe<MessageMessagePkeyConnect>;
  /** A `MessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<LatestMessageMessageIdForeignConnectionMessageCreateInput>;
  /** The primary key(s) and patch data for `message` for the far side of the relationship. */
  updateById?: InputMaybe<MessageOnLatestMessageForLatestMessageMessageIdForeignUsingMessagePkeyUpdate>;
};

/** Input for the nested mutation of `latestMessage` in the `MessageInput` mutation. */
export type LatestMessageMessageIdForeignInverseInput = {
  /** The primary key(s) for `latestMessage` for the far side of the relationship. */
  connectByEmployeeId1AndEmployeeId2?: InputMaybe<Array<LatestMessageLatestMessageEmployeeId1EmployeeId2UniqueConnect>>;
  /** The primary key(s) for `latestMessage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LatestMessageLatestMessagePkeyConnect>>;
  /** The primary key(s) and patch data for `latestMessage` for the far side of the relationship. */
  updateByEmployeeId1AndEmployeeId2?: InputMaybe<Array<LatestMessageOnLatestMessageForLatestMessageMessageIdForeignUsingLatestMessageEmployeeId1EmployeeId2UniqueUpdate>>;
  /** The primary key(s) and patch data for `latestMessage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LatestMessageOnLatestMessageForLatestMessageMessageIdForeignUsingLatestMessagePkeyUpdate>>;
};

/** The fields on `latestMessage` to look up the row to update. */
export type LatestMessageOnLatestMessageForLatestMessageCompanyIdForeignUsingLatestMessageEmployeeId1EmployeeId2UniqueUpdate = {
  employeeId1: Scalars['UUID'];
  employeeId2: Scalars['UUID'];
  /** An object where the defined keys will be set on the `latestMessage` being updated. */
  patch: UpdateLatestMessageOnLatestMessageForLatestMessageCompanyIdForeignPatch;
};

/** The fields on `latestMessage` to look up the row to update. */
export type LatestMessageOnLatestMessageForLatestMessageCompanyIdForeignUsingLatestMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `latestMessage` being updated. */
  patch: UpdateLatestMessageOnLatestMessageForLatestMessageCompanyIdForeignPatch;
};

/** The fields on `latestMessage` to look up the row to update. */
export type LatestMessageOnLatestMessageForLatestMessageEmployeeId1ForeignUsingLatestMessageEmployeeId1EmployeeId2UniqueUpdate = {
  employeeId1: Scalars['UUID'];
  employeeId2: Scalars['UUID'];
  /** An object where the defined keys will be set on the `latestMessage` being updated. */
  patch: UpdateLatestMessageOnLatestMessageForLatestMessageEmployeeId1ForeignPatch;
};

/** The fields on `latestMessage` to look up the row to update. */
export type LatestMessageOnLatestMessageForLatestMessageEmployeeId1ForeignUsingLatestMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `latestMessage` being updated. */
  patch: UpdateLatestMessageOnLatestMessageForLatestMessageEmployeeId1ForeignPatch;
};

/** The fields on `latestMessage` to look up the row to update. */
export type LatestMessageOnLatestMessageForLatestMessageEmployeeId2ForeignUsingLatestMessageEmployeeId1EmployeeId2UniqueUpdate = {
  employeeId1: Scalars['UUID'];
  employeeId2: Scalars['UUID'];
  /** An object where the defined keys will be set on the `latestMessage` being updated. */
  patch: UpdateLatestMessageOnLatestMessageForLatestMessageEmployeeId2ForeignPatch;
};

/** The fields on `latestMessage` to look up the row to update. */
export type LatestMessageOnLatestMessageForLatestMessageEmployeeId2ForeignUsingLatestMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `latestMessage` being updated. */
  patch: UpdateLatestMessageOnLatestMessageForLatestMessageEmployeeId2ForeignPatch;
};

/** The fields on `latestMessage` to look up the row to update. */
export type LatestMessageOnLatestMessageForLatestMessageMessageIdForeignUsingLatestMessageEmployeeId1EmployeeId2UniqueUpdate = {
  employeeId1: Scalars['UUID'];
  employeeId2: Scalars['UUID'];
  /** An object where the defined keys will be set on the `latestMessage` being updated. */
  patch: UpdateLatestMessageOnLatestMessageForLatestMessageMessageIdForeignPatch;
};

/** The fields on `latestMessage` to look up the row to update. */
export type LatestMessageOnLatestMessageForLatestMessageMessageIdForeignUsingLatestMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `latestMessage` being updated. */
  patch: UpdateLatestMessageOnLatestMessageForLatestMessageMessageIdForeignPatch;
};

/** A connection to a list of `LatestMessage` values. */
export type LatestMessagesConnection = {
  __typename?: 'LatestMessagesConnection';
  /** A list of edges which contains the `LatestMessage` and cursor to aid in pagination. */
  edges: Array<LatestMessagesEdge>;
  /** A list of `LatestMessage` objects. */
  nodes: Array<Maybe<LatestMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LatestMessage` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LatestMessage` edge in the connection. */
export type LatestMessagesEdge = {
  __typename?: 'LatestMessagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LatestMessage` at the end of the edge. */
  node?: Maybe<LatestMessage>;
};

/** Methods to use when ordering `LatestMessage`. */
export type LatestMessagesOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_1__USER_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID_2__USER_ID_DESC'
  | 'EMPLOYEE_ID_1_ASC'
  | 'EMPLOYEE_ID_1_DESC'
  | 'EMPLOYEE_ID_2_ASC'
  | 'EMPLOYEE_ID_2_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__BODY_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__BODY_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__COMPANY_ID_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__COMPANY_ID_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__CREATED_AT_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__CREATED_AT_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__FROM_EMPLOYEE_ID_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__FROM_EMPLOYEE_ID_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__ID_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__ID_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__READ_BY_FROM_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__READ_BY_FROM_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__READ_BY_TO_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__READ_BY_TO_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__SUBJECT_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__SUBJECT_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__TO_EMPLOYEE_ID_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__TO_EMPLOYEE_ID_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__TYPE_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__TYPE_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__UPDATED_AT_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__UPDATED_AT_DESC'
  | 'MESSAGE_ID_ASC'
  | 'MESSAGE_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

export type LikePostInput = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the `linkDepartmentAdministrators` mutation. */
export type LinkDepartmentAdministratorsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `linkDepartmentAdministrators` mutation. */
export type LinkDepartmentAdministratorsPayload = {
  __typename?: 'LinkDepartmentAdministratorsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type LocaleWithTranslation = {
  locale?: InputMaybe<Scalars['String']>;
  translation: Scalars['String'];
};

export type Log = {
  __typename?: 'Log';
  loggedAction?: Maybe<LoggedAction>;
  value?: Maybe<Scalars['JSON']>;
};

export type LogAction =
  | 'D'
  | 'I'
  | 'S'
  | 'U';

/** A connection to a list of `LogEntry` values. */
export type LogEntriesConnection = {
  __typename?: 'LogEntriesConnection';
  /** A list of edges which contains the `LogEntry` and cursor to aid in pagination. */
  edges: Array<LogEntriesEdge>;
  /** A list of `LogEntry` objects. */
  nodes: Array<Maybe<LogEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LogEntry` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LogEntry` edge in the connection. */
export type LogEntriesEdge = {
  __typename?: 'LogEntriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LogEntry` at the end of the edge. */
  node?: Maybe<LogEntry>;
};

export type LogEntry = {
  __typename?: 'LogEntry';
  changedFields?: Maybe<Scalars['JSON']>;
  loggedAction?: Maybe<LoggedAction>;
  rowData?: Maybe<Scalars['JSON']>;
};

/** A filter to be used against `LogEntry` object types. All fields are combined with a logical ‘and.’ */
export type LogEntryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LogEntryFilter>>;
  /** Filter by the object’s `changedFields` field. */
  changedFields?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LogEntryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LogEntryFilter>>;
  /** Filter by the object’s `rowData` field. */
  rowData?: InputMaybe<JsonFilter>;
};

/** A filter to be used against `Log` object types. All fields are combined with a logical ‘and.’ */
export type LogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LogFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<LogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LogFilter>>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<JsonFilter>;
};

/** History of auditable actions on audited tables, from public.if_modified_func() */
export type LoggedAction = {
  __typename?: 'LoggedAction';
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action: Scalars['String'];
  /** Wall clock time at which audited event's trigger call occurred */
  actionTstampClk: Scalars['Datetime'];
  /** Statement start timestamp for tx in which audited event occurred */
  actionTstampStm: Scalars['Datetime'];
  /** Transaction start timestamp for tx in which audited event occurred */
  actionTstampTx: Scalars['Datetime'];
  affectedId?: Maybe<Scalars['String']>;
  affectedItem?: Maybe<Scalars['JSON']>;
  affectedUuid?: Maybe<Scalars['UUID']>;
  /** Application name set when this audit event occurred. Can be changed in-session by client. */
  applicationName?: Maybe<Scalars['String']>;
  /** IP address of client that issued query. Null for unix domain socket. */
  clientAddr?: Maybe<Scalars['InternetAddress']>;
  /** Remote peer IP port address of client that issued query. Undefined for unix socket. */
  clientPort?: Maybe<Scalars['Int']>;
  /** Reads a single `Company` that is related to this `LoggedAction`. */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['UUID']>;
  creator?: Maybe<Scalars['JSON']>;
  /** Unique identifier for each auditable event */
  eventId: Scalars['BigInt'];
  loggedActionContext: LoggedActionContext;
  /** Reads and enables pagination through a set of `LoggedActionNote`. */
  loggedActionNotesByLoggedActionEventId: LoggedActionNotesConnection;
  /** Table OID. Changes with drop/create. Get with 'tablename'::regclass */
  relid?: Maybe<Scalars['BigFloat']>;
  /** Database schema audited table for this event is in */
  schemaName: Scalars['String'];
  selectedFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Login / session user whose statement caused the audited event */
  sessionUserName?: Maybe<Scalars['String']>;
  /** 't' if audit event is from an FOR EACH STATEMENT trigger, 'f' for FOR EACH ROW */
  statementOnly: Scalars['Boolean'];
  /** Reads a single `User` that is related to this `LoggedAction`. */
  superUser?: Maybe<User>;
  superUserId?: Maybe<Scalars['UUID']>;
  superUserName?: Maybe<Scalars['String']>;
  /** Non-schema-qualified table name of table event occured in */
  tableName: Scalars['String'];
  /** Identifier of transaction that made the change. May wrap, but unique paired with action_tstamp_tx. */
  transactionId?: Maybe<Scalars['BigInt']>;
  /** Reads a single `User` that is related to this `LoggedAction`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};


/** History of auditable actions on audited tables, from public.if_modified_func() */
export type LoggedActionLoggedActionNotesByLoggedActionEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LoggedActionNoteCondition>;
  filter?: InputMaybe<LoggedActionNoteFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LoggedActionNotesOrderBy>>;
};

export type LoggedActionContext =
  /** Changes made using the API */
  | 'API'
  /** Changes made using a CSV file */
  | 'CSV'
  /** Changes made via an Engagement */
  | 'ENGAGEMENT'
  /** Change from unknown source or before logged action context was introduced */
  | 'UNKNOWN'
  /** Changes made using the website */
  | 'WEB'
  /** Changes coming from Zenegy 2-way integration */
  | 'ZENEGY';

export type LoggedActionNote = {
  __typename?: 'LoggedActionNote';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `LoggedActionNote`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  creator?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  loggedActionEventId: Scalars['BigInt'];
  note: Scalars['String'];
  /** Reads a single `User` that is related to this `LoggedActionNote`. */
  superUser?: Maybe<User>;
  superUserId?: Maybe<Scalars['UUID']>;
  /** Reads a single `User` that is related to this `LoggedActionNote`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The `loggedActionNote` to be created by this mutation. */
export type LoggedActionNoteCompanyIdForeignConnectionLoggedActionNoteCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<LoggedActionNoteCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  loggedActionEventId: Scalars['BigInt'];
  note: Scalars['String'];
  superUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<LoggedActionNoteSuperUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `LoggedActionNoteInput` mutation. */
export type LoggedActionNoteCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnLoggedActionNoteForLoggedActionNoteCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `loggedActionNote` in the `CompanyInput` mutation. */
export type LoggedActionNoteCompanyIdForeignInverseInput = {
  /** The primary key(s) for `loggedActionNote` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LoggedActionNoteLoggedActionNotePkeyConnect>>;
  /** A `LoggedActionNoteInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LoggedActionNoteCompanyIdForeignConnectionLoggedActionNoteCreateInput>>;
  /** The primary key(s) and patch data for `loggedActionNote` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LoggedActionNoteOnLoggedActionNoteForLoggedActionNoteCompanyIdForeignUsingLoggedActionNotePkeyUpdate>>;
};

/**
 * A condition to be used against `LoggedActionNote` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LoggedActionNoteCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `loggedActionEventId` field. */
  loggedActionEventId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `superUserId` field. */
  superUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `LoggedActionNote` object types. All fields are combined with a logical ‘and.’ */
export type LoggedActionNoteFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LoggedActionNoteFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `creator` field. */
  creator?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `loggedActionEventId` field. */
  loggedActionEventId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LoggedActionNoteFilter>;
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LoggedActionNoteFilter>>;
  /** Filter by the object’s `superUser` relation. */
  superUser?: InputMaybe<UserFilter>;
  /** A related `superUser` exists. */
  superUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `superUserId` field. */
  superUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `LoggedActionNote` */
export type LoggedActionNoteInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<LoggedActionNoteCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  loggedActionEventId: Scalars['BigInt'];
  note: Scalars['String'];
  superUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<LoggedActionNoteSuperUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `loggedActionNote` to look up the row to connect. */
export type LoggedActionNoteLoggedActionNotePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `loggedActionNote` to look up the row to update. */
export type LoggedActionNoteOnLoggedActionNoteForLoggedActionNoteCompanyIdForeignUsingLoggedActionNotePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `loggedActionNote` being updated. */
  patch: UpdateLoggedActionNoteOnLoggedActionNoteForLoggedActionNoteCompanyIdForeignPatch;
};

/** The fields on `loggedActionNote` to look up the row to update. */
export type LoggedActionNoteOnLoggedActionNoteForLoggedActionNoteSuperUserIdForeignUsingLoggedActionNotePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `loggedActionNote` being updated. */
  patch: UpdateLoggedActionNoteOnLoggedActionNoteForLoggedActionNoteSuperUserIdForeignPatch;
};

/** The fields on `loggedActionNote` to look up the row to update. */
export type LoggedActionNoteOnLoggedActionNoteForLoggedActionNoteUserIdForeignUsingLoggedActionNotePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `loggedActionNote` being updated. */
  patch: UpdateLoggedActionNoteOnLoggedActionNoteForLoggedActionNoteUserIdForeignPatch;
};

/** Represents an update to a `LoggedActionNote`. Fields that are set will be updated. */
export type LoggedActionNotePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<LoggedActionNoteCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  loggedActionEventId?: InputMaybe<Scalars['BigInt']>;
  note?: InputMaybe<Scalars['String']>;
  superUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<LoggedActionNoteSuperUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `loggedActionNote` to be created by this mutation. */
export type LoggedActionNoteSuperUserIdForeignConnectionLoggedActionNoteCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<LoggedActionNoteCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  loggedActionEventId: Scalars['BigInt'];
  note: Scalars['String'];
  user?: InputMaybe<LoggedActionNoteSuperUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `user` in the `LoggedActionNoteInput` mutation. */
export type LoggedActionNoteSuperUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnLoggedActionNoteForLoggedActionNoteSuperUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `loggedActionNote` in the `UserInput` mutation. */
export type LoggedActionNoteSuperUserIdForeignInverseInput = {
  /** The primary key(s) for `loggedActionNote` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LoggedActionNoteLoggedActionNotePkeyConnect>>;
  /** A `LoggedActionNoteInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LoggedActionNoteSuperUserIdForeignConnectionLoggedActionNoteCreateInput>>;
  /** The primary key(s) and patch data for `loggedActionNote` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LoggedActionNoteOnLoggedActionNoteForLoggedActionNoteSuperUserIdForeignUsingLoggedActionNotePkeyUpdate>>;
};

/** The `loggedActionNote` to be created by this mutation. */
export type LoggedActionNoteUserIdForeignConnectionLoggedActionNoteCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<LoggedActionNoteCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  loggedActionEventId: Scalars['BigInt'];
  note: Scalars['String'];
  superUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<LoggedActionNoteSuperUserIdForeignInput>;
};

/** Input for the nested mutation of `loggedActionNote` in the `UserInput` mutation. */
export type LoggedActionNoteUserIdForeignInverseInput = {
  /** The primary key(s) for `loggedActionNote` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LoggedActionNoteLoggedActionNotePkeyConnect>>;
  /** A `LoggedActionNoteInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LoggedActionNoteUserIdForeignConnectionLoggedActionNoteCreateInput>>;
  /** The primary key(s) and patch data for `loggedActionNote` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LoggedActionNoteOnLoggedActionNoteForLoggedActionNoteUserIdForeignUsingLoggedActionNotePkeyUpdate>>;
};

/** A connection to a list of `LoggedActionNote` values. */
export type LoggedActionNotesConnection = {
  __typename?: 'LoggedActionNotesConnection';
  /** A list of edges which contains the `LoggedActionNote` and cursor to aid in pagination. */
  edges: Array<LoggedActionNotesEdge>;
  /** A list of `LoggedActionNote` objects. */
  nodes: Array<Maybe<LoggedActionNote>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LoggedActionNote` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LoggedActionNote` edge in the connection. */
export type LoggedActionNotesEdge = {
  __typename?: 'LoggedActionNotesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LoggedActionNote` at the end of the edge. */
  node?: Maybe<LoggedActionNote>;
};

/** Methods to use when ordering `LoggedActionNote`. */
export type LoggedActionNotesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOGGED_ACTION_EVENT_ID_ASC'
  | 'LOGGED_ACTION_EVENT_ID_DESC'
  | 'NATURAL'
  | 'NOTE_ASC'
  | 'NOTE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SUPER_USER_ID_ASC'
  | 'SUPER_USER_ID_DESC'
  | 'USER_BY_SUPER_USER_ID__ACTIVE_ASC'
  | 'USER_BY_SUPER_USER_ID__ACTIVE_DESC'
  | 'USER_BY_SUPER_USER_ID__ADDRESS_ASC'
  | 'USER_BY_SUPER_USER_ID__ADDRESS_DESC'
  | 'USER_BY_SUPER_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_SUPER_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_SUPER_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_SUPER_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_SUPER_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_SUPER_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_SUPER_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_SUPER_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_SUPER_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_SUPER_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_SUPER_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_SUPER_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_SUPER_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_SUPER_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_SUPER_USER_ID__CITY_ASC'
  | 'USER_BY_SUPER_USER_ID__CITY_DESC'
  | 'USER_BY_SUPER_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_SUPER_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_SUPER_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_SUPER_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_SUPER_USER_ID__CPR_ASC'
  | 'USER_BY_SUPER_USER_ID__CPR_DESC'
  | 'USER_BY_SUPER_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_SUPER_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_SUPER_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_SUPER_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_SUPER_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_SUPER_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_SUPER_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_SUPER_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_SUPER_USER_ID__EMAIL_ASC'
  | 'USER_BY_SUPER_USER_ID__EMAIL_DESC'
  | 'USER_BY_SUPER_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_SUPER_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_SUPER_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_SUPER_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_SUPER_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_SUPER_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_SUPER_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_SUPER_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_SUPER_USER_ID__GODMODE_ASC'
  | 'USER_BY_SUPER_USER_ID__GODMODE_DESC'
  | 'USER_BY_SUPER_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_SUPER_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_SUPER_USER_ID__ID_ASC'
  | 'USER_BY_SUPER_USER_ID__ID_DESC'
  | 'USER_BY_SUPER_USER_ID__INITIALS_ASC'
  | 'USER_BY_SUPER_USER_ID__INITIALS_DESC'
  | 'USER_BY_SUPER_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_SUPER_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_SUPER_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_SUPER_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_SUPER_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_SUPER_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_SUPER_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_SUPER_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_SUPER_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_SUPER_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_SUPER_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_SUPER_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_SUPER_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_SUPER_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_SUPER_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_SUPER_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_SUPER_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_SUPER_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_SUPER_USER_ID__MOBILE_ASC'
  | 'USER_BY_SUPER_USER_ID__MOBILE_DESC'
  | 'USER_BY_SUPER_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_SUPER_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_SUPER_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_SUPER_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_SUPER_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_SUPER_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_SUPER_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_SUPER_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_SUPER_USER_ID__PHONE_ASC'
  | 'USER_BY_SUPER_USER_ID__PHONE_DESC'
  | 'USER_BY_SUPER_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_SUPER_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_SUPER_USER_ID__SENIORITY_ASC'
  | 'USER_BY_SUPER_USER_ID__SENIORITY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type LoginLog = {
  __typename?: 'LoginLog';
  /** Reads a single `Company` that is related to this `LoginLog`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  ip: Scalars['InternetAddress'];
  note?: Maybe<Scalars['String']>;
  superUser?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `SuperUserLoginNote`. */
  superUserLoginNotes: SuperUserLoginNotesConnection;
  type: LoginLogType;
  /** Reads a single `User` that is related to this `LoginLog`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};


export type LoginLogSuperUserLoginNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SuperUserLoginNoteCondition>;
  filter?: InputMaybe<SuperUserLoginNoteFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuperUserLoginNotesOrderBy>>;
};

/** Input for the nested mutation of `company` in the `LoginLogInput` mutation. */
export type LoginLogCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnLoginLogForLoginLogCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `loginLog` in the `CompanyInput` mutation. */
export type LoginLogCompanyIdForeignInverseInput = {
  /** The primary key(s) for `loginLog` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LoginLogLoginLogPkeyConnect>>;
  /** The primary key(s) and patch data for `loginLog` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LoginLogOnLoginLogForLoginLogCompanyIdForeignUsingLoginLogPkeyUpdate>>;
};

/**
 * A condition to be used against `LoginLog` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type LoginLogCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `ip` field. */
  ip?: InputMaybe<Scalars['InternetAddress']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<LoginLogType>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `LoginLog` object types. All fields are combined with a logical ‘and.’ */
export type LoginLogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LoginLogFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `ip` field. */
  ip?: InputMaybe<InternetAddressFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LoginLogFilter>;
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LoginLogFilter>>;
  /** Filter by the object’s `superUserLoginNotes` relation. */
  superUserLoginNotes?: InputMaybe<LoginLogToManySuperUserLoginNoteFilter>;
  /** Some related `superUserLoginNotes` exist. */
  superUserLoginNotesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<LoginLogTypeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `loginLog` to look up the row to connect. */
export type LoginLogLoginLogPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `loginLog` to look up the row to update. */
export type LoginLogOnLoginLogForLoginLogCompanyIdForeignUsingLoginLogPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `loginLog` being updated. */
  patch: UpdateLoginLogOnLoginLogForLoginLogCompanyIdForeignPatch;
};

/** The fields on `loginLog` to look up the row to update. */
export type LoginLogOnLoginLogForLoginLogUserIdForeignUsingLoginLogPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `loginLog` being updated. */
  patch: UpdateLoginLogOnLoginLogForLoginLogUserIdForeignPatch;
};

/** The fields on `loginLog` to look up the row to update. */
export type LoginLogOnSuperUserLoginNoteForSuperUserLoginNoteLoginLogIdForeignUsingLoginLogPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `loginLog` being updated. */
  patch: UpdateLoginLogOnSuperUserLoginNoteForSuperUserLoginNoteLoginLogIdForeignPatch;
};

/** Input for the nested mutation of `user` in the `LoginLogInput` mutation. */
export type LoginLogSuperUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
};

/** Input for the nested mutation of `loginLog` in the `UserInput` mutation. */
export type LoginLogSuperUserIdForeignInverseInput = {
  /** The primary key(s) for `loginLog` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LoginLogLoginLogPkeyConnect>>;
};

/** A filter to be used against many `SuperUserLoginNote` object types. All fields are combined with a logical ‘and.’ */
export type LoginLogToManySuperUserLoginNoteFilter = {
  /** Every related `SuperUserLoginNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SuperUserLoginNoteFilter>;
  /** No related `SuperUserLoginNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SuperUserLoginNoteFilter>;
  /** Some related `SuperUserLoginNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SuperUserLoginNoteFilter>;
};

export type LoginLogType =
  | 'FAILED_LOGIN'
  | 'LOGIN'
  | 'SUPERUSER_LOGIN';

/** A filter to be used against LoginLogType fields. All fields are combined with a logical ‘and.’ */
export type LoginLogTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LoginLogType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LoginLogType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LoginLogType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LoginLogType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LoginLogType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LoginLogType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LoginLogType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LoginLogType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LoginLogType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LoginLogType>>;
};

/** Input for the nested mutation of `loginLog` in the `UserInput` mutation. */
export type LoginLogUserIdForeignInverseInput = {
  /** The primary key(s) for `loginLog` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LoginLogLoginLogPkeyConnect>>;
  /** The primary key(s) and patch data for `loginLog` for the far side of the relationship. */
  updateById?: InputMaybe<Array<LoginLogOnLoginLogForLoginLogUserIdForeignUsingLoginLogPkeyUpdate>>;
};

/** A connection to a list of `LoginLog` values. */
export type LoginLogsConnection = {
  __typename?: 'LoginLogsConnection';
  /** A list of edges which contains the `LoginLog` and cursor to aid in pagination. */
  edges: Array<LoginLogsEdge>;
  /** A list of `LoginLog` objects. */
  nodes: Array<Maybe<LoginLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LoginLog` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LoginLog` edge in the connection. */
export type LoginLogsEdge = {
  __typename?: 'LoginLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LoginLog` at the end of the edge. */
  node?: Maybe<LoginLog>;
};

/** Methods to use when ordering `LoginLog`. */
export type LoginLogsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IP_ASC'
  | 'IP_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SUPER_USER_LOGIN_NOTES_BY_LOGIN_LOG_ID__COUNT_ASC'
  | 'SUPER_USER_LOGIN_NOTES_BY_LOGIN_LOG_ID__COUNT_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** A connection to a list of `Log` values. */
export type LogsConnection = {
  __typename?: 'LogsConnection';
  /** A list of edges which contains the `Log` and cursor to aid in pagination. */
  edges: Array<LogsEdge>;
  /** A list of `Log` objects. */
  nodes: Array<Maybe<Log>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Log` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Log` edge in the connection. */
export type LogsEdge = {
  __typename?: 'LogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Log` at the end of the edge. */
  node?: Maybe<Log>;
};

export type ManuallySyncCasefileInput = {
  casefileId: Scalars['Int'];
};

/** All input for the `markMessageThreadAsRead` mutation. */
export type MarkMessageThreadAsReadInput = {
  argEmployeeId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `markMessageThreadAsRead` mutation. */
export type MarkMessageThreadAsReadPayload = {
  __typename?: 'MarkMessageThreadAsReadPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type Message = {
  __typename?: 'Message';
  body: Scalars['String'];
  /** Reads a single `Company` that is related to this `Message`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  /** Reads a single `Employee` that is related to this `Message`. */
  fromEmployee?: Maybe<Employee>;
  fromEmployeeId: Scalars['UUID'];
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `LatestMessage`. */
  latestMessages: LatestMessagesConnection;
  /** Reads and enables pagination through a set of `MessageRecipient`. */
  messageRecipients: MessageRecipientsConnection;
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferences: NotificationEmployeeReferencesConnection;
  readByFrom: Scalars['Boolean'];
  readByTo: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `Storage`. */
  storages: StoragesConnection;
  subject: Scalars['String'];
  /** Reads a single `Employee` that is related to this `Message`. */
  toEmployee?: Maybe<Employee>;
  toEmployeeId?: Maybe<Scalars['UUID']>;
  type: MessageType;
  updatedAt: Scalars['Datetime'];
};


export type MessageLatestMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LatestMessageCondition>;
  filter?: InputMaybe<LatestMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LatestMessagesOrderBy>>;
};


export type MessageMessageRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MessageRecipientCondition>;
  filter?: InputMaybe<MessageRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessageRecipientsOrderBy>>;
};


export type MessageNotificationEmployeeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};


export type MessageStoragesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type MessageChannel =
  | 'EMAIL'
  | 'SMS';

/** The `message` to be created by this mutation. */
export type MessageCompanyIdFkeyConnectionMessageCreateInput = {
  audioFile?: InputMaybe<Scalars['String']>;
  body: Scalars['String'];
  company?: InputMaybe<MessageCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<MessageToEmployeeIdForeignInput>;
  fromEmployeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  latestMessages?: InputMaybe<LatestMessageMessageIdForeignInverseInput>;
  messageRecipients?: InputMaybe<MessageRecipientMessageIdForeignInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInverseInput>;
  readByFrom?: InputMaybe<Scalars['Boolean']>;
  readByTo?: InputMaybe<Scalars['Boolean']>;
  subject: Scalars['String'];
  toEmployeeId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<MessageType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `company` in the `MessageInput` mutation. */
export type MessageCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnMessageForMessageCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `message` in the `CompanyInput` mutation. */
export type MessageCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `message` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MessageMessagePkeyConnect>>;
  /** A `MessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<MessageCompanyIdFkeyConnectionMessageCreateInput>>;
  /** The primary key(s) and patch data for `message` for the far side of the relationship. */
  updateById?: InputMaybe<Array<MessageOnMessageForMessageCompanyIdFkeyUsingMessagePkeyUpdate>>;
};

/** A condition to be used against `Message` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type MessageCondition = {
  /** Checks for equality with the object’s `body` field. */
  body?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `fromEmployeeId` field. */
  fromEmployeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `readByFrom` field. */
  readByFrom?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `readByTo` field. */
  readByTo?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `subject` field. */
  subject?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `toEmployeeId` field. */
  toEmployeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<MessageType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Message` object types. All fields are combined with a logical ‘and.’ */
export type MessageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MessageFilter>>;
  /** Filter by the object’s `body` field. */
  body?: InputMaybe<StringFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fromEmployee` relation. */
  fromEmployee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `fromEmployeeId` field. */
  fromEmployeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `latestMessages` relation. */
  latestMessages?: InputMaybe<MessageToManyLatestMessageFilter>;
  /** Some related `latestMessages` exist. */
  latestMessagesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `messageRecipients` relation. */
  messageRecipients?: InputMaybe<MessageToManyMessageRecipientFilter>;
  /** Some related `messageRecipients` exist. */
  messageRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Negates the expression. */
  not?: InputMaybe<MessageFilter>;
  /** Filter by the object’s `notificationEmployeeReferences` relation. */
  notificationEmployeeReferences?: InputMaybe<MessageToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferences` exist. */
  notificationEmployeeReferencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MessageFilter>>;
  /** Filter by the object’s `readByFrom` field. */
  readByFrom?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `readByTo` field. */
  readByTo?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `subject` field. */
  subject?: InputMaybe<StringFilter>;
  /** Filter by the object’s `toEmployee` relation. */
  toEmployee?: InputMaybe<EmployeeFilter>;
  /** A related `toEmployee` exists. */
  toEmployeeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `toEmployeeId` field. */
  toEmployeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<MessageTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** The `message` to be created by this mutation. */
export type MessageFromEmployeeIdForeignConnectionMessageCreateInput = {
  audioFile?: InputMaybe<Scalars['String']>;
  body: Scalars['String'];
  company?: InputMaybe<MessageCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<MessageToEmployeeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  latestMessages?: InputMaybe<LatestMessageMessageIdForeignInverseInput>;
  messageRecipients?: InputMaybe<MessageRecipientMessageIdForeignInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInverseInput>;
  readByFrom?: InputMaybe<Scalars['Boolean']>;
  readByTo?: InputMaybe<Scalars['Boolean']>;
  subject: Scalars['String'];
  toEmployeeId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<MessageType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `message` in the `EmployeeInput` mutation. */
export type MessageFromEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `message` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MessageMessagePkeyConnect>>;
  /** A `MessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<MessageFromEmployeeIdForeignConnectionMessageCreateInput>>;
  /** The primary key(s) and patch data for `message` for the far side of the relationship. */
  updateById?: InputMaybe<Array<MessageOnMessageForMessageFromEmployeeIdForeignUsingMessagePkeyUpdate>>;
};

export type MessageGraphileInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  body: Scalars['String'];
  channel?: InputMaybe<MessageChannel>;
  messageRecipients: Array<Scalars['UUID']>;
  subject: Scalars['String'];
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
};

export type MessageGraphilePayload = {
  __typename?: 'MessageGraphilePayload';
  message?: Maybe<Message>;
};

/** An input for mutations affecting `Message` */
export type MessageInput = {
  audioFile?: InputMaybe<Scalars['String']>;
  body: Scalars['String'];
  company?: InputMaybe<MessageCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<MessageToEmployeeIdForeignInput>;
  fromEmployeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  latestMessages?: InputMaybe<LatestMessageMessageIdForeignInverseInput>;
  messageRecipients?: InputMaybe<MessageRecipientMessageIdForeignInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInverseInput>;
  readByFrom?: InputMaybe<Scalars['Boolean']>;
  readByTo?: InputMaybe<Scalars['Boolean']>;
  subject: Scalars['String'];
  toEmployeeId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<MessageType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `message` to look up the row to connect. */
export type MessageMessagePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `message` to look up the row to update. */
export type MessageOnLatestMessageForLatestMessageMessageIdForeignUsingMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `message` being updated. */
  patch: UpdateMessageOnLatestMessageForLatestMessageMessageIdForeignPatch;
};

/** The fields on `message` to look up the row to update. */
export type MessageOnMessageForMessageCompanyIdFkeyUsingMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `message` being updated. */
  patch: UpdateMessageOnMessageForMessageCompanyIdFkeyPatch;
};

/** The fields on `message` to look up the row to update. */
export type MessageOnMessageForMessageFromEmployeeIdForeignUsingMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `message` being updated. */
  patch: UpdateMessageOnMessageForMessageFromEmployeeIdForeignPatch;
};

/** The fields on `message` to look up the row to update. */
export type MessageOnMessageForMessageToEmployeeIdForeignUsingMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `message` being updated. */
  patch: UpdateMessageOnMessageForMessageToEmployeeIdForeignPatch;
};

/** The fields on `message` to look up the row to update. */
export type MessageOnMessageRecipientForMessageRecipientMessageIdForeignUsingMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `message` being updated. */
  patch: UpdateMessageOnMessageRecipientForMessageRecipientMessageIdForeignPatch;
};

/** The fields on `message` to look up the row to update. */
export type MessageOnNotificationEmployeeReferenceForNotificationEmployeeReferenceMessageIdForeignUsingMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `message` being updated. */
  patch: UpdateMessageOnNotificationEmployeeReferenceForNotificationEmployeeReferenceMessageIdForeignPatch;
};

export type MessageRecipient = {
  __typename?: 'MessageRecipient';
  /** Reads a single `Employee` that is related to this `MessageRecipient`. */
  employee?: Maybe<Employee>;
  employeeId: Scalars['UUID'];
  /** Reads a single `Message` that is related to this `MessageRecipient`. */
  message?: Maybe<Message>;
  messageId: Scalars['UUID'];
};

/**
 * A condition to be used against `MessageRecipient` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MessageRecipientCondition = {
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `messageId` field. */
  messageId?: InputMaybe<Scalars['UUID']>;
};

/** The `messageRecipient` to be created by this mutation. */
export type MessageRecipientEmployeeIdForeignConnectionMessageRecipientCreateInput = {
  employee?: InputMaybe<MessageRecipientEmployeeIdForeignInput>;
  message?: InputMaybe<MessageRecipientMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `employee` in the `MessageRecipientInput` mutation. */
export type MessageRecipientEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnMessageRecipientForMessageRecipientEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnMessageRecipientForMessageRecipientEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `messageRecipient` in the `EmployeeInput` mutation. */
export type MessageRecipientEmployeeIdForeignInverseInput = {
  /** A `MessageRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<MessageRecipientEmployeeIdForeignConnectionMessageRecipientCreateInput>>;
};

/** A filter to be used against `MessageRecipient` object types. All fields are combined with a logical ‘and.’ */
export type MessageRecipientFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MessageRecipientFilter>>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `message` relation. */
  message?: InputMaybe<MessageFilter>;
  /** Filter by the object’s `messageId` field. */
  messageId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MessageRecipientFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MessageRecipientFilter>>;
};

/** An input for mutations affecting `MessageRecipient` */
export type MessageRecipientInput = {
  employee?: InputMaybe<MessageRecipientEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<MessageRecipientMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
};

/** The `message` to be created by this mutation. */
export type MessageRecipientMessageIdForeignConnectionMessageCreateInput = {
  audioFile?: InputMaybe<Scalars['String']>;
  body: Scalars['String'];
  company?: InputMaybe<MessageCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<MessageToEmployeeIdForeignInput>;
  fromEmployeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  latestMessages?: InputMaybe<LatestMessageMessageIdForeignInverseInput>;
  messageRecipients?: InputMaybe<MessageRecipientMessageIdForeignInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInverseInput>;
  readByFrom?: InputMaybe<Scalars['Boolean']>;
  readByTo?: InputMaybe<Scalars['Boolean']>;
  subject: Scalars['String'];
  toEmployeeId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<MessageType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `messageRecipient` to be created by this mutation. */
export type MessageRecipientMessageIdForeignConnectionMessageRecipientCreateInput = {
  employee?: InputMaybe<MessageRecipientEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<MessageRecipientMessageIdForeignInput>;
};

/** Input for the nested mutation of `message` in the `MessageRecipientInput` mutation. */
export type MessageRecipientMessageIdForeignInput = {
  /** The primary key(s) for `message` for the far side of the relationship. */
  connectById?: InputMaybe<MessageMessagePkeyConnect>;
  /** A `MessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<MessageRecipientMessageIdForeignConnectionMessageCreateInput>;
  /** The primary key(s) and patch data for `message` for the far side of the relationship. */
  updateById?: InputMaybe<MessageOnMessageRecipientForMessageRecipientMessageIdForeignUsingMessagePkeyUpdate>;
};

/** Input for the nested mutation of `messageRecipient` in the `MessageInput` mutation. */
export type MessageRecipientMessageIdForeignInverseInput = {
  /** A `MessageRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<MessageRecipientMessageIdForeignConnectionMessageRecipientCreateInput>>;
};

/** A connection to a list of `MessageRecipient` values. */
export type MessageRecipientsConnection = {
  __typename?: 'MessageRecipientsConnection';
  /** A list of edges which contains the `MessageRecipient` and cursor to aid in pagination. */
  edges: Array<MessageRecipientsEdge>;
  /** A list of `MessageRecipient` objects. */
  nodes: Array<Maybe<MessageRecipient>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MessageRecipient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MessageRecipient` edge in the connection. */
export type MessageRecipientsEdge = {
  __typename?: 'MessageRecipientsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MessageRecipient` at the end of the edge. */
  node?: Maybe<MessageRecipient>;
};

/** Methods to use when ordering `MessageRecipient`. */
export type MessageRecipientsOrderBy =
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__BODY_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__BODY_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__COMPANY_ID_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__COMPANY_ID_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__CREATED_AT_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__CREATED_AT_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__FROM_EMPLOYEE_ID_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__FROM_EMPLOYEE_ID_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__ID_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__ID_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__READ_BY_FROM_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__READ_BY_FROM_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__READ_BY_TO_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__READ_BY_TO_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__SUBJECT_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__SUBJECT_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__TO_EMPLOYEE_ID_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__TO_EMPLOYEE_ID_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__TYPE_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__TYPE_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__UPDATED_AT_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__UPDATED_AT_DESC'
  | 'MESSAGE_ID_ASC'
  | 'MESSAGE_ID_DESC'
  | 'NATURAL';

/** The `message` to be created by this mutation. */
export type MessageToEmployeeIdForeignConnectionMessageCreateInput = {
  audioFile?: InputMaybe<Scalars['String']>;
  body: Scalars['String'];
  company?: InputMaybe<MessageCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<MessageToEmployeeIdForeignInput>;
  fromEmployeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  latestMessages?: InputMaybe<LatestMessageMessageIdForeignInverseInput>;
  messageRecipients?: InputMaybe<MessageRecipientMessageIdForeignInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInverseInput>;
  readByFrom?: InputMaybe<Scalars['Boolean']>;
  readByTo?: InputMaybe<Scalars['Boolean']>;
  subject: Scalars['String'];
  type?: InputMaybe<MessageType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `employee` in the `MessageInput` mutation. */
export type MessageToEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnMessageForMessageToEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnMessageForMessageToEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `message` in the `EmployeeInput` mutation. */
export type MessageToEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `message` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MessageMessagePkeyConnect>>;
  /** A `MessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<MessageToEmployeeIdForeignConnectionMessageCreateInput>>;
  /** The primary key(s) and patch data for `message` for the far side of the relationship. */
  updateById?: InputMaybe<Array<MessageOnMessageForMessageToEmployeeIdForeignUsingMessagePkeyUpdate>>;
};

/** A filter to be used against many `LatestMessage` object types. All fields are combined with a logical ‘and.’ */
export type MessageToManyLatestMessageFilter = {
  /** Every related `LatestMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LatestMessageFilter>;
  /** No related `LatestMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LatestMessageFilter>;
  /** Some related `LatestMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LatestMessageFilter>;
};

/** A filter to be used against many `MessageRecipient` object types. All fields are combined with a logical ‘and.’ */
export type MessageToManyMessageRecipientFilter = {
  /** Every related `MessageRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MessageRecipientFilter>;
  /** No related `MessageRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MessageRecipientFilter>;
  /** Some related `MessageRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MessageRecipientFilter>;
};

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type MessageToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

export type MessageType =
  | 'CHAT'
  | 'EMAIL'
  | 'SMS';

/** A filter to be used against MessageType fields. All fields are combined with a logical ‘and.’ */
export type MessageTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<MessageType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<MessageType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<MessageType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<MessageType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<MessageType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<MessageType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<MessageType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<MessageType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<MessageType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<MessageType>>;
};

/** A connection to a list of `Message` values. */
export type MessagesConnection = {
  __typename?: 'MessagesConnection';
  /** A list of edges which contains the `Message` and cursor to aid in pagination. */
  edges: Array<MessagesEdge>;
  /** A list of `Message` objects. */
  nodes: Array<Maybe<Message>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Message` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Message` edge in the connection. */
export type MessagesEdge = {
  __typename?: 'MessagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Message` at the end of the edge. */
  node?: Maybe<Message>;
};

/** Methods to use when ordering `Message`. */
export type MessagesOrderBy =
  | 'BODY_ASC'
  | 'BODY_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_TO_EMPLOYEE_ID__USER_ID_DESC'
  | 'FROM_EMPLOYEE_ID_ASC'
  | 'FROM_EMPLOYEE_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LATEST_MESSAGES_BY_MESSAGE_ID__COUNT_ASC'
  | 'LATEST_MESSAGES_BY_MESSAGE_ID__COUNT_DESC'
  | 'MESSAGE_RECIPIENTS_BY_MESSAGE_ID__COUNT_ASC'
  | 'MESSAGE_RECIPIENTS_BY_MESSAGE_ID__COUNT_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_MESSAGE_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_MESSAGE_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'READ_BY_FROM_ASC'
  | 'READ_BY_FROM_DESC'
  | 'READ_BY_TO_ASC'
  | 'READ_BY_TO_DESC'
  | 'SUBJECT_ASC'
  | 'SUBJECT_DESC'
  | 'TO_EMPLOYEE_ID_ASC'
  | 'TO_EMPLOYEE_ID_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  CreateIntegration?: Maybe<CreateIntegrationResponse>;
  DeleteIntegration?: Maybe<DeleteIntegrationResponse>;
  FileDelete?: Maybe<FileDeletePayload>;
  FileDownload?: Maybe<FileDownloadPayload>;
  FileUpdate?: Maybe<FileUpdatePayload>;
  FileUpload?: Maybe<FileUploadPayload>;
  FileUploadLogo?: Maybe<FileUploadPayload>;
  FileUploadPublic?: Maybe<FileUploadPublicPayload>;
  GeneratePDF?: Maybe<GeneratePdfPayload>;
  ImportEmployeesFromFile: Scalars['Boolean'];
  ImportEquipmentFromFile: Scalars['Boolean'];
  SendMessage?: Maybe<MessageGraphilePayload>;
  SendPreboardingLinks?: Maybe<SendPreboardingLinksPayload>;
  UpdateIntegrationCredentials?: Maybe<UpdateIntegrationCredentialsResponse>;
  UploadFilesToBucket?: Maybe<UploadFilesToBucketPayload>;
  activateIntegrableSystemIntegration: Scalars['Boolean'];
  addCompanyRoleToUser?: Maybe<AddCompanyRoleToUserPayload>;
  addDepartmentRoleToUser?: Maybe<AddDepartmentRoleToUserPayload>;
  addRoleToGroup?: Maybe<AddRoleToGroupPayload>;
  addRoleToUser?: Maybe<AddRoleToUserPayload>;
  adminCreateCompanyWithRelations?: Maybe<AdminCreateCompanyWithRelationsPayload>;
  announcementReadAll?: Maybe<AnnouncementReadAllPayload>;
  applyTimeRegistrationTemplate?: Maybe<TimeRegistrationTemplate>;
  approveTimeRegistrationsByDeadline?: Maybe<ApproveTimeRegistrationsByDeadlinePayload>;
  arrayIntersect?: Maybe<ArrayIntersectPayload>;
  autoAddPermissionGroups?: Maybe<AutoAddPermissionGroupsPayload>;
  bulkApplyTimeRegistrationTemplate?: Maybe<TimeRegistrationTemplate>;
  bulkUpdateEmployeeCustomMutation: Scalars['Boolean'];
  changeGodModeStatus?: Maybe<ChangeGodModeStatusPayload>;
  changeTimeRegistrationBreakType?: Maybe<TimeRegistrationPresence>;
  changeTimeRegistrationPresence?: Maybe<TimeRegistrationPresence>;
  changeTimeRegistrationProject?: Maybe<TimeRegistrationPresence>;
  checkCompanyGrowthPermissions?: Maybe<CheckCompanyGrowthPermissionsPayload>;
  checkLogPermission?: Maybe<CheckLogPermissionPayload>;
  checkPinCode?: Maybe<Scalars['Boolean']>;
  checkPublishedAnnouncements?: Maybe<CheckPublishedAnnouncementsPayload>;
  cleanupEmptyGroups?: Maybe<CleanupEmptyGroupsPayload>;
  clearTimeRegistrationPresenceTemplateDay?: Maybe<ClearTimeRegistrationPresenceTemplateDayPayload>;
  clearTranslationsCache?: Maybe<Scalars['Boolean']>;
  clockIn?: Maybe<TimeRegistrationPresence>;
  clockOut?: Maybe<TimeRegistrationPresence>;
  cloneContractTemplate?: Maybe<CloneContractTemplatePayload>;
  cloneProcess?: Maybe<Process>;
  completeTask?: Maybe<CompleteTaskPayload>;
  convertformfieldentrytoemail?: Maybe<ConvertformfieldentrytoemailPayload>;
  copyCompany?: Maybe<CopyCompanyPayload>;
  copyUserGroupToUserCompanyGroup?: Maybe<CopyUserGroupToUserCompanyGroupPayload>;
  copyUserGroupToUserDepartmentGroup?: Maybe<CopyUserGroupToUserDepartmentGroupPayload>;
  /** Creates a single `Announcement`. */
  createAnnouncement?: Maybe<CreateAnnouncementPayload>;
  /** Creates a single `Approval`. */
  createApproval?: Maybe<CreateApprovalPayload>;
  createAuthAppMutation?: Maybe<AuthAppPayload>;
  /** Creates a single `AuthAppType`. */
  createAuthAppType?: Maybe<CreateAuthAppTypePayload>;
  /** Creates a single `AuthCode`. */
  createAuthCode?: Maybe<CreateAuthCodePayload>;
  /** Creates a single `Changelog`. */
  createChangelog?: Maybe<CreateChangelogPayload>;
  /** Creates a single `ChangelogUser`. */
  createChangelogUser?: Maybe<CreateChangelogUserPayload>;
  /** Creates a single `ChosenColumn`. */
  createChosenColumn?: Maybe<CreateChosenColumnPayload>;
  /** Creates a single `CompanyCompanyType`. */
  createCompanyCompanyType?: Maybe<CreateCompanyCompanyTypePayload>;
  /** Creates a single `CompanySystemField`. */
  createCompanySystemField?: Maybe<CreateCompanySystemFieldPayload>;
  /** Creates a single `CompanySystemFieldOption`. */
  createCompanySystemFieldOption?: Maybe<CreateCompanySystemFieldOptionPayload>;
  /** Creates a single `CompanyType`. */
  createCompanyType?: Maybe<CreateCompanyTypePayload>;
  /** Creates a single `Competence`. */
  createCompetence?: Maybe<CreateCompetencePayload>;
  /** Creates a single `CompetenceFormField`. */
  createCompetenceFormField?: Maybe<CreateCompetenceFormFieldPayload>;
  /** Creates a single `CompetenceGroup`. */
  createCompetenceGroup?: Maybe<CreateCompetenceGroupPayload>;
  /** Creates a single `CompetenceRequest`. */
  createCompetenceRequest?: Maybe<CreateCompetenceRequestPayload>;
  /** Creates a single `ContractPredefinedPlaceholder`. */
  createContractPredefinedPlaceholder?: Maybe<CreateContractPredefinedPlaceholderPayload>;
  /** Creates a single `ContractSignPending`. */
  createContractSignPending?: Maybe<CreateContractSignPendingPayload>;
  /** Creates a single `ContractSignPendingDocument`. */
  createContractSignPendingDocument?: Maybe<CreateContractSignPendingDocumentPayload>;
  /** Creates a single `ContractSignPendingSigner`. */
  createContractSignPendingSigner?: Maybe<CreateContractSignPendingSignerPayload>;
  /** Creates a single `ContractTemplate`. */
  createContractTemplate?: Maybe<CreateContractTemplatePayload>;
  /** Creates a single `ContractTemplateDepartment`. */
  createContractTemplateDepartment?: Maybe<CreateContractTemplateDepartmentPayload>;
  /** Creates a single `ContractTemplateFormField`. */
  createContractTemplateFormField?: Maybe<CreateContractTemplateFormFieldPayload>;
  /** Creates a single `ContractTemplateUser`. */
  createContractTemplateUser?: Maybe<CreateContractTemplateUserPayload>;
  /** Creates a single `CustomWidget`. */
  createCustomWidget?: Maybe<CreateCustomWidgetPayload>;
  /** Creates a single `CustomWidgetContent`. */
  createCustomWidgetContent?: Maybe<CreateCustomWidgetContentPayload>;
  /** Creates a single `CvTemplateFieldMapping`. */
  createCvTemplateFieldMapping?: Maybe<CreateCvTemplateFieldMappingPayload>;
  /** Creates a single `DashboardCard`. */
  createDashboardCard?: Maybe<CreateDashboardCardPayload>;
  /** Creates a single `DashboardCardStatistic`. */
  createDashboardCardStatistic?: Maybe<CreateDashboardCardStatisticPayload>;
  /** Creates a single `DashboardConfig`. */
  createDashboardConfig?: Maybe<CreateDashboardConfigPayload>;
  /** Creates a single `DashboardView`. */
  createDashboardView?: Maybe<CreateDashboardViewPayload>;
  /** Creates a single `Department`. */
  createDepartment?: Maybe<CreateDepartmentPayload>;
  /** Creates a single `DepartmentType`. */
  createDepartmentType?: Maybe<CreateDepartmentTypePayload>;
  /** Creates a single `DocumentDepartmentPermission`. */
  createDocumentDepartmentPermission?: Maybe<CreateDocumentDepartmentPermissionPayload>;
  /** Creates a single `DocumentFolder`. */
  createDocumentFolder?: Maybe<CreateDocumentFolderPayload>;
  /** Creates a single `DocumentFolderBlueprint`. */
  createDocumentFolderBlueprint?: Maybe<CreateDocumentFolderBlueprintPayload>;
  /** Creates a single `DocumentFolderDepartment`. */
  createDocumentFolderDepartment?: Maybe<CreateDocumentFolderDepartmentPayload>;
  /** Creates a single `DocumentFolderUser`. */
  createDocumentFolderUser?: Maybe<CreateDocumentFolderUserPayload>;
  /** Creates a single `DocumentType`. */
  createDocumentType?: Maybe<CreateDocumentTypePayload>;
  /** Creates a single `DocumentUserPermission`. */
  createDocumentUserPermission?: Maybe<CreateDocumentUserPermissionPayload>;
  /** Creates a single `DocumentUserResponsible`. */
  createDocumentUserResponsible?: Maybe<CreateDocumentUserResponsiblePayload>;
  createEmployeeCasefile?: Maybe<EmployeeCasefile>;
  createEmployeeCustomMutation?: Maybe<Employee>;
  /** Creates a single `EmployeeExternalIntegration`. */
  createEmployeeExternalIntegration?: Maybe<CreateEmployeeExternalIntegrationPayload>;
  /** Creates a single `EngagementType`. */
  createEngagementType?: Maybe<CreateEngagementTypePayload>;
  /** Creates a single `Equipment`. */
  createEquipment?: Maybe<CreateEquipmentPayload>;
  createErrorReport?: Maybe<ErrorReportResponse>;
  /** Creates a single `Event`. */
  createEvent?: Maybe<CreateEventPayload>;
  /** Creates a single `EventUser`. */
  createEventUser?: Maybe<CreateEventUserPayload>;
  /** Creates a single `ExternalIntegration`. */
  createExternalIntegration?: Maybe<CreateExternalIntegrationPayload>;
  /** Creates a single `FieldGroup`. */
  createFieldGroup?: Maybe<CreateFieldGroupPayload>;
  /** Creates a single `FieldGroupCard`. */
  createFieldGroupCard?: Maybe<CreateFieldGroupCardPayload>;
  /** Creates a single `FieldGroupCardColumn`. */
  createFieldGroupCardColumn?: Maybe<CreateFieldGroupCardColumnPayload>;
  /** Creates a single `FilterPreset`. */
  createFilterPreset?: Maybe<CreateFilterPresetPayload>;
  /** Creates a single `FilterView`. */
  createFilterView?: Maybe<CreateFilterViewPayload>;
  /** Creates a single `FormField`. */
  createFormField?: Maybe<CreateFormFieldPayload>;
  /** Creates a single `FormFieldAgreement`. */
  createFormFieldAgreement?: Maybe<CreateFormFieldAgreementPayload>;
  /** Creates a single `FormFieldEntry`. */
  createFormFieldEntry?: Maybe<CreateFormFieldEntryPayload>;
  /** Creates a single `FormFieldOption`. */
  createFormFieldOption?: Maybe<CreateFormFieldOptionPayload>;
  /** Creates a single `FroalaStyle`. */
  createFroalaStyle?: Maybe<CreateFroalaStylePayload>;
  createFutureDatum?: Maybe<CreateFutureDatumPayload>;
  /** Creates a single `Group`. */
  createGroup?: Maybe<CreateGroupPayload>;
  /** Creates a single `GroupRole`. */
  createGroupRole?: Maybe<CreateGroupRolePayload>;
  /** Creates a single `IntegrableSystem`. */
  createIntegrableSystem?: Maybe<CreateIntegrableSystemPayload>;
  createIntegrableSystemIntegration: Scalars['String'];
  /** Creates a single `IntegrationFieldMarking`. */
  createIntegrationFieldMarking?: Maybe<CreateIntegrationFieldMarkingPayload>;
  createLoggedAction?: Maybe<CreateLoggedActionPayload>;
  /** Creates a single `LoggedActionNote`. */
  createLoggedActionNote?: Maybe<CreateLoggedActionNotePayload>;
  /** Creates a single `Message`. */
  createMessage?: Maybe<CreateMessagePayload>;
  /** Creates a single `MessageRecipient`. */
  createMessageRecipient?: Maybe<CreateMessageRecipientPayload>;
  /** Creates a single `Notification`. */
  createNotification?: Maybe<CreateNotificationPayload>;
  /** Creates a single `NotificationCustomEmployeeFieldRecipient`. */
  createNotificationCustomEmployeeFieldRecipient?: Maybe<CreateNotificationCustomEmployeeFieldRecipientPayload>;
  /** Creates a single `NotificationCustomRecipient`. */
  createNotificationCustomRecipient?: Maybe<CreateNotificationCustomRecipientPayload>;
  /** Creates a single `NotificationEmployee`. */
  createNotificationEmployee?: Maybe<CreateNotificationEmployeePayload>;
  /** Creates a single `NotificationEmployeeReference`. */
  createNotificationEmployeeReference?: Maybe<CreateNotificationEmployeeReferencePayload>;
  /** Creates a single `NotificationGroupRecipient`. */
  createNotificationGroupRecipient?: Maybe<CreateNotificationGroupRecipientPayload>;
  /** Creates a single `NotificationType`. */
  createNotificationType?: Maybe<CreateNotificationTypePayload>;
  /** Creates a single `NotificationTypeChannelType`. */
  createNotificationTypeChannelType?: Maybe<CreateNotificationTypeChannelTypePayload>;
  /** Creates a single `Post`. */
  createPost?: Maybe<CreatePostPayload>;
  createPostComment?: Maybe<Post>;
  /** Creates a single `PostType`. */
  createPostType?: Maybe<CreatePostTypePayload>;
  /** Creates a single `Preboarding`. */
  createPreboarding?: Maybe<CreatePreboardingPayload>;
  /** Creates a single `PreboardingComment`. */
  createPreboardingComment?: Maybe<CreatePreboardingCommentPayload>;
  /** Creates a single `PreboardingEmployee`. */
  createPreboardingEmployee?: Maybe<CreatePreboardingEmployeePayload>;
  /** Creates a single `PreboardingFormCache`. */
  createPreboardingFormCache?: Maybe<CreatePreboardingFormCachePayload>;
  /** Creates a single `PreboardingProcess`. */
  createPreboardingProcess?: Maybe<CreatePreboardingProcessPayload>;
  /** Creates a single `PreboardingResult`. */
  createPreboardingResult?: Maybe<CreatePreboardingResultPayload>;
  /** Creates a single `PreboardingResultSlideComment`. */
  createPreboardingResultSlideComment?: Maybe<CreatePreboardingResultSlideCommentPayload>;
  /** Creates a single `PreboardingSlide`. */
  createPreboardingSlide?: Maybe<CreatePreboardingSlidePayload>;
  /** Creates a single `PreboardingSlideFormField`. */
  createPreboardingSlideFormField?: Maybe<CreatePreboardingSlideFormFieldPayload>;
  /** Creates a single `Process`. */
  createProcess?: Maybe<CreateProcessPayload>;
  /** Creates a single `ProcessDepartment`. */
  createProcessDepartment?: Maybe<CreateProcessDepartmentPayload>;
  /** Creates a single `ProcessEmployee`. */
  createProcessEmployee?: Maybe<CreateProcessEmployeePayload>;
  /** Creates a single `ProcessResponsible`. */
  createProcessResponsible?: Maybe<CreateProcessResponsiblePayload>;
  /** Creates a single `ProcessType`. */
  createProcessType?: Maybe<CreateProcessTypePayload>;
  /** Creates a single `Product`. */
  createProduct?: Maybe<CreateProductPayload>;
  /** Creates a single `ProductType`. */
  createProductType?: Maybe<CreateProductTypePayload>;
  /** Creates a single `Project`. */
  createProject?: Maybe<CreateProjectPayload>;
  /** Creates a single `ProjectTemplate`. */
  createProjectTemplate?: Maybe<CreateProjectTemplatePayload>;
  createPulseSurvey?: Maybe<PulseSurvey>;
  /** Creates a single `PulseType`. */
  createPulseType?: Maybe<CreatePulseTypePayload>;
  /** Creates a single `RecurrenceRule`. */
  createRecurrenceRule?: Maybe<CreateRecurrenceRulePayload>;
  /** Creates a single `RoadmapItem`. */
  createRoadmapItem?: Maybe<CreateRoadmapItemPayload>;
  /** Creates a single `RoadmapItemComment`. */
  createRoadmapItemComment?: Maybe<CreateRoadmapItemCommentPayload>;
  /** Creates a single `RoadmapItemLocalization`. */
  createRoadmapItemLocalization?: Maybe<CreateRoadmapItemLocalizationPayload>;
  /** Creates a single `RoadmapItemVote`. */
  createRoadmapItemVote?: Maybe<CreateRoadmapItemVotePayload>;
  /** Creates a single `Role`. */
  createRole?: Maybe<CreateRolePayload>;
  /** Creates a single `SavedSignature`. */
  createSavedSignature?: Maybe<CreateSavedSignaturePayload>;
  /** Creates a single `ScheduledMessage`. */
  createScheduledMessage?: Maybe<CreateScheduledMessagePayload>;
  /** Creates a single `ScheduledMessageExternalRecipient`. */
  createScheduledMessageExternalRecipient?: Maybe<CreateScheduledMessageExternalRecipientPayload>;
  /** Creates a single `ScheduledMessageRecipient`. */
  createScheduledMessageRecipient?: Maybe<CreateScheduledMessageRecipientPayload>;
  /** Creates a single `ScheduledMessageTemplate`. */
  createScheduledMessageTemplate?: Maybe<CreateScheduledMessageTemplatePayload>;
  /** Creates a single `ScheduledMessageTemplateExternalRecipient`. */
  createScheduledMessageTemplateExternalRecipient?: Maybe<CreateScheduledMessageTemplateExternalRecipientPayload>;
  /** Creates a single `ScheduledMessageTemplateRecipient`. */
  createScheduledMessageTemplateRecipient?: Maybe<CreateScheduledMessageTemplateRecipientPayload>;
  /** Creates a single `Storage`. */
  createStorage?: Maybe<CreateStoragePayload>;
  /** Creates a single `SuperUser`. */
  createSuperUser?: Maybe<CreateSuperUserPayload>;
  /** Creates a single `SuperUserAllowedUser`. */
  createSuperUserAllowedUser?: Maybe<CreateSuperUserAllowedUserPayload>;
  /** Creates a single `SystemFieldType`. */
  createSystemFieldType?: Maybe<CreateSystemFieldTypePayload>;
  /** Creates a single `Task`. */
  createTask?: Maybe<CreateTaskPayload>;
  /** Creates a single `TaskEmployee`. */
  createTaskEmployee?: Maybe<CreateTaskEmployeePayload>;
  /** Creates a single `TaskResponsible`. */
  createTaskResponsible?: Maybe<CreateTaskResponsiblePayload>;
  /** Creates a single `TaskTemplate`. */
  createTaskTemplate?: Maybe<CreateTaskTemplatePayload>;
  /** Creates a single `TaskTemplateEmployee`. */
  createTaskTemplateEmployee?: Maybe<CreateTaskTemplateEmployeePayload>;
  /** Creates a single `TaskTemplateResponsible`. */
  createTaskTemplateResponsible?: Maybe<CreateTaskTemplateResponsiblePayload>;
  /** Creates a single `TimeRegistrationBreakType`. */
  createTimeRegistrationBreakType?: Maybe<CreateTimeRegistrationBreakTypePayload>;
  /** Creates a single `TimeRegistrationEntry`. */
  createTimeRegistrationEntry?: Maybe<CreateTimeRegistrationEntryPayload>;
  /** Creates a single `TimeRegistrationEntryTemplate`. */
  createTimeRegistrationEntryTemplate?: Maybe<CreateTimeRegistrationEntryTemplatePayload>;
  /** Creates a single `TimeRegistrationPresence`. */
  createTimeRegistrationPresence?: Maybe<CreateTimeRegistrationPresencePayload>;
  /** Creates a single `TimeRegistrationPresenceTemplate`. */
  createTimeRegistrationPresenceTemplate?: Maybe<CreateTimeRegistrationPresenceTemplatePayload>;
  /** Creates a single `TimeRegistrationPresenceType`. */
  createTimeRegistrationPresenceType?: Maybe<CreateTimeRegistrationPresenceTypePayload>;
  /** Creates a single `TimeRegistrationProject`. */
  createTimeRegistrationProject?: Maybe<CreateTimeRegistrationProjectPayload>;
  /** Creates a single `TimeRegistrationTemplate`. */
  createTimeRegistrationTemplate?: Maybe<CreateTimeRegistrationTemplatePayload>;
  /** Creates a single `TimeRegistrationTemplateWeek`. */
  createTimeRegistrationTemplateWeek?: Maybe<CreateTimeRegistrationTemplateWeekPayload>;
  /** Creates a single `TranslatedEntity`. */
  createTranslatedEntity?: Maybe<CreateTranslatedEntityPayload>;
  /** Creates a single `TranslatedEntityLocalization`. */
  createTranslatedEntityLocalization?: Maybe<CreateTranslatedEntityLocalizationPayload>;
  /** Creates a single `Translation`. */
  createTranslation?: Maybe<CreateTranslationPayload>;
  /** Creates a single `UserAnnouncement`. */
  createUserAnnouncement?: Maybe<CreateUserAnnouncementPayload>;
  /** Creates a single `UserCompanyGroup`. */
  createUserCompanyGroup?: Maybe<CreateUserCompanyGroupPayload>;
  /** Creates a single `UserCompanyRole`. */
  createUserCompanyRole?: Maybe<CreateUserCompanyRolePayload>;
  /** Creates a single `UserCompetence`. */
  createUserCompetence?: Maybe<CreateUserCompetencePayload>;
  /** Creates a single `UserCompetenceEvaluation`. */
  createUserCompetenceEvaluation?: Maybe<CreateUserCompetenceEvaluationPayload>;
  /** Creates a single `UserCompetenceEvaluationComment`. */
  createUserCompetenceEvaluationComment?: Maybe<CreateUserCompetenceEvaluationCommentPayload>;
  /** Creates a single `UserDepartment`. */
  createUserDepartment?: Maybe<CreateUserDepartmentPayload>;
  /** Creates a single `UserDepartmentGroup`. */
  createUserDepartmentGroup?: Maybe<CreateUserDepartmentGroupPayload>;
  /** Creates a single `UserDepartmentRole`. */
  createUserDepartmentRole?: Maybe<CreateUserDepartmentRolePayload>;
  /** Creates a single `UserGroup`. */
  createUserGroup?: Maybe<CreateUserGroupPayload>;
  /** Creates a single `UserOnBehalfPermission`. */
  createUserOnBehalfPermission?: Maybe<CreateUserOnBehalfPermissionPayload>;
  /** Creates a single `UserRole`. */
  createUserRole?: Maybe<CreateUserRolePayload>;
  /** Creates a single `UserSetting`. */
  createUserSetting?: Maybe<CreateUserSettingPayload>;
  /** Creates a single `VacationType`. */
  createVacationType?: Maybe<CreateVacationTypePayload>;
  /** Creates a single `VacationUser`. */
  createVacationUser?: Maybe<CreateVacationUserPayload>;
  deactivateOldCompanyLogo?: Maybe<DeactivateOldCompanyLogoPayload>;
  deactivateOldContractsOnSign?: Maybe<DeactivateOldContractsOnSignPayload>;
  deleteAllCompanyEmployeeNotifications?: Maybe<DeleteAllCompanyEmployeeNotificationsPayload>;
  deleteAuthAppMutation?: Maybe<AuthAppPayload>;
  /** Deletes a single `AuthAppType` using a unique key. */
  deleteAuthAppTypeById?: Maybe<DeleteAuthAppTypePayload>;
  /** Deletes a single `AuthCode` using a unique key. */
  deleteAuthCodeById?: Maybe<DeleteAuthCodePayload>;
  /** Deletes a single `Changelog` using a unique key. */
  deleteChangelogById?: Maybe<DeleteChangelogPayload>;
  /** Deletes a single `ChangelogUser` using a unique key. */
  deleteChangelogUserByChangelogIdAndUserId?: Maybe<DeleteChangelogUserPayload>;
  /** Deletes a single `ChosenColumn` using a unique key. */
  deleteChosenColumnByUserIdAndTableName?: Maybe<DeleteChosenColumnPayload>;
  /** Deletes a single `CompanyCompanyType` using a unique key. */
  deleteCompanyCompanyTypeByCompanyId?: Maybe<DeleteCompanyCompanyTypePayload>;
  /** Deletes a single `CompanySystemField` using a unique key. */
  deleteCompanySystemFieldById?: Maybe<DeleteCompanySystemFieldPayload>;
  /** Deletes a single `CompanySystemField` using a unique key. */
  deleteCompanySystemFieldBySystemFieldIdAndCompanyId?: Maybe<DeleteCompanySystemFieldPayload>;
  /** Deletes a single `CompanyType` using a unique key. */
  deleteCompanyTypeById?: Maybe<DeleteCompanyTypePayload>;
  /** Deletes a single `CompetenceFormField` using a unique key. */
  deleteCompetenceFormFieldById?: Maybe<DeleteCompetenceFormFieldPayload>;
  deleteContractSignPendingByContractTemplateIds?: Maybe<DeleteContractSignPendingByContractTemplateIdsPayload>;
  /** Deletes a single `ContractSignPendingDocument` using a unique key. */
  deleteContractSignPendingDocumentById?: Maybe<DeleteContractSignPendingDocumentPayload>;
  /** Deletes a single `ContractSignPendingSigner` using a unique key. */
  deleteContractSignPendingSignerByContractSignPendingIdAndUserId?: Maybe<DeleteContractSignPendingSignerPayload>;
  /** Deletes a single `ContractSignPendingSigner` using a unique key. */
  deleteContractSignPendingSignerById?: Maybe<DeleteContractSignPendingSignerPayload>;
  /** Deletes a single `ContractTemplateDepartment` using a unique key. */
  deleteContractTemplateDepartmentByContractTemplateIdAndDepartmentId?: Maybe<DeleteContractTemplateDepartmentPayload>;
  /** Deletes a single `ContractTemplateUser` using a unique key. */
  deleteContractTemplateUserByUserIdAndContractTemplateId?: Maybe<DeleteContractTemplateUserPayload>;
  /** Deletes a single `CvTemplateFieldMapping` using a unique key. */
  deleteCvTemplateFieldMappingById?: Maybe<DeleteCvTemplateFieldMappingPayload>;
  /** Deletes a single `DashboardConfig` using a unique key. */
  deleteDashboardConfigByCompanyId?: Maybe<DeleteDashboardConfigPayload>;
  /** Deletes a single `DocumentDepartmentPermission` using a unique key. */
  deleteDocumentDepartmentPermissionByFileIdAndDepartmentId?: Maybe<DeleteDocumentDepartmentPermissionPayload>;
  /** Deletes a single `DocumentFolderDepartment` using a unique key. */
  deleteDocumentFolderDepartmentByDocumentFolderIdAndDepartmentId?: Maybe<DeleteDocumentFolderDepartmentPayload>;
  /** Deletes a single `DocumentFolderUser` using a unique key. */
  deleteDocumentFolderUserByDocumentFolderIdAndUserId?: Maybe<DeleteDocumentFolderUserPayload>;
  /** Deletes a single `DocumentUserPermission` using a unique key. */
  deleteDocumentUserPermissionByFileIdAndUserId?: Maybe<DeleteDocumentUserPermissionPayload>;
  /** Deletes a single `DocumentUserResponsible` using a unique key. */
  deleteDocumentUserResponsibleByFileIdAndUserId?: Maybe<DeleteDocumentUserResponsiblePayload>;
  /** Deletes a single `EmployeeExternalIntegration` using a unique key. */
  deleteEmployeeExternalIntegrationByEmployeeIdAndExternalIntegrationId?: Maybe<DeleteEmployeeExternalIntegrationPayload>;
  /** Deletes a single `EmployeeExternalIntegration` using a unique key. */
  deleteEmployeeExternalIntegrationBySameSystem?: Maybe<DeleteEmployeeExternalIntegrationPayload>;
  /** Deletes a single `Equipment` using a unique key. */
  deleteEquipmentById?: Maybe<DeleteEquipmentPayload>;
  /** Deletes a single `EventUser` using a unique key. */
  deleteEventUserByEventIdAndUserId?: Maybe<DeleteEventUserPayload>;
  /** Deletes a single `EventUser` using a unique key. */
  deleteEventUserById?: Maybe<DeleteEventUserPayload>;
  /** Deletes a single `ExternalIntegration` using a unique key. */
  deleteExternalIntegrationById?: Maybe<DeleteExternalIntegrationPayload>;
  /** Deletes a single `FilterView` using a unique key. */
  deleteFilterViewById?: Maybe<DeleteFilterViewPayload>;
  /** Deletes a single `FormFieldAgreement` using a unique key. */
  deleteFormFieldAgreementByFormFieldId?: Maybe<DeleteFormFieldAgreementPayload>;
  /** Deletes a single `FormFieldAgreement` using a unique key. */
  deleteFormFieldAgreementById?: Maybe<DeleteFormFieldAgreementPayload>;
  /** Deletes a single `GroupRole` using a unique key. */
  deleteGroupRoleByGroupIdAndRoleId?: Maybe<DeleteGroupRolePayload>;
  /** Deletes a single `IntegrableSystem` using a unique key. */
  deleteIntegrableSystemById?: Maybe<DeleteIntegrableSystemPayload>;
  deleteIntegrableSystemIntegration: Scalars['Boolean'];
  /** Deletes a single `NotificationCustomEmployeeFieldRecipient` using a unique key. */
  deleteNotificationCustomEmployeeFieldRecipientById?: Maybe<DeleteNotificationCustomEmployeeFieldRecipientPayload>;
  /** Deletes a single `NotificationCustomRecipient` using a unique key. */
  deleteNotificationCustomRecipientByNotificationIdAndEmployeeId?: Maybe<DeleteNotificationCustomRecipientPayload>;
  /** Deletes a single `NotificationEmployee` using a unique key. */
  deleteNotificationEmployeeById?: Maybe<DeleteNotificationEmployeePayload>;
  /** Deletes a single `NotificationEmployeeReference` using a unique key. */
  deleteNotificationEmployeeReferenceById?: Maybe<DeleteNotificationEmployeeReferencePayload>;
  /** Deletes a single `NotificationGroupRecipient` using a unique key. */
  deleteNotificationGroupRecipientByNotificationIdAndGroupId?: Maybe<DeleteNotificationGroupRecipientPayload>;
  deleteNotificationTypeChannelTypeByNotificationTypeId?: Maybe<DeleteNotificationTypeChannelTypeByNotificationTypeIdPayload>;
  /** Deletes a single `NotificationTypeChannelType` using a unique key. */
  deleteNotificationTypeChannelTypeByNotificationTypeIdAndChannelTypeId?: Maybe<DeleteNotificationTypeChannelTypePayload>;
  deleteOldRole?: Maybe<DeleteOldRolePayload>;
  deleteOldRoles?: Maybe<DeleteOldRolesPayload>;
  deletePostComment?: Maybe<Post>;
  /** Deletes a single `PostType` using a unique key. */
  deletePostTypeById?: Maybe<DeletePostTypePayload>;
  /** Deletes a single `PreboardingComment` using a unique key. */
  deletePreboardingCommentById?: Maybe<DeletePreboardingCommentPayload>;
  /** Deletes a single `PreboardingProcess` using a unique key. */
  deletePreboardingProcessByPreboardingIdAndProcessId?: Maybe<DeletePreboardingProcessPayload>;
  /** Deletes a single `PreboardingResult` using a unique key. */
  deletePreboardingResultById?: Maybe<DeletePreboardingResultPayload>;
  /** Deletes a single `PreboardingResultSlideComment` using a unique key. */
  deletePreboardingResultSlideCommentById?: Maybe<DeletePreboardingResultSlideCommentPayload>;
  /** Deletes a single `PreboardingSlideFormField` using a unique key. */
  deletePreboardingSlideFormFieldById?: Maybe<DeletePreboardingSlideFormFieldPayload>;
  /** Deletes a single `ProcessResponsible` using a unique key. */
  deleteProcessResponsibleByProcessIdAndResponsibleId?: Maybe<DeleteProcessResponsiblePayload>;
  /** Deletes a single `PulseSurveyAnswer` using a unique key. */
  deletePulseSurveyAnswerById?: Maybe<DeletePulseSurveyAnswerPayload>;
  /** Deletes a single `PulseSurveyAnswer` using a unique key. */
  deletePulseSurveyAnswerByUserIdAndPulseSurveyIdAndDate?: Maybe<DeletePulseSurveyAnswerPayload>;
  /** Deletes a single `PulseSurvey` using a unique key. */
  deletePulseSurveyById?: Maybe<DeletePulseSurveyPayload>;
  /** Deletes a single `PulseSurveyChoice` using a unique key. */
  deletePulseSurveyChoiceById?: Maybe<DeletePulseSurveyChoicePayload>;
  /** Deletes a single `PulseType` using a unique key. */
  deletePulseTypeById?: Maybe<DeletePulseTypePayload>;
  /** Deletes a single `PushToken` using a unique key. */
  deletePushTokenByUserId?: Maybe<DeletePushTokenPayload>;
  /** Deletes a single `RecurrenceRule` using a unique key. */
  deleteRecurrenceRuleById?: Maybe<DeleteRecurrenceRulePayload>;
  /** Deletes a single `RecurrenceRule` using a unique key. */
  deleteRecurrenceRuleByPulseSurveyId?: Maybe<DeleteRecurrenceRulePayload>;
  /** Deletes a single `RoadmapItemLocalization` using a unique key. */
  deleteRoadmapItemLocalizationById?: Maybe<DeleteRoadmapItemLocalizationPayload>;
  /** Deletes a single `RoadmapItemLocalization` using a unique key. */
  deleteRoadmapItemLocalizationByRoadmapItemIdAndLocale?: Maybe<DeleteRoadmapItemLocalizationPayload>;
  /** Deletes a single `RoadmapItemVote` using a unique key. */
  deleteRoadmapItemVoteById?: Maybe<DeleteRoadmapItemVotePayload>;
  /** Deletes a single `RoadmapItemVote` using a unique key. */
  deleteRoadmapItemVoteByUserIdAndRoadmapItemId?: Maybe<DeleteRoadmapItemVotePayload>;
  /** Deletes a single `Role` using a unique key. */
  deleteRoleById?: Maybe<DeleteRolePayload>;
  /** Deletes a single `SavedSignature` using a unique key. */
  deleteSavedSignatureById?: Maybe<DeleteSavedSignaturePayload>;
  /** Deletes a single `ScheduledMessageExternalRecipient` using a unique key. */
  deleteScheduledMessageExternalRecipientByScheduledMessageIdAndEmail?: Maybe<DeleteScheduledMessageExternalRecipientPayload>;
  /** Deletes a single `ScheduledMessageRecipient` using a unique key. */
  deleteScheduledMessageRecipientByScheduledMessageIdAndEmployeeId?: Maybe<DeleteScheduledMessageRecipientPayload>;
  /** Deletes a single `ScheduledMessageTemplateExternalRecipient` using a unique key. */
  deleteScheduledMessageTemplateExternalRecipientByScheduledMessageTemplateIdAndEmail?: Maybe<DeleteScheduledMessageTemplateExternalRecipientPayload>;
  /** Deletes a single `ScheduledMessageTemplateRecipient` using a unique key. */
  deleteScheduledMessageTemplateRecipientByScheduledMessageTemplateIdAndEmployeeId?: Maybe<DeleteScheduledMessageTemplateRecipientPayload>;
  /** Deletes a single `SuperUserAllowedUser` using a unique key. */
  deleteSuperUserAllowedUserById?: Maybe<DeleteSuperUserAllowedUserPayload>;
  /** Deletes a single `SuperUserAllowedUser` using a unique key. */
  deleteSuperUserAllowedUserBySuperUserIdAndCompanyId?: Maybe<DeleteSuperUserAllowedUserPayload>;
  /** Deletes a single `SuperUser` using a unique key. */
  deleteSuperUserById?: Maybe<DeleteSuperUserPayload>;
  /** Deletes a single `SuperUser` using a unique key. */
  deleteSuperUserByUserId?: Maybe<DeleteSuperUserPayload>;
  /** Deletes a single `SystemFieldType` using a unique key. */
  deleteSystemFieldTypeByType?: Maybe<DeleteSystemFieldTypePayload>;
  /** Deletes a single `TaskEmployee` using a unique key. */
  deleteTaskEmployeeByTaskIdAndEmployeeId?: Maybe<DeleteTaskEmployeePayload>;
  /** Deletes a single `TaskResponsible` using a unique key. */
  deleteTaskResponsibleByTaskIdAndResponsibleId?: Maybe<DeleteTaskResponsiblePayload>;
  /** Deletes a single `TaskTemplateEmployee` using a unique key. */
  deleteTaskTemplateEmployeeByTaskTemplateIdAndEmployeeId?: Maybe<DeleteTaskTemplateEmployeePayload>;
  /** Deletes a single `TaskTemplateResponsible` using a unique key. */
  deleteTaskTemplateResponsibleByTaskTemplateIdAndResponsibleId?: Maybe<DeleteTaskTemplateResponsiblePayload>;
  deleteTemporaryCasefile?: Maybe<DeleteTemporaryCasefilePayload>;
  /** Deletes a single `TimeRegistrationBreakType` using a unique key. */
  deleteTimeRegistrationBreakTypeById?: Maybe<DeleteTimeRegistrationBreakTypePayload>;
  /** Deletes a single `TimeRegistrationEntry` using a unique key. */
  deleteTimeRegistrationEntryById?: Maybe<DeleteTimeRegistrationEntryPayload>;
  /** Deletes a single `TimeRegistrationEntryTemplate` using a unique key. */
  deleteTimeRegistrationEntryTemplateById?: Maybe<DeleteTimeRegistrationEntryTemplatePayload>;
  /** Deletes a single `TimeRegistrationPresence` using a unique key. */
  deleteTimeRegistrationPresenceById?: Maybe<DeleteTimeRegistrationPresencePayload>;
  /** Deletes a single `TimeRegistrationPresenceTemplate` using a unique key. */
  deleteTimeRegistrationPresenceTemplateById?: Maybe<DeleteTimeRegistrationPresenceTemplatePayload>;
  /** Deletes a single `TimeRegistrationPresenceType` using a unique key. */
  deleteTimeRegistrationPresenceTypeById?: Maybe<DeleteTimeRegistrationPresenceTypePayload>;
  /** Deletes a single `TimeRegistrationProject` using a unique key. */
  deleteTimeRegistrationProjectById?: Maybe<DeleteTimeRegistrationProjectPayload>;
  /** Deletes a single `TimeRegistrationTemplate` using a unique key. */
  deleteTimeRegistrationTemplateById?: Maybe<DeleteTimeRegistrationTemplatePayload>;
  /** Deletes a single `TimeRegistrationTemplateWeek` using a unique key. */
  deleteTimeRegistrationTemplateWeekById?: Maybe<DeleteTimeRegistrationTemplateWeekPayload>;
  /** Deletes a single `TranslatedEntity` using a unique key. */
  deleteTranslatedEntityById?: Maybe<DeleteTranslatedEntityPayload>;
  /** Deletes a single `TranslatedEntityLocalization` using a unique key. */
  deleteTranslatedEntityLocalizationById?: Maybe<DeleteTranslatedEntityLocalizationPayload>;
  /** Deletes a single `TranslatedEntityLocalization` using a unique key. */
  deleteTranslatedEntityLocalizationByTranslatedEntityIdAndLocale?: Maybe<DeleteTranslatedEntityLocalizationPayload>;
  /** Deletes a single `Translation` using a unique key. */
  deleteTranslationById?: Maybe<DeleteTranslationPayload>;
  /** Deletes a single `UserAnnouncement` using a unique key. */
  deleteUserAnnouncementByUserIdAndAnnouncementId?: Maybe<DeleteUserAnnouncementPayload>;
  /** Deletes a single `UserCompanyGroup` using a unique key. */
  deleteUserCompanyGroupByUserIdAndGroupIdAndCompanyId?: Maybe<DeleteUserCompanyGroupPayload>;
  /** Deletes a single `UserCompanyRole` using a unique key. */
  deleteUserCompanyRoleByUserIdAndRoleIdAndCompanyId?: Maybe<DeleteUserCompanyRolePayload>;
  /** Deletes a single `UserDepartment` using a unique key. */
  deleteUserDepartmentByDepartmentIdAndUserId?: Maybe<DeleteUserDepartmentPayload>;
  /** Deletes a single `UserDepartment` using a unique key. */
  deleteUserDepartmentById?: Maybe<DeleteUserDepartmentPayload>;
  /** Deletes a single `UserDepartmentGroup` using a unique key. */
  deleteUserDepartmentGroupByUserIdAndDepartmentIdAndGroupId?: Maybe<DeleteUserDepartmentGroupPayload>;
  /** Deletes a single `UserDepartmentRole` using a unique key. */
  deleteUserDepartmentRoleByUserIdAndDepartmentIdAndRoleId?: Maybe<DeleteUserDepartmentRolePayload>;
  /** Deletes a single `UserGroup` using a unique key. */
  deleteUserGroupByUserIdAndGroupId?: Maybe<DeleteUserGroupPayload>;
  /** Deletes a single `UserOnBehalfPermission` using a unique key. */
  deleteUserOnBehalfPermissionById?: Maybe<DeleteUserOnBehalfPermissionPayload>;
  /** Deletes a single `UserRole` using a unique key. */
  deleteUserRoleByUserIdAndRoleId?: Maybe<DeleteUserRolePayload>;
  /** Deletes a single `UserSetting` using a unique key. */
  deleteUserSettingByUserIdAndKey?: Maybe<DeleteUserSettingPayload>;
  departmentDescendants?: Maybe<DepartmentDescendantsPayload>;
  docxToHtml?: Maybe<DocxToHtmlPayload>;
  downloadBulkDocumentTemplate?: Maybe<BulkDocumentTemplatePayload>;
  downloadCasefileDocument?: Maybe<DownloadCasefileDocumentPayload>;
  employeeLatestMessageTimestamp?: Maybe<EmployeeLatestMessageTimestampPayload>;
  endBreak?: Maybe<TimeRegistrationPresence>;
  fixBrokenContract?: Maybe<Scalars['Boolean']>;
  formEntryTxtToTsvector?: Maybe<FormEntryTxtToTsvectorPayload>;
  getAnnouncementRecipients?: Maybe<GetAnnouncementRecipientsPayload>;
  getContractSignPendingSignatures?: Maybe<GetContractSignPendingSignaturesPayload>;
  getExternalEmployeeId?: Maybe<GetExternalEmployeeIdPayload>;
  getExternalIntegrations?: Maybe<GetExternalIntegrationsPayload>;
  getPreboardingEmployeeProcesses?: Maybe<GetPreboardingEmployeeProcessesPayload>;
  getPresignedUploadLink?: Maybe<PresignedLinkPayload>;
  giveDepartmentAdministratorsRank?: Maybe<GiveDepartmentAdministratorsRankPayload>;
  grantAdditionalRole?: Maybe<GrantAdditionalRolePayload>;
  grantAdditionalRoles?: Maybe<GrantAdditionalRolesPayload>;
  hasSuperUserAccess?: Maybe<HasSuperUserAccessPayload>;
  htmlToPdf?: Maybe<HtmlToPdfPayload>;
  intersection?: Maybe<IntersectionPayload>;
  likePost?: Maybe<Post>;
  linkDepartmentAdministrators?: Maybe<LinkDepartmentAdministratorsPayload>;
  manuallySyncCasefile?: Maybe<Scalars['Boolean']>;
  markMessageThreadAsRead?: Maybe<MarkMessageThreadAsReadPayload>;
  notificationReadAll?: Maybe<NotificationReadAllPayload>;
  parseStringToDatetime?: Maybe<ParseStringToDatetimePayload>;
  processBulkUploadDocuments?: Maybe<Scalars['Boolean']>;
  removeCompanyRoleFromUser?: Maybe<RemoveCompanyRoleFromUserPayload>;
  removeDepartmentRoleFromUser?: Maybe<RemoveDepartmentRoleFromUserPayload>;
  removeRoleFromGroup?: Maybe<RemoveRoleFromGroupPayload>;
  removeRoleFromUser?: Maybe<RemoveRoleFromUserPayload>;
  renewClientSecretMutation?: Maybe<RenewClientSecretPayload>;
  requestPinCode?: Maybe<RequestPinCodePayload>;
  revokeRefreshTokensMutation?: Maybe<RevokeRefreshTokensPayload>;
  safeCastDate?: Maybe<SafeCastDatePayload>;
  sendContractLink?: Maybe<Scalars['Boolean']>;
  sendEmail?: Maybe<SendEmailPayload>;
  sendErrorReport?: Maybe<ErrorReportResponse>;
  sendSigningRequest?: Maybe<Scalars['Boolean']>;
  setFolderLastEdited?: Maybe<SetFolderLastEditedPayload>;
  setFormFieldEntryValue?: Maybe<SetFormFieldEntryValuePayload>;
  setMissingEmployeeNumber?: Maybe<SetMissingEmployeeNumberPayload>;
  setSystemFieldValue?: Maybe<SetSystemFieldValuePayload>;
  setUserSetting?: Maybe<SetUserSettingPayload>;
  signupToEvent?: Maybe<SignupToEventPayload>;
  sortEquipmentCustomFields: Scalars['Boolean'];
  startBreak?: Maybe<TimeRegistrationPresence>;
  submitPulseSurveyAnswer?: Maybe<PulseSurveyAnswer>;
  submitTimeRegistrationTemplate?: Maybe<TimeRegistrationPresenceTemplate>;
  triggerWebhookEvent?: Maybe<TriggerWebhookEventPayload>;
  /** Updates a single `Announcement` using a unique key and a patch. */
  updateAnnouncementById?: Maybe<UpdateAnnouncementPayload>;
  /** Updates a single `Approval` using a unique key and a patch. */
  updateApprovalById?: Maybe<UpdateApprovalPayload>;
  /** Updates a single `AsyncJob` using a unique key and a patch. */
  updateAsyncJobById?: Maybe<UpdateAsyncJobPayload>;
  updateAuthAppMutation?: Maybe<AuthAppPayload>;
  /** Updates a single `AuthAppType` using a unique key and a patch. */
  updateAuthAppTypeById?: Maybe<UpdateAuthAppTypePayload>;
  /** Updates a single `AuthCode` using a unique key and a patch. */
  updateAuthCodeById?: Maybe<UpdateAuthCodePayload>;
  /** Updates a single `Changelog` using a unique key and a patch. */
  updateChangelogById?: Maybe<UpdateChangelogPayload>;
  /** Updates a single `ChangelogUser` using a unique key and a patch. */
  updateChangelogUserByChangelogIdAndUserId?: Maybe<UpdateChangelogUserPayload>;
  /** Updates a single `ChosenColumn` using a unique key and a patch. */
  updateChosenColumnByUserIdAndTableName?: Maybe<UpdateChosenColumnPayload>;
  /** Updates a single `Company` using a unique key and a patch. */
  updateCompanyById?: Maybe<UpdateCompanyPayload>;
  /** Updates a single `CompanyCompanyType` using a unique key and a patch. */
  updateCompanyCompanyTypeByCompanyId?: Maybe<UpdateCompanyCompanyTypePayload>;
  /** Updates a single `CompanySystemField` using a unique key and a patch. */
  updateCompanySystemFieldById?: Maybe<UpdateCompanySystemFieldPayload>;
  /** Updates a single `CompanySystemField` using a unique key and a patch. */
  updateCompanySystemFieldBySystemFieldIdAndCompanyId?: Maybe<UpdateCompanySystemFieldPayload>;
  /** Updates a single `CompanySystemFieldOption` using a unique key and a patch. */
  updateCompanySystemFieldOptionById?: Maybe<UpdateCompanySystemFieldOptionPayload>;
  /** Updates a single `CompanyType` using a unique key and a patch. */
  updateCompanyTypeById?: Maybe<UpdateCompanyTypePayload>;
  /** Updates a single `Competence` using a unique key and a patch. */
  updateCompetenceById?: Maybe<UpdateCompetencePayload>;
  /** Updates a single `CompetenceFormField` using a unique key and a patch. */
  updateCompetenceFormFieldById?: Maybe<UpdateCompetenceFormFieldPayload>;
  /** Updates a single `CompetenceGroup` using a unique key and a patch. */
  updateCompetenceGroupById?: Maybe<UpdateCompetenceGroupPayload>;
  /** Updates a single `CompetenceRequest` using a unique key and a patch. */
  updateCompetenceRequestById?: Maybe<UpdateCompetenceRequestPayload>;
  /** Updates a single `ContractPredefinedPlaceholder` using a unique key and a patch. */
  updateContractPredefinedPlaceholderById?: Maybe<UpdateContractPredefinedPlaceholderPayload>;
  /** Updates a single `ContractSignPending` using a unique key and a patch. */
  updateContractSignPendingById?: Maybe<UpdateContractSignPendingPayload>;
  /** Updates a single `ContractSignPendingDocument` using a unique key and a patch. */
  updateContractSignPendingDocumentById?: Maybe<UpdateContractSignPendingDocumentPayload>;
  /** Updates a single `ContractSignPendingSigner` using a unique key and a patch. */
  updateContractSignPendingSignerByContractSignPendingIdAndUserId?: Maybe<UpdateContractSignPendingSignerPayload>;
  /** Updates a single `ContractSignPendingSigner` using a unique key and a patch. */
  updateContractSignPendingSignerById?: Maybe<UpdateContractSignPendingSignerPayload>;
  /** Updates a single `ContractTemplate` using a unique key and a patch. */
  updateContractTemplateById?: Maybe<UpdateContractTemplatePayload>;
  /** Updates a single `ContractTemplateDepartment` using a unique key and a patch. */
  updateContractTemplateDepartmentByContractTemplateIdAndDepartmentId?: Maybe<UpdateContractTemplateDepartmentPayload>;
  /** Updates a single `ContractTemplateUser` using a unique key and a patch. */
  updateContractTemplateUserByUserIdAndContractTemplateId?: Maybe<UpdateContractTemplateUserPayload>;
  updateCredential?: Maybe<UpdateCredentialPayload>;
  /** Updates a single `CustomWidget` using a unique key and a patch. */
  updateCustomWidgetById?: Maybe<UpdateCustomWidgetPayload>;
  /** Updates a single `CustomWidgetContent` using a unique key and a patch. */
  updateCustomWidgetContentById?: Maybe<UpdateCustomWidgetContentPayload>;
  /** Updates a single `CvTemplateFieldMapping` using a unique key and a patch. */
  updateCvTemplateFieldMappingById?: Maybe<UpdateCvTemplateFieldMappingPayload>;
  /** Updates a single `DashboardCard` using a unique key and a patch. */
  updateDashboardCardById?: Maybe<UpdateDashboardCardPayload>;
  /** Updates a single `DashboardCardStatistic` using a unique key and a patch. */
  updateDashboardCardStatisticById?: Maybe<UpdateDashboardCardStatisticPayload>;
  /** Updates a single `DashboardConfig` using a unique key and a patch. */
  updateDashboardConfigByCompanyId?: Maybe<UpdateDashboardConfigPayload>;
  /** Updates a single `DashboardView` using a unique key and a patch. */
  updateDashboardViewById?: Maybe<UpdateDashboardViewPayload>;
  /** Updates a single `Department` using a unique key and a patch. */
  updateDepartmentById?: Maybe<UpdateDepartmentPayload>;
  updateDepartmentColumns?: Maybe<UpdateDepartmentColumnsPayload>;
  /** Updates a single `DepartmentType` using a unique key and a patch. */
  updateDepartmentTypeById?: Maybe<UpdateDepartmentTypePayload>;
  /** Updates a single `DocumentDepartmentPermission` using a unique key and a patch. */
  updateDocumentDepartmentPermissionByFileIdAndDepartmentId?: Maybe<UpdateDocumentDepartmentPermissionPayload>;
  /** Updates a single `DocumentFolderBlueprint` using a unique key and a patch. */
  updateDocumentFolderBlueprintById?: Maybe<UpdateDocumentFolderBlueprintPayload>;
  /** Updates a single `DocumentFolder` using a unique key and a patch. */
  updateDocumentFolderById?: Maybe<UpdateDocumentFolderPayload>;
  /** Updates a single `DocumentFolderDepartment` using a unique key and a patch. */
  updateDocumentFolderDepartmentByDocumentFolderIdAndDepartmentId?: Maybe<UpdateDocumentFolderDepartmentPayload>;
  /** Updates a single `DocumentFolderUser` using a unique key and a patch. */
  updateDocumentFolderUserByDocumentFolderIdAndUserId?: Maybe<UpdateDocumentFolderUserPayload>;
  /** Updates a single `DocumentType` using a unique key and a patch. */
  updateDocumentTypeByCompanyIdAndDepartmentIdAndName?: Maybe<UpdateDocumentTypePayload>;
  /** Updates a single `DocumentType` using a unique key and a patch. */
  updateDocumentTypeById?: Maybe<UpdateDocumentTypePayload>;
  /** Updates a single `DocumentUserPermission` using a unique key and a patch. */
  updateDocumentUserPermissionByFileIdAndUserId?: Maybe<UpdateDocumentUserPermissionPayload>;
  /** Updates a single `DocumentUserResponsible` using a unique key and a patch. */
  updateDocumentUserResponsibleByFileIdAndUserId?: Maybe<UpdateDocumentUserResponsiblePayload>;
  /** Updates a single `Employee` using a unique key and a patch. */
  updateEmployeeById?: Maybe<UpdateEmployeePayload>;
  /** Updates a single `Employee` using a unique key and a patch. */
  updateEmployeeByUserId?: Maybe<UpdateEmployeePayload>;
  /** Updates a single `EmployeeCasefile` using a unique key and a patch. */
  updateEmployeeCasefileByEmployeeIdAndCasefileId?: Maybe<UpdateEmployeeCasefilePayload>;
  /** Updates a single `EmployeeCasefile` using a unique key and a patch. */
  updateEmployeeCasefileById?: Maybe<UpdateEmployeeCasefilePayload>;
  updateEmployeeCustomMutation?: Maybe<Employee>;
  updateEmployeeDataBasedOnSignedContract?: Maybe<UpdateEmployeeDataBasedOnSignedContractPayload>;
  /** Updates a single `EmployeeExternalIntegration` using a unique key and a patch. */
  updateEmployeeExternalIntegrationByEmployeeIdAndExternalIntegrationId?: Maybe<UpdateEmployeeExternalIntegrationPayload>;
  /** Updates a single `EmployeeExternalIntegration` using a unique key and a patch. */
  updateEmployeeExternalIntegrationBySameSystem?: Maybe<UpdateEmployeeExternalIntegrationPayload>;
  updateEmployeeGroupIds?: Maybe<UpdateEmployeeGroupIdsPayload>;
  updateEmployeeRecordsFromCsv: Scalars['Boolean'];
  updateEmployeesFromCsv: Scalars['Boolean'];
  /** Updates a single `EngagementType` using a unique key and a patch. */
  updateEngagementTypeById?: Maybe<UpdateEngagementTypePayload>;
  /** Updates a single `Equipment` using a unique key and a patch. */
  updateEquipmentById?: Maybe<UpdateEquipmentPayload>;
  /** Updates a single `Event` using a unique key and a patch. */
  updateEventById?: Maybe<UpdateEventPayload>;
  /** Updates a single `EventUser` using a unique key and a patch. */
  updateEventUserByEventIdAndUserId?: Maybe<UpdateEventUserPayload>;
  /** Updates a single `EventUser` using a unique key and a patch. */
  updateEventUserById?: Maybe<UpdateEventUserPayload>;
  /** Updates a single `ExternalIntegration` using a unique key and a patch. */
  updateExternalIntegrationById?: Maybe<UpdateExternalIntegrationPayload>;
  /** Updates a single `FieldGroup` using a unique key and a patch. */
  updateFieldGroupById?: Maybe<UpdateFieldGroupPayload>;
  /** Updates a single `FieldGroupCard` using a unique key and a patch. */
  updateFieldGroupCardById?: Maybe<UpdateFieldGroupCardPayload>;
  /** Updates a single `FieldGroupCardColumn` using a unique key and a patch. */
  updateFieldGroupCardColumnById?: Maybe<UpdateFieldGroupCardColumnPayload>;
  /** Updates a single `FilterPreset` using a unique key and a patch. */
  updateFilterPresetById?: Maybe<UpdateFilterPresetPayload>;
  /** Updates a single `FilterView` using a unique key and a patch. */
  updateFilterViewById?: Maybe<UpdateFilterViewPayload>;
  /** Updates a single `FormFieldAgreement` using a unique key and a patch. */
  updateFormFieldAgreementByFormFieldId?: Maybe<UpdateFormFieldAgreementPayload>;
  /** Updates a single `FormFieldAgreement` using a unique key and a patch. */
  updateFormFieldAgreementById?: Maybe<UpdateFormFieldAgreementPayload>;
  /** Updates a single `FormField` using a unique key and a patch. */
  updateFormFieldById?: Maybe<UpdateFormFieldPayload>;
  /** Updates a single `FormFieldEntry` using a unique key and a patch. */
  updateFormFieldEntryById?: Maybe<UpdateFormFieldEntryPayload>;
  /** Updates a single `FormFieldOption` using a unique key and a patch. */
  updateFormFieldOptionById?: Maybe<UpdateFormFieldOptionPayload>;
  /** Updates a single `FroalaStyle` using a unique key and a patch. */
  updateFroalaStyleById?: Maybe<UpdateFroalaStylePayload>;
  /** Updates a single `FutureDatum` using a unique key and a patch. */
  updateFutureDatumByApprovalId?: Maybe<UpdateFutureDatumPayload>;
  /** Updates a single `FutureDatum` using a unique key and a patch. */
  updateFutureDatumById?: Maybe<UpdateFutureDatumPayload>;
  /** Updates a single `Group` using a unique key and a patch. */
  updateGroupById?: Maybe<UpdateGroupPayload>;
  /** Updates a single `GroupRole` using a unique key and a patch. */
  updateGroupRoleByGroupIdAndRoleId?: Maybe<UpdateGroupRolePayload>;
  /** Updates a single `IntegrableSystem` using a unique key and a patch. */
  updateIntegrableSystemById?: Maybe<UpdateIntegrableSystemPayload>;
  /** Updates a single `IntegrationFieldMarking` using a unique key and a patch. */
  updateIntegrationFieldMarkingByCompanyIdAndExternalIntegrationIdAndFormFieldId?: Maybe<UpdateIntegrationFieldMarkingPayload>;
  /** Updates a single `IntegrationFieldMarking` using a unique key and a patch. */
  updateIntegrationFieldMarkingByCompanyIdAndExternalIntegrationIdAndSystemFieldId?: Maybe<UpdateIntegrationFieldMarkingPayload>;
  /** Updates a single `IntegrationFieldMarking` using a unique key and a patch. */
  updateIntegrationFieldMarkingById?: Maybe<UpdateIntegrationFieldMarkingPayload>;
  /** Updates a single `LoggedActionNote` using a unique key and a patch. */
  updateLoggedActionNoteById?: Maybe<UpdateLoggedActionNotePayload>;
  /** Updates a single `Notification` using a unique key and a patch. */
  updateNotificationById?: Maybe<UpdateNotificationPayload>;
  /** Updates a single `NotificationCustomEmployeeFieldRecipient` using a unique key and a patch. */
  updateNotificationCustomEmployeeFieldRecipientById?: Maybe<UpdateNotificationCustomEmployeeFieldRecipientPayload>;
  /** Updates a single `NotificationCustomRecipient` using a unique key and a patch. */
  updateNotificationCustomRecipientByNotificationIdAndEmployeeId?: Maybe<UpdateNotificationCustomRecipientPayload>;
  /** Updates a single `NotificationEmployee` using a unique key and a patch. */
  updateNotificationEmployeeById?: Maybe<UpdateNotificationEmployeePayload>;
  /** Updates a single `NotificationEmployeeReference` using a unique key and a patch. */
  updateNotificationEmployeeReferenceById?: Maybe<UpdateNotificationEmployeeReferencePayload>;
  /** Updates a single `NotificationGroupRecipient` using a unique key and a patch. */
  updateNotificationGroupRecipientByNotificationIdAndGroupId?: Maybe<UpdateNotificationGroupRecipientPayload>;
  /** Updates a single `NotificationType` using a unique key and a patch. */
  updateNotificationTypeById?: Maybe<UpdateNotificationTypePayload>;
  /** Updates a single `NotificationTypeChannelType` using a unique key and a patch. */
  updateNotificationTypeChannelTypeByNotificationTypeIdAndChannelTypeId?: Maybe<UpdateNotificationTypeChannelTypePayload>;
  updatePersonalDataCard?: Maybe<Scalars['Boolean']>;
  /** Updates a single `Post` using a unique key and a patch. */
  updatePostById?: Maybe<UpdatePostPayload>;
  /** Updates a single `PostType` using a unique key and a patch. */
  updatePostTypeById?: Maybe<UpdatePostTypePayload>;
  /** Updates a single `Preboarding` using a unique key and a patch. */
  updatePreboardingById?: Maybe<UpdatePreboardingPayload>;
  /** Updates a single `PreboardingComment` using a unique key and a patch. */
  updatePreboardingCommentById?: Maybe<UpdatePreboardingCommentPayload>;
  /** Updates a single `PreboardingEmployee` using a unique key and a patch. */
  updatePreboardingEmployeeById?: Maybe<UpdatePreboardingEmployeePayload>;
  /** Updates a single `PreboardingFormCache` using a unique key and a patch. */
  updatePreboardingFormCacheByPreboardingIdAndUserId?: Maybe<UpdatePreboardingFormCachePayload>;
  /** Updates a single `PreboardingProcess` using a unique key and a patch. */
  updatePreboardingProcessByPreboardingIdAndProcessId?: Maybe<UpdatePreboardingProcessPayload>;
  /** Updates a single `PreboardingResult` using a unique key and a patch. */
  updatePreboardingResultById?: Maybe<UpdatePreboardingResultPayload>;
  /** Updates a single `PreboardingResultSlideComment` using a unique key and a patch. */
  updatePreboardingResultSlideCommentById?: Maybe<UpdatePreboardingResultSlideCommentPayload>;
  /** Updates a single `PreboardingSlide` using a unique key and a patch. */
  updatePreboardingSlideById?: Maybe<UpdatePreboardingSlidePayload>;
  /** Updates a single `PreboardingSlideFormField` using a unique key and a patch. */
  updatePreboardingSlideFormFieldById?: Maybe<UpdatePreboardingSlideFormFieldPayload>;
  /** Updates a single `Process` using a unique key and a patch. */
  updateProcessById?: Maybe<UpdateProcessPayload>;
  /** Updates a single `ProcessResponsible` using a unique key and a patch. */
  updateProcessResponsibleByProcessIdAndResponsibleId?: Maybe<UpdateProcessResponsiblePayload>;
  /** Updates a single `ProcessType` using a unique key and a patch. */
  updateProcessTypeById?: Maybe<UpdateProcessTypePayload>;
  /** Updates a single `Product` using a unique key and a patch. */
  updateProductById?: Maybe<UpdateProductPayload>;
  /** Updates a single `ProductType` using a unique key and a patch. */
  updateProductTypeByCompanyIdAndDepartmentIdAndName?: Maybe<UpdateProductTypePayload>;
  /** Updates a single `ProductType` using a unique key and a patch. */
  updateProductTypeById?: Maybe<UpdateProductTypePayload>;
  /** Updates a single `Project` using a unique key and a patch. */
  updateProjectById?: Maybe<UpdateProjectPayload>;
  /** Updates a single `ProjectTemplate` using a unique key and a patch. */
  updateProjectTemplateById?: Maybe<UpdateProjectTemplatePayload>;
  /** Updates a single `PulseSurvey` using a unique key and a patch. */
  updatePulseSurveyById?: Maybe<UpdatePulseSurveyPayload>;
  /** Updates a single `PulseSurveyChoice` using a unique key and a patch. */
  updatePulseSurveyChoiceById?: Maybe<UpdatePulseSurveyChoicePayload>;
  /** Updates a single `PulseType` using a unique key and a patch. */
  updatePulseTypeById?: Maybe<UpdatePulseTypePayload>;
  /** Updates a single `RecurrenceRule` using a unique key and a patch. */
  updateRecurrenceRuleById?: Maybe<UpdateRecurrenceRulePayload>;
  /** Updates a single `RecurrenceRule` using a unique key and a patch. */
  updateRecurrenceRuleByPulseSurveyId?: Maybe<UpdateRecurrenceRulePayload>;
  /** Updates a single `RoadmapItem` using a unique key and a patch. */
  updateRoadmapItemById?: Maybe<UpdateRoadmapItemPayload>;
  /** Updates a single `RoadmapItemComment` using a unique key and a patch. */
  updateRoadmapItemCommentById?: Maybe<UpdateRoadmapItemCommentPayload>;
  /** Updates a single `RoadmapItemLocalization` using a unique key and a patch. */
  updateRoadmapItemLocalizationById?: Maybe<UpdateRoadmapItemLocalizationPayload>;
  /** Updates a single `RoadmapItemLocalization` using a unique key and a patch. */
  updateRoadmapItemLocalizationByRoadmapItemIdAndLocale?: Maybe<UpdateRoadmapItemLocalizationPayload>;
  /** Updates a single `RoadmapItemVote` using a unique key and a patch. */
  updateRoadmapItemVoteById?: Maybe<UpdateRoadmapItemVotePayload>;
  /** Updates a single `RoadmapItemVote` using a unique key and a patch. */
  updateRoadmapItemVoteByUserIdAndRoadmapItemId?: Maybe<UpdateRoadmapItemVotePayload>;
  /** Updates a single `Role` using a unique key and a patch. */
  updateRoleById?: Maybe<UpdateRolePayload>;
  /** Updates a single `SavedSignature` using a unique key and a patch. */
  updateSavedSignatureById?: Maybe<UpdateSavedSignaturePayload>;
  /** Updates a single `ScheduledMessage` using a unique key and a patch. */
  updateScheduledMessageById?: Maybe<UpdateScheduledMessagePayload>;
  /** Updates a single `ScheduledMessageExternalRecipient` using a unique key and a patch. */
  updateScheduledMessageExternalRecipientByScheduledMessageIdAndEmail?: Maybe<UpdateScheduledMessageExternalRecipientPayload>;
  /** Updates a single `ScheduledMessageRecipient` using a unique key and a patch. */
  updateScheduledMessageRecipientByScheduledMessageIdAndEmployeeId?: Maybe<UpdateScheduledMessageRecipientPayload>;
  /** Updates a single `ScheduledMessageTemplate` using a unique key and a patch. */
  updateScheduledMessageTemplateById?: Maybe<UpdateScheduledMessageTemplatePayload>;
  /** Updates a single `ScheduledMessageTemplateExternalRecipient` using a unique key and a patch. */
  updateScheduledMessageTemplateExternalRecipientByScheduledMessageTemplateIdAndEmail?: Maybe<UpdateScheduledMessageTemplateExternalRecipientPayload>;
  /** Updates a single `ScheduledMessageTemplateRecipient` using a unique key and a patch. */
  updateScheduledMessageTemplateRecipientByScheduledMessageTemplateIdAndEmployeeId?: Maybe<UpdateScheduledMessageTemplateRecipientPayload>;
  /** Updates a single `Storage` using a unique key and a patch. */
  updateStorageById?: Maybe<UpdateStoragePayload>;
  /** Updates a single `SuperUserAllowedUser` using a unique key and a patch. */
  updateSuperUserAllowedUserById?: Maybe<UpdateSuperUserAllowedUserPayload>;
  /** Updates a single `SuperUserAllowedUser` using a unique key and a patch. */
  updateSuperUserAllowedUserBySuperUserIdAndCompanyId?: Maybe<UpdateSuperUserAllowedUserPayload>;
  /** Updates a single `SuperUser` using a unique key and a patch. */
  updateSuperUserById?: Maybe<UpdateSuperUserPayload>;
  /** Updates a single `SuperUser` using a unique key and a patch. */
  updateSuperUserByUserId?: Maybe<UpdateSuperUserPayload>;
  /** Updates a single `SystemFieldType` using a unique key and a patch. */
  updateSystemFieldTypeByType?: Maybe<UpdateSystemFieldTypePayload>;
  /** Updates a single `Task` using a unique key and a patch. */
  updateTaskById?: Maybe<UpdateTaskPayload>;
  /** Updates a single `TaskEmployee` using a unique key and a patch. */
  updateTaskEmployeeByTaskIdAndEmployeeId?: Maybe<UpdateTaskEmployeePayload>;
  /** Updates a single `TaskResponsible` using a unique key and a patch. */
  updateTaskResponsibleByTaskIdAndResponsibleId?: Maybe<UpdateTaskResponsiblePayload>;
  /** Updates a single `TaskTemplate` using a unique key and a patch. */
  updateTaskTemplateById?: Maybe<UpdateTaskTemplatePayload>;
  /** Updates a single `TaskTemplateEmployee` using a unique key and a patch. */
  updateTaskTemplateEmployeeByTaskTemplateIdAndEmployeeId?: Maybe<UpdateTaskTemplateEmployeePayload>;
  /** Updates a single `TaskTemplateResponsible` using a unique key and a patch. */
  updateTaskTemplateResponsibleByTaskTemplateIdAndResponsibleId?: Maybe<UpdateTaskTemplateResponsiblePayload>;
  /** Updates a single `TimeRegistrationBreakType` using a unique key and a patch. */
  updateTimeRegistrationBreakTypeById?: Maybe<UpdateTimeRegistrationBreakTypePayload>;
  /** Updates a single `TimeRegistrationEntry` using a unique key and a patch. */
  updateTimeRegistrationEntryById?: Maybe<UpdateTimeRegistrationEntryPayload>;
  /** Updates a single `TimeRegistrationEntryTemplate` using a unique key and a patch. */
  updateTimeRegistrationEntryTemplateById?: Maybe<UpdateTimeRegistrationEntryTemplatePayload>;
  /** Updates a single `TimeRegistrationPresence` using a unique key and a patch. */
  updateTimeRegistrationPresenceById?: Maybe<UpdateTimeRegistrationPresencePayload>;
  /** Updates a single `TimeRegistrationPresenceTemplate` using a unique key and a patch. */
  updateTimeRegistrationPresenceTemplateById?: Maybe<UpdateTimeRegistrationPresenceTemplatePayload>;
  /** Updates a single `TimeRegistrationPresenceType` using a unique key and a patch. */
  updateTimeRegistrationPresenceTypeById?: Maybe<UpdateTimeRegistrationPresenceTypePayload>;
  /** Updates a single `TimeRegistrationProject` using a unique key and a patch. */
  updateTimeRegistrationProjectById?: Maybe<UpdateTimeRegistrationProjectPayload>;
  /** Updates a single `TimeRegistrationTemplate` using a unique key and a patch. */
  updateTimeRegistrationTemplateById?: Maybe<UpdateTimeRegistrationTemplatePayload>;
  /** Updates a single `TimeRegistrationTemplateWeek` using a unique key and a patch. */
  updateTimeRegistrationTemplateWeekById?: Maybe<UpdateTimeRegistrationTemplateWeekPayload>;
  /** Updates a single `TranslatedEntity` using a unique key and a patch. */
  updateTranslatedEntityById?: Maybe<UpdateTranslatedEntityPayload>;
  /** Updates a single `TranslatedEntityLocalization` using a unique key and a patch. */
  updateTranslatedEntityLocalizationById?: Maybe<UpdateTranslatedEntityLocalizationPayload>;
  /** Updates a single `TranslatedEntityLocalization` using a unique key and a patch. */
  updateTranslatedEntityLocalizationByTranslatedEntityIdAndLocale?: Maybe<UpdateTranslatedEntityLocalizationPayload>;
  /** Updates a single `Translation` using a unique key and a patch. */
  updateTranslationById?: Maybe<UpdateTranslationPayload>;
  /** Updates a single `UserAnnouncement` using a unique key and a patch. */
  updateUserAnnouncementByUserIdAndAnnouncementId?: Maybe<UpdateUserAnnouncementPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUserById?: Maybe<UpdateUserPayload>;
  /** Updates a single `UserCompanyGroup` using a unique key and a patch. */
  updateUserCompanyGroupByUserIdAndGroupIdAndCompanyId?: Maybe<UpdateUserCompanyGroupPayload>;
  /** Updates a single `UserCompanyRole` using a unique key and a patch. */
  updateUserCompanyRoleByUserIdAndRoleIdAndCompanyId?: Maybe<UpdateUserCompanyRolePayload>;
  /** Updates a single `UserCompetence` using a unique key and a patch. */
  updateUserCompetenceById?: Maybe<UpdateUserCompetencePayload>;
  /** Updates a single `UserCompetenceEvaluation` using a unique key and a patch. */
  updateUserCompetenceEvaluationById?: Maybe<UpdateUserCompetenceEvaluationPayload>;
  /** Updates a single `UserCompetenceEvaluationComment` using a unique key and a patch. */
  updateUserCompetenceEvaluationCommentById?: Maybe<UpdateUserCompetenceEvaluationCommentPayload>;
  /** Updates a single `UserDepartment` using a unique key and a patch. */
  updateUserDepartmentByDepartmentIdAndUserId?: Maybe<UpdateUserDepartmentPayload>;
  /** Updates a single `UserDepartment` using a unique key and a patch. */
  updateUserDepartmentById?: Maybe<UpdateUserDepartmentPayload>;
  /** Updates a single `UserDepartmentGroup` using a unique key and a patch. */
  updateUserDepartmentGroupByUserIdAndDepartmentIdAndGroupId?: Maybe<UpdateUserDepartmentGroupPayload>;
  /** Updates a single `UserDepartmentRole` using a unique key and a patch. */
  updateUserDepartmentRoleByUserIdAndDepartmentIdAndRoleId?: Maybe<UpdateUserDepartmentRolePayload>;
  /** Updates a single `UserGroup` using a unique key and a patch. */
  updateUserGroupByUserIdAndGroupId?: Maybe<UpdateUserGroupPayload>;
  updateUserLocale?: Maybe<UpdateUserLocalePayload>;
  /** Updates a single `UserOnBehalfPermission` using a unique key and a patch. */
  updateUserOnBehalfPermissionById?: Maybe<UpdateUserOnBehalfPermissionPayload>;
  /** Updates a single `UserRole` using a unique key and a patch. */
  updateUserRoleByUserIdAndRoleId?: Maybe<UpdateUserRolePayload>;
  /** Updates a single `UserSetting` using a unique key and a patch. */
  updateUserSettingByUserIdAndKey?: Maybe<UpdateUserSettingPayload>;
  /** Updates a single `VacationType` using a unique key and a patch. */
  updateVacationTypeById?: Maybe<UpdateVacationTypePayload>;
  /** Updates a single `VacationUser` using a unique key and a patch. */
  updateVacationUserByApprovalId?: Maybe<UpdateVacationUserPayload>;
  /** Updates a single `VacationUser` using a unique key and a patch. */
  updateVacationUserByDeletionApprovalId?: Maybe<UpdateVacationUserPayload>;
  /** Updates a single `VacationUser` using a unique key and a patch. */
  updateVacationUserById?: Maybe<UpdateVacationUserPayload>;
  upsertCompanySetting?: Maybe<CompanySetting>;
  upsertPushToken?: Maybe<UpsertPushTokenPayload>;
  uriToPdf?: Maybe<HtmlToPdfPayload>;
  zenegyInsertCustomFieldMarkings?: Maybe<ZenegyInsertCustomFieldMarkingsPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIntegrationArgs = {
  input?: InputMaybe<CreateIntegrationInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIntegrationArgs = {
  input?: InputMaybe<DeleteIntegrationInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationFileDeleteArgs = {
  input: FileDeleteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationFileDownloadArgs = {
  input: FileDownloadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationFileUpdateArgs = {
  input: FileUpdateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationFileUploadArgs = {
  input: FileUploadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationFileUploadLogoArgs = {
  input?: InputMaybe<FileUploadLogoInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationFileUploadPublicArgs = {
  input: FileUploadPublicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGeneratePdfArgs = {
  input: GeneratePdfInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationImportEmployeesFromFileArgs = {
  input: ImportEmployeesFromFileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationImportEquipmentFromFileArgs = {
  input: ImportEquipmentFromFileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendMessageArgs = {
  input: MessageGraphileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendPreboardingLinksArgs = {
  input: SendPreboardingLinksInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIntegrationCredentialsArgs = {
  input?: InputMaybe<UpdateIntegrationCredentialsInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationActivateIntegrableSystemIntegrationArgs = {
  input?: InputMaybe<ActivateIntegrableSystemIntegrationInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddCompanyRoleToUserArgs = {
  input: AddCompanyRoleToUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddDepartmentRoleToUserArgs = {
  input: AddDepartmentRoleToUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddRoleToGroupArgs = {
  input: AddRoleToGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddRoleToUserArgs = {
  input: AddRoleToUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAdminCreateCompanyWithRelationsArgs = {
  input: AdminCreateCompanyWithRelationsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAnnouncementReadAllArgs = {
  input: AnnouncementReadAllInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationApplyTimeRegistrationTemplateArgs = {
  input: ApplyTimeRegistrationTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationApproveTimeRegistrationsByDeadlineArgs = {
  input: ApproveTimeRegistrationsByDeadlineInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationArrayIntersectArgs = {
  input: ArrayIntersectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAutoAddPermissionGroupsArgs = {
  input: AutoAddPermissionGroupsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBulkApplyTimeRegistrationTemplateArgs = {
  input: BulkApplyTimeRegistrationTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBulkUpdateEmployeeCustomMutationArgs = {
  input: BulkUpdateEmployeeCustomMutationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationChangeGodModeStatusArgs = {
  input: ChangeGodModeStatusInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationChangeTimeRegistrationBreakTypeArgs = {
  input: ChangeTimeRegistrationBreakTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationChangeTimeRegistrationPresenceArgs = {
  input: ChangeTimeRegistrationPresenceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationChangeTimeRegistrationProjectArgs = {
  input?: InputMaybe<ChangeTimeRegistrationProjectInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCheckCompanyGrowthPermissionsArgs = {
  input: CheckCompanyGrowthPermissionsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCheckLogPermissionArgs = {
  input: CheckLogPermissionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCheckPinCodeArgs = {
  input: PinInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCheckPublishedAnnouncementsArgs = {
  input: CheckPublishedAnnouncementsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCleanupEmptyGroupsArgs = {
  input: CleanupEmptyGroupsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationClearTimeRegistrationPresenceTemplateDayArgs = {
  input: ClearTimeRegistrationPresenceTemplateDayInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationClockInArgs = {
  input: ClockInInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCloneContractTemplateArgs = {
  input: CloneContractTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCloneProcessArgs = {
  input: CloneProcessInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCompleteTaskArgs = {
  input: CompleteTaskInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationConvertformfieldentrytoemailArgs = {
  input: ConvertformfieldentrytoemailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCopyCompanyArgs = {
  input: CopyCompanyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCopyUserGroupToUserCompanyGroupArgs = {
  input: CopyUserGroupToUserCompanyGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCopyUserGroupToUserDepartmentGroupArgs = {
  input: CopyUserGroupToUserDepartmentGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAnnouncementArgs = {
  input: CreateAnnouncementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateApprovalArgs = {
  input: CreateApprovalInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAuthAppMutationArgs = {
  input?: InputMaybe<CreateAuthAppInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAuthAppTypeArgs = {
  input: CreateAuthAppTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAuthCodeArgs = {
  input: CreateAuthCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateChangelogArgs = {
  input: CreateChangelogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateChangelogUserArgs = {
  input: CreateChangelogUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateChosenColumnArgs = {
  input: CreateChosenColumnInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCompanyCompanyTypeArgs = {
  input: CreateCompanyCompanyTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCompanySystemFieldArgs = {
  input: CreateCompanySystemFieldInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCompanySystemFieldOptionArgs = {
  input: CreateCompanySystemFieldOptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCompanyTypeArgs = {
  input: CreateCompanyTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCompetenceArgs = {
  input: CreateCompetenceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCompetenceFormFieldArgs = {
  input: CreateCompetenceFormFieldInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCompetenceGroupArgs = {
  input: CreateCompetenceGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCompetenceRequestArgs = {
  input: CreateCompetenceRequestInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContractPredefinedPlaceholderArgs = {
  input: CreateContractPredefinedPlaceholderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContractSignPendingArgs = {
  input: CreateContractSignPendingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContractSignPendingDocumentArgs = {
  input: CreateContractSignPendingDocumentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContractSignPendingSignerArgs = {
  input: CreateContractSignPendingSignerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContractTemplateArgs = {
  input: CreateContractTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContractTemplateDepartmentArgs = {
  input: CreateContractTemplateDepartmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContractTemplateFormFieldArgs = {
  input: CreateContractTemplateFormFieldInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContractTemplateUserArgs = {
  input: CreateContractTemplateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCustomWidgetArgs = {
  input: CreateCustomWidgetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCustomWidgetContentArgs = {
  input: CreateCustomWidgetContentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCvTemplateFieldMappingArgs = {
  input: CreateCvTemplateFieldMappingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDashboardCardArgs = {
  input: CreateDashboardCardInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDashboardCardStatisticArgs = {
  input: CreateDashboardCardStatisticInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDashboardConfigArgs = {
  input: CreateDashboardConfigInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDashboardViewArgs = {
  input: CreateDashboardViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDepartmentArgs = {
  input: CreateDepartmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDepartmentTypeArgs = {
  input: CreateDepartmentTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentDepartmentPermissionArgs = {
  input: CreateDocumentDepartmentPermissionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentFolderArgs = {
  input: CreateDocumentFolderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentFolderBlueprintArgs = {
  input: CreateDocumentFolderBlueprintInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentFolderDepartmentArgs = {
  input: CreateDocumentFolderDepartmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentFolderUserArgs = {
  input: CreateDocumentFolderUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentTypeArgs = {
  input: CreateDocumentTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentUserPermissionArgs = {
  input: CreateDocumentUserPermissionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDocumentUserResponsibleArgs = {
  input: CreateDocumentUserResponsibleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEmployeeCasefileArgs = {
  input: CustomEmployeeCasefileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEmployeeCustomMutationArgs = {
  input: EmployeeCustomMutationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEmployeeExternalIntegrationArgs = {
  input: CreateEmployeeExternalIntegrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEngagementTypeArgs = {
  input: CreateEngagementTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEquipmentArgs = {
  input: CreateEquipmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateErrorReportArgs = {
  input: ErrorReportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEventUserArgs = {
  input: CreateEventUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateExternalIntegrationArgs = {
  input: CreateExternalIntegrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFieldGroupArgs = {
  input: CreateFieldGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFieldGroupCardArgs = {
  input: CreateFieldGroupCardInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFieldGroupCardColumnArgs = {
  input: CreateFieldGroupCardColumnInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFilterPresetArgs = {
  input: CreateFilterPresetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFilterViewArgs = {
  input: CreateFilterViewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFormFieldArgs = {
  input: CreateFormFieldInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFormFieldAgreementArgs = {
  input: CreateFormFieldAgreementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFormFieldEntryArgs = {
  input: CreateFormFieldEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFormFieldOptionArgs = {
  input: CreateFormFieldOptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFroalaStyleArgs = {
  input: CreateFroalaStyleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFutureDatumArgs = {
  input: CreateFutureDatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGroupRoleArgs = {
  input: CreateGroupRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIntegrableSystemArgs = {
  input: CreateIntegrableSystemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIntegrableSystemIntegrationArgs = {
  input?: InputMaybe<CreateIntegrableSystemIntegrationInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIntegrationFieldMarkingArgs = {
  input: CreateIntegrationFieldMarkingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLoggedActionArgs = {
  input: CreateLoggedActionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLoggedActionNoteArgs = {
  input: CreateLoggedActionNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMessageArgs = {
  input: CreateMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMessageRecipientArgs = {
  input: CreateMessageRecipientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNotificationArgs = {
  input: CreateNotificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNotificationCustomEmployeeFieldRecipientArgs = {
  input: CreateNotificationCustomEmployeeFieldRecipientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNotificationCustomRecipientArgs = {
  input: CreateNotificationCustomRecipientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNotificationEmployeeArgs = {
  input: CreateNotificationEmployeeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNotificationEmployeeReferenceArgs = {
  input: CreateNotificationEmployeeReferenceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNotificationGroupRecipientArgs = {
  input: CreateNotificationGroupRecipientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNotificationTypeArgs = {
  input: CreateNotificationTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNotificationTypeChannelTypeArgs = {
  input: CreateNotificationTypeChannelTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePostArgs = {
  input: CreatePostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePostCommentArgs = {
  input?: InputMaybe<CreatePostCommentInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePostTypeArgs = {
  input: CreatePostTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePreboardingArgs = {
  input: CreatePreboardingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePreboardingCommentArgs = {
  input: CreatePreboardingCommentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePreboardingEmployeeArgs = {
  input: CreatePreboardingEmployeeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePreboardingFormCacheArgs = {
  input: CreatePreboardingFormCacheInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePreboardingProcessArgs = {
  input: CreatePreboardingProcessInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePreboardingResultArgs = {
  input: CreatePreboardingResultInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePreboardingResultSlideCommentArgs = {
  input: CreatePreboardingResultSlideCommentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePreboardingSlideArgs = {
  input: CreatePreboardingSlideInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePreboardingSlideFormFieldArgs = {
  input: CreatePreboardingSlideFormFieldInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProcessArgs = {
  input: CreateProcessInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProcessDepartmentArgs = {
  input: CreateProcessDepartmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProcessEmployeeArgs = {
  input: CreateProcessEmployeeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProcessResponsibleArgs = {
  input: CreateProcessResponsibleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProcessTypeArgs = {
  input: CreateProcessTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProductTypeArgs = {
  input: CreateProductTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectTemplateArgs = {
  input: CreateProjectTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePulseSurveyArgs = {
  input: CreatePulseSurveyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePulseTypeArgs = {
  input: CreatePulseTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRecurrenceRuleArgs = {
  input: CreateRecurrenceRuleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoadmapItemArgs = {
  input: CreateRoadmapItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoadmapItemCommentArgs = {
  input: CreateRoadmapItemCommentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoadmapItemLocalizationArgs = {
  input: CreateRoadmapItemLocalizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoadmapItemVoteArgs = {
  input: CreateRoadmapItemVoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSavedSignatureArgs = {
  input: CreateSavedSignatureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateScheduledMessageArgs = {
  input: CreateScheduledMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateScheduledMessageExternalRecipientArgs = {
  input: CreateScheduledMessageExternalRecipientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateScheduledMessageRecipientArgs = {
  input: CreateScheduledMessageRecipientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateScheduledMessageTemplateArgs = {
  input: CreateScheduledMessageTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateScheduledMessageTemplateExternalRecipientArgs = {
  input: CreateScheduledMessageTemplateExternalRecipientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateScheduledMessageTemplateRecipientArgs = {
  input: CreateScheduledMessageTemplateRecipientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateStorageArgs = {
  input: CreateStorageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSuperUserArgs = {
  input: CreateSuperUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSuperUserAllowedUserArgs = {
  input: CreateSuperUserAllowedUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSystemFieldTypeArgs = {
  input: CreateSystemFieldTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTaskEmployeeArgs = {
  input: CreateTaskEmployeeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTaskResponsibleArgs = {
  input: CreateTaskResponsibleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTaskTemplateArgs = {
  input: CreateTaskTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTaskTemplateEmployeeArgs = {
  input: CreateTaskTemplateEmployeeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTaskTemplateResponsibleArgs = {
  input: CreateTaskTemplateResponsibleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTimeRegistrationBreakTypeArgs = {
  input: CreateTimeRegistrationBreakTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTimeRegistrationEntryArgs = {
  input: CreateTimeRegistrationEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTimeRegistrationEntryTemplateArgs = {
  input: CreateTimeRegistrationEntryTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTimeRegistrationPresenceArgs = {
  input: CreateTimeRegistrationPresenceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTimeRegistrationPresenceTemplateArgs = {
  input: CreateTimeRegistrationPresenceTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTimeRegistrationPresenceTypeArgs = {
  input: CreateTimeRegistrationPresenceTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTimeRegistrationProjectArgs = {
  input: CreateTimeRegistrationProjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTimeRegistrationTemplateArgs = {
  input: CreateTimeRegistrationTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTimeRegistrationTemplateWeekArgs = {
  input: CreateTimeRegistrationTemplateWeekInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTranslatedEntityArgs = {
  input: CreateTranslatedEntityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTranslatedEntityLocalizationArgs = {
  input: CreateTranslatedEntityLocalizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTranslationArgs = {
  input: CreateTranslationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserAnnouncementArgs = {
  input: CreateUserAnnouncementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserCompanyGroupArgs = {
  input: CreateUserCompanyGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserCompanyRoleArgs = {
  input: CreateUserCompanyRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserCompetenceArgs = {
  input: CreateUserCompetenceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserCompetenceEvaluationArgs = {
  input: CreateUserCompetenceEvaluationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserCompetenceEvaluationCommentArgs = {
  input: CreateUserCompetenceEvaluationCommentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserDepartmentArgs = {
  input: CreateUserDepartmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserDepartmentGroupArgs = {
  input: CreateUserDepartmentGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserDepartmentRoleArgs = {
  input: CreateUserDepartmentRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserGroupArgs = {
  input: CreateUserGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserOnBehalfPermissionArgs = {
  input: CreateUserOnBehalfPermissionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserRoleArgs = {
  input: CreateUserRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserSettingArgs = {
  input: CreateUserSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVacationTypeArgs = {
  input: CreateVacationTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVacationUserArgs = {
  input: CreateVacationUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeactivateOldCompanyLogoArgs = {
  input: DeactivateOldCompanyLogoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeactivateOldContractsOnSignArgs = {
  input: DeactivateOldContractsOnSignInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAllCompanyEmployeeNotificationsArgs = {
  input: DeleteAllCompanyEmployeeNotificationsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAuthAppMutationArgs = {
  input?: InputMaybe<AuthAppInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAuthAppTypeByIdArgs = {
  input: DeleteAuthAppTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAuthCodeByIdArgs = {
  input: DeleteAuthCodeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteChangelogByIdArgs = {
  input: DeleteChangelogByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteChangelogUserByChangelogIdAndUserIdArgs = {
  input: DeleteChangelogUserByChangelogIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteChosenColumnByUserIdAndTableNameArgs = {
  input: DeleteChosenColumnByUserIdAndTableNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyCompanyTypeByCompanyIdArgs = {
  input: DeleteCompanyCompanyTypeByCompanyIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanySystemFieldByIdArgs = {
  input: DeleteCompanySystemFieldByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanySystemFieldBySystemFieldIdAndCompanyIdArgs = {
  input: DeleteCompanySystemFieldBySystemFieldIdAndCompanyIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompanyTypeByIdArgs = {
  input: DeleteCompanyTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCompetenceFormFieldByIdArgs = {
  input: DeleteCompetenceFormFieldByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContractSignPendingByContractTemplateIdsArgs = {
  input: DeleteContractSignPendingByContractTemplateIdsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContractSignPendingDocumentByIdArgs = {
  input: DeleteContractSignPendingDocumentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContractSignPendingSignerByContractSignPendingIdAndUserIdArgs = {
  input: DeleteContractSignPendingSignerByContractSignPendingIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContractSignPendingSignerByIdArgs = {
  input: DeleteContractSignPendingSignerByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContractTemplateDepartmentByContractTemplateIdAndDepartmentIdArgs = {
  input: DeleteContractTemplateDepartmentByContractTemplateIdAndDepartmentIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContractTemplateUserByUserIdAndContractTemplateIdArgs = {
  input: DeleteContractTemplateUserByUserIdAndContractTemplateIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCvTemplateFieldMappingByIdArgs = {
  input: DeleteCvTemplateFieldMappingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDashboardConfigByCompanyIdArgs = {
  input: DeleteDashboardConfigByCompanyIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentDepartmentPermissionByFileIdAndDepartmentIdArgs = {
  input: DeleteDocumentDepartmentPermissionByFileIdAndDepartmentIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentFolderDepartmentByDocumentFolderIdAndDepartmentIdArgs = {
  input: DeleteDocumentFolderDepartmentByDocumentFolderIdAndDepartmentIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentFolderUserByDocumentFolderIdAndUserIdArgs = {
  input: DeleteDocumentFolderUserByDocumentFolderIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentUserPermissionByFileIdAndUserIdArgs = {
  input: DeleteDocumentUserPermissionByFileIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDocumentUserResponsibleByFileIdAndUserIdArgs = {
  input: DeleteDocumentUserResponsibleByFileIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmployeeExternalIntegrationByEmployeeIdAndExternalIntegrationIdArgs = {
  input: DeleteEmployeeExternalIntegrationByEmployeeIdAndExternalIntegrationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmployeeExternalIntegrationBySameSystemArgs = {
  input: DeleteEmployeeExternalIntegrationBySameSystemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEquipmentByIdArgs = {
  input: DeleteEquipmentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEventUserByEventIdAndUserIdArgs = {
  input: DeleteEventUserByEventIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEventUserByIdArgs = {
  input: DeleteEventUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteExternalIntegrationByIdArgs = {
  input: DeleteExternalIntegrationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFilterViewByIdArgs = {
  input: DeleteFilterViewByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFormFieldAgreementByFormFieldIdArgs = {
  input: DeleteFormFieldAgreementByFormFieldIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFormFieldAgreementByIdArgs = {
  input: DeleteFormFieldAgreementByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGroupRoleByGroupIdAndRoleIdArgs = {
  input: DeleteGroupRoleByGroupIdAndRoleIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIntegrableSystemByIdArgs = {
  input: DeleteIntegrableSystemByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIntegrableSystemIntegrationArgs = {
  input?: InputMaybe<DeleteIntegrableSystemIntegrationInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNotificationCustomEmployeeFieldRecipientByIdArgs = {
  input: DeleteNotificationCustomEmployeeFieldRecipientByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNotificationCustomRecipientByNotificationIdAndEmployeeIdArgs = {
  input: DeleteNotificationCustomRecipientByNotificationIdAndEmployeeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNotificationEmployeeByIdArgs = {
  input: DeleteNotificationEmployeeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNotificationEmployeeReferenceByIdArgs = {
  input: DeleteNotificationEmployeeReferenceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNotificationGroupRecipientByNotificationIdAndGroupIdArgs = {
  input: DeleteNotificationGroupRecipientByNotificationIdAndGroupIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNotificationTypeChannelTypeByNotificationTypeIdArgs = {
  input: DeleteNotificationTypeChannelTypeByNotificationTypeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNotificationTypeChannelTypeByNotificationTypeIdAndChannelTypeIdArgs = {
  input: DeleteNotificationTypeChannelTypeByNotificationTypeIdAndChannelTypeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOldRoleArgs = {
  input: DeleteOldRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOldRolesArgs = {
  input: DeleteOldRolesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostCommentArgs = {
  input?: InputMaybe<DeletePostCommentInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostTypeByIdArgs = {
  input: DeletePostTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePreboardingCommentByIdArgs = {
  input: DeletePreboardingCommentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePreboardingProcessByPreboardingIdAndProcessIdArgs = {
  input: DeletePreboardingProcessByPreboardingIdAndProcessIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePreboardingResultByIdArgs = {
  input: DeletePreboardingResultByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePreboardingResultSlideCommentByIdArgs = {
  input: DeletePreboardingResultSlideCommentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePreboardingSlideFormFieldByIdArgs = {
  input: DeletePreboardingSlideFormFieldByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProcessResponsibleByProcessIdAndResponsibleIdArgs = {
  input: DeleteProcessResponsibleByProcessIdAndResponsibleIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePulseSurveyAnswerByIdArgs = {
  input: DeletePulseSurveyAnswerByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePulseSurveyAnswerByUserIdAndPulseSurveyIdAndDateArgs = {
  input: DeletePulseSurveyAnswerByUserIdAndPulseSurveyIdAndDateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePulseSurveyByIdArgs = {
  input: DeletePulseSurveyByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePulseSurveyChoiceByIdArgs = {
  input: DeletePulseSurveyChoiceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePulseTypeByIdArgs = {
  input: DeletePulseTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePushTokenByUserIdArgs = {
  input: DeletePushTokenByUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRecurrenceRuleByIdArgs = {
  input: DeleteRecurrenceRuleByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRecurrenceRuleByPulseSurveyIdArgs = {
  input: DeleteRecurrenceRuleByPulseSurveyIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoadmapItemLocalizationByIdArgs = {
  input: DeleteRoadmapItemLocalizationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoadmapItemLocalizationByRoadmapItemIdAndLocaleArgs = {
  input: DeleteRoadmapItemLocalizationByRoadmapItemIdAndLocaleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoadmapItemVoteByIdArgs = {
  input: DeleteRoadmapItemVoteByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoadmapItemVoteByUserIdAndRoadmapItemIdArgs = {
  input: DeleteRoadmapItemVoteByUserIdAndRoadmapItemIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoleByIdArgs = {
  input: DeleteRoleByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSavedSignatureByIdArgs = {
  input: DeleteSavedSignatureByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteScheduledMessageExternalRecipientByScheduledMessageIdAndEmailArgs = {
  input: DeleteScheduledMessageExternalRecipientByScheduledMessageIdAndEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteScheduledMessageRecipientByScheduledMessageIdAndEmployeeIdArgs = {
  input: DeleteScheduledMessageRecipientByScheduledMessageIdAndEmployeeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteScheduledMessageTemplateExternalRecipientByScheduledMessageTemplateIdAndEmailArgs = {
  input: DeleteScheduledMessageTemplateExternalRecipientByScheduledMessageTemplateIdAndEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteScheduledMessageTemplateRecipientByScheduledMessageTemplateIdAndEmployeeIdArgs = {
  input: DeleteScheduledMessageTemplateRecipientByScheduledMessageTemplateIdAndEmployeeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuperUserAllowedUserByIdArgs = {
  input: DeleteSuperUserAllowedUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuperUserAllowedUserBySuperUserIdAndCompanyIdArgs = {
  input: DeleteSuperUserAllowedUserBySuperUserIdAndCompanyIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuperUserByIdArgs = {
  input: DeleteSuperUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSuperUserByUserIdArgs = {
  input: DeleteSuperUserByUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSystemFieldTypeByTypeArgs = {
  input: DeleteSystemFieldTypeByTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTaskEmployeeByTaskIdAndEmployeeIdArgs = {
  input: DeleteTaskEmployeeByTaskIdAndEmployeeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTaskResponsibleByTaskIdAndResponsibleIdArgs = {
  input: DeleteTaskResponsibleByTaskIdAndResponsibleIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTaskTemplateEmployeeByTaskTemplateIdAndEmployeeIdArgs = {
  input: DeleteTaskTemplateEmployeeByTaskTemplateIdAndEmployeeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTaskTemplateResponsibleByTaskTemplateIdAndResponsibleIdArgs = {
  input: DeleteTaskTemplateResponsibleByTaskTemplateIdAndResponsibleIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTemporaryCasefileArgs = {
  input: DeleteTemporaryCasefileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTimeRegistrationBreakTypeByIdArgs = {
  input: DeleteTimeRegistrationBreakTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTimeRegistrationEntryByIdArgs = {
  input: DeleteTimeRegistrationEntryByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTimeRegistrationEntryTemplateByIdArgs = {
  input: DeleteTimeRegistrationEntryTemplateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTimeRegistrationPresenceByIdArgs = {
  input: DeleteTimeRegistrationPresenceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTimeRegistrationPresenceTemplateByIdArgs = {
  input: DeleteTimeRegistrationPresenceTemplateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTimeRegistrationPresenceTypeByIdArgs = {
  input: DeleteTimeRegistrationPresenceTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTimeRegistrationProjectByIdArgs = {
  input: DeleteTimeRegistrationProjectByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTimeRegistrationTemplateByIdArgs = {
  input: DeleteTimeRegistrationTemplateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTimeRegistrationTemplateWeekByIdArgs = {
  input: DeleteTimeRegistrationTemplateWeekByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTranslatedEntityByIdArgs = {
  input: DeleteTranslatedEntityByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTranslatedEntityLocalizationByIdArgs = {
  input: DeleteTranslatedEntityLocalizationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTranslatedEntityLocalizationByTranslatedEntityIdAndLocaleArgs = {
  input: DeleteTranslatedEntityLocalizationByTranslatedEntityIdAndLocaleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTranslationByIdArgs = {
  input: DeleteTranslationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserAnnouncementByUserIdAndAnnouncementIdArgs = {
  input: DeleteUserAnnouncementByUserIdAndAnnouncementIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserCompanyGroupByUserIdAndGroupIdAndCompanyIdArgs = {
  input: DeleteUserCompanyGroupByUserIdAndGroupIdAndCompanyIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserCompanyRoleByUserIdAndRoleIdAndCompanyIdArgs = {
  input: DeleteUserCompanyRoleByUserIdAndRoleIdAndCompanyIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserDepartmentByDepartmentIdAndUserIdArgs = {
  input: DeleteUserDepartmentByDepartmentIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserDepartmentByIdArgs = {
  input: DeleteUserDepartmentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserDepartmentGroupByUserIdAndDepartmentIdAndGroupIdArgs = {
  input: DeleteUserDepartmentGroupByUserIdAndDepartmentIdAndGroupIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserDepartmentRoleByUserIdAndDepartmentIdAndRoleIdArgs = {
  input: DeleteUserDepartmentRoleByUserIdAndDepartmentIdAndRoleIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserGroupByUserIdAndGroupIdArgs = {
  input: DeleteUserGroupByUserIdAndGroupIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserOnBehalfPermissionByIdArgs = {
  input: DeleteUserOnBehalfPermissionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserRoleByUserIdAndRoleIdArgs = {
  input: DeleteUserRoleByUserIdAndRoleIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserSettingByUserIdAndKeyArgs = {
  input: DeleteUserSettingByUserIdAndKeyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDepartmentDescendantsArgs = {
  input: DepartmentDescendantsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDocxToHtmlArgs = {
  input: DocxToHtmlInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDownloadCasefileDocumentArgs = {
  input: DownloadCasefileDocumentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationEmployeeLatestMessageTimestampArgs = {
  input: EmployeeLatestMessageTimestampInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationEndBreakArgs = {
  input?: InputMaybe<EndBreakInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationFixBrokenContractArgs = {
  input: FixBrokenContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationFormEntryTxtToTsvectorArgs = {
  input: FormEntryTxtToTsvectorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGetAnnouncementRecipientsArgs = {
  input: GetAnnouncementRecipientsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGetContractSignPendingSignaturesArgs = {
  input: GetContractSignPendingSignaturesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGetExternalEmployeeIdArgs = {
  input: GetExternalEmployeeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGetExternalIntegrationsArgs = {
  input: GetExternalIntegrationsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGetPreboardingEmployeeProcessesArgs = {
  input: GetPreboardingEmployeeProcessesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGetPresignedUploadLinkArgs = {
  input: PresignedLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGiveDepartmentAdministratorsRankArgs = {
  input: GiveDepartmentAdministratorsRankInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGrantAdditionalRoleArgs = {
  input: GrantAdditionalRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGrantAdditionalRolesArgs = {
  input: GrantAdditionalRolesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationHasSuperUserAccessArgs = {
  input: HasSuperUserAccessInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationHtmlToPdfArgs = {
  input: HtmlToPdfInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationIntersectionArgs = {
  input: IntersectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLikePostArgs = {
  input?: InputMaybe<LikePostInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLinkDepartmentAdministratorsArgs = {
  input: LinkDepartmentAdministratorsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationManuallySyncCasefileArgs = {
  input: ManuallySyncCasefileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMarkMessageThreadAsReadArgs = {
  input: MarkMessageThreadAsReadInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationNotificationReadAllArgs = {
  input: NotificationReadAllInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationParseStringToDatetimeArgs = {
  input: ParseStringToDatetimeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationProcessBulkUploadDocumentsArgs = {
  input: ProcessBulkUploadDocumentsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveCompanyRoleFromUserArgs = {
  input: RemoveCompanyRoleFromUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveDepartmentRoleFromUserArgs = {
  input: RemoveDepartmentRoleFromUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveRoleFromGroupArgs = {
  input: RemoveRoleFromGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveRoleFromUserArgs = {
  input: RemoveRoleFromUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRenewClientSecretMutationArgs = {
  input?: InputMaybe<RenewClientSecretInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRequestPinCodeArgs = {
  input: RequestPinCodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRevokeRefreshTokensMutationArgs = {
  input?: InputMaybe<RevokeRefreshTokensInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSafeCastDateArgs = {
  input: SafeCastDateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendContractLinkArgs = {
  input?: InputMaybe<SendContractLinkInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendEmailArgs = {
  input: SendEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendErrorReportArgs = {
  input: ErrorReportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendSigningRequestArgs = {
  input: SendSigningRequestInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetFolderLastEditedArgs = {
  input: SetFolderLastEditedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetFormFieldEntryValueArgs = {
  input: SetFormFieldEntryValueInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetMissingEmployeeNumberArgs = {
  input: SetMissingEmployeeNumberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetSystemFieldValueArgs = {
  input: SetSystemFieldValueInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetUserSettingArgs = {
  input: SetUserSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSignupToEventArgs = {
  input: SignupToEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSortEquipmentCustomFieldsArgs = {
  input: SortEquipmentCustomFieldsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationStartBreakArgs = {
  input: StartBreakInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSubmitPulseSurveyAnswerArgs = {
  input: PulseSurveyAnswerCustomInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSubmitTimeRegistrationTemplateArgs = {
  input: SubmitTimeRegistrationTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationTriggerWebhookEventArgs = {
  input: TriggerWebhookEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAnnouncementByIdArgs = {
  input: UpdateAnnouncementByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApprovalByIdArgs = {
  input: UpdateApprovalByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAsyncJobByIdArgs = {
  input: UpdateAsyncJobByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuthAppMutationArgs = {
  input?: InputMaybe<UpdateAuthAppInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuthAppTypeByIdArgs = {
  input: UpdateAuthAppTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuthCodeByIdArgs = {
  input: UpdateAuthCodeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateChangelogByIdArgs = {
  input: UpdateChangelogByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateChangelogUserByChangelogIdAndUserIdArgs = {
  input: UpdateChangelogUserByChangelogIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateChosenColumnByUserIdAndTableNameArgs = {
  input: UpdateChosenColumnByUserIdAndTableNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyByIdArgs = {
  input: UpdateCompanyByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyCompanyTypeByCompanyIdArgs = {
  input: UpdateCompanyCompanyTypeByCompanyIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanySystemFieldByIdArgs = {
  input: UpdateCompanySystemFieldByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanySystemFieldBySystemFieldIdAndCompanyIdArgs = {
  input: UpdateCompanySystemFieldBySystemFieldIdAndCompanyIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanySystemFieldOptionByIdArgs = {
  input: UpdateCompanySystemFieldOptionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompanyTypeByIdArgs = {
  input: UpdateCompanyTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompetenceByIdArgs = {
  input: UpdateCompetenceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompetenceFormFieldByIdArgs = {
  input: UpdateCompetenceFormFieldByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompetenceGroupByIdArgs = {
  input: UpdateCompetenceGroupByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCompetenceRequestByIdArgs = {
  input: UpdateCompetenceRequestByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContractPredefinedPlaceholderByIdArgs = {
  input: UpdateContractPredefinedPlaceholderByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContractSignPendingByIdArgs = {
  input: UpdateContractSignPendingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContractSignPendingDocumentByIdArgs = {
  input: UpdateContractSignPendingDocumentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContractSignPendingSignerByContractSignPendingIdAndUserIdArgs = {
  input: UpdateContractSignPendingSignerByContractSignPendingIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContractSignPendingSignerByIdArgs = {
  input: UpdateContractSignPendingSignerByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContractTemplateByIdArgs = {
  input: UpdateContractTemplateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContractTemplateDepartmentByContractTemplateIdAndDepartmentIdArgs = {
  input: UpdateContractTemplateDepartmentByContractTemplateIdAndDepartmentIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContractTemplateUserByUserIdAndContractTemplateIdArgs = {
  input: UpdateContractTemplateUserByUserIdAndContractTemplateIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCredentialArgs = {
  input: UpdateCredentialInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomWidgetByIdArgs = {
  input: UpdateCustomWidgetByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomWidgetContentByIdArgs = {
  input: UpdateCustomWidgetContentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCvTemplateFieldMappingByIdArgs = {
  input: UpdateCvTemplateFieldMappingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDashboardCardByIdArgs = {
  input: UpdateDashboardCardByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDashboardCardStatisticByIdArgs = {
  input: UpdateDashboardCardStatisticByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDashboardConfigByCompanyIdArgs = {
  input: UpdateDashboardConfigByCompanyIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDashboardViewByIdArgs = {
  input: UpdateDashboardViewByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDepartmentByIdArgs = {
  input: UpdateDepartmentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDepartmentColumnsArgs = {
  input: UpdateDepartmentColumnsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDepartmentTypeByIdArgs = {
  input: UpdateDepartmentTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentDepartmentPermissionByFileIdAndDepartmentIdArgs = {
  input: UpdateDocumentDepartmentPermissionByFileIdAndDepartmentIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentFolderBlueprintByIdArgs = {
  input: UpdateDocumentFolderBlueprintByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentFolderByIdArgs = {
  input: UpdateDocumentFolderByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentFolderDepartmentByDocumentFolderIdAndDepartmentIdArgs = {
  input: UpdateDocumentFolderDepartmentByDocumentFolderIdAndDepartmentIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentFolderUserByDocumentFolderIdAndUserIdArgs = {
  input: UpdateDocumentFolderUserByDocumentFolderIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentTypeByCompanyIdAndDepartmentIdAndNameArgs = {
  input: UpdateDocumentTypeByCompanyIdAndDepartmentIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentTypeByIdArgs = {
  input: UpdateDocumentTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentUserPermissionByFileIdAndUserIdArgs = {
  input: UpdateDocumentUserPermissionByFileIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDocumentUserResponsibleByFileIdAndUserIdArgs = {
  input: UpdateDocumentUserResponsibleByFileIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmployeeByIdArgs = {
  input: UpdateEmployeeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmployeeByUserIdArgs = {
  input: UpdateEmployeeByUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmployeeCasefileByEmployeeIdAndCasefileIdArgs = {
  input: UpdateEmployeeCasefileByEmployeeIdAndCasefileIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmployeeCasefileByIdArgs = {
  input: UpdateEmployeeCasefileByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmployeeCustomMutationArgs = {
  input: EmployeeCustomMutationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmployeeDataBasedOnSignedContractArgs = {
  input: UpdateEmployeeDataBasedOnSignedContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmployeeExternalIntegrationByEmployeeIdAndExternalIntegrationIdArgs = {
  input: UpdateEmployeeExternalIntegrationByEmployeeIdAndExternalIntegrationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmployeeExternalIntegrationBySameSystemArgs = {
  input: UpdateEmployeeExternalIntegrationBySameSystemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmployeeGroupIdsArgs = {
  input: UpdateEmployeeGroupIdsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmployeeRecordsFromCsvArgs = {
  input: UpdateEmployeeRecordsFromCsvInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmployeesFromCsvArgs = {
  input: UpdateEmployeesFromCsvInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEngagementTypeByIdArgs = {
  input: UpdateEngagementTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEquipmentByIdArgs = {
  input: UpdateEquipmentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEventByIdArgs = {
  input: UpdateEventByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEventUserByEventIdAndUserIdArgs = {
  input: UpdateEventUserByEventIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEventUserByIdArgs = {
  input: UpdateEventUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateExternalIntegrationByIdArgs = {
  input: UpdateExternalIntegrationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFieldGroupByIdArgs = {
  input: UpdateFieldGroupByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFieldGroupCardByIdArgs = {
  input: UpdateFieldGroupCardByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFieldGroupCardColumnByIdArgs = {
  input: UpdateFieldGroupCardColumnByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFilterPresetByIdArgs = {
  input: UpdateFilterPresetByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFilterViewByIdArgs = {
  input: UpdateFilterViewByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFormFieldAgreementByFormFieldIdArgs = {
  input: UpdateFormFieldAgreementByFormFieldIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFormFieldAgreementByIdArgs = {
  input: UpdateFormFieldAgreementByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFormFieldByIdArgs = {
  input: UpdateFormFieldByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFormFieldEntryByIdArgs = {
  input: UpdateFormFieldEntryByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFormFieldOptionByIdArgs = {
  input: UpdateFormFieldOptionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFroalaStyleByIdArgs = {
  input: UpdateFroalaStyleByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFutureDatumByApprovalIdArgs = {
  input: UpdateFutureDatumByApprovalIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFutureDatumByIdArgs = {
  input: UpdateFutureDatumByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupByIdArgs = {
  input: UpdateGroupByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupRoleByGroupIdAndRoleIdArgs = {
  input: UpdateGroupRoleByGroupIdAndRoleIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIntegrableSystemByIdArgs = {
  input: UpdateIntegrableSystemByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIntegrationFieldMarkingByCompanyIdAndExternalIntegrationIdAndFormFieldIdArgs = {
  input: UpdateIntegrationFieldMarkingByCompanyIdAndExternalIntegrationIdAndFormFieldIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIntegrationFieldMarkingByCompanyIdAndExternalIntegrationIdAndSystemFieldIdArgs = {
  input: UpdateIntegrationFieldMarkingByCompanyIdAndExternalIntegrationIdAndSystemFieldIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIntegrationFieldMarkingByIdArgs = {
  input: UpdateIntegrationFieldMarkingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLoggedActionNoteByIdArgs = {
  input: UpdateLoggedActionNoteByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNotificationByIdArgs = {
  input: UpdateNotificationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNotificationCustomEmployeeFieldRecipientByIdArgs = {
  input: UpdateNotificationCustomEmployeeFieldRecipientByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNotificationCustomRecipientByNotificationIdAndEmployeeIdArgs = {
  input: UpdateNotificationCustomRecipientByNotificationIdAndEmployeeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNotificationEmployeeByIdArgs = {
  input: UpdateNotificationEmployeeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNotificationEmployeeReferenceByIdArgs = {
  input: UpdateNotificationEmployeeReferenceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNotificationGroupRecipientByNotificationIdAndGroupIdArgs = {
  input: UpdateNotificationGroupRecipientByNotificationIdAndGroupIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNotificationTypeByIdArgs = {
  input: UpdateNotificationTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNotificationTypeChannelTypeByNotificationTypeIdAndChannelTypeIdArgs = {
  input: UpdateNotificationTypeChannelTypeByNotificationTypeIdAndChannelTypeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePersonalDataCardArgs = {
  input: UpdatePersonalDataCardInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostByIdArgs = {
  input: UpdatePostByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostTypeByIdArgs = {
  input: UpdatePostTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePreboardingByIdArgs = {
  input: UpdatePreboardingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePreboardingCommentByIdArgs = {
  input: UpdatePreboardingCommentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePreboardingEmployeeByIdArgs = {
  input: UpdatePreboardingEmployeeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePreboardingFormCacheByPreboardingIdAndUserIdArgs = {
  input: UpdatePreboardingFormCacheByPreboardingIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePreboardingProcessByPreboardingIdAndProcessIdArgs = {
  input: UpdatePreboardingProcessByPreboardingIdAndProcessIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePreboardingResultByIdArgs = {
  input: UpdatePreboardingResultByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePreboardingResultSlideCommentByIdArgs = {
  input: UpdatePreboardingResultSlideCommentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePreboardingSlideByIdArgs = {
  input: UpdatePreboardingSlideByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePreboardingSlideFormFieldByIdArgs = {
  input: UpdatePreboardingSlideFormFieldByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProcessByIdArgs = {
  input: UpdateProcessByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProcessResponsibleByProcessIdAndResponsibleIdArgs = {
  input: UpdateProcessResponsibleByProcessIdAndResponsibleIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProcessTypeByIdArgs = {
  input: UpdateProcessTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProductByIdArgs = {
  input: UpdateProductByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProductTypeByCompanyIdAndDepartmentIdAndNameArgs = {
  input: UpdateProductTypeByCompanyIdAndDepartmentIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProductTypeByIdArgs = {
  input: UpdateProductTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectByIdArgs = {
  input: UpdateProjectByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectTemplateByIdArgs = {
  input: UpdateProjectTemplateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePulseSurveyByIdArgs = {
  input: UpdatePulseSurveyByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePulseSurveyChoiceByIdArgs = {
  input: UpdatePulseSurveyChoiceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePulseTypeByIdArgs = {
  input: UpdatePulseTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRecurrenceRuleByIdArgs = {
  input: UpdateRecurrenceRuleByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRecurrenceRuleByPulseSurveyIdArgs = {
  input: UpdateRecurrenceRuleByPulseSurveyIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoadmapItemByIdArgs = {
  input: UpdateRoadmapItemByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoadmapItemCommentByIdArgs = {
  input: UpdateRoadmapItemCommentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoadmapItemLocalizationByIdArgs = {
  input: UpdateRoadmapItemLocalizationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoadmapItemLocalizationByRoadmapItemIdAndLocaleArgs = {
  input: UpdateRoadmapItemLocalizationByRoadmapItemIdAndLocaleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoadmapItemVoteByIdArgs = {
  input: UpdateRoadmapItemVoteByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoadmapItemVoteByUserIdAndRoadmapItemIdArgs = {
  input: UpdateRoadmapItemVoteByUserIdAndRoadmapItemIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoleByIdArgs = {
  input: UpdateRoleByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSavedSignatureByIdArgs = {
  input: UpdateSavedSignatureByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScheduledMessageByIdArgs = {
  input: UpdateScheduledMessageByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScheduledMessageExternalRecipientByScheduledMessageIdAndEmailArgs = {
  input: UpdateScheduledMessageExternalRecipientByScheduledMessageIdAndEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScheduledMessageRecipientByScheduledMessageIdAndEmployeeIdArgs = {
  input: UpdateScheduledMessageRecipientByScheduledMessageIdAndEmployeeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScheduledMessageTemplateByIdArgs = {
  input: UpdateScheduledMessageTemplateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScheduledMessageTemplateExternalRecipientByScheduledMessageTemplateIdAndEmailArgs = {
  input: UpdateScheduledMessageTemplateExternalRecipientByScheduledMessageTemplateIdAndEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScheduledMessageTemplateRecipientByScheduledMessageTemplateIdAndEmployeeIdArgs = {
  input: UpdateScheduledMessageTemplateRecipientByScheduledMessageTemplateIdAndEmployeeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateStorageByIdArgs = {
  input: UpdateStorageByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuperUserAllowedUserByIdArgs = {
  input: UpdateSuperUserAllowedUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuperUserAllowedUserBySuperUserIdAndCompanyIdArgs = {
  input: UpdateSuperUserAllowedUserBySuperUserIdAndCompanyIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuperUserByIdArgs = {
  input: UpdateSuperUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSuperUserByUserIdArgs = {
  input: UpdateSuperUserByUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSystemFieldTypeByTypeArgs = {
  input: UpdateSystemFieldTypeByTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTaskByIdArgs = {
  input: UpdateTaskByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTaskEmployeeByTaskIdAndEmployeeIdArgs = {
  input: UpdateTaskEmployeeByTaskIdAndEmployeeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTaskResponsibleByTaskIdAndResponsibleIdArgs = {
  input: UpdateTaskResponsibleByTaskIdAndResponsibleIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTaskTemplateByIdArgs = {
  input: UpdateTaskTemplateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTaskTemplateEmployeeByTaskTemplateIdAndEmployeeIdArgs = {
  input: UpdateTaskTemplateEmployeeByTaskTemplateIdAndEmployeeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTaskTemplateResponsibleByTaskTemplateIdAndResponsibleIdArgs = {
  input: UpdateTaskTemplateResponsibleByTaskTemplateIdAndResponsibleIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTimeRegistrationBreakTypeByIdArgs = {
  input: UpdateTimeRegistrationBreakTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTimeRegistrationEntryByIdArgs = {
  input: UpdateTimeRegistrationEntryByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTimeRegistrationEntryTemplateByIdArgs = {
  input: UpdateTimeRegistrationEntryTemplateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTimeRegistrationPresenceByIdArgs = {
  input: UpdateTimeRegistrationPresenceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTimeRegistrationPresenceTemplateByIdArgs = {
  input: UpdateTimeRegistrationPresenceTemplateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTimeRegistrationPresenceTypeByIdArgs = {
  input: UpdateTimeRegistrationPresenceTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTimeRegistrationProjectByIdArgs = {
  input: UpdateTimeRegistrationProjectByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTimeRegistrationTemplateByIdArgs = {
  input: UpdateTimeRegistrationTemplateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTimeRegistrationTemplateWeekByIdArgs = {
  input: UpdateTimeRegistrationTemplateWeekByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTranslatedEntityByIdArgs = {
  input: UpdateTranslatedEntityByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTranslatedEntityLocalizationByIdArgs = {
  input: UpdateTranslatedEntityLocalizationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTranslatedEntityLocalizationByTranslatedEntityIdAndLocaleArgs = {
  input: UpdateTranslatedEntityLocalizationByTranslatedEntityIdAndLocaleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTranslationByIdArgs = {
  input: UpdateTranslationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserAnnouncementByUserIdAndAnnouncementIdArgs = {
  input: UpdateUserAnnouncementByUserIdAndAnnouncementIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByIdArgs = {
  input: UpdateUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserCompanyGroupByUserIdAndGroupIdAndCompanyIdArgs = {
  input: UpdateUserCompanyGroupByUserIdAndGroupIdAndCompanyIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserCompanyRoleByUserIdAndRoleIdAndCompanyIdArgs = {
  input: UpdateUserCompanyRoleByUserIdAndRoleIdAndCompanyIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserCompetenceByIdArgs = {
  input: UpdateUserCompetenceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserCompetenceEvaluationByIdArgs = {
  input: UpdateUserCompetenceEvaluationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserCompetenceEvaluationCommentByIdArgs = {
  input: UpdateUserCompetenceEvaluationCommentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserDepartmentByDepartmentIdAndUserIdArgs = {
  input: UpdateUserDepartmentByDepartmentIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserDepartmentByIdArgs = {
  input: UpdateUserDepartmentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserDepartmentGroupByUserIdAndDepartmentIdAndGroupIdArgs = {
  input: UpdateUserDepartmentGroupByUserIdAndDepartmentIdAndGroupIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserDepartmentRoleByUserIdAndDepartmentIdAndRoleIdArgs = {
  input: UpdateUserDepartmentRoleByUserIdAndDepartmentIdAndRoleIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserGroupByUserIdAndGroupIdArgs = {
  input: UpdateUserGroupByUserIdAndGroupIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserLocaleArgs = {
  input: UpdateUserLocaleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserOnBehalfPermissionByIdArgs = {
  input: UpdateUserOnBehalfPermissionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserRoleByUserIdAndRoleIdArgs = {
  input: UpdateUserRoleByUserIdAndRoleIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserSettingByUserIdAndKeyArgs = {
  input: UpdateUserSettingByUserIdAndKeyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVacationTypeByIdArgs = {
  input: UpdateVacationTypeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVacationUserByApprovalIdArgs = {
  input: UpdateVacationUserByApprovalIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVacationUserByDeletionApprovalIdArgs = {
  input: UpdateVacationUserByDeletionApprovalIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVacationUserByIdArgs = {
  input: UpdateVacationUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertCompanySettingArgs = {
  input: UpsertCompanySettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertPushTokenArgs = {
  input: UpsertPushTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUriToPdfArgs = {
  input: UriToPdfInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationZenegyInsertCustomFieldMarkingsArgs = {
  input: ZenegyInsertCustomFieldMarkingsInput;
};

export type Notification = {
  __typename?: 'Notification';
  active: Scalars['Boolean'];
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  emailSubject?: Maybe<Scalars['String']>;
  /** Reads a single `Hook` that is related to this `Notification`. */
  hook?: Maybe<Hook>;
  hookId: Scalars['UUID'];
  hookName?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  localizedText?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `NotificationCustomEmployeeFieldRecipient`. */
  notificationCustomEmployeeFieldRecipients: NotificationCustomEmployeeFieldRecipientsConnection;
  /** Reads and enables pagination through a set of `NotificationCustomRecipient`. */
  notificationCustomRecipients: NotificationCustomRecipientsConnection;
  /** Reads and enables pagination through a set of `NotificationEmployee`. */
  notificationEmployees: NotificationEmployeesConnection;
  /** Reads and enables pagination through a set of `NotificationGroupRecipient`. */
  notificationGroupRecipients: NotificationGroupRecipientsConnection;
  /** Reads a single `NotificationType` that is related to this `Notification`. */
  notificationType?: Maybe<NotificationType>;
  notificationTypeId: Scalars['UUID'];
  /** Reads a single `Preboarding` that is related to this `Notification`. */
  preboarding?: Maybe<Preboarding>;
  preboardingId?: Maybe<Scalars['UUID']>;
  recipientType?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};


export type NotificationNotificationCustomEmployeeFieldRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationCustomEmployeeFieldRecipientCondition>;
  filter?: InputMaybe<NotificationCustomEmployeeFieldRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientsOrderBy>>;
};


export type NotificationNotificationCustomRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationCustomRecipientCondition>;
  filter?: InputMaybe<NotificationCustomRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationCustomRecipientsOrderBy>>;
};


export type NotificationNotificationEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeCondition>;
  filter?: InputMaybe<NotificationEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeesOrderBy>>;
};


export type NotificationNotificationGroupRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationGroupRecipientCondition>;
  filter?: InputMaybe<NotificationGroupRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationGroupRecipientsOrderBy>>;
};

/**
 * A condition to be used against `Notification` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type NotificationCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `emailSubject` field. */
  emailSubject?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `hookId` field. */
  hookId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `notificationTypeId` field. */
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `preboardingId` field. */
  preboardingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `recipientType` field. */
  recipientType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `text` field. */
  text?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type NotificationCustomEmployeeFieldRecipient = {
  __typename?: 'NotificationCustomEmployeeFieldRecipient';
  /** Reads a single `Company` that is related to this `NotificationCustomEmployeeFieldRecipient`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `FormField` that is related to this `NotificationCustomEmployeeFieldRecipient`. */
  formField?: Maybe<FormField>;
  formFieldId: Scalars['UUID'];
  id: Scalars['UUID'];
  /** Reads a single `Notification` that is related to this `NotificationCustomEmployeeFieldRecipient`. */
  notification?: Maybe<Notification>;
  notificationId: Scalars['UUID'];
};

/** The `notificationCustomEmployeeFieldRecipient` to be created by this mutation. */
export type NotificationCustomEmployeeFieldRecipientCompanyIdForeignConnectionNotificationCustomEmployeeFieldRecipientCreateInput = {
  company?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInput>;
  formField?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `NotificationCustomEmployeeFieldRecipientInput` mutation. */
export type NotificationCustomEmployeeFieldRecipientCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `notificationCustomEmployeeFieldRecipient` in the `CompanyInput` mutation. */
export type NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput = {
  /** The primary key(s) for `notificationCustomEmployeeFieldRecipient` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientNotificationCustomEmployeeFieldRecipientPkeyConnect>>;
  /** A `NotificationCustomEmployeeFieldRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientCompanyIdForeignConnectionNotificationCustomEmployeeFieldRecipientCreateInput>>;
  /** The primary key(s) for `notificationCustomEmployeeFieldRecipient` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientNotificationCustomEmployeeFieldRecipientPkeyDelete>>;
  /** Flag indicating whether all other `notificationCustomEmployeeFieldRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationCustomEmployeeFieldRecipient` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientCompanyIdForeignUsingNotificationCustomEmployeeFieldRecipientPkeyUpdate>>;
};

/**
 * A condition to be used against `NotificationCustomEmployeeFieldRecipient` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type NotificationCustomEmployeeFieldRecipientCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `notificationId` field. */
  notificationId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `NotificationCustomEmployeeFieldRecipient` object types. All fields are combined with a logical ‘and.’ */
export type NotificationCustomEmployeeFieldRecipientFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `formField` relation. */
  formField?: InputMaybe<FormFieldFilter>;
  /** Filter by the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NotificationCustomEmployeeFieldRecipientFilter>;
  /** Filter by the object’s `notification` relation. */
  notification?: InputMaybe<NotificationFilter>;
  /** Filter by the object’s `notificationId` field. */
  notificationId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientFilter>>;
};

/** The `formField` to be created by this mutation. */
export type NotificationCustomEmployeeFieldRecipientFormFieldIdForeConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `notificationCustomEmployeeFieldRecipient` to be created by this mutation. */
export type NotificationCustomEmployeeFieldRecipientFormFieldIdForeConnectionNotificationCustomEmployeeFieldRecipientCreateInput = {
  company?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInput>;
  id?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `formField` in the `NotificationCustomEmployeeFieldRecipientInput` mutation. */
export type NotificationCustomEmployeeFieldRecipientFormFieldIdForeInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<FormFieldFormFieldPkeyConnect>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeConnectionFormFieldCreateInput>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<FormFieldOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientFormFieldIdForeUsingFormFieldPkeyUpdate>;
};

/** Input for the nested mutation of `notificationCustomEmployeeFieldRecipient` in the `FormFieldInput` mutation. */
export type NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput = {
  /** The primary key(s) for `notificationCustomEmployeeFieldRecipient` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientNotificationCustomEmployeeFieldRecipientPkeyConnect>>;
  /** A `NotificationCustomEmployeeFieldRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientFormFieldIdForeConnectionNotificationCustomEmployeeFieldRecipientCreateInput>>;
  /** The primary key(s) for `notificationCustomEmployeeFieldRecipient` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientNotificationCustomEmployeeFieldRecipientPkeyDelete>>;
  /** Flag indicating whether all other `notificationCustomEmployeeFieldRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationCustomEmployeeFieldRecipient` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientFormFieldIdForeUsingNotificationCustomEmployeeFieldRecipientPkeyUpdate>>;
};

/** An input for mutations affecting `NotificationCustomEmployeeFieldRecipient` */
export type NotificationCustomEmployeeFieldRecipientInput = {
  company?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `notificationCustomEmployeeFieldRecipient` to look up the row to connect. */
export type NotificationCustomEmployeeFieldRecipientNotificationCustomEmployeeFieldRecipientPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `notificationCustomEmployeeFieldRecipient` to look up the row to delete. */
export type NotificationCustomEmployeeFieldRecipientNotificationCustomEmployeeFieldRecipientPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `notification` to be created by this mutation. */
export type NotificationCustomEmployeeFieldRecipientNotificationIdFoConnectionNotificationCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  customRecipientEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  emailSubject?: InputMaybe<Scalars['String']>;
  hook?: InputMaybe<NotificationHookIdForeignInput>;
  hookId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeNotificationIdForeignInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInverseInput>;
  notificationType?: InputMaybe<NotificationNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
  permissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<NotificationPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  recipientType?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `notificationCustomEmployeeFieldRecipient` to be created by this mutation. */
export type NotificationCustomEmployeeFieldRecipientNotificationIdFoConnectionNotificationCustomEmployeeFieldRecipientCreateInput = {
  company?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInput>;
};

/** Input for the nested mutation of `notification` in the `NotificationCustomEmployeeFieldRecipientInput` mutation. */
export type NotificationCustomEmployeeFieldRecipientNotificationIdFoInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<NotificationNotificationPkeyConnect>;
  /** A `NotificationInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoConnectionNotificationCreateInput>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<NotificationOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientNotificationIdFoUsingNotificationPkeyUpdate>;
};

/** Input for the nested mutation of `notificationCustomEmployeeFieldRecipient` in the `NotificationInput` mutation. */
export type NotificationCustomEmployeeFieldRecipientNotificationIdFoInverseInput = {
  /** The primary key(s) for `notificationCustomEmployeeFieldRecipient` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientNotificationCustomEmployeeFieldRecipientPkeyConnect>>;
  /** A `NotificationCustomEmployeeFieldRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientNotificationIdFoConnectionNotificationCustomEmployeeFieldRecipientCreateInput>>;
  /** The primary key(s) for `notificationCustomEmployeeFieldRecipient` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientNotificationCustomEmployeeFieldRecipientPkeyDelete>>;
  /** Flag indicating whether all other `notificationCustomEmployeeFieldRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationCustomEmployeeFieldRecipient` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientNotificationIdFoUsingNotificationCustomEmployeeFieldRecipientPkeyUpdate>>;
};

/** The fields on `notificationCustomEmployeeFieldRecipient` to look up the row to update. */
export type NotificationCustomEmployeeFieldRecipientOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientCompanyIdForeignUsingNotificationCustomEmployeeFieldRecipientPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationCustomEmployeeFieldRecipient` being updated. */
  patch: UpdateNotificationCustomEmployeeFieldRecipientOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientCompanyIdForeignPatch;
};

/** The fields on `notificationCustomEmployeeFieldRecipient` to look up the row to update. */
export type NotificationCustomEmployeeFieldRecipientOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientFormFieldIdForeUsingNotificationCustomEmployeeFieldRecipientPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationCustomEmployeeFieldRecipient` being updated. */
  patch: UpdateNotificationCustomEmployeeFieldRecipientOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientFormFieldIdForePatch;
};

/** The fields on `notificationCustomEmployeeFieldRecipient` to look up the row to update. */
export type NotificationCustomEmployeeFieldRecipientOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientNotificationIdFoUsingNotificationCustomEmployeeFieldRecipientPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationCustomEmployeeFieldRecipient` being updated. */
  patch: UpdateNotificationCustomEmployeeFieldRecipientOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientNotificationIdFoPatch;
};

/** Represents an update to a `NotificationCustomEmployeeFieldRecipient`. Fields that are set will be updated. */
export type NotificationCustomEmployeeFieldRecipientPatch = {
  company?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `NotificationCustomEmployeeFieldRecipient` values. */
export type NotificationCustomEmployeeFieldRecipientsConnection = {
  __typename?: 'NotificationCustomEmployeeFieldRecipientsConnection';
  /** A list of edges which contains the `NotificationCustomEmployeeFieldRecipient` and cursor to aid in pagination. */
  edges: Array<NotificationCustomEmployeeFieldRecipientsEdge>;
  /** A list of `NotificationCustomEmployeeFieldRecipient` objects. */
  nodes: Array<Maybe<NotificationCustomEmployeeFieldRecipient>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NotificationCustomEmployeeFieldRecipient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `NotificationCustomEmployeeFieldRecipient` edge in the connection. */
export type NotificationCustomEmployeeFieldRecipientsEdge = {
  __typename?: 'NotificationCustomEmployeeFieldRecipientsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `NotificationCustomEmployeeFieldRecipient` at the end of the edge. */
  node?: Maybe<NotificationCustomEmployeeFieldRecipient>;
};

/** Methods to use when ordering `NotificationCustomEmployeeFieldRecipient`. */
export type NotificationCustomEmployeeFieldRecipientsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_DESC'
  | 'FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__ACTIVE_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__ACTIVE_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__COMPANY_ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__COMPANY_ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__CREATED_AT_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__CREATED_AT_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__EMAIL_SUBJECT_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__EMAIL_SUBJECT_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__HOOK_ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__HOOK_ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__METADATA_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__METADATA_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__NOTIFICATION_TYPE_ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__NOTIFICATION_TYPE_ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__PREBOARDING_ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__PREBOARDING_ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__RECIPIENT_TYPE_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__RECIPIENT_TYPE_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__TEXT_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__TEXT_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__UPDATED_AT_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__UPDATED_AT_DESC'
  | 'NOTIFICATION_ID_ASC'
  | 'NOTIFICATION_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type NotificationCustomRecipient = {
  __typename?: 'NotificationCustomRecipient';
  /** Reads a single `Company` that is related to this `NotificationCustomRecipient`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Employee` that is related to this `NotificationCustomRecipient`. */
  employee?: Maybe<Employee>;
  employeeId: Scalars['UUID'];
  /** Reads a single `Notification` that is related to this `NotificationCustomRecipient`. */
  notification?: Maybe<Notification>;
  notificationId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `NotificationCustomRecipient`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The `notificationCustomRecipient` to be created by this mutation. */
export type NotificationCustomRecipientCompanyIdFkeyConnectionNotificationCustomRecipientCreateInput = {
  company?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationCustomRecipientUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `NotificationCustomRecipientInput` mutation. */
export type NotificationCustomRecipientCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnNotificationCustomRecipientForNotificationCustomRecipientCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `notificationCustomRecipient` in the `CompanyInput` mutation. */
export type NotificationCustomRecipientCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `notificationCustomRecipient` for the far side of the relationship. */
  connectByNotificationIdAndEmployeeId?: InputMaybe<Array<NotificationCustomRecipientNotificationCustomRecipientPkeyConnect>>;
  /** A `NotificationCustomRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationCustomRecipientCompanyIdFkeyConnectionNotificationCustomRecipientCreateInput>>;
  /** The primary key(s) for `notificationCustomRecipient` for the far side of the relationship. */
  deleteByNotificationIdAndEmployeeId?: InputMaybe<Array<NotificationCustomRecipientNotificationCustomRecipientPkeyDelete>>;
  /** Flag indicating whether all other `notificationCustomRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationCustomRecipient` for the far side of the relationship. */
  updateByNotificationIdAndEmployeeId?: InputMaybe<Array<NotificationCustomRecipientOnNotificationCustomRecipientForNotificationCustomRecipientCompanyIdFkeyUsingNotificationCustomRecipientPkeyUpdate>>;
};

/**
 * A condition to be used against `NotificationCustomRecipient` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type NotificationCustomRecipientCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `notificationId` field. */
  notificationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `notificationCustomRecipient` to be created by this mutation. */
export type NotificationCustomRecipientEmployeeIdFkeyConnectionNotificationCustomRecipientCreateInput = {
  company?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInput>;
  notification?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationCustomRecipientUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `employee` in the `NotificationCustomRecipientInput` mutation. */
export type NotificationCustomRecipientEmployeeIdFkeyInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnNotificationCustomRecipientForNotificationCustomRecipientEmployeeIdFkeyUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnNotificationCustomRecipientForNotificationCustomRecipientEmployeeIdFkeyUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `notificationCustomRecipient` in the `EmployeeInput` mutation. */
export type NotificationCustomRecipientEmployeeIdFkeyInverseInput = {
  /** The primary key(s) for `notificationCustomRecipient` for the far side of the relationship. */
  connectByNotificationIdAndEmployeeId?: InputMaybe<Array<NotificationCustomRecipientNotificationCustomRecipientPkeyConnect>>;
  /** A `NotificationCustomRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationCustomRecipientEmployeeIdFkeyConnectionNotificationCustomRecipientCreateInput>>;
  /** The primary key(s) for `notificationCustomRecipient` for the far side of the relationship. */
  deleteByNotificationIdAndEmployeeId?: InputMaybe<Array<NotificationCustomRecipientNotificationCustomRecipientPkeyDelete>>;
  /** Flag indicating whether all other `notificationCustomRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationCustomRecipient` for the far side of the relationship. */
  updateByNotificationIdAndEmployeeId?: InputMaybe<Array<NotificationCustomRecipientOnNotificationCustomRecipientForNotificationCustomRecipientEmployeeIdFkeyUsingNotificationCustomRecipientPkeyUpdate>>;
};

/** A filter to be used against `NotificationCustomRecipient` object types. All fields are combined with a logical ‘and.’ */
export type NotificationCustomRecipientFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NotificationCustomRecipientFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NotificationCustomRecipientFilter>;
  /** Filter by the object’s `notification` relation. */
  notification?: InputMaybe<NotificationFilter>;
  /** Filter by the object’s `notificationId` field. */
  notificationId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NotificationCustomRecipientFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `NotificationCustomRecipient` */
export type NotificationCustomRecipientInput = {
  company?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationCustomRecipientUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `notificationCustomRecipient` to look up the row to connect. */
export type NotificationCustomRecipientNotificationCustomRecipientPkeyConnect = {
  employeeId: Scalars['UUID'];
  notificationId: Scalars['UUID'];
};

/** The fields on `notificationCustomRecipient` to look up the row to delete. */
export type NotificationCustomRecipientNotificationCustomRecipientPkeyDelete = {
  employeeId: Scalars['UUID'];
  notificationId: Scalars['UUID'];
};

/** The `notification` to be created by this mutation. */
export type NotificationCustomRecipientNotificationIdFkeyConnectionNotificationCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  customRecipientEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  emailSubject?: InputMaybe<Scalars['String']>;
  hook?: InputMaybe<NotificationHookIdForeignInput>;
  hookId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeNotificationIdForeignInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInverseInput>;
  notificationType?: InputMaybe<NotificationNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
  permissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<NotificationPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  recipientType?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `notificationCustomRecipient` to be created by this mutation. */
export type NotificationCustomRecipientNotificationIdFkeyConnectionNotificationCustomRecipientCreateInput = {
  company?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInput>;
  user?: InputMaybe<NotificationCustomRecipientUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `notification` in the `NotificationCustomRecipientInput` mutation. */
export type NotificationCustomRecipientNotificationIdFkeyInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<NotificationNotificationPkeyConnect>;
  /** A `NotificationInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyConnectionNotificationCreateInput>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<NotificationOnNotificationCustomRecipientForNotificationCustomRecipientNotificationIdFkeyUsingNotificationPkeyUpdate>;
};

/** Input for the nested mutation of `notificationCustomRecipient` in the `NotificationInput` mutation. */
export type NotificationCustomRecipientNotificationIdFkeyInverseInput = {
  /** The primary key(s) for `notificationCustomRecipient` for the far side of the relationship. */
  connectByNotificationIdAndEmployeeId?: InputMaybe<Array<NotificationCustomRecipientNotificationCustomRecipientPkeyConnect>>;
  /** A `NotificationCustomRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationCustomRecipientNotificationIdFkeyConnectionNotificationCustomRecipientCreateInput>>;
  /** The primary key(s) for `notificationCustomRecipient` for the far side of the relationship. */
  deleteByNotificationIdAndEmployeeId?: InputMaybe<Array<NotificationCustomRecipientNotificationCustomRecipientPkeyDelete>>;
  /** Flag indicating whether all other `notificationCustomRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationCustomRecipient` for the far side of the relationship. */
  updateByNotificationIdAndEmployeeId?: InputMaybe<Array<NotificationCustomRecipientOnNotificationCustomRecipientForNotificationCustomRecipientNotificationIdFkeyUsingNotificationCustomRecipientPkeyUpdate>>;
};

/** The fields on `notificationCustomRecipient` to look up the row to update. */
export type NotificationCustomRecipientOnNotificationCustomRecipientForNotificationCustomRecipientCompanyIdFkeyUsingNotificationCustomRecipientPkeyUpdate = {
  employeeId: Scalars['UUID'];
  notificationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationCustomRecipient` being updated. */
  patch: UpdateNotificationCustomRecipientOnNotificationCustomRecipientForNotificationCustomRecipientCompanyIdFkeyPatch;
};

/** The fields on `notificationCustomRecipient` to look up the row to update. */
export type NotificationCustomRecipientOnNotificationCustomRecipientForNotificationCustomRecipientEmployeeIdFkeyUsingNotificationCustomRecipientPkeyUpdate = {
  employeeId: Scalars['UUID'];
  notificationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationCustomRecipient` being updated. */
  patch: UpdateNotificationCustomRecipientOnNotificationCustomRecipientForNotificationCustomRecipientEmployeeIdFkeyPatch;
};

/** The fields on `notificationCustomRecipient` to look up the row to update. */
export type NotificationCustomRecipientOnNotificationCustomRecipientForNotificationCustomRecipientNotificationIdFkeyUsingNotificationCustomRecipientPkeyUpdate = {
  employeeId: Scalars['UUID'];
  notificationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationCustomRecipient` being updated. */
  patch: UpdateNotificationCustomRecipientOnNotificationCustomRecipientForNotificationCustomRecipientNotificationIdFkeyPatch;
};

/** The fields on `notificationCustomRecipient` to look up the row to update. */
export type NotificationCustomRecipientOnNotificationCustomRecipientForNotificationCustomRecipientUserIdFkeyUsingNotificationCustomRecipientPkeyUpdate = {
  employeeId: Scalars['UUID'];
  notificationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationCustomRecipient` being updated. */
  patch: UpdateNotificationCustomRecipientOnNotificationCustomRecipientForNotificationCustomRecipientUserIdFkeyPatch;
};

/** Represents an update to a `NotificationCustomRecipient`. Fields that are set will be updated. */
export type NotificationCustomRecipientPatch = {
  company?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationCustomRecipientUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `notificationCustomRecipient` to be created by this mutation. */
export type NotificationCustomRecipientUserIdFkeyConnectionNotificationCustomRecipientCreateInput = {
  company?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationCustomRecipientUserIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `NotificationCustomRecipientInput` mutation. */
export type NotificationCustomRecipientUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnNotificationCustomRecipientForNotificationCustomRecipientUserIdFkeyUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `notificationCustomRecipient` in the `UserInput` mutation. */
export type NotificationCustomRecipientUserIdFkeyInverseInput = {
  /** The primary key(s) for `notificationCustomRecipient` for the far side of the relationship. */
  connectByNotificationIdAndEmployeeId?: InputMaybe<Array<NotificationCustomRecipientNotificationCustomRecipientPkeyConnect>>;
  /** A `NotificationCustomRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationCustomRecipientUserIdFkeyConnectionNotificationCustomRecipientCreateInput>>;
  /** The primary key(s) for `notificationCustomRecipient` for the far side of the relationship. */
  deleteByNotificationIdAndEmployeeId?: InputMaybe<Array<NotificationCustomRecipientNotificationCustomRecipientPkeyDelete>>;
  /** Flag indicating whether all other `notificationCustomRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationCustomRecipient` for the far side of the relationship. */
  updateByNotificationIdAndEmployeeId?: InputMaybe<Array<NotificationCustomRecipientOnNotificationCustomRecipientForNotificationCustomRecipientUserIdFkeyUsingNotificationCustomRecipientPkeyUpdate>>;
};

/** A connection to a list of `NotificationCustomRecipient` values. */
export type NotificationCustomRecipientsConnection = {
  __typename?: 'NotificationCustomRecipientsConnection';
  /** A list of edges which contains the `NotificationCustomRecipient` and cursor to aid in pagination. */
  edges: Array<NotificationCustomRecipientsEdge>;
  /** A list of `NotificationCustomRecipient` objects. */
  nodes: Array<Maybe<NotificationCustomRecipient>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NotificationCustomRecipient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `NotificationCustomRecipient` edge in the connection. */
export type NotificationCustomRecipientsEdge = {
  __typename?: 'NotificationCustomRecipientsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `NotificationCustomRecipient` at the end of the edge. */
  node?: Maybe<NotificationCustomRecipient>;
};

/** Methods to use when ordering `NotificationCustomRecipient`. */
export type NotificationCustomRecipientsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__ACTIVE_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__ACTIVE_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__COMPANY_ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__COMPANY_ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__CREATED_AT_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__CREATED_AT_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__EMAIL_SUBJECT_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__EMAIL_SUBJECT_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__HOOK_ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__HOOK_ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__METADATA_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__METADATA_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__NOTIFICATION_TYPE_ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__NOTIFICATION_TYPE_ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__PREBOARDING_ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__PREBOARDING_ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__RECIPIENT_TYPE_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__RECIPIENT_TYPE_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__TEXT_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__TEXT_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__UPDATED_AT_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__UPDATED_AT_DESC'
  | 'NOTIFICATION_ID_ASC'
  | 'NOTIFICATION_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type NotificationData = {
  __typename?: 'NotificationData';
  editedFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['JSON']>;
  type?: Maybe<Scalars['String']>;
};

export type NotificationEmployee = {
  __typename?: 'NotificationEmployee';
  /** Reads a single `Company` that is related to this `NotificationEmployee`. */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['Datetime'];
  /** Reads a single `Employee` that is related to this `NotificationEmployee`. */
  employee?: Maybe<Employee>;
  employeeId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  localeOverride?: Maybe<Scalars['String']>;
  /** Reads a single `Notification` that is related to this `NotificationEmployee`. */
  notification?: Maybe<Notification>;
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferences: NotificationEmployeeReferencesConnection;
  notificationId: Scalars['UUID'];
  parentReference?: Maybe<Scalars['String']>;
  placeholderValues?: Maybe<Scalars['JSON']>;
  read: Scalars['Boolean'];
  readTime?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Employee` that is related to this `NotificationEmployee`. */
  recipient?: Maybe<Employee>;
  recipientId: Scalars['UUID'];
  reminded?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Employee` that is related to this `NotificationEmployee`. */
  sender?: Maybe<Employee>;
  senderId?: Maybe<Scalars['UUID']>;
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};


export type NotificationEmployeeNotificationEmployeeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};

/** The `notificationEmployee` to be created by this mutation. */
export type NotificationEmployeeCompanyIdFkeyConnectionNotificationEmployeeCreateInput = {
  company?: InputMaybe<NotificationEmployeeCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<NotificationEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  localeOverride?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<NotificationEmployeeNotificationIdForeignInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInverseInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  parentReference?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  read?: InputMaybe<Scalars['Boolean']>;
  readTime?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  senderId?: InputMaybe<Scalars['UUID']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `company` in the `NotificationEmployeeInput` mutation. */
export type NotificationEmployeeCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnNotificationEmployeeForNotificationEmployeeCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployee` in the `CompanyInput` mutation. */
export type NotificationEmployeeCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `notificationEmployee` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeNotificationEmployeePkeyConnect>>;
  /** A `NotificationEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeCompanyIdFkeyConnectionNotificationEmployeeCreateInput>>;
  /** The primary key(s) for `notificationEmployee` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeNotificationEmployeePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployee` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployee` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeOnNotificationEmployeeForNotificationEmployeeCompanyIdFkeyUsingNotificationEmployeePkeyUpdate>>;
};

/**
 * A condition to be used against `NotificationEmployee` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type NotificationEmployeeCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `localeOverride` field. */
  localeOverride?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notificationId` field. */
  notificationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `parentReference` field. */
  parentReference?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `placeholderValues` field. */
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `read` field. */
  read?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `readTime` field. */
  readTime?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `recipientId` field. */
  recipientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `reminded` field. */
  reminded?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `senderId` field. */
  senderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `text` field. */
  text?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `notificationEmployee` to be created by this mutation. */
export type NotificationEmployeeEmployeeIdForeignConnectionNotificationEmployeeCreateInput = {
  company?: InputMaybe<NotificationEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<NotificationEmployeeEmployeeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  localeOverride?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<NotificationEmployeeNotificationIdForeignInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInverseInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  parentReference?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  read?: InputMaybe<Scalars['Boolean']>;
  readTime?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  senderId?: InputMaybe<Scalars['UUID']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `employee` in the `NotificationEmployeeInput` mutation. */
export type NotificationEmployeeEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnNotificationEmployeeForNotificationEmployeeEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnNotificationEmployeeForNotificationEmployeeEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `notificationEmployee` in the `EmployeeInput` mutation. */
export type NotificationEmployeeEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployee` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeNotificationEmployeePkeyConnect>>;
  /** A `NotificationEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeEmployeeIdForeignConnectionNotificationEmployeeCreateInput>>;
  /** The primary key(s) for `notificationEmployee` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeNotificationEmployeePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployee` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployee` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeOnNotificationEmployeeForNotificationEmployeeEmployeeIdForeignUsingNotificationEmployeePkeyUpdate>>;
};

/** A filter to be used against `NotificationEmployee` object types. All fields are combined with a logical ‘and.’ */
export type NotificationEmployeeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NotificationEmployeeFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** A related `company` exists. */
  companyExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** A related `employee` exists. */
  employeeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localeOverride` field. */
  localeOverride?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NotificationEmployeeFilter>;
  /** Filter by the object’s `notification` relation. */
  notification?: InputMaybe<NotificationFilter>;
  /** Filter by the object’s `notificationEmployeeReferences` relation. */
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferences` exist. */
  notificationEmployeeReferencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `notificationId` field. */
  notificationId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NotificationEmployeeFilter>>;
  /** Filter by the object’s `parentReference` field. */
  parentReference?: InputMaybe<StringFilter>;
  /** Filter by the object’s `placeholderValues` field. */
  placeholderValues?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `read` field. */
  read?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `readTime` field. */
  readTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `recipient` relation. */
  recipient?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `recipientId` field. */
  recipientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `reminded` field. */
  reminded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sender` relation. */
  sender?: InputMaybe<EmployeeFilter>;
  /** A related `sender` exists. */
  senderExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `senderId` field. */
  senderId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `text` field. */
  text?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `NotificationEmployee` */
export type NotificationEmployeeInput = {
  company?: InputMaybe<NotificationEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<NotificationEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  localeOverride?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<NotificationEmployeeNotificationIdForeignInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInverseInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  parentReference?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  read?: InputMaybe<Scalars['Boolean']>;
  readTime?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  senderId?: InputMaybe<Scalars['UUID']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `notificationEmployee` to look up the row to connect. */
export type NotificationEmployeeNotificationEmployeePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `notificationEmployee` to look up the row to delete. */
export type NotificationEmployeeNotificationEmployeePkeyDelete = {
  id: Scalars['UUID'];
};

/** The `notification` to be created by this mutation. */
export type NotificationEmployeeNotificationIdForeignConnectionNotificationCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  customRecipientEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  emailSubject?: InputMaybe<Scalars['String']>;
  hook?: InputMaybe<NotificationHookIdForeignInput>;
  hookId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeNotificationIdForeignInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInverseInput>;
  notificationType?: InputMaybe<NotificationNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
  permissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<NotificationPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  recipientType?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `notificationEmployee` to be created by this mutation. */
export type NotificationEmployeeNotificationIdForeignConnectionNotificationEmployeeCreateInput = {
  company?: InputMaybe<NotificationEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<NotificationEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  localeOverride?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<NotificationEmployeeNotificationIdForeignInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInverseInput>;
  parentReference?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  read?: InputMaybe<Scalars['Boolean']>;
  readTime?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  senderId?: InputMaybe<Scalars['UUID']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `notification` in the `NotificationEmployeeInput` mutation. */
export type NotificationEmployeeNotificationIdForeignInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<NotificationNotificationPkeyConnect>;
  /** A `NotificationInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationEmployeeNotificationIdForeignConnectionNotificationCreateInput>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<NotificationOnNotificationEmployeeForNotificationEmployeeNotificationIdForeignUsingNotificationPkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployee` in the `NotificationInput` mutation. */
export type NotificationEmployeeNotificationIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployee` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeNotificationEmployeePkeyConnect>>;
  /** A `NotificationEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeNotificationIdForeignConnectionNotificationEmployeeCreateInput>>;
  /** The primary key(s) for `notificationEmployee` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeNotificationEmployeePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployee` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployee` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeOnNotificationEmployeeForNotificationEmployeeNotificationIdForeignUsingNotificationEmployeePkeyUpdate>>;
};

/** The fields on `notificationEmployee` to look up the row to update. */
export type NotificationEmployeeOnNotificationEmployeeForNotificationEmployeeCompanyIdFkeyUsingNotificationEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployee` being updated. */
  patch: UpdateNotificationEmployeeOnNotificationEmployeeForNotificationEmployeeCompanyIdFkeyPatch;
};

/** The fields on `notificationEmployee` to look up the row to update. */
export type NotificationEmployeeOnNotificationEmployeeForNotificationEmployeeEmployeeIdForeignUsingNotificationEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployee` being updated. */
  patch: UpdateNotificationEmployeeOnNotificationEmployeeForNotificationEmployeeEmployeeIdForeignPatch;
};

/** The fields on `notificationEmployee` to look up the row to update. */
export type NotificationEmployeeOnNotificationEmployeeForNotificationEmployeeNotificationIdForeignUsingNotificationEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployee` being updated. */
  patch: UpdateNotificationEmployeeOnNotificationEmployeeForNotificationEmployeeNotificationIdForeignPatch;
};

/** The fields on `notificationEmployee` to look up the row to update. */
export type NotificationEmployeeOnNotificationEmployeeForNotificationEmployeeRecipientIdForeignUsingNotificationEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployee` being updated. */
  patch: UpdateNotificationEmployeeOnNotificationEmployeeForNotificationEmployeeRecipientIdForeignPatch;
};

/** The fields on `notificationEmployee` to look up the row to update. */
export type NotificationEmployeeOnNotificationEmployeeForNotificationEmployeeSenderIdForeignUsingNotificationEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployee` being updated. */
  patch: UpdateNotificationEmployeeOnNotificationEmployeeForNotificationEmployeeSenderIdForeignPatch;
};

/** The fields on `notificationEmployee` to look up the row to update. */
export type NotificationEmployeeOnNotificationEmployeeReferenceForNotificationEmployeeReferenceNotificationEmployeeIdForeigUsingNotificationEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployee` being updated. */
  patch: UpdateNotificationEmployeeOnNotificationEmployeeReferenceForNotificationEmployeeReferenceNotificationEmployeeIdForeigPatch;
};

/** Represents an update to a `NotificationEmployee`. Fields that are set will be updated. */
export type NotificationEmployeePatch = {
  company?: InputMaybe<NotificationEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<NotificationEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  localeOverride?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<NotificationEmployeeNotificationIdForeignInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInverseInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  parentReference?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  read?: InputMaybe<Scalars['Boolean']>;
  readTime?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  senderId?: InputMaybe<Scalars['UUID']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `notificationEmployee` to be created by this mutation. */
export type NotificationEmployeeRecipientIdForeignConnectionNotificationEmployeeCreateInput = {
  company?: InputMaybe<NotificationEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<NotificationEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  localeOverride?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<NotificationEmployeeNotificationIdForeignInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInverseInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  parentReference?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  read?: InputMaybe<Scalars['Boolean']>;
  readTime?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  senderId?: InputMaybe<Scalars['UUID']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `notificationEmployee` in the `EmployeeInput` mutation. */
export type NotificationEmployeeRecipientIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployee` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeNotificationEmployeePkeyConnect>>;
  /** A `NotificationEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeRecipientIdForeignConnectionNotificationEmployeeCreateInput>>;
  /** The primary key(s) for `notificationEmployee` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeNotificationEmployeePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployee` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployee` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeOnNotificationEmployeeForNotificationEmployeeRecipientIdForeignUsingNotificationEmployeePkeyUpdate>>;
};

export type NotificationEmployeeReference = {
  __typename?: 'NotificationEmployeeReference';
  announcementId?: Maybe<Scalars['UUID']>;
  casefileId?: Maybe<Scalars['Int']>;
  /** Reads a single `Company` that is related to this `NotificationEmployeeReference`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `Competence` that is related to this `NotificationEmployeeReference`. */
  competence?: Maybe<Competence>;
  /** Reads a single `CompetenceGroup` that is related to this `NotificationEmployeeReference`. */
  competenceGroup?: Maybe<CompetenceGroup>;
  competenceGroupId?: Maybe<Scalars['UUID']>;
  competenceId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ContractSignPending` that is related to this `NotificationEmployeeReference`. */
  contractSignPending?: Maybe<ContractSignPending>;
  contractSignPendingId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Department` that is related to this `NotificationEmployeeReference`. */
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Employee` that is related to this `NotificationEmployeeReference`. */
  employee?: Maybe<Employee>;
  employeeId?: Maybe<Scalars['UUID']>;
  equipmentId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Storage` that is related to this `NotificationEmployeeReference`. */
  file?: Maybe<Storage>;
  fileId?: Maybe<Scalars['UUID']>;
  /** Reads a single `FutureDatum` that is related to this `NotificationEmployeeReference`. */
  futureData?: Maybe<FutureDatum>;
  futureDataId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  /** Reads a single `Message` that is related to this `NotificationEmployeeReference`. */
  message?: Maybe<Message>;
  messageId?: Maybe<Scalars['UUID']>;
  notificationData?: Maybe<NotificationData>;
  /** Reads a single `NotificationEmployee` that is related to this `NotificationEmployeeReference`. */
  notificationEmployee?: Maybe<NotificationEmployee>;
  notificationEmployeeId: Scalars['UUID'];
  /** Reads a single `Preboarding` that is related to this `NotificationEmployeeReference`. */
  preboarding?: Maybe<Preboarding>;
  preboardingId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Process` that is related to this `NotificationEmployeeReference`. */
  process?: Maybe<Process>;
  processId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Product` that is related to this `NotificationEmployeeReference`. */
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['UUID']>;
  /** Reads a single `User` that is related to this `NotificationEmployeeReference`. */
  recipientUser?: Maybe<User>;
  recipientUserId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Task` that is related to this `NotificationEmployeeReference`. */
  task?: Maybe<Task>;
  taskId?: Maybe<Scalars['UUID']>;
  /** Reads a single `TaskTemplate` that is related to this `NotificationEmployeeReference`. */
  taskTemplate?: Maybe<TaskTemplate>;
  taskTemplateId?: Maybe<Scalars['UUID']>;
  /** Reads a single `TimeRegistrationPresence` that is related to this `NotificationEmployeeReference`. */
  timeRegistrationPresence?: Maybe<TimeRegistrationPresence>;
  timeRegistrationPresenceId?: Maybe<Scalars['UUID']>;
  /** Reads a single `UserCompetence` that is related to this `NotificationEmployeeReference`. */
  userCompetence?: Maybe<UserCompetence>;
  userCompetenceId?: Maybe<Scalars['UUID']>;
  /** Reads a single `VacationType` that is related to this `NotificationEmployeeReference`. */
  vacationType?: Maybe<VacationType>;
  vacationTypeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `VacationUser` that is related to this `NotificationEmployeeReference`. */
  vacationUser?: Maybe<VacationUser>;
  vacationUserId?: Maybe<Scalars['UUID']>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceCompanyIdFkeyConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `CompanyInput` mutation. */
export type NotificationEmployeeReferenceCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceCompanyIdFkeyConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompanyIdFkeyUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** The `competenceGroup` to be created by this mutation. */
export type NotificationEmployeeReferenceCompetenceGroupIdForeignConnectionCompetenceGroupCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competences?: InputMaybe<CompetenceCompetenceGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInverseInput>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceCompetenceGroupIdForeignConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `competenceGroup` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceCompetenceGroupIdForeignInput = {
  /** The primary key(s) for `competenceGroup` for the far side of the relationship. */
  connectById?: InputMaybe<CompetenceGroupCompetenceGroupPkeyConnect>;
  /** A `CompetenceGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignConnectionCompetenceGroupCreateInput>;
  /** The primary key(s) and patch data for `competenceGroup` for the far side of the relationship. */
  updateById?: InputMaybe<CompetenceGroupOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompetenceGroupIdForeignUsingCompetenceGroupPkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `CompetenceGroupInput` mutation. */
export type NotificationEmployeeReferenceCompetenceGroupIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceCompetenceGroupIdForeignConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompetenceGroupIdForeignUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** The `competence` to be created by this mutation. */
export type NotificationEmployeeReferenceCompetenceIdForeignConnectionCompetenceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInverseInput>;
  competenceGroup?: InputMaybe<CompetenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceRequests?: InputMaybe<CompetenceRequestCompetenceIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CompetenceRatingFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInverseInput>;
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
  outdateAt?: InputMaybe<Scalars['Datetime']>;
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  outdateInterval?: InputMaybe<IntervalInput>;
  ratingFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval: IntervalInput;
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useRating?: InputMaybe<Scalars['Boolean']>;
  userCompetences?: InputMaybe<UserCompetenceCompetenceIdForeignInverseInput>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceCompetenceIdForeignConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `competence` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceCompetenceIdForeignInput = {
  /** The primary key(s) for `competence` for the far side of the relationship. */
  connectById?: InputMaybe<CompetenceCompetencePkeyConnect>;
  /** A `CompetenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignConnectionCompetenceCreateInput>;
  /** The primary key(s) and patch data for `competence` for the far side of the relationship. */
  updateById?: InputMaybe<CompetenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompetenceIdForeignUsingCompetencePkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `CompetenceInput` mutation. */
export type NotificationEmployeeReferenceCompetenceIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceCompetenceIdForeignConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompetenceIdForeignUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/**
 * A condition to be used against `NotificationEmployeeReference` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type NotificationEmployeeReferenceCondition = {
  /** Checks for equality with the object’s `announcementId` field. */
  announcementId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `casefileId` field. */
  casefileId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `competenceGroupId` field. */
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `competenceId` field. */
  competenceId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `contractSignPendingId` field. */
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departmentId` field. */
  departmentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `equipmentId` field. */
  equipmentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fileId` field. */
  fileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `futureDataId` field. */
  futureDataId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `messageId` field. */
  messageId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `notificationEmployeeId` field. */
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `preboardingId` field. */
  preboardingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `processId` field. */
  processId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `recipientUserId` field. */
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `taskTemplateId` field. */
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeRegistrationPresenceId` field. */
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userCompetenceId` field. */
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `vacationTypeId` field. */
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `vacationUserId` field. */
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** The `contractSignPending` to be created by this mutation. */
export type NotificationEmployeeReferenceContractSignPendingIdForeigConnectionContractSignPendingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  existingDocuments?: InputMaybe<Array<InputMaybe<ContractExistingDocumentInput>>>;
  generatedDocuments?: InputMaybe<Array<InputMaybe<ContractGeneratedDocumentInput>>>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUsers: Array<ContractSignerInput>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceContractSignPendingIdForeigConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `contractSignPending` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceContractSignPendingIdForeigInput = {
  /** The primary key(s) for `contractSignPending` for the far side of the relationship. */
  connectById?: InputMaybe<ContractSignPendingContractSignPendingPkeyConnect>;
  /** A `ContractSignPendingInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigConnectionContractSignPendingCreateInput>;
  /** The primary key(s) and patch data for `contractSignPending` for the far side of the relationship. */
  updateById?: InputMaybe<ContractSignPendingOnNotificationEmployeeReferenceForNotificationEmployeeReferenceContractSignPendingIdForeigUsingContractSignPendingPkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `ContractSignPendingInput` mutation. */
export type NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceContractSignPendingIdForeigConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceContractSignPendingIdForeigUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** The `department` to be created by this mutation. */
export type NotificationEmployeeReferenceDepartmentIdForeignConnectionDepartmentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceDepartmentIdForeignConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `department` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceDepartmentIdForeignInput = {
  /** The primary key(s) for `department` for the far side of the relationship. */
  connectById?: InputMaybe<DepartmentDepartmentPkeyConnect>;
  /** A `DepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignConnectionDepartmentCreateInput>;
  /** The primary key(s) and patch data for `department` for the far side of the relationship. */
  updateById?: InputMaybe<DepartmentOnNotificationEmployeeReferenceForNotificationEmployeeReferenceDepartmentIdForeignUsingDepartmentPkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `DepartmentInput` mutation. */
export type NotificationEmployeeReferenceDepartmentIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceDepartmentIdForeignConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceDepartmentIdForeignUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceEmployeeIdForeignConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `employee` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnNotificationEmployeeReferenceForNotificationEmployeeReferenceEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnNotificationEmployeeReferenceForNotificationEmployeeReferenceEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `EmployeeInput` mutation. */
export type NotificationEmployeeReferenceEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceEmployeeIdForeignConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceEmployeeIdForeignUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceFileIdForeignConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** The `storage` to be created by this mutation. */
export type NotificationEmployeeReferenceFileIdForeignConnectionStorageCreateInput = {
  access: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createCopy?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path: Scalars['String'];
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `storage` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceFileIdForeignInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<StorageStoragePkeyConnect>;
  /** A `StorageInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationEmployeeReferenceFileIdForeignConnectionStorageCreateInput>;
  /** The primary key(s) and patch data for `storage` for the far side of the relationship. */
  updateById?: InputMaybe<StorageOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFileIdForeignUsingStoragePkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `StorageInput` mutation. */
export type NotificationEmployeeReferenceFileIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceFileIdForeignConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFileIdForeignUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** A filter to be used against `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type NotificationEmployeeReferenceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NotificationEmployeeReferenceFilter>>;
  /** Filter by the object’s `announcementId` field. */
  announcementId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `casefileId` field. */
  casefileId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `competence` relation. */
  competence?: InputMaybe<CompetenceFilter>;
  /** A related `competence` exists. */
  competenceExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `competenceGroup` relation. */
  competenceGroup?: InputMaybe<CompetenceGroupFilter>;
  /** A related `competenceGroup` exists. */
  competenceGroupExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `competenceGroupId` field. */
  competenceGroupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `competenceId` field. */
  competenceId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `contractSignPending` relation. */
  contractSignPending?: InputMaybe<ContractSignPendingFilter>;
  /** A related `contractSignPending` exists. */
  contractSignPendingExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractSignPendingId` field. */
  contractSignPendingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `department` relation. */
  department?: InputMaybe<DepartmentFilter>;
  /** A related `department` exists. */
  departmentExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `departmentId` field. */
  departmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** A related `employee` exists. */
  employeeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `equipmentId` field. */
  equipmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `file` relation. */
  file?: InputMaybe<StorageFilter>;
  /** A related `file` exists. */
  fileExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `fileId` field. */
  fileId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `futureData` relation. */
  futureData?: InputMaybe<FutureDatumFilter>;
  /** A related `futureData` exists. */
  futureDataExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `futureDataId` field. */
  futureDataId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `message` relation. */
  message?: InputMaybe<MessageFilter>;
  /** A related `message` exists. */
  messageExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `messageId` field. */
  messageId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Filter by the object’s `notificationEmployee` relation. */
  notificationEmployee?: InputMaybe<NotificationEmployeeFilter>;
  /** Filter by the object’s `notificationEmployeeId` field. */
  notificationEmployeeId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NotificationEmployeeReferenceFilter>>;
  /** Filter by the object’s `preboarding` relation. */
  preboarding?: InputMaybe<PreboardingFilter>;
  /** A related `preboarding` exists. */
  preboardingExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingId` field. */
  preboardingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `process` relation. */
  process?: InputMaybe<ProcessFilter>;
  /** A related `process` exists. */
  processExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processId` field. */
  processId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `product` relation. */
  product?: InputMaybe<ProductFilter>;
  /** A related `product` exists. */
  productExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `recipientUser` relation. */
  recipientUser?: InputMaybe<UserFilter>;
  /** A related `recipientUser` exists. */
  recipientUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `recipientUserId` field. */
  recipientUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `task` relation. */
  task?: InputMaybe<TaskFilter>;
  /** A related `task` exists. */
  taskExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `taskTemplate` relation. */
  taskTemplate?: InputMaybe<TaskTemplateFilter>;
  /** A related `taskTemplate` exists. */
  taskTemplateExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskTemplateId` field. */
  taskTemplateId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `timeRegistrationPresence` relation. */
  timeRegistrationPresence?: InputMaybe<TimeRegistrationPresenceFilter>;
  /** A related `timeRegistrationPresence` exists. */
  timeRegistrationPresenceExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationPresenceId` field. */
  timeRegistrationPresenceId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userCompetence` relation. */
  userCompetence?: InputMaybe<UserCompetenceFilter>;
  /** A related `userCompetence` exists. */
  userCompetenceExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userCompetenceId` field. */
  userCompetenceId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `vacationType` relation. */
  vacationType?: InputMaybe<VacationTypeFilter>;
  /** A related `vacationType` exists. */
  vacationTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `vacationTypeId` field. */
  vacationTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `vacationUser` relation. */
  vacationUser?: InputMaybe<VacationUserFilter>;
  /** A related `vacationUser` exists. */
  vacationUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `vacationUserId` field. */
  vacationUserId?: InputMaybe<UuidFilter>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceFutureDataIdForeignConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `futureDatum` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceFutureDataIdForeignInput = {
  /** The primary key(s) for `futureDatum` for the far side of the relationship. */
  connectByApprovalId?: InputMaybe<FutureDatumFutureDataApprovalIdUniqueConnect>;
  /** The primary key(s) for `futureDatum` for the far side of the relationship. */
  connectById?: InputMaybe<FutureDatumFutureDataPkeyConnect>;
  /** The primary key(s) and patch data for `futureDatum` for the far side of the relationship. */
  updateByApprovalId?: InputMaybe<FutureDatumOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFutureDataIdForeignUsingFutureDataApprovalIdUniqueUpdate>;
  /** The primary key(s) and patch data for `futureDatum` for the far side of the relationship. */
  updateById?: InputMaybe<FutureDatumOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFutureDataIdForeignUsingFutureDataPkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `FutureDatumInput` mutation. */
export type NotificationEmployeeReferenceFutureDataIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceFutureDataIdForeignConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFutureDataIdForeignUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** An input for mutations affecting `NotificationEmployeeReference` */
export type NotificationEmployeeReferenceInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** The `message` to be created by this mutation. */
export type NotificationEmployeeReferenceMessageIdForeignConnectionMessageCreateInput = {
  audioFile?: InputMaybe<Scalars['String']>;
  body: Scalars['String'];
  company?: InputMaybe<MessageCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<MessageToEmployeeIdForeignInput>;
  fromEmployeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  latestMessages?: InputMaybe<LatestMessageMessageIdForeignInverseInput>;
  messageRecipients?: InputMaybe<MessageRecipientMessageIdForeignInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInverseInput>;
  readByFrom?: InputMaybe<Scalars['Boolean']>;
  readByTo?: InputMaybe<Scalars['Boolean']>;
  subject: Scalars['String'];
  toEmployeeId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<MessageType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceMessageIdForeignConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `message` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceMessageIdForeignInput = {
  /** The primary key(s) for `message` for the far side of the relationship. */
  connectById?: InputMaybe<MessageMessagePkeyConnect>;
  /** A `MessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignConnectionMessageCreateInput>;
  /** The primary key(s) and patch data for `message` for the far side of the relationship. */
  updateById?: InputMaybe<MessageOnNotificationEmployeeReferenceForNotificationEmployeeReferenceMessageIdForeignUsingMessagePkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `MessageInput` mutation. */
export type NotificationEmployeeReferenceMessageIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceMessageIdForeignConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceMessageIdForeignUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** The `notificationEmployee` to be created by this mutation. */
export type NotificationEmployeeReferenceNotificationEmployeeIdForeigConnectionNotificationEmployeeCreateInput = {
  company?: InputMaybe<NotificationEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<NotificationEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  localeOverride?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<NotificationEmployeeNotificationIdForeignInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInverseInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  parentReference?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  read?: InputMaybe<Scalars['Boolean']>;
  readTime?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  senderId?: InputMaybe<Scalars['UUID']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceNotificationEmployeeIdForeigConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `notificationEmployee` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceNotificationEmployeeIdForeigInput = {
  /** The primary key(s) for `notificationEmployee` for the far side of the relationship. */
  connectById?: InputMaybe<NotificationEmployeeNotificationEmployeePkeyConnect>;
  /** A `NotificationEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigConnectionNotificationEmployeeCreateInput>;
  /** The primary key(s) for `notificationEmployee` for the far side of the relationship. */
  deleteById?: InputMaybe<NotificationEmployeeNotificationEmployeePkeyDelete>;
  /** The primary key(s) and patch data for `notificationEmployee` for the far side of the relationship. */
  updateById?: InputMaybe<NotificationEmployeeOnNotificationEmployeeReferenceForNotificationEmployeeReferenceNotificationEmployeeIdForeigUsingNotificationEmployeePkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `NotificationEmployeeInput` mutation. */
export type NotificationEmployeeReferenceNotificationEmployeeIdForeigInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeIdForeigConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceNotificationEmployeeIdForeigUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** The fields on `notificationEmployeeReference` to look up the row to connect. */
export type NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `notificationEmployeeReference` to look up the row to delete. */
export type NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompanyIdFkeyUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompanyIdFkeyPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompetenceGroupIdForeignUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompetenceGroupIdForeignPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompetenceIdForeignUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompetenceIdForeignPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceContractSignPendingIdForeigUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceContractSignPendingIdForeigPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceDepartmentIdForeignUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceDepartmentIdForeignPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceEmployeeIdForeignUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceEmployeeIdForeignPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFileIdForeignUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFileIdForeignPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFutureDataIdForeignUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFutureDataIdForeignPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceMessageIdForeignUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceMessageIdForeignPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceNotificationEmployeeIdForeigUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceNotificationEmployeeIdForeigPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferencePreboardingIdForeignUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferencePreboardingIdForeignPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceProcessIdForeignUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceProcessIdForeignPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceProductIdForeignUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceProductIdForeignPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceRecipientUserIdFkeyUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceRecipientUserIdFkeyPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTaskIdForeignUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTaskIdForeignPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTaskTemplateIdForeignUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTaskTemplateIdForeignPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTimeRegistrationPresenceIdFUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTimeRegistrationPresenceIdFPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceUserCompetenceIdForeignUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceUserCompetenceIdForeignPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationTypeIdForeignUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationTypeIdForeignPatch;
};

/** The fields on `notificationEmployeeReference` to look up the row to update. */
export type NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationUserIdForeignUsingNotificationEmployeeReferencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
  patch: UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationUserIdForeignPatch;
};

/** Represents an update to a `NotificationEmployeeReference`. Fields that are set will be updated. */
export type NotificationEmployeeReferencePatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferencePreboardingIdForeignConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** The `preboarding` to be created by this mutation. */
export type NotificationEmployeeReferencePreboardingIdForeignConnectionPreboardingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontStorageId?: InputMaybe<Scalars['UUID']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoStorageId?: InputMaybe<Scalars['UUID']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `preboarding` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferencePreboardingIdForeignInput = {
  /** The primary key(s) for `preboarding` for the far side of the relationship. */
  connectById?: InputMaybe<PreboardingPreboardingPkeyConnect>;
  /** A `PreboardingInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignConnectionPreboardingCreateInput>;
  /** The primary key(s) and patch data for `preboarding` for the far side of the relationship. */
  updateById?: InputMaybe<PreboardingOnNotificationEmployeeReferenceForNotificationEmployeeReferencePreboardingIdForeignUsingPreboardingPkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `PreboardingInput` mutation. */
export type NotificationEmployeeReferencePreboardingIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferencePreboardingIdForeignConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferencePreboardingIdForeignUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceProcessIdForeignConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** The `process` to be created by this mutation. */
export type NotificationEmployeeReferenceProcessIdForeignConnectionProcessCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `process` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceProcessIdForeignInput = {
  /** The primary key(s) for `process` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessProcessPkeyConnect>;
  /** A `ProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignConnectionProcessCreateInput>;
  /** The primary key(s) and patch data for `process` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessOnNotificationEmployeeReferenceForNotificationEmployeeReferenceProcessIdForeignUsingProcessPkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `ProcessInput` mutation. */
export type NotificationEmployeeReferenceProcessIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceProcessIdForeignConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceProcessIdForeignUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceProductIdForeignConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** The `product` to be created by this mutation. */
export type NotificationEmployeeReferenceProductIdForeignConnectionProductCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ProductDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<EquipmentProductIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInverseInput>;
  productType?: InputMaybe<ProductProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  searchTerms?: InputMaybe<Scalars['FullText']>;
  serial?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProductAssignedUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `product` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceProductIdForeignInput = {
  /** The primary key(s) for `product` for the far side of the relationship. */
  connectById?: InputMaybe<ProductProductPkeyConnect>;
  /** A `ProductInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationEmployeeReferenceProductIdForeignConnectionProductCreateInput>;
  /** The primary key(s) and patch data for `product` for the far side of the relationship. */
  updateById?: InputMaybe<ProductOnNotificationEmployeeReferenceForNotificationEmployeeReferenceProductIdForeignUsingProductPkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `ProductInput` mutation. */
export type NotificationEmployeeReferenceProductIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceProductIdForeignConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceProductIdForeignUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceRecipientUserIdFkeyConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `user` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceRecipientUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnNotificationEmployeeReferenceForNotificationEmployeeReferenceRecipientUserIdFkeyUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `UserInput` mutation. */
export type NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceRecipientUserIdFkeyConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceRecipientUserIdFkeyUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceTaskIdForeignConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** The `task` to be created by this mutation. */
export type NotificationEmployeeReferenceTaskIdForeignConnectionTaskCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['Datetime'];
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `task` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceTaskIdForeignInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignConnectionTaskCreateInput>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTaskIdForeignUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `TaskInput` mutation. */
export type NotificationEmployeeReferenceTaskIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceTaskIdForeignConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTaskIdForeignUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceTaskTemplateIdForeignConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** The `taskTemplate` to be created by this mutation. */
export type NotificationEmployeeReferenceTaskTemplateIdForeignConnectionTaskTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** Input for the nested mutation of `taskTemplate` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceTaskTemplateIdForeignInput = {
  /** The primary key(s) for `taskTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTemplateTaskTemplatePkeyConnect>;
  /** A `TaskTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignConnectionTaskTemplateCreateInput>;
  /** The primary key(s) and patch data for `taskTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<TaskTemplateOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTaskTemplateIdForeignUsingTaskTemplatePkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `TaskTemplateInput` mutation. */
export type NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceTaskTemplateIdForeignConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTaskTemplateIdForeignUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceTimeRegistrationPresenceIdFConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** The `timeRegistrationPresence` to be created by this mutation. */
export type NotificationEmployeeReferenceTimeRegistrationPresenceIdFConnectionTimeRegistrationPresenceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInverseInput>;
  startDate: Scalars['Datetime'];
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  unpaidBreakTime?: InputMaybe<IntervalInput>;
  user?: InputMaybe<TimeRegistrationPresenceUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `timeRegistrationPresence` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput = {
  /** The primary key(s) for `timeRegistrationPresence` for the far side of the relationship. */
  connectById?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresencePkeyConnect>;
  /** A `TimeRegistrationPresenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFConnectionTimeRegistrationPresenceCreateInput>;
  /** The primary key(s) for `timeRegistrationPresence` for the far side of the relationship. */
  deleteById?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresencePkeyDelete>;
  /** The primary key(s) and patch data for `timeRegistrationPresence` for the far side of the relationship. */
  updateById?: InputMaybe<TimeRegistrationPresenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTimeRegistrationPresenceIdFUsingTimeRegistrationPresencePkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `TimeRegistrationPresenceInput` mutation. */
export type NotificationEmployeeReferenceTimeRegistrationPresenceIdFInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceTimeRegistrationPresenceIdFConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTimeRegistrationPresenceIdFUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceUserCompetenceIdForeignConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** The `userCompetence` to be created by this mutation. */
export type NotificationEmployeeReferenceUserCompetenceIdForeignConnectionUserCompetenceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addedDate?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<UserCompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<UserCompetenceCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  courseRequested?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInverseInput>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceUserIdForeignInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInverseInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `userCompetence` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceUserCompetenceIdForeignInput = {
  /** The primary key(s) for `userCompetence` for the far side of the relationship. */
  connectById?: InputMaybe<UserCompetenceUserCompetencePkeyConnect>;
  /** A `UserCompetenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignConnectionUserCompetenceCreateInput>;
  /** The primary key(s) and patch data for `userCompetence` for the far side of the relationship. */
  updateById?: InputMaybe<UserCompetenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceUserCompetenceIdForeignUsingUserCompetencePkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `UserCompetenceInput` mutation. */
export type NotificationEmployeeReferenceUserCompetenceIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceUserCompetenceIdForeignConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceUserCompetenceIdForeignUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceVacationTypeIdForeignConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** The `vacationType` to be created by this mutation. */
export type NotificationEmployeeReferenceVacationTypeIdForeignConnectionVacationTypeCreateInput = {
  absenceCode?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  color: Scalars['String'];
  company?: InputMaybe<VacationTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  mustBeApproved?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInverseInput>;
  quickAction?: InputMaybe<Scalars['Boolean']>;
  sendCalendarInvite?: InputMaybe<Scalars['Boolean']>;
  vacationUsers?: InputMaybe<VacationUserVacationTypeIdForeignInverseInput>;
};

/** Input for the nested mutation of `vacationType` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceVacationTypeIdForeignInput = {
  /** The primary key(s) for `vacationType` for the far side of the relationship. */
  connectById?: InputMaybe<VacationTypeVacationTypePkeyConnect>;
  /** A `VacationTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignConnectionVacationTypeCreateInput>;
  /** The primary key(s) and patch data for `vacationType` for the far side of the relationship. */
  updateById?: InputMaybe<VacationTypeOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationTypeIdForeignUsingVacationTypePkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `VacationTypeInput` mutation. */
export type NotificationEmployeeReferenceVacationTypeIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceVacationTypeIdForeignConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationTypeIdForeignUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** The `notificationEmployeeReference` to be created by this mutation. */
export type NotificationEmployeeReferenceVacationUserIdForeignConnectionNotificationEmployeeReferenceCreateInput = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
};

/** The `vacationUser` to be created by this mutation. */
export type NotificationEmployeeReferenceVacationUserIdForeignConnectionVacationUserCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  allDay?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<VacationUserDeletionApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<VacationUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  customId?: InputMaybe<Scalars['UUID']>;
  deletionApprovalId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInverseInput>;
  startDate: Scalars['Datetime'];
  user?: InputMaybe<VacationUserCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<VacationUserVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `vacationUser` in the `NotificationEmployeeReferenceInput` mutation. */
export type NotificationEmployeeReferenceVacationUserIdForeignInput = {
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectByApprovalId?: InputMaybe<VacationUserVacationUserApprovalIdUniqueConnect>;
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectByDeletionApprovalId?: InputMaybe<VacationUserVacationUserDeletionApprovalIdUniqueConnect>;
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectById?: InputMaybe<VacationUserVacationUserPkeyConnect>;
  /** A `VacationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignConnectionVacationUserCreateInput>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateByApprovalId?: InputMaybe<VacationUserOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationUserIdForeignUsingVacationUserApprovalIdUniqueUpdate>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateByDeletionApprovalId?: InputMaybe<VacationUserOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationUserIdForeignUsingVacationUserDeletionApprovalIdUniqueUpdate>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateById?: InputMaybe<VacationUserOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationUserIdForeignUsingVacationUserPkeyUpdate>;
};

/** Input for the nested mutation of `notificationEmployeeReference` in the `VacationUserInput` mutation. */
export type NotificationEmployeeReferenceVacationUserIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyConnect>>;
  /** A `NotificationEmployeeReferenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeReferenceVacationUserIdForeignConnectionNotificationEmployeeReferenceCreateInput>>;
  /** The primary key(s) for `notificationEmployeeReference` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeReferenceNotificationEmployeeReferencePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployeeReference` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployeeReference` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationUserIdForeignUsingNotificationEmployeeReferencePkeyUpdate>>;
};

/** A connection to a list of `NotificationEmployeeReference` values. */
export type NotificationEmployeeReferencesConnection = {
  __typename?: 'NotificationEmployeeReferencesConnection';
  /** A list of edges which contains the `NotificationEmployeeReference` and cursor to aid in pagination. */
  edges: Array<NotificationEmployeeReferencesEdge>;
  /** A list of `NotificationEmployeeReference` objects. */
  nodes: Array<Maybe<NotificationEmployeeReference>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NotificationEmployeeReference` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `NotificationEmployeeReference` edge in the connection. */
export type NotificationEmployeeReferencesEdge = {
  __typename?: 'NotificationEmployeeReferencesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `NotificationEmployeeReference` at the end of the edge. */
  node?: Maybe<NotificationEmployeeReference>;
};

/** Methods to use when ordering `NotificationEmployeeReference`. */
export type NotificationEmployeeReferencesOrderBy =
  | 'ANNOUNCEMENT_ID_ASC'
  | 'ANNOUNCEMENT_ID_DESC'
  | 'CASEFILE_ID_ASC'
  | 'CASEFILE_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ACTIVE_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ACTIVE_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__COMPANY_ID_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__COMPANY_ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__COMPETENCE_GROUP_ID_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__COMPETENCE_GROUP_ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__CREATED_AT_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__CREATED_AT_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__DESCRIPTION_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__DESCRIPTION_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ID_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__LOCALIZED_NAME_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__LOCALIZED_NAME_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__NAME_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__NAME_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ONLY_MANAGER_SHOULD_EVALUATE_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ONLY_MANAGER_SHOULD_EVALUATE_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_AT_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_AT_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_COMPETENCE_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_COMPETENCE_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_INTERVAL_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_INTERVAL_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__RATING_FORM_FIELD_ID_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__RATING_FORM_FIELD_ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__REMINDER_INTERVAL_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__REMINDER_INTERVAL_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__UPDATED_AT_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__UPDATED_AT_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__UPDATE_REMINDER_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__UPDATE_REMINDER_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__USE_RATING_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__USE_RATING_DESC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__ACTIVE_ASC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__ACTIVE_DESC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__COMPANY_ID_ASC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__COMPANY_ID_DESC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__ID_ASC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__ID_DESC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__LOCALIZED_NAME_ASC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__LOCALIZED_NAME_DESC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__NAME_ASC'
  | 'COMPETENCE_GROUP_BY_COMPETENCE_GROUP_ID__NAME_DESC'
  | 'COMPETENCE_GROUP_ID_ASC'
  | 'COMPETENCE_GROUP_ID_DESC'
  | 'COMPETENCE_ID_ASC'
  | 'COMPETENCE_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ACTIVE_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ACTIVE_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ARCHIVED_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ARCHIVED_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__COMPANY_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__COMPANY_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__CREATED_AT_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__CREATED_AT_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__CREATOR_USER_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__CREATOR_USER_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__DEPARTMENTS_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__DEPARTMENTS_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__EMAIL_TEXT_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__EMAIL_TEXT_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__EMPLOYEE_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__EMPLOYEE_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ENFORCE_SIGN_ORDER_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ENFORCE_SIGN_ORDER_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__MERGED_DOCUMENT_DOCUMENT_TYPE_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__MERGED_DOCUMENT_DOCUMENT_TYPE_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__MERGED_DOCUMENT_NAME_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__MERGED_DOCUMENT_NAME_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__MERGE_INTO_ONE_DOCUMENT_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__MERGE_INTO_ONE_DOCUMENT_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__NEXT_SIGNING_USER_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__NEXT_SIGNING_USER_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__PREBOARDING_EMPLOYEE_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__PREBOARDING_EMPLOYEE_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__PREBOARDING_SLIDE_FORM_FIELD_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__PREBOARDING_SLIDE_FORM_FIELD_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__REMINDER_INTERVAL_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__REMINDER_INTERVAL_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__SIGNED_USER_IDS_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__SIGNED_USER_IDS_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__SIGNING_USER_IDS_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__SIGNING_USER_IDS_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__SIGN_DATE_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__SIGN_DATE_DESC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__USER_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_BY_CONTRACT_SIGN_PENDING_ID__USER_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ACTIVE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ACTIVE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ADDRESS_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ADDRESS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ALIAS_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ALIAS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CITY_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CITY_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COMPANY_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COMPANY_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COUNTRY_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COUNTRY_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CREATED_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CREATED_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CUSTOM_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CUSTOM_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CVR_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CVR_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DELETE_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DELETE_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_NUMBER_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_NUMBER_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DESCRIPTION_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DESCRIPTION_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EAN_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EAN_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EMAIL_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EMAIL_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__MAIN_DEPARTMENT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__MAIN_DEPARTMENT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__NAME_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__NAME_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PHONE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PHONE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__POSTAL_CODE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__POSTAL_CODE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__P_NUMBER_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__P_NUMBER_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__UPDATED_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__UPDATED_AT_DESC'
  | 'DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'EQUIPMENT_ID_ASC'
  | 'EQUIPMENT_ID_DESC'
  | 'FILE_ID_ASC'
  | 'FILE_ID_DESC'
  | 'FUTURE_DATA_ID_ASC'
  | 'FUTURE_DATA_ID_DESC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__ACTIVE_ASC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__ACTIVE_DESC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__APPROVAL_ID_ASC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__APPROVAL_ID_DESC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__COMPANY_ID_ASC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__COMPANY_ID_DESC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__CREATED_AT_ASC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__CREATED_AT_DESC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__CREATOR_USER_ID_ASC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__CREATOR_USER_ID_DESC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__DEPARTMENT_IDS_ASC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__DEPARTMENT_IDS_DESC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__FIELD_GROUP_ID_ASC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__FIELD_GROUP_ID_DESC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__FORM_FIELD_ID_ASC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__FORM_FIELD_ID_DESC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__ID_ASC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__ID_DESC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__LEADER_DEPARTMENT_IDS_ASC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__LEADER_DEPARTMENT_IDS_DESC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__SYSTEM_FIELD_ID_ASC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__SYSTEM_FIELD_ID_DESC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__UNIQUE_KEY_ASC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__UNIQUE_KEY_DESC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__UPDATE_VALUE_AT_ASC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__UPDATE_VALUE_AT_DESC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__USER_ID_ASC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__USER_ID_DESC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__VALUE_ASC'
  | 'FUTURE_DATUM_BY_FUTURE_DATA_ID__VALUE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__BODY_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__BODY_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__COMPANY_ID_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__COMPANY_ID_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__CREATED_AT_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__CREATED_AT_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__FROM_EMPLOYEE_ID_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__FROM_EMPLOYEE_ID_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__ID_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__ID_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__READ_BY_FROM_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__READ_BY_FROM_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__READ_BY_TO_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__READ_BY_TO_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__SUBJECT_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__SUBJECT_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__TO_EMPLOYEE_ID_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__TO_EMPLOYEE_ID_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__TYPE_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__TYPE_DESC'
  | 'MESSAGE_BY_MESSAGE_ID__UPDATED_AT_ASC'
  | 'MESSAGE_BY_MESSAGE_ID__UPDATED_AT_DESC'
  | 'MESSAGE_ID_ASC'
  | 'MESSAGE_ID_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__EMPLOYEE_ID_ASC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__EMPLOYEE_ID_DESC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__ID_ASC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__ID_DESC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__LOCALE_OVERRIDE_ASC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__LOCALE_OVERRIDE_DESC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__NOTIFICATION_ID_ASC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__NOTIFICATION_ID_DESC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__PARENT_REFERENCE_ASC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__PARENT_REFERENCE_DESC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__PLACEHOLDER_VALUES_ASC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__PLACEHOLDER_VALUES_DESC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__READ_ASC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__READ_DESC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__READ_TIME_ASC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__READ_TIME_DESC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__RECIPIENT_ID_ASC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__RECIPIENT_ID_DESC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__REMINDED_ASC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__REMINDED_DESC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__SENDER_ID_ASC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__SENDER_ID_DESC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__TEXT_ASC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__TEXT_DESC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'NOTIFICATION_EMPLOYEE_BY_NOTIFICATION_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'NOTIFICATION_EMPLOYEE_ID_ASC'
  | 'NOTIFICATION_EMPLOYEE_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ACTIVE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ACTIVE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ANONYMOUS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ANONYMOUS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ARCHIVED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ARCHIVED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__BACKGROUND_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__BACKGROUND_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CHANNEL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CHANNEL_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CLOSE_ACCESS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CLOSE_ACCESS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPANY_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPANY_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPLETED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPLETED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONFIRM_RESULTS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONFIRM_RESULTS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_BACKGROUND_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_BACKGROUND_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_TEXT_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_TEXT_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_AT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_AT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_FROM_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_FROM_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DATE_FORMAT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DATE_FORMAT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEADLINE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEADLINE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_DIRECT_MANAGER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_DIRECT_MANAGER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_GROUP_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_GROUP_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_USER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_USER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEPARTMENT_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEPARTMENT_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DISABLE_2FA_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DISABLE_2FA_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_BODY_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_BODY_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_SUBJECT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_SUBJECT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMPLOYEE_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMPLOYEE_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FALLBACK_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FALLBACK_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_SIZE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_SIZE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_URL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_URL_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LINK_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LINK_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOCALE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOCALE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_WIDTH_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_WIDTH_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__MANAGER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__MANAGER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NEXT_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NEXT_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ORDER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ORDER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_ENABLED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_ENABLED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREDECESSOR_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREDECESSOR_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREV_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREV_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PUBLISHED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PUBLISHED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_DIRECT_MANAGER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_DIRECT_MANAGER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_GROUP_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_GROUP_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DAYS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DAYS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESPONSIBLE_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESPONSIBLE_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESULT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESULT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__SMS_BODY_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__SMS_BODY_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__START_DATE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__START_DATE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEMPLATE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEMPLATE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEXT_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEXT_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CONTENT_COLORS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CONTENT_COLORS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CUSTOM_LINK_BUTTON_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CUSTOM_LINK_BUTTON_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_LEADER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_LEADER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_WORK_EMAIL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_WORK_EMAIL_DESC'
  | 'PREBOARDING_ID_ASC'
  | 'PREBOARDING_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_ASC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_DESC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_ASC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_DESC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_DESC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__NAME_ASC'
  | 'PROCESS_BY_PROCESS_ID__NAME_DESC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_ASC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_DESC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_DESC'
  | 'PROCESS_ID_ASC'
  | 'PROCESS_ID_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__ACQUISITION_DATE_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__ACQUISITION_DATE_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__ACTIVE_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__ACTIVE_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__ASSIGNED_USER_DEPARTMENTS_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__ASSIGNED_USER_DEPARTMENTS_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__ASSIGNED_USER_ID_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__ASSIGNED_USER_ID_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__COMPANY_ID_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__COMPANY_ID_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__CREATED_AT_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__CREATED_AT_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__DEPARTMENT_ID_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__DEPARTMENT_ID_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__DESCRIPTION_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__DESCRIPTION_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__ID_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__ID_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__NAME_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__NAME_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__OCCUPIED_BY_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__OCCUPIED_BY_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__PRODUCT_TYPE_ID_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__PRODUCT_TYPE_ID_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__PURCHASE_DATE_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__PURCHASE_DATE_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__SEARCH_TERMS_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__SEARCH_TERMS_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__SERIAL_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__SERIAL_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__UPDATED_AT_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__UPDATED_AT_DESC'
  | 'PRODUCT_BY_PRODUCT_ID__USER_ID_ASC'
  | 'PRODUCT_BY_PRODUCT_ID__USER_ID_DESC'
  | 'PRODUCT_ID_ASC'
  | 'PRODUCT_ID_DESC'
  | 'RECIPIENT_USER_ID_ASC'
  | 'RECIPIENT_USER_ID_DESC'
  | 'STORAGE_BY_FILE_ID__ACCESS_ASC'
  | 'STORAGE_BY_FILE_ID__ACCESS_DESC'
  | 'STORAGE_BY_FILE_ID__ACTIVE_ASC'
  | 'STORAGE_BY_FILE_ID__ACTIVE_DESC'
  | 'STORAGE_BY_FILE_ID__BELONGS_TO_LEADER_ASC'
  | 'STORAGE_BY_FILE_ID__BELONGS_TO_LEADER_DESC'
  | 'STORAGE_BY_FILE_ID__COMPANY_ID_ASC'
  | 'STORAGE_BY_FILE_ID__COMPANY_ID_DESC'
  | 'STORAGE_BY_FILE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_FILE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_FILE_ID__CREATED_AT_ASC'
  | 'STORAGE_BY_FILE_ID__CREATED_AT_DESC'
  | 'STORAGE_BY_FILE_ID__DELETE_AT_ASC'
  | 'STORAGE_BY_FILE_ID__DELETE_AT_DESC'
  | 'STORAGE_BY_FILE_ID__DEPARTMENTS_ASC'
  | 'STORAGE_BY_FILE_ID__DEPARTMENTS_DESC'
  | 'STORAGE_BY_FILE_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'STORAGE_BY_FILE_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_FOLDER_ID_ASC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_FOLDER_ID_DESC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_TEMPLATE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_TEMPLATE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_TYPE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__DOCUMENT_TYPE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__EMPLOYEE_CASEFILE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__EMPLOYEE_CASEFILE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__EXPIRED_REMINDED_ASC'
  | 'STORAGE_BY_FILE_ID__EXPIRED_REMINDED_DESC'
  | 'STORAGE_BY_FILE_ID__EXPIRE_AT_ASC'
  | 'STORAGE_BY_FILE_ID__EXPIRE_AT_DESC'
  | 'STORAGE_BY_FILE_ID__FILENAME_ASC'
  | 'STORAGE_BY_FILE_ID__FILENAME_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_EXTENSION_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_EXTENSION_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_OWNER_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_OWNER_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_OWNER_ID_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_OWNER_ID_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_SIZE_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_SIZE_DESC'
  | 'STORAGE_BY_FILE_ID__FILE_TYPE_ASC'
  | 'STORAGE_BY_FILE_ID__FILE_TYPE_DESC'
  | 'STORAGE_BY_FILE_ID__FOLDER_DEPARTMENT_IDS_ASC'
  | 'STORAGE_BY_FILE_ID__FOLDER_DEPARTMENT_IDS_DESC'
  | 'STORAGE_BY_FILE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_FILE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_FILE_ID__FOLDER_OWNER_ID_ASC'
  | 'STORAGE_BY_FILE_ID__FOLDER_OWNER_ID_DESC'
  | 'STORAGE_BY_FILE_ID__FOLDER_USER_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_FILE_ID__FOLDER_USER_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_FILE_ID__HTML_ASC'
  | 'STORAGE_BY_FILE_ID__HTML_DESC'
  | 'STORAGE_BY_FILE_ID__ID_ASC'
  | 'STORAGE_BY_FILE_ID__ID_DESC'
  | 'STORAGE_BY_FILE_ID__MIMETYPE_ASC'
  | 'STORAGE_BY_FILE_ID__MIMETYPE_DESC'
  | 'STORAGE_BY_FILE_ID__OWNER_NAME_ASC'
  | 'STORAGE_BY_FILE_ID__OWNER_NAME_DESC'
  | 'STORAGE_BY_FILE_ID__PATH_ASC'
  | 'STORAGE_BY_FILE_ID__PATH_DESC'
  | 'STORAGE_BY_FILE_ID__PENNEO_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_FILE_ID__PENNEO_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_FILE_ID__PLACEHOLDER_VALUES_ASC'
  | 'STORAGE_BY_FILE_ID__PLACEHOLDER_VALUES_DESC'
  | 'STORAGE_BY_FILE_ID__PROCESS_TYPE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__PROCESS_TYPE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__REMINDED_ASC'
  | 'STORAGE_BY_FILE_ID__REMINDED_DESC'
  | 'STORAGE_BY_FILE_ID__REMIND_AT_ASC'
  | 'STORAGE_BY_FILE_ID__REMIND_AT_DESC'
  | 'STORAGE_BY_FILE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'STORAGE_BY_FILE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'STORAGE_BY_FILE_ID__TEMPLATING_SERVICE_ID_ASC'
  | 'STORAGE_BY_FILE_ID__TEMPLATING_SERVICE_ID_DESC'
  | 'STORAGE_BY_FILE_ID__USERS_RESPONSIBLE_ASC'
  | 'STORAGE_BY_FILE_ID__USERS_RESPONSIBLE_DESC'
  | 'STORAGE_BY_FILE_ID__USERS_SHARED_WITH_ASC'
  | 'STORAGE_BY_FILE_ID__USERS_SHARED_WITH_DEPARTMENTS_ASC'
  | 'STORAGE_BY_FILE_ID__USERS_SHARED_WITH_DEPARTMENTS_DESC'
  | 'STORAGE_BY_FILE_ID__USERS_SHARED_WITH_DESC'
  | 'TASK_BY_TASK_ID__ACTIVE_ASC'
  | 'TASK_BY_TASK_ID__ACTIVE_DESC'
  | 'TASK_BY_TASK_ID__ARCHIVED_ASC'
  | 'TASK_BY_TASK_ID__ARCHIVED_DESC'
  | 'TASK_BY_TASK_ID__ASSIGNED_PROCESS_USER_ID_ASC'
  | 'TASK_BY_TASK_ID__ASSIGNED_PROCESS_USER_ID_DESC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_FROM_ASC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_FROM_DESC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_ORGANIZER_ID_ASC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_ORGANIZER_ID_DESC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_REVISIONS_ASC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_REVISIONS_DESC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_TO_ASC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_TO_DESC'
  | 'TASK_BY_TASK_ID__COMPANY_ID_ASC'
  | 'TASK_BY_TASK_ID__COMPANY_ID_DESC'
  | 'TASK_BY_TASK_ID__COMPLETED_ASC'
  | 'TASK_BY_TASK_ID__COMPLETED_AT_ASC'
  | 'TASK_BY_TASK_ID__COMPLETED_AT_DESC'
  | 'TASK_BY_TASK_ID__COMPLETED_BY_ASC'
  | 'TASK_BY_TASK_ID__COMPLETED_BY_DESC'
  | 'TASK_BY_TASK_ID__COMPLETED_DESC'
  | 'TASK_BY_TASK_ID__COMPLETED_REMINDED_ASC'
  | 'TASK_BY_TASK_ID__COMPLETED_REMINDED_DESC'
  | 'TASK_BY_TASK_ID__CREATED_AT_ASC'
  | 'TASK_BY_TASK_ID__CREATED_AT_DESC'
  | 'TASK_BY_TASK_ID__CREATED_BY_ASC'
  | 'TASK_BY_TASK_ID__CREATED_BY_DESC'
  | 'TASK_BY_TASK_ID__DEADLINE_REMINDED_ASC'
  | 'TASK_BY_TASK_ID__DEADLINE_REMINDED_DESC'
  | 'TASK_BY_TASK_ID__DEADLINE_REMINDER_DATE_ASC'
  | 'TASK_BY_TASK_ID__DEADLINE_REMINDER_DATE_DESC'
  | 'TASK_BY_TASK_ID__DEPARTMENTS_ASC'
  | 'TASK_BY_TASK_ID__DEPARTMENTS_DESC'
  | 'TASK_BY_TASK_ID__END_DATE_ASC'
  | 'TASK_BY_TASK_ID__END_DATE_DESC'
  | 'TASK_BY_TASK_ID__ID_ASC'
  | 'TASK_BY_TASK_ID__ID_DESC'
  | 'TASK_BY_TASK_ID__NAME_ASC'
  | 'TASK_BY_TASK_ID__NAME_DESC'
  | 'TASK_BY_TASK_ID__NOTES_ASC'
  | 'TASK_BY_TASK_ID__NOTES_DESC'
  | 'TASK_BY_TASK_ID__ORDER_ASC'
  | 'TASK_BY_TASK_ID__ORDER_DESC'
  | 'TASK_BY_TASK_ID__PARENT_TASK_ID_ASC'
  | 'TASK_BY_TASK_ID__PARENT_TASK_ID_DESC'
  | 'TASK_BY_TASK_ID__PROCESS_ID_ASC'
  | 'TASK_BY_TASK_ID__PROCESS_ID_DESC'
  | 'TASK_BY_TASK_ID__PROCESS_TYPE_ID_ASC'
  | 'TASK_BY_TASK_ID__PROCESS_TYPE_ID_DESC'
  | 'TASK_BY_TASK_ID__PROJECT_ID_ASC'
  | 'TASK_BY_TASK_ID__PROJECT_ID_DESC'
  | 'TASK_BY_TASK_ID__START_DATE_ASC'
  | 'TASK_BY_TASK_ID__START_DATE_DESC'
  | 'TASK_BY_TASK_ID__START_REMINDED_ASC'
  | 'TASK_BY_TASK_ID__START_REMINDED_DESC'
  | 'TASK_BY_TASK_ID__UPDATED_AT_ASC'
  | 'TASK_BY_TASK_ID__UPDATED_AT_DESC'
  | 'TASK_BY_TASK_ID__USER_IDS_ASC'
  | 'TASK_BY_TASK_ID__USER_IDS_DESC'
  | 'TASK_ID_ASC'
  | 'TASK_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__ACTIVE_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__ACTIVE_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CALENDAR_EVENT_FROM_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CALENDAR_EVENT_FROM_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CALENDAR_EVENT_ORGANIZER_ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CALENDAR_EVENT_ORGANIZER_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CALENDAR_EVENT_TO_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CALENDAR_EVENT_TO_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__COMPANY_ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__COMPANY_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CREATED_AT_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CREATED_AT_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__DEADLINE_REMINDER_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__DEADLINE_REMINDER_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__DEPARTMENTS_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__DEPARTMENTS_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__DURATION_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__DURATION_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_RESPONSIBLES_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_RESPONSIBLES_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_DIRECT_MANAGER_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_DIRECT_MANAGER_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_DIRECT_MANAGER_RESPONSIBLE_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_DIRECT_MANAGER_RESPONSIBLE_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_EMPLOYEE_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_EMPLOYEE_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_EMPLOYEE_RESPONSIBLE_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_EMPLOYEE_RESPONSIBLE_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_GROUPS_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_GROUPS_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_GROUPS_RESPONSIBLES_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_GROUPS_RESPONSIBLES_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__NAME_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__NAME_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__NOTES_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__NOTES_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__ORDER_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__ORDER_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PARENT_TASK_ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PARENT_TASK_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PROCESS_ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PROCESS_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PROCESS_TYPE_ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PROCESS_TYPE_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PROJECT_ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PROJECT_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__START_DAY_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__START_DAY_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__UPDATED_AT_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__UPDATED_AT_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__USE_CALENDAR_EVENT_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__USE_CALENDAR_EVENT_DESC'
  | 'TASK_TEMPLATE_ID_ASC'
  | 'TASK_TEMPLATE_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__ACTIVE_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__ACTIVE_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__APPROVAL_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__APPROVAL_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__COMPANY_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__COMPANY_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__DEPARTMENT_IDS_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__DEPARTMENT_IDS_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__END_DATE_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__END_DATE_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__NOTE_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__NOTE_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__START_DATE_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__START_DATE_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__TIME_REGISTRATION_PRESENCE_TYPE_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__TIME_REGISTRATION_PRESENCE_TYPE_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__UNPAID_BREAK_TIME_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__UNPAID_BREAK_TIME_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__USER_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__USER_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_ID_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__ACTIVE_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__ACTIVE_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__ADDRESS_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__ADDRESS_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__CITY_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__CITY_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__CPR_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__CPR_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__EMAIL_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__EMAIL_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__GODMODE_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__GODMODE_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__ID_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__ID_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__INITIALS_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__INITIALS_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__MOBILE_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__MOBILE_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__PHONE_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__PHONE_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_RECIPIENT_USER_ID__SENIORITY_ASC'
  | 'USER_BY_RECIPIENT_USER_ID__SENIORITY_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__ACTIVE_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__ACTIVE_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__ADDED_DATE_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__ADDED_DATE_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__COMPANY_ID_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__COMPANY_ID_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__COMPETENCE_ID_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__COMPETENCE_ID_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__COURSE_REQUESTED_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__COURSE_REQUESTED_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__DEPARTMENT_IDS_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__DEPARTMENT_IDS_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__EXPIRE_AT_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__EXPIRE_AT_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__ID_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__ID_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__MANAGER_EVALUATION_DATE_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__MANAGER_EVALUATION_DATE_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__MANAGER_NEXT_UPDATE_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__MANAGER_NEXT_UPDATE_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__REMINDED_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__REMINDED_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__USER_ID_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__USER_ID_DESC'
  | 'USER_COMPETENCE_ID_ASC'
  | 'USER_COMPETENCE_ID_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__ABSENCE_CODE_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__ABSENCE_CODE_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__ACTIVE_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__ACTIVE_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__APPROVER_FORM_FIELD_IDS_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__APPROVER_FORM_FIELD_IDS_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__APPROVER_GROUP_IDS_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__APPROVER_GROUP_IDS_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__APPROVER_USER_IDS_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__APPROVER_USER_IDS_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__COLOR_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__COLOR_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__COMPANY_ID_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__COMPANY_ID_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__DESCRIPTION_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__DESCRIPTION_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__EMOJI_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__EMOJI_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__ID_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__ID_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__MUST_BE_APPROVED_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__MUST_BE_APPROVED_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__NAME_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__NAME_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__QUICK_ACTION_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__QUICK_ACTION_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__SEND_CALENDAR_INVITE_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__SEND_CALENDAR_INVITE_DESC'
  | 'VACATION_TYPE_ID_ASC'
  | 'VACATION_TYPE_ID_DESC'
  | 'VACATION_USER_BY_VACATION_USER_ID__ACTIVE_ASC'
  | 'VACATION_USER_BY_VACATION_USER_ID__ACTIVE_DESC'
  | 'VACATION_USER_BY_VACATION_USER_ID__ALL_DAY_ASC'
  | 'VACATION_USER_BY_VACATION_USER_ID__ALL_DAY_DESC'
  | 'VACATION_USER_BY_VACATION_USER_ID__APPROVAL_ID_ASC'
  | 'VACATION_USER_BY_VACATION_USER_ID__APPROVAL_ID_DESC'
  | 'VACATION_USER_BY_VACATION_USER_ID__CALENDAR_EVENT_REVISIONS_ASC'
  | 'VACATION_USER_BY_VACATION_USER_ID__CALENDAR_EVENT_REVISIONS_DESC'
  | 'VACATION_USER_BY_VACATION_USER_ID__COMPANY_ID_ASC'
  | 'VACATION_USER_BY_VACATION_USER_ID__COMPANY_ID_DESC'
  | 'VACATION_USER_BY_VACATION_USER_ID__CREATOR_USER_ID_ASC'
  | 'VACATION_USER_BY_VACATION_USER_ID__CREATOR_USER_ID_DESC'
  | 'VACATION_USER_BY_VACATION_USER_ID__CUSTOM_ID_ASC'
  | 'VACATION_USER_BY_VACATION_USER_ID__CUSTOM_ID_DESC'
  | 'VACATION_USER_BY_VACATION_USER_ID__DELETION_APPROVAL_ID_ASC'
  | 'VACATION_USER_BY_VACATION_USER_ID__DELETION_APPROVAL_ID_DESC'
  | 'VACATION_USER_BY_VACATION_USER_ID__DEPARTMENT_IDS_ASC'
  | 'VACATION_USER_BY_VACATION_USER_ID__DEPARTMENT_IDS_DESC'
  | 'VACATION_USER_BY_VACATION_USER_ID__DURATION_DAYS_ASC'
  | 'VACATION_USER_BY_VACATION_USER_ID__DURATION_DAYS_DESC'
  | 'VACATION_USER_BY_VACATION_USER_ID__END_DATE_ASC'
  | 'VACATION_USER_BY_VACATION_USER_ID__END_DATE_DESC'
  | 'VACATION_USER_BY_VACATION_USER_ID__ID_ASC'
  | 'VACATION_USER_BY_VACATION_USER_ID__ID_DESC'
  | 'VACATION_USER_BY_VACATION_USER_ID__NOTE_ASC'
  | 'VACATION_USER_BY_VACATION_USER_ID__NOTE_DESC'
  | 'VACATION_USER_BY_VACATION_USER_ID__START_DATE_ASC'
  | 'VACATION_USER_BY_VACATION_USER_ID__START_DATE_DESC'
  | 'VACATION_USER_BY_VACATION_USER_ID__USER_ID_ASC'
  | 'VACATION_USER_BY_VACATION_USER_ID__USER_ID_DESC'
  | 'VACATION_USER_BY_VACATION_USER_ID__VACATION_TYPE_ID_ASC'
  | 'VACATION_USER_BY_VACATION_USER_ID__VACATION_TYPE_ID_DESC'
  | 'VACATION_USER_ID_ASC'
  | 'VACATION_USER_ID_DESC';

/** The `notificationEmployee` to be created by this mutation. */
export type NotificationEmployeeSenderIdForeignConnectionNotificationEmployeeCreateInput = {
  company?: InputMaybe<NotificationEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<NotificationEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  localeOverride?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<NotificationEmployeeNotificationIdForeignInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInverseInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  parentReference?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  read?: InputMaybe<Scalars['Boolean']>;
  readTime?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `notificationEmployee` in the `EmployeeInput` mutation. */
export type NotificationEmployeeSenderIdForeignInverseInput = {
  /** The primary key(s) for `notificationEmployee` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationEmployeeNotificationEmployeePkeyConnect>>;
  /** A `NotificationEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationEmployeeSenderIdForeignConnectionNotificationEmployeeCreateInput>>;
  /** The primary key(s) for `notificationEmployee` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<NotificationEmployeeNotificationEmployeePkeyDelete>>;
  /** Flag indicating whether all other `notificationEmployee` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationEmployee` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationEmployeeOnNotificationEmployeeForNotificationEmployeeSenderIdForeignUsingNotificationEmployeePkeyUpdate>>;
};

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type NotificationEmployeeToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

/** A connection to a list of `NotificationEmployee` values. */
export type NotificationEmployeesConnection = {
  __typename?: 'NotificationEmployeesConnection';
  /** A list of edges which contains the `NotificationEmployee` and cursor to aid in pagination. */
  edges: Array<NotificationEmployeesEdge>;
  /** A list of `NotificationEmployee` objects. */
  nodes: Array<Maybe<NotificationEmployee>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NotificationEmployee` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `NotificationEmployee` edge in the connection. */
export type NotificationEmployeesEdge = {
  __typename?: 'NotificationEmployeesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `NotificationEmployee` at the end of the edge. */
  node?: Maybe<NotificationEmployee>;
};

/** Methods to use when ordering `NotificationEmployee`. */
export type NotificationEmployeesOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__ID_ASC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__ID_DESC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_RECIPIENT_ID__USER_ID_DESC'
  | 'EMPLOYEE_BY_SENDER_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_SENDER_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_SENDER_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_SENDER_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_SENDER_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_SENDER_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_SENDER_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_SENDER_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_SENDER_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_SENDER_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_SENDER_ID__ID_ASC'
  | 'EMPLOYEE_BY_SENDER_ID__ID_DESC'
  | 'EMPLOYEE_BY_SENDER_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_SENDER_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_SENDER_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_SENDER_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_SENDER_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_SENDER_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_SENDER_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_SENDER_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_SENDER_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_SENDER_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_SENDER_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_SENDER_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALE_OVERRIDE_ASC'
  | 'LOCALE_OVERRIDE_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__ACTIVE_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__ACTIVE_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__COMPANY_ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__COMPANY_ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__CREATED_AT_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__CREATED_AT_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__EMAIL_SUBJECT_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__EMAIL_SUBJECT_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__HOOK_ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__HOOK_ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__METADATA_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__METADATA_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__NOTIFICATION_TYPE_ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__NOTIFICATION_TYPE_ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__PREBOARDING_ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__PREBOARDING_ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__RECIPIENT_TYPE_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__RECIPIENT_TYPE_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__TEXT_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__TEXT_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__UPDATED_AT_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__UPDATED_AT_DESC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_NOTIFICATION_EMPLOYEE_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_NOTIFICATION_EMPLOYEE_ID__COUNT_DESC'
  | 'NOTIFICATION_ID_ASC'
  | 'NOTIFICATION_ID_DESC'
  | 'PARENT_REFERENCE_ASC'
  | 'PARENT_REFERENCE_DESC'
  | 'PLACEHOLDER_VALUES_ASC'
  | 'PLACEHOLDER_VALUES_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'READ_ASC'
  | 'READ_DESC'
  | 'READ_TIME_ASC'
  | 'READ_TIME_DESC'
  | 'RECIPIENT_ID_ASC'
  | 'RECIPIENT_ID_DESC'
  | 'REMINDED_ASC'
  | 'REMINDED_DESC'
  | 'SENDER_ID_ASC'
  | 'SENDER_ID_DESC'
  | 'TEXT_ASC'
  | 'TEXT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** A filter to be used against `Notification` object types. All fields are combined with a logical ‘and.’ */
export type NotificationFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NotificationFilter>>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `emailSubject` field. */
  emailSubject?: InputMaybe<StringFilter>;
  /** Filter by the object’s `hook` relation. */
  hook?: InputMaybe<HookFilter>;
  /** Filter by the object’s `hookId` field. */
  hookId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `hookName` field. */
  hookName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedText` field. */
  localizedText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NotificationFilter>;
  /** Filter by the object’s `notificationCustomEmployeeFieldRecipients` relation. */
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationToManyNotificationCustomEmployeeFieldRecipientFilter>;
  /** Some related `notificationCustomEmployeeFieldRecipients` exist. */
  notificationCustomEmployeeFieldRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `notificationCustomRecipients` relation. */
  notificationCustomRecipients?: InputMaybe<NotificationToManyNotificationCustomRecipientFilter>;
  /** Some related `notificationCustomRecipients` exist. */
  notificationCustomRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `notificationEmployees` relation. */
  notificationEmployees?: InputMaybe<NotificationToManyNotificationEmployeeFilter>;
  /** Some related `notificationEmployees` exist. */
  notificationEmployeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `notificationGroupRecipients` relation. */
  notificationGroupRecipients?: InputMaybe<NotificationToManyNotificationGroupRecipientFilter>;
  /** Some related `notificationGroupRecipients` exist. */
  notificationGroupRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `notificationType` relation. */
  notificationType?: InputMaybe<NotificationTypeFilter>;
  /** Filter by the object’s `notificationTypeId` field. */
  notificationTypeId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NotificationFilter>>;
  /** Filter by the object’s `preboarding` relation. */
  preboarding?: InputMaybe<PreboardingFilter>;
  /** A related `preboarding` exists. */
  preboardingExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingId` field. */
  preboardingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `recipientType` field. */
  recipientType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `text` field. */
  text?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type NotificationGroupRecipient = {
  __typename?: 'NotificationGroupRecipient';
  /** Reads a single `Company` that is related to this `NotificationGroupRecipient`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `Group` that is related to this `NotificationGroupRecipient`. */
  group?: Maybe<Group>;
  groupId: Scalars['UUID'];
  /** Reads a single `Notification` that is related to this `NotificationGroupRecipient`. */
  notification?: Maybe<Notification>;
  notificationId: Scalars['UUID'];
};

/** The `notificationGroupRecipient` to be created by this mutation. */
export type NotificationGroupRecipientCompanyIdFkeyConnectionNotificationGroupRecipientCreateInput = {
  company?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInput>;
  group?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `NotificationGroupRecipientInput` mutation. */
export type NotificationGroupRecipientCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnNotificationGroupRecipientForNotificationGroupRecipientCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `notificationGroupRecipient` in the `CompanyInput` mutation. */
export type NotificationGroupRecipientCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `notificationGroupRecipient` for the far side of the relationship. */
  connectByNotificationIdAndGroupId?: InputMaybe<Array<NotificationGroupRecipientNotificationGroupRecipientPkeyConnect>>;
  /** A `NotificationGroupRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationGroupRecipientCompanyIdFkeyConnectionNotificationGroupRecipientCreateInput>>;
  /** The primary key(s) for `notificationGroupRecipient` for the far side of the relationship. */
  deleteByNotificationIdAndGroupId?: InputMaybe<Array<NotificationGroupRecipientNotificationGroupRecipientPkeyDelete>>;
  /** Flag indicating whether all other `notificationGroupRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationGroupRecipient` for the far side of the relationship. */
  updateByNotificationIdAndGroupId?: InputMaybe<Array<NotificationGroupRecipientOnNotificationGroupRecipientForNotificationGroupRecipientCompanyIdFkeyUsingNotificationGroupRecipientPkeyUpdate>>;
};

/**
 * A condition to be used against `NotificationGroupRecipient` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type NotificationGroupRecipientCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `notificationId` field. */
  notificationId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `NotificationGroupRecipient` object types. All fields are combined with a logical ‘and.’ */
export type NotificationGroupRecipientFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NotificationGroupRecipientFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `group` relation. */
  group?: InputMaybe<GroupFilter>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NotificationGroupRecipientFilter>;
  /** Filter by the object’s `notification` relation. */
  notification?: InputMaybe<NotificationFilter>;
  /** Filter by the object’s `notificationId` field. */
  notificationId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NotificationGroupRecipientFilter>>;
};

/** The `group` to be created by this mutation. */
export type NotificationGroupRecipientGroupIdFkeyConnectionGroupCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppTableGroupIdFkInverseInput>;
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  autoInherit?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  copyFromGroupId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientGroupIdForeignInverseInput>;
  scope?: InputMaybe<RoleScope>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupGroupIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupGroupIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupGroupIdForeignInverseInput>;
};

/** The `notificationGroupRecipient` to be created by this mutation. */
export type NotificationGroupRecipientGroupIdFkeyConnectionNotificationGroupRecipientCreateInput = {
  company?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInput>;
  notification?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `group` in the `NotificationGroupRecipientInput` mutation. */
export type NotificationGroupRecipientGroupIdFkeyInput = {
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectById?: InputMaybe<GroupGroupPkeyConnect>;
  /** A `GroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationGroupRecipientGroupIdFkeyConnectionGroupCreateInput>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateById?: InputMaybe<GroupOnNotificationGroupRecipientForNotificationGroupRecipientGroupIdFkeyUsingGroupPkeyUpdate>;
};

/** Input for the nested mutation of `notificationGroupRecipient` in the `GroupInput` mutation. */
export type NotificationGroupRecipientGroupIdFkeyInverseInput = {
  /** The primary key(s) for `notificationGroupRecipient` for the far side of the relationship. */
  connectByNotificationIdAndGroupId?: InputMaybe<Array<NotificationGroupRecipientNotificationGroupRecipientPkeyConnect>>;
  /** A `NotificationGroupRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationGroupRecipientGroupIdFkeyConnectionNotificationGroupRecipientCreateInput>>;
  /** The primary key(s) for `notificationGroupRecipient` for the far side of the relationship. */
  deleteByNotificationIdAndGroupId?: InputMaybe<Array<NotificationGroupRecipientNotificationGroupRecipientPkeyDelete>>;
  /** Flag indicating whether all other `notificationGroupRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationGroupRecipient` for the far side of the relationship. */
  updateByNotificationIdAndGroupId?: InputMaybe<Array<NotificationGroupRecipientOnNotificationGroupRecipientForNotificationGroupRecipientGroupIdFkeyUsingNotificationGroupRecipientPkeyUpdate>>;
};

/** An input for mutations affecting `NotificationGroupRecipient` */
export type NotificationGroupRecipientInput = {
  company?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `notificationGroupRecipient` to look up the row to connect. */
export type NotificationGroupRecipientNotificationGroupRecipientPkeyConnect = {
  groupId: Scalars['UUID'];
  notificationId: Scalars['UUID'];
};

/** The fields on `notificationGroupRecipient` to look up the row to delete. */
export type NotificationGroupRecipientNotificationGroupRecipientPkeyDelete = {
  groupId: Scalars['UUID'];
  notificationId: Scalars['UUID'];
};

/** The `notification` to be created by this mutation. */
export type NotificationGroupRecipientNotificationIdFkeyConnectionNotificationCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  customRecipientEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  emailSubject?: InputMaybe<Scalars['String']>;
  hook?: InputMaybe<NotificationHookIdForeignInput>;
  hookId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeNotificationIdForeignInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInverseInput>;
  notificationType?: InputMaybe<NotificationNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
  permissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<NotificationPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  recipientType?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `notificationGroupRecipient` to be created by this mutation. */
export type NotificationGroupRecipientNotificationIdFkeyConnectionNotificationGroupRecipientCreateInput = {
  company?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInput>;
};

/** Input for the nested mutation of `notification` in the `NotificationGroupRecipientInput` mutation. */
export type NotificationGroupRecipientNotificationIdFkeyInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<NotificationNotificationPkeyConnect>;
  /** A `NotificationInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyConnectionNotificationCreateInput>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<NotificationOnNotificationGroupRecipientForNotificationGroupRecipientNotificationIdFkeyUsingNotificationPkeyUpdate>;
};

/** Input for the nested mutation of `notificationGroupRecipient` in the `NotificationInput` mutation. */
export type NotificationGroupRecipientNotificationIdFkeyInverseInput = {
  /** The primary key(s) for `notificationGroupRecipient` for the far side of the relationship. */
  connectByNotificationIdAndGroupId?: InputMaybe<Array<NotificationGroupRecipientNotificationGroupRecipientPkeyConnect>>;
  /** A `NotificationGroupRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationGroupRecipientNotificationIdFkeyConnectionNotificationGroupRecipientCreateInput>>;
  /** The primary key(s) for `notificationGroupRecipient` for the far side of the relationship. */
  deleteByNotificationIdAndGroupId?: InputMaybe<Array<NotificationGroupRecipientNotificationGroupRecipientPkeyDelete>>;
  /** Flag indicating whether all other `notificationGroupRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationGroupRecipient` for the far side of the relationship. */
  updateByNotificationIdAndGroupId?: InputMaybe<Array<NotificationGroupRecipientOnNotificationGroupRecipientForNotificationGroupRecipientNotificationIdFkeyUsingNotificationGroupRecipientPkeyUpdate>>;
};

/** The fields on `notificationGroupRecipient` to look up the row to update. */
export type NotificationGroupRecipientOnNotificationGroupRecipientForNotificationGroupRecipientCompanyIdFkeyUsingNotificationGroupRecipientPkeyUpdate = {
  groupId: Scalars['UUID'];
  notificationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationGroupRecipient` being updated. */
  patch: UpdateNotificationGroupRecipientOnNotificationGroupRecipientForNotificationGroupRecipientCompanyIdFkeyPatch;
};

/** The fields on `notificationGroupRecipient` to look up the row to update. */
export type NotificationGroupRecipientOnNotificationGroupRecipientForNotificationGroupRecipientGroupIdFkeyUsingNotificationGroupRecipientPkeyUpdate = {
  groupId: Scalars['UUID'];
  notificationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationGroupRecipient` being updated. */
  patch: UpdateNotificationGroupRecipientOnNotificationGroupRecipientForNotificationGroupRecipientGroupIdFkeyPatch;
};

/** The fields on `notificationGroupRecipient` to look up the row to update. */
export type NotificationGroupRecipientOnNotificationGroupRecipientForNotificationGroupRecipientNotificationIdFkeyUsingNotificationGroupRecipientPkeyUpdate = {
  groupId: Scalars['UUID'];
  notificationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationGroupRecipient` being updated. */
  patch: UpdateNotificationGroupRecipientOnNotificationGroupRecipientForNotificationGroupRecipientNotificationIdFkeyPatch;
};

/** Represents an update to a `NotificationGroupRecipient`. Fields that are set will be updated. */
export type NotificationGroupRecipientPatch = {
  company?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `NotificationGroupRecipient` values. */
export type NotificationGroupRecipientsConnection = {
  __typename?: 'NotificationGroupRecipientsConnection';
  /** A list of edges which contains the `NotificationGroupRecipient` and cursor to aid in pagination. */
  edges: Array<NotificationGroupRecipientsEdge>;
  /** A list of `NotificationGroupRecipient` objects. */
  nodes: Array<Maybe<NotificationGroupRecipient>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NotificationGroupRecipient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `NotificationGroupRecipient` edge in the connection. */
export type NotificationGroupRecipientsEdge = {
  __typename?: 'NotificationGroupRecipientsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `NotificationGroupRecipient` at the end of the edge. */
  node?: Maybe<NotificationGroupRecipient>;
};

/** Methods to use when ordering `NotificationGroupRecipient`. */
export type NotificationGroupRecipientsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'GROUP_BY_GROUP_ID__ACTIVE_ASC'
  | 'GROUP_BY_GROUP_ID__ACTIVE_DESC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_ASC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_DESC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_NEW_PERMISSIONS_ASC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_NEW_PERMISSIONS_DESC'
  | 'GROUP_BY_GROUP_ID__AUTO_INHERIT_ASC'
  | 'GROUP_BY_GROUP_ID__AUTO_INHERIT_DESC'
  | 'GROUP_BY_GROUP_ID__COMPANY_ID_ASC'
  | 'GROUP_BY_GROUP_ID__COMPANY_ID_DESC'
  | 'GROUP_BY_GROUP_ID__DESCRIPTION_ASC'
  | 'GROUP_BY_GROUP_ID__DESCRIPTION_DESC'
  | 'GROUP_BY_GROUP_ID__ID_ASC'
  | 'GROUP_BY_GROUP_ID__ID_DESC'
  | 'GROUP_BY_GROUP_ID__LOCALIZED_NAME_ASC'
  | 'GROUP_BY_GROUP_ID__LOCALIZED_NAME_DESC'
  | 'GROUP_BY_GROUP_ID__NAME_ASC'
  | 'GROUP_BY_GROUP_ID__NAME_DESC'
  | 'GROUP_BY_GROUP_ID__SCOPE_ASC'
  | 'GROUP_BY_GROUP_ID__SCOPE_DESC'
  | 'GROUP_ID_ASC'
  | 'GROUP_ID_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__ACTIVE_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__ACTIVE_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__COMPANY_ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__COMPANY_ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__CREATED_AT_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__CREATED_AT_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__EMAIL_SUBJECT_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__EMAIL_SUBJECT_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__HOOK_ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__HOOK_ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__METADATA_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__METADATA_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__NOTIFICATION_TYPE_ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__NOTIFICATION_TYPE_ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__PREBOARDING_ID_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__PREBOARDING_ID_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__RECIPIENT_TYPE_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__RECIPIENT_TYPE_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__TEXT_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__TEXT_DESC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__UPDATED_AT_ASC'
  | 'NOTIFICATION_BY_NOTIFICATION_ID__UPDATED_AT_DESC'
  | 'NOTIFICATION_ID_ASC'
  | 'NOTIFICATION_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/** The `notification` to be created by this mutation. */
export type NotificationHookIdForeignConnectionNotificationCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  customRecipientEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  emailSubject?: InputMaybe<Scalars['String']>;
  hook?: InputMaybe<NotificationHookIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeNotificationIdForeignInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInverseInput>;
  notificationType?: InputMaybe<NotificationNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
  permissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<NotificationPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  recipientType?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `hook` in the `NotificationInput` mutation. */
export type NotificationHookIdForeignInput = {
  /** The primary key(s) for `hook` for the far side of the relationship. */
  connectById?: InputMaybe<HookHookPkeyConnect>;
  /** The primary key(s) for `hook` for the far side of the relationship. */
  connectByName?: InputMaybe<HookHookNameUniqueConnect>;
  /** The primary key(s) and patch data for `hook` for the far side of the relationship. */
  updateById?: InputMaybe<HookOnNotificationForNotificationHookIdForeignUsingHookPkeyUpdate>;
  /** The primary key(s) and patch data for `hook` for the far side of the relationship. */
  updateByName?: InputMaybe<HookOnNotificationForNotificationHookIdForeignUsingHookNameUniqueUpdate>;
};

/** Input for the nested mutation of `notification` in the `HookInput` mutation. */
export type NotificationHookIdForeignInverseInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationNotificationPkeyConnect>>;
  /** A `NotificationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationHookIdForeignConnectionNotificationCreateInput>>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationOnNotificationForNotificationHookIdForeignUsingNotificationPkeyUpdate>>;
};

/** An input for mutations affecting `Notification` */
export type NotificationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  customRecipientEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  emailSubject?: InputMaybe<Scalars['String']>;
  hook?: InputMaybe<NotificationHookIdForeignInput>;
  hookId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeNotificationIdForeignInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInverseInput>;
  notificationType?: InputMaybe<NotificationNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
  permissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<NotificationPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  recipientType?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `notification` to look up the row to connect. */
export type NotificationNotificationPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `notification` to be created by this mutation. */
export type NotificationNotificationTypeIdForeignConnectionNotificationCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  customRecipientEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  emailSubject?: InputMaybe<Scalars['String']>;
  hook?: InputMaybe<NotificationHookIdForeignInput>;
  hookId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeNotificationIdForeignInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInverseInput>;
  notificationType?: InputMaybe<NotificationNotificationTypeIdForeignInput>;
  permissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<NotificationPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  recipientType?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `notificationType` to be created by this mutation. */
export type NotificationNotificationTypeIdForeignConnectionNotificationTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  avoidBundling?: InputMaybe<Scalars['Boolean']>;
  broadcastTime?: InputMaybe<Scalars['Time']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeNotificationTypeIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationNotificationTypeIdForeignInverseInput>;
  timeZone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `notificationType` in the `NotificationInput` mutation. */
export type NotificationNotificationTypeIdForeignInput = {
  /** The primary key(s) for `notificationType` for the far side of the relationship. */
  connectById?: InputMaybe<NotificationTypeNotificationTypePkeyConnect>;
  /** A `NotificationTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationNotificationTypeIdForeignConnectionNotificationTypeCreateInput>;
  /** The primary key(s) and patch data for `notificationType` for the far side of the relationship. */
  updateById?: InputMaybe<NotificationTypeOnNotificationForNotificationNotificationTypeIdForeignUsingNotificationTypePkeyUpdate>;
};

/** Input for the nested mutation of `notification` in the `NotificationTypeInput` mutation. */
export type NotificationNotificationTypeIdForeignInverseInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationNotificationPkeyConnect>>;
  /** A `NotificationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationNotificationTypeIdForeignConnectionNotificationCreateInput>>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationOnNotificationForNotificationNotificationTypeIdForeignUsingNotificationPkeyUpdate>>;
};

/** The fields on `notification` to look up the row to update. */
export type NotificationOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientNotificationIdFoUsingNotificationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notification` being updated. */
  patch: UpdateNotificationOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientNotificationIdFoPatch;
};

/** The fields on `notification` to look up the row to update. */
export type NotificationOnNotificationCustomRecipientForNotificationCustomRecipientNotificationIdFkeyUsingNotificationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notification` being updated. */
  patch: UpdateNotificationOnNotificationCustomRecipientForNotificationCustomRecipientNotificationIdFkeyPatch;
};

/** The fields on `notification` to look up the row to update. */
export type NotificationOnNotificationEmployeeForNotificationEmployeeNotificationIdForeignUsingNotificationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notification` being updated. */
  patch: UpdateNotificationOnNotificationEmployeeForNotificationEmployeeNotificationIdForeignPatch;
};

/** The fields on `notification` to look up the row to update. */
export type NotificationOnNotificationForNotificationHookIdForeignUsingNotificationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notification` being updated. */
  patch: UpdateNotificationOnNotificationForNotificationHookIdForeignPatch;
};

/** The fields on `notification` to look up the row to update. */
export type NotificationOnNotificationForNotificationNotificationTypeIdForeignUsingNotificationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notification` being updated. */
  patch: UpdateNotificationOnNotificationForNotificationNotificationTypeIdForeignPatch;
};

/** The fields on `notification` to look up the row to update. */
export type NotificationOnNotificationForNotificationPreboardingIdForeignUsingNotificationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notification` being updated. */
  patch: UpdateNotificationOnNotificationForNotificationPreboardingIdForeignPatch;
};

/** The fields on `notification` to look up the row to update. */
export type NotificationOnNotificationGroupRecipientForNotificationGroupRecipientNotificationIdFkeyUsingNotificationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notification` being updated. */
  patch: UpdateNotificationOnNotificationGroupRecipientForNotificationGroupRecipientNotificationIdFkeyPatch;
};

/** Represents an update to a `Notification`. Fields that are set will be updated. */
export type NotificationPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  customRecipientEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  emailSubject?: InputMaybe<Scalars['String']>;
  hook?: InputMaybe<NotificationHookIdForeignInput>;
  hookId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeNotificationIdForeignInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInverseInput>;
  notificationType?: InputMaybe<NotificationNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
  permissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<NotificationPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  recipientType?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `notification` to be created by this mutation. */
export type NotificationPreboardingIdForeignConnectionNotificationCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  customRecipientEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  emailSubject?: InputMaybe<Scalars['String']>;
  hook?: InputMaybe<NotificationHookIdForeignInput>;
  hookId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeNotificationIdForeignInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInverseInput>;
  notificationType?: InputMaybe<NotificationNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
  permissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<NotificationPreboardingIdForeignInput>;
  recipientType?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `preboarding` to be created by this mutation. */
export type NotificationPreboardingIdForeignConnectionPreboardingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontStorageId?: InputMaybe<Scalars['UUID']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoStorageId?: InputMaybe<Scalars['UUID']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `preboarding` in the `NotificationInput` mutation. */
export type NotificationPreboardingIdForeignInput = {
  /** The primary key(s) for `preboarding` for the far side of the relationship. */
  connectById?: InputMaybe<PreboardingPreboardingPkeyConnect>;
  /** A `PreboardingInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationPreboardingIdForeignConnectionPreboardingCreateInput>;
  /** The primary key(s) and patch data for `preboarding` for the far side of the relationship. */
  updateById?: InputMaybe<PreboardingOnNotificationForNotificationPreboardingIdForeignUsingPreboardingPkeyUpdate>;
};

/** Input for the nested mutation of `notification` in the `PreboardingInput` mutation. */
export type NotificationPreboardingIdForeignInverseInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationNotificationPkeyConnect>>;
  /** A `NotificationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationPreboardingIdForeignConnectionNotificationCreateInput>>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<Array<NotificationOnNotificationForNotificationPreboardingIdForeignUsingNotificationPkeyUpdate>>;
};

/** All input for the `notificationReadAll` mutation. */
export type NotificationReadAllInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `notificationReadAll` mutation. */
export type NotificationReadAllPayload = {
  __typename?: 'NotificationReadAllPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A filter to be used against many `NotificationCustomEmployeeFieldRecipient` object types. All fields are combined with a logical ‘and.’ */
export type NotificationToManyNotificationCustomEmployeeFieldRecipientFilter = {
  /** Every related `NotificationCustomEmployeeFieldRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationCustomEmployeeFieldRecipientFilter>;
  /** No related `NotificationCustomEmployeeFieldRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationCustomEmployeeFieldRecipientFilter>;
  /** Some related `NotificationCustomEmployeeFieldRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationCustomEmployeeFieldRecipientFilter>;
};

/** A filter to be used against many `NotificationCustomRecipient` object types. All fields are combined with a logical ‘and.’ */
export type NotificationToManyNotificationCustomRecipientFilter = {
  /** Every related `NotificationCustomRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationCustomRecipientFilter>;
  /** No related `NotificationCustomRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationCustomRecipientFilter>;
  /** Some related `NotificationCustomRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationCustomRecipientFilter>;
};

/** A filter to be used against many `NotificationEmployee` object types. All fields are combined with a logical ‘and.’ */
export type NotificationToManyNotificationEmployeeFilter = {
  /** Every related `NotificationEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeFilter>;
  /** No related `NotificationEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeFilter>;
  /** Some related `NotificationEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeFilter>;
};

/** A filter to be used against many `NotificationGroupRecipient` object types. All fields are combined with a logical ‘and.’ */
export type NotificationToManyNotificationGroupRecipientFilter = {
  /** Every related `NotificationGroupRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationGroupRecipientFilter>;
  /** No related `NotificationGroupRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationGroupRecipientFilter>;
  /** Some related `NotificationGroupRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationGroupRecipientFilter>;
};

export type NotificationType = {
  __typename?: 'NotificationType';
  active: Scalars['Boolean'];
  avoidBundling: Scalars['Boolean'];
  broadcastTime?: Maybe<Scalars['Time']>;
  /** Reads and enables pagination through a set of `ChannelType`. */
  channelTypes: ChannelTypesConnection;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `NotificationTypeChannelType`. */
  notificationTypeChannelTypes: NotificationTypeChannelTypesConnection;
  /** Reads and enables pagination through a set of `Notification`. */
  notifications: NotificationsConnection;
  timeZone?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};


export type NotificationTypeChannelTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<ChannelTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type NotificationTypeNotificationTypeChannelTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationTypeChannelTypeCondition>;
  filter?: InputMaybe<NotificationTypeChannelTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationTypeChannelTypesOrderBy>>;
};


export type NotificationTypeNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

export type NotificationTypeChannelType = {
  __typename?: 'NotificationTypeChannelType';
  /** Reads a single `ChannelType` that is related to this `NotificationTypeChannelType`. */
  channelType?: Maybe<ChannelType>;
  channelTypeId: Scalars['UUID'];
  /** Reads a single `Company` that is related to this `NotificationTypeChannelType`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  mandatory: Scalars['Boolean'];
  /** Reads a single `NotificationType` that is related to this `NotificationTypeChannelType`. */
  notificationType?: Maybe<NotificationType>;
  notificationTypeId: Scalars['UUID'];
};

/** The `notificationTypeChannelType` to be created by this mutation. */
export type NotificationTypeChannelTypeChannelTypeIdForeignConnectionNotificationTypeChannelTypeCreateInput = {
  channelType?: InputMaybe<NotificationTypeChannelTypeChannelTypeIdForeignInput>;
  company?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  notificationType?: InputMaybe<NotificationTypeChannelTypeNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `channelType` in the `NotificationTypeChannelTypeInput` mutation. */
export type NotificationTypeChannelTypeChannelTypeIdForeignInput = {
  /** The primary key(s) for `channelType` for the far side of the relationship. */
  connectById?: InputMaybe<ChannelTypeChannelTypePkeyConnect>;
  /** The primary key(s) for `channelType` for the far side of the relationship. */
  connectByName?: InputMaybe<ChannelTypeChannelTypeNameUniqueConnect>;
  /** The primary key(s) and patch data for `channelType` for the far side of the relationship. */
  updateById?: InputMaybe<ChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeChannelTypeIdForeignUsingChannelTypePkeyUpdate>;
  /** The primary key(s) and patch data for `channelType` for the far side of the relationship. */
  updateByName?: InputMaybe<ChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeChannelTypeIdForeignUsingChannelTypeNameUniqueUpdate>;
};

/** Input for the nested mutation of `notificationTypeChannelType` in the `ChannelTypeInput` mutation. */
export type NotificationTypeChannelTypeChannelTypeIdForeignInverseInput = {
  /** The primary key(s) for `notificationTypeChannelType` for the far side of the relationship. */
  connectByNotificationTypeIdAndChannelTypeId?: InputMaybe<Array<NotificationTypeChannelTypeNotificationTypeChannelTypePkeyConnect>>;
  /** A `NotificationTypeChannelTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationTypeChannelTypeChannelTypeIdForeignConnectionNotificationTypeChannelTypeCreateInput>>;
  /** The primary key(s) for `notificationTypeChannelType` for the far side of the relationship. */
  deleteByNotificationTypeIdAndChannelTypeId?: InputMaybe<Array<NotificationTypeChannelTypeNotificationTypeChannelTypePkeyDelete>>;
  /** Flag indicating whether all other `notificationTypeChannelType` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationTypeChannelType` for the far side of the relationship. */
  updateByNotificationTypeIdAndChannelTypeId?: InputMaybe<Array<NotificationTypeChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeChannelTypeIdForeignUsingNotificationTypeChannelTypePkeyUpdate>>;
};

/** The `notificationTypeChannelType` to be created by this mutation. */
export type NotificationTypeChannelTypeCompanyIdFkeyConnectionNotificationTypeChannelTypeCreateInput = {
  channelType?: InputMaybe<NotificationTypeChannelTypeChannelTypeIdForeignInput>;
  channelTypeId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInput>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  notificationType?: InputMaybe<NotificationTypeChannelTypeNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `NotificationTypeChannelTypeInput` mutation. */
export type NotificationTypeChannelTypeCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnNotificationTypeChannelTypeForNotificationTypeChannelTypeCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `notificationTypeChannelType` in the `CompanyInput` mutation. */
export type NotificationTypeChannelTypeCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `notificationTypeChannelType` for the far side of the relationship. */
  connectByNotificationTypeIdAndChannelTypeId?: InputMaybe<Array<NotificationTypeChannelTypeNotificationTypeChannelTypePkeyConnect>>;
  /** A `NotificationTypeChannelTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationTypeChannelTypeCompanyIdFkeyConnectionNotificationTypeChannelTypeCreateInput>>;
  /** The primary key(s) for `notificationTypeChannelType` for the far side of the relationship. */
  deleteByNotificationTypeIdAndChannelTypeId?: InputMaybe<Array<NotificationTypeChannelTypeNotificationTypeChannelTypePkeyDelete>>;
  /** Flag indicating whether all other `notificationTypeChannelType` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationTypeChannelType` for the far side of the relationship. */
  updateByNotificationTypeIdAndChannelTypeId?: InputMaybe<Array<NotificationTypeChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeCompanyIdFkeyUsingNotificationTypeChannelTypePkeyUpdate>>;
};

/**
 * A condition to be used against `NotificationTypeChannelType` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type NotificationTypeChannelTypeCondition = {
  /** Checks for equality with the object’s `channelTypeId` field. */
  channelTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `mandatory` field. */
  mandatory?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `notificationTypeId` field. */
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `NotificationTypeChannelType` object types. All fields are combined with a logical ‘and.’ */
export type NotificationTypeChannelTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NotificationTypeChannelTypeFilter>>;
  /** Filter by the object’s `channelType` relation. */
  channelType?: InputMaybe<ChannelTypeFilter>;
  /** Filter by the object’s `channelTypeId` field. */
  channelTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `mandatory` field. */
  mandatory?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NotificationTypeChannelTypeFilter>;
  /** Filter by the object’s `notificationType` relation. */
  notificationType?: InputMaybe<NotificationTypeFilter>;
  /** Filter by the object’s `notificationTypeId` field. */
  notificationTypeId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NotificationTypeChannelTypeFilter>>;
};

/** An input for mutations affecting `NotificationTypeChannelType` */
export type NotificationTypeChannelTypeInput = {
  channelType?: InputMaybe<NotificationTypeChannelTypeChannelTypeIdForeignInput>;
  channelTypeId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  notificationType?: InputMaybe<NotificationTypeChannelTypeNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `notificationTypeChannelType` to look up the row to connect. */
export type NotificationTypeChannelTypeNotificationTypeChannelTypePkeyConnect = {
  channelTypeId: Scalars['UUID'];
  notificationTypeId: Scalars['UUID'];
};

/** The fields on `notificationTypeChannelType` to look up the row to delete. */
export type NotificationTypeChannelTypeNotificationTypeChannelTypePkeyDelete = {
  channelTypeId: Scalars['UUID'];
  notificationTypeId: Scalars['UUID'];
};

/** The `notificationTypeChannelType` to be created by this mutation. */
export type NotificationTypeChannelTypeNotificationTypeIdForeignConnectionNotificationTypeChannelTypeCreateInput = {
  channelType?: InputMaybe<NotificationTypeChannelTypeChannelTypeIdForeignInput>;
  channelTypeId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  notificationType?: InputMaybe<NotificationTypeChannelTypeNotificationTypeIdForeignInput>;
};

/** The `notificationType` to be created by this mutation. */
export type NotificationTypeChannelTypeNotificationTypeIdForeignConnectionNotificationTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  avoidBundling?: InputMaybe<Scalars['Boolean']>;
  broadcastTime?: InputMaybe<Scalars['Time']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeNotificationTypeIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationNotificationTypeIdForeignInverseInput>;
  timeZone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `notificationType` in the `NotificationTypeChannelTypeInput` mutation. */
export type NotificationTypeChannelTypeNotificationTypeIdForeignInput = {
  /** The primary key(s) for `notificationType` for the far side of the relationship. */
  connectById?: InputMaybe<NotificationTypeNotificationTypePkeyConnect>;
  /** A `NotificationTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationTypeChannelTypeNotificationTypeIdForeignConnectionNotificationTypeCreateInput>;
  /** The primary key(s) and patch data for `notificationType` for the far side of the relationship. */
  updateById?: InputMaybe<NotificationTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeNotificationTypeIdForeignUsingNotificationTypePkeyUpdate>;
};

/** Input for the nested mutation of `notificationTypeChannelType` in the `NotificationTypeInput` mutation. */
export type NotificationTypeChannelTypeNotificationTypeIdForeignInverseInput = {
  /** The primary key(s) for `notificationTypeChannelType` for the far side of the relationship. */
  connectByNotificationTypeIdAndChannelTypeId?: InputMaybe<Array<NotificationTypeChannelTypeNotificationTypeChannelTypePkeyConnect>>;
  /** A `NotificationTypeChannelTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<NotificationTypeChannelTypeNotificationTypeIdForeignConnectionNotificationTypeChannelTypeCreateInput>>;
  /** The primary key(s) for `notificationTypeChannelType` for the far side of the relationship. */
  deleteByNotificationTypeIdAndChannelTypeId?: InputMaybe<Array<NotificationTypeChannelTypeNotificationTypeChannelTypePkeyDelete>>;
  /** Flag indicating whether all other `notificationTypeChannelType` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `notificationTypeChannelType` for the far side of the relationship. */
  updateByNotificationTypeIdAndChannelTypeId?: InputMaybe<Array<NotificationTypeChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeNotificationTypeIdForeignUsingNotificationTypeChannelTypePkeyUpdate>>;
};

/** The fields on `notificationTypeChannelType` to look up the row to update. */
export type NotificationTypeChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeChannelTypeIdForeignUsingNotificationTypeChannelTypePkeyUpdate = {
  channelTypeId: Scalars['UUID'];
  notificationTypeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationTypeChannelType` being updated. */
  patch: UpdateNotificationTypeChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeChannelTypeIdForeignPatch;
};

/** The fields on `notificationTypeChannelType` to look up the row to update. */
export type NotificationTypeChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeCompanyIdFkeyUsingNotificationTypeChannelTypePkeyUpdate = {
  channelTypeId: Scalars['UUID'];
  notificationTypeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationTypeChannelType` being updated. */
  patch: UpdateNotificationTypeChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeCompanyIdFkeyPatch;
};

/** The fields on `notificationTypeChannelType` to look up the row to update. */
export type NotificationTypeChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeNotificationTypeIdForeignUsingNotificationTypeChannelTypePkeyUpdate = {
  channelTypeId: Scalars['UUID'];
  notificationTypeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationTypeChannelType` being updated. */
  patch: UpdateNotificationTypeChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeNotificationTypeIdForeignPatch;
};

/** Represents an update to a `NotificationTypeChannelType`. Fields that are set will be updated. */
export type NotificationTypeChannelTypePatch = {
  channelType?: InputMaybe<NotificationTypeChannelTypeChannelTypeIdForeignInput>;
  channelTypeId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  notificationType?: InputMaybe<NotificationTypeChannelTypeNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `NotificationTypeChannelType` values. */
export type NotificationTypeChannelTypesConnection = {
  __typename?: 'NotificationTypeChannelTypesConnection';
  /** A list of edges which contains the `NotificationTypeChannelType` and cursor to aid in pagination. */
  edges: Array<NotificationTypeChannelTypesEdge>;
  /** A list of `NotificationTypeChannelType` objects. */
  nodes: Array<Maybe<NotificationTypeChannelType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NotificationTypeChannelType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `NotificationTypeChannelType` edge in the connection. */
export type NotificationTypeChannelTypesEdge = {
  __typename?: 'NotificationTypeChannelTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `NotificationTypeChannelType` at the end of the edge. */
  node?: Maybe<NotificationTypeChannelType>;
};

/** Methods to use when ordering `NotificationTypeChannelType`. */
export type NotificationTypeChannelTypesOrderBy =
  | 'CHANNEL_TYPE_BY_CHANNEL_TYPE_ID__ID_ASC'
  | 'CHANNEL_TYPE_BY_CHANNEL_TYPE_ID__ID_DESC'
  | 'CHANNEL_TYPE_BY_CHANNEL_TYPE_ID__NAME_ASC'
  | 'CHANNEL_TYPE_BY_CHANNEL_TYPE_ID__NAME_DESC'
  | 'CHANNEL_TYPE_ID_ASC'
  | 'CHANNEL_TYPE_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'MANDATORY_ASC'
  | 'MANDATORY_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__ACTIVE_ASC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__ACTIVE_DESC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__AVOID_BUNDLING_ASC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__AVOID_BUNDLING_DESC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__BROADCAST_TIME_ASC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__BROADCAST_TIME_DESC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__COMPANY_ID_ASC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__COMPANY_ID_DESC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__CREATED_AT_ASC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__CREATED_AT_DESC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__ID_ASC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__ID_DESC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__NAME_ASC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__NAME_DESC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__TIME_ZONE_ASC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__TIME_ZONE_DESC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__UPDATED_AT_ASC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__UPDATED_AT_DESC'
  | 'NOTIFICATION_TYPE_ID_ASC'
  | 'NOTIFICATION_TYPE_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/**
 * A condition to be used against `NotificationType` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type NotificationTypeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `avoidBundling` field. */
  avoidBundling?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `broadcastTime` field. */
  broadcastTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `timeZone` field. */
  timeZone?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `NotificationType` object types. All fields are combined with a logical ‘and.’ */
export type NotificationTypeFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NotificationTypeFilter>>;
  /** Filter by the object’s `avoidBundling` field. */
  avoidBundling?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `broadcastTime` field. */
  broadcastTime?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NotificationTypeFilter>;
  /** Filter by the object’s `notificationTypeChannelTypes` relation. */
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeToManyNotificationTypeChannelTypeFilter>;
  /** Some related `notificationTypeChannelTypes` exist. */
  notificationTypeChannelTypesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `notifications` relation. */
  notifications?: InputMaybe<NotificationTypeToManyNotificationFilter>;
  /** Some related `notifications` exist. */
  notificationsExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NotificationTypeFilter>>;
  /** Filter by the object’s `timeZone` field. */
  timeZone?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `NotificationType` */
export type NotificationTypeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  avoidBundling?: InputMaybe<Scalars['Boolean']>;
  broadcastTime?: InputMaybe<Scalars['Time']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeNotificationTypeIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationNotificationTypeIdForeignInverseInput>;
  timeZone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `notificationType` to look up the row to connect. */
export type NotificationTypeNotificationTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `notificationType` to look up the row to update. */
export type NotificationTypeOnNotificationForNotificationNotificationTypeIdForeignUsingNotificationTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationType` being updated. */
  patch: UpdateNotificationTypeOnNotificationForNotificationNotificationTypeIdForeignPatch;
};

/** The fields on `notificationType` to look up the row to update. */
export type NotificationTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeNotificationTypeIdForeignUsingNotificationTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `notificationType` being updated. */
  patch: UpdateNotificationTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeNotificationTypeIdForeignPatch;
};

/** Represents an update to a `NotificationType`. Fields that are set will be updated. */
export type NotificationTypePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  avoidBundling?: InputMaybe<Scalars['Boolean']>;
  broadcastTime?: InputMaybe<Scalars['Time']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeNotificationTypeIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationNotificationTypeIdForeignInverseInput>;
  timeZone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against many `Notification` object types. All fields are combined with a logical ‘and.’ */
export type NotificationTypeToManyNotificationFilter = {
  /** Every related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationFilter>;
  /** No related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationFilter>;
  /** Some related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationFilter>;
};

/** A filter to be used against many `NotificationTypeChannelType` object types. All fields are combined with a logical ‘and.’ */
export type NotificationTypeToManyNotificationTypeChannelTypeFilter = {
  /** Every related `NotificationTypeChannelType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationTypeChannelTypeFilter>;
  /** No related `NotificationTypeChannelType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationTypeChannelTypeFilter>;
  /** Some related `NotificationTypeChannelType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationTypeChannelTypeFilter>;
};

/** A connection to a list of `NotificationType` values. */
export type NotificationTypesConnection = {
  __typename?: 'NotificationTypesConnection';
  /** A list of edges which contains the `NotificationType` and cursor to aid in pagination. */
  edges: Array<NotificationTypesEdge>;
  /** A list of `NotificationType` objects. */
  nodes: Array<Maybe<NotificationType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NotificationType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `NotificationType` edge in the connection. */
export type NotificationTypesEdge = {
  __typename?: 'NotificationTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `NotificationType` at the end of the edge. */
  node?: Maybe<NotificationType>;
};

/** Methods to use when ordering `NotificationType`. */
export type NotificationTypesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'AVOID_BUNDLING_ASC'
  | 'AVOID_BUNDLING_DESC'
  | 'BROADCAST_TIME_ASC'
  | 'BROADCAST_TIME_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'NOTIFICATIONS_BY_NOTIFICATION_TYPE_ID__COUNT_ASC'
  | 'NOTIFICATIONS_BY_NOTIFICATION_TYPE_ID__COUNT_DESC'
  | 'NOTIFICATION_TYPE_CHANNEL_TYPES_BY_NOTIFICATION_TYPE_ID__COUNT_ASC'
  | 'NOTIFICATION_TYPE_CHANNEL_TYPES_BY_NOTIFICATION_TYPE_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIME_ZONE_ASC'
  | 'TIME_ZONE_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** A connection to a list of `Notification` values. */
export type NotificationsConnection = {
  __typename?: 'NotificationsConnection';
  /** A list of edges which contains the `Notification` and cursor to aid in pagination. */
  edges: Array<NotificationsEdge>;
  /** A list of `Notification` objects. */
  nodes: Array<Maybe<Notification>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Notification` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Notification` edge in the connection. */
export type NotificationsEdge = {
  __typename?: 'NotificationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Notification` at the end of the edge. */
  node?: Maybe<Notification>;
};

/** Methods to use when ordering `Notification`. */
export type NotificationsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'EMAIL_SUBJECT_ASC'
  | 'EMAIL_SUBJECT_DESC'
  | 'HOOK_BY_HOOK_ID__ALWAYS_SEND_ASC'
  | 'HOOK_BY_HOOK_ID__ALWAYS_SEND_DESC'
  | 'HOOK_BY_HOOK_ID__ID_ASC'
  | 'HOOK_BY_HOOK_ID__ID_DESC'
  | 'HOOK_BY_HOOK_ID__NAME_ASC'
  | 'HOOK_BY_HOOK_ID__NAME_DESC'
  | 'HOOK_ID_ASC'
  | 'HOOK_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'METADATA_ASC'
  | 'METADATA_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_CUSTOM_EMPLOYEE_FIELD_RECIPIENTS_BY_NOTIFICATION_ID__COUNT_ASC'
  | 'NOTIFICATION_CUSTOM_EMPLOYEE_FIELD_RECIPIENTS_BY_NOTIFICATION_ID__COUNT_DESC'
  | 'NOTIFICATION_CUSTOM_RECIPIENTS_BY_NOTIFICATION_ID__COUNT_ASC'
  | 'NOTIFICATION_CUSTOM_RECIPIENTS_BY_NOTIFICATION_ID__COUNT_DESC'
  | 'NOTIFICATION_EMPLOYEES_BY_NOTIFICATION_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEES_BY_NOTIFICATION_ID__COUNT_DESC'
  | 'NOTIFICATION_GROUP_RECIPIENTS_BY_NOTIFICATION_ID__COUNT_ASC'
  | 'NOTIFICATION_GROUP_RECIPIENTS_BY_NOTIFICATION_ID__COUNT_DESC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__ACTIVE_ASC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__ACTIVE_DESC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__AVOID_BUNDLING_ASC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__AVOID_BUNDLING_DESC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__BROADCAST_TIME_ASC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__BROADCAST_TIME_DESC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__COMPANY_ID_ASC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__COMPANY_ID_DESC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__CREATED_AT_ASC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__CREATED_AT_DESC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__ID_ASC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__ID_DESC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__NAME_ASC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__NAME_DESC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__TIME_ZONE_ASC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__TIME_ZONE_DESC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__UPDATED_AT_ASC'
  | 'NOTIFICATION_TYPE_BY_NOTIFICATION_TYPE_ID__UPDATED_AT_DESC'
  | 'NOTIFICATION_TYPE_ID_ASC'
  | 'NOTIFICATION_TYPE_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ACTIVE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ACTIVE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ANONYMOUS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ANONYMOUS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ARCHIVED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ARCHIVED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__BACKGROUND_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__BACKGROUND_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CHANNEL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CHANNEL_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CLOSE_ACCESS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CLOSE_ACCESS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPANY_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPANY_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPLETED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPLETED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONFIRM_RESULTS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONFIRM_RESULTS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_BACKGROUND_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_BACKGROUND_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_TEXT_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_TEXT_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_AT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_AT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_FROM_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_FROM_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DATE_FORMAT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DATE_FORMAT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEADLINE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEADLINE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_DIRECT_MANAGER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_DIRECT_MANAGER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_GROUP_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_GROUP_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_USER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_USER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEPARTMENT_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEPARTMENT_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DISABLE_2FA_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DISABLE_2FA_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_BODY_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_BODY_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_SUBJECT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_SUBJECT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMPLOYEE_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMPLOYEE_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FALLBACK_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FALLBACK_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_SIZE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_SIZE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_URL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_URL_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LINK_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LINK_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOCALE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOCALE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_WIDTH_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_WIDTH_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__MANAGER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__MANAGER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NEXT_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NEXT_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ORDER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ORDER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_ENABLED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_ENABLED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREDECESSOR_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREDECESSOR_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREV_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREV_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PUBLISHED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PUBLISHED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_DIRECT_MANAGER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_DIRECT_MANAGER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_GROUP_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_GROUP_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DAYS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DAYS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESPONSIBLE_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESPONSIBLE_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESULT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESULT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__SMS_BODY_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__SMS_BODY_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__START_DATE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__START_DATE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEMPLATE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEMPLATE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEXT_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEXT_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CONTENT_COLORS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CONTENT_COLORS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CUSTOM_LINK_BUTTON_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CUSTOM_LINK_BUTTON_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_LEADER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_LEADER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_WORK_EMAIL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_WORK_EMAIL_DESC'
  | 'PREBOARDING_ID_ASC'
  | 'PREBOARDING_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RECIPIENT_TYPE_ASC'
  | 'RECIPIENT_TYPE_DESC'
  | 'TEXT_ASC'
  | 'TEXT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

export type OgImage = {
  __typename?: 'OgImage';
  height?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type OpenGraph = {
  __typename?: 'OpenGraph';
  ogDescription?: Maybe<Scalars['String']>;
  ogImage?: Maybe<OgImage>;
  ogTitle?: Maybe<Scalars['String']>;
  ogType?: Maybe<Scalars['String']>;
  ogUrl?: Maybe<Scalars['String']>;
  requestUrl?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type OrderBy =
  | 'asc'
  | 'desc';

/** A connection to a list of `JSON` values. */
export type OrganizationDiagramConnection = {
  __typename?: 'OrganizationDiagramConnection';
  /** A list of edges which contains the `JSON` and cursor to aid in pagination. */
  edges: Array<OrganizationDiagramEdge>;
  /** A list of `JSON` objects. */
  nodes: Array<Maybe<Scalars['JSON']>>;
  /** The count of *all* `JSON` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `JSON` edge in the connection. */
export type OrganizationDiagramEdge = {
  __typename?: 'OrganizationDiagramEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `JSON` at the end of the edge. */
  node?: Maybe<Scalars['JSON']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']>;
};

/** All input for the `parseStringToDatetime` mutation. */
export type ParseStringToDatetimeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  string?: InputMaybe<Scalars['String']>;
};

/** The output of our `parseStringToDatetime` mutation. */
export type ParseStringToDatetimePayload = {
  __typename?: 'ParseStringToDatetimePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  datetime?: Maybe<Scalars['Datetime']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type PersonalDataCardField = {
  id: Scalars['UUID'];
  order: Scalars['Int'];
  type: Scalars['String'];
};

export type Point = {
  __typename?: 'Point';
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type PointInput = {
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type Post = {
  __typename?: 'Post';
  active: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `PostComment`. */
  comments: PostCommentsConnection;
  commentsEnabled?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Company` that is related to this `Post`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  creator?: Maybe<PostCreator>;
  /** Reads and enables pagination through a set of `Storage`. */
  files: StoragesConnection;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `Storage`. */
  images: StoragesConnection;
  /** Reads and enables pagination through a set of `PostLike`. */
  likes: PostLikesConnection;
  ogDescription?: Maybe<Scalars['String']>;
  ogImageHeight?: Maybe<Scalars['Int']>;
  ogImageType?: Maybe<Scalars['String']>;
  ogImageUrl?: Maybe<Scalars['String']>;
  ogImageWidth?: Maybe<Scalars['Int']>;
  ogTitle?: Maybe<Scalars['String']>;
  ogUrl?: Maybe<Scalars['String']>;
  postTypeIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads and enables pagination through a set of `PostType`. */
  postTypes: PostTypesConnection;
  text: Scalars['String'];
  /** Reads a single `User` that is related to this `Post`. */
  user?: Maybe<User>;
  userHasCommented?: Maybe<Scalars['Boolean']>;
  userHasLiked?: Maybe<Scalars['Boolean']>;
  userId: Scalars['UUID'];
};


export type PostCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<PostCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PostFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PostImagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PostLikesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<PostLikeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PostPostTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PostTypeCondition>;
  filter?: InputMaybe<PostTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PostTypesOrderBy>>;
};

export type PostComment = {
  __typename?: 'PostComment';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `PostComment`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  creator?: Maybe<PostCreator>;
  id: Scalars['UUID'];
  /** Reads a single `Post` that is related to this `PostComment`. */
  post?: Maybe<Post>;
  postId: Scalars['UUID'];
  text: Scalars['String'];
  /** Reads a single `User` that is related to this `PostComment`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** A filter to be used against `PostComment` object types. All fields are combined with a logical ‘and.’ */
export type PostCommentFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PostCommentFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PostCommentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PostCommentFilter>>;
  /** Filter by the object’s `post` relation. */
  post?: InputMaybe<PostFilter>;
  /** Filter by the object’s `postId` field. */
  postId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `text` field. */
  text?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** A connection to a list of `PostComment` values. */
export type PostCommentsConnection = {
  __typename?: 'PostCommentsConnection';
  /** A list of edges which contains the `PostComment` and cursor to aid in pagination. */
  edges: Array<PostCommentsEdge>;
  /** A list of `PostComment` objects. */
  nodes: Array<Maybe<PostComment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PostComment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PostComment` edge in the connection. */
export type PostCommentsEdge = {
  __typename?: 'PostCommentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PostComment` at the end of the edge. */
  node?: Maybe<PostComment>;
};

/** The `post` to be created by this mutation. */
export type PostCompanyIdForeignConnectionPostCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  commentsEnabled?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PostCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  ogDescription?: InputMaybe<Scalars['String']>;
  ogImageHeight?: InputMaybe<Scalars['Int']>;
  ogImageType?: InputMaybe<Scalars['String']>;
  ogImageUrl?: InputMaybe<Scalars['String']>;
  ogImageWidth?: InputMaybe<Scalars['Int']>;
  ogTitle?: InputMaybe<Scalars['String']>;
  ogUrl?: InputMaybe<Scalars['String']>;
  postTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  text: Scalars['String'];
  user?: InputMaybe<PostUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `PostInput` mutation. */
export type PostCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnPostForPostCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `post` in the `CompanyInput` mutation. */
export type PostCompanyIdForeignInverseInput = {
  /** The primary key(s) for `post` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PostPostPkeyConnect>>;
  /** A `PostInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PostCompanyIdForeignConnectionPostCreateInput>>;
  /** The primary key(s) and patch data for `post` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PostOnPostForPostCompanyIdForeignUsingPostPkeyUpdate>>;
};

/** A condition to be used against `Post` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PostCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `commentsEnabled` field. */
  commentsEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `ogDescription` field. */
  ogDescription?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `ogImageHeight` field. */
  ogImageHeight?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `ogImageType` field. */
  ogImageType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `ogImageUrl` field. */
  ogImageUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `ogImageWidth` field. */
  ogImageWidth?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `ogTitle` field. */
  ogTitle?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `ogUrl` field. */
  ogUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `postTypeIds` field. */
  postTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `text` field. */
  text?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

export type PostCreator = {
  __typename?: 'PostCreator';
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  jobPositionTitle?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
};

/** A filter to be used against `Post` object types. All fields are combined with a logical ‘and.’ */
export type PostFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PostFilter>>;
  /** Filter by the object’s `commentsEnabled` field. */
  commentsEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PostFilter>;
  /** Filter by the object’s `ogDescription` field. */
  ogDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ogImageHeight` field. */
  ogImageHeight?: InputMaybe<IntFilter>;
  /** Filter by the object’s `ogImageType` field. */
  ogImageType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ogImageUrl` field. */
  ogImageUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ogImageWidth` field. */
  ogImageWidth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `ogTitle` field. */
  ogTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ogUrl` field. */
  ogUrl?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PostFilter>>;
  /** Filter by the object’s `postTypeIds` field. */
  postTypeIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `text` field. */
  text?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userHasCommented` field. */
  userHasCommented?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `userHasLiked` field. */
  userHasLiked?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `Post` */
export type PostInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  commentsEnabled?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PostCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  ogDescription?: InputMaybe<Scalars['String']>;
  ogImageHeight?: InputMaybe<Scalars['Int']>;
  ogImageType?: InputMaybe<Scalars['String']>;
  ogImageUrl?: InputMaybe<Scalars['String']>;
  ogImageWidth?: InputMaybe<Scalars['Int']>;
  ogTitle?: InputMaybe<Scalars['String']>;
  ogUrl?: InputMaybe<Scalars['String']>;
  postTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  text: Scalars['String'];
  user?: InputMaybe<PostUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type PostLike = {
  __typename?: 'PostLike';
  /** Reads a single `Company` that is related to this `PostLike`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  creator?: Maybe<PostCreator>;
  id: Scalars['UUID'];
  /** Reads a single `Post` that is related to this `PostLike`. */
  post?: Maybe<Post>;
  postId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `PostLike`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** A filter to be used against `PostLike` object types. All fields are combined with a logical ‘and.’ */
export type PostLikeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PostLikeFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PostLikeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PostLikeFilter>>;
  /** Filter by the object’s `post` relation. */
  post?: InputMaybe<PostFilter>;
  /** Filter by the object’s `postId` field. */
  postId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** A connection to a list of `PostLike` values. */
export type PostLikesConnection = {
  __typename?: 'PostLikesConnection';
  /** A list of edges which contains the `PostLike` and cursor to aid in pagination. */
  edges: Array<PostLikesEdge>;
  /** A list of `PostLike` objects. */
  nodes: Array<Maybe<PostLike>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PostLike` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PostLike` edge in the connection. */
export type PostLikesEdge = {
  __typename?: 'PostLikesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PostLike` at the end of the edge. */
  node?: Maybe<PostLike>;
};

/** The fields on `post` to look up the row to update. */
export type PostOnPostForPostCompanyIdForeignUsingPostPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `post` being updated. */
  patch: UpdatePostOnPostForPostCompanyIdForeignPatch;
};

/** The fields on `post` to look up the row to update. */
export type PostOnPostForPostUserIdForeignUsingPostPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `post` being updated. */
  patch: UpdatePostOnPostForPostUserIdForeignPatch;
};

/** Represents an update to a `Post`. Fields that are set will be updated. */
export type PostPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  commentsEnabled?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PostCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  ogDescription?: InputMaybe<Scalars['String']>;
  ogImageHeight?: InputMaybe<Scalars['Int']>;
  ogImageType?: InputMaybe<Scalars['String']>;
  ogImageUrl?: InputMaybe<Scalars['String']>;
  ogImageWidth?: InputMaybe<Scalars['Int']>;
  ogTitle?: InputMaybe<Scalars['String']>;
  ogUrl?: InputMaybe<Scalars['String']>;
  postTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PostUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `post` to look up the row to connect. */
export type PostPostPkeyConnect = {
  id: Scalars['UUID'];
};

export type PostType = {
  __typename?: 'PostType';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `PostType`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `Department`. */
  departments: DepartmentsConnection;
  id: Scalars['UUID'];
  localizedName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Reads a single `TranslatedEntity` that is related to this `PostType`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  nameTranslatedEntityId: Scalars['UUID'];
  sharedDepartments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  sharedUsers?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads and enables pagination through a set of `User`. */
  users: UsersConnection;
};


export type PostTypeDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<DepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PostTypeUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** The `postType` to be created by this mutation. */
export type PostTypeCompanyIdForeignConnectionPostTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PostTypeCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  sharedDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  sharedUsers?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  translatedEntity?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInput>;
};

/** Input for the nested mutation of `company` in the `PostTypeInput` mutation. */
export type PostTypeCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnPostTypeForPostTypeCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `postType` in the `CompanyInput` mutation. */
export type PostTypeCompanyIdForeignInverseInput = {
  /** The primary key(s) for `postType` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PostTypePostTypePkeyConnect>>;
  /** A `PostTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PostTypeCompanyIdForeignConnectionPostTypeCreateInput>>;
  /** The primary key(s) for `postType` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PostTypePostTypePkeyDelete>>;
  /** Flag indicating whether all other `postType` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `postType` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PostTypeOnPostTypeForPostTypeCompanyIdForeignUsingPostTypePkeyUpdate>>;
};

/**
 * A condition to be used against `PostType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PostTypeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameTranslatedEntityId` field. */
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `sharedDepartments` field. */
  sharedDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `sharedUsers` field. */
  sharedUsers?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** A filter to be used against `PostType` object types. All fields are combined with a logical ‘and.’ */
export type PostTypeFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PostTypeFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameTranslatedEntity` relation. */
  nameTranslatedEntity?: InputMaybe<TranslatedEntityFilter>;
  /** Filter by the object’s `nameTranslatedEntityId` field. */
  nameTranslatedEntityId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PostTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PostTypeFilter>>;
  /** Filter by the object’s `sharedDepartments` field. */
  sharedDepartments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `sharedUsers` field. */
  sharedUsers?: InputMaybe<UuidListFilter>;
};

/** An input for mutations affecting `PostType` */
export type PostTypeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PostTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  sharedDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  sharedUsers?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  translatedEntity?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInput>;
};

/** Input for the nested mutation of `translatedEntity` in the `PostTypeInput` mutation. */
export type PostTypeNameTranslatedEntityIdForeignInput = {
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  connectById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyConnect>;
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  deleteById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyDelete>;
  /** The primary key(s) and patch data for `translatedEntity` for the far side of the relationship. */
  updateById?: InputMaybe<TranslatedEntityOnPostTypeForPostTypeNameTranslatedEntityIdForeignUsingTranslatedEntityPkeyUpdate>;
};

/** Input for the nested mutation of `postType` in the `TranslatedEntityInput` mutation. */
export type PostTypeNameTranslatedEntityIdForeignInverseInput = {
  /** The primary key(s) for `postType` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PostTypePostTypePkeyConnect>>;
  /** The primary key(s) for `postType` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PostTypePostTypePkeyDelete>>;
  /** Flag indicating whether all other `postType` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `postType` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PostTypeOnPostTypeForPostTypeNameTranslatedEntityIdForeignUsingPostTypePkeyUpdate>>;
};

/** The fields on `postType` to look up the row to update. */
export type PostTypeOnPostTypeForPostTypeCompanyIdForeignUsingPostTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `postType` being updated. */
  patch: UpdatePostTypeOnPostTypeForPostTypeCompanyIdForeignPatch;
};

/** The fields on `postType` to look up the row to update. */
export type PostTypeOnPostTypeForPostTypeNameTranslatedEntityIdForeignUsingPostTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `postType` being updated. */
  patch: UpdatePostTypeOnPostTypeForPostTypeNameTranslatedEntityIdForeignPatch;
};

/** Represents an update to a `PostType`. Fields that are set will be updated. */
export type PostTypePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PostTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  sharedDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  sharedUsers?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  translatedEntity?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInput>;
};

/** The fields on `postType` to look up the row to connect. */
export type PostTypePostTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `postType` to look up the row to delete. */
export type PostTypePostTypePkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `PostType` values. */
export type PostTypesConnection = {
  __typename?: 'PostTypesConnection';
  /** A list of edges which contains the `PostType` and cursor to aid in pagination. */
  edges: Array<PostTypesEdge>;
  /** A list of `PostType` objects. */
  nodes: Array<Maybe<PostType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PostType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PostType` edge in the connection. */
export type PostTypesEdge = {
  __typename?: 'PostTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PostType` at the end of the edge. */
  node?: Maybe<PostType>;
};

/** Methods to use when ordering `PostType`. */
export type PostTypesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALIZED_NAME_ASC'
  | 'LOCALIZED_NAME_DESC'
  | 'NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SHARED_DEPARTMENTS_ASC'
  | 'SHARED_DEPARTMENTS_DESC'
  | 'SHARED_USERS_ASC'
  | 'SHARED_USERS_DESC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__COMPANY_ID_ASC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__COMPANY_ID_DESC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__ID_ASC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__ID_DESC';

/** The `post` to be created by this mutation. */
export type PostUserIdForeignConnectionPostCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  commentsEnabled?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PostCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  ogDescription?: InputMaybe<Scalars['String']>;
  ogImageHeight?: InputMaybe<Scalars['Int']>;
  ogImageType?: InputMaybe<Scalars['String']>;
  ogImageUrl?: InputMaybe<Scalars['String']>;
  ogImageWidth?: InputMaybe<Scalars['Int']>;
  ogTitle?: InputMaybe<Scalars['String']>;
  ogUrl?: InputMaybe<Scalars['String']>;
  postTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  text: Scalars['String'];
  user?: InputMaybe<PostUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `PostInput` mutation. */
export type PostUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnPostForPostUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `post` in the `UserInput` mutation. */
export type PostUserIdForeignInverseInput = {
  /** The primary key(s) for `post` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PostPostPkeyConnect>>;
  /** A `PostInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PostUserIdForeignConnectionPostCreateInput>>;
  /** The primary key(s) and patch data for `post` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PostOnPostForPostUserIdForeignUsingPostPkeyUpdate>>;
};

/** A connection to a list of `Post` values. */
export type PostsConnection = {
  __typename?: 'PostsConnection';
  /** A list of edges which contains the `Post` and cursor to aid in pagination. */
  edges: Array<PostsEdge>;
  /** A list of `Post` objects. */
  nodes: Array<Maybe<Post>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Post` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Post` edge in the connection. */
export type PostsEdge = {
  __typename?: 'PostsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Post` at the end of the edge. */
  node?: Maybe<Post>;
};

/** Methods to use when ordering `Post`. */
export type PostsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMMENTS_ENABLED_ASC'
  | 'COMMENTS_ENABLED_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'OG_DESCRIPTION_ASC'
  | 'OG_DESCRIPTION_DESC'
  | 'OG_IMAGE_HEIGHT_ASC'
  | 'OG_IMAGE_HEIGHT_DESC'
  | 'OG_IMAGE_TYPE_ASC'
  | 'OG_IMAGE_TYPE_DESC'
  | 'OG_IMAGE_URL_ASC'
  | 'OG_IMAGE_URL_DESC'
  | 'OG_IMAGE_WIDTH_ASC'
  | 'OG_IMAGE_WIDTH_DESC'
  | 'OG_TITLE_ASC'
  | 'OG_TITLE_DESC'
  | 'OG_URL_ASC'
  | 'OG_URL_DESC'
  | 'POST_TYPE_IDS_ASC'
  | 'POST_TYPE_IDS_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TEXT_ASC'
  | 'TEXT_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type Preboarding = {
  __typename?: 'Preboarding';
  active: Scalars['Boolean'];
  anonymous: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  assigneeCount?: Maybe<Scalars['Int']>;
  backgroundColor?: Maybe<Scalars['String']>;
  channel?: Maybe<PreboardingChannel>;
  closeAccess?: Maybe<Scalars['Int']>;
  /** Reads a single `Company` that is related to this `Preboarding`. */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['UUID']>;
  completed: Scalars['Boolean'];
  confirmResults: Scalars['Boolean'];
  contentBackgroundColor?: Maybe<Scalars['String']>;
  contentTextColor?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  createdFrom?: Maybe<Scalars['UUID']>;
  dateFormat?: Maybe<Scalars['String']>;
  deadline?: Maybe<Scalars['Datetime']>;
  defaultManagerDirectManager: Scalars['Boolean'];
  defaultManagerEmployeeFieldIds: Array<Maybe<Scalars['UUID']>>;
  defaultManagerGroupIds: Array<Maybe<Scalars['UUID']>>;
  defaultManagerUserIds: Array<Maybe<Scalars['UUID']>>;
  departmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads and enables pagination through a set of `Department`. */
  departments: DepartmentsConnection;
  disable2Fa: Scalars['Boolean'];
  emailBody?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  /** Reads a single `Employee` that is related to this `Preboarding`. */
  employee?: Maybe<Employee>;
  employeeId?: Maybe<Scalars['UUID']>;
  employeeIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `EngagementType` that is related to this `Preboarding`. */
  engagementType?: Maybe<EngagementType>;
  engagementTypeId?: Maybe<Scalars['UUID']>;
  fallbackText?: Maybe<Scalars['String']>;
  finishedAssigneeCount?: Maybe<Scalars['Int']>;
  firstSlideDescription?: Maybe<Scalars['String']>;
  firstSlideName?: Maybe<Scalars['String']>;
  firstSlideTitle?: Maybe<Scalars['String']>;
  fontSize: Scalars['Int'];
  fontStorage?: Maybe<Storage>;
  fontType?: Maybe<PreboardingFontType>;
  fontUrl?: Maybe<Scalars['String']>;
  hasHandSignatureField?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  isUncategorized?: Maybe<Scalars['Boolean']>;
  lastSlideDescription?: Maybe<Scalars['String']>;
  lastSlideName?: Maybe<Scalars['String']>;
  lastSlideTitle?: Maybe<Scalars['String']>;
  linkButtonText?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  logoType?: Maybe<PreboardingLogoType>;
  logoWidth?: Maybe<Scalars['Int']>;
  managerIds: Array<Maybe<Scalars['UUID']>>;
  name?: Maybe<Scalars['String']>;
  nextButtonText?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferences: NotificationEmployeeReferencesConnection;
  /** Reads and enables pagination through a set of `Notification`. */
  notifications: NotificationsConnection;
  order: Scalars['Int'];
  overviewSlideDescription?: Maybe<Scalars['String']>;
  overviewSlideEnabled: Scalars['Boolean'];
  overviewSlideName?: Maybe<Scalars['String']>;
  overviewSlideTitle?: Maybe<Scalars['String']>;
  parsedFirstSlideDescription?: Maybe<Scalars['String']>;
  parsedLastSlideDescription?: Maybe<Scalars['String']>;
  /** Reads a single `Preboarding` that is related to this `Preboarding`. */
  preboardingByCreatedFrom?: Maybe<Preboarding>;
  /** Reads and enables pagination through a set of `PreboardingComment`. */
  preboardingComments: PreboardingCommentsConnection;
  /** Reads and enables pagination through a set of `PreboardingEmployee`. */
  preboardingEmployees: PreboardingEmployeesConnection;
  /** Reads and enables pagination through a set of `PreboardingFormCache`. */
  preboardingFormCaches: PreboardingFormCachesConnection;
  /** Reads and enables pagination through a set of `PreboardingProcess`. */
  preboardingProcesses: PreboardingProcessesConnection;
  /** Reads and enables pagination through a set of `PreboardingSlide`. */
  preboardingSlides: PreboardingSlidesConnection;
  /** Reads and enables pagination through a set of `Preboarding`. */
  preboardingsByCreatedFrom: PreboardingsConnection;
  /** Reads and enables pagination through a set of `Preboarding`. */
  preboardingsByPredecessorId: PreboardingsConnection;
  /** Reads a single `Preboarding` that is related to this `Preboarding`. */
  predecessor?: Maybe<Preboarding>;
  predecessorId?: Maybe<Scalars['UUID']>;
  prevButtonText?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  /** Reads a single `User` that is related to this `Preboarding`. */
  recipient?: Maybe<User>;
  /** Reads a single `FormField` that is related to this `Preboarding`. */
  recipientCustomEmployeeField?: Maybe<FormField>;
  recipientCustomEmployeeFieldId?: Maybe<Scalars['UUID']>;
  recipientDirectManager?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Group` that is related to this `Preboarding`. */
  recipientGroup?: Maybe<Group>;
  recipientGroupId?: Maybe<Scalars['UUID']>;
  recipientId?: Maybe<Scalars['UUID']>;
  reminded?: Maybe<Scalars['Boolean']>;
  reminder?: Maybe<Scalars['Datetime']>;
  reminderDays?: Maybe<Scalars['Int']>;
  responsibleIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads and enables pagination through a set of `Employee`. */
  responsibles: EmployeesConnection;
  result?: Maybe<Scalars['JSON']>;
  smsBody?: Maybe<Scalars['String']>;
  startDate: Scalars['Datetime'];
  storage?: Maybe<Storage>;
  template: Scalars['Boolean'];
  textColor?: Maybe<Scalars['String']>;
  type?: Maybe<PreboardingType>;
  useContentColors: Scalars['Boolean'];
  useCustomLinkButtonColor: Scalars['Boolean'];
  useLeader: Scalars['Boolean'];
  useWorkEmail: Scalars['Boolean'];
  userIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};


export type PreboardingDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DepartmentCondition>;
  filter?: InputMaybe<DepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DepartmentsOrderBy>>;
};


export type PreboardingNotificationEmployeeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};


export type PreboardingNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};


export type PreboardingParsedFirstSlideDescriptionArgs = {
  preboardingEmployeeId: Scalars['UUID'];
};


export type PreboardingParsedLastSlideDescriptionArgs = {
  preboardingEmployeeId: Scalars['UUID'];
};


export type PreboardingPreboardingCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingCommentCondition>;
  filter?: InputMaybe<PreboardingCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingCommentsOrderBy>>;
};


export type PreboardingPreboardingEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingEmployeeCondition>;
  filter?: InputMaybe<PreboardingEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingEmployeesOrderBy>>;
};


export type PreboardingPreboardingFormCachesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingFormCacheCondition>;
  filter?: InputMaybe<PreboardingFormCacheFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingFormCachesOrderBy>>;
};


export type PreboardingPreboardingProcessesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingProcessCondition>;
  filter?: InputMaybe<PreboardingProcessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingProcessesOrderBy>>;
};


export type PreboardingPreboardingSlidesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingSlideCondition>;
  filter?: InputMaybe<PreboardingSlideFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingSlidesOrderBy>>;
};


export type PreboardingPreboardingsByCreatedFromArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingCondition>;
  filter?: InputMaybe<PreboardingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingsOrderBy>>;
};


export type PreboardingPreboardingsByPredecessorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingCondition>;
  filter?: InputMaybe<PreboardingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingsOrderBy>>;
};


export type PreboardingResponsiblesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<EmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PreboardingChannel =
  | 'EMAIL'
  | 'SMS';

/** A filter to be used against PreboardingChannel fields. All fields are combined with a logical ‘and.’ */
export type PreboardingChannelFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PreboardingChannel>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PreboardingChannel>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PreboardingChannel>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PreboardingChannel>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PreboardingChannel>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PreboardingChannel>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PreboardingChannel>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PreboardingChannel>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PreboardingChannel>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PreboardingChannel>>;
};

export type PreboardingComment = {
  __typename?: 'PreboardingComment';
  /** Reads a single `Company` that is related to this `PreboardingComment`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  edited: Scalars['Boolean'];
  /** Reads a single `Employee` that is related to this `PreboardingComment`. */
  employee?: Maybe<Employee>;
  employeeId: Scalars['UUID'];
  /** Reads a single `EngagementType` that is related to this `PreboardingComment`. */
  engagementType?: Maybe<EngagementType>;
  engagementTypeId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  /** Reads a single `Preboarding` that is related to this `PreboardingComment`. */
  preboarding?: Maybe<Preboarding>;
  preboardingId: Scalars['UUID'];
  public: Scalars['Boolean'];
  text: Scalars['String'];
  /** Reads a single `User` that is related to this `PreboardingComment`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The `preboardingComment` to be created by this mutation. */
export type PreboardingCommentCompanyIdFkeyConnectionPreboardingCommentCreateInput = {
  company?: InputMaybe<PreboardingCommentCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<PreboardingCommentPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingCommentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `PreboardingCommentInput` mutation. */
export type PreboardingCommentCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnPreboardingCommentForPreboardingCommentCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingComment` in the `CompanyInput` mutation. */
export type PreboardingCommentCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `preboardingComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingCommentPreboardingCommentPkeyConnect>>;
  /** A `PreboardingCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingCommentCompanyIdFkeyConnectionPreboardingCommentCreateInput>>;
  /** The primary key(s) for `preboardingComment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingCommentPreboardingCommentPkeyDelete>>;
  /** Flag indicating whether all other `preboardingComment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingCommentOnPreboardingCommentForPreboardingCommentCompanyIdFkeyUsingPreboardingCommentPkeyUpdate>>;
};

/**
 * A condition to be used against `PreboardingComment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PreboardingCommentCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `edited` field. */
  edited?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `preboardingId` field. */
  preboardingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `public` field. */
  public?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `text` field. */
  text?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `preboardingComment` to be created by this mutation. */
export type PreboardingCommentEmployeeIdForeignConnectionPreboardingCommentCreateInput = {
  company?: InputMaybe<PreboardingCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingCommentEmployeeIdForeignInput>;
  engagementType?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<PreboardingCommentPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingCommentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `employee` in the `PreboardingCommentInput` mutation. */
export type PreboardingCommentEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnPreboardingCommentForPreboardingCommentEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnPreboardingCommentForPreboardingCommentEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `preboardingComment` in the `EmployeeInput` mutation. */
export type PreboardingCommentEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `preboardingComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingCommentPreboardingCommentPkeyConnect>>;
  /** A `PreboardingCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingCommentEmployeeIdForeignConnectionPreboardingCommentCreateInput>>;
  /** The primary key(s) for `preboardingComment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingCommentPreboardingCommentPkeyDelete>>;
  /** Flag indicating whether all other `preboardingComment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingCommentOnPreboardingCommentForPreboardingCommentEmployeeIdForeignUsingPreboardingCommentPkeyUpdate>>;
};

/** The `engagementType` to be created by this mutation. */
export type PreboardingCommentEngagementTypeIdForeignConnectionEngagementTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `preboardingComment` to be created by this mutation. */
export type PreboardingCommentEngagementTypeIdForeignConnectionPreboardingCommentCreateInput = {
  company?: InputMaybe<PreboardingCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<PreboardingCommentPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingCommentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `engagementType` in the `PreboardingCommentInput` mutation. */
export type PreboardingCommentEngagementTypeIdForeignInput = {
  /** The primary key(s) for `engagementType` for the far side of the relationship. */
  connectById?: InputMaybe<EngagementTypeEngagementTypePkeyConnect>;
  /** A `EngagementTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingCommentEngagementTypeIdForeignConnectionEngagementTypeCreateInput>;
  /** The primary key(s) and patch data for `engagementType` for the far side of the relationship. */
  updateById?: InputMaybe<EngagementTypeOnPreboardingCommentForPreboardingCommentEngagementTypeIdForeignUsingEngagementTypePkeyUpdate>;
};

/** Input for the nested mutation of `preboardingComment` in the `EngagementTypeInput` mutation. */
export type PreboardingCommentEngagementTypeIdForeignInverseInput = {
  /** The primary key(s) for `preboardingComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingCommentPreboardingCommentPkeyConnect>>;
  /** A `PreboardingCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingCommentEngagementTypeIdForeignConnectionPreboardingCommentCreateInput>>;
  /** The primary key(s) for `preboardingComment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingCommentPreboardingCommentPkeyDelete>>;
  /** Flag indicating whether all other `preboardingComment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingCommentOnPreboardingCommentForPreboardingCommentEngagementTypeIdForeignUsingPreboardingCommentPkeyUpdate>>;
};

/** A filter to be used against `PreboardingComment` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingCommentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PreboardingCommentFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `edited` field. */
  edited?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `engagementType` relation. */
  engagementType?: InputMaybe<EngagementTypeFilter>;
  /** A related `engagementType` exists. */
  engagementTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PreboardingCommentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PreboardingCommentFilter>>;
  /** Filter by the object’s `preboarding` relation. */
  preboarding?: InputMaybe<PreboardingFilter>;
  /** Filter by the object’s `preboardingId` field. */
  preboardingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `public` field. */
  public?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `text` field. */
  text?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `PreboardingComment` */
export type PreboardingCommentInput = {
  company?: InputMaybe<PreboardingCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<PreboardingCommentPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingCommentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `preboardingComment` to look up the row to update. */
export type PreboardingCommentOnPreboardingCommentForPreboardingCommentCompanyIdFkeyUsingPreboardingCommentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingComment` being updated. */
  patch: UpdatePreboardingCommentOnPreboardingCommentForPreboardingCommentCompanyIdFkeyPatch;
};

/** The fields on `preboardingComment` to look up the row to update. */
export type PreboardingCommentOnPreboardingCommentForPreboardingCommentEmployeeIdForeignUsingPreboardingCommentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingComment` being updated. */
  patch: UpdatePreboardingCommentOnPreboardingCommentForPreboardingCommentEmployeeIdForeignPatch;
};

/** The fields on `preboardingComment` to look up the row to update. */
export type PreboardingCommentOnPreboardingCommentForPreboardingCommentEngagementTypeIdForeignUsingPreboardingCommentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingComment` being updated. */
  patch: UpdatePreboardingCommentOnPreboardingCommentForPreboardingCommentEngagementTypeIdForeignPatch;
};

/** The fields on `preboardingComment` to look up the row to update. */
export type PreboardingCommentOnPreboardingCommentForPreboardingCommentPreboardingIdForeignUsingPreboardingCommentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingComment` being updated. */
  patch: UpdatePreboardingCommentOnPreboardingCommentForPreboardingCommentPreboardingIdForeignPatch;
};

/** The fields on `preboardingComment` to look up the row to update. */
export type PreboardingCommentOnPreboardingCommentForPreboardingCommentUserIdFkeyUsingPreboardingCommentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingComment` being updated. */
  patch: UpdatePreboardingCommentOnPreboardingCommentForPreboardingCommentUserIdFkeyPatch;
};

/** Represents an update to a `PreboardingComment`. Fields that are set will be updated. */
export type PreboardingCommentPatch = {
  company?: InputMaybe<PreboardingCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<PreboardingCommentPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingCommentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `preboardingComment` to look up the row to connect. */
export type PreboardingCommentPreboardingCommentPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `preboardingComment` to look up the row to delete. */
export type PreboardingCommentPreboardingCommentPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `preboardingComment` to be created by this mutation. */
export type PreboardingCommentPreboardingIdForeignConnectionPreboardingCommentCreateInput = {
  company?: InputMaybe<PreboardingCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<PreboardingCommentPreboardingIdForeignInput>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingCommentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `preboarding` to be created by this mutation. */
export type PreboardingCommentPreboardingIdForeignConnectionPreboardingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontStorageId?: InputMaybe<Scalars['UUID']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoStorageId?: InputMaybe<Scalars['UUID']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `preboarding` in the `PreboardingCommentInput` mutation. */
export type PreboardingCommentPreboardingIdForeignInput = {
  /** The primary key(s) for `preboarding` for the far side of the relationship. */
  connectById?: InputMaybe<PreboardingPreboardingPkeyConnect>;
  /** A `PreboardingInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingCommentPreboardingIdForeignConnectionPreboardingCreateInput>;
  /** The primary key(s) and patch data for `preboarding` for the far side of the relationship. */
  updateById?: InputMaybe<PreboardingOnPreboardingCommentForPreboardingCommentPreboardingIdForeignUsingPreboardingPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingComment` in the `PreboardingInput` mutation. */
export type PreboardingCommentPreboardingIdForeignInverseInput = {
  /** The primary key(s) for `preboardingComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingCommentPreboardingCommentPkeyConnect>>;
  /** A `PreboardingCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingCommentPreboardingIdForeignConnectionPreboardingCommentCreateInput>>;
  /** The primary key(s) for `preboardingComment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingCommentPreboardingCommentPkeyDelete>>;
  /** Flag indicating whether all other `preboardingComment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingCommentOnPreboardingCommentForPreboardingCommentPreboardingIdForeignUsingPreboardingCommentPkeyUpdate>>;
};

/** The `preboardingComment` to be created by this mutation. */
export type PreboardingCommentUserIdFkeyConnectionPreboardingCommentCreateInput = {
  company?: InputMaybe<PreboardingCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<PreboardingCommentPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingCommentUserIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `PreboardingCommentInput` mutation. */
export type PreboardingCommentUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnPreboardingCommentForPreboardingCommentUserIdFkeyUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingComment` in the `UserInput` mutation. */
export type PreboardingCommentUserIdFkeyInverseInput = {
  /** The primary key(s) for `preboardingComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingCommentPreboardingCommentPkeyConnect>>;
  /** A `PreboardingCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingCommentUserIdFkeyConnectionPreboardingCommentCreateInput>>;
  /** The primary key(s) for `preboardingComment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingCommentPreboardingCommentPkeyDelete>>;
  /** Flag indicating whether all other `preboardingComment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingCommentOnPreboardingCommentForPreboardingCommentUserIdFkeyUsingPreboardingCommentPkeyUpdate>>;
};

/** A connection to a list of `PreboardingComment` values. */
export type PreboardingCommentsConnection = {
  __typename?: 'PreboardingCommentsConnection';
  /** A list of edges which contains the `PreboardingComment` and cursor to aid in pagination. */
  edges: Array<PreboardingCommentsEdge>;
  /** A list of `PreboardingComment` objects. */
  nodes: Array<Maybe<PreboardingComment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PreboardingComment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PreboardingComment` edge in the connection. */
export type PreboardingCommentsEdge = {
  __typename?: 'PreboardingCommentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PreboardingComment` at the end of the edge. */
  node?: Maybe<PreboardingComment>;
};

/** Methods to use when ordering `PreboardingComment`. */
export type PreboardingCommentsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EDITED_ASC'
  | 'EDITED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_ID_ASC'
  | 'ENGAGEMENT_TYPE_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PREBOARDING_BY_PREBOARDING_ID__ACTIVE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ACTIVE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ANONYMOUS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ANONYMOUS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ARCHIVED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ARCHIVED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__BACKGROUND_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__BACKGROUND_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CHANNEL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CHANNEL_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CLOSE_ACCESS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CLOSE_ACCESS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPANY_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPANY_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPLETED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPLETED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONFIRM_RESULTS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONFIRM_RESULTS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_BACKGROUND_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_BACKGROUND_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_TEXT_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_TEXT_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_AT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_AT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_FROM_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_FROM_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DATE_FORMAT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DATE_FORMAT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEADLINE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEADLINE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_DIRECT_MANAGER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_DIRECT_MANAGER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_GROUP_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_GROUP_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_USER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_USER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEPARTMENT_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEPARTMENT_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DISABLE_2FA_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DISABLE_2FA_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_BODY_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_BODY_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_SUBJECT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_SUBJECT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMPLOYEE_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMPLOYEE_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FALLBACK_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FALLBACK_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_SIZE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_SIZE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_URL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_URL_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LINK_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LINK_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOCALE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOCALE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_WIDTH_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_WIDTH_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__MANAGER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__MANAGER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NEXT_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NEXT_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ORDER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ORDER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_ENABLED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_ENABLED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREDECESSOR_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREDECESSOR_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREV_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREV_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PUBLISHED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PUBLISHED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_DIRECT_MANAGER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_DIRECT_MANAGER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_GROUP_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_GROUP_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DAYS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DAYS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESPONSIBLE_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESPONSIBLE_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESULT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESULT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__SMS_BODY_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__SMS_BODY_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__START_DATE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__START_DATE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEMPLATE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEMPLATE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEXT_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEXT_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CONTENT_COLORS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CONTENT_COLORS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CUSTOM_LINK_BUTTON_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CUSTOM_LINK_BUTTON_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_LEADER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_LEADER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_WORK_EMAIL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_WORK_EMAIL_DESC'
  | 'PREBOARDING_ID_ASC'
  | 'PREBOARDING_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PUBLIC_ASC'
  | 'PUBLIC_DESC'
  | 'TEXT_ASC'
  | 'TEXT_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** The `preboarding` to be created by this mutation. */
export type PreboardingCompanyIdForeignConnectionPreboardingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontStorageId?: InputMaybe<Scalars['UUID']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoStorageId?: InputMaybe<Scalars['UUID']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `company` in the `PreboardingInput` mutation. */
export type PreboardingCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnPreboardingForPreboardingCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `preboarding` in the `CompanyInput` mutation. */
export type PreboardingCompanyIdForeignInverseInput = {
  /** The primary key(s) for `preboarding` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingPreboardingPkeyConnect>>;
  /** A `PreboardingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingCompanyIdForeignConnectionPreboardingCreateInput>>;
  /** The primary key(s) and patch data for `preboarding` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingOnPreboardingForPreboardingCompanyIdForeignUsingPreboardingPkeyUpdate>>;
};

/**
 * A condition to be used against `Preboarding` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PreboardingCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `anonymous` field. */
  anonymous?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `backgroundColor` field. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `channel` field. */
  channel?: InputMaybe<PreboardingChannel>;
  /** Checks for equality with the object’s `closeAccess` field. */
  closeAccess?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `completed` field. */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `confirmResults` field. */
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `contentBackgroundColor` field. */
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `contentTextColor` field. */
  contentTextColor?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdFrom` field. */
  createdFrom?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `dateFormat` field. */
  dateFormat?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `deadline` field. */
  deadline?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `defaultManagerDirectManager` field. */
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `defaultManagerEmployeeFieldIds` field. */
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `defaultManagerGroupIds` field. */
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `defaultManagerUserIds` field. */
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `disable2Fa` field. */
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `emailBody` field. */
  emailBody?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `emailSubject` field. */
  emailSubject?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fallbackText` field. */
  fallbackText?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `firstSlideDescription` field. */
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `firstSlideName` field. */
  firstSlideName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `firstSlideTitle` field. */
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fontSize` field. */
  fontSize?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `fontType` field. */
  fontType?: InputMaybe<PreboardingFontType>;
  /** Checks for equality with the object’s `fontUrl` field. */
  fontUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `lastSlideDescription` field. */
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lastSlideName` field. */
  lastSlideName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `lastSlideTitle` field. */
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `linkButtonText` field. */
  linkButtonText?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `locale` field. */
  locale?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `logoType` field. */
  logoType?: InputMaybe<PreboardingLogoType>;
  /** Checks for equality with the object’s `logoWidth` field. */
  logoWidth?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `managerIds` field. */
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `nextButtonText` field. */
  nextButtonText?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `overviewSlideDescription` field. */
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `overviewSlideEnabled` field. */
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `overviewSlideName` field. */
  overviewSlideName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `overviewSlideTitle` field. */
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `predecessorId` field. */
  predecessorId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `prevButtonText` field. */
  prevButtonText?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `published` field. */
  published?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `recipientCustomEmployeeFieldId` field. */
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `recipientDirectManager` field. */
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `recipientGroupId` field. */
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `recipientId` field. */
  recipientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `reminded` field. */
  reminded?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `reminder` field. */
  reminder?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `reminderDays` field. */
  reminderDays?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `responsibleIds` field. */
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `result` field. */
  result?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `smsBody` field. */
  smsBody?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `template` field. */
  template?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `textColor` field. */
  textColor?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<PreboardingType>;
  /** Checks for equality with the object’s `useContentColors` field. */
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `useCustomLinkButtonColor` field. */
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `useLeader` field. */
  useLeader?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `useWorkEmail` field. */
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `userIds` field. */
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `preboarding` to be created by this mutation. */
export type PreboardingCreatedFromForeignConnectionPreboardingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontStorageId?: InputMaybe<Scalars['UUID']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoStorageId?: InputMaybe<Scalars['UUID']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `preboarding` in the `PreboardingInput` mutation. */
export type PreboardingCreatedFromForeignInput = {
  /** The primary key(s) for `preboarding` for the far side of the relationship. */
  connectById?: InputMaybe<PreboardingPreboardingPkeyConnect>;
  /** A `PreboardingInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingCreatedFromForeignConnectionPreboardingCreateInput>;
  /** The primary key(s) and patch data for `preboarding` for the far side of the relationship. */
  updateById?: InputMaybe<PreboardingOnPreboardingForPreboardingCreatedFromForeignUsingPreboardingPkeyUpdate>;
};

export type PreboardingEmailLog = {
  __typename?: 'PreboardingEmailLog';
  body: Scalars['String'];
  /** Reads a single `Company` that is related to this `PreboardingEmailLog`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  email: Scalars['String'];
  /** Reads a single `EngagementType` that is related to this `PreboardingEmailLog`. */
  engagementType?: Maybe<EngagementType>;
  engagementTypeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Employee` that is related to this `PreboardingEmailLog`. */
  fromEmployee?: Maybe<Employee>;
  fromEmployeeId: Scalars['UUID'];
  id: Scalars['UUID'];
  /** Reads a single `PreboardingEmployee` that is related to this `PreboardingEmailLog`. */
  preboardingEmployee?: Maybe<PreboardingEmployee>;
  preboardingEmployeeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `User` that is related to this `PreboardingEmailLog`. */
  preboardingUser?: Maybe<User>;
  preboardingUserId?: Maybe<Scalars['UUID']>;
  subject: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

/** Input for the nested mutation of `company` in the `PreboardingEmailLogInput` mutation. */
export type PreboardingEmailLogCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnPreboardingEmailLogForPreboardingEmailLogCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingEmailLog` in the `CompanyInput` mutation. */
export type PreboardingEmailLogCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `preboardingEmailLog` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingEmailLogPreboardingEmailLogPkeyConnect>>;
  /** The primary key(s) and patch data for `preboardingEmailLog` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogCompanyIdFkeyUsingPreboardingEmailLogPkeyUpdate>>;
};

/**
 * A condition to be used against `PreboardingEmailLog` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PreboardingEmailLogCondition = {
  /** Checks for equality with the object’s `body` field. */
  body?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fromEmployeeId` field. */
  fromEmployeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `preboardingEmployeeId` field. */
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `preboardingUserId` field. */
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `subject` field. */
  subject?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `engagementType` to be created by this mutation. */
export type PreboardingEmailLogEngagementTypeIdForeignConnectionEngagementTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `engagementType` in the `PreboardingEmailLogInput` mutation. */
export type PreboardingEmailLogEngagementTypeIdForeignInput = {
  /** The primary key(s) for `engagementType` for the far side of the relationship. */
  connectById?: InputMaybe<EngagementTypeEngagementTypePkeyConnect>;
  /** A `EngagementTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignConnectionEngagementTypeCreateInput>;
  /** The primary key(s) and patch data for `engagementType` for the far side of the relationship. */
  updateById?: InputMaybe<EngagementTypeOnPreboardingEmailLogForPreboardingEmailLogEngagementTypeIdForeignUsingEngagementTypePkeyUpdate>;
};

/** Input for the nested mutation of `preboardingEmailLog` in the `EngagementTypeInput` mutation. */
export type PreboardingEmailLogEngagementTypeIdForeignInverseInput = {
  /** The primary key(s) for `preboardingEmailLog` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingEmailLogPreboardingEmailLogPkeyConnect>>;
  /** The primary key(s) and patch data for `preboardingEmailLog` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogEngagementTypeIdForeignUsingPreboardingEmailLogPkeyUpdate>>;
};

/** A filter to be used against `PreboardingEmailLog` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingEmailLogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PreboardingEmailLogFilter>>;
  /** Filter by the object’s `body` field. */
  body?: InputMaybe<StringFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `engagementType` relation. */
  engagementType?: InputMaybe<EngagementTypeFilter>;
  /** A related `engagementType` exists. */
  engagementTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fromEmployee` relation. */
  fromEmployee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `fromEmployeeId` field. */
  fromEmployeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PreboardingEmailLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PreboardingEmailLogFilter>>;
  /** Filter by the object’s `preboardingEmployee` relation. */
  preboardingEmployee?: InputMaybe<PreboardingEmployeeFilter>;
  /** A related `preboardingEmployee` exists. */
  preboardingEmployeeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingEmployeeId` field. */
  preboardingEmployeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `preboardingUser` relation. */
  preboardingUser?: InputMaybe<UserFilter>;
  /** A related `preboardingUser` exists. */
  preboardingUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingUserId` field. */
  preboardingUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `subject` field. */
  subject?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Input for the nested mutation of `employee` in the `PreboardingEmailLogInput` mutation. */
export type PreboardingEmailLogFromEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnPreboardingEmailLogForPreboardingEmailLogFromEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnPreboardingEmailLogForPreboardingEmailLogFromEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `preboardingEmailLog` in the `EmployeeInput` mutation. */
export type PreboardingEmailLogFromEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `preboardingEmailLog` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingEmailLogPreboardingEmailLogPkeyConnect>>;
  /** The primary key(s) and patch data for `preboardingEmailLog` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogFromEmployeeIdForeignUsingPreboardingEmailLogPkeyUpdate>>;
};

/** The fields on `preboardingEmailLog` to look up the row to update. */
export type PreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogCompanyIdFkeyUsingPreboardingEmailLogPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingEmailLog` being updated. */
  patch: UpdatePreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogCompanyIdFkeyPatch;
};

/** The fields on `preboardingEmailLog` to look up the row to update. */
export type PreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogEngagementTypeIdForeignUsingPreboardingEmailLogPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingEmailLog` being updated. */
  patch: UpdatePreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogEngagementTypeIdForeignPatch;
};

/** The fields on `preboardingEmailLog` to look up the row to update. */
export type PreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogFromEmployeeIdForeignUsingPreboardingEmailLogPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingEmailLog` being updated. */
  patch: UpdatePreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogFromEmployeeIdForeignPatch;
};

/** The fields on `preboardingEmailLog` to look up the row to update. */
export type PreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogPreboardingEmployeeIdForeignUsingPreboardingEmailLogPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingEmailLog` being updated. */
  patch: UpdatePreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogPreboardingEmployeeIdForeignPatch;
};

/** The fields on `preboardingEmailLog` to look up the row to update. */
export type PreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogPreboardingUserIdForeignUsingPreboardingEmailLogPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingEmailLog` being updated. */
  patch: UpdatePreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogPreboardingUserIdForeignPatch;
};

/** The fields on `preboardingEmailLog` to look up the row to connect. */
export type PreboardingEmailLogPreboardingEmailLogPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `preboardingEmployee` to be created by this mutation. */
export type PreboardingEmailLogPreboardingEmployeeIdForeignConnectionPreboardingEmployeeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `preboardingEmployee` in the `PreboardingEmailLogInput` mutation. */
export type PreboardingEmailLogPreboardingEmployeeIdForeignInput = {
  /** The primary key(s) for `preboardingEmployee` for the far side of the relationship. */
  connectById?: InputMaybe<PreboardingEmployeePreboardingEmployeePkeyConnect>;
  /** A `PreboardingEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignConnectionPreboardingEmployeeCreateInput>;
  /** The primary key(s) and patch data for `preboardingEmployee` for the far side of the relationship. */
  updateById?: InputMaybe<PreboardingEmployeeOnPreboardingEmailLogForPreboardingEmailLogPreboardingEmployeeIdForeignUsingPreboardingEmployeePkeyUpdate>;
};

/** Input for the nested mutation of `preboardingEmailLog` in the `PreboardingEmployeeInput` mutation. */
export type PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `preboardingEmailLog` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingEmailLogPreboardingEmailLogPkeyConnect>>;
  /** The primary key(s) and patch data for `preboardingEmailLog` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogPreboardingEmployeeIdForeignUsingPreboardingEmailLogPkeyUpdate>>;
};

/** Input for the nested mutation of `user` in the `PreboardingEmailLogInput` mutation. */
export type PreboardingEmailLogPreboardingUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnPreboardingEmailLogForPreboardingEmailLogPreboardingUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingEmailLog` in the `UserInput` mutation. */
export type PreboardingEmailLogPreboardingUserIdForeignInverseInput = {
  /** The primary key(s) for `preboardingEmailLog` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingEmailLogPreboardingEmailLogPkeyConnect>>;
  /** The primary key(s) and patch data for `preboardingEmailLog` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogPreboardingUserIdForeignUsingPreboardingEmailLogPkeyUpdate>>;
};

/** A connection to a list of `PreboardingEmailLog` values. */
export type PreboardingEmailLogsConnection = {
  __typename?: 'PreboardingEmailLogsConnection';
  /** A list of edges which contains the `PreboardingEmailLog` and cursor to aid in pagination. */
  edges: Array<PreboardingEmailLogsEdge>;
  /** A list of `PreboardingEmailLog` objects. */
  nodes: Array<Maybe<PreboardingEmailLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PreboardingEmailLog` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PreboardingEmailLog` edge in the connection. */
export type PreboardingEmailLogsEdge = {
  __typename?: 'PreboardingEmailLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PreboardingEmailLog` at the end of the edge. */
  node?: Maybe<PreboardingEmailLog>;
};

/** Methods to use when ordering `PreboardingEmailLog`. */
export type PreboardingEmailLogsOrderBy =
  | 'BODY_ASC'
  | 'BODY_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EMAIL_ASC'
  | 'EMAIL_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_FROM_EMPLOYEE_ID__USER_ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_ID_ASC'
  | 'ENGAGEMENT_TYPE_ID_DESC'
  | 'FROM_EMPLOYEE_ID_ASC'
  | 'FROM_EMPLOYEE_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ACTIVE_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ACTIVE_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ARCHIVED_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ARCHIVED_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__COMPLETED_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__COMPLETED_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__COMPLETED_REMINDED_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__COMPLETED_REMINDED_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__CONCLUSION_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__CONCLUSION_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__DEADLINE_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__DEADLINE_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__EMPLOYEE_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__EMPLOYEE_ID_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ID_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__MANAGER_IDS_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__MANAGER_IDS_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__NAME_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__NAME_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__PREBOARDING_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__PREBOARDING_ID_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__PUBLISHED_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__PUBLISHED_DATE_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__PUBLISHED_DATE_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__PUBLISHED_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__RECIPIENT_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__RECIPIENT_ID_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__REMINDER_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__REMINDER_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__RESPONSIBLE_IDS_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__RESPONSIBLE_IDS_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__USER_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__USER_ID_DESC'
  | 'PREBOARDING_EMPLOYEE_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_ID_DESC'
  | 'PREBOARDING_USER_ID_ASC'
  | 'PREBOARDING_USER_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SUBJECT_ASC'
  | 'SUBJECT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__ACTIVE_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__ACTIVE_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__ADDRESS_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__ADDRESS_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__CITY_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__CITY_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__CPR_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__CPR_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__EMAIL_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__EMAIL_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__GODMODE_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__GODMODE_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__ID_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__ID_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__INITIALS_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__INITIALS_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__MOBILE_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__MOBILE_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__PHONE_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__PHONE_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__SENIORITY_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__SENIORITY_DESC';

export type PreboardingEmployee = {
  __typename?: 'PreboardingEmployee';
  active: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `PreboardingEmployee`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  completed: Scalars['Boolean'];
  completedReminded?: Maybe<Scalars['Boolean']>;
  conclusion?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `ContractSignPending`. */
  contractSignPendings: ContractSignPendingsConnection;
  createdAt: Scalars['Datetime'];
  deadline?: Maybe<Scalars['Datetime']>;
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Employee` that is related to this `PreboardingEmployee`. */
  employee?: Maybe<Employee>;
  employeeId: Scalars['UUID'];
  /** Reads a single `EngagementType` that is related to this `PreboardingEmployee`. */
  engagementType?: Maybe<EngagementType>;
  engagementTypeId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  link?: Maybe<Scalars['String']>;
  managerIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  name?: Maybe<Scalars['String']>;
  /** Reads a single `Preboarding` that is related to this `PreboardingEmployee`. */
  preboarding?: Maybe<Preboarding>;
  /** Reads and enables pagination through a set of `PreboardingEmailLog`. */
  preboardingEmailLogs: PreboardingEmailLogsConnection;
  preboardingId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `PreboardingResult`. */
  preboardingResults: PreboardingResultsConnection;
  published: Scalars['Boolean'];
  publishedDate?: Maybe<Scalars['Datetime']>;
  /** Reads a single `User` that is related to this `PreboardingEmployee`. */
  recipient?: Maybe<User>;
  recipientId?: Maybe<Scalars['UUID']>;
  reminder?: Maybe<Scalars['Datetime']>;
  responsibleIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `User` that is related to this `PreboardingEmployee`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};


export type PreboardingEmployeeContractSignPendingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingCondition>;
  filter?: InputMaybe<ContractSignPendingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingsOrderBy>>;
};


export type PreboardingEmployeePreboardingEmailLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingEmailLogCondition>;
  filter?: InputMaybe<PreboardingEmailLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingEmailLogsOrderBy>>;
};


export type PreboardingEmployeePreboardingResultsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingResultCondition>;
  filter?: InputMaybe<PreboardingResultFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingResultsOrderBy>>;
};

/** The `preboardingEmployee` to be created by this mutation. */
export type PreboardingEmployeeCompanyIdFkeyConnectionPreboardingEmployeeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `PreboardingEmployeeInput` mutation. */
export type PreboardingEmployeeCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnPreboardingEmployeeForPreboardingEmployeeCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingEmployee` in the `CompanyInput` mutation. */
export type PreboardingEmployeeCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `preboardingEmployee` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingEmployeePreboardingEmployeePkeyConnect>>;
  /** A `PreboardingEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingEmployeeCompanyIdFkeyConnectionPreboardingEmployeeCreateInput>>;
  /** The primary key(s) and patch data for `preboardingEmployee` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeCompanyIdFkeyUsingPreboardingEmployeePkeyUpdate>>;
};

/**
 * A condition to be used against `PreboardingEmployee` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PreboardingEmployeeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `completed` field. */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `completedReminded` field. */
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `conclusion` field. */
  conclusion?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deadline` field. */
  deadline?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `managerIds` field. */
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `preboardingId` field. */
  preboardingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `published` field. */
  published?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `publishedDate` field. */
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `recipientId` field. */
  recipientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `reminder` field. */
  reminder?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `responsibleIds` field. */
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `preboardingEmployee` to be created by this mutation. */
export type PreboardingEmployeeEmployeeIdForeignConnectionPreboardingEmployeeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `employee` in the `PreboardingEmployeeInput` mutation. */
export type PreboardingEmployeeEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnPreboardingEmployeeForPreboardingEmployeeEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnPreboardingEmployeeForPreboardingEmployeeEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `preboardingEmployee` in the `EmployeeInput` mutation. */
export type PreboardingEmployeeEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `preboardingEmployee` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingEmployeePreboardingEmployeePkeyConnect>>;
  /** A `PreboardingEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingEmployeeEmployeeIdForeignConnectionPreboardingEmployeeCreateInput>>;
  /** The primary key(s) and patch data for `preboardingEmployee` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeEmployeeIdForeignUsingPreboardingEmployeePkeyUpdate>>;
};

/** The `engagementType` to be created by this mutation. */
export type PreboardingEmployeeEngagementTypeIdForeignConnectionEngagementTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `preboardingEmployee` to be created by this mutation. */
export type PreboardingEmployeeEngagementTypeIdForeignConnectionPreboardingEmployeeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `engagementType` in the `PreboardingEmployeeInput` mutation. */
export type PreboardingEmployeeEngagementTypeIdForeignInput = {
  /** The primary key(s) for `engagementType` for the far side of the relationship. */
  connectById?: InputMaybe<EngagementTypeEngagementTypePkeyConnect>;
  /** A `EngagementTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignConnectionEngagementTypeCreateInput>;
  /** The primary key(s) and patch data for `engagementType` for the far side of the relationship. */
  updateById?: InputMaybe<EngagementTypeOnPreboardingEmployeeForPreboardingEmployeeEngagementTypeIdForeignUsingEngagementTypePkeyUpdate>;
};

/** Input for the nested mutation of `preboardingEmployee` in the `EngagementTypeInput` mutation. */
export type PreboardingEmployeeEngagementTypeIdForeignInverseInput = {
  /** The primary key(s) for `preboardingEmployee` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingEmployeePreboardingEmployeePkeyConnect>>;
  /** A `PreboardingEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingEmployeeEngagementTypeIdForeignConnectionPreboardingEmployeeCreateInput>>;
  /** The primary key(s) and patch data for `preboardingEmployee` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeEngagementTypeIdForeignUsingPreboardingEmployeePkeyUpdate>>;
};

/** A filter to be used against `PreboardingEmployee` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingEmployeeFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PreboardingEmployeeFilter>>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `completed` field. */
  completed?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `completedReminded` field. */
  completedReminded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `conclusion` field. */
  conclusion?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `contractSignPendings` relation. */
  contractSignPendings?: InputMaybe<PreboardingEmployeeToManyContractSignPendingFilter>;
  /** Some related `contractSignPendings` exist. */
  contractSignPendingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deadline` field. */
  deadline?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `engagementType` relation. */
  engagementType?: InputMaybe<EngagementTypeFilter>;
  /** A related `engagementType` exists. */
  engagementTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `link` field. */
  link?: InputMaybe<StringFilter>;
  /** Filter by the object’s `managerIds` field. */
  managerIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PreboardingEmployeeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PreboardingEmployeeFilter>>;
  /** Filter by the object’s `preboarding` relation. */
  preboarding?: InputMaybe<PreboardingFilter>;
  /** Filter by the object’s `preboardingEmailLogs` relation. */
  preboardingEmailLogs?: InputMaybe<PreboardingEmployeeToManyPreboardingEmailLogFilter>;
  /** Some related `preboardingEmailLogs` exist. */
  preboardingEmailLogsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingId` field. */
  preboardingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `preboardingResults` relation. */
  preboardingResults?: InputMaybe<PreboardingEmployeeToManyPreboardingResultFilter>;
  /** Some related `preboardingResults` exist. */
  preboardingResultsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `published` field. */
  published?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `publishedDate` field. */
  publishedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `recipient` relation. */
  recipient?: InputMaybe<UserFilter>;
  /** A related `recipient` exists. */
  recipientExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `recipientId` field. */
  recipientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `reminder` field. */
  reminder?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `responsibleIds` field. */
  responsibleIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The `preboarding` to be created by this mutation. */
export type PreboardingEmployeeIdForeignConnectionPreboardingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontStorageId?: InputMaybe<Scalars['UUID']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoStorageId?: InputMaybe<Scalars['UUID']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `employee` in the `PreboardingInput` mutation. */
export type PreboardingEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnPreboardingForPreboardingEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnPreboardingForPreboardingEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `preboarding` in the `EmployeeInput` mutation. */
export type PreboardingEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `preboarding` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingPreboardingPkeyConnect>>;
  /** A `PreboardingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingEmployeeIdForeignConnectionPreboardingCreateInput>>;
  /** The primary key(s) and patch data for `preboarding` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingOnPreboardingForPreboardingEmployeeIdForeignUsingPreboardingPkeyUpdate>>;
};

/** An input for mutations affecting `PreboardingEmployee` */
export type PreboardingEmployeeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `preboardingEmployee` to look up the row to update. */
export type PreboardingEmployeeOnContractSignPendingForContractSignPendingPreboardingEmployeeIdForeignUsingPreboardingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingEmployee` being updated. */
  patch: UpdatePreboardingEmployeeOnContractSignPendingForContractSignPendingPreboardingEmployeeIdForeignPatch;
};

/** The fields on `preboardingEmployee` to look up the row to update. */
export type PreboardingEmployeeOnPreboardingEmailLogForPreboardingEmailLogPreboardingEmployeeIdForeignUsingPreboardingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingEmployee` being updated. */
  patch: UpdatePreboardingEmployeeOnPreboardingEmailLogForPreboardingEmailLogPreboardingEmployeeIdForeignPatch;
};

/** The fields on `preboardingEmployee` to look up the row to update. */
export type PreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeCompanyIdFkeyUsingPreboardingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingEmployee` being updated. */
  patch: UpdatePreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeCompanyIdFkeyPatch;
};

/** The fields on `preboardingEmployee` to look up the row to update. */
export type PreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeEmployeeIdForeignUsingPreboardingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingEmployee` being updated. */
  patch: UpdatePreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeEmployeeIdForeignPatch;
};

/** The fields on `preboardingEmployee` to look up the row to update. */
export type PreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeEngagementTypeIdForeignUsingPreboardingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingEmployee` being updated. */
  patch: UpdatePreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeEngagementTypeIdForeignPatch;
};

/** The fields on `preboardingEmployee` to look up the row to update. */
export type PreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeePreboardingIdForeignUsingPreboardingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingEmployee` being updated. */
  patch: UpdatePreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeePreboardingIdForeignPatch;
};

/** The fields on `preboardingEmployee` to look up the row to update. */
export type PreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeRecipientIdForeignUsingPreboardingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingEmployee` being updated. */
  patch: UpdatePreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeRecipientIdForeignPatch;
};

/** The fields on `preboardingEmployee` to look up the row to update. */
export type PreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeUserIdFkeyUsingPreboardingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingEmployee` being updated. */
  patch: UpdatePreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeUserIdFkeyPatch;
};

/** The fields on `preboardingEmployee` to look up the row to update. */
export type PreboardingEmployeeOnPreboardingResultForPreboardingResultPreboardingEmployeeIdForeignUsingPreboardingEmployeePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingEmployee` being updated. */
  patch: UpdatePreboardingEmployeeOnPreboardingResultForPreboardingResultPreboardingEmployeeIdForeignPatch;
};

/** Represents an update to a `PreboardingEmployee`. Fields that are set will be updated. */
export type PreboardingEmployeePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `preboardingEmployee` to look up the row to connect. */
export type PreboardingEmployeePreboardingEmployeePkeyConnect = {
  id: Scalars['UUID'];
};

/** The `preboarding` to be created by this mutation. */
export type PreboardingEmployeePreboardingIdForeignConnectionPreboardingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontStorageId?: InputMaybe<Scalars['UUID']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoStorageId?: InputMaybe<Scalars['UUID']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `preboardingEmployee` to be created by this mutation. */
export type PreboardingEmployeePreboardingIdForeignConnectionPreboardingEmployeeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `preboarding` in the `PreboardingEmployeeInput` mutation. */
export type PreboardingEmployeePreboardingIdForeignInput = {
  /** The primary key(s) for `preboarding` for the far side of the relationship. */
  connectById?: InputMaybe<PreboardingPreboardingPkeyConnect>;
  /** A `PreboardingInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingEmployeePreboardingIdForeignConnectionPreboardingCreateInput>;
  /** The primary key(s) and patch data for `preboarding` for the far side of the relationship. */
  updateById?: InputMaybe<PreboardingOnPreboardingEmployeeForPreboardingEmployeePreboardingIdForeignUsingPreboardingPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingEmployee` in the `PreboardingInput` mutation. */
export type PreboardingEmployeePreboardingIdForeignInverseInput = {
  /** The primary key(s) for `preboardingEmployee` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingEmployeePreboardingEmployeePkeyConnect>>;
  /** A `PreboardingEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingEmployeePreboardingIdForeignConnectionPreboardingEmployeeCreateInput>>;
  /** The primary key(s) and patch data for `preboardingEmployee` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeePreboardingIdForeignUsingPreboardingEmployeePkeyUpdate>>;
};

/** The `preboardingEmployee` to be created by this mutation. */
export type PreboardingEmployeeRecipientIdForeignConnectionPreboardingEmployeeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `user` in the `PreboardingEmployeeInput` mutation. */
export type PreboardingEmployeeRecipientIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnPreboardingEmployeeForPreboardingEmployeeRecipientIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingEmployee` in the `UserInput` mutation. */
export type PreboardingEmployeeRecipientIdForeignInverseInput = {
  /** The primary key(s) for `preboardingEmployee` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingEmployeePreboardingEmployeePkeyConnect>>;
  /** A `PreboardingEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingEmployeeRecipientIdForeignConnectionPreboardingEmployeeCreateInput>>;
  /** The primary key(s) and patch data for `preboardingEmployee` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeRecipientIdForeignUsingPreboardingEmployeePkeyUpdate>>;
};

/** A filter to be used against many `ContractSignPending` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingEmployeeToManyContractSignPendingFilter = {
  /** Every related `ContractSignPending` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractSignPendingFilter>;
  /** No related `ContractSignPending` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractSignPendingFilter>;
  /** Some related `ContractSignPending` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractSignPendingFilter>;
};

/** A filter to be used against many `PreboardingEmailLog` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingEmployeeToManyPreboardingEmailLogFilter = {
  /** Every related `PreboardingEmailLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingEmailLogFilter>;
  /** No related `PreboardingEmailLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingEmailLogFilter>;
  /** Some related `PreboardingEmailLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingEmailLogFilter>;
};

/** A filter to be used against many `PreboardingResult` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingEmployeeToManyPreboardingResultFilter = {
  /** Every related `PreboardingResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingResultFilter>;
  /** No related `PreboardingResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingResultFilter>;
  /** Some related `PreboardingResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingResultFilter>;
};

/** The `preboardingEmployee` to be created by this mutation. */
export type PreboardingEmployeeUserIdFkeyConnectionPreboardingEmployeeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
};

/** Input for the nested mutation of `preboardingEmployee` in the `UserInput` mutation. */
export type PreboardingEmployeeUserIdFkeyInverseInput = {
  /** The primary key(s) for `preboardingEmployee` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingEmployeePreboardingEmployeePkeyConnect>>;
  /** A `PreboardingEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingEmployeeUserIdFkeyConnectionPreboardingEmployeeCreateInput>>;
  /** The primary key(s) and patch data for `preboardingEmployee` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeUserIdFkeyUsingPreboardingEmployeePkeyUpdate>>;
};

/** A connection to a list of `PreboardingEmployee` values. */
export type PreboardingEmployeesConnection = {
  __typename?: 'PreboardingEmployeesConnection';
  /** A list of edges which contains the `PreboardingEmployee` and cursor to aid in pagination. */
  edges: Array<PreboardingEmployeesEdge>;
  /** A list of `PreboardingEmployee` objects. */
  nodes: Array<Maybe<PreboardingEmployee>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PreboardingEmployee` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PreboardingEmployee` edge in the connection. */
export type PreboardingEmployeesEdge = {
  __typename?: 'PreboardingEmployeesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PreboardingEmployee` at the end of the edge. */
  node?: Maybe<PreboardingEmployee>;
};

/** Methods to use when ordering `PreboardingEmployee`. */
export type PreboardingEmployeesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ARCHIVED_ASC'
  | 'ARCHIVED_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPLETED_ASC'
  | 'COMPLETED_DESC'
  | 'COMPLETED_REMINDED_ASC'
  | 'COMPLETED_REMINDED_DESC'
  | 'CONCLUSION_ASC'
  | 'CONCLUSION_DESC'
  | 'CONTRACT_SIGN_PENDINGS_BY_PREBOARDING_EMPLOYEE_ID__COUNT_ASC'
  | 'CONTRACT_SIGN_PENDINGS_BY_PREBOARDING_EMPLOYEE_ID__COUNT_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEADLINE_ASC'
  | 'DEADLINE_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_ID_ASC'
  | 'ENGAGEMENT_TYPE_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MANAGER_IDS_ASC'
  | 'MANAGER_IDS_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PREBOARDING_BY_PREBOARDING_ID__ACTIVE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ACTIVE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ANONYMOUS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ANONYMOUS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ARCHIVED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ARCHIVED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__BACKGROUND_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__BACKGROUND_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CHANNEL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CHANNEL_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CLOSE_ACCESS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CLOSE_ACCESS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPANY_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPANY_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPLETED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPLETED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONFIRM_RESULTS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONFIRM_RESULTS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_BACKGROUND_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_BACKGROUND_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_TEXT_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_TEXT_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_AT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_AT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_FROM_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_FROM_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DATE_FORMAT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DATE_FORMAT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEADLINE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEADLINE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_DIRECT_MANAGER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_DIRECT_MANAGER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_GROUP_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_GROUP_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_USER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_USER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEPARTMENT_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEPARTMENT_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DISABLE_2FA_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DISABLE_2FA_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_BODY_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_BODY_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_SUBJECT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_SUBJECT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMPLOYEE_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMPLOYEE_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FALLBACK_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FALLBACK_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_SIZE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_SIZE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_URL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_URL_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LINK_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LINK_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOCALE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOCALE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_WIDTH_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_WIDTH_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__MANAGER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__MANAGER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NEXT_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NEXT_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ORDER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ORDER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_ENABLED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_ENABLED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREDECESSOR_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREDECESSOR_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREV_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREV_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PUBLISHED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PUBLISHED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_DIRECT_MANAGER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_DIRECT_MANAGER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_GROUP_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_GROUP_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DAYS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DAYS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESPONSIBLE_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESPONSIBLE_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESULT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESULT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__SMS_BODY_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__SMS_BODY_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__START_DATE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__START_DATE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEMPLATE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEMPLATE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEXT_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEXT_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CONTENT_COLORS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CONTENT_COLORS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CUSTOM_LINK_BUTTON_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CUSTOM_LINK_BUTTON_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_LEADER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_LEADER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_WORK_EMAIL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_WORK_EMAIL_DESC'
  | 'PREBOARDING_EMAIL_LOGS_BY_PREBOARDING_EMPLOYEE_ID__COUNT_ASC'
  | 'PREBOARDING_EMAIL_LOGS_BY_PREBOARDING_EMPLOYEE_ID__COUNT_DESC'
  | 'PREBOARDING_ID_ASC'
  | 'PREBOARDING_ID_DESC'
  | 'PREBOARDING_RESULTS_BY_PREBOARDING_EMPLOYEE_ID__COUNT_ASC'
  | 'PREBOARDING_RESULTS_BY_PREBOARDING_EMPLOYEE_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PUBLISHED_ASC'
  | 'PUBLISHED_DATE_ASC'
  | 'PUBLISHED_DATE_DESC'
  | 'PUBLISHED_DESC'
  | 'RECIPIENT_ID_ASC'
  | 'RECIPIENT_ID_DESC'
  | 'REMINDER_ASC'
  | 'REMINDER_DESC'
  | 'RESPONSIBLE_IDS_ASC'
  | 'RESPONSIBLE_IDS_DESC'
  | 'USER_BY_RECIPIENT_ID__ACTIVE_ASC'
  | 'USER_BY_RECIPIENT_ID__ACTIVE_DESC'
  | 'USER_BY_RECIPIENT_ID__ADDRESS_ASC'
  | 'USER_BY_RECIPIENT_ID__ADDRESS_DESC'
  | 'USER_BY_RECIPIENT_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_RECIPIENT_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_RECIPIENT_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_RECIPIENT_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_RECIPIENT_ID__BIRTHDATE_ASC'
  | 'USER_BY_RECIPIENT_ID__BIRTHDATE_DESC'
  | 'USER_BY_RECIPIENT_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_RECIPIENT_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_RECIPIENT_ID__CAN_LOGIN_ASC'
  | 'USER_BY_RECIPIENT_ID__CAN_LOGIN_DESC'
  | 'USER_BY_RECIPIENT_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_RECIPIENT_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_RECIPIENT_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_RECIPIENT_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_RECIPIENT_ID__CITY_ASC'
  | 'USER_BY_RECIPIENT_ID__CITY_DESC'
  | 'USER_BY_RECIPIENT_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_RECIPIENT_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_RECIPIENT_ID__COMPANY_ID_ASC'
  | 'USER_BY_RECIPIENT_ID__COMPANY_ID_DESC'
  | 'USER_BY_RECIPIENT_ID__CPR_ASC'
  | 'USER_BY_RECIPIENT_ID__CPR_DESC'
  | 'USER_BY_RECIPIENT_ID__CUSTOM_ID_ASC'
  | 'USER_BY_RECIPIENT_ID__CUSTOM_ID_DESC'
  | 'USER_BY_RECIPIENT_ID__DELETE_AT_ASC'
  | 'USER_BY_RECIPIENT_ID__DELETE_AT_DESC'
  | 'USER_BY_RECIPIENT_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_RECIPIENT_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_RECIPIENT_ID__DEPARTMENTS_ASC'
  | 'USER_BY_RECIPIENT_ID__DEPARTMENTS_DESC'
  | 'USER_BY_RECIPIENT_ID__EMAIL_ASC'
  | 'USER_BY_RECIPIENT_ID__EMAIL_DESC'
  | 'USER_BY_RECIPIENT_ID__EMAIL_WORK_ASC'
  | 'USER_BY_RECIPIENT_ID__EMAIL_WORK_DESC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_RECIPIENT_ID__FIRST_NAME_ASC'
  | 'USER_BY_RECIPIENT_ID__FIRST_NAME_DESC'
  | 'USER_BY_RECIPIENT_ID__FULL_NAME_ASC'
  | 'USER_BY_RECIPIENT_ID__FULL_NAME_DESC'
  | 'USER_BY_RECIPIENT_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_RECIPIENT_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_RECIPIENT_ID__GODMODE_ASC'
  | 'USER_BY_RECIPIENT_ID__GODMODE_DESC'
  | 'USER_BY_RECIPIENT_ID__GROUP_IDS_ASC'
  | 'USER_BY_RECIPIENT_ID__GROUP_IDS_DESC'
  | 'USER_BY_RECIPIENT_ID__ID_ASC'
  | 'USER_BY_RECIPIENT_ID__ID_DESC'
  | 'USER_BY_RECIPIENT_ID__INITIALS_ASC'
  | 'USER_BY_RECIPIENT_ID__INITIALS_DESC'
  | 'USER_BY_RECIPIENT_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_RECIPIENT_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_RECIPIENT_ID__IS_LEADER_ASC'
  | 'USER_BY_RECIPIENT_ID__IS_LEADER_DESC'
  | 'USER_BY_RECIPIENT_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_RECIPIENT_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_RECIPIENT_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_RECIPIENT_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_RECIPIENT_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_RECIPIENT_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_RECIPIENT_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_RECIPIENT_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_RECIPIENT_ID__LAST_LOGIN_ASC'
  | 'USER_BY_RECIPIENT_ID__LAST_LOGIN_DESC'
  | 'USER_BY_RECIPIENT_ID__LAST_NAME_ASC'
  | 'USER_BY_RECIPIENT_ID__LAST_NAME_DESC'
  | 'USER_BY_RECIPIENT_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_RECIPIENT_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_RECIPIENT_ID__MOBILE_ASC'
  | 'USER_BY_RECIPIENT_ID__MOBILE_DESC'
  | 'USER_BY_RECIPIENT_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_RECIPIENT_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_RECIPIENT_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_RECIPIENT_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_RECIPIENT_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_RECIPIENT_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_RECIPIENT_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_RECIPIENT_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_RECIPIENT_ID__PHONE_ASC'
  | 'USER_BY_RECIPIENT_ID__PHONE_DESC'
  | 'USER_BY_RECIPIENT_ID__POSTAL_CODE_ASC'
  | 'USER_BY_RECIPIENT_ID__POSTAL_CODE_DESC'
  | 'USER_BY_RECIPIENT_ID__SENIORITY_ASC'
  | 'USER_BY_RECIPIENT_ID__SENIORITY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** The `engagementType` to be created by this mutation. */
export type PreboardingEngagementTypeIdForeignConnectionEngagementTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `preboarding` to be created by this mutation. */
export type PreboardingEngagementTypeIdForeignConnectionPreboardingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontStorageId?: InputMaybe<Scalars['UUID']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoStorageId?: InputMaybe<Scalars['UUID']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `engagementType` in the `PreboardingInput` mutation. */
export type PreboardingEngagementTypeIdForeignInput = {
  /** The primary key(s) for `engagementType` for the far side of the relationship. */
  connectById?: InputMaybe<EngagementTypeEngagementTypePkeyConnect>;
  /** A `EngagementTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingEngagementTypeIdForeignConnectionEngagementTypeCreateInput>;
  /** The primary key(s) and patch data for `engagementType` for the far side of the relationship. */
  updateById?: InputMaybe<EngagementTypeOnPreboardingForPreboardingEngagementTypeIdForeignUsingEngagementTypePkeyUpdate>;
};

/** Input for the nested mutation of `preboarding` in the `EngagementTypeInput` mutation. */
export type PreboardingEngagementTypeIdForeignInverseInput = {
  /** The primary key(s) for `preboarding` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingPreboardingPkeyConnect>>;
  /** A `PreboardingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingEngagementTypeIdForeignConnectionPreboardingCreateInput>>;
  /** The primary key(s) and patch data for `preboarding` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingOnPreboardingForPreboardingEngagementTypeIdForeignUsingPreboardingPkeyUpdate>>;
};

/** A filter to be used against `Preboarding` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PreboardingFilter>>;
  /** Filter by the object’s `anonymous` field. */
  anonymous?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `assigneeCount` field. */
  assigneeCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `backgroundColor` field. */
  backgroundColor?: InputMaybe<StringFilter>;
  /** Filter by the object’s `channel` field. */
  channel?: InputMaybe<PreboardingChannelFilter>;
  /** Filter by the object’s `closeAccess` field. */
  closeAccess?: InputMaybe<IntFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** A related `company` exists. */
  companyExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `completed` field. */
  completed?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `confirmResults` field. */
  confirmResults?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `contentBackgroundColor` field. */
  contentBackgroundColor?: InputMaybe<StringFilter>;
  /** Filter by the object’s `contentTextColor` field. */
  contentTextColor?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdFrom` field. */
  createdFrom?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `dateFormat` field. */
  dateFormat?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deadline` field. */
  deadline?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defaultManagerDirectManager` field. */
  defaultManagerDirectManager?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `defaultManagerEmployeeFieldIds` field. */
  defaultManagerEmployeeFieldIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `defaultManagerGroupIds` field. */
  defaultManagerGroupIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `defaultManagerUserIds` field. */
  defaultManagerUserIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `disable2Fa` field. */
  disable2Fa?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `emailBody` field. */
  emailBody?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emailSubject` field. */
  emailSubject?: InputMaybe<StringFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** A related `employee` exists. */
  employeeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `employeeIds` field. */
  employeeIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `engagementType` relation. */
  engagementType?: InputMaybe<EngagementTypeFilter>;
  /** A related `engagementType` exists. */
  engagementTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fallbackText` field. */
  fallbackText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `finishedAssigneeCount` field. */
  finishedAssigneeCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `firstSlideDescription` field. */
  firstSlideDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstSlideName` field. */
  firstSlideName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstSlideTitle` field. */
  firstSlideTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fontSize` field. */
  fontSize?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fontType` field. */
  fontType?: InputMaybe<PreboardingFontTypeFilter>;
  /** Filter by the object’s `fontUrl` field. */
  fontUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `hasHandSignatureField` field. */
  hasHandSignatureField?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isCompleted` field. */
  isCompleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isUncategorized` field. */
  isUncategorized?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lastSlideDescription` field. */
  lastSlideDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lastSlideName` field. */
  lastSlideName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lastSlideTitle` field. */
  lastSlideTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `linkButtonText` field. */
  linkButtonText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `locale` field. */
  locale?: InputMaybe<StringFilter>;
  /** Filter by the object’s `logoType` field. */
  logoType?: InputMaybe<PreboardingLogoTypeFilter>;
  /** Filter by the object’s `logoWidth` field. */
  logoWidth?: InputMaybe<IntFilter>;
  /** Filter by the object’s `managerIds` field. */
  managerIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nextButtonText` field. */
  nextButtonText?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PreboardingFilter>;
  /** Filter by the object’s `notificationEmployeeReferences` relation. */
  notificationEmployeeReferences?: InputMaybe<PreboardingToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferences` exist. */
  notificationEmployeeReferencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `notifications` relation. */
  notifications?: InputMaybe<PreboardingToManyNotificationFilter>;
  /** Some related `notifications` exist. */
  notificationsExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PreboardingFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `overviewSlideDescription` field. */
  overviewSlideDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `overviewSlideEnabled` field. */
  overviewSlideEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `overviewSlideName` field. */
  overviewSlideName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `overviewSlideTitle` field. */
  overviewSlideTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `preboardingByCreatedFrom` relation. */
  preboardingByCreatedFrom?: InputMaybe<PreboardingFilter>;
  /** A related `preboardingByCreatedFrom` exists. */
  preboardingByCreatedFromExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingComments` relation. */
  preboardingComments?: InputMaybe<PreboardingToManyPreboardingCommentFilter>;
  /** Some related `preboardingComments` exist. */
  preboardingCommentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingEmployees` relation. */
  preboardingEmployees?: InputMaybe<PreboardingToManyPreboardingEmployeeFilter>;
  /** Some related `preboardingEmployees` exist. */
  preboardingEmployeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingFormCaches` relation. */
  preboardingFormCaches?: InputMaybe<PreboardingToManyPreboardingFormCacheFilter>;
  /** Some related `preboardingFormCaches` exist. */
  preboardingFormCachesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingProcesses` relation. */
  preboardingProcesses?: InputMaybe<PreboardingToManyPreboardingProcessFilter>;
  /** Some related `preboardingProcesses` exist. */
  preboardingProcessesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingSlides` relation. */
  preboardingSlides?: InputMaybe<PreboardingToManyPreboardingSlideFilter>;
  /** Some related `preboardingSlides` exist. */
  preboardingSlidesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingsByCreatedFrom` relation. */
  preboardingsByCreatedFrom?: InputMaybe<PreboardingToManyPreboardingFilter>;
  /** Some related `preboardingsByCreatedFrom` exist. */
  preboardingsByCreatedFromExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingsByPredecessorId` relation. */
  preboardingsByPredecessorId?: InputMaybe<PreboardingToManyPreboardingFilter>;
  /** Some related `preboardingsByPredecessorId` exist. */
  preboardingsByPredecessorIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `predecessor` relation. */
  predecessor?: InputMaybe<PreboardingFilter>;
  /** A related `predecessor` exists. */
  predecessorExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `predecessorId` field. */
  predecessorId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `prevButtonText` field. */
  prevButtonText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `published` field. */
  published?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `recipient` relation. */
  recipient?: InputMaybe<UserFilter>;
  /** Filter by the object’s `recipientCustomEmployeeField` relation. */
  recipientCustomEmployeeField?: InputMaybe<FormFieldFilter>;
  /** A related `recipientCustomEmployeeField` exists. */
  recipientCustomEmployeeFieldExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `recipientCustomEmployeeFieldId` field. */
  recipientCustomEmployeeFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `recipientDirectManager` field. */
  recipientDirectManager?: InputMaybe<BooleanFilter>;
  /** A related `recipient` exists. */
  recipientExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `recipientGroup` relation. */
  recipientGroup?: InputMaybe<GroupFilter>;
  /** A related `recipientGroup` exists. */
  recipientGroupExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `recipientGroupId` field. */
  recipientGroupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `recipientId` field. */
  recipientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `reminded` field. */
  reminded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `reminder` field. */
  reminder?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `reminderDays` field. */
  reminderDays?: InputMaybe<IntFilter>;
  /** Filter by the object’s `responsibleIds` field. */
  responsibleIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `result` field. */
  result?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `smsBody` field. */
  smsBody?: InputMaybe<StringFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `template` field. */
  template?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `textColor` field. */
  textColor?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<PreboardingTypeFilter>;
  /** Filter by the object’s `useContentColors` field. */
  useContentColors?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `useCustomLinkButtonColor` field. */
  useCustomLinkButtonColor?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `useLeader` field. */
  useLeader?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `useWorkEmail` field. */
  useWorkEmail?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `userIds` field. */
  userIds?: InputMaybe<UuidListFilter>;
};

export type PreboardingFontType =
  | 'LINK'
  | 'STANDARD'
  | 'UPLOAD';

/** A filter to be used against PreboardingFontType fields. All fields are combined with a logical ‘and.’ */
export type PreboardingFontTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PreboardingFontType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PreboardingFontType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PreboardingFontType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PreboardingFontType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PreboardingFontType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PreboardingFontType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PreboardingFontType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PreboardingFontType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PreboardingFontType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PreboardingFontType>>;
};

export type PreboardingFormCache = {
  __typename?: 'PreboardingFormCache';
  formValues?: Maybe<Scalars['JSON']>;
  page?: Maybe<Scalars['String']>;
  /** Reads a single `Preboarding` that is related to this `PreboardingFormCache`. */
  preboarding?: Maybe<Preboarding>;
  preboardingId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `PreboardingFormCache`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/**
 * A condition to be used against `PreboardingFormCache` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PreboardingFormCacheCondition = {
  /** Checks for equality with the object’s `formValues` field. */
  formValues?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `page` field. */
  page?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `preboardingId` field. */
  preboardingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `PreboardingFormCache` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingFormCacheFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PreboardingFormCacheFilter>>;
  /** Filter by the object’s `formValues` field. */
  formValues?: InputMaybe<JsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PreboardingFormCacheFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PreboardingFormCacheFilter>>;
  /** Filter by the object’s `page` field. */
  page?: InputMaybe<StringFilter>;
  /** Filter by the object’s `preboarding` relation. */
  preboarding?: InputMaybe<PreboardingFilter>;
  /** Filter by the object’s `preboardingId` field. */
  preboardingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `PreboardingFormCache` */
export type PreboardingFormCacheInput = {
  formValues?: InputMaybe<Scalars['JSON']>;
  page?: InputMaybe<Scalars['String']>;
  preboarding?: InputMaybe<PreboardingFormCachePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<PreboardingFormCacheUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `preboardingFormCache` to look up the row to update. */
export type PreboardingFormCacheOnPreboardingFormCacheForPreboardingFormCachePreboardingIdForeignUsingPreboardingFormCachePkeyUpdate = {
  /** An object where the defined keys will be set on the `preboardingFormCache` being updated. */
  patch: UpdatePreboardingFormCacheOnPreboardingFormCacheForPreboardingFormCachePreboardingIdForeignPatch;
  preboardingId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `preboardingFormCache` to look up the row to update. */
export type PreboardingFormCacheOnPreboardingFormCacheForPreboardingFormCacheUserIdForeignUsingPreboardingFormCachePkeyUpdate = {
  /** An object where the defined keys will be set on the `preboardingFormCache` being updated. */
  patch: UpdatePreboardingFormCacheOnPreboardingFormCacheForPreboardingFormCacheUserIdForeignPatch;
  preboardingId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** Represents an update to a `PreboardingFormCache`. Fields that are set will be updated. */
export type PreboardingFormCachePatch = {
  formValues?: InputMaybe<Scalars['JSON']>;
  page?: InputMaybe<Scalars['String']>;
  preboarding?: InputMaybe<PreboardingFormCachePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<PreboardingFormCacheUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `preboardingFormCache` to look up the row to connect. */
export type PreboardingFormCachePreboardingFormCachePkeyConnect = {
  preboardingId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The `preboarding` to be created by this mutation. */
export type PreboardingFormCachePreboardingIdForeignConnectionPreboardingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontStorageId?: InputMaybe<Scalars['UUID']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoStorageId?: InputMaybe<Scalars['UUID']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `preboardingFormCache` to be created by this mutation. */
export type PreboardingFormCachePreboardingIdForeignConnectionPreboardingFormCacheCreateInput = {
  formValues?: InputMaybe<Scalars['JSON']>;
  page?: InputMaybe<Scalars['String']>;
  preboarding?: InputMaybe<PreboardingFormCachePreboardingIdForeignInput>;
  user?: InputMaybe<PreboardingFormCacheUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `preboarding` in the `PreboardingFormCacheInput` mutation. */
export type PreboardingFormCachePreboardingIdForeignInput = {
  /** The primary key(s) for `preboarding` for the far side of the relationship. */
  connectById?: InputMaybe<PreboardingPreboardingPkeyConnect>;
  /** A `PreboardingInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingFormCachePreboardingIdForeignConnectionPreboardingCreateInput>;
  /** The primary key(s) and patch data for `preboarding` for the far side of the relationship. */
  updateById?: InputMaybe<PreboardingOnPreboardingFormCacheForPreboardingFormCachePreboardingIdForeignUsingPreboardingPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingFormCache` in the `PreboardingInput` mutation. */
export type PreboardingFormCachePreboardingIdForeignInverseInput = {
  /** The primary key(s) for `preboardingFormCache` for the far side of the relationship. */
  connectByPreboardingIdAndUserId?: InputMaybe<Array<PreboardingFormCachePreboardingFormCachePkeyConnect>>;
  /** A `PreboardingFormCacheInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingFormCachePreboardingIdForeignConnectionPreboardingFormCacheCreateInput>>;
  /** The primary key(s) and patch data for `preboardingFormCache` for the far side of the relationship. */
  updateByPreboardingIdAndUserId?: InputMaybe<Array<PreboardingFormCacheOnPreboardingFormCacheForPreboardingFormCachePreboardingIdForeignUsingPreboardingFormCachePkeyUpdate>>;
};

/** The `preboardingFormCache` to be created by this mutation. */
export type PreboardingFormCacheUserIdForeignConnectionPreboardingFormCacheCreateInput = {
  formValues?: InputMaybe<Scalars['JSON']>;
  page?: InputMaybe<Scalars['String']>;
  preboarding?: InputMaybe<PreboardingFormCachePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<PreboardingFormCacheUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `PreboardingFormCacheInput` mutation. */
export type PreboardingFormCacheUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnPreboardingFormCacheForPreboardingFormCacheUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingFormCache` in the `UserInput` mutation. */
export type PreboardingFormCacheUserIdForeignInverseInput = {
  /** The primary key(s) for `preboardingFormCache` for the far side of the relationship. */
  connectByPreboardingIdAndUserId?: InputMaybe<Array<PreboardingFormCachePreboardingFormCachePkeyConnect>>;
  /** A `PreboardingFormCacheInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingFormCacheUserIdForeignConnectionPreboardingFormCacheCreateInput>>;
  /** The primary key(s) and patch data for `preboardingFormCache` for the far side of the relationship. */
  updateByPreboardingIdAndUserId?: InputMaybe<Array<PreboardingFormCacheOnPreboardingFormCacheForPreboardingFormCacheUserIdForeignUsingPreboardingFormCachePkeyUpdate>>;
};

/** A connection to a list of `PreboardingFormCache` values. */
export type PreboardingFormCachesConnection = {
  __typename?: 'PreboardingFormCachesConnection';
  /** A list of edges which contains the `PreboardingFormCache` and cursor to aid in pagination. */
  edges: Array<PreboardingFormCachesEdge>;
  /** A list of `PreboardingFormCache` objects. */
  nodes: Array<Maybe<PreboardingFormCache>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PreboardingFormCache` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PreboardingFormCache` edge in the connection. */
export type PreboardingFormCachesEdge = {
  __typename?: 'PreboardingFormCachesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PreboardingFormCache` at the end of the edge. */
  node?: Maybe<PreboardingFormCache>;
};

/** Methods to use when ordering `PreboardingFormCache`. */
export type PreboardingFormCachesOrderBy =
  | 'FORM_VALUES_ASC'
  | 'FORM_VALUES_DESC'
  | 'NATURAL'
  | 'PAGE_ASC'
  | 'PAGE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ACTIVE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ACTIVE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ANONYMOUS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ANONYMOUS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ARCHIVED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ARCHIVED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__BACKGROUND_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__BACKGROUND_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CHANNEL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CHANNEL_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CLOSE_ACCESS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CLOSE_ACCESS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPANY_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPANY_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPLETED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPLETED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONFIRM_RESULTS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONFIRM_RESULTS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_BACKGROUND_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_BACKGROUND_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_TEXT_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_TEXT_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_AT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_AT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_FROM_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_FROM_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DATE_FORMAT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DATE_FORMAT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEADLINE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEADLINE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_DIRECT_MANAGER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_DIRECT_MANAGER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_GROUP_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_GROUP_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_USER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_USER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEPARTMENT_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEPARTMENT_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DISABLE_2FA_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DISABLE_2FA_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_BODY_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_BODY_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_SUBJECT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_SUBJECT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMPLOYEE_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMPLOYEE_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FALLBACK_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FALLBACK_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_SIZE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_SIZE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_URL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_URL_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LINK_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LINK_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOCALE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOCALE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_WIDTH_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_WIDTH_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__MANAGER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__MANAGER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NEXT_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NEXT_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ORDER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ORDER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_ENABLED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_ENABLED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREDECESSOR_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREDECESSOR_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREV_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREV_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PUBLISHED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PUBLISHED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_DIRECT_MANAGER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_DIRECT_MANAGER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_GROUP_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_GROUP_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DAYS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DAYS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESPONSIBLE_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESPONSIBLE_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESULT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESULT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__SMS_BODY_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__SMS_BODY_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__START_DATE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__START_DATE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEMPLATE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEMPLATE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEXT_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEXT_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CONTENT_COLORS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CONTENT_COLORS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CUSTOM_LINK_BUTTON_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CUSTOM_LINK_BUTTON_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_LEADER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_LEADER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_WORK_EMAIL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_WORK_EMAIL_DESC'
  | 'PREBOARDING_ID_ASC'
  | 'PREBOARDING_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** An input for mutations affecting `Preboarding` */
export type PreboardingInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontStorageId?: InputMaybe<Scalars['UUID']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoStorageId?: InputMaybe<Scalars['UUID']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

export type PreboardingLogoType =
  | 'COMPANY'
  | 'CUSTOM'
  | 'NONE';

/** A filter to be used against PreboardingLogoType fields. All fields are combined with a logical ‘and.’ */
export type PreboardingLogoTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PreboardingLogoType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PreboardingLogoType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PreboardingLogoType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PreboardingLogoType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PreboardingLogoType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PreboardingLogoType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PreboardingLogoType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PreboardingLogoType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PreboardingLogoType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PreboardingLogoType>>;
};

/** The fields on `preboarding` to look up the row to update. */
export type PreboardingOnNotificationEmployeeReferenceForNotificationEmployeeReferencePreboardingIdForeignUsingPreboardingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboarding` being updated. */
  patch: UpdatePreboardingOnNotificationEmployeeReferenceForNotificationEmployeeReferencePreboardingIdForeignPatch;
};

/** The fields on `preboarding` to look up the row to update. */
export type PreboardingOnNotificationForNotificationPreboardingIdForeignUsingPreboardingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboarding` being updated. */
  patch: UpdatePreboardingOnNotificationForNotificationPreboardingIdForeignPatch;
};

/** The fields on `preboarding` to look up the row to update. */
export type PreboardingOnPreboardingCommentForPreboardingCommentPreboardingIdForeignUsingPreboardingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboarding` being updated. */
  patch: UpdatePreboardingOnPreboardingCommentForPreboardingCommentPreboardingIdForeignPatch;
};

/** The fields on `preboarding` to look up the row to update. */
export type PreboardingOnPreboardingEmployeeForPreboardingEmployeePreboardingIdForeignUsingPreboardingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboarding` being updated. */
  patch: UpdatePreboardingOnPreboardingEmployeeForPreboardingEmployeePreboardingIdForeignPatch;
};

/** The fields on `preboarding` to look up the row to update. */
export type PreboardingOnPreboardingForPreboardingCompanyIdForeignUsingPreboardingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboarding` being updated. */
  patch: UpdatePreboardingOnPreboardingForPreboardingCompanyIdForeignPatch;
};

/** The fields on `preboarding` to look up the row to update. */
export type PreboardingOnPreboardingForPreboardingCreatedFromForeignUsingPreboardingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboarding` being updated. */
  patch: UpdatePreboardingOnPreboardingForPreboardingCreatedFromForeignPatch;
};

/** The fields on `preboarding` to look up the row to update. */
export type PreboardingOnPreboardingForPreboardingEmployeeIdForeignUsingPreboardingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboarding` being updated. */
  patch: UpdatePreboardingOnPreboardingForPreboardingEmployeeIdForeignPatch;
};

/** The fields on `preboarding` to look up the row to update. */
export type PreboardingOnPreboardingForPreboardingEngagementTypeIdForeignUsingPreboardingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboarding` being updated. */
  patch: UpdatePreboardingOnPreboardingForPreboardingEngagementTypeIdForeignPatch;
};

/** The fields on `preboarding` to look up the row to update. */
export type PreboardingOnPreboardingForPreboardingPredecessorIdForeignUsingPreboardingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboarding` being updated. */
  patch: UpdatePreboardingOnPreboardingForPreboardingPredecessorIdForeignPatch;
};

/** The fields on `preboarding` to look up the row to update. */
export type PreboardingOnPreboardingForPreboardingRecipientCustomEmployeeFieldIdForeignUsingPreboardingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboarding` being updated. */
  patch: UpdatePreboardingOnPreboardingForPreboardingRecipientCustomEmployeeFieldIdForeignPatch;
};

/** The fields on `preboarding` to look up the row to update. */
export type PreboardingOnPreboardingForPreboardingRecipientGroupIdForeignUsingPreboardingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboarding` being updated. */
  patch: UpdatePreboardingOnPreboardingForPreboardingRecipientGroupIdForeignPatch;
};

/** The fields on `preboarding` to look up the row to update. */
export type PreboardingOnPreboardingForPreboardingRecipientIdForeignUsingPreboardingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboarding` being updated. */
  patch: UpdatePreboardingOnPreboardingForPreboardingRecipientIdForeignPatch;
};

/** The fields on `preboarding` to look up the row to update. */
export type PreboardingOnPreboardingFormCacheForPreboardingFormCachePreboardingIdForeignUsingPreboardingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboarding` being updated. */
  patch: UpdatePreboardingOnPreboardingFormCacheForPreboardingFormCachePreboardingIdForeignPatch;
};

/** The fields on `preboarding` to look up the row to update. */
export type PreboardingOnPreboardingProcessForPreboardingProcessPreboardingIdForeignUsingPreboardingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboarding` being updated. */
  patch: UpdatePreboardingOnPreboardingProcessForPreboardingProcessPreboardingIdForeignPatch;
};

/** The fields on `preboarding` to look up the row to update. */
export type PreboardingOnPreboardingSlideForPreboardingSlidePreboardingIdForeignUsingPreboardingPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboarding` being updated. */
  patch: UpdatePreboardingOnPreboardingSlideForPreboardingSlidePreboardingIdForeignPatch;
};

/** Represents an update to a `Preboarding`. Fields that are set will be updated. */
export type PreboardingPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The fields on `preboarding` to look up the row to connect. */
export type PreboardingPreboardingPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `preboarding` to be created by this mutation. */
export type PreboardingPredecessorIdForeignConnectionPreboardingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontStorageId?: InputMaybe<Scalars['UUID']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoStorageId?: InputMaybe<Scalars['UUID']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `preboarding` in the `PreboardingInput` mutation. */
export type PreboardingPredecessorIdForeignInput = {
  /** The primary key(s) for `preboarding` for the far side of the relationship. */
  connectById?: InputMaybe<PreboardingPreboardingPkeyConnect>;
  /** A `PreboardingInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingPredecessorIdForeignConnectionPreboardingCreateInput>;
  /** The primary key(s) and patch data for `preboarding` for the far side of the relationship. */
  updateById?: InputMaybe<PreboardingOnPreboardingForPreboardingPredecessorIdForeignUsingPreboardingPkeyUpdate>;
};

export type PreboardingProcess = {
  __typename?: 'PreboardingProcess';
  /** Reads a single `Company` that is related to this `PreboardingProcess`. */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['UUID']>;
  deadlineReminder?: Maybe<Scalars['Int']>;
  deadlineReminderDate?: Maybe<Scalars['Datetime']>;
  departmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  duration?: Maybe<Scalars['Int']>;
  /** Reads a single `Employee` that is related to this `PreboardingProcess`. */
  employee?: Maybe<Employee>;
  employeeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `EngagementType` that is related to this `PreboardingProcess`. */
  engagementType?: Maybe<EngagementType>;
  engagementTypeId?: Maybe<Scalars['UUID']>;
  order?: Maybe<Scalars['Int']>;
  /** Reads a single `Preboarding` that is related to this `PreboardingProcess`. */
  preboarding?: Maybe<Preboarding>;
  preboardingId: Scalars['UUID'];
  /** Reads a single `Process` that is related to this `PreboardingProcess`. */
  process?: Maybe<Process>;
  processId: Scalars['UUID'];
  sendDate?: Maybe<Scalars['Datetime']>;
  sendTime: Scalars['Time'];
  startDay?: Maybe<Scalars['Int']>;
  template: Scalars['Boolean'];
  /** Reads a single `User` that is related to this `PreboardingProcess`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

/** The `preboardingProcess` to be created by this mutation. */
export type PreboardingProcessCompanyIdForeignConnectionPreboardingProcessCreateInput = {
  company?: InputMaybe<PreboardingProcessCompanyIdForeignInput>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<PreboardingProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboarding?: InputMaybe<PreboardingProcessPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<PreboardingProcessProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `PreboardingProcessInput` mutation. */
export type PreboardingProcessCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnPreboardingProcessForPreboardingProcessCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingProcess` in the `CompanyInput` mutation. */
export type PreboardingProcessCompanyIdForeignInverseInput = {
  /** The primary key(s) for `preboardingProcess` for the far side of the relationship. */
  connectByPreboardingIdAndProcessId?: InputMaybe<Array<PreboardingProcessPreboardingProcessPkeyConnect>>;
  /** A `PreboardingProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingProcessCompanyIdForeignConnectionPreboardingProcessCreateInput>>;
  /** The primary key(s) for `preboardingProcess` for the far side of the relationship. */
  deleteByPreboardingIdAndProcessId?: InputMaybe<Array<PreboardingProcessPreboardingProcessPkeyDelete>>;
  /** Flag indicating whether all other `preboardingProcess` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingProcess` for the far side of the relationship. */
  updateByPreboardingIdAndProcessId?: InputMaybe<Array<PreboardingProcessOnPreboardingProcessForPreboardingProcessCompanyIdForeignUsingPreboardingProcessPkeyUpdate>>;
};

/**
 * A condition to be used against `PreboardingProcess` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PreboardingProcessCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `deadlineReminder` field. */
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `deadlineReminderDate` field. */
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `preboardingId` field. */
  preboardingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `processId` field. */
  processId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `sendDate` field. */
  sendDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `sendTime` field. */
  sendTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `startDay` field. */
  startDay?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `template` field. */
  template?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `preboardingProcess` to be created by this mutation. */
export type PreboardingProcessEmployeeIdForeignConnectionPreboardingProcessCreateInput = {
  company?: InputMaybe<PreboardingProcessCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<PreboardingProcessEmployeeIdForeignInput>;
  engagementType?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboarding?: InputMaybe<PreboardingProcessPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<PreboardingProcessProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `employee` in the `PreboardingProcessInput` mutation. */
export type PreboardingProcessEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnPreboardingProcessForPreboardingProcessEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnPreboardingProcessForPreboardingProcessEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `preboardingProcess` in the `EmployeeInput` mutation. */
export type PreboardingProcessEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `preboardingProcess` for the far side of the relationship. */
  connectByPreboardingIdAndProcessId?: InputMaybe<Array<PreboardingProcessPreboardingProcessPkeyConnect>>;
  /** A `PreboardingProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingProcessEmployeeIdForeignConnectionPreboardingProcessCreateInput>>;
  /** The primary key(s) for `preboardingProcess` for the far side of the relationship. */
  deleteByPreboardingIdAndProcessId?: InputMaybe<Array<PreboardingProcessPreboardingProcessPkeyDelete>>;
  /** Flag indicating whether all other `preboardingProcess` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingProcess` for the far side of the relationship. */
  updateByPreboardingIdAndProcessId?: InputMaybe<Array<PreboardingProcessOnPreboardingProcessForPreboardingProcessEmployeeIdForeignUsingPreboardingProcessPkeyUpdate>>;
};

/** The `engagementType` to be created by this mutation. */
export type PreboardingProcessEngagementTypeIdForeignConnectionEngagementTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `preboardingProcess` to be created by this mutation. */
export type PreboardingProcessEngagementTypeIdForeignConnectionPreboardingProcessCreateInput = {
  company?: InputMaybe<PreboardingProcessCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<PreboardingProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboarding?: InputMaybe<PreboardingProcessPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<PreboardingProcessProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `engagementType` in the `PreboardingProcessInput` mutation. */
export type PreboardingProcessEngagementTypeIdForeignInput = {
  /** The primary key(s) for `engagementType` for the far side of the relationship. */
  connectById?: InputMaybe<EngagementTypeEngagementTypePkeyConnect>;
  /** A `EngagementTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingProcessEngagementTypeIdForeignConnectionEngagementTypeCreateInput>;
  /** The primary key(s) and patch data for `engagementType` for the far side of the relationship. */
  updateById?: InputMaybe<EngagementTypeOnPreboardingProcessForPreboardingProcessEngagementTypeIdForeignUsingEngagementTypePkeyUpdate>;
};

/** Input for the nested mutation of `preboardingProcess` in the `EngagementTypeInput` mutation. */
export type PreboardingProcessEngagementTypeIdForeignInverseInput = {
  /** The primary key(s) for `preboardingProcess` for the far side of the relationship. */
  connectByPreboardingIdAndProcessId?: InputMaybe<Array<PreboardingProcessPreboardingProcessPkeyConnect>>;
  /** A `PreboardingProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingProcessEngagementTypeIdForeignConnectionPreboardingProcessCreateInput>>;
  /** The primary key(s) for `preboardingProcess` for the far side of the relationship. */
  deleteByPreboardingIdAndProcessId?: InputMaybe<Array<PreboardingProcessPreboardingProcessPkeyDelete>>;
  /** Flag indicating whether all other `preboardingProcess` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingProcess` for the far side of the relationship. */
  updateByPreboardingIdAndProcessId?: InputMaybe<Array<PreboardingProcessOnPreboardingProcessForPreboardingProcessEngagementTypeIdForeignUsingPreboardingProcessPkeyUpdate>>;
};

/** A filter to be used against `PreboardingProcess` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingProcessFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PreboardingProcessFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** A related `company` exists. */
  companyExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `deadlineReminder` field. */
  deadlineReminder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `deadlineReminderDate` field. */
  deadlineReminderDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** A related `employee` exists. */
  employeeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `engagementType` relation. */
  engagementType?: InputMaybe<EngagementTypeFilter>;
  /** A related `engagementType` exists. */
  engagementTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PreboardingProcessFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PreboardingProcessFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `preboarding` relation. */
  preboarding?: InputMaybe<PreboardingFilter>;
  /** Filter by the object’s `preboardingId` field. */
  preboardingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `process` relation. */
  process?: InputMaybe<ProcessFilter>;
  /** Filter by the object’s `processId` field. */
  processId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `sendDate` field. */
  sendDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `sendTime` field. */
  sendTime?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `startDay` field. */
  startDay?: InputMaybe<IntFilter>;
  /** Filter by the object’s `template` field. */
  template?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `PreboardingProcess` */
export type PreboardingProcessInput = {
  company?: InputMaybe<PreboardingProcessCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<PreboardingProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboarding?: InputMaybe<PreboardingProcessPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<PreboardingProcessProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `preboardingProcess` to look up the row to update. */
export type PreboardingProcessOnPreboardingProcessForPreboardingProcessCompanyIdForeignUsingPreboardingProcessPkeyUpdate = {
  /** An object where the defined keys will be set on the `preboardingProcess` being updated. */
  patch: UpdatePreboardingProcessOnPreboardingProcessForPreboardingProcessCompanyIdForeignPatch;
  preboardingId: Scalars['UUID'];
  processId: Scalars['UUID'];
};

/** The fields on `preboardingProcess` to look up the row to update. */
export type PreboardingProcessOnPreboardingProcessForPreboardingProcessEmployeeIdForeignUsingPreboardingProcessPkeyUpdate = {
  /** An object where the defined keys will be set on the `preboardingProcess` being updated. */
  patch: UpdatePreboardingProcessOnPreboardingProcessForPreboardingProcessEmployeeIdForeignPatch;
  preboardingId: Scalars['UUID'];
  processId: Scalars['UUID'];
};

/** The fields on `preboardingProcess` to look up the row to update. */
export type PreboardingProcessOnPreboardingProcessForPreboardingProcessEngagementTypeIdForeignUsingPreboardingProcessPkeyUpdate = {
  /** An object where the defined keys will be set on the `preboardingProcess` being updated. */
  patch: UpdatePreboardingProcessOnPreboardingProcessForPreboardingProcessEngagementTypeIdForeignPatch;
  preboardingId: Scalars['UUID'];
  processId: Scalars['UUID'];
};

/** The fields on `preboardingProcess` to look up the row to update. */
export type PreboardingProcessOnPreboardingProcessForPreboardingProcessPreboardingIdForeignUsingPreboardingProcessPkeyUpdate = {
  /** An object where the defined keys will be set on the `preboardingProcess` being updated. */
  patch: UpdatePreboardingProcessOnPreboardingProcessForPreboardingProcessPreboardingIdForeignPatch;
  preboardingId: Scalars['UUID'];
  processId: Scalars['UUID'];
};

/** The fields on `preboardingProcess` to look up the row to update. */
export type PreboardingProcessOnPreboardingProcessForPreboardingProcessProcessIdForeignUsingPreboardingProcessPkeyUpdate = {
  /** An object where the defined keys will be set on the `preboardingProcess` being updated. */
  patch: UpdatePreboardingProcessOnPreboardingProcessForPreboardingProcessProcessIdForeignPatch;
  preboardingId: Scalars['UUID'];
  processId: Scalars['UUID'];
};

/** The fields on `preboardingProcess` to look up the row to update. */
export type PreboardingProcessOnPreboardingProcessForPreboardingProcessUserIdForeignUsingPreboardingProcessPkeyUpdate = {
  /** An object where the defined keys will be set on the `preboardingProcess` being updated. */
  patch: UpdatePreboardingProcessOnPreboardingProcessForPreboardingProcessUserIdForeignPatch;
  preboardingId: Scalars['UUID'];
  processId: Scalars['UUID'];
};

/** Represents an update to a `PreboardingProcess`. Fields that are set will be updated. */
export type PreboardingProcessPatch = {
  company?: InputMaybe<PreboardingProcessCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<PreboardingProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboarding?: InputMaybe<PreboardingProcessPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<PreboardingProcessProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `preboarding` to be created by this mutation. */
export type PreboardingProcessPreboardingIdForeignConnectionPreboardingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontStorageId?: InputMaybe<Scalars['UUID']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoStorageId?: InputMaybe<Scalars['UUID']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `preboardingProcess` to be created by this mutation. */
export type PreboardingProcessPreboardingIdForeignConnectionPreboardingProcessCreateInput = {
  company?: InputMaybe<PreboardingProcessCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<PreboardingProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboarding?: InputMaybe<PreboardingProcessPreboardingIdForeignInput>;
  process?: InputMaybe<PreboardingProcessProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `preboarding` in the `PreboardingProcessInput` mutation. */
export type PreboardingProcessPreboardingIdForeignInput = {
  /** The primary key(s) for `preboarding` for the far side of the relationship. */
  connectById?: InputMaybe<PreboardingPreboardingPkeyConnect>;
  /** A `PreboardingInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingProcessPreboardingIdForeignConnectionPreboardingCreateInput>;
  /** The primary key(s) and patch data for `preboarding` for the far side of the relationship. */
  updateById?: InputMaybe<PreboardingOnPreboardingProcessForPreboardingProcessPreboardingIdForeignUsingPreboardingPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingProcess` in the `PreboardingInput` mutation. */
export type PreboardingProcessPreboardingIdForeignInverseInput = {
  /** The primary key(s) for `preboardingProcess` for the far side of the relationship. */
  connectByPreboardingIdAndProcessId?: InputMaybe<Array<PreboardingProcessPreboardingProcessPkeyConnect>>;
  /** A `PreboardingProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingProcessPreboardingIdForeignConnectionPreboardingProcessCreateInput>>;
  /** The primary key(s) for `preboardingProcess` for the far side of the relationship. */
  deleteByPreboardingIdAndProcessId?: InputMaybe<Array<PreboardingProcessPreboardingProcessPkeyDelete>>;
  /** Flag indicating whether all other `preboardingProcess` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingProcess` for the far side of the relationship. */
  updateByPreboardingIdAndProcessId?: InputMaybe<Array<PreboardingProcessOnPreboardingProcessForPreboardingProcessPreboardingIdForeignUsingPreboardingProcessPkeyUpdate>>;
};

/** The fields on `preboardingProcess` to look up the row to connect. */
export type PreboardingProcessPreboardingProcessPkeyConnect = {
  preboardingId: Scalars['UUID'];
  processId: Scalars['UUID'];
};

/** The fields on `preboardingProcess` to look up the row to delete. */
export type PreboardingProcessPreboardingProcessPkeyDelete = {
  preboardingId: Scalars['UUID'];
  processId: Scalars['UUID'];
};

/** The `preboardingProcess` to be created by this mutation. */
export type PreboardingProcessProcessIdForeignConnectionPreboardingProcessCreateInput = {
  company?: InputMaybe<PreboardingProcessCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<PreboardingProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboarding?: InputMaybe<PreboardingProcessPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<PreboardingProcessProcessIdForeignInput>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `process` to be created by this mutation. */
export type PreboardingProcessProcessIdForeignConnectionProcessCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `process` in the `PreboardingProcessInput` mutation. */
export type PreboardingProcessProcessIdForeignInput = {
  /** The primary key(s) for `process` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessProcessPkeyConnect>;
  /** A `ProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingProcessProcessIdForeignConnectionProcessCreateInput>;
  /** The primary key(s) and patch data for `process` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessOnPreboardingProcessForPreboardingProcessProcessIdForeignUsingProcessPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingProcess` in the `ProcessInput` mutation. */
export type PreboardingProcessProcessIdForeignInverseInput = {
  /** The primary key(s) for `preboardingProcess` for the far side of the relationship. */
  connectByPreboardingIdAndProcessId?: InputMaybe<Array<PreboardingProcessPreboardingProcessPkeyConnect>>;
  /** A `PreboardingProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingProcessProcessIdForeignConnectionPreboardingProcessCreateInput>>;
  /** The primary key(s) for `preboardingProcess` for the far side of the relationship. */
  deleteByPreboardingIdAndProcessId?: InputMaybe<Array<PreboardingProcessPreboardingProcessPkeyDelete>>;
  /** Flag indicating whether all other `preboardingProcess` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingProcess` for the far side of the relationship. */
  updateByPreboardingIdAndProcessId?: InputMaybe<Array<PreboardingProcessOnPreboardingProcessForPreboardingProcessProcessIdForeignUsingPreboardingProcessPkeyUpdate>>;
};

/** The `preboardingProcess` to be created by this mutation. */
export type PreboardingProcessUserIdForeignConnectionPreboardingProcessCreateInput = {
  company?: InputMaybe<PreboardingProcessCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<PreboardingProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboarding?: InputMaybe<PreboardingProcessPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<PreboardingProcessProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingProcessUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `PreboardingProcessInput` mutation. */
export type PreboardingProcessUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnPreboardingProcessForPreboardingProcessUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingProcess` in the `UserInput` mutation. */
export type PreboardingProcessUserIdForeignInverseInput = {
  /** The primary key(s) for `preboardingProcess` for the far side of the relationship. */
  connectByPreboardingIdAndProcessId?: InputMaybe<Array<PreboardingProcessPreboardingProcessPkeyConnect>>;
  /** A `PreboardingProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingProcessUserIdForeignConnectionPreboardingProcessCreateInput>>;
  /** The primary key(s) for `preboardingProcess` for the far side of the relationship. */
  deleteByPreboardingIdAndProcessId?: InputMaybe<Array<PreboardingProcessPreboardingProcessPkeyDelete>>;
  /** Flag indicating whether all other `preboardingProcess` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingProcess` for the far side of the relationship. */
  updateByPreboardingIdAndProcessId?: InputMaybe<Array<PreboardingProcessOnPreboardingProcessForPreboardingProcessUserIdForeignUsingPreboardingProcessPkeyUpdate>>;
};

/** A connection to a list of `PreboardingProcess` values. */
export type PreboardingProcessesConnection = {
  __typename?: 'PreboardingProcessesConnection';
  /** A list of edges which contains the `PreboardingProcess` and cursor to aid in pagination. */
  edges: Array<PreboardingProcessesEdge>;
  /** A list of `PreboardingProcess` objects. */
  nodes: Array<Maybe<PreboardingProcess>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PreboardingProcess` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PreboardingProcess` edge in the connection. */
export type PreboardingProcessesEdge = {
  __typename?: 'PreboardingProcessesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PreboardingProcess` at the end of the edge. */
  node?: Maybe<PreboardingProcess>;
};

/** Methods to use when ordering `PreboardingProcess`. */
export type PreboardingProcessesOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEADLINE_REMINDER_ASC'
  | 'DEADLINE_REMINDER_DATE_ASC'
  | 'DEADLINE_REMINDER_DATE_DESC'
  | 'DEADLINE_REMINDER_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'DURATION_ASC'
  | 'DURATION_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_ID_ASC'
  | 'ENGAGEMENT_TYPE_ID_DESC'
  | 'NATURAL'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ACTIVE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ACTIVE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ANONYMOUS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ANONYMOUS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ARCHIVED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ARCHIVED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__BACKGROUND_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__BACKGROUND_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CHANNEL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CHANNEL_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CLOSE_ACCESS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CLOSE_ACCESS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPANY_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPANY_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPLETED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPLETED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONFIRM_RESULTS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONFIRM_RESULTS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_BACKGROUND_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_BACKGROUND_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_TEXT_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_TEXT_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_AT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_AT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_FROM_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_FROM_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DATE_FORMAT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DATE_FORMAT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEADLINE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEADLINE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_DIRECT_MANAGER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_DIRECT_MANAGER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_GROUP_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_GROUP_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_USER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_USER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEPARTMENT_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEPARTMENT_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DISABLE_2FA_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DISABLE_2FA_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_BODY_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_BODY_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_SUBJECT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_SUBJECT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMPLOYEE_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMPLOYEE_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FALLBACK_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FALLBACK_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_SIZE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_SIZE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_URL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_URL_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LINK_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LINK_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOCALE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOCALE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_WIDTH_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_WIDTH_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__MANAGER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__MANAGER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NEXT_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NEXT_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ORDER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ORDER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_ENABLED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_ENABLED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREDECESSOR_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREDECESSOR_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREV_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREV_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PUBLISHED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PUBLISHED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_DIRECT_MANAGER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_DIRECT_MANAGER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_GROUP_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_GROUP_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DAYS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DAYS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESPONSIBLE_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESPONSIBLE_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESULT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESULT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__SMS_BODY_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__SMS_BODY_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__START_DATE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__START_DATE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEMPLATE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEMPLATE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEXT_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEXT_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CONTENT_COLORS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CONTENT_COLORS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CUSTOM_LINK_BUTTON_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CUSTOM_LINK_BUTTON_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_LEADER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_LEADER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_WORK_EMAIL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_WORK_EMAIL_DESC'
  | 'PREBOARDING_ID_ASC'
  | 'PREBOARDING_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_ASC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_DESC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_ASC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_DESC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_DESC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__NAME_ASC'
  | 'PROCESS_BY_PROCESS_ID__NAME_DESC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_ASC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_DESC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_DESC'
  | 'PROCESS_ID_ASC'
  | 'PROCESS_ID_DESC'
  | 'SEND_DATE_ASC'
  | 'SEND_DATE_DESC'
  | 'SEND_TIME_ASC'
  | 'SEND_TIME_DESC'
  | 'START_DAY_ASC'
  | 'START_DAY_DESC'
  | 'TEMPLATE_ASC'
  | 'TEMPLATE_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** The `formField` to be created by this mutation. */
export type PreboardingRecipientCustomEmployeeFieldIdForeignConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `preboarding` to be created by this mutation. */
export type PreboardingRecipientCustomEmployeeFieldIdForeignConnectionPreboardingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontStorageId?: InputMaybe<Scalars['UUID']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoStorageId?: InputMaybe<Scalars['UUID']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `formField` in the `PreboardingInput` mutation. */
export type PreboardingRecipientCustomEmployeeFieldIdForeignInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<FormFieldFormFieldPkeyConnect>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignConnectionFormFieldCreateInput>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<FormFieldOnPreboardingForPreboardingRecipientCustomEmployeeFieldIdForeignUsingFormFieldPkeyUpdate>;
};

/** Input for the nested mutation of `preboarding` in the `FormFieldInput` mutation. */
export type PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput = {
  /** The primary key(s) for `preboarding` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingPreboardingPkeyConnect>>;
  /** A `PreboardingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingRecipientCustomEmployeeFieldIdForeignConnectionPreboardingCreateInput>>;
  /** The primary key(s) and patch data for `preboarding` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingOnPreboardingForPreboardingRecipientCustomEmployeeFieldIdForeignUsingPreboardingPkeyUpdate>>;
};

/** The `group` to be created by this mutation. */
export type PreboardingRecipientGroupIdForeignConnectionGroupCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppTableGroupIdFkInverseInput>;
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  autoInherit?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  copyFromGroupId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientGroupIdForeignInverseInput>;
  scope?: InputMaybe<RoleScope>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupGroupIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupGroupIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupGroupIdForeignInverseInput>;
};

/** The `preboarding` to be created by this mutation. */
export type PreboardingRecipientGroupIdForeignConnectionPreboardingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontStorageId?: InputMaybe<Scalars['UUID']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoStorageId?: InputMaybe<Scalars['UUID']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `group` in the `PreboardingInput` mutation. */
export type PreboardingRecipientGroupIdForeignInput = {
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectById?: InputMaybe<GroupGroupPkeyConnect>;
  /** A `GroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingRecipientGroupIdForeignConnectionGroupCreateInput>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateById?: InputMaybe<GroupOnPreboardingForPreboardingRecipientGroupIdForeignUsingGroupPkeyUpdate>;
};

/** Input for the nested mutation of `preboarding` in the `GroupInput` mutation. */
export type PreboardingRecipientGroupIdForeignInverseInput = {
  /** The primary key(s) for `preboarding` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingPreboardingPkeyConnect>>;
  /** A `PreboardingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingRecipientGroupIdForeignConnectionPreboardingCreateInput>>;
  /** The primary key(s) and patch data for `preboarding` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingOnPreboardingForPreboardingRecipientGroupIdForeignUsingPreboardingPkeyUpdate>>;
};

/** The `preboarding` to be created by this mutation. */
export type PreboardingRecipientIdForeignConnectionPreboardingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontStorageId?: InputMaybe<Scalars['UUID']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoStorageId?: InputMaybe<Scalars['UUID']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `user` in the `PreboardingInput` mutation. */
export type PreboardingRecipientIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnPreboardingForPreboardingRecipientIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `preboarding` in the `UserInput` mutation. */
export type PreboardingRecipientIdForeignInverseInput = {
  /** The primary key(s) for `preboarding` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingPreboardingPkeyConnect>>;
  /** A `PreboardingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingRecipientIdForeignConnectionPreboardingCreateInput>>;
  /** The primary key(s) and patch data for `preboarding` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingOnPreboardingForPreboardingRecipientIdForeignUsingPreboardingPkeyUpdate>>;
};

export type PreboardingResult = {
  __typename?: 'PreboardingResult';
  /** Reads a single `Company` that is related to this `PreboardingResult`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Employee` that is related to this `PreboardingResult`. */
  employee?: Maybe<Employee>;
  employeeId: Scalars['UUID'];
  /** Reads a single `EngagementType` that is related to this `PreboardingResult`. */
  engagementType?: Maybe<EngagementType>;
  engagementTypeId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  /** Reads a single `PreboardingEmployee` that is related to this `PreboardingResult`. */
  preboardingEmployee?: Maybe<PreboardingEmployee>;
  preboardingEmployeeId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `PreboardingResultSlideComment`. */
  preboardingResultSlideComments: PreboardingResultSlideCommentsConnection;
  result?: Maybe<Scalars['JSON']>;
  /** Reads a single `User` that is related to this `PreboardingResult`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};


export type PreboardingResultPreboardingResultSlideCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingResultSlideCommentCondition>;
  filter?: InputMaybe<PreboardingResultSlideCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingResultSlideCommentsOrderBy>>;
};

/** The `preboardingResult` to be created by this mutation. */
export type PreboardingResultCompanyIdFkeyConnectionPreboardingResultCreateInput = {
  company?: InputMaybe<PreboardingResultCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingResultEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInverseInput>;
  result?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<PreboardingResultUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `PreboardingResultInput` mutation. */
export type PreboardingResultCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnPreboardingResultForPreboardingResultCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingResult` in the `CompanyInput` mutation. */
export type PreboardingResultCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `preboardingResult` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingResultPreboardingResultPkeyConnect>>;
  /** A `PreboardingResultInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingResultCompanyIdFkeyConnectionPreboardingResultCreateInput>>;
  /** The primary key(s) for `preboardingResult` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingResultPreboardingResultPkeyDelete>>;
  /** Flag indicating whether all other `preboardingResult` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingResult` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingResultOnPreboardingResultForPreboardingResultCompanyIdFkeyUsingPreboardingResultPkeyUpdate>>;
};

/**
 * A condition to be used against `PreboardingResult` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PreboardingResultCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `preboardingEmployeeId` field. */
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `result` field. */
  result?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `preboardingResult` to be created by this mutation. */
export type PreboardingResultEmployeeIdForeignConnectionPreboardingResultCreateInput = {
  company?: InputMaybe<PreboardingResultCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingResultEmployeeIdForeignInput>;
  engagementType?: InputMaybe<PreboardingResultEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInverseInput>;
  result?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<PreboardingResultUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `employee` in the `PreboardingResultInput` mutation. */
export type PreboardingResultEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnPreboardingResultForPreboardingResultEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnPreboardingResultForPreboardingResultEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `preboardingResult` in the `EmployeeInput` mutation. */
export type PreboardingResultEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `preboardingResult` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingResultPreboardingResultPkeyConnect>>;
  /** A `PreboardingResultInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingResultEmployeeIdForeignConnectionPreboardingResultCreateInput>>;
  /** The primary key(s) for `preboardingResult` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingResultPreboardingResultPkeyDelete>>;
  /** Flag indicating whether all other `preboardingResult` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingResult` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingResultOnPreboardingResultForPreboardingResultEmployeeIdForeignUsingPreboardingResultPkeyUpdate>>;
};

/** The `engagementType` to be created by this mutation. */
export type PreboardingResultEngagementTypeIdForeignConnectionEngagementTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `preboardingResult` to be created by this mutation. */
export type PreboardingResultEngagementTypeIdForeignConnectionPreboardingResultCreateInput = {
  company?: InputMaybe<PreboardingResultCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingResultEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultEngagementTypeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInverseInput>;
  result?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<PreboardingResultUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `engagementType` in the `PreboardingResultInput` mutation. */
export type PreboardingResultEngagementTypeIdForeignInput = {
  /** The primary key(s) for `engagementType` for the far side of the relationship. */
  connectById?: InputMaybe<EngagementTypeEngagementTypePkeyConnect>;
  /** A `EngagementTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingResultEngagementTypeIdForeignConnectionEngagementTypeCreateInput>;
  /** The primary key(s) and patch data for `engagementType` for the far side of the relationship. */
  updateById?: InputMaybe<EngagementTypeOnPreboardingResultForPreboardingResultEngagementTypeIdForeignUsingEngagementTypePkeyUpdate>;
};

/** Input for the nested mutation of `preboardingResult` in the `EngagementTypeInput` mutation. */
export type PreboardingResultEngagementTypeIdForeignInverseInput = {
  /** The primary key(s) for `preboardingResult` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingResultPreboardingResultPkeyConnect>>;
  /** A `PreboardingResultInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingResultEngagementTypeIdForeignConnectionPreboardingResultCreateInput>>;
  /** The primary key(s) for `preboardingResult` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingResultPreboardingResultPkeyDelete>>;
  /** Flag indicating whether all other `preboardingResult` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingResult` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingResultOnPreboardingResultForPreboardingResultEngagementTypeIdForeignUsingPreboardingResultPkeyUpdate>>;
};

/** A filter to be used against `PreboardingResult` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingResultFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PreboardingResultFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `engagementType` relation. */
  engagementType?: InputMaybe<EngagementTypeFilter>;
  /** A related `engagementType` exists. */
  engagementTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PreboardingResultFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PreboardingResultFilter>>;
  /** Filter by the object’s `preboardingEmployee` relation. */
  preboardingEmployee?: InputMaybe<PreboardingEmployeeFilter>;
  /** A related `preboardingEmployee` exists. */
  preboardingEmployeeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingEmployeeId` field. */
  preboardingEmployeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `preboardingResultSlideComments` relation. */
  preboardingResultSlideComments?: InputMaybe<PreboardingResultToManyPreboardingResultSlideCommentFilter>;
  /** Some related `preboardingResultSlideComments` exist. */
  preboardingResultSlideCommentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `result` field. */
  result?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `PreboardingResult` */
export type PreboardingResultInput = {
  company?: InputMaybe<PreboardingResultCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingResultEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInverseInput>;
  result?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<PreboardingResultUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `preboardingResult` to look up the row to update. */
export type PreboardingResultOnPreboardingResultForPreboardingResultCompanyIdFkeyUsingPreboardingResultPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingResult` being updated. */
  patch: UpdatePreboardingResultOnPreboardingResultForPreboardingResultCompanyIdFkeyPatch;
};

/** The fields on `preboardingResult` to look up the row to update. */
export type PreboardingResultOnPreboardingResultForPreboardingResultEmployeeIdForeignUsingPreboardingResultPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingResult` being updated. */
  patch: UpdatePreboardingResultOnPreboardingResultForPreboardingResultEmployeeIdForeignPatch;
};

/** The fields on `preboardingResult` to look up the row to update. */
export type PreboardingResultOnPreboardingResultForPreboardingResultEngagementTypeIdForeignUsingPreboardingResultPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingResult` being updated. */
  patch: UpdatePreboardingResultOnPreboardingResultForPreboardingResultEngagementTypeIdForeignPatch;
};

/** The fields on `preboardingResult` to look up the row to update. */
export type PreboardingResultOnPreboardingResultForPreboardingResultPreboardingEmployeeIdForeignUsingPreboardingResultPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingResult` being updated. */
  patch: UpdatePreboardingResultOnPreboardingResultForPreboardingResultPreboardingEmployeeIdForeignPatch;
};

/** The fields on `preboardingResult` to look up the row to update. */
export type PreboardingResultOnPreboardingResultForPreboardingResultUserIdForeignUsingPreboardingResultPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingResult` being updated. */
  patch: UpdatePreboardingResultOnPreboardingResultForPreboardingResultUserIdForeignPatch;
};

/** The fields on `preboardingResult` to look up the row to update. */
export type PreboardingResultOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingResultIdForeignUsingPreboardingResultPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingResult` being updated. */
  patch: UpdatePreboardingResultOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingResultIdForeignPatch;
};

/** Represents an update to a `PreboardingResult`. Fields that are set will be updated. */
export type PreboardingResultPatch = {
  company?: InputMaybe<PreboardingResultCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingResultEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInverseInput>;
  result?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<PreboardingResultUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `preboardingEmployee` to be created by this mutation. */
export type PreboardingResultPreboardingEmployeeIdForeignConnectionPreboardingEmployeeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `preboardingResult` to be created by this mutation. */
export type PreboardingResultPreboardingEmployeeIdForeignConnectionPreboardingResultCreateInput = {
  company?: InputMaybe<PreboardingResultCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingResultEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInverseInput>;
  result?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<PreboardingResultUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `preboardingEmployee` in the `PreboardingResultInput` mutation. */
export type PreboardingResultPreboardingEmployeeIdForeignInput = {
  /** The primary key(s) for `preboardingEmployee` for the far side of the relationship. */
  connectById?: InputMaybe<PreboardingEmployeePreboardingEmployeePkeyConnect>;
  /** A `PreboardingEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignConnectionPreboardingEmployeeCreateInput>;
  /** The primary key(s) and patch data for `preboardingEmployee` for the far side of the relationship. */
  updateById?: InputMaybe<PreboardingEmployeeOnPreboardingResultForPreboardingResultPreboardingEmployeeIdForeignUsingPreboardingEmployeePkeyUpdate>;
};

/** Input for the nested mutation of `preboardingResult` in the `PreboardingEmployeeInput` mutation. */
export type PreboardingResultPreboardingEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `preboardingResult` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingResultPreboardingResultPkeyConnect>>;
  /** A `PreboardingResultInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingResultPreboardingEmployeeIdForeignConnectionPreboardingResultCreateInput>>;
  /** The primary key(s) for `preboardingResult` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingResultPreboardingResultPkeyDelete>>;
  /** Flag indicating whether all other `preboardingResult` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingResult` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingResultOnPreboardingResultForPreboardingResultPreboardingEmployeeIdForeignUsingPreboardingResultPkeyUpdate>>;
};

/** The fields on `preboardingResult` to look up the row to connect. */
export type PreboardingResultPreboardingResultPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `preboardingResult` to look up the row to delete. */
export type PreboardingResultPreboardingResultPkeyDelete = {
  id: Scalars['UUID'];
};

export type PreboardingResultSlideComment = {
  __typename?: 'PreboardingResultSlideComment';
  /** Reads a single `Company` that is related to this `PreboardingResultSlideComment`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  edited: Scalars['Boolean'];
  /** Reads a single `Employee` that is related to this `PreboardingResultSlideComment`. */
  employee?: Maybe<Employee>;
  employeeId: Scalars['UUID'];
  /** Reads a single `EngagementType` that is related to this `PreboardingResultSlideComment`. */
  engagementType?: Maybe<EngagementType>;
  engagementTypeId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  /** Reads a single `PreboardingResult` that is related to this `PreboardingResultSlideComment`. */
  preboardingResult?: Maybe<PreboardingResult>;
  preboardingResultId: Scalars['UUID'];
  /** Reads a single `PreboardingSlide` that is related to this `PreboardingResultSlideComment`. */
  preboardingSlide?: Maybe<PreboardingSlide>;
  preboardingSlideId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `PreboardingResultSlideComment`. */
  preboardingUser?: Maybe<User>;
  preboardingUserId?: Maybe<Scalars['UUID']>;
  public: Scalars['Boolean'];
  text: Scalars['String'];
  /** Reads a single `User` that is related to this `PreboardingResultSlideComment`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

/** The `preboardingResultSlideComment` to be created by this mutation. */
export type PreboardingResultSlideCommentCompanyIdFkeyConnectionPreboardingResultSlideCommentCreateInput = {
  company?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingResult?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInput>;
  preboardingResultId?: InputMaybe<Scalars['UUID']>;
  preboardingSlide?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInput>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `PreboardingResultSlideCommentInput` mutation. */
export type PreboardingResultSlideCommentCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnPreboardingResultSlideCommentForPreboardingResultSlideCommentCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingResultSlideComment` in the `CompanyInput` mutation. */
export type PreboardingResultSlideCommentCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `preboardingResultSlideComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingResultSlideCommentPreboardingResultSlideCommentPkeyConnect>>;
  /** A `PreboardingResultSlideCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingResultSlideCommentCompanyIdFkeyConnectionPreboardingResultSlideCommentCreateInput>>;
  /** The primary key(s) for `preboardingResultSlideComment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingResultSlideCommentPreboardingResultSlideCommentPkeyDelete>>;
  /** Flag indicating whether all other `preboardingResultSlideComment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingResultSlideComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentCompanyIdFkeyUsingPreboardingResultSlideCommentPkeyUpdate>>;
};

/**
 * A condition to be used against `PreboardingResultSlideComment` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type PreboardingResultSlideCommentCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `edited` field. */
  edited?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `preboardingResultId` field. */
  preboardingResultId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `preboardingSlideId` field. */
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `preboardingUserId` field. */
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `public` field. */
  public?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `text` field. */
  text?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `preboardingResultSlideComment` to be created by this mutation. */
export type PreboardingResultSlideCommentEmployeeIdForeignConnectionPreboardingResultSlideCommentCreateInput = {
  company?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInput>;
  engagementType?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingResult?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInput>;
  preboardingResultId?: InputMaybe<Scalars['UUID']>;
  preboardingSlide?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInput>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `employee` in the `PreboardingResultSlideCommentInput` mutation. */
export type PreboardingResultSlideCommentEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `preboardingResultSlideComment` in the `EmployeeInput` mutation. */
export type PreboardingResultSlideCommentEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `preboardingResultSlideComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingResultSlideCommentPreboardingResultSlideCommentPkeyConnect>>;
  /** A `PreboardingResultSlideCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingResultSlideCommentEmployeeIdForeignConnectionPreboardingResultSlideCommentCreateInput>>;
  /** The primary key(s) for `preboardingResultSlideComment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingResultSlideCommentPreboardingResultSlideCommentPkeyDelete>>;
  /** Flag indicating whether all other `preboardingResultSlideComment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingResultSlideComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEmployeeIdForeignUsingPreboardingResultSlideCommentPkeyUpdate>>;
};

/** The `engagementType` to be created by this mutation. */
export type PreboardingResultSlideCommentEngagementTypeIdForeignConnectionEngagementTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `preboardingResultSlideComment` to be created by this mutation. */
export type PreboardingResultSlideCommentEngagementTypeIdForeignConnectionPreboardingResultSlideCommentCreateInput = {
  company?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingResult?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInput>;
  preboardingResultId?: InputMaybe<Scalars['UUID']>;
  preboardingSlide?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInput>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `engagementType` in the `PreboardingResultSlideCommentInput` mutation. */
export type PreboardingResultSlideCommentEngagementTypeIdForeignInput = {
  /** The primary key(s) for `engagementType` for the far side of the relationship. */
  connectById?: InputMaybe<EngagementTypeEngagementTypePkeyConnect>;
  /** A `EngagementTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignConnectionEngagementTypeCreateInput>;
  /** The primary key(s) and patch data for `engagementType` for the far side of the relationship. */
  updateById?: InputMaybe<EngagementTypeOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEngagementTypeIdForeignUsingEngagementTypePkeyUpdate>;
};

/** Input for the nested mutation of `preboardingResultSlideComment` in the `EngagementTypeInput` mutation. */
export type PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput = {
  /** The primary key(s) for `preboardingResultSlideComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingResultSlideCommentPreboardingResultSlideCommentPkeyConnect>>;
  /** A `PreboardingResultSlideCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingResultSlideCommentEngagementTypeIdForeignConnectionPreboardingResultSlideCommentCreateInput>>;
  /** The primary key(s) for `preboardingResultSlideComment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingResultSlideCommentPreboardingResultSlideCommentPkeyDelete>>;
  /** Flag indicating whether all other `preboardingResultSlideComment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingResultSlideComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEngagementTypeIdForeignUsingPreboardingResultSlideCommentPkeyUpdate>>;
};

/** A filter to be used against `PreboardingResultSlideComment` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingResultSlideCommentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PreboardingResultSlideCommentFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `edited` field. */
  edited?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `engagementType` relation. */
  engagementType?: InputMaybe<EngagementTypeFilter>;
  /** A related `engagementType` exists. */
  engagementTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PreboardingResultSlideCommentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PreboardingResultSlideCommentFilter>>;
  /** Filter by the object’s `preboardingResult` relation. */
  preboardingResult?: InputMaybe<PreboardingResultFilter>;
  /** Filter by the object’s `preboardingResultId` field. */
  preboardingResultId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `preboardingSlide` relation. */
  preboardingSlide?: InputMaybe<PreboardingSlideFilter>;
  /** Filter by the object’s `preboardingSlideId` field. */
  preboardingSlideId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `preboardingUser` relation. */
  preboardingUser?: InputMaybe<UserFilter>;
  /** A related `preboardingUser` exists. */
  preboardingUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingUserId` field. */
  preboardingUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `public` field. */
  public?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `text` field. */
  text?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `PreboardingResultSlideComment` */
export type PreboardingResultSlideCommentInput = {
  company?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingResult?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInput>;
  preboardingResultId?: InputMaybe<Scalars['UUID']>;
  preboardingSlide?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInput>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `preboardingResultSlideComment` to look up the row to update. */
export type PreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentCompanyIdFkeyUsingPreboardingResultSlideCommentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingResultSlideComment` being updated. */
  patch: UpdatePreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentCompanyIdFkeyPatch;
};

/** The fields on `preboardingResultSlideComment` to look up the row to update. */
export type PreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEmployeeIdForeignUsingPreboardingResultSlideCommentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingResultSlideComment` being updated. */
  patch: UpdatePreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEmployeeIdForeignPatch;
};

/** The fields on `preboardingResultSlideComment` to look up the row to update. */
export type PreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEngagementTypeIdForeignUsingPreboardingResultSlideCommentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingResultSlideComment` being updated. */
  patch: UpdatePreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEngagementTypeIdForeignPatch;
};

/** The fields on `preboardingResultSlideComment` to look up the row to update. */
export type PreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingResultIdForeignUsingPreboardingResultSlideCommentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingResultSlideComment` being updated. */
  patch: UpdatePreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingResultIdForeignPatch;
};

/** The fields on `preboardingResultSlideComment` to look up the row to update. */
export type PreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingSlideIdForeignUsingPreboardingResultSlideCommentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingResultSlideComment` being updated. */
  patch: UpdatePreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingSlideIdForeignPatch;
};

/** The fields on `preboardingResultSlideComment` to look up the row to update. */
export type PreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingUserIdForeignUsingPreboardingResultSlideCommentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingResultSlideComment` being updated. */
  patch: UpdatePreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingUserIdForeignPatch;
};

/** The fields on `preboardingResultSlideComment` to look up the row to update. */
export type PreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentUserIdForeignUsingPreboardingResultSlideCommentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingResultSlideComment` being updated. */
  patch: UpdatePreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentUserIdForeignPatch;
};

/** Represents an update to a `PreboardingResultSlideComment`. Fields that are set will be updated. */
export type PreboardingResultSlideCommentPatch = {
  company?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingResult?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInput>;
  preboardingResultId?: InputMaybe<Scalars['UUID']>;
  preboardingSlide?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInput>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `preboardingResult` to be created by this mutation. */
export type PreboardingResultSlideCommentPreboardingResultIdForeignConnectionPreboardingResultCreateInput = {
  company?: InputMaybe<PreboardingResultCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingResultEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInverseInput>;
  result?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<PreboardingResultUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `preboardingResultSlideComment` to be created by this mutation. */
export type PreboardingResultSlideCommentPreboardingResultIdForeignConnectionPreboardingResultSlideCommentCreateInput = {
  company?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingResult?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInput>;
  preboardingSlide?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInput>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `preboardingResult` in the `PreboardingResultSlideCommentInput` mutation. */
export type PreboardingResultSlideCommentPreboardingResultIdForeignInput = {
  /** The primary key(s) for `preboardingResult` for the far side of the relationship. */
  connectById?: InputMaybe<PreboardingResultPreboardingResultPkeyConnect>;
  /** A `PreboardingResultInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignConnectionPreboardingResultCreateInput>;
  /** The primary key(s) for `preboardingResult` for the far side of the relationship. */
  deleteById?: InputMaybe<PreboardingResultPreboardingResultPkeyDelete>;
  /** The primary key(s) and patch data for `preboardingResult` for the far side of the relationship. */
  updateById?: InputMaybe<PreboardingResultOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingResultIdForeignUsingPreboardingResultPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingResultSlideComment` in the `PreboardingResultInput` mutation. */
export type PreboardingResultSlideCommentPreboardingResultIdForeignInverseInput = {
  /** The primary key(s) for `preboardingResultSlideComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingResultSlideCommentPreboardingResultSlideCommentPkeyConnect>>;
  /** A `PreboardingResultSlideCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingResultSlideCommentPreboardingResultIdForeignConnectionPreboardingResultSlideCommentCreateInput>>;
  /** The primary key(s) for `preboardingResultSlideComment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingResultSlideCommentPreboardingResultSlideCommentPkeyDelete>>;
  /** Flag indicating whether all other `preboardingResultSlideComment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingResultSlideComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingResultIdForeignUsingPreboardingResultSlideCommentPkeyUpdate>>;
};

/** The fields on `preboardingResultSlideComment` to look up the row to connect. */
export type PreboardingResultSlideCommentPreboardingResultSlideCommentPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `preboardingResultSlideComment` to look up the row to delete. */
export type PreboardingResultSlideCommentPreboardingResultSlideCommentPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `preboardingResultSlideComment` to be created by this mutation. */
export type PreboardingResultSlideCommentPreboardingSlideIdForeignConnectionPreboardingResultSlideCommentCreateInput = {
  company?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingResult?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInput>;
  preboardingResultId?: InputMaybe<Scalars['UUID']>;
  preboardingSlide?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInput>;
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `preboardingSlide` to be created by this mutation. */
export type PreboardingResultSlideCommentPreboardingSlideIdForeignConnectionPreboardingSlideCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addReviewNote?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  pageDescription?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  preboarding?: InputMaybe<PreboardingSlidePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInverseInput>;
  reviewNote?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `preboardingSlide` in the `PreboardingResultSlideCommentInput` mutation. */
export type PreboardingResultSlideCommentPreboardingSlideIdForeignInput = {
  /** The primary key(s) for `preboardingSlide` for the far side of the relationship. */
  connectById?: InputMaybe<PreboardingSlidePreboardingSlidePkeyConnect>;
  /** A `PreboardingSlideInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignConnectionPreboardingSlideCreateInput>;
  /** The primary key(s) and patch data for `preboardingSlide` for the far side of the relationship. */
  updateById?: InputMaybe<PreboardingSlideOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingSlideIdForeignUsingPreboardingSlidePkeyUpdate>;
};

/** Input for the nested mutation of `preboardingResultSlideComment` in the `PreboardingSlideInput` mutation. */
export type PreboardingResultSlideCommentPreboardingSlideIdForeignInverseInput = {
  /** The primary key(s) for `preboardingResultSlideComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingResultSlideCommentPreboardingResultSlideCommentPkeyConnect>>;
  /** A `PreboardingResultSlideCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingResultSlideCommentPreboardingSlideIdForeignConnectionPreboardingResultSlideCommentCreateInput>>;
  /** The primary key(s) for `preboardingResultSlideComment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingResultSlideCommentPreboardingResultSlideCommentPkeyDelete>>;
  /** Flag indicating whether all other `preboardingResultSlideComment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingResultSlideComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingSlideIdForeignUsingPreboardingResultSlideCommentPkeyUpdate>>;
};

/** The `preboardingResultSlideComment` to be created by this mutation. */
export type PreboardingResultSlideCommentPreboardingUserIdForeignConnectionPreboardingResultSlideCommentCreateInput = {
  company?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingResult?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInput>;
  preboardingResultId?: InputMaybe<Scalars['UUID']>;
  preboardingSlide?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInput>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `user` in the `PreboardingResultSlideCommentInput` mutation. */
export type PreboardingResultSlideCommentPreboardingUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingResultSlideComment` in the `UserInput` mutation. */
export type PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput = {
  /** The primary key(s) for `preboardingResultSlideComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingResultSlideCommentPreboardingResultSlideCommentPkeyConnect>>;
  /** A `PreboardingResultSlideCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingResultSlideCommentPreboardingUserIdForeignConnectionPreboardingResultSlideCommentCreateInput>>;
  /** The primary key(s) for `preboardingResultSlideComment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingResultSlideCommentPreboardingResultSlideCommentPkeyDelete>>;
  /** Flag indicating whether all other `preboardingResultSlideComment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingResultSlideComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingUserIdForeignUsingPreboardingResultSlideCommentPkeyUpdate>>;
};

/** The `preboardingResultSlideComment` to be created by this mutation. */
export type PreboardingResultSlideCommentUserIdForeignConnectionPreboardingResultSlideCommentCreateInput = {
  company?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingResult?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInput>;
  preboardingResultId?: InputMaybe<Scalars['UUID']>;
  preboardingSlide?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInput>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInput>;
};

/** Input for the nested mutation of `preboardingResultSlideComment` in the `UserInput` mutation. */
export type PreboardingResultSlideCommentUserIdForeignInverseInput = {
  /** The primary key(s) for `preboardingResultSlideComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingResultSlideCommentPreboardingResultSlideCommentPkeyConnect>>;
  /** A `PreboardingResultSlideCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingResultSlideCommentUserIdForeignConnectionPreboardingResultSlideCommentCreateInput>>;
  /** The primary key(s) for `preboardingResultSlideComment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingResultSlideCommentPreboardingResultSlideCommentPkeyDelete>>;
  /** Flag indicating whether all other `preboardingResultSlideComment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingResultSlideComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentUserIdForeignUsingPreboardingResultSlideCommentPkeyUpdate>>;
};

/** A connection to a list of `PreboardingResultSlideComment` values. */
export type PreboardingResultSlideCommentsConnection = {
  __typename?: 'PreboardingResultSlideCommentsConnection';
  /** A list of edges which contains the `PreboardingResultSlideComment` and cursor to aid in pagination. */
  edges: Array<PreboardingResultSlideCommentsEdge>;
  /** A list of `PreboardingResultSlideComment` objects. */
  nodes: Array<Maybe<PreboardingResultSlideComment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PreboardingResultSlideComment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PreboardingResultSlideComment` edge in the connection. */
export type PreboardingResultSlideCommentsEdge = {
  __typename?: 'PreboardingResultSlideCommentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PreboardingResultSlideComment` at the end of the edge. */
  node?: Maybe<PreboardingResultSlideComment>;
};

/** Methods to use when ordering `PreboardingResultSlideComment`. */
export type PreboardingResultSlideCommentsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EDITED_ASC'
  | 'EDITED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_ID_ASC'
  | 'ENGAGEMENT_TYPE_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PREBOARDING_RESULT_BY_PREBOARDING_RESULT_ID__COMPANY_ID_ASC'
  | 'PREBOARDING_RESULT_BY_PREBOARDING_RESULT_ID__COMPANY_ID_DESC'
  | 'PREBOARDING_RESULT_BY_PREBOARDING_RESULT_ID__CREATED_AT_ASC'
  | 'PREBOARDING_RESULT_BY_PREBOARDING_RESULT_ID__CREATED_AT_DESC'
  | 'PREBOARDING_RESULT_BY_PREBOARDING_RESULT_ID__DEPARTMENTS_ASC'
  | 'PREBOARDING_RESULT_BY_PREBOARDING_RESULT_ID__DEPARTMENTS_DESC'
  | 'PREBOARDING_RESULT_BY_PREBOARDING_RESULT_ID__EMPLOYEE_ID_ASC'
  | 'PREBOARDING_RESULT_BY_PREBOARDING_RESULT_ID__EMPLOYEE_ID_DESC'
  | 'PREBOARDING_RESULT_BY_PREBOARDING_RESULT_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'PREBOARDING_RESULT_BY_PREBOARDING_RESULT_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'PREBOARDING_RESULT_BY_PREBOARDING_RESULT_ID__ID_ASC'
  | 'PREBOARDING_RESULT_BY_PREBOARDING_RESULT_ID__ID_DESC'
  | 'PREBOARDING_RESULT_BY_PREBOARDING_RESULT_ID__PREBOARDING_EMPLOYEE_ID_ASC'
  | 'PREBOARDING_RESULT_BY_PREBOARDING_RESULT_ID__PREBOARDING_EMPLOYEE_ID_DESC'
  | 'PREBOARDING_RESULT_BY_PREBOARDING_RESULT_ID__RESULT_ASC'
  | 'PREBOARDING_RESULT_BY_PREBOARDING_RESULT_ID__RESULT_DESC'
  | 'PREBOARDING_RESULT_BY_PREBOARDING_RESULT_ID__USER_ID_ASC'
  | 'PREBOARDING_RESULT_BY_PREBOARDING_RESULT_ID__USER_ID_DESC'
  | 'PREBOARDING_RESULT_ID_ASC'
  | 'PREBOARDING_RESULT_ID_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ACTIVE_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ACTIVE_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ADD_REVIEW_NOTE_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ADD_REVIEW_NOTE_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__COMPANY_ID_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__COMPANY_ID_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__DEPARTMENTS_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__DEPARTMENTS_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ID_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ID_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__NAME_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__NAME_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ORDER_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ORDER_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__PAGE_DESCRIPTION_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__PAGE_DESCRIPTION_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__PAGE_TITLE_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__PAGE_TITLE_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__PREBOARDING_ID_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__PREBOARDING_ID_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__REVIEW_NOTE_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__REVIEW_NOTE_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__USER_IDS_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__USER_IDS_DESC'
  | 'PREBOARDING_SLIDE_ID_ASC'
  | 'PREBOARDING_SLIDE_ID_DESC'
  | 'PREBOARDING_USER_ID_ASC'
  | 'PREBOARDING_USER_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PUBLIC_ASC'
  | 'PUBLIC_DESC'
  | 'TEXT_ASC'
  | 'TEXT_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__ACTIVE_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__ACTIVE_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__ADDRESS_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__ADDRESS_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__CITY_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__CITY_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__CPR_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__CPR_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__EMAIL_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__EMAIL_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__GODMODE_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__GODMODE_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__ID_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__ID_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__INITIALS_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__INITIALS_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__MOBILE_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__MOBILE_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__PHONE_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__PHONE_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_PREBOARDING_USER_ID__SENIORITY_ASC'
  | 'USER_BY_PREBOARDING_USER_ID__SENIORITY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** A filter to be used against many `PreboardingResultSlideComment` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingResultToManyPreboardingResultSlideCommentFilter = {
  /** Every related `PreboardingResultSlideComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingResultSlideCommentFilter>;
  /** No related `PreboardingResultSlideComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingResultSlideCommentFilter>;
  /** Some related `PreboardingResultSlideComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingResultSlideCommentFilter>;
};

/** The `preboardingResult` to be created by this mutation. */
export type PreboardingResultUserIdForeignConnectionPreboardingResultCreateInput = {
  company?: InputMaybe<PreboardingResultCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingResultEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInverseInput>;
  result?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<PreboardingResultUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `PreboardingResultInput` mutation. */
export type PreboardingResultUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnPreboardingResultForPreboardingResultUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingResult` in the `UserInput` mutation. */
export type PreboardingResultUserIdForeignInverseInput = {
  /** The primary key(s) for `preboardingResult` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingResultPreboardingResultPkeyConnect>>;
  /** A `PreboardingResultInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingResultUserIdForeignConnectionPreboardingResultCreateInput>>;
  /** The primary key(s) for `preboardingResult` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingResultPreboardingResultPkeyDelete>>;
  /** Flag indicating whether all other `preboardingResult` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingResult` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingResultOnPreboardingResultForPreboardingResultUserIdForeignUsingPreboardingResultPkeyUpdate>>;
};

/** A connection to a list of `PreboardingResult` values. */
export type PreboardingResultsConnection = {
  __typename?: 'PreboardingResultsConnection';
  /** A list of edges which contains the `PreboardingResult` and cursor to aid in pagination. */
  edges: Array<PreboardingResultsEdge>;
  /** A list of `PreboardingResult` objects. */
  nodes: Array<Maybe<PreboardingResult>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PreboardingResult` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PreboardingResult` edge in the connection. */
export type PreboardingResultsEdge = {
  __typename?: 'PreboardingResultsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PreboardingResult` at the end of the edge. */
  node?: Maybe<PreboardingResult>;
};

/** Methods to use when ordering `PreboardingResult`. */
export type PreboardingResultsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_ID_ASC'
  | 'ENGAGEMENT_TYPE_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ACTIVE_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ACTIVE_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ARCHIVED_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ARCHIVED_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__COMPLETED_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__COMPLETED_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__COMPLETED_REMINDED_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__COMPLETED_REMINDED_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__CONCLUSION_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__CONCLUSION_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__DEADLINE_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__DEADLINE_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__EMPLOYEE_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__EMPLOYEE_ID_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__ID_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__MANAGER_IDS_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__MANAGER_IDS_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__NAME_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__NAME_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__PREBOARDING_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__PREBOARDING_ID_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__PUBLISHED_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__PUBLISHED_DATE_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__PUBLISHED_DATE_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__PUBLISHED_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__RECIPIENT_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__RECIPIENT_ID_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__REMINDER_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__REMINDER_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__RESPONSIBLE_IDS_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__RESPONSIBLE_IDS_DESC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__USER_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_BY_PREBOARDING_EMPLOYEE_ID__USER_ID_DESC'
  | 'PREBOARDING_EMPLOYEE_ID_ASC'
  | 'PREBOARDING_EMPLOYEE_ID_DESC'
  | 'PREBOARDING_RESULT_SLIDE_COMMENTS_BY_PREBOARDING_RESULT_ID__COUNT_ASC'
  | 'PREBOARDING_RESULT_SLIDE_COMMENTS_BY_PREBOARDING_RESULT_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RESULT_ASC'
  | 'RESULT_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type PreboardingSlide = {
  __typename?: 'PreboardingSlide';
  active?: Maybe<Scalars['Boolean']>;
  addReviewNote: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `PreboardingSlide`. */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['UUID']>;
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `EngagementType` that is related to this `PreboardingSlide`. */
  engagementType?: Maybe<EngagementType>;
  engagementTypeId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pageDescription?: Maybe<Scalars['String']>;
  pageTitle?: Maybe<Scalars['String']>;
  parsedPageDescription?: Maybe<Scalars['String']>;
  /** Reads a single `Preboarding` that is related to this `PreboardingSlide`. */
  preboarding?: Maybe<Preboarding>;
  preboardingId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `PreboardingResultSlideComment`. */
  preboardingResultSlideComments: PreboardingResultSlideCommentsConnection;
  /** Reads and enables pagination through a set of `PreboardingSlideFormField`. */
  preboardingSlideFormFields: PreboardingSlideFormFieldsConnection;
  reviewNote?: Maybe<Scalars['String']>;
  userIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};


export type PreboardingSlideParsedPageDescriptionArgs = {
  preboardingEmployeeId: Scalars['UUID'];
};


export type PreboardingSlidePreboardingResultSlideCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingResultSlideCommentCondition>;
  filter?: InputMaybe<PreboardingResultSlideCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingResultSlideCommentsOrderBy>>;
};


export type PreboardingSlidePreboardingSlideFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingSlideFormFieldCondition>;
  filter?: InputMaybe<PreboardingSlideFormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingSlideFormFieldsOrderBy>>;
};

/** The `preboardingSlide` to be created by this mutation. */
export type PreboardingSlideCompanyIdFkeyConnectionPreboardingSlideCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addReviewNote?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  pageDescription?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  preboarding?: InputMaybe<PreboardingSlidePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInverseInput>;
  reviewNote?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `company` in the `PreboardingSlideInput` mutation. */
export type PreboardingSlideCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnPreboardingSlideForPreboardingSlideCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingSlide` in the `CompanyInput` mutation. */
export type PreboardingSlideCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `preboardingSlide` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingSlidePreboardingSlidePkeyConnect>>;
  /** A `PreboardingSlideInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingSlideCompanyIdFkeyConnectionPreboardingSlideCreateInput>>;
  /** The primary key(s) and patch data for `preboardingSlide` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingSlideOnPreboardingSlideForPreboardingSlideCompanyIdFkeyUsingPreboardingSlidePkeyUpdate>>;
};

/**
 * A condition to be used against `PreboardingSlide` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PreboardingSlideCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `addReviewNote` field. */
  addReviewNote?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `pageDescription` field. */
  pageDescription?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `pageTitle` field. */
  pageTitle?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `preboardingId` field. */
  preboardingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `reviewNote` field. */
  reviewNote?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userIds` field. */
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `engagementType` to be created by this mutation. */
export type PreboardingSlideEngagementTypeIdForeignConnectionEngagementTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `preboardingSlide` to be created by this mutation. */
export type PreboardingSlideEngagementTypeIdForeignConnectionPreboardingSlideCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addReviewNote?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  pageDescription?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  preboarding?: InputMaybe<PreboardingSlidePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInverseInput>;
  reviewNote?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `engagementType` in the `PreboardingSlideInput` mutation. */
export type PreboardingSlideEngagementTypeIdForeignInput = {
  /** The primary key(s) for `engagementType` for the far side of the relationship. */
  connectById?: InputMaybe<EngagementTypeEngagementTypePkeyConnect>;
  /** A `EngagementTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingSlideEngagementTypeIdForeignConnectionEngagementTypeCreateInput>;
  /** The primary key(s) and patch data for `engagementType` for the far side of the relationship. */
  updateById?: InputMaybe<EngagementTypeOnPreboardingSlideForPreboardingSlideEngagementTypeIdForeignUsingEngagementTypePkeyUpdate>;
};

/** Input for the nested mutation of `preboardingSlide` in the `EngagementTypeInput` mutation. */
export type PreboardingSlideEngagementTypeIdForeignInverseInput = {
  /** The primary key(s) for `preboardingSlide` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingSlidePreboardingSlidePkeyConnect>>;
  /** A `PreboardingSlideInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingSlideEngagementTypeIdForeignConnectionPreboardingSlideCreateInput>>;
  /** The primary key(s) and patch data for `preboardingSlide` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingSlideOnPreboardingSlideForPreboardingSlideEngagementTypeIdForeignUsingPreboardingSlidePkeyUpdate>>;
};

/** A filter to be used against `PreboardingSlide` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingSlideFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `addReviewNote` field. */
  addReviewNote?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PreboardingSlideFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** A related `company` exists. */
  companyExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `engagementType` relation. */
  engagementType?: InputMaybe<EngagementTypeFilter>;
  /** A related `engagementType` exists. */
  engagementTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PreboardingSlideFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PreboardingSlideFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `pageDescription` field. */
  pageDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `pageTitle` field. */
  pageTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `preboarding` relation. */
  preboarding?: InputMaybe<PreboardingFilter>;
  /** Filter by the object’s `preboardingId` field. */
  preboardingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `preboardingResultSlideComments` relation. */
  preboardingResultSlideComments?: InputMaybe<PreboardingSlideToManyPreboardingResultSlideCommentFilter>;
  /** Some related `preboardingResultSlideComments` exist. */
  preboardingResultSlideCommentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingSlideFormFields` relation. */
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideToManyPreboardingSlideFormFieldFilter>;
  /** Some related `preboardingSlideFormFields` exist. */
  preboardingSlideFormFieldsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `reviewNote` field. */
  reviewNote?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userIds` field. */
  userIds?: InputMaybe<UuidListFilter>;
};

export type PreboardingSlideFormField = {
  __typename?: 'PreboardingSlideFormField';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `PreboardingSlideFormField`. */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `ContractSignPending`. */
  contractSignPendings: ContractSignPendingsConnection;
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `EngagementType` that is related to this `PreboardingSlideFormField`. */
  engagementType?: Maybe<EngagementType>;
  engagementTypeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `FormField` that is related to this `PreboardingSlideFormField`. */
  formField?: Maybe<FormField>;
  formFieldId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  order?: Maybe<Scalars['Int']>;
  /** Reads a single `PreboardingSlide` that is related to this `PreboardingSlideFormField`. */
  preboardingSlide?: Maybe<PreboardingSlide>;
  /** Reads a single `PreboardingSlideFormField` that is related to this `PreboardingSlideFormField`. */
  preboardingSlideFormFieldByPreboardingSlideFormFieldIdParent?: Maybe<PreboardingSlideFormField>;
  preboardingSlideFormFieldIdParent?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `PreboardingSlideFormField`. */
  preboardingSlideFormFieldsByPreboardingSlideFormFieldIdParent: PreboardingSlideFormFieldsConnection;
  preboardingSlideId: Scalars['UUID'];
  required?: Maybe<Scalars['Boolean']>;
  storage?: Maybe<Storage>;
  systemFieldName?: Maybe<UserEmployeeFields>;
  userIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};


export type PreboardingSlideFormFieldContractSignPendingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingCondition>;
  filter?: InputMaybe<ContractSignPendingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingsOrderBy>>;
};


export type PreboardingSlideFormFieldPreboardingSlideFormFieldsByPreboardingSlideFormFieldIdParentArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingSlideFormFieldCondition>;
  filter?: InputMaybe<PreboardingSlideFormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingSlideFormFieldsOrderBy>>;
};

/** The `preboardingSlideFormField` to be created by this mutation. */
export type PreboardingSlideFormFieldCompanyIdFkeyConnectionPreboardingSlideFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInverseInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingSlide?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInput>;
  preboardingSlideFormField?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldIdChInput>;
  preboardingSlideFormFieldIdParent?: InputMaybe<Scalars['UUID']>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  required?: InputMaybe<Scalars['Boolean']>;
  systemFieldName?: InputMaybe<UserEmployeeFields>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `company` in the `PreboardingSlideFormFieldInput` mutation. */
export type PreboardingSlideFormFieldCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnPreboardingSlideFormFieldForPreboardingSlideFormFieldCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingSlideFormField` in the `CompanyInput` mutation. */
export type PreboardingSlideFormFieldCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `preboardingSlideFormField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingSlideFormFieldPreboardingSlideFormFieldPkeyConnect>>;
  /** A `PreboardingSlideFormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingSlideFormFieldCompanyIdFkeyConnectionPreboardingSlideFormFieldCreateInput>>;
  /** The primary key(s) for `preboardingSlideFormField` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingSlideFormFieldPreboardingSlideFormFieldPkeyDelete>>;
  /** Flag indicating whether all other `preboardingSlideFormField` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingSlideFormField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldCompanyIdFkeyUsingPreboardingSlideFormFieldPkeyUpdate>>;
};

/**
 * A condition to be used against `PreboardingSlideFormField` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type PreboardingSlideFormFieldCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `preboardingSlideFormFieldIdParent` field. */
  preboardingSlideFormFieldIdParent?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `preboardingSlideId` field. */
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `required` field. */
  required?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `systemFieldName` field. */
  systemFieldName?: InputMaybe<UserEmployeeFields>;
  /** Checks for equality with the object’s `userIds` field. */
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `engagementType` to be created by this mutation. */
export type PreboardingSlideFormFieldEngagementTypeIdForeignConnectionEngagementTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `preboardingSlideFormField` to be created by this mutation. */
export type PreboardingSlideFormFieldEngagementTypeIdForeignConnectionPreboardingSlideFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInverseInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInput>;
  formField?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingSlide?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInput>;
  preboardingSlideFormField?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldIdChInput>;
  preboardingSlideFormFieldIdParent?: InputMaybe<Scalars['UUID']>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  required?: InputMaybe<Scalars['Boolean']>;
  systemFieldName?: InputMaybe<UserEmployeeFields>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `engagementType` in the `PreboardingSlideFormFieldInput` mutation. */
export type PreboardingSlideFormFieldEngagementTypeIdForeignInput = {
  /** The primary key(s) for `engagementType` for the far side of the relationship. */
  connectById?: InputMaybe<EngagementTypeEngagementTypePkeyConnect>;
  /** A `EngagementTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignConnectionEngagementTypeCreateInput>;
  /** The primary key(s) and patch data for `engagementType` for the far side of the relationship. */
  updateById?: InputMaybe<EngagementTypeOnPreboardingSlideFormFieldForPreboardingSlideFormFieldEngagementTypeIdForeignUsingEngagementTypePkeyUpdate>;
};

/** Input for the nested mutation of `preboardingSlideFormField` in the `EngagementTypeInput` mutation. */
export type PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput = {
  /** The primary key(s) for `preboardingSlideFormField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingSlideFormFieldPreboardingSlideFormFieldPkeyConnect>>;
  /** A `PreboardingSlideFormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingSlideFormFieldEngagementTypeIdForeignConnectionPreboardingSlideFormFieldCreateInput>>;
  /** The primary key(s) for `preboardingSlideFormField` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingSlideFormFieldPreboardingSlideFormFieldPkeyDelete>>;
  /** Flag indicating whether all other `preboardingSlideFormField` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingSlideFormField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldEngagementTypeIdForeignUsingPreboardingSlideFormFieldPkeyUpdate>>;
};

/** A filter to be used against `PreboardingSlideFormField` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingSlideFormFieldFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PreboardingSlideFormFieldFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** A related `company` exists. */
  companyExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `contractSignPendings` relation. */
  contractSignPendings?: InputMaybe<PreboardingSlideFormFieldToManyContractSignPendingFilter>;
  /** Some related `contractSignPendings` exist. */
  contractSignPendingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `engagementType` relation. */
  engagementType?: InputMaybe<EngagementTypeFilter>;
  /** A related `engagementType` exists. */
  engagementTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `engagementTypeId` field. */
  engagementTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `formField` relation. */
  formField?: InputMaybe<FormFieldFilter>;
  /** A related `formField` exists. */
  formFieldExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PreboardingSlideFormFieldFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PreboardingSlideFormFieldFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `preboardingSlide` relation. */
  preboardingSlide?: InputMaybe<PreboardingSlideFilter>;
  /** Filter by the object’s `preboardingSlideFormFieldByPreboardingSlideFormFieldIdParent` relation. */
  preboardingSlideFormFieldByPreboardingSlideFormFieldIdParent?: InputMaybe<PreboardingSlideFormFieldFilter>;
  /** A related `preboardingSlideFormFieldByPreboardingSlideFormFieldIdParent` exists. */
  preboardingSlideFormFieldByPreboardingSlideFormFieldIdParentExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingSlideFormFieldIdParent` field. */
  preboardingSlideFormFieldIdParent?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `preboardingSlideFormFieldsByPreboardingSlideFormFieldIdParent` relation. */
  preboardingSlideFormFieldsByPreboardingSlideFormFieldIdParent?: InputMaybe<PreboardingSlideFormFieldToManyPreboardingSlideFormFieldFilter>;
  /** Some related `preboardingSlideFormFieldsByPreboardingSlideFormFieldIdParent` exist. */
  preboardingSlideFormFieldsByPreboardingSlideFormFieldIdParentExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingSlideId` field. */
  preboardingSlideId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `required` field. */
  required?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `systemFieldName` field. */
  systemFieldName?: InputMaybe<UserEmployeeFieldsFilter>;
  /** Filter by the object’s `userIds` field. */
  userIds?: InputMaybe<UuidListFilter>;
};

/** The `formField` to be created by this mutation. */
export type PreboardingSlideFormFieldFormFieldIdForeignConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `preboardingSlideFormField` to be created by this mutation. */
export type PreboardingSlideFormFieldFormFieldIdForeignConnectionPreboardingSlideFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInverseInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingSlide?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInput>;
  preboardingSlideFormField?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldIdChInput>;
  preboardingSlideFormFieldIdParent?: InputMaybe<Scalars['UUID']>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  required?: InputMaybe<Scalars['Boolean']>;
  systemFieldName?: InputMaybe<UserEmployeeFields>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `formField` in the `PreboardingSlideFormFieldInput` mutation. */
export type PreboardingSlideFormFieldFormFieldIdForeignInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<FormFieldFormFieldPkeyConnect>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignConnectionFormFieldCreateInput>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<FormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldFormFieldIdForeignUsingFormFieldPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingSlideFormField` in the `FormFieldInput` mutation. */
export type PreboardingSlideFormFieldFormFieldIdForeignInverseInput = {
  /** The primary key(s) for `preboardingSlideFormField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingSlideFormFieldPreboardingSlideFormFieldPkeyConnect>>;
  /** A `PreboardingSlideFormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingSlideFormFieldFormFieldIdForeignConnectionPreboardingSlideFormFieldCreateInput>>;
  /** The primary key(s) for `preboardingSlideFormField` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingSlideFormFieldPreboardingSlideFormFieldPkeyDelete>>;
  /** Flag indicating whether all other `preboardingSlideFormField` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingSlideFormField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldFormFieldIdForeignUsingPreboardingSlideFormFieldPkeyUpdate>>;
};

/** An input for mutations affecting `PreboardingSlideFormField` */
export type PreboardingSlideFormFieldInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInverseInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingSlide?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInput>;
  preboardingSlideFormField?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldIdChInput>;
  preboardingSlideFormFieldIdParent?: InputMaybe<Scalars['UUID']>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  required?: InputMaybe<Scalars['Boolean']>;
  systemFieldName?: InputMaybe<UserEmployeeFields>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The fields on `preboardingSlideFormField` to look up the row to update. */
export type PreboardingSlideFormFieldOnContractSignPendingForContractSignPendingPreboardingSlideFormFieldIdForeignUsingPreboardingSlideFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingSlideFormField` being updated. */
  patch: UpdatePreboardingSlideFormFieldOnContractSignPendingForContractSignPendingPreboardingSlideFormFieldIdForeignPatch;
};

/** The fields on `preboardingSlideFormField` to look up the row to update. */
export type PreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldCompanyIdFkeyUsingPreboardingSlideFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingSlideFormField` being updated. */
  patch: UpdatePreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldCompanyIdFkeyPatch;
};

/** The fields on `preboardingSlideFormField` to look up the row to update. */
export type PreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldEngagementTypeIdForeignUsingPreboardingSlideFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingSlideFormField` being updated. */
  patch: UpdatePreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldEngagementTypeIdForeignPatch;
};

/** The fields on `preboardingSlideFormField` to look up the row to update. */
export type PreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldFormFieldIdForeignUsingPreboardingSlideFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingSlideFormField` being updated. */
  patch: UpdatePreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldFormFieldIdForeignPatch;
};

/** The fields on `preboardingSlideFormField` to look up the row to update. */
export type PreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldPreboardingSlideFormFieldIdChUsingPreboardingSlideFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingSlideFormField` being updated. */
  patch: UpdatePreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldPreboardingSlideFormFieldIdChPatch;
};

/** The fields on `preboardingSlideFormField` to look up the row to update. */
export type PreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldPreboardingSlideIdForeignUsingPreboardingSlideFormFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingSlideFormField` being updated. */
  patch: UpdatePreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldPreboardingSlideIdForeignPatch;
};

/** Represents an update to a `PreboardingSlideFormField`. Fields that are set will be updated. */
export type PreboardingSlideFormFieldPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInverseInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingSlide?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInput>;
  preboardingSlideFormField?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldIdChInput>;
  preboardingSlideFormFieldIdParent?: InputMaybe<Scalars['UUID']>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  required?: InputMaybe<Scalars['Boolean']>;
  systemFieldName?: InputMaybe<UserEmployeeFields>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `preboardingSlideFormField` to be created by this mutation. */
export type PreboardingSlideFormFieldPreboardingSlideFormFieldIdChConnectionPreboardingSlideFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInverseInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingSlide?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInput>;
  preboardingSlideFormField?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldIdChInput>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  required?: InputMaybe<Scalars['Boolean']>;
  systemFieldName?: InputMaybe<UserEmployeeFields>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `preboardingSlideFormField` in the `PreboardingSlideFormFieldInput` mutation. */
export type PreboardingSlideFormFieldPreboardingSlideFormFieldIdChInput = {
  /** The primary key(s) for `preboardingSlideFormField` for the far side of the relationship. */
  connectById?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldPkeyConnect>;
  /** A `PreboardingSlideFormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldIdChConnectionPreboardingSlideFormFieldCreateInput>;
  /** The primary key(s) for `preboardingSlideFormField` for the far side of the relationship. */
  deleteById?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldPkeyDelete>;
  /** The primary key(s) and patch data for `preboardingSlideFormField` for the far side of the relationship. */
  updateById?: InputMaybe<PreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldPreboardingSlideFormFieldIdChUsingPreboardingSlideFormFieldPkeyUpdate>;
};

/** The fields on `preboardingSlideFormField` to look up the row to connect. */
export type PreboardingSlideFormFieldPreboardingSlideFormFieldPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `preboardingSlideFormField` to look up the row to delete. */
export type PreboardingSlideFormFieldPreboardingSlideFormFieldPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `preboardingSlide` to be created by this mutation. */
export type PreboardingSlideFormFieldPreboardingSlideIdForeignConnectionPreboardingSlideCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addReviewNote?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  pageDescription?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  preboarding?: InputMaybe<PreboardingSlidePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInverseInput>;
  reviewNote?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `preboardingSlideFormField` to be created by this mutation. */
export type PreboardingSlideFormFieldPreboardingSlideIdForeignConnectionPreboardingSlideFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInverseInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingSlide?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInput>;
  preboardingSlideFormField?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldIdChInput>;
  preboardingSlideFormFieldIdParent?: InputMaybe<Scalars['UUID']>;
  required?: InputMaybe<Scalars['Boolean']>;
  storageId?: InputMaybe<Scalars['UUID']>;
  systemFieldName?: InputMaybe<UserEmployeeFields>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `preboardingSlide` in the `PreboardingSlideFormFieldInput` mutation. */
export type PreboardingSlideFormFieldPreboardingSlideIdForeignInput = {
  /** The primary key(s) for `preboardingSlide` for the far side of the relationship. */
  connectById?: InputMaybe<PreboardingSlidePreboardingSlidePkeyConnect>;
  /** A `PreboardingSlideInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignConnectionPreboardingSlideCreateInput>;
  /** The primary key(s) and patch data for `preboardingSlide` for the far side of the relationship. */
  updateById?: InputMaybe<PreboardingSlideOnPreboardingSlideFormFieldForPreboardingSlideFormFieldPreboardingSlideIdForeignUsingPreboardingSlidePkeyUpdate>;
};

/** Input for the nested mutation of `preboardingSlideFormField` in the `PreboardingSlideInput` mutation. */
export type PreboardingSlideFormFieldPreboardingSlideIdForeignInverseInput = {
  /** The primary key(s) for `preboardingSlideFormField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingSlideFormFieldPreboardingSlideFormFieldPkeyConnect>>;
  /** A `PreboardingSlideFormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingSlideFormFieldPreboardingSlideIdForeignConnectionPreboardingSlideFormFieldCreateInput>>;
  /** The primary key(s) for `preboardingSlideFormField` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PreboardingSlideFormFieldPreboardingSlideFormFieldPkeyDelete>>;
  /** Flag indicating whether all other `preboardingSlideFormField` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `preboardingSlideFormField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldPreboardingSlideIdForeignUsingPreboardingSlideFormFieldPkeyUpdate>>;
};

/** A filter to be used against many `ContractSignPending` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingSlideFormFieldToManyContractSignPendingFilter = {
  /** Every related `ContractSignPending` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractSignPendingFilter>;
  /** No related `ContractSignPending` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractSignPendingFilter>;
  /** Some related `ContractSignPending` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractSignPendingFilter>;
};

/** A filter to be used against many `PreboardingSlideFormField` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingSlideFormFieldToManyPreboardingSlideFormFieldFilter = {
  /** Every related `PreboardingSlideFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingSlideFormFieldFilter>;
  /** No related `PreboardingSlideFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingSlideFormFieldFilter>;
  /** Some related `PreboardingSlideFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingSlideFormFieldFilter>;
};

/** A connection to a list of `PreboardingSlideFormField` values. */
export type PreboardingSlideFormFieldsConnection = {
  __typename?: 'PreboardingSlideFormFieldsConnection';
  /** A list of edges which contains the `PreboardingSlideFormField` and cursor to aid in pagination. */
  edges: Array<PreboardingSlideFormFieldsEdge>;
  /** A list of `PreboardingSlideFormField` objects. */
  nodes: Array<Maybe<PreboardingSlideFormField>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PreboardingSlideFormField` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PreboardingSlideFormField` edge in the connection. */
export type PreboardingSlideFormFieldsEdge = {
  __typename?: 'PreboardingSlideFormFieldsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PreboardingSlideFormField` at the end of the edge. */
  node?: Maybe<PreboardingSlideFormField>;
};

/** Methods to use when ordering `PreboardingSlideFormField`. */
export type PreboardingSlideFormFieldsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CONTRACT_SIGN_PENDINGS_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__COUNT_ASC'
  | 'CONTRACT_SIGN_PENDINGS_BY_PREBOARDING_SLIDE_FORM_FIELD_ID__COUNT_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_ID_ASC'
  | 'ENGAGEMENT_TYPE_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_DESC'
  | 'FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ACTIVE_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ACTIVE_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ADD_REVIEW_NOTE_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ADD_REVIEW_NOTE_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__COMPANY_ID_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__COMPANY_ID_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__DEPARTMENTS_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__DEPARTMENTS_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ID_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ID_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__NAME_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__NAME_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ORDER_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__ORDER_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__PAGE_DESCRIPTION_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__PAGE_DESCRIPTION_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__PAGE_TITLE_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__PAGE_TITLE_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__PREBOARDING_ID_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__PREBOARDING_ID_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__REVIEW_NOTE_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__REVIEW_NOTE_DESC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__USER_IDS_ASC'
  | 'PREBOARDING_SLIDE_BY_PREBOARDING_SLIDE_ID__USER_IDS_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELDS_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__COUNT_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELDS_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__COUNT_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__ACTIVE_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__ACTIVE_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__COMPANY_ID_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__COMPANY_ID_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__DEPARTMENTS_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__DEPARTMENTS_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__ENGAGEMENT_TYPE_ID_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__ENGAGEMENT_TYPE_ID_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__FORM_FIELD_ID_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__FORM_FIELD_ID_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__ID_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__ID_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__ORDER_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__ORDER_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__PREBOARDING_SLIDE_ID_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__PREBOARDING_SLIDE_ID_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__REQUIRED_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__REQUIRED_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__SYSTEM_FIELD_NAME_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__SYSTEM_FIELD_NAME_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__USER_IDS_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_BY_PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT__USER_IDS_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELD_ID_PARENT_DESC'
  | 'PREBOARDING_SLIDE_ID_ASC'
  | 'PREBOARDING_SLIDE_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REQUIRED_ASC'
  | 'REQUIRED_DESC'
  | 'SYSTEM_FIELD_NAME_ASC'
  | 'SYSTEM_FIELD_NAME_DESC'
  | 'USER_IDS_ASC'
  | 'USER_IDS_DESC';

/** An input for mutations affecting `PreboardingSlide` */
export type PreboardingSlideInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addReviewNote?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  pageDescription?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  preboarding?: InputMaybe<PreboardingSlidePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInverseInput>;
  reviewNote?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The fields on `preboardingSlide` to look up the row to update. */
export type PreboardingSlideOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingSlideIdForeignUsingPreboardingSlidePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingSlide` being updated. */
  patch: UpdatePreboardingSlideOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingSlideIdForeignPatch;
};

/** The fields on `preboardingSlide` to look up the row to update. */
export type PreboardingSlideOnPreboardingSlideForPreboardingSlideCompanyIdFkeyUsingPreboardingSlidePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingSlide` being updated. */
  patch: UpdatePreboardingSlideOnPreboardingSlideForPreboardingSlideCompanyIdFkeyPatch;
};

/** The fields on `preboardingSlide` to look up the row to update. */
export type PreboardingSlideOnPreboardingSlideForPreboardingSlideEngagementTypeIdForeignUsingPreboardingSlidePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingSlide` being updated. */
  patch: UpdatePreboardingSlideOnPreboardingSlideForPreboardingSlideEngagementTypeIdForeignPatch;
};

/** The fields on `preboardingSlide` to look up the row to update. */
export type PreboardingSlideOnPreboardingSlideForPreboardingSlidePreboardingIdForeignUsingPreboardingSlidePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingSlide` being updated. */
  patch: UpdatePreboardingSlideOnPreboardingSlideForPreboardingSlidePreboardingIdForeignPatch;
};

/** The fields on `preboardingSlide` to look up the row to update. */
export type PreboardingSlideOnPreboardingSlideFormFieldForPreboardingSlideFormFieldPreboardingSlideIdForeignUsingPreboardingSlidePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `preboardingSlide` being updated. */
  patch: UpdatePreboardingSlideOnPreboardingSlideFormFieldForPreboardingSlideFormFieldPreboardingSlideIdForeignPatch;
};

/** Represents an update to a `PreboardingSlide`. Fields that are set will be updated. */
export type PreboardingSlidePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addReviewNote?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  pageDescription?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  preboarding?: InputMaybe<PreboardingSlidePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInverseInput>;
  reviewNote?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `preboarding` to be created by this mutation. */
export type PreboardingSlidePreboardingIdForeignConnectionPreboardingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontStorageId?: InputMaybe<Scalars['UUID']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoStorageId?: InputMaybe<Scalars['UUID']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `preboardingSlide` to be created by this mutation. */
export type PreboardingSlidePreboardingIdForeignConnectionPreboardingSlideCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addReviewNote?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  pageDescription?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  preboarding?: InputMaybe<PreboardingSlidePreboardingIdForeignInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInverseInput>;
  reviewNote?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `preboarding` in the `PreboardingSlideInput` mutation. */
export type PreboardingSlidePreboardingIdForeignInput = {
  /** The primary key(s) for `preboarding` for the far side of the relationship. */
  connectById?: InputMaybe<PreboardingPreboardingPkeyConnect>;
  /** A `PreboardingInput` object that will be created and connected to this object. */
  create?: InputMaybe<PreboardingSlidePreboardingIdForeignConnectionPreboardingCreateInput>;
  /** The primary key(s) and patch data for `preboarding` for the far side of the relationship. */
  updateById?: InputMaybe<PreboardingOnPreboardingSlideForPreboardingSlidePreboardingIdForeignUsingPreboardingPkeyUpdate>;
};

/** Input for the nested mutation of `preboardingSlide` in the `PreboardingInput` mutation. */
export type PreboardingSlidePreboardingIdForeignInverseInput = {
  /** The primary key(s) for `preboardingSlide` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PreboardingSlidePreboardingSlidePkeyConnect>>;
  /** A `PreboardingSlideInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PreboardingSlidePreboardingIdForeignConnectionPreboardingSlideCreateInput>>;
  /** The primary key(s) and patch data for `preboardingSlide` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PreboardingSlideOnPreboardingSlideForPreboardingSlidePreboardingIdForeignUsingPreboardingSlidePkeyUpdate>>;
};

/** The fields on `preboardingSlide` to look up the row to connect. */
export type PreboardingSlidePreboardingSlidePkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `PreboardingResultSlideComment` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingSlideToManyPreboardingResultSlideCommentFilter = {
  /** Every related `PreboardingResultSlideComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingResultSlideCommentFilter>;
  /** No related `PreboardingResultSlideComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingResultSlideCommentFilter>;
  /** Some related `PreboardingResultSlideComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingResultSlideCommentFilter>;
};

/** A filter to be used against many `PreboardingSlideFormField` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingSlideToManyPreboardingSlideFormFieldFilter = {
  /** Every related `PreboardingSlideFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingSlideFormFieldFilter>;
  /** No related `PreboardingSlideFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingSlideFormFieldFilter>;
  /** Some related `PreboardingSlideFormField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingSlideFormFieldFilter>;
};

/** A connection to a list of `PreboardingSlide` values. */
export type PreboardingSlidesConnection = {
  __typename?: 'PreboardingSlidesConnection';
  /** A list of edges which contains the `PreboardingSlide` and cursor to aid in pagination. */
  edges: Array<PreboardingSlidesEdge>;
  /** A list of `PreboardingSlide` objects. */
  nodes: Array<Maybe<PreboardingSlide>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PreboardingSlide` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PreboardingSlide` edge in the connection. */
export type PreboardingSlidesEdge = {
  __typename?: 'PreboardingSlidesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PreboardingSlide` at the end of the edge. */
  node?: Maybe<PreboardingSlide>;
};

/** Methods to use when ordering `PreboardingSlide`. */
export type PreboardingSlidesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ADD_REVIEW_NOTE_ASC'
  | 'ADD_REVIEW_NOTE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_ID_ASC'
  | 'ENGAGEMENT_TYPE_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PAGE_DESCRIPTION_ASC'
  | 'PAGE_DESCRIPTION_DESC'
  | 'PAGE_TITLE_ASC'
  | 'PAGE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ACTIVE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ACTIVE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ANONYMOUS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ANONYMOUS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ARCHIVED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ARCHIVED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__BACKGROUND_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__BACKGROUND_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CHANNEL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CHANNEL_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CLOSE_ACCESS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CLOSE_ACCESS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPANY_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPANY_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPLETED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__COMPLETED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONFIRM_RESULTS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONFIRM_RESULTS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_BACKGROUND_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_BACKGROUND_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_TEXT_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CONTENT_TEXT_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_AT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_AT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_FROM_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__CREATED_FROM_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DATE_FORMAT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DATE_FORMAT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEADLINE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEADLINE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_DIRECT_MANAGER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_DIRECT_MANAGER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_GROUP_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_GROUP_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_USER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEFAULT_MANAGER_USER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEPARTMENT_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DEPARTMENT_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DISABLE_2FA_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__DISABLE_2FA_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_BODY_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_BODY_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_SUBJECT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMAIL_SUBJECT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMPLOYEE_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__EMPLOYEE_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FALLBACK_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FALLBACK_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FIRST_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_SIZE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_SIZE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_URL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__FONT_URL_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LAST_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LINK_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LINK_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOCALE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOCALE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_WIDTH_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__LOGO_WIDTH_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__MANAGER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__MANAGER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NEXT_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__NEXT_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ORDER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__ORDER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_ENABLED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_ENABLED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__OVERVIEW_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREDECESSOR_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREDECESSOR_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREV_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PREV_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PUBLISHED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__PUBLISHED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_DIRECT_MANAGER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_DIRECT_MANAGER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_GROUP_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_GROUP_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_ID_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RECIPIENT_ID_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDED_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDED_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DAYS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DAYS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__REMINDER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESPONSIBLE_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESPONSIBLE_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESULT_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__RESULT_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__SMS_BODY_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__SMS_BODY_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__START_DATE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__START_DATE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEMPLATE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEMPLATE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEXT_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TEXT_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TYPE_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__TYPE_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USER_IDS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USER_IDS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CONTENT_COLORS_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CONTENT_COLORS_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CUSTOM_LINK_BUTTON_COLOR_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_CUSTOM_LINK_BUTTON_COLOR_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_LEADER_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_LEADER_DESC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_WORK_EMAIL_ASC'
  | 'PREBOARDING_BY_PREBOARDING_ID__USE_WORK_EMAIL_DESC'
  | 'PREBOARDING_ID_ASC'
  | 'PREBOARDING_ID_DESC'
  | 'PREBOARDING_RESULT_SLIDE_COMMENTS_BY_PREBOARDING_SLIDE_ID__COUNT_ASC'
  | 'PREBOARDING_RESULT_SLIDE_COMMENTS_BY_PREBOARDING_SLIDE_ID__COUNT_DESC'
  | 'PREBOARDING_SLIDE_FORM_FIELDS_BY_PREBOARDING_SLIDE_ID__COUNT_ASC'
  | 'PREBOARDING_SLIDE_FORM_FIELDS_BY_PREBOARDING_SLIDE_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REVIEW_NOTE_ASC'
  | 'REVIEW_NOTE_DESC'
  | 'USER_IDS_ASC'
  | 'USER_IDS_DESC';

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

/** A filter to be used against many `Notification` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingToManyNotificationFilter = {
  /** Every related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationFilter>;
  /** No related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationFilter>;
  /** Some related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationFilter>;
};

/** A filter to be used against many `PreboardingComment` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingToManyPreboardingCommentFilter = {
  /** Every related `PreboardingComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingCommentFilter>;
  /** No related `PreboardingComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingCommentFilter>;
  /** Some related `PreboardingComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingCommentFilter>;
};

/** A filter to be used against many `PreboardingEmployee` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingToManyPreboardingEmployeeFilter = {
  /** Every related `PreboardingEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingEmployeeFilter>;
  /** No related `PreboardingEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingEmployeeFilter>;
  /** Some related `PreboardingEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingEmployeeFilter>;
};

/** A filter to be used against many `Preboarding` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingToManyPreboardingFilter = {
  /** Every related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingFilter>;
  /** No related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingFilter>;
  /** Some related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingFilter>;
};

/** A filter to be used against many `PreboardingFormCache` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingToManyPreboardingFormCacheFilter = {
  /** Every related `PreboardingFormCache` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingFormCacheFilter>;
  /** No related `PreboardingFormCache` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingFormCacheFilter>;
  /** Some related `PreboardingFormCache` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingFormCacheFilter>;
};

/** A filter to be used against many `PreboardingProcess` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingToManyPreboardingProcessFilter = {
  /** Every related `PreboardingProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingProcessFilter>;
  /** No related `PreboardingProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingProcessFilter>;
  /** Some related `PreboardingProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingProcessFilter>;
};

/** A filter to be used against many `PreboardingSlide` object types. All fields are combined with a logical ‘and.’ */
export type PreboardingToManyPreboardingSlideFilter = {
  /** Every related `PreboardingSlide` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingSlideFilter>;
  /** No related `PreboardingSlide` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingSlideFilter>;
  /** Some related `PreboardingSlide` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingSlideFilter>;
};

export type PreboardingType =
  | 'ANONYMOUS'
  | 'EMPLOYEE_DEVELOPMENT_PLAN'
  | 'STANDARD';

/** A filter to be used against PreboardingType fields. All fields are combined with a logical ‘and.’ */
export type PreboardingTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PreboardingType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PreboardingType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PreboardingType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PreboardingType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PreboardingType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PreboardingType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PreboardingType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PreboardingType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PreboardingType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PreboardingType>>;
};

/** A connection to a list of `Preboarding` values. */
export type PreboardingsConnection = {
  __typename?: 'PreboardingsConnection';
  /** A list of edges which contains the `Preboarding` and cursor to aid in pagination. */
  edges: Array<PreboardingsEdge>;
  /** A list of `Preboarding` objects. */
  nodes: Array<Maybe<Preboarding>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Preboarding` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Preboarding` edge in the connection. */
export type PreboardingsEdge = {
  __typename?: 'PreboardingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Preboarding` at the end of the edge. */
  node?: Maybe<Preboarding>;
};

/** Methods to use when ordering `Preboarding`. */
export type PreboardingsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ANONYMOUS_ASC'
  | 'ANONYMOUS_DESC'
  | 'ARCHIVED_ASC'
  | 'ARCHIVED_DESC'
  | 'BACKGROUND_COLOR_ASC'
  | 'BACKGROUND_COLOR_DESC'
  | 'CHANNEL_ASC'
  | 'CHANNEL_DESC'
  | 'CLOSE_ACCESS_ASC'
  | 'CLOSE_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPLETED_ASC'
  | 'COMPLETED_DESC'
  | 'CONFIRM_RESULTS_ASC'
  | 'CONFIRM_RESULTS_DESC'
  | 'CONTENT_BACKGROUND_COLOR_ASC'
  | 'CONTENT_BACKGROUND_COLOR_DESC'
  | 'CONTENT_TEXT_COLOR_ASC'
  | 'CONTENT_TEXT_COLOR_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CREATED_FROM_ASC'
  | 'CREATED_FROM_DESC'
  | 'DATE_FORMAT_ASC'
  | 'DATE_FORMAT_DESC'
  | 'DEADLINE_ASC'
  | 'DEADLINE_DESC'
  | 'DEFAULT_MANAGER_DIRECT_MANAGER_ASC'
  | 'DEFAULT_MANAGER_DIRECT_MANAGER_DESC'
  | 'DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_ASC'
  | 'DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_DESC'
  | 'DEFAULT_MANAGER_GROUP_IDS_ASC'
  | 'DEFAULT_MANAGER_GROUP_IDS_DESC'
  | 'DEFAULT_MANAGER_USER_IDS_ASC'
  | 'DEFAULT_MANAGER_USER_IDS_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'DISABLE_2FA_ASC'
  | 'DISABLE_2FA_DESC'
  | 'EMAIL_BODY_ASC'
  | 'EMAIL_BODY_DESC'
  | 'EMAIL_SUBJECT_ASC'
  | 'EMAIL_SUBJECT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ACTIVE_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__CREATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__ID_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__NAME_DESC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'ENGAGEMENT_TYPE_BY_ENGAGEMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'ENGAGEMENT_TYPE_ID_ASC'
  | 'ENGAGEMENT_TYPE_ID_DESC'
  | 'FALLBACK_TEXT_ASC'
  | 'FALLBACK_TEXT_DESC'
  | 'FIRST_SLIDE_DESCRIPTION_ASC'
  | 'FIRST_SLIDE_DESCRIPTION_DESC'
  | 'FIRST_SLIDE_NAME_ASC'
  | 'FIRST_SLIDE_NAME_DESC'
  | 'FIRST_SLIDE_TITLE_ASC'
  | 'FIRST_SLIDE_TITLE_DESC'
  | 'FONT_SIZE_ASC'
  | 'FONT_SIZE_DESC'
  | 'FONT_TYPE_ASC'
  | 'FONT_TYPE_DESC'
  | 'FONT_URL_ASC'
  | 'FONT_URL_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__ACTIVE_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__ACTIVE_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__APPROVER_FORM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__APPROVER_FORM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__APPROVER_GROUP_IDS_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__APPROVER_GROUP_IDS_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__APPROVER_USER_IDS_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__APPROVER_USER_IDS_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__CARD_ORDER_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__CARD_ORDER_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__CHANGES_MUST_BE_APPROVED_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__CHANGES_MUST_BE_APPROVED_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__COMPANY_ID_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__COMPANY_ID_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__CREATED_AT_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__CREATED_AT_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__CUSTOM_ID_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__CUSTOM_ID_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__DEFAULT_VALUE_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__DEFAULT_VALUE_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__DEPARTMENTS_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__DEPARTMENTS_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__DEPARTMENT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__DEPARTMENT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__EVENT_ID_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__EVENT_ID_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__EXCLUDED_ROLE_IDS_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__EXCLUDED_ROLE_IDS_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__FIELD_GROUP_ID_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__FIELD_GROUP_ID_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__FIELD_TYPE_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__FIELD_TYPE_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__HELP_TEXT_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__HELP_TEXT_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__ID_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__ID_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__LOCALIZED_NAME_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__LOCALIZED_NAME_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__METADATA_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__METADATA_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__MULTIPLE_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__MULTIPLE_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__NAME_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__NAME_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__OBJECT_TYPE_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__OBJECT_TYPE_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__ORDER_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__ORDER_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__PARENT_FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__PARENT_FORM_FIELD_ID_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__PRODUCT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__PRODUCT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__REQUIRED_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__REQUIRED_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__SENSITIVE_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__SENSITIVE_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__SUPPORTS_FUTURE_DATA_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__SUPPORTS_FUTURE_DATA_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__UNIQUE_VALUE_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__UNIQUE_VALUE_DESC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__UPDATED_AT_ASC'
  | 'FORM_FIELD_BY_RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID__UPDATED_AT_DESC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__ACTIVE_ASC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__ACTIVE_DESC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__AUTO_ADD_ASC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__AUTO_ADD_DESC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__AUTO_ADD_NEW_PERMISSIONS_ASC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__AUTO_ADD_NEW_PERMISSIONS_DESC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__AUTO_INHERIT_ASC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__AUTO_INHERIT_DESC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__COMPANY_ID_ASC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__COMPANY_ID_DESC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__DESCRIPTION_ASC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__DESCRIPTION_DESC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__ID_ASC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__ID_DESC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__LOCALIZED_NAME_ASC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__LOCALIZED_NAME_DESC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__NAME_ASC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__NAME_DESC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__SCOPE_ASC'
  | 'GROUP_BY_RECIPIENT_GROUP_ID__SCOPE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LAST_SLIDE_DESCRIPTION_ASC'
  | 'LAST_SLIDE_DESCRIPTION_DESC'
  | 'LAST_SLIDE_NAME_ASC'
  | 'LAST_SLIDE_NAME_DESC'
  | 'LAST_SLIDE_TITLE_ASC'
  | 'LAST_SLIDE_TITLE_DESC'
  | 'LINK_BUTTON_TEXT_ASC'
  | 'LINK_BUTTON_TEXT_DESC'
  | 'LOCALE_ASC'
  | 'LOCALE_DESC'
  | 'LOGO_TYPE_ASC'
  | 'LOGO_TYPE_DESC'
  | 'LOGO_WIDTH_ASC'
  | 'LOGO_WIDTH_DESC'
  | 'MANAGER_IDS_ASC'
  | 'MANAGER_IDS_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'NEXT_BUTTON_TEXT_ASC'
  | 'NEXT_BUTTON_TEXT_DESC'
  | 'NOTIFICATIONS_BY_PREBOARDING_ID__COUNT_ASC'
  | 'NOTIFICATIONS_BY_PREBOARDING_ID__COUNT_DESC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_PREBOARDING_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_PREBOARDING_ID__COUNT_DESC'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'OVERVIEW_SLIDE_DESCRIPTION_ASC'
  | 'OVERVIEW_SLIDE_DESCRIPTION_DESC'
  | 'OVERVIEW_SLIDE_ENABLED_ASC'
  | 'OVERVIEW_SLIDE_ENABLED_DESC'
  | 'OVERVIEW_SLIDE_NAME_ASC'
  | 'OVERVIEW_SLIDE_NAME_DESC'
  | 'OVERVIEW_SLIDE_TITLE_ASC'
  | 'OVERVIEW_SLIDE_TITLE_DESC'
  | 'PREBOARDINGS_BY_CREATED_FROM__COUNT_ASC'
  | 'PREBOARDINGS_BY_CREATED_FROM__COUNT_DESC'
  | 'PREBOARDINGS_BY_PREDECESSOR_ID__COUNT_ASC'
  | 'PREBOARDINGS_BY_PREDECESSOR_ID__COUNT_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__ACTIVE_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__ACTIVE_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__ANONYMOUS_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__ANONYMOUS_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__ARCHIVED_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__ARCHIVED_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__BACKGROUND_COLOR_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__BACKGROUND_COLOR_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__CHANNEL_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__CHANNEL_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__CLOSE_ACCESS_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__CLOSE_ACCESS_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__COMPANY_ID_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__COMPANY_ID_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__COMPLETED_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__COMPLETED_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__CONFIRM_RESULTS_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__CONFIRM_RESULTS_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__CONTENT_BACKGROUND_COLOR_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__CONTENT_BACKGROUND_COLOR_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__CONTENT_TEXT_COLOR_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__CONTENT_TEXT_COLOR_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__CREATED_AT_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__CREATED_AT_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__CREATED_FROM_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__CREATED_FROM_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__DATE_FORMAT_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__DATE_FORMAT_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__DEADLINE_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__DEADLINE_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__DEFAULT_MANAGER_DIRECT_MANAGER_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__DEFAULT_MANAGER_DIRECT_MANAGER_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__DEFAULT_MANAGER_GROUP_IDS_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__DEFAULT_MANAGER_GROUP_IDS_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__DEFAULT_MANAGER_USER_IDS_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__DEFAULT_MANAGER_USER_IDS_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__DEPARTMENT_IDS_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__DEPARTMENT_IDS_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__DISABLE_2FA_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__DISABLE_2FA_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__EMAIL_BODY_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__EMAIL_BODY_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__EMAIL_SUBJECT_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__EMAIL_SUBJECT_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__EMPLOYEE_ID_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__EMPLOYEE_ID_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__ENGAGEMENT_TYPE_ID_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__ENGAGEMENT_TYPE_ID_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__FALLBACK_TEXT_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__FALLBACK_TEXT_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__FIRST_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__FIRST_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__FIRST_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__FIRST_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__FIRST_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__FIRST_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__FONT_SIZE_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__FONT_SIZE_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__FONT_TYPE_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__FONT_TYPE_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__FONT_URL_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__FONT_URL_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__ID_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__ID_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__LAST_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__LAST_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__LAST_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__LAST_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__LAST_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__LAST_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__LINK_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__LINK_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__LOCALE_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__LOCALE_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__LOGO_TYPE_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__LOGO_TYPE_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__LOGO_WIDTH_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__LOGO_WIDTH_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__MANAGER_IDS_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__MANAGER_IDS_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__NAME_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__NAME_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__NEXT_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__NEXT_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__ORDER_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__ORDER_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__OVERVIEW_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__OVERVIEW_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__OVERVIEW_SLIDE_ENABLED_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__OVERVIEW_SLIDE_ENABLED_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__OVERVIEW_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__OVERVIEW_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__OVERVIEW_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__OVERVIEW_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__PREDECESSOR_ID_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__PREDECESSOR_ID_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__PREV_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__PREV_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__PUBLISHED_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__PUBLISHED_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__RECIPIENT_DIRECT_MANAGER_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__RECIPIENT_DIRECT_MANAGER_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__RECIPIENT_GROUP_ID_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__RECIPIENT_GROUP_ID_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__RECIPIENT_ID_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__RECIPIENT_ID_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__REMINDED_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__REMINDED_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__REMINDER_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__REMINDER_DAYS_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__REMINDER_DAYS_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__REMINDER_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__RESPONSIBLE_IDS_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__RESPONSIBLE_IDS_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__RESULT_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__RESULT_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__SMS_BODY_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__SMS_BODY_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__START_DATE_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__START_DATE_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__TEMPLATE_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__TEMPLATE_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__TEXT_COLOR_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__TEXT_COLOR_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__TYPE_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__TYPE_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__USER_IDS_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__USER_IDS_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__USE_CONTENT_COLORS_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__USE_CONTENT_COLORS_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__USE_CUSTOM_LINK_BUTTON_COLOR_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__USE_CUSTOM_LINK_BUTTON_COLOR_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__USE_LEADER_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__USE_LEADER_DESC'
  | 'PREBOARDING_BY_CREATED_FROM__USE_WORK_EMAIL_ASC'
  | 'PREBOARDING_BY_CREATED_FROM__USE_WORK_EMAIL_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__ACTIVE_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__ACTIVE_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__ANONYMOUS_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__ANONYMOUS_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__ARCHIVED_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__ARCHIVED_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__BACKGROUND_COLOR_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__BACKGROUND_COLOR_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__CHANNEL_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__CHANNEL_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__CLOSE_ACCESS_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__CLOSE_ACCESS_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__COMPANY_ID_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__COMPANY_ID_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__COMPLETED_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__COMPLETED_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__CONFIRM_RESULTS_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__CONFIRM_RESULTS_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__CONTENT_BACKGROUND_COLOR_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__CONTENT_BACKGROUND_COLOR_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__CONTENT_TEXT_COLOR_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__CONTENT_TEXT_COLOR_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__CREATED_AT_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__CREATED_AT_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__CREATED_FROM_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__CREATED_FROM_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__DATE_FORMAT_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__DATE_FORMAT_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__DEADLINE_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__DEADLINE_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__DEFAULT_MANAGER_DIRECT_MANAGER_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__DEFAULT_MANAGER_DIRECT_MANAGER_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__DEFAULT_MANAGER_EMPLOYEE_FIELD_IDS_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__DEFAULT_MANAGER_GROUP_IDS_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__DEFAULT_MANAGER_GROUP_IDS_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__DEFAULT_MANAGER_USER_IDS_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__DEFAULT_MANAGER_USER_IDS_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__DEPARTMENT_IDS_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__DEPARTMENT_IDS_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__DISABLE_2FA_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__DISABLE_2FA_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__EMAIL_BODY_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__EMAIL_BODY_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__EMAIL_SUBJECT_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__EMAIL_SUBJECT_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__EMPLOYEE_ID_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__EMPLOYEE_ID_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__FALLBACK_TEXT_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__FALLBACK_TEXT_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__FIRST_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__FIRST_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__FIRST_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__FIRST_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__FIRST_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__FIRST_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__FONT_SIZE_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__FONT_SIZE_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__FONT_TYPE_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__FONT_TYPE_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__FONT_URL_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__FONT_URL_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__ID_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__ID_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__LAST_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__LAST_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__LAST_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__LAST_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__LAST_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__LAST_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__LINK_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__LINK_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__LOCALE_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__LOCALE_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__LOGO_TYPE_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__LOGO_TYPE_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__LOGO_WIDTH_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__LOGO_WIDTH_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__MANAGER_IDS_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__MANAGER_IDS_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__NAME_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__NAME_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__NEXT_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__NEXT_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__ORDER_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__ORDER_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__OVERVIEW_SLIDE_DESCRIPTION_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__OVERVIEW_SLIDE_DESCRIPTION_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__OVERVIEW_SLIDE_ENABLED_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__OVERVIEW_SLIDE_ENABLED_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__OVERVIEW_SLIDE_NAME_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__OVERVIEW_SLIDE_NAME_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__OVERVIEW_SLIDE_TITLE_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__OVERVIEW_SLIDE_TITLE_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__PREDECESSOR_ID_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__PREDECESSOR_ID_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__PREV_BUTTON_TEXT_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__PREV_BUTTON_TEXT_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__PUBLISHED_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__PUBLISHED_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__RECIPIENT_DIRECT_MANAGER_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__RECIPIENT_DIRECT_MANAGER_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__RECIPIENT_GROUP_ID_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__RECIPIENT_GROUP_ID_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__RECIPIENT_ID_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__RECIPIENT_ID_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__REMINDED_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__REMINDED_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__REMINDER_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__REMINDER_DAYS_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__REMINDER_DAYS_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__REMINDER_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__RESPONSIBLE_IDS_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__RESPONSIBLE_IDS_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__RESULT_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__RESULT_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__SMS_BODY_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__SMS_BODY_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__START_DATE_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__START_DATE_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__TEMPLATE_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__TEMPLATE_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__TEXT_COLOR_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__TEXT_COLOR_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__TYPE_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__TYPE_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__USER_IDS_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__USER_IDS_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__USE_CONTENT_COLORS_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__USE_CONTENT_COLORS_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__USE_CUSTOM_LINK_BUTTON_COLOR_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__USE_CUSTOM_LINK_BUTTON_COLOR_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__USE_LEADER_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__USE_LEADER_DESC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__USE_WORK_EMAIL_ASC'
  | 'PREBOARDING_BY_PREDECESSOR_ID__USE_WORK_EMAIL_DESC'
  | 'PREBOARDING_COMMENTS_BY_PREBOARDING_ID__COUNT_ASC'
  | 'PREBOARDING_COMMENTS_BY_PREBOARDING_ID__COUNT_DESC'
  | 'PREBOARDING_EMPLOYEES_BY_PREBOARDING_ID__COUNT_ASC'
  | 'PREBOARDING_EMPLOYEES_BY_PREBOARDING_ID__COUNT_DESC'
  | 'PREBOARDING_FORM_CACHES_BY_PREBOARDING_ID__COUNT_ASC'
  | 'PREBOARDING_FORM_CACHES_BY_PREBOARDING_ID__COUNT_DESC'
  | 'PREBOARDING_PROCESSES_BY_PREBOARDING_ID__COUNT_ASC'
  | 'PREBOARDING_PROCESSES_BY_PREBOARDING_ID__COUNT_DESC'
  | 'PREBOARDING_SLIDES_BY_PREBOARDING_ID__COUNT_ASC'
  | 'PREBOARDING_SLIDES_BY_PREBOARDING_ID__COUNT_DESC'
  | 'PREDECESSOR_ID_ASC'
  | 'PREDECESSOR_ID_DESC'
  | 'PREV_BUTTON_TEXT_ASC'
  | 'PREV_BUTTON_TEXT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PUBLISHED_ASC'
  | 'PUBLISHED_DESC'
  | 'RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_ASC'
  | 'RECIPIENT_CUSTOM_EMPLOYEE_FIELD_ID_DESC'
  | 'RECIPIENT_DIRECT_MANAGER_ASC'
  | 'RECIPIENT_DIRECT_MANAGER_DESC'
  | 'RECIPIENT_GROUP_ID_ASC'
  | 'RECIPIENT_GROUP_ID_DESC'
  | 'RECIPIENT_ID_ASC'
  | 'RECIPIENT_ID_DESC'
  | 'REMINDED_ASC'
  | 'REMINDED_DESC'
  | 'REMINDER_ASC'
  | 'REMINDER_DAYS_ASC'
  | 'REMINDER_DAYS_DESC'
  | 'REMINDER_DESC'
  | 'RESPONSIBLE_IDS_ASC'
  | 'RESPONSIBLE_IDS_DESC'
  | 'RESULT_ASC'
  | 'RESULT_DESC'
  | 'SMS_BODY_ASC'
  | 'SMS_BODY_DESC'
  | 'START_DATE_ASC'
  | 'START_DATE_DESC'
  | 'TEMPLATE_ASC'
  | 'TEMPLATE_DESC'
  | 'TEXT_COLOR_ASC'
  | 'TEXT_COLOR_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | 'USER_BY_RECIPIENT_ID__ACTIVE_ASC'
  | 'USER_BY_RECIPIENT_ID__ACTIVE_DESC'
  | 'USER_BY_RECIPIENT_ID__ADDRESS_ASC'
  | 'USER_BY_RECIPIENT_ID__ADDRESS_DESC'
  | 'USER_BY_RECIPIENT_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_RECIPIENT_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_RECIPIENT_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_RECIPIENT_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_RECIPIENT_ID__BIRTHDATE_ASC'
  | 'USER_BY_RECIPIENT_ID__BIRTHDATE_DESC'
  | 'USER_BY_RECIPIENT_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_RECIPIENT_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_RECIPIENT_ID__CAN_LOGIN_ASC'
  | 'USER_BY_RECIPIENT_ID__CAN_LOGIN_DESC'
  | 'USER_BY_RECIPIENT_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_RECIPIENT_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_RECIPIENT_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_RECIPIENT_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_RECIPIENT_ID__CITY_ASC'
  | 'USER_BY_RECIPIENT_ID__CITY_DESC'
  | 'USER_BY_RECIPIENT_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_RECIPIENT_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_RECIPIENT_ID__COMPANY_ID_ASC'
  | 'USER_BY_RECIPIENT_ID__COMPANY_ID_DESC'
  | 'USER_BY_RECIPIENT_ID__CPR_ASC'
  | 'USER_BY_RECIPIENT_ID__CPR_DESC'
  | 'USER_BY_RECIPIENT_ID__CUSTOM_ID_ASC'
  | 'USER_BY_RECIPIENT_ID__CUSTOM_ID_DESC'
  | 'USER_BY_RECIPIENT_ID__DELETE_AT_ASC'
  | 'USER_BY_RECIPIENT_ID__DELETE_AT_DESC'
  | 'USER_BY_RECIPIENT_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_RECIPIENT_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_RECIPIENT_ID__DEPARTMENTS_ASC'
  | 'USER_BY_RECIPIENT_ID__DEPARTMENTS_DESC'
  | 'USER_BY_RECIPIENT_ID__EMAIL_ASC'
  | 'USER_BY_RECIPIENT_ID__EMAIL_DESC'
  | 'USER_BY_RECIPIENT_ID__EMAIL_WORK_ASC'
  | 'USER_BY_RECIPIENT_ID__EMAIL_WORK_DESC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_RECIPIENT_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_RECIPIENT_ID__FIRST_NAME_ASC'
  | 'USER_BY_RECIPIENT_ID__FIRST_NAME_DESC'
  | 'USER_BY_RECIPIENT_ID__FULL_NAME_ASC'
  | 'USER_BY_RECIPIENT_ID__FULL_NAME_DESC'
  | 'USER_BY_RECIPIENT_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_RECIPIENT_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_RECIPIENT_ID__GODMODE_ASC'
  | 'USER_BY_RECIPIENT_ID__GODMODE_DESC'
  | 'USER_BY_RECIPIENT_ID__GROUP_IDS_ASC'
  | 'USER_BY_RECIPIENT_ID__GROUP_IDS_DESC'
  | 'USER_BY_RECIPIENT_ID__ID_ASC'
  | 'USER_BY_RECIPIENT_ID__ID_DESC'
  | 'USER_BY_RECIPIENT_ID__INITIALS_ASC'
  | 'USER_BY_RECIPIENT_ID__INITIALS_DESC'
  | 'USER_BY_RECIPIENT_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_RECIPIENT_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_RECIPIENT_ID__IS_LEADER_ASC'
  | 'USER_BY_RECIPIENT_ID__IS_LEADER_DESC'
  | 'USER_BY_RECIPIENT_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_RECIPIENT_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_RECIPIENT_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_RECIPIENT_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_RECIPIENT_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_RECIPIENT_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_RECIPIENT_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_RECIPIENT_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_RECIPIENT_ID__LAST_LOGIN_ASC'
  | 'USER_BY_RECIPIENT_ID__LAST_LOGIN_DESC'
  | 'USER_BY_RECIPIENT_ID__LAST_NAME_ASC'
  | 'USER_BY_RECIPIENT_ID__LAST_NAME_DESC'
  | 'USER_BY_RECIPIENT_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_RECIPIENT_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_RECIPIENT_ID__MOBILE_ASC'
  | 'USER_BY_RECIPIENT_ID__MOBILE_DESC'
  | 'USER_BY_RECIPIENT_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_RECIPIENT_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_RECIPIENT_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_RECIPIENT_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_RECIPIENT_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_RECIPIENT_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_RECIPIENT_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_RECIPIENT_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_RECIPIENT_ID__PHONE_ASC'
  | 'USER_BY_RECIPIENT_ID__PHONE_DESC'
  | 'USER_BY_RECIPIENT_ID__POSTAL_CODE_ASC'
  | 'USER_BY_RECIPIENT_ID__POSTAL_CODE_DESC'
  | 'USER_BY_RECIPIENT_ID__SENIORITY_ASC'
  | 'USER_BY_RECIPIENT_ID__SENIORITY_DESC'
  | 'USER_IDS_ASC'
  | 'USER_IDS_DESC'
  | 'USE_CONTENT_COLORS_ASC'
  | 'USE_CONTENT_COLORS_DESC'
  | 'USE_CUSTOM_LINK_BUTTON_COLOR_ASC'
  | 'USE_CUSTOM_LINK_BUTTON_COLOR_DESC'
  | 'USE_LEADER_ASC'
  | 'USE_LEADER_DESC'
  | 'USE_WORK_EMAIL_ASC'
  | 'USE_WORK_EMAIL_DESC';

export type Process = {
  __typename?: 'Process';
  active: Scalars['Boolean'];
  appCount?: Maybe<Scalars['BigInt']>;
  archived: Scalars['Boolean'];
  /** Reads a single `User` that is related to this `Process`. */
  assignedUser?: Maybe<User>;
  assignedUserDepartments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  assignedUserId?: Maybe<Scalars['UUID']>;
  autoArchived: Scalars['Boolean'];
  companyId: Scalars['UUID'];
  completed?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Datetime'];
  cutoffDay?: Maybe<Scalars['Boolean']>;
  departmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads and enables pagination through a set of `Department`. */
  departments: DepartmentsConnection;
  /** Reads a single `Employee` that is related to this `Process`. */
  employee?: Maybe<Employee>;
  employeeId?: Maybe<Scalars['UUID']>;
  endDate?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  messageCount?: Maybe<Scalars['BigFloat']>;
  name?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferences: NotificationEmployeeReferencesConnection;
  order: Scalars['Int'];
  /** Reads and enables pagination through a set of `PreboardingProcess`. */
  preboardingProcesses: PreboardingProcessesConnection;
  /** Reads and enables pagination through a set of `ProcessDepartment`. */
  processDepartments: ProcessDepartmentsConnection;
  /** Reads and enables pagination through a set of `ProcessEmployee`. */
  processEmployees: ProcessEmployeesConnection;
  /** Reads and enables pagination through a set of `ProcessResponsible`. */
  processResponsibles: ProcessResponsiblesConnection;
  /** Reads a single `ProcessType` that is related to this `Process`. */
  processType?: Maybe<ProcessType>;
  processTypeId?: Maybe<Scalars['UUID']>;
  progress?: Maybe<Scalars['BigFloat']>;
  projectCount?: Maybe<Scalars['BigInt']>;
  /** Reads and enables pagination through a set of `ProjectTemplate`. */
  projectTemplates: ProjectTemplatesConnection;
  /** Reads and enables pagination through a set of `Project`. */
  projects: ProjectsConnection;
  /** Reads and enables pagination through a set of `ScheduledMessageTemplate`. */
  scheduledMessageTemplates: ScheduledMessageTemplatesConnection;
  /** Reads and enables pagination through a set of `ScheduledMessage`. */
  scheduledMessages: ScheduledMessagesConnection;
  simpleUser?: Maybe<SimpleUser>;
  startDate?: Maybe<Scalars['Datetime']>;
  taskCount?: Maybe<Scalars['BigFloat']>;
  /** Reads and enables pagination through a set of `TaskTemplate`. */
  taskTemplates: TaskTemplatesConnection;
  /** Reads and enables pagination through a set of `Task`. */
  tasks: TasksConnection;
  template: Scalars['Boolean'];
  updatedAt: Scalars['Datetime'];
  userIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};


export type ProcessDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<DepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProcessNotificationEmployeeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};


export type ProcessPreboardingProcessesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingProcessCondition>;
  filter?: InputMaybe<PreboardingProcessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingProcessesOrderBy>>;
};


export type ProcessProcessDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcessDepartmentCondition>;
  filter?: InputMaybe<ProcessDepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcessDepartmentsOrderBy>>;
};


export type ProcessProcessEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcessEmployeeCondition>;
  filter?: InputMaybe<ProcessEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcessEmployeesOrderBy>>;
};


export type ProcessProcessResponsiblesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcessResponsibleCondition>;
  filter?: InputMaybe<ProcessResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcessResponsiblesOrderBy>>;
};


export type ProcessProjectTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectTemplateCondition>;
  filter?: InputMaybe<ProjectTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplatesOrderBy>>;
};


export type ProcessProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};


export type ProcessScheduledMessageTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageTemplateCondition>;
  filter?: InputMaybe<ScheduledMessageTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageTemplatesOrderBy>>;
};


export type ProcessScheduledMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageCondition>;
  filter?: InputMaybe<ScheduledMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessagesOrderBy>>;
};


export type ProcessTaskTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskTemplateCondition>;
  filter?: InputMaybe<TaskTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskTemplatesOrderBy>>;
};


export type ProcessTasksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};

/** The `process` to be created by this mutation. */
export type ProcessAssignedUserIdForeignConnectionProcessCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `user` in the `ProcessInput` mutation. */
export type ProcessAssignedUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnProcessForProcessAssignedUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `process` in the `UserInput` mutation. */
export type ProcessAssignedUserIdForeignInverseInput = {
  /** The primary key(s) for `process` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProcessProcessPkeyConnect>>;
  /** A `ProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProcessAssignedUserIdForeignConnectionProcessCreateInput>>;
  /** The primary key(s) and patch data for `process` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProcessOnProcessForProcessAssignedUserIdForeignUsingProcessPkeyUpdate>>;
};

/** A condition to be used against `Process` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ProcessCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `assignedUserDepartments` field. */
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `assignedUserId` field. */
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `autoArchived` field. */
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `completed` field. */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `cutoffDay` field. */
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `template` field. */
  template?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userIds` field. */
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

export type ProcessDepartment = {
  __typename?: 'ProcessDepartment';
  /** Reads a single `Company` that is related to this `ProcessDepartment`. */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['Datetime'];
  departmentId: Scalars['UUID'];
  /** Reads a single `Process` that is related to this `ProcessDepartment`. */
  process?: Maybe<Process>;
  processId: Scalars['UUID'];
};

/** The `processDepartment` to be created by this mutation. */
export type ProcessDepartmentCompanyIdFkeyConnectionProcessDepartmentCreateInput = {
  company?: InputMaybe<ProcessDepartmentCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId: Scalars['UUID'];
  process?: InputMaybe<ProcessDepartmentProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `ProcessDepartmentInput` mutation. */
export type ProcessDepartmentCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnProcessDepartmentForProcessDepartmentCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `processDepartment` in the `CompanyInput` mutation. */
export type ProcessDepartmentCompanyIdFkeyInverseInput = {
  /** A `ProcessDepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProcessDepartmentCompanyIdFkeyConnectionProcessDepartmentCreateInput>>;
};

/**
 * A condition to be used against `ProcessDepartment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProcessDepartmentCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departmentId` field. */
  departmentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `processId` field. */
  processId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ProcessDepartment` object types. All fields are combined with a logical ‘and.’ */
export type ProcessDepartmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProcessDepartmentFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** A related `company` exists. */
  companyExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departmentId` field. */
  departmentId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProcessDepartmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProcessDepartmentFilter>>;
  /** Filter by the object’s `process` relation. */
  process?: InputMaybe<ProcessFilter>;
  /** Filter by the object’s `processId` field. */
  processId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ProcessDepartment` */
export type ProcessDepartmentInput = {
  company?: InputMaybe<ProcessDepartmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId: Scalars['UUID'];
  process?: InputMaybe<ProcessDepartmentProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
};

/** The `process` to be created by this mutation. */
export type ProcessDepartmentProcessIdForeignConnectionProcessCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `processDepartment` to be created by this mutation. */
export type ProcessDepartmentProcessIdForeignConnectionProcessDepartmentCreateInput = {
  company?: InputMaybe<ProcessDepartmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId: Scalars['UUID'];
  process?: InputMaybe<ProcessDepartmentProcessIdForeignInput>;
};

/** Input for the nested mutation of `process` in the `ProcessDepartmentInput` mutation. */
export type ProcessDepartmentProcessIdForeignInput = {
  /** The primary key(s) for `process` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessProcessPkeyConnect>;
  /** A `ProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProcessDepartmentProcessIdForeignConnectionProcessCreateInput>;
  /** The primary key(s) and patch data for `process` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessOnProcessDepartmentForProcessDepartmentProcessIdForeignUsingProcessPkeyUpdate>;
};

/** Input for the nested mutation of `processDepartment` in the `ProcessInput` mutation. */
export type ProcessDepartmentProcessIdForeignInverseInput = {
  /** A `ProcessDepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProcessDepartmentProcessIdForeignConnectionProcessDepartmentCreateInput>>;
};

/** A connection to a list of `ProcessDepartment` values. */
export type ProcessDepartmentsConnection = {
  __typename?: 'ProcessDepartmentsConnection';
  /** A list of edges which contains the `ProcessDepartment` and cursor to aid in pagination. */
  edges: Array<ProcessDepartmentsEdge>;
  /** A list of `ProcessDepartment` objects. */
  nodes: Array<Maybe<ProcessDepartment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProcessDepartment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProcessDepartment` edge in the connection. */
export type ProcessDepartmentsEdge = {
  __typename?: 'ProcessDepartmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProcessDepartment` at the end of the edge. */
  node?: Maybe<ProcessDepartment>;
};

/** Methods to use when ordering `ProcessDepartment`. */
export type ProcessDepartmentsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_ID_DESC'
  | 'NATURAL'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_ASC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_DESC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_ASC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_DESC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_DESC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__NAME_ASC'
  | 'PROCESS_BY_PROCESS_ID__NAME_DESC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_ASC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_DESC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_DESC'
  | 'PROCESS_ID_ASC'
  | 'PROCESS_ID_DESC';

export type ProcessEmployee = {
  __typename?: 'ProcessEmployee';
  createdAt: Scalars['Datetime'];
  /** Reads a single `Employee` that is related to this `ProcessEmployee`. */
  employee?: Maybe<Employee>;
  employeeId: Scalars['UUID'];
  /** Reads a single `Process` that is related to this `ProcessEmployee`. */
  process?: Maybe<Process>;
  processId: Scalars['UUID'];
};

/**
 * A condition to be used against `ProcessEmployee` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProcessEmployeeCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `processId` field. */
  processId?: InputMaybe<Scalars['UUID']>;
};

/** The `processEmployee` to be created by this mutation. */
export type ProcessEmployeeEmployeeIdForeignConnectionProcessEmployeeCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<ProcessEmployeeEmployeeIdForeignInput>;
  process?: InputMaybe<ProcessEmployeeProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `employee` in the `ProcessEmployeeInput` mutation. */
export type ProcessEmployeeEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnProcessEmployeeForProcessEmployeeEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnProcessEmployeeForProcessEmployeeEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `processEmployee` in the `EmployeeInput` mutation. */
export type ProcessEmployeeEmployeeIdForeignInverseInput = {
  /** A `ProcessEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProcessEmployeeEmployeeIdForeignConnectionProcessEmployeeCreateInput>>;
};

/** A filter to be used against `ProcessEmployee` object types. All fields are combined with a logical ‘and.’ */
export type ProcessEmployeeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProcessEmployeeFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProcessEmployeeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProcessEmployeeFilter>>;
  /** Filter by the object’s `process` relation. */
  process?: InputMaybe<ProcessFilter>;
  /** Filter by the object’s `processId` field. */
  processId?: InputMaybe<UuidFilter>;
};

/** The `process` to be created by this mutation. */
export type ProcessEmployeeIdForeignConnectionProcessCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `employee` in the `ProcessInput` mutation. */
export type ProcessEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnProcessForProcessEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnProcessForProcessEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `process` in the `EmployeeInput` mutation. */
export type ProcessEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `process` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProcessProcessPkeyConnect>>;
  /** A `ProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProcessEmployeeIdForeignConnectionProcessCreateInput>>;
  /** The primary key(s) and patch data for `process` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProcessOnProcessForProcessEmployeeIdForeignUsingProcessPkeyUpdate>>;
};

/** An input for mutations affecting `ProcessEmployee` */
export type ProcessEmployeeInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<ProcessEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<ProcessEmployeeProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
};

/** The `process` to be created by this mutation. */
export type ProcessEmployeeProcessIdForeignConnectionProcessCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `processEmployee` to be created by this mutation. */
export type ProcessEmployeeProcessIdForeignConnectionProcessEmployeeCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<ProcessEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<ProcessEmployeeProcessIdForeignInput>;
};

/** Input for the nested mutation of `process` in the `ProcessEmployeeInput` mutation. */
export type ProcessEmployeeProcessIdForeignInput = {
  /** The primary key(s) for `process` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessProcessPkeyConnect>;
  /** A `ProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProcessEmployeeProcessIdForeignConnectionProcessCreateInput>;
  /** The primary key(s) and patch data for `process` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessOnProcessEmployeeForProcessEmployeeProcessIdForeignUsingProcessPkeyUpdate>;
};

/** Input for the nested mutation of `processEmployee` in the `ProcessInput` mutation. */
export type ProcessEmployeeProcessIdForeignInverseInput = {
  /** A `ProcessEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProcessEmployeeProcessIdForeignConnectionProcessEmployeeCreateInput>>;
};

/** A connection to a list of `ProcessEmployee` values. */
export type ProcessEmployeesConnection = {
  __typename?: 'ProcessEmployeesConnection';
  /** A list of edges which contains the `ProcessEmployee` and cursor to aid in pagination. */
  edges: Array<ProcessEmployeesEdge>;
  /** A list of `ProcessEmployee` objects. */
  nodes: Array<Maybe<ProcessEmployee>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProcessEmployee` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProcessEmployee` edge in the connection. */
export type ProcessEmployeesEdge = {
  __typename?: 'ProcessEmployeesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProcessEmployee` at the end of the edge. */
  node?: Maybe<ProcessEmployee>;
};

/** Methods to use when ordering `ProcessEmployee`. */
export type ProcessEmployeesOrderBy =
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'NATURAL'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_ASC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_DESC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_ASC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_DESC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_DESC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__NAME_ASC'
  | 'PROCESS_BY_PROCESS_ID__NAME_DESC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_ASC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_DESC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_DESC'
  | 'PROCESS_ID_ASC'
  | 'PROCESS_ID_DESC';

/** A filter to be used against `Process` object types. All fields are combined with a logical ‘and.’ */
export type ProcessFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProcessFilter>>;
  /** Filter by the object’s `appCount` field. */
  appCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `assignedUser` relation. */
  assignedUser?: InputMaybe<UserFilter>;
  /** Filter by the object’s `assignedUserDepartments` field. */
  assignedUserDepartments?: InputMaybe<UuidListFilter>;
  /** A related `assignedUser` exists. */
  assignedUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `assignedUserId` field. */
  assignedUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `autoArchived` field. */
  autoArchived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `completed` field. */
  completed?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `cutoffDay` field. */
  cutoffDay?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** A related `employee` exists. */
  employeeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `messageCount` field. */
  messageCount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProcessFilter>;
  /** Filter by the object’s `notificationEmployeeReferences` relation. */
  notificationEmployeeReferences?: InputMaybe<ProcessToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferences` exist. */
  notificationEmployeeReferencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProcessFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `preboardingProcesses` relation. */
  preboardingProcesses?: InputMaybe<ProcessToManyPreboardingProcessFilter>;
  /** Some related `preboardingProcesses` exist. */
  preboardingProcessesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processDepartments` relation. */
  processDepartments?: InputMaybe<ProcessToManyProcessDepartmentFilter>;
  /** Some related `processDepartments` exist. */
  processDepartmentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processEmployees` relation. */
  processEmployees?: InputMaybe<ProcessToManyProcessEmployeeFilter>;
  /** Some related `processEmployees` exist. */
  processEmployeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processResponsibles` relation. */
  processResponsibles?: InputMaybe<ProcessToManyProcessResponsibleFilter>;
  /** Some related `processResponsibles` exist. */
  processResponsiblesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processType` relation. */
  processType?: InputMaybe<ProcessTypeFilter>;
  /** A related `processType` exists. */
  processTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `progress` field. */
  progress?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectCount` field. */
  projectCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `projectTemplates` relation. */
  projectTemplates?: InputMaybe<ProcessToManyProjectTemplateFilter>;
  /** Some related `projectTemplates` exist. */
  projectTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projects` relation. */
  projects?: InputMaybe<ProcessToManyProjectFilter>;
  /** Some related `projects` exist. */
  projectsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scheduledMessageTemplates` relation. */
  scheduledMessageTemplates?: InputMaybe<ProcessToManyScheduledMessageTemplateFilter>;
  /** Some related `scheduledMessageTemplates` exist. */
  scheduledMessageTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scheduledMessages` relation. */
  scheduledMessages?: InputMaybe<ProcessToManyScheduledMessageFilter>;
  /** Some related `scheduledMessages` exist. */
  scheduledMessagesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `taskCount` field. */
  taskCount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `taskTemplates` relation. */
  taskTemplates?: InputMaybe<ProcessToManyTaskTemplateFilter>;
  /** Some related `taskTemplates` exist. */
  taskTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `tasks` relation. */
  tasks?: InputMaybe<ProcessToManyTaskFilter>;
  /** Some related `tasks` exist. */
  tasksExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `template` field. */
  template?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userIds` field. */
  userIds?: InputMaybe<UuidListFilter>;
};

/** An input for mutations affecting `Process` */
export type ProcessInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The fields on `process` to look up the row to update. */
export type ProcessOnNotificationEmployeeReferenceForNotificationEmployeeReferenceProcessIdForeignUsingProcessPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `process` being updated. */
  patch: UpdateProcessOnNotificationEmployeeReferenceForNotificationEmployeeReferenceProcessIdForeignPatch;
};

/** The fields on `process` to look up the row to update. */
export type ProcessOnPreboardingProcessForPreboardingProcessProcessIdForeignUsingProcessPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `process` being updated. */
  patch: UpdateProcessOnPreboardingProcessForPreboardingProcessProcessIdForeignPatch;
};

/** The fields on `process` to look up the row to update. */
export type ProcessOnProcessDepartmentForProcessDepartmentProcessIdForeignUsingProcessPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `process` being updated. */
  patch: UpdateProcessOnProcessDepartmentForProcessDepartmentProcessIdForeignPatch;
};

/** The fields on `process` to look up the row to update. */
export type ProcessOnProcessEmployeeForProcessEmployeeProcessIdForeignUsingProcessPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `process` being updated. */
  patch: UpdateProcessOnProcessEmployeeForProcessEmployeeProcessIdForeignPatch;
};

/** The fields on `process` to look up the row to update. */
export type ProcessOnProcessForProcessAssignedUserIdForeignUsingProcessPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `process` being updated. */
  patch: UpdateProcessOnProcessForProcessAssignedUserIdForeignPatch;
};

/** The fields on `process` to look up the row to update. */
export type ProcessOnProcessForProcessEmployeeIdForeignUsingProcessPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `process` being updated. */
  patch: UpdateProcessOnProcessForProcessEmployeeIdForeignPatch;
};

/** The fields on `process` to look up the row to update. */
export type ProcessOnProcessForProcessProcessTypeIdForeignUsingProcessPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `process` being updated. */
  patch: UpdateProcessOnProcessForProcessProcessTypeIdForeignPatch;
};

/** The fields on `process` to look up the row to update. */
export type ProcessOnProcessResponsibleForProcessResponsibleProcessIdForeignUsingProcessPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `process` being updated. */
  patch: UpdateProcessOnProcessResponsibleForProcessResponsibleProcessIdForeignPatch;
};

/** The fields on `process` to look up the row to update. */
export type ProcessOnProjectForProjectProcessIdForeignUsingProcessPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `process` being updated. */
  patch: UpdateProcessOnProjectForProjectProcessIdForeignPatch;
};

/** The fields on `process` to look up the row to update. */
export type ProcessOnProjectTemplateForProjectTemplateProcessIdForeignUsingProcessPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `process` being updated. */
  patch: UpdateProcessOnProjectTemplateForProjectTemplateProcessIdForeignPatch;
};

/** The fields on `process` to look up the row to update. */
export type ProcessOnScheduledMessageForScheduledMessageProcessIdForeignUsingProcessPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `process` being updated. */
  patch: UpdateProcessOnScheduledMessageForScheduledMessageProcessIdForeignPatch;
};

/** The fields on `process` to look up the row to update. */
export type ProcessOnScheduledMessageTemplateForScheduledMessageTemplateProcessIdForeignUsingProcessPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `process` being updated. */
  patch: UpdateProcessOnScheduledMessageTemplateForScheduledMessageTemplateProcessIdForeignPatch;
};

/** The fields on `process` to look up the row to update. */
export type ProcessOnTaskForTaskProcessIdForeignUsingProcessPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `process` being updated. */
  patch: UpdateProcessOnTaskForTaskProcessIdForeignPatch;
};

/** The fields on `process` to look up the row to update. */
export type ProcessOnTaskTemplateForTaskTemplateProcessIdForeignUsingProcessPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `process` being updated. */
  patch: UpdateProcessOnTaskTemplateForTaskTemplateProcessIdForeignPatch;
};

/** Represents an update to a `Process`. Fields that are set will be updated. */
export type ProcessPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The fields on `process` to look up the row to connect. */
export type ProcessProcessPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `process` to be created by this mutation. */
export type ProcessProcessTypeIdForeignConnectionProcessCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `processType` to be created by this mutation. */
export type ProcessProcessTypeIdForeignConnectionProcessTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `processType` in the `ProcessInput` mutation. */
export type ProcessProcessTypeIdForeignInput = {
  /** The primary key(s) for `processType` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessTypeProcessTypePkeyConnect>;
  /** A `ProcessTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProcessProcessTypeIdForeignConnectionProcessTypeCreateInput>;
  /** The primary key(s) and patch data for `processType` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessTypeOnProcessForProcessProcessTypeIdForeignUsingProcessTypePkeyUpdate>;
};

/** Input for the nested mutation of `process` in the `ProcessTypeInput` mutation. */
export type ProcessProcessTypeIdForeignInverseInput = {
  /** The primary key(s) for `process` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProcessProcessPkeyConnect>>;
  /** A `ProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProcessProcessTypeIdForeignConnectionProcessCreateInput>>;
  /** The primary key(s) and patch data for `process` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProcessOnProcessForProcessProcessTypeIdForeignUsingProcessPkeyUpdate>>;
};

export type ProcessResponsible = {
  __typename?: 'ProcessResponsible';
  /** Reads a single `Company` that is related to this `ProcessResponsible`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Process` that is related to this `ProcessResponsible`. */
  process?: Maybe<Process>;
  processId: Scalars['UUID'];
  /** Reads a single `Employee` that is related to this `ProcessResponsible`. */
  responsible?: Maybe<Employee>;
  responsibleId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `ProcessResponsible`. */
  responsibleUser?: Maybe<User>;
  responsibleUserDepartments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  responsibleUserId: Scalars['UUID'];
};

/** The `processResponsible` to be created by this mutation. */
export type ProcessResponsibleCompanyIdFkeyConnectionProcessResponsibleCreateInput = {
  company?: InputMaybe<ProcessResponsibleCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessResponsibleResponsibleIdForeignInput>;
  process?: InputMaybe<ProcessResponsibleProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  responsibleUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInput>;
};

/** Input for the nested mutation of `company` in the `ProcessResponsibleInput` mutation. */
export type ProcessResponsibleCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnProcessResponsibleForProcessResponsibleCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `processResponsible` in the `CompanyInput` mutation. */
export type ProcessResponsibleCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `processResponsible` for the far side of the relationship. */
  connectByProcessIdAndResponsibleId?: InputMaybe<Array<ProcessResponsibleProcessResponsiblePkeyConnect>>;
  /** A `ProcessResponsibleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProcessResponsibleCompanyIdFkeyConnectionProcessResponsibleCreateInput>>;
  /** The primary key(s) for `processResponsible` for the far side of the relationship. */
  deleteByProcessIdAndResponsibleId?: InputMaybe<Array<ProcessResponsibleProcessResponsiblePkeyDelete>>;
  /** Flag indicating whether all other `processResponsible` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `processResponsible` for the far side of the relationship. */
  updateByProcessIdAndResponsibleId?: InputMaybe<Array<ProcessResponsibleOnProcessResponsibleForProcessResponsibleCompanyIdFkeyUsingProcessResponsiblePkeyUpdate>>;
};

/**
 * A condition to be used against `ProcessResponsible` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProcessResponsibleCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `processId` field. */
  processId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `responsibleId` field. */
  responsibleId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `responsibleUserDepartments` field. */
  responsibleUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `responsibleUserId` field. */
  responsibleUserId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ProcessResponsible` object types. All fields are combined with a logical ‘and.’ */
export type ProcessResponsibleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProcessResponsibleFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProcessResponsibleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProcessResponsibleFilter>>;
  /** Filter by the object’s `process` relation. */
  process?: InputMaybe<ProcessFilter>;
  /** Filter by the object’s `processId` field. */
  processId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `responsible` relation. */
  responsible?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `responsibleId` field. */
  responsibleId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `responsibleUser` relation. */
  responsibleUser?: InputMaybe<UserFilter>;
  /** Filter by the object’s `responsibleUserDepartments` field. */
  responsibleUserDepartments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `responsibleUserId` field. */
  responsibleUserId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ProcessResponsible` */
export type ProcessResponsibleInput = {
  company?: InputMaybe<ProcessResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessResponsibleResponsibleIdForeignInput>;
  process?: InputMaybe<ProcessResponsibleProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  responsibleUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInput>;
};

/** The fields on `processResponsible` to look up the row to update. */
export type ProcessResponsibleOnProcessResponsibleForProcessResponsibleCompanyIdFkeyUsingProcessResponsiblePkeyUpdate = {
  /** An object where the defined keys will be set on the `processResponsible` being updated. */
  patch: UpdateProcessResponsibleOnProcessResponsibleForProcessResponsibleCompanyIdFkeyPatch;
  processId: Scalars['UUID'];
  responsibleId: Scalars['UUID'];
};

/** The fields on `processResponsible` to look up the row to update. */
export type ProcessResponsibleOnProcessResponsibleForProcessResponsibleProcessIdForeignUsingProcessResponsiblePkeyUpdate = {
  /** An object where the defined keys will be set on the `processResponsible` being updated. */
  patch: UpdateProcessResponsibleOnProcessResponsibleForProcessResponsibleProcessIdForeignPatch;
  processId: Scalars['UUID'];
  responsibleId: Scalars['UUID'];
};

/** The fields on `processResponsible` to look up the row to update. */
export type ProcessResponsibleOnProcessResponsibleForProcessResponsibleResponsibleIdForeignUsingProcessResponsiblePkeyUpdate = {
  /** An object where the defined keys will be set on the `processResponsible` being updated. */
  patch: UpdateProcessResponsibleOnProcessResponsibleForProcessResponsibleResponsibleIdForeignPatch;
  processId: Scalars['UUID'];
  responsibleId: Scalars['UUID'];
};

/** The fields on `processResponsible` to look up the row to update. */
export type ProcessResponsibleOnProcessResponsibleForProcessResponsibleResponsibleUserIdFkeyUsingProcessResponsiblePkeyUpdate = {
  /** An object where the defined keys will be set on the `processResponsible` being updated. */
  patch: UpdateProcessResponsibleOnProcessResponsibleForProcessResponsibleResponsibleUserIdFkeyPatch;
  processId: Scalars['UUID'];
  responsibleId: Scalars['UUID'];
};

/** Represents an update to a `ProcessResponsible`. Fields that are set will be updated. */
export type ProcessResponsiblePatch = {
  company?: InputMaybe<ProcessResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessResponsibleResponsibleIdForeignInput>;
  process?: InputMaybe<ProcessResponsibleProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  responsibleUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInput>;
};

/** The `process` to be created by this mutation. */
export type ProcessResponsibleProcessIdForeignConnectionProcessCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `processResponsible` to be created by this mutation. */
export type ProcessResponsibleProcessIdForeignConnectionProcessResponsibleCreateInput = {
  company?: InputMaybe<ProcessResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessResponsibleResponsibleIdForeignInput>;
  process?: InputMaybe<ProcessResponsibleProcessIdForeignInput>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  responsibleUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInput>;
};

/** Input for the nested mutation of `process` in the `ProcessResponsibleInput` mutation. */
export type ProcessResponsibleProcessIdForeignInput = {
  /** The primary key(s) for `process` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessProcessPkeyConnect>;
  /** A `ProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProcessResponsibleProcessIdForeignConnectionProcessCreateInput>;
  /** The primary key(s) and patch data for `process` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessOnProcessResponsibleForProcessResponsibleProcessIdForeignUsingProcessPkeyUpdate>;
};

/** Input for the nested mutation of `processResponsible` in the `ProcessInput` mutation. */
export type ProcessResponsibleProcessIdForeignInverseInput = {
  /** The primary key(s) for `processResponsible` for the far side of the relationship. */
  connectByProcessIdAndResponsibleId?: InputMaybe<Array<ProcessResponsibleProcessResponsiblePkeyConnect>>;
  /** A `ProcessResponsibleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProcessResponsibleProcessIdForeignConnectionProcessResponsibleCreateInput>>;
  /** The primary key(s) for `processResponsible` for the far side of the relationship. */
  deleteByProcessIdAndResponsibleId?: InputMaybe<Array<ProcessResponsibleProcessResponsiblePkeyDelete>>;
  /** Flag indicating whether all other `processResponsible` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `processResponsible` for the far side of the relationship. */
  updateByProcessIdAndResponsibleId?: InputMaybe<Array<ProcessResponsibleOnProcessResponsibleForProcessResponsibleProcessIdForeignUsingProcessResponsiblePkeyUpdate>>;
};

/** The fields on `processResponsible` to look up the row to connect. */
export type ProcessResponsibleProcessResponsiblePkeyConnect = {
  processId: Scalars['UUID'];
  responsibleId: Scalars['UUID'];
};

/** The fields on `processResponsible` to look up the row to delete. */
export type ProcessResponsibleProcessResponsiblePkeyDelete = {
  processId: Scalars['UUID'];
  responsibleId: Scalars['UUID'];
};

/** The `processResponsible` to be created by this mutation. */
export type ProcessResponsibleResponsibleIdForeignConnectionProcessResponsibleCreateInput = {
  company?: InputMaybe<ProcessResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessResponsibleResponsibleIdForeignInput>;
  process?: InputMaybe<ProcessResponsibleProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  responsibleUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInput>;
};

/** Input for the nested mutation of `employee` in the `ProcessResponsibleInput` mutation. */
export type ProcessResponsibleResponsibleIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnProcessResponsibleForProcessResponsibleResponsibleIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnProcessResponsibleForProcessResponsibleResponsibleIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `processResponsible` in the `EmployeeInput` mutation. */
export type ProcessResponsibleResponsibleIdForeignInverseInput = {
  /** The primary key(s) for `processResponsible` for the far side of the relationship. */
  connectByProcessIdAndResponsibleId?: InputMaybe<Array<ProcessResponsibleProcessResponsiblePkeyConnect>>;
  /** A `ProcessResponsibleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProcessResponsibleResponsibleIdForeignConnectionProcessResponsibleCreateInput>>;
  /** The primary key(s) for `processResponsible` for the far side of the relationship. */
  deleteByProcessIdAndResponsibleId?: InputMaybe<Array<ProcessResponsibleProcessResponsiblePkeyDelete>>;
  /** Flag indicating whether all other `processResponsible` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `processResponsible` for the far side of the relationship. */
  updateByProcessIdAndResponsibleId?: InputMaybe<Array<ProcessResponsibleOnProcessResponsibleForProcessResponsibleResponsibleIdForeignUsingProcessResponsiblePkeyUpdate>>;
};

/** The `processResponsible` to be created by this mutation. */
export type ProcessResponsibleResponsibleUserIdFkeyConnectionProcessResponsibleCreateInput = {
  company?: InputMaybe<ProcessResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessResponsibleResponsibleIdForeignInput>;
  process?: InputMaybe<ProcessResponsibleProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  responsibleUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInput>;
};

/** Input for the nested mutation of `user` in the `ProcessResponsibleInput` mutation. */
export type ProcessResponsibleResponsibleUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnProcessResponsibleForProcessResponsibleResponsibleUserIdFkeyUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `processResponsible` in the `UserInput` mutation. */
export type ProcessResponsibleResponsibleUserIdFkeyInverseInput = {
  /** The primary key(s) for `processResponsible` for the far side of the relationship. */
  connectByProcessIdAndResponsibleId?: InputMaybe<Array<ProcessResponsibleProcessResponsiblePkeyConnect>>;
  /** A `ProcessResponsibleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProcessResponsibleResponsibleUserIdFkeyConnectionProcessResponsibleCreateInput>>;
  /** The primary key(s) for `processResponsible` for the far side of the relationship. */
  deleteByProcessIdAndResponsibleId?: InputMaybe<Array<ProcessResponsibleProcessResponsiblePkeyDelete>>;
  /** Flag indicating whether all other `processResponsible` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `processResponsible` for the far side of the relationship. */
  updateByProcessIdAndResponsibleId?: InputMaybe<Array<ProcessResponsibleOnProcessResponsibleForProcessResponsibleResponsibleUserIdFkeyUsingProcessResponsiblePkeyUpdate>>;
};

/** A connection to a list of `ProcessResponsible` values. */
export type ProcessResponsiblesConnection = {
  __typename?: 'ProcessResponsiblesConnection';
  /** A list of edges which contains the `ProcessResponsible` and cursor to aid in pagination. */
  edges: Array<ProcessResponsiblesEdge>;
  /** A list of `ProcessResponsible` objects. */
  nodes: Array<Maybe<ProcessResponsible>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProcessResponsible` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProcessResponsible` edge in the connection. */
export type ProcessResponsiblesEdge = {
  __typename?: 'ProcessResponsiblesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProcessResponsible` at the end of the edge. */
  node?: Maybe<ProcessResponsible>;
};

/** Methods to use when ordering `ProcessResponsible`. */
export type ProcessResponsiblesOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__ID_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__ID_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__USER_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_ASC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_DESC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_ASC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_DESC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_DESC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__NAME_ASC'
  | 'PROCESS_BY_PROCESS_ID__NAME_DESC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_ASC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_DESC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_DESC'
  | 'PROCESS_ID_ASC'
  | 'PROCESS_ID_DESC'
  | 'RESPONSIBLE_ID_ASC'
  | 'RESPONSIBLE_ID_DESC'
  | 'RESPONSIBLE_USER_DEPARTMENTS_ASC'
  | 'RESPONSIBLE_USER_DEPARTMENTS_DESC'
  | 'RESPONSIBLE_USER_ID_ASC'
  | 'RESPONSIBLE_USER_ID_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__ACTIVE_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__ACTIVE_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__ADDRESS_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__ADDRESS_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__CITY_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__CITY_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__CPR_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__CPR_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__EMAIL_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__EMAIL_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__GODMODE_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__GODMODE_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__ID_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__ID_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__INITIALS_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__INITIALS_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__MOBILE_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__MOBILE_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__PHONE_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__PHONE_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_RESPONSIBLE_USER_ID__SENIORITY_ASC'
  | 'USER_BY_RESPONSIBLE_USER_ID__SENIORITY_DESC';

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type ProcessToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

/** A filter to be used against many `PreboardingProcess` object types. All fields are combined with a logical ‘and.’ */
export type ProcessToManyPreboardingProcessFilter = {
  /** Every related `PreboardingProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingProcessFilter>;
  /** No related `PreboardingProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingProcessFilter>;
  /** Some related `PreboardingProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingProcessFilter>;
};

/** A filter to be used against many `ProcessDepartment` object types. All fields are combined with a logical ‘and.’ */
export type ProcessToManyProcessDepartmentFilter = {
  /** Every related `ProcessDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProcessDepartmentFilter>;
  /** No related `ProcessDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProcessDepartmentFilter>;
  /** Some related `ProcessDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProcessDepartmentFilter>;
};

/** A filter to be used against many `ProcessEmployee` object types. All fields are combined with a logical ‘and.’ */
export type ProcessToManyProcessEmployeeFilter = {
  /** Every related `ProcessEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProcessEmployeeFilter>;
  /** No related `ProcessEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProcessEmployeeFilter>;
  /** Some related `ProcessEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProcessEmployeeFilter>;
};

/** A filter to be used against many `ProcessResponsible` object types. All fields are combined with a logical ‘and.’ */
export type ProcessToManyProcessResponsibleFilter = {
  /** Every related `ProcessResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProcessResponsibleFilter>;
  /** No related `ProcessResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProcessResponsibleFilter>;
  /** Some related `ProcessResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProcessResponsibleFilter>;
};

/** A filter to be used against many `Project` object types. All fields are combined with a logical ‘and.’ */
export type ProcessToManyProjectFilter = {
  /** Every related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectFilter>;
  /** No related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectFilter>;
  /** Some related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectFilter>;
};

/** A filter to be used against many `ProjectTemplate` object types. All fields are combined with a logical ‘and.’ */
export type ProcessToManyProjectTemplateFilter = {
  /** Every related `ProjectTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectTemplateFilter>;
  /** No related `ProjectTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectTemplateFilter>;
  /** Some related `ProjectTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectTemplateFilter>;
};

/** A filter to be used against many `ScheduledMessage` object types. All fields are combined with a logical ‘and.’ */
export type ProcessToManyScheduledMessageFilter = {
  /** Every related `ScheduledMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageFilter>;
  /** No related `ScheduledMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageFilter>;
  /** Some related `ScheduledMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageFilter>;
};

/** A filter to be used against many `ScheduledMessageTemplate` object types. All fields are combined with a logical ‘and.’ */
export type ProcessToManyScheduledMessageTemplateFilter = {
  /** Every related `ScheduledMessageTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageTemplateFilter>;
  /** No related `ScheduledMessageTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageTemplateFilter>;
  /** Some related `ScheduledMessageTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageTemplateFilter>;
};

/** A filter to be used against many `Task` object types. All fields are combined with a logical ‘and.’ */
export type ProcessToManyTaskFilter = {
  /** Every related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskFilter>;
  /** No related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskFilter>;
  /** Some related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskFilter>;
};

/** A filter to be used against many `TaskTemplate` object types. All fields are combined with a logical ‘and.’ */
export type ProcessToManyTaskTemplateFilter = {
  /** Every related `TaskTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskTemplateFilter>;
  /** No related `TaskTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskTemplateFilter>;
  /** Some related `TaskTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskTemplateFilter>;
};

export type ProcessType = {
  __typename?: 'ProcessType';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `ProcessType`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  localizedName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `Process`. */
  processes: ProcessesConnection;
  /** Reads and enables pagination through a set of `ProjectTemplate`. */
  projectTemplates: ProjectTemplatesConnection;
  /** Reads and enables pagination through a set of `Project`. */
  projects: ProjectsConnection;
  /** Reads and enables pagination through a set of `ScheduledMessageExternalRecipient`. */
  scheduledMessageExternalRecipients: ScheduledMessageExternalRecipientsConnection;
  /** Reads and enables pagination through a set of `ScheduledMessageRecipient`. */
  scheduledMessageRecipients: ScheduledMessageRecipientsConnection;
  /** Reads and enables pagination through a set of `ScheduledMessageTemplate`. */
  scheduledMessageTemplates: ScheduledMessageTemplatesConnection;
  /** Reads and enables pagination through a set of `ScheduledMessage`. */
  scheduledMessages: ScheduledMessagesConnection;
  /** Reads and enables pagination through a set of `Storage`. */
  storages: StoragesConnection;
  /** Reads and enables pagination through a set of `TaskEmployee`. */
  taskEmployees: TaskEmployeesConnection;
  /** Reads and enables pagination through a set of `TaskResponsible`. */
  taskResponsibles: TaskResponsiblesConnection;
  /** Reads and enables pagination through a set of `TaskTemplate`. */
  taskTemplates: TaskTemplatesConnection;
  /** Reads and enables pagination through a set of `Task`. */
  tasks: TasksConnection;
  updatedAt: Scalars['Datetime'];
};


export type ProcessTypeProcessesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcessCondition>;
  filter?: InputMaybe<ProcessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcessesOrderBy>>;
};


export type ProcessTypeProjectTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectTemplateCondition>;
  filter?: InputMaybe<ProjectTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplatesOrderBy>>;
};


export type ProcessTypeProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};


export type ProcessTypeScheduledMessageExternalRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageExternalRecipientCondition>;
  filter?: InputMaybe<ScheduledMessageExternalRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageExternalRecipientsOrderBy>>;
};


export type ProcessTypeScheduledMessageRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageRecipientCondition>;
  filter?: InputMaybe<ScheduledMessageRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageRecipientsOrderBy>>;
};


export type ProcessTypeScheduledMessageTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageTemplateCondition>;
  filter?: InputMaybe<ScheduledMessageTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageTemplatesOrderBy>>;
};


export type ProcessTypeScheduledMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageCondition>;
  filter?: InputMaybe<ScheduledMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessagesOrderBy>>;
};


export type ProcessTypeStoragesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<StorageCondition>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StoragesOrderBy>>;
};


export type ProcessTypeTaskEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskEmployeeCondition>;
  filter?: InputMaybe<TaskEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskEmployeesOrderBy>>;
};


export type ProcessTypeTaskResponsiblesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskResponsibleCondition>;
  filter?: InputMaybe<TaskResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskResponsiblesOrderBy>>;
};


export type ProcessTypeTaskTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskTemplateCondition>;
  filter?: InputMaybe<TaskTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskTemplatesOrderBy>>;
};


export type ProcessTypeTasksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};

/** The `processType` to be created by this mutation. */
export type ProcessTypeCompanyIdForeignConnectionProcessTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `company` in the `ProcessTypeInput` mutation. */
export type ProcessTypeCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnProcessTypeForProcessTypeCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `processType` in the `CompanyInput` mutation. */
export type ProcessTypeCompanyIdForeignInverseInput = {
  /** The primary key(s) for `processType` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProcessTypeProcessTypePkeyConnect>>;
  /** A `ProcessTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProcessTypeCompanyIdForeignConnectionProcessTypeCreateInput>>;
  /** The primary key(s) and patch data for `processType` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProcessTypeOnProcessTypeForProcessTypeCompanyIdForeignUsingProcessTypePkeyUpdate>>;
};

/**
 * A condition to be used against `ProcessType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ProcessTypeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ProcessType` object types. All fields are combined with a logical ‘and.’ */
export type ProcessTypeFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProcessTypeFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProcessTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProcessTypeFilter>>;
  /** Filter by the object’s `processes` relation. */
  processes?: InputMaybe<ProcessTypeToManyProcessFilter>;
  /** Some related `processes` exist. */
  processesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectTemplates` relation. */
  projectTemplates?: InputMaybe<ProcessTypeToManyProjectTemplateFilter>;
  /** Some related `projectTemplates` exist. */
  projectTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projects` relation. */
  projects?: InputMaybe<ProcessTypeToManyProjectFilter>;
  /** Some related `projects` exist. */
  projectsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scheduledMessageExternalRecipients` relation. */
  scheduledMessageExternalRecipients?: InputMaybe<ProcessTypeToManyScheduledMessageExternalRecipientFilter>;
  /** Some related `scheduledMessageExternalRecipients` exist. */
  scheduledMessageExternalRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scheduledMessageRecipients` relation. */
  scheduledMessageRecipients?: InputMaybe<ProcessTypeToManyScheduledMessageRecipientFilter>;
  /** Some related `scheduledMessageRecipients` exist. */
  scheduledMessageRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scheduledMessageTemplates` relation. */
  scheduledMessageTemplates?: InputMaybe<ProcessTypeToManyScheduledMessageTemplateFilter>;
  /** Some related `scheduledMessageTemplates` exist. */
  scheduledMessageTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scheduledMessages` relation. */
  scheduledMessages?: InputMaybe<ProcessTypeToManyScheduledMessageFilter>;
  /** Some related `scheduledMessages` exist. */
  scheduledMessagesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `storages` relation. */
  storages?: InputMaybe<ProcessTypeToManyStorageFilter>;
  /** Some related `storages` exist. */
  storagesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskEmployees` relation. */
  taskEmployees?: InputMaybe<ProcessTypeToManyTaskEmployeeFilter>;
  /** Some related `taskEmployees` exist. */
  taskEmployeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskResponsibles` relation. */
  taskResponsibles?: InputMaybe<ProcessTypeToManyTaskResponsibleFilter>;
  /** Some related `taskResponsibles` exist. */
  taskResponsiblesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskTemplates` relation. */
  taskTemplates?: InputMaybe<ProcessTypeToManyTaskTemplateFilter>;
  /** Some related `taskTemplates` exist. */
  taskTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `tasks` relation. */
  tasks?: InputMaybe<ProcessTypeToManyTaskFilter>;
  /** Some related `tasks` exist. */
  tasksExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ProcessType` */
export type ProcessTypeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `processType` to look up the row to update. */
export type ProcessTypeOnProcessForProcessProcessTypeIdForeignUsingProcessTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `processType` being updated. */
  patch: UpdateProcessTypeOnProcessForProcessProcessTypeIdForeignPatch;
};

/** The fields on `processType` to look up the row to update. */
export type ProcessTypeOnProcessTypeForProcessTypeCompanyIdForeignUsingProcessTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `processType` being updated. */
  patch: UpdateProcessTypeOnProcessTypeForProcessTypeCompanyIdForeignPatch;
};

/** The fields on `processType` to look up the row to update. */
export type ProcessTypeOnProjectForProjectProcessTypeIdForeignUsingProcessTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `processType` being updated. */
  patch: UpdateProcessTypeOnProjectForProjectProcessTypeIdForeignPatch;
};

/** The fields on `processType` to look up the row to update. */
export type ProcessTypeOnProjectTemplateForProjectTemplateProcessTypeIdForeignUsingProcessTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `processType` being updated. */
  patch: UpdateProcessTypeOnProjectTemplateForProjectTemplateProcessTypeIdForeignPatch;
};

/** The fields on `processType` to look up the row to update. */
export type ProcessTypeOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientProcessTypeIdForeignUsingProcessTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `processType` being updated. */
  patch: UpdateProcessTypeOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientProcessTypeIdForeignPatch;
};

/** The fields on `processType` to look up the row to update. */
export type ProcessTypeOnScheduledMessageForScheduledMessageProcessTypeIdForeignUsingProcessTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `processType` being updated. */
  patch: UpdateProcessTypeOnScheduledMessageForScheduledMessageProcessTypeIdForeignPatch;
};

/** The fields on `processType` to look up the row to update. */
export type ProcessTypeOnScheduledMessageRecipientForScheduledMessageRecipientProcessTypeIdForeignUsingProcessTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `processType` being updated. */
  patch: UpdateProcessTypeOnScheduledMessageRecipientForScheduledMessageRecipientProcessTypeIdForeignPatch;
};

/** The fields on `processType` to look up the row to update. */
export type ProcessTypeOnScheduledMessageTemplateForScheduledMessageTemplateProcessTypeIdForeignUsingProcessTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `processType` being updated. */
  patch: UpdateProcessTypeOnScheduledMessageTemplateForScheduledMessageTemplateProcessTypeIdForeignPatch;
};

/** The fields on `processType` to look up the row to update. */
export type ProcessTypeOnStorageForStorageProcessTypeIdForeignUsingProcessTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `processType` being updated. */
  patch: UpdateProcessTypeOnStorageForStorageProcessTypeIdForeignPatch;
};

/** The fields on `processType` to look up the row to update. */
export type ProcessTypeOnTaskEmployeeForTaskEmployeeProcessTypeIdForeignUsingProcessTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `processType` being updated. */
  patch: UpdateProcessTypeOnTaskEmployeeForTaskEmployeeProcessTypeIdForeignPatch;
};

/** The fields on `processType` to look up the row to update. */
export type ProcessTypeOnTaskForTaskProcessTypeIdForeignUsingProcessTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `processType` being updated. */
  patch: UpdateProcessTypeOnTaskForTaskProcessTypeIdForeignPatch;
};

/** The fields on `processType` to look up the row to update. */
export type ProcessTypeOnTaskResponsibleForTaskResponsibleProcessTypeIdForeignUsingProcessTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `processType` being updated. */
  patch: UpdateProcessTypeOnTaskResponsibleForTaskResponsibleProcessTypeIdForeignPatch;
};

/** The fields on `processType` to look up the row to update. */
export type ProcessTypeOnTaskTemplateForTaskTemplateProcessTypeIdForeignUsingProcessTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `processType` being updated. */
  patch: UpdateProcessTypeOnTaskTemplateForTaskTemplateProcessTypeIdForeignPatch;
};

/** Represents an update to a `ProcessType`. Fields that are set will be updated. */
export type ProcessTypePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `processType` to look up the row to connect. */
export type ProcessTypeProcessTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `Process` object types. All fields are combined with a logical ‘and.’ */
export type ProcessTypeToManyProcessFilter = {
  /** Every related `Process` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProcessFilter>;
  /** No related `Process` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProcessFilter>;
  /** Some related `Process` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProcessFilter>;
};

/** A filter to be used against many `Project` object types. All fields are combined with a logical ‘and.’ */
export type ProcessTypeToManyProjectFilter = {
  /** Every related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectFilter>;
  /** No related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectFilter>;
  /** Some related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectFilter>;
};

/** A filter to be used against many `ProjectTemplate` object types. All fields are combined with a logical ‘and.’ */
export type ProcessTypeToManyProjectTemplateFilter = {
  /** Every related `ProjectTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectTemplateFilter>;
  /** No related `ProjectTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectTemplateFilter>;
  /** Some related `ProjectTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectTemplateFilter>;
};

/** A filter to be used against many `ScheduledMessageExternalRecipient` object types. All fields are combined with a logical ‘and.’ */
export type ProcessTypeToManyScheduledMessageExternalRecipientFilter = {
  /** Every related `ScheduledMessageExternalRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageExternalRecipientFilter>;
  /** No related `ScheduledMessageExternalRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageExternalRecipientFilter>;
  /** Some related `ScheduledMessageExternalRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageExternalRecipientFilter>;
};

/** A filter to be used against many `ScheduledMessage` object types. All fields are combined with a logical ‘and.’ */
export type ProcessTypeToManyScheduledMessageFilter = {
  /** Every related `ScheduledMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageFilter>;
  /** No related `ScheduledMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageFilter>;
  /** Some related `ScheduledMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageFilter>;
};

/** A filter to be used against many `ScheduledMessageRecipient` object types. All fields are combined with a logical ‘and.’ */
export type ProcessTypeToManyScheduledMessageRecipientFilter = {
  /** Every related `ScheduledMessageRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageRecipientFilter>;
  /** No related `ScheduledMessageRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageRecipientFilter>;
  /** Some related `ScheduledMessageRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageRecipientFilter>;
};

/** A filter to be used against many `ScheduledMessageTemplate` object types. All fields are combined with a logical ‘and.’ */
export type ProcessTypeToManyScheduledMessageTemplateFilter = {
  /** Every related `ScheduledMessageTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageTemplateFilter>;
  /** No related `ScheduledMessageTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageTemplateFilter>;
  /** Some related `ScheduledMessageTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageTemplateFilter>;
};

/** A filter to be used against many `Storage` object types. All fields are combined with a logical ‘and.’ */
export type ProcessTypeToManyStorageFilter = {
  /** Every related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<StorageFilter>;
  /** No related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<StorageFilter>;
  /** Some related `Storage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<StorageFilter>;
};

/** A filter to be used against many `TaskEmployee` object types. All fields are combined with a logical ‘and.’ */
export type ProcessTypeToManyTaskEmployeeFilter = {
  /** Every related `TaskEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskEmployeeFilter>;
  /** No related `TaskEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskEmployeeFilter>;
  /** Some related `TaskEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskEmployeeFilter>;
};

/** A filter to be used against many `Task` object types. All fields are combined with a logical ‘and.’ */
export type ProcessTypeToManyTaskFilter = {
  /** Every related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskFilter>;
  /** No related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskFilter>;
  /** Some related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskFilter>;
};

/** A filter to be used against many `TaskResponsible` object types. All fields are combined with a logical ‘and.’ */
export type ProcessTypeToManyTaskResponsibleFilter = {
  /** Every related `TaskResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskResponsibleFilter>;
  /** No related `TaskResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskResponsibleFilter>;
  /** Some related `TaskResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskResponsibleFilter>;
};

/** A filter to be used against many `TaskTemplate` object types. All fields are combined with a logical ‘and.’ */
export type ProcessTypeToManyTaskTemplateFilter = {
  /** Every related `TaskTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskTemplateFilter>;
  /** No related `TaskTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskTemplateFilter>;
  /** Some related `TaskTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskTemplateFilter>;
};

/** A connection to a list of `ProcessType` values. */
export type ProcessTypesConnection = {
  __typename?: 'ProcessTypesConnection';
  /** A list of edges which contains the `ProcessType` and cursor to aid in pagination. */
  edges: Array<ProcessTypesEdge>;
  /** A list of `ProcessType` objects. */
  nodes: Array<Maybe<ProcessType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProcessType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProcessType` edge in the connection. */
export type ProcessTypesEdge = {
  __typename?: 'ProcessTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProcessType` at the end of the edge. */
  node?: Maybe<ProcessType>;
};

/** Methods to use when ordering `ProcessType`. */
export type ProcessTypesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALIZED_NAME_ASC'
  | 'LOCALIZED_NAME_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESSES_BY_PROCESS_TYPE_ID__COUNT_ASC'
  | 'PROCESSES_BY_PROCESS_TYPE_ID__COUNT_DESC'
  | 'PROJECTS_BY_PROCESS_TYPE_ID__COUNT_ASC'
  | 'PROJECTS_BY_PROCESS_TYPE_ID__COUNT_DESC'
  | 'PROJECT_TEMPLATES_BY_PROCESS_TYPE_ID__COUNT_ASC'
  | 'PROJECT_TEMPLATES_BY_PROCESS_TYPE_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGES_BY_PROCESS_TYPE_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGES_BY_PROCESS_TYPE_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGE_EXTERNAL_RECIPIENTS_BY_PROCESS_TYPE_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGE_EXTERNAL_RECIPIENTS_BY_PROCESS_TYPE_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGE_RECIPIENTS_BY_PROCESS_TYPE_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGE_RECIPIENTS_BY_PROCESS_TYPE_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATES_BY_PROCESS_TYPE_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATES_BY_PROCESS_TYPE_ID__COUNT_DESC'
  | 'STORAGES_BY_PROCESS_TYPE_ID__COUNT_ASC'
  | 'STORAGES_BY_PROCESS_TYPE_ID__COUNT_DESC'
  | 'TASKS_BY_PROCESS_TYPE_ID__COUNT_ASC'
  | 'TASKS_BY_PROCESS_TYPE_ID__COUNT_DESC'
  | 'TASK_EMPLOYEES_BY_PROCESS_TYPE_ID__COUNT_ASC'
  | 'TASK_EMPLOYEES_BY_PROCESS_TYPE_ID__COUNT_DESC'
  | 'TASK_RESPONSIBLES_BY_PROCESS_TYPE_ID__COUNT_ASC'
  | 'TASK_RESPONSIBLES_BY_PROCESS_TYPE_ID__COUNT_DESC'
  | 'TASK_TEMPLATES_BY_PROCESS_TYPE_ID__COUNT_ASC'
  | 'TASK_TEMPLATES_BY_PROCESS_TYPE_ID__COUNT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** A connection to a list of `Process` values. */
export type ProcessesConnection = {
  __typename?: 'ProcessesConnection';
  /** A list of edges which contains the `Process` and cursor to aid in pagination. */
  edges: Array<ProcessesEdge>;
  /** A list of `Process` objects. */
  nodes: Array<Maybe<Process>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Process` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Process` edge in the connection. */
export type ProcessesEdge = {
  __typename?: 'ProcessesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Process` at the end of the edge. */
  node?: Maybe<Process>;
};

/** Methods to use when ordering `Process`. */
export type ProcessesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ARCHIVED_ASC'
  | 'ARCHIVED_DESC'
  | 'ASSIGNED_USER_DEPARTMENTS_ASC'
  | 'ASSIGNED_USER_DEPARTMENTS_DESC'
  | 'ASSIGNED_USER_ID_ASC'
  | 'ASSIGNED_USER_ID_DESC'
  | 'AUTO_ARCHIVED_ASC'
  | 'AUTO_ARCHIVED_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPLETED_ASC'
  | 'COMPLETED_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CUTOFF_DAY_ASC'
  | 'CUTOFF_DAY_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'END_DATE_ASC'
  | 'END_DATE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_PROCESS_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_PROCESS_ID__COUNT_DESC'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PREBOARDING_PROCESSES_BY_PROCESS_ID__COUNT_ASC'
  | 'PREBOARDING_PROCESSES_BY_PROCESS_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESS_DEPARTMENTS_BY_PROCESS_ID__COUNT_ASC'
  | 'PROCESS_DEPARTMENTS_BY_PROCESS_ID__COUNT_DESC'
  | 'PROCESS_EMPLOYEES_BY_PROCESS_ID__COUNT_ASC'
  | 'PROCESS_EMPLOYEES_BY_PROCESS_ID__COUNT_DESC'
  | 'PROCESS_RESPONSIBLES_BY_PROCESS_ID__COUNT_ASC'
  | 'PROCESS_RESPONSIBLES_BY_PROCESS_ID__COUNT_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_DESC'
  | 'PROCESS_TYPE_ID_ASC'
  | 'PROCESS_TYPE_ID_DESC'
  | 'PROJECTS_BY_PROCESS_ID__COUNT_ASC'
  | 'PROJECTS_BY_PROCESS_ID__COUNT_DESC'
  | 'PROJECT_TEMPLATES_BY_PROCESS_ID__COUNT_ASC'
  | 'PROJECT_TEMPLATES_BY_PROCESS_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGES_BY_PROCESS_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGES_BY_PROCESS_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATES_BY_PROCESS_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATES_BY_PROCESS_ID__COUNT_DESC'
  | 'START_DATE_ASC'
  | 'START_DATE_DESC'
  | 'TASKS_BY_PROCESS_ID__COUNT_ASC'
  | 'TASKS_BY_PROCESS_ID__COUNT_DESC'
  | 'TASK_TEMPLATES_BY_PROCESS_ID__COUNT_ASC'
  | 'TASK_TEMPLATES_BY_PROCESS_ID__COUNT_DESC'
  | 'TEMPLATE_ASC'
  | 'TEMPLATE_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__ACTIVE_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__ACTIVE_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__ADDRESS_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__ADDRESS_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__CITY_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__CITY_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__CPR_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__CPR_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__EMAIL_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__EMAIL_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__GODMODE_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__GODMODE_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__ID_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__ID_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__INITIALS_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__INITIALS_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__MOBILE_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__MOBILE_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__PHONE_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__PHONE_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__SENIORITY_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__SENIORITY_DESC'
  | 'USER_IDS_ASC'
  | 'USER_IDS_DESC';

export type Product = {
  __typename?: 'Product';
  acquisitionDate?: Maybe<Scalars['Datetime']>;
  active: Scalars['Boolean'];
  /** Reads a single `User` that is related to this `Product`. */
  assignedUser?: Maybe<User>;
  assignedUserDepartments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  assignedUserId?: Maybe<Scalars['UUID']>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  /** Reads a single `Department` that is related to this `Product`. */
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['UUID']>;
  description?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Equipment`. */
  equipments: EquipmentConnection;
  /** Reads and enables pagination through a set of `FormFieldEntry`. */
  formFieldEntries: FormFieldEntriesConnection;
  /** Reads and enables pagination through a set of `Equipment`. */
  history: EquipmentConnection;
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferences: NotificationEmployeeReferencesConnection;
  occupiedBy?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Department`. */
  occupiedByDepartments: DepartmentsConnection;
  occupiedByEmployeeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ProductType` that is related to this `Product`. */
  productType?: Maybe<ProductType>;
  productTypeId: Scalars['UUID'];
  purchaseDate?: Maybe<Scalars['Datetime']>;
  searchTerms?: Maybe<Scalars['FullText']>;
  /** Full-text search ranking when filtered by `searchTerms`. */
  searchTermsRank?: Maybe<Scalars['Float']>;
  serial?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Storage`. */
  storages: StoragesConnection;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `Product`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};


export type ProductEquipmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EquipmentCondition>;
  filter?: InputMaybe<EquipmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentOrderBy>>;
};


export type ProductFormFieldEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldEntryCondition>;
  filter?: InputMaybe<FormFieldEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldEntriesOrderBy>>;
};


export type ProductHistoryArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<EquipmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentOrderBy>>;
};


export type ProductNotificationEmployeeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};


export type ProductOccupiedByDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<DepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProductStoragesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** The `product` to be created by this mutation. */
export type ProductAssignedUserIdFkeyConnectionProductCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ProductDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<EquipmentProductIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInverseInput>;
  productType?: InputMaybe<ProductProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  searchTerms?: InputMaybe<Scalars['FullText']>;
  serial?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProductAssignedUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `user` in the `ProductInput` mutation. */
export type ProductAssignedUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnProductForProductAssignedUserIdFkeyUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `product` in the `UserInput` mutation. */
export type ProductAssignedUserIdFkeyInverseInput = {
  /** The primary key(s) for `product` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProductProductPkeyConnect>>;
  /** A `ProductInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProductAssignedUserIdFkeyConnectionProductCreateInput>>;
  /** The primary key(s) and patch data for `product` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProductOnProductForProductAssignedUserIdFkeyUsingProductPkeyUpdate>>;
};

/** A condition to be used against `Product` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ProductCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `assignedUserDepartments` field. */
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `assignedUserId` field. */
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departmentId` field. */
  departmentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `productTypeId` field. */
  productTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `purchaseDate` field. */
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `searchTerms` field. */
  searchTerms?: InputMaybe<Scalars['FullText']>;
  /** Checks for equality with the object’s `serial` field. */
  serial?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `department` to be created by this mutation. */
export type ProductDepartmentIdForeignConnectionDepartmentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** The `product` to be created by this mutation. */
export type ProductDepartmentIdForeignConnectionProductCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ProductDepartmentIdForeignInput>;
  description?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<EquipmentProductIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInverseInput>;
  productType?: InputMaybe<ProductProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  searchTerms?: InputMaybe<Scalars['FullText']>;
  serial?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProductAssignedUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `department` in the `ProductInput` mutation. */
export type ProductDepartmentIdForeignInput = {
  /** The primary key(s) for `department` for the far side of the relationship. */
  connectById?: InputMaybe<DepartmentDepartmentPkeyConnect>;
  /** A `DepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProductDepartmentIdForeignConnectionDepartmentCreateInput>;
  /** The primary key(s) and patch data for `department` for the far side of the relationship. */
  updateById?: InputMaybe<DepartmentOnProductForProductDepartmentIdForeignUsingDepartmentPkeyUpdate>;
};

/** Input for the nested mutation of `product` in the `DepartmentInput` mutation. */
export type ProductDepartmentIdForeignInverseInput = {
  /** The primary key(s) for `product` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProductProductPkeyConnect>>;
  /** A `ProductInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProductDepartmentIdForeignConnectionProductCreateInput>>;
  /** The primary key(s) and patch data for `product` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProductOnProductForProductDepartmentIdForeignUsingProductPkeyUpdate>>;
};

/** A filter to be used against `Product` object types. All fields are combined with a logical ‘and.’ */
export type ProductFilter = {
  /** Filter by the object’s `acquisitionDate` field. */
  acquisitionDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProductFilter>>;
  /** Filter by the object’s `assignedUser` relation. */
  assignedUser?: InputMaybe<UserFilter>;
  /** Filter by the object’s `assignedUserDepartments` field. */
  assignedUserDepartments?: InputMaybe<UuidListFilter>;
  /** A related `assignedUser` exists. */
  assignedUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `assignedUserId` field. */
  assignedUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `department` relation. */
  department?: InputMaybe<DepartmentFilter>;
  /** A related `department` exists. */
  departmentExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `departmentId` field. */
  departmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `equipments` relation. */
  equipments?: InputMaybe<ProductToManyEquipmentFilter>;
  /** Some related `equipments` exist. */
  equipmentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFieldEntries` relation. */
  formFieldEntries?: InputMaybe<ProductToManyFormFieldEntryFilter>;
  /** Some related `formFieldEntries` exist. */
  formFieldEntriesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProductFilter>;
  /** Filter by the object’s `notificationEmployeeReferences` relation. */
  notificationEmployeeReferences?: InputMaybe<ProductToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferences` exist. */
  notificationEmployeeReferencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `occupiedBy` field. */
  occupiedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `occupiedByEmployeeId` field. */
  occupiedByEmployeeId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProductFilter>>;
  /** Filter by the object’s `productType` relation. */
  productType?: InputMaybe<ProductTypeFilter>;
  /** Filter by the object’s `productTypeId` field. */
  productTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `purchaseDate` field. */
  purchaseDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `searchTerms` field. */
  searchTerms?: InputMaybe<FullTextFilter>;
  /** Filter by the object’s `serial` field. */
  serial?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `Product` */
export type ProductInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ProductDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<EquipmentProductIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInverseInput>;
  productType?: InputMaybe<ProductProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  searchTerms?: InputMaybe<Scalars['FullText']>;
  serial?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProductAssignedUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `product` to look up the row to update. */
export type ProductOnEquipmentForEquipmentProductIdForeignUsingProductPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `product` being updated. */
  patch: UpdateProductOnEquipmentForEquipmentProductIdForeignPatch;
};

/** The fields on `product` to look up the row to update. */
export type ProductOnFormFieldEntryForFormFieldEntryProductIdForeignUsingProductPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `product` being updated. */
  patch: UpdateProductOnFormFieldEntryForFormFieldEntryProductIdForeignPatch;
};

/** The fields on `product` to look up the row to update. */
export type ProductOnNotificationEmployeeReferenceForNotificationEmployeeReferenceProductIdForeignUsingProductPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `product` being updated. */
  patch: UpdateProductOnNotificationEmployeeReferenceForNotificationEmployeeReferenceProductIdForeignPatch;
};

/** The fields on `product` to look up the row to update. */
export type ProductOnProductForProductAssignedUserIdFkeyUsingProductPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `product` being updated. */
  patch: UpdateProductOnProductForProductAssignedUserIdFkeyPatch;
};

/** The fields on `product` to look up the row to update. */
export type ProductOnProductForProductDepartmentIdForeignUsingProductPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `product` being updated. */
  patch: UpdateProductOnProductForProductDepartmentIdForeignPatch;
};

/** The fields on `product` to look up the row to update. */
export type ProductOnProductForProductProductTypeIdForeignUsingProductPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `product` being updated. */
  patch: UpdateProductOnProductForProductProductTypeIdForeignPatch;
};

/** The fields on `product` to look up the row to update. */
export type ProductOnProductForProductUserIdForeignUsingProductPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `product` being updated. */
  patch: UpdateProductOnProductForProductUserIdForeignPatch;
};

/** Represents an update to a `Product`. Fields that are set will be updated. */
export type ProductPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ProductDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<EquipmentProductIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInverseInput>;
  productType?: InputMaybe<ProductProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  searchTerms?: InputMaybe<Scalars['FullText']>;
  serial?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProductAssignedUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `product` to look up the row to connect. */
export type ProductProductPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `product` to be created by this mutation. */
export type ProductProductTypeIdForeignConnectionProductCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ProductDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<EquipmentProductIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInverseInput>;
  productType?: InputMaybe<ProductProductTypeIdForeignInput>;
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  searchTerms?: InputMaybe<Scalars['FullText']>;
  serial?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProductAssignedUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `productType` to be created by this mutation. */
export type ProductProductTypeIdForeignConnectionProductTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  equipment?: InputMaybe<EquipmentProductTypeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  products?: InputMaybe<ProductProductTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `productType` in the `ProductInput` mutation. */
export type ProductProductTypeIdForeignInput = {
  /** The primary key(s) for `productType` for the far side of the relationship. */
  connectByCompanyIdAndDepartmentIdAndName?: InputMaybe<ProductTypeProductTypeCompanyIdDepartmentIdNameUniqueConnect>;
  /** The primary key(s) for `productType` for the far side of the relationship. */
  connectById?: InputMaybe<ProductTypeProductTypePkeyConnect>;
  /** A `ProductTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProductProductTypeIdForeignConnectionProductTypeCreateInput>;
  /** The primary key(s) and patch data for `productType` for the far side of the relationship. */
  updateByCompanyIdAndDepartmentIdAndName?: InputMaybe<ProductTypeOnProductForProductProductTypeIdForeignUsingProductTypeCompanyIdDepartmentIdNameUniqueUpdate>;
  /** The primary key(s) and patch data for `productType` for the far side of the relationship. */
  updateById?: InputMaybe<ProductTypeOnProductForProductProductTypeIdForeignUsingProductTypePkeyUpdate>;
};

/** Input for the nested mutation of `product` in the `ProductTypeInput` mutation. */
export type ProductProductTypeIdForeignInverseInput = {
  /** The primary key(s) for `product` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProductProductPkeyConnect>>;
  /** A `ProductInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProductProductTypeIdForeignConnectionProductCreateInput>>;
  /** The primary key(s) and patch data for `product` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProductOnProductForProductProductTypeIdForeignUsingProductPkeyUpdate>>;
};

/** A filter to be used against many `Equipment` object types. All fields are combined with a logical ‘and.’ */
export type ProductToManyEquipmentFilter = {
  /** Every related `Equipment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EquipmentFilter>;
  /** No related `Equipment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EquipmentFilter>;
  /** Some related `Equipment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EquipmentFilter>;
};

/** A filter to be used against many `FormFieldEntry` object types. All fields are combined with a logical ‘and.’ */
export type ProductToManyFormFieldEntryFilter = {
  /** Every related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FormFieldEntryFilter>;
  /** No related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FormFieldEntryFilter>;
  /** Some related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FormFieldEntryFilter>;
};

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type ProductToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

export type ProductType = {
  __typename?: 'ProductType';
  active: Scalars['Boolean'];
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  departmentId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `Equipment`. */
  equipments: EquipmentConnection;
  id: Scalars['UUID'];
  localizedName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `Product`. */
  products: ProductsConnection;
  updatedAt: Scalars['Datetime'];
};


export type ProductTypeEquipmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EquipmentCondition>;
  filter?: InputMaybe<EquipmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentOrderBy>>;
};


export type ProductTypeProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProductCondition>;
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/**
 * A condition to be used against `ProductType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ProductTypeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departmentId` field. */
  departmentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ProductType` object types. All fields are combined with a logical ‘and.’ */
export type ProductTypeFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProductTypeFilter>>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departmentId` field. */
  departmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `equipments` relation. */
  equipments?: InputMaybe<ProductTypeToManyEquipmentFilter>;
  /** Some related `equipments` exist. */
  equipmentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProductTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProductTypeFilter>>;
  /** Filter by the object’s `products` relation. */
  products?: InputMaybe<ProductTypeToManyProductFilter>;
  /** Some related `products` exist. */
  productsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ProductType` */
export type ProductTypeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  equipment?: InputMaybe<EquipmentProductTypeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  products?: InputMaybe<ProductProductTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `productType` to look up the row to update. */
export type ProductTypeOnEquipmentForEquipmentProductTypeIdForeignUsingProductTypeCompanyIdDepartmentIdNameUniqueUpdate = {
  companyId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `productType` being updated. */
  patch: UpdateProductTypeOnEquipmentForEquipmentProductTypeIdForeignPatch;
};

/** The fields on `productType` to look up the row to update. */
export type ProductTypeOnEquipmentForEquipmentProductTypeIdForeignUsingProductTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `productType` being updated. */
  patch: UpdateProductTypeOnEquipmentForEquipmentProductTypeIdForeignPatch;
};

/** The fields on `productType` to look up the row to update. */
export type ProductTypeOnProductForProductProductTypeIdForeignUsingProductTypeCompanyIdDepartmentIdNameUniqueUpdate = {
  companyId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `productType` being updated. */
  patch: UpdateProductTypeOnProductForProductProductTypeIdForeignPatch;
};

/** The fields on `productType` to look up the row to update. */
export type ProductTypeOnProductForProductProductTypeIdForeignUsingProductTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `productType` being updated. */
  patch: UpdateProductTypeOnProductForProductProductTypeIdForeignPatch;
};

/** Represents an update to a `ProductType`. Fields that are set will be updated. */
export type ProductTypePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  equipment?: InputMaybe<EquipmentProductTypeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductProductTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `productType` to look up the row to connect. */
export type ProductTypeProductTypeCompanyIdDepartmentIdNameUniqueConnect = {
  companyId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  name: Scalars['String'];
};

/** The fields on `productType` to look up the row to connect. */
export type ProductTypeProductTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `Equipment` object types. All fields are combined with a logical ‘and.’ */
export type ProductTypeToManyEquipmentFilter = {
  /** Every related `Equipment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EquipmentFilter>;
  /** No related `Equipment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EquipmentFilter>;
  /** Some related `Equipment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EquipmentFilter>;
};

/** A filter to be used against many `Product` object types. All fields are combined with a logical ‘and.’ */
export type ProductTypeToManyProductFilter = {
  /** Every related `Product` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProductFilter>;
  /** No related `Product` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProductFilter>;
  /** Some related `Product` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProductFilter>;
};

/** A connection to a list of `ProductType` values. */
export type ProductTypesConnection = {
  __typename?: 'ProductTypesConnection';
  /** A list of edges which contains the `ProductType` and cursor to aid in pagination. */
  edges: Array<ProductTypesEdge>;
  /** A list of `ProductType` objects. */
  nodes: Array<Maybe<ProductType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProductType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProductType` edge in the connection. */
export type ProductTypesEdge = {
  __typename?: 'ProductTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProductType` at the end of the edge. */
  node?: Maybe<ProductType>;
};

/** Methods to use when ordering `ProductType`. */
export type ProductTypesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_ID_DESC'
  | 'EQUIPMENT_BY_PRODUCT_TYPE_ID__COUNT_ASC'
  | 'EQUIPMENT_BY_PRODUCT_TYPE_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALIZED_NAME_ASC'
  | 'LOCALIZED_NAME_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PRODUCTS_BY_PRODUCT_TYPE_ID__COUNT_ASC'
  | 'PRODUCTS_BY_PRODUCT_TYPE_ID__COUNT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** The `product` to be created by this mutation. */
export type ProductUserIdForeignConnectionProductCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ProductDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<EquipmentProductIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInverseInput>;
  productType?: InputMaybe<ProductProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  searchTerms?: InputMaybe<Scalars['FullText']>;
  serial?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProductAssignedUserIdFkeyInput>;
};

/** Input for the nested mutation of `product` in the `UserInput` mutation. */
export type ProductUserIdForeignInverseInput = {
  /** The primary key(s) for `product` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProductProductPkeyConnect>>;
  /** A `ProductInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProductUserIdForeignConnectionProductCreateInput>>;
  /** The primary key(s) and patch data for `product` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProductOnProductForProductUserIdForeignUsingProductPkeyUpdate>>;
};

/** A connection to a list of `Product` values. */
export type ProductsConnection = {
  __typename?: 'ProductsConnection';
  /** A list of edges which contains the `Product` and cursor to aid in pagination. */
  edges: Array<ProductsEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<Product>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection. */
export type ProductsEdge = {
  __typename?: 'ProductsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node?: Maybe<Product>;
};

/** Methods to use when ordering `Product`. */
export type ProductsOrderBy =
  | 'ACQUISITION_DATE_ASC'
  | 'ACQUISITION_DATE_DESC'
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ASSIGNED_USER_DEPARTMENTS_ASC'
  | 'ASSIGNED_USER_DEPARTMENTS_DESC'
  | 'ASSIGNED_USER_ID_ASC'
  | 'ASSIGNED_USER_ID_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ACTIVE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ACTIVE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ADDRESS_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ADDRESS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ALIAS_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ALIAS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CITY_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CITY_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COMPANY_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COMPANY_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COUNTRY_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COUNTRY_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CREATED_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CREATED_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CUSTOM_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CUSTOM_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CVR_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CVR_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DELETE_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DELETE_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_NUMBER_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_NUMBER_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DESCRIPTION_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DESCRIPTION_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EAN_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EAN_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EMAIL_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EMAIL_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__MAIN_DEPARTMENT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__MAIN_DEPARTMENT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__NAME_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__NAME_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PHONE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PHONE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__POSTAL_CODE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__POSTAL_CODE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__P_NUMBER_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__P_NUMBER_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__UPDATED_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__UPDATED_AT_DESC'
  | 'DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_ID_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'EQUIPMENT_BY_PRODUCT_ID__COUNT_ASC'
  | 'EQUIPMENT_BY_PRODUCT_ID__COUNT_DESC'
  | 'FORM_FIELD_ENTRIES_BY_PRODUCT_ID__COUNT_ASC'
  | 'FORM_FIELD_ENTRIES_BY_PRODUCT_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_PRODUCT_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_PRODUCT_ID__COUNT_DESC'
  | 'OCCUPIED_BY_ASC'
  | 'OCCUPIED_BY_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__ACTIVE_ASC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__ACTIVE_DESC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__COMPANY_ID_ASC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__COMPANY_ID_DESC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__CREATED_AT_ASC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__CREATED_AT_DESC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__DEPARTMENT_ID_ASC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__DEPARTMENT_ID_DESC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__ID_ASC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__ID_DESC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__NAME_ASC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__NAME_DESC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__UPDATED_AT_ASC'
  | 'PRODUCT_TYPE_BY_PRODUCT_TYPE_ID__UPDATED_AT_DESC'
  | 'PRODUCT_TYPE_ID_ASC'
  | 'PRODUCT_TYPE_ID_DESC'
  | 'PURCHASE_DATE_ASC'
  | 'PURCHASE_DATE_DESC'
  | 'SEARCH_TERMS_ASC'
  | 'SEARCH_TERMS_DESC'
  | 'SEARCH_TERMS_RANK_ASC'
  | 'SEARCH_TERMS_RANK_DESC'
  | 'SERIAL_ASC'
  | 'SERIAL_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__ACTIVE_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__ACTIVE_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__ADDRESS_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__ADDRESS_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__CITY_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__CITY_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__CPR_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__CPR_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__EMAIL_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__EMAIL_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__GODMODE_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__GODMODE_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__ID_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__ID_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__INITIALS_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__INITIALS_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__MOBILE_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__MOBILE_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__PHONE_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__PHONE_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_ASSIGNED_USER_ID__SENIORITY_ASC'
  | 'USER_BY_ASSIGNED_USER_ID__SENIORITY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type Project = {
  __typename?: 'Project';
  active: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  /** Reads a single `User` that is related to this `Project`. */
  assignedProcessUser?: Maybe<User>;
  assignedProcessUserId?: Maybe<Scalars['UUID']>;
  autoArchived: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `Project`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Employee` that is related to this `Project`. */
  employee?: Maybe<Employee>;
  employeeId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  /** Reads a single `Process` that is related to this `Project`. */
  process?: Maybe<Process>;
  processId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ProcessType` that is related to this `Project`. */
  processType?: Maybe<ProcessType>;
  processTypeId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `ScheduledMessage`. */
  scheduledMessages: ScheduledMessagesConnection;
  /** Reads and enables pagination through a set of `Task`. */
  tasks: TasksConnection;
  userIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};


export type ProjectScheduledMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageCondition>;
  filter?: InputMaybe<ScheduledMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessagesOrderBy>>;
};


export type ProjectTasksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};

/** The `project` to be created by this mutation. */
export type ProjectAssignedProcessUserIdForeignConnectionProjectCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProjectEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessages?: InputMaybe<ScheduledMessageProjectIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProjectIdForeignInverseInput>;
  user?: InputMaybe<ProjectAssignedProcessUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `user` in the `ProjectInput` mutation. */
export type ProjectAssignedProcessUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnProjectForProjectAssignedProcessUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `project` in the `UserInput` mutation. */
export type ProjectAssignedProcessUserIdForeignInverseInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectProjectPkeyConnect>>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectAssignedProcessUserIdForeignConnectionProjectCreateInput>>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectOnProjectForProjectAssignedProcessUserIdForeignUsingProjectPkeyUpdate>>;
};

/** The `project` to be created by this mutation. */
export type ProjectCompanyIdFkeyConnectionProjectCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProjectEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessages?: InputMaybe<ScheduledMessageProjectIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProjectIdForeignInverseInput>;
  user?: InputMaybe<ProjectAssignedProcessUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `company` in the `ProjectInput` mutation. */
export type ProjectCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnProjectForProjectCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `project` in the `CompanyInput` mutation. */
export type ProjectCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectProjectPkeyConnect>>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectCompanyIdFkeyConnectionProjectCreateInput>>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectOnProjectForProjectCompanyIdFkeyUsingProjectPkeyUpdate>>;
};

/** A condition to be used against `Project` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ProjectCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `assignedProcessUserId` field. */
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `autoArchived` field. */
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `processId` field. */
  processId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userIds` field. */
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `project` to be created by this mutation. */
export type ProjectEmployeeIdForeignConnectionProjectCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProjectEmployeeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessages?: InputMaybe<ScheduledMessageProjectIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProjectIdForeignInverseInput>;
  user?: InputMaybe<ProjectAssignedProcessUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `employee` in the `ProjectInput` mutation. */
export type ProjectEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnProjectForProjectEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnProjectForProjectEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `project` in the `EmployeeInput` mutation. */
export type ProjectEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectProjectPkeyConnect>>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectEmployeeIdForeignConnectionProjectCreateInput>>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectOnProjectForProjectEmployeeIdForeignUsingProjectPkeyUpdate>>;
};

/** A filter to be used against `Project` object types. All fields are combined with a logical ‘and.’ */
export type ProjectFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectFilter>>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `assignedProcessUser` relation. */
  assignedProcessUser?: InputMaybe<UserFilter>;
  /** A related `assignedProcessUser` exists. */
  assignedProcessUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `assignedProcessUserId` field. */
  assignedProcessUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `autoArchived` field. */
  autoArchived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** A related `employee` exists. */
  employeeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `process` relation. */
  process?: InputMaybe<ProcessFilter>;
  /** A related `process` exists. */
  processExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processId` field. */
  processId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `processType` relation. */
  processType?: InputMaybe<ProcessTypeFilter>;
  /** A related `processType` exists. */
  processTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `scheduledMessages` relation. */
  scheduledMessages?: InputMaybe<ProjectToManyScheduledMessageFilter>;
  /** Some related `scheduledMessages` exist. */
  scheduledMessagesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `tasks` relation. */
  tasks?: InputMaybe<ProjectToManyTaskFilter>;
  /** Some related `tasks` exist. */
  tasksExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userIds` field. */
  userIds?: InputMaybe<UuidListFilter>;
};

/** An input for mutations affecting `Project` */
export type ProjectInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProjectEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessages?: InputMaybe<ScheduledMessageProjectIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProjectIdForeignInverseInput>;
  user?: InputMaybe<ProjectAssignedProcessUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectAssignedProcessUserIdForeignUsingProjectPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnProjectForProjectAssignedProcessUserIdForeignPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectCompanyIdFkeyUsingProjectPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnProjectForProjectCompanyIdFkeyPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectEmployeeIdForeignUsingProjectPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnProjectForProjectEmployeeIdForeignPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectProcessIdForeignUsingProjectPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnProjectForProjectProcessIdForeignPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectProcessTypeIdForeignUsingProjectPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnProjectForProjectProcessTypeIdForeignPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnScheduledMessageForScheduledMessageProjectIdForeignUsingProjectPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnScheduledMessageForScheduledMessageProjectIdForeignPatch;
};

/** The fields on `project` to look up the row to update. */
export type ProjectOnTaskForTaskProjectIdForeignUsingProjectPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `project` being updated. */
  patch: UpdateProjectOnTaskForTaskProjectIdForeignPatch;
};

/** Represents an update to a `Project`. Fields that are set will be updated. */
export type ProjectPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProjectEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessages?: InputMaybe<ScheduledMessageProjectIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  tasks?: InputMaybe<TaskProjectIdForeignInverseInput>;
  user?: InputMaybe<ProjectAssignedProcessUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `process` to be created by this mutation. */
export type ProjectProcessIdForeignConnectionProcessCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `project` to be created by this mutation. */
export type ProjectProcessIdForeignConnectionProjectCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProjectEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectProcessIdForeignInput>;
  processType?: InputMaybe<ProjectProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessages?: InputMaybe<ScheduledMessageProjectIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProjectIdForeignInverseInput>;
  user?: InputMaybe<ProjectAssignedProcessUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `process` in the `ProjectInput` mutation. */
export type ProjectProcessIdForeignInput = {
  /** The primary key(s) for `process` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessProcessPkeyConnect>;
  /** A `ProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectProcessIdForeignConnectionProcessCreateInput>;
  /** The primary key(s) and patch data for `process` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessOnProjectForProjectProcessIdForeignUsingProcessPkeyUpdate>;
};

/** Input for the nested mutation of `project` in the `ProcessInput` mutation. */
export type ProjectProcessIdForeignInverseInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectProjectPkeyConnect>>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectProcessIdForeignConnectionProjectCreateInput>>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectOnProjectForProjectProcessIdForeignUsingProjectPkeyUpdate>>;
};

/** The `processType` to be created by this mutation. */
export type ProjectProcessTypeIdForeignConnectionProcessTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `project` to be created by this mutation. */
export type ProjectProcessTypeIdForeignConnectionProjectCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProjectEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectProcessTypeIdForeignInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProjectIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProjectIdForeignInverseInput>;
  user?: InputMaybe<ProjectAssignedProcessUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `processType` in the `ProjectInput` mutation. */
export type ProjectProcessTypeIdForeignInput = {
  /** The primary key(s) for `processType` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessTypeProcessTypePkeyConnect>;
  /** A `ProcessTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectProcessTypeIdForeignConnectionProcessTypeCreateInput>;
  /** The primary key(s) and patch data for `processType` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessTypeOnProjectForProjectProcessTypeIdForeignUsingProcessTypePkeyUpdate>;
};

/** Input for the nested mutation of `project` in the `ProcessTypeInput` mutation. */
export type ProjectProcessTypeIdForeignInverseInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectProjectPkeyConnect>>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectProcessTypeIdForeignConnectionProjectCreateInput>>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectOnProjectForProjectProcessTypeIdForeignUsingProjectPkeyUpdate>>;
};

/** The fields on `project` to look up the row to connect. */
export type ProjectProjectPkeyConnect = {
  id: Scalars['UUID'];
};

export type ProjectTemplate = {
  __typename?: 'ProjectTemplate';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `ProjectTemplate`. */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['UUID']>;
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  /** Reads a single `Process` that is related to this `ProjectTemplate`. */
  process?: Maybe<Process>;
  processId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ProcessType` that is related to this `ProjectTemplate`. */
  processType?: Maybe<ProcessType>;
  processTypeId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `ScheduledMessageTemplate`. */
  scheduledMessageTemplatesByProjectId: ScheduledMessageTemplatesConnection;
  /** Reads and enables pagination through a set of `TaskTemplate`. */
  taskTemplatesByProjectId: TaskTemplatesConnection;
};


export type ProjectTemplateScheduledMessageTemplatesByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageTemplateCondition>;
  filter?: InputMaybe<ScheduledMessageTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageTemplatesOrderBy>>;
};


export type ProjectTemplateTaskTemplatesByProjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskTemplateCondition>;
  filter?: InputMaybe<TaskTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskTemplatesOrderBy>>;
};

/** The `projectTemplate` to be created by this mutation. */
export type ProjectTemplateCompanyIdFkeyConnectionProjectTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectTemplateCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProjectIdForeignInverseInput>;
};

/** Input for the nested mutation of `company` in the `ProjectTemplateInput` mutation. */
export type ProjectTemplateCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnProjectTemplateForProjectTemplateCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `projectTemplate` in the `CompanyInput` mutation. */
export type ProjectTemplateCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `projectTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectTemplateProjectTemplatePkeyConnect>>;
  /** A `ProjectTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectTemplateCompanyIdFkeyConnectionProjectTemplateCreateInput>>;
  /** The primary key(s) and patch data for `projectTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectTemplateOnProjectTemplateForProjectTemplateCompanyIdFkeyUsingProjectTemplatePkeyUpdate>>;
};

/**
 * A condition to be used against `ProjectTemplate` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProjectTemplateCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `processId` field. */
  processId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ProjectTemplate` object types. All fields are combined with a logical ‘and.’ */
export type ProjectTemplateFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectTemplateFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** A related `company` exists. */
  companyExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectTemplateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectTemplateFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `process` relation. */
  process?: InputMaybe<ProcessFilter>;
  /** A related `process` exists. */
  processExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processId` field. */
  processId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `processType` relation. */
  processType?: InputMaybe<ProcessTypeFilter>;
  /** A related `processType` exists. */
  processTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `scheduledMessageTemplatesByProjectId` relation. */
  scheduledMessageTemplatesByProjectId?: InputMaybe<ProjectTemplateToManyScheduledMessageTemplateFilter>;
  /** Some related `scheduledMessageTemplatesByProjectId` exist. */
  scheduledMessageTemplatesByProjectIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskTemplatesByProjectId` relation. */
  taskTemplatesByProjectId?: InputMaybe<ProjectTemplateToManyTaskTemplateFilter>;
  /** Some related `taskTemplatesByProjectId` exist. */
  taskTemplatesByProjectIdExist?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `ProjectTemplate` */
export type ProjectTemplateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProjectIdForeignInverseInput>;
};

/** The fields on `projectTemplate` to look up the row to update. */
export type ProjectTemplateOnProjectTemplateForProjectTemplateCompanyIdFkeyUsingProjectTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectTemplate` being updated. */
  patch: UpdateProjectTemplateOnProjectTemplateForProjectTemplateCompanyIdFkeyPatch;
};

/** The fields on `projectTemplate` to look up the row to update. */
export type ProjectTemplateOnProjectTemplateForProjectTemplateProcessIdForeignUsingProjectTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectTemplate` being updated. */
  patch: UpdateProjectTemplateOnProjectTemplateForProjectTemplateProcessIdForeignPatch;
};

/** The fields on `projectTemplate` to look up the row to update. */
export type ProjectTemplateOnProjectTemplateForProjectTemplateProcessTypeIdForeignUsingProjectTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectTemplate` being updated. */
  patch: UpdateProjectTemplateOnProjectTemplateForProjectTemplateProcessTypeIdForeignPatch;
};

/** The fields on `projectTemplate` to look up the row to update. */
export type ProjectTemplateOnScheduledMessageTemplateForScheduledMessageTemplateProjectIdForeignUsingProjectTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectTemplate` being updated. */
  patch: UpdateProjectTemplateOnScheduledMessageTemplateForScheduledMessageTemplateProjectIdForeignPatch;
};

/** The fields on `projectTemplate` to look up the row to update. */
export type ProjectTemplateOnTaskTemplateForTaskTemplateProjectIdForeignUsingProjectTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `projectTemplate` being updated. */
  patch: UpdateProjectTemplateOnTaskTemplateForTaskTemplateProjectIdForeignPatch;
};

/** Represents an update to a `ProjectTemplate`. Fields that are set will be updated. */
export type ProjectTemplatePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInverseInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplates?: InputMaybe<TaskTemplateProjectIdForeignInverseInput>;
};

/** The `process` to be created by this mutation. */
export type ProjectTemplateProcessIdForeignConnectionProcessCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `projectTemplate` to be created by this mutation. */
export type ProjectTemplateProcessIdForeignConnectionProjectTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectTemplateProcessIdForeignInput>;
  processType?: InputMaybe<ProjectTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProjectIdForeignInverseInput>;
};

/** Input for the nested mutation of `process` in the `ProjectTemplateInput` mutation. */
export type ProjectTemplateProcessIdForeignInput = {
  /** The primary key(s) for `process` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessProcessPkeyConnect>;
  /** A `ProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectTemplateProcessIdForeignConnectionProcessCreateInput>;
  /** The primary key(s) and patch data for `process` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessOnProjectTemplateForProjectTemplateProcessIdForeignUsingProcessPkeyUpdate>;
};

/** Input for the nested mutation of `projectTemplate` in the `ProcessInput` mutation. */
export type ProjectTemplateProcessIdForeignInverseInput = {
  /** The primary key(s) for `projectTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectTemplateProjectTemplatePkeyConnect>>;
  /** A `ProjectTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectTemplateProcessIdForeignConnectionProjectTemplateCreateInput>>;
  /** The primary key(s) and patch data for `projectTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectTemplateOnProjectTemplateForProjectTemplateProcessIdForeignUsingProjectTemplatePkeyUpdate>>;
};

/** The `processType` to be created by this mutation. */
export type ProjectTemplateProcessTypeIdForeignConnectionProcessTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `projectTemplate` to be created by this mutation. */
export type ProjectTemplateProcessTypeIdForeignConnectionProjectTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectTemplateProcessTypeIdForeignInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProjectIdForeignInverseInput>;
};

/** Input for the nested mutation of `processType` in the `ProjectTemplateInput` mutation. */
export type ProjectTemplateProcessTypeIdForeignInput = {
  /** The primary key(s) for `processType` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessTypeProcessTypePkeyConnect>;
  /** A `ProcessTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectTemplateProcessTypeIdForeignConnectionProcessTypeCreateInput>;
  /** The primary key(s) and patch data for `processType` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessTypeOnProjectTemplateForProjectTemplateProcessTypeIdForeignUsingProcessTypePkeyUpdate>;
};

/** Input for the nested mutation of `projectTemplate` in the `ProcessTypeInput` mutation. */
export type ProjectTemplateProcessTypeIdForeignInverseInput = {
  /** The primary key(s) for `projectTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectTemplateProjectTemplatePkeyConnect>>;
  /** A `ProjectTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ProjectTemplateProcessTypeIdForeignConnectionProjectTemplateCreateInput>>;
  /** The primary key(s) and patch data for `projectTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ProjectTemplateOnProjectTemplateForProjectTemplateProcessTypeIdForeignUsingProjectTemplatePkeyUpdate>>;
};

/** The fields on `projectTemplate` to look up the row to connect. */
export type ProjectTemplateProjectTemplatePkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `ScheduledMessageTemplate` object types. All fields are combined with a logical ‘and.’ */
export type ProjectTemplateToManyScheduledMessageTemplateFilter = {
  /** Every related `ScheduledMessageTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageTemplateFilter>;
  /** No related `ScheduledMessageTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageTemplateFilter>;
  /** Some related `ScheduledMessageTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageTemplateFilter>;
};

/** A filter to be used against many `TaskTemplate` object types. All fields are combined with a logical ‘and.’ */
export type ProjectTemplateToManyTaskTemplateFilter = {
  /** Every related `TaskTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskTemplateFilter>;
  /** No related `TaskTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskTemplateFilter>;
  /** Some related `TaskTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskTemplateFilter>;
};

/** A connection to a list of `ProjectTemplate` values. */
export type ProjectTemplatesConnection = {
  __typename?: 'ProjectTemplatesConnection';
  /** A list of edges which contains the `ProjectTemplate` and cursor to aid in pagination. */
  edges: Array<ProjectTemplatesEdge>;
  /** A list of `ProjectTemplate` objects. */
  nodes: Array<Maybe<ProjectTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectTemplate` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProjectTemplate` edge in the connection. */
export type ProjectTemplatesEdge = {
  __typename?: 'ProjectTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProjectTemplate` at the end of the edge. */
  node?: Maybe<ProjectTemplate>;
};

/** Methods to use when ordering `ProjectTemplate`. */
export type ProjectTemplatesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_ASC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_DESC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_ASC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_DESC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_DESC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__NAME_ASC'
  | 'PROCESS_BY_PROCESS_ID__NAME_DESC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_ASC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_DESC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_DESC'
  | 'PROCESS_ID_ASC'
  | 'PROCESS_ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_DESC'
  | 'PROCESS_TYPE_ID_ASC'
  | 'PROCESS_TYPE_ID_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATES_BY_PROJECT_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATES_BY_PROJECT_ID__COUNT_DESC'
  | 'TASK_TEMPLATES_BY_PROJECT_ID__COUNT_ASC'
  | 'TASK_TEMPLATES_BY_PROJECT_ID__COUNT_DESC';

/** A filter to be used against many `ScheduledMessage` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyScheduledMessageFilter = {
  /** Every related `ScheduledMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageFilter>;
  /** No related `ScheduledMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageFilter>;
  /** Some related `ScheduledMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageFilter>;
};

/** A filter to be used against many `Task` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyTaskFilter = {
  /** Every related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskFilter>;
  /** No related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskFilter>;
  /** Some related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskFilter>;
};

/** A connection to a list of `Project` values. */
export type ProjectsConnection = {
  __typename?: 'ProjectsConnection';
  /** A list of edges which contains the `Project` and cursor to aid in pagination. */
  edges: Array<ProjectsEdge>;
  /** A list of `Project` objects. */
  nodes: Array<Maybe<Project>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Project` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Project` edge in the connection. */
export type ProjectsEdge = {
  __typename?: 'ProjectsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Project` at the end of the edge. */
  node?: Maybe<Project>;
};

/** Methods to use when ordering `Project`. */
export type ProjectsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ARCHIVED_ASC'
  | 'ARCHIVED_DESC'
  | 'ASSIGNED_PROCESS_USER_ID_ASC'
  | 'ASSIGNED_PROCESS_USER_ID_DESC'
  | 'AUTO_ARCHIVED_ASC'
  | 'AUTO_ARCHIVED_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_ASC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_DESC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_ASC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_DESC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_DESC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__NAME_ASC'
  | 'PROCESS_BY_PROCESS_ID__NAME_DESC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_ASC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_DESC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_DESC'
  | 'PROCESS_ID_ASC'
  | 'PROCESS_ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_DESC'
  | 'PROCESS_TYPE_ID_ASC'
  | 'PROCESS_TYPE_ID_DESC'
  | 'SCHEDULED_MESSAGES_BY_PROJECT_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGES_BY_PROJECT_ID__COUNT_DESC'
  | 'TASKS_BY_PROJECT_ID__COUNT_ASC'
  | 'TASKS_BY_PROJECT_ID__COUNT_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ACTIVE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ACTIVE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ADDRESS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ADDRESS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CITY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CITY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CPR_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CPR_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GODMODE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GODMODE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__INITIALS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__INITIALS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__PHONE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__PHONE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__SENIORITY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__SENIORITY_DESC'
  | 'USER_IDS_ASC'
  | 'USER_IDS_DESC';

export type PulseSurvey = {
  __typename?: 'PulseSurvey';
  active: Scalars['Boolean'];
  anonymous: Scalars['Boolean'];
  averageRatingAllTime?: Maybe<Scalars['BigFloat']>;
  averageRatingAllTimeLastYear?: Maybe<Scalars['BigFloat']>;
  averageRatingThisMonth?: Maybe<Scalars['BigFloat']>;
  averageRatingThisMonthLastYear?: Maybe<Scalars['BigFloat']>;
  choiceIndicator: PulseSurveyChoiceIndicator;
  /** Reads a single `Company` that is related to this `PulseSurvey`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  completionPercentage?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Datetime'];
  currentAnswerByCurrentUser?: Maybe<Scalars['String']>;
  deadline: Interval;
  endDate?: Maybe<Scalars['Date']>;
  hasBeenAnsweredByCurrentUser?: Maybe<Scalars['Boolean']>;
  highestRating?: Maybe<Scalars['Int']>;
  highestRatingLabel?: Maybe<Scalars['String']>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseSurvey`. */
  highestRatingLabelTranslatedEntity?: Maybe<TranslatedEntity>;
  highestRatingLabelTranslatedEntityId: Scalars['UUID'];
  horizontal: Scalars['Boolean'];
  id: Scalars['UUID'];
  invitedAll: Scalars['Boolean'];
  invitedDepartmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  invitedUserIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  isDraft: Scalars['Boolean'];
  isOpenForAnswers?: Maybe<Scalars['Boolean']>;
  localizedHighestRatingLabel?: Maybe<Scalars['String']>;
  localizedLowestRatingLabel?: Maybe<Scalars['String']>;
  localizedName?: Maybe<Scalars['String']>;
  localizedQuestion?: Maybe<Scalars['String']>;
  lowestRating?: Maybe<Scalars['Int']>;
  lowestRatingLabel?: Maybe<Scalars['String']>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseSurvey`. */
  lowestRatingLabelTranslatedEntity?: Maybe<TranslatedEntity>;
  lowestRatingLabelTranslatedEntityId: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseSurvey`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  nameTranslatedEntityId: Scalars['UUID'];
  nextOccurrence: Scalars['Datetime'];
  nextSurveyDate?: Maybe<Scalars['Date']>;
  numberOfAnswersCollected?: Maybe<Scalars['Int']>;
  numberOfChoices?: Maybe<Scalars['BigInt']>;
  numberOfRecipients?: Maybe<Scalars['Int']>;
  numberOfRecipientsLastYear?: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `PulseSurveyAnswer`. */
  pulseSurveyAnswers: PulseSurveyAnswersConnection;
  /** Reads and enables pagination through a set of `PulseSurveyChoice`. */
  pulseSurveyChoices: PulseSurveyChoicesConnection;
  /** Reads a single `PulseType` that is related to this `PulseSurvey`. */
  pulseType?: Maybe<PulseType>;
  pulseTypeId?: Maybe<Scalars['UUID']>;
  question?: Maybe<Scalars['String']>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseSurvey`. */
  questionTranslatedEntity?: Maybe<TranslatedEntity>;
  questionTranslatedEntityId: Scalars['UUID'];
  questionType: PulseSurveyQuestionType;
  ratingType: RatingType;
  readableQuestionType?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `PulseSurveyRecipient`. */
  recipients: PulseSurveyRecipientsConnection;
  /** Reads a single `RecurrenceRule` that is related to this `PulseSurvey`. */
  recurrenceRuleByPulseSurveyId?: Maybe<RecurrenceRule>;
  /**
   * Reads and enables pagination through a set of `RecurrenceRule`.
   * @deprecated Please use recurrenceRuleByPulseSurveyId instead
   */
  recurrenceRules: RecurrenceRulesConnection;
  reminders?: Maybe<Array<Maybe<Interval>>>;
  rruleHumanReadableText?: Maybe<Scalars['String']>;
  startDate: Scalars['Date'];
  surveyDates?: Maybe<Array<Maybe<Scalars['Date']>>>;
  surveyTime: Scalars['Time'];
  timezoneName: Scalars['String'];
};


export type PulseSurveyAverageRatingAllTimeArgs = {
  beforeDate?: InputMaybe<Scalars['Date']>;
};


export type PulseSurveyCompletionPercentageArgs = {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};


export type PulseSurveyPulseSurveyAnswersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseSurveyAnswerCondition>;
  filter?: InputMaybe<PulseSurveyAnswerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseSurveyAnswersOrderBy>>;
};


export type PulseSurveyPulseSurveyChoicesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseSurveyChoiceCondition>;
  filter?: InputMaybe<PulseSurveyChoiceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseSurveyChoicesOrderBy>>;
};


export type PulseSurveyRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<PulseSurveyRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PulseSurveyRecurrenceRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RecurrenceRuleCondition>;
  filter?: InputMaybe<RecurrenceRuleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurrenceRulesOrderBy>>;
};


export type PulseSurveySurveyDatesArgs = {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};

export type PulseSurveyAnswer = {
  __typename?: 'PulseSurveyAnswer';
  anonymous: Scalars['Boolean'];
  answer?: Maybe<Scalars['JSON']>;
  /** Reads a single `Company` that is related to this `PulseSurveyAnswer`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  date: Scalars['Date'];
  id: Scalars['UUID'];
  /** Reads a single `PulseSurvey` that is related to this `PulseSurveyAnswer`. */
  pulseSurvey?: Maybe<PulseSurvey>;
  pulseSurveyId: Scalars['UUID'];
  /** Reads a single `PulseType` that is related to this `PulseSurveyAnswer`. */
  pulseType?: Maybe<PulseType>;
  pulseTypeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `User` that is related to this `PulseSurveyAnswer`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** Input for the nested mutation of `company` in the `PulseSurveyAnswerInput` mutation. */
export type PulseSurveyAnswerCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnPulseSurveyAnswerForPulseSurveyAnswerCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `pulseSurveyAnswer` in the `CompanyInput` mutation. */
export type PulseSurveyAnswerCompanyIdForeignInverseInput = {
  /** The primary key(s) for `pulseSurveyAnswer` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PulseSurveyAnswerPulseSurveyAnswerPkeyConnect>>;
  /** The primary key(s) for `pulseSurveyAnswer` for the far side of the relationship. */
  connectByUserIdAndPulseSurveyIdAndDate?: InputMaybe<Array<PulseSurveyAnswerPulseSurveyAnswerUserIdPulseSurveyIdDateUniqueConnect>>;
  /** The primary key(s) for `pulseSurveyAnswer` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PulseSurveyAnswerPulseSurveyAnswerPkeyDelete>>;
  /** The primary key(s) for `pulseSurveyAnswer` for the far side of the relationship. */
  deleteByUserIdAndPulseSurveyIdAndDate?: InputMaybe<Array<PulseSurveyAnswerPulseSurveyAnswerUserIdPulseSurveyIdDateUniqueDelete>>;
  /** Flag indicating whether all other `pulseSurveyAnswer` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `pulseSurveyAnswer` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerCompanyIdForeignUsingPulseSurveyAnswerPkeyUpdate>>;
  /** The primary key(s) and patch data for `pulseSurveyAnswer` for the far side of the relationship. */
  updateByUserIdAndPulseSurveyIdAndDate?: InputMaybe<Array<PulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerCompanyIdForeignUsingPulseSurveyAnswerUserIdPulseSurveyIdDateUniqueUpdate>>;
};

/**
 * A condition to be used against `PulseSurveyAnswer` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PulseSurveyAnswerCondition = {
  /** Checks for equality with the object’s `anonymous` field. */
  anonymous?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `answer` field. */
  answer?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `pulseSurveyId` field. */
  pulseSurveyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `pulseTypeId` field. */
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

export type PulseSurveyAnswerCustomInput = {
  answer: Scalars['JSON'];
  pulseSurveyId: Scalars['UUID'];
};

/** A filter to be used against `PulseSurveyAnswer` object types. All fields are combined with a logical ‘and.’ */
export type PulseSurveyAnswerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PulseSurveyAnswerFilter>>;
  /** Filter by the object’s `anonymous` field. */
  anonymous?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `answer` field. */
  answer?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DateFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PulseSurveyAnswerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PulseSurveyAnswerFilter>>;
  /** Filter by the object’s `pulseSurvey` relation. */
  pulseSurvey?: InputMaybe<PulseSurveyFilter>;
  /** Filter by the object’s `pulseSurveyId` field. */
  pulseSurveyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `pulseType` relation. */
  pulseType?: InputMaybe<PulseTypeFilter>;
  /** A related `pulseType` exists. */
  pulseTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseTypeId` field. */
  pulseTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `pulseSurveyAnswer` to look up the row to update. */
export type PulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerCompanyIdForeignUsingPulseSurveyAnswerPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseSurveyAnswer` being updated. */
  patch: UpdatePulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerCompanyIdForeignPatch;
};

/** The fields on `pulseSurveyAnswer` to look up the row to update. */
export type PulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerCompanyIdForeignUsingPulseSurveyAnswerUserIdPulseSurveyIdDateUniqueUpdate = {
  date: Scalars['Date'];
  /** An object where the defined keys will be set on the `pulseSurveyAnswer` being updated. */
  patch: UpdatePulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerCompanyIdForeignPatch;
  pulseSurveyId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `pulseSurveyAnswer` to look up the row to update. */
export type PulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerPulseSurveyIdForeignUsingPulseSurveyAnswerPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseSurveyAnswer` being updated. */
  patch: UpdatePulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerPulseSurveyIdForeignPatch;
};

/** The fields on `pulseSurveyAnswer` to look up the row to update. */
export type PulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerPulseSurveyIdForeignUsingPulseSurveyAnswerUserIdPulseSurveyIdDateUniqueUpdate = {
  date: Scalars['Date'];
  /** An object where the defined keys will be set on the `pulseSurveyAnswer` being updated. */
  patch: UpdatePulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerPulseSurveyIdForeignPatch;
  pulseSurveyId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `pulseSurveyAnswer` to look up the row to update. */
export type PulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerPulseTypeIdForeignUsingPulseSurveyAnswerPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseSurveyAnswer` being updated. */
  patch: UpdatePulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerPulseTypeIdForeignPatch;
};

/** The fields on `pulseSurveyAnswer` to look up the row to update. */
export type PulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerPulseTypeIdForeignUsingPulseSurveyAnswerUserIdPulseSurveyIdDateUniqueUpdate = {
  date: Scalars['Date'];
  /** An object where the defined keys will be set on the `pulseSurveyAnswer` being updated. */
  patch: UpdatePulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerPulseTypeIdForeignPatch;
  pulseSurveyId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `pulseSurveyAnswer` to look up the row to update. */
export type PulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerUserIdForeignUsingPulseSurveyAnswerPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseSurveyAnswer` being updated. */
  patch: UpdatePulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerUserIdForeignPatch;
};

/** The fields on `pulseSurveyAnswer` to look up the row to update. */
export type PulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerUserIdForeignUsingPulseSurveyAnswerUserIdPulseSurveyIdDateUniqueUpdate = {
  date: Scalars['Date'];
  /** An object where the defined keys will be set on the `pulseSurveyAnswer` being updated. */
  patch: UpdatePulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerUserIdForeignPatch;
  pulseSurveyId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `pulseSurveyAnswer` to look up the row to connect. */
export type PulseSurveyAnswerPulseSurveyAnswerPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `pulseSurveyAnswer` to look up the row to delete. */
export type PulseSurveyAnswerPulseSurveyAnswerPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `pulseSurveyAnswer` to look up the row to connect. */
export type PulseSurveyAnswerPulseSurveyAnswerUserIdPulseSurveyIdDateUniqueConnect = {
  date: Scalars['Date'];
  pulseSurveyId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `pulseSurveyAnswer` to look up the row to delete. */
export type PulseSurveyAnswerPulseSurveyAnswerUserIdPulseSurveyIdDateUniqueDelete = {
  date: Scalars['Date'];
  pulseSurveyId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** Input for the nested mutation of `pulseSurvey` in the `PulseSurveyAnswerInput` mutation. */
export type PulseSurveyAnswerPulseSurveyIdForeignInput = {
  /** The primary key(s) for `pulseSurvey` for the far side of the relationship. */
  connectById?: InputMaybe<PulseSurveyPulseSurveyPkeyConnect>;
  /** The primary key(s) for `pulseSurvey` for the far side of the relationship. */
  deleteById?: InputMaybe<PulseSurveyPulseSurveyPkeyDelete>;
  /** The primary key(s) and patch data for `pulseSurvey` for the far side of the relationship. */
  updateById?: InputMaybe<PulseSurveyOnPulseSurveyAnswerForPulseSurveyAnswerPulseSurveyIdForeignUsingPulseSurveyPkeyUpdate>;
};

/** Input for the nested mutation of `pulseSurveyAnswer` in the `PulseSurveyInput` mutation. */
export type PulseSurveyAnswerPulseSurveyIdForeignInverseInput = {
  /** The primary key(s) for `pulseSurveyAnswer` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PulseSurveyAnswerPulseSurveyAnswerPkeyConnect>>;
  /** The primary key(s) for `pulseSurveyAnswer` for the far side of the relationship. */
  connectByUserIdAndPulseSurveyIdAndDate?: InputMaybe<Array<PulseSurveyAnswerPulseSurveyAnswerUserIdPulseSurveyIdDateUniqueConnect>>;
  /** The primary key(s) for `pulseSurveyAnswer` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PulseSurveyAnswerPulseSurveyAnswerPkeyDelete>>;
  /** The primary key(s) for `pulseSurveyAnswer` for the far side of the relationship. */
  deleteByUserIdAndPulseSurveyIdAndDate?: InputMaybe<Array<PulseSurveyAnswerPulseSurveyAnswerUserIdPulseSurveyIdDateUniqueDelete>>;
  /** Flag indicating whether all other `pulseSurveyAnswer` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `pulseSurveyAnswer` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerPulseSurveyIdForeignUsingPulseSurveyAnswerPkeyUpdate>>;
  /** The primary key(s) and patch data for `pulseSurveyAnswer` for the far side of the relationship. */
  updateByUserIdAndPulseSurveyIdAndDate?: InputMaybe<Array<PulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerPulseSurveyIdForeignUsingPulseSurveyAnswerUserIdPulseSurveyIdDateUniqueUpdate>>;
};

/** The `pulseType` to be created by this mutation. */
export type PulseSurveyAnswerPulseTypeIdForeignConnectionPulseTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PulseTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseTypeIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseTypeIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyPulseTypeIdForeignInverseInput>;
  translatedEntity?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `pulseType` in the `PulseSurveyAnswerInput` mutation. */
export type PulseSurveyAnswerPulseTypeIdForeignInput = {
  /** The primary key(s) for `pulseType` for the far side of the relationship. */
  connectById?: InputMaybe<PulseTypePulseTypePkeyConnect>;
  /** A `PulseTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<PulseSurveyAnswerPulseTypeIdForeignConnectionPulseTypeCreateInput>;
  /** The primary key(s) for `pulseType` for the far side of the relationship. */
  deleteById?: InputMaybe<PulseTypePulseTypePkeyDelete>;
  /** The primary key(s) and patch data for `pulseType` for the far side of the relationship. */
  updateById?: InputMaybe<PulseTypeOnPulseSurveyAnswerForPulseSurveyAnswerPulseTypeIdForeignUsingPulseTypePkeyUpdate>;
};

/** Input for the nested mutation of `pulseSurveyAnswer` in the `PulseTypeInput` mutation. */
export type PulseSurveyAnswerPulseTypeIdForeignInverseInput = {
  /** The primary key(s) for `pulseSurveyAnswer` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PulseSurveyAnswerPulseSurveyAnswerPkeyConnect>>;
  /** The primary key(s) for `pulseSurveyAnswer` for the far side of the relationship. */
  connectByUserIdAndPulseSurveyIdAndDate?: InputMaybe<Array<PulseSurveyAnswerPulseSurveyAnswerUserIdPulseSurveyIdDateUniqueConnect>>;
  /** The primary key(s) for `pulseSurveyAnswer` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PulseSurveyAnswerPulseSurveyAnswerPkeyDelete>>;
  /** The primary key(s) for `pulseSurveyAnswer` for the far side of the relationship. */
  deleteByUserIdAndPulseSurveyIdAndDate?: InputMaybe<Array<PulseSurveyAnswerPulseSurveyAnswerUserIdPulseSurveyIdDateUniqueDelete>>;
  /** Flag indicating whether all other `pulseSurveyAnswer` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `pulseSurveyAnswer` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerPulseTypeIdForeignUsingPulseSurveyAnswerPkeyUpdate>>;
  /** The primary key(s) and patch data for `pulseSurveyAnswer` for the far side of the relationship. */
  updateByUserIdAndPulseSurveyIdAndDate?: InputMaybe<Array<PulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerPulseTypeIdForeignUsingPulseSurveyAnswerUserIdPulseSurveyIdDateUniqueUpdate>>;
};

/** Input for the nested mutation of `user` in the `PulseSurveyAnswerInput` mutation. */
export type PulseSurveyAnswerUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnPulseSurveyAnswerForPulseSurveyAnswerUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `pulseSurveyAnswer` in the `UserInput` mutation. */
export type PulseSurveyAnswerUserIdForeignInverseInput = {
  /** The primary key(s) for `pulseSurveyAnswer` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PulseSurveyAnswerPulseSurveyAnswerPkeyConnect>>;
  /** The primary key(s) for `pulseSurveyAnswer` for the far side of the relationship. */
  connectByUserIdAndPulseSurveyIdAndDate?: InputMaybe<Array<PulseSurveyAnswerPulseSurveyAnswerUserIdPulseSurveyIdDateUniqueConnect>>;
  /** The primary key(s) for `pulseSurveyAnswer` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PulseSurveyAnswerPulseSurveyAnswerPkeyDelete>>;
  /** The primary key(s) for `pulseSurveyAnswer` for the far side of the relationship. */
  deleteByUserIdAndPulseSurveyIdAndDate?: InputMaybe<Array<PulseSurveyAnswerPulseSurveyAnswerUserIdPulseSurveyIdDateUniqueDelete>>;
  /** Flag indicating whether all other `pulseSurveyAnswer` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `pulseSurveyAnswer` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerUserIdForeignUsingPulseSurveyAnswerPkeyUpdate>>;
  /** The primary key(s) and patch data for `pulseSurveyAnswer` for the far side of the relationship. */
  updateByUserIdAndPulseSurveyIdAndDate?: InputMaybe<Array<PulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerUserIdForeignUsingPulseSurveyAnswerUserIdPulseSurveyIdDateUniqueUpdate>>;
};

/** A connection to a list of `PulseSurveyAnswer` values. */
export type PulseSurveyAnswersConnection = {
  __typename?: 'PulseSurveyAnswersConnection';
  /** A list of edges which contains the `PulseSurveyAnswer` and cursor to aid in pagination. */
  edges: Array<PulseSurveyAnswersEdge>;
  /** A list of `PulseSurveyAnswer` objects. */
  nodes: Array<Maybe<PulseSurveyAnswer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PulseSurveyAnswer` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PulseSurveyAnswer` edge in the connection. */
export type PulseSurveyAnswersEdge = {
  __typename?: 'PulseSurveyAnswersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PulseSurveyAnswer` at the end of the edge. */
  node?: Maybe<PulseSurveyAnswer>;
};

/** Methods to use when ordering `PulseSurveyAnswer`. */
export type PulseSurveyAnswersOrderBy =
  | 'ANONYMOUS_ASC'
  | 'ANONYMOUS_DESC'
  | 'ANSWER_ASC'
  | 'ANSWER_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DATE_ASC'
  | 'DATE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__ACTIVE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__ACTIVE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__ANONYMOUS_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__ANONYMOUS_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__CHOICE_INDICATOR_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__CHOICE_INDICATOR_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__COMPANY_ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__COMPANY_ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__CREATED_AT_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__CREATED_AT_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__DEADLINE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__DEADLINE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__END_DATE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__END_DATE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__HIGHEST_RATING_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__HIGHEST_RATING_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__HIGHEST_RATING_LABEL_TRANSLATED_ENTITY_ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__HIGHEST_RATING_LABEL_TRANSLATED_ENTITY_ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__HORIZONTAL_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__HORIZONTAL_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__INVITED_ALL_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__INVITED_ALL_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__INVITED_DEPARTMENT_IDS_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__INVITED_DEPARTMENT_IDS_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__INVITED_USER_IDS_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__INVITED_USER_IDS_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__IS_DRAFT_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__IS_DRAFT_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__LOCALIZED_NAME_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__LOCALIZED_NAME_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__LOWEST_RATING_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__LOWEST_RATING_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__LOWEST_RATING_LABEL_TRANSLATED_ENTITY_ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__LOWEST_RATING_LABEL_TRANSLATED_ENTITY_ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__NEXT_OCCURRENCE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__NEXT_OCCURRENCE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__PULSE_TYPE_ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__PULSE_TYPE_ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__QUESTION_TRANSLATED_ENTITY_ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__QUESTION_TRANSLATED_ENTITY_ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__QUESTION_TYPE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__QUESTION_TYPE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__RATING_TYPE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__RATING_TYPE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__REMINDERS_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__REMINDERS_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__START_DATE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__START_DATE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__SURVEY_TIME_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__SURVEY_TIME_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__TIMEZONE_NAME_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__TIMEZONE_NAME_DESC'
  | 'PULSE_SURVEY_ID_ASC'
  | 'PULSE_SURVEY_ID_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__ACTIVE_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__ACTIVE_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__COMPANY_ID_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__COMPANY_ID_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__CREATED_AT_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__CREATED_AT_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__ID_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__ID_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__UPDATED_AT_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__UPDATED_AT_DESC'
  | 'PULSE_TYPE_ID_ASC'
  | 'PULSE_TYPE_ID_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type PulseSurveyChoice = {
  __typename?: 'PulseSurveyChoice';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `PulseSurveyChoice`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  emoji?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  localizedText?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  /** Reads a single `PulseSurvey` that is related to this `PulseSurveyChoice`. */
  pulseSurvey?: Maybe<PulseSurvey>;
  pulseSurveyId: Scalars['UUID'];
  /** Reads a single `PulseType` that is related to this `PulseSurveyChoice`. */
  pulseType?: Maybe<PulseType>;
  pulseTypeId?: Maybe<Scalars['UUID']>;
  text?: Maybe<Scalars['String']>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseSurveyChoice`. */
  textTranslatedEntity?: Maybe<TranslatedEntity>;
  textTranslatedEntityId: Scalars['UUID'];
};

/** Input for the nested mutation of `company` in the `PulseSurveyChoiceInput` mutation. */
export type PulseSurveyChoiceCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnPulseSurveyChoiceForPulseSurveyChoiceCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `pulseSurveyChoice` in the `CompanyInput` mutation. */
export type PulseSurveyChoiceCompanyIdForeignInverseInput = {
  /** The primary key(s) for `pulseSurveyChoice` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PulseSurveyChoicePulseSurveyChoicePkeyConnect>>;
  /** The primary key(s) for `pulseSurveyChoice` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PulseSurveyChoicePulseSurveyChoicePkeyDelete>>;
  /** Flag indicating whether all other `pulseSurveyChoice` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `pulseSurveyChoice` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PulseSurveyChoiceOnPulseSurveyChoiceForPulseSurveyChoiceCompanyIdForeignUsingPulseSurveyChoicePkeyUpdate>>;
};

/**
 * A condition to be used against `PulseSurveyChoice` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PulseSurveyChoiceCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `emoji` field. */
  emoji?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `pulseSurveyId` field. */
  pulseSurveyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `pulseTypeId` field. */
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `textTranslatedEntityId` field. */
  textTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `PulseSurveyChoice` object types. All fields are combined with a logical ‘and.’ */
export type PulseSurveyChoiceFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PulseSurveyChoiceFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `emoji` field. */
  emoji?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedText` field. */
  localizedText?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PulseSurveyChoiceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PulseSurveyChoiceFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `pulseSurvey` relation. */
  pulseSurvey?: InputMaybe<PulseSurveyFilter>;
  /** Filter by the object’s `pulseSurveyId` field. */
  pulseSurveyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `pulseType` relation. */
  pulseType?: InputMaybe<PulseTypeFilter>;
  /** A related `pulseType` exists. */
  pulseTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseTypeId` field. */
  pulseTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `text` field. */
  text?: InputMaybe<StringFilter>;
  /** Filter by the object’s `textTranslatedEntity` relation. */
  textTranslatedEntity?: InputMaybe<TranslatedEntityFilter>;
  /** Filter by the object’s `textTranslatedEntityId` field. */
  textTranslatedEntityId?: InputMaybe<UuidFilter>;
};

export type PulseSurveyChoiceIndicator =
  /** Choices are given a letter in alphabetical order. */
  | 'ALPHABETICAL'
  /** Choices are given a user defined emoji. */
  | 'EMOJIS'
  /** Choices are given no indicator. */
  | 'NONE'
  /** Choices are given a number in numerical order. */
  | 'NUMBERS';

/** A filter to be used against PulseSurveyChoiceIndicator fields. All fields are combined with a logical ‘and.’ */
export type PulseSurveyChoiceIndicatorFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PulseSurveyChoiceIndicator>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PulseSurveyChoiceIndicator>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PulseSurveyChoiceIndicator>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PulseSurveyChoiceIndicator>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PulseSurveyChoiceIndicator>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PulseSurveyChoiceIndicator>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PulseSurveyChoiceIndicator>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PulseSurveyChoiceIndicator>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PulseSurveyChoiceIndicator>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PulseSurveyChoiceIndicator>>;
};

export type PulseSurveyChoiceLocalization = {
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  localizations?: InputMaybe<Array<LocaleWithTranslation>>;
  order?: InputMaybe<Scalars['Int']>;
  text: Scalars['String'];
};

/** The fields on `pulseSurveyChoice` to look up the row to update. */
export type PulseSurveyChoiceOnPulseSurveyChoiceForPulseSurveyChoiceCompanyIdForeignUsingPulseSurveyChoicePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseSurveyChoice` being updated. */
  patch: UpdatePulseSurveyChoiceOnPulseSurveyChoiceForPulseSurveyChoiceCompanyIdForeignPatch;
};

/** The fields on `pulseSurveyChoice` to look up the row to update. */
export type PulseSurveyChoiceOnPulseSurveyChoiceForPulseSurveyChoicePulseSurveyIdForeignUsingPulseSurveyChoicePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseSurveyChoice` being updated. */
  patch: UpdatePulseSurveyChoiceOnPulseSurveyChoiceForPulseSurveyChoicePulseSurveyIdForeignPatch;
};

/** The fields on `pulseSurveyChoice` to look up the row to update. */
export type PulseSurveyChoiceOnPulseSurveyChoiceForPulseSurveyChoicePulseTypeIdForeignUsingPulseSurveyChoicePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseSurveyChoice` being updated. */
  patch: UpdatePulseSurveyChoiceOnPulseSurveyChoiceForPulseSurveyChoicePulseTypeIdForeignPatch;
};

/** The fields on `pulseSurveyChoice` to look up the row to update. */
export type PulseSurveyChoiceOnPulseSurveyChoiceForPulseSurveyChoiceTextTranslatedEntityIdForeignUsingPulseSurveyChoicePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseSurveyChoice` being updated. */
  patch: UpdatePulseSurveyChoiceOnPulseSurveyChoiceForPulseSurveyChoiceTextTranslatedEntityIdForeignPatch;
};

/** Represents an update to a `PulseSurveyChoice`. Fields that are set will be updated. */
export type PulseSurveyChoicePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  pulseSurvey?: InputMaybe<PulseSurveyChoicePulseSurveyIdForeignInput>;
  pulseSurveyId?: InputMaybe<Scalars['UUID']>;
  pulseType?: InputMaybe<PulseSurveyChoicePulseTypeIdForeignInput>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  textTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInput>;
};

/** The fields on `pulseSurveyChoice` to look up the row to connect. */
export type PulseSurveyChoicePulseSurveyChoicePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `pulseSurveyChoice` to look up the row to delete. */
export type PulseSurveyChoicePulseSurveyChoicePkeyDelete = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `pulseSurvey` in the `PulseSurveyChoiceInput` mutation. */
export type PulseSurveyChoicePulseSurveyIdForeignInput = {
  /** The primary key(s) for `pulseSurvey` for the far side of the relationship. */
  connectById?: InputMaybe<PulseSurveyPulseSurveyPkeyConnect>;
  /** The primary key(s) for `pulseSurvey` for the far side of the relationship. */
  deleteById?: InputMaybe<PulseSurveyPulseSurveyPkeyDelete>;
  /** The primary key(s) and patch data for `pulseSurvey` for the far side of the relationship. */
  updateById?: InputMaybe<PulseSurveyOnPulseSurveyChoiceForPulseSurveyChoicePulseSurveyIdForeignUsingPulseSurveyPkeyUpdate>;
};

/** Input for the nested mutation of `pulseSurveyChoice` in the `PulseSurveyInput` mutation. */
export type PulseSurveyChoicePulseSurveyIdForeignInverseInput = {
  /** The primary key(s) for `pulseSurveyChoice` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PulseSurveyChoicePulseSurveyChoicePkeyConnect>>;
  /** The primary key(s) for `pulseSurveyChoice` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PulseSurveyChoicePulseSurveyChoicePkeyDelete>>;
  /** Flag indicating whether all other `pulseSurveyChoice` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `pulseSurveyChoice` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PulseSurveyChoiceOnPulseSurveyChoiceForPulseSurveyChoicePulseSurveyIdForeignUsingPulseSurveyChoicePkeyUpdate>>;
};

/** The `pulseType` to be created by this mutation. */
export type PulseSurveyChoicePulseTypeIdForeignConnectionPulseTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PulseTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseTypeIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseTypeIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyPulseTypeIdForeignInverseInput>;
  translatedEntity?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `pulseType` in the `PulseSurveyChoiceInput` mutation. */
export type PulseSurveyChoicePulseTypeIdForeignInput = {
  /** The primary key(s) for `pulseType` for the far side of the relationship. */
  connectById?: InputMaybe<PulseTypePulseTypePkeyConnect>;
  /** A `PulseTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<PulseSurveyChoicePulseTypeIdForeignConnectionPulseTypeCreateInput>;
  /** The primary key(s) for `pulseType` for the far side of the relationship. */
  deleteById?: InputMaybe<PulseTypePulseTypePkeyDelete>;
  /** The primary key(s) and patch data for `pulseType` for the far side of the relationship. */
  updateById?: InputMaybe<PulseTypeOnPulseSurveyChoiceForPulseSurveyChoicePulseTypeIdForeignUsingPulseTypePkeyUpdate>;
};

/** Input for the nested mutation of `pulseSurveyChoice` in the `PulseTypeInput` mutation. */
export type PulseSurveyChoicePulseTypeIdForeignInverseInput = {
  /** The primary key(s) for `pulseSurveyChoice` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PulseSurveyChoicePulseSurveyChoicePkeyConnect>>;
  /** The primary key(s) for `pulseSurveyChoice` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PulseSurveyChoicePulseSurveyChoicePkeyDelete>>;
  /** Flag indicating whether all other `pulseSurveyChoice` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `pulseSurveyChoice` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PulseSurveyChoiceOnPulseSurveyChoiceForPulseSurveyChoicePulseTypeIdForeignUsingPulseSurveyChoicePkeyUpdate>>;
};

/** Input for the nested mutation of `translatedEntity` in the `PulseSurveyChoiceInput` mutation. */
export type PulseSurveyChoiceTextTranslatedEntityIdForeignInput = {
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  connectById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyConnect>;
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  deleteById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyDelete>;
  /** The primary key(s) and patch data for `translatedEntity` for the far side of the relationship. */
  updateById?: InputMaybe<TranslatedEntityOnPulseSurveyChoiceForPulseSurveyChoiceTextTranslatedEntityIdForeignUsingTranslatedEntityPkeyUpdate>;
};

/** Input for the nested mutation of `pulseSurveyChoice` in the `TranslatedEntityInput` mutation. */
export type PulseSurveyChoiceTextTranslatedEntityIdForeignInverseInput = {
  /** The primary key(s) for `pulseSurveyChoice` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PulseSurveyChoicePulseSurveyChoicePkeyConnect>>;
  /** The primary key(s) for `pulseSurveyChoice` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PulseSurveyChoicePulseSurveyChoicePkeyDelete>>;
  /** Flag indicating whether all other `pulseSurveyChoice` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `pulseSurveyChoice` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PulseSurveyChoiceOnPulseSurveyChoiceForPulseSurveyChoiceTextTranslatedEntityIdForeignUsingPulseSurveyChoicePkeyUpdate>>;
};

/** A connection to a list of `PulseSurveyChoice` values. */
export type PulseSurveyChoicesConnection = {
  __typename?: 'PulseSurveyChoicesConnection';
  /** A list of edges which contains the `PulseSurveyChoice` and cursor to aid in pagination. */
  edges: Array<PulseSurveyChoicesEdge>;
  /** A list of `PulseSurveyChoice` objects. */
  nodes: Array<Maybe<PulseSurveyChoice>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PulseSurveyChoice` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PulseSurveyChoice` edge in the connection. */
export type PulseSurveyChoicesEdge = {
  __typename?: 'PulseSurveyChoicesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PulseSurveyChoice` at the end of the edge. */
  node?: Maybe<PulseSurveyChoice>;
};

/** Methods to use when ordering `PulseSurveyChoice`. */
export type PulseSurveyChoicesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'EMOJI_ASC'
  | 'EMOJI_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__ACTIVE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__ACTIVE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__ANONYMOUS_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__ANONYMOUS_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__CHOICE_INDICATOR_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__CHOICE_INDICATOR_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__COMPANY_ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__COMPANY_ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__CREATED_AT_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__CREATED_AT_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__DEADLINE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__DEADLINE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__END_DATE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__END_DATE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__HIGHEST_RATING_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__HIGHEST_RATING_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__HIGHEST_RATING_LABEL_TRANSLATED_ENTITY_ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__HIGHEST_RATING_LABEL_TRANSLATED_ENTITY_ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__HORIZONTAL_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__HORIZONTAL_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__INVITED_ALL_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__INVITED_ALL_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__INVITED_DEPARTMENT_IDS_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__INVITED_DEPARTMENT_IDS_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__INVITED_USER_IDS_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__INVITED_USER_IDS_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__IS_DRAFT_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__IS_DRAFT_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__LOCALIZED_NAME_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__LOCALIZED_NAME_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__LOWEST_RATING_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__LOWEST_RATING_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__LOWEST_RATING_LABEL_TRANSLATED_ENTITY_ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__LOWEST_RATING_LABEL_TRANSLATED_ENTITY_ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__NEXT_OCCURRENCE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__NEXT_OCCURRENCE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__PULSE_TYPE_ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__PULSE_TYPE_ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__QUESTION_TRANSLATED_ENTITY_ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__QUESTION_TRANSLATED_ENTITY_ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__QUESTION_TYPE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__QUESTION_TYPE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__RATING_TYPE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__RATING_TYPE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__REMINDERS_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__REMINDERS_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__START_DATE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__START_DATE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__SURVEY_TIME_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__SURVEY_TIME_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__TIMEZONE_NAME_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__TIMEZONE_NAME_DESC'
  | 'PULSE_SURVEY_ID_ASC'
  | 'PULSE_SURVEY_ID_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__ACTIVE_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__ACTIVE_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__COMPANY_ID_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__COMPANY_ID_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__CREATED_AT_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__CREATED_AT_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__ID_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__ID_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__UPDATED_AT_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__UPDATED_AT_DESC'
  | 'PULSE_TYPE_ID_ASC'
  | 'PULSE_TYPE_ID_DESC'
  | 'TEXT_TRANSLATED_ENTITY_ID_ASC'
  | 'TEXT_TRANSLATED_ENTITY_ID_DESC'
  | 'TRANSLATED_ENTITY_BY_TEXT_TRANSLATED_ENTITY_ID__COMPANY_ID_ASC'
  | 'TRANSLATED_ENTITY_BY_TEXT_TRANSLATED_ENTITY_ID__COMPANY_ID_DESC'
  | 'TRANSLATED_ENTITY_BY_TEXT_TRANSLATED_ENTITY_ID__ID_ASC'
  | 'TRANSLATED_ENTITY_BY_TEXT_TRANSLATED_ENTITY_ID__ID_DESC';

/** Input for the nested mutation of `company` in the `PulseSurveyInput` mutation. */
export type PulseSurveyCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnPulseSurveyForPulseSurveyCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `pulseSurvey` in the `CompanyInput` mutation. */
export type PulseSurveyCompanyIdForeignInverseInput = {
  /** The primary key(s) for `pulseSurvey` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PulseSurveyPulseSurveyPkeyConnect>>;
  /** The primary key(s) for `pulseSurvey` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PulseSurveyPulseSurveyPkeyDelete>>;
  /** Flag indicating whether all other `pulseSurvey` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `pulseSurvey` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PulseSurveyOnPulseSurveyForPulseSurveyCompanyIdForeignUsingPulseSurveyPkeyUpdate>>;
};

/**
 * A condition to be used against `PulseSurvey` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PulseSurveyCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `anonymous` field. */
  anonymous?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `choiceIndicator` field. */
  choiceIndicator?: InputMaybe<PulseSurveyChoiceIndicator>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deadline` field. */
  deadline?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `highestRating` field. */
  highestRating?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `highestRatingLabelTranslatedEntityId` field. */
  highestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `horizontal` field. */
  horizontal?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `invitedAll` field. */
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `invitedDepartmentIds` field. */
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `invitedUserIds` field. */
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `isDraft` field. */
  isDraft?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `lowestRating` field. */
  lowestRating?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `lowestRatingLabelTranslatedEntityId` field. */
  lowestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameTranslatedEntityId` field. */
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nextOccurrence` field. */
  nextOccurrence?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `pulseTypeId` field. */
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `questionTranslatedEntityId` field. */
  questionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `questionType` field. */
  questionType?: InputMaybe<PulseSurveyQuestionType>;
  /** Checks for equality with the object’s `ratingType` field. */
  ratingType?: InputMaybe<RatingType>;
  /** Checks for equality with the object’s `reminders` field. */
  reminders?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `surveyTime` field. */
  surveyTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `timezoneName` field. */
  timezoneName?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `PulseSurvey` object types. All fields are combined with a logical ‘and.’ */
export type PulseSurveyFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PulseSurveyFilter>>;
  /** Filter by the object’s `anonymous` field. */
  anonymous?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `averageRatingAllTimeLastYear` field. */
  averageRatingAllTimeLastYear?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `averageRatingThisMonth` field. */
  averageRatingThisMonth?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `averageRatingThisMonthLastYear` field. */
  averageRatingThisMonthLastYear?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `choiceIndicator` field. */
  choiceIndicator?: InputMaybe<PulseSurveyChoiceIndicatorFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currentAnswerByCurrentUser` field. */
  currentAnswerByCurrentUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deadline` field. */
  deadline?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `hasBeenAnsweredByCurrentUser` field. */
  hasBeenAnsweredByCurrentUser?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `highestRating` field. */
  highestRating?: InputMaybe<IntFilter>;
  /** Filter by the object’s `highestRatingLabel` field. */
  highestRatingLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `highestRatingLabelTranslatedEntity` relation. */
  highestRatingLabelTranslatedEntity?: InputMaybe<TranslatedEntityFilter>;
  /** Filter by the object’s `highestRatingLabelTranslatedEntityId` field. */
  highestRatingLabelTranslatedEntityId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `horizontal` field. */
  horizontal?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `invitedAll` field. */
  invitedAll?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `invitedDepartmentIds` field. */
  invitedDepartmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `invitedUserIds` field. */
  invitedUserIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `isDraft` field. */
  isDraft?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `localizedHighestRatingLabel` field. */
  localizedHighestRatingLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `localizedLowestRatingLabel` field. */
  localizedLowestRatingLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `localizedQuestion` field. */
  localizedQuestion?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lowestRating` field. */
  lowestRating?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lowestRatingLabel` field. */
  lowestRatingLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lowestRatingLabelTranslatedEntity` relation. */
  lowestRatingLabelTranslatedEntity?: InputMaybe<TranslatedEntityFilter>;
  /** Filter by the object’s `lowestRatingLabelTranslatedEntityId` field. */
  lowestRatingLabelTranslatedEntityId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameTranslatedEntity` relation. */
  nameTranslatedEntity?: InputMaybe<TranslatedEntityFilter>;
  /** Filter by the object’s `nameTranslatedEntityId` field. */
  nameTranslatedEntityId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `nextOccurrence` field. */
  nextOccurrence?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PulseSurveyFilter>;
  /** Filter by the object’s `numberOfAnswersCollected` field. */
  numberOfAnswersCollected?: InputMaybe<IntFilter>;
  /** Filter by the object’s `numberOfChoices` field. */
  numberOfChoices?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `numberOfRecipients` field. */
  numberOfRecipients?: InputMaybe<IntFilter>;
  /** Filter by the object’s `numberOfRecipientsLastYear` field. */
  numberOfRecipientsLastYear?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PulseSurveyFilter>>;
  /** Filter by the object’s `pulseSurveyAnswers` relation. */
  pulseSurveyAnswers?: InputMaybe<PulseSurveyToManyPulseSurveyAnswerFilter>;
  /** Some related `pulseSurveyAnswers` exist. */
  pulseSurveyAnswersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseSurveyChoices` relation. */
  pulseSurveyChoices?: InputMaybe<PulseSurveyToManyPulseSurveyChoiceFilter>;
  /** Some related `pulseSurveyChoices` exist. */
  pulseSurveyChoicesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseType` relation. */
  pulseType?: InputMaybe<PulseTypeFilter>;
  /** A related `pulseType` exists. */
  pulseTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseTypeId` field. */
  pulseTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `question` field. */
  question?: InputMaybe<StringFilter>;
  /** Filter by the object’s `questionTranslatedEntity` relation. */
  questionTranslatedEntity?: InputMaybe<TranslatedEntityFilter>;
  /** Filter by the object’s `questionTranslatedEntityId` field. */
  questionTranslatedEntityId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `questionType` field. */
  questionType?: InputMaybe<PulseSurveyQuestionTypeFilter>;
  /** Filter by the object’s `ratingType` field. */
  ratingType?: InputMaybe<RatingTypeFilter>;
  /** Filter by the object’s `recurrenceRuleByPulseSurveyId` relation. */
  recurrenceRuleByPulseSurveyId?: InputMaybe<RecurrenceRuleFilter>;
  /** A related `recurrenceRuleByPulseSurveyId` exists. */
  recurrenceRuleByPulseSurveyIdExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `reminders` field. */
  reminders?: InputMaybe<IntervalListFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `surveyTime` field. */
  surveyTime?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `timezoneName` field. */
  timezoneName?: InputMaybe<StringFilter>;
};

/** Input for the nested mutation of `translatedEntity` in the `PulseSurveyInput` mutation. */
export type PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInput = {
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  connectById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyConnect>;
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  deleteById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyDelete>;
  /** The primary key(s) and patch data for `translatedEntity` for the far side of the relationship. */
  updateById?: InputMaybe<TranslatedEntityOnPulseSurveyForPulseSurveyHighestRatingLabelTranslatedEntityIdForeignUsingTranslatedEntityPkeyUpdate>;
};

/** Input for the nested mutation of `pulseSurvey` in the `TranslatedEntityInput` mutation. */
export type PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInverseInput = {
  /** The primary key(s) for `pulseSurvey` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PulseSurveyPulseSurveyPkeyConnect>>;
  /** The primary key(s) for `pulseSurvey` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PulseSurveyPulseSurveyPkeyDelete>>;
  /** Flag indicating whether all other `pulseSurvey` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `pulseSurvey` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PulseSurveyOnPulseSurveyForPulseSurveyHighestRatingLabelTranslatedEntityIdForeignUsingPulseSurveyPkeyUpdate>>;
};

/** Input for the nested mutation of `pulseSurvey` in the `TranslatedEntityInput` mutation. */
export type PulseSurveyLowestRatingLabelTranslatedEntityIdForeignInverseInput = {
  /** The primary key(s) for `pulseSurvey` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PulseSurveyPulseSurveyPkeyConnect>>;
  /** The primary key(s) for `pulseSurvey` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PulseSurveyPulseSurveyPkeyDelete>>;
  /** Flag indicating whether all other `pulseSurvey` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `pulseSurvey` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PulseSurveyOnPulseSurveyForPulseSurveyLowestRatingLabelTranslatedEntityIdForeignUsingPulseSurveyPkeyUpdate>>;
};

/** Input for the nested mutation of `pulseSurvey` in the `TranslatedEntityInput` mutation. */
export type PulseSurveyNameTranslatedEntityIdForeignInverseInput = {
  /** The primary key(s) for `pulseSurvey` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PulseSurveyPulseSurveyPkeyConnect>>;
  /** The primary key(s) for `pulseSurvey` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PulseSurveyPulseSurveyPkeyDelete>>;
  /** Flag indicating whether all other `pulseSurvey` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `pulseSurvey` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PulseSurveyOnPulseSurveyForPulseSurveyNameTranslatedEntityIdForeignUsingPulseSurveyPkeyUpdate>>;
};

/** The fields on `pulseSurvey` to look up the row to update. */
export type PulseSurveyOnPulseSurveyAnswerForPulseSurveyAnswerPulseSurveyIdForeignUsingPulseSurveyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseSurvey` being updated. */
  patch: UpdatePulseSurveyOnPulseSurveyAnswerForPulseSurveyAnswerPulseSurveyIdForeignPatch;
};

/** The fields on `pulseSurvey` to look up the row to update. */
export type PulseSurveyOnPulseSurveyChoiceForPulseSurveyChoicePulseSurveyIdForeignUsingPulseSurveyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseSurvey` being updated. */
  patch: UpdatePulseSurveyOnPulseSurveyChoiceForPulseSurveyChoicePulseSurveyIdForeignPatch;
};

/** The fields on `pulseSurvey` to look up the row to update. */
export type PulseSurveyOnPulseSurveyForPulseSurveyCompanyIdForeignUsingPulseSurveyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseSurvey` being updated. */
  patch: UpdatePulseSurveyOnPulseSurveyForPulseSurveyCompanyIdForeignPatch;
};

/** The fields on `pulseSurvey` to look up the row to update. */
export type PulseSurveyOnPulseSurveyForPulseSurveyHighestRatingLabelTranslatedEntityIdForeignUsingPulseSurveyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseSurvey` being updated. */
  patch: UpdatePulseSurveyOnPulseSurveyForPulseSurveyHighestRatingLabelTranslatedEntityIdForeignPatch;
};

/** The fields on `pulseSurvey` to look up the row to update. */
export type PulseSurveyOnPulseSurveyForPulseSurveyLowestRatingLabelTranslatedEntityIdForeignUsingPulseSurveyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseSurvey` being updated. */
  patch: UpdatePulseSurveyOnPulseSurveyForPulseSurveyLowestRatingLabelTranslatedEntityIdForeignPatch;
};

/** The fields on `pulseSurvey` to look up the row to update. */
export type PulseSurveyOnPulseSurveyForPulseSurveyNameTranslatedEntityIdForeignUsingPulseSurveyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseSurvey` being updated. */
  patch: UpdatePulseSurveyOnPulseSurveyForPulseSurveyNameTranslatedEntityIdForeignPatch;
};

/** The fields on `pulseSurvey` to look up the row to update. */
export type PulseSurveyOnPulseSurveyForPulseSurveyPulseTypeIdForeignUsingPulseSurveyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseSurvey` being updated. */
  patch: UpdatePulseSurveyOnPulseSurveyForPulseSurveyPulseTypeIdForeignPatch;
};

/** The fields on `pulseSurvey` to look up the row to update. */
export type PulseSurveyOnPulseSurveyForPulseSurveyQuestionTranslatedEntityIdForeignUsingPulseSurveyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseSurvey` being updated. */
  patch: UpdatePulseSurveyOnPulseSurveyForPulseSurveyQuestionTranslatedEntityIdForeignPatch;
};

/** The fields on `pulseSurvey` to look up the row to update. */
export type PulseSurveyOnRecurrenceRuleForRecurrenceRulePulseSurveyIdForeignUsingPulseSurveyPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseSurvey` being updated. */
  patch: UpdatePulseSurveyOnRecurrenceRuleForRecurrenceRulePulseSurveyIdForeignPatch;
};

/** Represents an update to a `PulseSurvey`. Fields that are set will be updated. */
export type PulseSurveyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  choiceIndicator?: InputMaybe<PulseSurveyChoiceIndicator>;
  company?: InputMaybe<PulseSurveyCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<IntervalInput>;
  endDate?: InputMaybe<Scalars['Date']>;
  highestRating?: InputMaybe<Scalars['Int']>;
  highestRatingLabel?: InputMaybe<Scalars['String']>;
  highestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  highestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  horizontal?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  lowestRating?: InputMaybe<Scalars['Int']>;
  lowestRatingLabel?: InputMaybe<Scalars['String']>;
  lowestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  lowestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseSurveyIdForeignInverseInput>;
  pulseSurveyChoiceLocalizations?: InputMaybe<Array<PulseSurveyChoiceLocalization>>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseSurveyIdForeignInverseInput>;
  pulseType?: InputMaybe<PulseSurveyPulseTypeIdForeignInput>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  question?: InputMaybe<Scalars['String']>;
  questionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  questionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  questionType?: InputMaybe<PulseSurveyQuestionType>;
  ratingType?: InputMaybe<RatingType>;
  recurrenceRule?: InputMaybe<RecurrenceRulePulseSurveyIdForeignInverseInput>;
  reminders?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  startDate?: InputMaybe<Scalars['Date']>;
  surveyTime?: InputMaybe<Scalars['Time']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  translatedEntity?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInput>;
};

/** The fields on `pulseSurvey` to look up the row to connect. */
export type PulseSurveyPulseSurveyPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `pulseSurvey` to look up the row to delete. */
export type PulseSurveyPulseSurveyPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `pulseType` to be created by this mutation. */
export type PulseSurveyPulseTypeIdForeignConnectionPulseTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PulseTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseTypeIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseTypeIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyPulseTypeIdForeignInverseInput>;
  translatedEntity?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `pulseType` in the `PulseSurveyInput` mutation. */
export type PulseSurveyPulseTypeIdForeignInput = {
  /** The primary key(s) for `pulseType` for the far side of the relationship. */
  connectById?: InputMaybe<PulseTypePulseTypePkeyConnect>;
  /** A `PulseTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<PulseSurveyPulseTypeIdForeignConnectionPulseTypeCreateInput>;
  /** The primary key(s) for `pulseType` for the far side of the relationship. */
  deleteById?: InputMaybe<PulseTypePulseTypePkeyDelete>;
  /** The primary key(s) and patch data for `pulseType` for the far side of the relationship. */
  updateById?: InputMaybe<PulseTypeOnPulseSurveyForPulseSurveyPulseTypeIdForeignUsingPulseTypePkeyUpdate>;
};

/** Input for the nested mutation of `pulseSurvey` in the `PulseTypeInput` mutation. */
export type PulseSurveyPulseTypeIdForeignInverseInput = {
  /** The primary key(s) for `pulseSurvey` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PulseSurveyPulseSurveyPkeyConnect>>;
  /** The primary key(s) for `pulseSurvey` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PulseSurveyPulseSurveyPkeyDelete>>;
  /** Flag indicating whether all other `pulseSurvey` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `pulseSurvey` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PulseSurveyOnPulseSurveyForPulseSurveyPulseTypeIdForeignUsingPulseSurveyPkeyUpdate>>;
};

/** Input for the nested mutation of `pulseSurvey` in the `TranslatedEntityInput` mutation. */
export type PulseSurveyQuestionTranslatedEntityIdForeignInverseInput = {
  /** The primary key(s) for `pulseSurvey` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PulseSurveyPulseSurveyPkeyConnect>>;
  /** The primary key(s) for `pulseSurvey` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PulseSurveyPulseSurveyPkeyDelete>>;
  /** Flag indicating whether all other `pulseSurvey` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `pulseSurvey` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PulseSurveyOnPulseSurveyForPulseSurveyQuestionTranslatedEntityIdForeignUsingPulseSurveyPkeyUpdate>>;
};

export type PulseSurveyQuestionType =
  /** Select a float value with a slider. */
  | 'CONTINUOUS_RATING_SCALE'
  /** Select from a list of emojis. */
  | 'EMOJI_MOOD_SCALE'
  /** Select multiple choices from a list of options. */
  | 'MULTIPLE_CHOICE'
  /** Select from a list of numbers. */
  | 'NUMERIC_SCALE'
  /** Select a number of stars. */
  | 'RATING'
  /** Simple yes/no answer. */
  | 'YES_NO';

/** A filter to be used against PulseSurveyQuestionType fields. All fields are combined with a logical ‘and.’ */
export type PulseSurveyQuestionTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PulseSurveyQuestionType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PulseSurveyQuestionType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PulseSurveyQuestionType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PulseSurveyQuestionType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PulseSurveyQuestionType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PulseSurveyQuestionType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PulseSurveyQuestionType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PulseSurveyQuestionType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PulseSurveyQuestionType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PulseSurveyQuestionType>>;
};

export type PulseSurveyRecipient = {
  __typename?: 'PulseSurveyRecipient';
  canLoginApp?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['UUID']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  locale?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
};

/** A filter to be used against `PulseSurveyRecipient` object types. All fields are combined with a logical ‘and.’ */
export type PulseSurveyRecipientFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PulseSurveyRecipientFilter>>;
  /** Filter by the object’s `canLoginApp` field. */
  canLoginApp?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `locale` field. */
  locale?: InputMaybe<StringFilter>;
  /** Filter by the object’s `logo` field. */
  logo?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PulseSurveyRecipientFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PulseSurveyRecipientFilter>>;
};

/** A connection to a list of `PulseSurveyRecipient` values. */
export type PulseSurveyRecipientsConnection = {
  __typename?: 'PulseSurveyRecipientsConnection';
  /** A list of edges which contains the `PulseSurveyRecipient` and cursor to aid in pagination. */
  edges: Array<PulseSurveyRecipientsEdge>;
  /** A list of `PulseSurveyRecipient` objects. */
  nodes: Array<Maybe<PulseSurveyRecipient>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PulseSurveyRecipient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PulseSurveyRecipient` edge in the connection. */
export type PulseSurveyRecipientsEdge = {
  __typename?: 'PulseSurveyRecipientsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PulseSurveyRecipient` at the end of the edge. */
  node?: Maybe<PulseSurveyRecipient>;
};

/** A filter to be used against many `PulseSurveyAnswer` object types. All fields are combined with a logical ‘and.’ */
export type PulseSurveyToManyPulseSurveyAnswerFilter = {
  /** Every related `PulseSurveyAnswer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PulseSurveyAnswerFilter>;
  /** No related `PulseSurveyAnswer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PulseSurveyAnswerFilter>;
  /** Some related `PulseSurveyAnswer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PulseSurveyAnswerFilter>;
};

/** A filter to be used against many `PulseSurveyChoice` object types. All fields are combined with a logical ‘and.’ */
export type PulseSurveyToManyPulseSurveyChoiceFilter = {
  /** Every related `PulseSurveyChoice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PulseSurveyChoiceFilter>;
  /** No related `PulseSurveyChoice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PulseSurveyChoiceFilter>;
  /** Some related `PulseSurveyChoice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PulseSurveyChoiceFilter>;
};

/** A connection to a list of `PulseSurvey` values. */
export type PulseSurveysConnection = {
  __typename?: 'PulseSurveysConnection';
  /** A list of edges which contains the `PulseSurvey` and cursor to aid in pagination. */
  edges: Array<PulseSurveysEdge>;
  /** A list of `PulseSurvey` objects. */
  nodes: Array<Maybe<PulseSurvey>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PulseSurvey` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PulseSurvey` edge in the connection. */
export type PulseSurveysEdge = {
  __typename?: 'PulseSurveysEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PulseSurvey` at the end of the edge. */
  node?: Maybe<PulseSurvey>;
};

/** Methods to use when ordering `PulseSurvey`. */
export type PulseSurveysOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ANONYMOUS_ASC'
  | 'ANONYMOUS_DESC'
  | 'CHOICE_INDICATOR_ASC'
  | 'CHOICE_INDICATOR_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEADLINE_ASC'
  | 'DEADLINE_DESC'
  | 'END_DATE_ASC'
  | 'END_DATE_DESC'
  | 'HIGHEST_RATING_ASC'
  | 'HIGHEST_RATING_DESC'
  | 'HIGHEST_RATING_LABEL_TRANSLATED_ENTITY_ID_ASC'
  | 'HIGHEST_RATING_LABEL_TRANSLATED_ENTITY_ID_DESC'
  | 'HORIZONTAL_ASC'
  | 'HORIZONTAL_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INVITED_ALL_ASC'
  | 'INVITED_ALL_DESC'
  | 'INVITED_DEPARTMENT_IDS_ASC'
  | 'INVITED_DEPARTMENT_IDS_DESC'
  | 'INVITED_USER_IDS_ASC'
  | 'INVITED_USER_IDS_DESC'
  | 'IS_DRAFT_ASC'
  | 'IS_DRAFT_DESC'
  | 'LOCALIZED_NAME_ASC'
  | 'LOCALIZED_NAME_DESC'
  | 'LOWEST_RATING_ASC'
  | 'LOWEST_RATING_DESC'
  | 'LOWEST_RATING_LABEL_TRANSLATED_ENTITY_ID_ASC'
  | 'LOWEST_RATING_LABEL_TRANSLATED_ENTITY_ID_DESC'
  | 'NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'NATURAL'
  | 'NEXT_OCCURRENCE_ASC'
  | 'NEXT_OCCURRENCE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PULSE_SURVEY_ANSWERS_BY_PULSE_SURVEY_ID__COUNT_ASC'
  | 'PULSE_SURVEY_ANSWERS_BY_PULSE_SURVEY_ID__COUNT_DESC'
  | 'PULSE_SURVEY_CHOICES_BY_PULSE_SURVEY_ID__COUNT_ASC'
  | 'PULSE_SURVEY_CHOICES_BY_PULSE_SURVEY_ID__COUNT_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__ACTIVE_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__ACTIVE_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__COMPANY_ID_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__COMPANY_ID_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__CREATED_AT_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__CREATED_AT_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__ID_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__ID_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__UPDATED_AT_ASC'
  | 'PULSE_TYPE_BY_PULSE_TYPE_ID__UPDATED_AT_DESC'
  | 'PULSE_TYPE_ID_ASC'
  | 'PULSE_TYPE_ID_DESC'
  | 'QUESTION_TRANSLATED_ENTITY_ID_ASC'
  | 'QUESTION_TRANSLATED_ENTITY_ID_DESC'
  | 'QUESTION_TYPE_ASC'
  | 'QUESTION_TYPE_DESC'
  | 'RATING_TYPE_ASC'
  | 'RATING_TYPE_DESC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__COMPANY_ID_ASC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__COMPANY_ID_DESC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__DAYS_OF_MONTH_ASC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__DAYS_OF_MONTH_DESC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__DAYS_OF_WEEK_ASC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__DAYS_OF_WEEK_DESC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__DAYS_OF_YEAR_ASC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__DAYS_OF_YEAR_DESC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__FREQUENCY_ASC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__FREQUENCY_DESC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__ID_ASC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__ID_DESC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__INTERVAL_ASC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__INTERVAL_DESC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__MAX_NUMBER_OF_OCCURENCES_ASC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__MAX_NUMBER_OF_OCCURENCES_DESC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__MONTHS_OF_YEAR_ASC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__MONTHS_OF_YEAR_DESC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__PULSE_SURVEY_ID_ASC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__PULSE_SURVEY_ID_DESC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__SET_POSITION_ASC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__SET_POSITION_DESC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__WEEKS_OF_YEAR_ASC'
  | 'RECURRENCE_RULE_BY_PULSE_SURVEY_ID__WEEKS_OF_YEAR_DESC'
  | 'REMINDERS_ASC'
  | 'REMINDERS_DESC'
  | 'START_DATE_ASC'
  | 'START_DATE_DESC'
  | 'SURVEY_TIME_ASC'
  | 'SURVEY_TIME_DESC'
  | 'TIMEZONE_NAME_ASC'
  | 'TIMEZONE_NAME_DESC'
  | 'TRANSLATED_ENTITY_BY_HIGHEST_RATING_LABEL_TRANSLATED_ENTITY_ID__COMPANY_ID_ASC'
  | 'TRANSLATED_ENTITY_BY_HIGHEST_RATING_LABEL_TRANSLATED_ENTITY_ID__COMPANY_ID_DESC'
  | 'TRANSLATED_ENTITY_BY_HIGHEST_RATING_LABEL_TRANSLATED_ENTITY_ID__ID_ASC'
  | 'TRANSLATED_ENTITY_BY_HIGHEST_RATING_LABEL_TRANSLATED_ENTITY_ID__ID_DESC'
  | 'TRANSLATED_ENTITY_BY_LOWEST_RATING_LABEL_TRANSLATED_ENTITY_ID__COMPANY_ID_ASC'
  | 'TRANSLATED_ENTITY_BY_LOWEST_RATING_LABEL_TRANSLATED_ENTITY_ID__COMPANY_ID_DESC'
  | 'TRANSLATED_ENTITY_BY_LOWEST_RATING_LABEL_TRANSLATED_ENTITY_ID__ID_ASC'
  | 'TRANSLATED_ENTITY_BY_LOWEST_RATING_LABEL_TRANSLATED_ENTITY_ID__ID_DESC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__COMPANY_ID_ASC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__COMPANY_ID_DESC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__ID_ASC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__ID_DESC'
  | 'TRANSLATED_ENTITY_BY_QUESTION_TRANSLATED_ENTITY_ID__COMPANY_ID_ASC'
  | 'TRANSLATED_ENTITY_BY_QUESTION_TRANSLATED_ENTITY_ID__COMPANY_ID_DESC'
  | 'TRANSLATED_ENTITY_BY_QUESTION_TRANSLATED_ENTITY_ID__ID_ASC'
  | 'TRANSLATED_ENTITY_BY_QUESTION_TRANSLATED_ENTITY_ID__ID_DESC';

export type PulseType = {
  __typename?: 'PulseType';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `PulseType`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  localizedName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseType`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  nameTranslatedEntityId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `PulseSurveyAnswer`. */
  pulseSurveyAnswers: PulseSurveyAnswersConnection;
  /** Reads and enables pagination through a set of `PulseSurveyChoice`. */
  pulseSurveyChoices: PulseSurveyChoicesConnection;
  /** Reads and enables pagination through a set of `PulseSurvey`. */
  pulseSurveys: PulseSurveysConnection;
  updatedAt: Scalars['Datetime'];
};


export type PulseTypePulseSurveyAnswersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseSurveyAnswerCondition>;
  filter?: InputMaybe<PulseSurveyAnswerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseSurveyAnswersOrderBy>>;
};


export type PulseTypePulseSurveyChoicesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseSurveyChoiceCondition>;
  filter?: InputMaybe<PulseSurveyChoiceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseSurveyChoicesOrderBy>>;
};


export type PulseTypePulseSurveysArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseSurveyCondition>;
  filter?: InputMaybe<PulseSurveyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseSurveysOrderBy>>;
};

/** The `pulseType` to be created by this mutation. */
export type PulseTypeCompanyIdForeignConnectionPulseTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PulseTypeCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseTypeIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseTypeIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyPulseTypeIdForeignInverseInput>;
  translatedEntity?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `company` in the `PulseTypeInput` mutation. */
export type PulseTypeCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnPulseTypeForPulseTypeCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `pulseType` in the `CompanyInput` mutation. */
export type PulseTypeCompanyIdForeignInverseInput = {
  /** The primary key(s) for `pulseType` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PulseTypePulseTypePkeyConnect>>;
  /** A `PulseTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PulseTypeCompanyIdForeignConnectionPulseTypeCreateInput>>;
  /** The primary key(s) for `pulseType` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PulseTypePulseTypePkeyDelete>>;
  /** Flag indicating whether all other `pulseType` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `pulseType` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PulseTypeOnPulseTypeForPulseTypeCompanyIdForeignUsingPulseTypePkeyUpdate>>;
};

/**
 * A condition to be used against `PulseType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PulseTypeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameTranslatedEntityId` field. */
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `PulseType` object types. All fields are combined with a logical ‘and.’ */
export type PulseTypeFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PulseTypeFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameTranslatedEntity` relation. */
  nameTranslatedEntity?: InputMaybe<TranslatedEntityFilter>;
  /** A related `nameTranslatedEntity` exists. */
  nameTranslatedEntityExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `nameTranslatedEntityId` field. */
  nameTranslatedEntityId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PulseTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PulseTypeFilter>>;
  /** Filter by the object’s `pulseSurveyAnswers` relation. */
  pulseSurveyAnswers?: InputMaybe<PulseTypeToManyPulseSurveyAnswerFilter>;
  /** Some related `pulseSurveyAnswers` exist. */
  pulseSurveyAnswersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseSurveyChoices` relation. */
  pulseSurveyChoices?: InputMaybe<PulseTypeToManyPulseSurveyChoiceFilter>;
  /** Some related `pulseSurveyChoices` exist. */
  pulseSurveyChoicesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseSurveys` relation. */
  pulseSurveys?: InputMaybe<PulseTypeToManyPulseSurveyFilter>;
  /** Some related `pulseSurveys` exist. */
  pulseSurveysExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `PulseType` */
export type PulseTypeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PulseTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseTypeIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseTypeIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyPulseTypeIdForeignInverseInput>;
  translatedEntity?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `translatedEntity` in the `PulseTypeInput` mutation. */
export type PulseTypeNameTranslatedEntityIdForeignInput = {
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  connectById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyConnect>;
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  deleteById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyDelete>;
  /** The primary key(s) and patch data for `translatedEntity` for the far side of the relationship. */
  updateById?: InputMaybe<TranslatedEntityOnPulseTypeForPulseTypeNameTranslatedEntityIdForeignUsingTranslatedEntityPkeyUpdate>;
};

/** Input for the nested mutation of `pulseType` in the `TranslatedEntityInput` mutation. */
export type PulseTypeNameTranslatedEntityIdForeignInverseInput = {
  /** The primary key(s) for `pulseType` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PulseTypePulseTypePkeyConnect>>;
  /** The primary key(s) for `pulseType` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PulseTypePulseTypePkeyDelete>>;
  /** Flag indicating whether all other `pulseType` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `pulseType` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PulseTypeOnPulseTypeForPulseTypeNameTranslatedEntityIdForeignUsingPulseTypePkeyUpdate>>;
};

/** The fields on `pulseType` to look up the row to update. */
export type PulseTypeOnPulseSurveyAnswerForPulseSurveyAnswerPulseTypeIdForeignUsingPulseTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseType` being updated. */
  patch: UpdatePulseTypeOnPulseSurveyAnswerForPulseSurveyAnswerPulseTypeIdForeignPatch;
};

/** The fields on `pulseType` to look up the row to update. */
export type PulseTypeOnPulseSurveyChoiceForPulseSurveyChoicePulseTypeIdForeignUsingPulseTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseType` being updated. */
  patch: UpdatePulseTypeOnPulseSurveyChoiceForPulseSurveyChoicePulseTypeIdForeignPatch;
};

/** The fields on `pulseType` to look up the row to update. */
export type PulseTypeOnPulseSurveyForPulseSurveyPulseTypeIdForeignUsingPulseTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseType` being updated. */
  patch: UpdatePulseTypeOnPulseSurveyForPulseSurveyPulseTypeIdForeignPatch;
};

/** The fields on `pulseType` to look up the row to update. */
export type PulseTypeOnPulseTypeForPulseTypeCompanyIdForeignUsingPulseTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseType` being updated. */
  patch: UpdatePulseTypeOnPulseTypeForPulseTypeCompanyIdForeignPatch;
};

/** The fields on `pulseType` to look up the row to update. */
export type PulseTypeOnPulseTypeForPulseTypeNameTranslatedEntityIdForeignUsingPulseTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `pulseType` being updated. */
  patch: UpdatePulseTypeOnPulseTypeForPulseTypeNameTranslatedEntityIdForeignPatch;
};

/** Represents an update to a `PulseType`. Fields that are set will be updated. */
export type PulseTypePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PulseTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseTypeIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseTypeIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyPulseTypeIdForeignInverseInput>;
  translatedEntity?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `pulseType` to look up the row to connect. */
export type PulseTypePulseTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `pulseType` to look up the row to delete. */
export type PulseTypePulseTypePkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `PulseSurveyAnswer` object types. All fields are combined with a logical ‘and.’ */
export type PulseTypeToManyPulseSurveyAnswerFilter = {
  /** Every related `PulseSurveyAnswer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PulseSurveyAnswerFilter>;
  /** No related `PulseSurveyAnswer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PulseSurveyAnswerFilter>;
  /** Some related `PulseSurveyAnswer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PulseSurveyAnswerFilter>;
};

/** A filter to be used against many `PulseSurveyChoice` object types. All fields are combined with a logical ‘and.’ */
export type PulseTypeToManyPulseSurveyChoiceFilter = {
  /** Every related `PulseSurveyChoice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PulseSurveyChoiceFilter>;
  /** No related `PulseSurveyChoice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PulseSurveyChoiceFilter>;
  /** Some related `PulseSurveyChoice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PulseSurveyChoiceFilter>;
};

/** A filter to be used against many `PulseSurvey` object types. All fields are combined with a logical ‘and.’ */
export type PulseTypeToManyPulseSurveyFilter = {
  /** Every related `PulseSurvey` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PulseSurveyFilter>;
  /** No related `PulseSurvey` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PulseSurveyFilter>;
  /** Some related `PulseSurvey` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PulseSurveyFilter>;
};

/** A connection to a list of `PulseType` values. */
export type PulseTypesConnection = {
  __typename?: 'PulseTypesConnection';
  /** A list of edges which contains the `PulseType` and cursor to aid in pagination. */
  edges: Array<PulseTypesEdge>;
  /** A list of `PulseType` objects. */
  nodes: Array<Maybe<PulseType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PulseType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PulseType` edge in the connection. */
export type PulseTypesEdge = {
  __typename?: 'PulseTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PulseType` at the end of the edge. */
  node?: Maybe<PulseType>;
};

/** Methods to use when ordering `PulseType`. */
export type PulseTypesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALIZED_NAME_ASC'
  | 'LOCALIZED_NAME_DESC'
  | 'NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PULSE_SURVEYS_BY_PULSE_TYPE_ID__COUNT_ASC'
  | 'PULSE_SURVEYS_BY_PULSE_TYPE_ID__COUNT_DESC'
  | 'PULSE_SURVEY_ANSWERS_BY_PULSE_TYPE_ID__COUNT_ASC'
  | 'PULSE_SURVEY_ANSWERS_BY_PULSE_TYPE_ID__COUNT_DESC'
  | 'PULSE_SURVEY_CHOICES_BY_PULSE_TYPE_ID__COUNT_ASC'
  | 'PULSE_SURVEY_CHOICES_BY_PULSE_TYPE_ID__COUNT_DESC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__COMPANY_ID_ASC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__COMPANY_ID_DESC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__ID_ASC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__ID_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

export type PushToken = {
  __typename?: 'PushToken';
  createdAt: Scalars['Datetime'];
  token?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `PushToken`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/**
 * A condition to be used against `PushToken` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PushTokenCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `token` field. */
  token?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `PushToken` object types. All fields are combined with a logical ‘and.’ */
export type PushTokenFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PushTokenFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PushTokenFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PushTokenFilter>>;
  /** Filter by the object’s `token` field. */
  token?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `pushToken` to look up the row to update. */
export type PushTokenOnPushTokenForPushTokenUserIdForeignUsingPushTokenUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `pushToken` being updated. */
  patch: UpdatePushTokenOnPushTokenForPushTokenUserIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `pushToken` to look up the row to connect. */
export type PushTokenPushTokenUserIdUniqueConnect = {
  userId: Scalars['UUID'];
};

/** Input for the nested mutation of `user` in the `PushTokenInput` mutation. */
export type PushTokenUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnPushTokenForPushTokenUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `pushToken` in the `UserInput` mutation. */
export type PushTokenUserIdForeignInverseInput = {
  /** The primary key(s) for `pushToken` for the far side of the relationship. */
  connectByUserId?: InputMaybe<PushTokenPushTokenUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `pushToken` for the far side of the relationship. */
  updateByUserId?: InputMaybe<PushTokenOnPushTokenForPushTokenUserIdForeignUsingPushTokenUserIdUniqueUpdate>;
};

/** A connection to a list of `PushToken` values. */
export type PushTokensConnection = {
  __typename?: 'PushTokensConnection';
  /** A list of edges which contains the `PushToken` and cursor to aid in pagination. */
  edges: Array<PushTokensEdge>;
  /** A list of `PushToken` objects. */
  nodes: Array<Maybe<PushToken>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PushToken` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PushToken` edge in the connection. */
export type PushTokensEdge = {
  __typename?: 'PushTokensEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PushToken` at the end of the edge. */
  node?: Maybe<PushToken>;
};

/** Methods to use when ordering `PushToken`. */
export type PushTokensOrderBy =
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'NATURAL'
  | 'TOKEN_ASC'
  | 'TOKEN_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** The root query type which gives access points into the data universe. */
export type Query = {
  __typename?: 'Query';
  AnalyseImportEmployeesFromFile?: Maybe<AnalyseImportEmployeesFromFilePayload>;
  AnalyseImportEquipmentFromFile?: Maybe<AnalyseImportEquipmentFromFilePayload>;
  DownloadEmployeesFile?: Maybe<DownloadEmployeesFilePayload>;
  DownloadEquipmentFile?: Maybe<DownloadEquipmentFilePayload>;
  ExportEquipmentToExcel?: Maybe<ExportEquipmentPayload>;
  GetZenegyTokens?: Maybe<Jwt>;
  GoogleFonts?: Maybe<GoogleFontsPayload>;
  affectedPostsCountOnPostTypeDelete: Scalars['Int'];
  allApplications?: Maybe<ApplicationConnection>;
  analyseCsvEmployeeRecordUpdateFile?: Maybe<AnalyseCsvEmployeeRecordUpdateFilePayload>;
  analyseCsvEmployeeUpdateFile?: Maybe<AnalyseCsvEmployeeUpdateFilePayload>;
  /** Reads and enables pagination through a set of `User`. */
  anniversaryUsers?: Maybe<UsersConnection>;
  announcementById?: Maybe<Announcement>;
  /** Reads and enables pagination through a set of `Announcement`. */
  announcements?: Maybe<AnnouncementsConnection>;
  application?: Maybe<ApplicationPayload>;
  approvalById?: Maybe<Approval>;
  /** Reads and enables pagination through a set of `Approval`. */
  approvals?: Maybe<ApprovalsConnection>;
  asyncJobById?: Maybe<AsyncJob>;
  asyncJobItemById?: Maybe<AsyncJobItem>;
  /** Reads and enables pagination through a set of `AsyncJobItem`. */
  asyncJobItems?: Maybe<AsyncJobItemsConnection>;
  /** Reads and enables pagination through a set of `AsyncJob`. */
  asyncJobs?: Maybe<AsyncJobsConnection>;
  /** Reads and enables pagination through a set of `Attendee`. */
  attendeesByEventId?: Maybe<AttendeesConnection>;
  authAppById?: Maybe<AuthApp>;
  authAppTypeById?: Maybe<AuthAppType>;
  /** Reads and enables pagination through a set of `AuthAppType`. */
  authAppTypes?: Maybe<AuthAppTypesConnection>;
  /** Reads and enables pagination through a set of `AuthApp`. */
  authApps?: Maybe<AuthAppsConnection>;
  authCodeById?: Maybe<AuthCode>;
  /** Reads and enables pagination through a set of `AuthCode`. */
  authCodes?: Maybe<AuthCodesConnection>;
  averageAge?: Maybe<Scalars['Int']>;
  averageSeniority?: Maybe<Scalars['Float']>;
  /** Reads and enables pagination through a set of `User`. */
  birthdayUsers?: Maybe<UsersConnection>;
  changelogById?: Maybe<Changelog>;
  changelogUserByChangelogIdAndUserId?: Maybe<ChangelogUser>;
  /** Reads and enables pagination through a set of `ChangelogUser`. */
  changelogUsers?: Maybe<ChangelogUsersConnection>;
  /** Reads and enables pagination through a set of `Changelog`. */
  changelogs?: Maybe<ChangelogsConnection>;
  channelTypeById?: Maybe<ChannelType>;
  channelTypeByName?: Maybe<ChannelType>;
  /** Reads and enables pagination through a set of `ChannelType`. */
  channelTypes?: Maybe<ChannelTypesConnection>;
  chosenColumnByUserIdAndTableName?: Maybe<ChosenColumn>;
  /** Reads and enables pagination through a set of `ChosenColumn`. */
  chosenColumns?: Maybe<ChosenColumnsConnection>;
  communicationLogs?: Maybe<CommunicationLogResponse>;
  /** Reads and enables pagination through a set of `Company`. */
  companies?: Maybe<CompaniesConnection>;
  companyBindingByCompanyIdAndLegacyCompanyId?: Maybe<CompanyBinding>;
  /** Reads and enables pagination through a set of `CompanyBinding`. */
  companyBindings?: Maybe<CompanyBindingsConnection>;
  companyById?: Maybe<Company>;
  companyCompanyTypeByCompanyId?: Maybe<CompanyCompanyType>;
  /** Reads and enables pagination through a set of `CompanyCompanyType`. */
  companyCompanyTypes?: Maybe<CompanyCompanyTypesConnection>;
  companySettingByCompanyIdAndKey?: Maybe<CompanySetting>;
  companySettingById?: Maybe<CompanySetting>;
  /** Reads and enables pagination through a set of `CompanySetting`. */
  companySettings?: Maybe<CompanySettingsConnection>;
  companySystemFieldById?: Maybe<CompanySystemField>;
  companySystemFieldBySystemFieldIdAndCompanyId?: Maybe<CompanySystemField>;
  companySystemFieldOptionById?: Maybe<CompanySystemFieldOption>;
  /** Reads and enables pagination through a set of `CompanySystemFieldOption`. */
  companySystemFieldOptions?: Maybe<CompanySystemFieldOptionsConnection>;
  /** Reads and enables pagination through a set of `CompanySystemField`. */
  companySystemFields?: Maybe<CompanySystemFieldsConnection>;
  companyTypeById?: Maybe<CompanyType>;
  /** Reads and enables pagination through a set of `CompanyType`. */
  companyTypes?: Maybe<CompanyTypesConnection>;
  competenceById?: Maybe<Competence>;
  competenceFormFieldById?: Maybe<CompetenceFormField>;
  /** Reads and enables pagination through a set of `CompetenceFormField`. */
  competenceFormFields?: Maybe<CompetenceFormFieldsConnection>;
  competenceGroupById?: Maybe<CompetenceGroup>;
  /** Reads and enables pagination through a set of `CompetenceGroup`. */
  competenceGroups?: Maybe<CompetenceGroupsConnection>;
  competenceRequestById?: Maybe<CompetenceRequest>;
  /** Reads and enables pagination through a set of `CompetenceRequest`. */
  competenceRequests?: Maybe<CompetenceRequestsConnection>;
  /** Reads and enables pagination through a set of `Competence`. */
  competences?: Maybe<CompetencesConnection>;
  competencesSearch?: Maybe<CompetencesSearchPayload>;
  contractPredefinedPlaceholderById?: Maybe<ContractPredefinedPlaceholder>;
  /** Reads and enables pagination through a set of `ContractPredefinedPlaceholder`. */
  contractPredefinedPlaceholders?: Maybe<ContractPredefinedPlaceholdersConnection>;
  contractSignPendingById?: Maybe<ContractSignPending>;
  contractSignPendingDocumentById?: Maybe<ContractSignPendingDocument>;
  /** Reads and enables pagination through a set of `ContractSignPendingDocument`. */
  contractSignPendingDocuments?: Maybe<ContractSignPendingDocumentsConnection>;
  contractSignPendingSignerByContractSignPendingIdAndUserId?: Maybe<ContractSignPendingSigner>;
  contractSignPendingSignerById?: Maybe<ContractSignPendingSigner>;
  /** Reads and enables pagination through a set of `ContractSignPendingSigner`. */
  contractSignPendingSigners?: Maybe<ContractSignPendingSignersConnection>;
  /** Reads and enables pagination through a set of `ContractSignPending`. */
  contractSignPendings?: Maybe<ContractSignPendingsConnection>;
  /** Reads and enables pagination through a set of `ContractSignPending`. */
  contractSignPendingsByEmployeeId?: Maybe<ContractSignPendingsConnection>;
  contractTemplateById?: Maybe<ContractTemplate>;
  contractTemplateDepartmentByContractTemplateIdAndDepartmentId?: Maybe<ContractTemplateDepartment>;
  /** Reads and enables pagination through a set of `ContractTemplateDepartment`. */
  contractTemplateDepartments?: Maybe<ContractTemplateDepartmentsConnection>;
  /** Reads and enables pagination through a set of `ContractTemplateFormField`. */
  contractTemplateFormFields?: Maybe<ContractTemplateFormFieldsConnection>;
  contractTemplateUserByUserIdAndContractTemplateId?: Maybe<ContractTemplateUser>;
  /** Reads and enables pagination through a set of `ContractTemplateUser`. */
  contractTemplateUsers?: Maybe<ContractTemplateUsersConnection>;
  /** Reads and enables pagination through a set of `ContractTemplate`. */
  contractTemplates?: Maybe<ContractTemplatesConnection>;
  countryOptionsInUse?: Maybe<CountryOptionsInUseConnection>;
  currentSuperUserCompanyId?: Maybe<Scalars['UUID']>;
  customWidgetById?: Maybe<CustomWidget>;
  customWidgetContentById?: Maybe<CustomWidgetContent>;
  /** Reads and enables pagination through a set of `CustomWidgetContent`. */
  customWidgetContents?: Maybe<CustomWidgetContentsConnection>;
  /** Reads and enables pagination through a set of `CustomWidget`. */
  customWidgets?: Maybe<CustomWidgetsConnection>;
  cvTemplateFieldMappingById?: Maybe<CvTemplateFieldMapping>;
  /** Reads and enables pagination through a set of `CvTemplateFieldMapping`. */
  cvTemplateFieldMappings?: Maybe<CvTemplateFieldMappingsConnection>;
  cvTemplateFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  dashboardCardById?: Maybe<DashboardCard>;
  dashboardCardChart?: Maybe<DashboardCardChartPayload>;
  dashboardCardStatisticById?: Maybe<DashboardCardStatistic>;
  /** Reads and enables pagination through a set of `DashboardCardStatistic`. */
  dashboardCardStatistics?: Maybe<DashboardCardStatisticsConnection>;
  /** Reads and enables pagination through a set of `DashboardCard`. */
  dashboardCards?: Maybe<DashboardCardsConnection>;
  dashboardConfigByCompanyId?: Maybe<DashboardConfig>;
  /** Reads and enables pagination through a set of `DashboardConfig`. */
  dashboardConfigs?: Maybe<DashboardConfigsConnection>;
  dashboardViewById?: Maybe<DashboardView>;
  /** Reads and enables pagination through a set of `DashboardView`. */
  dashboardViews?: Maybe<DashboardViewsConnection>;
  departmentById?: Maybe<Department>;
  departmentEmployeeHierarchy?: Maybe<DepartmentEmployeeHierarchyConnection>;
  departmentTreeItem?: Maybe<Scalars['JSON']>;
  departmentTypeById?: Maybe<DepartmentType>;
  /** Reads and enables pagination through a set of `DepartmentType`. */
  departmentTypes?: Maybe<DepartmentTypesConnection>;
  departmentUserItems?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `Department`. */
  departments?: Maybe<DepartmentsConnection>;
  /** Reads and enables pagination through a set of `Department`. */
  departmentsSortByFormField?: Maybe<DepartmentsConnection>;
  /** Reads and enables pagination through a set of `User`. */
  directManagers?: Maybe<UsersConnection>;
  documentDepartmentPermissionByFileIdAndDepartmentId?: Maybe<DocumentDepartmentPermission>;
  /** Reads and enables pagination through a set of `DocumentDepartmentPermission`. */
  documentDepartmentPermissions?: Maybe<DocumentDepartmentPermissionsConnection>;
  documentFolderBlueprintAffectedFiles?: Maybe<DocumentFolderBlueprintDependant>;
  documentFolderBlueprintById?: Maybe<DocumentFolderBlueprint>;
  /** Reads and enables pagination through a set of `DocumentFolderBlueprint`. */
  documentFolderBlueprints?: Maybe<DocumentFolderBlueprintsConnection>;
  documentFolderById?: Maybe<DocumentFolder>;
  documentFolderDepartmentByDocumentFolderIdAndDepartmentId?: Maybe<DocumentFolderDepartment>;
  /** Reads and enables pagination through a set of `DocumentFolderDepartment`. */
  documentFolderDepartments?: Maybe<DocumentFolderDepartmentsConnection>;
  documentFolderUserByDocumentFolderIdAndUserId?: Maybe<DocumentFolderUser>;
  /** Reads and enables pagination through a set of `DocumentFolderUser`. */
  documentFolderUsers?: Maybe<DocumentFolderUsersConnection>;
  /** Reads and enables pagination through a set of `DocumentFolder`. */
  documentFolders?: Maybe<DocumentFoldersConnection>;
  documentFoldersWithPath?: Maybe<DocumentFoldersWithPathConnection>;
  documentTypeByCompanyIdAndDepartmentIdAndName?: Maybe<DocumentType>;
  documentTypeById?: Maybe<DocumentType>;
  /** Reads and enables pagination through a set of `DocumentType`. */
  documentTypes?: Maybe<DocumentTypesConnection>;
  documentUserPermissionByFileIdAndUserId?: Maybe<DocumentUserPermission>;
  /** Reads and enables pagination through a set of `DocumentUserPermission`. */
  documentUserPermissions?: Maybe<DocumentUserPermissionsConnection>;
  /** Reads and enables pagination through a set of `DocumentUserResponsible`. */
  documentUserResponsibleByFileId?: Maybe<DocumentUserResponsiblesConnection>;
  documentUserResponsibleByFileIdAndUserId?: Maybe<DocumentUserResponsible>;
  /** Reads and enables pagination through a set of `DocumentUserResponsible`. */
  documentUserResponsibleByUserId?: Maybe<DocumentUserResponsiblesConnection>;
  /** Reads and enables pagination through a set of `DocumentUserResponsible`. */
  documentUserResponsibles?: Maybe<DocumentUserResponsiblesConnection>;
  downloadEmployeeRecordUpdateTemplate?: Maybe<DownloadEmployeeRecordUpdateTemplatePayload>;
  employeeBelongsToDepartment?: Maybe<Scalars['Boolean']>;
  employeeById?: Maybe<Employee>;
  employeeByUserId?: Maybe<Employee>;
  employeeCasefileByEmployeeIdAndCasefileId?: Maybe<EmployeeCasefile>;
  employeeCasefileById?: Maybe<EmployeeCasefile>;
  /** Reads and enables pagination through a set of `EmployeeCasefile`. */
  employeeCasefiles?: Maybe<EmployeeCasefilesConnection>;
  /** Reads and enables pagination through a set of `EmployeeCasefile`. */
  employeeCasefilesSearch?: Maybe<EmployeeCasefilesConnection>;
  /** Reads and enables pagination through a set of `Storage`. */
  employeeDocuments?: Maybe<StoragesConnection>;
  employeeExternalIntegrationByEmployeeIdAndExternalIntegrationId?: Maybe<EmployeeExternalIntegration>;
  employeeExternalIntegrationBySameSystem?: Maybe<EmployeeExternalIntegration>;
  /** Reads and enables pagination through a set of `EmployeeExternalIntegration`. */
  employeeExternalIntegrations?: Maybe<EmployeeExternalIntegrationsConnection>;
  employeeHierarchyItem?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `Employee`. */
  employeeOrderedByLatestMessage?: Maybe<EmployeesConnection>;
  /** Reads and enables pagination through a set of `Storage`. */
  employeeResponsibleDocuments?: Maybe<StoragesConnection>;
  /** Reads and enables pagination through a set of `Employee`. */
  employees?: Maybe<EmployeesConnection>;
  engagementTypeById?: Maybe<EngagementType>;
  /** Reads and enables pagination through a set of `EngagementType`. */
  engagementTypes?: Maybe<EngagementTypesConnection>;
  equipmentById?: Maybe<Equipment>;
  /** Reads and enables pagination through a set of `Equipment`. */
  equipments?: Maybe<EquipmentConnection>;
  eventById?: Maybe<Event>;
  eventUserByEventIdAndUserId?: Maybe<EventUser>;
  eventUserById?: Maybe<EventUser>;
  /** Reads and enables pagination through a set of `Event`. */
  events?: Maybe<EventsConnection>;
  exportCompetencesToExcel?: Maybe<ExportCompetencesToExcelPayload>;
  exportDashboardCardToExcel?: Maybe<ExportDashboardCardToExcelPayload>;
  exportDepartmentsToExcel?: Maybe<ExportDepartmentsToExcelPayload>;
  exportDocumentsToExcel?: Maybe<ExportDocumentsToExcelPayload>;
  exportEmployeesToExcel?: Maybe<ExportEmployeesToExcelPayload>;
  exportFieldLogToExcel?: Maybe<ExportFieldLogToExcelPayload>;
  exportPreboardingResultsToExcel?: Maybe<ExportPreboardingResultsToExcelPayload>;
  exportVacationToExcel?: Maybe<ExportVacationToExcelPayload>;
  externalIntegrationById?: Maybe<ExternalIntegration>;
  /** Reads and enables pagination through a set of `ExternalIntegration`. */
  externalIntegrations?: Maybe<ExternalIntegrationsConnection>;
  externalSystemById?: Maybe<ExternalSystem>;
  /** Reads and enables pagination through a set of `ExternalSystem`. */
  externalSystems?: Maybe<ExternalSystemsConnection>;
  fieldGroupById?: Maybe<FieldGroup>;
  fieldGroupCardById?: Maybe<FieldGroupCard>;
  fieldGroupCardColumnById?: Maybe<FieldGroupCardColumn>;
  /** Reads and enables pagination through a set of `FieldGroupCardColumn`. */
  fieldGroupCardColumns?: Maybe<FieldGroupCardColumnsConnection>;
  /** Reads and enables pagination through a set of `FieldGroupCard`. */
  fieldGroupCards?: Maybe<FieldGroupCardsConnection>;
  /** Reads and enables pagination through a set of `FieldGroup`. */
  fieldGroups?: Maybe<FieldGroupsConnection>;
  filterPresetById?: Maybe<FilterPreset>;
  /** Reads and enables pagination through a set of `FilterPreset`. */
  filterPresets?: Maybe<FilterPresetsConnection>;
  filterViewById?: Maybe<FilterView>;
  /** Reads and enables pagination through a set of `FilterView`. */
  filterViews?: Maybe<FilterViewsConnection>;
  formFieldAgreementByFormFieldId?: Maybe<FormFieldAgreement>;
  formFieldAgreementById?: Maybe<FormFieldAgreement>;
  /** Reads and enables pagination through a set of `FormFieldAgreement`. */
  formFieldAgreements?: Maybe<FormFieldAgreementsConnection>;
  formFieldById?: Maybe<FormField>;
  /** Reads and enables pagination through a set of `FormFieldEntry`. */
  formFieldEntries?: Maybe<FormFieldEntriesConnection>;
  /** Reads and enables pagination through a set of `FormFieldEntry`. */
  formFieldEntryByEmployeeId?: Maybe<FormFieldEntriesConnection>;
  formFieldEntryById?: Maybe<FormFieldEntry>;
  formFieldEntryCount?: Maybe<FormFieldEntryCountConnection>;
  formFieldOptionById?: Maybe<FormFieldOption>;
  /** Reads and enables pagination through a set of `FormFieldOption`. */
  formFieldOptions?: Maybe<FormFieldOptionsConnection>;
  formFieldStatistics?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  /** Reads and enables pagination through a set of `FormField`. */
  formFields?: Maybe<FormFieldsConnection>;
  froalaStyleById?: Maybe<FroalaStyle>;
  /** Reads and enables pagination through a set of `FroalaStyle`. */
  froalaStyles?: Maybe<FroalaStylesConnection>;
  /** Reads and enables pagination through a set of `FutureDatum`. */
  futureData?: Maybe<FutureDataConnection>;
  futureDataFieldsInUse?: Maybe<FutureDataFieldsInUseConnection>;
  futureDatumByApprovalId?: Maybe<FutureDatum>;
  futureDatumById?: Maybe<FutureDatum>;
  getAuthApp?: Maybe<GetAuthAppPayload>;
  getAuthApps?: Maybe<GetAuthAppsPayload>;
  getCompanyByEmployeeId?: Maybe<Scalars['UUID']>;
  getCompanyByUserId?: Maybe<Scalars['UUID']>;
  getCompanyIdByUserId?: Maybe<Scalars['UUID']>;
  getCompanyPublicSso?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Log`. */
  getDeletionLog?: Maybe<LogsConnection>;
  /** Reads and enables pagination through a set of `Department`. */
  getDepartmentDescendants?: Maybe<DepartmentsConnection>;
  /** Reads and enables pagination through a set of `User`. */
  getDepartmentLeaders?: Maybe<UsersConnection>;
  getDepartmentLeadersCount?: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `Role`. */
  getDependingRoles?: Maybe<RolesConnection>;
  getDirectManagerBasicInfo?: Maybe<GetDirectManagerBasicInfoConnection>;
  /** Reads and enables pagination through a set of `LogEntry`. */
  getEmployeeCasefileLogs?: Maybe<LogEntriesConnection>;
  getEmployeeCsvFieldMapping?: Maybe<GetEmployeeCsvFieldMappingPayload>;
  /** Reads and enables pagination through a set of `LogEntry`. */
  getEmployeeLogs?: Maybe<LogEntriesConnection>;
  getEmployeesBasicInfo?: Maybe<GetEmployeesBasicInfoConnection>;
  /** Reads and enables pagination through a set of `User`. */
  getEquipmentOwners?: Maybe<UsersConnection>;
  getFieldLog?: Maybe<GetFieldLogPayload>;
  getGeneralHolidays?: Maybe<GetGeneralHolidaysPayload>;
  getLocalizedString?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Role`. */
  getMissingGroupRoles?: Maybe<RolesConnection>;
  getMyBadges?: Maybe<Scalars['JSON']>;
  getPlaceholdersWithInitialValues?: Maybe<GetPlaceholdersWithInitialValuesPayload>;
  /** Reads and enables pagination through a set of `LogEntry`. */
  getPreboardingEmployeeLogs?: Maybe<LogEntriesConnection>;
  getPulseSurveyChartData?: Maybe<GetPulseSurveyChartDataConnection>;
  getSecret?: Maybe<AuthAppPayload>;
  getSignedStorageByContractSignPendingDocumentId?: Maybe<StorageBase64Payload>;
  /** Reads and enables pagination through a set of `LogEntry`. */
  getSingleProcessLogs?: Maybe<LogEntriesConnection>;
  /** Reads and enables pagination through a set of `LogEntry`. */
  getStorageLogs?: Maybe<LogEntriesConnection>;
  getSupportedHolidayCountries?: Maybe<GetSupportedHolidayCountriesPayload>;
  /** Reads and enables pagination through a set of `PulseSurvey`. */
  getUnansweredPulseSurveys?: Maybe<PulseSurveysConnection>;
  getUserDirectManagerBasicInfo?: Maybe<SimpleUser>;
  /** Reads and enables pagination through a set of `User`. */
  getUsersByBirthdayMonth?: Maybe<UsersConnection>;
  /** Reads and enables pagination through a set of `User`. */
  getUsersBySeniorityMonth?: Maybe<UsersConnection>;
  getWorkHoursLogs?: Maybe<GetWorkHoursLogsConnection>;
  groupById?: Maybe<Group>;
  groupRoleByGroupIdAndRoleId?: Maybe<GroupRole>;
  /** Reads and enables pagination through a set of `GroupRole`. */
  groupRoles?: Maybe<GroupRolesConnection>;
  /** Reads and enables pagination through a set of `Group`. */
  groups?: Maybe<GroupsConnection>;
  hookById?: Maybe<Hook>;
  hookByName?: Maybe<Hook>;
  /** Reads and enables pagination through a set of `Hook`. */
  hooks?: Maybe<HooksConnection>;
  i18on?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `Group`. */
  inheritedDepartmentGroups?: Maybe<GroupsConnection>;
  intAddAbs?: Maybe<Scalars['Int']>;
  integrableSystemById?: Maybe<IntegrableSystem>;
  /** Reads and enables pagination through a set of `IntegrableSystem`. */
  integrableSystems?: Maybe<IntegrableSystemsConnection>;
  integrationFieldMarkingByCompanyIdAndExternalIntegrationIdAndFormFieldId?: Maybe<IntegrationFieldMarking>;
  integrationFieldMarkingByCompanyIdAndExternalIntegrationIdAndSystemFieldId?: Maybe<IntegrationFieldMarking>;
  integrationFieldMarkingById?: Maybe<IntegrationFieldMarking>;
  /** Reads and enables pagination through a set of `IntegrationFieldMarking`. */
  integrationFieldMarkings?: Maybe<IntegrationFieldMarkingsConnection>;
  jobPositionTitles?: Maybe<JobPositionTitlesConnection>;
  latestMessageByEmployeeId1AndEmployeeId2?: Maybe<LatestMessage>;
  latestMessageById?: Maybe<LatestMessage>;
  /** Reads and enables pagination through a set of `LatestMessage`. */
  latestMessages?: Maybe<LatestMessagesConnection>;
  loggedActionNoteById?: Maybe<LoggedActionNote>;
  /** Reads and enables pagination through a set of `LoggedActionNote`. */
  loggedActionNotes?: Maybe<LoggedActionNotesConnection>;
  loginLogById?: Maybe<LoginLog>;
  /** Reads and enables pagination through a set of `LoginLog`. */
  loginLogs?: Maybe<LoginLogsConnection>;
  messageById?: Maybe<Message>;
  /** Reads and enables pagination through a set of `MessageRecipient`. */
  messageRecipients?: Maybe<MessageRecipientsConnection>;
  /** Reads and enables pagination through a set of `Message`. */
  messageThread?: Maybe<MessagesConnection>;
  /** Reads and enables pagination through a set of `Message`. */
  messages?: Maybe<MessagesConnection>;
  notificationById?: Maybe<Notification>;
  notificationCustomEmployeeFieldRecipientById?: Maybe<NotificationCustomEmployeeFieldRecipient>;
  /** Reads and enables pagination through a set of `NotificationCustomEmployeeFieldRecipient`. */
  notificationCustomEmployeeFieldRecipients?: Maybe<NotificationCustomEmployeeFieldRecipientsConnection>;
  notificationCustomRecipientByNotificationIdAndEmployeeId?: Maybe<NotificationCustomRecipient>;
  /** Reads and enables pagination through a set of `NotificationCustomRecipient`. */
  notificationCustomRecipients?: Maybe<NotificationCustomRecipientsConnection>;
  notificationEmployeeById?: Maybe<NotificationEmployee>;
  notificationEmployeeReferenceById?: Maybe<NotificationEmployeeReference>;
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferences?: Maybe<NotificationEmployeeReferencesConnection>;
  /** Reads and enables pagination through a set of `NotificationEmployee`. */
  notificationEmployees?: Maybe<NotificationEmployeesConnection>;
  notificationGroupRecipientByNotificationIdAndGroupId?: Maybe<NotificationGroupRecipient>;
  /** Reads and enables pagination through a set of `NotificationGroupRecipient`. */
  notificationGroupRecipients?: Maybe<NotificationGroupRecipientsConnection>;
  notificationTypeById?: Maybe<NotificationType>;
  notificationTypeChannelTypeByNotificationTypeIdAndChannelTypeId?: Maybe<NotificationTypeChannelType>;
  /** Reads and enables pagination through a set of `NotificationTypeChannelType`. */
  notificationTypeChannelTypes?: Maybe<NotificationTypeChannelTypesConnection>;
  /** Reads and enables pagination through a set of `NotificationType`. */
  notificationTypes?: Maybe<NotificationTypesConnection>;
  /** Reads and enables pagination through a set of `Notification`. */
  notifications?: Maybe<NotificationsConnection>;
  openGraph?: Maybe<OpenGraph>;
  organizationDiagram?: Maybe<OrganizationDiagramConnection>;
  postById?: Maybe<Post>;
  postTypeById?: Maybe<PostType>;
  /** Reads and enables pagination through a set of `PostType`. */
  postTypes?: Maybe<PostTypesConnection>;
  /** Reads and enables pagination through a set of `Post`. */
  posts?: Maybe<PostsConnection>;
  preboardingById?: Maybe<Preboarding>;
  preboardingCommentById?: Maybe<PreboardingComment>;
  /** Reads and enables pagination through a set of `PreboardingComment`. */
  preboardingComments?: Maybe<PreboardingCommentsConnection>;
  preboardingEmailLogById?: Maybe<PreboardingEmailLog>;
  /** Reads and enables pagination through a set of `PreboardingEmailLog`. */
  preboardingEmailLogs?: Maybe<PreboardingEmailLogsConnection>;
  preboardingEmployeeById?: Maybe<PreboardingEmployee>;
  /** Reads and enables pagination through a set of `PreboardingEmployee`. */
  preboardingEmployees?: Maybe<PreboardingEmployeesConnection>;
  preboardingFormCacheByPreboardingIdAndUserId?: Maybe<PreboardingFormCache>;
  /** Reads and enables pagination through a set of `PreboardingFormCache`. */
  preboardingFormCaches?: Maybe<PreboardingFormCachesConnection>;
  preboardingProcessByPreboardingIdAndProcessId?: Maybe<PreboardingProcess>;
  /** Reads and enables pagination through a set of `PreboardingProcess`. */
  preboardingProcesses?: Maybe<PreboardingProcessesConnection>;
  preboardingResultById?: Maybe<PreboardingResult>;
  preboardingResultSlideCommentById?: Maybe<PreboardingResultSlideComment>;
  /** Reads and enables pagination through a set of `PreboardingResultSlideComment`. */
  preboardingResultSlideComments?: Maybe<PreboardingResultSlideCommentsConnection>;
  /** Reads and enables pagination through a set of `PreboardingResult`. */
  preboardingResults?: Maybe<PreboardingResultsConnection>;
  preboardingSlideById?: Maybe<PreboardingSlide>;
  preboardingSlideFormFieldById?: Maybe<PreboardingSlideFormField>;
  /** Reads and enables pagination through a set of `PreboardingSlideFormField`. */
  preboardingSlideFormFields?: Maybe<PreboardingSlideFormFieldsConnection>;
  /** Reads and enables pagination through a set of `PreboardingSlide`. */
  preboardingSlides?: Maybe<PreboardingSlidesConnection>;
  /** Reads and enables pagination through a set of `Preboarding`. */
  preboardings?: Maybe<PreboardingsConnection>;
  processById?: Maybe<Process>;
  /** Reads and enables pagination through a set of `ProcessDepartment`. */
  processDepartments?: Maybe<ProcessDepartmentsConnection>;
  /** Reads and enables pagination through a set of `ProcessEmployee`. */
  processEmployees?: Maybe<ProcessEmployeesConnection>;
  processResponsibleByProcessIdAndResponsibleId?: Maybe<ProcessResponsible>;
  /** Reads and enables pagination through a set of `ProcessResponsible`. */
  processResponsibles?: Maybe<ProcessResponsiblesConnection>;
  processTypeById?: Maybe<ProcessType>;
  /** Reads and enables pagination through a set of `ProcessType`. */
  processTypes?: Maybe<ProcessTypesConnection>;
  /** Reads and enables pagination through a set of `Process`. */
  processes?: Maybe<ProcessesConnection>;
  /** Reads and enables pagination through a set of `Process`. */
  processesOrderedByProgress?: Maybe<ProcessesConnection>;
  productById?: Maybe<Product>;
  productTypeByCompanyIdAndDepartmentIdAndName?: Maybe<ProductType>;
  productTypeById?: Maybe<ProductType>;
  /** Reads and enables pagination through a set of `ProductType`. */
  productTypes?: Maybe<ProductTypesConnection>;
  /** Reads and enables pagination through a set of `Product`. */
  products?: Maybe<ProductsConnection>;
  /** Reads and enables pagination through a set of `Product`. */
  productsSortByFormField?: Maybe<ProductsConnection>;
  projectById?: Maybe<Project>;
  projectTemplateById?: Maybe<ProjectTemplate>;
  /** Reads and enables pagination through a set of `ProjectTemplate`. */
  projectTemplates?: Maybe<ProjectTemplatesConnection>;
  /** Reads and enables pagination through a set of `Project`. */
  projects?: Maybe<ProjectsConnection>;
  pulseSurveyAnswerById?: Maybe<PulseSurveyAnswer>;
  pulseSurveyAnswerByUserIdAndPulseSurveyIdAndDate?: Maybe<PulseSurveyAnswer>;
  /** Reads and enables pagination through a set of `PulseSurveyAnswer`. */
  pulseSurveyAnswers?: Maybe<PulseSurveyAnswersConnection>;
  pulseSurveyById?: Maybe<PulseSurvey>;
  pulseSurveyChoiceById?: Maybe<PulseSurveyChoice>;
  /** Reads and enables pagination through a set of `PulseSurveyChoice`. */
  pulseSurveyChoices?: Maybe<PulseSurveyChoicesConnection>;
  /** Reads and enables pagination through a set of `PulseSurvey`. */
  pulseSurveys?: Maybe<PulseSurveysConnection>;
  pulseTypeById?: Maybe<PulseType>;
  /** Reads and enables pagination through a set of `PulseType`. */
  pulseTypes?: Maybe<PulseTypesConnection>;
  pushTokenByUserId?: Maybe<PushToken>;
  /** Reads and enables pagination through a set of `PushToken`. */
  pushTokens?: Maybe<PushTokensConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  rankById?: Maybe<Rank>;
  /** Reads and enables pagination through a set of `Rank`. */
  ranks?: Maybe<RanksConnection>;
  /** Reads and enables pagination through a set of `TimeRegistrationPresenceType`. */
  recentTimeRegistrationPresenceTypes?: Maybe<TimeRegistrationPresenceTypesConnection>;
  /** Reads and enables pagination through a set of `TimeRegistrationProject`. */
  recentTimeRegistrationProjects?: Maybe<TimeRegistrationProjectsConnection>;
  recruitCompanies?: Maybe<Array<Maybe<RecruitCompany>>>;
  recurrenceRuleById?: Maybe<RecurrenceRule>;
  recurrenceRuleByPulseSurveyId?: Maybe<RecurrenceRule>;
  /** Reads and enables pagination through a set of `RecurrenceRule`. */
  recurrenceRules?: Maybe<RecurrenceRulesConnection>;
  referenceTokenByToken?: Maybe<ReferenceToken>;
  /** Reads and enables pagination through a set of `ReferenceToken`. */
  referenceTokens?: Maybe<ReferenceTokensConnection>;
  relationRoleById?: Maybe<RelationRole>;
  /** Reads and enables pagination through a set of `RelationRole`. */
  relationRoles?: Maybe<RelationRolesConnection>;
  resetFormCompanies?: Maybe<ResetFormCompaniesConnection>;
  roadmapItemById?: Maybe<RoadmapItem>;
  roadmapItemCommentById?: Maybe<RoadmapItemComment>;
  /** Reads and enables pagination through a set of `RoadmapItemComment`. */
  roadmapItemComments?: Maybe<RoadmapItemCommentsConnection>;
  roadmapItemLocalizationById?: Maybe<RoadmapItemLocalization>;
  roadmapItemLocalizationByRoadmapItemIdAndLocale?: Maybe<RoadmapItemLocalization>;
  /** Reads and enables pagination through a set of `RoadmapItemLocalization`. */
  roadmapItemLocalizations?: Maybe<RoadmapItemLocalizationsConnection>;
  roadmapItemVoteById?: Maybe<RoadmapItemVote>;
  roadmapItemVoteByUserIdAndRoadmapItemId?: Maybe<RoadmapItemVote>;
  /** Reads and enables pagination through a set of `RoadmapItemVote`. */
  roadmapItemVotes?: Maybe<RoadmapItemVotesConnection>;
  /** Reads and enables pagination through a set of `RoadmapItem`. */
  roadmapItems?: Maybe<RoadmapItemsConnection>;
  roleById?: Maybe<Role>;
  /** Reads and enables pagination through a set of `RoleDependency`. */
  roleDependencies?: Maybe<RoleDependenciesConnection>;
  roleDependencyByRoleIdAndDependentOn?: Maybe<RoleDependency>;
  /** Reads and enables pagination through a set of `Role`. */
  roles?: Maybe<RolesConnection>;
  savedSignatureById?: Maybe<SavedSignature>;
  /** Reads and enables pagination through a set of `SavedSignature`. */
  savedSignatures?: Maybe<SavedSignaturesConnection>;
  scheduledMessageById?: Maybe<ScheduledMessage>;
  scheduledMessageExternalRecipientByScheduledMessageIdAndEmail?: Maybe<ScheduledMessageExternalRecipient>;
  /** Reads and enables pagination through a set of `ScheduledMessageExternalRecipient`. */
  scheduledMessageExternalRecipients?: Maybe<ScheduledMessageExternalRecipientsConnection>;
  scheduledMessageRecipientByScheduledMessageIdAndEmployeeId?: Maybe<ScheduledMessageRecipient>;
  /** Reads and enables pagination through a set of `ScheduledMessageRecipient`. */
  scheduledMessageRecipients?: Maybe<ScheduledMessageRecipientsConnection>;
  scheduledMessageTemplateById?: Maybe<ScheduledMessageTemplate>;
  scheduledMessageTemplateExternalRecipientByScheduledMessageTemplateIdAndEmail?: Maybe<ScheduledMessageTemplateExternalRecipient>;
  /** Reads and enables pagination through a set of `ScheduledMessageTemplateExternalRecipient`. */
  scheduledMessageTemplateExternalRecipients?: Maybe<ScheduledMessageTemplateExternalRecipientsConnection>;
  scheduledMessageTemplateRecipientByScheduledMessageTemplateIdAndEmployeeId?: Maybe<ScheduledMessageTemplateRecipient>;
  /** Reads and enables pagination through a set of `ScheduledMessageTemplateRecipient`. */
  scheduledMessageTemplateRecipients?: Maybe<ScheduledMessageTemplateRecipientsConnection>;
  /** Reads and enables pagination through a set of `ScheduledMessageTemplate`. */
  scheduledMessageTemplates?: Maybe<ScheduledMessageTemplatesConnection>;
  /** Reads and enables pagination through a set of `ScheduledMessage`. */
  scheduledMessages?: Maybe<ScheduledMessagesConnection>;
  storageById?: Maybe<Storage>;
  storageIdToDirectUrl?: Maybe<StorageDirectUrlPayload>;
  /** Reads and enables pagination through a set of `Storage`. */
  storages?: Maybe<StoragesConnection>;
  superUserAllowedUserById?: Maybe<SuperUserAllowedUser>;
  superUserAllowedUserBySuperUserIdAndCompanyId?: Maybe<SuperUserAllowedUser>;
  /** Reads and enables pagination through a set of `SuperUserAllowedUser`. */
  superUserAllowedUsers?: Maybe<SuperUserAllowedUsersConnection>;
  superUserById?: Maybe<SuperUser>;
  superUserByUserId?: Maybe<SuperUser>;
  superUserLoginNoteById?: Maybe<SuperUserLoginNote>;
  /** Reads and enables pagination through a set of `SuperUserLoginNote`. */
  superUserLoginNotes?: Maybe<SuperUserLoginNotesConnection>;
  /** Reads and enables pagination through a set of `SuperUser`. */
  superUsers?: Maybe<SuperUsersConnection>;
  systemFieldById?: Maybe<SystemField>;
  systemFieldByName?: Maybe<SystemField>;
  systemFieldTypeByType?: Maybe<SystemFieldType>;
  /** Reads and enables pagination through a set of `SystemFieldType`. */
  systemFieldTypes?: Maybe<SystemFieldTypesConnection>;
  /** Reads and enables pagination through a set of `SystemField`. */
  systemFields?: Maybe<SystemFieldsConnection>;
  /** Reads and enables pagination through a set of `Tableslist`. */
  tableslists?: Maybe<TableslistsConnection>;
  taskById?: Maybe<Task>;
  taskEmployeeByTaskIdAndEmployeeId?: Maybe<TaskEmployee>;
  /** Reads and enables pagination through a set of `TaskEmployee`. */
  taskEmployees?: Maybe<TaskEmployeesConnection>;
  taskResponsibleByTaskIdAndResponsibleId?: Maybe<TaskResponsible>;
  /** Reads and enables pagination through a set of `TaskResponsible`. */
  taskResponsibles?: Maybe<TaskResponsiblesConnection>;
  taskTemplateById?: Maybe<TaskTemplate>;
  taskTemplateEmployeeByTaskTemplateIdAndEmployeeId?: Maybe<TaskTemplateEmployee>;
  /** Reads and enables pagination through a set of `TaskTemplateEmployee`. */
  taskTemplateEmployees?: Maybe<TaskTemplateEmployeesConnection>;
  taskTemplateResponsibleByTaskTemplateIdAndResponsibleId?: Maybe<TaskTemplateResponsible>;
  /** Reads and enables pagination through a set of `TaskTemplateResponsible`. */
  taskTemplateResponsibles?: Maybe<TaskTemplateResponsiblesConnection>;
  /** Reads and enables pagination through a set of `TaskTemplate`. */
  taskTemplates?: Maybe<TaskTemplatesConnection>;
  /** Reads and enables pagination through a set of `Task`. */
  tasks?: Maybe<TasksConnection>;
  timeRegistrationBreakTypeById?: Maybe<TimeRegistrationBreakType>;
  /** Reads and enables pagination through a set of `TimeRegistrationBreakType`. */
  timeRegistrationBreakTypes?: Maybe<TimeRegistrationBreakTypesConnection>;
  timeRegistrationDepartmentOverview?: Maybe<TimeRegistrationDepartmentOverviewConnection>;
  /** Reads and enables pagination through a set of `TimeRegistrationEntry`. */
  timeRegistrationEntries?: Maybe<TimeRegistrationEntriesConnection>;
  timeRegistrationEntryById?: Maybe<TimeRegistrationEntry>;
  timeRegistrationEntryTemplateById?: Maybe<TimeRegistrationEntryTemplate>;
  /** Reads and enables pagination through a set of `TimeRegistrationEntryTemplate`. */
  timeRegistrationEntryTemplates?: Maybe<TimeRegistrationEntryTemplatesConnection>;
  timeRegistrationPresenceById?: Maybe<TimeRegistrationPresence>;
  timeRegistrationPresenceTemplateById?: Maybe<TimeRegistrationPresenceTemplate>;
  /** Reads and enables pagination through a set of `TimeRegistrationPresenceTemplate`. */
  timeRegistrationPresenceTemplates?: Maybe<TimeRegistrationPresenceTemplatesConnection>;
  timeRegistrationPresenceTypeById?: Maybe<TimeRegistrationPresenceType>;
  /** Reads and enables pagination through a set of `TimeRegistrationPresenceType`. */
  timeRegistrationPresenceTypes?: Maybe<TimeRegistrationPresenceTypesConnection>;
  /** Reads and enables pagination through a set of `TimeRegistrationPresence`. */
  timeRegistrationPresences?: Maybe<TimeRegistrationPresencesConnection>;
  timeRegistrationProjectById?: Maybe<TimeRegistrationProject>;
  /** Reads and enables pagination through a set of `TimeRegistrationProject`. */
  timeRegistrationProjects?: Maybe<TimeRegistrationProjectsConnection>;
  timeRegistrationRegisteredTime?: Maybe<TimeRegistrationRegisteredTimeConnection>;
  timeRegistrationTemplateById?: Maybe<TimeRegistrationTemplate>;
  timeRegistrationTemplateWeekById?: Maybe<TimeRegistrationTemplateWeek>;
  /** Reads and enables pagination through a set of `TimeRegistrationTemplateWeek`. */
  timeRegistrationTemplateWeeks?: Maybe<TimeRegistrationTemplateWeeksConnection>;
  /** Reads and enables pagination through a set of `TimeRegistrationTemplate`. */
  timeRegistrationTemplates?: Maybe<TimeRegistrationTemplatesConnection>;
  timeRegistrationUserOverview?: Maybe<TimeRegistrationUserOverviewConnection>;
  timeRegistrationWeekOverview?: Maybe<TimeRegistrationWeekOverviewConnection>;
  timeRegistrationsPendingApproval?: Maybe<TimeRegistrationsPendingApprovalConnection>;
  /** Reads and enables pagination through a set of `TranslatedEntity`. */
  translatedEntities?: Maybe<TranslatedEntitiesConnection>;
  translatedEntityById?: Maybe<TranslatedEntity>;
  translatedEntityLocalizationById?: Maybe<TranslatedEntityLocalization>;
  translatedEntityLocalizationByTranslatedEntityIdAndLocale?: Maybe<TranslatedEntityLocalization>;
  /** Reads and enables pagination through a set of `TranslatedEntityLocalization`. */
  translatedEntityLocalizations?: Maybe<TranslatedEntityLocalizationsConnection>;
  translationById?: Maybe<Translation>;
  /** Reads and enables pagination through a set of `Translation`. */
  translations?: Maybe<TranslationsConnection>;
  /** Reads and enables pagination through a set of `EmployeeCasefile`. */
  unsignedCasefiles?: Maybe<EmployeeCasefilesConnection>;
  unsignedContractSignPendingCount?: Maybe<Scalars['Int']>;
  unsignedDocumentsCount?: Maybe<Scalars['Int']>;
  unsignedEmployeeCasefileCount?: Maybe<Scalars['Int']>;
  userAnnouncementByUserIdAndAnnouncementId?: Maybe<UserAnnouncement>;
  /** Reads and enables pagination through a set of `UserAnnouncement`. */
  userAnnouncements?: Maybe<UserAnnouncementsConnection>;
  userById?: Maybe<User>;
  userCompanyGroupByUserIdAndGroupIdAndCompanyId?: Maybe<UserCompanyGroup>;
  /** Reads and enables pagination through a set of `UserCompanyGroup`. */
  userCompanyGroups?: Maybe<UserCompanyGroupsConnection>;
  userCompanyRoleByUserIdAndRoleIdAndCompanyId?: Maybe<UserCompanyRole>;
  /** Reads and enables pagination through a set of `UserCompanyRole`. */
  userCompanyRoles?: Maybe<UserCompanyRolesConnection>;
  userCompetenceById?: Maybe<UserCompetence>;
  userCompetenceEvaluationById?: Maybe<UserCompetenceEvaluation>;
  userCompetenceEvaluationCommentById?: Maybe<UserCompetenceEvaluationComment>;
  /** Reads and enables pagination through a set of `UserCompetenceEvaluationComment`. */
  userCompetenceEvaluationComments?: Maybe<UserCompetenceEvaluationCommentsConnection>;
  /** Reads and enables pagination through a set of `UserCompetenceEvaluation`. */
  userCompetenceEvaluations?: Maybe<UserCompetenceEvaluationsConnection>;
  /** Reads and enables pagination through a set of `UserCompetence`. */
  userCompetences?: Maybe<UserCompetencesConnection>;
  userDepartmentByDepartmentIdAndUserId?: Maybe<UserDepartment>;
  userDepartmentById?: Maybe<UserDepartment>;
  userDepartmentCount?: Maybe<Scalars['BigInt']>;
  userDepartmentGroupByUserIdAndDepartmentIdAndGroupId?: Maybe<UserDepartmentGroup>;
  /** Reads and enables pagination through a set of `UserDepartmentGroup`. */
  userDepartmentGroups?: Maybe<UserDepartmentGroupsConnection>;
  userDepartmentRoleByUserIdAndDepartmentIdAndRoleId?: Maybe<UserDepartmentRole>;
  /** Reads and enables pagination through a set of `UserDepartmentRole`. */
  userDepartmentRoles?: Maybe<UserDepartmentRolesConnection>;
  /** Reads and enables pagination through a set of `UserDepartment`. */
  userDepartments?: Maybe<UserDepartmentsConnection>;
  userGroupByUserIdAndGroupId?: Maybe<UserGroup>;
  /** Reads and enables pagination through a set of `UserGroup`. */
  userGroups?: Maybe<UserGroupsConnection>;
  userOnBehalfPermissionById?: Maybe<UserOnBehalfPermission>;
  /** Reads and enables pagination through a set of `UserOnBehalfPermission`. */
  userOnBehalfPermissions?: Maybe<UserOnBehalfPermissionsConnection>;
  userRoleByUserIdAndRoleId?: Maybe<UserRole>;
  /** Reads and enables pagination through a set of `UserRole`. */
  userRoles?: Maybe<UserRolesConnection>;
  userSettingByUserIdAndKey?: Maybe<UserSetting>;
  /** Reads and enables pagination through a set of `UserSetting`. */
  userSettings?: Maybe<UserSettingsConnection>;
  userSystemFieldByUserIdAndSystemFieldId?: Maybe<UserSystemField>;
  userSystemFieldCount?: Maybe<UserSystemFieldCountConnection>;
  userSystemFieldUpdateCompanySystemFieldOptionId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `UserSystemField`. */
  userSystemFields?: Maybe<UserSystemFieldsConnection>;
  /** Reads and enables pagination through a set of `User`. */
  users?: Maybe<UsersConnection>;
  /** Reads and enables pagination through a set of `User`. */
  usersSearch?: Maybe<UsersConnection>;
  /** Reads and enables pagination through a set of `User`. */
  usersSearchName?: Maybe<UsersConnection>;
  vacationTypeById?: Maybe<VacationType>;
  /** Reads and enables pagination through a set of `VacationType`. */
  vacationTypes?: Maybe<VacationTypesConnection>;
  vacationUserByApprovalId?: Maybe<VacationUser>;
  vacationUserByDeletionApprovalId?: Maybe<VacationUser>;
  vacationUserById?: Maybe<VacationUser>;
  /** Reads and enables pagination through a set of `VacationUser`. */
  vacationUsers?: Maybe<VacationUsersConnection>;
  validateEmailAvailability?: Maybe<Scalars['Boolean']>;
  validateFormFieldEntryUniqueness?: Maybe<Scalars['Boolean']>;
  validateZenegyFields?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAnalyseImportEmployeesFromFileArgs = {
  input: AnalyseImportEmployeesFromFileInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryAnalyseImportEquipmentFromFileArgs = {
  input: AnalyseImportEquipmentFromFileInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryDownloadEmployeesFileArgs = {
  input?: InputMaybe<DownloadEmployeesFileInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDownloadEquipmentFileArgs = {
  input: DownloadEquipmentFileInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryExportEquipmentToExcelArgs = {
  input: ExportEquipmentInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetZenegyTokensArgs = {
  code?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAffectedPostsCountOnPostTypeDeleteArgs = {
  postTypeId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderByInput>;
  search?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAnalyseCsvEmployeeRecordUpdateFileArgs = {
  input?: InputMaybe<AnalyseCsvEmployeeRecordUpdateFileInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAnalyseCsvEmployeeUpdateFileArgs = {
  input?: InputMaybe<AnalyseCsvEmployeeUpdateFileInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAnniversaryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAnnouncementByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAnnouncementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AnnouncementCondition>;
  filter?: InputMaybe<AnnouncementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AnnouncementsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryApplicationArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryApprovalByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryApprovalsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ApprovalCondition>;
  filter?: InputMaybe<ApprovalFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ApprovalsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAsyncJobByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAsyncJobItemByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAsyncJobItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AsyncJobItemCondition>;
  filter?: InputMaybe<AsyncJobItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AsyncJobItemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAsyncJobsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AsyncJobCondition>;
  filter?: InputMaybe<AsyncJobFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AsyncJobsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAttendeesByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  filter?: InputMaybe<AttendeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthAppByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthAppTypeByIdArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthAppTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AuthAppTypeCondition>;
  filter?: InputMaybe<AuthAppTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AuthAppTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthAppsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AuthAppCondition>;
  filter?: InputMaybe<AuthAppFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AuthAppsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthCodeByIdArgs = {
  id: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthCodesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AuthCodeCondition>;
  filter?: InputMaybe<AuthCodeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AuthCodesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAverageAgeArgs = {
  argDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAverageSeniorityArgs = {
  argDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  argJobPositionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBirthdayUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryChangelogByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChangelogUserByChangelogIdAndUserIdArgs = {
  changelogId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChangelogUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ChangelogUserCondition>;
  filter?: InputMaybe<ChangelogUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChangelogUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryChangelogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ChangelogCondition>;
  filter?: InputMaybe<ChangelogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChangelogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryChannelTypeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChannelTypeByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChannelTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ChannelTypeCondition>;
  filter?: InputMaybe<ChannelTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChannelTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryChosenColumnByUserIdAndTableNameArgs = {
  tableName: Scalars['String'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChosenColumnsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ChosenColumnCondition>;
  filter?: InputMaybe<ChosenColumnFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChosenColumnsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCommunicationLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  dispatchedAfterDate?: InputMaybe<Scalars['Datetime']>;
  dispatchedBeforeDate?: InputMaybe<Scalars['Datetime']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CommunicationLogOrderBy>;
  receiverId: Scalars['String'];
  searchSubject?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CommunicationLogStatusType>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyCondition>;
  filter?: InputMaybe<CompanyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompaniesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyBindingByCompanyIdAndLegacyCompanyIdArgs = {
  companyId: Scalars['UUID'];
  legacyCompanyId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyBindingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyBindingCondition>;
  filter?: InputMaybe<CompanyBindingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyBindingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyCompanyTypeByCompanyIdArgs = {
  companyId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyCompanyTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyCompanyTypeCondition>;
  filter?: InputMaybe<CompanyCompanyTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyCompanyTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanySettingByCompanyIdAndKeyArgs = {
  companyId: Scalars['UUID'];
  key: CompanySettingKey;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanySettingByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanySettingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanySettingCondition>;
  filter?: InputMaybe<CompanySettingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanySettingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanySystemFieldByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanySystemFieldBySystemFieldIdAndCompanyIdArgs = {
  companyId: Scalars['UUID'];
  systemFieldId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanySystemFieldOptionByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanySystemFieldOptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanySystemFieldOptionCondition>;
  filter?: InputMaybe<CompanySystemFieldOptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanySystemFieldOptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanySystemFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanySystemFieldCondition>;
  filter?: InputMaybe<CompanySystemFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanySystemFieldsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyTypeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompanyTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanyTypeCondition>;
  filter?: InputMaybe<CompanyTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompetenceByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompetenceFormFieldByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompetenceFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompetenceFormFieldCondition>;
  filter?: InputMaybe<CompetenceFormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetenceFormFieldsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompetenceGroupByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompetenceGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompetenceGroupCondition>;
  filter?: InputMaybe<CompetenceGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetenceGroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompetenceRequestByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCompetenceRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompetenceRequestCondition>;
  filter?: InputMaybe<CompetenceRequestFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetenceRequestsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompetencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompetenceCondition>;
  filter?: InputMaybe<CompetenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompetencesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCompetencesSearchArgs = {
  input: CompetencesSearchInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryContractPredefinedPlaceholderByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContractPredefinedPlaceholdersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractPredefinedPlaceholderCondition>;
  filter?: InputMaybe<ContractPredefinedPlaceholderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPredefinedPlaceholdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContractSignPendingByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContractSignPendingDocumentByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContractSignPendingDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingDocumentCondition>;
  filter?: InputMaybe<ContractSignPendingDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingDocumentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContractSignPendingSignerByContractSignPendingIdAndUserIdArgs = {
  contractSignPendingId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContractSignPendingSignerByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContractSignPendingSignersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingSignerCondition>;
  filter?: InputMaybe<ContractSignPendingSignerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingSignersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContractSignPendingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingCondition>;
  filter?: InputMaybe<ContractSignPendingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContractSignPendingsByEmployeeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  filter?: InputMaybe<ContractSignPendingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContractTemplateByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContractTemplateDepartmentByContractTemplateIdAndDepartmentIdArgs = {
  contractTemplateId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContractTemplateDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractTemplateDepartmentCondition>;
  filter?: InputMaybe<ContractTemplateDepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractTemplateDepartmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContractTemplateFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractTemplateFormFieldCondition>;
  filter?: InputMaybe<ContractTemplateFormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractTemplateFormFieldsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContractTemplateUserByUserIdAndContractTemplateIdArgs = {
  contractTemplateId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContractTemplateUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractTemplateUserCondition>;
  filter?: InputMaybe<ContractTemplateUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractTemplateUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryContractTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractTemplateCondition>;
  filter?: InputMaybe<ContractTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractTemplatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCountryOptionsInUseArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<CountryOptionsInUseRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  systemFieldName?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomWidgetByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomWidgetContentByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomWidgetContentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CustomWidgetContentCondition>;
  filter?: InputMaybe<CustomWidgetContentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomWidgetContentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomWidgetsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CustomWidgetCondition>;
  filter?: InputMaybe<CustomWidgetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomWidgetsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCvTemplateFieldMappingByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCvTemplateFieldMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CvTemplateFieldMappingCondition>;
  filter?: InputMaybe<CvTemplateFieldMappingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CvTemplateFieldMappingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDashboardCardByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDashboardCardChartArgs = {
  input: DashboardCardChartInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryDashboardCardStatisticByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDashboardCardStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DashboardCardStatisticCondition>;
  filter?: InputMaybe<DashboardCardStatisticFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DashboardCardStatisticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDashboardCardsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DashboardCardCondition>;
  filter?: InputMaybe<DashboardCardFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DashboardCardsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDashboardConfigByCompanyIdArgs = {
  companyId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDashboardConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DashboardConfigCondition>;
  filter?: InputMaybe<DashboardConfigFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DashboardConfigsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDashboardViewByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDashboardViewsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DashboardViewCondition>;
  filter?: InputMaybe<DashboardViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DashboardViewsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDepartmentByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDepartmentEmployeeHierarchyArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  departmentId: Scalars['UUID'];
  filter?: InputMaybe<JsonFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDepartmentTreeItemArgs = {
  departmentId?: InputMaybe<Scalars['UUID']>;
  depth?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDepartmentTypeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDepartmentTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DepartmentTypeCondition>;
  filter?: InputMaybe<DepartmentTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DepartmentTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDepartmentUserItemsArgs = {
  departmentId?: InputMaybe<Scalars['UUID']>;
  managers?: InputMaybe<Scalars['Boolean']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DepartmentCondition>;
  filter?: InputMaybe<DepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DepartmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDepartmentsSortByFormFieldArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  argFormFieldId?: InputMaybe<Scalars['UUID']>;
  argOrderDirection?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DepartmentCondition>;
  filter?: InputMaybe<DepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDirectManagersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentDepartmentPermissionByFileIdAndDepartmentIdArgs = {
  departmentId: Scalars['UUID'];
  fileId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentDepartmentPermissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentDepartmentPermissionCondition>;
  filter?: InputMaybe<DocumentDepartmentPermissionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentDepartmentPermissionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentFolderBlueprintAffectedFilesArgs = {
  documentFolderBlueprintId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentFolderBlueprintByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentFolderBlueprintsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentFolderBlueprintCondition>;
  filter?: InputMaybe<DocumentFolderBlueprintFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentFolderBlueprintsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentFolderByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentFolderDepartmentByDocumentFolderIdAndDepartmentIdArgs = {
  departmentId: Scalars['UUID'];
  documentFolderId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentFolderDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentFolderDepartmentCondition>;
  filter?: InputMaybe<DocumentFolderDepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentFolderDepartmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentFolderUserByDocumentFolderIdAndUserIdArgs = {
  documentFolderId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentFolderUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentFolderUserCondition>;
  filter?: InputMaybe<DocumentFolderUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentFolderUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentFoldersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentFolderCondition>;
  filter?: InputMaybe<DocumentFolderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentFoldersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentFoldersWithPathArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  filter?: InputMaybe<DocumentFoldersWithPathRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentTypeByCompanyIdAndDepartmentIdAndNameArgs = {
  companyId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentTypeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentTypeCondition>;
  filter?: InputMaybe<DocumentTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentUserPermissionByFileIdAndUserIdArgs = {
  fileId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentUserPermissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentUserPermissionCondition>;
  filter?: InputMaybe<DocumentUserPermissionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentUserPermissionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentUserResponsibleByFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  fileid?: InputMaybe<Scalars['UUID']>;
  filter?: InputMaybe<DocumentUserResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentUserResponsibleByFileIdAndUserIdArgs = {
  fileId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentUserResponsibleByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<DocumentUserResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  userid?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDocumentUserResponsiblesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentUserResponsibleCondition>;
  filter?: InputMaybe<DocumentUserResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentUserResponsiblesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDownloadEmployeeRecordUpdateTemplateArgs = {
  input: DownloadEmployeeRecordUpdateTemplateInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryEmployeeBelongsToDepartmentArgs = {
  argDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  argEmployeeId?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEmployeeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmployeeByUserIdArgs = {
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmployeeCasefileByEmployeeIdAndCasefileIdArgs = {
  casefileId: Scalars['Int'];
  employeeId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmployeeCasefileByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmployeeCasefilesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmployeeCasefileCondition>;
  filter?: InputMaybe<EmployeeCasefileFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmployeeCasefilesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEmployeeCasefilesSearchArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  argSearchString?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmployeeCasefileCondition>;
  filter?: InputMaybe<EmployeeCasefileFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmployeeCasefilesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEmployeeDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StoragesOrderBy>>;
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmployeeExternalIntegrationByEmployeeIdAndExternalIntegrationIdArgs = {
  employeeId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmployeeExternalIntegrationBySameSystemArgs = {
  sameSystem: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmployeeExternalIntegrationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmployeeExternalIntegrationCondition>;
  filter?: InputMaybe<EmployeeExternalIntegrationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmployeeExternalIntegrationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEmployeeHierarchyItemArgs = {
  depth?: InputMaybe<Scalars['Int']>;
  userDepartmentId?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEmployeeOrderedByLatestMessageArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<EmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEmployeeResponsibleDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StoragesOrderBy>>;
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmployeeCondition>;
  filter?: InputMaybe<EmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  includeArchived?: InputMaybe<IncludeArchivedOption>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmployeesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEngagementTypeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEngagementTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EngagementTypeCondition>;
  filter?: InputMaybe<EngagementTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EngagementTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEquipmentByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEquipmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EquipmentCondition>;
  filter?: InputMaybe<EquipmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEventByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventUserByEventIdAndUserIdArgs = {
  eventId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventUserByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExportCompetencesToExcelArgs = {
  columnNames: Array<Scalars['String']>;
  userCompetenceIds: Array<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExportDashboardCardToExcelArgs = {
  input: ExportDashboardCardToExcelInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryExportDepartmentsToExcelArgs = {
  input: ExportDepartmentsToExcelInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryExportDocumentsToExcelArgs = {
  input: ExportDocumentsToExcelInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryExportEmployeesToExcelArgs = {
  input?: InputMaybe<ExportEmployeesToExcelInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExportFieldLogToExcelArgs = {
  input: FieldLogInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryExportPreboardingResultsToExcelArgs = {
  input?: InputMaybe<ExportPreboardingResultsToExcelInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExportVacationToExcelArgs = {
  input: ExportVacationToExcelInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalIntegrationByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalIntegrationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalIntegrationCondition>;
  filter?: InputMaybe<ExternalIntegrationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalIntegrationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalSystemByIdArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalSystemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ExternalSystemCondition>;
  filter?: InputMaybe<ExternalSystemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ExternalSystemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFieldGroupByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFieldGroupCardByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFieldGroupCardColumnByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFieldGroupCardColumnsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FieldGroupCardColumnCondition>;
  filter?: InputMaybe<FieldGroupCardColumnFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FieldGroupCardColumnsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFieldGroupCardsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FieldGroupCardCondition>;
  filter?: InputMaybe<FieldGroupCardFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FieldGroupCardsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFieldGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FieldGroupCondition>;
  filter?: InputMaybe<FieldGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FieldGroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFilterPresetByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFilterPresetsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FilterPresetCondition>;
  filter?: InputMaybe<FilterPresetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FilterPresetsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFilterViewByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFilterViewsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FilterViewCondition>;
  filter?: InputMaybe<FilterViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FilterViewsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFormFieldAgreementByFormFieldIdArgs = {
  formFieldId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFormFieldAgreementByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFormFieldAgreementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldAgreementCondition>;
  filter?: InputMaybe<FormFieldAgreementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldAgreementsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFormFieldByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFormFieldEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldEntryCondition>;
  filter?: InputMaybe<FormFieldEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldEntriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFormFieldEntryByEmployeeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  argEmployeeId?: InputMaybe<Scalars['UUID']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<FormFieldEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFormFieldEntryByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFormFieldEntryCountArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  argEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<FormFieldEntryCountRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFormFieldOptionByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFormFieldOptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldOptionCondition>;
  filter?: InputMaybe<FormFieldOptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldOptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFormFieldStatisticsArgs = {
  argDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  argFormFieldId?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldCondition>;
  filter?: InputMaybe<FormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFroalaStyleByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFroalaStylesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FroalaStyleCondition>;
  filter?: InputMaybe<FroalaStyleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FroalaStylesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFutureDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FutureDatumCondition>;
  filter?: InputMaybe<FutureDatumFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FutureDataOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFutureDataFieldsInUseArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<FutureDataFieldsInUseRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFutureDatumByApprovalIdArgs = {
  approvalId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFutureDatumByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetAuthAppArgs = {
  input?: InputMaybe<AuthAppInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetAuthAppsArgs = {
  input?: InputMaybe<AuthAppsInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetCompanyByEmployeeIdArgs = {
  argEmployeeId?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetCompanyByUserIdArgs = {
  userId?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetCompanyIdByUserIdArgs = {
  argUserId?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetCompanyPublicSsoArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetDeletionLogArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  argObjectType?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<LogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetDepartmentDescendantsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  filter?: InputMaybe<DepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetDepartmentLeadersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  departmentId: Scalars['UUID'];
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetDepartmentLeadersCountArgs = {
  departmentId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetDependingRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<RoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  groupId: Scalars['UUID'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  roleId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetDirectManagerBasicInfoArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<GetDirectManagerBasicInfoRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetEmployeeCasefileLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  argCasefileId?: InputMaybe<Scalars['Int']>;
  argFrom?: InputMaybe<Scalars['Date']>;
  argOrderBy?: InputMaybe<Scalars['String']>;
  argSearch?: InputMaybe<Scalars['String']>;
  argTo?: InputMaybe<Scalars['Date']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<LogEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetEmployeeCsvFieldMappingArgs = {
  input: GetEmployeeCsvFieldMappingInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetEmployeeLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  argEmployeeId?: InputMaybe<Scalars['UUID']>;
  argFrom?: InputMaybe<Scalars['Date']>;
  argOrderBy?: InputMaybe<Scalars['String']>;
  argSearch?: InputMaybe<Scalars['String']>;
  argTo?: InputMaybe<Scalars['Date']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<LogEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetEmployeesBasicInfoArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  employeeIds: Array<InputMaybe<Scalars['UUID']>>;
  filter?: InputMaybe<GetEmployeesBasicInfoRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetEquipmentOwnersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetFieldLogArgs = {
  input: FieldLogInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetGeneralHolidaysArgs = {
  input: GetGeneralHolidaysInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetLocalizedStringArgs = {
  fetchOriginal?: InputMaybe<Scalars['Boolean']>;
  translatedEntityId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetMissingGroupRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<RoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  groupId: Scalars['UUID'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  roleId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPlaceholdersWithInitialValuesArgs = {
  input: GetPlaceholdersWithInitialValuesInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPreboardingEmployeeLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  argFrom?: InputMaybe<Scalars['Date']>;
  argOrderBy?: InputMaybe<Scalars['String']>;
  argPreboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  argSearch?: InputMaybe<Scalars['String']>;
  argTo?: InputMaybe<Scalars['Date']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<LogEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPulseSurveyChartDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  endDate: Scalars['Date'];
  filter?: InputMaybe<GetPulseSurveyChartDataRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  onlyShowCurrentUserData?: InputMaybe<Scalars['Boolean']>;
  pulseSurveyId: Scalars['UUID'];
  startDate: Scalars['Date'];
  truncTo?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetSecretArgs = {
  input?: InputMaybe<AuthAppInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetSignedStorageByContractSignPendingDocumentIdArgs = {
  input: SignedContractInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetSingleProcessLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  argFrom?: InputMaybe<Scalars['Date']>;
  argOrderBy?: InputMaybe<Scalars['String']>;
  argProcessId?: InputMaybe<Scalars['UUID']>;
  argSearch?: InputMaybe<Scalars['String']>;
  argTo?: InputMaybe<Scalars['Date']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<LogEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetStorageLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  argFrom?: InputMaybe<Scalars['Date']>;
  argOrderBy?: InputMaybe<Scalars['String']>;
  argSearch?: InputMaybe<Scalars['String']>;
  argStorageId?: InputMaybe<Scalars['UUID']>;
  argTo?: InputMaybe<Scalars['Date']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<LogEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetUnansweredPulseSurveysArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<PulseSurveyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetUserDirectManagerBasicInfoArgs = {
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetUsersByBirthdayMonthArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  endMonth?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  includeFuture?: InputMaybe<Scalars['Boolean']>;
  includeResigned?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  startMonth?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetUsersBySeniorityMonthArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  endMonth?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  includeFuture?: InputMaybe<Scalars['Boolean']>;
  includeResigned?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  startMonth?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetWorkHoursLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  argFrom?: InputMaybe<Scalars['Date']>;
  argOrderBy?: InputMaybe<Scalars['String']>;
  argTo?: InputMaybe<Scalars['Date']>;
  argUserId?: InputMaybe<Scalars['UUID']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<GetWorkHoursLogsRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupRoleByGroupIdAndRoleIdArgs = {
  groupId: Scalars['UUID'];
  roleId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupRoleCondition>;
  filter?: InputMaybe<GroupRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHookByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHookByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHooksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<HookCondition>;
  filter?: InputMaybe<HookFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<HooksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryI18onArgs = {
  input: I18onInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryInheritedDepartmentGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  departmentId: Scalars['UUID'];
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIntAddAbsArgs = {
  arg0?: InputMaybe<Scalars['Int']>;
  arg1?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIntegrableSystemByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIntegrableSystemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<IntegrableSystemCondition>;
  filter?: InputMaybe<IntegrableSystemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegrableSystemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIntegrationFieldMarkingByCompanyIdAndExternalIntegrationIdAndFormFieldIdArgs = {
  companyId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  formFieldId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIntegrationFieldMarkingByCompanyIdAndExternalIntegrationIdAndSystemFieldIdArgs = {
  companyId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  systemFieldId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIntegrationFieldMarkingByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIntegrationFieldMarkingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<IntegrationFieldMarkingCondition>;
  filter?: InputMaybe<IntegrationFieldMarkingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegrationFieldMarkingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryJobPositionTitlesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  argCompanyId?: InputMaybe<Scalars['UUID']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<JsonFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLatestMessageByEmployeeId1AndEmployeeId2Args = {
  employeeId1: Scalars['UUID'];
  employeeId2: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLatestMessageByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLatestMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LatestMessageCondition>;
  filter?: InputMaybe<LatestMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LatestMessagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLoggedActionNoteByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLoggedActionNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LoggedActionNoteCondition>;
  filter?: InputMaybe<LoggedActionNoteFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LoggedActionNotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLoginLogByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLoginLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LoginLogCondition>;
  filter?: InputMaybe<LoginLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LoginLogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMessageByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMessageRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MessageRecipientCondition>;
  filter?: InputMaybe<MessageRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessageRecipientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMessageThreadArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  argEmployeeId?: InputMaybe<Scalars['UUID']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<MessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MessageCondition>;
  filter?: InputMaybe<MessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MessagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationCustomEmployeeFieldRecipientByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationCustomEmployeeFieldRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationCustomEmployeeFieldRecipientCondition>;
  filter?: InputMaybe<NotificationCustomEmployeeFieldRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationCustomRecipientByNotificationIdAndEmployeeIdArgs = {
  employeeId: Scalars['UUID'];
  notificationId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationCustomRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationCustomRecipientCondition>;
  filter?: InputMaybe<NotificationCustomRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationCustomRecipientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationEmployeeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationEmployeeReferenceByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationEmployeeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeCondition>;
  filter?: InputMaybe<NotificationEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationGroupRecipientByNotificationIdAndGroupIdArgs = {
  groupId: Scalars['UUID'];
  notificationId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationGroupRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationGroupRecipientCondition>;
  filter?: InputMaybe<NotificationGroupRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationGroupRecipientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationTypeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationTypeChannelTypeByNotificationTypeIdAndChannelTypeIdArgs = {
  channelTypeId: Scalars['UUID'];
  notificationTypeId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationTypeChannelTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationTypeChannelTypeCondition>;
  filter?: InputMaybe<NotificationTypeChannelTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationTypeChannelTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationTypeCondition>;
  filter?: InputMaybe<NotificationTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenGraphArgs = {
  url: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationDiagramArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<JsonFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPostByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPostTypeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPostTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PostTypeCondition>;
  filter?: InputMaybe<PostTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PostTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPostsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PostCondition>;
  filter?: InputMaybe<PostFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PostsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingCommentByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingCommentCondition>;
  filter?: InputMaybe<PreboardingCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingCommentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingEmailLogByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingEmailLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingEmailLogCondition>;
  filter?: InputMaybe<PreboardingEmailLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingEmailLogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingEmployeeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingEmployeeCondition>;
  filter?: InputMaybe<PreboardingEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingEmployeesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingFormCacheByPreboardingIdAndUserIdArgs = {
  preboardingId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingFormCachesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingFormCacheCondition>;
  filter?: InputMaybe<PreboardingFormCacheFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingFormCachesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingProcessByPreboardingIdAndProcessIdArgs = {
  preboardingId: Scalars['UUID'];
  processId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingProcessesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingProcessCondition>;
  filter?: InputMaybe<PreboardingProcessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingProcessesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingResultByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingResultSlideCommentByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingResultSlideCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingResultSlideCommentCondition>;
  filter?: InputMaybe<PreboardingResultSlideCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingResultSlideCommentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingResultsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingResultCondition>;
  filter?: InputMaybe<PreboardingResultFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingResultsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingSlideByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingSlideFormFieldByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingSlideFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingSlideFormFieldCondition>;
  filter?: InputMaybe<PreboardingSlideFormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingSlideFormFieldsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingSlidesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingSlideCondition>;
  filter?: InputMaybe<PreboardingSlideFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingSlidesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPreboardingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingCondition>;
  filter?: InputMaybe<PreboardingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProcessByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProcessDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcessDepartmentCondition>;
  filter?: InputMaybe<ProcessDepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcessDepartmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProcessEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcessEmployeeCondition>;
  filter?: InputMaybe<ProcessEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcessEmployeesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProcessResponsibleByProcessIdAndResponsibleIdArgs = {
  processId: Scalars['UUID'];
  responsibleId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProcessResponsiblesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcessResponsibleCondition>;
  filter?: InputMaybe<ProcessResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcessResponsiblesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProcessTypeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProcessTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcessTypeCondition>;
  filter?: InputMaybe<ProcessTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcessTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProcessesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcessCondition>;
  filter?: InputMaybe<ProcessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcessesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProcessesOrderedByProgressArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  direction?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ProcessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProductByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProductTypeByCompanyIdAndDepartmentIdAndNameArgs = {
  companyId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProductTypeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProductTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProductTypeCondition>;
  filter?: InputMaybe<ProductTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProductCondition>;
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProductsSortByFormFieldArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  argFormFieldId?: InputMaybe<Scalars['UUID']>;
  argOrderDirection?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProductCondition>;
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTemplateByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectTemplateCondition>;
  filter?: InputMaybe<ProjectTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectTemplatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPulseSurveyAnswerByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPulseSurveyAnswerByUserIdAndPulseSurveyIdAndDateArgs = {
  date: Scalars['Date'];
  pulseSurveyId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPulseSurveyAnswersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseSurveyAnswerCondition>;
  filter?: InputMaybe<PulseSurveyAnswerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseSurveyAnswersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPulseSurveyByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPulseSurveyChoiceByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPulseSurveyChoicesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseSurveyChoiceCondition>;
  filter?: InputMaybe<PulseSurveyChoiceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseSurveyChoicesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPulseSurveysArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseSurveyCondition>;
  filter?: InputMaybe<PulseSurveyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseSurveysOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPulseTypeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPulseTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseTypeCondition>;
  filter?: InputMaybe<PulseTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPushTokenByUserIdArgs = {
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPushTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PushTokenCondition>;
  filter?: InputMaybe<PushTokenFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PushTokensOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRankByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRanksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RankCondition>;
  filter?: InputMaybe<RankFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RanksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRecentTimeRegistrationPresenceTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<TimeRegistrationPresenceTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRecentTimeRegistrationProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<TimeRegistrationProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRecurrenceRuleByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRecurrenceRuleByPulseSurveyIdArgs = {
  pulseSurveyId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRecurrenceRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RecurrenceRuleCondition>;
  filter?: InputMaybe<RecurrenceRuleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecurrenceRulesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryReferenceTokenByTokenArgs = {
  token: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryReferenceTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReferenceTokenCondition>;
  filter?: InputMaybe<ReferenceTokenFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReferenceTokensOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRelationRoleByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRelationRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RelationRoleCondition>;
  filter?: InputMaybe<RelationRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RelationRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryResetFormCompaniesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<ResetFormCompaniesRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoadmapItemByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoadmapItemCommentByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoadmapItemCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoadmapItemCommentCondition>;
  filter?: InputMaybe<RoadmapItemCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoadmapItemCommentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoadmapItemLocalizationByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoadmapItemLocalizationByRoadmapItemIdAndLocaleArgs = {
  locale: Scalars['String'];
  roadmapItemId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoadmapItemLocalizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoadmapItemLocalizationCondition>;
  filter?: InputMaybe<RoadmapItemLocalizationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoadmapItemLocalizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoadmapItemVoteByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoadmapItemVoteByUserIdAndRoadmapItemIdArgs = {
  roadmapItemId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoadmapItemVotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoadmapItemVoteCondition>;
  filter?: InputMaybe<RoadmapItemVoteFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoadmapItemVotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoadmapItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoadmapItemCondition>;
  filter?: InputMaybe<RoadmapItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoadmapItemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoleByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoleDependenciesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoleDependencyCondition>;
  filter?: InputMaybe<RoleDependencyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoleDependenciesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoleDependencyByRoleIdAndDependentOnArgs = {
  dependentOn: Scalars['UUID'];
  roleId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoleCondition>;
  filter?: InputMaybe<RoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySavedSignatureByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySavedSignaturesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SavedSignatureCondition>;
  filter?: InputMaybe<SavedSignatureFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SavedSignaturesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryScheduledMessageByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScheduledMessageExternalRecipientByScheduledMessageIdAndEmailArgs = {
  email: Scalars['String'];
  scheduledMessageId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScheduledMessageExternalRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageExternalRecipientCondition>;
  filter?: InputMaybe<ScheduledMessageExternalRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageExternalRecipientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryScheduledMessageRecipientByScheduledMessageIdAndEmployeeIdArgs = {
  employeeId: Scalars['UUID'];
  scheduledMessageId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScheduledMessageRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageRecipientCondition>;
  filter?: InputMaybe<ScheduledMessageRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageRecipientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryScheduledMessageTemplateByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScheduledMessageTemplateExternalRecipientByScheduledMessageTemplateIdAndEmailArgs = {
  email: Scalars['String'];
  scheduledMessageTemplateId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScheduledMessageTemplateExternalRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageTemplateExternalRecipientCondition>;
  filter?: InputMaybe<ScheduledMessageTemplateExternalRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageTemplateExternalRecipientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryScheduledMessageTemplateRecipientByScheduledMessageTemplateIdAndEmployeeIdArgs = {
  employeeId: Scalars['UUID'];
  scheduledMessageTemplateId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScheduledMessageTemplateRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageTemplateRecipientCondition>;
  filter?: InputMaybe<ScheduledMessageTemplateRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageTemplateRecipientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryScheduledMessageTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageTemplateCondition>;
  filter?: InputMaybe<ScheduledMessageTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageTemplatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryScheduledMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageCondition>;
  filter?: InputMaybe<ScheduledMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryStorageByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStorageIdToDirectUrlArgs = {
  input: StorageIdInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryStoragesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<StorageCondition>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StoragesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySuperUserAllowedUserByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySuperUserAllowedUserBySuperUserIdAndCompanyIdArgs = {
  companyId: Scalars['UUID'];
  superUserId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySuperUserAllowedUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SuperUserAllowedUserCondition>;
  filter?: InputMaybe<SuperUserAllowedUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuperUserAllowedUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySuperUserByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySuperUserByUserIdArgs = {
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySuperUserLoginNoteByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySuperUserLoginNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SuperUserLoginNoteCondition>;
  filter?: InputMaybe<SuperUserLoginNoteFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuperUserLoginNotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySuperUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SuperUserCondition>;
  filter?: InputMaybe<SuperUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuperUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySystemFieldByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySystemFieldByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySystemFieldTypeByTypeArgs = {
  type: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySystemFieldTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SystemFieldTypeCondition>;
  filter?: InputMaybe<SystemFieldTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SystemFieldTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySystemFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SystemFieldCondition>;
  filter?: InputMaybe<SystemFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SystemFieldsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTableslistsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TableslistCondition>;
  filter?: InputMaybe<TableslistFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TableslistsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskEmployeeByTaskIdAndEmployeeIdArgs = {
  employeeId: Scalars['UUID'];
  taskId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskEmployeeCondition>;
  filter?: InputMaybe<TaskEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskEmployeesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskResponsibleByTaskIdAndResponsibleIdArgs = {
  responsibleId: Scalars['UUID'];
  taskId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskResponsiblesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskResponsibleCondition>;
  filter?: InputMaybe<TaskResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskResponsiblesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskTemplateByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskTemplateEmployeeByTaskTemplateIdAndEmployeeIdArgs = {
  employeeId: Scalars['UUID'];
  taskTemplateId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskTemplateEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskTemplateEmployeeCondition>;
  filter?: InputMaybe<TaskTemplateEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskTemplateEmployeesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskTemplateResponsibleByTaskTemplateIdAndResponsibleIdArgs = {
  responsibleId: Scalars['UUID'];
  taskTemplateId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskTemplateResponsiblesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskTemplateResponsibleCondition>;
  filter?: InputMaybe<TaskTemplateResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskTemplateResponsiblesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTaskTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskTemplateCondition>;
  filter?: InputMaybe<TaskTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskTemplatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTasksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationBreakTypeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationBreakTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationBreakTypeCondition>;
  filter?: InputMaybe<TimeRegistrationBreakTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationBreakTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationDepartmentOverviewArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  endDate: Scalars['Datetime'];
  filter?: InputMaybe<TimeRegistrationDepartmentOverviewRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['Datetime'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationEntryCondition>;
  filter?: InputMaybe<TimeRegistrationEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationEntriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationEntryByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationEntryTemplateByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationEntryTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationEntryTemplateCondition>;
  filter?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationEntryTemplatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationPresenceByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationPresenceTemplateByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationPresenceTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationPresenceTemplateCondition>;
  filter?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationPresenceTemplatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationPresenceTypeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationPresenceTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationPresenceTypeCondition>;
  filter?: InputMaybe<TimeRegistrationPresenceTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationPresenceTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationPresencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationPresenceCondition>;
  filter?: InputMaybe<TimeRegistrationPresenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationPresencesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationProjectByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationProjectCondition>;
  filter?: InputMaybe<TimeRegistrationProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationProjectsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationRegisteredTimeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  filter?: InputMaybe<TimeRegistrationRegisteredTimeRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  truncTo?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationTemplateByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationTemplateWeekByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationTemplateWeeksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationTemplateWeekCondition>;
  filter?: InputMaybe<TimeRegistrationTemplateWeekFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationTemplateWeeksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationTemplateCondition>;
  filter?: InputMaybe<TimeRegistrationTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationTemplatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationUserOverviewArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  departmentId: Scalars['UUID'];
  endDate: Scalars['Datetime'];
  filter?: InputMaybe<TimeRegistrationUserOverviewRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['Datetime'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationWeekOverviewArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  endDate: Scalars['Datetime'];
  filter?: InputMaybe<TimeRegistrationWeekOverviewRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  startDate: Scalars['Datetime'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTimeRegistrationsPendingApprovalArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<TimeRegistrationsPendingApprovalRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTranslatedEntitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TranslatedEntityCondition>;
  filter?: InputMaybe<TranslatedEntityFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TranslatedEntitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTranslatedEntityByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTranslatedEntityLocalizationByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTranslatedEntityLocalizationByTranslatedEntityIdAndLocaleArgs = {
  locale: Scalars['String'];
  translatedEntityId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTranslatedEntityLocalizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TranslatedEntityLocalizationCondition>;
  filter?: InputMaybe<TranslatedEntityLocalizationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TranslatedEntityLocalizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTranslationByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTranslationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TranslationCondition>;
  filter?: InputMaybe<TranslationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TranslationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUnsignedCasefilesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<EmployeeCasefileFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUnsignedContractSignPendingCountArgs = {
  argUserId?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUnsignedDocumentsCountArgs = {
  argUserId?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUnsignedEmployeeCasefileCountArgs = {
  argUserId?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserAnnouncementByUserIdAndAnnouncementIdArgs = {
  announcementId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserAnnouncementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserAnnouncementCondition>;
  filter?: InputMaybe<UserAnnouncementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserAnnouncementsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCompanyGroupByUserIdAndGroupIdAndCompanyIdArgs = {
  companyId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCompanyGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompanyGroupCondition>;
  filter?: InputMaybe<UserCompanyGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompanyGroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCompanyRoleByUserIdAndRoleIdAndCompanyIdArgs = {
  companyId: Scalars['UUID'];
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCompanyRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompanyRoleCondition>;
  filter?: InputMaybe<UserCompanyRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompanyRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCompetenceByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCompetenceEvaluationByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCompetenceEvaluationCommentByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCompetenceEvaluationCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompetenceEvaluationCommentCondition>;
  filter?: InputMaybe<UserCompetenceEvaluationCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompetenceEvaluationCommentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCompetenceEvaluationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompetenceEvaluationCondition>;
  filter?: InputMaybe<UserCompetenceEvaluationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompetenceEvaluationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCompetencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompetenceCondition>;
  filter?: InputMaybe<UserCompetenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompetencesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserDepartmentByDepartmentIdAndUserIdArgs = {
  departmentId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserDepartmentByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserDepartmentCountArgs = {
  argEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserDepartmentGroupByUserIdAndDepartmentIdAndGroupIdArgs = {
  departmentId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserDepartmentGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserDepartmentGroupCondition>;
  filter?: InputMaybe<UserDepartmentGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserDepartmentGroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserDepartmentRoleByUserIdAndDepartmentIdAndRoleIdArgs = {
  departmentId: Scalars['UUID'];
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserDepartmentRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserDepartmentRoleCondition>;
  filter?: InputMaybe<UserDepartmentRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserDepartmentRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserDepartmentCondition>;
  filter?: InputMaybe<UserDepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserDepartmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserGroupByUserIdAndGroupIdArgs = {
  groupId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserGroupCondition>;
  filter?: InputMaybe<UserGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserGroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserOnBehalfPermissionByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserOnBehalfPermissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserOnBehalfPermissionCondition>;
  filter?: InputMaybe<UserOnBehalfPermissionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserOnBehalfPermissionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRoleByUserIdAndRoleIdArgs = {
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserRoleCondition>;
  filter?: InputMaybe<UserRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserSettingByUserIdAndKeyArgs = {
  key: UserSettingKey;
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserSettingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserSettingCondition>;
  filter?: InputMaybe<UserSettingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserSystemFieldByUserIdAndSystemFieldIdArgs = {
  systemFieldId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserSystemFieldCountArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  argEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserSystemFieldCountRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserSystemFieldUpdateCompanySystemFieldOptionIdArgs = {
  data?: InputMaybe<Scalars['JSON']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserSystemFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserSystemFieldCondition>;
  filter?: InputMaybe<UserSystemFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSystemFieldsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  includeArchived?: InputMaybe<IncludeArchivedOption>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersSearchArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  argFormFieldId?: InputMaybe<Scalars['UUID']>;
  argOrderDirection?: InputMaybe<Scalars['String']>;
  argSearchString?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersSearchNameArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  argOrderDirection?: InputMaybe<Scalars['String']>;
  argSearchString?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVacationTypeByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVacationTypesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VacationTypeCondition>;
  filter?: InputMaybe<VacationTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VacationTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVacationUserByApprovalIdArgs = {
  approvalId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVacationUserByDeletionApprovalIdArgs = {
  deletionApprovalId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVacationUserByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVacationUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VacationUserCondition>;
  filter?: InputMaybe<VacationUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VacationUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryValidateEmailAvailabilityArgs = {
  email?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryValidateFormFieldEntryUniquenessArgs = {
  formFieldId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryValidateZenegyFieldsArgs = {
  input?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Rank = {
  __typename?: 'Rank';
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `UserDepartment`. */
  userDepartments: UserDepartmentsConnection;
};


export type RankUserDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserDepartmentCondition>;
  filter?: InputMaybe<UserDepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserDepartmentsOrderBy>>;
};

/** A condition to be used against `Rank` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type RankCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Rank` object types. All fields are combined with a logical ‘and.’ */
export type RankFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RankFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RankFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RankFilter>>;
  /** Filter by the object’s `userDepartments` relation. */
  userDepartments?: InputMaybe<RankToManyUserDepartmentFilter>;
  /** Some related `userDepartments` exist. */
  userDepartmentsExist?: InputMaybe<Scalars['Boolean']>;
};

/** The fields on `rank` to look up the row to update. */
export type RankOnUserDepartmentForUserDepartmentRankIdForeignUsingRankPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `rank` being updated. */
  patch: UpdateRankOnUserDepartmentForUserDepartmentRankIdForeignPatch;
};

/** The fields on `rank` to look up the row to connect. */
export type RankRankPkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `UserDepartment` object types. All fields are combined with a logical ‘and.’ */
export type RankToManyUserDepartmentFilter = {
  /** Every related `UserDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserDepartmentFilter>;
  /** No related `UserDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserDepartmentFilter>;
  /** Some related `UserDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserDepartmentFilter>;
};

/** A connection to a list of `Rank` values. */
export type RanksConnection = {
  __typename?: 'RanksConnection';
  /** A list of edges which contains the `Rank` and cursor to aid in pagination. */
  edges: Array<RanksEdge>;
  /** A list of `Rank` objects. */
  nodes: Array<Maybe<Rank>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Rank` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Rank` edge in the connection. */
export type RanksEdge = {
  __typename?: 'RanksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Rank` at the end of the edge. */
  node?: Maybe<Rank>;
};

/** Methods to use when ordering `Rank`. */
export type RanksOrderBy =
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'USER_DEPARTMENTS_BY_RANK_ID__COUNT_ASC'
  | 'USER_DEPARTMENTS_BY_RANK_ID__COUNT_DESC';

export type RatingType =
  /** Rating using heart emojis. */
  | 'HEART'
  /** Rating using star emojis. */
  | 'STAR';

/** A filter to be used against RatingType fields. All fields are combined with a logical ‘and.’ */
export type RatingTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<RatingType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<RatingType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<RatingType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<RatingType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<RatingType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<RatingType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<RatingType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<RatingType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<RatingType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<RatingType>>;
};

export type RecruitCompany = {
  __typename?: 'RecruitCompany';
  company?: Maybe<Scalars['String']>;
  companyid?: Maybe<Scalars['Int']>;
  mode?: Maybe<Scalars['String']>;
};

export type RecurrenceRule = {
  __typename?: 'RecurrenceRule';
  /** Reads a single `Company` that is related to this `RecurrenceRule`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  daysOfMonth?: Maybe<Array<Maybe<Scalars['Int']>>>;
  daysOfWeek?: Maybe<Array<Maybe<Scalars['Int']>>>;
  daysOfYear?: Maybe<Array<Maybe<Scalars['Int']>>>;
  frequency?: Maybe<RecurrenceRuleFrequency>;
  id: Scalars['UUID'];
  interval?: Maybe<Scalars['Int']>;
  maxNumberOfOccurences?: Maybe<Scalars['Int']>;
  monthsOfYear?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Reads a single `PulseSurvey` that is related to this `RecurrenceRule`. */
  pulseSurvey?: Maybe<PulseSurvey>;
  pulseSurveyId?: Maybe<Scalars['UUID']>;
  setPosition?: Maybe<Array<Maybe<Scalars['Int']>>>;
  weeksOfYear?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

/** The `recurrenceRule` to be created by this mutation. */
export type RecurrenceRuleCompanyIdForeignConnectionRecurrenceRuleCreateInput = {
  company?: InputMaybe<RecurrenceRuleCompanyIdForeignInput>;
  daysOfMonth?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  daysOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  frequency?: InputMaybe<RecurrenceRuleFrequency>;
  id?: InputMaybe<Scalars['UUID']>;
  interval?: InputMaybe<Scalars['Int']>;
  maxNumberOfOccurences?: InputMaybe<Scalars['Int']>;
  monthsOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  pulseSurvey?: InputMaybe<RecurrenceRulePulseSurveyIdForeignInput>;
  pulseSurveyId?: InputMaybe<Scalars['UUID']>;
  setPosition?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weeksOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Input for the nested mutation of `company` in the `RecurrenceRuleInput` mutation. */
export type RecurrenceRuleCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnRecurrenceRuleForRecurrenceRuleCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `recurrenceRule` in the `CompanyInput` mutation. */
export type RecurrenceRuleCompanyIdForeignInverseInput = {
  /** The primary key(s) for `recurrenceRule` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RecurrenceRuleRecurrenceRulePkeyConnect>>;
  /** The primary key(s) for `recurrenceRule` for the far side of the relationship. */
  connectByPulseSurveyId?: InputMaybe<Array<RecurrenceRuleRecurrenceRulePulseSurveyIdUniqueConnect>>;
  /** A `RecurrenceRuleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RecurrenceRuleCompanyIdForeignConnectionRecurrenceRuleCreateInput>>;
  /** The primary key(s) for `recurrenceRule` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RecurrenceRuleRecurrenceRulePkeyDelete>>;
  /** The primary key(s) for `recurrenceRule` for the far side of the relationship. */
  deleteByPulseSurveyId?: InputMaybe<Array<RecurrenceRuleRecurrenceRulePulseSurveyIdUniqueDelete>>;
  /** Flag indicating whether all other `recurrenceRule` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `recurrenceRule` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RecurrenceRuleOnRecurrenceRuleForRecurrenceRuleCompanyIdForeignUsingRecurrenceRulePkeyUpdate>>;
  /** The primary key(s) and patch data for `recurrenceRule` for the far side of the relationship. */
  updateByPulseSurveyId?: InputMaybe<Array<RecurrenceRuleOnRecurrenceRuleForRecurrenceRuleCompanyIdForeignUsingRecurrenceRulePulseSurveyIdUniqueUpdate>>;
};

/**
 * A condition to be used against `RecurrenceRule` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RecurrenceRuleCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `daysOfMonth` field. */
  daysOfMonth?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Checks for equality with the object’s `daysOfWeek` field. */
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Checks for equality with the object’s `daysOfYear` field. */
  daysOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Checks for equality with the object’s `frequency` field. */
  frequency?: InputMaybe<RecurrenceRuleFrequency>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `interval` field. */
  interval?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `maxNumberOfOccurences` field. */
  maxNumberOfOccurences?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `monthsOfYear` field. */
  monthsOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Checks for equality with the object’s `pulseSurveyId` field. */
  pulseSurveyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `setPosition` field. */
  setPosition?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Checks for equality with the object’s `weeksOfYear` field. */
  weeksOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** A filter to be used against `RecurrenceRule` object types. All fields are combined with a logical ‘and.’ */
export type RecurrenceRuleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RecurrenceRuleFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `daysOfMonth` field. */
  daysOfMonth?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `daysOfWeek` field. */
  daysOfWeek?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `daysOfYear` field. */
  daysOfYear?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `frequency` field. */
  frequency?: InputMaybe<RecurrenceRuleFrequencyFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `interval` field. */
  interval?: InputMaybe<IntFilter>;
  /** Filter by the object’s `maxNumberOfOccurences` field. */
  maxNumberOfOccurences?: InputMaybe<IntFilter>;
  /** Filter by the object’s `monthsOfYear` field. */
  monthsOfYear?: InputMaybe<IntListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RecurrenceRuleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RecurrenceRuleFilter>>;
  /** Filter by the object’s `pulseSurvey` relation. */
  pulseSurvey?: InputMaybe<PulseSurveyFilter>;
  /** A related `pulseSurvey` exists. */
  pulseSurveyExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseSurveyId` field. */
  pulseSurveyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `setPosition` field. */
  setPosition?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `weeksOfYear` field. */
  weeksOfYear?: InputMaybe<IntListFilter>;
};

export type RecurrenceRuleFrequency =
  | 'DAILY'
  | 'MONTHLY'
  | 'WEEKLY'
  | 'YEARLY';

/** A filter to be used against RecurrenceRuleFrequency fields. All fields are combined with a logical ‘and.’ */
export type RecurrenceRuleFrequencyFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<RecurrenceRuleFrequency>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<RecurrenceRuleFrequency>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<RecurrenceRuleFrequency>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<RecurrenceRuleFrequency>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<RecurrenceRuleFrequency>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<RecurrenceRuleFrequency>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<RecurrenceRuleFrequency>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<RecurrenceRuleFrequency>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<RecurrenceRuleFrequency>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<RecurrenceRuleFrequency>>;
};

/** An input for mutations affecting `RecurrenceRule` */
export type RecurrenceRuleInput = {
  company?: InputMaybe<RecurrenceRuleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  daysOfMonth?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  daysOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  frequency?: InputMaybe<RecurrenceRuleFrequency>;
  id?: InputMaybe<Scalars['UUID']>;
  interval?: InputMaybe<Scalars['Int']>;
  maxNumberOfOccurences?: InputMaybe<Scalars['Int']>;
  monthsOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  pulseSurvey?: InputMaybe<RecurrenceRulePulseSurveyIdForeignInput>;
  pulseSurveyId?: InputMaybe<Scalars['UUID']>;
  setPosition?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weeksOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** The fields on `recurrenceRule` to look up the row to update. */
export type RecurrenceRuleOnRecurrenceRuleForRecurrenceRuleCompanyIdForeignUsingRecurrenceRulePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `recurrenceRule` being updated. */
  patch: UpdateRecurrenceRuleOnRecurrenceRuleForRecurrenceRuleCompanyIdForeignPatch;
};

/** The fields on `recurrenceRule` to look up the row to update. */
export type RecurrenceRuleOnRecurrenceRuleForRecurrenceRuleCompanyIdForeignUsingRecurrenceRulePulseSurveyIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `recurrenceRule` being updated. */
  patch: UpdateRecurrenceRuleOnRecurrenceRuleForRecurrenceRuleCompanyIdForeignPatch;
  pulseSurveyId: Scalars['UUID'];
};

/** The fields on `recurrenceRule` to look up the row to update. */
export type RecurrenceRuleOnRecurrenceRuleForRecurrenceRulePulseSurveyIdForeignUsingRecurrenceRulePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `recurrenceRule` being updated. */
  patch: UpdateRecurrenceRuleOnRecurrenceRuleForRecurrenceRulePulseSurveyIdForeignPatch;
};

/** The fields on `recurrenceRule` to look up the row to update. */
export type RecurrenceRuleOnRecurrenceRuleForRecurrenceRulePulseSurveyIdForeignUsingRecurrenceRulePulseSurveyIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `recurrenceRule` being updated. */
  patch: UpdateRecurrenceRuleOnRecurrenceRuleForRecurrenceRulePulseSurveyIdForeignPatch;
  pulseSurveyId: Scalars['UUID'];
};

/** Represents an update to a `RecurrenceRule`. Fields that are set will be updated. */
export type RecurrenceRulePatch = {
  company?: InputMaybe<RecurrenceRuleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  daysOfMonth?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  daysOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  frequency?: InputMaybe<RecurrenceRuleFrequency>;
  id?: InputMaybe<Scalars['UUID']>;
  interval?: InputMaybe<Scalars['Int']>;
  maxNumberOfOccurences?: InputMaybe<Scalars['Int']>;
  monthsOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  pulseSurvey?: InputMaybe<RecurrenceRulePulseSurveyIdForeignInput>;
  pulseSurveyId?: InputMaybe<Scalars['UUID']>;
  setPosition?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weeksOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** The `recurrenceRule` to be created by this mutation. */
export type RecurrenceRulePulseSurveyIdForeignConnectionRecurrenceRuleCreateInput = {
  company?: InputMaybe<RecurrenceRuleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  daysOfMonth?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  daysOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  frequency?: InputMaybe<RecurrenceRuleFrequency>;
  id?: InputMaybe<Scalars['UUID']>;
  interval?: InputMaybe<Scalars['Int']>;
  maxNumberOfOccurences?: InputMaybe<Scalars['Int']>;
  monthsOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  pulseSurvey?: InputMaybe<RecurrenceRulePulseSurveyIdForeignInput>;
  setPosition?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weeksOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Input for the nested mutation of `pulseSurvey` in the `RecurrenceRuleInput` mutation. */
export type RecurrenceRulePulseSurveyIdForeignInput = {
  /** The primary key(s) for `pulseSurvey` for the far side of the relationship. */
  connectById?: InputMaybe<PulseSurveyPulseSurveyPkeyConnect>;
  /** The primary key(s) for `pulseSurvey` for the far side of the relationship. */
  deleteById?: InputMaybe<PulseSurveyPulseSurveyPkeyDelete>;
  /** The primary key(s) and patch data for `pulseSurvey` for the far side of the relationship. */
  updateById?: InputMaybe<PulseSurveyOnRecurrenceRuleForRecurrenceRulePulseSurveyIdForeignUsingPulseSurveyPkeyUpdate>;
};

/** Input for the nested mutation of `recurrenceRule` in the `PulseSurveyInput` mutation. */
export type RecurrenceRulePulseSurveyIdForeignInverseInput = {
  /** The primary key(s) for `recurrenceRule` for the far side of the relationship. */
  connectById?: InputMaybe<RecurrenceRuleRecurrenceRulePkeyConnect>;
  /** The primary key(s) for `recurrenceRule` for the far side of the relationship. */
  connectByPulseSurveyId?: InputMaybe<RecurrenceRuleRecurrenceRulePulseSurveyIdUniqueConnect>;
  /** A `RecurrenceRuleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RecurrenceRulePulseSurveyIdForeignConnectionRecurrenceRuleCreateInput>>;
  /** The primary key(s) for `recurrenceRule` for the far side of the relationship. */
  deleteById?: InputMaybe<RecurrenceRuleRecurrenceRulePkeyDelete>;
  /** The primary key(s) for `recurrenceRule` for the far side of the relationship. */
  deleteByPulseSurveyId?: InputMaybe<RecurrenceRuleRecurrenceRulePulseSurveyIdUniqueDelete>;
  /** Flag indicating whether all other `recurrenceRule` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `recurrenceRule` for the far side of the relationship. */
  updateById?: InputMaybe<RecurrenceRuleOnRecurrenceRuleForRecurrenceRulePulseSurveyIdForeignUsingRecurrenceRulePkeyUpdate>;
  /** The primary key(s) and patch data for `recurrenceRule` for the far side of the relationship. */
  updateByPulseSurveyId?: InputMaybe<RecurrenceRuleOnRecurrenceRuleForRecurrenceRulePulseSurveyIdForeignUsingRecurrenceRulePulseSurveyIdUniqueUpdate>;
};

/** The fields on `recurrenceRule` to look up the row to connect. */
export type RecurrenceRuleRecurrenceRulePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `recurrenceRule` to look up the row to delete. */
export type RecurrenceRuleRecurrenceRulePkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `recurrenceRule` to look up the row to connect. */
export type RecurrenceRuleRecurrenceRulePulseSurveyIdUniqueConnect = {
  pulseSurveyId: Scalars['UUID'];
};

/** The fields on `recurrenceRule` to look up the row to delete. */
export type RecurrenceRuleRecurrenceRulePulseSurveyIdUniqueDelete = {
  pulseSurveyId: Scalars['UUID'];
};

/** A connection to a list of `RecurrenceRule` values. */
export type RecurrenceRulesConnection = {
  __typename?: 'RecurrenceRulesConnection';
  /** A list of edges which contains the `RecurrenceRule` and cursor to aid in pagination. */
  edges: Array<RecurrenceRulesEdge>;
  /** A list of `RecurrenceRule` objects. */
  nodes: Array<Maybe<RecurrenceRule>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RecurrenceRule` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RecurrenceRule` edge in the connection. */
export type RecurrenceRulesEdge = {
  __typename?: 'RecurrenceRulesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RecurrenceRule` at the end of the edge. */
  node?: Maybe<RecurrenceRule>;
};

/** Methods to use when ordering `RecurrenceRule`. */
export type RecurrenceRulesOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DAYS_OF_MONTH_ASC'
  | 'DAYS_OF_MONTH_DESC'
  | 'DAYS_OF_WEEK_ASC'
  | 'DAYS_OF_WEEK_DESC'
  | 'DAYS_OF_YEAR_ASC'
  | 'DAYS_OF_YEAR_DESC'
  | 'FREQUENCY_ASC'
  | 'FREQUENCY_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INTERVAL_ASC'
  | 'INTERVAL_DESC'
  | 'MAX_NUMBER_OF_OCCURENCES_ASC'
  | 'MAX_NUMBER_OF_OCCURENCES_DESC'
  | 'MONTHS_OF_YEAR_ASC'
  | 'MONTHS_OF_YEAR_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__ACTIVE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__ACTIVE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__ANONYMOUS_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__ANONYMOUS_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__CHOICE_INDICATOR_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__CHOICE_INDICATOR_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__COMPANY_ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__COMPANY_ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__CREATED_AT_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__CREATED_AT_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__DEADLINE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__DEADLINE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__END_DATE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__END_DATE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__HIGHEST_RATING_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__HIGHEST_RATING_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__HIGHEST_RATING_LABEL_TRANSLATED_ENTITY_ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__HIGHEST_RATING_LABEL_TRANSLATED_ENTITY_ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__HORIZONTAL_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__HORIZONTAL_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__INVITED_ALL_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__INVITED_ALL_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__INVITED_DEPARTMENT_IDS_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__INVITED_DEPARTMENT_IDS_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__INVITED_USER_IDS_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__INVITED_USER_IDS_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__IS_DRAFT_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__IS_DRAFT_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__LOCALIZED_NAME_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__LOCALIZED_NAME_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__LOWEST_RATING_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__LOWEST_RATING_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__LOWEST_RATING_LABEL_TRANSLATED_ENTITY_ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__LOWEST_RATING_LABEL_TRANSLATED_ENTITY_ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__NEXT_OCCURRENCE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__NEXT_OCCURRENCE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__PULSE_TYPE_ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__PULSE_TYPE_ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__QUESTION_TRANSLATED_ENTITY_ID_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__QUESTION_TRANSLATED_ENTITY_ID_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__QUESTION_TYPE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__QUESTION_TYPE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__RATING_TYPE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__RATING_TYPE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__REMINDERS_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__REMINDERS_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__START_DATE_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__START_DATE_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__SURVEY_TIME_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__SURVEY_TIME_DESC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__TIMEZONE_NAME_ASC'
  | 'PULSE_SURVEY_BY_PULSE_SURVEY_ID__TIMEZONE_NAME_DESC'
  | 'PULSE_SURVEY_ID_ASC'
  | 'PULSE_SURVEY_ID_DESC'
  | 'SET_POSITION_ASC'
  | 'SET_POSITION_DESC'
  | 'WEEKS_OF_YEAR_ASC'
  | 'WEEKS_OF_YEAR_DESC';

export type ReferenceToken = {
  __typename?: 'ReferenceToken';
  /** Reads a single `Company` that is related to this `ReferenceToken`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  token: Scalars['String'];
  /** Reads a single `User` that is related to this `ReferenceToken`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** Input for the nested mutation of `company` in the `ReferenceTokenInput` mutation. */
export type ReferenceTokenCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnReferenceTokenForReferenceTokenCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `referenceToken` in the `CompanyInput` mutation. */
export type ReferenceTokenCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `referenceToken` for the far side of the relationship. */
  connectByToken?: InputMaybe<Array<ReferenceTokenReferenceTokenPkeyConnect>>;
  /** The primary key(s) and patch data for `referenceToken` for the far side of the relationship. */
  updateByToken?: InputMaybe<Array<ReferenceTokenOnReferenceTokenForReferenceTokenCompanyIdFkeyUsingReferenceTokenPkeyUpdate>>;
};

/**
 * A condition to be used against `ReferenceToken` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ReferenceTokenCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `token` field. */
  token?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ReferenceToken` object types. All fields are combined with a logical ‘and.’ */
export type ReferenceTokenFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ReferenceTokenFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ReferenceTokenFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ReferenceTokenFilter>>;
  /** Filter by the object’s `token` field. */
  token?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `referenceToken` to look up the row to update. */
export type ReferenceTokenOnReferenceTokenForReferenceTokenCompanyIdFkeyUsingReferenceTokenPkeyUpdate = {
  /** An object where the defined keys will be set on the `referenceToken` being updated. */
  patch: UpdateReferenceTokenOnReferenceTokenForReferenceTokenCompanyIdFkeyPatch;
  token: Scalars['String'];
};

/** The fields on `referenceToken` to look up the row to update. */
export type ReferenceTokenOnReferenceTokenForReferenceTokenUserIdForeignUsingReferenceTokenPkeyUpdate = {
  /** An object where the defined keys will be set on the `referenceToken` being updated. */
  patch: UpdateReferenceTokenOnReferenceTokenForReferenceTokenUserIdForeignPatch;
  token: Scalars['String'];
};

/** The fields on `referenceToken` to look up the row to connect. */
export type ReferenceTokenReferenceTokenPkeyConnect = {
  token: Scalars['String'];
};

/** Input for the nested mutation of `user` in the `ReferenceTokenInput` mutation. */
export type ReferenceTokenUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnReferenceTokenForReferenceTokenUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `referenceToken` in the `UserInput` mutation. */
export type ReferenceTokenUserIdForeignInverseInput = {
  /** The primary key(s) for `referenceToken` for the far side of the relationship. */
  connectByToken?: InputMaybe<Array<ReferenceTokenReferenceTokenPkeyConnect>>;
  /** The primary key(s) and patch data for `referenceToken` for the far side of the relationship. */
  updateByToken?: InputMaybe<Array<ReferenceTokenOnReferenceTokenForReferenceTokenUserIdForeignUsingReferenceTokenPkeyUpdate>>;
};

/** A connection to a list of `ReferenceToken` values. */
export type ReferenceTokensConnection = {
  __typename?: 'ReferenceTokensConnection';
  /** A list of edges which contains the `ReferenceToken` and cursor to aid in pagination. */
  edges: Array<ReferenceTokensEdge>;
  /** A list of `ReferenceToken` objects. */
  nodes: Array<Maybe<ReferenceToken>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReferenceToken` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ReferenceToken` edge in the connection. */
export type ReferenceTokensEdge = {
  __typename?: 'ReferenceTokensEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ReferenceToken` at the end of the edge. */
  node?: Maybe<ReferenceToken>;
};

/** Methods to use when ordering `ReferenceToken`. */
export type ReferenceTokensOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TOKEN_ASC'
  | 'TOKEN_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type RelationRole = {
  __typename?: 'RelationRole';
  /** Reads a single `Company` that is related to this `RelationRole`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `FormField` that is related to this `RelationRole`. */
  formField?: Maybe<FormField>;
  formFieldId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  itemIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Role` that is related to this `RelationRole`. */
  role?: Maybe<Role>;
  roleId: Scalars['UUID'];
  /** Reads a single `SystemField` that is related to this `RelationRole`. */
  systemField?: Maybe<SystemField>;
  systemFieldId?: Maybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `RelationRoleInput` mutation. */
export type RelationRoleCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnRelationRoleForRelationRoleCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `relationRole` in the `CompanyInput` mutation. */
export type RelationRoleCompanyIdForeignInverseInput = {
  /** The primary key(s) for `relationRole` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RelationRoleRelationRolePkeyConnect>>;
  /** The primary key(s) and patch data for `relationRole` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RelationRoleOnRelationRoleForRelationRoleCompanyIdForeignUsingRelationRolePkeyUpdate>>;
};

/**
 * A condition to be used against `RelationRole` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RelationRoleCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `itemIds` field. */
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `roleId` field. */
  roleId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `systemFieldId` field. */
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `RelationRole` object types. All fields are combined with a logical ‘and.’ */
export type RelationRoleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RelationRoleFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `formField` relation. */
  formField?: InputMaybe<FormFieldFilter>;
  /** A related `formField` exists. */
  formFieldExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFieldId` field. */
  formFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `itemIds` field. */
  itemIds?: InputMaybe<UuidListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RelationRoleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RelationRoleFilter>>;
  /** Filter by the object’s `role` relation. */
  role?: InputMaybe<RoleFilter>;
  /** Filter by the object’s `roleId` field. */
  roleId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `systemField` relation. */
  systemField?: InputMaybe<SystemFieldFilter>;
  /** A related `systemField` exists. */
  systemFieldExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `systemFieldId` field. */
  systemFieldId?: InputMaybe<UuidFilter>;
};

/** The `formField` to be created by this mutation. */
export type RelationRoleFormFieldIdForeignConnectionFormFieldCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `formField` in the `RelationRoleInput` mutation. */
export type RelationRoleFormFieldIdForeignInput = {
  /** The primary key(s) for `formField` for the far side of the relationship. */
  connectById?: InputMaybe<FormFieldFormFieldPkeyConnect>;
  /** A `FormFieldInput` object that will be created and connected to this object. */
  create?: InputMaybe<RelationRoleFormFieldIdForeignConnectionFormFieldCreateInput>;
  /** The primary key(s) and patch data for `formField` for the far side of the relationship. */
  updateById?: InputMaybe<FormFieldOnRelationRoleForRelationRoleFormFieldIdForeignUsingFormFieldPkeyUpdate>;
};

/** Input for the nested mutation of `relationRole` in the `FormFieldInput` mutation. */
export type RelationRoleFormFieldIdForeignInverseInput = {
  /** The primary key(s) for `relationRole` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RelationRoleRelationRolePkeyConnect>>;
  /** The primary key(s) and patch data for `relationRole` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RelationRoleOnRelationRoleForRelationRoleFormFieldIdForeignUsingRelationRolePkeyUpdate>>;
};

/** The fields on `relationRole` to look up the row to update. */
export type RelationRoleOnRelationRoleForRelationRoleCompanyIdForeignUsingRelationRolePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `relationRole` being updated. */
  patch: UpdateRelationRoleOnRelationRoleForRelationRoleCompanyIdForeignPatch;
};

/** The fields on `relationRole` to look up the row to update. */
export type RelationRoleOnRelationRoleForRelationRoleFormFieldIdForeignUsingRelationRolePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `relationRole` being updated. */
  patch: UpdateRelationRoleOnRelationRoleForRelationRoleFormFieldIdForeignPatch;
};

/** The fields on `relationRole` to look up the row to update. */
export type RelationRoleOnRelationRoleForRelationRoleRoleIdForeignUsingRelationRolePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `relationRole` being updated. */
  patch: UpdateRelationRoleOnRelationRoleForRelationRoleRoleIdForeignPatch;
};

/** The fields on `relationRole` to look up the row to update. */
export type RelationRoleOnRelationRoleForRelationRoleSystemFieldIdForeignUsingRelationRolePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `relationRole` being updated. */
  patch: UpdateRelationRoleOnRelationRoleForRelationRoleSystemFieldIdForeignPatch;
};

/** The fields on `relationRole` to look up the row to connect. */
export type RelationRoleRelationRolePkeyConnect = {
  id: Scalars['UUID'];
};

/** The `role` to be created by this mutation. */
export type RelationRoleRoleIdForeignConnectionRoleCreateInput = {
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleRoleIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  info: Scalars['String'];
  name: Scalars['String'];
  relationRoles?: InputMaybe<RelationRoleRoleIdForeignInverseInput>;
  roleDependenciesToDependentOnUsingId?: InputMaybe<RoleDependencyDependentOnForeignInverseInput>;
  roleDependenciesToRoleIdUsingId?: InputMaybe<RoleDependencyRoleIdForeignInverseInput>;
  scopes?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleRoleIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleRoleIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleRoleIdForeignInverseInput>;
  usesItemIds?: InputMaybe<Scalars['Boolean']>;
};

/** Input for the nested mutation of `role` in the `RelationRoleInput` mutation. */
export type RelationRoleRoleIdForeignInput = {
  /** The primary key(s) for `role` for the far side of the relationship. */
  connectById?: InputMaybe<RoleRolePkeyConnect>;
  /** A `RoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<RelationRoleRoleIdForeignConnectionRoleCreateInput>;
  /** The primary key(s) for `role` for the far side of the relationship. */
  deleteById?: InputMaybe<RoleRolePkeyDelete>;
  /** The primary key(s) and patch data for `role` for the far side of the relationship. */
  updateById?: InputMaybe<RoleOnRelationRoleForRelationRoleRoleIdForeignUsingRolePkeyUpdate>;
};

/** Input for the nested mutation of `relationRole` in the `RoleInput` mutation. */
export type RelationRoleRoleIdForeignInverseInput = {
  /** The primary key(s) for `relationRole` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RelationRoleRelationRolePkeyConnect>>;
  /** The primary key(s) and patch data for `relationRole` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RelationRoleOnRelationRoleForRelationRoleRoleIdForeignUsingRelationRolePkeyUpdate>>;
};

/** Input for the nested mutation of `systemField` in the `RelationRoleInput` mutation. */
export type RelationRoleSystemFieldIdForeignInput = {
  /** The primary key(s) for `systemField` for the far side of the relationship. */
  connectById?: InputMaybe<SystemFieldSystemFieldPkeyConnect>;
  /** The primary key(s) for `systemField` for the far side of the relationship. */
  connectByName?: InputMaybe<SystemFieldSystemFieldNameUniqueConnect>;
  /** The primary key(s) and patch data for `systemField` for the far side of the relationship. */
  updateById?: InputMaybe<SystemFieldOnRelationRoleForRelationRoleSystemFieldIdForeignUsingSystemFieldPkeyUpdate>;
  /** The primary key(s) and patch data for `systemField` for the far side of the relationship. */
  updateByName?: InputMaybe<SystemFieldOnRelationRoleForRelationRoleSystemFieldIdForeignUsingSystemFieldNameUniqueUpdate>;
};

/** Input for the nested mutation of `relationRole` in the `SystemFieldInput` mutation. */
export type RelationRoleSystemFieldIdForeignInverseInput = {
  /** The primary key(s) for `relationRole` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RelationRoleRelationRolePkeyConnect>>;
  /** The primary key(s) and patch data for `relationRole` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RelationRoleOnRelationRoleForRelationRoleSystemFieldIdForeignUsingRelationRolePkeyUpdate>>;
};

/** A connection to a list of `RelationRole` values. */
export type RelationRolesConnection = {
  __typename?: 'RelationRolesConnection';
  /** A list of edges which contains the `RelationRole` and cursor to aid in pagination. */
  edges: Array<RelationRolesEdge>;
  /** A list of `RelationRole` objects. */
  nodes: Array<Maybe<RelationRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RelationRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RelationRole` edge in the connection. */
export type RelationRolesEdge = {
  __typename?: 'RelationRolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RelationRole` at the end of the edge. */
  node?: Maybe<RelationRole>;
};

/** Methods to use when ordering `RelationRole`. */
export type RelationRolesOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ACTIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_FORM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_GROUP_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__APPROVER_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CARD_ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CHANGES_MUST_BE_APPROVED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__COMPANY_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CREATED_AT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__CUSTOM_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEFAULT_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENTS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__DEPARTMENT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ENGAGEMENT_TYPE_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EVENT_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__EXCLUDED_ROLE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_CARD_COLUMN_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_GROUP_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__FIELD_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__HELP_TEXT_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__LOCALIZED_NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__METADATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__MULTIPLE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__NAME_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__OBJECT_TYPE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__ORDER_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PARENT_FORM_FIELD_ID_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PREBOARDING_ASSIGNED_USER_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__PRODUCT_TYPE_IDS_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__REQUIRED_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SENSITIVE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__SUPPORTS_FUTURE_DATA_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UNIQUE_VALUE_DESC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_ASC'
  | 'FORM_FIELD_BY_FORM_FIELD_ID__UPDATED_AT_DESC'
  | 'FORM_FIELD_ID_ASC'
  | 'FORM_FIELD_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'ITEM_IDS_ASC'
  | 'ITEM_IDS_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROLE_BY_ROLE_ID__COMPANY_ID_ASC'
  | 'ROLE_BY_ROLE_ID__COMPANY_ID_DESC'
  | 'ROLE_BY_ROLE_ID__DESCRIPTION_ASC'
  | 'ROLE_BY_ROLE_ID__DESCRIPTION_DESC'
  | 'ROLE_BY_ROLE_ID__ID_ASC'
  | 'ROLE_BY_ROLE_ID__ID_DESC'
  | 'ROLE_BY_ROLE_ID__INFO_ASC'
  | 'ROLE_BY_ROLE_ID__INFO_DESC'
  | 'ROLE_BY_ROLE_ID__NAME_ASC'
  | 'ROLE_BY_ROLE_ID__NAME_DESC'
  | 'ROLE_BY_ROLE_ID__SCOPES_ASC'
  | 'ROLE_BY_ROLE_ID__SCOPES_DESC'
  | 'ROLE_BY_ROLE_ID__USES_ITEM_IDS_ASC'
  | 'ROLE_BY_ROLE_ID__USES_ITEM_IDS_DESC'
  | 'ROLE_ID_ASC'
  | 'ROLE_ID_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ALWAYS_REQUIRED_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ALWAYS_REQUIRED_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__DOCUMENT_TEMPLATE_PLACEHOLDER_NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__DOCUMENT_TEMPLATE_PLACEHOLDER_NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__EXCLUDE_FROM_PLACEHOLDER_FORM_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__EXCLUDE_FROM_PLACEHOLDER_FORM_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ID_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ID_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READABLE_NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READABLE_NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READ_ONLY_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READ_ONLY_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__TYPE_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__TYPE_DESC'
  | 'SYSTEM_FIELD_ID_ASC'
  | 'SYSTEM_FIELD_ID_DESC';

/** All input for the `removeCompanyRoleFromUser` mutation. */
export type RemoveCompanyRoleFromUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our `removeCompanyRoleFromUser` mutation. */
export type RemoveCompanyRoleFromUserPayload = {
  __typename?: 'RemoveCompanyRoleFromUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `removeDepartmentRoleFromUser` mutation. */
export type RemoveDepartmentRoleFromUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  departmentId: Scalars['UUID'];
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our `removeDepartmentRoleFromUser` mutation. */
export type RemoveDepartmentRoleFromUserPayload = {
  __typename?: 'RemoveDepartmentRoleFromUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `removeRoleFromGroup` mutation. */
export type RemoveRoleFromGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupId: Scalars['UUID'];
  roleId: Scalars['UUID'];
};

/** The output of our `removeRoleFromGroup` mutation. */
export type RemoveRoleFromGroupPayload = {
  __typename?: 'RemoveRoleFromGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `removeRoleFromUser` mutation. */
export type RemoveRoleFromUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our `removeRoleFromUser` mutation. */
export type RemoveRoleFromUserPayload = {
  __typename?: 'RemoveRoleFromUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A connection to a list of `ResetFormCompaniesRecord` values. */
export type ResetFormCompaniesConnection = {
  __typename?: 'ResetFormCompaniesConnection';
  /** A list of edges which contains the `ResetFormCompaniesRecord` and cursor to aid in pagination. */
  edges: Array<ResetFormCompanyEdge>;
  /** A list of `ResetFormCompaniesRecord` objects. */
  nodes: Array<Maybe<ResetFormCompaniesRecord>>;
  /** The count of *all* `ResetFormCompaniesRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The return type of our `resetFormCompanies` query. */
export type ResetFormCompaniesRecord = {
  __typename?: 'ResetFormCompaniesRecord';
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
};

/** A filter to be used against `ResetFormCompaniesRecord` object types. All fields are combined with a logical ‘and.’ */
export type ResetFormCompaniesRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ResetFormCompaniesRecordFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ResetFormCompaniesRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ResetFormCompaniesRecordFilter>>;
};

/** A `ResetFormCompaniesRecord` edge in the connection. */
export type ResetFormCompanyEdge = {
  __typename?: 'ResetFormCompanyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ResetFormCompaniesRecord` at the end of the edge. */
  node?: Maybe<ResetFormCompaniesRecord>;
};

export type RoadmapItem = {
  __typename?: 'RoadmapItem';
  active: Scalars['Boolean'];
  commentCount?: Maybe<Scalars['BigInt']>;
  createdAt: Scalars['Datetime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  needToHaveVoteCount?: Maybe<Scalars['BigInt']>;
  niceToHaveVoteCount?: Maybe<Scalars['BigInt']>;
  /** Reads and enables pagination through a set of `RoadmapItemComment`. */
  roadmapItemComments: RoadmapItemCommentsConnection;
  /** Reads and enables pagination through a set of `RoadmapItemLocalization`. */
  roadmapItemLocalizations: RoadmapItemLocalizationsConnection;
  /** Reads and enables pagination through a set of `RoadmapItemVote`. */
  roadmapItemVotes: RoadmapItemVotesConnection;
  stage: RoadmapStage;
  summary?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};


export type RoadmapItemRoadmapItemCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoadmapItemCommentCondition>;
  filter?: InputMaybe<RoadmapItemCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoadmapItemCommentsOrderBy>>;
};


export type RoadmapItemRoadmapItemLocalizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoadmapItemLocalizationCondition>;
  filter?: InputMaybe<RoadmapItemLocalizationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoadmapItemLocalizationsOrderBy>>;
};


export type RoadmapItemRoadmapItemVotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoadmapItemVoteCondition>;
  filter?: InputMaybe<RoadmapItemVoteFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoadmapItemVotesOrderBy>>;
};

export type RoadmapItemComment = {
  __typename?: 'RoadmapItemComment';
  active: Scalars['Boolean'];
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** Reads a single `User` that is related to this `RoadmapItemComment`. */
  oldUser?: Maybe<User>;
  /** Reads a single `RoadmapItem` that is related to this `RoadmapItemComment`. */
  roadmapItem?: Maybe<RoadmapItem>;
  roadmapItemId: Scalars['UUID'];
  user?: Maybe<RoadmapItemCommentUserRecord>;
  userId: Scalars['UUID'];
};

/**
 * A condition to be used against `RoadmapItemComment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoadmapItemCommentCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `comment` field. */
  comment?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roadmapItemId` field. */
  roadmapItemId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `RoadmapItemComment` object types. All fields are combined with a logical ‘and.’ */
export type RoadmapItemCommentFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoadmapItemCommentFilter>>;
  /** Filter by the object’s `comment` field. */
  comment?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoadmapItemCommentFilter>;
  /** Filter by the object’s `oldUser` relation. */
  oldUser?: InputMaybe<UserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoadmapItemCommentFilter>>;
  /** Filter by the object’s `roadmapItem` relation. */
  roadmapItem?: InputMaybe<RoadmapItemFilter>;
  /** Filter by the object’s `roadmapItemId` field. */
  roadmapItemId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `RoadmapItemComment` */
export type RoadmapItemCommentInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  oldUser?: InputMaybe<RoadmapItemCommentUserIdForeignInput>;
  roadmapItem?: InputMaybe<RoadmapItemCommentRoadmapItemIdForeignInput>;
  roadmapItemId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `roadmapItemComment` to look up the row to update. */
export type RoadmapItemCommentOnRoadmapItemCommentForRoadmapItemCommentRoadmapItemIdForeignUsingRoadmapItemCommentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roadmapItemComment` being updated. */
  patch: UpdateRoadmapItemCommentOnRoadmapItemCommentForRoadmapItemCommentRoadmapItemIdForeignPatch;
};

/** The fields on `roadmapItemComment` to look up the row to update. */
export type RoadmapItemCommentOnRoadmapItemCommentForRoadmapItemCommentUserIdForeignUsingRoadmapItemCommentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roadmapItemComment` being updated. */
  patch: UpdateRoadmapItemCommentOnRoadmapItemCommentForRoadmapItemCommentUserIdForeignPatch;
};

/** Represents an update to a `RoadmapItemComment`. Fields that are set will be updated. */
export type RoadmapItemCommentPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  oldUser?: InputMaybe<RoadmapItemCommentUserIdForeignInput>;
  roadmapItem?: InputMaybe<RoadmapItemCommentRoadmapItemIdForeignInput>;
  roadmapItemId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `roadmapItemComment` to look up the row to connect. */
export type RoadmapItemCommentRoadmapItemCommentPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `roadmapItemComment` to be created by this mutation. */
export type RoadmapItemCommentRoadmapItemIdForeignConnectionRoadmapItemCommentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  oldUser?: InputMaybe<RoadmapItemCommentUserIdForeignInput>;
  roadmapItem?: InputMaybe<RoadmapItemCommentRoadmapItemIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `roadmapItem` to be created by this mutation. */
export type RoadmapItemCommentRoadmapItemIdForeignConnectionRoadmapItemCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentRoadmapItemIdForeignInverseInput>;
  roadmapItemLocalizations?: InputMaybe<RoadmapItemLocalizationRoadmapItemIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteRoadmapItemIdForeignInverseInput>;
  stage: RoadmapStage;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `roadmapItem` in the `RoadmapItemCommentInput` mutation. */
export type RoadmapItemCommentRoadmapItemIdForeignInput = {
  /** The primary key(s) for `roadmapItem` for the far side of the relationship. */
  connectById?: InputMaybe<RoadmapItemRoadmapItemPkeyConnect>;
  /** A `RoadmapItemInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoadmapItemCommentRoadmapItemIdForeignConnectionRoadmapItemCreateInput>;
  /** The primary key(s) and patch data for `roadmapItem` for the far side of the relationship. */
  updateById?: InputMaybe<RoadmapItemOnRoadmapItemCommentForRoadmapItemCommentRoadmapItemIdForeignUsingRoadmapItemPkeyUpdate>;
};

/** Input for the nested mutation of `roadmapItemComment` in the `RoadmapItemInput` mutation. */
export type RoadmapItemCommentRoadmapItemIdForeignInverseInput = {
  /** The primary key(s) for `roadmapItemComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoadmapItemCommentRoadmapItemCommentPkeyConnect>>;
  /** A `RoadmapItemCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoadmapItemCommentRoadmapItemIdForeignConnectionRoadmapItemCommentCreateInput>>;
  /** The primary key(s) and patch data for `roadmapItemComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoadmapItemCommentOnRoadmapItemCommentForRoadmapItemCommentRoadmapItemIdForeignUsingRoadmapItemCommentPkeyUpdate>>;
};

/** The `roadmapItemComment` to be created by this mutation. */
export type RoadmapItemCommentUserIdForeignConnectionRoadmapItemCommentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  oldUser?: InputMaybe<RoadmapItemCommentUserIdForeignInput>;
  roadmapItem?: InputMaybe<RoadmapItemCommentRoadmapItemIdForeignInput>;
  roadmapItemId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `user` in the `RoadmapItemCommentInput` mutation. */
export type RoadmapItemCommentUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnRoadmapItemCommentForRoadmapItemCommentUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `roadmapItemComment` in the `UserInput` mutation. */
export type RoadmapItemCommentUserIdForeignInverseInput = {
  /** The primary key(s) for `roadmapItemComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoadmapItemCommentRoadmapItemCommentPkeyConnect>>;
  /** A `RoadmapItemCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoadmapItemCommentUserIdForeignConnectionRoadmapItemCommentCreateInput>>;
  /** The primary key(s) and patch data for `roadmapItemComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoadmapItemCommentOnRoadmapItemCommentForRoadmapItemCommentUserIdForeignUsingRoadmapItemCommentPkeyUpdate>>;
};

/** The return type of our `user` query. */
export type RoadmapItemCommentUserRecord = {
  __typename?: 'RoadmapItemCommentUserRecord';
  company?: Maybe<Company>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  logo?: Maybe<Scalars['String']>;
};

/** A connection to a list of `RoadmapItemComment` values. */
export type RoadmapItemCommentsConnection = {
  __typename?: 'RoadmapItemCommentsConnection';
  /** A list of edges which contains the `RoadmapItemComment` and cursor to aid in pagination. */
  edges: Array<RoadmapItemCommentsEdge>;
  /** A list of `RoadmapItemComment` objects. */
  nodes: Array<Maybe<RoadmapItemComment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoadmapItemComment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoadmapItemComment` edge in the connection. */
export type RoadmapItemCommentsEdge = {
  __typename?: 'RoadmapItemCommentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoadmapItemComment` at the end of the edge. */
  node?: Maybe<RoadmapItemComment>;
};

/** Methods to use when ordering `RoadmapItemComment`. */
export type RoadmapItemCommentsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMMENT_ASC'
  | 'COMMENT_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__ACTIVE_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__ACTIVE_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__COMMENT_COUNT_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__COMMENT_COUNT_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__CREATED_AT_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__CREATED_AT_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__ID_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__ID_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__NAME_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__NAME_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__NEED_TO_HAVE_VOTE_COUNT_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__NEED_TO_HAVE_VOTE_COUNT_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__NICE_TO_HAVE_VOTE_COUNT_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__NICE_TO_HAVE_VOTE_COUNT_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__STAGE_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__STAGE_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__UPDATED_AT_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__UPDATED_AT_DESC'
  | 'ROADMAP_ITEM_ID_ASC'
  | 'ROADMAP_ITEM_ID_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/**
 * A condition to be used against `RoadmapItem` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type RoadmapItemCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `stage` field. */
  stage?: InputMaybe<RoadmapStage>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `RoadmapItem` object types. All fields are combined with a logical ‘and.’ */
export type RoadmapItemFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoadmapItemFilter>>;
  /** Filter by the object’s `commentCount` field. */
  commentCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `needToHaveVoteCount` field. */
  needToHaveVoteCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `niceToHaveVoteCount` field. */
  niceToHaveVoteCount?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoadmapItemFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoadmapItemFilter>>;
  /** Filter by the object’s `roadmapItemComments` relation. */
  roadmapItemComments?: InputMaybe<RoadmapItemToManyRoadmapItemCommentFilter>;
  /** Some related `roadmapItemComments` exist. */
  roadmapItemCommentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roadmapItemLocalizations` relation. */
  roadmapItemLocalizations?: InputMaybe<RoadmapItemToManyRoadmapItemLocalizationFilter>;
  /** Some related `roadmapItemLocalizations` exist. */
  roadmapItemLocalizationsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roadmapItemVotes` relation. */
  roadmapItemVotes?: InputMaybe<RoadmapItemToManyRoadmapItemVoteFilter>;
  /** Some related `roadmapItemVotes` exist. */
  roadmapItemVotesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `stage` field. */
  stage?: InputMaybe<RoadmapStageFilter>;
  /** Filter by the object’s `summary` field. */
  summary?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `RoadmapItem` */
export type RoadmapItemInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentRoadmapItemIdForeignInverseInput>;
  roadmapItemLocalizations?: InputMaybe<RoadmapItemLocalizationRoadmapItemIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteRoadmapItemIdForeignInverseInput>;
  stage: RoadmapStage;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type RoadmapItemLocalization = {
  __typename?: 'RoadmapItemLocalization';
  description: Scalars['String'];
  id: Scalars['UUID'];
  locale: Scalars['String'];
  name: Scalars['String'];
  /** Reads a single `RoadmapItem` that is related to this `RoadmapItemLocalization`. */
  roadmapItem?: Maybe<RoadmapItem>;
  roadmapItemId: Scalars['UUID'];
  summary: Scalars['String'];
};

/**
 * A condition to be used against `RoadmapItemLocalization` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type RoadmapItemLocalizationCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `locale` field. */
  locale?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `roadmapItemId` field. */
  roadmapItemId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `summary` field. */
  summary?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `RoadmapItemLocalization` object types. All fields are combined with a logical ‘and.’ */
export type RoadmapItemLocalizationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoadmapItemLocalizationFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `locale` field. */
  locale?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoadmapItemLocalizationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoadmapItemLocalizationFilter>>;
  /** Filter by the object’s `roadmapItem` relation. */
  roadmapItem?: InputMaybe<RoadmapItemFilter>;
  /** Filter by the object’s `roadmapItemId` field. */
  roadmapItemId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `summary` field. */
  summary?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoadmapItemLocalization` */
export type RoadmapItemLocalizationInput = {
  description: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  locale: Scalars['String'];
  name: Scalars['String'];
  roadmapItem?: InputMaybe<RoadmapItemLocalizationRoadmapItemIdForeignInput>;
  roadmapItemId?: InputMaybe<Scalars['UUID']>;
  summary: Scalars['String'];
};

/** The fields on `roadmapItemLocalization` to look up the row to update. */
export type RoadmapItemLocalizationOnRoadmapItemLocalizationForRoadmapItemLocalizationRoadmapItemIdForeignUsingRoadmapItemLocalizationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roadmapItemLocalization` being updated. */
  patch: UpdateRoadmapItemLocalizationOnRoadmapItemLocalizationForRoadmapItemLocalizationRoadmapItemIdForeignPatch;
};

/** The fields on `roadmapItemLocalization` to look up the row to update. */
export type RoadmapItemLocalizationOnRoadmapItemLocalizationForRoadmapItemLocalizationRoadmapItemIdForeignUsingRoadmapItemLocalizationRoadmapItemIdLocaleUniqueUpdate = {
  locale: Scalars['String'];
  /** An object where the defined keys will be set on the `roadmapItemLocalization` being updated. */
  patch: UpdateRoadmapItemLocalizationOnRoadmapItemLocalizationForRoadmapItemLocalizationRoadmapItemIdForeignPatch;
  roadmapItemId: Scalars['UUID'];
};

/** Represents an update to a `RoadmapItemLocalization`. Fields that are set will be updated. */
export type RoadmapItemLocalizationPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  roadmapItem?: InputMaybe<RoadmapItemLocalizationRoadmapItemIdForeignInput>;
  roadmapItemId?: InputMaybe<Scalars['UUID']>;
  summary?: InputMaybe<Scalars['String']>;
};

/** The `roadmapItem` to be created by this mutation. */
export type RoadmapItemLocalizationRoadmapItemIdForeignConnectionRoadmapItemCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentRoadmapItemIdForeignInverseInput>;
  roadmapItemLocalizations?: InputMaybe<RoadmapItemLocalizationRoadmapItemIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteRoadmapItemIdForeignInverseInput>;
  stage: RoadmapStage;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `roadmapItemLocalization` to be created by this mutation. */
export type RoadmapItemLocalizationRoadmapItemIdForeignConnectionRoadmapItemLocalizationCreateInput = {
  description: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  locale: Scalars['String'];
  name: Scalars['String'];
  roadmapItem?: InputMaybe<RoadmapItemLocalizationRoadmapItemIdForeignInput>;
  summary: Scalars['String'];
};

/** Input for the nested mutation of `roadmapItem` in the `RoadmapItemLocalizationInput` mutation. */
export type RoadmapItemLocalizationRoadmapItemIdForeignInput = {
  /** The primary key(s) for `roadmapItem` for the far side of the relationship. */
  connectById?: InputMaybe<RoadmapItemRoadmapItemPkeyConnect>;
  /** A `RoadmapItemInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoadmapItemLocalizationRoadmapItemIdForeignConnectionRoadmapItemCreateInput>;
  /** The primary key(s) and patch data for `roadmapItem` for the far side of the relationship. */
  updateById?: InputMaybe<RoadmapItemOnRoadmapItemLocalizationForRoadmapItemLocalizationRoadmapItemIdForeignUsingRoadmapItemPkeyUpdate>;
};

/** Input for the nested mutation of `roadmapItemLocalization` in the `RoadmapItemInput` mutation. */
export type RoadmapItemLocalizationRoadmapItemIdForeignInverseInput = {
  /** The primary key(s) for `roadmapItemLocalization` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoadmapItemLocalizationRoadmapItemLocalizationPkeyConnect>>;
  /** The primary key(s) for `roadmapItemLocalization` for the far side of the relationship. */
  connectByRoadmapItemIdAndLocale?: InputMaybe<Array<RoadmapItemLocalizationRoadmapItemLocalizationRoadmapItemIdLocaleUniqueConnect>>;
  /** A `RoadmapItemLocalizationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoadmapItemLocalizationRoadmapItemIdForeignConnectionRoadmapItemLocalizationCreateInput>>;
  /** The primary key(s) for `roadmapItemLocalization` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoadmapItemLocalizationRoadmapItemLocalizationPkeyDelete>>;
  /** The primary key(s) for `roadmapItemLocalization` for the far side of the relationship. */
  deleteByRoadmapItemIdAndLocale?: InputMaybe<Array<RoadmapItemLocalizationRoadmapItemLocalizationRoadmapItemIdLocaleUniqueDelete>>;
  /** Flag indicating whether all other `roadmapItemLocalization` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roadmapItemLocalization` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoadmapItemLocalizationOnRoadmapItemLocalizationForRoadmapItemLocalizationRoadmapItemIdForeignUsingRoadmapItemLocalizationPkeyUpdate>>;
  /** The primary key(s) and patch data for `roadmapItemLocalization` for the far side of the relationship. */
  updateByRoadmapItemIdAndLocale?: InputMaybe<Array<RoadmapItemLocalizationOnRoadmapItemLocalizationForRoadmapItemLocalizationRoadmapItemIdForeignUsingRoadmapItemLocalizationRoadmapItemIdLocaleUniqueUpdate>>;
};

/** The fields on `roadmapItemLocalization` to look up the row to connect. */
export type RoadmapItemLocalizationRoadmapItemLocalizationPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roadmapItemLocalization` to look up the row to delete. */
export type RoadmapItemLocalizationRoadmapItemLocalizationPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `roadmapItemLocalization` to look up the row to connect. */
export type RoadmapItemLocalizationRoadmapItemLocalizationRoadmapItemIdLocaleUniqueConnect = {
  locale: Scalars['String'];
  roadmapItemId: Scalars['UUID'];
};

/** The fields on `roadmapItemLocalization` to look up the row to delete. */
export type RoadmapItemLocalizationRoadmapItemLocalizationRoadmapItemIdLocaleUniqueDelete = {
  locale: Scalars['String'];
  roadmapItemId: Scalars['UUID'];
};

/** A connection to a list of `RoadmapItemLocalization` values. */
export type RoadmapItemLocalizationsConnection = {
  __typename?: 'RoadmapItemLocalizationsConnection';
  /** A list of edges which contains the `RoadmapItemLocalization` and cursor to aid in pagination. */
  edges: Array<RoadmapItemLocalizationsEdge>;
  /** A list of `RoadmapItemLocalization` objects. */
  nodes: Array<Maybe<RoadmapItemLocalization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoadmapItemLocalization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoadmapItemLocalization` edge in the connection. */
export type RoadmapItemLocalizationsEdge = {
  __typename?: 'RoadmapItemLocalizationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoadmapItemLocalization` at the end of the edge. */
  node?: Maybe<RoadmapItemLocalization>;
};

/** Methods to use when ordering `RoadmapItemLocalization`. */
export type RoadmapItemLocalizationsOrderBy =
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALE_ASC'
  | 'LOCALE_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__ACTIVE_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__ACTIVE_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__COMMENT_COUNT_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__COMMENT_COUNT_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__CREATED_AT_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__CREATED_AT_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__ID_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__ID_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__NAME_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__NAME_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__NEED_TO_HAVE_VOTE_COUNT_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__NEED_TO_HAVE_VOTE_COUNT_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__NICE_TO_HAVE_VOTE_COUNT_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__NICE_TO_HAVE_VOTE_COUNT_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__STAGE_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__STAGE_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__UPDATED_AT_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__UPDATED_AT_DESC'
  | 'ROADMAP_ITEM_ID_ASC'
  | 'ROADMAP_ITEM_ID_DESC'
  | 'SUMMARY_ASC'
  | 'SUMMARY_DESC';

/** The fields on `roadmapItem` to look up the row to update. */
export type RoadmapItemOnRoadmapItemCommentForRoadmapItemCommentRoadmapItemIdForeignUsingRoadmapItemPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roadmapItem` being updated. */
  patch: UpdateRoadmapItemOnRoadmapItemCommentForRoadmapItemCommentRoadmapItemIdForeignPatch;
};

/** The fields on `roadmapItem` to look up the row to update. */
export type RoadmapItemOnRoadmapItemLocalizationForRoadmapItemLocalizationRoadmapItemIdForeignUsingRoadmapItemPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roadmapItem` being updated. */
  patch: UpdateRoadmapItemOnRoadmapItemLocalizationForRoadmapItemLocalizationRoadmapItemIdForeignPatch;
};

/** The fields on `roadmapItem` to look up the row to update. */
export type RoadmapItemOnRoadmapItemVoteForRoadmapItemVoteRoadmapItemIdForeignUsingRoadmapItemPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roadmapItem` being updated. */
  patch: UpdateRoadmapItemOnRoadmapItemVoteForRoadmapItemVoteRoadmapItemIdForeignPatch;
};

/** Represents an update to a `RoadmapItem`. Fields that are set will be updated. */
export type RoadmapItemPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentRoadmapItemIdForeignInverseInput>;
  roadmapItemLocalizations?: InputMaybe<RoadmapItemLocalizationRoadmapItemIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteRoadmapItemIdForeignInverseInput>;
  stage?: InputMaybe<RoadmapStage>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `roadmapItem` to look up the row to connect. */
export type RoadmapItemRoadmapItemPkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `RoadmapItemComment` object types. All fields are combined with a logical ‘and.’ */
export type RoadmapItemToManyRoadmapItemCommentFilter = {
  /** Every related `RoadmapItemComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoadmapItemCommentFilter>;
  /** No related `RoadmapItemComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoadmapItemCommentFilter>;
  /** Some related `RoadmapItemComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoadmapItemCommentFilter>;
};

/** A filter to be used against many `RoadmapItemLocalization` object types. All fields are combined with a logical ‘and.’ */
export type RoadmapItemToManyRoadmapItemLocalizationFilter = {
  /** Every related `RoadmapItemLocalization` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoadmapItemLocalizationFilter>;
  /** No related `RoadmapItemLocalization` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoadmapItemLocalizationFilter>;
  /** Some related `RoadmapItemLocalization` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoadmapItemLocalizationFilter>;
};

/** A filter to be used against many `RoadmapItemVote` object types. All fields are combined with a logical ‘and.’ */
export type RoadmapItemToManyRoadmapItemVoteFilter = {
  /** Every related `RoadmapItemVote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoadmapItemVoteFilter>;
  /** No related `RoadmapItemVote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoadmapItemVoteFilter>;
  /** Some related `RoadmapItemVote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoadmapItemVoteFilter>;
};

export type RoadmapItemVote = {
  __typename?: 'RoadmapItemVote';
  id: Scalars['UUID'];
  /** Reads a single `RoadmapItem` that is related to this `RoadmapItemVote`. */
  roadmapItem?: Maybe<RoadmapItem>;
  roadmapItemId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `RoadmapItemVote`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
  voteType: RoadmapItemVoteType;
};

/**
 * A condition to be used against `RoadmapItemVote` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoadmapItemVoteCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roadmapItemId` field. */
  roadmapItemId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `voteType` field. */
  voteType?: InputMaybe<RoadmapItemVoteType>;
};

/** A filter to be used against `RoadmapItemVote` object types. All fields are combined with a logical ‘and.’ */
export type RoadmapItemVoteFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoadmapItemVoteFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoadmapItemVoteFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoadmapItemVoteFilter>>;
  /** Filter by the object’s `roadmapItem` relation. */
  roadmapItem?: InputMaybe<RoadmapItemFilter>;
  /** Filter by the object’s `roadmapItemId` field. */
  roadmapItemId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `voteType` field. */
  voteType?: InputMaybe<RoadmapItemVoteTypeFilter>;
};

/** An input for mutations affecting `RoadmapItemVote` */
export type RoadmapItemVoteInput = {
  id?: InputMaybe<Scalars['UUID']>;
  roadmapItem?: InputMaybe<RoadmapItemVoteRoadmapItemIdForeignInput>;
  roadmapItemId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<RoadmapItemVoteUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  voteType: RoadmapItemVoteType;
};

/** The fields on `roadmapItemVote` to look up the row to update. */
export type RoadmapItemVoteOnRoadmapItemVoteForRoadmapItemVoteRoadmapItemIdForeignUsingRoadmapItemVotePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roadmapItemVote` being updated. */
  patch: UpdateRoadmapItemVoteOnRoadmapItemVoteForRoadmapItemVoteRoadmapItemIdForeignPatch;
};

/** The fields on `roadmapItemVote` to look up the row to update. */
export type RoadmapItemVoteOnRoadmapItemVoteForRoadmapItemVoteRoadmapItemIdForeignUsingRoadmapItemVoteUserIdRoadmapItemIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `roadmapItemVote` being updated. */
  patch: UpdateRoadmapItemVoteOnRoadmapItemVoteForRoadmapItemVoteRoadmapItemIdForeignPatch;
  roadmapItemId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `roadmapItemVote` to look up the row to update. */
export type RoadmapItemVoteOnRoadmapItemVoteForRoadmapItemVoteUserIdForeignUsingRoadmapItemVotePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roadmapItemVote` being updated. */
  patch: UpdateRoadmapItemVoteOnRoadmapItemVoteForRoadmapItemVoteUserIdForeignPatch;
};

/** The fields on `roadmapItemVote` to look up the row to update. */
export type RoadmapItemVoteOnRoadmapItemVoteForRoadmapItemVoteUserIdForeignUsingRoadmapItemVoteUserIdRoadmapItemIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `roadmapItemVote` being updated. */
  patch: UpdateRoadmapItemVoteOnRoadmapItemVoteForRoadmapItemVoteUserIdForeignPatch;
  roadmapItemId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** Represents an update to a `RoadmapItemVote`. Fields that are set will be updated. */
export type RoadmapItemVotePatch = {
  id?: InputMaybe<Scalars['UUID']>;
  roadmapItem?: InputMaybe<RoadmapItemVoteRoadmapItemIdForeignInput>;
  roadmapItemId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<RoadmapItemVoteUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  voteType?: InputMaybe<RoadmapItemVoteType>;
};

/** The `roadmapItem` to be created by this mutation. */
export type RoadmapItemVoteRoadmapItemIdForeignConnectionRoadmapItemCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentRoadmapItemIdForeignInverseInput>;
  roadmapItemLocalizations?: InputMaybe<RoadmapItemLocalizationRoadmapItemIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteRoadmapItemIdForeignInverseInput>;
  stage: RoadmapStage;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `roadmapItemVote` to be created by this mutation. */
export type RoadmapItemVoteRoadmapItemIdForeignConnectionRoadmapItemVoteCreateInput = {
  id?: InputMaybe<Scalars['UUID']>;
  roadmapItem?: InputMaybe<RoadmapItemVoteRoadmapItemIdForeignInput>;
  user?: InputMaybe<RoadmapItemVoteUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  voteType: RoadmapItemVoteType;
};

/** Input for the nested mutation of `roadmapItem` in the `RoadmapItemVoteInput` mutation. */
export type RoadmapItemVoteRoadmapItemIdForeignInput = {
  /** The primary key(s) for `roadmapItem` for the far side of the relationship. */
  connectById?: InputMaybe<RoadmapItemRoadmapItemPkeyConnect>;
  /** A `RoadmapItemInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoadmapItemVoteRoadmapItemIdForeignConnectionRoadmapItemCreateInput>;
  /** The primary key(s) and patch data for `roadmapItem` for the far side of the relationship. */
  updateById?: InputMaybe<RoadmapItemOnRoadmapItemVoteForRoadmapItemVoteRoadmapItemIdForeignUsingRoadmapItemPkeyUpdate>;
};

/** Input for the nested mutation of `roadmapItemVote` in the `RoadmapItemInput` mutation. */
export type RoadmapItemVoteRoadmapItemIdForeignInverseInput = {
  /** The primary key(s) for `roadmapItemVote` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoadmapItemVoteRoadmapItemVotePkeyConnect>>;
  /** The primary key(s) for `roadmapItemVote` for the far side of the relationship. */
  connectByUserIdAndRoadmapItemId?: InputMaybe<Array<RoadmapItemVoteRoadmapItemVoteUserIdRoadmapItemIdUniqueConnect>>;
  /** A `RoadmapItemVoteInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoadmapItemVoteRoadmapItemIdForeignConnectionRoadmapItemVoteCreateInput>>;
  /** The primary key(s) for `roadmapItemVote` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoadmapItemVoteRoadmapItemVotePkeyDelete>>;
  /** The primary key(s) for `roadmapItemVote` for the far side of the relationship. */
  deleteByUserIdAndRoadmapItemId?: InputMaybe<Array<RoadmapItemVoteRoadmapItemVoteUserIdRoadmapItemIdUniqueDelete>>;
  /** Flag indicating whether all other `roadmapItemVote` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roadmapItemVote` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoadmapItemVoteOnRoadmapItemVoteForRoadmapItemVoteRoadmapItemIdForeignUsingRoadmapItemVotePkeyUpdate>>;
  /** The primary key(s) and patch data for `roadmapItemVote` for the far side of the relationship. */
  updateByUserIdAndRoadmapItemId?: InputMaybe<Array<RoadmapItemVoteOnRoadmapItemVoteForRoadmapItemVoteRoadmapItemIdForeignUsingRoadmapItemVoteUserIdRoadmapItemIdUniqueUpdate>>;
};

/** The fields on `roadmapItemVote` to look up the row to connect. */
export type RoadmapItemVoteRoadmapItemVotePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `roadmapItemVote` to look up the row to delete. */
export type RoadmapItemVoteRoadmapItemVotePkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `roadmapItemVote` to look up the row to connect. */
export type RoadmapItemVoteRoadmapItemVoteUserIdRoadmapItemIdUniqueConnect = {
  roadmapItemId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `roadmapItemVote` to look up the row to delete. */
export type RoadmapItemVoteRoadmapItemVoteUserIdRoadmapItemIdUniqueDelete = {
  roadmapItemId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

export type RoadmapItemVoteType =
  /** A feature that is needed. */
  | 'NEED_TO_HAVE'
  /** A feature that is nice to have. */
  | 'NICE_TO_HAVE';

/** A filter to be used against RoadmapItemVoteType fields. All fields are combined with a logical ‘and.’ */
export type RoadmapItemVoteTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<RoadmapItemVoteType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<RoadmapItemVoteType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<RoadmapItemVoteType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<RoadmapItemVoteType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<RoadmapItemVoteType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<RoadmapItemVoteType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<RoadmapItemVoteType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<RoadmapItemVoteType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<RoadmapItemVoteType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<RoadmapItemVoteType>>;
};

/** The `roadmapItemVote` to be created by this mutation. */
export type RoadmapItemVoteUserIdForeignConnectionRoadmapItemVoteCreateInput = {
  id?: InputMaybe<Scalars['UUID']>;
  roadmapItem?: InputMaybe<RoadmapItemVoteRoadmapItemIdForeignInput>;
  roadmapItemId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<RoadmapItemVoteUserIdForeignInput>;
  voteType: RoadmapItemVoteType;
};

/** Input for the nested mutation of `user` in the `RoadmapItemVoteInput` mutation. */
export type RoadmapItemVoteUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnRoadmapItemVoteForRoadmapItemVoteUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `roadmapItemVote` in the `UserInput` mutation. */
export type RoadmapItemVoteUserIdForeignInverseInput = {
  /** The primary key(s) for `roadmapItemVote` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RoadmapItemVoteRoadmapItemVotePkeyConnect>>;
  /** The primary key(s) for `roadmapItemVote` for the far side of the relationship. */
  connectByUserIdAndRoadmapItemId?: InputMaybe<Array<RoadmapItemVoteRoadmapItemVoteUserIdRoadmapItemIdUniqueConnect>>;
  /** A `RoadmapItemVoteInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RoadmapItemVoteUserIdForeignConnectionRoadmapItemVoteCreateInput>>;
  /** The primary key(s) for `roadmapItemVote` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RoadmapItemVoteRoadmapItemVotePkeyDelete>>;
  /** The primary key(s) for `roadmapItemVote` for the far side of the relationship. */
  deleteByUserIdAndRoadmapItemId?: InputMaybe<Array<RoadmapItemVoteRoadmapItemVoteUserIdRoadmapItemIdUniqueDelete>>;
  /** Flag indicating whether all other `roadmapItemVote` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `roadmapItemVote` for the far side of the relationship. */
  updateById?: InputMaybe<Array<RoadmapItemVoteOnRoadmapItemVoteForRoadmapItemVoteUserIdForeignUsingRoadmapItemVotePkeyUpdate>>;
  /** The primary key(s) and patch data for `roadmapItemVote` for the far side of the relationship. */
  updateByUserIdAndRoadmapItemId?: InputMaybe<Array<RoadmapItemVoteOnRoadmapItemVoteForRoadmapItemVoteUserIdForeignUsingRoadmapItemVoteUserIdRoadmapItemIdUniqueUpdate>>;
};

/** A connection to a list of `RoadmapItemVote` values. */
export type RoadmapItemVotesConnection = {
  __typename?: 'RoadmapItemVotesConnection';
  /** A list of edges which contains the `RoadmapItemVote` and cursor to aid in pagination. */
  edges: Array<RoadmapItemVotesEdge>;
  /** A list of `RoadmapItemVote` objects. */
  nodes: Array<Maybe<RoadmapItemVote>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoadmapItemVote` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoadmapItemVote` edge in the connection. */
export type RoadmapItemVotesEdge = {
  __typename?: 'RoadmapItemVotesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoadmapItemVote` at the end of the edge. */
  node?: Maybe<RoadmapItemVote>;
};

/** Methods to use when ordering `RoadmapItemVote`. */
export type RoadmapItemVotesOrderBy =
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__ACTIVE_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__ACTIVE_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__COMMENT_COUNT_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__COMMENT_COUNT_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__CREATED_AT_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__CREATED_AT_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__ID_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__ID_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__NAME_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__NAME_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__NEED_TO_HAVE_VOTE_COUNT_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__NEED_TO_HAVE_VOTE_COUNT_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__NICE_TO_HAVE_VOTE_COUNT_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__NICE_TO_HAVE_VOTE_COUNT_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__STAGE_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__STAGE_DESC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__UPDATED_AT_ASC'
  | 'ROADMAP_ITEM_BY_ROADMAP_ITEM_ID__UPDATED_AT_DESC'
  | 'ROADMAP_ITEM_ID_ASC'
  | 'ROADMAP_ITEM_ID_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC'
  | 'VOTE_TYPE_ASC'
  | 'VOTE_TYPE_DESC';

/** A connection to a list of `RoadmapItem` values. */
export type RoadmapItemsConnection = {
  __typename?: 'RoadmapItemsConnection';
  /** A list of edges which contains the `RoadmapItem` and cursor to aid in pagination. */
  edges: Array<RoadmapItemsEdge>;
  /** A list of `RoadmapItem` objects. */
  nodes: Array<Maybe<RoadmapItem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoadmapItem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoadmapItem` edge in the connection. */
export type RoadmapItemsEdge = {
  __typename?: 'RoadmapItemsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoadmapItem` at the end of the edge. */
  node?: Maybe<RoadmapItem>;
};

/** Methods to use when ordering `RoadmapItem`. */
export type RoadmapItemsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMMENT_COUNT_ASC'
  | 'COMMENT_COUNT_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'NEED_TO_HAVE_VOTE_COUNT_ASC'
  | 'NEED_TO_HAVE_VOTE_COUNT_DESC'
  | 'NICE_TO_HAVE_VOTE_COUNT_ASC'
  | 'NICE_TO_HAVE_VOTE_COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROADMAP_ITEM_COMMENTS_BY_ROADMAP_ITEM_ID__COUNT_ASC'
  | 'ROADMAP_ITEM_COMMENTS_BY_ROADMAP_ITEM_ID__COUNT_DESC'
  | 'ROADMAP_ITEM_LOCALIZATIONS_BY_ROADMAP_ITEM_ID__COUNT_ASC'
  | 'ROADMAP_ITEM_LOCALIZATIONS_BY_ROADMAP_ITEM_ID__COUNT_DESC'
  | 'ROADMAP_ITEM_VOTES_BY_ROADMAP_ITEM_ID__COUNT_ASC'
  | 'ROADMAP_ITEM_VOTES_BY_ROADMAP_ITEM_ID__COUNT_DESC'
  | 'STAGE_ASC'
  | 'STAGE_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

export type RoadmapStage =
  /** This feature has been completed. */
  | 'DEVELOPED'
  /** This feature is not yet planned. */
  | 'FUTURE'
  /** This feature is actively being worked on. */
  | 'IN_PROGRESS'
  /** This feature is planned but is not yet in development. */
  | 'PLANNED';

/** A filter to be used against RoadmapStage fields. All fields are combined with a logical ‘and.’ */
export type RoadmapStageFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<RoadmapStage>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<RoadmapStage>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<RoadmapStage>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<RoadmapStage>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<RoadmapStage>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<RoadmapStage>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<RoadmapStage>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<RoadmapStage>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<RoadmapStage>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<RoadmapStage>>;
};

export type Role = {
  __typename?: 'Role';
  companyId?: Maybe<Scalars['UUID']>;
  description?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `GroupRole`. */
  groupRoles: GroupRolesConnection;
  id: Scalars['UUID'];
  info: Scalars['String'];
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `RelationRole`. */
  relationRoles: RelationRolesConnection;
  /** Reads and enables pagination through a set of `RoleDependency`. */
  roleDependencies: RoleDependenciesConnection;
  /** Reads and enables pagination through a set of `RoleDependency`. */
  roleDependenciesByDependentOn: RoleDependenciesConnection;
  scopes?: Maybe<Array<Maybe<RoleScope>>>;
  /** Reads and enables pagination through a set of `UserCompanyRole`. */
  userCompanyRoles: UserCompanyRolesConnection;
  /** Reads and enables pagination through a set of `UserDepartmentRole`. */
  userDepartmentRoles: UserDepartmentRolesConnection;
  /** Reads and enables pagination through a set of `UserRole`. */
  userRoles: UserRolesConnection;
  usesItemIds: Scalars['Boolean'];
};


export type RoleGroupRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupRoleCondition>;
  filter?: InputMaybe<GroupRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupRolesOrderBy>>;
};


export type RoleRelationRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RelationRoleCondition>;
  filter?: InputMaybe<RelationRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RelationRolesOrderBy>>;
};


export type RoleRoleDependenciesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoleDependencyCondition>;
  filter?: InputMaybe<RoleDependencyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoleDependenciesOrderBy>>;
};


export type RoleRoleDependenciesByDependentOnArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoleDependencyCondition>;
  filter?: InputMaybe<RoleDependencyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoleDependenciesOrderBy>>;
};


export type RoleUserCompanyRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompanyRoleCondition>;
  filter?: InputMaybe<UserCompanyRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompanyRolesOrderBy>>;
};


export type RoleUserDepartmentRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserDepartmentRoleCondition>;
  filter?: InputMaybe<UserDepartmentRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserDepartmentRolesOrderBy>>;
};


export type RoleUserRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserRoleCondition>;
  filter?: InputMaybe<UserRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
};

/** A condition to be used against `Role` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type RoleCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `info` field. */
  info?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `scopes` field. */
  scopes?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  /** Checks for equality with the object’s `usesItemIds` field. */
  usesItemIds?: InputMaybe<Scalars['Boolean']>;
};

/** A connection to a list of `RoleDependency` values. */
export type RoleDependenciesConnection = {
  __typename?: 'RoleDependenciesConnection';
  /** A list of edges which contains the `RoleDependency` and cursor to aid in pagination. */
  edges: Array<RoleDependenciesEdge>;
  /** A list of `RoleDependency` objects. */
  nodes: Array<Maybe<RoleDependency>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoleDependency` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoleDependency` edge in the connection. */
export type RoleDependenciesEdge = {
  __typename?: 'RoleDependenciesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RoleDependency` at the end of the edge. */
  node?: Maybe<RoleDependency>;
};

/** Methods to use when ordering `RoleDependency`. */
export type RoleDependenciesOrderBy =
  | 'DEPENDENT_ON_ASC'
  | 'DEPENDENT_ON_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROLE_BY_DEPENDENT_ON__COMPANY_ID_ASC'
  | 'ROLE_BY_DEPENDENT_ON__COMPANY_ID_DESC'
  | 'ROLE_BY_DEPENDENT_ON__DESCRIPTION_ASC'
  | 'ROLE_BY_DEPENDENT_ON__DESCRIPTION_DESC'
  | 'ROLE_BY_DEPENDENT_ON__ID_ASC'
  | 'ROLE_BY_DEPENDENT_ON__ID_DESC'
  | 'ROLE_BY_DEPENDENT_ON__INFO_ASC'
  | 'ROLE_BY_DEPENDENT_ON__INFO_DESC'
  | 'ROLE_BY_DEPENDENT_ON__NAME_ASC'
  | 'ROLE_BY_DEPENDENT_ON__NAME_DESC'
  | 'ROLE_BY_DEPENDENT_ON__SCOPES_ASC'
  | 'ROLE_BY_DEPENDENT_ON__SCOPES_DESC'
  | 'ROLE_BY_DEPENDENT_ON__USES_ITEM_IDS_ASC'
  | 'ROLE_BY_DEPENDENT_ON__USES_ITEM_IDS_DESC'
  | 'ROLE_BY_ROLE_ID__COMPANY_ID_ASC'
  | 'ROLE_BY_ROLE_ID__COMPANY_ID_DESC'
  | 'ROLE_BY_ROLE_ID__DESCRIPTION_ASC'
  | 'ROLE_BY_ROLE_ID__DESCRIPTION_DESC'
  | 'ROLE_BY_ROLE_ID__ID_ASC'
  | 'ROLE_BY_ROLE_ID__ID_DESC'
  | 'ROLE_BY_ROLE_ID__INFO_ASC'
  | 'ROLE_BY_ROLE_ID__INFO_DESC'
  | 'ROLE_BY_ROLE_ID__NAME_ASC'
  | 'ROLE_BY_ROLE_ID__NAME_DESC'
  | 'ROLE_BY_ROLE_ID__SCOPES_ASC'
  | 'ROLE_BY_ROLE_ID__SCOPES_DESC'
  | 'ROLE_BY_ROLE_ID__USES_ITEM_IDS_ASC'
  | 'ROLE_BY_ROLE_ID__USES_ITEM_IDS_DESC'
  | 'ROLE_ID_ASC'
  | 'ROLE_ID_DESC';

export type RoleDependency = {
  __typename?: 'RoleDependency';
  dependentOn: Scalars['UUID'];
  /** Reads a single `Role` that is related to this `RoleDependency`. */
  role?: Maybe<Role>;
  /** Reads a single `Role` that is related to this `RoleDependency`. */
  roleByDependentOn?: Maybe<Role>;
  roleId: Scalars['UUID'];
};

/**
 * A condition to be used against `RoleDependency` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoleDependencyCondition = {
  /** Checks for equality with the object’s `dependentOn` field. */
  dependentOn?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roleId` field. */
  roleId?: InputMaybe<Scalars['UUID']>;
};

/** The `role` to be created by this mutation. */
export type RoleDependencyDependentOnForeignConnectionRoleCreateInput = {
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleRoleIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  info: Scalars['String'];
  name: Scalars['String'];
  relationRoles?: InputMaybe<RelationRoleRoleIdForeignInverseInput>;
  roleDependenciesToDependentOnUsingId?: InputMaybe<RoleDependencyDependentOnForeignInverseInput>;
  roleDependenciesToRoleIdUsingId?: InputMaybe<RoleDependencyRoleIdForeignInverseInput>;
  scopes?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleRoleIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleRoleIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleRoleIdForeignInverseInput>;
  usesItemIds?: InputMaybe<Scalars['Boolean']>;
};

/** Input for the nested mutation of `role` in the `RoleDependencyInput` mutation. */
export type RoleDependencyDependentOnForeignInput = {
  /** The primary key(s) for `role` for the far side of the relationship. */
  connectById?: InputMaybe<RoleRolePkeyConnect>;
  /** A `RoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoleDependencyDependentOnForeignConnectionRoleCreateInput>;
  /** The primary key(s) for `role` for the far side of the relationship. */
  deleteById?: InputMaybe<RoleRolePkeyDelete>;
  /** The primary key(s) and patch data for `role` for the far side of the relationship. */
  updateById?: InputMaybe<RoleOnRoleDependencyForRoleDependencyDependentOnForeignUsingRolePkeyUpdate>;
};

/** Input for the nested mutation of `roleDependency` in the `RoleInput` mutation. */
export type RoleDependencyDependentOnForeignInverseInput = {
  /** The primary key(s) for `roleDependency` for the far side of the relationship. */
  connectByRoleIdAndDependentOn?: InputMaybe<Array<RoleDependencyRoleDependencyPkeyConnect>>;
  /** The primary key(s) and patch data for `roleDependency` for the far side of the relationship. */
  updateByRoleIdAndDependentOn?: InputMaybe<Array<RoleDependencyOnRoleDependencyForRoleDependencyDependentOnForeignUsingRoleDependencyPkeyUpdate>>;
};

/** A filter to be used against `RoleDependency` object types. All fields are combined with a logical ‘and.’ */
export type RoleDependencyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoleDependencyFilter>>;
  /** Filter by the object’s `dependentOn` field. */
  dependentOn?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoleDependencyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoleDependencyFilter>>;
  /** Filter by the object’s `role` relation. */
  role?: InputMaybe<RoleFilter>;
  /** Filter by the object’s `roleByDependentOn` relation. */
  roleByDependentOn?: InputMaybe<RoleFilter>;
  /** Filter by the object’s `roleId` field. */
  roleId?: InputMaybe<UuidFilter>;
};

/** The fields on `roleDependency` to look up the row to update. */
export type RoleDependencyOnRoleDependencyForRoleDependencyDependentOnForeignUsingRoleDependencyPkeyUpdate = {
  dependentOn: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roleDependency` being updated. */
  patch: UpdateRoleDependencyOnRoleDependencyForRoleDependencyDependentOnForeignPatch;
  roleId: Scalars['UUID'];
};

/** The fields on `roleDependency` to look up the row to update. */
export type RoleDependencyOnRoleDependencyForRoleDependencyRoleIdForeignUsingRoleDependencyPkeyUpdate = {
  dependentOn: Scalars['UUID'];
  /** An object where the defined keys will be set on the `roleDependency` being updated. */
  patch: UpdateRoleDependencyOnRoleDependencyForRoleDependencyRoleIdForeignPatch;
  roleId: Scalars['UUID'];
};

/** The fields on `roleDependency` to look up the row to connect. */
export type RoleDependencyRoleDependencyPkeyConnect = {
  dependentOn: Scalars['UUID'];
  roleId: Scalars['UUID'];
};

/** Input for the nested mutation of `roleDependency` in the `RoleInput` mutation. */
export type RoleDependencyRoleIdForeignInverseInput = {
  /** The primary key(s) for `roleDependency` for the far side of the relationship. */
  connectByRoleIdAndDependentOn?: InputMaybe<Array<RoleDependencyRoleDependencyPkeyConnect>>;
  /** The primary key(s) and patch data for `roleDependency` for the far side of the relationship. */
  updateByRoleIdAndDependentOn?: InputMaybe<Array<RoleDependencyOnRoleDependencyForRoleDependencyRoleIdForeignUsingRoleDependencyPkeyUpdate>>;
};

/** A filter to be used against `Role` object types. All fields are combined with a logical ‘and.’ */
export type RoleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoleFilter>>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `groupRoles` relation. */
  groupRoles?: InputMaybe<RoleToManyGroupRoleFilter>;
  /** Some related `groupRoles` exist. */
  groupRolesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `info` field. */
  info?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoleFilter>>;
  /** Filter by the object’s `relationRoles` relation. */
  relationRoles?: InputMaybe<RoleToManyRelationRoleFilter>;
  /** Some related `relationRoles` exist. */
  relationRolesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roleDependencies` relation. */
  roleDependencies?: InputMaybe<RoleToManyRoleDependencyFilter>;
  /** Filter by the object’s `roleDependenciesByDependentOn` relation. */
  roleDependenciesByDependentOn?: InputMaybe<RoleToManyRoleDependencyFilter>;
  /** Some related `roleDependenciesByDependentOn` exist. */
  roleDependenciesByDependentOnExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `roleDependencies` exist. */
  roleDependenciesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scopes` field. */
  scopes?: InputMaybe<RoleScopeListFilter>;
  /** Filter by the object’s `userCompanyRoles` relation. */
  userCompanyRoles?: InputMaybe<RoleToManyUserCompanyRoleFilter>;
  /** Some related `userCompanyRoles` exist. */
  userCompanyRolesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userDepartmentRoles` relation. */
  userDepartmentRoles?: InputMaybe<RoleToManyUserDepartmentRoleFilter>;
  /** Some related `userDepartmentRoles` exist. */
  userDepartmentRolesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userRoles` relation. */
  userRoles?: InputMaybe<RoleToManyUserRoleFilter>;
  /** Some related `userRoles` exist. */
  userRolesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `usesItemIds` field. */
  usesItemIds?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `Role` */
export type RoleInput = {
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleRoleIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  info: Scalars['String'];
  name: Scalars['String'];
  relationRoles?: InputMaybe<RelationRoleRoleIdForeignInverseInput>;
  roleDependenciesToDependentOnUsingId?: InputMaybe<RoleDependencyDependentOnForeignInverseInput>;
  roleDependenciesToRoleIdUsingId?: InputMaybe<RoleDependencyRoleIdForeignInverseInput>;
  scopes?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleRoleIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleRoleIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleRoleIdForeignInverseInput>;
  usesItemIds?: InputMaybe<Scalars['Boolean']>;
};

/** The fields on `role` to look up the row to update. */
export type RoleOnGroupRoleForGroupRoleRoleIdForeignUsingRolePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `role` being updated. */
  patch: UpdateRoleOnGroupRoleForGroupRoleRoleIdForeignPatch;
};

/** The fields on `role` to look up the row to update. */
export type RoleOnRelationRoleForRelationRoleRoleIdForeignUsingRolePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `role` being updated. */
  patch: UpdateRoleOnRelationRoleForRelationRoleRoleIdForeignPatch;
};

/** The fields on `role` to look up the row to update. */
export type RoleOnRoleDependencyForRoleDependencyDependentOnForeignUsingRolePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `role` being updated. */
  patch: UpdateRoleOnRoleDependencyForRoleDependencyDependentOnForeignPatch;
};

/** The fields on `role` to look up the row to update. */
export type RoleOnUserCompanyRoleForUserCompanyRoleRoleIdForeignUsingRolePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `role` being updated. */
  patch: UpdateRoleOnUserCompanyRoleForUserCompanyRoleRoleIdForeignPatch;
};

/** The fields on `role` to look up the row to update. */
export type RoleOnUserDepartmentRoleForUserDepartmentRoleRoleIdForeignUsingRolePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `role` being updated. */
  patch: UpdateRoleOnUserDepartmentRoleForUserDepartmentRoleRoleIdForeignPatch;
};

/** The fields on `role` to look up the row to update. */
export type RoleOnUserRoleForUserRoleRoleIdForeignUsingRolePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `role` being updated. */
  patch: UpdateRoleOnUserRoleForUserRoleRoleIdForeignPatch;
};

/** Represents an update to a `Role`. Fields that are set will be updated. */
export type RolePatch = {
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleRoleIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  info?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  relationRoles?: InputMaybe<RelationRoleRoleIdForeignInverseInput>;
  roleDependenciesToDependentOnUsingId?: InputMaybe<RoleDependencyDependentOnForeignInverseInput>;
  roleDependenciesToRoleIdUsingId?: InputMaybe<RoleDependencyRoleIdForeignInverseInput>;
  scopes?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleRoleIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleRoleIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleRoleIdForeignInverseInput>;
  usesItemIds?: InputMaybe<Scalars['Boolean']>;
};

/** The fields on `role` to look up the row to connect. */
export type RoleRolePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `role` to look up the row to delete. */
export type RoleRolePkeyDelete = {
  id: Scalars['UUID'];
};

export type RoleScope =
  | 'ALL'
  | 'DEPARTMENT'
  | 'RELATION'
  | 'SELF';

/** A filter to be used against RoleScope fields. All fields are combined with a logical ‘and.’ */
export type RoleScopeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<RoleScope>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<RoleScope>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<RoleScope>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<RoleScope>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<RoleScope>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<RoleScope>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<RoleScope>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<RoleScope>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<RoleScope>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<RoleScope>>;
};

/** A filter to be used against RoleScope List fields. All fields are combined with a logical ‘and.’ */
export type RoleScopeListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<RoleScope>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<RoleScope>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<RoleScope>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<RoleScope>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<RoleScope>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<RoleScope>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<RoleScope>>>;
};

/** A filter to be used against many `GroupRole` object types. All fields are combined with a logical ‘and.’ */
export type RoleToManyGroupRoleFilter = {
  /** Every related `GroupRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GroupRoleFilter>;
  /** No related `GroupRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GroupRoleFilter>;
  /** Some related `GroupRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GroupRoleFilter>;
};

/** A filter to be used against many `RelationRole` object types. All fields are combined with a logical ‘and.’ */
export type RoleToManyRelationRoleFilter = {
  /** Every related `RelationRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RelationRoleFilter>;
  /** No related `RelationRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RelationRoleFilter>;
  /** Some related `RelationRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RelationRoleFilter>;
};

/** A filter to be used against many `RoleDependency` object types. All fields are combined with a logical ‘and.’ */
export type RoleToManyRoleDependencyFilter = {
  /** Every related `RoleDependency` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoleDependencyFilter>;
  /** No related `RoleDependency` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoleDependencyFilter>;
  /** Some related `RoleDependency` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoleDependencyFilter>;
};

/** A filter to be used against many `UserCompanyRole` object types. All fields are combined with a logical ‘and.’ */
export type RoleToManyUserCompanyRoleFilter = {
  /** Every related `UserCompanyRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCompanyRoleFilter>;
  /** No related `UserCompanyRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCompanyRoleFilter>;
  /** Some related `UserCompanyRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCompanyRoleFilter>;
};

/** A filter to be used against many `UserDepartmentRole` object types. All fields are combined with a logical ‘and.’ */
export type RoleToManyUserDepartmentRoleFilter = {
  /** Every related `UserDepartmentRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserDepartmentRoleFilter>;
  /** No related `UserDepartmentRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserDepartmentRoleFilter>;
  /** Some related `UserDepartmentRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserDepartmentRoleFilter>;
};

/** A filter to be used against many `UserRole` object types. All fields are combined with a logical ‘and.’ */
export type RoleToManyUserRoleFilter = {
  /** Every related `UserRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserRoleFilter>;
  /** No related `UserRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserRoleFilter>;
  /** Some related `UserRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserRoleFilter>;
};

/** A connection to a list of `Role` values. */
export type RolesConnection = {
  __typename?: 'RolesConnection';
  /** A list of edges which contains the `Role` and cursor to aid in pagination. */
  edges: Array<RolesEdge>;
  /** A list of `Role` objects. */
  nodes: Array<Maybe<Role>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Role` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Role` edge in the connection. */
export type RolesEdge = {
  __typename?: 'RolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Role` at the end of the edge. */
  node?: Maybe<Role>;
};

/** Methods to use when ordering `Role`. */
export type RolesOrderBy =
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'GROUP_ROLES_BY_ROLE_ID__COUNT_ASC'
  | 'GROUP_ROLES_BY_ROLE_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INFO_ASC'
  | 'INFO_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RELATION_ROLES_BY_ROLE_ID__COUNT_ASC'
  | 'RELATION_ROLES_BY_ROLE_ID__COUNT_DESC'
  | 'ROLE_DEPENDENCIES_BY_DEPENDENT_ON__COUNT_ASC'
  | 'ROLE_DEPENDENCIES_BY_DEPENDENT_ON__COUNT_DESC'
  | 'ROLE_DEPENDENCIES_BY_ROLE_ID__COUNT_ASC'
  | 'ROLE_DEPENDENCIES_BY_ROLE_ID__COUNT_DESC'
  | 'SCOPES_ASC'
  | 'SCOPES_DESC'
  | 'USER_COMPANY_ROLES_BY_ROLE_ID__COUNT_ASC'
  | 'USER_COMPANY_ROLES_BY_ROLE_ID__COUNT_DESC'
  | 'USER_DEPARTMENT_ROLES_BY_ROLE_ID__COUNT_ASC'
  | 'USER_DEPARTMENT_ROLES_BY_ROLE_ID__COUNT_DESC'
  | 'USER_ROLES_BY_ROLE_ID__COUNT_ASC'
  | 'USER_ROLES_BY_ROLE_ID__COUNT_DESC'
  | 'USES_ITEM_IDS_ASC'
  | 'USES_ITEM_IDS_DESC';

/** All input for the `safeCastDate` mutation. */
export type SafeCastDateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The output of our `safeCastDate` mutation. */
export type SafeCastDatePayload = {
  __typename?: 'SafeCastDatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type SavedSignature = {
  __typename?: 'SavedSignature';
  /** Reads a single `Employee` that is related to this `SavedSignature`. */
  employee?: Maybe<Employee>;
  employeeId: Scalars['UUID'];
  id: Scalars['UUID'];
  /** Reads a single `Storage` that is related to this `SavedSignature`. */
  storage?: Maybe<Storage>;
  storageId: Scalars['UUID'];
};

/**
 * A condition to be used against `SavedSignature` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SavedSignatureCondition = {
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `storageId` field. */
  storageId?: InputMaybe<Scalars['UUID']>;
};

/** The `savedSignature` to be created by this mutation. */
export type SavedSignatureEmployeeIdForeignConnectionSavedSignatureCreateInput = {
  employee?: InputMaybe<SavedSignatureEmployeeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<SavedSignatureStorageIdForeignInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `employee` in the `SavedSignatureInput` mutation. */
export type SavedSignatureEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnSavedSignatureForSavedSignatureEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnSavedSignatureForSavedSignatureEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `savedSignature` in the `EmployeeInput` mutation. */
export type SavedSignatureEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `savedSignature` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SavedSignatureSavedSignaturePkeyConnect>>;
  /** A `SavedSignatureInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SavedSignatureEmployeeIdForeignConnectionSavedSignatureCreateInput>>;
  /** The primary key(s) for `savedSignature` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SavedSignatureSavedSignaturePkeyDelete>>;
  /** Flag indicating whether all other `savedSignature` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `savedSignature` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SavedSignatureOnSavedSignatureForSavedSignatureEmployeeIdForeignUsingSavedSignaturePkeyUpdate>>;
};

/** A filter to be used against `SavedSignature` object types. All fields are combined with a logical ‘and.’ */
export type SavedSignatureFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SavedSignatureFilter>>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SavedSignatureFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SavedSignatureFilter>>;
  /** Filter by the object’s `storage` relation. */
  storage?: InputMaybe<StorageFilter>;
  /** Filter by the object’s `storageId` field. */
  storageId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `SavedSignature` */
export type SavedSignatureInput = {
  employee?: InputMaybe<SavedSignatureEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<SavedSignatureStorageIdForeignInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `savedSignature` to look up the row to update. */
export type SavedSignatureOnSavedSignatureForSavedSignatureEmployeeIdForeignUsingSavedSignaturePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `savedSignature` being updated. */
  patch: UpdateSavedSignatureOnSavedSignatureForSavedSignatureEmployeeIdForeignPatch;
};

/** The fields on `savedSignature` to look up the row to update. */
export type SavedSignatureOnSavedSignatureForSavedSignatureStorageIdForeignUsingSavedSignaturePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `savedSignature` being updated. */
  patch: UpdateSavedSignatureOnSavedSignatureForSavedSignatureStorageIdForeignPatch;
};

/** Represents an update to a `SavedSignature`. Fields that are set will be updated. */
export type SavedSignaturePatch = {
  employee?: InputMaybe<SavedSignatureEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<SavedSignatureStorageIdForeignInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `savedSignature` to look up the row to connect. */
export type SavedSignatureSavedSignaturePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `savedSignature` to look up the row to delete. */
export type SavedSignatureSavedSignaturePkeyDelete = {
  id: Scalars['UUID'];
};

/** The `savedSignature` to be created by this mutation. */
export type SavedSignatureStorageIdForeignConnectionSavedSignatureCreateInput = {
  employee?: InputMaybe<SavedSignatureEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<SavedSignatureStorageIdForeignInput>;
};

/** The `storage` to be created by this mutation. */
export type SavedSignatureStorageIdForeignConnectionStorageCreateInput = {
  access: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createCopy?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path: Scalars['String'];
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `storage` in the `SavedSignatureInput` mutation. */
export type SavedSignatureStorageIdForeignInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<StorageStoragePkeyConnect>;
  /** A `StorageInput` object that will be created and connected to this object. */
  create?: InputMaybe<SavedSignatureStorageIdForeignConnectionStorageCreateInput>;
  /** The primary key(s) and patch data for `storage` for the far side of the relationship. */
  updateById?: InputMaybe<StorageOnSavedSignatureForSavedSignatureStorageIdForeignUsingStoragePkeyUpdate>;
};

/** Input for the nested mutation of `savedSignature` in the `StorageInput` mutation. */
export type SavedSignatureStorageIdForeignInverseInput = {
  /** The primary key(s) for `savedSignature` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SavedSignatureSavedSignaturePkeyConnect>>;
  /** A `SavedSignatureInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SavedSignatureStorageIdForeignConnectionSavedSignatureCreateInput>>;
  /** The primary key(s) for `savedSignature` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SavedSignatureSavedSignaturePkeyDelete>>;
  /** Flag indicating whether all other `savedSignature` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `savedSignature` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SavedSignatureOnSavedSignatureForSavedSignatureStorageIdForeignUsingSavedSignaturePkeyUpdate>>;
};

/** A connection to a list of `SavedSignature` values. */
export type SavedSignaturesConnection = {
  __typename?: 'SavedSignaturesConnection';
  /** A list of edges which contains the `SavedSignature` and cursor to aid in pagination. */
  edges: Array<SavedSignaturesEdge>;
  /** A list of `SavedSignature` objects. */
  nodes: Array<Maybe<SavedSignature>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SavedSignature` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SavedSignature` edge in the connection. */
export type SavedSignaturesEdge = {
  __typename?: 'SavedSignaturesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SavedSignature` at the end of the edge. */
  node?: Maybe<SavedSignature>;
};

/** Methods to use when ordering `SavedSignature`. */
export type SavedSignaturesOrderBy =
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'STORAGE_BY_STORAGE_ID__ACCESS_ASC'
  | 'STORAGE_BY_STORAGE_ID__ACCESS_DESC'
  | 'STORAGE_BY_STORAGE_ID__ACTIVE_ASC'
  | 'STORAGE_BY_STORAGE_ID__ACTIVE_DESC'
  | 'STORAGE_BY_STORAGE_ID__BELONGS_TO_LEADER_ASC'
  | 'STORAGE_BY_STORAGE_ID__BELONGS_TO_LEADER_DESC'
  | 'STORAGE_BY_STORAGE_ID__COMPANY_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__COMPANY_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__CONTRACT_SIGN_PENDING_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__CREATED_AT_ASC'
  | 'STORAGE_BY_STORAGE_ID__CREATED_AT_DESC'
  | 'STORAGE_BY_STORAGE_ID__DELETE_AT_ASC'
  | 'STORAGE_BY_STORAGE_ID__DELETE_AT_DESC'
  | 'STORAGE_BY_STORAGE_ID__DEPARTMENTS_ASC'
  | 'STORAGE_BY_STORAGE_ID__DEPARTMENTS_DESC'
  | 'STORAGE_BY_STORAGE_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'STORAGE_BY_STORAGE_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'STORAGE_BY_STORAGE_ID__DOCUMENT_FOLDER_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__DOCUMENT_FOLDER_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__DOCUMENT_TEMPLATE_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__DOCUMENT_TEMPLATE_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__DOCUMENT_TYPE_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__DOCUMENT_TYPE_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__EMPLOYEE_CASEFILE_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__EMPLOYEE_CASEFILE_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__EXPIRED_REMINDED_ASC'
  | 'STORAGE_BY_STORAGE_ID__EXPIRED_REMINDED_DESC'
  | 'STORAGE_BY_STORAGE_ID__EXPIRE_AT_ASC'
  | 'STORAGE_BY_STORAGE_ID__EXPIRE_AT_DESC'
  | 'STORAGE_BY_STORAGE_ID__FILENAME_ASC'
  | 'STORAGE_BY_STORAGE_ID__FILENAME_DESC'
  | 'STORAGE_BY_STORAGE_ID__FILE_EXTENSION_ASC'
  | 'STORAGE_BY_STORAGE_ID__FILE_EXTENSION_DESC'
  | 'STORAGE_BY_STORAGE_ID__FILE_OWNER_ASC'
  | 'STORAGE_BY_STORAGE_ID__FILE_OWNER_DESC'
  | 'STORAGE_BY_STORAGE_ID__FILE_OWNER_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__FILE_OWNER_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__FILE_SIZE_ASC'
  | 'STORAGE_BY_STORAGE_ID__FILE_SIZE_DESC'
  | 'STORAGE_BY_STORAGE_ID__FILE_TYPE_ASC'
  | 'STORAGE_BY_STORAGE_ID__FILE_TYPE_DESC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_DEPARTMENT_IDS_ASC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_DEPARTMENT_IDS_DESC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_DEPARTMENT_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_OWNER_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_OWNER_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_USER_IDS_SHARED_WITH_ASC'
  | 'STORAGE_BY_STORAGE_ID__FOLDER_USER_IDS_SHARED_WITH_DESC'
  | 'STORAGE_BY_STORAGE_ID__HTML_ASC'
  | 'STORAGE_BY_STORAGE_ID__HTML_DESC'
  | 'STORAGE_BY_STORAGE_ID__ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__MIMETYPE_ASC'
  | 'STORAGE_BY_STORAGE_ID__MIMETYPE_DESC'
  | 'STORAGE_BY_STORAGE_ID__OWNER_NAME_ASC'
  | 'STORAGE_BY_STORAGE_ID__OWNER_NAME_DESC'
  | 'STORAGE_BY_STORAGE_ID__PATH_ASC'
  | 'STORAGE_BY_STORAGE_ID__PATH_DESC'
  | 'STORAGE_BY_STORAGE_ID__PENNEO_DOCUMENT_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__PENNEO_DOCUMENT_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__PLACEHOLDER_VALUES_ASC'
  | 'STORAGE_BY_STORAGE_ID__PLACEHOLDER_VALUES_DESC'
  | 'STORAGE_BY_STORAGE_ID__PROCESS_TYPE_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__PROCESS_TYPE_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__REMINDED_ASC'
  | 'STORAGE_BY_STORAGE_ID__REMINDED_DESC'
  | 'STORAGE_BY_STORAGE_ID__REMIND_AT_ASC'
  | 'STORAGE_BY_STORAGE_ID__REMIND_AT_DESC'
  | 'STORAGE_BY_STORAGE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__TEMPLATING_SERVICE_ID_ASC'
  | 'STORAGE_BY_STORAGE_ID__TEMPLATING_SERVICE_ID_DESC'
  | 'STORAGE_BY_STORAGE_ID__USERS_RESPONSIBLE_ASC'
  | 'STORAGE_BY_STORAGE_ID__USERS_RESPONSIBLE_DESC'
  | 'STORAGE_BY_STORAGE_ID__USERS_SHARED_WITH_ASC'
  | 'STORAGE_BY_STORAGE_ID__USERS_SHARED_WITH_DEPARTMENTS_ASC'
  | 'STORAGE_BY_STORAGE_ID__USERS_SHARED_WITH_DEPARTMENTS_DESC'
  | 'STORAGE_BY_STORAGE_ID__USERS_SHARED_WITH_DESC'
  | 'STORAGE_ID_ASC'
  | 'STORAGE_ID_DESC';

export type ScheduledMessage = {
  __typename?: 'ScheduledMessage';
  active: Scalars['Boolean'];
  /** Reads a single `User` that is related to this `ScheduledMessage`. */
  assignedProcessUser?: Maybe<User>;
  assignedProcessUserId?: Maybe<Scalars['UUID']>;
  body: Scalars['String'];
  /** Reads a single `Company` that is related to this `ScheduledMessage`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt?: Maybe<Scalars['Datetime']>;
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Employee` that is related to this `ScheduledMessage`. */
  employee?: Maybe<Employee>;
  employeeId: Scalars['UUID'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  /** Reads a single `Process` that is related to this `ScheduledMessage`. */
  process?: Maybe<Process>;
  processId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ProcessType` that is related to this `ScheduledMessage`. */
  processType?: Maybe<ProcessType>;
  processTypeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Project` that is related to this `ScheduledMessage`. */
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `ScheduledMessageExternalRecipient`. */
  scheduledMessageExternalRecipients: ScheduledMessageExternalRecipientsConnection;
  /** Reads and enables pagination through a set of `ScheduledMessageRecipient`. */
  scheduledMessageRecipients: ScheduledMessageRecipientsConnection;
  sendDate: Scalars['Datetime'];
  /** Reads a single `Employee` that is related to this `ScheduledMessage`. */
  senderEmployee?: Maybe<Employee>;
  senderEmployeeId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `Storage`. */
  storages: StoragesConnection;
  subject: Scalars['String'];
  updatedAt?: Maybe<Scalars['Datetime']>;
};


export type ScheduledMessageScheduledMessageExternalRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageExternalRecipientCondition>;
  filter?: InputMaybe<ScheduledMessageExternalRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageExternalRecipientsOrderBy>>;
};


export type ScheduledMessageScheduledMessageRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageRecipientCondition>;
  filter?: InputMaybe<ScheduledMessageRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageRecipientsOrderBy>>;
};


export type ScheduledMessageStoragesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** The `scheduledMessage` to be created by this mutation. */
export type ScheduledMessageAssignedProcessUserIdForeignConnectionScheduledMessageCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  body: Scalars['String'];
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate: Scalars['Datetime'];
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `ScheduledMessageInput` mutation. */
export type ScheduledMessageAssignedProcessUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnScheduledMessageForScheduledMessageAssignedProcessUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessage` in the `UserInput` mutation. */
export type ScheduledMessageAssignedProcessUserIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScheduledMessageScheduledMessagePkeyConnect>>;
  /** A `ScheduledMessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageAssignedProcessUserIdForeignConnectionScheduledMessageCreateInput>>;
  /** The primary key(s) and patch data for `scheduledMessage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScheduledMessageOnScheduledMessageForScheduledMessageAssignedProcessUserIdForeignUsingScheduledMessagePkeyUpdate>>;
};

/** The `scheduledMessage` to be created by this mutation. */
export type ScheduledMessageCompanyIdForeignConnectionScheduledMessageCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  body: Scalars['String'];
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate: Scalars['Datetime'];
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** Input for the nested mutation of `company` in the `ScheduledMessageInput` mutation. */
export type ScheduledMessageCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnScheduledMessageForScheduledMessageCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessage` in the `CompanyInput` mutation. */
export type ScheduledMessageCompanyIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScheduledMessageScheduledMessagePkeyConnect>>;
  /** A `ScheduledMessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageCompanyIdForeignConnectionScheduledMessageCreateInput>>;
  /** The primary key(s) and patch data for `scheduledMessage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScheduledMessageOnScheduledMessageForScheduledMessageCompanyIdForeignUsingScheduledMessagePkeyUpdate>>;
};

/**
 * A condition to be used against `ScheduledMessage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ScheduledMessageCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `assignedProcessUserId` field. */
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `body` field. */
  body?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `processId` field. */
  processId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `sendDate` field. */
  sendDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `senderEmployeeId` field. */
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `subject` field. */
  subject?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `scheduledMessage` to be created by this mutation. */
export type ScheduledMessageEmployeeIdForeignConnectionScheduledMessageCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  body: Scalars['String'];
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate: Scalars['Datetime'];
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** Input for the nested mutation of `employee` in the `ScheduledMessageInput` mutation. */
export type ScheduledMessageEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnScheduledMessageForScheduledMessageEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnScheduledMessageForScheduledMessageEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `scheduledMessage` in the `EmployeeInput` mutation. */
export type ScheduledMessageEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScheduledMessageScheduledMessagePkeyConnect>>;
  /** A `ScheduledMessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageEmployeeIdForeignConnectionScheduledMessageCreateInput>>;
  /** The primary key(s) and patch data for `scheduledMessage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScheduledMessageOnScheduledMessageForScheduledMessageEmployeeIdForeignUsingScheduledMessagePkeyUpdate>>;
};

export type ScheduledMessageExternalRecipient = {
  __typename?: 'ScheduledMessageExternalRecipient';
  /** Reads a single `Company` that is related to this `ScheduledMessageExternalRecipient`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  locale: Scalars['String'];
  /** Reads a single `ProcessType` that is related to this `ScheduledMessageExternalRecipient`. */
  processType?: Maybe<ProcessType>;
  processTypeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ScheduledMessage` that is related to this `ScheduledMessageExternalRecipient`. */
  scheduledMessage?: Maybe<ScheduledMessage>;
  scheduledMessageId: Scalars['UUID'];
  sentDate?: Maybe<Scalars['Datetime']>;
};

/** The `scheduledMessageExternalRecipient` to be created by this mutation. */
export type ScheduledMessageExternalRecipientCompanyIdForeignConnectionScheduledMessageExternalRecipientCreateInput = {
  company?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInput>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  processType?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessage?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInput>;
  scheduledMessageId?: InputMaybe<Scalars['UUID']>;
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `company` in the `ScheduledMessageExternalRecipientInput` mutation. */
export type ScheduledMessageExternalRecipientCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessageExternalRecipient` in the `CompanyInput` mutation. */
export type ScheduledMessageExternalRecipientCompanyIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessageExternalRecipient` for the far side of the relationship. */
  connectByScheduledMessageIdAndEmail?: InputMaybe<Array<ScheduledMessageExternalRecipientScheduledMessageExternalRecipientPkeyConnect>>;
  /** A `ScheduledMessageExternalRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageExternalRecipientCompanyIdForeignConnectionScheduledMessageExternalRecipientCreateInput>>;
  /** The primary key(s) for `scheduledMessageExternalRecipient` for the far side of the relationship. */
  deleteByScheduledMessageIdAndEmail?: InputMaybe<Array<ScheduledMessageExternalRecipientScheduledMessageExternalRecipientPkeyDelete>>;
  /** Flag indicating whether all other `scheduledMessageExternalRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scheduledMessageExternalRecipient` for the far side of the relationship. */
  updateByScheduledMessageIdAndEmail?: InputMaybe<Array<ScheduledMessageExternalRecipientOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientCompanyIdForeignUsingScheduledMessageExternalRecipientPkeyUpdate>>;
};

/**
 * A condition to be used against `ScheduledMessageExternalRecipient` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type ScheduledMessageExternalRecipientCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fullName` field. */
  fullName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `locale` field. */
  locale?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `scheduledMessageId` field. */
  scheduledMessageId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `sentDate` field. */
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ScheduledMessageExternalRecipient` object types. All fields are combined with a logical ‘and.’ */
export type ScheduledMessageExternalRecipientFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ScheduledMessageExternalRecipientFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `locale` field. */
  locale?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ScheduledMessageExternalRecipientFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ScheduledMessageExternalRecipientFilter>>;
  /** Filter by the object’s `processType` relation. */
  processType?: InputMaybe<ProcessTypeFilter>;
  /** A related `processType` exists. */
  processTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `scheduledMessage` relation. */
  scheduledMessage?: InputMaybe<ScheduledMessageFilter>;
  /** Filter by the object’s `scheduledMessageId` field. */
  scheduledMessageId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `sentDate` field. */
  sentDate?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ScheduledMessageExternalRecipient` */
export type ScheduledMessageExternalRecipientInput = {
  company?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  processType?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessage?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInput>;
  scheduledMessageId?: InputMaybe<Scalars['UUID']>;
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `scheduledMessageExternalRecipient` to look up the row to update. */
export type ScheduledMessageExternalRecipientOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientCompanyIdForeignUsingScheduledMessageExternalRecipientPkeyUpdate = {
  email: Scalars['String'];
  /** An object where the defined keys will be set on the `scheduledMessageExternalRecipient` being updated. */
  patch: UpdateScheduledMessageExternalRecipientOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientCompanyIdForeignPatch;
  scheduledMessageId: Scalars['UUID'];
};

/** The fields on `scheduledMessageExternalRecipient` to look up the row to update. */
export type ScheduledMessageExternalRecipientOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientProcessTypeIdForeignUsingScheduledMessageExternalRecipientPkeyUpdate = {
  email: Scalars['String'];
  /** An object where the defined keys will be set on the `scheduledMessageExternalRecipient` being updated. */
  patch: UpdateScheduledMessageExternalRecipientOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientProcessTypeIdForeignPatch;
  scheduledMessageId: Scalars['UUID'];
};

/** The fields on `scheduledMessageExternalRecipient` to look up the row to update. */
export type ScheduledMessageExternalRecipientOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientScheduledMessageIdForeiUsingScheduledMessageExternalRecipientPkeyUpdate = {
  email: Scalars['String'];
  /** An object where the defined keys will be set on the `scheduledMessageExternalRecipient` being updated. */
  patch: UpdateScheduledMessageExternalRecipientOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientScheduledMessageIdForeiPatch;
  scheduledMessageId: Scalars['UUID'];
};

/** Represents an update to a `ScheduledMessageExternalRecipient`. Fields that are set will be updated. */
export type ScheduledMessageExternalRecipientPatch = {
  company?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  processType?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessage?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInput>;
  scheduledMessageId?: InputMaybe<Scalars['UUID']>;
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** The `processType` to be created by this mutation. */
export type ScheduledMessageExternalRecipientProcessTypeIdForeignConnectionProcessTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `scheduledMessageExternalRecipient` to be created by this mutation. */
export type ScheduledMessageExternalRecipientProcessTypeIdForeignConnectionScheduledMessageExternalRecipientCreateInput = {
  company?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  processType?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInput>;
  scheduledMessage?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInput>;
  scheduledMessageId?: InputMaybe<Scalars['UUID']>;
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `processType` in the `ScheduledMessageExternalRecipientInput` mutation. */
export type ScheduledMessageExternalRecipientProcessTypeIdForeignInput = {
  /** The primary key(s) for `processType` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessTypeProcessTypePkeyConnect>;
  /** A `ProcessTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignConnectionProcessTypeCreateInput>;
  /** The primary key(s) and patch data for `processType` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessTypeOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientProcessTypeIdForeignUsingProcessTypePkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessageExternalRecipient` in the `ProcessTypeInput` mutation. */
export type ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessageExternalRecipient` for the far side of the relationship. */
  connectByScheduledMessageIdAndEmail?: InputMaybe<Array<ScheduledMessageExternalRecipientScheduledMessageExternalRecipientPkeyConnect>>;
  /** A `ScheduledMessageExternalRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageExternalRecipientProcessTypeIdForeignConnectionScheduledMessageExternalRecipientCreateInput>>;
  /** The primary key(s) for `scheduledMessageExternalRecipient` for the far side of the relationship. */
  deleteByScheduledMessageIdAndEmail?: InputMaybe<Array<ScheduledMessageExternalRecipientScheduledMessageExternalRecipientPkeyDelete>>;
  /** Flag indicating whether all other `scheduledMessageExternalRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scheduledMessageExternalRecipient` for the far side of the relationship. */
  updateByScheduledMessageIdAndEmail?: InputMaybe<Array<ScheduledMessageExternalRecipientOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientProcessTypeIdForeignUsingScheduledMessageExternalRecipientPkeyUpdate>>;
};

/** The fields on `scheduledMessageExternalRecipient` to look up the row to connect. */
export type ScheduledMessageExternalRecipientScheduledMessageExternalRecipientPkeyConnect = {
  email: Scalars['String'];
  scheduledMessageId: Scalars['UUID'];
};

/** The fields on `scheduledMessageExternalRecipient` to look up the row to delete. */
export type ScheduledMessageExternalRecipientScheduledMessageExternalRecipientPkeyDelete = {
  email: Scalars['String'];
  scheduledMessageId: Scalars['UUID'];
};

/** The `scheduledMessage` to be created by this mutation. */
export type ScheduledMessageExternalRecipientScheduledMessageIdForeiConnectionScheduledMessageCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  body: Scalars['String'];
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate: Scalars['Datetime'];
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** The `scheduledMessageExternalRecipient` to be created by this mutation. */
export type ScheduledMessageExternalRecipientScheduledMessageIdForeiConnectionScheduledMessageExternalRecipientCreateInput = {
  company?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  processType?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessage?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInput>;
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `scheduledMessage` in the `ScheduledMessageExternalRecipientInput` mutation. */
export type ScheduledMessageExternalRecipientScheduledMessageIdForeiInput = {
  /** The primary key(s) for `scheduledMessage` for the far side of the relationship. */
  connectById?: InputMaybe<ScheduledMessageScheduledMessagePkeyConnect>;
  /** A `ScheduledMessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiConnectionScheduledMessageCreateInput>;
  /** The primary key(s) and patch data for `scheduledMessage` for the far side of the relationship. */
  updateById?: InputMaybe<ScheduledMessageOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientScheduledMessageIdForeiUsingScheduledMessagePkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessageExternalRecipient` in the `ScheduledMessageInput` mutation. */
export type ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput = {
  /** The primary key(s) for `scheduledMessageExternalRecipient` for the far side of the relationship. */
  connectByScheduledMessageIdAndEmail?: InputMaybe<Array<ScheduledMessageExternalRecipientScheduledMessageExternalRecipientPkeyConnect>>;
  /** A `ScheduledMessageExternalRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageExternalRecipientScheduledMessageIdForeiConnectionScheduledMessageExternalRecipientCreateInput>>;
  /** The primary key(s) for `scheduledMessageExternalRecipient` for the far side of the relationship. */
  deleteByScheduledMessageIdAndEmail?: InputMaybe<Array<ScheduledMessageExternalRecipientScheduledMessageExternalRecipientPkeyDelete>>;
  /** Flag indicating whether all other `scheduledMessageExternalRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scheduledMessageExternalRecipient` for the far side of the relationship. */
  updateByScheduledMessageIdAndEmail?: InputMaybe<Array<ScheduledMessageExternalRecipientOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientScheduledMessageIdForeiUsingScheduledMessageExternalRecipientPkeyUpdate>>;
};

/** A connection to a list of `ScheduledMessageExternalRecipient` values. */
export type ScheduledMessageExternalRecipientsConnection = {
  __typename?: 'ScheduledMessageExternalRecipientsConnection';
  /** A list of edges which contains the `ScheduledMessageExternalRecipient` and cursor to aid in pagination. */
  edges: Array<ScheduledMessageExternalRecipientsEdge>;
  /** A list of `ScheduledMessageExternalRecipient` objects. */
  nodes: Array<Maybe<ScheduledMessageExternalRecipient>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ScheduledMessageExternalRecipient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ScheduledMessageExternalRecipient` edge in the connection. */
export type ScheduledMessageExternalRecipientsEdge = {
  __typename?: 'ScheduledMessageExternalRecipientsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ScheduledMessageExternalRecipient` at the end of the edge. */
  node?: Maybe<ScheduledMessageExternalRecipient>;
};

/** Methods to use when ordering `ScheduledMessageExternalRecipient`. */
export type ScheduledMessageExternalRecipientsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'EMAIL_ASC'
  | 'EMAIL_DESC'
  | 'FULL_NAME_ASC'
  | 'FULL_NAME_DESC'
  | 'LOCALE_ASC'
  | 'LOCALE_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_DESC'
  | 'PROCESS_TYPE_ID_ASC'
  | 'PROCESS_TYPE_ID_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__ACTIVE_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__ACTIVE_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__ASSIGNED_PROCESS_USER_ID_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__ASSIGNED_PROCESS_USER_ID_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__BODY_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__BODY_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__COMPANY_ID_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__COMPANY_ID_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__CREATED_AT_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__CREATED_AT_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__DEPARTMENTS_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__DEPARTMENTS_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__EMPLOYEE_ID_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__EMPLOYEE_ID_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__ID_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__ID_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__NAME_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__NAME_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__ORDER_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__ORDER_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__PROCESS_ID_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__PROCESS_ID_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__PROCESS_TYPE_ID_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__PROCESS_TYPE_ID_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__PROJECT_ID_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__PROJECT_ID_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__SENDER_EMPLOYEE_ID_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__SENDER_EMPLOYEE_ID_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__SEND_DATE_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__SEND_DATE_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__SUBJECT_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__SUBJECT_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__UPDATED_AT_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__UPDATED_AT_DESC'
  | 'SCHEDULED_MESSAGE_ID_ASC'
  | 'SCHEDULED_MESSAGE_ID_DESC'
  | 'SENT_DATE_ASC'
  | 'SENT_DATE_DESC';

/** A filter to be used against `ScheduledMessage` object types. All fields are combined with a logical ‘and.’ */
export type ScheduledMessageFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ScheduledMessageFilter>>;
  /** Filter by the object’s `assignedProcessUser` relation. */
  assignedProcessUser?: InputMaybe<UserFilter>;
  /** A related `assignedProcessUser` exists. */
  assignedProcessUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `assignedProcessUserId` field. */
  assignedProcessUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `body` field. */
  body?: InputMaybe<StringFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ScheduledMessageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ScheduledMessageFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `process` relation. */
  process?: InputMaybe<ProcessFilter>;
  /** A related `process` exists. */
  processExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processId` field. */
  processId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `processType` relation. */
  processType?: InputMaybe<ProcessTypeFilter>;
  /** A related `processType` exists. */
  processTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `project` relation. */
  project?: InputMaybe<ProjectFilter>;
  /** A related `project` exists. */
  projectExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `scheduledMessageExternalRecipients` relation. */
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageToManyScheduledMessageExternalRecipientFilter>;
  /** Some related `scheduledMessageExternalRecipients` exist. */
  scheduledMessageExternalRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scheduledMessageRecipients` relation. */
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageToManyScheduledMessageRecipientFilter>;
  /** Some related `scheduledMessageRecipients` exist. */
  scheduledMessageRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `sendDate` field. */
  sendDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `senderEmployee` relation. */
  senderEmployee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `senderEmployeeId` field. */
  senderEmployeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `subject` field. */
  subject?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ScheduledMessage` */
export type ScheduledMessageInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  body: Scalars['String'];
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate: Scalars['Datetime'];
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** The fields on `scheduledMessage` to look up the row to update. */
export type ScheduledMessageOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientScheduledMessageIdForeiUsingScheduledMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessage` being updated. */
  patch: UpdateScheduledMessageOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientScheduledMessageIdForeiPatch;
};

/** The fields on `scheduledMessage` to look up the row to update. */
export type ScheduledMessageOnScheduledMessageForScheduledMessageAssignedProcessUserIdForeignUsingScheduledMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessage` being updated. */
  patch: UpdateScheduledMessageOnScheduledMessageForScheduledMessageAssignedProcessUserIdForeignPatch;
};

/** The fields on `scheduledMessage` to look up the row to update. */
export type ScheduledMessageOnScheduledMessageForScheduledMessageCompanyIdForeignUsingScheduledMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessage` being updated. */
  patch: UpdateScheduledMessageOnScheduledMessageForScheduledMessageCompanyIdForeignPatch;
};

/** The fields on `scheduledMessage` to look up the row to update. */
export type ScheduledMessageOnScheduledMessageForScheduledMessageEmployeeIdForeignUsingScheduledMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessage` being updated. */
  patch: UpdateScheduledMessageOnScheduledMessageForScheduledMessageEmployeeIdForeignPatch;
};

/** The fields on `scheduledMessage` to look up the row to update. */
export type ScheduledMessageOnScheduledMessageForScheduledMessageProcessIdForeignUsingScheduledMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessage` being updated. */
  patch: UpdateScheduledMessageOnScheduledMessageForScheduledMessageProcessIdForeignPatch;
};

/** The fields on `scheduledMessage` to look up the row to update. */
export type ScheduledMessageOnScheduledMessageForScheduledMessageProcessTypeIdForeignUsingScheduledMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessage` being updated. */
  patch: UpdateScheduledMessageOnScheduledMessageForScheduledMessageProcessTypeIdForeignPatch;
};

/** The fields on `scheduledMessage` to look up the row to update. */
export type ScheduledMessageOnScheduledMessageForScheduledMessageProjectIdForeignUsingScheduledMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessage` being updated. */
  patch: UpdateScheduledMessageOnScheduledMessageForScheduledMessageProjectIdForeignPatch;
};

/** The fields on `scheduledMessage` to look up the row to update. */
export type ScheduledMessageOnScheduledMessageForScheduledMessageSenderEmployeeIdForeignUsingScheduledMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessage` being updated. */
  patch: UpdateScheduledMessageOnScheduledMessageForScheduledMessageSenderEmployeeIdForeignPatch;
};

/** The fields on `scheduledMessage` to look up the row to update. */
export type ScheduledMessageOnScheduledMessageRecipientForScheduledMessageRecipientScheduledMessageIdForeignUsingScheduledMessagePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessage` being updated. */
  patch: UpdateScheduledMessageOnScheduledMessageRecipientForScheduledMessageRecipientScheduledMessageIdForeignPatch;
};

/** Represents an update to a `ScheduledMessage`. Fields that are set will be updated. */
export type ScheduledMessagePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** The `process` to be created by this mutation. */
export type ScheduledMessageProcessIdForeignConnectionProcessCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `scheduledMessage` to be created by this mutation. */
export type ScheduledMessageProcessIdForeignConnectionScheduledMessageCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  body: Scalars['String'];
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate: Scalars['Datetime'];
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** Input for the nested mutation of `process` in the `ScheduledMessageInput` mutation. */
export type ScheduledMessageProcessIdForeignInput = {
  /** The primary key(s) for `process` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessProcessPkeyConnect>;
  /** A `ProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScheduledMessageProcessIdForeignConnectionProcessCreateInput>;
  /** The primary key(s) and patch data for `process` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessOnScheduledMessageForScheduledMessageProcessIdForeignUsingProcessPkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessage` in the `ProcessInput` mutation. */
export type ScheduledMessageProcessIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScheduledMessageScheduledMessagePkeyConnect>>;
  /** A `ScheduledMessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageProcessIdForeignConnectionScheduledMessageCreateInput>>;
  /** The primary key(s) and patch data for `scheduledMessage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScheduledMessageOnScheduledMessageForScheduledMessageProcessIdForeignUsingScheduledMessagePkeyUpdate>>;
};

/** The `processType` to be created by this mutation. */
export type ScheduledMessageProcessTypeIdForeignConnectionProcessTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `scheduledMessage` to be created by this mutation. */
export type ScheduledMessageProcessTypeIdForeignConnectionScheduledMessageCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  body: Scalars['String'];
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate: Scalars['Datetime'];
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** Input for the nested mutation of `processType` in the `ScheduledMessageInput` mutation. */
export type ScheduledMessageProcessTypeIdForeignInput = {
  /** The primary key(s) for `processType` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessTypeProcessTypePkeyConnect>;
  /** A `ProcessTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScheduledMessageProcessTypeIdForeignConnectionProcessTypeCreateInput>;
  /** The primary key(s) and patch data for `processType` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessTypeOnScheduledMessageForScheduledMessageProcessTypeIdForeignUsingProcessTypePkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessage` in the `ProcessTypeInput` mutation. */
export type ScheduledMessageProcessTypeIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScheduledMessageScheduledMessagePkeyConnect>>;
  /** A `ScheduledMessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageProcessTypeIdForeignConnectionScheduledMessageCreateInput>>;
  /** The primary key(s) and patch data for `scheduledMessage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScheduledMessageOnScheduledMessageForScheduledMessageProcessTypeIdForeignUsingScheduledMessagePkeyUpdate>>;
};

/** The `project` to be created by this mutation. */
export type ScheduledMessageProjectIdForeignConnectionProjectCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProjectEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessages?: InputMaybe<ScheduledMessageProjectIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProjectIdForeignInverseInput>;
  user?: InputMaybe<ProjectAssignedProcessUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `scheduledMessage` to be created by this mutation. */
export type ScheduledMessageProjectIdForeignConnectionScheduledMessageCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  body: Scalars['String'];
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate: Scalars['Datetime'];
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** Input for the nested mutation of `project` in the `ScheduledMessageInput` mutation. */
export type ScheduledMessageProjectIdForeignInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScheduledMessageProjectIdForeignConnectionProjectCreateInput>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnScheduledMessageForScheduledMessageProjectIdForeignUsingProjectPkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessage` in the `ProjectInput` mutation. */
export type ScheduledMessageProjectIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScheduledMessageScheduledMessagePkeyConnect>>;
  /** A `ScheduledMessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageProjectIdForeignConnectionScheduledMessageCreateInput>>;
  /** The primary key(s) and patch data for `scheduledMessage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScheduledMessageOnScheduledMessageForScheduledMessageProjectIdForeignUsingScheduledMessagePkeyUpdate>>;
};

export type ScheduledMessageRecipient = {
  __typename?: 'ScheduledMessageRecipient';
  /** Reads a single `Company` that is related to this `ScheduledMessageRecipient`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Employee` that is related to this `ScheduledMessageRecipient`. */
  employee?: Maybe<Employee>;
  employeeId: Scalars['UUID'];
  /** Reads a single `ProcessType` that is related to this `ScheduledMessageRecipient`. */
  processType?: Maybe<ProcessType>;
  processTypeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ScheduledMessage` that is related to this `ScheduledMessageRecipient`. */
  scheduledMessage?: Maybe<ScheduledMessage>;
  scheduledMessageId: Scalars['UUID'];
  sentDate?: Maybe<Scalars['Datetime']>;
};

/** The `scheduledMessageRecipient` to be created by this mutation. */
export type ScheduledMessageRecipientCompanyIdForeignConnectionScheduledMessageRecipientCreateInput = {
  company?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessage?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInput>;
  scheduledMessageId?: InputMaybe<Scalars['UUID']>;
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `company` in the `ScheduledMessageRecipientInput` mutation. */
export type ScheduledMessageRecipientCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnScheduledMessageRecipientForScheduledMessageRecipientCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessageRecipient` in the `CompanyInput` mutation. */
export type ScheduledMessageRecipientCompanyIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessageRecipient` for the far side of the relationship. */
  connectByScheduledMessageIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageRecipientScheduledMessageRecipientPkeyConnect>>;
  /** A `ScheduledMessageRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageRecipientCompanyIdForeignConnectionScheduledMessageRecipientCreateInput>>;
  /** The primary key(s) for `scheduledMessageRecipient` for the far side of the relationship. */
  deleteByScheduledMessageIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageRecipientScheduledMessageRecipientPkeyDelete>>;
  /** Flag indicating whether all other `scheduledMessageRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scheduledMessageRecipient` for the far side of the relationship. */
  updateByScheduledMessageIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageRecipientOnScheduledMessageRecipientForScheduledMessageRecipientCompanyIdForeignUsingScheduledMessageRecipientPkeyUpdate>>;
};

/**
 * A condition to be used against `ScheduledMessageRecipient` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ScheduledMessageRecipientCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `scheduledMessageId` field. */
  scheduledMessageId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `sentDate` field. */
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** The `scheduledMessageRecipient` to be created by this mutation. */
export type ScheduledMessageRecipientEmployeeIdForeignConnectionScheduledMessageRecipientCreateInput = {
  company?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInput>;
  processType?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessage?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInput>;
  scheduledMessageId?: InputMaybe<Scalars['UUID']>;
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `employee` in the `ScheduledMessageRecipientInput` mutation. */
export type ScheduledMessageRecipientEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnScheduledMessageRecipientForScheduledMessageRecipientEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnScheduledMessageRecipientForScheduledMessageRecipientEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `scheduledMessageRecipient` in the `EmployeeInput` mutation. */
export type ScheduledMessageRecipientEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessageRecipient` for the far side of the relationship. */
  connectByScheduledMessageIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageRecipientScheduledMessageRecipientPkeyConnect>>;
  /** A `ScheduledMessageRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageRecipientEmployeeIdForeignConnectionScheduledMessageRecipientCreateInput>>;
  /** The primary key(s) for `scheduledMessageRecipient` for the far side of the relationship. */
  deleteByScheduledMessageIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageRecipientScheduledMessageRecipientPkeyDelete>>;
  /** Flag indicating whether all other `scheduledMessageRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scheduledMessageRecipient` for the far side of the relationship. */
  updateByScheduledMessageIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageRecipientOnScheduledMessageRecipientForScheduledMessageRecipientEmployeeIdForeignUsingScheduledMessageRecipientPkeyUpdate>>;
};

/** A filter to be used against `ScheduledMessageRecipient` object types. All fields are combined with a logical ‘and.’ */
export type ScheduledMessageRecipientFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ScheduledMessageRecipientFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ScheduledMessageRecipientFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ScheduledMessageRecipientFilter>>;
  /** Filter by the object’s `processType` relation. */
  processType?: InputMaybe<ProcessTypeFilter>;
  /** A related `processType` exists. */
  processTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `scheduledMessage` relation. */
  scheduledMessage?: InputMaybe<ScheduledMessageFilter>;
  /** Filter by the object’s `scheduledMessageId` field. */
  scheduledMessageId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `sentDate` field. */
  sentDate?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ScheduledMessageRecipient` */
export type ScheduledMessageRecipientInput = {
  company?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessage?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInput>;
  scheduledMessageId?: InputMaybe<Scalars['UUID']>;
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `scheduledMessageRecipient` to look up the row to update. */
export type ScheduledMessageRecipientOnScheduledMessageRecipientForScheduledMessageRecipientCompanyIdForeignUsingScheduledMessageRecipientPkeyUpdate = {
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessageRecipient` being updated. */
  patch: UpdateScheduledMessageRecipientOnScheduledMessageRecipientForScheduledMessageRecipientCompanyIdForeignPatch;
  scheduledMessageId: Scalars['UUID'];
};

/** The fields on `scheduledMessageRecipient` to look up the row to update. */
export type ScheduledMessageRecipientOnScheduledMessageRecipientForScheduledMessageRecipientEmployeeIdForeignUsingScheduledMessageRecipientPkeyUpdate = {
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessageRecipient` being updated. */
  patch: UpdateScheduledMessageRecipientOnScheduledMessageRecipientForScheduledMessageRecipientEmployeeIdForeignPatch;
  scheduledMessageId: Scalars['UUID'];
};

/** The fields on `scheduledMessageRecipient` to look up the row to update. */
export type ScheduledMessageRecipientOnScheduledMessageRecipientForScheduledMessageRecipientProcessTypeIdForeignUsingScheduledMessageRecipientPkeyUpdate = {
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessageRecipient` being updated. */
  patch: UpdateScheduledMessageRecipientOnScheduledMessageRecipientForScheduledMessageRecipientProcessTypeIdForeignPatch;
  scheduledMessageId: Scalars['UUID'];
};

/** The fields on `scheduledMessageRecipient` to look up the row to update. */
export type ScheduledMessageRecipientOnScheduledMessageRecipientForScheduledMessageRecipientScheduledMessageIdForeignUsingScheduledMessageRecipientPkeyUpdate = {
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessageRecipient` being updated. */
  patch: UpdateScheduledMessageRecipientOnScheduledMessageRecipientForScheduledMessageRecipientScheduledMessageIdForeignPatch;
  scheduledMessageId: Scalars['UUID'];
};

/** Represents an update to a `ScheduledMessageRecipient`. Fields that are set will be updated. */
export type ScheduledMessageRecipientPatch = {
  company?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessage?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInput>;
  scheduledMessageId?: InputMaybe<Scalars['UUID']>;
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** The `processType` to be created by this mutation. */
export type ScheduledMessageRecipientProcessTypeIdForeignConnectionProcessTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `scheduledMessageRecipient` to be created by this mutation. */
export type ScheduledMessageRecipientProcessTypeIdForeignConnectionScheduledMessageRecipientCreateInput = {
  company?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInput>;
  scheduledMessage?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInput>;
  scheduledMessageId?: InputMaybe<Scalars['UUID']>;
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `processType` in the `ScheduledMessageRecipientInput` mutation. */
export type ScheduledMessageRecipientProcessTypeIdForeignInput = {
  /** The primary key(s) for `processType` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessTypeProcessTypePkeyConnect>;
  /** A `ProcessTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignConnectionProcessTypeCreateInput>;
  /** The primary key(s) and patch data for `processType` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessTypeOnScheduledMessageRecipientForScheduledMessageRecipientProcessTypeIdForeignUsingProcessTypePkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessageRecipient` in the `ProcessTypeInput` mutation. */
export type ScheduledMessageRecipientProcessTypeIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessageRecipient` for the far side of the relationship. */
  connectByScheduledMessageIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageRecipientScheduledMessageRecipientPkeyConnect>>;
  /** A `ScheduledMessageRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageRecipientProcessTypeIdForeignConnectionScheduledMessageRecipientCreateInput>>;
  /** The primary key(s) for `scheduledMessageRecipient` for the far side of the relationship. */
  deleteByScheduledMessageIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageRecipientScheduledMessageRecipientPkeyDelete>>;
  /** Flag indicating whether all other `scheduledMessageRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scheduledMessageRecipient` for the far side of the relationship. */
  updateByScheduledMessageIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageRecipientOnScheduledMessageRecipientForScheduledMessageRecipientProcessTypeIdForeignUsingScheduledMessageRecipientPkeyUpdate>>;
};

/** The `scheduledMessage` to be created by this mutation. */
export type ScheduledMessageRecipientScheduledMessageIdForeignConnectionScheduledMessageCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  body: Scalars['String'];
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate: Scalars['Datetime'];
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** The `scheduledMessageRecipient` to be created by this mutation. */
export type ScheduledMessageRecipientScheduledMessageIdForeignConnectionScheduledMessageRecipientCreateInput = {
  company?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessage?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInput>;
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `scheduledMessage` in the `ScheduledMessageRecipientInput` mutation. */
export type ScheduledMessageRecipientScheduledMessageIdForeignInput = {
  /** The primary key(s) for `scheduledMessage` for the far side of the relationship. */
  connectById?: InputMaybe<ScheduledMessageScheduledMessagePkeyConnect>;
  /** A `ScheduledMessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignConnectionScheduledMessageCreateInput>;
  /** The primary key(s) and patch data for `scheduledMessage` for the far side of the relationship. */
  updateById?: InputMaybe<ScheduledMessageOnScheduledMessageRecipientForScheduledMessageRecipientScheduledMessageIdForeignUsingScheduledMessagePkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessageRecipient` in the `ScheduledMessageInput` mutation. */
export type ScheduledMessageRecipientScheduledMessageIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessageRecipient` for the far side of the relationship. */
  connectByScheduledMessageIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageRecipientScheduledMessageRecipientPkeyConnect>>;
  /** A `ScheduledMessageRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageRecipientScheduledMessageIdForeignConnectionScheduledMessageRecipientCreateInput>>;
  /** The primary key(s) for `scheduledMessageRecipient` for the far side of the relationship. */
  deleteByScheduledMessageIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageRecipientScheduledMessageRecipientPkeyDelete>>;
  /** Flag indicating whether all other `scheduledMessageRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scheduledMessageRecipient` for the far side of the relationship. */
  updateByScheduledMessageIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageRecipientOnScheduledMessageRecipientForScheduledMessageRecipientScheduledMessageIdForeignUsingScheduledMessageRecipientPkeyUpdate>>;
};

/** The fields on `scheduledMessageRecipient` to look up the row to connect. */
export type ScheduledMessageRecipientScheduledMessageRecipientPkeyConnect = {
  employeeId: Scalars['UUID'];
  scheduledMessageId: Scalars['UUID'];
};

/** The fields on `scheduledMessageRecipient` to look up the row to delete. */
export type ScheduledMessageRecipientScheduledMessageRecipientPkeyDelete = {
  employeeId: Scalars['UUID'];
  scheduledMessageId: Scalars['UUID'];
};

/** A connection to a list of `ScheduledMessageRecipient` values. */
export type ScheduledMessageRecipientsConnection = {
  __typename?: 'ScheduledMessageRecipientsConnection';
  /** A list of edges which contains the `ScheduledMessageRecipient` and cursor to aid in pagination. */
  edges: Array<ScheduledMessageRecipientsEdge>;
  /** A list of `ScheduledMessageRecipient` objects. */
  nodes: Array<Maybe<ScheduledMessageRecipient>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ScheduledMessageRecipient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ScheduledMessageRecipient` edge in the connection. */
export type ScheduledMessageRecipientsEdge = {
  __typename?: 'ScheduledMessageRecipientsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ScheduledMessageRecipient` at the end of the edge. */
  node?: Maybe<ScheduledMessageRecipient>;
};

/** Methods to use when ordering `ScheduledMessageRecipient`. */
export type ScheduledMessageRecipientsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_DESC'
  | 'PROCESS_TYPE_ID_ASC'
  | 'PROCESS_TYPE_ID_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__ACTIVE_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__ACTIVE_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__ASSIGNED_PROCESS_USER_ID_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__ASSIGNED_PROCESS_USER_ID_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__BODY_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__BODY_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__COMPANY_ID_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__COMPANY_ID_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__CREATED_AT_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__CREATED_AT_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__DEPARTMENTS_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__DEPARTMENTS_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__EMPLOYEE_ID_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__EMPLOYEE_ID_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__ID_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__ID_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__NAME_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__NAME_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__ORDER_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__ORDER_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__PROCESS_ID_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__PROCESS_ID_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__PROCESS_TYPE_ID_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__PROCESS_TYPE_ID_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__PROJECT_ID_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__PROJECT_ID_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__SENDER_EMPLOYEE_ID_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__SENDER_EMPLOYEE_ID_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__SEND_DATE_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__SEND_DATE_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__SUBJECT_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__SUBJECT_DESC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__UPDATED_AT_ASC'
  | 'SCHEDULED_MESSAGE_BY_SCHEDULED_MESSAGE_ID__UPDATED_AT_DESC'
  | 'SCHEDULED_MESSAGE_ID_ASC'
  | 'SCHEDULED_MESSAGE_ID_DESC'
  | 'SENT_DATE_ASC'
  | 'SENT_DATE_DESC';

/** The fields on `scheduledMessage` to look up the row to connect. */
export type ScheduledMessageScheduledMessagePkeyConnect = {
  id: Scalars['UUID'];
};

/** The `scheduledMessage` to be created by this mutation. */
export type ScheduledMessageSenderEmployeeIdForeignConnectionScheduledMessageCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  body: Scalars['String'];
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate: Scalars['Datetime'];
  subject: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** Input for the nested mutation of `scheduledMessage` in the `EmployeeInput` mutation. */
export type ScheduledMessageSenderEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScheduledMessageScheduledMessagePkeyConnect>>;
  /** A `ScheduledMessageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageSenderEmployeeIdForeignConnectionScheduledMessageCreateInput>>;
  /** The primary key(s) and patch data for `scheduledMessage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScheduledMessageOnScheduledMessageForScheduledMessageSenderEmployeeIdForeignUsingScheduledMessagePkeyUpdate>>;
};

export type ScheduledMessageTemplate = {
  __typename?: 'ScheduledMessageTemplate';
  active: Scalars['Boolean'];
  body: Scalars['String'];
  /** Reads a single `Company` that is related to this `ScheduledMessageTemplate`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt?: Maybe<Scalars['Datetime']>;
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  duration: Scalars['Int'];
  id: Scalars['UUID'];
  includeCustomEmployeeFields?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  includeDirectManager?: Maybe<Scalars['Boolean']>;
  includeEmployee: Scalars['Boolean'];
  includeGroups?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  /** Reads a single `Process` that is related to this `ScheduledMessageTemplate`. */
  process?: Maybe<Process>;
  processId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ProcessType` that is related to this `ScheduledMessageTemplate`. */
  processType?: Maybe<ProcessType>;
  processTypeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ProjectTemplate` that is related to this `ScheduledMessageTemplate`. */
  project?: Maybe<ProjectTemplate>;
  projectId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `ScheduledMessageTemplateExternalRecipient`. */
  scheduledMessageTemplateExternalRecipients: ScheduledMessageTemplateExternalRecipientsConnection;
  /** Reads and enables pagination through a set of `ScheduledMessageTemplateRecipient`. */
  scheduledMessageTemplateRecipients: ScheduledMessageTemplateRecipientsConnection;
  sendTime: Scalars['Time'];
  startDay: Scalars['Int'];
  /** Reads and enables pagination through a set of `Storage`. */
  storages: StoragesConnection;
  subject: Scalars['String'];
  updatedAt?: Maybe<Scalars['Datetime']>;
};


export type ScheduledMessageTemplateScheduledMessageTemplateExternalRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageTemplateExternalRecipientCondition>;
  filter?: InputMaybe<ScheduledMessageTemplateExternalRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageTemplateExternalRecipientsOrderBy>>;
};


export type ScheduledMessageTemplateScheduledMessageTemplateRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageTemplateRecipientCondition>;
  filter?: InputMaybe<ScheduledMessageTemplateRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessageTemplateRecipientsOrderBy>>;
};


export type ScheduledMessageTemplateStoragesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** The `scheduledMessageTemplate` to be created by this mutation. */
export type ScheduledMessageTemplateCompanyIdForeignConnectionScheduledMessageTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  body: Scalars['String'];
  company?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  subject: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `company` in the `ScheduledMessageTemplateInput` mutation. */
export type ScheduledMessageTemplateCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnScheduledMessageTemplateForScheduledMessageTemplateCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessageTemplate` in the `CompanyInput` mutation. */
export type ScheduledMessageTemplateCompanyIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessageTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScheduledMessageTemplateScheduledMessageTemplatePkeyConnect>>;
  /** A `ScheduledMessageTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageTemplateCompanyIdForeignConnectionScheduledMessageTemplateCreateInput>>;
  /** The primary key(s) and patch data for `scheduledMessageTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScheduledMessageTemplateOnScheduledMessageTemplateForScheduledMessageTemplateCompanyIdForeignUsingScheduledMessageTemplatePkeyUpdate>>;
};

/**
 * A condition to be used against `ScheduledMessageTemplate` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ScheduledMessageTemplateCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `body` field. */
  body?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `includeCustomEmployeeFields` field. */
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `includeDirectManager` field. */
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `includeEmployee` field. */
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `includeGroups` field. */
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `processId` field. */
  processId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `sendTime` field. */
  sendTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `startDay` field. */
  startDay?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `subject` field. */
  subject?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ScheduledMessageTemplateExternalRecipient = {
  __typename?: 'ScheduledMessageTemplateExternalRecipient';
  /** Reads a single `Company` that is related to this `ScheduledMessageTemplateExternalRecipient`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  locale: Scalars['String'];
  /** Reads a single `ScheduledMessageTemplate` that is related to this `ScheduledMessageTemplateExternalRecipient`. */
  scheduledMessageTemplate?: Maybe<ScheduledMessageTemplate>;
  scheduledMessageTemplateId: Scalars['UUID'];
};

/** The `scheduledMessageTemplateExternalRecipient` to be created by this mutation. */
export type ScheduledMessageTemplateExternalRecipientCompanyIdForeigConnectionScheduledMessageTemplateExternalRecipientCreateInput = {
  company?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInput>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  scheduledMessageTemplate?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInput>;
  scheduledMessageTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `ScheduledMessageTemplateExternalRecipientInput` mutation. */
export type ScheduledMessageTemplateExternalRecipientCompanyIdForeigInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnScheduledMessageTemplateExternalRecipientForScheduledMessageTemplateExternalRecipientCompanyIdForeigUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessageTemplateExternalRecipient` in the `CompanyInput` mutation. */
export type ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput = {
  /** The primary key(s) for `scheduledMessageTemplateExternalRecipient` for the far side of the relationship. */
  connectByScheduledMessageTemplateIdAndEmail?: InputMaybe<Array<ScheduledMessageTemplateExternalRecipientScheduledMessageTemplateExternalRecipientPkeyConnect>>;
  /** A `ScheduledMessageTemplateExternalRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageTemplateExternalRecipientCompanyIdForeigConnectionScheduledMessageTemplateExternalRecipientCreateInput>>;
  /** The primary key(s) for `scheduledMessageTemplateExternalRecipient` for the far side of the relationship. */
  deleteByScheduledMessageTemplateIdAndEmail?: InputMaybe<Array<ScheduledMessageTemplateExternalRecipientScheduledMessageTemplateExternalRecipientPkeyDelete>>;
  /** Flag indicating whether all other `scheduledMessageTemplateExternalRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scheduledMessageTemplateExternalRecipient` for the far side of the relationship. */
  updateByScheduledMessageTemplateIdAndEmail?: InputMaybe<Array<ScheduledMessageTemplateExternalRecipientOnScheduledMessageTemplateExternalRecipientForScheduledMessageTemplateExternalRecipientCompanyIdForeigUsingScheduledMessageTemplateExternalRecipientPkeyUpdate>>;
};

/**
 * A condition to be used against `ScheduledMessageTemplateExternalRecipient`
 * object types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type ScheduledMessageTemplateExternalRecipientCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fullName` field. */
  fullName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `locale` field. */
  locale?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `scheduledMessageTemplateId` field. */
  scheduledMessageTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `ScheduledMessageTemplateExternalRecipient` object types. All fields are combined with a logical ‘and.’ */
export type ScheduledMessageTemplateExternalRecipientFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ScheduledMessageTemplateExternalRecipientFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `locale` field. */
  locale?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ScheduledMessageTemplateExternalRecipientFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ScheduledMessageTemplateExternalRecipientFilter>>;
  /** Filter by the object’s `scheduledMessageTemplate` relation. */
  scheduledMessageTemplate?: InputMaybe<ScheduledMessageTemplateFilter>;
  /** Filter by the object’s `scheduledMessageTemplateId` field. */
  scheduledMessageTemplateId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ScheduledMessageTemplateExternalRecipient` */
export type ScheduledMessageTemplateExternalRecipientInput = {
  company?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  scheduledMessageTemplate?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInput>;
  scheduledMessageTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `scheduledMessageTemplateExternalRecipient` to look up the row to update. */
export type ScheduledMessageTemplateExternalRecipientOnScheduledMessageTemplateExternalRecipientForScheduledMessageTemplateExternalRecipientCompanyIdForeigUsingScheduledMessageTemplateExternalRecipientPkeyUpdate = {
  email: Scalars['String'];
  /** An object where the defined keys will be set on the `scheduledMessageTemplateExternalRecipient` being updated. */
  patch: UpdateScheduledMessageTemplateExternalRecipientOnScheduledMessageTemplateExternalRecipientForScheduledMessageTemplateExternalRecipientCompanyIdForeigPatch;
  scheduledMessageTemplateId: Scalars['UUID'];
};

/** The fields on `scheduledMessageTemplateExternalRecipient` to look up the row to update. */
export type ScheduledMessageTemplateExternalRecipientOnScheduledMessageTemplateExternalRecipientForScheduledMessageTemplateExternalRecipientScheduledMessageUsingScheduledMessageTemplateExternalRecipientPkeyUpdate = {
  email: Scalars['String'];
  /** An object where the defined keys will be set on the `scheduledMessageTemplateExternalRecipient` being updated. */
  patch: UpdateScheduledMessageTemplateExternalRecipientOnScheduledMessageTemplateExternalRecipientForScheduledMessageTemplateExternalRecipientScheduledMessagePatch;
  scheduledMessageTemplateId: Scalars['UUID'];
};

/** Represents an update to a `ScheduledMessageTemplateExternalRecipient`. Fields that are set will be updated. */
export type ScheduledMessageTemplateExternalRecipientPatch = {
  company?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  scheduledMessageTemplate?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInput>;
  scheduledMessageTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** The `scheduledMessageTemplate` to be created by this mutation. */
export type ScheduledMessageTemplateExternalRecipientScheduledMessageConnectionScheduledMessageTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  body: Scalars['String'];
  company?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  subject: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `scheduledMessageTemplateExternalRecipient` to be created by this mutation. */
export type ScheduledMessageTemplateExternalRecipientScheduledMessageConnectionScheduledMessageTemplateExternalRecipientCreateInput = {
  company?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  scheduledMessageTemplate?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInput>;
};

/** Input for the nested mutation of `scheduledMessageTemplate` in the `ScheduledMessageTemplateExternalRecipientInput` mutation. */
export type ScheduledMessageTemplateExternalRecipientScheduledMessageInput = {
  /** The primary key(s) for `scheduledMessageTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<ScheduledMessageTemplateScheduledMessageTemplatePkeyConnect>;
  /** A `ScheduledMessageTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageConnectionScheduledMessageTemplateCreateInput>;
  /** The primary key(s) and patch data for `scheduledMessageTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<ScheduledMessageTemplateOnScheduledMessageTemplateExternalRecipientForScheduledMessageTemplateExternalRecipientScheduledMessageUsingScheduledMessageTemplatePkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessageTemplateExternalRecipient` in the `ScheduledMessageTemplateInput` mutation. */
export type ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput = {
  /** The primary key(s) for `scheduledMessageTemplateExternalRecipient` for the far side of the relationship. */
  connectByScheduledMessageTemplateIdAndEmail?: InputMaybe<Array<ScheduledMessageTemplateExternalRecipientScheduledMessageTemplateExternalRecipientPkeyConnect>>;
  /** A `ScheduledMessageTemplateExternalRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageTemplateExternalRecipientScheduledMessageConnectionScheduledMessageTemplateExternalRecipientCreateInput>>;
  /** The primary key(s) for `scheduledMessageTemplateExternalRecipient` for the far side of the relationship. */
  deleteByScheduledMessageTemplateIdAndEmail?: InputMaybe<Array<ScheduledMessageTemplateExternalRecipientScheduledMessageTemplateExternalRecipientPkeyDelete>>;
  /** Flag indicating whether all other `scheduledMessageTemplateExternalRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scheduledMessageTemplateExternalRecipient` for the far side of the relationship. */
  updateByScheduledMessageTemplateIdAndEmail?: InputMaybe<Array<ScheduledMessageTemplateExternalRecipientOnScheduledMessageTemplateExternalRecipientForScheduledMessageTemplateExternalRecipientScheduledMessageUsingScheduledMessageTemplateExternalRecipientPkeyUpdate>>;
};

/** The fields on `scheduledMessageTemplateExternalRecipient` to look up the row to connect. */
export type ScheduledMessageTemplateExternalRecipientScheduledMessageTemplateExternalRecipientPkeyConnect = {
  email: Scalars['String'];
  scheduledMessageTemplateId: Scalars['UUID'];
};

/** The fields on `scheduledMessageTemplateExternalRecipient` to look up the row to delete. */
export type ScheduledMessageTemplateExternalRecipientScheduledMessageTemplateExternalRecipientPkeyDelete = {
  email: Scalars['String'];
  scheduledMessageTemplateId: Scalars['UUID'];
};

/** A connection to a list of `ScheduledMessageTemplateExternalRecipient` values. */
export type ScheduledMessageTemplateExternalRecipientsConnection = {
  __typename?: 'ScheduledMessageTemplateExternalRecipientsConnection';
  /** A list of edges which contains the `ScheduledMessageTemplateExternalRecipient` and cursor to aid in pagination. */
  edges: Array<ScheduledMessageTemplateExternalRecipientsEdge>;
  /** A list of `ScheduledMessageTemplateExternalRecipient` objects. */
  nodes: Array<Maybe<ScheduledMessageTemplateExternalRecipient>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ScheduledMessageTemplateExternalRecipient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ScheduledMessageTemplateExternalRecipient` edge in the connection. */
export type ScheduledMessageTemplateExternalRecipientsEdge = {
  __typename?: 'ScheduledMessageTemplateExternalRecipientsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ScheduledMessageTemplateExternalRecipient` at the end of the edge. */
  node?: Maybe<ScheduledMessageTemplateExternalRecipient>;
};

/** Methods to use when ordering `ScheduledMessageTemplateExternalRecipient`. */
export type ScheduledMessageTemplateExternalRecipientsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'EMAIL_ASC'
  | 'EMAIL_DESC'
  | 'FULL_NAME_ASC'
  | 'FULL_NAME_DESC'
  | 'LOCALE_ASC'
  | 'LOCALE_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__ACTIVE_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__ACTIVE_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__BODY_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__BODY_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__COMPANY_ID_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__COMPANY_ID_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__CREATED_AT_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__CREATED_AT_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__DEPARTMENTS_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__DEPARTMENTS_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__DURATION_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__DURATION_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__ID_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__ID_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__INCLUDE_DIRECT_MANAGER_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__INCLUDE_DIRECT_MANAGER_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__INCLUDE_EMPLOYEE_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__INCLUDE_EMPLOYEE_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__INCLUDE_GROUPS_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__INCLUDE_GROUPS_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__NAME_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__NAME_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__ORDER_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__ORDER_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__PROCESS_ID_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__PROCESS_ID_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__PROCESS_TYPE_ID_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__PROCESS_TYPE_ID_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__PROJECT_ID_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__PROJECT_ID_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__SEND_TIME_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__SEND_TIME_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__START_DAY_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__START_DAY_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__SUBJECT_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__SUBJECT_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__UPDATED_AT_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__UPDATED_AT_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_ID_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_ID_DESC';

/** A filter to be used against `ScheduledMessageTemplate` object types. All fields are combined with a logical ‘and.’ */
export type ScheduledMessageTemplateFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ScheduledMessageTemplateFilter>>;
  /** Filter by the object’s `body` field. */
  body?: InputMaybe<StringFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `includeCustomEmployeeFields` field. */
  includeCustomEmployeeFields?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `includeDirectManager` field. */
  includeDirectManager?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `includeEmployee` field. */
  includeEmployee?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `includeGroups` field. */
  includeGroups?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ScheduledMessageTemplateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ScheduledMessageTemplateFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `process` relation. */
  process?: InputMaybe<ProcessFilter>;
  /** A related `process` exists. */
  processExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processId` field. */
  processId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `processType` relation. */
  processType?: InputMaybe<ProcessTypeFilter>;
  /** A related `processType` exists. */
  processTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `project` relation. */
  project?: InputMaybe<ProjectTemplateFilter>;
  /** A related `project` exists. */
  projectExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `scheduledMessageTemplateExternalRecipients` relation. */
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateToManyScheduledMessageTemplateExternalRecipientFilter>;
  /** Some related `scheduledMessageTemplateExternalRecipients` exist. */
  scheduledMessageTemplateExternalRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scheduledMessageTemplateRecipients` relation. */
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateToManyScheduledMessageTemplateRecipientFilter>;
  /** Some related `scheduledMessageTemplateRecipients` exist. */
  scheduledMessageTemplateRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `sendTime` field. */
  sendTime?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `startDay` field. */
  startDay?: InputMaybe<IntFilter>;
  /** Filter by the object’s `subject` field. */
  subject?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ScheduledMessageTemplate` */
export type ScheduledMessageTemplateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  body: Scalars['String'];
  company?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  subject: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `scheduledMessageTemplate` to look up the row to update. */
export type ScheduledMessageTemplateOnScheduledMessageTemplateExternalRecipientForScheduledMessageTemplateExternalRecipientScheduledMessageUsingScheduledMessageTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessageTemplate` being updated. */
  patch: UpdateScheduledMessageTemplateOnScheduledMessageTemplateExternalRecipientForScheduledMessageTemplateExternalRecipientScheduledMessagePatch;
};

/** The fields on `scheduledMessageTemplate` to look up the row to update. */
export type ScheduledMessageTemplateOnScheduledMessageTemplateForScheduledMessageTemplateCompanyIdForeignUsingScheduledMessageTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessageTemplate` being updated. */
  patch: UpdateScheduledMessageTemplateOnScheduledMessageTemplateForScheduledMessageTemplateCompanyIdForeignPatch;
};

/** The fields on `scheduledMessageTemplate` to look up the row to update. */
export type ScheduledMessageTemplateOnScheduledMessageTemplateForScheduledMessageTemplateProcessIdForeignUsingScheduledMessageTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessageTemplate` being updated. */
  patch: UpdateScheduledMessageTemplateOnScheduledMessageTemplateForScheduledMessageTemplateProcessIdForeignPatch;
};

/** The fields on `scheduledMessageTemplate` to look up the row to update. */
export type ScheduledMessageTemplateOnScheduledMessageTemplateForScheduledMessageTemplateProcessTypeIdForeignUsingScheduledMessageTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessageTemplate` being updated. */
  patch: UpdateScheduledMessageTemplateOnScheduledMessageTemplateForScheduledMessageTemplateProcessTypeIdForeignPatch;
};

/** The fields on `scheduledMessageTemplate` to look up the row to update. */
export type ScheduledMessageTemplateOnScheduledMessageTemplateForScheduledMessageTemplateProjectIdForeignUsingScheduledMessageTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessageTemplate` being updated. */
  patch: UpdateScheduledMessageTemplateOnScheduledMessageTemplateForScheduledMessageTemplateProjectIdForeignPatch;
};

/** The fields on `scheduledMessageTemplate` to look up the row to update. */
export type ScheduledMessageTemplateOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientScheduledMessageTemplateUsingScheduledMessageTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessageTemplate` being updated. */
  patch: UpdateScheduledMessageTemplateOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientScheduledMessageTemplatePatch;
};

/** Represents an update to a `ScheduledMessageTemplate`. Fields that are set will be updated. */
export type ScheduledMessageTemplatePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `process` to be created by this mutation. */
export type ScheduledMessageTemplateProcessIdForeignConnectionProcessCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `scheduledMessageTemplate` to be created by this mutation. */
export type ScheduledMessageTemplateProcessIdForeignConnectionScheduledMessageTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  body: Scalars['String'];
  company?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInput>;
  processType?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  subject: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `process` in the `ScheduledMessageTemplateInput` mutation. */
export type ScheduledMessageTemplateProcessIdForeignInput = {
  /** The primary key(s) for `process` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessProcessPkeyConnect>;
  /** A `ProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScheduledMessageTemplateProcessIdForeignConnectionProcessCreateInput>;
  /** The primary key(s) and patch data for `process` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessOnScheduledMessageTemplateForScheduledMessageTemplateProcessIdForeignUsingProcessPkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessageTemplate` in the `ProcessInput` mutation. */
export type ScheduledMessageTemplateProcessIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessageTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScheduledMessageTemplateScheduledMessageTemplatePkeyConnect>>;
  /** A `ScheduledMessageTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageTemplateProcessIdForeignConnectionScheduledMessageTemplateCreateInput>>;
  /** The primary key(s) and patch data for `scheduledMessageTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScheduledMessageTemplateOnScheduledMessageTemplateForScheduledMessageTemplateProcessIdForeignUsingScheduledMessageTemplatePkeyUpdate>>;
};

/** The `processType` to be created by this mutation. */
export type ScheduledMessageTemplateProcessTypeIdForeignConnectionProcessTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `scheduledMessageTemplate` to be created by this mutation. */
export type ScheduledMessageTemplateProcessTypeIdForeignConnectionScheduledMessageTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  body: Scalars['String'];
  company?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  subject: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `processType` in the `ScheduledMessageTemplateInput` mutation. */
export type ScheduledMessageTemplateProcessTypeIdForeignInput = {
  /** The primary key(s) for `processType` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessTypeProcessTypePkeyConnect>;
  /** A `ProcessTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignConnectionProcessTypeCreateInput>;
  /** The primary key(s) and patch data for `processType` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessTypeOnScheduledMessageTemplateForScheduledMessageTemplateProcessTypeIdForeignUsingProcessTypePkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessageTemplate` in the `ProcessTypeInput` mutation. */
export type ScheduledMessageTemplateProcessTypeIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessageTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScheduledMessageTemplateScheduledMessageTemplatePkeyConnect>>;
  /** A `ScheduledMessageTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageTemplateProcessTypeIdForeignConnectionScheduledMessageTemplateCreateInput>>;
  /** The primary key(s) and patch data for `scheduledMessageTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScheduledMessageTemplateOnScheduledMessageTemplateForScheduledMessageTemplateProcessTypeIdForeignUsingScheduledMessageTemplatePkeyUpdate>>;
};

/** The `projectTemplate` to be created by this mutation. */
export type ScheduledMessageTemplateProjectIdForeignConnectionProjectTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProjectIdForeignInverseInput>;
};

/** The `scheduledMessageTemplate` to be created by this mutation. */
export type ScheduledMessageTemplateProjectIdForeignConnectionScheduledMessageTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  body: Scalars['String'];
  company?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  subject: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Input for the nested mutation of `projectTemplate` in the `ScheduledMessageTemplateInput` mutation. */
export type ScheduledMessageTemplateProjectIdForeignInput = {
  /** The primary key(s) for `projectTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectTemplateProjectTemplatePkeyConnect>;
  /** A `ProjectTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScheduledMessageTemplateProjectIdForeignConnectionProjectTemplateCreateInput>;
  /** The primary key(s) and patch data for `projectTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectTemplateOnScheduledMessageTemplateForScheduledMessageTemplateProjectIdForeignUsingProjectTemplatePkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessageTemplate` in the `ProjectTemplateInput` mutation. */
export type ScheduledMessageTemplateProjectIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessageTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ScheduledMessageTemplateScheduledMessageTemplatePkeyConnect>>;
  /** A `ScheduledMessageTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageTemplateProjectIdForeignConnectionScheduledMessageTemplateCreateInput>>;
  /** The primary key(s) and patch data for `scheduledMessageTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ScheduledMessageTemplateOnScheduledMessageTemplateForScheduledMessageTemplateProjectIdForeignUsingScheduledMessageTemplatePkeyUpdate>>;
};

export type ScheduledMessageTemplateRecipient = {
  __typename?: 'ScheduledMessageTemplateRecipient';
  /** Reads a single `Company` that is related to this `ScheduledMessageTemplateRecipient`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Employee` that is related to this `ScheduledMessageTemplateRecipient`. */
  employee?: Maybe<Employee>;
  employeeId: Scalars['UUID'];
  /** Reads a single `ScheduledMessageTemplate` that is related to this `ScheduledMessageTemplateRecipient`. */
  scheduledMessageTemplate?: Maybe<ScheduledMessageTemplate>;
  scheduledMessageTemplateId: Scalars['UUID'];
};

/** The `scheduledMessageTemplateRecipient` to be created by this mutation. */
export type ScheduledMessageTemplateRecipientCompanyIdForeignConnectionScheduledMessageTemplateRecipientCreateInput = {
  company?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageTemplate?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInput>;
  scheduledMessageTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `ScheduledMessageTemplateRecipientInput` mutation. */
export type ScheduledMessageTemplateRecipientCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessageTemplateRecipient` in the `CompanyInput` mutation. */
export type ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessageTemplateRecipient` for the far side of the relationship. */
  connectByScheduledMessageTemplateIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageTemplateRecipientScheduledMessageTemplateRecipientPkeyConnect>>;
  /** A `ScheduledMessageTemplateRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageTemplateRecipientCompanyIdForeignConnectionScheduledMessageTemplateRecipientCreateInput>>;
  /** The primary key(s) for `scheduledMessageTemplateRecipient` for the far side of the relationship. */
  deleteByScheduledMessageTemplateIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageTemplateRecipientScheduledMessageTemplateRecipientPkeyDelete>>;
  /** Flag indicating whether all other `scheduledMessageTemplateRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scheduledMessageTemplateRecipient` for the far side of the relationship. */
  updateByScheduledMessageTemplateIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageTemplateRecipientOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientCompanyIdForeignUsingScheduledMessageTemplateRecipientPkeyUpdate>>;
};

/**
 * A condition to be used against `ScheduledMessageTemplateRecipient` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type ScheduledMessageTemplateRecipientCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `scheduledMessageTemplateId` field. */
  scheduledMessageTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** The `scheduledMessageTemplateRecipient` to be created by this mutation. */
export type ScheduledMessageTemplateRecipientEmployeeIdForeignConnectionScheduledMessageTemplateRecipientCreateInput = {
  company?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInput>;
  scheduledMessageTemplate?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInput>;
  scheduledMessageTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `employee` in the `ScheduledMessageTemplateRecipientInput` mutation. */
export type ScheduledMessageTemplateRecipientEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `scheduledMessageTemplateRecipient` in the `EmployeeInput` mutation. */
export type ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `scheduledMessageTemplateRecipient` for the far side of the relationship. */
  connectByScheduledMessageTemplateIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageTemplateRecipientScheduledMessageTemplateRecipientPkeyConnect>>;
  /** A `ScheduledMessageTemplateRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageTemplateRecipientEmployeeIdForeignConnectionScheduledMessageTemplateRecipientCreateInput>>;
  /** The primary key(s) for `scheduledMessageTemplateRecipient` for the far side of the relationship. */
  deleteByScheduledMessageTemplateIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageTemplateRecipientScheduledMessageTemplateRecipientPkeyDelete>>;
  /** Flag indicating whether all other `scheduledMessageTemplateRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scheduledMessageTemplateRecipient` for the far side of the relationship. */
  updateByScheduledMessageTemplateIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageTemplateRecipientOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientEmployeeIdForeignUsingScheduledMessageTemplateRecipientPkeyUpdate>>;
};

/** A filter to be used against `ScheduledMessageTemplateRecipient` object types. All fields are combined with a logical ‘and.’ */
export type ScheduledMessageTemplateRecipientFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ScheduledMessageTemplateRecipientFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ScheduledMessageTemplateRecipientFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ScheduledMessageTemplateRecipientFilter>>;
  /** Filter by the object’s `scheduledMessageTemplate` relation. */
  scheduledMessageTemplate?: InputMaybe<ScheduledMessageTemplateFilter>;
  /** Filter by the object’s `scheduledMessageTemplateId` field. */
  scheduledMessageTemplateId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ScheduledMessageTemplateRecipient` */
export type ScheduledMessageTemplateRecipientInput = {
  company?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageTemplate?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInput>;
  scheduledMessageTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `scheduledMessageTemplateRecipient` to look up the row to update. */
export type ScheduledMessageTemplateRecipientOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientCompanyIdForeignUsingScheduledMessageTemplateRecipientPkeyUpdate = {
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessageTemplateRecipient` being updated. */
  patch: UpdateScheduledMessageTemplateRecipientOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientCompanyIdForeignPatch;
  scheduledMessageTemplateId: Scalars['UUID'];
};

/** The fields on `scheduledMessageTemplateRecipient` to look up the row to update. */
export type ScheduledMessageTemplateRecipientOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientEmployeeIdForeignUsingScheduledMessageTemplateRecipientPkeyUpdate = {
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessageTemplateRecipient` being updated. */
  patch: UpdateScheduledMessageTemplateRecipientOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientEmployeeIdForeignPatch;
  scheduledMessageTemplateId: Scalars['UUID'];
};

/** The fields on `scheduledMessageTemplateRecipient` to look up the row to update. */
export type ScheduledMessageTemplateRecipientOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientScheduledMessageTemplateUsingScheduledMessageTemplateRecipientPkeyUpdate = {
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `scheduledMessageTemplateRecipient` being updated. */
  patch: UpdateScheduledMessageTemplateRecipientOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientScheduledMessageTemplatePatch;
  scheduledMessageTemplateId: Scalars['UUID'];
};

/** Represents an update to a `ScheduledMessageTemplateRecipient`. Fields that are set will be updated. */
export type ScheduledMessageTemplateRecipientPatch = {
  company?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageTemplate?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInput>;
  scheduledMessageTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** The `scheduledMessageTemplate` to be created by this mutation. */
export type ScheduledMessageTemplateRecipientScheduledMessageTemplateConnectionScheduledMessageTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  body: Scalars['String'];
  company?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  subject: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `scheduledMessageTemplateRecipient` to be created by this mutation. */
export type ScheduledMessageTemplateRecipientScheduledMessageTemplateConnectionScheduledMessageTemplateRecipientCreateInput = {
  company?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageTemplate?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInput>;
};

/** Input for the nested mutation of `scheduledMessageTemplate` in the `ScheduledMessageTemplateRecipientInput` mutation. */
export type ScheduledMessageTemplateRecipientScheduledMessageTemplateInput = {
  /** The primary key(s) for `scheduledMessageTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<ScheduledMessageTemplateScheduledMessageTemplatePkeyConnect>;
  /** A `ScheduledMessageTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateConnectionScheduledMessageTemplateCreateInput>;
  /** The primary key(s) and patch data for `scheduledMessageTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<ScheduledMessageTemplateOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientScheduledMessageTemplateUsingScheduledMessageTemplatePkeyUpdate>;
};

/** Input for the nested mutation of `scheduledMessageTemplateRecipient` in the `ScheduledMessageTemplateInput` mutation. */
export type ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput = {
  /** The primary key(s) for `scheduledMessageTemplateRecipient` for the far side of the relationship. */
  connectByScheduledMessageTemplateIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageTemplateRecipientScheduledMessageTemplateRecipientPkeyConnect>>;
  /** A `ScheduledMessageTemplateRecipientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ScheduledMessageTemplateRecipientScheduledMessageTemplateConnectionScheduledMessageTemplateRecipientCreateInput>>;
  /** The primary key(s) for `scheduledMessageTemplateRecipient` for the far side of the relationship. */
  deleteByScheduledMessageTemplateIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageTemplateRecipientScheduledMessageTemplateRecipientPkeyDelete>>;
  /** Flag indicating whether all other `scheduledMessageTemplateRecipient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `scheduledMessageTemplateRecipient` for the far side of the relationship. */
  updateByScheduledMessageTemplateIdAndEmployeeId?: InputMaybe<Array<ScheduledMessageTemplateRecipientOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientScheduledMessageTemplateUsingScheduledMessageTemplateRecipientPkeyUpdate>>;
};

/** The fields on `scheduledMessageTemplateRecipient` to look up the row to connect. */
export type ScheduledMessageTemplateRecipientScheduledMessageTemplateRecipientPkeyConnect = {
  employeeId: Scalars['UUID'];
  scheduledMessageTemplateId: Scalars['UUID'];
};

/** The fields on `scheduledMessageTemplateRecipient` to look up the row to delete. */
export type ScheduledMessageTemplateRecipientScheduledMessageTemplateRecipientPkeyDelete = {
  employeeId: Scalars['UUID'];
  scheduledMessageTemplateId: Scalars['UUID'];
};

/** A connection to a list of `ScheduledMessageTemplateRecipient` values. */
export type ScheduledMessageTemplateRecipientsConnection = {
  __typename?: 'ScheduledMessageTemplateRecipientsConnection';
  /** A list of edges which contains the `ScheduledMessageTemplateRecipient` and cursor to aid in pagination. */
  edges: Array<ScheduledMessageTemplateRecipientsEdge>;
  /** A list of `ScheduledMessageTemplateRecipient` objects. */
  nodes: Array<Maybe<ScheduledMessageTemplateRecipient>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ScheduledMessageTemplateRecipient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ScheduledMessageTemplateRecipient` edge in the connection. */
export type ScheduledMessageTemplateRecipientsEdge = {
  __typename?: 'ScheduledMessageTemplateRecipientsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ScheduledMessageTemplateRecipient` at the end of the edge. */
  node?: Maybe<ScheduledMessageTemplateRecipient>;
};

/** Methods to use when ordering `ScheduledMessageTemplateRecipient`. */
export type ScheduledMessageTemplateRecipientsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__ACTIVE_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__ACTIVE_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__BODY_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__BODY_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__COMPANY_ID_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__COMPANY_ID_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__CREATED_AT_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__CREATED_AT_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__DEPARTMENTS_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__DEPARTMENTS_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__DURATION_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__DURATION_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__ID_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__ID_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__INCLUDE_DIRECT_MANAGER_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__INCLUDE_DIRECT_MANAGER_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__INCLUDE_EMPLOYEE_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__INCLUDE_EMPLOYEE_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__INCLUDE_GROUPS_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__INCLUDE_GROUPS_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__NAME_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__NAME_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__ORDER_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__ORDER_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__PROCESS_ID_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__PROCESS_ID_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__PROCESS_TYPE_ID_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__PROCESS_TYPE_ID_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__PROJECT_ID_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__PROJECT_ID_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__SEND_TIME_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__SEND_TIME_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__START_DAY_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__START_DAY_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__SUBJECT_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__SUBJECT_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__UPDATED_AT_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__UPDATED_AT_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_ID_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_ID_DESC';

/** The fields on `scheduledMessageTemplate` to look up the row to connect. */
export type ScheduledMessageTemplateScheduledMessageTemplatePkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `ScheduledMessageTemplateExternalRecipient` object types. All fields are combined with a logical ‘and.’ */
export type ScheduledMessageTemplateToManyScheduledMessageTemplateExternalRecipientFilter = {
  /** Every related `ScheduledMessageTemplateExternalRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageTemplateExternalRecipientFilter>;
  /** No related `ScheduledMessageTemplateExternalRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageTemplateExternalRecipientFilter>;
  /** Some related `ScheduledMessageTemplateExternalRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageTemplateExternalRecipientFilter>;
};

/** A filter to be used against many `ScheduledMessageTemplateRecipient` object types. All fields are combined with a logical ‘and.’ */
export type ScheduledMessageTemplateToManyScheduledMessageTemplateRecipientFilter = {
  /** Every related `ScheduledMessageTemplateRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageTemplateRecipientFilter>;
  /** No related `ScheduledMessageTemplateRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageTemplateRecipientFilter>;
  /** Some related `ScheduledMessageTemplateRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageTemplateRecipientFilter>;
};

/** A connection to a list of `ScheduledMessageTemplate` values. */
export type ScheduledMessageTemplatesConnection = {
  __typename?: 'ScheduledMessageTemplatesConnection';
  /** A list of edges which contains the `ScheduledMessageTemplate` and cursor to aid in pagination. */
  edges: Array<ScheduledMessageTemplatesEdge>;
  /** A list of `ScheduledMessageTemplate` objects. */
  nodes: Array<Maybe<ScheduledMessageTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ScheduledMessageTemplate` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ScheduledMessageTemplate` edge in the connection. */
export type ScheduledMessageTemplatesEdge = {
  __typename?: 'ScheduledMessageTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ScheduledMessageTemplate` at the end of the edge. */
  node?: Maybe<ScheduledMessageTemplate>;
};

/** Methods to use when ordering `ScheduledMessageTemplate`. */
export type ScheduledMessageTemplatesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'BODY_ASC'
  | 'BODY_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'DURATION_ASC'
  | 'DURATION_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INCLUDE_CUSTOM_EMPLOYEE_FIELDS_ASC'
  | 'INCLUDE_CUSTOM_EMPLOYEE_FIELDS_DESC'
  | 'INCLUDE_DIRECT_MANAGER_ASC'
  | 'INCLUDE_DIRECT_MANAGER_DESC'
  | 'INCLUDE_EMPLOYEE_ASC'
  | 'INCLUDE_EMPLOYEE_DESC'
  | 'INCLUDE_GROUPS_ASC'
  | 'INCLUDE_GROUPS_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_ASC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_DESC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_ASC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_DESC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_DESC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__NAME_ASC'
  | 'PROCESS_BY_PROCESS_ID__NAME_DESC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_ASC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_DESC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_DESC'
  | 'PROCESS_ID_ASC'
  | 'PROCESS_ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_DESC'
  | 'PROCESS_TYPE_ID_ASC'
  | 'PROCESS_TYPE_ID_DESC'
  | 'PROJECT_ID_ASC'
  | 'PROJECT_ID_DESC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__ACTIVE_ASC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__ACTIVE_DESC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__COMPANY_ID_ASC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__COMPANY_ID_DESC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__DEPARTMENTS_ASC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__DEPARTMENTS_DESC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__ID_ASC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__ID_DESC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__NAME_ASC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__NAME_DESC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__ORDER_ASC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__ORDER_DESC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__PROCESS_ID_ASC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__PROCESS_ID_DESC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__PROCESS_TYPE_ID_ASC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__PROCESS_TYPE_ID_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_EXTERNAL_RECIPIENTS_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_EXTERNAL_RECIPIENTS_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_RECIPIENTS_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGE_TEMPLATE_RECIPIENTS_BY_SCHEDULED_MESSAGE_TEMPLATE_ID__COUNT_DESC'
  | 'SEND_TIME_ASC'
  | 'SEND_TIME_DESC'
  | 'START_DAY_ASC'
  | 'START_DAY_DESC'
  | 'SUBJECT_ASC'
  | 'SUBJECT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** A filter to be used against many `ScheduledMessageExternalRecipient` object types. All fields are combined with a logical ‘and.’ */
export type ScheduledMessageToManyScheduledMessageExternalRecipientFilter = {
  /** Every related `ScheduledMessageExternalRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageExternalRecipientFilter>;
  /** No related `ScheduledMessageExternalRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageExternalRecipientFilter>;
  /** Some related `ScheduledMessageExternalRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageExternalRecipientFilter>;
};

/** A filter to be used against many `ScheduledMessageRecipient` object types. All fields are combined with a logical ‘and.’ */
export type ScheduledMessageToManyScheduledMessageRecipientFilter = {
  /** Every related `ScheduledMessageRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageRecipientFilter>;
  /** No related `ScheduledMessageRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageRecipientFilter>;
  /** Some related `ScheduledMessageRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageRecipientFilter>;
};

/** A connection to a list of `ScheduledMessage` values. */
export type ScheduledMessagesConnection = {
  __typename?: 'ScheduledMessagesConnection';
  /** A list of edges which contains the `ScheduledMessage` and cursor to aid in pagination. */
  edges: Array<ScheduledMessagesEdge>;
  /** A list of `ScheduledMessage` objects. */
  nodes: Array<Maybe<ScheduledMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ScheduledMessage` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ScheduledMessage` edge in the connection. */
export type ScheduledMessagesEdge = {
  __typename?: 'ScheduledMessagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ScheduledMessage` at the end of the edge. */
  node?: Maybe<ScheduledMessage>;
};

/** Methods to use when ordering `ScheduledMessage`. */
export type ScheduledMessagesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ASSIGNED_PROCESS_USER_ID_ASC'
  | 'ASSIGNED_PROCESS_USER_ID_DESC'
  | 'BODY_ASC'
  | 'BODY_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_SENDER_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_ASC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_DESC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_ASC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_DESC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_DESC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__NAME_ASC'
  | 'PROCESS_BY_PROCESS_ID__NAME_DESC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_ASC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_DESC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_DESC'
  | 'PROCESS_ID_ASC'
  | 'PROCESS_ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_DESC'
  | 'PROCESS_TYPE_ID_ASC'
  | 'PROCESS_TYPE_ID_DESC'
  | 'PROJECT_BY_PROJECT_ID__ACTIVE_ASC'
  | 'PROJECT_BY_PROJECT_ID__ACTIVE_DESC'
  | 'PROJECT_BY_PROJECT_ID__ARCHIVED_ASC'
  | 'PROJECT_BY_PROJECT_ID__ARCHIVED_DESC'
  | 'PROJECT_BY_PROJECT_ID__ASSIGNED_PROCESS_USER_ID_ASC'
  | 'PROJECT_BY_PROJECT_ID__ASSIGNED_PROCESS_USER_ID_DESC'
  | 'PROJECT_BY_PROJECT_ID__AUTO_ARCHIVED_ASC'
  | 'PROJECT_BY_PROJECT_ID__AUTO_ARCHIVED_DESC'
  | 'PROJECT_BY_PROJECT_ID__COMPANY_ID_ASC'
  | 'PROJECT_BY_PROJECT_ID__COMPANY_ID_DESC'
  | 'PROJECT_BY_PROJECT_ID__DEPARTMENTS_ASC'
  | 'PROJECT_BY_PROJECT_ID__DEPARTMENTS_DESC'
  | 'PROJECT_BY_PROJECT_ID__EMPLOYEE_ID_ASC'
  | 'PROJECT_BY_PROJECT_ID__EMPLOYEE_ID_DESC'
  | 'PROJECT_BY_PROJECT_ID__ID_ASC'
  | 'PROJECT_BY_PROJECT_ID__ID_DESC'
  | 'PROJECT_BY_PROJECT_ID__NAME_ASC'
  | 'PROJECT_BY_PROJECT_ID__NAME_DESC'
  | 'PROJECT_BY_PROJECT_ID__ORDER_ASC'
  | 'PROJECT_BY_PROJECT_ID__ORDER_DESC'
  | 'PROJECT_BY_PROJECT_ID__PROCESS_ID_ASC'
  | 'PROJECT_BY_PROJECT_ID__PROCESS_ID_DESC'
  | 'PROJECT_BY_PROJECT_ID__PROCESS_TYPE_ID_ASC'
  | 'PROJECT_BY_PROJECT_ID__PROCESS_TYPE_ID_DESC'
  | 'PROJECT_BY_PROJECT_ID__USER_IDS_ASC'
  | 'PROJECT_BY_PROJECT_ID__USER_IDS_DESC'
  | 'PROJECT_ID_ASC'
  | 'PROJECT_ID_DESC'
  | 'SCHEDULED_MESSAGE_EXTERNAL_RECIPIENTS_BY_SCHEDULED_MESSAGE_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGE_EXTERNAL_RECIPIENTS_BY_SCHEDULED_MESSAGE_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGE_RECIPIENTS_BY_SCHEDULED_MESSAGE_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGE_RECIPIENTS_BY_SCHEDULED_MESSAGE_ID__COUNT_DESC'
  | 'SENDER_EMPLOYEE_ID_ASC'
  | 'SENDER_EMPLOYEE_ID_DESC'
  | 'SEND_DATE_ASC'
  | 'SEND_DATE_DESC'
  | 'SUBJECT_ASC'
  | 'SUBJECT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ACTIVE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ACTIVE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ADDRESS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ADDRESS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CITY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CITY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CPR_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CPR_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GODMODE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GODMODE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__INITIALS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__INITIALS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__PHONE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__PHONE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__SENIORITY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__SENIORITY_DESC';

export type SendContractLinkInput = {
  contractSignPendingSignerId: Scalars['UUID'];
};

/** All input for the `sendEmail` mutation. */
export type SendEmailInput = {
  attachments?: InputMaybe<Scalars['JSON']>;
  bccField?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ccField?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  htmlText?: InputMaybe<Scalars['String']>;
  plainSubject?: InputMaybe<Scalars['String']>;
  recipientEmail?: InputMaybe<Scalars['String']>;
};

/** The output of our `sendEmail` mutation. */
export type SendEmailPayload = {
  __typename?: 'SendEmailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  strings?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SendPreboardingLinksInput = {
  channel?: InputMaybe<PreboardingChannel>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employeeIds: Array<Scalars['UUID']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  preboardingId: Scalars['UUID'];
  sendTime?: InputMaybe<Scalars['Datetime']>;
  smsBody?: InputMaybe<Scalars['String']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
};

export type SendPreboardingLinksPayload = {
  __typename?: 'SendPreboardingLinksPayload';
  links?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SendSigningRequestInput = {
  casefileId: Scalars['Int'];
  signingRequestId: Scalars['Int'];
};

/** All input for the `setFolderLastEdited` mutation. */
export type SetFolderLastEditedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  folderId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `setFolderLastEdited` mutation. */
export type SetFolderLastEditedPayload = {
  __typename?: 'SetFolderLastEditedPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setFormFieldEntryValue` mutation. */
export type SetFormFieldEntryValueInput = {
  argFormFieldId?: InputMaybe<Scalars['UUID']>;
  argUserId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fieldValue?: InputMaybe<Scalars['String']>;
};

/** The output of our `setFormFieldEntryValue` mutation. */
export type SetFormFieldEntryValuePayload = {
  __typename?: 'SetFormFieldEntryValuePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FormFieldEntry`. */
  company?: Maybe<Company>;
  /** Reads a single `Department` that is related to this `FormFieldEntry`. */
  department?: Maybe<Department>;
  /** Reads a single `Employee` that is related to this `FormFieldEntry`. */
  employee?: Maybe<Employee>;
  /** Reads a single `FieldGroup` that is related to this `FormFieldEntry`. */
  fieldGroup?: Maybe<FieldGroup>;
  /** Reads a single `FormField` that is related to this `FormFieldEntry`. */
  formField?: Maybe<FormField>;
  formFieldEntry?: Maybe<FormFieldEntry>;
  /** An edge for our `FormFieldEntry`. May be used by Relay 1. */
  formFieldEntryEdge?: Maybe<FormFieldEntriesEdge>;
  /** Reads a single `Product` that is related to this `FormFieldEntry`. */
  product?: Maybe<Product>;
  /** Reads a single `Department` that is related to this `FormFieldEntry`. */
  productDepartment?: Maybe<Department>;
  /** Reads a single `User` that is related to this `FormFieldEntry`. */
  productUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `FormFieldEntry`. */
  user?: Maybe<User>;
  /** Reads a single `UserCompetenceEvaluation` that is related to this `FormFieldEntry`. */
  userCompetenceEvaluation?: Maybe<UserCompetenceEvaluation>;
};


/** The output of our `setFormFieldEntryValue` mutation. */
export type SetFormFieldEntryValuePayloadFormFieldEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<FormFieldEntriesOrderBy>>;
};

/** All input for the `setMissingEmployeeNumber` mutation. */
export type SetMissingEmployeeNumberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  userId: Scalars['UUID'];
};

/** The output of our `setMissingEmployeeNumber` mutation. */
export type SetMissingEmployeeNumberPayload = {
  __typename?: 'SetMissingEmployeeNumberPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  integer?: Maybe<Scalars['Int']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setSystemFieldValue` mutation. */
export type SetSystemFieldValueInput = {
  argUserId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fieldName?: InputMaybe<Scalars['String']>;
  fieldValue?: InputMaybe<Scalars['String']>;
};

/** The output of our `setSystemFieldValue` mutation. */
export type SetSystemFieldValuePayload = {
  __typename?: 'SetSystemFieldValuePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserSystemField`. */
  company?: Maybe<Company>;
  /** Reads a single `FieldGroup` that is related to this `UserSystemField`. */
  fieldGroup?: Maybe<FieldGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SystemField` that is related to this `UserSystemField`. */
  systemField?: Maybe<SystemField>;
  /** Reads a single `User` that is related to this `UserSystemField`. */
  user?: Maybe<User>;
  userSystemField?: Maybe<UserSystemField>;
  /** An edge for our `UserSystemField`. May be used by Relay 1. */
  userSystemFieldEdge?: Maybe<UserSystemFieldsEdge>;
};


/** The output of our `setSystemFieldValue` mutation. */
export type SetSystemFieldValuePayloadUserSystemFieldEdgeArgs = {
  orderBy?: InputMaybe<Array<UserSystemFieldsOrderBy>>;
};

/** All input for the `setUserSetting` mutation. */
export type SetUserSettingInput = {
  argKey: Scalars['String'];
  argValue: Scalars['JSON'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `setUserSetting` mutation. */
export type SetUserSettingPayload = {
  __typename?: 'SetUserSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserSetting`. */
  user?: Maybe<User>;
  userSetting?: Maybe<UserSetting>;
  /** An edge for our `UserSetting`. May be used by Relay 1. */
  userSettingEdge?: Maybe<UserSettingsEdge>;
};


/** The output of our `setUserSetting` mutation. */
export type SetUserSettingPayloadUserSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
};

/** All input for the `signupToEvent` mutation. */
export type SignupToEventInput = {
  argAttending: Scalars['Boolean'];
  argEventId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `signupToEvent` mutation. */
export type SignupToEventPayload = {
  __typename?: 'SignupToEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `EventUser`. */
  company?: Maybe<Company>;
  /** Reads a single `Event` that is related to this `EventUser`. */
  event?: Maybe<Event>;
  eventUser?: Maybe<EventUser>;
  /** An edge for our `EventUser`. May be used by Relay 1. */
  eventUserEdge?: Maybe<EventUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EventUser`. */
  user?: Maybe<User>;
};


/** The output of our `signupToEvent` mutation. */
export type SignupToEventPayloadEventUserEdgeArgs = {
  orderBy?: InputMaybe<Array<EventUsersOrderBy>>;
};

export type SimpleUser = {
  __typename?: 'SimpleUser';
  employeeId?: Maybe<Scalars['UUID']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  logo?: Maybe<Scalars['String']>;
};

export type SortEquipmentCustomFieldsInput = {
  equipmentFieldsOrder: Array<EquipmentFieldOrder>;
};

/** A filter to be used against SqlIdentifier fields. All fields are combined with a logical ‘and.’ */
export type SqlIdentifierFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['SqlIdentifier']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['SqlIdentifier']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Does not match the specified pattern using the SQL standard's definition of a regular expression. */
  notSimilarTo?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Matches the specified pattern using the SQL standard's definition of a regular expression. */
  similarTo?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['SqlIdentifier']>;
};

export type StartBreakInput = {
  timeRegistrationBreakTypeId: Scalars['UUID'];
};

export type Storage = {
  __typename?: 'Storage';
  access: Scalars['String'];
  active: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `AuthApp`. */
  authApps: AuthAppsConnection;
  belongsToLeader: Scalars['Boolean'];
  companyId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `CompanySetting`. */
  companySettingsByValueStorageId: CompanySettingsConnection;
  /** Reads a single `ContractSignPendingDocument` that is related to this `Storage`. */
  contractSignPendingDocument?: Maybe<ContractSignPendingDocument>;
  contractSignPendingDocumentId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `ContractSignPendingDocument`. */
  contractSignPendingDocumentsByExistingStorageId: ContractSignPendingDocumentsConnection;
  /** Reads and enables pagination through a set of `ContractSignPendingSigner`. */
  contractSignPendingSignersBySignatureFileId: ContractSignPendingSignersConnection;
  createdAt: Scalars['Datetime'];
  deleteAt?: Maybe<Scalars['Datetime']>;
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  departmentsSharedWith?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads and enables pagination through a set of `Department`. */
  departmentsSharedWithComputedColumn: DepartmentsConnection;
  /** Reads and enables pagination through a set of `DocumentDepartmentPermission`. */
  documentDepartmentPermissionsByFileId: DocumentDepartmentPermissionsConnection;
  /** Reads a single `DocumentFolder` that is related to this `Storage`. */
  documentFolder?: Maybe<DocumentFolder>;
  documentFolderId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ContractTemplate` that is related to this `Storage`. */
  documentTemplate?: Maybe<ContractTemplate>;
  documentTemplateId?: Maybe<Scalars['UUID']>;
  /** Reads a single `DocumentType` that is related to this `Storage`. */
  documentType?: Maybe<DocumentType>;
  documentTypeId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `DocumentUserPermission`. */
  documentUserPermissionsByFileId: DocumentUserPermissionsConnection;
  /** Reads and enables pagination through a set of `DocumentUserResponsible`. */
  documentUserResponsiblesByFileId: DocumentUserResponsiblesConnection;
  /** Reads a single `EmployeeCasefile` that is related to this `Storage`. */
  employeeCasefile?: Maybe<EmployeeCasefile>;
  employeeCasefileId?: Maybe<Scalars['UUID']>;
  expireAt?: Maybe<Scalars['Datetime']>;
  expiredReminded?: Maybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: Maybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  folderOwnerId?: Maybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  html?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `IntegrationFieldMarking`. */
  integrationFieldMarkings: IntegrationFieldMarkingsConnection;
  mimetype?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferencesByFileId: NotificationEmployeeReferencesConnection;
  owner?: Maybe<Scalars['JSON']>;
  ownerName?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  penneoDocumentId?: Maybe<Scalars['String']>;
  placeholderValues?: Maybe<Scalars['JSON']>;
  /** Reads a single `ProcessType` that is related to this `Storage`. */
  processType?: Maybe<ProcessType>;
  processTypeId?: Maybe<Scalars['UUID']>;
  remindAt?: Maybe<Scalars['Datetime']>;
  reminded?: Maybe<Scalars['Boolean']>;
  /** Reads a single `DocumentFolderBlueprint` that is related to this `Storage`. */
  rootDocumentFolderBlueprint?: Maybe<DocumentFolderBlueprint>;
  rootDocumentFolderBlueprintId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `SavedSignature`. */
  savedSignatures: SavedSignaturesConnection;
  templatingServiceId?: Maybe<Scalars['UUID']>;
  url?: Maybe<Scalars['String']>;
  usersResponsible?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads and enables pagination through a set of `User`. */
  usersResponsibleComputedColumn: UsersConnection;
  usersSharedWith?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads and enables pagination through a set of `User`. */
  usersSharedWithComputedColumn: UsersConnection;
  usersSharedWithDepartments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};


export type StorageAuthAppsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AuthAppCondition>;
  filter?: InputMaybe<AuthAppFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AuthAppsOrderBy>>;
};


export type StorageCompanySettingsByValueStorageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanySettingCondition>;
  filter?: InputMaybe<CompanySettingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanySettingsOrderBy>>;
};


export type StorageContractSignPendingDocumentsByExistingStorageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingDocumentCondition>;
  filter?: InputMaybe<ContractSignPendingDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingDocumentsOrderBy>>;
};


export type StorageContractSignPendingSignersBySignatureFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingSignerCondition>;
  filter?: InputMaybe<ContractSignPendingSignerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingSignersOrderBy>>;
};


export type StorageDepartmentsSharedWithComputedColumnArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<DepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type StorageDocumentDepartmentPermissionsByFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentDepartmentPermissionCondition>;
  filter?: InputMaybe<DocumentDepartmentPermissionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentDepartmentPermissionsOrderBy>>;
};


export type StorageDocumentUserPermissionsByFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentUserPermissionCondition>;
  filter?: InputMaybe<DocumentUserPermissionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentUserPermissionsOrderBy>>;
};


export type StorageDocumentUserResponsiblesByFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentUserResponsibleCondition>;
  filter?: InputMaybe<DocumentUserResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentUserResponsiblesOrderBy>>;
};


export type StorageIntegrationFieldMarkingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<IntegrationFieldMarkingCondition>;
  filter?: InputMaybe<IntegrationFieldMarkingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegrationFieldMarkingsOrderBy>>;
};


export type StorageNotificationEmployeeReferencesByFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};


export type StorageSavedSignaturesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SavedSignatureCondition>;
  filter?: InputMaybe<SavedSignatureFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SavedSignaturesOrderBy>>;
};


export type StorageUsersResponsibleComputedColumnArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type StorageUsersSharedWithComputedColumnArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A condition to be used against `Storage` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type StorageCondition = {
  /** Checks for equality with the object’s `access` field. */
  access?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `belongsToLeader` field. */
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `contractSignPendingDocumentId` field. */
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deleteAt` field. */
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `departmentsSharedWith` field. */
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `documentFolderId` field. */
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `documentTemplateId` field. */
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `documentTypeId` field. */
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `employeeCasefileId` field. */
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `expireAt` field. */
  expireAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `expiredReminded` field. */
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `fileExtension` field. */
  fileExtension?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fileOwner` field. */
  fileOwner?: InputMaybe<StorageFileOwner>;
  /** Checks for equality with the object’s `fileOwnerId` field. */
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fileSize` field. */
  fileSize?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `fileType` field. */
  fileType?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `filename` field. */
  filename?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `folderDepartmentIds` field. */
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `folderDepartmentIdsSharedWith` field. */
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `folderOwnerId` field. */
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `folderUserIdsSharedWith` field. */
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `html` field. */
  html?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `mimetype` field. */
  mimetype?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `path` field. */
  path?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `penneoDocumentId` field. */
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `placeholderValues` field. */
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `remindAt` field. */
  remindAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `reminded` field. */
  reminded?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `rootDocumentFolderBlueprintId` field. */
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `templatingServiceId` field. */
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `usersResponsible` field. */
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `usersSharedWith` field. */
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `usersSharedWithDepartments` field. */
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `contractSignPendingDocument` to be created by this mutation. */
export type StorageContractSignPendingDocumentIdForeignConnectionContractSignPendingDocumentCreateInput = {
  company?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractName: Scalars['String'];
  contractSignPending?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  deleteExistingStorage?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  existingStorageId?: InputMaybe<Scalars['UUID']>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  signingUserIds: Array<InputMaybe<Scalars['UUID']>>;
  storage?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInput>;
  storages?: InputMaybe<StorageContractSignPendingDocumentIdForeignInverseInput>;
};

/** The `storage` to be created by this mutation. */
export type StorageContractSignPendingDocumentIdForeignConnectionStorageCreateInput = {
  access: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createCopy?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path: Scalars['String'];
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `contractSignPendingDocument` in the `StorageInput` mutation. */
export type StorageContractSignPendingDocumentIdForeignInput = {
  /** The primary key(s) for `contractSignPendingDocument` for the far side of the relationship. */
  connectById?: InputMaybe<ContractSignPendingDocumentContractSignPendingDocumentPkeyConnect>;
  /** A `ContractSignPendingDocumentInput` object that will be created and connected to this object. */
  create?: InputMaybe<StorageContractSignPendingDocumentIdForeignConnectionContractSignPendingDocumentCreateInput>;
  /** The primary key(s) for `contractSignPendingDocument` for the far side of the relationship. */
  deleteById?: InputMaybe<ContractSignPendingDocumentContractSignPendingDocumentPkeyDelete>;
  /** The primary key(s) and patch data for `contractSignPendingDocument` for the far side of the relationship. */
  updateById?: InputMaybe<ContractSignPendingDocumentOnStorageForStorageContractSignPendingDocumentIdForeignUsingContractSignPendingDocumentPkeyUpdate>;
};

/** Input for the nested mutation of `storage` in the `ContractSignPendingDocumentInput` mutation. */
export type StorageContractSignPendingDocumentIdForeignInverseInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<StorageStoragePkeyConnect>>;
  /** A `StorageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<StorageContractSignPendingDocumentIdForeignConnectionStorageCreateInput>>;
  /** The primary key(s) and patch data for `storage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<StorageOnStorageForStorageContractSignPendingDocumentIdForeignUsingStoragePkeyUpdate>>;
};

/** The `documentFolder` to be created by this mutation. */
export type StorageDocumentFolderIdForeignConnectionDocumentFolderCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolder?: InputMaybe<DocumentFolderParentDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastEdited?: InputMaybe<Scalars['Datetime']>;
  name: Scalars['String'];
  ownerId: Scalars['UUID'];
  ownerType: DocumentFolderOwnerType;
  parentDocumentFolderId?: InputMaybe<Scalars['UUID']>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageDocumentFolderIdForeignInverseInput>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `storage` to be created by this mutation. */
export type StorageDocumentFolderIdForeignConnectionStorageCreateInput = {
  access: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createCopy?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path: Scalars['String'];
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `documentFolder` in the `StorageInput` mutation. */
export type StorageDocumentFolderIdForeignInput = {
  /** The primary key(s) for `documentFolder` for the far side of the relationship. */
  connectById?: InputMaybe<DocumentFolderDocumentFolderPkeyConnect>;
  /** A `DocumentFolderInput` object that will be created and connected to this object. */
  create?: InputMaybe<StorageDocumentFolderIdForeignConnectionDocumentFolderCreateInput>;
  /** The primary key(s) and patch data for `documentFolder` for the far side of the relationship. */
  updateById?: InputMaybe<DocumentFolderOnStorageForStorageDocumentFolderIdForeignUsingDocumentFolderPkeyUpdate>;
};

/** Input for the nested mutation of `storage` in the `DocumentFolderInput` mutation. */
export type StorageDocumentFolderIdForeignInverseInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<StorageStoragePkeyConnect>>;
  /** A `StorageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<StorageDocumentFolderIdForeignConnectionStorageCreateInput>>;
  /** The primary key(s) and patch data for `storage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<StorageOnStorageForStorageDocumentFolderIdForeignUsingStoragePkeyUpdate>>;
};

/** The `contractTemplate` to be created by this mutation. */
export type StorageDocumentTemplateIdForeignConnectionContractTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInverseInput>;
  contractSignPendingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInverseInput>;
  contractTemplateFormFields?: InputMaybe<ContractTemplateFormFieldContractTemplateIdForeignInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<ContractTemplateDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  footer?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  htmlPlaceholders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  jobPositionTypes?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  placeholders?: InputMaybe<Scalars['JSON']>;
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
  signable?: InputMaybe<Scalars['Boolean']>;
  storages?: InputMaybe<StorageDocumentTemplateIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `storage` to be created by this mutation. */
export type StorageDocumentTemplateIdForeignConnectionStorageCreateInput = {
  access: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createCopy?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path: Scalars['String'];
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `contractTemplate` in the `StorageInput` mutation. */
export type StorageDocumentTemplateIdForeignInput = {
  /** The primary key(s) for `contractTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<ContractTemplateContractTemplatePkeyConnect>;
  /** A `ContractTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<StorageDocumentTemplateIdForeignConnectionContractTemplateCreateInput>;
  /** The primary key(s) and patch data for `contractTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<ContractTemplateOnStorageForStorageDocumentTemplateIdForeignUsingContractTemplatePkeyUpdate>;
};

/** Input for the nested mutation of `storage` in the `ContractTemplateInput` mutation. */
export type StorageDocumentTemplateIdForeignInverseInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<StorageStoragePkeyConnect>>;
  /** A `StorageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<StorageDocumentTemplateIdForeignConnectionStorageCreateInput>>;
  /** The primary key(s) and patch data for `storage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<StorageOnStorageForStorageDocumentTemplateIdForeignUsingStoragePkeyUpdate>>;
};

/** The `documentType` to be created by this mutation. */
export type StorageDocumentTypeIdForeignConnectionDocumentTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput>;
  contractTemplates?: InputMaybe<ContractTemplateDocumentTypeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lifetime?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  storages?: InputMaybe<StorageDocumentTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `storage` to be created by this mutation. */
export type StorageDocumentTypeIdForeignConnectionStorageCreateInput = {
  access: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createCopy?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path: Scalars['String'];
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `documentType` in the `StorageInput` mutation. */
export type StorageDocumentTypeIdForeignInput = {
  /** The primary key(s) for `documentType` for the far side of the relationship. */
  connectByCompanyIdAndDepartmentIdAndName?: InputMaybe<DocumentTypeDocumentTypeCompanyIdDepartmentIdNameUniqueConnect>;
  /** The primary key(s) for `documentType` for the far side of the relationship. */
  connectById?: InputMaybe<DocumentTypeDocumentTypePkeyConnect>;
  /** A `DocumentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<StorageDocumentTypeIdForeignConnectionDocumentTypeCreateInput>;
  /** The primary key(s) and patch data for `documentType` for the far side of the relationship. */
  updateByCompanyIdAndDepartmentIdAndName?: InputMaybe<DocumentTypeOnStorageForStorageDocumentTypeIdForeignUsingDocumentTypeCompanyIdDepartmentIdNameUniqueUpdate>;
  /** The primary key(s) and patch data for `documentType` for the far side of the relationship. */
  updateById?: InputMaybe<DocumentTypeOnStorageForStorageDocumentTypeIdForeignUsingDocumentTypePkeyUpdate>;
};

/** Input for the nested mutation of `storage` in the `DocumentTypeInput` mutation. */
export type StorageDocumentTypeIdForeignInverseInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<StorageStoragePkeyConnect>>;
  /** A `StorageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<StorageDocumentTypeIdForeignConnectionStorageCreateInput>>;
  /** The primary key(s) and patch data for `storage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<StorageOnStorageForStorageDocumentTypeIdForeignUsingStoragePkeyUpdate>>;
};

/** The `storage` to be created by this mutation. */
export type StorageEmployeeCasefileIdForeignConnectionStorageCreateInput = {
  access: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createCopy?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path: Scalars['String'];
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `employeeCasefile` in the `StorageInput` mutation. */
export type StorageEmployeeCasefileIdForeignInput = {
  /** The primary key(s) for `employeeCasefile` for the far side of the relationship. */
  connectByEmployeeIdAndCasefileId?: InputMaybe<EmployeeCasefileEmployeeCasefileEmployeeIdCasefileIdUniqueConnect>;
  /** The primary key(s) for `employeeCasefile` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeCasefileEmployeeCasefilePkeyConnect>;
  /** The primary key(s) and patch data for `employeeCasefile` for the far side of the relationship. */
  updateByEmployeeIdAndCasefileId?: InputMaybe<EmployeeCasefileOnStorageForStorageEmployeeCasefileIdForeignUsingEmployeeCasefileEmployeeIdCasefileIdUniqueUpdate>;
  /** The primary key(s) and patch data for `employeeCasefile` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeCasefileOnStorageForStorageEmployeeCasefileIdForeignUsingEmployeeCasefilePkeyUpdate>;
};

/** Input for the nested mutation of `storage` in the `EmployeeCasefileInput` mutation. */
export type StorageEmployeeCasefileIdForeignInverseInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<StorageStoragePkeyConnect>>;
  /** A `StorageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<StorageEmployeeCasefileIdForeignConnectionStorageCreateInput>>;
  /** The primary key(s) and patch data for `storage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<StorageOnStorageForStorageEmployeeCasefileIdForeignUsingStoragePkeyUpdate>>;
};

export type StorageFileOwner =
  | 'COMPANY'
  | 'COMPANY_FOLDER_DOCUMENT'
  | 'COMPETENCE'
  | 'CUSTOM_WIDGET'
  | 'DEPARTMENT'
  | 'EVENT'
  | 'INTEGRATION_FIELD_MARKING'
  | 'MESSAGE'
  | 'POST'
  | 'PREBOARDING'
  | 'PREBOARDING_SLIDE_FORM_FIELD'
  | 'PRODUCT'
  | 'SCHEDULED_MESSAGE'
  | 'SCHEDULED_MESSAGE_TEMPLATE'
  | 'TASK'
  | 'TASK_TEMPLATE'
  | 'USER'
  | 'USER_COMPETENCE'
  | 'USER_FOLDER_DOCUMENT';

/** A filter to be used against StorageFileOwner fields. All fields are combined with a logical ‘and.’ */
export type StorageFileOwnerFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<StorageFileOwner>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<StorageFileOwner>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<StorageFileOwner>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<StorageFileOwner>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<StorageFileOwner>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<StorageFileOwner>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<StorageFileOwner>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<StorageFileOwner>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<StorageFileOwner>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<StorageFileOwner>>;
};

/** A filter to be used against `Storage` object types. All fields are combined with a logical ‘and.’ */
export type StorageFilter = {
  /** Filter by the object’s `access` field. */
  access?: InputMaybe<StringFilter>;
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<StorageFilter>>;
  /** Filter by the object’s `authApps` relation. */
  authApps?: InputMaybe<StorageToManyAuthAppFilter>;
  /** Some related `authApps` exist. */
  authAppsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `belongsToLeader` field. */
  belongsToLeader?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `companySettingsByValueStorageId` relation. */
  companySettingsByValueStorageId?: InputMaybe<StorageToManyCompanySettingFilter>;
  /** Some related `companySettingsByValueStorageId` exist. */
  companySettingsByValueStorageIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractSignPendingDocument` relation. */
  contractSignPendingDocument?: InputMaybe<ContractSignPendingDocumentFilter>;
  /** A related `contractSignPendingDocument` exists. */
  contractSignPendingDocumentExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractSignPendingDocumentId` field. */
  contractSignPendingDocumentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `contractSignPendingDocumentsByExistingStorageId` relation. */
  contractSignPendingDocumentsByExistingStorageId?: InputMaybe<StorageToManyContractSignPendingDocumentFilter>;
  /** Some related `contractSignPendingDocumentsByExistingStorageId` exist. */
  contractSignPendingDocumentsByExistingStorageIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractSignPendingSignersBySignatureFileId` relation. */
  contractSignPendingSignersBySignatureFileId?: InputMaybe<StorageToManyContractSignPendingSignerFilter>;
  /** Some related `contractSignPendingSignersBySignatureFileId` exist. */
  contractSignPendingSignersBySignatureFileIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deleteAt` field. */
  deleteAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `departmentsSharedWith` field. */
  departmentsSharedWith?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `documentDepartmentPermissionsByFileId` relation. */
  documentDepartmentPermissionsByFileId?: InputMaybe<StorageToManyDocumentDepartmentPermissionFilter>;
  /** Some related `documentDepartmentPermissionsByFileId` exist. */
  documentDepartmentPermissionsByFileIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentFolder` relation. */
  documentFolder?: InputMaybe<DocumentFolderFilter>;
  /** A related `documentFolder` exists. */
  documentFolderExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentFolderId` field. */
  documentFolderId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `documentTemplate` relation. */
  documentTemplate?: InputMaybe<ContractTemplateFilter>;
  /** A related `documentTemplate` exists. */
  documentTemplateExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentTemplateId` field. */
  documentTemplateId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `documentType` relation. */
  documentType?: InputMaybe<DocumentTypeFilter>;
  /** A related `documentType` exists. */
  documentTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentTypeId` field. */
  documentTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `documentUserPermissionsByFileId` relation. */
  documentUserPermissionsByFileId?: InputMaybe<StorageToManyDocumentUserPermissionFilter>;
  /** Some related `documentUserPermissionsByFileId` exist. */
  documentUserPermissionsByFileIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentUserResponsiblesByFileId` relation. */
  documentUserResponsiblesByFileId?: InputMaybe<StorageToManyDocumentUserResponsibleFilter>;
  /** Some related `documentUserResponsiblesByFileId` exist. */
  documentUserResponsiblesByFileIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `employeeCasefile` relation. */
  employeeCasefile?: InputMaybe<EmployeeCasefileFilter>;
  /** A related `employeeCasefile` exists. */
  employeeCasefileExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `employeeCasefileId` field. */
  employeeCasefileId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `expireAt` field. */
  expireAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `expiredReminded` field. */
  expiredReminded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `fileExtension` field. */
  fileExtension?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fileOwner` field. */
  fileOwner?: InputMaybe<StorageFileOwnerFilter>;
  /** Filter by the object’s `fileOwnerId` field. */
  fileOwnerId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fileSize` field. */
  fileSize?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fileType` field. */
  fileType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `filename` field. */
  filename?: InputMaybe<StringFilter>;
  /** Filter by the object’s `folderDepartmentIds` field. */
  folderDepartmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `folderDepartmentIdsSharedWith` field. */
  folderDepartmentIdsSharedWith?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `folderOwnerId` field. */
  folderOwnerId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `folderUserIdsSharedWith` field. */
  folderUserIdsSharedWith?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `html` field. */
  html?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `integrationFieldMarkings` relation. */
  integrationFieldMarkings?: InputMaybe<StorageToManyIntegrationFieldMarkingFilter>;
  /** Some related `integrationFieldMarkings` exist. */
  integrationFieldMarkingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `mimetype` field. */
  mimetype?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<StorageFilter>;
  /** Filter by the object’s `notificationEmployeeReferencesByFileId` relation. */
  notificationEmployeeReferencesByFileId?: InputMaybe<StorageToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferencesByFileId` exist. */
  notificationEmployeeReferencesByFileIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<StorageFilter>>;
  /** Filter by the object’s `owner` field. */
  owner?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `ownerName` field. */
  ownerName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `path` field. */
  path?: InputMaybe<StringFilter>;
  /** Filter by the object’s `penneoDocumentId` field. */
  penneoDocumentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `placeholderValues` field. */
  placeholderValues?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `processType` relation. */
  processType?: InputMaybe<ProcessTypeFilter>;
  /** A related `processType` exists. */
  processTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `remindAt` field. */
  remindAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `reminded` field. */
  reminded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `rootDocumentFolderBlueprint` relation. */
  rootDocumentFolderBlueprint?: InputMaybe<DocumentFolderBlueprintFilter>;
  /** A related `rootDocumentFolderBlueprint` exists. */
  rootDocumentFolderBlueprintExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `rootDocumentFolderBlueprintId` field. */
  rootDocumentFolderBlueprintId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `savedSignatures` relation. */
  savedSignatures?: InputMaybe<StorageToManySavedSignatureFilter>;
  /** Some related `savedSignatures` exist. */
  savedSignaturesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `templatingServiceId` field. */
  templatingServiceId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `url` field. */
  url?: InputMaybe<StringFilter>;
  /** Filter by the object’s `usersResponsible` field. */
  usersResponsible?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `usersSharedWith` field. */
  usersSharedWith?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `usersSharedWithDepartments` field. */
  usersSharedWithDepartments?: InputMaybe<UuidListFilter>;
};

/** An input for mutations affecting `Storage` */
export type StorageInput = {
  access: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createCopy?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path: Scalars['String'];
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The fields on `storage` to look up the row to update. */
export type StorageOnAuthAppForAuthAppStorageIdFkeyUsingStoragePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `storage` being updated. */
  patch: UpdateStorageOnAuthAppForAuthAppStorageIdFkeyPatch;
};

/** The fields on `storage` to look up the row to update. */
export type StorageOnCompanySettingForCompanySettingValueStorageIdForeignUsingStoragePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `storage` being updated. */
  patch: UpdateStorageOnCompanySettingForCompanySettingValueStorageIdForeignPatch;
};

/** The fields on `storage` to look up the row to update. */
export type StorageOnContractSignPendingDocumentForContractSignPendingDocumentExistingStorageIdForeignUsingStoragePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `storage` being updated. */
  patch: UpdateStorageOnContractSignPendingDocumentForContractSignPendingDocumentExistingStorageIdForeignPatch;
};

/** The fields on `storage` to look up the row to update. */
export type StorageOnContractSignPendingSignerForContractSignPendingSignerSignatureFileIdForeignUsingStoragePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `storage` being updated. */
  patch: UpdateStorageOnContractSignPendingSignerForContractSignPendingSignerSignatureFileIdForeignPatch;
};

/** The fields on `storage` to look up the row to update. */
export type StorageOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsFileIdForeignUsingStoragePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `storage` being updated. */
  patch: UpdateStorageOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsFileIdForeignPatch;
};

/** The fields on `storage` to look up the row to update. */
export type StorageOnDocumentUserPermissionForDocumentUserPermissionsFileIdForeignUsingStoragePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `storage` being updated. */
  patch: UpdateStorageOnDocumentUserPermissionForDocumentUserPermissionsFileIdForeignPatch;
};

/** The fields on `storage` to look up the row to update. */
export type StorageOnDocumentUserResponsibleForDocumentUserResponsibleFileIdForeignUsingStoragePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `storage` being updated. */
  patch: UpdateStorageOnDocumentUserResponsibleForDocumentUserResponsibleFileIdForeignPatch;
};

/** The fields on `storage` to look up the row to update. */
export type StorageOnIntegrationFieldMarkingForIntegrationFieldMarkingStorageIdFkeyUsingStoragePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `storage` being updated. */
  patch: UpdateStorageOnIntegrationFieldMarkingForIntegrationFieldMarkingStorageIdFkeyPatch;
};

/** The fields on `storage` to look up the row to update. */
export type StorageOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFileIdForeignUsingStoragePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `storage` being updated. */
  patch: UpdateStorageOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFileIdForeignPatch;
};

/** The fields on `storage` to look up the row to update. */
export type StorageOnSavedSignatureForSavedSignatureStorageIdForeignUsingStoragePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `storage` being updated. */
  patch: UpdateStorageOnSavedSignatureForSavedSignatureStorageIdForeignPatch;
};

/** The fields on `storage` to look up the row to update. */
export type StorageOnStorageForStorageContractSignPendingDocumentIdForeignUsingStoragePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `storage` being updated. */
  patch: UpdateStorageOnStorageForStorageContractSignPendingDocumentIdForeignPatch;
};

/** The fields on `storage` to look up the row to update. */
export type StorageOnStorageForStorageDocumentFolderIdForeignUsingStoragePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `storage` being updated. */
  patch: UpdateStorageOnStorageForStorageDocumentFolderIdForeignPatch;
};

/** The fields on `storage` to look up the row to update. */
export type StorageOnStorageForStorageDocumentTemplateIdForeignUsingStoragePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `storage` being updated. */
  patch: UpdateStorageOnStorageForStorageDocumentTemplateIdForeignPatch;
};

/** The fields on `storage` to look up the row to update. */
export type StorageOnStorageForStorageDocumentTypeIdForeignUsingStoragePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `storage` being updated. */
  patch: UpdateStorageOnStorageForStorageDocumentTypeIdForeignPatch;
};

/** The fields on `storage` to look up the row to update. */
export type StorageOnStorageForStorageEmployeeCasefileIdForeignUsingStoragePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `storage` being updated. */
  patch: UpdateStorageOnStorageForStorageEmployeeCasefileIdForeignPatch;
};

/** The fields on `storage` to look up the row to update. */
export type StorageOnStorageForStorageProcessTypeIdForeignUsingStoragePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `storage` being updated. */
  patch: UpdateStorageOnStorageForStorageProcessTypeIdForeignPatch;
};

/** The fields on `storage` to look up the row to update. */
export type StorageOnStorageForStorageRootDocumentFolderBlueprintIdForeignUsingStoragePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `storage` being updated. */
  patch: UpdateStorageOnStorageForStorageRootDocumentFolderBlueprintIdForeignPatch;
};

/** Represents an update to a `Storage`. Fields that are set will be updated. */
export type StoragePatch = {
  access?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path?: InputMaybe<Scalars['String']>;
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `processType` to be created by this mutation. */
export type StorageProcessTypeIdForeignConnectionProcessTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `storage` to be created by this mutation. */
export type StorageProcessTypeIdForeignConnectionStorageCreateInput = {
  access: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createCopy?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path: Scalars['String'];
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `processType` in the `StorageInput` mutation. */
export type StorageProcessTypeIdForeignInput = {
  /** The primary key(s) for `processType` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessTypeProcessTypePkeyConnect>;
  /** A `ProcessTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<StorageProcessTypeIdForeignConnectionProcessTypeCreateInput>;
  /** The primary key(s) and patch data for `processType` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessTypeOnStorageForStorageProcessTypeIdForeignUsingProcessTypePkeyUpdate>;
};

/** Input for the nested mutation of `storage` in the `ProcessTypeInput` mutation. */
export type StorageProcessTypeIdForeignInverseInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<StorageStoragePkeyConnect>>;
  /** A `StorageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<StorageProcessTypeIdForeignConnectionStorageCreateInput>>;
  /** The primary key(s) and patch data for `storage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<StorageOnStorageForStorageProcessTypeIdForeignUsingStoragePkeyUpdate>>;
};

/** Input for the nested mutation of `productType` in the `StorageInput` mutation. */
export type StorageProductTypeIdForeignInput = {
  /** The primary key(s) for `productType` for the far side of the relationship. */
  connectByCompanyIdAndDepartmentIdAndName?: InputMaybe<ProductTypeProductTypeCompanyIdDepartmentIdNameUniqueConnect>;
  /** The primary key(s) for `productType` for the far side of the relationship. */
  connectById?: InputMaybe<ProductTypeProductTypePkeyConnect>;
};

/** Input for the nested mutation of `storage` in the `ProductTypeInput` mutation. */
export type StorageProductTypeIdForeignInverseInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<StorageStoragePkeyConnect>>;
};

/** Input for the nested mutation of `user` in the `StorageInput` mutation. */
export type StorageProductUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
};

/** Input for the nested mutation of `storage` in the `UserInput` mutation. */
export type StorageProductUserIdForeignInverseInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<StorageStoragePkeyConnect>>;
};

/** The `documentFolderBlueprint` to be created by this mutation. */
export type StorageRootDocumentFolderBlueprintIdForeignConnectionDocumentFolderBlueprintCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderBlueprintParentDocumentFolderBlueprintIdFInput>;
  documentFoldersToDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderDocumentFolderBlueprintIdForeignInverseInput>;
  documentFoldersToRootDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  parentDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInverseInput>;
};

/** The `storage` to be created by this mutation. */
export type StorageRootDocumentFolderBlueprintIdForeignConnectionStorageCreateInput = {
  access: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createCopy?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType: Scalars['String'];
  filename: Scalars['String'];
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path: Scalars['String'];
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `documentFolderBlueprint` in the `StorageInput` mutation. */
export type StorageRootDocumentFolderBlueprintIdForeignInput = {
  /** The primary key(s) for `documentFolderBlueprint` for the far side of the relationship. */
  connectById?: InputMaybe<DocumentFolderBlueprintDocumentFolderBlueprintPkeyConnect>;
  /** A `DocumentFolderBlueprintInput` object that will be created and connected to this object. */
  create?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignConnectionDocumentFolderBlueprintCreateInput>;
  /** The primary key(s) and patch data for `documentFolderBlueprint` for the far side of the relationship. */
  updateById?: InputMaybe<DocumentFolderBlueprintOnStorageForStorageRootDocumentFolderBlueprintIdForeignUsingDocumentFolderBlueprintPkeyUpdate>;
};

/** Input for the nested mutation of `storage` in the `DocumentFolderBlueprintInput` mutation. */
export type StorageRootDocumentFolderBlueprintIdForeignInverseInput = {
  /** The primary key(s) for `storage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<StorageStoragePkeyConnect>>;
  /** A `StorageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<StorageRootDocumentFolderBlueprintIdForeignConnectionStorageCreateInput>>;
  /** The primary key(s) and patch data for `storage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<StorageOnStorageForStorageRootDocumentFolderBlueprintIdForeignUsingStoragePkeyUpdate>>;
};

/** The fields on `storage` to look up the row to connect. */
export type StorageStoragePkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `AuthApp` object types. All fields are combined with a logical ‘and.’ */
export type StorageToManyAuthAppFilter = {
  /** Every related `AuthApp` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuthAppFilter>;
  /** No related `AuthApp` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuthAppFilter>;
  /** Some related `AuthApp` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuthAppFilter>;
};

/** A filter to be used against many `CompanySetting` object types. All fields are combined with a logical ‘and.’ */
export type StorageToManyCompanySettingFilter = {
  /** Every related `CompanySetting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompanySettingFilter>;
  /** No related `CompanySetting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompanySettingFilter>;
  /** Some related `CompanySetting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompanySettingFilter>;
};

/** A filter to be used against many `ContractSignPendingDocument` object types. All fields are combined with a logical ‘and.’ */
export type StorageToManyContractSignPendingDocumentFilter = {
  /** Every related `ContractSignPendingDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractSignPendingDocumentFilter>;
  /** No related `ContractSignPendingDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractSignPendingDocumentFilter>;
  /** Some related `ContractSignPendingDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractSignPendingDocumentFilter>;
};

/** A filter to be used against many `ContractSignPendingSigner` object types. All fields are combined with a logical ‘and.’ */
export type StorageToManyContractSignPendingSignerFilter = {
  /** Every related `ContractSignPendingSigner` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractSignPendingSignerFilter>;
  /** No related `ContractSignPendingSigner` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractSignPendingSignerFilter>;
  /** Some related `ContractSignPendingSigner` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractSignPendingSignerFilter>;
};

/** A filter to be used against many `DocumentDepartmentPermission` object types. All fields are combined with a logical ‘and.’ */
export type StorageToManyDocumentDepartmentPermissionFilter = {
  /** Every related `DocumentDepartmentPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentDepartmentPermissionFilter>;
  /** No related `DocumentDepartmentPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentDepartmentPermissionFilter>;
  /** Some related `DocumentDepartmentPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentDepartmentPermissionFilter>;
};

/** A filter to be used against many `DocumentUserPermission` object types. All fields are combined with a logical ‘and.’ */
export type StorageToManyDocumentUserPermissionFilter = {
  /** Every related `DocumentUserPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentUserPermissionFilter>;
  /** No related `DocumentUserPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentUserPermissionFilter>;
  /** Some related `DocumentUserPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentUserPermissionFilter>;
};

/** A filter to be used against many `DocumentUserResponsible` object types. All fields are combined with a logical ‘and.’ */
export type StorageToManyDocumentUserResponsibleFilter = {
  /** Every related `DocumentUserResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentUserResponsibleFilter>;
  /** No related `DocumentUserResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentUserResponsibleFilter>;
  /** Some related `DocumentUserResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentUserResponsibleFilter>;
};

/** A filter to be used against many `IntegrationFieldMarking` object types. All fields are combined with a logical ‘and.’ */
export type StorageToManyIntegrationFieldMarkingFilter = {
  /** Every related `IntegrationFieldMarking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<IntegrationFieldMarkingFilter>;
  /** No related `IntegrationFieldMarking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<IntegrationFieldMarkingFilter>;
  /** Some related `IntegrationFieldMarking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<IntegrationFieldMarkingFilter>;
};

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type StorageToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

/** A filter to be used against many `SavedSignature` object types. All fields are combined with a logical ‘and.’ */
export type StorageToManySavedSignatureFilter = {
  /** Every related `SavedSignature` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SavedSignatureFilter>;
  /** No related `SavedSignature` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SavedSignatureFilter>;
  /** Some related `SavedSignature` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SavedSignatureFilter>;
};

/** A connection to a list of `Storage` values. */
export type StoragesConnection = {
  __typename?: 'StoragesConnection';
  /** A list of edges which contains the `Storage` and cursor to aid in pagination. */
  edges: Array<StoragesEdge>;
  /** A list of `Storage` objects. */
  nodes: Array<Maybe<Storage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Storage` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Storage` edge in the connection. */
export type StoragesEdge = {
  __typename?: 'StoragesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Storage` at the end of the edge. */
  node?: Maybe<Storage>;
};

/** Methods to use when ordering `Storage`. */
export type StoragesOrderBy =
  | 'ACCESS_ASC'
  | 'ACCESS_DESC'
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'AUTH_APPS_BY_STORAGE_ID__COUNT_ASC'
  | 'AUTH_APPS_BY_STORAGE_ID__COUNT_DESC'
  | 'BELONGS_TO_LEADER_ASC'
  | 'BELONGS_TO_LEADER_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPANY_SETTINGS_BY_VALUE_STORAGE_ID__COUNT_ASC'
  | 'COMPANY_SETTINGS_BY_VALUE_STORAGE_ID__COUNT_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENTS_BY_EXISTING_STORAGE_ID__COUNT_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENTS_BY_EXISTING_STORAGE_ID__COUNT_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__COMPANY_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__COMPANY_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__CONTRACT_NAME_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__CONTRACT_NAME_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__CONTRACT_SIGN_PENDING_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__CONTRACT_SIGN_PENDING_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__CONTRACT_TEMPLATE_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__CONTRACT_TEMPLATE_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__DELETE_EXISTING_STORAGE_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__DELETE_EXISTING_STORAGE_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__DEPARTMENT_IDS_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__DEPARTMENT_IDS_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__DOCUMENT_TYPE_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__DOCUMENT_TYPE_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__EXISTING_STORAGE_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__EXISTING_STORAGE_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__FIELD_MAPPINGS_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__FIELD_MAPPINGS_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__ID_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__ID_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__ORDER_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__ORDER_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__PLACEHOLDER_VALUES_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__PLACEHOLDER_VALUES_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__SIGNING_USER_IDS_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_BY_CONTRACT_SIGN_PENDING_DOCUMENT_ID__SIGNING_USER_IDS_DESC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_ID_ASC'
  | 'CONTRACT_SIGN_PENDING_DOCUMENT_ID_DESC'
  | 'CONTRACT_SIGN_PENDING_SIGNERS_BY_SIGNATURE_FILE_ID__COUNT_ASC'
  | 'CONTRACT_SIGN_PENDING_SIGNERS_BY_SIGNATURE_FILE_ID__COUNT_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__ACTIVE_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__ACTIVE_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__BOTTOM_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__BOTTOM_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__COMPANY_ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__COMPANY_ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__CONTRACT_SIGN_PENDING_USER_IDS_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__CONTRACT_SIGN_PENDING_USER_IDS_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__CREATED_AT_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__CREATED_AT_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__DATE_FORMAT_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__DATE_FORMAT_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__DESCRIPTION_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__DESCRIPTION_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__DOCUMENT_TYPE_ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__DOCUMENT_TYPE_ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__FOOTER_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__FOOTER_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__HEADER_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__HEADER_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__HTML_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__HTML_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__HTML_PLACEHOLDERS_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__HTML_PLACEHOLDERS_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__IS_GLOBAL_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__IS_GLOBAL_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__JOB_POSITION_TYPES_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__JOB_POSITION_TYPES_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__LEFT_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__LEFT_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__LOCALE_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__LOCALE_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__NAME_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__NAME_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__PAGE_NUMBER_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__PAGE_NUMBER_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__PLACEHOLDERS_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__PLACEHOLDERS_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__RIGHT_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__RIGHT_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__SIGNABLE_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__SIGNABLE_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__TEMPLATING_SERVICE_ID_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__TEMPLATING_SERVICE_ID_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__TOP_MARGIN_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__TOP_MARGIN_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__UPDATED_AT_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__UPDATED_AT_DESC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__USERS_SHARED_WITH_ASC'
  | 'CONTRACT_TEMPLATE_BY_DOCUMENT_TEMPLATE_ID__USERS_SHARED_WITH_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DELETE_AT_ASC'
  | 'DELETE_AT_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'DEPARTMENTS_SHARED_WITH_ASC'
  | 'DEPARTMENTS_SHARED_WITH_DESC'
  | 'DOCUMENT_DEPARTMENT_PERMISSIONS_BY_FILE_ID__COUNT_ASC'
  | 'DOCUMENT_DEPARTMENT_PERMISSIONS_BY_FILE_ID__COUNT_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__ACTIVE_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__ACTIVE_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__COMPANY_ID_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__COMPANY_ID_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__ID_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__ID_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__NAME_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__NAME_DESC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'DOCUMENT_FOLDER_BLUEPRINT_BY_ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID__PARENT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__ACTIVE_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__ACTIVE_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__COMPANY_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__COMPANY_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__DEPARTMENTS_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__DEPARTMENTS_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__DEPARTMENTS_SHARED_WITH_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__DEPARTMENTS_SHARED_WITH_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__ID_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__LAST_EDITED_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__LAST_EDITED_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__NAME_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__NAME_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__OWNER_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__OWNER_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__OWNER_TYPE_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__OWNER_TYPE_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__PARENT_DOCUMENT_FOLDER_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__PARENT_DOCUMENT_FOLDER_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__USERS_SHARED_WITH_ASC'
  | 'DOCUMENT_FOLDER_BY_DOCUMENT_FOLDER_ID__USERS_SHARED_WITH_DESC'
  | 'DOCUMENT_FOLDER_ID_ASC'
  | 'DOCUMENT_FOLDER_ID_DESC'
  | 'DOCUMENT_TEMPLATE_ID_ASC'
  | 'DOCUMENT_TEMPLATE_ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ACTIVE_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ACTIVE_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__AUTO_DELETE_DAYS_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__AUTO_DELETE_DAYS_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__COMPANY_ID_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__COMPANY_ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__CREATED_AT_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__CREATED_AT_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DEPARTMENT_ID_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DEPARTMENT_ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ID_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__ID_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LIFETIME_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LIFETIME_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__NAME_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__NAME_DESC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__UPDATED_AT_ASC'
  | 'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__UPDATED_AT_DESC'
  | 'DOCUMENT_TYPE_ID_ASC'
  | 'DOCUMENT_TYPE_ID_DESC'
  | 'DOCUMENT_USER_PERMISSIONS_BY_FILE_ID__COUNT_ASC'
  | 'DOCUMENT_USER_PERMISSIONS_BY_FILE_ID__COUNT_DESC'
  | 'DOCUMENT_USER_RESPONSIBLES_BY_FILE_ID__COUNT_ASC'
  | 'DOCUMENT_USER_RESPONSIBLES_BY_FILE_ID__COUNT_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__BELONGS_TO_LEADER_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__BELONGS_TO_LEADER_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__CASEFILE_ID_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__CASEFILE_ID_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__CREATOR_USER_ID_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__CREATOR_USER_ID_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__DOCUMENTS_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__DOCUMENTS_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__DOCUMENT_TYPE_ID_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__DOCUMENT_TYPE_ID_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__EMPLOYEE_ID_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__ENFORCE_SIGN_ORDER_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__ENFORCE_SIGN_ORDER_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__EXPIRE_AT_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__EXPIRE_AT_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__FAILED_SYNC_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__FAILED_SYNC_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__ID_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__ID_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__LOCALE_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__LOCALE_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__NEXT_SIGNING_USER_ID_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__NEXT_SIGNING_USER_ID_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__NOTIFIED_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__NOTIFIED_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__RECIPIENTS_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__RECIPIENTS_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__SIGNED_USER_IDS_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__SIGNED_USER_IDS_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__SIGNERS_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__SIGNERS_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__SIGNING_USER_IDS_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__SIGNING_USER_IDS_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__STATUS_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__STATUS_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__TEMP_CASEFILE_ID_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__TEMP_CASEFILE_ID_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__TITLE_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__TITLE_DESC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__USER_ID_ASC'
  | 'EMPLOYEE_CASEFILE_BY_EMPLOYEE_CASEFILE_ID__USER_ID_DESC'
  | 'EMPLOYEE_CASEFILE_ID_ASC'
  | 'EMPLOYEE_CASEFILE_ID_DESC'
  | 'EXPIRED_REMINDED_ASC'
  | 'EXPIRED_REMINDED_DESC'
  | 'EXPIRE_AT_ASC'
  | 'EXPIRE_AT_DESC'
  | 'FILENAME_ASC'
  | 'FILENAME_DESC'
  | 'FILE_EXTENSION_ASC'
  | 'FILE_EXTENSION_DESC'
  | 'FILE_OWNER_ASC'
  | 'FILE_OWNER_DESC'
  | 'FILE_OWNER_ID_ASC'
  | 'FILE_OWNER_ID_DESC'
  | 'FILE_SIZE_ASC'
  | 'FILE_SIZE_DESC'
  | 'FILE_TYPE_ASC'
  | 'FILE_TYPE_DESC'
  | 'FOLDER_DEPARTMENT_IDS_ASC'
  | 'FOLDER_DEPARTMENT_IDS_DESC'
  | 'FOLDER_DEPARTMENT_IDS_SHARED_WITH_ASC'
  | 'FOLDER_DEPARTMENT_IDS_SHARED_WITH_DESC'
  | 'FOLDER_OWNER_ID_ASC'
  | 'FOLDER_OWNER_ID_DESC'
  | 'FOLDER_USER_IDS_SHARED_WITH_ASC'
  | 'FOLDER_USER_IDS_SHARED_WITH_DESC'
  | 'HTML_ASC'
  | 'HTML_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INTEGRATION_FIELD_MARKINGS_BY_STORAGE_ID__COUNT_ASC'
  | 'INTEGRATION_FIELD_MARKINGS_BY_STORAGE_ID__COUNT_DESC'
  | 'MIMETYPE_ASC'
  | 'MIMETYPE_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_FILE_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_FILE_ID__COUNT_DESC'
  | 'OWNER_NAME_ASC'
  | 'OWNER_NAME_DESC'
  | 'PATH_ASC'
  | 'PATH_DESC'
  | 'PENNEO_DOCUMENT_ID_ASC'
  | 'PENNEO_DOCUMENT_ID_DESC'
  | 'PLACEHOLDER_VALUES_ASC'
  | 'PLACEHOLDER_VALUES_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_DESC'
  | 'PROCESS_TYPE_ID_ASC'
  | 'PROCESS_TYPE_ID_DESC'
  | 'REMINDED_ASC'
  | 'REMINDED_DESC'
  | 'REMIND_AT_ASC'
  | 'REMIND_AT_DESC'
  | 'ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_ASC'
  | 'ROOT_DOCUMENT_FOLDER_BLUEPRINT_ID_DESC'
  | 'SAVED_SIGNATURES_BY_STORAGE_ID__COUNT_ASC'
  | 'SAVED_SIGNATURES_BY_STORAGE_ID__COUNT_DESC'
  | 'TEMPLATING_SERVICE_ID_ASC'
  | 'TEMPLATING_SERVICE_ID_DESC'
  | 'USERS_RESPONSIBLE_ASC'
  | 'USERS_RESPONSIBLE_DESC'
  | 'USERS_SHARED_WITH_ASC'
  | 'USERS_SHARED_WITH_DEPARTMENTS_ASC'
  | 'USERS_SHARED_WITH_DEPARTMENTS_DESC'
  | 'USERS_SHARED_WITH_DESC';

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern using the SQL standard's definition of a regular expression. */
  notSimilarTo?: InputMaybe<Scalars['String']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern using the SQL standard's definition of a regular expression. */
  similarTo?: InputMaybe<Scalars['String']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against String List fields. All fields are combined with a logical ‘and.’ */
export type StringListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['String']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['String']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['String']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['String']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubmitTimeRegistrationTemplateInput = {
  days?: InputMaybe<Array<TimeRegistrationDayTemplateInput>>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  weeks?: InputMaybe<Array<TimeRegistrationWeekTemplateInput>>;
};

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type Subscription = {
  __typename?: 'Subscription';
  asyncJobUpdated?: Maybe<AsyncJobSubscriptionPayload>;
  messageUpdated?: Maybe<MessageSubscriptionPayload>;
  timeRegistrationUpdated?: Maybe<TimeRegistrationSubscriptionPayload>;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionAsyncJobUpdatedArgs = {
  input: AsyncJobSubscriptionInput;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionMessageUpdatedArgs = {
  input: MessageSubscriptionInput;
};

export type SuperUser = {
  __typename?: 'SuperUser';
  companyBlacklist?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  companyWhitelist?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `SuperUserAllowedUser`. */
  superUserAllowedUsers: SuperUserAllowedUsersConnection;
  /** Reads a single `User` that is related to this `SuperUser`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};


export type SuperUserSuperUserAllowedUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SuperUserAllowedUserCondition>;
  filter?: InputMaybe<SuperUserAllowedUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuperUserAllowedUsersOrderBy>>;
};

export type SuperUserAllowedUser = {
  __typename?: 'SuperUserAllowedUser';
  allowedUserIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Company` that is related to this `SuperUserAllowedUser`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  disallowedUserIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  id: Scalars['UUID'];
  /** Reads a single `SuperUser` that is related to this `SuperUserAllowedUser`. */
  superUser?: Maybe<SuperUser>;
  superUserId: Scalars['UUID'];
  users: SuperUserAllowedUsersUsersConnection;
};


export type SuperUserAllowedUserUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  filter?: InputMaybe<SuperUserAllowedUsersUsersRecordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/**
 * A condition to be used against `SuperUserAllowedUser` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type SuperUserAllowedUserCondition = {
  /** Checks for equality with the object’s `allowedUserIds` field. */
  allowedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `disallowedUserIds` field. */
  disallowedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `superUserId` field. */
  superUserId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `SuperUserAllowedUser` object types. All fields are combined with a logical ‘and.’ */
export type SuperUserAllowedUserFilter = {
  /** Filter by the object’s `allowedUserIds` field. */
  allowedUserIds?: InputMaybe<UuidListFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SuperUserAllowedUserFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `disallowedUserIds` field. */
  disallowedUserIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SuperUserAllowedUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SuperUserAllowedUserFilter>>;
  /** Filter by the object’s `superUser` relation. */
  superUser?: InputMaybe<SuperUserFilter>;
  /** Filter by the object’s `superUserId` field. */
  superUserId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `SuperUserAllowedUser` */
export type SuperUserAllowedUserInput = {
  allowedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  company?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  disallowedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  superUser?: InputMaybe<SuperUserAllowedUsersSuperUserIdForeignInput>;
  superUserId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `superUserAllowedUser` to look up the row to update. */
export type SuperUserAllowedUserOnSuperUserAllowedUserForSuperUserAllowedUsersCompanyIdForeignUsingSuperUserAllowedUsersPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `superUserAllowedUser` being updated. */
  patch: UpdateSuperUserAllowedUserOnSuperUserAllowedUserForSuperUserAllowedUsersCompanyIdForeignPatch;
};

/** The fields on `superUserAllowedUser` to look up the row to update. */
export type SuperUserAllowedUserOnSuperUserAllowedUserForSuperUserAllowedUsersCompanyIdForeignUsingSuperUserAllowedUsersSuperUserIdCompanyIdUniqueUpdate = {
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `superUserAllowedUser` being updated. */
  patch: UpdateSuperUserAllowedUserOnSuperUserAllowedUserForSuperUserAllowedUsersCompanyIdForeignPatch;
  superUserId: Scalars['UUID'];
};

/** The fields on `superUserAllowedUser` to look up the row to update. */
export type SuperUserAllowedUserOnSuperUserAllowedUserForSuperUserAllowedUsersSuperUserIdForeignUsingSuperUserAllowedUsersPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `superUserAllowedUser` being updated. */
  patch: UpdateSuperUserAllowedUserOnSuperUserAllowedUserForSuperUserAllowedUsersSuperUserIdForeignPatch;
};

/** The fields on `superUserAllowedUser` to look up the row to update. */
export type SuperUserAllowedUserOnSuperUserAllowedUserForSuperUserAllowedUsersSuperUserIdForeignUsingSuperUserAllowedUsersSuperUserIdCompanyIdUniqueUpdate = {
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `superUserAllowedUser` being updated. */
  patch: UpdateSuperUserAllowedUserOnSuperUserAllowedUserForSuperUserAllowedUsersSuperUserIdForeignPatch;
  superUserId: Scalars['UUID'];
};

/** Represents an update to a `SuperUserAllowedUser`. Fields that are set will be updated. */
export type SuperUserAllowedUserPatch = {
  allowedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  company?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  disallowedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  superUser?: InputMaybe<SuperUserAllowedUsersSuperUserIdForeignInput>;
  superUserId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `superUserAllowedUser` to look up the row to connect. */
export type SuperUserAllowedUserSuperUserAllowedUsersPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `superUserAllowedUser` to look up the row to delete. */
export type SuperUserAllowedUserSuperUserAllowedUsersPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `superUserAllowedUser` to look up the row to connect. */
export type SuperUserAllowedUserSuperUserAllowedUsersSuperUserIdCompanyIdUniqueConnect = {
  companyId: Scalars['UUID'];
  superUserId: Scalars['UUID'];
};

/** The fields on `superUserAllowedUser` to look up the row to delete. */
export type SuperUserAllowedUserSuperUserAllowedUsersSuperUserIdCompanyIdUniqueDelete = {
  companyId: Scalars['UUID'];
  superUserId: Scalars['UUID'];
};

/** The `superUserAllowedUser` to be created by this mutation. */
export type SuperUserAllowedUsersCompanyIdForeignConnectionSuperUserAllowedUsersCreateInput = {
  allowedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  company?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInput>;
  disallowedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  superUser?: InputMaybe<SuperUserAllowedUsersSuperUserIdForeignInput>;
  superUserId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `SuperUserAllowedUserInput` mutation. */
export type SuperUserAllowedUsersCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnSuperUserAllowedUserForSuperUserAllowedUsersCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `superUserAllowedUser` in the `CompanyInput` mutation. */
export type SuperUserAllowedUsersCompanyIdForeignInverseInput = {
  /** The primary key(s) for `superUserAllowedUser` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SuperUserAllowedUserSuperUserAllowedUsersPkeyConnect>>;
  /** The primary key(s) for `superUserAllowedUser` for the far side of the relationship. */
  connectBySuperUserIdAndCompanyId?: InputMaybe<Array<SuperUserAllowedUserSuperUserAllowedUsersSuperUserIdCompanyIdUniqueConnect>>;
  /** A `SuperUserAllowedUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SuperUserAllowedUsersCompanyIdForeignConnectionSuperUserAllowedUsersCreateInput>>;
  /** The primary key(s) for `superUserAllowedUser` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SuperUserAllowedUserSuperUserAllowedUsersPkeyDelete>>;
  /** The primary key(s) for `superUserAllowedUser` for the far side of the relationship. */
  deleteBySuperUserIdAndCompanyId?: InputMaybe<Array<SuperUserAllowedUserSuperUserAllowedUsersSuperUserIdCompanyIdUniqueDelete>>;
  /** Flag indicating whether all other `superUserAllowedUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `superUserAllowedUser` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SuperUserAllowedUserOnSuperUserAllowedUserForSuperUserAllowedUsersCompanyIdForeignUsingSuperUserAllowedUsersPkeyUpdate>>;
  /** The primary key(s) and patch data for `superUserAllowedUser` for the far side of the relationship. */
  updateBySuperUserIdAndCompanyId?: InputMaybe<Array<SuperUserAllowedUserOnSuperUserAllowedUserForSuperUserAllowedUsersCompanyIdForeignUsingSuperUserAllowedUsersSuperUserIdCompanyIdUniqueUpdate>>;
};

/** A connection to a list of `SuperUserAllowedUser` values. */
export type SuperUserAllowedUsersConnection = {
  __typename?: 'SuperUserAllowedUsersConnection';
  /** A list of edges which contains the `SuperUserAllowedUser` and cursor to aid in pagination. */
  edges: Array<SuperUserAllowedUsersEdge>;
  /** A list of `SuperUserAllowedUser` objects. */
  nodes: Array<Maybe<SuperUserAllowedUser>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SuperUserAllowedUser` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SuperUserAllowedUser` edge in the connection. */
export type SuperUserAllowedUsersEdge = {
  __typename?: 'SuperUserAllowedUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SuperUserAllowedUser` at the end of the edge. */
  node?: Maybe<SuperUserAllowedUser>;
};

/** Methods to use when ordering `SuperUserAllowedUser`. */
export type SuperUserAllowedUsersOrderBy =
  | 'ALLOWED_USER_IDS_ASC'
  | 'ALLOWED_USER_IDS_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DISALLOWED_USER_IDS_ASC'
  | 'DISALLOWED_USER_IDS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SUPER_USER_BY_SUPER_USER_ID__COMPANY_BLACKLIST_ASC'
  | 'SUPER_USER_BY_SUPER_USER_ID__COMPANY_BLACKLIST_DESC'
  | 'SUPER_USER_BY_SUPER_USER_ID__COMPANY_WHITELIST_ASC'
  | 'SUPER_USER_BY_SUPER_USER_ID__COMPANY_WHITELIST_DESC'
  | 'SUPER_USER_BY_SUPER_USER_ID__CREATED_AT_ASC'
  | 'SUPER_USER_BY_SUPER_USER_ID__CREATED_AT_DESC'
  | 'SUPER_USER_BY_SUPER_USER_ID__ID_ASC'
  | 'SUPER_USER_BY_SUPER_USER_ID__ID_DESC'
  | 'SUPER_USER_BY_SUPER_USER_ID__USER_ID_ASC'
  | 'SUPER_USER_BY_SUPER_USER_ID__USER_ID_DESC'
  | 'SUPER_USER_ID_ASC'
  | 'SUPER_USER_ID_DESC';

/** The `superUserAllowedUser` to be created by this mutation. */
export type SuperUserAllowedUsersSuperUserIdForeignConnectionSuperUserAllowedUsersCreateInput = {
  allowedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  company?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  disallowedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  superUser?: InputMaybe<SuperUserAllowedUsersSuperUserIdForeignInput>;
};

/** The `superUser` to be created by this mutation. */
export type SuperUserAllowedUsersSuperUserIdForeignConnectionSuperUserCreateInput = {
  companyBlacklist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  companyWhitelist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersSuperUserIdForeignInverseInput>;
  user?: InputMaybe<SuperUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `superUser` in the `SuperUserAllowedUserInput` mutation. */
export type SuperUserAllowedUsersSuperUserIdForeignInput = {
  /** The primary key(s) for `superUser` for the far side of the relationship. */
  connectById?: InputMaybe<SuperUserSuperUserPkeyConnect>;
  /** The primary key(s) for `superUser` for the far side of the relationship. */
  connectByUserId?: InputMaybe<SuperUserSuperUserUserIdUniqueConnect>;
  /** A `SuperUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<SuperUserAllowedUsersSuperUserIdForeignConnectionSuperUserCreateInput>;
  /** The primary key(s) for `superUser` for the far side of the relationship. */
  deleteById?: InputMaybe<SuperUserSuperUserPkeyDelete>;
  /** The primary key(s) for `superUser` for the far side of the relationship. */
  deleteByUserId?: InputMaybe<SuperUserSuperUserUserIdUniqueDelete>;
  /** The primary key(s) and patch data for `superUser` for the far side of the relationship. */
  updateById?: InputMaybe<SuperUserOnSuperUserAllowedUserForSuperUserAllowedUsersSuperUserIdForeignUsingSuperUserPkeyUpdate>;
  /** The primary key(s) and patch data for `superUser` for the far side of the relationship. */
  updateByUserId?: InputMaybe<SuperUserOnSuperUserAllowedUserForSuperUserAllowedUsersSuperUserIdForeignUsingSuperUserUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `superUserAllowedUser` in the `SuperUserInput` mutation. */
export type SuperUserAllowedUsersSuperUserIdForeignInverseInput = {
  /** The primary key(s) for `superUserAllowedUser` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SuperUserAllowedUserSuperUserAllowedUsersPkeyConnect>>;
  /** The primary key(s) for `superUserAllowedUser` for the far side of the relationship. */
  connectBySuperUserIdAndCompanyId?: InputMaybe<Array<SuperUserAllowedUserSuperUserAllowedUsersSuperUserIdCompanyIdUniqueConnect>>;
  /** A `SuperUserAllowedUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SuperUserAllowedUsersSuperUserIdForeignConnectionSuperUserAllowedUsersCreateInput>>;
  /** The primary key(s) for `superUserAllowedUser` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<SuperUserAllowedUserSuperUserAllowedUsersPkeyDelete>>;
  /** The primary key(s) for `superUserAllowedUser` for the far side of the relationship. */
  deleteBySuperUserIdAndCompanyId?: InputMaybe<Array<SuperUserAllowedUserSuperUserAllowedUsersSuperUserIdCompanyIdUniqueDelete>>;
  /** Flag indicating whether all other `superUserAllowedUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `superUserAllowedUser` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SuperUserAllowedUserOnSuperUserAllowedUserForSuperUserAllowedUsersSuperUserIdForeignUsingSuperUserAllowedUsersPkeyUpdate>>;
  /** The primary key(s) and patch data for `superUserAllowedUser` for the far side of the relationship. */
  updateBySuperUserIdAndCompanyId?: InputMaybe<Array<SuperUserAllowedUserOnSuperUserAllowedUserForSuperUserAllowedUsersSuperUserIdForeignUsingSuperUserAllowedUsersSuperUserIdCompanyIdUniqueUpdate>>;
};

/** A `SuperUserAllowedUsersUsersRecord` edge in the connection. */
export type SuperUserAllowedUsersUserEdge = {
  __typename?: 'SuperUserAllowedUsersUserEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SuperUserAllowedUsersUsersRecord` at the end of the edge. */
  node?: Maybe<SuperUserAllowedUsersUsersRecord>;
};

/** A connection to a list of `SuperUserAllowedUsersUsersRecord` values. */
export type SuperUserAllowedUsersUsersConnection = {
  __typename?: 'SuperUserAllowedUsersUsersConnection';
  /** A list of edges which contains the `SuperUserAllowedUsersUsersRecord` and cursor to aid in pagination. */
  edges: Array<SuperUserAllowedUsersUserEdge>;
  /** A list of `SuperUserAllowedUsersUsersRecord` objects. */
  nodes: Array<Maybe<SuperUserAllowedUsersUsersRecord>>;
  /** The count of *all* `SuperUserAllowedUsersUsersRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The return type of our `users` query. */
export type SuperUserAllowedUsersUsersRecord = {
  __typename?: 'SuperUserAllowedUsersUsersRecord';
  companyId?: Maybe<Scalars['UUID']>;
  companyName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
};

/** A filter to be used against `SuperUserAllowedUsersUsersRecord` object types. All fields are combined with a logical ‘and.’ */
export type SuperUserAllowedUsersUsersRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SuperUserAllowedUsersUsersRecordFilter>>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `companyName` field. */
  companyName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SuperUserAllowedUsersUsersRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SuperUserAllowedUsersUsersRecordFilter>>;
};

/**
 * A condition to be used against `SuperUser` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SuperUserCondition = {
  /** Checks for equality with the object’s `companyBlacklist` field. */
  companyBlacklist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `companyWhitelist` field. */
  companyWhitelist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `SuperUser` object types. All fields are combined with a logical ‘and.’ */
export type SuperUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SuperUserFilter>>;
  /** Filter by the object’s `companyBlacklist` field. */
  companyBlacklist?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `companyWhitelist` field. */
  companyWhitelist?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SuperUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SuperUserFilter>>;
  /** Filter by the object’s `superUserAllowedUsers` relation. */
  superUserAllowedUsers?: InputMaybe<SuperUserToManySuperUserAllowedUserFilter>;
  /** Some related `superUserAllowedUsers` exist. */
  superUserAllowedUsersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `SuperUser` */
export type SuperUserInput = {
  companyBlacklist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  companyWhitelist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersSuperUserIdForeignInverseInput>;
  user?: InputMaybe<SuperUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type SuperUserLoginNote = {
  __typename?: 'SuperUserLoginNote';
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** Reads a single `LoginLog` that is related to this `SuperUserLoginNote`. */
  loginLog?: Maybe<LoginLog>;
  loginLogId?: Maybe<Scalars['UUID']>;
  note: Scalars['String'];
  /** Reads a single `User` that is related to this `SuperUserLoginNote`. */
  superUser?: Maybe<User>;
  superUserId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `SuperUserLoginNote`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/**
 * A condition to be used against `SuperUserLoginNote` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SuperUserLoginNoteCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `loginLogId` field. */
  loginLogId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `superUserId` field. */
  superUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `SuperUserLoginNote` object types. All fields are combined with a logical ‘and.’ */
export type SuperUserLoginNoteFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SuperUserLoginNoteFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `loginLog` relation. */
  loginLog?: InputMaybe<LoginLogFilter>;
  /** A related `loginLog` exists. */
  loginLogExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `loginLogId` field. */
  loginLogId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SuperUserLoginNoteFilter>;
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SuperUserLoginNoteFilter>>;
  /** Filter by the object’s `superUser` relation. */
  superUser?: InputMaybe<UserFilter>;
  /** Filter by the object’s `superUserId` field. */
  superUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** Input for the nested mutation of `loginLog` in the `SuperUserLoginNoteInput` mutation. */
export type SuperUserLoginNoteLoginLogIdForeignInput = {
  /** The primary key(s) for `loginLog` for the far side of the relationship. */
  connectById?: InputMaybe<LoginLogLoginLogPkeyConnect>;
  /** The primary key(s) and patch data for `loginLog` for the far side of the relationship. */
  updateById?: InputMaybe<LoginLogOnSuperUserLoginNoteForSuperUserLoginNoteLoginLogIdForeignUsingLoginLogPkeyUpdate>;
};

/** Input for the nested mutation of `superUserLoginNote` in the `LoginLogInput` mutation. */
export type SuperUserLoginNoteLoginLogIdForeignInverseInput = {
  /** The primary key(s) for `superUserLoginNote` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SuperUserLoginNoteSuperUserLoginNotePkeyConnect>>;
  /** The primary key(s) and patch data for `superUserLoginNote` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SuperUserLoginNoteOnSuperUserLoginNoteForSuperUserLoginNoteLoginLogIdForeignUsingSuperUserLoginNotePkeyUpdate>>;
};

/** The fields on `superUserLoginNote` to look up the row to update. */
export type SuperUserLoginNoteOnSuperUserLoginNoteForSuperUserLoginNoteLoginLogIdForeignUsingSuperUserLoginNotePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `superUserLoginNote` being updated. */
  patch: UpdateSuperUserLoginNoteOnSuperUserLoginNoteForSuperUserLoginNoteLoginLogIdForeignPatch;
};

/** The fields on `superUserLoginNote` to look up the row to update. */
export type SuperUserLoginNoteOnSuperUserLoginNoteForSuperUserLoginNoteSuperUserIdForeignUsingSuperUserLoginNotePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `superUserLoginNote` being updated. */
  patch: UpdateSuperUserLoginNoteOnSuperUserLoginNoteForSuperUserLoginNoteSuperUserIdForeignPatch;
};

/** The fields on `superUserLoginNote` to look up the row to update. */
export type SuperUserLoginNoteOnSuperUserLoginNoteForSuperUserLoginNoteUserIdForeignUsingSuperUserLoginNotePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `superUserLoginNote` being updated. */
  patch: UpdateSuperUserLoginNoteOnSuperUserLoginNoteForSuperUserLoginNoteUserIdForeignPatch;
};

/** Input for the nested mutation of `user` in the `SuperUserLoginNoteInput` mutation. */
export type SuperUserLoginNoteSuperUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnSuperUserLoginNoteForSuperUserLoginNoteSuperUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `superUserLoginNote` in the `UserInput` mutation. */
export type SuperUserLoginNoteSuperUserIdForeignInverseInput = {
  /** The primary key(s) for `superUserLoginNote` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SuperUserLoginNoteSuperUserLoginNotePkeyConnect>>;
  /** The primary key(s) and patch data for `superUserLoginNote` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SuperUserLoginNoteOnSuperUserLoginNoteForSuperUserLoginNoteSuperUserIdForeignUsingSuperUserLoginNotePkeyUpdate>>;
};

/** The fields on `superUserLoginNote` to look up the row to connect. */
export type SuperUserLoginNoteSuperUserLoginNotePkeyConnect = {
  id: Scalars['UUID'];
};

/** Input for the nested mutation of `superUserLoginNote` in the `UserInput` mutation. */
export type SuperUserLoginNoteUserIdForeignInverseInput = {
  /** The primary key(s) for `superUserLoginNote` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SuperUserLoginNoteSuperUserLoginNotePkeyConnect>>;
  /** The primary key(s) and patch data for `superUserLoginNote` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SuperUserLoginNoteOnSuperUserLoginNoteForSuperUserLoginNoteUserIdForeignUsingSuperUserLoginNotePkeyUpdate>>;
};

/** A connection to a list of `SuperUserLoginNote` values. */
export type SuperUserLoginNotesConnection = {
  __typename?: 'SuperUserLoginNotesConnection';
  /** A list of edges which contains the `SuperUserLoginNote` and cursor to aid in pagination. */
  edges: Array<SuperUserLoginNotesEdge>;
  /** A list of `SuperUserLoginNote` objects. */
  nodes: Array<Maybe<SuperUserLoginNote>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SuperUserLoginNote` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SuperUserLoginNote` edge in the connection. */
export type SuperUserLoginNotesEdge = {
  __typename?: 'SuperUserLoginNotesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SuperUserLoginNote` at the end of the edge. */
  node?: Maybe<SuperUserLoginNote>;
};

/** Methods to use when ordering `SuperUserLoginNote`. */
export type SuperUserLoginNotesOrderBy =
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOGIN_LOG_BY_LOGIN_LOG_ID__COMPANY_ID_ASC'
  | 'LOGIN_LOG_BY_LOGIN_LOG_ID__COMPANY_ID_DESC'
  | 'LOGIN_LOG_BY_LOGIN_LOG_ID__CREATED_AT_ASC'
  | 'LOGIN_LOG_BY_LOGIN_LOG_ID__CREATED_AT_DESC'
  | 'LOGIN_LOG_BY_LOGIN_LOG_ID__ID_ASC'
  | 'LOGIN_LOG_BY_LOGIN_LOG_ID__ID_DESC'
  | 'LOGIN_LOG_BY_LOGIN_LOG_ID__IP_ASC'
  | 'LOGIN_LOG_BY_LOGIN_LOG_ID__IP_DESC'
  | 'LOGIN_LOG_BY_LOGIN_LOG_ID__TYPE_ASC'
  | 'LOGIN_LOG_BY_LOGIN_LOG_ID__TYPE_DESC'
  | 'LOGIN_LOG_BY_LOGIN_LOG_ID__USER_ID_ASC'
  | 'LOGIN_LOG_BY_LOGIN_LOG_ID__USER_ID_DESC'
  | 'LOGIN_LOG_ID_ASC'
  | 'LOGIN_LOG_ID_DESC'
  | 'NATURAL'
  | 'NOTE_ASC'
  | 'NOTE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SUPER_USER_ID_ASC'
  | 'SUPER_USER_ID_DESC'
  | 'USER_BY_SUPER_USER_ID__ACTIVE_ASC'
  | 'USER_BY_SUPER_USER_ID__ACTIVE_DESC'
  | 'USER_BY_SUPER_USER_ID__ADDRESS_ASC'
  | 'USER_BY_SUPER_USER_ID__ADDRESS_DESC'
  | 'USER_BY_SUPER_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_SUPER_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_SUPER_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_SUPER_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_SUPER_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_SUPER_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_SUPER_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_SUPER_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_SUPER_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_SUPER_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_SUPER_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_SUPER_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_SUPER_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_SUPER_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_SUPER_USER_ID__CITY_ASC'
  | 'USER_BY_SUPER_USER_ID__CITY_DESC'
  | 'USER_BY_SUPER_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_SUPER_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_SUPER_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_SUPER_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_SUPER_USER_ID__CPR_ASC'
  | 'USER_BY_SUPER_USER_ID__CPR_DESC'
  | 'USER_BY_SUPER_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_SUPER_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_SUPER_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_SUPER_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_SUPER_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_SUPER_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_SUPER_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_SUPER_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_SUPER_USER_ID__EMAIL_ASC'
  | 'USER_BY_SUPER_USER_ID__EMAIL_DESC'
  | 'USER_BY_SUPER_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_SUPER_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_SUPER_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_SUPER_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_SUPER_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_SUPER_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_SUPER_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_SUPER_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_SUPER_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_SUPER_USER_ID__GODMODE_ASC'
  | 'USER_BY_SUPER_USER_ID__GODMODE_DESC'
  | 'USER_BY_SUPER_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_SUPER_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_SUPER_USER_ID__ID_ASC'
  | 'USER_BY_SUPER_USER_ID__ID_DESC'
  | 'USER_BY_SUPER_USER_ID__INITIALS_ASC'
  | 'USER_BY_SUPER_USER_ID__INITIALS_DESC'
  | 'USER_BY_SUPER_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_SUPER_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_SUPER_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_SUPER_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_SUPER_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_SUPER_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_SUPER_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_SUPER_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_SUPER_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_SUPER_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_SUPER_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_SUPER_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_SUPER_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_SUPER_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_SUPER_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_SUPER_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_SUPER_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_SUPER_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_SUPER_USER_ID__MOBILE_ASC'
  | 'USER_BY_SUPER_USER_ID__MOBILE_DESC'
  | 'USER_BY_SUPER_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_SUPER_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_SUPER_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_SUPER_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_SUPER_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_SUPER_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_SUPER_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_SUPER_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_SUPER_USER_ID__PHONE_ASC'
  | 'USER_BY_SUPER_USER_ID__PHONE_DESC'
  | 'USER_BY_SUPER_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_SUPER_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_SUPER_USER_ID__SENIORITY_ASC'
  | 'USER_BY_SUPER_USER_ID__SENIORITY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** The fields on `superUser` to look up the row to update. */
export type SuperUserOnSuperUserAllowedUserForSuperUserAllowedUsersSuperUserIdForeignUsingSuperUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `superUser` being updated. */
  patch: UpdateSuperUserOnSuperUserAllowedUserForSuperUserAllowedUsersSuperUserIdForeignPatch;
};

/** The fields on `superUser` to look up the row to update. */
export type SuperUserOnSuperUserAllowedUserForSuperUserAllowedUsersSuperUserIdForeignUsingSuperUserUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `superUser` being updated. */
  patch: UpdateSuperUserOnSuperUserAllowedUserForSuperUserAllowedUsersSuperUserIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `superUser` to look up the row to update. */
export type SuperUserOnSuperUserForSuperUserUserIdForeignUsingSuperUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `superUser` being updated. */
  patch: UpdateSuperUserOnSuperUserForSuperUserUserIdForeignPatch;
};

/** The fields on `superUser` to look up the row to update. */
export type SuperUserOnSuperUserForSuperUserUserIdForeignUsingSuperUserUserIdUniqueUpdate = {
  /** An object where the defined keys will be set on the `superUser` being updated. */
  patch: UpdateSuperUserOnSuperUserForSuperUserUserIdForeignPatch;
  userId: Scalars['UUID'];
};

/** Represents an update to a `SuperUser`. Fields that are set will be updated. */
export type SuperUserPatch = {
  companyBlacklist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  companyWhitelist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersSuperUserIdForeignInverseInput>;
  user?: InputMaybe<SuperUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `superUser` to look up the row to connect. */
export type SuperUserSuperUserPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `superUser` to look up the row to delete. */
export type SuperUserSuperUserPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `superUser` to look up the row to connect. */
export type SuperUserSuperUserUserIdUniqueConnect = {
  userId: Scalars['UUID'];
};

/** The fields on `superUser` to look up the row to delete. */
export type SuperUserSuperUserUserIdUniqueDelete = {
  userId: Scalars['UUID'];
};

/** A filter to be used against many `SuperUserAllowedUser` object types. All fields are combined with a logical ‘and.’ */
export type SuperUserToManySuperUserAllowedUserFilter = {
  /** Every related `SuperUserAllowedUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SuperUserAllowedUserFilter>;
  /** No related `SuperUserAllowedUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SuperUserAllowedUserFilter>;
  /** Some related `SuperUserAllowedUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SuperUserAllowedUserFilter>;
};

/** The `superUser` to be created by this mutation. */
export type SuperUserUserIdForeignConnectionSuperUserCreateInput = {
  companyBlacklist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  companyWhitelist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersSuperUserIdForeignInverseInput>;
  user?: InputMaybe<SuperUserUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `SuperUserInput` mutation. */
export type SuperUserUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnSuperUserForSuperUserUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `superUser` in the `UserInput` mutation. */
export type SuperUserUserIdForeignInverseInput = {
  /** The primary key(s) for `superUser` for the far side of the relationship. */
  connectById?: InputMaybe<SuperUserSuperUserPkeyConnect>;
  /** The primary key(s) for `superUser` for the far side of the relationship. */
  connectByUserId?: InputMaybe<SuperUserSuperUserUserIdUniqueConnect>;
  /** A `SuperUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<SuperUserUserIdForeignConnectionSuperUserCreateInput>>;
  /** The primary key(s) for `superUser` for the far side of the relationship. */
  deleteById?: InputMaybe<SuperUserSuperUserPkeyDelete>;
  /** The primary key(s) for `superUser` for the far side of the relationship. */
  deleteByUserId?: InputMaybe<SuperUserSuperUserUserIdUniqueDelete>;
  /** Flag indicating whether all other `superUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `superUser` for the far side of the relationship. */
  updateById?: InputMaybe<SuperUserOnSuperUserForSuperUserUserIdForeignUsingSuperUserPkeyUpdate>;
  /** The primary key(s) and patch data for `superUser` for the far side of the relationship. */
  updateByUserId?: InputMaybe<SuperUserOnSuperUserForSuperUserUserIdForeignUsingSuperUserUserIdUniqueUpdate>;
};

/** A connection to a list of `SuperUser` values. */
export type SuperUsersConnection = {
  __typename?: 'SuperUsersConnection';
  /** A list of edges which contains the `SuperUser` and cursor to aid in pagination. */
  edges: Array<SuperUsersEdge>;
  /** A list of `SuperUser` objects. */
  nodes: Array<Maybe<SuperUser>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SuperUser` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SuperUser` edge in the connection. */
export type SuperUsersEdge = {
  __typename?: 'SuperUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SuperUser` at the end of the edge. */
  node?: Maybe<SuperUser>;
};

/** Methods to use when ordering `SuperUser`. */
export type SuperUsersOrderBy =
  | 'COMPANY_BLACKLIST_ASC'
  | 'COMPANY_BLACKLIST_DESC'
  | 'COMPANY_WHITELIST_ASC'
  | 'COMPANY_WHITELIST_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SUPER_USER_ALLOWED_USERS_BY_SUPER_USER_ID__COUNT_ASC'
  | 'SUPER_USER_ALLOWED_USERS_BY_SUPER_USER_ID__COUNT_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type SystemField = {
  __typename?: 'SystemField';
  alwaysRequired: Scalars['Boolean'];
  companySystemField?: Maybe<CompanySystemField>;
  /** Reads and enables pagination through a set of `CompanySystemField`. */
  companySystemFields: CompanySystemFieldsConnection;
  /** Reads and enables pagination through a set of `CvTemplateFieldMapping`. */
  cvTemplateFieldMappings: CvTemplateFieldMappingsConnection;
  /** Reads and enables pagination through a set of `DashboardCardStatistic`. */
  dashboardCardStatistics: DashboardCardStatisticsConnection;
  documentTemplatePlaceholderName?: Maybe<Scalars['String']>;
  excludeFromPlaceholderForm: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `FutureDatum`. */
  futureData: FutureDataConnection;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `IntegrationFieldMarking`. */
  integrationFieldMarkings: IntegrationFieldMarkingsConnection;
  localizedName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  readOnly: Scalars['Boolean'];
  readableName?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `RelationRole`. */
  relationRoles: RelationRolesConnection;
  /** Reads a single `SystemFieldType` that is related to this `SystemField`. */
  systemFieldTypeByType?: Maybe<SystemFieldType>;
  type?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `UserSystemField`. */
  userSystemFields: UserSystemFieldsConnection;
};


export type SystemFieldCompanySystemFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanySystemFieldCondition>;
  filter?: InputMaybe<CompanySystemFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanySystemFieldsOrderBy>>;
};


export type SystemFieldCvTemplateFieldMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CvTemplateFieldMappingCondition>;
  filter?: InputMaybe<CvTemplateFieldMappingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CvTemplateFieldMappingsOrderBy>>;
};


export type SystemFieldDashboardCardStatisticsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DashboardCardStatisticCondition>;
  filter?: InputMaybe<DashboardCardStatisticFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DashboardCardStatisticsOrderBy>>;
};


export type SystemFieldFutureDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FutureDatumCondition>;
  filter?: InputMaybe<FutureDatumFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FutureDataOrderBy>>;
};


export type SystemFieldIntegrationFieldMarkingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<IntegrationFieldMarkingCondition>;
  filter?: InputMaybe<IntegrationFieldMarkingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegrationFieldMarkingsOrderBy>>;
};


export type SystemFieldRelationRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RelationRoleCondition>;
  filter?: InputMaybe<RelationRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RelationRolesOrderBy>>;
};


export type SystemFieldUserSystemFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserSystemFieldCondition>;
  filter?: InputMaybe<UserSystemFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSystemFieldsOrderBy>>;
};

/**
 * A condition to be used against `SystemField` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SystemFieldCondition = {
  /** Checks for equality with the object’s `alwaysRequired` field. */
  alwaysRequired?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `documentTemplatePlaceholderName` field. */
  documentTemplatePlaceholderName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `excludeFromPlaceholderForm` field. */
  excludeFromPlaceholderForm?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `readOnly` field. */
  readOnly?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `readableName` field. */
  readableName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `SystemField` object types. All fields are combined with a logical ‘and.’ */
export type SystemFieldFilter = {
  /** Filter by the object’s `alwaysRequired` field. */
  alwaysRequired?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SystemFieldFilter>>;
  /** Filter by the object’s `companySystemFields` relation. */
  companySystemFields?: InputMaybe<SystemFieldToManyCompanySystemFieldFilter>;
  /** Some related `companySystemFields` exist. */
  companySystemFieldsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `cvTemplateFieldMappings` relation. */
  cvTemplateFieldMappings?: InputMaybe<SystemFieldToManyCvTemplateFieldMappingFilter>;
  /** Some related `cvTemplateFieldMappings` exist. */
  cvTemplateFieldMappingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `dashboardCardStatistics` relation. */
  dashboardCardStatistics?: InputMaybe<SystemFieldToManyDashboardCardStatisticFilter>;
  /** Some related `dashboardCardStatistics` exist. */
  dashboardCardStatisticsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentTemplatePlaceholderName` field. */
  documentTemplatePlaceholderName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `excludeFromPlaceholderForm` field. */
  excludeFromPlaceholderForm?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `futureData` relation. */
  futureData?: InputMaybe<SystemFieldToManyFutureDatumFilter>;
  /** Some related `futureData` exist. */
  futureDataExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `integrationFieldMarkings` relation. */
  integrationFieldMarkings?: InputMaybe<SystemFieldToManyIntegrationFieldMarkingFilter>;
  /** Some related `integrationFieldMarkings` exist. */
  integrationFieldMarkingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SystemFieldFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SystemFieldFilter>>;
  /** Filter by the object’s `readOnly` field. */
  readOnly?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `readableName` field. */
  readableName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `relationRoles` relation. */
  relationRoles?: InputMaybe<SystemFieldToManyRelationRoleFilter>;
  /** Some related `relationRoles` exist. */
  relationRolesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `systemFieldTypeByType` relation. */
  systemFieldTypeByType?: InputMaybe<SystemFieldTypeFilter>;
  /** A related `systemFieldTypeByType` exists. */
  systemFieldTypeByTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userSystemFields` relation. */
  userSystemFields?: InputMaybe<SystemFieldToManyUserSystemFieldFilter>;
  /** Some related `userSystemFields` exist. */
  userSystemFieldsExist?: InputMaybe<Scalars['Boolean']>;
};

/** The fields on `systemField` to look up the row to update. */
export type SystemFieldOnCompanySystemFieldForCompanySystemFieldSystemFieldIdForeignUsingSystemFieldNameUniqueUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `systemField` being updated. */
  patch: UpdateSystemFieldOnCompanySystemFieldForCompanySystemFieldSystemFieldIdForeignPatch;
};

/** The fields on `systemField` to look up the row to update. */
export type SystemFieldOnCompanySystemFieldForCompanySystemFieldSystemFieldIdForeignUsingSystemFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `systemField` being updated. */
  patch: UpdateSystemFieldOnCompanySystemFieldForCompanySystemFieldSystemFieldIdForeignPatch;
};

/** The fields on `systemField` to look up the row to update. */
export type SystemFieldOnCvTemplateFieldMappingForCvTemplateFieldMappingSystemFieldIdForeignUsingSystemFieldNameUniqueUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `systemField` being updated. */
  patch: UpdateSystemFieldOnCvTemplateFieldMappingForCvTemplateFieldMappingSystemFieldIdForeignPatch;
};

/** The fields on `systemField` to look up the row to update. */
export type SystemFieldOnCvTemplateFieldMappingForCvTemplateFieldMappingSystemFieldIdForeignUsingSystemFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `systemField` being updated. */
  patch: UpdateSystemFieldOnCvTemplateFieldMappingForCvTemplateFieldMappingSystemFieldIdForeignPatch;
};

/** The fields on `systemField` to look up the row to update. */
export type SystemFieldOnDashboardCardStatisticForDashboardCardStatisticSystemFieldIdForeignUsingSystemFieldNameUniqueUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `systemField` being updated. */
  patch: UpdateSystemFieldOnDashboardCardStatisticForDashboardCardStatisticSystemFieldIdForeignPatch;
};

/** The fields on `systemField` to look up the row to update. */
export type SystemFieldOnDashboardCardStatisticForDashboardCardStatisticSystemFieldIdForeignUsingSystemFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `systemField` being updated. */
  patch: UpdateSystemFieldOnDashboardCardStatisticForDashboardCardStatisticSystemFieldIdForeignPatch;
};

/** The fields on `systemField` to look up the row to update. */
export type SystemFieldOnFutureDatumForFutureDataSystemFieldIdForeignUsingSystemFieldNameUniqueUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `systemField` being updated. */
  patch: UpdateSystemFieldOnFutureDatumForFutureDataSystemFieldIdForeignPatch;
};

/** The fields on `systemField` to look up the row to update. */
export type SystemFieldOnFutureDatumForFutureDataSystemFieldIdForeignUsingSystemFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `systemField` being updated. */
  patch: UpdateSystemFieldOnFutureDatumForFutureDataSystemFieldIdForeignPatch;
};

/** The fields on `systemField` to look up the row to update. */
export type SystemFieldOnIntegrationFieldMarkingForIntegrationFieldMarkingSystemFieldIdFkeyUsingSystemFieldNameUniqueUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `systemField` being updated. */
  patch: UpdateSystemFieldOnIntegrationFieldMarkingForIntegrationFieldMarkingSystemFieldIdFkeyPatch;
};

/** The fields on `systemField` to look up the row to update. */
export type SystemFieldOnIntegrationFieldMarkingForIntegrationFieldMarkingSystemFieldIdFkeyUsingSystemFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `systemField` being updated. */
  patch: UpdateSystemFieldOnIntegrationFieldMarkingForIntegrationFieldMarkingSystemFieldIdFkeyPatch;
};

/** The fields on `systemField` to look up the row to update. */
export type SystemFieldOnRelationRoleForRelationRoleSystemFieldIdForeignUsingSystemFieldNameUniqueUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `systemField` being updated. */
  patch: UpdateSystemFieldOnRelationRoleForRelationRoleSystemFieldIdForeignPatch;
};

/** The fields on `systemField` to look up the row to update. */
export type SystemFieldOnRelationRoleForRelationRoleSystemFieldIdForeignUsingSystemFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `systemField` being updated. */
  patch: UpdateSystemFieldOnRelationRoleForRelationRoleSystemFieldIdForeignPatch;
};

/** The fields on `systemField` to look up the row to update. */
export type SystemFieldOnSystemFieldForSystemFieldTypeForeignUsingSystemFieldNameUniqueUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `systemField` being updated. */
  patch: UpdateSystemFieldOnSystemFieldForSystemFieldTypeForeignPatch;
};

/** The fields on `systemField` to look up the row to update. */
export type SystemFieldOnSystemFieldForSystemFieldTypeForeignUsingSystemFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `systemField` being updated. */
  patch: UpdateSystemFieldOnSystemFieldForSystemFieldTypeForeignPatch;
};

/** The fields on `systemField` to look up the row to update. */
export type SystemFieldOnUserSystemFieldForUserSystemFieldSystemFieldIdForeignUsingSystemFieldNameUniqueUpdate = {
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `systemField` being updated. */
  patch: UpdateSystemFieldOnUserSystemFieldForUserSystemFieldSystemFieldIdForeignPatch;
};

/** The fields on `systemField` to look up the row to update. */
export type SystemFieldOnUserSystemFieldForUserSystemFieldSystemFieldIdForeignUsingSystemFieldPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `systemField` being updated. */
  patch: UpdateSystemFieldOnUserSystemFieldForUserSystemFieldSystemFieldIdForeignPatch;
};

/** The fields on `systemField` to look up the row to connect. */
export type SystemFieldSystemFieldNameUniqueConnect = {
  name: Scalars['String'];
};

/** The fields on `systemField` to look up the row to connect. */
export type SystemFieldSystemFieldPkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `CompanySystemField` object types. All fields are combined with a logical ‘and.’ */
export type SystemFieldToManyCompanySystemFieldFilter = {
  /** Every related `CompanySystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompanySystemFieldFilter>;
  /** No related `CompanySystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompanySystemFieldFilter>;
  /** Some related `CompanySystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompanySystemFieldFilter>;
};

/** A filter to be used against many `CvTemplateFieldMapping` object types. All fields are combined with a logical ‘and.’ */
export type SystemFieldToManyCvTemplateFieldMappingFilter = {
  /** Every related `CvTemplateFieldMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CvTemplateFieldMappingFilter>;
  /** No related `CvTemplateFieldMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CvTemplateFieldMappingFilter>;
  /** Some related `CvTemplateFieldMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CvTemplateFieldMappingFilter>;
};

/** A filter to be used against many `DashboardCardStatistic` object types. All fields are combined with a logical ‘and.’ */
export type SystemFieldToManyDashboardCardStatisticFilter = {
  /** Every related `DashboardCardStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DashboardCardStatisticFilter>;
  /** No related `DashboardCardStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DashboardCardStatisticFilter>;
  /** Some related `DashboardCardStatistic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DashboardCardStatisticFilter>;
};

/** A filter to be used against many `FutureDatum` object types. All fields are combined with a logical ‘and.’ */
export type SystemFieldToManyFutureDatumFilter = {
  /** Every related `FutureDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FutureDatumFilter>;
  /** No related `FutureDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FutureDatumFilter>;
  /** Some related `FutureDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FutureDatumFilter>;
};

/** A filter to be used against many `IntegrationFieldMarking` object types. All fields are combined with a logical ‘and.’ */
export type SystemFieldToManyIntegrationFieldMarkingFilter = {
  /** Every related `IntegrationFieldMarking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<IntegrationFieldMarkingFilter>;
  /** No related `IntegrationFieldMarking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<IntegrationFieldMarkingFilter>;
  /** Some related `IntegrationFieldMarking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<IntegrationFieldMarkingFilter>;
};

/** A filter to be used against many `RelationRole` object types. All fields are combined with a logical ‘and.’ */
export type SystemFieldToManyRelationRoleFilter = {
  /** Every related `RelationRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RelationRoleFilter>;
  /** No related `RelationRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RelationRoleFilter>;
  /** Some related `RelationRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RelationRoleFilter>;
};

/** A filter to be used against many `UserSystemField` object types. All fields are combined with a logical ‘and.’ */
export type SystemFieldToManyUserSystemFieldFilter = {
  /** Every related `UserSystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserSystemFieldFilter>;
  /** No related `UserSystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserSystemFieldFilter>;
  /** Some related `UserSystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserSystemFieldFilter>;
};

export type SystemFieldType = {
  __typename?: 'SystemFieldType';
  description?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `SystemField`. */
  systemFieldsByType: SystemFieldsConnection;
  type: Scalars['String'];
};


export type SystemFieldTypeSystemFieldsByTypeArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SystemFieldCondition>;
  filter?: InputMaybe<SystemFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SystemFieldsOrderBy>>;
};

/**
 * A condition to be used against `SystemFieldType` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SystemFieldTypeCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `SystemFieldType` object types. All fields are combined with a logical ‘and.’ */
export type SystemFieldTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SystemFieldTypeFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SystemFieldTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SystemFieldTypeFilter>>;
  /** Filter by the object’s `systemFieldsByType` relation. */
  systemFieldsByType?: InputMaybe<SystemFieldTypeToManySystemFieldFilter>;
  /** Some related `systemFieldsByType` exist. */
  systemFieldsByTypeExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
};

/** The `systemFieldType` to be created by this mutation. */
export type SystemFieldTypeForeignConnectionSystemFieldTypeCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  systemFields?: InputMaybe<SystemFieldTypeForeignInverseInput>;
};

/** Input for the nested mutation of `systemFieldType` in the `SystemFieldInput` mutation. */
export type SystemFieldTypeForeignInput = {
  /** The primary key(s) for `systemFieldType` for the far side of the relationship. */
  connectByType?: InputMaybe<SystemFieldTypeSystemFieldTypePkeyConnect>;
  /** A `SystemFieldTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<SystemFieldTypeForeignConnectionSystemFieldTypeCreateInput>;
  /** The primary key(s) for `systemFieldType` for the far side of the relationship. */
  deleteByType?: InputMaybe<SystemFieldTypeSystemFieldTypePkeyDelete>;
  /** The primary key(s) and patch data for `systemFieldType` for the far side of the relationship. */
  updateByType?: InputMaybe<SystemFieldTypeOnSystemFieldForSystemFieldTypeForeignUsingSystemFieldTypePkeyUpdate>;
};

/** Input for the nested mutation of `systemField` in the `SystemFieldTypeInput` mutation. */
export type SystemFieldTypeForeignInverseInput = {
  /** The primary key(s) for `systemField` for the far side of the relationship. */
  connectById?: InputMaybe<Array<SystemFieldSystemFieldPkeyConnect>>;
  /** The primary key(s) for `systemField` for the far side of the relationship. */
  connectByName?: InputMaybe<Array<SystemFieldSystemFieldNameUniqueConnect>>;
  /** The primary key(s) and patch data for `systemField` for the far side of the relationship. */
  updateById?: InputMaybe<Array<SystemFieldOnSystemFieldForSystemFieldTypeForeignUsingSystemFieldPkeyUpdate>>;
  /** The primary key(s) and patch data for `systemField` for the far side of the relationship. */
  updateByName?: InputMaybe<Array<SystemFieldOnSystemFieldForSystemFieldTypeForeignUsingSystemFieldNameUniqueUpdate>>;
};

/** An input for mutations affecting `SystemFieldType` */
export type SystemFieldTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  systemFields?: InputMaybe<SystemFieldTypeForeignInverseInput>;
  type: Scalars['String'];
};

/** The fields on `systemFieldType` to look up the row to update. */
export type SystemFieldTypeOnSystemFieldForSystemFieldTypeForeignUsingSystemFieldTypePkeyUpdate = {
  /** An object where the defined keys will be set on the `systemFieldType` being updated. */
  patch: UpdateSystemFieldTypeOnSystemFieldForSystemFieldTypeForeignPatch;
  type: Scalars['String'];
};

/** Represents an update to a `SystemFieldType`. Fields that are set will be updated. */
export type SystemFieldTypePatch = {
  description?: InputMaybe<Scalars['String']>;
  systemFields?: InputMaybe<SystemFieldTypeForeignInverseInput>;
  type?: InputMaybe<Scalars['String']>;
};

/** The fields on `systemFieldType` to look up the row to connect. */
export type SystemFieldTypeSystemFieldTypePkeyConnect = {
  type: Scalars['String'];
};

/** The fields on `systemFieldType` to look up the row to delete. */
export type SystemFieldTypeSystemFieldTypePkeyDelete = {
  type: Scalars['String'];
};

/** A filter to be used against many `SystemField` object types. All fields are combined with a logical ‘and.’ */
export type SystemFieldTypeToManySystemFieldFilter = {
  /** Every related `SystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SystemFieldFilter>;
  /** No related `SystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SystemFieldFilter>;
  /** Some related `SystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SystemFieldFilter>;
};

/** A connection to a list of `SystemFieldType` values. */
export type SystemFieldTypesConnection = {
  __typename?: 'SystemFieldTypesConnection';
  /** A list of edges which contains the `SystemFieldType` and cursor to aid in pagination. */
  edges: Array<SystemFieldTypesEdge>;
  /** A list of `SystemFieldType` objects. */
  nodes: Array<Maybe<SystemFieldType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SystemFieldType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SystemFieldType` edge in the connection. */
export type SystemFieldTypesEdge = {
  __typename?: 'SystemFieldTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SystemFieldType` at the end of the edge. */
  node?: Maybe<SystemFieldType>;
};

/** Methods to use when ordering `SystemFieldType`. */
export type SystemFieldTypesOrderBy =
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SYSTEM_FIELDS_BY_TYPE__COUNT_ASC'
  | 'SYSTEM_FIELDS_BY_TYPE__COUNT_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

/** A connection to a list of `SystemField` values. */
export type SystemFieldsConnection = {
  __typename?: 'SystemFieldsConnection';
  /** A list of edges which contains the `SystemField` and cursor to aid in pagination. */
  edges: Array<SystemFieldsEdge>;
  /** A list of `SystemField` objects. */
  nodes: Array<Maybe<SystemField>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SystemField` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SystemField` edge in the connection. */
export type SystemFieldsEdge = {
  __typename?: 'SystemFieldsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SystemField` at the end of the edge. */
  node?: Maybe<SystemField>;
};

/** Methods to use when ordering `SystemField`. */
export type SystemFieldsOrderBy =
  | 'ALWAYS_REQUIRED_ASC'
  | 'ALWAYS_REQUIRED_DESC'
  | 'COMPANY_SYSTEM_FIELDS_BY_SYSTEM_FIELD_ID__COUNT_ASC'
  | 'COMPANY_SYSTEM_FIELDS_BY_SYSTEM_FIELD_ID__COUNT_DESC'
  | 'CV_TEMPLATE_FIELD_MAPPINGS_BY_SYSTEM_FIELD_ID__COUNT_ASC'
  | 'CV_TEMPLATE_FIELD_MAPPINGS_BY_SYSTEM_FIELD_ID__COUNT_DESC'
  | 'DASHBOARD_CARD_STATISTICS_BY_SYSTEM_FIELD_ID__COUNT_ASC'
  | 'DASHBOARD_CARD_STATISTICS_BY_SYSTEM_FIELD_ID__COUNT_DESC'
  | 'DOCUMENT_TEMPLATE_PLACEHOLDER_NAME_ASC'
  | 'DOCUMENT_TEMPLATE_PLACEHOLDER_NAME_DESC'
  | 'EXCLUDE_FROM_PLACEHOLDER_FORM_ASC'
  | 'EXCLUDE_FROM_PLACEHOLDER_FORM_DESC'
  | 'FUTURE_DATA_BY_SYSTEM_FIELD_ID__COUNT_ASC'
  | 'FUTURE_DATA_BY_SYSTEM_FIELD_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INTEGRATION_FIELD_MARKINGS_BY_SYSTEM_FIELD_ID__COUNT_ASC'
  | 'INTEGRATION_FIELD_MARKINGS_BY_SYSTEM_FIELD_ID__COUNT_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'READABLE_NAME_ASC'
  | 'READABLE_NAME_DESC'
  | 'READ_ONLY_ASC'
  | 'READ_ONLY_DESC'
  | 'RELATION_ROLES_BY_SYSTEM_FIELD_ID__COUNT_ASC'
  | 'RELATION_ROLES_BY_SYSTEM_FIELD_ID__COUNT_DESC'
  | 'SYSTEM_FIELD_TYPE_BY_TYPE__DESCRIPTION_ASC'
  | 'SYSTEM_FIELD_TYPE_BY_TYPE__DESCRIPTION_DESC'
  | 'SYSTEM_FIELD_TYPE_BY_TYPE__TYPE_ASC'
  | 'SYSTEM_FIELD_TYPE_BY_TYPE__TYPE_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | 'USER_SYSTEM_FIELDS_BY_SYSTEM_FIELD_ID__COUNT_ASC'
  | 'USER_SYSTEM_FIELDS_BY_SYSTEM_FIELD_ID__COUNT_DESC';

export type SystemType =
  | 'CRM'
  | 'RECRUIT'
  | 'STAFF';

/** A filter to be used against SystemType fields. All fields are combined with a logical ‘and.’ */
export type SystemTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<SystemType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<SystemType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<SystemType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<SystemType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<SystemType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<SystemType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<SystemType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<SystemType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<SystemType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<SystemType>>;
};

/**
 *     View showing all tables with auditing set up. Ordered by schema, then table.
 *
 */
export type Tableslist = {
  __typename?: 'Tableslist';
  auditedtable?: Maybe<Scalars['SqlIdentifier']>;
  schema?: Maybe<Scalars['SqlIdentifier']>;
};

/**
 * A condition to be used against `Tableslist` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type TableslistCondition = {
  /** Checks for equality with the object’s `auditedtable` field. */
  auditedtable?: InputMaybe<Scalars['SqlIdentifier']>;
  /** Checks for equality with the object’s `schema` field. */
  schema?: InputMaybe<Scalars['SqlIdentifier']>;
};

/** A filter to be used against `Tableslist` object types. All fields are combined with a logical ‘and.’ */
export type TableslistFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TableslistFilter>>;
  /** Filter by the object’s `auditedtable` field. */
  auditedtable?: InputMaybe<SqlIdentifierFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TableslistFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TableslistFilter>>;
  /** Filter by the object’s `schema` field. */
  schema?: InputMaybe<SqlIdentifierFilter>;
};

/** A connection to a list of `Tableslist` values. */
export type TableslistsConnection = {
  __typename?: 'TableslistsConnection';
  /** A list of edges which contains the `Tableslist` and cursor to aid in pagination. */
  edges: Array<TableslistsEdge>;
  /** A list of `Tableslist` objects. */
  nodes: Array<Maybe<Tableslist>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Tableslist` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Tableslist` edge in the connection. */
export type TableslistsEdge = {
  __typename?: 'TableslistsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Tableslist` at the end of the edge. */
  node?: Maybe<Tableslist>;
};

/** Methods to use when ordering `Tableslist`. */
export type TableslistsOrderBy =
  | 'AUDITEDTABLE_ASC'
  | 'AUDITEDTABLE_DESC'
  | 'NATURAL'
  | 'SCHEMA_ASC'
  | 'SCHEMA_DESC';

export type Task = {
  __typename?: 'Task';
  active: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  /** Reads a single `User` that is related to this `Task`. */
  assignedProcessUser?: Maybe<User>;
  assignedProcessUserId?: Maybe<Scalars['UUID']>;
  calendarEventFrom?: Maybe<Scalars['Datetime']>;
  /** Reads a single `User` that is related to this `Task`. */
  calendarEventOrganizer?: Maybe<User>;
  calendarEventOrganizerId?: Maybe<Scalars['UUID']>;
  calendarEventRevisions?: Maybe<Scalars['Int']>;
  calendarEventTo?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Company` that is related to this `Task`. */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['UUID']>;
  completed: Scalars['Boolean'];
  completedAt?: Maybe<Scalars['Datetime']>;
  completedBy?: Maybe<Scalars['UUID']>;
  completedReminded?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['UUID']>;
  deadlineReminded?: Maybe<Scalars['Boolean']>;
  deadlineReminderDate?: Maybe<Scalars['Datetime']>;
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferences: NotificationEmployeeReferencesConnection;
  order?: Maybe<Scalars['Int']>;
  /** Reads a single `Task` that is related to this `Task`. */
  parentTask?: Maybe<Task>;
  parentTaskId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Process` that is related to this `Task`. */
  process?: Maybe<Process>;
  processId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ProcessType` that is related to this `Task`. */
  processType?: Maybe<ProcessType>;
  processTypeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Project` that is related to this `Task`. */
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['UUID']>;
  simpleAssignees?: Maybe<Array<Maybe<SimpleUser>>>;
  simpleResponsibles?: Maybe<Array<Maybe<SimpleUser>>>;
  startDate: Scalars['Datetime'];
  startReminded?: Maybe<Scalars['Boolean']>;
  /** Reads and enables pagination through a set of `Storage`. */
  storages: StoragesConnection;
  /** Reads and enables pagination through a set of `TaskEmployee`. */
  taskEmployees: TaskEmployeesConnection;
  /** Reads and enables pagination through a set of `TaskResponsible`. */
  taskResponsibles: TaskResponsiblesConnection;
  /** Reads and enables pagination through a set of `Task`. */
  tasksByParentTaskId: TasksConnection;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `Task`. */
  userByCompletedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `Task`. */
  userByCreatedBy?: Maybe<User>;
  userIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};


export type TaskNotificationEmployeeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};


export type TaskStoragesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type TaskTaskEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskEmployeeCondition>;
  filter?: InputMaybe<TaskEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskEmployeesOrderBy>>;
};


export type TaskTaskResponsiblesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskResponsibleCondition>;
  filter?: InputMaybe<TaskResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskResponsiblesOrderBy>>;
};


export type TaskTasksByParentTaskIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};

/** The `task` to be created by this mutation. */
export type TaskAssignedProcessUserIdForeignConnectionTaskCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['Datetime'];
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `task` in the `UserInput` mutation. */
export type TaskAssignedProcessUserIdForeignInverseInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTaskPkeyConnect>>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskAssignedProcessUserIdForeignConnectionTaskCreateInput>>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskOnTaskForTaskAssignedProcessUserIdForeignUsingTaskPkeyUpdate>>;
};

/** The `task` to be created by this mutation. */
export type TaskCalendarEventOrganizerIdForeignConnectionTaskCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['Datetime'];
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `task` in the `UserInput` mutation. */
export type TaskCalendarEventOrganizerIdForeignInverseInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTaskPkeyConnect>>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskCalendarEventOrganizerIdForeignConnectionTaskCreateInput>>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskOnTaskForTaskCalendarEventOrganizerIdForeignUsingTaskPkeyUpdate>>;
};

/** The `task` to be created by this mutation. */
export type TaskCompanyIdFkeyConnectionTaskCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['Datetime'];
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `company` in the `TaskInput` mutation. */
export type TaskCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnTaskForTaskCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `task` in the `CompanyInput` mutation. */
export type TaskCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTaskPkeyConnect>>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskCompanyIdFkeyConnectionTaskCreateInput>>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskOnTaskForTaskCompanyIdFkeyUsingTaskPkeyUpdate>>;
};

/** The `task` to be created by this mutation. */
export type TaskCompletedByForeignConnectionTaskCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['Datetime'];
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `user` in the `TaskInput` mutation. */
export type TaskCompletedByForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnTaskForTaskCompletedByForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `task` in the `UserInput` mutation. */
export type TaskCompletedByForeignInverseInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTaskPkeyConnect>>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskCompletedByForeignConnectionTaskCreateInput>>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskOnTaskForTaskCompletedByForeignUsingTaskPkeyUpdate>>;
};

/** A condition to be used against `Task` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type TaskCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `assignedProcessUserId` field. */
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `calendarEventFrom` field. */
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `calendarEventOrganizerId` field. */
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `calendarEventRevisions` field. */
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `calendarEventTo` field. */
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `completed` field. */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `completedAt` field. */
  completedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `completedBy` field. */
  completedBy?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `completedReminded` field. */
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `deadlineReminded` field. */
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `deadlineReminderDate` field. */
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notes` field. */
  notes?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `parentTaskId` field. */
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `processId` field. */
  processId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `startReminded` field. */
  startReminded?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userIds` field. */
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `task` to be created by this mutation. */
export type TaskCreatedByForeignConnectionTaskCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['Datetime'];
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `task` in the `UserInput` mutation. */
export type TaskCreatedByForeignInverseInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTaskPkeyConnect>>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskCreatedByForeignConnectionTaskCreateInput>>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskOnTaskForTaskCreatedByForeignUsingTaskPkeyUpdate>>;
};

export type TaskEmployee = {
  __typename?: 'TaskEmployee';
  assignReminded?: Maybe<Scalars['Boolean']>;
  /** Reads a single `User` that is related to this `TaskEmployee`. */
  assignedProcessUser?: Maybe<User>;
  assignedProcessUserId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Company` that is related to this `TaskEmployee`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Employee` that is related to this `TaskEmployee`. */
  employee?: Maybe<Employee>;
  employeeId: Scalars['UUID'];
  /** Reads a single `ProcessType` that is related to this `TaskEmployee`. */
  processType?: Maybe<ProcessType>;
  processTypeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Task` that is related to this `TaskEmployee`. */
  task?: Maybe<Task>;
  taskId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `TaskEmployee`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The `taskEmployee` to be created by this mutation. */
export type TaskEmployeeAssignedProcessUserIdForeignConnectionTaskEmployeeCreateInput = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TaskEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskEmployeeProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskEmployeeTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `user` in the `TaskEmployeeInput` mutation. */
export type TaskEmployeeAssignedProcessUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnTaskEmployeeForTaskEmployeeAssignedProcessUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `taskEmployee` in the `UserInput` mutation. */
export type TaskEmployeeAssignedProcessUserIdForeignInverseInput = {
  /** The primary key(s) for `taskEmployee` for the far side of the relationship. */
  connectByTaskIdAndEmployeeId?: InputMaybe<Array<TaskEmployeeTaskEmployeePkeyConnect>>;
  /** A `TaskEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskEmployeeAssignedProcessUserIdForeignConnectionTaskEmployeeCreateInput>>;
  /** The primary key(s) for `taskEmployee` for the far side of the relationship. */
  deleteByTaskIdAndEmployeeId?: InputMaybe<Array<TaskEmployeeTaskEmployeePkeyDelete>>;
  /** Flag indicating whether all other `taskEmployee` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `taskEmployee` for the far side of the relationship. */
  updateByTaskIdAndEmployeeId?: InputMaybe<Array<TaskEmployeeOnTaskEmployeeForTaskEmployeeAssignedProcessUserIdForeignUsingTaskEmployeePkeyUpdate>>;
};

/** The `taskEmployee` to be created by this mutation. */
export type TaskEmployeeCompanyIdFkeyConnectionTaskEmployeeCreateInput = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskEmployeeCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskEmployeeProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskEmployeeTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `TaskEmployeeInput` mutation. */
export type TaskEmployeeCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnTaskEmployeeForTaskEmployeeCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `taskEmployee` in the `CompanyInput` mutation. */
export type TaskEmployeeCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `taskEmployee` for the far side of the relationship. */
  connectByTaskIdAndEmployeeId?: InputMaybe<Array<TaskEmployeeTaskEmployeePkeyConnect>>;
  /** A `TaskEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskEmployeeCompanyIdFkeyConnectionTaskEmployeeCreateInput>>;
  /** The primary key(s) for `taskEmployee` for the far side of the relationship. */
  deleteByTaskIdAndEmployeeId?: InputMaybe<Array<TaskEmployeeTaskEmployeePkeyDelete>>;
  /** Flag indicating whether all other `taskEmployee` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `taskEmployee` for the far side of the relationship. */
  updateByTaskIdAndEmployeeId?: InputMaybe<Array<TaskEmployeeOnTaskEmployeeForTaskEmployeeCompanyIdFkeyUsingTaskEmployeePkeyUpdate>>;
};

/**
 * A condition to be used against `TaskEmployee` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TaskEmployeeCondition = {
  /** Checks for equality with the object’s `assignReminded` field. */
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `assignedProcessUserId` field. */
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `taskEmployee` to be created by this mutation. */
export type TaskEmployeeEmployeeIdForeignConnectionTaskEmployeeCreateInput = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskEmployeeEmployeeIdForeignInput>;
  processType?: InputMaybe<TaskEmployeeProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskEmployeeTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `employee` in the `TaskEmployeeInput` mutation. */
export type TaskEmployeeEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnTaskEmployeeForTaskEmployeeEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnTaskEmployeeForTaskEmployeeEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `taskEmployee` in the `EmployeeInput` mutation. */
export type TaskEmployeeEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `taskEmployee` for the far side of the relationship. */
  connectByTaskIdAndEmployeeId?: InputMaybe<Array<TaskEmployeeTaskEmployeePkeyConnect>>;
  /** A `TaskEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskEmployeeEmployeeIdForeignConnectionTaskEmployeeCreateInput>>;
  /** The primary key(s) for `taskEmployee` for the far side of the relationship. */
  deleteByTaskIdAndEmployeeId?: InputMaybe<Array<TaskEmployeeTaskEmployeePkeyDelete>>;
  /** Flag indicating whether all other `taskEmployee` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `taskEmployee` for the far side of the relationship. */
  updateByTaskIdAndEmployeeId?: InputMaybe<Array<TaskEmployeeOnTaskEmployeeForTaskEmployeeEmployeeIdForeignUsingTaskEmployeePkeyUpdate>>;
};

/** A filter to be used against `TaskEmployee` object types. All fields are combined with a logical ‘and.’ */
export type TaskEmployeeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TaskEmployeeFilter>>;
  /** Filter by the object’s `assignReminded` field. */
  assignReminded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `assignedProcessUser` relation. */
  assignedProcessUser?: InputMaybe<UserFilter>;
  /** A related `assignedProcessUser` exists. */
  assignedProcessUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `assignedProcessUserId` field. */
  assignedProcessUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TaskEmployeeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TaskEmployeeFilter>>;
  /** Filter by the object’s `processType` relation. */
  processType?: InputMaybe<ProcessTypeFilter>;
  /** A related `processType` exists. */
  processTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `task` relation. */
  task?: InputMaybe<TaskFilter>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `TaskEmployee` */
export type TaskEmployeeInput = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskEmployeeProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskEmployeeTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `taskEmployee` to look up the row to update. */
export type TaskEmployeeOnTaskEmployeeForTaskEmployeeAssignedProcessUserIdForeignUsingTaskEmployeePkeyUpdate = {
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `taskEmployee` being updated. */
  patch: UpdateTaskEmployeeOnTaskEmployeeForTaskEmployeeAssignedProcessUserIdForeignPatch;
  taskId: Scalars['UUID'];
};

/** The fields on `taskEmployee` to look up the row to update. */
export type TaskEmployeeOnTaskEmployeeForTaskEmployeeCompanyIdFkeyUsingTaskEmployeePkeyUpdate = {
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `taskEmployee` being updated. */
  patch: UpdateTaskEmployeeOnTaskEmployeeForTaskEmployeeCompanyIdFkeyPatch;
  taskId: Scalars['UUID'];
};

/** The fields on `taskEmployee` to look up the row to update. */
export type TaskEmployeeOnTaskEmployeeForTaskEmployeeEmployeeIdForeignUsingTaskEmployeePkeyUpdate = {
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `taskEmployee` being updated. */
  patch: UpdateTaskEmployeeOnTaskEmployeeForTaskEmployeeEmployeeIdForeignPatch;
  taskId: Scalars['UUID'];
};

/** The fields on `taskEmployee` to look up the row to update. */
export type TaskEmployeeOnTaskEmployeeForTaskEmployeeProcessTypeIdForeignUsingTaskEmployeePkeyUpdate = {
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `taskEmployee` being updated. */
  patch: UpdateTaskEmployeeOnTaskEmployeeForTaskEmployeeProcessTypeIdForeignPatch;
  taskId: Scalars['UUID'];
};

/** The fields on `taskEmployee` to look up the row to update. */
export type TaskEmployeeOnTaskEmployeeForTaskEmployeeTaskIdForeignUsingTaskEmployeePkeyUpdate = {
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `taskEmployee` being updated. */
  patch: UpdateTaskEmployeeOnTaskEmployeeForTaskEmployeeTaskIdForeignPatch;
  taskId: Scalars['UUID'];
};

/** The fields on `taskEmployee` to look up the row to update. */
export type TaskEmployeeOnTaskEmployeeForTaskEmployeeUserIdFkeyUsingTaskEmployeePkeyUpdate = {
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `taskEmployee` being updated. */
  patch: UpdateTaskEmployeeOnTaskEmployeeForTaskEmployeeUserIdFkeyPatch;
  taskId: Scalars['UUID'];
};

/** Represents an update to a `TaskEmployee`. Fields that are set will be updated. */
export type TaskEmployeePatch = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskEmployeeProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskEmployeeTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `processType` to be created by this mutation. */
export type TaskEmployeeProcessTypeIdForeignConnectionProcessTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `taskEmployee` to be created by this mutation. */
export type TaskEmployeeProcessTypeIdForeignConnectionTaskEmployeeCreateInput = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskEmployeeProcessTypeIdForeignInput>;
  task?: InputMaybe<TaskEmployeeTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `processType` in the `TaskEmployeeInput` mutation. */
export type TaskEmployeeProcessTypeIdForeignInput = {
  /** The primary key(s) for `processType` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessTypeProcessTypePkeyConnect>;
  /** A `ProcessTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskEmployeeProcessTypeIdForeignConnectionProcessTypeCreateInput>;
  /** The primary key(s) and patch data for `processType` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessTypeOnTaskEmployeeForTaskEmployeeProcessTypeIdForeignUsingProcessTypePkeyUpdate>;
};

/** Input for the nested mutation of `taskEmployee` in the `ProcessTypeInput` mutation. */
export type TaskEmployeeProcessTypeIdForeignInverseInput = {
  /** The primary key(s) for `taskEmployee` for the far side of the relationship. */
  connectByTaskIdAndEmployeeId?: InputMaybe<Array<TaskEmployeeTaskEmployeePkeyConnect>>;
  /** A `TaskEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskEmployeeProcessTypeIdForeignConnectionTaskEmployeeCreateInput>>;
  /** The primary key(s) for `taskEmployee` for the far side of the relationship. */
  deleteByTaskIdAndEmployeeId?: InputMaybe<Array<TaskEmployeeTaskEmployeePkeyDelete>>;
  /** Flag indicating whether all other `taskEmployee` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `taskEmployee` for the far side of the relationship. */
  updateByTaskIdAndEmployeeId?: InputMaybe<Array<TaskEmployeeOnTaskEmployeeForTaskEmployeeProcessTypeIdForeignUsingTaskEmployeePkeyUpdate>>;
};

/** The fields on `taskEmployee` to look up the row to connect. */
export type TaskEmployeeTaskEmployeePkeyConnect = {
  employeeId: Scalars['UUID'];
  taskId: Scalars['UUID'];
};

/** The fields on `taskEmployee` to look up the row to delete. */
export type TaskEmployeeTaskEmployeePkeyDelete = {
  employeeId: Scalars['UUID'];
  taskId: Scalars['UUID'];
};

/** The `task` to be created by this mutation. */
export type TaskEmployeeTaskIdForeignConnectionTaskCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['Datetime'];
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `taskEmployee` to be created by this mutation. */
export type TaskEmployeeTaskIdForeignConnectionTaskEmployeeCreateInput = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskEmployeeProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskEmployeeTaskIdForeignInput>;
  user?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `task` in the `TaskEmployeeInput` mutation. */
export type TaskEmployeeTaskIdForeignInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskEmployeeTaskIdForeignConnectionTaskCreateInput>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnTaskEmployeeForTaskEmployeeTaskIdForeignUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `taskEmployee` in the `TaskInput` mutation. */
export type TaskEmployeeTaskIdForeignInverseInput = {
  /** The primary key(s) for `taskEmployee` for the far side of the relationship. */
  connectByTaskIdAndEmployeeId?: InputMaybe<Array<TaskEmployeeTaskEmployeePkeyConnect>>;
  /** A `TaskEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskEmployeeTaskIdForeignConnectionTaskEmployeeCreateInput>>;
  /** The primary key(s) for `taskEmployee` for the far side of the relationship. */
  deleteByTaskIdAndEmployeeId?: InputMaybe<Array<TaskEmployeeTaskEmployeePkeyDelete>>;
  /** Flag indicating whether all other `taskEmployee` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `taskEmployee` for the far side of the relationship. */
  updateByTaskIdAndEmployeeId?: InputMaybe<Array<TaskEmployeeOnTaskEmployeeForTaskEmployeeTaskIdForeignUsingTaskEmployeePkeyUpdate>>;
};

/** The `taskEmployee` to be created by this mutation. */
export type TaskEmployeeUserIdFkeyConnectionTaskEmployeeCreateInput = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskEmployeeProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskEmployeeTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInput>;
};

/** Input for the nested mutation of `taskEmployee` in the `UserInput` mutation. */
export type TaskEmployeeUserIdFkeyInverseInput = {
  /** The primary key(s) for `taskEmployee` for the far side of the relationship. */
  connectByTaskIdAndEmployeeId?: InputMaybe<Array<TaskEmployeeTaskEmployeePkeyConnect>>;
  /** A `TaskEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskEmployeeUserIdFkeyConnectionTaskEmployeeCreateInput>>;
  /** The primary key(s) for `taskEmployee` for the far side of the relationship. */
  deleteByTaskIdAndEmployeeId?: InputMaybe<Array<TaskEmployeeTaskEmployeePkeyDelete>>;
  /** Flag indicating whether all other `taskEmployee` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `taskEmployee` for the far side of the relationship. */
  updateByTaskIdAndEmployeeId?: InputMaybe<Array<TaskEmployeeOnTaskEmployeeForTaskEmployeeUserIdFkeyUsingTaskEmployeePkeyUpdate>>;
};

/** A connection to a list of `TaskEmployee` values. */
export type TaskEmployeesConnection = {
  __typename?: 'TaskEmployeesConnection';
  /** A list of edges which contains the `TaskEmployee` and cursor to aid in pagination. */
  edges: Array<TaskEmployeesEdge>;
  /** A list of `TaskEmployee` objects. */
  nodes: Array<Maybe<TaskEmployee>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TaskEmployee` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TaskEmployee` edge in the connection. */
export type TaskEmployeesEdge = {
  __typename?: 'TaskEmployeesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TaskEmployee` at the end of the edge. */
  node?: Maybe<TaskEmployee>;
};

/** Methods to use when ordering `TaskEmployee`. */
export type TaskEmployeesOrderBy =
  | 'ASSIGNED_PROCESS_USER_ID_ASC'
  | 'ASSIGNED_PROCESS_USER_ID_DESC'
  | 'ASSIGN_REMINDED_ASC'
  | 'ASSIGN_REMINDED_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_DESC'
  | 'PROCESS_TYPE_ID_ASC'
  | 'PROCESS_TYPE_ID_DESC'
  | 'TASK_BY_TASK_ID__ACTIVE_ASC'
  | 'TASK_BY_TASK_ID__ACTIVE_DESC'
  | 'TASK_BY_TASK_ID__ARCHIVED_ASC'
  | 'TASK_BY_TASK_ID__ARCHIVED_DESC'
  | 'TASK_BY_TASK_ID__ASSIGNED_PROCESS_USER_ID_ASC'
  | 'TASK_BY_TASK_ID__ASSIGNED_PROCESS_USER_ID_DESC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_FROM_ASC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_FROM_DESC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_ORGANIZER_ID_ASC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_ORGANIZER_ID_DESC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_REVISIONS_ASC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_REVISIONS_DESC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_TO_ASC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_TO_DESC'
  | 'TASK_BY_TASK_ID__COMPANY_ID_ASC'
  | 'TASK_BY_TASK_ID__COMPANY_ID_DESC'
  | 'TASK_BY_TASK_ID__COMPLETED_ASC'
  | 'TASK_BY_TASK_ID__COMPLETED_AT_ASC'
  | 'TASK_BY_TASK_ID__COMPLETED_AT_DESC'
  | 'TASK_BY_TASK_ID__COMPLETED_BY_ASC'
  | 'TASK_BY_TASK_ID__COMPLETED_BY_DESC'
  | 'TASK_BY_TASK_ID__COMPLETED_DESC'
  | 'TASK_BY_TASK_ID__COMPLETED_REMINDED_ASC'
  | 'TASK_BY_TASK_ID__COMPLETED_REMINDED_DESC'
  | 'TASK_BY_TASK_ID__CREATED_AT_ASC'
  | 'TASK_BY_TASK_ID__CREATED_AT_DESC'
  | 'TASK_BY_TASK_ID__CREATED_BY_ASC'
  | 'TASK_BY_TASK_ID__CREATED_BY_DESC'
  | 'TASK_BY_TASK_ID__DEADLINE_REMINDED_ASC'
  | 'TASK_BY_TASK_ID__DEADLINE_REMINDED_DESC'
  | 'TASK_BY_TASK_ID__DEADLINE_REMINDER_DATE_ASC'
  | 'TASK_BY_TASK_ID__DEADLINE_REMINDER_DATE_DESC'
  | 'TASK_BY_TASK_ID__DEPARTMENTS_ASC'
  | 'TASK_BY_TASK_ID__DEPARTMENTS_DESC'
  | 'TASK_BY_TASK_ID__END_DATE_ASC'
  | 'TASK_BY_TASK_ID__END_DATE_DESC'
  | 'TASK_BY_TASK_ID__ID_ASC'
  | 'TASK_BY_TASK_ID__ID_DESC'
  | 'TASK_BY_TASK_ID__NAME_ASC'
  | 'TASK_BY_TASK_ID__NAME_DESC'
  | 'TASK_BY_TASK_ID__NOTES_ASC'
  | 'TASK_BY_TASK_ID__NOTES_DESC'
  | 'TASK_BY_TASK_ID__ORDER_ASC'
  | 'TASK_BY_TASK_ID__ORDER_DESC'
  | 'TASK_BY_TASK_ID__PARENT_TASK_ID_ASC'
  | 'TASK_BY_TASK_ID__PARENT_TASK_ID_DESC'
  | 'TASK_BY_TASK_ID__PROCESS_ID_ASC'
  | 'TASK_BY_TASK_ID__PROCESS_ID_DESC'
  | 'TASK_BY_TASK_ID__PROCESS_TYPE_ID_ASC'
  | 'TASK_BY_TASK_ID__PROCESS_TYPE_ID_DESC'
  | 'TASK_BY_TASK_ID__PROJECT_ID_ASC'
  | 'TASK_BY_TASK_ID__PROJECT_ID_DESC'
  | 'TASK_BY_TASK_ID__START_DATE_ASC'
  | 'TASK_BY_TASK_ID__START_DATE_DESC'
  | 'TASK_BY_TASK_ID__START_REMINDED_ASC'
  | 'TASK_BY_TASK_ID__START_REMINDED_DESC'
  | 'TASK_BY_TASK_ID__UPDATED_AT_ASC'
  | 'TASK_BY_TASK_ID__UPDATED_AT_DESC'
  | 'TASK_BY_TASK_ID__USER_IDS_ASC'
  | 'TASK_BY_TASK_ID__USER_IDS_DESC'
  | 'TASK_ID_ASC'
  | 'TASK_ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ACTIVE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ACTIVE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ADDRESS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ADDRESS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CITY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CITY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CPR_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CPR_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GODMODE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GODMODE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__INITIALS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__INITIALS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__PHONE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__PHONE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__SENIORITY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__SENIORITY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** A filter to be used against `Task` object types. All fields are combined with a logical ‘and.’ */
export type TaskFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TaskFilter>>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `assignedProcessUser` relation. */
  assignedProcessUser?: InputMaybe<UserFilter>;
  /** A related `assignedProcessUser` exists. */
  assignedProcessUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `assignedProcessUserId` field. */
  assignedProcessUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `calendarEventFrom` field. */
  calendarEventFrom?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `calendarEventOrganizer` relation. */
  calendarEventOrganizer?: InputMaybe<UserFilter>;
  /** A related `calendarEventOrganizer` exists. */
  calendarEventOrganizerExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `calendarEventOrganizerId` field. */
  calendarEventOrganizerId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `calendarEventRevisions` field. */
  calendarEventRevisions?: InputMaybe<IntFilter>;
  /** Filter by the object’s `calendarEventTo` field. */
  calendarEventTo?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** A related `company` exists. */
  companyExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `completed` field. */
  completed?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `completedAt` field. */
  completedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `completedBy` field. */
  completedBy?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `completedReminded` field. */
  completedReminded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `deadlineReminded` field. */
  deadlineReminded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `deadlineReminderDate` field. */
  deadlineReminderDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TaskFilter>;
  /** Filter by the object’s `notes` field. */
  notes?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notificationEmployeeReferences` relation. */
  notificationEmployeeReferences?: InputMaybe<TaskToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferences` exist. */
  notificationEmployeeReferencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TaskFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `parentTask` relation. */
  parentTask?: InputMaybe<TaskFilter>;
  /** A related `parentTask` exists. */
  parentTaskExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `parentTaskId` field. */
  parentTaskId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `process` relation. */
  process?: InputMaybe<ProcessFilter>;
  /** A related `process` exists. */
  processExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processId` field. */
  processId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `processType` relation. */
  processType?: InputMaybe<ProcessTypeFilter>;
  /** A related `processType` exists. */
  processTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `project` relation. */
  project?: InputMaybe<ProjectFilter>;
  /** A related `project` exists. */
  projectExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `startReminded` field. */
  startReminded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `taskEmployees` relation. */
  taskEmployees?: InputMaybe<TaskToManyTaskEmployeeFilter>;
  /** Some related `taskEmployees` exist. */
  taskEmployeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskResponsibles` relation. */
  taskResponsibles?: InputMaybe<TaskToManyTaskResponsibleFilter>;
  /** Some related `taskResponsibles` exist. */
  taskResponsiblesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `tasksByParentTaskId` relation. */
  tasksByParentTaskId?: InputMaybe<TaskToManyTaskFilter>;
  /** Some related `tasksByParentTaskId` exist. */
  tasksByParentTaskIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userByCompletedBy` relation. */
  userByCompletedBy?: InputMaybe<UserFilter>;
  /** A related `userByCompletedBy` exists. */
  userByCompletedByExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userByCreatedBy` relation. */
  userByCreatedBy?: InputMaybe<UserFilter>;
  /** A related `userByCreatedBy` exists. */
  userByCreatedByExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userIds` field. */
  userIds?: InputMaybe<UuidListFilter>;
};

/** An input for mutations affecting `Task` */
export type TaskInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['Datetime'];
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTaskIdForeignUsingTaskPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `task` being updated. */
  patch: UpdateTaskOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTaskIdForeignPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskEmployeeForTaskEmployeeTaskIdForeignUsingTaskPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `task` being updated. */
  patch: UpdateTaskOnTaskEmployeeForTaskEmployeeTaskIdForeignPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskAssignedProcessUserIdForeignUsingTaskPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `task` being updated. */
  patch: UpdateTaskOnTaskForTaskAssignedProcessUserIdForeignPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskCalendarEventOrganizerIdForeignUsingTaskPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `task` being updated. */
  patch: UpdateTaskOnTaskForTaskCalendarEventOrganizerIdForeignPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskCompanyIdFkeyUsingTaskPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `task` being updated. */
  patch: UpdateTaskOnTaskForTaskCompanyIdFkeyPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskCompletedByForeignUsingTaskPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `task` being updated. */
  patch: UpdateTaskOnTaskForTaskCompletedByForeignPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskCreatedByForeignUsingTaskPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `task` being updated. */
  patch: UpdateTaskOnTaskForTaskCreatedByForeignPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskParentTaskIdForeignUsingTaskPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `task` being updated. */
  patch: UpdateTaskOnTaskForTaskParentTaskIdForeignPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskProcessIdForeignUsingTaskPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `task` being updated. */
  patch: UpdateTaskOnTaskForTaskProcessIdForeignPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskProcessTypeIdForeignUsingTaskPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `task` being updated. */
  patch: UpdateTaskOnTaskForTaskProcessTypeIdForeignPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskProjectIdForeignUsingTaskPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `task` being updated. */
  patch: UpdateTaskOnTaskForTaskProjectIdForeignPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskResponsibleForTaskResponsibleTaskIdForeignUsingTaskPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `task` being updated. */
  patch: UpdateTaskOnTaskResponsibleForTaskResponsibleTaskIdForeignPatch;
};

/** The `task` to be created by this mutation. */
export type TaskParentTaskIdForeignConnectionTaskCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['Datetime'];
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `task` in the `TaskInput` mutation. */
export type TaskParentTaskIdForeignInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskParentTaskIdForeignConnectionTaskCreateInput>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnTaskForTaskParentTaskIdForeignUsingTaskPkeyUpdate>;
};

/** Represents an update to a `Task`. Fields that are set will be updated. */
export type TaskPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `process` to be created by this mutation. */
export type TaskProcessIdForeignConnectionProcessCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `task` to be created by this mutation. */
export type TaskProcessIdForeignConnectionTaskCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['Datetime'];
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `process` in the `TaskInput` mutation. */
export type TaskProcessIdForeignInput = {
  /** The primary key(s) for `process` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessProcessPkeyConnect>;
  /** A `ProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskProcessIdForeignConnectionProcessCreateInput>;
  /** The primary key(s) and patch data for `process` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessOnTaskForTaskProcessIdForeignUsingProcessPkeyUpdate>;
};

/** Input for the nested mutation of `task` in the `ProcessInput` mutation. */
export type TaskProcessIdForeignInverseInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTaskPkeyConnect>>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskProcessIdForeignConnectionTaskCreateInput>>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskOnTaskForTaskProcessIdForeignUsingTaskPkeyUpdate>>;
};

/** The `processType` to be created by this mutation. */
export type TaskProcessTypeIdForeignConnectionProcessTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `task` to be created by this mutation. */
export type TaskProcessTypeIdForeignConnectionTaskCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['Datetime'];
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `processType` in the `TaskInput` mutation. */
export type TaskProcessTypeIdForeignInput = {
  /** The primary key(s) for `processType` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessTypeProcessTypePkeyConnect>;
  /** A `ProcessTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskProcessTypeIdForeignConnectionProcessTypeCreateInput>;
  /** The primary key(s) and patch data for `processType` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessTypeOnTaskForTaskProcessTypeIdForeignUsingProcessTypePkeyUpdate>;
};

/** Input for the nested mutation of `task` in the `ProcessTypeInput` mutation. */
export type TaskProcessTypeIdForeignInverseInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTaskPkeyConnect>>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskProcessTypeIdForeignConnectionTaskCreateInput>>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskOnTaskForTaskProcessTypeIdForeignUsingTaskPkeyUpdate>>;
};

/** The `project` to be created by this mutation. */
export type TaskProjectIdForeignConnectionProjectCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProjectEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessages?: InputMaybe<ScheduledMessageProjectIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProjectIdForeignInverseInput>;
  user?: InputMaybe<ProjectAssignedProcessUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `task` to be created by this mutation. */
export type TaskProjectIdForeignConnectionTaskCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  startDate: Scalars['Datetime'];
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** Input for the nested mutation of `project` in the `TaskInput` mutation. */
export type TaskProjectIdForeignInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** A `ProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskProjectIdForeignConnectionProjectCreateInput>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnTaskForTaskProjectIdForeignUsingProjectPkeyUpdate>;
};

/** Input for the nested mutation of `task` in the `ProjectInput` mutation. */
export type TaskProjectIdForeignInverseInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTaskPkeyConnect>>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskProjectIdForeignConnectionTaskCreateInput>>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskOnTaskForTaskProjectIdForeignUsingTaskPkeyUpdate>>;
};

export type TaskResponsible = {
  __typename?: 'TaskResponsible';
  assignReminded?: Maybe<Scalars['Boolean']>;
  /** Reads a single `User` that is related to this `TaskResponsible`. */
  assignedProcessUser?: Maybe<User>;
  assignedProcessUserId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Company` that is related to this `TaskResponsible`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `ProcessType` that is related to this `TaskResponsible`. */
  processType?: Maybe<ProcessType>;
  processTypeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Employee` that is related to this `TaskResponsible`. */
  responsible?: Maybe<Employee>;
  responsibleId: Scalars['UUID'];
  /** Reads a single `Task` that is related to this `TaskResponsible`. */
  task?: Maybe<Task>;
  taskId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `TaskResponsible`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The `taskResponsible` to be created by this mutation. */
export type TaskResponsibleAssignedProcessUserIdForeignConnectionTaskResponsibleCreateInput = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TaskResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskResponsibleResponsibleIdForeignInput>;
  processType?: InputMaybe<TaskResponsibleProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskResponsibleTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `user` in the `TaskResponsibleInput` mutation. */
export type TaskResponsibleAssignedProcessUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnTaskResponsibleForTaskResponsibleAssignedProcessUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `taskResponsible` in the `UserInput` mutation. */
export type TaskResponsibleAssignedProcessUserIdForeignInverseInput = {
  /** The primary key(s) for `taskResponsible` for the far side of the relationship. */
  connectByTaskIdAndResponsibleId?: InputMaybe<Array<TaskResponsibleTaskResponsiblePkeyConnect>>;
  /** A `TaskResponsibleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskResponsibleAssignedProcessUserIdForeignConnectionTaskResponsibleCreateInput>>;
  /** The primary key(s) for `taskResponsible` for the far side of the relationship. */
  deleteByTaskIdAndResponsibleId?: InputMaybe<Array<TaskResponsibleTaskResponsiblePkeyDelete>>;
  /** Flag indicating whether all other `taskResponsible` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `taskResponsible` for the far side of the relationship. */
  updateByTaskIdAndResponsibleId?: InputMaybe<Array<TaskResponsibleOnTaskResponsibleForTaskResponsibleAssignedProcessUserIdForeignUsingTaskResponsiblePkeyUpdate>>;
};

/** The `taskResponsible` to be created by this mutation. */
export type TaskResponsibleCompanyIdFkeyConnectionTaskResponsibleCreateInput = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskResponsibleCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskResponsibleResponsibleIdForeignInput>;
  processType?: InputMaybe<TaskResponsibleProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskResponsibleTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `TaskResponsibleInput` mutation. */
export type TaskResponsibleCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnTaskResponsibleForTaskResponsibleCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `taskResponsible` in the `CompanyInput` mutation. */
export type TaskResponsibleCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `taskResponsible` for the far side of the relationship. */
  connectByTaskIdAndResponsibleId?: InputMaybe<Array<TaskResponsibleTaskResponsiblePkeyConnect>>;
  /** A `TaskResponsibleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskResponsibleCompanyIdFkeyConnectionTaskResponsibleCreateInput>>;
  /** The primary key(s) for `taskResponsible` for the far side of the relationship. */
  deleteByTaskIdAndResponsibleId?: InputMaybe<Array<TaskResponsibleTaskResponsiblePkeyDelete>>;
  /** Flag indicating whether all other `taskResponsible` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `taskResponsible` for the far side of the relationship. */
  updateByTaskIdAndResponsibleId?: InputMaybe<Array<TaskResponsibleOnTaskResponsibleForTaskResponsibleCompanyIdFkeyUsingTaskResponsiblePkeyUpdate>>;
};

/**
 * A condition to be used against `TaskResponsible` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TaskResponsibleCondition = {
  /** Checks for equality with the object’s `assignReminded` field. */
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `assignedProcessUserId` field. */
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `responsibleId` field. */
  responsibleId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `TaskResponsible` object types. All fields are combined with a logical ‘and.’ */
export type TaskResponsibleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TaskResponsibleFilter>>;
  /** Filter by the object’s `assignReminded` field. */
  assignReminded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `assignedProcessUser` relation. */
  assignedProcessUser?: InputMaybe<UserFilter>;
  /** A related `assignedProcessUser` exists. */
  assignedProcessUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `assignedProcessUserId` field. */
  assignedProcessUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TaskResponsibleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TaskResponsibleFilter>>;
  /** Filter by the object’s `processType` relation. */
  processType?: InputMaybe<ProcessTypeFilter>;
  /** A related `processType` exists. */
  processTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `responsible` relation. */
  responsible?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `responsibleId` field. */
  responsibleId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `task` relation. */
  task?: InputMaybe<TaskFilter>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `TaskResponsible` */
export type TaskResponsibleInput = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskResponsibleResponsibleIdForeignInput>;
  processType?: InputMaybe<TaskResponsibleProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskResponsibleTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `taskResponsible` to look up the row to update. */
export type TaskResponsibleOnTaskResponsibleForTaskResponsibleAssignedProcessUserIdForeignUsingTaskResponsiblePkeyUpdate = {
  /** An object where the defined keys will be set on the `taskResponsible` being updated. */
  patch: UpdateTaskResponsibleOnTaskResponsibleForTaskResponsibleAssignedProcessUserIdForeignPatch;
  responsibleId: Scalars['UUID'];
  taskId: Scalars['UUID'];
};

/** The fields on `taskResponsible` to look up the row to update. */
export type TaskResponsibleOnTaskResponsibleForTaskResponsibleCompanyIdFkeyUsingTaskResponsiblePkeyUpdate = {
  /** An object where the defined keys will be set on the `taskResponsible` being updated. */
  patch: UpdateTaskResponsibleOnTaskResponsibleForTaskResponsibleCompanyIdFkeyPatch;
  responsibleId: Scalars['UUID'];
  taskId: Scalars['UUID'];
};

/** The fields on `taskResponsible` to look up the row to update. */
export type TaskResponsibleOnTaskResponsibleForTaskResponsibleProcessTypeIdForeignUsingTaskResponsiblePkeyUpdate = {
  /** An object where the defined keys will be set on the `taskResponsible` being updated. */
  patch: UpdateTaskResponsibleOnTaskResponsibleForTaskResponsibleProcessTypeIdForeignPatch;
  responsibleId: Scalars['UUID'];
  taskId: Scalars['UUID'];
};

/** The fields on `taskResponsible` to look up the row to update. */
export type TaskResponsibleOnTaskResponsibleForTaskResponsibleResponsibleIdForeignUsingTaskResponsiblePkeyUpdate = {
  /** An object where the defined keys will be set on the `taskResponsible` being updated. */
  patch: UpdateTaskResponsibleOnTaskResponsibleForTaskResponsibleResponsibleIdForeignPatch;
  responsibleId: Scalars['UUID'];
  taskId: Scalars['UUID'];
};

/** The fields on `taskResponsible` to look up the row to update. */
export type TaskResponsibleOnTaskResponsibleForTaskResponsibleTaskIdForeignUsingTaskResponsiblePkeyUpdate = {
  /** An object where the defined keys will be set on the `taskResponsible` being updated. */
  patch: UpdateTaskResponsibleOnTaskResponsibleForTaskResponsibleTaskIdForeignPatch;
  responsibleId: Scalars['UUID'];
  taskId: Scalars['UUID'];
};

/** The fields on `taskResponsible` to look up the row to update. */
export type TaskResponsibleOnTaskResponsibleForTaskResponsibleUserIdFkeyUsingTaskResponsiblePkeyUpdate = {
  /** An object where the defined keys will be set on the `taskResponsible` being updated. */
  patch: UpdateTaskResponsibleOnTaskResponsibleForTaskResponsibleUserIdFkeyPatch;
  responsibleId: Scalars['UUID'];
  taskId: Scalars['UUID'];
};

/** Represents an update to a `TaskResponsible`. Fields that are set will be updated. */
export type TaskResponsiblePatch = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskResponsibleResponsibleIdForeignInput>;
  processType?: InputMaybe<TaskResponsibleProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskResponsibleTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `processType` to be created by this mutation. */
export type TaskResponsibleProcessTypeIdForeignConnectionProcessTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `taskResponsible` to be created by this mutation. */
export type TaskResponsibleProcessTypeIdForeignConnectionTaskResponsibleCreateInput = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskResponsibleResponsibleIdForeignInput>;
  processType?: InputMaybe<TaskResponsibleProcessTypeIdForeignInput>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskResponsibleTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `processType` in the `TaskResponsibleInput` mutation. */
export type TaskResponsibleProcessTypeIdForeignInput = {
  /** The primary key(s) for `processType` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessTypeProcessTypePkeyConnect>;
  /** A `ProcessTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskResponsibleProcessTypeIdForeignConnectionProcessTypeCreateInput>;
  /** The primary key(s) and patch data for `processType` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessTypeOnTaskResponsibleForTaskResponsibleProcessTypeIdForeignUsingProcessTypePkeyUpdate>;
};

/** Input for the nested mutation of `taskResponsible` in the `ProcessTypeInput` mutation. */
export type TaskResponsibleProcessTypeIdForeignInverseInput = {
  /** The primary key(s) for `taskResponsible` for the far side of the relationship. */
  connectByTaskIdAndResponsibleId?: InputMaybe<Array<TaskResponsibleTaskResponsiblePkeyConnect>>;
  /** A `TaskResponsibleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskResponsibleProcessTypeIdForeignConnectionTaskResponsibleCreateInput>>;
  /** The primary key(s) for `taskResponsible` for the far side of the relationship. */
  deleteByTaskIdAndResponsibleId?: InputMaybe<Array<TaskResponsibleTaskResponsiblePkeyDelete>>;
  /** Flag indicating whether all other `taskResponsible` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `taskResponsible` for the far side of the relationship. */
  updateByTaskIdAndResponsibleId?: InputMaybe<Array<TaskResponsibleOnTaskResponsibleForTaskResponsibleProcessTypeIdForeignUsingTaskResponsiblePkeyUpdate>>;
};

/** The `taskResponsible` to be created by this mutation. */
export type TaskResponsibleResponsibleIdForeignConnectionTaskResponsibleCreateInput = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskResponsibleResponsibleIdForeignInput>;
  processType?: InputMaybe<TaskResponsibleProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskResponsibleTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `employee` in the `TaskResponsibleInput` mutation. */
export type TaskResponsibleResponsibleIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnTaskResponsibleForTaskResponsibleResponsibleIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnTaskResponsibleForTaskResponsibleResponsibleIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `taskResponsible` in the `EmployeeInput` mutation. */
export type TaskResponsibleResponsibleIdForeignInverseInput = {
  /** The primary key(s) for `taskResponsible` for the far side of the relationship. */
  connectByTaskIdAndResponsibleId?: InputMaybe<Array<TaskResponsibleTaskResponsiblePkeyConnect>>;
  /** A `TaskResponsibleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskResponsibleResponsibleIdForeignConnectionTaskResponsibleCreateInput>>;
  /** The primary key(s) for `taskResponsible` for the far side of the relationship. */
  deleteByTaskIdAndResponsibleId?: InputMaybe<Array<TaskResponsibleTaskResponsiblePkeyDelete>>;
  /** Flag indicating whether all other `taskResponsible` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `taskResponsible` for the far side of the relationship. */
  updateByTaskIdAndResponsibleId?: InputMaybe<Array<TaskResponsibleOnTaskResponsibleForTaskResponsibleResponsibleIdForeignUsingTaskResponsiblePkeyUpdate>>;
};

/** The `task` to be created by this mutation. */
export type TaskResponsibleTaskIdForeignConnectionTaskCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['Datetime'];
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `taskResponsible` to be created by this mutation. */
export type TaskResponsibleTaskIdForeignConnectionTaskResponsibleCreateInput = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskResponsibleResponsibleIdForeignInput>;
  processType?: InputMaybe<TaskResponsibleProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskResponsibleTaskIdForeignInput>;
  user?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `task` in the `TaskResponsibleInput` mutation. */
export type TaskResponsibleTaskIdForeignInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskResponsibleTaskIdForeignConnectionTaskCreateInput>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnTaskResponsibleForTaskResponsibleTaskIdForeignUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `taskResponsible` in the `TaskInput` mutation. */
export type TaskResponsibleTaskIdForeignInverseInput = {
  /** The primary key(s) for `taskResponsible` for the far side of the relationship. */
  connectByTaskIdAndResponsibleId?: InputMaybe<Array<TaskResponsibleTaskResponsiblePkeyConnect>>;
  /** A `TaskResponsibleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskResponsibleTaskIdForeignConnectionTaskResponsibleCreateInput>>;
  /** The primary key(s) for `taskResponsible` for the far side of the relationship. */
  deleteByTaskIdAndResponsibleId?: InputMaybe<Array<TaskResponsibleTaskResponsiblePkeyDelete>>;
  /** Flag indicating whether all other `taskResponsible` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `taskResponsible` for the far side of the relationship. */
  updateByTaskIdAndResponsibleId?: InputMaybe<Array<TaskResponsibleOnTaskResponsibleForTaskResponsibleTaskIdForeignUsingTaskResponsiblePkeyUpdate>>;
};

/** The fields on `taskResponsible` to look up the row to connect. */
export type TaskResponsibleTaskResponsiblePkeyConnect = {
  responsibleId: Scalars['UUID'];
  taskId: Scalars['UUID'];
};

/** The fields on `taskResponsible` to look up the row to delete. */
export type TaskResponsibleTaskResponsiblePkeyDelete = {
  responsibleId: Scalars['UUID'];
  taskId: Scalars['UUID'];
};

/** The `taskResponsible` to be created by this mutation. */
export type TaskResponsibleUserIdFkeyConnectionTaskResponsibleCreateInput = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskResponsibleResponsibleIdForeignInput>;
  processType?: InputMaybe<TaskResponsibleProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskResponsibleTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInput>;
};

/** Input for the nested mutation of `taskResponsible` in the `UserInput` mutation. */
export type TaskResponsibleUserIdFkeyInverseInput = {
  /** The primary key(s) for `taskResponsible` for the far side of the relationship. */
  connectByTaskIdAndResponsibleId?: InputMaybe<Array<TaskResponsibleTaskResponsiblePkeyConnect>>;
  /** A `TaskResponsibleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskResponsibleUserIdFkeyConnectionTaskResponsibleCreateInput>>;
  /** The primary key(s) for `taskResponsible` for the far side of the relationship. */
  deleteByTaskIdAndResponsibleId?: InputMaybe<Array<TaskResponsibleTaskResponsiblePkeyDelete>>;
  /** Flag indicating whether all other `taskResponsible` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `taskResponsible` for the far side of the relationship. */
  updateByTaskIdAndResponsibleId?: InputMaybe<Array<TaskResponsibleOnTaskResponsibleForTaskResponsibleUserIdFkeyUsingTaskResponsiblePkeyUpdate>>;
};

/** A connection to a list of `TaskResponsible` values. */
export type TaskResponsiblesConnection = {
  __typename?: 'TaskResponsiblesConnection';
  /** A list of edges which contains the `TaskResponsible` and cursor to aid in pagination. */
  edges: Array<TaskResponsiblesEdge>;
  /** A list of `TaskResponsible` objects. */
  nodes: Array<Maybe<TaskResponsible>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TaskResponsible` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TaskResponsible` edge in the connection. */
export type TaskResponsiblesEdge = {
  __typename?: 'TaskResponsiblesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TaskResponsible` at the end of the edge. */
  node?: Maybe<TaskResponsible>;
};

/** Methods to use when ordering `TaskResponsible`. */
export type TaskResponsiblesOrderBy =
  | 'ASSIGNED_PROCESS_USER_ID_ASC'
  | 'ASSIGNED_PROCESS_USER_ID_DESC'
  | 'ASSIGN_REMINDED_ASC'
  | 'ASSIGN_REMINDED_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__ID_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__ID_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__USER_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_DESC'
  | 'PROCESS_TYPE_ID_ASC'
  | 'PROCESS_TYPE_ID_DESC'
  | 'RESPONSIBLE_ID_ASC'
  | 'RESPONSIBLE_ID_DESC'
  | 'TASK_BY_TASK_ID__ACTIVE_ASC'
  | 'TASK_BY_TASK_ID__ACTIVE_DESC'
  | 'TASK_BY_TASK_ID__ARCHIVED_ASC'
  | 'TASK_BY_TASK_ID__ARCHIVED_DESC'
  | 'TASK_BY_TASK_ID__ASSIGNED_PROCESS_USER_ID_ASC'
  | 'TASK_BY_TASK_ID__ASSIGNED_PROCESS_USER_ID_DESC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_FROM_ASC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_FROM_DESC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_ORGANIZER_ID_ASC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_ORGANIZER_ID_DESC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_REVISIONS_ASC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_REVISIONS_DESC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_TO_ASC'
  | 'TASK_BY_TASK_ID__CALENDAR_EVENT_TO_DESC'
  | 'TASK_BY_TASK_ID__COMPANY_ID_ASC'
  | 'TASK_BY_TASK_ID__COMPANY_ID_DESC'
  | 'TASK_BY_TASK_ID__COMPLETED_ASC'
  | 'TASK_BY_TASK_ID__COMPLETED_AT_ASC'
  | 'TASK_BY_TASK_ID__COMPLETED_AT_DESC'
  | 'TASK_BY_TASK_ID__COMPLETED_BY_ASC'
  | 'TASK_BY_TASK_ID__COMPLETED_BY_DESC'
  | 'TASK_BY_TASK_ID__COMPLETED_DESC'
  | 'TASK_BY_TASK_ID__COMPLETED_REMINDED_ASC'
  | 'TASK_BY_TASK_ID__COMPLETED_REMINDED_DESC'
  | 'TASK_BY_TASK_ID__CREATED_AT_ASC'
  | 'TASK_BY_TASK_ID__CREATED_AT_DESC'
  | 'TASK_BY_TASK_ID__CREATED_BY_ASC'
  | 'TASK_BY_TASK_ID__CREATED_BY_DESC'
  | 'TASK_BY_TASK_ID__DEADLINE_REMINDED_ASC'
  | 'TASK_BY_TASK_ID__DEADLINE_REMINDED_DESC'
  | 'TASK_BY_TASK_ID__DEADLINE_REMINDER_DATE_ASC'
  | 'TASK_BY_TASK_ID__DEADLINE_REMINDER_DATE_DESC'
  | 'TASK_BY_TASK_ID__DEPARTMENTS_ASC'
  | 'TASK_BY_TASK_ID__DEPARTMENTS_DESC'
  | 'TASK_BY_TASK_ID__END_DATE_ASC'
  | 'TASK_BY_TASK_ID__END_DATE_DESC'
  | 'TASK_BY_TASK_ID__ID_ASC'
  | 'TASK_BY_TASK_ID__ID_DESC'
  | 'TASK_BY_TASK_ID__NAME_ASC'
  | 'TASK_BY_TASK_ID__NAME_DESC'
  | 'TASK_BY_TASK_ID__NOTES_ASC'
  | 'TASK_BY_TASK_ID__NOTES_DESC'
  | 'TASK_BY_TASK_ID__ORDER_ASC'
  | 'TASK_BY_TASK_ID__ORDER_DESC'
  | 'TASK_BY_TASK_ID__PARENT_TASK_ID_ASC'
  | 'TASK_BY_TASK_ID__PARENT_TASK_ID_DESC'
  | 'TASK_BY_TASK_ID__PROCESS_ID_ASC'
  | 'TASK_BY_TASK_ID__PROCESS_ID_DESC'
  | 'TASK_BY_TASK_ID__PROCESS_TYPE_ID_ASC'
  | 'TASK_BY_TASK_ID__PROCESS_TYPE_ID_DESC'
  | 'TASK_BY_TASK_ID__PROJECT_ID_ASC'
  | 'TASK_BY_TASK_ID__PROJECT_ID_DESC'
  | 'TASK_BY_TASK_ID__START_DATE_ASC'
  | 'TASK_BY_TASK_ID__START_DATE_DESC'
  | 'TASK_BY_TASK_ID__START_REMINDED_ASC'
  | 'TASK_BY_TASK_ID__START_REMINDED_DESC'
  | 'TASK_BY_TASK_ID__UPDATED_AT_ASC'
  | 'TASK_BY_TASK_ID__UPDATED_AT_DESC'
  | 'TASK_BY_TASK_ID__USER_IDS_ASC'
  | 'TASK_BY_TASK_ID__USER_IDS_DESC'
  | 'TASK_ID_ASC'
  | 'TASK_ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ACTIVE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ACTIVE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ADDRESS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ADDRESS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CITY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CITY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CPR_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CPR_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GODMODE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GODMODE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__INITIALS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__INITIALS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__PHONE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__PHONE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__SENIORITY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__SENIORITY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** The fields on `task` to look up the row to connect. */
export type TaskTaskPkeyConnect = {
  id: Scalars['UUID'];
};

export type TaskTemplate = {
  __typename?: 'TaskTemplate';
  active: Scalars['Boolean'];
  calendarEventFrom?: Maybe<Scalars['Time']>;
  /** Reads a single `User` that is related to this `TaskTemplate`. */
  calendarEventOrganizer?: Maybe<User>;
  calendarEventOrganizerId?: Maybe<Scalars['UUID']>;
  calendarEventTo?: Maybe<Scalars['Time']>;
  /** Reads a single `Company` that is related to this `TaskTemplate`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  deadlineReminder?: Maybe<Scalars['Int']>;
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  duration: Scalars['Int'];
  id: Scalars['UUID'];
  includeCustomEmployeeFields?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  includeDirectManager: Scalars['Boolean'];
  includeDirectManagerResponsible: Scalars['Boolean'];
  includeEmployee: Scalars['Boolean'];
  includeEmployeeResponsible: Scalars['Boolean'];
  includeGroups?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferences: NotificationEmployeeReferencesConnection;
  order?: Maybe<Scalars['Int']>;
  /** Reads a single `TaskTemplate` that is related to this `TaskTemplate`. */
  parentTask?: Maybe<TaskTemplate>;
  parentTaskId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Process` that is related to this `TaskTemplate`. */
  process?: Maybe<Process>;
  processId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ProcessType` that is related to this `TaskTemplate`. */
  processType?: Maybe<ProcessType>;
  processTypeId?: Maybe<Scalars['UUID']>;
  /** Reads a single `ProjectTemplate` that is related to this `TaskTemplate`. */
  project?: Maybe<ProjectTemplate>;
  projectId?: Maybe<Scalars['UUID']>;
  simpleAssignees?: Maybe<Array<Maybe<SimpleUser>>>;
  simpleResponsibles?: Maybe<Array<Maybe<SimpleUser>>>;
  startDay: Scalars['Int'];
  /** Reads and enables pagination through a set of `Storage`. */
  storages: StoragesConnection;
  /** Reads and enables pagination through a set of `TaskTemplateEmployee`. */
  taskTemplateEmployees: TaskTemplateEmployeesConnection;
  /** Reads and enables pagination through a set of `TaskTemplateResponsible`. */
  taskTemplateResponsibles: TaskTemplateResponsiblesConnection;
  /** Reads and enables pagination through a set of `TaskTemplate`. */
  taskTemplatesByParentTaskId: TaskTemplatesConnection;
  updatedAt: Scalars['Datetime'];
  useCalendarEvent: Scalars['Boolean'];
};


export type TaskTemplateNotificationEmployeeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};


export type TaskTemplateStoragesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type TaskTemplateTaskTemplateEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskTemplateEmployeeCondition>;
  filter?: InputMaybe<TaskTemplateEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskTemplateEmployeesOrderBy>>;
};


export type TaskTemplateTaskTemplateResponsiblesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskTemplateResponsibleCondition>;
  filter?: InputMaybe<TaskTemplateResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskTemplateResponsiblesOrderBy>>;
};


export type TaskTemplateTaskTemplatesByParentTaskIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskTemplateCondition>;
  filter?: InputMaybe<TaskTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskTemplatesOrderBy>>;
};

/** The `taskTemplate` to be created by this mutation. */
export type TaskTemplateCalendarEventOrganizerIdForeignConnectionTaskTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `TaskTemplateInput` mutation. */
export type TaskTemplateCalendarEventOrganizerIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnTaskTemplateForTaskTemplateCalendarEventOrganizerIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `taskTemplate` in the `UserInput` mutation. */
export type TaskTemplateCalendarEventOrganizerIdForeignInverseInput = {
  /** The primary key(s) for `taskTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTemplateTaskTemplatePkeyConnect>>;
  /** A `TaskTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskTemplateCalendarEventOrganizerIdForeignConnectionTaskTemplateCreateInput>>;
  /** The primary key(s) and patch data for `taskTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskTemplateOnTaskTemplateForTaskTemplateCalendarEventOrganizerIdForeignUsingTaskTemplatePkeyUpdate>>;
};

/** The `taskTemplate` to be created by this mutation. */
export type TaskTemplateCompanyIdFkeyConnectionTaskTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** Input for the nested mutation of `company` in the `TaskTemplateInput` mutation. */
export type TaskTemplateCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnTaskTemplateForTaskTemplateCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `taskTemplate` in the `CompanyInput` mutation. */
export type TaskTemplateCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `taskTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTemplateTaskTemplatePkeyConnect>>;
  /** A `TaskTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskTemplateCompanyIdFkeyConnectionTaskTemplateCreateInput>>;
  /** The primary key(s) and patch data for `taskTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskTemplateOnTaskTemplateForTaskTemplateCompanyIdFkeyUsingTaskTemplatePkeyUpdate>>;
};

/**
 * A condition to be used against `TaskTemplate` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TaskTemplateCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `calendarEventFrom` field. */
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `calendarEventOrganizerId` field. */
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `calendarEventTo` field. */
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deadlineReminder` field. */
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `includeCustomEmployeeFields` field. */
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `includeCustomEmployeeFieldsResponsibles` field. */
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `includeDirectManager` field. */
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `includeDirectManagerResponsible` field. */
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `includeEmployee` field. */
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `includeEmployeeResponsible` field. */
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `includeGroups` field. */
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `includeGroupsResponsibles` field. */
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `notes` field. */
  notes?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `parentTaskId` field. */
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `processId` field. */
  processId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `startDay` field. */
  startDay?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `useCalendarEvent` field. */
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
};

export type TaskTemplateEmployee = {
  __typename?: 'TaskTemplateEmployee';
  /** Reads a single `Company` that is related to this `TaskTemplateEmployee`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Employee` that is related to this `TaskTemplateEmployee`. */
  employee?: Maybe<Employee>;
  employeeId: Scalars['UUID'];
  /** Reads a single `TaskTemplate` that is related to this `TaskTemplateEmployee`. */
  taskTemplate?: Maybe<TaskTemplate>;
  taskTemplateId: Scalars['UUID'];
};

/** The `taskTemplateEmployee` to be created by this mutation. */
export type TaskTemplateEmployeeCompanyIdFkeyConnectionTaskTemplateEmployeeCreateInput = {
  company?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `TaskTemplateEmployeeInput` mutation. */
export type TaskTemplateEmployeeCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnTaskTemplateEmployeeForTaskTemplateEmployeeCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `taskTemplateEmployee` in the `CompanyInput` mutation. */
export type TaskTemplateEmployeeCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `taskTemplateEmployee` for the far side of the relationship. */
  connectByTaskTemplateIdAndEmployeeId?: InputMaybe<Array<TaskTemplateEmployeeTaskTemplateEmployeePkeyConnect>>;
  /** A `TaskTemplateEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskTemplateEmployeeCompanyIdFkeyConnectionTaskTemplateEmployeeCreateInput>>;
  /** The primary key(s) for `taskTemplateEmployee` for the far side of the relationship. */
  deleteByTaskTemplateIdAndEmployeeId?: InputMaybe<Array<TaskTemplateEmployeeTaskTemplateEmployeePkeyDelete>>;
  /** Flag indicating whether all other `taskTemplateEmployee` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `taskTemplateEmployee` for the far side of the relationship. */
  updateByTaskTemplateIdAndEmployeeId?: InputMaybe<Array<TaskTemplateEmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeCompanyIdFkeyUsingTaskTemplateEmployeePkeyUpdate>>;
};

/**
 * A condition to be used against `TaskTemplateEmployee` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type TaskTemplateEmployeeCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `taskTemplateId` field. */
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** The `taskTemplateEmployee` to be created by this mutation. */
export type TaskTemplateEmployeeEmployeeIdForeignConnectionTaskTemplateEmployeeCreateInput = {
  company?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInput>;
  taskTemplate?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `employee` in the `TaskTemplateEmployeeInput` mutation. */
export type TaskTemplateEmployeeEmployeeIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeEmployeeIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeEmployeeIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `taskTemplateEmployee` in the `EmployeeInput` mutation. */
export type TaskTemplateEmployeeEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `taskTemplateEmployee` for the far side of the relationship. */
  connectByTaskTemplateIdAndEmployeeId?: InputMaybe<Array<TaskTemplateEmployeeTaskTemplateEmployeePkeyConnect>>;
  /** A `TaskTemplateEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskTemplateEmployeeEmployeeIdForeignConnectionTaskTemplateEmployeeCreateInput>>;
  /** The primary key(s) for `taskTemplateEmployee` for the far side of the relationship. */
  deleteByTaskTemplateIdAndEmployeeId?: InputMaybe<Array<TaskTemplateEmployeeTaskTemplateEmployeePkeyDelete>>;
  /** Flag indicating whether all other `taskTemplateEmployee` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `taskTemplateEmployee` for the far side of the relationship. */
  updateByTaskTemplateIdAndEmployeeId?: InputMaybe<Array<TaskTemplateEmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeEmployeeIdForeignUsingTaskTemplateEmployeePkeyUpdate>>;
};

/** A filter to be used against `TaskTemplateEmployee` object types. All fields are combined with a logical ‘and.’ */
export type TaskTemplateEmployeeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TaskTemplateEmployeeFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TaskTemplateEmployeeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TaskTemplateEmployeeFilter>>;
  /** Filter by the object’s `taskTemplate` relation. */
  taskTemplate?: InputMaybe<TaskTemplateFilter>;
  /** Filter by the object’s `taskTemplateId` field. */
  taskTemplateId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `TaskTemplateEmployee` */
export type TaskTemplateEmployeeInput = {
  company?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `taskTemplateEmployee` to look up the row to update. */
export type TaskTemplateEmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeCompanyIdFkeyUsingTaskTemplateEmployeePkeyUpdate = {
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `taskTemplateEmployee` being updated. */
  patch: UpdateTaskTemplateEmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeCompanyIdFkeyPatch;
  taskTemplateId: Scalars['UUID'];
};

/** The fields on `taskTemplateEmployee` to look up the row to update. */
export type TaskTemplateEmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeEmployeeIdForeignUsingTaskTemplateEmployeePkeyUpdate = {
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `taskTemplateEmployee` being updated. */
  patch: UpdateTaskTemplateEmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeEmployeeIdForeignPatch;
  taskTemplateId: Scalars['UUID'];
};

/** The fields on `taskTemplateEmployee` to look up the row to update. */
export type TaskTemplateEmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeTaskTemplateIdForeignUsingTaskTemplateEmployeePkeyUpdate = {
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `taskTemplateEmployee` being updated. */
  patch: UpdateTaskTemplateEmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeTaskTemplateIdForeignPatch;
  taskTemplateId: Scalars['UUID'];
};

/** Represents an update to a `TaskTemplateEmployee`. Fields that are set will be updated. */
export type TaskTemplateEmployeePatch = {
  company?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `taskTemplateEmployee` to look up the row to connect. */
export type TaskTemplateEmployeeTaskTemplateEmployeePkeyConnect = {
  employeeId: Scalars['UUID'];
  taskTemplateId: Scalars['UUID'];
};

/** The fields on `taskTemplateEmployee` to look up the row to delete. */
export type TaskTemplateEmployeeTaskTemplateEmployeePkeyDelete = {
  employeeId: Scalars['UUID'];
  taskTemplateId: Scalars['UUID'];
};

/** The `taskTemplate` to be created by this mutation. */
export type TaskTemplateEmployeeTaskTemplateIdForeignConnectionTaskTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** The `taskTemplateEmployee` to be created by this mutation. */
export type TaskTemplateEmployeeTaskTemplateIdForeignConnectionTaskTemplateEmployeeCreateInput = {
  company?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInput>;
};

/** Input for the nested mutation of `taskTemplate` in the `TaskTemplateEmployeeInput` mutation. */
export type TaskTemplateEmployeeTaskTemplateIdForeignInput = {
  /** The primary key(s) for `taskTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTemplateTaskTemplatePkeyConnect>;
  /** A `TaskTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignConnectionTaskTemplateCreateInput>;
  /** The primary key(s) and patch data for `taskTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<TaskTemplateOnTaskTemplateEmployeeForTaskTemplateEmployeeTaskTemplateIdForeignUsingTaskTemplatePkeyUpdate>;
};

/** Input for the nested mutation of `taskTemplateEmployee` in the `TaskTemplateInput` mutation. */
export type TaskTemplateEmployeeTaskTemplateIdForeignInverseInput = {
  /** The primary key(s) for `taskTemplateEmployee` for the far side of the relationship. */
  connectByTaskTemplateIdAndEmployeeId?: InputMaybe<Array<TaskTemplateEmployeeTaskTemplateEmployeePkeyConnect>>;
  /** A `TaskTemplateEmployeeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskTemplateEmployeeTaskTemplateIdForeignConnectionTaskTemplateEmployeeCreateInput>>;
  /** The primary key(s) for `taskTemplateEmployee` for the far side of the relationship. */
  deleteByTaskTemplateIdAndEmployeeId?: InputMaybe<Array<TaskTemplateEmployeeTaskTemplateEmployeePkeyDelete>>;
  /** Flag indicating whether all other `taskTemplateEmployee` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `taskTemplateEmployee` for the far side of the relationship. */
  updateByTaskTemplateIdAndEmployeeId?: InputMaybe<Array<TaskTemplateEmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeTaskTemplateIdForeignUsingTaskTemplateEmployeePkeyUpdate>>;
};

/** A connection to a list of `TaskTemplateEmployee` values. */
export type TaskTemplateEmployeesConnection = {
  __typename?: 'TaskTemplateEmployeesConnection';
  /** A list of edges which contains the `TaskTemplateEmployee` and cursor to aid in pagination. */
  edges: Array<TaskTemplateEmployeesEdge>;
  /** A list of `TaskTemplateEmployee` objects. */
  nodes: Array<Maybe<TaskTemplateEmployee>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TaskTemplateEmployee` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TaskTemplateEmployee` edge in the connection. */
export type TaskTemplateEmployeesEdge = {
  __typename?: 'TaskTemplateEmployeesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TaskTemplateEmployee` at the end of the edge. */
  node?: Maybe<TaskTemplateEmployee>;
};

/** Methods to use when ordering `TaskTemplateEmployee`. */
export type TaskTemplateEmployeesOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__ACTIVE_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__ACTIVE_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CALENDAR_EVENT_FROM_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CALENDAR_EVENT_FROM_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CALENDAR_EVENT_ORGANIZER_ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CALENDAR_EVENT_ORGANIZER_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CALENDAR_EVENT_TO_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CALENDAR_EVENT_TO_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__COMPANY_ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__COMPANY_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CREATED_AT_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CREATED_AT_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__DEADLINE_REMINDER_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__DEADLINE_REMINDER_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__DEPARTMENTS_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__DEPARTMENTS_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__DURATION_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__DURATION_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_RESPONSIBLES_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_RESPONSIBLES_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_DIRECT_MANAGER_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_DIRECT_MANAGER_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_DIRECT_MANAGER_RESPONSIBLE_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_DIRECT_MANAGER_RESPONSIBLE_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_EMPLOYEE_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_EMPLOYEE_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_EMPLOYEE_RESPONSIBLE_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_EMPLOYEE_RESPONSIBLE_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_GROUPS_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_GROUPS_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_GROUPS_RESPONSIBLES_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_GROUPS_RESPONSIBLES_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__NAME_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__NAME_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__NOTES_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__NOTES_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__ORDER_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__ORDER_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PARENT_TASK_ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PARENT_TASK_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PROCESS_ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PROCESS_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PROCESS_TYPE_ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PROCESS_TYPE_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PROJECT_ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PROJECT_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__START_DAY_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__START_DAY_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__UPDATED_AT_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__UPDATED_AT_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__USE_CALENDAR_EVENT_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__USE_CALENDAR_EVENT_DESC'
  | 'TASK_TEMPLATE_ID_ASC'
  | 'TASK_TEMPLATE_ID_DESC';

/** A filter to be used against `TaskTemplate` object types. All fields are combined with a logical ‘and.’ */
export type TaskTemplateFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TaskTemplateFilter>>;
  /** Filter by the object’s `calendarEventFrom` field. */
  calendarEventFrom?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `calendarEventOrganizer` relation. */
  calendarEventOrganizer?: InputMaybe<UserFilter>;
  /** A related `calendarEventOrganizer` exists. */
  calendarEventOrganizerExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `calendarEventOrganizerId` field. */
  calendarEventOrganizerId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `calendarEventTo` field. */
  calendarEventTo?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deadlineReminder` field. */
  deadlineReminder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `includeCustomEmployeeFields` field. */
  includeCustomEmployeeFields?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `includeCustomEmployeeFieldsResponsibles` field. */
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `includeDirectManager` field. */
  includeDirectManager?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `includeDirectManagerResponsible` field. */
  includeDirectManagerResponsible?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `includeEmployee` field. */
  includeEmployee?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `includeEmployeeResponsible` field. */
  includeEmployeeResponsible?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `includeGroups` field. */
  includeGroups?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `includeGroupsResponsibles` field. */
  includeGroupsResponsibles?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TaskTemplateFilter>;
  /** Filter by the object’s `notes` field. */
  notes?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notificationEmployeeReferences` relation. */
  notificationEmployeeReferences?: InputMaybe<TaskTemplateToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferences` exist. */
  notificationEmployeeReferencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TaskTemplateFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `parentTask` relation. */
  parentTask?: InputMaybe<TaskTemplateFilter>;
  /** A related `parentTask` exists. */
  parentTaskExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `parentTaskId` field. */
  parentTaskId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `process` relation. */
  process?: InputMaybe<ProcessFilter>;
  /** A related `process` exists. */
  processExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processId` field. */
  processId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `processType` relation. */
  processType?: InputMaybe<ProcessTypeFilter>;
  /** A related `processType` exists. */
  processTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processTypeId` field. */
  processTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `project` relation. */
  project?: InputMaybe<ProjectTemplateFilter>;
  /** A related `project` exists. */
  projectExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `startDay` field. */
  startDay?: InputMaybe<IntFilter>;
  /** Filter by the object’s `taskTemplateEmployees` relation. */
  taskTemplateEmployees?: InputMaybe<TaskTemplateToManyTaskTemplateEmployeeFilter>;
  /** Some related `taskTemplateEmployees` exist. */
  taskTemplateEmployeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskTemplateResponsibles` relation. */
  taskTemplateResponsibles?: InputMaybe<TaskTemplateToManyTaskTemplateResponsibleFilter>;
  /** Some related `taskTemplateResponsibles` exist. */
  taskTemplateResponsiblesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskTemplatesByParentTaskId` relation. */
  taskTemplatesByParentTaskId?: InputMaybe<TaskTemplateToManyTaskTemplateFilter>;
  /** Some related `taskTemplatesByParentTaskId` exist. */
  taskTemplatesByParentTaskIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `useCalendarEvent` field. */
  useCalendarEvent?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `TaskTemplate` */
export type TaskTemplateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** The fields on `taskTemplate` to look up the row to update. */
export type TaskTemplateOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTaskTemplateIdForeignUsingTaskTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `taskTemplate` being updated. */
  patch: UpdateTaskTemplateOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTaskTemplateIdForeignPatch;
};

/** The fields on `taskTemplate` to look up the row to update. */
export type TaskTemplateOnTaskTemplateEmployeeForTaskTemplateEmployeeTaskTemplateIdForeignUsingTaskTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `taskTemplate` being updated. */
  patch: UpdateTaskTemplateOnTaskTemplateEmployeeForTaskTemplateEmployeeTaskTemplateIdForeignPatch;
};

/** The fields on `taskTemplate` to look up the row to update. */
export type TaskTemplateOnTaskTemplateForTaskTemplateCalendarEventOrganizerIdForeignUsingTaskTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `taskTemplate` being updated. */
  patch: UpdateTaskTemplateOnTaskTemplateForTaskTemplateCalendarEventOrganizerIdForeignPatch;
};

/** The fields on `taskTemplate` to look up the row to update. */
export type TaskTemplateOnTaskTemplateForTaskTemplateCompanyIdFkeyUsingTaskTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `taskTemplate` being updated. */
  patch: UpdateTaskTemplateOnTaskTemplateForTaskTemplateCompanyIdFkeyPatch;
};

/** The fields on `taskTemplate` to look up the row to update. */
export type TaskTemplateOnTaskTemplateForTaskTemplateParentTaskIdForeignUsingTaskTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `taskTemplate` being updated. */
  patch: UpdateTaskTemplateOnTaskTemplateForTaskTemplateParentTaskIdForeignPatch;
};

/** The fields on `taskTemplate` to look up the row to update. */
export type TaskTemplateOnTaskTemplateForTaskTemplateProcessIdForeignUsingTaskTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `taskTemplate` being updated. */
  patch: UpdateTaskTemplateOnTaskTemplateForTaskTemplateProcessIdForeignPatch;
};

/** The fields on `taskTemplate` to look up the row to update. */
export type TaskTemplateOnTaskTemplateForTaskTemplateProcessTypeIdForeignUsingTaskTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `taskTemplate` being updated. */
  patch: UpdateTaskTemplateOnTaskTemplateForTaskTemplateProcessTypeIdForeignPatch;
};

/** The fields on `taskTemplate` to look up the row to update. */
export type TaskTemplateOnTaskTemplateForTaskTemplateProjectIdForeignUsingTaskTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `taskTemplate` being updated. */
  patch: UpdateTaskTemplateOnTaskTemplateForTaskTemplateProjectIdForeignPatch;
};

/** The fields on `taskTemplate` to look up the row to update. */
export type TaskTemplateOnTaskTemplateResponsibleForTaskTemplateResponsibleTaskTemplateIdForeignUsingTaskTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `taskTemplate` being updated. */
  patch: UpdateTaskTemplateOnTaskTemplateResponsibleForTaskTemplateResponsibleTaskTemplateIdForeignPatch;
};

/** The `taskTemplate` to be created by this mutation. */
export type TaskTemplateParentTaskIdForeignConnectionTaskTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** Input for the nested mutation of `taskTemplate` in the `TaskTemplateInput` mutation. */
export type TaskTemplateParentTaskIdForeignInput = {
  /** The primary key(s) for `taskTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTemplateTaskTemplatePkeyConnect>;
  /** A `TaskTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskTemplateParentTaskIdForeignConnectionTaskTemplateCreateInput>;
  /** The primary key(s) and patch data for `taskTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<TaskTemplateOnTaskTemplateForTaskTemplateParentTaskIdForeignUsingTaskTemplatePkeyUpdate>;
};

/** Represents an update to a `TaskTemplate`. Fields that are set will be updated. */
export type TaskTemplatePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** The `process` to be created by this mutation. */
export type TaskTemplateProcessIdForeignConnectionProcessCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The `taskTemplate` to be created by this mutation. */
export type TaskTemplateProcessIdForeignConnectionTaskTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** Input for the nested mutation of `process` in the `TaskTemplateInput` mutation. */
export type TaskTemplateProcessIdForeignInput = {
  /** The primary key(s) for `process` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessProcessPkeyConnect>;
  /** A `ProcessInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskTemplateProcessIdForeignConnectionProcessCreateInput>;
  /** The primary key(s) and patch data for `process` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessOnTaskTemplateForTaskTemplateProcessIdForeignUsingProcessPkeyUpdate>;
};

/** Input for the nested mutation of `taskTemplate` in the `ProcessInput` mutation. */
export type TaskTemplateProcessIdForeignInverseInput = {
  /** The primary key(s) for `taskTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTemplateTaskTemplatePkeyConnect>>;
  /** A `TaskTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskTemplateProcessIdForeignConnectionTaskTemplateCreateInput>>;
  /** The primary key(s) and patch data for `taskTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskTemplateOnTaskTemplateForTaskTemplateProcessIdForeignUsingTaskTemplatePkeyUpdate>>;
};

/** The `processType` to be created by this mutation. */
export type TaskTemplateProcessTypeIdForeignConnectionProcessTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The `taskTemplate` to be created by this mutation. */
export type TaskTemplateProcessTypeIdForeignConnectionTaskTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** Input for the nested mutation of `processType` in the `TaskTemplateInput` mutation. */
export type TaskTemplateProcessTypeIdForeignInput = {
  /** The primary key(s) for `processType` for the far side of the relationship. */
  connectById?: InputMaybe<ProcessTypeProcessTypePkeyConnect>;
  /** A `ProcessTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskTemplateProcessTypeIdForeignConnectionProcessTypeCreateInput>;
  /** The primary key(s) and patch data for `processType` for the far side of the relationship. */
  updateById?: InputMaybe<ProcessTypeOnTaskTemplateForTaskTemplateProcessTypeIdForeignUsingProcessTypePkeyUpdate>;
};

/** Input for the nested mutation of `taskTemplate` in the `ProcessTypeInput` mutation. */
export type TaskTemplateProcessTypeIdForeignInverseInput = {
  /** The primary key(s) for `taskTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTemplateTaskTemplatePkeyConnect>>;
  /** A `TaskTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskTemplateProcessTypeIdForeignConnectionTaskTemplateCreateInput>>;
  /** The primary key(s) and patch data for `taskTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskTemplateOnTaskTemplateForTaskTemplateProcessTypeIdForeignUsingTaskTemplatePkeyUpdate>>;
};

/** The `projectTemplate` to be created by this mutation. */
export type TaskTemplateProjectIdForeignConnectionProjectTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProjectIdForeignInverseInput>;
};

/** The `taskTemplate` to be created by this mutation. */
export type TaskTemplateProjectIdForeignConnectionTaskTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** Input for the nested mutation of `projectTemplate` in the `TaskTemplateInput` mutation. */
export type TaskTemplateProjectIdForeignInput = {
  /** The primary key(s) for `projectTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectTemplateProjectTemplatePkeyConnect>;
  /** A `ProjectTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskTemplateProjectIdForeignConnectionProjectTemplateCreateInput>;
  /** The primary key(s) and patch data for `projectTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectTemplateOnTaskTemplateForTaskTemplateProjectIdForeignUsingProjectTemplatePkeyUpdate>;
};

/** Input for the nested mutation of `taskTemplate` in the `ProjectTemplateInput` mutation. */
export type TaskTemplateProjectIdForeignInverseInput = {
  /** The primary key(s) for `taskTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTemplateTaskTemplatePkeyConnect>>;
  /** A `TaskTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskTemplateProjectIdForeignConnectionTaskTemplateCreateInput>>;
  /** The primary key(s) and patch data for `taskTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TaskTemplateOnTaskTemplateForTaskTemplateProjectIdForeignUsingTaskTemplatePkeyUpdate>>;
};

export type TaskTemplateResponsible = {
  __typename?: 'TaskTemplateResponsible';
  /** Reads a single `Company` that is related to this `TaskTemplateResponsible`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Employee` that is related to this `TaskTemplateResponsible`. */
  responsible?: Maybe<Employee>;
  responsibleId: Scalars['UUID'];
  /** Reads a single `TaskTemplate` that is related to this `TaskTemplateResponsible`. */
  taskTemplate?: Maybe<TaskTemplate>;
  taskTemplateId: Scalars['UUID'];
};

/** The `taskTemplateResponsible` to be created by this mutation. */
export type TaskTemplateResponsibleCompanyIdFkeyConnectionTaskTemplateResponsibleCreateInput = {
  company?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInput>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `TaskTemplateResponsibleInput` mutation. */
export type TaskTemplateResponsibleCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnTaskTemplateResponsibleForTaskTemplateResponsibleCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `taskTemplateResponsible` in the `CompanyInput` mutation. */
export type TaskTemplateResponsibleCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `taskTemplateResponsible` for the far side of the relationship. */
  connectByTaskTemplateIdAndResponsibleId?: InputMaybe<Array<TaskTemplateResponsibleTaskTemplateResponsiblePkeyConnect>>;
  /** A `TaskTemplateResponsibleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskTemplateResponsibleCompanyIdFkeyConnectionTaskTemplateResponsibleCreateInput>>;
  /** The primary key(s) for `taskTemplateResponsible` for the far side of the relationship. */
  deleteByTaskTemplateIdAndResponsibleId?: InputMaybe<Array<TaskTemplateResponsibleTaskTemplateResponsiblePkeyDelete>>;
  /** Flag indicating whether all other `taskTemplateResponsible` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `taskTemplateResponsible` for the far side of the relationship. */
  updateByTaskTemplateIdAndResponsibleId?: InputMaybe<Array<TaskTemplateResponsibleOnTaskTemplateResponsibleForTaskTemplateResponsibleCompanyIdFkeyUsingTaskTemplateResponsiblePkeyUpdate>>;
};

/**
 * A condition to be used against `TaskTemplateResponsible` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type TaskTemplateResponsibleCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `responsibleId` field. */
  responsibleId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `taskTemplateId` field. */
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `TaskTemplateResponsible` object types. All fields are combined with a logical ‘and.’ */
export type TaskTemplateResponsibleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TaskTemplateResponsibleFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TaskTemplateResponsibleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TaskTemplateResponsibleFilter>>;
  /** Filter by the object’s `responsible` relation. */
  responsible?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `responsibleId` field. */
  responsibleId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `taskTemplate` relation. */
  taskTemplate?: InputMaybe<TaskTemplateFilter>;
  /** Filter by the object’s `taskTemplateId` field. */
  taskTemplateId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `TaskTemplateResponsible` */
export type TaskTemplateResponsibleInput = {
  company?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInput>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `taskTemplateResponsible` to look up the row to update. */
export type TaskTemplateResponsibleOnTaskTemplateResponsibleForTaskTemplateResponsibleCompanyIdFkeyUsingTaskTemplateResponsiblePkeyUpdate = {
  /** An object where the defined keys will be set on the `taskTemplateResponsible` being updated. */
  patch: UpdateTaskTemplateResponsibleOnTaskTemplateResponsibleForTaskTemplateResponsibleCompanyIdFkeyPatch;
  responsibleId: Scalars['UUID'];
  taskTemplateId: Scalars['UUID'];
};

/** The fields on `taskTemplateResponsible` to look up the row to update. */
export type TaskTemplateResponsibleOnTaskTemplateResponsibleForTaskTemplateResponsibleResponsibleIdForeignUsingTaskTemplateResponsiblePkeyUpdate = {
  /** An object where the defined keys will be set on the `taskTemplateResponsible` being updated. */
  patch: UpdateTaskTemplateResponsibleOnTaskTemplateResponsibleForTaskTemplateResponsibleResponsibleIdForeignPatch;
  responsibleId: Scalars['UUID'];
  taskTemplateId: Scalars['UUID'];
};

/** The fields on `taskTemplateResponsible` to look up the row to update. */
export type TaskTemplateResponsibleOnTaskTemplateResponsibleForTaskTemplateResponsibleTaskTemplateIdForeignUsingTaskTemplateResponsiblePkeyUpdate = {
  /** An object where the defined keys will be set on the `taskTemplateResponsible` being updated. */
  patch: UpdateTaskTemplateResponsibleOnTaskTemplateResponsibleForTaskTemplateResponsibleTaskTemplateIdForeignPatch;
  responsibleId: Scalars['UUID'];
  taskTemplateId: Scalars['UUID'];
};

/** Represents an update to a `TaskTemplateResponsible`. Fields that are set will be updated. */
export type TaskTemplateResponsiblePatch = {
  company?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInput>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** The `taskTemplateResponsible` to be created by this mutation. */
export type TaskTemplateResponsibleResponsibleIdForeignConnectionTaskTemplateResponsibleCreateInput = {
  company?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInput>;
  taskTemplate?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `employee` in the `TaskTemplateResponsibleInput` mutation. */
export type TaskTemplateResponsibleResponsibleIdForeignInput = {
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectById?: InputMaybe<EmployeeEmployeePkeyConnect>;
  /** The primary key(s) for `employee` for the far side of the relationship. */
  connectByUserId?: InputMaybe<EmployeeEmployeeUserIdUniqueConnect>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateById?: InputMaybe<EmployeeOnTaskTemplateResponsibleForTaskTemplateResponsibleResponsibleIdForeignUsingEmployeePkeyUpdate>;
  /** The primary key(s) and patch data for `employee` for the far side of the relationship. */
  updateByUserId?: InputMaybe<EmployeeOnTaskTemplateResponsibleForTaskTemplateResponsibleResponsibleIdForeignUsingEmployeeUserIdUniqueUpdate>;
};

/** Input for the nested mutation of `taskTemplateResponsible` in the `EmployeeInput` mutation. */
export type TaskTemplateResponsibleResponsibleIdForeignInverseInput = {
  /** The primary key(s) for `taskTemplateResponsible` for the far side of the relationship. */
  connectByTaskTemplateIdAndResponsibleId?: InputMaybe<Array<TaskTemplateResponsibleTaskTemplateResponsiblePkeyConnect>>;
  /** A `TaskTemplateResponsibleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskTemplateResponsibleResponsibleIdForeignConnectionTaskTemplateResponsibleCreateInput>>;
  /** The primary key(s) for `taskTemplateResponsible` for the far side of the relationship. */
  deleteByTaskTemplateIdAndResponsibleId?: InputMaybe<Array<TaskTemplateResponsibleTaskTemplateResponsiblePkeyDelete>>;
  /** Flag indicating whether all other `taskTemplateResponsible` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `taskTemplateResponsible` for the far side of the relationship. */
  updateByTaskTemplateIdAndResponsibleId?: InputMaybe<Array<TaskTemplateResponsibleOnTaskTemplateResponsibleForTaskTemplateResponsibleResponsibleIdForeignUsingTaskTemplateResponsiblePkeyUpdate>>;
};

/** The `taskTemplate` to be created by this mutation. */
export type TaskTemplateResponsibleTaskTemplateIdForeignConnectionTaskTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** The `taskTemplateResponsible` to be created by this mutation. */
export type TaskTemplateResponsibleTaskTemplateIdForeignConnectionTaskTemplateResponsibleCreateInput = {
  company?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInput>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInput>;
};

/** Input for the nested mutation of `taskTemplate` in the `TaskTemplateResponsibleInput` mutation. */
export type TaskTemplateResponsibleTaskTemplateIdForeignInput = {
  /** The primary key(s) for `taskTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTemplateTaskTemplatePkeyConnect>;
  /** A `TaskTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignConnectionTaskTemplateCreateInput>;
  /** The primary key(s) and patch data for `taskTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<TaskTemplateOnTaskTemplateResponsibleForTaskTemplateResponsibleTaskTemplateIdForeignUsingTaskTemplatePkeyUpdate>;
};

/** Input for the nested mutation of `taskTemplateResponsible` in the `TaskTemplateInput` mutation. */
export type TaskTemplateResponsibleTaskTemplateIdForeignInverseInput = {
  /** The primary key(s) for `taskTemplateResponsible` for the far side of the relationship. */
  connectByTaskTemplateIdAndResponsibleId?: InputMaybe<Array<TaskTemplateResponsibleTaskTemplateResponsiblePkeyConnect>>;
  /** A `TaskTemplateResponsibleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskTemplateResponsibleTaskTemplateIdForeignConnectionTaskTemplateResponsibleCreateInput>>;
  /** The primary key(s) for `taskTemplateResponsible` for the far side of the relationship. */
  deleteByTaskTemplateIdAndResponsibleId?: InputMaybe<Array<TaskTemplateResponsibleTaskTemplateResponsiblePkeyDelete>>;
  /** Flag indicating whether all other `taskTemplateResponsible` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `taskTemplateResponsible` for the far side of the relationship. */
  updateByTaskTemplateIdAndResponsibleId?: InputMaybe<Array<TaskTemplateResponsibleOnTaskTemplateResponsibleForTaskTemplateResponsibleTaskTemplateIdForeignUsingTaskTemplateResponsiblePkeyUpdate>>;
};

/** The fields on `taskTemplateResponsible` to look up the row to connect. */
export type TaskTemplateResponsibleTaskTemplateResponsiblePkeyConnect = {
  responsibleId: Scalars['UUID'];
  taskTemplateId: Scalars['UUID'];
};

/** The fields on `taskTemplateResponsible` to look up the row to delete. */
export type TaskTemplateResponsibleTaskTemplateResponsiblePkeyDelete = {
  responsibleId: Scalars['UUID'];
  taskTemplateId: Scalars['UUID'];
};

/** A connection to a list of `TaskTemplateResponsible` values. */
export type TaskTemplateResponsiblesConnection = {
  __typename?: 'TaskTemplateResponsiblesConnection';
  /** A list of edges which contains the `TaskTemplateResponsible` and cursor to aid in pagination. */
  edges: Array<TaskTemplateResponsiblesEdge>;
  /** A list of `TaskTemplateResponsible` objects. */
  nodes: Array<Maybe<TaskTemplateResponsible>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TaskTemplateResponsible` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TaskTemplateResponsible` edge in the connection. */
export type TaskTemplateResponsiblesEdge = {
  __typename?: 'TaskTemplateResponsiblesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TaskTemplateResponsible` at the end of the edge. */
  node?: Maybe<TaskTemplateResponsible>;
};

/** Methods to use when ordering `TaskTemplateResponsible`. */
export type TaskTemplateResponsiblesOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__ID_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__ID_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_RESPONSIBLE_ID__USER_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RESPONSIBLE_ID_ASC'
  | 'RESPONSIBLE_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__ACTIVE_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__ACTIVE_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CALENDAR_EVENT_FROM_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CALENDAR_EVENT_FROM_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CALENDAR_EVENT_ORGANIZER_ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CALENDAR_EVENT_ORGANIZER_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CALENDAR_EVENT_TO_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CALENDAR_EVENT_TO_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__COMPANY_ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__COMPANY_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CREATED_AT_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__CREATED_AT_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__DEADLINE_REMINDER_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__DEADLINE_REMINDER_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__DEPARTMENTS_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__DEPARTMENTS_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__DURATION_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__DURATION_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_RESPONSIBLES_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_RESPONSIBLES_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_DIRECT_MANAGER_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_DIRECT_MANAGER_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_DIRECT_MANAGER_RESPONSIBLE_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_DIRECT_MANAGER_RESPONSIBLE_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_EMPLOYEE_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_EMPLOYEE_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_EMPLOYEE_RESPONSIBLE_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_EMPLOYEE_RESPONSIBLE_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_GROUPS_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_GROUPS_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_GROUPS_RESPONSIBLES_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__INCLUDE_GROUPS_RESPONSIBLES_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__NAME_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__NAME_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__NOTES_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__NOTES_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__ORDER_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__ORDER_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PARENT_TASK_ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PARENT_TASK_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PROCESS_ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PROCESS_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PROCESS_TYPE_ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PROCESS_TYPE_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PROJECT_ID_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__PROJECT_ID_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__START_DAY_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__START_DAY_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__UPDATED_AT_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__UPDATED_AT_DESC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__USE_CALENDAR_EVENT_ASC'
  | 'TASK_TEMPLATE_BY_TASK_TEMPLATE_ID__USE_CALENDAR_EVENT_DESC'
  | 'TASK_TEMPLATE_ID_ASC'
  | 'TASK_TEMPLATE_ID_DESC';

/** The fields on `taskTemplate` to look up the row to connect. */
export type TaskTemplateTaskTemplatePkeyConnect = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type TaskTemplateToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

/** A filter to be used against many `TaskTemplateEmployee` object types. All fields are combined with a logical ‘and.’ */
export type TaskTemplateToManyTaskTemplateEmployeeFilter = {
  /** Every related `TaskTemplateEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskTemplateEmployeeFilter>;
  /** No related `TaskTemplateEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskTemplateEmployeeFilter>;
  /** Some related `TaskTemplateEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskTemplateEmployeeFilter>;
};

/** A filter to be used against many `TaskTemplate` object types. All fields are combined with a logical ‘and.’ */
export type TaskTemplateToManyTaskTemplateFilter = {
  /** Every related `TaskTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskTemplateFilter>;
  /** No related `TaskTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskTemplateFilter>;
  /** Some related `TaskTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskTemplateFilter>;
};

/** A filter to be used against many `TaskTemplateResponsible` object types. All fields are combined with a logical ‘and.’ */
export type TaskTemplateToManyTaskTemplateResponsibleFilter = {
  /** Every related `TaskTemplateResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskTemplateResponsibleFilter>;
  /** No related `TaskTemplateResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskTemplateResponsibleFilter>;
  /** Some related `TaskTemplateResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskTemplateResponsibleFilter>;
};

/** A connection to a list of `TaskTemplate` values. */
export type TaskTemplatesConnection = {
  __typename?: 'TaskTemplatesConnection';
  /** A list of edges which contains the `TaskTemplate` and cursor to aid in pagination. */
  edges: Array<TaskTemplatesEdge>;
  /** A list of `TaskTemplate` objects. */
  nodes: Array<Maybe<TaskTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TaskTemplate` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TaskTemplate` edge in the connection. */
export type TaskTemplatesEdge = {
  __typename?: 'TaskTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TaskTemplate` at the end of the edge. */
  node?: Maybe<TaskTemplate>;
};

/** Methods to use when ordering `TaskTemplate`. */
export type TaskTemplatesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'CALENDAR_EVENT_FROM_ASC'
  | 'CALENDAR_EVENT_FROM_DESC'
  | 'CALENDAR_EVENT_ORGANIZER_ID_ASC'
  | 'CALENDAR_EVENT_ORGANIZER_ID_DESC'
  | 'CALENDAR_EVENT_TO_ASC'
  | 'CALENDAR_EVENT_TO_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DEADLINE_REMINDER_ASC'
  | 'DEADLINE_REMINDER_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'DURATION_ASC'
  | 'DURATION_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INCLUDE_CUSTOM_EMPLOYEE_FIELDS_ASC'
  | 'INCLUDE_CUSTOM_EMPLOYEE_FIELDS_DESC'
  | 'INCLUDE_CUSTOM_EMPLOYEE_FIELDS_RESPONSIBLES_ASC'
  | 'INCLUDE_CUSTOM_EMPLOYEE_FIELDS_RESPONSIBLES_DESC'
  | 'INCLUDE_DIRECT_MANAGER_ASC'
  | 'INCLUDE_DIRECT_MANAGER_DESC'
  | 'INCLUDE_DIRECT_MANAGER_RESPONSIBLE_ASC'
  | 'INCLUDE_DIRECT_MANAGER_RESPONSIBLE_DESC'
  | 'INCLUDE_EMPLOYEE_ASC'
  | 'INCLUDE_EMPLOYEE_DESC'
  | 'INCLUDE_EMPLOYEE_RESPONSIBLE_ASC'
  | 'INCLUDE_EMPLOYEE_RESPONSIBLE_DESC'
  | 'INCLUDE_GROUPS_ASC'
  | 'INCLUDE_GROUPS_DESC'
  | 'INCLUDE_GROUPS_RESPONSIBLES_ASC'
  | 'INCLUDE_GROUPS_RESPONSIBLES_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'NOTES_ASC'
  | 'NOTES_DESC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_TASK_TEMPLATE_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_TASK_TEMPLATE_ID__COUNT_DESC'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PARENT_TASK_ID_ASC'
  | 'PARENT_TASK_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_ASC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_DESC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_ASC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_DESC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_DESC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__NAME_ASC'
  | 'PROCESS_BY_PROCESS_ID__NAME_DESC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_ASC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_DESC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_DESC'
  | 'PROCESS_ID_ASC'
  | 'PROCESS_ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_DESC'
  | 'PROCESS_TYPE_ID_ASC'
  | 'PROCESS_TYPE_ID_DESC'
  | 'PROJECT_ID_ASC'
  | 'PROJECT_ID_DESC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__ACTIVE_ASC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__ACTIVE_DESC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__COMPANY_ID_ASC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__COMPANY_ID_DESC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__DEPARTMENTS_ASC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__DEPARTMENTS_DESC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__ID_ASC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__ID_DESC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__NAME_ASC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__NAME_DESC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__ORDER_ASC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__ORDER_DESC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__PROCESS_ID_ASC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__PROCESS_ID_DESC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__PROCESS_TYPE_ID_ASC'
  | 'PROJECT_TEMPLATE_BY_PROJECT_ID__PROCESS_TYPE_ID_DESC'
  | 'START_DAY_ASC'
  | 'START_DAY_DESC'
  | 'TASK_TEMPLATES_BY_PARENT_TASK_ID__COUNT_ASC'
  | 'TASK_TEMPLATES_BY_PARENT_TASK_ID__COUNT_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__ACTIVE_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__ACTIVE_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__CALENDAR_EVENT_FROM_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__CALENDAR_EVENT_FROM_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__CALENDAR_EVENT_ORGANIZER_ID_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__CALENDAR_EVENT_ORGANIZER_ID_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__CALENDAR_EVENT_TO_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__CALENDAR_EVENT_TO_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__COMPANY_ID_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__COMPANY_ID_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__CREATED_AT_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__CREATED_AT_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__DEADLINE_REMINDER_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__DEADLINE_REMINDER_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__DEPARTMENTS_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__DEPARTMENTS_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__DURATION_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__DURATION_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__ID_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__ID_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_RESPONSIBLES_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__INCLUDE_CUSTOM_EMPLOYEE_FIELDS_RESPONSIBLES_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__INCLUDE_DIRECT_MANAGER_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__INCLUDE_DIRECT_MANAGER_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__INCLUDE_DIRECT_MANAGER_RESPONSIBLE_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__INCLUDE_DIRECT_MANAGER_RESPONSIBLE_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__INCLUDE_EMPLOYEE_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__INCLUDE_EMPLOYEE_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__INCLUDE_EMPLOYEE_RESPONSIBLE_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__INCLUDE_EMPLOYEE_RESPONSIBLE_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__INCLUDE_GROUPS_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__INCLUDE_GROUPS_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__INCLUDE_GROUPS_RESPONSIBLES_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__INCLUDE_GROUPS_RESPONSIBLES_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__NAME_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__NAME_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__NOTES_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__NOTES_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__ORDER_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__ORDER_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__PARENT_TASK_ID_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__PARENT_TASK_ID_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__PROCESS_ID_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__PROCESS_ID_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__PROCESS_TYPE_ID_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__PROCESS_TYPE_ID_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__PROJECT_ID_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__PROJECT_ID_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__START_DAY_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__START_DAY_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__UPDATED_AT_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__UPDATED_AT_DESC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__USE_CALENDAR_EVENT_ASC'
  | 'TASK_TEMPLATE_BY_PARENT_TASK_ID__USE_CALENDAR_EVENT_DESC'
  | 'TASK_TEMPLATE_EMPLOYEES_BY_TASK_TEMPLATE_ID__COUNT_ASC'
  | 'TASK_TEMPLATE_EMPLOYEES_BY_TASK_TEMPLATE_ID__COUNT_DESC'
  | 'TASK_TEMPLATE_RESPONSIBLES_BY_TASK_TEMPLATE_ID__COUNT_ASC'
  | 'TASK_TEMPLATE_RESPONSIBLES_BY_TASK_TEMPLATE_ID__COUNT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__ACTIVE_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__ACTIVE_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__ADDRESS_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__ADDRESS_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__BIRTHDATE_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__BIRTHDATE_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CITY_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CITY_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__COMPANY_ID_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__COMPANY_ID_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CPR_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CPR_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__DELETE_AT_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__DELETE_AT_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMAIL_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMAIL_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__FIRST_NAME_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__FIRST_NAME_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__FULL_NAME_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__FULL_NAME_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__GODMODE_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__GODMODE_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__GROUP_IDS_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__GROUP_IDS_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__ID_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__ID_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__INITIALS_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__INITIALS_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__IS_LEADER_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__IS_LEADER_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__LAST_NAME_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__LAST_NAME_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__MOBILE_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__MOBILE_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__PHONE_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__PHONE_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__SENIORITY_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__SENIORITY_DESC'
  | 'USE_CALENDAR_EVENT_ASC'
  | 'USE_CALENDAR_EVENT_DESC';

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type TaskToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

/** A filter to be used against many `TaskEmployee` object types. All fields are combined with a logical ‘and.’ */
export type TaskToManyTaskEmployeeFilter = {
  /** Every related `TaskEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskEmployeeFilter>;
  /** No related `TaskEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskEmployeeFilter>;
  /** Some related `TaskEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskEmployeeFilter>;
};

/** A filter to be used against many `Task` object types. All fields are combined with a logical ‘and.’ */
export type TaskToManyTaskFilter = {
  /** Every related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskFilter>;
  /** No related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskFilter>;
  /** Some related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskFilter>;
};

/** A filter to be used against many `TaskResponsible` object types. All fields are combined with a logical ‘and.’ */
export type TaskToManyTaskResponsibleFilter = {
  /** Every related `TaskResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskResponsibleFilter>;
  /** No related `TaskResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskResponsibleFilter>;
  /** Some related `TaskResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskResponsibleFilter>;
};

/** A connection to a list of `Task` values. */
export type TasksConnection = {
  __typename?: 'TasksConnection';
  /** A list of edges which contains the `Task` and cursor to aid in pagination. */
  edges: Array<TasksEdge>;
  /** A list of `Task` objects. */
  nodes: Array<Maybe<Task>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Task` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Task` edge in the connection. */
export type TasksEdge = {
  __typename?: 'TasksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Task` at the end of the edge. */
  node?: Maybe<Task>;
};

/** Methods to use when ordering `Task`. */
export type TasksOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ARCHIVED_ASC'
  | 'ARCHIVED_DESC'
  | 'ASSIGNED_PROCESS_USER_ID_ASC'
  | 'ASSIGNED_PROCESS_USER_ID_DESC'
  | 'CALENDAR_EVENT_FROM_ASC'
  | 'CALENDAR_EVENT_FROM_DESC'
  | 'CALENDAR_EVENT_ORGANIZER_ID_ASC'
  | 'CALENDAR_EVENT_ORGANIZER_ID_DESC'
  | 'CALENDAR_EVENT_REVISIONS_ASC'
  | 'CALENDAR_EVENT_REVISIONS_DESC'
  | 'CALENDAR_EVENT_TO_ASC'
  | 'CALENDAR_EVENT_TO_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPLETED_ASC'
  | 'COMPLETED_AT_ASC'
  | 'COMPLETED_AT_DESC'
  | 'COMPLETED_BY_ASC'
  | 'COMPLETED_BY_DESC'
  | 'COMPLETED_DESC'
  | 'COMPLETED_REMINDED_ASC'
  | 'COMPLETED_REMINDED_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CREATED_BY_ASC'
  | 'CREATED_BY_DESC'
  | 'DEADLINE_REMINDED_ASC'
  | 'DEADLINE_REMINDED_DESC'
  | 'DEADLINE_REMINDER_DATE_ASC'
  | 'DEADLINE_REMINDER_DATE_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'END_DATE_ASC'
  | 'END_DATE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'NOTES_ASC'
  | 'NOTES_DESC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_TASK_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_TASK_ID__COUNT_DESC'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'PARENT_TASK_ID_ASC'
  | 'PARENT_TASK_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_ASC'
  | 'PROCESS_BY_PROCESS_ID__ACTIVE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_DEPARTMENTS_DESC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ASSIGNED_USER_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_ASC'
  | 'PROCESS_BY_PROCESS_ID__AUTO_ARCHIVED_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPANY_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_ASC'
  | 'PROCESS_BY_PROCESS_ID__COMPLETED_DESC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__CREATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_ASC'
  | 'PROCESS_BY_PROCESS_ID__CUTOFF_DAY_DESC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__DEPARTMENT_IDS_DESC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__EMPLOYEE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__END_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__NAME_ASC'
  | 'PROCESS_BY_PROCESS_ID__NAME_DESC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_ASC'
  | 'PROCESS_BY_PROCESS_ID__ORDER_DESC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_ASC'
  | 'PROCESS_BY_PROCESS_ID__PROCESS_TYPE_ID_DESC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__START_DATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_ASC'
  | 'PROCESS_BY_PROCESS_ID__TEMPLATE_DESC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_ASC'
  | 'PROCESS_BY_PROCESS_ID__UPDATED_AT_DESC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_ASC'
  | 'PROCESS_BY_PROCESS_ID__USER_IDS_DESC'
  | 'PROCESS_ID_ASC'
  | 'PROCESS_ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ACTIVE_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__COMPANY_ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__CREATED_AT_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__ID_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__NAME_DESC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_ASC'
  | 'PROCESS_TYPE_BY_PROCESS_TYPE_ID__UPDATED_AT_DESC'
  | 'PROCESS_TYPE_ID_ASC'
  | 'PROCESS_TYPE_ID_DESC'
  | 'PROJECT_BY_PROJECT_ID__ACTIVE_ASC'
  | 'PROJECT_BY_PROJECT_ID__ACTIVE_DESC'
  | 'PROJECT_BY_PROJECT_ID__ARCHIVED_ASC'
  | 'PROJECT_BY_PROJECT_ID__ARCHIVED_DESC'
  | 'PROJECT_BY_PROJECT_ID__ASSIGNED_PROCESS_USER_ID_ASC'
  | 'PROJECT_BY_PROJECT_ID__ASSIGNED_PROCESS_USER_ID_DESC'
  | 'PROJECT_BY_PROJECT_ID__AUTO_ARCHIVED_ASC'
  | 'PROJECT_BY_PROJECT_ID__AUTO_ARCHIVED_DESC'
  | 'PROJECT_BY_PROJECT_ID__COMPANY_ID_ASC'
  | 'PROJECT_BY_PROJECT_ID__COMPANY_ID_DESC'
  | 'PROJECT_BY_PROJECT_ID__DEPARTMENTS_ASC'
  | 'PROJECT_BY_PROJECT_ID__DEPARTMENTS_DESC'
  | 'PROJECT_BY_PROJECT_ID__EMPLOYEE_ID_ASC'
  | 'PROJECT_BY_PROJECT_ID__EMPLOYEE_ID_DESC'
  | 'PROJECT_BY_PROJECT_ID__ID_ASC'
  | 'PROJECT_BY_PROJECT_ID__ID_DESC'
  | 'PROJECT_BY_PROJECT_ID__NAME_ASC'
  | 'PROJECT_BY_PROJECT_ID__NAME_DESC'
  | 'PROJECT_BY_PROJECT_ID__ORDER_ASC'
  | 'PROJECT_BY_PROJECT_ID__ORDER_DESC'
  | 'PROJECT_BY_PROJECT_ID__PROCESS_ID_ASC'
  | 'PROJECT_BY_PROJECT_ID__PROCESS_ID_DESC'
  | 'PROJECT_BY_PROJECT_ID__PROCESS_TYPE_ID_ASC'
  | 'PROJECT_BY_PROJECT_ID__PROCESS_TYPE_ID_DESC'
  | 'PROJECT_BY_PROJECT_ID__USER_IDS_ASC'
  | 'PROJECT_BY_PROJECT_ID__USER_IDS_DESC'
  | 'PROJECT_ID_ASC'
  | 'PROJECT_ID_DESC'
  | 'START_DATE_ASC'
  | 'START_DATE_DESC'
  | 'START_REMINDED_ASC'
  | 'START_REMINDED_DESC'
  | 'TASKS_BY_PARENT_TASK_ID__COUNT_ASC'
  | 'TASKS_BY_PARENT_TASK_ID__COUNT_DESC'
  | 'TASK_BY_PARENT_TASK_ID__ACTIVE_ASC'
  | 'TASK_BY_PARENT_TASK_ID__ACTIVE_DESC'
  | 'TASK_BY_PARENT_TASK_ID__ARCHIVED_ASC'
  | 'TASK_BY_PARENT_TASK_ID__ARCHIVED_DESC'
  | 'TASK_BY_PARENT_TASK_ID__ASSIGNED_PROCESS_USER_ID_ASC'
  | 'TASK_BY_PARENT_TASK_ID__ASSIGNED_PROCESS_USER_ID_DESC'
  | 'TASK_BY_PARENT_TASK_ID__CALENDAR_EVENT_FROM_ASC'
  | 'TASK_BY_PARENT_TASK_ID__CALENDAR_EVENT_FROM_DESC'
  | 'TASK_BY_PARENT_TASK_ID__CALENDAR_EVENT_ORGANIZER_ID_ASC'
  | 'TASK_BY_PARENT_TASK_ID__CALENDAR_EVENT_ORGANIZER_ID_DESC'
  | 'TASK_BY_PARENT_TASK_ID__CALENDAR_EVENT_REVISIONS_ASC'
  | 'TASK_BY_PARENT_TASK_ID__CALENDAR_EVENT_REVISIONS_DESC'
  | 'TASK_BY_PARENT_TASK_ID__CALENDAR_EVENT_TO_ASC'
  | 'TASK_BY_PARENT_TASK_ID__CALENDAR_EVENT_TO_DESC'
  | 'TASK_BY_PARENT_TASK_ID__COMPANY_ID_ASC'
  | 'TASK_BY_PARENT_TASK_ID__COMPANY_ID_DESC'
  | 'TASK_BY_PARENT_TASK_ID__COMPLETED_ASC'
  | 'TASK_BY_PARENT_TASK_ID__COMPLETED_AT_ASC'
  | 'TASK_BY_PARENT_TASK_ID__COMPLETED_AT_DESC'
  | 'TASK_BY_PARENT_TASK_ID__COMPLETED_BY_ASC'
  | 'TASK_BY_PARENT_TASK_ID__COMPLETED_BY_DESC'
  | 'TASK_BY_PARENT_TASK_ID__COMPLETED_DESC'
  | 'TASK_BY_PARENT_TASK_ID__COMPLETED_REMINDED_ASC'
  | 'TASK_BY_PARENT_TASK_ID__COMPLETED_REMINDED_DESC'
  | 'TASK_BY_PARENT_TASK_ID__CREATED_AT_ASC'
  | 'TASK_BY_PARENT_TASK_ID__CREATED_AT_DESC'
  | 'TASK_BY_PARENT_TASK_ID__CREATED_BY_ASC'
  | 'TASK_BY_PARENT_TASK_ID__CREATED_BY_DESC'
  | 'TASK_BY_PARENT_TASK_ID__DEADLINE_REMINDED_ASC'
  | 'TASK_BY_PARENT_TASK_ID__DEADLINE_REMINDED_DESC'
  | 'TASK_BY_PARENT_TASK_ID__DEADLINE_REMINDER_DATE_ASC'
  | 'TASK_BY_PARENT_TASK_ID__DEADLINE_REMINDER_DATE_DESC'
  | 'TASK_BY_PARENT_TASK_ID__DEPARTMENTS_ASC'
  | 'TASK_BY_PARENT_TASK_ID__DEPARTMENTS_DESC'
  | 'TASK_BY_PARENT_TASK_ID__END_DATE_ASC'
  | 'TASK_BY_PARENT_TASK_ID__END_DATE_DESC'
  | 'TASK_BY_PARENT_TASK_ID__ID_ASC'
  | 'TASK_BY_PARENT_TASK_ID__ID_DESC'
  | 'TASK_BY_PARENT_TASK_ID__NAME_ASC'
  | 'TASK_BY_PARENT_TASK_ID__NAME_DESC'
  | 'TASK_BY_PARENT_TASK_ID__NOTES_ASC'
  | 'TASK_BY_PARENT_TASK_ID__NOTES_DESC'
  | 'TASK_BY_PARENT_TASK_ID__ORDER_ASC'
  | 'TASK_BY_PARENT_TASK_ID__ORDER_DESC'
  | 'TASK_BY_PARENT_TASK_ID__PARENT_TASK_ID_ASC'
  | 'TASK_BY_PARENT_TASK_ID__PARENT_TASK_ID_DESC'
  | 'TASK_BY_PARENT_TASK_ID__PROCESS_ID_ASC'
  | 'TASK_BY_PARENT_TASK_ID__PROCESS_ID_DESC'
  | 'TASK_BY_PARENT_TASK_ID__PROCESS_TYPE_ID_ASC'
  | 'TASK_BY_PARENT_TASK_ID__PROCESS_TYPE_ID_DESC'
  | 'TASK_BY_PARENT_TASK_ID__PROJECT_ID_ASC'
  | 'TASK_BY_PARENT_TASK_ID__PROJECT_ID_DESC'
  | 'TASK_BY_PARENT_TASK_ID__START_DATE_ASC'
  | 'TASK_BY_PARENT_TASK_ID__START_DATE_DESC'
  | 'TASK_BY_PARENT_TASK_ID__START_REMINDED_ASC'
  | 'TASK_BY_PARENT_TASK_ID__START_REMINDED_DESC'
  | 'TASK_BY_PARENT_TASK_ID__UPDATED_AT_ASC'
  | 'TASK_BY_PARENT_TASK_ID__UPDATED_AT_DESC'
  | 'TASK_BY_PARENT_TASK_ID__USER_IDS_ASC'
  | 'TASK_BY_PARENT_TASK_ID__USER_IDS_DESC'
  | 'TASK_EMPLOYEES_BY_TASK_ID__COUNT_ASC'
  | 'TASK_EMPLOYEES_BY_TASK_ID__COUNT_DESC'
  | 'TASK_RESPONSIBLES_BY_TASK_ID__COUNT_ASC'
  | 'TASK_RESPONSIBLES_BY_TASK_ID__COUNT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ACTIVE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ACTIVE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ADDRESS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ADDRESS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CITY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CITY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CPR_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CPR_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GODMODE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GODMODE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ID_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__ID_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__INITIALS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__INITIALS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__PHONE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__PHONE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__SENIORITY_ASC'
  | 'USER_BY_ASSIGNED_PROCESS_USER_ID__SENIORITY_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__ACTIVE_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__ACTIVE_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__ADDRESS_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__ADDRESS_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__BIRTHDATE_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__BIRTHDATE_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CITY_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CITY_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__COMPANY_ID_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__COMPANY_ID_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CPR_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CPR_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__DELETE_AT_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__DELETE_AT_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMAIL_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMAIL_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__FIRST_NAME_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__FIRST_NAME_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__FULL_NAME_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__FULL_NAME_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__GODMODE_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__GODMODE_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__GROUP_IDS_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__GROUP_IDS_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__ID_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__ID_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__INITIALS_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__INITIALS_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__IS_LEADER_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__IS_LEADER_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__LAST_NAME_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__LAST_NAME_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__MOBILE_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__MOBILE_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__PHONE_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__PHONE_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__SENIORITY_ASC'
  | 'USER_BY_CALENDAR_EVENT_ORGANIZER_ID__SENIORITY_DESC'
  | 'USER_BY_COMPLETED_BY__ACTIVE_ASC'
  | 'USER_BY_COMPLETED_BY__ACTIVE_DESC'
  | 'USER_BY_COMPLETED_BY__ADDRESS_ASC'
  | 'USER_BY_COMPLETED_BY__ADDRESS_DESC'
  | 'USER_BY_COMPLETED_BY__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_COMPLETED_BY__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_COMPLETED_BY__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_COMPLETED_BY__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_COMPLETED_BY__BIRTHDATE_ASC'
  | 'USER_BY_COMPLETED_BY__BIRTHDATE_DESC'
  | 'USER_BY_COMPLETED_BY__CAN_LOGIN_APP_ASC'
  | 'USER_BY_COMPLETED_BY__CAN_LOGIN_APP_DESC'
  | 'USER_BY_COMPLETED_BY__CAN_LOGIN_ASC'
  | 'USER_BY_COMPLETED_BY__CAN_LOGIN_DESC'
  | 'USER_BY_COMPLETED_BY__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_COMPLETED_BY__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_COMPLETED_BY__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_COMPLETED_BY__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_COMPLETED_BY__CITY_ASC'
  | 'USER_BY_COMPLETED_BY__CITY_DESC'
  | 'USER_BY_COMPLETED_BY__COMPANY_ADMIN_ASC'
  | 'USER_BY_COMPLETED_BY__COMPANY_ADMIN_DESC'
  | 'USER_BY_COMPLETED_BY__COMPANY_ID_ASC'
  | 'USER_BY_COMPLETED_BY__COMPANY_ID_DESC'
  | 'USER_BY_COMPLETED_BY__CPR_ASC'
  | 'USER_BY_COMPLETED_BY__CPR_DESC'
  | 'USER_BY_COMPLETED_BY__CUSTOM_ID_ASC'
  | 'USER_BY_COMPLETED_BY__CUSTOM_ID_DESC'
  | 'USER_BY_COMPLETED_BY__DELETE_AT_ASC'
  | 'USER_BY_COMPLETED_BY__DELETE_AT_DESC'
  | 'USER_BY_COMPLETED_BY__DELETE_REMINDED_ASC'
  | 'USER_BY_COMPLETED_BY__DELETE_REMINDED_DESC'
  | 'USER_BY_COMPLETED_BY__DEPARTMENTS_ASC'
  | 'USER_BY_COMPLETED_BY__DEPARTMENTS_DESC'
  | 'USER_BY_COMPLETED_BY__EMAIL_ASC'
  | 'USER_BY_COMPLETED_BY__EMAIL_DESC'
  | 'USER_BY_COMPLETED_BY__EMAIL_WORK_ASC'
  | 'USER_BY_COMPLETED_BY__EMAIL_WORK_DESC'
  | 'USER_BY_COMPLETED_BY__EMPLOYEE_ID_ASC'
  | 'USER_BY_COMPLETED_BY__EMPLOYEE_ID_DESC'
  | 'USER_BY_COMPLETED_BY__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_COMPLETED_BY__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_COMPLETED_BY__EMPLOYMENT_END_ASC'
  | 'USER_BY_COMPLETED_BY__EMPLOYMENT_END_DESC'
  | 'USER_BY_COMPLETED_BY__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_COMPLETED_BY__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_COMPLETED_BY__EMPLOYMENT_START_ASC'
  | 'USER_BY_COMPLETED_BY__EMPLOYMENT_START_DESC'
  | 'USER_BY_COMPLETED_BY__FIRST_NAME_ASC'
  | 'USER_BY_COMPLETED_BY__FIRST_NAME_DESC'
  | 'USER_BY_COMPLETED_BY__FULL_NAME_ASC'
  | 'USER_BY_COMPLETED_BY__FULL_NAME_DESC'
  | 'USER_BY_COMPLETED_BY__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_COMPLETED_BY__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_COMPLETED_BY__GODMODE_ASC'
  | 'USER_BY_COMPLETED_BY__GODMODE_DESC'
  | 'USER_BY_COMPLETED_BY__GROUP_IDS_ASC'
  | 'USER_BY_COMPLETED_BY__GROUP_IDS_DESC'
  | 'USER_BY_COMPLETED_BY__ID_ASC'
  | 'USER_BY_COMPLETED_BY__ID_DESC'
  | 'USER_BY_COMPLETED_BY__INITIALS_ASC'
  | 'USER_BY_COMPLETED_BY__INITIALS_DESC'
  | 'USER_BY_COMPLETED_BY__IS_ARCHIVED_ASC'
  | 'USER_BY_COMPLETED_BY__IS_ARCHIVED_DESC'
  | 'USER_BY_COMPLETED_BY__IS_LEADER_ASC'
  | 'USER_BY_COMPLETED_BY__IS_LEADER_DESC'
  | 'USER_BY_COMPLETED_BY__IS_SYSTEM_USER_ASC'
  | 'USER_BY_COMPLETED_BY__IS_SYSTEM_USER_DESC'
  | 'USER_BY_COMPLETED_BY__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_COMPLETED_BY__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_COMPLETED_BY__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_COMPLETED_BY__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_COMPLETED_BY__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_COMPLETED_BY__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_COMPLETED_BY__LAST_LOGIN_ASC'
  | 'USER_BY_COMPLETED_BY__LAST_LOGIN_DESC'
  | 'USER_BY_COMPLETED_BY__LAST_NAME_ASC'
  | 'USER_BY_COMPLETED_BY__LAST_NAME_DESC'
  | 'USER_BY_COMPLETED_BY__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_COMPLETED_BY__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_COMPLETED_BY__MOBILE_ASC'
  | 'USER_BY_COMPLETED_BY__MOBILE_DESC'
  | 'USER_BY_COMPLETED_BY__MOBILE_PRIVATE_ASC'
  | 'USER_BY_COMPLETED_BY__MOBILE_PRIVATE_DESC'
  | 'USER_BY_COMPLETED_BY__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_COMPLETED_BY__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_COMPLETED_BY__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_COMPLETED_BY__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_COMPLETED_BY__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_COMPLETED_BY__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_COMPLETED_BY__PHONE_ASC'
  | 'USER_BY_COMPLETED_BY__PHONE_DESC'
  | 'USER_BY_COMPLETED_BY__POSTAL_CODE_ASC'
  | 'USER_BY_COMPLETED_BY__POSTAL_CODE_DESC'
  | 'USER_BY_COMPLETED_BY__SENIORITY_ASC'
  | 'USER_BY_COMPLETED_BY__SENIORITY_DESC'
  | 'USER_BY_CREATED_BY__ACTIVE_ASC'
  | 'USER_BY_CREATED_BY__ACTIVE_DESC'
  | 'USER_BY_CREATED_BY__ADDRESS_ASC'
  | 'USER_BY_CREATED_BY__ADDRESS_DESC'
  | 'USER_BY_CREATED_BY__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_CREATED_BY__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_CREATED_BY__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_CREATED_BY__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_CREATED_BY__BIRTHDATE_ASC'
  | 'USER_BY_CREATED_BY__BIRTHDATE_DESC'
  | 'USER_BY_CREATED_BY__CAN_LOGIN_APP_ASC'
  | 'USER_BY_CREATED_BY__CAN_LOGIN_APP_DESC'
  | 'USER_BY_CREATED_BY__CAN_LOGIN_ASC'
  | 'USER_BY_CREATED_BY__CAN_LOGIN_DESC'
  | 'USER_BY_CREATED_BY__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_CREATED_BY__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_CREATED_BY__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_CREATED_BY__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_CREATED_BY__CITY_ASC'
  | 'USER_BY_CREATED_BY__CITY_DESC'
  | 'USER_BY_CREATED_BY__COMPANY_ADMIN_ASC'
  | 'USER_BY_CREATED_BY__COMPANY_ADMIN_DESC'
  | 'USER_BY_CREATED_BY__COMPANY_ID_ASC'
  | 'USER_BY_CREATED_BY__COMPANY_ID_DESC'
  | 'USER_BY_CREATED_BY__CPR_ASC'
  | 'USER_BY_CREATED_BY__CPR_DESC'
  | 'USER_BY_CREATED_BY__CUSTOM_ID_ASC'
  | 'USER_BY_CREATED_BY__CUSTOM_ID_DESC'
  | 'USER_BY_CREATED_BY__DELETE_AT_ASC'
  | 'USER_BY_CREATED_BY__DELETE_AT_DESC'
  | 'USER_BY_CREATED_BY__DELETE_REMINDED_ASC'
  | 'USER_BY_CREATED_BY__DELETE_REMINDED_DESC'
  | 'USER_BY_CREATED_BY__DEPARTMENTS_ASC'
  | 'USER_BY_CREATED_BY__DEPARTMENTS_DESC'
  | 'USER_BY_CREATED_BY__EMAIL_ASC'
  | 'USER_BY_CREATED_BY__EMAIL_DESC'
  | 'USER_BY_CREATED_BY__EMAIL_WORK_ASC'
  | 'USER_BY_CREATED_BY__EMAIL_WORK_DESC'
  | 'USER_BY_CREATED_BY__EMPLOYEE_ID_ASC'
  | 'USER_BY_CREATED_BY__EMPLOYEE_ID_DESC'
  | 'USER_BY_CREATED_BY__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_CREATED_BY__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_CREATED_BY__EMPLOYMENT_END_ASC'
  | 'USER_BY_CREATED_BY__EMPLOYMENT_END_DESC'
  | 'USER_BY_CREATED_BY__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_CREATED_BY__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_CREATED_BY__EMPLOYMENT_START_ASC'
  | 'USER_BY_CREATED_BY__EMPLOYMENT_START_DESC'
  | 'USER_BY_CREATED_BY__FIRST_NAME_ASC'
  | 'USER_BY_CREATED_BY__FIRST_NAME_DESC'
  | 'USER_BY_CREATED_BY__FULL_NAME_ASC'
  | 'USER_BY_CREATED_BY__FULL_NAME_DESC'
  | 'USER_BY_CREATED_BY__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_CREATED_BY__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_CREATED_BY__GODMODE_ASC'
  | 'USER_BY_CREATED_BY__GODMODE_DESC'
  | 'USER_BY_CREATED_BY__GROUP_IDS_ASC'
  | 'USER_BY_CREATED_BY__GROUP_IDS_DESC'
  | 'USER_BY_CREATED_BY__ID_ASC'
  | 'USER_BY_CREATED_BY__ID_DESC'
  | 'USER_BY_CREATED_BY__INITIALS_ASC'
  | 'USER_BY_CREATED_BY__INITIALS_DESC'
  | 'USER_BY_CREATED_BY__IS_ARCHIVED_ASC'
  | 'USER_BY_CREATED_BY__IS_ARCHIVED_DESC'
  | 'USER_BY_CREATED_BY__IS_LEADER_ASC'
  | 'USER_BY_CREATED_BY__IS_LEADER_DESC'
  | 'USER_BY_CREATED_BY__IS_SYSTEM_USER_ASC'
  | 'USER_BY_CREATED_BY__IS_SYSTEM_USER_DESC'
  | 'USER_BY_CREATED_BY__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_CREATED_BY__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_CREATED_BY__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_CREATED_BY__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_CREATED_BY__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_CREATED_BY__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_CREATED_BY__LAST_LOGIN_ASC'
  | 'USER_BY_CREATED_BY__LAST_LOGIN_DESC'
  | 'USER_BY_CREATED_BY__LAST_NAME_ASC'
  | 'USER_BY_CREATED_BY__LAST_NAME_DESC'
  | 'USER_BY_CREATED_BY__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_CREATED_BY__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_CREATED_BY__MOBILE_ASC'
  | 'USER_BY_CREATED_BY__MOBILE_DESC'
  | 'USER_BY_CREATED_BY__MOBILE_PRIVATE_ASC'
  | 'USER_BY_CREATED_BY__MOBILE_PRIVATE_DESC'
  | 'USER_BY_CREATED_BY__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_CREATED_BY__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_CREATED_BY__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_CREATED_BY__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_CREATED_BY__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_CREATED_BY__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_CREATED_BY__PHONE_ASC'
  | 'USER_BY_CREATED_BY__PHONE_DESC'
  | 'USER_BY_CREATED_BY__POSTAL_CODE_ASC'
  | 'USER_BY_CREATED_BY__POSTAL_CODE_DESC'
  | 'USER_BY_CREATED_BY__SENIORITY_ASC'
  | 'USER_BY_CREATED_BY__SENIORITY_DESC'
  | 'USER_IDS_ASC'
  | 'USER_IDS_DESC';

/** A filter to be used against Time fields. All fields are combined with a logical ‘and.’ */
export type TimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Time']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Time']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Time']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Time']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Time']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Time']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Time']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Time']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Time']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Time']>>;
};

export type TimeRegistrationBreakType = {
  __typename?: 'TimeRegistrationBreakType';
  active: Scalars['Boolean'];
  code?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationBreakType`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  emoji: Scalars['String'];
  id: Scalars['UUID'];
  localizedName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationBreakType`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  nameTranslatedEntityId: Scalars['UUID'];
  paidTime: Interval;
  /** Reads and enables pagination through a set of `TimeRegistrationEntry`. */
  timeRegistrationEntries: TimeRegistrationEntriesConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationEntryTemplate`. */
  timeRegistrationEntryTemplates: TimeRegistrationEntryTemplatesConnection;
};


export type TimeRegistrationBreakTypeTimeRegistrationEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationEntryCondition>;
  filter?: InputMaybe<TimeRegistrationEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationEntriesOrderBy>>;
};


export type TimeRegistrationBreakTypeTimeRegistrationEntryTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationEntryTemplateCondition>;
  filter?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationEntryTemplatesOrderBy>>;
};

/** The `timeRegistrationBreakType` to be created by this mutation. */
export type TimeRegistrationBreakTypeCompanyIdForeignConnectionTimeRegistrationBreakTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInput>;
  emoji: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  paidTime?: InputMaybe<IntervalInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInput>;
};

/** Input for the nested mutation of `company` in the `TimeRegistrationBreakTypeInput` mutation. */
export type TimeRegistrationBreakTypeCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnTimeRegistrationBreakTypeForTimeRegistrationBreakTypeCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationBreakType` in the `CompanyInput` mutation. */
export type TimeRegistrationBreakTypeCompanyIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationBreakType` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationBreakTypeTimeRegistrationBreakTypePkeyConnect>>;
  /** A `TimeRegistrationBreakTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationBreakTypeCompanyIdForeignConnectionTimeRegistrationBreakTypeCreateInput>>;
  /** The primary key(s) for `timeRegistrationBreakType` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationBreakTypeTimeRegistrationBreakTypePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationBreakType` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationBreakType` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationBreakTypeOnTimeRegistrationBreakTypeForTimeRegistrationBreakTypeCompanyIdForeignUsingTimeRegistrationBreakTypePkeyUpdate>>;
};

/**
 * A condition to be used against `TimeRegistrationBreakType` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type TimeRegistrationBreakTypeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `emoji` field. */
  emoji?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameTranslatedEntityId` field. */
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `paidTime` field. */
  paidTime?: InputMaybe<IntervalInput>;
};

/** A filter to be used against `TimeRegistrationBreakType` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationBreakTypeFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TimeRegistrationBreakTypeFilter>>;
  /** Filter by the object’s `code` field. */
  code?: InputMaybe<StringFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `emoji` field. */
  emoji?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameTranslatedEntity` relation. */
  nameTranslatedEntity?: InputMaybe<TranslatedEntityFilter>;
  /** Filter by the object’s `nameTranslatedEntityId` field. */
  nameTranslatedEntityId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TimeRegistrationBreakTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TimeRegistrationBreakTypeFilter>>;
  /** Filter by the object’s `paidTime` field. */
  paidTime?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `timeRegistrationEntries` relation. */
  timeRegistrationEntries?: InputMaybe<TimeRegistrationBreakTypeToManyTimeRegistrationEntryFilter>;
  /** Some related `timeRegistrationEntries` exist. */
  timeRegistrationEntriesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationEntryTemplates` relation. */
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationBreakTypeToManyTimeRegistrationEntryTemplateFilter>;
  /** Some related `timeRegistrationEntryTemplates` exist. */
  timeRegistrationEntryTemplatesExist?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `TimeRegistrationBreakType` */
export type TimeRegistrationBreakTypeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  emoji: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  paidTime?: InputMaybe<IntervalInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInput>;
};

/** Input for the nested mutation of `translatedEntity` in the `TimeRegistrationBreakTypeInput` mutation. */
export type TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInput = {
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  connectById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyConnect>;
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  deleteById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyDelete>;
  /** The primary key(s) and patch data for `translatedEntity` for the far side of the relationship. */
  updateById?: InputMaybe<TranslatedEntityOnTimeRegistrationBreakTypeForTimeRegistrationBreakTypeNameTranslatedEntityIdForeignUsingTranslatedEntityPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationBreakType` in the `TranslatedEntityInput` mutation. */
export type TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationBreakType` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationBreakTypeTimeRegistrationBreakTypePkeyConnect>>;
  /** The primary key(s) for `timeRegistrationBreakType` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationBreakTypeTimeRegistrationBreakTypePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationBreakType` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationBreakType` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationBreakTypeOnTimeRegistrationBreakTypeForTimeRegistrationBreakTypeNameTranslatedEntityIdForeignUsingTimeRegistrationBreakTypePkeyUpdate>>;
};

/** The fields on `timeRegistrationBreakType` to look up the row to update. */
export type TimeRegistrationBreakTypeOnTimeRegistrationBreakTypeForTimeRegistrationBreakTypeCompanyIdForeignUsingTimeRegistrationBreakTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationBreakType` being updated. */
  patch: UpdateTimeRegistrationBreakTypeOnTimeRegistrationBreakTypeForTimeRegistrationBreakTypeCompanyIdForeignPatch;
};

/** The fields on `timeRegistrationBreakType` to look up the row to update. */
export type TimeRegistrationBreakTypeOnTimeRegistrationBreakTypeForTimeRegistrationBreakTypeNameTranslatedEntityIdForeignUsingTimeRegistrationBreakTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationBreakType` being updated. */
  patch: UpdateTimeRegistrationBreakTypeOnTimeRegistrationBreakTypeForTimeRegistrationBreakTypeNameTranslatedEntityIdForeignPatch;
};

/** The fields on `timeRegistrationBreakType` to look up the row to update. */
export type TimeRegistrationBreakTypeOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationBreakTypeIdForeignUsingTimeRegistrationBreakTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationBreakType` being updated. */
  patch: UpdateTimeRegistrationBreakTypeOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationBreakTypeIdForeignPatch;
};

/** The fields on `timeRegistrationBreakType` to look up the row to update. */
export type TimeRegistrationBreakTypeOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationBreakTypeIUsingTimeRegistrationBreakTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationBreakType` being updated. */
  patch: UpdateTimeRegistrationBreakTypeOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationBreakTypeIPatch;
};

/** Represents an update to a `TimeRegistrationBreakType`. Fields that are set will be updated. */
export type TimeRegistrationBreakTypePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  paidTime?: InputMaybe<IntervalInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInput>;
};

/** The fields on `timeRegistrationBreakType` to look up the row to connect. */
export type TimeRegistrationBreakTypeTimeRegistrationBreakTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `timeRegistrationBreakType` to look up the row to delete. */
export type TimeRegistrationBreakTypeTimeRegistrationBreakTypePkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `TimeRegistrationEntry` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationBreakTypeToManyTimeRegistrationEntryFilter = {
  /** Every related `TimeRegistrationEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationEntryFilter>;
  /** No related `TimeRegistrationEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationEntryFilter>;
  /** Some related `TimeRegistrationEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationEntryFilter>;
};

/** A filter to be used against many `TimeRegistrationEntryTemplate` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationBreakTypeToManyTimeRegistrationEntryTemplateFilter = {
  /** Every related `TimeRegistrationEntryTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  /** No related `TimeRegistrationEntryTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  /** Some related `TimeRegistrationEntryTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
};

/** A connection to a list of `TimeRegistrationBreakType` values. */
export type TimeRegistrationBreakTypesConnection = {
  __typename?: 'TimeRegistrationBreakTypesConnection';
  /** A list of edges which contains the `TimeRegistrationBreakType` and cursor to aid in pagination. */
  edges: Array<TimeRegistrationBreakTypesEdge>;
  /** A list of `TimeRegistrationBreakType` objects. */
  nodes: Array<Maybe<TimeRegistrationBreakType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TimeRegistrationBreakType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TimeRegistrationBreakType` edge in the connection. */
export type TimeRegistrationBreakTypesEdge = {
  __typename?: 'TimeRegistrationBreakTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TimeRegistrationBreakType` at the end of the edge. */
  node?: Maybe<TimeRegistrationBreakType>;
};

/** Methods to use when ordering `TimeRegistrationBreakType`. */
export type TimeRegistrationBreakTypesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'CODE_ASC'
  | 'CODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'EMOJI_ASC'
  | 'EMOJI_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALIZED_NAME_ASC'
  | 'LOCALIZED_NAME_DESC'
  | 'NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'NATURAL'
  | 'PAID_TIME_ASC'
  | 'PAID_TIME_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIME_REGISTRATION_ENTRIES_BY_TIME_REGISTRATION_BREAK_TYPE_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_ENTRIES_BY_TIME_REGISTRATION_BREAK_TYPE_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_ENTRY_TEMPLATES_BY_TIME_REGISTRATION_BREAK_TYPE_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_ENTRY_TEMPLATES_BY_TIME_REGISTRATION_BREAK_TYPE_ID__COUNT_DESC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__COMPANY_ID_ASC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__COMPANY_ID_DESC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__ID_ASC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__ID_DESC';

export type TimeRegistrationDayTemplateInput = {
  dayIndex?: InputMaybe<Scalars['Int']>;
  presences?: InputMaybe<Array<TimeRegistrationTemplatePresenceInput>>;
};

/** A connection to a list of `TimeRegistrationDepartmentOverviewRecord` values. */
export type TimeRegistrationDepartmentOverviewConnection = {
  __typename?: 'TimeRegistrationDepartmentOverviewConnection';
  /** A list of edges which contains the `TimeRegistrationDepartmentOverviewRecord` and cursor to aid in pagination. */
  edges: Array<TimeRegistrationDepartmentOverviewEdge>;
  /** A list of `TimeRegistrationDepartmentOverviewRecord` objects. */
  nodes: Array<Maybe<TimeRegistrationDepartmentOverviewRecord>>;
  /** The count of *all* `TimeRegistrationDepartmentOverviewRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TimeRegistrationDepartmentOverviewRecord` edge in the connection. */
export type TimeRegistrationDepartmentOverviewEdge = {
  __typename?: 'TimeRegistrationDepartmentOverviewEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TimeRegistrationDepartmentOverviewRecord` at the end of the edge. */
  node?: Maybe<TimeRegistrationDepartmentOverviewRecord>;
};

/** The return type of our `timeRegistrationDepartmentOverview` query. */
export type TimeRegistrationDepartmentOverviewRecord = {
  __typename?: 'TimeRegistrationDepartmentOverviewRecord';
  departmentId?: Maybe<Scalars['UUID']>;
  hoursThisWeek?: Maybe<Interval>;
  name?: Maybe<Scalars['String']>;
  numberOfEmployees?: Maybe<Scalars['BigInt']>;
  numberOfWarnings?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `TimeRegistrationDepartmentOverviewRecord` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationDepartmentOverviewRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TimeRegistrationDepartmentOverviewRecordFilter>>;
  /** Filter by the object’s `departmentId` field. */
  departmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `hoursThisWeek` field. */
  hoursThisWeek?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TimeRegistrationDepartmentOverviewRecordFilter>;
  /** Filter by the object’s `numberOfEmployees` field. */
  numberOfEmployees?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `numberOfWarnings` field. */
  numberOfWarnings?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TimeRegistrationDepartmentOverviewRecordFilter>>;
};

/** A connection to a list of `TimeRegistrationEntry` values. */
export type TimeRegistrationEntriesConnection = {
  __typename?: 'TimeRegistrationEntriesConnection';
  /** A list of edges which contains the `TimeRegistrationEntry` and cursor to aid in pagination. */
  edges: Array<TimeRegistrationEntriesEdge>;
  /** A list of `TimeRegistrationEntry` objects. */
  nodes: Array<Maybe<TimeRegistrationEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TimeRegistrationEntry` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TimeRegistrationEntry` edge in the connection. */
export type TimeRegistrationEntriesEdge = {
  __typename?: 'TimeRegistrationEntriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TimeRegistrationEntry` at the end of the edge. */
  node?: Maybe<TimeRegistrationEntry>;
};

/** Methods to use when ordering `TimeRegistrationEntry`. */
export type TimeRegistrationEntriesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'END_DATE_ASC'
  | 'END_DATE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'NOTE_ASC'
  | 'NOTE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'START_DATE_ASC'
  | 'START_DATE_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__ACTIVE_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__ACTIVE_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__CODE_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__CODE_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__COMPANY_ID_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__COMPANY_ID_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__EMOJI_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__EMOJI_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__ID_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__ID_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__PAID_TIME_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__PAID_TIME_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPE_ID_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPE_ID_DESC'
  | 'TIME_REGISTRATION_ENTRY_TYPE_ASC'
  | 'TIME_REGISTRATION_ENTRY_TYPE_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__ACTIVE_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__ACTIVE_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__APPROVAL_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__APPROVAL_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__COMPANY_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__COMPANY_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__DEPARTMENT_IDS_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__DEPARTMENT_IDS_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__END_DATE_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__END_DATE_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__NOTE_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__NOTE_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__START_DATE_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__START_DATE_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__TIME_REGISTRATION_PRESENCE_TYPE_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__TIME_REGISTRATION_PRESENCE_TYPE_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__UNPAID_BREAK_TIME_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__UNPAID_BREAK_TIME_DESC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__USER_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_BY_TIME_REGISTRATION_PRESENCE_ID__USER_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_ID_DESC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__ACTIVE_ASC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__ACTIVE_DESC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__CODE_ASC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__CODE_DESC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__COLOR_ASC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__COLOR_DESC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__COMPANY_ID_ASC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__COMPANY_ID_DESC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__DESCRIPTION_TRANSLATED_ENTITY_ID_ASC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__DESCRIPTION_TRANSLATED_ENTITY_ID_DESC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__ID_ASC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__ID_DESC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__LOCALIZED_NAME_ASC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__LOCALIZED_NAME_DESC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'TIME_REGISTRATION_PROJECT_ID_ASC'
  | 'TIME_REGISTRATION_PROJECT_ID_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type TimeRegistrationEntry = {
  __typename?: 'TimeRegistrationEntry';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `TimeRegistrationEntry`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  departmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  elapsedTime?: Maybe<Interval>;
  endDate?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  note?: Maybe<Scalars['String']>;
  startDate: Scalars['Datetime'];
  /** Reads a single `TimeRegistrationBreakType` that is related to this `TimeRegistrationEntry`. */
  timeRegistrationBreakType?: Maybe<TimeRegistrationBreakType>;
  timeRegistrationBreakTypeId?: Maybe<Scalars['UUID']>;
  timeRegistrationEntryType: TimeRegistrationEntryType;
  /** Reads a single `TimeRegistrationPresence` that is related to this `TimeRegistrationEntry`. */
  timeRegistrationPresence?: Maybe<TimeRegistrationPresence>;
  timeRegistrationPresenceId: Scalars['UUID'];
  /** Reads a single `TimeRegistrationProject` that is related to this `TimeRegistrationEntry`. */
  timeRegistrationProject?: Maybe<TimeRegistrationProject>;
  timeRegistrationProjectId?: Maybe<Scalars['UUID']>;
  /** Reads a single `User` that is related to this `TimeRegistrationEntry`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The `timeRegistrationEntry` to be created by this mutation. */
export type TimeRegistrationEntryCompanyIdForeignConnectionTimeRegistrationEntryCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInput>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  startDate: Scalars['Datetime'];
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType: TimeRegistrationEntryType;
  timeRegistrationPresence?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `TimeRegistrationEntryInput` mutation. */
export type TimeRegistrationEntryCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnTimeRegistrationEntryForTimeRegistrationEntryCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationEntry` in the `CompanyInput` mutation. */
export type TimeRegistrationEntryCompanyIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationEntryTimeRegistrationEntryPkeyConnect>>;
  /** A `TimeRegistrationEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationEntryCompanyIdForeignConnectionTimeRegistrationEntryCreateInput>>;
  /** The primary key(s) for `timeRegistrationEntry` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationEntryTimeRegistrationEntryPkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationEntry` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryCompanyIdForeignUsingTimeRegistrationEntryPkeyUpdate>>;
};

/**
 * A condition to be used against `TimeRegistrationEntry` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type TimeRegistrationEntryCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `timeRegistrationBreakTypeId` field. */
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeRegistrationEntryType` field. */
  timeRegistrationEntryType?: InputMaybe<TimeRegistrationEntryType>;
  /** Checks for equality with the object’s `timeRegistrationPresenceId` field. */
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeRegistrationProjectId` field. */
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `TimeRegistrationEntry` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationEntryFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TimeRegistrationEntryFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `elapsedTime` field. */
  elapsedTime?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TimeRegistrationEntryFilter>;
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TimeRegistrationEntryFilter>>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `timeRegistrationBreakType` relation. */
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationBreakTypeFilter>;
  /** A related `timeRegistrationBreakType` exists. */
  timeRegistrationBreakTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationBreakTypeId` field. */
  timeRegistrationBreakTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `timeRegistrationEntryType` field. */
  timeRegistrationEntryType?: InputMaybe<TimeRegistrationEntryTypeFilter>;
  /** Filter by the object’s `timeRegistrationPresence` relation. */
  timeRegistrationPresence?: InputMaybe<TimeRegistrationPresenceFilter>;
  /** Filter by the object’s `timeRegistrationPresenceId` field. */
  timeRegistrationPresenceId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `timeRegistrationProject` relation. */
  timeRegistrationProject?: InputMaybe<TimeRegistrationProjectFilter>;
  /** A related `timeRegistrationProject` exists. */
  timeRegistrationProjectExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationProjectId` field. */
  timeRegistrationProjectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `TimeRegistrationEntry` */
export type TimeRegistrationEntryInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  startDate: Scalars['Datetime'];
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType: TimeRegistrationEntryType;
  timeRegistrationPresence?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `timeRegistrationEntry` to look up the row to update. */
export type TimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryCompanyIdForeignUsingTimeRegistrationEntryPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationEntry` being updated. */
  patch: UpdateTimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryCompanyIdForeignPatch;
};

/** The fields on `timeRegistrationEntry` to look up the row to update. */
export type TimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationBreakTypeIdForeignUsingTimeRegistrationEntryPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationEntry` being updated. */
  patch: UpdateTimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationBreakTypeIdForeignPatch;
};

/** The fields on `timeRegistrationEntry` to look up the row to update. */
export type TimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationPresenceIdForeignUsingTimeRegistrationEntryPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationEntry` being updated. */
  patch: UpdateTimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationPresenceIdForeignPatch;
};

/** The fields on `timeRegistrationEntry` to look up the row to update. */
export type TimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationProjectIdForeignUsingTimeRegistrationEntryPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationEntry` being updated. */
  patch: UpdateTimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationProjectIdForeignPatch;
};

/** The fields on `timeRegistrationEntry` to look up the row to update. */
export type TimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryUserIdForeignUsingTimeRegistrationEntryPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationEntry` being updated. */
  patch: UpdateTimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryUserIdForeignPatch;
};

/** Represents an update to a `TimeRegistrationEntry`. Fields that are set will be updated. */
export type TimeRegistrationEntryPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType?: InputMaybe<TimeRegistrationEntryType>;
  timeRegistrationPresence?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type TimeRegistrationEntryTemplate = {
  __typename?: 'TimeRegistrationEntryTemplate';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `TimeRegistrationEntryTemplate`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  endTime: Scalars['Time'];
  id: Scalars['UUID'];
  startTime: Scalars['Time'];
  /** Reads a single `TimeRegistrationBreakType` that is related to this `TimeRegistrationEntryTemplate`. */
  timeRegistrationBreakType?: Maybe<TimeRegistrationBreakType>;
  timeRegistrationBreakTypeId?: Maybe<Scalars['UUID']>;
  timeRegistrationEntryType: TimeRegistrationEntryType;
  /** Reads a single `TimeRegistrationPresenceTemplate` that is related to this `TimeRegistrationEntryTemplate`. */
  timeRegistrationPresenceTemplate?: Maybe<TimeRegistrationPresenceTemplate>;
  timeRegistrationPresenceTemplateId: Scalars['UUID'];
  /** Reads a single `TimeRegistrationProject` that is related to this `TimeRegistrationEntryTemplate`. */
  timeRegistrationProject?: Maybe<TimeRegistrationProject>;
  timeRegistrationProjectId?: Maybe<Scalars['UUID']>;
  /** Reads a single `TimeRegistrationTemplate` that is related to this `TimeRegistrationEntryTemplate`. */
  timeRegistrationTemplate?: Maybe<TimeRegistrationTemplate>;
  timeRegistrationTemplateId?: Maybe<Scalars['UUID']>;
  /** Reads a single `User` that is related to this `TimeRegistrationEntryTemplate`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

/** The `timeRegistrationEntryTemplate` to be created by this mutation. */
export type TimeRegistrationEntryTemplateCompanyIdForeignConnectionTimeRegistrationEntryTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInput>;
  endTime: Scalars['Time'];
  id?: InputMaybe<Scalars['UUID']>;
  startTime: Scalars['Time'];
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType: TimeRegistrationEntryType;
  timeRegistrationPresenceTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInput>;
  timeRegistrationPresenceTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `TimeRegistrationEntryTemplateInput` mutation. */
export type TimeRegistrationEntryTemplateCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationEntryTemplate` in the `CompanyInput` mutation. */
export type TimeRegistrationEntryTemplateCompanyIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationEntryTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationEntryTemplateTimeRegistrationEntryTemplatePkeyConnect>>;
  /** A `TimeRegistrationEntryTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationEntryTemplateCompanyIdForeignConnectionTimeRegistrationEntryTemplateCreateInput>>;
  /** The primary key(s) for `timeRegistrationEntryTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationEntryTemplateTimeRegistrationEntryTemplatePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationEntryTemplate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationEntryTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateCompanyIdForeignUsingTimeRegistrationEntryTemplatePkeyUpdate>>;
};

/**
 * A condition to be used against `TimeRegistrationEntryTemplate` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type TimeRegistrationEntryTemplateCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `timeRegistrationBreakTypeId` field. */
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeRegistrationEntryType` field. */
  timeRegistrationEntryType?: InputMaybe<TimeRegistrationEntryType>;
  /** Checks for equality with the object’s `timeRegistrationPresenceTemplateId` field. */
  timeRegistrationPresenceTemplateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeRegistrationProjectId` field. */
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeRegistrationTemplateId` field. */
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `TimeRegistrationEntryTemplate` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationEntryTemplateFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TimeRegistrationEntryTemplateFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TimeRegistrationEntryTemplateFilter>>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `timeRegistrationBreakType` relation. */
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationBreakTypeFilter>;
  /** A related `timeRegistrationBreakType` exists. */
  timeRegistrationBreakTypeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationBreakTypeId` field. */
  timeRegistrationBreakTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `timeRegistrationEntryType` field. */
  timeRegistrationEntryType?: InputMaybe<TimeRegistrationEntryTypeFilter>;
  /** Filter by the object’s `timeRegistrationPresenceTemplate` relation. */
  timeRegistrationPresenceTemplate?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
  /** Filter by the object’s `timeRegistrationPresenceTemplateId` field. */
  timeRegistrationPresenceTemplateId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `timeRegistrationProject` relation. */
  timeRegistrationProject?: InputMaybe<TimeRegistrationProjectFilter>;
  /** A related `timeRegistrationProject` exists. */
  timeRegistrationProjectExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationProjectId` field. */
  timeRegistrationProjectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `timeRegistrationTemplate` relation. */
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationTemplateFilter>;
  /** A related `timeRegistrationTemplate` exists. */
  timeRegistrationTemplateExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationTemplateId` field. */
  timeRegistrationTemplateId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `TimeRegistrationEntryTemplate` */
export type TimeRegistrationEntryTemplateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  endTime: Scalars['Time'];
  id?: InputMaybe<Scalars['UUID']>;
  startTime: Scalars['Time'];
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType: TimeRegistrationEntryType;
  timeRegistrationPresenceTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInput>;
  timeRegistrationPresenceTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `timeRegistrationEntryTemplate` to look up the row to update. */
export type TimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateCompanyIdForeignUsingTimeRegistrationEntryTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationEntryTemplate` being updated. */
  patch: UpdateTimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateCompanyIdForeignPatch;
};

/** The fields on `timeRegistrationEntryTemplate` to look up the row to update. */
export type TimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationBreakTypeIUsingTimeRegistrationEntryTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationEntryTemplate` being updated. */
  patch: UpdateTimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationBreakTypeIPatch;
};

/** The fields on `timeRegistrationEntryTemplate` to look up the row to update. */
export type TimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationPresenceTemUsingTimeRegistrationEntryTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationEntryTemplate` being updated. */
  patch: UpdateTimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationPresenceTemPatch;
};

/** The fields on `timeRegistrationEntryTemplate` to look up the row to update. */
export type TimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationProjectIdFUsingTimeRegistrationEntryTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationEntryTemplate` being updated. */
  patch: UpdateTimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationProjectIdFPatch;
};

/** The fields on `timeRegistrationEntryTemplate` to look up the row to update. */
export type TimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationTemplateIdUsingTimeRegistrationEntryTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationEntryTemplate` being updated. */
  patch: UpdateTimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationTemplateIdPatch;
};

/** The fields on `timeRegistrationEntryTemplate` to look up the row to update. */
export type TimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateUserIdForeignUsingTimeRegistrationEntryTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationEntryTemplate` being updated. */
  patch: UpdateTimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateUserIdForeignPatch;
};

/** Represents an update to a `TimeRegistrationEntryTemplate`. Fields that are set will be updated. */
export type TimeRegistrationEntryTemplatePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  endTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['UUID']>;
  startTime?: InputMaybe<Scalars['Time']>;
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType?: InputMaybe<TimeRegistrationEntryType>;
  timeRegistrationPresenceTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInput>;
  timeRegistrationPresenceTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `timeRegistrationBreakType` to be created by this mutation. */
export type TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIConnectionTimeRegistrationBreakTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  emoji: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  paidTime?: InputMaybe<IntervalInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInput>;
};

/** The `timeRegistrationEntryTemplate` to be created by this mutation. */
export type TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIConnectionTimeRegistrationEntryTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  endTime: Scalars['Time'];
  id?: InputMaybe<Scalars['UUID']>;
  startTime: Scalars['Time'];
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInput>;
  timeRegistrationEntryType: TimeRegistrationEntryType;
  timeRegistrationPresenceTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInput>;
  timeRegistrationPresenceTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `timeRegistrationBreakType` in the `TimeRegistrationEntryTemplateInput` mutation. */
export type TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInput = {
  /** The primary key(s) for `timeRegistrationBreakType` for the far side of the relationship. */
  connectById?: InputMaybe<TimeRegistrationBreakTypeTimeRegistrationBreakTypePkeyConnect>;
  /** A `TimeRegistrationBreakTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIConnectionTimeRegistrationBreakTypeCreateInput>;
  /** The primary key(s) for `timeRegistrationBreakType` for the far side of the relationship. */
  deleteById?: InputMaybe<TimeRegistrationBreakTypeTimeRegistrationBreakTypePkeyDelete>;
  /** The primary key(s) and patch data for `timeRegistrationBreakType` for the far side of the relationship. */
  updateById?: InputMaybe<TimeRegistrationBreakTypeOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationBreakTypeIUsingTimeRegistrationBreakTypePkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationEntryTemplate` in the `TimeRegistrationBreakTypeInput` mutation. */
export type TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInverseInput = {
  /** The primary key(s) for `timeRegistrationEntryTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationEntryTemplateTimeRegistrationEntryTemplatePkeyConnect>>;
  /** A `TimeRegistrationEntryTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIConnectionTimeRegistrationEntryTemplateCreateInput>>;
  /** The primary key(s) for `timeRegistrationEntryTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationEntryTemplateTimeRegistrationEntryTemplatePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationEntryTemplate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationEntryTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationBreakTypeIUsingTimeRegistrationEntryTemplatePkeyUpdate>>;
};

/** The fields on `timeRegistrationEntryTemplate` to look up the row to connect. */
export type TimeRegistrationEntryTemplateTimeRegistrationEntryTemplatePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `timeRegistrationEntryTemplate` to look up the row to delete. */
export type TimeRegistrationEntryTemplateTimeRegistrationEntryTemplatePkeyDelete = {
  id: Scalars['UUID'];
};

/** The `timeRegistrationEntryTemplate` to be created by this mutation. */
export type TimeRegistrationEntryTemplateTimeRegistrationPresenceTemConnectionTimeRegistrationEntryTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  endTime: Scalars['Time'];
  id?: InputMaybe<Scalars['UUID']>;
  startTime: Scalars['Time'];
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType: TimeRegistrationEntryType;
  timeRegistrationPresenceTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInput>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `timeRegistrationPresenceTemplate` to be created by this mutation. */
export type TimeRegistrationEntryTemplateTimeRegistrationPresenceTemConnectionTimeRegistrationPresenceTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['Time'];
  id?: InputMaybe<Scalars['UUID']>;
  startTime: Scalars['Time'];
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplateWeek?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInput>;
  timeRegistrationTemplateWeekId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `timeRegistrationPresenceTemplate` in the `TimeRegistrationEntryTemplateInput` mutation. */
export type TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInput = {
  /** The primary key(s) for `timeRegistrationPresenceTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceTemplatePkeyConnect>;
  /** A `TimeRegistrationPresenceTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemConnectionTimeRegistrationPresenceTemplateCreateInput>;
  /** The primary key(s) for `timeRegistrationPresenceTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceTemplatePkeyDelete>;
  /** The primary key(s) and patch data for `timeRegistrationPresenceTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<TimeRegistrationPresenceTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationPresenceTemUsingTimeRegistrationPresenceTemplatePkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationEntryTemplate` in the `TimeRegistrationPresenceTemplateInput` mutation. */
export type TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInverseInput = {
  /** The primary key(s) for `timeRegistrationEntryTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationEntryTemplateTimeRegistrationEntryTemplatePkeyConnect>>;
  /** A `TimeRegistrationEntryTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemConnectionTimeRegistrationEntryTemplateCreateInput>>;
  /** The primary key(s) for `timeRegistrationEntryTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationEntryTemplateTimeRegistrationEntryTemplatePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationEntryTemplate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationEntryTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationPresenceTemUsingTimeRegistrationEntryTemplatePkeyUpdate>>;
};

/** The `timeRegistrationEntryTemplate` to be created by this mutation. */
export type TimeRegistrationEntryTemplateTimeRegistrationProjectIdFConnectionTimeRegistrationEntryTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  endTime: Scalars['Time'];
  id?: InputMaybe<Scalars['UUID']>;
  startTime: Scalars['Time'];
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType: TimeRegistrationEntryType;
  timeRegistrationPresenceTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInput>;
  timeRegistrationPresenceTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInput>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `timeRegistrationProject` to be created by this mutation. */
export type TimeRegistrationEntryTemplateTimeRegistrationProjectIdFConnectionTimeRegistrationProjectCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  color: Scalars['String'];
  company?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  descriptionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInput>;
};

/** Input for the nested mutation of `timeRegistrationProject` in the `TimeRegistrationEntryTemplateInput` mutation. */
export type TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInput = {
  /** The primary key(s) for `timeRegistrationProject` for the far side of the relationship. */
  connectById?: InputMaybe<TimeRegistrationProjectTimeRegistrationProjectPkeyConnect>;
  /** A `TimeRegistrationProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFConnectionTimeRegistrationProjectCreateInput>;
  /** The primary key(s) for `timeRegistrationProject` for the far side of the relationship. */
  deleteById?: InputMaybe<TimeRegistrationProjectTimeRegistrationProjectPkeyDelete>;
  /** The primary key(s) and patch data for `timeRegistrationProject` for the far side of the relationship. */
  updateById?: InputMaybe<TimeRegistrationProjectOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationProjectIdFUsingTimeRegistrationProjectPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationEntryTemplate` in the `TimeRegistrationProjectInput` mutation. */
export type TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInverseInput = {
  /** The primary key(s) for `timeRegistrationEntryTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationEntryTemplateTimeRegistrationEntryTemplatePkeyConnect>>;
  /** A `TimeRegistrationEntryTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFConnectionTimeRegistrationEntryTemplateCreateInput>>;
  /** The primary key(s) for `timeRegistrationEntryTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationEntryTemplateTimeRegistrationEntryTemplatePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationEntryTemplate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationEntryTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationProjectIdFUsingTimeRegistrationEntryTemplatePkeyUpdate>>;
};

/** The `timeRegistrationEntryTemplate` to be created by this mutation. */
export type TimeRegistrationEntryTemplateTimeRegistrationTemplateIdConnectionTimeRegistrationEntryTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  endTime: Scalars['Time'];
  id?: InputMaybe<Scalars['UUID']>;
  startTime: Scalars['Time'];
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType: TimeRegistrationEntryType;
  timeRegistrationPresenceTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInput>;
  timeRegistrationPresenceTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInput>;
  user?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `timeRegistrationTemplate` to be created by this mutation. */
export type TimeRegistrationEntryTemplateTimeRegistrationTemplateIdConnectionTimeRegistrationTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInput>;
  useMultiWeek?: InputMaybe<Scalars['Boolean']>;
  users?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInverseInput>;
};

/** Input for the nested mutation of `timeRegistrationTemplate` in the `TimeRegistrationEntryTemplateInput` mutation. */
export type TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInput = {
  /** The primary key(s) for `timeRegistrationTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<TimeRegistrationTemplateTimeRegistrationTemplatePkeyConnect>;
  /** A `TimeRegistrationTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdConnectionTimeRegistrationTemplateCreateInput>;
  /** The primary key(s) for `timeRegistrationTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<TimeRegistrationTemplateTimeRegistrationTemplatePkeyDelete>;
  /** The primary key(s) and patch data for `timeRegistrationTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<TimeRegistrationTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationTemplateIdUsingTimeRegistrationTemplatePkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationEntryTemplate` in the `TimeRegistrationTemplateInput` mutation. */
export type TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInverseInput = {
  /** The primary key(s) for `timeRegistrationEntryTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationEntryTemplateTimeRegistrationEntryTemplatePkeyConnect>>;
  /** A `TimeRegistrationEntryTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdConnectionTimeRegistrationEntryTemplateCreateInput>>;
  /** The primary key(s) for `timeRegistrationEntryTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationEntryTemplateTimeRegistrationEntryTemplatePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationEntryTemplate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationEntryTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationTemplateIdUsingTimeRegistrationEntryTemplatePkeyUpdate>>;
};

/** The `timeRegistrationEntryTemplate` to be created by this mutation. */
export type TimeRegistrationEntryTemplateUserIdForeignConnectionTimeRegistrationEntryTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  endTime: Scalars['Time'];
  id?: InputMaybe<Scalars['UUID']>;
  startTime: Scalars['Time'];
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType: TimeRegistrationEntryType;
  timeRegistrationPresenceTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInput>;
  timeRegistrationPresenceTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `TimeRegistrationEntryTemplateInput` mutation. */
export type TimeRegistrationEntryTemplateUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationEntryTemplate` in the `UserInput` mutation. */
export type TimeRegistrationEntryTemplateUserIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationEntryTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationEntryTemplateTimeRegistrationEntryTemplatePkeyConnect>>;
  /** A `TimeRegistrationEntryTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationEntryTemplateUserIdForeignConnectionTimeRegistrationEntryTemplateCreateInput>>;
  /** The primary key(s) for `timeRegistrationEntryTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationEntryTemplateTimeRegistrationEntryTemplatePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationEntryTemplate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationEntryTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateUserIdForeignUsingTimeRegistrationEntryTemplatePkeyUpdate>>;
};

/** A connection to a list of `TimeRegistrationEntryTemplate` values. */
export type TimeRegistrationEntryTemplatesConnection = {
  __typename?: 'TimeRegistrationEntryTemplatesConnection';
  /** A list of edges which contains the `TimeRegistrationEntryTemplate` and cursor to aid in pagination. */
  edges: Array<TimeRegistrationEntryTemplatesEdge>;
  /** A list of `TimeRegistrationEntryTemplate` objects. */
  nodes: Array<Maybe<TimeRegistrationEntryTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TimeRegistrationEntryTemplate` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TimeRegistrationEntryTemplate` edge in the connection. */
export type TimeRegistrationEntryTemplatesEdge = {
  __typename?: 'TimeRegistrationEntryTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TimeRegistrationEntryTemplate` at the end of the edge. */
  node?: Maybe<TimeRegistrationEntryTemplate>;
};

/** Methods to use when ordering `TimeRegistrationEntryTemplate`. */
export type TimeRegistrationEntryTemplatesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'END_TIME_ASC'
  | 'END_TIME_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'START_TIME_ASC'
  | 'START_TIME_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__ACTIVE_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__ACTIVE_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__CODE_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__CODE_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__COMPANY_ID_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__COMPANY_ID_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__EMOJI_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__EMOJI_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__ID_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__ID_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__PAID_TIME_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPE_BY_TIME_REGISTRATION_BREAK_TYPE_ID__PAID_TIME_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPE_ID_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPE_ID_DESC'
  | 'TIME_REGISTRATION_ENTRY_TYPE_ASC'
  | 'TIME_REGISTRATION_ENTRY_TYPE_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__ACTIVE_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__ACTIVE_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__COMPANY_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__COMPANY_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__DAY_OF_WEEK_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__DAY_OF_WEEK_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__END_TIME_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__END_TIME_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__START_TIME_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__START_TIME_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__TIME_REGISTRATION_PRESENCE_TYPE_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__TIME_REGISTRATION_PRESENCE_TYPE_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__TIME_REGISTRATION_TEMPLATE_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__TIME_REGISTRATION_TEMPLATE_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__TIME_REGISTRATION_TEMPLATE_WEEK_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__TIME_REGISTRATION_TEMPLATE_WEEK_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__USER_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__USER_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATE_ID_DESC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__ACTIVE_ASC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__ACTIVE_DESC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__CODE_ASC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__CODE_DESC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__COLOR_ASC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__COLOR_DESC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__COMPANY_ID_ASC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__COMPANY_ID_DESC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__DESCRIPTION_TRANSLATED_ENTITY_ID_ASC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__DESCRIPTION_TRANSLATED_ENTITY_ID_DESC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__ID_ASC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__ID_DESC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__LOCALIZED_NAME_ASC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__LOCALIZED_NAME_DESC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'TIME_REGISTRATION_PROJECT_BY_TIME_REGISTRATION_PROJECT_ID__NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'TIME_REGISTRATION_PROJECT_ID_ASC'
  | 'TIME_REGISTRATION_PROJECT_ID_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__ACTIVE_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__ACTIVE_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__COMPANY_ID_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__COMPANY_ID_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__ID_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__ID_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__LOCALIZED_NAME_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__LOCALIZED_NAME_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__USE_MULTI_WEEK_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__USE_MULTI_WEEK_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_ID_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_ID_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** The `timeRegistrationBreakType` to be created by this mutation. */
export type TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignConnectionTimeRegistrationBreakTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  emoji: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  paidTime?: InputMaybe<IntervalInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInput>;
};

/** The `timeRegistrationEntry` to be created by this mutation. */
export type TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignConnectionTimeRegistrationEntryCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  startDate: Scalars['Datetime'];
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInput>;
  timeRegistrationEntryType: TimeRegistrationEntryType;
  timeRegistrationPresence?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `timeRegistrationBreakType` in the `TimeRegistrationEntryInput` mutation. */
export type TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInput = {
  /** The primary key(s) for `timeRegistrationBreakType` for the far side of the relationship. */
  connectById?: InputMaybe<TimeRegistrationBreakTypeTimeRegistrationBreakTypePkeyConnect>;
  /** A `TimeRegistrationBreakTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignConnectionTimeRegistrationBreakTypeCreateInput>;
  /** The primary key(s) for `timeRegistrationBreakType` for the far side of the relationship. */
  deleteById?: InputMaybe<TimeRegistrationBreakTypeTimeRegistrationBreakTypePkeyDelete>;
  /** The primary key(s) and patch data for `timeRegistrationBreakType` for the far side of the relationship. */
  updateById?: InputMaybe<TimeRegistrationBreakTypeOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationBreakTypeIdForeignUsingTimeRegistrationBreakTypePkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationEntry` in the `TimeRegistrationBreakTypeInput` mutation. */
export type TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationEntryTimeRegistrationEntryPkeyConnect>>;
  /** A `TimeRegistrationEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignConnectionTimeRegistrationEntryCreateInput>>;
  /** The primary key(s) for `timeRegistrationEntry` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationEntryTimeRegistrationEntryPkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationEntry` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationBreakTypeIdForeignUsingTimeRegistrationEntryPkeyUpdate>>;
};

/** The fields on `timeRegistrationEntry` to look up the row to connect. */
export type TimeRegistrationEntryTimeRegistrationEntryPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `timeRegistrationEntry` to look up the row to delete. */
export type TimeRegistrationEntryTimeRegistrationEntryPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `timeRegistrationEntry` to be created by this mutation. */
export type TimeRegistrationEntryTimeRegistrationPresenceIdForeignConnectionTimeRegistrationEntryCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  startDate: Scalars['Datetime'];
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType: TimeRegistrationEntryType;
  timeRegistrationPresence?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInput>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `timeRegistrationPresence` to be created by this mutation. */
export type TimeRegistrationEntryTimeRegistrationPresenceIdForeignConnectionTimeRegistrationPresenceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInverseInput>;
  startDate: Scalars['Datetime'];
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  unpaidBreakTime?: InputMaybe<IntervalInput>;
  user?: InputMaybe<TimeRegistrationPresenceUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `timeRegistrationPresence` in the `TimeRegistrationEntryInput` mutation. */
export type TimeRegistrationEntryTimeRegistrationPresenceIdForeignInput = {
  /** The primary key(s) for `timeRegistrationPresence` for the far side of the relationship. */
  connectById?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresencePkeyConnect>;
  /** A `TimeRegistrationPresenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignConnectionTimeRegistrationPresenceCreateInput>;
  /** The primary key(s) for `timeRegistrationPresence` for the far side of the relationship. */
  deleteById?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresencePkeyDelete>;
  /** The primary key(s) and patch data for `timeRegistrationPresence` for the far side of the relationship. */
  updateById?: InputMaybe<TimeRegistrationPresenceOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationPresenceIdForeignUsingTimeRegistrationPresencePkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationEntry` in the `TimeRegistrationPresenceInput` mutation. */
export type TimeRegistrationEntryTimeRegistrationPresenceIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationEntryTimeRegistrationEntryPkeyConnect>>;
  /** A `TimeRegistrationEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationEntryTimeRegistrationPresenceIdForeignConnectionTimeRegistrationEntryCreateInput>>;
  /** The primary key(s) for `timeRegistrationEntry` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationEntryTimeRegistrationEntryPkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationEntry` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationPresenceIdForeignUsingTimeRegistrationEntryPkeyUpdate>>;
};

/** The `timeRegistrationEntry` to be created by this mutation. */
export type TimeRegistrationEntryTimeRegistrationProjectIdForeignConnectionTimeRegistrationEntryCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  startDate: Scalars['Datetime'];
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType: TimeRegistrationEntryType;
  timeRegistrationPresence?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInput>;
  user?: InputMaybe<TimeRegistrationEntryUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `timeRegistrationProject` to be created by this mutation. */
export type TimeRegistrationEntryTimeRegistrationProjectIdForeignConnectionTimeRegistrationProjectCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  color: Scalars['String'];
  company?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  descriptionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInput>;
};

/** Input for the nested mutation of `timeRegistrationProject` in the `TimeRegistrationEntryInput` mutation. */
export type TimeRegistrationEntryTimeRegistrationProjectIdForeignInput = {
  /** The primary key(s) for `timeRegistrationProject` for the far side of the relationship. */
  connectById?: InputMaybe<TimeRegistrationProjectTimeRegistrationProjectPkeyConnect>;
  /** A `TimeRegistrationProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignConnectionTimeRegistrationProjectCreateInput>;
  /** The primary key(s) for `timeRegistrationProject` for the far side of the relationship. */
  deleteById?: InputMaybe<TimeRegistrationProjectTimeRegistrationProjectPkeyDelete>;
  /** The primary key(s) and patch data for `timeRegistrationProject` for the far side of the relationship. */
  updateById?: InputMaybe<TimeRegistrationProjectOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationProjectIdForeignUsingTimeRegistrationProjectPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationEntry` in the `TimeRegistrationProjectInput` mutation. */
export type TimeRegistrationEntryTimeRegistrationProjectIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationEntryTimeRegistrationEntryPkeyConnect>>;
  /** A `TimeRegistrationEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationEntryTimeRegistrationProjectIdForeignConnectionTimeRegistrationEntryCreateInput>>;
  /** The primary key(s) for `timeRegistrationEntry` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationEntryTimeRegistrationEntryPkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationEntry` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationProjectIdForeignUsingTimeRegistrationEntryPkeyUpdate>>;
};

export type TimeRegistrationEntryType =
  /** Taking a break. */
  | 'BREAK'
  /** Working on a project. */
  | 'PROJECT';

/** A filter to be used against TimeRegistrationEntryType fields. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationEntryTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<TimeRegistrationEntryType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<TimeRegistrationEntryType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<TimeRegistrationEntryType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<TimeRegistrationEntryType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<TimeRegistrationEntryType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<TimeRegistrationEntryType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<TimeRegistrationEntryType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<TimeRegistrationEntryType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<TimeRegistrationEntryType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<TimeRegistrationEntryType>>;
};

/** The `timeRegistrationEntry` to be created by this mutation. */
export type TimeRegistrationEntryUserIdForeignConnectionTimeRegistrationEntryCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  startDate: Scalars['Datetime'];
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType: TimeRegistrationEntryType;
  timeRegistrationPresence?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `TimeRegistrationEntryInput` mutation. */
export type TimeRegistrationEntryUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnTimeRegistrationEntryForTimeRegistrationEntryUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationEntry` in the `UserInput` mutation. */
export type TimeRegistrationEntryUserIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationEntry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationEntryTimeRegistrationEntryPkeyConnect>>;
  /** A `TimeRegistrationEntryInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationEntryUserIdForeignConnectionTimeRegistrationEntryCreateInput>>;
  /** The primary key(s) for `timeRegistrationEntry` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationEntryTimeRegistrationEntryPkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationEntry` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationEntry` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryUserIdForeignUsingTimeRegistrationEntryPkeyUpdate>>;
};

export type TimeRegistrationPresence = {
  __typename?: 'TimeRegistrationPresence';
  active: Scalars['Boolean'];
  /** Reads a single `Approval` that is related to this `TimeRegistrationPresence`. */
  approval?: Maybe<Approval>;
  approvalId?: Maybe<Scalars['UUID']>;
  breakSum?: Maybe<Interval>;
  /** Reads a single `Company` that is related to this `TimeRegistrationPresence`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  compliesWithElevenHourRule?: Maybe<Scalars['Boolean']>;
  departmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  elapsedTime?: Maybe<Interval>;
  endDate?: Maybe<Scalars['Datetime']>;
  hasBeenApproved?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  note?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferences: NotificationEmployeeReferencesConnection;
  restTime?: Maybe<Interval>;
  startDate: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `TimeRegistrationEntry`. */
  timeRegistrationEntries: TimeRegistrationEntriesConnection;
  /** Reads a single `TimeRegistrationPresenceType` that is related to this `TimeRegistrationPresence`. */
  timeRegistrationPresenceType?: Maybe<TimeRegistrationPresenceType>;
  timeRegistrationPresenceTypeId: Scalars['UUID'];
  unpaidBreakTime: Interval;
  /** Reads a single `User` that is related to this `TimeRegistrationPresence`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
  weekNumber?: Maybe<Scalars['Int']>;
  weekStartDate?: Maybe<Scalars['Datetime']>;
};


export type TimeRegistrationPresenceNotificationEmployeeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};


export type TimeRegistrationPresenceTimeRegistrationEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationEntryCondition>;
  filter?: InputMaybe<TimeRegistrationEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationEntriesOrderBy>>;
};

/** The `approval` to be created by this mutation. */
export type TimeRegistrationPresenceApprovalIdForeignConnectionApprovalCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  affectedUserDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  affectedUserId?: InputMaybe<Scalars['UUID']>;
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  approvingUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<ApprovalCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  deniedAt?: InputMaybe<Scalars['Datetime']>;
  futureDatum?: InputMaybe<FutureDataApprovalIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isDeletionRequest?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['UUID']>;
  requestingUserId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInverseInput>;
  type: ApprovalType;
  user?: InputMaybe<ApprovalRequestingUserIdForeignInput>;
  vacationUserToApprovalIdUsingId?: InputMaybe<VacationUserApprovalIdForeignInverseInput>;
  vacationUserToDeletionApprovalIdUsingId?: InputMaybe<VacationUserDeletionApprovalIdForeignInverseInput>;
};

/** The `timeRegistrationPresence` to be created by this mutation. */
export type TimeRegistrationPresenceApprovalIdForeignConnectionTimeRegistrationPresenceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInput>;
  company?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInverseInput>;
  startDate: Scalars['Datetime'];
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  unpaidBreakTime?: InputMaybe<IntervalInput>;
  user?: InputMaybe<TimeRegistrationPresenceUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `approval` in the `TimeRegistrationPresenceInput` mutation. */
export type TimeRegistrationPresenceApprovalIdForeignInput = {
  /** The primary key(s) for `approval` for the far side of the relationship. */
  connectById?: InputMaybe<ApprovalApprovalPkeyConnect>;
  /** A `ApprovalInput` object that will be created and connected to this object. */
  create?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignConnectionApprovalCreateInput>;
  /** The primary key(s) and patch data for `approval` for the far side of the relationship. */
  updateById?: InputMaybe<ApprovalOnTimeRegistrationPresenceForTimeRegistrationPresenceApprovalIdForeignUsingApprovalPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationPresence` in the `ApprovalInput` mutation. */
export type TimeRegistrationPresenceApprovalIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationPresence` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationPresenceTimeRegistrationPresencePkeyConnect>>;
  /** A `TimeRegistrationPresenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationPresenceApprovalIdForeignConnectionTimeRegistrationPresenceCreateInput>>;
  /** The primary key(s) for `timeRegistrationPresence` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationPresenceTimeRegistrationPresencePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationPresence` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationPresence` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationPresenceOnTimeRegistrationPresenceForTimeRegistrationPresenceApprovalIdForeignUsingTimeRegistrationPresencePkeyUpdate>>;
};

/** The `timeRegistrationPresence` to be created by this mutation. */
export type TimeRegistrationPresenceCompanyIdForeignConnectionTimeRegistrationPresenceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInput>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInverseInput>;
  startDate: Scalars['Datetime'];
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  unpaidBreakTime?: InputMaybe<IntervalInput>;
  user?: InputMaybe<TimeRegistrationPresenceUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `TimeRegistrationPresenceInput` mutation. */
export type TimeRegistrationPresenceCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnTimeRegistrationPresenceForTimeRegistrationPresenceCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationPresence` in the `CompanyInput` mutation. */
export type TimeRegistrationPresenceCompanyIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationPresence` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationPresenceTimeRegistrationPresencePkeyConnect>>;
  /** A `TimeRegistrationPresenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationPresenceCompanyIdForeignConnectionTimeRegistrationPresenceCreateInput>>;
  /** The primary key(s) for `timeRegistrationPresence` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationPresenceTimeRegistrationPresencePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationPresence` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationPresence` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationPresenceOnTimeRegistrationPresenceForTimeRegistrationPresenceCompanyIdForeignUsingTimeRegistrationPresencePkeyUpdate>>;
};

/**
 * A condition to be used against `TimeRegistrationPresence` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type TimeRegistrationPresenceCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `approvalId` field. */
  approvalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `timeRegistrationPresenceTypeId` field. */
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `unpaidBreakTime` field. */
  unpaidBreakTime?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `TimeRegistrationPresence` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationPresenceFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TimeRegistrationPresenceFilter>>;
  /** Filter by the object’s `approval` relation. */
  approval?: InputMaybe<ApprovalFilter>;
  /** A related `approval` exists. */
  approvalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `approvalId` field. */
  approvalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `breakSum` field. */
  breakSum?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `compliesWithElevenHourRule` field. */
  compliesWithElevenHourRule?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `elapsedTime` field. */
  elapsedTime?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `hasBeenApproved` field. */
  hasBeenApproved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TimeRegistrationPresenceFilter>;
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notificationEmployeeReferences` relation. */
  notificationEmployeeReferences?: InputMaybe<TimeRegistrationPresenceToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferences` exist. */
  notificationEmployeeReferencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TimeRegistrationPresenceFilter>>;
  /** Filter by the object’s `restTime` field. */
  restTime?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `timeRegistrationEntries` relation. */
  timeRegistrationEntries?: InputMaybe<TimeRegistrationPresenceToManyTimeRegistrationEntryFilter>;
  /** Some related `timeRegistrationEntries` exist. */
  timeRegistrationEntriesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationPresenceType` relation. */
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTypeFilter>;
  /** Filter by the object’s `timeRegistrationPresenceTypeId` field. */
  timeRegistrationPresenceTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `unpaidBreakTime` field. */
  unpaidBreakTime?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `weekNumber` field. */
  weekNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `weekStartDate` field. */
  weekStartDate?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `TimeRegistrationPresence` */
export type TimeRegistrationPresenceInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInverseInput>;
  startDate: Scalars['Datetime'];
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  unpaidBreakTime?: InputMaybe<IntervalInput>;
  user?: InputMaybe<TimeRegistrationPresenceUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `timeRegistrationPresence` to look up the row to update. */
export type TimeRegistrationPresenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTimeRegistrationPresenceIdFUsingTimeRegistrationPresencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationPresence` being updated. */
  patch: UpdateTimeRegistrationPresenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTimeRegistrationPresenceIdFPatch;
};

/** The fields on `timeRegistrationPresence` to look up the row to update. */
export type TimeRegistrationPresenceOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationPresenceIdForeignUsingTimeRegistrationPresencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationPresence` being updated. */
  patch: UpdateTimeRegistrationPresenceOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationPresenceIdForeignPatch;
};

/** The fields on `timeRegistrationPresence` to look up the row to update. */
export type TimeRegistrationPresenceOnTimeRegistrationPresenceForTimeRegistrationPresenceApprovalIdForeignUsingTimeRegistrationPresencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationPresence` being updated. */
  patch: UpdateTimeRegistrationPresenceOnTimeRegistrationPresenceForTimeRegistrationPresenceApprovalIdForeignPatch;
};

/** The fields on `timeRegistrationPresence` to look up the row to update. */
export type TimeRegistrationPresenceOnTimeRegistrationPresenceForTimeRegistrationPresenceCompanyIdForeignUsingTimeRegistrationPresencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationPresence` being updated. */
  patch: UpdateTimeRegistrationPresenceOnTimeRegistrationPresenceForTimeRegistrationPresenceCompanyIdForeignPatch;
};

/** The fields on `timeRegistrationPresence` to look up the row to update. */
export type TimeRegistrationPresenceOnTimeRegistrationPresenceForTimeRegistrationPresenceTimeRegistrationPresenceTypeIdFUsingTimeRegistrationPresencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationPresence` being updated. */
  patch: UpdateTimeRegistrationPresenceOnTimeRegistrationPresenceForTimeRegistrationPresenceTimeRegistrationPresenceTypeIdFPatch;
};

/** The fields on `timeRegistrationPresence` to look up the row to update. */
export type TimeRegistrationPresenceOnTimeRegistrationPresenceForTimeRegistrationPresenceUserIdForeignUsingTimeRegistrationPresencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationPresence` being updated. */
  patch: UpdateTimeRegistrationPresenceOnTimeRegistrationPresenceForTimeRegistrationPresenceUserIdForeignPatch;
};

/** Represents an update to a `TimeRegistrationPresence`. Fields that are set will be updated. */
export type TimeRegistrationPresencePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  unpaidBreakTime?: InputMaybe<IntervalInput>;
  user?: InputMaybe<TimeRegistrationPresenceUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type TimeRegistrationPresenceTemplate = {
  __typename?: 'TimeRegistrationPresenceTemplate';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `TimeRegistrationPresenceTemplate`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['Time'];
  id: Scalars['UUID'];
  startTime: Scalars['Time'];
  /** Reads and enables pagination through a set of `TimeRegistrationEntryTemplate`. */
  timeRegistrationEntryTemplates: TimeRegistrationEntryTemplatesConnection;
  /** Reads a single `TimeRegistrationPresenceType` that is related to this `TimeRegistrationPresenceTemplate`. */
  timeRegistrationPresenceType?: Maybe<TimeRegistrationPresenceType>;
  timeRegistrationPresenceTypeId: Scalars['UUID'];
  /** Reads a single `TimeRegistrationTemplate` that is related to this `TimeRegistrationPresenceTemplate`. */
  timeRegistrationTemplate?: Maybe<TimeRegistrationTemplate>;
  timeRegistrationTemplateId?: Maybe<Scalars['UUID']>;
  /** Reads a single `TimeRegistrationTemplateWeek` that is related to this `TimeRegistrationPresenceTemplate`. */
  timeRegistrationTemplateWeek?: Maybe<TimeRegistrationTemplateWeek>;
  timeRegistrationTemplateWeekId?: Maybe<Scalars['UUID']>;
  /** Reads a single `User` that is related to this `TimeRegistrationPresenceTemplate`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};


export type TimeRegistrationPresenceTemplateTimeRegistrationEntryTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationEntryTemplateCondition>;
  filter?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationEntryTemplatesOrderBy>>;
};

/** The `timeRegistrationPresenceTemplate` to be created by this mutation. */
export type TimeRegistrationPresenceTemplateCompanyIdForeignConnectionTimeRegistrationPresenceTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInput>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['Time'];
  id?: InputMaybe<Scalars['UUID']>;
  startTime: Scalars['Time'];
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplateWeek?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInput>;
  timeRegistrationTemplateWeekId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `TimeRegistrationPresenceTemplateInput` mutation. */
export type TimeRegistrationPresenceTemplateCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationPresenceTemplate` in the `CompanyInput` mutation. */
export type TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationPresenceTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationPresenceTemplateTimeRegistrationPresenceTemplatePkeyConnect>>;
  /** A `TimeRegistrationPresenceTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationPresenceTemplateCompanyIdForeignConnectionTimeRegistrationPresenceTemplateCreateInput>>;
  /** The primary key(s) for `timeRegistrationPresenceTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationPresenceTemplateTimeRegistrationPresenceTemplatePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationPresenceTemplate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationPresenceTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateCompanyIdForeignUsingTimeRegistrationPresenceTemplatePkeyUpdate>>;
};

/**
 * A condition to be used against `TimeRegistrationPresenceTemplate` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type TimeRegistrationPresenceTemplateCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `dayOfWeek` field. */
  dayOfWeek?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `endTime` field. */
  endTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `timeRegistrationPresenceTypeId` field. */
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeRegistrationTemplateId` field. */
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeRegistrationTemplateWeekId` field. */
  timeRegistrationTemplateWeekId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `TimeRegistrationPresenceTemplate` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationPresenceTemplateFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TimeRegistrationPresenceTemplateFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `dayOfWeek` field. */
  dayOfWeek?: InputMaybe<IntFilter>;
  /** Filter by the object’s `endTime` field. */
  endTime?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TimeRegistrationPresenceTemplateFilter>>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `timeRegistrationEntryTemplates` relation. */
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationPresenceTemplateToManyTimeRegistrationEntryTemplateFilter>;
  /** Some related `timeRegistrationEntryTemplates` exist. */
  timeRegistrationEntryTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationPresenceType` relation. */
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTypeFilter>;
  /** Filter by the object’s `timeRegistrationPresenceTypeId` field. */
  timeRegistrationPresenceTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `timeRegistrationTemplate` relation. */
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationTemplateFilter>;
  /** A related `timeRegistrationTemplate` exists. */
  timeRegistrationTemplateExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationTemplateId` field. */
  timeRegistrationTemplateId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `timeRegistrationTemplateWeek` relation. */
  timeRegistrationTemplateWeek?: InputMaybe<TimeRegistrationTemplateWeekFilter>;
  /** A related `timeRegistrationTemplateWeek` exists. */
  timeRegistrationTemplateWeekExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationTemplateWeekId` field. */
  timeRegistrationTemplateWeekId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `TimeRegistrationPresenceTemplate` */
export type TimeRegistrationPresenceTemplateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['Time'];
  id?: InputMaybe<Scalars['UUID']>;
  startTime: Scalars['Time'];
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplateWeek?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInput>;
  timeRegistrationTemplateWeekId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `timeRegistrationPresenceTemplate` to look up the row to update. */
export type TimeRegistrationPresenceTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationPresenceTemUsingTimeRegistrationPresenceTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationPresenceTemplate` being updated. */
  patch: UpdateTimeRegistrationPresenceTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationPresenceTemPatch;
};

/** The fields on `timeRegistrationPresenceTemplate` to look up the row to update. */
export type TimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateCompanyIdForeignUsingTimeRegistrationPresenceTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationPresenceTemplate` being updated. */
  patch: UpdateTimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateCompanyIdForeignPatch;
};

/** The fields on `timeRegistrationPresenceTemplate` to look up the row to update. */
export type TimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateTimeRegistrationPresenceUsingTimeRegistrationPresenceTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationPresenceTemplate` being updated. */
  patch: UpdateTimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateTimeRegistrationPresencePatch;
};

/** The fields on `timeRegistrationPresenceTemplate` to look up the row to update. */
export type TimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateTimeRegistrationTemplateUsingTimeRegistrationPresenceTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationPresenceTemplate` being updated. */
  patch: UpdateTimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateTimeRegistrationTemplatePatch;
};

/** The fields on `timeRegistrationPresenceTemplate` to look up the row to update. */
export type TimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateUserIdForeignUsingTimeRegistrationPresenceTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationPresenceTemplate` being updated. */
  patch: UpdateTimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateUserIdForeignPatch;
};

/** The fields on `timeRegistrationPresenceTemplate` to look up the row to update. */
export type TimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTrptTimeRegistrationTemplateWeekIdForeignUsingTimeRegistrationPresenceTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationPresenceTemplate` being updated. */
  patch: UpdateTimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTrptTimeRegistrationTemplateWeekIdForeignPatch;
};

/** Represents an update to a `TimeRegistrationPresenceTemplate`. Fields that are set will be updated. */
export type TimeRegistrationPresenceTemplatePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dayOfWeek?: InputMaybe<Scalars['Int']>;
  endTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['UUID']>;
  startTime?: InputMaybe<Scalars['Time']>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplateWeek?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInput>;
  timeRegistrationTemplateWeekId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `timeRegistrationPresenceTemplate` to be created by this mutation. */
export type TimeRegistrationPresenceTemplateTimeRegistrationPresenceConnectionTimeRegistrationPresenceTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['Time'];
  id?: InputMaybe<Scalars['UUID']>;
  startTime: Scalars['Time'];
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInput>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplateWeek?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInput>;
  timeRegistrationTemplateWeekId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `timeRegistrationPresenceType` to be created by this mutation. */
export type TimeRegistrationPresenceTemplateTimeRegistrationPresenceConnectionTimeRegistrationPresenceTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  emoji: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInput>;
};

/** Input for the nested mutation of `timeRegistrationPresenceType` in the `TimeRegistrationPresenceTemplateInput` mutation. */
export type TimeRegistrationPresenceTemplateTimeRegistrationPresenceInput = {
  /** The primary key(s) for `timeRegistrationPresenceType` for the far side of the relationship. */
  connectById?: InputMaybe<TimeRegistrationPresenceTypeTimeRegistrationPresenceTypePkeyConnect>;
  /** A `TimeRegistrationPresenceTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceConnectionTimeRegistrationPresenceTypeCreateInput>;
  /** The primary key(s) for `timeRegistrationPresenceType` for the far side of the relationship. */
  deleteById?: InputMaybe<TimeRegistrationPresenceTypeTimeRegistrationPresenceTypePkeyDelete>;
  /** The primary key(s) and patch data for `timeRegistrationPresenceType` for the far side of the relationship. */
  updateById?: InputMaybe<TimeRegistrationPresenceTypeOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateTimeRegistrationPresenceUsingTimeRegistrationPresenceTypePkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationPresenceTemplate` in the `TimeRegistrationPresenceTypeInput` mutation. */
export type TimeRegistrationPresenceTemplateTimeRegistrationPresenceInverseInput = {
  /** The primary key(s) for `timeRegistrationPresenceTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationPresenceTemplateTimeRegistrationPresenceTemplatePkeyConnect>>;
  /** A `TimeRegistrationPresenceTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationPresenceTemplateTimeRegistrationPresenceConnectionTimeRegistrationPresenceTemplateCreateInput>>;
  /** The primary key(s) for `timeRegistrationPresenceTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationPresenceTemplateTimeRegistrationPresenceTemplatePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationPresenceTemplate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationPresenceTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateTimeRegistrationPresenceUsingTimeRegistrationPresenceTemplatePkeyUpdate>>;
};

/** The fields on `timeRegistrationPresenceTemplate` to look up the row to connect. */
export type TimeRegistrationPresenceTemplateTimeRegistrationPresenceTemplatePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `timeRegistrationPresenceTemplate` to look up the row to delete. */
export type TimeRegistrationPresenceTemplateTimeRegistrationPresenceTemplatePkeyDelete = {
  id: Scalars['UUID'];
};

/** The `timeRegistrationPresenceTemplate` to be created by this mutation. */
export type TimeRegistrationPresenceTemplateTimeRegistrationTemplateConnectionTimeRegistrationPresenceTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['Time'];
  id?: InputMaybe<Scalars['UUID']>;
  startTime: Scalars['Time'];
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInput>;
  timeRegistrationTemplateWeek?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInput>;
  timeRegistrationTemplateWeekId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `timeRegistrationTemplate` to be created by this mutation. */
export type TimeRegistrationPresenceTemplateTimeRegistrationTemplateConnectionTimeRegistrationTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInput>;
  useMultiWeek?: InputMaybe<Scalars['Boolean']>;
  users?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInverseInput>;
};

/** Input for the nested mutation of `timeRegistrationTemplate` in the `TimeRegistrationPresenceTemplateInput` mutation. */
export type TimeRegistrationPresenceTemplateTimeRegistrationTemplateInput = {
  /** The primary key(s) for `timeRegistrationTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<TimeRegistrationTemplateTimeRegistrationTemplatePkeyConnect>;
  /** A `TimeRegistrationTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateConnectionTimeRegistrationTemplateCreateInput>;
  /** The primary key(s) for `timeRegistrationTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<TimeRegistrationTemplateTimeRegistrationTemplatePkeyDelete>;
  /** The primary key(s) and patch data for `timeRegistrationTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<TimeRegistrationTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateTimeRegistrationTemplateUsingTimeRegistrationTemplatePkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationPresenceTemplate` in the `TimeRegistrationTemplateInput` mutation. */
export type TimeRegistrationPresenceTemplateTimeRegistrationTemplateInverseInput = {
  /** The primary key(s) for `timeRegistrationPresenceTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationPresenceTemplateTimeRegistrationPresenceTemplatePkeyConnect>>;
  /** A `TimeRegistrationPresenceTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationPresenceTemplateTimeRegistrationTemplateConnectionTimeRegistrationPresenceTemplateCreateInput>>;
  /** The primary key(s) for `timeRegistrationPresenceTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationPresenceTemplateTimeRegistrationPresenceTemplatePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationPresenceTemplate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationPresenceTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateTimeRegistrationTemplateUsingTimeRegistrationPresenceTemplatePkeyUpdate>>;
};

/** A filter to be used against many `TimeRegistrationEntryTemplate` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationPresenceTemplateToManyTimeRegistrationEntryTemplateFilter = {
  /** Every related `TimeRegistrationEntryTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  /** No related `TimeRegistrationEntryTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  /** Some related `TimeRegistrationEntryTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
};

/** The `timeRegistrationPresenceTemplate` to be created by this mutation. */
export type TimeRegistrationPresenceTemplateUserIdForeignConnectionTimeRegistrationPresenceTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['Time'];
  id?: InputMaybe<Scalars['UUID']>;
  startTime: Scalars['Time'];
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplateWeek?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInput>;
  timeRegistrationTemplateWeekId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `TimeRegistrationPresenceTemplateInput` mutation. */
export type TimeRegistrationPresenceTemplateUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationPresenceTemplate` in the `UserInput` mutation. */
export type TimeRegistrationPresenceTemplateUserIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationPresenceTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationPresenceTemplateTimeRegistrationPresenceTemplatePkeyConnect>>;
  /** A `TimeRegistrationPresenceTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationPresenceTemplateUserIdForeignConnectionTimeRegistrationPresenceTemplateCreateInput>>;
  /** The primary key(s) for `timeRegistrationPresenceTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationPresenceTemplateTimeRegistrationPresenceTemplatePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationPresenceTemplate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationPresenceTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateUserIdForeignUsingTimeRegistrationPresenceTemplatePkeyUpdate>>;
};

/** A connection to a list of `TimeRegistrationPresenceTemplate` values. */
export type TimeRegistrationPresenceTemplatesConnection = {
  __typename?: 'TimeRegistrationPresenceTemplatesConnection';
  /** A list of edges which contains the `TimeRegistrationPresenceTemplate` and cursor to aid in pagination. */
  edges: Array<TimeRegistrationPresenceTemplatesEdge>;
  /** A list of `TimeRegistrationPresenceTemplate` objects. */
  nodes: Array<Maybe<TimeRegistrationPresenceTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TimeRegistrationPresenceTemplate` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TimeRegistrationPresenceTemplate` edge in the connection. */
export type TimeRegistrationPresenceTemplatesEdge = {
  __typename?: 'TimeRegistrationPresenceTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TimeRegistrationPresenceTemplate` at the end of the edge. */
  node?: Maybe<TimeRegistrationPresenceTemplate>;
};

/** Methods to use when ordering `TimeRegistrationPresenceTemplate`. */
export type TimeRegistrationPresenceTemplatesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DAY_OF_WEEK_ASC'
  | 'DAY_OF_WEEK_DESC'
  | 'END_TIME_ASC'
  | 'END_TIME_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'START_TIME_ASC'
  | 'START_TIME_DESC'
  | 'TIME_REGISTRATION_ENTRY_TEMPLATES_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_ENTRY_TEMPLATES_BY_TIME_REGISTRATION_PRESENCE_TEMPLATE_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__ACTIVE_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__ACTIVE_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__CODE_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__CODE_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__COMPANY_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__COMPANY_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__EMOJI_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__EMOJI_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_ID_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__ACTIVE_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__ACTIVE_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__COMPANY_ID_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__COMPANY_ID_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__ID_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__ID_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__LOCALIZED_NAME_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__LOCALIZED_NAME_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__USE_MULTI_WEEK_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__USE_MULTI_WEEK_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_ID_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_ID_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEK_BY_TIME_REGISTRATION_TEMPLATE_WEEK_ID__ACTIVE_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEK_BY_TIME_REGISTRATION_TEMPLATE_WEEK_ID__ACTIVE_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEK_BY_TIME_REGISTRATION_TEMPLATE_WEEK_ID__COMPANY_ID_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEK_BY_TIME_REGISTRATION_TEMPLATE_WEEK_ID__COMPANY_ID_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEK_BY_TIME_REGISTRATION_TEMPLATE_WEEK_ID__CURRENTLY_RUNNING_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEK_BY_TIME_REGISTRATION_TEMPLATE_WEEK_ID__CURRENTLY_RUNNING_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEK_BY_TIME_REGISTRATION_TEMPLATE_WEEK_ID__ID_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEK_BY_TIME_REGISTRATION_TEMPLATE_WEEK_ID__ID_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEK_BY_TIME_REGISTRATION_TEMPLATE_WEEK_ID__TIME_REGISTRATION_TEMPLATE_ID_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEK_BY_TIME_REGISTRATION_TEMPLATE_WEEK_ID__TIME_REGISTRATION_TEMPLATE_ID_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEK_BY_TIME_REGISTRATION_TEMPLATE_WEEK_ID__USER_ID_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEK_BY_TIME_REGISTRATION_TEMPLATE_WEEK_ID__USER_ID_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEK_BY_TIME_REGISTRATION_TEMPLATE_WEEK_ID__WEEK_INDEX_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEK_BY_TIME_REGISTRATION_TEMPLATE_WEEK_ID__WEEK_INDEX_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEK_ID_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEK_ID_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** The fields on `timeRegistrationPresence` to look up the row to connect. */
export type TimeRegistrationPresenceTimeRegistrationPresencePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `timeRegistrationPresence` to look up the row to delete. */
export type TimeRegistrationPresenceTimeRegistrationPresencePkeyDelete = {
  id: Scalars['UUID'];
};

/** The `timeRegistrationPresence` to be created by this mutation. */
export type TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFConnectionTimeRegistrationPresenceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInverseInput>;
  startDate: Scalars['Datetime'];
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInput>;
  unpaidBreakTime?: InputMaybe<IntervalInput>;
  user?: InputMaybe<TimeRegistrationPresenceUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `timeRegistrationPresenceType` to be created by this mutation. */
export type TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFConnectionTimeRegistrationPresenceTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  emoji: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInput>;
};

/** Input for the nested mutation of `timeRegistrationPresenceType` in the `TimeRegistrationPresenceInput` mutation. */
export type TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInput = {
  /** The primary key(s) for `timeRegistrationPresenceType` for the far side of the relationship. */
  connectById?: InputMaybe<TimeRegistrationPresenceTypeTimeRegistrationPresenceTypePkeyConnect>;
  /** A `TimeRegistrationPresenceTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFConnectionTimeRegistrationPresenceTypeCreateInput>;
  /** The primary key(s) for `timeRegistrationPresenceType` for the far side of the relationship. */
  deleteById?: InputMaybe<TimeRegistrationPresenceTypeTimeRegistrationPresenceTypePkeyDelete>;
  /** The primary key(s) and patch data for `timeRegistrationPresenceType` for the far side of the relationship. */
  updateById?: InputMaybe<TimeRegistrationPresenceTypeOnTimeRegistrationPresenceForTimeRegistrationPresenceTimeRegistrationPresenceTypeIdFUsingTimeRegistrationPresenceTypePkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationPresence` in the `TimeRegistrationPresenceTypeInput` mutation. */
export type TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInverseInput = {
  /** The primary key(s) for `timeRegistrationPresence` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationPresenceTimeRegistrationPresencePkeyConnect>>;
  /** A `TimeRegistrationPresenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFConnectionTimeRegistrationPresenceCreateInput>>;
  /** The primary key(s) for `timeRegistrationPresence` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationPresenceTimeRegistrationPresencePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationPresence` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationPresence` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationPresenceOnTimeRegistrationPresenceForTimeRegistrationPresenceTimeRegistrationPresenceTypeIdFUsingTimeRegistrationPresencePkeyUpdate>>;
};

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationPresenceToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

/** A filter to be used against many `TimeRegistrationEntry` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationPresenceToManyTimeRegistrationEntryFilter = {
  /** Every related `TimeRegistrationEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationEntryFilter>;
  /** No related `TimeRegistrationEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationEntryFilter>;
  /** Some related `TimeRegistrationEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationEntryFilter>;
};

export type TimeRegistrationPresenceType = {
  __typename?: 'TimeRegistrationPresenceType';
  active: Scalars['Boolean'];
  code?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationPresenceType`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  emoji: Scalars['String'];
  id: Scalars['UUID'];
  localizedName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationPresenceType`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  nameTranslatedEntityId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `TimeRegistrationPresenceTemplate`. */
  timeRegistrationPresenceTemplates: TimeRegistrationPresenceTemplatesConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationPresence`. */
  timeRegistrationPresences: TimeRegistrationPresencesConnection;
};


export type TimeRegistrationPresenceTypeTimeRegistrationPresenceTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationPresenceTemplateCondition>;
  filter?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationPresenceTemplatesOrderBy>>;
};


export type TimeRegistrationPresenceTypeTimeRegistrationPresencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationPresenceCondition>;
  filter?: InputMaybe<TimeRegistrationPresenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationPresencesOrderBy>>;
};

/** The `timeRegistrationPresenceType` to be created by this mutation. */
export type TimeRegistrationPresenceTypeCompanyIdForeignConnectionTimeRegistrationPresenceTypeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInput>;
  emoji: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInput>;
};

/** Input for the nested mutation of `company` in the `TimeRegistrationPresenceTypeInput` mutation. */
export type TimeRegistrationPresenceTypeCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnTimeRegistrationPresenceTypeForTimeRegistrationPresenceTypeCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationPresenceType` in the `CompanyInput` mutation. */
export type TimeRegistrationPresenceTypeCompanyIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationPresenceType` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationPresenceTypeTimeRegistrationPresenceTypePkeyConnect>>;
  /** A `TimeRegistrationPresenceTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationPresenceTypeCompanyIdForeignConnectionTimeRegistrationPresenceTypeCreateInput>>;
  /** The primary key(s) for `timeRegistrationPresenceType` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationPresenceTypeTimeRegistrationPresenceTypePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationPresenceType` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationPresenceType` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationPresenceTypeOnTimeRegistrationPresenceTypeForTimeRegistrationPresenceTypeCompanyIdForeignUsingTimeRegistrationPresenceTypePkeyUpdate>>;
};

/**
 * A condition to be used against `TimeRegistrationPresenceType` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type TimeRegistrationPresenceTypeCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `emoji` field. */
  emoji?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameTranslatedEntityId` field. */
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `TimeRegistrationPresenceType` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationPresenceTypeFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TimeRegistrationPresenceTypeFilter>>;
  /** Filter by the object’s `code` field. */
  code?: InputMaybe<StringFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `emoji` field. */
  emoji?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameTranslatedEntity` relation. */
  nameTranslatedEntity?: InputMaybe<TranslatedEntityFilter>;
  /** Filter by the object’s `nameTranslatedEntityId` field. */
  nameTranslatedEntityId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TimeRegistrationPresenceTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TimeRegistrationPresenceTypeFilter>>;
  /** Filter by the object’s `timeRegistrationPresenceTemplates` relation. */
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTypeToManyTimeRegistrationPresenceTemplateFilter>;
  /** Some related `timeRegistrationPresenceTemplates` exist. */
  timeRegistrationPresenceTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationPresences` relation. */
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceTypeToManyTimeRegistrationPresenceFilter>;
  /** Some related `timeRegistrationPresences` exist. */
  timeRegistrationPresencesExist?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `TimeRegistrationPresenceType` */
export type TimeRegistrationPresenceTypeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  emoji: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInput>;
};

/** Input for the nested mutation of `translatedEntity` in the `TimeRegistrationPresenceTypeInput` mutation. */
export type TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInput = {
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  connectById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyConnect>;
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  deleteById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyDelete>;
  /** The primary key(s) and patch data for `translatedEntity` for the far side of the relationship. */
  updateById?: InputMaybe<TranslatedEntityOnTimeRegistrationPresenceTypeForTimeRegistrationPresenceTypeNameTranslatedEntityIdForeiUsingTranslatedEntityPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationPresenceType` in the `TranslatedEntityInput` mutation. */
export type TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInverseInput = {
  /** The primary key(s) for `timeRegistrationPresenceType` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationPresenceTypeTimeRegistrationPresenceTypePkeyConnect>>;
  /** The primary key(s) for `timeRegistrationPresenceType` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationPresenceTypeTimeRegistrationPresenceTypePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationPresenceType` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationPresenceType` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationPresenceTypeOnTimeRegistrationPresenceTypeForTimeRegistrationPresenceTypeNameTranslatedEntityIdForeiUsingTimeRegistrationPresenceTypePkeyUpdate>>;
};

/** The fields on `timeRegistrationPresenceType` to look up the row to update. */
export type TimeRegistrationPresenceTypeOnTimeRegistrationPresenceForTimeRegistrationPresenceTimeRegistrationPresenceTypeIdFUsingTimeRegistrationPresenceTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationPresenceType` being updated. */
  patch: UpdateTimeRegistrationPresenceTypeOnTimeRegistrationPresenceForTimeRegistrationPresenceTimeRegistrationPresenceTypeIdFPatch;
};

/** The fields on `timeRegistrationPresenceType` to look up the row to update. */
export type TimeRegistrationPresenceTypeOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateTimeRegistrationPresenceUsingTimeRegistrationPresenceTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationPresenceType` being updated. */
  patch: UpdateTimeRegistrationPresenceTypeOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateTimeRegistrationPresencePatch;
};

/** The fields on `timeRegistrationPresenceType` to look up the row to update. */
export type TimeRegistrationPresenceTypeOnTimeRegistrationPresenceTypeForTimeRegistrationPresenceTypeCompanyIdForeignUsingTimeRegistrationPresenceTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationPresenceType` being updated. */
  patch: UpdateTimeRegistrationPresenceTypeOnTimeRegistrationPresenceTypeForTimeRegistrationPresenceTypeCompanyIdForeignPatch;
};

/** The fields on `timeRegistrationPresenceType` to look up the row to update. */
export type TimeRegistrationPresenceTypeOnTimeRegistrationPresenceTypeForTimeRegistrationPresenceTypeNameTranslatedEntityIdForeiUsingTimeRegistrationPresenceTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationPresenceType` being updated. */
  patch: UpdateTimeRegistrationPresenceTypeOnTimeRegistrationPresenceTypeForTimeRegistrationPresenceTypeNameTranslatedEntityIdForeiPatch;
};

/** Represents an update to a `TimeRegistrationPresenceType`. Fields that are set will be updated. */
export type TimeRegistrationPresenceTypePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInput>;
};

/** The fields on `timeRegistrationPresenceType` to look up the row to connect. */
export type TimeRegistrationPresenceTypeTimeRegistrationPresenceTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `timeRegistrationPresenceType` to look up the row to delete. */
export type TimeRegistrationPresenceTypeTimeRegistrationPresenceTypePkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `TimeRegistrationPresence` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationPresenceTypeToManyTimeRegistrationPresenceFilter = {
  /** Every related `TimeRegistrationPresence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationPresenceFilter>;
  /** No related `TimeRegistrationPresence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationPresenceFilter>;
  /** Some related `TimeRegistrationPresence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationPresenceFilter>;
};

/** A filter to be used against many `TimeRegistrationPresenceTemplate` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationPresenceTypeToManyTimeRegistrationPresenceTemplateFilter = {
  /** Every related `TimeRegistrationPresenceTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
  /** No related `TimeRegistrationPresenceTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
  /** Some related `TimeRegistrationPresenceTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
};

/** A connection to a list of `TimeRegistrationPresenceType` values. */
export type TimeRegistrationPresenceTypesConnection = {
  __typename?: 'TimeRegistrationPresenceTypesConnection';
  /** A list of edges which contains the `TimeRegistrationPresenceType` and cursor to aid in pagination. */
  edges: Array<TimeRegistrationPresenceTypesEdge>;
  /** A list of `TimeRegistrationPresenceType` objects. */
  nodes: Array<Maybe<TimeRegistrationPresenceType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TimeRegistrationPresenceType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TimeRegistrationPresenceType` edge in the connection. */
export type TimeRegistrationPresenceTypesEdge = {
  __typename?: 'TimeRegistrationPresenceTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TimeRegistrationPresenceType` at the end of the edge. */
  node?: Maybe<TimeRegistrationPresenceType>;
};

/** Methods to use when ordering `TimeRegistrationPresenceType`. */
export type TimeRegistrationPresenceTypesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'CODE_ASC'
  | 'CODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'EMOJI_ASC'
  | 'EMOJI_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALIZED_NAME_ASC'
  | 'LOCALIZED_NAME_DESC'
  | 'NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIME_REGISTRATION_PRESENCES_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_PRESENCES_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATES_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATES_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__COUNT_DESC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__COMPANY_ID_ASC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__COMPANY_ID_DESC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__ID_ASC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__ID_DESC';

/** The `timeRegistrationPresence` to be created by this mutation. */
export type TimeRegistrationPresenceUserIdForeignConnectionTimeRegistrationPresenceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInverseInput>;
  startDate: Scalars['Datetime'];
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  unpaidBreakTime?: InputMaybe<IntervalInput>;
  user?: InputMaybe<TimeRegistrationPresenceUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `TimeRegistrationPresenceInput` mutation. */
export type TimeRegistrationPresenceUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnTimeRegistrationPresenceForTimeRegistrationPresenceUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationPresence` in the `UserInput` mutation. */
export type TimeRegistrationPresenceUserIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationPresence` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationPresenceTimeRegistrationPresencePkeyConnect>>;
  /** A `TimeRegistrationPresenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationPresenceUserIdForeignConnectionTimeRegistrationPresenceCreateInput>>;
  /** The primary key(s) for `timeRegistrationPresence` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationPresenceTimeRegistrationPresencePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationPresence` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationPresence` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationPresenceOnTimeRegistrationPresenceForTimeRegistrationPresenceUserIdForeignUsingTimeRegistrationPresencePkeyUpdate>>;
};

/** A connection to a list of `TimeRegistrationPresence` values. */
export type TimeRegistrationPresencesConnection = {
  __typename?: 'TimeRegistrationPresencesConnection';
  /** A list of edges which contains the `TimeRegistrationPresence` and cursor to aid in pagination. */
  edges: Array<TimeRegistrationPresencesEdge>;
  /** A list of `TimeRegistrationPresence` objects. */
  nodes: Array<Maybe<TimeRegistrationPresence>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TimeRegistrationPresence` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TimeRegistrationPresence` edge in the connection. */
export type TimeRegistrationPresencesEdge = {
  __typename?: 'TimeRegistrationPresencesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TimeRegistrationPresence` at the end of the edge. */
  node?: Maybe<TimeRegistrationPresence>;
};

/** Methods to use when ordering `TimeRegistrationPresence`. */
export type TimeRegistrationPresencesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__ACTIVE_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__ACTIVE_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__AFFECTED_USER_DEPARTMENT_IDS_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__AFFECTED_USER_DEPARTMENT_IDS_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__AFFECTED_USER_ID_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__AFFECTED_USER_ID_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__APPROVED_AT_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__APPROVED_AT_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__APPROVING_USER_ID_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__APPROVING_USER_ID_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__COMPANY_ID_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__COMPANY_ID_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__CREATED_AT_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__CREATED_AT_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__DEADLINE_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__DEADLINE_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__DENIED_AT_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__DENIED_AT_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__ID_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__ID_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__IS_DELETION_REQUEST_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__IS_DELETION_REQUEST_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__ITEM_ID_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__ITEM_ID_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__REQUESTING_USER_ID_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__REQUESTING_USER_ID_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__TYPE_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__TYPE_DESC'
  | 'APPROVAL_ID_ASC'
  | 'APPROVAL_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'END_DATE_ASC'
  | 'END_DATE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'NOTE_ASC'
  | 'NOTE_DESC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_TIME_REGISTRATION_PRESENCE_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_TIME_REGISTRATION_PRESENCE_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'START_DATE_ASC'
  | 'START_DATE_DESC'
  | 'TIME_REGISTRATION_ENTRIES_BY_TIME_REGISTRATION_PRESENCE_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_ENTRIES_BY_TIME_REGISTRATION_PRESENCE_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__ACTIVE_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__ACTIVE_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__CODE_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__CODE_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__COMPANY_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__COMPANY_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__EMOJI_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__EMOJI_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_BY_TIME_REGISTRATION_PRESENCE_TYPE_ID__NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_ID_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TYPE_ID_DESC'
  | 'UNPAID_BREAK_TIME_ASC'
  | 'UNPAID_BREAK_TIME_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type TimeRegistrationProject = {
  __typename?: 'TimeRegistrationProject';
  active: Scalars['Boolean'];
  code?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  /** Reads a single `Company` that is related to this `TimeRegistrationProject`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  description?: Maybe<Scalars['String']>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationProject`. */
  descriptionTranslatedEntity?: Maybe<TranslatedEntity>;
  descriptionTranslatedEntityId: Scalars['UUID'];
  id: Scalars['UUID'];
  localizedDescription?: Maybe<Scalars['String']>;
  localizedName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationProject`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  nameTranslatedEntityId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `TimeRegistrationEntry`. */
  timeRegistrationEntries: TimeRegistrationEntriesConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationEntryTemplate`. */
  timeRegistrationEntryTemplates: TimeRegistrationEntryTemplatesConnection;
};


export type TimeRegistrationProjectTimeRegistrationEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationEntryCondition>;
  filter?: InputMaybe<TimeRegistrationEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationEntriesOrderBy>>;
};


export type TimeRegistrationProjectTimeRegistrationEntryTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationEntryTemplateCondition>;
  filter?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationEntryTemplatesOrderBy>>;
};

/** The `timeRegistrationProject` to be created by this mutation. */
export type TimeRegistrationProjectCompanyIdForeignConnectionTimeRegistrationProjectCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  color: Scalars['String'];
  company?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInput>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  descriptionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInput>;
};

/** Input for the nested mutation of `company` in the `TimeRegistrationProjectInput` mutation. */
export type TimeRegistrationProjectCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnTimeRegistrationProjectForTimeRegistrationProjectCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationProject` in the `CompanyInput` mutation. */
export type TimeRegistrationProjectCompanyIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationProject` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationProjectTimeRegistrationProjectPkeyConnect>>;
  /** A `TimeRegistrationProjectInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationProjectCompanyIdForeignConnectionTimeRegistrationProjectCreateInput>>;
  /** The primary key(s) for `timeRegistrationProject` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationProjectTimeRegistrationProjectPkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationProject` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationProject` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationProjectOnTimeRegistrationProjectForTimeRegistrationProjectCompanyIdForeignUsingTimeRegistrationProjectPkeyUpdate>>;
};

/**
 * A condition to be used against `TimeRegistrationProject` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type TimeRegistrationProjectCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `color` field. */
  color?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `descriptionTranslatedEntityId` field. */
  descriptionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameTranslatedEntityId` field. */
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `translatedEntity` in the `TimeRegistrationProjectInput` mutation. */
export type TimeRegistrationProjectDescriptionTranslatedEntityIdForeInput = {
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  connectById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyConnect>;
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  deleteById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyDelete>;
  /** The primary key(s) and patch data for `translatedEntity` for the far side of the relationship. */
  updateById?: InputMaybe<TranslatedEntityOnTimeRegistrationProjectForTimeRegistrationProjectDescriptionTranslatedEntityIdForeUsingTranslatedEntityPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationProject` in the `TranslatedEntityInput` mutation. */
export type TimeRegistrationProjectDescriptionTranslatedEntityIdForeInverseInput = {
  /** The primary key(s) for `timeRegistrationProject` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationProjectTimeRegistrationProjectPkeyConnect>>;
  /** The primary key(s) for `timeRegistrationProject` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationProjectTimeRegistrationProjectPkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationProject` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationProject` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationProjectOnTimeRegistrationProjectForTimeRegistrationProjectDescriptionTranslatedEntityIdForeUsingTimeRegistrationProjectPkeyUpdate>>;
};

/** A filter to be used against `TimeRegistrationProject` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationProjectFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TimeRegistrationProjectFilter>>;
  /** Filter by the object’s `code` field. */
  code?: InputMaybe<StringFilter>;
  /** Filter by the object’s `color` field. */
  color?: InputMaybe<StringFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `descriptionTranslatedEntity` relation. */
  descriptionTranslatedEntity?: InputMaybe<TranslatedEntityFilter>;
  /** Filter by the object’s `descriptionTranslatedEntityId` field. */
  descriptionTranslatedEntityId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedDescription` field. */
  localizedDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameTranslatedEntity` relation. */
  nameTranslatedEntity?: InputMaybe<TranslatedEntityFilter>;
  /** Filter by the object’s `nameTranslatedEntityId` field. */
  nameTranslatedEntityId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TimeRegistrationProjectFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TimeRegistrationProjectFilter>>;
  /** Filter by the object’s `timeRegistrationEntries` relation. */
  timeRegistrationEntries?: InputMaybe<TimeRegistrationProjectToManyTimeRegistrationEntryFilter>;
  /** Some related `timeRegistrationEntries` exist. */
  timeRegistrationEntriesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationEntryTemplates` relation. */
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationProjectToManyTimeRegistrationEntryTemplateFilter>;
  /** Some related `timeRegistrationEntryTemplates` exist. */
  timeRegistrationEntryTemplatesExist?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `TimeRegistrationProject` */
export type TimeRegistrationProjectInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  color: Scalars['String'];
  company?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  descriptionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInput>;
};

/** Input for the nested mutation of `timeRegistrationProject` in the `TranslatedEntityInput` mutation. */
export type TimeRegistrationProjectNameTranslatedEntityIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationProject` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationProjectTimeRegistrationProjectPkeyConnect>>;
  /** The primary key(s) for `timeRegistrationProject` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationProjectTimeRegistrationProjectPkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationProject` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationProject` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationProjectOnTimeRegistrationProjectForTimeRegistrationProjectNameTranslatedEntityIdForeignUsingTimeRegistrationProjectPkeyUpdate>>;
};

/** The fields on `timeRegistrationProject` to look up the row to update. */
export type TimeRegistrationProjectOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationProjectIdForeignUsingTimeRegistrationProjectPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationProject` being updated. */
  patch: UpdateTimeRegistrationProjectOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationProjectIdForeignPatch;
};

/** The fields on `timeRegistrationProject` to look up the row to update. */
export type TimeRegistrationProjectOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationProjectIdFUsingTimeRegistrationProjectPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationProject` being updated. */
  patch: UpdateTimeRegistrationProjectOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationProjectIdFPatch;
};

/** The fields on `timeRegistrationProject` to look up the row to update. */
export type TimeRegistrationProjectOnTimeRegistrationProjectForTimeRegistrationProjectCompanyIdForeignUsingTimeRegistrationProjectPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationProject` being updated. */
  patch: UpdateTimeRegistrationProjectOnTimeRegistrationProjectForTimeRegistrationProjectCompanyIdForeignPatch;
};

/** The fields on `timeRegistrationProject` to look up the row to update. */
export type TimeRegistrationProjectOnTimeRegistrationProjectForTimeRegistrationProjectDescriptionTranslatedEntityIdForeUsingTimeRegistrationProjectPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationProject` being updated. */
  patch: UpdateTimeRegistrationProjectOnTimeRegistrationProjectForTimeRegistrationProjectDescriptionTranslatedEntityIdForePatch;
};

/** The fields on `timeRegistrationProject` to look up the row to update. */
export type TimeRegistrationProjectOnTimeRegistrationProjectForTimeRegistrationProjectNameTranslatedEntityIdForeignUsingTimeRegistrationProjectPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationProject` being updated. */
  patch: UpdateTimeRegistrationProjectOnTimeRegistrationProjectForTimeRegistrationProjectNameTranslatedEntityIdForeignPatch;
};

/** Represents an update to a `TimeRegistrationProject`. Fields that are set will be updated. */
export type TimeRegistrationProjectPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  descriptionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInput>;
};

/** The fields on `timeRegistrationProject` to look up the row to connect. */
export type TimeRegistrationProjectTimeRegistrationProjectPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `timeRegistrationProject` to look up the row to delete. */
export type TimeRegistrationProjectTimeRegistrationProjectPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `TimeRegistrationEntry` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationProjectToManyTimeRegistrationEntryFilter = {
  /** Every related `TimeRegistrationEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationEntryFilter>;
  /** No related `TimeRegistrationEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationEntryFilter>;
  /** Some related `TimeRegistrationEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationEntryFilter>;
};

/** A filter to be used against many `TimeRegistrationEntryTemplate` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationProjectToManyTimeRegistrationEntryTemplateFilter = {
  /** Every related `TimeRegistrationEntryTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  /** No related `TimeRegistrationEntryTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  /** Some related `TimeRegistrationEntryTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
};

/** A connection to a list of `TimeRegistrationProject` values. */
export type TimeRegistrationProjectsConnection = {
  __typename?: 'TimeRegistrationProjectsConnection';
  /** A list of edges which contains the `TimeRegistrationProject` and cursor to aid in pagination. */
  edges: Array<TimeRegistrationProjectsEdge>;
  /** A list of `TimeRegistrationProject` objects. */
  nodes: Array<Maybe<TimeRegistrationProject>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TimeRegistrationProject` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TimeRegistrationProject` edge in the connection. */
export type TimeRegistrationProjectsEdge = {
  __typename?: 'TimeRegistrationProjectsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TimeRegistrationProject` at the end of the edge. */
  node?: Maybe<TimeRegistrationProject>;
};

/** Methods to use when ordering `TimeRegistrationProject`. */
export type TimeRegistrationProjectsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'CODE_ASC'
  | 'CODE_DESC'
  | 'COLOR_ASC'
  | 'COLOR_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DESCRIPTION_TRANSLATED_ENTITY_ID_ASC'
  | 'DESCRIPTION_TRANSLATED_ENTITY_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALIZED_NAME_ASC'
  | 'LOCALIZED_NAME_DESC'
  | 'NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIME_REGISTRATION_ENTRIES_BY_TIME_REGISTRATION_PROJECT_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_ENTRIES_BY_TIME_REGISTRATION_PROJECT_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_ENTRY_TEMPLATES_BY_TIME_REGISTRATION_PROJECT_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_ENTRY_TEMPLATES_BY_TIME_REGISTRATION_PROJECT_ID__COUNT_DESC'
  | 'TRANSLATED_ENTITY_BY_DESCRIPTION_TRANSLATED_ENTITY_ID__COMPANY_ID_ASC'
  | 'TRANSLATED_ENTITY_BY_DESCRIPTION_TRANSLATED_ENTITY_ID__COMPANY_ID_DESC'
  | 'TRANSLATED_ENTITY_BY_DESCRIPTION_TRANSLATED_ENTITY_ID__ID_ASC'
  | 'TRANSLATED_ENTITY_BY_DESCRIPTION_TRANSLATED_ENTITY_ID__ID_DESC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__COMPANY_ID_ASC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__COMPANY_ID_DESC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__ID_ASC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__ID_DESC';

/** A connection to a list of `TimeRegistrationRegisteredTimeRecord` values. */
export type TimeRegistrationRegisteredTimeConnection = {
  __typename?: 'TimeRegistrationRegisteredTimeConnection';
  /** A list of edges which contains the `TimeRegistrationRegisteredTimeRecord` and cursor to aid in pagination. */
  edges: Array<TimeRegistrationRegisteredTimeEdge>;
  /** A list of `TimeRegistrationRegisteredTimeRecord` objects. */
  nodes: Array<Maybe<TimeRegistrationRegisteredTimeRecord>>;
  /** The count of *all* `TimeRegistrationRegisteredTimeRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TimeRegistrationRegisteredTimeRecord` edge in the connection. */
export type TimeRegistrationRegisteredTimeEdge = {
  __typename?: 'TimeRegistrationRegisteredTimeEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TimeRegistrationRegisteredTimeRecord` at the end of the edge. */
  node?: Maybe<TimeRegistrationRegisteredTimeRecord>;
};

/** The return type of our `timeRegistrationRegisteredTime` query. */
export type TimeRegistrationRegisteredTimeRecord = {
  __typename?: 'TimeRegistrationRegisteredTimeRecord';
  date?: Maybe<Scalars['Date']>;
  registeredTime?: Maybe<Interval>;
};

/** A filter to be used against `TimeRegistrationRegisteredTimeRecord` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationRegisteredTimeRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TimeRegistrationRegisteredTimeRecordFilter>>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DateFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TimeRegistrationRegisteredTimeRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TimeRegistrationRegisteredTimeRecordFilter>>;
  /** Filter by the object’s `registeredTime` field. */
  registeredTime?: InputMaybe<IntervalFilter>;
};

export type TimeRegistrationTemplate = {
  __typename?: 'TimeRegistrationTemplate';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `TimeRegistrationTemplate`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  id: Scalars['UUID'];
  localizedName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationTemplate`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  nameTranslatedEntityId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `TimeRegistrationEntryTemplate`. */
  timeRegistrationEntryTemplates: TimeRegistrationEntryTemplatesConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationPresenceTemplate`. */
  timeRegistrationPresenceTemplates: TimeRegistrationPresenceTemplatesConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationTemplateWeek`. */
  timeRegistrationTemplateWeeks: TimeRegistrationTemplateWeeksConnection;
  useMultiWeek: Scalars['Boolean'];
};


export type TimeRegistrationTemplateTimeRegistrationEntryTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationEntryTemplateCondition>;
  filter?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationEntryTemplatesOrderBy>>;
};


export type TimeRegistrationTemplateTimeRegistrationPresenceTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationPresenceTemplateCondition>;
  filter?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationPresenceTemplatesOrderBy>>;
};


export type TimeRegistrationTemplateTimeRegistrationTemplateWeeksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationTemplateWeekCondition>;
  filter?: InputMaybe<TimeRegistrationTemplateWeekFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationTemplateWeeksOrderBy>>;
};

/** The `timeRegistrationTemplate` to be created by this mutation. */
export type TimeRegistrationTemplateCompanyIdForeignConnectionTimeRegistrationTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInput>;
  useMultiWeek?: InputMaybe<Scalars['Boolean']>;
  users?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInverseInput>;
};

/** Input for the nested mutation of `company` in the `TimeRegistrationTemplateInput` mutation. */
export type TimeRegistrationTemplateCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnTimeRegistrationTemplateForTimeRegistrationTemplateCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationTemplate` in the `CompanyInput` mutation. */
export type TimeRegistrationTemplateCompanyIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationTemplateTimeRegistrationTemplatePkeyConnect>>;
  /** A `TimeRegistrationTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationTemplateCompanyIdForeignConnectionTimeRegistrationTemplateCreateInput>>;
  /** The primary key(s) for `timeRegistrationTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationTemplateTimeRegistrationTemplatePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationTemplate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationTemplateOnTimeRegistrationTemplateForTimeRegistrationTemplateCompanyIdForeignUsingTimeRegistrationTemplatePkeyUpdate>>;
};

/**
 * A condition to be used against `TimeRegistrationTemplate` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type TimeRegistrationTemplateCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nameTranslatedEntityId` field. */
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `useMultiWeek` field. */
  useMultiWeek?: InputMaybe<Scalars['Boolean']>;
};

export type TimeRegistrationTemplateEntryInput = {
  endTime: Scalars['Time'];
  startTime: Scalars['Time'];
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType: TimeRegistrationEntryType;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `TimeRegistrationTemplate` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationTemplateFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TimeRegistrationTemplateFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameTranslatedEntity` relation. */
  nameTranslatedEntity?: InputMaybe<TranslatedEntityFilter>;
  /** Filter by the object’s `nameTranslatedEntityId` field. */
  nameTranslatedEntityId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TimeRegistrationTemplateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TimeRegistrationTemplateFilter>>;
  /** Filter by the object’s `timeRegistrationEntryTemplates` relation. */
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationTemplateToManyTimeRegistrationEntryTemplateFilter>;
  /** Some related `timeRegistrationEntryTemplates` exist. */
  timeRegistrationEntryTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationPresenceTemplates` relation. */
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationTemplateToManyTimeRegistrationPresenceTemplateFilter>;
  /** Some related `timeRegistrationPresenceTemplates` exist. */
  timeRegistrationPresenceTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationTemplateWeeks` relation. */
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateToManyTimeRegistrationTemplateWeekFilter>;
  /** Some related `timeRegistrationTemplateWeeks` exist. */
  timeRegistrationTemplateWeeksExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `useMultiWeek` field. */
  useMultiWeek?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `TimeRegistrationTemplate` */
export type TimeRegistrationTemplateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInput>;
  useMultiWeek?: InputMaybe<Scalars['Boolean']>;
  users?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInverseInput>;
};

/** Input for the nested mutation of `translatedEntity` in the `TimeRegistrationTemplateInput` mutation. */
export type TimeRegistrationTemplateNameTranslatedEntityIdForeignInput = {
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  connectById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyConnect>;
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  deleteById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyDelete>;
  /** The primary key(s) and patch data for `translatedEntity` for the far side of the relationship. */
  updateById?: InputMaybe<TranslatedEntityOnTimeRegistrationTemplateForTimeRegistrationTemplateNameTranslatedEntityIdForeignUsingTranslatedEntityPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationTemplate` in the `TranslatedEntityInput` mutation. */
export type TimeRegistrationTemplateNameTranslatedEntityIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationTemplateTimeRegistrationTemplatePkeyConnect>>;
  /** The primary key(s) for `timeRegistrationTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationTemplateTimeRegistrationTemplatePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationTemplate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationTemplateOnTimeRegistrationTemplateForTimeRegistrationTemplateNameTranslatedEntityIdForeignUsingTimeRegistrationTemplatePkeyUpdate>>;
};

/** The fields on `timeRegistrationTemplate` to look up the row to update. */
export type TimeRegistrationTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationTemplateIdUsingTimeRegistrationTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationTemplate` being updated. */
  patch: UpdateTimeRegistrationTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationTemplateIdPatch;
};

/** The fields on `timeRegistrationTemplate` to look up the row to update. */
export type TimeRegistrationTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateTimeRegistrationTemplateUsingTimeRegistrationTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationTemplate` being updated. */
  patch: UpdateTimeRegistrationTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateTimeRegistrationTemplatePatch;
};

/** The fields on `timeRegistrationTemplate` to look up the row to update. */
export type TimeRegistrationTemplateOnTimeRegistrationTemplateForTimeRegistrationTemplateCompanyIdForeignUsingTimeRegistrationTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationTemplate` being updated. */
  patch: UpdateTimeRegistrationTemplateOnTimeRegistrationTemplateForTimeRegistrationTemplateCompanyIdForeignPatch;
};

/** The fields on `timeRegistrationTemplate` to look up the row to update. */
export type TimeRegistrationTemplateOnTimeRegistrationTemplateForTimeRegistrationTemplateNameTranslatedEntityIdForeignUsingTimeRegistrationTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationTemplate` being updated. */
  patch: UpdateTimeRegistrationTemplateOnTimeRegistrationTemplateForTimeRegistrationTemplateNameTranslatedEntityIdForeignPatch;
};

/** The fields on `timeRegistrationTemplate` to look up the row to update. */
export type TimeRegistrationTemplateOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekTimeRegistrationTemplateIdFUsingTimeRegistrationTemplatePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationTemplate` being updated. */
  patch: UpdateTimeRegistrationTemplateOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekTimeRegistrationTemplateIdFPatch;
};

/** Represents an update to a `TimeRegistrationTemplate`. Fields that are set will be updated. */
export type TimeRegistrationTemplatePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInput>;
  useMultiWeek?: InputMaybe<Scalars['Boolean']>;
  users?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInverseInput>;
};

export type TimeRegistrationTemplatePresenceInput = {
  endTime: Scalars['Time'];
  entries?: InputMaybe<Array<TimeRegistrationTemplateEntryInput>>;
  startTime: Scalars['Time'];
  timeRegistrationPresenceTypeId: Scalars['UUID'];
};

/** The fields on `timeRegistrationTemplate` to look up the row to connect. */
export type TimeRegistrationTemplateTimeRegistrationTemplatePkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `timeRegistrationTemplate` to look up the row to delete. */
export type TimeRegistrationTemplateTimeRegistrationTemplatePkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `TimeRegistrationEntryTemplate` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationTemplateToManyTimeRegistrationEntryTemplateFilter = {
  /** Every related `TimeRegistrationEntryTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  /** No related `TimeRegistrationEntryTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  /** Some related `TimeRegistrationEntryTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
};

/** A filter to be used against many `TimeRegistrationPresenceTemplate` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationTemplateToManyTimeRegistrationPresenceTemplateFilter = {
  /** Every related `TimeRegistrationPresenceTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
  /** No related `TimeRegistrationPresenceTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
  /** Some related `TimeRegistrationPresenceTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
};

/** A filter to be used against many `TimeRegistrationTemplateWeek` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationTemplateToManyTimeRegistrationTemplateWeekFilter = {
  /** Every related `TimeRegistrationTemplateWeek` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationTemplateWeekFilter>;
  /** No related `TimeRegistrationTemplateWeek` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationTemplateWeekFilter>;
  /** Some related `TimeRegistrationTemplateWeek` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationTemplateWeekFilter>;
};

export type TimeRegistrationTemplateWeek = {
  __typename?: 'TimeRegistrationTemplateWeek';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `TimeRegistrationTemplateWeek`. */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['UUID']>;
  currentlyRunning: Scalars['Boolean'];
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `TimeRegistrationPresenceTemplate`. */
  timeRegistrationPresenceTemplates: TimeRegistrationPresenceTemplatesConnection;
  /** Reads a single `TimeRegistrationTemplate` that is related to this `TimeRegistrationTemplateWeek`. */
  timeRegistrationTemplate?: Maybe<TimeRegistrationTemplate>;
  timeRegistrationTemplateId?: Maybe<Scalars['UUID']>;
  /** Reads a single `User` that is related to this `TimeRegistrationTemplateWeek`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  weekIndex: Scalars['Int'];
};


export type TimeRegistrationTemplateWeekTimeRegistrationPresenceTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationPresenceTemplateCondition>;
  filter?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationPresenceTemplatesOrderBy>>;
};

/** The `timeRegistrationTemplateWeek` to be created by this mutation. */
export type TimeRegistrationTemplateWeekCompanyIdForeignConnectionTimeRegistrationTemplateWeekCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInput>;
  currentlyRunning?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceTemplates?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  weekIndex: Scalars['Int'];
};

/** Input for the nested mutation of `company` in the `TimeRegistrationTemplateWeekInput` mutation. */
export type TimeRegistrationTemplateWeekCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationTemplateWeek` in the `CompanyInput` mutation. */
export type TimeRegistrationTemplateWeekCompanyIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationTemplateWeek` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationTemplateWeekTimeRegistrationTemplateWeekPkeyConnect>>;
  /** A `TimeRegistrationTemplateWeekInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationTemplateWeekCompanyIdForeignConnectionTimeRegistrationTemplateWeekCreateInput>>;
  /** The primary key(s) for `timeRegistrationTemplateWeek` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationTemplateWeekTimeRegistrationTemplateWeekPkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationTemplateWeek` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationTemplateWeek` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationTemplateWeekOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekCompanyIdForeignUsingTimeRegistrationTemplateWeekPkeyUpdate>>;
};

/**
 * A condition to be used against `TimeRegistrationTemplateWeek` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type TimeRegistrationTemplateWeekCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `currentlyRunning` field. */
  currentlyRunning?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `timeRegistrationTemplateId` field. */
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `weekIndex` field. */
  weekIndex?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `TimeRegistrationTemplateWeek` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationTemplateWeekFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TimeRegistrationTemplateWeekFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** A related `company` exists. */
  companyExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `currentlyRunning` field. */
  currentlyRunning?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TimeRegistrationTemplateWeekFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TimeRegistrationTemplateWeekFilter>>;
  /** Filter by the object’s `timeRegistrationPresenceTemplates` relation. */
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationTemplateWeekToManyTimeRegistrationPresenceTemplateFilter>;
  /** Some related `timeRegistrationPresenceTemplates` exist. */
  timeRegistrationPresenceTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationTemplate` relation. */
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationTemplateFilter>;
  /** A related `timeRegistrationTemplate` exists. */
  timeRegistrationTemplateExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationTemplateId` field. */
  timeRegistrationTemplateId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `weekIndex` field. */
  weekIndex?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `TimeRegistrationTemplateWeek` */
export type TimeRegistrationTemplateWeekInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  currentlyRunning?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceTemplates?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  weekIndex: Scalars['Int'];
};

/** The fields on `timeRegistrationTemplateWeek` to look up the row to update. */
export type TimeRegistrationTemplateWeekOnTimeRegistrationPresenceTemplateForTrptTimeRegistrationTemplateWeekIdForeignUsingTimeRegistrationTemplateWeekPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationTemplateWeek` being updated. */
  patch: UpdateTimeRegistrationTemplateWeekOnTimeRegistrationPresenceTemplateForTrptTimeRegistrationTemplateWeekIdForeignPatch;
};

/** The fields on `timeRegistrationTemplateWeek` to look up the row to update. */
export type TimeRegistrationTemplateWeekOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekCompanyIdForeignUsingTimeRegistrationTemplateWeekPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationTemplateWeek` being updated. */
  patch: UpdateTimeRegistrationTemplateWeekOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekCompanyIdForeignPatch;
};

/** The fields on `timeRegistrationTemplateWeek` to look up the row to update. */
export type TimeRegistrationTemplateWeekOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekTimeRegistrationTemplateIdFUsingTimeRegistrationTemplateWeekPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationTemplateWeek` being updated. */
  patch: UpdateTimeRegistrationTemplateWeekOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekTimeRegistrationTemplateIdFPatch;
};

/** The fields on `timeRegistrationTemplateWeek` to look up the row to update. */
export type TimeRegistrationTemplateWeekOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekUserIdForeignUsingTimeRegistrationTemplateWeekPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `timeRegistrationTemplateWeek` being updated. */
  patch: UpdateTimeRegistrationTemplateWeekOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekUserIdForeignPatch;
};

/** Represents an update to a `TimeRegistrationTemplateWeek`. Fields that are set will be updated. */
export type TimeRegistrationTemplateWeekPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  currentlyRunning?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceTemplates?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  weekIndex?: InputMaybe<Scalars['Int']>;
};

/** The `timeRegistrationTemplate` to be created by this mutation. */
export type TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFConnectionTimeRegistrationTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInput>;
  useMultiWeek?: InputMaybe<Scalars['Boolean']>;
  users?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInverseInput>;
};

/** The `timeRegistrationTemplateWeek` to be created by this mutation. */
export type TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFConnectionTimeRegistrationTemplateWeekCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  currentlyRunning?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceTemplates?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInput>;
  user?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  weekIndex: Scalars['Int'];
};

/** Input for the nested mutation of `timeRegistrationTemplate` in the `TimeRegistrationTemplateWeekInput` mutation. */
export type TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInput = {
  /** The primary key(s) for `timeRegistrationTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<TimeRegistrationTemplateTimeRegistrationTemplatePkeyConnect>;
  /** A `TimeRegistrationTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFConnectionTimeRegistrationTemplateCreateInput>;
  /** The primary key(s) for `timeRegistrationTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<TimeRegistrationTemplateTimeRegistrationTemplatePkeyDelete>;
  /** The primary key(s) and patch data for `timeRegistrationTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<TimeRegistrationTemplateOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekTimeRegistrationTemplateIdFUsingTimeRegistrationTemplatePkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationTemplateWeek` in the `TimeRegistrationTemplateInput` mutation. */
export type TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInverseInput = {
  /** The primary key(s) for `timeRegistrationTemplateWeek` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationTemplateWeekTimeRegistrationTemplateWeekPkeyConnect>>;
  /** A `TimeRegistrationTemplateWeekInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFConnectionTimeRegistrationTemplateWeekCreateInput>>;
  /** The primary key(s) for `timeRegistrationTemplateWeek` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationTemplateWeekTimeRegistrationTemplateWeekPkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationTemplateWeek` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationTemplateWeek` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationTemplateWeekOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekTimeRegistrationTemplateIdFUsingTimeRegistrationTemplateWeekPkeyUpdate>>;
};

/** The fields on `timeRegistrationTemplateWeek` to look up the row to connect. */
export type TimeRegistrationTemplateWeekTimeRegistrationTemplateWeekPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `timeRegistrationTemplateWeek` to look up the row to delete. */
export type TimeRegistrationTemplateWeekTimeRegistrationTemplateWeekPkeyDelete = {
  id: Scalars['UUID'];
};

/** A filter to be used against many `TimeRegistrationPresenceTemplate` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationTemplateWeekToManyTimeRegistrationPresenceTemplateFilter = {
  /** Every related `TimeRegistrationPresenceTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
  /** No related `TimeRegistrationPresenceTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
  /** Some related `TimeRegistrationPresenceTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
};

/** The `timeRegistrationTemplateWeek` to be created by this mutation. */
export type TimeRegistrationTemplateWeekUserIdForeignConnectionTimeRegistrationTemplateWeekCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  currentlyRunning?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceTemplates?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInput>;
  weekIndex: Scalars['Int'];
};

/** Input for the nested mutation of `user` in the `TimeRegistrationTemplateWeekInput` mutation. */
export type TimeRegistrationTemplateWeekUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationTemplateWeek` in the `UserInput` mutation. */
export type TimeRegistrationTemplateWeekUserIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationTemplateWeek` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationTemplateWeekTimeRegistrationTemplateWeekPkeyConnect>>;
  /** A `TimeRegistrationTemplateWeekInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TimeRegistrationTemplateWeekUserIdForeignConnectionTimeRegistrationTemplateWeekCreateInput>>;
  /** The primary key(s) for `timeRegistrationTemplateWeek` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationTemplateWeekTimeRegistrationTemplateWeekPkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationTemplateWeek` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationTemplateWeek` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationTemplateWeekOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekUserIdForeignUsingTimeRegistrationTemplateWeekPkeyUpdate>>;
};

/** A connection to a list of `TimeRegistrationTemplateWeek` values. */
export type TimeRegistrationTemplateWeeksConnection = {
  __typename?: 'TimeRegistrationTemplateWeeksConnection';
  /** A list of edges which contains the `TimeRegistrationTemplateWeek` and cursor to aid in pagination. */
  edges: Array<TimeRegistrationTemplateWeeksEdge>;
  /** A list of `TimeRegistrationTemplateWeek` objects. */
  nodes: Array<Maybe<TimeRegistrationTemplateWeek>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TimeRegistrationTemplateWeek` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TimeRegistrationTemplateWeek` edge in the connection. */
export type TimeRegistrationTemplateWeeksEdge = {
  __typename?: 'TimeRegistrationTemplateWeeksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TimeRegistrationTemplateWeek` at the end of the edge. */
  node?: Maybe<TimeRegistrationTemplateWeek>;
};

/** Methods to use when ordering `TimeRegistrationTemplateWeek`. */
export type TimeRegistrationTemplateWeeksOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CURRENTLY_RUNNING_ASC'
  | 'CURRENTLY_RUNNING_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATES_BY_TIME_REGISTRATION_TEMPLATE_WEEK_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATES_BY_TIME_REGISTRATION_TEMPLATE_WEEK_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__ACTIVE_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__ACTIVE_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__COMPANY_ID_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__COMPANY_ID_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__ID_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__ID_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__LOCALIZED_NAME_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__LOCALIZED_NAME_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__USE_MULTI_WEEK_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_BY_TIME_REGISTRATION_TEMPLATE_ID__USE_MULTI_WEEK_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_ID_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_ID_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC'
  | 'WEEK_INDEX_ASC'
  | 'WEEK_INDEX_DESC';

/** A connection to a list of `TimeRegistrationTemplate` values. */
export type TimeRegistrationTemplatesConnection = {
  __typename?: 'TimeRegistrationTemplatesConnection';
  /** A list of edges which contains the `TimeRegistrationTemplate` and cursor to aid in pagination. */
  edges: Array<TimeRegistrationTemplatesEdge>;
  /** A list of `TimeRegistrationTemplate` objects. */
  nodes: Array<Maybe<TimeRegistrationTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TimeRegistrationTemplate` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TimeRegistrationTemplate` edge in the connection. */
export type TimeRegistrationTemplatesEdge = {
  __typename?: 'TimeRegistrationTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TimeRegistrationTemplate` at the end of the edge. */
  node?: Maybe<TimeRegistrationTemplate>;
};

/** Methods to use when ordering `TimeRegistrationTemplate`. */
export type TimeRegistrationTemplatesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALIZED_NAME_ASC'
  | 'LOCALIZED_NAME_DESC'
  | 'NAME_TRANSLATED_ENTITY_ID_ASC'
  | 'NAME_TRANSLATED_ENTITY_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIME_REGISTRATION_ENTRY_TEMPLATES_BY_TIME_REGISTRATION_TEMPLATE_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_ENTRY_TEMPLATES_BY_TIME_REGISTRATION_TEMPLATE_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATES_BY_TIME_REGISTRATION_TEMPLATE_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATES_BY_TIME_REGISTRATION_TEMPLATE_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEKS_BY_TIME_REGISTRATION_TEMPLATE_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEKS_BY_TIME_REGISTRATION_TEMPLATE_ID__COUNT_DESC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__COMPANY_ID_ASC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__COMPANY_ID_DESC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__ID_ASC'
  | 'TRANSLATED_ENTITY_BY_NAME_TRANSLATED_ENTITY_ID__ID_DESC'
  | 'USE_MULTI_WEEK_ASC'
  | 'USE_MULTI_WEEK_DESC';

/** A connection to a list of `TimeRegistrationUserOverviewRecord` values. */
export type TimeRegistrationUserOverviewConnection = {
  __typename?: 'TimeRegistrationUserOverviewConnection';
  /** A list of edges which contains the `TimeRegistrationUserOverviewRecord` and cursor to aid in pagination. */
  edges: Array<TimeRegistrationUserOverviewEdge>;
  /** A list of `TimeRegistrationUserOverviewRecord` objects. */
  nodes: Array<Maybe<TimeRegistrationUserOverviewRecord>>;
  /** The count of *all* `TimeRegistrationUserOverviewRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TimeRegistrationUserOverviewRecord` edge in the connection. */
export type TimeRegistrationUserOverviewEdge = {
  __typename?: 'TimeRegistrationUserOverviewEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TimeRegistrationUserOverviewRecord` at the end of the edge. */
  node?: Maybe<TimeRegistrationUserOverviewRecord>;
};

/** The return type of our `timeRegistrationUserOverview` query. */
export type TimeRegistrationUserOverviewRecord = {
  __typename?: 'TimeRegistrationUserOverviewRecord';
  averageWeeklyHoursLastFourMonths?: Maybe<Interval>;
  breaksThisWeek?: Maybe<Interval>;
  fullName?: Maybe<Scalars['String']>;
  hoursThisWeek?: Maybe<Interval>;
  logo?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['UUID']>;
};

/** A filter to be used against `TimeRegistrationUserOverviewRecord` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationUserOverviewRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TimeRegistrationUserOverviewRecordFilter>>;
  /** Filter by the object’s `averageWeeklyHoursLastFourMonths` field. */
  averageWeeklyHoursLastFourMonths?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `breaksThisWeek` field. */
  breaksThisWeek?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `hoursThisWeek` field. */
  hoursThisWeek?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `logo` field. */
  logo?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TimeRegistrationUserOverviewRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TimeRegistrationUserOverviewRecordFilter>>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** A connection to a list of `TimeRegistrationWeekOverviewRecord` values. */
export type TimeRegistrationWeekOverviewConnection = {
  __typename?: 'TimeRegistrationWeekOverviewConnection';
  /** A list of edges which contains the `TimeRegistrationWeekOverviewRecord` and cursor to aid in pagination. */
  edges: Array<TimeRegistrationWeekOverviewEdge>;
  /** A list of `TimeRegistrationWeekOverviewRecord` objects. */
  nodes: Array<Maybe<TimeRegistrationWeekOverviewRecord>>;
  /** The count of *all* `TimeRegistrationWeekOverviewRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TimeRegistrationWeekOverviewRecord` edge in the connection. */
export type TimeRegistrationWeekOverviewEdge = {
  __typename?: 'TimeRegistrationWeekOverviewEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TimeRegistrationWeekOverviewRecord` at the end of the edge. */
  node?: Maybe<TimeRegistrationWeekOverviewRecord>;
};

/** The return type of our `timeRegistrationWeekOverview` query. */
export type TimeRegistrationWeekOverviewRecord = {
  __typename?: 'TimeRegistrationWeekOverviewRecord';
  totalBreakTime?: Maybe<Interval>;
  totalWorkTime?: Maybe<Interval>;
  weekStart?: Maybe<Scalars['Datetime']>;
};

/** A filter to be used against `TimeRegistrationWeekOverviewRecord` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationWeekOverviewRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TimeRegistrationWeekOverviewRecordFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<TimeRegistrationWeekOverviewRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TimeRegistrationWeekOverviewRecordFilter>>;
  /** Filter by the object’s `totalBreakTime` field. */
  totalBreakTime?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `totalWorkTime` field. */
  totalWorkTime?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `weekStart` field. */
  weekStart?: InputMaybe<DatetimeFilter>;
};

export type TimeRegistrationWeekTemplateInput = {
  days?: InputMaybe<Array<TimeRegistrationDayTemplateInput>>;
  weekIndex?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `TimeRegistrationsPendingApprovalRecord` values. */
export type TimeRegistrationsPendingApprovalConnection = {
  __typename?: 'TimeRegistrationsPendingApprovalConnection';
  /** A list of edges which contains the `TimeRegistrationsPendingApprovalRecord` and cursor to aid in pagination. */
  edges: Array<TimeRegistrationsPendingApprovalEdge>;
  /** A list of `TimeRegistrationsPendingApprovalRecord` objects. */
  nodes: Array<Maybe<TimeRegistrationsPendingApprovalRecord>>;
  /** The count of *all* `TimeRegistrationsPendingApprovalRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TimeRegistrationsPendingApprovalRecord` edge in the connection. */
export type TimeRegistrationsPendingApprovalEdge = {
  __typename?: 'TimeRegistrationsPendingApprovalEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TimeRegistrationsPendingApprovalRecord` at the end of the edge. */
  node?: Maybe<TimeRegistrationsPendingApprovalRecord>;
};

/** The return type of our `timeRegistrationsPendingApproval` query. */
export type TimeRegistrationsPendingApprovalRecord = {
  __typename?: 'TimeRegistrationsPendingApprovalRecord';
  deadline?: Maybe<Scalars['Datetime']>;
  endDate?: Maybe<Scalars['Datetime']>;
  startDate?: Maybe<Scalars['Datetime']>;
};

/** A filter to be used against `TimeRegistrationsPendingApprovalRecord` object types. All fields are combined with a logical ‘and.’ */
export type TimeRegistrationsPendingApprovalRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TimeRegistrationsPendingApprovalRecordFilter>>;
  /** Filter by the object’s `deadline` field. */
  deadline?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TimeRegistrationsPendingApprovalRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TimeRegistrationsPendingApprovalRecordFilter>>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `TranslatedEntity` values. */
export type TranslatedEntitiesConnection = {
  __typename?: 'TranslatedEntitiesConnection';
  /** A list of edges which contains the `TranslatedEntity` and cursor to aid in pagination. */
  edges: Array<TranslatedEntitiesEdge>;
  /** A list of `TranslatedEntity` objects. */
  nodes: Array<Maybe<TranslatedEntity>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TranslatedEntity` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TranslatedEntity` edge in the connection. */
export type TranslatedEntitiesEdge = {
  __typename?: 'TranslatedEntitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TranslatedEntity` at the end of the edge. */
  node?: Maybe<TranslatedEntity>;
};

/** Methods to use when ordering `TranslatedEntity`. */
export type TranslatedEntitiesOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPANY_SYSTEM_FIELDS_BY_ALIAS_TRANSLATED_ENTITY_ID__COUNT_ASC'
  | 'COMPANY_SYSTEM_FIELDS_BY_ALIAS_TRANSLATED_ENTITY_ID__COUNT_DESC'
  | 'COMPANY_SYSTEM_FIELDS_BY_HELP_TEXT_TRANSLATED_ENTITY_ID__COUNT_ASC'
  | 'COMPANY_SYSTEM_FIELDS_BY_HELP_TEXT_TRANSLATED_ENTITY_ID__COUNT_DESC'
  | 'FORM_FIELD_AGREEMENTS_BY_AGREEMENT_TEXT_TRANSLATED_ENTITY_ID__COUNT_ASC'
  | 'FORM_FIELD_AGREEMENTS_BY_AGREEMENT_TEXT_TRANSLATED_ENTITY_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'POST_TYPES_BY_NAME_TRANSLATED_ENTITY_ID__COUNT_ASC'
  | 'POST_TYPES_BY_NAME_TRANSLATED_ENTITY_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PULSE_SURVEYS_BY_HIGHEST_RATING_LABEL_TRANSLATED_ENTITY_ID__COUNT_ASC'
  | 'PULSE_SURVEYS_BY_HIGHEST_RATING_LABEL_TRANSLATED_ENTITY_ID__COUNT_DESC'
  | 'PULSE_SURVEYS_BY_LOWEST_RATING_LABEL_TRANSLATED_ENTITY_ID__COUNT_ASC'
  | 'PULSE_SURVEYS_BY_LOWEST_RATING_LABEL_TRANSLATED_ENTITY_ID__COUNT_DESC'
  | 'PULSE_SURVEYS_BY_NAME_TRANSLATED_ENTITY_ID__COUNT_ASC'
  | 'PULSE_SURVEYS_BY_NAME_TRANSLATED_ENTITY_ID__COUNT_DESC'
  | 'PULSE_SURVEYS_BY_QUESTION_TRANSLATED_ENTITY_ID__COUNT_ASC'
  | 'PULSE_SURVEYS_BY_QUESTION_TRANSLATED_ENTITY_ID__COUNT_DESC'
  | 'PULSE_SURVEY_CHOICES_BY_TEXT_TRANSLATED_ENTITY_ID__COUNT_ASC'
  | 'PULSE_SURVEY_CHOICES_BY_TEXT_TRANSLATED_ENTITY_ID__COUNT_DESC'
  | 'PULSE_TYPES_BY_NAME_TRANSLATED_ENTITY_ID__COUNT_ASC'
  | 'PULSE_TYPES_BY_NAME_TRANSLATED_ENTITY_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_BREAK_TYPES_BY_NAME_TRANSLATED_ENTITY_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_BREAK_TYPES_BY_NAME_TRANSLATED_ENTITY_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TYPES_BY_NAME_TRANSLATED_ENTITY_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TYPES_BY_NAME_TRANSLATED_ENTITY_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_PROJECTS_BY_DESCRIPTION_TRANSLATED_ENTITY_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_PROJECTS_BY_DESCRIPTION_TRANSLATED_ENTITY_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_PROJECTS_BY_NAME_TRANSLATED_ENTITY_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_PROJECTS_BY_NAME_TRANSLATED_ENTITY_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_TEMPLATES_BY_NAME_TRANSLATED_ENTITY_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_TEMPLATES_BY_NAME_TRANSLATED_ENTITY_ID__COUNT_DESC'
  | 'TRANSLATED_ENTITY_LOCALIZATIONS_BY_TRANSLATED_ENTITY_ID__COUNT_ASC'
  | 'TRANSLATED_ENTITY_LOCALIZATIONS_BY_TRANSLATED_ENTITY_ID__COUNT_DESC';

export type TranslatedEntity = {
  __typename?: 'TranslatedEntity';
  /** Reads a single `Company` that is related to this `TranslatedEntity`. */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `CompanySystemField`. */
  companySystemFieldsByAliasTranslatedEntityId: CompanySystemFieldsConnection;
  /** Reads and enables pagination through a set of `CompanySystemField`. */
  companySystemFieldsByHelpTextTranslatedEntityId: CompanySystemFieldsConnection;
  /** Reads and enables pagination through a set of `FormFieldAgreement`. */
  formFieldAgreementsByAgreementTextTranslatedEntityId: FormFieldAgreementsConnection;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `PostType`. */
  postTypesByNameTranslatedEntityId: PostTypesConnection;
  /** Reads and enables pagination through a set of `PulseSurveyChoice`. */
  pulseSurveyChoicesByTextTranslatedEntityId: PulseSurveyChoicesConnection;
  /** Reads and enables pagination through a set of `PulseSurvey`. */
  pulseSurveysByHighestRatingLabelTranslatedEntityId: PulseSurveysConnection;
  /** Reads and enables pagination through a set of `PulseSurvey`. */
  pulseSurveysByLowestRatingLabelTranslatedEntityId: PulseSurveysConnection;
  /** Reads and enables pagination through a set of `PulseSurvey`. */
  pulseSurveysByNameTranslatedEntityId: PulseSurveysConnection;
  /** Reads and enables pagination through a set of `PulseSurvey`. */
  pulseSurveysByQuestionTranslatedEntityId: PulseSurveysConnection;
  /** Reads and enables pagination through a set of `PulseType`. */
  pulseTypesByNameTranslatedEntityId: PulseTypesConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationBreakType`. */
  timeRegistrationBreakTypesByNameTranslatedEntityId: TimeRegistrationBreakTypesConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationPresenceType`. */
  timeRegistrationPresenceTypesByNameTranslatedEntityId: TimeRegistrationPresenceTypesConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationProject`. */
  timeRegistrationProjectsByDescriptionTranslatedEntityId: TimeRegistrationProjectsConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationProject`. */
  timeRegistrationProjectsByNameTranslatedEntityId: TimeRegistrationProjectsConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationTemplate`. */
  timeRegistrationTemplatesByNameTranslatedEntityId: TimeRegistrationTemplatesConnection;
  /** Reads and enables pagination through a set of `TranslatedEntityLocalization`. */
  translatedEntityLocalizations: TranslatedEntityLocalizationsConnection;
};


export type TranslatedEntityCompanySystemFieldsByAliasTranslatedEntityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanySystemFieldCondition>;
  filter?: InputMaybe<CompanySystemFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanySystemFieldsOrderBy>>;
};


export type TranslatedEntityCompanySystemFieldsByHelpTextTranslatedEntityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CompanySystemFieldCondition>;
  filter?: InputMaybe<CompanySystemFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanySystemFieldsOrderBy>>;
};


export type TranslatedEntityFormFieldAgreementsByAgreementTextTranslatedEntityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldAgreementCondition>;
  filter?: InputMaybe<FormFieldAgreementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldAgreementsOrderBy>>;
};


export type TranslatedEntityPostTypesByNameTranslatedEntityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PostTypeCondition>;
  filter?: InputMaybe<PostTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PostTypesOrderBy>>;
};


export type TranslatedEntityPulseSurveyChoicesByTextTranslatedEntityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseSurveyChoiceCondition>;
  filter?: InputMaybe<PulseSurveyChoiceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseSurveyChoicesOrderBy>>;
};


export type TranslatedEntityPulseSurveysByHighestRatingLabelTranslatedEntityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseSurveyCondition>;
  filter?: InputMaybe<PulseSurveyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseSurveysOrderBy>>;
};


export type TranslatedEntityPulseSurveysByLowestRatingLabelTranslatedEntityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseSurveyCondition>;
  filter?: InputMaybe<PulseSurveyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseSurveysOrderBy>>;
};


export type TranslatedEntityPulseSurveysByNameTranslatedEntityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseSurveyCondition>;
  filter?: InputMaybe<PulseSurveyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseSurveysOrderBy>>;
};


export type TranslatedEntityPulseSurveysByQuestionTranslatedEntityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseSurveyCondition>;
  filter?: InputMaybe<PulseSurveyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseSurveysOrderBy>>;
};


export type TranslatedEntityPulseTypesByNameTranslatedEntityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseTypeCondition>;
  filter?: InputMaybe<PulseTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseTypesOrderBy>>;
};


export type TranslatedEntityTimeRegistrationBreakTypesByNameTranslatedEntityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationBreakTypeCondition>;
  filter?: InputMaybe<TimeRegistrationBreakTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationBreakTypesOrderBy>>;
};


export type TranslatedEntityTimeRegistrationPresenceTypesByNameTranslatedEntityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationPresenceTypeCondition>;
  filter?: InputMaybe<TimeRegistrationPresenceTypeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationPresenceTypesOrderBy>>;
};


export type TranslatedEntityTimeRegistrationProjectsByDescriptionTranslatedEntityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationProjectCondition>;
  filter?: InputMaybe<TimeRegistrationProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationProjectsOrderBy>>;
};


export type TranslatedEntityTimeRegistrationProjectsByNameTranslatedEntityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationProjectCondition>;
  filter?: InputMaybe<TimeRegistrationProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationProjectsOrderBy>>;
};


export type TranslatedEntityTimeRegistrationTemplatesByNameTranslatedEntityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationTemplateCondition>;
  filter?: InputMaybe<TimeRegistrationTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationTemplatesOrderBy>>;
};


export type TranslatedEntityTranslatedEntityLocalizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TranslatedEntityLocalizationCondition>;
  filter?: InputMaybe<TranslatedEntityLocalizationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TranslatedEntityLocalizationsOrderBy>>;
};

/** The `translatedEntity` to be created by this mutation. */
export type TranslatedEntityCompanyIdForeignConnectionTranslatedEntityCreateInput = {
  company?: InputMaybe<TranslatedEntityCompanyIdForeignInput>;
  companySystemFieldsToAliasTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldAliasTranslatedEntityIdForeignInverseInput>;
  companySystemFieldsToHelpTextTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  postTypes?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToHighestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToLowestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyLowestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToNameTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToQuestionTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyQuestionTranslatedEntityIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInverseInput>;
  timeRegistrationProjectsToDescriptionTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInverseInput>;
  timeRegistrationProjectsToNameTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInverseInput>;
};

/** Input for the nested mutation of `company` in the `TranslatedEntityInput` mutation. */
export type TranslatedEntityCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnTranslatedEntityForTranslatedEntityCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `translatedEntity` in the `CompanyInput` mutation. */
export type TranslatedEntityCompanyIdForeignInverseInput = {
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TranslatedEntityTranslatedEntityPkeyConnect>>;
  /** A `TranslatedEntityInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TranslatedEntityCompanyIdForeignConnectionTranslatedEntityCreateInput>>;
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TranslatedEntityTranslatedEntityPkeyDelete>>;
  /** Flag indicating whether all other `translatedEntity` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `translatedEntity` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TranslatedEntityOnTranslatedEntityForTranslatedEntityCompanyIdForeignUsingTranslatedEntityPkeyUpdate>>;
};

/**
 * A condition to be used against `TranslatedEntity` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TranslatedEntityCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `TranslatedEntity` object types. All fields are combined with a logical ‘and.’ */
export type TranslatedEntityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TranslatedEntityFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** A related `company` exists. */
  companyExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `companySystemFieldsByAliasTranslatedEntityId` relation. */
  companySystemFieldsByAliasTranslatedEntityId?: InputMaybe<TranslatedEntityToManyCompanySystemFieldFilter>;
  /** Some related `companySystemFieldsByAliasTranslatedEntityId` exist. */
  companySystemFieldsByAliasTranslatedEntityIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companySystemFieldsByHelpTextTranslatedEntityId` relation. */
  companySystemFieldsByHelpTextTranslatedEntityId?: InputMaybe<TranslatedEntityToManyCompanySystemFieldFilter>;
  /** Some related `companySystemFieldsByHelpTextTranslatedEntityId` exist. */
  companySystemFieldsByHelpTextTranslatedEntityIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `formFieldAgreementsByAgreementTextTranslatedEntityId` relation. */
  formFieldAgreementsByAgreementTextTranslatedEntityId?: InputMaybe<TranslatedEntityToManyFormFieldAgreementFilter>;
  /** Some related `formFieldAgreementsByAgreementTextTranslatedEntityId` exist. */
  formFieldAgreementsByAgreementTextTranslatedEntityIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TranslatedEntityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TranslatedEntityFilter>>;
  /** Filter by the object’s `postTypesByNameTranslatedEntityId` relation. */
  postTypesByNameTranslatedEntityId?: InputMaybe<TranslatedEntityToManyPostTypeFilter>;
  /** Some related `postTypesByNameTranslatedEntityId` exist. */
  postTypesByNameTranslatedEntityIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseSurveyChoicesByTextTranslatedEntityId` relation. */
  pulseSurveyChoicesByTextTranslatedEntityId?: InputMaybe<TranslatedEntityToManyPulseSurveyChoiceFilter>;
  /** Some related `pulseSurveyChoicesByTextTranslatedEntityId` exist. */
  pulseSurveyChoicesByTextTranslatedEntityIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseSurveysByHighestRatingLabelTranslatedEntityId` relation. */
  pulseSurveysByHighestRatingLabelTranslatedEntityId?: InputMaybe<TranslatedEntityToManyPulseSurveyFilter>;
  /** Some related `pulseSurveysByHighestRatingLabelTranslatedEntityId` exist. */
  pulseSurveysByHighestRatingLabelTranslatedEntityIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseSurveysByLowestRatingLabelTranslatedEntityId` relation. */
  pulseSurveysByLowestRatingLabelTranslatedEntityId?: InputMaybe<TranslatedEntityToManyPulseSurveyFilter>;
  /** Some related `pulseSurveysByLowestRatingLabelTranslatedEntityId` exist. */
  pulseSurveysByLowestRatingLabelTranslatedEntityIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseSurveysByNameTranslatedEntityId` relation. */
  pulseSurveysByNameTranslatedEntityId?: InputMaybe<TranslatedEntityToManyPulseSurveyFilter>;
  /** Some related `pulseSurveysByNameTranslatedEntityId` exist. */
  pulseSurveysByNameTranslatedEntityIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseSurveysByQuestionTranslatedEntityId` relation. */
  pulseSurveysByQuestionTranslatedEntityId?: InputMaybe<TranslatedEntityToManyPulseSurveyFilter>;
  /** Some related `pulseSurveysByQuestionTranslatedEntityId` exist. */
  pulseSurveysByQuestionTranslatedEntityIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseTypesByNameTranslatedEntityId` relation. */
  pulseTypesByNameTranslatedEntityId?: InputMaybe<TranslatedEntityToManyPulseTypeFilter>;
  /** Some related `pulseTypesByNameTranslatedEntityId` exist. */
  pulseTypesByNameTranslatedEntityIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationBreakTypesByNameTranslatedEntityId` relation. */
  timeRegistrationBreakTypesByNameTranslatedEntityId?: InputMaybe<TranslatedEntityToManyTimeRegistrationBreakTypeFilter>;
  /** Some related `timeRegistrationBreakTypesByNameTranslatedEntityId` exist. */
  timeRegistrationBreakTypesByNameTranslatedEntityIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationPresenceTypesByNameTranslatedEntityId` relation. */
  timeRegistrationPresenceTypesByNameTranslatedEntityId?: InputMaybe<TranslatedEntityToManyTimeRegistrationPresenceTypeFilter>;
  /** Some related `timeRegistrationPresenceTypesByNameTranslatedEntityId` exist. */
  timeRegistrationPresenceTypesByNameTranslatedEntityIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationProjectsByDescriptionTranslatedEntityId` relation. */
  timeRegistrationProjectsByDescriptionTranslatedEntityId?: InputMaybe<TranslatedEntityToManyTimeRegistrationProjectFilter>;
  /** Some related `timeRegistrationProjectsByDescriptionTranslatedEntityId` exist. */
  timeRegistrationProjectsByDescriptionTranslatedEntityIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationProjectsByNameTranslatedEntityId` relation. */
  timeRegistrationProjectsByNameTranslatedEntityId?: InputMaybe<TranslatedEntityToManyTimeRegistrationProjectFilter>;
  /** Some related `timeRegistrationProjectsByNameTranslatedEntityId` exist. */
  timeRegistrationProjectsByNameTranslatedEntityIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationTemplatesByNameTranslatedEntityId` relation. */
  timeRegistrationTemplatesByNameTranslatedEntityId?: InputMaybe<TranslatedEntityToManyTimeRegistrationTemplateFilter>;
  /** Some related `timeRegistrationTemplatesByNameTranslatedEntityId` exist. */
  timeRegistrationTemplatesByNameTranslatedEntityIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `translatedEntityLocalizations` relation. */
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityToManyTranslatedEntityLocalizationFilter>;
  /** Some related `translatedEntityLocalizations` exist. */
  translatedEntityLocalizationsExist?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `TranslatedEntity` */
export type TranslatedEntityInput = {
  company?: InputMaybe<TranslatedEntityCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldsToAliasTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldAliasTranslatedEntityIdForeignInverseInput>;
  companySystemFieldsToHelpTextTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  postTypes?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToHighestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToLowestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyLowestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToNameTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToQuestionTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyQuestionTranslatedEntityIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInverseInput>;
  timeRegistrationProjectsToDescriptionTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInverseInput>;
  timeRegistrationProjectsToNameTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInverseInput>;
};

export type TranslatedEntityLocalization = {
  __typename?: 'TranslatedEntityLocalization';
  /** Reads a single `Company` that is related to this `TranslatedEntityLocalization`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  id: Scalars['UUID'];
  isOriginalLanguage: Scalars['Boolean'];
  locale: Scalars['String'];
  /** Reads a single `TranslatedEntity` that is related to this `TranslatedEntityLocalization`. */
  translatedEntity?: Maybe<TranslatedEntity>;
  translatedEntityId: Scalars['UUID'];
  translation: Scalars['String'];
};

/** The `translatedEntityLocalization` to be created by this mutation. */
export type TranslatedEntityLocalizationCompanyIdForeignConnectionTranslatedEntityLocalizationCreateInput = {
  company?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOriginalLanguage?: InputMaybe<Scalars['Boolean']>;
  locale: Scalars['String'];
  translatedEntity?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInput>;
  translatedEntityId?: InputMaybe<Scalars['UUID']>;
  translation: Scalars['String'];
};

/** Input for the nested mutation of `company` in the `TranslatedEntityLocalizationInput` mutation. */
export type TranslatedEntityLocalizationCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnTranslatedEntityLocalizationForTranslatedEntityLocalizationCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `translatedEntityLocalization` in the `CompanyInput` mutation. */
export type TranslatedEntityLocalizationCompanyIdForeignInverseInput = {
  /** The primary key(s) for `translatedEntityLocalization` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TranslatedEntityLocalizationTranslatedEntityLocalizationPkeyConnect>>;
  /** The primary key(s) for `translatedEntityLocalization` for the far side of the relationship. */
  connectByTranslatedEntityIdAndLocale?: InputMaybe<Array<TranslatedEntityLocalizationTranslatedEntityLocalizationTranslatedEntityIdLocaleUniqConnect>>;
  /** A `TranslatedEntityLocalizationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TranslatedEntityLocalizationCompanyIdForeignConnectionTranslatedEntityLocalizationCreateInput>>;
  /** The primary key(s) for `translatedEntityLocalization` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TranslatedEntityLocalizationTranslatedEntityLocalizationPkeyDelete>>;
  /** The primary key(s) for `translatedEntityLocalization` for the far side of the relationship. */
  deleteByTranslatedEntityIdAndLocale?: InputMaybe<Array<TranslatedEntityLocalizationTranslatedEntityLocalizationTranslatedEntityIdLocaleUniqDelete>>;
  /** Flag indicating whether all other `translatedEntityLocalization` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `translatedEntityLocalization` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TranslatedEntityLocalizationOnTranslatedEntityLocalizationForTranslatedEntityLocalizationCompanyIdForeignUsingTranslatedEntityLocalizationPkeyUpdate>>;
  /** The primary key(s) and patch data for `translatedEntityLocalization` for the far side of the relationship. */
  updateByTranslatedEntityIdAndLocale?: InputMaybe<Array<TranslatedEntityLocalizationOnTranslatedEntityLocalizationForTranslatedEntityLocalizationCompanyIdForeignUsingTranslatedEntityLocalizationTranslatedEntityIdLocaleUniqUpdate>>;
};

/**
 * A condition to be used against `TranslatedEntityLocalization` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type TranslatedEntityLocalizationCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isOriginalLanguage` field. */
  isOriginalLanguage?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `locale` field. */
  locale?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `translatedEntityId` field. */
  translatedEntityId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `translation` field. */
  translation?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `TranslatedEntityLocalization` object types. All fields are combined with a logical ‘and.’ */
export type TranslatedEntityLocalizationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TranslatedEntityLocalizationFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isOriginalLanguage` field. */
  isOriginalLanguage?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `locale` field. */
  locale?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TranslatedEntityLocalizationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TranslatedEntityLocalizationFilter>>;
  /** Filter by the object’s `translatedEntity` relation. */
  translatedEntity?: InputMaybe<TranslatedEntityFilter>;
  /** Filter by the object’s `translatedEntityId` field. */
  translatedEntityId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `translation` field. */
  translation?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `TranslatedEntityLocalization` */
export type TranslatedEntityLocalizationInput = {
  company?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  isOriginalLanguage?: InputMaybe<Scalars['Boolean']>;
  locale: Scalars['String'];
  translatedEntity?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInput>;
  translatedEntityId?: InputMaybe<Scalars['UUID']>;
  translation: Scalars['String'];
};

/** The fields on `translatedEntityLocalization` to look up the row to update. */
export type TranslatedEntityLocalizationOnTranslatedEntityLocalizationForTranslatedEntityLocalizationCompanyIdForeignUsingTranslatedEntityLocalizationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `translatedEntityLocalization` being updated. */
  patch: UpdateTranslatedEntityLocalizationOnTranslatedEntityLocalizationForTranslatedEntityLocalizationCompanyIdForeignPatch;
};

/** The fields on `translatedEntityLocalization` to look up the row to update. */
export type TranslatedEntityLocalizationOnTranslatedEntityLocalizationForTranslatedEntityLocalizationCompanyIdForeignUsingTranslatedEntityLocalizationTranslatedEntityIdLocaleUniqUpdate = {
  locale: Scalars['String'];
  /** An object where the defined keys will be set on the `translatedEntityLocalization` being updated. */
  patch: UpdateTranslatedEntityLocalizationOnTranslatedEntityLocalizationForTranslatedEntityLocalizationCompanyIdForeignPatch;
  translatedEntityId: Scalars['UUID'];
};

/** The fields on `translatedEntityLocalization` to look up the row to update. */
export type TranslatedEntityLocalizationOnTranslatedEntityLocalizationForTranslatedEntityLocalizationTranslatedEntityIdForeignUsingTranslatedEntityLocalizationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `translatedEntityLocalization` being updated. */
  patch: UpdateTranslatedEntityLocalizationOnTranslatedEntityLocalizationForTranslatedEntityLocalizationTranslatedEntityIdForeignPatch;
};

/** The fields on `translatedEntityLocalization` to look up the row to update. */
export type TranslatedEntityLocalizationOnTranslatedEntityLocalizationForTranslatedEntityLocalizationTranslatedEntityIdForeignUsingTranslatedEntityLocalizationTranslatedEntityIdLocaleUniqUpdate = {
  locale: Scalars['String'];
  /** An object where the defined keys will be set on the `translatedEntityLocalization` being updated. */
  patch: UpdateTranslatedEntityLocalizationOnTranslatedEntityLocalizationForTranslatedEntityLocalizationTranslatedEntityIdForeignPatch;
  translatedEntityId: Scalars['UUID'];
};

/** Represents an update to a `TranslatedEntityLocalization`. Fields that are set will be updated. */
export type TranslatedEntityLocalizationPatch = {
  company?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  isOriginalLanguage?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  translatedEntity?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInput>;
  translatedEntityId?: InputMaybe<Scalars['UUID']>;
  translation?: InputMaybe<Scalars['String']>;
};

/** The `translatedEntity` to be created by this mutation. */
export type TranslatedEntityLocalizationTranslatedEntityIdForeignConnectionTranslatedEntityCreateInput = {
  company?: InputMaybe<TranslatedEntityCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldsToAliasTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldAliasTranslatedEntityIdForeignInverseInput>;
  companySystemFieldsToHelpTextTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  postTypes?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToHighestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToLowestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyLowestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToNameTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToQuestionTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyQuestionTranslatedEntityIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInverseInput>;
  timeRegistrationProjectsToDescriptionTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInverseInput>;
  timeRegistrationProjectsToNameTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInverseInput>;
};

/** The `translatedEntityLocalization` to be created by this mutation. */
export type TranslatedEntityLocalizationTranslatedEntityIdForeignConnectionTranslatedEntityLocalizationCreateInput = {
  company?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  isOriginalLanguage?: InputMaybe<Scalars['Boolean']>;
  locale: Scalars['String'];
  translatedEntity?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInput>;
  translation: Scalars['String'];
};

/** Input for the nested mutation of `translatedEntity` in the `TranslatedEntityLocalizationInput` mutation. */
export type TranslatedEntityLocalizationTranslatedEntityIdForeignInput = {
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  connectById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyConnect>;
  /** A `TranslatedEntityInput` object that will be created and connected to this object. */
  create?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignConnectionTranslatedEntityCreateInput>;
  /** The primary key(s) for `translatedEntity` for the far side of the relationship. */
  deleteById?: InputMaybe<TranslatedEntityTranslatedEntityPkeyDelete>;
  /** The primary key(s) and patch data for `translatedEntity` for the far side of the relationship. */
  updateById?: InputMaybe<TranslatedEntityOnTranslatedEntityLocalizationForTranslatedEntityLocalizationTranslatedEntityIdForeignUsingTranslatedEntityPkeyUpdate>;
};

/** Input for the nested mutation of `translatedEntityLocalization` in the `TranslatedEntityInput` mutation. */
export type TranslatedEntityLocalizationTranslatedEntityIdForeignInverseInput = {
  /** The primary key(s) for `translatedEntityLocalization` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TranslatedEntityLocalizationTranslatedEntityLocalizationPkeyConnect>>;
  /** The primary key(s) for `translatedEntityLocalization` for the far side of the relationship. */
  connectByTranslatedEntityIdAndLocale?: InputMaybe<Array<TranslatedEntityLocalizationTranslatedEntityLocalizationTranslatedEntityIdLocaleUniqConnect>>;
  /** A `TranslatedEntityLocalizationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TranslatedEntityLocalizationTranslatedEntityIdForeignConnectionTranslatedEntityLocalizationCreateInput>>;
  /** The primary key(s) for `translatedEntityLocalization` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TranslatedEntityLocalizationTranslatedEntityLocalizationPkeyDelete>>;
  /** The primary key(s) for `translatedEntityLocalization` for the far side of the relationship. */
  deleteByTranslatedEntityIdAndLocale?: InputMaybe<Array<TranslatedEntityLocalizationTranslatedEntityLocalizationTranslatedEntityIdLocaleUniqDelete>>;
  /** Flag indicating whether all other `translatedEntityLocalization` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `translatedEntityLocalization` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TranslatedEntityLocalizationOnTranslatedEntityLocalizationForTranslatedEntityLocalizationTranslatedEntityIdForeignUsingTranslatedEntityLocalizationPkeyUpdate>>;
  /** The primary key(s) and patch data for `translatedEntityLocalization` for the far side of the relationship. */
  updateByTranslatedEntityIdAndLocale?: InputMaybe<Array<TranslatedEntityLocalizationOnTranslatedEntityLocalizationForTranslatedEntityLocalizationTranslatedEntityIdForeignUsingTranslatedEntityLocalizationTranslatedEntityIdLocaleUniqUpdate>>;
};

/** The fields on `translatedEntityLocalization` to look up the row to connect. */
export type TranslatedEntityLocalizationTranslatedEntityLocalizationPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `translatedEntityLocalization` to look up the row to delete. */
export type TranslatedEntityLocalizationTranslatedEntityLocalizationPkeyDelete = {
  id: Scalars['UUID'];
};

/** The fields on `translatedEntityLocalization` to look up the row to connect. */
export type TranslatedEntityLocalizationTranslatedEntityLocalizationTranslatedEntityIdLocaleUniqConnect = {
  locale: Scalars['String'];
  translatedEntityId: Scalars['UUID'];
};

/** The fields on `translatedEntityLocalization` to look up the row to delete. */
export type TranslatedEntityLocalizationTranslatedEntityLocalizationTranslatedEntityIdLocaleUniqDelete = {
  locale: Scalars['String'];
  translatedEntityId: Scalars['UUID'];
};

/** A connection to a list of `TranslatedEntityLocalization` values. */
export type TranslatedEntityLocalizationsConnection = {
  __typename?: 'TranslatedEntityLocalizationsConnection';
  /** A list of edges which contains the `TranslatedEntityLocalization` and cursor to aid in pagination. */
  edges: Array<TranslatedEntityLocalizationsEdge>;
  /** A list of `TranslatedEntityLocalization` objects. */
  nodes: Array<Maybe<TranslatedEntityLocalization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TranslatedEntityLocalization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TranslatedEntityLocalization` edge in the connection. */
export type TranslatedEntityLocalizationsEdge = {
  __typename?: 'TranslatedEntityLocalizationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TranslatedEntityLocalization` at the end of the edge. */
  node?: Maybe<TranslatedEntityLocalization>;
};

/** Methods to use when ordering `TranslatedEntityLocalization`. */
export type TranslatedEntityLocalizationsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IS_ORIGINAL_LANGUAGE_ASC'
  | 'IS_ORIGINAL_LANGUAGE_DESC'
  | 'LOCALE_ASC'
  | 'LOCALE_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TRANSLATED_ENTITY_BY_TRANSLATED_ENTITY_ID__COMPANY_ID_ASC'
  | 'TRANSLATED_ENTITY_BY_TRANSLATED_ENTITY_ID__COMPANY_ID_DESC'
  | 'TRANSLATED_ENTITY_BY_TRANSLATED_ENTITY_ID__ID_ASC'
  | 'TRANSLATED_ENTITY_BY_TRANSLATED_ENTITY_ID__ID_DESC'
  | 'TRANSLATED_ENTITY_ID_ASC'
  | 'TRANSLATED_ENTITY_ID_DESC'
  | 'TRANSLATION_ASC'
  | 'TRANSLATION_DESC';

/** The fields on `translatedEntity` to look up the row to update. */
export type TranslatedEntityOnCompanySystemFieldForCompanySystemFieldHelpTextTranslatedEntityIdForeignUsingTranslatedEntityPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `translatedEntity` being updated. */
  patch: UpdateTranslatedEntityOnCompanySystemFieldForCompanySystemFieldHelpTextTranslatedEntityIdForeignPatch;
};

/** The fields on `translatedEntity` to look up the row to update. */
export type TranslatedEntityOnFormFieldAgreementForFormFieldAgreementAgreementTextTranslatedEntityIdForeigUsingTranslatedEntityPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `translatedEntity` being updated. */
  patch: UpdateTranslatedEntityOnFormFieldAgreementForFormFieldAgreementAgreementTextTranslatedEntityIdForeigPatch;
};

/** The fields on `translatedEntity` to look up the row to update. */
export type TranslatedEntityOnPostTypeForPostTypeNameTranslatedEntityIdForeignUsingTranslatedEntityPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `translatedEntity` being updated. */
  patch: UpdateTranslatedEntityOnPostTypeForPostTypeNameTranslatedEntityIdForeignPatch;
};

/** The fields on `translatedEntity` to look up the row to update. */
export type TranslatedEntityOnPulseSurveyChoiceForPulseSurveyChoiceTextTranslatedEntityIdForeignUsingTranslatedEntityPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `translatedEntity` being updated. */
  patch: UpdateTranslatedEntityOnPulseSurveyChoiceForPulseSurveyChoiceTextTranslatedEntityIdForeignPatch;
};

/** The fields on `translatedEntity` to look up the row to update. */
export type TranslatedEntityOnPulseSurveyForPulseSurveyHighestRatingLabelTranslatedEntityIdForeignUsingTranslatedEntityPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `translatedEntity` being updated. */
  patch: UpdateTranslatedEntityOnPulseSurveyForPulseSurveyHighestRatingLabelTranslatedEntityIdForeignPatch;
};

/** The fields on `translatedEntity` to look up the row to update. */
export type TranslatedEntityOnPulseTypeForPulseTypeNameTranslatedEntityIdForeignUsingTranslatedEntityPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `translatedEntity` being updated. */
  patch: UpdateTranslatedEntityOnPulseTypeForPulseTypeNameTranslatedEntityIdForeignPatch;
};

/** The fields on `translatedEntity` to look up the row to update. */
export type TranslatedEntityOnTimeRegistrationBreakTypeForTimeRegistrationBreakTypeNameTranslatedEntityIdForeignUsingTranslatedEntityPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `translatedEntity` being updated. */
  patch: UpdateTranslatedEntityOnTimeRegistrationBreakTypeForTimeRegistrationBreakTypeNameTranslatedEntityIdForeignPatch;
};

/** The fields on `translatedEntity` to look up the row to update. */
export type TranslatedEntityOnTimeRegistrationPresenceTypeForTimeRegistrationPresenceTypeNameTranslatedEntityIdForeiUsingTranslatedEntityPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `translatedEntity` being updated. */
  patch: UpdateTranslatedEntityOnTimeRegistrationPresenceTypeForTimeRegistrationPresenceTypeNameTranslatedEntityIdForeiPatch;
};

/** The fields on `translatedEntity` to look up the row to update. */
export type TranslatedEntityOnTimeRegistrationProjectForTimeRegistrationProjectDescriptionTranslatedEntityIdForeUsingTranslatedEntityPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `translatedEntity` being updated. */
  patch: UpdateTranslatedEntityOnTimeRegistrationProjectForTimeRegistrationProjectDescriptionTranslatedEntityIdForePatch;
};

/** The fields on `translatedEntity` to look up the row to update. */
export type TranslatedEntityOnTimeRegistrationTemplateForTimeRegistrationTemplateNameTranslatedEntityIdForeignUsingTranslatedEntityPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `translatedEntity` being updated. */
  patch: UpdateTranslatedEntityOnTimeRegistrationTemplateForTimeRegistrationTemplateNameTranslatedEntityIdForeignPatch;
};

/** The fields on `translatedEntity` to look up the row to update. */
export type TranslatedEntityOnTranslatedEntityForTranslatedEntityCompanyIdForeignUsingTranslatedEntityPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `translatedEntity` being updated. */
  patch: UpdateTranslatedEntityOnTranslatedEntityForTranslatedEntityCompanyIdForeignPatch;
};

/** The fields on `translatedEntity` to look up the row to update. */
export type TranslatedEntityOnTranslatedEntityLocalizationForTranslatedEntityLocalizationTranslatedEntityIdForeignUsingTranslatedEntityPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `translatedEntity` being updated. */
  patch: UpdateTranslatedEntityOnTranslatedEntityLocalizationForTranslatedEntityLocalizationTranslatedEntityIdForeignPatch;
};

/** Represents an update to a `TranslatedEntity`. Fields that are set will be updated. */
export type TranslatedEntityPatch = {
  company?: InputMaybe<TranslatedEntityCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldsToAliasTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldAliasTranslatedEntityIdForeignInverseInput>;
  companySystemFieldsToHelpTextTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  postTypes?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToHighestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToLowestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyLowestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToNameTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToQuestionTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyQuestionTranslatedEntityIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInverseInput>;
  timeRegistrationProjectsToDescriptionTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInverseInput>;
  timeRegistrationProjectsToNameTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInverseInput>;
};

/** A filter to be used against many `CompanySystemField` object types. All fields are combined with a logical ‘and.’ */
export type TranslatedEntityToManyCompanySystemFieldFilter = {
  /** Every related `CompanySystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CompanySystemFieldFilter>;
  /** No related `CompanySystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CompanySystemFieldFilter>;
  /** Some related `CompanySystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CompanySystemFieldFilter>;
};

/** A filter to be used against many `FormFieldAgreement` object types. All fields are combined with a logical ‘and.’ */
export type TranslatedEntityToManyFormFieldAgreementFilter = {
  /** Every related `FormFieldAgreement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FormFieldAgreementFilter>;
  /** No related `FormFieldAgreement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FormFieldAgreementFilter>;
  /** Some related `FormFieldAgreement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FormFieldAgreementFilter>;
};

/** A filter to be used against many `PostType` object types. All fields are combined with a logical ‘and.’ */
export type TranslatedEntityToManyPostTypeFilter = {
  /** Every related `PostType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PostTypeFilter>;
  /** No related `PostType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PostTypeFilter>;
  /** Some related `PostType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PostTypeFilter>;
};

/** A filter to be used against many `PulseSurveyChoice` object types. All fields are combined with a logical ‘and.’ */
export type TranslatedEntityToManyPulseSurveyChoiceFilter = {
  /** Every related `PulseSurveyChoice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PulseSurveyChoiceFilter>;
  /** No related `PulseSurveyChoice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PulseSurveyChoiceFilter>;
  /** Some related `PulseSurveyChoice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PulseSurveyChoiceFilter>;
};

/** A filter to be used against many `PulseSurvey` object types. All fields are combined with a logical ‘and.’ */
export type TranslatedEntityToManyPulseSurveyFilter = {
  /** Every related `PulseSurvey` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PulseSurveyFilter>;
  /** No related `PulseSurvey` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PulseSurveyFilter>;
  /** Some related `PulseSurvey` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PulseSurveyFilter>;
};

/** A filter to be used against many `PulseType` object types. All fields are combined with a logical ‘and.’ */
export type TranslatedEntityToManyPulseTypeFilter = {
  /** Every related `PulseType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PulseTypeFilter>;
  /** No related `PulseType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PulseTypeFilter>;
  /** Some related `PulseType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PulseTypeFilter>;
};

/** A filter to be used against many `TimeRegistrationBreakType` object types. All fields are combined with a logical ‘and.’ */
export type TranslatedEntityToManyTimeRegistrationBreakTypeFilter = {
  /** Every related `TimeRegistrationBreakType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationBreakTypeFilter>;
  /** No related `TimeRegistrationBreakType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationBreakTypeFilter>;
  /** Some related `TimeRegistrationBreakType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationBreakTypeFilter>;
};

/** A filter to be used against many `TimeRegistrationPresenceType` object types. All fields are combined with a logical ‘and.’ */
export type TranslatedEntityToManyTimeRegistrationPresenceTypeFilter = {
  /** Every related `TimeRegistrationPresenceType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationPresenceTypeFilter>;
  /** No related `TimeRegistrationPresenceType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationPresenceTypeFilter>;
  /** Some related `TimeRegistrationPresenceType` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationPresenceTypeFilter>;
};

/** A filter to be used against many `TimeRegistrationProject` object types. All fields are combined with a logical ‘and.’ */
export type TranslatedEntityToManyTimeRegistrationProjectFilter = {
  /** Every related `TimeRegistrationProject` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationProjectFilter>;
  /** No related `TimeRegistrationProject` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationProjectFilter>;
  /** Some related `TimeRegistrationProject` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationProjectFilter>;
};

/** A filter to be used against many `TimeRegistrationTemplate` object types. All fields are combined with a logical ‘and.’ */
export type TranslatedEntityToManyTimeRegistrationTemplateFilter = {
  /** Every related `TimeRegistrationTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationTemplateFilter>;
  /** No related `TimeRegistrationTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationTemplateFilter>;
  /** Some related `TimeRegistrationTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationTemplateFilter>;
};

/** A filter to be used against many `TranslatedEntityLocalization` object types. All fields are combined with a logical ‘and.’ */
export type TranslatedEntityToManyTranslatedEntityLocalizationFilter = {
  /** Every related `TranslatedEntityLocalization` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TranslatedEntityLocalizationFilter>;
  /** No related `TranslatedEntityLocalization` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TranslatedEntityLocalizationFilter>;
  /** Some related `TranslatedEntityLocalization` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TranslatedEntityLocalizationFilter>;
};

/** The fields on `translatedEntity` to look up the row to connect. */
export type TranslatedEntityTranslatedEntityPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `translatedEntity` to look up the row to delete. */
export type TranslatedEntityTranslatedEntityPkeyDelete = {
  id: Scalars['UUID'];
};

export type Translation = {
  __typename?: 'Translation';
  /** Reads a single `Company` that is related to this `Translation`. */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['UUID']>;
  from?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  text?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  translation?: Maybe<Scalars['String']>;
  translationGroup?: Maybe<Scalars['String']>;
};

/** The `translation` to be created by this mutation. */
export type TranslationCompanyIdForeignConnectionTranslationCreateInput = {
  company?: InputMaybe<TranslationCompanyIdForeignInput>;
  from?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  text?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
  translationGroup?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `company` in the `TranslationInput` mutation. */
export type TranslationCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnTranslationForTranslationCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `translation` in the `CompanyInput` mutation. */
export type TranslationCompanyIdForeignInverseInput = {
  /** The primary key(s) for `translation` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TranslationTranslationPkeyConnect>>;
  /** A `TranslationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TranslationCompanyIdForeignConnectionTranslationCreateInput>>;
  /** The primary key(s) for `translation` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TranslationTranslationPkeyDelete>>;
  /** Flag indicating whether all other `translation` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `translation` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TranslationOnTranslationForTranslationCompanyIdForeignUsingTranslationPkeyUpdate>>;
};

/**
 * A condition to be used against `Translation` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type TranslationCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `from` field. */
  from?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `text` field. */
  text?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `to` field. */
  to?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `translation` field. */
  translation?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `translationGroup` field. */
  translationGroup?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Translation` object types. All fields are combined with a logical ‘and.’ */
export type TranslationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TranslationFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** A related `company` exists. */
  companyExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `from` field. */
  from?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TranslationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TranslationFilter>>;
  /** Filter by the object’s `text` field. */
  text?: InputMaybe<StringFilter>;
  /** Filter by the object’s `to` field. */
  to?: InputMaybe<StringFilter>;
  /** Filter by the object’s `translation` field. */
  translation?: InputMaybe<StringFilter>;
  /** Filter by the object’s `translationGroup` field. */
  translationGroup?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Translation` */
export type TranslationInput = {
  company?: InputMaybe<TranslationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  from?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  text?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
  translationGroup?: InputMaybe<Scalars['String']>;
};

/** The fields on `translation` to look up the row to update. */
export type TranslationOnTranslationForTranslationCompanyIdForeignUsingTranslationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `translation` being updated. */
  patch: UpdateTranslationOnTranslationForTranslationCompanyIdForeignPatch;
};

/** Represents an update to a `Translation`. Fields that are set will be updated. */
export type TranslationPatch = {
  company?: InputMaybe<TranslationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  from?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  text?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
  translationGroup?: InputMaybe<Scalars['String']>;
};

/** The fields on `translation` to look up the row to connect. */
export type TranslationTranslationPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `translation` to look up the row to delete. */
export type TranslationTranslationPkeyDelete = {
  id: Scalars['UUID'];
};

/** A connection to a list of `Translation` values. */
export type TranslationsConnection = {
  __typename?: 'TranslationsConnection';
  /** A list of edges which contains the `Translation` and cursor to aid in pagination. */
  edges: Array<TranslationsEdge>;
  /** A list of `Translation` objects. */
  nodes: Array<Maybe<Translation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Translation` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Translation` edge in the connection. */
export type TranslationsEdge = {
  __typename?: 'TranslationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Translation` at the end of the edge. */
  node?: Maybe<Translation>;
};

/** Methods to use when ordering `Translation`. */
export type TranslationsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'FROM_ASC'
  | 'FROM_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TEXT_ASC'
  | 'TEXT_DESC'
  | 'TO_ASC'
  | 'TO_DESC'
  | 'TRANSLATION_ASC'
  | 'TRANSLATION_DESC'
  | 'TRANSLATION_GROUP_ASC'
  | 'TRANSLATION_GROUP_DESC';

/** All input for the `triggerWebhookEvent` mutation. */
export type TriggerWebhookEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  eventName?: InputMaybe<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `triggerWebhookEvent` mutation. */
export type TriggerWebhookEventPayload = {
  __typename?: 'TriggerWebhookEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The `timeRegistrationPresenceTemplate` to be created by this mutation. */
export type TrptTimeRegistrationTemplateWeekIdForeignConnectionTimeRegistrationPresenceTemplateCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dayOfWeek: Scalars['Int'];
  endTime: Scalars['Time'];
  id?: InputMaybe<Scalars['UUID']>;
  startTime: Scalars['Time'];
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplateWeek?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInput>;
  user?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `timeRegistrationTemplateWeek` to be created by this mutation. */
export type TrptTimeRegistrationTemplateWeekIdForeignConnectionTimeRegistrationTemplateWeekCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  currentlyRunning?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceTemplates?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  weekIndex: Scalars['Int'];
};

/** Input for the nested mutation of `timeRegistrationTemplateWeek` in the `TimeRegistrationPresenceTemplateInput` mutation. */
export type TrptTimeRegistrationTemplateWeekIdForeignInput = {
  /** The primary key(s) for `timeRegistrationTemplateWeek` for the far side of the relationship. */
  connectById?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateWeekPkeyConnect>;
  /** A `TimeRegistrationTemplateWeekInput` object that will be created and connected to this object. */
  create?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignConnectionTimeRegistrationTemplateWeekCreateInput>;
  /** The primary key(s) for `timeRegistrationTemplateWeek` for the far side of the relationship. */
  deleteById?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateWeekPkeyDelete>;
  /** The primary key(s) and patch data for `timeRegistrationTemplateWeek` for the far side of the relationship. */
  updateById?: InputMaybe<TimeRegistrationTemplateWeekOnTimeRegistrationPresenceTemplateForTrptTimeRegistrationTemplateWeekIdForeignUsingTimeRegistrationTemplateWeekPkeyUpdate>;
};

/** Input for the nested mutation of `timeRegistrationPresenceTemplate` in the `TimeRegistrationTemplateWeekInput` mutation. */
export type TrptTimeRegistrationTemplateWeekIdForeignInverseInput = {
  /** The primary key(s) for `timeRegistrationPresenceTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TimeRegistrationPresenceTemplateTimeRegistrationPresenceTemplatePkeyConnect>>;
  /** A `TimeRegistrationPresenceTemplateInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TrptTimeRegistrationTemplateWeekIdForeignConnectionTimeRegistrationPresenceTemplateCreateInput>>;
  /** The primary key(s) for `timeRegistrationPresenceTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TimeRegistrationPresenceTemplateTimeRegistrationPresenceTemplatePkeyDelete>>;
  /** Flag indicating whether all other `timeRegistrationPresenceTemplate` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `timeRegistrationPresenceTemplate` for the far side of the relationship. */
  updateById?: InputMaybe<Array<TimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTrptTimeRegistrationTemplateWeekIdForeignUsingTimeRegistrationPresenceTemplatePkeyUpdate>>;
};

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']>>;
};

/** A filter to be used against UUID List fields. All fields are combined with a logical ‘and.’ */
export type UuidListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['UUID']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['UUID']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** All input for the `updateAnnouncementById` mutation. */
export type UpdateAnnouncementByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Announcement` being updated. */
  patch: AnnouncementPatch;
};

/** The output of our update `Announcement` mutation. */
export type UpdateAnnouncementPayload = {
  __typename?: 'UpdateAnnouncementPayload';
  /** The `Announcement` that was updated by this mutation. */
  announcement?: Maybe<Announcement>;
  /** An edge for our `Announcement`. May be used by Relay 1. */
  announcementEdge?: Maybe<AnnouncementsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Announcement`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Announcement`. */
  user?: Maybe<User>;
};


/** The output of our update `Announcement` mutation. */
export type UpdateAnnouncementPayloadAnnouncementEdgeArgs = {
  orderBy?: InputMaybe<Array<AnnouncementsOrderBy>>;
};

/** All input for the `updateApprovalById` mutation. */
export type UpdateApprovalByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Approval` being updated. */
  patch: ApprovalPatch;
};

/** The output of our update `Approval` mutation. */
export type UpdateApprovalPayload = {
  __typename?: 'UpdateApprovalPayload';
  /** Reads a single `User` that is related to this `Approval`. */
  affectedUser?: Maybe<User>;
  /** The `Approval` that was updated by this mutation. */
  approval?: Maybe<Approval>;
  /** An edge for our `Approval`. May be used by Relay 1. */
  approvalEdge?: Maybe<ApprovalsEdge>;
  /** Reads a single `User` that is related to this `Approval`. */
  approvingUser?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Approval`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Approval`. */
  requestingUser?: Maybe<User>;
};


/** The output of our update `Approval` mutation. */
export type UpdateApprovalPayloadApprovalEdgeArgs = {
  orderBy?: InputMaybe<Array<ApprovalsOrderBy>>;
};

/** All input for the `updateAsyncJobById` mutation. */
export type UpdateAsyncJobByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AsyncJob` being updated. */
  patch: AsyncJobPatch;
};

/** The output of our update `AsyncJob` mutation. */
export type UpdateAsyncJobPayload = {
  __typename?: 'UpdateAsyncJobPayload';
  /** The `AsyncJob` that was updated by this mutation. */
  asyncJob?: Maybe<AsyncJob>;
  /** An edge for our `AsyncJob`. May be used by Relay 1. */
  asyncJobEdge?: Maybe<AsyncJobsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `AsyncJob`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `AsyncJob`. */
  user?: Maybe<User>;
};


/** The output of our update `AsyncJob` mutation. */
export type UpdateAsyncJobPayloadAsyncJobEdgeArgs = {
  orderBy?: InputMaybe<Array<AsyncJobsOrderBy>>;
};

/** All input for the `updateAuthAppTypeById` mutation. */
export type UpdateAuthAppTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `AuthAppType` being updated. */
  patch: AuthAppTypePatch;
};

/** The output of our update `AuthAppType` mutation. */
export type UpdateAuthAppTypePayload = {
  __typename?: 'UpdateAuthAppTypePayload';
  /** The `AuthAppType` that was updated by this mutation. */
  authAppType?: Maybe<AuthAppType>;
  /** An edge for our `AuthAppType`. May be used by Relay 1. */
  authAppTypeEdge?: Maybe<AuthAppTypesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AuthAppType` mutation. */
export type UpdateAuthAppTypePayloadAuthAppTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<AuthAppTypesOrderBy>>;
};

/** All input for the `updateAuthCodeById` mutation. */
export type UpdateAuthCodeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  /** An object where the defined keys will be set on the `AuthCode` being updated. */
  patch: AuthCodePatch;
};

/** The output of our update `AuthCode` mutation. */
export type UpdateAuthCodePayload = {
  __typename?: 'UpdateAuthCodePayload';
  /** The `AuthCode` that was updated by this mutation. */
  authCode?: Maybe<AuthCode>;
  /** An edge for our `AuthCode`. May be used by Relay 1. */
  authCodeEdge?: Maybe<AuthCodesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AuthCode` mutation. */
export type UpdateAuthCodePayloadAuthCodeEdgeArgs = {
  orderBy?: InputMaybe<Array<AuthCodesOrderBy>>;
};

/** All input for the `updateChangelogById` mutation. */
export type UpdateChangelogByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Changelog` being updated. */
  patch: ChangelogPatch;
};

/** The output of our update `Changelog` mutation. */
export type UpdateChangelogPayload = {
  __typename?: 'UpdateChangelogPayload';
  /** The `Changelog` that was updated by this mutation. */
  changelog?: Maybe<Changelog>;
  /** An edge for our `Changelog`. May be used by Relay 1. */
  changelogEdge?: Maybe<ChangelogsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Changelog` mutation. */
export type UpdateChangelogPayloadChangelogEdgeArgs = {
  orderBy?: InputMaybe<Array<ChangelogsOrderBy>>;
};

/** All input for the `updateChangelogUserByChangelogIdAndUserId` mutation. */
export type UpdateChangelogUserByChangelogIdAndUserIdInput = {
  changelogId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ChangelogUser` being updated. */
  patch: ChangelogUserPatch;
  userId: Scalars['UUID'];
};

/** The output of our update `ChangelogUser` mutation. */
export type UpdateChangelogUserPayload = {
  __typename?: 'UpdateChangelogUserPayload';
  /** Reads a single `Changelog` that is related to this `ChangelogUser`. */
  changelog?: Maybe<Changelog>;
  /** The `ChangelogUser` that was updated by this mutation. */
  changelogUser?: Maybe<ChangelogUser>;
  /** An edge for our `ChangelogUser`. May be used by Relay 1. */
  changelogUserEdge?: Maybe<ChangelogUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ChangelogUser`. */
  user?: Maybe<User>;
};


/** The output of our update `ChangelogUser` mutation. */
export type UpdateChangelogUserPayloadChangelogUserEdgeArgs = {
  orderBy?: InputMaybe<Array<ChangelogUsersOrderBy>>;
};

/** All input for the `updateChosenColumnByUserIdAndTableName` mutation. */
export type UpdateChosenColumnByUserIdAndTableNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ChosenColumn` being updated. */
  patch: ChosenColumnPatch;
  tableName: Scalars['String'];
  userId: Scalars['UUID'];
};

/** The output of our update `ChosenColumn` mutation. */
export type UpdateChosenColumnPayload = {
  __typename?: 'UpdateChosenColumnPayload';
  /** The `ChosenColumn` that was updated by this mutation. */
  chosenColumn?: Maybe<ChosenColumn>;
  /** An edge for our `ChosenColumn`. May be used by Relay 1. */
  chosenColumnEdge?: Maybe<ChosenColumnsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ChosenColumn`. */
  user?: Maybe<User>;
};


/** The output of our update `ChosenColumn` mutation. */
export type UpdateChosenColumnPayloadChosenColumnEdgeArgs = {
  orderBy?: InputMaybe<Array<ChosenColumnsOrderBy>>;
};

/** All input for the `updateCompanyById` mutation. */
export type UpdateCompanyByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Company` being updated. */
  patch: CompanyPatch;
};

/** All input for the `updateCompanyCompanyTypeByCompanyId` mutation. */
export type UpdateCompanyCompanyTypeByCompanyIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CompanyCompanyType` being updated. */
  patch: CompanyCompanyTypePatch;
};

/** The output of our update `CompanyCompanyType` mutation. */
export type UpdateCompanyCompanyTypePayload = {
  __typename?: 'UpdateCompanyCompanyTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CompanyCompanyType`. */
  company?: Maybe<Company>;
  /** The `CompanyCompanyType` that was updated by this mutation. */
  companyCompanyType?: Maybe<CompanyCompanyType>;
  /** An edge for our `CompanyCompanyType`. May be used by Relay 1. */
  companyCompanyTypeEdge?: Maybe<CompanyCompanyTypesEdge>;
  /** Reads a single `CompanyType` that is related to this `CompanyCompanyType`. */
  companyType?: Maybe<CompanyType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CompanyCompanyType` mutation. */
export type UpdateCompanyCompanyTypePayloadCompanyCompanyTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyCompanyTypesOrderBy>>;
};

/** The output of our update `Company` mutation. */
export type UpdateCompanyPayload = {
  __typename?: 'UpdateCompanyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Company` that was updated by this mutation. */
  company?: Maybe<Company>;
  /** An edge for our `Company`. May be used by Relay 1. */
  companyEdge?: Maybe<CompaniesEdge>;
  /** Reads a single `Company` that is related to this `Company`. */
  masterForCompany?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Company` mutation. */
export type UpdateCompanyPayloadCompanyEdgeArgs = {
  orderBy?: InputMaybe<Array<CompaniesOrderBy>>;
};

/** All input for the `updateCompanySystemFieldById` mutation. */
export type UpdateCompanySystemFieldByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CompanySystemField` being updated. */
  patch: CompanySystemFieldPatch;
};

/** All input for the `updateCompanySystemFieldBySystemFieldIdAndCompanyId` mutation. */
export type UpdateCompanySystemFieldBySystemFieldIdAndCompanyIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CompanySystemField` being updated. */
  patch: CompanySystemFieldPatch;
  systemFieldId: Scalars['UUID'];
};

/** All input for the `updateCompanySystemFieldOptionById` mutation. */
export type UpdateCompanySystemFieldOptionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CompanySystemFieldOption` being updated. */
  patch: CompanySystemFieldOptionPatch;
};

/** The output of our update `CompanySystemFieldOption` mutation. */
export type UpdateCompanySystemFieldOptionPayload = {
  __typename?: 'UpdateCompanySystemFieldOptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CompanySystemFieldOption`. */
  company?: Maybe<Company>;
  /** Reads a single `CompanySystemField` that is related to this `CompanySystemFieldOption`. */
  companySystemField?: Maybe<CompanySystemField>;
  /** The `CompanySystemFieldOption` that was updated by this mutation. */
  companySystemFieldOption?: Maybe<CompanySystemFieldOption>;
  /** An edge for our `CompanySystemFieldOption`. May be used by Relay 1. */
  companySystemFieldOptionEdge?: Maybe<CompanySystemFieldOptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CompanySystemFieldOption` mutation. */
export type UpdateCompanySystemFieldOptionPayloadCompanySystemFieldOptionEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanySystemFieldOptionsOrderBy>>;
};

/** The output of our update `CompanySystemField` mutation. */
export type UpdateCompanySystemFieldPayload = {
  __typename?: 'UpdateCompanySystemFieldPayload';
  /** Reads a single `TranslatedEntity` that is related to this `CompanySystemField`. */
  aliasTranslatedEntity?: Maybe<TranslatedEntity>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CompanySystemField`. */
  company?: Maybe<Company>;
  /** The `CompanySystemField` that was updated by this mutation. */
  companySystemField?: Maybe<CompanySystemField>;
  /** An edge for our `CompanySystemField`. May be used by Relay 1. */
  companySystemFieldEdge?: Maybe<CompanySystemFieldsEdge>;
  /** Reads a single `FieldGroup` that is related to this `CompanySystemField`. */
  fieldGroup?: Maybe<FieldGroup>;
  /** Reads a single `FieldGroupCardColumn` that is related to this `CompanySystemField`. */
  fieldGroupCardColumn?: Maybe<FieldGroupCardColumn>;
  /** Reads a single `TranslatedEntity` that is related to this `CompanySystemField`. */
  helpTextTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SystemField` that is related to this `CompanySystemField`. */
  systemField?: Maybe<SystemField>;
};


/** The output of our update `CompanySystemField` mutation. */
export type UpdateCompanySystemFieldPayloadCompanySystemFieldEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanySystemFieldsOrderBy>>;
};

/** All input for the `updateCompanyTypeById` mutation. */
export type UpdateCompanyTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CompanyType` being updated. */
  patch: CompanyTypePatch;
};

/** The output of our update `CompanyType` mutation. */
export type UpdateCompanyTypePayload = {
  __typename?: 'UpdateCompanyTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CompanyType` that was updated by this mutation. */
  companyType?: Maybe<CompanyType>;
  /** An edge for our `CompanyType`. May be used by Relay 1. */
  companyTypeEdge?: Maybe<CompanyTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CompanyType` mutation. */
export type UpdateCompanyTypePayloadCompanyTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<CompanyTypesOrderBy>>;
};

/** All input for the `updateCompetenceById` mutation. */
export type UpdateCompetenceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Competence` being updated. */
  patch: CompetencePatch;
};

/** All input for the `updateCompetenceFormFieldById` mutation. */
export type UpdateCompetenceFormFieldByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CompetenceFormField` being updated. */
  patch: CompetenceFormFieldPatch;
};

/** The output of our update `CompetenceFormField` mutation. */
export type UpdateCompetenceFormFieldPayload = {
  __typename?: 'UpdateCompetenceFormFieldPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CompetenceFormField`. */
  company?: Maybe<Company>;
  /** Reads a single `Competence` that is related to this `CompetenceFormField`. */
  competence?: Maybe<Competence>;
  /** The `CompetenceFormField` that was updated by this mutation. */
  competenceFormField?: Maybe<CompetenceFormField>;
  /** An edge for our `CompetenceFormField`. May be used by Relay 1. */
  competenceFormFieldEdge?: Maybe<CompetenceFormFieldsEdge>;
  /** Reads a single `FormField` that is related to this `CompetenceFormField`. */
  formField?: Maybe<FormField>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CompetenceFormField` mutation. */
export type UpdateCompetenceFormFieldPayloadCompetenceFormFieldEdgeArgs = {
  orderBy?: InputMaybe<Array<CompetenceFormFieldsOrderBy>>;
};

/** All input for the `updateCompetenceGroupById` mutation. */
export type UpdateCompetenceGroupByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CompetenceGroup` being updated. */
  patch: CompetenceGroupPatch;
};

/** The output of our update `CompetenceGroup` mutation. */
export type UpdateCompetenceGroupPayload = {
  __typename?: 'UpdateCompetenceGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CompetenceGroup`. */
  company?: Maybe<Company>;
  /** The `CompetenceGroup` that was updated by this mutation. */
  competenceGroup?: Maybe<CompetenceGroup>;
  /** An edge for our `CompetenceGroup`. May be used by Relay 1. */
  competenceGroupEdge?: Maybe<CompetenceGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CompetenceGroup` mutation. */
export type UpdateCompetenceGroupPayloadCompetenceGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<CompetenceGroupsOrderBy>>;
};

/** The output of our update `Competence` mutation. */
export type UpdateCompetencePayload = {
  __typename?: 'UpdateCompetencePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Competence`. */
  company?: Maybe<Company>;
  /** The `Competence` that was updated by this mutation. */
  competence?: Maybe<Competence>;
  /** An edge for our `Competence`. May be used by Relay 1. */
  competenceEdge?: Maybe<CompetencesEdge>;
  /** Reads a single `CompetenceGroup` that is related to this `Competence`. */
  competenceGroup?: Maybe<CompetenceGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `FormField` that is related to this `Competence`. */
  ratingFormField?: Maybe<FormField>;
};


/** The output of our update `Competence` mutation. */
export type UpdateCompetencePayloadCompetenceEdgeArgs = {
  orderBy?: InputMaybe<Array<CompetencesOrderBy>>;
};

/** All input for the `updateCompetenceRequestById` mutation. */
export type UpdateCompetenceRequestByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CompetenceRequest` being updated. */
  patch: CompetenceRequestPatch;
};

/** The output of our update `CompetenceRequest` mutation. */
export type UpdateCompetenceRequestPayload = {
  __typename?: 'UpdateCompetenceRequestPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CompetenceRequest`. */
  company?: Maybe<Company>;
  /** Reads a single `Competence` that is related to this `CompetenceRequest`. */
  competence?: Maybe<Competence>;
  /** The `CompetenceRequest` that was updated by this mutation. */
  competenceRequest?: Maybe<CompetenceRequest>;
  /** An edge for our `CompetenceRequest`. May be used by Relay 1. */
  competenceRequestEdge?: Maybe<CompetenceRequestsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CompetenceRequest` mutation. */
export type UpdateCompetenceRequestPayloadCompetenceRequestEdgeArgs = {
  orderBy?: InputMaybe<Array<CompetenceRequestsOrderBy>>;
};

/** All input for the `updateContractPredefinedPlaceholderById` mutation. */
export type UpdateContractPredefinedPlaceholderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ContractPredefinedPlaceholder` being updated. */
  patch: ContractPredefinedPlaceholderPatch;
};

/** The output of our update `ContractPredefinedPlaceholder` mutation. */
export type UpdateContractPredefinedPlaceholderPayload = {
  __typename?: 'UpdateContractPredefinedPlaceholderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ContractPredefinedPlaceholder` that was updated by this mutation. */
  contractPredefinedPlaceholder?: Maybe<ContractPredefinedPlaceholder>;
  /** An edge for our `ContractPredefinedPlaceholder`. May be used by Relay 1. */
  contractPredefinedPlaceholderEdge?: Maybe<ContractPredefinedPlaceholdersEdge>;
  /** Reads a single `FormField` that is related to this `ContractPredefinedPlaceholder`. */
  formField?: Maybe<FormField>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ContractPredefinedPlaceholder` mutation. */
export type UpdateContractPredefinedPlaceholderPayloadContractPredefinedPlaceholderEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractPredefinedPlaceholdersOrderBy>>;
};

/** All input for the `updateContractSignPendingById` mutation. */
export type UpdateContractSignPendingByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ContractSignPending` being updated. */
  patch: ContractSignPendingPatch;
};

/** All input for the `updateContractSignPendingDocumentById` mutation. */
export type UpdateContractSignPendingDocumentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ContractSignPendingDocument` being updated. */
  patch: ContractSignPendingDocumentPatch;
};

/** The output of our update `ContractSignPendingDocument` mutation. */
export type UpdateContractSignPendingDocumentPayload = {
  __typename?: 'UpdateContractSignPendingDocumentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ContractSignPendingDocument`. */
  company?: Maybe<Company>;
  /** Reads a single `ContractSignPending` that is related to this `ContractSignPendingDocument`. */
  contractSignPending?: Maybe<ContractSignPending>;
  /** The `ContractSignPendingDocument` that was updated by this mutation. */
  contractSignPendingDocument?: Maybe<ContractSignPendingDocument>;
  /** An edge for our `ContractSignPendingDocument`. May be used by Relay 1. */
  contractSignPendingDocumentEdge?: Maybe<ContractSignPendingDocumentsEdge>;
  /** Reads a single `ContractTemplate` that is related to this `ContractSignPendingDocument`. */
  contractTemplate?: Maybe<ContractTemplate>;
  /** Reads a single `DocumentType` that is related to this `ContractSignPendingDocument`. */
  documentType?: Maybe<DocumentType>;
  /** Reads a single `Storage` that is related to this `ContractSignPendingDocument`. */
  existingStorage?: Maybe<Storage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ContractSignPendingDocument` mutation. */
export type UpdateContractSignPendingDocumentPayloadContractSignPendingDocumentEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractSignPendingDocumentsOrderBy>>;
};

/** The output of our update `ContractSignPending` mutation. */
export type UpdateContractSignPendingPayload = {
  __typename?: 'UpdateContractSignPendingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ContractSignPending`. */
  company?: Maybe<Company>;
  /** The `ContractSignPending` that was updated by this mutation. */
  contractSignPending?: Maybe<ContractSignPending>;
  /** An edge for our `ContractSignPending`. May be used by Relay 1. */
  contractSignPendingEdge?: Maybe<ContractSignPendingsEdge>;
  /** Reads a single `User` that is related to this `ContractSignPending`. */
  creatorUser?: Maybe<User>;
  /** Reads a single `Employee` that is related to this `ContractSignPending`. */
  employee?: Maybe<Employee>;
  /** Reads a single `DocumentType` that is related to this `ContractSignPending`. */
  mergedDocumentDocumentType?: Maybe<DocumentType>;
  /** Reads a single `User` that is related to this `ContractSignPending`. */
  nextSigningUser?: Maybe<User>;
  /** Reads a single `PreboardingEmployee` that is related to this `ContractSignPending`. */
  preboardingEmployee?: Maybe<PreboardingEmployee>;
  /** Reads a single `PreboardingSlideFormField` that is related to this `ContractSignPending`. */
  preboardingSlideFormField?: Maybe<PreboardingSlideFormField>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ContractSignPending`. */
  user?: Maybe<User>;
};


/** The output of our update `ContractSignPending` mutation. */
export type UpdateContractSignPendingPayloadContractSignPendingEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractSignPendingsOrderBy>>;
};

/** All input for the `updateContractSignPendingSignerByContractSignPendingIdAndUserId` mutation. */
export type UpdateContractSignPendingSignerByContractSignPendingIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contractSignPendingId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ContractSignPendingSigner` being updated. */
  patch: ContractSignPendingSignerPatch;
  userId: Scalars['UUID'];
};

/** All input for the `updateContractSignPendingSignerById` mutation. */
export type UpdateContractSignPendingSignerByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ContractSignPendingSigner` being updated. */
  patch: ContractSignPendingSignerPatch;
};

/** The output of our update `ContractSignPendingSigner` mutation. */
export type UpdateContractSignPendingSignerPayload = {
  __typename?: 'UpdateContractSignPendingSignerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ContractSignPendingSigner`. */
  company?: Maybe<Company>;
  /** Reads a single `ContractSignPending` that is related to this `ContractSignPendingSigner`. */
  contractSignPending?: Maybe<ContractSignPending>;
  /** The `ContractSignPendingSigner` that was updated by this mutation. */
  contractSignPendingSigner?: Maybe<ContractSignPendingSigner>;
  /** An edge for our `ContractSignPendingSigner`. May be used by Relay 1. */
  contractSignPendingSignerEdge?: Maybe<ContractSignPendingSignersEdge>;
  /** Reads a single `User` that is related to this `ContractSignPendingSigner`. */
  onBehalfOfUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Storage` that is related to this `ContractSignPendingSigner`. */
  signatureFile?: Maybe<Storage>;
  /** Reads a single `User` that is related to this `ContractSignPendingSigner`. */
  user?: Maybe<User>;
};


/** The output of our update `ContractSignPendingSigner` mutation. */
export type UpdateContractSignPendingSignerPayloadContractSignPendingSignerEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractSignPendingSignersOrderBy>>;
};

/** All input for the `updateContractTemplateById` mutation. */
export type UpdateContractTemplateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ContractTemplate` being updated. */
  patch: ContractTemplatePatch;
};

/** All input for the `updateContractTemplateDepartmentByContractTemplateIdAndDepartmentId` mutation. */
export type UpdateContractTemplateDepartmentByContractTemplateIdAndDepartmentIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contractTemplateId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ContractTemplateDepartment` being updated. */
  patch: ContractTemplateDepartmentPatch;
};

/** The output of our update `ContractTemplateDepartment` mutation. */
export type UpdateContractTemplateDepartmentPayload = {
  __typename?: 'UpdateContractTemplateDepartmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ContractTemplateDepartment`. */
  company?: Maybe<Company>;
  /** Reads a single `ContractTemplate` that is related to this `ContractTemplateDepartment`. */
  contractTemplate?: Maybe<ContractTemplate>;
  /** The `ContractTemplateDepartment` that was updated by this mutation. */
  contractTemplateDepartment?: Maybe<ContractTemplateDepartment>;
  /** An edge for our `ContractTemplateDepartment`. May be used by Relay 1. */
  contractTemplateDepartmentEdge?: Maybe<ContractTemplateDepartmentsEdge>;
  /** Reads a single `Department` that is related to this `ContractTemplateDepartment`. */
  department?: Maybe<Department>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ContractTemplateDepartment` mutation. */
export type UpdateContractTemplateDepartmentPayloadContractTemplateDepartmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractTemplateDepartmentsOrderBy>>;
};

/** The output of our update `ContractTemplate` mutation. */
export type UpdateContractTemplatePayload = {
  __typename?: 'UpdateContractTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ContractTemplate` that was updated by this mutation. */
  contractTemplate?: Maybe<ContractTemplate>;
  /** An edge for our `ContractTemplate`. May be used by Relay 1. */
  contractTemplateEdge?: Maybe<ContractTemplatesEdge>;
  /** Reads a single `DocumentType` that is related to this `ContractTemplate`. */
  documentType?: Maybe<DocumentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ContractTemplate` mutation. */
export type UpdateContractTemplatePayloadContractTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractTemplatesOrderBy>>;
};

/** All input for the `updateContractTemplateUserByUserIdAndContractTemplateId` mutation. */
export type UpdateContractTemplateUserByUserIdAndContractTemplateIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contractTemplateId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ContractTemplateUser` being updated. */
  patch: ContractTemplateUserPatch;
  userId: Scalars['UUID'];
};

/** The output of our update `ContractTemplateUser` mutation. */
export type UpdateContractTemplateUserPayload = {
  __typename?: 'UpdateContractTemplateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ContractTemplateUser`. */
  company?: Maybe<Company>;
  /** Reads a single `ContractTemplate` that is related to this `ContractTemplateUser`. */
  contractTemplate?: Maybe<ContractTemplate>;
  /** The `ContractTemplateUser` that was updated by this mutation. */
  contractTemplateUser?: Maybe<ContractTemplateUser>;
  /** An edge for our `ContractTemplateUser`. May be used by Relay 1. */
  contractTemplateUserEdge?: Maybe<ContractTemplateUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ContractTemplateUser`. */
  user?: Maybe<User>;
};


/** The output of our update `ContractTemplateUser` mutation. */
export type UpdateContractTemplateUserPayloadContractTemplateUserEdgeArgs = {
  orderBy?: InputMaybe<Array<ContractTemplateUsersOrderBy>>;
};

/** All input for the `updateCredential` mutation. */
export type UpdateCredentialInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  newPassword: Scalars['String'];
};

/** The output of our `updateCredential` mutation. */
export type UpdateCredentialPayload = {
  __typename?: 'UpdateCredentialPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateCustomWidgetById` mutation. */
export type UpdateCustomWidgetByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CustomWidget` being updated. */
  patch: CustomWidgetPatch;
};

/** All input for the `updateCustomWidgetContentById` mutation. */
export type UpdateCustomWidgetContentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CustomWidgetContent` being updated. */
  patch: CustomWidgetContentPatch;
};

/** The output of our update `CustomWidgetContent` mutation. */
export type UpdateCustomWidgetContentPayload = {
  __typename?: 'UpdateCustomWidgetContentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CustomWidgetContent`. */
  company?: Maybe<Company>;
  /** Reads a single `CustomWidget` that is related to this `CustomWidgetContent`. */
  customWidget?: Maybe<CustomWidget>;
  /** The `CustomWidgetContent` that was updated by this mutation. */
  customWidgetContent?: Maybe<CustomWidgetContent>;
  /** An edge for our `CustomWidgetContent`. May be used by Relay 1. */
  customWidgetContentEdge?: Maybe<CustomWidgetContentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CustomWidgetContent` mutation. */
export type UpdateCustomWidgetContentPayloadCustomWidgetContentEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomWidgetContentsOrderBy>>;
};

/** The output of our update `CustomWidget` mutation. */
export type UpdateCustomWidgetPayload = {
  __typename?: 'UpdateCustomWidgetPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CustomWidget`. */
  company?: Maybe<Company>;
  /** The `CustomWidget` that was updated by this mutation. */
  customWidget?: Maybe<CustomWidget>;
  /** An edge for our `CustomWidget`. May be used by Relay 1. */
  customWidgetEdge?: Maybe<CustomWidgetsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CustomWidget` mutation. */
export type UpdateCustomWidgetPayloadCustomWidgetEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomWidgetsOrderBy>>;
};

/** All input for the `updateCvTemplateFieldMappingById` mutation. */
export type UpdateCvTemplateFieldMappingByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `CvTemplateFieldMapping` being updated. */
  patch: CvTemplateFieldMappingPatch;
};

/** The output of our update `CvTemplateFieldMapping` mutation. */
export type UpdateCvTemplateFieldMappingPayload = {
  __typename?: 'UpdateCvTemplateFieldMappingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `CvTemplateFieldMapping`. */
  company?: Maybe<Company>;
  /** The `CvTemplateFieldMapping` that was updated by this mutation. */
  cvTemplateFieldMapping?: Maybe<CvTemplateFieldMapping>;
  /** An edge for our `CvTemplateFieldMapping`. May be used by Relay 1. */
  cvTemplateFieldMappingEdge?: Maybe<CvTemplateFieldMappingsEdge>;
  /** Reads a single `FormField` that is related to this `CvTemplateFieldMapping`. */
  formField?: Maybe<FormField>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SystemField` that is related to this `CvTemplateFieldMapping`. */
  systemField?: Maybe<SystemField>;
};


/** The output of our update `CvTemplateFieldMapping` mutation. */
export type UpdateCvTemplateFieldMappingPayloadCvTemplateFieldMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<CvTemplateFieldMappingsOrderBy>>;
};

/** All input for the `updateDashboardCardById` mutation. */
export type UpdateDashboardCardByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `DashboardCard` being updated. */
  patch: DashboardCardPatch;
};

/** The output of our update `DashboardCard` mutation. */
export type UpdateDashboardCardPayload = {
  __typename?: 'UpdateDashboardCardPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DashboardCard`. */
  company?: Maybe<Company>;
  /** Reads a single `CustomWidget` that is related to this `DashboardCard`. */
  customWidget?: Maybe<CustomWidget>;
  /** The `DashboardCard` that was updated by this mutation. */
  dashboardCard?: Maybe<DashboardCard>;
  /** An edge for our `DashboardCard`. May be used by Relay 1. */
  dashboardCardEdge?: Maybe<DashboardCardsEdge>;
  /** Reads a single `DashboardView` that is related to this `DashboardCard`. */
  dashboardView?: Maybe<DashboardView>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DashboardCard` mutation. */
export type UpdateDashboardCardPayloadDashboardCardEdgeArgs = {
  orderBy?: InputMaybe<Array<DashboardCardsOrderBy>>;
};

/** All input for the `updateDashboardCardStatisticById` mutation. */
export type UpdateDashboardCardStatisticByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `DashboardCardStatistic` being updated. */
  patch: DashboardCardStatisticPatch;
};

/** The output of our update `DashboardCardStatistic` mutation. */
export type UpdateDashboardCardStatisticPayload = {
  __typename?: 'UpdateDashboardCardStatisticPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DashboardCardStatistic`. */
  company?: Maybe<Company>;
  /** Reads a single `DashboardCard` that is related to this `DashboardCardStatistic`. */
  dashboardCard?: Maybe<DashboardCard>;
  /** The `DashboardCardStatistic` that was updated by this mutation. */
  dashboardCardStatistic?: Maybe<DashboardCardStatistic>;
  /** An edge for our `DashboardCardStatistic`. May be used by Relay 1. */
  dashboardCardStatisticEdge?: Maybe<DashboardCardStatisticsEdge>;
  /** Reads a single `DashboardView` that is related to this `DashboardCardStatistic`. */
  dashboardView?: Maybe<DashboardView>;
  /** Reads a single `FormField` that is related to this `DashboardCardStatistic`. */
  formField?: Maybe<FormField>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SystemField` that is related to this `DashboardCardStatistic`. */
  systemField?: Maybe<SystemField>;
};


/** The output of our update `DashboardCardStatistic` mutation. */
export type UpdateDashboardCardStatisticPayloadDashboardCardStatisticEdgeArgs = {
  orderBy?: InputMaybe<Array<DashboardCardStatisticsOrderBy>>;
};

/** All input for the `updateDashboardConfigByCompanyId` mutation. */
export type UpdateDashboardConfigByCompanyIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `DashboardConfig` being updated. */
  patch: DashboardConfigPatch;
};

/** The output of our update `DashboardConfig` mutation. */
export type UpdateDashboardConfigPayload = {
  __typename?: 'UpdateDashboardConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DashboardConfig`. */
  company?: Maybe<Company>;
  /** The `DashboardConfig` that was updated by this mutation. */
  dashboardConfig?: Maybe<DashboardConfig>;
  /** An edge for our `DashboardConfig`. May be used by Relay 1. */
  dashboardConfigEdge?: Maybe<DashboardConfigsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DashboardConfig` mutation. */
export type UpdateDashboardConfigPayloadDashboardConfigEdgeArgs = {
  orderBy?: InputMaybe<Array<DashboardConfigsOrderBy>>;
};

/** All input for the `updateDashboardViewById` mutation. */
export type UpdateDashboardViewByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `DashboardView` being updated. */
  patch: DashboardViewPatch;
};

/** The output of our update `DashboardView` mutation. */
export type UpdateDashboardViewPayload = {
  __typename?: 'UpdateDashboardViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DashboardView`. */
  company?: Maybe<Company>;
  /** The `DashboardView` that was updated by this mutation. */
  dashboardView?: Maybe<DashboardView>;
  /** An edge for our `DashboardView`. May be used by Relay 1. */
  dashboardViewEdge?: Maybe<DashboardViewsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DashboardView` mutation. */
export type UpdateDashboardViewPayloadDashboardViewEdgeArgs = {
  orderBy?: InputMaybe<Array<DashboardViewsOrderBy>>;
};

/** All input for the `updateDepartmentById` mutation. */
export type UpdateDepartmentByIdInput = {
  changedFormFieldIds?: InputMaybe<Array<Scalars['UUID']>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Department` being updated. */
  patch: DepartmentPatch;
};

/** All input for the `updateDepartmentColumns` mutation. */
export type UpdateDepartmentColumnsInput = {
  argUserId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `updateDepartmentColumns` mutation. */
export type UpdateDepartmentColumnsPayload = {
  __typename?: 'UpdateDepartmentColumnsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Department` mutation. */
export type UpdateDepartmentPayload = {
  __typename?: 'UpdateDepartmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Department`. */
  company?: Maybe<Company>;
  /** The `Department` that was updated by this mutation. */
  department?: Maybe<Department>;
  /** An edge for our `Department`. May be used by Relay 1. */
  departmentEdge?: Maybe<DepartmentsEdge>;
  /** Reads a single `DepartmentType` that is related to this `Department`. */
  departmentType?: Maybe<DepartmentType>;
  /** Reads a single `Department` that is related to this `Department`. */
  parentDepartment?: Maybe<Department>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Department` mutation. */
export type UpdateDepartmentPayloadDepartmentEdgeArgs = {
  orderBy?: InputMaybe<Array<DepartmentsOrderBy>>;
};

/** All input for the `updateDepartmentTypeById` mutation. */
export type UpdateDepartmentTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `DepartmentType` being updated. */
  patch: DepartmentTypePatch;
};

/** The output of our update `DepartmentType` mutation. */
export type UpdateDepartmentTypePayload = {
  __typename?: 'UpdateDepartmentTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DepartmentType`. */
  company?: Maybe<Company>;
  /** The `DepartmentType` that was updated by this mutation. */
  departmentType?: Maybe<DepartmentType>;
  /** An edge for our `DepartmentType`. May be used by Relay 1. */
  departmentTypeEdge?: Maybe<DepartmentTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DepartmentType` mutation. */
export type UpdateDepartmentTypePayloadDepartmentTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<DepartmentTypesOrderBy>>;
};

/** All input for the `updateDocumentDepartmentPermissionByFileIdAndDepartmentId` mutation. */
export type UpdateDocumentDepartmentPermissionByFileIdAndDepartmentIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  departmentId: Scalars['UUID'];
  fileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `DocumentDepartmentPermission` being updated. */
  patch: DocumentDepartmentPermissionPatch;
};

/** The output of our update `DocumentDepartmentPermission` mutation. */
export type UpdateDocumentDepartmentPermissionPayload = {
  __typename?: 'UpdateDocumentDepartmentPermissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentDepartmentPermission`. */
  company?: Maybe<Company>;
  /** Reads a single `Department` that is related to this `DocumentDepartmentPermission`. */
  department?: Maybe<Department>;
  /** The `DocumentDepartmentPermission` that was updated by this mutation. */
  documentDepartmentPermission?: Maybe<DocumentDepartmentPermission>;
  /** An edge for our `DocumentDepartmentPermission`. May be used by Relay 1. */
  documentDepartmentPermissionEdge?: Maybe<DocumentDepartmentPermissionsEdge>;
  /** Reads a single `Storage` that is related to this `DocumentDepartmentPermission`. */
  file?: Maybe<Storage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DocumentDepartmentPermission` mutation. */
export type UpdateDocumentDepartmentPermissionPayloadDocumentDepartmentPermissionEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentDepartmentPermissionsOrderBy>>;
};

/** All input for the `updateDocumentFolderBlueprintById` mutation. */
export type UpdateDocumentFolderBlueprintByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `DocumentFolderBlueprint` being updated. */
  patch: DocumentFolderBlueprintPatch;
};

/** The output of our update `DocumentFolderBlueprint` mutation. */
export type UpdateDocumentFolderBlueprintPayload = {
  __typename?: 'UpdateDocumentFolderBlueprintPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentFolderBlueprint`. */
  company?: Maybe<Company>;
  /** The `DocumentFolderBlueprint` that was updated by this mutation. */
  documentFolderBlueprint?: Maybe<DocumentFolderBlueprint>;
  /** An edge for our `DocumentFolderBlueprint`. May be used by Relay 1. */
  documentFolderBlueprintEdge?: Maybe<DocumentFolderBlueprintsEdge>;
  /** Reads a single `DocumentFolderBlueprint` that is related to this `DocumentFolderBlueprint`. */
  parentDocumentFolderBlueprint?: Maybe<DocumentFolderBlueprint>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DocumentFolderBlueprint` mutation. */
export type UpdateDocumentFolderBlueprintPayloadDocumentFolderBlueprintEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentFolderBlueprintsOrderBy>>;
};

/** All input for the `updateDocumentFolderById` mutation. */
export type UpdateDocumentFolderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `DocumentFolder` being updated. */
  patch: DocumentFolderPatch;
};

/** All input for the `updateDocumentFolderDepartmentByDocumentFolderIdAndDepartmentId` mutation. */
export type UpdateDocumentFolderDepartmentByDocumentFolderIdAndDepartmentIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  departmentId: Scalars['UUID'];
  documentFolderId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `DocumentFolderDepartment` being updated. */
  patch: DocumentFolderDepartmentPatch;
};

/** The output of our update `DocumentFolderDepartment` mutation. */
export type UpdateDocumentFolderDepartmentPayload = {
  __typename?: 'UpdateDocumentFolderDepartmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentFolderDepartment`. */
  company?: Maybe<Company>;
  /** Reads a single `Department` that is related to this `DocumentFolderDepartment`. */
  department?: Maybe<Department>;
  /** Reads a single `DocumentFolder` that is related to this `DocumentFolderDepartment`. */
  documentFolder?: Maybe<DocumentFolder>;
  /** The `DocumentFolderDepartment` that was updated by this mutation. */
  documentFolderDepartment?: Maybe<DocumentFolderDepartment>;
  /** An edge for our `DocumentFolderDepartment`. May be used by Relay 1. */
  documentFolderDepartmentEdge?: Maybe<DocumentFolderDepartmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DocumentFolderDepartment` mutation. */
export type UpdateDocumentFolderDepartmentPayloadDocumentFolderDepartmentEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentFolderDepartmentsOrderBy>>;
};

/** The output of our update `DocumentFolder` mutation. */
export type UpdateDocumentFolderPayload = {
  __typename?: 'UpdateDocumentFolderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentFolder`. */
  company?: Maybe<Company>;
  /** The `DocumentFolder` that was updated by this mutation. */
  documentFolder?: Maybe<DocumentFolder>;
  /** Reads a single `DocumentFolderBlueprint` that is related to this `DocumentFolder`. */
  documentFolderBlueprint?: Maybe<DocumentFolderBlueprint>;
  /** An edge for our `DocumentFolder`. May be used by Relay 1. */
  documentFolderEdge?: Maybe<DocumentFoldersEdge>;
  /** Reads a single `DocumentFolder` that is related to this `DocumentFolder`. */
  parentDocumentFolder?: Maybe<DocumentFolder>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentFolderBlueprint` that is related to this `DocumentFolder`. */
  rootDocumentFolderBlueprint?: Maybe<DocumentFolderBlueprint>;
};


/** The output of our update `DocumentFolder` mutation. */
export type UpdateDocumentFolderPayloadDocumentFolderEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentFoldersOrderBy>>;
};

/** All input for the `updateDocumentFolderUserByDocumentFolderIdAndUserId` mutation. */
export type UpdateDocumentFolderUserByDocumentFolderIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  documentFolderId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `DocumentFolderUser` being updated. */
  patch: DocumentFolderUserPatch;
  userId: Scalars['UUID'];
};

/** The output of our update `DocumentFolderUser` mutation. */
export type UpdateDocumentFolderUserPayload = {
  __typename?: 'UpdateDocumentFolderUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentFolderUser`. */
  company?: Maybe<Company>;
  /** Reads a single `DocumentFolder` that is related to this `DocumentFolderUser`. */
  documentFolder?: Maybe<DocumentFolder>;
  /** The `DocumentFolderUser` that was updated by this mutation. */
  documentFolderUser?: Maybe<DocumentFolderUser>;
  /** An edge for our `DocumentFolderUser`. May be used by Relay 1. */
  documentFolderUserEdge?: Maybe<DocumentFolderUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `DocumentFolderUser`. */
  user?: Maybe<User>;
};


/** The output of our update `DocumentFolderUser` mutation. */
export type UpdateDocumentFolderUserPayloadDocumentFolderUserEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentFolderUsersOrderBy>>;
};

/** All input for the `updateDocumentTypeByCompanyIdAndDepartmentIdAndName` mutation. */
export type UpdateDocumentTypeByCompanyIdAndDepartmentIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `DocumentType` being updated. */
  patch: DocumentTypePatch;
};

/** All input for the `updateDocumentTypeById` mutation. */
export type UpdateDocumentTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `DocumentType` being updated. */
  patch: DocumentTypePatch;
};

/** The output of our update `DocumentType` mutation. */
export type UpdateDocumentTypePayload = {
  __typename?: 'UpdateDocumentTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `DocumentType` that was updated by this mutation. */
  documentType?: Maybe<DocumentType>;
  /** An edge for our `DocumentType`. May be used by Relay 1. */
  documentTypeEdge?: Maybe<DocumentTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DocumentType` mutation. */
export type UpdateDocumentTypePayloadDocumentTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentTypesOrderBy>>;
};

/** All input for the `updateDocumentUserPermissionByFileIdAndUserId` mutation. */
export type UpdateDocumentUserPermissionByFileIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `DocumentUserPermission` being updated. */
  patch: DocumentUserPermissionPatch;
  userId: Scalars['UUID'];
};

/** The output of our update `DocumentUserPermission` mutation. */
export type UpdateDocumentUserPermissionPayload = {
  __typename?: 'UpdateDocumentUserPermissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentUserPermission`. */
  company?: Maybe<Company>;
  /** Reads a single `DocumentType` that is related to this `DocumentUserPermission`. */
  documentType?: Maybe<DocumentType>;
  /** The `DocumentUserPermission` that was updated by this mutation. */
  documentUserPermission?: Maybe<DocumentUserPermission>;
  /** An edge for our `DocumentUserPermission`. May be used by Relay 1. */
  documentUserPermissionEdge?: Maybe<DocumentUserPermissionsEdge>;
  /** Reads a single `Storage` that is related to this `DocumentUserPermission`. */
  file?: Maybe<Storage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `DocumentUserPermission`. */
  user?: Maybe<User>;
};


/** The output of our update `DocumentUserPermission` mutation. */
export type UpdateDocumentUserPermissionPayloadDocumentUserPermissionEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentUserPermissionsOrderBy>>;
};

/** All input for the `updateDocumentUserResponsibleByFileIdAndUserId` mutation. */
export type UpdateDocumentUserResponsibleByFileIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fileId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `DocumentUserResponsible` being updated. */
  patch: DocumentUserResponsiblePatch;
  userId: Scalars['UUID'];
};

/** The output of our update `DocumentUserResponsible` mutation. */
export type UpdateDocumentUserResponsiblePayload = {
  __typename?: 'UpdateDocumentUserResponsiblePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `DocumentUserResponsible`. */
  company?: Maybe<Company>;
  /** Reads a single `DocumentType` that is related to this `DocumentUserResponsible`. */
  documentType?: Maybe<DocumentType>;
  /** The `DocumentUserResponsible` that was updated by this mutation. */
  documentUserResponsible?: Maybe<DocumentUserResponsible>;
  /** An edge for our `DocumentUserResponsible`. May be used by Relay 1. */
  documentUserResponsibleEdge?: Maybe<DocumentUserResponsiblesEdge>;
  /** Reads a single `Storage` that is related to this `DocumentUserResponsible`. */
  file?: Maybe<Storage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `DocumentUserResponsible`. */
  user?: Maybe<User>;
  /** Reads a single `User` that is related to this `DocumentUserResponsible`. */
  userByAssignedBy?: Maybe<User>;
};


/** The output of our update `DocumentUserResponsible` mutation. */
export type UpdateDocumentUserResponsiblePayloadDocumentUserResponsibleEdgeArgs = {
  orderBy?: InputMaybe<Array<DocumentUserResponsiblesOrderBy>>;
};

/** All input for the `updateEmployeeById` mutation. */
export type UpdateEmployeeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Employee` being updated. */
  patch: EmployeePatch;
};

/** All input for the `updateEmployeeByUserId` mutation. */
export type UpdateEmployeeByUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Employee` being updated. */
  patch: EmployeePatch;
  userId: Scalars['UUID'];
};

/** All input for the `updateEmployeeCasefileByEmployeeIdAndCasefileId` mutation. */
export type UpdateEmployeeCasefileByEmployeeIdAndCasefileIdInput = {
  casefileId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `EmployeeCasefile` being updated. */
  patch: EmployeeCasefilePatch;
};

/** All input for the `updateEmployeeCasefileById` mutation. */
export type UpdateEmployeeCasefileByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `EmployeeCasefile` being updated. */
  patch: EmployeeCasefilePatch;
};

/** The output of our update `EmployeeCasefile` mutation. */
export type UpdateEmployeeCasefilePayload = {
  __typename?: 'UpdateEmployeeCasefilePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `EmployeeCasefile`. */
  company?: Maybe<Company>;
  /** Reads a single `User` that is related to this `EmployeeCasefile`. */
  creatorUser?: Maybe<User>;
  /** Reads a single `DocumentType` that is related to this `EmployeeCasefile`. */
  documentType?: Maybe<DocumentType>;
  /** Reads a single `Employee` that is related to this `EmployeeCasefile`. */
  employee?: Maybe<Employee>;
  /** The `EmployeeCasefile` that was updated by this mutation. */
  employeeCasefile?: Maybe<EmployeeCasefile>;
  /** An edge for our `EmployeeCasefile`. May be used by Relay 1. */
  employeeCasefileEdge?: Maybe<EmployeeCasefilesEdge>;
  /** Reads a single `User` that is related to this `EmployeeCasefile`. */
  nextSigningUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmployeeCasefile`. */
  user?: Maybe<User>;
};


/** The output of our update `EmployeeCasefile` mutation. */
export type UpdateEmployeeCasefilePayloadEmployeeCasefileEdgeArgs = {
  orderBy?: InputMaybe<Array<EmployeeCasefilesOrderBy>>;
};

export type UpdateEmployeeDataBasedOnSignedContractInput = {
  contractSignPendingDocumentId: Scalars['UUID'];
  fieldsToUpdate: Array<Scalars['UUID']>;
};

export type UpdateEmployeeDataBasedOnSignedContractPayload = {
  __typename?: 'UpdateEmployeeDataBasedOnSignedContractPayload';
  fieldIdErrors?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};

/** All input for the `updateEmployeeExternalIntegrationByEmployeeIdAndExternalIntegrationId` mutation. */
export type UpdateEmployeeExternalIntegrationByEmployeeIdAndExternalIntegrationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `EmployeeExternalIntegration` being updated. */
  patch: EmployeeExternalIntegrationPatch;
};

/** All input for the `updateEmployeeExternalIntegrationBySameSystem` mutation. */
export type UpdateEmployeeExternalIntegrationBySameSystemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `EmployeeExternalIntegration` being updated. */
  patch: EmployeeExternalIntegrationPatch;
  sameSystem: Scalars['String'];
};

/** The output of our update `EmployeeExternalIntegration` mutation. */
export type UpdateEmployeeExternalIntegrationPayload = {
  __typename?: 'UpdateEmployeeExternalIntegrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `EmployeeExternalIntegration`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `EmployeeExternalIntegration`. */
  employee?: Maybe<Employee>;
  /** The `EmployeeExternalIntegration` that was updated by this mutation. */
  employeeExternalIntegration?: Maybe<EmployeeExternalIntegration>;
  /** An edge for our `EmployeeExternalIntegration`. May be used by Relay 1. */
  employeeExternalIntegrationEdge?: Maybe<EmployeeExternalIntegrationsEdge>;
  /** Reads a single `ExternalIntegration` that is related to this `EmployeeExternalIntegration`. */
  externalIntegration?: Maybe<ExternalIntegration>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `EmployeeExternalIntegration` mutation. */
export type UpdateEmployeeExternalIntegrationPayloadEmployeeExternalIntegrationEdgeArgs = {
  orderBy?: InputMaybe<Array<EmployeeExternalIntegrationsOrderBy>>;
};

/** All input for the `updateEmployeeGroupIds` mutation. */
export type UpdateEmployeeGroupIdsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `updateEmployeeGroupIds` mutation. */
export type UpdateEmployeeGroupIdsPayload = {
  __typename?: 'UpdateEmployeeGroupIdsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our update `Employee` mutation. */
export type UpdateEmployeePayload = {
  __typename?: 'UpdateEmployeePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Employee`. */
  company?: Maybe<Company>;
  /** The `Employee` that was updated by this mutation. */
  employee?: Maybe<Employee>;
  /** An edge for our `Employee`. May be used by Relay 1. */
  employeeEdge?: Maybe<EmployeesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Employee`. */
  user?: Maybe<User>;
};


/** The output of our update `Employee` mutation. */
export type UpdateEmployeePayloadEmployeeEdgeArgs = {
  orderBy?: InputMaybe<Array<EmployeesOrderBy>>;
};

export type UpdateEmployeeRecordsFromCsvInput = {
  csvFile: Scalars['Upload'];
  delimiter?: InputMaybe<Scalars['String']>;
  employeeRecordFieldId: Scalars['UUID'];
};

export type UpdateEmployeesFromCsvInput = {
  clearFieldValuesWhenEmpty?: InputMaybe<Scalars['Boolean']>;
  csvFile: Scalars['Upload'];
  delimiter?: InputMaybe<Scalars['String']>;
  mappings: Array<CsvMappingInput>;
};

/** All input for the `updateEngagementTypeById` mutation. */
export type UpdateEngagementTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `EngagementType` being updated. */
  patch: EngagementTypePatch;
};

/** The output of our update `EngagementType` mutation. */
export type UpdateEngagementTypePayload = {
  __typename?: 'UpdateEngagementTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `EngagementType`. */
  company?: Maybe<Company>;
  /** The `EngagementType` that was updated by this mutation. */
  engagementType?: Maybe<EngagementType>;
  /** An edge for our `EngagementType`. May be used by Relay 1. */
  engagementTypeEdge?: Maybe<EngagementTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `EngagementType` mutation. */
export type UpdateEngagementTypePayloadEngagementTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<EngagementTypesOrderBy>>;
};

/** All input for the `updateEquipmentById` mutation. */
export type UpdateEquipmentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Equipment` being updated. */
  patch: EquipmentPatch;
};

/** The output of our update `Equipment` mutation. */
export type UpdateEquipmentPayload = {
  __typename?: 'UpdateEquipmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Equipment`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `Equipment`. */
  employee?: Maybe<Employee>;
  /** The `Equipment` that was updated by this mutation. */
  equipment?: Maybe<Equipment>;
  /** An edge for our `Equipment`. May be used by Relay 1. */
  equipmentEdge?: Maybe<EquipmentEdge>;
  /** Reads a single `Product` that is related to this `Equipment`. */
  product?: Maybe<Product>;
  /** Reads a single `ProductType` that is related to this `Equipment`. */
  productType?: Maybe<ProductType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Equipment`. */
  user?: Maybe<User>;
};


/** The output of our update `Equipment` mutation. */
export type UpdateEquipmentPayloadEquipmentEdgeArgs = {
  orderBy?: InputMaybe<Array<EquipmentOrderBy>>;
};

/** All input for the `updateEventById` mutation. */
export type UpdateEventByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Event` being updated. */
  patch: EventPatch;
};

/** The output of our update `Event` mutation. */
export type UpdateEventPayload = {
  __typename?: 'UpdateEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Event`. */
  company?: Maybe<Company>;
  /** The `Event` that was updated by this mutation. */
  event?: Maybe<Event>;
  /** An edge for our `Event`. May be used by Relay 1. */
  eventEdge?: Maybe<EventsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Event` mutation. */
export type UpdateEventPayloadEventEdgeArgs = {
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};

/** All input for the `updateEventUserByEventIdAndUserId` mutation. */
export type UpdateEventUserByEventIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `EventUser` being updated. */
  patch: EventUserPatch;
  userId: Scalars['UUID'];
};

/** All input for the `updateEventUserById` mutation. */
export type UpdateEventUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `EventUser` being updated. */
  patch: EventUserPatch;
};

/** The output of our update `EventUser` mutation. */
export type UpdateEventUserPayload = {
  __typename?: 'UpdateEventUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `EventUser`. */
  company?: Maybe<Company>;
  /** Reads a single `Event` that is related to this `EventUser`. */
  event?: Maybe<Event>;
  /** The `EventUser` that was updated by this mutation. */
  eventUser?: Maybe<EventUser>;
  /** An edge for our `EventUser`. May be used by Relay 1. */
  eventUserEdge?: Maybe<EventUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EventUser`. */
  user?: Maybe<User>;
};


/** The output of our update `EventUser` mutation. */
export type UpdateEventUserPayloadEventUserEdgeArgs = {
  orderBy?: InputMaybe<Array<EventUsersOrderBy>>;
};

/** All input for the `updateExternalIntegrationById` mutation. */
export type UpdateExternalIntegrationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ExternalIntegration` being updated. */
  patch: ExternalIntegrationPatch;
};

/** The output of our update `ExternalIntegration` mutation. */
export type UpdateExternalIntegrationPayload = {
  __typename?: 'UpdateExternalIntegrationPayload';
  /** Reads a single `AuthApp` that is related to this `ExternalIntegration`. */
  authApp?: Maybe<AuthApp>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ExternalIntegration`. */
  company?: Maybe<Company>;
  /** The `ExternalIntegration` that was updated by this mutation. */
  externalIntegration?: Maybe<ExternalIntegration>;
  /** An edge for our `ExternalIntegration`. May be used by Relay 1. */
  externalIntegrationEdge?: Maybe<ExternalIntegrationsEdge>;
  /** Reads a single `IntegrableSystem` that is related to this `ExternalIntegration`. */
  integrableSystem?: Maybe<IntegrableSystem>;
  /** Reads a single `DocumentFolderBlueprint` that is related to this `ExternalIntegration`. */
  payslipDocumentBlueprintFolder?: Maybe<DocumentFolderBlueprint>;
  /** Reads a single `DocumentType` that is related to this `ExternalIntegration`. */
  payslipDocumentType?: Maybe<DocumentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ExternalSystem` that is related to this `ExternalIntegration`. */
  system?: Maybe<ExternalSystem>;
};


/** The output of our update `ExternalIntegration` mutation. */
export type UpdateExternalIntegrationPayloadExternalIntegrationEdgeArgs = {
  orderBy?: InputMaybe<Array<ExternalIntegrationsOrderBy>>;
};

/** All input for the `updateFieldGroupById` mutation. */
export type UpdateFieldGroupByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FieldGroup` being updated. */
  patch: FieldGroupPatch;
};

/** All input for the `updateFieldGroupCardById` mutation. */
export type UpdateFieldGroupCardByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FieldGroupCard` being updated. */
  patch: FieldGroupCardPatch;
};

/** All input for the `updateFieldGroupCardColumnById` mutation. */
export type UpdateFieldGroupCardColumnByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FieldGroupCardColumn` being updated. */
  patch: FieldGroupCardColumnPatch;
};

/** The output of our update `FieldGroupCardColumn` mutation. */
export type UpdateFieldGroupCardColumnPayload = {
  __typename?: 'UpdateFieldGroupCardColumnPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FieldGroupCardColumn`. */
  company?: Maybe<Company>;
  /** Reads a single `FieldGroupCard` that is related to this `FieldGroupCardColumn`. */
  fieldGroupCard?: Maybe<FieldGroupCard>;
  /** The `FieldGroupCardColumn` that was updated by this mutation. */
  fieldGroupCardColumn?: Maybe<FieldGroupCardColumn>;
  /** An edge for our `FieldGroupCardColumn`. May be used by Relay 1. */
  fieldGroupCardColumnEdge?: Maybe<FieldGroupCardColumnsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `FieldGroupCardColumn` mutation. */
export type UpdateFieldGroupCardColumnPayloadFieldGroupCardColumnEdgeArgs = {
  orderBy?: InputMaybe<Array<FieldGroupCardColumnsOrderBy>>;
};

/** The output of our update `FieldGroupCard` mutation. */
export type UpdateFieldGroupCardPayload = {
  __typename?: 'UpdateFieldGroupCardPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FieldGroupCard`. */
  company?: Maybe<Company>;
  /** Reads a single `FieldGroup` that is related to this `FieldGroupCard`. */
  fieldGroup?: Maybe<FieldGroup>;
  /** The `FieldGroupCard` that was updated by this mutation. */
  fieldGroupCard?: Maybe<FieldGroupCard>;
  /** An edge for our `FieldGroupCard`. May be used by Relay 1. */
  fieldGroupCardEdge?: Maybe<FieldGroupCardsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `FieldGroupCard` mutation. */
export type UpdateFieldGroupCardPayloadFieldGroupCardEdgeArgs = {
  orderBy?: InputMaybe<Array<FieldGroupCardsOrderBy>>;
};

/** The output of our update `FieldGroup` mutation. */
export type UpdateFieldGroupPayload = {
  __typename?: 'UpdateFieldGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FieldGroup`. */
  company?: Maybe<Company>;
  /** The `FieldGroup` that was updated by this mutation. */
  fieldGroup?: Maybe<FieldGroup>;
  /** An edge for our `FieldGroup`. May be used by Relay 1. */
  fieldGroupEdge?: Maybe<FieldGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `FieldGroup` mutation. */
export type UpdateFieldGroupPayloadFieldGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<FieldGroupsOrderBy>>;
};

/** All input for the `updateFilterPresetById` mutation. */
export type UpdateFilterPresetByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FilterPreset` being updated. */
  patch: FilterPresetPatch;
};

/** The output of our update `FilterPreset` mutation. */
export type UpdateFilterPresetPayload = {
  __typename?: 'UpdateFilterPresetPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FilterPreset`. */
  company?: Maybe<Company>;
  /** The `FilterPreset` that was updated by this mutation. */
  filterPreset?: Maybe<FilterPreset>;
  /** An edge for our `FilterPreset`. May be used by Relay 1. */
  filterPresetEdge?: Maybe<FilterPresetsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `FilterPreset`. */
  user?: Maybe<User>;
};


/** The output of our update `FilterPreset` mutation. */
export type UpdateFilterPresetPayloadFilterPresetEdgeArgs = {
  orderBy?: InputMaybe<Array<FilterPresetsOrderBy>>;
};

/** All input for the `updateFilterViewById` mutation. */
export type UpdateFilterViewByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FilterView` being updated. */
  patch: FilterViewPatch;
};

/** The output of our update `FilterView` mutation. */
export type UpdateFilterViewPayload = {
  __typename?: 'UpdateFilterViewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `FilterView` that was updated by this mutation. */
  filterView?: Maybe<FilterView>;
  /** An edge for our `FilterView`. May be used by Relay 1. */
  filterViewEdge?: Maybe<FilterViewsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `FilterView`. */
  user?: Maybe<User>;
};


/** The output of our update `FilterView` mutation. */
export type UpdateFilterViewPayloadFilterViewEdgeArgs = {
  orderBy?: InputMaybe<Array<FilterViewsOrderBy>>;
};

/** All input for the `updateFormFieldAgreementByFormFieldId` mutation. */
export type UpdateFormFieldAgreementByFormFieldIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  formFieldId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FormFieldAgreement` being updated. */
  patch: FormFieldAgreementPatch;
};

/** All input for the `updateFormFieldAgreementById` mutation. */
export type UpdateFormFieldAgreementByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FormFieldAgreement` being updated. */
  patch: FormFieldAgreementPatch;
};

/** The output of our update `FormFieldAgreement` mutation. */
export type UpdateFormFieldAgreementPayload = {
  __typename?: 'UpdateFormFieldAgreementPayload';
  /** Reads a single `TranslatedEntity` that is related to this `FormFieldAgreement`. */
  agreementTextTranslatedEntity?: Maybe<TranslatedEntity>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FormFieldAgreement`. */
  company?: Maybe<Company>;
  /** Reads a single `FormField` that is related to this `FormFieldAgreement`. */
  formField?: Maybe<FormField>;
  /** The `FormFieldAgreement` that was updated by this mutation. */
  formFieldAgreement?: Maybe<FormFieldAgreement>;
  /** An edge for our `FormFieldAgreement`. May be used by Relay 1. */
  formFieldAgreementEdge?: Maybe<FormFieldAgreementsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `FormFieldAgreement` mutation. */
export type UpdateFormFieldAgreementPayloadFormFieldAgreementEdgeArgs = {
  orderBy?: InputMaybe<Array<FormFieldAgreementsOrderBy>>;
};

/** All input for the `updateFormFieldById` mutation. */
export type UpdateFormFieldByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FormField` being updated. */
  patch: FormFieldPatch;
};

/** All input for the `updateFormFieldEntryById` mutation. */
export type UpdateFormFieldEntryByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FormFieldEntry` being updated. */
  patch: FormFieldEntryPatch;
};

/** The output of our update `FormFieldEntry` mutation. */
export type UpdateFormFieldEntryPayload = {
  __typename?: 'UpdateFormFieldEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FormFieldEntry`. */
  company?: Maybe<Company>;
  /** Reads a single `Department` that is related to this `FormFieldEntry`. */
  department?: Maybe<Department>;
  /** Reads a single `Employee` that is related to this `FormFieldEntry`. */
  employee?: Maybe<Employee>;
  /** Reads a single `FieldGroup` that is related to this `FormFieldEntry`. */
  fieldGroup?: Maybe<FieldGroup>;
  /** Reads a single `FormField` that is related to this `FormFieldEntry`. */
  formField?: Maybe<FormField>;
  /** The `FormFieldEntry` that was updated by this mutation. */
  formFieldEntry?: Maybe<FormFieldEntry>;
  /** An edge for our `FormFieldEntry`. May be used by Relay 1. */
  formFieldEntryEdge?: Maybe<FormFieldEntriesEdge>;
  /** Reads a single `Product` that is related to this `FormFieldEntry`. */
  product?: Maybe<Product>;
  /** Reads a single `Department` that is related to this `FormFieldEntry`. */
  productDepartment?: Maybe<Department>;
  /** Reads a single `User` that is related to this `FormFieldEntry`. */
  productUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `FormFieldEntry`. */
  user?: Maybe<User>;
  /** Reads a single `UserCompetenceEvaluation` that is related to this `FormFieldEntry`. */
  userCompetenceEvaluation?: Maybe<UserCompetenceEvaluation>;
};


/** The output of our update `FormFieldEntry` mutation. */
export type UpdateFormFieldEntryPayloadFormFieldEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<FormFieldEntriesOrderBy>>;
};

/** All input for the `updateFormFieldOptionById` mutation. */
export type UpdateFormFieldOptionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FormFieldOption` being updated. */
  patch: FormFieldOptionPatch;
};

/** The output of our update `FormFieldOption` mutation. */
export type UpdateFormFieldOptionPayload = {
  __typename?: 'UpdateFormFieldOptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FormFieldOption`. */
  company?: Maybe<Company>;
  /** Reads a single `EngagementType` that is related to this `FormFieldOption`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `FormField` that is related to this `FormFieldOption`. */
  formField?: Maybe<FormField>;
  /** The `FormFieldOption` that was updated by this mutation. */
  formFieldOption?: Maybe<FormFieldOption>;
  /** An edge for our `FormFieldOption`. May be used by Relay 1. */
  formFieldOptionEdge?: Maybe<FormFieldOptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `FormFieldOption` mutation. */
export type UpdateFormFieldOptionPayloadFormFieldOptionEdgeArgs = {
  orderBy?: InputMaybe<Array<FormFieldOptionsOrderBy>>;
};

/** The output of our update `FormField` mutation. */
export type UpdateFormFieldPayload = {
  __typename?: 'UpdateFormFieldPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EngagementType` that is related to this `FormField`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `Event` that is related to this `FormField`. */
  event?: Maybe<Event>;
  /** Reads a single `FieldGroup` that is related to this `FormField`. */
  fieldGroup?: Maybe<FieldGroup>;
  /** Reads a single `FieldGroupCardColumn` that is related to this `FormField`. */
  fieldGroupCardColumn?: Maybe<FieldGroupCardColumn>;
  /** The `FormField` that was updated by this mutation. */
  formField?: Maybe<FormField>;
  /** An edge for our `FormField`. May be used by Relay 1. */
  formFieldEdge?: Maybe<FormFieldsEdge>;
  /** Reads a single `FormField` that is related to this `FormField`. */
  parentFormField?: Maybe<FormField>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `FormField` mutation. */
export type UpdateFormFieldPayloadFormFieldEdgeArgs = {
  orderBy?: InputMaybe<Array<FormFieldsOrderBy>>;
};

/** All input for the `updateFroalaStyleById` mutation. */
export type UpdateFroalaStyleByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FroalaStyle` being updated. */
  patch: FroalaStylePatch;
};

/** The output of our update `FroalaStyle` mutation. */
export type UpdateFroalaStylePayload = {
  __typename?: 'UpdateFroalaStylePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FroalaStyle`. */
  company?: Maybe<Company>;
  /** The `FroalaStyle` that was updated by this mutation. */
  froalaStyle?: Maybe<FroalaStyle>;
  /** An edge for our `FroalaStyle`. May be used by Relay 1. */
  froalaStyleEdge?: Maybe<FroalaStylesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `FroalaStyle` mutation. */
export type UpdateFroalaStylePayloadFroalaStyleEdgeArgs = {
  orderBy?: InputMaybe<Array<FroalaStylesOrderBy>>;
};

/** All input for the `updateFutureDatumByApprovalId` mutation. */
export type UpdateFutureDatumByApprovalIdInput = {
  approvalId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `FutureDatum` being updated. */
  patch: FutureDatumPatch;
};

/** All input for the `updateFutureDatumById` mutation. */
export type UpdateFutureDatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `FutureDatum` being updated. */
  patch: FutureDatumPatch;
};

/** The output of our update `FutureDatum` mutation. */
export type UpdateFutureDatumPayload = {
  __typename?: 'UpdateFutureDatumPayload';
  /** Reads a single `Approval` that is related to this `FutureDatum`. */
  approval?: Maybe<Approval>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `FutureDatum`. */
  company?: Maybe<Company>;
  /** Reads a single `User` that is related to this `FutureDatum`. */
  creatorUser?: Maybe<User>;
  /** Reads a single `FieldGroup` that is related to this `FutureDatum`. */
  fieldGroup?: Maybe<FieldGroup>;
  /** Reads a single `FormField` that is related to this `FutureDatum`. */
  formField?: Maybe<FormField>;
  /** The `FutureDatum` that was updated by this mutation. */
  futureDatum?: Maybe<FutureDatum>;
  /** An edge for our `FutureDatum`. May be used by Relay 1. */
  futureDatumEdge?: Maybe<FutureDataEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SystemField` that is related to this `FutureDatum`. */
  systemField?: Maybe<SystemField>;
  /** Reads a single `User` that is related to this `FutureDatum`. */
  user?: Maybe<User>;
};


/** The output of our update `FutureDatum` mutation. */
export type UpdateFutureDatumPayloadFutureDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<FutureDataOrderBy>>;
};

/** All input for the `updateGroupById` mutation. */
export type UpdateGroupByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Group` being updated. */
  patch: GroupPatch;
};

/** The output of our update `Group` mutation. */
export type UpdateGroupPayload = {
  __typename?: 'UpdateGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Group` that was updated by this mutation. */
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Group` mutation. */
export type UpdateGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

/** All input for the `updateGroupRoleByGroupIdAndRoleId` mutation. */
export type UpdateGroupRoleByGroupIdAndRoleIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `GroupRole` being updated. */
  patch: GroupRolePatch;
  roleId: Scalars['UUID'];
};

/** The output of our update `GroupRole` mutation. */
export type UpdateGroupRolePayload = {
  __typename?: 'UpdateGroupRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `GroupRole`. */
  company?: Maybe<Company>;
  /** Reads a single `Group` that is related to this `GroupRole`. */
  group?: Maybe<Group>;
  /** The `GroupRole` that was updated by this mutation. */
  groupRole?: Maybe<GroupRole>;
  /** An edge for our `GroupRole`. May be used by Relay 1. */
  groupRoleEdge?: Maybe<GroupRolesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Role` that is related to this `GroupRole`. */
  role?: Maybe<Role>;
};


/** The output of our update `GroupRole` mutation. */
export type UpdateGroupRolePayloadGroupRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupRolesOrderBy>>;
};

/** All input for the `updateIntegrableSystemById` mutation. */
export type UpdateIntegrableSystemByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `IntegrableSystem` being updated. */
  patch: IntegrableSystemPatch;
};

/** The output of our update `IntegrableSystem` mutation. */
export type UpdateIntegrableSystemPayload = {
  __typename?: 'UpdateIntegrableSystemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `IntegrableSystem` that was updated by this mutation. */
  integrableSystem?: Maybe<IntegrableSystem>;
  /** An edge for our `IntegrableSystem`. May be used by Relay 1. */
  integrableSystemEdge?: Maybe<IntegrableSystemsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `IntegrableSystem` mutation. */
export type UpdateIntegrableSystemPayloadIntegrableSystemEdgeArgs = {
  orderBy?: InputMaybe<Array<IntegrableSystemsOrderBy>>;
};

export type UpdateIntegrationCredentialsInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  refreshToken?: InputMaybe<Scalars['String']>;
};

export type UpdateIntegrationCredentialsResponse = {
  __typename?: 'UpdateIntegrationCredentialsResponse';
  message: Scalars['String'];
};

/** All input for the `updateIntegrationFieldMarkingByCompanyIdAndExternalIntegrationIdAndFormFieldId` mutation. */
export type UpdateIntegrationFieldMarkingByCompanyIdAndExternalIntegrationIdAndFormFieldIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  formFieldId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `IntegrationFieldMarking` being updated. */
  patch: IntegrationFieldMarkingPatch;
};

/** All input for the `updateIntegrationFieldMarkingByCompanyIdAndExternalIntegrationIdAndSystemFieldId` mutation. */
export type UpdateIntegrationFieldMarkingByCompanyIdAndExternalIntegrationIdAndSystemFieldIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
  externalIntegrationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `IntegrationFieldMarking` being updated. */
  patch: IntegrationFieldMarkingPatch;
  systemFieldId: Scalars['UUID'];
};

/** All input for the `updateIntegrationFieldMarkingById` mutation. */
export type UpdateIntegrationFieldMarkingByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `IntegrationFieldMarking` being updated. */
  patch: IntegrationFieldMarkingPatch;
};

/** The output of our update `IntegrationFieldMarking` mutation. */
export type UpdateIntegrationFieldMarkingPayload = {
  __typename?: 'UpdateIntegrationFieldMarkingPayload';
  /** Reads a single `AuthApp` that is related to this `IntegrationFieldMarking`. */
  authApp?: Maybe<AuthApp>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `IntegrationFieldMarking`. */
  company?: Maybe<Company>;
  /** Reads a single `ExternalIntegration` that is related to this `IntegrationFieldMarking`. */
  externalIntegration?: Maybe<ExternalIntegration>;
  /** Reads a single `FormField` that is related to this `IntegrationFieldMarking`. */
  formField?: Maybe<FormField>;
  /** The `IntegrationFieldMarking` that was updated by this mutation. */
  integrationFieldMarking?: Maybe<IntegrationFieldMarking>;
  /** An edge for our `IntegrationFieldMarking`. May be used by Relay 1. */
  integrationFieldMarkingEdge?: Maybe<IntegrationFieldMarkingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Storage` that is related to this `IntegrationFieldMarking`. */
  storage?: Maybe<Storage>;
  /** Reads a single `SystemField` that is related to this `IntegrationFieldMarking`. */
  systemField?: Maybe<SystemField>;
};


/** The output of our update `IntegrationFieldMarking` mutation. */
export type UpdateIntegrationFieldMarkingPayloadIntegrationFieldMarkingEdgeArgs = {
  orderBy?: InputMaybe<Array<IntegrationFieldMarkingsOrderBy>>;
};

/** All input for the `updateLoggedActionNoteById` mutation. */
export type UpdateLoggedActionNoteByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `LoggedActionNote` being updated. */
  patch: LoggedActionNotePatch;
};

/** The output of our update `LoggedActionNote` mutation. */
export type UpdateLoggedActionNotePayload = {
  __typename?: 'UpdateLoggedActionNotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `LoggedActionNote`. */
  company?: Maybe<Company>;
  /** The `LoggedActionNote` that was updated by this mutation. */
  loggedActionNote?: Maybe<LoggedActionNote>;
  /** An edge for our `LoggedActionNote`. May be used by Relay 1. */
  loggedActionNoteEdge?: Maybe<LoggedActionNotesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `LoggedActionNote`. */
  superUser?: Maybe<User>;
  /** Reads a single `User` that is related to this `LoggedActionNote`. */
  user?: Maybe<User>;
};


/** The output of our update `LoggedActionNote` mutation. */
export type UpdateLoggedActionNotePayloadLoggedActionNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<LoggedActionNotesOrderBy>>;
};

/** All input for the `updateNotificationById` mutation. */
export type UpdateNotificationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Notification` being updated. */
  patch: NotificationPatch;
};

/** All input for the `updateNotificationCustomEmployeeFieldRecipientById` mutation. */
export type UpdateNotificationCustomEmployeeFieldRecipientByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `NotificationCustomEmployeeFieldRecipient` being updated. */
  patch: NotificationCustomEmployeeFieldRecipientPatch;
};

/** The output of our update `NotificationCustomEmployeeFieldRecipient` mutation. */
export type UpdateNotificationCustomEmployeeFieldRecipientPayload = {
  __typename?: 'UpdateNotificationCustomEmployeeFieldRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `NotificationCustomEmployeeFieldRecipient`. */
  company?: Maybe<Company>;
  /** Reads a single `FormField` that is related to this `NotificationCustomEmployeeFieldRecipient`. */
  formField?: Maybe<FormField>;
  /** Reads a single `Notification` that is related to this `NotificationCustomEmployeeFieldRecipient`. */
  notification?: Maybe<Notification>;
  /** The `NotificationCustomEmployeeFieldRecipient` that was updated by this mutation. */
  notificationCustomEmployeeFieldRecipient?: Maybe<NotificationCustomEmployeeFieldRecipient>;
  /** An edge for our `NotificationCustomEmployeeFieldRecipient`. May be used by Relay 1. */
  notificationCustomEmployeeFieldRecipientEdge?: Maybe<NotificationCustomEmployeeFieldRecipientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `NotificationCustomEmployeeFieldRecipient` mutation. */
export type UpdateNotificationCustomEmployeeFieldRecipientPayloadNotificationCustomEmployeeFieldRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationCustomEmployeeFieldRecipientsOrderBy>>;
};

/** All input for the `updateNotificationCustomRecipientByNotificationIdAndEmployeeId` mutation. */
export type UpdateNotificationCustomRecipientByNotificationIdAndEmployeeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['UUID'];
  notificationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `NotificationCustomRecipient` being updated. */
  patch: NotificationCustomRecipientPatch;
};

/** The output of our update `NotificationCustomRecipient` mutation. */
export type UpdateNotificationCustomRecipientPayload = {
  __typename?: 'UpdateNotificationCustomRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `NotificationCustomRecipient`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `NotificationCustomRecipient`. */
  employee?: Maybe<Employee>;
  /** Reads a single `Notification` that is related to this `NotificationCustomRecipient`. */
  notification?: Maybe<Notification>;
  /** The `NotificationCustomRecipient` that was updated by this mutation. */
  notificationCustomRecipient?: Maybe<NotificationCustomRecipient>;
  /** An edge for our `NotificationCustomRecipient`. May be used by Relay 1. */
  notificationCustomRecipientEdge?: Maybe<NotificationCustomRecipientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `NotificationCustomRecipient`. */
  user?: Maybe<User>;
};


/** The output of our update `NotificationCustomRecipient` mutation. */
export type UpdateNotificationCustomRecipientPayloadNotificationCustomRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationCustomRecipientsOrderBy>>;
};

/** All input for the `updateNotificationEmployeeById` mutation. */
export type UpdateNotificationEmployeeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `NotificationEmployee` being updated. */
  patch: NotificationEmployeePatch;
};

/** The output of our update `NotificationEmployee` mutation. */
export type UpdateNotificationEmployeePayload = {
  __typename?: 'UpdateNotificationEmployeePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `NotificationEmployee`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `NotificationEmployee`. */
  employee?: Maybe<Employee>;
  /** Reads a single `Notification` that is related to this `NotificationEmployee`. */
  notification?: Maybe<Notification>;
  /** The `NotificationEmployee` that was updated by this mutation. */
  notificationEmployee?: Maybe<NotificationEmployee>;
  /** An edge for our `NotificationEmployee`. May be used by Relay 1. */
  notificationEmployeeEdge?: Maybe<NotificationEmployeesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Employee` that is related to this `NotificationEmployee`. */
  recipient?: Maybe<Employee>;
  /** Reads a single `Employee` that is related to this `NotificationEmployee`. */
  sender?: Maybe<Employee>;
};


/** The output of our update `NotificationEmployee` mutation. */
export type UpdateNotificationEmployeePayloadNotificationEmployeeEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationEmployeesOrderBy>>;
};

/** All input for the `updateNotificationEmployeeReferenceById` mutation. */
export type UpdateNotificationEmployeeReferenceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `NotificationEmployeeReference` being updated. */
  patch: NotificationEmployeeReferencePatch;
};

/** The output of our update `NotificationEmployeeReference` mutation. */
export type UpdateNotificationEmployeeReferencePayload = {
  __typename?: 'UpdateNotificationEmployeeReferencePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `NotificationEmployeeReference`. */
  company?: Maybe<Company>;
  /** Reads a single `Competence` that is related to this `NotificationEmployeeReference`. */
  competence?: Maybe<Competence>;
  /** Reads a single `CompetenceGroup` that is related to this `NotificationEmployeeReference`. */
  competenceGroup?: Maybe<CompetenceGroup>;
  /** Reads a single `ContractSignPending` that is related to this `NotificationEmployeeReference`. */
  contractSignPending?: Maybe<ContractSignPending>;
  /** Reads a single `Department` that is related to this `NotificationEmployeeReference`. */
  department?: Maybe<Department>;
  /** Reads a single `Employee` that is related to this `NotificationEmployeeReference`. */
  employee?: Maybe<Employee>;
  /** Reads a single `Storage` that is related to this `NotificationEmployeeReference`. */
  file?: Maybe<Storage>;
  /** Reads a single `FutureDatum` that is related to this `NotificationEmployeeReference`. */
  futureData?: Maybe<FutureDatum>;
  /** Reads a single `Message` that is related to this `NotificationEmployeeReference`. */
  message?: Maybe<Message>;
  /** Reads a single `NotificationEmployee` that is related to this `NotificationEmployeeReference`. */
  notificationEmployee?: Maybe<NotificationEmployee>;
  /** The `NotificationEmployeeReference` that was updated by this mutation. */
  notificationEmployeeReference?: Maybe<NotificationEmployeeReference>;
  /** An edge for our `NotificationEmployeeReference`. May be used by Relay 1. */
  notificationEmployeeReferenceEdge?: Maybe<NotificationEmployeeReferencesEdge>;
  /** Reads a single `Preboarding` that is related to this `NotificationEmployeeReference`. */
  preboarding?: Maybe<Preboarding>;
  /** Reads a single `Process` that is related to this `NotificationEmployeeReference`. */
  process?: Maybe<Process>;
  /** Reads a single `Product` that is related to this `NotificationEmployeeReference`. */
  product?: Maybe<Product>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `NotificationEmployeeReference`. */
  recipientUser?: Maybe<User>;
  /** Reads a single `Task` that is related to this `NotificationEmployeeReference`. */
  task?: Maybe<Task>;
  /** Reads a single `TaskTemplate` that is related to this `NotificationEmployeeReference`. */
  taskTemplate?: Maybe<TaskTemplate>;
  /** Reads a single `TimeRegistrationPresence` that is related to this `NotificationEmployeeReference`. */
  timeRegistrationPresence?: Maybe<TimeRegistrationPresence>;
  /** Reads a single `UserCompetence` that is related to this `NotificationEmployeeReference`. */
  userCompetence?: Maybe<UserCompetence>;
  /** Reads a single `VacationType` that is related to this `NotificationEmployeeReference`. */
  vacationType?: Maybe<VacationType>;
  /** Reads a single `VacationUser` that is related to this `NotificationEmployeeReference`. */
  vacationUser?: Maybe<VacationUser>;
};


/** The output of our update `NotificationEmployeeReference` mutation. */
export type UpdateNotificationEmployeeReferencePayloadNotificationEmployeeReferenceEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};

/** All input for the `updateNotificationGroupRecipientByNotificationIdAndGroupId` mutation. */
export type UpdateNotificationGroupRecipientByNotificationIdAndGroupIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupId: Scalars['UUID'];
  notificationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `NotificationGroupRecipient` being updated. */
  patch: NotificationGroupRecipientPatch;
};

/** The output of our update `NotificationGroupRecipient` mutation. */
export type UpdateNotificationGroupRecipientPayload = {
  __typename?: 'UpdateNotificationGroupRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `NotificationGroupRecipient`. */
  company?: Maybe<Company>;
  /** Reads a single `Group` that is related to this `NotificationGroupRecipient`. */
  group?: Maybe<Group>;
  /** Reads a single `Notification` that is related to this `NotificationGroupRecipient`. */
  notification?: Maybe<Notification>;
  /** The `NotificationGroupRecipient` that was updated by this mutation. */
  notificationGroupRecipient?: Maybe<NotificationGroupRecipient>;
  /** An edge for our `NotificationGroupRecipient`. May be used by Relay 1. */
  notificationGroupRecipientEdge?: Maybe<NotificationGroupRecipientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `NotificationGroupRecipient` mutation. */
export type UpdateNotificationGroupRecipientPayloadNotificationGroupRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationGroupRecipientsOrderBy>>;
};

/** The output of our update `Notification` mutation. */
export type UpdateNotificationPayload = {
  __typename?: 'UpdateNotificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Hook` that is related to this `Notification`. */
  hook?: Maybe<Hook>;
  /** The `Notification` that was updated by this mutation. */
  notification?: Maybe<Notification>;
  /** An edge for our `Notification`. May be used by Relay 1. */
  notificationEdge?: Maybe<NotificationsEdge>;
  /** Reads a single `NotificationType` that is related to this `Notification`. */
  notificationType?: Maybe<NotificationType>;
  /** Reads a single `Preboarding` that is related to this `Notification`. */
  preboarding?: Maybe<Preboarding>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Notification` mutation. */
export type UpdateNotificationPayloadNotificationEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** All input for the `updateNotificationTypeById` mutation. */
export type UpdateNotificationTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `NotificationType` being updated. */
  patch: NotificationTypePatch;
};

/** All input for the `updateNotificationTypeChannelTypeByNotificationTypeIdAndChannelTypeId` mutation. */
export type UpdateNotificationTypeChannelTypeByNotificationTypeIdAndChannelTypeIdInput = {
  channelTypeId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  notificationTypeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `NotificationTypeChannelType` being updated. */
  patch: NotificationTypeChannelTypePatch;
};

/** The output of our update `NotificationTypeChannelType` mutation. */
export type UpdateNotificationTypeChannelTypePayload = {
  __typename?: 'UpdateNotificationTypeChannelTypePayload';
  /** Reads a single `ChannelType` that is related to this `NotificationTypeChannelType`. */
  channelType?: Maybe<ChannelType>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `NotificationTypeChannelType`. */
  company?: Maybe<Company>;
  /** Reads a single `NotificationType` that is related to this `NotificationTypeChannelType`. */
  notificationType?: Maybe<NotificationType>;
  /** The `NotificationTypeChannelType` that was updated by this mutation. */
  notificationTypeChannelType?: Maybe<NotificationTypeChannelType>;
  /** An edge for our `NotificationTypeChannelType`. May be used by Relay 1. */
  notificationTypeChannelTypeEdge?: Maybe<NotificationTypeChannelTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `NotificationTypeChannelType` mutation. */
export type UpdateNotificationTypeChannelTypePayloadNotificationTypeChannelTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationTypeChannelTypesOrderBy>>;
};

/** The output of our update `NotificationType` mutation. */
export type UpdateNotificationTypePayload = {
  __typename?: 'UpdateNotificationTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `NotificationType` that was updated by this mutation. */
  notificationType?: Maybe<NotificationType>;
  /** An edge for our `NotificationType`. May be used by Relay 1. */
  notificationTypeEdge?: Maybe<NotificationTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `NotificationType` mutation. */
export type UpdateNotificationTypePayloadNotificationTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationTypesOrderBy>>;
};

export type UpdatePersonalDataCardInput = {
  cards?: InputMaybe<Array<FieldGroupCardAction>>;
  cardsToDelete?: InputMaybe<Array<Scalars['UUID']>>;
  fieldsToDelete?: InputMaybe<Array<Scalars['UUID']>>;
  unassignedFields?: InputMaybe<Array<PersonalDataCardField>>;
};

/** All input for the `updatePostById` mutation. */
export type UpdatePostByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Post` being updated. */
  patch: PostPatch;
};

/** The output of our update `Post` mutation. */
export type UpdatePostPayload = {
  __typename?: 'UpdatePostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Post`. */
  company?: Maybe<Company>;
  /** The `Post` that was updated by this mutation. */
  post?: Maybe<Post>;
  /** An edge for our `Post`. May be used by Relay 1. */
  postEdge?: Maybe<PostsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Post`. */
  user?: Maybe<User>;
};


/** The output of our update `Post` mutation. */
export type UpdatePostPayloadPostEdgeArgs = {
  orderBy?: InputMaybe<Array<PostsOrderBy>>;
};

/** All input for the `updatePostTypeById` mutation. */
export type UpdatePostTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PostType` being updated. */
  patch: PostTypePatch;
};

/** The output of our update `PostType` mutation. */
export type UpdatePostTypePayload = {
  __typename?: 'UpdatePostTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PostType`. */
  company?: Maybe<Company>;
  /** Reads a single `TranslatedEntity` that is related to this `PostType`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** The `PostType` that was updated by this mutation. */
  postType?: Maybe<PostType>;
  /** An edge for our `PostType`. May be used by Relay 1. */
  postTypeEdge?: Maybe<PostTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PostType` mutation. */
export type UpdatePostTypePayloadPostTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<PostTypesOrderBy>>;
};

/** All input for the `updatePreboardingById` mutation. */
export type UpdatePreboardingByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Preboarding` being updated. */
  patch: PreboardingPatch;
};

/** All input for the `updatePreboardingCommentById` mutation. */
export type UpdatePreboardingCommentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PreboardingComment` being updated. */
  patch: PreboardingCommentPatch;
};

/** The output of our update `PreboardingComment` mutation. */
export type UpdatePreboardingCommentPayload = {
  __typename?: 'UpdatePreboardingCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingComment`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `PreboardingComment`. */
  employee?: Maybe<Employee>;
  /** Reads a single `EngagementType` that is related to this `PreboardingComment`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `Preboarding` that is related to this `PreboardingComment`. */
  preboarding?: Maybe<Preboarding>;
  /** The `PreboardingComment` that was updated by this mutation. */
  preboardingComment?: Maybe<PreboardingComment>;
  /** An edge for our `PreboardingComment`. May be used by Relay 1. */
  preboardingCommentEdge?: Maybe<PreboardingCommentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PreboardingComment`. */
  user?: Maybe<User>;
};


/** The output of our update `PreboardingComment` mutation. */
export type UpdatePreboardingCommentPayloadPreboardingCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingCommentsOrderBy>>;
};

/** All input for the `updatePreboardingEmployeeById` mutation. */
export type UpdatePreboardingEmployeeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PreboardingEmployee` being updated. */
  patch: PreboardingEmployeePatch;
};

/** The output of our update `PreboardingEmployee` mutation. */
export type UpdatePreboardingEmployeePayload = {
  __typename?: 'UpdatePreboardingEmployeePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingEmployee`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `PreboardingEmployee`. */
  employee?: Maybe<Employee>;
  /** Reads a single `EngagementType` that is related to this `PreboardingEmployee`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `Preboarding` that is related to this `PreboardingEmployee`. */
  preboarding?: Maybe<Preboarding>;
  /** The `PreboardingEmployee` that was updated by this mutation. */
  preboardingEmployee?: Maybe<PreboardingEmployee>;
  /** An edge for our `PreboardingEmployee`. May be used by Relay 1. */
  preboardingEmployeeEdge?: Maybe<PreboardingEmployeesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PreboardingEmployee`. */
  recipient?: Maybe<User>;
  /** Reads a single `User` that is related to this `PreboardingEmployee`. */
  user?: Maybe<User>;
};


/** The output of our update `PreboardingEmployee` mutation. */
export type UpdatePreboardingEmployeePayloadPreboardingEmployeeEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingEmployeesOrderBy>>;
};

/** All input for the `updatePreboardingFormCacheByPreboardingIdAndUserId` mutation. */
export type UpdatePreboardingFormCacheByPreboardingIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `PreboardingFormCache` being updated. */
  patch: PreboardingFormCachePatch;
  preboardingId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our update `PreboardingFormCache` mutation. */
export type UpdatePreboardingFormCachePayload = {
  __typename?: 'UpdatePreboardingFormCachePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Preboarding` that is related to this `PreboardingFormCache`. */
  preboarding?: Maybe<Preboarding>;
  /** The `PreboardingFormCache` that was updated by this mutation. */
  preboardingFormCache?: Maybe<PreboardingFormCache>;
  /** An edge for our `PreboardingFormCache`. May be used by Relay 1. */
  preboardingFormCacheEdge?: Maybe<PreboardingFormCachesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PreboardingFormCache`. */
  user?: Maybe<User>;
};


/** The output of our update `PreboardingFormCache` mutation. */
export type UpdatePreboardingFormCachePayloadPreboardingFormCacheEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingFormCachesOrderBy>>;
};

/** The output of our update `Preboarding` mutation. */
export type UpdatePreboardingPayload = {
  __typename?: 'UpdatePreboardingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Preboarding`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `Preboarding`. */
  employee?: Maybe<Employee>;
  /** Reads a single `EngagementType` that is related to this `Preboarding`. */
  engagementType?: Maybe<EngagementType>;
  /** The `Preboarding` that was updated by this mutation. */
  preboarding?: Maybe<Preboarding>;
  /** Reads a single `Preboarding` that is related to this `Preboarding`. */
  preboardingByCreatedFrom?: Maybe<Preboarding>;
  /** An edge for our `Preboarding`. May be used by Relay 1. */
  preboardingEdge?: Maybe<PreboardingsEdge>;
  /** Reads a single `Preboarding` that is related to this `Preboarding`. */
  predecessor?: Maybe<Preboarding>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Preboarding`. */
  recipient?: Maybe<User>;
  /** Reads a single `FormField` that is related to this `Preboarding`. */
  recipientCustomEmployeeField?: Maybe<FormField>;
  /** Reads a single `Group` that is related to this `Preboarding`. */
  recipientGroup?: Maybe<Group>;
};


/** The output of our update `Preboarding` mutation. */
export type UpdatePreboardingPayloadPreboardingEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingsOrderBy>>;
};

/** All input for the `updatePreboardingProcessByPreboardingIdAndProcessId` mutation. */
export type UpdatePreboardingProcessByPreboardingIdAndProcessIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `PreboardingProcess` being updated. */
  patch: PreboardingProcessPatch;
  preboardingId: Scalars['UUID'];
  processId: Scalars['UUID'];
};

/** The output of our update `PreboardingProcess` mutation. */
export type UpdatePreboardingProcessPayload = {
  __typename?: 'UpdatePreboardingProcessPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingProcess`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `PreboardingProcess`. */
  employee?: Maybe<Employee>;
  /** Reads a single `EngagementType` that is related to this `PreboardingProcess`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `Preboarding` that is related to this `PreboardingProcess`. */
  preboarding?: Maybe<Preboarding>;
  /** The `PreboardingProcess` that was updated by this mutation. */
  preboardingProcess?: Maybe<PreboardingProcess>;
  /** An edge for our `PreboardingProcess`. May be used by Relay 1. */
  preboardingProcessEdge?: Maybe<PreboardingProcessesEdge>;
  /** Reads a single `Process` that is related to this `PreboardingProcess`. */
  process?: Maybe<Process>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PreboardingProcess`. */
  user?: Maybe<User>;
};


/** The output of our update `PreboardingProcess` mutation. */
export type UpdatePreboardingProcessPayloadPreboardingProcessEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingProcessesOrderBy>>;
};

/** All input for the `updatePreboardingResultById` mutation. */
export type UpdatePreboardingResultByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PreboardingResult` being updated. */
  patch: PreboardingResultPatch;
};

/** The output of our update `PreboardingResult` mutation. */
export type UpdatePreboardingResultPayload = {
  __typename?: 'UpdatePreboardingResultPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingResult`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `PreboardingResult`. */
  employee?: Maybe<Employee>;
  /** Reads a single `EngagementType` that is related to this `PreboardingResult`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `PreboardingEmployee` that is related to this `PreboardingResult`. */
  preboardingEmployee?: Maybe<PreboardingEmployee>;
  /** The `PreboardingResult` that was updated by this mutation. */
  preboardingResult?: Maybe<PreboardingResult>;
  /** An edge for our `PreboardingResult`. May be used by Relay 1. */
  preboardingResultEdge?: Maybe<PreboardingResultsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PreboardingResult`. */
  user?: Maybe<User>;
};


/** The output of our update `PreboardingResult` mutation. */
export type UpdatePreboardingResultPayloadPreboardingResultEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingResultsOrderBy>>;
};

/** All input for the `updatePreboardingResultSlideCommentById` mutation. */
export type UpdatePreboardingResultSlideCommentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PreboardingResultSlideComment` being updated. */
  patch: PreboardingResultSlideCommentPatch;
};

/** The output of our update `PreboardingResultSlideComment` mutation. */
export type UpdatePreboardingResultSlideCommentPayload = {
  __typename?: 'UpdatePreboardingResultSlideCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingResultSlideComment`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `PreboardingResultSlideComment`. */
  employee?: Maybe<Employee>;
  /** Reads a single `EngagementType` that is related to this `PreboardingResultSlideComment`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `PreboardingResult` that is related to this `PreboardingResultSlideComment`. */
  preboardingResult?: Maybe<PreboardingResult>;
  /** The `PreboardingResultSlideComment` that was updated by this mutation. */
  preboardingResultSlideComment?: Maybe<PreboardingResultSlideComment>;
  /** An edge for our `PreboardingResultSlideComment`. May be used by Relay 1. */
  preboardingResultSlideCommentEdge?: Maybe<PreboardingResultSlideCommentsEdge>;
  /** Reads a single `PreboardingSlide` that is related to this `PreboardingResultSlideComment`. */
  preboardingSlide?: Maybe<PreboardingSlide>;
  /** Reads a single `User` that is related to this `PreboardingResultSlideComment`. */
  preboardingUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PreboardingResultSlideComment`. */
  user?: Maybe<User>;
};


/** The output of our update `PreboardingResultSlideComment` mutation. */
export type UpdatePreboardingResultSlideCommentPayloadPreboardingResultSlideCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingResultSlideCommentsOrderBy>>;
};

/** All input for the `updatePreboardingSlideById` mutation. */
export type UpdatePreboardingSlideByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PreboardingSlide` being updated. */
  patch: PreboardingSlidePatch;
};

/** All input for the `updatePreboardingSlideFormFieldById` mutation. */
export type UpdatePreboardingSlideFormFieldByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PreboardingSlideFormField` being updated. */
  patch: PreboardingSlideFormFieldPatch;
};

/** The output of our update `PreboardingSlideFormField` mutation. */
export type UpdatePreboardingSlideFormFieldPayload = {
  __typename?: 'UpdatePreboardingSlideFormFieldPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingSlideFormField`. */
  company?: Maybe<Company>;
  /** Reads a single `EngagementType` that is related to this `PreboardingSlideFormField`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `FormField` that is related to this `PreboardingSlideFormField`. */
  formField?: Maybe<FormField>;
  /** Reads a single `PreboardingSlide` that is related to this `PreboardingSlideFormField`. */
  preboardingSlide?: Maybe<PreboardingSlide>;
  /** The `PreboardingSlideFormField` that was updated by this mutation. */
  preboardingSlideFormField?: Maybe<PreboardingSlideFormField>;
  /** Reads a single `PreboardingSlideFormField` that is related to this `PreboardingSlideFormField`. */
  preboardingSlideFormFieldByPreboardingSlideFormFieldIdParent?: Maybe<PreboardingSlideFormField>;
  /** An edge for our `PreboardingSlideFormField`. May be used by Relay 1. */
  preboardingSlideFormFieldEdge?: Maybe<PreboardingSlideFormFieldsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PreboardingSlideFormField` mutation. */
export type UpdatePreboardingSlideFormFieldPayloadPreboardingSlideFormFieldEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingSlideFormFieldsOrderBy>>;
};

/** The output of our update `PreboardingSlide` mutation. */
export type UpdatePreboardingSlidePayload = {
  __typename?: 'UpdatePreboardingSlidePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PreboardingSlide`. */
  company?: Maybe<Company>;
  /** Reads a single `EngagementType` that is related to this `PreboardingSlide`. */
  engagementType?: Maybe<EngagementType>;
  /** Reads a single `Preboarding` that is related to this `PreboardingSlide`. */
  preboarding?: Maybe<Preboarding>;
  /** The `PreboardingSlide` that was updated by this mutation. */
  preboardingSlide?: Maybe<PreboardingSlide>;
  /** An edge for our `PreboardingSlide`. May be used by Relay 1. */
  preboardingSlideEdge?: Maybe<PreboardingSlidesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PreboardingSlide` mutation. */
export type UpdatePreboardingSlidePayloadPreboardingSlideEdgeArgs = {
  orderBy?: InputMaybe<Array<PreboardingSlidesOrderBy>>;
};

/** All input for the `updateProcessById` mutation. */
export type UpdateProcessByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Process` being updated. */
  patch: ProcessPatch;
};

/** The output of our update `Process` mutation. */
export type UpdateProcessPayload = {
  __typename?: 'UpdateProcessPayload';
  /** Reads a single `User` that is related to this `Process`. */
  assignedUser?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Employee` that is related to this `Process`. */
  employee?: Maybe<Employee>;
  /** The `Process` that was updated by this mutation. */
  process?: Maybe<Process>;
  /** An edge for our `Process`. May be used by Relay 1. */
  processEdge?: Maybe<ProcessesEdge>;
  /** Reads a single `ProcessType` that is related to this `Process`. */
  processType?: Maybe<ProcessType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Process` mutation. */
export type UpdateProcessPayloadProcessEdgeArgs = {
  orderBy?: InputMaybe<Array<ProcessesOrderBy>>;
};

/** All input for the `updateProcessResponsibleByProcessIdAndResponsibleId` mutation. */
export type UpdateProcessResponsibleByProcessIdAndResponsibleIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ProcessResponsible` being updated. */
  patch: ProcessResponsiblePatch;
  processId: Scalars['UUID'];
  responsibleId: Scalars['UUID'];
};

/** The output of our update `ProcessResponsible` mutation. */
export type UpdateProcessResponsiblePayload = {
  __typename?: 'UpdateProcessResponsiblePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ProcessResponsible`. */
  company?: Maybe<Company>;
  /** Reads a single `Process` that is related to this `ProcessResponsible`. */
  process?: Maybe<Process>;
  /** The `ProcessResponsible` that was updated by this mutation. */
  processResponsible?: Maybe<ProcessResponsible>;
  /** An edge for our `ProcessResponsible`. May be used by Relay 1. */
  processResponsibleEdge?: Maybe<ProcessResponsiblesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Employee` that is related to this `ProcessResponsible`. */
  responsible?: Maybe<Employee>;
  /** Reads a single `User` that is related to this `ProcessResponsible`. */
  responsibleUser?: Maybe<User>;
};


/** The output of our update `ProcessResponsible` mutation. */
export type UpdateProcessResponsiblePayloadProcessResponsibleEdgeArgs = {
  orderBy?: InputMaybe<Array<ProcessResponsiblesOrderBy>>;
};

/** All input for the `updateProcessTypeById` mutation. */
export type UpdateProcessTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProcessType` being updated. */
  patch: ProcessTypePatch;
};

/** The output of our update `ProcessType` mutation. */
export type UpdateProcessTypePayload = {
  __typename?: 'UpdateProcessTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ProcessType`. */
  company?: Maybe<Company>;
  /** The `ProcessType` that was updated by this mutation. */
  processType?: Maybe<ProcessType>;
  /** An edge for our `ProcessType`. May be used by Relay 1. */
  processTypeEdge?: Maybe<ProcessTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ProcessType` mutation. */
export type UpdateProcessTypePayloadProcessTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<ProcessTypesOrderBy>>;
};

/** All input for the `updateProductById` mutation. */
export type UpdateProductByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Product` being updated. */
  patch: ProductPatch;
};

/** The output of our update `Product` mutation. */
export type UpdateProductPayload = {
  __typename?: 'UpdateProductPayload';
  /** Reads a single `User` that is related to this `Product`. */
  assignedUser?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Department` that is related to this `Product`. */
  department?: Maybe<Department>;
  /** The `Product` that was updated by this mutation. */
  product?: Maybe<Product>;
  /** An edge for our `Product`. May be used by Relay 1. */
  productEdge?: Maybe<ProductsEdge>;
  /** Reads a single `ProductType` that is related to this `Product`. */
  productType?: Maybe<ProductType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Product`. */
  user?: Maybe<User>;
};


/** The output of our update `Product` mutation. */
export type UpdateProductPayloadProductEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** All input for the `updateProductTypeByCompanyIdAndDepartmentIdAndName` mutation. */
export type UpdateProductTypeByCompanyIdAndDepartmentIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `ProductType` being updated. */
  patch: ProductTypePatch;
};

/** All input for the `updateProductTypeById` mutation. */
export type UpdateProductTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProductType` being updated. */
  patch: ProductTypePatch;
};

/** The output of our update `ProductType` mutation. */
export type UpdateProductTypePayload = {
  __typename?: 'UpdateProductTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `ProductType` that was updated by this mutation. */
  productType?: Maybe<ProductType>;
  /** An edge for our `ProductType`. May be used by Relay 1. */
  productTypeEdge?: Maybe<ProductTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ProductType` mutation. */
export type UpdateProductTypePayloadProductTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductTypesOrderBy>>;
};

/** All input for the `updateProjectById` mutation. */
export type UpdateProjectByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Project` being updated. */
  patch: ProjectPatch;
};

/** The output of our update `Project` mutation. */
export type UpdateProjectPayload = {
  __typename?: 'UpdateProjectPayload';
  /** Reads a single `User` that is related to this `Project`. */
  assignedProcessUser?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Project`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `Project`. */
  employee?: Maybe<Employee>;
  /** Reads a single `Process` that is related to this `Project`. */
  process?: Maybe<Process>;
  /** Reads a single `ProcessType` that is related to this `Project`. */
  processType?: Maybe<ProcessType>;
  /** The `Project` that was updated by this mutation. */
  project?: Maybe<Project>;
  /** An edge for our `Project`. May be used by Relay 1. */
  projectEdge?: Maybe<ProjectsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Project` mutation. */
export type UpdateProjectPayloadProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** All input for the `updateProjectTemplateById` mutation. */
export type UpdateProjectTemplateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProjectTemplate` being updated. */
  patch: ProjectTemplatePatch;
};

/** The output of our update `ProjectTemplate` mutation. */
export type UpdateProjectTemplatePayload = {
  __typename?: 'UpdateProjectTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ProjectTemplate`. */
  company?: Maybe<Company>;
  /** Reads a single `Process` that is related to this `ProjectTemplate`. */
  process?: Maybe<Process>;
  /** Reads a single `ProcessType` that is related to this `ProjectTemplate`. */
  processType?: Maybe<ProcessType>;
  /** The `ProjectTemplate` that was updated by this mutation. */
  projectTemplate?: Maybe<ProjectTemplate>;
  /** An edge for our `ProjectTemplate`. May be used by Relay 1. */
  projectTemplateEdge?: Maybe<ProjectTemplatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ProjectTemplate` mutation. */
export type UpdateProjectTemplatePayloadProjectTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTemplatesOrderBy>>;
};

/** All input for the `updatePulseSurveyById` mutation. */
export type UpdatePulseSurveyByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PulseSurvey` being updated. */
  patch: PulseSurveyPatch;
};

/** All input for the `updatePulseSurveyChoiceById` mutation. */
export type UpdatePulseSurveyChoiceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PulseSurveyChoice` being updated. */
  patch: PulseSurveyChoicePatch;
};

/** The output of our update `PulseSurveyChoice` mutation. */
export type UpdatePulseSurveyChoicePayload = {
  __typename?: 'UpdatePulseSurveyChoicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PulseSurveyChoice`. */
  company?: Maybe<Company>;
  /** Reads a single `PulseSurvey` that is related to this `PulseSurveyChoice`. */
  pulseSurvey?: Maybe<PulseSurvey>;
  /** The `PulseSurveyChoice` that was updated by this mutation. */
  pulseSurveyChoice?: Maybe<PulseSurveyChoice>;
  /** An edge for our `PulseSurveyChoice`. May be used by Relay 1. */
  pulseSurveyChoiceEdge?: Maybe<PulseSurveyChoicesEdge>;
  /** Reads a single `PulseType` that is related to this `PulseSurveyChoice`. */
  pulseType?: Maybe<PulseType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseSurveyChoice`. */
  textTranslatedEntity?: Maybe<TranslatedEntity>;
};


/** The output of our update `PulseSurveyChoice` mutation. */
export type UpdatePulseSurveyChoicePayloadPulseSurveyChoiceEdgeArgs = {
  orderBy?: InputMaybe<Array<PulseSurveyChoicesOrderBy>>;
};

/** The output of our update `PulseSurvey` mutation. */
export type UpdatePulseSurveyPayload = {
  __typename?: 'UpdatePulseSurveyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PulseSurvey`. */
  company?: Maybe<Company>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseSurvey`. */
  highestRatingLabelTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseSurvey`. */
  lowestRatingLabelTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseSurvey`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** The `PulseSurvey` that was updated by this mutation. */
  pulseSurvey?: Maybe<PulseSurvey>;
  /** An edge for our `PulseSurvey`. May be used by Relay 1. */
  pulseSurveyEdge?: Maybe<PulseSurveysEdge>;
  /** Reads a single `PulseType` that is related to this `PulseSurvey`. */
  pulseType?: Maybe<PulseType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseSurvey`. */
  questionTranslatedEntity?: Maybe<TranslatedEntity>;
};


/** The output of our update `PulseSurvey` mutation. */
export type UpdatePulseSurveyPayloadPulseSurveyEdgeArgs = {
  orderBy?: InputMaybe<Array<PulseSurveysOrderBy>>;
};

/** All input for the `updatePulseTypeById` mutation. */
export type UpdatePulseTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PulseType` being updated. */
  patch: PulseTypePatch;
};

/** The output of our update `PulseType` mutation. */
export type UpdatePulseTypePayload = {
  __typename?: 'UpdatePulseTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `PulseType`. */
  company?: Maybe<Company>;
  /** Reads a single `TranslatedEntity` that is related to this `PulseType`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** The `PulseType` that was updated by this mutation. */
  pulseType?: Maybe<PulseType>;
  /** An edge for our `PulseType`. May be used by Relay 1. */
  pulseTypeEdge?: Maybe<PulseTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PulseType` mutation. */
export type UpdatePulseTypePayloadPulseTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<PulseTypesOrderBy>>;
};

/** All input for the `updateRecurrenceRuleById` mutation. */
export type UpdateRecurrenceRuleByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RecurrenceRule` being updated. */
  patch: RecurrenceRulePatch;
};

/** All input for the `updateRecurrenceRuleByPulseSurveyId` mutation. */
export type UpdateRecurrenceRuleByPulseSurveyIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `RecurrenceRule` being updated. */
  patch: RecurrenceRulePatch;
  pulseSurveyId: Scalars['UUID'];
};

/** The output of our update `RecurrenceRule` mutation. */
export type UpdateRecurrenceRulePayload = {
  __typename?: 'UpdateRecurrenceRulePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `RecurrenceRule`. */
  company?: Maybe<Company>;
  /** Reads a single `PulseSurvey` that is related to this `RecurrenceRule`. */
  pulseSurvey?: Maybe<PulseSurvey>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RecurrenceRule` that was updated by this mutation. */
  recurrenceRule?: Maybe<RecurrenceRule>;
  /** An edge for our `RecurrenceRule`. May be used by Relay 1. */
  recurrenceRuleEdge?: Maybe<RecurrenceRulesEdge>;
};


/** The output of our update `RecurrenceRule` mutation. */
export type UpdateRecurrenceRulePayloadRecurrenceRuleEdgeArgs = {
  orderBy?: InputMaybe<Array<RecurrenceRulesOrderBy>>;
};

/** All input for the `updateRoadmapItemById` mutation. */
export type UpdateRoadmapItemByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoadmapItem` being updated. */
  patch: RoadmapItemPatch;
};

/** All input for the `updateRoadmapItemCommentById` mutation. */
export type UpdateRoadmapItemCommentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoadmapItemComment` being updated. */
  patch: RoadmapItemCommentPatch;
};

/** The output of our update `RoadmapItemComment` mutation. */
export type UpdateRoadmapItemCommentPayload = {
  __typename?: 'UpdateRoadmapItemCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `RoadmapItemComment`. */
  oldUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoadmapItem` that is related to this `RoadmapItemComment`. */
  roadmapItem?: Maybe<RoadmapItem>;
  /** The `RoadmapItemComment` that was updated by this mutation. */
  roadmapItemComment?: Maybe<RoadmapItemComment>;
  /** An edge for our `RoadmapItemComment`. May be used by Relay 1. */
  roadmapItemCommentEdge?: Maybe<RoadmapItemCommentsEdge>;
};


/** The output of our update `RoadmapItemComment` mutation. */
export type UpdateRoadmapItemCommentPayloadRoadmapItemCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<RoadmapItemCommentsOrderBy>>;
};

/** All input for the `updateRoadmapItemLocalizationById` mutation. */
export type UpdateRoadmapItemLocalizationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoadmapItemLocalization` being updated. */
  patch: RoadmapItemLocalizationPatch;
};

/** All input for the `updateRoadmapItemLocalizationByRoadmapItemIdAndLocale` mutation. */
export type UpdateRoadmapItemLocalizationByRoadmapItemIdAndLocaleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locale: Scalars['String'];
  /** An object where the defined keys will be set on the `RoadmapItemLocalization` being updated. */
  patch: RoadmapItemLocalizationPatch;
  roadmapItemId: Scalars['UUID'];
};

/** The output of our update `RoadmapItemLocalization` mutation. */
export type UpdateRoadmapItemLocalizationPayload = {
  __typename?: 'UpdateRoadmapItemLocalizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoadmapItem` that is related to this `RoadmapItemLocalization`. */
  roadmapItem?: Maybe<RoadmapItem>;
  /** The `RoadmapItemLocalization` that was updated by this mutation. */
  roadmapItemLocalization?: Maybe<RoadmapItemLocalization>;
  /** An edge for our `RoadmapItemLocalization`. May be used by Relay 1. */
  roadmapItemLocalizationEdge?: Maybe<RoadmapItemLocalizationsEdge>;
};


/** The output of our update `RoadmapItemLocalization` mutation. */
export type UpdateRoadmapItemLocalizationPayloadRoadmapItemLocalizationEdgeArgs = {
  orderBy?: InputMaybe<Array<RoadmapItemLocalizationsOrderBy>>;
};

/** The output of our update `RoadmapItem` mutation. */
export type UpdateRoadmapItemPayload = {
  __typename?: 'UpdateRoadmapItemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RoadmapItem` that was updated by this mutation. */
  roadmapItem?: Maybe<RoadmapItem>;
  /** An edge for our `RoadmapItem`. May be used by Relay 1. */
  roadmapItemEdge?: Maybe<RoadmapItemsEdge>;
};


/** The output of our update `RoadmapItem` mutation. */
export type UpdateRoadmapItemPayloadRoadmapItemEdgeArgs = {
  orderBy?: InputMaybe<Array<RoadmapItemsOrderBy>>;
};

/** All input for the `updateRoadmapItemVoteById` mutation. */
export type UpdateRoadmapItemVoteByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RoadmapItemVote` being updated. */
  patch: RoadmapItemVotePatch;
};

/** All input for the `updateRoadmapItemVoteByUserIdAndRoadmapItemId` mutation. */
export type UpdateRoadmapItemVoteByUserIdAndRoadmapItemIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `RoadmapItemVote` being updated. */
  patch: RoadmapItemVotePatch;
  roadmapItemId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our update `RoadmapItemVote` mutation. */
export type UpdateRoadmapItemVotePayload = {
  __typename?: 'UpdateRoadmapItemVotePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `RoadmapItem` that is related to this `RoadmapItemVote`. */
  roadmapItem?: Maybe<RoadmapItem>;
  /** The `RoadmapItemVote` that was updated by this mutation. */
  roadmapItemVote?: Maybe<RoadmapItemVote>;
  /** An edge for our `RoadmapItemVote`. May be used by Relay 1. */
  roadmapItemVoteEdge?: Maybe<RoadmapItemVotesEdge>;
  /** Reads a single `User` that is related to this `RoadmapItemVote`. */
  user?: Maybe<User>;
};


/** The output of our update `RoadmapItemVote` mutation. */
export type UpdateRoadmapItemVotePayloadRoadmapItemVoteEdgeArgs = {
  orderBy?: InputMaybe<Array<RoadmapItemVotesOrderBy>>;
};

/** All input for the `updateRoleById` mutation. */
export type UpdateRoleByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Role` being updated. */
  patch: RolePatch;
};

/** The output of our update `Role` mutation. */
export type UpdateRolePayload = {
  __typename?: 'UpdateRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Role` that was updated by this mutation. */
  role?: Maybe<Role>;
  /** An edge for our `Role`. May be used by Relay 1. */
  roleEdge?: Maybe<RolesEdge>;
};


/** The output of our update `Role` mutation. */
export type UpdateRolePayloadRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<RolesOrderBy>>;
};

/** All input for the `updateSavedSignatureById` mutation. */
export type UpdateSavedSignatureByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SavedSignature` being updated. */
  patch: SavedSignaturePatch;
};

/** The output of our update `SavedSignature` mutation. */
export type UpdateSavedSignaturePayload = {
  __typename?: 'UpdateSavedSignaturePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Employee` that is related to this `SavedSignature`. */
  employee?: Maybe<Employee>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SavedSignature` that was updated by this mutation. */
  savedSignature?: Maybe<SavedSignature>;
  /** An edge for our `SavedSignature`. May be used by Relay 1. */
  savedSignatureEdge?: Maybe<SavedSignaturesEdge>;
  /** Reads a single `Storage` that is related to this `SavedSignature`. */
  storage?: Maybe<Storage>;
};


/** The output of our update `SavedSignature` mutation. */
export type UpdateSavedSignaturePayloadSavedSignatureEdgeArgs = {
  orderBy?: InputMaybe<Array<SavedSignaturesOrderBy>>;
};

/** All input for the `updateScheduledMessageById` mutation. */
export type UpdateScheduledMessageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ScheduledMessage` being updated. */
  patch: ScheduledMessagePatch;
};

/** All input for the `updateScheduledMessageExternalRecipientByScheduledMessageIdAndEmail` mutation. */
export type UpdateScheduledMessageExternalRecipientByScheduledMessageIdAndEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  /** An object where the defined keys will be set on the `ScheduledMessageExternalRecipient` being updated. */
  patch: ScheduledMessageExternalRecipientPatch;
  scheduledMessageId: Scalars['UUID'];
};

/** The output of our update `ScheduledMessageExternalRecipient` mutation. */
export type UpdateScheduledMessageExternalRecipientPayload = {
  __typename?: 'UpdateScheduledMessageExternalRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ScheduledMessageExternalRecipient`. */
  company?: Maybe<Company>;
  /** Reads a single `ProcessType` that is related to this `ScheduledMessageExternalRecipient`. */
  processType?: Maybe<ProcessType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ScheduledMessage` that is related to this `ScheduledMessageExternalRecipient`. */
  scheduledMessage?: Maybe<ScheduledMessage>;
  /** The `ScheduledMessageExternalRecipient` that was updated by this mutation. */
  scheduledMessageExternalRecipient?: Maybe<ScheduledMessageExternalRecipient>;
  /** An edge for our `ScheduledMessageExternalRecipient`. May be used by Relay 1. */
  scheduledMessageExternalRecipientEdge?: Maybe<ScheduledMessageExternalRecipientsEdge>;
};


/** The output of our update `ScheduledMessageExternalRecipient` mutation. */
export type UpdateScheduledMessageExternalRecipientPayloadScheduledMessageExternalRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledMessageExternalRecipientsOrderBy>>;
};

/** The output of our update `ScheduledMessage` mutation. */
export type UpdateScheduledMessagePayload = {
  __typename?: 'UpdateScheduledMessagePayload';
  /** Reads a single `User` that is related to this `ScheduledMessage`. */
  assignedProcessUser?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ScheduledMessage`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `ScheduledMessage`. */
  employee?: Maybe<Employee>;
  /** Reads a single `Process` that is related to this `ScheduledMessage`. */
  process?: Maybe<Process>;
  /** Reads a single `ProcessType` that is related to this `ScheduledMessage`. */
  processType?: Maybe<ProcessType>;
  /** Reads a single `Project` that is related to this `ScheduledMessage`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ScheduledMessage` that was updated by this mutation. */
  scheduledMessage?: Maybe<ScheduledMessage>;
  /** An edge for our `ScheduledMessage`. May be used by Relay 1. */
  scheduledMessageEdge?: Maybe<ScheduledMessagesEdge>;
  /** Reads a single `Employee` that is related to this `ScheduledMessage`. */
  senderEmployee?: Maybe<Employee>;
};


/** The output of our update `ScheduledMessage` mutation. */
export type UpdateScheduledMessagePayloadScheduledMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledMessagesOrderBy>>;
};

/** All input for the `updateScheduledMessageRecipientByScheduledMessageIdAndEmployeeId` mutation. */
export type UpdateScheduledMessageRecipientByScheduledMessageIdAndEmployeeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ScheduledMessageRecipient` being updated. */
  patch: ScheduledMessageRecipientPatch;
  scheduledMessageId: Scalars['UUID'];
};

/** The output of our update `ScheduledMessageRecipient` mutation. */
export type UpdateScheduledMessageRecipientPayload = {
  __typename?: 'UpdateScheduledMessageRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ScheduledMessageRecipient`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `ScheduledMessageRecipient`. */
  employee?: Maybe<Employee>;
  /** Reads a single `ProcessType` that is related to this `ScheduledMessageRecipient`. */
  processType?: Maybe<ProcessType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ScheduledMessage` that is related to this `ScheduledMessageRecipient`. */
  scheduledMessage?: Maybe<ScheduledMessage>;
  /** The `ScheduledMessageRecipient` that was updated by this mutation. */
  scheduledMessageRecipient?: Maybe<ScheduledMessageRecipient>;
  /** An edge for our `ScheduledMessageRecipient`. May be used by Relay 1. */
  scheduledMessageRecipientEdge?: Maybe<ScheduledMessageRecipientsEdge>;
};


/** The output of our update `ScheduledMessageRecipient` mutation. */
export type UpdateScheduledMessageRecipientPayloadScheduledMessageRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledMessageRecipientsOrderBy>>;
};

/** All input for the `updateScheduledMessageTemplateById` mutation. */
export type UpdateScheduledMessageTemplateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ScheduledMessageTemplate` being updated. */
  patch: ScheduledMessageTemplatePatch;
};

/** All input for the `updateScheduledMessageTemplateExternalRecipientByScheduledMessageTemplateIdAndEmail` mutation. */
export type UpdateScheduledMessageTemplateExternalRecipientByScheduledMessageTemplateIdAndEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  /** An object where the defined keys will be set on the `ScheduledMessageTemplateExternalRecipient` being updated. */
  patch: ScheduledMessageTemplateExternalRecipientPatch;
  scheduledMessageTemplateId: Scalars['UUID'];
};

/** The output of our update `ScheduledMessageTemplateExternalRecipient` mutation. */
export type UpdateScheduledMessageTemplateExternalRecipientPayload = {
  __typename?: 'UpdateScheduledMessageTemplateExternalRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ScheduledMessageTemplateExternalRecipient`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ScheduledMessageTemplate` that is related to this `ScheduledMessageTemplateExternalRecipient`. */
  scheduledMessageTemplate?: Maybe<ScheduledMessageTemplate>;
  /** The `ScheduledMessageTemplateExternalRecipient` that was updated by this mutation. */
  scheduledMessageTemplateExternalRecipient?: Maybe<ScheduledMessageTemplateExternalRecipient>;
  /** An edge for our `ScheduledMessageTemplateExternalRecipient`. May be used by Relay 1. */
  scheduledMessageTemplateExternalRecipientEdge?: Maybe<ScheduledMessageTemplateExternalRecipientsEdge>;
};


/** The output of our update `ScheduledMessageTemplateExternalRecipient` mutation. */
export type UpdateScheduledMessageTemplateExternalRecipientPayloadScheduledMessageTemplateExternalRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledMessageTemplateExternalRecipientsOrderBy>>;
};

/** The output of our update `ScheduledMessageTemplate` mutation. */
export type UpdateScheduledMessageTemplatePayload = {
  __typename?: 'UpdateScheduledMessageTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ScheduledMessageTemplate`. */
  company?: Maybe<Company>;
  /** Reads a single `Process` that is related to this `ScheduledMessageTemplate`. */
  process?: Maybe<Process>;
  /** Reads a single `ProcessType` that is related to this `ScheduledMessageTemplate`. */
  processType?: Maybe<ProcessType>;
  /** Reads a single `ProjectTemplate` that is related to this `ScheduledMessageTemplate`. */
  project?: Maybe<ProjectTemplate>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ScheduledMessageTemplate` that was updated by this mutation. */
  scheduledMessageTemplate?: Maybe<ScheduledMessageTemplate>;
  /** An edge for our `ScheduledMessageTemplate`. May be used by Relay 1. */
  scheduledMessageTemplateEdge?: Maybe<ScheduledMessageTemplatesEdge>;
};


/** The output of our update `ScheduledMessageTemplate` mutation. */
export type UpdateScheduledMessageTemplatePayloadScheduledMessageTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledMessageTemplatesOrderBy>>;
};

/** All input for the `updateScheduledMessageTemplateRecipientByScheduledMessageTemplateIdAndEmployeeId` mutation. */
export type UpdateScheduledMessageTemplateRecipientByScheduledMessageTemplateIdAndEmployeeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ScheduledMessageTemplateRecipient` being updated. */
  patch: ScheduledMessageTemplateRecipientPatch;
  scheduledMessageTemplateId: Scalars['UUID'];
};

/** The output of our update `ScheduledMessageTemplateRecipient` mutation. */
export type UpdateScheduledMessageTemplateRecipientPayload = {
  __typename?: 'UpdateScheduledMessageTemplateRecipientPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `ScheduledMessageTemplateRecipient`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `ScheduledMessageTemplateRecipient`. */
  employee?: Maybe<Employee>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ScheduledMessageTemplate` that is related to this `ScheduledMessageTemplateRecipient`. */
  scheduledMessageTemplate?: Maybe<ScheduledMessageTemplate>;
  /** The `ScheduledMessageTemplateRecipient` that was updated by this mutation. */
  scheduledMessageTemplateRecipient?: Maybe<ScheduledMessageTemplateRecipient>;
  /** An edge for our `ScheduledMessageTemplateRecipient`. May be used by Relay 1. */
  scheduledMessageTemplateRecipientEdge?: Maybe<ScheduledMessageTemplateRecipientsEdge>;
};


/** The output of our update `ScheduledMessageTemplateRecipient` mutation. */
export type UpdateScheduledMessageTemplateRecipientPayloadScheduledMessageTemplateRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledMessageTemplateRecipientsOrderBy>>;
};

/** All input for the `updateStorageById` mutation. */
export type UpdateStorageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Storage` being updated. */
  patch: StoragePatch;
};

/** The output of our update `Storage` mutation. */
export type UpdateStoragePayload = {
  __typename?: 'UpdateStoragePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `ContractSignPendingDocument` that is related to this `Storage`. */
  contractSignPendingDocument?: Maybe<ContractSignPendingDocument>;
  /** Reads a single `DocumentFolder` that is related to this `Storage`. */
  documentFolder?: Maybe<DocumentFolder>;
  /** Reads a single `ContractTemplate` that is related to this `Storage`. */
  documentTemplate?: Maybe<ContractTemplate>;
  /** Reads a single `DocumentType` that is related to this `Storage`. */
  documentType?: Maybe<DocumentType>;
  /** Reads a single `EmployeeCasefile` that is related to this `Storage`. */
  employeeCasefile?: Maybe<EmployeeCasefile>;
  /** Reads a single `ProcessType` that is related to this `Storage`. */
  processType?: Maybe<ProcessType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `DocumentFolderBlueprint` that is related to this `Storage`. */
  rootDocumentFolderBlueprint?: Maybe<DocumentFolderBlueprint>;
  /** The `Storage` that was updated by this mutation. */
  storage?: Maybe<Storage>;
  /** An edge for our `Storage`. May be used by Relay 1. */
  storageEdge?: Maybe<StoragesEdge>;
};


/** The output of our update `Storage` mutation. */
export type UpdateStoragePayloadStorageEdgeArgs = {
  orderBy?: InputMaybe<Array<StoragesOrderBy>>;
};

/** All input for the `updateSuperUserAllowedUserById` mutation. */
export type UpdateSuperUserAllowedUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SuperUserAllowedUser` being updated. */
  patch: SuperUserAllowedUserPatch;
};

/** All input for the `updateSuperUserAllowedUserBySuperUserIdAndCompanyId` mutation. */
export type UpdateSuperUserAllowedUserBySuperUserIdAndCompanyIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SuperUserAllowedUser` being updated. */
  patch: SuperUserAllowedUserPatch;
  superUserId: Scalars['UUID'];
};

/** The output of our update `SuperUserAllowedUser` mutation. */
export type UpdateSuperUserAllowedUserPayload = {
  __typename?: 'UpdateSuperUserAllowedUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `SuperUserAllowedUser`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SuperUser` that is related to this `SuperUserAllowedUser`. */
  superUser?: Maybe<SuperUser>;
  /** The `SuperUserAllowedUser` that was updated by this mutation. */
  superUserAllowedUser?: Maybe<SuperUserAllowedUser>;
  /** An edge for our `SuperUserAllowedUser`. May be used by Relay 1. */
  superUserAllowedUserEdge?: Maybe<SuperUserAllowedUsersEdge>;
};


/** The output of our update `SuperUserAllowedUser` mutation. */
export type UpdateSuperUserAllowedUserPayloadSuperUserAllowedUserEdgeArgs = {
  orderBy?: InputMaybe<Array<SuperUserAllowedUsersOrderBy>>;
};

/** All input for the `updateSuperUserById` mutation. */
export type UpdateSuperUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SuperUser` being updated. */
  patch: SuperUserPatch;
};

/** All input for the `updateSuperUserByUserId` mutation. */
export type UpdateSuperUserByUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `SuperUser` being updated. */
  patch: SuperUserPatch;
  userId: Scalars['UUID'];
};

/** The output of our update `SuperUser` mutation. */
export type UpdateSuperUserPayload = {
  __typename?: 'UpdateSuperUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SuperUser` that was updated by this mutation. */
  superUser?: Maybe<SuperUser>;
  /** An edge for our `SuperUser`. May be used by Relay 1. */
  superUserEdge?: Maybe<SuperUsersEdge>;
  /** Reads a single `User` that is related to this `SuperUser`. */
  user?: Maybe<User>;
};


/** The output of our update `SuperUser` mutation. */
export type UpdateSuperUserPayloadSuperUserEdgeArgs = {
  orderBy?: InputMaybe<Array<SuperUsersOrderBy>>;
};

/** All input for the `updateSystemFieldTypeByType` mutation. */
export type UpdateSystemFieldTypeByTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `SystemFieldType` being updated. */
  patch: SystemFieldTypePatch;
  type: Scalars['String'];
};

/** The output of our update `SystemFieldType` mutation. */
export type UpdateSystemFieldTypePayload = {
  __typename?: 'UpdateSystemFieldTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SystemFieldType` that was updated by this mutation. */
  systemFieldType?: Maybe<SystemFieldType>;
  /** An edge for our `SystemFieldType`. May be used by Relay 1. */
  systemFieldTypeEdge?: Maybe<SystemFieldTypesEdge>;
};


/** The output of our update `SystemFieldType` mutation. */
export type UpdateSystemFieldTypePayloadSystemFieldTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<SystemFieldTypesOrderBy>>;
};

/** All input for the `updateTaskById` mutation. */
export type UpdateTaskByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Task` being updated. */
  patch: TaskPatch;
};

/** All input for the `updateTaskEmployeeByTaskIdAndEmployeeId` mutation. */
export type UpdateTaskEmployeeByTaskIdAndEmployeeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `TaskEmployee` being updated. */
  patch: TaskEmployeePatch;
  taskId: Scalars['UUID'];
};

/** The output of our update `TaskEmployee` mutation. */
export type UpdateTaskEmployeePayload = {
  __typename?: 'UpdateTaskEmployeePayload';
  /** Reads a single `User` that is related to this `TaskEmployee`. */
  assignedProcessUser?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TaskEmployee`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `TaskEmployee`. */
  employee?: Maybe<Employee>;
  /** Reads a single `ProcessType` that is related to this `TaskEmployee`. */
  processType?: Maybe<ProcessType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Task` that is related to this `TaskEmployee`. */
  task?: Maybe<Task>;
  /** The `TaskEmployee` that was updated by this mutation. */
  taskEmployee?: Maybe<TaskEmployee>;
  /** An edge for our `TaskEmployee`. May be used by Relay 1. */
  taskEmployeeEdge?: Maybe<TaskEmployeesEdge>;
  /** Reads a single `User` that is related to this `TaskEmployee`. */
  user?: Maybe<User>;
};


/** The output of our update `TaskEmployee` mutation. */
export type UpdateTaskEmployeePayloadTaskEmployeeEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskEmployeesOrderBy>>;
};

/** The output of our update `Task` mutation. */
export type UpdateTaskPayload = {
  __typename?: 'UpdateTaskPayload';
  /** Reads a single `User` that is related to this `Task`. */
  assignedProcessUser?: Maybe<User>;
  /** Reads a single `User` that is related to this `Task`. */
  calendarEventOrganizer?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Task`. */
  company?: Maybe<Company>;
  /** Reads a single `Task` that is related to this `Task`. */
  parentTask?: Maybe<Task>;
  /** Reads a single `Process` that is related to this `Task`. */
  process?: Maybe<Process>;
  /** Reads a single `ProcessType` that is related to this `Task`. */
  processType?: Maybe<ProcessType>;
  /** Reads a single `Project` that is related to this `Task`. */
  project?: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Task` that was updated by this mutation. */
  task?: Maybe<Task>;
  /** An edge for our `Task`. May be used by Relay 1. */
  taskEdge?: Maybe<TasksEdge>;
  /** Reads a single `User` that is related to this `Task`. */
  userByCompletedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `Task`. */
  userByCreatedBy?: Maybe<User>;
};


/** The output of our update `Task` mutation. */
export type UpdateTaskPayloadTaskEdgeArgs = {
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};

/** All input for the `updateTaskResponsibleByTaskIdAndResponsibleId` mutation. */
export type UpdateTaskResponsibleByTaskIdAndResponsibleIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `TaskResponsible` being updated. */
  patch: TaskResponsiblePatch;
  responsibleId: Scalars['UUID'];
  taskId: Scalars['UUID'];
};

/** The output of our update `TaskResponsible` mutation. */
export type UpdateTaskResponsiblePayload = {
  __typename?: 'UpdateTaskResponsiblePayload';
  /** Reads a single `User` that is related to this `TaskResponsible`. */
  assignedProcessUser?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TaskResponsible`. */
  company?: Maybe<Company>;
  /** Reads a single `ProcessType` that is related to this `TaskResponsible`. */
  processType?: Maybe<ProcessType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Employee` that is related to this `TaskResponsible`. */
  responsible?: Maybe<Employee>;
  /** Reads a single `Task` that is related to this `TaskResponsible`. */
  task?: Maybe<Task>;
  /** The `TaskResponsible` that was updated by this mutation. */
  taskResponsible?: Maybe<TaskResponsible>;
  /** An edge for our `TaskResponsible`. May be used by Relay 1. */
  taskResponsibleEdge?: Maybe<TaskResponsiblesEdge>;
  /** Reads a single `User` that is related to this `TaskResponsible`. */
  user?: Maybe<User>;
};


/** The output of our update `TaskResponsible` mutation. */
export type UpdateTaskResponsiblePayloadTaskResponsibleEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskResponsiblesOrderBy>>;
};

/** All input for the `updateTaskTemplateById` mutation. */
export type UpdateTaskTemplateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `TaskTemplate` being updated. */
  patch: TaskTemplatePatch;
};

/** All input for the `updateTaskTemplateEmployeeByTaskTemplateIdAndEmployeeId` mutation. */
export type UpdateTaskTemplateEmployeeByTaskTemplateIdAndEmployeeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `TaskTemplateEmployee` being updated. */
  patch: TaskTemplateEmployeePatch;
  taskTemplateId: Scalars['UUID'];
};

/** The output of our update `TaskTemplateEmployee` mutation. */
export type UpdateTaskTemplateEmployeePayload = {
  __typename?: 'UpdateTaskTemplateEmployeePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TaskTemplateEmployee`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `TaskTemplateEmployee`. */
  employee?: Maybe<Employee>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TaskTemplate` that is related to this `TaskTemplateEmployee`. */
  taskTemplate?: Maybe<TaskTemplate>;
  /** The `TaskTemplateEmployee` that was updated by this mutation. */
  taskTemplateEmployee?: Maybe<TaskTemplateEmployee>;
  /** An edge for our `TaskTemplateEmployee`. May be used by Relay 1. */
  taskTemplateEmployeeEdge?: Maybe<TaskTemplateEmployeesEdge>;
};


/** The output of our update `TaskTemplateEmployee` mutation. */
export type UpdateTaskTemplateEmployeePayloadTaskTemplateEmployeeEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskTemplateEmployeesOrderBy>>;
};

/** The output of our update `TaskTemplate` mutation. */
export type UpdateTaskTemplatePayload = {
  __typename?: 'UpdateTaskTemplatePayload';
  /** Reads a single `User` that is related to this `TaskTemplate`. */
  calendarEventOrganizer?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TaskTemplate`. */
  company?: Maybe<Company>;
  /** Reads a single `TaskTemplate` that is related to this `TaskTemplate`. */
  parentTask?: Maybe<TaskTemplate>;
  /** Reads a single `Process` that is related to this `TaskTemplate`. */
  process?: Maybe<Process>;
  /** Reads a single `ProcessType` that is related to this `TaskTemplate`. */
  processType?: Maybe<ProcessType>;
  /** Reads a single `ProjectTemplate` that is related to this `TaskTemplate`. */
  project?: Maybe<ProjectTemplate>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TaskTemplate` that was updated by this mutation. */
  taskTemplate?: Maybe<TaskTemplate>;
  /** An edge for our `TaskTemplate`. May be used by Relay 1. */
  taskTemplateEdge?: Maybe<TaskTemplatesEdge>;
};


/** The output of our update `TaskTemplate` mutation. */
export type UpdateTaskTemplatePayloadTaskTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskTemplatesOrderBy>>;
};

/** All input for the `updateTaskTemplateResponsibleByTaskTemplateIdAndResponsibleId` mutation. */
export type UpdateTaskTemplateResponsibleByTaskTemplateIdAndResponsibleIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `TaskTemplateResponsible` being updated. */
  patch: TaskTemplateResponsiblePatch;
  responsibleId: Scalars['UUID'];
  taskTemplateId: Scalars['UUID'];
};

/** The output of our update `TaskTemplateResponsible` mutation. */
export type UpdateTaskTemplateResponsiblePayload = {
  __typename?: 'UpdateTaskTemplateResponsiblePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TaskTemplateResponsible`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Employee` that is related to this `TaskTemplateResponsible`. */
  responsible?: Maybe<Employee>;
  /** Reads a single `TaskTemplate` that is related to this `TaskTemplateResponsible`. */
  taskTemplate?: Maybe<TaskTemplate>;
  /** The `TaskTemplateResponsible` that was updated by this mutation. */
  taskTemplateResponsible?: Maybe<TaskTemplateResponsible>;
  /** An edge for our `TaskTemplateResponsible`. May be used by Relay 1. */
  taskTemplateResponsibleEdge?: Maybe<TaskTemplateResponsiblesEdge>;
};


/** The output of our update `TaskTemplateResponsible` mutation. */
export type UpdateTaskTemplateResponsiblePayloadTaskTemplateResponsibleEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskTemplateResponsiblesOrderBy>>;
};

/** All input for the `updateTimeRegistrationBreakTypeById` mutation. */
export type UpdateTimeRegistrationBreakTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `TimeRegistrationBreakType` being updated. */
  patch: TimeRegistrationBreakTypePatch;
};

/** The output of our update `TimeRegistrationBreakType` mutation. */
export type UpdateTimeRegistrationBreakTypePayload = {
  __typename?: 'UpdateTimeRegistrationBreakTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationBreakType`. */
  company?: Maybe<Company>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationBreakType`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TimeRegistrationBreakType` that was updated by this mutation. */
  timeRegistrationBreakType?: Maybe<TimeRegistrationBreakType>;
  /** An edge for our `TimeRegistrationBreakType`. May be used by Relay 1. */
  timeRegistrationBreakTypeEdge?: Maybe<TimeRegistrationBreakTypesEdge>;
};


/** The output of our update `TimeRegistrationBreakType` mutation. */
export type UpdateTimeRegistrationBreakTypePayloadTimeRegistrationBreakTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationBreakTypesOrderBy>>;
};

/** All input for the `updateTimeRegistrationEntryById` mutation. */
export type UpdateTimeRegistrationEntryByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `TimeRegistrationEntry` being updated. */
  patch: TimeRegistrationEntryPatch;
};

/** The output of our update `TimeRegistrationEntry` mutation. */
export type UpdateTimeRegistrationEntryPayload = {
  __typename?: 'UpdateTimeRegistrationEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationEntry`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TimeRegistrationBreakType` that is related to this `TimeRegistrationEntry`. */
  timeRegistrationBreakType?: Maybe<TimeRegistrationBreakType>;
  /** The `TimeRegistrationEntry` that was updated by this mutation. */
  timeRegistrationEntry?: Maybe<TimeRegistrationEntry>;
  /** An edge for our `TimeRegistrationEntry`. May be used by Relay 1. */
  timeRegistrationEntryEdge?: Maybe<TimeRegistrationEntriesEdge>;
  /** Reads a single `TimeRegistrationPresence` that is related to this `TimeRegistrationEntry`. */
  timeRegistrationPresence?: Maybe<TimeRegistrationPresence>;
  /** Reads a single `TimeRegistrationProject` that is related to this `TimeRegistrationEntry`. */
  timeRegistrationProject?: Maybe<TimeRegistrationProject>;
  /** Reads a single `User` that is related to this `TimeRegistrationEntry`. */
  user?: Maybe<User>;
};


/** The output of our update `TimeRegistrationEntry` mutation. */
export type UpdateTimeRegistrationEntryPayloadTimeRegistrationEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationEntriesOrderBy>>;
};

/** All input for the `updateTimeRegistrationEntryTemplateById` mutation. */
export type UpdateTimeRegistrationEntryTemplateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `TimeRegistrationEntryTemplate` being updated. */
  patch: TimeRegistrationEntryTemplatePatch;
};

/** The output of our update `TimeRegistrationEntryTemplate` mutation. */
export type UpdateTimeRegistrationEntryTemplatePayload = {
  __typename?: 'UpdateTimeRegistrationEntryTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationEntryTemplate`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TimeRegistrationBreakType` that is related to this `TimeRegistrationEntryTemplate`. */
  timeRegistrationBreakType?: Maybe<TimeRegistrationBreakType>;
  /** The `TimeRegistrationEntryTemplate` that was updated by this mutation. */
  timeRegistrationEntryTemplate?: Maybe<TimeRegistrationEntryTemplate>;
  /** An edge for our `TimeRegistrationEntryTemplate`. May be used by Relay 1. */
  timeRegistrationEntryTemplateEdge?: Maybe<TimeRegistrationEntryTemplatesEdge>;
  /** Reads a single `TimeRegistrationPresenceTemplate` that is related to this `TimeRegistrationEntryTemplate`. */
  timeRegistrationPresenceTemplate?: Maybe<TimeRegistrationPresenceTemplate>;
  /** Reads a single `TimeRegistrationProject` that is related to this `TimeRegistrationEntryTemplate`. */
  timeRegistrationProject?: Maybe<TimeRegistrationProject>;
  /** Reads a single `TimeRegistrationTemplate` that is related to this `TimeRegistrationEntryTemplate`. */
  timeRegistrationTemplate?: Maybe<TimeRegistrationTemplate>;
  /** Reads a single `User` that is related to this `TimeRegistrationEntryTemplate`. */
  user?: Maybe<User>;
};


/** The output of our update `TimeRegistrationEntryTemplate` mutation. */
export type UpdateTimeRegistrationEntryTemplatePayloadTimeRegistrationEntryTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationEntryTemplatesOrderBy>>;
};

/** All input for the `updateTimeRegistrationPresenceById` mutation. */
export type UpdateTimeRegistrationPresenceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `TimeRegistrationPresence` being updated. */
  patch: TimeRegistrationPresencePatch;
};

/** The output of our update `TimeRegistrationPresence` mutation. */
export type UpdateTimeRegistrationPresencePayload = {
  __typename?: 'UpdateTimeRegistrationPresencePayload';
  /** Reads a single `Approval` that is related to this `TimeRegistrationPresence`. */
  approval?: Maybe<Approval>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationPresence`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TimeRegistrationPresence` that was updated by this mutation. */
  timeRegistrationPresence?: Maybe<TimeRegistrationPresence>;
  /** An edge for our `TimeRegistrationPresence`. May be used by Relay 1. */
  timeRegistrationPresenceEdge?: Maybe<TimeRegistrationPresencesEdge>;
  /** Reads a single `TimeRegistrationPresenceType` that is related to this `TimeRegistrationPresence`. */
  timeRegistrationPresenceType?: Maybe<TimeRegistrationPresenceType>;
  /** Reads a single `User` that is related to this `TimeRegistrationPresence`. */
  user?: Maybe<User>;
};


/** The output of our update `TimeRegistrationPresence` mutation. */
export type UpdateTimeRegistrationPresencePayloadTimeRegistrationPresenceEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationPresencesOrderBy>>;
};

/** All input for the `updateTimeRegistrationPresenceTemplateById` mutation. */
export type UpdateTimeRegistrationPresenceTemplateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `TimeRegistrationPresenceTemplate` being updated. */
  patch: TimeRegistrationPresenceTemplatePatch;
};

/** The output of our update `TimeRegistrationPresenceTemplate` mutation. */
export type UpdateTimeRegistrationPresenceTemplatePayload = {
  __typename?: 'UpdateTimeRegistrationPresenceTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationPresenceTemplate`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TimeRegistrationPresenceTemplate` that was updated by this mutation. */
  timeRegistrationPresenceTemplate?: Maybe<TimeRegistrationPresenceTemplate>;
  /** An edge for our `TimeRegistrationPresenceTemplate`. May be used by Relay 1. */
  timeRegistrationPresenceTemplateEdge?: Maybe<TimeRegistrationPresenceTemplatesEdge>;
  /** Reads a single `TimeRegistrationPresenceType` that is related to this `TimeRegistrationPresenceTemplate`. */
  timeRegistrationPresenceType?: Maybe<TimeRegistrationPresenceType>;
  /** Reads a single `TimeRegistrationTemplate` that is related to this `TimeRegistrationPresenceTemplate`. */
  timeRegistrationTemplate?: Maybe<TimeRegistrationTemplate>;
  /** Reads a single `TimeRegistrationTemplateWeek` that is related to this `TimeRegistrationPresenceTemplate`. */
  timeRegistrationTemplateWeek?: Maybe<TimeRegistrationTemplateWeek>;
  /** Reads a single `User` that is related to this `TimeRegistrationPresenceTemplate`. */
  user?: Maybe<User>;
};


/** The output of our update `TimeRegistrationPresenceTemplate` mutation. */
export type UpdateTimeRegistrationPresenceTemplatePayloadTimeRegistrationPresenceTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationPresenceTemplatesOrderBy>>;
};

/** All input for the `updateTimeRegistrationPresenceTypeById` mutation. */
export type UpdateTimeRegistrationPresenceTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `TimeRegistrationPresenceType` being updated. */
  patch: TimeRegistrationPresenceTypePatch;
};

/** The output of our update `TimeRegistrationPresenceType` mutation. */
export type UpdateTimeRegistrationPresenceTypePayload = {
  __typename?: 'UpdateTimeRegistrationPresenceTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationPresenceType`. */
  company?: Maybe<Company>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationPresenceType`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TimeRegistrationPresenceType` that was updated by this mutation. */
  timeRegistrationPresenceType?: Maybe<TimeRegistrationPresenceType>;
  /** An edge for our `TimeRegistrationPresenceType`. May be used by Relay 1. */
  timeRegistrationPresenceTypeEdge?: Maybe<TimeRegistrationPresenceTypesEdge>;
};


/** The output of our update `TimeRegistrationPresenceType` mutation. */
export type UpdateTimeRegistrationPresenceTypePayloadTimeRegistrationPresenceTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationPresenceTypesOrderBy>>;
};

/** All input for the `updateTimeRegistrationProjectById` mutation. */
export type UpdateTimeRegistrationProjectByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `TimeRegistrationProject` being updated. */
  patch: TimeRegistrationProjectPatch;
};

/** The output of our update `TimeRegistrationProject` mutation. */
export type UpdateTimeRegistrationProjectPayload = {
  __typename?: 'UpdateTimeRegistrationProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationProject`. */
  company?: Maybe<Company>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationProject`. */
  descriptionTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationProject`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TimeRegistrationProject` that was updated by this mutation. */
  timeRegistrationProject?: Maybe<TimeRegistrationProject>;
  /** An edge for our `TimeRegistrationProject`. May be used by Relay 1. */
  timeRegistrationProjectEdge?: Maybe<TimeRegistrationProjectsEdge>;
};


/** The output of our update `TimeRegistrationProject` mutation. */
export type UpdateTimeRegistrationProjectPayloadTimeRegistrationProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationProjectsOrderBy>>;
};

/** All input for the `updateTimeRegistrationTemplateById` mutation. */
export type UpdateTimeRegistrationTemplateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `TimeRegistrationTemplate` being updated. */
  patch: TimeRegistrationTemplatePatch;
};

/** The output of our update `TimeRegistrationTemplate` mutation. */
export type UpdateTimeRegistrationTemplatePayload = {
  __typename?: 'UpdateTimeRegistrationTemplatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationTemplate`. */
  company?: Maybe<Company>;
  /** Reads a single `TranslatedEntity` that is related to this `TimeRegistrationTemplate`. */
  nameTranslatedEntity?: Maybe<TranslatedEntity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TimeRegistrationTemplate` that was updated by this mutation. */
  timeRegistrationTemplate?: Maybe<TimeRegistrationTemplate>;
  /** An edge for our `TimeRegistrationTemplate`. May be used by Relay 1. */
  timeRegistrationTemplateEdge?: Maybe<TimeRegistrationTemplatesEdge>;
};


/** The output of our update `TimeRegistrationTemplate` mutation. */
export type UpdateTimeRegistrationTemplatePayloadTimeRegistrationTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationTemplatesOrderBy>>;
};

/** All input for the `updateTimeRegistrationTemplateWeekById` mutation. */
export type UpdateTimeRegistrationTemplateWeekByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `TimeRegistrationTemplateWeek` being updated. */
  patch: TimeRegistrationTemplateWeekPatch;
};

/** The output of our update `TimeRegistrationTemplateWeek` mutation. */
export type UpdateTimeRegistrationTemplateWeekPayload = {
  __typename?: 'UpdateTimeRegistrationTemplateWeekPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TimeRegistrationTemplateWeek`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TimeRegistrationTemplate` that is related to this `TimeRegistrationTemplateWeek`. */
  timeRegistrationTemplate?: Maybe<TimeRegistrationTemplate>;
  /** The `TimeRegistrationTemplateWeek` that was updated by this mutation. */
  timeRegistrationTemplateWeek?: Maybe<TimeRegistrationTemplateWeek>;
  /** An edge for our `TimeRegistrationTemplateWeek`. May be used by Relay 1. */
  timeRegistrationTemplateWeekEdge?: Maybe<TimeRegistrationTemplateWeeksEdge>;
  /** Reads a single `User` that is related to this `TimeRegistrationTemplateWeek`. */
  user?: Maybe<User>;
};


/** The output of our update `TimeRegistrationTemplateWeek` mutation. */
export type UpdateTimeRegistrationTemplateWeekPayloadTimeRegistrationTemplateWeekEdgeArgs = {
  orderBy?: InputMaybe<Array<TimeRegistrationTemplateWeeksOrderBy>>;
};

/** All input for the `updateTranslatedEntityById` mutation. */
export type UpdateTranslatedEntityByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `TranslatedEntity` being updated. */
  patch: TranslatedEntityPatch;
};

/** All input for the `updateTranslatedEntityLocalizationById` mutation. */
export type UpdateTranslatedEntityLocalizationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `TranslatedEntityLocalization` being updated. */
  patch: TranslatedEntityLocalizationPatch;
};

/** All input for the `updateTranslatedEntityLocalizationByTranslatedEntityIdAndLocale` mutation. */
export type UpdateTranslatedEntityLocalizationByTranslatedEntityIdAndLocaleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locale: Scalars['String'];
  /** An object where the defined keys will be set on the `TranslatedEntityLocalization` being updated. */
  patch: TranslatedEntityLocalizationPatch;
  translatedEntityId: Scalars['UUID'];
};

/** The output of our update `TranslatedEntityLocalization` mutation. */
export type UpdateTranslatedEntityLocalizationPayload = {
  __typename?: 'UpdateTranslatedEntityLocalizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TranslatedEntityLocalization`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `TranslatedEntity` that is related to this `TranslatedEntityLocalization`. */
  translatedEntity?: Maybe<TranslatedEntity>;
  /** The `TranslatedEntityLocalization` that was updated by this mutation. */
  translatedEntityLocalization?: Maybe<TranslatedEntityLocalization>;
  /** An edge for our `TranslatedEntityLocalization`. May be used by Relay 1. */
  translatedEntityLocalizationEdge?: Maybe<TranslatedEntityLocalizationsEdge>;
};


/** The output of our update `TranslatedEntityLocalization` mutation. */
export type UpdateTranslatedEntityLocalizationPayloadTranslatedEntityLocalizationEdgeArgs = {
  orderBy?: InputMaybe<Array<TranslatedEntityLocalizationsOrderBy>>;
};

/** The output of our update `TranslatedEntity` mutation. */
export type UpdateTranslatedEntityPayload = {
  __typename?: 'UpdateTranslatedEntityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `TranslatedEntity`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TranslatedEntity` that was updated by this mutation. */
  translatedEntity?: Maybe<TranslatedEntity>;
  /** An edge for our `TranslatedEntity`. May be used by Relay 1. */
  translatedEntityEdge?: Maybe<TranslatedEntitiesEdge>;
};


/** The output of our update `TranslatedEntity` mutation. */
export type UpdateTranslatedEntityPayloadTranslatedEntityEdgeArgs = {
  orderBy?: InputMaybe<Array<TranslatedEntitiesOrderBy>>;
};

/** All input for the `updateTranslationById` mutation. */
export type UpdateTranslationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Translation` being updated. */
  patch: TranslationPatch;
};

/** The output of our update `Translation` mutation. */
export type UpdateTranslationPayload = {
  __typename?: 'UpdateTranslationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `Translation`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Translation` that was updated by this mutation. */
  translation?: Maybe<Translation>;
  /** An edge for our `Translation`. May be used by Relay 1. */
  translationEdge?: Maybe<TranslationsEdge>;
};


/** The output of our update `Translation` mutation. */
export type UpdateTranslationPayloadTranslationEdgeArgs = {
  orderBy?: InputMaybe<Array<TranslationsOrderBy>>;
};

/** All input for the `updateUserAnnouncementByUserIdAndAnnouncementId` mutation. */
export type UpdateUserAnnouncementByUserIdAndAnnouncementIdInput = {
  announcementId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `UserAnnouncement` being updated. */
  patch: UserAnnouncementPatch;
  userId: Scalars['UUID'];
};

/** The output of our update `UserAnnouncement` mutation. */
export type UpdateUserAnnouncementPayload = {
  __typename?: 'UpdateUserAnnouncementPayload';
  /** Reads a single `Announcement` that is related to this `UserAnnouncement`. */
  announcement?: Maybe<Announcement>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserAnnouncement`. */
  user?: Maybe<User>;
  /** The `UserAnnouncement` that was updated by this mutation. */
  userAnnouncement?: Maybe<UserAnnouncement>;
  /** An edge for our `UserAnnouncement`. May be used by Relay 1. */
  userAnnouncementEdge?: Maybe<UserAnnouncementsEdge>;
};


/** The output of our update `UserAnnouncement` mutation. */
export type UpdateUserAnnouncementPayloadUserAnnouncementEdgeArgs = {
  orderBy?: InputMaybe<Array<UserAnnouncementsOrderBy>>;
};

/** All input for the `updateUserById` mutation. */
export type UpdateUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** All input for the `updateUserCompanyGroupByUserIdAndGroupIdAndCompanyId` mutation. */
export type UpdateUserCompanyGroupByUserIdAndGroupIdAndCompanyIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `UserCompanyGroup` being updated. */
  patch: UserCompanyGroupPatch;
  userId: Scalars['UUID'];
};

/** The output of our update `UserCompanyGroup` mutation. */
export type UpdateUserCompanyGroupPayload = {
  __typename?: 'UpdateUserCompanyGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserCompanyGroup`. */
  company?: Maybe<Company>;
  /** Reads a single `Group` that is related to this `UserCompanyGroup`. */
  group?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserCompanyGroup`. */
  user?: Maybe<User>;
  /** The `UserCompanyGroup` that was updated by this mutation. */
  userCompanyGroup?: Maybe<UserCompanyGroup>;
  /** An edge for our `UserCompanyGroup`. May be used by Relay 1. */
  userCompanyGroupEdge?: Maybe<UserCompanyGroupsEdge>;
};


/** The output of our update `UserCompanyGroup` mutation. */
export type UpdateUserCompanyGroupPayloadUserCompanyGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCompanyGroupsOrderBy>>;
};

/** All input for the `updateUserCompanyRoleByUserIdAndRoleIdAndCompanyId` mutation. */
export type UpdateUserCompanyRoleByUserIdAndRoleIdAndCompanyIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `UserCompanyRole` being updated. */
  patch: UserCompanyRolePatch;
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our update `UserCompanyRole` mutation. */
export type UpdateUserCompanyRolePayload = {
  __typename?: 'UpdateUserCompanyRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserCompanyRole`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Role` that is related to this `UserCompanyRole`. */
  role?: Maybe<Role>;
  /** Reads a single `User` that is related to this `UserCompanyRole`. */
  user?: Maybe<User>;
  /** The `UserCompanyRole` that was updated by this mutation. */
  userCompanyRole?: Maybe<UserCompanyRole>;
  /** An edge for our `UserCompanyRole`. May be used by Relay 1. */
  userCompanyRoleEdge?: Maybe<UserCompanyRolesEdge>;
};


/** The output of our update `UserCompanyRole` mutation. */
export type UpdateUserCompanyRolePayloadUserCompanyRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCompanyRolesOrderBy>>;
};

/** All input for the `updateUserCompetenceById` mutation. */
export type UpdateUserCompetenceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `UserCompetence` being updated. */
  patch: UserCompetencePatch;
};

/** All input for the `updateUserCompetenceEvaluationById` mutation. */
export type UpdateUserCompetenceEvaluationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `UserCompetenceEvaluation` being updated. */
  patch: UserCompetenceEvaluationPatch;
};

/** All input for the `updateUserCompetenceEvaluationCommentById` mutation. */
export type UpdateUserCompetenceEvaluationCommentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `UserCompetenceEvaluationComment` being updated. */
  patch: UserCompetenceEvaluationCommentPatch;
};

/** The output of our update `UserCompetenceEvaluationComment` mutation. */
export type UpdateUserCompetenceEvaluationCommentPayload = {
  __typename?: 'UpdateUserCompetenceEvaluationCommentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserCompetenceEvaluationComment`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserCompetenceEvaluationComment`. */
  user?: Maybe<User>;
  /** Reads a single `UserCompetenceEvaluation` that is related to this `UserCompetenceEvaluationComment`. */
  userCompetenceEvaluation?: Maybe<UserCompetenceEvaluation>;
  /** The `UserCompetenceEvaluationComment` that was updated by this mutation. */
  userCompetenceEvaluationComment?: Maybe<UserCompetenceEvaluationComment>;
  /** An edge for our `UserCompetenceEvaluationComment`. May be used by Relay 1. */
  userCompetenceEvaluationCommentEdge?: Maybe<UserCompetenceEvaluationCommentsEdge>;
};


/** The output of our update `UserCompetenceEvaluationComment` mutation. */
export type UpdateUserCompetenceEvaluationCommentPayloadUserCompetenceEvaluationCommentEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCompetenceEvaluationCommentsOrderBy>>;
};

/** The output of our update `UserCompetenceEvaluation` mutation. */
export type UpdateUserCompetenceEvaluationPayload = {
  __typename?: 'UpdateUserCompetenceEvaluationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserCompetenceEvaluation`. */
  company?: Maybe<Company>;
  /** Reads a single `User` that is related to this `UserCompetenceEvaluation`. */
  evaluatingUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UserCompetence` that is related to this `UserCompetenceEvaluation`. */
  userCompetence?: Maybe<UserCompetence>;
  /** The `UserCompetenceEvaluation` that was updated by this mutation. */
  userCompetenceEvaluation?: Maybe<UserCompetenceEvaluation>;
  /** An edge for our `UserCompetenceEvaluation`. May be used by Relay 1. */
  userCompetenceEvaluationEdge?: Maybe<UserCompetenceEvaluationsEdge>;
};


/** The output of our update `UserCompetenceEvaluation` mutation. */
export type UpdateUserCompetenceEvaluationPayloadUserCompetenceEvaluationEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCompetenceEvaluationsOrderBy>>;
};

/** The output of our update `UserCompetence` mutation. */
export type UpdateUserCompetencePayload = {
  __typename?: 'UpdateUserCompetencePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserCompetence`. */
  company?: Maybe<Company>;
  /** Reads a single `Competence` that is related to this `UserCompetence`. */
  competence?: Maybe<Competence>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserCompetence`. */
  user?: Maybe<User>;
  /** The `UserCompetence` that was updated by this mutation. */
  userCompetence?: Maybe<UserCompetence>;
  /** An edge for our `UserCompetence`. May be used by Relay 1. */
  userCompetenceEdge?: Maybe<UserCompetencesEdge>;
};


/** The output of our update `UserCompetence` mutation. */
export type UpdateUserCompetencePayloadUserCompetenceEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCompetencesOrderBy>>;
};

/** All input for the `updateUserDepartmentByDepartmentIdAndUserId` mutation. */
export type UpdateUserDepartmentByDepartmentIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  departmentId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `UserDepartment` being updated. */
  patch: UserDepartmentPatch;
  userId: Scalars['UUID'];
};

/** All input for the `updateUserDepartmentById` mutation. */
export type UpdateUserDepartmentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `UserDepartment` being updated. */
  patch: UserDepartmentPatch;
};

/** All input for the `updateUserDepartmentGroupByUserIdAndDepartmentIdAndGroupId` mutation. */
export type UpdateUserDepartmentGroupByUserIdAndDepartmentIdAndGroupIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  departmentId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `UserDepartmentGroup` being updated. */
  patch: UserDepartmentGroupPatch;
  userId: Scalars['UUID'];
};

/** The output of our update `UserDepartmentGroup` mutation. */
export type UpdateUserDepartmentGroupPayload = {
  __typename?: 'UpdateUserDepartmentGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserDepartmentGroup`. */
  company?: Maybe<Company>;
  /** Reads a single `Department` that is related to this `UserDepartmentGroup`. */
  department?: Maybe<Department>;
  /** Reads a single `Group` that is related to this `UserDepartmentGroup`. */
  group?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserDepartmentGroup`. */
  user?: Maybe<User>;
  /** The `UserDepartmentGroup` that was updated by this mutation. */
  userDepartmentGroup?: Maybe<UserDepartmentGroup>;
  /** An edge for our `UserDepartmentGroup`. May be used by Relay 1. */
  userDepartmentGroupEdge?: Maybe<UserDepartmentGroupsEdge>;
};


/** The output of our update `UserDepartmentGroup` mutation. */
export type UpdateUserDepartmentGroupPayloadUserDepartmentGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UserDepartmentGroupsOrderBy>>;
};

/** The output of our update `UserDepartment` mutation. */
export type UpdateUserDepartmentPayload = {
  __typename?: 'UpdateUserDepartmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserDepartment`. */
  company?: Maybe<Company>;
  /** Reads a single `Department` that is related to this `UserDepartment`. */
  department?: Maybe<Department>;
  /** Reads a single `UserDepartment` that is related to this `UserDepartment`. */
  parentUserDepartment?: Maybe<UserDepartment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Rank` that is related to this `UserDepartment`. */
  rank?: Maybe<Rank>;
  /** Reads a single `User` that is related to this `UserDepartment`. */
  user?: Maybe<User>;
  /** The `UserDepartment` that was updated by this mutation. */
  userDepartment?: Maybe<UserDepartment>;
  /** An edge for our `UserDepartment`. May be used by Relay 1. */
  userDepartmentEdge?: Maybe<UserDepartmentsEdge>;
};


/** The output of our update `UserDepartment` mutation. */
export type UpdateUserDepartmentPayloadUserDepartmentEdgeArgs = {
  orderBy?: InputMaybe<Array<UserDepartmentsOrderBy>>;
};

/** All input for the `updateUserDepartmentRoleByUserIdAndDepartmentIdAndRoleId` mutation. */
export type UpdateUserDepartmentRoleByUserIdAndDepartmentIdAndRoleIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  departmentId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `UserDepartmentRole` being updated. */
  patch: UserDepartmentRolePatch;
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our update `UserDepartmentRole` mutation. */
export type UpdateUserDepartmentRolePayload = {
  __typename?: 'UpdateUserDepartmentRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserDepartmentRole`. */
  company?: Maybe<Company>;
  /** Reads a single `Department` that is related to this `UserDepartmentRole`. */
  department?: Maybe<Department>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Role` that is related to this `UserDepartmentRole`. */
  role?: Maybe<Role>;
  /** Reads a single `User` that is related to this `UserDepartmentRole`. */
  user?: Maybe<User>;
  /** The `UserDepartmentRole` that was updated by this mutation. */
  userDepartmentRole?: Maybe<UserDepartmentRole>;
  /** An edge for our `UserDepartmentRole`. May be used by Relay 1. */
  userDepartmentRoleEdge?: Maybe<UserDepartmentRolesEdge>;
};


/** The output of our update `UserDepartmentRole` mutation. */
export type UpdateUserDepartmentRolePayloadUserDepartmentRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserDepartmentRolesOrderBy>>;
};

/** All input for the `updateUserGroupByUserIdAndGroupId` mutation. */
export type UpdateUserGroupByUserIdAndGroupIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `UserGroup` being updated. */
  patch: UserGroupPatch;
  userId: Scalars['UUID'];
};

/** The output of our update `UserGroup` mutation. */
export type UpdateUserGroupPayload = {
  __typename?: 'UpdateUserGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserGroup`. */
  company?: Maybe<Company>;
  /** Reads a single `Group` that is related to this `UserGroup`. */
  group?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserGroup`. */
  user?: Maybe<User>;
  /** The `UserGroup` that was updated by this mutation. */
  userGroup?: Maybe<UserGroup>;
  /** An edge for our `UserGroup`. May be used by Relay 1. */
  userGroupEdge?: Maybe<UserGroupsEdge>;
};


/** The output of our update `UserGroup` mutation. */
export type UpdateUserGroupPayloadUserGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UserGroupsOrderBy>>;
};

/** All input for the `updateUserLocale` mutation. */
export type UpdateUserLocaleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locale: Scalars['String'];
};

/** The output of our `updateUserLocale` mutation. */
export type UpdateUserLocalePayload = {
  __typename?: 'UpdateUserLocalePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateUserOnBehalfPermissionById` mutation. */
export type UpdateUserOnBehalfPermissionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `UserOnBehalfPermission` being updated. */
  patch: UserOnBehalfPermissionPatch;
};

/** The output of our update `UserOnBehalfPermission` mutation. */
export type UpdateUserOnBehalfPermissionPayload = {
  __typename?: 'UpdateUserOnBehalfPermissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserOnBehalfPermission`. */
  company?: Maybe<Company>;
  /** Reads a single `User` that is related to this `UserOnBehalfPermission`. */
  onBehalfOfUser?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserOnBehalfPermission`. */
  user?: Maybe<User>;
  /** The `UserOnBehalfPermission` that was updated by this mutation. */
  userOnBehalfPermission?: Maybe<UserOnBehalfPermission>;
  /** An edge for our `UserOnBehalfPermission`. May be used by Relay 1. */
  userOnBehalfPermissionEdge?: Maybe<UserOnBehalfPermissionsEdge>;
};


/** The output of our update `UserOnBehalfPermission` mutation. */
export type UpdateUserOnBehalfPermissionPayloadUserOnBehalfPermissionEdgeArgs = {
  orderBy?: InputMaybe<Array<UserOnBehalfPermissionsOrderBy>>;
};

/** The output of our update `User` mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `User`. */
  company?: Maybe<Company>;
  /** Reads a single `Employee` that is related to this `User`. */
  employee?: Maybe<Employee>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was updated by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our update `User` mutation. */
export type UpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `updateUserRoleByUserIdAndRoleId` mutation. */
export type UpdateUserRoleByUserIdAndRoleIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `UserRole` being updated. */
  patch: UserRolePatch;
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our update `UserRole` mutation. */
export type UpdateUserRolePayload = {
  __typename?: 'UpdateUserRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserRole`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Role` that is related to this `UserRole`. */
  role?: Maybe<Role>;
  /** Reads a single `User` that is related to this `UserRole`. */
  user?: Maybe<User>;
  /** The `UserRole` that was updated by this mutation. */
  userRole?: Maybe<UserRole>;
  /** An edge for our `UserRole`. May be used by Relay 1. */
  userRoleEdge?: Maybe<UserRolesEdge>;
};


/** The output of our update `UserRole` mutation. */
export type UpdateUserRolePayloadUserRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
};

/** All input for the `updateUserSettingByUserIdAndKey` mutation. */
export type UpdateUserSettingByUserIdAndKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  key: UserSettingKey;
  /** An object where the defined keys will be set on the `UserSetting` being updated. */
  patch: UserSettingPatch;
  userId: Scalars['UUID'];
};

/** The output of our update `UserSetting` mutation. */
export type UpdateUserSettingPayload = {
  __typename?: 'UpdateUserSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserSetting`. */
  user?: Maybe<User>;
  /** The `UserSetting` that was updated by this mutation. */
  userSetting?: Maybe<UserSetting>;
  /** An edge for our `UserSetting`. May be used by Relay 1. */
  userSettingEdge?: Maybe<UserSettingsEdge>;
};


/** The output of our update `UserSetting` mutation. */
export type UpdateUserSettingPayloadUserSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
};

/** All input for the `updateVacationTypeById` mutation. */
export type UpdateVacationTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `VacationType` being updated. */
  patch: VacationTypePatch;
};

/** The output of our update `VacationType` mutation. */
export type UpdateVacationTypePayload = {
  __typename?: 'UpdateVacationTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `VacationType`. */
  company?: Maybe<Company>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VacationType` that was updated by this mutation. */
  vacationType?: Maybe<VacationType>;
  /** An edge for our `VacationType`. May be used by Relay 1. */
  vacationTypeEdge?: Maybe<VacationTypesEdge>;
};


/** The output of our update `VacationType` mutation. */
export type UpdateVacationTypePayloadVacationTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<VacationTypesOrderBy>>;
};

/** All input for the `updateVacationUserByApprovalId` mutation. */
export type UpdateVacationUserByApprovalIdInput = {
  approvalId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `VacationUser` being updated. */
  patch: VacationUserPatch;
};

/** All input for the `updateVacationUserByDeletionApprovalId` mutation. */
export type UpdateVacationUserByDeletionApprovalIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deletionApprovalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `VacationUser` being updated. */
  patch: VacationUserPatch;
};

/** All input for the `updateVacationUserById` mutation. */
export type UpdateVacationUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `VacationUser` being updated. */
  patch: VacationUserPatch;
};

/** The output of our update `VacationUser` mutation. */
export type UpdateVacationUserPayload = {
  __typename?: 'UpdateVacationUserPayload';
  /** Reads a single `Approval` that is related to this `VacationUser`. */
  approval?: Maybe<Approval>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `VacationUser`. */
  company?: Maybe<Company>;
  /** Reads a single `User` that is related to this `VacationUser`. */
  creatorUser?: Maybe<User>;
  /** Reads a single `Approval` that is related to this `VacationUser`. */
  deletionApproval?: Maybe<Approval>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `VacationUser`. */
  user?: Maybe<User>;
  /** Reads a single `VacationType` that is related to this `VacationUser`. */
  vacationType?: Maybe<VacationType>;
  /** The `VacationUser` that was updated by this mutation. */
  vacationUser?: Maybe<VacationUser>;
  /** An edge for our `VacationUser`. May be used by Relay 1. */
  vacationUserEdge?: Maybe<VacationUsersEdge>;
};


/** The output of our update `VacationUser` mutation. */
export type UpdateVacationUserPayloadVacationUserEdgeArgs = {
  orderBy?: InputMaybe<Array<VacationUsersOrderBy>>;
};

export type UploadFilesToBucketPayload = {
  __typename?: 'UploadFilesToBucketPayload';
  storagesUploaded: Array<Maybe<Scalars['UUID']>>;
};

export type UpsertCompanySettingInput = {
  key: CompanySettingKey;
  value?: InputMaybe<Scalars['String']>;
  valueBoolean?: InputMaybe<Scalars['Boolean']>;
  valueStorageId?: InputMaybe<Scalars['UUID']>;
};

/** All input for the `upsertPushToken` mutation. */
export type UpsertPushTokenInput = {
  argToken: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `upsertPushToken` mutation. */
export type UpsertPushTokenPayload = {
  __typename?: 'UpsertPushTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  pushToken?: Maybe<PushToken>;
  /** An edge for our `PushToken`. May be used by Relay 1. */
  pushTokenEdge?: Maybe<PushTokensEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PushToken`. */
  user?: Maybe<User>;
};


/** The output of our `upsertPushToken` mutation. */
export type UpsertPushTokenPayloadPushTokenEdgeArgs = {
  orderBy?: InputMaybe<Array<PushTokensOrderBy>>;
};

export type UriToPdfInput = {
  placeholders?: InputMaybe<Scalars['JSON']>;
  uri: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  active: Scalars['Boolean'];
  address?: Maybe<Scalars['String']>;
  alternateFirstName?: Maybe<Scalars['String']>;
  alternateLastName?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Announcement`. */
  announcements: AnnouncementsConnection;
  /** Reads and enables pagination through a set of `Approval`. */
  approvalsByAffectedUserId: ApprovalsConnection;
  /** Reads and enables pagination through a set of `Approval`. */
  approvalsByApprovingUserId: ApprovalsConnection;
  /** Reads and enables pagination through a set of `Approval`. */
  approvalsByRequestingUserId: ApprovalsConnection;
  /** Reads and enables pagination through a set of `AsyncJobItem`. */
  asyncJobItems: AsyncJobItemsConnection;
  /** Reads and enables pagination through a set of `AsyncJob`. */
  asyncJobs: AsyncJobsConnection;
  averageWeeklyHoursLastFourMonths?: Maybe<Interval>;
  bankAccountNumber?: Maybe<Scalars['String']>;
  bankRegistrationNumber?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['Date']>;
  canLogin: Scalars['Boolean'];
  canLoginApp: Scalars['Boolean'];
  canLoginSso: Scalars['Boolean'];
  canSignOnBehalfOf?: Maybe<Scalars['Boolean']>;
  /** Reads and enables pagination through a set of `ChangelogUser`. */
  changelogUsers: ChangelogUsersConnection;
  /** Reads and enables pagination through a set of `ChosenColumn`. */
  chosenColumns: ChosenColumnsConnection;
  city?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `User`. */
  company?: Maybe<Company>;
  companyAdmin: Scalars['Boolean'];
  companyId: Scalars['UUID'];
  competenceIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads and enables pagination through a set of `ContractSignPendingSigner`. */
  contractSignPendingSigners: ContractSignPendingSignersConnection;
  /** Reads and enables pagination through a set of `ContractSignPendingSigner`. */
  contractSignPendingSignersByOnBehalfOfUserId: ContractSignPendingSignersConnection;
  /** Reads and enables pagination through a set of `ContractSignPending`. */
  contractSignPendings: ContractSignPendingsConnection;
  /** Reads and enables pagination through a set of `ContractSignPending`. */
  contractSignPendingsByCreatorUserId: ContractSignPendingsConnection;
  /** Reads and enables pagination through a set of `ContractSignPending`. */
  contractSignPendingsByNextSigningUserId: ContractSignPendingsConnection;
  /** Reads and enables pagination through a set of `ContractTemplateUser`. */
  contractTemplateUsers: ContractTemplateUsersConnection;
  country?: Maybe<Scalars['String']>;
  cpr?: Maybe<Scalars['String']>;
  currentVacationTypeId?: Maybe<Scalars['UUID']>;
  customId?: Maybe<Scalars['String']>;
  deleteAt?: Maybe<Scalars['Date']>;
  deleteReminded?: Maybe<Scalars['Boolean']>;
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  directManager?: Maybe<User>;
  directManagerUserId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `DocumentFolderUser`. */
  documentFolderUsers: DocumentFolderUsersConnection;
  /** Reads and enables pagination through a set of `DocumentUserPermission`. */
  documentUserPermissions: DocumentUserPermissionsConnection;
  /** Reads and enables pagination through a set of `DocumentUserResponsible`. */
  documentUserResponsibles: DocumentUserResponsiblesConnection;
  /** Reads and enables pagination through a set of `DocumentUserResponsible`. */
  documentUserResponsiblesByAssignedBy: DocumentUserResponsiblesConnection;
  email?: Maybe<Scalars['String']>;
  emailWork?: Maybe<Scalars['String']>;
  /** Reads a single `Employee` that is related to this `User`. */
  employee?: Maybe<Employee>;
  /** Reads a single `Employee` that is related to this `User`. */
  employeeByUserId?: Maybe<Employee>;
  /** Reads and enables pagination through a set of `EmployeeCasefile`. */
  employeeCasefiles: EmployeeCasefilesConnection;
  /** Reads and enables pagination through a set of `EmployeeCasefile`. */
  employeeCasefilesByCreatorUserId: EmployeeCasefilesConnection;
  /** Reads and enables pagination through a set of `EmployeeCasefile`. */
  employeeCasefilesByNextSigningUserId: EmployeeCasefilesConnection;
  employeeId?: Maybe<Scalars['UUID']>;
  employeeNumber?: Maybe<Scalars['BigFloat']>;
  /**
   * Reads and enables pagination through a set of `Employee`.
   * @deprecated Please use employeeByUserId instead
   */
  employees: EmployeesConnection;
  employmentEnd?: Maybe<Scalars['Date']>;
  employmentEndReminded?: Maybe<Scalars['Boolean']>;
  employmentJurisdiction?: Maybe<Scalars['String']>;
  employmentStart?: Maybe<Scalars['Date']>;
  /** Reads and enables pagination through a set of `Equipment`. */
  equipments: EquipmentConnection;
  /** Reads and enables pagination through a set of `EventUser`. */
  eventUsers: EventUsersConnection;
  /** Reads and enables pagination through a set of `FilterPreset`. */
  filterPresets: FilterPresetsConnection;
  /** Reads and enables pagination through a set of `FilterView`. */
  filterViews: FilterViewsConnection;
  finishedEngagementNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  firstName?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `FormFieldEntry`. */
  formFieldEntries: FormFieldEntriesConnection;
  /** Reads and enables pagination through a set of `FormFieldEntry`. */
  formFieldEntriesByProductUserId: FormFieldEntriesConnection;
  fullName?: Maybe<Scalars['String']>;
  fullNameTsvector?: Maybe<Scalars['FullText']>;
  /** Full-text search ranking when filtered by `fullNameTsvector`. */
  fullNameTsvectorRank?: Maybe<Scalars['Float']>;
  /** Reads and enables pagination through a set of `FutureDatum`. */
  futureData: FutureDataConnection;
  /** Reads and enables pagination through a set of `FutureDatum`. */
  futureDataByCreatorUserId: FutureDataConnection;
  godmode: Scalars['Boolean'];
  groupIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads and enables pagination through a set of `Group`. */
  groups: GroupsConnection;
  hasLogo?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  initials?: Maybe<Scalars['String']>;
  initialsLogo?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isFuture?: Maybe<Scalars['Boolean']>;
  isLeader: Scalars['Boolean'];
  isResigned?: Maybe<Scalars['Boolean']>;
  isSystemUser: Scalars['Boolean'];
  jobPositionDescription?: Maybe<Scalars['String']>;
  jobPositionTitle?: Maybe<Scalars['String']>;
  jobPositionType?: Maybe<Scalars['String']>;
  jobPositionWorkingHours?: Maybe<Scalars['String']>;
  lastLogin?: Maybe<Scalars['Datetime']>;
  lastName?: Maybe<Scalars['String']>;
  latestTimeRegistrationTemplate?: Maybe<Scalars['String']>;
  leaderDepartments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  locale?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `LoggedActionNote`. */
  loggedActionNotes: LoggedActionNotesConnection;
  /** Reads and enables pagination through a set of `LoggedActionNote`. */
  loggedActionNotesBySuperUserId: LoggedActionNotesConnection;
  /** Reads and enables pagination through a set of `LoginLog`. */
  loginLogs: LoginLogsConnection;
  logo?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  mobilePrivate?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `User`. */
  nearestLeaders: UsersConnection;
  nextAnniversary?: Maybe<Scalars['Date']>;
  nextBirthday?: Maybe<Scalars['Date']>;
  nextBirthdayOrAnniversary?: Maybe<Scalars['Date']>;
  /** Reads and enables pagination through a set of `NotificationCustomRecipient`. */
  notificationCustomRecipients: NotificationCustomRecipientsConnection;
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferencesByRecipientUserId: NotificationEmployeeReferencesConnection;
  ongoingEngagementNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['BigFloat']>;
  /** Reads and enables pagination through a set of `Post`. */
  posts: PostsConnection;
  /** Reads and enables pagination through a set of `PreboardingComment`. */
  preboardingComments: PreboardingCommentsConnection;
  /** Reads and enables pagination through a set of `PreboardingEmailLog`. */
  preboardingEmailLogsByPreboardingUserId: PreboardingEmailLogsConnection;
  /** Reads and enables pagination through a set of `PreboardingEmployee`. */
  preboardingEmployees: PreboardingEmployeesConnection;
  /** Reads and enables pagination through a set of `PreboardingEmployee`. */
  preboardingEmployeesByRecipientId: PreboardingEmployeesConnection;
  /** Reads and enables pagination through a set of `PreboardingFormCache`. */
  preboardingFormCaches: PreboardingFormCachesConnection;
  /** Reads and enables pagination through a set of `PreboardingProcess`. */
  preboardingProcesses: PreboardingProcessesConnection;
  /** Reads and enables pagination through a set of `PreboardingResultSlideComment`. */
  preboardingResultSlideComments: PreboardingResultSlideCommentsConnection;
  /** Reads and enables pagination through a set of `PreboardingResultSlideComment`. */
  preboardingResultSlideCommentsByPreboardingUserId: PreboardingResultSlideCommentsConnection;
  /** Reads and enables pagination through a set of `PreboardingResult`. */
  preboardingResults: PreboardingResultsConnection;
  /** Reads and enables pagination through a set of `Preboarding`. */
  preboardingsByRecipientId: PreboardingsConnection;
  /** Reads and enables pagination through a set of `ProcessResponsible`. */
  processResponsiblesByResponsibleUserId: ProcessResponsiblesConnection;
  /** Reads and enables pagination through a set of `Process`. */
  processesByAssignedUserId: ProcessesConnection;
  /** Reads and enables pagination through a set of `Product`. */
  products: ProductsConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByAssignedUserId: ProductsConnection;
  /** Reads and enables pagination through a set of `Project`. */
  projectsByAssignedProcessUserId: ProjectsConnection;
  /** Reads and enables pagination through a set of `PulseSurveyAnswer`. */
  pulseSurveyAnswers: PulseSurveyAnswersConnection;
  /** Reads a single `PushToken` that is related to this `User`. */
  pushTokenByUserId?: Maybe<PushToken>;
  /**
   * Reads and enables pagination through a set of `PushToken`.
   * @deprecated Please use pushTokenByUserId instead
   */
  pushTokens: PushTokensConnection;
  /** Reads and enables pagination through a set of `ReferenceToken`. */
  referenceTokens: ReferenceTokensConnection;
  /** Reads and enables pagination through a set of `RoadmapItemComment`. */
  roadmapItemComments: RoadmapItemCommentsConnection;
  /** Reads and enables pagination through a set of `RoadmapItemVote`. */
  roadmapItemVotes: RoadmapItemVotesConnection;
  /** Reads and enables pagination through a set of `ScheduledMessage`. */
  scheduledMessagesByAssignedProcessUserId: ScheduledMessagesConnection;
  scope?: Maybe<Array<Maybe<Scalars['String']>>>;
  seniority?: Maybe<Scalars['Date']>;
  /** Reads a single `SuperUser` that is related to this `User`. */
  superUserByUserId?: Maybe<SuperUser>;
  /** Reads and enables pagination through a set of `SuperUserLoginNote`. */
  superUserLoginNotes: SuperUserLoginNotesConnection;
  /** Reads and enables pagination through a set of `SuperUserLoginNote`. */
  superUserLoginNotesBySuperUserId: SuperUserLoginNotesConnection;
  /**
   * Reads and enables pagination through a set of `SuperUser`.
   * @deprecated Please use superUserByUserId instead
   */
  superUsers: SuperUsersConnection;
  /** Reads and enables pagination through a set of `TaskEmployee`. */
  taskEmployees: TaskEmployeesConnection;
  /** Reads and enables pagination through a set of `TaskEmployee`. */
  taskEmployeesByAssignedProcessUserId: TaskEmployeesConnection;
  /** Reads and enables pagination through a set of `TaskResponsible`. */
  taskResponsibles: TaskResponsiblesConnection;
  /** Reads and enables pagination through a set of `TaskResponsible`. */
  taskResponsiblesByAssignedProcessUserId: TaskResponsiblesConnection;
  /** Reads and enables pagination through a set of `TaskTemplate`. */
  taskTemplatesByCalendarEventOrganizerId: TaskTemplatesConnection;
  /** Reads and enables pagination through a set of `Task`. */
  tasksByAssignedProcessUserId: TasksConnection;
  /** Reads and enables pagination through a set of `Task`. */
  tasksByCalendarEventOrganizerId: TasksConnection;
  /** Reads and enables pagination through a set of `Task`. */
  tasksByCompletedBy: TasksConnection;
  /** Reads and enables pagination through a set of `Task`. */
  tasksByCreatedBy: TasksConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationEntry`. */
  timeRegistrationEntries: TimeRegistrationEntriesConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationEntryTemplate`. */
  timeRegistrationEntryTemplates: TimeRegistrationEntryTemplatesConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationPresenceTemplate`. */
  timeRegistrationPresenceTemplates: TimeRegistrationPresenceTemplatesConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationPresence`. */
  timeRegistrationPresences: TimeRegistrationPresencesConnection;
  /** Reads and enables pagination through a set of `TimeRegistrationTemplateWeek`. */
  timeRegistrationTemplateWeeks: TimeRegistrationTemplateWeeksConnection;
  /** Reads and enables pagination through a set of `UserAnnouncement`. */
  userAnnouncements: UserAnnouncementsConnection;
  /** Reads and enables pagination through a set of `UserCompanyGroup`. */
  userCompanyGroups: UserCompanyGroupsConnection;
  /** Reads and enables pagination through a set of `UserCompanyRole`. */
  userCompanyRoles: UserCompanyRolesConnection;
  /** Reads and enables pagination through a set of `UserCompetenceEvaluationComment`. */
  userCompetenceEvaluationComments: UserCompetenceEvaluationCommentsConnection;
  /** Reads and enables pagination through a set of `UserCompetenceEvaluation`. */
  userCompetenceEvaluationsByEvaluatingUserId: UserCompetenceEvaluationsConnection;
  /** Reads and enables pagination through a set of `UserCompetence`. */
  userCompetences: UserCompetencesConnection;
  /** Reads and enables pagination through a set of `UserDepartmentGroup`. */
  userDepartmentGroups: UserDepartmentGroupsConnection;
  /** Reads and enables pagination through a set of `UserDepartmentRole`. */
  userDepartmentRoles: UserDepartmentRolesConnection;
  /** Reads and enables pagination through a set of `UserDepartment`. */
  userDepartments: UserDepartmentsConnection;
  /** Reads and enables pagination through a set of `UserGroup`. */
  userGroups: UserGroupsConnection;
  /** Reads and enables pagination through a set of `UserOnBehalfPermission`. */
  userOnBehalfPermissions: UserOnBehalfPermissionsConnection;
  /** Reads and enables pagination through a set of `UserOnBehalfPermission`. */
  userOnBehalfPermissionsByOnBehalfOfUserId: UserOnBehalfPermissionsConnection;
  /** Reads and enables pagination through a set of `UserRole`. */
  userRoles: UserRolesConnection;
  /** Reads and enables pagination through a set of `UserSetting`. */
  userSettings: UserSettingsConnection;
  /** Reads and enables pagination through a set of `UserSystemField`. */
  userSystemFields: UserSystemFieldsConnection;
  /** Reads and enables pagination through a set of `VacationUser`. */
  vacationUsers: VacationUsersConnection;
  /** Reads and enables pagination through a set of `VacationUser`. */
  vacationUsersByCreatorUserId: VacationUsersConnection;
};


export type UserAnnouncementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AnnouncementCondition>;
  filter?: InputMaybe<AnnouncementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AnnouncementsOrderBy>>;
};


export type UserApprovalsByAffectedUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ApprovalCondition>;
  filter?: InputMaybe<ApprovalFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ApprovalsOrderBy>>;
};


export type UserApprovalsByApprovingUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ApprovalCondition>;
  filter?: InputMaybe<ApprovalFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ApprovalsOrderBy>>;
};


export type UserApprovalsByRequestingUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ApprovalCondition>;
  filter?: InputMaybe<ApprovalFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ApprovalsOrderBy>>;
};


export type UserAsyncJobItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AsyncJobItemCondition>;
  filter?: InputMaybe<AsyncJobItemFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AsyncJobItemsOrderBy>>;
};


export type UserAsyncJobsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AsyncJobCondition>;
  filter?: InputMaybe<AsyncJobFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AsyncJobsOrderBy>>;
};


export type UserAverageWeeklyHoursLastFourMonthsArgs = {
  fromDate?: InputMaybe<Scalars['Datetime']>;
};


export type UserChangelogUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ChangelogUserCondition>;
  filter?: InputMaybe<ChangelogUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChangelogUsersOrderBy>>;
};


export type UserChosenColumnsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ChosenColumnCondition>;
  filter?: InputMaybe<ChosenColumnFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChosenColumnsOrderBy>>;
};


export type UserContractSignPendingSignersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingSignerCondition>;
  filter?: InputMaybe<ContractSignPendingSignerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingSignersOrderBy>>;
};


export type UserContractSignPendingSignersByOnBehalfOfUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingSignerCondition>;
  filter?: InputMaybe<ContractSignPendingSignerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingSignersOrderBy>>;
};


export type UserContractSignPendingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingCondition>;
  filter?: InputMaybe<ContractSignPendingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingsOrderBy>>;
};


export type UserContractSignPendingsByCreatorUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingCondition>;
  filter?: InputMaybe<ContractSignPendingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingsOrderBy>>;
};


export type UserContractSignPendingsByNextSigningUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractSignPendingCondition>;
  filter?: InputMaybe<ContractSignPendingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractSignPendingsOrderBy>>;
};


export type UserContractTemplateUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ContractTemplateUserCondition>;
  filter?: InputMaybe<ContractTemplateUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractTemplateUsersOrderBy>>;
};


export type UserDocumentFolderUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentFolderUserCondition>;
  filter?: InputMaybe<DocumentFolderUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentFolderUsersOrderBy>>;
};


export type UserDocumentUserPermissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentUserPermissionCondition>;
  filter?: InputMaybe<DocumentUserPermissionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentUserPermissionsOrderBy>>;
};


export type UserDocumentUserResponsiblesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentUserResponsibleCondition>;
  filter?: InputMaybe<DocumentUserResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentUserResponsiblesOrderBy>>;
};


export type UserDocumentUserResponsiblesByAssignedByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DocumentUserResponsibleCondition>;
  filter?: InputMaybe<DocumentUserResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentUserResponsiblesOrderBy>>;
};


export type UserEmployeeCasefilesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmployeeCasefileCondition>;
  filter?: InputMaybe<EmployeeCasefileFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmployeeCasefilesOrderBy>>;
};


export type UserEmployeeCasefilesByCreatorUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmployeeCasefileCondition>;
  filter?: InputMaybe<EmployeeCasefileFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmployeeCasefilesOrderBy>>;
};


export type UserEmployeeCasefilesByNextSigningUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmployeeCasefileCondition>;
  filter?: InputMaybe<EmployeeCasefileFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmployeeCasefilesOrderBy>>;
};


export type UserEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmployeeCondition>;
  filter?: InputMaybe<EmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  includeArchived?: InputMaybe<IncludeArchivedOption>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmployeesOrderBy>>;
};


export type UserEquipmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EquipmentCondition>;
  filter?: InputMaybe<EquipmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentOrderBy>>;
};


export type UserEventUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EventUserCondition>;
  filter?: InputMaybe<EventUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventUsersOrderBy>>;
};


export type UserFilterPresetsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FilterPresetCondition>;
  filter?: InputMaybe<FilterPresetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FilterPresetsOrderBy>>;
};


export type UserFilterViewsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FilterViewCondition>;
  filter?: InputMaybe<FilterViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FilterViewsOrderBy>>;
};


export type UserFormFieldEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldEntryCondition>;
  filter?: InputMaybe<FormFieldEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldEntriesOrderBy>>;
};


export type UserFormFieldEntriesByProductUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldEntryCondition>;
  filter?: InputMaybe<FormFieldEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldEntriesOrderBy>>;
};


export type UserFutureDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FutureDatumCondition>;
  filter?: InputMaybe<FutureDatumFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FutureDataOrderBy>>;
};


export type UserFutureDataByCreatorUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FutureDatumCondition>;
  filter?: InputMaybe<FutureDatumFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FutureDataOrderBy>>;
};


export type UserGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserLoggedActionNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LoggedActionNoteCondition>;
  filter?: InputMaybe<LoggedActionNoteFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LoggedActionNotesOrderBy>>;
};


export type UserLoggedActionNotesBySuperUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LoggedActionNoteCondition>;
  filter?: InputMaybe<LoggedActionNoteFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LoggedActionNotesOrderBy>>;
};


export type UserLoginLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LoginLogCondition>;
  filter?: InputMaybe<LoginLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LoginLogsOrderBy>>;
};


export type UserLogoArgs = {
  thumbnail?: InputMaybe<Scalars['Boolean']>;
};


export type UserNearestLeadersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserNotificationCustomRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationCustomRecipientCondition>;
  filter?: InputMaybe<NotificationCustomRecipientFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationCustomRecipientsOrderBy>>;
};


export type UserNotificationEmployeeReferencesByRecipientUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};


export type UserPostsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PostCondition>;
  filter?: InputMaybe<PostFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PostsOrderBy>>;
};


export type UserPreboardingCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingCommentCondition>;
  filter?: InputMaybe<PreboardingCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingCommentsOrderBy>>;
};


export type UserPreboardingEmailLogsByPreboardingUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingEmailLogCondition>;
  filter?: InputMaybe<PreboardingEmailLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingEmailLogsOrderBy>>;
};


export type UserPreboardingEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingEmployeeCondition>;
  filter?: InputMaybe<PreboardingEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingEmployeesOrderBy>>;
};


export type UserPreboardingEmployeesByRecipientIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingEmployeeCondition>;
  filter?: InputMaybe<PreboardingEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingEmployeesOrderBy>>;
};


export type UserPreboardingFormCachesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingFormCacheCondition>;
  filter?: InputMaybe<PreboardingFormCacheFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingFormCachesOrderBy>>;
};


export type UserPreboardingProcessesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingProcessCondition>;
  filter?: InputMaybe<PreboardingProcessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingProcessesOrderBy>>;
};


export type UserPreboardingResultSlideCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingResultSlideCommentCondition>;
  filter?: InputMaybe<PreboardingResultSlideCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingResultSlideCommentsOrderBy>>;
};


export type UserPreboardingResultSlideCommentsByPreboardingUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingResultSlideCommentCondition>;
  filter?: InputMaybe<PreboardingResultSlideCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingResultSlideCommentsOrderBy>>;
};


export type UserPreboardingResultsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingResultCondition>;
  filter?: InputMaybe<PreboardingResultFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingResultsOrderBy>>;
};


export type UserPreboardingsByRecipientIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PreboardingCondition>;
  filter?: InputMaybe<PreboardingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PreboardingsOrderBy>>;
};


export type UserProcessResponsiblesByResponsibleUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcessResponsibleCondition>;
  filter?: InputMaybe<ProcessResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcessResponsiblesOrderBy>>;
};


export type UserProcessesByAssignedUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProcessCondition>;
  filter?: InputMaybe<ProcessFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProcessesOrderBy>>;
};


export type UserProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProductCondition>;
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type UserProductsByAssignedUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProductCondition>;
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type UserProjectsByAssignedProcessUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};


export type UserPulseSurveyAnswersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PulseSurveyAnswerCondition>;
  filter?: InputMaybe<PulseSurveyAnswerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PulseSurveyAnswersOrderBy>>;
};


export type UserPushTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PushTokenCondition>;
  filter?: InputMaybe<PushTokenFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PushTokensOrderBy>>;
};


export type UserReferenceTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReferenceTokenCondition>;
  filter?: InputMaybe<ReferenceTokenFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReferenceTokensOrderBy>>;
};


export type UserRoadmapItemCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoadmapItemCommentCondition>;
  filter?: InputMaybe<RoadmapItemCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoadmapItemCommentsOrderBy>>;
};


export type UserRoadmapItemVotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoadmapItemVoteCondition>;
  filter?: InputMaybe<RoadmapItemVoteFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoadmapItemVotesOrderBy>>;
};


export type UserScheduledMessagesByAssignedProcessUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScheduledMessageCondition>;
  filter?: InputMaybe<ScheduledMessageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScheduledMessagesOrderBy>>;
};


export type UserSuperUserLoginNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SuperUserLoginNoteCondition>;
  filter?: InputMaybe<SuperUserLoginNoteFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuperUserLoginNotesOrderBy>>;
};


export type UserSuperUserLoginNotesBySuperUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SuperUserLoginNoteCondition>;
  filter?: InputMaybe<SuperUserLoginNoteFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuperUserLoginNotesOrderBy>>;
};


export type UserSuperUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SuperUserCondition>;
  filter?: InputMaybe<SuperUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuperUsersOrderBy>>;
};


export type UserTaskEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskEmployeeCondition>;
  filter?: InputMaybe<TaskEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskEmployeesOrderBy>>;
};


export type UserTaskEmployeesByAssignedProcessUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskEmployeeCondition>;
  filter?: InputMaybe<TaskEmployeeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskEmployeesOrderBy>>;
};


export type UserTaskResponsiblesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskResponsibleCondition>;
  filter?: InputMaybe<TaskResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskResponsiblesOrderBy>>;
};


export type UserTaskResponsiblesByAssignedProcessUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskResponsibleCondition>;
  filter?: InputMaybe<TaskResponsibleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskResponsiblesOrderBy>>;
};


export type UserTaskTemplatesByCalendarEventOrganizerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskTemplateCondition>;
  filter?: InputMaybe<TaskTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaskTemplatesOrderBy>>;
};


export type UserTasksByAssignedProcessUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};


export type UserTasksByCalendarEventOrganizerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};


export type UserTasksByCompletedByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};


export type UserTasksByCreatedByArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};


export type UserTimeRegistrationEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationEntryCondition>;
  filter?: InputMaybe<TimeRegistrationEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationEntriesOrderBy>>;
};


export type UserTimeRegistrationEntryTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationEntryTemplateCondition>;
  filter?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationEntryTemplatesOrderBy>>;
};


export type UserTimeRegistrationPresenceTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationPresenceTemplateCondition>;
  filter?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationPresenceTemplatesOrderBy>>;
};


export type UserTimeRegistrationPresencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationPresenceCondition>;
  filter?: InputMaybe<TimeRegistrationPresenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationPresencesOrderBy>>;
};


export type UserTimeRegistrationTemplateWeeksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TimeRegistrationTemplateWeekCondition>;
  filter?: InputMaybe<TimeRegistrationTemplateWeekFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimeRegistrationTemplateWeeksOrderBy>>;
};


export type UserUserAnnouncementsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserAnnouncementCondition>;
  filter?: InputMaybe<UserAnnouncementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserAnnouncementsOrderBy>>;
};


export type UserUserCompanyGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompanyGroupCondition>;
  filter?: InputMaybe<UserCompanyGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompanyGroupsOrderBy>>;
};


export type UserUserCompanyRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompanyRoleCondition>;
  filter?: InputMaybe<UserCompanyRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompanyRolesOrderBy>>;
};


export type UserUserCompetenceEvaluationCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompetenceEvaluationCommentCondition>;
  filter?: InputMaybe<UserCompetenceEvaluationCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompetenceEvaluationCommentsOrderBy>>;
};


export type UserUserCompetenceEvaluationsByEvaluatingUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompetenceEvaluationCondition>;
  filter?: InputMaybe<UserCompetenceEvaluationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompetenceEvaluationsOrderBy>>;
};


export type UserUserCompetencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompetenceCondition>;
  filter?: InputMaybe<UserCompetenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompetencesOrderBy>>;
};


export type UserUserDepartmentGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserDepartmentGroupCondition>;
  filter?: InputMaybe<UserDepartmentGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserDepartmentGroupsOrderBy>>;
};


export type UserUserDepartmentRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserDepartmentRoleCondition>;
  filter?: InputMaybe<UserDepartmentRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserDepartmentRolesOrderBy>>;
};


export type UserUserDepartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserDepartmentCondition>;
  filter?: InputMaybe<UserDepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserDepartmentsOrderBy>>;
};


export type UserUserGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserGroupCondition>;
  filter?: InputMaybe<UserGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserGroupsOrderBy>>;
};


export type UserUserOnBehalfPermissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserOnBehalfPermissionCondition>;
  filter?: InputMaybe<UserOnBehalfPermissionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserOnBehalfPermissionsOrderBy>>;
};


export type UserUserOnBehalfPermissionsByOnBehalfOfUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserOnBehalfPermissionCondition>;
  filter?: InputMaybe<UserOnBehalfPermissionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserOnBehalfPermissionsOrderBy>>;
};


export type UserUserRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserRoleCondition>;
  filter?: InputMaybe<UserRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
};


export type UserUserSettingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserSettingCondition>;
  filter?: InputMaybe<UserSettingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
};


export type UserUserSystemFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserSystemFieldCondition>;
  filter?: InputMaybe<UserSystemFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSystemFieldsOrderBy>>;
};


export type UserVacationUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VacationUserCondition>;
  filter?: InputMaybe<VacationUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VacationUsersOrderBy>>;
};


export type UserVacationUsersByCreatorUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VacationUserCondition>;
  filter?: InputMaybe<VacationUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VacationUsersOrderBy>>;
};

export type UserAnnouncement = {
  __typename?: 'UserAnnouncement';
  /** Reads a single `Announcement` that is related to this `UserAnnouncement`. */
  announcement?: Maybe<Announcement>;
  announcementId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `UserAnnouncement`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The `announcement` to be created by this mutation. */
export type UserAnnouncementAnnouncementIdForeignConnectionAnnouncementCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addPlayIcon?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<AnnouncementCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  popup?: InputMaybe<Scalars['Boolean']>;
  publishAt?: InputMaybe<Scalars['Datetime']>;
  publishAtReminded?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  systemAnnouncement?: InputMaybe<Scalars['Boolean']>;
  teaser?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<AnnouncementUserIdForeignInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementAnnouncementIdForeignInverseInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `userAnnouncement` to be created by this mutation. */
export type UserAnnouncementAnnouncementIdForeignConnectionUserAnnouncementCreateInput = {
  announcement?: InputMaybe<UserAnnouncementAnnouncementIdForeignInput>;
  user?: InputMaybe<UserAnnouncementUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `announcement` in the `UserAnnouncementInput` mutation. */
export type UserAnnouncementAnnouncementIdForeignInput = {
  /** The primary key(s) for `announcement` for the far side of the relationship. */
  connectById?: InputMaybe<AnnouncementAnnouncementPkeyConnect>;
  /** A `AnnouncementInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserAnnouncementAnnouncementIdForeignConnectionAnnouncementCreateInput>;
  /** The primary key(s) and patch data for `announcement` for the far side of the relationship. */
  updateById?: InputMaybe<AnnouncementOnUserAnnouncementForUserAnnouncementAnnouncementIdForeignUsingAnnouncementPkeyUpdate>;
};

/** Input for the nested mutation of `userAnnouncement` in the `AnnouncementInput` mutation. */
export type UserAnnouncementAnnouncementIdForeignInverseInput = {
  /** The primary key(s) for `userAnnouncement` for the far side of the relationship. */
  connectByUserIdAndAnnouncementId?: InputMaybe<Array<UserAnnouncementUserAnnouncementPkeyConnect>>;
  /** A `UserAnnouncementInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserAnnouncementAnnouncementIdForeignConnectionUserAnnouncementCreateInput>>;
  /** The primary key(s) for `userAnnouncement` for the far side of the relationship. */
  deleteByUserIdAndAnnouncementId?: InputMaybe<Array<UserAnnouncementUserAnnouncementPkeyDelete>>;
  /** Flag indicating whether all other `userAnnouncement` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userAnnouncement` for the far side of the relationship. */
  updateByUserIdAndAnnouncementId?: InputMaybe<Array<UserAnnouncementOnUserAnnouncementForUserAnnouncementAnnouncementIdForeignUsingUserAnnouncementPkeyUpdate>>;
};

/**
 * A condition to be used against `UserAnnouncement` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserAnnouncementCondition = {
  /** Checks for equality with the object’s `announcementId` field. */
  announcementId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `UserAnnouncement` object types. All fields are combined with a logical ‘and.’ */
export type UserAnnouncementFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserAnnouncementFilter>>;
  /** Filter by the object’s `announcement` relation. */
  announcement?: InputMaybe<AnnouncementFilter>;
  /** Filter by the object’s `announcementId` field. */
  announcementId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserAnnouncementFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserAnnouncementFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `UserAnnouncement` */
export type UserAnnouncementInput = {
  announcement?: InputMaybe<UserAnnouncementAnnouncementIdForeignInput>;
  announcementId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserAnnouncementUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `userAnnouncement` to look up the row to update. */
export type UserAnnouncementOnUserAnnouncementForUserAnnouncementAnnouncementIdForeignUsingUserAnnouncementPkeyUpdate = {
  announcementId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userAnnouncement` being updated. */
  patch: UpdateUserAnnouncementOnUserAnnouncementForUserAnnouncementAnnouncementIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `userAnnouncement` to look up the row to update. */
export type UserAnnouncementOnUserAnnouncementForUserAnnouncementUserIdForeignUsingUserAnnouncementPkeyUpdate = {
  announcementId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userAnnouncement` being updated. */
  patch: UpdateUserAnnouncementOnUserAnnouncementForUserAnnouncementUserIdForeignPatch;
  userId: Scalars['UUID'];
};

/** Represents an update to a `UserAnnouncement`. Fields that are set will be updated. */
export type UserAnnouncementPatch = {
  announcement?: InputMaybe<UserAnnouncementAnnouncementIdForeignInput>;
  announcementId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserAnnouncementUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `userAnnouncement` to look up the row to connect. */
export type UserAnnouncementUserAnnouncementPkeyConnect = {
  announcementId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `userAnnouncement` to look up the row to delete. */
export type UserAnnouncementUserAnnouncementPkeyDelete = {
  announcementId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The `userAnnouncement` to be created by this mutation. */
export type UserAnnouncementUserIdForeignConnectionUserAnnouncementCreateInput = {
  announcement?: InputMaybe<UserAnnouncementAnnouncementIdForeignInput>;
  announcementId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserAnnouncementUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `UserAnnouncementInput` mutation. */
export type UserAnnouncementUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserAnnouncementForUserAnnouncementUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `userAnnouncement` in the `UserInput` mutation. */
export type UserAnnouncementUserIdForeignInverseInput = {
  /** The primary key(s) for `userAnnouncement` for the far side of the relationship. */
  connectByUserIdAndAnnouncementId?: InputMaybe<Array<UserAnnouncementUserAnnouncementPkeyConnect>>;
  /** A `UserAnnouncementInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserAnnouncementUserIdForeignConnectionUserAnnouncementCreateInput>>;
  /** The primary key(s) for `userAnnouncement` for the far side of the relationship. */
  deleteByUserIdAndAnnouncementId?: InputMaybe<Array<UserAnnouncementUserAnnouncementPkeyDelete>>;
  /** Flag indicating whether all other `userAnnouncement` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userAnnouncement` for the far side of the relationship. */
  updateByUserIdAndAnnouncementId?: InputMaybe<Array<UserAnnouncementOnUserAnnouncementForUserAnnouncementUserIdForeignUsingUserAnnouncementPkeyUpdate>>;
};

/** A connection to a list of `UserAnnouncement` values. */
export type UserAnnouncementsConnection = {
  __typename?: 'UserAnnouncementsConnection';
  /** A list of edges which contains the `UserAnnouncement` and cursor to aid in pagination. */
  edges: Array<UserAnnouncementsEdge>;
  /** A list of `UserAnnouncement` objects. */
  nodes: Array<Maybe<UserAnnouncement>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserAnnouncement` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserAnnouncement` edge in the connection. */
export type UserAnnouncementsEdge = {
  __typename?: 'UserAnnouncementsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserAnnouncement` at the end of the edge. */
  node?: Maybe<UserAnnouncement>;
};

/** Methods to use when ordering `UserAnnouncement`. */
export type UserAnnouncementsOrderBy =
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__ACTIVE_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__ACTIVE_DESC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__ADD_PLAY_ICON_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__ADD_PLAY_ICON_DESC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__COMPANY_ID_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__COMPANY_ID_DESC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__CONTENT_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__CONTENT_DESC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__CREATED_AT_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__CREATED_AT_DESC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__DEPARTMENT_IDS_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__DEPARTMENT_IDS_DESC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__EXPIRE_AT_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__EXPIRE_AT_DESC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__ID_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__ID_DESC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__LOCALES_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__LOCALES_DESC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__POPUP_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__POPUP_DESC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__PUBLISHED_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__PUBLISHED_DESC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__PUBLISH_AT_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__PUBLISH_AT_DESC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__PUBLISH_AT_REMINDED_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__PUBLISH_AT_REMINDED_DESC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__SYSTEM_ANNOUNCEMENT_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__SYSTEM_ANNOUNCEMENT_DESC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__TEASER_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__TEASER_DESC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__TITLE_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__TITLE_DESC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__UPDATED_AT_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__UPDATED_AT_DESC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__URL_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__URL_DESC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__USER_ID_ASC'
  | 'ANNOUNCEMENT_BY_ANNOUNCEMENT_ID__USER_ID_DESC'
  | 'ANNOUNCEMENT_ID_ASC'
  | 'ANNOUNCEMENT_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type UserCompanyGroup = {
  __typename?: 'UserCompanyGroup';
  /** Reads a single `Company` that is related to this `UserCompanyGroup`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  departmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Group` that is related to this `UserCompanyGroup`. */
  group?: Maybe<Group>;
  groupId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `UserCompanyGroup`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The `userCompanyGroup` to be created by this mutation. */
export type UserCompanyGroupCompanyIdForeignConnectionUserCompanyGroupCreateInput = {
  company?: InputMaybe<UserCompanyGroupCompanyIdForeignInput>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  group?: InputMaybe<UserCompanyGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserCompanyGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `UserCompanyGroupInput` mutation. */
export type UserCompanyGroupCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnUserCompanyGroupForUserCompanyGroupCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `userCompanyGroup` in the `CompanyInput` mutation. */
export type UserCompanyGroupCompanyIdForeignInverseInput = {
  /** The primary key(s) for `userCompanyGroup` for the far side of the relationship. */
  connectByUserIdAndGroupIdAndCompanyId?: InputMaybe<Array<UserCompanyGroupUserCompanyGroupPkeyConnect>>;
  /** A `UserCompanyGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserCompanyGroupCompanyIdForeignConnectionUserCompanyGroupCreateInput>>;
  /** The primary key(s) for `userCompanyGroup` for the far side of the relationship. */
  deleteByUserIdAndGroupIdAndCompanyId?: InputMaybe<Array<UserCompanyGroupUserCompanyGroupPkeyDelete>>;
  /** Flag indicating whether all other `userCompanyGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userCompanyGroup` for the far side of the relationship. */
  updateByUserIdAndGroupIdAndCompanyId?: InputMaybe<Array<UserCompanyGroupOnUserCompanyGroupForUserCompanyGroupCompanyIdForeignUsingUserCompanyGroupPkeyUpdate>>;
};

/**
 * A condition to be used against `UserCompanyGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserCompanyGroupCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `UserCompanyGroup` object types. All fields are combined with a logical ‘and.’ */
export type UserCompanyGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserCompanyGroupFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `group` relation. */
  group?: InputMaybe<GroupFilter>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserCompanyGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserCompanyGroupFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The `group` to be created by this mutation. */
export type UserCompanyGroupGroupIdForeignConnectionGroupCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppTableGroupIdFkInverseInput>;
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  autoInherit?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  copyFromGroupId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientGroupIdForeignInverseInput>;
  scope?: InputMaybe<RoleScope>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupGroupIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupGroupIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupGroupIdForeignInverseInput>;
};

/** The `userCompanyGroup` to be created by this mutation. */
export type UserCompanyGroupGroupIdForeignConnectionUserCompanyGroupCreateInput = {
  company?: InputMaybe<UserCompanyGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  group?: InputMaybe<UserCompanyGroupGroupIdForeignInput>;
  user?: InputMaybe<UserCompanyGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `group` in the `UserCompanyGroupInput` mutation. */
export type UserCompanyGroupGroupIdForeignInput = {
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectById?: InputMaybe<GroupGroupPkeyConnect>;
  /** A `GroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserCompanyGroupGroupIdForeignConnectionGroupCreateInput>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateById?: InputMaybe<GroupOnUserCompanyGroupForUserCompanyGroupGroupIdForeignUsingGroupPkeyUpdate>;
};

/** Input for the nested mutation of `userCompanyGroup` in the `GroupInput` mutation. */
export type UserCompanyGroupGroupIdForeignInverseInput = {
  /** The primary key(s) for `userCompanyGroup` for the far side of the relationship. */
  connectByUserIdAndGroupIdAndCompanyId?: InputMaybe<Array<UserCompanyGroupUserCompanyGroupPkeyConnect>>;
  /** A `UserCompanyGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserCompanyGroupGroupIdForeignConnectionUserCompanyGroupCreateInput>>;
  /** The primary key(s) for `userCompanyGroup` for the far side of the relationship. */
  deleteByUserIdAndGroupIdAndCompanyId?: InputMaybe<Array<UserCompanyGroupUserCompanyGroupPkeyDelete>>;
  /** Flag indicating whether all other `userCompanyGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userCompanyGroup` for the far side of the relationship. */
  updateByUserIdAndGroupIdAndCompanyId?: InputMaybe<Array<UserCompanyGroupOnUserCompanyGroupForUserCompanyGroupGroupIdForeignUsingUserCompanyGroupPkeyUpdate>>;
};

/** An input for mutations affecting `UserCompanyGroup` */
export type UserCompanyGroupInput = {
  company?: InputMaybe<UserCompanyGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  group?: InputMaybe<UserCompanyGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserCompanyGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `userCompanyGroup` to look up the row to update. */
export type UserCompanyGroupOnUserCompanyGroupForUserCompanyGroupCompanyIdForeignUsingUserCompanyGroupPkeyUpdate = {
  companyId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompanyGroup` being updated. */
  patch: UpdateUserCompanyGroupOnUserCompanyGroupForUserCompanyGroupCompanyIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `userCompanyGroup` to look up the row to update. */
export type UserCompanyGroupOnUserCompanyGroupForUserCompanyGroupGroupIdForeignUsingUserCompanyGroupPkeyUpdate = {
  companyId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompanyGroup` being updated. */
  patch: UpdateUserCompanyGroupOnUserCompanyGroupForUserCompanyGroupGroupIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `userCompanyGroup` to look up the row to update. */
export type UserCompanyGroupOnUserCompanyGroupForUserCompanyGroupUserIdForeignUsingUserCompanyGroupPkeyUpdate = {
  companyId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompanyGroup` being updated. */
  patch: UpdateUserCompanyGroupOnUserCompanyGroupForUserCompanyGroupUserIdForeignPatch;
  userId: Scalars['UUID'];
};

/** Represents an update to a `UserCompanyGroup`. Fields that are set will be updated. */
export type UserCompanyGroupPatch = {
  company?: InputMaybe<UserCompanyGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  group?: InputMaybe<UserCompanyGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserCompanyGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `userCompanyGroup` to look up the row to connect. */
export type UserCompanyGroupUserCompanyGroupPkeyConnect = {
  companyId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `userCompanyGroup` to look up the row to delete. */
export type UserCompanyGroupUserCompanyGroupPkeyDelete = {
  companyId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The `userCompanyGroup` to be created by this mutation. */
export type UserCompanyGroupUserIdForeignConnectionUserCompanyGroupCreateInput = {
  company?: InputMaybe<UserCompanyGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  group?: InputMaybe<UserCompanyGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserCompanyGroupUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `UserCompanyGroupInput` mutation. */
export type UserCompanyGroupUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserCompanyGroupForUserCompanyGroupUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `userCompanyGroup` in the `UserInput` mutation. */
export type UserCompanyGroupUserIdForeignInverseInput = {
  /** The primary key(s) for `userCompanyGroup` for the far side of the relationship. */
  connectByUserIdAndGroupIdAndCompanyId?: InputMaybe<Array<UserCompanyGroupUserCompanyGroupPkeyConnect>>;
  /** A `UserCompanyGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserCompanyGroupUserIdForeignConnectionUserCompanyGroupCreateInput>>;
  /** The primary key(s) for `userCompanyGroup` for the far side of the relationship. */
  deleteByUserIdAndGroupIdAndCompanyId?: InputMaybe<Array<UserCompanyGroupUserCompanyGroupPkeyDelete>>;
  /** Flag indicating whether all other `userCompanyGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userCompanyGroup` for the far side of the relationship. */
  updateByUserIdAndGroupIdAndCompanyId?: InputMaybe<Array<UserCompanyGroupOnUserCompanyGroupForUserCompanyGroupUserIdForeignUsingUserCompanyGroupPkeyUpdate>>;
};

/** A connection to a list of `UserCompanyGroup` values. */
export type UserCompanyGroupsConnection = {
  __typename?: 'UserCompanyGroupsConnection';
  /** A list of edges which contains the `UserCompanyGroup` and cursor to aid in pagination. */
  edges: Array<UserCompanyGroupsEdge>;
  /** A list of `UserCompanyGroup` objects. */
  nodes: Array<Maybe<UserCompanyGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserCompanyGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserCompanyGroup` edge in the connection. */
export type UserCompanyGroupsEdge = {
  __typename?: 'UserCompanyGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserCompanyGroup` at the end of the edge. */
  node?: Maybe<UserCompanyGroup>;
};

/** Methods to use when ordering `UserCompanyGroup`. */
export type UserCompanyGroupsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'GROUP_BY_GROUP_ID__ACTIVE_ASC'
  | 'GROUP_BY_GROUP_ID__ACTIVE_DESC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_ASC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_DESC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_NEW_PERMISSIONS_ASC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_NEW_PERMISSIONS_DESC'
  | 'GROUP_BY_GROUP_ID__AUTO_INHERIT_ASC'
  | 'GROUP_BY_GROUP_ID__AUTO_INHERIT_DESC'
  | 'GROUP_BY_GROUP_ID__COMPANY_ID_ASC'
  | 'GROUP_BY_GROUP_ID__COMPANY_ID_DESC'
  | 'GROUP_BY_GROUP_ID__DESCRIPTION_ASC'
  | 'GROUP_BY_GROUP_ID__DESCRIPTION_DESC'
  | 'GROUP_BY_GROUP_ID__ID_ASC'
  | 'GROUP_BY_GROUP_ID__ID_DESC'
  | 'GROUP_BY_GROUP_ID__LOCALIZED_NAME_ASC'
  | 'GROUP_BY_GROUP_ID__LOCALIZED_NAME_DESC'
  | 'GROUP_BY_GROUP_ID__NAME_ASC'
  | 'GROUP_BY_GROUP_ID__NAME_DESC'
  | 'GROUP_BY_GROUP_ID__SCOPE_ASC'
  | 'GROUP_BY_GROUP_ID__SCOPE_DESC'
  | 'GROUP_ID_ASC'
  | 'GROUP_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** Input for the nested mutation of `company` in the `UserInput` mutation. */
export type UserCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnUserForUserCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `user` in the `CompanyInput` mutation. */
export type UserCompanyIdForeignInverseInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserUserPkeyConnect>>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserOnUserForUserCompanyIdForeignUsingUserPkeyUpdate>>;
};

export type UserCompanyRole = {
  __typename?: 'UserCompanyRole';
  /** Reads a single `Company` that is related to this `UserCompanyRole`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  excludeRole: Scalars['Boolean'];
  itemIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Role` that is related to this `UserCompanyRole`. */
  role?: Maybe<Role>;
  roleId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `UserCompanyRole`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The `userCompanyRole` to be created by this mutation. */
export type UserCompanyRoleCompanyIdForeignConnectionUserCompanyRoleCreateInput = {
  company?: InputMaybe<UserCompanyRoleCompanyIdForeignInput>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<UserCompanyRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserCompanyRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `UserCompanyRoleInput` mutation. */
export type UserCompanyRoleCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnUserCompanyRoleForUserCompanyRoleCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `userCompanyRole` in the `CompanyInput` mutation. */
export type UserCompanyRoleCompanyIdForeignInverseInput = {
  /** The primary key(s) for `userCompanyRole` for the far side of the relationship. */
  connectByUserIdAndRoleIdAndCompanyId?: InputMaybe<Array<UserCompanyRoleUserCompanyRolePkeyConnect>>;
  /** A `UserCompanyRoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserCompanyRoleCompanyIdForeignConnectionUserCompanyRoleCreateInput>>;
  /** The primary key(s) for `userCompanyRole` for the far side of the relationship. */
  deleteByUserIdAndRoleIdAndCompanyId?: InputMaybe<Array<UserCompanyRoleUserCompanyRolePkeyDelete>>;
  /** Flag indicating whether all other `userCompanyRole` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userCompanyRole` for the far side of the relationship. */
  updateByUserIdAndRoleIdAndCompanyId?: InputMaybe<Array<UserCompanyRoleOnUserCompanyRoleForUserCompanyRoleCompanyIdForeignUsingUserCompanyRolePkeyUpdate>>;
};

/**
 * A condition to be used against `UserCompanyRole` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserCompanyRoleCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `excludeRole` field. */
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `itemIds` field. */
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `roleId` field. */
  roleId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `UserCompanyRole` object types. All fields are combined with a logical ‘and.’ */
export type UserCompanyRoleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserCompanyRoleFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `excludeRole` field. */
  excludeRole?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `itemIds` field. */
  itemIds?: InputMaybe<UuidListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserCompanyRoleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserCompanyRoleFilter>>;
  /** Filter by the object’s `role` relation. */
  role?: InputMaybe<RoleFilter>;
  /** Filter by the object’s `roleId` field. */
  roleId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `UserCompanyRole` */
export type UserCompanyRoleInput = {
  company?: InputMaybe<UserCompanyRoleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<UserCompanyRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserCompanyRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `userCompanyRole` to look up the row to update. */
export type UserCompanyRoleOnUserCompanyRoleForUserCompanyRoleCompanyIdForeignUsingUserCompanyRolePkeyUpdate = {
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompanyRole` being updated. */
  patch: UpdateUserCompanyRoleOnUserCompanyRoleForUserCompanyRoleCompanyIdForeignPatch;
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `userCompanyRole` to look up the row to update. */
export type UserCompanyRoleOnUserCompanyRoleForUserCompanyRoleRoleIdForeignUsingUserCompanyRolePkeyUpdate = {
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompanyRole` being updated. */
  patch: UpdateUserCompanyRoleOnUserCompanyRoleForUserCompanyRoleRoleIdForeignPatch;
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `userCompanyRole` to look up the row to update. */
export type UserCompanyRoleOnUserCompanyRoleForUserCompanyRoleUserIdForeignUsingUserCompanyRolePkeyUpdate = {
  companyId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompanyRole` being updated. */
  patch: UpdateUserCompanyRoleOnUserCompanyRoleForUserCompanyRoleUserIdForeignPatch;
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** Represents an update to a `UserCompanyRole`. Fields that are set will be updated. */
export type UserCompanyRolePatch = {
  company?: InputMaybe<UserCompanyRoleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<UserCompanyRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserCompanyRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `role` to be created by this mutation. */
export type UserCompanyRoleRoleIdForeignConnectionRoleCreateInput = {
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleRoleIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  info: Scalars['String'];
  name: Scalars['String'];
  relationRoles?: InputMaybe<RelationRoleRoleIdForeignInverseInput>;
  roleDependenciesToDependentOnUsingId?: InputMaybe<RoleDependencyDependentOnForeignInverseInput>;
  roleDependenciesToRoleIdUsingId?: InputMaybe<RoleDependencyRoleIdForeignInverseInput>;
  scopes?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleRoleIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleRoleIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleRoleIdForeignInverseInput>;
  usesItemIds?: InputMaybe<Scalars['Boolean']>;
};

/** The `userCompanyRole` to be created by this mutation. */
export type UserCompanyRoleRoleIdForeignConnectionUserCompanyRoleCreateInput = {
  company?: InputMaybe<UserCompanyRoleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<UserCompanyRoleRoleIdForeignInput>;
  user?: InputMaybe<UserCompanyRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `role` in the `UserCompanyRoleInput` mutation. */
export type UserCompanyRoleRoleIdForeignInput = {
  /** The primary key(s) for `role` for the far side of the relationship. */
  connectById?: InputMaybe<RoleRolePkeyConnect>;
  /** A `RoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserCompanyRoleRoleIdForeignConnectionRoleCreateInput>;
  /** The primary key(s) for `role` for the far side of the relationship. */
  deleteById?: InputMaybe<RoleRolePkeyDelete>;
  /** The primary key(s) and patch data for `role` for the far side of the relationship. */
  updateById?: InputMaybe<RoleOnUserCompanyRoleForUserCompanyRoleRoleIdForeignUsingRolePkeyUpdate>;
};

/** Input for the nested mutation of `userCompanyRole` in the `RoleInput` mutation. */
export type UserCompanyRoleRoleIdForeignInverseInput = {
  /** The primary key(s) for `userCompanyRole` for the far side of the relationship. */
  connectByUserIdAndRoleIdAndCompanyId?: InputMaybe<Array<UserCompanyRoleUserCompanyRolePkeyConnect>>;
  /** A `UserCompanyRoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserCompanyRoleRoleIdForeignConnectionUserCompanyRoleCreateInput>>;
  /** The primary key(s) for `userCompanyRole` for the far side of the relationship. */
  deleteByUserIdAndRoleIdAndCompanyId?: InputMaybe<Array<UserCompanyRoleUserCompanyRolePkeyDelete>>;
  /** Flag indicating whether all other `userCompanyRole` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userCompanyRole` for the far side of the relationship. */
  updateByUserIdAndRoleIdAndCompanyId?: InputMaybe<Array<UserCompanyRoleOnUserCompanyRoleForUserCompanyRoleRoleIdForeignUsingUserCompanyRolePkeyUpdate>>;
};

/** The fields on `userCompanyRole` to look up the row to connect. */
export type UserCompanyRoleUserCompanyRolePkeyConnect = {
  companyId: Scalars['UUID'];
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `userCompanyRole` to look up the row to delete. */
export type UserCompanyRoleUserCompanyRolePkeyDelete = {
  companyId: Scalars['UUID'];
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The `userCompanyRole` to be created by this mutation. */
export type UserCompanyRoleUserIdForeignConnectionUserCompanyRoleCreateInput = {
  company?: InputMaybe<UserCompanyRoleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<UserCompanyRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserCompanyRoleUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `UserCompanyRoleInput` mutation. */
export type UserCompanyRoleUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserCompanyRoleForUserCompanyRoleUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `userCompanyRole` in the `UserInput` mutation. */
export type UserCompanyRoleUserIdForeignInverseInput = {
  /** The primary key(s) for `userCompanyRole` for the far side of the relationship. */
  connectByUserIdAndRoleIdAndCompanyId?: InputMaybe<Array<UserCompanyRoleUserCompanyRolePkeyConnect>>;
  /** A `UserCompanyRoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserCompanyRoleUserIdForeignConnectionUserCompanyRoleCreateInput>>;
  /** The primary key(s) for `userCompanyRole` for the far side of the relationship. */
  deleteByUserIdAndRoleIdAndCompanyId?: InputMaybe<Array<UserCompanyRoleUserCompanyRolePkeyDelete>>;
  /** Flag indicating whether all other `userCompanyRole` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userCompanyRole` for the far side of the relationship. */
  updateByUserIdAndRoleIdAndCompanyId?: InputMaybe<Array<UserCompanyRoleOnUserCompanyRoleForUserCompanyRoleUserIdForeignUsingUserCompanyRolePkeyUpdate>>;
};

/** A connection to a list of `UserCompanyRole` values. */
export type UserCompanyRolesConnection = {
  __typename?: 'UserCompanyRolesConnection';
  /** A list of edges which contains the `UserCompanyRole` and cursor to aid in pagination. */
  edges: Array<UserCompanyRolesEdge>;
  /** A list of `UserCompanyRole` objects. */
  nodes: Array<Maybe<UserCompanyRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserCompanyRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserCompanyRole` edge in the connection. */
export type UserCompanyRolesEdge = {
  __typename?: 'UserCompanyRolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserCompanyRole` at the end of the edge. */
  node?: Maybe<UserCompanyRole>;
};

/** Methods to use when ordering `UserCompanyRole`. */
export type UserCompanyRolesOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'EXCLUDE_ROLE_ASC'
  | 'EXCLUDE_ROLE_DESC'
  | 'ITEM_IDS_ASC'
  | 'ITEM_IDS_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROLE_BY_ROLE_ID__COMPANY_ID_ASC'
  | 'ROLE_BY_ROLE_ID__COMPANY_ID_DESC'
  | 'ROLE_BY_ROLE_ID__DESCRIPTION_ASC'
  | 'ROLE_BY_ROLE_ID__DESCRIPTION_DESC'
  | 'ROLE_BY_ROLE_ID__ID_ASC'
  | 'ROLE_BY_ROLE_ID__ID_DESC'
  | 'ROLE_BY_ROLE_ID__INFO_ASC'
  | 'ROLE_BY_ROLE_ID__INFO_DESC'
  | 'ROLE_BY_ROLE_ID__NAME_ASC'
  | 'ROLE_BY_ROLE_ID__NAME_DESC'
  | 'ROLE_BY_ROLE_ID__SCOPES_ASC'
  | 'ROLE_BY_ROLE_ID__SCOPES_DESC'
  | 'ROLE_BY_ROLE_ID__USES_ITEM_IDS_ASC'
  | 'ROLE_BY_ROLE_ID__USES_ITEM_IDS_DESC'
  | 'ROLE_ID_ASC'
  | 'ROLE_ID_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type UserCompetence = {
  __typename?: 'UserCompetence';
  active: Scalars['Boolean'];
  addedDate: Scalars['Datetime'];
  /** Reads a single `Company` that is related to this `UserCompetence`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `Competence` that is related to this `UserCompetence`. */
  competence?: Maybe<Competence>;
  competenceId: Scalars['UUID'];
  courseRequested: Scalars['Boolean'];
  departmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  expireAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  managerEvaluation?: Maybe<UserCompetenceEvaluation>;
  managerEvaluationDate?: Maybe<Scalars['Datetime']>;
  managerNextUpdate?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferences: NotificationEmployeeReferencesConnection;
  reminded: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `Storage`. */
  storages: StoragesConnection;
  /** Reads a single `User` that is related to this `UserCompetence`. */
  user?: Maybe<User>;
  /** Reads and enables pagination through a set of `UserCompetenceEvaluation`. */
  userCompetenceEvaluations: UserCompetenceEvaluationsConnection;
  userId: Scalars['UUID'];
};


export type UserCompetenceNotificationEmployeeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};


export type UserCompetenceStoragesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<StorageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserCompetenceUserCompetenceEvaluationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompetenceEvaluationCondition>;
  filter?: InputMaybe<UserCompetenceEvaluationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompetenceEvaluationsOrderBy>>;
};

/** The `userCompetence` to be created by this mutation. */
export type UserCompetenceCompanyIdForeignConnectionUserCompetenceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addedDate?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<UserCompetenceCompanyIdForeignInput>;
  competence?: InputMaybe<UserCompetenceCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  courseRequested?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInverseInput>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceUserIdForeignInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInverseInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `UserCompetenceInput` mutation. */
export type UserCompetenceCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnUserCompetenceForUserCompetenceCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `userCompetence` in the `CompanyInput` mutation. */
export type UserCompetenceCompanyIdForeignInverseInput = {
  /** The primary key(s) for `userCompetence` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserCompetenceUserCompetencePkeyConnect>>;
  /** A `UserCompetenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserCompetenceCompanyIdForeignConnectionUserCompetenceCreateInput>>;
  /** The primary key(s) and patch data for `userCompetence` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserCompetenceOnUserCompetenceForUserCompetenceCompanyIdForeignUsingUserCompetencePkeyUpdate>>;
};

/** The `competence` to be created by this mutation. */
export type UserCompetenceCompetenceIdForeignConnectionCompetenceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInverseInput>;
  competenceGroup?: InputMaybe<CompetenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceRequests?: InputMaybe<CompetenceRequestCompetenceIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CompetenceRatingFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInverseInput>;
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
  outdateAt?: InputMaybe<Scalars['Datetime']>;
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  outdateInterval?: InputMaybe<IntervalInput>;
  ratingFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval: IntervalInput;
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useRating?: InputMaybe<Scalars['Boolean']>;
  userCompetences?: InputMaybe<UserCompetenceCompetenceIdForeignInverseInput>;
};

/** The `userCompetence` to be created by this mutation. */
export type UserCompetenceCompetenceIdForeignConnectionUserCompetenceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addedDate?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<UserCompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<UserCompetenceCompetenceIdForeignInput>;
  courseRequested?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInverseInput>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceUserIdForeignInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInverseInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `competence` in the `UserCompetenceInput` mutation. */
export type UserCompetenceCompetenceIdForeignInput = {
  /** The primary key(s) for `competence` for the far side of the relationship. */
  connectById?: InputMaybe<CompetenceCompetencePkeyConnect>;
  /** A `CompetenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserCompetenceCompetenceIdForeignConnectionCompetenceCreateInput>;
  /** The primary key(s) and patch data for `competence` for the far side of the relationship. */
  updateById?: InputMaybe<CompetenceOnUserCompetenceForUserCompetenceCompetenceIdForeignUsingCompetencePkeyUpdate>;
};

/** Input for the nested mutation of `userCompetence` in the `CompetenceInput` mutation. */
export type UserCompetenceCompetenceIdForeignInverseInput = {
  /** The primary key(s) for `userCompetence` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserCompetenceUserCompetencePkeyConnect>>;
  /** A `UserCompetenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserCompetenceCompetenceIdForeignConnectionUserCompetenceCreateInput>>;
  /** The primary key(s) and patch data for `userCompetence` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserCompetenceOnUserCompetenceForUserCompetenceCompetenceIdForeignUsingUserCompetencePkeyUpdate>>;
};

/**
 * A condition to be used against `UserCompetence` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserCompetenceCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `addedDate` field. */
  addedDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `competenceId` field. */
  competenceId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `courseRequested` field. */
  courseRequested?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `expireAt` field. */
  expireAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `reminded` field. */
  reminded?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

export type UserCompetenceEvaluation = {
  __typename?: 'UserCompetenceEvaluation';
  active: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `UserCompetenceEvaluation`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  departmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `User` that is related to this `UserCompetenceEvaluation`. */
  evaluatingUser?: Maybe<User>;
  evaluatingUserId: Scalars['UUID'];
  evaluationDate: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `FormFieldEntry`. */
  formFieldEntries: FormFieldEntriesConnection;
  id: Scalars['UUID'];
  nextUpdate?: Maybe<Scalars['Datetime']>;
  reminded?: Maybe<Scalars['Boolean']>;
  /** Reads a single `UserCompetence` that is related to this `UserCompetenceEvaluation`. */
  userCompetence?: Maybe<UserCompetence>;
  /** Reads and enables pagination through a set of `UserCompetenceEvaluationComment`. */
  userCompetenceEvaluationComments: UserCompetenceEvaluationCommentsConnection;
  userCompetenceId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


export type UserCompetenceEvaluationFormFieldEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FormFieldEntryCondition>;
  filter?: InputMaybe<FormFieldEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FormFieldEntriesOrderBy>>;
};


export type UserCompetenceEvaluationUserCompetenceEvaluationCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCompetenceEvaluationCommentCondition>;
  filter?: InputMaybe<UserCompetenceEvaluationCommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCompetenceEvaluationCommentsOrderBy>>;
};

export type UserCompetenceEvaluationComment = {
  __typename?: 'UserCompetenceEvaluationComment';
  active: Scalars['Boolean'];
  comment?: Maybe<Scalars['String']>;
  /** Reads a single `Company` that is related to this `UserCompetenceEvaluationComment`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `UserCompetenceEvaluationComment`. */
  user?: Maybe<User>;
  userCompetenceDepartmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `UserCompetenceEvaluation` that is related to this `UserCompetenceEvaluationComment`. */
  userCompetenceEvaluation?: Maybe<UserCompetenceEvaluation>;
  userCompetenceEvaluationId: Scalars['UUID'];
  userCompetenceUserId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The `userCompetenceEvaluationComment` to be created by this mutation. */
export type UserCompetenceEvaluationCommentCompanyIdForeignConnectionUserCompetenceEvaluationCommentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInput>;
  userCompetenceDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userCompetenceEvaluation?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userCompetenceUserId: Scalars['UUID'];
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `UserCompetenceEvaluationCommentInput` mutation. */
export type UserCompetenceEvaluationCommentCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `userCompetenceEvaluationComment` in the `CompanyInput` mutation. */
export type UserCompetenceEvaluationCommentCompanyIdForeignInverseInput = {
  /** The primary key(s) for `userCompetenceEvaluationComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserCompetenceEvaluationCommentUserCompetenceEvaluationCommentPkeyConnect>>;
  /** A `UserCompetenceEvaluationCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserCompetenceEvaluationCommentCompanyIdForeignConnectionUserCompetenceEvaluationCommentCreateInput>>;
  /** The primary key(s) and patch data for `userCompetenceEvaluationComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserCompetenceEvaluationCommentOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentCompanyIdForeignUsingUserCompetenceEvaluationCommentPkeyUpdate>>;
};

/**
 * A condition to be used against `UserCompetenceEvaluationComment` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type UserCompetenceEvaluationCommentCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `comment` field. */
  comment?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userCompetenceDepartmentIds` field. */
  userCompetenceDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `userCompetenceEvaluationId` field. */
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userCompetenceUserId` field. */
  userCompetenceUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `UserCompetenceEvaluationComment` object types. All fields are combined with a logical ‘and.’ */
export type UserCompetenceEvaluationCommentFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserCompetenceEvaluationCommentFilter>>;
  /** Filter by the object’s `comment` field. */
  comment?: InputMaybe<StringFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserCompetenceEvaluationCommentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserCompetenceEvaluationCommentFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userCompetenceDepartmentIds` field. */
  userCompetenceDepartmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `userCompetenceEvaluation` relation. */
  userCompetenceEvaluation?: InputMaybe<UserCompetenceEvaluationFilter>;
  /** Filter by the object’s `userCompetenceEvaluationId` field. */
  userCompetenceEvaluationId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userCompetenceUserId` field. */
  userCompetenceUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `UserCompetenceEvaluationComment` */
export type UserCompetenceEvaluationCommentInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInput>;
  userCompetenceDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userCompetenceEvaluation?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userCompetenceUserId: Scalars['UUID'];
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `userCompetenceEvaluationComment` to look up the row to update. */
export type UserCompetenceEvaluationCommentOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentCompanyIdForeignUsingUserCompetenceEvaluationCommentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompetenceEvaluationComment` being updated. */
  patch: UpdateUserCompetenceEvaluationCommentOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentCompanyIdForeignPatch;
};

/** The fields on `userCompetenceEvaluationComment` to look up the row to update. */
export type UserCompetenceEvaluationCommentOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentUserCompetenceEvaluationIUsingUserCompetenceEvaluationCommentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompetenceEvaluationComment` being updated. */
  patch: UpdateUserCompetenceEvaluationCommentOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentUserCompetenceEvaluationIPatch;
};

/** The fields on `userCompetenceEvaluationComment` to look up the row to update. */
export type UserCompetenceEvaluationCommentOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentUserIdForeignUsingUserCompetenceEvaluationCommentPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompetenceEvaluationComment` being updated. */
  patch: UpdateUserCompetenceEvaluationCommentOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentUserIdForeignPatch;
};

/** Represents an update to a `UserCompetenceEvaluationComment`. Fields that are set will be updated. */
export type UserCompetenceEvaluationCommentPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInput>;
  userCompetenceDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userCompetenceEvaluation?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userCompetenceUserId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `userCompetenceEvaluationComment` to look up the row to connect. */
export type UserCompetenceEvaluationCommentUserCompetenceEvaluationCommentPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `userCompetenceEvaluationComment` to be created by this mutation. */
export type UserCompetenceEvaluationCommentUserCompetenceEvaluationIConnectionUserCompetenceEvaluationCommentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInput>;
  userCompetenceDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userCompetenceEvaluation?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInput>;
  userCompetenceUserId: Scalars['UUID'];
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `userCompetenceEvaluation` to be created by this mutation. */
export type UserCompetenceEvaluationCommentUserCompetenceEvaluationIConnectionUserCompetenceEvaluationCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  evaluatingUserId?: InputMaybe<Scalars['UUID']>;
  evaluationDate?: InputMaybe<Scalars['Datetime']>;
  formFieldEntries?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  nextUpdate?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInput>;
  userCompetence?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInverseInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
};

/** Input for the nested mutation of `userCompetenceEvaluation` in the `UserCompetenceEvaluationCommentInput` mutation. */
export type UserCompetenceEvaluationCommentUserCompetenceEvaluationIInput = {
  /** The primary key(s) for `userCompetenceEvaluation` for the far side of the relationship. */
  connectById?: InputMaybe<UserCompetenceEvaluationUserCompetenceEvaluationPkeyConnect>;
  /** A `UserCompetenceEvaluationInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIConnectionUserCompetenceEvaluationCreateInput>;
  /** The primary key(s) and patch data for `userCompetenceEvaluation` for the far side of the relationship. */
  updateById?: InputMaybe<UserCompetenceEvaluationOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentUserCompetenceEvaluationIUsingUserCompetenceEvaluationPkeyUpdate>;
};

/** Input for the nested mutation of `userCompetenceEvaluationComment` in the `UserCompetenceEvaluationInput` mutation. */
export type UserCompetenceEvaluationCommentUserCompetenceEvaluationIInverseInput = {
  /** The primary key(s) for `userCompetenceEvaluationComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserCompetenceEvaluationCommentUserCompetenceEvaluationCommentPkeyConnect>>;
  /** A `UserCompetenceEvaluationCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserCompetenceEvaluationCommentUserCompetenceEvaluationIConnectionUserCompetenceEvaluationCommentCreateInput>>;
  /** The primary key(s) and patch data for `userCompetenceEvaluationComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserCompetenceEvaluationCommentOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentUserCompetenceEvaluationIUsingUserCompetenceEvaluationCommentPkeyUpdate>>;
};

/** The `userCompetenceEvaluationComment` to be created by this mutation. */
export type UserCompetenceEvaluationCommentUserIdForeignConnectionUserCompetenceEvaluationCommentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInput>;
  userCompetenceDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userCompetenceEvaluation?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userCompetenceUserId: Scalars['UUID'];
};

/** Input for the nested mutation of `user` in the `UserCompetenceEvaluationCommentInput` mutation. */
export type UserCompetenceEvaluationCommentUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `userCompetenceEvaluationComment` in the `UserInput` mutation. */
export type UserCompetenceEvaluationCommentUserIdForeignInverseInput = {
  /** The primary key(s) for `userCompetenceEvaluationComment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserCompetenceEvaluationCommentUserCompetenceEvaluationCommentPkeyConnect>>;
  /** A `UserCompetenceEvaluationCommentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserCompetenceEvaluationCommentUserIdForeignConnectionUserCompetenceEvaluationCommentCreateInput>>;
  /** The primary key(s) and patch data for `userCompetenceEvaluationComment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserCompetenceEvaluationCommentOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentUserIdForeignUsingUserCompetenceEvaluationCommentPkeyUpdate>>;
};

/** A connection to a list of `UserCompetenceEvaluationComment` values. */
export type UserCompetenceEvaluationCommentsConnection = {
  __typename?: 'UserCompetenceEvaluationCommentsConnection';
  /** A list of edges which contains the `UserCompetenceEvaluationComment` and cursor to aid in pagination. */
  edges: Array<UserCompetenceEvaluationCommentsEdge>;
  /** A list of `UserCompetenceEvaluationComment` objects. */
  nodes: Array<Maybe<UserCompetenceEvaluationComment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserCompetenceEvaluationComment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserCompetenceEvaluationComment` edge in the connection. */
export type UserCompetenceEvaluationCommentsEdge = {
  __typename?: 'UserCompetenceEvaluationCommentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserCompetenceEvaluationComment` at the end of the edge. */
  node?: Maybe<UserCompetenceEvaluationComment>;
};

/** Methods to use when ordering `UserCompetenceEvaluationComment`. */
export type UserCompetenceEvaluationCommentsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMMENT_ASC'
  | 'COMMENT_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_COMPETENCE_DEPARTMENT_IDS_ASC'
  | 'USER_COMPETENCE_DEPARTMENT_IDS_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__ACTIVE_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__ACTIVE_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__COMPANY_ID_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__COMPANY_ID_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__DEPARTMENT_IDS_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__DEPARTMENT_IDS_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__EVALUATING_USER_ID_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__EVALUATING_USER_ID_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__EVALUATION_DATE_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__EVALUATION_DATE_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__ID_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__ID_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__NEXT_UPDATE_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__NEXT_UPDATE_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__REMINDED_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__REMINDED_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__USER_COMPETENCE_ID_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__USER_COMPETENCE_ID_DESC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__USER_ID_ASC'
  | 'USER_COMPETENCE_EVALUATION_BY_USER_COMPETENCE_EVALUATION_ID__USER_ID_DESC'
  | 'USER_COMPETENCE_EVALUATION_ID_ASC'
  | 'USER_COMPETENCE_EVALUATION_ID_DESC'
  | 'USER_COMPETENCE_USER_ID_ASC'
  | 'USER_COMPETENCE_USER_ID_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** The `userCompetenceEvaluation` to be created by this mutation. */
export type UserCompetenceEvaluationCompanyIdForeignConnectionUserCompetenceEvaluationCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInput>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  evaluatingUserId?: InputMaybe<Scalars['UUID']>;
  evaluationDate?: InputMaybe<Scalars['Datetime']>;
  formFieldEntries?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  nextUpdate?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInput>;
  userCompetence?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInverseInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
};

/** Input for the nested mutation of `company` in the `UserCompetenceEvaluationInput` mutation. */
export type UserCompetenceEvaluationCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnUserCompetenceEvaluationForUserCompetenceEvaluationCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `userCompetenceEvaluation` in the `CompanyInput` mutation. */
export type UserCompetenceEvaluationCompanyIdForeignInverseInput = {
  /** The primary key(s) for `userCompetenceEvaluation` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserCompetenceEvaluationUserCompetenceEvaluationPkeyConnect>>;
  /** A `UserCompetenceEvaluationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserCompetenceEvaluationCompanyIdForeignConnectionUserCompetenceEvaluationCreateInput>>;
  /** The primary key(s) and patch data for `userCompetenceEvaluation` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserCompetenceEvaluationOnUserCompetenceEvaluationForUserCompetenceEvaluationCompanyIdForeignUsingUserCompetenceEvaluationPkeyUpdate>>;
};

/**
 * A condition to be used against `UserCompetenceEvaluation` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type UserCompetenceEvaluationCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `evaluatingUserId` field. */
  evaluatingUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `evaluationDate` field. */
  evaluationDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `nextUpdate` field. */
  nextUpdate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `reminded` field. */
  reminded?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `userCompetenceId` field. */
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `userCompetenceEvaluation` to be created by this mutation. */
export type UserCompetenceEvaluationEvaluatingUserIdForeignConnectionUserCompetenceEvaluationCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  evaluationDate?: InputMaybe<Scalars['Datetime']>;
  formFieldEntries?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  nextUpdate?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInput>;
  userCompetence?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInverseInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
};

/** Input for the nested mutation of `user` in the `UserCompetenceEvaluationInput` mutation. */
export type UserCompetenceEvaluationEvaluatingUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserCompetenceEvaluationForUserCompetenceEvaluationEvaluatingUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `userCompetenceEvaluation` in the `UserInput` mutation. */
export type UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput = {
  /** The primary key(s) for `userCompetenceEvaluation` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserCompetenceEvaluationUserCompetenceEvaluationPkeyConnect>>;
  /** A `UserCompetenceEvaluationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserCompetenceEvaluationEvaluatingUserIdForeignConnectionUserCompetenceEvaluationCreateInput>>;
  /** The primary key(s) and patch data for `userCompetenceEvaluation` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserCompetenceEvaluationOnUserCompetenceEvaluationForUserCompetenceEvaluationEvaluatingUserIdForeignUsingUserCompetenceEvaluationPkeyUpdate>>;
};

/** A filter to be used against `UserCompetenceEvaluation` object types. All fields are combined with a logical ‘and.’ */
export type UserCompetenceEvaluationFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserCompetenceEvaluationFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `evaluatingUser` relation. */
  evaluatingUser?: InputMaybe<UserFilter>;
  /** Filter by the object’s `evaluatingUserId` field. */
  evaluatingUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `evaluationDate` field. */
  evaluationDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `formFieldEntries` relation. */
  formFieldEntries?: InputMaybe<UserCompetenceEvaluationToManyFormFieldEntryFilter>;
  /** Some related `formFieldEntries` exist. */
  formFieldEntriesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `nextUpdate` field. */
  nextUpdate?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserCompetenceEvaluationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserCompetenceEvaluationFilter>>;
  /** Filter by the object’s `reminded` field. */
  reminded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `userCompetence` relation. */
  userCompetence?: InputMaybe<UserCompetenceFilter>;
  /** Filter by the object’s `userCompetenceEvaluationComments` relation. */
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationToManyUserCompetenceEvaluationCommentFilter>;
  /** Some related `userCompetenceEvaluationComments` exist. */
  userCompetenceEvaluationCommentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userCompetenceId` field. */
  userCompetenceId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `UserCompetenceEvaluation` */
export type UserCompetenceEvaluationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  evaluatingUserId?: InputMaybe<Scalars['UUID']>;
  evaluationDate?: InputMaybe<Scalars['Datetime']>;
  formFieldEntries?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  nextUpdate?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInput>;
  userCompetence?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInverseInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
};

/** The fields on `userCompetenceEvaluation` to look up the row to update. */
export type UserCompetenceEvaluationOnFormFieldEntryForFormFieldEntryUserCompetenceEvaluationIdForeignUsingUserCompetenceEvaluationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompetenceEvaluation` being updated. */
  patch: UpdateUserCompetenceEvaluationOnFormFieldEntryForFormFieldEntryUserCompetenceEvaluationIdForeignPatch;
};

/** The fields on `userCompetenceEvaluation` to look up the row to update. */
export type UserCompetenceEvaluationOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentUserCompetenceEvaluationIUsingUserCompetenceEvaluationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompetenceEvaluation` being updated. */
  patch: UpdateUserCompetenceEvaluationOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentUserCompetenceEvaluationIPatch;
};

/** The fields on `userCompetenceEvaluation` to look up the row to update. */
export type UserCompetenceEvaluationOnUserCompetenceEvaluationForUserCompetenceEvaluationCompanyIdForeignUsingUserCompetenceEvaluationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompetenceEvaluation` being updated. */
  patch: UpdateUserCompetenceEvaluationOnUserCompetenceEvaluationForUserCompetenceEvaluationCompanyIdForeignPatch;
};

/** The fields on `userCompetenceEvaluation` to look up the row to update. */
export type UserCompetenceEvaluationOnUserCompetenceEvaluationForUserCompetenceEvaluationEvaluatingUserIdForeignUsingUserCompetenceEvaluationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompetenceEvaluation` being updated. */
  patch: UpdateUserCompetenceEvaluationOnUserCompetenceEvaluationForUserCompetenceEvaluationEvaluatingUserIdForeignPatch;
};

/** The fields on `userCompetenceEvaluation` to look up the row to update. */
export type UserCompetenceEvaluationOnUserCompetenceEvaluationForUserCompetenceEvaluationUserCompetenceIdForeignUsingUserCompetenceEvaluationPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompetenceEvaluation` being updated. */
  patch: UpdateUserCompetenceEvaluationOnUserCompetenceEvaluationForUserCompetenceEvaluationUserCompetenceIdForeignPatch;
};

/** Represents an update to a `UserCompetenceEvaluation`. Fields that are set will be updated. */
export type UserCompetenceEvaluationPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  evaluatingUserId?: InputMaybe<Scalars['UUID']>;
  evaluationDate?: InputMaybe<Scalars['Datetime']>;
  formFieldEntries?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  nextUpdate?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInput>;
  userCompetence?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInverseInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against many `FormFieldEntry` object types. All fields are combined with a logical ‘and.’ */
export type UserCompetenceEvaluationToManyFormFieldEntryFilter = {
  /** Every related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FormFieldEntryFilter>;
  /** No related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FormFieldEntryFilter>;
  /** Some related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FormFieldEntryFilter>;
};

/** A filter to be used against many `UserCompetenceEvaluationComment` object types. All fields are combined with a logical ‘and.’ */
export type UserCompetenceEvaluationToManyUserCompetenceEvaluationCommentFilter = {
  /** Every related `UserCompetenceEvaluationComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCompetenceEvaluationCommentFilter>;
  /** No related `UserCompetenceEvaluationComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCompetenceEvaluationCommentFilter>;
  /** Some related `UserCompetenceEvaluationComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCompetenceEvaluationCommentFilter>;
};

/** The fields on `userCompetenceEvaluation` to look up the row to connect. */
export type UserCompetenceEvaluationUserCompetenceEvaluationPkeyConnect = {
  id: Scalars['UUID'];
};

/** The `userCompetence` to be created by this mutation. */
export type UserCompetenceEvaluationUserCompetenceIdForeignConnectionUserCompetenceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addedDate?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<UserCompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<UserCompetenceCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  courseRequested?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInverseInput>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceUserIdForeignInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInverseInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `userCompetenceEvaluation` to be created by this mutation. */
export type UserCompetenceEvaluationUserCompetenceIdForeignConnectionUserCompetenceEvaluationCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  evaluatingUserId?: InputMaybe<Scalars['UUID']>;
  evaluationDate?: InputMaybe<Scalars['Datetime']>;
  formFieldEntries?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  nextUpdate?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInput>;
  userCompetence?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInverseInput>;
  userId: Scalars['UUID'];
};

/** Input for the nested mutation of `userCompetence` in the `UserCompetenceEvaluationInput` mutation. */
export type UserCompetenceEvaluationUserCompetenceIdForeignInput = {
  /** The primary key(s) for `userCompetence` for the far side of the relationship. */
  connectById?: InputMaybe<UserCompetenceUserCompetencePkeyConnect>;
  /** A `UserCompetenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignConnectionUserCompetenceCreateInput>;
  /** The primary key(s) and patch data for `userCompetence` for the far side of the relationship. */
  updateById?: InputMaybe<UserCompetenceOnUserCompetenceEvaluationForUserCompetenceEvaluationUserCompetenceIdForeignUsingUserCompetencePkeyUpdate>;
};

/** Input for the nested mutation of `userCompetenceEvaluation` in the `UserCompetenceInput` mutation. */
export type UserCompetenceEvaluationUserCompetenceIdForeignInverseInput = {
  /** The primary key(s) for `userCompetenceEvaluation` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserCompetenceEvaluationUserCompetenceEvaluationPkeyConnect>>;
  /** A `UserCompetenceEvaluationInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserCompetenceEvaluationUserCompetenceIdForeignConnectionUserCompetenceEvaluationCreateInput>>;
  /** The primary key(s) and patch data for `userCompetenceEvaluation` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserCompetenceEvaluationOnUserCompetenceEvaluationForUserCompetenceEvaluationUserCompetenceIdForeignUsingUserCompetenceEvaluationPkeyUpdate>>;
};

/** A connection to a list of `UserCompetenceEvaluation` values. */
export type UserCompetenceEvaluationsConnection = {
  __typename?: 'UserCompetenceEvaluationsConnection';
  /** A list of edges which contains the `UserCompetenceEvaluation` and cursor to aid in pagination. */
  edges: Array<UserCompetenceEvaluationsEdge>;
  /** A list of `UserCompetenceEvaluation` objects. */
  nodes: Array<Maybe<UserCompetenceEvaluation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserCompetenceEvaluation` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserCompetenceEvaluation` edge in the connection. */
export type UserCompetenceEvaluationsEdge = {
  __typename?: 'UserCompetenceEvaluationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserCompetenceEvaluation` at the end of the edge. */
  node?: Maybe<UserCompetenceEvaluation>;
};

/** Methods to use when ordering `UserCompetenceEvaluation`. */
export type UserCompetenceEvaluationsOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'EVALUATING_USER_ID_ASC'
  | 'EVALUATING_USER_ID_DESC'
  | 'EVALUATION_DATE_ASC'
  | 'EVALUATION_DATE_DESC'
  | 'FORM_FIELD_ENTRIES_BY_USER_COMPETENCE_EVALUATION_ID__COUNT_ASC'
  | 'FORM_FIELD_ENTRIES_BY_USER_COMPETENCE_EVALUATION_ID__COUNT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'NEXT_UPDATE_ASC'
  | 'NEXT_UPDATE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REMINDED_ASC'
  | 'REMINDED_DESC'
  | 'USER_BY_EVALUATING_USER_ID__ACTIVE_ASC'
  | 'USER_BY_EVALUATING_USER_ID__ACTIVE_DESC'
  | 'USER_BY_EVALUATING_USER_ID__ADDRESS_ASC'
  | 'USER_BY_EVALUATING_USER_ID__ADDRESS_DESC'
  | 'USER_BY_EVALUATING_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_EVALUATING_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_EVALUATING_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_EVALUATING_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_EVALUATING_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_EVALUATING_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_EVALUATING_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_EVALUATING_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_EVALUATING_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_EVALUATING_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_EVALUATING_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_EVALUATING_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_EVALUATING_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_EVALUATING_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_EVALUATING_USER_ID__CITY_ASC'
  | 'USER_BY_EVALUATING_USER_ID__CITY_DESC'
  | 'USER_BY_EVALUATING_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_EVALUATING_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_EVALUATING_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_EVALUATING_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_EVALUATING_USER_ID__CPR_ASC'
  | 'USER_BY_EVALUATING_USER_ID__CPR_DESC'
  | 'USER_BY_EVALUATING_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_EVALUATING_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_EVALUATING_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_EVALUATING_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_EVALUATING_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_EVALUATING_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_EVALUATING_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_EVALUATING_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_EVALUATING_USER_ID__EMAIL_ASC'
  | 'USER_BY_EVALUATING_USER_ID__EMAIL_DESC'
  | 'USER_BY_EVALUATING_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_EVALUATING_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_EVALUATING_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_EVALUATING_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_EVALUATING_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_EVALUATING_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_EVALUATING_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_EVALUATING_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_EVALUATING_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_EVALUATING_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_EVALUATING_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_EVALUATING_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_EVALUATING_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_EVALUATING_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_EVALUATING_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_EVALUATING_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_EVALUATING_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_EVALUATING_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_EVALUATING_USER_ID__GODMODE_ASC'
  | 'USER_BY_EVALUATING_USER_ID__GODMODE_DESC'
  | 'USER_BY_EVALUATING_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_EVALUATING_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_EVALUATING_USER_ID__ID_ASC'
  | 'USER_BY_EVALUATING_USER_ID__ID_DESC'
  | 'USER_BY_EVALUATING_USER_ID__INITIALS_ASC'
  | 'USER_BY_EVALUATING_USER_ID__INITIALS_DESC'
  | 'USER_BY_EVALUATING_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_EVALUATING_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_EVALUATING_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_EVALUATING_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_EVALUATING_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_EVALUATING_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_EVALUATING_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_EVALUATING_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_EVALUATING_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_EVALUATING_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_EVALUATING_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_EVALUATING_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_EVALUATING_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_EVALUATING_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_EVALUATING_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_EVALUATING_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_EVALUATING_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_EVALUATING_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_EVALUATING_USER_ID__MOBILE_ASC'
  | 'USER_BY_EVALUATING_USER_ID__MOBILE_DESC'
  | 'USER_BY_EVALUATING_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_EVALUATING_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_EVALUATING_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_EVALUATING_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_EVALUATING_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_EVALUATING_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_EVALUATING_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_EVALUATING_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_EVALUATING_USER_ID__PHONE_ASC'
  | 'USER_BY_EVALUATING_USER_ID__PHONE_DESC'
  | 'USER_BY_EVALUATING_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_EVALUATING_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_EVALUATING_USER_ID__SENIORITY_ASC'
  | 'USER_BY_EVALUATING_USER_ID__SENIORITY_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__ACTIVE_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__ACTIVE_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__ADDED_DATE_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__ADDED_DATE_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__COMPANY_ID_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__COMPANY_ID_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__COMPETENCE_ID_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__COMPETENCE_ID_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__COURSE_REQUESTED_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__COURSE_REQUESTED_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__DEPARTMENT_IDS_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__DEPARTMENT_IDS_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__EXPIRE_AT_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__EXPIRE_AT_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__ID_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__ID_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__MANAGER_EVALUATION_DATE_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__MANAGER_EVALUATION_DATE_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__MANAGER_NEXT_UPDATE_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__MANAGER_NEXT_UPDATE_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__REMINDED_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__REMINDED_DESC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__USER_ID_ASC'
  | 'USER_COMPETENCE_BY_USER_COMPETENCE_ID__USER_ID_DESC'
  | 'USER_COMPETENCE_EVALUATION_COMMENTS_BY_USER_COMPETENCE_EVALUATION_ID__COUNT_ASC'
  | 'USER_COMPETENCE_EVALUATION_COMMENTS_BY_USER_COMPETENCE_EVALUATION_ID__COUNT_DESC'
  | 'USER_COMPETENCE_ID_ASC'
  | 'USER_COMPETENCE_ID_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** A filter to be used against `UserCompetence` object types. All fields are combined with a logical ‘and.’ */
export type UserCompetenceFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `addedDate` field. */
  addedDate?: InputMaybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserCompetenceFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `competence` relation. */
  competence?: InputMaybe<CompetenceFilter>;
  /** Filter by the object’s `competenceId` field. */
  competenceId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `courseRequested` field. */
  courseRequested?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `expireAt` field. */
  expireAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `managerEvaluationDate` field. */
  managerEvaluationDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `managerNextUpdate` field. */
  managerNextUpdate?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserCompetenceFilter>;
  /** Filter by the object’s `notificationEmployeeReferences` relation. */
  notificationEmployeeReferences?: InputMaybe<UserCompetenceToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferences` exist. */
  notificationEmployeeReferencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserCompetenceFilter>>;
  /** Filter by the object’s `reminded` field. */
  reminded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userCompetenceEvaluations` relation. */
  userCompetenceEvaluations?: InputMaybe<UserCompetenceToManyUserCompetenceEvaluationFilter>;
  /** Some related `userCompetenceEvaluations` exist. */
  userCompetenceEvaluationsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `UserCompetence` */
export type UserCompetenceInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addedDate?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<UserCompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<UserCompetenceCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  courseRequested?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInverseInput>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceUserIdForeignInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInverseInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `userCompetence` to look up the row to update. */
export type UserCompetenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceUserCompetenceIdForeignUsingUserCompetencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompetence` being updated. */
  patch: UpdateUserCompetenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceUserCompetenceIdForeignPatch;
};

/** The fields on `userCompetence` to look up the row to update. */
export type UserCompetenceOnUserCompetenceEvaluationForUserCompetenceEvaluationUserCompetenceIdForeignUsingUserCompetencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompetence` being updated. */
  patch: UpdateUserCompetenceOnUserCompetenceEvaluationForUserCompetenceEvaluationUserCompetenceIdForeignPatch;
};

/** The fields on `userCompetence` to look up the row to update. */
export type UserCompetenceOnUserCompetenceForUserCompetenceCompanyIdForeignUsingUserCompetencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompetence` being updated. */
  patch: UpdateUserCompetenceOnUserCompetenceForUserCompetenceCompanyIdForeignPatch;
};

/** The fields on `userCompetence` to look up the row to update. */
export type UserCompetenceOnUserCompetenceForUserCompetenceCompetenceIdForeignUsingUserCompetencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompetence` being updated. */
  patch: UpdateUserCompetenceOnUserCompetenceForUserCompetenceCompetenceIdForeignPatch;
};

/** The fields on `userCompetence` to look up the row to update. */
export type UserCompetenceOnUserCompetenceForUserCompetenceUserIdForeignUsingUserCompetencePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userCompetence` being updated. */
  patch: UpdateUserCompetenceOnUserCompetenceForUserCompetenceUserIdForeignPatch;
};

/** Represents an update to a `UserCompetence`. Fields that are set will be updated. */
export type UserCompetencePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addedDate?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<UserCompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<UserCompetenceCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  courseRequested?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInverseInput>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceUserIdForeignInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInverseInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type UserCompetenceToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

/** A filter to be used against many `UserCompetenceEvaluation` object types. All fields are combined with a logical ‘and.’ */
export type UserCompetenceToManyUserCompetenceEvaluationFilter = {
  /** Every related `UserCompetenceEvaluation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCompetenceEvaluationFilter>;
  /** No related `UserCompetenceEvaluation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCompetenceEvaluationFilter>;
  /** Some related `UserCompetenceEvaluation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCompetenceEvaluationFilter>;
};

/** The fields on `userCompetence` to look up the row to connect. */
export type UserCompetenceUserCompetencePkeyConnect = {
  id: Scalars['UUID'];
};

/** The `userCompetence` to be created by this mutation. */
export type UserCompetenceUserIdForeignConnectionUserCompetenceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addedDate?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<UserCompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<UserCompetenceCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  courseRequested?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInverseInput>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceUserIdForeignInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInverseInput>;
};

/** Input for the nested mutation of `user` in the `UserCompetenceInput` mutation. */
export type UserCompetenceUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserCompetenceForUserCompetenceUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `userCompetence` in the `UserInput` mutation. */
export type UserCompetenceUserIdForeignInverseInput = {
  /** The primary key(s) for `userCompetence` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserCompetenceUserCompetencePkeyConnect>>;
  /** A `UserCompetenceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserCompetenceUserIdForeignConnectionUserCompetenceCreateInput>>;
  /** The primary key(s) and patch data for `userCompetence` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserCompetenceOnUserCompetenceForUserCompetenceUserIdForeignUsingUserCompetencePkeyUpdate>>;
};

/** A connection to a list of `UserCompetence` values. */
export type UserCompetencesConnection = {
  __typename?: 'UserCompetencesConnection';
  /** A list of edges which contains the `UserCompetence` and cursor to aid in pagination. */
  edges: Array<UserCompetencesEdge>;
  /** A list of `UserCompetence` objects. */
  nodes: Array<Maybe<UserCompetence>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserCompetence` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserCompetence` edge in the connection. */
export type UserCompetencesEdge = {
  __typename?: 'UserCompetencesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserCompetence` at the end of the edge. */
  node?: Maybe<UserCompetence>;
};

/** Methods to use when ordering `UserCompetence`. */
export type UserCompetencesOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ADDED_DATE_ASC'
  | 'ADDED_DATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ACTIVE_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ACTIVE_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__COMPANY_ID_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__COMPANY_ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__COMPETENCE_GROUP_ID_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__COMPETENCE_GROUP_ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__CREATED_AT_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__CREATED_AT_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__DESCRIPTION_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__DESCRIPTION_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ID_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__LOCALIZED_NAME_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__LOCALIZED_NAME_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__NAME_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__NAME_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ONLY_MANAGER_SHOULD_EVALUATE_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__ONLY_MANAGER_SHOULD_EVALUATE_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_AT_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_AT_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_COMPETENCE_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_COMPETENCE_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_INTERVAL_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__OUTDATE_INTERVAL_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__RATING_FORM_FIELD_ID_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__RATING_FORM_FIELD_ID_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__REMINDER_INTERVAL_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__REMINDER_INTERVAL_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__UPDATED_AT_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__UPDATED_AT_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__UPDATE_REMINDER_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__UPDATE_REMINDER_DESC'
  | 'COMPETENCE_BY_COMPETENCE_ID__USE_RATING_ASC'
  | 'COMPETENCE_BY_COMPETENCE_ID__USE_RATING_DESC'
  | 'COMPETENCE_ID_ASC'
  | 'COMPETENCE_ID_DESC'
  | 'COURSE_REQUESTED_ASC'
  | 'COURSE_REQUESTED_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'EXPIRE_AT_ASC'
  | 'EXPIRE_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MANAGER_EVALUATION_DATE_ASC'
  | 'MANAGER_EVALUATION_DATE_DESC'
  | 'MANAGER_NEXT_UPDATE_ASC'
  | 'MANAGER_NEXT_UPDATE_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_USER_COMPETENCE_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_USER_COMPETENCE_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REMINDED_ASC'
  | 'REMINDED_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_COMPETENCE_EVALUATIONS_BY_USER_COMPETENCE_ID__COUNT_ASC'
  | 'USER_COMPETENCE_EVALUATIONS_BY_USER_COMPETENCE_ID__COUNT_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canLogin` field. */
  canLogin?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canLoginApp` field. */
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canLoginSso` field. */
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `canSignOnBehalfOf` field. */
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyAdmin` field. */
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `customId` field. */
  customId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `deleteAt` field. */
  deleteAt?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `deleteReminded` field. */
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `employmentEndReminded` field. */
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fullName` field. */
  fullName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fullNameTsvector` field. */
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  /** Checks for equality with the object’s `godmode` field. */
  godmode?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `groupIds` field. */
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isArchived` field. */
  isArchived?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isFuture` field. */
  isFuture?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isLeader` field. */
  isLeader?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isResigned` field. */
  isResigned?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `isSystemUser` field. */
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `lastLogin` field. */
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `latestTimeRegistrationTemplate` field. */
  latestTimeRegistrationTemplate?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `leaderDepartments` field. */
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

export type UserDepartment = {
  __typename?: 'UserDepartment';
  /** Reads a single `Company` that is related to this `UserDepartment`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `Department` that is related to this `UserDepartment`. */
  department?: Maybe<Department>;
  departmentId: Scalars['UUID'];
  id: Scalars['UUID'];
  /** Reads a single `UserDepartment` that is related to this `UserDepartment`. */
  parentUserDepartment?: Maybe<UserDepartment>;
  parentUserDepartmentId?: Maybe<Scalars['UUID']>;
  parentUserIsMissing?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Rank` that is related to this `UserDepartment`. */
  rank?: Maybe<Rank>;
  rankId?: Maybe<Scalars['UUID']>;
  /** Reads a single `User` that is related to this `UserDepartment`. */
  user?: Maybe<User>;
  /** Reads and enables pagination through a set of `UserDepartment`. */
  userDepartmentsByParentUserDepartmentId: UserDepartmentsConnection;
  userId: Scalars['UUID'];
};


export type UserDepartmentUserDepartmentsByParentUserDepartmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserDepartmentCondition>;
  filter?: InputMaybe<UserDepartmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserDepartmentsOrderBy>>;
};

/** The `userDepartment` to be created by this mutation. */
export type UserDepartmentCompanyIdFkeyConnectionUserDepartmentCreateInput = {
  company?: InputMaybe<UserDepartmentCompanyIdFkeyInput>;
  department?: InputMaybe<UserDepartmentDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  parentUserDepartmentId?: InputMaybe<Scalars['UUID']>;
  rank?: InputMaybe<UserDepartmentRankIdForeignInput>;
  rankId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserDepartmentUserIdForeignInput>;
  userDepartment?: InputMaybe<UserDepartmentParentUserDepartmentIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `UserDepartmentInput` mutation. */
export type UserDepartmentCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnUserDepartmentForUserDepartmentCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `userDepartment` in the `CompanyInput` mutation. */
export type UserDepartmentCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `userDepartment` for the far side of the relationship. */
  connectByDepartmentIdAndUserId?: InputMaybe<Array<UserDepartmentUserDepartmentDepartmentIdUserIdUniqueConnect>>;
  /** The primary key(s) for `userDepartment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserDepartmentUserDepartmentIdUniqueConnect>>;
  /** A `UserDepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserDepartmentCompanyIdFkeyConnectionUserDepartmentCreateInput>>;
  /** The primary key(s) and patch data for `userDepartment` for the far side of the relationship. */
  updateByDepartmentIdAndUserId?: InputMaybe<Array<UserDepartmentOnUserDepartmentForUserDepartmentCompanyIdFkeyUsingUserDepartmentDepartmentIdUserIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `userDepartment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserDepartmentOnUserDepartmentForUserDepartmentCompanyIdFkeyUsingUserDepartmentIdUniqueUpdate>>;
};

/**
 * A condition to be used against `UserDepartment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserDepartmentCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departmentId` field. */
  departmentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `parentUserDepartmentId` field. */
  parentUserDepartmentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `rankId` field. */
  rankId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `department` to be created by this mutation. */
export type UserDepartmentDepartmentIdForeignConnectionDepartmentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** The `userDepartment` to be created by this mutation. */
export type UserDepartmentDepartmentIdForeignConnectionUserDepartmentCreateInput = {
  company?: InputMaybe<UserDepartmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentDepartmentIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  parentUserDepartmentId?: InputMaybe<Scalars['UUID']>;
  rank?: InputMaybe<UserDepartmentRankIdForeignInput>;
  rankId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserDepartmentUserIdForeignInput>;
  userDepartment?: InputMaybe<UserDepartmentParentUserDepartmentIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `department` in the `UserDepartmentInput` mutation. */
export type UserDepartmentDepartmentIdForeignInput = {
  /** The primary key(s) for `department` for the far side of the relationship. */
  connectById?: InputMaybe<DepartmentDepartmentPkeyConnect>;
  /** A `DepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserDepartmentDepartmentIdForeignConnectionDepartmentCreateInput>;
  /** The primary key(s) and patch data for `department` for the far side of the relationship. */
  updateById?: InputMaybe<DepartmentOnUserDepartmentForUserDepartmentDepartmentIdForeignUsingDepartmentPkeyUpdate>;
};

/** Input for the nested mutation of `userDepartment` in the `DepartmentInput` mutation. */
export type UserDepartmentDepartmentIdForeignInverseInput = {
  /** The primary key(s) for `userDepartment` for the far side of the relationship. */
  connectByDepartmentIdAndUserId?: InputMaybe<Array<UserDepartmentUserDepartmentDepartmentIdUserIdUniqueConnect>>;
  /** The primary key(s) for `userDepartment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserDepartmentUserDepartmentIdUniqueConnect>>;
  /** A `UserDepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserDepartmentDepartmentIdForeignConnectionUserDepartmentCreateInput>>;
  /** The primary key(s) and patch data for `userDepartment` for the far side of the relationship. */
  updateByDepartmentIdAndUserId?: InputMaybe<Array<UserDepartmentOnUserDepartmentForUserDepartmentDepartmentIdForeignUsingUserDepartmentDepartmentIdUserIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `userDepartment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserDepartmentOnUserDepartmentForUserDepartmentDepartmentIdForeignUsingUserDepartmentIdUniqueUpdate>>;
};

/** A filter to be used against `UserDepartment` object types. All fields are combined with a logical ‘and.’ */
export type UserDepartmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserDepartmentFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `department` relation. */
  department?: InputMaybe<DepartmentFilter>;
  /** Filter by the object’s `departmentId` field. */
  departmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserDepartmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserDepartmentFilter>>;
  /** Filter by the object’s `parentUserDepartment` relation. */
  parentUserDepartment?: InputMaybe<UserDepartmentFilter>;
  /** A related `parentUserDepartment` exists. */
  parentUserDepartmentExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `parentUserDepartmentId` field. */
  parentUserDepartmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `parentUserIsMissing` field. */
  parentUserIsMissing?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `rank` relation. */
  rank?: InputMaybe<RankFilter>;
  /** A related `rank` exists. */
  rankExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `rankId` field. */
  rankId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userDepartmentsByParentUserDepartmentId` relation. */
  userDepartmentsByParentUserDepartmentId?: InputMaybe<UserDepartmentToManyUserDepartmentFilter>;
  /** Some related `userDepartmentsByParentUserDepartmentId` exist. */
  userDepartmentsByParentUserDepartmentIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

export type UserDepartmentGroup = {
  __typename?: 'UserDepartmentGroup';
  /** Reads a single `Company` that is related to this `UserDepartmentGroup`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `Department` that is related to this `UserDepartmentGroup`. */
  department?: Maybe<Department>;
  departmentId: Scalars['UUID'];
  /** Reads a single `Group` that is related to this `UserDepartmentGroup`. */
  group?: Maybe<Group>;
  groupId: Scalars['UUID'];
  inheritToDescendants: Scalars['Boolean'];
  onlyIncludeInDescendants: Scalars['Boolean'];
  /** Reads a single `User` that is related to this `UserDepartmentGroup`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The `userDepartmentGroup` to be created by this mutation. */
export type UserDepartmentGroupCompanyIdForeignConnectionUserDepartmentGroupCreateInput = {
  company?: InputMaybe<UserDepartmentGroupCompanyIdForeignInput>;
  department?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<UserDepartmentGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserDepartmentGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `UserDepartmentGroupInput` mutation. */
export type UserDepartmentGroupCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnUserDepartmentGroupForUserDepartmentGroupCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `userDepartmentGroup` in the `CompanyInput` mutation. */
export type UserDepartmentGroupCompanyIdForeignInverseInput = {
  /** The primary key(s) for `userDepartmentGroup` for the far side of the relationship. */
  connectByUserIdAndDepartmentIdAndGroupId?: InputMaybe<Array<UserDepartmentGroupUserDepartmentGroupPkeyConnect>>;
  /** A `UserDepartmentGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserDepartmentGroupCompanyIdForeignConnectionUserDepartmentGroupCreateInput>>;
  /** The primary key(s) for `userDepartmentGroup` for the far side of the relationship. */
  deleteByUserIdAndDepartmentIdAndGroupId?: InputMaybe<Array<UserDepartmentGroupUserDepartmentGroupPkeyDelete>>;
  /** Flag indicating whether all other `userDepartmentGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userDepartmentGroup` for the far side of the relationship. */
  updateByUserIdAndDepartmentIdAndGroupId?: InputMaybe<Array<UserDepartmentGroupOnUserDepartmentGroupForUserDepartmentGroupCompanyIdForeignUsingUserDepartmentGroupPkeyUpdate>>;
};

/**
 * A condition to be used against `UserDepartmentGroup` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type UserDepartmentGroupCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departmentId` field. */
  departmentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `inheritToDescendants` field. */
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `onlyIncludeInDescendants` field. */
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `department` to be created by this mutation. */
export type UserDepartmentGroupDepartmentIdForeignConnectionDepartmentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** The `userDepartmentGroup` to be created by this mutation. */
export type UserDepartmentGroupDepartmentIdForeignConnectionUserDepartmentGroupCreateInput = {
  company?: InputMaybe<UserDepartmentGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInput>;
  group?: InputMaybe<UserDepartmentGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserDepartmentGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `department` in the `UserDepartmentGroupInput` mutation. */
export type UserDepartmentGroupDepartmentIdForeignInput = {
  /** The primary key(s) for `department` for the far side of the relationship. */
  connectById?: InputMaybe<DepartmentDepartmentPkeyConnect>;
  /** A `DepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserDepartmentGroupDepartmentIdForeignConnectionDepartmentCreateInput>;
  /** The primary key(s) and patch data for `department` for the far side of the relationship. */
  updateById?: InputMaybe<DepartmentOnUserDepartmentGroupForUserDepartmentGroupDepartmentIdForeignUsingDepartmentPkeyUpdate>;
};

/** Input for the nested mutation of `userDepartmentGroup` in the `DepartmentInput` mutation. */
export type UserDepartmentGroupDepartmentIdForeignInverseInput = {
  /** The primary key(s) for `userDepartmentGroup` for the far side of the relationship. */
  connectByUserIdAndDepartmentIdAndGroupId?: InputMaybe<Array<UserDepartmentGroupUserDepartmentGroupPkeyConnect>>;
  /** A `UserDepartmentGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserDepartmentGroupDepartmentIdForeignConnectionUserDepartmentGroupCreateInput>>;
  /** The primary key(s) for `userDepartmentGroup` for the far side of the relationship. */
  deleteByUserIdAndDepartmentIdAndGroupId?: InputMaybe<Array<UserDepartmentGroupUserDepartmentGroupPkeyDelete>>;
  /** Flag indicating whether all other `userDepartmentGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userDepartmentGroup` for the far side of the relationship. */
  updateByUserIdAndDepartmentIdAndGroupId?: InputMaybe<Array<UserDepartmentGroupOnUserDepartmentGroupForUserDepartmentGroupDepartmentIdForeignUsingUserDepartmentGroupPkeyUpdate>>;
};

/** A filter to be used against `UserDepartmentGroup` object types. All fields are combined with a logical ‘and.’ */
export type UserDepartmentGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserDepartmentGroupFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `department` relation. */
  department?: InputMaybe<DepartmentFilter>;
  /** Filter by the object’s `departmentId` field. */
  departmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `group` relation. */
  group?: InputMaybe<GroupFilter>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `inheritToDescendants` field. */
  inheritToDescendants?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserDepartmentGroupFilter>;
  /** Filter by the object’s `onlyIncludeInDescendants` field. */
  onlyIncludeInDescendants?: InputMaybe<BooleanFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserDepartmentGroupFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The `group` to be created by this mutation. */
export type UserDepartmentGroupGroupIdForeignConnectionGroupCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppTableGroupIdFkInverseInput>;
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  autoInherit?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  copyFromGroupId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientGroupIdForeignInverseInput>;
  scope?: InputMaybe<RoleScope>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupGroupIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupGroupIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupGroupIdForeignInverseInput>;
};

/** The `userDepartmentGroup` to be created by this mutation. */
export type UserDepartmentGroupGroupIdForeignConnectionUserDepartmentGroupCreateInput = {
  company?: InputMaybe<UserDepartmentGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<UserDepartmentGroupGroupIdForeignInput>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserDepartmentGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `group` in the `UserDepartmentGroupInput` mutation. */
export type UserDepartmentGroupGroupIdForeignInput = {
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectById?: InputMaybe<GroupGroupPkeyConnect>;
  /** A `GroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserDepartmentGroupGroupIdForeignConnectionGroupCreateInput>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateById?: InputMaybe<GroupOnUserDepartmentGroupForUserDepartmentGroupGroupIdForeignUsingGroupPkeyUpdate>;
};

/** Input for the nested mutation of `userDepartmentGroup` in the `GroupInput` mutation. */
export type UserDepartmentGroupGroupIdForeignInverseInput = {
  /** The primary key(s) for `userDepartmentGroup` for the far side of the relationship. */
  connectByUserIdAndDepartmentIdAndGroupId?: InputMaybe<Array<UserDepartmentGroupUserDepartmentGroupPkeyConnect>>;
  /** A `UserDepartmentGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserDepartmentGroupGroupIdForeignConnectionUserDepartmentGroupCreateInput>>;
  /** The primary key(s) for `userDepartmentGroup` for the far side of the relationship. */
  deleteByUserIdAndDepartmentIdAndGroupId?: InputMaybe<Array<UserDepartmentGroupUserDepartmentGroupPkeyDelete>>;
  /** Flag indicating whether all other `userDepartmentGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userDepartmentGroup` for the far side of the relationship. */
  updateByUserIdAndDepartmentIdAndGroupId?: InputMaybe<Array<UserDepartmentGroupOnUserDepartmentGroupForUserDepartmentGroupGroupIdForeignUsingUserDepartmentGroupPkeyUpdate>>;
};

/** An input for mutations affecting `UserDepartmentGroup` */
export type UserDepartmentGroupInput = {
  company?: InputMaybe<UserDepartmentGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<UserDepartmentGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserDepartmentGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `userDepartmentGroup` to look up the row to update. */
export type UserDepartmentGroupOnUserDepartmentGroupForUserDepartmentGroupCompanyIdForeignUsingUserDepartmentGroupPkeyUpdate = {
  departmentId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userDepartmentGroup` being updated. */
  patch: UpdateUserDepartmentGroupOnUserDepartmentGroupForUserDepartmentGroupCompanyIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `userDepartmentGroup` to look up the row to update. */
export type UserDepartmentGroupOnUserDepartmentGroupForUserDepartmentGroupDepartmentIdForeignUsingUserDepartmentGroupPkeyUpdate = {
  departmentId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userDepartmentGroup` being updated. */
  patch: UpdateUserDepartmentGroupOnUserDepartmentGroupForUserDepartmentGroupDepartmentIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `userDepartmentGroup` to look up the row to update. */
export type UserDepartmentGroupOnUserDepartmentGroupForUserDepartmentGroupGroupIdForeignUsingUserDepartmentGroupPkeyUpdate = {
  departmentId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userDepartmentGroup` being updated. */
  patch: UpdateUserDepartmentGroupOnUserDepartmentGroupForUserDepartmentGroupGroupIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `userDepartmentGroup` to look up the row to update. */
export type UserDepartmentGroupOnUserDepartmentGroupForUserDepartmentGroupUserIdForeignUsingUserDepartmentGroupPkeyUpdate = {
  departmentId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userDepartmentGroup` being updated. */
  patch: UpdateUserDepartmentGroupOnUserDepartmentGroupForUserDepartmentGroupUserIdForeignPatch;
  userId: Scalars['UUID'];
};

/** Represents an update to a `UserDepartmentGroup`. Fields that are set will be updated. */
export type UserDepartmentGroupPatch = {
  company?: InputMaybe<UserDepartmentGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<UserDepartmentGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserDepartmentGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `userDepartmentGroup` to look up the row to connect. */
export type UserDepartmentGroupUserDepartmentGroupPkeyConnect = {
  departmentId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `userDepartmentGroup` to look up the row to delete. */
export type UserDepartmentGroupUserDepartmentGroupPkeyDelete = {
  departmentId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The `userDepartmentGroup` to be created by this mutation. */
export type UserDepartmentGroupUserIdForeignConnectionUserDepartmentGroupCreateInput = {
  company?: InputMaybe<UserDepartmentGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<UserDepartmentGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserDepartmentGroupUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `UserDepartmentGroupInput` mutation. */
export type UserDepartmentGroupUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserDepartmentGroupForUserDepartmentGroupUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `userDepartmentGroup` in the `UserInput` mutation. */
export type UserDepartmentGroupUserIdForeignInverseInput = {
  /** The primary key(s) for `userDepartmentGroup` for the far side of the relationship. */
  connectByUserIdAndDepartmentIdAndGroupId?: InputMaybe<Array<UserDepartmentGroupUserDepartmentGroupPkeyConnect>>;
  /** A `UserDepartmentGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserDepartmentGroupUserIdForeignConnectionUserDepartmentGroupCreateInput>>;
  /** The primary key(s) for `userDepartmentGroup` for the far side of the relationship. */
  deleteByUserIdAndDepartmentIdAndGroupId?: InputMaybe<Array<UserDepartmentGroupUserDepartmentGroupPkeyDelete>>;
  /** Flag indicating whether all other `userDepartmentGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userDepartmentGroup` for the far side of the relationship. */
  updateByUserIdAndDepartmentIdAndGroupId?: InputMaybe<Array<UserDepartmentGroupOnUserDepartmentGroupForUserDepartmentGroupUserIdForeignUsingUserDepartmentGroupPkeyUpdate>>;
};

/** A connection to a list of `UserDepartmentGroup` values. */
export type UserDepartmentGroupsConnection = {
  __typename?: 'UserDepartmentGroupsConnection';
  /** A list of edges which contains the `UserDepartmentGroup` and cursor to aid in pagination. */
  edges: Array<UserDepartmentGroupsEdge>;
  /** A list of `UserDepartmentGroup` objects. */
  nodes: Array<Maybe<UserDepartmentGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserDepartmentGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserDepartmentGroup` edge in the connection. */
export type UserDepartmentGroupsEdge = {
  __typename?: 'UserDepartmentGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserDepartmentGroup` at the end of the edge. */
  node?: Maybe<UserDepartmentGroup>;
};

/** Methods to use when ordering `UserDepartmentGroup`. */
export type UserDepartmentGroupsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ACTIVE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ACTIVE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ADDRESS_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ADDRESS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ALIAS_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ALIAS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CITY_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CITY_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COMPANY_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COMPANY_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COUNTRY_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COUNTRY_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CREATED_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CREATED_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CUSTOM_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CUSTOM_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CVR_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CVR_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DELETE_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DELETE_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_NUMBER_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_NUMBER_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DESCRIPTION_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DESCRIPTION_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EAN_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EAN_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EMAIL_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EMAIL_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__MAIN_DEPARTMENT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__MAIN_DEPARTMENT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__NAME_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__NAME_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PHONE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PHONE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__POSTAL_CODE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__POSTAL_CODE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__P_NUMBER_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__P_NUMBER_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__UPDATED_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__UPDATED_AT_DESC'
  | 'DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_ID_DESC'
  | 'GROUP_BY_GROUP_ID__ACTIVE_ASC'
  | 'GROUP_BY_GROUP_ID__ACTIVE_DESC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_ASC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_DESC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_NEW_PERMISSIONS_ASC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_NEW_PERMISSIONS_DESC'
  | 'GROUP_BY_GROUP_ID__AUTO_INHERIT_ASC'
  | 'GROUP_BY_GROUP_ID__AUTO_INHERIT_DESC'
  | 'GROUP_BY_GROUP_ID__COMPANY_ID_ASC'
  | 'GROUP_BY_GROUP_ID__COMPANY_ID_DESC'
  | 'GROUP_BY_GROUP_ID__DESCRIPTION_ASC'
  | 'GROUP_BY_GROUP_ID__DESCRIPTION_DESC'
  | 'GROUP_BY_GROUP_ID__ID_ASC'
  | 'GROUP_BY_GROUP_ID__ID_DESC'
  | 'GROUP_BY_GROUP_ID__LOCALIZED_NAME_ASC'
  | 'GROUP_BY_GROUP_ID__LOCALIZED_NAME_DESC'
  | 'GROUP_BY_GROUP_ID__NAME_ASC'
  | 'GROUP_BY_GROUP_ID__NAME_DESC'
  | 'GROUP_BY_GROUP_ID__SCOPE_ASC'
  | 'GROUP_BY_GROUP_ID__SCOPE_DESC'
  | 'GROUP_ID_ASC'
  | 'GROUP_ID_DESC'
  | 'INHERIT_TO_DESCENDANTS_ASC'
  | 'INHERIT_TO_DESCENDANTS_DESC'
  | 'NATURAL'
  | 'ONLY_INCLUDE_IN_DESCENDANTS_ASC'
  | 'ONLY_INCLUDE_IN_DESCENDANTS_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** An input for mutations affecting `UserDepartment` */
export type UserDepartmentInput = {
  company?: InputMaybe<UserDepartmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  parentUserDepartmentId?: InputMaybe<Scalars['UUID']>;
  rank?: InputMaybe<UserDepartmentRankIdForeignInput>;
  rankId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserDepartmentUserIdForeignInput>;
  userDepartment?: InputMaybe<UserDepartmentParentUserDepartmentIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `userDepartment` to look up the row to update. */
export type UserDepartmentOnUserDepartmentForUserDepartmentCompanyIdFkeyUsingUserDepartmentDepartmentIdUserIdUniqueUpdate = {
  departmentId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userDepartment` being updated. */
  patch: UpdateUserDepartmentOnUserDepartmentForUserDepartmentCompanyIdFkeyPatch;
  userId: Scalars['UUID'];
};

/** The fields on `userDepartment` to look up the row to update. */
export type UserDepartmentOnUserDepartmentForUserDepartmentCompanyIdFkeyUsingUserDepartmentIdUniqueUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userDepartment` being updated. */
  patch: UpdateUserDepartmentOnUserDepartmentForUserDepartmentCompanyIdFkeyPatch;
};

/** The fields on `userDepartment` to look up the row to update. */
export type UserDepartmentOnUserDepartmentForUserDepartmentDepartmentIdForeignUsingUserDepartmentDepartmentIdUserIdUniqueUpdate = {
  departmentId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userDepartment` being updated. */
  patch: UpdateUserDepartmentOnUserDepartmentForUserDepartmentDepartmentIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `userDepartment` to look up the row to update. */
export type UserDepartmentOnUserDepartmentForUserDepartmentDepartmentIdForeignUsingUserDepartmentIdUniqueUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userDepartment` being updated. */
  patch: UpdateUserDepartmentOnUserDepartmentForUserDepartmentDepartmentIdForeignPatch;
};

/** The fields on `userDepartment` to look up the row to update. */
export type UserDepartmentOnUserDepartmentForUserDepartmentParentUserDepartmentIdForeignUsingUserDepartmentDepartmentIdUserIdUniqueUpdate = {
  departmentId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userDepartment` being updated. */
  patch: UpdateUserDepartmentOnUserDepartmentForUserDepartmentParentUserDepartmentIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `userDepartment` to look up the row to update. */
export type UserDepartmentOnUserDepartmentForUserDepartmentParentUserDepartmentIdForeignUsingUserDepartmentIdUniqueUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userDepartment` being updated. */
  patch: UpdateUserDepartmentOnUserDepartmentForUserDepartmentParentUserDepartmentIdForeignPatch;
};

/** The fields on `userDepartment` to look up the row to update. */
export type UserDepartmentOnUserDepartmentForUserDepartmentRankIdForeignUsingUserDepartmentDepartmentIdUserIdUniqueUpdate = {
  departmentId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userDepartment` being updated. */
  patch: UpdateUserDepartmentOnUserDepartmentForUserDepartmentRankIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `userDepartment` to look up the row to update. */
export type UserDepartmentOnUserDepartmentForUserDepartmentRankIdForeignUsingUserDepartmentIdUniqueUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userDepartment` being updated. */
  patch: UpdateUserDepartmentOnUserDepartmentForUserDepartmentRankIdForeignPatch;
};

/** The fields on `userDepartment` to look up the row to update. */
export type UserDepartmentOnUserDepartmentForUserDepartmentUserIdForeignUsingUserDepartmentDepartmentIdUserIdUniqueUpdate = {
  departmentId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userDepartment` being updated. */
  patch: UpdateUserDepartmentOnUserDepartmentForUserDepartmentUserIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `userDepartment` to look up the row to update. */
export type UserDepartmentOnUserDepartmentForUserDepartmentUserIdForeignUsingUserDepartmentIdUniqueUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userDepartment` being updated. */
  patch: UpdateUserDepartmentOnUserDepartmentForUserDepartmentUserIdForeignPatch;
};

/** The `userDepartment` to be created by this mutation. */
export type UserDepartmentParentUserDepartmentIdForeignConnectionUserDepartmentCreateInput = {
  company?: InputMaybe<UserDepartmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  rank?: InputMaybe<UserDepartmentRankIdForeignInput>;
  rankId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserDepartmentUserIdForeignInput>;
  userDepartment?: InputMaybe<UserDepartmentParentUserDepartmentIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `userDepartment` in the `UserDepartmentInput` mutation. */
export type UserDepartmentParentUserDepartmentIdForeignInput = {
  /** The primary key(s) for `userDepartment` for the far side of the relationship. */
  connectByDepartmentIdAndUserId?: InputMaybe<UserDepartmentUserDepartmentDepartmentIdUserIdUniqueConnect>;
  /** The primary key(s) for `userDepartment` for the far side of the relationship. */
  connectById?: InputMaybe<UserDepartmentUserDepartmentIdUniqueConnect>;
  /** A `UserDepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserDepartmentParentUserDepartmentIdForeignConnectionUserDepartmentCreateInput>;
  /** The primary key(s) and patch data for `userDepartment` for the far side of the relationship. */
  updateByDepartmentIdAndUserId?: InputMaybe<UserDepartmentOnUserDepartmentForUserDepartmentParentUserDepartmentIdForeignUsingUserDepartmentDepartmentIdUserIdUniqueUpdate>;
  /** The primary key(s) and patch data for `userDepartment` for the far side of the relationship. */
  updateById?: InputMaybe<UserDepartmentOnUserDepartmentForUserDepartmentParentUserDepartmentIdForeignUsingUserDepartmentIdUniqueUpdate>;
};

/** Represents an update to a `UserDepartment`. Fields that are set will be updated. */
export type UserDepartmentPatch = {
  company?: InputMaybe<UserDepartmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  parentUserDepartmentId?: InputMaybe<Scalars['UUID']>;
  rank?: InputMaybe<UserDepartmentRankIdForeignInput>;
  rankId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserDepartmentUserIdForeignInput>;
  userDepartment?: InputMaybe<UserDepartmentParentUserDepartmentIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `userDepartment` to be created by this mutation. */
export type UserDepartmentRankIdForeignConnectionUserDepartmentCreateInput = {
  company?: InputMaybe<UserDepartmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  parentUserDepartmentId?: InputMaybe<Scalars['UUID']>;
  rank?: InputMaybe<UserDepartmentRankIdForeignInput>;
  user?: InputMaybe<UserDepartmentUserIdForeignInput>;
  userDepartment?: InputMaybe<UserDepartmentParentUserDepartmentIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `rank` in the `UserDepartmentInput` mutation. */
export type UserDepartmentRankIdForeignInput = {
  /** The primary key(s) for `rank` for the far side of the relationship. */
  connectById?: InputMaybe<RankRankPkeyConnect>;
  /** The primary key(s) and patch data for `rank` for the far side of the relationship. */
  updateById?: InputMaybe<RankOnUserDepartmentForUserDepartmentRankIdForeignUsingRankPkeyUpdate>;
};

/** Input for the nested mutation of `userDepartment` in the `RankInput` mutation. */
export type UserDepartmentRankIdForeignInverseInput = {
  /** The primary key(s) for `userDepartment` for the far side of the relationship. */
  connectByDepartmentIdAndUserId?: InputMaybe<Array<UserDepartmentUserDepartmentDepartmentIdUserIdUniqueConnect>>;
  /** The primary key(s) for `userDepartment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserDepartmentUserDepartmentIdUniqueConnect>>;
  /** A `UserDepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserDepartmentRankIdForeignConnectionUserDepartmentCreateInput>>;
  /** The primary key(s) and patch data for `userDepartment` for the far side of the relationship. */
  updateByDepartmentIdAndUserId?: InputMaybe<Array<UserDepartmentOnUserDepartmentForUserDepartmentRankIdForeignUsingUserDepartmentDepartmentIdUserIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `userDepartment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserDepartmentOnUserDepartmentForUserDepartmentRankIdForeignUsingUserDepartmentIdUniqueUpdate>>;
};

export type UserDepartmentRole = {
  __typename?: 'UserDepartmentRole';
  /** Reads a single `Company` that is related to this `UserDepartmentRole`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `Department` that is related to this `UserDepartmentRole`. */
  department?: Maybe<Department>;
  departmentId: Scalars['UUID'];
  excludeRole: Scalars['Boolean'];
  inheritToDescendants: Scalars['Boolean'];
  itemIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  onlyIncludeInDescendants: Scalars['Boolean'];
  /** Reads a single `Role` that is related to this `UserDepartmentRole`. */
  role?: Maybe<Role>;
  roleId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `UserDepartmentRole`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The `userDepartmentRole` to be created by this mutation. */
export type UserDepartmentRoleCompanyIdForeignConnectionUserDepartmentRoleCreateInput = {
  company?: InputMaybe<UserDepartmentRoleCompanyIdForeignInput>;
  department?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<UserDepartmentRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserDepartmentRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `UserDepartmentRoleInput` mutation. */
export type UserDepartmentRoleCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnUserDepartmentRoleForUserDepartmentRoleCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `userDepartmentRole` in the `CompanyInput` mutation. */
export type UserDepartmentRoleCompanyIdForeignInverseInput = {
  /** The primary key(s) for `userDepartmentRole` for the far side of the relationship. */
  connectByUserIdAndDepartmentIdAndRoleId?: InputMaybe<Array<UserDepartmentRoleUserDepartmentRolePkeyConnect>>;
  /** A `UserDepartmentRoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserDepartmentRoleCompanyIdForeignConnectionUserDepartmentRoleCreateInput>>;
  /** The primary key(s) for `userDepartmentRole` for the far side of the relationship. */
  deleteByUserIdAndDepartmentIdAndRoleId?: InputMaybe<Array<UserDepartmentRoleUserDepartmentRolePkeyDelete>>;
  /** Flag indicating whether all other `userDepartmentRole` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userDepartmentRole` for the far side of the relationship. */
  updateByUserIdAndDepartmentIdAndRoleId?: InputMaybe<Array<UserDepartmentRoleOnUserDepartmentRoleForUserDepartmentRoleCompanyIdForeignUsingUserDepartmentRolePkeyUpdate>>;
};

/**
 * A condition to be used against `UserDepartmentRole` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserDepartmentRoleCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departmentId` field. */
  departmentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `excludeRole` field. */
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `inheritToDescendants` field. */
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `itemIds` field. */
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `onlyIncludeInDescendants` field. */
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `roleId` field. */
  roleId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `department` to be created by this mutation. */
export type UserDepartmentRoleDepartmentIdForeignConnectionDepartmentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** The `userDepartmentRole` to be created by this mutation. */
export type UserDepartmentRoleDepartmentIdForeignConnectionUserDepartmentRoleCreateInput = {
  company?: InputMaybe<UserDepartmentRoleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInput>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<UserDepartmentRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserDepartmentRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `department` in the `UserDepartmentRoleInput` mutation. */
export type UserDepartmentRoleDepartmentIdForeignInput = {
  /** The primary key(s) for `department` for the far side of the relationship. */
  connectById?: InputMaybe<DepartmentDepartmentPkeyConnect>;
  /** A `DepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserDepartmentRoleDepartmentIdForeignConnectionDepartmentCreateInput>;
  /** The primary key(s) and patch data for `department` for the far side of the relationship. */
  updateById?: InputMaybe<DepartmentOnUserDepartmentRoleForUserDepartmentRoleDepartmentIdForeignUsingDepartmentPkeyUpdate>;
};

/** Input for the nested mutation of `userDepartmentRole` in the `DepartmentInput` mutation. */
export type UserDepartmentRoleDepartmentIdForeignInverseInput = {
  /** The primary key(s) for `userDepartmentRole` for the far side of the relationship. */
  connectByUserIdAndDepartmentIdAndRoleId?: InputMaybe<Array<UserDepartmentRoleUserDepartmentRolePkeyConnect>>;
  /** A `UserDepartmentRoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserDepartmentRoleDepartmentIdForeignConnectionUserDepartmentRoleCreateInput>>;
  /** The primary key(s) for `userDepartmentRole` for the far side of the relationship. */
  deleteByUserIdAndDepartmentIdAndRoleId?: InputMaybe<Array<UserDepartmentRoleUserDepartmentRolePkeyDelete>>;
  /** Flag indicating whether all other `userDepartmentRole` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userDepartmentRole` for the far side of the relationship. */
  updateByUserIdAndDepartmentIdAndRoleId?: InputMaybe<Array<UserDepartmentRoleOnUserDepartmentRoleForUserDepartmentRoleDepartmentIdForeignUsingUserDepartmentRolePkeyUpdate>>;
};

/** A filter to be used against `UserDepartmentRole` object types. All fields are combined with a logical ‘and.’ */
export type UserDepartmentRoleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserDepartmentRoleFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `department` relation. */
  department?: InputMaybe<DepartmentFilter>;
  /** Filter by the object’s `departmentId` field. */
  departmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `excludeRole` field. */
  excludeRole?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `inheritToDescendants` field. */
  inheritToDescendants?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `itemIds` field. */
  itemIds?: InputMaybe<UuidListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserDepartmentRoleFilter>;
  /** Filter by the object’s `onlyIncludeInDescendants` field. */
  onlyIncludeInDescendants?: InputMaybe<BooleanFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserDepartmentRoleFilter>>;
  /** Filter by the object’s `role` relation. */
  role?: InputMaybe<RoleFilter>;
  /** Filter by the object’s `roleId` field. */
  roleId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `UserDepartmentRole` */
export type UserDepartmentRoleInput = {
  company?: InputMaybe<UserDepartmentRoleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<UserDepartmentRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserDepartmentRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `userDepartmentRole` to look up the row to update. */
export type UserDepartmentRoleOnUserDepartmentRoleForUserDepartmentRoleCompanyIdForeignUsingUserDepartmentRolePkeyUpdate = {
  departmentId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userDepartmentRole` being updated. */
  patch: UpdateUserDepartmentRoleOnUserDepartmentRoleForUserDepartmentRoleCompanyIdForeignPatch;
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `userDepartmentRole` to look up the row to update. */
export type UserDepartmentRoleOnUserDepartmentRoleForUserDepartmentRoleDepartmentIdForeignUsingUserDepartmentRolePkeyUpdate = {
  departmentId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userDepartmentRole` being updated. */
  patch: UpdateUserDepartmentRoleOnUserDepartmentRoleForUserDepartmentRoleDepartmentIdForeignPatch;
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `userDepartmentRole` to look up the row to update. */
export type UserDepartmentRoleOnUserDepartmentRoleForUserDepartmentRoleRoleIdForeignUsingUserDepartmentRolePkeyUpdate = {
  departmentId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userDepartmentRole` being updated. */
  patch: UpdateUserDepartmentRoleOnUserDepartmentRoleForUserDepartmentRoleRoleIdForeignPatch;
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `userDepartmentRole` to look up the row to update. */
export type UserDepartmentRoleOnUserDepartmentRoleForUserDepartmentRoleUserIdForeignUsingUserDepartmentRolePkeyUpdate = {
  departmentId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userDepartmentRole` being updated. */
  patch: UpdateUserDepartmentRoleOnUserDepartmentRoleForUserDepartmentRoleUserIdForeignPatch;
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** Represents an update to a `UserDepartmentRole`. Fields that are set will be updated. */
export type UserDepartmentRolePatch = {
  company?: InputMaybe<UserDepartmentRoleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<UserDepartmentRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserDepartmentRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `role` to be created by this mutation. */
export type UserDepartmentRoleRoleIdForeignConnectionRoleCreateInput = {
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleRoleIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  info: Scalars['String'];
  name: Scalars['String'];
  relationRoles?: InputMaybe<RelationRoleRoleIdForeignInverseInput>;
  roleDependenciesToDependentOnUsingId?: InputMaybe<RoleDependencyDependentOnForeignInverseInput>;
  roleDependenciesToRoleIdUsingId?: InputMaybe<RoleDependencyRoleIdForeignInverseInput>;
  scopes?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleRoleIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleRoleIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleRoleIdForeignInverseInput>;
  usesItemIds?: InputMaybe<Scalars['Boolean']>;
};

/** The `userDepartmentRole` to be created by this mutation. */
export type UserDepartmentRoleRoleIdForeignConnectionUserDepartmentRoleCreateInput = {
  company?: InputMaybe<UserDepartmentRoleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<UserDepartmentRoleRoleIdForeignInput>;
  user?: InputMaybe<UserDepartmentRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `role` in the `UserDepartmentRoleInput` mutation. */
export type UserDepartmentRoleRoleIdForeignInput = {
  /** The primary key(s) for `role` for the far side of the relationship. */
  connectById?: InputMaybe<RoleRolePkeyConnect>;
  /** A `RoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserDepartmentRoleRoleIdForeignConnectionRoleCreateInput>;
  /** The primary key(s) for `role` for the far side of the relationship. */
  deleteById?: InputMaybe<RoleRolePkeyDelete>;
  /** The primary key(s) and patch data for `role` for the far side of the relationship. */
  updateById?: InputMaybe<RoleOnUserDepartmentRoleForUserDepartmentRoleRoleIdForeignUsingRolePkeyUpdate>;
};

/** Input for the nested mutation of `userDepartmentRole` in the `RoleInput` mutation. */
export type UserDepartmentRoleRoleIdForeignInverseInput = {
  /** The primary key(s) for `userDepartmentRole` for the far side of the relationship. */
  connectByUserIdAndDepartmentIdAndRoleId?: InputMaybe<Array<UserDepartmentRoleUserDepartmentRolePkeyConnect>>;
  /** A `UserDepartmentRoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserDepartmentRoleRoleIdForeignConnectionUserDepartmentRoleCreateInput>>;
  /** The primary key(s) for `userDepartmentRole` for the far side of the relationship. */
  deleteByUserIdAndDepartmentIdAndRoleId?: InputMaybe<Array<UserDepartmentRoleUserDepartmentRolePkeyDelete>>;
  /** Flag indicating whether all other `userDepartmentRole` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userDepartmentRole` for the far side of the relationship. */
  updateByUserIdAndDepartmentIdAndRoleId?: InputMaybe<Array<UserDepartmentRoleOnUserDepartmentRoleForUserDepartmentRoleRoleIdForeignUsingUserDepartmentRolePkeyUpdate>>;
};

/** The fields on `userDepartmentRole` to look up the row to connect. */
export type UserDepartmentRoleUserDepartmentRolePkeyConnect = {
  departmentId: Scalars['UUID'];
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `userDepartmentRole` to look up the row to delete. */
export type UserDepartmentRoleUserDepartmentRolePkeyDelete = {
  departmentId: Scalars['UUID'];
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The `userDepartmentRole` to be created by this mutation. */
export type UserDepartmentRoleUserIdForeignConnectionUserDepartmentRoleCreateInput = {
  company?: InputMaybe<UserDepartmentRoleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<UserDepartmentRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserDepartmentRoleUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `UserDepartmentRoleInput` mutation. */
export type UserDepartmentRoleUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserDepartmentRoleForUserDepartmentRoleUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `userDepartmentRole` in the `UserInput` mutation. */
export type UserDepartmentRoleUserIdForeignInverseInput = {
  /** The primary key(s) for `userDepartmentRole` for the far side of the relationship. */
  connectByUserIdAndDepartmentIdAndRoleId?: InputMaybe<Array<UserDepartmentRoleUserDepartmentRolePkeyConnect>>;
  /** A `UserDepartmentRoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserDepartmentRoleUserIdForeignConnectionUserDepartmentRoleCreateInput>>;
  /** The primary key(s) for `userDepartmentRole` for the far side of the relationship. */
  deleteByUserIdAndDepartmentIdAndRoleId?: InputMaybe<Array<UserDepartmentRoleUserDepartmentRolePkeyDelete>>;
  /** Flag indicating whether all other `userDepartmentRole` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userDepartmentRole` for the far side of the relationship. */
  updateByUserIdAndDepartmentIdAndRoleId?: InputMaybe<Array<UserDepartmentRoleOnUserDepartmentRoleForUserDepartmentRoleUserIdForeignUsingUserDepartmentRolePkeyUpdate>>;
};

/** A connection to a list of `UserDepartmentRole` values. */
export type UserDepartmentRolesConnection = {
  __typename?: 'UserDepartmentRolesConnection';
  /** A list of edges which contains the `UserDepartmentRole` and cursor to aid in pagination. */
  edges: Array<UserDepartmentRolesEdge>;
  /** A list of `UserDepartmentRole` objects. */
  nodes: Array<Maybe<UserDepartmentRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserDepartmentRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserDepartmentRole` edge in the connection. */
export type UserDepartmentRolesEdge = {
  __typename?: 'UserDepartmentRolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserDepartmentRole` at the end of the edge. */
  node?: Maybe<UserDepartmentRole>;
};

/** Methods to use when ordering `UserDepartmentRole`. */
export type UserDepartmentRolesOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ACTIVE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ACTIVE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ADDRESS_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ADDRESS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ALIAS_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ALIAS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CITY_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CITY_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COMPANY_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COMPANY_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COUNTRY_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COUNTRY_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CREATED_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CREATED_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CUSTOM_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CUSTOM_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CVR_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CVR_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DELETE_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DELETE_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_NUMBER_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_NUMBER_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DESCRIPTION_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DESCRIPTION_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EAN_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EAN_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EMAIL_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EMAIL_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__MAIN_DEPARTMENT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__MAIN_DEPARTMENT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__NAME_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__NAME_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PHONE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PHONE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__POSTAL_CODE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__POSTAL_CODE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__P_NUMBER_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__P_NUMBER_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__UPDATED_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__UPDATED_AT_DESC'
  | 'DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_ID_DESC'
  | 'EXCLUDE_ROLE_ASC'
  | 'EXCLUDE_ROLE_DESC'
  | 'INHERIT_TO_DESCENDANTS_ASC'
  | 'INHERIT_TO_DESCENDANTS_DESC'
  | 'ITEM_IDS_ASC'
  | 'ITEM_IDS_DESC'
  | 'NATURAL'
  | 'ONLY_INCLUDE_IN_DESCENDANTS_ASC'
  | 'ONLY_INCLUDE_IN_DESCENDANTS_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROLE_BY_ROLE_ID__COMPANY_ID_ASC'
  | 'ROLE_BY_ROLE_ID__COMPANY_ID_DESC'
  | 'ROLE_BY_ROLE_ID__DESCRIPTION_ASC'
  | 'ROLE_BY_ROLE_ID__DESCRIPTION_DESC'
  | 'ROLE_BY_ROLE_ID__ID_ASC'
  | 'ROLE_BY_ROLE_ID__ID_DESC'
  | 'ROLE_BY_ROLE_ID__INFO_ASC'
  | 'ROLE_BY_ROLE_ID__INFO_DESC'
  | 'ROLE_BY_ROLE_ID__NAME_ASC'
  | 'ROLE_BY_ROLE_ID__NAME_DESC'
  | 'ROLE_BY_ROLE_ID__SCOPES_ASC'
  | 'ROLE_BY_ROLE_ID__SCOPES_DESC'
  | 'ROLE_BY_ROLE_ID__USES_ITEM_IDS_ASC'
  | 'ROLE_BY_ROLE_ID__USES_ITEM_IDS_DESC'
  | 'ROLE_ID_ASC'
  | 'ROLE_ID_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** A filter to be used against many `UserDepartment` object types. All fields are combined with a logical ‘and.’ */
export type UserDepartmentToManyUserDepartmentFilter = {
  /** Every related `UserDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserDepartmentFilter>;
  /** No related `UserDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserDepartmentFilter>;
  /** Some related `UserDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserDepartmentFilter>;
};

/** The fields on `userDepartment` to look up the row to connect. */
export type UserDepartmentUserDepartmentDepartmentIdUserIdUniqueConnect = {
  departmentId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `userDepartment` to look up the row to connect. */
export type UserDepartmentUserDepartmentIdUniqueConnect = {
  id: Scalars['UUID'];
};

/** The `userDepartment` to be created by this mutation. */
export type UserDepartmentUserIdForeignConnectionUserDepartmentCreateInput = {
  company?: InputMaybe<UserDepartmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  parentUserDepartmentId?: InputMaybe<Scalars['UUID']>;
  rank?: InputMaybe<UserDepartmentRankIdForeignInput>;
  rankId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserDepartmentUserIdForeignInput>;
  userDepartment?: InputMaybe<UserDepartmentParentUserDepartmentIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `UserDepartmentInput` mutation. */
export type UserDepartmentUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserDepartmentForUserDepartmentUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `userDepartment` in the `UserInput` mutation. */
export type UserDepartmentUserIdForeignInverseInput = {
  /** The primary key(s) for `userDepartment` for the far side of the relationship. */
  connectByDepartmentIdAndUserId?: InputMaybe<Array<UserDepartmentUserDepartmentDepartmentIdUserIdUniqueConnect>>;
  /** The primary key(s) for `userDepartment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserDepartmentUserDepartmentIdUniqueConnect>>;
  /** A `UserDepartmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserDepartmentUserIdForeignConnectionUserDepartmentCreateInput>>;
  /** The primary key(s) and patch data for `userDepartment` for the far side of the relationship. */
  updateByDepartmentIdAndUserId?: InputMaybe<Array<UserDepartmentOnUserDepartmentForUserDepartmentUserIdForeignUsingUserDepartmentDepartmentIdUserIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `userDepartment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserDepartmentOnUserDepartmentForUserDepartmentUserIdForeignUsingUserDepartmentIdUniqueUpdate>>;
};

/** A connection to a list of `UserDepartment` values. */
export type UserDepartmentsConnection = {
  __typename?: 'UserDepartmentsConnection';
  /** A list of edges which contains the `UserDepartment` and cursor to aid in pagination. */
  edges: Array<UserDepartmentsEdge>;
  /** A list of `UserDepartment` objects. */
  nodes: Array<Maybe<UserDepartment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserDepartment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserDepartment` edge in the connection. */
export type UserDepartmentsEdge = {
  __typename?: 'UserDepartmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserDepartment` at the end of the edge. */
  node?: Maybe<UserDepartment>;
};

/** Methods to use when ordering `UserDepartment`. */
export type UserDepartmentsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ACTIVE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ACTIVE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ADDRESS_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ADDRESS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ALIAS_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ALIAS_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CITY_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CITY_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COMPANY_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COMPANY_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COUNTRY_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__COUNTRY_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CREATED_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CREATED_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CUSTOM_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CUSTOM_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CVR_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__CVR_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DELETE_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DELETE_AT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_NUMBER_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_NUMBER_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DEPARTMENT_TYPE_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DESCRIPTION_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__DESCRIPTION_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EAN_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EAN_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EMAIL_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__EMAIL_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__MAIN_DEPARTMENT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__MAIN_DEPARTMENT_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__NAME_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__NAME_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PARENT_DEPARTMENT_ID_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PHONE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__PHONE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__POSTAL_CODE_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__POSTAL_CODE_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__P_NUMBER_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__P_NUMBER_DESC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__UPDATED_AT_ASC'
  | 'DEPARTMENT_BY_DEPARTMENT_ID__UPDATED_AT_DESC'
  | 'DEPARTMENT_ID_ASC'
  | 'DEPARTMENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PARENT_USER_DEPARTMENT_ID_ASC'
  | 'PARENT_USER_DEPARTMENT_ID_DESC'
  | 'RANK_BY_RANK_ID__ID_ASC'
  | 'RANK_BY_RANK_ID__ID_DESC'
  | 'RANK_BY_RANK_ID__NAME_ASC'
  | 'RANK_BY_RANK_ID__NAME_DESC'
  | 'RANK_ID_ASC'
  | 'RANK_ID_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_DEPARTMENTS_BY_PARENT_USER_DEPARTMENT_ID__COUNT_ASC'
  | 'USER_DEPARTMENTS_BY_PARENT_USER_DEPARTMENT_ID__COUNT_DESC'
  | 'USER_DEPARTMENT_BY_PARENT_USER_DEPARTMENT_ID__COMPANY_ID_ASC'
  | 'USER_DEPARTMENT_BY_PARENT_USER_DEPARTMENT_ID__COMPANY_ID_DESC'
  | 'USER_DEPARTMENT_BY_PARENT_USER_DEPARTMENT_ID__DEPARTMENT_ID_ASC'
  | 'USER_DEPARTMENT_BY_PARENT_USER_DEPARTMENT_ID__DEPARTMENT_ID_DESC'
  | 'USER_DEPARTMENT_BY_PARENT_USER_DEPARTMENT_ID__ID_ASC'
  | 'USER_DEPARTMENT_BY_PARENT_USER_DEPARTMENT_ID__ID_DESC'
  | 'USER_DEPARTMENT_BY_PARENT_USER_DEPARTMENT_ID__PARENT_USER_DEPARTMENT_ID_ASC'
  | 'USER_DEPARTMENT_BY_PARENT_USER_DEPARTMENT_ID__PARENT_USER_DEPARTMENT_ID_DESC'
  | 'USER_DEPARTMENT_BY_PARENT_USER_DEPARTMENT_ID__RANK_ID_ASC'
  | 'USER_DEPARTMENT_BY_PARENT_USER_DEPARTMENT_ID__RANK_ID_DESC'
  | 'USER_DEPARTMENT_BY_PARENT_USER_DEPARTMENT_ID__USER_ID_ASC'
  | 'USER_DEPARTMENT_BY_PARENT_USER_DEPARTMENT_ID__USER_ID_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type UserEmployeeFields =
  | 'ADDRESS'
  | 'ALTERNATE_FIRST_NAME'
  | 'ALTERNATE_LAST_NAME'
  | 'BANK_ACCOUNT_NUMBER'
  | 'BANK_REGISTRATION_NUMBER'
  | 'BIRTHDATE'
  | 'CITY'
  | 'COUNTRY'
  | 'CPR'
  | 'EMAIL'
  | 'EMAIL_WORK'
  | 'EMPLOYMENT_END'
  | 'EMPLOYMENT_JURISDICTION'
  | 'EMPLOYMENT_START'
  | 'FIRST_NAME'
  | 'INITIALS'
  | 'JOB_POSITION_DESCRIPTION'
  | 'JOB_POSITION_TITLE'
  | 'JOB_POSITION_TYPE'
  | 'JOB_POSITION_WORKING_HOURS'
  | 'LAST_NAME'
  | 'LOCALE'
  | 'MOBILE'
  | 'MOBILE_PRIVATE'
  | 'PHONE'
  | 'POSTAL_CODE'
  | 'PROFILE_IMAGE'
  | 'SENIORITY';

/** A filter to be used against UserEmployeeFields fields. All fields are combined with a logical ‘and.’ */
export type UserEmployeeFieldsFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserEmployeeFields>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserEmployeeFields>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserEmployeeFields>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserEmployeeFields>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserEmployeeFields>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserEmployeeFields>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserEmployeeFields>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserEmployeeFields>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserEmployeeFields>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserEmployeeFields>>;
};

/** Input for the nested mutation of `user` in the `EmployeeInput` mutation. */
export type UserEmployeeIdForeignInverseInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserUserPkeyConnect>>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserOnUserForUserEmployeeIdForeignUsingUserPkeyUpdate>>;
};

/** A filter to be used against `User` object types. All fields are combined with a logical ‘and.’ */
export type UserFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `address` field. */
  address?: InputMaybe<StringFilter>;
  /** Filter by the object’s `alternateFirstName` field. */
  alternateFirstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `alternateLastName` field. */
  alternateLastName?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `announcements` relation. */
  announcements?: InputMaybe<UserToManyAnnouncementFilter>;
  /** Some related `announcements` exist. */
  announcementsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `approvalsByAffectedUserId` relation. */
  approvalsByAffectedUserId?: InputMaybe<UserToManyApprovalFilter>;
  /** Some related `approvalsByAffectedUserId` exist. */
  approvalsByAffectedUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `approvalsByApprovingUserId` relation. */
  approvalsByApprovingUserId?: InputMaybe<UserToManyApprovalFilter>;
  /** Some related `approvalsByApprovingUserId` exist. */
  approvalsByApprovingUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `approvalsByRequestingUserId` relation. */
  approvalsByRequestingUserId?: InputMaybe<UserToManyApprovalFilter>;
  /** Some related `approvalsByRequestingUserId` exist. */
  approvalsByRequestingUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `asyncJobItems` relation. */
  asyncJobItems?: InputMaybe<UserToManyAsyncJobItemFilter>;
  /** Some related `asyncJobItems` exist. */
  asyncJobItemsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `asyncJobs` relation. */
  asyncJobs?: InputMaybe<UserToManyAsyncJobFilter>;
  /** Some related `asyncJobs` exist. */
  asyncJobsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `bankAccountNumber` field. */
  bankAccountNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `bankRegistrationNumber` field. */
  bankRegistrationNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `birthdate` field. */
  birthdate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `canLogin` field. */
  canLogin?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `canLoginApp` field. */
  canLoginApp?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `canLoginSso` field. */
  canLoginSso?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `canSignOnBehalfOf` field. */
  canSignOnBehalfOf?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `changelogUsers` relation. */
  changelogUsers?: InputMaybe<UserToManyChangelogUserFilter>;
  /** Some related `changelogUsers` exist. */
  changelogUsersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `chosenColumns` relation. */
  chosenColumns?: InputMaybe<UserToManyChosenColumnFilter>;
  /** Some related `chosenColumns` exist. */
  chosenColumnsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `city` field. */
  city?: InputMaybe<StringFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyAdmin` field. */
  companyAdmin?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `competenceIds` field. */
  competenceIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `contractSignPendingSigners` relation. */
  contractSignPendingSigners?: InputMaybe<UserToManyContractSignPendingSignerFilter>;
  /** Filter by the object’s `contractSignPendingSignersByOnBehalfOfUserId` relation. */
  contractSignPendingSignersByOnBehalfOfUserId?: InputMaybe<UserToManyContractSignPendingSignerFilter>;
  /** Some related `contractSignPendingSignersByOnBehalfOfUserId` exist. */
  contractSignPendingSignersByOnBehalfOfUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `contractSignPendingSigners` exist. */
  contractSignPendingSignersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractSignPendings` relation. */
  contractSignPendings?: InputMaybe<UserToManyContractSignPendingFilter>;
  /** Filter by the object’s `contractSignPendingsByCreatorUserId` relation. */
  contractSignPendingsByCreatorUserId?: InputMaybe<UserToManyContractSignPendingFilter>;
  /** Some related `contractSignPendingsByCreatorUserId` exist. */
  contractSignPendingsByCreatorUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractSignPendingsByNextSigningUserId` relation. */
  contractSignPendingsByNextSigningUserId?: InputMaybe<UserToManyContractSignPendingFilter>;
  /** Some related `contractSignPendingsByNextSigningUserId` exist. */
  contractSignPendingsByNextSigningUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `contractSignPendings` exist. */
  contractSignPendingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `contractTemplateUsers` relation. */
  contractTemplateUsers?: InputMaybe<UserToManyContractTemplateUserFilter>;
  /** Some related `contractTemplateUsers` exist. */
  contractTemplateUsersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `country` field. */
  country?: InputMaybe<StringFilter>;
  /** Filter by the object’s `cpr` field. */
  cpr?: InputMaybe<StringFilter>;
  /** Filter by the object’s `currentVacationTypeId` field. */
  currentVacationTypeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `customId` field. */
  customId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deleteAt` field. */
  deleteAt?: InputMaybe<DateFilter>;
  /** Filter by the object’s `deleteReminded` field. */
  deleteReminded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `directManagerUserId` field. */
  directManagerUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `documentFolderUsers` relation. */
  documentFolderUsers?: InputMaybe<UserToManyDocumentFolderUserFilter>;
  /** Some related `documentFolderUsers` exist. */
  documentFolderUsersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentUserPermissions` relation. */
  documentUserPermissions?: InputMaybe<UserToManyDocumentUserPermissionFilter>;
  /** Some related `documentUserPermissions` exist. */
  documentUserPermissionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `documentUserResponsibles` relation. */
  documentUserResponsibles?: InputMaybe<UserToManyDocumentUserResponsibleFilter>;
  /** Filter by the object’s `documentUserResponsiblesByAssignedBy` relation. */
  documentUserResponsiblesByAssignedBy?: InputMaybe<UserToManyDocumentUserResponsibleFilter>;
  /** Some related `documentUserResponsiblesByAssignedBy` exist. */
  documentUserResponsiblesByAssignedByExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `documentUserResponsibles` exist. */
  documentUserResponsiblesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emailWork` field. */
  emailWork?: InputMaybe<StringFilter>;
  /** Filter by the object’s `employee` relation. */
  employee?: InputMaybe<EmployeeFilter>;
  /** Filter by the object’s `employeeByUserId` relation. */
  employeeByUserId?: InputMaybe<EmployeeFilter>;
  /** A related `employeeByUserId` exists. */
  employeeByUserIdExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `employeeCasefiles` relation. */
  employeeCasefiles?: InputMaybe<UserToManyEmployeeCasefileFilter>;
  /** Filter by the object’s `employeeCasefilesByCreatorUserId` relation. */
  employeeCasefilesByCreatorUserId?: InputMaybe<UserToManyEmployeeCasefileFilter>;
  /** Some related `employeeCasefilesByCreatorUserId` exist. */
  employeeCasefilesByCreatorUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `employeeCasefilesByNextSigningUserId` relation. */
  employeeCasefilesByNextSigningUserId?: InputMaybe<UserToManyEmployeeCasefileFilter>;
  /** Some related `employeeCasefilesByNextSigningUserId` exist. */
  employeeCasefilesByNextSigningUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `employeeCasefiles` exist. */
  employeeCasefilesExist?: InputMaybe<Scalars['Boolean']>;
  /** A related `employee` exists. */
  employeeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `employeeId` field. */
  employeeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `employeeNumber` field. */
  employeeNumber?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `employmentEnd` field. */
  employmentEnd?: InputMaybe<DateFilter>;
  /** Filter by the object’s `employmentEndReminded` field. */
  employmentEndReminded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `employmentJurisdiction` field. */
  employmentJurisdiction?: InputMaybe<StringFilter>;
  /** Filter by the object’s `employmentStart` field. */
  employmentStart?: InputMaybe<DateFilter>;
  /** Filter by the object’s `equipments` relation. */
  equipments?: InputMaybe<UserToManyEquipmentFilter>;
  /** Some related `equipments` exist. */
  equipmentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `eventUsers` relation. */
  eventUsers?: InputMaybe<UserToManyEventUserFilter>;
  /** Some related `eventUsers` exist. */
  eventUsersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `filterPresets` relation. */
  filterPresets?: InputMaybe<UserToManyFilterPresetFilter>;
  /** Some related `filterPresets` exist. */
  filterPresetsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `filterViews` relation. */
  filterViews?: InputMaybe<UserToManyFilterViewFilter>;
  /** Some related `filterViews` exist. */
  filterViewsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `finishedEngagementNames` field. */
  finishedEngagementNames?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `formFieldEntries` relation. */
  formFieldEntries?: InputMaybe<UserToManyFormFieldEntryFilter>;
  /** Filter by the object’s `formFieldEntriesByProductUserId` relation. */
  formFieldEntriesByProductUserId?: InputMaybe<UserToManyFormFieldEntryFilter>;
  /** Some related `formFieldEntriesByProductUserId` exist. */
  formFieldEntriesByProductUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `formFieldEntries` exist. */
  formFieldEntriesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fullNameTsvector` field. */
  fullNameTsvector?: InputMaybe<FullTextFilter>;
  /** Filter by the object’s `futureData` relation. */
  futureData?: InputMaybe<UserToManyFutureDatumFilter>;
  /** Filter by the object’s `futureDataByCreatorUserId` relation. */
  futureDataByCreatorUserId?: InputMaybe<UserToManyFutureDatumFilter>;
  /** Some related `futureDataByCreatorUserId` exist. */
  futureDataByCreatorUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `futureData` exist. */
  futureDataExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `godmode` field. */
  godmode?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `groupIds` field. */
  groupIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `hasLogo` field. */
  hasLogo?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `initials` field. */
  initials?: InputMaybe<StringFilter>;
  /** Filter by the object’s `initialsLogo` field. */
  initialsLogo?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isArchived` field. */
  isArchived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isFuture` field. */
  isFuture?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isLeader` field. */
  isLeader?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isResigned` field. */
  isResigned?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isSystemUser` field. */
  isSystemUser?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `jobPositionDescription` field. */
  jobPositionDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `jobPositionTitle` field. */
  jobPositionTitle?: InputMaybe<StringFilter>;
  /** Filter by the object’s `jobPositionType` field. */
  jobPositionType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `jobPositionWorkingHours` field. */
  jobPositionWorkingHours?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lastLogin` field. */
  lastLogin?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `latestTimeRegistrationTemplate` field. */
  latestTimeRegistrationTemplate?: InputMaybe<StringFilter>;
  /** Filter by the object’s `leaderDepartments` field. */
  leaderDepartments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `locale` field. */
  locale?: InputMaybe<StringFilter>;
  /** Filter by the object’s `loggedActionNotes` relation. */
  loggedActionNotes?: InputMaybe<UserToManyLoggedActionNoteFilter>;
  /** Filter by the object’s `loggedActionNotesBySuperUserId` relation. */
  loggedActionNotesBySuperUserId?: InputMaybe<UserToManyLoggedActionNoteFilter>;
  /** Some related `loggedActionNotesBySuperUserId` exist. */
  loggedActionNotesBySuperUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `loggedActionNotes` exist. */
  loggedActionNotesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `loginLogs` relation. */
  loginLogs?: InputMaybe<UserToManyLoginLogFilter>;
  /** Some related `loginLogs` exist. */
  loginLogsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `logo` field. */
  logo?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mobile` field. */
  mobile?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mobilePrivate` field. */
  mobilePrivate?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nextAnniversary` field. */
  nextAnniversary?: InputMaybe<DateFilter>;
  /** Filter by the object’s `nextBirthday` field. */
  nextBirthday?: InputMaybe<DateFilter>;
  /** Filter by the object’s `nextBirthdayOrAnniversary` field. */
  nextBirthdayOrAnniversary?: InputMaybe<DateFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserFilter>;
  /** Filter by the object’s `notificationCustomRecipients` relation. */
  notificationCustomRecipients?: InputMaybe<UserToManyNotificationCustomRecipientFilter>;
  /** Some related `notificationCustomRecipients` exist. */
  notificationCustomRecipientsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `notificationEmployeeReferencesByRecipientUserId` relation. */
  notificationEmployeeReferencesByRecipientUserId?: InputMaybe<UserToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferencesByRecipientUserId` exist. */
  notificationEmployeeReferencesByRecipientUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `ongoingEngagementNames` field. */
  ongoingEngagementNames?: InputMaybe<StringListFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `phone` field. */
  phone?: InputMaybe<StringFilter>;
  /** Filter by the object’s `postalCode` field. */
  postalCode?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `posts` relation. */
  posts?: InputMaybe<UserToManyPostFilter>;
  /** Some related `posts` exist. */
  postsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingComments` relation. */
  preboardingComments?: InputMaybe<UserToManyPreboardingCommentFilter>;
  /** Some related `preboardingComments` exist. */
  preboardingCommentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingEmailLogsByPreboardingUserId` relation. */
  preboardingEmailLogsByPreboardingUserId?: InputMaybe<UserToManyPreboardingEmailLogFilter>;
  /** Some related `preboardingEmailLogsByPreboardingUserId` exist. */
  preboardingEmailLogsByPreboardingUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingEmployees` relation. */
  preboardingEmployees?: InputMaybe<UserToManyPreboardingEmployeeFilter>;
  /** Filter by the object’s `preboardingEmployeesByRecipientId` relation. */
  preboardingEmployeesByRecipientId?: InputMaybe<UserToManyPreboardingEmployeeFilter>;
  /** Some related `preboardingEmployeesByRecipientId` exist. */
  preboardingEmployeesByRecipientIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `preboardingEmployees` exist. */
  preboardingEmployeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingFormCaches` relation. */
  preboardingFormCaches?: InputMaybe<UserToManyPreboardingFormCacheFilter>;
  /** Some related `preboardingFormCaches` exist. */
  preboardingFormCachesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingProcesses` relation. */
  preboardingProcesses?: InputMaybe<UserToManyPreboardingProcessFilter>;
  /** Some related `preboardingProcesses` exist. */
  preboardingProcessesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingResultSlideComments` relation. */
  preboardingResultSlideComments?: InputMaybe<UserToManyPreboardingResultSlideCommentFilter>;
  /** Filter by the object’s `preboardingResultSlideCommentsByPreboardingUserId` relation. */
  preboardingResultSlideCommentsByPreboardingUserId?: InputMaybe<UserToManyPreboardingResultSlideCommentFilter>;
  /** Some related `preboardingResultSlideCommentsByPreboardingUserId` exist. */
  preboardingResultSlideCommentsByPreboardingUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `preboardingResultSlideComments` exist. */
  preboardingResultSlideCommentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingResults` relation. */
  preboardingResults?: InputMaybe<UserToManyPreboardingResultFilter>;
  /** Some related `preboardingResults` exist. */
  preboardingResultsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `preboardingsByRecipientId` relation. */
  preboardingsByRecipientId?: InputMaybe<UserToManyPreboardingFilter>;
  /** Some related `preboardingsByRecipientId` exist. */
  preboardingsByRecipientIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processResponsiblesByResponsibleUserId` relation. */
  processResponsiblesByResponsibleUserId?: InputMaybe<UserToManyProcessResponsibleFilter>;
  /** Some related `processResponsiblesByResponsibleUserId` exist. */
  processResponsiblesByResponsibleUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `processesByAssignedUserId` relation. */
  processesByAssignedUserId?: InputMaybe<UserToManyProcessFilter>;
  /** Some related `processesByAssignedUserId` exist. */
  processesByAssignedUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `products` relation. */
  products?: InputMaybe<UserToManyProductFilter>;
  /** Filter by the object’s `productsByAssignedUserId` relation. */
  productsByAssignedUserId?: InputMaybe<UserToManyProductFilter>;
  /** Some related `productsByAssignedUserId` exist. */
  productsByAssignedUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `products` exist. */
  productsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `projectsByAssignedProcessUserId` relation. */
  projectsByAssignedProcessUserId?: InputMaybe<UserToManyProjectFilter>;
  /** Some related `projectsByAssignedProcessUserId` exist. */
  projectsByAssignedProcessUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pulseSurveyAnswers` relation. */
  pulseSurveyAnswers?: InputMaybe<UserToManyPulseSurveyAnswerFilter>;
  /** Some related `pulseSurveyAnswers` exist. */
  pulseSurveyAnswersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `pushTokenByUserId` relation. */
  pushTokenByUserId?: InputMaybe<PushTokenFilter>;
  /** A related `pushTokenByUserId` exists. */
  pushTokenByUserIdExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `referenceTokens` relation. */
  referenceTokens?: InputMaybe<UserToManyReferenceTokenFilter>;
  /** Some related `referenceTokens` exist. */
  referenceTokensExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roadmapItemComments` relation. */
  roadmapItemComments?: InputMaybe<UserToManyRoadmapItemCommentFilter>;
  /** Some related `roadmapItemComments` exist. */
  roadmapItemCommentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `roadmapItemVotes` relation. */
  roadmapItemVotes?: InputMaybe<UserToManyRoadmapItemVoteFilter>;
  /** Some related `roadmapItemVotes` exist. */
  roadmapItemVotesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scheduledMessagesByAssignedProcessUserId` relation. */
  scheduledMessagesByAssignedProcessUserId?: InputMaybe<UserToManyScheduledMessageFilter>;
  /** Some related `scheduledMessagesByAssignedProcessUserId` exist. */
  scheduledMessagesByAssignedProcessUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `scope` field. */
  scope?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `seniority` field. */
  seniority?: InputMaybe<DateFilter>;
  /** Filter by the object’s `superUserByUserId` relation. */
  superUserByUserId?: InputMaybe<SuperUserFilter>;
  /** A related `superUserByUserId` exists. */
  superUserByUserIdExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `superUserLoginNotes` relation. */
  superUserLoginNotes?: InputMaybe<UserToManySuperUserLoginNoteFilter>;
  /** Filter by the object’s `superUserLoginNotesBySuperUserId` relation. */
  superUserLoginNotesBySuperUserId?: InputMaybe<UserToManySuperUserLoginNoteFilter>;
  /** Some related `superUserLoginNotesBySuperUserId` exist. */
  superUserLoginNotesBySuperUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `superUserLoginNotes` exist. */
  superUserLoginNotesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskEmployees` relation. */
  taskEmployees?: InputMaybe<UserToManyTaskEmployeeFilter>;
  /** Filter by the object’s `taskEmployeesByAssignedProcessUserId` relation. */
  taskEmployeesByAssignedProcessUserId?: InputMaybe<UserToManyTaskEmployeeFilter>;
  /** Some related `taskEmployeesByAssignedProcessUserId` exist. */
  taskEmployeesByAssignedProcessUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `taskEmployees` exist. */
  taskEmployeesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskResponsibles` relation. */
  taskResponsibles?: InputMaybe<UserToManyTaskResponsibleFilter>;
  /** Filter by the object’s `taskResponsiblesByAssignedProcessUserId` relation. */
  taskResponsiblesByAssignedProcessUserId?: InputMaybe<UserToManyTaskResponsibleFilter>;
  /** Some related `taskResponsiblesByAssignedProcessUserId` exist. */
  taskResponsiblesByAssignedProcessUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `taskResponsibles` exist. */
  taskResponsiblesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `taskTemplatesByCalendarEventOrganizerId` relation. */
  taskTemplatesByCalendarEventOrganizerId?: InputMaybe<UserToManyTaskTemplateFilter>;
  /** Some related `taskTemplatesByCalendarEventOrganizerId` exist. */
  taskTemplatesByCalendarEventOrganizerIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `tasksByAssignedProcessUserId` relation. */
  tasksByAssignedProcessUserId?: InputMaybe<UserToManyTaskFilter>;
  /** Some related `tasksByAssignedProcessUserId` exist. */
  tasksByAssignedProcessUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `tasksByCalendarEventOrganizerId` relation. */
  tasksByCalendarEventOrganizerId?: InputMaybe<UserToManyTaskFilter>;
  /** Some related `tasksByCalendarEventOrganizerId` exist. */
  tasksByCalendarEventOrganizerIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `tasksByCompletedBy` relation. */
  tasksByCompletedBy?: InputMaybe<UserToManyTaskFilter>;
  /** Some related `tasksByCompletedBy` exist. */
  tasksByCompletedByExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `tasksByCreatedBy` relation. */
  tasksByCreatedBy?: InputMaybe<UserToManyTaskFilter>;
  /** Some related `tasksByCreatedBy` exist. */
  tasksByCreatedByExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationEntries` relation. */
  timeRegistrationEntries?: InputMaybe<UserToManyTimeRegistrationEntryFilter>;
  /** Some related `timeRegistrationEntries` exist. */
  timeRegistrationEntriesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationEntryTemplates` relation. */
  timeRegistrationEntryTemplates?: InputMaybe<UserToManyTimeRegistrationEntryTemplateFilter>;
  /** Some related `timeRegistrationEntryTemplates` exist. */
  timeRegistrationEntryTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationPresenceTemplates` relation. */
  timeRegistrationPresenceTemplates?: InputMaybe<UserToManyTimeRegistrationPresenceTemplateFilter>;
  /** Some related `timeRegistrationPresenceTemplates` exist. */
  timeRegistrationPresenceTemplatesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationPresences` relation. */
  timeRegistrationPresences?: InputMaybe<UserToManyTimeRegistrationPresenceFilter>;
  /** Some related `timeRegistrationPresences` exist. */
  timeRegistrationPresencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `timeRegistrationTemplateWeeks` relation. */
  timeRegistrationTemplateWeeks?: InputMaybe<UserToManyTimeRegistrationTemplateWeekFilter>;
  /** Some related `timeRegistrationTemplateWeeks` exist. */
  timeRegistrationTemplateWeeksExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userAnnouncements` relation. */
  userAnnouncements?: InputMaybe<UserToManyUserAnnouncementFilter>;
  /** Some related `userAnnouncements` exist. */
  userAnnouncementsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userCompanyGroups` relation. */
  userCompanyGroups?: InputMaybe<UserToManyUserCompanyGroupFilter>;
  /** Some related `userCompanyGroups` exist. */
  userCompanyGroupsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userCompanyRoles` relation. */
  userCompanyRoles?: InputMaybe<UserToManyUserCompanyRoleFilter>;
  /** Some related `userCompanyRoles` exist. */
  userCompanyRolesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userCompetenceEvaluationComments` relation. */
  userCompetenceEvaluationComments?: InputMaybe<UserToManyUserCompetenceEvaluationCommentFilter>;
  /** Some related `userCompetenceEvaluationComments` exist. */
  userCompetenceEvaluationCommentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userCompetenceEvaluationsByEvaluatingUserId` relation. */
  userCompetenceEvaluationsByEvaluatingUserId?: InputMaybe<UserToManyUserCompetenceEvaluationFilter>;
  /** Some related `userCompetenceEvaluationsByEvaluatingUserId` exist. */
  userCompetenceEvaluationsByEvaluatingUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userCompetences` relation. */
  userCompetences?: InputMaybe<UserToManyUserCompetenceFilter>;
  /** Some related `userCompetences` exist. */
  userCompetencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userDepartmentGroups` relation. */
  userDepartmentGroups?: InputMaybe<UserToManyUserDepartmentGroupFilter>;
  /** Some related `userDepartmentGroups` exist. */
  userDepartmentGroupsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userDepartmentRoles` relation. */
  userDepartmentRoles?: InputMaybe<UserToManyUserDepartmentRoleFilter>;
  /** Some related `userDepartmentRoles` exist. */
  userDepartmentRolesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userDepartments` relation. */
  userDepartments?: InputMaybe<UserToManyUserDepartmentFilter>;
  /** Some related `userDepartments` exist. */
  userDepartmentsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userGroups` relation. */
  userGroups?: InputMaybe<UserToManyUserGroupFilter>;
  /** Some related `userGroups` exist. */
  userGroupsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userOnBehalfPermissions` relation. */
  userOnBehalfPermissions?: InputMaybe<UserToManyUserOnBehalfPermissionFilter>;
  /** Filter by the object’s `userOnBehalfPermissionsByOnBehalfOfUserId` relation. */
  userOnBehalfPermissionsByOnBehalfOfUserId?: InputMaybe<UserToManyUserOnBehalfPermissionFilter>;
  /** Some related `userOnBehalfPermissionsByOnBehalfOfUserId` exist. */
  userOnBehalfPermissionsByOnBehalfOfUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `userOnBehalfPermissions` exist. */
  userOnBehalfPermissionsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userRoles` relation. */
  userRoles?: InputMaybe<UserToManyUserRoleFilter>;
  /** Some related `userRoles` exist. */
  userRolesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userSettings` relation. */
  userSettings?: InputMaybe<UserToManyUserSettingFilter>;
  /** Some related `userSettings` exist. */
  userSettingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userSystemFields` relation. */
  userSystemFields?: InputMaybe<UserToManyUserSystemFieldFilter>;
  /** Some related `userSystemFields` exist. */
  userSystemFieldsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `vacationUsers` relation. */
  vacationUsers?: InputMaybe<UserToManyVacationUserFilter>;
  /** Filter by the object’s `vacationUsersByCreatorUserId` relation. */
  vacationUsersByCreatorUserId?: InputMaybe<UserToManyVacationUserFilter>;
  /** Some related `vacationUsersByCreatorUserId` exist. */
  vacationUsersByCreatorUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `vacationUsers` exist. */
  vacationUsersExist?: InputMaybe<Scalars['Boolean']>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  /** Reads a single `Company` that is related to this `UserGroup`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  departmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Group` that is related to this `UserGroup`. */
  group?: Maybe<Group>;
  groupId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `UserGroup`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The `userGroup` to be created by this mutation. */
export type UserGroupCompanyIdFkeyConnectionUserGroupCreateInput = {
  company?: InputMaybe<UserGroupCompanyIdFkeyInput>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  group?: InputMaybe<UserGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `UserGroupInput` mutation. */
export type UserGroupCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnUserGroupForUserGroupCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `userGroup` in the `CompanyInput` mutation. */
export type UserGroupCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `userGroup` for the far side of the relationship. */
  connectByUserIdAndGroupId?: InputMaybe<Array<UserGroupUserGroupPkeyConnect>>;
  /** A `UserGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserGroupCompanyIdFkeyConnectionUserGroupCreateInput>>;
  /** The primary key(s) for `userGroup` for the far side of the relationship. */
  deleteByUserIdAndGroupId?: InputMaybe<Array<UserGroupUserGroupPkeyDelete>>;
  /** Flag indicating whether all other `userGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userGroup` for the far side of the relationship. */
  updateByUserIdAndGroupId?: InputMaybe<Array<UserGroupOnUserGroupForUserGroupCompanyIdFkeyUsingUserGroupPkeyUpdate>>;
};

/**
 * A condition to be used against `UserGroup` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserGroupCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `UserGroup` object types. All fields are combined with a logical ‘and.’ */
export type UserGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserGroupFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `group` relation. */
  group?: InputMaybe<GroupFilter>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserGroupFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The `group` to be created by this mutation. */
export type UserGroupGroupIdForeignConnectionGroupCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppTableGroupIdFkInverseInput>;
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  autoInherit?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  copyFromGroupId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientGroupIdForeignInverseInput>;
  scope?: InputMaybe<RoleScope>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupGroupIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupGroupIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupGroupIdForeignInverseInput>;
};

/** The `userGroup` to be created by this mutation. */
export type UserGroupGroupIdForeignConnectionUserGroupCreateInput = {
  company?: InputMaybe<UserGroupCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  group?: InputMaybe<UserGroupGroupIdForeignInput>;
  user?: InputMaybe<UserGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `group` in the `UserGroupInput` mutation. */
export type UserGroupGroupIdForeignInput = {
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectById?: InputMaybe<GroupGroupPkeyConnect>;
  /** A `GroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserGroupGroupIdForeignConnectionGroupCreateInput>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateById?: InputMaybe<GroupOnUserGroupForUserGroupGroupIdForeignUsingGroupPkeyUpdate>;
};

/** Input for the nested mutation of `userGroup` in the `GroupInput` mutation. */
export type UserGroupGroupIdForeignInverseInput = {
  /** The primary key(s) for `userGroup` for the far side of the relationship. */
  connectByUserIdAndGroupId?: InputMaybe<Array<UserGroupUserGroupPkeyConnect>>;
  /** A `UserGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserGroupGroupIdForeignConnectionUserGroupCreateInput>>;
  /** The primary key(s) for `userGroup` for the far side of the relationship. */
  deleteByUserIdAndGroupId?: InputMaybe<Array<UserGroupUserGroupPkeyDelete>>;
  /** Flag indicating whether all other `userGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userGroup` for the far side of the relationship. */
  updateByUserIdAndGroupId?: InputMaybe<Array<UserGroupOnUserGroupForUserGroupGroupIdForeignUsingUserGroupPkeyUpdate>>;
};

/** An input for mutations affecting `UserGroup` */
export type UserGroupInput = {
  company?: InputMaybe<UserGroupCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  group?: InputMaybe<UserGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `userGroup` to look up the row to update. */
export type UserGroupOnUserGroupForUserGroupCompanyIdFkeyUsingUserGroupPkeyUpdate = {
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userGroup` being updated. */
  patch: UpdateUserGroupOnUserGroupForUserGroupCompanyIdFkeyPatch;
  userId: Scalars['UUID'];
};

/** The fields on `userGroup` to look up the row to update. */
export type UserGroupOnUserGroupForUserGroupGroupIdForeignUsingUserGroupPkeyUpdate = {
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userGroup` being updated. */
  patch: UpdateUserGroupOnUserGroupForUserGroupGroupIdForeignPatch;
  userId: Scalars['UUID'];
};

/** The fields on `userGroup` to look up the row to update. */
export type UserGroupOnUserGroupForUserGroupUserIdForeignUsingUserGroupPkeyUpdate = {
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userGroup` being updated. */
  patch: UpdateUserGroupOnUserGroupForUserGroupUserIdForeignPatch;
  userId: Scalars['UUID'];
};

/** Represents an update to a `UserGroup`. Fields that are set will be updated. */
export type UserGroupPatch = {
  company?: InputMaybe<UserGroupCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  group?: InputMaybe<UserGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `userGroup` to look up the row to connect. */
export type UserGroupUserGroupPkeyConnect = {
  groupId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `userGroup` to look up the row to delete. */
export type UserGroupUserGroupPkeyDelete = {
  groupId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The `userGroup` to be created by this mutation. */
export type UserGroupUserIdForeignConnectionUserGroupCreateInput = {
  company?: InputMaybe<UserGroupCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  group?: InputMaybe<UserGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserGroupUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `UserGroupInput` mutation. */
export type UserGroupUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserGroupForUserGroupUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `userGroup` in the `UserInput` mutation. */
export type UserGroupUserIdForeignInverseInput = {
  /** The primary key(s) for `userGroup` for the far side of the relationship. */
  connectByUserIdAndGroupId?: InputMaybe<Array<UserGroupUserGroupPkeyConnect>>;
  /** A `UserGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserGroupUserIdForeignConnectionUserGroupCreateInput>>;
  /** The primary key(s) for `userGroup` for the far side of the relationship. */
  deleteByUserIdAndGroupId?: InputMaybe<Array<UserGroupUserGroupPkeyDelete>>;
  /** Flag indicating whether all other `userGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userGroup` for the far side of the relationship. */
  updateByUserIdAndGroupId?: InputMaybe<Array<UserGroupOnUserGroupForUserGroupUserIdForeignUsingUserGroupPkeyUpdate>>;
};

/** A connection to a list of `UserGroup` values. */
export type UserGroupsConnection = {
  __typename?: 'UserGroupsConnection';
  /** A list of edges which contains the `UserGroup` and cursor to aid in pagination. */
  edges: Array<UserGroupsEdge>;
  /** A list of `UserGroup` objects. */
  nodes: Array<Maybe<UserGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserGroup` edge in the connection. */
export type UserGroupsEdge = {
  __typename?: 'UserGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserGroup` at the end of the edge. */
  node?: Maybe<UserGroup>;
};

/** Methods to use when ordering `UserGroup`. */
export type UserGroupsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'GROUP_BY_GROUP_ID__ACTIVE_ASC'
  | 'GROUP_BY_GROUP_ID__ACTIVE_DESC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_ASC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_DESC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_NEW_PERMISSIONS_ASC'
  | 'GROUP_BY_GROUP_ID__AUTO_ADD_NEW_PERMISSIONS_DESC'
  | 'GROUP_BY_GROUP_ID__AUTO_INHERIT_ASC'
  | 'GROUP_BY_GROUP_ID__AUTO_INHERIT_DESC'
  | 'GROUP_BY_GROUP_ID__COMPANY_ID_ASC'
  | 'GROUP_BY_GROUP_ID__COMPANY_ID_DESC'
  | 'GROUP_BY_GROUP_ID__DESCRIPTION_ASC'
  | 'GROUP_BY_GROUP_ID__DESCRIPTION_DESC'
  | 'GROUP_BY_GROUP_ID__ID_ASC'
  | 'GROUP_BY_GROUP_ID__ID_DESC'
  | 'GROUP_BY_GROUP_ID__LOCALIZED_NAME_ASC'
  | 'GROUP_BY_GROUP_ID__LOCALIZED_NAME_DESC'
  | 'GROUP_BY_GROUP_ID__NAME_ASC'
  | 'GROUP_BY_GROUP_ID__NAME_DESC'
  | 'GROUP_BY_GROUP_ID__SCOPE_ASC'
  | 'GROUP_BY_GROUP_ID__SCOPE_DESC'
  | 'GROUP_ID_ASC'
  | 'GROUP_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** Input for the nested mutation of `timeRegistrationTemplate` in the `UserInput` mutation. */
export type UserLatestTimeRegistrationTemplateIdForeignInput = {
  /** The primary key(s) for `timeRegistrationTemplate` for the far side of the relationship. */
  connectById?: InputMaybe<TimeRegistrationTemplateTimeRegistrationTemplatePkeyConnect>;
  /** The primary key(s) for `timeRegistrationTemplate` for the far side of the relationship. */
  deleteById?: InputMaybe<TimeRegistrationTemplateTimeRegistrationTemplatePkeyDelete>;
};

/** Input for the nested mutation of `user` in the `TimeRegistrationTemplateInput` mutation. */
export type UserLatestTimeRegistrationTemplateIdForeignInverseInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserUserPkeyConnect>>;
};

/** The fields on `user` to look up the row to update. */
export type UserOnAnnouncementForAnnouncementUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnAnnouncementForAnnouncementUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnApprovalForApprovalRequestingUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnApprovalForApprovalRequestingUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnAsyncJobForAsyncJobUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnAsyncJobForAsyncJobUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnAsyncJobItemForAsyncJobItemUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnAsyncJobItemForAsyncJobItemUserIdForeignPatch;
};

export type UserOnBehalfPermission = {
  __typename?: 'UserOnBehalfPermission';
  /** Reads a single `Company` that is related to this `UserOnBehalfPermission`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** Reads a single `User` that is related to this `UserOnBehalfPermission`. */
  onBehalfOfUser?: Maybe<User>;
  onBehalfOfUserId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `UserOnBehalfPermission`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/**
 * A condition to be used against `UserOnBehalfPermission` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type UserOnBehalfPermissionCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `onBehalfOfUserId` field. */
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `UserOnBehalfPermission` object types. All fields are combined with a logical ‘and.’ */
export type UserOnBehalfPermissionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserOnBehalfPermissionFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserOnBehalfPermissionFilter>;
  /** Filter by the object’s `onBehalfOfUser` relation. */
  onBehalfOfUser?: InputMaybe<UserFilter>;
  /** Filter by the object’s `onBehalfOfUserId` field. */
  onBehalfOfUserId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserOnBehalfPermissionFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `UserOnBehalfPermission` */
export type UserOnBehalfPermissionInput = {
  company?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `userOnBehalfPermission` to look up the row to update. */
export type UserOnBehalfPermissionOnUserOnBehalfPermissionForUserOnBehalfPermissionsCompanyIdForeignUsingUserOnBehalfPermissionsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userOnBehalfPermission` being updated. */
  patch: UpdateUserOnBehalfPermissionOnUserOnBehalfPermissionForUserOnBehalfPermissionsCompanyIdForeignPatch;
};

/** The fields on `userOnBehalfPermission` to look up the row to update. */
export type UserOnBehalfPermissionOnUserOnBehalfPermissionForUserOnBehalfPermissionsOnBehalfOfUserIdForeignUsingUserOnBehalfPermissionsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userOnBehalfPermission` being updated. */
  patch: UpdateUserOnBehalfPermissionOnUserOnBehalfPermissionForUserOnBehalfPermissionsOnBehalfOfUserIdForeignPatch;
};

/** The fields on `userOnBehalfPermission` to look up the row to update. */
export type UserOnBehalfPermissionOnUserOnBehalfPermissionForUserOnBehalfPermissionsUserIdForeignUsingUserOnBehalfPermissionsPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `userOnBehalfPermission` being updated. */
  patch: UpdateUserOnBehalfPermissionOnUserOnBehalfPermissionForUserOnBehalfPermissionsUserIdForeignPatch;
};

/** Represents an update to a `UserOnBehalfPermission`. Fields that are set will be updated. */
export type UserOnBehalfPermissionPatch = {
  company?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `userOnBehalfPermission` to look up the row to connect. */
export type UserOnBehalfPermissionUserOnBehalfPermissionsPkeyConnect = {
  id: Scalars['UUID'];
};

/** The fields on `userOnBehalfPermission` to look up the row to delete. */
export type UserOnBehalfPermissionUserOnBehalfPermissionsPkeyDelete = {
  id: Scalars['UUID'];
};

/** The `userOnBehalfPermission` to be created by this mutation. */
export type UserOnBehalfPermissionsCompanyIdForeignConnectionUserOnBehalfPermissionsCreateInput = {
  company?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `UserOnBehalfPermissionInput` mutation. */
export type UserOnBehalfPermissionsCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnUserOnBehalfPermissionForUserOnBehalfPermissionsCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `userOnBehalfPermission` in the `CompanyInput` mutation. */
export type UserOnBehalfPermissionsCompanyIdForeignInverseInput = {
  /** The primary key(s) for `userOnBehalfPermission` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserOnBehalfPermissionUserOnBehalfPermissionsPkeyConnect>>;
  /** A `UserOnBehalfPermissionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserOnBehalfPermissionsCompanyIdForeignConnectionUserOnBehalfPermissionsCreateInput>>;
  /** The primary key(s) for `userOnBehalfPermission` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserOnBehalfPermissionUserOnBehalfPermissionsPkeyDelete>>;
  /** Flag indicating whether all other `userOnBehalfPermission` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userOnBehalfPermission` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserOnBehalfPermissionOnUserOnBehalfPermissionForUserOnBehalfPermissionsCompanyIdForeignUsingUserOnBehalfPermissionsPkeyUpdate>>;
};

/** A connection to a list of `UserOnBehalfPermission` values. */
export type UserOnBehalfPermissionsConnection = {
  __typename?: 'UserOnBehalfPermissionsConnection';
  /** A list of edges which contains the `UserOnBehalfPermission` and cursor to aid in pagination. */
  edges: Array<UserOnBehalfPermissionsEdge>;
  /** A list of `UserOnBehalfPermission` objects. */
  nodes: Array<Maybe<UserOnBehalfPermission>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserOnBehalfPermission` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserOnBehalfPermission` edge in the connection. */
export type UserOnBehalfPermissionsEdge = {
  __typename?: 'UserOnBehalfPermissionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserOnBehalfPermission` at the end of the edge. */
  node?: Maybe<UserOnBehalfPermission>;
};

/** The `userOnBehalfPermission` to be created by this mutation. */
export type UserOnBehalfPermissionsOnBehalfOfUserIdForeignConnectionUserOnBehalfPermissionsCreateInput = {
  company?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `user` in the `UserOnBehalfPermissionInput` mutation. */
export type UserOnBehalfPermissionsOnBehalfOfUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserOnBehalfPermissionForUserOnBehalfPermissionsOnBehalfOfUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `userOnBehalfPermission` in the `UserInput` mutation. */
export type UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput = {
  /** The primary key(s) for `userOnBehalfPermission` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserOnBehalfPermissionUserOnBehalfPermissionsPkeyConnect>>;
  /** A `UserOnBehalfPermissionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserOnBehalfPermissionsOnBehalfOfUserIdForeignConnectionUserOnBehalfPermissionsCreateInput>>;
  /** The primary key(s) for `userOnBehalfPermission` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserOnBehalfPermissionUserOnBehalfPermissionsPkeyDelete>>;
  /** Flag indicating whether all other `userOnBehalfPermission` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userOnBehalfPermission` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserOnBehalfPermissionOnUserOnBehalfPermissionForUserOnBehalfPermissionsOnBehalfOfUserIdForeignUsingUserOnBehalfPermissionsPkeyUpdate>>;
};

/** Methods to use when ordering `UserOnBehalfPermission`. */
export type UserOnBehalfPermissionsOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'ON_BEHALF_OF_USER_ID_ASC'
  | 'ON_BEHALF_OF_USER_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__ACTIVE_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__ACTIVE_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__ADDRESS_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__ADDRESS_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CITY_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CITY_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CPR_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CPR_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMAIL_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMAIL_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__GODMODE_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__GODMODE_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__ID_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__ID_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__INITIALS_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__INITIALS_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__MOBILE_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__MOBILE_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__PHONE_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__PHONE_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__SENIORITY_ASC'
  | 'USER_BY_ON_BEHALF_OF_USER_ID__SENIORITY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** The `userOnBehalfPermission` to be created by this mutation. */
export type UserOnBehalfPermissionsUserIdForeignConnectionUserOnBehalfPermissionsCreateInput = {
  company?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInput>;
};

/** Input for the nested mutation of `userOnBehalfPermission` in the `UserInput` mutation. */
export type UserOnBehalfPermissionsUserIdForeignInverseInput = {
  /** The primary key(s) for `userOnBehalfPermission` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserOnBehalfPermissionUserOnBehalfPermissionsPkeyConnect>>;
  /** A `UserOnBehalfPermissionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserOnBehalfPermissionsUserIdForeignConnectionUserOnBehalfPermissionsCreateInput>>;
  /** The primary key(s) for `userOnBehalfPermission` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserOnBehalfPermissionUserOnBehalfPermissionsPkeyDelete>>;
  /** Flag indicating whether all other `userOnBehalfPermission` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userOnBehalfPermission` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserOnBehalfPermissionOnUserOnBehalfPermissionForUserOnBehalfPermissionsUserIdForeignUsingUserOnBehalfPermissionsPkeyUpdate>>;
};

/** The fields on `user` to look up the row to update. */
export type UserOnChangelogUserForChangelogUserUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnChangelogUserForChangelogUserUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnChosenColumnForChosenColumnsUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnChosenColumnForChosenColumnsUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnContractSignPendingForContractSignPendingNextSigningUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnContractSignPendingForContractSignPendingNextSigningUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnContractSignPendingSignerForContractSignPendingSignerOnBehalfOfUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnContractSignPendingSignerForContractSignPendingSignerOnBehalfOfUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnContractTemplateUserForContractTemplateUsersUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnContractTemplateUserForContractTemplateUsersUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnDocumentFolderUserForDocumentFolderUserUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnDocumentFolderUserForDocumentFolderUserUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnDocumentUserPermissionForDocumentUserPermissionsUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnDocumentUserPermissionForDocumentUserPermissionsUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnDocumentUserResponsibleForDocumentUserResponsibleAssignedByForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnDocumentUserResponsibleForDocumentUserResponsibleAssignedByForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnEmployeeCasefileForEmployeeCasefileCreatorUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnEmployeeCasefileForEmployeeCasefileCreatorUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnEmployeeForEmployeeUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnEmployeeForEmployeeUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnEquipmentForEquipmentUserIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnEquipmentForEquipmentUserIdFkeyPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnEventUserForEventUserUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnEventUserForEventUserUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnFilterPresetForFilterPresetUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnFilterPresetForFilterPresetUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnFilterViewForFilterViewUserIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnFilterViewForFilterViewUserIdFkeyPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnFormFieldEntryForFormFieldEntryProductUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnFormFieldEntryForFormFieldEntryProductUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnFutureDatumForFutureDataCreatorUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnFutureDatumForFutureDataCreatorUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnLoggedActionNoteForLoggedActionNoteSuperUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnLoggedActionNoteForLoggedActionNoteSuperUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnNotificationCustomRecipientForNotificationCustomRecipientUserIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnNotificationCustomRecipientForNotificationCustomRecipientUserIdFkeyPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnNotificationEmployeeReferenceForNotificationEmployeeReferenceRecipientUserIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnNotificationEmployeeReferenceForNotificationEmployeeReferenceRecipientUserIdFkeyPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnPostForPostUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnPostForPostUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnPreboardingCommentForPreboardingCommentUserIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnPreboardingCommentForPreboardingCommentUserIdFkeyPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnPreboardingEmailLogForPreboardingEmailLogPreboardingUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnPreboardingEmailLogForPreboardingEmailLogPreboardingUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnPreboardingEmployeeForPreboardingEmployeeRecipientIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnPreboardingEmployeeForPreboardingEmployeeRecipientIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnPreboardingForPreboardingRecipientIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnPreboardingForPreboardingRecipientIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnPreboardingFormCacheForPreboardingFormCacheUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnPreboardingFormCacheForPreboardingFormCacheUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnPreboardingProcessForPreboardingProcessUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnPreboardingProcessForPreboardingProcessUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnPreboardingResultForPreboardingResultUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnPreboardingResultForPreboardingResultUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnProcessForProcessAssignedUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnProcessForProcessAssignedUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnProcessResponsibleForProcessResponsibleResponsibleUserIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnProcessResponsibleForProcessResponsibleResponsibleUserIdFkeyPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnProductForProductAssignedUserIdFkeyUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnProductForProductAssignedUserIdFkeyPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnProjectForProjectAssignedProcessUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnProjectForProjectAssignedProcessUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnPulseSurveyAnswerForPulseSurveyAnswerUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnPulseSurveyAnswerForPulseSurveyAnswerUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnPushTokenForPushTokenUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnPushTokenForPushTokenUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnReferenceTokenForReferenceTokenUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnReferenceTokenForReferenceTokenUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnRoadmapItemCommentForRoadmapItemCommentUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnRoadmapItemCommentForRoadmapItemCommentUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnRoadmapItemVoteForRoadmapItemVoteUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnRoadmapItemVoteForRoadmapItemVoteUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnScheduledMessageForScheduledMessageAssignedProcessUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnScheduledMessageForScheduledMessageAssignedProcessUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnSuperUserForSuperUserUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnSuperUserForSuperUserUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnSuperUserLoginNoteForSuperUserLoginNoteSuperUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnSuperUserLoginNoteForSuperUserLoginNoteSuperUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnTaskEmployeeForTaskEmployeeAssignedProcessUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnTaskEmployeeForTaskEmployeeAssignedProcessUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnTaskForTaskCompletedByForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnTaskForTaskCompletedByForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnTaskResponsibleForTaskResponsibleAssignedProcessUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnTaskResponsibleForTaskResponsibleAssignedProcessUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnTaskTemplateForTaskTemplateCalendarEventOrganizerIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnTaskTemplateForTaskTemplateCalendarEventOrganizerIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnTimeRegistrationEntryForTimeRegistrationEntryUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnTimeRegistrationEntryForTimeRegistrationEntryUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnTimeRegistrationPresenceForTimeRegistrationPresenceUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnTimeRegistrationPresenceForTimeRegistrationPresenceUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserAnnouncementForUserAnnouncementUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserAnnouncementForUserAnnouncementUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserCompanyGroupForUserCompanyGroupUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserCompanyGroupForUserCompanyGroupUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserCompanyRoleForUserCompanyRoleUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserCompanyRoleForUserCompanyRoleUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserCompetenceEvaluationForUserCompetenceEvaluationEvaluatingUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserCompetenceEvaluationForUserCompetenceEvaluationEvaluatingUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserCompetenceForUserCompetenceUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserCompetenceForUserCompetenceUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserDepartmentForUserDepartmentUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserDepartmentForUserDepartmentUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserDepartmentGroupForUserDepartmentGroupUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserDepartmentGroupForUserDepartmentGroupUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserDepartmentRoleForUserDepartmentRoleUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserDepartmentRoleForUserDepartmentRoleUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserForUserCompanyIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserForUserCompanyIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserForUserEmployeeIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserForUserEmployeeIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserGroupForUserGroupUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserGroupForUserGroupUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserOnBehalfPermissionForUserOnBehalfPermissionsOnBehalfOfUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserOnBehalfPermissionForUserOnBehalfPermissionsOnBehalfOfUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserRoleForUserRoleUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserRoleForUserRoleUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserSettingForUserSettingUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserSettingForUserSettingUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserSystemFieldForUserSystemFieldUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserSystemFieldForUserSystemFieldUserIdForeignPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnVacationUserForVacationUserCreatorUserIdForeignUsingUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnVacationUserForVacationUserCreatorUserIdForeignPatch;
};

/** Represents an update to a `User`. Fields that are set will be updated. */
export type UserPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

export type UserRole = {
  __typename?: 'UserRole';
  /** Reads a single `Company` that is related to this `UserRole`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  departments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  excludeRole: Scalars['Boolean'];
  itemIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Reads a single `Role` that is related to this `UserRole`. */
  role?: Maybe<Role>;
  roleId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `UserRole`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** The `userRole` to be created by this mutation. */
export type UserRoleCompanyIdFkeyConnectionUserRoleCreateInput = {
  company?: InputMaybe<UserRoleCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<UserRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `UserRoleInput` mutation. */
export type UserRoleCompanyIdFkeyInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnUserRoleForUserRoleCompanyIdFkeyUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `userRole` in the `CompanyInput` mutation. */
export type UserRoleCompanyIdFkeyInverseInput = {
  /** The primary key(s) for `userRole` for the far side of the relationship. */
  connectByUserIdAndRoleId?: InputMaybe<Array<UserRoleUserRolePkeyConnect>>;
  /** A `UserRoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserRoleCompanyIdFkeyConnectionUserRoleCreateInput>>;
  /** The primary key(s) for `userRole` for the far side of the relationship. */
  deleteByUserIdAndRoleId?: InputMaybe<Array<UserRoleUserRolePkeyDelete>>;
  /** Flag indicating whether all other `userRole` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userRole` for the far side of the relationship. */
  updateByUserIdAndRoleId?: InputMaybe<Array<UserRoleOnUserRoleForUserRoleCompanyIdFkeyUsingUserRolePkeyUpdate>>;
};

/**
 * A condition to be used against `UserRole` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserRoleCondition = {
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departments` field. */
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `excludeRole` field. */
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `itemIds` field. */
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `roleId` field. */
  roleId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `UserRole` object types. All fields are combined with a logical ‘and.’ */
export type UserRoleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserRoleFilter>>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departments` field. */
  departments?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `excludeRole` field. */
  excludeRole?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `itemIds` field. */
  itemIds?: InputMaybe<UuidListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserRoleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserRoleFilter>>;
  /** Filter by the object’s `role` relation. */
  role?: InputMaybe<RoleFilter>;
  /** Filter by the object’s `roleId` field. */
  roleId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `UserRole` */
export type UserRoleInput = {
  company?: InputMaybe<UserRoleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<UserRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `userRole` to look up the row to update. */
export type UserRoleOnUserRoleForUserRoleCompanyIdFkeyUsingUserRolePkeyUpdate = {
  /** An object where the defined keys will be set on the `userRole` being updated. */
  patch: UpdateUserRoleOnUserRoleForUserRoleCompanyIdFkeyPatch;
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `userRole` to look up the row to update. */
export type UserRoleOnUserRoleForUserRoleRoleIdForeignUsingUserRolePkeyUpdate = {
  /** An object where the defined keys will be set on the `userRole` being updated. */
  patch: UpdateUserRoleOnUserRoleForUserRoleRoleIdForeignPatch;
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `userRole` to look up the row to update. */
export type UserRoleOnUserRoleForUserRoleUserIdForeignUsingUserRolePkeyUpdate = {
  /** An object where the defined keys will be set on the `userRole` being updated. */
  patch: UpdateUserRoleOnUserRoleForUserRoleUserIdForeignPatch;
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** Represents an update to a `UserRole`. Fields that are set will be updated. */
export type UserRolePatch = {
  company?: InputMaybe<UserRoleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<UserRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** The `role` to be created by this mutation. */
export type UserRoleRoleIdForeignConnectionRoleCreateInput = {
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleRoleIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  info: Scalars['String'];
  name: Scalars['String'];
  relationRoles?: InputMaybe<RelationRoleRoleIdForeignInverseInput>;
  roleDependenciesToDependentOnUsingId?: InputMaybe<RoleDependencyDependentOnForeignInverseInput>;
  roleDependenciesToRoleIdUsingId?: InputMaybe<RoleDependencyRoleIdForeignInverseInput>;
  scopes?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleRoleIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleRoleIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleRoleIdForeignInverseInput>;
  usesItemIds?: InputMaybe<Scalars['Boolean']>;
};

/** The `userRole` to be created by this mutation. */
export type UserRoleRoleIdForeignConnectionUserRoleCreateInput = {
  company?: InputMaybe<UserRoleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<UserRoleRoleIdForeignInput>;
  user?: InputMaybe<UserRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `role` in the `UserRoleInput` mutation. */
export type UserRoleRoleIdForeignInput = {
  /** The primary key(s) for `role` for the far side of the relationship. */
  connectById?: InputMaybe<RoleRolePkeyConnect>;
  /** A `RoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserRoleRoleIdForeignConnectionRoleCreateInput>;
  /** The primary key(s) for `role` for the far side of the relationship. */
  deleteById?: InputMaybe<RoleRolePkeyDelete>;
  /** The primary key(s) and patch data for `role` for the far side of the relationship. */
  updateById?: InputMaybe<RoleOnUserRoleForUserRoleRoleIdForeignUsingRolePkeyUpdate>;
};

/** Input for the nested mutation of `userRole` in the `RoleInput` mutation. */
export type UserRoleRoleIdForeignInverseInput = {
  /** The primary key(s) for `userRole` for the far side of the relationship. */
  connectByUserIdAndRoleId?: InputMaybe<Array<UserRoleUserRolePkeyConnect>>;
  /** A `UserRoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserRoleRoleIdForeignConnectionUserRoleCreateInput>>;
  /** The primary key(s) for `userRole` for the far side of the relationship. */
  deleteByUserIdAndRoleId?: InputMaybe<Array<UserRoleUserRolePkeyDelete>>;
  /** Flag indicating whether all other `userRole` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userRole` for the far side of the relationship. */
  updateByUserIdAndRoleId?: InputMaybe<Array<UserRoleOnUserRoleForUserRoleRoleIdForeignUsingUserRolePkeyUpdate>>;
};

/** The `userRole` to be created by this mutation. */
export type UserRoleUserIdForeignConnectionUserRoleCreateInput = {
  company?: InputMaybe<UserRoleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<UserRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserRoleUserIdForeignInput>;
};

/** Input for the nested mutation of `user` in the `UserRoleInput` mutation. */
export type UserRoleUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserRoleForUserRoleUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `userRole` in the `UserInput` mutation. */
export type UserRoleUserIdForeignInverseInput = {
  /** The primary key(s) for `userRole` for the far side of the relationship. */
  connectByUserIdAndRoleId?: InputMaybe<Array<UserRoleUserRolePkeyConnect>>;
  /** A `UserRoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserRoleUserIdForeignConnectionUserRoleCreateInput>>;
  /** The primary key(s) for `userRole` for the far side of the relationship. */
  deleteByUserIdAndRoleId?: InputMaybe<Array<UserRoleUserRolePkeyDelete>>;
  /** Flag indicating whether all other `userRole` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userRole` for the far side of the relationship. */
  updateByUserIdAndRoleId?: InputMaybe<Array<UserRoleOnUserRoleForUserRoleUserIdForeignUsingUserRolePkeyUpdate>>;
};

/** The fields on `userRole` to look up the row to connect. */
export type UserRoleUserRolePkeyConnect = {
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `userRole` to look up the row to delete. */
export type UserRoleUserRolePkeyDelete = {
  roleId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** A connection to a list of `UserRole` values. */
export type UserRolesConnection = {
  __typename?: 'UserRolesConnection';
  /** A list of edges which contains the `UserRole` and cursor to aid in pagination. */
  edges: Array<UserRolesEdge>;
  /** A list of `UserRole` objects. */
  nodes: Array<Maybe<UserRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserRole` edge in the connection. */
export type UserRolesEdge = {
  __typename?: 'UserRolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserRole` at the end of the edge. */
  node?: Maybe<UserRole>;
};

/** Methods to use when ordering `UserRole`. */
export type UserRolesOrderBy =
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'EXCLUDE_ROLE_ASC'
  | 'EXCLUDE_ROLE_DESC'
  | 'ITEM_IDS_ASC'
  | 'ITEM_IDS_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROLE_BY_ROLE_ID__COMPANY_ID_ASC'
  | 'ROLE_BY_ROLE_ID__COMPANY_ID_DESC'
  | 'ROLE_BY_ROLE_ID__DESCRIPTION_ASC'
  | 'ROLE_BY_ROLE_ID__DESCRIPTION_DESC'
  | 'ROLE_BY_ROLE_ID__ID_ASC'
  | 'ROLE_BY_ROLE_ID__ID_DESC'
  | 'ROLE_BY_ROLE_ID__INFO_ASC'
  | 'ROLE_BY_ROLE_ID__INFO_DESC'
  | 'ROLE_BY_ROLE_ID__NAME_ASC'
  | 'ROLE_BY_ROLE_ID__NAME_DESC'
  | 'ROLE_BY_ROLE_ID__SCOPES_ASC'
  | 'ROLE_BY_ROLE_ID__SCOPES_DESC'
  | 'ROLE_BY_ROLE_ID__USES_ITEM_IDS_ASC'
  | 'ROLE_BY_ROLE_ID__USES_ITEM_IDS_DESC'
  | 'ROLE_ID_ASC'
  | 'ROLE_ID_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type UserSetting = {
  __typename?: 'UserSetting';
  key: UserSettingKey;
  /** Reads a single `User` that is related to this `UserSetting`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
  value: Scalars['JSON'];
};

/**
 * A condition to be used against `UserSetting` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserSettingCondition = {
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<UserSettingKey>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['JSON']>;
};

/** A filter to be used against `UserSetting` object types. All fields are combined with a logical ‘and.’ */
export type UserSettingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserSettingFilter>>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<UserSettingKeyFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserSettingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserSettingFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<JsonFilter>;
};

/** An input for mutations affecting `UserSetting` */
export type UserSettingInput = {
  key: UserSettingKey;
  user?: InputMaybe<UserSettingUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  value: Scalars['JSON'];
};

export type UserSettingKey =
  | 'ALL_DOCUMENTS_SETTINGS'
  | 'ALL_DOCUMENTS_VIEW'
  | 'DASHBOARD_VIEW'
  | 'DOCUMENT_FOLDER_SORT'
  | 'DOCUMENT_FOLDER_TABLE_SORT'
  | 'DOCUMENT_FOLDER_VIEW'
  | 'FINISHED_NATIVE_APP_ONBOARDING'
  | 'NOTIFICATIONS_INCLUDE_OWN_CHANGES'
  | 'PREFERRED_DATE_FORMAT'
  | 'PULSE'
  /** Show views in employee list */
  | 'SHOW_VIEWS_EMPLOYEE_LIST'
  | 'SUPERADMIN_STAY_ON_SAME_PAGE_WHEN_SWITCHING_USER'
  /** Whether the user has multiple weeks enabled in their automatic time registration setup */
  | 'TIME_REGISTRATION_MULTI_WEEK_ENABLED'
  /** The time zone the user lives in */
  | 'TIME_ZONE'
  | 'TUTORIAL_COLLAPSE_SUBMENU'
  | 'TUTORIAL_DOCUMENT_FOLDERS'
  | 'TUTORIAL_EXPAND_SUBMENU'
  | 'TUTORIAL_FOLDER_SCHEME'
  | 'TUTORIAL_PERMISSION_SETTINGS'
  | 'TUTORIAL_PERSONAL_DATA_CARD_SETUP'
  | 'UNREAD_ENGAGEMENTS'
  /** How many days to show in the day calendar view */
  | 'VACATION_DAY_VIEW_NUMBER_OF_DAYS'
  | 'VACATION_HOLIDAY_COUNTRY'
  | 'VACATION_PREFERRED_VIEW'
  | 'VACATION_SELECTED_DEPARTMENTS'
  | 'VACATION_SELECTED_TYPES'
  | 'VACATION_SHOW_APPROVED_ABSENCE'
  | 'VACATION_SHOW_DENIED_ABSENCE'
  | 'VACATION_SHOW_HOLIDAYS'
  | 'VACATION_SHOW_NEIGHBORING_MONTHS'
  | 'VACATION_SHOW_UNAPPROVED_ABSENCE'
  | 'VACATION_SHOW_WEEK_NUMBERS';

/** A filter to be used against UserSettingKey fields. All fields are combined with a logical ‘and.’ */
export type UserSettingKeyFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserSettingKey>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserSettingKey>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserSettingKey>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserSettingKey>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserSettingKey>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserSettingKey>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserSettingKey>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserSettingKey>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserSettingKey>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserSettingKey>>;
};

/** The fields on `userSetting` to look up the row to update. */
export type UserSettingOnUserSettingForUserSettingUserIdForeignUsingUserSettingPkeyUpdate = {
  key: UserSettingKey;
  /** An object where the defined keys will be set on the `userSetting` being updated. */
  patch: UpdateUserSettingOnUserSettingForUserSettingUserIdForeignPatch;
  userId: Scalars['UUID'];
};

/** Represents an update to a `UserSetting`. Fields that are set will be updated. */
export type UserSettingPatch = {
  key?: InputMaybe<UserSettingKey>;
  user?: InputMaybe<UserSettingUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['JSON']>;
};

/** The `userSetting` to be created by this mutation. */
export type UserSettingUserIdForeignConnectionUserSettingCreateInput = {
  key: UserSettingKey;
  user?: InputMaybe<UserSettingUserIdForeignInput>;
  value: Scalars['JSON'];
};

/** Input for the nested mutation of `user` in the `UserSettingInput` mutation. */
export type UserSettingUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserSettingForUserSettingUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `userSetting` in the `UserInput` mutation. */
export type UserSettingUserIdForeignInverseInput = {
  /** The primary key(s) for `userSetting` for the far side of the relationship. */
  connectByUserIdAndKey?: InputMaybe<Array<UserSettingUserSettingPkeyConnect>>;
  /** A `UserSettingInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserSettingUserIdForeignConnectionUserSettingCreateInput>>;
  /** The primary key(s) for `userSetting` for the far side of the relationship. */
  deleteByUserIdAndKey?: InputMaybe<Array<UserSettingUserSettingPkeyDelete>>;
  /** Flag indicating whether all other `userSetting` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userSetting` for the far side of the relationship. */
  updateByUserIdAndKey?: InputMaybe<Array<UserSettingOnUserSettingForUserSettingUserIdForeignUsingUserSettingPkeyUpdate>>;
};

/** The fields on `userSetting` to look up the row to connect. */
export type UserSettingUserSettingPkeyConnect = {
  key: UserSettingKey;
  userId: Scalars['UUID'];
};

/** The fields on `userSetting` to look up the row to delete. */
export type UserSettingUserSettingPkeyDelete = {
  key: UserSettingKey;
  userId: Scalars['UUID'];
};

/** A connection to a list of `UserSetting` values. */
export type UserSettingsConnection = {
  __typename?: 'UserSettingsConnection';
  /** A list of edges which contains the `UserSetting` and cursor to aid in pagination. */
  edges: Array<UserSettingsEdge>;
  /** A list of `UserSetting` objects. */
  nodes: Array<Maybe<UserSetting>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserSetting` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserSetting` edge in the connection. */
export type UserSettingsEdge = {
  __typename?: 'UserSettingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserSetting` at the end of the edge. */
  node?: Maybe<UserSetting>;
};

/** Methods to use when ordering `UserSetting`. */
export type UserSettingsOrderBy =
  | 'KEY_ASC'
  | 'KEY_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC'
  | 'VALUE_ASC'
  | 'VALUE_DESC';

export type UserSystemField = {
  __typename?: 'UserSystemField';
  approvalIsRequired: Scalars['Boolean'];
  /** Reads a single `Company` that is related to this `UserSystemField`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  companySystemFieldOptionId?: Maybe<Scalars['UUID']>;
  data?: Maybe<Scalars['JSON']>;
  departmentIds: Array<Maybe<Scalars['UUID']>>;
  /** Reads a single `FieldGroup` that is related to this `UserSystemField`. */
  fieldGroup?: Maybe<FieldGroup>;
  fieldGroupId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `FutureDatum`. */
  futureData: FutureDataConnection;
  humanReadableValue?: Maybe<Scalars['String']>;
  leaderDepartmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  sensitive: Scalars['Boolean'];
  /** Reads a single `SystemField` that is related to this `UserSystemField`. */
  systemField?: Maybe<SystemField>;
  systemFieldId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `UserSystemField`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};


export type UserSystemFieldFutureDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<FutureDatumFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FutureDataOrderBy>>;
};

/** Input for the nested mutation of `company` in the `UserSystemFieldInput` mutation. */
export type UserSystemFieldCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnUserSystemFieldForUserSystemFieldCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `userSystemField` in the `CompanyInput` mutation. */
export type UserSystemFieldCompanyIdForeignInverseInput = {
  /** The primary key(s) for `userSystemField` for the far side of the relationship. */
  connectByUserIdAndSystemFieldId?: InputMaybe<Array<UserSystemFieldUserSystemFieldPkeyConnect>>;
  /** The primary key(s) and patch data for `userSystemField` for the far side of the relationship. */
  updateByUserIdAndSystemFieldId?: InputMaybe<Array<UserSystemFieldOnUserSystemFieldForUserSystemFieldCompanyIdForeignUsingUserSystemFieldPkeyUpdate>>;
};

/**
 * A condition to be used against `UserSystemField` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserSystemFieldCondition = {
  /** Checks for equality with the object’s `approvalIsRequired` field. */
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `companySystemFieldOptionId` field. */
  companySystemFieldOptionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `data` field. */
  data?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `fieldGroupId` field. */
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `leaderDepartmentIds` field. */
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `sensitive` field. */
  sensitive?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `systemFieldId` field. */
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `UserSystemFieldCountRecord` values. */
export type UserSystemFieldCountConnection = {
  __typename?: 'UserSystemFieldCountConnection';
  /** A list of edges which contains the `UserSystemFieldCountRecord` and cursor to aid in pagination. */
  edges: Array<UserSystemFieldCountEdge>;
  /** A list of `UserSystemFieldCountRecord` objects. */
  nodes: Array<Maybe<UserSystemFieldCountRecord>>;
  /** The count of *all* `UserSystemFieldCountRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserSystemFieldCountRecord` edge in the connection. */
export type UserSystemFieldCountEdge = {
  __typename?: 'UserSystemFieldCountEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserSystemFieldCountRecord` at the end of the edge. */
  node?: Maybe<UserSystemFieldCountRecord>;
};

/** The return type of our `userSystemFieldCount` query. */
export type UserSystemFieldCountRecord = {
  __typename?: 'UserSystemFieldCountRecord';
  count?: Maybe<Scalars['BigInt']>;
  value?: Maybe<Scalars['UUID']>;
};

/** A filter to be used against `UserSystemFieldCountRecord` object types. All fields are combined with a logical ‘and.’ */
export type UserSystemFieldCountRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserSystemFieldCountRecordFilter>>;
  /** Filter by the object’s `count` field. */
  count?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserSystemFieldCountRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserSystemFieldCountRecordFilter>>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<UuidFilter>;
};

/** The `fieldGroup` to be created by this mutation. */
export type UserSystemFieldFieldGroupIdForeignConnectionFieldGroupCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  fieldGroupCards?: InputMaybe<FieldGroupCardFieldGroupIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFieldGroupIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldFormFieldTypeIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFieldGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  userSystemFields?: InputMaybe<UserSystemFieldFieldGroupIdForeignInverseInput>;
};

/** Input for the nested mutation of `fieldGroup` in the `UserSystemFieldInput` mutation. */
export type UserSystemFieldFieldGroupIdForeignInput = {
  /** The primary key(s) for `fieldGroup` for the far side of the relationship. */
  connectById?: InputMaybe<FieldGroupFormFieldTypePkeyConnect>;
  /** A `FieldGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserSystemFieldFieldGroupIdForeignConnectionFieldGroupCreateInput>;
  /** The primary key(s) and patch data for `fieldGroup` for the far side of the relationship. */
  updateById?: InputMaybe<FieldGroupOnUserSystemFieldForUserSystemFieldFieldGroupIdForeignUsingFormFieldTypePkeyUpdate>;
};

/** Input for the nested mutation of `userSystemField` in the `FieldGroupInput` mutation. */
export type UserSystemFieldFieldGroupIdForeignInverseInput = {
  /** The primary key(s) for `userSystemField` for the far side of the relationship. */
  connectByUserIdAndSystemFieldId?: InputMaybe<Array<UserSystemFieldUserSystemFieldPkeyConnect>>;
  /** The primary key(s) and patch data for `userSystemField` for the far side of the relationship. */
  updateByUserIdAndSystemFieldId?: InputMaybe<Array<UserSystemFieldOnUserSystemFieldForUserSystemFieldFieldGroupIdForeignUsingUserSystemFieldPkeyUpdate>>;
};

/** A filter to be used against `UserSystemField` object types. All fields are combined with a logical ‘and.’ */
export type UserSystemFieldFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserSystemFieldFilter>>;
  /** Filter by the object’s `approvalIsRequired` field. */
  approvalIsRequired?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `companySystemFieldOptionId` field. */
  companySystemFieldOptionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `data` field. */
  data?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `fieldGroup` relation. */
  fieldGroup?: InputMaybe<FieldGroupFilter>;
  /** A related `fieldGroup` exists. */
  fieldGroupExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `fieldGroupId` field. */
  fieldGroupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `leaderDepartmentIds` field. */
  leaderDepartmentIds?: InputMaybe<UuidListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserSystemFieldFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserSystemFieldFilter>>;
  /** Filter by the object’s `sensitive` field. */
  sensitive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `systemField` relation. */
  systemField?: InputMaybe<SystemFieldFilter>;
  /** Filter by the object’s `systemFieldId` field. */
  systemFieldId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `userSystemField` to look up the row to update. */
export type UserSystemFieldOnUserSystemFieldForUserSystemFieldCompanyIdForeignUsingUserSystemFieldPkeyUpdate = {
  /** An object where the defined keys will be set on the `userSystemField` being updated. */
  patch: UpdateUserSystemFieldOnUserSystemFieldForUserSystemFieldCompanyIdForeignPatch;
  systemFieldId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `userSystemField` to look up the row to update. */
export type UserSystemFieldOnUserSystemFieldForUserSystemFieldFieldGroupIdForeignUsingUserSystemFieldPkeyUpdate = {
  /** An object where the defined keys will be set on the `userSystemField` being updated. */
  patch: UpdateUserSystemFieldOnUserSystemFieldForUserSystemFieldFieldGroupIdForeignPatch;
  systemFieldId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `userSystemField` to look up the row to update. */
export type UserSystemFieldOnUserSystemFieldForUserSystemFieldSystemFieldIdForeignUsingUserSystemFieldPkeyUpdate = {
  /** An object where the defined keys will be set on the `userSystemField` being updated. */
  patch: UpdateUserSystemFieldOnUserSystemFieldForUserSystemFieldSystemFieldIdForeignPatch;
  systemFieldId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The fields on `userSystemField` to look up the row to update. */
export type UserSystemFieldOnUserSystemFieldForUserSystemFieldUserIdForeignUsingUserSystemFieldPkeyUpdate = {
  /** An object where the defined keys will be set on the `userSystemField` being updated. */
  patch: UpdateUserSystemFieldOnUserSystemFieldForUserSystemFieldUserIdForeignPatch;
  systemFieldId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** Input for the nested mutation of `systemField` in the `UserSystemFieldInput` mutation. */
export type UserSystemFieldSystemFieldIdForeignInput = {
  /** The primary key(s) for `systemField` for the far side of the relationship. */
  connectById?: InputMaybe<SystemFieldSystemFieldPkeyConnect>;
  /** The primary key(s) for `systemField` for the far side of the relationship. */
  connectByName?: InputMaybe<SystemFieldSystemFieldNameUniqueConnect>;
  /** The primary key(s) and patch data for `systemField` for the far side of the relationship. */
  updateById?: InputMaybe<SystemFieldOnUserSystemFieldForUserSystemFieldSystemFieldIdForeignUsingSystemFieldPkeyUpdate>;
  /** The primary key(s) and patch data for `systemField` for the far side of the relationship. */
  updateByName?: InputMaybe<SystemFieldOnUserSystemFieldForUserSystemFieldSystemFieldIdForeignUsingSystemFieldNameUniqueUpdate>;
};

/** Input for the nested mutation of `userSystemField` in the `SystemFieldInput` mutation. */
export type UserSystemFieldSystemFieldIdForeignInverseInput = {
  /** The primary key(s) for `userSystemField` for the far side of the relationship. */
  connectByUserIdAndSystemFieldId?: InputMaybe<Array<UserSystemFieldUserSystemFieldPkeyConnect>>;
  /** The primary key(s) and patch data for `userSystemField` for the far side of the relationship. */
  updateByUserIdAndSystemFieldId?: InputMaybe<Array<UserSystemFieldOnUserSystemFieldForUserSystemFieldSystemFieldIdForeignUsingUserSystemFieldPkeyUpdate>>;
};

/** Input for the nested mutation of `user` in the `UserSystemFieldInput` mutation. */
export type UserSystemFieldUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserSystemFieldForUserSystemFieldUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `userSystemField` in the `UserInput` mutation. */
export type UserSystemFieldUserIdForeignInverseInput = {
  /** The primary key(s) for `userSystemField` for the far side of the relationship. */
  connectByUserIdAndSystemFieldId?: InputMaybe<Array<UserSystemFieldUserSystemFieldPkeyConnect>>;
  /** The primary key(s) and patch data for `userSystemField` for the far side of the relationship. */
  updateByUserIdAndSystemFieldId?: InputMaybe<Array<UserSystemFieldOnUserSystemFieldForUserSystemFieldUserIdForeignUsingUserSystemFieldPkeyUpdate>>;
};

/** The fields on `userSystemField` to look up the row to connect. */
export type UserSystemFieldUserSystemFieldPkeyConnect = {
  systemFieldId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** A connection to a list of `UserSystemField` values. */
export type UserSystemFieldsConnection = {
  __typename?: 'UserSystemFieldsConnection';
  /** A list of edges which contains the `UserSystemField` and cursor to aid in pagination. */
  edges: Array<UserSystemFieldsEdge>;
  /** A list of `UserSystemField` objects. */
  nodes: Array<Maybe<UserSystemField>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserSystemField` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserSystemField` edge in the connection. */
export type UserSystemFieldsEdge = {
  __typename?: 'UserSystemFieldsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserSystemField` at the end of the edge. */
  node?: Maybe<UserSystemField>;
};

/** Methods to use when ordering `UserSystemField`. */
export type UserSystemFieldsOrderBy =
  | 'APPROVAL_IS_REQUIRED_ASC'
  | 'APPROVAL_IS_REQUIRED_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'COMPANY_SYSTEM_FIELD_OPTION_ID_ASC'
  | 'COMPANY_SYSTEM_FIELD_OPTION_ID_DESC'
  | 'DATA_ASC'
  | 'DATA_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ACTIVE_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ACTIVE_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__COMPANY_ID_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__COMPANY_ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__CUSTOM_ID_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__CUSTOM_ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ID_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ID_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__LOCALIZED_NAME_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__LOCALIZED_NAME_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__NAME_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__NAME_DESC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ORDER_ASC'
  | 'FIELD_GROUP_BY_FIELD_GROUP_ID__ORDER_DESC'
  | 'FIELD_GROUP_ID_ASC'
  | 'FIELD_GROUP_ID_DESC'
  | 'LEADER_DEPARTMENT_IDS_ASC'
  | 'LEADER_DEPARTMENT_IDS_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SENSITIVE_ASC'
  | 'SENSITIVE_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ALWAYS_REQUIRED_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ALWAYS_REQUIRED_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__DOCUMENT_TEMPLATE_PLACEHOLDER_NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__DOCUMENT_TEMPLATE_PLACEHOLDER_NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__EXCLUDE_FROM_PLACEHOLDER_FORM_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__EXCLUDE_FROM_PLACEHOLDER_FORM_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ID_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__ID_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READABLE_NAME_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READABLE_NAME_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READ_ONLY_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__READ_ONLY_DESC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__TYPE_ASC'
  | 'SYSTEM_FIELD_BY_SYSTEM_FIELD_ID__TYPE_DESC'
  | 'SYSTEM_FIELD_ID_ASC'
  | 'SYSTEM_FIELD_ID_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** A filter to be used against many `Announcement` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyAnnouncementFilter = {
  /** Every related `Announcement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AnnouncementFilter>;
  /** No related `Announcement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AnnouncementFilter>;
  /** Some related `Announcement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AnnouncementFilter>;
};

/** A filter to be used against many `Approval` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyApprovalFilter = {
  /** Every related `Approval` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ApprovalFilter>;
  /** No related `Approval` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ApprovalFilter>;
  /** Some related `Approval` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ApprovalFilter>;
};

/** A filter to be used against many `AsyncJob` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyAsyncJobFilter = {
  /** Every related `AsyncJob` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AsyncJobFilter>;
  /** No related `AsyncJob` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AsyncJobFilter>;
  /** Some related `AsyncJob` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AsyncJobFilter>;
};

/** A filter to be used against many `AsyncJobItem` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyAsyncJobItemFilter = {
  /** Every related `AsyncJobItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AsyncJobItemFilter>;
  /** No related `AsyncJobItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AsyncJobItemFilter>;
  /** Some related `AsyncJobItem` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AsyncJobItemFilter>;
};

/** A filter to be used against many `ChangelogUser` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyChangelogUserFilter = {
  /** Every related `ChangelogUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ChangelogUserFilter>;
  /** No related `ChangelogUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ChangelogUserFilter>;
  /** Some related `ChangelogUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ChangelogUserFilter>;
};

/** A filter to be used against many `ChosenColumn` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyChosenColumnFilter = {
  /** Every related `ChosenColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ChosenColumnFilter>;
  /** No related `ChosenColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ChosenColumnFilter>;
  /** Some related `ChosenColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ChosenColumnFilter>;
};

/** A filter to be used against many `ContractSignPending` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyContractSignPendingFilter = {
  /** Every related `ContractSignPending` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractSignPendingFilter>;
  /** No related `ContractSignPending` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractSignPendingFilter>;
  /** Some related `ContractSignPending` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractSignPendingFilter>;
};

/** A filter to be used against many `ContractSignPendingSigner` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyContractSignPendingSignerFilter = {
  /** Every related `ContractSignPendingSigner` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractSignPendingSignerFilter>;
  /** No related `ContractSignPendingSigner` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractSignPendingSignerFilter>;
  /** Some related `ContractSignPendingSigner` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractSignPendingSignerFilter>;
};

/** A filter to be used against many `ContractTemplateUser` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyContractTemplateUserFilter = {
  /** Every related `ContractTemplateUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContractTemplateUserFilter>;
  /** No related `ContractTemplateUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContractTemplateUserFilter>;
  /** Some related `ContractTemplateUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContractTemplateUserFilter>;
};

/** A filter to be used against many `DocumentFolderUser` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyDocumentFolderUserFilter = {
  /** Every related `DocumentFolderUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentFolderUserFilter>;
  /** No related `DocumentFolderUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentFolderUserFilter>;
  /** Some related `DocumentFolderUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentFolderUserFilter>;
};

/** A filter to be used against many `DocumentUserPermission` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyDocumentUserPermissionFilter = {
  /** Every related `DocumentUserPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentUserPermissionFilter>;
  /** No related `DocumentUserPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentUserPermissionFilter>;
  /** Some related `DocumentUserPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentUserPermissionFilter>;
};

/** A filter to be used against many `DocumentUserResponsible` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyDocumentUserResponsibleFilter = {
  /** Every related `DocumentUserResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DocumentUserResponsibleFilter>;
  /** No related `DocumentUserResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DocumentUserResponsibleFilter>;
  /** Some related `DocumentUserResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DocumentUserResponsibleFilter>;
};

/** A filter to be used against many `EmployeeCasefile` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyEmployeeCasefileFilter = {
  /** Every related `EmployeeCasefile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmployeeCasefileFilter>;
  /** No related `EmployeeCasefile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmployeeCasefileFilter>;
  /** Some related `EmployeeCasefile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmployeeCasefileFilter>;
};

/** A filter to be used against many `Equipment` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyEquipmentFilter = {
  /** Every related `Equipment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EquipmentFilter>;
  /** No related `Equipment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EquipmentFilter>;
  /** Some related `Equipment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EquipmentFilter>;
};

/** A filter to be used against many `EventUser` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyEventUserFilter = {
  /** Every related `EventUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EventUserFilter>;
  /** No related `EventUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EventUserFilter>;
  /** Some related `EventUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EventUserFilter>;
};

/** A filter to be used against many `FilterPreset` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyFilterPresetFilter = {
  /** Every related `FilterPreset` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FilterPresetFilter>;
  /** No related `FilterPreset` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FilterPresetFilter>;
  /** Some related `FilterPreset` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FilterPresetFilter>;
};

/** A filter to be used against many `FilterView` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyFilterViewFilter = {
  /** Every related `FilterView` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FilterViewFilter>;
  /** No related `FilterView` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FilterViewFilter>;
  /** Some related `FilterView` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FilterViewFilter>;
};

/** A filter to be used against many `FormFieldEntry` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyFormFieldEntryFilter = {
  /** Every related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FormFieldEntryFilter>;
  /** No related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FormFieldEntryFilter>;
  /** Some related `FormFieldEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FormFieldEntryFilter>;
};

/** A filter to be used against many `FutureDatum` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyFutureDatumFilter = {
  /** Every related `FutureDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FutureDatumFilter>;
  /** No related `FutureDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FutureDatumFilter>;
  /** Some related `FutureDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FutureDatumFilter>;
};

/** A filter to be used against many `LoggedActionNote` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyLoggedActionNoteFilter = {
  /** Every related `LoggedActionNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LoggedActionNoteFilter>;
  /** No related `LoggedActionNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LoggedActionNoteFilter>;
  /** Some related `LoggedActionNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LoggedActionNoteFilter>;
};

/** A filter to be used against many `LoginLog` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyLoginLogFilter = {
  /** Every related `LoginLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LoginLogFilter>;
  /** No related `LoginLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LoginLogFilter>;
  /** Some related `LoginLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LoginLogFilter>;
};

/** A filter to be used against many `NotificationCustomRecipient` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyNotificationCustomRecipientFilter = {
  /** Every related `NotificationCustomRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationCustomRecipientFilter>;
  /** No related `NotificationCustomRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationCustomRecipientFilter>;
  /** Some related `NotificationCustomRecipient` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationCustomRecipientFilter>;
};

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

/** A filter to be used against many `Post` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyPostFilter = {
  /** Every related `Post` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PostFilter>;
  /** No related `Post` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PostFilter>;
  /** Some related `Post` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PostFilter>;
};

/** A filter to be used against many `PreboardingComment` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyPreboardingCommentFilter = {
  /** Every related `PreboardingComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingCommentFilter>;
  /** No related `PreboardingComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingCommentFilter>;
  /** Some related `PreboardingComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingCommentFilter>;
};

/** A filter to be used against many `PreboardingEmailLog` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyPreboardingEmailLogFilter = {
  /** Every related `PreboardingEmailLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingEmailLogFilter>;
  /** No related `PreboardingEmailLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingEmailLogFilter>;
  /** Some related `PreboardingEmailLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingEmailLogFilter>;
};

/** A filter to be used against many `PreboardingEmployee` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyPreboardingEmployeeFilter = {
  /** Every related `PreboardingEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingEmployeeFilter>;
  /** No related `PreboardingEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingEmployeeFilter>;
  /** Some related `PreboardingEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingEmployeeFilter>;
};

/** A filter to be used against many `Preboarding` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyPreboardingFilter = {
  /** Every related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingFilter>;
  /** No related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingFilter>;
  /** Some related `Preboarding` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingFilter>;
};

/** A filter to be used against many `PreboardingFormCache` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyPreboardingFormCacheFilter = {
  /** Every related `PreboardingFormCache` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingFormCacheFilter>;
  /** No related `PreboardingFormCache` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingFormCacheFilter>;
  /** Some related `PreboardingFormCache` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingFormCacheFilter>;
};

/** A filter to be used against many `PreboardingProcess` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyPreboardingProcessFilter = {
  /** Every related `PreboardingProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingProcessFilter>;
  /** No related `PreboardingProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingProcessFilter>;
  /** Some related `PreboardingProcess` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingProcessFilter>;
};

/** A filter to be used against many `PreboardingResult` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyPreboardingResultFilter = {
  /** Every related `PreboardingResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingResultFilter>;
  /** No related `PreboardingResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingResultFilter>;
  /** Some related `PreboardingResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingResultFilter>;
};

/** A filter to be used against many `PreboardingResultSlideComment` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyPreboardingResultSlideCommentFilter = {
  /** Every related `PreboardingResultSlideComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PreboardingResultSlideCommentFilter>;
  /** No related `PreboardingResultSlideComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PreboardingResultSlideCommentFilter>;
  /** Some related `PreboardingResultSlideComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PreboardingResultSlideCommentFilter>;
};

/** A filter to be used against many `Process` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyProcessFilter = {
  /** Every related `Process` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProcessFilter>;
  /** No related `Process` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProcessFilter>;
  /** Some related `Process` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProcessFilter>;
};

/** A filter to be used against many `ProcessResponsible` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyProcessResponsibleFilter = {
  /** Every related `ProcessResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProcessResponsibleFilter>;
  /** No related `ProcessResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProcessResponsibleFilter>;
  /** Some related `ProcessResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProcessResponsibleFilter>;
};

/** A filter to be used against many `Product` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyProductFilter = {
  /** Every related `Product` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProductFilter>;
  /** No related `Product` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProductFilter>;
  /** Some related `Product` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProductFilter>;
};

/** A filter to be used against many `Project` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyProjectFilter = {
  /** Every related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectFilter>;
  /** No related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectFilter>;
  /** Some related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectFilter>;
};

/** A filter to be used against many `PulseSurveyAnswer` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyPulseSurveyAnswerFilter = {
  /** Every related `PulseSurveyAnswer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PulseSurveyAnswerFilter>;
  /** No related `PulseSurveyAnswer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PulseSurveyAnswerFilter>;
  /** Some related `PulseSurveyAnswer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PulseSurveyAnswerFilter>;
};

/** A filter to be used against many `ReferenceToken` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyReferenceTokenFilter = {
  /** Every related `ReferenceToken` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ReferenceTokenFilter>;
  /** No related `ReferenceToken` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ReferenceTokenFilter>;
  /** Some related `ReferenceToken` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ReferenceTokenFilter>;
};

/** A filter to be used against many `RoadmapItemComment` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyRoadmapItemCommentFilter = {
  /** Every related `RoadmapItemComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoadmapItemCommentFilter>;
  /** No related `RoadmapItemComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoadmapItemCommentFilter>;
  /** Some related `RoadmapItemComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoadmapItemCommentFilter>;
};

/** A filter to be used against many `RoadmapItemVote` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyRoadmapItemVoteFilter = {
  /** Every related `RoadmapItemVote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoadmapItemVoteFilter>;
  /** No related `RoadmapItemVote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoadmapItemVoteFilter>;
  /** Some related `RoadmapItemVote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoadmapItemVoteFilter>;
};

/** A filter to be used against many `ScheduledMessage` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyScheduledMessageFilter = {
  /** Every related `ScheduledMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ScheduledMessageFilter>;
  /** No related `ScheduledMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ScheduledMessageFilter>;
  /** Some related `ScheduledMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ScheduledMessageFilter>;
};

/** A filter to be used against many `SuperUserLoginNote` object types. All fields are combined with a logical ‘and.’ */
export type UserToManySuperUserLoginNoteFilter = {
  /** Every related `SuperUserLoginNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SuperUserLoginNoteFilter>;
  /** No related `SuperUserLoginNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SuperUserLoginNoteFilter>;
  /** Some related `SuperUserLoginNote` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SuperUserLoginNoteFilter>;
};

/** A filter to be used against many `TaskEmployee` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyTaskEmployeeFilter = {
  /** Every related `TaskEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskEmployeeFilter>;
  /** No related `TaskEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskEmployeeFilter>;
  /** Some related `TaskEmployee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskEmployeeFilter>;
};

/** A filter to be used against many `Task` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyTaskFilter = {
  /** Every related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskFilter>;
  /** No related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskFilter>;
  /** Some related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskFilter>;
};

/** A filter to be used against many `TaskResponsible` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyTaskResponsibleFilter = {
  /** Every related `TaskResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskResponsibleFilter>;
  /** No related `TaskResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskResponsibleFilter>;
  /** Some related `TaskResponsible` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskResponsibleFilter>;
};

/** A filter to be used against many `TaskTemplate` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyTaskTemplateFilter = {
  /** Every related `TaskTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskTemplateFilter>;
  /** No related `TaskTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskTemplateFilter>;
  /** Some related `TaskTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskTemplateFilter>;
};

/** A filter to be used against many `TimeRegistrationEntry` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyTimeRegistrationEntryFilter = {
  /** Every related `TimeRegistrationEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationEntryFilter>;
  /** No related `TimeRegistrationEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationEntryFilter>;
  /** Some related `TimeRegistrationEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationEntryFilter>;
};

/** A filter to be used against many `TimeRegistrationEntryTemplate` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyTimeRegistrationEntryTemplateFilter = {
  /** Every related `TimeRegistrationEntryTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  /** No related `TimeRegistrationEntryTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
  /** Some related `TimeRegistrationEntryTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationEntryTemplateFilter>;
};

/** A filter to be used against many `TimeRegistrationPresence` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyTimeRegistrationPresenceFilter = {
  /** Every related `TimeRegistrationPresence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationPresenceFilter>;
  /** No related `TimeRegistrationPresence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationPresenceFilter>;
  /** Some related `TimeRegistrationPresence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationPresenceFilter>;
};

/** A filter to be used against many `TimeRegistrationPresenceTemplate` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyTimeRegistrationPresenceTemplateFilter = {
  /** Every related `TimeRegistrationPresenceTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
  /** No related `TimeRegistrationPresenceTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
  /** Some related `TimeRegistrationPresenceTemplate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationPresenceTemplateFilter>;
};

/** A filter to be used against many `TimeRegistrationTemplateWeek` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyTimeRegistrationTemplateWeekFilter = {
  /** Every related `TimeRegistrationTemplateWeek` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TimeRegistrationTemplateWeekFilter>;
  /** No related `TimeRegistrationTemplateWeek` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TimeRegistrationTemplateWeekFilter>;
  /** Some related `TimeRegistrationTemplateWeek` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TimeRegistrationTemplateWeekFilter>;
};

/** A filter to be used against many `UserAnnouncement` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserAnnouncementFilter = {
  /** Every related `UserAnnouncement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserAnnouncementFilter>;
  /** No related `UserAnnouncement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserAnnouncementFilter>;
  /** Some related `UserAnnouncement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserAnnouncementFilter>;
};

/** A filter to be used against many `UserCompanyGroup` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserCompanyGroupFilter = {
  /** Every related `UserCompanyGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCompanyGroupFilter>;
  /** No related `UserCompanyGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCompanyGroupFilter>;
  /** Some related `UserCompanyGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCompanyGroupFilter>;
};

/** A filter to be used against many `UserCompanyRole` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserCompanyRoleFilter = {
  /** Every related `UserCompanyRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCompanyRoleFilter>;
  /** No related `UserCompanyRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCompanyRoleFilter>;
  /** Some related `UserCompanyRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCompanyRoleFilter>;
};

/** A filter to be used against many `UserCompetenceEvaluationComment` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserCompetenceEvaluationCommentFilter = {
  /** Every related `UserCompetenceEvaluationComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCompetenceEvaluationCommentFilter>;
  /** No related `UserCompetenceEvaluationComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCompetenceEvaluationCommentFilter>;
  /** Some related `UserCompetenceEvaluationComment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCompetenceEvaluationCommentFilter>;
};

/** A filter to be used against many `UserCompetenceEvaluation` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserCompetenceEvaluationFilter = {
  /** Every related `UserCompetenceEvaluation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCompetenceEvaluationFilter>;
  /** No related `UserCompetenceEvaluation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCompetenceEvaluationFilter>;
  /** Some related `UserCompetenceEvaluation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCompetenceEvaluationFilter>;
};

/** A filter to be used against many `UserCompetence` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserCompetenceFilter = {
  /** Every related `UserCompetence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCompetenceFilter>;
  /** No related `UserCompetence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCompetenceFilter>;
  /** Some related `UserCompetence` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCompetenceFilter>;
};

/** A filter to be used against many `UserDepartment` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserDepartmentFilter = {
  /** Every related `UserDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserDepartmentFilter>;
  /** No related `UserDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserDepartmentFilter>;
  /** Some related `UserDepartment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserDepartmentFilter>;
};

/** A filter to be used against many `UserDepartmentGroup` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserDepartmentGroupFilter = {
  /** Every related `UserDepartmentGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserDepartmentGroupFilter>;
  /** No related `UserDepartmentGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserDepartmentGroupFilter>;
  /** Some related `UserDepartmentGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserDepartmentGroupFilter>;
};

/** A filter to be used against many `UserDepartmentRole` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserDepartmentRoleFilter = {
  /** Every related `UserDepartmentRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserDepartmentRoleFilter>;
  /** No related `UserDepartmentRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserDepartmentRoleFilter>;
  /** Some related `UserDepartmentRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserDepartmentRoleFilter>;
};

/** A filter to be used against many `UserGroup` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserGroupFilter = {
  /** Every related `UserGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserGroupFilter>;
  /** No related `UserGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserGroupFilter>;
  /** Some related `UserGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserGroupFilter>;
};

/** A filter to be used against many `UserOnBehalfPermission` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserOnBehalfPermissionFilter = {
  /** Every related `UserOnBehalfPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserOnBehalfPermissionFilter>;
  /** No related `UserOnBehalfPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserOnBehalfPermissionFilter>;
  /** Some related `UserOnBehalfPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserOnBehalfPermissionFilter>;
};

/** A filter to be used against many `UserRole` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserRoleFilter = {
  /** Every related `UserRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserRoleFilter>;
  /** No related `UserRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserRoleFilter>;
  /** Some related `UserRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserRoleFilter>;
};

/** A filter to be used against many `UserSetting` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserSettingFilter = {
  /** Every related `UserSetting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserSettingFilter>;
  /** No related `UserSetting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserSettingFilter>;
  /** Some related `UserSetting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserSettingFilter>;
};

/** A filter to be used against many `UserSystemField` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserSystemFieldFilter = {
  /** Every related `UserSystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserSystemFieldFilter>;
  /** No related `UserSystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserSystemFieldFilter>;
  /** Some related `UserSystemField` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserSystemFieldFilter>;
};

/** A filter to be used against many `VacationUser` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyVacationUserFilter = {
  /** Every related `VacationUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<VacationUserFilter>;
  /** No related `VacationUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<VacationUserFilter>;
  /** Some related `VacationUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<VacationUserFilter>;
};

/** The fields on `user` to look up the row to connect. */
export type UserUserPkeyConnect = {
  id: Scalars['UUID'];
};

/** A connection to a list of `User` values. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node?: Maybe<User>;
};

/** Methods to use when ordering `User`. */
export type UsersOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ADDRESS_ASC'
  | 'ADDRESS_DESC'
  | 'ANNOUNCEMENTS_BY_USER_ID__COUNT_ASC'
  | 'ANNOUNCEMENTS_BY_USER_ID__COUNT_DESC'
  | 'APPROVALS_BY_AFFECTED_USER_ID__COUNT_ASC'
  | 'APPROVALS_BY_AFFECTED_USER_ID__COUNT_DESC'
  | 'APPROVALS_BY_APPROVING_USER_ID__COUNT_ASC'
  | 'APPROVALS_BY_APPROVING_USER_ID__COUNT_DESC'
  | 'APPROVALS_BY_REQUESTING_USER_ID__COUNT_ASC'
  | 'APPROVALS_BY_REQUESTING_USER_ID__COUNT_DESC'
  | 'ASYNC_JOBS_BY_USER_ID__COUNT_ASC'
  | 'ASYNC_JOBS_BY_USER_ID__COUNT_DESC'
  | 'ASYNC_JOB_ITEMS_BY_USER_ID__COUNT_ASC'
  | 'ASYNC_JOB_ITEMS_BY_USER_ID__COUNT_DESC'
  | 'BANK_ACCOUNT_NUMBER_ASC'
  | 'BANK_ACCOUNT_NUMBER_DESC'
  | 'BANK_REGISTRATION_NUMBER_ASC'
  | 'BANK_REGISTRATION_NUMBER_DESC'
  | 'BIRTHDATE_ASC'
  | 'BIRTHDATE_DESC'
  | 'CAN_LOGIN_APP_ASC'
  | 'CAN_LOGIN_APP_DESC'
  | 'CAN_LOGIN_ASC'
  | 'CAN_LOGIN_DESC'
  | 'CAN_LOGIN_SSO_ASC'
  | 'CAN_LOGIN_SSO_DESC'
  | 'CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'CHANGELOG_USERS_BY_USER_ID__COUNT_ASC'
  | 'CHANGELOG_USERS_BY_USER_ID__COUNT_DESC'
  | 'CHOSEN_COLUMNS_BY_USER_ID__COUNT_ASC'
  | 'CHOSEN_COLUMNS_BY_USER_ID__COUNT_DESC'
  | 'CITY_ASC'
  | 'CITY_DESC'
  | 'COMPANY_ADMIN_ASC'
  | 'COMPANY_ADMIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CONTRACT_SIGN_PENDINGS_BY_CREATOR_USER_ID__COUNT_ASC'
  | 'CONTRACT_SIGN_PENDINGS_BY_CREATOR_USER_ID__COUNT_DESC'
  | 'CONTRACT_SIGN_PENDINGS_BY_NEXT_SIGNING_USER_ID__COUNT_ASC'
  | 'CONTRACT_SIGN_PENDINGS_BY_NEXT_SIGNING_USER_ID__COUNT_DESC'
  | 'CONTRACT_SIGN_PENDINGS_BY_USER_ID__COUNT_ASC'
  | 'CONTRACT_SIGN_PENDINGS_BY_USER_ID__COUNT_DESC'
  | 'CONTRACT_SIGN_PENDING_SIGNERS_BY_ON_BEHALF_OF_USER_ID__COUNT_ASC'
  | 'CONTRACT_SIGN_PENDING_SIGNERS_BY_ON_BEHALF_OF_USER_ID__COUNT_DESC'
  | 'CONTRACT_SIGN_PENDING_SIGNERS_BY_USER_ID__COUNT_ASC'
  | 'CONTRACT_SIGN_PENDING_SIGNERS_BY_USER_ID__COUNT_DESC'
  | 'CONTRACT_TEMPLATE_USERS_BY_USER_ID__COUNT_ASC'
  | 'CONTRACT_TEMPLATE_USERS_BY_USER_ID__COUNT_DESC'
  | 'CPR_ASC'
  | 'CPR_DESC'
  | 'CUSTOM_ID_ASC'
  | 'CUSTOM_ID_DESC'
  | 'DELETE_AT_ASC'
  | 'DELETE_AT_DESC'
  | 'DELETE_REMINDED_ASC'
  | 'DELETE_REMINDED_DESC'
  | 'DEPARTMENTS_ASC'
  | 'DEPARTMENTS_DESC'
  | 'DOCUMENT_FOLDER_USERS_BY_USER_ID__COUNT_ASC'
  | 'DOCUMENT_FOLDER_USERS_BY_USER_ID__COUNT_DESC'
  | 'DOCUMENT_USER_PERMISSIONS_BY_USER_ID__COUNT_ASC'
  | 'DOCUMENT_USER_PERMISSIONS_BY_USER_ID__COUNT_DESC'
  | 'DOCUMENT_USER_RESPONSIBLES_BY_ASSIGNED_BY__COUNT_ASC'
  | 'DOCUMENT_USER_RESPONSIBLES_BY_ASSIGNED_BY__COUNT_DESC'
  | 'DOCUMENT_USER_RESPONSIBLES_BY_USER_ID__COUNT_ASC'
  | 'DOCUMENT_USER_RESPONSIBLES_BY_USER_ID__COUNT_DESC'
  | 'EMAIL_ASC'
  | 'EMAIL_DESC'
  | 'EMAIL_WORK_ASC'
  | 'EMAIL_WORK_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__ID_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_EMPLOYEE_ID__USER_ID_DESC'
  | 'EMPLOYEE_BY_USER_ID__ACTIVE_ASC'
  | 'EMPLOYEE_BY_USER_ID__ACTIVE_DESC'
  | 'EMPLOYEE_BY_USER_ID__COMPANY_ID_ASC'
  | 'EMPLOYEE_BY_USER_ID__COMPANY_ID_DESC'
  | 'EMPLOYEE_BY_USER_ID__CREATED_AT_ASC'
  | 'EMPLOYEE_BY_USER_ID__CREATED_AT_DESC'
  | 'EMPLOYEE_BY_USER_ID__DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_USER_ID__DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_USER_ID__GROUP_IDS_ASC'
  | 'EMPLOYEE_BY_USER_ID__GROUP_IDS_DESC'
  | 'EMPLOYEE_BY_USER_ID__ID_ASC'
  | 'EMPLOYEE_BY_USER_ID__ID_DESC'
  | 'EMPLOYEE_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'EMPLOYEE_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'EMPLOYEE_BY_USER_ID__IS_LEADER_ASC'
  | 'EMPLOYEE_BY_USER_ID__IS_LEADER_DESC'
  | 'EMPLOYEE_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'EMPLOYEE_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'EMPLOYEE_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'EMPLOYEE_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'EMPLOYEE_BY_USER_ID__UPDATED_AT_ASC'
  | 'EMPLOYEE_BY_USER_ID__UPDATED_AT_DESC'
  | 'EMPLOYEE_BY_USER_ID__USER_ID_ASC'
  | 'EMPLOYEE_BY_USER_ID__USER_ID_DESC'
  | 'EMPLOYEE_CASEFILES_BY_CREATOR_USER_ID__COUNT_ASC'
  | 'EMPLOYEE_CASEFILES_BY_CREATOR_USER_ID__COUNT_DESC'
  | 'EMPLOYEE_CASEFILES_BY_NEXT_SIGNING_USER_ID__COUNT_ASC'
  | 'EMPLOYEE_CASEFILES_BY_NEXT_SIGNING_USER_ID__COUNT_DESC'
  | 'EMPLOYEE_CASEFILES_BY_USER_ID__COUNT_ASC'
  | 'EMPLOYEE_CASEFILES_BY_USER_ID__COUNT_DESC'
  | 'EMPLOYEE_ID_ASC'
  | 'EMPLOYEE_ID_DESC'
  | 'EMPLOYEE_NUMBER_ASC'
  | 'EMPLOYEE_NUMBER_DESC'
  | 'EMPLOYMENT_END_ASC'
  | 'EMPLOYMENT_END_DESC'
  | 'EMPLOYMENT_END_REMINDED_ASC'
  | 'EMPLOYMENT_END_REMINDED_DESC'
  | 'EMPLOYMENT_START_ASC'
  | 'EMPLOYMENT_START_DESC'
  | 'EQUIPMENT_BY_USER_ID__COUNT_ASC'
  | 'EQUIPMENT_BY_USER_ID__COUNT_DESC'
  | 'EVENT_USERS_BY_USER_ID__COUNT_ASC'
  | 'EVENT_USERS_BY_USER_ID__COUNT_DESC'
  | 'FILTER_PRESETS_BY_USER_ID__COUNT_ASC'
  | 'FILTER_PRESETS_BY_USER_ID__COUNT_DESC'
  | 'FILTER_VIEWS_BY_USER_ID__COUNT_ASC'
  | 'FILTER_VIEWS_BY_USER_ID__COUNT_DESC'
  | 'FIRST_NAME_ASC'
  | 'FIRST_NAME_DESC'
  | 'FORM_FIELD_ENTRIES_BY_PRODUCT_USER_ID__COUNT_ASC'
  | 'FORM_FIELD_ENTRIES_BY_PRODUCT_USER_ID__COUNT_DESC'
  | 'FORM_FIELD_ENTRIES_BY_USER_ID__COUNT_ASC'
  | 'FORM_FIELD_ENTRIES_BY_USER_ID__COUNT_DESC'
  | 'FULL_NAME_ASC'
  | 'FULL_NAME_DESC'
  | 'FULL_NAME_TSVECTOR_ASC'
  | 'FULL_NAME_TSVECTOR_DESC'
  | 'FULL_NAME_TSVECTOR_RANK_ASC'
  | 'FULL_NAME_TSVECTOR_RANK_DESC'
  | 'FUTURE_DATA_BY_CREATOR_USER_ID__COUNT_ASC'
  | 'FUTURE_DATA_BY_CREATOR_USER_ID__COUNT_DESC'
  | 'FUTURE_DATA_BY_USER_ID__COUNT_ASC'
  | 'FUTURE_DATA_BY_USER_ID__COUNT_DESC'
  | 'GODMODE_ASC'
  | 'GODMODE_DESC'
  | 'GROUP_IDS_ASC'
  | 'GROUP_IDS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INITIALS_ASC'
  | 'INITIALS_DESC'
  | 'IS_ARCHIVED_ASC'
  | 'IS_ARCHIVED_DESC'
  | 'IS_LEADER_ASC'
  | 'IS_LEADER_DESC'
  | 'IS_SYSTEM_USER_ASC'
  | 'IS_SYSTEM_USER_DESC'
  | 'JOB_POSITION_DESCRIPTION_ASC'
  | 'JOB_POSITION_DESCRIPTION_DESC'
  | 'JOB_POSITION_TITLE_ASC'
  | 'JOB_POSITION_TITLE_DESC'
  | 'JOB_POSITION_TYPE_ASC'
  | 'JOB_POSITION_TYPE_DESC'
  | 'LAST_LOGIN_ASC'
  | 'LAST_LOGIN_DESC'
  | 'LAST_NAME_ASC'
  | 'LAST_NAME_DESC'
  | 'LEADER_DEPARTMENTS_ASC'
  | 'LEADER_DEPARTMENTS_DESC'
  | 'LOGGED_ACTION_NOTES_BY_SUPER_USER_ID__COUNT_ASC'
  | 'LOGGED_ACTION_NOTES_BY_SUPER_USER_ID__COUNT_DESC'
  | 'LOGGED_ACTION_NOTES_BY_USER_ID__COUNT_ASC'
  | 'LOGGED_ACTION_NOTES_BY_USER_ID__COUNT_DESC'
  | 'LOGIN_LOGS_BY_USER_ID__COUNT_ASC'
  | 'LOGIN_LOGS_BY_USER_ID__COUNT_DESC'
  | 'MOBILE_ASC'
  | 'MOBILE_DESC'
  | 'MOBILE_PRIVATE_ASC'
  | 'MOBILE_PRIVATE_DESC'
  | 'NATURAL'
  | 'NEXT_ANNIVERSARY_ASC'
  | 'NEXT_ANNIVERSARY_DESC'
  | 'NEXT_BIRTHDAY_ASC'
  | 'NEXT_BIRTHDAY_DESC'
  | 'NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'NOTIFICATION_CUSTOM_RECIPIENTS_BY_USER_ID__COUNT_ASC'
  | 'NOTIFICATION_CUSTOM_RECIPIENTS_BY_USER_ID__COUNT_DESC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_RECIPIENT_USER_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_RECIPIENT_USER_ID__COUNT_DESC'
  | 'PHONE_ASC'
  | 'PHONE_DESC'
  | 'POSTAL_CODE_ASC'
  | 'POSTAL_CODE_DESC'
  | 'POSTS_BY_USER_ID__COUNT_ASC'
  | 'POSTS_BY_USER_ID__COUNT_DESC'
  | 'PREBOARDINGS_BY_RECIPIENT_ID__COUNT_ASC'
  | 'PREBOARDINGS_BY_RECIPIENT_ID__COUNT_DESC'
  | 'PREBOARDING_COMMENTS_BY_USER_ID__COUNT_ASC'
  | 'PREBOARDING_COMMENTS_BY_USER_ID__COUNT_DESC'
  | 'PREBOARDING_EMAIL_LOGS_BY_PREBOARDING_USER_ID__COUNT_ASC'
  | 'PREBOARDING_EMAIL_LOGS_BY_PREBOARDING_USER_ID__COUNT_DESC'
  | 'PREBOARDING_EMPLOYEES_BY_RECIPIENT_ID__COUNT_ASC'
  | 'PREBOARDING_EMPLOYEES_BY_RECIPIENT_ID__COUNT_DESC'
  | 'PREBOARDING_EMPLOYEES_BY_USER_ID__COUNT_ASC'
  | 'PREBOARDING_EMPLOYEES_BY_USER_ID__COUNT_DESC'
  | 'PREBOARDING_FORM_CACHES_BY_USER_ID__COUNT_ASC'
  | 'PREBOARDING_FORM_CACHES_BY_USER_ID__COUNT_DESC'
  | 'PREBOARDING_PROCESSES_BY_USER_ID__COUNT_ASC'
  | 'PREBOARDING_PROCESSES_BY_USER_ID__COUNT_DESC'
  | 'PREBOARDING_RESULTS_BY_USER_ID__COUNT_ASC'
  | 'PREBOARDING_RESULTS_BY_USER_ID__COUNT_DESC'
  | 'PREBOARDING_RESULT_SLIDE_COMMENTS_BY_PREBOARDING_USER_ID__COUNT_ASC'
  | 'PREBOARDING_RESULT_SLIDE_COMMENTS_BY_PREBOARDING_USER_ID__COUNT_DESC'
  | 'PREBOARDING_RESULT_SLIDE_COMMENTS_BY_USER_ID__COUNT_ASC'
  | 'PREBOARDING_RESULT_SLIDE_COMMENTS_BY_USER_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROCESSES_BY_ASSIGNED_USER_ID__COUNT_ASC'
  | 'PROCESSES_BY_ASSIGNED_USER_ID__COUNT_DESC'
  | 'PROCESS_RESPONSIBLES_BY_RESPONSIBLE_USER_ID__COUNT_ASC'
  | 'PROCESS_RESPONSIBLES_BY_RESPONSIBLE_USER_ID__COUNT_DESC'
  | 'PRODUCTS_BY_ASSIGNED_USER_ID__COUNT_ASC'
  | 'PRODUCTS_BY_ASSIGNED_USER_ID__COUNT_DESC'
  | 'PRODUCTS_BY_USER_ID__COUNT_ASC'
  | 'PRODUCTS_BY_USER_ID__COUNT_DESC'
  | 'PROJECTS_BY_ASSIGNED_PROCESS_USER_ID__COUNT_ASC'
  | 'PROJECTS_BY_ASSIGNED_PROCESS_USER_ID__COUNT_DESC'
  | 'PULSE_SURVEY_ANSWERS_BY_USER_ID__COUNT_ASC'
  | 'PULSE_SURVEY_ANSWERS_BY_USER_ID__COUNT_DESC'
  | 'PUSH_TOKEN_BY_USER_ID__CREATED_AT_ASC'
  | 'PUSH_TOKEN_BY_USER_ID__CREATED_AT_DESC'
  | 'PUSH_TOKEN_BY_USER_ID__TOKEN_ASC'
  | 'PUSH_TOKEN_BY_USER_ID__TOKEN_DESC'
  | 'PUSH_TOKEN_BY_USER_ID__USER_ID_ASC'
  | 'PUSH_TOKEN_BY_USER_ID__USER_ID_DESC'
  | 'REFERENCE_TOKENS_BY_USER_ID__COUNT_ASC'
  | 'REFERENCE_TOKENS_BY_USER_ID__COUNT_DESC'
  | 'ROADMAP_ITEM_COMMENTS_BY_USER_ID__COUNT_ASC'
  | 'ROADMAP_ITEM_COMMENTS_BY_USER_ID__COUNT_DESC'
  | 'ROADMAP_ITEM_VOTES_BY_USER_ID__COUNT_ASC'
  | 'ROADMAP_ITEM_VOTES_BY_USER_ID__COUNT_DESC'
  | 'SCHEDULED_MESSAGES_BY_ASSIGNED_PROCESS_USER_ID__COUNT_ASC'
  | 'SCHEDULED_MESSAGES_BY_ASSIGNED_PROCESS_USER_ID__COUNT_DESC'
  | 'SENIORITY_ASC'
  | 'SENIORITY_DESC'
  | 'SUPER_USER_BY_USER_ID__COMPANY_BLACKLIST_ASC'
  | 'SUPER_USER_BY_USER_ID__COMPANY_BLACKLIST_DESC'
  | 'SUPER_USER_BY_USER_ID__COMPANY_WHITELIST_ASC'
  | 'SUPER_USER_BY_USER_ID__COMPANY_WHITELIST_DESC'
  | 'SUPER_USER_BY_USER_ID__CREATED_AT_ASC'
  | 'SUPER_USER_BY_USER_ID__CREATED_AT_DESC'
  | 'SUPER_USER_BY_USER_ID__ID_ASC'
  | 'SUPER_USER_BY_USER_ID__ID_DESC'
  | 'SUPER_USER_BY_USER_ID__USER_ID_ASC'
  | 'SUPER_USER_BY_USER_ID__USER_ID_DESC'
  | 'SUPER_USER_LOGIN_NOTES_BY_SUPER_USER_ID__COUNT_ASC'
  | 'SUPER_USER_LOGIN_NOTES_BY_SUPER_USER_ID__COUNT_DESC'
  | 'SUPER_USER_LOGIN_NOTES_BY_USER_ID__COUNT_ASC'
  | 'SUPER_USER_LOGIN_NOTES_BY_USER_ID__COUNT_DESC'
  | 'TASKS_BY_ASSIGNED_PROCESS_USER_ID__COUNT_ASC'
  | 'TASKS_BY_ASSIGNED_PROCESS_USER_ID__COUNT_DESC'
  | 'TASKS_BY_CALENDAR_EVENT_ORGANIZER_ID__COUNT_ASC'
  | 'TASKS_BY_CALENDAR_EVENT_ORGANIZER_ID__COUNT_DESC'
  | 'TASKS_BY_COMPLETED_BY__COUNT_ASC'
  | 'TASKS_BY_COMPLETED_BY__COUNT_DESC'
  | 'TASKS_BY_CREATED_BY__COUNT_ASC'
  | 'TASKS_BY_CREATED_BY__COUNT_DESC'
  | 'TASK_EMPLOYEES_BY_ASSIGNED_PROCESS_USER_ID__COUNT_ASC'
  | 'TASK_EMPLOYEES_BY_ASSIGNED_PROCESS_USER_ID__COUNT_DESC'
  | 'TASK_EMPLOYEES_BY_USER_ID__COUNT_ASC'
  | 'TASK_EMPLOYEES_BY_USER_ID__COUNT_DESC'
  | 'TASK_RESPONSIBLES_BY_ASSIGNED_PROCESS_USER_ID__COUNT_ASC'
  | 'TASK_RESPONSIBLES_BY_ASSIGNED_PROCESS_USER_ID__COUNT_DESC'
  | 'TASK_RESPONSIBLES_BY_USER_ID__COUNT_ASC'
  | 'TASK_RESPONSIBLES_BY_USER_ID__COUNT_DESC'
  | 'TASK_TEMPLATES_BY_CALENDAR_EVENT_ORGANIZER_ID__COUNT_ASC'
  | 'TASK_TEMPLATES_BY_CALENDAR_EVENT_ORGANIZER_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_ENTRIES_BY_USER_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_ENTRIES_BY_USER_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_ENTRY_TEMPLATES_BY_USER_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_ENTRY_TEMPLATES_BY_USER_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_PRESENCES_BY_USER_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_PRESENCES_BY_USER_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATES_BY_USER_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_PRESENCE_TEMPLATES_BY_USER_ID__COUNT_DESC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEKS_BY_USER_ID__COUNT_ASC'
  | 'TIME_REGISTRATION_TEMPLATE_WEEKS_BY_USER_ID__COUNT_DESC'
  | 'USER_ANNOUNCEMENTS_BY_USER_ID__COUNT_ASC'
  | 'USER_ANNOUNCEMENTS_BY_USER_ID__COUNT_DESC'
  | 'USER_COMPANY_GROUPS_BY_USER_ID__COUNT_ASC'
  | 'USER_COMPANY_GROUPS_BY_USER_ID__COUNT_DESC'
  | 'USER_COMPANY_ROLES_BY_USER_ID__COUNT_ASC'
  | 'USER_COMPANY_ROLES_BY_USER_ID__COUNT_DESC'
  | 'USER_COMPETENCES_BY_USER_ID__COUNT_ASC'
  | 'USER_COMPETENCES_BY_USER_ID__COUNT_DESC'
  | 'USER_COMPETENCE_EVALUATIONS_BY_EVALUATING_USER_ID__COUNT_ASC'
  | 'USER_COMPETENCE_EVALUATIONS_BY_EVALUATING_USER_ID__COUNT_DESC'
  | 'USER_COMPETENCE_EVALUATION_COMMENTS_BY_USER_ID__COUNT_ASC'
  | 'USER_COMPETENCE_EVALUATION_COMMENTS_BY_USER_ID__COUNT_DESC'
  | 'USER_DEPARTMENTS_BY_USER_ID__COUNT_ASC'
  | 'USER_DEPARTMENTS_BY_USER_ID__COUNT_DESC'
  | 'USER_DEPARTMENT_GROUPS_BY_USER_ID__COUNT_ASC'
  | 'USER_DEPARTMENT_GROUPS_BY_USER_ID__COUNT_DESC'
  | 'USER_DEPARTMENT_ROLES_BY_USER_ID__COUNT_ASC'
  | 'USER_DEPARTMENT_ROLES_BY_USER_ID__COUNT_DESC'
  | 'USER_GROUPS_BY_USER_ID__COUNT_ASC'
  | 'USER_GROUPS_BY_USER_ID__COUNT_DESC'
  | 'USER_ON_BEHALF_PERMISSIONS_BY_ON_BEHALF_OF_USER_ID__COUNT_ASC'
  | 'USER_ON_BEHALF_PERMISSIONS_BY_ON_BEHALF_OF_USER_ID__COUNT_DESC'
  | 'USER_ON_BEHALF_PERMISSIONS_BY_USER_ID__COUNT_ASC'
  | 'USER_ON_BEHALF_PERMISSIONS_BY_USER_ID__COUNT_DESC'
  | 'USER_ROLES_BY_USER_ID__COUNT_ASC'
  | 'USER_ROLES_BY_USER_ID__COUNT_DESC'
  | 'USER_SETTINGS_BY_USER_ID__COUNT_ASC'
  | 'USER_SETTINGS_BY_USER_ID__COUNT_DESC'
  | 'USER_SYSTEM_FIELDS_BY_USER_ID__COUNT_ASC'
  | 'USER_SYSTEM_FIELDS_BY_USER_ID__COUNT_DESC'
  | 'VACATION_USERS_BY_CREATOR_USER_ID__COUNT_ASC'
  | 'VACATION_USERS_BY_CREATOR_USER_ID__COUNT_DESC'
  | 'VACATION_USERS_BY_USER_ID__COUNT_ASC'
  | 'VACATION_USERS_BY_USER_ID__COUNT_DESC';

export type VacationType = {
  __typename?: 'VacationType';
  absenceCode?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  approverFormFieldIds: Array<Maybe<Scalars['UUID']>>;
  /** Reads and enables pagination through a set of `FormField`. */
  approverFormFields: FormFieldsConnection;
  approverGroupIds: Array<Maybe<Scalars['UUID']>>;
  /** Reads and enables pagination through a set of `Group`. */
  approverGroups: GroupsConnection;
  approverSystemFieldIds: Array<Maybe<Scalars['UUID']>>;
  /** Reads and enables pagination through a set of `SystemField`. */
  approverSystemFields: SystemFieldsConnection;
  approverUserIds: Array<Maybe<Scalars['UUID']>>;
  /** Reads and enables pagination through a set of `User`. */
  approverUsers: UsersConnection;
  color: Scalars['String'];
  /** Reads a single `Company` that is related to this `VacationType`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  description?: Maybe<Scalars['String']>;
  emoji?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  localizedName?: Maybe<Scalars['String']>;
  mustBeApproved: Scalars['Boolean'];
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferences: NotificationEmployeeReferencesConnection;
  quickAction: Scalars['Boolean'];
  sendCalendarInvite: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `VacationUser`. */
  vacationUsers: VacationUsersConnection;
};


export type VacationTypeApproverFormFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<FormFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type VacationTypeApproverGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type VacationTypeApproverSystemFieldsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<SystemFieldFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type VacationTypeApproverUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type VacationTypeNotificationEmployeeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};


export type VacationTypeVacationUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<VacationUserCondition>;
  filter?: InputMaybe<VacationUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VacationUsersOrderBy>>;
};

/** The `vacationType` to be created by this mutation. */
export type VacationTypeCompanyIdForeignConnectionVacationTypeCreateInput = {
  absenceCode?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  color: Scalars['String'];
  company?: InputMaybe<VacationTypeCompanyIdForeignInput>;
  description?: InputMaybe<Scalars['String']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  mustBeApproved?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInverseInput>;
  quickAction?: InputMaybe<Scalars['Boolean']>;
  sendCalendarInvite?: InputMaybe<Scalars['Boolean']>;
  vacationUsers?: InputMaybe<VacationUserVacationTypeIdForeignInverseInput>;
};

/** Input for the nested mutation of `company` in the `VacationTypeInput` mutation. */
export type VacationTypeCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnVacationTypeForVacationTypeCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `vacationType` in the `CompanyInput` mutation. */
export type VacationTypeCompanyIdForeignInverseInput = {
  /** The primary key(s) for `vacationType` for the far side of the relationship. */
  connectById?: InputMaybe<Array<VacationTypeVacationTypePkeyConnect>>;
  /** A `VacationTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<VacationTypeCompanyIdForeignConnectionVacationTypeCreateInput>>;
  /** The primary key(s) and patch data for `vacationType` for the far side of the relationship. */
  updateById?: InputMaybe<Array<VacationTypeOnVacationTypeForVacationTypeCompanyIdForeignUsingVacationTypePkeyUpdate>>;
};

/**
 * A condition to be used against `VacationType` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type VacationTypeCondition = {
  /** Checks for equality with the object’s `absenceCode` field. */
  absenceCode?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `approverFormFieldIds` field. */
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `approverGroupIds` field. */
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `approverSystemFieldIds` field. */
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `approverUserIds` field. */
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `color` field. */
  color?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `emoji` field. */
  emoji?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `mustBeApproved` field. */
  mustBeApproved?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `quickAction` field. */
  quickAction?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `sendCalendarInvite` field. */
  sendCalendarInvite?: InputMaybe<Scalars['Boolean']>;
};

/** A filter to be used against `VacationType` object types. All fields are combined with a logical ‘and.’ */
export type VacationTypeFilter = {
  /** Filter by the object’s `absenceCode` field. */
  absenceCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VacationTypeFilter>>;
  /** Filter by the object’s `approverFormFieldIds` field. */
  approverFormFieldIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `approverGroupIds` field. */
  approverGroupIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `approverSystemFieldIds` field. */
  approverSystemFieldIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `approverUserIds` field. */
  approverUserIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `color` field. */
  color?: InputMaybe<StringFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emoji` field. */
  emoji?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `localizedName` field. */
  localizedName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mustBeApproved` field. */
  mustBeApproved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VacationTypeFilter>;
  /** Filter by the object’s `notificationEmployeeReferences` relation. */
  notificationEmployeeReferences?: InputMaybe<VacationTypeToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferences` exist. */
  notificationEmployeeReferencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VacationTypeFilter>>;
  /** Filter by the object’s `quickAction` field. */
  quickAction?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sendCalendarInvite` field. */
  sendCalendarInvite?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `vacationUsers` relation. */
  vacationUsers?: InputMaybe<VacationTypeToManyVacationUserFilter>;
  /** Some related `vacationUsers` exist. */
  vacationUsersExist?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `VacationType` */
export type VacationTypeInput = {
  absenceCode?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  color: Scalars['String'];
  company?: InputMaybe<VacationTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  mustBeApproved?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInverseInput>;
  quickAction?: InputMaybe<Scalars['Boolean']>;
  sendCalendarInvite?: InputMaybe<Scalars['Boolean']>;
  vacationUsers?: InputMaybe<VacationUserVacationTypeIdForeignInverseInput>;
};

/** The fields on `vacationType` to look up the row to update. */
export type VacationTypeOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationTypeIdForeignUsingVacationTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationType` being updated. */
  patch: UpdateVacationTypeOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationTypeIdForeignPatch;
};

/** The fields on `vacationType` to look up the row to update. */
export type VacationTypeOnVacationTypeForVacationTypeCompanyIdForeignUsingVacationTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationType` being updated. */
  patch: UpdateVacationTypeOnVacationTypeForVacationTypeCompanyIdForeignPatch;
};

/** The fields on `vacationType` to look up the row to update. */
export type VacationTypeOnVacationUserForVacationUserVacationTypeIdForeignUsingVacationTypePkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationType` being updated. */
  patch: UpdateVacationTypeOnVacationUserForVacationUserVacationTypeIdForeignPatch;
};

/** Represents an update to a `VacationType`. Fields that are set will be updated. */
export type VacationTypePatch = {
  absenceCode?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  color?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<VacationTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  mustBeApproved?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInverseInput>;
  quickAction?: InputMaybe<Scalars['Boolean']>;
  sendCalendarInvite?: InputMaybe<Scalars['Boolean']>;
  vacationUsers?: InputMaybe<VacationUserVacationTypeIdForeignInverseInput>;
};

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type VacationTypeToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

/** A filter to be used against many `VacationUser` object types. All fields are combined with a logical ‘and.’ */
export type VacationTypeToManyVacationUserFilter = {
  /** Every related `VacationUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<VacationUserFilter>;
  /** No related `VacationUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<VacationUserFilter>;
  /** Some related `VacationUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<VacationUserFilter>;
};

/** The fields on `vacationType` to look up the row to connect. */
export type VacationTypeVacationTypePkeyConnect = {
  id: Scalars['UUID'];
};

/** A connection to a list of `VacationType` values. */
export type VacationTypesConnection = {
  __typename?: 'VacationTypesConnection';
  /** A list of edges which contains the `VacationType` and cursor to aid in pagination. */
  edges: Array<VacationTypesEdge>;
  /** A list of `VacationType` objects. */
  nodes: Array<Maybe<VacationType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VacationType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `VacationType` edge in the connection. */
export type VacationTypesEdge = {
  __typename?: 'VacationTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `VacationType` at the end of the edge. */
  node?: Maybe<VacationType>;
};

/** Methods to use when ordering `VacationType`. */
export type VacationTypesOrderBy =
  | 'ABSENCE_CODE_ASC'
  | 'ABSENCE_CODE_DESC'
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'APPROVER_FORM_FIELD_IDS_ASC'
  | 'APPROVER_FORM_FIELD_IDS_DESC'
  | 'APPROVER_GROUP_IDS_ASC'
  | 'APPROVER_GROUP_IDS_DESC'
  | 'APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'APPROVER_USER_IDS_ASC'
  | 'APPROVER_USER_IDS_DESC'
  | 'COLOR_ASC'
  | 'COLOR_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'EMOJI_ASC'
  | 'EMOJI_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOCALIZED_NAME_ASC'
  | 'LOCALIZED_NAME_DESC'
  | 'MUST_BE_APPROVED_ASC'
  | 'MUST_BE_APPROVED_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_VACATION_TYPE_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_VACATION_TYPE_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'QUICK_ACTION_ASC'
  | 'QUICK_ACTION_DESC'
  | 'SEND_CALENDAR_INVITE_ASC'
  | 'SEND_CALENDAR_INVITE_DESC'
  | 'VACATION_USERS_BY_VACATION_TYPE_ID__COUNT_ASC'
  | 'VACATION_USERS_BY_VACATION_TYPE_ID__COUNT_DESC';

export type VacationUser = {
  __typename?: 'VacationUser';
  active: Scalars['Boolean'];
  allDay: Scalars['Boolean'];
  /** Reads a single `Approval` that is related to this `VacationUser`. */
  approval?: Maybe<Approval>;
  approvalId?: Maybe<Scalars['UUID']>;
  calendarEventRevisions: Scalars['Int'];
  /** Reads a single `Company` that is related to this `VacationUser`. */
  company?: Maybe<Company>;
  companyId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `VacationUser`. */
  creatorUser?: Maybe<User>;
  creatorUserId?: Maybe<Scalars['UUID']>;
  customId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Approval` that is related to this `VacationUser`. */
  deletionApproval?: Maybe<Approval>;
  deletionApprovalId?: Maybe<Scalars['UUID']>;
  departmentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  durationDays?: Maybe<Scalars['BigFloat']>;
  endDate: Scalars['Datetime'];
  hasBeenApproved?: Maybe<Scalars['Boolean']>;
  hasBeenDenied?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  lastProcessedBy?: Maybe<User>;
  note?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `NotificationEmployeeReference`. */
  notificationEmployeeReferences: NotificationEmployeeReferencesConnection;
  startDate: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `VacationUser`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
  /** Reads a single `VacationType` that is related to this `VacationUser`. */
  vacationType?: Maybe<VacationType>;
  vacationTypeId: Scalars['UUID'];
};


export type VacationUserNotificationEmployeeReferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationEmployeeReferenceCondition>;
  filter?: InputMaybe<NotificationEmployeeReferenceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationEmployeeReferencesOrderBy>>;
};

/** The `vacationUser` to be created by this mutation. */
export type VacationUserApprovalIdForeignConnectionVacationUserCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  allDay?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<VacationUserDeletionApprovalIdForeignInput>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<VacationUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  customId?: InputMaybe<Scalars['UUID']>;
  deletionApprovalId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInverseInput>;
  startDate: Scalars['Datetime'];
  user?: InputMaybe<VacationUserCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<VacationUserVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `vacationUser` in the `ApprovalInput` mutation. */
export type VacationUserApprovalIdForeignInverseInput = {
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectByApprovalId?: InputMaybe<VacationUserVacationUserApprovalIdUniqueConnect>;
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectByDeletionApprovalId?: InputMaybe<VacationUserVacationUserDeletionApprovalIdUniqueConnect>;
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectById?: InputMaybe<VacationUserVacationUserPkeyConnect>;
  /** A `VacationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<VacationUserApprovalIdForeignConnectionVacationUserCreateInput>>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateByApprovalId?: InputMaybe<VacationUserOnVacationUserForVacationUserApprovalIdForeignUsingVacationUserApprovalIdUniqueUpdate>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateByDeletionApprovalId?: InputMaybe<VacationUserOnVacationUserForVacationUserApprovalIdForeignUsingVacationUserDeletionApprovalIdUniqueUpdate>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateById?: InputMaybe<VacationUserOnVacationUserForVacationUserApprovalIdForeignUsingVacationUserPkeyUpdate>;
};

/** The `vacationUser` to be created by this mutation. */
export type VacationUserCompanyIdForeignConnectionVacationUserCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  allDay?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<VacationUserDeletionApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<VacationUserCompanyIdForeignInput>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  customId?: InputMaybe<Scalars['UUID']>;
  deletionApprovalId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInverseInput>;
  startDate: Scalars['Datetime'];
  user?: InputMaybe<VacationUserCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<VacationUserVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `company` in the `VacationUserInput` mutation. */
export type VacationUserCompanyIdForeignInput = {
  /** The primary key(s) for `company` for the far side of the relationship. */
  connectById?: InputMaybe<CompanyCompanyPkeyConnect>;
  /** The primary key(s) and patch data for `company` for the far side of the relationship. */
  updateById?: InputMaybe<CompanyOnVacationUserForVacationUserCompanyIdForeignUsingCompanyPkeyUpdate>;
};

/** Input for the nested mutation of `vacationUser` in the `CompanyInput` mutation. */
export type VacationUserCompanyIdForeignInverseInput = {
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectByApprovalId?: InputMaybe<Array<VacationUserVacationUserApprovalIdUniqueConnect>>;
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectByDeletionApprovalId?: InputMaybe<Array<VacationUserVacationUserDeletionApprovalIdUniqueConnect>>;
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectById?: InputMaybe<Array<VacationUserVacationUserPkeyConnect>>;
  /** A `VacationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<VacationUserCompanyIdForeignConnectionVacationUserCreateInput>>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateByApprovalId?: InputMaybe<Array<VacationUserOnVacationUserForVacationUserCompanyIdForeignUsingVacationUserApprovalIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateByDeletionApprovalId?: InputMaybe<Array<VacationUserOnVacationUserForVacationUserCompanyIdForeignUsingVacationUserDeletionApprovalIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateById?: InputMaybe<Array<VacationUserOnVacationUserForVacationUserCompanyIdForeignUsingVacationUserPkeyUpdate>>;
};

/**
 * A condition to be used against `VacationUser` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type VacationUserCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `allDay` field. */
  allDay?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `approvalId` field. */
  approvalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `calendarEventRevisions` field. */
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `companyId` field. */
  companyId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `creatorUserId` field. */
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `customId` field. */
  customId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `deletionApprovalId` field. */
  deletionApprovalId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `vacationTypeId` field. */
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** The `vacationUser` to be created by this mutation. */
export type VacationUserCreatorUserIdForeignConnectionVacationUserCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  allDay?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<VacationUserDeletionApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<VacationUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  customId?: InputMaybe<Scalars['UUID']>;
  deletionApprovalId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInverseInput>;
  startDate: Scalars['Datetime'];
  user?: InputMaybe<VacationUserCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<VacationUserVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `user` in the `VacationUserInput` mutation. */
export type VacationUserCreatorUserIdForeignInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserUserPkeyConnect>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnVacationUserForVacationUserCreatorUserIdForeignUsingUserPkeyUpdate>;
};

/** Input for the nested mutation of `vacationUser` in the `UserInput` mutation. */
export type VacationUserCreatorUserIdForeignInverseInput = {
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectByApprovalId?: InputMaybe<Array<VacationUserVacationUserApprovalIdUniqueConnect>>;
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectByDeletionApprovalId?: InputMaybe<Array<VacationUserVacationUserDeletionApprovalIdUniqueConnect>>;
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectById?: InputMaybe<Array<VacationUserVacationUserPkeyConnect>>;
  /** A `VacationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<VacationUserCreatorUserIdForeignConnectionVacationUserCreateInput>>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateByApprovalId?: InputMaybe<Array<VacationUserOnVacationUserForVacationUserCreatorUserIdForeignUsingVacationUserApprovalIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateByDeletionApprovalId?: InputMaybe<Array<VacationUserOnVacationUserForVacationUserCreatorUserIdForeignUsingVacationUserDeletionApprovalIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateById?: InputMaybe<Array<VacationUserOnVacationUserForVacationUserCreatorUserIdForeignUsingVacationUserPkeyUpdate>>;
};

/** The `approval` to be created by this mutation. */
export type VacationUserDeletionApprovalIdForeignConnectionApprovalCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  affectedUserDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  affectedUserId?: InputMaybe<Scalars['UUID']>;
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  approvingUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<ApprovalCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  deniedAt?: InputMaybe<Scalars['Datetime']>;
  futureDatum?: InputMaybe<FutureDataApprovalIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isDeletionRequest?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['UUID']>;
  requestingUserId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInverseInput>;
  type: ApprovalType;
  user?: InputMaybe<ApprovalRequestingUserIdForeignInput>;
  vacationUserToApprovalIdUsingId?: InputMaybe<VacationUserApprovalIdForeignInverseInput>;
  vacationUserToDeletionApprovalIdUsingId?: InputMaybe<VacationUserDeletionApprovalIdForeignInverseInput>;
};

/** The `vacationUser` to be created by this mutation. */
export type VacationUserDeletionApprovalIdForeignConnectionVacationUserCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  allDay?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<VacationUserDeletionApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<VacationUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  customId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInverseInput>;
  startDate: Scalars['Datetime'];
  user?: InputMaybe<VacationUserCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<VacationUserVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `approval` in the `VacationUserInput` mutation. */
export type VacationUserDeletionApprovalIdForeignInput = {
  /** The primary key(s) for `approval` for the far side of the relationship. */
  connectById?: InputMaybe<ApprovalApprovalPkeyConnect>;
  /** A `ApprovalInput` object that will be created and connected to this object. */
  create?: InputMaybe<VacationUserDeletionApprovalIdForeignConnectionApprovalCreateInput>;
  /** The primary key(s) and patch data for `approval` for the far side of the relationship. */
  updateById?: InputMaybe<ApprovalOnVacationUserForVacationUserDeletionApprovalIdForeignUsingApprovalPkeyUpdate>;
};

/** Input for the nested mutation of `vacationUser` in the `ApprovalInput` mutation. */
export type VacationUserDeletionApprovalIdForeignInverseInput = {
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectByApprovalId?: InputMaybe<VacationUserVacationUserApprovalIdUniqueConnect>;
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectByDeletionApprovalId?: InputMaybe<VacationUserVacationUserDeletionApprovalIdUniqueConnect>;
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectById?: InputMaybe<VacationUserVacationUserPkeyConnect>;
  /** A `VacationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<VacationUserDeletionApprovalIdForeignConnectionVacationUserCreateInput>>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateByApprovalId?: InputMaybe<VacationUserOnVacationUserForVacationUserDeletionApprovalIdForeignUsingVacationUserApprovalIdUniqueUpdate>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateByDeletionApprovalId?: InputMaybe<VacationUserOnVacationUserForVacationUserDeletionApprovalIdForeignUsingVacationUserDeletionApprovalIdUniqueUpdate>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateById?: InputMaybe<VacationUserOnVacationUserForVacationUserDeletionApprovalIdForeignUsingVacationUserPkeyUpdate>;
};

/** A filter to be used against `VacationUser` object types. All fields are combined with a logical ‘and.’ */
export type VacationUserFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allDay` field. */
  allDay?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VacationUserFilter>>;
  /** Filter by the object’s `approval` relation. */
  approval?: InputMaybe<ApprovalFilter>;
  /** A related `approval` exists. */
  approvalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `approvalId` field. */
  approvalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `calendarEventRevisions` field. */
  calendarEventRevisions?: InputMaybe<IntFilter>;
  /** Filter by the object’s `company` relation. */
  company?: InputMaybe<CompanyFilter>;
  /** Filter by the object’s `companyId` field. */
  companyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `creatorUser` relation. */
  creatorUser?: InputMaybe<UserFilter>;
  /** A related `creatorUser` exists. */
  creatorUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `creatorUserId` field. */
  creatorUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `customId` field. */
  customId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `deletionApproval` relation. */
  deletionApproval?: InputMaybe<ApprovalFilter>;
  /** A related `deletionApproval` exists. */
  deletionApprovalExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `deletionApprovalId` field. */
  deletionApprovalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `departmentIds` field. */
  departmentIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `durationDays` field. */
  durationDays?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `hasBeenApproved` field. */
  hasBeenApproved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `hasBeenDenied` field. */
  hasBeenDenied?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VacationUserFilter>;
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>;
  /** Filter by the object’s `notificationEmployeeReferences` relation. */
  notificationEmployeeReferences?: InputMaybe<VacationUserToManyNotificationEmployeeReferenceFilter>;
  /** Some related `notificationEmployeeReferences` exist. */
  notificationEmployeeReferencesExist?: InputMaybe<Scalars['Boolean']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VacationUserFilter>>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `vacationType` relation. */
  vacationType?: InputMaybe<VacationTypeFilter>;
  /** Filter by the object’s `vacationTypeId` field. */
  vacationTypeId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `VacationUser` */
export type VacationUserInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  allDay?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<VacationUserDeletionApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<VacationUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  customId?: InputMaybe<Scalars['UUID']>;
  deletionApprovalId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInverseInput>;
  startDate: Scalars['Datetime'];
  user?: InputMaybe<VacationUserCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<VacationUserVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationUserIdForeignUsingVacationUserApprovalIdUniqueUpdate = {
  approvalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationUserIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationUserIdForeignUsingVacationUserDeletionApprovalIdUniqueUpdate = {
  deletionApprovalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationUserIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationUserIdForeignUsingVacationUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationUserIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnVacationUserForVacationUserApprovalIdForeignUsingVacationUserApprovalIdUniqueUpdate = {
  approvalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnVacationUserForVacationUserApprovalIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnVacationUserForVacationUserApprovalIdForeignUsingVacationUserDeletionApprovalIdUniqueUpdate = {
  deletionApprovalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnVacationUserForVacationUserApprovalIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnVacationUserForVacationUserApprovalIdForeignUsingVacationUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnVacationUserForVacationUserApprovalIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnVacationUserForVacationUserCompanyIdForeignUsingVacationUserApprovalIdUniqueUpdate = {
  approvalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnVacationUserForVacationUserCompanyIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnVacationUserForVacationUserCompanyIdForeignUsingVacationUserDeletionApprovalIdUniqueUpdate = {
  deletionApprovalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnVacationUserForVacationUserCompanyIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnVacationUserForVacationUserCompanyIdForeignUsingVacationUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnVacationUserForVacationUserCompanyIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnVacationUserForVacationUserCreatorUserIdForeignUsingVacationUserApprovalIdUniqueUpdate = {
  approvalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnVacationUserForVacationUserCreatorUserIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnVacationUserForVacationUserCreatorUserIdForeignUsingVacationUserDeletionApprovalIdUniqueUpdate = {
  deletionApprovalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnVacationUserForVacationUserCreatorUserIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnVacationUserForVacationUserCreatorUserIdForeignUsingVacationUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnVacationUserForVacationUserCreatorUserIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnVacationUserForVacationUserDeletionApprovalIdForeignUsingVacationUserApprovalIdUniqueUpdate = {
  approvalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnVacationUserForVacationUserDeletionApprovalIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnVacationUserForVacationUserDeletionApprovalIdForeignUsingVacationUserDeletionApprovalIdUniqueUpdate = {
  deletionApprovalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnVacationUserForVacationUserDeletionApprovalIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnVacationUserForVacationUserDeletionApprovalIdForeignUsingVacationUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnVacationUserForVacationUserDeletionApprovalIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnVacationUserForVacationUserUserIdForeignUsingVacationUserApprovalIdUniqueUpdate = {
  approvalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnVacationUserForVacationUserUserIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnVacationUserForVacationUserUserIdForeignUsingVacationUserDeletionApprovalIdUniqueUpdate = {
  deletionApprovalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnVacationUserForVacationUserUserIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnVacationUserForVacationUserUserIdForeignUsingVacationUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnVacationUserForVacationUserUserIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnVacationUserForVacationUserVacationTypeIdForeignUsingVacationUserApprovalIdUniqueUpdate = {
  approvalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnVacationUserForVacationUserVacationTypeIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnVacationUserForVacationUserVacationTypeIdForeignUsingVacationUserDeletionApprovalIdUniqueUpdate = {
  deletionApprovalId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnVacationUserForVacationUserVacationTypeIdForeignPatch;
};

/** The fields on `vacationUser` to look up the row to update. */
export type VacationUserOnVacationUserForVacationUserVacationTypeIdForeignUsingVacationUserPkeyUpdate = {
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `vacationUser` being updated. */
  patch: UpdateVacationUserOnVacationUserForVacationUserVacationTypeIdForeignPatch;
};

/** Represents an update to a `VacationUser`. Fields that are set will be updated. */
export type VacationUserPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  allDay?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<VacationUserDeletionApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<VacationUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  customId?: InputMaybe<Scalars['UUID']>;
  deletionApprovalId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<VacationUserCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<VacationUserVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against many `NotificationEmployeeReference` object types. All fields are combined with a logical ‘and.’ */
export type VacationUserToManyNotificationEmployeeReferenceFilter = {
  /** Every related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** No related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationEmployeeReferenceFilter>;
  /** Some related `NotificationEmployeeReference` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationEmployeeReferenceFilter>;
};

/** The `vacationUser` to be created by this mutation. */
export type VacationUserUserIdForeignConnectionVacationUserCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  allDay?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<VacationUserDeletionApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<VacationUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  customId?: InputMaybe<Scalars['UUID']>;
  deletionApprovalId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInverseInput>;
  startDate: Scalars['Datetime'];
  user?: InputMaybe<VacationUserCreatorUserIdForeignInput>;
  vacationType?: InputMaybe<VacationUserVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** Input for the nested mutation of `vacationUser` in the `UserInput` mutation. */
export type VacationUserUserIdForeignInverseInput = {
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectByApprovalId?: InputMaybe<Array<VacationUserVacationUserApprovalIdUniqueConnect>>;
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectByDeletionApprovalId?: InputMaybe<Array<VacationUserVacationUserDeletionApprovalIdUniqueConnect>>;
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectById?: InputMaybe<Array<VacationUserVacationUserPkeyConnect>>;
  /** A `VacationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<VacationUserUserIdForeignConnectionVacationUserCreateInput>>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateByApprovalId?: InputMaybe<Array<VacationUserOnVacationUserForVacationUserUserIdForeignUsingVacationUserApprovalIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateByDeletionApprovalId?: InputMaybe<Array<VacationUserOnVacationUserForVacationUserUserIdForeignUsingVacationUserDeletionApprovalIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateById?: InputMaybe<Array<VacationUserOnVacationUserForVacationUserUserIdForeignUsingVacationUserPkeyUpdate>>;
};

/** The `vacationType` to be created by this mutation. */
export type VacationUserVacationTypeIdForeignConnectionVacationTypeCreateInput = {
  absenceCode?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  color: Scalars['String'];
  company?: InputMaybe<VacationTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  mustBeApproved?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInverseInput>;
  quickAction?: InputMaybe<Scalars['Boolean']>;
  sendCalendarInvite?: InputMaybe<Scalars['Boolean']>;
  vacationUsers?: InputMaybe<VacationUserVacationTypeIdForeignInverseInput>;
};

/** The `vacationUser` to be created by this mutation. */
export type VacationUserVacationTypeIdForeignConnectionVacationUserCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  allDay?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<VacationUserDeletionApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<VacationUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  customId?: InputMaybe<Scalars['UUID']>;
  deletionApprovalId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate: Scalars['Datetime'];
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInverseInput>;
  startDate: Scalars['Datetime'];
  user?: InputMaybe<VacationUserCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<VacationUserVacationTypeIdForeignInput>;
};

/** Input for the nested mutation of `vacationType` in the `VacationUserInput` mutation. */
export type VacationUserVacationTypeIdForeignInput = {
  /** The primary key(s) for `vacationType` for the far side of the relationship. */
  connectById?: InputMaybe<VacationTypeVacationTypePkeyConnect>;
  /** A `VacationTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<VacationUserVacationTypeIdForeignConnectionVacationTypeCreateInput>;
  /** The primary key(s) and patch data for `vacationType` for the far side of the relationship. */
  updateById?: InputMaybe<VacationTypeOnVacationUserForVacationUserVacationTypeIdForeignUsingVacationTypePkeyUpdate>;
};

/** Input for the nested mutation of `vacationUser` in the `VacationTypeInput` mutation. */
export type VacationUserVacationTypeIdForeignInverseInput = {
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectByApprovalId?: InputMaybe<Array<VacationUserVacationUserApprovalIdUniqueConnect>>;
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectByDeletionApprovalId?: InputMaybe<Array<VacationUserVacationUserDeletionApprovalIdUniqueConnect>>;
  /** The primary key(s) for `vacationUser` for the far side of the relationship. */
  connectById?: InputMaybe<Array<VacationUserVacationUserPkeyConnect>>;
  /** A `VacationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<VacationUserVacationTypeIdForeignConnectionVacationUserCreateInput>>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateByApprovalId?: InputMaybe<Array<VacationUserOnVacationUserForVacationUserVacationTypeIdForeignUsingVacationUserApprovalIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateByDeletionApprovalId?: InputMaybe<Array<VacationUserOnVacationUserForVacationUserVacationTypeIdForeignUsingVacationUserDeletionApprovalIdUniqueUpdate>>;
  /** The primary key(s) and patch data for `vacationUser` for the far side of the relationship. */
  updateById?: InputMaybe<Array<VacationUserOnVacationUserForVacationUserVacationTypeIdForeignUsingVacationUserPkeyUpdate>>;
};

/** The fields on `vacationUser` to look up the row to connect. */
export type VacationUserVacationUserApprovalIdUniqueConnect = {
  approvalId: Scalars['UUID'];
};

/** The fields on `vacationUser` to look up the row to connect. */
export type VacationUserVacationUserDeletionApprovalIdUniqueConnect = {
  deletionApprovalId: Scalars['UUID'];
};

/** The fields on `vacationUser` to look up the row to connect. */
export type VacationUserVacationUserPkeyConnect = {
  id: Scalars['UUID'];
};

/** A connection to a list of `VacationUser` values. */
export type VacationUsersConnection = {
  __typename?: 'VacationUsersConnection';
  /** A list of edges which contains the `VacationUser` and cursor to aid in pagination. */
  edges: Array<VacationUsersEdge>;
  /** A list of `VacationUser` objects. */
  nodes: Array<Maybe<VacationUser>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VacationUser` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `VacationUser` edge in the connection. */
export type VacationUsersEdge = {
  __typename?: 'VacationUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `VacationUser` at the end of the edge. */
  node?: Maybe<VacationUser>;
};

/** Methods to use when ordering `VacationUser`. */
export type VacationUsersOrderBy =
  | 'ACTIVE_ASC'
  | 'ACTIVE_DESC'
  | 'ALL_DAY_ASC'
  | 'ALL_DAY_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__ACTIVE_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__ACTIVE_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__AFFECTED_USER_DEPARTMENT_IDS_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__AFFECTED_USER_DEPARTMENT_IDS_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__AFFECTED_USER_ID_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__AFFECTED_USER_ID_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__APPROVED_AT_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__APPROVED_AT_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__APPROVING_USER_ID_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__APPROVING_USER_ID_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__COMPANY_ID_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__COMPANY_ID_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__CREATED_AT_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__CREATED_AT_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__DEADLINE_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__DEADLINE_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__DENIED_AT_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__DENIED_AT_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__ID_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__ID_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__IS_DELETION_REQUEST_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__IS_DELETION_REQUEST_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__ITEM_ID_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__ITEM_ID_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__REQUESTING_USER_ID_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__REQUESTING_USER_ID_DESC'
  | 'APPROVAL_BY_APPROVAL_ID__TYPE_ASC'
  | 'APPROVAL_BY_APPROVAL_ID__TYPE_DESC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__ACTIVE_ASC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__ACTIVE_DESC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__AFFECTED_USER_DEPARTMENT_IDS_ASC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__AFFECTED_USER_DEPARTMENT_IDS_DESC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__AFFECTED_USER_ID_ASC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__AFFECTED_USER_ID_DESC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__APPROVED_AT_ASC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__APPROVED_AT_DESC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__APPROVING_USER_ID_ASC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__APPROVING_USER_ID_DESC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__COMPANY_ID_ASC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__COMPANY_ID_DESC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__CREATED_AT_ASC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__CREATED_AT_DESC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__DEADLINE_ASC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__DEADLINE_DESC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__DENIED_AT_ASC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__DENIED_AT_DESC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__ID_ASC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__ID_DESC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__IS_DELETION_REQUEST_ASC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__IS_DELETION_REQUEST_DESC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__ITEM_ID_ASC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__ITEM_ID_DESC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__REQUESTING_USER_ID_ASC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__REQUESTING_USER_ID_DESC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__TYPE_ASC'
  | 'APPROVAL_BY_DELETION_APPROVAL_ID__TYPE_DESC'
  | 'APPROVAL_ID_ASC'
  | 'APPROVAL_ID_DESC'
  | 'CALENDAR_EVENT_REVISIONS_ASC'
  | 'CALENDAR_EVENT_REVISIONS_DESC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_ASC'
  | 'COMPANY_BY_COMPANY_ID__ACTIVE_DESC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_ASC'
  | 'COMPANY_BY_COMPANY_ID__AVAILABLE_LOCALES_DESC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__COPY_IN_PROGRESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__CREATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__CVR_ASC'
  | 'COMPANY_BY_COMPANY_ID__CVR_DESC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__DELETE_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_ASC'
  | 'COMPANY_BY_COMPANY_ID__DESCRIPTION_DESC'
  | 'COMPANY_BY_COMPANY_ID__ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_ASC'
  | 'COMPANY_BY_COMPANY_ID__LAST_LOGIN_DESC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_ASC'
  | 'COMPANY_BY_COMPANY_ID__LOCALE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_FOR_COMPANY_ID_DESC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MASTER_TEMPLATE_DESC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_ASC'
  | 'COMPANY_BY_COMPANY_ID__MINIMUM_EMPLOYEE_NUMBER_DESC'
  | 'COMPANY_BY_COMPANY_ID__MODE_ASC'
  | 'COMPANY_BY_COMPANY_ID__MODE_DESC'
  | 'COMPANY_BY_COMPANY_ID__NAME_ASC'
  | 'COMPANY_BY_COMPANY_ID__NAME_DESC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_ASC'
  | 'COMPANY_BY_COMPANY_ID__NATIVE_APP_ACCESS_DESC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_ASC'
  | 'COMPANY_BY_COMPANY_ID__NUMBER_OF_CURRENTLY_EMPLOYED_EMPLOYEES_DESC'
  | 'COMPANY_BY_COMPANY_ID__SSO_ASC'
  | 'COMPANY_BY_COMPANY_ID__SSO_DESC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_ASC'
  | 'COMPANY_BY_COMPANY_ID__UPDATED_AT_DESC'
  | 'COMPANY_BY_COMPANY_ID__URL_ASC'
  | 'COMPANY_BY_COMPANY_ID__URL_DESC'
  | 'COMPANY_ID_ASC'
  | 'COMPANY_ID_DESC'
  | 'CREATOR_USER_ID_ASC'
  | 'CREATOR_USER_ID_DESC'
  | 'CUSTOM_ID_ASC'
  | 'CUSTOM_ID_DESC'
  | 'DELETION_APPROVAL_ID_ASC'
  | 'DELETION_APPROVAL_ID_DESC'
  | 'DEPARTMENT_IDS_ASC'
  | 'DEPARTMENT_IDS_DESC'
  | 'DURATION_DAYS_ASC'
  | 'DURATION_DAYS_DESC'
  | 'END_DATE_ASC'
  | 'END_DATE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'NOTE_ASC'
  | 'NOTE_DESC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_VACATION_USER_ID__COUNT_ASC'
  | 'NOTIFICATION_EMPLOYEE_REFERENCES_BY_VACATION_USER_ID__COUNT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'START_DATE_ASC'
  | 'START_DATE_DESC'
  | 'USER_BY_CREATOR_USER_ID__ACTIVE_ASC'
  | 'USER_BY_CREATOR_USER_ID__ACTIVE_DESC'
  | 'USER_BY_CREATOR_USER_ID__ADDRESS_ASC'
  | 'USER_BY_CREATOR_USER_ID__ADDRESS_DESC'
  | 'USER_BY_CREATOR_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_CREATOR_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_CREATOR_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_CREATOR_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_CREATOR_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_CREATOR_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_CREATOR_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_CREATOR_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_CREATOR_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_CREATOR_USER_ID__CITY_ASC'
  | 'USER_BY_CREATOR_USER_ID__CITY_DESC'
  | 'USER_BY_CREATOR_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_CREATOR_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_CREATOR_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_CREATOR_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_CREATOR_USER_ID__CPR_ASC'
  | 'USER_BY_CREATOR_USER_ID__CPR_DESC'
  | 'USER_BY_CREATOR_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_CREATOR_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_CREATOR_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_CREATOR_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_CREATOR_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_CREATOR_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_CREATOR_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_CREATOR_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMAIL_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMAIL_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_CREATOR_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_CREATOR_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_CREATOR_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_CREATOR_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_CREATOR_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_CREATOR_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_CREATOR_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_CREATOR_USER_ID__GODMODE_ASC'
  | 'USER_BY_CREATOR_USER_ID__GODMODE_DESC'
  | 'USER_BY_CREATOR_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_CREATOR_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_CREATOR_USER_ID__ID_ASC'
  | 'USER_BY_CREATOR_USER_ID__ID_DESC'
  | 'USER_BY_CREATOR_USER_ID__INITIALS_ASC'
  | 'USER_BY_CREATOR_USER_ID__INITIALS_DESC'
  | 'USER_BY_CREATOR_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_CREATOR_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_CREATOR_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_CREATOR_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_CREATOR_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_CREATOR_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_CREATOR_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_CREATOR_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_CREATOR_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_CREATOR_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_CREATOR_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_CREATOR_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_CREATOR_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_CREATOR_USER_ID__MOBILE_ASC'
  | 'USER_BY_CREATOR_USER_ID__MOBILE_DESC'
  | 'USER_BY_CREATOR_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_CREATOR_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_CREATOR_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_CREATOR_USER_ID__PHONE_ASC'
  | 'USER_BY_CREATOR_USER_ID__PHONE_DESC'
  | 'USER_BY_CREATOR_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_CREATOR_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_CREATOR_USER_ID__SENIORITY_ASC'
  | 'USER_BY_CREATOR_USER_ID__SENIORITY_DESC'
  | 'USER_BY_USER_ID__ACTIVE_ASC'
  | 'USER_BY_USER_ID__ACTIVE_DESC'
  | 'USER_BY_USER_ID__ADDRESS_ASC'
  | 'USER_BY_USER_ID__ADDRESS_DESC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_ACCOUNT_NUMBER_DESC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_ASC'
  | 'USER_BY_USER_ID__BANK_REGISTRATION_NUMBER_DESC'
  | 'USER_BY_USER_ID__BIRTHDATE_ASC'
  | 'USER_BY_USER_ID__BIRTHDATE_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_APP_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_DESC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_ASC'
  | 'USER_BY_USER_ID__CAN_LOGIN_SSO_DESC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_ASC'
  | 'USER_BY_USER_ID__CAN_SIGN_ON_BEHALF_OF_DESC'
  | 'USER_BY_USER_ID__CITY_ASC'
  | 'USER_BY_USER_ID__CITY_DESC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_ASC'
  | 'USER_BY_USER_ID__COMPANY_ADMIN_DESC'
  | 'USER_BY_USER_ID__COMPANY_ID_ASC'
  | 'USER_BY_USER_ID__COMPANY_ID_DESC'
  | 'USER_BY_USER_ID__CPR_ASC'
  | 'USER_BY_USER_ID__CPR_DESC'
  | 'USER_BY_USER_ID__CUSTOM_ID_ASC'
  | 'USER_BY_USER_ID__CUSTOM_ID_DESC'
  | 'USER_BY_USER_ID__DELETE_AT_ASC'
  | 'USER_BY_USER_ID__DELETE_AT_DESC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_ASC'
  | 'USER_BY_USER_ID__DELETE_REMINDED_DESC'
  | 'USER_BY_USER_ID__DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__EMAIL_ASC'
  | 'USER_BY_USER_ID__EMAIL_DESC'
  | 'USER_BY_USER_ID__EMAIL_WORK_ASC'
  | 'USER_BY_USER_ID__EMAIL_WORK_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_ID_DESC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_ASC'
  | 'USER_BY_USER_ID__EMPLOYEE_NUMBER_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_END_REMINDED_DESC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_ASC'
  | 'USER_BY_USER_ID__EMPLOYMENT_START_DESC'
  | 'USER_BY_USER_ID__FIRST_NAME_ASC'
  | 'USER_BY_USER_ID__FIRST_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_DESC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_ASC'
  | 'USER_BY_USER_ID__FULL_NAME_TSVECTOR_DESC'
  | 'USER_BY_USER_ID__GODMODE_ASC'
  | 'USER_BY_USER_ID__GODMODE_DESC'
  | 'USER_BY_USER_ID__GROUP_IDS_ASC'
  | 'USER_BY_USER_ID__GROUP_IDS_DESC'
  | 'USER_BY_USER_ID__ID_ASC'
  | 'USER_BY_USER_ID__ID_DESC'
  | 'USER_BY_USER_ID__INITIALS_ASC'
  | 'USER_BY_USER_ID__INITIALS_DESC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_ASC'
  | 'USER_BY_USER_ID__IS_ARCHIVED_DESC'
  | 'USER_BY_USER_ID__IS_LEADER_ASC'
  | 'USER_BY_USER_ID__IS_LEADER_DESC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_ASC'
  | 'USER_BY_USER_ID__IS_SYSTEM_USER_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_DESCRIPTION_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TITLE_DESC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_ASC'
  | 'USER_BY_USER_ID__JOB_POSITION_TYPE_DESC'
  | 'USER_BY_USER_ID__LAST_LOGIN_ASC'
  | 'USER_BY_USER_ID__LAST_LOGIN_DESC'
  | 'USER_BY_USER_ID__LAST_NAME_ASC'
  | 'USER_BY_USER_ID__LAST_NAME_DESC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_ASC'
  | 'USER_BY_USER_ID__LEADER_DEPARTMENTS_DESC'
  | 'USER_BY_USER_ID__MOBILE_ASC'
  | 'USER_BY_USER_ID__MOBILE_DESC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_ASC'
  | 'USER_BY_USER_ID__MOBILE_PRIVATE_DESC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_DESC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_ASC'
  | 'USER_BY_USER_ID__NEXT_BIRTHDAY_OR_ANNIVERSARY_DESC'
  | 'USER_BY_USER_ID__PHONE_ASC'
  | 'USER_BY_USER_ID__PHONE_DESC'
  | 'USER_BY_USER_ID__POSTAL_CODE_ASC'
  | 'USER_BY_USER_ID__POSTAL_CODE_DESC'
  | 'USER_BY_USER_ID__SENIORITY_ASC'
  | 'USER_BY_USER_ID__SENIORITY_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__ABSENCE_CODE_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__ABSENCE_CODE_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__ACTIVE_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__ACTIVE_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__APPROVER_FORM_FIELD_IDS_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__APPROVER_FORM_FIELD_IDS_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__APPROVER_GROUP_IDS_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__APPROVER_GROUP_IDS_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__APPROVER_SYSTEM_FIELD_IDS_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__APPROVER_SYSTEM_FIELD_IDS_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__APPROVER_USER_IDS_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__APPROVER_USER_IDS_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__COLOR_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__COLOR_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__COMPANY_ID_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__COMPANY_ID_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__DESCRIPTION_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__DESCRIPTION_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__EMOJI_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__EMOJI_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__ID_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__ID_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__LOCALIZED_NAME_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__LOCALIZED_NAME_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__MUST_BE_APPROVED_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__MUST_BE_APPROVED_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__NAME_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__NAME_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__QUICK_ACTION_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__QUICK_ACTION_DESC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__SEND_CALENDAR_INVITE_ASC'
  | 'VACATION_TYPE_BY_VACATION_TYPE_ID__SEND_CALENDAR_INVITE_DESC'
  | 'VACATION_TYPE_ID_ASC'
  | 'VACATION_TYPE_ID_DESC';

export type WhitelistedField = {
  formFieldId?: InputMaybe<Scalars['UUID']>;
  systemFieldName?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};

/** All input for the `zenegyInsertCustomFieldMarkings` mutation. */
export type ZenegyInsertCustomFieldMarkingsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  integration?: InputMaybe<ExternalIntegrationInput>;
};

/** The output of our `zenegyInsertCustomFieldMarkings` mutation. */
export type ZenegyInsertCustomFieldMarkingsPayload = {
  __typename?: 'ZenegyInsertCustomFieldMarkingsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type ActivateIntegrableSystemIntegrationInput = {
  id: Scalars['UUID'];
};

export type AuthAppInput = {
  appId: Scalars['UUID'];
};

export type AuthAppsInput = {
  offset?: InputMaybe<Scalars['Int']>;
  searchString?: InputMaybe<Scalars['String']>;
};

export type BulkDocumentTemplatePayload = {
  __typename?: 'bulkDocumentTemplatePayload';
  base64?: Maybe<Scalars['String']>;
};

export type BulkUpdateEmployeeCustomMutationInput = {
  employeeIds: Array<Scalars['UUID']>;
  fields: EmployeeCustomMutationInput;
  futureData?: InputMaybe<Array<FutureDatumInput>>;
};

export type CopyCompanyInput = {
  address?: InputMaybe<Scalars['String']>;
  availableLocales: Array<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyTypeId?: InputMaybe<Scalars['UUID']>;
  cvr?: InputMaybe<Scalars['String']>;
  departmentName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  fromCompanyId: Scalars['UUID'];
  includePersonData?: InputMaybe<Scalars['Boolean']>;
  jobPositionTitle: Scalars['String'];
  jobPositionType: Scalars['String'];
  lastName: Scalars['String'];
  locale: Scalars['String'];
  logo?: InputMaybe<Scalars['Upload']>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mobile?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  pNumber?: InputMaybe<Scalars['Int']>;
  postalCode?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateAuthAppInput = {
  appType: Scalars['Int'];
  description: Scalars['String'];
  groupId?: InputMaybe<Scalars['UUID']>;
  homepageUri: Scalars['String'];
  name: Scalars['String'];
};

export type CreateIntegrableSystemIntegrationInput = {
  code: Scalars['String'];
  id: Scalars['UUID'];
};

export type CustomFieldType = {
  __typename?: 'customFieldType';
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type DeleteIntegrableSystemIntegrationInput = {
  id: Scalars['UUID'];
};

export type EmployeeCustomMutationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alternateFirstName?: InputMaybe<Scalars['String']>;
  alternateLastName?: InputMaybe<Scalars['String']>;
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  bankRegistrationNumber?: InputMaybe<Scalars['String']>;
  birthdate?: InputMaybe<Scalars['Date']>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  country?: InputMaybe<Scalars['String']>;
  cpr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departments?: InputMaybe<Scalars['JSON']>;
  directManager?: InputMaybe<Scalars['UUID']>;
  email?: InputMaybe<Scalars['String']>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  emailWork?: InputMaybe<Scalars['String']>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEnd?: InputMaybe<Scalars['String']>;
  employmentJurisdiction?: InputMaybe<Scalars['String']>;
  employmentStart?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntries?: InputMaybe<Scalars['JSON']>;
  fromEngagement?: InputMaybe<Scalars['Boolean']>;
  initials?: InputMaybe<Scalars['String']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  jobPositionDescription?: InputMaybe<Scalars['String']>;
  jobPositionTitle?: InputMaybe<Scalars['String']>;
  jobPositionType?: InputMaybe<Scalars['String']>;
  jobPositionWorkingHours?: InputMaybe<Scalars['String']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  mobilePrivate?: InputMaybe<Scalars['String']>;
  personalGroupIds?: InputMaybe<Array<Scalars['UUID']>>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  seniority?: InputMaybe<Scalars['String']>;
  userDepartmentsToCreate?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userDepartmentsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userId?: InputMaybe<Scalars['UUID']>;
  username?: InputMaybe<Scalars['String']>;
};

export type GetAuthAppPayload = {
  __typename?: 'getAuthAppPayload';
  response?: Maybe<Scalars['JSON']>;
};

export type GetAuthAppsPayload = {
  __typename?: 'getAuthAppsPayload';
  response?: Maybe<Scalars['JSON']>;
};

export type MessageSubscriptionInput = {
  fromEmployeeId: Scalars['UUID'];
};

export type MessageSubscriptionPayload = {
  __typename?: 'messageSubscriptionPayload';
  event?: Maybe<Scalars['String']>;
  message?: Maybe<Message>;
};

export type OrderByInput = {
  direction?: InputMaybe<OrderBy>;
  field?: InputMaybe<Scalars['String']>;
};

export type PinInput = {
  pin: Scalars['String'];
  userId: Scalars['UUID'];
};

export type PresignedLinkInput = {
  filename: Scalars['String'];
};

export type PresignedLinkPayload = {
  __typename?: 'presignedLinkPayload';
  url: Scalars['String'];
};

export type ProcessBulkUploadDocumentsInput = {
  doCreateMissingFolders: Scalars['Boolean'];
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fileName: Scalars['String'];
  inferDocumentTypeFromFileName: Scalars['Boolean'];
};

export type RenewClientSecretInput = {
  appId: Scalars['UUID'];
};

export type RenewClientSecretPayload = {
  __typename?: 'renewClientSecretPayload';
  response?: Maybe<Scalars['JSON']>;
};

export type RequestPinCodeInput = {
  userId: Scalars['UUID'];
};

export type RequestPinCodePayload = {
  __typename?: 'requestPinCodePayload';
  sentTo?: Maybe<Scalars['String']>;
};

export type RevokeRefreshTokensInput = {
  appId: Scalars['UUID'];
};

export type RevokeRefreshTokensPayload = {
  __typename?: 'revokeRefreshTokensPayload';
  response?: Maybe<Scalars['JSON']>;
};

export type SignedContractInput = {
  contractSignPendingDocumentId: Scalars['UUID'];
};

export type StorageBase64Payload = {
  __typename?: 'storageBase64Payload';
  base64?: Maybe<Scalars['String']>;
};

export type StorageDirectUrlPayload = {
  __typename?: 'storageDirectUrlPayload';
  url?: Maybe<Scalars['String']>;
};

export type StorageIdInput = {
  id: Scalars['UUID'];
};

export type TimeRegistrationSubscriptionPayload = {
  __typename?: 'timeRegistrationSubscriptionPayload';
  event?: Maybe<Scalars['String']>;
  timeRegistration?: Maybe<TimeRegistrationPresence>;
};

/** An object where the defined keys will be set on the `announcement` being updated. */
export type UpdateAnnouncementOnAnnouncementForAnnouncementCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addPlayIcon?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<AnnouncementCompanyIdForeignInput>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  popup?: InputMaybe<Scalars['Boolean']>;
  publishAt?: InputMaybe<Scalars['Datetime']>;
  publishAtReminded?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  systemAnnouncement?: InputMaybe<Scalars['Boolean']>;
  teaser?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<AnnouncementUserIdForeignInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementAnnouncementIdForeignInverseInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `announcement` being updated. */
export type UpdateAnnouncementOnAnnouncementForAnnouncementUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addPlayIcon?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<AnnouncementCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  popup?: InputMaybe<Scalars['Boolean']>;
  publishAt?: InputMaybe<Scalars['Datetime']>;
  publishAtReminded?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  systemAnnouncement?: InputMaybe<Scalars['Boolean']>;
  teaser?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<AnnouncementUserIdForeignInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementAnnouncementIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `announcement` being updated. */
export type UpdateAnnouncementOnUserAnnouncementForUserAnnouncementAnnouncementIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addPlayIcon?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<AnnouncementCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  popup?: InputMaybe<Scalars['Boolean']>;
  publishAt?: InputMaybe<Scalars['Datetime']>;
  publishAtReminded?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  systemAnnouncement?: InputMaybe<Scalars['Boolean']>;
  teaser?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<AnnouncementUserIdForeignInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementAnnouncementIdForeignInverseInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `approval` being updated. */
export type UpdateApprovalOnApprovalForApprovalAffectedUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  affectedUserDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  approvingUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<ApprovalCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  deniedAt?: InputMaybe<Scalars['Datetime']>;
  futureDatum?: InputMaybe<FutureDataApprovalIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isDeletionRequest?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['UUID']>;
  requestingUserId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInverseInput>;
  type?: InputMaybe<ApprovalType>;
  user?: InputMaybe<ApprovalRequestingUserIdForeignInput>;
  vacationUserToApprovalIdUsingId?: InputMaybe<VacationUserApprovalIdForeignInverseInput>;
  vacationUserToDeletionApprovalIdUsingId?: InputMaybe<VacationUserDeletionApprovalIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `approval` being updated. */
export type UpdateApprovalOnApprovalForApprovalApprovingUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  affectedUserDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  affectedUserId?: InputMaybe<Scalars['UUID']>;
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<ApprovalCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  deniedAt?: InputMaybe<Scalars['Datetime']>;
  futureDatum?: InputMaybe<FutureDataApprovalIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isDeletionRequest?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['UUID']>;
  requestingUserId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInverseInput>;
  type?: InputMaybe<ApprovalType>;
  user?: InputMaybe<ApprovalRequestingUserIdForeignInput>;
  vacationUserToApprovalIdUsingId?: InputMaybe<VacationUserApprovalIdForeignInverseInput>;
  vacationUserToDeletionApprovalIdUsingId?: InputMaybe<VacationUserDeletionApprovalIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `approval` being updated. */
export type UpdateApprovalOnApprovalForApprovalCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  affectedUserDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  affectedUserId?: InputMaybe<Scalars['UUID']>;
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  approvingUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<ApprovalCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  deniedAt?: InputMaybe<Scalars['Datetime']>;
  futureDatum?: InputMaybe<FutureDataApprovalIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isDeletionRequest?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['UUID']>;
  requestingUserId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInverseInput>;
  type?: InputMaybe<ApprovalType>;
  user?: InputMaybe<ApprovalRequestingUserIdForeignInput>;
  vacationUserToApprovalIdUsingId?: InputMaybe<VacationUserApprovalIdForeignInverseInput>;
  vacationUserToDeletionApprovalIdUsingId?: InputMaybe<VacationUserDeletionApprovalIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `approval` being updated. */
export type UpdateApprovalOnApprovalForApprovalRequestingUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  affectedUserDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  affectedUserId?: InputMaybe<Scalars['UUID']>;
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  approvingUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<ApprovalCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  deniedAt?: InputMaybe<Scalars['Datetime']>;
  futureDatum?: InputMaybe<FutureDataApprovalIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isDeletionRequest?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInverseInput>;
  type?: InputMaybe<ApprovalType>;
  user?: InputMaybe<ApprovalRequestingUserIdForeignInput>;
  vacationUserToApprovalIdUsingId?: InputMaybe<VacationUserApprovalIdForeignInverseInput>;
  vacationUserToDeletionApprovalIdUsingId?: InputMaybe<VacationUserDeletionApprovalIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `approval` being updated. */
export type UpdateApprovalOnFutureDatumForFutureDataApprovalIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  affectedUserDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  affectedUserId?: InputMaybe<Scalars['UUID']>;
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  approvingUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<ApprovalCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  deniedAt?: InputMaybe<Scalars['Datetime']>;
  futureDatum?: InputMaybe<FutureDataApprovalIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isDeletionRequest?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['UUID']>;
  requestingUserId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInverseInput>;
  type?: InputMaybe<ApprovalType>;
  user?: InputMaybe<ApprovalRequestingUserIdForeignInput>;
  vacationUserToApprovalIdUsingId?: InputMaybe<VacationUserApprovalIdForeignInverseInput>;
  vacationUserToDeletionApprovalIdUsingId?: InputMaybe<VacationUserDeletionApprovalIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `approval` being updated. */
export type UpdateApprovalOnTimeRegistrationPresenceForTimeRegistrationPresenceApprovalIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  affectedUserDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  affectedUserId?: InputMaybe<Scalars['UUID']>;
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  approvingUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<ApprovalCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  deniedAt?: InputMaybe<Scalars['Datetime']>;
  futureDatum?: InputMaybe<FutureDataApprovalIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isDeletionRequest?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['UUID']>;
  requestingUserId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInverseInput>;
  type?: InputMaybe<ApprovalType>;
  user?: InputMaybe<ApprovalRequestingUserIdForeignInput>;
  vacationUserToApprovalIdUsingId?: InputMaybe<VacationUserApprovalIdForeignInverseInput>;
  vacationUserToDeletionApprovalIdUsingId?: InputMaybe<VacationUserDeletionApprovalIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `approval` being updated. */
export type UpdateApprovalOnVacationUserForVacationUserDeletionApprovalIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  affectedUserDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  affectedUserId?: InputMaybe<Scalars['UUID']>;
  approvedAt?: InputMaybe<Scalars['Datetime']>;
  approvingUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<ApprovalCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  deniedAt?: InputMaybe<Scalars['Datetime']>;
  futureDatum?: InputMaybe<FutureDataApprovalIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isDeletionRequest?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['UUID']>;
  requestingUserId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInverseInput>;
  type?: InputMaybe<ApprovalType>;
  user?: InputMaybe<ApprovalRequestingUserIdForeignInput>;
  vacationUserToApprovalIdUsingId?: InputMaybe<VacationUserApprovalIdForeignInverseInput>;
  vacationUserToDeletionApprovalIdUsingId?: InputMaybe<VacationUserDeletionApprovalIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `asyncJobItem` being updated. */
export type UpdateAsyncJobItemOnAsyncJobItemForAsyncJobItemAsyncJobIdForeignPatch = {
  asyncJob?: InputMaybe<AsyncJobItemAsyncJobIdForeignInput>;
  company?: InputMaybe<AsyncJobItemCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completionDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<Scalars['String']>;
  messageVariables?: InputMaybe<Scalars['JSON']>;
  tabulation?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<AsyncJobItemUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `asyncJobItem` being updated. */
export type UpdateAsyncJobItemOnAsyncJobItemForAsyncJobItemCompanyIdForeignPatch = {
  asyncJob?: InputMaybe<AsyncJobItemAsyncJobIdForeignInput>;
  asyncJobId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<AsyncJobItemCompanyIdForeignInput>;
  completionDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<Scalars['String']>;
  messageVariables?: InputMaybe<Scalars['JSON']>;
  tabulation?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<AsyncJobItemUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `asyncJobItem` being updated. */
export type UpdateAsyncJobItemOnAsyncJobItemForAsyncJobItemUserIdForeignPatch = {
  asyncJob?: InputMaybe<AsyncJobItemAsyncJobIdForeignInput>;
  asyncJobId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<AsyncJobItemCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completionDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<Scalars['String']>;
  messageVariables?: InputMaybe<Scalars['JSON']>;
  tabulation?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<AsyncJobItemUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `asyncJob` being updated. */
export type UpdateAsyncJobOnAsyncJobForAsyncJobCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  asyncJobItems?: InputMaybe<AsyncJobItemAsyncJobIdForeignInverseInput>;
  company?: InputMaybe<AsyncJobCompanyIdForeignInput>;
  completionDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  type?: InputMaybe<AsyncJobType>;
  user?: InputMaybe<AsyncJobUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `asyncJob` being updated. */
export type UpdateAsyncJobOnAsyncJobForAsyncJobUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  asyncJobItems?: InputMaybe<AsyncJobItemAsyncJobIdForeignInverseInput>;
  company?: InputMaybe<AsyncJobCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completionDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  type?: InputMaybe<AsyncJobType>;
  user?: InputMaybe<AsyncJobUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `asyncJob` being updated. */
export type UpdateAsyncJobOnAsyncJobItemForAsyncJobItemAsyncJobIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  asyncJobItems?: InputMaybe<AsyncJobItemAsyncJobIdForeignInverseInput>;
  company?: InputMaybe<AsyncJobCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completionDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  type?: InputMaybe<AsyncJobType>;
  user?: InputMaybe<AsyncJobUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateAuthAppInput = {
  appId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['UUID']>;
  homepageUri?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `authApp` being updated. */
export type UpdateAuthAppOnAuthAppForAuthAppAppTypeFkeyPatch = {
  apiKey?: InputMaybe<Scalars['JSON']>;
  authAppType?: InputMaybe<AuthAppAppTypeFkeyInput>;
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegrations?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInverseInput>;
  group?: InputMaybe<AuthAppTableGroupIdFkInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  homepageUri?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  redirectUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  storage?: InputMaybe<AuthAppStorageIdFkeyInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
  tokensRevokedAt?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `authApp` being updated. */
export type UpdateAuthAppOnAuthAppForAuthAppStorageIdFkeyPatch = {
  apiKey?: InputMaybe<Scalars['JSON']>;
  appType?: InputMaybe<Scalars['Int']>;
  authAppType?: InputMaybe<AuthAppAppTypeFkeyInput>;
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegrations?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInverseInput>;
  group?: InputMaybe<AuthAppTableGroupIdFkInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  homepageUri?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  redirectUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  storage?: InputMaybe<AuthAppStorageIdFkeyInput>;
  tokensRevokedAt?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `authApp` being updated. */
export type UpdateAuthAppOnAuthAppForAuthAppTableGroupIdFkPatch = {
  apiKey?: InputMaybe<Scalars['JSON']>;
  appType?: InputMaybe<Scalars['Int']>;
  authAppType?: InputMaybe<AuthAppAppTypeFkeyInput>;
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegrations?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInverseInput>;
  group?: InputMaybe<AuthAppTableGroupIdFkInput>;
  homepageUri?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  redirectUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  storage?: InputMaybe<AuthAppStorageIdFkeyInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
  tokensRevokedAt?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `authApp` being updated. */
export type UpdateAuthAppOnExternalIntegrationForExternalIntegrationAuthAppIdFkeyPatch = {
  apiKey?: InputMaybe<Scalars['JSON']>;
  appType?: InputMaybe<Scalars['Int']>;
  authAppType?: InputMaybe<AuthAppAppTypeFkeyInput>;
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegrations?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInverseInput>;
  group?: InputMaybe<AuthAppTableGroupIdFkInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  homepageUri?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  redirectUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  storage?: InputMaybe<AuthAppStorageIdFkeyInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
  tokensRevokedAt?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `authApp` being updated. */
export type UpdateAuthAppOnIntegrationFieldMarkingForIntegrationFieldMarkingAuthAppIdFkeyPatch = {
  apiKey?: InputMaybe<Scalars['JSON']>;
  appType?: InputMaybe<Scalars['Int']>;
  authAppType?: InputMaybe<AuthAppAppTypeFkeyInput>;
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegrations?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInverseInput>;
  group?: InputMaybe<AuthAppTableGroupIdFkInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  homepageUri?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  redirectUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  storage?: InputMaybe<AuthAppStorageIdFkeyInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
  tokensRevokedAt?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `authAppType` being updated. */
export type UpdateAuthAppTypeOnAuthAppForAuthAppAppTypeFkeyPatch = {
  authApps?: InputMaybe<AuthAppAppTypeFkeyInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `changelog` being updated. */
export type UpdateChangelogOnChangelogUserForChangelogUserChangelogIdForeignPatch = {
  changelogUsers?: InputMaybe<ChangelogUserChangelogIdForeignInverseInput>;
  guides?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isAppNotes?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  major?: InputMaybe<Scalars['String']>;
  minor?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  releaseDate?: InputMaybe<Scalars['Date']>;
  system?: InputMaybe<SystemType>;
  version?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `changelogUser` being updated. */
export type UpdateChangelogUserOnChangelogUserForChangelogUserChangelogIdForeignPatch = {
  changelog?: InputMaybe<ChangelogUserChangelogIdForeignInput>;
  user?: InputMaybe<ChangelogUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `changelogUser` being updated. */
export type UpdateChangelogUserOnChangelogUserForChangelogUserUserIdForeignPatch = {
  changelog?: InputMaybe<ChangelogUserChangelogIdForeignInput>;
  changelogId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<ChangelogUserUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `channelType` being updated. */
export type UpdateChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeChannelTypeIdForeignPatch = {
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeChannelTypeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `chosenColumn` being updated. */
export type UpdateChosenColumnOnChosenColumnForChosenColumnsUserIdForeignPatch = {
  chosenColumns?: InputMaybe<Scalars['JSON']>;
  filters?: InputMaybe<Scalars['JSON']>;
  miscellaneousFilters?: InputMaybe<Scalars['JSON']>;
  tableName?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<ChosenColumnsUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `companyBinding` being updated. */
export type UpdateCompanyBindingOnCompanyBindingForCompanyBindingCompanyIdForeignPatch = {
  company?: InputMaybe<CompanyBindingCompanyIdForeignInput>;
  legacyCompanyId?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `companyCompanyType` being updated. */
export type UpdateCompanyCompanyTypeOnCompanyCompanyTypeForCompanyCompanyTypeCompanyIdForeignPatch = {
  company?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInput>;
  companyType?: InputMaybe<CompanyCompanyTypeCompanyTypeIdForeignInput>;
  companyTypeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `companyCompanyType` being updated. */
export type UpdateCompanyCompanyTypeOnCompanyCompanyTypeForCompanyCompanyTypeCompanyTypeIdForeignPatch = {
  company?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companyType?: InputMaybe<CompanyCompanyTypeCompanyTypeIdForeignInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnAnnouncementForAnnouncementCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnApprovalForApprovalCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnAsyncJobForAsyncJobCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnAsyncJobItemForAsyncJobItemCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnCompanyBindingForCompanyBindingCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnCompanyCompanyTypeForCompanyCompanyTypeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnCompanyForCompanyMasterForCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnCompanySettingForCompanySettingCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnCompanySystemFieldForCompanySystemFieldCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnCompetenceForCompetenceCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnCompetenceFormFieldForCompetenceFormFieldCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnCompetenceGroupForCompetenceGroupCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnCompetenceRequestForCompetenceRequestCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnContractSignPendingDocumentForContractSignPendingDocumentCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnContractSignPendingForContractSignPendingCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnContractSignPendingSignerForContractSignPendingSignerCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnContractTemplateDepartmentForContractTemplateDepartmentsCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnContractTemplateUserForContractTemplateUsersCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnCustomWidgetContentForCustomWidgetContentCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnCustomWidgetForCustomWidgetCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnCvTemplateFieldMappingForCvTemplateFieldMappingCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnDashboardCardForDashboardCardCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnDashboardCardStatisticForDashboardCardStatisticCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnDashboardConfigForDashboardConfigCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnDashboardViewForDashboardViewCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnDepartmentForDepartmentCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnDepartmentTypeForDepartmentTypeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnDocumentFolderBlueprintForDocumentFolderBlueprintCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnDocumentFolderDepartmentForDocumentFolderDepartmentCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnDocumentFolderForDocumentFolderCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnDocumentFolderUserForDocumentFolderUserCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnDocumentUserPermissionForDocumentUserPermissionsCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnDocumentUserResponsibleForDocumentUserResponsibleCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnEmployeeCasefileForEmployeeCasefileCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnEmployeeExternalIntegrationForEmployeeExternalIntegrationCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnEmployeeForEmployeeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnEngagementTypeForEngagementTypeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnEquipmentForEquipmentCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnEventForEventCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnEventUserForEventUserCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnExternalIntegrationForExternalIntegrationCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnFieldGroupCardColumnForFieldGroupCardColumnCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnFieldGroupCardForFieldGroupCardCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnFieldGroupForFormFieldTypeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnFilterPresetForFilterPresetCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnFormFieldAgreementForFormFieldAgreementCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnFormFieldEntryForFormFieldEntryCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnFormFieldOptionForFormFieldOptionCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnFroalaStyleForFroalaStylesCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnFutureDatumForFutureDataCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnGroupRoleForGroupRoleCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnIntegrationFieldMarkingForIntegrationFieldMarkingCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnLatestMessageForLatestMessageCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnLoggedActionNoteForLoggedActionNoteCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnLoginLogForLoginLogCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnMessageForMessageCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnNotificationCustomRecipientForNotificationCustomRecipientCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnNotificationEmployeeForNotificationEmployeeCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnNotificationGroupRecipientForNotificationGroupRecipientCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnNotificationTypeChannelTypeForNotificationTypeChannelTypeCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnPostForPostCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnPostTypeForPostTypeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnPreboardingCommentForPreboardingCommentCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnPreboardingEmailLogForPreboardingEmailLogCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnPreboardingEmployeeForPreboardingEmployeeCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnPreboardingForPreboardingCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnPreboardingProcessForPreboardingProcessCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnPreboardingResultForPreboardingResultCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnPreboardingResultSlideCommentForPreboardingResultSlideCommentCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnPreboardingSlideForPreboardingSlideCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnPreboardingSlideFormFieldForPreboardingSlideFormFieldCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnProcessDepartmentForProcessDepartmentCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnProcessResponsibleForProcessResponsibleCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnProcessTypeForProcessTypeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnProjectForProjectCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnProjectTemplateForProjectTemplateCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnPulseSurveyAnswerForPulseSurveyAnswerCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnPulseSurveyChoiceForPulseSurveyChoiceCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnPulseSurveyForPulseSurveyCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnPulseTypeForPulseTypeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnRecurrenceRuleForRecurrenceRuleCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnReferenceTokenForReferenceTokenCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnRelationRoleForRelationRoleCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnScheduledMessageForScheduledMessageCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnScheduledMessageRecipientForScheduledMessageRecipientCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnScheduledMessageTemplateExternalRecipientForScheduledMessageTemplateExternalRecipientCompanyIdForeigPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnScheduledMessageTemplateForScheduledMessageTemplateCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnSuperUserAllowedUserForSuperUserAllowedUsersCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnTaskEmployeeForTaskEmployeeCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnTaskForTaskCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnTaskResponsibleForTaskResponsibleCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnTaskTemplateEmployeeForTaskTemplateEmployeeCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnTaskTemplateForTaskTemplateCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnTaskTemplateResponsibleForTaskTemplateResponsibleCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnTimeRegistrationBreakTypeForTimeRegistrationBreakTypeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnTimeRegistrationEntryForTimeRegistrationEntryCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnTimeRegistrationPresenceForTimeRegistrationPresenceCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnTimeRegistrationPresenceTypeForTimeRegistrationPresenceTypeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnTimeRegistrationProjectForTimeRegistrationProjectCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnTimeRegistrationTemplateForTimeRegistrationTemplateCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnTranslatedEntityForTranslatedEntityCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnTranslatedEntityLocalizationForTranslatedEntityLocalizationCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnTranslationForTranslationCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnUserCompanyGroupForUserCompanyGroupCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnUserCompanyRoleForUserCompanyRoleCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnUserCompetenceEvaluationForUserCompetenceEvaluationCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnUserCompetenceForUserCompetenceCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnUserDepartmentForUserDepartmentCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnUserDepartmentGroupForUserDepartmentGroupCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnUserDepartmentRoleForUserDepartmentRoleCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnUserForUserCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnUserGroupForUserGroupCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnUserOnBehalfPermissionForUserOnBehalfPermissionsCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnUserRoleForUserRoleCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnUserSystemFieldForUserSystemFieldCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnVacationTypeForVacationTypeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `company` being updated. */
export type UpdateCompanyOnVacationUserForVacationUserCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCompanyIdForeignInverseInput>;
  approvals?: InputMaybe<ApprovalCompanyIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemCompanyIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobCompanyIdForeignInverseInput>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  company?: InputMaybe<CompanyMasterForCompanyIdForeignInput>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']>>;
  companyBindings?: InputMaybe<CompanyBindingCompanyIdForeignInverseInput>;
  companyCompanyType?: InputMaybe<CompanyCompanyTypeCompanyIdForeignInverseInput>;
  companySettings?: InputMaybe<CompanySettingCompanyIdForeignInverseInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInverseInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldCompanyIdForeignInverseInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompanyIdForeignInverseInput>;
  competenceGroups?: InputMaybe<CompetenceGroupCompanyIdForeignInverseInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompanyIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceCompanyIdForeignInverseInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingCompanyIdFkeyInverseInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInverseInput>;
  copyInProgress?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCompanyIdForeignInverseInput>;
  customWidgets?: InputMaybe<CustomWidgetCompanyIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInverseInput>;
  cvr?: InputMaybe<Scalars['String']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticCompanyIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCompanyIdForeignInverseInput>;
  dashboardConfig?: InputMaybe<DashboardConfigCompanyIdForeignInverseInput>;
  dashboardViews?: InputMaybe<DashboardViewCompanyIdForeignInverseInput>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  departmentTypes?: InputMaybe<DepartmentTypeCompanyIdForeignInverseInput>;
  departments?: InputMaybe<DepartmentCompanyIdForeignInverseInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInverseInput>;
  documentFolderBlueprints?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserCompanyIdForeignInverseInput>;
  documentFolders?: InputMaybe<DocumentFolderCompanyIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileCompanyIdFkeyInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInverseInput>;
  employees?: InputMaybe<EmployeeCompanyIdForeignInverseInput>;
  engagementTypes?: InputMaybe<EngagementTypeCompanyIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentCompanyIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserCompanyIdForeignInverseInput>;
  events?: InputMaybe<EventCompanyIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationCompanyIdForeignInverseInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInverseInput>;
  fieldGroupCards?: InputMaybe<FieldGroupCardCompanyIdForeignInverseInput>;
  fieldGroups?: InputMaybe<FormFieldTypeCompanyIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetCompanyIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementCompanyIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryCompanyIdFkeyInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionCompanyIdFkeyInverseInput>;
  froalaStyles?: InputMaybe<FroalaStylesCompanyIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataCompanyIdForeignInverseInput>;
  groupRoles?: InputMaybe<GroupRoleCompanyIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInverseInput>;
  latestMessages?: InputMaybe<LatestMessageCompanyIdForeignInverseInput>;
  locale?: InputMaybe<Scalars['String']>;
  loggedActionNotes?: InputMaybe<LoggedActionNoteCompanyIdForeignInverseInput>;
  loginLogs?: InputMaybe<LoginLogCompanyIdForeignInverseInput>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  messages?: InputMaybe<MessageCompanyIdFkeyInverseInput>;
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeCompanyIdFkeyInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInverseInput>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInverseInput>;
  postTypes?: InputMaybe<PostTypeCompanyIdForeignInverseInput>;
  posts?: InputMaybe<PostCompanyIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentCompanyIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessCompanyIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultCompanyIdFkeyInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideCompanyIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingCompanyIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentCompanyIdFkeyInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleCompanyIdFkeyInverseInput>;
  processTypes?: InputMaybe<ProcessTypeCompanyIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateCompanyIdFkeyInverseInput>;
  projects?: InputMaybe<ProjectCompanyIdFkeyInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyCompanyIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeCompanyIdForeignInverseInput>;
  recurrenceRules?: InputMaybe<RecurrenceRuleCompanyIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenCompanyIdFkeyInverseInput>;
  relationRoles?: InputMaybe<RelationRoleCompanyIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageCompanyIdForeignInverseInput>;
  sso?: InputMaybe<Scalars['String']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeCompanyIdFkeyInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleCompanyIdFkeyInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCompanyIdFkeyInverseInput>;
  tasks?: InputMaybe<TaskCompanyIdFkeyInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInverseInput>;
  timeRegistrationProjects?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInverseInput>;
  translatedEntities?: InputMaybe<TranslatedEntityCompanyIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInverseInput>;
  translations?: InputMaybe<TranslationCompanyIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupCompanyIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleCompanyIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceCompanyIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupCompanyIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleCompanyIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentCompanyIdFkeyInverseInput>;
  userGroups?: InputMaybe<UserGroupCompanyIdFkeyInverseInput>;
  userOnBehalfPermissions?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleCompanyIdFkeyInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldCompanyIdForeignInverseInput>;
  users?: InputMaybe<UserCompanyIdForeignInverseInput>;
  vacationTypes?: InputMaybe<VacationTypeCompanyIdForeignInverseInput>;
  vacationUsers?: InputMaybe<VacationUserCompanyIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `companySetting` being updated. */
export type UpdateCompanySettingOnCompanySettingForCompanySettingCompanyIdForeignPatch = {
  company?: InputMaybe<CompanySettingCompanyIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  key?: InputMaybe<CompanySettingKey>;
  storage?: InputMaybe<CompanySettingValueStorageIdForeignInput>;
  value?: InputMaybe<Scalars['String']>;
  valueBoolean?: InputMaybe<Scalars['Boolean']>;
  valueStorageId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `companySetting` being updated. */
export type UpdateCompanySettingOnCompanySettingForCompanySettingValueStorageIdForeignPatch = {
  company?: InputMaybe<CompanySettingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  key?: InputMaybe<CompanySettingKey>;
  storage?: InputMaybe<CompanySettingValueStorageIdForeignInput>;
  value?: InputMaybe<Scalars['String']>;
  valueBoolean?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `companySystemField` being updated. */
export type UpdateCompanySystemFieldOnCompanySystemFieldForCompanySystemFieldAliasTranslatedEntityIdForeignPatch = {
  alias?: InputMaybe<Scalars['String']>;
  aliasLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  helpText?: InputMaybe<Scalars['String']>;
  helpTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  helpTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  order?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  systemField?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInput>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `companySystemField` being updated. */
export type UpdateCompanySystemFieldOnCompanySystemFieldForCompanySystemFieldCompanyIdForeignPatch = {
  alias?: InputMaybe<Scalars['String']>;
  aliasLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  aliasTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldCompanyIdForeignInput>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  helpText?: InputMaybe<Scalars['String']>;
  helpTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  helpTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  order?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  systemField?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInput>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `companySystemField` being updated. */
export type UpdateCompanySystemFieldOnCompanySystemFieldForCompanySystemFieldFieldGroupCardColumnIdForeignPatch = {
  alias?: InputMaybe<Scalars['String']>;
  aliasLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  aliasTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  helpText?: InputMaybe<Scalars['String']>;
  helpTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  helpTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  order?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  systemField?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInput>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `companySystemField` being updated. */
export type UpdateCompanySystemFieldOnCompanySystemFieldForCompanySystemFieldFormFieldTypeIdForeignPatch = {
  alias?: InputMaybe<Scalars['String']>;
  aliasLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  aliasTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  helpText?: InputMaybe<Scalars['String']>;
  helpTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  helpTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  order?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  systemField?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInput>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `companySystemField` being updated. */
export type UpdateCompanySystemFieldOnCompanySystemFieldForCompanySystemFieldHelpTextTranslatedEntityIdForeignPatch = {
  alias?: InputMaybe<Scalars['String']>;
  aliasLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  aliasTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  helpText?: InputMaybe<Scalars['String']>;
  helpTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  order?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  systemField?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInput>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `companySystemField` being updated. */
export type UpdateCompanySystemFieldOnCompanySystemFieldForCompanySystemFieldSystemFieldIdForeignPatch = {
  alias?: InputMaybe<Scalars['String']>;
  aliasLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  aliasTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  helpText?: InputMaybe<Scalars['String']>;
  helpTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  helpTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  order?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  systemField?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInput>;
  translatedEntity?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInput>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `companySystemField` being updated. */
export type UpdateCompanySystemFieldOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanySystemFieldIdForeignPatch = {
  alias?: InputMaybe<Scalars['String']>;
  aliasLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  aliasTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  helpText?: InputMaybe<Scalars['String']>;
  helpTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  helpTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  order?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  systemField?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInput>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `companySystemFieldOption` being updated. */
export type UpdateCompanySystemFieldOptionOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInput>;
  companySystemField?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInput>;
  companySystemFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `companySystemFieldOption` being updated. */
export type UpdateCompanySystemFieldOptionOnCompanySystemFieldOptionForCompanySystemFieldOptionCompanySystemFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompanySystemFieldOptionCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemField?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `companyType` being updated. */
export type UpdateCompanyTypeOnCompanyCompanyTypeForCompanyCompanyTypeCompanyTypeIdForeignPatch = {
  companyCompanyTypes?: InputMaybe<CompanyCompanyTypeCompanyTypeIdForeignInverseInput>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `competenceFormField` being updated. */
export type UpdateCompetenceFormFieldOnCompetenceFormFieldForCompetenceFormFieldCompanyIdForeignPatch = {
  company?: InputMaybe<CompetenceFormFieldCompanyIdForeignInput>;
  competence?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `competenceFormField` being updated. */
export type UpdateCompetenceFormFieldOnCompetenceFormFieldForCompetenceFormFieldCompetenceIdForeignPatch = {
  company?: InputMaybe<CompetenceFormFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInput>;
  formField?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `competenceFormField` being updated. */
export type UpdateCompetenceFormFieldOnCompetenceFormFieldForCompetenceFormFieldFormFieldIdForeignPatch = {
  company?: InputMaybe<CompetenceFormFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `competenceGroup` being updated. */
export type UpdateCompetenceGroupOnCompetenceForCompetenceCompetenceGroupIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competences?: InputMaybe<CompetenceCompetenceGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `competenceGroup` being updated. */
export type UpdateCompetenceGroupOnCompetenceGroupForCompetenceGroupCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceGroupCompanyIdForeignInput>;
  competences?: InputMaybe<CompetenceCompetenceGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `competenceGroup` being updated. */
export type UpdateCompetenceGroupOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompetenceGroupIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competences?: InputMaybe<CompetenceCompetenceGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `competence` being updated. */
export type UpdateCompetenceOnCompetenceForCompetenceCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceCompanyIdForeignInput>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInverseInput>;
  competenceGroup?: InputMaybe<CompetenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceRequests?: InputMaybe<CompetenceRequestCompetenceIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CompetenceRatingFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInverseInput>;
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
  outdateAt?: InputMaybe<Scalars['Datetime']>;
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  outdateInterval?: InputMaybe<IntervalInput>;
  ratingFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<IntervalInput>;
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useRating?: InputMaybe<Scalars['Boolean']>;
  userCompetences?: InputMaybe<UserCompetenceCompetenceIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `competence` being updated. */
export type UpdateCompetenceOnCompetenceForCompetenceCompetenceGroupIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInverseInput>;
  competenceGroup?: InputMaybe<CompetenceCompetenceGroupIdForeignInput>;
  competenceRequests?: InputMaybe<CompetenceRequestCompetenceIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CompetenceRatingFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInverseInput>;
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
  outdateAt?: InputMaybe<Scalars['Datetime']>;
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  outdateInterval?: InputMaybe<IntervalInput>;
  ratingFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<IntervalInput>;
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useRating?: InputMaybe<Scalars['Boolean']>;
  userCompetences?: InputMaybe<UserCompetenceCompetenceIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `competence` being updated. */
export type UpdateCompetenceOnCompetenceForCompetenceRatingFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInverseInput>;
  competenceGroup?: InputMaybe<CompetenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceRequests?: InputMaybe<CompetenceRequestCompetenceIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CompetenceRatingFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInverseInput>;
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
  outdateAt?: InputMaybe<Scalars['Datetime']>;
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  outdateInterval?: InputMaybe<IntervalInput>;
  reminderInterval?: InputMaybe<IntervalInput>;
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useRating?: InputMaybe<Scalars['Boolean']>;
  userCompetences?: InputMaybe<UserCompetenceCompetenceIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `competence` being updated. */
export type UpdateCompetenceOnCompetenceFormFieldForCompetenceFormFieldCompetenceIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInverseInput>;
  competenceGroup?: InputMaybe<CompetenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceRequests?: InputMaybe<CompetenceRequestCompetenceIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CompetenceRatingFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInverseInput>;
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
  outdateAt?: InputMaybe<Scalars['Datetime']>;
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  outdateInterval?: InputMaybe<IntervalInput>;
  ratingFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<IntervalInput>;
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useRating?: InputMaybe<Scalars['Boolean']>;
  userCompetences?: InputMaybe<UserCompetenceCompetenceIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `competence` being updated. */
export type UpdateCompetenceOnCompetenceRequestForCompetenceRequestCompetenceIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInverseInput>;
  competenceGroup?: InputMaybe<CompetenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceRequests?: InputMaybe<CompetenceRequestCompetenceIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CompetenceRatingFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInverseInput>;
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
  outdateAt?: InputMaybe<Scalars['Datetime']>;
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  outdateInterval?: InputMaybe<IntervalInput>;
  ratingFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<IntervalInput>;
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useRating?: InputMaybe<Scalars['Boolean']>;
  userCompetences?: InputMaybe<UserCompetenceCompetenceIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `competence` being updated. */
export type UpdateCompetenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompetenceIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInverseInput>;
  competenceGroup?: InputMaybe<CompetenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceRequests?: InputMaybe<CompetenceRequestCompetenceIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CompetenceRatingFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInverseInput>;
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
  outdateAt?: InputMaybe<Scalars['Datetime']>;
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  outdateInterval?: InputMaybe<IntervalInput>;
  ratingFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<IntervalInput>;
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useRating?: InputMaybe<Scalars['Boolean']>;
  userCompetences?: InputMaybe<UserCompetenceCompetenceIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `competence` being updated. */
export type UpdateCompetenceOnUserCompetenceForUserCompetenceCompetenceIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldCompetenceIdForeignInverseInput>;
  competenceGroup?: InputMaybe<CompetenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceRequests?: InputMaybe<CompetenceRequestCompetenceIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CompetenceRatingFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInverseInput>;
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
  outdateAt?: InputMaybe<Scalars['Datetime']>;
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  outdateInterval?: InputMaybe<IntervalInput>;
  ratingFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<IntervalInput>;
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useRating?: InputMaybe<Scalars['Boolean']>;
  userCompetences?: InputMaybe<UserCompetenceCompetenceIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `competenceRequest` being updated. */
export type UpdateCompetenceRequestOnCompetenceRequestForCompetenceRequestCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceRequestCompanyIdForeignInput>;
  competence?: InputMaybe<CompetenceRequestCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `competenceRequest` being updated. */
export type UpdateCompetenceRequestOnCompetenceRequestForCompetenceRequestCompetenceIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompetenceRequestCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<CompetenceRequestCompetenceIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `contractPredefinedPlaceholder` being updated. */
export type UpdateContractPredefinedPlaceholderOnContractPredefinedPlaceholderForContractPredefinedPlaceholderFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  alias?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  placeholder?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `contractSignPendingDocument` being updated. */
export type UpdateContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentCompanyIdForeignPatch = {
  company?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInput>;
  contractName?: InputMaybe<Scalars['String']>;
  contractSignPending?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  deleteExistingStorage?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  existingStorageId?: InputMaybe<Scalars['UUID']>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  storage?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInput>;
  storages?: InputMaybe<StorageContractSignPendingDocumentIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `contractSignPendingDocument` being updated. */
export type UpdateContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentContractSignPendingIdForeignPatch = {
  company?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractName?: InputMaybe<Scalars['String']>;
  contractSignPending?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInput>;
  contractTemplate?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  deleteExistingStorage?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  existingStorageId?: InputMaybe<Scalars['UUID']>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  storage?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInput>;
  storages?: InputMaybe<StorageContractSignPendingDocumentIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `contractSignPendingDocument` being updated. */
export type UpdateContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentContractTemplateIdForeignPatch = {
  company?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractName?: InputMaybe<Scalars['String']>;
  contractSignPending?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInput>;
  deleteExistingStorage?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  existingStorageId?: InputMaybe<Scalars['UUID']>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  storage?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInput>;
  storages?: InputMaybe<StorageContractSignPendingDocumentIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `contractSignPendingDocument` being updated. */
export type UpdateContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentDocumentTypeIdForeignPatch = {
  company?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractName?: InputMaybe<Scalars['String']>;
  contractSignPending?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  deleteExistingStorage?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInput>;
  existingStorageId?: InputMaybe<Scalars['UUID']>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  storage?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInput>;
  storages?: InputMaybe<StorageContractSignPendingDocumentIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `contractSignPendingDocument` being updated. */
export type UpdateContractSignPendingDocumentOnContractSignPendingDocumentForContractSignPendingDocumentExistingStorageIdForeignPatch = {
  company?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractName?: InputMaybe<Scalars['String']>;
  contractSignPending?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  deleteExistingStorage?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  storage?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInput>;
  storages?: InputMaybe<StorageContractSignPendingDocumentIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `contractSignPendingDocument` being updated. */
export type UpdateContractSignPendingDocumentOnStorageForStorageContractSignPendingDocumentIdForeignPatch = {
  company?: InputMaybe<ContractSignPendingDocumentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractName?: InputMaybe<Scalars['String']>;
  contractSignPending?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  deleteExistingStorage?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  existingStorageId?: InputMaybe<Scalars['UUID']>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  storage?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInput>;
  storages?: InputMaybe<StorageContractSignPendingDocumentIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `contractSignPending` being updated. */
export type UpdateContractSignPendingOnContractSignPendingDocumentForContractSignPendingDocumentContractSignPendingIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `contractSignPending` being updated. */
export type UpdateContractSignPendingOnContractSignPendingForContractSignPendingCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `contractSignPending` being updated. */
export type UpdateContractSignPendingOnContractSignPendingForContractSignPendingCreatorUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `contractSignPending` being updated. */
export type UpdateContractSignPendingOnContractSignPendingForContractSignPendingEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `contractSignPending` being updated. */
export type UpdateContractSignPendingOnContractSignPendingForContractSignPendingMergedDocumentDocumentTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `contractSignPending` being updated. */
export type UpdateContractSignPendingOnContractSignPendingForContractSignPendingNextSigningUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `contractSignPending` being updated. */
export type UpdateContractSignPendingOnContractSignPendingForContractSignPendingPreboardingEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `contractSignPending` being updated. */
export type UpdateContractSignPendingOnContractSignPendingForContractSignPendingPreboardingSlideFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `contractSignPending` being updated. */
export type UpdateContractSignPendingOnContractSignPendingForContractSignPendingUserIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `contractSignPending` being updated. */
export type UpdateContractSignPendingOnContractSignPendingSignerForContractSignPendingSignerContractSignPendingIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `contractSignPending` being updated. */
export type UpdateContractSignPendingOnNotificationEmployeeReferenceForNotificationEmployeeReferenceContractSignPendingIdForeigPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ContractSignPendingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractSignPendingIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInput>;
  emailText?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<ContractSignPendingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInverseInput>;
  preboardingEmployee?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormField?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInput>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `contractSignPendingSigner` being updated. */
export type UpdateContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerCompanyIdForeignPatch = {
  coSigningUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  company?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInput>;
  contractSignPending?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  ip?: InputMaybe<Scalars['String']>;
  lastReminded?: InputMaybe<Scalars['Datetime']>;
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  refusalReason?: InputMaybe<Scalars['String']>;
  refused?: InputMaybe<Scalars['Boolean']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signOrder?: InputMaybe<Scalars['Int']>;
  signatureFileId?: InputMaybe<Scalars['UUID']>;
  signed?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInput>;
  useSecondaryEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInput>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `contractSignPendingSigner` being updated. */
export type UpdateContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerContractSignPendingIdForeignPatch = {
  coSigningUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  company?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  ip?: InputMaybe<Scalars['String']>;
  lastReminded?: InputMaybe<Scalars['Datetime']>;
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  refusalReason?: InputMaybe<Scalars['String']>;
  refused?: InputMaybe<Scalars['Boolean']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signOrder?: InputMaybe<Scalars['Int']>;
  signatureFileId?: InputMaybe<Scalars['UUID']>;
  signed?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInput>;
  useSecondaryEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInput>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `contractSignPendingSigner` being updated. */
export type UpdateContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerOnBehalfOfUserIdForeignPatch = {
  coSigningUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  company?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  ip?: InputMaybe<Scalars['String']>;
  lastReminded?: InputMaybe<Scalars['Datetime']>;
  refusalReason?: InputMaybe<Scalars['String']>;
  refused?: InputMaybe<Scalars['Boolean']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signOrder?: InputMaybe<Scalars['Int']>;
  signatureFileId?: InputMaybe<Scalars['UUID']>;
  signed?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInput>;
  useSecondaryEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInput>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `contractSignPendingSigner` being updated. */
export type UpdateContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerSignatureFileIdForeignPatch = {
  coSigningUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  company?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  ip?: InputMaybe<Scalars['String']>;
  lastReminded?: InputMaybe<Scalars['Datetime']>;
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  refusalReason?: InputMaybe<Scalars['String']>;
  refused?: InputMaybe<Scalars['Boolean']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signOrder?: InputMaybe<Scalars['Int']>;
  signed?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInput>;
  useSecondaryEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInput>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `contractSignPendingSigner` being updated. */
export type UpdateContractSignPendingSignerOnContractSignPendingSignerForContractSignPendingSignerUserIdForeignPatch = {
  coSigningUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  company?: InputMaybe<ContractSignPendingSignerCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<ContractSignPendingSignerContractSignPendingIdForeignInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  ip?: InputMaybe<Scalars['String']>;
  lastReminded?: InputMaybe<Scalars['Datetime']>;
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  refusalReason?: InputMaybe<Scalars['String']>;
  refused?: InputMaybe<Scalars['Boolean']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signOrder?: InputMaybe<Scalars['Int']>;
  signatureFileId?: InputMaybe<Scalars['UUID']>;
  signed?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInput>;
  useSecondaryEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInput>;
  userAgent?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `contractTemplateDepartment` being updated. */
export type UpdateContractTemplateDepartmentOnContractTemplateDepartmentForContractTemplateDepartmentsCompanyIdFkeyPatch = {
  company?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInput>;
  contractTemplate?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  contractTemplateIsSignable?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `contractTemplateDepartment` being updated. */
export type UpdateContractTemplateDepartmentOnContractTemplateDepartmentForContractTemplateDepartmentsContractTemplateIdForeignPatch = {
  company?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInput>;
  contractTemplateIsSignable?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `contractTemplateDepartment` being updated. */
export type UpdateContractTemplateDepartmentOnContractTemplateDepartmentForContractTemplateDepartmentsDepartmentIdForeignPatch = {
  company?: InputMaybe<ContractTemplateDepartmentsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  contractTemplateIsSignable?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `contractTemplate` being updated. */
export type UpdateContractTemplateOnContractSignPendingDocumentForContractSignPendingDocumentContractTemplateIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInverseInput>;
  contractSignPendingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInverseInput>;
  contractTemplateFormFields?: InputMaybe<ContractTemplateFormFieldContractTemplateIdForeignInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<ContractTemplateDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  footer?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  htmlPlaceholders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  jobPositionTypes?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  placeholders?: InputMaybe<Scalars['JSON']>;
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
  signable?: InputMaybe<Scalars['Boolean']>;
  storages?: InputMaybe<StorageDocumentTemplateIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `contractTemplate` being updated. */
export type UpdateContractTemplateOnContractTemplateDepartmentForContractTemplateDepartmentsContractTemplateIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInverseInput>;
  contractSignPendingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInverseInput>;
  contractTemplateFormFields?: InputMaybe<ContractTemplateFormFieldContractTemplateIdForeignInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<ContractTemplateDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  footer?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  htmlPlaceholders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  jobPositionTypes?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  placeholders?: InputMaybe<Scalars['JSON']>;
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
  signable?: InputMaybe<Scalars['Boolean']>;
  storages?: InputMaybe<StorageDocumentTemplateIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `contractTemplate` being updated. */
export type UpdateContractTemplateOnContractTemplateForContractTemplateDocumentTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInverseInput>;
  contractSignPendingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInverseInput>;
  contractTemplateFormFields?: InputMaybe<ContractTemplateFormFieldContractTemplateIdForeignInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<ContractTemplateDocumentTypeIdForeignInput>;
  footer?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  htmlPlaceholders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  jobPositionTypes?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  placeholders?: InputMaybe<Scalars['JSON']>;
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
  signable?: InputMaybe<Scalars['Boolean']>;
  storages?: InputMaybe<StorageDocumentTemplateIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `contractTemplate` being updated. */
export type UpdateContractTemplateOnContractTemplateFormFieldForContractTemplateFormFieldContractTemplateIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInverseInput>;
  contractSignPendingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInverseInput>;
  contractTemplateFormFields?: InputMaybe<ContractTemplateFormFieldContractTemplateIdForeignInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<ContractTemplateDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  footer?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  htmlPlaceholders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  jobPositionTypes?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  placeholders?: InputMaybe<Scalars['JSON']>;
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
  signable?: InputMaybe<Scalars['Boolean']>;
  storages?: InputMaybe<StorageDocumentTemplateIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `contractTemplate` being updated. */
export type UpdateContractTemplateOnContractTemplateUserForContractTemplateUsersContractTemplateIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInverseInput>;
  contractSignPendingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInverseInput>;
  contractTemplateFormFields?: InputMaybe<ContractTemplateFormFieldContractTemplateIdForeignInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<ContractTemplateDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  footer?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  htmlPlaceholders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  jobPositionTypes?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  placeholders?: InputMaybe<Scalars['JSON']>;
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
  signable?: InputMaybe<Scalars['Boolean']>;
  storages?: InputMaybe<StorageDocumentTemplateIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `contractTemplate` being updated. */
export type UpdateContractTemplateOnStorageForStorageDocumentTemplateIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentContractTemplateIdForeignInverseInput>;
  contractSignPendingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInverseInput>;
  contractTemplateFormFields?: InputMaybe<ContractTemplateFormFieldContractTemplateIdForeignInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<ContractTemplateDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  footer?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  htmlPlaceholders?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  jobPositionTypes?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  placeholders?: InputMaybe<Scalars['JSON']>;
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
  signable?: InputMaybe<Scalars['Boolean']>;
  storages?: InputMaybe<StorageDocumentTemplateIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `contractTemplateUser` being updated. */
export type UpdateContractTemplateUserOnContractTemplateUserForContractTemplateUsersCompanyIdFkeyPatch = {
  company?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInput>;
  contractTemplate?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  contractTemplateIsSignable?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractTemplateUsersUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `contractTemplateUser` being updated. */
export type UpdateContractTemplateUserOnContractTemplateUserForContractTemplateUsersContractTemplateIdForeignPatch = {
  company?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInput>;
  contractTemplateIsSignable?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractTemplateUsersUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `contractTemplateUser` being updated. */
export type UpdateContractTemplateUserOnContractTemplateUserForContractTemplateUsersUserIdForeignPatch = {
  company?: InputMaybe<ContractTemplateUsersCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplate?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInput>;
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  contractTemplateIsSignable?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ContractTemplateUsersUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `customWidgetContent` being updated. */
export type UpdateCustomWidgetContentOnCustomWidgetContentForCustomWidgetContentCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addButton?: InputMaybe<Scalars['Boolean']>;
  buttonLink?: InputMaybe<Scalars['String']>;
  buttonText?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CustomWidgetContentCompanyIdForeignInput>;
  content?: InputMaybe<Scalars['String']>;
  customWidget?: InputMaybe<CustomWidgetContentCustomWidgetIdForeignInput>;
  customWidgetId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  isInternalButtonLink?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `customWidgetContent` being updated. */
export type UpdateCustomWidgetContentOnCustomWidgetContentForCustomWidgetContentCustomWidgetIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addButton?: InputMaybe<Scalars['Boolean']>;
  buttonLink?: InputMaybe<Scalars['String']>;
  buttonText?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CustomWidgetContentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  content?: InputMaybe<Scalars['String']>;
  customWidget?: InputMaybe<CustomWidgetContentCustomWidgetIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isInternalButtonLink?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `customWidget` being updated. */
export type UpdateCustomWidgetOnCustomWidgetContentForCustomWidgetContentCustomWidgetIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  buttonBackgroundColor?: InputMaybe<Scalars['String']>;
  buttonBorder?: InputMaybe<Scalars['Boolean']>;
  buttonTextColor?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CustomWidgetCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCustomWidgetIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCustomWidgetIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  imageLayout?: InputMaybe<Scalars['String']>;
  useImage?: InputMaybe<Scalars['Boolean']>;
  widgetSize?: InputMaybe<Scalars['Int']>;
  widgetTextColor?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `customWidget` being updated. */
export type UpdateCustomWidgetOnCustomWidgetForCustomWidgetCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  buttonBackgroundColor?: InputMaybe<Scalars['String']>;
  buttonBorder?: InputMaybe<Scalars['Boolean']>;
  buttonTextColor?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CustomWidgetCompanyIdForeignInput>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCustomWidgetIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCustomWidgetIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  imageLayout?: InputMaybe<Scalars['String']>;
  useImage?: InputMaybe<Scalars['Boolean']>;
  widgetSize?: InputMaybe<Scalars['Int']>;
  widgetTextColor?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `customWidget` being updated. */
export type UpdateCustomWidgetOnDashboardCardForDashboardCardCustomWidgetIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  buttonBackgroundColor?: InputMaybe<Scalars['String']>;
  buttonBorder?: InputMaybe<Scalars['Boolean']>;
  buttonTextColor?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CustomWidgetCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCustomWidgetIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardCustomWidgetIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  imageLayout?: InputMaybe<Scalars['String']>;
  useImage?: InputMaybe<Scalars['Boolean']>;
  widgetSize?: InputMaybe<Scalars['Int']>;
  widgetTextColor?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `cvTemplateFieldMapping` being updated. */
export type UpdateCvTemplateFieldMappingOnCvTemplateFieldMappingForCvTemplateFieldMappingCompanyIdForeignPatch = {
  company?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInput>;
  cvTemplateField?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<CvTemplateFieldMappingSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `cvTemplateFieldMapping` being updated. */
export type UpdateCvTemplateFieldMappingOnCvTemplateFieldMappingForCvTemplateFieldMappingFormFieldIdForeignPatch = {
  company?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  cvTemplateField?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<CvTemplateFieldMappingSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `cvTemplateFieldMapping` being updated. */
export type UpdateCvTemplateFieldMappingOnCvTemplateFieldMappingForCvTemplateFieldMappingSystemFieldIdForeignPatch = {
  company?: InputMaybe<CvTemplateFieldMappingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  cvTemplateField?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<CvTemplateFieldMappingSystemFieldIdForeignInput>;
};

/** An object where the defined keys will be set on the `dashboardCard` being updated. */
export type UpdateDashboardCardOnDashboardCardForDashboardCardCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DashboardCardCompanyIdForeignInput>;
  customWidget?: InputMaybe<DashboardCardCustomWidgetIdForeignInput>;
  customWidgetId?: InputMaybe<Scalars['UUID']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInverseInput>;
  dashboardView?: InputMaybe<DashboardCardDashboardViewIdForeignInput>;
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  jobPositionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  order?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<DashboardCardType>;
};

/** An object where the defined keys will be set on the `dashboardCard` being updated. */
export type UpdateDashboardCardOnDashboardCardForDashboardCardCustomWidgetIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DashboardCardCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  customWidget?: InputMaybe<DashboardCardCustomWidgetIdForeignInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInverseInput>;
  dashboardView?: InputMaybe<DashboardCardDashboardViewIdForeignInput>;
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  jobPositionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  order?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<DashboardCardType>;
};

/** An object where the defined keys will be set on the `dashboardCard` being updated. */
export type UpdateDashboardCardOnDashboardCardForDashboardCardDashboardViewIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DashboardCardCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  customWidget?: InputMaybe<DashboardCardCustomWidgetIdForeignInput>;
  customWidgetId?: InputMaybe<Scalars['UUID']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInverseInput>;
  dashboardView?: InputMaybe<DashboardCardDashboardViewIdForeignInput>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  jobPositionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  order?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<DashboardCardType>;
};

/** An object where the defined keys will be set on the `dashboardCard` being updated. */
export type UpdateDashboardCardOnDashboardCardStatisticForDashboardCardStatisticDashboardCardIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DashboardCardCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  customWidget?: InputMaybe<DashboardCardCustomWidgetIdForeignInput>;
  customWidgetId?: InputMaybe<Scalars['UUID']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInverseInput>;
  dashboardView?: InputMaybe<DashboardCardDashboardViewIdForeignInput>;
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  jobPositionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  order?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<DashboardCardType>;
};

/** An object where the defined keys will be set on the `dashboardCardStatistic` being updated. */
export type UpdateDashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  chartType?: InputMaybe<DashboardCardStatisticChartType>;
  company?: InputMaybe<DashboardCardStatisticCompanyIdForeignInput>;
  dashboardCard?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInput>;
  dashboardCardId?: InputMaybe<Scalars['UUID']>;
  dashboardView?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInput>;
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  systemField?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `dashboardCardStatistic` being updated. */
export type UpdateDashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticDashboardCardIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  chartType?: InputMaybe<DashboardCardStatisticChartType>;
  company?: InputMaybe<DashboardCardStatisticCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dashboardCard?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInput>;
  dashboardView?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInput>;
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  systemField?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `dashboardCardStatistic` being updated. */
export type UpdateDashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticDashboardViewIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  chartType?: InputMaybe<DashboardCardStatisticChartType>;
  company?: InputMaybe<DashboardCardStatisticCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dashboardCard?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInput>;
  dashboardCardId?: InputMaybe<Scalars['UUID']>;
  dashboardView?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInput>;
  formField?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  systemField?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `dashboardCardStatistic` being updated. */
export type UpdateDashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  chartType?: InputMaybe<DashboardCardStatisticChartType>;
  company?: InputMaybe<DashboardCardStatisticCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dashboardCard?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInput>;
  dashboardCardId?: InputMaybe<Scalars['UUID']>;
  dashboardView?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInput>;
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  systemField?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `dashboardCardStatistic` being updated. */
export type UpdateDashboardCardStatisticOnDashboardCardStatisticForDashboardCardStatisticSystemFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  chartType?: InputMaybe<DashboardCardStatisticChartType>;
  company?: InputMaybe<DashboardCardStatisticCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dashboardCard?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInput>;
  dashboardCardId?: InputMaybe<Scalars['UUID']>;
  dashboardView?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInput>;
  dashboardViewId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  systemField?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInput>;
};

/** An object where the defined keys will be set on the `dashboardConfig` being updated. */
export type UpdateDashboardConfigOnDashboardConfigForDashboardConfigCompanyIdForeignPatch = {
  company?: InputMaybe<DashboardConfigCompanyIdForeignInput>;
  pageTitle?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `dashboardView` being updated. */
export type UpdateDashboardViewOnDashboardCardForDashboardCardDashboardViewIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DashboardViewCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardDashboardViewIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `dashboardView` being updated. */
export type UpdateDashboardViewOnDashboardCardStatisticForDashboardCardStatisticDashboardViewIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DashboardViewCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardDashboardViewIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `dashboardView` being updated. */
export type UpdateDashboardViewOnDashboardViewForDashboardViewCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DashboardViewCompanyIdForeignInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticDashboardViewIdForeignInverseInput>;
  dashboardCards?: InputMaybe<DashboardCardDashboardViewIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `department` being updated. */
export type UpdateDepartmentOnContractTemplateDepartmentForContractTemplateDepartmentsDepartmentIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `department` being updated. */
export type UpdateDepartmentOnDepartmentForDepartmentCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `department` being updated. */
export type UpdateDepartmentOnDepartmentForDepartmentDepartmentTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `department` being updated. */
export type UpdateDepartmentOnDepartmentForDepartmentParentDepartmentIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `department` being updated. */
export type UpdateDepartmentOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsDepartmentIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `department` being updated. */
export type UpdateDepartmentOnDocumentFolderDepartmentForDocumentFolderDepartmentDepartmentIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `department` being updated. */
export type UpdateDepartmentOnFormFieldEntryForFormFieldEntryDepartmentIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `department` being updated. */
export type UpdateDepartmentOnNotificationEmployeeReferenceForNotificationEmployeeReferenceDepartmentIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `department` being updated. */
export type UpdateDepartmentOnProductForProductDepartmentIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `department` being updated. */
export type UpdateDepartmentOnUserDepartmentForUserDepartmentDepartmentIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `department` being updated. */
export type UpdateDepartmentOnUserDepartmentGroupForUserDepartmentGroupDepartmentIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `department` being updated. */
export type UpdateDepartmentOnUserDepartmentRoleForUserDepartmentRoleDepartmentIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsDepartmentIdForeignInverseInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<DepartmentParentDepartmentIdForeignInput>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  departmentType?: InputMaybe<DepartmentDepartmentTypeIdForeignInput>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInverseInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInverseInput>;
  ean?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  formFieldEntriesToDepartmentIdUsingId?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
  formFieldEntriesToProductDepartmentIdUsingId?: InputMaybe<FormFieldEntryProductDepartmentIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  mainDepartment?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInverseInput>;
  pNumber?: InputMaybe<Scalars['Int']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductDepartmentIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentDepartmentIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `departmentType` being updated. */
export type UpdateDepartmentTypeOnDepartmentForDepartmentDepartmentTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<DepartmentDepartmentTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `departmentType` being updated. */
export type UpdateDepartmentTypeOnDepartmentTypeForDepartmentTypeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<DepartmentTypeCompanyIdForeignInput>;
  departments?: InputMaybe<DepartmentDepartmentTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `documentDepartmentPermission` being updated. */
export type UpdateDocumentDepartmentPermissionOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsCompanyIdFkeyPatch = {
  company?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInput>;
  department?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInput>;
};

/** An object where the defined keys will be set on the `documentDepartmentPermission` being updated. */
export type UpdateDocumentDepartmentPermissionOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsDepartmentIdForeignPatch = {
  company?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInput>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInput>;
};

/** An object where the defined keys will be set on the `documentDepartmentPermission` being updated. */
export type UpdateDocumentDepartmentPermissionOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsFileIdForeignPatch = {
  company?: InputMaybe<DocumentDepartmentPermissionsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<DocumentDepartmentPermissionsDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInput>;
};

/** An object where the defined keys will be set on the `documentFolderBlueprint` being updated. */
export type UpdateDocumentFolderBlueprintOnDocumentFolderBlueprintForDocumentFolderBlueprintCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderBlueprintParentDocumentFolderBlueprintIdFInput>;
  documentFoldersToDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderDocumentFolderBlueprintIdForeignInverseInput>;
  documentFoldersToRootDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  parentDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `documentFolderBlueprint` being updated. */
export type UpdateDocumentFolderBlueprintOnDocumentFolderBlueprintForDocumentFolderBlueprintParentDocumentFolderBlueprintIdFPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderBlueprintParentDocumentFolderBlueprintIdFInput>;
  documentFoldersToDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderDocumentFolderBlueprintIdForeignInverseInput>;
  documentFoldersToRootDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  storages?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `documentFolderBlueprint` being updated. */
export type UpdateDocumentFolderBlueprintOnDocumentFolderForDocumentFolderRootDocumentFolderBlueprintIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderBlueprintParentDocumentFolderBlueprintIdFInput>;
  documentFoldersToDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderDocumentFolderBlueprintIdForeignInverseInput>;
  documentFoldersToRootDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  parentDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `documentFolderBlueprint` being updated. */
export type UpdateDocumentFolderBlueprintOnExternalIntegrationForExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderBlueprintParentDocumentFolderBlueprintIdFInput>;
  documentFoldersToDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderDocumentFolderBlueprintIdForeignInverseInput>;
  documentFoldersToRootDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  parentDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `documentFolderBlueprint` being updated. */
export type UpdateDocumentFolderBlueprintOnStorageForStorageRootDocumentFolderBlueprintIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderBlueprintCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderBlueprintParentDocumentFolderBlueprintIdFInput>;
  documentFoldersToDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderDocumentFolderBlueprintIdForeignInverseInput>;
  documentFoldersToRootDocumentFolderBlueprintIdUsingId?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  parentDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `documentFolderDepartment` being updated. */
export type UpdateDocumentFolderDepartmentOnDocumentFolderDepartmentForDocumentFolderDepartmentCompanyIdForeignPatch = {
  company?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInput>;
  department?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentFolder?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `documentFolderDepartment` being updated. */
export type UpdateDocumentFolderDepartmentOnDocumentFolderDepartmentForDocumentFolderDepartmentDepartmentIdForeignPatch = {
  company?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInput>;
  documentFolder?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `documentFolderDepartment` being updated. */
export type UpdateDocumentFolderDepartmentOnDocumentFolderDepartmentForDocumentFolderDepartmentDocumentFolderIdForeignPatch = {
  company?: InputMaybe<DocumentFolderDepartmentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<DocumentFolderDepartmentDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentFolder?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInput>;
};

/** An object where the defined keys will be set on the `documentFolder` being updated. */
export type UpdateDocumentFolderOnDocumentFolderDepartmentForDocumentFolderDepartmentDocumentFolderIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolder?: InputMaybe<DocumentFolderParentDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastEdited?: InputMaybe<Scalars['Datetime']>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['UUID']>;
  ownerType?: InputMaybe<DocumentFolderOwnerType>;
  parentDocumentFolderId?: InputMaybe<Scalars['UUID']>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageDocumentFolderIdForeignInverseInput>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `documentFolder` being updated. */
export type UpdateDocumentFolderOnDocumentFolderForDocumentFolderCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderCompanyIdForeignInput>;
  departmentIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolder?: InputMaybe<DocumentFolderParentDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastEdited?: InputMaybe<Scalars['Datetime']>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['UUID']>;
  ownerType?: InputMaybe<DocumentFolderOwnerType>;
  parentDocumentFolderId?: InputMaybe<Scalars['UUID']>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageDocumentFolderIdForeignInverseInput>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `documentFolder` being updated. */
export type UpdateDocumentFolderOnDocumentFolderForDocumentFolderDocumentFolderBlueprintIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolder?: InputMaybe<DocumentFolderParentDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastEdited?: InputMaybe<Scalars['Datetime']>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['UUID']>;
  ownerType?: InputMaybe<DocumentFolderOwnerType>;
  parentDocumentFolderId?: InputMaybe<Scalars['UUID']>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageDocumentFolderIdForeignInverseInput>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `documentFolder` being updated. */
export type UpdateDocumentFolderOnDocumentFolderForDocumentFolderParentDocumentFolderIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolder?: InputMaybe<DocumentFolderParentDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastEdited?: InputMaybe<Scalars['Datetime']>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['UUID']>;
  ownerType?: InputMaybe<DocumentFolderOwnerType>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageDocumentFolderIdForeignInverseInput>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `documentFolder` being updated. */
export type UpdateDocumentFolderOnDocumentFolderForDocumentFolderRootDocumentFolderBlueprintIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolder?: InputMaybe<DocumentFolderParentDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastEdited?: InputMaybe<Scalars['Datetime']>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['UUID']>;
  ownerType?: InputMaybe<DocumentFolderOwnerType>;
  parentDocumentFolderId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageDocumentFolderIdForeignInverseInput>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `documentFolder` being updated. */
export type UpdateDocumentFolderOnDocumentFolderUserForDocumentFolderUserDocumentFolderIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolder?: InputMaybe<DocumentFolderParentDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastEdited?: InputMaybe<Scalars['Datetime']>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['UUID']>;
  ownerType?: InputMaybe<DocumentFolderOwnerType>;
  parentDocumentFolderId?: InputMaybe<Scalars['UUID']>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageDocumentFolderIdForeignInverseInput>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `documentFolder` being updated. */
export type UpdateDocumentFolderOnStorageForStorageDocumentFolderIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<DocumentFolderCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolder?: InputMaybe<DocumentFolderParentDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<DocumentFolderRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  documentFolderDepartments?: InputMaybe<DocumentFolderDepartmentDocumentFolderIdForeignInverseInput>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastEdited?: InputMaybe<Scalars['Datetime']>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['UUID']>;
  ownerType?: InputMaybe<DocumentFolderOwnerType>;
  parentDocumentFolderId?: InputMaybe<Scalars['UUID']>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  storages?: InputMaybe<StorageDocumentFolderIdForeignInverseInput>;
  userIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `documentFolderUser` being updated. */
export type UpdateDocumentFolderUserOnDocumentFolderUserForDocumentFolderUserCompanyIdForeignPatch = {
  company?: InputMaybe<DocumentFolderUserCompanyIdForeignInput>;
  documentFolder?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<DocumentFolderUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `documentFolderUser` being updated. */
export type UpdateDocumentFolderUserOnDocumentFolderUserForDocumentFolderUserDocumentFolderIdForeignPatch = {
  company?: InputMaybe<DocumentFolderUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  documentFolder?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInput>;
  user?: InputMaybe<DocumentFolderUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `documentFolderUser` being updated. */
export type UpdateDocumentFolderUserOnDocumentFolderUserForDocumentFolderUserUserIdForeignPatch = {
  company?: InputMaybe<DocumentFolderUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  documentFolder?: InputMaybe<DocumentFolderUserDocumentFolderIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<DocumentFolderUserUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `documentType` being updated. */
export type UpdateDocumentTypeOnContractSignPendingDocumentForContractSignPendingDocumentDocumentTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput>;
  contractTemplates?: InputMaybe<ContractTemplateDocumentTypeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lifetime?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  storages?: InputMaybe<StorageDocumentTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `documentType` being updated. */
export type UpdateDocumentTypeOnContractSignPendingForContractSignPendingMergedDocumentDocumentTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput>;
  contractTemplates?: InputMaybe<ContractTemplateDocumentTypeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lifetime?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  storages?: InputMaybe<StorageDocumentTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `documentType` being updated. */
export type UpdateDocumentTypeOnContractTemplateForContractTemplateDocumentTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput>;
  contractTemplates?: InputMaybe<ContractTemplateDocumentTypeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lifetime?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  storages?: InputMaybe<StorageDocumentTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `documentType` being updated. */
export type UpdateDocumentTypeOnDocumentUserPermissionForDocumentUserPermissionsDocumentTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput>;
  contractTemplates?: InputMaybe<ContractTemplateDocumentTypeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lifetime?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  storages?: InputMaybe<StorageDocumentTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `documentType` being updated. */
export type UpdateDocumentTypeOnDocumentUserResponsibleForDocumentUserResponsibleDocumentTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput>;
  contractTemplates?: InputMaybe<ContractTemplateDocumentTypeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lifetime?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  storages?: InputMaybe<StorageDocumentTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `documentType` being updated. */
export type UpdateDocumentTypeOnEmployeeCasefileForEmployeeCasefileDocumentTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput>;
  contractTemplates?: InputMaybe<ContractTemplateDocumentTypeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lifetime?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  storages?: InputMaybe<StorageDocumentTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `documentType` being updated. */
export type UpdateDocumentTypeOnExternalIntegrationForExternalIntegrationPayslipDocumentTypeIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput>;
  contractTemplates?: InputMaybe<ContractTemplateDocumentTypeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lifetime?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  storages?: InputMaybe<StorageDocumentTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `documentType` being updated. */
export type UpdateDocumentTypeOnStorageForStorageDocumentTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentDocumentTypeIdForeignInverseInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingMergedDocumentDocumentTypeIdForeignInverseInput>;
  contractTemplates?: InputMaybe<ContractTemplateDocumentTypeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInverseInput>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInverseInput>;
  externalIntegrations?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lifetime?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  storages?: InputMaybe<StorageDocumentTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `documentUserPermission` being updated. */
export type UpdateDocumentUserPermissionOnDocumentUserPermissionForDocumentUserPermissionsCompanyIdFkeyPatch = {
  company?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserPermissionsFileIdForeignInput>;
  user?: InputMaybe<DocumentUserPermissionsUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `documentUserPermission` being updated. */
export type UpdateDocumentUserPermissionOnDocumentUserPermissionForDocumentUserPermissionsDocumentTypeIdForeignPatch = {
  company?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInput>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserPermissionsFileIdForeignInput>;
  user?: InputMaybe<DocumentUserPermissionsUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `documentUserPermission` being updated. */
export type UpdateDocumentUserPermissionOnDocumentUserPermissionForDocumentUserPermissionsFileIdForeignPatch = {
  company?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserPermissionsFileIdForeignInput>;
  user?: InputMaybe<DocumentUserPermissionsUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `documentUserPermission` being updated. */
export type UpdateDocumentUserPermissionOnDocumentUserPermissionForDocumentUserPermissionsUserIdForeignPatch = {
  company?: InputMaybe<DocumentUserPermissionsCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<DocumentUserPermissionsDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserPermissionsFileIdForeignInput>;
  user?: InputMaybe<DocumentUserPermissionsUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `documentUserResponsible` being updated. */
export type UpdateDocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleAssignedByForeignPatch = {
  company?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserResponsibleFileIdForeignInput>;
  user?: InputMaybe<DocumentUserResponsibleAssignedByForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `documentUserResponsible` being updated. */
export type UpdateDocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleCompanyIdFkeyPatch = {
  assignedBy?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserResponsibleFileIdForeignInput>;
  user?: InputMaybe<DocumentUserResponsibleAssignedByForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `documentUserResponsible` being updated. */
export type UpdateDocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleDocumentTypeIdForeignPatch = {
  assignedBy?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInput>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserResponsibleFileIdForeignInput>;
  user?: InputMaybe<DocumentUserResponsibleAssignedByForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `documentUserResponsible` being updated. */
export type UpdateDocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleFileIdForeignPatch = {
  assignedBy?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserResponsibleFileIdForeignInput>;
  user?: InputMaybe<DocumentUserResponsibleAssignedByForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `documentUserResponsible` being updated. */
export type UpdateDocumentUserResponsibleOnDocumentUserResponsibleForDocumentUserResponsibleUserIdForeignPatch = {
  assignedBy?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<DocumentUserResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentOwnerId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<DocumentUserResponsibleDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<DocumentUserResponsibleFileIdForeignInput>;
  user?: InputMaybe<DocumentUserResponsibleAssignedByForeignInput>;
};

/** An object where the defined keys will be set on the `employeeCasefile` being updated. */
export type UpdateEmployeeCasefileOnEmployeeCasefileForEmployeeCasefileCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<EmployeeCasefileCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documents?: InputMaybe<Scalars['JSON']>;
  employee?: InputMaybe<EmployeeCasefileEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  expireAt?: InputMaybe<Scalars['Int']>;
  failedSync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  locale?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notified?: InputMaybe<Scalars['Boolean']>;
  recipients?: InputMaybe<Scalars['JSON']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signers?: InputMaybe<Scalars['JSON']>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  status?: InputMaybe<Scalars['String']>;
  storages?: InputMaybe<StorageEmployeeCasefileIdForeignInverseInput>;
  tempCasefileId?: InputMaybe<Scalars['UUID']>;
  title?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `employeeCasefile` being updated. */
export type UpdateEmployeeCasefileOnEmployeeCasefileForEmployeeCasefileCreatorUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<EmployeeCasefileCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documents?: InputMaybe<Scalars['JSON']>;
  employee?: InputMaybe<EmployeeCasefileEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  expireAt?: InputMaybe<Scalars['Int']>;
  failedSync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  locale?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notified?: InputMaybe<Scalars['Boolean']>;
  recipients?: InputMaybe<Scalars['JSON']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signers?: InputMaybe<Scalars['JSON']>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  status?: InputMaybe<Scalars['String']>;
  storages?: InputMaybe<StorageEmployeeCasefileIdForeignInverseInput>;
  tempCasefileId?: InputMaybe<Scalars['UUID']>;
  title?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `employeeCasefile` being updated. */
export type UpdateEmployeeCasefileOnEmployeeCasefileForEmployeeCasefileDocumentTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<EmployeeCasefileCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInput>;
  documents?: InputMaybe<Scalars['JSON']>;
  employee?: InputMaybe<EmployeeCasefileEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  expireAt?: InputMaybe<Scalars['Int']>;
  failedSync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  locale?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notified?: InputMaybe<Scalars['Boolean']>;
  recipients?: InputMaybe<Scalars['JSON']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signers?: InputMaybe<Scalars['JSON']>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  status?: InputMaybe<Scalars['String']>;
  storages?: InputMaybe<StorageEmployeeCasefileIdForeignInverseInput>;
  tempCasefileId?: InputMaybe<Scalars['UUID']>;
  title?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `employeeCasefile` being updated. */
export type UpdateEmployeeCasefileOnEmployeeCasefileForEmployeeCasefileEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<EmployeeCasefileCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documents?: InputMaybe<Scalars['JSON']>;
  employee?: InputMaybe<EmployeeCasefileEmployeeIdForeignInput>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  expireAt?: InputMaybe<Scalars['Int']>;
  failedSync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  locale?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notified?: InputMaybe<Scalars['Boolean']>;
  recipients?: InputMaybe<Scalars['JSON']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signers?: InputMaybe<Scalars['JSON']>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  status?: InputMaybe<Scalars['String']>;
  storages?: InputMaybe<StorageEmployeeCasefileIdForeignInverseInput>;
  tempCasefileId?: InputMaybe<Scalars['UUID']>;
  title?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `employeeCasefile` being updated. */
export type UpdateEmployeeCasefileOnEmployeeCasefileForEmployeeCasefileNextSigningUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<EmployeeCasefileCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documents?: InputMaybe<Scalars['JSON']>;
  employee?: InputMaybe<EmployeeCasefileEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  expireAt?: InputMaybe<Scalars['Int']>;
  failedSync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  locale?: InputMaybe<Scalars['String']>;
  notified?: InputMaybe<Scalars['Boolean']>;
  recipients?: InputMaybe<Scalars['JSON']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signers?: InputMaybe<Scalars['JSON']>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  status?: InputMaybe<Scalars['String']>;
  storages?: InputMaybe<StorageEmployeeCasefileIdForeignInverseInput>;
  tempCasefileId?: InputMaybe<Scalars['UUID']>;
  title?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `employeeCasefile` being updated. */
export type UpdateEmployeeCasefileOnEmployeeCasefileForEmployeeCasefileUserIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<EmployeeCasefileCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documents?: InputMaybe<Scalars['JSON']>;
  employee?: InputMaybe<EmployeeCasefileEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  expireAt?: InputMaybe<Scalars['Int']>;
  failedSync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  locale?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notified?: InputMaybe<Scalars['Boolean']>;
  recipients?: InputMaybe<Scalars['JSON']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signers?: InputMaybe<Scalars['JSON']>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  status?: InputMaybe<Scalars['String']>;
  storages?: InputMaybe<StorageEmployeeCasefileIdForeignInverseInput>;
  tempCasefileId?: InputMaybe<Scalars['UUID']>;
  title?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `employeeCasefile` being updated. */
export type UpdateEmployeeCasefileOnStorageForStorageEmployeeCasefileIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<EmployeeCasefileCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentType?: InputMaybe<EmployeeCasefileDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documents?: InputMaybe<Scalars['JSON']>;
  employee?: InputMaybe<EmployeeCasefileEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  expireAt?: InputMaybe<Scalars['Int']>;
  failedSync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  locale?: InputMaybe<Scalars['String']>;
  nextSigningUserId?: InputMaybe<Scalars['UUID']>;
  notified?: InputMaybe<Scalars['Boolean']>;
  recipients?: InputMaybe<Scalars['JSON']>;
  signedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  signers?: InputMaybe<Scalars['JSON']>;
  signingUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  status?: InputMaybe<Scalars['String']>;
  storages?: InputMaybe<StorageEmployeeCasefileIdForeignInverseInput>;
  tempCasefileId?: InputMaybe<Scalars['UUID']>;
  title?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `employeeExternalIntegration` being updated. */
export type UpdateEmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationCompanyIdFkeyPatch = {
  company?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  externalEmployeeId?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInput>;
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  sameSystem?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `employeeExternalIntegration` being updated. */
export type UpdateEmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationEmployeeIdForeignPatch = {
  company?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInput>;
  externalEmployeeId?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInput>;
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  sameSystem?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `employeeExternalIntegration` being updated. */
export type UpdateEmployeeExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationExternalIntegrationIdForeignPatch = {
  company?: InputMaybe<EmployeeExternalIntegrationCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  externalEmployeeId?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInput>;
  sameSystem?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnContractSignPendingForContractSignPendingEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnEmployeeCasefileForEmployeeCasefileEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnEmployeeExternalIntegrationForEmployeeExternalIntegrationEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnEmployeeForEmployeeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnEmployeeForEmployeeUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnEquipmentForEquipmentEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnFormFieldEntryForFormFieldEntryEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnLatestMessageForLatestMessageEmployeeId2ForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnMessageForMessageToEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnMessageRecipientForMessageRecipientEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnNotificationCustomRecipientForNotificationCustomRecipientEmployeeIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnNotificationEmployeeForNotificationEmployeeEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnNotificationEmployeeReferenceForNotificationEmployeeReferenceEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnPreboardingCommentForPreboardingCommentEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnPreboardingEmailLogForPreboardingEmailLogFromEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnPreboardingEmployeeForPreboardingEmployeeEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnPreboardingForPreboardingEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnPreboardingProcessForPreboardingProcessEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnPreboardingResultForPreboardingResultEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnProcessEmployeeForProcessEmployeeEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnProcessForProcessEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnProcessResponsibleForProcessResponsibleResponsibleIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnProjectForProjectEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnSavedSignatureForSavedSignatureEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnScheduledMessageForScheduledMessageEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnScheduledMessageRecipientForScheduledMessageRecipientEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnTaskEmployeeForTaskEmployeeEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnTaskResponsibleForTaskResponsibleResponsibleIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `employee` being updated. */
export type UpdateEmployeeOnTaskTemplateResponsibleForTaskTemplateResponsibleResponsibleIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EmployeeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employeeCasefiles?: InputMaybe<EmployeeCasefileEmployeeIdForeignInverseInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationEmployeeIdForeignInverseInput>;
  equipment?: InputMaybe<EquipmentEmployeeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryEmployeeIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  latestMessagesToEmployeeId1UsingId?: InputMaybe<LatestMessageEmployeeId1ForeignInverseInput>;
  latestMessagesToEmployeeId2UsingId?: InputMaybe<LatestMessageEmployeeId2ForeignInverseInput>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  messageRecipients?: InputMaybe<MessageRecipientEmployeeIdForeignInverseInput>;
  messagesToFromEmployeeIdUsingId?: InputMaybe<MessageFromEmployeeIdForeignInverseInput>;
  messagesToToEmployeeIdUsingId?: InputMaybe<MessageToEmployeeIdForeignInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInverseInput>;
  notificationEmployeesToEmployeeIdUsingId?: InputMaybe<NotificationEmployeeEmployeeIdForeignInverseInput>;
  notificationEmployeesToRecipientIdUsingId?: InputMaybe<NotificationEmployeeRecipientIdForeignInverseInput>;
  notificationEmployeesToSenderIdUsingId?: InputMaybe<NotificationEmployeeSenderIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentEmployeeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEmployeeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEmployeeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEmployeeIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeEmployeeIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleIdForeignInverseInput>;
  processes?: InputMaybe<ProcessEmployeeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectEmployeeIdForeignInverseInput>;
  savedSignatures?: InputMaybe<SavedSignatureEmployeeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInverseInput>;
  scheduledMessagesToEmployeeIdUsingId?: InputMaybe<ScheduledMessageEmployeeIdForeignInverseInput>;
  scheduledMessagesToSenderEmployeeIdUsingId?: InputMaybe<ScheduledMessageSenderEmployeeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeEmployeeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleResponsibleIdForeignInverseInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EmployeeUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  users?: InputMaybe<UserEmployeeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `engagementType` being updated. */
export type UpdateEngagementTypeOnEngagementTypeForEngagementTypeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `engagementType` being updated. */
export type UpdateEngagementTypeOnFormFieldForFormFieldEngagementTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `engagementType` being updated. */
export type UpdateEngagementTypeOnFormFieldOptionForFormFieldOptionEngagementTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `engagementType` being updated. */
export type UpdateEngagementTypeOnPreboardingCommentForPreboardingCommentEngagementTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `engagementType` being updated. */
export type UpdateEngagementTypeOnPreboardingEmailLogForPreboardingEmailLogEngagementTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `engagementType` being updated. */
export type UpdateEngagementTypeOnPreboardingEmployeeForPreboardingEmployeeEngagementTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `engagementType` being updated. */
export type UpdateEngagementTypeOnPreboardingForPreboardingEngagementTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `engagementType` being updated. */
export type UpdateEngagementTypeOnPreboardingProcessForPreboardingProcessEngagementTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `engagementType` being updated. */
export type UpdateEngagementTypeOnPreboardingResultForPreboardingResultEngagementTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `engagementType` being updated. */
export type UpdateEngagementTypeOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEngagementTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `engagementType` being updated. */
export type UpdateEngagementTypeOnPreboardingSlideForPreboardingSlideEngagementTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `engagementType` being updated. */
export type UpdateEngagementTypeOnPreboardingSlideFormFieldForPreboardingSlideFormFieldEngagementTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EngagementTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  formFieldOptions?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEngagementTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInverseInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultEngagementTypeIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingEngagementTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `equipment` being updated. */
export type UpdateEquipmentOnEquipmentForEquipmentCompanyIdFkeyPatch = {
  company?: InputMaybe<EquipmentCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EquipmentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<EquipmentProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<EquipmentProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EquipmentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `equipment` being updated. */
export type UpdateEquipmentOnEquipmentForEquipmentEmployeeIdForeignPatch = {
  company?: InputMaybe<EquipmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EquipmentEmployeeIdForeignInput>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<EquipmentProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<EquipmentProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EquipmentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `equipment` being updated. */
export type UpdateEquipmentOnEquipmentForEquipmentProductIdForeignPatch = {
  company?: InputMaybe<EquipmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EquipmentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<EquipmentProductIdForeignInput>;
  productType?: InputMaybe<EquipmentProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EquipmentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `equipment` being updated. */
export type UpdateEquipmentOnEquipmentForEquipmentProductTypeIdForeignPatch = {
  company?: InputMaybe<EquipmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EquipmentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<EquipmentProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<EquipmentProductTypeIdForeignInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EquipmentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `equipment` being updated. */
export type UpdateEquipmentOnEquipmentForEquipmentUserIdFkeyPatch = {
  company?: InputMaybe<EquipmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<EquipmentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<EquipmentProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<EquipmentProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<EquipmentUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventForEventCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EventCompanyIdForeignInput>;
  contactPersonIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  eventUsers?: InputMaybe<EventUserEventIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEventIdForeignInverseInput>;
  geography?: InputMaybe<PointInput>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  startDate?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnEventUserForEventUserEventIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EventCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contactPersonIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  eventUsers?: InputMaybe<EventUserEventIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEventIdForeignInverseInput>;
  geography?: InputMaybe<PointInput>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  startDate?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `event` being updated. */
export type UpdateEventOnFormFieldForFormFieldEventIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EventCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contactPersonIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  eventUsers?: InputMaybe<EventUserEventIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldEventIdForeignInverseInput>;
  geography?: InputMaybe<PointInput>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  startDate?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `eventUser` being updated. */
export type UpdateEventUserOnEventUserForEventUserCompanyIdForeignPatch = {
  attending?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EventUserCompanyIdForeignInput>;
  event?: InputMaybe<EventUserEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<EventUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventUser` being updated. */
export type UpdateEventUserOnEventUserForEventUserEventIdForeignPatch = {
  attending?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EventUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<EventUserEventIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<EventUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `eventUser` being updated. */
export type UpdateEventUserOnEventUserForEventUserUserIdForeignPatch = {
  attending?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<EventUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<EventUserEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<EventUserUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `externalIntegration` being updated. */
export type UpdateExternalIntegrationOnEmployeeExternalIntegrationForEmployeeExternalIntegrationExternalIntegrationIdForeignPatch = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<ExternalIntegrationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  documentFolderBlueprint?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput>;
  documentType?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput>;
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  externalCompanyId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInput>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrableSystem?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInput>;
  integrableSystemId?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput>;
  payslipDocumentBlueprintFolderId?: InputMaybe<Scalars['UUID']>;
  payslipDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `externalIntegration` being updated. */
export type UpdateExternalIntegrationOnExternalIntegrationForExternalIntegrationAuthAppIdFkeyPatch = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInput>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<ExternalIntegrationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  documentFolderBlueprint?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput>;
  documentType?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput>;
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  externalCompanyId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInput>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrableSystem?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInput>;
  integrableSystemId?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput>;
  payslipDocumentBlueprintFolderId?: InputMaybe<Scalars['UUID']>;
  payslipDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `externalIntegration` being updated. */
export type UpdateExternalIntegrationOnExternalIntegrationForExternalIntegrationCompanyIdForeignPatch = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<ExternalIntegrationCompanyIdForeignInput>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  documentFolderBlueprint?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput>;
  documentType?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput>;
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  externalCompanyId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInput>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrableSystem?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInput>;
  integrableSystemId?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput>;
  payslipDocumentBlueprintFolderId?: InputMaybe<Scalars['UUID']>;
  payslipDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `externalIntegration` being updated. */
export type UpdateExternalIntegrationOnExternalIntegrationForExternalIntegrationExternalSystemIdFkeyPatch = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<ExternalIntegrationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  documentFolderBlueprint?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput>;
  documentType?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput>;
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  externalCompanyId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInput>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrableSystem?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInput>;
  integrableSystemId?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput>;
  payslipDocumentBlueprintFolderId?: InputMaybe<Scalars['UUID']>;
  payslipDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `externalIntegration` being updated. */
export type UpdateExternalIntegrationOnExternalIntegrationForExternalIntegrationIntegrableSystemIdFkeyPatch = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<ExternalIntegrationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  documentFolderBlueprint?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput>;
  documentType?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput>;
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  externalCompanyId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInput>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrableSystem?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInput>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput>;
  payslipDocumentBlueprintFolderId?: InputMaybe<Scalars['UUID']>;
  payslipDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `externalIntegration` being updated. */
export type UpdateExternalIntegrationOnExternalIntegrationForExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyPatch = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<ExternalIntegrationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  documentFolderBlueprint?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput>;
  documentType?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput>;
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  externalCompanyId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInput>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrableSystem?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInput>;
  integrableSystemId?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput>;
  payslipDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `externalIntegration` being updated. */
export type UpdateExternalIntegrationOnExternalIntegrationForExternalIntegrationPayslipDocumentTypeIdFkeyPatch = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<ExternalIntegrationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  documentFolderBlueprint?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput>;
  documentType?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput>;
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  externalCompanyId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInput>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrableSystem?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInput>;
  integrableSystemId?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput>;
  payslipDocumentBlueprintFolderId?: InputMaybe<Scalars['UUID']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `externalIntegration` being updated. */
export type UpdateExternalIntegrationOnIntegrationFieldMarkingForIntegrationFieldMarkingExternalIntegrationIdFkeyPatch = {
  absenceMappings?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<ExternalIntegrationAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<ExternalIntegrationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  documentFolderBlueprint?: InputMaybe<ExternalIntegrationPayslipDocumentBlueprintFolderIdFkeyInput>;
  documentType?: InputMaybe<ExternalIntegrationPayslipDocumentTypeIdFkeyInput>;
  employeeExternalIntegrations?: InputMaybe<EmployeeExternalIntegrationExternalIntegrationIdForeignInverseInput>;
  externalAdditionalId?: InputMaybe<Scalars['String']>;
  externalCompanyId?: InputMaybe<Scalars['String']>;
  externalSystem?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInput>;
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrableSystem?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInput>;
  integrableSystemId?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInverseInput>;
  payslipDocumentBlueprintFolderId?: InputMaybe<Scalars['UUID']>;
  payslipDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `externalSystem` being updated. */
export type UpdateExternalSystemOnExternalIntegrationForExternalIntegrationExternalSystemIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  externalIntegrations?: InputMaybe<ExternalIntegrationExternalSystemIdFkeyInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `fieldGroupCardColumn` being updated. */
export type UpdateFieldGroupCardColumnOnCompanySystemFieldForCompanySystemFieldFieldGroupCardColumnIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  fieldGroupCard?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignInput>;
  fieldGroupCardId?: InputMaybe<Scalars['UUID']>;
  formFields?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `fieldGroupCardColumn` being updated. */
export type UpdateFieldGroupCardColumnOnFieldGroupCardColumnForFieldGroupCardColumnCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  fieldGroupCard?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignInput>;
  fieldGroupCardId?: InputMaybe<Scalars['UUID']>;
  formFields?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `fieldGroupCardColumn` being updated. */
export type UpdateFieldGroupCardColumnOnFieldGroupCardColumnForFieldGroupCardColumnFieldGroupCardIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  fieldGroupCard?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignInput>;
  formFields?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `fieldGroupCardColumn` being updated. */
export type UpdateFieldGroupCardColumnOnFormFieldForFormFieldFieldGroupCardColumnIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FieldGroupCardColumnCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFieldGroupCardColumnIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  fieldGroupCard?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignInput>;
  fieldGroupCardId?: InputMaybe<Scalars['UUID']>;
  formFields?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `fieldGroupCard` being updated. */
export type UpdateFieldGroupCardOnFieldGroupCardColumnForFieldGroupCardColumnFieldGroupCardIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  columns?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<FieldGroupCardCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  fieldGroup?: InputMaybe<FieldGroupCardFieldGroupIdForeignInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignInverseInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `fieldGroupCard` being updated. */
export type UpdateFieldGroupCardOnFieldGroupCardForFieldGroupCardCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  columns?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<FieldGroupCardCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  fieldGroup?: InputMaybe<FieldGroupCardFieldGroupIdForeignInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignInverseInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `fieldGroupCard` being updated. */
export type UpdateFieldGroupCardOnFieldGroupCardForFieldGroupCardFieldGroupIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  columns?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<FieldGroupCardCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  fieldGroup?: InputMaybe<FieldGroupCardFieldGroupIdForeignInput>;
  fieldGroupCardColumns?: InputMaybe<FieldGroupCardColumnFieldGroupCardIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `fieldGroup` being updated. */
export type UpdateFieldGroupOnCompanySystemFieldForCompanySystemFieldFormFieldTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  fieldGroupCards?: InputMaybe<FieldGroupCardFieldGroupIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFieldGroupIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldFormFieldTypeIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFieldGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  userSystemFields?: InputMaybe<UserSystemFieldFieldGroupIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `fieldGroup` being updated. */
export type UpdateFieldGroupOnFieldGroupCardForFieldGroupCardFieldGroupIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  fieldGroupCards?: InputMaybe<FieldGroupCardFieldGroupIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFieldGroupIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldFormFieldTypeIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFieldGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  userSystemFields?: InputMaybe<UserSystemFieldFieldGroupIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `fieldGroup` being updated. */
export type UpdateFieldGroupOnFieldGroupForFormFieldTypeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldTypeCompanyIdForeignInput>;
  companySystemFields?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  fieldGroupCards?: InputMaybe<FieldGroupCardFieldGroupIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFieldGroupIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldFormFieldTypeIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFieldGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  userSystemFields?: InputMaybe<UserSystemFieldFieldGroupIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `fieldGroup` being updated. */
export type UpdateFieldGroupOnFormFieldEntryForFormFieldEntryFieldGroupIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  fieldGroupCards?: InputMaybe<FieldGroupCardFieldGroupIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFieldGroupIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldFormFieldTypeIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFieldGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  userSystemFields?: InputMaybe<UserSystemFieldFieldGroupIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `fieldGroup` being updated. */
export type UpdateFieldGroupOnFormFieldForFormFieldFormFieldTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  fieldGroupCards?: InputMaybe<FieldGroupCardFieldGroupIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFieldGroupIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldFormFieldTypeIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFieldGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  userSystemFields?: InputMaybe<UserSystemFieldFieldGroupIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `fieldGroup` being updated. */
export type UpdateFieldGroupOnFutureDatumForFutureDataFieldGroupIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  fieldGroupCards?: InputMaybe<FieldGroupCardFieldGroupIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFieldGroupIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldFormFieldTypeIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFieldGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  userSystemFields?: InputMaybe<UserSystemFieldFieldGroupIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `fieldGroup` being updated. */
export type UpdateFieldGroupOnUserSystemFieldForUserSystemFieldFieldGroupIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFields?: InputMaybe<CompanySystemFieldFormFieldTypeIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  fieldGroupCards?: InputMaybe<FieldGroupCardFieldGroupIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFieldGroupIdForeignInverseInput>;
  formFields?: InputMaybe<FormFieldFormFieldTypeIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFieldGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  userSystemFields?: InputMaybe<UserSystemFieldFieldGroupIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `filterPreset` being updated. */
export type UpdateFilterPresetOnFilterPresetForFilterPresetCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  columns?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<FilterPresetCompanyIdForeignInput>;
  filters?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  miscellaneousFilters?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  tableName?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<FilterPresetUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `filterPreset` being updated. */
export type UpdateFilterPresetOnFilterPresetForFilterPresetUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  columns?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<FilterPresetCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  filters?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
  miscellaneousFilters?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  tableName?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<FilterPresetUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `filterView` being updated. */
export type UpdateFilterViewOnFilterViewForFilterViewUserIdFkeyPatch = {
  filterViewData?: InputMaybe<Scalars['JSON']>;
  filterViewName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  tableName?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<FilterViewUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `formFieldAgreement` being updated. */
export type UpdateFormFieldAgreementOnFormFieldAgreementForFormFieldAgreementAgreementTextTranslatedEntityIdForeigPatch = {
  company?: InputMaybe<FormFieldAgreementCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldAgreementFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInput>;
};

/** An object where the defined keys will be set on the `formFieldAgreement` being updated. */
export type UpdateFormFieldAgreementOnFormFieldAgreementForFormFieldAgreementCompanyIdForeignPatch = {
  agreementTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<FormFieldAgreementCompanyIdForeignInput>;
  formField?: InputMaybe<FormFieldAgreementFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInput>;
};

/** An object where the defined keys will be set on the `formFieldAgreement` being updated. */
export type UpdateFormFieldAgreementOnFormFieldAgreementForFormFieldAgreementFormFieldIdForeignPatch = {
  agreementTextTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<FormFieldAgreementCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldAgreementFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInput>;
};

/** An object where the defined keys will be set on the `formFieldEntry` being updated. */
export type UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `formFieldEntry` being updated. */
export type UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryDepartmentIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `formFieldEntry` being updated. */
export type UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `formFieldEntry` being updated. */
export type UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryFieldGroupIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `formFieldEntry` being updated. */
export type UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `formFieldEntry` being updated. */
export type UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryProductDepartmentIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `formFieldEntry` being updated. */
export type UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryProductIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `formFieldEntry` being updated. */
export type UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryProductUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `formFieldEntry` being updated. */
export type UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryUserCompetenceEvaluationIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `formFieldEntry` being updated. */
export type UpdateFormFieldEntryOnFormFieldEntryForFormFieldEntryUserIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldEntryCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<FormFieldEntryDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<FormFieldEntryEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  fieldGroup?: InputMaybe<FormFieldEntryFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldEntryFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldOptionIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  keywords?: InputMaybe<Scalars['FullText']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  objectType?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<FormFieldEntryProductIdForeignInput>;
  productDepartmentId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<FormFieldEntryProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FormFieldEntryProductUserIdForeignInput>;
  userCompetenceEvaluation?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnCompetenceForCompetenceRatingFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnCompetenceFormFieldForCompetenceFormFieldFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnContractPredefinedPlaceholderForContractPredefinedPlaceholderFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnCvTemplateFieldMappingForCvTemplateFieldMappingFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnDashboardCardStatisticForDashboardCardStatisticFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnFormFieldAgreementForFormFieldAgreementFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnFormFieldEntryForFormFieldEntryFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnFormFieldForFormFieldEngagementTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnFormFieldForFormFieldEventIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnFormFieldForFormFieldFieldGroupCardColumnIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnFormFieldForFormFieldFormFieldTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnFormFieldForFormFieldParentFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnFormFieldOptionForFormFieldOptionFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnFutureDatumForFutureDataFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnIntegrationFieldMarkingForIntegrationFieldMarkingFormFieldIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientFormFieldIdForePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnPreboardingForPreboardingRecipientCustomEmployeeFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formField` being updated. */
export type UpdateFormFieldOnRelationRoleForRelationRoleFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceFormFields?: InputMaybe<CompetenceFormFieldFormFieldIdForeignInverseInput>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  contractPredefinedPlaceholders?: InputMaybe<ContractPredefinedPlaceholderFormFieldIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingFormFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticFormFieldIdForeignInverseInput>;
  defaultValue?: InputMaybe<Scalars['String']>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  event?: InputMaybe<FormFieldEventIdForeignInput>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FormFieldFormFieldTypeIdForeignInput>;
  fieldGroupCardColumn?: InputMaybe<FormFieldFieldGroupCardColumnIdForeignInput>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<FormFieldParentFormFieldIdForeignInput>;
  formFieldAgreement?: InputMaybe<FormFieldAgreementFormFieldIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryFormFieldIdForeignInverseInput>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  futureData?: InputMaybe<FutureDataFormFieldIdForeignInverseInput>;
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInverseInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInverseInput>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInverseInput>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  relationRoles?: InputMaybe<RelationRoleFormFieldIdForeignInverseInput>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `formFieldOption` being updated. */
export type UpdateFormFieldOptionOnFormFieldOptionForFormFieldOptionCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldOptionCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldOptionFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  predefined?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `formFieldOption` being updated. */
export type UpdateFormFieldOptionOnFormFieldOptionForFormFieldOptionEngagementTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldOptionCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInput>;
  formField?: InputMaybe<FormFieldOptionFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  predefined?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `formFieldOption` being updated. */
export type UpdateFormFieldOptionOnFormFieldOptionForFormFieldOptionFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FormFieldOptionCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customId?: InputMaybe<Scalars['String']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<FormFieldOptionEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FormFieldOptionFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  objectType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingAssignedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  predefined?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `froalaStyle` being updated. */
export type UpdateFroalaStyleOnFroalaStyleForFroalaStylesCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<FroalaStylesCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  css?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `futureDatum` being updated. */
export type UpdateFutureDatumOnFutureDatumForFutureDataApprovalIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<FutureDataApprovalIdForeignInput>;
  company?: InputMaybe<FutureDataCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FutureDataFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FutureDataFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInverseInput>;
  systemField?: InputMaybe<FutureDataSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  uniqueKey?: InputMaybe<Scalars['UUID']>;
  updateValueAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FutureDataCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `futureDatum` being updated. */
export type UpdateFutureDatumOnFutureDatumForFutureDataCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<FutureDataApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<FutureDataCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FutureDataFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FutureDataFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInverseInput>;
  systemField?: InputMaybe<FutureDataSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  uniqueKey?: InputMaybe<Scalars['UUID']>;
  updateValueAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FutureDataCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `futureDatum` being updated. */
export type UpdateFutureDatumOnFutureDatumForFutureDataCreatorUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<FutureDataApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<FutureDataCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FutureDataFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FutureDataFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInverseInput>;
  systemField?: InputMaybe<FutureDataSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  uniqueKey?: InputMaybe<Scalars['UUID']>;
  updateValueAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FutureDataCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `futureDatum` being updated. */
export type UpdateFutureDatumOnFutureDatumForFutureDataFieldGroupIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<FutureDataApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<FutureDataCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FutureDataFieldGroupIdForeignInput>;
  formField?: InputMaybe<FutureDataFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInverseInput>;
  systemField?: InputMaybe<FutureDataSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  uniqueKey?: InputMaybe<Scalars['UUID']>;
  updateValueAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FutureDataCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `futureDatum` being updated. */
export type UpdateFutureDatumOnFutureDatumForFutureDataFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<FutureDataApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<FutureDataCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FutureDataFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FutureDataFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInverseInput>;
  systemField?: InputMaybe<FutureDataSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  uniqueKey?: InputMaybe<Scalars['UUID']>;
  updateValueAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FutureDataCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `futureDatum` being updated. */
export type UpdateFutureDatumOnFutureDatumForFutureDataSystemFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<FutureDataApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<FutureDataCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FutureDataFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FutureDataFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInverseInput>;
  systemField?: InputMaybe<FutureDataSystemFieldIdForeignInput>;
  uniqueKey?: InputMaybe<Scalars['UUID']>;
  updateValueAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FutureDataCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `futureDatum` being updated. */
export type UpdateFutureDatumOnFutureDatumForFutureDataUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<FutureDataApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<FutureDataCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FutureDataFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FutureDataFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInverseInput>;
  systemField?: InputMaybe<FutureDataSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  uniqueKey?: InputMaybe<Scalars['UUID']>;
  updateValueAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FutureDataCreatorUserIdForeignInput>;
  value?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `futureDatum` being updated. */
export type UpdateFutureDatumOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFutureDataIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<FutureDataApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<FutureDataCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<FutureDataFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<FutureDataFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInverseInput>;
  systemField?: InputMaybe<FutureDataSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  uniqueKey?: InputMaybe<Scalars['UUID']>;
  updateValueAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<FutureDataCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `group` being updated. */
export type UpdateGroupOnAuthAppForAuthAppTableGroupIdFkPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppTableGroupIdFkInverseInput>;
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  autoInherit?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientGroupIdForeignInverseInput>;
  scope?: InputMaybe<RoleScope>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupGroupIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupGroupIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupGroupIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `group` being updated. */
export type UpdateGroupOnGroupRoleForGroupRoleGroupIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppTableGroupIdFkInverseInput>;
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  autoInherit?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientGroupIdForeignInverseInput>;
  scope?: InputMaybe<RoleScope>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupGroupIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupGroupIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupGroupIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `group` being updated. */
export type UpdateGroupOnNotificationGroupRecipientForNotificationGroupRecipientGroupIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppTableGroupIdFkInverseInput>;
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  autoInherit?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientGroupIdForeignInverseInput>;
  scope?: InputMaybe<RoleScope>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupGroupIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupGroupIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupGroupIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `group` being updated. */
export type UpdateGroupOnPreboardingForPreboardingRecipientGroupIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppTableGroupIdFkInverseInput>;
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  autoInherit?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientGroupIdForeignInverseInput>;
  scope?: InputMaybe<RoleScope>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupGroupIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupGroupIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupGroupIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `group` being updated. */
export type UpdateGroupOnUserCompanyGroupForUserCompanyGroupGroupIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppTableGroupIdFkInverseInput>;
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  autoInherit?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientGroupIdForeignInverseInput>;
  scope?: InputMaybe<RoleScope>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupGroupIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupGroupIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupGroupIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `group` being updated. */
export type UpdateGroupOnUserDepartmentGroupForUserDepartmentGroupGroupIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppTableGroupIdFkInverseInput>;
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  autoInherit?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientGroupIdForeignInverseInput>;
  scope?: InputMaybe<RoleScope>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupGroupIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupGroupIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupGroupIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `group` being updated. */
export type UpdateGroupOnUserGroupForUserGroupGroupIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppTableGroupIdFkInverseInput>;
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  autoInherit?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleGroupIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientGroupIdForeignInverseInput>;
  scope?: InputMaybe<RoleScope>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupGroupIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupGroupIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupGroupIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `groupRole` being updated. */
export type UpdateGroupRoleOnGroupRoleForGroupRoleCompanyIdFkeyPatch = {
  company?: InputMaybe<GroupRoleCompanyIdFkeyInput>;
  group?: InputMaybe<GroupRoleGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<GroupRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `groupRole` being updated. */
export type UpdateGroupRoleOnGroupRoleForGroupRoleGroupIdForeignPatch = {
  company?: InputMaybe<GroupRoleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<GroupRoleGroupIdForeignInput>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<GroupRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `groupRole` being updated. */
export type UpdateGroupRoleOnGroupRoleForGroupRoleRoleIdForeignPatch = {
  company?: InputMaybe<GroupRoleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<GroupRoleGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<GroupRoleRoleIdForeignInput>;
};

/** An object where the defined keys will be set on the `hook` being updated. */
export type UpdateHookOnNotificationForNotificationHookIdForeignPatch = {
  alwaysSend?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notifications?: InputMaybe<NotificationHookIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `integrableSystem` being updated. */
export type UpdateIntegrableSystemOnExternalIntegrationForExternalIntegrationIntegrableSystemIdFkeyPatch = {
  authUrl?: InputMaybe<Scalars['String']>;
  createUrl?: InputMaybe<Scalars['String']>;
  deleteUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegrations?: InputMaybe<ExternalIntegrationIntegrableSystemIdFkeyInverseInput>;
  homepageUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isBeta?: InputMaybe<Scalars['Boolean']>;
  legalDescription?: InputMaybe<Scalars['String']>;
  loginUrl?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  settingsUrl?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
export type UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingAuthAppIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInput>;
  company?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInput>;
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationName?: InputMaybe<Scalars['String']>;
  receivesData?: InputMaybe<Scalars['Boolean']>;
  sendsData?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
export type UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInput>;
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationName?: InputMaybe<Scalars['String']>;
  receivesData?: InputMaybe<Scalars['Boolean']>;
  sendsData?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
export type UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingExternalIntegrationIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInput>;
  formField?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationName?: InputMaybe<Scalars['String']>;
  receivesData?: InputMaybe<Scalars['Boolean']>;
  sendsData?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
export type UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingFormFieldIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInput>;
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationName?: InputMaybe<Scalars['String']>;
  receivesData?: InputMaybe<Scalars['Boolean']>;
  sendsData?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
export type UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingStorageIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInput>;
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationName?: InputMaybe<Scalars['String']>;
  receivesData?: InputMaybe<Scalars['Boolean']>;
  sendsData?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInput>;
  systemField?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `integrationFieldMarking` being updated. */
export type UpdateIntegrationFieldMarkingOnIntegrationFieldMarkingForIntegrationFieldMarkingSystemFieldIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  authApp?: InputMaybe<IntegrationFieldMarkingAuthAppIdFkeyInput>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<IntegrationFieldMarkingCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deletedAt?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  description?: InputMaybe<Scalars['String']>;
  externalIntegration?: InputMaybe<IntegrationFieldMarkingExternalIntegrationIdFkeyInput>;
  externalIntegrationId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<IntegrationFieldMarkingFormFieldIdFkeyInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationName?: InputMaybe<Scalars['String']>;
  receivesData?: InputMaybe<Scalars['Boolean']>;
  sendsData?: InputMaybe<Scalars['Boolean']>;
  storage?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `latestMessage` being updated. */
export type UpdateLatestMessageOnLatestMessageForLatestMessageCompanyIdForeignPatch = {
  company?: InputMaybe<LatestMessageCompanyIdForeignInput>;
  employee?: InputMaybe<LatestMessageEmployeeId2ForeignInput>;
  employeeId1?: InputMaybe<Scalars['UUID']>;
  employeeId2?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<LatestMessageMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `latestMessage` being updated. */
export type UpdateLatestMessageOnLatestMessageForLatestMessageEmployeeId1ForeignPatch = {
  company?: InputMaybe<LatestMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<LatestMessageEmployeeId2ForeignInput>;
  employeeId2?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<LatestMessageMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `latestMessage` being updated. */
export type UpdateLatestMessageOnLatestMessageForLatestMessageEmployeeId2ForeignPatch = {
  company?: InputMaybe<LatestMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<LatestMessageEmployeeId2ForeignInput>;
  employeeId1?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<LatestMessageMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `latestMessage` being updated. */
export type UpdateLatestMessageOnLatestMessageForLatestMessageMessageIdForeignPatch = {
  company?: InputMaybe<LatestMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<LatestMessageEmployeeId2ForeignInput>;
  employeeId1?: InputMaybe<Scalars['UUID']>;
  employeeId2?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<LatestMessageMessageIdForeignInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `loggedActionNote` being updated. */
export type UpdateLoggedActionNoteOnLoggedActionNoteForLoggedActionNoteCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<LoggedActionNoteCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  loggedActionEventId?: InputMaybe<Scalars['BigInt']>;
  note?: InputMaybe<Scalars['String']>;
  superUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<LoggedActionNoteSuperUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `loggedActionNote` being updated. */
export type UpdateLoggedActionNoteOnLoggedActionNoteForLoggedActionNoteSuperUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<LoggedActionNoteCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  loggedActionEventId?: InputMaybe<Scalars['BigInt']>;
  note?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<LoggedActionNoteSuperUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `loggedActionNote` being updated. */
export type UpdateLoggedActionNoteOnLoggedActionNoteForLoggedActionNoteUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<LoggedActionNoteCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  loggedActionEventId?: InputMaybe<Scalars['BigInt']>;
  note?: InputMaybe<Scalars['String']>;
  superUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<LoggedActionNoteSuperUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `loginLog` being updated. */
export type UpdateLoginLogOnLoginLogForLoginLogCompanyIdForeignPatch = {
  company?: InputMaybe<LoginLogCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  ip?: InputMaybe<Scalars['InternetAddress']>;
  superUserId?: InputMaybe<Scalars['UUID']>;
  superUserLoginNotes?: InputMaybe<SuperUserLoginNoteLoginLogIdForeignInverseInput>;
  type?: InputMaybe<LoginLogType>;
  user?: InputMaybe<LoginLogSuperUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `loginLog` being updated. */
export type UpdateLoginLogOnLoginLogForLoginLogUserIdForeignPatch = {
  company?: InputMaybe<LoginLogCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  ip?: InputMaybe<Scalars['InternetAddress']>;
  superUserId?: InputMaybe<Scalars['UUID']>;
  superUserLoginNotes?: InputMaybe<SuperUserLoginNoteLoginLogIdForeignInverseInput>;
  type?: InputMaybe<LoginLogType>;
  user?: InputMaybe<LoginLogSuperUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `loginLog` being updated. */
export type UpdateLoginLogOnSuperUserLoginNoteForSuperUserLoginNoteLoginLogIdForeignPatch = {
  company?: InputMaybe<LoginLogCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  ip?: InputMaybe<Scalars['InternetAddress']>;
  superUserId?: InputMaybe<Scalars['UUID']>;
  superUserLoginNotes?: InputMaybe<SuperUserLoginNoteLoginLogIdForeignInverseInput>;
  type?: InputMaybe<LoginLogType>;
  user?: InputMaybe<LoginLogSuperUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `message` being updated. */
export type UpdateMessageOnLatestMessageForLatestMessageMessageIdForeignPatch = {
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<MessageCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<MessageToEmployeeIdForeignInput>;
  fromEmployeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  latestMessages?: InputMaybe<LatestMessageMessageIdForeignInverseInput>;
  messageRecipients?: InputMaybe<MessageRecipientMessageIdForeignInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInverseInput>;
  readByFrom?: InputMaybe<Scalars['Boolean']>;
  readByTo?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  toEmployeeId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<MessageType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `message` being updated. */
export type UpdateMessageOnMessageForMessageCompanyIdFkeyPatch = {
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<MessageCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<MessageToEmployeeIdForeignInput>;
  fromEmployeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  latestMessages?: InputMaybe<LatestMessageMessageIdForeignInverseInput>;
  messageRecipients?: InputMaybe<MessageRecipientMessageIdForeignInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInverseInput>;
  readByFrom?: InputMaybe<Scalars['Boolean']>;
  readByTo?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  toEmployeeId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<MessageType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `message` being updated. */
export type UpdateMessageOnMessageForMessageFromEmployeeIdForeignPatch = {
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<MessageCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<MessageToEmployeeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  latestMessages?: InputMaybe<LatestMessageMessageIdForeignInverseInput>;
  messageRecipients?: InputMaybe<MessageRecipientMessageIdForeignInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInverseInput>;
  readByFrom?: InputMaybe<Scalars['Boolean']>;
  readByTo?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  toEmployeeId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<MessageType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `message` being updated. */
export type UpdateMessageOnMessageForMessageToEmployeeIdForeignPatch = {
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<MessageCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<MessageToEmployeeIdForeignInput>;
  fromEmployeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  latestMessages?: InputMaybe<LatestMessageMessageIdForeignInverseInput>;
  messageRecipients?: InputMaybe<MessageRecipientMessageIdForeignInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInverseInput>;
  readByFrom?: InputMaybe<Scalars['Boolean']>;
  readByTo?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<MessageType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `message` being updated. */
export type UpdateMessageOnMessageRecipientForMessageRecipientMessageIdForeignPatch = {
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<MessageCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<MessageToEmployeeIdForeignInput>;
  fromEmployeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  latestMessages?: InputMaybe<LatestMessageMessageIdForeignInverseInput>;
  messageRecipients?: InputMaybe<MessageRecipientMessageIdForeignInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInverseInput>;
  readByFrom?: InputMaybe<Scalars['Boolean']>;
  readByTo?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  toEmployeeId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<MessageType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `message` being updated. */
export type UpdateMessageOnNotificationEmployeeReferenceForNotificationEmployeeReferenceMessageIdForeignPatch = {
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<MessageCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<MessageToEmployeeIdForeignInput>;
  fromEmployeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  latestMessages?: InputMaybe<LatestMessageMessageIdForeignInverseInput>;
  messageRecipients?: InputMaybe<MessageRecipientMessageIdForeignInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInverseInput>;
  readByFrom?: InputMaybe<Scalars['Boolean']>;
  readByTo?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  toEmployeeId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<MessageType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `notificationCustomEmployeeFieldRecipient` being updated. */
export type UpdateNotificationCustomEmployeeFieldRecipientOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientCompanyIdForeignPatch = {
  company?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInput>;
  formField?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationCustomEmployeeFieldRecipient` being updated. */
export type UpdateNotificationCustomEmployeeFieldRecipientOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientFormFieldIdForePatch = {
  company?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInput>;
  id?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationCustomEmployeeFieldRecipient` being updated. */
export type UpdateNotificationCustomEmployeeFieldRecipientOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientNotificationIdFoPatch = {
  company?: InputMaybe<NotificationCustomEmployeeFieldRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<NotificationCustomEmployeeFieldRecipientFormFieldIdForeInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInput>;
};

/** An object where the defined keys will be set on the `notificationCustomRecipient` being updated. */
export type UpdateNotificationCustomRecipientOnNotificationCustomRecipientForNotificationCustomRecipientCompanyIdFkeyPatch = {
  company?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationCustomRecipientUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationCustomRecipient` being updated. */
export type UpdateNotificationCustomRecipientOnNotificationCustomRecipientForNotificationCustomRecipientEmployeeIdFkeyPatch = {
  company?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInput>;
  notification?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationCustomRecipientUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationCustomRecipient` being updated. */
export type UpdateNotificationCustomRecipientOnNotificationCustomRecipientForNotificationCustomRecipientNotificationIdFkeyPatch = {
  company?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInput>;
  user?: InputMaybe<NotificationCustomRecipientUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationCustomRecipient` being updated. */
export type UpdateNotificationCustomRecipientOnNotificationCustomRecipientForNotificationCustomRecipientUserIdFkeyPatch = {
  company?: InputMaybe<NotificationCustomRecipientCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<NotificationCustomRecipientEmployeeIdFkeyInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationCustomRecipientUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `notificationEmployee` being updated. */
export type UpdateNotificationEmployeeOnNotificationEmployeeForNotificationEmployeeCompanyIdFkeyPatch = {
  company?: InputMaybe<NotificationEmployeeCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<NotificationEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  localeOverride?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<NotificationEmployeeNotificationIdForeignInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInverseInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  parentReference?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  read?: InputMaybe<Scalars['Boolean']>;
  readTime?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  senderId?: InputMaybe<Scalars['UUID']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `notificationEmployee` being updated. */
export type UpdateNotificationEmployeeOnNotificationEmployeeForNotificationEmployeeEmployeeIdForeignPatch = {
  company?: InputMaybe<NotificationEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<NotificationEmployeeEmployeeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  localeOverride?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<NotificationEmployeeNotificationIdForeignInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInverseInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  parentReference?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  read?: InputMaybe<Scalars['Boolean']>;
  readTime?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  senderId?: InputMaybe<Scalars['UUID']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `notificationEmployee` being updated. */
export type UpdateNotificationEmployeeOnNotificationEmployeeForNotificationEmployeeNotificationIdForeignPatch = {
  company?: InputMaybe<NotificationEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<NotificationEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  localeOverride?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<NotificationEmployeeNotificationIdForeignInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInverseInput>;
  parentReference?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  read?: InputMaybe<Scalars['Boolean']>;
  readTime?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  senderId?: InputMaybe<Scalars['UUID']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `notificationEmployee` being updated. */
export type UpdateNotificationEmployeeOnNotificationEmployeeForNotificationEmployeeRecipientIdForeignPatch = {
  company?: InputMaybe<NotificationEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<NotificationEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  localeOverride?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<NotificationEmployeeNotificationIdForeignInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInverseInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  parentReference?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  read?: InputMaybe<Scalars['Boolean']>;
  readTime?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  senderId?: InputMaybe<Scalars['UUID']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `notificationEmployee` being updated. */
export type UpdateNotificationEmployeeOnNotificationEmployeeForNotificationEmployeeSenderIdForeignPatch = {
  company?: InputMaybe<NotificationEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<NotificationEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  localeOverride?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<NotificationEmployeeNotificationIdForeignInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInverseInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  parentReference?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  read?: InputMaybe<Scalars['Boolean']>;
  readTime?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `notificationEmployee` being updated. */
export type UpdateNotificationEmployeeOnNotificationEmployeeReferenceForNotificationEmployeeReferenceNotificationEmployeeIdForeigPatch = {
  company?: InputMaybe<NotificationEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  employee?: InputMaybe<NotificationEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  localeOverride?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<NotificationEmployeeNotificationIdForeignInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInverseInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
  parentReference?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  read?: InputMaybe<Scalars['Boolean']>;
  readTime?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  senderId?: InputMaybe<Scalars['UUID']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompanyIdFkeyPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompetenceGroupIdForeignPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceCompetenceIdForeignPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceContractSignPendingIdForeigPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceDepartmentIdForeignPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceEmployeeIdForeignPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFileIdForeignPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFutureDataIdForeignPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceMessageIdForeignPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceNotificationEmployeeIdForeigPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferencePreboardingIdForeignPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceProcessIdForeignPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceProductIdForeignPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceRecipientUserIdFkeyPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTaskIdForeignPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTaskTemplateIdForeignPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTimeRegistrationPresenceIdFPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceUserCompetenceIdForeignPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationTypeIdForeignPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
  vacationUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationEmployeeReference` being updated. */
export type UpdateNotificationEmployeeReferenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationUserIdForeignPatch = {
  announcementId?: InputMaybe<Scalars['UUID']>;
  casefileId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<NotificationEmployeeReferenceCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<NotificationEmployeeReferenceCompetenceIdForeignInput>;
  competenceGroup?: InputMaybe<NotificationEmployeeReferenceCompetenceGroupIdForeignInput>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  contractSignPending?: InputMaybe<NotificationEmployeeReferenceContractSignPendingIdForeigInput>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<NotificationEmployeeReferenceDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  employee?: InputMaybe<NotificationEmployeeReferenceEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  equipmentId?: InputMaybe<Scalars['UUID']>;
  fileId?: InputMaybe<Scalars['UUID']>;
  futureDataId?: InputMaybe<Scalars['UUID']>;
  futureDatum?: InputMaybe<NotificationEmployeeReferenceFutureDataIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<NotificationEmployeeReferenceMessageIdForeignInput>;
  messageId?: InputMaybe<Scalars['UUID']>;
  notificationEmployee?: InputMaybe<NotificationEmployeeReferenceNotificationEmployeeIdForeigInput>;
  notificationEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  product?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInput>;
  productId?: InputMaybe<Scalars['UUID']>;
  recipientUserId?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInput>;
  task?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresence?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInput>;
  userCompetence?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  vacationUser?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `notificationGroupRecipient` being updated. */
export type UpdateNotificationGroupRecipientOnNotificationGroupRecipientForNotificationGroupRecipientCompanyIdFkeyPatch = {
  company?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInput>;
  group?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationGroupRecipient` being updated. */
export type UpdateNotificationGroupRecipientOnNotificationGroupRecipientForNotificationGroupRecipientGroupIdFkeyPatch = {
  company?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInput>;
  notification?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInput>;
  notificationId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationGroupRecipient` being updated. */
export type UpdateNotificationGroupRecipientOnNotificationGroupRecipientForNotificationGroupRecipientNotificationIdFkeyPatch = {
  company?: InputMaybe<NotificationGroupRecipientCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<NotificationGroupRecipientGroupIdFkeyInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  notification?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInput>;
};

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnNotificationCustomEmployeeFieldRecipientForNotificationCustomEmployeeFieldRecipientNotificationIdFoPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  customRecipientEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  emailSubject?: InputMaybe<Scalars['String']>;
  hook?: InputMaybe<NotificationHookIdForeignInput>;
  hookId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeNotificationIdForeignInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInverseInput>;
  notificationType?: InputMaybe<NotificationNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
  permissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<NotificationPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  recipientType?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnNotificationCustomRecipientForNotificationCustomRecipientNotificationIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  customRecipientEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  emailSubject?: InputMaybe<Scalars['String']>;
  hook?: InputMaybe<NotificationHookIdForeignInput>;
  hookId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeNotificationIdForeignInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInverseInput>;
  notificationType?: InputMaybe<NotificationNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
  permissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<NotificationPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  recipientType?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnNotificationEmployeeForNotificationEmployeeNotificationIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  customRecipientEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  emailSubject?: InputMaybe<Scalars['String']>;
  hook?: InputMaybe<NotificationHookIdForeignInput>;
  hookId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeNotificationIdForeignInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInverseInput>;
  notificationType?: InputMaybe<NotificationNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
  permissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<NotificationPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  recipientType?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnNotificationForNotificationHookIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  customRecipientEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  emailSubject?: InputMaybe<Scalars['String']>;
  hook?: InputMaybe<NotificationHookIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeNotificationIdForeignInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInverseInput>;
  notificationType?: InputMaybe<NotificationNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
  permissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<NotificationPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  recipientType?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnNotificationForNotificationNotificationTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  customRecipientEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  emailSubject?: InputMaybe<Scalars['String']>;
  hook?: InputMaybe<NotificationHookIdForeignInput>;
  hookId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeNotificationIdForeignInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInverseInput>;
  notificationType?: InputMaybe<NotificationNotificationTypeIdForeignInput>;
  permissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<NotificationPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  recipientType?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnNotificationForNotificationPreboardingIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  customRecipientEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  emailSubject?: InputMaybe<Scalars['String']>;
  hook?: InputMaybe<NotificationHookIdForeignInput>;
  hookId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeNotificationIdForeignInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInverseInput>;
  notificationType?: InputMaybe<NotificationNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
  permissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<NotificationPreboardingIdForeignInput>;
  recipientType?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnNotificationGroupRecipientForNotificationGroupRecipientNotificationIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  customRecipientEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  emailSubject?: InputMaybe<Scalars['String']>;
  hook?: InputMaybe<NotificationHookIdForeignInput>;
  hookId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  notificationCustomEmployeeFieldRecipients?: InputMaybe<NotificationCustomEmployeeFieldRecipientNotificationIdFoInverseInput>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientNotificationIdFkeyInverseInput>;
  notificationEmployees?: InputMaybe<NotificationEmployeeNotificationIdForeignInverseInput>;
  notificationGroupRecipients?: InputMaybe<NotificationGroupRecipientNotificationIdFkeyInverseInput>;
  notificationType?: InputMaybe<NotificationNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
  permissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<NotificationPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  recipientType?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `notificationTypeChannelType` being updated. */
export type UpdateNotificationTypeChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeChannelTypeIdForeignPatch = {
  channelType?: InputMaybe<NotificationTypeChannelTypeChannelTypeIdForeignInput>;
  company?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  notificationType?: InputMaybe<NotificationTypeChannelTypeNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationTypeChannelType` being updated. */
export type UpdateNotificationTypeChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeCompanyIdFkeyPatch = {
  channelType?: InputMaybe<NotificationTypeChannelTypeChannelTypeIdForeignInput>;
  channelTypeId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInput>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  notificationType?: InputMaybe<NotificationTypeChannelTypeNotificationTypeIdForeignInput>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `notificationTypeChannelType` being updated. */
export type UpdateNotificationTypeChannelTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeNotificationTypeIdForeignPatch = {
  channelType?: InputMaybe<NotificationTypeChannelTypeChannelTypeIdForeignInput>;
  channelTypeId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<NotificationTypeChannelTypeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  notificationType?: InputMaybe<NotificationTypeChannelTypeNotificationTypeIdForeignInput>;
};

/** An object where the defined keys will be set on the `notificationType` being updated. */
export type UpdateNotificationTypeOnNotificationForNotificationNotificationTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  avoidBundling?: InputMaybe<Scalars['Boolean']>;
  broadcastTime?: InputMaybe<Scalars['Time']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeNotificationTypeIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationNotificationTypeIdForeignInverseInput>;
  timeZone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `notificationType` being updated. */
export type UpdateNotificationTypeOnNotificationTypeChannelTypeForNotificationTypeChannelTypeNotificationTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  avoidBundling?: InputMaybe<Scalars['Boolean']>;
  broadcastTime?: InputMaybe<Scalars['Time']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationTypeChannelTypes?: InputMaybe<NotificationTypeChannelTypeNotificationTypeIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationNotificationTypeIdForeignInverseInput>;
  timeZone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `post` being updated. */
export type UpdatePostOnPostForPostCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  commentsEnabled?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PostCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  ogDescription?: InputMaybe<Scalars['String']>;
  ogImageHeight?: InputMaybe<Scalars['Int']>;
  ogImageType?: InputMaybe<Scalars['String']>;
  ogImageUrl?: InputMaybe<Scalars['String']>;
  ogImageWidth?: InputMaybe<Scalars['Int']>;
  ogTitle?: InputMaybe<Scalars['String']>;
  ogUrl?: InputMaybe<Scalars['String']>;
  postTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PostUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `post` being updated. */
export type UpdatePostOnPostForPostUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  commentsEnabled?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PostCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  ogDescription?: InputMaybe<Scalars['String']>;
  ogImageHeight?: InputMaybe<Scalars['Int']>;
  ogImageType?: InputMaybe<Scalars['String']>;
  ogImageUrl?: InputMaybe<Scalars['String']>;
  ogImageWidth?: InputMaybe<Scalars['Int']>;
  ogTitle?: InputMaybe<Scalars['String']>;
  ogUrl?: InputMaybe<Scalars['String']>;
  postTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PostUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `postType` being updated. */
export type UpdatePostTypeOnPostTypeForPostTypeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PostTypeCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  sharedDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  sharedUsers?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  translatedEntity?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `postType` being updated. */
export type UpdatePostTypeOnPostTypeForPostTypeNameTranslatedEntityIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PostTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  sharedDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  sharedUsers?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  translatedEntity?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `preboardingComment` being updated. */
export type UpdatePreboardingCommentOnPreboardingCommentForPreboardingCommentCompanyIdFkeyPatch = {
  company?: InputMaybe<PreboardingCommentCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<PreboardingCommentPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingCommentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingComment` being updated. */
export type UpdatePreboardingCommentOnPreboardingCommentForPreboardingCommentEmployeeIdForeignPatch = {
  company?: InputMaybe<PreboardingCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingCommentEmployeeIdForeignInput>;
  engagementType?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<PreboardingCommentPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingCommentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingComment` being updated. */
export type UpdatePreboardingCommentOnPreboardingCommentForPreboardingCommentEngagementTypeIdForeignPatch = {
  company?: InputMaybe<PreboardingCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<PreboardingCommentPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingCommentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingComment` being updated. */
export type UpdatePreboardingCommentOnPreboardingCommentForPreboardingCommentPreboardingIdForeignPatch = {
  company?: InputMaybe<PreboardingCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<PreboardingCommentPreboardingIdForeignInput>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingCommentUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingComment` being updated. */
export type UpdatePreboardingCommentOnPreboardingCommentForPreboardingCommentUserIdFkeyPatch = {
  company?: InputMaybe<PreboardingCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboarding?: InputMaybe<PreboardingCommentPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingCommentUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `preboardingEmailLog` being updated. */
export type UpdatePreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogCompanyIdFkeyPatch = {
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  email?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInput>;
  engagementType?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fromEmployeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `preboardingEmailLog` being updated. */
export type UpdatePreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogEngagementTypeIdForeignPatch = {
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  email?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInput>;
  engagementType?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInput>;
  fromEmployeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `preboardingEmailLog` being updated. */
export type UpdatePreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogFromEmployeeIdForeignPatch = {
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  email?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInput>;
  engagementType?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `preboardingEmailLog` being updated. */
export type UpdatePreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogPreboardingEmployeeIdForeignPatch = {
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  email?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInput>;
  engagementType?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fromEmployeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInput>;
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `preboardingEmailLog` being updated. */
export type UpdatePreboardingEmailLogOnPreboardingEmailLogForPreboardingEmailLogPreboardingUserIdForeignPatch = {
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<PreboardingEmailLogCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  email?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmailLogFromEmployeeIdForeignInput>;
  engagementType?: InputMaybe<PreboardingEmailLogEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fromEmployeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `preboardingEmployee` being updated. */
export type UpdatePreboardingEmployeeOnContractSignPendingForContractSignPendingPreboardingEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingEmployee` being updated. */
export type UpdatePreboardingEmployeeOnPreboardingEmailLogForPreboardingEmailLogPreboardingEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingEmployee` being updated. */
export type UpdatePreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingEmployee` being updated. */
export type UpdatePreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingEmployee` being updated. */
export type UpdatePreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeEngagementTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingEmployee` being updated. */
export type UpdatePreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeePreboardingIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingEmployee` being updated. */
export type UpdatePreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeRecipientIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingEmployee` being updated. */
export type UpdatePreboardingEmployeeOnPreboardingEmployeeForPreboardingEmployeeUserIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
};

/** An object where the defined keys will be set on the `preboardingEmployee` being updated. */
export type UpdatePreboardingEmployeeOnPreboardingResultForPreboardingResultPreboardingEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingEmployeeIdForeignInverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEmployeeEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  preboarding?: InputMaybe<PreboardingEmployeePreboardingIdForeignInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingEmployeeIdForeignInverseInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
  published?: InputMaybe<Scalars['Boolean']>;
  publishedDate?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<PreboardingEmployeeRecipientIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingFormCache` being updated. */
export type UpdatePreboardingFormCacheOnPreboardingFormCacheForPreboardingFormCachePreboardingIdForeignPatch = {
  formValues?: InputMaybe<Scalars['JSON']>;
  page?: InputMaybe<Scalars['String']>;
  preboarding?: InputMaybe<PreboardingFormCachePreboardingIdForeignInput>;
  user?: InputMaybe<PreboardingFormCacheUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingFormCache` being updated. */
export type UpdatePreboardingFormCacheOnPreboardingFormCacheForPreboardingFormCacheUserIdForeignPatch = {
  formValues?: InputMaybe<Scalars['JSON']>;
  page?: InputMaybe<Scalars['String']>;
  preboarding?: InputMaybe<PreboardingFormCachePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<PreboardingFormCacheUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `preboarding` being updated. */
export type UpdatePreboardingOnNotificationEmployeeReferenceForNotificationEmployeeReferencePreboardingIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboarding` being updated. */
export type UpdatePreboardingOnNotificationForNotificationPreboardingIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboarding` being updated. */
export type UpdatePreboardingOnPreboardingCommentForPreboardingCommentPreboardingIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboarding` being updated. */
export type UpdatePreboardingOnPreboardingEmployeeForPreboardingEmployeePreboardingIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboarding` being updated. */
export type UpdatePreboardingOnPreboardingForPreboardingCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboarding` being updated. */
export type UpdatePreboardingOnPreboardingForPreboardingCreatedFromForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboarding` being updated. */
export type UpdatePreboardingOnPreboardingForPreboardingEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboarding` being updated. */
export type UpdatePreboardingOnPreboardingForPreboardingEngagementTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboarding` being updated. */
export type UpdatePreboardingOnPreboardingForPreboardingPredecessorIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboarding` being updated. */
export type UpdatePreboardingOnPreboardingForPreboardingRecipientCustomEmployeeFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboarding` being updated. */
export type UpdatePreboardingOnPreboardingForPreboardingRecipientGroupIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboarding` being updated. */
export type UpdatePreboardingOnPreboardingForPreboardingRecipientIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboarding` being updated. */
export type UpdatePreboardingOnPreboardingFormCacheForPreboardingFormCachePreboardingIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboarding` being updated. */
export type UpdatePreboardingOnPreboardingProcessForPreboardingProcessPreboardingIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboarding` being updated. */
export type UpdatePreboardingOnPreboardingSlideForPreboardingSlidePreboardingIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<PreboardingCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdFrom?: InputMaybe<Scalars['UUID']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  employee?: InputMaybe<PreboardingEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontType?: InputMaybe<PreboardingFontType>;
  fontUrl?: InputMaybe<Scalars['String']>;
  formField?: InputMaybe<PreboardingRecipientCustomEmployeeFieldIdForeignInput>;
  group?: InputMaybe<PreboardingRecipientGroupIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  logoType?: InputMaybe<PreboardingLogoType>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferencePreboardingIdForeignInverseInput>;
  notifications?: InputMaybe<NotificationPreboardingIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  preboardingComments?: InputMaybe<PreboardingCommentPreboardingIdForeignInverseInput>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCachePreboardingIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessPreboardingIdForeignInverseInput>;
  preboardingSlides?: InputMaybe<PreboardingSlidePreboardingIdForeignInverseInput>;
  preboardingToCreatedFrom?: InputMaybe<PreboardingCreatedFromForeignInput>;
  preboardingToPredecessorId?: InputMaybe<PreboardingPredecessorIdForeignInput>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  responsibleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  result?: InputMaybe<Scalars['JSON']>;
  smsBody?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PreboardingType>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingRecipientIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboardingProcess` being updated. */
export type UpdatePreboardingProcessOnPreboardingProcessForPreboardingProcessCompanyIdForeignPatch = {
  company?: InputMaybe<PreboardingProcessCompanyIdForeignInput>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<PreboardingProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboarding?: InputMaybe<PreboardingProcessPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<PreboardingProcessProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingProcess` being updated. */
export type UpdatePreboardingProcessOnPreboardingProcessForPreboardingProcessEmployeeIdForeignPatch = {
  company?: InputMaybe<PreboardingProcessCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<PreboardingProcessEmployeeIdForeignInput>;
  engagementType?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboarding?: InputMaybe<PreboardingProcessPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<PreboardingProcessProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingProcess` being updated. */
export type UpdatePreboardingProcessOnPreboardingProcessForPreboardingProcessEngagementTypeIdForeignPatch = {
  company?: InputMaybe<PreboardingProcessCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<PreboardingProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboarding?: InputMaybe<PreboardingProcessPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<PreboardingProcessProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingProcess` being updated. */
export type UpdatePreboardingProcessOnPreboardingProcessForPreboardingProcessPreboardingIdForeignPatch = {
  company?: InputMaybe<PreboardingProcessCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<PreboardingProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboarding?: InputMaybe<PreboardingProcessPreboardingIdForeignInput>;
  process?: InputMaybe<PreboardingProcessProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingProcess` being updated. */
export type UpdatePreboardingProcessOnPreboardingProcessForPreboardingProcessProcessIdForeignPatch = {
  company?: InputMaybe<PreboardingProcessCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<PreboardingProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboarding?: InputMaybe<PreboardingProcessPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<PreboardingProcessProcessIdForeignInput>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingProcess` being updated. */
export type UpdatePreboardingProcessOnPreboardingProcessForPreboardingProcessUserIdForeignPatch = {
  company?: InputMaybe<PreboardingProcessCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  employee?: InputMaybe<PreboardingProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingProcessEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboarding?: InputMaybe<PreboardingProcessPreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<PreboardingProcessProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  template?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<PreboardingProcessUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `preboardingResult` being updated. */
export type UpdatePreboardingResultOnPreboardingResultForPreboardingResultCompanyIdFkeyPatch = {
  company?: InputMaybe<PreboardingResultCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingResultEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInverseInput>;
  result?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<PreboardingResultUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingResult` being updated. */
export type UpdatePreboardingResultOnPreboardingResultForPreboardingResultEmployeeIdForeignPatch = {
  company?: InputMaybe<PreboardingResultCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingResultEmployeeIdForeignInput>;
  engagementType?: InputMaybe<PreboardingResultEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInverseInput>;
  result?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<PreboardingResultUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingResult` being updated. */
export type UpdatePreboardingResultOnPreboardingResultForPreboardingResultEngagementTypeIdForeignPatch = {
  company?: InputMaybe<PreboardingResultCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingResultEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultEngagementTypeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInverseInput>;
  result?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<PreboardingResultUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingResult` being updated. */
export type UpdatePreboardingResultOnPreboardingResultForPreboardingResultPreboardingEmployeeIdForeignPatch = {
  company?: InputMaybe<PreboardingResultCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingResultEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInverseInput>;
  result?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<PreboardingResultUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingResult` being updated. */
export type UpdatePreboardingResultOnPreboardingResultForPreboardingResultUserIdForeignPatch = {
  company?: InputMaybe<PreboardingResultCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingResultEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInverseInput>;
  result?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<PreboardingResultUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `preboardingResult` being updated. */
export type UpdatePreboardingResultOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingResultIdForeignPatch = {
  company?: InputMaybe<PreboardingResultCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<PreboardingResultEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingEmployee?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInput>;
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInverseInput>;
  result?: InputMaybe<Scalars['JSON']>;
  user?: InputMaybe<PreboardingResultUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingResultSlideComment` being updated. */
export type UpdatePreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentCompanyIdFkeyPatch = {
  company?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingResult?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInput>;
  preboardingResultId?: InputMaybe<Scalars['UUID']>;
  preboardingSlide?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInput>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingResultSlideComment` being updated. */
export type UpdatePreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEmployeeIdForeignPatch = {
  company?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInput>;
  engagementType?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingResult?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInput>;
  preboardingResultId?: InputMaybe<Scalars['UUID']>;
  preboardingSlide?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInput>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingResultSlideComment` being updated. */
export type UpdatePreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentEngagementTypeIdForeignPatch = {
  company?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingResult?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInput>;
  preboardingResultId?: InputMaybe<Scalars['UUID']>;
  preboardingSlide?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInput>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingResultSlideComment` being updated. */
export type UpdatePreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingResultIdForeignPatch = {
  company?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingResult?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInput>;
  preboardingSlide?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInput>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingResultSlideComment` being updated. */
export type UpdatePreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingSlideIdForeignPatch = {
  company?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingResult?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInput>;
  preboardingResultId?: InputMaybe<Scalars['UUID']>;
  preboardingSlide?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInput>;
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingResultSlideComment` being updated. */
export type UpdatePreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingUserIdForeignPatch = {
  company?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingResult?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInput>;
  preboardingResultId?: InputMaybe<Scalars['UUID']>;
  preboardingSlide?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInput>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `preboardingResultSlideComment` being updated. */
export type UpdatePreboardingResultSlideCommentOnPreboardingResultSlideCommentForPreboardingResultSlideCommentUserIdForeignPatch = {
  company?: InputMaybe<PreboardingResultSlideCommentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  edited?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<PreboardingResultSlideCommentEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  engagementType?: InputMaybe<PreboardingResultSlideCommentEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  preboardingResult?: InputMaybe<PreboardingResultSlideCommentPreboardingResultIdForeignInput>;
  preboardingResultId?: InputMaybe<Scalars['UUID']>;
  preboardingSlide?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInput>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  preboardingUserId?: InputMaybe<Scalars['UUID']>;
  public?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `preboardingSlideFormField` being updated. */
export type UpdatePreboardingSlideFormFieldOnContractSignPendingForContractSignPendingPreboardingSlideFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInverseInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingSlide?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInput>;
  preboardingSlideFormField?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldIdChInput>;
  preboardingSlideFormFieldIdParent?: InputMaybe<Scalars['UUID']>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  required?: InputMaybe<Scalars['Boolean']>;
  systemFieldName?: InputMaybe<UserEmployeeFields>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboardingSlideFormField` being updated. */
export type UpdatePreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInput>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInverseInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingSlide?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInput>;
  preboardingSlideFormField?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldIdChInput>;
  preboardingSlideFormFieldIdParent?: InputMaybe<Scalars['UUID']>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  required?: InputMaybe<Scalars['Boolean']>;
  systemFieldName?: InputMaybe<UserEmployeeFields>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboardingSlideFormField` being updated. */
export type UpdatePreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldEngagementTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInverseInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInput>;
  formField?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingSlide?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInput>;
  preboardingSlideFormField?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldIdChInput>;
  preboardingSlideFormFieldIdParent?: InputMaybe<Scalars['UUID']>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  required?: InputMaybe<Scalars['Boolean']>;
  systemFieldName?: InputMaybe<UserEmployeeFields>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboardingSlideFormField` being updated. */
export type UpdatePreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldFormFieldIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInverseInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingSlide?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInput>;
  preboardingSlideFormField?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldIdChInput>;
  preboardingSlideFormFieldIdParent?: InputMaybe<Scalars['UUID']>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  required?: InputMaybe<Scalars['Boolean']>;
  systemFieldName?: InputMaybe<UserEmployeeFields>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboardingSlideFormField` being updated. */
export type UpdatePreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldPreboardingSlideFormFieldIdChPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInverseInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingSlide?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInput>;
  preboardingSlideFormField?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldIdChInput>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  required?: InputMaybe<Scalars['Boolean']>;
  systemFieldName?: InputMaybe<UserEmployeeFields>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboardingSlideFormField` being updated. */
export type UpdatePreboardingSlideFormFieldOnPreboardingSlideFormFieldForPreboardingSlideFormFieldPreboardingSlideIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideFormFieldCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendings?: InputMaybe<ContractSignPendingPreboardingSlideFormFieldIdForeignInverseInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideFormFieldEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<PreboardingSlideFormFieldFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingSlide?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInput>;
  preboardingSlideFormField?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideFormFieldIdChInput>;
  preboardingSlideFormFieldIdParent?: InputMaybe<Scalars['UUID']>;
  required?: InputMaybe<Scalars['Boolean']>;
  systemFieldName?: InputMaybe<UserEmployeeFields>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboardingSlide` being updated. */
export type UpdatePreboardingSlideOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingSlideIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addReviewNote?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  pageDescription?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  preboarding?: InputMaybe<PreboardingSlidePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInverseInput>;
  reviewNote?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboardingSlide` being updated. */
export type UpdatePreboardingSlideOnPreboardingSlideForPreboardingSlideCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addReviewNote?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  pageDescription?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  preboarding?: InputMaybe<PreboardingSlidePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInverseInput>;
  reviewNote?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboardingSlide` being updated. */
export type UpdatePreboardingSlideOnPreboardingSlideForPreboardingSlideEngagementTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addReviewNote?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  pageDescription?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  preboarding?: InputMaybe<PreboardingSlidePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInverseInput>;
  reviewNote?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboardingSlide` being updated. */
export type UpdatePreboardingSlideOnPreboardingSlideForPreboardingSlidePreboardingIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addReviewNote?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  pageDescription?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  preboarding?: InputMaybe<PreboardingSlidePreboardingIdForeignInput>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInverseInput>;
  reviewNote?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `preboardingSlide` being updated. */
export type UpdatePreboardingSlideOnPreboardingSlideFormFieldForPreboardingSlideFormFieldPreboardingSlideIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addReviewNote?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PreboardingSlideCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  engagementType?: InputMaybe<PreboardingSlideEngagementTypeIdForeignInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  pageDescription?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  preboarding?: InputMaybe<PreboardingSlidePreboardingIdForeignInput>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  preboardingResultSlideComments?: InputMaybe<PreboardingResultSlideCommentPreboardingSlideIdForeignInverseInput>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInverseInput>;
  reviewNote?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `process` being updated. */
export type UpdateProcessOnNotificationEmployeeReferenceForNotificationEmployeeReferenceProcessIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `process` being updated. */
export type UpdateProcessOnPreboardingProcessForPreboardingProcessProcessIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `process` being updated. */
export type UpdateProcessOnProcessDepartmentForProcessDepartmentProcessIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `process` being updated. */
export type UpdateProcessOnProcessEmployeeForProcessEmployeeProcessIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `process` being updated. */
export type UpdateProcessOnProcessForProcessAssignedUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `process` being updated. */
export type UpdateProcessOnProcessForProcessEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `process` being updated. */
export type UpdateProcessOnProcessForProcessProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `process` being updated. */
export type UpdateProcessOnProcessResponsibleForProcessResponsibleProcessIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `process` being updated. */
export type UpdateProcessOnProjectForProjectProcessIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `process` being updated. */
export type UpdateProcessOnProjectTemplateForProjectTemplateProcessIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `process` being updated. */
export type UpdateProcessOnScheduledMessageForScheduledMessageProcessIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `process` being updated. */
export type UpdateProcessOnScheduledMessageTemplateForScheduledMessageTemplateProcessIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `process` being updated. */
export type UpdateProcessOnTaskForTaskProcessIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `process` being updated. */
export type UpdateProcessOnTaskTemplateForTaskTemplateProcessIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProcessIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
  processDepartments?: InputMaybe<ProcessDepartmentProcessIdForeignInverseInput>;
  processEmployees?: InputMaybe<ProcessEmployeeProcessIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  processType?: InputMaybe<ProcessProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  template?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProcessAssignedUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `processResponsible` being updated. */
export type UpdateProcessResponsibleOnProcessResponsibleForProcessResponsibleCompanyIdFkeyPatch = {
  company?: InputMaybe<ProcessResponsibleCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessResponsibleResponsibleIdForeignInput>;
  process?: InputMaybe<ProcessResponsibleProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  responsibleUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `processResponsible` being updated. */
export type UpdateProcessResponsibleOnProcessResponsibleForProcessResponsibleProcessIdForeignPatch = {
  company?: InputMaybe<ProcessResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessResponsibleResponsibleIdForeignInput>;
  process?: InputMaybe<ProcessResponsibleProcessIdForeignInput>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  responsibleUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `processResponsible` being updated. */
export type UpdateProcessResponsibleOnProcessResponsibleForProcessResponsibleResponsibleIdForeignPatch = {
  company?: InputMaybe<ProcessResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessResponsibleResponsibleIdForeignInput>;
  process?: InputMaybe<ProcessResponsibleProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  responsibleUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `processResponsible` being updated. */
export type UpdateProcessResponsibleOnProcessResponsibleForProcessResponsibleResponsibleUserIdFkeyPatch = {
  company?: InputMaybe<ProcessResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProcessResponsibleResponsibleIdForeignInput>;
  process?: InputMaybe<ProcessResponsibleProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  responsibleUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  user?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `processType` being updated. */
export type UpdateProcessTypeOnProcessForProcessProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `processType` being updated. */
export type UpdateProcessTypeOnProcessTypeForProcessTypeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `processType` being updated. */
export type UpdateProcessTypeOnProjectForProjectProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `processType` being updated. */
export type UpdateProcessTypeOnProjectTemplateForProjectTemplateProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `processType` being updated. */
export type UpdateProcessTypeOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `processType` being updated. */
export type UpdateProcessTypeOnScheduledMessageForScheduledMessageProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `processType` being updated. */
export type UpdateProcessTypeOnScheduledMessageRecipientForScheduledMessageRecipientProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `processType` being updated. */
export type UpdateProcessTypeOnScheduledMessageTemplateForScheduledMessageTemplateProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `processType` being updated. */
export type UpdateProcessTypeOnStorageForStorageProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `processType` being updated. */
export type UpdateProcessTypeOnTaskEmployeeForTaskEmployeeProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `processType` being updated. */
export type UpdateProcessTypeOnTaskForTaskProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `processType` being updated. */
export type UpdateProcessTypeOnTaskResponsibleForTaskResponsibleProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `processType` being updated. */
export type UpdateProcessTypeOnTaskTemplateForTaskTemplateProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProcessTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  processes?: InputMaybe<ProcessProcessTypeIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessTypeIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessTypeIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProcessTypeIdForeignInverseInput>;
  taskEmployees?: InputMaybe<TaskEmployeeProcessTypeIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleProcessTypeIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessTypeIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `product` being updated. */
export type UpdateProductOnEquipmentForEquipmentProductIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ProductDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<EquipmentProductIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInverseInput>;
  productType?: InputMaybe<ProductProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  searchTerms?: InputMaybe<Scalars['FullText']>;
  serial?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProductAssignedUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `product` being updated. */
export type UpdateProductOnFormFieldEntryForFormFieldEntryProductIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ProductDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<EquipmentProductIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInverseInput>;
  productType?: InputMaybe<ProductProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  searchTerms?: InputMaybe<Scalars['FullText']>;
  serial?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProductAssignedUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `product` being updated. */
export type UpdateProductOnNotificationEmployeeReferenceForNotificationEmployeeReferenceProductIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ProductDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<EquipmentProductIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInverseInput>;
  productType?: InputMaybe<ProductProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  searchTerms?: InputMaybe<Scalars['FullText']>;
  serial?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProductAssignedUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `product` being updated. */
export type UpdateProductOnProductForProductAssignedUserIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ProductDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<EquipmentProductIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInverseInput>;
  productType?: InputMaybe<ProductProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  searchTerms?: InputMaybe<Scalars['FullText']>;
  serial?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProductAssignedUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `product` being updated. */
export type UpdateProductOnProductForProductDepartmentIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ProductDepartmentIdForeignInput>;
  description?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<EquipmentProductIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInverseInput>;
  productType?: InputMaybe<ProductProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  searchTerms?: InputMaybe<Scalars['FullText']>;
  serial?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProductAssignedUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `product` being updated. */
export type UpdateProductOnProductForProductProductTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ProductDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<EquipmentProductIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInverseInput>;
  productType?: InputMaybe<ProductProductTypeIdForeignInput>;
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  searchTerms?: InputMaybe<Scalars['FullText']>;
  serial?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProductAssignedUserIdFkeyInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `product` being updated. */
export type UpdateProductOnProductForProductUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  department?: InputMaybe<ProductDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  equipment?: InputMaybe<EquipmentProductIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceProductIdForeignInverseInput>;
  productType?: InputMaybe<ProductProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  searchTerms?: InputMaybe<Scalars['FullText']>;
  serial?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ProductAssignedUserIdFkeyInput>;
};

/** An object where the defined keys will be set on the `productType` being updated. */
export type UpdateProductTypeOnEquipmentForEquipmentProductTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  equipment?: InputMaybe<EquipmentProductTypeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductProductTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `productType` being updated. */
export type UpdateProductTypeOnProductForProductProductTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  equipment?: InputMaybe<EquipmentProductTypeIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductTypeIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductProductTypeIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductTypeIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectForProjectAssignedProcessUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProjectEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessages?: InputMaybe<ScheduledMessageProjectIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  tasks?: InputMaybe<TaskProjectIdForeignInverseInput>;
  user?: InputMaybe<ProjectAssignedProcessUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectForProjectCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProjectEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessages?: InputMaybe<ScheduledMessageProjectIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  tasks?: InputMaybe<TaskProjectIdForeignInverseInput>;
  user?: InputMaybe<ProjectAssignedProcessUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectForProjectEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProjectEmployeeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessages?: InputMaybe<ScheduledMessageProjectIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  tasks?: InputMaybe<TaskProjectIdForeignInverseInput>;
  user?: InputMaybe<ProjectAssignedProcessUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectForProjectProcessIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProjectEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectProcessIdForeignInput>;
  processType?: InputMaybe<ProjectProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessages?: InputMaybe<ScheduledMessageProjectIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  tasks?: InputMaybe<TaskProjectIdForeignInverseInput>;
  user?: InputMaybe<ProjectAssignedProcessUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectForProjectProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProjectEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectProcessTypeIdForeignInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProjectIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  tasks?: InputMaybe<TaskProjectIdForeignInverseInput>;
  user?: InputMaybe<ProjectAssignedProcessUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnScheduledMessageForScheduledMessageProjectIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProjectEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessages?: InputMaybe<ScheduledMessageProjectIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  tasks?: InputMaybe<TaskProjectIdForeignInverseInput>;
  user?: InputMaybe<ProjectAssignedProcessUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnTaskForTaskProjectIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  autoArchived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ProjectEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessages?: InputMaybe<ScheduledMessageProjectIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  tasks?: InputMaybe<TaskProjectIdForeignInverseInput>;
  user?: InputMaybe<ProjectAssignedProcessUserIdForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `projectTemplate` being updated. */
export type UpdateProjectTemplateOnProjectTemplateForProjectTemplateCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectTemplateCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInverseInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplates?: InputMaybe<TaskTemplateProjectIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `projectTemplate` being updated. */
export type UpdateProjectTemplateOnProjectTemplateForProjectTemplateProcessIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectTemplateProcessIdForeignInput>;
  processType?: InputMaybe<ProjectTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInverseInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplates?: InputMaybe<TaskTemplateProjectIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `projectTemplate` being updated. */
export type UpdateProjectTemplateOnProjectTemplateForProjectTemplateProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectTemplateProcessTypeIdForeignInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInverseInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplates?: InputMaybe<TaskTemplateProjectIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `projectTemplate` being updated. */
export type UpdateProjectTemplateOnScheduledMessageTemplateForScheduledMessageTemplateProjectIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInverseInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplates?: InputMaybe<TaskTemplateProjectIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `projectTemplate` being updated. */
export type UpdateProjectTemplateOnTaskTemplateForTaskTemplateProjectIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<ProjectTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ProjectTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ProjectTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInverseInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplates?: InputMaybe<TaskTemplateProjectIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `pulseSurveyAnswer` being updated. */
export type UpdatePulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerCompanyIdForeignPatch = {
  anonymous?: InputMaybe<Scalars['Boolean']>;
  answer?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['UUID']>;
  pulseSurvey?: InputMaybe<PulseSurveyAnswerPulseSurveyIdForeignInput>;
  pulseSurveyId?: InputMaybe<Scalars['UUID']>;
  pulseType?: InputMaybe<PulseSurveyAnswerPulseTypeIdForeignInput>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<PulseSurveyAnswerUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `pulseSurveyAnswer` being updated. */
export type UpdatePulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerPulseSurveyIdForeignPatch = {
  anonymous?: InputMaybe<Scalars['Boolean']>;
  answer?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['UUID']>;
  pulseSurvey?: InputMaybe<PulseSurveyAnswerPulseSurveyIdForeignInput>;
  pulseType?: InputMaybe<PulseSurveyAnswerPulseTypeIdForeignInput>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<PulseSurveyAnswerUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `pulseSurveyAnswer` being updated. */
export type UpdatePulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerPulseTypeIdForeignPatch = {
  anonymous?: InputMaybe<Scalars['Boolean']>;
  answer?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['UUID']>;
  pulseSurvey?: InputMaybe<PulseSurveyAnswerPulseSurveyIdForeignInput>;
  pulseSurveyId?: InputMaybe<Scalars['UUID']>;
  pulseType?: InputMaybe<PulseSurveyAnswerPulseTypeIdForeignInput>;
  user?: InputMaybe<PulseSurveyAnswerUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `pulseSurveyAnswer` being updated. */
export type UpdatePulseSurveyAnswerOnPulseSurveyAnswerForPulseSurveyAnswerUserIdForeignPatch = {
  anonymous?: InputMaybe<Scalars['Boolean']>;
  answer?: InputMaybe<Scalars['JSON']>;
  company?: InputMaybe<PulseSurveyAnswerCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['UUID']>;
  pulseSurvey?: InputMaybe<PulseSurveyAnswerPulseSurveyIdForeignInput>;
  pulseSurveyId?: InputMaybe<Scalars['UUID']>;
  pulseType?: InputMaybe<PulseSurveyAnswerPulseTypeIdForeignInput>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<PulseSurveyAnswerUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `pulseSurveyChoice` being updated. */
export type UpdatePulseSurveyChoiceOnPulseSurveyChoiceForPulseSurveyChoiceCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInput>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  pulseSurvey?: InputMaybe<PulseSurveyChoicePulseSurveyIdForeignInput>;
  pulseSurveyId?: InputMaybe<Scalars['UUID']>;
  pulseType?: InputMaybe<PulseSurveyChoicePulseTypeIdForeignInput>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  textTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `pulseSurveyChoice` being updated. */
export type UpdatePulseSurveyChoiceOnPulseSurveyChoiceForPulseSurveyChoicePulseSurveyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  pulseSurvey?: InputMaybe<PulseSurveyChoicePulseSurveyIdForeignInput>;
  pulseType?: InputMaybe<PulseSurveyChoicePulseTypeIdForeignInput>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  textTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `pulseSurveyChoice` being updated. */
export type UpdatePulseSurveyChoiceOnPulseSurveyChoiceForPulseSurveyChoicePulseTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  pulseSurvey?: InputMaybe<PulseSurveyChoicePulseSurveyIdForeignInput>;
  pulseSurveyId?: InputMaybe<Scalars['UUID']>;
  pulseType?: InputMaybe<PulseSurveyChoicePulseTypeIdForeignInput>;
  textTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `pulseSurveyChoice` being updated. */
export type UpdatePulseSurveyChoiceOnPulseSurveyChoiceForPulseSurveyChoiceTextTranslatedEntityIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PulseSurveyChoiceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  pulseSurvey?: InputMaybe<PulseSurveyChoicePulseSurveyIdForeignInput>;
  pulseSurveyId?: InputMaybe<Scalars['UUID']>;
  pulseType?: InputMaybe<PulseSurveyChoicePulseTypeIdForeignInput>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  translatedEntity?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `pulseSurvey` being updated. */
export type UpdatePulseSurveyOnPulseSurveyAnswerForPulseSurveyAnswerPulseSurveyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  choiceIndicator?: InputMaybe<PulseSurveyChoiceIndicator>;
  company?: InputMaybe<PulseSurveyCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<IntervalInput>;
  endDate?: InputMaybe<Scalars['Date']>;
  highestRating?: InputMaybe<Scalars['Int']>;
  highestRatingLabel?: InputMaybe<Scalars['String']>;
  highestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  highestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  horizontal?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  lowestRating?: InputMaybe<Scalars['Int']>;
  lowestRatingLabel?: InputMaybe<Scalars['String']>;
  lowestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  lowestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseSurveyIdForeignInverseInput>;
  pulseSurveyChoiceLocalizations?: InputMaybe<Array<PulseSurveyChoiceLocalization>>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseSurveyIdForeignInverseInput>;
  pulseType?: InputMaybe<PulseSurveyPulseTypeIdForeignInput>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  question?: InputMaybe<Scalars['String']>;
  questionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  questionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  questionType?: InputMaybe<PulseSurveyQuestionType>;
  ratingType?: InputMaybe<RatingType>;
  recurrenceRule?: InputMaybe<RecurrenceRulePulseSurveyIdForeignInverseInput>;
  reminders?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  startDate?: InputMaybe<Scalars['Date']>;
  surveyTime?: InputMaybe<Scalars['Time']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  translatedEntity?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `pulseSurvey` being updated. */
export type UpdatePulseSurveyOnPulseSurveyChoiceForPulseSurveyChoicePulseSurveyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  choiceIndicator?: InputMaybe<PulseSurveyChoiceIndicator>;
  company?: InputMaybe<PulseSurveyCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<IntervalInput>;
  endDate?: InputMaybe<Scalars['Date']>;
  highestRating?: InputMaybe<Scalars['Int']>;
  highestRatingLabel?: InputMaybe<Scalars['String']>;
  highestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  highestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  horizontal?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  lowestRating?: InputMaybe<Scalars['Int']>;
  lowestRatingLabel?: InputMaybe<Scalars['String']>;
  lowestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  lowestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseSurveyIdForeignInverseInput>;
  pulseSurveyChoiceLocalizations?: InputMaybe<Array<PulseSurveyChoiceLocalization>>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseSurveyIdForeignInverseInput>;
  pulseType?: InputMaybe<PulseSurveyPulseTypeIdForeignInput>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  question?: InputMaybe<Scalars['String']>;
  questionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  questionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  questionType?: InputMaybe<PulseSurveyQuestionType>;
  ratingType?: InputMaybe<RatingType>;
  recurrenceRule?: InputMaybe<RecurrenceRulePulseSurveyIdForeignInverseInput>;
  reminders?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  startDate?: InputMaybe<Scalars['Date']>;
  surveyTime?: InputMaybe<Scalars['Time']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  translatedEntity?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `pulseSurvey` being updated. */
export type UpdatePulseSurveyOnPulseSurveyForPulseSurveyCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  choiceIndicator?: InputMaybe<PulseSurveyChoiceIndicator>;
  company?: InputMaybe<PulseSurveyCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<IntervalInput>;
  endDate?: InputMaybe<Scalars['Date']>;
  highestRating?: InputMaybe<Scalars['Int']>;
  highestRatingLabel?: InputMaybe<Scalars['String']>;
  highestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  highestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  horizontal?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  lowestRating?: InputMaybe<Scalars['Int']>;
  lowestRatingLabel?: InputMaybe<Scalars['String']>;
  lowestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  lowestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseSurveyIdForeignInverseInput>;
  pulseSurveyChoiceLocalizations?: InputMaybe<Array<PulseSurveyChoiceLocalization>>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseSurveyIdForeignInverseInput>;
  pulseType?: InputMaybe<PulseSurveyPulseTypeIdForeignInput>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  question?: InputMaybe<Scalars['String']>;
  questionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  questionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  questionType?: InputMaybe<PulseSurveyQuestionType>;
  ratingType?: InputMaybe<RatingType>;
  recurrenceRule?: InputMaybe<RecurrenceRulePulseSurveyIdForeignInverseInput>;
  reminders?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  startDate?: InputMaybe<Scalars['Date']>;
  surveyTime?: InputMaybe<Scalars['Time']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  translatedEntity?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `pulseSurvey` being updated. */
export type UpdatePulseSurveyOnPulseSurveyForPulseSurveyHighestRatingLabelTranslatedEntityIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  choiceIndicator?: InputMaybe<PulseSurveyChoiceIndicator>;
  company?: InputMaybe<PulseSurveyCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<IntervalInput>;
  endDate?: InputMaybe<Scalars['Date']>;
  highestRating?: InputMaybe<Scalars['Int']>;
  highestRatingLabel?: InputMaybe<Scalars['String']>;
  highestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  horizontal?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  lowestRating?: InputMaybe<Scalars['Int']>;
  lowestRatingLabel?: InputMaybe<Scalars['String']>;
  lowestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  lowestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseSurveyIdForeignInverseInput>;
  pulseSurveyChoiceLocalizations?: InputMaybe<Array<PulseSurveyChoiceLocalization>>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseSurveyIdForeignInverseInput>;
  pulseType?: InputMaybe<PulseSurveyPulseTypeIdForeignInput>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  question?: InputMaybe<Scalars['String']>;
  questionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  questionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  questionType?: InputMaybe<PulseSurveyQuestionType>;
  ratingType?: InputMaybe<RatingType>;
  recurrenceRule?: InputMaybe<RecurrenceRulePulseSurveyIdForeignInverseInput>;
  reminders?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  startDate?: InputMaybe<Scalars['Date']>;
  surveyTime?: InputMaybe<Scalars['Time']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  translatedEntity?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `pulseSurvey` being updated. */
export type UpdatePulseSurveyOnPulseSurveyForPulseSurveyLowestRatingLabelTranslatedEntityIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  choiceIndicator?: InputMaybe<PulseSurveyChoiceIndicator>;
  company?: InputMaybe<PulseSurveyCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<IntervalInput>;
  endDate?: InputMaybe<Scalars['Date']>;
  highestRating?: InputMaybe<Scalars['Int']>;
  highestRatingLabel?: InputMaybe<Scalars['String']>;
  highestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  highestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  horizontal?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  lowestRating?: InputMaybe<Scalars['Int']>;
  lowestRatingLabel?: InputMaybe<Scalars['String']>;
  lowestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseSurveyIdForeignInverseInput>;
  pulseSurveyChoiceLocalizations?: InputMaybe<Array<PulseSurveyChoiceLocalization>>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseSurveyIdForeignInverseInput>;
  pulseType?: InputMaybe<PulseSurveyPulseTypeIdForeignInput>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  question?: InputMaybe<Scalars['String']>;
  questionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  questionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  questionType?: InputMaybe<PulseSurveyQuestionType>;
  ratingType?: InputMaybe<RatingType>;
  recurrenceRule?: InputMaybe<RecurrenceRulePulseSurveyIdForeignInverseInput>;
  reminders?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  startDate?: InputMaybe<Scalars['Date']>;
  surveyTime?: InputMaybe<Scalars['Time']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  translatedEntity?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `pulseSurvey` being updated. */
export type UpdatePulseSurveyOnPulseSurveyForPulseSurveyNameTranslatedEntityIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  choiceIndicator?: InputMaybe<PulseSurveyChoiceIndicator>;
  company?: InputMaybe<PulseSurveyCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<IntervalInput>;
  endDate?: InputMaybe<Scalars['Date']>;
  highestRating?: InputMaybe<Scalars['Int']>;
  highestRatingLabel?: InputMaybe<Scalars['String']>;
  highestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  highestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  horizontal?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  lowestRating?: InputMaybe<Scalars['Int']>;
  lowestRatingLabel?: InputMaybe<Scalars['String']>;
  lowestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  lowestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseSurveyIdForeignInverseInput>;
  pulseSurveyChoiceLocalizations?: InputMaybe<Array<PulseSurveyChoiceLocalization>>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseSurveyIdForeignInverseInput>;
  pulseType?: InputMaybe<PulseSurveyPulseTypeIdForeignInput>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  question?: InputMaybe<Scalars['String']>;
  questionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  questionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  questionType?: InputMaybe<PulseSurveyQuestionType>;
  ratingType?: InputMaybe<RatingType>;
  recurrenceRule?: InputMaybe<RecurrenceRulePulseSurveyIdForeignInverseInput>;
  reminders?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  startDate?: InputMaybe<Scalars['Date']>;
  surveyTime?: InputMaybe<Scalars['Time']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  translatedEntity?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `pulseSurvey` being updated. */
export type UpdatePulseSurveyOnPulseSurveyForPulseSurveyPulseTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  choiceIndicator?: InputMaybe<PulseSurveyChoiceIndicator>;
  company?: InputMaybe<PulseSurveyCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<IntervalInput>;
  endDate?: InputMaybe<Scalars['Date']>;
  highestRating?: InputMaybe<Scalars['Int']>;
  highestRatingLabel?: InputMaybe<Scalars['String']>;
  highestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  highestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  horizontal?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  lowestRating?: InputMaybe<Scalars['Int']>;
  lowestRatingLabel?: InputMaybe<Scalars['String']>;
  lowestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  lowestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseSurveyIdForeignInverseInput>;
  pulseSurveyChoiceLocalizations?: InputMaybe<Array<PulseSurveyChoiceLocalization>>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseSurveyIdForeignInverseInput>;
  pulseType?: InputMaybe<PulseSurveyPulseTypeIdForeignInput>;
  question?: InputMaybe<Scalars['String']>;
  questionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  questionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  questionType?: InputMaybe<PulseSurveyQuestionType>;
  ratingType?: InputMaybe<RatingType>;
  recurrenceRule?: InputMaybe<RecurrenceRulePulseSurveyIdForeignInverseInput>;
  reminders?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  startDate?: InputMaybe<Scalars['Date']>;
  surveyTime?: InputMaybe<Scalars['Time']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  translatedEntity?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `pulseSurvey` being updated. */
export type UpdatePulseSurveyOnPulseSurveyForPulseSurveyQuestionTranslatedEntityIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  choiceIndicator?: InputMaybe<PulseSurveyChoiceIndicator>;
  company?: InputMaybe<PulseSurveyCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<IntervalInput>;
  endDate?: InputMaybe<Scalars['Date']>;
  highestRating?: InputMaybe<Scalars['Int']>;
  highestRatingLabel?: InputMaybe<Scalars['String']>;
  highestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  highestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  horizontal?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  lowestRating?: InputMaybe<Scalars['Int']>;
  lowestRatingLabel?: InputMaybe<Scalars['String']>;
  lowestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  lowestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseSurveyIdForeignInverseInput>;
  pulseSurveyChoiceLocalizations?: InputMaybe<Array<PulseSurveyChoiceLocalization>>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseSurveyIdForeignInverseInput>;
  pulseType?: InputMaybe<PulseSurveyPulseTypeIdForeignInput>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  question?: InputMaybe<Scalars['String']>;
  questionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  questionType?: InputMaybe<PulseSurveyQuestionType>;
  ratingType?: InputMaybe<RatingType>;
  recurrenceRule?: InputMaybe<RecurrenceRulePulseSurveyIdForeignInverseInput>;
  reminders?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  startDate?: InputMaybe<Scalars['Date']>;
  surveyTime?: InputMaybe<Scalars['Time']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  translatedEntity?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `pulseSurvey` being updated. */
export type UpdatePulseSurveyOnRecurrenceRuleForRecurrenceRulePulseSurveyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  choiceIndicator?: InputMaybe<PulseSurveyChoiceIndicator>;
  company?: InputMaybe<PulseSurveyCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<IntervalInput>;
  endDate?: InputMaybe<Scalars['Date']>;
  highestRating?: InputMaybe<Scalars['Int']>;
  highestRatingLabel?: InputMaybe<Scalars['String']>;
  highestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  highestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  horizontal?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  invitedDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  invitedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  lowestRating?: InputMaybe<Scalars['Int']>;
  lowestRatingLabel?: InputMaybe<Scalars['String']>;
  lowestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  lowestRatingLabelTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseSurveyIdForeignInverseInput>;
  pulseSurveyChoiceLocalizations?: InputMaybe<Array<PulseSurveyChoiceLocalization>>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseSurveyIdForeignInverseInput>;
  pulseType?: InputMaybe<PulseSurveyPulseTypeIdForeignInput>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  question?: InputMaybe<Scalars['String']>;
  questionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  questionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  questionType?: InputMaybe<PulseSurveyQuestionType>;
  ratingType?: InputMaybe<RatingType>;
  recurrenceRule?: InputMaybe<RecurrenceRulePulseSurveyIdForeignInverseInput>;
  reminders?: InputMaybe<Array<InputMaybe<IntervalInput>>>;
  startDate?: InputMaybe<Scalars['Date']>;
  surveyTime?: InputMaybe<Scalars['Time']>;
  timezoneName?: InputMaybe<Scalars['String']>;
  translatedEntity?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `pulseType` being updated. */
export type UpdatePulseTypeOnPulseSurveyAnswerForPulseSurveyAnswerPulseTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PulseTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseTypeIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseTypeIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyPulseTypeIdForeignInverseInput>;
  translatedEntity?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `pulseType` being updated. */
export type UpdatePulseTypeOnPulseSurveyChoiceForPulseSurveyChoicePulseTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PulseTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseTypeIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseTypeIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyPulseTypeIdForeignInverseInput>;
  translatedEntity?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `pulseType` being updated. */
export type UpdatePulseTypeOnPulseSurveyForPulseSurveyPulseTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PulseTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseTypeIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseTypeIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyPulseTypeIdForeignInverseInput>;
  translatedEntity?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `pulseType` being updated. */
export type UpdatePulseTypeOnPulseTypeForPulseTypeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PulseTypeCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseTypeIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseTypeIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyPulseTypeIdForeignInverseInput>;
  translatedEntity?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `pulseType` being updated. */
export type UpdatePulseTypeOnPulseTypeForPulseTypeNameTranslatedEntityIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<PulseTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerPulseTypeIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoicePulseTypeIdForeignInverseInput>;
  pulseSurveys?: InputMaybe<PulseSurveyPulseTypeIdForeignInverseInput>;
  translatedEntity?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `pushToken` being updated. */
export type UpdatePushTokenOnPushTokenForPushTokenUserIdForeignPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  token?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PushTokenUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `rank` being updated. */
export type UpdateRankOnUserDepartmentForUserDepartmentRankIdForeignPatch = {
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  userDepartments?: InputMaybe<UserDepartmentRankIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `recurrenceRule` being updated. */
export type UpdateRecurrenceRuleOnRecurrenceRuleForRecurrenceRuleCompanyIdForeignPatch = {
  company?: InputMaybe<RecurrenceRuleCompanyIdForeignInput>;
  daysOfMonth?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  daysOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  frequency?: InputMaybe<RecurrenceRuleFrequency>;
  id?: InputMaybe<Scalars['UUID']>;
  interval?: InputMaybe<Scalars['Int']>;
  maxNumberOfOccurences?: InputMaybe<Scalars['Int']>;
  monthsOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  pulseSurvey?: InputMaybe<RecurrenceRulePulseSurveyIdForeignInput>;
  pulseSurveyId?: InputMaybe<Scalars['UUID']>;
  setPosition?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weeksOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** An object where the defined keys will be set on the `recurrenceRule` being updated. */
export type UpdateRecurrenceRuleOnRecurrenceRuleForRecurrenceRulePulseSurveyIdForeignPatch = {
  company?: InputMaybe<RecurrenceRuleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  daysOfMonth?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  daysOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  frequency?: InputMaybe<RecurrenceRuleFrequency>;
  id?: InputMaybe<Scalars['UUID']>;
  interval?: InputMaybe<Scalars['Int']>;
  maxNumberOfOccurences?: InputMaybe<Scalars['Int']>;
  monthsOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  pulseSurvey?: InputMaybe<RecurrenceRulePulseSurveyIdForeignInput>;
  setPosition?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  weeksOfYear?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** An object where the defined keys will be set on the `referenceToken` being updated. */
export type UpdateReferenceTokenOnReferenceTokenForReferenceTokenCompanyIdFkeyPatch = {
  company?: InputMaybe<ReferenceTokenCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  token?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<ReferenceTokenUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `referenceToken` being updated. */
export type UpdateReferenceTokenOnReferenceTokenForReferenceTokenUserIdForeignPatch = {
  company?: InputMaybe<ReferenceTokenCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  token?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<ReferenceTokenUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `relationRole` being updated. */
export type UpdateRelationRoleOnRelationRoleForRelationRoleCompanyIdForeignPatch = {
  company?: InputMaybe<RelationRoleCompanyIdForeignInput>;
  formField?: InputMaybe<RelationRoleFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<RelationRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<RelationRoleSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `relationRole` being updated. */
export type UpdateRelationRoleOnRelationRoleForRelationRoleFormFieldIdForeignPatch = {
  company?: InputMaybe<RelationRoleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<RelationRoleFormFieldIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<RelationRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<RelationRoleSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `relationRole` being updated. */
export type UpdateRelationRoleOnRelationRoleForRelationRoleRoleIdForeignPatch = {
  company?: InputMaybe<RelationRoleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<RelationRoleFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<RelationRoleRoleIdForeignInput>;
  systemField?: InputMaybe<RelationRoleSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `relationRole` being updated. */
export type UpdateRelationRoleOnRelationRoleForRelationRoleSystemFieldIdForeignPatch = {
  company?: InputMaybe<RelationRoleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  formField?: InputMaybe<RelationRoleFormFieldIdForeignInput>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<RelationRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  systemField?: InputMaybe<RelationRoleSystemFieldIdForeignInput>;
};

/** An object where the defined keys will be set on the `roadmapItemComment` being updated. */
export type UpdateRoadmapItemCommentOnRoadmapItemCommentForRoadmapItemCommentRoadmapItemIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  oldUser?: InputMaybe<RoadmapItemCommentUserIdForeignInput>;
  roadmapItem?: InputMaybe<RoadmapItemCommentRoadmapItemIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roadmapItemComment` being updated. */
export type UpdateRoadmapItemCommentOnRoadmapItemCommentForRoadmapItemCommentUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  oldUser?: InputMaybe<RoadmapItemCommentUserIdForeignInput>;
  roadmapItem?: InputMaybe<RoadmapItemCommentRoadmapItemIdForeignInput>;
  roadmapItemId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roadmapItemLocalization` being updated. */
export type UpdateRoadmapItemLocalizationOnRoadmapItemLocalizationForRoadmapItemLocalizationRoadmapItemIdForeignPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  roadmapItem?: InputMaybe<RoadmapItemLocalizationRoadmapItemIdForeignInput>;
  summary?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `roadmapItem` being updated. */
export type UpdateRoadmapItemOnRoadmapItemCommentForRoadmapItemCommentRoadmapItemIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentRoadmapItemIdForeignInverseInput>;
  roadmapItemLocalizations?: InputMaybe<RoadmapItemLocalizationRoadmapItemIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteRoadmapItemIdForeignInverseInput>;
  stage?: InputMaybe<RoadmapStage>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `roadmapItem` being updated. */
export type UpdateRoadmapItemOnRoadmapItemLocalizationForRoadmapItemLocalizationRoadmapItemIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentRoadmapItemIdForeignInverseInput>;
  roadmapItemLocalizations?: InputMaybe<RoadmapItemLocalizationRoadmapItemIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteRoadmapItemIdForeignInverseInput>;
  stage?: InputMaybe<RoadmapStage>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `roadmapItem` being updated. */
export type UpdateRoadmapItemOnRoadmapItemVoteForRoadmapItemVoteRoadmapItemIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentRoadmapItemIdForeignInverseInput>;
  roadmapItemLocalizations?: InputMaybe<RoadmapItemLocalizationRoadmapItemIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteRoadmapItemIdForeignInverseInput>;
  stage?: InputMaybe<RoadmapStage>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `roadmapItemVote` being updated. */
export type UpdateRoadmapItemVoteOnRoadmapItemVoteForRoadmapItemVoteRoadmapItemIdForeignPatch = {
  id?: InputMaybe<Scalars['UUID']>;
  roadmapItem?: InputMaybe<RoadmapItemVoteRoadmapItemIdForeignInput>;
  user?: InputMaybe<RoadmapItemVoteUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  voteType?: InputMaybe<RoadmapItemVoteType>;
};

/** An object where the defined keys will be set on the `roadmapItemVote` being updated. */
export type UpdateRoadmapItemVoteOnRoadmapItemVoteForRoadmapItemVoteUserIdForeignPatch = {
  id?: InputMaybe<Scalars['UUID']>;
  roadmapItem?: InputMaybe<RoadmapItemVoteRoadmapItemIdForeignInput>;
  roadmapItemId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<RoadmapItemVoteUserIdForeignInput>;
  voteType?: InputMaybe<RoadmapItemVoteType>;
};

/** An object where the defined keys will be set on the `roleDependency` being updated. */
export type UpdateRoleDependencyOnRoleDependencyForRoleDependencyDependentOnForeignPatch = {
  role?: InputMaybe<RoleDependencyDependentOnForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `roleDependency` being updated. */
export type UpdateRoleDependencyOnRoleDependencyForRoleDependencyRoleIdForeignPatch = {
  dependentOn?: InputMaybe<Scalars['UUID']>;
  role?: InputMaybe<RoleDependencyDependentOnForeignInput>;
};

/** An object where the defined keys will be set on the `role` being updated. */
export type UpdateRoleOnGroupRoleForGroupRoleRoleIdForeignPatch = {
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleRoleIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  info?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  relationRoles?: InputMaybe<RelationRoleRoleIdForeignInverseInput>;
  roleDependenciesToDependentOnUsingId?: InputMaybe<RoleDependencyDependentOnForeignInverseInput>;
  roleDependenciesToRoleIdUsingId?: InputMaybe<RoleDependencyRoleIdForeignInverseInput>;
  scopes?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleRoleIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleRoleIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleRoleIdForeignInverseInput>;
  usesItemIds?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `role` being updated. */
export type UpdateRoleOnRelationRoleForRelationRoleRoleIdForeignPatch = {
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleRoleIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  info?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  relationRoles?: InputMaybe<RelationRoleRoleIdForeignInverseInput>;
  roleDependenciesToDependentOnUsingId?: InputMaybe<RoleDependencyDependentOnForeignInverseInput>;
  roleDependenciesToRoleIdUsingId?: InputMaybe<RoleDependencyRoleIdForeignInverseInput>;
  scopes?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleRoleIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleRoleIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleRoleIdForeignInverseInput>;
  usesItemIds?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `role` being updated. */
export type UpdateRoleOnRoleDependencyForRoleDependencyDependentOnForeignPatch = {
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleRoleIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  info?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  relationRoles?: InputMaybe<RelationRoleRoleIdForeignInverseInput>;
  roleDependenciesToDependentOnUsingId?: InputMaybe<RoleDependencyDependentOnForeignInverseInput>;
  roleDependenciesToRoleIdUsingId?: InputMaybe<RoleDependencyRoleIdForeignInverseInput>;
  scopes?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleRoleIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleRoleIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleRoleIdForeignInverseInput>;
  usesItemIds?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `role` being updated. */
export type UpdateRoleOnUserCompanyRoleForUserCompanyRoleRoleIdForeignPatch = {
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleRoleIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  info?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  relationRoles?: InputMaybe<RelationRoleRoleIdForeignInverseInput>;
  roleDependenciesToDependentOnUsingId?: InputMaybe<RoleDependencyDependentOnForeignInverseInput>;
  roleDependenciesToRoleIdUsingId?: InputMaybe<RoleDependencyRoleIdForeignInverseInput>;
  scopes?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleRoleIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleRoleIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleRoleIdForeignInverseInput>;
  usesItemIds?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `role` being updated. */
export type UpdateRoleOnUserDepartmentRoleForUserDepartmentRoleRoleIdForeignPatch = {
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleRoleIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  info?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  relationRoles?: InputMaybe<RelationRoleRoleIdForeignInverseInput>;
  roleDependenciesToDependentOnUsingId?: InputMaybe<RoleDependencyDependentOnForeignInverseInput>;
  roleDependenciesToRoleIdUsingId?: InputMaybe<RoleDependencyRoleIdForeignInverseInput>;
  scopes?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleRoleIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleRoleIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleRoleIdForeignInverseInput>;
  usesItemIds?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `role` being updated. */
export type UpdateRoleOnUserRoleForUserRoleRoleIdForeignPatch = {
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  groupRoles?: InputMaybe<GroupRoleRoleIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  info?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  relationRoles?: InputMaybe<RelationRoleRoleIdForeignInverseInput>;
  roleDependenciesToDependentOnUsingId?: InputMaybe<RoleDependencyDependentOnForeignInverseInput>;
  roleDependenciesToRoleIdUsingId?: InputMaybe<RoleDependencyRoleIdForeignInverseInput>;
  scopes?: InputMaybe<Array<InputMaybe<RoleScope>>>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleRoleIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleRoleIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleRoleIdForeignInverseInput>;
  usesItemIds?: InputMaybe<Scalars['Boolean']>;
};

/** An object where the defined keys will be set on the `savedSignature` being updated. */
export type UpdateSavedSignatureOnSavedSignatureForSavedSignatureEmployeeIdForeignPatch = {
  employee?: InputMaybe<SavedSignatureEmployeeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<SavedSignatureStorageIdForeignInput>;
  storageId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `savedSignature` being updated. */
export type UpdateSavedSignatureOnSavedSignatureForSavedSignatureStorageIdForeignPatch = {
  employee?: InputMaybe<SavedSignatureEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  storage?: InputMaybe<SavedSignatureStorageIdForeignInput>;
};

/** An object where the defined keys will be set on the `scheduledMessageExternalRecipient` being updated. */
export type UpdateScheduledMessageExternalRecipientOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientCompanyIdForeignPatch = {
  company?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInput>;
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  processType?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessage?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInput>;
  scheduledMessageId?: InputMaybe<Scalars['UUID']>;
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `scheduledMessageExternalRecipient` being updated. */
export type UpdateScheduledMessageExternalRecipientOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientProcessTypeIdForeignPatch = {
  company?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  processType?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInput>;
  scheduledMessage?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInput>;
  scheduledMessageId?: InputMaybe<Scalars['UUID']>;
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `scheduledMessageExternalRecipient` being updated. */
export type UpdateScheduledMessageExternalRecipientOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientScheduledMessageIdForeiPatch = {
  company?: InputMaybe<ScheduledMessageExternalRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  processType?: InputMaybe<ScheduledMessageExternalRecipientProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessage?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInput>;
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `scheduledMessage` being updated. */
export type UpdateScheduledMessageOnScheduledMessageExternalRecipientForScheduledMessageExternalRecipientScheduledMessageIdForeiPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `scheduledMessage` being updated. */
export type UpdateScheduledMessageOnScheduledMessageForScheduledMessageAssignedProcessUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `scheduledMessage` being updated. */
export type UpdateScheduledMessageOnScheduledMessageForScheduledMessageCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `scheduledMessage` being updated. */
export type UpdateScheduledMessageOnScheduledMessageForScheduledMessageEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `scheduledMessage` being updated. */
export type UpdateScheduledMessageOnScheduledMessageForScheduledMessageProcessIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `scheduledMessage` being updated. */
export type UpdateScheduledMessageOnScheduledMessageForScheduledMessageProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `scheduledMessage` being updated. */
export type UpdateScheduledMessageOnScheduledMessageForScheduledMessageProjectIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `scheduledMessage` being updated. */
export type UpdateScheduledMessageOnScheduledMessageForScheduledMessageSenderEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `scheduledMessage` being updated. */
export type UpdateScheduledMessageOnScheduledMessageRecipientForScheduledMessageRecipientScheduledMessageIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<ScheduledMessageCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<ScheduledMessageProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  senderEmployeeId?: InputMaybe<Scalars['UUID']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `scheduledMessageRecipient` being updated. */
export type UpdateScheduledMessageRecipientOnScheduledMessageRecipientForScheduledMessageRecipientCompanyIdForeignPatch = {
  company?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessage?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInput>;
  scheduledMessageId?: InputMaybe<Scalars['UUID']>;
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `scheduledMessageRecipient` being updated. */
export type UpdateScheduledMessageRecipientOnScheduledMessageRecipientForScheduledMessageRecipientEmployeeIdForeignPatch = {
  company?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInput>;
  processType?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessage?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInput>;
  scheduledMessageId?: InputMaybe<Scalars['UUID']>;
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `scheduledMessageRecipient` being updated. */
export type UpdateScheduledMessageRecipientOnScheduledMessageRecipientForScheduledMessageRecipientProcessTypeIdForeignPatch = {
  company?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInput>;
  scheduledMessage?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInput>;
  scheduledMessageId?: InputMaybe<Scalars['UUID']>;
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `scheduledMessageRecipient` being updated. */
export type UpdateScheduledMessageRecipientOnScheduledMessageRecipientForScheduledMessageRecipientScheduledMessageIdForeignPatch = {
  company?: InputMaybe<ScheduledMessageRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageRecipientEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageRecipientProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessage?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInput>;
  sentDate?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `scheduledMessageTemplateExternalRecipient` being updated. */
export type UpdateScheduledMessageTemplateExternalRecipientOnScheduledMessageTemplateExternalRecipientForScheduledMessageTemplateExternalRecipientCompanyIdForeigPatch = {
  company?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInput>;
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  scheduledMessageTemplate?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInput>;
  scheduledMessageTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `scheduledMessageTemplateExternalRecipient` being updated. */
export type UpdateScheduledMessageTemplateExternalRecipientOnScheduledMessageTemplateExternalRecipientForScheduledMessageTemplateExternalRecipientScheduledMessagePatch = {
  company?: InputMaybe<ScheduledMessageTemplateExternalRecipientCompanyIdForeigInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  scheduledMessageTemplate?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInput>;
};

/** An object where the defined keys will be set on the `scheduledMessageTemplate` being updated. */
export type UpdateScheduledMessageTemplateOnScheduledMessageTemplateExternalRecipientForScheduledMessageTemplateExternalRecipientScheduledMessagePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `scheduledMessageTemplate` being updated. */
export type UpdateScheduledMessageTemplateOnScheduledMessageTemplateForScheduledMessageTemplateCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `scheduledMessageTemplate` being updated. */
export type UpdateScheduledMessageTemplateOnScheduledMessageTemplateForScheduledMessageTemplateProcessIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInput>;
  processType?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `scheduledMessageTemplate` being updated. */
export type UpdateScheduledMessageTemplateOnScheduledMessageTemplateForScheduledMessageTemplateProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `scheduledMessageTemplate` being updated. */
export type UpdateScheduledMessageTemplateOnScheduledMessageTemplateForScheduledMessageTemplateProjectIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `scheduledMessageTemplate` being updated. */
export type UpdateScheduledMessageTemplateOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientScheduledMessageTemplatePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<ScheduledMessageTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<ScheduledMessageTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<ScheduledMessageTemplateProjectIdForeignInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `scheduledMessageTemplateRecipient` being updated. */
export type UpdateScheduledMessageTemplateRecipientOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientCompanyIdForeignPatch = {
  company?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageTemplate?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInput>;
  scheduledMessageTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `scheduledMessageTemplateRecipient` being updated. */
export type UpdateScheduledMessageTemplateRecipientOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientEmployeeIdForeignPatch = {
  company?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInput>;
  scheduledMessageTemplate?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInput>;
  scheduledMessageTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `scheduledMessageTemplateRecipient` being updated. */
export type UpdateScheduledMessageTemplateRecipientOnScheduledMessageTemplateRecipientForScheduledMessageTemplateRecipientScheduledMessageTemplatePatch = {
  company?: InputMaybe<ScheduledMessageTemplateRecipientCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<ScheduledMessageTemplateRecipientEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageTemplate?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInput>;
};

/** An object where the defined keys will be set on the `storage` being updated. */
export type UpdateStorageOnAuthAppForAuthAppStorageIdFkeyPatch = {
  access?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path?: InputMaybe<Scalars['String']>;
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `storage` being updated. */
export type UpdateStorageOnCompanySettingForCompanySettingValueStorageIdForeignPatch = {
  access?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path?: InputMaybe<Scalars['String']>;
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `storage` being updated. */
export type UpdateStorageOnContractSignPendingDocumentForContractSignPendingDocumentExistingStorageIdForeignPatch = {
  access?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path?: InputMaybe<Scalars['String']>;
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `storage` being updated. */
export type UpdateStorageOnContractSignPendingSignerForContractSignPendingSignerSignatureFileIdForeignPatch = {
  access?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path?: InputMaybe<Scalars['String']>;
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `storage` being updated. */
export type UpdateStorageOnDocumentDepartmentPermissionForDocumentDepartmentPermissionsFileIdForeignPatch = {
  access?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path?: InputMaybe<Scalars['String']>;
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `storage` being updated. */
export type UpdateStorageOnDocumentUserPermissionForDocumentUserPermissionsFileIdForeignPatch = {
  access?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path?: InputMaybe<Scalars['String']>;
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `storage` being updated. */
export type UpdateStorageOnDocumentUserResponsibleForDocumentUserResponsibleFileIdForeignPatch = {
  access?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path?: InputMaybe<Scalars['String']>;
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `storage` being updated. */
export type UpdateStorageOnIntegrationFieldMarkingForIntegrationFieldMarkingStorageIdFkeyPatch = {
  access?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path?: InputMaybe<Scalars['String']>;
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `storage` being updated. */
export type UpdateStorageOnNotificationEmployeeReferenceForNotificationEmployeeReferenceFileIdForeignPatch = {
  access?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path?: InputMaybe<Scalars['String']>;
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `storage` being updated. */
export type UpdateStorageOnSavedSignatureForSavedSignatureStorageIdForeignPatch = {
  access?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path?: InputMaybe<Scalars['String']>;
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `storage` being updated. */
export type UpdateStorageOnStorageForStorageContractSignPendingDocumentIdForeignPatch = {
  access?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path?: InputMaybe<Scalars['String']>;
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `storage` being updated. */
export type UpdateStorageOnStorageForStorageDocumentFolderIdForeignPatch = {
  access?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path?: InputMaybe<Scalars['String']>;
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `storage` being updated. */
export type UpdateStorageOnStorageForStorageDocumentTemplateIdForeignPatch = {
  access?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path?: InputMaybe<Scalars['String']>;
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `storage` being updated. */
export type UpdateStorageOnStorageForStorageDocumentTypeIdForeignPatch = {
  access?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path?: InputMaybe<Scalars['String']>;
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `storage` being updated. */
export type UpdateStorageOnStorageForStorageEmployeeCasefileIdForeignPatch = {
  access?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path?: InputMaybe<Scalars['String']>;
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `storage` being updated. */
export type UpdateStorageOnStorageForStorageProcessTypeIdForeignPatch = {
  access?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path?: InputMaybe<Scalars['String']>;
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `storage` being updated. */
export type UpdateStorageOnStorageForStorageRootDocumentFolderBlueprintIdForeignPatch = {
  access?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  authApps?: InputMaybe<AuthAppStorageIdFkeyInverseInput>;
  base64?: InputMaybe<Scalars['String']>;
  belongsToLeader?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySettings?: InputMaybe<CompanySettingValueStorageIdForeignInverseInput>;
  contractSignPendingDocument?: InputMaybe<StorageContractSignPendingDocumentIdForeignInput>;
  contractSignPendingDocumentId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingDocuments?: InputMaybe<ContractSignPendingDocumentExistingStorageIdForeignInverseInput>;
  contractSignPendingSigners?: InputMaybe<ContractSignPendingSignerSignatureFileIdForeignInverseInput>;
  contractTemplate?: InputMaybe<StorageDocumentTemplateIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentDepartmentPermissions?: InputMaybe<DocumentDepartmentPermissionsFileIdForeignInverseInput>;
  documentFolder?: InputMaybe<StorageDocumentFolderIdForeignInput>;
  documentFolderBlueprint?: InputMaybe<StorageRootDocumentFolderBlueprintIdForeignInput>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  documentType?: InputMaybe<StorageDocumentTypeIdForeignInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsFileIdForeignInverseInput>;
  documentUserResponsibles?: InputMaybe<DocumentUserResponsibleFileIdForeignInverseInput>;
  employeeCasefile?: InputMaybe<StorageEmployeeCasefileIdForeignInput>;
  employeeCasefileId?: InputMaybe<Scalars['UUID']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  expiredReminded?: InputMaybe<Scalars['Boolean']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  fileType?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderDepartmentIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderOwnerId?: InputMaybe<Scalars['UUID']>;
  folderUserIdsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingStorageIdFkeyInverseInput>;
  mimetype?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceFileIdForeignInverseInput>;
  path?: InputMaybe<Scalars['String']>;
  penneoDocumentId?: InputMaybe<Scalars['String']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  processType?: InputMaybe<StorageProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  productType?: InputMaybe<StorageProductTypeIdForeignInput>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  productUserId?: InputMaybe<Scalars['UUID']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  savedSignatures?: InputMaybe<SavedSignatureStorageIdForeignInverseInput>;
  templatingServiceId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<StorageProductUserIdForeignInput>;
  usersResponsible?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  usersSharedWithDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `superUserAllowedUser` being updated. */
export type UpdateSuperUserAllowedUserOnSuperUserAllowedUserForSuperUserAllowedUsersCompanyIdForeignPatch = {
  allowedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  company?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInput>;
  disallowedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  superUser?: InputMaybe<SuperUserAllowedUsersSuperUserIdForeignInput>;
  superUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `superUserAllowedUser` being updated. */
export type UpdateSuperUserAllowedUserOnSuperUserAllowedUserForSuperUserAllowedUsersSuperUserIdForeignPatch = {
  allowedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  company?: InputMaybe<SuperUserAllowedUsersCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  disallowedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  superUser?: InputMaybe<SuperUserAllowedUsersSuperUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `superUserLoginNote` being updated. */
export type UpdateSuperUserLoginNoteOnSuperUserLoginNoteForSuperUserLoginNoteLoginLogIdForeignPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  loginLog?: InputMaybe<SuperUserLoginNoteLoginLogIdForeignInput>;
  note?: InputMaybe<Scalars['String']>;
  superUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `superUserLoginNote` being updated. */
export type UpdateSuperUserLoginNoteOnSuperUserLoginNoteForSuperUserLoginNoteSuperUserIdForeignPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  loginLog?: InputMaybe<SuperUserLoginNoteLoginLogIdForeignInput>;
  loginLogId?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `superUserLoginNote` being updated. */
export type UpdateSuperUserLoginNoteOnSuperUserLoginNoteForSuperUserLoginNoteUserIdForeignPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  loginLog?: InputMaybe<SuperUserLoginNoteLoginLogIdForeignInput>;
  loginLogId?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  superUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `superUser` being updated. */
export type UpdateSuperUserOnSuperUserAllowedUserForSuperUserAllowedUsersSuperUserIdForeignPatch = {
  companyBlacklist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  companyWhitelist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersSuperUserIdForeignInverseInput>;
  user?: InputMaybe<SuperUserUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `superUser` being updated. */
export type UpdateSuperUserOnSuperUserForSuperUserUserIdForeignPatch = {
  companyBlacklist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  companyWhitelist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  superUserAllowedUsers?: InputMaybe<SuperUserAllowedUsersSuperUserIdForeignInverseInput>;
  user?: InputMaybe<SuperUserUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `systemField` being updated. */
export type UpdateSystemFieldOnCompanySystemFieldForCompanySystemFieldSystemFieldIdForeignPatch = {
  alwaysRequired?: InputMaybe<Scalars['Boolean']>;
  companySystemFields?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingSystemFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInverseInput>;
  documentTemplatePlaceholderName?: InputMaybe<Scalars['String']>;
  excludeFromPlaceholderForm?: InputMaybe<Scalars['Boolean']>;
  futureData?: InputMaybe<FutureDataSystemFieldIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  readableName?: InputMaybe<Scalars['String']>;
  relationRoles?: InputMaybe<RelationRoleSystemFieldIdForeignInverseInput>;
  systemFieldType?: InputMaybe<SystemFieldTypeForeignInput>;
  type?: InputMaybe<Scalars['String']>;
  userSystemFields?: InputMaybe<UserSystemFieldSystemFieldIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `systemField` being updated. */
export type UpdateSystemFieldOnCvTemplateFieldMappingForCvTemplateFieldMappingSystemFieldIdForeignPatch = {
  alwaysRequired?: InputMaybe<Scalars['Boolean']>;
  companySystemFields?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingSystemFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInverseInput>;
  documentTemplatePlaceholderName?: InputMaybe<Scalars['String']>;
  excludeFromPlaceholderForm?: InputMaybe<Scalars['Boolean']>;
  futureData?: InputMaybe<FutureDataSystemFieldIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  readableName?: InputMaybe<Scalars['String']>;
  relationRoles?: InputMaybe<RelationRoleSystemFieldIdForeignInverseInput>;
  systemFieldType?: InputMaybe<SystemFieldTypeForeignInput>;
  type?: InputMaybe<Scalars['String']>;
  userSystemFields?: InputMaybe<UserSystemFieldSystemFieldIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `systemField` being updated. */
export type UpdateSystemFieldOnDashboardCardStatisticForDashboardCardStatisticSystemFieldIdForeignPatch = {
  alwaysRequired?: InputMaybe<Scalars['Boolean']>;
  companySystemFields?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingSystemFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInverseInput>;
  documentTemplatePlaceholderName?: InputMaybe<Scalars['String']>;
  excludeFromPlaceholderForm?: InputMaybe<Scalars['Boolean']>;
  futureData?: InputMaybe<FutureDataSystemFieldIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  readableName?: InputMaybe<Scalars['String']>;
  relationRoles?: InputMaybe<RelationRoleSystemFieldIdForeignInverseInput>;
  systemFieldType?: InputMaybe<SystemFieldTypeForeignInput>;
  type?: InputMaybe<Scalars['String']>;
  userSystemFields?: InputMaybe<UserSystemFieldSystemFieldIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `systemField` being updated. */
export type UpdateSystemFieldOnFutureDatumForFutureDataSystemFieldIdForeignPatch = {
  alwaysRequired?: InputMaybe<Scalars['Boolean']>;
  companySystemFields?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingSystemFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInverseInput>;
  documentTemplatePlaceholderName?: InputMaybe<Scalars['String']>;
  excludeFromPlaceholderForm?: InputMaybe<Scalars['Boolean']>;
  futureData?: InputMaybe<FutureDataSystemFieldIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  readableName?: InputMaybe<Scalars['String']>;
  relationRoles?: InputMaybe<RelationRoleSystemFieldIdForeignInverseInput>;
  systemFieldType?: InputMaybe<SystemFieldTypeForeignInput>;
  type?: InputMaybe<Scalars['String']>;
  userSystemFields?: InputMaybe<UserSystemFieldSystemFieldIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `systemField` being updated. */
export type UpdateSystemFieldOnIntegrationFieldMarkingForIntegrationFieldMarkingSystemFieldIdFkeyPatch = {
  alwaysRequired?: InputMaybe<Scalars['Boolean']>;
  companySystemFields?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingSystemFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInverseInput>;
  documentTemplatePlaceholderName?: InputMaybe<Scalars['String']>;
  excludeFromPlaceholderForm?: InputMaybe<Scalars['Boolean']>;
  futureData?: InputMaybe<FutureDataSystemFieldIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  readableName?: InputMaybe<Scalars['String']>;
  relationRoles?: InputMaybe<RelationRoleSystemFieldIdForeignInverseInput>;
  systemFieldType?: InputMaybe<SystemFieldTypeForeignInput>;
  type?: InputMaybe<Scalars['String']>;
  userSystemFields?: InputMaybe<UserSystemFieldSystemFieldIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `systemField` being updated. */
export type UpdateSystemFieldOnRelationRoleForRelationRoleSystemFieldIdForeignPatch = {
  alwaysRequired?: InputMaybe<Scalars['Boolean']>;
  companySystemFields?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingSystemFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInverseInput>;
  documentTemplatePlaceholderName?: InputMaybe<Scalars['String']>;
  excludeFromPlaceholderForm?: InputMaybe<Scalars['Boolean']>;
  futureData?: InputMaybe<FutureDataSystemFieldIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  readableName?: InputMaybe<Scalars['String']>;
  relationRoles?: InputMaybe<RelationRoleSystemFieldIdForeignInverseInput>;
  systemFieldType?: InputMaybe<SystemFieldTypeForeignInput>;
  type?: InputMaybe<Scalars['String']>;
  userSystemFields?: InputMaybe<UserSystemFieldSystemFieldIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `systemField` being updated. */
export type UpdateSystemFieldOnSystemFieldForSystemFieldTypeForeignPatch = {
  alwaysRequired?: InputMaybe<Scalars['Boolean']>;
  companySystemFields?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingSystemFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInverseInput>;
  documentTemplatePlaceholderName?: InputMaybe<Scalars['String']>;
  excludeFromPlaceholderForm?: InputMaybe<Scalars['Boolean']>;
  futureData?: InputMaybe<FutureDataSystemFieldIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  readableName?: InputMaybe<Scalars['String']>;
  relationRoles?: InputMaybe<RelationRoleSystemFieldIdForeignInverseInput>;
  systemFieldType?: InputMaybe<SystemFieldTypeForeignInput>;
  userSystemFields?: InputMaybe<UserSystemFieldSystemFieldIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `systemField` being updated. */
export type UpdateSystemFieldOnUserSystemFieldForUserSystemFieldSystemFieldIdForeignPatch = {
  alwaysRequired?: InputMaybe<Scalars['Boolean']>;
  companySystemFields?: InputMaybe<CompanySystemFieldSystemFieldIdForeignInverseInput>;
  cvTemplateFieldMappings?: InputMaybe<CvTemplateFieldMappingSystemFieldIdForeignInverseInput>;
  dashboardCardStatistics?: InputMaybe<DashboardCardStatisticSystemFieldIdForeignInverseInput>;
  documentTemplatePlaceholderName?: InputMaybe<Scalars['String']>;
  excludeFromPlaceholderForm?: InputMaybe<Scalars['Boolean']>;
  futureData?: InputMaybe<FutureDataSystemFieldIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  integrationFieldMarkings?: InputMaybe<IntegrationFieldMarkingSystemFieldIdFkeyInverseInput>;
  name?: InputMaybe<Scalars['String']>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  readableName?: InputMaybe<Scalars['String']>;
  relationRoles?: InputMaybe<RelationRoleSystemFieldIdForeignInverseInput>;
  systemFieldType?: InputMaybe<SystemFieldTypeForeignInput>;
  type?: InputMaybe<Scalars['String']>;
  userSystemFields?: InputMaybe<UserSystemFieldSystemFieldIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `systemFieldType` being updated. */
export type UpdateSystemFieldTypeOnSystemFieldForSystemFieldTypeForeignPatch = {
  description?: InputMaybe<Scalars['String']>;
  systemFields?: InputMaybe<SystemFieldTypeForeignInverseInput>;
};

/** An object where the defined keys will be set on the `taskEmployee` being updated. */
export type UpdateTaskEmployeeOnTaskEmployeeForTaskEmployeeAssignedProcessUserIdForeignPatch = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TaskEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskEmployeeProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskEmployeeTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `taskEmployee` being updated. */
export type UpdateTaskEmployeeOnTaskEmployeeForTaskEmployeeCompanyIdFkeyPatch = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskEmployeeCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskEmployeeProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskEmployeeTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `taskEmployee` being updated. */
export type UpdateTaskEmployeeOnTaskEmployeeForTaskEmployeeEmployeeIdForeignPatch = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskEmployeeEmployeeIdForeignInput>;
  processType?: InputMaybe<TaskEmployeeProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskEmployeeTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `taskEmployee` being updated. */
export type UpdateTaskEmployeeOnTaskEmployeeForTaskEmployeeProcessTypeIdForeignPatch = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskEmployeeProcessTypeIdForeignInput>;
  task?: InputMaybe<TaskEmployeeTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `taskEmployee` being updated. */
export type UpdateTaskEmployeeOnTaskEmployeeForTaskEmployeeTaskIdForeignPatch = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskEmployeeProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskEmployeeTaskIdForeignInput>;
  user?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `taskEmployee` being updated. */
export type UpdateTaskEmployeeOnTaskEmployeeForTaskEmployeeUserIdFkeyPatch = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskEmployeeProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskEmployeeTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTaskIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskEmployeeForTaskEmployeeTaskIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskAssignedProcessUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskCalendarEventOrganizerIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskCompletedByForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskCreatedByForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskParentTaskIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskProcessIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskProjectIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskResponsibleForTaskResponsibleTaskIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  calendarEventFrom?: InputMaybe<Scalars['Datetime']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  calendarEventTo?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<TaskCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  completedBy?: InputMaybe<Scalars['UUID']>;
  completedReminded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdBy?: InputMaybe<Scalars['UUID']>;
  deadlineReminded?: InputMaybe<Scalars['Boolean']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  project?: InputMaybe<TaskProjectIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  startReminded?: InputMaybe<Scalars['Boolean']>;
  task?: InputMaybe<TaskParentTaskIdForeignInput>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<TaskCompletedByForeignInput>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** An object where the defined keys will be set on the `taskResponsible` being updated. */
export type UpdateTaskResponsibleOnTaskResponsibleForTaskResponsibleAssignedProcessUserIdForeignPatch = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TaskResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskResponsibleResponsibleIdForeignInput>;
  processType?: InputMaybe<TaskResponsibleProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskResponsibleTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `taskResponsible` being updated. */
export type UpdateTaskResponsibleOnTaskResponsibleForTaskResponsibleCompanyIdFkeyPatch = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskResponsibleCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskResponsibleResponsibleIdForeignInput>;
  processType?: InputMaybe<TaskResponsibleProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskResponsibleTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `taskResponsible` being updated. */
export type UpdateTaskResponsibleOnTaskResponsibleForTaskResponsibleProcessTypeIdForeignPatch = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskResponsibleResponsibleIdForeignInput>;
  processType?: InputMaybe<TaskResponsibleProcessTypeIdForeignInput>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskResponsibleTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `taskResponsible` being updated. */
export type UpdateTaskResponsibleOnTaskResponsibleForTaskResponsibleResponsibleIdForeignPatch = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskResponsibleResponsibleIdForeignInput>;
  processType?: InputMaybe<TaskResponsibleProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskResponsibleTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `taskResponsible` being updated. */
export type UpdateTaskResponsibleOnTaskResponsibleForTaskResponsibleTaskIdForeignPatch = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskResponsibleResponsibleIdForeignInput>;
  processType?: InputMaybe<TaskResponsibleProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskResponsibleTaskIdForeignInput>;
  user?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `taskResponsible` being updated. */
export type UpdateTaskResponsibleOnTaskResponsibleForTaskResponsibleUserIdFkeyPatch = {
  assignReminded?: InputMaybe<Scalars['Boolean']>;
  assignedProcessUserId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TaskResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskResponsibleResponsibleIdForeignInput>;
  processType?: InputMaybe<TaskResponsibleProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  task?: InputMaybe<TaskResponsibleTaskIdForeignInput>;
  taskId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `taskTemplateEmployee` being updated. */
export type UpdateTaskTemplateEmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeCompanyIdFkeyPatch = {
  company?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `taskTemplateEmployee` being updated. */
export type UpdateTaskTemplateEmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeEmployeeIdForeignPatch = {
  company?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInput>;
  taskTemplate?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `taskTemplateEmployee` being updated. */
export type UpdateTaskTemplateEmployeeOnTaskTemplateEmployeeForTaskTemplateEmployeeTaskTemplateIdForeignPatch = {
  company?: InputMaybe<TaskTemplateEmployeeCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskTemplateEmployeeEmployeeIdForeignInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInput>;
};

/** An object where the defined keys will be set on the `taskTemplate` being updated. */
export type UpdateTaskTemplateOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTaskTemplateIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** An object where the defined keys will be set on the `taskTemplate` being updated. */
export type UpdateTaskTemplateOnTaskTemplateEmployeeForTaskTemplateEmployeeTaskTemplateIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** An object where the defined keys will be set on the `taskTemplate` being updated. */
export type UpdateTaskTemplateOnTaskTemplateForTaskTemplateCalendarEventOrganizerIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** An object where the defined keys will be set on the `taskTemplate` being updated. */
export type UpdateTaskTemplateOnTaskTemplateForTaskTemplateCompanyIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** An object where the defined keys will be set on the `taskTemplate` being updated. */
export type UpdateTaskTemplateOnTaskTemplateForTaskTemplateParentTaskIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** An object where the defined keys will be set on the `taskTemplate` being updated. */
export type UpdateTaskTemplateOnTaskTemplateForTaskTemplateProcessIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** An object where the defined keys will be set on the `taskTemplate` being updated. */
export type UpdateTaskTemplateOnTaskTemplateForTaskTemplateProcessTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** An object where the defined keys will be set on the `taskTemplate` being updated. */
export type UpdateTaskTemplateOnTaskTemplateForTaskTemplateProjectIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** An object where the defined keys will be set on the `taskTemplate` being updated. */
export type UpdateTaskTemplateOnTaskTemplateResponsibleForTaskTemplateResponsibleTaskTemplateIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  company?: InputMaybe<TaskTemplateCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTaskTemplateIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  parentTaskId?: InputMaybe<Scalars['UUID']>;
  process?: InputMaybe<TaskTemplateProcessIdForeignInput>;
  processId?: InputMaybe<Scalars['UUID']>;
  processType?: InputMaybe<TaskTemplateProcessTypeIdForeignInput>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  projectTemplate?: InputMaybe<TaskTemplateProjectIdForeignInput>;
  startDay?: InputMaybe<Scalars['Int']>;
  taskTemplate?: InputMaybe<TaskTemplateParentTaskIdForeignInput>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInput>;
};

/** An object where the defined keys will be set on the `taskTemplateResponsible` being updated. */
export type UpdateTaskTemplateResponsibleOnTaskTemplateResponsibleForTaskTemplateResponsibleCompanyIdFkeyPatch = {
  company?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInput>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `taskTemplateResponsible` being updated. */
export type UpdateTaskTemplateResponsibleOnTaskTemplateResponsibleForTaskTemplateResponsibleResponsibleIdForeignPatch = {
  company?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInput>;
  taskTemplate?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInput>;
  taskTemplateId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `taskTemplateResponsible` being updated. */
export type UpdateTaskTemplateResponsibleOnTaskTemplateResponsibleForTaskTemplateResponsibleTaskTemplateIdForeignPatch = {
  company?: InputMaybe<TaskTemplateResponsibleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  employee?: InputMaybe<TaskTemplateResponsibleResponsibleIdForeignInput>;
  responsibleId?: InputMaybe<Scalars['UUID']>;
  taskTemplate?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationBreakType` being updated. */
export type UpdateTimeRegistrationBreakTypeOnTimeRegistrationBreakTypeForTimeRegistrationBreakTypeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInput>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  paidTime?: InputMaybe<IntervalInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationBreakType` being updated. */
export type UpdateTimeRegistrationBreakTypeOnTimeRegistrationBreakTypeForTimeRegistrationBreakTypeNameTranslatedEntityIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  paidTime?: InputMaybe<IntervalInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationBreakType` being updated. */
export type UpdateTimeRegistrationBreakTypeOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationBreakTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  paidTime?: InputMaybe<IntervalInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationBreakType` being updated. */
export type UpdateTimeRegistrationBreakTypeOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationBreakTypeIPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationBreakTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  paidTime?: InputMaybe<IntervalInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationEntry` being updated. */
export type UpdateTimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInput>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType?: InputMaybe<TimeRegistrationEntryType>;
  timeRegistrationPresence?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationEntry` being updated. */
export type UpdateTimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationBreakTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInput>;
  timeRegistrationEntryType?: InputMaybe<TimeRegistrationEntryType>;
  timeRegistrationPresence?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationEntry` being updated. */
export type UpdateTimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationPresenceIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType?: InputMaybe<TimeRegistrationEntryType>;
  timeRegistrationPresence?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInput>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationEntry` being updated. */
export type UpdateTimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationProjectIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType?: InputMaybe<TimeRegistrationEntryType>;
  timeRegistrationPresence?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInput>;
  user?: InputMaybe<TimeRegistrationEntryUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationEntry` being updated. */
export type UpdateTimeRegistrationEntryOnTimeRegistrationEntryForTimeRegistrationEntryUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTimeRegistrationBreakTypeIdForeignInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType?: InputMaybe<TimeRegistrationEntryType>;
  timeRegistrationPresence?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInput>;
  timeRegistrationPresenceId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationEntryTemplate` being updated. */
export type UpdateTimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInput>;
  endTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['UUID']>;
  startTime?: InputMaybe<Scalars['Time']>;
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType?: InputMaybe<TimeRegistrationEntryType>;
  timeRegistrationPresenceTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInput>;
  timeRegistrationPresenceTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationEntryTemplate` being updated. */
export type UpdateTimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationBreakTypeIPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  endTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['UUID']>;
  startTime?: InputMaybe<Scalars['Time']>;
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInput>;
  timeRegistrationEntryType?: InputMaybe<TimeRegistrationEntryType>;
  timeRegistrationPresenceTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInput>;
  timeRegistrationPresenceTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationEntryTemplate` being updated. */
export type UpdateTimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationPresenceTemPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  endTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['UUID']>;
  startTime?: InputMaybe<Scalars['Time']>;
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType?: InputMaybe<TimeRegistrationEntryType>;
  timeRegistrationPresenceTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInput>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationEntryTemplate` being updated. */
export type UpdateTimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationProjectIdFPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  endTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['UUID']>;
  startTime?: InputMaybe<Scalars['Time']>;
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType?: InputMaybe<TimeRegistrationEntryType>;
  timeRegistrationPresenceTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInput>;
  timeRegistrationPresenceTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInput>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationEntryTemplate` being updated. */
export type UpdateTimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationTemplateIdPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  endTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['UUID']>;
  startTime?: InputMaybe<Scalars['Time']>;
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType?: InputMaybe<TimeRegistrationEntryType>;
  timeRegistrationPresenceTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInput>;
  timeRegistrationPresenceTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInput>;
  user?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationEntryTemplate` being updated. */
export type UpdateTimeRegistrationEntryTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationEntryTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  endTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['UUID']>;
  startTime?: InputMaybe<Scalars['Time']>;
  timeRegistrationBreakType?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationBreakTypeIInput>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryType?: InputMaybe<TimeRegistrationEntryType>;
  timeRegistrationPresenceTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInput>;
  timeRegistrationPresenceTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProject?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInput>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationPresence` being updated. */
export type UpdateTimeRegistrationPresenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceTimeRegistrationPresenceIdFPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  unpaidBreakTime?: InputMaybe<IntervalInput>;
  user?: InputMaybe<TimeRegistrationPresenceUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationPresence` being updated. */
export type UpdateTimeRegistrationPresenceOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationPresenceIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  unpaidBreakTime?: InputMaybe<IntervalInput>;
  user?: InputMaybe<TimeRegistrationPresenceUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationPresence` being updated. */
export type UpdateTimeRegistrationPresenceOnTimeRegistrationPresenceForTimeRegistrationPresenceApprovalIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInput>;
  company?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  unpaidBreakTime?: InputMaybe<IntervalInput>;
  user?: InputMaybe<TimeRegistrationPresenceUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationPresence` being updated. */
export type UpdateTimeRegistrationPresenceOnTimeRegistrationPresenceForTimeRegistrationPresenceCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInput>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  unpaidBreakTime?: InputMaybe<IntervalInput>;
  user?: InputMaybe<TimeRegistrationPresenceUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationPresence` being updated. */
export type UpdateTimeRegistrationPresenceOnTimeRegistrationPresenceForTimeRegistrationPresenceTimeRegistrationPresenceTypeIdFPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInput>;
  unpaidBreakTime?: InputMaybe<IntervalInput>;
  user?: InputMaybe<TimeRegistrationPresenceUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationPresence` being updated. */
export type UpdateTimeRegistrationPresenceOnTimeRegistrationPresenceForTimeRegistrationPresenceUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<TimeRegistrationPresenceApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  company?: InputMaybe<TimeRegistrationPresenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceTimeRegistrationPresenceIdFInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationPresenceIdForeignInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  unpaidBreakTime?: InputMaybe<IntervalInput>;
  user?: InputMaybe<TimeRegistrationPresenceUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationPresenceTemplate` being updated. */
export type UpdateTimeRegistrationPresenceTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationPresenceTemPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dayOfWeek?: InputMaybe<Scalars['Int']>;
  endTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['UUID']>;
  startTime?: InputMaybe<Scalars['Time']>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplateWeek?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInput>;
  timeRegistrationTemplateWeekId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationPresenceTemplate` being updated. */
export type UpdateTimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInput>;
  dayOfWeek?: InputMaybe<Scalars['Int']>;
  endTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['UUID']>;
  startTime?: InputMaybe<Scalars['Time']>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplateWeek?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInput>;
  timeRegistrationTemplateWeekId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationPresenceTemplate` being updated. */
export type UpdateTimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateTimeRegistrationPresencePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dayOfWeek?: InputMaybe<Scalars['Int']>;
  endTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['UUID']>;
  startTime?: InputMaybe<Scalars['Time']>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInput>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplateWeek?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInput>;
  timeRegistrationTemplateWeekId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationPresenceTemplate` being updated. */
export type UpdateTimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateTimeRegistrationTemplatePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dayOfWeek?: InputMaybe<Scalars['Int']>;
  endTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['UUID']>;
  startTime?: InputMaybe<Scalars['Time']>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInput>;
  timeRegistrationTemplateWeek?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInput>;
  timeRegistrationTemplateWeekId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationPresenceTemplate` being updated. */
export type UpdateTimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dayOfWeek?: InputMaybe<Scalars['Int']>;
  endTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['UUID']>;
  startTime?: InputMaybe<Scalars['Time']>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplateWeek?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInput>;
  timeRegistrationTemplateWeekId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationPresenceTemplate` being updated. */
export type UpdateTimeRegistrationPresenceTemplateOnTimeRegistrationPresenceTemplateForTrptTimeRegistrationTemplateWeekIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationPresenceTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  dayOfWeek?: InputMaybe<Scalars['Int']>;
  endTime?: InputMaybe<Scalars['Time']>;
  id?: InputMaybe<Scalars['UUID']>;
  startTime?: InputMaybe<Scalars['Time']>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationPresenceTemInverseInput>;
  timeRegistrationPresenceType?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInput>;
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplateWeek?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInput>;
  user?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `timeRegistrationPresenceType` being updated. */
export type UpdateTimeRegistrationPresenceTypeOnTimeRegistrationPresenceForTimeRegistrationPresenceTimeRegistrationPresenceTypeIdFPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationPresenceType` being updated. */
export type UpdateTimeRegistrationPresenceTypeOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateTimeRegistrationPresencePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationPresenceType` being updated. */
export type UpdateTimeRegistrationPresenceTypeOnTimeRegistrationPresenceTypeForTimeRegistrationPresenceTypeCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInput>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationPresenceType` being updated. */
export type UpdateTimeRegistrationPresenceTypeOnTimeRegistrationPresenceTypeForTimeRegistrationPresenceTypeNameTranslatedEntityIdForeiPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationPresenceTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationPresenceInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceTimeRegistrationPresenceTypeIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationProject` being updated. */
export type UpdateTimeRegistrationProjectOnTimeRegistrationEntryForTimeRegistrationEntryTimeRegistrationProjectIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  descriptionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationProject` being updated. */
export type UpdateTimeRegistrationProjectOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationProjectIdFPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  descriptionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationProject` being updated. */
export type UpdateTimeRegistrationProjectOnTimeRegistrationProjectForTimeRegistrationProjectCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInput>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  descriptionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationProject` being updated. */
export type UpdateTimeRegistrationProjectOnTimeRegistrationProjectForTimeRegistrationProjectDescriptionTranslatedEntityIdForePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationProject` being updated. */
export type UpdateTimeRegistrationProjectOnTimeRegistrationProjectForTimeRegistrationProjectNameTranslatedEntityIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<TimeRegistrationProjectCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  descriptionTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryTimeRegistrationProjectIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationProjectIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationTemplate` being updated. */
export type UpdateTimeRegistrationTemplateOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateTimeRegistrationTemplateIdPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInput>;
  useMultiWeek?: InputMaybe<Scalars['Boolean']>;
  users?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationTemplate` being updated. */
export type UpdateTimeRegistrationTemplateOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateTimeRegistrationTemplatePatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInput>;
  useMultiWeek?: InputMaybe<Scalars['Boolean']>;
  users?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationTemplate` being updated. */
export type UpdateTimeRegistrationTemplateOnTimeRegistrationTemplateForTimeRegistrationTemplateCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInput>;
  useMultiWeek?: InputMaybe<Scalars['Boolean']>;
  users?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationTemplate` being updated. */
export type UpdateTimeRegistrationTemplateOnTimeRegistrationTemplateForTimeRegistrationTemplateNameTranslatedEntityIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInput>;
  useMultiWeek?: InputMaybe<Scalars['Boolean']>;
  users?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationTemplate` being updated. */
export type UpdateTimeRegistrationTemplateOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekTimeRegistrationTemplateIdFPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation>>;
  nameTranslatedEntityId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateTimeRegistrationTemplateIdInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateTimeRegistrationTemplateInverseInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInverseInput>;
  translatedEntity?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInput>;
  useMultiWeek?: InputMaybe<Scalars['Boolean']>;
  users?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `timeRegistrationTemplateWeek` being updated. */
export type UpdateTimeRegistrationTemplateWeekOnTimeRegistrationPresenceTemplateForTrptTimeRegistrationTemplateWeekIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  currentlyRunning?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceTemplates?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  weekIndex?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `timeRegistrationTemplateWeek` being updated. */
export type UpdateTimeRegistrationTemplateWeekOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInput>;
  currentlyRunning?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceTemplates?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  weekIndex?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `timeRegistrationTemplateWeek` being updated. */
export type UpdateTimeRegistrationTemplateWeekOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekTimeRegistrationTemplateIdFPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  currentlyRunning?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceTemplates?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInput>;
  user?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  weekIndex?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `timeRegistrationTemplateWeek` being updated. */
export type UpdateTimeRegistrationTemplateWeekOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<TimeRegistrationTemplateWeekCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  currentlyRunning?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceTemplates?: InputMaybe<TrptTimeRegistrationTemplateWeekIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<TimeRegistrationTemplateWeekTimeRegistrationTemplateIdFInput>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInput>;
  weekIndex?: InputMaybe<Scalars['Int']>;
};

/** An object where the defined keys will be set on the `translatedEntityLocalization` being updated. */
export type UpdateTranslatedEntityLocalizationOnTranslatedEntityLocalizationForTranslatedEntityLocalizationCompanyIdForeignPatch = {
  company?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  isOriginalLanguage?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  translatedEntity?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInput>;
  translatedEntityId?: InputMaybe<Scalars['UUID']>;
  translation?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `translatedEntityLocalization` being updated. */
export type UpdateTranslatedEntityLocalizationOnTranslatedEntityLocalizationForTranslatedEntityLocalizationTranslatedEntityIdForeignPatch = {
  company?: InputMaybe<TranslatedEntityLocalizationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  isOriginalLanguage?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  translatedEntity?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInput>;
  translation?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `translatedEntity` being updated. */
export type UpdateTranslatedEntityOnCompanySystemFieldForCompanySystemFieldHelpTextTranslatedEntityIdForeignPatch = {
  company?: InputMaybe<TranslatedEntityCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldsToAliasTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldAliasTranslatedEntityIdForeignInverseInput>;
  companySystemFieldsToHelpTextTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  postTypes?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToHighestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToLowestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyLowestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToNameTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToQuestionTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyQuestionTranslatedEntityIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInverseInput>;
  timeRegistrationProjectsToDescriptionTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInverseInput>;
  timeRegistrationProjectsToNameTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `translatedEntity` being updated. */
export type UpdateTranslatedEntityOnFormFieldAgreementForFormFieldAgreementAgreementTextTranslatedEntityIdForeigPatch = {
  company?: InputMaybe<TranslatedEntityCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldsToAliasTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldAliasTranslatedEntityIdForeignInverseInput>;
  companySystemFieldsToHelpTextTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  postTypes?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToHighestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToLowestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyLowestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToNameTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToQuestionTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyQuestionTranslatedEntityIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInverseInput>;
  timeRegistrationProjectsToDescriptionTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInverseInput>;
  timeRegistrationProjectsToNameTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `translatedEntity` being updated. */
export type UpdateTranslatedEntityOnPostTypeForPostTypeNameTranslatedEntityIdForeignPatch = {
  company?: InputMaybe<TranslatedEntityCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldsToAliasTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldAliasTranslatedEntityIdForeignInverseInput>;
  companySystemFieldsToHelpTextTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  postTypes?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToHighestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToLowestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyLowestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToNameTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToQuestionTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyQuestionTranslatedEntityIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInverseInput>;
  timeRegistrationProjectsToDescriptionTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInverseInput>;
  timeRegistrationProjectsToNameTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `translatedEntity` being updated. */
export type UpdateTranslatedEntityOnPulseSurveyChoiceForPulseSurveyChoiceTextTranslatedEntityIdForeignPatch = {
  company?: InputMaybe<TranslatedEntityCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldsToAliasTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldAliasTranslatedEntityIdForeignInverseInput>;
  companySystemFieldsToHelpTextTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  postTypes?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToHighestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToLowestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyLowestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToNameTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToQuestionTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyQuestionTranslatedEntityIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInverseInput>;
  timeRegistrationProjectsToDescriptionTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInverseInput>;
  timeRegistrationProjectsToNameTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `translatedEntity` being updated. */
export type UpdateTranslatedEntityOnPulseSurveyForPulseSurveyHighestRatingLabelTranslatedEntityIdForeignPatch = {
  company?: InputMaybe<TranslatedEntityCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldsToAliasTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldAliasTranslatedEntityIdForeignInverseInput>;
  companySystemFieldsToHelpTextTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  postTypes?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToHighestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToLowestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyLowestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToNameTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToQuestionTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyQuestionTranslatedEntityIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInverseInput>;
  timeRegistrationProjectsToDescriptionTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInverseInput>;
  timeRegistrationProjectsToNameTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `translatedEntity` being updated. */
export type UpdateTranslatedEntityOnPulseTypeForPulseTypeNameTranslatedEntityIdForeignPatch = {
  company?: InputMaybe<TranslatedEntityCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldsToAliasTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldAliasTranslatedEntityIdForeignInverseInput>;
  companySystemFieldsToHelpTextTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  postTypes?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToHighestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToLowestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyLowestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToNameTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToQuestionTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyQuestionTranslatedEntityIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInverseInput>;
  timeRegistrationProjectsToDescriptionTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInverseInput>;
  timeRegistrationProjectsToNameTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `translatedEntity` being updated. */
export type UpdateTranslatedEntityOnTimeRegistrationBreakTypeForTimeRegistrationBreakTypeNameTranslatedEntityIdForeignPatch = {
  company?: InputMaybe<TranslatedEntityCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldsToAliasTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldAliasTranslatedEntityIdForeignInverseInput>;
  companySystemFieldsToHelpTextTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  postTypes?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToHighestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToLowestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyLowestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToNameTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToQuestionTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyQuestionTranslatedEntityIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInverseInput>;
  timeRegistrationProjectsToDescriptionTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInverseInput>;
  timeRegistrationProjectsToNameTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `translatedEntity` being updated. */
export type UpdateTranslatedEntityOnTimeRegistrationPresenceTypeForTimeRegistrationPresenceTypeNameTranslatedEntityIdForeiPatch = {
  company?: InputMaybe<TranslatedEntityCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldsToAliasTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldAliasTranslatedEntityIdForeignInverseInput>;
  companySystemFieldsToHelpTextTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  postTypes?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToHighestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToLowestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyLowestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToNameTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToQuestionTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyQuestionTranslatedEntityIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInverseInput>;
  timeRegistrationProjectsToDescriptionTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInverseInput>;
  timeRegistrationProjectsToNameTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `translatedEntity` being updated. */
export type UpdateTranslatedEntityOnTimeRegistrationProjectForTimeRegistrationProjectDescriptionTranslatedEntityIdForePatch = {
  company?: InputMaybe<TranslatedEntityCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldsToAliasTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldAliasTranslatedEntityIdForeignInverseInput>;
  companySystemFieldsToHelpTextTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  postTypes?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToHighestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToLowestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyLowestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToNameTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToQuestionTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyQuestionTranslatedEntityIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInverseInput>;
  timeRegistrationProjectsToDescriptionTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInverseInput>;
  timeRegistrationProjectsToNameTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `translatedEntity` being updated. */
export type UpdateTranslatedEntityOnTimeRegistrationTemplateForTimeRegistrationTemplateNameTranslatedEntityIdForeignPatch = {
  company?: InputMaybe<TranslatedEntityCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldsToAliasTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldAliasTranslatedEntityIdForeignInverseInput>;
  companySystemFieldsToHelpTextTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  postTypes?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToHighestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToLowestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyLowestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToNameTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToQuestionTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyQuestionTranslatedEntityIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInverseInput>;
  timeRegistrationProjectsToDescriptionTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInverseInput>;
  timeRegistrationProjectsToNameTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `translatedEntity` being updated. */
export type UpdateTranslatedEntityOnTranslatedEntityForTranslatedEntityCompanyIdForeignPatch = {
  company?: InputMaybe<TranslatedEntityCompanyIdForeignInput>;
  companySystemFieldsToAliasTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldAliasTranslatedEntityIdForeignInverseInput>;
  companySystemFieldsToHelpTextTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  postTypes?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToHighestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToLowestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyLowestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToNameTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToQuestionTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyQuestionTranslatedEntityIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInverseInput>;
  timeRegistrationProjectsToDescriptionTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInverseInput>;
  timeRegistrationProjectsToNameTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `translatedEntity` being updated. */
export type UpdateTranslatedEntityOnTranslatedEntityLocalizationForTranslatedEntityLocalizationTranslatedEntityIdForeignPatch = {
  company?: InputMaybe<TranslatedEntityCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldsToAliasTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldAliasTranslatedEntityIdForeignInverseInput>;
  companySystemFieldsToHelpTextTranslatedEntityIdUsingId?: InputMaybe<CompanySystemFieldHelpTextTranslatedEntityIdForeignInverseInput>;
  formFieldAgreements?: InputMaybe<FormFieldAgreementAgreementTextTranslatedEntityIdForeigInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  postTypes?: InputMaybe<PostTypeNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveyChoices?: InputMaybe<PulseSurveyChoiceTextTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToHighestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyHighestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToLowestRatingLabelTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyLowestRatingLabelTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToNameTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyNameTranslatedEntityIdForeignInverseInput>;
  pulseSurveysToQuestionTranslatedEntityIdUsingId?: InputMaybe<PulseSurveyQuestionTranslatedEntityIdForeignInverseInput>;
  pulseTypes?: InputMaybe<PulseTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationBreakTypes?: InputMaybe<TimeRegistrationBreakTypeNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationPresenceTypes?: InputMaybe<TimeRegistrationPresenceTypeNameTranslatedEntityIdForeiInverseInput>;
  timeRegistrationProjectsToDescriptionTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectDescriptionTranslatedEntityIdForeInverseInput>;
  timeRegistrationProjectsToNameTranslatedEntityIdUsingId?: InputMaybe<TimeRegistrationProjectNameTranslatedEntityIdForeignInverseInput>;
  timeRegistrationTemplates?: InputMaybe<TimeRegistrationTemplateNameTranslatedEntityIdForeignInverseInput>;
  translatedEntityLocalizations?: InputMaybe<TranslatedEntityLocalizationTranslatedEntityIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `translation` being updated. */
export type UpdateTranslationOnTranslationForTranslationCompanyIdForeignPatch = {
  company?: InputMaybe<TranslationCompanyIdForeignInput>;
  from?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  text?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
  translationGroup?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `userAnnouncement` being updated. */
export type UpdateUserAnnouncementOnUserAnnouncementForUserAnnouncementAnnouncementIdForeignPatch = {
  announcement?: InputMaybe<UserAnnouncementAnnouncementIdForeignInput>;
  user?: InputMaybe<UserAnnouncementUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userAnnouncement` being updated. */
export type UpdateUserAnnouncementOnUserAnnouncementForUserAnnouncementUserIdForeignPatch = {
  announcement?: InputMaybe<UserAnnouncementAnnouncementIdForeignInput>;
  announcementId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserAnnouncementUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `userCompanyGroup` being updated. */
export type UpdateUserCompanyGroupOnUserCompanyGroupForUserCompanyGroupCompanyIdForeignPatch = {
  company?: InputMaybe<UserCompanyGroupCompanyIdForeignInput>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  group?: InputMaybe<UserCompanyGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserCompanyGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userCompanyGroup` being updated. */
export type UpdateUserCompanyGroupOnUserCompanyGroupForUserCompanyGroupGroupIdForeignPatch = {
  company?: InputMaybe<UserCompanyGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  group?: InputMaybe<UserCompanyGroupGroupIdForeignInput>;
  user?: InputMaybe<UserCompanyGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userCompanyGroup` being updated. */
export type UpdateUserCompanyGroupOnUserCompanyGroupForUserCompanyGroupUserIdForeignPatch = {
  company?: InputMaybe<UserCompanyGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  group?: InputMaybe<UserCompanyGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserCompanyGroupUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `userCompanyRole` being updated. */
export type UpdateUserCompanyRoleOnUserCompanyRoleForUserCompanyRoleCompanyIdForeignPatch = {
  company?: InputMaybe<UserCompanyRoleCompanyIdForeignInput>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<UserCompanyRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserCompanyRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userCompanyRole` being updated. */
export type UpdateUserCompanyRoleOnUserCompanyRoleForUserCompanyRoleRoleIdForeignPatch = {
  company?: InputMaybe<UserCompanyRoleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<UserCompanyRoleRoleIdForeignInput>;
  user?: InputMaybe<UserCompanyRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userCompanyRole` being updated. */
export type UpdateUserCompanyRoleOnUserCompanyRoleForUserCompanyRoleUserIdForeignPatch = {
  company?: InputMaybe<UserCompanyRoleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<UserCompanyRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserCompanyRoleUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `userCompetenceEvaluationComment` being updated. */
export type UpdateUserCompetenceEvaluationCommentOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInput>;
  userCompetenceDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userCompetenceEvaluation?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userCompetenceUserId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userCompetenceEvaluationComment` being updated. */
export type UpdateUserCompetenceEvaluationCommentOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentUserCompetenceEvaluationIPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInput>;
  userCompetenceDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userCompetenceEvaluation?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInput>;
  userCompetenceUserId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userCompetenceEvaluationComment` being updated. */
export type UpdateUserCompetenceEvaluationCommentOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<UserCompetenceEvaluationCommentCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInput>;
  userCompetenceDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userCompetenceEvaluation?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInput>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userCompetenceUserId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userCompetenceEvaluation` being updated. */
export type UpdateUserCompetenceEvaluationOnFormFieldEntryForFormFieldEntryUserCompetenceEvaluationIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  evaluatingUserId?: InputMaybe<Scalars['UUID']>;
  evaluationDate?: InputMaybe<Scalars['Datetime']>;
  formFieldEntries?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  nextUpdate?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInput>;
  userCompetence?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInverseInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userCompetenceEvaluation` being updated. */
export type UpdateUserCompetenceEvaluationOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentUserCompetenceEvaluationIPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  evaluatingUserId?: InputMaybe<Scalars['UUID']>;
  evaluationDate?: InputMaybe<Scalars['Datetime']>;
  formFieldEntries?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  nextUpdate?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInput>;
  userCompetence?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInverseInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userCompetenceEvaluation` being updated. */
export type UpdateUserCompetenceEvaluationOnUserCompetenceEvaluationForUserCompetenceEvaluationCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInput>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  evaluatingUserId?: InputMaybe<Scalars['UUID']>;
  evaluationDate?: InputMaybe<Scalars['Datetime']>;
  formFieldEntries?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  nextUpdate?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInput>;
  userCompetence?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInverseInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userCompetenceEvaluation` being updated. */
export type UpdateUserCompetenceEvaluationOnUserCompetenceEvaluationForUserCompetenceEvaluationEvaluatingUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  evaluationDate?: InputMaybe<Scalars['Datetime']>;
  formFieldEntries?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  nextUpdate?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInput>;
  userCompetence?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInverseInput>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userCompetenceEvaluation` being updated. */
export type UpdateUserCompetenceEvaluationOnUserCompetenceEvaluationForUserCompetenceEvaluationUserCompetenceIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<UserCompetenceEvaluationCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  evaluatingUserId?: InputMaybe<Scalars['UUID']>;
  evaluationDate?: InputMaybe<Scalars['Datetime']>;
  formFieldEntries?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInverseInput>;
  id?: InputMaybe<Scalars['UUID']>;
  nextUpdate?: InputMaybe<Scalars['Datetime']>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInput>;
  userCompetence?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserCompetenceEvaluationIInverseInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userCompetence` being updated. */
export type UpdateUserCompetenceOnNotificationEmployeeReferenceForNotificationEmployeeReferenceUserCompetenceIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addedDate?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<UserCompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<UserCompetenceCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  courseRequested?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInverseInput>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceUserIdForeignInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInverseInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userCompetence` being updated. */
export type UpdateUserCompetenceOnUserCompetenceEvaluationForUserCompetenceEvaluationUserCompetenceIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addedDate?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<UserCompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<UserCompetenceCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  courseRequested?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInverseInput>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceUserIdForeignInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInverseInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userCompetence` being updated. */
export type UpdateUserCompetenceOnUserCompetenceForUserCompetenceCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addedDate?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<UserCompetenceCompanyIdForeignInput>;
  competence?: InputMaybe<UserCompetenceCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  courseRequested?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInverseInput>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceUserIdForeignInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInverseInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userCompetence` being updated. */
export type UpdateUserCompetenceOnUserCompetenceForUserCompetenceCompetenceIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addedDate?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<UserCompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<UserCompetenceCompetenceIdForeignInput>;
  courseRequested?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInverseInput>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceUserIdForeignInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInverseInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userCompetence` being updated. */
export type UpdateUserCompetenceOnUserCompetenceForUserCompetenceUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  addedDate?: InputMaybe<Scalars['Datetime']>;
  company?: InputMaybe<UserCompetenceCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  competence?: InputMaybe<UserCompetenceCompetenceIdForeignInput>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  courseRequested?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceUserCompetenceIdForeignInverseInput>;
  reminded?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserCompetenceUserIdForeignInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `userDepartmentGroup` being updated. */
export type UpdateUserDepartmentGroupOnUserDepartmentGroupForUserDepartmentGroupCompanyIdForeignPatch = {
  company?: InputMaybe<UserDepartmentGroupCompanyIdForeignInput>;
  department?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<UserDepartmentGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserDepartmentGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userDepartmentGroup` being updated. */
export type UpdateUserDepartmentGroupOnUserDepartmentGroupForUserDepartmentGroupDepartmentIdForeignPatch = {
  company?: InputMaybe<UserDepartmentGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInput>;
  group?: InputMaybe<UserDepartmentGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserDepartmentGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userDepartmentGroup` being updated. */
export type UpdateUserDepartmentGroupOnUserDepartmentGroupForUserDepartmentGroupGroupIdForeignPatch = {
  company?: InputMaybe<UserDepartmentGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<UserDepartmentGroupGroupIdForeignInput>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserDepartmentGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userDepartmentGroup` being updated. */
export type UpdateUserDepartmentGroupOnUserDepartmentGroupForUserDepartmentGroupUserIdForeignPatch = {
  company?: InputMaybe<UserDepartmentGroupCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentGroupDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  group?: InputMaybe<UserDepartmentGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserDepartmentGroupUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `userDepartment` being updated. */
export type UpdateUserDepartmentOnUserDepartmentForUserDepartmentCompanyIdFkeyPatch = {
  company?: InputMaybe<UserDepartmentCompanyIdFkeyInput>;
  department?: InputMaybe<UserDepartmentDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  parentUserDepartmentId?: InputMaybe<Scalars['UUID']>;
  rank?: InputMaybe<UserDepartmentRankIdForeignInput>;
  rankId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserDepartmentUserIdForeignInput>;
  userDepartment?: InputMaybe<UserDepartmentParentUserDepartmentIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userDepartment` being updated. */
export type UpdateUserDepartmentOnUserDepartmentForUserDepartmentDepartmentIdForeignPatch = {
  company?: InputMaybe<UserDepartmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentDepartmentIdForeignInput>;
  id?: InputMaybe<Scalars['UUID']>;
  parentUserDepartmentId?: InputMaybe<Scalars['UUID']>;
  rank?: InputMaybe<UserDepartmentRankIdForeignInput>;
  rankId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserDepartmentUserIdForeignInput>;
  userDepartment?: InputMaybe<UserDepartmentParentUserDepartmentIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userDepartment` being updated. */
export type UpdateUserDepartmentOnUserDepartmentForUserDepartmentParentUserDepartmentIdForeignPatch = {
  company?: InputMaybe<UserDepartmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  rank?: InputMaybe<UserDepartmentRankIdForeignInput>;
  rankId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserDepartmentUserIdForeignInput>;
  userDepartment?: InputMaybe<UserDepartmentParentUserDepartmentIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userDepartment` being updated. */
export type UpdateUserDepartmentOnUserDepartmentForUserDepartmentRankIdForeignPatch = {
  company?: InputMaybe<UserDepartmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  parentUserDepartmentId?: InputMaybe<Scalars['UUID']>;
  rank?: InputMaybe<UserDepartmentRankIdForeignInput>;
  user?: InputMaybe<UserDepartmentUserIdForeignInput>;
  userDepartment?: InputMaybe<UserDepartmentParentUserDepartmentIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userDepartment` being updated. */
export type UpdateUserDepartmentOnUserDepartmentForUserDepartmentUserIdForeignPatch = {
  company?: InputMaybe<UserDepartmentCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  parentUserDepartmentId?: InputMaybe<Scalars['UUID']>;
  rank?: InputMaybe<UserDepartmentRankIdForeignInput>;
  rankId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserDepartmentUserIdForeignInput>;
  userDepartment?: InputMaybe<UserDepartmentParentUserDepartmentIdForeignInput>;
};

/** An object where the defined keys will be set on the `userDepartmentRole` being updated. */
export type UpdateUserDepartmentRoleOnUserDepartmentRoleForUserDepartmentRoleCompanyIdForeignPatch = {
  company?: InputMaybe<UserDepartmentRoleCompanyIdForeignInput>;
  department?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<UserDepartmentRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserDepartmentRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userDepartmentRole` being updated. */
export type UpdateUserDepartmentRoleOnUserDepartmentRoleForUserDepartmentRoleDepartmentIdForeignPatch = {
  company?: InputMaybe<UserDepartmentRoleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInput>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<UserDepartmentRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserDepartmentRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userDepartmentRole` being updated. */
export type UpdateUserDepartmentRoleOnUserDepartmentRoleForUserDepartmentRoleRoleIdForeignPatch = {
  company?: InputMaybe<UserDepartmentRoleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<UserDepartmentRoleRoleIdForeignInput>;
  user?: InputMaybe<UserDepartmentRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userDepartmentRole` being updated. */
export type UpdateUserDepartmentRoleOnUserDepartmentRoleForUserDepartmentRoleUserIdForeignPatch = {
  company?: InputMaybe<UserDepartmentRoleCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  department?: InputMaybe<UserDepartmentRoleDepartmentIdForeignInput>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<UserDepartmentRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserDepartmentRoleUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `userGroup` being updated. */
export type UpdateUserGroupOnUserGroupForUserGroupCompanyIdFkeyPatch = {
  company?: InputMaybe<UserGroupCompanyIdFkeyInput>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  group?: InputMaybe<UserGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userGroup` being updated. */
export type UpdateUserGroupOnUserGroupForUserGroupGroupIdForeignPatch = {
  company?: InputMaybe<UserGroupCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  group?: InputMaybe<UserGroupGroupIdForeignInput>;
  user?: InputMaybe<UserGroupUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userGroup` being updated. */
export type UpdateUserGroupOnUserGroupForUserGroupUserIdForeignPatch = {
  company?: InputMaybe<UserGroupCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  group?: InputMaybe<UserGroupGroupIdForeignInput>;
  groupId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserGroupUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnAnnouncementForAnnouncementUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnApprovalForApprovalRequestingUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnAsyncJobForAsyncJobUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnAsyncJobItemForAsyncJobItemUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `userOnBehalfPermission` being updated. */
export type UpdateUserOnBehalfPermissionOnUserOnBehalfPermissionForUserOnBehalfPermissionsCompanyIdForeignPatch = {
  company?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userOnBehalfPermission` being updated. */
export type UpdateUserOnBehalfPermissionOnUserOnBehalfPermissionForUserOnBehalfPermissionsOnBehalfOfUserIdForeignPatch = {
  company?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userOnBehalfPermission` being updated. */
export type UpdateUserOnBehalfPermissionOnUserOnBehalfPermissionForUserOnBehalfPermissionsUserIdForeignPatch = {
  company?: InputMaybe<UserOnBehalfPermissionsCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnChangelogUserForChangelogUserUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnChosenColumnForChosenColumnsUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnContractSignPendingForContractSignPendingNextSigningUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnContractSignPendingSignerForContractSignPendingSignerOnBehalfOfUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnContractTemplateUserForContractTemplateUsersUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnDocumentFolderUserForDocumentFolderUserUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnDocumentUserPermissionForDocumentUserPermissionsUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnDocumentUserResponsibleForDocumentUserResponsibleAssignedByForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnEmployeeCasefileForEmployeeCasefileCreatorUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnEmployeeForEmployeeUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnEquipmentForEquipmentUserIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnEventUserForEventUserUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnFilterPresetForFilterPresetUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnFilterViewForFilterViewUserIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnFormFieldEntryForFormFieldEntryProductUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnFutureDatumForFutureDataCreatorUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnLoggedActionNoteForLoggedActionNoteSuperUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnNotificationCustomRecipientForNotificationCustomRecipientUserIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnNotificationEmployeeReferenceForNotificationEmployeeReferenceRecipientUserIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnPostForPostUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnPreboardingCommentForPreboardingCommentUserIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnPreboardingEmailLogForPreboardingEmailLogPreboardingUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnPreboardingEmployeeForPreboardingEmployeeRecipientIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnPreboardingForPreboardingRecipientIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnPreboardingFormCacheForPreboardingFormCacheUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnPreboardingProcessForPreboardingProcessUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnPreboardingResultForPreboardingResultUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnPreboardingResultSlideCommentForPreboardingResultSlideCommentPreboardingUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnProcessForProcessAssignedUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnProcessResponsibleForProcessResponsibleResponsibleUserIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnProductForProductAssignedUserIdFkeyPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnProjectForProjectAssignedProcessUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnPulseSurveyAnswerForPulseSurveyAnswerUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnPushTokenForPushTokenUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnReferenceTokenForReferenceTokenUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnRoadmapItemCommentForRoadmapItemCommentUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnRoadmapItemVoteForRoadmapItemVoteUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnScheduledMessageForScheduledMessageAssignedProcessUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnSuperUserForSuperUserUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnSuperUserLoginNoteForSuperUserLoginNoteSuperUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnTaskEmployeeForTaskEmployeeAssignedProcessUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnTaskForTaskCompletedByForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnTaskResponsibleForTaskResponsibleAssignedProcessUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnTaskTemplateForTaskTemplateCalendarEventOrganizerIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnTimeRegistrationEntryForTimeRegistrationEntryUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnTimeRegistrationEntryTemplateForTimeRegistrationEntryTemplateUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnTimeRegistrationPresenceForTimeRegistrationPresenceUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnTimeRegistrationPresenceTemplateForTimeRegistrationPresenceTemplateUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnTimeRegistrationTemplateWeekForTimeRegistrationTemplateWeekUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserAnnouncementForUserAnnouncementUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserCompanyGroupForUserCompanyGroupUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserCompanyRoleForUserCompanyRoleUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserCompetenceEvaluationCommentForUserCompetenceEvaluationCommentUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserCompetenceEvaluationForUserCompetenceEvaluationEvaluatingUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserCompetenceForUserCompetenceUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserDepartmentForUserDepartmentUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserDepartmentGroupForUserDepartmentGroupUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserDepartmentRoleForUserDepartmentRoleUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserForUserCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserForUserEmployeeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserGroupForUserGroupUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserOnBehalfPermissionForUserOnBehalfPermissionsOnBehalfOfUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserRoleForUserRoleUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserSettingForUserSettingUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserSystemFieldForUserSystemFieldUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnVacationUserForVacationUserCreatorUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUserIdForeignInverseInput>;
  approvalsToAffectedUserIdUsingId?: InputMaybe<ApprovalAffectedUserIdForeignInverseInput>;
  approvalsToApprovingUserIdUsingId?: InputMaybe<ApprovalApprovingUserIdForeignInverseInput>;
  approvalsToRequestingUserIdUsingId?: InputMaybe<ApprovalRequestingUserIdForeignInverseInput>;
  asyncJobItems?: InputMaybe<AsyncJobItemUserIdForeignInverseInput>;
  asyncJobs?: InputMaybe<AsyncJobUserIdForeignInverseInput>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  changelogUsers?: InputMaybe<ChangelogUserUserIdForeignInverseInput>;
  chosenColumns?: InputMaybe<ChosenColumnsUserIdForeignInverseInput>;
  company?: InputMaybe<UserCompanyIdForeignInput>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  contractSignPendingSignersToOnBehalfOfUserIdUsingId?: InputMaybe<ContractSignPendingSignerOnBehalfOfUserIdForeignInverseInput>;
  contractSignPendingSignersToUserIdUsingId?: InputMaybe<ContractSignPendingSignerUserIdForeignInverseInput>;
  contractSignPendingsToCreatorUserIdUsingId?: InputMaybe<ContractSignPendingCreatorUserIdForeignInverseInput>;
  contractSignPendingsToNextSigningUserIdUsingId?: InputMaybe<ContractSignPendingNextSigningUserIdForeignInverseInput>;
  contractSignPendingsToUserIdUsingId?: InputMaybe<ContractSignPendingUserIdFkeyInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersUserIdForeignInverseInput>;
  customId?: InputMaybe<Scalars['String']>;
  deleteAt?: InputMaybe<Scalars['Date']>;
  deleteReminded?: InputMaybe<Scalars['Boolean']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  documentFolderUsers?: InputMaybe<DocumentFolderUserUserIdForeignInverseInput>;
  documentUserPermissions?: InputMaybe<DocumentUserPermissionsUserIdForeignInverseInput>;
  documentUserResponsiblesToAssignedByUsingId?: InputMaybe<DocumentUserResponsibleAssignedByForeignInverseInput>;
  documentUserResponsiblesToUserIdUsingId?: InputMaybe<DocumentUserResponsibleUserIdForeignInverseInput>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  employee?: InputMaybe<EmployeeUserIdForeignInverseInput>;
  employeeCasefilesToCreatorUserIdUsingId?: InputMaybe<EmployeeCasefileCreatorUserIdForeignInverseInput>;
  employeeCasefilesToNextSigningUserIdUsingId?: InputMaybe<EmployeeCasefileNextSigningUserIdForeignInverseInput>;
  employeeCasefilesToUserIdUsingId?: InputMaybe<EmployeeCasefileUserIdFkeyInverseInput>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  employmentEndReminded?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<EquipmentUserIdFkeyInverseInput>;
  eventUsers?: InputMaybe<EventUserUserIdForeignInverseInput>;
  filterPresets?: InputMaybe<FilterPresetUserIdForeignInverseInput>;
  filterViews?: InputMaybe<FilterViewUserIdFkeyInverseInput>;
  firstName?: InputMaybe<Scalars['String']>;
  formFieldEntriesToProductUserIdUsingId?: InputMaybe<FormFieldEntryProductUserIdForeignInverseInput>;
  formFieldEntriesToUserIdUsingId?: InputMaybe<FormFieldEntryUserIdFkeyInverseInput>;
  fullName?: InputMaybe<Scalars['String']>;
  fullNameTsvector?: InputMaybe<Scalars['FullText']>;
  futureDataToCreatorUserIdUsingId?: InputMaybe<FutureDataCreatorUserIdForeignInverseInput>;
  futureDataToUserIdUsingId?: InputMaybe<FutureDataUserIdForeignInverseInput>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isLeader?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  lastLogin?: InputMaybe<Scalars['Datetime']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestTimeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  leaderDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  loggedActionNotesToSuperUserIdUsingId?: InputMaybe<LoggedActionNoteSuperUserIdForeignInverseInput>;
  loggedActionNotesToUserIdUsingId?: InputMaybe<LoggedActionNoteUserIdForeignInverseInput>;
  loginLogsToSuperUserIdUsingId?: InputMaybe<LoginLogSuperUserIdForeignInverseInput>;
  loginLogsToUserIdUsingId?: InputMaybe<LoginLogUserIdForeignInverseInput>;
  logo?: InputMaybe<Scalars['String']>;
  notificationCustomRecipients?: InputMaybe<NotificationCustomRecipientUserIdFkeyInverseInput>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceRecipientUserIdFkeyInverseInput>;
  posts?: InputMaybe<PostUserIdForeignInverseInput>;
  preboardingComments?: InputMaybe<PreboardingCommentUserIdFkeyInverseInput>;
  preboardingEmailLogs?: InputMaybe<PreboardingEmailLogPreboardingUserIdForeignInverseInput>;
  preboardingEmployeesToRecipientIdUsingId?: InputMaybe<PreboardingEmployeeRecipientIdForeignInverseInput>;
  preboardingEmployeesToUserIdUsingId?: InputMaybe<PreboardingEmployeeUserIdFkeyInverseInput>;
  preboardingFormCaches?: InputMaybe<PreboardingFormCacheUserIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToPreboardingUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentPreboardingUserIdForeignInverseInput>;
  preboardingResultSlideCommentsToUserIdUsingId?: InputMaybe<PreboardingResultSlideCommentUserIdForeignInverseInput>;
  preboardingResults?: InputMaybe<PreboardingResultUserIdForeignInverseInput>;
  preboardings?: InputMaybe<PreboardingRecipientIdForeignInverseInput>;
  processResponsibles?: InputMaybe<ProcessResponsibleResponsibleUserIdFkeyInverseInput>;
  processes?: InputMaybe<ProcessAssignedUserIdForeignInverseInput>;
  productsToAssignedUserIdUsingId?: InputMaybe<ProductAssignedUserIdFkeyInverseInput>;
  productsToUserIdUsingId?: InputMaybe<ProductUserIdForeignInverseInput>;
  projects?: InputMaybe<ProjectAssignedProcessUserIdForeignInverseInput>;
  pulseSurveyAnswers?: InputMaybe<PulseSurveyAnswerUserIdForeignInverseInput>;
  pushToken?: InputMaybe<PushTokenUserIdForeignInverseInput>;
  referenceTokens?: InputMaybe<ReferenceTokenUserIdForeignInverseInput>;
  roadmapItemComments?: InputMaybe<RoadmapItemCommentUserIdForeignInverseInput>;
  roadmapItemVotes?: InputMaybe<RoadmapItemVoteUserIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageAssignedProcessUserIdForeignInverseInput>;
  storages?: InputMaybe<StorageProductUserIdForeignInverseInput>;
  superUser?: InputMaybe<SuperUserUserIdForeignInverseInput>;
  superUserLoginNotesToSuperUserIdUsingId?: InputMaybe<SuperUserLoginNoteSuperUserIdForeignInverseInput>;
  superUserLoginNotesToUserIdUsingId?: InputMaybe<SuperUserLoginNoteUserIdForeignInverseInput>;
  taskEmployeesToAssignedProcessUserIdUsingId?: InputMaybe<TaskEmployeeAssignedProcessUserIdForeignInverseInput>;
  taskEmployeesToUserIdUsingId?: InputMaybe<TaskEmployeeUserIdFkeyInverseInput>;
  taskResponsiblesToAssignedProcessUserIdUsingId?: InputMaybe<TaskResponsibleAssignedProcessUserIdForeignInverseInput>;
  taskResponsiblesToUserIdUsingId?: InputMaybe<TaskResponsibleUserIdFkeyInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateCalendarEventOrganizerIdForeignInverseInput>;
  tasksToAssignedProcessUserIdUsingId?: InputMaybe<TaskAssignedProcessUserIdForeignInverseInput>;
  tasksToCalendarEventOrganizerIdUsingId?: InputMaybe<TaskCalendarEventOrganizerIdForeignInverseInput>;
  tasksToCompletedByUsingId?: InputMaybe<TaskCompletedByForeignInverseInput>;
  tasksToCreatedByUsingId?: InputMaybe<TaskCreatedByForeignInverseInput>;
  timeRegistrationEntries?: InputMaybe<TimeRegistrationEntryUserIdForeignInverseInput>;
  timeRegistrationEntryTemplates?: InputMaybe<TimeRegistrationEntryTemplateUserIdForeignInverseInput>;
  timeRegistrationPresenceTemplates?: InputMaybe<TimeRegistrationPresenceTemplateUserIdForeignInverseInput>;
  timeRegistrationPresences?: InputMaybe<TimeRegistrationPresenceUserIdForeignInverseInput>;
  timeRegistrationTemplate?: InputMaybe<UserLatestTimeRegistrationTemplateIdForeignInput>;
  timeRegistrationTemplateWeeks?: InputMaybe<TimeRegistrationTemplateWeekUserIdForeignInverseInput>;
  userAnnouncements?: InputMaybe<UserAnnouncementUserIdForeignInverseInput>;
  userCompanyGroups?: InputMaybe<UserCompanyGroupUserIdForeignInverseInput>;
  userCompanyRoles?: InputMaybe<UserCompanyRoleUserIdForeignInverseInput>;
  userCompetenceEvaluationComments?: InputMaybe<UserCompetenceEvaluationCommentUserIdForeignInverseInput>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationEvaluatingUserIdForeignInverseInput>;
  userCompetences?: InputMaybe<UserCompetenceUserIdForeignInverseInput>;
  userDepartmentGroups?: InputMaybe<UserDepartmentGroupUserIdForeignInverseInput>;
  userDepartmentRoles?: InputMaybe<UserDepartmentRoleUserIdForeignInverseInput>;
  userDepartments?: InputMaybe<UserDepartmentUserIdForeignInverseInput>;
  userGroups?: InputMaybe<UserGroupUserIdForeignInverseInput>;
  userOnBehalfPermissionsToOnBehalfOfUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsOnBehalfOfUserIdForeignInverseInput>;
  userOnBehalfPermissionsToUserIdUsingId?: InputMaybe<UserOnBehalfPermissionsUserIdForeignInverseInput>;
  userRoles?: InputMaybe<UserRoleUserIdForeignInverseInput>;
  userSettings?: InputMaybe<UserSettingUserIdForeignInverseInput>;
  userSystemFields?: InputMaybe<UserSystemFieldUserIdForeignInverseInput>;
  vacationUsersToCreatorUserIdUsingId?: InputMaybe<VacationUserCreatorUserIdForeignInverseInput>;
  vacationUsersToUserIdUsingId?: InputMaybe<VacationUserUserIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `userRole` being updated. */
export type UpdateUserRoleOnUserRoleForUserRoleCompanyIdFkeyPatch = {
  company?: InputMaybe<UserRoleCompanyIdFkeyInput>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<UserRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userRole` being updated. */
export type UpdateUserRoleOnUserRoleForUserRoleRoleIdForeignPatch = {
  company?: InputMaybe<UserRoleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<UserRoleRoleIdForeignInput>;
  user?: InputMaybe<UserRoleUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userRole` being updated. */
export type UpdateUserRoleOnUserRoleForUserRoleUserIdForeignPatch = {
  company?: InputMaybe<UserRoleCompanyIdFkeyInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  excludeRole?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  role?: InputMaybe<UserRoleRoleIdForeignInput>;
  roleId?: InputMaybe<Scalars['UUID']>;
  user?: InputMaybe<UserRoleUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `userSetting` being updated. */
export type UpdateUserSettingOnUserSettingForUserSettingUserIdForeignPatch = {
  key?: InputMaybe<UserSettingKey>;
  user?: InputMaybe<UserSettingUserIdForeignInput>;
  value?: InputMaybe<Scalars['JSON']>;
};

/** An object where the defined keys will be set on the `userSystemField` being updated. */
export type UpdateUserSystemFieldOnUserSystemFieldForUserSystemFieldCompanyIdForeignPatch = {
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<UserSystemFieldCompanyIdForeignInput>;
  companySystemFieldOptionId?: InputMaybe<Scalars['UUID']>;
  data?: InputMaybe<Scalars['JSON']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<UserSystemFieldFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  systemField?: InputMaybe<UserSystemFieldSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<UserSystemFieldUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userSystemField` being updated. */
export type UpdateUserSystemFieldOnUserSystemFieldForUserSystemFieldFieldGroupIdForeignPatch = {
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<UserSystemFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldOptionId?: InputMaybe<Scalars['UUID']>;
  data?: InputMaybe<Scalars['JSON']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<UserSystemFieldFieldGroupIdForeignInput>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  systemField?: InputMaybe<UserSystemFieldSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<UserSystemFieldUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userSystemField` being updated. */
export type UpdateUserSystemFieldOnUserSystemFieldForUserSystemFieldSystemFieldIdForeignPatch = {
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<UserSystemFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldOptionId?: InputMaybe<Scalars['UUID']>;
  data?: InputMaybe<Scalars['JSON']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<UserSystemFieldFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  systemField?: InputMaybe<UserSystemFieldSystemFieldIdForeignInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<UserSystemFieldUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `userSystemField` being updated. */
export type UpdateUserSystemFieldOnUserSystemFieldForUserSystemFieldUserIdForeignPatch = {
  approvalIsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<UserSystemFieldCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  companySystemFieldOptionId?: InputMaybe<Scalars['UUID']>;
  data?: InputMaybe<Scalars['JSON']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fieldGroup?: InputMaybe<UserSystemFieldFieldGroupIdForeignInput>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  leaderDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  systemField?: InputMaybe<UserSystemFieldSystemFieldIdForeignInput>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<UserSystemFieldUserIdForeignInput>;
};

/** An object where the defined keys will be set on the `vacationType` being updated. */
export type UpdateVacationTypeOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationTypeIdForeignPatch = {
  absenceCode?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  color?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<VacationTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  mustBeApproved?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInverseInput>;
  quickAction?: InputMaybe<Scalars['Boolean']>;
  sendCalendarInvite?: InputMaybe<Scalars['Boolean']>;
  vacationUsers?: InputMaybe<VacationUserVacationTypeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `vacationType` being updated. */
export type UpdateVacationTypeOnVacationTypeForVacationTypeCompanyIdForeignPatch = {
  absenceCode?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  color?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<VacationTypeCompanyIdForeignInput>;
  description?: InputMaybe<Scalars['String']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  mustBeApproved?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInverseInput>;
  quickAction?: InputMaybe<Scalars['Boolean']>;
  sendCalendarInvite?: InputMaybe<Scalars['Boolean']>;
  vacationUsers?: InputMaybe<VacationUserVacationTypeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `vacationType` being updated. */
export type UpdateVacationTypeOnVacationUserForVacationUserVacationTypeIdForeignPatch = {
  absenceCode?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  color?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<VacationTypeCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  emoji?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  mustBeApproved?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationTypeIdForeignInverseInput>;
  quickAction?: InputMaybe<Scalars['Boolean']>;
  sendCalendarInvite?: InputMaybe<Scalars['Boolean']>;
  vacationUsers?: InputMaybe<VacationUserVacationTypeIdForeignInverseInput>;
};

/** An object where the defined keys will be set on the `vacationUser` being updated. */
export type UpdateVacationUserOnNotificationEmployeeReferenceForNotificationEmployeeReferenceVacationUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  allDay?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<VacationUserDeletionApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<VacationUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  customId?: InputMaybe<Scalars['UUID']>;
  deletionApprovalId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<VacationUserCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<VacationUserVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `vacationUser` being updated. */
export type UpdateVacationUserOnVacationUserForVacationUserApprovalIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  allDay?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<VacationUserDeletionApprovalIdForeignInput>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<VacationUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  customId?: InputMaybe<Scalars['UUID']>;
  deletionApprovalId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<VacationUserCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<VacationUserVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `vacationUser` being updated. */
export type UpdateVacationUserOnVacationUserForVacationUserCompanyIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  allDay?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<VacationUserDeletionApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<VacationUserCompanyIdForeignInput>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  customId?: InputMaybe<Scalars['UUID']>;
  deletionApprovalId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<VacationUserCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<VacationUserVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `vacationUser` being updated. */
export type UpdateVacationUserOnVacationUserForVacationUserCreatorUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  allDay?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<VacationUserDeletionApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<VacationUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  customId?: InputMaybe<Scalars['UUID']>;
  deletionApprovalId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<VacationUserCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<VacationUserVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `vacationUser` being updated. */
export type UpdateVacationUserOnVacationUserForVacationUserDeletionApprovalIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  allDay?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<VacationUserDeletionApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<VacationUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  customId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<VacationUserCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<VacationUserVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `vacationUser` being updated. */
export type UpdateVacationUserOnVacationUserForVacationUserUserIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  allDay?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<VacationUserDeletionApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<VacationUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  customId?: InputMaybe<Scalars['UUID']>;
  deletionApprovalId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<VacationUserCreatorUserIdForeignInput>;
  vacationType?: InputMaybe<VacationUserVacationTypeIdForeignInput>;
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
};

/** An object where the defined keys will be set on the `vacationUser` being updated. */
export type UpdateVacationUserOnVacationUserForVacationUserVacationTypeIdForeignPatch = {
  active?: InputMaybe<Scalars['Boolean']>;
  allDay?: InputMaybe<Scalars['Boolean']>;
  approval?: InputMaybe<VacationUserDeletionApprovalIdForeignInput>;
  approvalId?: InputMaybe<Scalars['UUID']>;
  calendarEventRevisions?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<VacationUserCompanyIdForeignInput>;
  companyId?: InputMaybe<Scalars['UUID']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  customId?: InputMaybe<Scalars['UUID']>;
  deletionApprovalId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  notificationEmployeeReferences?: InputMaybe<NotificationEmployeeReferenceVacationUserIdForeignInverseInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  user?: InputMaybe<VacationUserCreatorUserIdForeignInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  vacationType?: InputMaybe<VacationUserVacationTypeIdForeignInput>;
};

export type AnnouncementFragment = { __typename?: 'Announcement', id: string, userId?: string | null, companyId: string, departmentIds: Array<string | null>, systemAnnouncement: boolean, title: string, teaser?: string | null, content?: string | null, url?: string | null, addPlayIcon: boolean, popup: boolean, locales: Array<string | null>, published: boolean, active: boolean, publishAt?: Date | string | null, expireAt?: Date | string | null, createdAt: Date | string, updatedAt: Date | string };

export type ChangelogFragment = { __typename?: 'Changelog', id: string, version: string, system: SystemType, releaseDate: Date | string, major?: string | null, minor?: string | null, guides?: string | null, published: boolean, locale: string, isAppNotes: boolean };

export type UserCompetenceEvaluationsFragment = { __typename?: 'UserCompetence', userCompetenceEvaluations: { __typename?: 'UserCompetenceEvaluationsConnection', edges: Array<{ __typename?: 'UserCompetenceEvaluationsEdge', node?: { __typename?: 'UserCompetenceEvaluation', id: string, evaluatingUserId: string, nextUpdate?: Date | string | null, evaluationDate: Date | string, evaluatingUser?: { __typename?: 'User', fullName?: string | null } | null, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, formFieldId: string, userId?: string | null, value?: string | null } | null> } } | null }> } };

export type ContractSignPendingDocumentFragment = { __typename?: 'ContractSignPendingDocument', id: string, contractTemplateId?: string | null, placeholderValues?: any | null, contractName: string, documentTypeId?: string | null, existingStorageId?: string | null, fieldMappings?: any | null, documentType?: { __typename?: 'DocumentType', id: string, localizedName?: string | null } | null, contractTemplate?: { __typename?: 'ContractTemplate', id: string, html?: string | null, header?: string | null, footer?: string | null, dateFormat: string, locale: string, documentType?: { __typename?: 'DocumentType', id: string } | null } | null };

export type ContractSignPendingSignerFragment = { __typename?: 'ContractSignPendingSigner', id: string, contractSignPendingId: string, signed: boolean, signDate?: Date | string | null, signatureFileId?: string | null, userId: string, createdAt: Date | string, refused: boolean, refusalReason?: string | null };

export type ContractSignPendingSignerWithUserFragment = { __typename?: 'ContractSignPendingSigner', signatureImage?: string | null, useSecondaryEmail: boolean, onBehalfOfUserId?: string | null, signOrder: number, id: string, contractSignPendingId: string, signed: boolean, signDate?: Date | string | null, signatureFileId?: string | null, userId: string, createdAt: Date | string, refused: boolean, refusalReason?: string | null, contractSignPending?: { __typename?: 'ContractSignPending', id: string, signDate?: Date | string | null } | null, user?: { __typename?: 'User', id: string, logo?: string | null, email?: string | null, emailWork?: string | null, fullName?: string | null } | null, onBehalfOfUser?: { __typename?: 'User', id: string, logo?: string | null, email?: string | null, fullName?: string | null } | null };

export type ContractTemplateFragment = { __typename?: 'ContractTemplate', id: string, companyId: string, name?: string | null, description?: string | null, active: boolean, jobPositionTypes?: Array<string | null> | null, placeholders?: any | null, htmlPlaceholders?: Array<string | null> | null, html?: string | null, header?: string | null, footer?: string | null, dateFormat: string, pageNumber: boolean, locale: string, topMargin: string | number, bottomMargin: string | number, leftMargin: string | number, rightMargin: string | number, createdAt: Date | string, updatedAt: Date | string, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null, lifetime?: number | null } | null };

export type UsersFragment = { __typename?: 'ContractTemplate', contractTemplateUsers: { __typename?: 'ContractTemplateUsersConnection', nodes: Array<{ __typename?: 'ContractTemplateUser', userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null, companyId: string } | null } | null> } };

export type DepartmentsFragment = { __typename?: 'ContractTemplate', contractTemplateDepartments: { __typename?: 'ContractTemplateDepartmentsConnection', nodes: Array<{ __typename?: 'ContractTemplateDepartment', departmentId: string, department?: { __typename?: 'Department', id: string, name: string, companyId?: string | null } | null } | null> } };

export type DepartmentBasicFragment = { __typename: 'Department', id: string, name: string, departmentNumber?: string | null, description?: string | null, mainDepartment: boolean, parentDepartmentId?: string | null, cvr?: string | null, alias?: string | null, pNumber?: number | null, ean?: string | null, address: string, postalCode: string, city: string, phone: string, email: string, departmentTypeId?: string | null, hasChildren?: boolean | null, parentDepartment?: { __typename?: 'Department', id: string, name: string } | null, departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null };

export type DepartmentBasicWithFieldEntriesFragment = { __typename: 'Department', id: string, name: string, departmentNumber?: string | null, description?: string | null, mainDepartment: boolean, parentDepartmentId?: string | null, cvr?: string | null, alias?: string | null, pNumber?: number | null, ean?: string | null, address: string, postalCode: string, city: string, phone: string, email: string, departmentTypeId?: string | null, hasChildren?: boolean | null, userDepartments: { __typename?: 'UserDepartmentsConnection', nodes: Array<{ __typename?: 'UserDepartment', user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null> }, formFieldEntries?: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, formFieldId: string, humanReadableValue?: string | null } | null> }, parentDepartment?: { __typename?: 'Department', id: string, name: string } | null, departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null };

export type DepartmentFragment = { __typename: 'Department', id: string, name: string, departmentNumber?: string | null, description?: string | null, mainDepartment: boolean, parentDepartmentId?: string | null, cvr?: string | null, alias?: string | null, pNumber?: number | null, ean?: string | null, address: string, postalCode: string, city: string, phone: string, email: string, departmentTypeId?: string | null, hasChildren?: boolean | null, userDepartments: { __typename?: 'UserDepartmentsConnection', totalCount: number, nodes: Array<{ __typename?: 'UserDepartment', user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null, jobPositionTitle?: string | null, employeeId?: string | null } | null, rank?: { __typename?: 'Rank', id: string, name: string } | null } | null> }, userDepartmentGroups: { __typename?: 'UserDepartmentGroupsConnection', nodes: Array<{ __typename?: 'UserDepartmentGroup', user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null, jobPositionTitle?: string | null, employeeId?: string | null } | null } | null> }, departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null, parentDepartment?: { __typename?: 'Department', id: string, name: string } | null };

export type DepartmentTypeFragment = { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean };

export type DepartmentTypeEmployeesPageFragment = { __typename?: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean };

export type StorageFragment = { __typename?: 'Storage', active: boolean, id: string, path: string, filename: string, fileOwner: StorageFileOwner, fileSize?: number | null, fileOwnerId: string, fileType: string, mimetype?: string | null, fileExtension: string, createdAt: Date | string, deleteAt?: Date | string | null, expireAt?: Date | string | null, remindAt?: Date | string | null, departments?: Array<string | null> | null, url?: string | null, html?: string | null, contractSignPendingDocumentId?: string | null, documentFolderId?: string | null, documentTemplateId?: string | null, placeholderValues?: any | null, documentTypeId?: string | null, owner?: any | null, employeeCasefileId?: string | null, contractSignPendingDocument?: { __typename?: 'ContractSignPendingDocument', id: string, fieldMappings?: any | null } | null, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null } | null, documentUserResponsiblesByFileId: { __typename?: 'DocumentUserResponsiblesConnection', edges: Array<{ __typename?: 'DocumentUserResponsiblesEdge', node?: { __typename?: 'DocumentUserResponsible', userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null }> } };

export type DocumentFolderFragment = { __typename?: 'DocumentFolder', id: string, name: string, parentDocumentFolderId?: string | null, ownerType: DocumentFolderOwnerType, lastEdited?: Date | string | null, ownerId: string, companyId: string, documentFolderBlueprintId?: string | null, rootDocumentFolderBlueprintId?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null } | null, documentFolderDepartments: { __typename?: 'DocumentFolderDepartmentsConnection', nodes: Array<{ __typename?: 'DocumentFolderDepartment', documentFolderId: string, departmentId: string, department?: { __typename?: 'Department', name: string, id: string } | null } | null> }, documentFolderUsers: { __typename?: 'DocumentFolderUsersConnection', nodes: Array<{ __typename?: 'DocumentFolderUser', documentFolderId: string, userId: string, user?: { __typename?: 'User', logo?: string | null, id: string, fullName?: string | null } | null } | null> } };

export type EmployeeCasefileFragment = { __typename?: 'EmployeeCasefile', casefileId: number, employeeId: string, title?: string | null, status?: string | null, expireAt?: number | null, signers?: any | null, recipients?: any | null, documents?: any | null, createdAt?: Date | string | null, id: number, documentType?: { __typename?: 'DocumentType', id: string, name?: string | null } | null, employeeSigners: { __typename?: 'EmployeesConnection', nodes: Array<{ __typename?: 'Employee', id: string, departments?: Array<string | null> | null, user?: { __typename?: 'User', id: string, logo?: string | null, email?: string | null } | null } | null> }, user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, email?: string | null, fullName?: string | null } | null };

export type EmployeeBasicFragment = { __typename?: 'Employee', id: string, userId: string, departments?: Array<string | null> | null, leaderDepartments?: Array<string | null> | null, isLeader: boolean, active: boolean, user?: { __typename?: 'User', id: string, locale?: string | null, firstName?: string | null, lastName?: string | null, alternateFirstName?: string | null, alternateLastName?: string | null, fullName?: string | null, birthdate?: Date | string | null, employmentStart?: Date | string | null, employmentEnd?: Date | string | null, companyAdmin: boolean, isSystemUser: boolean, canSignOnBehalfOf?: boolean | null, cpr?: string | null, bankRegistrationNumber?: string | null, bankAccountNumber?: string | null, country?: string | null, jobPositionTitle?: string | null, jobPositionType?: string | null, jobPositionWorkingHours?: string | null, jobPositionDescription?: string | null, initialsLogo?: string | null, logo?: string | null, hasLogo?: boolean | null, isFuture?: boolean | null, isResigned?: boolean | null, canLogin: boolean, canLoginApp: boolean, canLoginSso: boolean, godmode: boolean, employeeNumber?: string | number | null, directManager?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null };

export type EmployeeContactFragment = { __typename?: 'Employee', user?: { __typename?: 'User', email?: string | null, emailWork?: string | null, phone?: string | null, mobile?: string | null, mobilePrivate?: string | null } | null };

export type EmployeeLocationFragment = { __typename?: 'Employee', user?: { __typename?: 'User', address?: string | null, city?: string | null, postalCode?: string | number | null } | null };

export type EmployeeFormFieldEntriesFragment = { __typename?: 'Employee', formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, value?: string | null, formField?: { __typename?: 'FormField', id: string, fieldType?: string | null, name: string, metadata?: any | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, value: string } | null> } } | null } | null> } };

export type EmployeeProfileFragment = { __typename?: 'Employee', id: string, userId: string, departments?: Array<string | null> | null, leaderDepartments?: Array<string | null> | null, isLeader: boolean, active: boolean, company?: { __typename?: 'Company', id: string, name?: string | null } | null, user?: { __typename?: 'User', id: string, locale?: string | null, firstName?: string | null, lastName?: string | null, alternateFirstName?: string | null, alternateLastName?: string | null, fullName?: string | null, birthdate?: Date | string | null, employmentStart?: Date | string | null, employmentEnd?: Date | string | null, companyAdmin: boolean, isSystemUser: boolean, canSignOnBehalfOf?: boolean | null, cpr?: string | null, bankRegistrationNumber?: string | null, bankAccountNumber?: string | null, country?: string | null, jobPositionTitle?: string | null, jobPositionType?: string | null, jobPositionWorkingHours?: string | null, jobPositionDescription?: string | null, initialsLogo?: string | null, logo?: string | null, hasLogo?: boolean | null, isFuture?: boolean | null, isResigned?: boolean | null, canLogin: boolean, canLoginApp: boolean, canLoginSso: boolean, godmode: boolean, employeeNumber?: string | number | null, email?: string | null, emailWork?: string | null, phone?: string | null, mobile?: string | null, mobilePrivate?: string | null, address?: string | null, city?: string | null, postalCode?: string | number | null, userGroups: { __typename?: 'UserGroupsConnection', nodes: Array<{ __typename?: 'UserGroup', groupId: string } | null> }, userDepartments: { __typename?: 'UserDepartmentsConnection', edges: Array<{ __typename?: 'UserDepartmentsEdge', node?: { __typename?: 'UserDepartment', departmentId: string, rankId?: string | null, rank?: { __typename?: 'Rank', id: string, name: string } | null, department?: { __typename?: 'Department', id: string, name: string, address: string, postalCode: string, city: string, phone: string, email: string, cvr?: string | null, departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null } | null }> }, directManager?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null };

export type EquipmentFragment = { __typename?: 'Equipment', id: string, productId: string, employeeId: string, startDate?: Date | string | null, endDate?: Date | string | null, departments?: Array<string | null> | null, employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null };

export type ProductFragment = { __typename?: 'Product', id: string, name: string, description?: string | null, serial?: string | null, purchaseDate?: Date | string | null, acquisitionDate?: Date | string | null, companyId: string, departmentId?: string | null, userId?: string | null, createdAt: Date | string, updatedAt: Date | string, active: boolean, productTypeId: string, assignedUserDepartments?: Array<string | null> | null, assignedUserId?: string | null, occupiedBy?: string | null, occupiedByEmployeeId?: string | null, department?: { __typename?: 'Department', id: string, name: string } | null, occupiedByDepartments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, equipments: { __typename?: 'EquipmentConnection', edges: Array<{ __typename?: 'EquipmentEdge', node?: { __typename?: 'Equipment', id: string, productId: string, employeeId: string, startDate?: Date | string | null, endDate?: Date | string | null, departments?: Array<string | null> | null, employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null }> }, productType?: { __typename?: 'ProductType', id: string, name: string, localizedName?: string | null } | null, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', value?: string | null, formFieldId: string, formField?: { __typename?: 'FormField', fieldType?: string | null, metadata?: any | null, productTypeIds?: Array<string | null> | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string } | null> } } | null } | null> } };

export type ExternalIntegrationBasicFragment = { __typename?: 'ExternalIntegration', id: string, credentials?: any | null, config?: any | null, systemId?: number | null, externalCompanyId?: string | null, fieldMappings?: any | null, blacklistedFields?: any | null, whitelistedFields?: any | null, continuousSync?: boolean | null, title?: string | null, departmentId?: string | null, departmentInheritance?: boolean | null, active: boolean, system?: { __typename?: 'ExternalSystem', id: number, name: string } | null, integrableSystem?: { __typename?: 'IntegrableSystem', id: string, name: string, logo: string, description: string, homepageUrl: string, settingsUrl?: string | null } | null };

export type FieldGroupFragment = { __typename?: 'FieldGroup', id: string, name: string, localizedName?: string | null, order: number, active: boolean, companyId: string, recordFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, excludedRoleIds?: Array<string | null> | null } | null> }, fieldGroupCards: { __typename?: 'FieldGroupCardsConnection', nodes: Array<{ __typename?: 'FieldGroupCard', id: string, name?: string | null, localizedName?: string | null, description?: string | null, columns: number, fieldGroupId: string, fieldGroupCardColumns: { __typename?: 'FieldGroupCardColumnsConnection', nodes: Array<{ __typename?: 'FieldGroupCardColumn', id: string, name?: string | null, localizedName?: string | null, formFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, excludedRoleIds?: Array<string | null> | null } | null> }, companySystemFields: { __typename?: 'CompanySystemFieldsConnection', nodes: Array<{ __typename?: 'CompanySystemField', id: string, systemFieldId: string, excludedRoleIds?: Array<string | null> | null } | null> } } | null> } } | null> } };

export type FieldGroupCardFragment = { __typename?: 'FieldGroupCard', id: string, fieldGroupId: string, name?: string | null, localizedName?: string | null, description?: string | null, localizedDescription?: string | null, columns: number, order: number, createdAt: Date | string, fieldGroupCardColumns: { __typename?: 'FieldGroupCardColumnsConnection', nodes: Array<{ __typename?: 'FieldGroupCardColumn', id: string, name?: string | null, localizedName?: string | null, formFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldGroupId?: string | null, order: number, name: string, localizedName?: string | null, localizedHelpText?: string | null, fieldType?: string | null, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, supportsFutureData: boolean, required: boolean, uniqueValue: boolean, excludedRoleIds?: Array<string | null> | null, metadata?: any | null, customId?: string | null, integrationFieldMarkings: { __typename?: 'IntegrationFieldMarkingsConnection', nodes: Array<{ __typename?: 'IntegrationFieldMarking', sendsData: boolean, receivesData: boolean, systemFieldId?: string | null, integrationName: string, authAppId?: string | null, formFieldId?: string | null, departmentIds?: Array<string | null> | null, externalIntegration?: { __typename?: 'ExternalIntegration', systemId?: number | null, departmentId?: string | null } | null, storage?: { __typename?: 'Storage', url?: string | null } | null } | null> }, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string } | null> }, formFieldEntries?: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, value?: string | null } | null> } } | null> }, companySystemFields: { __typename?: 'CompanySystemFieldsConnection', nodes: Array<{ __typename?: 'CompanySystemField', id: string, order: number, sensitive: boolean, changesMustBeApproved: boolean, supportsFutureData: boolean, excludedRoleIds?: Array<string | null> | null, required: boolean, systemFieldId: string, companySystemFieldOptions: { __typename?: 'CompanySystemFieldOptionsConnection', nodes: Array<{ __typename?: 'CompanySystemFieldOption', id: string, value: string, localizedValue?: string | null } | null> }, systemField?: { __typename?: 'SystemField', id: string, name: string, integrationFieldMarkings: { __typename?: 'IntegrationFieldMarkingsConnection', nodes: Array<{ __typename?: 'IntegrationFieldMarking', sendsData: boolean, receivesData: boolean, authAppId?: string | null, systemFieldId?: string | null, formFieldId?: string | null, integrationName: string, departmentIds?: Array<string | null> | null, externalIntegration?: { __typename?: 'ExternalIntegration', systemId?: number | null, departmentId?: string | null } | null, storage?: { __typename?: 'Storage', url?: string | null } | null } | null> }, userSystemFields?: { __typename?: 'UserSystemFieldsConnection', nodes: Array<{ __typename?: 'UserSystemField', data?: any | null } | null> } } | null } | null> } } | null> } };

export type FilterPresetFragment = { __typename?: 'FilterPreset', id: string, name: string, tableName: string, columns: any, filters?: any | null, miscellaneousFilters?: any | null };

export type FormFieldEntryFragment = { __typename?: 'FormFieldEntry', id: string, value?: string | null, humanReadableValue?: string | null, formFieldId: string, employeeId?: string | null, productId?: string | null, active: boolean };

export type FormFieldWithEntryFragment = { __typename?: 'FormField', id: string, companyId: string, objectType: string, fieldType?: string | null, name: string, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> }, formFieldEntries?: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, value?: string | null, humanReadableValue?: string | null, formFieldId: string, employeeId?: string | null, productId?: string | null, active: boolean } | null> } };

export type FormFieldFragment = { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null };

export type FormFieldEntryEmployeesPageFragment = { __typename?: 'FormFieldEntry', id: string, value?: string | null, formFieldId: string, employeeId?: string | null, productId?: string | null, active: boolean };

export type UseFormFieldFragment = { __typename?: 'FormField', id: string, name: string, localizedName?: string | null, fieldType?: string | null, objectType: string, sensitive?: boolean | null, required: boolean, multiple: boolean, uniqueValue: boolean, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, metadata?: any | null, localizedHelpText?: string | null, localizedAgreementText?: string | null, supportsFutureData: boolean, changesMustBeApproved: boolean, defaultValue?: string | null, fieldGroup?: { __typename?: 'FieldGroup', id: string, localizedName?: string | null } | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null } | null> }, formFieldEntries?: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, value?: string | null, humanReadableValue?: string | null, userId?: string | null } | null> } };

export type FroalaStyleFragment = { __typename?: 'FroalaStyle', id: string, name: string, values?: any | null, css?: string | null };

export type FutureDataFragment = { __typename?: 'FutureDatum', id: string, systemFieldId?: string | null, formFieldId?: string | null, formFieldEntryId?: string | null, userId: string, updateValueAt?: Date | string | null, createdAt: Date | string, value: any, previousHumanReadableValue?: string | null, humanReadableValue?: string | null, approvalIsRequired?: boolean | null, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, approvalId?: string | null, creatorUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null, formField?: { __typename?: 'FormField', id: string, localizedName?: string | null, sensitive?: boolean | null } | null, systemField?: { __typename?: 'SystemField', id: string, readableName?: string | null, localizedName?: string | null, companySystemField?: { __typename?: 'CompanySystemField', id: string, sensitive: boolean } | null } | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null };

export type FutureDataEmployeesPageFragment = { __typename?: 'FutureDatum', id: string, systemFieldId?: string | null, formFieldId?: string | null, formFieldEntryId?: string | null, userId: string, updateValueAt?: Date | string | null, createdAt: Date | string, value: any, previousHumanReadableValue?: string | null, humanReadableValue?: string | null, approvalIsRequired?: boolean | null, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, approvalId?: string | null, creatorUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null, formField?: { __typename?: 'FormField', id: string, localizedName?: string | null, sensitive?: boolean | null } | null, systemField?: { __typename?: 'SystemField', id: string, readableName?: string | null, companySystemField?: { __typename?: 'CompanySystemField', id: string, sensitive: boolean } | null } | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null };

export type RoleFragment = { __typename?: 'Role', id: string, info: string, name: string, scopes?: Array<RoleScope | null> | null, usesItemIds: boolean };

export type GroupFragment = { __typename?: 'Group', id: string, name?: string | null, localizedName?: string | null, description?: string | null, scope?: RoleScope | null, active: boolean, autoAdd?: boolean | null, autoAddNewPermissions: boolean, autoInherit: boolean, groupRoles: { __typename?: 'GroupRolesConnection', nodes: Array<{ __typename?: 'GroupRole', groupId: string, roleId: string, itemIds?: Array<string | null> | null, role?: { __typename?: 'Role', id: string, info: string, name: string, scopes?: Array<RoleScope | null> | null, usesItemIds: boolean } | null } | null> } };

export type LogEntryFragment = { __typename?: 'LogEntry', rowData?: any | null, changedFields?: any | null, loggedAction?: { __typename?: 'LoggedAction', eventId: string | number, transactionId?: string | number | null, schemaName: string, tableName: string, actionTstampTx: Date | string, action: string, selectedFields?: Array<string | null> | null, affectedId?: string | null, loggedActionContext: LoggedActionContext, user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null } | null } | null };

export type NotificationFragment = { __typename?: 'Notification', id: string, notificationTypeId: string, hookId: string, hookName?: string | null, recipientType?: string | null, text?: string | null, emailSubject?: string | null, localizedText?: string | null, metadata?: any | null, createdAt: Date | string, updatedAt: Date | string, notificationType?: { __typename?: 'NotificationType', id: string, name: string, broadcastTime?: string | null, channelTypes: { __typename?: 'ChannelTypesConnection', nodes: Array<{ __typename?: 'ChannelType', id: string, name: string } | null> } } | null };

export type NotificationTypeFragment = { __typename?: 'NotificationType', id: string, name: string, broadcastTime?: string | null, timeZone?: string | null, avoidBundling: boolean, channelTypes: { __typename?: 'ChannelTypesConnection', nodes: Array<{ __typename?: 'ChannelType', id: string, name: string } | null> } };

export type NotificationEmployeeFragment = { __typename?: 'NotificationEmployee', id: string, recipientId: string, read: boolean, createdAt: Date | string, text?: string | null, placeholderValues?: any | null, notification?: { __typename?: 'Notification', text?: string | null, hook?: { __typename?: 'Hook', id: string, name: string } | null } | null, references: { __typename?: 'NotificationEmployeeReferencesConnection', nodes: Array<{ __typename?: 'NotificationEmployeeReference', notificationData?: { __typename?: 'NotificationData', type?: string | null, name?: string | null, object?: any | null, editedFields?: Array<string | null> | null } | null } | null> }, sender?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null, employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null };

export type PreboardingResultSlideCommentFragment = { __typename?: 'PreboardingResultSlideComment', id: string, preboardingSlideId: string, edited: boolean, public: boolean, text: string, createdAt: Date | string, preboardingSlide?: { __typename?: 'PreboardingSlide', id: string, name?: string | null } | null, user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null } | null };

export type PreboardingSlideFormFieldFragment = { __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null };

export type PreboardingSlideFragment = { __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } };

export type PreboardingFragment = { __typename?: 'Preboarding', id: string, archived: boolean, companyId?: string | null, name?: string | null, departmentIds?: Array<string | null> | null, userIds?: Array<string | null> | null, managerIds: Array<string | null>, predecessorId?: string | null, recipientId?: string | null, active: boolean, order: number, fontSize: number, backgroundColor?: string | null, textColor?: string | null, useContentColors: boolean, contentBackgroundColor?: string | null, contentTextColor?: string | null, logoWidth?: number | null, firstSlideName?: string | null, firstSlideTitle?: string | null, firstSlideDescription?: string | null, lastSlideName?: string | null, lastSlideTitle?: string | null, lastSlideDescription?: string | null, overviewSlideName?: string | null, overviewSlideTitle?: string | null, overviewSlideDescription?: string | null, overviewSlideEnabled: boolean, nextButtonText?: string | null, prevButtonText?: string | null, logoType?: PreboardingLogoType | null, emailSubject?: string | null, emailBody?: string | null, smsBody?: string | null, linkButtonText?: string | null, result?: any | null, type?: PreboardingType | null, template: boolean, published: boolean, completed: boolean, deadline?: Date | string | null, reminder?: Date | string | null, startDate: Date | string, createdAt: Date | string, locale: string, useCustomLinkButtonColor: boolean, fallbackText?: string | null, dateFormat?: string | null, disable2Fa: boolean, confirmResults: boolean, useLeader: boolean, useWorkEmail: boolean, channel?: PreboardingChannel | null, closeAccess?: number | null, reminderDays?: number | null, recipientGroupId?: string | null, recipientDirectManager?: boolean | null, recipientCustomEmployeeFieldId?: string | null, defaultManagerUserIds: Array<string | null>, defaultManagerGroupIds: Array<string | null>, defaultManagerEmployeeFieldIds: Array<string | null>, defaultManagerDirectManager: boolean, fontUrl?: string | null, fontType?: PreboardingFontType | null, engagementTypeId?: string | null, anonymous: boolean, recipient?: { __typename?: 'User', id: string, firstName?: string | null, fullName?: string | null, logo?: string | null } | null, storage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, fontStorage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, departments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, preboardingSlides: { __typename?: 'PreboardingSlidesConnection', nodes: Array<{ __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null> }, preboardingEmployees: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, completed: boolean, published: boolean } | null> }, engagementType?: { __typename?: 'EngagementType', id: string, localizedName?: string | null } | null };

export type PreboardingEmployeeFragment = { __typename?: 'PreboardingEmployee', id: string, employeeId: string, managerIds?: Array<string | null> | null, active: boolean, conclusion?: any | null, archived: boolean, published: boolean, completed: boolean, completedReminded?: boolean | null, createdAt: Date | string, recipientId?: string | null, employee?: { __typename?: 'Employee', id: string, userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null, isLeader: boolean, userDepartments: { __typename?: 'UserDepartmentsConnection', nodes: Array<{ __typename?: 'UserDepartment', departmentId: string } | null> } } | null } | null, preboarding?: { __typename?: 'Preboarding', id: string, archived: boolean, companyId?: string | null, name?: string | null, departmentIds?: Array<string | null> | null, userIds?: Array<string | null> | null, managerIds: Array<string | null>, predecessorId?: string | null, recipientId?: string | null, active: boolean, order: number, fontSize: number, backgroundColor?: string | null, textColor?: string | null, useContentColors: boolean, contentBackgroundColor?: string | null, contentTextColor?: string | null, logoWidth?: number | null, firstSlideName?: string | null, firstSlideTitle?: string | null, firstSlideDescription?: string | null, lastSlideName?: string | null, lastSlideTitle?: string | null, lastSlideDescription?: string | null, overviewSlideName?: string | null, overviewSlideTitle?: string | null, overviewSlideDescription?: string | null, overviewSlideEnabled: boolean, nextButtonText?: string | null, prevButtonText?: string | null, logoType?: PreboardingLogoType | null, emailSubject?: string | null, emailBody?: string | null, smsBody?: string | null, linkButtonText?: string | null, result?: any | null, type?: PreboardingType | null, template: boolean, published: boolean, completed: boolean, deadline?: Date | string | null, reminder?: Date | string | null, startDate: Date | string, createdAt: Date | string, locale: string, useCustomLinkButtonColor: boolean, fallbackText?: string | null, dateFormat?: string | null, disable2Fa: boolean, confirmResults: boolean, useLeader: boolean, useWorkEmail: boolean, channel?: PreboardingChannel | null, closeAccess?: number | null, reminderDays?: number | null, recipientGroupId?: string | null, recipientDirectManager?: boolean | null, recipientCustomEmployeeFieldId?: string | null, defaultManagerUserIds: Array<string | null>, defaultManagerGroupIds: Array<string | null>, defaultManagerEmployeeFieldIds: Array<string | null>, defaultManagerDirectManager: boolean, fontUrl?: string | null, fontType?: PreboardingFontType | null, engagementTypeId?: string | null, anonymous: boolean, recipient?: { __typename?: 'User', id: string, firstName?: string | null, fullName?: string | null, logo?: string | null } | null, storage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, fontStorage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, departments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, preboardingSlides: { __typename?: 'PreboardingSlidesConnection', nodes: Array<{ __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null> }, preboardingEmployees: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, completed: boolean, published: boolean } | null> }, engagementType?: { __typename?: 'EngagementType', id: string, localizedName?: string | null } | null } | null };

export type PreboardingProcessFragment = { __typename?: 'PreboardingProcess', preboardingId: string, processId: string, sendDate?: Date | string | null, sendTime: string, startDay?: number | null, duration?: number | null, deadlineReminder?: number | null, deadlineReminderDate?: Date | string | null, preboarding?: { __typename?: 'Preboarding', id: string, archived: boolean, companyId?: string | null, name?: string | null, departmentIds?: Array<string | null> | null, userIds?: Array<string | null> | null, managerIds: Array<string | null>, predecessorId?: string | null, recipientId?: string | null, active: boolean, order: number, fontSize: number, backgroundColor?: string | null, textColor?: string | null, useContentColors: boolean, contentBackgroundColor?: string | null, contentTextColor?: string | null, logoWidth?: number | null, firstSlideName?: string | null, firstSlideTitle?: string | null, firstSlideDescription?: string | null, lastSlideName?: string | null, lastSlideTitle?: string | null, lastSlideDescription?: string | null, overviewSlideName?: string | null, overviewSlideTitle?: string | null, overviewSlideDescription?: string | null, overviewSlideEnabled: boolean, nextButtonText?: string | null, prevButtonText?: string | null, logoType?: PreboardingLogoType | null, emailSubject?: string | null, emailBody?: string | null, smsBody?: string | null, linkButtonText?: string | null, result?: any | null, type?: PreboardingType | null, template: boolean, published: boolean, completed: boolean, deadline?: Date | string | null, reminder?: Date | string | null, startDate: Date | string, createdAt: Date | string, locale: string, useCustomLinkButtonColor: boolean, fallbackText?: string | null, dateFormat?: string | null, disable2Fa: boolean, confirmResults: boolean, useLeader: boolean, useWorkEmail: boolean, channel?: PreboardingChannel | null, closeAccess?: number | null, reminderDays?: number | null, recipientGroupId?: string | null, recipientDirectManager?: boolean | null, recipientCustomEmployeeFieldId?: string | null, defaultManagerUserIds: Array<string | null>, defaultManagerGroupIds: Array<string | null>, defaultManagerEmployeeFieldIds: Array<string | null>, defaultManagerDirectManager: boolean, fontUrl?: string | null, fontType?: PreboardingFontType | null, engagementTypeId?: string | null, anonymous: boolean, recipient?: { __typename?: 'User', id: string, firstName?: string | null, fullName?: string | null, logo?: string | null } | null, storage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, fontStorage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, departments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, preboardingSlides: { __typename?: 'PreboardingSlidesConnection', nodes: Array<{ __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null> }, preboardingEmployees: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, completed: boolean, published: boolean } | null> }, engagementType?: { __typename?: 'EngagementType', id: string, localizedName?: string | null } | null } | null };

export type ProcessFragment = { __typename?: 'Process', id: string, name?: string | null, processTypeId?: string | null, cutoffDay?: boolean | null, departmentIds?: Array<string | null> | null, createdAt: Date | string, order: number, startDate?: Date | string | null, endDate?: Date | string | null, progress?: string | number | null, active: boolean, taskCount?: string | number | null, projectCount?: string | number | null, messageCount?: string | number | null, appCount?: string | number | null, assignedUserDepartments?: Array<string | null> | null, processType?: { __typename?: 'ProcessType', id: string, localizedName?: string | null } | null, simpleUser?: { __typename?: 'SimpleUser', id?: string | null, logo?: string | null, fullName?: string | null } | null, employee?: { __typename?: 'Employee', id: string, departments?: Array<string | null> | null, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null, projects: { __typename?: 'ProjectsConnection', nodes: Array<{ __typename?: 'Project', id: string, name: string, order?: number | null, tasks: { __typename?: 'TasksConnection', nodes: Array<{ __typename?: 'Task', id: string, name: string, order?: number | null, startDate: Date | string, endDate: Date | string, deadlineReminderDate?: Date | string | null, notes?: string | null, projectId?: string | null, processId?: string | null, parentTaskId?: string | null, completed: boolean, archived: boolean, calendarEventFrom?: Date | string | null, calendarEventTo?: Date | string | null, calendarEventOrganizerId?: string | null, departments?: Array<string | null> | null, userIds?: Array<string | null> | null, parentTask?: { __typename?: 'Task', id: string, name: string, projectId?: string | null, processId?: string | null, startDate: Date | string, endDate: Date | string } | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean, processTypeId?: string | null } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskResponsibles: { __typename?: 'TaskResponsiblesConnection', nodes: Array<{ __typename?: 'TaskResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskEmployees: { __typename?: 'TaskEmployeesConnection', nodes: Array<{ __typename?: 'TaskEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> }, scheduledMessages: { __typename?: 'ScheduledMessagesConnection', nodes: Array<{ __typename?: 'ScheduledMessage', id: string, senderEmployeeId: string, name: string, subject: string, body: string, active: boolean, sendDate: Date | string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageRecipients: { __typename?: 'ScheduledMessageRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageRecipient', scheduledMessageId: string, employeeId: string } | null> }, scheduledMessageExternalRecipients: { __typename?: 'ScheduledMessageExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageExternalRecipient', scheduledMessageId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> } } | null> }, tasks: { __typename?: 'TasksConnection', nodes: Array<{ __typename?: 'Task', id: string, name: string, order?: number | null, startDate: Date | string, endDate: Date | string, deadlineReminderDate?: Date | string | null, notes?: string | null, projectId?: string | null, processId?: string | null, parentTaskId?: string | null, completed: boolean, archived: boolean, calendarEventFrom?: Date | string | null, calendarEventTo?: Date | string | null, calendarEventOrganizerId?: string | null, departments?: Array<string | null> | null, userIds?: Array<string | null> | null, parentTask?: { __typename?: 'Task', id: string, name: string, projectId?: string | null, processId?: string | null, startDate: Date | string, endDate: Date | string } | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean, processTypeId?: string | null } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskResponsibles: { __typename?: 'TaskResponsiblesConnection', nodes: Array<{ __typename?: 'TaskResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskEmployees: { __typename?: 'TaskEmployeesConnection', nodes: Array<{ __typename?: 'TaskEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> }, scheduledMessages: { __typename?: 'ScheduledMessagesConnection', nodes: Array<{ __typename?: 'ScheduledMessage', id: string, senderEmployeeId: string, name: string, subject: string, body: string, active: boolean, sendDate: Date | string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageRecipients: { __typename?: 'ScheduledMessageRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageRecipient', scheduledMessageId: string, employeeId: string } | null> }, scheduledMessageExternalRecipients: { __typename?: 'ScheduledMessageExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageExternalRecipient', scheduledMessageId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> }, preboardingProcesses: { __typename?: 'PreboardingProcessesConnection', nodes: Array<{ __typename?: 'PreboardingProcess', preboardingId: string, processId: string, sendDate?: Date | string | null, sendTime: string, startDay?: number | null, duration?: number | null, deadlineReminder?: number | null, deadlineReminderDate?: Date | string | null, preboarding?: { __typename?: 'Preboarding', id: string, archived: boolean, companyId?: string | null, name?: string | null, departmentIds?: Array<string | null> | null, userIds?: Array<string | null> | null, managerIds: Array<string | null>, predecessorId?: string | null, recipientId?: string | null, active: boolean, order: number, fontSize: number, backgroundColor?: string | null, textColor?: string | null, useContentColors: boolean, contentBackgroundColor?: string | null, contentTextColor?: string | null, logoWidth?: number | null, firstSlideName?: string | null, firstSlideTitle?: string | null, firstSlideDescription?: string | null, lastSlideName?: string | null, lastSlideTitle?: string | null, lastSlideDescription?: string | null, overviewSlideName?: string | null, overviewSlideTitle?: string | null, overviewSlideDescription?: string | null, overviewSlideEnabled: boolean, nextButtonText?: string | null, prevButtonText?: string | null, logoType?: PreboardingLogoType | null, emailSubject?: string | null, emailBody?: string | null, smsBody?: string | null, linkButtonText?: string | null, result?: any | null, type?: PreboardingType | null, template: boolean, published: boolean, completed: boolean, deadline?: Date | string | null, reminder?: Date | string | null, startDate: Date | string, createdAt: Date | string, locale: string, useCustomLinkButtonColor: boolean, fallbackText?: string | null, dateFormat?: string | null, disable2Fa: boolean, confirmResults: boolean, useLeader: boolean, useWorkEmail: boolean, channel?: PreboardingChannel | null, closeAccess?: number | null, reminderDays?: number | null, recipientGroupId?: string | null, recipientDirectManager?: boolean | null, recipientCustomEmployeeFieldId?: string | null, defaultManagerUserIds: Array<string | null>, defaultManagerGroupIds: Array<string | null>, defaultManagerEmployeeFieldIds: Array<string | null>, defaultManagerDirectManager: boolean, fontUrl?: string | null, fontType?: PreboardingFontType | null, engagementTypeId?: string | null, anonymous: boolean, recipient?: { __typename?: 'User', id: string, firstName?: string | null, fullName?: string | null, logo?: string | null } | null, storage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, fontStorage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, departments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, preboardingSlides: { __typename?: 'PreboardingSlidesConnection', nodes: Array<{ __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null> }, preboardingEmployees: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, completed: boolean, published: boolean } | null> }, engagementType?: { __typename?: 'EngagementType', id: string, localizedName?: string | null } | null } | null } | null> }, projectTemplates: { __typename?: 'ProjectTemplatesConnection', nodes: Array<{ __typename?: 'ProjectTemplate', id: string, name: string, order?: number | null, taskTemplatesByProjectId: { __typename?: 'TaskTemplatesConnection', nodes: Array<{ __typename?: 'TaskTemplate', id: string, name: string, order?: number | null, startDay: number, duration: number, deadlineReminder?: number | null, useCalendarEvent: boolean, calendarEventFrom?: string | null, calendarEventTo?: string | null, calendarEventOrganizerId?: string | null, notes?: string | null, projectId?: string | null, processId?: string | null, includeEmployee: boolean, includeDirectManager: boolean, includeEmployeeResponsible: boolean, includeDirectManagerResponsible: boolean, includeCustomEmployeeFields?: Array<string | null> | null, includeCustomEmployeeFieldsResponsibles?: Array<string | null> | null, includeGroups?: Array<string | null> | null, includeGroupsResponsibles?: Array<string | null> | null, parentTaskId?: string | null, parentTask?: { __typename?: 'TaskTemplate', id: string, name: string, projectId?: string | null, processId?: string | null, duration: number, startDay: number } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskTemplateResponsibles: { __typename?: 'TaskTemplateResponsiblesConnection', nodes: Array<{ __typename?: 'TaskTemplateResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskTemplateEmployees: { __typename?: 'TaskTemplateEmployeesConnection', nodes: Array<{ __typename?: 'TaskTemplateEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> }, scheduledMessageTemplatesByProjectId: { __typename?: 'ScheduledMessageTemplatesConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplate', id: string, name: string, subject: string, includeEmployee: boolean, includeDirectManager?: boolean | null, includeGroups?: Array<string | null> | null, includeCustomEmployeeFields?: Array<string | null> | null, body: string, active: boolean, startDay: number, duration: number, sendTime: string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'ProjectTemplate', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageTemplateRecipients: { __typename?: 'ScheduledMessageTemplateRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplateRecipient', scheduledMessageTemplateId: string, employeeId: string } | null> }, scheduledMessageTemplateExternalRecipients: { __typename?: 'ScheduledMessageTemplateExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplateExternalRecipient', scheduledMessageTemplateId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> } } | null> }, taskTemplates: { __typename?: 'TaskTemplatesConnection', nodes: Array<{ __typename?: 'TaskTemplate', id: string, name: string, order?: number | null, startDay: number, duration: number, deadlineReminder?: number | null, useCalendarEvent: boolean, calendarEventFrom?: string | null, calendarEventTo?: string | null, calendarEventOrganizerId?: string | null, notes?: string | null, projectId?: string | null, processId?: string | null, includeEmployee: boolean, includeDirectManager: boolean, includeEmployeeResponsible: boolean, includeDirectManagerResponsible: boolean, includeCustomEmployeeFields?: Array<string | null> | null, includeCustomEmployeeFieldsResponsibles?: Array<string | null> | null, includeGroups?: Array<string | null> | null, includeGroupsResponsibles?: Array<string | null> | null, parentTaskId?: string | null, parentTask?: { __typename?: 'TaskTemplate', id: string, name: string, projectId?: string | null, processId?: string | null, duration: number, startDay: number } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskTemplateResponsibles: { __typename?: 'TaskTemplateResponsiblesConnection', nodes: Array<{ __typename?: 'TaskTemplateResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskTemplateEmployees: { __typename?: 'TaskTemplateEmployeesConnection', nodes: Array<{ __typename?: 'TaskTemplateEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> }, scheduledMessageTemplates: { __typename?: 'ScheduledMessageTemplatesConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplate', id: string, name: string, subject: string, includeEmployee: boolean, includeDirectManager?: boolean | null, includeGroups?: Array<string | null> | null, includeCustomEmployeeFields?: Array<string | null> | null, body: string, active: boolean, startDay: number, duration: number, sendTime: string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'ProjectTemplate', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageTemplateRecipients: { __typename?: 'ScheduledMessageTemplateRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplateRecipient', scheduledMessageTemplateId: string, employeeId: string } | null> }, scheduledMessageTemplateExternalRecipients: { __typename?: 'ScheduledMessageTemplateExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplateExternalRecipient', scheduledMessageTemplateId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> } };

export type ProjectFragment = { __typename?: 'Project', id: string, name: string, order?: number | null, tasks: { __typename?: 'TasksConnection', nodes: Array<{ __typename?: 'Task', id: string, name: string, order?: number | null, startDate: Date | string, endDate: Date | string, deadlineReminderDate?: Date | string | null, notes?: string | null, projectId?: string | null, processId?: string | null, parentTaskId?: string | null, completed: boolean, archived: boolean, calendarEventFrom?: Date | string | null, calendarEventTo?: Date | string | null, calendarEventOrganizerId?: string | null, departments?: Array<string | null> | null, userIds?: Array<string | null> | null, parentTask?: { __typename?: 'Task', id: string, name: string, projectId?: string | null, processId?: string | null, startDate: Date | string, endDate: Date | string } | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean, processTypeId?: string | null } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskResponsibles: { __typename?: 'TaskResponsiblesConnection', nodes: Array<{ __typename?: 'TaskResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskEmployees: { __typename?: 'TaskEmployeesConnection', nodes: Array<{ __typename?: 'TaskEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> }, scheduledMessages: { __typename?: 'ScheduledMessagesConnection', nodes: Array<{ __typename?: 'ScheduledMessage', id: string, senderEmployeeId: string, name: string, subject: string, body: string, active: boolean, sendDate: Date | string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageRecipients: { __typename?: 'ScheduledMessageRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageRecipient', scheduledMessageId: string, employeeId: string } | null> }, scheduledMessageExternalRecipients: { __typename?: 'ScheduledMessageExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageExternalRecipient', scheduledMessageId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> } };

export type ProjectTemplateFragment = { __typename?: 'ProjectTemplate', id: string, name: string, order?: number | null, taskTemplatesByProjectId: { __typename?: 'TaskTemplatesConnection', nodes: Array<{ __typename?: 'TaskTemplate', id: string, name: string, order?: number | null, startDay: number, duration: number, deadlineReminder?: number | null, useCalendarEvent: boolean, calendarEventFrom?: string | null, calendarEventTo?: string | null, calendarEventOrganizerId?: string | null, notes?: string | null, projectId?: string | null, processId?: string | null, includeEmployee: boolean, includeDirectManager: boolean, includeEmployeeResponsible: boolean, includeDirectManagerResponsible: boolean, includeCustomEmployeeFields?: Array<string | null> | null, includeCustomEmployeeFieldsResponsibles?: Array<string | null> | null, includeGroups?: Array<string | null> | null, includeGroupsResponsibles?: Array<string | null> | null, parentTaskId?: string | null, parentTask?: { __typename?: 'TaskTemplate', id: string, name: string, projectId?: string | null, processId?: string | null, duration: number, startDay: number } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskTemplateResponsibles: { __typename?: 'TaskTemplateResponsiblesConnection', nodes: Array<{ __typename?: 'TaskTemplateResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskTemplateEmployees: { __typename?: 'TaskTemplateEmployeesConnection', nodes: Array<{ __typename?: 'TaskTemplateEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> }, scheduledMessageTemplatesByProjectId: { __typename?: 'ScheduledMessageTemplatesConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplate', id: string, name: string, subject: string, includeEmployee: boolean, includeDirectManager?: boolean | null, includeGroups?: Array<string | null> | null, includeCustomEmployeeFields?: Array<string | null> | null, body: string, active: boolean, startDay: number, duration: number, sendTime: string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'ProjectTemplate', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageTemplateRecipients: { __typename?: 'ScheduledMessageTemplateRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplateRecipient', scheduledMessageTemplateId: string, employeeId: string } | null> }, scheduledMessageTemplateExternalRecipients: { __typename?: 'ScheduledMessageTemplateExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplateExternalRecipient', scheduledMessageTemplateId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> } };

export type PulseSurveyListItemFragment = { __typename?: 'PulseSurvey', id: string, name?: string | null, localizedName?: string | null, questionType: PulseSurveyQuestionType, localizedQuestion?: string | null, anonymous: boolean, startDate: Date | string, surveyTime: string, endDate?: Date | string | null, isDraft: boolean, highestRating?: number | null, averageRatingAllTime?: string | number | null, averageRatingThisMonth?: string | number | null, averageRatingThisMonthLastYear?: string | number | null, averageRatingAllTimeLastYear?: string | number | null, invitedAll: boolean, recipients: { __typename?: 'PulseSurveyRecipientsConnection', nodes: Array<{ __typename?: 'PulseSurveyRecipient', id?: string | null, fullName?: string | null, logo?: string | null } | null> }, pulseType?: { __typename?: 'PulseType', id: string, localizedName?: string | null } | null, pulseSurveyChoices: { __typename?: 'PulseSurveyChoicesConnection', nodes: Array<{ __typename?: 'PulseSurveyChoice', id: string, emoji?: string | null } | null> } };

export type RoadmapItemFragment = { __typename?: 'RoadmapItem', id: string, name?: string | null, summary?: string | null, description?: string | null, stage: RoadmapStage };

export type RoadmapItemWithVotesFragment = { __typename?: 'RoadmapItem', needToHaveVoteCount?: string | number | null, niceToHaveVoteCount?: string | number | null, commentCount?: string | number | null, id: string, name?: string | null, summary?: string | null, description?: string | null, stage: RoadmapStage };

export type RoadmapItemVoteFragment = { __typename?: 'RoadmapItemVote', id: string, roadmapItemId: string, userId: string, voteType: RoadmapItemVoteType };

export type RoadmapItemVoteWithUserInfoFragment = { __typename?: 'RoadmapItemVote', id: string, roadmapItemId: string, userId: string, voteType: RoadmapItemVoteType, user?: { __typename?: 'User', id: string, fullName?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null } | null } | null };

export type ScheduledMessageFragment = { __typename?: 'ScheduledMessage', id: string, senderEmployeeId: string, name: string, subject: string, body: string, active: boolean, sendDate: Date | string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageRecipients: { __typename?: 'ScheduledMessageRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageRecipient', scheduledMessageId: string, employeeId: string } | null> }, scheduledMessageExternalRecipients: { __typename?: 'ScheduledMessageExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageExternalRecipient', scheduledMessageId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } };

export type ScheduledMessageTemplateFragment = { __typename?: 'ScheduledMessageTemplate', id: string, name: string, subject: string, includeEmployee: boolean, includeDirectManager?: boolean | null, includeGroups?: Array<string | null> | null, includeCustomEmployeeFields?: Array<string | null> | null, body: string, active: boolean, startDay: number, duration: number, sendTime: string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'ProjectTemplate', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageTemplateRecipients: { __typename?: 'ScheduledMessageTemplateRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplateRecipient', scheduledMessageTemplateId: string, employeeId: string } | null> }, scheduledMessageTemplateExternalRecipients: { __typename?: 'ScheduledMessageTemplateExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplateExternalRecipient', scheduledMessageTemplateId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } };

export type TaskFragment = { __typename?: 'Task', id: string, name: string, order?: number | null, startDate: Date | string, endDate: Date | string, deadlineReminderDate?: Date | string | null, notes?: string | null, projectId?: string | null, processId?: string | null, parentTaskId?: string | null, completed: boolean, archived: boolean, calendarEventFrom?: Date | string | null, calendarEventTo?: Date | string | null, calendarEventOrganizerId?: string | null, departments?: Array<string | null> | null, userIds?: Array<string | null> | null, parentTask?: { __typename?: 'Task', id: string, name: string, projectId?: string | null, processId?: string | null, startDate: Date | string, endDate: Date | string } | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean, processTypeId?: string | null } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskResponsibles: { __typename?: 'TaskResponsiblesConnection', nodes: Array<{ __typename?: 'TaskResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskEmployees: { __typename?: 'TaskEmployeesConnection', nodes: Array<{ __typename?: 'TaskEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } };

export type TaskTemplateFragment = { __typename?: 'TaskTemplate', id: string, name: string, order?: number | null, startDay: number, duration: number, deadlineReminder?: number | null, useCalendarEvent: boolean, calendarEventFrom?: string | null, calendarEventTo?: string | null, calendarEventOrganizerId?: string | null, notes?: string | null, projectId?: string | null, processId?: string | null, includeEmployee: boolean, includeDirectManager: boolean, includeEmployeeResponsible: boolean, includeDirectManagerResponsible: boolean, includeCustomEmployeeFields?: Array<string | null> | null, includeCustomEmployeeFieldsResponsibles?: Array<string | null> | null, includeGroups?: Array<string | null> | null, includeGroupsResponsibles?: Array<string | null> | null, parentTaskId?: string | null, parentTask?: { __typename?: 'TaskTemplate', id: string, name: string, projectId?: string | null, processId?: string | null, duration: number, startDay: number } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskTemplateResponsibles: { __typename?: 'TaskTemplateResponsiblesConnection', nodes: Array<{ __typename?: 'TaskTemplateResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskTemplateEmployees: { __typename?: 'TaskTemplateEmployeesConnection', nodes: Array<{ __typename?: 'TaskTemplateEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } };

export type TimeRegistrationTimesheetWeekItemFragment = { __typename?: 'TimeRegistrationPresence', id: string, weekNumber?: number | null, weekStartDate?: Date | string | null, startDate: Date | string, endDate?: Date | string | null, note?: string | null, compliesWithElevenHourRule?: boolean | null, elapsedTime?: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null } | null, restTime?: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null } | null, timeRegistrationPresenceType?: { __typename?: 'TimeRegistrationPresenceType', id: string, localizedName?: string | null, emoji: string } | null, projects: { __typename?: 'TimeRegistrationEntriesConnection', nodes: Array<{ __typename?: 'TimeRegistrationEntry', id: string, note?: string | null, timeRegistrationProject?: { __typename?: 'TimeRegistrationProject', id: string, localizedName?: string | null, color: string } | null } | null> } };

export type TimeRegistrationTimesheetEntryFragment = { __typename?: 'TimeRegistrationEntry', id: string, startDate: Date | string, endDate?: Date | string | null, timeRegistrationEntryType: TimeRegistrationEntryType, note?: string | null, elapsedTime?: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null } | null, timeRegistrationProject?: { __typename?: 'TimeRegistrationProject', id: string, localizedName?: string | null, color: string } | null, timeRegistrationBreakType?: { __typename?: 'TimeRegistrationBreakType', id: string, localizedName?: string | null, emoji: string } | null };

export type TimeRegistrationUserOverviewItemFragment = { __typename?: 'TimeRegistrationUserOverviewRecord', userId?: string | null, fullName?: string | null, logo?: string | null, averageWeeklyHoursLastFourMonths?: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null } | null, hoursThisWeek?: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null } | null, breaksThisWeek?: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null } | null };

export type TimeRegistrationProfileItemFragment = { __typename?: 'TimeRegistrationPresence', id: string, startDate: Date | string, endDate?: Date | string | null, timeRegistrationPresenceType?: { __typename?: 'TimeRegistrationPresenceType', id: string, localizedName?: string | null, emoji: string } | null, timeRegistrationEntries: { __typename?: 'TimeRegistrationEntriesConnection', nodes: Array<{ __typename?: 'TimeRegistrationEntry', id: string, startDate: Date | string, endDate?: Date | string | null, timeRegistrationEntryType: TimeRegistrationEntryType, timeRegistrationProject?: { __typename?: 'TimeRegistrationProject', id: string, localizedName?: string | null, color: string } | null, timeRegistrationBreakType?: { __typename?: 'TimeRegistrationBreakType', id: string, localizedName?: string | null } | null } | null> } };

export type TimeRegistrationPresenceTemplateFragment = { __typename?: 'TimeRegistrationPresenceTemplate', id: string, dayOfWeek: number, startTime: string, endTime: string, timeRegistrationPresenceTypeId: string, timeRegistrationEntryTemplates: { __typename?: 'TimeRegistrationEntryTemplatesConnection', nodes: Array<{ __typename?: 'TimeRegistrationEntryTemplate', id: string, startTime: string, endTime: string, timeRegistrationEntryType: TimeRegistrationEntryType, timeRegistrationProjectId?: string | null, timeRegistrationBreakTypeId?: string | null } | null> } };

export type TranslatedEntityLocalizationsFragment = { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } };

export type UserCompanyGroupFragment = { __typename?: 'UserCompanyGroup', userId: string, groupId: string, companyId: string, group?: { __typename?: 'Group', id: string, name?: string | null, localizedName?: string | null, description?: string | null, scope?: RoleScope | null } | null, user?: { __typename?: 'User', employeeByUserId?: { __typename?: 'Employee', id: string, userId: string } | null } | null };

export type UserDepartmentGroupFragment = { __typename?: 'UserDepartmentGroup', userId: string, departmentId: string, groupId: string, companyId: string, inheritToDescendants: boolean, onlyIncludeInDescendants: boolean, department?: { __typename?: 'Department', id: string, name: string } | null, group?: { __typename?: 'Group', id: string, name?: string | null, localizedName?: string | null, description?: string | null, scope?: RoleScope | null } | null, user?: { __typename?: 'User', employeeByUserId?: { __typename?: 'Employee', id: string, userId: string } | null } | null };

export type UserGroupFragment = { __typename?: 'UserGroup', userId: string, groupId: string, companyId: string, group?: { __typename?: 'Group', id: string, name?: string | null, localizedName?: string | null, description?: string | null, scope?: RoleScope | null } | null, user?: { __typename?: 'User', employeeByUserId?: { __typename?: 'Employee', id: string, userId: string } | null } | null };

export type UserOnBehalfPermissionFragment = { __typename?: 'UserOnBehalfPermission', id: string, userId: string, onBehalfOfUserId: string, companyId: string, user?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null, jobPositionTitle?: string | null } | null, onBehalfOfUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null, jobPositionTitle?: string | null } | null };

export type VacationTypeFragment = { __typename?: 'VacationType', id: string, name: string, localizedName?: string | null, color: string, active: boolean, companyId: string, absenceCode?: string | null, quickAction: boolean, emoji?: string | null, description?: string | null, mustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, sendCalendarInvite: boolean };

export type VacationUserFragment = { __typename?: 'VacationUser', id: string, vacationTypeId: string, allDay: boolean, startDate: Date | string, endDate: Date | string, durationDays?: string | number | null, note?: string | null, active: boolean, userId: string, departmentIds?: Array<string | null> | null, companyId: string, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, approvalId?: string | null, vacationType?: { __typename?: 'VacationType', id: string, name: string, localizedName?: string | null, color: string, active: boolean, companyId: string, absenceCode?: string | null, quickAction: boolean, emoji?: string | null, description?: string | null, mustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, sendCalendarInvite: boolean } | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null, creatorUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null };

export type CreateAnnouncementMutationVariables = Exact<{
  userId: Scalars['UUID'];
  companyId: Scalars['UUID'];
  departmentIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  systemAnnouncement: Scalars['Boolean'];
  title: Scalars['String'];
  teaser?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  addPlayIcon?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  popup?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  publishAt?: InputMaybe<Scalars['Datetime']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
}>;


export type CreateAnnouncementMutation = { __typename?: 'Mutation', createAnnouncement?: { __typename?: 'CreateAnnouncementPayload', announcement?: { __typename?: 'Announcement', id: string, userId?: string | null, companyId: string, departmentIds: Array<string | null>, systemAnnouncement: boolean, title: string, teaser?: string | null, content?: string | null, url?: string | null, addPlayIcon: boolean, popup: boolean, locales: Array<string | null>, published: boolean, active: boolean, publishAt?: Date | string | null, expireAt?: Date | string | null, createdAt: Date | string, updatedAt: Date | string } | null } | null };

export type UpdateAnnouncementMutationVariables = Exact<{
  id: Scalars['UUID'];
  departmentIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  systemAnnouncement: Scalars['Boolean'];
  title: Scalars['String'];
  teaser?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  addPlayIcon?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  popup?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  publishAt?: InputMaybe<Scalars['Datetime']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
}>;


export type UpdateAnnouncementMutation = { __typename?: 'Mutation', updateAnnouncementById?: { __typename?: 'UpdateAnnouncementPayload', announcement?: { __typename?: 'Announcement', id: string, userId?: string | null, companyId: string, departmentIds: Array<string | null>, systemAnnouncement: boolean, title: string, teaser?: string | null, content?: string | null, url?: string | null, addPlayIcon: boolean, popup: boolean, locales: Array<string | null>, published: boolean, active: boolean, publishAt?: Date | string | null, expireAt?: Date | string | null, createdAt: Date | string, updatedAt: Date | string } | null } | null };

export type DeleteAnnouncementMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteAnnouncementMutation = { __typename?: 'Mutation', updateAnnouncementById?: { __typename?: 'UpdateAnnouncementPayload', announcement?: { __typename?: 'Announcement', id: string, title: string } | null } | null };

export type UploadThumbnailMutationVariables = Exact<{
  base64?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  mimetype?: InputMaybe<Scalars['String']>;
}>;


export type UploadThumbnailMutation = { __typename?: 'Mutation', FileUploadPublic?: { __typename?: 'FileUploadPublicPayload', filename?: string | null, mimetype?: string | null, url?: string | null } | null };

export type ReadAnnouncementMutationVariables = Exact<{
  userId: Scalars['UUID'];
  announcementId: Scalars['UUID'];
}>;


export type ReadAnnouncementMutation = { __typename?: 'Mutation', createUserAnnouncement?: { __typename?: 'CreateUserAnnouncementPayload', clientMutationId?: string | null } | null };

export type AnnouncementReadAllMutationVariables = Exact<{ [key: string]: never; }>;


export type AnnouncementReadAllMutation = { __typename?: 'Mutation', announcementReadAll?: { __typename?: 'AnnouncementReadAllPayload', clientMutationId?: string | null } | null };

export type ApproveItemMutationVariables = Exact<{
  id: Scalars['UUID'];
  approvedAt?: InputMaybe<Scalars['Datetime']>;
}>;


export type ApproveItemMutation = { __typename?: 'Mutation', updateApprovalById?: { __typename?: 'UpdateApprovalPayload', approval?: { __typename?: 'Approval', id: string, approvedAt?: Date | string | null, approvingUserId?: string | null, futureDatumByApprovalId?: { __typename?: 'FutureDatum', id: string, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null, vacationUserByApprovalId?: { __typename?: 'VacationUser', id: string, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null } | null } | null };

export type DenyItemMutationVariables = Exact<{
  id: Scalars['UUID'];
  deniedAt?: InputMaybe<Scalars['Datetime']>;
}>;


export type DenyItemMutation = { __typename?: 'Mutation', updateApprovalById?: { __typename?: 'UpdateApprovalPayload', approval?: { __typename?: 'Approval', id: string, deniedAt?: Date | string | null, approvingUserId?: string | null, futureDatumByApprovalId?: { __typename?: 'FutureDatum', id: string, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null, vacationUserByApprovalId?: { __typename?: 'VacationUser', id: string, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null } | null } | null };

export type ResetItemMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ResetItemMutation = { __typename?: 'Mutation', updateApprovalById?: { __typename?: 'UpdateApprovalPayload', approval?: { __typename?: 'Approval', id: string, approvedAt?: Date | string | null, deniedAt?: Date | string | null, approvingUserId?: string | null, futureDatumByApprovalId?: { __typename?: 'FutureDatum', id: string, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null, vacationUserByApprovalId?: { __typename?: 'VacationUser', id: string, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null } | null } | null };

export type DeleteAsyncJobMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteAsyncJobMutation = { __typename?: 'Mutation', updateAsyncJobById?: { __typename?: 'UpdateAsyncJobPayload', clientMutationId?: string | null } | null };

export type CreateAuthAppMutationMutationVariables = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
  homepageUri: Scalars['String'];
  appType: Scalars['Int'];
  groupId?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateAuthAppMutationMutation = { __typename?: 'Mutation', createAuthAppMutation?: { __typename?: 'AuthAppPayload', response?: any | null } | null };

export type UpdateAuthAppMutationMutationVariables = Exact<{
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  homepageUri: Scalars['String'];
  id: Scalars['UUID'];
  groupId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpdateAuthAppMutationMutation = { __typename?: 'Mutation', updateAuthAppMutation?: { __typename?: 'AuthAppPayload', response?: any | null } | null };

export type DeleteAuthAppMutationMutationVariables = Exact<{
  appId: Scalars['UUID'];
}>;


export type DeleteAuthAppMutationMutation = { __typename?: 'Mutation', deleteAuthAppMutation?: { __typename?: 'AuthAppPayload', response?: any | null } | null };

export type RenewClientSecretMutationMutationVariables = Exact<{
  appId: Scalars['UUID'];
}>;


export type RenewClientSecretMutationMutation = { __typename?: 'Mutation', renewClientSecretMutation?: { __typename?: 'renewClientSecretPayload', response?: any | null } | null };

export type CreateIntegrationFieldMarkingMutationVariables = Exact<{
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  integrationName: Scalars['String'];
  sendsData?: InputMaybe<Scalars['Boolean']>;
  receivesData?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  storageId?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateIntegrationFieldMarkingMutation = { __typename?: 'Mutation', createIntegrationFieldMarking?: { __typename?: 'CreateIntegrationFieldMarkingPayload', clientMutationId?: string | null } | null };

export type DeleteIntegrationFieldMarkingByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteIntegrationFieldMarkingByIdMutation = { __typename?: 'Mutation', updateIntegrationFieldMarkingById?: { __typename?: 'UpdateIntegrationFieldMarkingPayload', clientMutationId?: string | null } | null };

export type UpdateIntegrationFieldMarkingByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  authAppId?: InputMaybe<Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  integrationName: Scalars['String'];
  sendsData?: InputMaybe<Scalars['Boolean']>;
  receivesData?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  storageId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpdateIntegrationFieldMarkingByIdMutation = { __typename?: 'Mutation', updateIntegrationFieldMarkingById?: { __typename?: 'UpdateIntegrationFieldMarkingPayload', clientMutationId?: string | null } | null };

export type RequestPinCodeMutationVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type RequestPinCodeMutation = { __typename?: 'Mutation', requestPinCode?: { __typename?: 'requestPinCodePayload', sentTo?: string | null } | null };

export type CheckPinCodeMutationVariables = Exact<{
  userId: Scalars['UUID'];
  pin: Scalars['String'];
}>;


export type CheckPinCodeMutation = { __typename?: 'Mutation', checkPinCode?: boolean | null };

export type CreateChangelogUserMutationVariables = Exact<{
  changeLogId: Scalars['UUID'];
  userId: Scalars['UUID'];
}>;


export type CreateChangelogUserMutation = { __typename?: 'Mutation', createChangelogUser?: { __typename?: 'CreateChangelogUserPayload', changelog?: { __typename?: 'Changelog', id: string, version: string, changelogUsers: { __typename?: 'ChangelogUsersConnection', totalCount: number } } | null } | null };

export type CreateChangelogMutationVariables = Exact<{
  version: Scalars['String'];
  system: SystemType;
  releaseDate: Scalars['Date'];
  major?: InputMaybe<Scalars['String']>;
  minor?: InputMaybe<Scalars['String']>;
  guides?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  isAppNotes?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateChangelogMutation = { __typename?: 'Mutation', createChangelog?: { __typename?: 'CreateChangelogPayload', changelog?: { __typename?: 'Changelog', id: string, version: string, system: SystemType, releaseDate: Date | string, major?: string | null, minor?: string | null, guides?: string | null, published: boolean, locale: string, isAppNotes: boolean } | null } | null };

export type UpdateChangelogByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  version: Scalars['String'];
  system: SystemType;
  releaseDate: Scalars['Date'];
  major?: InputMaybe<Scalars['String']>;
  minor?: InputMaybe<Scalars['String']>;
  guides?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  isAppNotes?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateChangelogByIdMutation = { __typename?: 'Mutation', updateChangelogById?: { __typename?: 'UpdateChangelogPayload', changelog?: { __typename?: 'Changelog', id: string, version: string, system: SystemType, releaseDate: Date | string, major?: string | null, minor?: string | null, guides?: string | null, published: boolean, locale: string, isAppNotes: boolean } | null } | null };

export type DeleteChangelogByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteChangelogByIdMutation = { __typename?: 'Mutation', deleteChangelogById?: { __typename?: 'DeleteChangelogPayload', changelog?: { __typename?: 'Changelog', id: string, version: string, system: SystemType, releaseDate: Date | string, major?: string | null, minor?: string | null, guides?: string | null, published: boolean, locale: string, isAppNotes: boolean } | null } | null };

export type PublishChangelogByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PublishChangelogByIdMutation = { __typename?: 'Mutation', updateChangelogById?: { __typename?: 'UpdateChangelogPayload', changelog?: { __typename?: 'Changelog', id: string, version: string, system: SystemType, releaseDate: Date | string, major?: string | null, minor?: string | null, guides?: string | null, published: boolean, locale: string, isAppNotes: boolean } | null } | null };

export type UnpublishChangelogByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UnpublishChangelogByIdMutation = { __typename?: 'Mutation', updateChangelogById?: { __typename?: 'UpdateChangelogPayload', changelog?: { __typename?: 'Changelog', id: string, version: string, system: SystemType, releaseDate: Date | string, major?: string | null, minor?: string | null, guides?: string | null, published: boolean, locale: string, isAppNotes: boolean } | null } | null };

export type CreateChosenColumnsMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  tableName: Scalars['String'];
  chosenColumns?: InputMaybe<Scalars['JSON']>;
  filters?: InputMaybe<Scalars['JSON']>;
  miscellaneousFilters?: InputMaybe<Scalars['JSON']>;
}>;


export type CreateChosenColumnsMutation = { __typename?: 'Mutation', createChosenColumn?: { __typename?: 'CreateChosenColumnPayload', clientMutationId?: string | null } | null };

export type UpdateChosenColumnsByUserIdAndTableNameMutationVariables = Exact<{
  userId: Scalars['UUID'];
  tableName: Scalars['String'];
  chosenColumns?: InputMaybe<Scalars['JSON']>;
  filters?: InputMaybe<Scalars['JSON']>;
  miscellaneousFilters?: InputMaybe<Scalars['JSON']>;
}>;


export type UpdateChosenColumnsByUserIdAndTableNameMutation = { __typename?: 'Mutation', updateChosenColumnByUserIdAndTableName?: { __typename?: 'UpdateChosenColumnPayload', clientMutationId?: string | null } | null };

export type UploadCompanyLogoMutationVariables = Exact<{
  filename?: InputMaybe<Scalars['String']>;
  mimetype?: InputMaybe<Scalars['String']>;
  fileOwnerId: Scalars['UUID'];
  base64?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
}>;


export type UploadCompanyLogoMutation = { __typename?: 'Mutation', deactivateOldCompanyLogo?: { __typename?: 'DeactivateOldCompanyLogoPayload', clientMutationId?: string | null } | null, FileUploadLogo?: { __typename?: 'FileUploadPayload', id?: string | null, filename?: string | null, mimetype?: string | null, path?: string | null, fileType?: string | null, fileOwner?: StorageFileOwner | null, fileOwnerId?: string | null, documentTypeId?: string | null, base64?: string | null } | null };

export type RemoveCompanyLogoMutationVariables = Exact<{
  fileOwnerId: Scalars['UUID'];
}>;


export type RemoveCompanyLogoMutation = { __typename?: 'Mutation', deactivateOldCompanyLogo?: { __typename?: 'DeactivateOldCompanyLogoPayload', clientMutationId?: string | null } | null };

export type CompanyUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  sso?: InputMaybe<Scalars['String']>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  masterTemplate?: InputMaybe<Scalars['Boolean']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
  availableLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  companyBindingIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type CompanyUpdateMutation = { __typename?: 'Mutation', updateCompanyById?: { __typename?: 'UpdateCompanyPayload', company?: { __typename?: 'Company', id: string, name?: string | null, description?: string | null, cvr?: string | null, url?: string | null, logo?: string | null, sso?: string | null, locale?: string | null, departments: { __typename?: 'DepartmentsConnection', edges: Array<{ __typename?: 'DepartmentsEdge', node?: { __typename?: 'Department', id: string, mainDepartment: boolean, name: string, description?: string | null, cvr?: string | null, alias?: string | null, pNumber?: number | null, ean?: string | null } | null }> } } | null } | null };

export type CompanyDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CompanyDeleteMutation = { __typename?: 'Mutation', updateCompanyById?: { __typename?: 'UpdateCompanyPayload', clientMutationId?: string | null } | null };

export type CopyCompanyMutationVariables = Exact<{
  fromCompanyId: Scalars['UUID'];
  name: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
  cvr?: InputMaybe<Scalars['String']>;
  companyTypeId?: InputMaybe<Scalars['UUID']>;
  departmentName?: InputMaybe<Scalars['String']>;
  pNumber?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  mobile?: InputMaybe<Scalars['String']>;
  jobPositionTitle: Scalars['String'];
  jobPositionType: Scalars['String'];
  locale: Scalars['String'];
  companyBindingIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  logo?: InputMaybe<Scalars['Upload']>;
  masterForCompanyId?: InputMaybe<Scalars['UUID']>;
  availableLocales: Array<Scalars['String']> | Scalars['String'];
  minimumEmployeeNumber?: InputMaybe<Scalars['Int']>;
  includePersonData?: InputMaybe<Scalars['Boolean']>;
  nativeAppAccess?: InputMaybe<Scalars['Boolean']>;
}>;


export type CopyCompanyMutation = { __typename?: 'Mutation', copyCompany?: { __typename?: 'CopyCompanyPayload', company?: { __typename?: 'Company', id: string } | null } | null };

export type UpsertCompanySettingMutationVariables = Exact<{
  key: CompanySettingKey;
  value?: InputMaybe<Scalars['String']>;
  valueBoolean?: InputMaybe<Scalars['Boolean']>;
  valueStorageId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpsertCompanySettingMutation = { __typename?: 'Mutation', upsertCompanySetting?: { __typename?: 'CompanySetting', id: string, companyId: string, key: CompanySettingKey, value?: string | null, valueBoolean?: boolean | null } | null };

export type CreateCompanyTypeMutationVariables = Exact<{
  name: Scalars['String'];
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateCompanyTypeMutation = { __typename?: 'Mutation', createCompanyType?: { __typename?: 'CreateCompanyTypePayload', companyType?: { __typename?: 'CompanyType', id: string, name: string, disable2Fa: boolean } | null } | null };

export type UpdateCompanyTypeMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateCompanyTypeMutation = { __typename?: 'Mutation', updateCompanyTypeById?: { __typename?: 'UpdateCompanyTypePayload', companyType?: { __typename?: 'CompanyType', id: string, name: string, disable2Fa: boolean } | null } | null };

export type DeleteCompanyTypeMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteCompanyTypeMutation = { __typename?: 'Mutation', deleteCompanyTypeById?: { __typename?: 'DeleteCompanyTypePayload', companyType?: { __typename?: 'CompanyType', id: string, name: string, disable2Fa: boolean } | null } | null };

export type CreateCompanyCompanyTypeMutationVariables = Exact<{
  companyCompanyType: CompanyCompanyTypeInput;
}>;


export type CreateCompanyCompanyTypeMutation = { __typename?: 'Mutation', createCompanyCompanyType?: { __typename?: 'CreateCompanyCompanyTypePayload', companyCompanyType?: { __typename?: 'CompanyCompanyType', companyId: string, companyType?: { __typename?: 'CompanyType', id: string, name: string, disable2Fa: boolean } | null } | null } | null };

export type UpdateCompanyCompanyTypeByCompanyIdMutationVariables = Exact<{
  companyId: Scalars['UUID'];
  companyCompanyType: CompanyCompanyTypePatch;
}>;


export type UpdateCompanyCompanyTypeByCompanyIdMutation = { __typename?: 'Mutation', updateCompanyCompanyTypeByCompanyId?: { __typename?: 'UpdateCompanyCompanyTypePayload', companyCompanyType?: { __typename?: 'CompanyCompanyType', companyId: string, companyType?: { __typename?: 'CompanyType', id: string, name: string, disable2Fa: boolean } | null } | null } | null };

export type CompetenceGroupCreateMutationVariables = Exact<{
  name: Scalars['String'];
  companyId?: InputMaybe<Scalars['UUID']>;
}>;


export type CompetenceGroupCreateMutation = { __typename?: 'Mutation', createCompetenceGroup?: { __typename?: 'CreateCompetenceGroupPayload', competenceGroup?: { __typename?: 'CompetenceGroup', id: string, name: string } | null } | null };

export type UpdateCompetenceGroupByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
}>;


export type UpdateCompetenceGroupByIdMutation = { __typename?: 'Mutation', updateCompetenceGroupById?: { __typename?: 'UpdateCompetenceGroupPayload', competenceGroup?: { __typename?: 'CompetenceGroup', id: string, name: string } | null } | null };

export type CompetenceGroupDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CompetenceGroupDeleteMutation = { __typename?: 'Mutation', updateCompetenceGroupById?: { __typename?: 'UpdateCompetenceGroupPayload', competenceGroup?: { __typename?: 'CompetenceGroup', id: string, name: string } | null } | null };

export type CompetenceCreateMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['UUID']>;
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  outdateInterval: IntervalInput;
  reminderInterval: IntervalInput;
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  useRating?: InputMaybe<Scalars['Boolean']>;
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
}>;


export type CompetenceCreateMutation = { __typename?: 'Mutation', createCompetence?: { __typename?: 'CreateCompetencePayload', competence?: { __typename?: 'Competence', id: string, name: string } | null } | null };

export type UpdateCompetenceByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  competenceGroupId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  outdateCompetence?: InputMaybe<Scalars['Boolean']>;
  outdateInterval: IntervalInput;
  reminderInterval: IntervalInput;
  updateReminder?: InputMaybe<Scalars['Boolean']>;
  useRating?: InputMaybe<Scalars['Boolean']>;
  onlyManagerShouldEvaluate?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateCompetenceByIdMutation = { __typename?: 'Mutation', updateCompetenceById?: { __typename?: 'UpdateCompetencePayload', competence?: { __typename?: 'Competence', id: string, name: string } | null } | null };

export type CompetenceDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CompetenceDeleteMutation = { __typename?: 'Mutation', updateCompetenceById?: { __typename?: 'UpdateCompetencePayload', competence?: { __typename?: 'Competence', id: string } | null } | null };

export type UserCompetenceDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UserCompetenceDeleteMutation = { __typename?: 'Mutation', updateUserCompetenceById?: { __typename?: 'UpdateUserCompetencePayload', userCompetence?: { __typename?: 'UserCompetence', id: string } | null } | null };

export type UserCompetenceEvaluationCreateMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['UUID']>;
  evaluatingUserId?: InputMaybe<Scalars['UUID']>;
  userCompetenceId?: InputMaybe<Scalars['UUID']>;
  evaluationDate?: InputMaybe<Scalars['Datetime']>;
  userId: Scalars['UUID'];
  nextUpdate?: InputMaybe<Scalars['Datetime']>;
  formFieldEntries?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInverseInput>;
}>;


export type UserCompetenceEvaluationCreateMutation = { __typename?: 'Mutation', createUserCompetenceEvaluation?: { __typename?: 'CreateUserCompetenceEvaluationPayload', userCompetenceEvaluation?: { __typename?: 'UserCompetenceEvaluation', id: string } | null } | null };

export type UserCompetenceEvaluationUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  nextUpdate?: InputMaybe<Scalars['Datetime']>;
  formFieldEntries?: InputMaybe<FormFieldEntryUserCompetenceEvaluationIdForeignInverseInput>;
  active?: InputMaybe<Scalars['Boolean']>;
  evaluationDate?: InputMaybe<Scalars['Datetime']>;
}>;


export type UserCompetenceEvaluationUpdateMutation = { __typename?: 'Mutation', updateUserCompetenceEvaluationById?: { __typename?: 'UpdateUserCompetenceEvaluationPayload', userCompetenceEvaluation?: { __typename?: 'UserCompetenceEvaluation', id: string } | null } | null };

export type UpdateUserCompetenceEvaluationCommentByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserCompetenceEvaluationCommentByIdMutation = { __typename?: 'Mutation', updateUserCompetenceEvaluationCommentById?: { __typename?: 'UpdateUserCompetenceEvaluationCommentPayload', userCompetenceEvaluationComment?: { __typename?: 'UserCompetenceEvaluationComment', id: string } | null } | null };

export type UserCompetenceEvaluationCommentDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UserCompetenceEvaluationCommentDeleteMutation = { __typename?: 'Mutation', updateUserCompetenceEvaluationCommentById?: { __typename?: 'UpdateUserCompetenceEvaluationCommentPayload', userCompetenceEvaluationComment?: { __typename?: 'UserCompetenceEvaluationComment', id: string } | null } | null };

export type CreateUserCompetenceEvaluationCommentMutationVariables = Exact<{
  comment?: InputMaybe<Scalars['String']>;
  userCompetenceEvaluationId?: InputMaybe<Scalars['UUID']>;
  userCompetenceUserId: Scalars['UUID'];
  userId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateUserCompetenceEvaluationCommentMutation = { __typename?: 'Mutation', createUserCompetenceEvaluationComment?: { __typename?: 'CreateUserCompetenceEvaluationCommentPayload', userCompetenceEvaluationComment?: { __typename?: 'UserCompetenceEvaluationComment', id: string } | null } | null };

export type UserCompetenceCreateMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  competenceId?: InputMaybe<Scalars['UUID']>;
  addedDate?: InputMaybe<Scalars['Datetime']>;
  userCompetenceEvaluations?: InputMaybe<UserCompetenceEvaluationUserCompetenceIdForeignInverseInput>;
}>;


export type UserCompetenceCreateMutation = { __typename?: 'Mutation', createUserCompetence?: { __typename?: 'CreateUserCompetencePayload', userCompetence?: { __typename?: 'UserCompetence', id: string } | null } | null };

export type UserCompetenceUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  addedDate?: InputMaybe<Scalars['Datetime']>;
}>;


export type UserCompetenceUpdateMutation = { __typename?: 'Mutation', updateUserCompetenceById?: { __typename?: 'UpdateUserCompetencePayload', userCompetence?: { __typename?: 'UserCompetence', id: string, addedDate: Date | string } | null } | null };

export type HtmlToPdfMutationVariables = Exact<{
  html: Scalars['String'];
  contractTemplateId?: InputMaybe<Scalars['UUID']>;
  header?: InputMaybe<Scalars['String']>;
  footer?: InputMaybe<Scalars['String']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  placeholders?: InputMaybe<Scalars['JSON']>;
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  signatureBase64?: InputMaybe<Scalars['String']>;
  signatureFileId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  appendSignaturePage?: InputMaybe<Scalars['Boolean']>;
  existingStorageId?: InputMaybe<Scalars['UUID']>;
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
}>;


export type HtmlToPdfMutation = { __typename?: 'Mutation', htmlToPdf?: { __typename?: 'HtmlToPdfPayload', base64: string, errors?: Array<string> | null } | null };

export type DocxToHtmlMutationVariables = Exact<{
  base64: Scalars['String'];
}>;


export type DocxToHtmlMutation = { __typename?: 'Mutation', docxToHtml?: { __typename?: 'DocxToHtmlPayload', html: string } | null };

export type UriToPdfMutationVariables = Exact<{
  uri: Scalars['String'];
}>;


export type UriToPdfMutation = { __typename?: 'Mutation', uriToPdf?: { __typename?: 'HtmlToPdfPayload', base64: string } | null };

export type CreateContractSignPendingMutationVariables = Exact<{
  employeeId: Scalars['UUID'];
  signDate?: InputMaybe<Scalars['Datetime']>;
  signingUserIds: Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>;
  signingUsers: Array<ContractSignerInput> | ContractSignerInput;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
  creatorUserId?: InputMaybe<Scalars['UUID']>;
  existingDocuments?: InputMaybe<Array<InputMaybe<ContractExistingDocumentInput>> | InputMaybe<ContractExistingDocumentInput>>;
  generatedDocuments?: InputMaybe<Array<InputMaybe<ContractGeneratedDocumentInput>> | InputMaybe<ContractGeneratedDocumentInput>>;
  mergeIntoOneDocument?: InputMaybe<Scalars['Boolean']>;
  mergedDocumentName?: InputMaybe<Scalars['String']>;
  mergedDocumentDocumentTypeId?: InputMaybe<Scalars['UUID']>;
  emailText?: InputMaybe<Scalars['String']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
}>;


export type CreateContractSignPendingMutation = { __typename?: 'Mutation', createContractSignPending?: { __typename?: 'CreateContractSignPendingPayload', contractSignPending?: { __typename?: 'ContractSignPending', id: string } | null } | null };

export type DeleteContractSignPendingMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteContractSignPendingMutation = { __typename?: 'Mutation', updateContractSignPendingById?: { __typename?: 'UpdateContractSignPendingPayload', contractSignPending?: { __typename?: 'ContractSignPending', id: string } | null } | null };

export type CreateSavedSignatureMutationVariables = Exact<{
  employeeId?: InputMaybe<Scalars['UUID']>;
  storageId?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateSavedSignatureMutation = { __typename?: 'Mutation', createSavedSignature?: { __typename?: 'CreateSavedSignaturePayload', savedSignature?: { __typename?: 'SavedSignature', id: string, employeeId: string, storageId: string } | null } | null };

export type DeleteSavedSignatureMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteSavedSignatureMutation = { __typename?: 'Mutation', deleteSavedSignatureById?: { __typename?: 'DeleteSavedSignaturePayload', savedSignature?: { __typename?: 'SavedSignature', id: string, employeeId: string, storageId: string } | null } | null };

export type CreateContractSignPendingSignerMutationVariables = Exact<{
  contractSignPendingId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  signOrder?: InputMaybe<Scalars['Int']>;
  useSecondaryEmail?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateContractSignPendingSignerMutation = { __typename?: 'Mutation', createContractSignPendingSigner?: { __typename?: 'CreateContractSignPendingSignerPayload', contractSignPendingSigner?: { __typename?: 'ContractSignPendingSigner', id: string, contractSignPendingId: string, signed: boolean, signDate?: Date | string | null, signatureFileId?: string | null, userId: string, createdAt: Date | string, refused: boolean, refusalReason?: string | null } | null } | null };

export type UpdateContractSignPendingSignerMutationVariables = Exact<{
  contractSignPendingId: Scalars['UUID'];
  userId: Scalars['UUID'];
  signed?: InputMaybe<Scalars['Boolean']>;
  signDate?: InputMaybe<Scalars['Datetime']>;
  signatureFileId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpdateContractSignPendingSignerMutation = { __typename?: 'Mutation', updateContractSignPendingSignerByContractSignPendingIdAndUserId?: { __typename?: 'UpdateContractSignPendingSignerPayload', contractSignPendingSigner?: { __typename?: 'ContractSignPendingSigner', id: string, contractSignPendingId: string, signed: boolean, signDate?: Date | string | null, signatureFileId?: string | null, userId: string, createdAt: Date | string, refused: boolean, refusalReason?: string | null } | null } | null };

export type RefuseSigningContractMutationVariables = Exact<{
  contractSignPendingId: Scalars['UUID'];
  userId: Scalars['UUID'];
  refusalReason?: InputMaybe<Scalars['String']>;
}>;


export type RefuseSigningContractMutation = { __typename?: 'Mutation', updateContractSignPendingSignerByContractSignPendingIdAndUserId?: { __typename?: 'UpdateContractSignPendingSignerPayload', contractSignPendingSigner?: { __typename?: 'ContractSignPendingSigner', id: string, contractSignPendingId: string, signed: boolean, signDate?: Date | string | null, signatureFileId?: string | null, userId: string, createdAt: Date | string, refused: boolean, refusalReason?: string | null } | null } | null };

export type UpdateEmployeeDataBasedOnSignedContractMutationVariables = Exact<{
  contractSignPendingDocumentId: Scalars['UUID'];
  fieldsToUpdate: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type UpdateEmployeeDataBasedOnSignedContractMutation = { __typename?: 'Mutation', updateEmployeeDataBasedOnSignedContract?: { __typename?: 'UpdateEmployeeDataBasedOnSignedContractPayload', fieldIdErrors?: Array<string | null> | null } | null };

export type SendContractLinkMutationVariables = Exact<{
  contractSignPendingSignerId: Scalars['UUID'];
}>;


export type SendContractLinkMutation = { __typename?: 'Mutation', sendContractLink?: boolean | null };

export type FixBrokenContractMutationVariables = Exact<{
  contractSignPendingId: Scalars['UUID'];
}>;


export type FixBrokenContractMutation = { __typename?: 'Mutation', fixBrokenContract?: boolean | null };

export type ContractPredefinedPlaceholdersCreateMutationVariables = Exact<{
  input: ContractPredefinedPlaceholderInput;
}>;


export type ContractPredefinedPlaceholdersCreateMutation = { __typename?: 'Mutation', createContractPredefinedPlaceholder?: { __typename?: 'CreateContractPredefinedPlaceholderPayload', contractPredefinedPlaceholder?: { __typename?: 'ContractPredefinedPlaceholder', id: string, placeholder?: string | null, alias?: string | null } | null } | null };

export type ContractPredefinedPlaceholdersUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  placeholder?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type ContractPredefinedPlaceholdersUpdateMutation = { __typename?: 'Mutation', updateContractPredefinedPlaceholderById?: { __typename?: 'UpdateContractPredefinedPlaceholderPayload', contractPredefinedPlaceholder?: { __typename?: 'ContractPredefinedPlaceholder', id: string } | null } | null };

export type CreateContractTemplateMutationVariables = Exact<{
  companyId: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  jobPositionTypes?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  placeholders?: InputMaybe<Scalars['JSON']>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInverseInput>;
  usersSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  departmentsSharedWith?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  html?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  footer?: InputMaybe<Scalars['String']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
}>;


export type CreateContractTemplateMutation = { __typename?: 'Mutation', createContractTemplate?: { __typename?: 'CreateContractTemplatePayload', contractTemplate?: { __typename?: 'ContractTemplate', id: string, companyId: string, name?: string | null, description?: string | null, active: boolean, jobPositionTypes?: Array<string | null> | null, placeholders?: any | null, htmlPlaceholders?: Array<string | null> | null, html?: string | null, header?: string | null, footer?: string | null, dateFormat: string, pageNumber: boolean, locale: string, topMargin: string | number, bottomMargin: string | number, leftMargin: string | number, rightMargin: string | number, createdAt: Date | string, updatedAt: Date | string, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null, lifetime?: number | null } | null, contractTemplateDepartments: { __typename?: 'ContractTemplateDepartmentsConnection', nodes: Array<{ __typename?: 'ContractTemplateDepartment', departmentId: string, department?: { __typename?: 'Department', id: string, name: string, companyId?: string | null } | null } | null> }, contractTemplateUsers: { __typename?: 'ContractTemplateUsersConnection', nodes: Array<{ __typename?: 'ContractTemplateUser', userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null, companyId: string } | null } | null> } } | null } | null };

export type UpdateContractTemplateByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  companyId: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  jobPositionTypes?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  contractTemplateDepartments?: InputMaybe<ContractTemplateDepartmentsContractTemplateIdForeignInverseInput>;
  contractTemplateUsers?: InputMaybe<ContractTemplateUsersContractTemplateIdForeignInverseInput>;
  html?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  footer?: InputMaybe<Scalars['String']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  topMargin?: InputMaybe<Scalars['BigFloat']>;
  bottomMargin?: InputMaybe<Scalars['BigFloat']>;
  leftMargin?: InputMaybe<Scalars['BigFloat']>;
  rightMargin?: InputMaybe<Scalars['BigFloat']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateContractTemplateByIdMutation = { __typename?: 'Mutation', updateContractTemplateById?: { __typename?: 'UpdateContractTemplatePayload', contractTemplate?: { __typename?: 'ContractTemplate', id: string, companyId: string, name?: string | null, description?: string | null, active: boolean, jobPositionTypes?: Array<string | null> | null, placeholders?: any | null, htmlPlaceholders?: Array<string | null> | null, html?: string | null, header?: string | null, footer?: string | null, dateFormat: string, pageNumber: boolean, locale: string, topMargin: string | number, bottomMargin: string | number, leftMargin: string | number, rightMargin: string | number, createdAt: Date | string, updatedAt: Date | string, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null, lifetime?: number | null } | null, contractTemplateDepartments: { __typename?: 'ContractTemplateDepartmentsConnection', nodes: Array<{ __typename?: 'ContractTemplateDepartment', departmentId: string, department?: { __typename?: 'Department', id: string, name: string, companyId?: string | null } | null } | null> }, contractTemplateUsers: { __typename?: 'ContractTemplateUsersConnection', nodes: Array<{ __typename?: 'ContractTemplateUser', userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null, companyId: string } | null } | null> } } | null } | null };

export type CloneContactTemplateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
  signable: Scalars['Boolean'];
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  getData: Scalars['Boolean'];
}>;


export type CloneContactTemplateMutation = { __typename?: 'Mutation', cloneContractTemplate?: { __typename?: 'CloneContractTemplatePayload', contractTemplate?: { __typename?: 'ContractTemplate', id: string, name?: string | null, html?: string | null, documentTypeId?: string | null, locale?: string, dateFormat?: string, documentType?: { __typename?: 'DocumentType', lifetime?: number | null } | null } | null } | null };

export type CreateCustomWidgetMutationVariables = Exact<{
  widgetSize: Scalars['Int'];
  useImage: Scalars['Boolean'];
  backgroundColor: Scalars['String'];
  widgetTextColor: Scalars['String'];
  buttonTextColor: Scalars['String'];
  buttonBackgroundColor: Scalars['String'];
  buttonBorder: Scalars['Boolean'];
  imageLayout?: InputMaybe<Scalars['String']>;
  customWidgetContents?: InputMaybe<Array<CustomWidgetContentCustomWidgetIdForeignConnectionCustomWidgetContentCreateInput> | CustomWidgetContentCustomWidgetIdForeignConnectionCustomWidgetContentCreateInput>;
}>;


export type CreateCustomWidgetMutation = { __typename?: 'Mutation', createCustomWidget?: { __typename?: 'CreateCustomWidgetPayload', customWidget?: { __typename?: 'CustomWidget', id: string } | null } | null };

export type UpdateCustomWidgetMutationVariables = Exact<{
  id: Scalars['UUID'];
  widgetSize?: InputMaybe<Scalars['Int']>;
  useImage?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  widgetTextColor?: InputMaybe<Scalars['String']>;
  buttonTextColor?: InputMaybe<Scalars['String']>;
  buttonBackgroundColor?: InputMaybe<Scalars['String']>;
  buttonBorder?: InputMaybe<Scalars['Boolean']>;
  imageLayout?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  customWidgetContents?: InputMaybe<CustomWidgetContentCustomWidgetIdForeignInverseInput>;
}>;


export type UpdateCustomWidgetMutation = { __typename?: 'Mutation', updateCustomWidgetById?: { __typename?: 'UpdateCustomWidgetPayload', clientMutationId?: string | null } | null };

export type CreateCvTemplateFieldMappingMutationVariables = Exact<{
  cvTemplateField: Scalars['String'];
  companyId?: InputMaybe<Scalars['UUID']>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateCvTemplateFieldMappingMutation = { __typename?: 'Mutation', createCvTemplateFieldMapping?: { __typename?: 'CreateCvTemplateFieldMappingPayload', cvTemplateFieldMapping?: { __typename?: 'CvTemplateFieldMapping', id: string, cvTemplateField: string, systemFieldId?: string | null, formFieldId?: string | null } | null } | null };

export type UpdateCvTemplateFieldMappingByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  cvTemplateField?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpdateCvTemplateFieldMappingByIdMutation = { __typename?: 'Mutation', updateCvTemplateFieldMappingById?: { __typename?: 'UpdateCvTemplateFieldMappingPayload', cvTemplateFieldMapping?: { __typename?: 'CvTemplateFieldMapping', id: string, cvTemplateField: string, systemFieldId?: string | null, formFieldId?: string | null } | null } | null };

export type DeleteCvTemplateFieldMappingByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteCvTemplateFieldMappingByIdMutation = { __typename?: 'Mutation', deleteCvTemplateFieldMappingById?: { __typename?: 'DeleteCvTemplateFieldMappingPayload', clientMutationId?: string | null } | null };

export type CreateDashboardViewMutationVariables = Exact<{
  name: Scalars['String'];
  copyDashboardViewId?: InputMaybe<Scalars['UUID']>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type CreateDashboardViewMutation = { __typename?: 'Mutation', createDashboardView?: { __typename?: 'CreateDashboardViewPayload', dashboardView?: { __typename?: 'DashboardView', id: string } | null } | null };

export type UpdateDashboardViewByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateDashboardViewByIdMutation = { __typename?: 'Mutation', updateDashboardViewById?: { __typename?: 'UpdateDashboardViewPayload', clientMutationId?: string | null } | null };

export type CreateDashboardCardMutationVariables = Exact<{
  dashboardViewId: Scalars['UUID'];
  customWidgetId?: InputMaybe<Scalars['UUID']>;
  type: DashboardCardType;
  statistics?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInverseInput>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  jobPositionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type CreateDashboardCardMutation = { __typename?: 'Mutation', createDashboardCard?: { __typename?: 'CreateDashboardCardPayload', clientMutationId?: string | null } | null };

export type UpdateDashboardCardByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  type?: InputMaybe<DashboardCardType>;
  order?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
  statistics?: InputMaybe<DashboardCardStatisticDashboardCardIdForeignInverseInput>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  jobPositionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type UpdateDashboardCardByIdMutation = { __typename?: 'Mutation', updateDashboardCardById?: { __typename?: 'UpdateDashboardCardPayload', clientMutationId?: string | null } | null };

export type CreateDashboardConfigMutationVariables = Exact<{
  pageTitle?: InputMaybe<Scalars['String']>;
}>;


export type CreateDashboardConfigMutation = { __typename?: 'Mutation', createDashboardConfig?: { __typename?: 'CreateDashboardConfigPayload', clientMutationId?: string | null } | null };

export type UpdateDashboardConfigMutationVariables = Exact<{
  id: Scalars['UUID'];
  pageTitle?: InputMaybe<Scalars['String']>;
}>;


export type UpdateDashboardConfigMutation = { __typename?: 'Mutation', updateDashboardConfigByCompanyId?: { __typename?: 'UpdateDashboardConfigPayload', clientMutationId?: string | null } | null };

export type DepartmentCreateMutationVariables = Exact<{
  companyId: Scalars['UUID'];
  name: Scalars['String'];
  departmentNumber?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  mainDepartment: Scalars['Boolean'];
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  cvr?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  pNumber?: InputMaybe<Scalars['Int']>;
  ean?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  formFieldEntries?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
}>;


export type DepartmentCreateMutation = { __typename?: 'Mutation', createDepartment?: { __typename?: 'CreateDepartmentPayload', department?: { __typename: 'Department', id: string, name: string, departmentNumber?: string | null, description?: string | null, mainDepartment: boolean, parentDepartmentId?: string | null, cvr?: string | null, alias?: string | null, pNumber?: number | null, ean?: string | null, address: string, postalCode: string, city: string, phone: string, email: string, departmentTypeId?: string | null, hasChildren?: boolean | null, parentDepartment?: { __typename?: 'Department', id: string, name: string } | null, departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null } | null };

export type DepartmentUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  mainDepartment?: InputMaybe<Scalars['Boolean']>;
  parentDepartmentId?: InputMaybe<Scalars['UUID']>;
  cvr?: InputMaybe<Scalars['String']>;
  alias?: InputMaybe<Scalars['String']>;
  pNumber?: InputMaybe<Scalars['Int']>;
  ean?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  departmentTypeId?: InputMaybe<Scalars['UUID']>;
  changedFormFieldIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  formFieldEntries?: InputMaybe<FormFieldEntryDepartmentIdForeignInverseInput>;
}>;


export type DepartmentUpdateMutation = { __typename?: 'Mutation', updateDepartmentById?: { __typename?: 'UpdateDepartmentPayload', department?: { __typename: 'Department', id: string, name: string, departmentNumber?: string | null, description?: string | null, mainDepartment: boolean, parentDepartmentId?: string | null, cvr?: string | null, alias?: string | null, pNumber?: number | null, ean?: string | null, address: string, postalCode: string, city: string, phone: string, email: string, departmentTypeId?: string | null, hasChildren?: boolean | null, parentDepartment?: { __typename?: 'Department', id: string, name: string } | null, departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null } | null };

export type DepartmentDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DepartmentDeleteMutation = { __typename?: 'Mutation', updateDepartmentById?: { __typename?: 'UpdateDepartmentPayload', department?: { __typename?: 'Department', id: string } | null } | null };

export type CreateDepartmentTypeMutationVariables = Exact<{
  name: Scalars['String'];
  color?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateDepartmentTypeMutation = { __typename?: 'Mutation', createDepartmentType?: { __typename?: 'CreateDepartmentTypePayload', departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null };

export type UpdateDepartmentTypeMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
  color?: InputMaybe<Scalars['String']>;
}>;


export type UpdateDepartmentTypeMutation = { __typename?: 'Mutation', updateDepartmentTypeById?: { __typename?: 'UpdateDepartmentTypePayload', departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null };

export type DeleteDepartmentTypeMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteDepartmentTypeMutation = { __typename?: 'Mutation', updateDepartmentTypeById?: { __typename?: 'UpdateDepartmentTypePayload', departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null };

export type GraphileCreateDocumentMutationVariables = Exact<{
  filename: Scalars['String'];
  mimetype?: InputMaybe<Scalars['String']>;
  access: Scalars['String'];
  fileType: Scalars['String'];
  fileOwner: StorageFileOwner;
  fileOwnerId: Scalars['UUID'];
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  base64?: InputMaybe<Scalars['String']>;
  path: Scalars['String'];
  fileExtension: Scalars['String'];
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  html?: InputMaybe<Scalars['String']>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
}>;


export type GraphileCreateDocumentMutation = { __typename?: 'Mutation', createStorage?: { __typename?: 'CreateStoragePayload', storage?: { __typename?: 'Storage', id: string, path: string, filename: string, fileOwner: StorageFileOwner, fileOwnerId: string, mimetype?: string | null, fileExtension: string, createdAt: Date | string, deleteAt?: Date | string | null, expireAt?: Date | string | null, remindAt?: Date | string | null, html?: string | null, documentType?: { __typename?: 'DocumentType', id: string, name: string } | null } | null } | null };

export type UpdateDocumentTypeMutationVariables = Exact<{
  id: Scalars['UUID'];
  documentTypeId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpdateDocumentTypeMutation = { __typename?: 'Mutation', updateStorageById?: { __typename?: 'UpdateStoragePayload', storage?: { __typename?: 'Storage', id: string, documentType?: { __typename?: 'DocumentType', id: string, name: string } | null } | null } | null };

export type GraphileUpdateDocumentMutationVariables = Exact<{
  id: Scalars['UUID'];
  mimetype?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  base64?: InputMaybe<Scalars['String']>;
  fileExtension?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleteAt?: InputMaybe<Scalars['Datetime']>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  responsibleUserIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  responsibleUserIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  active?: InputMaybe<Scalars['Boolean']>;
  html?: InputMaybe<Scalars['String']>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  path?: InputMaybe<Scalars['String']>;
}>;


export type GraphileUpdateDocumentMutation = { __typename?: 'Mutation', updateStorageById?: { __typename?: 'UpdateStoragePayload', storage?: { __typename?: 'Storage', id: string, path: string, filename: string, fileOwner: StorageFileOwner, fileOwnerId: string, mimetype?: string | null, fileExtension: string, createdAt: Date | string, deleteAt?: Date | string | null, expireAt?: Date | string | null, remindAt?: Date | string | null, html?: string | null, documentType?: { __typename?: 'DocumentType', id: string, name: string } | null } | null } | null };

export type DocumentTypeCreateMutationVariables = Exact<{
  documentType: Scalars['String'];
  companyId: Scalars['UUID'];
  lifetime?: InputMaybe<Scalars['Int']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
}>;


export type DocumentTypeCreateMutation = { __typename?: 'Mutation', createDocumentType?: { __typename?: 'CreateDocumentTypePayload', documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null, lifetime?: number | null } | null } | null };

export type DocumentTypeUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  documentType: Scalars['String'];
  lifetime?: InputMaybe<Scalars['Int']>;
  autoDeleteDays?: InputMaybe<Scalars['Int']>;
}>;


export type DocumentTypeUpdateMutation = { __typename?: 'Mutation', updateDocumentTypeById?: { __typename?: 'UpdateDocumentTypePayload', documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null, lifetime?: number | null, autoDeleteDays?: number | null } | null } | null };

export type DocumentTypeDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DocumentTypeDeleteMutation = { __typename?: 'Mutation', updateDocumentTypeById?: { __typename?: 'UpdateDocumentTypePayload', documentType?: { __typename?: 'DocumentType', id: string } | null } | null };

export type FileUploadMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
  filename?: InputMaybe<Scalars['String']>;
  mimetype?: InputMaybe<Scalars['String']>;
  fileAccess?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  fileOwner?: InputMaybe<StorageFileOwner>;
  fileOwnerId?: InputMaybe<Scalars['UUID']>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  base64?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  expireAt?: InputMaybe<Scalars['Datetime']>;
  remindAt?: InputMaybe<Scalars['Datetime']>;
  documentTemplateId?: InputMaybe<Scalars['UUID']>;
  placeholderValues?: InputMaybe<Scalars['JSON']>;
  sendNotification?: InputMaybe<Scalars['Boolean']>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
}>;


export type FileUploadMutation = { __typename?: 'Mutation', FileUpload?: { __typename?: 'FileUploadPayload', id?: string | null, filename?: string | null, path?: string | null, base64?: string | null } | null };

export type FileDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type FileDeleteMutation = { __typename?: 'Mutation', FileDelete?: { __typename?: 'FileDeletePayload', id?: string | null, filename?: string | null } | null };

export type FileDownloadMutationVariables = Exact<{
  id: Scalars['UUID'];
  convertToPdf?: InputMaybe<Scalars['Boolean']>;
}>;


export type FileDownloadMutation = { __typename?: 'Mutation', FileDownload?: { __typename?: 'FileDownloadPayload', id?: string | null, filename?: string | null, mimetype?: string | null, path?: string | null, fileType?: string | null, fileOwner?: StorageFileOwner | null, fileOwnerId?: string | null, documentTypeId?: string | null, fileExtension?: string | null, base64?: string | null } | null };

export type GeneratePdfMutationVariables = Exact<{
  base64: Scalars['String'];
}>;


export type GeneratePdfMutation = { __typename?: 'Mutation', GeneratePDF?: { __typename?: 'GeneratePDFPayload', pdf: string } | null };

export type ProcessBulkUploadDocumentsMutationVariables = Exact<{
  fileName: Scalars['String'];
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  doCreateMissingFolders: Scalars['Boolean'];
  inferDocumentTypeFromFileName: Scalars['Boolean'];
}>;


export type ProcessBulkUploadDocumentsMutation = { __typename?: 'Mutation', processBulkUploadDocuments?: boolean | null };

export type GetPresignedUploadLinkMutationVariables = Exact<{
  filename: Scalars['String'];
}>;


export type GetPresignedUploadLinkMutation = { __typename?: 'Mutation', getPresignedUploadLink?: { __typename?: 'presignedLinkPayload', url: string } | null };

export type DownloadBulkDocumentTemplateMutationVariables = Exact<{ [key: string]: never; }>;


export type DownloadBulkDocumentTemplateMutation = { __typename?: 'Mutation', downloadBulkDocumentTemplate?: { __typename?: 'bulkDocumentTemplatePayload', base64?: string | null } | null };

export type DocumentFolderCreateMutationVariables = Exact<{
  name: Scalars['String'];
  parentDocumentFolderId?: InputMaybe<Scalars['UUID']>;
  ownerType: DocumentFolderOwnerType;
  ownerId: Scalars['UUID'];
  documentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
}>;


export type DocumentFolderCreateMutation = { __typename?: 'Mutation', createDocumentFolder?: { __typename?: 'CreateDocumentFolderPayload', documentFolder?: { __typename?: 'DocumentFolder', id: string, name: string, parentDocumentFolderId?: string | null, ownerType: DocumentFolderOwnerType, lastEdited?: Date | string | null, ownerId: string, companyId: string, documentFolderBlueprintId?: string | null, rootDocumentFolderBlueprintId?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null } | null, documentFolderDepartments: { __typename?: 'DocumentFolderDepartmentsConnection', nodes: Array<{ __typename?: 'DocumentFolderDepartment', documentFolderId: string, departmentId: string, department?: { __typename?: 'Department', name: string, id: string } | null } | null> }, documentFolderUsers: { __typename?: 'DocumentFolderUsersConnection', nodes: Array<{ __typename?: 'DocumentFolderUser', documentFolderId: string, userId: string, user?: { __typename?: 'User', logo?: string | null, id: string, fullName?: string | null } | null } | null> } } | null } | null };

export type CreateDocumentFolderBlueprintMutationVariables = Exact<{
  name: Scalars['String'];
  parentDocumentFolderBlueprintId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateDocumentFolderBlueprintMutation = { __typename?: 'Mutation', createDocumentFolderBlueprint?: { __typename?: 'CreateDocumentFolderBlueprintPayload', documentFolderBlueprint?: { __typename?: 'DocumentFolderBlueprint', name: string, id: string } | null } | null };

export type DocumentFolderBlueprintUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type DocumentFolderBlueprintUpdateMutation = { __typename?: 'Mutation', updateDocumentFolderBlueprintById?: { __typename?: 'UpdateDocumentFolderBlueprintPayload', documentFolderBlueprint?: { __typename?: 'DocumentFolderBlueprint', name: string, id: string } | null } | null };

export type DocumentFolderUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
  parentDocumentFolderId?: InputMaybe<Scalars['UUID']>;
  ownerType: DocumentFolderOwnerType;
  ownerId: Scalars['UUID'];
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type DocumentFolderUpdateMutation = { __typename?: 'Mutation', updateDocumentFolderById?: { __typename?: 'UpdateDocumentFolderPayload', documentFolder?: { __typename?: 'DocumentFolder', id: string, name: string, parentDocumentFolderId?: string | null, ownerType: DocumentFolderOwnerType, lastEdited?: Date | string | null, ownerId: string, companyId: string, documentFolderBlueprintId?: string | null, rootDocumentFolderBlueprintId?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null } | null, documentFolderDepartments: { __typename?: 'DocumentFolderDepartmentsConnection', nodes: Array<{ __typename?: 'DocumentFolderDepartment', documentFolderId: string, departmentId: string, department?: { __typename?: 'Department', name: string, id: string } | null } | null> }, documentFolderUsers: { __typename?: 'DocumentFolderUsersConnection', nodes: Array<{ __typename?: 'DocumentFolderUser', documentFolderId: string, userId: string, user?: { __typename?: 'User', logo?: string | null, id: string, fullName?: string | null } | null } | null> } } | null } | null };

export type DocumentFolderDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DocumentFolderDeleteMutation = { __typename?: 'Mutation', updateDocumentFolderById?: { __typename?: 'UpdateDocumentFolderPayload', documentFolder?: { __typename?: 'DocumentFolder', id: string } | null } | null };

export type DocumentFolderBlueprintDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DocumentFolderBlueprintDeleteMutation = { __typename?: 'Mutation', updateDocumentFolderBlueprintById?: { __typename?: 'UpdateDocumentFolderBlueprintPayload', documentFolderBlueprint?: { __typename?: 'DocumentFolderBlueprint', id: string } | null } | null };

export type DocumentFolderDepartmentCreateMutationVariables = Exact<{
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
}>;


export type DocumentFolderDepartmentCreateMutation = { __typename?: 'Mutation', createDocumentFolderDepartment?: { __typename?: 'CreateDocumentFolderDepartmentPayload', documentFolder?: { __typename?: 'DocumentFolder', id: string, name: string, parentDocumentFolderId?: string | null, ownerType: DocumentFolderOwnerType, lastEdited?: Date | string | null, ownerId: string, companyId: string, documentFolderBlueprintId?: string | null, rootDocumentFolderBlueprintId?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null } | null, documentFolderDepartments: { __typename?: 'DocumentFolderDepartmentsConnection', nodes: Array<{ __typename?: 'DocumentFolderDepartment', documentFolderId: string, departmentId: string, department?: { __typename?: 'Department', name: string, id: string } | null } | null> }, documentFolderUsers: { __typename?: 'DocumentFolderUsersConnection', nodes: Array<{ __typename?: 'DocumentFolderUser', documentFolderId: string, userId: string, user?: { __typename?: 'User', logo?: string | null, id: string, fullName?: string | null } | null } | null> } } | null } | null };

export type DocumentFolderDepartmentDeleteMutationVariables = Exact<{
  documentFolderId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
}>;


export type DocumentFolderDepartmentDeleteMutation = { __typename?: 'Mutation', deleteDocumentFolderDepartmentByDocumentFolderIdAndDepartmentId?: { __typename?: 'DeleteDocumentFolderDepartmentPayload', documentFolder?: { __typename?: 'DocumentFolder', id: string, name: string, parentDocumentFolderId?: string | null, ownerType: DocumentFolderOwnerType, lastEdited?: Date | string | null, ownerId: string, companyId: string, documentFolderBlueprintId?: string | null, rootDocumentFolderBlueprintId?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null } | null, documentFolderDepartments: { __typename?: 'DocumentFolderDepartmentsConnection', nodes: Array<{ __typename?: 'DocumentFolderDepartment', documentFolderId: string, departmentId: string, department?: { __typename?: 'Department', name: string, id: string } | null } | null> }, documentFolderUsers: { __typename?: 'DocumentFolderUsersConnection', nodes: Array<{ __typename?: 'DocumentFolderUser', documentFolderId: string, userId: string, user?: { __typename?: 'User', logo?: string | null, id: string, fullName?: string | null } | null } | null> } } | null } | null };

export type DocumentFolderUserCreateMutationVariables = Exact<{
  documentFolderId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type DocumentFolderUserCreateMutation = { __typename?: 'Mutation', createDocumentFolderUser?: { __typename?: 'CreateDocumentFolderUserPayload', documentFolder?: { __typename?: 'DocumentFolder', id: string, name: string, parentDocumentFolderId?: string | null, ownerType: DocumentFolderOwnerType, lastEdited?: Date | string | null, ownerId: string, companyId: string, documentFolderBlueprintId?: string | null, rootDocumentFolderBlueprintId?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null } | null, documentFolderDepartments: { __typename?: 'DocumentFolderDepartmentsConnection', nodes: Array<{ __typename?: 'DocumentFolderDepartment', documentFolderId: string, departmentId: string, department?: { __typename?: 'Department', name: string, id: string } | null } | null> }, documentFolderUsers: { __typename?: 'DocumentFolderUsersConnection', nodes: Array<{ __typename?: 'DocumentFolderUser', documentFolderId: string, userId: string, user?: { __typename?: 'User', logo?: string | null, id: string, fullName?: string | null } | null } | null> } } | null } | null };

export type DocumentFolderUserDeleteMutationVariables = Exact<{
  documentFolderId: Scalars['UUID'];
  userId: Scalars['UUID'];
}>;


export type DocumentFolderUserDeleteMutation = { __typename?: 'Mutation', deleteDocumentFolderUserByDocumentFolderIdAndUserId?: { __typename?: 'DeleteDocumentFolderUserPayload', documentFolder?: { __typename?: 'DocumentFolder', id: string, name: string, parentDocumentFolderId?: string | null, ownerType: DocumentFolderOwnerType, lastEdited?: Date | string | null, ownerId: string, companyId: string, documentFolderBlueprintId?: string | null, rootDocumentFolderBlueprintId?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null } | null, documentFolderDepartments: { __typename?: 'DocumentFolderDepartmentsConnection', nodes: Array<{ __typename?: 'DocumentFolderDepartment', documentFolderId: string, departmentId: string, department?: { __typename?: 'Department', name: string, id: string } | null } | null> }, documentFolderUsers: { __typename?: 'DocumentFolderUsersConnection', nodes: Array<{ __typename?: 'DocumentFolderUser', documentFolderId: string, userId: string, user?: { __typename?: 'User', logo?: string | null, id: string, fullName?: string | null } | null } | null> } } | null } | null };

export type CustomEmployeeCreateMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  departments?: InputMaybe<Scalars['JSON']>;
  alternateFirstName?: InputMaybe<Scalars['String']>;
  alternateLastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailWork?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  mobilePrivate?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  birthdate?: InputMaybe<Scalars['Date']>;
  employmentStart?: InputMaybe<Scalars['String']>;
  employmentEnd?: InputMaybe<Scalars['String']>;
  seniority?: InputMaybe<Scalars['String']>;
  jobPositionTitle?: InputMaybe<Scalars['String']>;
  jobPositionDescription?: InputMaybe<Scalars['String']>;
  jobPositionType?: InputMaybe<Scalars['String']>;
  jobPositionWorkingHours?: InputMaybe<Scalars['String']>;
  bankRegistrationNumber?: InputMaybe<Scalars['String']>;
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  cpr?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  directManager?: InputMaybe<Scalars['UUID']>;
  employmentJurisdiction?: InputMaybe<Scalars['String']>;
  initials?: InputMaybe<Scalars['String']>;
  formFieldEntries?: InputMaybe<Scalars['JSON']>;
  personalGroupIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
}>;


export type CustomEmployeeCreateMutation = { __typename?: 'Mutation', createEmployeeCustomMutation?: { __typename?: 'Employee', id: string, userId: string } | null };

export type CustomEmployeeUpdateMutationVariables = Exact<{
  employeeId: Scalars['UUID'];
  userId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  departments?: InputMaybe<Scalars['JSON']>;
  alternateFirstName?: InputMaybe<Scalars['String']>;
  alternateLastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailWork?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  mobilePrivate?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  birthdate?: InputMaybe<Scalars['Date']>;
  employmentStart?: InputMaybe<Scalars['String']>;
  employmentEnd?: InputMaybe<Scalars['String']>;
  seniority?: InputMaybe<Scalars['String']>;
  jobPositionTitle?: InputMaybe<Scalars['String']>;
  jobPositionDescription?: InputMaybe<Scalars['String']>;
  jobPositionType?: InputMaybe<Scalars['String']>;
  jobPositionWorkingHours?: InputMaybe<Scalars['String']>;
  bankRegistrationNumber?: InputMaybe<Scalars['String']>;
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  cpr?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  userDepartmentsToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  userDepartmentsToCreate?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  directManager?: InputMaybe<Scalars['UUID']>;
  employmentJurisdiction?: InputMaybe<Scalars['String']>;
  initials?: InputMaybe<Scalars['String']>;
  formFieldEntries?: InputMaybe<Scalars['JSON']>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  fromEngagement?: InputMaybe<Scalars['Boolean']>;
}>;


export type CustomEmployeeUpdateMutation = { __typename?: 'Mutation', updateEmployeeCustomMutation?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, fullName?: string | null, jobPositionTitle?: string | null, initialsLogo?: string | null, directManager?: { __typename?: 'User', id: string } | null } | null } | null };

export type BulkUpdateEmployeeCustomMutationMutationVariables = Exact<{
  employeeIds: Array<Scalars['UUID']> | Scalars['UUID'];
  fields: EmployeeCustomMutationInput;
  futureData?: InputMaybe<Array<FutureDatumInput> | FutureDatumInput>;
}>;


export type BulkUpdateEmployeeCustomMutationMutation = { __typename?: 'Mutation', bulkUpdateEmployeeCustomMutation: boolean };

export type EmployeeAndUserUpdateMutationVariables = Exact<{
  employeeId: Scalars['UUID'];
  userId: Scalars['UUID'];
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type EmployeeAndUserUpdateMutation = { __typename?: 'Mutation', updateEmployeeById?: { __typename?: 'UpdateEmployeePayload', employee?: { __typename?: 'Employee', id: string, userId: string, departments?: Array<string | null> | null, leaderDepartments?: Array<string | null> | null, isLeader: boolean, active: boolean, user?: { __typename?: 'User', id: string, locale?: string | null, firstName?: string | null, lastName?: string | null, alternateFirstName?: string | null, alternateLastName?: string | null, fullName?: string | null, birthdate?: Date | string | null, employmentStart?: Date | string | null, employmentEnd?: Date | string | null, companyAdmin: boolean, isSystemUser: boolean, canSignOnBehalfOf?: boolean | null, cpr?: string | null, bankRegistrationNumber?: string | null, bankAccountNumber?: string | null, country?: string | null, jobPositionTitle?: string | null, jobPositionType?: string | null, jobPositionWorkingHours?: string | null, jobPositionDescription?: string | null, initialsLogo?: string | null, logo?: string | null, hasLogo?: boolean | null, isFuture?: boolean | null, isResigned?: boolean | null, canLogin: boolean, canLoginApp: boolean, canLoginSso: boolean, godmode: boolean, employeeNumber?: string | number | null, email?: string | null, emailWork?: string | null, phone?: string | null, mobile?: string | null, mobilePrivate?: string | null, address?: string | null, city?: string | null, postalCode?: string | number | null, directManager?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null } | null } | null, updateUserById?: { __typename?: 'UpdateUserPayload', user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null };

export type EmployeeArchiveMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type EmployeeArchiveMutation = { __typename?: 'Mutation', updateEmployeeById?: { __typename?: 'UpdateEmployeePayload', clientMutationId?: string | null } | null };

export type EmployeeRestoreMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type EmployeeRestoreMutation = { __typename?: 'Mutation', updateEmployeeById?: { __typename?: 'UpdateEmployeePayload', clientMutationId?: string | null } | null };

export type SetMissingEmployeeNumberMutationVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type SetMissingEmployeeNumberMutation = { __typename?: 'Mutation', setMissingEmployeeNumber?: { __typename?: 'SetMissingEmployeeNumberPayload', integer?: number | null } | null };

export type EmployeeCreateCaseFileMutationVariables = Exact<{
  employeeId: Scalars['UUID'];
  signingUserIds: Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>;
  title?: InputMaybe<Scalars['String']>;
  signers: Array<InputMaybe<CasefileSignerInput>> | InputMaybe<CasefileSignerInput>;
  recipients: Array<InputMaybe<CasefileRecipientInput>> | InputMaybe<CasefileRecipientInput>;
  documents: Array<InputMaybe<CasefileDocumentInput>> | InputMaybe<CasefileDocumentInput>;
  documentTypeId?: InputMaybe<Scalars['UUID']>;
  reminderInterval?: InputMaybe<Scalars['Int']>;
  emailSubject: Scalars['String'];
  emailText: Scalars['String'];
  locale: Scalars['String'];
  expireAt?: InputMaybe<Scalars['Int']>;
  enforceSignOrder?: InputMaybe<Scalars['Boolean']>;
}>;


export type EmployeeCreateCaseFileMutation = { __typename?: 'Mutation', createEmployeeCasefile?: { __typename?: 'EmployeeCasefile', casefileId: number } | null };

export type UpdateEmployeeCasefileByEmployeeIdAndCasefileIdMutationVariables = Exact<{
  employeeId: Scalars['UUID'];
  casefileId: Scalars['Int'];
  documentTypeId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpdateEmployeeCasefileByEmployeeIdAndCasefileIdMutation = { __typename?: 'Mutation', updateEmployeeCasefileByEmployeeIdAndCasefileId?: { __typename?: 'UpdateEmployeeCasefilePayload', clientMutationId?: string | null } | null };

export type DeleteEmployeeCasefileMutationVariables = Exact<{
  employeeId: Scalars['UUID'];
  casefileId: Scalars['Int'];
}>;


export type DeleteEmployeeCasefileMutation = { __typename?: 'Mutation', updateEmployeeCasefileByEmployeeIdAndCasefileId?: { __typename?: 'UpdateEmployeeCasefilePayload', clientMutationId?: string | null } | null };

export type DownloadCasefileDocumentMutationVariables = Exact<{
  casefileId: Scalars['Int'];
  documentId: Scalars['Int'];
}>;


export type DownloadCasefileDocumentMutation = { __typename?: 'Mutation', downloadCasefileDocument?: { __typename?: 'DownloadCasefileDocumentPayload', base64: string } | null };

export type SendSigningRequestMutationVariables = Exact<{
  casefileId: Scalars['Int'];
  signingRequestId: Scalars['Int'];
}>;


export type SendSigningRequestMutation = { __typename?: 'Mutation', sendSigningRequest?: boolean | null };

export type ManuallySyncCasefileMutationVariables = Exact<{
  casefileId: Scalars['Int'];
}>;


export type ManuallySyncCasefileMutation = { __typename?: 'Mutation', manuallySyncCasefile?: boolean | null };

export type EmployeesImportFileMutationVariables = Exact<{
  file: Scalars['Upload'];
  useDefaultCustomFieldValues: Scalars['Boolean'];
  sendPasswordToEmails: Scalars['Boolean'];
  mappings: Array<CsvMappingInput> | CsvMappingInput;
}>;


export type EmployeesImportFileMutation = { __typename?: 'Mutation', ImportEmployeesFromFile: boolean };

export type UpdateEmployeesFromCsvMutationVariables = Exact<{
  csvFile: Scalars['Upload'];
  mappings: Array<CsvMappingInput> | CsvMappingInput;
  clearFieldValuesWhenEmpty?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateEmployeesFromCsvMutation = { __typename?: 'Mutation', updateEmployeesFromCsv: boolean };

export type UpdateEmployeeRecordsFromCsvMutationVariables = Exact<{
  csvFile: Scalars['Upload'];
  employeeRecordFieldId: Scalars['UUID'];
}>;


export type UpdateEmployeeRecordsFromCsvMutation = { __typename?: 'Mutation', updateEmployeeRecordsFromCsv: boolean };

export type EngagementTypeDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type EngagementTypeDeleteMutation = { __typename?: 'Mutation', updateEngagementTypeById?: { __typename?: 'UpdateEngagementTypePayload', engagementType?: { __typename?: 'EngagementType', id: string } | null } | null };

export type EngagementTypeCreateMutationVariables = Exact<{
  name: Scalars['String'];
  companyId: Scalars['UUID'];
}>;


export type EngagementTypeCreateMutation = { __typename?: 'Mutation', createEngagementType?: { __typename?: 'CreateEngagementTypePayload', engagementType?: { __typename?: 'EngagementType', id: string, name: string, localizedName?: string | null } | null } | null };

export type EngagementTypeUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
}>;


export type EngagementTypeUpdateMutation = { __typename?: 'Mutation', updateEngagementTypeById?: { __typename?: 'UpdateEngagementTypePayload', engagementType?: { __typename?: 'EngagementType', id: string, name: string, localizedName?: string | null } | null } | null };

export type EquipmentCreateMutationVariables = Exact<{
  productId: Scalars['UUID'];
  employeeId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
}>;


export type EquipmentCreateMutation = { __typename?: 'Mutation', createEquipment?: { __typename?: 'CreateEquipmentPayload', equipment?: { __typename?: 'Equipment', id: string, createdAt: Date | string, startDate?: Date | string | null, product?: { __typename?: 'Product', id: string, name: string, description?: string | null, serial?: string | null, productTypeId: string, productType?: { __typename?: 'ProductType', id: string, name: string, localizedName?: string | null } | null } | null } | null } | null };

export type UpdateEquipmentMutationVariables = Exact<{
  id: Scalars['UUID'];
  startDate?: InputMaybe<Scalars['Datetime']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  employeeId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpdateEquipmentMutation = { __typename?: 'Mutation', updateEquipmentById?: { __typename?: 'UpdateEquipmentPayload', equipment?: { __typename?: 'Equipment', id: string, startDate?: Date | string | null, createdAt: Date | string, product?: { __typename?: 'Product', id: string, name: string, description?: string | null, serial?: string | null, productTypeId: string, productType?: { __typename?: 'ProductType', id: string, name: string, localizedName?: string | null } | null } | null } | null } | null };

export type ProductCreateMutationVariables = Exact<{
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  serial?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
  departmentId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  assignedUserId?: InputMaybe<Scalars['UUID']>;
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  equipment?: InputMaybe<EquipmentProductIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductIdForeignInverseInput>;
}>;


export type ProductCreateMutation = { __typename?: 'Mutation', createProduct?: { __typename?: 'CreateProductPayload', product?: { __typename?: 'Product', id: string, name: string, description?: string | null, serial?: string | null, purchaseDate?: Date | string | null, acquisitionDate?: Date | string | null, companyId: string, departmentId?: string | null, userId?: string | null, createdAt: Date | string, updatedAt: Date | string, active: boolean, productTypeId: string, assignedUserDepartments?: Array<string | null> | null, assignedUserId?: string | null, occupiedBy?: string | null, occupiedByEmployeeId?: string | null, department?: { __typename?: 'Department', id: string, name: string } | null, occupiedByDepartments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, equipments: { __typename?: 'EquipmentConnection', edges: Array<{ __typename?: 'EquipmentEdge', node?: { __typename?: 'Equipment', id: string, productId: string, employeeId: string, startDate?: Date | string | null, endDate?: Date | string | null, departments?: Array<string | null> | null, employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null }> }, productType?: { __typename?: 'ProductType', id: string, name: string, localizedName?: string | null } | null, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', value?: string | null, formFieldId: string, formField?: { __typename?: 'FormField', fieldType?: string | null, metadata?: any | null, productTypeIds?: Array<string | null> | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string } | null> } } | null } | null> } } | null } | null };

export type ProductUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  productTypeId?: InputMaybe<Scalars['UUID']>;
  serial?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  purchaseDate?: InputMaybe<Scalars['Datetime']>;
  equipment?: InputMaybe<EquipmentProductIdForeignInverseInput>;
  formFieldEntries?: InputMaybe<FormFieldEntryProductIdForeignInverseInput>;
}>;


export type ProductUpdateMutation = { __typename?: 'Mutation', updateProductById?: { __typename?: 'UpdateProductPayload', product?: { __typename?: 'Product', id: string, name: string, description?: string | null, serial?: string | null, purchaseDate?: Date | string | null, acquisitionDate?: Date | string | null, companyId: string, departmentId?: string | null, userId?: string | null, createdAt: Date | string, updatedAt: Date | string, active: boolean, productTypeId: string, assignedUserDepartments?: Array<string | null> | null, assignedUserId?: string | null, occupiedBy?: string | null, occupiedByEmployeeId?: string | null, department?: { __typename?: 'Department', id: string, name: string } | null, occupiedByDepartments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, equipments: { __typename?: 'EquipmentConnection', edges: Array<{ __typename?: 'EquipmentEdge', node?: { __typename?: 'Equipment', id: string, productId: string, employeeId: string, startDate?: Date | string | null, endDate?: Date | string | null, departments?: Array<string | null> | null, employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null }> }, productType?: { __typename?: 'ProductType', id: string, name: string, localizedName?: string | null } | null, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', value?: string | null, formFieldId: string, formField?: { __typename?: 'FormField', fieldType?: string | null, metadata?: any | null, productTypeIds?: Array<string | null> | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string } | null> } } | null } | null> } } | null } | null };

export type ProductDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProductDeleteMutation = { __typename?: 'Mutation', updateProductById?: { __typename?: 'UpdateProductPayload', product?: { __typename?: 'Product', id: string, name: string, description?: string | null, serial?: string | null, purchaseDate?: Date | string | null, acquisitionDate?: Date | string | null, companyId: string, departmentId?: string | null, userId?: string | null, createdAt: Date | string, updatedAt: Date | string, active: boolean, productTypeId: string, assignedUserDepartments?: Array<string | null> | null, assignedUserId?: string | null, occupiedBy?: string | null, occupiedByEmployeeId?: string | null, department?: { __typename?: 'Department', id: string, name: string } | null, occupiedByDepartments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, equipments: { __typename?: 'EquipmentConnection', edges: Array<{ __typename?: 'EquipmentEdge', node?: { __typename?: 'Equipment', id: string, productId: string, employeeId: string, startDate?: Date | string | null, endDate?: Date | string | null, departments?: Array<string | null> | null, employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null }> }, productType?: { __typename?: 'ProductType', id: string, name: string, localizedName?: string | null } | null, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', value?: string | null, formFieldId: string, formField?: { __typename?: 'FormField', fieldType?: string | null, metadata?: any | null, productTypeIds?: Array<string | null> | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string } | null> } } | null } | null> } } | null } | null };

export type ProductTypeCreateMutationVariables = Exact<{
  name: Scalars['String'];
  companyId: Scalars['UUID'];
}>;


export type ProductTypeCreateMutation = { __typename?: 'Mutation', createProductType?: { __typename?: 'CreateProductTypePayload', productType?: { __typename?: 'ProductType', id: string, name: string, localizedName?: string | null } | null } | null };

export type ProductTypeUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
}>;


export type ProductTypeUpdateMutation = { __typename?: 'Mutation', updateProductTypeById?: { __typename?: 'UpdateProductTypePayload', productType?: { __typename?: 'ProductType', id: string, name: string, localizedName?: string | null } | null } | null };

export type ProductTypeDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProductTypeDeleteMutation = { __typename?: 'Mutation', updateProductTypeById?: { __typename?: 'UpdateProductTypePayload', productType?: { __typename?: 'ProductType', id: string } | null } | null };

export type EquipmentImportFileMutationVariables = Exact<{
  file: Scalars['Upload'];
  useDefaultCustomFieldValues: Scalars['Boolean'];
}>;


export type EquipmentImportFileMutation = { __typename?: 'Mutation', ImportEquipmentFromFile: boolean };

export type SortEquipmentCustomFieldsMutationVariables = Exact<{
  equipmentFieldsOrder: Array<EquipmentFieldOrder> | EquipmentFieldOrder;
}>;


export type SortEquipmentCustomFieldsMutation = { __typename?: 'Mutation', sortEquipmentCustomFields: boolean };

export type CreateErrorReportMutationVariables = Exact<{
  error: Scalars['String'];
  routeName: Scalars['String'];
  userAgent: Scalars['JSON'];
  message?: InputMaybe<Scalars['String']>;
  useEmail?: InputMaybe<Scalars['Boolean']>;
  grantAccess?: InputMaybe<Scalars['Boolean']>;
  isCrash?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateErrorReportMutation = { __typename?: 'Mutation', createErrorReport?: { __typename?: 'ErrorReportResponse', response: string } | null };

export type CreateEventMutationVariables = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
  location: Scalars['String'];
  startDate: Scalars['Datetime'];
  deadline?: InputMaybe<Scalars['Datetime']>;
  organizerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  contactPersonIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  invitedUserIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  invitedDepartmentIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent?: { __typename?: 'CreateEventPayload', event?: { __typename?: 'Event', id: string } | null } | null };

export type UpdateEventMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
  description: Scalars['String'];
  location: Scalars['String'];
  startDate: Scalars['Datetime'];
  deadline?: InputMaybe<Scalars['Datetime']>;
  organizerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  contactPersonIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  invitedUserIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  invitedDepartmentIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEventById?: { __typename?: 'UpdateEventPayload', clientMutationId?: string | null } | null };

export type DeleteEventMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', updateEventById?: { __typename?: 'UpdateEventPayload', clientMutationId?: string | null } | null };

export type UpdateExternalIntegrationMutationVariables = Exact<{
  id: Scalars['UUID'];
  fieldMappings?: InputMaybe<Scalars['JSON']>;
  credentials?: InputMaybe<Scalars['JSON']>;
  blacklistedFields?: InputMaybe<Scalars['JSON']>;
  whitelistedFields?: InputMaybe<Scalars['JSON']>;
  config?: InputMaybe<Scalars['JSON']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateExternalIntegrationMutation = { __typename?: 'Mutation', updateExternalIntegrationById?: { __typename?: 'UpdateExternalIntegrationPayload', externalIntegration?: { __typename?: 'ExternalIntegration', companyId: string, id: string, credentials?: any | null, config?: any | null, systemId?: number | null, externalCompanyId?: string | null, fieldMappings?: any | null, blacklistedFields?: any | null, whitelistedFields?: any | null, continuousSync?: boolean | null, title?: string | null, departmentId?: string | null, departmentInheritance?: boolean | null, active: boolean, system?: { __typename?: 'ExternalSystem', id: number, name: string } | null, integrableSystem?: { __typename?: 'IntegrableSystem', id: string, name: string, logo: string, description: string, homepageUrl: string, settingsUrl?: string | null } | null } | null } | null };

export type DeleteExternalIntegrationByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteExternalIntegrationByIdMutation = { __typename?: 'Mutation', deleteExternalIntegrationById?: { __typename?: 'DeleteExternalIntegrationPayload', clientMutationId?: string | null } | null };

export type UpdateIntegrationCredentialsMutationVariables = Exact<{
  id: Scalars['UUID'];
  accessToken?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
}>;


export type UpdateIntegrationCredentialsMutation = { __typename?: 'Mutation', UpdateIntegrationCredentials?: { __typename?: 'UpdateIntegrationCredentialsResponse', message: string } | null };

export type CreateIntegrationMutationVariables = Exact<{
  companyId: Scalars['UUID'];
  system: IntegrationSystemInput;
  externalCompanyId: Scalars['String'];
  externalAdditionId?: InputMaybe<Scalars['String']>;
  apiKey?: InputMaybe<Scalars['String']>;
  accessToken?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  fieldMappings?: InputMaybe<Array<FieldMapping> | FieldMapping>;
  copyEmployees?: InputMaybe<Scalars['Boolean']>;
  continuousSync?: InputMaybe<Scalars['Boolean']>;
  blacklistedFields?: InputMaybe<Array<BlacklistedField> | BlacklistedField>;
  whitelistedFields?: InputMaybe<Array<WhitelistedField> | WhitelistedField>;
  overwriteExternalData?: InputMaybe<Scalars['Boolean']>;
  departmentId?: InputMaybe<Scalars['String']>;
  departmentInheritance?: InputMaybe<Scalars['Boolean']>;
  payslipDocumentTypeId?: InputMaybe<Scalars['String']>;
  payslipDocumentFolderId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['JSON']>;
  absenceSync?: InputMaybe<Scalars['Boolean']>;
  absenceMappings?: InputMaybe<Scalars['JSON']>;
}>;


export type CreateIntegrationMutation = { __typename?: 'Mutation', CreateIntegration?: { __typename?: 'CreateIntegrationResponse', message: string } | null };

export type FieldGroupCreateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  companyId: Scalars['UUID'];
}>;


export type FieldGroupCreateMutation = { __typename?: 'Mutation', createFieldGroup?: { __typename?: 'CreateFieldGroupPayload', fieldGroup?: { __typename?: 'FieldGroup', id: string, name: string, localizedName?: string | null, order: number, active: boolean, companyId: string, recordFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, excludedRoleIds?: Array<string | null> | null } | null> }, fieldGroupCards: { __typename?: 'FieldGroupCardsConnection', nodes: Array<{ __typename?: 'FieldGroupCard', id: string, name?: string | null, localizedName?: string | null, description?: string | null, columns: number, fieldGroupId: string, fieldGroupCardColumns: { __typename?: 'FieldGroupCardColumnsConnection', nodes: Array<{ __typename?: 'FieldGroupCardColumn', id: string, name?: string | null, localizedName?: string | null, formFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, excludedRoleIds?: Array<string | null> | null } | null> }, companySystemFields: { __typename?: 'CompanySystemFieldsConnection', nodes: Array<{ __typename?: 'CompanySystemField', id: string, systemFieldId: string, excludedRoleIds?: Array<string | null> | null } | null> } } | null> } } | null> } } | null } | null };

export type FieldGroupUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
}>;


export type FieldGroupUpdateMutation = { __typename?: 'Mutation', updateFieldGroupById?: { __typename?: 'UpdateFieldGroupPayload', fieldGroup?: { __typename?: 'FieldGroup', id: string, name: string, localizedName?: string | null, order: number, active: boolean, companyId: string, recordFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, excludedRoleIds?: Array<string | null> | null } | null> }, fieldGroupCards: { __typename?: 'FieldGroupCardsConnection', nodes: Array<{ __typename?: 'FieldGroupCard', id: string, name?: string | null, localizedName?: string | null, description?: string | null, columns: number, fieldGroupId: string, fieldGroupCardColumns: { __typename?: 'FieldGroupCardColumnsConnection', nodes: Array<{ __typename?: 'FieldGroupCardColumn', id: string, name?: string | null, localizedName?: string | null, formFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, excludedRoleIds?: Array<string | null> | null } | null> }, companySystemFields: { __typename?: 'CompanySystemFieldsConnection', nodes: Array<{ __typename?: 'CompanySystemField', id: string, systemFieldId: string, excludedRoleIds?: Array<string | null> | null } | null> } } | null> } } | null> } } | null } | null };

export type FieldGroupDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type FieldGroupDeleteMutation = { __typename?: 'Mutation', updateFieldGroupById?: { __typename?: 'UpdateFieldGroupPayload', fieldGroup?: { __typename?: 'FieldGroup', id: string } | null } | null };

export type CreateFieldGroupCardMutationVariables = Exact<{
  fieldGroupId: Scalars['UUID'];
  companyId: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateFieldGroupCardMutation = { __typename?: 'Mutation', createFieldGroupCard?: { __typename?: 'CreateFieldGroupCardPayload', fieldGroupCard?: { __typename?: 'FieldGroupCard', id: string, name?: string | null, description?: string | null, fieldGroupCardColumns: { __typename?: 'FieldGroupCardColumnsConnection', nodes: Array<{ __typename?: 'FieldGroupCardColumn', id: string } | null> } } | null } | null };

export type UpdateFieldGroupCardMutationVariables = Exact<{
  id: Scalars['UUID'];
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  columns?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateFieldGroupCardMutation = { __typename?: 'Mutation', updateFieldGroupCardById?: { __typename?: 'UpdateFieldGroupCardPayload', fieldGroupCard?: { __typename?: 'FieldGroupCard', id: string, name?: string | null, description?: string | null } | null } | null };

export type CreateFilterPresetMutationVariables = Exact<{
  name: Scalars['String'];
  tableName: Scalars['String'];
  columns: Scalars['JSON'];
  filters: Scalars['JSON'];
  miscellaneousFilters?: InputMaybe<Scalars['JSON']>;
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateFilterPresetMutation = { __typename?: 'Mutation', createFilterPreset?: { __typename?: 'CreateFilterPresetPayload', filterPreset?: { __typename?: 'FilterPreset', id: string, name: string, tableName: string, columns: any, filters?: any | null, miscellaneousFilters?: any | null } | null } | null };

export type UpdateFilterPresetMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  columns?: InputMaybe<Scalars['JSON']>;
  filters?: InputMaybe<Scalars['JSON']>;
  miscellaneousFilters?: InputMaybe<Scalars['JSON']>;
}>;


export type UpdateFilterPresetMutation = { __typename?: 'Mutation', updateFilterPresetById?: { __typename?: 'UpdateFilterPresetPayload', filterPreset?: { __typename?: 'FilterPreset', id: string, name: string, tableName: string, columns: any, filters?: any | null, miscellaneousFilters?: any | null } | null } | null };

export type DeleteFilterPresetMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteFilterPresetMutation = { __typename?: 'Mutation', updateFilterPresetById?: { __typename?: 'UpdateFilterPresetPayload', filterPreset?: { __typename?: 'FilterPreset', id: string, name: string, tableName: string, columns: any, filters?: any | null, miscellaneousFilters?: any | null } | null } | null };

export type FormFieldCreateMutationVariables = Exact<{
  id: Scalars['UUID'];
  companyId: Scalars['UUID'];
  name: Scalars['String'];
  helpText?: InputMaybe<Scalars['String']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  objectType: Scalars['String'];
  fieldType: Scalars['String'];
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  defaultValue?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  multiple?: InputMaybe<Scalars['Boolean']>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  readPermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  writePermissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  readWriteLeaderPermissions?: InputMaybe<Scalars['Boolean']>;
  parentFormFieldId?: InputMaybe<Scalars['UUID']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  eventId?: InputMaybe<Scalars['UUID']>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type FormFieldCreateMutation = { __typename?: 'Mutation', createFormField?: { __typename?: 'CreateFormFieldPayload', formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null };

export type FormFieldUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  helpText?: InputMaybe<Scalars['String']>;
  agreementText?: InputMaybe<Scalars['String']>;
  agreementTextLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  fieldType?: InputMaybe<Scalars['String']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  defaultValue?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  active?: InputMaybe<Scalars['Boolean']>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  departmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  competences?: InputMaybe<CompetenceRatingFormFieldIdForeignInverseInput>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type FormFieldUpdateMutation = { __typename?: 'Mutation', updateFormFieldById?: { __typename?: 'UpdateFormFieldPayload', formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null };

export type FormFieldEntryCreateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type FormFieldEntryCreateMutation = { __typename?: 'Mutation', createFormFieldEntry?: { __typename?: 'CreateFormFieldEntryPayload', formFieldEntry?: { __typename?: 'FormFieldEntry', id: string, value?: string | null, humanReadableValue?: string | null, formFieldId: string, employeeId?: string | null, productId?: string | null, active: boolean } | null } | null };

export type FormFieldEntryUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  formFieldId?: InputMaybe<Scalars['UUID']>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type FormFieldEntryUpdateMutation = { __typename?: 'Mutation', updateFormFieldEntryById?: { __typename?: 'UpdateFormFieldEntryPayload', formFieldEntry?: { __typename?: 'FormFieldEntry', id: string, value?: string | null, humanReadableValue?: string | null, formFieldId: string, employeeId?: string | null, productId?: string | null, active: boolean } | null } | null };

export type CreateFroalaStyleMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  values?: InputMaybe<Scalars['JSON']>;
  css?: InputMaybe<Scalars['String']>;
}>;


export type CreateFroalaStyleMutation = { __typename?: 'Mutation', createFroalaStyle?: { __typename?: 'CreateFroalaStylePayload', froalaStyle?: { __typename?: 'FroalaStyle', id: string, name: string, values?: any | null, css?: string | null } | null } | null };

export type UpdateFroalaStyleMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
  values?: InputMaybe<Scalars['JSON']>;
  css?: InputMaybe<Scalars['String']>;
}>;


export type UpdateFroalaStyleMutation = { __typename?: 'Mutation', updateFroalaStyleById?: { __typename?: 'UpdateFroalaStylePayload', froalaStyle?: { __typename?: 'FroalaStyle', id: string, name: string, values?: any | null, css?: string | null } | null } | null };

export type DeleteFroalaStyleMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteFroalaStyleMutation = { __typename?: 'Mutation', updateFroalaStyleById?: { __typename?: 'UpdateFroalaStylePayload', froalaStyle?: { __typename?: 'FroalaStyle', id: string, name: string, values?: any | null, css?: string | null } | null } | null };

export type CreateFutureDataMutationVariables = Exact<{
  formFieldId?: InputMaybe<Scalars['UUID']>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  value: Scalars['JSON'];
  userId?: InputMaybe<Scalars['UUID']>;
  updateValueAt?: InputMaybe<Scalars['Datetime']>;
  uniqueKey?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateFutureDataMutation = { __typename?: 'Mutation', createFutureDatum?: { __typename?: 'CreateFutureDatumPayload', futureDatum?: { __typename?: 'FutureDatum', id: string, systemFieldId?: string | null, formFieldId?: string | null, formFieldEntryId?: string | null, userId: string, updateValueAt?: Date | string | null, createdAt: Date | string, value: any, previousHumanReadableValue?: string | null, humanReadableValue?: string | null, approvalIsRequired?: boolean | null, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, approvalId?: string | null, creatorUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null, formField?: { __typename?: 'FormField', id: string, localizedName?: string | null, sensitive?: boolean | null } | null, systemField?: { __typename?: 'SystemField', id: string, readableName?: string | null, localizedName?: string | null, companySystemField?: { __typename?: 'CompanySystemField', id: string, sensitive: boolean } | null } | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null } | null };

export type UpdateFutureDataByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UpdateFutureDataByIdMutation = { __typename?: 'Mutation', updateFutureDatumById?: { __typename?: 'UpdateFutureDatumPayload', futureDatum?: { __typename?: 'FutureDatum', id: string, systemFieldId?: string | null, formFieldId?: string | null, formFieldEntryId?: string | null, userId: string, updateValueAt?: Date | string | null, createdAt: Date | string, value: any, previousHumanReadableValue?: string | null, humanReadableValue?: string | null, approvalIsRequired?: boolean | null, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, approvalId?: string | null, creatorUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null, formField?: { __typename?: 'FormField', id: string, localizedName?: string | null, sensitive?: boolean | null } | null, systemField?: { __typename?: 'SystemField', id: string, readableName?: string | null, localizedName?: string | null, companySystemField?: { __typename?: 'CompanySystemField', id: string, sensitive: boolean } | null } | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null } | null };

export type CreateGroupMutationVariables = Exact<{
  companyId: Scalars['UUID'];
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<RoleScope>;
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  autoInherit?: InputMaybe<Scalars['Boolean']>;
  copyFromGroupId?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup?: { __typename?: 'CreateGroupPayload', group?: { __typename?: 'Group', id: string, name?: string | null, localizedName?: string | null, description?: string | null, scope?: RoleScope | null, active: boolean, autoAdd?: boolean | null, autoAddNewPermissions: boolean, autoInherit: boolean, groupRoles: { __typename?: 'GroupRolesConnection', nodes: Array<{ __typename?: 'GroupRole', groupId: string, roleId: string, itemIds?: Array<string | null> | null, role?: { __typename?: 'Role', id: string, info: string, name: string, scopes?: Array<RoleScope | null> | null, usesItemIds: boolean } | null } | null> } } | null } | null };

export type UpdateGroupByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<RoleScope>;
  autoAdd?: InputMaybe<Scalars['Boolean']>;
  autoAddNewPermissions?: InputMaybe<Scalars['Boolean']>;
  autoInherit?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateGroupByIdMutation = { __typename?: 'Mutation', updateGroupById?: { __typename?: 'UpdateGroupPayload', group?: { __typename?: 'Group', id: string, name?: string | null, localizedName?: string | null, description?: string | null, scope?: RoleScope | null, active: boolean, autoAdd?: boolean | null, autoAddNewPermissions: boolean, autoInherit: boolean, groupRoles: { __typename?: 'GroupRolesConnection', nodes: Array<{ __typename?: 'GroupRole', groupId: string, roleId: string, itemIds?: Array<string | null> | null, role?: { __typename?: 'Role', id: string, info: string, name: string, scopes?: Array<RoleScope | null> | null, usesItemIds: boolean } | null } | null> } } | null } | null };

export type DeleteGroupByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteGroupByIdMutation = { __typename?: 'Mutation', updateGroupById?: { __typename?: 'UpdateGroupPayload', clientMutationId?: string | null } | null };

export type AddRoleToGroupMutationVariables = Exact<{
  roleId: Scalars['UUID'];
  groupId: Scalars['UUID'];
}>;


export type AddRoleToGroupMutation = { __typename?: 'Mutation', addRoleToGroup?: { __typename?: 'AddRoleToGroupPayload', groupRole?: { __typename?: 'GroupRole', roleId: string, groupId: string, itemIds?: Array<string | null> | null } | null } | null };

export type RemoveRoleFromGroupMutationVariables = Exact<{
  roleId: Scalars['UUID'];
  groupId: Scalars['UUID'];
}>;


export type RemoveRoleFromGroupMutation = { __typename?: 'Mutation', removeRoleFromGroup?: { __typename?: 'RemoveRoleFromGroupPayload', clientMutationId?: string | null } | null };

export type CreateGroupRoleMutationVariables = Exact<{
  roleId?: InputMaybe<Scalars['UUID']>;
  groupId?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateGroupRoleMutation = { __typename?: 'Mutation', createGroupRole?: { __typename?: 'CreateGroupRolePayload', groupRole?: { __typename?: 'GroupRole', roleId: string, groupId: string, itemIds?: Array<string | null> | null } | null } | null };

export type UpdateGroupRoleByGroupIdAndRoleIdMutationVariables = Exact<{
  roleId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type UpdateGroupRoleByGroupIdAndRoleIdMutation = { __typename?: 'Mutation', updateGroupRoleByGroupIdAndRoleId?: { __typename?: 'UpdateGroupRolePayload', groupRole?: { __typename?: 'GroupRole', roleId: string, groupId: string, itemIds?: Array<string | null> | null } | null } | null };

export type DeleteIntegrableSystemIntegrationMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteIntegrableSystemIntegrationMutation = { __typename?: 'Mutation', deleteIntegrableSystemIntegration: boolean };

export type CreateIntegrableSystemIntegrationMutationVariables = Exact<{
  id: Scalars['UUID'];
  code: Scalars['String'];
}>;


export type CreateIntegrableSystemIntegrationMutation = { __typename?: 'Mutation', createIntegrableSystemIntegration: string };

export type ActivateIntegrableSystemIntegrationMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ActivateIntegrableSystemIntegrationMutation = { __typename?: 'Mutation', activateIntegrableSystemIntegration: boolean };

export type CreateLoggedActionMutationVariables = Exact<{
  tableName: Scalars['String'];
  affectedId: Scalars['String'];
  selectedFields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateLoggedActionMutation = { __typename?: 'Mutation', createLoggedAction?: { __typename?: 'CreateLoggedActionPayload', clientMutationId?: string | null } | null };

export type CreateLoggedActionNoteMutationVariables = Exact<{
  eventId: Scalars['BigInt'];
  note: Scalars['String'];
}>;


export type CreateLoggedActionNoteMutation = { __typename?: 'Mutation', createLoggedActionNote?: { __typename?: 'CreateLoggedActionNotePayload', clientMutationId?: string | null } | null };

export type UpdateLoggedActionNoteByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateLoggedActionNoteByIdMutation = { __typename?: 'Mutation', updateLoggedActionNoteById?: { __typename?: 'UpdateLoggedActionNotePayload', loggedActionNote?: { __typename?: 'LoggedActionNote', id: string, note: string } | null } | null };

export type CreateMessageMutationVariables = Exact<{
  messageRecipients: Array<Scalars['UUID']> | Scalars['UUID'];
  subject: Scalars['String'];
  body: Scalars['String'];
  attachments?: InputMaybe<Array<AttachmentInput> | AttachmentInput>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  channel?: InputMaybe<MessageChannel>;
}>;


export type CreateMessageMutation = { __typename?: 'Mutation', SendMessage?: { __typename?: 'MessageGraphilePayload', message?: { __typename?: 'Message', id: string } | null } | null };

export type NotificationCreateMutationVariables = Exact<{
  companyId: Scalars['UUID'];
  notificationTypeId: Scalars['UUID'];
  hookName: Scalars['String'];
  recipientType?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
  emailSubject?: InputMaybe<Scalars['String']>;
  customRecipientEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  permissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  customEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  metadata?: InputMaybe<Scalars['JSON']>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
}>;


export type NotificationCreateMutation = { __typename?: 'Mutation', createNotification?: { __typename?: 'CreateNotificationPayload', notification?: { __typename?: 'Notification', id: string, notificationTypeId: string, hookId: string, hookName?: string | null, recipientType?: string | null, text?: string | null, emailSubject?: string | null, localizedText?: string | null, metadata?: any | null, createdAt: Date | string, updatedAt: Date | string, notificationType?: { __typename?: 'NotificationType', id: string, name: string, broadcastTime?: string | null, channelTypes: { __typename?: 'ChannelTypesConnection', nodes: Array<{ __typename?: 'ChannelType', id: string, name: string } | null> } } | null } | null } | null };

export type NotificationUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
  recipientType?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  customRecipientEmployeeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  permissionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  customEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  metadata?: InputMaybe<Scalars['JSON']>;
}>;


export type NotificationUpdateMutation = { __typename?: 'Mutation', updateNotificationById?: { __typename?: 'UpdateNotificationPayload', notification?: { __typename?: 'Notification', id: string, notificationTypeId: string, hookId: string, hookName?: string | null, recipientType?: string | null, text?: string | null, emailSubject?: string | null, localizedText?: string | null, metadata?: any | null, createdAt: Date | string, updatedAt: Date | string, notificationType?: { __typename?: 'NotificationType', id: string, name: string, broadcastTime?: string | null, channelTypes: { __typename?: 'ChannelTypesConnection', nodes: Array<{ __typename?: 'ChannelType', id: string, name: string } | null> } } | null } | null } | null };

export type NotificationDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type NotificationDeleteMutation = { __typename?: 'Mutation', updateNotificationById?: { __typename?: 'UpdateNotificationPayload', notification?: { __typename?: 'Notification', id: string, notificationTypeId: string, hookId: string, hookName?: string | null, recipientType?: string | null, text?: string | null, emailSubject?: string | null, localizedText?: string | null, metadata?: any | null, createdAt: Date | string, updatedAt: Date | string, notificationType?: { __typename?: 'NotificationType', id: string, name: string, broadcastTime?: string | null, channelTypes: { __typename?: 'ChannelTypesConnection', nodes: Array<{ __typename?: 'ChannelType', id: string, name: string } | null> } } | null } | null } | null };

export type NotificationTypeCreateMutationVariables = Exact<{
  companyId: Scalars['UUID'];
  name: Scalars['String'];
  channelTypeIds?: InputMaybe<NotificationTypeChannelTypeNotificationTypeIdForeignInverseInput>;
  broadcastTime?: InputMaybe<Scalars['Time']>;
  timeZone?: InputMaybe<Scalars['String']>;
  avoidBundling?: InputMaybe<Scalars['Boolean']>;
}>;


export type NotificationTypeCreateMutation = { __typename?: 'Mutation', createNotificationType?: { __typename?: 'CreateNotificationTypePayload', notificationType?: { __typename?: 'NotificationType', id: string, name: string, broadcastTime?: string | null, timeZone?: string | null, avoidBundling: boolean, channelTypes: { __typename?: 'ChannelTypesConnection', nodes: Array<{ __typename?: 'ChannelType', id: string, name: string } | null> } } | null } | null };

export type NotificationTypeUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
  channelTypeIds?: InputMaybe<NotificationTypeChannelTypeNotificationTypeIdForeignInverseInput>;
  broadcastTime?: InputMaybe<Scalars['Time']>;
  timeZone?: InputMaybe<Scalars['String']>;
  avoidBundling?: InputMaybe<Scalars['Boolean']>;
}>;


export type NotificationTypeUpdateMutation = { __typename?: 'Mutation', deleteNotificationTypeChannelTypeByNotificationTypeId?: { __typename?: 'DeleteNotificationTypeChannelTypeByNotificationTypeIdPayload', notificationTypeChannelTypes?: Array<{ __typename?: 'NotificationTypeChannelType', notificationTypeId: string, channelTypeId: string } | null> | null } | null, updateNotificationTypeById?: { __typename?: 'UpdateNotificationTypePayload', notificationType?: { __typename?: 'NotificationType', id: string, name: string, broadcastTime?: string | null, timeZone?: string | null, avoidBundling: boolean, channelTypes: { __typename?: 'ChannelTypesConnection', nodes: Array<{ __typename?: 'ChannelType', id: string, name: string } | null> } } | null } | null };

export type NotificationTypeDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type NotificationTypeDeleteMutation = { __typename?: 'Mutation', updateNotificationTypeById?: { __typename?: 'UpdateNotificationTypePayload', notificationType?: { __typename?: 'NotificationType', id: string, name: string, broadcastTime?: string | null, timeZone?: string | null, avoidBundling: boolean, channelTypes: { __typename?: 'ChannelTypesConnection', nodes: Array<{ __typename?: 'ChannelType', id: string, name: string } | null> } } | null } | null };

export type NotificationReadAllMutationVariables = Exact<{ [key: string]: never; }>;


export type NotificationReadAllMutation = { __typename?: 'Mutation', notificationReadAll?: { __typename?: 'NotificationReadAllPayload', clientMutationId?: string | null } | null };

export type UpdateNotificationEmployeeByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UpdateNotificationEmployeeByIdMutation = { __typename?: 'Mutation', updateNotificationEmployeeById?: { __typename?: 'UpdateNotificationEmployeePayload', notificationEmployee?: { __typename?: 'NotificationEmployee', id: string, recipientId: string, read: boolean, createdAt: Date | string, notification?: { __typename?: 'Notification', text?: string | null, hook?: { __typename?: 'Hook', id: string, name: string } | null } | null, references: { __typename?: 'NotificationEmployeeReferencesConnection', nodes: Array<{ __typename?: 'NotificationEmployeeReference', notificationData?: { __typename?: 'NotificationData', type?: string | null, name?: string | null, object?: any | null } | null } | null> }, sender?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null, employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null } | null };

export type DeleteAllCompanyEmployeeNotificationsMutationVariables = Exact<{
  companyId: Scalars['UUID'];
}>;


export type DeleteAllCompanyEmployeeNotificationsMutation = { __typename?: 'Mutation', deleteAllCompanyEmployeeNotifications?: { __typename?: 'DeleteAllCompanyEmployeeNotificationsPayload', clientMutationId?: string | null } | null };

export type DeletePostTypeMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeletePostTypeMutation = { __typename?: 'Mutation', updatePostTypeById?: { __typename?: 'UpdatePostTypePayload', clientMutationId?: string | null } | null };

export type PostTypeCreateMutationVariables = Exact<{
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  sharedUsers?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  sharedDepartments?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type PostTypeCreateMutation = { __typename?: 'Mutation', createPostType?: { __typename?: 'CreatePostTypePayload', postType?: { __typename?: 'PostType', id: string, name?: string | null, localizedName?: string | null } | null } | null };

export type PostTypeUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  sharedUsers?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  sharedDepartments?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type PostTypeUpdateMutation = { __typename?: 'Mutation', updatePostTypeById?: { __typename?: 'UpdatePostTypePayload', postType?: { __typename?: 'PostType', id: string, name?: string | null, localizedName?: string | null } | null } | null };

export type CreatePreboardingMutationVariables = Exact<{
  preboarding: PreboardingInput;
}>;


export type CreatePreboardingMutation = { __typename?: 'Mutation', createPreboarding?: { __typename?: 'CreatePreboardingPayload', preboarding?: { __typename?: 'Preboarding', id: string, archived: boolean, companyId?: string | null, name?: string | null, departmentIds?: Array<string | null> | null, userIds?: Array<string | null> | null, managerIds: Array<string | null>, predecessorId?: string | null, recipientId?: string | null, active: boolean, order: number, fontSize: number, backgroundColor?: string | null, textColor?: string | null, useContentColors: boolean, contentBackgroundColor?: string | null, contentTextColor?: string | null, logoWidth?: number | null, firstSlideName?: string | null, firstSlideTitle?: string | null, firstSlideDescription?: string | null, lastSlideName?: string | null, lastSlideTitle?: string | null, lastSlideDescription?: string | null, overviewSlideName?: string | null, overviewSlideTitle?: string | null, overviewSlideDescription?: string | null, overviewSlideEnabled: boolean, nextButtonText?: string | null, prevButtonText?: string | null, logoType?: PreboardingLogoType | null, emailSubject?: string | null, emailBody?: string | null, smsBody?: string | null, linkButtonText?: string | null, result?: any | null, type?: PreboardingType | null, template: boolean, published: boolean, completed: boolean, deadline?: Date | string | null, reminder?: Date | string | null, startDate: Date | string, createdAt: Date | string, locale: string, useCustomLinkButtonColor: boolean, fallbackText?: string | null, dateFormat?: string | null, disable2Fa: boolean, confirmResults: boolean, useLeader: boolean, useWorkEmail: boolean, channel?: PreboardingChannel | null, closeAccess?: number | null, reminderDays?: number | null, recipientGroupId?: string | null, recipientDirectManager?: boolean | null, recipientCustomEmployeeFieldId?: string | null, defaultManagerUserIds: Array<string | null>, defaultManagerGroupIds: Array<string | null>, defaultManagerEmployeeFieldIds: Array<string | null>, defaultManagerDirectManager: boolean, fontUrl?: string | null, fontType?: PreboardingFontType | null, engagementTypeId?: string | null, anonymous: boolean, recipient?: { __typename?: 'User', id: string, firstName?: string | null, fullName?: string | null, logo?: string | null } | null, storage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, fontStorage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, departments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, preboardingSlides: { __typename?: 'PreboardingSlidesConnection', nodes: Array<{ __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null> }, preboardingEmployees: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, completed: boolean, published: boolean } | null> }, engagementType?: { __typename?: 'EngagementType', id: string, localizedName?: string | null } | null } | null } | null };

export type UpdatePreboardingMutationVariables = Exact<{
  id: Scalars['UUID'];
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  predecessorId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['Int']>;
  fontUrl?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  textColor?: InputMaybe<Scalars['String']>;
  useContentColors?: InputMaybe<Scalars['Boolean']>;
  contentBackgroundColor?: InputMaybe<Scalars['String']>;
  contentTextColor?: InputMaybe<Scalars['String']>;
  logoWidth?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<PreboardingType>;
  fontType?: InputMaybe<PreboardingFontType>;
  logoType?: InputMaybe<PreboardingLogoType>;
  firstSlideName?: InputMaybe<Scalars['String']>;
  firstSlideTitle?: InputMaybe<Scalars['String']>;
  firstSlideDescription?: InputMaybe<Scalars['String']>;
  lastSlideName?: InputMaybe<Scalars['String']>;
  lastSlideTitle?: InputMaybe<Scalars['String']>;
  lastSlideDescription?: InputMaybe<Scalars['String']>;
  overviewSlideName?: InputMaybe<Scalars['String']>;
  overviewSlideTitle?: InputMaybe<Scalars['String']>;
  overviewSlideDescription?: InputMaybe<Scalars['String']>;
  nextButtonText?: InputMaybe<Scalars['String']>;
  prevButtonText?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  emailBody?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  fallbackText?: InputMaybe<Scalars['String']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['JSON']>;
  overviewSlideEnabled?: InputMaybe<Scalars['Boolean']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  useCustomLinkButtonColor?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  useLeader?: InputMaybe<Scalars['Boolean']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  confirmResults?: InputMaybe<Scalars['Boolean']>;
  disable2Fa?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  reminder?: InputMaybe<Scalars['Datetime']>;
  order?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  recipientGroupId?: InputMaybe<Scalars['UUID']>;
  recipientCustomEmployeeFieldId?: InputMaybe<Scalars['UUID']>;
  recipientDirectManager?: InputMaybe<Scalars['Boolean']>;
  defaultManagerUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  defaultManagerGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  defaultManagerEmployeeFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  defaultManagerDirectManager?: InputMaybe<Scalars['Boolean']>;
  channel?: InputMaybe<PreboardingChannel>;
  closeAccess?: InputMaybe<Scalars['Int']>;
  reminderDays?: InputMaybe<Scalars['Int']>;
  preboardingEmployees?: InputMaybe<PreboardingEmployeePreboardingIdForeignInverseInput>;
  smsBody?: InputMaybe<Scalars['String']>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdatePreboardingMutation = { __typename?: 'Mutation', updatePreboardingById?: { __typename?: 'UpdatePreboardingPayload', preboarding?: { __typename?: 'Preboarding', id: string, archived: boolean, companyId?: string | null, name?: string | null, departmentIds?: Array<string | null> | null, userIds?: Array<string | null> | null, managerIds: Array<string | null>, predecessorId?: string | null, recipientId?: string | null, active: boolean, order: number, fontSize: number, backgroundColor?: string | null, textColor?: string | null, useContentColors: boolean, contentBackgroundColor?: string | null, contentTextColor?: string | null, logoWidth?: number | null, firstSlideName?: string | null, firstSlideTitle?: string | null, firstSlideDescription?: string | null, lastSlideName?: string | null, lastSlideTitle?: string | null, lastSlideDescription?: string | null, overviewSlideName?: string | null, overviewSlideTitle?: string | null, overviewSlideDescription?: string | null, overviewSlideEnabled: boolean, nextButtonText?: string | null, prevButtonText?: string | null, logoType?: PreboardingLogoType | null, emailSubject?: string | null, emailBody?: string | null, smsBody?: string | null, linkButtonText?: string | null, result?: any | null, type?: PreboardingType | null, template: boolean, published: boolean, completed: boolean, deadline?: Date | string | null, reminder?: Date | string | null, startDate: Date | string, createdAt: Date | string, locale: string, useCustomLinkButtonColor: boolean, fallbackText?: string | null, dateFormat?: string | null, disable2Fa: boolean, confirmResults: boolean, useLeader: boolean, useWorkEmail: boolean, channel?: PreboardingChannel | null, closeAccess?: number | null, reminderDays?: number | null, recipientGroupId?: string | null, recipientDirectManager?: boolean | null, recipientCustomEmployeeFieldId?: string | null, defaultManagerUserIds: Array<string | null>, defaultManagerGroupIds: Array<string | null>, defaultManagerEmployeeFieldIds: Array<string | null>, defaultManagerDirectManager: boolean, fontUrl?: string | null, fontType?: PreboardingFontType | null, engagementTypeId?: string | null, anonymous: boolean, recipient?: { __typename?: 'User', id: string, firstName?: string | null, fullName?: string | null, logo?: string | null } | null, storage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, fontStorage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, departments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, preboardingSlides: { __typename?: 'PreboardingSlidesConnection', nodes: Array<{ __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null> }, preboardingEmployees: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, completed: boolean, published: boolean } | null> }, engagementType?: { __typename?: 'EngagementType', id: string, localizedName?: string | null } | null } | null } | null };

export type UpdatePreboardingEmployeeMutationVariables = Exact<{
  id: Scalars['UUID'];
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  conclusion?: InputMaybe<Scalars['JSON']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  preboardingResults?: InputMaybe<PreboardingResultPreboardingEmployeeIdForeignInverseInput>;
}>;


export type UpdatePreboardingEmployeeMutation = { __typename?: 'Mutation', updatePreboardingEmployeeById?: { __typename?: 'UpdatePreboardingEmployeePayload', preboardingEmployee?: { __typename?: 'PreboardingEmployee', id: string, employeeId: string, managerIds?: Array<string | null> | null, active: boolean, conclusion?: any | null, archived: boolean, published: boolean, completed: boolean, completedReminded?: boolean | null, createdAt: Date | string, recipientId?: string | null, employee?: { __typename?: 'Employee', id: string, userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null, isLeader: boolean, userDepartments: { __typename?: 'UserDepartmentsConnection', nodes: Array<{ __typename?: 'UserDepartment', departmentId: string } | null> } } | null } | null, preboarding?: { __typename?: 'Preboarding', id: string, archived: boolean, companyId?: string | null, name?: string | null, departmentIds?: Array<string | null> | null, userIds?: Array<string | null> | null, managerIds: Array<string | null>, predecessorId?: string | null, recipientId?: string | null, active: boolean, order: number, fontSize: number, backgroundColor?: string | null, textColor?: string | null, useContentColors: boolean, contentBackgroundColor?: string | null, contentTextColor?: string | null, logoWidth?: number | null, firstSlideName?: string | null, firstSlideTitle?: string | null, firstSlideDescription?: string | null, lastSlideName?: string | null, lastSlideTitle?: string | null, lastSlideDescription?: string | null, overviewSlideName?: string | null, overviewSlideTitle?: string | null, overviewSlideDescription?: string | null, overviewSlideEnabled: boolean, nextButtonText?: string | null, prevButtonText?: string | null, logoType?: PreboardingLogoType | null, emailSubject?: string | null, emailBody?: string | null, smsBody?: string | null, linkButtonText?: string | null, result?: any | null, type?: PreboardingType | null, template: boolean, published: boolean, completed: boolean, deadline?: Date | string | null, reminder?: Date | string | null, startDate: Date | string, createdAt: Date | string, locale: string, useCustomLinkButtonColor: boolean, fallbackText?: string | null, dateFormat?: string | null, disable2Fa: boolean, confirmResults: boolean, useLeader: boolean, useWorkEmail: boolean, channel?: PreboardingChannel | null, closeAccess?: number | null, reminderDays?: number | null, recipientGroupId?: string | null, recipientDirectManager?: boolean | null, recipientCustomEmployeeFieldId?: string | null, defaultManagerUserIds: Array<string | null>, defaultManagerGroupIds: Array<string | null>, defaultManagerEmployeeFieldIds: Array<string | null>, defaultManagerDirectManager: boolean, fontUrl?: string | null, fontType?: PreboardingFontType | null, engagementTypeId?: string | null, anonymous: boolean, recipient?: { __typename?: 'User', id: string, firstName?: string | null, fullName?: string | null, logo?: string | null } | null, storage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, fontStorage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, departments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, preboardingSlides: { __typename?: 'PreboardingSlidesConnection', nodes: Array<{ __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null> }, preboardingEmployees: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, completed: boolean, published: boolean } | null> }, engagementType?: { __typename?: 'EngagementType', id: string, localizedName?: string | null } | null } | null } | null } | null };

export type CreatePreboardingSlideMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
  preboardingId?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
}>;


export type CreatePreboardingSlideMutation = { __typename?: 'Mutation', createPreboardingSlide?: { __typename?: 'CreatePreboardingSlidePayload', preboardingSlide?: { __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null } | null };

export type UpdatePreboardingSlideMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  pageDescription?: InputMaybe<Scalars['String']>;
  preboardingSlideFormFields?: InputMaybe<PreboardingSlideFormFieldPreboardingSlideIdForeignInverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  addReviewNote?: InputMaybe<Scalars['Boolean']>;
  reviewNote?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePreboardingSlideMutation = { __typename?: 'Mutation', updatePreboardingSlideById?: { __typename?: 'UpdatePreboardingSlidePayload', preboardingSlide?: { __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null } | null };

export type CreatePreboardingSlideFormFieldMutationVariables = Exact<{
  companyId: Scalars['UUID'];
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  name: Scalars['String'];
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideFormFieldId?: InputMaybe<Scalars['UUID']>;
  fieldType?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
  engagementTypeId?: InputMaybe<Scalars['UUID']>;
}>;


export type CreatePreboardingSlideFormFieldMutation = { __typename?: 'Mutation', createPreboardingSlideFormField?: { __typename?: 'CreatePreboardingSlideFormFieldPayload', preboardingSlideFormField?: { __typename?: 'PreboardingSlideFormField', id: string } | null, preboardingSlide?: { __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null } | null };

export type UpdatePreboardingSlideFormFieldByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  formFieldId: Scalars['UUID'];
  name: Scalars['String'];
  fieldType?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  formFieldOptions?: InputMaybe<FormFieldOptionFormFieldIdForeignInverseInput>;
}>;


export type UpdatePreboardingSlideFormFieldByIdMutation = { __typename?: 'Mutation', updatePreboardingSlideFormFieldById?: { __typename?: 'UpdatePreboardingSlideFormFieldPayload', preboardingSlide?: { __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null } | null };

export type UpdatePreboardingSlideFormFieldByIdBasic1MutationVariables = Exact<{
  id: Scalars['UUID'];
  active?: InputMaybe<Scalars['Boolean']>;
  required?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdatePreboardingSlideFormFieldByIdBasic1Mutation = { __typename?: 'Mutation', updatePreboardingSlideFormFieldById?: { __typename?: 'UpdatePreboardingSlideFormFieldPayload', preboardingSlide?: { __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null } | null };

export type DeletePreboardingSlideFormFieldByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeletePreboardingSlideFormFieldByIdMutation = { __typename?: 'Mutation', deletePreboardingSlideFormFieldById?: { __typename?: 'DeletePreboardingSlideFormFieldPayload', preboardingSlide?: { __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null } | null };

export type CreatePreboardingSlideFormFieldNoCreateFormFieldMutationVariables = Exact<{
  preboardingSlideFormField: PreboardingSlideFormFieldInput;
}>;


export type CreatePreboardingSlideFormFieldNoCreateFormFieldMutation = { __typename?: 'Mutation', createPreboardingSlideFormField?: { __typename?: 'CreatePreboardingSlideFormFieldPayload', preboardingSlideFormField?: { __typename?: 'PreboardingSlideFormField', id: string, systemField?: UserEmployeeFields | null, formField?: { __typename?: 'FormField', id: string, name: string } | null } | null } | null };

export type UpdatePreboardingSlideFormFieldByIdNoCreateFormFieldMutationVariables = Exact<{
  id: Scalars['UUID'];
  preboardingSlideFormField: PreboardingSlideFormFieldPatch;
}>;


export type UpdatePreboardingSlideFormFieldByIdNoCreateFormFieldMutation = { __typename?: 'Mutation', updatePreboardingSlideFormFieldById?: { __typename?: 'UpdatePreboardingSlideFormFieldPayload', preboardingSlideFormField?: { __typename?: 'PreboardingSlideFormField', id: string, systemField?: UserEmployeeFields | null, formField?: { __typename?: 'FormField', id: string, name: string } | null } | null } | null };

export type SendPreboardingLinksMutationVariables = Exact<{
  preboardingId: Scalars['UUID'];
  employeeIds: Array<Scalars['UUID']> | Scalars['UUID'];
  emailSubject?: InputMaybe<Scalars['String']>;
  emailBody?: InputMaybe<Scalars['String']>;
  smsBody?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
  useWorkEmail?: InputMaybe<Scalars['Boolean']>;
  channel?: InputMaybe<PreboardingChannel>;
  sendTime?: InputMaybe<Scalars['Datetime']>;
}>;


export type SendPreboardingLinksMutation = { __typename?: 'Mutation', SendPreboardingLinks?: { __typename?: 'SendPreboardingLinksPayload', links?: Array<string | null> | null } | null };

export type CreatePreboardingCommentMutationVariables = Exact<{
  preboardingResultId?: InputMaybe<Scalars['UUID']>;
  preboardingSlideId?: InputMaybe<Scalars['UUID']>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  text?: InputMaybe<Scalars['String']>;
}>;


export type CreatePreboardingCommentMutation = { __typename?: 'Mutation', createPreboardingResultSlideComment?: { __typename?: 'CreatePreboardingResultSlideCommentPayload', preboardingResultSlideComment?: { __typename?: 'PreboardingResultSlideComment', id: string, preboardingSlideId: string, edited: boolean, public: boolean, text: string, createdAt: Date | string, preboardingSlide?: { __typename?: 'PreboardingSlide', id: string, name?: string | null } | null, user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null } | null } | null } | null };

export type UpdatePreboardingCommentMutationVariables = Exact<{
  id: Scalars['UUID'];
  text?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  edited?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdatePreboardingCommentMutation = { __typename?: 'Mutation', updatePreboardingResultSlideCommentById?: { __typename?: 'UpdatePreboardingResultSlideCommentPayload', preboardingResultSlideComment?: { __typename?: 'PreboardingResultSlideComment', id: string, preboardingSlideId: string, edited: boolean, public: boolean, text: string, createdAt: Date | string, preboardingSlide?: { __typename?: 'PreboardingSlide', id: string, name?: string | null } | null, user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null } | null } | null } | null };

export type DeletePreboardingCommentMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeletePreboardingCommentMutation = { __typename?: 'Mutation', deletePreboardingResultSlideCommentById?: { __typename?: 'DeletePreboardingResultSlideCommentPayload', preboardingResultSlideComment?: { __typename?: 'PreboardingResultSlideComment', id: string } | null } | null };

export type CreatePreboardingResultMutationVariables = Exact<{
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  result?: InputMaybe<Scalars['JSON']>;
}>;


export type CreatePreboardingResultMutation = { __typename?: 'Mutation', createPreboardingResult?: { __typename?: 'CreatePreboardingResultPayload', clientMutationId?: string | null } | null };

export type UpdatePreboardingResultMutationVariables = Exact<{
  id: Scalars['UUID'];
  result?: InputMaybe<Scalars['JSON']>;
}>;


export type UpdatePreboardingResultMutation = { __typename?: 'Mutation', updatePreboardingResultById?: { __typename?: 'UpdatePreboardingResultPayload', clientMutationId?: string | null } | null };

export type CreatePreboardingProcessMutationVariables = Exact<{
  preboardingId?: InputMaybe<Scalars['UUID']>;
  processId?: InputMaybe<Scalars['UUID']>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<Scalars['Int']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  order?: InputMaybe<Scalars['Int']>;
}>;


export type CreatePreboardingProcessMutation = { __typename?: 'Mutation', createPreboardingProcess?: { __typename?: 'CreatePreboardingProcessPayload', clientMutationId?: string | null } | null };

export type UpdatePreboardingProcessMutationVariables = Exact<{
  preboardingId: Scalars['UUID'];
  processId: Scalars['UUID'];
  sendDate?: InputMaybe<Scalars['Datetime']>;
  sendTime?: InputMaybe<Scalars['Time']>;
  startDay?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<Scalars['Int']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  order?: InputMaybe<Scalars['Int']>;
  deadline?: InputMaybe<Scalars['Datetime']>;
  recipientId?: InputMaybe<Scalars['UUID']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  emailBody?: InputMaybe<Scalars['String']>;
  linkButtonText?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePreboardingProcessMutation = { __typename?: 'Mutation', updatePreboardingProcessByPreboardingIdAndProcessId?: { __typename?: 'UpdatePreboardingProcessPayload', clientMutationId?: string | null } | null };

export type DeletePreboardingProcessMutationVariables = Exact<{
  preboardingId: Scalars['UUID'];
  processId: Scalars['UUID'];
}>;


export type DeletePreboardingProcessMutation = { __typename?: 'Mutation', deletePreboardingProcessByPreboardingIdAndProcessId?: { __typename?: 'DeletePreboardingProcessPayload', clientMutationId?: string | null } | null };

export type CreatePreboardingFormCacheMutationVariables = Exact<{
  preboardingId: Scalars['UUID'];
  userId: Scalars['UUID'];
  formValues?: InputMaybe<Scalars['JSON']>;
  page?: InputMaybe<Scalars['String']>;
}>;


export type CreatePreboardingFormCacheMutation = { __typename?: 'Mutation', createPreboardingFormCache?: { __typename?: 'CreatePreboardingFormCachePayload', clientMutationId?: string | null } | null };

export type UpdatePreboardingFormCacheByPreboardingIdAndUserIdMutationVariables = Exact<{
  preboardingId: Scalars['UUID'];
  userId: Scalars['UUID'];
  formValues?: InputMaybe<Scalars['JSON']>;
  page?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePreboardingFormCacheByPreboardingIdAndUserIdMutation = { __typename?: 'Mutation', updatePreboardingFormCacheByPreboardingIdAndUserId?: { __typename?: 'UpdatePreboardingFormCachePayload', clientMutationId?: string | null } | null };

export type CreateProcessMutationVariables = Exact<{
  name: Scalars['String'];
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  companyId: Scalars['UUID'];
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  assignedUserDepartments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  template?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  processResponsibles?: InputMaybe<ProcessResponsibleProcessIdForeignInverseInput>;
  projects?: InputMaybe<ProjectProcessIdForeignInverseInput>;
  tasks?: InputMaybe<TaskProcessIdForeignInverseInput>;
  scheduledMessages?: InputMaybe<ScheduledMessageProcessIdForeignInverseInput>;
  projectTemplates?: InputMaybe<ProjectTemplateProcessIdForeignInverseInput>;
  taskTemplates?: InputMaybe<TaskTemplateProcessIdForeignInverseInput>;
  scheduledMessageTemplates?: InputMaybe<ScheduledMessageTemplateProcessIdForeignInverseInput>;
  preboardingProcesses?: InputMaybe<PreboardingProcessProcessIdForeignInverseInput>;
}>;


export type CreateProcessMutation = { __typename?: 'Mutation', createProcess?: { __typename?: 'CreateProcessPayload', process?: { __typename?: 'Process', id: string } | null } | null };

export type UpdateProcessMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  processTypeId?: InputMaybe<Scalars['UUID']>;
  cutoffDay?: InputMaybe<Scalars['Boolean']>;
  template?: InputMaybe<Scalars['Boolean']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  employee?: InputMaybe<ProcessEmployeeIdForeignInput>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  active?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateProcessMutation = { __typename?: 'Mutation', updateProcessById?: { __typename?: 'UpdateProcessPayload', process?: { __typename?: 'Process', id: string, name?: string | null, processTypeId?: string | null, departmentIds?: Array<string | null> | null } | null } | null };

export type CloneProcessMutationVariables = Exact<{
  processId: Scalars['UUID'];
  name: Scalars['String'];
  departmentIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type CloneProcessMutation = { __typename?: 'Mutation', cloneProcess?: { __typename?: 'Process', id: string } | null };

export type ProcessTypeDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProcessTypeDeleteMutation = { __typename?: 'Mutation', updateProcessTypeById?: { __typename?: 'UpdateProcessTypePayload', processType?: { __typename?: 'ProcessType', id: string } | null } | null };

export type ProcessTypeCreateMutationVariables = Exact<{
  name: Scalars['String'];
  companyId: Scalars['UUID'];
}>;


export type ProcessTypeCreateMutation = { __typename?: 'Mutation', createProcessType?: { __typename?: 'CreateProcessTypePayload', processType?: { __typename?: 'ProcessType', id: string, name: string, localizedName?: string | null } | null } | null };

export type ProcessTypeUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
}>;


export type ProcessTypeUpdateMutation = { __typename?: 'Mutation', updateProcessTypeById?: { __typename?: 'UpdateProcessTypePayload', processType?: { __typename?: 'ProcessType', id: string, name: string, localizedName?: string | null } | null } | null };

export type CreateProjectTemplateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
  processId: Scalars['UUID'];
  name: Scalars['String'];
}>;


export type CreateProjectTemplateMutation = { __typename?: 'Mutation', createProjectTemplate?: { __typename?: 'CreateProjectTemplatePayload', clientMutationId?: string | null } | null };

export type UpdateProjectTemplateByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  patch: ProjectTemplatePatch;
}>;


export type UpdateProjectTemplateByIdMutation = { __typename?: 'Mutation', updateProjectTemplateById?: { __typename?: 'UpdateProjectTemplatePayload', clientMutationId?: string | null } | null };

export type CreateProjectMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
  employeeId?: InputMaybe<Scalars['UUID']>;
  processId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  name: Scalars['String'];
  tasks?: InputMaybe<TaskProjectIdForeignInverseInput>;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject?: { __typename?: 'CreateProjectPayload', clientMutationId?: string | null } | null };

export type UpdateProjectByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  patch: ProjectPatch;
}>;


export type UpdateProjectByIdMutation = { __typename?: 'Mutation', updateProjectById?: { __typename?: 'UpdateProjectPayload', clientMutationId?: string | null } | null };

export type CreatePulseSurveyMutationVariables = Exact<{
  name: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  question: Scalars['String'];
  questionLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  questionType: PulseSurveyQuestionType;
  lowestRatingLabel?: InputMaybe<Scalars['String']>;
  lowestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  highestRatingLabel?: InputMaybe<Scalars['String']>;
  highestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  lowestRating?: InputMaybe<Scalars['Int']>;
  highestRating?: InputMaybe<Scalars['Int']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['Date'];
  endDate?: InputMaybe<Scalars['Date']>;
  surveyTime: Scalars['Time'];
  isDraft?: InputMaybe<Scalars['Boolean']>;
  horizontal?: InputMaybe<Scalars['Boolean']>;
  ratingType?: InputMaybe<RatingType>;
  pulseSurveyChoices?: InputMaybe<Array<CreatePulseSurveyChoiceInput> | CreatePulseSurveyChoiceInput>;
  recurrenceRule: RecurrenceRuleInput;
  invitedUserIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  invitedDepartmentIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  reminders?: InputMaybe<Array<IntervalInput> | IntervalInput>;
  timezoneName: Scalars['String'];
}>;


export type CreatePulseSurveyMutation = { __typename?: 'Mutation', createPulseSurvey?: { __typename?: 'PulseSurvey', id: string, name?: string | null, localizedName?: string | null, questionType: PulseSurveyQuestionType, localizedQuestion?: string | null, anonymous: boolean, startDate: Date | string, surveyTime: string, endDate?: Date | string | null, isDraft: boolean, highestRating?: number | null, averageRatingAllTime?: string | number | null, averageRatingThisMonth?: string | number | null, averageRatingThisMonthLastYear?: string | number | null, averageRatingAllTimeLastYear?: string | number | null, invitedAll: boolean, recipients: { __typename?: 'PulseSurveyRecipientsConnection', nodes: Array<{ __typename?: 'PulseSurveyRecipient', id?: string | null, fullName?: string | null, logo?: string | null } | null> }, pulseType?: { __typename?: 'PulseType', id: string, localizedName?: string | null } | null, pulseSurveyChoices: { __typename?: 'PulseSurveyChoicesConnection', nodes: Array<{ __typename?: 'PulseSurveyChoice', id: string, emoji?: string | null } | null> } } | null };

export type UpdatePulseSurveyMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  question?: InputMaybe<Scalars['String']>;
  questionLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  pulseTypeId?: InputMaybe<Scalars['UUID']>;
  questionType?: InputMaybe<PulseSurveyQuestionType>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  surveyTime?: InputMaybe<Scalars['Time']>;
  lowestRating?: InputMaybe<Scalars['Int']>;
  highestRating?: InputMaybe<Scalars['Int']>;
  lowestRatingLabel?: InputMaybe<Scalars['String']>;
  lowestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  highestRatingLabel?: InputMaybe<Scalars['String']>;
  highestRatingLabelLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  horizontal?: InputMaybe<Scalars['Boolean']>;
  ratingType?: InputMaybe<RatingType>;
  recurrenceRule?: InputMaybe<RecurrenceRulePulseSurveyIdForeignInverseInput>;
  invitedUserIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  invitedDepartmentIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  invitedAll?: InputMaybe<Scalars['Boolean']>;
  reminders?: InputMaybe<Array<IntervalInput> | IntervalInput>;
  pulseSurveyChoiceLocalizations?: InputMaybe<Array<PulseSurveyChoiceLocalization> | PulseSurveyChoiceLocalization>;
}>;


export type UpdatePulseSurveyMutation = { __typename?: 'Mutation', updatePulseSurveyById?: { __typename?: 'UpdatePulseSurveyPayload', pulseSurvey?: { __typename?: 'PulseSurvey', id: string, name?: string | null, localizedName?: string | null, questionType: PulseSurveyQuestionType, localizedQuestion?: string | null, anonymous: boolean, startDate: Date | string, surveyTime: string, endDate?: Date | string | null, isDraft: boolean, highestRating?: number | null, averageRatingAllTime?: string | number | null, averageRatingThisMonth?: string | number | null, averageRatingThisMonthLastYear?: string | number | null, averageRatingAllTimeLastYear?: string | number | null, invitedAll: boolean, recipients: { __typename?: 'PulseSurveyRecipientsConnection', nodes: Array<{ __typename?: 'PulseSurveyRecipient', id?: string | null, fullName?: string | null, logo?: string | null } | null> }, pulseType?: { __typename?: 'PulseType', id: string, localizedName?: string | null } | null, pulseSurveyChoices: { __typename?: 'PulseSurveyChoicesConnection', nodes: Array<{ __typename?: 'PulseSurveyChoice', id: string, emoji?: string | null } | null> } } | null } | null };

export type DeletePulseSurveyMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeletePulseSurveyMutation = { __typename?: 'Mutation', updatePulseSurveyById?: { __typename?: 'UpdatePulseSurveyPayload', clientMutationId?: string | null } | null };

export type SubmitPulseSurveyAnswerMutationVariables = Exact<{
  pulseSurveyId: Scalars['UUID'];
  answer: Scalars['JSON'];
}>;


export type SubmitPulseSurveyAnswerMutation = { __typename?: 'Mutation', submitPulseSurveyAnswer?: { __typename?: 'PulseSurveyAnswer', id: string } | null };

export type PulseTypeDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PulseTypeDeleteMutation = { __typename?: 'Mutation', updatePulseTypeById?: { __typename?: 'UpdatePulseTypePayload', pulseType?: { __typename?: 'PulseType', id: string } | null } | null };

export type PulseTypeCreateMutationVariables = Exact<{
  name: Scalars['String'];
  companyId: Scalars['UUID'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
}>;


export type PulseTypeCreateMutation = { __typename?: 'Mutation', createPulseType?: { __typename?: 'CreatePulseTypePayload', pulseType?: { __typename?: 'PulseType', id: string, name?: string | null, localizedName?: string | null } | null } | null };

export type PulseTypeUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
}>;


export type PulseTypeUpdateMutation = { __typename?: 'Mutation', updatePulseTypeById?: { __typename?: 'UpdatePulseTypePayload', pulseType?: { __typename?: 'PulseType', id: string, name?: string | null, localizedName?: string | null } | null } | null };

export type CreateRoadmapItemMutationVariables = Exact<{
  stage: RoadmapStage;
  roadmapItemLocalization?: InputMaybe<Array<RoadmapItemLocalizationRoadmapItemIdForeignConnectionRoadmapItemLocalizationCreateInput> | RoadmapItemLocalizationRoadmapItemIdForeignConnectionRoadmapItemLocalizationCreateInput>;
}>;


export type CreateRoadmapItemMutation = { __typename?: 'Mutation', createRoadmapItem?: { __typename?: 'CreateRoadmapItemPayload', roadmapItem?: { __typename?: 'RoadmapItem', id: string, name?: string | null, summary?: string | null, description?: string | null, stage: RoadmapStage } | null } | null };

export type UpdateRoadmapItemByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  stage: RoadmapStage;
  roadmapItemLocalization?: InputMaybe<Array<RoadmapItemLocalizationOnRoadmapItemLocalizationForRoadmapItemLocalizationRoadmapItemIdForeignUsingRoadmapItemLocalizationRoadmapItemIdLocaleUniqueUpdate> | RoadmapItemLocalizationOnRoadmapItemLocalizationForRoadmapItemLocalizationRoadmapItemIdForeignUsingRoadmapItemLocalizationRoadmapItemIdLocaleUniqueUpdate>;
}>;


export type UpdateRoadmapItemByIdMutation = { __typename?: 'Mutation', updateRoadmapItemById?: { __typename?: 'UpdateRoadmapItemPayload', roadmapItem?: { __typename?: 'RoadmapItem', id: string, name?: string | null, summary?: string | null, description?: string | null, stage: RoadmapStage } | null } | null };

export type CreateRoadmapItemVoteMutationVariables = Exact<{
  roadmapItemId: Scalars['UUID'];
  userId: Scalars['UUID'];
  voteType: RoadmapItemVoteType;
}>;


export type CreateRoadmapItemVoteMutation = { __typename?: 'Mutation', createRoadmapItemVote?: { __typename?: 'CreateRoadmapItemVotePayload', roadmapItemVote?: { __typename?: 'RoadmapItemVote', id: string, roadmapItemId: string, userId: string, voteType: RoadmapItemVoteType } | null } | null };

export type DeleteRoadmapItemVoteByUserIdAndRoadmapItemIdMutationVariables = Exact<{
  userId: Scalars['UUID'];
  roadmapItemId: Scalars['UUID'];
}>;


export type DeleteRoadmapItemVoteByUserIdAndRoadmapItemIdMutation = { __typename?: 'Mutation', deleteRoadmapItemVoteByUserIdAndRoadmapItemId?: { __typename?: 'DeleteRoadmapItemVotePayload', roadmapItemVote?: { __typename?: 'RoadmapItemVote', id: string, roadmapItemId: string, userId: string, voteType: RoadmapItemVoteType } | null } | null };

export type DeleteRoadMapItemMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteRoadMapItemMutation = { __typename?: 'Mutation', updateRoadmapItemById?: { __typename?: 'UpdateRoadmapItemPayload', roadmapItem?: { __typename?: 'RoadmapItem', id: string, name?: string | null, summary?: string | null, description?: string | null, stage: RoadmapStage } | null } | null };

export type CreateRoadmapItemCommentMutationVariables = Exact<{
  roadmapItemId?: InputMaybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type CreateRoadmapItemCommentMutation = { __typename?: 'Mutation', createRoadmapItemComment?: { __typename?: 'CreateRoadmapItemCommentPayload', roadmapItemComment?: { __typename?: 'RoadmapItemComment', id: string, roadmapItemId: string, userId: string, comment?: string | null } | null } | null };

export type UpdateRoadmapItemCommentMutationVariables = Exact<{
  id: Scalars['UUID'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type UpdateRoadmapItemCommentMutation = { __typename?: 'Mutation', updateRoadmapItemCommentById?: { __typename?: 'UpdateRoadmapItemCommentPayload', roadmapItemComment?: { __typename?: 'RoadmapItemComment', id: string, comment?: string | null } | null } | null };

export type DeleteRoadmapItemCommentMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteRoadmapItemCommentMutation = { __typename?: 'Mutation', updateRoadmapItemCommentById?: { __typename?: 'UpdateRoadmapItemCommentPayload', roadmapItemComment?: { __typename?: 'RoadmapItemComment', id: string, comment?: string | null } | null } | null };

export type AddRoleToUserMutationVariables = Exact<{
  userId: Scalars['UUID'];
  roleId: Scalars['UUID'];
}>;


export type AddRoleToUserMutation = { __typename?: 'Mutation', addRoleToUser?: { __typename?: 'AddRoleToUserPayload', userRole?: { __typename?: 'UserRole', userId: string, roleId: string } | null } | null };

export type AddDepartmentRoleToUserMutationVariables = Exact<{
  userId: Scalars['UUID'];
  roleId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
}>;


export type AddDepartmentRoleToUserMutation = { __typename?: 'Mutation', addDepartmentRoleToUser?: { __typename?: 'AddDepartmentRoleToUserPayload', userDepartmentRole?: { __typename?: 'UserDepartmentRole', userId: string, roleId: string, departmentId: string } | null } | null };

export type AddCompanyRoleToUserMutationVariables = Exact<{
  userId: Scalars['UUID'];
  roleId: Scalars['UUID'];
}>;


export type AddCompanyRoleToUserMutation = { __typename?: 'Mutation', addCompanyRoleToUser?: { __typename?: 'AddCompanyRoleToUserPayload', userCompanyRole?: { __typename?: 'UserCompanyRole', userId: string, roleId: string } | null } | null };

export type RemoveRoleFromUserMutationVariables = Exact<{
  userId: Scalars['UUID'];
  roleId: Scalars['UUID'];
}>;


export type RemoveRoleFromUserMutation = { __typename?: 'Mutation', removeRoleFromUser?: { __typename?: 'RemoveRoleFromUserPayload', clientMutationId?: string | null } | null };

export type RemoveDepartmentRoleFromUserMutationVariables = Exact<{
  userId: Scalars['UUID'];
  roleId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
}>;


export type RemoveDepartmentRoleFromUserMutation = { __typename?: 'Mutation', removeDepartmentRoleFromUser?: { __typename?: 'RemoveDepartmentRoleFromUserPayload', clientMutationId?: string | null } | null };

export type RemoveCompanyRoleFromUserMutationVariables = Exact<{
  userId: Scalars['UUID'];
  roleId: Scalars['UUID'];
}>;


export type RemoveCompanyRoleFromUserMutation = { __typename?: 'Mutation', removeCompanyRoleFromUser?: { __typename?: 'RemoveCompanyRoleFromUserPayload', clientMutationId?: string | null } | null };

export type UserDepartmentRoleToggleInheritanceMutationVariables = Exact<{
  userId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  roleId: Scalars['UUID'];
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
}>;


export type UserDepartmentRoleToggleInheritanceMutation = { __typename?: 'Mutation', updateUserDepartmentRoleByUserIdAndDepartmentIdAndRoleId?: { __typename?: 'UpdateUserDepartmentRolePayload', userDepartmentRole?: { __typename?: 'UserDepartmentRole', userId: string, departmentId: string, roleId: string, inheritToDescendants: boolean, onlyIncludeInDescendants: boolean } | null } | null };

export type UserRoleToggleExclusionMutationVariables = Exact<{
  userId: Scalars['UUID'];
  roleId: Scalars['UUID'];
  excludeRole?: InputMaybe<Scalars['Boolean']>;
}>;


export type UserRoleToggleExclusionMutation = { __typename?: 'Mutation', updateUserRoleByUserIdAndRoleId?: { __typename?: 'UpdateUserRolePayload', userRole?: { __typename?: 'UserRole', userId: string, roleId: string, excludeRole: boolean } | null } | null };

export type UserDepartmentRoleToggleExclusionMutationVariables = Exact<{
  userId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  roleId: Scalars['UUID'];
  excludeRole?: InputMaybe<Scalars['Boolean']>;
}>;


export type UserDepartmentRoleToggleExclusionMutation = { __typename?: 'Mutation', updateUserDepartmentRoleByUserIdAndDepartmentIdAndRoleId?: { __typename?: 'UpdateUserDepartmentRolePayload', userDepartmentRole?: { __typename?: 'UserDepartmentRole', userId: string, departmentId: string, roleId: string, excludeRole: boolean } | null } | null };

export type UserCompanyRoleToggleExclusionMutationVariables = Exact<{
  userId: Scalars['UUID'];
  roleId: Scalars['UUID'];
  companyId: Scalars['UUID'];
  excludeRole?: InputMaybe<Scalars['Boolean']>;
}>;


export type UserCompanyRoleToggleExclusionMutation = { __typename?: 'Mutation', updateUserCompanyRoleByUserIdAndRoleIdAndCompanyId?: { __typename?: 'UpdateUserCompanyRolePayload', userCompanyRole?: { __typename?: 'UserCompanyRole', userId: string, roleId: string, excludeRole: boolean } | null } | null };

export type CreateScheduledMessageMutationVariables = Exact<{
  employeeId?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  subject: Scalars['String'];
  body: Scalars['String'];
  sendDate: Scalars['Datetime'];
  order?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
}>;


export type CreateScheduledMessageMutation = { __typename?: 'Mutation', createScheduledMessage?: { __typename?: 'CreateScheduledMessagePayload', scheduledMessage?: { __typename?: 'ScheduledMessage', id: string } | null } | null };

export type CreateScheduledMessageTemplateMutationVariables = Exact<{
  name: Scalars['String'];
  subject: Scalars['String'];
  body: Scalars['String'];
  startDay: Scalars['Int'];
  sendTime: Scalars['Time'];
  order?: InputMaybe<Scalars['Int']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  processId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput>;
}>;


export type CreateScheduledMessageTemplateMutation = { __typename?: 'Mutation', createScheduledMessageTemplate?: { __typename?: 'CreateScheduledMessageTemplatePayload', scheduledMessageTemplate?: { __typename?: 'ScheduledMessageTemplate', id: string } | null } | null };

export type UpdateScheduledMessageMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  sendDate?: InputMaybe<Scalars['Datetime']>;
  order?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageRecipients?: InputMaybe<ScheduledMessageRecipientScheduledMessageIdForeignInverseInput>;
  scheduledMessageExternalRecipients?: InputMaybe<ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput>;
}>;


export type UpdateScheduledMessageMutation = { __typename?: 'Mutation', updateScheduledMessageById?: { __typename?: 'UpdateScheduledMessagePayload', scheduledMessage?: { __typename?: 'ScheduledMessage', id: string } | null } | null };

export type UpdateScheduledMessageTemplateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  startDay?: InputMaybe<Scalars['Int']>;
  sendTime?: InputMaybe<Scalars['Time']>;
  order?: InputMaybe<Scalars['Int']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  processId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  scheduledMessageTemplateRecipients?: InputMaybe<ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput>;
  scheduledMessageTemplateExternalRecipients?: InputMaybe<ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput>;
}>;


export type UpdateScheduledMessageTemplateMutation = { __typename?: 'Mutation', updateScheduledMessageTemplateById?: { __typename?: 'UpdateScheduledMessageTemplatePayload', scheduledMessageTemplate?: { __typename?: 'ScheduledMessageTemplate', id: string } | null } | null };

export type DeleteScheduledMessageMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteScheduledMessageMutation = { __typename?: 'Mutation', updateScheduledMessageById?: { __typename?: 'UpdateScheduledMessagePayload', scheduledMessage?: { __typename?: 'ScheduledMessage', id: string } | null } | null };

export type DeleteScheduledMessageTemplateMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteScheduledMessageTemplateMutation = { __typename?: 'Mutation', updateScheduledMessageTemplateById?: { __typename?: 'UpdateScheduledMessageTemplatePayload', scheduledMessageTemplate?: { __typename?: 'ScheduledMessageTemplate', id: string } | null } | null };

export type DeleteScheduledMessageRecipientMutationVariables = Exact<{
  scheduledMessageId: Scalars['UUID'];
  employeeId: Scalars['UUID'];
}>;


export type DeleteScheduledMessageRecipientMutation = { __typename?: 'Mutation', deleteScheduledMessageRecipientByScheduledMessageIdAndEmployeeId?: { __typename?: 'DeleteScheduledMessageRecipientPayload', clientMutationId?: string | null } | null };

export type DeleteScheduledMessageTemplateRecipientMutationVariables = Exact<{
  scheduledMessageId: Scalars['UUID'];
  employeeId: Scalars['UUID'];
}>;


export type DeleteScheduledMessageTemplateRecipientMutation = { __typename?: 'Mutation', deleteScheduledMessageTemplateRecipientByScheduledMessageTemplateIdAndEmployeeId?: { __typename?: 'DeleteScheduledMessageTemplateRecipientPayload', clientMutationId?: string | null } | null };

export type DeleteScheduledMessageExternalRecipientMutationVariables = Exact<{
  scheduledMessageId: Scalars['UUID'];
  email: Scalars['String'];
}>;


export type DeleteScheduledMessageExternalRecipientMutation = { __typename?: 'Mutation', deleteScheduledMessageExternalRecipientByScheduledMessageIdAndEmail?: { __typename?: 'DeleteScheduledMessageExternalRecipientPayload', clientMutationId?: string | null } | null };

export type DeleteScheduledMessageTemplateExternalRecipientMutationVariables = Exact<{
  scheduledMessageId: Scalars['UUID'];
  email: Scalars['String'];
}>;


export type DeleteScheduledMessageTemplateExternalRecipientMutation = { __typename?: 'Mutation', deleteScheduledMessageTemplateExternalRecipientByScheduledMessageTemplateIdAndEmail?: { __typename?: 'DeleteScheduledMessageTemplateExternalRecipientPayload', clientMutationId?: string | null } | null };

export type CreateCompanySystemFieldMutationVariables = Exact<{
  systemFieldId: Scalars['UUID'];
  companyId: Scalars['UUID'];
  sensitive?: InputMaybe<Scalars['Boolean']>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  required?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  defaultValue?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateCompanySystemFieldMutation = { __typename?: 'Mutation', createCompanySystemField?: { __typename?: 'CreateCompanySystemFieldPayload', systemField?: { __typename?: 'SystemField', id: string, name: string, companySystemField?: { __typename?: 'CompanySystemField', id: string, sensitive: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, required: boolean, defaultValue?: string | null } | null } | null } | null };

export type UpdateCompanySystemFieldMutationVariables = Exact<{
  id: Scalars['UUID'];
  sensitive?: InputMaybe<Scalars['Boolean']>;
  changesMustBeApproved?: InputMaybe<Scalars['Boolean']>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  supportsFutureData?: InputMaybe<Scalars['Boolean']>;
  required?: InputMaybe<Scalars['Boolean']>;
  uniqueValue?: InputMaybe<Scalars['Boolean']>;
  defaultValue?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  fieldGroupId?: InputMaybe<Scalars['UUID']>;
  fieldGroupCardColumnId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  companySystemFieldOptions?: InputMaybe<CompanySystemFieldOptionCompanySystemFieldIdForeignInverseInput>;
  alias?: InputMaybe<Scalars['String']>;
  aliasLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  helpText?: InputMaybe<Scalars['String']>;
  helpTextLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  excludedRoleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type UpdateCompanySystemFieldMutation = { __typename?: 'Mutation', updateCompanySystemFieldById?: { __typename?: 'UpdateCompanySystemFieldPayload', systemField?: { __typename?: 'SystemField', id: string, name: string, companySystemField?: { __typename?: 'CompanySystemField', id: string, sensitive: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, required: boolean, defaultValue?: string | null, fieldGroupId?: string | null, alias?: string | null, localizedAlias?: string | null, helpText?: string | null, localizedHelpText?: string | null, excludedRoleIds?: Array<string | null> | null } | null } | null } | null };

export type CreateTaskTemplateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
  processId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  duration?: InputMaybe<Scalars['Int']>;
  startDay?: InputMaybe<Scalars['Int']>;
  deadlineReminder?: InputMaybe<Scalars['Int']>;
  useCalendarEvent?: InputMaybe<Scalars['Boolean']>;
  calendarEventFrom?: InputMaybe<Scalars['Time']>;
  calendarEventTo?: InputMaybe<Scalars['Time']>;
  calendarEventOrganizerId?: InputMaybe<Scalars['UUID']>;
  notes?: InputMaybe<Scalars['String']>;
  includeEmployee?: InputMaybe<Scalars['Boolean']>;
  includeDirectManager?: InputMaybe<Scalars['Boolean']>;
  includeEmployeeResponsible?: InputMaybe<Scalars['Boolean']>;
  includeDirectManagerResponsible?: InputMaybe<Scalars['Boolean']>;
  includeCustomEmployeeFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  includeCustomEmployeeFieldsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  includeGroups?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  includeGroupsResponsibles?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  taskTemplateEmployees?: InputMaybe<TaskTemplateEmployeeTaskTemplateIdForeignInverseInput>;
  taskTemplateResponsibles?: InputMaybe<TaskTemplateResponsibleTaskTemplateIdForeignInverseInput>;
}>;


export type CreateTaskTemplateMutation = { __typename?: 'Mutation', createTaskTemplate?: { __typename?: 'CreateTaskTemplatePayload', taskTemplate?: { __typename?: 'TaskTemplate', id: string } | null } | null };

export type UpdateTaskTemplateByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  patch: TaskTemplatePatch;
}>;


export type UpdateTaskTemplateByIdMutation = { __typename?: 'Mutation', updateTaskTemplateById?: { __typename?: 'UpdateTaskTemplatePayload', clientMutationId?: string | null } | null };

export type CreateTaskMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
  processId?: InputMaybe<Scalars['UUID']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  startDate: Scalars['Datetime'];
  endDate: Scalars['Datetime'];
  deadlineReminderDate?: InputMaybe<Scalars['Datetime']>;
  taskEmployees?: InputMaybe<TaskEmployeeTaskIdForeignInverseInput>;
  taskResponsibles?: InputMaybe<TaskResponsibleTaskIdForeignInverseInput>;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask?: { __typename?: 'CreateTaskPayload', task?: { __typename?: 'Task', id: string, processId?: string | null } | null } | null };

export type UpdateTaskByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  patch: TaskPatch;
}>;


export type UpdateTaskByIdMutation = { __typename?: 'Mutation', updateTaskById?: { __typename?: 'UpdateTaskPayload', task?: { __typename?: 'Task', id: string, name: string, order?: number | null, startDate: Date | string, endDate: Date | string, deadlineReminderDate?: Date | string | null, notes?: string | null, projectId?: string | null, processId?: string | null, parentTaskId?: string | null, completed: boolean, archived: boolean, calendarEventFrom?: Date | string | null, calendarEventTo?: Date | string | null, calendarEventOrganizerId?: string | null, departments?: Array<string | null> | null, userIds?: Array<string | null> | null, parentTask?: { __typename?: 'Task', id: string, name: string, projectId?: string | null, processId?: string | null, startDate: Date | string, endDate: Date | string } | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean, processTypeId?: string | null } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskResponsibles: { __typename?: 'TaskResponsiblesConnection', nodes: Array<{ __typename?: 'TaskResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskEmployees: { __typename?: 'TaskEmployeesConnection', nodes: Array<{ __typename?: 'TaskEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null } | null };

export type CompleteTaskMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CompleteTaskMutation = { __typename?: 'Mutation', completeTask?: { __typename?: 'CompleteTaskPayload', task?: { __typename?: 'Task', id: string, name: string, order?: number | null, startDate: Date | string, endDate: Date | string, deadlineReminderDate?: Date | string | null, notes?: string | null, projectId?: string | null, processId?: string | null, parentTaskId?: string | null, completed: boolean, archived: boolean, calendarEventFrom?: Date | string | null, calendarEventTo?: Date | string | null, calendarEventOrganizerId?: string | null, departments?: Array<string | null> | null, userIds?: Array<string | null> | null, parentTask?: { __typename?: 'Task', id: string, name: string, projectId?: string | null, processId?: string | null, startDate: Date | string, endDate: Date | string } | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean, processTypeId?: string | null } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskResponsibles: { __typename?: 'TaskResponsiblesConnection', nodes: Array<{ __typename?: 'TaskResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskEmployees: { __typename?: 'TaskEmployeesConnection', nodes: Array<{ __typename?: 'TaskEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null } | null };

export type DeleteTaskEmployeeMutationVariables = Exact<{
  taskId: Scalars['UUID'];
  employeeId: Scalars['UUID'];
}>;


export type DeleteTaskEmployeeMutation = { __typename?: 'Mutation', deleteTaskEmployeeByTaskIdAndEmployeeId?: { __typename?: 'DeleteTaskEmployeePayload', clientMutationId?: string | null } | null };

export type DeleteTaskTemplateEmployeeMutationVariables = Exact<{
  taskId: Scalars['UUID'];
  employeeId: Scalars['UUID'];
}>;


export type DeleteTaskTemplateEmployeeMutation = { __typename?: 'Mutation', deleteTaskTemplateEmployeeByTaskTemplateIdAndEmployeeId?: { __typename?: 'DeleteTaskTemplateEmployeePayload', clientMutationId?: string | null } | null };

export type DeleteTaskResponsibleMutationVariables = Exact<{
  taskId: Scalars['UUID'];
  responsibleId: Scalars['UUID'];
}>;


export type DeleteTaskResponsibleMutation = { __typename?: 'Mutation', deleteTaskResponsibleByTaskIdAndResponsibleId?: { __typename?: 'DeleteTaskResponsiblePayload', clientMutationId?: string | null } | null };

export type DeleteTaskTemplateResponsibleMutationVariables = Exact<{
  taskId: Scalars['UUID'];
  responsibleId: Scalars['UUID'];
}>;


export type DeleteTaskTemplateResponsibleMutation = { __typename?: 'Mutation', deleteTaskTemplateResponsibleByTaskTemplateIdAndResponsibleId?: { __typename?: 'DeleteTaskTemplateResponsiblePayload', clientMutationId?: string | null } | null };

export type ClockInDashboardMutationVariables = Exact<{
  presenceTypeId: Scalars['UUID'];
  projectId?: InputMaybe<Scalars['UUID']>;
}>;


export type ClockInDashboardMutation = { __typename?: 'Mutation', clockIn?: { __typename?: 'TimeRegistrationPresence', id: string, startDate: Date | string } | null };

export type ClockOutDashboardMutationVariables = Exact<{ [key: string]: never; }>;


export type ClockOutDashboardMutation = { __typename?: 'Mutation', clockOut?: { __typename?: 'TimeRegistrationPresence', id: string, startDate: Date | string, endDate?: Date | string | null, timeRegistrationPresenceType?: { __typename?: 'TimeRegistrationPresenceType', id: string, localizedName?: string | null, emoji: string } | null, timeRegistrationEntries: { __typename?: 'TimeRegistrationEntriesConnection', nodes: Array<{ __typename?: 'TimeRegistrationEntry', id: string, startDate: Date | string, endDate?: Date | string | null, timeRegistrationProject?: { __typename?: 'TimeRegistrationProject', id: string, localizedName?: string | null, color: string } | null, timeRegistrationBreakType?: { __typename?: 'TimeRegistrationBreakType', id: string, localizedName?: string | null, emoji: string } | null } | null> } } | null };

export type StartBreakMutationVariables = Exact<{
  breakTypeId: Scalars['UUID'];
}>;


export type StartBreakMutation = { __typename?: 'Mutation', startBreak?: { __typename?: 'TimeRegistrationPresence', id: string } | null };

export type EndBreakMutationVariables = Exact<{
  resumeTimeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
}>;


export type EndBreakMutation = { __typename?: 'Mutation', endBreak?: { __typename?: 'TimeRegistrationPresence', id: string } | null };

export type ChangeTimeRegistrationProjectMutationVariables = Exact<{
  projectId?: InputMaybe<Scalars['UUID']>;
}>;


export type ChangeTimeRegistrationProjectMutation = { __typename?: 'Mutation', changeTimeRegistrationProject?: { __typename?: 'TimeRegistrationPresence', id: string } | null };

export type ChangeTimeRegistrationPresenceMutationVariables = Exact<{
  presenceTypeId: Scalars['UUID'];
}>;


export type ChangeTimeRegistrationPresenceMutation = { __typename?: 'Mutation', changeTimeRegistrationPresence?: { __typename?: 'TimeRegistrationPresence', id: string } | null };

export type AddTimeRegistrationPresenceNoteMutationVariables = Exact<{
  presenceId: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
}>;


export type AddTimeRegistrationPresenceNoteMutation = { __typename?: 'Mutation', updateTimeRegistrationPresenceById?: { __typename?: 'UpdateTimeRegistrationPresencePayload', timeRegistrationPresence?: { __typename?: 'TimeRegistrationPresence', id: string } | null } | null };

export type TimeRegistrationBreakTypeDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TimeRegistrationBreakTypeDeleteMutation = { __typename?: 'Mutation', updateTimeRegistrationBreakTypeById?: { __typename?: 'UpdateTimeRegistrationBreakTypePayload', timeRegistrationBreakType?: { __typename?: 'TimeRegistrationBreakType', id: string } | null } | null };

export type TimeRegistrationBreakTypeCreateMutationVariables = Exact<{
  name: Scalars['String'];
  emoji: Scalars['String'];
  paidTime?: InputMaybe<IntervalInput>;
  code?: InputMaybe<Scalars['String']>;
  companyId: Scalars['UUID'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
}>;


export type TimeRegistrationBreakTypeCreateMutation = { __typename?: 'Mutation', createTimeRegistrationBreakType?: { __typename?: 'CreateTimeRegistrationBreakTypePayload', timeRegistrationBreakType?: { __typename?: 'TimeRegistrationBreakType', id: string, name?: string | null, localizedName?: string | null } | null } | null };

export type TimeRegistrationBreakTypeUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  emoji?: InputMaybe<Scalars['String']>;
  paidTime?: InputMaybe<IntervalInput>;
  code?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
}>;


export type TimeRegistrationBreakTypeUpdateMutation = { __typename?: 'Mutation', updateTimeRegistrationBreakTypeById?: { __typename?: 'UpdateTimeRegistrationBreakTypePayload', timeRegistrationBreakType?: { __typename?: 'TimeRegistrationBreakType', id: string, name?: string | null, localizedName?: string | null } | null } | null };

export type CreateTimeRegistrationEntryMutationVariables = Exact<{
  timeRegistrationEntryType: TimeRegistrationEntryType;
  startDate: Scalars['Datetime'];
  endDate: Scalars['Datetime'];
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationPresenceId: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
}>;


export type CreateTimeRegistrationEntryMutation = { __typename?: 'Mutation', createTimeRegistrationEntry?: { __typename?: 'CreateTimeRegistrationEntryPayload', timeRegistrationEntry?: { __typename?: 'TimeRegistrationEntry', id: string, startDate: Date | string, endDate?: Date | string | null, timeRegistrationPresenceId: string } | null } | null };

export type UpdateTimeRegistrationEntryMutationVariables = Exact<{
  id: Scalars['UUID'];
  startDate?: InputMaybe<Scalars['Datetime']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  timeRegistrationBreakTypeId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationProjectId?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTimeRegistrationEntryMutation = { __typename?: 'Mutation', updateTimeRegistrationEntryById?: { __typename?: 'UpdateTimeRegistrationEntryPayload', timeRegistrationEntry?: { __typename?: 'TimeRegistrationEntry', id: string, startDate: Date | string, endDate?: Date | string | null } | null } | null };

export type DeleteTimeRegistrationEntryMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteTimeRegistrationEntryMutation = { __typename?: 'Mutation', updateTimeRegistrationEntryById?: { __typename?: 'UpdateTimeRegistrationEntryPayload', timeRegistrationEntry?: { __typename?: 'TimeRegistrationEntry', id: string, active: boolean } | null } | null };

export type CreateTimeRegistrationPresenceMutationVariables = Exact<{
  timeRegistrationPresenceTypeId: Scalars['UUID'];
  startDate: Scalars['Datetime'];
  endDate: Scalars['Datetime'];
  note?: InputMaybe<Scalars['String']>;
}>;


export type CreateTimeRegistrationPresenceMutation = { __typename?: 'Mutation', createTimeRegistrationPresence?: { __typename?: 'CreateTimeRegistrationPresencePayload', timeRegistrationPresence?: { __typename?: 'TimeRegistrationPresence', id: string, startDate: Date | string, endDate?: Date | string | null, timeRegistrationPresenceType?: { __typename?: 'TimeRegistrationPresenceType', id: string, localizedName?: string | null, emoji: string } | null, timeRegistrationEntries: { __typename?: 'TimeRegistrationEntriesConnection', nodes: Array<{ __typename?: 'TimeRegistrationEntry', id: string, startDate: Date | string, endDate?: Date | string | null, timeRegistrationEntryType: TimeRegistrationEntryType, timeRegistrationProject?: { __typename?: 'TimeRegistrationProject', id: string, localizedName?: string | null, color: string } | null, timeRegistrationBreakType?: { __typename?: 'TimeRegistrationBreakType', id: string, localizedName?: string | null } | null } | null> } } | null } | null };

export type UpdateTimeRegistrationPresenceMutationVariables = Exact<{
  id: Scalars['UUID'];
  timeRegistrationPresenceTypeId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Datetime']>;
  endDate?: InputMaybe<Scalars['Datetime']>;
  note?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTimeRegistrationPresenceMutation = { __typename?: 'Mutation', updateTimeRegistrationPresenceById?: { __typename?: 'UpdateTimeRegistrationPresencePayload', timeRegistrationPresence?: { __typename?: 'TimeRegistrationPresence', id: string, startDate: Date | string, endDate?: Date | string | null, timeRegistrationPresenceType?: { __typename?: 'TimeRegistrationPresenceType', id: string, localizedName?: string | null, emoji: string } | null, timeRegistrationEntries: { __typename?: 'TimeRegistrationEntriesConnection', nodes: Array<{ __typename?: 'TimeRegistrationEntry', id: string, startDate: Date | string, endDate?: Date | string | null, timeRegistrationEntryType: TimeRegistrationEntryType, timeRegistrationProject?: { __typename?: 'TimeRegistrationProject', id: string, localizedName?: string | null, color: string } | null, timeRegistrationBreakType?: { __typename?: 'TimeRegistrationBreakType', id: string, localizedName?: string | null } | null } | null> } } | null } | null };

export type DeleteTimeRegistrationPresenceMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteTimeRegistrationPresenceMutation = { __typename?: 'Mutation', updateTimeRegistrationPresenceById?: { __typename?: 'UpdateTimeRegistrationPresencePayload', timeRegistrationPresence?: { __typename?: 'TimeRegistrationPresence', id: string, active: boolean } | null } | null };

export type ApproveTimeRegistrationsByDeadlineMutationVariables = Exact<{
  deadline: Scalars['Datetime'];
}>;


export type ApproveTimeRegistrationsByDeadlineMutation = { __typename?: 'Mutation', approveTimeRegistrationsByDeadline?: { __typename?: 'ApproveTimeRegistrationsByDeadlinePayload', clientMutationId?: string | null } | null };

export type TimeRegistrationPresenceTypeDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TimeRegistrationPresenceTypeDeleteMutation = { __typename?: 'Mutation', updateTimeRegistrationPresenceTypeById?: { __typename?: 'UpdateTimeRegistrationPresenceTypePayload', timeRegistrationPresenceType?: { __typename?: 'TimeRegistrationPresenceType', id: string } | null } | null };

export type TimeRegistrationPresenceTypeCreateMutationVariables = Exact<{
  name: Scalars['String'];
  emoji: Scalars['String'];
  companyId: Scalars['UUID'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  code?: InputMaybe<Scalars['String']>;
}>;


export type TimeRegistrationPresenceTypeCreateMutation = { __typename?: 'Mutation', createTimeRegistrationPresenceType?: { __typename?: 'CreateTimeRegistrationPresenceTypePayload', timeRegistrationPresenceType?: { __typename?: 'TimeRegistrationPresenceType', id: string, name?: string | null, localizedName?: string | null } | null } | null };

export type TimeRegistrationPresenceTypeUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  emoji: Scalars['String'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  code?: InputMaybe<Scalars['String']>;
}>;


export type TimeRegistrationPresenceTypeUpdateMutation = { __typename?: 'Mutation', updateTimeRegistrationPresenceTypeById?: { __typename?: 'UpdateTimeRegistrationPresenceTypePayload', timeRegistrationPresenceType?: { __typename?: 'TimeRegistrationPresenceType', id: string, name?: string | null, localizedName?: string | null } | null } | null };

export type TimeRegistrationProjectDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TimeRegistrationProjectDeleteMutation = { __typename?: 'Mutation', updateTimeRegistrationProjectById?: { __typename?: 'UpdateTimeRegistrationProjectPayload', timeRegistrationProject?: { __typename?: 'TimeRegistrationProject', id: string } | null } | null };

export type TimeRegistrationProjectCreateMutationVariables = Exact<{
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  color: Scalars['String'];
  companyId: Scalars['UUID'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  descriptionLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
}>;


export type TimeRegistrationProjectCreateMutation = { __typename?: 'Mutation', createTimeRegistrationProject?: { __typename?: 'CreateTimeRegistrationProjectPayload', timeRegistrationProject?: { __typename?: 'TimeRegistrationProject', id: string, name?: string | null, localizedName?: string | null, description?: string | null, localizedDescription?: string | null } | null } | null };

export type TimeRegistrationProjectUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  descriptionLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
}>;


export type TimeRegistrationProjectUpdateMutation = { __typename?: 'Mutation', updateTimeRegistrationProjectById?: { __typename?: 'UpdateTimeRegistrationProjectPayload', timeRegistrationProject?: { __typename?: 'TimeRegistrationProject', id: string, name?: string | null, localizedName?: string | null, description?: string | null, localizedDescription?: string | null } | null } | null };

export type TimeRegistrationTemplateDeleteMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TimeRegistrationTemplateDeleteMutation = { __typename?: 'Mutation', updateTimeRegistrationTemplateById?: { __typename?: 'UpdateTimeRegistrationTemplatePayload', timeRegistrationTemplate?: { __typename?: 'TimeRegistrationTemplate', id: string } | null } | null };

export type TimeRegistrationTemplateCreateMutationVariables = Exact<{
  name: Scalars['String'];
  companyId: Scalars['UUID'];
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
}>;


export type TimeRegistrationTemplateCreateMutation = { __typename?: 'Mutation', createTimeRegistrationTemplate?: { __typename?: 'CreateTimeRegistrationTemplatePayload', timeRegistrationTemplate?: { __typename?: 'TimeRegistrationTemplate', id: string, name?: string | null, localizedName?: string | null } | null } | null };

export type TimeRegistrationTemplateUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  nameLocalizations?: InputMaybe<Array<LocaleWithTranslation> | LocaleWithTranslation>;
  useMultiWeek?: InputMaybe<Scalars['Boolean']>;
}>;


export type TimeRegistrationTemplateUpdateMutation = { __typename?: 'Mutation', updateTimeRegistrationTemplateById?: { __typename?: 'UpdateTimeRegistrationTemplatePayload', timeRegistrationTemplate?: { __typename?: 'TimeRegistrationTemplate', id: string, name?: string | null, localizedName?: string | null } | null } | null };

export type SubmitTimeRegistrationTemplateMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  timeRegistrationTemplateId?: InputMaybe<Scalars['UUID']>;
  weeks?: InputMaybe<Array<TimeRegistrationWeekTemplateInput> | TimeRegistrationWeekTemplateInput>;
  days?: InputMaybe<Array<TimeRegistrationDayTemplateInput> | TimeRegistrationDayTemplateInput>;
}>;


export type SubmitTimeRegistrationTemplateMutation = { __typename?: 'Mutation', submitTimeRegistrationTemplate?: { __typename?: 'TimeRegistrationPresenceTemplate', id: string } | null };

export type BulkApplyTimeRegistrationTemplateMutationVariables = Exact<{
  timeRegistrationTemplateId: Scalars['UUID'];
  employeeIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type BulkApplyTimeRegistrationTemplateMutation = { __typename?: 'Mutation', bulkApplyTimeRegistrationTemplate?: { __typename?: 'TimeRegistrationTemplate', id: string } | null };

export type TranslationCreateMutationVariables = Exact<{
  translation: TranslationInput;
}>;


export type TranslationCreateMutation = { __typename?: 'Mutation', createTranslation?: { __typename?: 'CreateTranslationPayload', clientMutationId?: string | null } | null };

export type TranslationUpdateByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  translation: TranslationPatch;
}>;


export type TranslationUpdateByIdMutation = { __typename?: 'Mutation', updateTranslationById?: { __typename?: 'UpdateTranslationPayload', clientMutationId?: string | null } | null };

export type TranslationDeleteByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TranslationDeleteByIdMutation = { __typename?: 'Mutation', deleteTranslationById?: { __typename?: 'DeleteTranslationPayload', clientMutationId?: string | null } | null };

export type ClearTranslationsCacheMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearTranslationsCacheMutation = { __typename?: 'Mutation', clearTranslationsCache?: boolean | null };

export type UpdateCredentialMutationVariables = Exact<{
  newPassword: Scalars['String'];
  companyId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpdateCredentialMutation = { __typename?: 'Mutation', updateCredential?: { __typename?: 'UpdateCredentialPayload', clientMutationId?: string | null } | null };

export type UserUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
  companyId?: InputMaybe<Scalars['UUID']>;
  emailPassword?: InputMaybe<Scalars['Boolean']>;
  companyAdmin?: InputMaybe<Scalars['Boolean']>;
  isSystemUser?: InputMaybe<Scalars['Boolean']>;
  canSignOnBehalfOf?: InputMaybe<Scalars['Boolean']>;
  canLogin?: InputMaybe<Scalars['Boolean']>;
  canLoginApp?: InputMaybe<Scalars['Boolean']>;
  canLoginSso?: InputMaybe<Scalars['Boolean']>;
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', updateUserById?: { __typename?: 'UpdateUserPayload', clientMutationId?: string | null } | null };

export type CreateSuperUserMutationVariables = Exact<{
  userId: Scalars['UUID'];
  companyWhitelist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  companyBlacklist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  createSuperUserAllowedUsers?: InputMaybe<Array<SuperUserAllowedUsersSuperUserIdForeignConnectionSuperUserAllowedUsersCreateInput> | SuperUserAllowedUsersSuperUserIdForeignConnectionSuperUserAllowedUsersCreateInput>;
}>;


export type CreateSuperUserMutation = { __typename?: 'Mutation', createSuperUser?: { __typename?: 'CreateSuperUserPayload', superUser?: { __typename?: 'SuperUser', id: string } | null } | null };

export type UpdateSuperUserByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
  companyWhitelist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  companyBlacklist?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type UpdateSuperUserByIdMutation = { __typename?: 'Mutation', updateSuperUserById?: { __typename?: 'UpdateSuperUserPayload', clientMutationId?: string | null } | null };

export type DeleteSuperUserByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteSuperUserByIdMutation = { __typename?: 'Mutation', deleteSuperUserById?: { __typename?: 'DeleteSuperUserPayload', clientMutationId?: string | null } | null };

export type UpdateUserLocaleMutationVariables = Exact<{
  locale: Scalars['String'];
}>;


export type UpdateUserLocaleMutation = { __typename?: 'Mutation', updateUserLocale?: { __typename?: 'UpdateUserLocalePayload', clientMutationId?: string | null } | null };

export type SetUserSettingMutationVariables = Exact<{
  key: Scalars['String'];
  value: Scalars['JSON'];
}>;


export type SetUserSettingMutation = { __typename?: 'Mutation', setUserSetting?: { __typename?: 'SetUserSettingPayload', userSetting?: { __typename?: 'UserSetting', value: any, userId: string, id: UserSettingKey } | null } | null };

export type ChangeGodModeStatusMutationVariables = Exact<{
  userId: Scalars['UUID'];
  enable: Scalars['Boolean'];
}>;


export type ChangeGodModeStatusMutation = { __typename?: 'Mutation', changeGodModeStatus?: { __typename?: 'ChangeGodModeStatusPayload', user?: { __typename?: 'User', id: string, godmode: boolean } | null } | null };

export type CreateSuperUserAllowedUsersMutationVariables = Exact<{
  superUserId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  allowedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  disallowedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type CreateSuperUserAllowedUsersMutation = { __typename?: 'Mutation', createSuperUserAllowedUser?: { __typename?: 'CreateSuperUserAllowedUserPayload', superUserAllowedUser?: { __typename?: 'SuperUserAllowedUser', id: string, companyId: string, allowedUserIds?: Array<string | null> | null, disallowedUserIds?: Array<string | null> | null } | null } | null };

export type UpdateSuperUserAllowedUsersMutationVariables = Exact<{
  superUserId: Scalars['UUID'];
  companyId: Scalars['UUID'];
  allowedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  disallowedUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type UpdateSuperUserAllowedUsersMutation = { __typename?: 'Mutation', updateSuperUserAllowedUserBySuperUserIdAndCompanyId?: { __typename?: 'UpdateSuperUserAllowedUserPayload', superUserAllowedUser?: { __typename?: 'SuperUserAllowedUser', id: string, companyId: string, allowedUserIds?: Array<string | null> | null, disallowedUserIds?: Array<string | null> | null } | null } | null };

export type SetUserDepartmentParentUserMutationVariables = Exact<{
  id: Scalars['UUID'];
  parentUserDepartmentId?: InputMaybe<Scalars['UUID']>;
}>;


export type SetUserDepartmentParentUserMutation = { __typename?: 'Mutation', updateUserDepartmentById?: { __typename?: 'UpdateUserDepartmentPayload', userDepartment?: { __typename?: 'UserDepartment', id: string, userId: string, departmentId: string, parentUserDepartmentId?: string | null } | null } | null };

export type UserGroupCreateMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  groupId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
}>;


export type UserGroupCreateMutation = { __typename?: 'Mutation', createUserGroup?: { __typename?: 'CreateUserGroupPayload', clientMutationId?: string | null } | null };

export type UserGroupDeleteMutationVariables = Exact<{
  userId: Scalars['UUID'];
  groupId: Scalars['UUID'];
}>;


export type UserGroupDeleteMutation = { __typename?: 'Mutation', deleteUserGroupByUserIdAndGroupId?: { __typename?: 'DeleteUserGroupPayload', clientMutationId?: string | null } | null };

export type UserDepartmentGroupCreateMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  departmentId?: InputMaybe<Scalars['UUID']>;
  groupId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
}>;


export type UserDepartmentGroupCreateMutation = { __typename?: 'Mutation', createUserDepartmentGroup?: { __typename?: 'CreateUserDepartmentGroupPayload', clientMutationId?: string | null } | null };

export type UserDepartmentGroupDeleteMutationVariables = Exact<{
  userId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  groupId: Scalars['UUID'];
}>;


export type UserDepartmentGroupDeleteMutation = { __typename?: 'Mutation', deleteUserDepartmentGroupByUserIdAndDepartmentIdAndGroupId?: { __typename?: 'DeleteUserDepartmentGroupPayload', clientMutationId?: string | null } | null };

export type UserDepartmentGroupToggleInheritanceMutationVariables = Exact<{
  userId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  inheritToDescendants?: InputMaybe<Scalars['Boolean']>;
  onlyIncludeInDescendants?: InputMaybe<Scalars['Boolean']>;
}>;


export type UserDepartmentGroupToggleInheritanceMutation = { __typename?: 'Mutation', updateUserDepartmentGroupByUserIdAndDepartmentIdAndGroupId?: { __typename?: 'UpdateUserDepartmentGroupPayload', clientMutationId?: string | null } | null };

export type UserCompanyGroupCreateMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  groupId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
}>;


export type UserCompanyGroupCreateMutation = { __typename?: 'Mutation', createUserCompanyGroup?: { __typename?: 'CreateUserCompanyGroupPayload', clientMutationId?: string | null } | null };

export type UserCompanyGroupDeleteMutationVariables = Exact<{
  userId: Scalars['UUID'];
  groupId: Scalars['UUID'];
  companyId: Scalars['UUID'];
}>;


export type UserCompanyGroupDeleteMutation = { __typename?: 'Mutation', deleteUserCompanyGroupByUserIdAndGroupIdAndCompanyId?: { __typename?: 'DeleteUserCompanyGroupPayload', clientMutationId?: string | null } | null };

export type CreateUserOnBehalfPermissionMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  onBehalfOfUserId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateUserOnBehalfPermissionMutation = { __typename?: 'Mutation', createUserOnBehalfPermission?: { __typename?: 'CreateUserOnBehalfPermissionPayload', userOnBehalfPermission?: { __typename?: 'UserOnBehalfPermission', id: string, userId: string, onBehalfOfUserId: string, companyId: string, user?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null, jobPositionTitle?: string | null } | null, onBehalfOfUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null, jobPositionTitle?: string | null } | null } | null } | null };

export type DeleteUserOnBehalfPermissionMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteUserOnBehalfPermissionMutation = { __typename?: 'Mutation', deleteUserOnBehalfPermissionById?: { __typename?: 'DeleteUserOnBehalfPermissionPayload', userOnBehalfPermission?: { __typename?: 'UserOnBehalfPermission', id: string, userId: string, onBehalfOfUserId: string, companyId: string, user?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null, jobPositionTitle?: string | null } | null, onBehalfOfUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null, jobPositionTitle?: string | null } | null } | null } | null };

export type CreateVacationTypeMutationVariables = Exact<{
  name: Scalars['String'];
  color: Scalars['String'];
  companyId?: InputMaybe<Scalars['UUID']>;
  absenceCode?: InputMaybe<Scalars['String']>;
  quickAction?: InputMaybe<Scalars['Boolean']>;
  emoji?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  mustBeApproved?: InputMaybe<Scalars['Boolean']>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  sendCalendarInvite?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateVacationTypeMutation = { __typename?: 'Mutation', createVacationType?: { __typename?: 'CreateVacationTypePayload', vacationType?: { __typename?: 'VacationType', id: string, name: string, localizedName?: string | null, color: string, active: boolean, companyId: string, absenceCode?: string | null, quickAction: boolean, emoji?: string | null, description?: string | null, mustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, sendCalendarInvite: boolean } | null } | null };

export type UpdateVacationTypeMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
  color: Scalars['String'];
  absenceCode?: InputMaybe<Scalars['String']>;
  quickAction?: InputMaybe<Scalars['Boolean']>;
  emoji?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  mustBeApproved?: InputMaybe<Scalars['Boolean']>;
  approverUserIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  approverGroupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  approverSystemFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  approverFormFieldIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  sendCalendarInvite?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateVacationTypeMutation = { __typename?: 'Mutation', updateVacationTypeById?: { __typename?: 'UpdateVacationTypePayload', vacationType?: { __typename?: 'VacationType', id: string, name: string, localizedName?: string | null, color: string, active: boolean, companyId: string, absenceCode?: string | null, quickAction: boolean, emoji?: string | null, description?: string | null, mustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, sendCalendarInvite: boolean } | null } | null };

export type DeleteVacationTypeMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteVacationTypeMutation = { __typename?: 'Mutation', updateVacationTypeById?: { __typename?: 'UpdateVacationTypePayload', vacationType?: { __typename?: 'VacationType', id: string, name: string, localizedName?: string | null, color: string, active: boolean, companyId: string, absenceCode?: string | null, quickAction: boolean, emoji?: string | null, description?: string | null, mustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, sendCalendarInvite: boolean } | null } | null };

export type CreateVacationUserMutationVariables = Exact<{
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  allDay?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['Datetime'];
  endDate: Scalars['Datetime'];
  note?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
}>;


export type CreateVacationUserMutation = { __typename?: 'Mutation', createVacationUser?: { __typename?: 'CreateVacationUserPayload', vacationUser?: { __typename?: 'VacationUser', id: string, vacationTypeId: string, allDay: boolean, startDate: Date | string, endDate: Date | string, durationDays?: string | number | null, note?: string | null, active: boolean, userId: string, departmentIds?: Array<string | null> | null, companyId: string, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, approvalId?: string | null, vacationType?: { __typename?: 'VacationType', id: string, name: string, localizedName?: string | null, color: string, active: boolean, companyId: string, absenceCode?: string | null, quickAction: boolean, emoji?: string | null, description?: string | null, mustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, sendCalendarInvite: boolean } | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null, creatorUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null } | null };

export type UpdateVacationUserMutationVariables = Exact<{
  id: Scalars['UUID'];
  vacationTypeId?: InputMaybe<Scalars['UUID']>;
  allDay?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['Datetime'];
  endDate: Scalars['Datetime'];
  note?: InputMaybe<Scalars['String']>;
}>;


export type UpdateVacationUserMutation = { __typename?: 'Mutation', updateVacationUserById?: { __typename?: 'UpdateVacationUserPayload', vacationUser?: { __typename?: 'VacationUser', id: string, vacationTypeId: string, allDay: boolean, startDate: Date | string, endDate: Date | string, durationDays?: string | number | null, note?: string | null, active: boolean, userId: string, departmentIds?: Array<string | null> | null, companyId: string, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, approvalId?: string | null, vacationType?: { __typename?: 'VacationType', id: string, name: string, localizedName?: string | null, color: string, active: boolean, companyId: string, absenceCode?: string | null, quickAction: boolean, emoji?: string | null, description?: string | null, mustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, sendCalendarInvite: boolean } | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null, creatorUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null } | null };

export type DeleteVacationUserMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteVacationUserMutation = { __typename?: 'Mutation', updateVacationUserById?: { __typename?: 'UpdateVacationUserPayload', vacationUser?: { __typename?: 'VacationUser', id: string, vacationTypeId: string, allDay: boolean, startDate: Date | string, endDate: Date | string, durationDays?: string | number | null, note?: string | null, active: boolean, userId: string, departmentIds?: Array<string | null> | null, companyId: string, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, approvalId?: string | null, vacationType?: { __typename?: 'VacationType', id: string, name: string, localizedName?: string | null, color: string, active: boolean, companyId: string, absenceCode?: string | null, quickAction: boolean, emoji?: string | null, description?: string | null, mustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, sendCalendarInvite: boolean } | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null, creatorUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null } | null };

export type GetAllAnnouncementsQueryVariables = Exact<{
  filter?: InputMaybe<AnnouncementFilter>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
}>;


export type GetAllAnnouncementsQuery = { __typename?: 'Query', announcements?: { __typename?: 'AnnouncementsConnection', totalCount: number, edges: Array<{ __typename?: 'AnnouncementsEdge', node?: { __typename?: 'Announcement', read?: boolean | null, id: string, userId?: string | null, companyId: string, departmentIds: Array<string | null>, systemAnnouncement: boolean, title: string, teaser?: string | null, content?: string | null, url?: string | null, addPlayIcon: boolean, popup: boolean, locales: Array<string | null>, published: boolean, active: boolean, publishAt?: Date | string | null, expireAt?: Date | string | null, createdAt: Date | string, updatedAt: Date | string } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type GetAnnouncementsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<AnnouncementsOrderBy> | AnnouncementsOrderBy>;
  filter?: InputMaybe<AnnouncementFilter>;
}>;


export type GetAnnouncementsQuery = { __typename?: 'Query', announcements?: { __typename?: 'AnnouncementsConnection', totalCount: number, edges: Array<{ __typename?: 'AnnouncementsEdge', node?: { __typename?: 'Announcement', id: string, userId?: string | null, companyId: string, departmentIds: Array<string | null>, systemAnnouncement: boolean, title: string, teaser?: string | null, content?: string | null, url?: string | null, addPlayIcon: boolean, popup: boolean, locales: Array<string | null>, published: boolean, active: boolean, publishAt?: Date | string | null, expireAt?: Date | string | null, createdAt: Date | string, updatedAt: Date | string } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type GetAnnouncementDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnnouncementDepartmentsQuery = { __typename?: 'Query', departments?: { __typename?: 'DepartmentsConnection', edges: Array<{ __typename?: 'DepartmentsEdge', node?: { __typename?: 'Department', id: string, name: string, companyId?: string | null } | null }> } | null };

export type GetAnnouncementByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetAnnouncementByIdQuery = { __typename?: 'Query', announcementById?: { __typename?: 'Announcement', id: string, userId?: string | null, companyId: string, departmentIds: Array<string | null>, systemAnnouncement: boolean, title: string, teaser?: string | null, content?: string | null, url?: string | null, addPlayIcon: boolean, popup: boolean, locales: Array<string | null>, published: boolean, active: boolean, publishAt?: Date | string | null, expireAt?: Date | string | null, createdAt: Date | string, updatedAt: Date | string } | null };

export type AllAnnouncementsCheckboxQueryVariables = Exact<{
  filter?: InputMaybe<AnnouncementFilter>;
}>;


export type AllAnnouncementsCheckboxQuery = { __typename?: 'Query', announcements?: { __typename?: 'AnnouncementsConnection', edges: Array<{ __typename?: 'AnnouncementsEdge', node?: { __typename?: 'Announcement', id: string } | null }> } | null };

export type LatestPopupAnnouncementQueryVariables = Exact<{
  currentDate?: InputMaybe<Scalars['Datetime']>;
  locale: Scalars['String'];
}>;


export type LatestPopupAnnouncementQuery = { __typename?: 'Query', announcements?: { __typename?: 'AnnouncementsConnection', nodes: Array<{ __typename?: 'Announcement', id: string, title: string, content?: string | null, userAnnouncements: { __typename?: 'UserAnnouncementsConnection', nodes: Array<{ __typename?: 'UserAnnouncement', userId: string } | null> } } | null> } | null };

export type UnreadAnnouncementsCountQueryVariables = Exact<{
  filter?: InputMaybe<AnnouncementFilter>;
}>;


export type UnreadAnnouncementsCountQuery = { __typename?: 'Query', announcements?: { __typename?: 'AnnouncementsConnection', totalCount: number } | null };

export type ApplicationQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ApplicationQuery = { __typename?: 'Query', application?: { __typename?: 'ApplicationPayload', id: string, companyId: number, firstName: string, lastName: string, fullName: string, email: string, emailWork: string, mobilePrivate?: string | null, address?: string | null, city?: string | null, postalCode?: string | null, country?: string | null, profileImage?: string | null, jobPositionTitle?: string | null, jobPositionType?: Array<string> | null, caseFileIds?: Array<string | null> | null, mappedFields?: Array<{ __typename?: 'ApplicationFieldMapping', name?: string | null, label?: string | null, value?: string | null } | null> | null, customFieldValues?: Array<{ __typename?: 'CustomFieldValueType', value?: string | null, customField?: { __typename?: 'customFieldType', title?: string | null, type?: string | null } | null } | null> | null, files?: Array<{ __typename?: 'ApplicationFileType', id?: string | null, hashid?: string | null, name?: string | null, type?: string | null, cache?: string | null } | null> | null } | null };

export type ApplicationsQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type ApplicationsQueryQuery = { __typename?: 'Query', allApplications?: { __typename?: 'ApplicationConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'ApplicationEdge', node?: { __typename?: 'ApplicationPayload', id: string, companyId: number, firstName: string, lastName: string, fullName: string, email: string, mobilePrivate?: string | null, address?: string | null, city?: string | null, postalCode?: string | null, country?: string | null, profileImage?: string | null, jobPositionTitle?: string | null, customFieldValues?: Array<{ __typename?: 'CustomFieldValueType', value?: string | null, customField?: { __typename?: 'customFieldType', title?: string | null, type?: string | null } | null } | null> | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } | null } | null };

export type ApprovalsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<ApprovalFilter>;
  orderBy?: InputMaybe<Array<ApprovalsOrderBy> | ApprovalsOrderBy>;
  companyId?: InputMaybe<Scalars['UUID']>;
}>;


export type ApprovalsQuery = { __typename?: 'Query', approvals?: { __typename?: 'ApprovalsConnection', totalCount: number, edges: Array<{ __typename?: 'ApprovalsEdge', node?: { __typename?: 'Approval', id: string, approvedAt?: Date | string | null, deniedAt?: Date | string | null, isDeletionRequest: boolean, createdAt: Date | string, affectedUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null, requestingUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null, futureDatumByApprovalId?: { __typename?: 'FutureDatum', id: string, systemFieldId?: string | null, formFieldId?: string | null, formFieldEntryId?: string | null, userId: string, updateValueAt?: Date | string | null, createdAt: Date | string, value: any, previousHumanReadableValue?: string | null, humanReadableValue?: string | null, approvalIsRequired?: boolean | null, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, approvalId?: string | null, creatorUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null, formField?: { __typename?: 'FormField', id: string, localizedName?: string | null, sensitive?: boolean | null } | null, systemField?: { __typename?: 'SystemField', id: string, readableName?: string | null, localizedName?: string | null, companySystemField?: { __typename?: 'CompanySystemField', id: string, sensitive: boolean } | null } | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null, vacationUserByApprovalId?: { __typename?: 'VacationUser', id: string, vacationTypeId: string, allDay: boolean, startDate: Date | string, endDate: Date | string, durationDays?: string | number | null, note?: string | null, active: boolean, userId: string, departmentIds?: Array<string | null> | null, companyId: string, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, approvalId?: string | null, vacationType?: { __typename?: 'VacationType', id: string, name: string, localizedName?: string | null, color: string, active: boolean, companyId: string, absenceCode?: string | null, quickAction: boolean, emoji?: string | null, description?: string | null, mustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, sendCalendarInvite: boolean } | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null, creatorUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null, vacationUserByDeletionApprovalId?: { __typename?: 'VacationUser', id: string, vacationTypeId: string, allDay: boolean, startDate: Date | string, endDate: Date | string, durationDays?: string | number | null, note?: string | null, active: boolean, userId: string, departmentIds?: Array<string | null> | null, companyId: string, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, approvalId?: string | null, vacationType?: { __typename?: 'VacationType', id: string, name: string, localizedName?: string | null, color: string, active: boolean, companyId: string, absenceCode?: string | null, quickAction: boolean, emoji?: string | null, description?: string | null, mustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, sendCalendarInvite: boolean } | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null, creatorUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type AsyncJobsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  orderBy?: InputMaybe<Array<AsyncJobsOrderBy> | AsyncJobsOrderBy>;
}>;


export type AsyncJobsQuery = { __typename?: 'Query', asyncJobs?: { __typename?: 'AsyncJobsConnection', edges: Array<{ __typename?: 'AsyncJobsEdge', node?: { __typename?: 'AsyncJob', id: string, startDate: Date | string, completionDate?: Date | string | null, type: AsyncJobType, duration?: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null } | null } | null }> } | null };

export type AsyncJobByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AsyncJobByIdQuery = { __typename?: 'Query', asyncJobById?: { __typename?: 'AsyncJob', id: string, completionDate?: Date | string | null, asyncJobItems: { __typename?: 'AsyncJobItemsConnection', nodes: Array<{ __typename: 'AsyncJobItem', id: string, completionDate: Date | string, message?: string | null, messageVariables?: any | null, tabulation: number } | null> } } | null };

export type GetAuthAppQueryVariables = Exact<{
  appId: Scalars['UUID'];
}>;


export type GetAuthAppQuery = { __typename?: 'Query', getAuthApp?: { __typename?: 'getAuthAppPayload', response?: any | null } | null };

export type GetAuthAppsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthAppsQuery = { __typename?: 'Query', getAuthApps?: { __typename?: 'getAuthAppsPayload', response?: any | null } | null };

export type GetAuthAppsPaginatedQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  searchString?: InputMaybe<Scalars['String']>;
}>;


export type GetAuthAppsPaginatedQuery = { __typename?: 'Query', getAuthApps?: { __typename?: 'getAuthAppsPayload', response?: any | null } | null };

export type GetIntegrationFieldMarkingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIntegrationFieldMarkingsQuery = { __typename?: 'Query', integrationFieldMarkings?: { __typename?: 'IntegrationFieldMarkingsConnection', nodes: Array<{ __typename?: 'IntegrationFieldMarking', authAppId?: string | null, id: string, departmentIds?: Array<string | null> | null, storageId?: string | null, sendsData: boolean, receivesData: boolean, formField?: { __typename?: 'FormField', localizedName?: string | null, id: string } | null, systemField?: { __typename?: 'SystemField', id: string, readableName?: string | null } | null, storage?: { __typename?: 'Storage', url?: string | null } | null } | null> } | null };

export type ChangelogByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ChangelogByIdQuery = { __typename?: 'Query', changelogById?: { __typename?: 'Changelog', id: string, version: string, system: SystemType, releaseDate: Date | string, major?: string | null, minor?: string | null, guides?: string | null, published: boolean, locale: string, isAppNotes: boolean } | null };

export type AllChangeLogsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<ChangelogsOrderBy> | ChangelogsOrderBy>;
  filter?: InputMaybe<ChangelogFilter>;
  condition?: InputMaybe<ChangelogCondition>;
}>;


export type AllChangeLogsQuery = { __typename?: 'Query', changelogs?: { __typename?: 'ChangelogsConnection', totalCount: number, edges: Array<{ __typename?: 'ChangelogsEdge', node?: { __typename?: 'Changelog', id: string, version: string, system: SystemType, releaseDate: Date | string, major?: string | null, minor?: string | null, guides?: string | null, published: boolean, locale: string, isAppNotes: boolean } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type GetChosenColumnsQueryVariables = Exact<{
  userId: Scalars['UUID'];
  tableName: Scalars['String'];
  getFormFields: Scalars['Boolean'];
  formFieldObjectType?: InputMaybe<Scalars['String']>;
  fieldGroupCardColumnExists?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetChosenColumnsQuery = { __typename?: 'Query', chosenColumnByUserIdAndTableName?: { __typename?: 'ChosenColumn', userId: string, tableName: string, chosenColumns?: any | null, filters?: any | null, miscellaneousFilters?: any | null } | null, formFields?: { __typename?: 'FormFieldsConnection', edges: Array<{ __typename?: 'FormFieldsEdge', node?: { __typename?: 'FormField', id: string, fieldGroupId?: string | null, name: string, fieldType?: string | null, objectType: string, localizedName?: string | null, metadata?: any | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string } | null> } } | null }> } | null };

export type EmployeeListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']>;
  includesInsensitive?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  departmentsFilter?: InputMaybe<UuidListFilter>;
}>;


export type EmployeeListQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', edges: Array<{ __typename?: 'UsersEdge', node?: { __typename?: 'User', email?: string | null, fullName?: string | null, phone?: string | null, logo?: string | null, id: string } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type EmailLogQueryVariables = Exact<{
  receiverId: Scalars['String'];
  after?: InputMaybe<Scalars['String']>;
  searchSubject?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<CommunicationLogOrderBy>;
  status?: InputMaybe<CommunicationLogStatusType>;
}>;


export type EmailLogQuery = { __typename?: 'Query', communicationLogs?: { __typename?: 'CommunicationLogResponse', totalCount?: number | null, edges: Array<{ __typename?: 'CommunicationLogItemEdge', node?: { __typename?: 'CommunicationLogItem', id?: number | null, status?: CommunicationLogStatusType | null, emailSubject?: string | null, emailText?: string | null, emailTo?: Array<string | null> | null, emailCreatedAt?: Date | string | null, emailFrom?: string | null, emailHtml?: string | null, emailReplyTo?: string | null, emailCc?: Array<string | null> | null, emailBcc?: Array<string | null> | null, system?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean, startCursor?: unknown | null } } | null };

export type CompaniesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<CompaniesOrderBy> | CompaniesOrderBy>;
  filter?: InputMaybe<CompanyFilter>;
}>;


export type CompaniesQuery = { __typename?: 'Query', companies?: { __typename?: 'CompaniesConnection', totalCount: number, edges: Array<{ __typename?: 'CompaniesEdge', node?: { __typename?: 'Company', id: string, name?: string | null, nativeAppAccess?: boolean | null, numberOfCurrentlyEmployedEmployees?: string | number | null, users: { __typename?: 'CompanySuperadminUserListConnection', totalCount: number, edges: Array<{ __typename?: 'CompanySuperadminUserListEdge', node?: { __typename?: 'CompanySuperadminUserListRecord', id?: string | null, fullName?: string | null, lastLogin?: Date | string | null } | null }> } } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type CompaniesInputFieldQueryVariables = Exact<{
  selected?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  search?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['Cursor']>;
}>;


export type CompaniesInputFieldQuery = { __typename?: 'Query', allCompanies?: { __typename?: 'CompaniesConnection', totalCount: number, edges: Array<{ __typename?: 'CompaniesEdge', node?: { __typename?: 'Company', id: string, name?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null, selectedUsers?: { __typename?: 'CompaniesConnection', totalCount: number, edges: Array<{ __typename?: 'CompaniesEdge', node?: { __typename?: 'Company', id: string, name?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type GetCompanySsoQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetCompanySsoQuery = { __typename?: 'Query', getCompanyPublicSso?: string | null };

export type CompanyQueryVariables = Exact<{
  id: Scalars['UUID'];
  includeUsers: Scalars['Boolean'];
}>;


export type CompanyQuery = { __typename?: 'Query', companyById?: { __typename?: 'Company', id: string, name?: string | null, description?: string | null, locale?: string | null, cvr?: string | null, url?: string | null, logo?: string | null, sso?: string | null, copyInProgress: boolean, masterForCompanyId?: string | null, masterTemplate: boolean, availableLocales?: Array<string | null> | null, nativeAppAccess?: boolean | null, mainDepartment?: { __typename: 'Department', id: string, name: string, departmentNumber?: string | null, description?: string | null, mainDepartment: boolean, parentDepartmentId?: string | null, cvr?: string | null, alias?: string | null, pNumber?: number | null, ean?: string | null, address: string, postalCode: string, city: string, phone: string, email: string, departmentTypeId?: string | null, hasChildren?: boolean | null, parentDepartment?: { __typename?: 'Department', id: string, name: string } | null, departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null, companyCompanyTypes: { __typename?: 'CompanyCompanyTypesConnection', edges: Array<{ __typename?: 'CompanyCompanyTypesEdge', node?: { __typename?: 'CompanyCompanyType', companyType?: { __typename?: 'CompanyType', id: string, name: string, disable2Fa: boolean } | null } | null }> }, companyBindings?: { __typename?: 'CompanyBindingsConnection', nodes: Array<{ __typename?: 'CompanyBinding', legacyCompanyId?: number | null } | null> }, users: { __typename?: 'CompanySuperadminUserListConnection', totalCount: number, edges: Array<{ __typename?: 'CompanySuperadminUserListEdge', node?: { __typename?: 'CompanySuperadminUserListRecord', id?: string | null, fullName?: string | null, email?: string | null, lastLogin?: Date | string | null, companyAdmin?: boolean | null, superUser?: { __typename?: 'SuperUser', id: string, companyWhitelist?: Array<string | null> | null, companyBlacklist?: Array<string | null> | null, superUserAllowedUsers: { __typename?: 'SuperUserAllowedUsersConnection', nodes: Array<{ __typename?: 'SuperUserAllowedUser', id: string, companyId: string, allowedUserIds?: Array<string | null> | null, disallowedUserIds?: Array<string | null> | null, users: { __typename?: 'SuperUserAllowedUsersUsersConnection', nodes: Array<{ __typename?: 'SuperUserAllowedUsersUsersRecord', id?: string | null, fullName?: string | null, companyId?: string | null, companyName?: string | null } | null> } } | null> } } | null } | null }> } } | null };

export type CompanyBindingQueryVariables = Exact<{
  companyId: Scalars['UUID'];
}>;


export type CompanyBindingQuery = { __typename?: 'Query', companyBindings?: { __typename?: 'CompanyBindingsConnection', nodes: Array<{ __typename?: 'CompanyBinding', companyId?: string | null, legacyCompanyId?: number | null } | null> } | null };

export type CompanyCopyInProgressQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CompanyCopyInProgressQuery = { __typename?: 'Query', companyById?: { __typename?: 'Company', copyInProgress: boolean } | null };

export type RecruitCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type RecruitCompaniesQuery = { __typename?: 'Query', recruitCompanies?: Array<{ __typename?: 'RecruitCompany', companyid?: number | null, company?: string | null, mode?: string | null } | null> | null };

export type CompanySearchSuggestionsQueryVariables = Exact<{
  searchQuery: Scalars['String'];
}>;


export type CompanySearchSuggestionsQuery = { __typename?: 'Query', companies?: { __typename?: 'CompaniesConnection', edges: Array<{ __typename?: 'CompaniesEdge', node?: { __typename?: 'Company', id: string, name?: string | null } | null }> } | null };

export type CompaniesWithAdminUserListQueryVariables = Exact<{
  companyIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type CompaniesWithAdminUserListQuery = { __typename?: 'Query', companies?: { __typename?: 'CompaniesConnection', nodes: Array<{ __typename?: 'Company', id: string, name?: string | null, superadminUserList: { __typename?: 'CompanySuperadminUserListConnection', nodes: Array<{ __typename?: 'CompanySuperadminUserListRecord', id?: string | null, fullName?: string | null } | null> } } | null> } | null };

export type ResetFormCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type ResetFormCompaniesQuery = { __typename?: 'Query', resetFormCompanies?: { __typename?: 'ResetFormCompaniesConnection', edges: Array<{ __typename?: 'ResetFormCompanyEdge', node?: { __typename?: 'ResetFormCompaniesRecord', id?: string | null, name?: string | null } | null }> } | null };

export type AllCompanySettingsQueryVariables = Exact<{
  filter?: InputMaybe<CompanySettingFilter>;
}>;


export type AllCompanySettingsQuery = { __typename?: 'Query', companySettings?: { __typename?: 'CompanySettingsConnection', edges: Array<{ __typename?: 'CompanySettingsEdge', node?: { __typename?: 'CompanySetting', id: string, companyId: string, key: CompanySettingKey, value?: string | null, valueBoolean?: boolean | null, valueStorage?: { __typename?: 'Storage', id: string, url?: string | null } | null } | null }> } | null };

export type CompanySettingByKeyQueryVariables = Exact<{
  companyId: Scalars['UUID'];
  key: CompanySettingKey;
}>;


export type CompanySettingByKeyQuery = { __typename?: 'Query', companySettingByCompanyIdAndKey?: { __typename?: 'CompanySetting', id: string, companyId: string, key: CompanySettingKey, value?: string | null, valueBoolean?: boolean | null, valueStorage?: { __typename?: 'Storage', id: string, url?: string | null } | null } | null };

export type CompanyTypeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CompanyTypeQuery = { __typename?: 'Query', companyTypeById?: { __typename?: 'CompanyType', id: string, name: string, disable2Fa: boolean } | null };

export type CompanyCompanyTypeByCompanyIdQueryVariables = Exact<{
  companyId: Scalars['UUID'];
}>;


export type CompanyCompanyTypeByCompanyIdQuery = { __typename?: 'Query', companyCompanyTypeByCompanyId?: { __typename?: 'CompanyCompanyType', companyId: string, companyTypeId: string } | null };

export type CompanyTypesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<CompanyTypesOrderBy> | CompanyTypesOrderBy>;
  filter?: InputMaybe<CompanyTypeFilter>;
}>;


export type CompanyTypesQuery = { __typename?: 'Query', companyTypes?: { __typename?: 'CompanyTypesConnection', edges: Array<{ __typename?: 'CompanyTypesEdge', node?: { __typename?: 'CompanyType', id: string, name: string, disable2Fa: boolean } | null }> } | null };

export type CompetenceGroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<CompetenceGroupsOrderBy> | CompetenceGroupsOrderBy>;
  filter?: InputMaybe<CompetenceGroupFilter>;
  competencesFilter?: InputMaybe<CompetenceFilter>;
}>;


export type CompetenceGroupsQuery = { __typename?: 'Query', competenceGroups?: { __typename?: 'CompetenceGroupsConnection', totalCount: number, edges: Array<{ __typename?: 'CompetenceGroupsEdge', node?: { __typename?: 'CompetenceGroup', id: string, name: string, localizedName?: string | null, competences: { __typename?: 'CompetencesConnection', edges: Array<{ __typename?: 'CompetencesEdge', node?: { __typename?: 'Competence', id: string, name: string, description?: string | null, localizedName?: string | null, localizedDescription?: string | null, active: boolean, useRating: boolean, outdateCompetence: boolean, assigneeCount?: number | null, ratingFormField?: { __typename?: 'FormField', id: string, metadata?: any | null, fieldType?: string | null, localizedHelpText?: string | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, order: number } | null> } } | null, outdateInterval?: { __typename?: 'Interval', seconds?: number | null, minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } | null } | null }> } } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: unknown | null } } | null };

export type CompetencesQueryVariables = Exact<{
  filter?: InputMaybe<CompetenceFilter>;
}>;


export type CompetencesQuery = { __typename?: 'Query', competences?: { __typename?: 'CompetencesConnection', nodes: Array<{ __typename?: 'Competence', id: string, name: string, description?: string | null, localizedName?: string | null, localizedDescription?: string | null, active: boolean, useRating: boolean, outdateCompetence: boolean, outdateInterval?: { __typename?: 'Interval', days?: number | null, months?: number | null, years?: number | null } | null, ratingFormField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } | null };

export type CompetenceByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CompetenceByIdQuery = { __typename?: 'Query', competenceById?: { __typename?: 'Competence', name: string, id: string, competenceGroupId: string, description?: string | null, useRating: boolean, onlyManagerShouldEvaluate: boolean, updateReminder: boolean, outdateCompetence: boolean, ratingFormField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null, reminderInterval: { __typename?: 'Interval', days?: number | null, months?: number | null, years?: number | null }, outdateInterval?: { __typename?: 'Interval', days?: number | null, months?: number | null, years?: number | null } | null, userCompetences: { __typename?: 'UserCompetencesConnection', edges: Array<{ __typename?: 'UserCompetencesEdge', node?: { __typename?: 'UserCompetence', userId: string } | null }> }, storages: { __typename?: 'StoragesConnection', edges: Array<{ __typename?: 'StoragesEdge', node?: { __typename?: 'Storage', id: string, path: string, filename: string, fileOwner: StorageFileOwner, fileOwnerId: string, mimetype?: string | null, fileExtension: string, createdAt: Date | string, deleteAt?: Date | string | null, expireAt?: Date | string | null, remindAt?: Date | string | null } | null }> } } | null };

export type CompetenceGroupByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CompetenceGroupByIdQuery = { __typename?: 'Query', competenceGroupById?: { __typename?: 'CompetenceGroup', name: string, id: string } | null };

export type UserCompetenceQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UserCompetenceQuery = { __typename?: 'Query', userCompetenceById?: { __typename?: 'UserCompetence', addedDate: Date | string, id: string, courseRequested: boolean, competence?: { __typename?: 'Competence', useRating: boolean, onlyManagerShouldEvaluate: boolean, outdateCompetence: boolean, ratingFormField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null, outdateInterval?: { __typename?: 'Interval', days?: number | null, months?: number | null, years?: number | null } | null } | null, userCompetenceEvaluations: { __typename?: 'UserCompetenceEvaluationsConnection', edges: Array<{ __typename?: 'UserCompetenceEvaluationsEdge', node?: { __typename?: 'UserCompetenceEvaluation', id: string, evaluatingUserId: string, nextUpdate?: Date | string | null, evaluationDate: Date | string, evaluatingUser?: { __typename?: 'User', fullName?: string | null } | null, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, formFieldId: string, userId?: string | null, value?: string | null } | null> } } | null }> } } | null };

export type UserCompetencesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<UserCompetencesOrderBy> | UserCompetencesOrderBy>;
  filter?: InputMaybe<UserCompetenceFilter>;
  includeUser?: InputMaybe<Scalars['Boolean']>;
}>;


export type UserCompetencesQuery = { __typename?: 'Query', userCompetences?: { __typename?: 'UserCompetencesConnection', edges: Array<{ __typename?: 'UserCompetencesEdge', node?: { __typename?: 'UserCompetence', addedDate: Date | string, id: string, courseRequested: boolean, competence?: { __typename?: 'Competence', id: string, name: string, localizedName?: string | null, description?: string | null, outdateCompetence: boolean, onlyManagerShouldEvaluate: boolean, competenceGroupId: string, ratingFormField?: { __typename?: 'FormField', id: string, metadata?: any | null, fieldType?: string | null, localizedHelpText?: string | null } | null, competenceGroup?: { __typename?: 'CompetenceGroup', id: string, name: string, localizedName?: string | null } | null } | null, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null, userCompetenceEvaluations: { __typename?: 'UserCompetenceEvaluationsConnection', edges: Array<{ __typename?: 'UserCompetenceEvaluationsEdge', node?: { __typename?: 'UserCompetenceEvaluation', id: string, evaluatingUserId: string, nextUpdate?: Date | string | null, evaluationDate: Date | string, evaluatingUser?: { __typename?: 'User', fullName?: string | null } | null, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, formFieldId: string, userId?: string | null, value?: string | null } | null> } } | null }> } } | null }> } | null };

export type UserEvaluationCommentsQueryVariables = Exact<{
  filter?: InputMaybe<UserCompetenceEvaluationCommentFilter>;
  orderBy?: InputMaybe<Array<UserCompetenceEvaluationCommentsOrderBy> | UserCompetenceEvaluationCommentsOrderBy>;
}>;


export type UserEvaluationCommentsQuery = { __typename?: 'Query', userCompetenceEvaluationComments?: { __typename?: 'UserCompetenceEvaluationCommentsConnection', edges: Array<{ __typename?: 'UserCompetenceEvaluationCommentsEdge', node?: { __typename?: 'UserCompetenceEvaluationComment', comment?: string | null, updatedAt: Date | string, createdAt: Date | string, id: string, user?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null }> } | null };

export type CompetencesSearchQueryVariables = Exact<{
  searchQuery: Scalars['String'];
  page: Scalars['Int'];
}>;


export type CompetencesSearchQuery = { __typename?: 'Query', competencesSearch?: { __typename?: 'CompetencesSearchPayload', results?: Array<{ __typename?: 'ESCOSearchResult', title?: string | null, description?: string | null, uri?: string | null } | null> | null } | null };

export type ExportCompetencesToExcelQueryVariables = Exact<{
  userCompetenceIds: Array<Scalars['UUID']> | Scalars['UUID'];
  columnNames: Array<Scalars['String']> | Scalars['String'];
}>;


export type ExportCompetencesToExcelQuery = { __typename?: 'Query', exportCompetencesToExcel?: { __typename?: 'ExportCompetencesToExcelPayload', base64?: string | null } | null };

export type UserCompetencesTableQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<UserCompetencesOrderBy> | UserCompetencesOrderBy>;
  filter?: InputMaybe<UserCompetenceFilter>;
}>;


export type UserCompetencesTableQuery = { __typename?: 'Query', userCompetences?: { __typename?: 'UserCompetencesConnection', edges: Array<{ __typename?: 'UserCompetencesEdge', node?: { __typename?: 'UserCompetence', id: string, addedDate: Date | string, user?: { __typename?: 'User', id: string, employeeId?: string | null, fullName?: string | null, logo?: string | null, cpr?: string | null, address?: string | null, userDepartments: { __typename?: 'UserDepartmentsConnection', nodes: Array<{ __typename?: 'UserDepartment', department?: { __typename?: 'Department', id: string, name: string } | null } | null> } } | null, competence?: { __typename?: 'Competence', id: string, localizedName?: string | null, outdateCompetence: boolean, description?: string | null, competenceGroup?: { __typename?: 'CompetenceGroup', id: string, localizedName?: string | null } | null, ratingFormField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null, managerEvaluation?: { __typename?: 'UserCompetenceEvaluation', id: string, evaluationDate: Date | string, nextUpdate?: Date | string | null } | null, userCompetenceEvaluations: { __typename?: 'UserCompetenceEvaluationsConnection', edges: Array<{ __typename?: 'UserCompetenceEvaluationsEdge', node?: { __typename?: 'UserCompetenceEvaluation', id: string, evaluatingUserId: string, nextUpdate?: Date | string | null, evaluationDate: Date | string, evaluatingUser?: { __typename?: 'User', fullName?: string | null } | null, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, formFieldId: string, userId?: string | null, value?: string | null } | null> } } | null }> } } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: unknown | null } } | null };

export type UserCompetencesTableCountQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<UserCompetencesOrderBy> | UserCompetencesOrderBy>;
  filter?: InputMaybe<UserCompetenceFilter>;
}>;


export type UserCompetencesTableCountQuery = { __typename?: 'Query', userCompetences?: { __typename?: 'UserCompetencesConnection', totalCount: number } | null };

export type UserCompetencesTableIdsQueryVariables = Exact<{
  filter?: InputMaybe<UserCompetenceFilter>;
}>;


export type UserCompetencesTableIdsQuery = { __typename?: 'Query', userCompetences?: { __typename?: 'UserCompetencesConnection', edges: Array<{ __typename?: 'UserCompetencesEdge', node?: { __typename?: 'UserCompetence', id: string } | null }> } | null };

export type CompetenceGroupOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompetenceGroupOptionsQuery = { __typename?: 'Query', competenceGroups?: { __typename?: 'CompetenceGroupsConnection', edges: Array<{ __typename?: 'CompetenceGroupsEdge', node?: { __typename?: 'CompetenceGroup', id: string, localizedName?: string | null } | null }> } | null };

export type CompetenceNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompetenceNamesQuery = { __typename?: 'Query', competences?: { __typename?: 'CompetencesConnection', edges: Array<{ __typename?: 'CompetencesEdge', node?: { __typename?: 'Competence', id: string, localizedName?: string | null } | null }> } | null };

export type CompetenceAssigneesQueryVariables = Exact<{
  competenceId: Scalars['UUID'];
  after?: InputMaybe<Scalars['Cursor']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type CompetenceAssigneesQuery = { __typename?: 'Query', userCompetences?: { __typename?: 'UserCompetencesConnection', edges: Array<{ __typename?: 'UserCompetencesEdge', node?: { __typename?: 'UserCompetence', id: string, user?: { __typename?: 'User', id: string, employeeId?: string | null, fullName?: string | null, jobPositionTitle?: string | null, logo?: string | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: unknown | null } } | null };

export type ContractSignPendingsByEmployeeIdQueryVariables = Exact<{
  filter?: InputMaybe<ContractSignPendingFilter>;
  casefileFilter?: InputMaybe<EmployeeCasefileFilter>;
  orderBy?: InputMaybe<Array<ContractSignPendingsOrderBy> | ContractSignPendingsOrderBy>;
}>;


export type ContractSignPendingsByEmployeeIdQuery = { __typename?: 'Query', contractSignPendings?: { __typename?: 'ContractSignPendingsConnection', totalCount: number, edges: Array<{ __typename?: 'ContractSignPendingsEdge', node?: { __typename?: 'ContractSignPending', id: string, active: boolean, employeeId: string, userId: string, createdAt?: Date | string | null, contractSignPendingDocuments: { __typename?: 'ContractSignPendingDocumentsConnection', nodes: Array<{ __typename?: 'ContractSignPendingDocument', id: string, contractTemplateId?: string | null, placeholderValues?: any | null, contractName: string, documentTypeId?: string | null, existingStorageId?: string | null, fieldMappings?: any | null, documentType?: { __typename?: 'DocumentType', id: string, localizedName?: string | null } | null, contractTemplate?: { __typename?: 'ContractTemplate', id: string, html?: string | null, header?: string | null, footer?: string | null, dateFormat: string, locale: string, documentType?: { __typename?: 'DocumentType', id: string } | null } | null } | null> }, contractSignPendingSigners: { __typename?: 'ContractSignPendingSignersConnection', nodes: Array<{ __typename?: 'ContractSignPendingSigner', signatureImage?: string | null, useSecondaryEmail: boolean, onBehalfOfUserId?: string | null, signOrder: number, id: string, contractSignPendingId: string, signed: boolean, signDate?: Date | string | null, signatureFileId?: string | null, userId: string, createdAt: Date | string, refused: boolean, refusalReason?: string | null, contractSignPending?: { __typename?: 'ContractSignPending', id: string, signDate?: Date | string | null } | null, user?: { __typename?: 'User', id: string, logo?: string | null, email?: string | null, emailWork?: string | null, fullName?: string | null } | null, onBehalfOfUser?: { __typename?: 'User', id: string, logo?: string | null, email?: string | null, fullName?: string | null } | null } | null> } } | null }> } | null, employeeCasefiles?: { __typename?: 'EmployeeCasefilesConnection', totalCount: number, edges: Array<{ __typename?: 'EmployeeCasefilesEdge', node?: { __typename?: 'EmployeeCasefile', casefileId: number, employeeId: string, title?: string | null, status?: string | null, signers?: any | null, documents?: any | null, createdAt?: Date | string | null, documentType?: { __typename?: 'DocumentType', id: string, name?: string | null } | null, employeeSigners: { __typename?: 'EmployeesConnection', nodes: Array<{ __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, email?: string | null } | null } | null> }, user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, email?: string | null, fullName?: string | null } | null } | null }> } | null };

export type ContractSignPendingByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ContractSignPendingByIdQuery = { __typename?: 'Query', contractSignPendingById?: { __typename?: 'ContractSignPending', id: string, active: boolean, employeeId: string, userId: string, signingUserIds: Array<string | null>, signedUserIds: Array<string | null>, contractSignPendingDocuments: { __typename?: 'ContractSignPendingDocumentsConnection', nodes: Array<{ __typename?: 'ContractSignPendingDocument', id: string, contractTemplateId?: string | null, placeholderValues?: any | null, contractName: string, documentTypeId?: string | null, existingStorageId?: string | null, fieldMappings?: any | null, documentType?: { __typename?: 'DocumentType', id: string, localizedName?: string | null } | null, contractTemplate?: { __typename?: 'ContractTemplate', id: string, html?: string | null, header?: string | null, footer?: string | null, dateFormat: string, locale: string, documentType?: { __typename?: 'DocumentType', id: string } | null } | null } | null> }, contractSignPendingSigners: { __typename?: 'ContractSignPendingSignersConnection', nodes: Array<{ __typename?: 'ContractSignPendingSigner', id: string, userId: string, onBehalfOfUserId?: string | null, signOrder: number, signed: boolean, refused: boolean } | null> } } | null };

export type ContractSignPendingDocumentByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ContractSignPendingDocumentByIdQuery = { __typename?: 'Query', contractSignPendingDocumentById?: { __typename?: 'ContractSignPendingDocument', id: string, contractTemplateId?: string | null, placeholderValues?: any | null, contractName: string, documentTypeId?: string | null, existingStorageId?: string | null, fieldMappings?: any | null, documentType?: { __typename?: 'DocumentType', id: string, localizedName?: string | null } | null, contractTemplate?: { __typename?: 'ContractTemplate', id: string, html?: string | null, header?: string | null, footer?: string | null, dateFormat: string, locale: string, documentType?: { __typename?: 'DocumentType', id: string } | null } | null } | null };

export type SavedSignaturesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
}>;


export type SavedSignaturesQuery = { __typename?: 'Query', savedSignatures?: { __typename?: 'SavedSignaturesConnection', edges: Array<{ __typename?: 'SavedSignaturesEdge', node?: { __typename?: 'SavedSignature', id: string, employee?: { __typename?: 'Employee', id: string } | null, storage?: { __typename?: 'Storage', id: string, url?: string | null } | null } | null }> } | null };

export type GetContractsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ContractSignPendingFilter>;
  orderBy?: InputMaybe<Array<ContractSignPendingsOrderBy> | ContractSignPendingsOrderBy>;
  after?: InputMaybe<Scalars['Cursor']>;
  includeUserData: Scalars['Boolean'];
}>;


export type GetContractsQuery = { __typename?: 'Query', contractSignPendings?: { __typename?: 'ContractSignPendingsConnection', totalCount: number, edges: Array<{ __typename?: 'ContractSignPendingsEdge', node?: { __typename?: 'ContractSignPending', id: string, active: boolean, userId: string, refused?: boolean | null, enforceSignOrder: boolean, createdAt?: Date | string | null, employee?: { __typename?: 'Employee', id: string } | null, user?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null, jobPositionTitle?: string | null } | null, contractSignPendingDocuments: { __typename?: 'ContractSignPendingDocumentsConnection', nodes: Array<{ __typename?: 'ContractSignPendingDocument', id: string, contractTemplateId?: string | null, placeholderValues?: any | null, contractName: string, documentTypeId?: string | null, existingStorageId?: string | null, fieldMappings?: any | null, documentType?: { __typename?: 'DocumentType', id: string, localizedName?: string | null } | null, contractTemplate?: { __typename?: 'ContractTemplate', id: string, html?: string | null, header?: string | null, footer?: string | null, dateFormat: string, locale: string, documentType?: { __typename?: 'DocumentType', id: string } | null } | null } | null> }, contractSignPendingSigners: { __typename?: 'ContractSignPendingSignersConnection', nodes: Array<{ __typename?: 'ContractSignPendingSigner', signatureImage?: string | null, useSecondaryEmail: boolean, onBehalfOfUserId?: string | null, signOrder: number, id: string, contractSignPendingId: string, signed: boolean, signDate?: Date | string | null, signatureFileId?: string | null, userId: string, createdAt: Date | string, refused: boolean, refusalReason?: string | null, contractSignPending?: { __typename?: 'ContractSignPending', id: string, signDate?: Date | string | null } | null, user?: { __typename?: 'User', id: string, logo?: string | null, email?: string | null, emailWork?: string | null, fullName?: string | null } | null, onBehalfOfUser?: { __typename?: 'User', id: string, logo?: string | null, email?: string | null, fullName?: string | null } | null } | null> } } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type UnsignedDocumentsCountQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type UnsignedDocumentsCountQuery = { __typename?: 'Query', unsignedDocumentsCount?: number | null };

export type SpecificUnsignedDocumentsCountQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type SpecificUnsignedDocumentsCountQuery = { __typename?: 'Query', unsignedContractSignPendingCount?: number | null, unsignedEmployeeCasefileCount?: number | null };

export type ContractTemplatesQueryVariables = Exact<{
  filter?: InputMaybe<ContractTemplateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractTemplatesOrderBy> | ContractTemplatesOrderBy>;
  after?: InputMaybe<Scalars['Cursor']>;
}>;


export type ContractTemplatesQuery = { __typename?: 'Query', contractTemplates?: { __typename?: 'ContractTemplatesConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'ContractTemplatesEdge', node?: { __typename?: 'ContractTemplate', id: string, companyId: string, name?: string | null, description?: string | null, active: boolean, jobPositionTypes?: Array<string | null> | null, placeholders?: any | null, htmlPlaceholders?: Array<string | null> | null, html?: string | null, header?: string | null, footer?: string | null, dateFormat: string, pageNumber: boolean, locale: string, topMargin: string | number, bottomMargin: string | number, leftMargin: string | number, rightMargin: string | number, createdAt: Date | string, updatedAt: Date | string, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null, lifetime?: number | null } | null, contractTemplateDepartments: { __typename?: 'ContractTemplateDepartmentsConnection', nodes: Array<{ __typename?: 'ContractTemplateDepartment', departmentId: string, department?: { __typename?: 'Department', id: string, name: string, companyId?: string | null } | null } | null> }, contractTemplateUsers: { __typename?: 'ContractTemplateUsersConnection', nodes: Array<{ __typename?: 'ContractTemplateUser', userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null, companyId: string } | null } | null> } } | null }> } | null };

export type ContractTemplateByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ContractTemplateByIdQuery = { __typename?: 'Query', contractTemplateById?: { __typename?: 'ContractTemplate', id: string, companyId: string, name?: string | null, description?: string | null, active: boolean, jobPositionTypes?: Array<string | null> | null, placeholders?: any | null, htmlPlaceholders?: Array<string | null> | null, html?: string | null, header?: string | null, footer?: string | null, dateFormat: string, pageNumber: boolean, locale: string, topMargin: string | number, bottomMargin: string | number, leftMargin: string | number, rightMargin: string | number, createdAt: Date | string, updatedAt: Date | string, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null, lifetime?: number | null } | null, contractTemplateDepartments: { __typename?: 'ContractTemplateDepartmentsConnection', nodes: Array<{ __typename?: 'ContractTemplateDepartment', departmentId: string, department?: { __typename?: 'Department', id: string, name: string, companyId?: string | null } | null } | null> }, contractTemplateUsers: { __typename?: 'ContractTemplateUsersConnection', nodes: Array<{ __typename?: 'ContractTemplateUser', userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null, companyId: string } | null } | null> } } | null };

export type CustomWidgetsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<CustomWidgetsOrderBy> | CustomWidgetsOrderBy>;
  filter?: InputMaybe<CustomWidgetFilter>;
}>;


export type CustomWidgetsQuery = { __typename?: 'Query', customWidgets?: { __typename?: 'CustomWidgetsConnection', totalCount: number, edges: Array<{ __typename?: 'CustomWidgetsEdge', node?: { __typename?: 'CustomWidget', id: string, useImage: boolean, image?: { __typename?: 'Storage', id: string, url?: string | null } | null, customWidgetContents: { __typename?: 'CustomWidgetContentsConnection', nodes: Array<{ __typename?: 'CustomWidgetContent', id: string, title: string, locale: string } | null> } } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type CustomWidgetQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CustomWidgetQuery = { __typename?: 'Query', customWidgetById?: { __typename?: 'CustomWidget', id: string, useImage: boolean, widgetSize: number, backgroundColor: string, widgetTextColor: string, buttonTextColor: string, buttonBackgroundColor: string, buttonBorder: boolean, imageLayout: string, image?: { __typename?: 'Storage', id: string, url?: string | null } | null, customWidgetContents: { __typename?: 'CustomWidgetContentsConnection', nodes: Array<{ __typename?: 'CustomWidgetContent', id: string, locale: string, title: string, content: string, addButton: boolean, buttonText?: string | null, buttonLink?: string | null, isInternalButtonLink?: boolean | null } | null> } } | null };

export type InternalLinkOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type InternalLinkOptionsQuery = { __typename?: 'Query', documentFolderBlueprints?: { __typename?: 'DocumentFolderBlueprintsConnection', nodes: Array<{ __typename?: 'DocumentFolderBlueprint', id: string, name: string } | null> } | null, fieldGroups?: { __typename?: 'FieldGroupsConnection', nodes: Array<{ __typename?: 'FieldGroup', id: string, localizedName?: string | null } | null> } | null };

export type CvTemplateFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type CvTemplateFieldsQuery = { __typename?: 'Query', cvTemplateFields?: Array<string | null> | null };

export type CvTemplateFieldMappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type CvTemplateFieldMappingsQuery = { __typename?: 'Query', cvTemplateFieldMappings?: { __typename?: 'CvTemplateFieldMappingsConnection', nodes: Array<{ __typename?: 'CvTemplateFieldMapping', id: string, cvTemplateField: string, systemFieldId?: string | null, formFieldId?: string | null } | null> } | null };

export type AllStaffFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllStaffFieldsQuery = { __typename?: 'Query', systemFields?: { __typename?: 'SystemFieldsConnection', nodes: Array<{ __typename?: 'SystemField', id: string, name: string } | null> } | null, formFields?: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, localizedName?: string | null } | null> } | null };

export type StaffFieldsQueryVariables = Exact<{
  autoMappedFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type StaffFieldsQuery = { __typename?: 'Query', systemFields?: { __typename?: 'SystemFieldsConnection', nodes: Array<{ __typename?: 'SystemField', id: string, name: string } | null> } | null, formFields?: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, localizedName?: string | null } | null> } | null };

export type DashboardViewsQueryVariables = Exact<{
  filter?: InputMaybe<DashboardViewFilter>;
}>;


export type DashboardViewsQuery = { __typename?: 'Query', dashboardViews?: { __typename?: 'DashboardViewsConnection', edges: Array<{ __typename?: 'DashboardViewsEdge', node?: { __typename?: 'DashboardView', id: string, name: string } | null }> } | null };

export type CalendarBirthdayAnniversaryQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
}>;


export type CalendarBirthdayAnniversaryQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: string, fullName?: string | null, birthdate?: Date | string | null, seniority?: Date | string | null, logo?: string | null, employeeId?: string | null } | null> } | null };

export type CalendarEmploymentStartEndQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
}>;


export type CalendarEmploymentStartEndQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: string, fullName?: string | null, birthdate?: Date | string | null, employmentStart?: Date | string | null, employmentEnd?: Date | string | null, logo?: string | null, employeeId?: string | null } | null> } | null };

export type DashboardCardsQueryVariables = Exact<{
  dashboardViewId: Scalars['UUID'];
}>;


export type DashboardCardsQuery = { __typename?: 'Query', dashboardCards?: { __typename?: 'DashboardCardsConnection', nodes: Array<{ __typename?: 'DashboardCard', id: string, type: DashboardCardType, departmentIds?: Array<string | null> | null, jobPositionTypeIds?: Array<string | null> | null, customWidget?: { __typename?: 'CustomWidget', id: string, useImage: boolean, widgetSize: number, backgroundColor: string, widgetTextColor: string, buttonTextColor: string, buttonBackgroundColor: string, buttonBorder: boolean, imageLayout: string, image?: { __typename?: 'Storage', id: string, url?: string | null } | null, customWidgetContents: { __typename?: 'CustomWidgetContentsConnection', nodes: Array<{ __typename?: 'CustomWidgetContent', id: string, locale: string, title: string, content: string, addButton: boolean, buttonText?: string | null, buttonLink?: string | null, isInternalButtonLink?: boolean | null } | null> } } | null, dashboardCardStatistics: { __typename?: 'DashboardCardStatisticsConnection', nodes: Array<{ __typename?: 'DashboardCardStatistic', id: string, chartType: DashboardCardStatisticChartType, formField?: { __typename?: 'FormField', id: string, active: boolean, localizedName?: string | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null } | null> } } | null, systemField?: { __typename?: 'SystemField', id: string, name: string } | null } | null> } } | null> } | null };

export type DashboardViewByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DashboardViewByIdQuery = { __typename?: 'Query', dashboardViewById?: { __typename?: 'DashboardView', id: string, name: string } | null };

export type DashboardCardByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DashboardCardByIdQuery = { __typename?: 'Query', dashboardCardById?: { __typename?: 'DashboardCard', id: string, type: DashboardCardType, departmentIds?: Array<string | null> | null, jobPositionTypeIds?: Array<string | null> | null, dashboardCardStatistics: { __typename?: 'DashboardCardStatisticsConnection', nodes: Array<{ __typename?: 'DashboardCardStatistic', id: string, chartType: DashboardCardStatisticChartType, formField?: { __typename?: 'FormField', id: string, localizedName?: string | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null } | null> } } | null, systemField?: { __typename?: 'SystemField', id: string, name: string } | null } | null> } } | null };

export type AverageAgeQueryVariables = Exact<{
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type AverageAgeQuery = { __typename?: 'Query', averageAge?: number | null };

export type AverageSeniorityQueryVariables = Exact<{
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  jobPositionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type AverageSeniorityQuery = { __typename?: 'Query', averageSeniority?: number | null };

export type DashboardViewCountQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardViewCountQuery = { __typename?: 'Query', dashboardViews?: { __typename?: 'DashboardViewsConnection', totalCount: number } | null };

export type DashboardConfigQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DashboardConfigQuery = { __typename?: 'Query', dashboardConfigByCompanyId?: { __typename?: 'DashboardConfig', companyId: string, pageTitle: string, localizedPageTitle?: string | null } | null };

export type ExportDashboardCardToExcelQueryVariables = Exact<{
  dashboardCardId: Scalars['UUID'];
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
}>;


export type ExportDashboardCardToExcelQuery = { __typename?: 'Query', exportDashboardCardToExcel?: { __typename?: 'ExportDashboardCardToExcelPayload', base64?: string | null } | null };

export type DashboardCardChartQueryVariables = Exact<{
  dashboardCardId: Scalars['UUID'];
  dashboardCardStatisticId?: InputMaybe<Scalars['UUID']>;
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
}>;


export type DashboardCardChartQuery = { __typename?: 'Query', dashboardCardChart?: { __typename?: 'DashboardCardChartPayload', data?: any | null } | null };

export type DepartmentTypeByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DepartmentTypeByIdQuery = { __typename?: 'Query', departmentTypeById?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null };

export type DepartmentTypesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<DepartmentTypesOrderBy> | DepartmentTypesOrderBy>;
  filter?: InputMaybe<DepartmentTypeFilter>;
}>;


export type DepartmentTypesQuery = { __typename?: 'Query', departmentTypes?: { __typename?: 'DepartmentTypesConnection', totalCount: number, edges: Array<{ __typename?: 'DepartmentTypesEdge', node?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null }> } | null };

export type DepartmentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<DepartmentsOrderBy> | DepartmentsOrderBy>;
  filter?: InputMaybe<DepartmentFilter>;
}>;


export type DepartmentsQuery = { __typename?: 'Query', departments?: { __typename?: 'DepartmentsConnection', totalCount: number, edges: Array<{ __typename?: 'DepartmentsEdge', node?: { __typename: 'Department', id: string, name: string, departmentNumber?: string | null, description?: string | null, mainDepartment: boolean, parentDepartmentId?: string | null, cvr?: string | null, alias?: string | null, pNumber?: number | null, ean?: string | null, address: string, postalCode: string, city: string, phone: string, email: string, departmentTypeId?: string | null, hasChildren?: boolean | null, userDepartments: { __typename?: 'UserDepartmentsConnection', totalCount: number, nodes: Array<{ __typename?: 'UserDepartment', user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null, jobPositionTitle?: string | null, employeeId?: string | null } | null, rank?: { __typename?: 'Rank', id: string, name: string } | null } | null> }, userDepartmentGroups: { __typename?: 'UserDepartmentGroupsConnection', nodes: Array<{ __typename?: 'UserDepartmentGroup', user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null, jobPositionTitle?: string | null, employeeId?: string | null } | null } | null> }, departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null, parentDepartment?: { __typename?: 'Department', id: string, name: string } | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type CompanyDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyDepartmentsQuery = { __typename?: 'Query', departments?: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', alias?: string | null, name: string, id: string } | null> } | null };

export type GraphileDepartmentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<DepartmentsOrderBy> | DepartmentsOrderBy>;
  filter?: InputMaybe<DepartmentFilter>;
  includeFieldEntries?: Scalars['Boolean'];
}>;


export type GraphileDepartmentsQuery = { __typename?: 'Query', departments?: { __typename?: 'DepartmentsConnection', totalCount: number, edges: Array<{ __typename?: 'DepartmentsEdge', node?: { __typename: 'Department', id: string, name: string, departmentNumber?: string | null, description?: string | null, mainDepartment: boolean, parentDepartmentId?: string | null, cvr?: string | null, alias?: string | null, pNumber?: number | null, ean?: string | null, address: string, postalCode: string, city: string, phone: string, email: string, departmentTypeId?: string | null, hasChildren?: boolean | null, userDepartments: { __typename?: 'UserDepartmentsConnection', nodes: Array<{ __typename?: 'UserDepartment', user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null> }, formFieldEntries?: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, formFieldId: string, humanReadableValue?: string | null } | null> }, parentDepartment?: { __typename?: 'Department', id: string, name: string } | null, departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type GetDepartmentsFormFieldSortQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<DepartmentFilter>;
  includeFieldEntries?: Scalars['Boolean'];
  argFormFieldId?: InputMaybe<Scalars['UUID']>;
  argOrderDirection?: InputMaybe<Scalars['String']>;
}>;


export type GetDepartmentsFormFieldSortQuery = { __typename?: 'Query', departmentsSortByFormField?: { __typename?: 'DepartmentsConnection', totalCount: number, edges: Array<{ __typename?: 'DepartmentsEdge', node?: { __typename: 'Department', id: string, name: string, departmentNumber?: string | null, description?: string | null, mainDepartment: boolean, parentDepartmentId?: string | null, cvr?: string | null, alias?: string | null, pNumber?: number | null, ean?: string | null, address: string, postalCode: string, city: string, phone: string, email: string, departmentTypeId?: string | null, hasChildren?: boolean | null, userDepartments: { __typename?: 'UserDepartmentsConnection', nodes: Array<{ __typename?: 'UserDepartment', user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null> }, formFieldEntries?: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, formFieldId: string, humanReadableValue?: string | null } | null> }, parentDepartment?: { __typename?: 'Department', id: string, name: string } | null, departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type DepartmentsInputFieldQueryVariables = Exact<{
  selected?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  after?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<DepartmentFilter>;
}>;


export type DepartmentsInputFieldQuery = { __typename?: 'Query', allDepartments?: { __typename?: 'DepartmentsConnection', totalCount: number, edges: Array<{ __typename?: 'DepartmentsEdge', node?: { __typename: 'Department', id: string, name: string, departmentNumber?: string | null, description?: string | null, mainDepartment: boolean, parentDepartmentId?: string | null, cvr?: string | null, alias?: string | null, pNumber?: number | null, ean?: string | null, address: string, postalCode: string, city: string, phone: string, email: string, departmentTypeId?: string | null, hasChildren?: boolean | null, parentDepartment?: { __typename?: 'Department', id: string, name: string } | null, departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null, selectedDepartments?: { __typename?: 'DepartmentsConnection', totalCount: number, edges: Array<{ __typename?: 'DepartmentsEdge', node?: { __typename: 'Department', id: string, name: string, departmentNumber?: string | null, description?: string | null, mainDepartment: boolean, parentDepartmentId?: string | null, cvr?: string | null, alias?: string | null, pNumber?: number | null, ean?: string | null, address: string, postalCode: string, city: string, phone: string, email: string, departmentTypeId?: string | null, hasChildren?: boolean | null, parentDepartment?: { __typename?: 'Department', id: string, name: string } | null, departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type DepartmentQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DepartmentQuery = { __typename?: 'Query', departmentById?: { __typename: 'Department', id: string, name: string, departmentNumber?: string | null, description?: string | null, mainDepartment: boolean, parentDepartmentId?: string | null, cvr?: string | null, alias?: string | null, pNumber?: number | null, ean?: string | null, address: string, postalCode: string, city: string, phone: string, email: string, departmentTypeId?: string | null, hasChildren?: boolean | null, userDepartments: { __typename?: 'UserDepartmentsConnection', totalCount: number, nodes: Array<{ __typename?: 'UserDepartment', user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null, jobPositionTitle?: string | null, employeeId?: string | null } | null, rank?: { __typename?: 'Rank', id: string, name: string } | null } | null> }, userDepartmentGroups: { __typename?: 'UserDepartmentGroupsConnection', nodes: Array<{ __typename?: 'UserDepartmentGroup', user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null, jobPositionTitle?: string | null, employeeId?: string | null } | null } | null> }, departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null, parentDepartment?: { __typename?: 'Department', id: string, name: string } | null } | null };

export type DepartmentBasicQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DepartmentBasicQuery = { __typename?: 'Query', departmentById?: { __typename: 'Department', id: string, name: string, departmentNumber?: string | null, description?: string | null, mainDepartment: boolean, parentDepartmentId?: string | null, cvr?: string | null, alias?: string | null, pNumber?: number | null, ean?: string | null, address: string, postalCode: string, city: string, phone: string, email: string, departmentTypeId?: string | null, hasChildren?: boolean | null, parentDepartment?: { __typename?: 'Department', id: string, name: string } | null, departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null };

export type DepartmentsBasicQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<DepartmentFilter>;
}>;


export type DepartmentsBasicQuery = { __typename?: 'Query', departments?: { __typename?: 'DepartmentsConnection', edges: Array<{ __typename?: 'DepartmentsEdge', node?: { __typename?: 'Department', id: string, name: string } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type MainDepartmentQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['UUID']>;
}>;


export type MainDepartmentQuery = { __typename?: 'Query', departments?: { __typename?: 'DepartmentsConnection', totalCount: number, edges: Array<{ __typename?: 'DepartmentsEdge', node?: { __typename: 'Department', id: string, name: string, departmentNumber?: string | null, description?: string | null, mainDepartment: boolean, parentDepartmentId?: string | null, cvr?: string | null, alias?: string | null, pNumber?: number | null, ean?: string | null, address: string, postalCode: string, city: string, phone: string, email: string, departmentTypeId?: string | null, hasChildren?: boolean | null, parentDepartment?: { __typename?: 'Department', id: string, name: string } | null, departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null }> } | null };

export type DepartmentDescendantsQueryVariables = Exact<{
  departmentId?: InputMaybe<Scalars['UUID']>;
}>;


export type DepartmentDescendantsQuery = { __typename?: 'Query', getDepartmentDescendants?: { __typename?: 'DepartmentsConnection', totalCount: number, edges: Array<{ __typename?: 'DepartmentsEdge', node?: { __typename?: 'Department', id: string, name: string } | null }> } | null };

export type DepartmentWithChildrenQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DepartmentWithChildrenQuery = { __typename?: 'Query', departmentById?: { __typename: 'Department', id: string, name: string, departmentNumber?: string | null, description?: string | null, mainDepartment: boolean, parentDepartmentId?: string | null, cvr?: string | null, alias?: string | null, pNumber?: number | null, ean?: string | null, address: string, postalCode: string, city: string, phone: string, email: string, departmentTypeId?: string | null, hasChildren?: boolean | null, departmentsByParentDepartmentId: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename: 'Department', id: string, name: string, departmentNumber?: string | null, description?: string | null, mainDepartment: boolean, parentDepartmentId?: string | null, cvr?: string | null, alias?: string | null, pNumber?: number | null, ean?: string | null, address: string, postalCode: string, city: string, phone: string, email: string, departmentTypeId?: string | null, hasChildren?: boolean | null, parentDepartment?: { __typename?: 'Department', id: string, name: string } | null, departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null> }, parentDepartment?: { __typename?: 'Department', id: string, name: string } | null, departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null };

export type ExportDepartmentsToExcelQueryVariables = Exact<{
  departmentIds: Array<Scalars['UUID']> | Scalars['UUID'];
  fields: Array<Scalars['String']> | Scalars['String'];
}>;


export type ExportDepartmentsToExcelQuery = { __typename?: 'Query', exportDepartmentsToExcel?: { __typename?: 'ExportDepartmentsToExcelPayload', base64?: string | null } | null };

export type OrganizationDiagramQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationDiagramQuery = { __typename?: 'Query', organizationDiagram?: { __typename?: 'OrganizationDiagramConnection', nodes: Array<any | null> } | null };

export type DepartmentTimeRegistrationRuleBreachesSummaryQueryVariables = Exact<{
  departmentId: Scalars['UUID'];
  fromDate: Scalars['Datetime'];
}>;


export type DepartmentTimeRegistrationRuleBreachesSummaryQuery = { __typename?: 'Query', departmentById?: { __typename?: 'Department', id: string, ruleBreachesSummary: { __typename?: 'DepartmentRuleBreachesSummaryConnection', nodes: Array<{ __typename?: 'DepartmentRuleBreachesSummaryRecord', fullName?: string | null, jobTitle?: string | null, logo?: string | null, rule?: string | null, date?: Date | string | null } | null> } } | null };

export type AllDocumentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<StoragesOrderBy> | StoragesOrderBy>;
  filter?: InputMaybe<StorageFilter>;
  companyId: Scalars['UUID'];
}>;


export type AllDocumentsQuery = { __typename?: 'Query', storages?: { __typename?: 'StoragesConnection', edges: Array<{ __typename?: 'StoragesEdge', node?: { __typename?: 'Storage', active: boolean, id: string, path: string, filename: string, fileOwner: StorageFileOwner, fileSize?: number | null, fileOwnerId: string, fileType: string, mimetype?: string | null, fileExtension: string, createdAt: Date | string, deleteAt?: Date | string | null, expireAt?: Date | string | null, remindAt?: Date | string | null, departments?: Array<string | null> | null, url?: string | null, html?: string | null, contractSignPendingDocumentId?: string | null, documentFolderId?: string | null, documentTemplateId?: string | null, placeholderValues?: any | null, documentTypeId?: string | null, owner?: any | null, employeeCasefileId?: string | null, contractSignPendingDocument?: { __typename?: 'ContractSignPendingDocument', id: string, fieldMappings?: any | null } | null, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null } | null, documentUserResponsiblesByFileId: { __typename?: 'DocumentUserResponsiblesConnection', edges: Array<{ __typename?: 'DocumentUserResponsiblesEdge', node?: { __typename?: 'DocumentUserResponsible', userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null }> } } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type AllDocumentsTotalCountQueryVariables = Exact<{
  filter?: InputMaybe<StorageFilter>;
}>;


export type AllDocumentsTotalCountQuery = { __typename?: 'Query', storages?: { __typename?: 'StoragesConnection', totalCount: number } | null };

export type AllDocumentTypesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentTypesOrderBy> | DocumentTypesOrderBy>;
  filter?: InputMaybe<DocumentTypeFilter>;
  after?: InputMaybe<Scalars['Cursor']>;
}>;


export type AllDocumentTypesQuery = { __typename?: 'Query', documentTypes?: { __typename?: 'DocumentTypesConnection', totalCount: number, edges: Array<{ __typename?: 'DocumentTypesEdge', node?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null, lifetime?: number | null, autoDeleteDays?: number | null, groupsWithAccess: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string, localizedName?: string | null, scope?: RoleScope | null } | null> } } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type DocumentTypeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DocumentTypeQuery = { __typename?: 'Query', documentTypeById?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null, lifetime?: number | null, autoDeleteDays?: number | null } | null };

export type DocumentOwnerNamesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<StoragesOrderBy> | StoragesOrderBy>;
}>;


export type DocumentOwnerNamesQuery = { __typename?: 'Query', storages?: { __typename?: 'StoragesConnection', edges: Array<{ __typename?: 'StoragesEdge', node?: { __typename?: 'Storage', fileOwnerId: string, ownerName?: string | null } | null }> } | null };

export type DocumentCardsQueryVariables = Exact<{
  filter?: InputMaybe<StorageFilter>;
}>;


export type DocumentCardsQuery = { __typename?: 'Query', storages?: { __typename?: 'StoragesConnection', totalCount: number, edges: Array<{ __typename?: 'StoragesEdge', node?: { __typename?: 'Storage', id: string, path: string, filename: string, mimetype?: string | null, fileExtension: string, createdAt: Date | string, url?: string | null, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null } | null } | null }> } | null };

export type DocumentsResponsibleQueryQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type DocumentsResponsibleQueryQuery = { __typename?: 'Query', documentUserResponsibleByUserId?: { __typename?: 'DocumentUserResponsiblesConnection', totalCount: number, edges: Array<{ __typename?: 'DocumentUserResponsiblesEdge', node?: { __typename?: 'DocumentUserResponsible', file?: { __typename?: 'Storage', id: string, path: string, filename: string, mimetype?: string | null, fileExtension: string, active: boolean, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null } | null } | null } | null }> } | null };

export type StorageByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type StorageByIdQuery = { __typename?: 'Query', storageById?: { __typename?: 'Storage', active: boolean, id: string, path: string, filename: string, fileOwner: StorageFileOwner, fileSize?: number | null, fileOwnerId: string, fileType: string, mimetype?: string | null, fileExtension: string, createdAt: Date | string, deleteAt?: Date | string | null, expireAt?: Date | string | null, remindAt?: Date | string | null, departments?: Array<string | null> | null, url?: string | null, html?: string | null, contractSignPendingDocumentId?: string | null, documentFolderId?: string | null, documentTemplateId?: string | null, placeholderValues?: any | null, documentTypeId?: string | null, owner?: any | null, employeeCasefileId?: string | null, contractSignPendingDocument?: { __typename?: 'ContractSignPendingDocument', id: string, fieldMappings?: any | null } | null, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null } | null, documentUserResponsiblesByFileId: { __typename?: 'DocumentUserResponsiblesConnection', edges: Array<{ __typename?: 'DocumentUserResponsiblesEdge', node?: { __typename?: 'DocumentUserResponsible', userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null }> } } | null };

export type GetSignedStorageByContractSignPendingDocumentIdQueryVariables = Exact<{
  contractSignPendingDocumentId: Scalars['UUID'];
}>;


export type GetSignedStorageByContractSignPendingDocumentIdQuery = { __typename?: 'Query', getSignedStorageByContractSignPendingDocumentId?: { __typename?: 'storageBase64Payload', base64?: string | null } | null };

export type EmployeeDocumentsQueryVariables = Exact<{
  userId: Scalars['UUID'];
  filter?: InputMaybe<StorageFilter>;
  orderBy?: InputMaybe<Array<StoragesOrderBy> | StoragesOrderBy>;
}>;


export type EmployeeDocumentsQuery = { __typename?: 'Query', employeeDocuments?: { __typename?: 'StoragesConnection', edges: Array<{ __typename?: 'StoragesEdge', node?: { __typename?: 'Storage', id: string, path: string, filename: string, fileOwner: StorageFileOwner, fileOwnerId: string, ownerName?: string | null, mimetype?: string | null, fileExtension: string, createdAt: Date | string, deleteAt?: Date | string | null, expireAt?: Date | string | null, url?: string | null, templatingServiceId?: string | null, departments?: Array<string | null> | null, contractSignPendingDocumentId?: string | null, usersSharedWith?: Array<string | null> | null, usersResponsible?: Array<string | null> | null, departmentsSharedWith?: Array<string | null> | null, documentTemplateId?: string | null, placeholderValues?: any | null, contractSignPendingDocument?: { __typename?: 'ContractSignPendingDocument', id: string, fieldMappings?: any | null } | null, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null } | null, usersSharedWithComputedColumn: { __typename?: 'UsersConnection', edges: Array<{ __typename?: 'UsersEdge', node?: { __typename?: 'User', id: string, fullName?: string | null } | null }> }, usersResponsibleComputedColumn: { __typename?: 'UsersConnection', edges: Array<{ __typename?: 'UsersEdge', node?: { __typename?: 'User', id: string, fullName?: string | null } | null }> }, departmentsSharedWithComputedColumn: { __typename?: 'DepartmentsConnection', edges: Array<{ __typename?: 'DepartmentsEdge', node?: { __typename?: 'Department', id: string, name: string } | null }> } } | null }> } | null, documentTypes?: { __typename?: 'DocumentTypesConnection', totalCount: number, edges: Array<{ __typename?: 'DocumentTypesEdge', node?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null } | null }> } | null };

export type EmployeeResponsibleDocumentsQueryVariables = Exact<{
  userId: Scalars['UUID'];
  filter?: InputMaybe<StorageFilter>;
  orderBy?: InputMaybe<Array<StoragesOrderBy> | StoragesOrderBy>;
}>;


export type EmployeeResponsibleDocumentsQuery = { __typename?: 'Query', employeeResponsibleDocuments?: { __typename?: 'StoragesConnection', edges: Array<{ __typename?: 'StoragesEdge', node?: { __typename?: 'Storage', id: string, path: string, filename: string, fileOwner: StorageFileOwner, fileOwnerId: string, ownerName?: string | null, mimetype?: string | null, fileExtension: string, createdAt: Date | string, deleteAt?: Date | string | null, expireAt?: Date | string | null, url?: string | null, departments?: Array<string | null> | null, contractSignPendingDocumentId?: string | null, usersSharedWith?: Array<string | null> | null, usersResponsible?: Array<string | null> | null, departmentsSharedWith?: Array<string | null> | null, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null } | null, usersSharedWithComputedColumn: { __typename?: 'UsersConnection', edges: Array<{ __typename?: 'UsersEdge', node?: { __typename?: 'User', id: string, fullName?: string | null } | null }> }, usersResponsibleComputedColumn: { __typename?: 'UsersConnection', edges: Array<{ __typename?: 'UsersEdge', node?: { __typename?: 'User', id: string, fullName?: string | null } | null }> }, departmentsSharedWithComputedColumn: { __typename?: 'DepartmentsConnection', edges: Array<{ __typename?: 'DepartmentsEdge', node?: { __typename?: 'Department', id: string, name: string } | null }> } } | null }> } | null, documentTypes?: { __typename?: 'DocumentTypesConnection', totalCount: number, edges: Array<{ __typename?: 'DocumentTypesEdge', node?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null } | null }> } | null };

export type DocumentsSearchSuggestionsQueryVariables = Exact<{
  searchQuery: Scalars['String'];
  companyId: Scalars['UUID'];
}>;


export type DocumentsSearchSuggestionsQuery = { __typename?: 'Query', storages?: { __typename?: 'StoragesConnection', edges: Array<{ __typename?: 'StoragesEdge', node?: { __typename?: 'Storage', id: string, filename: string } | null }> } | null };

export type DocumentHandSignatoriesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DocumentHandSignatoriesQuery = { __typename?: 'Query', storageById?: { __typename?: 'Storage', id: string, contractSignPendingDocument?: { __typename?: 'ContractSignPendingDocument', id: string, contractSignPending?: { __typename?: 'ContractSignPending', id: string, signDate?: Date | string | null, contractSignPendingSigners: { __typename?: 'ContractSignPendingSignersConnection', edges: Array<{ __typename?: 'ContractSignPendingSignersEdge', node?: { __typename?: 'ContractSignPendingSigner', signatureImage?: string | null, useSecondaryEmail: boolean, onBehalfOfUserId?: string | null, signOrder: number, id: string, contractSignPendingId: string, signed: boolean, signDate?: Date | string | null, signatureFileId?: string | null, userId: string, createdAt: Date | string, refused: boolean, refusalReason?: string | null, contractSignPending?: { __typename?: 'ContractSignPending', id: string, signDate?: Date | string | null } | null, user?: { __typename?: 'User', id: string, logo?: string | null, email?: string | null, emailWork?: string | null, fullName?: string | null } | null, onBehalfOfUser?: { __typename?: 'User', id: string, logo?: string | null, email?: string | null, fullName?: string | null } | null } | null }> } } | null } | null } | null };

export type StorageByContractSignPendingDocumentIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type StorageByContractSignPendingDocumentIdQuery = { __typename?: 'Query', storages?: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string } | null> } | null };

export type GetUserFilesInFolderQueryVariables = Exact<{
  userId: Scalars['UUID'];
  documentFolderId?: InputMaybe<Scalars['UUID']>;
}>;


export type GetUserFilesInFolderQuery = { __typename?: 'Query', storages?: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string, documentType?: { __typename?: 'DocumentType', localizedName?: string | null } | null } | null> } | null };

export type ExpiringDocumentsWidgetQueryQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<StoragesOrderBy> | StoragesOrderBy>;
}>;


export type ExpiringDocumentsWidgetQueryQuery = { __typename?: 'Query', storages?: { __typename?: 'StoragesConnection', edges: Array<{ __typename?: 'StoragesEdge', node?: { __typename?: 'Storage', expireAt?: Date | string | null, fileExtension: string, fileOwner: StorageFileOwner, fileOwnerId: string, fileType: string, ownerName?: string | null, path: string, id: string, owner?: any | null, filename: string } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type ExportDocumentsToExcelQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type ExportDocumentsToExcelQuery = { __typename?: 'Query', exportDocumentsToExcel?: { __typename?: 'ExportDocumentsToExcelPayload', base64?: string | null } | null };

export type StorageHtmlQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type StorageHtmlQuery = { __typename?: 'Query', storageById?: { __typename?: 'Storage', id: string, filename: string, html?: string | null } | null };

export type UserDocumentFoldersQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type UserDocumentFoldersQuery = { __typename?: 'Query', documentFolders?: { __typename?: 'DocumentFoldersConnection', nodes: Array<{ __typename?: 'DocumentFolder', id: string, name: string, parentDocumentFolderId?: string | null, ownerType: DocumentFolderOwnerType, lastEdited?: Date | string | null, ownerId: string, companyId: string, documentFolderBlueprintId?: string | null, rootDocumentFolderBlueprintId?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null } | null, documentFolderDepartments: { __typename?: 'DocumentFolderDepartmentsConnection', nodes: Array<{ __typename?: 'DocumentFolderDepartment', documentFolderId: string, departmentId: string, department?: { __typename?: 'Department', name: string, id: string } | null } | null> }, documentFolderUsers: { __typename?: 'DocumentFolderUsersConnection', nodes: Array<{ __typename?: 'DocumentFolderUser', documentFolderId: string, userId: string, user?: { __typename?: 'User', logo?: string | null, id: string, fullName?: string | null } | null } | null> } } | null> } | null };

export type DocumentFoldersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DocumentFoldersOrderBy> | DocumentFoldersOrderBy>;
  filter?: InputMaybe<DocumentFolderFilter>;
  userId?: InputMaybe<Scalars['UUID']>;
  includePersonalFolders: Scalars['Boolean'];
  storageFilter?: InputMaybe<StorageFilter>;
  rootStorageFilter?: InputMaybe<StorageFilter>;
  casefileFilter?: InputMaybe<EmployeeCasefileFilter>;
  signPendingFilter?: InputMaybe<ContractSignPendingDocumentFilter>;
}>;


export type DocumentFoldersQuery = { __typename?: 'Query', documentFolders?: { __typename?: 'DocumentFoldersConnection', totalCount: number, nodes: Array<{ __typename?: 'DocumentFolder', id: string, name: string, parentDocumentFolderId?: string | null, ownerType: DocumentFolderOwnerType, lastEdited?: Date | string | null, ownerId: string, companyId: string, documentFolderBlueprintId?: string | null, rootDocumentFolderBlueprintId?: string | null, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', active: boolean, id: string, path: string, filename: string, fileOwner: StorageFileOwner, fileSize?: number | null, fileOwnerId: string, fileType: string, mimetype?: string | null, fileExtension: string, createdAt: Date | string, deleteAt?: Date | string | null, expireAt?: Date | string | null, remindAt?: Date | string | null, departments?: Array<string | null> | null, url?: string | null, html?: string | null, contractSignPendingDocumentId?: string | null, documentFolderId?: string | null, documentTemplateId?: string | null, placeholderValues?: any | null, documentTypeId?: string | null, owner?: any | null, employeeCasefileId?: string | null, contractSignPendingDocument?: { __typename?: 'ContractSignPendingDocument', id: string, fieldMappings?: any | null } | null, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null } | null, documentUserResponsiblesByFileId: { __typename?: 'DocumentUserResponsiblesConnection', edges: Array<{ __typename?: 'DocumentUserResponsiblesEdge', node?: { __typename?: 'DocumentUserResponsible', userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null }> } } | null> }, company?: { __typename?: 'Company', id: string, name?: string | null } | null, documentFolderDepartments: { __typename?: 'DocumentFolderDepartmentsConnection', nodes: Array<{ __typename?: 'DocumentFolderDepartment', documentFolderId: string, departmentId: string, department?: { __typename?: 'Department', name: string, id: string } | null } | null> }, documentFolderUsers: { __typename?: 'DocumentFolderUsersConnection', nodes: Array<{ __typename?: 'DocumentFolderUser', documentFolderId: string, userId: string, user?: { __typename?: 'User', logo?: string | null, id: string, fullName?: string | null } | null } | null> } } | null>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null, storages?: { __typename?: 'StoragesConnection', totalCount: number, nodes: Array<{ __typename?: 'Storage', active: boolean, id: string, path: string, filename: string, fileOwner: StorageFileOwner, fileSize?: number | null, fileOwnerId: string, fileType: string, mimetype?: string | null, fileExtension: string, createdAt: Date | string, deleteAt?: Date | string | null, expireAt?: Date | string | null, remindAt?: Date | string | null, departments?: Array<string | null> | null, url?: string | null, html?: string | null, contractSignPendingDocumentId?: string | null, documentFolderId?: string | null, documentTemplateId?: string | null, placeholderValues?: any | null, documentTypeId?: string | null, owner?: any | null, employeeCasefileId?: string | null, contractSignPendingDocument?: { __typename?: 'ContractSignPendingDocument', id: string, fieldMappings?: any | null } | null, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null } | null, documentUserResponsiblesByFileId: { __typename?: 'DocumentUserResponsiblesConnection', edges: Array<{ __typename?: 'DocumentUserResponsiblesEdge', node?: { __typename?: 'DocumentUserResponsible', userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null }> } } | null>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null, contractSignPendings?: { __typename?: 'ContractSignPendingsConnection', nodes: Array<{ __typename?: 'ContractSignPending', contractSignPendingSigners: { __typename?: 'ContractSignPendingSignersConnection', nodes: Array<{ __typename?: 'ContractSignPendingSigner', id: string, refused: boolean, signed: boolean, user?: { __typename?: 'User', id: string, email?: string | null, fullName?: string | null } | null } | null> }, contractSignPendingDocuments: { __typename?: 'ContractSignPendingDocumentsConnection', nodes: Array<{ __typename?: 'ContractSignPendingDocument', contractSignPendingId: string, placeholderValues?: any | null, existingStorageId?: string | null, contractName: string, id: string, documentType?: { __typename?: 'DocumentType', localizedName?: string | null, id: string } | null, contractTemplate?: { __typename?: 'ContractTemplate', id: string, dateFormat: string, html?: string | null, locale: string, header?: string | null, footer?: string | null } | null, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', active: boolean, id: string, path: string, filename: string, fileOwner: StorageFileOwner, fileSize?: number | null, fileOwnerId: string, fileType: string, mimetype?: string | null, fileExtension: string, createdAt: Date | string, deleteAt?: Date | string | null, expireAt?: Date | string | null, remindAt?: Date | string | null, departments?: Array<string | null> | null, url?: string | null, html?: string | null, contractSignPendingDocumentId?: string | null, documentFolderId?: string | null, documentTemplateId?: string | null, placeholderValues?: any | null, documentTypeId?: string | null, owner?: any | null, employeeCasefileId?: string | null, contractSignPendingDocument?: { __typename?: 'ContractSignPendingDocument', id: string, fieldMappings?: any | null } | null, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null } | null, documentUserResponsiblesByFileId: { __typename?: 'DocumentUserResponsiblesConnection', edges: Array<{ __typename?: 'DocumentUserResponsiblesEdge', node?: { __typename?: 'DocumentUserResponsible', userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null }> } } | null> }, existingStorage?: { __typename?: 'Storage', active: boolean, id: string, path: string, filename: string, fileOwner: StorageFileOwner, fileSize?: number | null, fileOwnerId: string, fileType: string, mimetype?: string | null, fileExtension: string, createdAt: Date | string, deleteAt?: Date | string | null, expireAt?: Date | string | null, remindAt?: Date | string | null, departments?: Array<string | null> | null, url?: string | null, html?: string | null, contractSignPendingDocumentId?: string | null, documentFolderId?: string | null, documentTemplateId?: string | null, placeholderValues?: any | null, documentTypeId?: string | null, owner?: any | null, employeeCasefileId?: string | null, contractSignPendingDocument?: { __typename?: 'ContractSignPendingDocument', id: string, fieldMappings?: any | null } | null, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null } | null, documentUserResponsiblesByFileId: { __typename?: 'DocumentUserResponsiblesConnection', edges: Array<{ __typename?: 'DocumentUserResponsiblesEdge', node?: { __typename?: 'DocumentUserResponsible', userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null }> } } | null } | null> } } | null> } | null, employeeCasefiles?: { __typename?: 'EmployeeCasefilesConnection', nodes?: Array<{ __typename?: 'EmployeeCasefile', documents?: any | null, status?: string | null, signers?: any | null, documentType?: { __typename?: 'DocumentType', id: string, localizedName?: string | null } | null } | null> } | null };

export type DocumentFoldersSearchQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<DocumentFoldersOrderBy> | DocumentFoldersOrderBy>;
  filter?: InputMaybe<DocumentFolderFilter>;
  includeSharedFolders: Scalars['Boolean'];
  storageFilter?: InputMaybe<StorageFilter>;
  departmentsFilter?: InputMaybe<DepartmentFilter>;
}>;


export type DocumentFoldersSearchQuery = { __typename?: 'Query', documentFolders?: { __typename?: 'DocumentFoldersConnection', totalCount: number, nodes: Array<{ __typename?: 'DocumentFolder', id: string, name: string, parentDocumentFolderId?: string | null, ownerType: DocumentFolderOwnerType, lastEdited?: Date | string | null, ownerId: string, companyId: string, documentFolderBlueprintId?: string | null, rootDocumentFolderBlueprintId?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null } | null, documentFolderDepartments: { __typename?: 'DocumentFolderDepartmentsConnection', nodes: Array<{ __typename?: 'DocumentFolderDepartment', documentFolderId: string, departmentId: string, department?: { __typename?: 'Department', name: string, id: string } | null } | null> }, documentFolderUsers: { __typename?: 'DocumentFolderUsersConnection', nodes: Array<{ __typename?: 'DocumentFolderUser', documentFolderId: string, userId: string, user?: { __typename?: 'User', logo?: string | null, id: string, fullName?: string | null } | null } | null> } } | null>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null, storages?: { __typename?: 'StoragesConnection', totalCount: number, nodes: Array<{ __typename?: 'Storage', active: boolean, id: string, path: string, filename: string, fileOwner: StorageFileOwner, fileSize?: number | null, fileOwnerId: string, fileType: string, mimetype?: string | null, fileExtension: string, createdAt: Date | string, deleteAt?: Date | string | null, expireAt?: Date | string | null, remindAt?: Date | string | null, departments?: Array<string | null> | null, url?: string | null, html?: string | null, contractSignPendingDocumentId?: string | null, documentFolderId?: string | null, documentTemplateId?: string | null, placeholderValues?: any | null, documentTypeId?: string | null, owner?: any | null, employeeCasefileId?: string | null, contractSignPendingDocument?: { __typename?: 'ContractSignPendingDocument', id: string, fieldMappings?: any | null } | null, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null } | null, documentUserResponsiblesByFileId: { __typename?: 'DocumentUserResponsiblesConnection', edges: Array<{ __typename?: 'DocumentUserResponsiblesEdge', node?: { __typename?: 'DocumentUserResponsible', userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null }> } } | null>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null, departments?: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', name: string, id: string } | null> } | null };

export type DocumentFolderBlueprintsQueryVariables = Exact<{
  filter?: InputMaybe<DocumentFolderBlueprintFilter>;
}>;


export type DocumentFolderBlueprintsQuery = { __typename?: 'Query', documentFolderBlueprints?: { __typename?: 'DocumentFolderBlueprintsConnection', nodes: Array<{ __typename?: 'DocumentFolderBlueprint', name: string, parentDocumentFolderBlueprintId?: string | null, id: string, numberOfFiles?: string | number | null } | null> } | null };

export type DocumentFolderByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
  storageFilter?: InputMaybe<StorageFilter>;
}>;


export type DocumentFolderByIdQuery = { __typename?: 'Query', documentFolderById?: { __typename?: 'DocumentFolder', id: string, name: string, parentDocumentFolderId?: string | null, ownerType: DocumentFolderOwnerType, lastEdited?: Date | string | null, ownerId: string, companyId: string, documentFolderBlueprintId?: string | null, rootDocumentFolderBlueprintId?: string | null, storages: { __typename?: 'StoragesConnection', edges: Array<{ __typename?: 'StoragesEdge', node?: { __typename?: 'Storage', active: boolean, id: string, path: string, filename: string, fileOwner: StorageFileOwner, fileSize?: number | null, fileOwnerId: string, fileType: string, mimetype?: string | null, fileExtension: string, createdAt: Date | string, deleteAt?: Date | string | null, expireAt?: Date | string | null, remindAt?: Date | string | null, departments?: Array<string | null> | null, url?: string | null, html?: string | null, contractSignPendingDocumentId?: string | null, documentFolderId?: string | null, documentTemplateId?: string | null, placeholderValues?: any | null, documentTypeId?: string | null, owner?: any | null, employeeCasefileId?: string | null, contractSignPendingDocument?: { __typename?: 'ContractSignPendingDocument', id: string, fieldMappings?: any | null } | null, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null } | null, documentUserResponsiblesByFileId: { __typename?: 'DocumentUserResponsiblesConnection', edges: Array<{ __typename?: 'DocumentUserResponsiblesEdge', node?: { __typename?: 'DocumentUserResponsible', userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null }> } } | null }> }, company?: { __typename?: 'Company', id: string, name?: string | null } | null, documentFolderDepartments: { __typename?: 'DocumentFolderDepartmentsConnection', nodes: Array<{ __typename?: 'DocumentFolderDepartment', documentFolderId: string, departmentId: string, department?: { __typename?: 'Department', name: string, id: string } | null } | null> }, documentFolderUsers: { __typename?: 'DocumentFolderUsersConnection', nodes: Array<{ __typename?: 'DocumentFolderUser', documentFolderId: string, userId: string, user?: { __typename?: 'User', logo?: string | null, id: string, fullName?: string | null } | null } | null> } } | null };

export type StoragesQueryVariables = Exact<{ [key: string]: never; }>;


export type StoragesQuery = { __typename?: 'Query', storages?: { __typename?: 'StoragesConnection', totalCount: number, nodes: Array<{ __typename?: 'Storage', active: boolean, id: string, path: string, filename: string, fileOwner: StorageFileOwner, fileSize?: number | null, fileOwnerId: string, fileType: string, mimetype?: string | null, fileExtension: string, createdAt: Date | string, deleteAt?: Date | string | null, expireAt?: Date | string | null, remindAt?: Date | string | null, departments?: Array<string | null> | null, url?: string | null, html?: string | null, contractSignPendingDocumentId?: string | null, documentFolderId?: string | null, documentTemplateId?: string | null, placeholderValues?: any | null, documentTypeId?: string | null, owner?: any | null, employeeCasefileId?: string | null, contractSignPendingDocument?: { __typename?: 'ContractSignPendingDocument', id: string, fieldMappings?: any | null } | null, documentType?: { __typename?: 'DocumentType', id: string, name: string, localizedName?: string | null } | null, documentUserResponsiblesByFileId: { __typename?: 'DocumentUserResponsiblesConnection', edges: Array<{ __typename?: 'DocumentUserResponsiblesEdge', node?: { __typename?: 'DocumentUserResponsible', userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null }> } } | null>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type DocumentFolderBlueprintAffectedFilesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DocumentFolderBlueprintAffectedFilesQuery = { __typename?: 'Query', documentFolderBlueprintAffectedFiles?: { __typename?: 'DocumentFolderBlueprintDependant', numberOfEmployees?: string | number | null, numberOfFiles?: string | number | null } | null };

export type GetFolderByBlueprintAndEmployeeIdQueryVariables = Exact<{
  blueprintId: Scalars['UUID'];
  userId: Scalars['UUID'];
}>;


export type GetFolderByBlueprintAndEmployeeIdQuery = { __typename?: 'Query', documentFolders?: { __typename?: 'DocumentFoldersConnection', nodes: Array<{ __typename?: 'DocumentFolder', id: string } | null> } | null };

export type GetEmployeeQueryVariables = Exact<{
  graphileIdRequired: Scalars['UUID'];
}>;


export type GetEmployeeQuery = { __typename?: 'Query', employeeById?: { __typename?: 'Employee', id: string, userId: string, departments?: Array<string | null> | null, leaderDepartments?: Array<string | null> | null, isLeader: boolean, active: boolean, company?: { __typename?: 'Company', id: string, name?: string | null } | null, user?: { __typename?: 'User', id: string, locale?: string | null, firstName?: string | null, lastName?: string | null, alternateFirstName?: string | null, alternateLastName?: string | null, fullName?: string | null, birthdate?: Date | string | null, employmentStart?: Date | string | null, employmentEnd?: Date | string | null, companyAdmin: boolean, isSystemUser: boolean, canSignOnBehalfOf?: boolean | null, cpr?: string | null, bankRegistrationNumber?: string | null, bankAccountNumber?: string | null, country?: string | null, jobPositionTitle?: string | null, jobPositionType?: string | null, jobPositionWorkingHours?: string | null, jobPositionDescription?: string | null, initialsLogo?: string | null, logo?: string | null, hasLogo?: boolean | null, isFuture?: boolean | null, isResigned?: boolean | null, canLogin: boolean, canLoginApp: boolean, canLoginSso: boolean, godmode: boolean, employeeNumber?: string | number | null, email?: string | null, emailWork?: string | null, phone?: string | null, mobile?: string | null, mobilePrivate?: string | null, address?: string | null, city?: string | null, postalCode?: string | number | null, userGroups: { __typename?: 'UserGroupsConnection', nodes: Array<{ __typename?: 'UserGroup', groupId: string } | null> }, userDepartments: { __typename?: 'UserDepartmentsConnection', edges: Array<{ __typename?: 'UserDepartmentsEdge', node?: { __typename?: 'UserDepartment', departmentId: string, rankId?: string | null, rank?: { __typename?: 'Rank', id: string, name: string } | null, department?: { __typename?: 'Department', id: string, name: string, address: string, postalCode: string, city: string, phone: string, email: string, cvr?: string | null, departmentType?: { __typename: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null } | null }> }, directManager?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null } | null };

export type EmployeeQueryQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type EmployeeQueryQuery = { __typename?: 'Query', employeeById?: { __typename?: 'Employee', id: string, departments?: Array<string | null> | null, isArchived: boolean, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', edges: Array<{ __typename?: 'FormFieldEntriesEdge', node?: { __typename?: 'FormFieldEntry', id: string, value?: string | null, humanReadableValue?: string | null, formFieldId: string, employeeId?: string | null, productId?: string | null, active: boolean } | null }> }, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, initials?: string | null, alternateFirstName?: string | null, alternateLastName?: string | null, fullName?: string | null, email?: string | null, emailWork?: string | null, mobile?: string | null, phone?: string | null, employmentStart?: Date | string | null, employmentEnd?: Date | string | null, seniority?: Date | string | null, employeeNumber?: string | number | null, employmentJurisdiction?: string | null, birthdate?: Date | string | null, address?: string | null, postalCode?: string | number | null, city?: string | null, country?: string | null, mobilePrivate?: string | null, locale?: string | null, cpr?: string | null, bankRegistrationNumber?: string | null, bankAccountNumber?: string | null, logo?: string | null, hasLogo?: boolean | null, jobPositionTitle?: string | null, jobPositionType?: string | null, jobPositionWorkingHours?: string | null, jobPositionDescription?: string | null, directManager?: { __typename?: 'User', id: string, employeeId?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null } | null, userDepartments: { __typename?: 'UserDepartmentsConnection', nodes: Array<{ __typename?: 'UserDepartment', departmentId: string, department?: { __typename?: 'Department', id: string, name: string } | null } | null> } } | null } | null };

export type GetEmployeeEquipmentQueryVariables = Exact<{
  id: Scalars['UUID'];
  filter?: InputMaybe<EquipmentFilter>;
  orderBy?: InputMaybe<Array<EquipmentOrderBy> | EquipmentOrderBy>;
}>;


export type GetEmployeeEquipmentQuery = { __typename?: 'Query', employeeById?: { __typename?: 'Employee', id: string, userId: string, equipments: { __typename?: 'EquipmentConnection', edges: Array<{ __typename?: 'EquipmentEdge', node?: { __typename?: 'Equipment', id: string, startDate?: Date | string | null, createdAt: Date | string, product?: { __typename?: 'Product', id: string, name: string, description?: string | null, serial?: string | null, productTypeId: string, productType?: { __typename?: 'ProductType', id: string, name: string, localizedName?: string | null } | null, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> }, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', value?: string | null, formFieldId: string, formField?: { __typename?: 'FormField', fieldType?: string | null, metadata?: any | null, productTypeIds?: Array<string | null> | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string } | null> } } | null } | null> } } | null } | null }> } } | null };

export type EmployeeTasksQueryVariables = Exact<{
  filter?: InputMaybe<TaskFilter>;
  after?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  includeRelations: Scalars['Boolean'];
}>;


export type EmployeeTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TasksConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'TasksEdge', node?: { __typename?: 'Task', id: string, name: string, order?: number | null, startDate: Date | string, endDate: Date | string, deadlineReminderDate?: Date | string | null, notes?: string | null, projectId?: string | null, processId?: string | null, parentTaskId?: string | null, completed: boolean, archived: boolean, calendarEventFrom?: Date | string | null, calendarEventTo?: Date | string | null, calendarEventOrganizerId?: string | null, departments?: Array<string | null> | null, userIds?: Array<string | null> | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean, processTypeId?: string | null } | null, project?: { __typename?: 'Project', id: string, name: string, order?: number | null, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, parentTask?: { __typename?: 'Task', id: string, name: string, projectId?: string | null, processId?: string | null, startDate: Date | string, endDate: Date | string } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskResponsibles: { __typename?: 'TaskResponsiblesConnection', nodes: Array<{ __typename?: 'TaskResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskEmployees: { __typename?: 'TaskEmployeesConnection', nodes: Array<{ __typename?: 'TaskEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null }> } | null };

export type GetBulkEditEmployeeValuesQueryVariables = Exact<{
  formFieldIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  userIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  systemFieldNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetBulkEditEmployeeValuesQuery = { __typename?: 'Query', formFields?: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null> } | null, departments?: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> } | null, users?: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null> } | null, systemFields?: { __typename?: 'SystemFieldsConnection', nodes: Array<{ __typename?: 'SystemField', id: string, name: string, companySystemField?: { __typename?: 'CompanySystemField', id: string, companySystemFieldOptions: { __typename?: 'CompanySystemFieldOptionsConnection', nodes: Array<{ __typename?: 'CompanySystemFieldOption', id: string, value: string, localizedValue?: string | null } | null> } } | null } | null> } | null };

export type TryGetEmployeeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TryGetEmployeeQuery = { __typename?: 'Query', employeeById?: { __typename?: 'Employee', id: string } | null };

export type LoggedInEmployeeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type LoggedInEmployeeQuery = { __typename?: 'Query', userById?: { __typename?: 'User', id: string, employeeId?: string | null, locale?: string | null, logo?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, email?: string | null, phone?: string | null, mobile?: string | null, address?: string | null, city?: string | null, birthdate?: Date | string | null, cpr?: string | null, bankAccountNumber?: string | null, bankRegistrationNumber?: string | null, companyAdmin: boolean, jobPositionTitle?: string | null, jobPositionType?: string | null, departments?: Array<string | null> | null, company?: { __typename?: 'Company', id: string, name?: string | null, locale?: string | null, logo?: string | null, sso?: string | null, availableLocales?: Array<string | null> | null, nativeAppAccess?: boolean | null } | null } | null };

export type EmployeeCaseFilesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<EmployeeCasefilesOrderBy> | EmployeeCasefilesOrderBy>;
  filter?: InputMaybe<EmployeeCasefileFilter>;
}>;


export type EmployeeCaseFilesQuery = { __typename?: 'Query', employeeCasefiles?: { __typename?: 'EmployeeCasefilesConnection', totalCount: number, edges: Array<{ __typename?: 'EmployeeCasefilesEdge', node?: { __typename?: 'EmployeeCasefile', casefileId: number, employeeId: string, title?: string | null, status?: string | null, expireAt?: number | null, signers?: any | null, recipients?: any | null, documents?: any | null, createdAt?: Date | string | null, id: number, documentType?: { __typename?: 'DocumentType', id: string, name?: string | null } | null, employeeSigners: { __typename?: 'EmployeesConnection', nodes: Array<{ __typename?: 'Employee', id: string, departments?: Array<string | null> | null, user?: { __typename?: 'User', id: string, logo?: string | null, email?: string | null } | null } | null> }, user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, email?: string | null, fullName?: string | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type EmployeeCaseFilesSearchQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<EmployeeCasefilesOrderBy> | EmployeeCasefilesOrderBy>;
  filter?: InputMaybe<EmployeeCasefileFilter>;
  argSearchString?: InputMaybe<Scalars['String']>;
}>;


export type EmployeeCaseFilesSearchQuery = { __typename?: 'Query', employeeCasefilesSearch?: { __typename?: 'EmployeeCasefilesConnection', totalCount: number, edges: Array<{ __typename?: 'EmployeeCasefilesEdge', node?: { __typename?: 'EmployeeCasefile', casefileId: number, employeeId: string, title?: string | null, status?: string | null, expireAt?: number | null, signers?: any | null, recipients?: any | null, documents?: any | null, createdAt?: Date | string | null, id: number, documentType?: { __typename?: 'DocumentType', id: string, name?: string | null } | null, employeeSigners: { __typename?: 'EmployeesConnection', nodes: Array<{ __typename?: 'Employee', id: string, departments?: Array<string | null> | null, user?: { __typename?: 'User', id: string, logo?: string | null, email?: string | null } | null } | null> }, user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, email?: string | null, fullName?: string | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type EmployeeCasefileByEmployeeIdAndCasefileIdQueryVariables = Exact<{
  employeeId: Scalars['UUID'];
  casefileId: Scalars['Int'];
}>;


export type EmployeeCasefileByEmployeeIdAndCasefileIdQuery = { __typename?: 'Query', employeeCasefileByEmployeeIdAndCasefileId?: { __typename?: 'EmployeeCasefile', documentTypeId?: string | null } | null };

export type UnsignedCasefilesQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type UnsignedCasefilesQuery = { __typename?: 'Query', unsignedCasefiles?: { __typename?: 'EmployeeCasefilesConnection', edges: Array<{ __typename?: 'EmployeeCasefilesEdge', node?: { __typename?: 'EmployeeCasefile', casefileId: number, employeeId: string, status?: string | null, title?: string | null, signers?: any | null, documents?: any | null, employeeSigners: { __typename?: 'EmployeesConnection', nodes: Array<{ __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, email?: string | null } | null } | null> }, user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, email?: string | null, fullName?: string | null } | null } | null }> } | null, contractSignPendings?: { __typename?: 'ContractSignPendingsConnection', edges: Array<{ __typename?: 'ContractSignPendingsEdge', node?: { __typename?: 'ContractSignPending', id: string, enforceSignOrder: boolean, contractSignPendingDocuments: { __typename?: 'ContractSignPendingDocumentsConnection', nodes: Array<{ __typename?: 'ContractSignPendingDocument', id: string, contractTemplateId?: string | null, placeholderValues?: any | null, contractName: string, documentTypeId?: string | null, existingStorageId?: string | null, fieldMappings?: any | null, documentType?: { __typename?: 'DocumentType', id: string, localizedName?: string | null } | null, contractTemplate?: { __typename?: 'ContractTemplate', id: string, html?: string | null, header?: string | null, footer?: string | null, dateFormat: string, locale: string, documentType?: { __typename?: 'DocumentType', id: string } | null } | null } | null> }, contractSignPendingSigners: { __typename?: 'ContractSignPendingSignersConnection', nodes: Array<{ __typename?: 'ContractSignPendingSigner', signatureImage?: string | null, useSecondaryEmail: boolean, onBehalfOfUserId?: string | null, signOrder: number, id: string, contractSignPendingId: string, signed: boolean, signDate?: Date | string | null, signatureFileId?: string | null, userId: string, createdAt: Date | string, refused: boolean, refusalReason?: string | null, contractSignPending?: { __typename?: 'ContractSignPending', id: string, signDate?: Date | string | null } | null, user?: { __typename?: 'User', id: string, logo?: string | null, email?: string | null, emailWork?: string | null, fullName?: string | null } | null, onBehalfOfUser?: { __typename?: 'User', id: string, logo?: string | null, email?: string | null, fullName?: string | null } | null } | null> }, user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, email?: string | null, fullName?: string | null } | null } | null }> } | null };

export type EmployeesSearchSuggestionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']>;
  searchQuery: Scalars['String'];
  companyId: Scalars['UUID'];
  and?: InputMaybe<Array<UserFilter> | UserFilter>;
}>;


export type EmployeesSearchSuggestionsQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', edges: Array<{ __typename?: 'UsersEdge', node?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type AllEployeesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<EmployeeFilter>;
  orderBy?: InputMaybe<Array<EmployeesOrderBy> | EmployeesOrderBy>;
  after?: InputMaybe<Scalars['Cursor']>;
}>;


export type AllEployeesQuery = { __typename?: 'Query', employees?: { __typename?: 'EmployeesConnection', totalCount: number, edges: Array<{ __typename?: 'EmployeesEdge', node?: { __typename?: 'Employee', id: string, userId: string, user?: { __typename?: 'User', id: string, logo?: string | null, locale?: string | null, fullName?: string | null, email?: string | null, emailWork?: string | null, userDepartments: { __typename?: 'UserDepartmentsConnection', edges: Array<{ __typename?: 'UserDepartmentsEdge', node?: { __typename?: 'UserDepartment', departmentId: string, rankId?: string | null, department?: { __typename?: 'Department', id: string, name: string } | null } | null }> } } | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type EmployeesPageQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<UsersOrderBy> | UsersOrderBy>;
  filter?: InputMaybe<UserFilter>;
  companyId?: InputMaybe<Scalars['UUID']>;
  systemFieldColumnNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  formFieldColumnIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  includeArchived?: InputMaybe<IncludeArchivedOption>;
  includeOngoingProcesses: Scalars['Boolean'];
  includeFinishedProcesses: Scalars['Boolean'];
  includeOngoingPreboardings: Scalars['Boolean'];
  includeFinishedPreboardings: Scalars['Boolean'];
  includeDepartments: Scalars['Boolean'];
  includeGroups: Scalars['Boolean'];
  includeCompetences: Scalars['Boolean'];
  includeLatestTimeRegistrationTemplate: Scalars['Boolean'];
}>;


export type EmployeesPageQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', edges: Array<{ __typename?: 'UsersEdge', node?: { __typename?: 'User', id: string, isArchived?: boolean | null, isLeader: boolean, departments?: Array<string | null> | null, leaderDepartments?: Array<string | null> | null, latestTimeRegistrationTemplate?: string | null, firstName?: string | null, lastName?: string | null, alternateFirstName?: string | null, alternateLastName?: string | null, userSystemFields: { __typename?: 'UserSystemFieldsConnection', nodes: Array<{ __typename?: 'UserSystemField', data?: any | null, humanReadableValue?: string | null, systemFieldId: string, systemField?: { __typename?: 'SystemField', id: string, name: string } | null } | null> }, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, value?: string | null, formFieldId: string, employeeId?: string | null, productId?: string | null, active: boolean, formField?: { __typename?: 'FormField', id: string, sensitive?: boolean | null, supportsFutureData: boolean, changesMustBeApproved: boolean } | null } | null> }, futureData: { __typename?: 'FutureDataConnection', nodes: Array<{ __typename?: 'FutureDatum', id: string, systemFieldId?: string | null, formFieldId?: string | null, formFieldEntryId?: string | null, userId: string, updateValueAt?: Date | string | null, createdAt: Date | string, value: any, previousHumanReadableValue?: string | null, humanReadableValue?: string | null, approvalIsRequired?: boolean | null, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, approvalId?: string | null, creatorUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null, formField?: { __typename?: 'FormField', id: string, localizedName?: string | null, sensitive?: boolean | null } | null, systemField?: { __typename?: 'SystemField', id: string, readableName?: string | null, companySystemField?: { __typename?: 'CompanySystemField', id: string, sensitive: boolean } | null } | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null> }, employeeByUserId?: { __typename?: 'Employee', id: string, ongoingProcesses: { __typename?: 'ProcessesConnection', totalCount: number, nodes: Array<{ __typename?: 'Process', id: string, name?: string | null, progress?: string | number | null } | null> }, finishedProcesses: { __typename?: 'ProcessesConnection', totalCount: number, nodes: Array<{ __typename?: 'Process', id: string, name?: string | null, progress?: string | number | null } | null> }, ongoingPreboardings: { __typename?: 'PreboardingEmployeesConnection', totalCount: number, nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, published: boolean, completed: boolean, preboarding?: { __typename?: 'Preboarding', id: string, name?: string | null } | null } | null> }, finishedPreboardings: { __typename?: 'PreboardingEmployeesConnection', totalCount: number, nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, published: boolean, completed: boolean, preboarding?: { __typename?: 'Preboarding', id: string, name?: string | null } | null } | null> } } | null, userDepartments?: { __typename?: 'UserDepartmentsConnection', edges: Array<{ __typename?: 'UserDepartmentsEdge', node?: { __typename?: 'UserDepartment', departmentId: string, rankId?: string | null, rank?: { __typename?: 'Rank', id: string, name: string } | null, department?: { __typename?: 'Department', id: string, name: string, departmentType?: { __typename?: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null } | null }> }, userGroups?: { __typename?: 'UserGroupsConnection', edges: Array<{ __typename?: 'UserGroupsEdge', node?: { __typename?: 'UserGroup', group?: { __typename?: 'Group', id: string, description?: string | null, scope?: RoleScope | null, name?: string | null, localizedName?: string | null } | null } | null }> }, userDepartmentGroups?: { __typename?: 'UserDepartmentGroupsConnection', edges: Array<{ __typename?: 'UserDepartmentGroupsEdge', node?: { __typename?: 'UserDepartmentGroup', group?: { __typename?: 'Group', id: string, description?: string | null, scope?: RoleScope | null, name?: string | null, localizedName?: string | null } | null, department?: { __typename?: 'Department', id: string, name: string } | null } | null }> }, userCompanyGroups?: { __typename?: 'UserCompanyGroupsConnection', edges: Array<{ __typename?: 'UserCompanyGroupsEdge', node?: { __typename?: 'UserCompanyGroup', group?: { __typename?: 'Group', id: string, description?: string | null, scope?: RoleScope | null, name?: string | null, localizedName?: string | null } | null } | null }> }, userCompetences?: { __typename?: 'UserCompetencesConnection', edges: Array<{ __typename?: 'UserCompetencesEdge', node?: { __typename?: 'UserCompetence', id: string, expireAt?: Date | string | null, userCompetenceEvaluations: { __typename?: 'UserCompetenceEvaluationsConnection', nodes: Array<{ __typename?: 'UserCompetenceEvaluation', id: string, nextUpdate?: Date | string | null, evaluatingUserId: string, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, value?: string | null } | null> } } | null> }, competence?: { __typename?: 'Competence', id: string, localizedName?: string | null, outdateCompetence: boolean, ratingFormField?: { __typename?: 'FormField', metadata?: any | null, fieldType?: string | null, localizedHelpText?: string | null } | null, competenceGroup?: { __typename?: 'CompetenceGroup', id: string, localizedName?: string | null } | null, reminderInterval: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null, months?: number | null, seconds?: number | null, years?: number | null } } | null } | null }> } } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type UsersPageTotalCountQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
  companyId?: InputMaybe<Scalars['UUID']>;
  includeArchived?: InputMaybe<IncludeArchivedOption>;
}>;


export type UsersPageTotalCountQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', totalCount: number } | null };

export type UsersSearchTotalCountQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
  companyId?: InputMaybe<Scalars['UUID']>;
  argSearchString?: InputMaybe<Scalars['String']>;
}>;


export type UsersSearchTotalCountQuery = { __typename?: 'Query', usersSearch?: { __typename?: 'UsersConnection', totalCount: number } | null };

export type EmployeesPageOldQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<EmployeesOrderBy> | EmployeesOrderBy>;
  filter?: InputMaybe<EmployeeFilter>;
  includeArchived?: InputMaybe<IncludeArchivedOption>;
  companyId?: InputMaybe<Scalars['UUID']>;
  formFieldColumnIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type EmployeesPageOldQuery = { __typename?: 'Query', employees?: { __typename?: 'EmployeesConnection', totalCount: number, edges: Array<{ __typename?: 'EmployeesEdge', node?: { __typename?: 'Employee', id: string, userId: string, isArchived: boolean, isLeader: boolean, departments?: Array<string | null> | null, leaderDepartments?: Array<string | null> | null, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, value?: string | null, formFieldId: string, employeeId?: string | null, productId?: string | null, active: boolean, formField?: { __typename?: 'FormField', sensitive?: boolean | null } | null } | null> }, user?: { __typename?: 'User', directManager?: { __typename?: 'User', id: string, fullName?: string | null } | null, userDepartments: { __typename?: 'UserDepartmentsConnection', edges: Array<{ __typename?: 'UserDepartmentsEdge', node?: { __typename?: 'UserDepartment', departmentId: string, rankId?: string | null, rank?: { __typename?: 'Rank', id: string, name: string } | null, department?: { __typename?: 'Department', id: string, name: string, departmentType?: { __typename?: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null } | null }> }, userGroups: { __typename?: 'UserGroupsConnection', edges: Array<{ __typename?: 'UserGroupsEdge', node?: { __typename?: 'UserGroup', group?: { __typename?: 'Group', id: string, description?: string | null, scope?: RoleScope | null, name?: string | null, localizedName?: string | null } | null } | null }> }, userDepartmentGroups: { __typename?: 'UserDepartmentGroupsConnection', edges: Array<{ __typename?: 'UserDepartmentGroupsEdge', node?: { __typename?: 'UserDepartmentGroup', group?: { __typename?: 'Group', id: string, description?: string | null, scope?: RoleScope | null, name?: string | null, localizedName?: string | null } | null, department?: { __typename?: 'Department', id: string, name: string } | null } | null }> }, userCompanyGroups: { __typename?: 'UserCompanyGroupsConnection', edges: Array<{ __typename?: 'UserCompanyGroupsEdge', node?: { __typename?: 'UserCompanyGroup', group?: { __typename?: 'Group', id: string, description?: string | null, scope?: RoleScope | null, name?: string | null, localizedName?: string | null } | null } | null }> }, userCompetences: { __typename?: 'UserCompetencesConnection', edges: Array<{ __typename?: 'UserCompetencesEdge', node?: { __typename?: 'UserCompetence', competence?: { __typename?: 'Competence', id: string, localizedName?: string | null, competenceGroup?: { __typename?: 'CompetenceGroup', id: string, localizedName?: string | null } | null } | null } | null }> } } | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null, systemFields?: { __typename?: 'SystemFieldsConnection', edges: Array<{ __typename?: 'SystemFieldsEdge', node?: { __typename?: 'SystemField', id: string, name: string, companySystemField?: { __typename?: 'CompanySystemField', id: string, sensitive: boolean, required: boolean, fieldGroupId?: string | null, companySystemFieldOptions: { __typename?: 'CompanySystemFieldOptionsConnection', nodes: Array<{ __typename?: 'CompanySystemFieldOption', id: string, value?: string | null } | null> } } | null } | null }> } | null };

export type EmployeesSearchQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<UsersOrderBy> | UsersOrderBy>;
  filter?: InputMaybe<UserFilter>;
  argSearchString?: InputMaybe<Scalars['String']>;
  argFormFieldId?: InputMaybe<Scalars['UUID']>;
  argOrderDirection?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  systemFieldColumnNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  formFieldColumnIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  includeOngoingProcesses: Scalars['Boolean'];
  includeFinishedProcesses: Scalars['Boolean'];
  includeOngoingPreboardings: Scalars['Boolean'];
  includeFinishedPreboardings: Scalars['Boolean'];
  includeDepartments: Scalars['Boolean'];
  includeGroups: Scalars['Boolean'];
  includeCompetences: Scalars['Boolean'];
  includeLatestTimeRegistrationTemplate: Scalars['Boolean'];
}>;


export type EmployeesSearchQuery = { __typename?: 'Query', usersSearch?: { __typename?: 'UsersConnection', totalCount: number, edges: Array<{ __typename?: 'UsersEdge', node?: { __typename?: 'User', id: string, isArchived?: boolean | null, isLeader: boolean, departments?: Array<string | null> | null, latestTimeRegistrationTemplate?: string | null, firstName?: string | null, lastName?: string | null, alternateFirstName?: string | null, alternateLastName?: string | null, userSystemFields: { __typename?: 'UserSystemFieldsConnection', nodes: Array<{ __typename?: 'UserSystemField', data?: any | null, humanReadableValue?: string | null, systemFieldId: string, systemField?: { __typename?: 'SystemField', id: string, name: string } | null } | null> }, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, value?: string | null, formFieldId: string, employeeId?: string | null, productId?: string | null, active: boolean, formField?: { __typename?: 'FormField', id: string, sensitive?: boolean | null, supportsFutureData: boolean } | null } | null> }, futureData: { __typename?: 'FutureDataConnection', nodes: Array<{ __typename?: 'FutureDatum', id: string, systemFieldId?: string | null, formFieldId?: string | null, formFieldEntryId?: string | null, userId: string, updateValueAt?: Date | string | null, createdAt: Date | string, value: any, previousHumanReadableValue?: string | null, humanReadableValue?: string | null, approvalIsRequired?: boolean | null, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, approvalId?: string | null, creatorUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null, formField?: { __typename?: 'FormField', id: string, localizedName?: string | null, sensitive?: boolean | null } | null, systemField?: { __typename?: 'SystemField', id: string, readableName?: string | null, companySystemField?: { __typename?: 'CompanySystemField', id: string, sensitive: boolean } | null } | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null> }, employeeByUserId?: { __typename?: 'Employee', id: string, ongoingProcesses: { __typename?: 'ProcessesConnection', totalCount: number, nodes: Array<{ __typename?: 'Process', id: string, name?: string | null, progress?: string | number | null } | null> }, finishedProcesses: { __typename?: 'ProcessesConnection', totalCount: number, nodes: Array<{ __typename?: 'Process', id: string, name?: string | null, progress?: string | number | null } | null> }, ongoingPreboardings: { __typename?: 'PreboardingEmployeesConnection', totalCount: number, nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, published: boolean, completed: boolean, preboarding?: { __typename?: 'Preboarding', id: string, name?: string | null } | null } | null> }, finishedPreboardings: { __typename?: 'PreboardingEmployeesConnection', totalCount: number, nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, published: boolean, completed: boolean, preboarding?: { __typename?: 'Preboarding', id: string, name?: string | null } | null } | null> } } | null, userDepartments?: { __typename?: 'UserDepartmentsConnection', edges: Array<{ __typename?: 'UserDepartmentsEdge', node?: { __typename?: 'UserDepartment', departmentId: string, rankId?: string | null, rank?: { __typename?: 'Rank', id: string, name: string } | null, department?: { __typename?: 'Department', id: string, name: string, departmentType?: { __typename?: 'DepartmentType', id: string, name: string, localizedName?: string | null, color?: string | null, companyId: string, active: boolean } | null } | null } | null }> }, userGroups?: { __typename?: 'UserGroupsConnection', edges: Array<{ __typename?: 'UserGroupsEdge', node?: { __typename?: 'UserGroup', group?: { __typename?: 'Group', id: string, description?: string | null, scope?: RoleScope | null, name?: string | null, localizedName?: string | null } | null } | null }> }, userDepartmentGroups?: { __typename?: 'UserDepartmentGroupsConnection', edges: Array<{ __typename?: 'UserDepartmentGroupsEdge', node?: { __typename?: 'UserDepartmentGroup', group?: { __typename?: 'Group', id: string, description?: string | null, scope?: RoleScope | null, name?: string | null, localizedName?: string | null } | null, department?: { __typename?: 'Department', id: string, name: string } | null } | null }> }, userCompanyGroups?: { __typename?: 'UserCompanyGroupsConnection', edges: Array<{ __typename?: 'UserCompanyGroupsEdge', node?: { __typename?: 'UserCompanyGroup', group?: { __typename?: 'Group', id: string, description?: string | null, scope?: RoleScope | null, name?: string | null, localizedName?: string | null } | null } | null }> }, userCompetences?: { __typename?: 'UserCompetencesConnection', edges: Array<{ __typename?: 'UserCompetencesEdge', node?: { __typename?: 'UserCompetence', id: string, expireAt?: Date | string | null, userCompetenceEvaluations: { __typename?: 'UserCompetenceEvaluationsConnection', nodes: Array<{ __typename?: 'UserCompetenceEvaluation', id: string, nextUpdate?: Date | string | null, evaluatingUserId: string, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, value?: string | null } | null> } } | null> }, competence?: { __typename?: 'Competence', id: string, localizedName?: string | null, outdateCompetence: boolean, ratingFormField?: { __typename?: 'FormField', metadata?: any | null, fieldType?: string | null, localizedHelpText?: string | null } | null, competenceGroup?: { __typename?: 'CompetenceGroup', id: string, localizedName?: string | null } | null, reminderInterval: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null, months?: number | null, seconds?: number | null, years?: number | null } } | null } | null }> } } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type DirectManagerBasicInfoQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type DirectManagerBasicInfoQuery = { __typename?: 'Query', getDirectManagerBasicInfo?: { __typename?: 'GetDirectManagerBasicInfoConnection', nodes: Array<{ __typename?: 'GetDirectManagerBasicInfoRecord', id?: string | null, fullName?: string | null, logo?: string | null } | null> } | null };

export type UserDirectManagerBasicInfoQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type UserDirectManagerBasicInfoQuery = { __typename?: 'Query', getUserDirectManagerBasicInfo?: { __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null };

export type EmployeeBasicInfoQueryVariables = Exact<{
  employeeIds: Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>;
}>;


export type EmployeeBasicInfoQuery = { __typename?: 'Query', getEmployeesBasicInfo?: { __typename?: 'GetEmployeesBasicInfoConnection', nodes: Array<{ __typename?: 'GetEmployeesBasicInfoRecord', id?: string | null, fullName?: string | null, logo?: string | null } | null> } | null };

export type EmployeesByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  first?: InputMaybe<Scalars['Int']>;
  departmentsFilter?: InputMaybe<UuidListFilter>;
  orderBy?: InputMaybe<Array<EmployeesOrderBy> | EmployeesOrderBy>;
}>;


export type EmployeesByIdsQuery = { __typename?: 'Query', employees?: { __typename?: 'EmployeesConnection', totalCount: number, nodes: Array<{ __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null, mobilePrivate?: string | null, mobile?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, leaderDepartments?: Array<string | null> | null, departments?: Array<string | null> | null, userDepartments: { __typename?: 'UserDepartmentsConnection', edges: Array<{ __typename?: 'UserDepartmentsEdge', node?: { __typename?: 'UserDepartment', departmentId: string } | null }> } } | null } | null> } | null };

export type EmployeeByUserIdQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type EmployeeByUserIdQuery = { __typename?: 'Query', employees?: { __typename?: 'EmployeesConnection', totalCount: number, nodes: Array<{ __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null, mobilePrivate?: string | null, mobile?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, userDepartments: { __typename?: 'UserDepartmentsConnection', edges: Array<{ __typename?: 'UserDepartmentsEdge', node?: { __typename?: 'UserDepartment', departmentId: string } | null }> } } | null } | null> } | null };

export type EmployeesFilterQueryVariables = Exact<{
  companyId: Scalars['UUID'];
}>;


export type EmployeesFilterQuery = { __typename?: 'Query', employees?: { __typename?: 'EmployeesConnection', edges: Array<{ __typename?: 'EmployeesEdge', node?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null }> } | null };

export type EmployeesDownloadImportFileQueryVariables = Exact<{
  delimiter: Scalars['String'];
  onlyIncludeRequiredFields?: InputMaybe<Scalars['Boolean']>;
}>;


export type EmployeesDownloadImportFileQuery = { __typename?: 'Query', DownloadEmployeesFile?: { __typename?: 'DownloadEmployeesFilePayload', file: string } | null };

export type EmployeesAnalyseImportFileQueryVariables = Exact<{
  file: Scalars['Upload'];
  mappings: Array<CsvMappingInput> | CsvMappingInput;
  useDefaultCustomFieldValues?: InputMaybe<Scalars['Boolean']>;
  delimiter?: InputMaybe<Scalars['String']>;
}>;


export type EmployeesAnalyseImportFileQuery = { __typename?: 'Query', AnalyseImportEmployeesFromFile?: { __typename?: 'AnalyseImportEmployeesFromFilePayload', errors: Array<{ __typename?: 'ErrorMessage', value?: any | null, type?: string | null, name?: string | null, messageCode?: string | null, id?: string | null }> } | null };

export type EmployeeDepartmentsQueryVariables = Exact<{
  ids: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type EmployeeDepartmentsQuery = { __typename?: 'Query', employees?: { __typename?: 'EmployeesConnection', nodes: Array<{ __typename?: 'Employee', id: string, departments?: Array<string | null> | null, user?: { __typename?: 'User', directManager?: { __typename?: 'User', employeeId?: string | null } | null } | null } | null> } | null };

export type GetEmployeeCsvFieldMappingQueryVariables = Exact<{
  csvFile: Scalars['Upload'];
  delimiter?: InputMaybe<Scalars['String']>;
}>;


export type GetEmployeeCsvFieldMappingQuery = { __typename?: 'Query', getEmployeeCsvFieldMapping?: { __typename?: 'GetEmployeeCsvFieldMappingPayload', mappings?: Array<{ __typename?: 'CsvMapping', columnName?: string | null, fieldType?: FieldType | null, fieldId?: string | null, fieldName?: string | null, options?: Array<{ __typename?: 'FieldMappingOption', fieldType?: FieldType | null, fieldId?: string | null, fieldName?: string | null } | null> | null } | null> | null } | null };

export type AnalyseCsvEmployeeUpdateFileQueryVariables = Exact<{
  csvFile: Scalars['Upload'];
  mappings: Array<CsvMappingInput> | CsvMappingInput;
  clearFieldValuesWhenEmpty?: InputMaybe<Scalars['Boolean']>;
  delimiter?: InputMaybe<Scalars['String']>;
}>;


export type AnalyseCsvEmployeeUpdateFileQuery = { __typename?: 'Query', analyseCsvEmployeeUpdateFile?: { __typename?: 'AnalyseCsvEmployeeUpdateFilePayload', errors: Array<{ __typename?: 'ErrorMessage', id?: string | null, name?: string | null, value?: any | null, messageCode?: string | null, type?: string | null }> } | null };

export type DownloadEmployeeRecordUpdateTemplateQueryVariables = Exact<{
  employeeRecordFieldId: Scalars['UUID'];
  delimiter: Scalars['String'];
}>;


export type DownloadEmployeeRecordUpdateTemplateQuery = { __typename?: 'Query', downloadEmployeeRecordUpdateTemplate?: { __typename?: 'DownloadEmployeeRecordUpdateTemplatePayload', base64?: string | null } | null };

export type AnalyseCsvEmployeeRecordUpdateFileQueryVariables = Exact<{
  csvFile: Scalars['Upload'];
  employeeRecordFieldId: Scalars['UUID'];
  delimiter?: InputMaybe<Scalars['String']>;
}>;


export type AnalyseCsvEmployeeRecordUpdateFileQuery = { __typename?: 'Query', analyseCsvEmployeeRecordUpdateFile?: { __typename?: 'AnalyseCsvEmployeeRecordUpdateFilePayload', errors: Array<{ __typename?: 'ErrorMessage', id?: string | null, name?: string | null, value?: any | null, messageCode?: string | null, type?: string | null }> } | null };

export type EmployeesByIdsWithDateFieldEntriesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  first?: InputMaybe<Scalars['Int']>;
  departmentsFilter?: InputMaybe<UuidListFilter>;
  orderBy?: InputMaybe<Array<EmployeesOrderBy> | EmployeesOrderBy>;
}>;


export type EmployeesByIdsWithDateFieldEntriesQuery = { __typename?: 'Query', employees?: { __typename?: 'EmployeesConnection', totalCount: number, nodes: Array<{ __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null, mobilePrivate?: string | null, mobile?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, employmentEnd?: Date | string | null, employmentStart?: Date | string | null, userDepartments: { __typename?: 'UserDepartmentsConnection', edges: Array<{ __typename?: 'UserDepartmentsEdge', node?: { __typename?: 'UserDepartment', departmentId: string } | null }> } } | null, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, value?: string | null, formField?: { __typename?: 'FormField', id: string, localizedName?: string | null, defaultValue?: string | null } | null } | null> } } | null> } | null };

export type AllUserIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUserIdsQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: string } | null> } | null };

export type UsersTotalCountByGroupIdsAndDepartmentIdsQueryVariables = Exact<{
  groupIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  departmentIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  employeeIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type UsersTotalCountByGroupIdsAndDepartmentIdsQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', totalCount: number } | null };

export type AllEngagementTypesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<EngagementTypesOrderBy> | EngagementTypesOrderBy>;
  filter?: InputMaybe<EngagementTypeFilter>;
}>;


export type AllEngagementTypesQuery = { __typename?: 'Query', engagementTypes?: { __typename?: 'EngagementTypesConnection', totalCount: number, edges: Array<{ __typename?: 'EngagementTypesEdge', node?: { __typename?: 'EngagementType', id: string, name: string, localizedName?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type EngagementTypeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type EngagementTypeQuery = { __typename?: 'Query', engagementTypeById?: { __typename?: 'EngagementType', id: string, name: string } | null };

export type GetProductsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy> | ProductsOrderBy>;
  filter?: InputMaybe<ProductFilter>;
}>;


export type GetProductsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductsConnection', totalCount: number, edges: Array<{ __typename?: 'ProductsEdge', node?: { __typename?: 'Product', id: string, name: string, description?: string | null, serial?: string | null, purchaseDate?: Date | string | null, acquisitionDate?: Date | string | null, companyId: string, departmentId?: string | null, userId?: string | null, createdAt: Date | string, updatedAt: Date | string, active: boolean, productTypeId: string, assignedUserDepartments?: Array<string | null> | null, assignedUserId?: string | null, occupiedBy?: string | null, occupiedByEmployeeId?: string | null, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, path: string, filename: string, fileOwner: StorageFileOwner, fileOwnerId: string, mimetype?: string | null, fileExtension: string, createdAt: Date | string, deleteAt?: Date | string | null, expireAt?: Date | string | null, remindAt?: Date | string | null } | null> }, department?: { __typename?: 'Department', id: string, name: string } | null, occupiedByDepartments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, equipments: { __typename?: 'EquipmentConnection', edges: Array<{ __typename?: 'EquipmentEdge', node?: { __typename?: 'Equipment', id: string, productId: string, employeeId: string, startDate?: Date | string | null, endDate?: Date | string | null, departments?: Array<string | null> | null, employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null }> }, productType?: { __typename?: 'ProductType', id: string, name: string, localizedName?: string | null } | null, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', value?: string | null, formFieldId: string, formField?: { __typename?: 'FormField', fieldType?: string | null, metadata?: any | null, productTypeIds?: Array<string | null> | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string } | null> } } | null } | null> } } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type ProductDropdownQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy> | ProductsOrderBy>;
  filter?: InputMaybe<ProductFilter>;
}>;


export type ProductDropdownQueryQuery = { __typename?: 'Query', products?: { __typename?: 'ProductsConnection', edges: Array<{ __typename?: 'ProductsEdge', node?: { __typename?: 'Product', id: string, name: string, assignedUserId?: string | null, serial?: string | null, productTypeId: string } | null }> } | null };

export type GetProductsFormFieldSortQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy> | ProductsOrderBy>;
  filter?: InputMaybe<ProductFilter>;
  argFormFieldId?: InputMaybe<Scalars['UUID']>;
  argOrderDirection?: InputMaybe<Scalars['String']>;
}>;


export type GetProductsFormFieldSortQuery = { __typename?: 'Query', productsSortByFormField?: { __typename?: 'ProductsConnection', totalCount: number, edges: Array<{ __typename?: 'ProductsEdge', node?: { __typename?: 'Product', id: string, name: string, description?: string | null, serial?: string | null, purchaseDate?: Date | string | null, acquisitionDate?: Date | string | null, companyId: string, departmentId?: string | null, userId?: string | null, createdAt: Date | string, updatedAt: Date | string, active: boolean, productTypeId: string, assignedUserDepartments?: Array<string | null> | null, assignedUserId?: string | null, occupiedBy?: string | null, occupiedByEmployeeId?: string | null, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, path: string, filename: string, fileOwner: StorageFileOwner, fileOwnerId: string, mimetype?: string | null, fileExtension: string, createdAt: Date | string, deleteAt?: Date | string | null, expireAt?: Date | string | null, remindAt?: Date | string | null } | null> }, department?: { __typename?: 'Department', id: string, name: string } | null, occupiedByDepartments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, equipments: { __typename?: 'EquipmentConnection', edges: Array<{ __typename?: 'EquipmentEdge', node?: { __typename?: 'Equipment', id: string, productId: string, employeeId: string, startDate?: Date | string | null, endDate?: Date | string | null, departments?: Array<string | null> | null, employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null }> }, productType?: { __typename?: 'ProductType', id: string, name: string, localizedName?: string | null } | null, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', value?: string | null, formFieldId: string, formField?: { __typename?: 'FormField', fieldType?: string | null, metadata?: any | null, productTypeIds?: Array<string | null> | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string } | null> } } | null } | null> } } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type GetEquipmentQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetEquipmentQuery = { __typename?: 'Query', productById?: { __typename?: 'Product', id: string, name: string, description?: string | null, serial?: string | null, purchaseDate?: Date | string | null, acquisitionDate?: Date | string | null, companyId: string, departmentId?: string | null, userId?: string | null, createdAt: Date | string, updatedAt: Date | string, active: boolean, productTypeId: string, assignedUserDepartments?: Array<string | null> | null, assignedUserId?: string | null, occupiedBy?: string | null, occupiedByEmployeeId?: string | null, storages: { __typename?: 'StoragesConnection', edges: Array<{ __typename?: 'StoragesEdge', node?: { __typename?: 'Storage', id: string, path: string, filename: string, fileOwner: StorageFileOwner, fileOwnerId: string, mimetype?: string | null, fileExtension: string, createdAt: Date | string, deleteAt?: Date | string | null, expireAt?: Date | string | null, remindAt?: Date | string | null } | null }> }, department?: { __typename?: 'Department', id: string, name: string } | null, occupiedByDepartments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, equipments: { __typename?: 'EquipmentConnection', edges: Array<{ __typename?: 'EquipmentEdge', node?: { __typename?: 'Equipment', id: string, productId: string, employeeId: string, startDate?: Date | string | null, endDate?: Date | string | null, departments?: Array<string | null> | null, employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null }> }, productType?: { __typename?: 'ProductType', id: string, name: string, localizedName?: string | null } | null, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', value?: string | null, formFieldId: string, formField?: { __typename?: 'FormField', fieldType?: string | null, metadata?: any | null, productTypeIds?: Array<string | null> | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string } | null> } } | null } | null> } } | null };

export type EquipmentCustomFieldsQueryVariables = Exact<{
  condition?: InputMaybe<FormFieldEntryCondition>;
  includeEntry: Scalars['Boolean'];
}>;


export type EquipmentCustomFieldsQuery = { __typename?: 'Query', formFields?: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, companyId: string, objectType: string, fieldType?: string | null, name: string, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> }, formFieldEntries?: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, value?: string | null, humanReadableValue?: string | null, formFieldId: string, employeeId?: string | null, productId?: string | null, active: boolean } | null> } } | null> } | null };

export type GetEquipmentOwnersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEquipmentOwnersQuery = { __typename?: 'Query', getEquipmentOwners?: { __typename?: 'UsersConnection', edges: Array<{ __typename?: 'UsersEdge', node?: { __typename?: 'User', id: string, fullName?: string | null } | null }> } | null };

export type AllProductTypesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<ProductTypesOrderBy> | ProductTypesOrderBy>;
  filter?: InputMaybe<ProductTypeFilter>;
}>;


export type AllProductTypesQuery = { __typename?: 'Query', productTypes?: { __typename?: 'ProductTypesConnection', totalCount: number, edges: Array<{ __typename?: 'ProductTypesEdge', node?: { __typename?: 'ProductType', id: string, name: string, localizedName?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type ProductTypeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProductTypeQuery = { __typename?: 'Query', productTypeById?: { __typename?: 'ProductType', id: string, name: string } | null };

export type EquipmentListAsExcelQueryVariables = Exact<{
  productIds: Array<Scalars['UUID']> | Scalars['UUID'];
  fields: Array<Scalars['String']> | Scalars['String'];
}>;


export type EquipmentListAsExcelQuery = { __typename?: 'Query', ExportEquipmentToExcel?: { __typename?: 'ExportEquipmentPayload', excelFile: string } | null };

export type GetEquipmentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<EquipmentOrderBy> | EquipmentOrderBy>;
  filter?: InputMaybe<EquipmentFilter>;
}>;


export type GetEquipmentsQuery = { __typename?: 'Query', equipments?: { __typename?: 'EquipmentConnection', totalCount: number, edges: Array<{ __typename?: 'EquipmentEdge', node?: { __typename?: 'Equipment', id: string, productId: string, employeeId: string, startDate?: Date | string | null, endDate?: Date | string | null, departments?: Array<string | null> | null, employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type EquipmentDownloadImportFileQueryVariables = Exact<{
  delimiter: Scalars['String'];
}>;


export type EquipmentDownloadImportFileQuery = { __typename?: 'Query', DownloadEquipmentFile?: { __typename?: 'DownloadEquipmentFilePayload', file: string } | null };

export type EquipmentAnalyseImportFileQueryVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type EquipmentAnalyseImportFileQuery = { __typename?: 'Query', AnalyseImportEquipmentFromFile?: { __typename?: 'AnalyseImportEquipmentFromFilePayload', errors: Array<{ __typename?: 'ErrorMessage', value?: any | null, type?: string | null, name?: string | null, messageCode?: string | null, id?: string | null }> } | null };

export type EquipmentHistoryQueryVariables = Exact<{
  productId: Scalars['UUID'];
  orderBy?: InputMaybe<Array<EquipmentOrderBy> | EquipmentOrderBy>;
}>;


export type EquipmentHistoryQuery = { __typename?: 'Query', productById?: { __typename?: 'Product', id: string, history: { __typename?: 'EquipmentConnection', totalCount: number, edges: Array<{ __typename?: 'EquipmentEdge', node?: { __typename?: 'Equipment', id: string, startDate?: Date | string | null, endDate?: Date | string | null, addedBy?: string | null, removedBy?: string | null, user?: { __typename?: 'User', fullName?: string | null, logo?: string | null } | null } | null }> } } | null };

export type EventsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventsOrderBy> | EventsOrderBy>;
  filter?: InputMaybe<EventFilter>;
  after?: InputMaybe<Scalars['Cursor']>;
}>;


export type EventsQuery = { __typename?: 'Query', events?: { __typename?: 'EventsConnection', totalCount: number, edges: Array<{ __typename?: 'EventsEdge', node?: { __typename?: 'Event', id: string, name: string, description: string, location: string, startDate: Date | string, deadline?: Date | string | null, image?: { __typename?: 'Storage', id: string, url?: string | null } | null, attendees: { __typename?: 'AttendeesConnection', nodes: Array<{ __typename?: 'Attendee', attending?: boolean | null } | null> }, organizers: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null> } } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type EventQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type EventQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, name: string, description: string, location: string, startDate: Date | string, deadline?: Date | string | null, organizerIds?: Array<string | null> | null, contactPersonIds?: Array<string | null> | null, invitedAll: boolean, invitedUserIds?: Array<string | null> | null, invitedDepartmentIds?: Array<string | null> | null, image?: { __typename?: 'Storage', id: string, url?: string | null } | null, formFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, name: string, fieldType?: string | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, value: string } | null> } } | null> } } | null };

export type EventWithAnswersQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type EventWithAnswersQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', id: string, name: string, description: string, location: string, startDate: Date | string, deadline?: Date | string | null, organizerIds?: Array<string | null> | null, contactPersonIds?: Array<string | null> | null, image?: { __typename?: 'Storage', id: string, url?: string | null } | null, attendees: { __typename?: 'AttendeesConnection', nodes: Array<{ __typename?: 'Attendee', id?: string | null, attending?: boolean | null } | null> }, formFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, name: string, fieldType?: string | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, value: string } | null> }, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, value?: string | null, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null> } } | null> } } | null };

export type AttendeesByEventIdQueryVariables = Exact<{
  id: Scalars['UUID'];
  search?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['Cursor']>;
  or?: InputMaybe<Array<AttendeeFilter> | AttendeeFilter>;
}>;


export type AttendeesByEventIdQuery = { __typename?: 'Query', attendeesByEventId?: { __typename?: 'AttendeesConnection', edges: Array<{ __typename?: 'AttendeesEdge', node?: { __typename?: 'Attendee', id?: string | null, fullName?: string | null, jobPositionTitle?: string | null, logo?: string | null, attending?: boolean | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type ExternalIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExternalIntegrationsQuery = { __typename?: 'Query', externalIntegrations?: { __typename?: 'ExternalIntegrationsConnection', nodes: Array<{ __typename?: 'ExternalIntegration', id: string, credentials?: any | null, config?: any | null, systemId?: number | null, externalCompanyId?: string | null, fieldMappings?: any | null, blacklistedFields?: any | null, whitelistedFields?: any | null, continuousSync?: boolean | null, title?: string | null, departmentId?: string | null, departmentInheritance?: boolean | null, active: boolean, system?: { __typename?: 'ExternalSystem', id: number, name: string } | null, integrableSystem?: { __typename?: 'IntegrableSystem', id: string, name: string, logo: string, description: string, homepageUrl: string, settingsUrl?: string | null } | null } | null> } | null };

export type GetZenegyTokensQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GetZenegyTokensQuery = { __typename?: 'Query', GetZenegyTokens?: { __typename?: 'JWT', accessToken: string, refreshToken?: string | null, externalCompanyId?: string | null } | null };

export type ValidateZenegyFieldsQueryVariables = Exact<{
  input: Array<InputMaybe<Scalars['JSON']>> | InputMaybe<Scalars['JSON']>;
}>;


export type ValidateZenegyFieldsQuery = { __typename?: 'Query', validateZenegyFields?: Array<string | null> | null };

export type IntegrationDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationDepartmentsQuery = { __typename?: 'Query', externalIntegrations?: { __typename?: 'ExternalIntegrationsConnection', nodes: Array<{ __typename?: 'ExternalIntegration', departmentId?: string | null } | null> } | null };

export type IntegrationDocumentOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationDocumentOptionsQuery = { __typename?: 'Query', documentFolderBlueprints?: { __typename?: 'DocumentFolderBlueprintsConnection', nodes: Array<{ __typename?: 'DocumentFolderBlueprint', id: string, name: string } | null> } | null, documentTypes?: { __typename?: 'DocumentTypesConnection', nodes: Array<{ __typename?: 'DocumentType', id: string, localizedName?: string | null } | null> } | null };

export type ZenegyIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type ZenegyIntegrationQuery = { __typename?: 'Query', externalIntegrations?: { __typename?: 'ExternalIntegrationsConnection', nodes: Array<{ __typename?: 'ExternalIntegration', id: string, externalCompanyId?: string | null, fieldMappings?: any | null, departmentId?: string | null, departmentInheritance?: boolean | null, title?: string | null, config?: any | null, blacklistedFields?: any | null, whitelistedFields?: any | null, continuousSync?: boolean | null, absenceSync?: boolean | null, absenceMappings?: any | null, payslipDocumentBlueprintFolder?: { __typename?: 'DocumentFolderBlueprint', id: string, name: string } | null, payslipDocumentType?: { __typename?: 'DocumentType', id: string, localizedName?: string | null } | null, employeeExternalIntegrations: { __typename?: 'EmployeeExternalIntegrationsConnection', totalCount: number, nodes: Array<{ __typename?: 'EmployeeExternalIntegration', employee?: { __typename?: 'Employee', user?: { __typename?: 'User', id: string, fullName?: string | null, email?: string | null, logo?: string | null } | null } | null } | null> } } | null> } | null };

export type FieldGroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<FieldGroupFilter>;
}>;


export type FieldGroupsQuery = { __typename?: 'Query', fieldGroups?: { __typename?: 'FieldGroupsConnection', edges: Array<{ __typename?: 'FieldGroupsEdge', node?: { __typename?: 'FieldGroup', id: string, name: string, localizedName?: string | null, order: number, active: boolean, companyId: string, recordFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, excludedRoleIds?: Array<string | null> | null } | null> }, fieldGroupCards: { __typename?: 'FieldGroupCardsConnection', nodes: Array<{ __typename?: 'FieldGroupCard', id: string, name?: string | null, localizedName?: string | null, description?: string | null, columns: number, fieldGroupId: string, fieldGroupCardColumns: { __typename?: 'FieldGroupCardColumnsConnection', nodes: Array<{ __typename?: 'FieldGroupCardColumn', id: string, name?: string | null, localizedName?: string | null, formFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, excludedRoleIds?: Array<string | null> | null } | null> }, companySystemFields: { __typename?: 'CompanySystemFieldsConnection', nodes: Array<{ __typename?: 'CompanySystemField', id: string, systemFieldId: string, excludedRoleIds?: Array<string | null> | null } | null> } } | null> } } | null> } } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type FieldGroupQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type FieldGroupQuery = { __typename?: 'Query', fieldGroupById?: { __typename?: 'FieldGroup', id: string, name: string, localizedName?: string | null, order: number, active: boolean, companyId: string, recordFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, excludedRoleIds?: Array<string | null> | null } | null> }, fieldGroupCards: { __typename?: 'FieldGroupCardsConnection', nodes: Array<{ __typename?: 'FieldGroupCard', id: string, name?: string | null, localizedName?: string | null, description?: string | null, columns: number, fieldGroupId: string, fieldGroupCardColumns: { __typename?: 'FieldGroupCardColumnsConnection', nodes: Array<{ __typename?: 'FieldGroupCardColumn', id: string, name?: string | null, localizedName?: string | null, formFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, excludedRoleIds?: Array<string | null> | null } | null> }, companySystemFields: { __typename?: 'CompanySystemFieldsConnection', nodes: Array<{ __typename?: 'CompanySystemField', id: string, systemFieldId: string, excludedRoleIds?: Array<string | null> | null } | null> } } | null> } } | null> } } | null };

export type FieldGroupQueryQueryVariables = Exact<{
  id: Scalars['UUID'];
  userId?: InputMaybe<Scalars['UUID']>;
  getUserData: Scalars['Boolean'];
}>;


export type FieldGroupQueryQuery = { __typename?: 'Query', fieldGroupById?: { __typename?: 'FieldGroup', id: string, fieldGroupCards: { __typename?: 'FieldGroupCardsConnection', nodes: Array<{ __typename?: 'FieldGroupCard', id: string, fieldGroupId: string, name?: string | null, localizedName?: string | null, description?: string | null, localizedDescription?: string | null, columns: number, order: number, createdAt: Date | string, fieldGroupCardColumns: { __typename?: 'FieldGroupCardColumnsConnection', nodes: Array<{ __typename?: 'FieldGroupCardColumn', id: string, name?: string | null, localizedName?: string | null, formFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldGroupId?: string | null, order: number, name: string, localizedName?: string | null, localizedHelpText?: string | null, fieldType?: string | null, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, supportsFutureData: boolean, required: boolean, uniqueValue: boolean, excludedRoleIds?: Array<string | null> | null, metadata?: any | null, customId?: string | null, integrationFieldMarkings: { __typename?: 'IntegrationFieldMarkingsConnection', nodes: Array<{ __typename?: 'IntegrationFieldMarking', sendsData: boolean, receivesData: boolean, systemFieldId?: string | null, integrationName: string, authAppId?: string | null, formFieldId?: string | null, departmentIds?: Array<string | null> | null, externalIntegration?: { __typename?: 'ExternalIntegration', systemId?: number | null, departmentId?: string | null } | null, storage?: { __typename?: 'Storage', url?: string | null } | null } | null> }, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string } | null> }, formFieldEntries?: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, value?: string | null } | null> } } | null> }, companySystemFields: { __typename?: 'CompanySystemFieldsConnection', nodes: Array<{ __typename?: 'CompanySystemField', id: string, order: number, sensitive: boolean, changesMustBeApproved: boolean, supportsFutureData: boolean, excludedRoleIds?: Array<string | null> | null, required: boolean, systemFieldId: string, companySystemFieldOptions: { __typename?: 'CompanySystemFieldOptionsConnection', nodes: Array<{ __typename?: 'CompanySystemFieldOption', id: string, value: string, localizedValue?: string | null } | null> }, systemField?: { __typename?: 'SystemField', id: string, name: string, integrationFieldMarkings: { __typename?: 'IntegrationFieldMarkingsConnection', nodes: Array<{ __typename?: 'IntegrationFieldMarking', sendsData: boolean, receivesData: boolean, authAppId?: string | null, systemFieldId?: string | null, formFieldId?: string | null, integrationName: string, departmentIds?: Array<string | null> | null, externalIntegration?: { __typename?: 'ExternalIntegration', systemId?: number | null, departmentId?: string | null } | null, storage?: { __typename?: 'Storage', url?: string | null } | null } | null> }, userSystemFields?: { __typename?: 'UserSystemFieldsConnection', nodes: Array<{ __typename?: 'UserSystemField', data?: any | null } | null> } } | null } | null> } } | null> } } | null> }, formFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, localizedName?: string | null, order: number, createdAt: Date | string, excludedRoleIds?: Array<string | null> | null, metadata?: any | null, integrationFieldMarkings: { __typename?: 'IntegrationFieldMarkingsConnection', nodes: Array<{ __typename?: 'IntegrationFieldMarking', sendsData: boolean, receivesData: boolean, authAppId?: string | null, systemFieldId?: string | null, formFieldId?: string | null, integrationName: string, departmentIds?: Array<string | null> | null, externalIntegration?: { __typename?: 'ExternalIntegration', systemId?: number | null, departmentId?: string | null } | null, storage?: { __typename?: 'Storage', url?: string | null } | null } | null> }, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldEntries?: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, value?: string | null } | null> } } | null> } } | null };

export type FieldGroupCardQueryQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type FieldGroupCardQueryQuery = { __typename?: 'Query', fieldGroupCardById?: { __typename?: 'FieldGroupCard', id: string, fieldGroupId: string, name?: string | null, description?: string | null, active: boolean } | null };

export type AllFieldsQueryQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  getUserData: Scalars['Boolean'];
}>;


export type AllFieldsQueryQuery = { __typename?: 'Query', fieldGroups?: { __typename?: 'FieldGroupsConnection', nodes: Array<{ __typename?: 'FieldGroup', id: string, localizedName?: string | null, fieldGroupCards: { __typename?: 'FieldGroupCardsConnection', nodes: Array<{ __typename?: 'FieldGroupCard', id: string, fieldGroupId: string, name?: string | null, localizedName?: string | null, description?: string | null, localizedDescription?: string | null, columns: number, order: number, createdAt: Date | string, fieldGroupCardColumns: { __typename?: 'FieldGroupCardColumnsConnection', nodes: Array<{ __typename?: 'FieldGroupCardColumn', id: string, name?: string | null, localizedName?: string | null, formFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldGroupId?: string | null, order: number, name: string, localizedName?: string | null, localizedHelpText?: string | null, fieldType?: string | null, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, supportsFutureData: boolean, required: boolean, uniqueValue: boolean, excludedRoleIds?: Array<string | null> | null, metadata?: any | null, customId?: string | null, integrationFieldMarkings: { __typename?: 'IntegrationFieldMarkingsConnection', nodes: Array<{ __typename?: 'IntegrationFieldMarking', sendsData: boolean, receivesData: boolean, systemFieldId?: string | null, integrationName: string, authAppId?: string | null, formFieldId?: string | null, departmentIds?: Array<string | null> | null, externalIntegration?: { __typename?: 'ExternalIntegration', systemId?: number | null, departmentId?: string | null } | null, storage?: { __typename?: 'Storage', url?: string | null } | null } | null> }, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string } | null> }, formFieldEntries?: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, value?: string | null } | null> } } | null> }, companySystemFields: { __typename?: 'CompanySystemFieldsConnection', nodes: Array<{ __typename?: 'CompanySystemField', id: string, order: number, sensitive: boolean, changesMustBeApproved: boolean, supportsFutureData: boolean, excludedRoleIds?: Array<string | null> | null, required: boolean, systemFieldId: string, companySystemFieldOptions: { __typename?: 'CompanySystemFieldOptionsConnection', nodes: Array<{ __typename?: 'CompanySystemFieldOption', id: string, value: string, localizedValue?: string | null } | null> }, systemField?: { __typename?: 'SystemField', id: string, name: string, integrationFieldMarkings: { __typename?: 'IntegrationFieldMarkingsConnection', nodes: Array<{ __typename?: 'IntegrationFieldMarking', sendsData: boolean, receivesData: boolean, authAppId?: string | null, systemFieldId?: string | null, formFieldId?: string | null, integrationName: string, departmentIds?: Array<string | null> | null, externalIntegration?: { __typename?: 'ExternalIntegration', systemId?: number | null, departmentId?: string | null } | null, storage?: { __typename?: 'Storage', url?: string | null } | null } | null> }, userSystemFields?: { __typename?: 'UserSystemFieldsConnection', nodes: Array<{ __typename?: 'UserSystemField', data?: any | null } | null> } } | null } | null> } } | null> } } | null> } } | null> } | null };

export type RequiredFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type RequiredFieldsQuery = { __typename?: 'Query', fieldGroups?: { __typename?: 'FieldGroupsConnection', nodes: Array<{ __typename?: 'FieldGroup', id: string, localizedName?: string | null, companySystemFields: { __typename?: 'CompanySystemFieldsConnection', nodes: Array<{ __typename?: 'CompanySystemField', id: string, fieldGroupId?: string | null, required: boolean, order: number, cardOrder?: number | null, systemField?: { __typename?: 'SystemField', id: string, name: string, alwaysRequired: boolean } | null, companySystemFieldOptions: { __typename?: 'CompanySystemFieldOptionsConnection', nodes: Array<{ __typename?: 'CompanySystemFieldOption', id: string, value: string, localizedValue?: string | null } | null> } } | null> }, formFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldGroupId?: string | null, localizedName?: string | null, localizedHelpText?: string | null, fieldType?: string | null, required: boolean, order: number, cardOrder?: number | null, metadata?: any | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string } | null> } } | null> } } | null> } | null };

export type FieldGroupsAddEmployeeQueryVariables = Exact<{
  filter?: InputMaybe<FieldGroupFilter>;
}>;


export type FieldGroupsAddEmployeeQuery = { __typename?: 'Query', fieldGroups?: { __typename?: 'FieldGroupsConnection', nodes: Array<{ __typename?: 'FieldGroup', id: string, localizedName?: string | null, formFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldGroupId?: string | null, localizedName?: string | null, localizedHelpText?: string | null, fieldType?: string | null, defaultValue?: string | null, required: boolean, uniqueValue: boolean, metadata?: any | null, order: number, cardOrder?: number | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string } | null> }, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> } } | null> }, fieldGroupCards: { __typename?: 'FieldGroupCardsConnection', nodes: Array<{ __typename?: 'FieldGroupCard', id: string, fieldGroupId: string, localizedName?: string | null, localizedDescription?: string | null, order: number, fieldGroupCardColumns: { __typename?: 'FieldGroupCardColumnsConnection', nodes: Array<{ __typename?: 'FieldGroupCardColumn', companySystemFields: { __typename?: 'CompanySystemFieldsConnection', nodes: Array<{ __typename?: 'CompanySystemField', id: string, fieldGroupId?: string | null, order: number, cardOrder?: number | null, required: boolean, systemField?: { __typename?: 'SystemField', id: string, name: string, alwaysRequired: boolean } | null, companySystemFieldOptions: { __typename?: 'CompanySystemFieldOptionsConnection', nodes: Array<{ __typename?: 'CompanySystemFieldOption', id: string, value: string, localizedValue?: string | null } | null> } } | null> }, formFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldGroupId?: string | null, localizedName?: string | null, localizedHelpText?: string | null, fieldType?: string | null, defaultValue?: string | null, required: boolean, uniqueValue: boolean, metadata?: any | null, order: number, cardOrder?: number | null, multiple: boolean, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string } | null> } } | null> } } | null> } } | null> } } | null> } | null };

export type FieldGroupCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type FieldGroupCardsQuery = { __typename?: 'Query', fieldGroupCards?: { __typename?: 'FieldGroupCardsConnection', edges: Array<{ __typename?: 'FieldGroupCardsEdge', node?: { __typename?: 'FieldGroupCard', id: string, name?: string | null, description?: string | null } | null }> } | null };

export type AddFieldGroupQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AddFieldGroupQueryQuery = { __typename?: 'Query', fieldGroups?: { __typename?: 'FieldGroupsConnection', nodes: Array<{ __typename?: 'FieldGroup', id: string, name: string, formFields: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, localizedName?: string | null } | null> } } | null> } | null };

export type UnassignedFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type UnassignedFieldsQuery = { __typename?: 'Query', unassignedFormFields?: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, name: string, localizedName?: string | null, fieldGroupId?: string | null, fieldType?: string | null, metadata?: any | null, order: number, required: boolean, sensitive?: boolean | null } | null> } | null, unassignedSystemFields?: { __typename?: 'SystemFieldsConnection', nodes: Array<{ __typename?: 'SystemField', id: string, name: string, companySystemField?: { __typename?: 'CompanySystemField', id: string, order: number, fieldGroupId?: string | null, required: boolean, sensitive: boolean } | null } | null> } | null };

export type FilterPresetsQueryVariables = Exact<{
  tableName?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type FilterPresetsQuery = { __typename?: 'Query', filterPresets?: { __typename?: 'FilterPresetsConnection', edges: Array<{ __typename?: 'FilterPresetsEdge', node?: { __typename?: 'FilterPreset', id: string, name: string, tableName: string, columns: any, filters?: any | null, miscellaneousFilters?: any | null } | null }> } | null };

export type AllFormFieldsQueryVariables = Exact<{
  objectTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  excludeFields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  orderBy?: InputMaybe<Array<FormFieldsOrderBy> | FormFieldsOrderBy>;
  or?: InputMaybe<Array<FormFieldFilter> | FormFieldFilter>;
}>;


export type AllFormFieldsQuery = { __typename?: 'Query', formFields?: { __typename?: 'FormFieldsConnection', edges: Array<{ __typename?: 'FormFieldsEdge', node?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null }> } | null };

export type AllEmployeeFormFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllEmployeeFormFieldsQuery = { __typename?: 'Query', formFields?: { __typename?: 'FormFieldsConnection', edges: Array<{ __typename?: 'FormFieldsEdge', node?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null }> } | null };

export type AllFormFieldsWithEntriesQueryVariables = Exact<{
  employeeId: Scalars['UUID'];
  objectTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type AllFormFieldsWithEntriesQuery = { __typename?: 'Query', formFields?: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', humanReadableValue?: string | null } | null> } } | null> } | null };

export type EmployeeFieldFormFieldEntriesQueryVariables = Exact<{
  userId: Scalars['UUID'];
  formFieldIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type EmployeeFieldFormFieldEntriesQuery = { __typename?: 'Query', formFieldEntries?: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', value?: string | null } | null> } | null };

export type GetFormFieldQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetFormFieldQuery = { __typename?: 'Query', formFieldById?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null };

export type ValidateFormFieldEntryUniquenessQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
}>;


export type ValidateFormFieldEntryUniquenessQuery = { __typename?: 'Query', validateFormFieldEntryUniqueness?: boolean | null };

export type FormFieldEntryCountQueryVariables = Exact<{
  employeeIds: Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>;
}>;


export type FormFieldEntryCountQuery = { __typename?: 'Query', formFieldEntryCount?: { __typename?: 'FormFieldEntryCountConnection', nodes: Array<{ __typename?: 'FormFieldEntryCountRecord', count?: string | number | null, value?: string | null } | null> } | null };

export type FormFieldEntriesQueryVariables = Exact<{
  id: Scalars['UUID'];
  employeeIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type FormFieldEntriesQuery = { __typename?: 'Query', formFieldById?: { __typename?: 'FormField', id: string, objectType: string, fieldType?: string | null, localizedName?: string | null, localizedHelpText?: string | null, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldEntries: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, value?: string | null, humanReadableValue?: string | null, formFieldId: string, employeeId?: string | null, productId?: string | null, active: boolean } | null> } } | null };

export type AllFormFields2QueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<FormFieldFilter>;
}>;


export type AllFormFields2Query = { __typename?: 'Query', formFields?: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null> } | null };

export type FormFieldsNameOnlyQueryVariables = Exact<{
  formFieldIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type FormFieldsNameOnlyQuery = { __typename?: 'Query', formFields?: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, localizedName?: string | null } | null> } | null };

export type FormFieldExistsQueryVariables = Exact<{
  name: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type FormFieldExistsQuery = { __typename?: 'Query', formFields?: { __typename?: 'FormFieldsConnection', totalCount: number } | null };

export type FormFieldSearchSuggestionsQueryVariables = Exact<{
  searchQuery: Scalars['String'];
  companyId: Scalars['UUID'];
}>;


export type FormFieldSearchSuggestionsQuery = { __typename?: 'Query', formFields?: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, localizedName?: string | null, fieldGroupId?: string | null } | null> } | null };

export type FormFieldContactsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type FormFieldContactsQuery = { __typename?: 'Query', formFieldById?: { __typename?: 'FormField', contacts: { __typename?: 'FormFieldContactsConnection', nodes: Array<{ __typename?: 'FormFieldContactsRecord', id?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, email?: string | null, emailWork?: string | null, mobile?: string | null, mobilePrivate?: string | null, logo?: string | null, jobPositionTitle?: string | null } | null> } } | null };

export type UseFormFieldsQueryQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['UUID']>;
  filter?: InputMaybe<FormFieldFilter>;
  getFieldEntries: Scalars['Boolean'];
  orderBy?: InputMaybe<Array<FormFieldsOrderBy> | FormFieldsOrderBy>;
  fieldEntriesFilter?: InputMaybe<FormFieldEntryFilter>;
}>;


export type UseFormFieldsQueryQuery = { __typename?: 'Query', formFields?: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, name: string, localizedName?: string | null, fieldType?: string | null, objectType: string, sensitive?: boolean | null, required: boolean, multiple: boolean, uniqueValue: boolean, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, metadata?: any | null, localizedHelpText?: string | null, localizedAgreementText?: string | null, supportsFutureData: boolean, changesMustBeApproved: boolean, defaultValue?: string | null, fieldGroup?: { __typename?: 'FieldGroup', id: string, localizedName?: string | null } | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null } | null> }, formFieldEntries?: { __typename?: 'FormFieldEntriesConnection', nodes: Array<{ __typename?: 'FormFieldEntry', id: string, value?: string | null, humanReadableValue?: string | null, userId?: string | null } | null> } } | null> } | null };

export type FroalaStyleByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type FroalaStyleByIdQuery = { __typename?: 'Query', froalaStyleById?: { __typename?: 'FroalaStyle', id: string, name: string, values?: any | null, css?: string | null } | null };

export type FroalaStylesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<FroalaStylesOrderBy> | FroalaStylesOrderBy>;
  filter?: InputMaybe<FroalaStyleFilter>;
  companyId?: InputMaybe<Scalars['UUID']>;
}>;


export type FroalaStylesQuery = { __typename?: 'Query', froalaStyles?: { __typename?: 'FroalaStylesConnection', edges: Array<{ __typename?: 'FroalaStylesEdge', node?: { __typename?: 'FroalaStyle', id: string, name: string, values?: any | null, css?: string | null } | null }> } | null };

export type FutureDataQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<FutureDatumFilter>;
  orderBy?: InputMaybe<Array<FutureDataOrderBy> | FutureDataOrderBy>;
  companyId?: InputMaybe<Scalars['UUID']>;
}>;


export type FutureDataQuery = { __typename?: 'Query', futureData?: { __typename?: 'FutureDataConnection', totalCount: number, edges: Array<{ __typename?: 'FutureDataEdge', node?: { __typename?: 'FutureDatum', id: string, systemFieldId?: string | null, formFieldId?: string | null, formFieldEntryId?: string | null, userId: string, updateValueAt?: Date | string | null, createdAt: Date | string, value: any, previousHumanReadableValue?: string | null, humanReadableValue?: string | null, approvalIsRequired?: boolean | null, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, approvalId?: string | null, creatorUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null, formField?: { __typename?: 'FormField', id: string, localizedName?: string | null, sensitive?: boolean | null } | null, systemField?: { __typename?: 'SystemField', id: string, readableName?: string | null, localizedName?: string | null, companySystemField?: { __typename?: 'CompanySystemField', id: string, sensitive: boolean } | null } | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type FutureDataFieldsInUseQueryVariables = Exact<{ [key: string]: never; }>;


export type FutureDataFieldsInUseQuery = { __typename?: 'Query', futureDataFieldsInUse?: { __typename?: 'FutureDataFieldsInUseConnection', edges: Array<{ __typename?: 'FutureDataFieldsInUseEdge', node?: { __typename?: 'FutureDataFieldsInUseRecord', id?: string | null, value?: string | null, type?: string | null } | null }> } | null };

export type GroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<GroupFilter>;
  orderBy?: InputMaybe<Array<GroupsOrderBy> | GroupsOrderBy>;
}>;


export type GroupsQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupsConnection', totalCount: number, edges: Array<{ __typename?: 'GroupsEdge', node?: { __typename?: 'Group', id: string, name?: string | null, localizedName?: string | null, description?: string | null, scope?: RoleScope | null, active: boolean, autoAdd?: boolean | null, autoAddNewPermissions: boolean, autoInherit: boolean, groupRoles: { __typename?: 'GroupRolesConnection', nodes: Array<{ __typename?: 'GroupRole', groupId: string, roleId: string, itemIds?: Array<string | null> | null, role?: { __typename?: 'Role', id: string, info: string, name: string, scopes?: Array<RoleScope | null> | null, usesItemIds: boolean } | null } | null> } } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null, roles?: { __typename?: 'RolesConnection', edges: Array<{ __typename?: 'RolesEdge', node?: { __typename?: 'Role', id: string, info: string, name: string, scopes?: Array<RoleScope | null> | null, usesItemIds: boolean } | null }> } | null };

export type GroupsTableQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<GroupFilter>;
  orderBy?: InputMaybe<Array<GroupsOrderBy> | GroupsOrderBy>;
}>;


export type GroupsTableQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupsConnection', totalCount: number, edges: Array<{ __typename?: 'GroupsEdge', node?: { __typename?: 'Group', id: string, name?: string | null, localizedName?: string | null, description?: string | null, scope?: RoleScope | null, active: boolean, autoAdd?: boolean | null, autoAddNewPermissions: boolean, autoInherit: boolean, userGroups: { __typename?: 'UserGroupsConnection', totalCount: number }, userDepartmentGroups: { __typename?: 'UserDepartmentGroupsConnection', totalCount: number }, userCompanyGroups: { __typename?: 'UserCompanyGroupsConnection', totalCount: number }, groupRoles: { __typename?: 'GroupRolesConnection', nodes: Array<{ __typename?: 'GroupRole', groupId: string, roleId: string, itemIds?: Array<string | null> | null, role?: { __typename?: 'Role', id: string, info: string, name: string, scopes?: Array<RoleScope | null> | null, usesItemIds: boolean } | null } | null> } } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type RoleByInfoQueryVariables = Exact<{
  info?: InputMaybe<Scalars['String']>;
}>;


export type RoleByInfoQuery = { __typename?: 'Query', roles?: { __typename?: 'RolesConnection', nodes: Array<{ __typename?: 'Role', id: string } | null> } | null };

export type RolesQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['UUID']>;
  filter?: InputMaybe<RoleFilter>;
}>;


export type RolesQuery = { __typename?: 'Query', documentTypes?: { __typename?: 'DocumentTypesConnection', edges: Array<{ __typename?: 'DocumentTypesEdge', node?: { __typename?: 'DocumentType', id: string, name?: string | null } | null }> } | null, dashboardViews?: { __typename?: 'DashboardViewsConnection', nodes: Array<{ __typename?: 'DashboardView', id: string, name: string } | null> } | null, processTypes?: { __typename?: 'ProcessTypesConnection', nodes: Array<{ __typename?: 'ProcessType', id: string, name?: string | null } | null> } | null, engagementTypes?: { __typename?: 'EngagementTypesConnection', nodes: Array<{ __typename?: 'EngagementType', id: string, name?: string | null } | null> } | null, vacationTypes?: { __typename?: 'VacationTypesConnection', nodes: Array<{ __typename?: 'VacationType', id: string, name?: string | null } | null> } | null, pulseTypes?: { __typename?: 'PulseTypesConnection', nodes: Array<{ __typename?: 'PulseType', id: string, name?: string | null } | null> } | null, postTypes?: { __typename?: 'PostTypesConnection', nodes: Array<{ __typename?: 'PostType', id: string, name?: string | null } | null> } | null, productTypes?: { __typename?: 'ProductTypesConnection', nodes: Array<{ __typename?: 'ProductType', id: string, name?: string | null } | null> } | null, documentFolderBlueprints?: { __typename?: 'DocumentFolderBlueprintsConnection', nodes: Array<{ __typename?: 'DocumentFolderBlueprint', id: string, name: string } | null> } | null, roles?: { __typename?: 'RolesConnection', edges: Array<{ __typename?: 'RolesEdge', node?: { __typename?: 'Role', id: string, info: string, name: string, scopes?: Array<RoleScope | null> | null, usesItemIds: boolean } | null }> } | null };

export type GroupQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GroupQuery = { __typename?: 'Query', groupById?: { __typename?: 'Group', id: string, name?: string | null, localizedName?: string | null, description?: string | null, scope?: RoleScope | null, active: boolean, autoAdd?: boolean | null, autoAddNewPermissions: boolean, autoInherit: boolean, groupRoles: { __typename?: 'GroupRolesConnection', nodes: Array<{ __typename?: 'GroupRole', groupId: string, roleId: string, itemIds?: Array<string | null> | null, role?: { __typename?: 'Role', id: string, info: string, name: string, scopes?: Array<RoleScope | null> | null, usesItemIds: boolean } | null } | null> } } | null };

export type GroupRoleByGroupIdAndRoleIdQueryVariables = Exact<{
  groupId: Scalars['UUID'];
  roleId: Scalars['UUID'];
}>;


export type GroupRoleByGroupIdAndRoleIdQuery = { __typename?: 'Query', groupRoleByGroupIdAndRoleId?: { __typename?: 'GroupRole', roleId: string, groupId: string, itemIds?: Array<string | null> | null } | null };

export type MissingGroupRolesQueryVariables = Exact<{
  groupId: Scalars['UUID'];
  roleId: Scalars['UUID'];
}>;


export type MissingGroupRolesQuery = { __typename?: 'Query', getMissingGroupRoles?: { __typename?: 'RolesConnection', edges: Array<{ __typename?: 'RolesEdge', node?: { __typename?: 'Role', id: string, info: string, name: string, scopes?: Array<RoleScope | null> | null, usesItemIds: boolean } | null }> } | null };

export type GroupUsersQueryVariables = Exact<{
  id: Scalars['UUID'];
  departmentIdFilter?: InputMaybe<UuidFilter>;
}>;


export type GroupUsersQuery = { __typename?: 'Query', groupById?: { __typename?: 'Group', userGroups: { __typename?: 'UserGroupsConnection', nodes: Array<{ __typename?: 'UserGroup', user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null } | null } | null> }, userDepartmentGroups: { __typename?: 'UserDepartmentGroupsConnection', nodes: Array<{ __typename?: 'UserDepartmentGroup', user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null } | null, department?: { __typename?: 'Department', id: string, name: string } | null } | null> }, userCompanyGroups: { __typename?: 'UserCompanyGroupsConnection', nodes: Array<{ __typename?: 'UserCompanyGroup', user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null } | null } | null> } } | null };

export type AllGroupsQueryVariables = Exact<{
  filter?: InputMaybe<GroupFilter>;
  after?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type AllGroupsQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupsConnection', edges: Array<{ __typename?: 'GroupsEdge', node?: { __typename?: 'Group', name?: string | null, localizedName?: string | null, id: string, scope?: RoleScope | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type ActiveAllScopeGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveAllScopeGroupsQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', name?: string | null, id: string } | null> } | null };

export type ActiveDepartmentAboveScopeGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveDepartmentAboveScopeGroupsQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', name?: string | null, id: string, scope?: RoleScope | null } | null> } | null };

export type UserGroupListQueryVariables = Exact<{
  groupId: Scalars['UUID'];
  search?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['Cursor']>;
  includeUserGroups?: InputMaybe<Scalars['Boolean']>;
  includeUserDepartmentGroups?: InputMaybe<Scalars['Boolean']>;
  includeUserCompanyGroups?: InputMaybe<Scalars['Boolean']>;
}>;


export type UserGroupListQuery = { __typename?: 'Query', userGroups?: { __typename?: 'UserGroupsConnection', edges: Array<{ __typename?: 'UserGroupsEdge', node?: { __typename?: 'UserGroup', user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null, userDepartmentGroups?: { __typename?: 'UserDepartmentGroupsConnection', edges: Array<{ __typename?: 'UserDepartmentGroupsEdge', node?: { __typename?: 'UserDepartmentGroup', user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null } | null, department?: { __typename?: 'Department', id: string, name: string } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null, userCompanyGroups?: { __typename?: 'UserCompanyGroupsConnection', edges: Array<{ __typename?: 'UserCompanyGroupsEdge', node?: { __typename?: 'UserCompanyGroup', user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type FieldsByExcludedRoleIdsQueryVariables = Exact<{
  roleIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  includeExcludedFields: Scalars['Boolean'];
}>;


export type FieldsByExcludedRoleIdsQuery = { __typename?: 'Query', autoAddGroups?: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', id: string } | null> } | null, formFields?: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string } | null> } | null, companySystemFields?: { __typename?: 'CompanySystemFieldsConnection', nodes: Array<{ __typename?: 'CompanySystemField', id: string, systemField?: { __typename?: 'SystemField', id: string, name: string } | null } | null> } | null };

export type IntegrableSystemsQueryVariables = Exact<{
  isBeta: Scalars['Boolean'];
}>;


export type IntegrableSystemsQuery = { __typename?: 'Query', integrableSystems?: { __typename?: 'IntegrableSystemsConnection', nodes: Array<{ __typename?: 'IntegrableSystem', id: string, name: string, logo: string, description: string, homepageUrl: string, authUrl: string, createUrl: string, deleteUrl: string, loginUrl?: string | null, settingsUrl?: string | null, legalDescription?: string | null } | null> } | null };

export type IntegrableSystemByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type IntegrableSystemByIdQuery = { __typename?: 'Query', integrableSystemById?: { __typename?: 'IntegrableSystem', id: string, settingsUrl?: string | null, name: string, logo: string, loginUrl?: string | null, legalDescription?: string | null, homepageUrl: string, description: string, authUrl: string, createUrl: string } | null };

export type GetFieldLogQueryVariables = Exact<{
  userId: Scalars['UUID'];
  type: FieldLogType;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldEntryId?: InputMaybe<Scalars['UUID']>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetFieldLogQuery = { __typename?: 'Query', getFieldLog?: { __typename?: 'GetFieldLogPayload', entries?: Array<{ __typename?: 'FieldLogValue', id?: number | null, value?: any | null, date?: Date | string | null, creator?: any | null, notes?: any | null, action?: LogAction | null, context?: LoggedActionContext | null } | null> | null } | null };

export type LoggedActionNotesQueryVariables = Exact<{
  eventId: Scalars['BigInt'];
}>;


export type LoggedActionNotesQuery = { __typename?: 'Query', loggedActionNotes?: { __typename?: 'LoggedActionNotesConnection', nodes: Array<{ __typename?: 'LoggedActionNote', id: string, createdAt: Date | string, note: string, creator?: any | null } | null> } | null };

export type ExportFieldLogToExcelQueryVariables = Exact<{
  userId: Scalars['UUID'];
  type: FieldLogType;
  systemFieldId?: InputMaybe<Scalars['UUID']>;
  formFieldEntryId?: InputMaybe<Scalars['UUID']>;
  formFieldId?: InputMaybe<Scalars['UUID']>;
}>;


export type ExportFieldLogToExcelQuery = { __typename?: 'Query', exportFieldLogToExcel?: { __typename?: 'ExportFieldLogToExcelPayload', base64?: string | null } | null };

export type GetSingleProcessLogsQueryVariables = Exact<{
  processId?: InputMaybe<Scalars['UUID']>;
  orderBy?: InputMaybe<Scalars['String']>;
  argSearchString?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<LogEntryFilter>;
}>;


export type GetSingleProcessLogsQuery = { __typename?: 'Query', getSingleProcessLogs?: { __typename?: 'LogEntriesConnection', totalCount: number, edges: Array<{ __typename?: 'LogEntriesEdge', node?: { __typename?: 'LogEntry', rowData?: any | null, changedFields?: any | null, loggedAction?: { __typename?: 'LoggedAction', eventId: string | number, transactionId?: string | number | null, schemaName: string, tableName: string, actionTstampTx: Date | string, action: string, selectedFields?: Array<string | null> | null, affectedId?: string | null, loggedActionContext: LoggedActionContext, user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null } | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type GetDeletionLogQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<LogFilter>;
}>;


export type GetDeletionLogQuery = { __typename?: 'Query', getDeletionLog?: { __typename?: 'LogsConnection', edges: Array<{ __typename?: 'LogsEdge', node?: { __typename?: 'Log', loggedAction?: { __typename?: 'LoggedAction', affectedId?: string | null, affectedItem?: any | null, actionTstampTx: Date | string, loggedActionContext: LoggedActionContext, creator?: any | null, id: string | number } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type GetLoginLogsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<LoginLogFilter>;
  orderBy?: InputMaybe<Array<LoginLogsOrderBy> | LoginLogsOrderBy>;
}>;


export type GetLoginLogsQuery = { __typename?: 'Query', loginLogs?: { __typename?: 'LoginLogsConnection', totalCount: number, edges: Array<{ __typename?: 'LoginLogsEdge', node?: { __typename?: 'LoginLog', id: string, ip: unknown, type: LoginLogType, createdAt: Date | string, superUser?: any | null, note?: string | null, user?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type GetEmployeeCasefileLogsQueryVariables = Exact<{
  casefileId?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  argSearchString?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<LogEntryFilter>;
}>;


export type GetEmployeeCasefileLogsQuery = { __typename?: 'Query', getEmployeeCasefileLogs?: { __typename?: 'LogEntriesConnection', totalCount: number, edges: Array<{ __typename?: 'LogEntriesEdge', node?: { __typename?: 'LogEntry', rowData?: any | null, changedFields?: any | null, loggedAction?: { __typename?: 'LoggedAction', eventId: string | number, transactionId?: string | number | null, schemaName: string, tableName: string, actionTstampTx: Date | string, action: string, selectedFields?: Array<string | null> | null, affectedId?: string | null, loggedActionContext: LoggedActionContext, user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null } | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type GetEmployeeLogsQueryVariables = Exact<{
  employeeId?: InputMaybe<Scalars['UUID']>;
  orderBy?: InputMaybe<Scalars['String']>;
  argSearchString?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<LogEntryFilter>;
}>;


export type GetEmployeeLogsQuery = { __typename?: 'Query', getEmployeeLogs?: { __typename?: 'LogEntriesConnection', totalCount: number, edges: Array<{ __typename?: 'LogEntriesEdge', node?: { __typename?: 'LogEntry', rowData?: any | null, changedFields?: any | null, loggedAction?: { __typename?: 'LoggedAction', eventId: string | number, transactionId?: string | number | null, schemaName: string, tableName: string, actionTstampTx: Date | string, action: string, selectedFields?: Array<string | null> | null, affectedId?: string | null, loggedActionContext: LoggedActionContext, user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null } | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type GetStorageLogsQueryVariables = Exact<{
  storageId?: InputMaybe<Scalars['UUID']>;
  orderBy?: InputMaybe<Scalars['String']>;
  argSearchString?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<LogEntryFilter>;
}>;


export type GetStorageLogsQuery = { __typename?: 'Query', getStorageLogs?: { __typename?: 'LogEntriesConnection', totalCount: number, edges: Array<{ __typename?: 'LogEntriesEdge', node?: { __typename?: 'LogEntry', rowData?: any | null, changedFields?: any | null, loggedAction?: { __typename?: 'LoggedAction', eventId: string | number, transactionId?: string | number | null, schemaName: string, tableName: string, actionTstampTx: Date | string, action: string, selectedFields?: Array<string | null> | null, affectedId?: string | null, loggedActionContext: LoggedActionContext, user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null } | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type GetPreboardingEmployeeLogsQueryVariables = Exact<{
  preboardingEmployeeId?: InputMaybe<Scalars['UUID']>;
  orderBy?: InputMaybe<Scalars['String']>;
  argSearchString?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<LogEntryFilter>;
}>;


export type GetPreboardingEmployeeLogsQuery = { __typename?: 'Query', getPreboardingEmployeeLogs?: { __typename?: 'LogEntriesConnection', totalCount: number, edges: Array<{ __typename?: 'LogEntriesEdge', node?: { __typename?: 'LogEntry', rowData?: any | null, changedFields?: any | null, loggedAction?: { __typename?: 'LoggedAction', eventId: string | number, transactionId?: string | number | null, schemaName: string, tableName: string, actionTstampTx: Date | string, action: string, selectedFields?: Array<string | null> | null, affectedId?: string | null, loggedActionContext: LoggedActionContext, user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null } | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type GetWorkHoursLogsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  orderBy?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GetWorkHoursLogsQuery = { __typename?: 'Query', getWorkHoursLogs?: { __typename?: 'GetWorkHoursLogsConnection', totalCount: number, edges: Array<{ __typename?: 'GetWorkHoursLogEdge', node?: { __typename?: 'GetWorkHoursLogsRecord', id?: string | number | null, loggedActionContext?: string | null, actionTstampTx?: Date | string | null, user?: { __typename?: 'SimpleUser', id?: string | null, fullName?: string | null, logo?: string | null } | null } | null }> } | null };

export type MainMenuBadgesQueryVariables = Exact<{
  userId: Scalars['UUID'];
  locale?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ChangelogFilter>;
}>;


export type MainMenuBadgesQuery = { __typename?: 'Query', changelogs?: { __typename?: 'ChangelogsConnection', nodes: Array<{ __typename?: 'Changelog', id: string, version: string, changelogUsers: { __typename?: 'ChangelogUsersConnection', totalCount: number } } | null> } | null, approvals?: { __typename?: 'ApprovalsConnection', totalCount: number } | null };

export type NotificationQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type NotificationQuery = { __typename?: 'Query', notificationById?: { __typename?: 'Notification', id: string, notificationTypeId: string, hookId: string, hookName?: string | null, recipientType?: string | null, text?: string | null, emailSubject?: string | null, localizedText?: string | null, metadata?: any | null, createdAt: Date | string, updatedAt: Date | string, notificationCustomRecipients: { __typename?: 'NotificationCustomRecipientsConnection', edges: Array<{ __typename?: 'NotificationCustomRecipientsEdge', node?: { __typename?: 'NotificationCustomRecipient', employeeId: string } | null }> }, notificationGroupRecipients: { __typename?: 'NotificationGroupRecipientsConnection', edges: Array<{ __typename?: 'NotificationGroupRecipientsEdge', node?: { __typename?: 'NotificationGroupRecipient', groupId: string } | null }> }, notificationCustomEmployeeFieldRecipients: { __typename?: 'NotificationCustomEmployeeFieldRecipientsConnection', edges: Array<{ __typename?: 'NotificationCustomEmployeeFieldRecipientsEdge', node?: { __typename?: 'NotificationCustomEmployeeFieldRecipient', formFieldId: string } | null }> }, notificationType?: { __typename?: 'NotificationType', id: string, name: string, broadcastTime?: string | null, channelTypes: { __typename?: 'ChannelTypesConnection', nodes: Array<{ __typename?: 'ChannelType', id: string, name: string } | null> } } | null } | null };

export type AllNotificationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<NotificationFilter>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy> | NotificationsOrderBy>;
}>;


export type AllNotificationsQuery = { __typename?: 'Query', notifications?: { __typename?: 'NotificationsConnection', edges: Array<{ __typename?: 'NotificationsEdge', node?: { __typename?: 'Notification', id: string, notificationTypeId: string, hookId: string, hookName?: string | null, recipientType?: string | null, text?: string | null, emailSubject?: string | null, localizedText?: string | null, metadata?: any | null, createdAt: Date | string, updatedAt: Date | string, notificationCustomRecipients: { __typename?: 'NotificationCustomRecipientsConnection', edges: Array<{ __typename?: 'NotificationCustomRecipientsEdge', node?: { __typename?: 'NotificationCustomRecipient', employeeId: string, user?: { __typename?: 'User', fullName?: string | null, logo?: string | null } | null } | null }> }, notificationGroupRecipients: { __typename?: 'NotificationGroupRecipientsConnection', edges: Array<{ __typename?: 'NotificationGroupRecipientsEdge', node?: { __typename?: 'NotificationGroupRecipient', groupId: string, group?: { __typename?: 'Group', id: string, localizedName?: string | null, scopeName?: string | null } | null } | null }> }, notificationType?: { __typename?: 'NotificationType', id: string, name: string, broadcastTime?: string | null, channelTypes: { __typename?: 'ChannelTypesConnection', nodes: Array<{ __typename?: 'ChannelType', id: string, name: string } | null> } } | null } | null }> } | null };

export type AllNotificationTypesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<NotificationTypesOrderBy> | NotificationTypesOrderBy>;
  filter?: InputMaybe<NotificationTypeFilter>;
}>;


export type AllNotificationTypesQuery = { __typename?: 'Query', notificationTypes?: { __typename?: 'NotificationTypesConnection', totalCount: number, edges: Array<{ __typename?: 'NotificationTypesEdge', node?: { __typename?: 'NotificationType', id: string, name: string, broadcastTime?: string | null, timeZone?: string | null, avoidBundling: boolean, channelTypes: { __typename?: 'ChannelTypesConnection', nodes: Array<{ __typename?: 'ChannelType', id: string, name: string } | null> } } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type NotificationTypeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type NotificationTypeQuery = { __typename?: 'Query', notificationTypeById?: { __typename?: 'NotificationType', id: string, name: string, broadcastTime?: string | null, timeZone?: string | null, avoidBundling: boolean, channelTypes: { __typename?: 'ChannelTypesConnection', nodes: Array<{ __typename?: 'ChannelType', id: string, name: string } | null> } } | null };

export type NotificationTypesInputFieldQueryVariables = Exact<{
  filter?: InputMaybe<NotificationTypeFilter>;
  after?: InputMaybe<Scalars['Cursor']>;
}>;


export type NotificationTypesInputFieldQuery = { __typename?: 'Query', notificationTypes?: { __typename?: 'NotificationTypesConnection', edges: Array<{ __typename?: 'NotificationTypesEdge', node?: { __typename?: 'NotificationType', id: string, name: string } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type AllEmployeeNotificationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<NotificationEmployeeFilter>;
}>;


export type AllEmployeeNotificationsQuery = { __typename?: 'Query', notificationEmployees?: { __typename?: 'NotificationEmployeesConnection', totalCount: number, edges: Array<{ __typename?: 'NotificationEmployeesEdge', node?: { __typename?: 'NotificationEmployee', id: string, recipientId: string, read: boolean, createdAt: Date | string, text?: string | null, placeholderValues?: any | null, notification?: { __typename?: 'Notification', text?: string | null, hook?: { __typename?: 'Hook', id: string, name: string } | null } | null, references: { __typename?: 'NotificationEmployeeReferencesConnection', nodes: Array<{ __typename?: 'NotificationEmployeeReference', notificationData?: { __typename?: 'NotificationData', type?: string | null, name?: string | null, object?: any | null, editedFields?: Array<string | null> | null } | null } | null> }, sender?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null, employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type UnreadNotificationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadNotificationsCountQuery = { __typename?: 'Query', notificationEmployees?: { __typename?: 'NotificationEmployeesConnection', totalCount: number } | null };

export type AllChannelTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllChannelTypesQuery = { __typename?: 'Query', channelTypes?: { __typename?: 'ChannelTypesConnection', edges: Array<{ __typename?: 'ChannelTypesEdge', node?: { __typename?: 'ChannelType', id: string, name: string } | null }> } | null };

export type ContractPredefinedPlaceholderQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<ContractPredefinedPlaceholdersOrderBy> | ContractPredefinedPlaceholdersOrderBy>;
  filter?: InputMaybe<ContractPredefinedPlaceholderFilter>;
  locale?: InputMaybe<Scalars['String']>;
}>;


export type ContractPredefinedPlaceholderQuery = { __typename?: 'Query', contractPredefinedPlaceholders?: { __typename?: 'ContractPredefinedPlaceholdersConnection', totalCount: number, edges: Array<{ __typename?: 'ContractPredefinedPlaceholdersEdge', node?: { __typename?: 'ContractPredefinedPlaceholder', id: string, alias?: string | null, companyId: string, departmentId?: string | null, formFieldId?: string | null, createdAt: Date | string, updatedAt: Date | string, placeholder?: string | null, formField?: { __typename?: 'FormField', id: string, objectType: string, fieldType?: string | null, name: string, localizedName?: string | null, defaultValue?: string | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, value: string, localizedValue?: string | null, order: number } | null> } } | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type PostTypesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<PostTypesOrderBy> | PostTypesOrderBy>;
  filter?: InputMaybe<PostTypeFilter>;
}>;


export type PostTypesQuery = { __typename?: 'Query', postTypes?: { __typename?: 'PostTypesConnection', totalCount: number, edges: Array<{ __typename?: 'PostTypesEdge', node?: { __typename?: 'PostType', id: string, localizedName?: string | null, users: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null } | null> }, departments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> } } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type PostTypeByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PostTypeByIdQuery = { __typename?: 'Query', postTypeById?: { __typename?: 'PostType', id: string, name?: string | null, sharedUsers?: Array<string | null> | null, sharedDepartments?: Array<string | null> | null, nameTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null };

export type AffectedPostsCountOnPostTypeDeleteQueryVariables = Exact<{
  postTypeId: Scalars['UUID'];
}>;


export type AffectedPostsCountOnPostTypeDeleteQuery = { __typename?: 'Query', affectedPostsCountOnPostTypeDelete: number };

export type PreboardingsQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<PreboardingsOrderBy> | PreboardingsOrderBy>;
  filter?: InputMaybe<PreboardingFilter>;
  preboardingEmployeesFilter?: InputMaybe<PreboardingEmployeeFilter>;
}>;


export type PreboardingsQueryQuery = { __typename?: 'Query', preboardings?: { __typename?: 'PreboardingsConnection', totalCount: number, edges: Array<{ __typename?: 'PreboardingsEdge', node?: { __typename?: 'Preboarding', id: string, template: boolean, archived: boolean, type?: PreboardingType | null, anonymous: boolean, companyId?: string | null, departmentIds?: Array<string | null> | null, userIds?: Array<string | null> | null, predecessorId?: string | null, name?: string | null, order: number, emailSubject?: string | null, emailBody?: string | null, useWorkEmail: boolean, linkButtonText?: string | null, deadline?: Date | string | null, reminder?: Date | string | null, startDate: Date | string, createdAt: Date | string, locale: string, hasHandSignatureField?: boolean | null, channel?: PreboardingChannel | null, disable2Fa: boolean, closeAccess?: number | null, reminderDays?: number | null, assigneeCount?: number | null, recipientId?: string | null, recipientGroupId?: string | null, recipientCustomEmployeeFieldId?: string | null, recipientDirectManager?: boolean | null, defaultManagerDirectManager: boolean, defaultManagerUserIds: Array<string | null>, defaultManagerGroupIds: Array<string | null>, defaultManagerEmployeeFieldIds: Array<string | null>, smsBody?: string | null, engagementTypeId?: string | null, isUncategorized?: boolean | null, predecessor?: { __typename?: 'Preboarding', id: string, name?: string | null } | null, preboardingProcesses: { __typename?: 'PreboardingProcessesConnection', nodes: Array<{ __typename?: 'PreboardingProcess', process?: { __typename?: 'Process', id: string, name?: string | null } | null } | null> }, preboardingEmployees: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, preboardingId: string, employeeId: string, managerIds?: Array<string | null> | null, userId: string, departments?: Array<string | null> | null, completed: boolean, published: boolean, createdAt: Date | string, recipient?: { __typename?: 'User', id: string, fullName?: string | null } | null, employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, fullName?: string | null, userDepartments: { __typename?: 'UserDepartmentsConnection', nodes: Array<{ __typename?: 'UserDepartment', department?: { __typename?: 'Department', id: string, name: string } | null } | null> } } | null } | null } | null> }, departments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> } } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type PreboardingQueryQueryVariables = Exact<{
  id: Scalars['UUID'];
  companyId: Scalars['UUID'];
}>;


export type PreboardingQueryQuery = { __typename?: 'Query', preboardingById?: { __typename?: 'Preboarding', id: string, archived: boolean, companyId?: string | null, name?: string | null, departmentIds?: Array<string | null> | null, userIds?: Array<string | null> | null, managerIds: Array<string | null>, predecessorId?: string | null, recipientId?: string | null, active: boolean, order: number, fontSize: number, backgroundColor?: string | null, textColor?: string | null, useContentColors: boolean, contentBackgroundColor?: string | null, contentTextColor?: string | null, logoWidth?: number | null, firstSlideName?: string | null, firstSlideTitle?: string | null, firstSlideDescription?: string | null, lastSlideName?: string | null, lastSlideTitle?: string | null, lastSlideDescription?: string | null, overviewSlideName?: string | null, overviewSlideTitle?: string | null, overviewSlideDescription?: string | null, overviewSlideEnabled: boolean, nextButtonText?: string | null, prevButtonText?: string | null, logoType?: PreboardingLogoType | null, emailSubject?: string | null, emailBody?: string | null, smsBody?: string | null, linkButtonText?: string | null, result?: any | null, type?: PreboardingType | null, template: boolean, published: boolean, completed: boolean, deadline?: Date | string | null, reminder?: Date | string | null, startDate: Date | string, createdAt: Date | string, locale: string, useCustomLinkButtonColor: boolean, fallbackText?: string | null, dateFormat?: string | null, disable2Fa: boolean, confirmResults: boolean, useLeader: boolean, useWorkEmail: boolean, channel?: PreboardingChannel | null, closeAccess?: number | null, reminderDays?: number | null, recipientGroupId?: string | null, recipientDirectManager?: boolean | null, recipientCustomEmployeeFieldId?: string | null, defaultManagerUserIds: Array<string | null>, defaultManagerGroupIds: Array<string | null>, defaultManagerEmployeeFieldIds: Array<string | null>, defaultManagerDirectManager: boolean, fontUrl?: string | null, fontType?: PreboardingFontType | null, engagementTypeId?: string | null, anonymous: boolean, recipient?: { __typename?: 'User', id: string, firstName?: string | null, fullName?: string | null, logo?: string | null } | null, storage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, fontStorage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, departments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, preboardingSlides: { __typename?: 'PreboardingSlidesConnection', nodes: Array<{ __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null> }, preboardingEmployees: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, completed: boolean, published: boolean } | null> }, engagementType?: { __typename?: 'EngagementType', id: string, localizedName?: string | null } | null } | null, companyById?: { __typename?: 'Company', id: string, name?: string | null, logo?: string | null } | null };

export type PreboardingEmployeeQueryQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PreboardingEmployeeQueryQuery = { __typename?: 'Query', preboardingEmployeeById?: { __typename?: 'PreboardingEmployee', id: string, employeeId: string, managerIds?: Array<string | null> | null, active: boolean, conclusion?: any | null, archived: boolean, published: boolean, completed: boolean, completedReminded?: boolean | null, createdAt: Date | string, recipientId?: string | null, employee?: { __typename?: 'Employee', id: string, userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null, isLeader: boolean, userDepartments: { __typename?: 'UserDepartmentsConnection', nodes: Array<{ __typename?: 'UserDepartment', departmentId: string } | null> } } | null } | null, preboarding?: { __typename?: 'Preboarding', id: string, archived: boolean, companyId?: string | null, name?: string | null, departmentIds?: Array<string | null> | null, userIds?: Array<string | null> | null, managerIds: Array<string | null>, predecessorId?: string | null, recipientId?: string | null, active: boolean, order: number, fontSize: number, backgroundColor?: string | null, textColor?: string | null, useContentColors: boolean, contentBackgroundColor?: string | null, contentTextColor?: string | null, logoWidth?: number | null, firstSlideName?: string | null, firstSlideTitle?: string | null, firstSlideDescription?: string | null, lastSlideName?: string | null, lastSlideTitle?: string | null, lastSlideDescription?: string | null, overviewSlideName?: string | null, overviewSlideTitle?: string | null, overviewSlideDescription?: string | null, overviewSlideEnabled: boolean, nextButtonText?: string | null, prevButtonText?: string | null, logoType?: PreboardingLogoType | null, emailSubject?: string | null, emailBody?: string | null, smsBody?: string | null, linkButtonText?: string | null, result?: any | null, type?: PreboardingType | null, template: boolean, published: boolean, completed: boolean, deadline?: Date | string | null, reminder?: Date | string | null, startDate: Date | string, createdAt: Date | string, locale: string, useCustomLinkButtonColor: boolean, fallbackText?: string | null, dateFormat?: string | null, disable2Fa: boolean, confirmResults: boolean, useLeader: boolean, useWorkEmail: boolean, channel?: PreboardingChannel | null, closeAccess?: number | null, reminderDays?: number | null, recipientGroupId?: string | null, recipientDirectManager?: boolean | null, recipientCustomEmployeeFieldId?: string | null, defaultManagerUserIds: Array<string | null>, defaultManagerGroupIds: Array<string | null>, defaultManagerEmployeeFieldIds: Array<string | null>, defaultManagerDirectManager: boolean, fontUrl?: string | null, fontType?: PreboardingFontType | null, engagementTypeId?: string | null, anonymous: boolean, recipient?: { __typename?: 'User', id: string, firstName?: string | null, fullName?: string | null, logo?: string | null } | null, storage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, fontStorage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, departments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, preboardingSlides: { __typename?: 'PreboardingSlidesConnection', nodes: Array<{ __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null> }, preboardingEmployees: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, completed: boolean, published: boolean } | null> }, engagementType?: { __typename?: 'EngagementType', id: string, localizedName?: string | null } | null } | null } | null };

export type PreboardingEmployeesQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<PreboardingEmployeesOrderBy> | PreboardingEmployeesOrderBy>;
  filter?: InputMaybe<PreboardingEmployeeFilter>;
  includeUser?: InputMaybe<Scalars['Boolean']>;
}>;


export type PreboardingEmployeesQueryQuery = { __typename?: 'Query', preboardingEmployees?: { __typename?: 'PreboardingEmployeesConnection', totalCount: number, edges: Array<{ __typename?: 'PreboardingEmployeesEdge', node?: { __typename?: 'PreboardingEmployee', id: string, employeeId: string, managerIds?: Array<string | null> | null, active: boolean, conclusion?: any | null, archived: boolean, published: boolean, completed: boolean, completedReminded?: boolean | null, createdAt: Date | string, preboarding?: { __typename?: 'Preboarding', id: string, name?: string | null, startDate: Date | string, deadline?: Date | string | null, reminder?: Date | string | null, engagementTypeId?: string | null, recipient?: { __typename?: 'User', id: string, fullName?: string | null } | null, preboardingProcesses: { __typename?: 'PreboardingProcessesConnection', nodes: Array<{ __typename?: 'PreboardingProcess', process?: { __typename?: 'Process', name?: string | null, id: string } | null } | null> } } | null, user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: unknown | null } } | null };

export type PreboardingStatisticsQueryQueryVariables = Exact<{
  preboardingId: Scalars['UUID'];
  filter?: InputMaybe<PreboardingResultFilter>;
}>;


export type PreboardingStatisticsQueryQuery = { __typename?: 'Query', preboardingById?: { __typename?: 'Preboarding', id: string, name?: string | null, deadline?: Date | string | null, startDate: Date | string, anonymous: boolean, recipient?: { __typename?: 'User', logo?: string | null, fullName?: string | null } | null, preboardingSlides: { __typename?: 'PreboardingSlidesConnection', nodes: Array<{ __typename?: 'PreboardingSlide', id: string, name?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, systemField?: UserEmployeeFields | null, formField?: { __typename?: 'FormField', id: string, fieldGroupId?: string | null, name: string, fieldType?: string | null, objectType: string, metadata?: any | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, value: string } | null> } } | null } | null> } } | null> } } | null, preboardingResults?: { __typename?: 'PreboardingResultsConnection', nodes: Array<{ __typename?: 'PreboardingResult', id: string, result?: any | null, employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null, departments?: Array<string | null> | null, leaderDepartments?: Array<string | null> | null } | null } | null } | null> } | null };

export type PreboardingResultQueryQueryVariables = Exact<{
  filter?: InputMaybe<PreboardingResultFilter>;
}>;


export type PreboardingResultQueryQuery = { __typename?: 'Query', preboardingResults?: { __typename?: 'PreboardingResultsConnection', nodes: Array<{ __typename?: 'PreboardingResult', id: string, result?: any | null, employee?: { __typename?: 'Employee', id: string, company?: { __typename?: 'Company', id: string, name?: string | null, logo?: string | null } | null, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> } | null };

export type PreboardingEmailLogQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<PreboardingEmailLogsOrderBy> | PreboardingEmailLogsOrderBy>;
  filter?: InputMaybe<PreboardingEmailLogFilter>;
}>;


export type PreboardingEmailLogQueryQuery = { __typename?: 'Query', preboardingEmailLogs?: { __typename?: 'PreboardingEmailLogsConnection', edges: Array<{ __typename?: 'PreboardingEmailLogsEdge', node?: { __typename?: 'PreboardingEmailLog', id: string, subject: string, body: string, email: string, createdAt: Date | string, fromEmployee?: { __typename?: 'Employee', user?: { __typename?: 'User', fullName?: string | null } | null } | null } | null }> } | null };

export type PreboardingSlideQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PreboardingSlideQuery = { __typename?: 'Query', preboardingSlideById?: { __typename?: 'PreboardingSlide', id: string, addReviewNote: boolean, reviewNote?: string | null } | null };

export type PreboardingCommentsQueryQueryVariables = Exact<{
  filter?: InputMaybe<PreboardingResultSlideCommentFilter>;
}>;


export type PreboardingCommentsQueryQuery = { __typename?: 'Query', preboardingResultSlideComments?: { __typename?: 'PreboardingResultSlideCommentsConnection', nodes: Array<{ __typename?: 'PreboardingResultSlideComment', id: string, preboardingSlideId: string, edited: boolean, public: boolean, text: string, createdAt: Date | string, preboardingSlide?: { __typename?: 'PreboardingSlide', id: string, name?: string | null } | null, user?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null } | null } | null> } | null };

export type PreboardingSlideCommentCountQueryVariables = Exact<{
  preboardingSlideId: Scalars['UUID'];
  preboardingResultId: Scalars['UUID'];
}>;


export type PreboardingSlideCommentCountQuery = { __typename?: 'Query', preboardingResultSlideComments?: { __typename?: 'PreboardingResultSlideCommentsConnection', totalCount: number } | null };

export type PreboardingStatusQueryQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PreboardingStatusQueryQuery = { __typename?: 'Query', preboardingById?: { __typename?: 'Preboarding', id: string, assigneeCount?: number | null, finishedAssigneeCount?: number | null, startDate: Date | string, deadline?: Date | string | null, reminder?: Date | string | null, disable2Fa: boolean, type?: PreboardingType | null, anonymous: boolean, engagementTypeId?: string | null, preboardingEmployees: { __typename?: 'PreboardingEmployeesConnection', totalCount: number, nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, archived: boolean, completed: boolean, published: boolean, employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null, departments?: Array<string | null> | null, companyId: string } | null } | null, preboardingResults: { __typename?: 'PreboardingResultsConnection', nodes: Array<{ __typename?: 'PreboardingResult', createdAt: Date | string } | null> } } | null> } } | null };

export type GoogleFontsQueryVariables = Exact<{ [key: string]: never; }>;


export type GoogleFontsQuery = { __typename?: 'Query', GoogleFonts?: { __typename?: 'GoogleFontsPayload', fontFamilies?: any | null } | null };

export type PageDescriptionVariablesQueryQueryVariables = Exact<{
  departmentIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type PageDescriptionVariablesQueryQuery = { __typename?: 'Query', formFields?: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, metadata?: any | null, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, value: string, localizedValue?: string | null } | null> } } | null> } | null, companySystemFieldOptions?: { __typename?: 'CompanySystemFieldOptionsConnection', nodes: Array<{ __typename?: 'CompanySystemFieldOption', id: string, localizedValue?: string | null } | null> } | null, departments?: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> } | null };

export type PreboardingProcessesByProcessIdAndPreboardingIdQueryQueryVariables = Exact<{
  processId: Scalars['UUID'];
  preboardingId: Scalars['UUID'];
}>;


export type PreboardingProcessesByProcessIdAndPreboardingIdQueryQuery = { __typename?: 'Query', preboardingProcessByPreboardingIdAndProcessId?: { __typename?: 'PreboardingProcess', preboardingId: string, processId: string, sendDate?: Date | string | null, sendTime: string, startDay?: number | null, duration?: number | null, deadlineReminder?: number | null, deadlineReminderDate?: Date | string | null, preboarding?: { __typename?: 'Preboarding', id: string, archived: boolean, companyId?: string | null, name?: string | null, departmentIds?: Array<string | null> | null, userIds?: Array<string | null> | null, managerIds: Array<string | null>, predecessorId?: string | null, recipientId?: string | null, active: boolean, order: number, fontSize: number, backgroundColor?: string | null, textColor?: string | null, useContentColors: boolean, contentBackgroundColor?: string | null, contentTextColor?: string | null, logoWidth?: number | null, firstSlideName?: string | null, firstSlideTitle?: string | null, firstSlideDescription?: string | null, lastSlideName?: string | null, lastSlideTitle?: string | null, lastSlideDescription?: string | null, overviewSlideName?: string | null, overviewSlideTitle?: string | null, overviewSlideDescription?: string | null, overviewSlideEnabled: boolean, nextButtonText?: string | null, prevButtonText?: string | null, logoType?: PreboardingLogoType | null, emailSubject?: string | null, emailBody?: string | null, smsBody?: string | null, linkButtonText?: string | null, result?: any | null, type?: PreboardingType | null, template: boolean, published: boolean, completed: boolean, deadline?: Date | string | null, reminder?: Date | string | null, startDate: Date | string, createdAt: Date | string, locale: string, useCustomLinkButtonColor: boolean, fallbackText?: string | null, dateFormat?: string | null, disable2Fa: boolean, confirmResults: boolean, useLeader: boolean, useWorkEmail: boolean, channel?: PreboardingChannel | null, closeAccess?: number | null, reminderDays?: number | null, recipientGroupId?: string | null, recipientDirectManager?: boolean | null, recipientCustomEmployeeFieldId?: string | null, defaultManagerUserIds: Array<string | null>, defaultManagerGroupIds: Array<string | null>, defaultManagerEmployeeFieldIds: Array<string | null>, defaultManagerDirectManager: boolean, fontUrl?: string | null, fontType?: PreboardingFontType | null, engagementTypeId?: string | null, anonymous: boolean, recipient?: { __typename?: 'User', id: string, firstName?: string | null, fullName?: string | null, logo?: string | null } | null, storage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, fontStorage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, departments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, preboardingSlides: { __typename?: 'PreboardingSlidesConnection', nodes: Array<{ __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null> }, preboardingEmployees: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, completed: boolean, published: boolean } | null> }, engagementType?: { __typename?: 'EngagementType', id: string, localizedName?: string | null } | null } | null } | null };

export type PreboardingProcessesByProcessIdQueryVariables = Exact<{
  processId?: InputMaybe<Scalars['UUID']>;
}>;


export type PreboardingProcessesByProcessIdQuery = { __typename?: 'Query', preboardingProcesses?: { __typename?: 'PreboardingProcessesConnection', nodes: Array<{ __typename?: 'PreboardingProcess', preboardingId: string, processId: string, sendDate?: Date | string | null, sendTime: string, startDay?: number | null, duration?: number | null, deadlineReminder?: number | null, deadlineReminderDate?: Date | string | null, preboarding?: { __typename?: 'Preboarding', id: string, archived: boolean, companyId?: string | null, name?: string | null, departmentIds?: Array<string | null> | null, userIds?: Array<string | null> | null, managerIds: Array<string | null>, predecessorId?: string | null, recipientId?: string | null, active: boolean, order: number, fontSize: number, backgroundColor?: string | null, textColor?: string | null, useContentColors: boolean, contentBackgroundColor?: string | null, contentTextColor?: string | null, logoWidth?: number | null, firstSlideName?: string | null, firstSlideTitle?: string | null, firstSlideDescription?: string | null, lastSlideName?: string | null, lastSlideTitle?: string | null, lastSlideDescription?: string | null, overviewSlideName?: string | null, overviewSlideTitle?: string | null, overviewSlideDescription?: string | null, overviewSlideEnabled: boolean, nextButtonText?: string | null, prevButtonText?: string | null, logoType?: PreboardingLogoType | null, emailSubject?: string | null, emailBody?: string | null, smsBody?: string | null, linkButtonText?: string | null, result?: any | null, type?: PreboardingType | null, template: boolean, published: boolean, completed: boolean, deadline?: Date | string | null, reminder?: Date | string | null, startDate: Date | string, createdAt: Date | string, locale: string, useCustomLinkButtonColor: boolean, fallbackText?: string | null, dateFormat?: string | null, disable2Fa: boolean, confirmResults: boolean, useLeader: boolean, useWorkEmail: boolean, channel?: PreboardingChannel | null, closeAccess?: number | null, reminderDays?: number | null, recipientGroupId?: string | null, recipientDirectManager?: boolean | null, recipientCustomEmployeeFieldId?: string | null, defaultManagerUserIds: Array<string | null>, defaultManagerGroupIds: Array<string | null>, defaultManagerEmployeeFieldIds: Array<string | null>, defaultManagerDirectManager: boolean, fontUrl?: string | null, fontType?: PreboardingFontType | null, engagementTypeId?: string | null, anonymous: boolean, recipient?: { __typename?: 'User', id: string, firstName?: string | null, fullName?: string | null, logo?: string | null } | null, storage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, fontStorage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, departments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, preboardingSlides: { __typename?: 'PreboardingSlidesConnection', nodes: Array<{ __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null> }, preboardingEmployees: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, completed: boolean, published: boolean } | null> }, engagementType?: { __typename?: 'EngagementType', id: string, localizedName?: string | null } | null } | null } | null> } | null };

export type PreboardingProcessesQueryQueryVariables = Exact<{
  employeeId?: InputMaybe<Scalars['UUID']>;
  filter: PreboardingProcessFilter;
  includeRelations: Scalars['Boolean'];
}>;


export type PreboardingProcessesQueryQuery = { __typename?: 'Query', preboardingProcesses?: { __typename?: 'PreboardingProcessesConnection', edges: Array<{ __typename?: 'PreboardingProcessesEdge', node?: { __typename?: 'PreboardingProcess', preboardingId: string, processId: string, sendDate?: Date | string | null, sendTime: string, startDay?: number | null, duration?: number | null, deadlineReminder?: number | null, deadlineReminderDate?: Date | string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, preboarding?: { __typename?: 'Preboarding', id: string, archived: boolean, companyId?: string | null, name?: string | null, departmentIds?: Array<string | null> | null, userIds?: Array<string | null> | null, managerIds: Array<string | null>, predecessorId?: string | null, recipientId?: string | null, active: boolean, order: number, fontSize: number, backgroundColor?: string | null, textColor?: string | null, useContentColors: boolean, contentBackgroundColor?: string | null, contentTextColor?: string | null, logoWidth?: number | null, firstSlideName?: string | null, firstSlideTitle?: string | null, firstSlideDescription?: string | null, lastSlideName?: string | null, lastSlideTitle?: string | null, lastSlideDescription?: string | null, overviewSlideName?: string | null, overviewSlideTitle?: string | null, overviewSlideDescription?: string | null, overviewSlideEnabled: boolean, nextButtonText?: string | null, prevButtonText?: string | null, logoType?: PreboardingLogoType | null, emailSubject?: string | null, emailBody?: string | null, smsBody?: string | null, linkButtonText?: string | null, result?: any | null, type?: PreboardingType | null, template: boolean, published: boolean, completed: boolean, deadline?: Date | string | null, reminder?: Date | string | null, startDate: Date | string, createdAt: Date | string, locale: string, useCustomLinkButtonColor: boolean, fallbackText?: string | null, dateFormat?: string | null, disable2Fa: boolean, confirmResults: boolean, useLeader: boolean, useWorkEmail: boolean, channel?: PreboardingChannel | null, closeAccess?: number | null, reminderDays?: number | null, recipientGroupId?: string | null, recipientDirectManager?: boolean | null, recipientCustomEmployeeFieldId?: string | null, defaultManagerUserIds: Array<string | null>, defaultManagerGroupIds: Array<string | null>, defaultManagerEmployeeFieldIds: Array<string | null>, defaultManagerDirectManager: boolean, fontUrl?: string | null, fontType?: PreboardingFontType | null, engagementTypeId?: string | null, anonymous: boolean, recipient?: { __typename?: 'User', id: string, firstName?: string | null, fullName?: string | null, logo?: string | null } | null, storage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, fontStorage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, departments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, preboardingSlides: { __typename?: 'PreboardingSlidesConnection', nodes: Array<{ __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null> }, preboardingEmployees: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, completed: boolean, published: boolean } | null> }, engagementType?: { __typename?: 'EngagementType', id: string, localizedName?: string | null } | null } | null } | null }> } | null };

export type OngoingPreboardingsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type OngoingPreboardingsQuery = { __typename?: 'Query', employeeById?: { __typename?: 'Employee', preboardingEmployees: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, preboarding?: { __typename?: 'Preboarding', id: string, name?: string | null } | null } | null> } } | null };

export type FinishedPreboardingsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type FinishedPreboardingsQuery = { __typename?: 'Query', employeeById?: { __typename?: 'Employee', preboardingEmployees: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, completed: boolean, published: boolean, preboarding?: { __typename?: 'Preboarding', id: string, name?: string | null } | null } | null> } } | null };

export type PreboardingFormCacheByPreboardingIdAndUserIdQueryVariables = Exact<{
  preboardingId: Scalars['UUID'];
  userId: Scalars['UUID'];
}>;


export type PreboardingFormCacheByPreboardingIdAndUserIdQuery = { __typename?: 'Query', preboardingFormCacheByPreboardingIdAndUserId?: { __typename?: 'PreboardingFormCache', formValues?: any | null, page?: string | null } | null };

export type ExportPreboardingResultsToExcelQueryVariables = Exact<{
  preboardingId: Scalars['UUID'];
  includeDepartments?: InputMaybe<Scalars['Boolean']>;
}>;


export type ExportPreboardingResultsToExcelQuery = { __typename?: 'Query', exportPreboardingResultsToExcel?: { __typename?: 'ExportPreboardingResultsToExcelPayload', base64?: string | null } | null };

export type EmployeePreboardingCountsQueryVariables = Exact<{
  employeeId: Scalars['UUID'];
}>;


export type EmployeePreboardingCountsQuery = { __typename?: 'Query', engagementTypes?: { __typename?: 'EngagementTypesConnection', nodes: Array<{ __typename?: 'EngagementType', id: string, localizedName?: string | null, ongoingCount: { __typename?: 'PreboardingEmployeesConnection', totalCount: number }, finishedCount: { __typename?: 'PreboardingEmployeesConnection', totalCount: number } } | null> } | null, uncategorizedOngoingCount?: { __typename?: 'PreboardingEmployeesConnection', totalCount: number } | null, uncategorizedFinishedCount?: { __typename?: 'PreboardingEmployeesConnection', totalCount: number } | null };

export type PreboardingsFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type PreboardingsFilterQuery = { __typename?: 'Query', preboardings?: { __typename?: 'PreboardingsConnection', edges: Array<{ __typename?: 'PreboardingsEdge', node?: { __typename?: 'Preboarding', id: string, name?: string | null } | null }> } | null };

export type PreboardingBasicQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PreboardingBasicQuery = { __typename?: 'Query', preboardingById?: { __typename?: 'Preboarding', id: string, name?: string | null, departmentIds?: Array<string | null> | null, engagementTypeId?: string | null } | null };

export type PreboardingEmployeeByPreboardingIdAndEmployeeIdQueryVariables = Exact<{
  preboardingId: Scalars['UUID'];
  employeeId: Scalars['UUID'];
}>;


export type PreboardingEmployeeByPreboardingIdAndEmployeeIdQuery = { __typename?: 'Query', preboardingEmployees?: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string } | null> } | null };

export type PreboardingWidgetQueryQueryVariables = Exact<{
  userId: Scalars['UUID'];
  startDate?: InputMaybe<Scalars['Datetime']>;
  orderBy?: InputMaybe<Array<PreboardingEmployeesOrderBy> | PreboardingEmployeesOrderBy>;
}>;


export type PreboardingWidgetQueryQuery = { __typename?: 'Query', preboardingEmployees?: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, link?: string | null, userId: string, user?: { __typename?: 'User', id: string, fullName?: string | null } | null, preboarding?: { __typename?: 'Preboarding', id: string, name?: string | null, deadline?: Date | string | null, startDate: Date | string, published: boolean, completed: boolean } | null } | null> } | null };

export type PreboardingFormQueryQueryVariables = Exact<{
  preboardingEmployeeId: Scalars['UUID'];
}>;


export type PreboardingFormQueryQuery = { __typename?: 'Query', preboardingEmployeeById?: { __typename?: 'PreboardingEmployee', id: string, employeeId: string, companyId: string, preboardingId: string, userId: string, conclusion?: any | null, completed: boolean, published: boolean, user?: { __typename?: 'User', fullName?: string | null, departments?: Array<string | null> | null, hasLogo?: boolean | null, initialsLogo?: string | null } | null } | null };

export type PreboardingLocaleByPreboardingEmployeeIdQueryVariables = Exact<{
  preboardingEmployeeId: Scalars['UUID'];
}>;


export type PreboardingLocaleByPreboardingEmployeeIdQuery = { __typename?: 'Query', preboardingEmployeeById?: { __typename?: 'PreboardingEmployee', preboarding?: { __typename?: 'Preboarding', id: string, locale: string } | null } | null };

export type PreboardingFormFormFieldsQueryQueryVariables = Exact<{
  preboardingId: Scalars['UUID'];
}>;


export type PreboardingFormFormFieldsQueryQuery = { __typename?: 'Query', formFields?: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null> } | null };

export type PreboardingFormSubmitCheckApprovalFieldsQueryVariables = Exact<{
  formFieldIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  systemFieldNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type PreboardingFormSubmitCheckApprovalFieldsQuery = { __typename?: 'Query', formFields?: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string } | null> } | null, companySystemFields?: { __typename?: 'CompanySystemFieldsConnection', nodes: Array<{ __typename?: 'CompanySystemField', systemField?: { __typename?: 'SystemField', id: string, name: string } | null } | null> } | null };

export type AllProcessTypesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<ProcessTypesOrderBy> | ProcessTypesOrderBy>;
  filter?: InputMaybe<ProcessTypeFilter>;
}>;


export type AllProcessTypesQuery = { __typename?: 'Query', processTypes?: { __typename?: 'ProcessTypesConnection', totalCount: number, edges: Array<{ __typename?: 'ProcessTypesEdge', node?: { __typename?: 'ProcessType', id: string, name: string, localizedName?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type ProcessTypeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProcessTypeQuery = { __typename?: 'Query', processTypeById?: { __typename?: 'ProcessType', id: string, name: string } | null };

export type ProcessesQueryQueryVariables = Exact<{
  filter?: InputMaybe<ProcessFilter>;
}>;


export type ProcessesQueryQuery = { __typename?: 'Query', processes?: { __typename?: 'ProcessesConnection', edges: Array<{ __typename?: 'ProcessesEdge', node?: { __typename?: 'Process', id: string, name?: string | null, cutoffDay?: boolean | null, departmentIds?: Array<string | null> | null, createdAt: Date | string, order: number, taskCount?: string | number | null, projectCount?: string | number | null, messageCount?: string | number | null, appCount?: string | number | null, processType?: { __typename?: 'ProcessType', id: string, localizedName?: string | null } | null, departments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, projectTemplates: { __typename?: 'ProjectTemplatesConnection', totalCount: number }, taskTemplates: { __typename?: 'TaskTemplatesConnection', totalCount: number }, scheduledMessageTemplates: { __typename?: 'ScheduledMessageTemplatesConnection', totalCount: number } } | null }> } | null };

export type ProcessesQueryVariables = Exact<{
  filter?: InputMaybe<ProcessFilter>;
}>;


export type ProcessesQuery = { __typename?: 'Query', processes?: { __typename?: 'ProcessesConnection', edges: Array<{ __typename?: 'ProcessesEdge', node?: { __typename?: 'Process', id: string, progress?: string | number | null, name?: string | null, departmentIds?: Array<string | null> | null, createdAt: Date | string, order: number, startDate?: Date | string | null, endDate?: Date | string | null, processTypeId?: string | null, processType?: { __typename?: 'ProcessType', id: string, localizedName?: string | null } | null, departments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, projects: { __typename?: 'ProjectsConnection', nodes: Array<{ __typename?: 'Project', id: string, name: string, order?: number | null, tasks: { __typename?: 'TasksConnection', nodes: Array<{ __typename?: 'Task', id: string, name: string, order?: number | null, startDate: Date | string, endDate: Date | string, deadlineReminderDate?: Date | string | null, notes?: string | null, projectId?: string | null, processId?: string | null, parentTaskId?: string | null, completed: boolean, archived: boolean, calendarEventFrom?: Date | string | null, calendarEventTo?: Date | string | null, calendarEventOrganizerId?: string | null, departments?: Array<string | null> | null, userIds?: Array<string | null> | null, parentTask?: { __typename?: 'Task', id: string, name: string, projectId?: string | null, processId?: string | null, startDate: Date | string, endDate: Date | string } | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean, processTypeId?: string | null } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskResponsibles: { __typename?: 'TaskResponsiblesConnection', nodes: Array<{ __typename?: 'TaskResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskEmployees: { __typename?: 'TaskEmployeesConnection', nodes: Array<{ __typename?: 'TaskEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> }, scheduledMessages: { __typename?: 'ScheduledMessagesConnection', nodes: Array<{ __typename?: 'ScheduledMessage', id: string, senderEmployeeId: string, name: string, subject: string, body: string, active: boolean, sendDate: Date | string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageRecipients: { __typename?: 'ScheduledMessageRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageRecipient', scheduledMessageId: string, employeeId: string } | null> }, scheduledMessageExternalRecipients: { __typename?: 'ScheduledMessageExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageExternalRecipient', scheduledMessageId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> } } | null> }, tasks: { __typename?: 'TasksConnection', nodes: Array<{ __typename?: 'Task', id: string, name: string, order?: number | null, startDate: Date | string, endDate: Date | string, deadlineReminderDate?: Date | string | null, notes?: string | null, projectId?: string | null, processId?: string | null, parentTaskId?: string | null, completed: boolean, archived: boolean, calendarEventFrom?: Date | string | null, calendarEventTo?: Date | string | null, calendarEventOrganizerId?: string | null, departments?: Array<string | null> | null, userIds?: Array<string | null> | null, parentTask?: { __typename?: 'Task', id: string, name: string, projectId?: string | null, processId?: string | null, startDate: Date | string, endDate: Date | string } | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean, processTypeId?: string | null } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskResponsibles: { __typename?: 'TaskResponsiblesConnection', nodes: Array<{ __typename?: 'TaskResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskEmployees: { __typename?: 'TaskEmployeesConnection', nodes: Array<{ __typename?: 'TaskEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> }, scheduledMessages: { __typename?: 'ScheduledMessagesConnection', nodes: Array<{ __typename?: 'ScheduledMessage', id: string, senderEmployeeId: string, name: string, subject: string, body: string, active: boolean, sendDate: Date | string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageRecipients: { __typename?: 'ScheduledMessageRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageRecipient', scheduledMessageId: string, employeeId: string } | null> }, scheduledMessageExternalRecipients: { __typename?: 'ScheduledMessageExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageExternalRecipient', scheduledMessageId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> }, preboardingProcesses: { __typename?: 'PreboardingProcessesConnection', nodes: Array<{ __typename?: 'PreboardingProcess', preboardingId: string, processId: string, sendDate?: Date | string | null, sendTime: string, startDay?: number | null, duration?: number | null, deadlineReminder?: number | null, deadlineReminderDate?: Date | string | null, preboarding?: { __typename?: 'Preboarding', id: string, archived: boolean, companyId?: string | null, name?: string | null, departmentIds?: Array<string | null> | null, userIds?: Array<string | null> | null, managerIds: Array<string | null>, predecessorId?: string | null, recipientId?: string | null, active: boolean, order: number, fontSize: number, backgroundColor?: string | null, textColor?: string | null, useContentColors: boolean, contentBackgroundColor?: string | null, contentTextColor?: string | null, logoWidth?: number | null, firstSlideName?: string | null, firstSlideTitle?: string | null, firstSlideDescription?: string | null, lastSlideName?: string | null, lastSlideTitle?: string | null, lastSlideDescription?: string | null, overviewSlideName?: string | null, overviewSlideTitle?: string | null, overviewSlideDescription?: string | null, overviewSlideEnabled: boolean, nextButtonText?: string | null, prevButtonText?: string | null, logoType?: PreboardingLogoType | null, emailSubject?: string | null, emailBody?: string | null, smsBody?: string | null, linkButtonText?: string | null, result?: any | null, type?: PreboardingType | null, template: boolean, published: boolean, completed: boolean, deadline?: Date | string | null, reminder?: Date | string | null, startDate: Date | string, createdAt: Date | string, locale: string, useCustomLinkButtonColor: boolean, fallbackText?: string | null, dateFormat?: string | null, disable2Fa: boolean, confirmResults: boolean, useLeader: boolean, useWorkEmail: boolean, channel?: PreboardingChannel | null, closeAccess?: number | null, reminderDays?: number | null, recipientGroupId?: string | null, recipientDirectManager?: boolean | null, recipientCustomEmployeeFieldId?: string | null, defaultManagerUserIds: Array<string | null>, defaultManagerGroupIds: Array<string | null>, defaultManagerEmployeeFieldIds: Array<string | null>, defaultManagerDirectManager: boolean, fontUrl?: string | null, fontType?: PreboardingFontType | null, engagementTypeId?: string | null, anonymous: boolean, recipient?: { __typename?: 'User', id: string, firstName?: string | null, fullName?: string | null, logo?: string | null } | null, storage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, fontStorage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, departments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, preboardingSlides: { __typename?: 'PreboardingSlidesConnection', nodes: Array<{ __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null> }, preboardingEmployees: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, completed: boolean, published: boolean } | null> }, engagementType?: { __typename?: 'EngagementType', id: string, localizedName?: string | null } | null } | null } | null> } } | null }> } | null };

export type EmployeeProcessesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<ProcessesOrderBy> | ProcessesOrderBy>;
  filter?: InputMaybe<ProcessFilter>;
}>;


export type EmployeeProcessesQuery = { __typename?: 'Query', processes?: { __typename?: 'ProcessesConnection', totalCount: number, edges: Array<{ __typename?: 'ProcessesEdge', node?: { __typename?: 'Process', id: string, companyId: string, assignedUserDepartments?: Array<string | null> | null, name?: string | null, completed?: boolean | null, progress?: string | number | null, createdAt: Date | string, startDate?: Date | string | null, endDate?: Date | string | null, processType?: { __typename?: 'ProcessType', id: string, localizedName?: string | null } | null, employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type ProcessesOrderedByProgressQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  direction?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ProcessFilter>;
}>;


export type ProcessesOrderedByProgressQuery = { __typename?: 'Query', processesOrderedByProgress?: { __typename?: 'ProcessesConnection', totalCount: number, edges: Array<{ __typename?: 'ProcessesEdge', node?: { __typename?: 'Process', id: string, companyId: string, assignedUserDepartments?: Array<string | null> | null, name?: string | null, completed?: boolean | null, progress?: string | number | null, createdAt: Date | string, processType?: { __typename?: 'ProcessType', id: string, localizedName?: string | null } | null, employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type GetProcessGraphileQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetProcessGraphileQuery = { __typename?: 'Query', processById?: { __typename?: 'Process', id: string, name?: string | null, processTypeId?: string | null, cutoffDay?: boolean | null, departmentIds?: Array<string | null> | null, createdAt: Date | string, order: number, startDate?: Date | string | null, endDate?: Date | string | null, progress?: string | number | null, active: boolean, taskCount?: string | number | null, projectCount?: string | number | null, messageCount?: string | number | null, appCount?: string | number | null, assignedUserDepartments?: Array<string | null> | null, processType?: { __typename?: 'ProcessType', id: string, localizedName?: string | null } | null, simpleUser?: { __typename?: 'SimpleUser', id?: string | null, logo?: string | null, fullName?: string | null } | null, employee?: { __typename?: 'Employee', id: string, departments?: Array<string | null> | null, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null, projects: { __typename?: 'ProjectsConnection', nodes: Array<{ __typename?: 'Project', id: string, name: string, order?: number | null, tasks: { __typename?: 'TasksConnection', nodes: Array<{ __typename?: 'Task', id: string, name: string, order?: number | null, startDate: Date | string, endDate: Date | string, deadlineReminderDate?: Date | string | null, notes?: string | null, projectId?: string | null, processId?: string | null, parentTaskId?: string | null, completed: boolean, archived: boolean, calendarEventFrom?: Date | string | null, calendarEventTo?: Date | string | null, calendarEventOrganizerId?: string | null, departments?: Array<string | null> | null, userIds?: Array<string | null> | null, parentTask?: { __typename?: 'Task', id: string, name: string, projectId?: string | null, processId?: string | null, startDate: Date | string, endDate: Date | string } | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean, processTypeId?: string | null } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskResponsibles: { __typename?: 'TaskResponsiblesConnection', nodes: Array<{ __typename?: 'TaskResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskEmployees: { __typename?: 'TaskEmployeesConnection', nodes: Array<{ __typename?: 'TaskEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> }, scheduledMessages: { __typename?: 'ScheduledMessagesConnection', nodes: Array<{ __typename?: 'ScheduledMessage', id: string, senderEmployeeId: string, name: string, subject: string, body: string, active: boolean, sendDate: Date | string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageRecipients: { __typename?: 'ScheduledMessageRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageRecipient', scheduledMessageId: string, employeeId: string } | null> }, scheduledMessageExternalRecipients: { __typename?: 'ScheduledMessageExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageExternalRecipient', scheduledMessageId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> } } | null> }, tasks: { __typename?: 'TasksConnection', nodes: Array<{ __typename?: 'Task', id: string, name: string, order?: number | null, startDate: Date | string, endDate: Date | string, deadlineReminderDate?: Date | string | null, notes?: string | null, projectId?: string | null, processId?: string | null, parentTaskId?: string | null, completed: boolean, archived: boolean, calendarEventFrom?: Date | string | null, calendarEventTo?: Date | string | null, calendarEventOrganizerId?: string | null, departments?: Array<string | null> | null, userIds?: Array<string | null> | null, parentTask?: { __typename?: 'Task', id: string, name: string, projectId?: string | null, processId?: string | null, startDate: Date | string, endDate: Date | string } | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean, processTypeId?: string | null } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskResponsibles: { __typename?: 'TaskResponsiblesConnection', nodes: Array<{ __typename?: 'TaskResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskEmployees: { __typename?: 'TaskEmployeesConnection', nodes: Array<{ __typename?: 'TaskEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> }, scheduledMessages: { __typename?: 'ScheduledMessagesConnection', nodes: Array<{ __typename?: 'ScheduledMessage', id: string, senderEmployeeId: string, name: string, subject: string, body: string, active: boolean, sendDate: Date | string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageRecipients: { __typename?: 'ScheduledMessageRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageRecipient', scheduledMessageId: string, employeeId: string } | null> }, scheduledMessageExternalRecipients: { __typename?: 'ScheduledMessageExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageExternalRecipient', scheduledMessageId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> }, preboardingProcesses: { __typename?: 'PreboardingProcessesConnection', nodes: Array<{ __typename?: 'PreboardingProcess', preboardingId: string, processId: string, sendDate?: Date | string | null, sendTime: string, startDay?: number | null, duration?: number | null, deadlineReminder?: number | null, deadlineReminderDate?: Date | string | null, preboarding?: { __typename?: 'Preboarding', id: string, archived: boolean, companyId?: string | null, name?: string | null, departmentIds?: Array<string | null> | null, userIds?: Array<string | null> | null, managerIds: Array<string | null>, predecessorId?: string | null, recipientId?: string | null, active: boolean, order: number, fontSize: number, backgroundColor?: string | null, textColor?: string | null, useContentColors: boolean, contentBackgroundColor?: string | null, contentTextColor?: string | null, logoWidth?: number | null, firstSlideName?: string | null, firstSlideTitle?: string | null, firstSlideDescription?: string | null, lastSlideName?: string | null, lastSlideTitle?: string | null, lastSlideDescription?: string | null, overviewSlideName?: string | null, overviewSlideTitle?: string | null, overviewSlideDescription?: string | null, overviewSlideEnabled: boolean, nextButtonText?: string | null, prevButtonText?: string | null, logoType?: PreboardingLogoType | null, emailSubject?: string | null, emailBody?: string | null, smsBody?: string | null, linkButtonText?: string | null, result?: any | null, type?: PreboardingType | null, template: boolean, published: boolean, completed: boolean, deadline?: Date | string | null, reminder?: Date | string | null, startDate: Date | string, createdAt: Date | string, locale: string, useCustomLinkButtonColor: boolean, fallbackText?: string | null, dateFormat?: string | null, disable2Fa: boolean, confirmResults: boolean, useLeader: boolean, useWorkEmail: boolean, channel?: PreboardingChannel | null, closeAccess?: number | null, reminderDays?: number | null, recipientGroupId?: string | null, recipientDirectManager?: boolean | null, recipientCustomEmployeeFieldId?: string | null, defaultManagerUserIds: Array<string | null>, defaultManagerGroupIds: Array<string | null>, defaultManagerEmployeeFieldIds: Array<string | null>, defaultManagerDirectManager: boolean, fontUrl?: string | null, fontType?: PreboardingFontType | null, engagementTypeId?: string | null, anonymous: boolean, recipient?: { __typename?: 'User', id: string, firstName?: string | null, fullName?: string | null, logo?: string | null } | null, storage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, fontStorage?: { __typename?: 'Storage', id: string, url?: string | null, filename: string } | null, departments: { __typename?: 'DepartmentsConnection', nodes: Array<{ __typename?: 'Department', id: string, name: string } | null> }, preboardingSlides: { __typename?: 'PreboardingSlidesConnection', nodes: Array<{ __typename?: 'PreboardingSlide', id: string, preboardingId: string, departments?: Array<string | null> | null, name?: string | null, order?: number | null, pageTitle?: string | null, pageDescription?: string | null, addReviewNote: boolean, reviewNote?: string | null, preboardingSlideFormFields: { __typename?: 'PreboardingSlideFormFieldsConnection', nodes: Array<{ __typename?: 'PreboardingSlideFormField', id: string, required?: boolean | null, order?: number | null, active: boolean, systemField?: UserEmployeeFields | null, storage?: { __typename?: 'Storage', id: string, filename: string, url?: string | null } | null, formField?: { __typename?: 'FormField', id: string, companyId: string, customId?: string | null, objectType: string, fieldType?: string | null, name: string, active: boolean, localizedName?: string | null, helpText?: string | null, localizedHelpText?: string | null, agreementText?: string | null, localizedAgreementText?: string | null, uniqueValue: boolean, defaultValue?: string | null, required: boolean, sensitive?: boolean | null, multiple: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, order: number, metadata?: any | null, fieldGroupId?: string | null, productTypeIds?: Array<string | null> | null, departmentTypeIds?: Array<string | null> | null, excludedRoleIds?: Array<string | null> | null, formFieldsByParentFormFieldId: { __typename?: 'FormFieldsConnection', nodes: Array<{ __typename?: 'FormField', id: string, fieldType?: string | null, name: string, localizedName?: string | null, metadata?: any | null, order: number, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number } | null> } } | null> }, formFieldOptions: { __typename?: 'FormFieldOptionsConnection', nodes: Array<{ __typename?: 'FormFieldOption', id: string, localizedValue?: string | null, value: string, order: number, predefined?: boolean | null } | null> }, formFieldAgreementByFormFieldId?: { __typename?: 'FormFieldAgreement', agreementTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null } | null } | null> } } | null> }, preboardingEmployees: { __typename?: 'PreboardingEmployeesConnection', nodes: Array<{ __typename?: 'PreboardingEmployee', id: string, completed: boolean, published: boolean } | null> }, engagementType?: { __typename?: 'EngagementType', id: string, localizedName?: string | null } | null } | null } | null> }, projectTemplates: { __typename?: 'ProjectTemplatesConnection', nodes: Array<{ __typename?: 'ProjectTemplate', id: string, name: string, order?: number | null, taskTemplatesByProjectId: { __typename?: 'TaskTemplatesConnection', nodes: Array<{ __typename?: 'TaskTemplate', id: string, name: string, order?: number | null, startDay: number, duration: number, deadlineReminder?: number | null, useCalendarEvent: boolean, calendarEventFrom?: string | null, calendarEventTo?: string | null, calendarEventOrganizerId?: string | null, notes?: string | null, projectId?: string | null, processId?: string | null, includeEmployee: boolean, includeDirectManager: boolean, includeEmployeeResponsible: boolean, includeDirectManagerResponsible: boolean, includeCustomEmployeeFields?: Array<string | null> | null, includeCustomEmployeeFieldsResponsibles?: Array<string | null> | null, includeGroups?: Array<string | null> | null, includeGroupsResponsibles?: Array<string | null> | null, parentTaskId?: string | null, parentTask?: { __typename?: 'TaskTemplate', id: string, name: string, projectId?: string | null, processId?: string | null, duration: number, startDay: number } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskTemplateResponsibles: { __typename?: 'TaskTemplateResponsiblesConnection', nodes: Array<{ __typename?: 'TaskTemplateResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskTemplateEmployees: { __typename?: 'TaskTemplateEmployeesConnection', nodes: Array<{ __typename?: 'TaskTemplateEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> }, scheduledMessageTemplatesByProjectId: { __typename?: 'ScheduledMessageTemplatesConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplate', id: string, name: string, subject: string, includeEmployee: boolean, includeDirectManager?: boolean | null, includeGroups?: Array<string | null> | null, includeCustomEmployeeFields?: Array<string | null> | null, body: string, active: boolean, startDay: number, duration: number, sendTime: string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'ProjectTemplate', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageTemplateRecipients: { __typename?: 'ScheduledMessageTemplateRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplateRecipient', scheduledMessageTemplateId: string, employeeId: string } | null> }, scheduledMessageTemplateExternalRecipients: { __typename?: 'ScheduledMessageTemplateExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplateExternalRecipient', scheduledMessageTemplateId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> } } | null> }, taskTemplates: { __typename?: 'TaskTemplatesConnection', nodes: Array<{ __typename?: 'TaskTemplate', id: string, name: string, order?: number | null, startDay: number, duration: number, deadlineReminder?: number | null, useCalendarEvent: boolean, calendarEventFrom?: string | null, calendarEventTo?: string | null, calendarEventOrganizerId?: string | null, notes?: string | null, projectId?: string | null, processId?: string | null, includeEmployee: boolean, includeDirectManager: boolean, includeEmployeeResponsible: boolean, includeDirectManagerResponsible: boolean, includeCustomEmployeeFields?: Array<string | null> | null, includeCustomEmployeeFieldsResponsibles?: Array<string | null> | null, includeGroups?: Array<string | null> | null, includeGroupsResponsibles?: Array<string | null> | null, parentTaskId?: string | null, parentTask?: { __typename?: 'TaskTemplate', id: string, name: string, projectId?: string | null, processId?: string | null, duration: number, startDay: number } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskTemplateResponsibles: { __typename?: 'TaskTemplateResponsiblesConnection', nodes: Array<{ __typename?: 'TaskTemplateResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskTemplateEmployees: { __typename?: 'TaskTemplateEmployeesConnection', nodes: Array<{ __typename?: 'TaskTemplateEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> }, scheduledMessageTemplates: { __typename?: 'ScheduledMessageTemplatesConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplate', id: string, name: string, subject: string, includeEmployee: boolean, includeDirectManager?: boolean | null, includeGroups?: Array<string | null> | null, includeCustomEmployeeFields?: Array<string | null> | null, body: string, active: boolean, startDay: number, duration: number, sendTime: string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'ProjectTemplate', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageTemplateRecipients: { __typename?: 'ScheduledMessageTemplateRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplateRecipient', scheduledMessageTemplateId: string, employeeId: string } | null> }, scheduledMessageTemplateExternalRecipients: { __typename?: 'ScheduledMessageTemplateExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplateExternalRecipient', scheduledMessageTemplateId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> } } | null };

export type OngoingProcessesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type OngoingProcessesQuery = { __typename?: 'Query', employeeById?: { __typename?: 'Employee', processes: { __typename?: 'ProcessesConnection', nodes: Array<{ __typename?: 'Process', id: string, name?: string | null, progress?: string | number | null } | null> } } | null };

export type FinishedProcessesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type FinishedProcessesQuery = { __typename?: 'Query', employeeById?: { __typename?: 'Employee', processes: { __typename?: 'ProcessesConnection', nodes: Array<{ __typename?: 'Process', id: string, name?: string | null, progress?: string | number | null } | null> } } | null };

export type ProjectByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProjectByIdQuery = { __typename?: 'Query', projectById?: { __typename?: 'Project', id: string, name: string, order?: number | null, tasks: { __typename?: 'TasksConnection', nodes: Array<{ __typename?: 'Task', id: string, name: string, order?: number | null, startDate: Date | string, endDate: Date | string, deadlineReminderDate?: Date | string | null, notes?: string | null, projectId?: string | null, processId?: string | null, parentTaskId?: string | null, completed: boolean, archived: boolean, calendarEventFrom?: Date | string | null, calendarEventTo?: Date | string | null, calendarEventOrganizerId?: string | null, departments?: Array<string | null> | null, userIds?: Array<string | null> | null, parentTask?: { __typename?: 'Task', id: string, name: string, projectId?: string | null, processId?: string | null, startDate: Date | string, endDate: Date | string } | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean, processTypeId?: string | null } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskResponsibles: { __typename?: 'TaskResponsiblesConnection', nodes: Array<{ __typename?: 'TaskResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskEmployees: { __typename?: 'TaskEmployeesConnection', nodes: Array<{ __typename?: 'TaskEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> }, scheduledMessages: { __typename?: 'ScheduledMessagesConnection', nodes: Array<{ __typename?: 'ScheduledMessage', id: string, senderEmployeeId: string, name: string, subject: string, body: string, active: boolean, sendDate: Date | string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageRecipients: { __typename?: 'ScheduledMessageRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageRecipient', scheduledMessageId: string, employeeId: string } | null> }, scheduledMessageExternalRecipients: { __typename?: 'ScheduledMessageExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageExternalRecipient', scheduledMessageId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> } } | null };

export type ProjectTemplateByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProjectTemplateByIdQuery = { __typename?: 'Query', projectTemplateById?: { __typename?: 'ProjectTemplate', id: string, name: string, order?: number | null, taskTemplatesByProjectId: { __typename?: 'TaskTemplatesConnection', nodes: Array<{ __typename?: 'TaskTemplate', id: string, name: string, order?: number | null, startDay: number, duration: number, deadlineReminder?: number | null, useCalendarEvent: boolean, calendarEventFrom?: string | null, calendarEventTo?: string | null, calendarEventOrganizerId?: string | null, notes?: string | null, projectId?: string | null, processId?: string | null, includeEmployee: boolean, includeDirectManager: boolean, includeEmployeeResponsible: boolean, includeDirectManagerResponsible: boolean, includeCustomEmployeeFields?: Array<string | null> | null, includeCustomEmployeeFieldsResponsibles?: Array<string | null> | null, includeGroups?: Array<string | null> | null, includeGroupsResponsibles?: Array<string | null> | null, parentTaskId?: string | null, parentTask?: { __typename?: 'TaskTemplate', id: string, name: string, projectId?: string | null, processId?: string | null, duration: number, startDay: number } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskTemplateResponsibles: { __typename?: 'TaskTemplateResponsiblesConnection', nodes: Array<{ __typename?: 'TaskTemplateResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskTemplateEmployees: { __typename?: 'TaskTemplateEmployeesConnection', nodes: Array<{ __typename?: 'TaskTemplateEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> }, scheduledMessageTemplatesByProjectId: { __typename?: 'ScheduledMessageTemplatesConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplate', id: string, name: string, subject: string, includeEmployee: boolean, includeDirectManager?: boolean | null, includeGroups?: Array<string | null> | null, includeCustomEmployeeFields?: Array<string | null> | null, body: string, active: boolean, startDay: number, duration: number, sendTime: string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'ProjectTemplate', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageTemplateRecipients: { __typename?: 'ScheduledMessageTemplateRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplateRecipient', scheduledMessageTemplateId: string, employeeId: string } | null> }, scheduledMessageTemplateExternalRecipients: { __typename?: 'ScheduledMessageTemplateExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplateExternalRecipient', scheduledMessageTemplateId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null> } } | null };

export type PulseSurveyQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PulseSurveyQuery = { __typename?: 'Query', pulseSurveyById?: { __typename?: 'PulseSurvey', id: string, name?: string | null, localizedName?: string | null, questionType: PulseSurveyQuestionType, question?: string | null, localizedQuestion?: string | null, anonymous: boolean, startDate: Date | string, surveyTime: string, endDate?: Date | string | null, isDraft: boolean, horizontal: boolean, ratingType: RatingType, invitedAll: boolean, invitedUserIds?: Array<string | null> | null, invitedDepartmentIds?: Array<string | null> | null, numberOfRecipients?: number | null, numberOfRecipientsLastYear?: number | null, lowestRating?: number | null, highestRating?: number | null, lowestRatingLabel?: string | null, highestRatingLabel?: string | null, averageRatingThisMonth?: string | number | null, averageRatingThisMonthLastYear?: string | number | null, averageRatingAllTime?: string | number | null, averageRatingAllTimeLastYear?: string | number | null, pulseTypeId?: string | null, nameTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null, questionTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null, lowestRatingLabelTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null, highestRatingLabelTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null, reminders?: Array<{ __typename?: 'Interval', minutes?: number | null, hours?: number | null, days?: number | null, months?: number | null, years?: number | null } | null> | null, pulseType?: { __typename?: 'PulseType', id: string, localizedName?: string | null } | null, recurrenceRuleByPulseSurveyId?: { __typename?: 'RecurrenceRule', id: string, frequency?: RecurrenceRuleFrequency | null, daysOfWeek?: Array<number | null> | null, daysOfMonth?: Array<number | null> | null, daysOfYear?: Array<number | null> | null } | null, pulseSurveyChoices: { __typename?: 'PulseSurveyChoicesConnection', nodes: Array<{ __typename?: 'PulseSurveyChoice', id: string, emoji?: string | null, order?: number | null, text?: string | null } | null> } } | null };

export type PulseSurveySidebarDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PulseSurveySidebarDataQuery = { __typename?: 'Query', pulseSurveyById?: { __typename?: 'PulseSurvey', id: string, localizedName?: string | null, localizedQuestion?: string | null, startDate: Date | string, endDate?: Date | string | null, surveyTime: string, isDraft: boolean, numberOfRecipients?: number | null, numberOfAnswersCollected?: number | null, readableQuestionType?: string | null, pulseType?: { __typename?: 'PulseType', id: string, localizedName?: string | null } | null, deadline: { __typename?: 'Interval', hours?: number | null, days?: number | null, months?: number | null, years?: number | null }, reminders?: Array<{ __typename?: 'Interval', hours?: number | null, days?: number | null, months?: number | null, years?: number | null } | null> | null, recurrenceRuleByPulseSurveyId?: { __typename?: 'RecurrenceRule', id: string, frequency?: RecurrenceRuleFrequency | null, daysOfWeek?: Array<number | null> | null, daysOfMonth?: Array<number | null> | null, daysOfYear?: Array<number | null> | null } | null } | null };

export type PulseSurveyAnswerPageDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PulseSurveyAnswerPageDataQuery = { __typename?: 'Query', pulseSurveyById?: { __typename?: 'PulseSurvey', id: string, questionType: PulseSurveyQuestionType, localizedQuestion?: string | null, horizontal: boolean, ratingType: RatingType, localizedLowestRatingLabel?: string | null, localizedHighestRatingLabel?: string | null, highestRating?: number | null, isOpenForAnswers?: boolean | null, pulseSurveyChoices: { __typename?: 'PulseSurveyChoicesConnection', nodes: Array<{ __typename?: 'PulseSurveyChoice', id: string, emoji?: string | null, order?: number | null, text?: string | null } | null> } } | null };

export type PulseSurveyCompletionPercentageQueryVariables = Exact<{
  id: Scalars['UUID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type PulseSurveyCompletionPercentageQuery = { __typename?: 'Query', pulseSurveyById?: { __typename?: 'PulseSurvey', id: string, completionPercentage?: number | null } | null };

export type GetPulseSurveyChartDataQueryVariables = Exact<{
  id: Scalars['UUID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  truncTo?: InputMaybe<Scalars['String']>;
}>;


export type GetPulseSurveyChartDataQuery = { __typename?: 'Query', getPulseSurveyChartData?: { __typename?: 'GetPulseSurveyChartDataConnection', nodes: Array<{ __typename?: 'GetPulseSurveyChartDataRecord', date?: Date | string | null, average?: number | null, numberOfAnswers?: string | number | null } | null> } | null, pulseSurveyById?: { __typename?: 'PulseSurvey', id: string, questionType: PulseSurveyQuestionType, lowestRating?: number | null, highestRating?: number | null, pulseSurveyChoices: { __typename?: 'PulseSurveyChoicesConnection', nodes: Array<{ __typename?: 'PulseSurveyChoice', id: string, emoji?: string | null, localizedText?: string | null } | null> } } | null };

export type PulseSurveysQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<PulseSurveyFilter>;
}>;


export type PulseSurveysQuery = { __typename?: 'Query', pulseSurveys?: { __typename?: 'PulseSurveysConnection', totalCount: number, edges: Array<{ __typename?: 'PulseSurveysEdge', node?: { __typename?: 'PulseSurvey', id: string, name?: string | null, localizedName?: string | null, questionType: PulseSurveyQuestionType, localizedQuestion?: string | null, anonymous: boolean, startDate: Date | string, surveyTime: string, endDate?: Date | string | null, isDraft: boolean, highestRating?: number | null, averageRatingAllTime?: string | number | null, averageRatingThisMonth?: string | number | null, averageRatingThisMonthLastYear?: string | number | null, averageRatingAllTimeLastYear?: string | number | null, invitedAll: boolean, recipients: { __typename?: 'PulseSurveyRecipientsConnection', nodes: Array<{ __typename?: 'PulseSurveyRecipient', id?: string | null, fullName?: string | null, logo?: string | null } | null> }, pulseType?: { __typename?: 'PulseType', id: string, localizedName?: string | null } | null, pulseSurveyChoices: { __typename?: 'PulseSurveyChoicesConnection', nodes: Array<{ __typename?: 'PulseSurveyChoice', id: string, emoji?: string | null } | null> } } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type PulseTypesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<PulseTypesOrderBy> | PulseTypesOrderBy>;
  filter?: InputMaybe<PulseTypeFilter>;
}>;


export type PulseTypesQuery = { __typename?: 'Query', pulseTypes?: { __typename?: 'PulseTypesConnection', totalCount: number, edges: Array<{ __typename?: 'PulseTypesEdge', node?: { __typename?: 'PulseType', id: string, localizedName?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type PulseTypeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PulseTypeQuery = { __typename?: 'Query', pulseTypeById?: { __typename?: 'PulseType', id: string, name?: string | null, nameTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null };

export type RoadmapItemsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<RoadmapItemsOrderBy> | RoadmapItemsOrderBy>;
  filter?: InputMaybe<RoadmapItemFilter>;
}>;


export type RoadmapItemsQuery = { __typename?: 'Query', roadmapItems?: { __typename?: 'RoadmapItemsConnection', totalCount: number, edges: Array<{ __typename?: 'RoadmapItemsEdge', node?: { __typename?: 'RoadmapItem', needToHaveVoteCount?: string | number | null, niceToHaveVoteCount?: string | number | null, commentCount?: string | number | null, id: string, name?: string | null, summary?: string | null, description?: string | null, stage: RoadmapStage } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type RoadmapItemsByStageQueryVariables = Exact<{
  stage: RoadmapStage;
  orderBy?: InputMaybe<Array<RoadmapItemsOrderBy> | RoadmapItemsOrderBy>;
}>;


export type RoadmapItemsByStageQuery = { __typename?: 'Query', roadmapItems?: { __typename?: 'RoadmapItemsConnection', nodes: Array<{ __typename?: 'RoadmapItem', id: string, name?: string | null, summary?: string | null, description?: string | null, stage: RoadmapStage } | null> } | null };

export type RoadmapItemByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RoadmapItemByIdQuery = { __typename?: 'Query', roadmapItemById?: { __typename?: 'RoadmapItem', needToHaveVoteCount?: string | number | null, niceToHaveVoteCount?: string | number | null, commentCount?: string | number | null, id: string, name?: string | null, summary?: string | null, description?: string | null, stage: RoadmapStage, roadmapItemLocalizations: { __typename?: 'RoadmapItemLocalizationsConnection', nodes: Array<{ __typename?: 'RoadmapItemLocalization', id: string, locale: string, name: string, summary: string, description: string } | null> } } | null };

export type RoadmapItemVoteByUserIdAndRoadmapItemIdQueryVariables = Exact<{
  userId: Scalars['UUID'];
  roadmapItemId: Scalars['UUID'];
}>;


export type RoadmapItemVoteByUserIdAndRoadmapItemIdQuery = { __typename?: 'Query', roadmapItemVoteByUserIdAndRoadmapItemId?: { __typename?: 'RoadmapItemVote', id: string, roadmapItemId: string, userId: string, voteType: RoadmapItemVoteType } | null };

export type GetVotersForItemQueryVariables = Exact<{
  roadmapItemId: Scalars['UUID'];
}>;


export type GetVotersForItemQuery = { __typename?: 'Query', roadmapItemVotes?: { __typename?: 'RoadmapItemVotesConnection', nodes: Array<{ __typename?: 'RoadmapItemVote', id: string, roadmapItemId: string, userId: string, voteType: RoadmapItemVoteType, user?: { __typename?: 'User', id: string, fullName?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null } | null } | null } | null> } | null };

export type GetRoadmapItemCommentsQueryVariables = Exact<{
  roadmapItemId?: InputMaybe<Scalars['UUID']>;
}>;


export type GetRoadmapItemCommentsQuery = { __typename?: 'Query', roadmapItemComments?: { __typename?: 'RoadmapItemCommentsConnection', nodes: Array<{ __typename?: 'RoadmapItemComment', id: string, roadmapItemId: string, userId: string, comment?: string | null, createdAt: Date | string, user?: { __typename?: 'RoadmapItemCommentUserRecord', id?: string | null, fullName?: string | null, logo?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null } | null } | null } | null> } | null };

export type AllRoadmapCommentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<RoadmapItemCommentsOrderBy> | RoadmapItemCommentsOrderBy>;
  filter?: InputMaybe<RoadmapItemCommentFilter>;
}>;


export type AllRoadmapCommentsQuery = { __typename?: 'Query', roadmapItemComments?: { __typename?: 'RoadmapItemCommentsConnection', totalCount: number, edges: Array<{ __typename?: 'RoadmapItemCommentsEdge', node?: { __typename?: 'RoadmapItemComment', id: string, createdAt: Date | string, comment?: string | null, user?: { __typename?: 'RoadmapItemCommentUserRecord', id?: string | null, fullName?: string | null, logo?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null } | null } | null, roadmapItem?: { __typename?: 'RoadmapItem', id: string, name?: string | null, summary?: string | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type UserRolesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserRoleFilter>;
}>;


export type UserRolesQuery = { __typename?: 'Query', userRoles?: { __typename?: 'UserRolesConnection', edges: Array<{ __typename?: 'UserRolesEdge', node?: { __typename?: 'UserRole', userId: string, roleId: string, excludeRole: boolean, role?: { __typename?: 'Role', id: string, info: string, name: string, scopes?: Array<RoleScope | null> | null, usesItemIds: boolean } | null } | null }> } | null };

export type UserDepartmentRolesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserDepartmentRoleFilter>;
}>;


export type UserDepartmentRolesQuery = { __typename?: 'Query', userDepartmentRoles?: { __typename?: 'UserDepartmentRolesConnection', edges: Array<{ __typename?: 'UserDepartmentRolesEdge', node?: { __typename?: 'UserDepartmentRole', userId: string, roleId: string, departmentId: string, excludeRole: boolean, inheritToDescendants: boolean, onlyIncludeInDescendants: boolean, role?: { __typename?: 'Role', id: string, info: string, name: string, scopes?: Array<RoleScope | null> | null, usesItemIds: boolean } | null } | null }> } | null };

export type UserCompanyRolesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserCompanyRoleFilter>;
}>;


export type UserCompanyRolesQuery = { __typename?: 'Query', userCompanyRoles?: { __typename?: 'UserCompanyRolesConnection', edges: Array<{ __typename?: 'UserCompanyRolesEdge', node?: { __typename?: 'UserCompanyRole', userId: string, roleId: string, excludeRole: boolean, role?: { __typename?: 'Role', id: string, info: string, name: string, scopes?: Array<RoleScope | null> | null, usesItemIds: boolean } | null } | null }> } | null };

export type ScheduledMessagesQueryVariables = Exact<{
  employeeId?: InputMaybe<Scalars['UUID']>;
  filter?: InputMaybe<ScheduledMessageFilter>;
  includeRelations: Scalars['Boolean'];
}>;


export type ScheduledMessagesQuery = { __typename?: 'Query', scheduledMessages?: { __typename?: 'ScheduledMessagesConnection', edges: Array<{ __typename?: 'ScheduledMessagesEdge', node?: { __typename?: 'ScheduledMessage', id: string, senderEmployeeId: string, name: string, subject: string, body: string, active: boolean, sendDate: Date | string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageRecipients: { __typename?: 'ScheduledMessageRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageRecipient', scheduledMessageId: string, employeeId: string } | null> }, scheduledMessageExternalRecipients: { __typename?: 'ScheduledMessageExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageExternalRecipient', scheduledMessageId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null }> } | null };

export type ScheduledMessageTemplatesQueryVariables = Exact<{
  filter?: InputMaybe<ScheduledMessageTemplateFilter>;
  includeRelations: Scalars['Boolean'];
}>;


export type ScheduledMessageTemplatesQuery = { __typename?: 'Query', scheduledMessageTemplates?: { __typename?: 'ScheduledMessageTemplatesConnection', edges: Array<{ __typename?: 'ScheduledMessageTemplatesEdge', node?: { __typename?: 'ScheduledMessageTemplate', id: string, name: string, subject: string, includeEmployee: boolean, includeDirectManager?: boolean | null, includeGroups?: Array<string | null> | null, includeCustomEmployeeFields?: Array<string | null> | null, body: string, active: boolean, startDay: number, duration: number, sendTime: string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'ProjectTemplate', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageTemplateRecipients: { __typename?: 'ScheduledMessageTemplateRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplateRecipient', scheduledMessageTemplateId: string, employeeId: string } | null> }, scheduledMessageTemplateExternalRecipients: { __typename?: 'ScheduledMessageTemplateExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplateExternalRecipient', scheduledMessageTemplateId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null }> } | null };

export type ScheduledMessageQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ScheduledMessageQuery = { __typename?: 'Query', scheduledMessageById?: { __typename?: 'ScheduledMessage', id: string, senderEmployeeId: string, name: string, subject: string, body: string, active: boolean, sendDate: Date | string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageRecipients: { __typename?: 'ScheduledMessageRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageRecipient', scheduledMessageId: string, employeeId: string } | null> }, scheduledMessageExternalRecipients: { __typename?: 'ScheduledMessageExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageExternalRecipient', scheduledMessageId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null };

export type ScheduledMessageTemplateQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ScheduledMessageTemplateQuery = { __typename?: 'Query', scheduledMessageTemplateById?: { __typename?: 'ScheduledMessageTemplate', id: string, name: string, subject: string, includeEmployee: boolean, includeDirectManager?: boolean | null, includeGroups?: Array<string | null> | null, includeCustomEmployeeFields?: Array<string | null> | null, body: string, active: boolean, startDay: number, duration: number, sendTime: string, order?: number | null, processId?: string | null, projectId?: string | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null, project?: { __typename?: 'ProjectTemplate', id: string, name: string, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, scheduledMessageTemplateRecipients: { __typename?: 'ScheduledMessageTemplateRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplateRecipient', scheduledMessageTemplateId: string, employeeId: string } | null> }, scheduledMessageTemplateExternalRecipients: { __typename?: 'ScheduledMessageTemplateExternalRecipientsConnection', nodes: Array<{ __typename?: 'ScheduledMessageTemplateExternalRecipient', scheduledMessageTemplateId: string, email: string, fullName: string, locale: string } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null };

export type FileIdToUrlQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type FileIdToUrlQuery = { __typename?: 'Query', storageIdToDirectUrl?: { __typename?: 'storageDirectUrlPayload', url?: string | null } | null };

export type SystemFieldsQueryVariables = Exact<{
  filter?: InputMaybe<SystemFieldFilter>;
  locale?: InputMaybe<Scalars['String']>;
  getUserData: Scalars['Boolean'];
  userIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type SystemFieldsQuery = { __typename?: 'Query', systemFields?: { __typename?: 'SystemFieldsConnection', edges: Array<{ __typename?: 'SystemFieldsEdge', node?: { __typename?: 'SystemField', id: string, name: string, type?: string | null, readableName?: string | null, localizedName?: string | null, readOnly: boolean, documentTemplatePlaceholderName?: string | null, excludeFromPlaceholderForm: boolean, alwaysRequired: boolean, userSystemFields?: { __typename?: 'UserSystemFieldsConnection', nodes: Array<{ __typename?: 'UserSystemField', data?: any | null, humanReadableValue?: string | null, userId: string } | null> }, companySystemField?: { __typename?: 'CompanySystemField', id: string, sensitive: boolean, changesMustBeApproved: boolean, supportsFutureData: boolean, required: boolean, defaultValue?: string | null, fieldGroupId?: string | null, metadata?: any | null, localizedAlias?: string | null, localizedHelpText?: string | null, fieldGroup?: { __typename?: 'FieldGroup', id: string, localizedName?: string | null } | null, companySystemFieldOptions: { __typename?: 'CompanySystemFieldOptionsConnection', nodes: Array<{ __typename?: 'CompanySystemFieldOption', id: string, value: string, localizedValue?: string | null } | null> } } | null } | null }> } | null };

export type CompanySystemFieldQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CompanySystemFieldQuery = { __typename?: 'Query', companySystemFieldById?: { __typename?: 'CompanySystemField', id: string, sensitive: boolean, changesMustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, supportsFutureData: boolean, required: boolean, uniqueValue?: boolean | null, metadata?: any | null, defaultValue?: string | null, fieldGroupId?: string | null, alias?: string | null, helpText?: string | null, excludedRoleIds?: Array<string | null> | null, aliasTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null, helpTextTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null, systemField?: { __typename?: 'SystemField', id: string, name: string, readableName?: string | null } | null, companySystemFieldOptions: { __typename?: 'CompanySystemFieldOptionsConnection', nodes: Array<{ __typename?: 'CompanySystemFieldOption', id: string, order: number, value: string } | null> } } | null };

export type CompanySystemFieldOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanySystemFieldOptionsQuery = { __typename?: 'Query', companySystemFieldOptions?: { __typename?: 'CompanySystemFieldOptionsConnection', edges: Array<{ __typename?: 'CompanySystemFieldOptionsEdge', node?: { __typename?: 'CompanySystemFieldOption', id: string, value: string } | null }> } | null };

export type JobPositionTypeOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type JobPositionTypeOptionsQuery = { __typename?: 'Query', companySystemFieldOptions?: { __typename?: 'CompanySystemFieldOptionsConnection', edges: Array<{ __typename?: 'CompanySystemFieldOptionsEdge', node?: { __typename?: 'CompanySystemFieldOption', id: string, name?: string | null } | null }> } | null };

export type JobPositionWorkingHoursOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type JobPositionWorkingHoursOptionsQuery = { __typename?: 'Query', companySystemFieldOptions?: { __typename?: 'CompanySystemFieldOptionsConnection', edges: Array<{ __typename?: 'CompanySystemFieldOptionsEdge', node?: { __typename?: 'CompanySystemFieldOption', id: string, name?: string | null } | null }> } | null };

export type UserSystemFieldCountQueryVariables = Exact<{
  employeeIds: Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>;
}>;


export type UserSystemFieldCountQuery = { __typename?: 'Query', userDepartmentCount?: string | number | null, userSystemFieldCount?: { __typename?: 'UserSystemFieldCountConnection', nodes: Array<{ __typename?: 'UserSystemFieldCountRecord', count?: string | number | null, value?: string | null } | null> } | null };

export type UserSystemFieldsQueryVariables = Exact<{
  id: Scalars['UUID'];
  companyId: Scalars['UUID'];
  employeeIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type UserSystemFieldsQuery = { __typename?: 'Query', userSystemFields?: { __typename?: 'UserSystemFieldsConnection', nodes: Array<{ __typename?: 'UserSystemField', systemFieldId: string, userId: string, data?: any | null } | null> } | null };

export type TaskQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TaskQuery = { __typename?: 'Query', taskById?: { __typename?: 'Task', id: string, name: string, order?: number | null, startDate: Date | string, endDate: Date | string, deadlineReminderDate?: Date | string | null, notes?: string | null, projectId?: string | null, processId?: string | null, parentTaskId?: string | null, completed: boolean, archived: boolean, calendarEventFrom?: Date | string | null, calendarEventTo?: Date | string | null, calendarEventOrganizerId?: string | null, departments?: Array<string | null> | null, userIds?: Array<string | null> | null, parentTask?: { __typename?: 'Task', id: string, name: string, projectId?: string | null, processId?: string | null, startDate: Date | string, endDate: Date | string } | null, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean, processTypeId?: string | null } | null, project?: { __typename?: 'Project', id: string, name: string, active: boolean } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskResponsibles: { __typename?: 'TaskResponsiblesConnection', nodes: Array<{ __typename?: 'TaskResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskEmployees: { __typename?: 'TaskEmployeesConnection', nodes: Array<{ __typename?: 'TaskEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null };

export type TaskTemplateQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TaskTemplateQuery = { __typename?: 'Query', taskTemplateById?: { __typename?: 'TaskTemplate', id: string, name: string, order?: number | null, startDay: number, duration: number, deadlineReminder?: number | null, useCalendarEvent: boolean, calendarEventFrom?: string | null, calendarEventTo?: string | null, calendarEventOrganizerId?: string | null, notes?: string | null, projectId?: string | null, processId?: string | null, includeEmployee: boolean, includeDirectManager: boolean, includeEmployeeResponsible: boolean, includeDirectManagerResponsible: boolean, includeCustomEmployeeFields?: Array<string | null> | null, includeCustomEmployeeFieldsResponsibles?: Array<string | null> | null, includeGroups?: Array<string | null> | null, includeGroupsResponsibles?: Array<string | null> | null, parentTaskId?: string | null, parentTask?: { __typename?: 'TaskTemplate', id: string, name: string, projectId?: string | null, processId?: string | null, duration: number, startDay: number } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskTemplateResponsibles: { __typename?: 'TaskTemplateResponsiblesConnection', nodes: Array<{ __typename?: 'TaskTemplateResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskTemplateEmployees: { __typename?: 'TaskTemplateEmployeesConnection', nodes: Array<{ __typename?: 'TaskTemplateEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null };

export type TaskNotesMappingsQueryVariables = Exact<{
  assignedToIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  responsibleIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
}>;


export type TaskNotesMappingsQuery = { __typename?: 'Query', assignedTo?: { __typename?: 'EmployeesConnection', nodes: Array<{ __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null> } | null, responsibles?: { __typename?: 'EmployeesConnection', nodes: Array<{ __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null> } | null };

export type TasksQueryVariables = Exact<{
  filter?: InputMaybe<TaskFilter>;
  after?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  includeRelations: Scalars['Boolean'];
  orderBy?: InputMaybe<Array<TasksOrderBy> | TasksOrderBy>;
}>;


export type TasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TasksConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'TasksEdge', node?: { __typename?: 'Task', id: string, name: string, order?: number | null, startDate: Date | string, endDate: Date | string, deadlineReminderDate?: Date | string | null, notes?: string | null, projectId?: string | null, processId?: string | null, parentTaskId?: string | null, completed: boolean, archived: boolean, calendarEventFrom?: Date | string | null, calendarEventTo?: Date | string | null, calendarEventOrganizerId?: string | null, departments?: Array<string | null> | null, userIds?: Array<string | null> | null, process?: { __typename?: 'Process', id: string, employeeId?: string | null, name?: string | null, active: boolean, processTypeId?: string | null, simpleUser?: { __typename?: 'SimpleUser', id?: string | null, fullName?: string | null, logo?: string | null } | null, employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null } | null, project?: { __typename?: 'Project', id: string, name: string, order?: number | null, active: boolean, process?: { __typename?: 'Process', id: string, name?: string | null, active: boolean } | null } | null, parentTask?: { __typename?: 'Task', id: string, name: string, projectId?: string | null, processId?: string | null, startDate: Date | string, endDate: Date | string } | null, simpleAssignees?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, simpleResponsibles?: Array<{ __typename?: 'SimpleUser', id?: string | null, employeeId?: string | null, fullName?: string | null, logo?: string | null } | null> | null, taskResponsibles: { __typename?: 'TaskResponsiblesConnection', nodes: Array<{ __typename?: 'TaskResponsible', responsible?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, taskEmployees: { __typename?: 'TaskEmployeesConnection', nodes: Array<{ __typename?: 'TaskEmployee', employee?: { __typename?: 'Employee', id: string, user?: { __typename?: 'User', id: string, logo?: string | null, fullName?: string | null } | null } | null } | null> }, storages: { __typename?: 'StoragesConnection', nodes: Array<{ __typename?: 'Storage', id: string, filename: string, fileExtension: string } | null> } } | null }> } | null };

export type TaskCompletedByQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TaskCompletedByQuery = { __typename?: 'Query', taskById?: { __typename?: 'Task', id: string, userByCompletedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null };

export type UpcomingTasksQueryVariables = Exact<{
  currentDate?: InputMaybe<Scalars['Datetime']>;
  employeeId?: InputMaybe<Scalars['UUID']>;
}>;


export type UpcomingTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TasksConnection', totalCount: number } | null };

export type CurrentPresenceQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type CurrentPresenceQuery = { __typename?: 'Query', timeRegistrationPresences?: { __typename?: 'TimeRegistrationPresencesConnection', nodes: Array<{ __typename?: 'TimeRegistrationPresence', id: string, startDate: Date | string, endDate?: Date | string | null, note?: string | null, timeRegistrationPresenceType?: { __typename?: 'TimeRegistrationPresenceType', id: string, localizedName?: string | null, emoji: string } | null, timeRegistrationEntries: { __typename?: 'TimeRegistrationEntriesConnection', nodes: Array<{ __typename?: 'TimeRegistrationEntry', id: string, startDate: Date | string, endDate?: Date | string | null, timeRegistrationProject?: { __typename?: 'TimeRegistrationProject', id: string, localizedName?: string | null, color: string } | null, timeRegistrationBreakType?: { __typename?: 'TimeRegistrationBreakType', id: string, localizedName?: string | null, emoji: string } | null } | null> } } | null> } | null };

export type TimeRegistrationPresenceTypesAndProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type TimeRegistrationPresenceTypesAndProjectsQuery = { __typename?: 'Query', timeRegistrationPresenceTypes?: { __typename?: 'TimeRegistrationPresenceTypesConnection', nodes: Array<{ __typename?: 'TimeRegistrationPresenceType', id: string, localizedName?: string | null, emoji: string } | null> } | null, recentTimeRegistrationPresenceTypes?: { __typename?: 'TimeRegistrationPresenceTypesConnection', nodes: Array<{ __typename?: 'TimeRegistrationPresenceType', id: string, localizedName?: string | null, emoji: string } | null> } | null, timeRegistrationProjects?: { __typename?: 'TimeRegistrationProjectsConnection', nodes: Array<{ __typename?: 'TimeRegistrationProject', id: string, localizedName?: string | null, color: string } | null> } | null, recentTimeRegistrationProjects?: { __typename?: 'TimeRegistrationProjectsConnection', nodes: Array<{ __typename?: 'TimeRegistrationProject', id: string, localizedName?: string | null, color: string } | null> } | null };

export type TimeRegistrationSummaryQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TimeRegistrationSummaryQuery = { __typename?: 'Query', timeRegistrationPresenceById?: { __typename?: 'TimeRegistrationPresence', id: string, startDate: Date | string, endDate?: Date | string | null, timeRegistrationPresenceTypeId: string, timeRegistrationEntries: { __typename?: 'TimeRegistrationEntriesConnection', nodes: Array<{ __typename?: 'TimeRegistrationEntry', id: string, startDate: Date | string, endDate?: Date | string | null, timeRegistrationProjectId?: string | null, timeRegistrationBreakTypeId?: string | null } | null> } } | null };

export type TimeRegistrationBreakTypesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<TimeRegistrationBreakTypesOrderBy> | TimeRegistrationBreakTypesOrderBy>;
  filter?: InputMaybe<TimeRegistrationBreakTypeFilter>;
  companyId: Scalars['UUID'];
}>;


export type TimeRegistrationBreakTypesQuery = { __typename?: 'Query', timeRegistrationBreakTypes?: { __typename?: 'TimeRegistrationBreakTypesConnection', totalCount: number, edges: Array<{ __typename?: 'TimeRegistrationBreakTypesEdge', node?: { __typename?: 'TimeRegistrationBreakType', id: string, localizedName?: string | null, emoji: string, paidTime: { __typename?: 'Interval', hours?: number | null, minutes?: number | null } } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type TimeRegistrationBreakTypeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TimeRegistrationBreakTypeQuery = { __typename?: 'Query', timeRegistrationBreakTypeById?: { __typename?: 'TimeRegistrationBreakType', id: string, name?: string | null, code?: string | null, emoji: string, nameTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null, paidTime: { __typename?: 'Interval', hours?: number | null, minutes?: number | null } } | null };

export type TimeRegistrationEntryByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TimeRegistrationEntryByIdQuery = { __typename?: 'Query', timeRegistrationEntryById?: { __typename?: 'TimeRegistrationEntry', id: string, timeRegistrationEntryType: TimeRegistrationEntryType, timeRegistrationBreakTypeId?: string | null, timeRegistrationProjectId?: string | null, startDate: Date | string, endDate?: Date | string | null, note?: string | null } | null };

export type TimeRegistrationWeekOverviewQueryVariables = Exact<{
  startDate: Scalars['Datetime'];
  endDate: Scalars['Datetime'];
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderDirection?: InputMaybe<Scalars['String']>;
}>;


export type TimeRegistrationWeekOverviewQuery = { __typename?: 'Query', timeRegistrationWeekOverview?: { __typename?: 'TimeRegistrationWeekOverviewConnection', totalCount: number, edges: Array<{ __typename?: 'TimeRegistrationWeekOverviewEdge', node?: { __typename?: 'TimeRegistrationWeekOverviewRecord', weekStart?: Date | string | null, totalWorkTime?: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null } | null, totalBreakTime?: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null } | null } | null }> } | null };

export type TimeRegistrationDepartmentOverviewQueryVariables = Exact<{
  startDate: Scalars['Datetime'];
  endDate: Scalars['Datetime'];
}>;


export type TimeRegistrationDepartmentOverviewQuery = { __typename?: 'Query', timeRegistrationDepartmentOverview?: { __typename?: 'TimeRegistrationDepartmentOverviewConnection', edges: Array<{ __typename?: 'TimeRegistrationDepartmentOverviewEdge', node?: { __typename?: 'TimeRegistrationDepartmentOverviewRecord', departmentId?: string | null, name?: string | null, numberOfEmployees?: string | number | null, numberOfWarnings?: string | number | null, hoursThisWeek?: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null } | null } | null }> } | null };

export type TimeRegistrationUserOverviewQueryVariables = Exact<{
  startDate: Scalars['Datetime'];
  endDate: Scalars['Datetime'];
  departmentId: Scalars['UUID'];
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type TimeRegistrationUserOverviewQuery = { __typename?: 'Query', timeRegistrationUserOverview?: { __typename?: 'TimeRegistrationUserOverviewConnection', totalCount: number, edges: Array<{ __typename?: 'TimeRegistrationUserOverviewEdge', node?: { __typename?: 'TimeRegistrationUserOverviewRecord', userId?: string | null, fullName?: string | null, logo?: string | null, averageWeeklyHoursLastFourMonths?: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null } | null, hoursThisWeek?: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null } | null, breaksThisWeek?: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null } | null } | null }> } | null };

export type GetTimeRegistrationsInRangeForUserQueryVariables = Exact<{
  from: Scalars['Datetime'];
  to: Scalars['Datetime'];
  userId: Scalars['UUID'];
  companyId: Scalars['UUID'];
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetTimeRegistrationsInRangeForUserQuery = { __typename?: 'Query', timeRegistrationPresences?: { __typename?: 'TimeRegistrationPresencesConnection', totalCount: number, edges: Array<{ __typename?: 'TimeRegistrationPresencesEdge', node?: { __typename?: 'TimeRegistrationPresence', id: string, weekNumber?: number | null, weekStartDate?: Date | string | null, startDate: Date | string, endDate?: Date | string | null, note?: string | null, compliesWithElevenHourRule?: boolean | null, elapsedTime?: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null } | null, restTime?: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null } | null, timeRegistrationPresenceType?: { __typename?: 'TimeRegistrationPresenceType', id: string, localizedName?: string | null, emoji: string } | null, projects: { __typename?: 'TimeRegistrationEntriesConnection', nodes: Array<{ __typename?: 'TimeRegistrationEntry', id: string, note?: string | null, timeRegistrationProject?: { __typename?: 'TimeRegistrationProject', id: string, localizedName?: string | null, color: string } | null } | null> } } | null }> } | null };

export type GetTimeRegistrationEntriesForPresenceQueryVariables = Exact<{
  timeRegistrationPresenceId: Scalars['UUID'];
}>;


export type GetTimeRegistrationEntriesForPresenceQuery = { __typename?: 'Query', timeRegistrationEntries?: { __typename?: 'TimeRegistrationEntriesConnection', edges: Array<{ __typename?: 'TimeRegistrationEntriesEdge', node?: { __typename?: 'TimeRegistrationEntry', id: string, startDate: Date | string, endDate?: Date | string | null, timeRegistrationEntryType: TimeRegistrationEntryType, note?: string | null, elapsedTime?: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null } | null, timeRegistrationProject?: { __typename?: 'TimeRegistrationProject', id: string, localizedName?: string | null, color: string } | null, timeRegistrationBreakType?: { __typename?: 'TimeRegistrationBreakType', id: string, localizedName?: string | null, emoji: string } | null } | null }> } | null };

export type TimeRegistrationPresenceProfileQueryVariables = Exact<{
  userId: Scalars['UUID'];
  from: Scalars['Datetime'];
  to: Scalars['Datetime'];
  orderBy?: InputMaybe<Array<TimeRegistrationPresencesOrderBy> | TimeRegistrationPresencesOrderBy>;
}>;


export type TimeRegistrationPresenceProfileQuery = { __typename?: 'Query', timeRegistrationPresences?: { __typename?: 'TimeRegistrationPresencesConnection', nodes: Array<{ __typename?: 'TimeRegistrationPresence', id: string, startDate: Date | string, endDate?: Date | string | null, timeRegistrationPresenceType?: { __typename?: 'TimeRegistrationPresenceType', id: string, localizedName?: string | null, emoji: string } | null, timeRegistrationEntries: { __typename?: 'TimeRegistrationEntriesConnection', nodes: Array<{ __typename?: 'TimeRegistrationEntry', id: string, startDate: Date | string, endDate?: Date | string | null, timeRegistrationEntryType: TimeRegistrationEntryType, timeRegistrationProject?: { __typename?: 'TimeRegistrationProject', id: string, localizedName?: string | null, color: string } | null, timeRegistrationBreakType?: { __typename?: 'TimeRegistrationBreakType', id: string, localizedName?: string | null } | null } | null> } } | null> } | null, weeklyRegisteredTime?: { __typename?: 'TimeRegistrationRegisteredTimeConnection', nodes: Array<{ __typename?: 'TimeRegistrationRegisteredTimeRecord', date?: Date | string | null, registeredTime?: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null } | null } | null> } | null, dailyRegisteredTime?: { __typename?: 'TimeRegistrationRegisteredTimeConnection', nodes: Array<{ __typename?: 'TimeRegistrationRegisteredTimeRecord', date?: Date | string | null, registeredTime?: { __typename?: 'Interval', days?: number | null, hours?: number | null, minutes?: number | null } | null } | null> } | null };

export type TimeRegistrationsPendingApprovalQueryVariables = Exact<{ [key: string]: never; }>;


export type TimeRegistrationsPendingApprovalQuery = { __typename?: 'Query', timeRegistrationsPendingApproval?: { __typename?: 'TimeRegistrationsPendingApprovalConnection', nodes: Array<{ __typename?: 'TimeRegistrationsPendingApprovalRecord', startDate?: Date | string | null, endDate?: Date | string | null, deadline?: Date | string | null } | null> } | null };

export type TimeRegistrationPresenceByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TimeRegistrationPresenceByIdQuery = { __typename?: 'Query', timeRegistrationPresenceById?: { __typename?: 'TimeRegistrationPresence', id: string, timeRegistrationPresenceTypeId: string, startDate: Date | string, endDate?: Date | string | null, note?: string | null } | null };

export type TimeRegistrationPresenceTemplatesQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type TimeRegistrationPresenceTemplatesQuery = { __typename?: 'Query', timeRegistrationPresenceTemplates?: { __typename?: 'TimeRegistrationPresenceTemplatesConnection', nodes: Array<{ __typename?: 'TimeRegistrationPresenceTemplate', id: string, dayOfWeek: number, startTime: string, endTime: string, timeRegistrationPresenceTypeId: string, timeRegistrationEntryTemplates: { __typename?: 'TimeRegistrationEntryTemplatesConnection', nodes: Array<{ __typename?: 'TimeRegistrationEntryTemplate', id: string, startTime: string, endTime: string, timeRegistrationEntryType: TimeRegistrationEntryType, timeRegistrationProjectId?: string | null, timeRegistrationBreakTypeId?: string | null } | null> } } | null> } | null, timeRegistrationTemplateWeeks?: { __typename?: 'TimeRegistrationTemplateWeeksConnection', nodes: Array<{ __typename?: 'TimeRegistrationTemplateWeek', id: string, weekIndex: number, timeRegistrationPresenceTemplates: { __typename?: 'TimeRegistrationPresenceTemplatesConnection', nodes: Array<{ __typename?: 'TimeRegistrationPresenceTemplate', id: string, dayOfWeek: number, startTime: string, endTime: string, timeRegistrationPresenceTypeId: string, timeRegistrationEntryTemplates: { __typename?: 'TimeRegistrationEntryTemplatesConnection', nodes: Array<{ __typename?: 'TimeRegistrationEntryTemplate', id: string, startTime: string, endTime: string, timeRegistrationEntryType: TimeRegistrationEntryType, timeRegistrationProjectId?: string | null, timeRegistrationBreakTypeId?: string | null } | null> } } | null> } } | null> } | null };

export type TimeRegistrationTemplatePresenceTemplatesQueryVariables = Exact<{
  timeRegistrationTemplateId: Scalars['UUID'];
}>;


export type TimeRegistrationTemplatePresenceTemplatesQuery = { __typename?: 'Query', timeRegistrationTemplateById?: { __typename?: 'TimeRegistrationTemplate', useMultiWeek: boolean, timeRegistrationPresenceTemplates: { __typename?: 'TimeRegistrationPresenceTemplatesConnection', nodes: Array<{ __typename?: 'TimeRegistrationPresenceTemplate', id: string, dayOfWeek: number, startTime: string, endTime: string, timeRegistrationPresenceTypeId: string, timeRegistrationEntryTemplates: { __typename?: 'TimeRegistrationEntryTemplatesConnection', nodes: Array<{ __typename?: 'TimeRegistrationEntryTemplate', id: string, startTime: string, endTime: string, timeRegistrationEntryType: TimeRegistrationEntryType, timeRegistrationProjectId?: string | null, timeRegistrationBreakTypeId?: string | null } | null> } } | null> }, timeRegistrationTemplateWeeks: { __typename?: 'TimeRegistrationTemplateWeeksConnection', nodes: Array<{ __typename?: 'TimeRegistrationTemplateWeek', id: string, weekIndex: number, timeRegistrationPresenceTemplates: { __typename?: 'TimeRegistrationPresenceTemplatesConnection', nodes: Array<{ __typename?: 'TimeRegistrationPresenceTemplate', id: string, dayOfWeek: number, startTime: string, endTime: string, timeRegistrationPresenceTypeId: string, timeRegistrationEntryTemplates: { __typename?: 'TimeRegistrationEntryTemplatesConnection', nodes: Array<{ __typename?: 'TimeRegistrationEntryTemplate', id: string, startTime: string, endTime: string, timeRegistrationEntryType: TimeRegistrationEntryType, timeRegistrationProjectId?: string | null, timeRegistrationBreakTypeId?: string | null } | null> } } | null> } } | null> } } | null };

export type TimeRegistrationPresenceTypesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<TimeRegistrationPresenceTypesOrderBy> | TimeRegistrationPresenceTypesOrderBy>;
  filter?: InputMaybe<TimeRegistrationPresenceTypeFilter>;
  companyId: Scalars['UUID'];
}>;


export type TimeRegistrationPresenceTypesQuery = { __typename?: 'Query', timeRegistrationPresenceTypes?: { __typename?: 'TimeRegistrationPresenceTypesConnection', totalCount: number, edges: Array<{ __typename?: 'TimeRegistrationPresenceTypesEdge', node?: { __typename?: 'TimeRegistrationPresenceType', id: string, localizedName?: string | null, emoji: string } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type TimeRegistrationPresenceTypeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TimeRegistrationPresenceTypeQuery = { __typename?: 'Query', timeRegistrationPresenceTypeById?: { __typename?: 'TimeRegistrationPresenceType', id: string, code?: string | null, name?: string | null, emoji: string, nameTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null };

export type TimeRegistrationProjectsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<TimeRegistrationProjectsOrderBy> | TimeRegistrationProjectsOrderBy>;
  filter?: InputMaybe<TimeRegistrationProjectFilter>;
  companyId: Scalars['UUID'];
}>;


export type TimeRegistrationProjectsQuery = { __typename?: 'Query', timeRegistrationProjects?: { __typename?: 'TimeRegistrationProjectsConnection', totalCount: number, edges: Array<{ __typename?: 'TimeRegistrationProjectsEdge', node?: { __typename?: 'TimeRegistrationProject', id: string, localizedName?: string | null, localizedDescription?: string | null, color: string } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type TimeRegistrationProjectQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TimeRegistrationProjectQuery = { __typename?: 'Query', timeRegistrationProjectById?: { __typename?: 'TimeRegistrationProject', id: string, name?: string | null, code?: string | null, description?: string | null, color: string, nameTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null, descriptionTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null };

export type TimeRegistrationTemplatesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<TimeRegistrationTemplatesOrderBy> | TimeRegistrationTemplatesOrderBy>;
  filter?: InputMaybe<TimeRegistrationTemplateFilter>;
  companyId: Scalars['UUID'];
}>;


export type TimeRegistrationTemplatesQuery = { __typename?: 'Query', timeRegistrationTemplates?: { __typename?: 'TimeRegistrationTemplatesConnection', totalCount: number, edges: Array<{ __typename?: 'TimeRegistrationTemplatesEdge', node?: { __typename?: 'TimeRegistrationTemplate', id: string, localizedName?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type TimeRegistrationTemplateQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TimeRegistrationTemplateQuery = { __typename?: 'Query', timeRegistrationTemplateById?: { __typename?: 'TimeRegistrationTemplate', id: string, name?: string | null, nameTranslatedEntity?: { __typename?: 'TranslatedEntity', id: string, translatedEntityLocalizations: { __typename?: 'TranslatedEntityLocalizationsConnection', nodes: Array<{ __typename?: 'TranslatedEntityLocalization', id: string, locale: string, translation: string } | null> } } | null } | null };

export type AllTranslationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<TranslationFilter>;
}>;


export type AllTranslationsQuery = { __typename?: 'Query', translations?: { __typename?: 'TranslationsConnection', edges: Array<{ __typename?: 'TranslationsEdge', node?: { __typename?: 'Translation', id: string, text?: string | null, translation?: string | null, from?: string | null, to?: string | null } | null }> } | null };

export type I18onQueryVariables = Exact<{
  locale: Scalars['String'];
  strings: Array<Scalars['String']> | Scalars['String'];
}>;


export type I18onQuery = { __typename?: 'Query', i18on?: any | null };

export type UserDepartmentsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type UserDepartmentsQuery = { __typename?: 'Query', userDepartments?: { __typename?: 'UserDepartmentsConnection', edges: Array<{ __typename?: 'UserDepartmentsEdge', node?: { __typename?: 'UserDepartment', userId: string, departmentId: string, department?: { __typename?: 'Department', id: string, name: string } | null, rank?: { __typename?: 'Rank', id: string, name: string } | null } | null }> } | null };

export type UsersDepartmentsQueryVariables = Exact<{
  userId?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type UsersDepartmentsQuery = { __typename?: 'Query', userDepartments?: { __typename?: 'UserDepartmentsConnection', edges: Array<{ __typename?: 'UserDepartmentsEdge', node?: { __typename?: 'UserDepartment', userId: string, departmentId: string, department?: { __typename?: 'Department', id: string, name: string } | null, rank?: { __typename?: 'Rank', id: string, name: string } | null } | null }> } | null };

export type UserDepartmentHierarchyQueryVariables = Exact<{
  departmentId: Scalars['UUID'];
}>;


export type UserDepartmentHierarchyQuery = { __typename?: 'Query', departmentEmployeeHierarchy?: { __typename?: 'DepartmentEmployeeHierarchyConnection', nodes: Array<any | null> } | null };

export type UserDepartmentInheritedGroupsQueryVariables = Exact<{
  userId: Scalars['UUID'];
  departmentId: Scalars['UUID'];
}>;


export type UserDepartmentInheritedGroupsQuery = { __typename?: 'Query', inheritedDepartmentGroups?: { __typename?: 'GroupsConnection', edges: Array<{ __typename?: 'GroupsEdge', node?: { __typename?: 'Group', id: string, name?: string | null, localizedName?: string | null } | null }> } | null };

export type UserGroupsQueryVariables = Exact<{
  userIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type UserGroupsQuery = { __typename?: 'Query', userGroups?: { __typename?: 'UserGroupsConnection', edges: Array<{ __typename?: 'UserGroupsEdge', node?: { __typename?: 'UserGroup', userId: string, groupId: string, companyId: string, group?: { __typename?: 'Group', id: string, name?: string | null, localizedName?: string | null, description?: string | null, scope?: RoleScope | null } | null, user?: { __typename?: 'User', employeeByUserId?: { __typename?: 'Employee', id: string, userId: string } | null } | null } | null }> } | null };

export type UserDepartmentGroupsQueryVariables = Exact<{
  userId?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type UserDepartmentGroupsQuery = { __typename?: 'Query', userDepartmentGroups?: { __typename?: 'UserDepartmentGroupsConnection', edges: Array<{ __typename?: 'UserDepartmentGroupsEdge', node?: { __typename?: 'UserDepartmentGroup', userId: string, departmentId: string, groupId: string, companyId: string, inheritToDescendants: boolean, onlyIncludeInDescendants: boolean, department?: { __typename?: 'Department', id: string, name: string } | null, group?: { __typename?: 'Group', id: string, name?: string | null, localizedName?: string | null, description?: string | null, scope?: RoleScope | null } | null, user?: { __typename?: 'User', employeeByUserId?: { __typename?: 'Employee', id: string, userId: string } | null } | null } | null }> } | null };

export type UserCompanyGroupsQueryVariables = Exact<{
  userId?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type UserCompanyGroupsQuery = { __typename?: 'Query', userCompanyGroups?: { __typename?: 'UserCompanyGroupsConnection', edges: Array<{ __typename?: 'UserCompanyGroupsEdge', node?: { __typename?: 'UserCompanyGroup', userId: string, groupId: string, companyId: string, group?: { __typename?: 'Group', id: string, name?: string | null, localizedName?: string | null, description?: string | null, scope?: RoleScope | null } | null, user?: { __typename?: 'User', employeeByUserId?: { __typename?: 'Employee', id: string, userId: string } | null } | null } | null }> } | null };

export type UserOnBehalfPermissionsByUserIdQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type UserOnBehalfPermissionsByUserIdQuery = { __typename?: 'Query', userOnBehalfPermissions?: { __typename?: 'UserOnBehalfPermissionsConnection', edges: Array<{ __typename?: 'UserOnBehalfPermissionsEdge', node?: { __typename?: 'UserOnBehalfPermission', id: string, userId: string, onBehalfOfUserId: string, companyId: string, user?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null, jobPositionTitle?: string | null } | null, onBehalfOfUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null, jobPositionTitle?: string | null } | null } | null }> } | null };

export type GetUserQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetUserQuery = { __typename?: 'Query', userById?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, email?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null } | null } | null };

export type UserNamesByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type UserNamesByIdsQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null } | null> } | null };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetUserByIdQuery = { __typename?: 'Query', userById?: { __typename?: 'User', id: string, fullName?: string | null, email?: string | null, logo?: string | null, departments?: Array<string | null> | null, canSignOnBehalfOf?: boolean | null, company?: { __typename?: 'Company', id: string, name?: string | null } | null, userOnBehalfPermissions: { __typename?: 'UserOnBehalfPermissionsConnection', nodes: Array<{ __typename?: 'UserOnBehalfPermission', id: string, onBehalfOfUserId: string } | null> } } | null };

export type UsersByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  orderBy?: InputMaybe<Array<UsersOrderBy> | UsersOrderBy>;
}>;


export type UsersByIdsQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: string, fullName?: string | null, email?: string | null, emailWork?: string | null, logo?: string | null, departments?: Array<string | null> | null, canSignOnBehalfOf?: boolean | null, company?: { __typename?: 'Company', id: string, name?: string | null } | null, userOnBehalfPermissions: { __typename?: 'UserOnBehalfPermissionsConnection', nodes: Array<{ __typename?: 'UserOnBehalfPermission', id: string, onBehalfOfUserId: string } | null> } } | null> } | null };

export type UsersInputFieldQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['UUID']>;
  selected?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  search?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['Cursor']>;
  orFilter?: InputMaybe<Array<UserFilter> | UserFilter>;
  withEmployeeId?: InputMaybe<Scalars['Boolean']>;
  departmentsFilter?: InputMaybe<UuidListFilter>;
  filterByIds?: InputMaybe<UuidFilter>;
}>;


export type UsersInputFieldQuery = { __typename?: 'Query', allUsers?: { __typename?: 'UsersConnection', edges: Array<{ __typename?: 'UsersEdge', node?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null, canSignOnBehalfOf?: boolean | null, userDepartments: { __typename?: 'UserDepartmentsConnection', edges: Array<{ __typename?: 'UserDepartmentsEdge', node?: { __typename?: 'UserDepartment', departmentId: string, department?: { __typename?: 'Department', id: string, name: string } | null } | null }> } } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null, selectedUsers?: { __typename?: 'UsersConnection', edges: Array<{ __typename?: 'UsersEdge', node?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null, userDepartments: { __typename?: 'UserDepartmentsConnection', edges: Array<{ __typename?: 'UserDepartmentsEdge', node?: { __typename?: 'UserDepartment', department?: { __typename?: 'Department', id: string, name: string } | null } | null }> } } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type UsersInputFieldSearchQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['UUID']>;
  selected?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  search?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['Cursor']>;
  orFilter?: InputMaybe<Array<UserFilter> | UserFilter>;
  withEmployeeId?: InputMaybe<Scalars['Boolean']>;
  departmentsFilter?: InputMaybe<UuidListFilter>;
  filterByIds?: InputMaybe<UuidFilter>;
}>;


export type UsersInputFieldSearchQuery = { __typename?: 'Query', allUsers?: { __typename?: 'UsersConnection', edges: Array<{ __typename?: 'UsersEdge', node?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null, canSignOnBehalfOf?: boolean | null, userDepartments: { __typename?: 'UserDepartmentsConnection', edges: Array<{ __typename?: 'UserDepartmentsEdge', node?: { __typename?: 'UserDepartment', departmentId: string, department?: { __typename?: 'Department', id: string, name: string } | null } | null }> } } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null, selectedUsers?: { __typename?: 'UsersConnection', edges: Array<{ __typename?: 'UsersEdge', node?: { __typename?: 'User', id: string, employeeId?: string | null, logo?: string | null, fullName?: string | null, userDepartments: { __typename?: 'UserDepartmentsConnection', edges: Array<{ __typename?: 'UserDepartmentsEdge', node?: { __typename?: 'UserDepartment', department?: { __typename?: 'Department', id: string, name: string } | null } | null }> } } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type DirectManagersQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<UsersOrderBy> | UsersOrderBy>;
}>;


export type DirectManagersQuery = { __typename?: 'Query', directManagers?: { __typename?: 'UsersConnection', totalCount: number, edges: Array<{ __typename?: 'UsersEdge', node?: { __typename?: 'User', id: string, fullName?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type AllDepartmentLeadersQueryVariables = Exact<{
  companyId: Scalars['UUID'];
  orderBy?: InputMaybe<Array<UsersOrderBy> | UsersOrderBy>;
}>;


export type AllDepartmentLeadersQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', totalCount: number, edges: Array<{ __typename?: 'UsersEdge', node?: { __typename?: 'User', id: string, fullName?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type GetDepartmentLeadersQueryVariables = Exact<{
  departmentId: Scalars['UUID'];
}>;


export type GetDepartmentLeadersQuery = { __typename?: 'Query', getDepartmentLeaders?: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: string, fullName?: string | null } | null> } | null };

export type GetDepartmentLeadersCountQueryVariables = Exact<{
  departmentId: Scalars['UUID'];
}>;


export type GetDepartmentLeadersCountQuery = { __typename?: 'Query', getDepartmentLeadersCount?: number | null };

export type AllUsersDepartmentsQueryVariables = Exact<{
  companyId: Scalars['UUID'];
  employeeIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type AllUsersDepartmentsQuery = { __typename?: 'Query', userDepartments?: { __typename?: 'UserDepartmentsConnection', nodes: Array<{ __typename?: 'UserDepartment', userId: string, rankId?: string | null, department?: { __typename?: 'Department', id: string, name: string } | null } | null> } | null };

export type UserSettingByKeyQueryVariables = Exact<{
  userId: Scalars['UUID'];
  key: UserSettingKey;
}>;


export type UserSettingByKeyQuery = { __typename?: 'Query', userSettingByUserIdAndKey?: { __typename?: 'UserSetting', value: any, userId: string, id: UserSettingKey } | null };

export type ValidateEmailAvailabilityQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  email?: InputMaybe<Scalars['String']>;
}>;


export type ValidateEmailAvailabilityQuery = { __typename?: 'Query', validateEmailAvailability?: boolean | null };

export type UsersBasicQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
}>;


export type UsersBasicQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null } | null> } | null };

export type UsersFilterQueryVariables = Exact<{
  companyId: Scalars['UUID'];
}>;


export type UsersFilterQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', edges: Array<{ __typename?: 'UsersEdge', node?: { __typename?: 'User', id: string, fullName?: string | null } | null }> } | null };

export type SuperUserLoginNotesQueryVariables = Exact<{
  userId: Scalars['UUID'];
  orderBy?: InputMaybe<Array<SuperUserLoginNotesOrderBy> | SuperUserLoginNotesOrderBy>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
}>;


export type SuperUserLoginNotesQuery = { __typename?: 'Query', superUserLoginNotes?: { __typename?: 'SuperUserLoginNotesConnection', totalCount: number, edges: Array<{ __typename?: 'SuperUserLoginNotesEdge', node?: { __typename?: 'SuperUserLoginNote', id: string, note: string, createdAt: Date | string, superUser?: { __typename?: 'User', fullName?: string | null, logo?: string | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: unknown | null } } | null };

export type VacationTypesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<VacationTypesOrderBy> | VacationTypesOrderBy>;
  filter?: InputMaybe<VacationTypeFilter>;
}>;


export type VacationTypesQuery = { __typename?: 'Query', vacationTypes?: { __typename?: 'VacationTypesConnection', totalCount: number, edges: Array<{ __typename?: 'VacationTypesEdge', node?: { __typename?: 'VacationType', id: string, name: string, localizedName?: string | null, color: string, active: boolean, companyId: string, absenceCode?: string | null, quickAction: boolean, emoji?: string | null, description?: string | null, mustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, sendCalendarInvite: boolean } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor?: unknown | null, endCursor?: unknown | null, hasNextPage: boolean } } | null };

export type VacationTypeByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type VacationTypeByIdQuery = { __typename?: 'Query', vacationTypeById?: { __typename?: 'VacationType', id: string, name: string, localizedName?: string | null, color: string, active: boolean, companyId: string, absenceCode?: string | null, quickAction: boolean, emoji?: string | null, description?: string | null, mustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, sendCalendarInvite: boolean } | null };

export type VacationUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  orderBy?: InputMaybe<Array<VacationUsersOrderBy> | VacationUsersOrderBy>;
  filter?: InputMaybe<VacationUserFilter>;
}>;


export type VacationUsersQuery = { __typename?: 'Query', vacationUsers?: { __typename?: 'VacationUsersConnection', edges: Array<{ __typename?: 'VacationUsersEdge', node?: { __typename?: 'VacationUser', id: string, vacationTypeId: string, allDay: boolean, startDate: Date | string, endDate: Date | string, durationDays?: string | number | null, note?: string | null, active: boolean, userId: string, departmentIds?: Array<string | null> | null, companyId: string, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, approvalId?: string | null, user?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null, departments?: Array<string | null> | null } | null, vacationType?: { __typename?: 'VacationType', id: string, name: string, localizedName?: string | null, color: string, active: boolean, companyId: string, absenceCode?: string | null, quickAction: boolean, emoji?: string | null, description?: string | null, mustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, sendCalendarInvite: boolean } | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null, creatorUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null }> } | null };

export type VacationUserByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type VacationUserByIdQuery = { __typename?: 'Query', vacationUserById?: { __typename?: 'VacationUser', id: string, vacationTypeId: string, allDay: boolean, startDate: Date | string, endDate: Date | string, durationDays?: string | number | null, note?: string | null, active: boolean, userId: string, departmentIds?: Array<string | null> | null, companyId: string, hasBeenApproved?: boolean | null, hasBeenDenied?: boolean | null, approvalId?: string | null, user?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null, departments?: Array<string | null> | null } | null, vacationType?: { __typename?: 'VacationType', id: string, name: string, localizedName?: string | null, color: string, active: boolean, companyId: string, absenceCode?: string | null, quickAction: boolean, emoji?: string | null, description?: string | null, mustBeApproved: boolean, approverUserIds: Array<string | null>, approverGroupIds: Array<string | null>, approverSystemFieldIds: Array<string | null>, approverFormFieldIds: Array<string | null>, sendCalendarInvite: boolean } | null, lastProcessedBy?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null, creatorUser?: { __typename?: 'User', id: string, fullName?: string | null, logo?: string | null } | null } | null };

export type ExportVacationToExcelQueryVariables = Exact<{
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  vacationTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  dataType: Scalars['String'];
  includeWeekends?: InputMaybe<Scalars['Boolean']>;
  includeHolidays?: InputMaybe<Scalars['Boolean']>;
  holidayCountry?: InputMaybe<Scalars['String']>;
  includeApprovedAbsence?: InputMaybe<Scalars['Boolean']>;
  includeUnapprovedAbsence?: InputMaybe<Scalars['Boolean']>;
  includeRejectedAbsence?: InputMaybe<Scalars['Boolean']>;
  groupedByEmployee?: InputMaybe<Scalars['Boolean']>;
  systemFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  formFields?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type ExportVacationToExcelQuery = { __typename?: 'Query', exportVacationToExcel?: { __typename?: 'ExportVacationToExcelPayload', base64?: string | null } | null };

export type GetSupportedHolidayCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSupportedHolidayCountriesQuery = { __typename?: 'Query', getSupportedHolidayCountries?: { __typename?: 'GetSupportedHolidayCountriesPayload', countries?: Array<string | null> | null } | null };

export type GetGeneralHolidaysQueryVariables = Exact<{
  year?: InputMaybe<Scalars['Int']>;
  country: Scalars['String'];
}>;


export type GetGeneralHolidaysQuery = { __typename?: 'Query', getGeneralHolidays?: { __typename?: 'GetGeneralHolidaysPayload', holidays?: Array<{ __typename?: 'Holiday', id?: string | null, date?: string | null, startDate?: Date | string | null, endDate?: Date | string | null, name?: string | null } | null> | null } | null };

export type OnAsyncJobUpdateSubscriptionVariables = Exact<{
  asyncJobId: Scalars['UUID'];
}>;


export type OnAsyncJobUpdateSubscription = { __typename?: 'Subscription', asyncJobUpdated?: { __typename?: 'AsyncJobSubscriptionPayload', asyncJobItem?: { __typename: 'AsyncJobItem', id: string, completionDate: Date | string, message?: string | null, messageVariables?: any | null, tabulation: number } | null } | null };

export type OnTimeRegistrationUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnTimeRegistrationUpdateSubscription = { __typename?: 'Subscription', timeRegistrationUpdated?: { __typename?: 'timeRegistrationSubscriptionPayload', timeRegistration?: { __typename?: 'TimeRegistrationPresence', id: string } | null } | null };

export const AnnouncementFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Announcement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Announcement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"systemAnnouncement"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"teaser"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"addPlayIcon"}},{"kind":"Field","name":{"kind":"Name","value":"popup"}},{"kind":"Field","name":{"kind":"Name","value":"locales"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"publishAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<AnnouncementFragment, unknown>;
export const ChangelogFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Changelog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Changelog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"system"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"major"}},{"kind":"Field","name":{"kind":"Name","value":"minor"}},{"kind":"Field","name":{"kind":"Name","value":"guides"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAppNotes"}}]}}]} as unknown as DocumentNode<ChangelogFragment, unknown>;
export const UserCompetenceEvaluationsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCompetenceEvaluations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserCompetence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetenceEvaluations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"evaluatingUserId"}},{"kind":"Field","name":{"kind":"Name","value":"nextUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"evaluatingUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"evaluationDate"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserCompetenceEvaluationsFragment, unknown>;
export const ContractSignPendingDocumentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingDocument"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingDocument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderValues"}},{"kind":"Field","name":{"kind":"Name","value":"contractName"}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"existingStorageId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMappings"}}]}}]} as unknown as DocumentNode<ContractSignPendingDocumentFragment, unknown>;
export const ContractSignPendingSignerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingSigner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingSigner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingId"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"signDate"}},{"kind":"Field","name":{"kind":"Name","value":"signatureFileId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"refused"}},{"kind":"Field","name":{"kind":"Name","value":"refusalReason"}}]}}]} as unknown as DocumentNode<ContractSignPendingSignerFragment, unknown>;
export const ContractSignPendingSignerWithUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingSignerWithUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingSigner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractSignPendingSigner"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signatureImage"}},{"kind":"Field","name":{"kind":"Name","value":"useSecondaryEmail"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailWork"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUserId"}},{"kind":"Field","name":{"kind":"Name","value":"signOrder"}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingSigner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingSigner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingId"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"signDate"}},{"kind":"Field","name":{"kind":"Name","value":"signatureFileId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"refused"}},{"kind":"Field","name":{"kind":"Name","value":"refusalReason"}}]}}]} as unknown as DocumentNode<ContractSignPendingSignerWithUserFragment, unknown>;
export const ContractTemplateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTypes"}},{"kind":"Field","name":{"kind":"Name","value":"placeholders"}},{"kind":"Field","name":{"kind":"Name","value":"htmlPlaceholders"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"topMargin"}},{"kind":"Field","name":{"kind":"Name","value":"bottomMargin"}},{"kind":"Field","name":{"kind":"Name","value":"leftMargin"}},{"kind":"Field","name":{"kind":"Name","value":"rightMargin"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"lifetime"}}]}}]}}]} as unknown as DocumentNode<ContractTemplateFragment, unknown>;
export const UsersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Users"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractTemplateUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UsersFragment, unknown>;
export const DepartmentsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Departments"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractTemplateDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DepartmentsFragment, unknown>;
export const DepartmentTypeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<DepartmentTypeFragment, unknown>;
export const DepartmentBasicFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mainDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartmentId"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"pNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<DepartmentBasicFragment, unknown>;
export const DepartmentBasicWithFieldEntriesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentBasicWithFieldEntries"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentBasic"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rankId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeFieldEntries"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mainDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartmentId"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"pNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<DepartmentBasicWithFieldEntriesFragment, unknown>;
export const DepartmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Department"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentBasic"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isSystemUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userDepartmentGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employeeByUserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mainDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartmentId"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"pNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<DepartmentFragment, unknown>;
export const DepartmentTypeEmployeesPageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentTypeEmployeesPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]} as unknown as DocumentNode<DepartmentTypeEmployeesPageFragment, unknown>;
export const StorageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Storage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Storage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwner"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deleteAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"remindAt"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMappings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"documentTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderValues"}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentUserResponsiblesByFileId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeCasefileId"}}]}}]} as unknown as DocumentNode<StorageFragment, unknown>;
export const DocumentFolderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentFolder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentFolder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentDocumentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerType"}},{"kind":"Field","name":{"kind":"Name","value":"lastEdited"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"rootDocumentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DocumentFolderFragment, unknown>;
export const EmployeeCasefileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployeeCasefile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmployeeCasefile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"casefileId"}},{"kind":"Field","name":{"kind":"Name","value":"casefileId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"signers"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"}},{"kind":"Field","name":{"kind":"Name","value":"documents"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeSigners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<EmployeeCasefileFragment, unknown>;
export const EmployeeFormFieldEntriesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployeeFormFieldEntries"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EmployeeFormFieldEntriesFragment, unknown>;
export const EmployeeBasicFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployeeBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"leaderDepartments"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"alternateFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"alternateLastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"birthdate"}},{"kind":"Field","name":{"kind":"Name","value":"employmentStart"}},{"kind":"Field","name":{"kind":"Name","value":"employmentEnd"}},{"kind":"Field","name":{"kind":"Name","value":"companyAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemUser"}},{"kind":"Field","name":{"kind":"Name","value":"canSignOnBehalfOf"}},{"kind":"Field","name":{"kind":"Name","value":"cpr"}},{"kind":"Field","name":{"kind":"Name","value":"bankRegistrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionType"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionWorkingHours"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionDescription"}},{"kind":"Field","name":{"kind":"Name","value":"initialsLogo"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"thumbnail"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"Field","name":{"kind":"Name","value":"hasLogo"}},{"kind":"Field","name":{"kind":"Name","value":"isFuture"}},{"kind":"Field","name":{"kind":"Name","value":"isResigned"}},{"kind":"Field","name":{"kind":"Name","value":"directManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canLogin"}},{"kind":"Field","name":{"kind":"Name","value":"canLoginApp"}},{"kind":"Field","name":{"kind":"Name","value":"canLoginSso"}},{"kind":"Field","name":{"kind":"Name","value":"godmode"}},{"kind":"Field","name":{"kind":"Name","value":"employeeNumber"}}]}}]}}]} as unknown as DocumentNode<EmployeeBasicFragment, unknown>;
export const EmployeeContactFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployeeContact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailWork"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePrivate"}}]}}]}}]} as unknown as DocumentNode<EmployeeContactFragment, unknown>;
export const EmployeeLocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployeeLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}}]}}]} as unknown as DocumentNode<EmployeeLocationFragment, unknown>;
export const EmployeeProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployeeProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"rankId"}},{"kind":"Field","name":{"kind":"Name","value":"rank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmployeeBasic"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmployeeContact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmployeeLocation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployeeBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"leaderDepartments"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"alternateFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"alternateLastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"birthdate"}},{"kind":"Field","name":{"kind":"Name","value":"employmentStart"}},{"kind":"Field","name":{"kind":"Name","value":"employmentEnd"}},{"kind":"Field","name":{"kind":"Name","value":"companyAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemUser"}},{"kind":"Field","name":{"kind":"Name","value":"canSignOnBehalfOf"}},{"kind":"Field","name":{"kind":"Name","value":"cpr"}},{"kind":"Field","name":{"kind":"Name","value":"bankRegistrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionType"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionWorkingHours"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionDescription"}},{"kind":"Field","name":{"kind":"Name","value":"initialsLogo"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"thumbnail"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"Field","name":{"kind":"Name","value":"hasLogo"}},{"kind":"Field","name":{"kind":"Name","value":"isFuture"}},{"kind":"Field","name":{"kind":"Name","value":"isResigned"}},{"kind":"Field","name":{"kind":"Name","value":"directManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canLogin"}},{"kind":"Field","name":{"kind":"Name","value":"canLoginApp"}},{"kind":"Field","name":{"kind":"Name","value":"canLoginSso"}},{"kind":"Field","name":{"kind":"Name","value":"godmode"}},{"kind":"Field","name":{"kind":"Name","value":"employeeNumber"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployeeContact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailWork"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePrivate"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployeeLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}}]}}]} as unknown as DocumentNode<EmployeeProfileFragment, unknown>;
export const EquipmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Equipment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Equipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<EquipmentFragment, unknown>;
export const ProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"serial"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"acquisitionDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserDepartments"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserId"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedByEmployeeId"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedByDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Equipment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Equipment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Equipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<ProductFragment, unknown>;
export const ExternalIntegrationBasicFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalIntegrationBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalIntegration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"systemId"}},{"kind":"Field","name":{"kind":"Name","value":"externalCompanyId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMappings"}},{"kind":"Field","name":{"kind":"Name","value":"blacklistedFields"}},{"kind":"Field","name":{"kind":"Name","value":"whitelistedFields"}},{"kind":"Field","name":{"kind":"Name","value":"continuousSync"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentInheritance"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"system"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integrableSystem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"homepageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUrl"}}]}}]}}]} as unknown as DocumentNode<ExternalIntegrationBasicFragment, unknown>;
export const FieldGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","alias":{"kind":"Name","value":"recordFields"},"name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"StringValue","value":"table","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCardColumns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FieldGroupFragment, unknown>;
export const FieldGroupCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldGroupCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldGroupCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"localizedDescription"}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCardColumns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"employee","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"StringValue","value":"table","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"integrationFieldMarkings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendsData"}},{"kind":"Field","name":{"kind":"Name","value":"receivesData"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"integrationName"}},{"kind":"Field","name":{"kind":"Name","value":"externalIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"systemId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authAppId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getUserData"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"integrationFieldMarkings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendsData"}},{"kind":"Field","name":{"kind":"Name","value":"receivesData"}},{"kind":"Field","name":{"kind":"Name","value":"authAppId"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"integrationName"}},{"kind":"Field","name":{"kind":"Name","value":"externalIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"systemId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userSystemFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getUserData"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FieldGroupCardFragment, unknown>;
export const FilterPresetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilterPreset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FilterPreset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tableName"}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"filters"}},{"kind":"Field","name":{"kind":"Name","value":"miscellaneousFilters"}}]}}]} as unknown as DocumentNode<FilterPresetFragment, unknown>;
export const FormFieldEntryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormFieldEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]} as unknown as DocumentNode<FormFieldEntryFragment, unknown>;
export const FormFieldWithEntryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormFieldWithEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeEntry"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormFieldEntry"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormFieldEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]} as unknown as DocumentNode<FormFieldWithEntryFragment, unknown>;
export const FormFieldEntryEmployeesPageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormFieldEntryEmployeesPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]} as unknown as DocumentNode<FormFieldEntryEmployeesPageFragment, unknown>;
export const UseFormFieldFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldEntriesFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getFieldEntries"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<UseFormFieldFragment, unknown>;
export const FroalaStyleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FroalaStyle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FroalaStyle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}},{"kind":"Field","name":{"kind":"Name","value":"css"}}]}}]} as unknown as DocumentNode<FroalaStyleFragment, unknown>;
export const FutureDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FutureDatum"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntryId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"updateValueAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"previousHumanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"approvalIsRequired"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"creatorUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"readableName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalId"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]} as unknown as DocumentNode<FutureDataFragment, unknown>;
export const FutureDataEmployeesPageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureDataEmployeesPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FutureDatum"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntryId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"updateValueAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"previousHumanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"approvalIsRequired"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"creatorUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"readableName"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalId"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]} as unknown as DocumentNode<FutureDataEmployeesPageFragment, unknown>;
export const RoleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Role"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}},{"kind":"Field","name":{"kind":"Name","value":"usesItemIds"}}]}}]} as unknown as DocumentNode<RoleFragment, unknown>;
export const GroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Group"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"autoAdd"}},{"kind":"Field","name":{"kind":"Name","value":"autoAddNewPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"autoInherit"}},{"kind":"Field","name":{"kind":"Name","value":"groupRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"itemIds"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Role"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Role"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}},{"kind":"Field","name":{"kind":"Name","value":"usesItemIds"}}]}}]} as unknown as DocumentNode<GroupFragment, unknown>;
export const LogEntryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LogEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LogEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowData"}},{"kind":"Field","name":{"kind":"Name","value":"changedFields"}},{"kind":"Field","name":{"kind":"Name","value":"loggedAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"schemaName"}},{"kind":"Field","name":{"kind":"Name","value":"tableName"}},{"kind":"Field","name":{"kind":"Name","value":"actionTstampTx"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"selectedFields"}},{"kind":"Field","name":{"kind":"Name","value":"affectedId"}},{"kind":"Field","name":{"kind":"Name","value":"loggedActionContext"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<LogEntryFragment, unknown>;
export const NotificationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Notification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Notification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notificationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"hookId"}},{"kind":"Field","name":{"kind":"Name","value":"hookName"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"localizedText"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastTime"}},{"kind":"Field","name":{"kind":"Name","value":"channelTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NotificationFragment, unknown>;
export const NotificationTypeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"avoidBundling"}},{"kind":"Field","name":{"kind":"Name","value":"channelTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<NotificationTypeFragment, unknown>;
export const NotificationEmployeeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationEmployee"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationEmployee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderValues"}},{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"localizedText"}},{"kind":"Field","name":{"kind":"Name","value":"hook"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"references"},"name":{"kind":"Name","value":"notificationEmployeeReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"object"}},{"kind":"Field","name":{"kind":"Name","value":"editedFields"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<NotificationEmployeeFragment, unknown>;
export const PreboardingResultSlideCommentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingResultSlideComment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingResultSlideComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideId"}},{"kind":"Field","name":{"kind":"Name","value":"edited"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<PreboardingResultSlideCommentFragment, unknown>;
export const TranslatedEntityLocalizationsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}}]} as unknown as DocumentNode<TranslatedEntityLocalizationsFragment, unknown>;
export const FormFieldFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}}]} as unknown as DocumentNode<FormFieldFragment, unknown>;
export const PreboardingSlideFormFieldFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}}]} as unknown as DocumentNode<PreboardingSlideFormFieldFragment, unknown>;
export const PreboardingSlideFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}}]} as unknown as DocumentNode<PreboardingSlideFragment, unknown>;
export const PreboardingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Preboarding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Preboarding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"predecessorId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"fontSize"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"useContentColors"}},{"kind":"Field","name":{"kind":"Name","value":"contentBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"contentTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"logoWidth"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"nextButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"prevButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"logoType"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"smsBody"}},{"kind":"Field","name":{"kind":"Name","value":"linkButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"useCustomLinkButtonColor"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackText"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}},{"kind":"Field","name":{"kind":"Name","value":"confirmResults"}},{"kind":"Field","name":{"kind":"Name","value":"useLeader"}},{"kind":"Field","name":{"kind":"Name","value":"useWorkEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"closeAccess"}},{"kind":"Field","name":{"kind":"Name","value":"reminderDays"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipientCustomEmployeeFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerEmployeeFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontStorage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fontType"}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}}]} as unknown as DocumentNode<PreboardingFragment, unknown>;
export const PreboardingEmployeeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingEmployee"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingEmployee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"conclusion"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completedReminded"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Preboarding"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Preboarding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Preboarding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"predecessorId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"fontSize"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"useContentColors"}},{"kind":"Field","name":{"kind":"Name","value":"contentBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"contentTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"logoWidth"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"nextButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"prevButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"logoType"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"smsBody"}},{"kind":"Field","name":{"kind":"Name","value":"linkButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"useCustomLinkButtonColor"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackText"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}},{"kind":"Field","name":{"kind":"Name","value":"confirmResults"}},{"kind":"Field","name":{"kind":"Name","value":"useLeader"}},{"kind":"Field","name":{"kind":"Name","value":"useWorkEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"closeAccess"}},{"kind":"Field","name":{"kind":"Name","value":"reminderDays"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipientCustomEmployeeFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerEmployeeFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontStorage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fontType"}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}}]}}]} as unknown as DocumentNode<PreboardingEmployeeFragment, unknown>;
export const TaskFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Task"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminderDate"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"parentTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventFrom"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventTo"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventOrganizerId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"parentTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"processTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleResponsibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskResponsibles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}}]} as unknown as DocumentNode<TaskFragment, unknown>;
export const ScheduledMessageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduledMessage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"senderEmployeeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"sendDate"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageExternalRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}}]} as unknown as DocumentNode<ScheduledMessageFragment, unknown>;
export const ProjectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Task"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduledMessage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Task"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminderDate"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"parentTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventFrom"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventTo"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventOrganizerId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"parentTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"processTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleResponsibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskResponsibles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduledMessage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"senderEmployeeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"sendDate"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageExternalRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectFragment, unknown>;
export const PreboardingProcessFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingProcess"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingProcess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Preboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"sendDate"}},{"kind":"Field","name":{"kind":"Name","value":"sendTime"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminder"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminderDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Preboarding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Preboarding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"predecessorId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"fontSize"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"useContentColors"}},{"kind":"Field","name":{"kind":"Name","value":"contentBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"contentTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"logoWidth"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"nextButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"prevButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"logoType"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"smsBody"}},{"kind":"Field","name":{"kind":"Name","value":"linkButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"useCustomLinkButtonColor"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackText"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}},{"kind":"Field","name":{"kind":"Name","value":"confirmResults"}},{"kind":"Field","name":{"kind":"Name","value":"useLeader"}},{"kind":"Field","name":{"kind":"Name","value":"useWorkEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"closeAccess"}},{"kind":"Field","name":{"kind":"Name","value":"reminderDays"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipientCustomEmployeeFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerEmployeeFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontStorage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fontType"}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}}]}}]} as unknown as DocumentNode<PreboardingProcessFragment, unknown>;
export const TaskTemplateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminder"}},{"kind":"Field","name":{"kind":"Name","value":"useCalendarEvent"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventFrom"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventTo"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventOrganizerId"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployee"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployeeResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManagerResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFields"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFieldsResponsibles"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroups"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroupsResponsibles"}},{"kind":"Field","name":{"kind":"Name","value":"parentTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"parentTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleResponsibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplateResponsibles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"responsible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplateEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employee"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}}]} as unknown as DocumentNode<TaskTemplateFragment, unknown>;
export const ScheduledMessageTemplateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduledMessageTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployee"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroups"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFields"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"sendTime"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateExternalRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}}]} as unknown as DocumentNode<ScheduledMessageTemplateFragment, unknown>;
export const ProjectTemplateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplatesByProjectId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskTemplate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplatesByProjectId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduledMessageTemplate"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminder"}},{"kind":"Field","name":{"kind":"Name","value":"useCalendarEvent"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventFrom"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventTo"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventOrganizerId"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployee"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployeeResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManagerResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFields"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFieldsResponsibles"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroups"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroupsResponsibles"}},{"kind":"Field","name":{"kind":"Name","value":"parentTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"parentTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleResponsibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplateResponsibles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"responsible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplateEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employee"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduledMessageTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployee"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroups"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFields"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"sendTime"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateExternalRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectTemplateFragment, unknown>;
export const ProcessFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Process"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Process"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"processTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"cutoffDay"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"taskCount"}},{"kind":"Field","name":{"kind":"Name","value":"projectCount"}},{"kind":"Field","name":{"kind":"Name","value":"messageCount"}},{"kind":"Field","name":{"kind":"Name","value":"appCount"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserDepartments"}},{"kind":"Field","name":{"kind":"Name","value":"processType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Project"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Task"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduledMessage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingProcesses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingProcess"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTemplate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskTemplate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduledMessageTemplate"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Task"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminderDate"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"parentTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventFrom"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventTo"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventOrganizerId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"parentTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"processTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleResponsibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskResponsibles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduledMessage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"senderEmployeeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"sendDate"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageExternalRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Preboarding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Preboarding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"predecessorId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"fontSize"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"useContentColors"}},{"kind":"Field","name":{"kind":"Name","value":"contentBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"contentTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"logoWidth"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"nextButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"prevButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"logoType"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"smsBody"}},{"kind":"Field","name":{"kind":"Name","value":"linkButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"useCustomLinkButtonColor"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackText"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}},{"kind":"Field","name":{"kind":"Name","value":"confirmResults"}},{"kind":"Field","name":{"kind":"Name","value":"useLeader"}},{"kind":"Field","name":{"kind":"Name","value":"useWorkEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"closeAccess"}},{"kind":"Field","name":{"kind":"Name","value":"reminderDays"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipientCustomEmployeeFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerEmployeeFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontStorage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fontType"}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminder"}},{"kind":"Field","name":{"kind":"Name","value":"useCalendarEvent"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventFrom"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventTo"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventOrganizerId"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployee"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployeeResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManagerResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFields"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFieldsResponsibles"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroups"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroupsResponsibles"}},{"kind":"Field","name":{"kind":"Name","value":"parentTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"parentTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleResponsibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplateResponsibles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"responsible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplateEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employee"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduledMessageTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployee"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroups"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFields"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"sendTime"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateExternalRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Task"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduledMessage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingProcess"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingProcess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Preboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"sendDate"}},{"kind":"Field","name":{"kind":"Name","value":"sendTime"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminder"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminderDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplatesByProjectId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskTemplate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplatesByProjectId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduledMessageTemplate"}}]}}]}}]}}]} as unknown as DocumentNode<ProcessFragment, unknown>;
export const PulseSurveyListItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PulseSurveyListItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PulseSurvey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"questionType"}},{"kind":"Field","name":{"kind":"Name","value":"localizedQuestion"}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"surveyTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"isDraft"}},{"kind":"Field","name":{"kind":"Name","value":"highestRating"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingAllTime"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingThisMonth"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingThisMonthLastYear"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingAllTimeLastYear"}},{"kind":"Field","name":{"kind":"Name","value":"invitedAll"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pulseType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pulseSurveyChoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ORDER_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}}]}}]}}]} as unknown as DocumentNode<PulseSurveyListItemFragment, unknown>;
export const RoadmapItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}}]}}]} as unknown as DocumentNode<RoadmapItemFragment, unknown>;
export const RoadmapItemWithVotesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItemWithVotes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoadmapItem"}},{"kind":"Field","name":{"kind":"Name","value":"needToHaveVoteCount"}},{"kind":"Field","name":{"kind":"Name","value":"niceToHaveVoteCount"}},{"kind":"Field","name":{"kind":"Name","value":"commentCount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}}]}}]} as unknown as DocumentNode<RoadmapItemWithVotesFragment, unknown>;
export const RoadmapItemVoteFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItemVote"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItemVote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roadmapItemId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"voteType"}}]}}]} as unknown as DocumentNode<RoadmapItemVoteFragment, unknown>;
export const RoadmapItemVoteWithUserInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItemVoteWithUserInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItemVote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoadmapItemVote"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItemVote"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItemVote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roadmapItemId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"voteType"}}]}}]} as unknown as DocumentNode<RoadmapItemVoteWithUserInfoFragment, unknown>;
export const TimeRegistrationTimesheetWeekItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeRegistrationTimesheetWeekItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationPresence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weekNumber"}},{"kind":"Field","name":{"kind":"Name","value":"weekStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"elapsedTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"restTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliesWithElevenHourRule"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"projects"},"name":{"kind":"Name","value":"timeRegistrationEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationEntryType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"PROJECT"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationTimesheetWeekItemFragment, unknown>;
export const TimeRegistrationTimesheetEntryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeRegistrationTimesheetEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntryType"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"elapsedTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationBreakType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationTimesheetEntryFragment, unknown>;
export const TimeRegistrationUserOverviewItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeRegistrationUserOverviewItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationUserOverviewRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"averageWeeklyHoursLastFourMonths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hoursThisWeek"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breaksThisWeek"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationUserOverviewItemFragment, unknown>;
export const TimeRegistrationProfileItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeRegistrationProfileItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationPresence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntryType"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationBreakType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationProfileItemFragment, unknown>;
export const TimeRegistrationPresenceTemplateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeRegistrationPresenceTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationPresenceTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntryTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntryType"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProjectId"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationBreakTypeId"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationPresenceTemplateFragment, unknown>;
export const UserCompanyGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCompanyGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserCompanyGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeByUserId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<UserCompanyGroupFragment, unknown>;
export const UserDepartmentGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDepartmentGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserDepartmentGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"inheritToDescendants"}},{"kind":"Field","name":{"kind":"Name","value":"onlyIncludeInDescendants"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeByUserId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<UserDepartmentGroupFragment, unknown>;
export const UserGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeByUserId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<UserGroupFragment, unknown>;
export const UserOnBehalfPermissionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserOnBehalfPermission"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserOnBehalfPermission"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUserId"}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]} as unknown as DocumentNode<UserOnBehalfPermissionFragment, unknown>;
export const VacationTypeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"absenceCode"}},{"kind":"Field","name":{"kind":"Name","value":"quickAction"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"sendCalendarInvite"}}]}}]} as unknown as DocumentNode<VacationTypeFragment, unknown>;
export const VacationUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vacationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"vacationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allDay"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"durationDays"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creatorUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"absenceCode"}},{"kind":"Field","name":{"kind":"Name","value":"quickAction"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"sendCalendarInvite"}}]}}]} as unknown as DocumentNode<VacationUserFragment, unknown>;
export const CreateAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"systemAnnouncement"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teaser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addPlayIcon"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"popup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"published"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publishAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expireAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAnnouncement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"announcement"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"systemAnnouncement"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemAnnouncement"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"teaser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teaser"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"addPlayIcon"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addPlayIcon"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"popup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"popup"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"Variable","name":{"kind":"Name","value":"published"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"publishAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publishAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"expireAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expireAt"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Announcement"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Announcement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Announcement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"systemAnnouncement"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"teaser"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"addPlayIcon"}},{"kind":"Field","name":{"kind":"Name","value":"popup"}},{"kind":"Field","name":{"kind":"Name","value":"locales"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"publishAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;
export const UpdateAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"systemAnnouncement"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teaser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addPlayIcon"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"popup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"published"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publishAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expireAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAnnouncementById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"systemAnnouncement"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemAnnouncement"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"teaser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teaser"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"addPlayIcon"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addPlayIcon"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"popup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"popup"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"Variable","name":{"kind":"Name","value":"published"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"publishAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publishAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"expireAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expireAt"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Announcement"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Announcement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Announcement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"systemAnnouncement"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"teaser"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"addPlayIcon"}},{"kind":"Field","name":{"kind":"Name","value":"popup"}},{"kind":"Field","name":{"kind":"Name","value":"locales"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"publishAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>;
export const DeleteAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAnnouncementById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>;
export const UploadThumbnailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadThumbnail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"base64"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filename"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mimetype"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FileUploadPublic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base64"},"value":{"kind":"Variable","name":{"kind":"Name","value":"base64"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filename"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filename"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mimetype"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mimetype"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<UploadThumbnailMutation, UploadThumbnailMutationVariables>;
export const ReadAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"readAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"announcementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserAnnouncement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userAnnouncement"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"announcementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"announcementId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<ReadAnnouncementMutation, ReadAnnouncementMutationVariables>;
export const AnnouncementReadAllDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"announcementReadAll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcementReadAll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<AnnouncementReadAllMutation, AnnouncementReadAllMutationVariables>;
export const ApproveItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"approveItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approvedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateApprovalById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"approvedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approvedAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deniedAt"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"approvingUserId"}},{"kind":"Field","name":{"kind":"Name","value":"futureDatumByApprovalId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vacationUserByApprovalId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ApproveItemMutation, ApproveItemMutationVariables>;
export const DenyItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"denyItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deniedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateApprovalById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"approvedAt"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"deniedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deniedAt"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deniedAt"}},{"kind":"Field","name":{"kind":"Name","value":"approvingUserId"}},{"kind":"Field","name":{"kind":"Name","value":"futureDatumByApprovalId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vacationUserByApprovalId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DenyItemMutation, DenyItemMutationVariables>;
export const ResetItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resetItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateApprovalById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"approvedAt"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"deniedAt"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deniedAt"}},{"kind":"Field","name":{"kind":"Name","value":"approvingUserId"}},{"kind":"Field","name":{"kind":"Name","value":"futureDatumByApprovalId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vacationUserByApprovalId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ResetItemMutation, ResetItemMutationVariables>;
export const DeleteAsyncJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAsyncJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAsyncJobById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteAsyncJobMutation, DeleteAsyncJobMutationVariables>;
export const CreateAuthAppMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAuthAppMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"homepageUri"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAuthAppMutation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"homepageUri"},"value":{"kind":"Variable","name":{"kind":"Name","value":"homepageUri"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"appType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"response"}}]}}]}}]} as unknown as DocumentNode<CreateAuthAppMutationMutation, CreateAuthAppMutationMutationVariables>;
export const UpdateAuthAppMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAuthAppMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"homepageUri"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAuthAppMutation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"homepageUri"},"value":{"kind":"Variable","name":{"kind":"Name","value":"homepageUri"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"appId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"response"}}]}}]}}]} as unknown as DocumentNode<UpdateAuthAppMutationMutation, UpdateAuthAppMutationMutationVariables>;
export const DeleteAuthAppMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAuthAppMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAuthAppMutation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"response"}}]}}]}}]} as unknown as DocumentNode<DeleteAuthAppMutationMutation, DeleteAuthAppMutationMutationVariables>;
export const RenewClientSecretMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"renewClientSecretMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renewClientSecretMutation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"response"}}]}}]}}]} as unknown as DocumentNode<RenewClientSecretMutationMutation, RenewClientSecretMutationMutationVariables>;
export const CreateIntegrationFieldMarkingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createIntegrationFieldMarking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"authAppId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"integrationName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendsData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"receivesData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIntegrationFieldMarking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"integrationFieldMarking"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"authAppId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"authAppId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"integrationName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"integrationName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sendsData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendsData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"receivesData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"receivesData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"storageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storageId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<CreateIntegrationFieldMarkingMutation, CreateIntegrationFieldMarkingMutationVariables>;
export const DeleteIntegrationFieldMarkingByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteIntegrationFieldMarkingById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIntegrationFieldMarkingById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteIntegrationFieldMarkingByIdMutation, DeleteIntegrationFieldMarkingByIdMutationVariables>;
export const UpdateIntegrationFieldMarkingByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateIntegrationFieldMarkingById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"authAppId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"integrationName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendsData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"receivesData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIntegrationFieldMarkingById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"authAppId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"authAppId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"integrationName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"integrationName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sendsData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendsData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"receivesData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"receivesData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"storageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storageId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateIntegrationFieldMarkingByIdMutation, UpdateIntegrationFieldMarkingByIdMutationVariables>;
export const RequestPinCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"requestPinCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestPinCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sentTo"}}]}}]}}]} as unknown as DocumentNode<RequestPinCodeMutation, RequestPinCodeMutationVariables>;
export const CheckPinCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"checkPinCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPinCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pin"}}}]}}]}]}}]} as unknown as DocumentNode<CheckPinCodeMutation, CheckPinCodeMutationVariables>;
export const CreateChangelogUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createChangelogUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changeLogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createChangelogUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"changelogUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"changelogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changeLogId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changelog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"changelogUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateChangelogUserMutation, CreateChangelogUserMutationVariables>;
export const CreateChangelogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createChangelog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"system"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SystemType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"releaseDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"major"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guides"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"published"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isAppNotes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createChangelog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"changelog"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"system"},"value":{"kind":"Variable","name":{"kind":"Name","value":"system"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"releaseDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"releaseDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"major"},"value":{"kind":"Variable","name":{"kind":"Name","value":"major"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"minor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"guides"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guides"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"Variable","name":{"kind":"Name","value":"published"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isAppNotes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isAppNotes"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changelog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Changelog"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Changelog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Changelog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"system"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"major"}},{"kind":"Field","name":{"kind":"Name","value":"minor"}},{"kind":"Field","name":{"kind":"Name","value":"guides"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAppNotes"}}]}}]} as unknown as DocumentNode<CreateChangelogMutation, CreateChangelogMutationVariables>;
export const UpdateChangelogByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateChangelogById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"system"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SystemType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"releaseDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"major"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guides"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"published"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isAppNotes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChangelogById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"system"},"value":{"kind":"Variable","name":{"kind":"Name","value":"system"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"releaseDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"releaseDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"major"},"value":{"kind":"Variable","name":{"kind":"Name","value":"major"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"minor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"guides"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guides"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"Variable","name":{"kind":"Name","value":"published"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isAppNotes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isAppNotes"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changelog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Changelog"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Changelog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Changelog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"system"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"major"}},{"kind":"Field","name":{"kind":"Name","value":"minor"}},{"kind":"Field","name":{"kind":"Name","value":"guides"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAppNotes"}}]}}]} as unknown as DocumentNode<UpdateChangelogByIdMutation, UpdateChangelogByIdMutationVariables>;
export const DeleteChangelogByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteChangelogById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteChangelogById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changelog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Changelog"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Changelog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Changelog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"system"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"major"}},{"kind":"Field","name":{"kind":"Name","value":"minor"}},{"kind":"Field","name":{"kind":"Name","value":"guides"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAppNotes"}}]}}]} as unknown as DocumentNode<DeleteChangelogByIdMutation, DeleteChangelogByIdMutationVariables>;
export const PublishChangelogByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"publishChangelogById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChangelogById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changelog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Changelog"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Changelog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Changelog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"system"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"major"}},{"kind":"Field","name":{"kind":"Name","value":"minor"}},{"kind":"Field","name":{"kind":"Name","value":"guides"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAppNotes"}}]}}]} as unknown as DocumentNode<PublishChangelogByIdMutation, PublishChangelogByIdMutationVariables>;
export const UnpublishChangelogByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"unpublishChangelogById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChangelogById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changelog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Changelog"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Changelog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Changelog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"system"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"major"}},{"kind":"Field","name":{"kind":"Name","value":"minor"}},{"kind":"Field","name":{"kind":"Name","value":"guides"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAppNotes"}}]}}]} as unknown as DocumentNode<UnpublishChangelogByIdMutation, UnpublishChangelogByIdMutationVariables>;
export const CreateChosenColumnsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createChosenColumns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chosenColumns"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"miscellaneousFilters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createChosenColumn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"chosenColumn"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tableName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"chosenColumns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chosenColumns"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"miscellaneousFilters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"miscellaneousFilters"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<CreateChosenColumnsMutation, CreateChosenColumnsMutationVariables>;
export const UpdateChosenColumnsByUserIdAndTableNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateChosenColumnsByUserIdAndTableName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chosenColumns"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"miscellaneousFilters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChosenColumnByUserIdAndTableName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tableName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"chosenColumns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chosenColumns"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"miscellaneousFilters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"miscellaneousFilters"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateChosenColumnsByUserIdAndTableNameMutation, UpdateChosenColumnsByUserIdAndTableNameMutationVariables>;
export const UploadCompanyLogoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadCompanyLogo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filename"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mimetype"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileOwnerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"base64"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivateOldCompanyLogo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileOwnerId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"FileUploadLogo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filename"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filename"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mimetype"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mimetype"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileOwnerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileOwnerId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"base64"},"value":{"kind":"Variable","name":{"kind":"Name","value":"base64"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwner"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]} as unknown as DocumentNode<UploadCompanyLogoMutation, UploadCompanyLogoMutationVariables>;
export const RemoveCompanyLogoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeCompanyLogo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileOwnerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivateOldCompanyLogo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileOwnerId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<RemoveCompanyLogoMutation, RemoveCompanyLogoMutationVariables>;
export const CompanyUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"companyUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cvr"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sso"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"masterForCompanyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"masterTemplate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nativeAppAccess"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"availableLocales"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyBindingIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompanyById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cvr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cvr"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sso"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"masterForCompanyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"masterForCompanyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"masterTemplate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"masterTemplate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nativeAppAccess"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nativeAppAccess"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"availableLocales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"availableLocales"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyBindingIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyBindingIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"sso"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mainDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"pNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CompanyUpdateMutation, CompanyUpdateMutationVariables>;
export const CompanyDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"companyDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompanyById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<CompanyDeleteMutation, CompanyDeleteMutationVariables>;
export const CopyCompanyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"copyCompany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromCompanyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cvr"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionTitle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyBindingIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"masterForCompanyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"availableLocales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minimumEmployeeNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includePersonData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nativeAppAccess"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyCompany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fromCompanyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromCompanyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cvr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cvr"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mobile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobPositionTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionTitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobPositionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyBindingIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyBindingIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"logo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"masterForCompanyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"masterForCompanyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"availableLocales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"availableLocales"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"minimumEmployeeNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minimumEmployeeNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includePersonData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includePersonData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nativeAppAccess"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nativeAppAccess"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CopyCompanyMutation, CopyCompanyMutationVariables>;
export const UpsertCompanySettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertCompanySetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySettingKey"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"valueBoolean"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"valueStorageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertCompanySetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"valueBoolean"},"value":{"kind":"Variable","name":{"kind":"Name","value":"valueBoolean"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"valueStorageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"valueStorageId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"valueBoolean"}}]}}]}}]} as unknown as DocumentNode<UpsertCompanySettingMutation, UpsertCompanySettingMutationVariables>;
export const CreateCompanyTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCompanyType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"disable2Fa"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCompanyType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"disable2Fa"},"value":{"kind":"Variable","name":{"kind":"Name","value":"disable2Fa"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCompanyTypeMutation, CreateCompanyTypeMutationVariables>;
export const UpdateCompanyTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCompanyType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"disable2Fa"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompanyTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"disable2Fa"},"value":{"kind":"Variable","name":{"kind":"Name","value":"disable2Fa"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCompanyTypeMutation, UpdateCompanyTypeMutationVariables>;
export const DeleteCompanyTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteCompanyType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCompanyTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteCompanyTypeMutation, DeleteCompanyTypeMutationVariables>;
export const CreateCompanyCompanyTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCompanyCompanyType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyCompanyType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyCompanyTypeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCompanyCompanyType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyCompanyType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyCompanyType"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyCompanyType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"companyType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateCompanyCompanyTypeMutation, CreateCompanyCompanyTypeMutationVariables>;
export const UpdateCompanyCompanyTypeByCompanyIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCompanyCompanyTypeByCompanyId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyCompanyType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyCompanyTypePatch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompanyCompanyTypeByCompanyId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyCompanyType"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyCompanyType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"companyType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCompanyCompanyTypeByCompanyIdMutation, UpdateCompanyCompanyTypeByCompanyIdMutationVariables>;
export const CompetenceGroupCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"competenceGroupCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCompetenceGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"competenceGroup"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competenceGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CompetenceGroupCreateMutation, CompetenceGroupCreateMutationVariables>;
export const UpdateCompetenceGroupByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCompetenceGroupById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompetenceGroupById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competenceGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCompetenceGroupByIdMutation, UpdateCompetenceGroupByIdMutationVariables>;
export const CompetenceGroupDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"competenceGroupDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompetenceGroupById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competenceGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CompetenceGroupDeleteMutation, CompetenceGroupDeleteMutationVariables>;
export const CompetenceCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"competenceCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"competenceGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"outdateCompetence"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"outdateInterval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntervalInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reminderInterval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntervalInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateReminder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useRating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyManagerShouldEvaluate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCompetence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"competence"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"competenceGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"competenceGroupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"outdateCompetence"},"value":{"kind":"Variable","name":{"kind":"Name","value":"outdateCompetence"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"outdateInterval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"outdateInterval"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateReminder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateReminder"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useRating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useRating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"reminderInterval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reminderInterval"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"onlyManagerShouldEvaluate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyManagerShouldEvaluate"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CompetenceCreateMutation, CompetenceCreateMutationVariables>;
export const UpdateCompetenceByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCompetenceById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"competenceGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"outdateCompetence"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"outdateInterval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntervalInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reminderInterval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntervalInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateReminder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useRating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyManagerShouldEvaluate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompetenceById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"competenceGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"competenceGroupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"outdateInterval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"outdateInterval"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"outdateCompetence"},"value":{"kind":"Variable","name":{"kind":"Name","value":"outdateCompetence"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateReminder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateReminder"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useRating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useRating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"reminderInterval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reminderInterval"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"onlyManagerShouldEvaluate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyManagerShouldEvaluate"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCompetenceByIdMutation, UpdateCompetenceByIdMutationVariables>;
export const CompetenceDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"competenceDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompetenceById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CompetenceDeleteMutation, CompetenceDeleteMutationVariables>;
export const UserCompetenceDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userCompetenceDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserCompetenceById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UserCompetenceDeleteMutation, UserCompetenceDeleteMutationVariables>;
export const UserCompetenceEvaluationCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserCompetenceEvaluationCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"evaluatingUserId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userCompetenceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"evaluationDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nextUpdate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntries"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntryUserCompetenceEvaluationIdForeignInverseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserCompetenceEvaluation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userCompetenceEvaluation"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nextUpdate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nextUpdate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"evaluatingUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"evaluatingUserId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userCompetenceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userCompetenceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"evaluationDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"evaluationDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldEntries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntries"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetenceEvaluation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UserCompetenceEvaluationCreateMutation, UserCompetenceEvaluationCreateMutationVariables>;
export const UserCompetenceEvaluationUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserCompetenceEvaluationUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nextUpdate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntries"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntryUserCompetenceEvaluationIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"evaluationDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserCompetenceEvaluationById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nextUpdate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nextUpdate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldEntries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntries"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"evaluationDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"evaluationDate"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetenceEvaluation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UserCompetenceEvaluationUpdateMutation, UserCompetenceEvaluationUpdateMutationVariables>;
export const UpdateUserCompetenceEvaluationCommentByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserCompetenceEvaluationCommentById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserCompetenceEvaluationCommentById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetenceEvaluationComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserCompetenceEvaluationCommentByIdMutation, UpdateUserCompetenceEvaluationCommentByIdMutationVariables>;
export const UserCompetenceEvaluationCommentDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserCompetenceEvaluationCommentDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserCompetenceEvaluationCommentById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetenceEvaluationComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UserCompetenceEvaluationCommentDeleteMutation, UserCompetenceEvaluationCommentDeleteMutationVariables>;
export const CreateUserCompetenceEvaluationCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUserCompetenceEvaluationComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userCompetenceEvaluationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userCompetenceUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserCompetenceEvaluationComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userCompetenceEvaluationComment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userCompetenceEvaluationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userCompetenceEvaluationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userCompetenceUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userCompetenceUserId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetenceEvaluationComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateUserCompetenceEvaluationCommentMutation, CreateUserCompetenceEvaluationCommentMutationVariables>;
export const UserCompetenceCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userCompetenceCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"competenceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addedDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userCompetenceEvaluations"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCompetenceEvaluationUserCompetenceIdForeignInverseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserCompetence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userCompetence"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"competenceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"competenceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"addedDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addedDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userCompetenceEvaluations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userCompetenceEvaluations"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UserCompetenceCreateMutation, UserCompetenceCreateMutationVariables>;
export const UserCompetenceUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userCompetenceUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addedDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserCompetenceById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"addedDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addedDate"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"addedDate"}}]}}]}}]}}]} as unknown as DocumentNode<UserCompetenceUpdateMutation, UserCompetenceUpdateMutationVariables>;
export const HtmlToPdfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"htmlToPdf"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"html"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractTemplateId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"header"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"footer"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"placeholders"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractSignPendingId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signatureBase64"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signatureFileId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appendSignaturePage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"existingStorageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"topMargin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bottomMargin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leftMargin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rightMargin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"htmlToPdf"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"html"},"value":{"kind":"Variable","name":{"kind":"Name","value":"html"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contractTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractTemplateId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"header"},"value":{"kind":"Variable","name":{"kind":"Name","value":"header"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"footer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"footer"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dateFormat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFormat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pageNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"placeholders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeholders"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contractSignPendingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractSignPendingId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"signatureBase64"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signatureBase64"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"signatureFileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signatureFileId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"appendSignaturePage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appendSignaturePage"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"existingStorageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"existingStorageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"topMargin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"topMargin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"bottomMargin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bottomMargin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"leftMargin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leftMargin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"rightMargin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rightMargin"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<HtmlToPdfMutation, HtmlToPdfMutationVariables>;
export const DocxToHtmlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"docxToHtml"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"base64"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docxToHtml"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base64"},"value":{"kind":"Variable","name":{"kind":"Name","value":"base64"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"html"}}]}}]}}]} as unknown as DocumentNode<DocxToHtmlMutation, DocxToHtmlMutationVariables>;
export const UriToPdfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uriToPdf"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uri"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uriToPdf"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uri"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uri"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]} as unknown as DocumentNode<UriToPdfMutation, UriToPdfMutationVariables>;
export const CreateContractSignPendingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createContractSignPending"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signingUserIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signingUsers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignerInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enforceSignOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"creatorUserId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"existingDocuments"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractExistingDocumentInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"generatedDocuments"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractGeneratedDocumentInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mergeIntoOneDocument"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mergedDocumentName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mergedDocumentDocumentTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reminderInterval"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createContractSignPending"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contractSignPending"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"signDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"signingUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signingUserIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"signingUsers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signingUsers"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"enforceSignOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enforceSignOrder"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"creatorUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"creatorUserId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"existingDocuments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"existingDocuments"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"generatedDocuments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"generatedDocuments"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mergeIntoOneDocument"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mergeIntoOneDocument"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mergedDocumentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mergedDocumentName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mergedDocumentDocumentTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mergedDocumentDocumentTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailText"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"reminderInterval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reminderInterval"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSignPending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateContractSignPendingMutation, CreateContractSignPendingMutationVariables>;
export const DeleteContractSignPendingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteContractSignPending"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContractSignPendingById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSignPending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteContractSignPendingMutation, DeleteContractSignPendingMutationVariables>;
export const CreateSavedSignatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createSavedSignature"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSavedSignature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"savedSignature"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"storageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storageId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedSignature"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"storageId"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSavedSignatureMutation, CreateSavedSignatureMutationVariables>;
export const DeleteSavedSignatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteSavedSignature"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSavedSignatureById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedSignature"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"storageId"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteSavedSignatureMutation, DeleteSavedSignatureMutationVariables>;
export const CreateContractSignPendingSignerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createContractSignPendingSigner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractSignPendingId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onBehalfOfUserId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useSecondaryEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createContractSignPendingSigner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contractSignPendingSigner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contractSignPendingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractSignPendingId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"onBehalfOfUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onBehalfOfUserId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"signOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signOrder"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useSecondaryEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useSecondaryEmail"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingSigner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractSignPendingSigner"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingSigner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingSigner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingId"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"signDate"}},{"kind":"Field","name":{"kind":"Name","value":"signatureFileId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"refused"}},{"kind":"Field","name":{"kind":"Name","value":"refusalReason"}}]}}]} as unknown as DocumentNode<CreateContractSignPendingSignerMutation, CreateContractSignPendingSignerMutationVariables>;
export const UpdateContractSignPendingSignerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateContractSignPendingSigner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractSignPendingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signatureFileId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContractSignPendingSignerByContractSignPendingIdAndUserId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contractSignPendingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractSignPendingId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signed"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"signDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"signatureFileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signatureFileId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingSigner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractSignPendingSigner"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingSigner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingSigner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingId"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"signDate"}},{"kind":"Field","name":{"kind":"Name","value":"signatureFileId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"refused"}},{"kind":"Field","name":{"kind":"Name","value":"refusalReason"}}]}}]} as unknown as DocumentNode<UpdateContractSignPendingSignerMutation, UpdateContractSignPendingSignerMutationVariables>;
export const RefuseSigningContractDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"refuseSigningContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractSignPendingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refusalReason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContractSignPendingSignerByContractSignPendingIdAndUserId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contractSignPendingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractSignPendingId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"refused"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"refusalReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refusalReason"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingSigner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractSignPendingSigner"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingSigner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingSigner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingId"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"signDate"}},{"kind":"Field","name":{"kind":"Name","value":"signatureFileId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"refused"}},{"kind":"Field","name":{"kind":"Name","value":"refusalReason"}}]}}]} as unknown as DocumentNode<RefuseSigningContractMutation, RefuseSigningContractMutationVariables>;
export const UpdateEmployeeDataBasedOnSignedContractDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEmployeeDataBasedOnSignedContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractSignPendingDocumentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldsToUpdate"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEmployeeDataBasedOnSignedContract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contractSignPendingDocumentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractSignPendingDocumentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldsToUpdate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldsToUpdate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldIdErrors"}}]}}]}}]} as unknown as DocumentNode<UpdateEmployeeDataBasedOnSignedContractMutation, UpdateEmployeeDataBasedOnSignedContractMutationVariables>;
export const SendContractLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendContractLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractSignPendingSignerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendContractLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contractSignPendingSignerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractSignPendingSignerId"}}}]}}]}]}}]} as unknown as DocumentNode<SendContractLinkMutation, SendContractLinkMutationVariables>;
export const FixBrokenContractDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"fixBrokenContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractSignPendingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixBrokenContract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contractSignPendingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractSignPendingId"}}}]}}]}]}}]} as unknown as DocumentNode<FixBrokenContractMutation, FixBrokenContractMutationVariables>;
export const ContractPredefinedPlaceholdersCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"contractPredefinedPlaceholdersCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractPredefinedPlaceholderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createContractPredefinedPlaceholder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contractPredefinedPlaceholder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractPredefinedPlaceholder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}}]}}]} as unknown as DocumentNode<ContractPredefinedPlaceholdersCreateMutation, ContractPredefinedPlaceholdersCreateMutationVariables>;
export const ContractPredefinedPlaceholdersUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"contractPredefinedPlaceholdersUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"placeholder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alias"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContractPredefinedPlaceholderById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"placeholder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeholder"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"alias"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alias"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractPredefinedPlaceholder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ContractPredefinedPlaceholdersUpdateMutation, ContractPredefinedPlaceholdersUpdateMutationVariables>;
export const CreateContractTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createContractTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionTypes"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"placeholders"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractTemplateDepartments"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplateDepartmentsContractTemplateIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractTemplateUsers"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplateUsersContractTemplateIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usersSharedWith"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentsSharedWith"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"html"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"header"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"footer"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"topMargin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bottomMargin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leftMargin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rightMargin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createContractTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contractTemplate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"documentTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobPositionTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionTypes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"placeholders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeholders"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contractTemplateDepartments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractTemplateDepartments"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contractTemplateUsers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractTemplateUsers"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"usersSharedWith"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usersSharedWith"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentsSharedWith"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentsSharedWith"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"html"},"value":{"kind":"Variable","name":{"kind":"Name","value":"html"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"header"},"value":{"kind":"Variable","name":{"kind":"Name","value":"header"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"footer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"footer"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dateFormat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFormat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pageNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"topMargin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"topMargin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"bottomMargin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bottomMargin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"leftMargin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leftMargin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"rightMargin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rightMargin"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractTemplate"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Departments"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Users"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTypes"}},{"kind":"Field","name":{"kind":"Name","value":"placeholders"}},{"kind":"Field","name":{"kind":"Name","value":"htmlPlaceholders"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"topMargin"}},{"kind":"Field","name":{"kind":"Name","value":"bottomMargin"}},{"kind":"Field","name":{"kind":"Name","value":"leftMargin"}},{"kind":"Field","name":{"kind":"Name","value":"rightMargin"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"lifetime"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Departments"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractTemplateDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Users"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractTemplateUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateContractTemplateMutation, CreateContractTemplateMutationVariables>;
export const UpdateContractTemplateByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateContractTemplateById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionTypes"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractTemplateDepartments"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplateDepartmentsContractTemplateIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractTemplateUsers"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplateUsersContractTemplateIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"html"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"header"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"footer"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"topMargin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bottomMargin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leftMargin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rightMargin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigFloat"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContractTemplateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"documentTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobPositionTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionTypes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contractTemplateDepartments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractTemplateDepartments"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contractTemplateUsers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractTemplateUsers"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"html"},"value":{"kind":"Variable","name":{"kind":"Name","value":"html"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"header"},"value":{"kind":"Variable","name":{"kind":"Name","value":"header"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"footer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"footer"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dateFormat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFormat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pageNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"topMargin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"topMargin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"bottomMargin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bottomMargin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"leftMargin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leftMargin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"rightMargin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rightMargin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractTemplate"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Departments"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Users"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTypes"}},{"kind":"Field","name":{"kind":"Name","value":"placeholders"}},{"kind":"Field","name":{"kind":"Name","value":"htmlPlaceholders"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"topMargin"}},{"kind":"Field","name":{"kind":"Name","value":"bottomMargin"}},{"kind":"Field","name":{"kind":"Name","value":"leftMargin"}},{"kind":"Field","name":{"kind":"Name","value":"rightMargin"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"lifetime"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Departments"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractTemplateDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Users"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractTemplateUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateContractTemplateByIdMutation, UpdateContractTemplateByIdMutationVariables>;
export const CloneContactTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cloneContactTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signable"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cloneContractTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"argId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"argName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"argSignable"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signable"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"argUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"argDepartmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getData"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"html"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getData"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getData"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"locale"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getData"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getData"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getData"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lifetime"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CloneContactTemplateMutation, CloneContactTemplateMutationVariables>;
export const CreateCustomWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCustomWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"widgetSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useImage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"backgroundColor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"widgetTextColor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buttonTextColor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buttonBackgroundColor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buttonBorder"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageLayout"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customWidgetContents"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomWidgetContentCustomWidgetIdForeignConnectionCustomWidgetContentCreateInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomWidget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"customWidget"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"widgetSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"widgetSize"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useImage"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"backgroundColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"backgroundColor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"widgetTextColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"widgetTextColor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"buttonTextColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buttonTextColor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"buttonBackgroundColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buttonBackgroundColor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"buttonBorder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buttonBorder"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"imageLayout"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageLayout"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customWidgetContents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customWidgetContents"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customWidget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCustomWidgetMutation, CreateCustomWidgetMutationVariables>;
export const UpdateCustomWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustomWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"widgetSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useImage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"backgroundColor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"widgetTextColor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buttonTextColor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buttonBackgroundColor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buttonBorder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageLayout"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customWidgetContents"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomWidgetContentCustomWidgetIdForeignInverseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomWidgetById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"widgetSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"widgetSize"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useImage"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"backgroundColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"backgroundColor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"widgetTextColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"widgetTextColor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"buttonTextColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buttonTextColor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"buttonBackgroundColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buttonBackgroundColor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"buttonBorder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buttonBorder"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"imageLayout"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageLayout"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customWidgetContents"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customWidgetContents"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateCustomWidgetMutation, UpdateCustomWidgetMutationVariables>;
export const CreateCvTemplateFieldMappingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCvTemplateFieldMapping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cvTemplateField"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCvTemplateFieldMapping"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cvTemplateFieldMapping"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cvTemplateField"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cvTemplateField"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cvTemplateFieldMapping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cvTemplateField"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCvTemplateFieldMappingMutation, CreateCvTemplateFieldMappingMutationVariables>;
export const UpdateCvTemplateFieldMappingByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCvTemplateFieldMappingById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cvTemplateField"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCvTemplateFieldMappingById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cvTemplateField"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cvTemplateField"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cvTemplateFieldMapping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cvTemplateField"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCvTemplateFieldMappingByIdMutation, UpdateCvTemplateFieldMappingByIdMutationVariables>;
export const DeleteCvTemplateFieldMappingByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteCvTemplateFieldMappingById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCvTemplateFieldMappingById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteCvTemplateFieldMappingByIdMutation, DeleteCvTemplateFieldMappingByIdMutationVariables>;
export const CreateDashboardViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createDashboardView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyDashboardViewId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"readPermissionGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"writePermissionGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDashboardView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dashboardView"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyDashboardViewId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyDashboardViewId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"readPermissionGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"readPermissionGroupIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"writePermissionGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"writePermissionGroupIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateDashboardViewMutation, CreateDashboardViewMutationVariables>;
export const UpdateDashboardViewByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDashboardViewById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDashboardViewById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateDashboardViewByIdMutation, UpdateDashboardViewByIdMutationVariables>;
export const CreateDashboardCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createDashboardCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dashboardViewId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customWidgetId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardCardType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statistics"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardCardStatisticDashboardCardIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionTypeIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDashboardCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dashboardCard"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dashboardViewId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dashboardViewId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customWidgetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customWidgetId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dashboardCardStatistics"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statistics"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobPositionTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionTypeIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<CreateDashboardCardMutation, CreateDashboardCardMutationVariables>;
export const UpdateDashboardCardByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDashboardCardById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardCardType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statistics"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardCardStatisticDashboardCardIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionTypeIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDashboardCardById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dashboardCardStatistics"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statistics"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobPositionTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionTypeIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateDashboardCardByIdMutation, UpdateDashboardCardByIdMutationVariables>;
export const CreateDashboardConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createDashboardConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDashboardConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dashboardConfig"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pageTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageTitle"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<CreateDashboardConfigMutation, CreateDashboardConfigMutationVariables>;
export const UpdateDashboardConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDashboardConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDashboardConfigByCompanyId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pageTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageTitle"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateDashboardConfigMutation, UpdateDashboardConfigMutationVariables>;
export const DepartmentCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"departmentCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainDepartment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentDepartmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cvr"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alias"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ean"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntries"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntryDepartmentIdForeignInverseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDepartment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mainDepartment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainDepartment"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentDepartmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentDepartmentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cvr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cvr"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"alias"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alias"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ean"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ean"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldEntriesToDepartmentIdUsingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntries"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentBasic"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mainDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartmentId"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"pNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<DepartmentCreateMutation, DepartmentCreateMutationVariables>;
export const DepartmentUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"departmentUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mainDepartment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentDepartmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cvr"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alias"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ean"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changedFormFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntries"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntryDepartmentIdForeignInverseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDepartmentById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mainDepartment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mainDepartment"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentDepartmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentDepartmentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cvr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cvr"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"alias"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alias"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ean"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ean"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldEntriesToDepartmentIdUsingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntries"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"changedFormFieldIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changedFormFieldIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentBasic"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mainDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartmentId"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"pNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<DepartmentUpdateMutation, DepartmentUpdateMutationVariables>;
export const DepartmentDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"departmentDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDepartmentById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DepartmentDeleteMutation, DepartmentDeleteMutationVariables>;
export const CreateDepartmentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createDepartmentType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"color"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDepartmentType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departmentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"color"},"value":{"kind":"Variable","name":{"kind":"Name","value":"color"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<CreateDepartmentTypeMutation, CreateDepartmentTypeMutationVariables>;
export const UpdateDepartmentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDepartmentType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"color"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDepartmentTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"color"},"value":{"kind":"Variable","name":{"kind":"Name","value":"color"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<UpdateDepartmentTypeMutation, UpdateDepartmentTypeMutationVariables>;
export const DeleteDepartmentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteDepartmentType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDepartmentTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<DeleteDepartmentTypeMutation, DeleteDepartmentTypeMutationVariables>;
export const GraphileCreateDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"graphileCreateDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filename"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mimetype"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"access"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileOwner"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StorageFileOwner"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileOwnerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"base64"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileExtension"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responsibleUserIdsToAdd"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responsibleUserIdsToDelete"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expireAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"remindAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"html"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentFolderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createStorage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"storage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filename"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filename"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mimetype"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mimetype"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"access"},"value":{"kind":"Variable","name":{"kind":"Name","value":"access"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileOwner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileOwner"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileOwnerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileOwnerId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"documentTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"base64"},"value":{"kind":"Variable","name":{"kind":"Name","value":"base64"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileExtension"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileExtension"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deleteAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"expireAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expireAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"remindAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"remindAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"responsibleUserIdsToAdd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responsibleUserIdsToAdd"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"responsibleUserIdsToDelete"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responsibleUserIdsToDelete"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"html"},"value":{"kind":"Variable","name":{"kind":"Name","value":"html"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"documentFolderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentFolderId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwner"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deleteAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"remindAt"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GraphileCreateDocumentMutation, GraphileCreateDocumentMutationVariables>;
export const UpdateDocumentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDocumentType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateStorageById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentTypeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDocumentTypeMutation, UpdateDocumentTypeMutationVariables>;
export const GraphileUpdateDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"graphileUpdateDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mimetype"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filename"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileOwner"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StorageFileOwner"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileOwnerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"base64"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileExtension"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expireAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"remindAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responsibleUserIdsToAdd"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responsibleUserIdsToDelete"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"html"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentFolderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateStorageById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filename"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filename"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mimetype"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mimetype"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileOwner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileOwner"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileOwnerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileOwnerId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"documentTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"base64"},"value":{"kind":"Variable","name":{"kind":"Name","value":"base64"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileExtension"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileExtension"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deleteAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"expireAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expireAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"remindAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"remindAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"responsibleUserIdsToAdd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responsibleUserIdsToAdd"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"responsibleUserIdsToDelete"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responsibleUserIdsToDelete"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"html"},"value":{"kind":"Variable","name":{"kind":"Name","value":"html"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"documentFolderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentFolderId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwner"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deleteAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"remindAt"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GraphileUpdateDocumentMutation, GraphileUpdateDocumentMutationVariables>;
export const DocumentTypeCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"documentTypeCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lifetime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autoDeleteDays"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDocumentType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lifetime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lifetime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"autoDeleteDays"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autoDeleteDays"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"lifetime"}}]}}]}}]}}]} as unknown as DocumentNode<DocumentTypeCreateMutation, DocumentTypeCreateMutationVariables>;
export const DocumentTypeUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"documentTypeUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lifetime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autoDeleteDays"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDocumentTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lifetime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lifetime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"autoDeleteDays"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autoDeleteDays"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"lifetime"}},{"kind":"Field","name":{"kind":"Name","value":"autoDeleteDays"}}]}}]}}]}}]} as unknown as DocumentNode<DocumentTypeUpdateMutation, DocumentTypeUpdateMutationVariables>;
export const DocumentTypeDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"documentTypeDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDocumentTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DocumentTypeDeleteMutation, DocumentTypeDeleteMutationVariables>;
export const FileUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"fileUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filename"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mimetype"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileAccess"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileOwner"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StorageFileOwner"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileOwnerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentFolderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"base64"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expireAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"remindAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentTemplateId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"placeholderValues"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendNotification"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FileUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filename"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filename"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mimetype"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mimetype"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileAccess"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileAccess"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileOwner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileOwner"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileOwnerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileOwnerId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"documentTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"documentFolderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentFolderId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"base64"},"value":{"kind":"Variable","name":{"kind":"Name","value":"base64"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"expireAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expireAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"remindAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"remindAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"documentTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentTemplateId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"placeholderValues"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeholderValues"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sendNotification"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendNotification"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"processTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processTypeId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]} as unknown as DocumentNode<FileUploadMutation, FileUploadMutationVariables>;
export const FileDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"fileDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FileDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}}]} as unknown as DocumentNode<FileDeleteMutation, FileDeleteMutationVariables>;
export const FileDownloadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"fileDownload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"convertToPdf"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FileDownload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"convertToPdf"},"value":{"kind":"Variable","name":{"kind":"Name","value":"convertToPdf"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwner"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]} as unknown as DocumentNode<FileDownloadMutation, FileDownloadMutationVariables>;
export const GeneratePdfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GeneratePDF"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"base64"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GeneratePDF"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"base64"},"value":{"kind":"Variable","name":{"kind":"Name","value":"base64"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pdf"}}]}}]}}]} as unknown as DocumentNode<GeneratePdfMutation, GeneratePdfMutationVariables>;
export const ProcessBulkUploadDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"processBulkUploadDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"doCreateMissingFolders"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inferDocumentTypeFromFileName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processBulkUploadDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"documentTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"doCreateMissingFolders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"doCreateMissingFolders"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"inferDocumentTypeFromFileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inferDocumentTypeFromFileName"}}}]}}]}]}}]} as unknown as DocumentNode<ProcessBulkUploadDocumentsMutation, ProcessBulkUploadDocumentsMutationVariables>;
export const GetPresignedUploadLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"getPresignedUploadLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filename"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPresignedUploadLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filename"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filename"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GetPresignedUploadLinkMutation, GetPresignedUploadLinkMutationVariables>;
export const DownloadBulkDocumentTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"downloadBulkDocumentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadBulkDocumentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]} as unknown as DocumentNode<DownloadBulkDocumentTemplateMutation, DownloadBulkDocumentTemplateMutationVariables>;
export const DocumentFolderCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"documentFolderCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentDocumentFolderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownerType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentFolderOwnerType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentFolderBlueprintId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDocumentFolder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentFolder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentDocumentFolderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentDocumentFolderId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"documentFolderBlueprintId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentFolderBlueprintId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ownerType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownerType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ownerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownerId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFolder"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentFolder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentFolder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentDocumentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerType"}},{"kind":"Field","name":{"kind":"Name","value":"lastEdited"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"rootDocumentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DocumentFolderCreateMutation, DocumentFolderCreateMutationVariables>;
export const CreateDocumentFolderBlueprintDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDocumentFolderBlueprint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentDocumentFolderBlueprintId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDocumentFolderBlueprint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentFolderBlueprint"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentDocumentFolderBlueprintId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentDocumentFolderBlueprintId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateDocumentFolderBlueprintMutation, CreateDocumentFolderBlueprintMutationVariables>;
export const DocumentFolderBlueprintUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"documentFolderBlueprintUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDocumentFolderBlueprintById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DocumentFolderBlueprintUpdateMutation, DocumentFolderBlueprintUpdateMutationVariables>;
export const DocumentFolderUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"documentFolderUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentDocumentFolderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownerType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentFolderOwnerType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDocumentFolderById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentDocumentFolderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentDocumentFolderId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ownerType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownerType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ownerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownerId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFolder"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentFolder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentFolder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentDocumentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerType"}},{"kind":"Field","name":{"kind":"Name","value":"lastEdited"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"rootDocumentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DocumentFolderUpdateMutation, DocumentFolderUpdateMutationVariables>;
export const DocumentFolderDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"documentFolderDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDocumentFolderById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DocumentFolderDeleteMutation, DocumentFolderDeleteMutationVariables>;
export const DocumentFolderBlueprintDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"documentFolderBlueprintDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDocumentFolderBlueprintById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DocumentFolderBlueprintDeleteMutation, DocumentFolderBlueprintDeleteMutationVariables>;
export const DocumentFolderDepartmentCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DocumentFolderDepartmentCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentFolderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDocumentFolderDepartment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentFolderDepartment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentFolderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentFolderId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFolder"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentFolder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentFolder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentDocumentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerType"}},{"kind":"Field","name":{"kind":"Name","value":"lastEdited"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"rootDocumentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DocumentFolderDepartmentCreateMutation, DocumentFolderDepartmentCreateMutationVariables>;
export const DocumentFolderDepartmentDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DocumentFolderDepartmentDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentFolderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDocumentFolderDepartmentByDocumentFolderIdAndDepartmentId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentFolderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentFolderId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFolder"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentFolder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentFolder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentDocumentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerType"}},{"kind":"Field","name":{"kind":"Name","value":"lastEdited"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"rootDocumentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DocumentFolderDepartmentDeleteMutation, DocumentFolderDepartmentDeleteMutationVariables>;
export const DocumentFolderUserCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DocumentFolderUserCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentFolderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDocumentFolderUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentFolderUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentFolderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentFolderId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFolder"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentFolder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentFolder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentDocumentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerType"}},{"kind":"Field","name":{"kind":"Name","value":"lastEdited"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"rootDocumentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DocumentFolderUserCreateMutation, DocumentFolderUserCreateMutationVariables>;
export const DocumentFolderUserDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DocumentFolderUserDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentFolderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDocumentFolderUserByDocumentFolderIdAndUserId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentFolderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentFolderId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFolder"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentFolder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentFolder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentDocumentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerType"}},{"kind":"Field","name":{"kind":"Name","value":"lastEdited"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"rootDocumentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DocumentFolderUserDeleteMutation, DocumentFolderUserDeleteMutationVariables>;
export const CustomEmployeeCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"customEmployeeCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departments"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alternateFirstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alternateLastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailWork"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobilePrivate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"birthdate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentStart"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentEnd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seniority"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionDescription"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionWorkingHours"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankRegistrationNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cpr"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailPassword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyAdmin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isSystemUser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"directManager"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentJurisdiction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"initials"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntries"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personalGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canLogin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canLoginApp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canLoginSso"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEmployeeCustomMutation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departments"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"alternateFirstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alternateFirstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"alternateLastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alternateLastName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailWork"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailWork"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mobile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mobilePrivate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobilePrivate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"birthdate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"birthdate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employmentStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentStart"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employmentEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentEnd"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"seniority"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seniority"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobPositionTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionTitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobPositionDescription"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionDescription"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobPositionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobPositionWorkingHours"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionWorkingHours"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"bankRegistrationNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankRegistrationNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"bankAccountNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cpr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cpr"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"logo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailPassword"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyAdmin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyAdmin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isSystemUser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isSystemUser"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"directManager"},"value":{"kind":"Variable","name":{"kind":"Name","value":"directManager"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employmentJurisdiction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentJurisdiction"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"initials"},"value":{"kind":"Variable","name":{"kind":"Name","value":"initials"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldEntries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntries"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"personalGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personalGroupIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"canLogin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canLogin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"canLoginApp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canLoginApp"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"canLoginSso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canLoginSso"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<CustomEmployeeCreateMutation, CustomEmployeeCreateMutationVariables>;
export const CustomEmployeeUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"customEmployeeUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departments"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alternateFirstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alternateLastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailWork"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mobilePrivate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"birthdate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentStart"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentEnd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seniority"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionDescription"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionWorkingHours"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankRegistrationNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cpr"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailPassword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userDepartmentsToDelete"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userDepartmentsToCreate"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyAdmin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isSystemUser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"directManager"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentJurisdiction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"initials"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntries"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromEngagement"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEmployeeCustomMutation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departments"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"alternateFirstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alternateFirstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"alternateLastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alternateLastName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailWork"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailWork"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mobile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobile"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mobilePrivate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mobilePrivate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"birthdate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"birthdate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employmentStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentStart"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employmentEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentEnd"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"seniority"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seniority"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobPositionTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionTitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobPositionDescription"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionDescription"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobPositionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobPositionWorkingHours"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionWorkingHours"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"bankRegistrationNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankRegistrationNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"bankAccountNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cpr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cpr"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"logo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailPassword"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userDepartmentsToDelete"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userDepartmentsToDelete"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userDepartmentsToCreate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userDepartmentsToCreate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyAdmin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyAdmin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isSystemUser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isSystemUser"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"directManager"},"value":{"kind":"Variable","name":{"kind":"Name","value":"directManager"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employmentJurisdiction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentJurisdiction"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"initials"},"value":{"kind":"Variable","name":{"kind":"Name","value":"initials"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldEntries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntries"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fromEngagement"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromEngagement"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"initialsLogo"}},{"kind":"Field","name":{"kind":"Name","value":"directManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CustomEmployeeUpdateMutation, CustomEmployeeUpdateMutationVariables>;
export const BulkUpdateEmployeeCustomMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bulkUpdateEmployeeCustomMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fields"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"employeeCustomMutationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"futureData"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FutureDatumInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateEmployeeCustomMutation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employeeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fields"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"futureData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"futureData"}}}]}}]}]}}]} as unknown as DocumentNode<BulkUpdateEmployeeCustomMutationMutation, BulkUpdateEmployeeCustomMutationMutationVariables>;
export const EmployeeAndUserUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"employeeAndUserUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEmployeeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmployeeBasic"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmployeeContact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmployeeLocation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateUserById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployeeBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"leaderDepartments"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"alternateFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"alternateLastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"birthdate"}},{"kind":"Field","name":{"kind":"Name","value":"employmentStart"}},{"kind":"Field","name":{"kind":"Name","value":"employmentEnd"}},{"kind":"Field","name":{"kind":"Name","value":"companyAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemUser"}},{"kind":"Field","name":{"kind":"Name","value":"canSignOnBehalfOf"}},{"kind":"Field","name":{"kind":"Name","value":"cpr"}},{"kind":"Field","name":{"kind":"Name","value":"bankRegistrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionType"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionWorkingHours"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionDescription"}},{"kind":"Field","name":{"kind":"Name","value":"initialsLogo"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"thumbnail"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"Field","name":{"kind":"Name","value":"hasLogo"}},{"kind":"Field","name":{"kind":"Name","value":"isFuture"}},{"kind":"Field","name":{"kind":"Name","value":"isResigned"}},{"kind":"Field","name":{"kind":"Name","value":"directManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canLogin"}},{"kind":"Field","name":{"kind":"Name","value":"canLoginApp"}},{"kind":"Field","name":{"kind":"Name","value":"canLoginSso"}},{"kind":"Field","name":{"kind":"Name","value":"godmode"}},{"kind":"Field","name":{"kind":"Name","value":"employeeNumber"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployeeContact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailWork"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePrivate"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployeeLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}}]}}]} as unknown as DocumentNode<EmployeeAndUserUpdateMutation, EmployeeAndUserUpdateMutationVariables>;
export const EmployeeArchiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"employeeArchive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEmployeeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<EmployeeArchiveMutation, EmployeeArchiveMutationVariables>;
export const EmployeeRestoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"employeeRestore"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEmployeeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<EmployeeRestoreMutation, EmployeeRestoreMutationVariables>;
export const SetMissingEmployeeNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setMissingEmployeeNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setMissingEmployeeNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integer"}}]}}]}}]} as unknown as DocumentNode<SetMissingEmployeeNumberMutation, SetMissingEmployeeNumberMutationVariables>;
export const EmployeeCreateCaseFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"employeeCreateCaseFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signingUserIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CasefileSignerInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipients"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CasefileRecipientInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documents"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CasefileDocumentInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reminderInterval"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailSubject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailText"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expireAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enforceSignOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEmployeeCasefile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"signingUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signingUserIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"signers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signers"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"recipients"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipients"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"documents"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documents"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"documentTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"reminderInterval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reminderInterval"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailSubject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailSubject"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailText"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"expireAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expireAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"enforceSignOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enforceSignOrder"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"casefileId"}}]}}]}}]} as unknown as DocumentNode<EmployeeCreateCaseFileMutation, EmployeeCreateCaseFileMutationVariables>;
export const UpdateEmployeeCasefileByEmployeeIdAndCasefileIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEmployeeCasefileByEmployeeIdAndCasefileId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"casefileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEmployeeCasefileByEmployeeIdAndCasefileId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"casefileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"casefileId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentTypeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateEmployeeCasefileByEmployeeIdAndCasefileIdMutation, UpdateEmployeeCasefileByEmployeeIdAndCasefileIdMutationVariables>;
export const DeleteEmployeeCasefileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteEmployeeCasefile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"casefileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEmployeeCasefileByEmployeeIdAndCasefileId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"casefileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"casefileId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteEmployeeCasefileMutation, DeleteEmployeeCasefileMutationVariables>;
export const DownloadCasefileDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"downloadCasefileDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"casefileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadCasefileDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"casefileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"casefileId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"documentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]} as unknown as DocumentNode<DownloadCasefileDocumentMutation, DownloadCasefileDocumentMutationVariables>;
export const SendSigningRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendSigningRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"casefileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signingRequestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendSigningRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"casefileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"casefileId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"signingRequestId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signingRequestId"}}}]}}]}]}}]} as unknown as DocumentNode<SendSigningRequestMutation, SendSigningRequestMutationVariables>;
export const ManuallySyncCasefileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"manuallySyncCasefile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"casefileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manuallySyncCasefile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"casefileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"casefileId"}}}]}}]}]}}]} as unknown as DocumentNode<ManuallySyncCasefileMutation, ManuallySyncCasefileMutationVariables>;
export const EmployeesImportFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmployeesImportFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useDefaultCustomFieldValues"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendPasswordToEmails"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mappings"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CsvMappingInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ImportEmployeesFromFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useDefaultCustomFieldValues"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useDefaultCustomFieldValues"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sendPasswordToEmails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendPasswordToEmails"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mappings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mappings"}}}]}}]}]}}]} as unknown as DocumentNode<EmployeesImportFileMutation, EmployeesImportFileMutationVariables>;
export const UpdateEmployeesFromCsvDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEmployeesFromCsv"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"csvFile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mappings"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CsvMappingInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clearFieldValuesWhenEmpty"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEmployeesFromCsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"csvFile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"csvFile"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mappings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mappings"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"clearFieldValuesWhenEmpty"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clearFieldValuesWhenEmpty"}}}]}}]}]}}]} as unknown as DocumentNode<UpdateEmployeesFromCsvMutation, UpdateEmployeesFromCsvMutationVariables>;
export const UpdateEmployeeRecordsFromCsvDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEmployeeRecordsFromCsv"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"csvFile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeRecordFieldId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEmployeeRecordsFromCsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"csvFile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"csvFile"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeRecordFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeRecordFieldId"}}}]}}]}]}}]} as unknown as DocumentNode<UpdateEmployeeRecordsFromCsvMutation, UpdateEmployeeRecordsFromCsvMutationVariables>;
export const EngagementTypeDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"engagementTypeDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEngagementTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<EngagementTypeDeleteMutation, EngagementTypeDeleteMutationVariables>;
export const EngagementTypeCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"engagementTypeCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEngagementType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"engagementType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<EngagementTypeCreateMutation, EngagementTypeCreateMutationVariables>;
export const EngagementTypeUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"engagementTypeUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEngagementTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<EngagementTypeUpdateMutation, EngagementTypeUpdateMutationVariables>;
export const EquipmentCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"equipmentCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEquipment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equipment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"serial"}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productTypeId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EquipmentCreateMutation, EquipmentCreateMutationVariables>;
export const UpdateEquipmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEquipment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEquipmentById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"serial"}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productTypeId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateEquipmentMutation, UpdateEquipmentMutationVariables>;
export const ProductCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"productCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serial"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignedUserId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"purchaseDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"equipment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentProductIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntries"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntryProductIdForeignInverseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"productTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"serial"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serial"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"assignedUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignedUserId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"purchaseDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"purchaseDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"equipment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"equipment"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldEntries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntries"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Product"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Equipment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Equipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"serial"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"acquisitionDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserDepartments"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserId"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedByEmployeeId"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedByDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Equipment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductCreateMutation, ProductCreateMutationVariables>;
export const ProductUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"productUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serial"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"purchaseDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"equipment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentProductIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntries"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntryProductIdForeignInverseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProductById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"productTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"serial"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serial"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"purchaseDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"purchaseDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"equipment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"equipment"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldEntries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntries"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Product"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Equipment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Equipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"serial"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"acquisitionDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserDepartments"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserId"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedByEmployeeId"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedByDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Equipment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductUpdateMutation, ProductUpdateMutationVariables>;
export const ProductDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"productDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProductById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Product"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Equipment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Equipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"serial"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"acquisitionDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserDepartments"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserId"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedByEmployeeId"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedByDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Equipment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductDeleteMutation, ProductDeleteMutationVariables>;
export const ProductTypeCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"productTypeCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProductType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<ProductTypeCreateMutation, ProductTypeCreateMutationVariables>;
export const ProductTypeUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"productTypeUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProductTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<ProductTypeUpdateMutation, ProductTypeUpdateMutationVariables>;
export const ProductTypeDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"productTypeDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProductTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ProductTypeDeleteMutation, ProductTypeDeleteMutationVariables>;
export const EquipmentImportFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EquipmentImportFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useDefaultCustomFieldValues"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ImportEquipmentFromFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"overwrite"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"useDefaultCustomFieldValues"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useDefaultCustomFieldValues"}}}]}}]}]}}]} as unknown as DocumentNode<EquipmentImportFileMutation, EquipmentImportFileMutationVariables>;
export const SortEquipmentCustomFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sortEquipmentCustomFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"equipmentFieldsOrder"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentFieldOrder"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sortEquipmentCustomFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equipmentFieldsOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"equipmentFieldsOrder"}}}]}}]}]}}]} as unknown as DocumentNode<SortEquipmentCustomFieldsMutation, SortEquipmentCustomFieldsMutationVariables>;
export const CreateErrorReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createErrorReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"error"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"routeName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAgent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"grantAccess"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCrash"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createErrorReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"error"},"value":{"kind":"Variable","name":{"kind":"Name","value":"error"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"routeName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"routeName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userAgent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAgent"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useEmail"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"grantAccess"},"value":{"kind":"Variable","name":{"kind":"Name","value":"grantAccess"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isCrash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCrash"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"response"}}]}}]}}]} as unknown as DocumentNode<CreateErrorReportMutation, CreateErrorReportMutationVariables>;
export const CreateEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deadline"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizerIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactPersonIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitedUserIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitedDepartmentIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitedAll"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deadline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deadline"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizerIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contactPersonIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactPersonIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"invitedUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitedUserIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"invitedDepartmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitedDepartmentIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"invitedAll"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitedAll"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateEventMutation, CreateEventMutationVariables>;
export const UpdateEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deadline"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizerIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactPersonIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitedUserIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitedDepartmentIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitedAll"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEventById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deadline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deadline"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizerIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contactPersonIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactPersonIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"invitedUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitedUserIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"invitedDepartmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitedDepartmentIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"invitedAll"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitedAll"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateEventMutation, UpdateEventMutationVariables>;
export const DeleteEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEventById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteEventMutation, DeleteEventMutationVariables>;
export const UpdateExternalIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateExternalIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldMappings"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"blacklistedFields"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whitelistedFields"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"config"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"continuousSync"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateExternalIntegrationById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldMappings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldMappings"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"credentials"},"value":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"blacklistedFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blacklistedFields"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"whitelistedFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whitelistedFields"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"config"},"value":{"kind":"Variable","name":{"kind":"Name","value":"config"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"continuousSync"},"value":{"kind":"Variable","name":{"kind":"Name","value":"continuousSync"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalIntegrationBasic"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalIntegrationBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalIntegration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"systemId"}},{"kind":"Field","name":{"kind":"Name","value":"externalCompanyId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMappings"}},{"kind":"Field","name":{"kind":"Name","value":"blacklistedFields"}},{"kind":"Field","name":{"kind":"Name","value":"whitelistedFields"}},{"kind":"Field","name":{"kind":"Name","value":"continuousSync"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentInheritance"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"system"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integrableSystem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"homepageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUrl"}}]}}]}}]} as unknown as DocumentNode<UpdateExternalIntegrationMutation, UpdateExternalIntegrationMutationVariables>;
export const DeleteExternalIntegrationByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteExternalIntegrationById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteExternalIntegrationById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteExternalIntegrationByIdMutation, DeleteExternalIntegrationByIdMutationVariables>;
export const UpdateIntegrationCredentialsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIntegrationCredentials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessToken"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UpdateIntegrationCredentials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"accessToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessToken"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"refreshToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateIntegrationCredentialsMutation, UpdateIntegrationCredentialsMutationVariables>;
export const CreateIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"system"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationSystemInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalCompanyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalAdditionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"apiKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessToken"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldMappings"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FieldMapping"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyEmployees"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"continuousSync"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"blacklistedFields"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BlacklistedField"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whitelistedFields"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WhitelistedField"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"overwriteExternalData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentInheritance"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payslipDocumentTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payslipDocumentFolderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"config"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"absenceSync"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"absenceMappings"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CreateIntegration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"system"},"value":{"kind":"Variable","name":{"kind":"Name","value":"system"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"externalCompanyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalCompanyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"externalAdditionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalAdditionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"apiKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"apiKey"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"accessToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessToken"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"refreshToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldMappings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldMappings"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyEmployees"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyEmployees"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"continuousSync"},"value":{"kind":"Variable","name":{"kind":"Name","value":"continuousSync"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"blacklistedFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blacklistedFields"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"whitelistedFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whitelistedFields"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"overwriteExternalData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"overwriteExternalData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentInheritance"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentInheritance"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"payslipDocumentTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payslipDocumentTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"payslipDocumentFolderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payslipDocumentFolderId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"config"},"value":{"kind":"Variable","name":{"kind":"Name","value":"config"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"absenceSync"},"value":{"kind":"Variable","name":{"kind":"Name","value":"absenceSync"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"absenceMappings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"absenceMappings"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CreateIntegrationMutation, CreateIntegrationMutationVariables>;
export const FieldGroupCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"fieldGroupCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFieldGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldGroup"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldGroup"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","alias":{"kind":"Name","value":"recordFields"},"name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"StringValue","value":"table","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCardColumns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FieldGroupCreateMutation, FieldGroupCreateMutationVariables>;
export const FieldGroupUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"fieldGroupUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFieldGroupById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldGroup"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","alias":{"kind":"Name","value":"recordFields"},"name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"StringValue","value":"table","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCardColumns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FieldGroupUpdateMutation, FieldGroupUpdateMutationVariables>;
export const FieldGroupDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"fieldGroupDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFieldGroupById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<FieldGroupDeleteMutation, FieldGroupDeleteMutationVariables>;
export const CreateFieldGroupCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createFieldGroupCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFieldGroupCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldGroupCard"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCardColumns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateFieldGroupCardMutation, CreateFieldGroupCardMutationVariables>;
export const UpdateFieldGroupCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateFieldGroupCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"columns"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFieldGroupCardById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"columns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"columns"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateFieldGroupCardMutation, UpdateFieldGroupCardMutationVariables>;
export const CreateFilterPresetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createFilterPreset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"columns"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"miscellaneousFilters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFilterPreset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filterPreset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tableName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"columns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"columns"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"miscellaneousFilters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"miscellaneousFilters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filterPreset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilterPreset"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilterPreset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FilterPreset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tableName"}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"filters"}},{"kind":"Field","name":{"kind":"Name","value":"miscellaneousFilters"}}]}}]} as unknown as DocumentNode<CreateFilterPresetMutation, CreateFilterPresetMutationVariables>;
export const UpdateFilterPresetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateFilterPreset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"columns"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"miscellaneousFilters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFilterPresetById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"columns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"columns"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"miscellaneousFilters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"miscellaneousFilters"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filterPreset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilterPreset"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilterPreset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FilterPreset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tableName"}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"filters"}},{"kind":"Field","name":{"kind":"Name","value":"miscellaneousFilters"}}]}}]} as unknown as DocumentNode<UpdateFilterPresetMutation, UpdateFilterPresetMutationVariables>;
export const DeleteFilterPresetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteFilterPreset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFilterPresetById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filterPreset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilterPreset"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilterPreset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FilterPreset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tableName"}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"filters"}},{"kind":"Field","name":{"kind":"Name","value":"miscellaneousFilters"}}]}}]} as unknown as DocumentNode<DeleteFilterPresetMutation, DeleteFilterPresetMutationVariables>;
export const FormFieldCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"formFieldCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"helpText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agreementText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agreementTextLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uniqueValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"defaultValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"required"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sensitive"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"multiple"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changesMustBeApproved"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverUserIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverSystemFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverFormFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supportsFutureData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldOptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldOptionFormFieldIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productTypeIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentTypeIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"competences"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompetenceRatingFormFieldIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"readPermissionGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"writePermissionGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"readWriteLeaderPermissions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentFormFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupCardColumnId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludedRoleIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFormField"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"helpText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"helpText"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"agreementText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agreementText"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"agreementTextLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agreementTextLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"uniqueValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uniqueValue"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"defaultValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"defaultValue"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"required"},"value":{"kind":"Variable","name":{"kind":"Name","value":"required"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sensitive"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"multiple"},"value":{"kind":"Variable","name":{"kind":"Name","value":"multiple"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"changesMustBeApproved"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changesMustBeApproved"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverUserIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverGroupIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverSystemFieldIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverSystemFieldIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverFormFieldIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverFormFieldIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"supportsFutureData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supportsFutureData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"metadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldOptions"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"productTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productTypeIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentTypeIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"competences"},"value":{"kind":"Variable","name":{"kind":"Name","value":"competences"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"readPermissionGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"readPermissionGroupIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"writePermissionGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"writePermissionGroupIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"readWriteLeaderPermissions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"readWriteLeaderPermissions"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentFormFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentFormFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldGroupCardColumnId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupCardColumnId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"excludedRoleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludedRoleIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}}]} as unknown as DocumentNode<FormFieldCreateMutation, FormFieldCreateMutationVariables>;
export const FormFieldUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"formFieldUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"helpText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agreementText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agreementTextLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uniqueValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"defaultValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"required"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sensitive"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changesMustBeApproved"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverUserIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverSystemFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverFormFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supportsFutureData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldOptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldOptionFormFieldIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupCardColumnId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productTypeIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentTypeIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"competences"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompetenceRatingFormFieldIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludedRoleIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFormFieldById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"helpText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"helpText"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"agreementText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agreementText"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"agreementTextLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agreementTextLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"uniqueValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uniqueValue"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"defaultValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"defaultValue"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"required"},"value":{"kind":"Variable","name":{"kind":"Name","value":"required"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sensitive"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"changesMustBeApproved"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changesMustBeApproved"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverUserIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverGroupIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverSystemFieldIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverSystemFieldIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverFormFieldIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverFormFieldIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"supportsFutureData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supportsFutureData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"metadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldOptions"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldGroupCardColumnId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupCardColumnId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"productTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productTypeIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentTypeIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"competences"},"value":{"kind":"Variable","name":{"kind":"Name","value":"competences"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"excludedRoleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludedRoleIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}}]} as unknown as DocumentNode<FormFieldUpdateMutation, FormFieldUpdateMutationVariables>;
export const FormFieldEntryCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"formFieldEntryCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFormFieldEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldEntry"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFieldEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormFieldEntry"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormFieldEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]} as unknown as DocumentNode<FormFieldEntryCreateMutation, FormFieldEntryCreateMutationVariables>;
export const FormFieldEntryUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"formFieldEntryUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFormFieldEntryById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFieldEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormFieldEntry"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormFieldEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]} as unknown as DocumentNode<FormFieldEntryUpdateMutation, FormFieldEntryUpdateMutationVariables>;
export const CreateFroalaStyleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createFroalaStyle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"values"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"css"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFroalaStyle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"froalaStyle"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"values"},"value":{"kind":"Variable","name":{"kind":"Name","value":"values"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"css"},"value":{"kind":"Variable","name":{"kind":"Name","value":"css"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"froalaStyle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FroalaStyle"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FroalaStyle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FroalaStyle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}},{"kind":"Field","name":{"kind":"Name","value":"css"}}]}}]} as unknown as DocumentNode<CreateFroalaStyleMutation, CreateFroalaStyleMutationVariables>;
export const UpdateFroalaStyleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateFroalaStyle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"values"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"css"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFroalaStyleById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"values"},"value":{"kind":"Variable","name":{"kind":"Name","value":"values"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"css"},"value":{"kind":"Variable","name":{"kind":"Name","value":"css"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"froalaStyle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FroalaStyle"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FroalaStyle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FroalaStyle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}},{"kind":"Field","name":{"kind":"Name","value":"css"}}]}}]} as unknown as DocumentNode<UpdateFroalaStyleMutation, UpdateFroalaStyleMutationVariables>;
export const DeleteFroalaStyleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteFroalaStyle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFroalaStyleById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"froalaStyle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FroalaStyle"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FroalaStyle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FroalaStyle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}},{"kind":"Field","name":{"kind":"Name","value":"css"}}]}}]} as unknown as DocumentNode<DeleteFroalaStyleMutation, DeleteFroalaStyleMutationVariables>;
export const CreateFutureDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createFutureData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateValueAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uniqueKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFutureDatum"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"argFormFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"argSystemFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"argValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"argUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"argUpdateValueAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateValueAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"argUniqueKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uniqueKey"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"futureDatum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FutureDatum"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntryId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"updateValueAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"previousHumanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"approvalIsRequired"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"creatorUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"readableName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalId"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]} as unknown as DocumentNode<CreateFutureDataMutation, CreateFutureDataMutationVariables>;
export const UpdateFutureDataByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateFutureDataById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFutureDatumById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"futureDatum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FutureDatum"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntryId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"updateValueAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"previousHumanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"approvalIsRequired"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"creatorUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"readableName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalId"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]} as unknown as DocumentNode<UpdateFutureDataByIdMutation, UpdateFutureDataByIdMutationVariables>;
export const CreateGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scope"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RoleScope"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autoAdd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autoAddNewPermissions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autoInherit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyFromGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"scope"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scope"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"autoAdd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autoAdd"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"autoAddNewPermissions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autoAddNewPermissions"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"autoInherit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autoInherit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"copyFromGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyFromGroupId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Group"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Role"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}},{"kind":"Field","name":{"kind":"Name","value":"usesItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Group"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"autoAdd"}},{"kind":"Field","name":{"kind":"Name","value":"autoAddNewPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"autoInherit"}},{"kind":"Field","name":{"kind":"Name","value":"groupRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"itemIds"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Role"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateGroupMutation, CreateGroupMutationVariables>;
export const UpdateGroupByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateGroupById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scope"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RoleScope"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autoAdd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autoAddNewPermissions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autoInherit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGroupById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"scope"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scope"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"autoAdd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autoAdd"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"autoAddNewPermissions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autoAddNewPermissions"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"autoInherit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autoInherit"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Group"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Role"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}},{"kind":"Field","name":{"kind":"Name","value":"usesItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Group"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"autoAdd"}},{"kind":"Field","name":{"kind":"Name","value":"autoAddNewPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"autoInherit"}},{"kind":"Field","name":{"kind":"Name","value":"groupRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"itemIds"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Role"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateGroupByIdMutation, UpdateGroupByIdMutationVariables>;
export const DeleteGroupByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteGroupById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGroupById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteGroupByIdMutation, DeleteGroupByIdMutationVariables>;
export const AddRoleToGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addRoleToGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addRoleToGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"itemIds"}}]}}]}}]}}]} as unknown as DocumentNode<AddRoleToGroupMutation, AddRoleToGroupMutationVariables>;
export const RemoveRoleFromGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeRoleFromGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeRoleFromGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<RemoveRoleFromGroupMutation, RemoveRoleFromGroupMutationVariables>;
export const CreateGroupRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createGroupRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGroupRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"groupRole"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"itemIds"}}]}}]}}]}}]} as unknown as DocumentNode<CreateGroupRoleMutation, CreateGroupRoleMutationVariables>;
export const UpdateGroupRoleByGroupIdAndRoleIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateGroupRoleByGroupIdAndRoleId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itemIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGroupRoleByGroupIdAndRoleId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"itemIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itemIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"itemIds"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateGroupRoleByGroupIdAndRoleIdMutation, UpdateGroupRoleByGroupIdAndRoleIdMutationVariables>;
export const DeleteIntegrableSystemIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteIntegrableSystemIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteIntegrableSystemIntegration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}]}}]} as unknown as DocumentNode<DeleteIntegrableSystemIntegrationMutation, DeleteIntegrableSystemIntegrationMutationVariables>;
export const CreateIntegrableSystemIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createIntegrableSystemIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIntegrableSystemIntegration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}]}}]}]}}]} as unknown as DocumentNode<CreateIntegrableSystemIntegrationMutation, CreateIntegrableSystemIntegrationMutationVariables>;
export const ActivateIntegrableSystemIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"activateIntegrableSystemIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateIntegrableSystemIntegration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}]}}]} as unknown as DocumentNode<ActivateIntegrableSystemIntegrationMutation, ActivateIntegrableSystemIntegrationMutationVariables>;
export const CreateLoggedActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createLoggedAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"affectedId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedFields"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLoggedAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tableName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"affectedId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"affectedId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"selectedFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedFields"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<CreateLoggedActionMutation, CreateLoggedActionMutationVariables>;
export const CreateLoggedActionNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createLoggedActionNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLoggedActionNote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loggedActionNote"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loggedActionEventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<CreateLoggedActionNoteMutation, CreateLoggedActionNoteMutationVariables>;
export const UpdateLoggedActionNoteByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateLoggedActionNoteById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLoggedActionNoteById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loggedActionNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLoggedActionNoteByIdMutation, UpdateLoggedActionNoteByIdMutationVariables>;
export const CreateMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageRecipients"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"body"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attachments"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AttachmentInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useWorkEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MessageChannel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SendMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"messageRecipients"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageRecipients"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"body"},"value":{"kind":"Variable","name":{"kind":"Name","value":"body"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"attachments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attachments"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useWorkEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useWorkEmail"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateMessageMutation, CreateMessageMutationVariables>;
export const NotificationCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"notificationCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hookName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipientType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailSubject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customRecipientEmployeeIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permissionGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customEmployeeFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notification"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notificationTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"recipientType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipientType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailSubject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailSubject"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customRecipientEmployeeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customRecipientEmployeeIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"permissionGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permissionGroupIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customEmployeeFieldIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customEmployeeFieldIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"metadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"hook"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connectByName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hookName"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Notification"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Notification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Notification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notificationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"hookId"}},{"kind":"Field","name":{"kind":"Name","value":"hookName"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"localizedText"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastTime"}},{"kind":"Field","name":{"kind":"Name","value":"channelTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NotificationCreateMutation, NotificationCreateMutationVariables>;
export const NotificationUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"notificationUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipientType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailSubject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customRecipientEmployeeIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permissionGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customEmployeeFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNotificationById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notificationTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"recipientType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipientType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailSubject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailSubject"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customRecipientEmployeeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customRecipientEmployeeIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"permissionGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permissionGroupIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customEmployeeFieldIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customEmployeeFieldIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"metadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Notification"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Notification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Notification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notificationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"hookId"}},{"kind":"Field","name":{"kind":"Name","value":"hookName"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"localizedText"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastTime"}},{"kind":"Field","name":{"kind":"Name","value":"channelTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NotificationUpdateMutation, NotificationUpdateMutationVariables>;
export const NotificationDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"notificationDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNotificationById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Notification"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Notification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Notification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notificationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"hookId"}},{"kind":"Field","name":{"kind":"Name","value":"hookName"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"localizedText"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastTime"}},{"kind":"Field","name":{"kind":"Name","value":"channelTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NotificationDeleteMutation, NotificationDeleteMutationVariables>;
export const NotificationTypeCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"notificationTypeCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelTypeIds"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationTypeChannelTypeNotificationTypeIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"broadcastTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"avoidBundling"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createNotificationType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notificationType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notificationTypeChannelTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelTypeIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"broadcastTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broadcastTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"timeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeZone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"avoidBundling"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avoidBundling"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"avoidBundling"}},{"kind":"Field","name":{"kind":"Name","value":"channelTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<NotificationTypeCreateMutation, NotificationTypeCreateMutationVariables>;
export const NotificationTypeUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"notificationTypeUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelTypeIds"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationTypeChannelTypeNotificationTypeIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"broadcastTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"avoidBundling"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteNotificationTypeChannelTypeByNotificationTypeId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notificationTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationTypeChannelTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"channelTypeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateNotificationTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notificationTypeChannelTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelTypeIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"broadcastTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broadcastTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"timeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeZone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"avoidBundling"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avoidBundling"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"avoidBundling"}},{"kind":"Field","name":{"kind":"Name","value":"channelTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<NotificationTypeUpdateMutation, NotificationTypeUpdateMutationVariables>;
export const NotificationTypeDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"notificationTypeDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNotificationTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"avoidBundling"}},{"kind":"Field","name":{"kind":"Name","value":"channelTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<NotificationTypeDeleteMutation, NotificationTypeDeleteMutationVariables>;
export const NotificationReadAllDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"notificationReadAll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationReadAll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<NotificationReadAllMutation, NotificationReadAllMutationVariables>;
export const UpdateNotificationEmployeeByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateNotificationEmployeeById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNotificationEmployeeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"read"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationEmployee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"localizedText"}},{"kind":"Field","name":{"kind":"Name","value":"hook"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"references"},"name":{"kind":"Name","value":"notificationEmployeeReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"object"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateNotificationEmployeeByIdMutation, UpdateNotificationEmployeeByIdMutationVariables>;
export const DeleteAllCompanyEmployeeNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAllCompanyEmployeeNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAllCompanyEmployeeNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"argCompanyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteAllCompanyEmployeeNotificationsMutation, DeleteAllCompanyEmployeeNotificationsMutationVariables>;
export const DeletePostTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePostType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePostTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeletePostTypeMutation, DeletePostTypeMutationVariables>;
export const PostTypeCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"postTypeCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sharedUsers"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sharedDepartments"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPostType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"postType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sharedUsers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sharedUsers"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sharedDepartments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sharedDepartments"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<PostTypeCreateMutation, PostTypeCreateMutationVariables>;
export const PostTypeUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"postTypeUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sharedUsers"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sharedDepartments"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePostTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sharedUsers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sharedUsers"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sharedDepartments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sharedDepartments"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<PostTypeUpdateMutation, PostTypeUpdateMutationVariables>;
export const CreatePreboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPreboarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboarding"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPreboarding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboarding"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboarding"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Preboarding"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Preboarding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Preboarding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"predecessorId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"fontSize"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"useContentColors"}},{"kind":"Field","name":{"kind":"Name","value":"contentBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"contentTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"logoWidth"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"nextButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"prevButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"logoType"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"smsBody"}},{"kind":"Field","name":{"kind":"Name","value":"linkButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"useCustomLinkButtonColor"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackText"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}},{"kind":"Field","name":{"kind":"Name","value":"confirmResults"}},{"kind":"Field","name":{"kind":"Name","value":"useLeader"}},{"kind":"Field","name":{"kind":"Name","value":"useWorkEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"closeAccess"}},{"kind":"Field","name":{"kind":"Name","value":"reminderDays"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipientCustomEmployeeFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerEmployeeFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontStorage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fontType"}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}}]}}]} as unknown as DocumentNode<CreatePreboardingMutation, CreatePreboardingMutationVariables>;
export const UpdatePreboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePreboarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"managerIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"predecessorId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fontSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fontUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"backgroundColor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"textColor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useContentColors"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentBackgroundColor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentTextColor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoWidth"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fontType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingFontType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingLogoType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstSlideName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstSlideTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstSlideDescription"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastSlideName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastSlideTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastSlideDescription"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"overviewSlideName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"overviewSlideTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"overviewSlideDescription"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nextButtonText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"prevButtonText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailSubject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailBody"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linkButtonText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fallbackText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"result"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"overviewSlideEnabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"completed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"published"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"archived"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useCustomLinkButtonColor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useLeader"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useWorkEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"confirmResults"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"disable2Fa"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deadline"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reminder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipientId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipientGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipientCustomEmployeeFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipientDirectManager"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"defaultManagerUserIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"defaultManagerGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"defaultManagerEmployeeFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"defaultManagerDirectManager"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingChannel"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"closeAccess"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reminderDays"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingEmployees"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingEmployeePreboardingIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"smsBody"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"engagementTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"anonymous"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePreboardingById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"managerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"managerIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"predecessorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"predecessorId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fontSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fontSize"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fontUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fontUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"backgroundColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"backgroundColor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"textColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"textColor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useContentColors"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useContentColors"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contentBackgroundColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentBackgroundColor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contentTextColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentTextColor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"logoWidth"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoWidth"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"logoType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fontType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fontType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"firstSlideName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstSlideName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"firstSlideTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstSlideTitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"firstSlideDescription"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstSlideDescription"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastSlideName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastSlideName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastSlideTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastSlideTitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastSlideDescription"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastSlideDescription"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"overviewSlideName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"overviewSlideName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"overviewSlideTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"overviewSlideTitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"overviewSlideDescription"},"value":{"kind":"Variable","name":{"kind":"Name","value":"overviewSlideDescription"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nextButtonText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nextButtonText"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"prevButtonText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"prevButtonText"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailSubject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailSubject"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailBody"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailBody"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"linkButtonText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linkButtonText"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fallbackText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fallbackText"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dateFormat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFormat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"result"},"value":{"kind":"Variable","name":{"kind":"Name","value":"result"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"overviewSlideEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"overviewSlideEnabled"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"completed"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"Variable","name":{"kind":"Name","value":"published"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"Variable","name":{"kind":"Name","value":"archived"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useCustomLinkButtonColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useCustomLinkButtonColor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useLeader"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useLeader"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useWorkEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useWorkEmail"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"confirmResults"},"value":{"kind":"Variable","name":{"kind":"Name","value":"confirmResults"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"disable2Fa"},"value":{"kind":"Variable","name":{"kind":"Name","value":"disable2Fa"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deadline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deadline"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"reminder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reminder"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"closeAccess"},"value":{"kind":"Variable","name":{"kind":"Name","value":"closeAccess"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"reminderDays"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reminderDays"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"recipientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipientId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"recipientGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipientGroupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"recipientCustomEmployeeFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipientCustomEmployeeFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"recipientDirectManager"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipientDirectManager"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"defaultManagerUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"defaultManagerUserIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"defaultManagerGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"defaultManagerGroupIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"defaultManagerEmployeeFieldIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"defaultManagerEmployeeFieldIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"defaultManagerDirectManager"},"value":{"kind":"Variable","name":{"kind":"Name","value":"defaultManagerDirectManager"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingEmployees"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingEmployees"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"smsBody"},"value":{"kind":"Variable","name":{"kind":"Name","value":"smsBody"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"engagementTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"engagementTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"anonymous"},"value":{"kind":"Variable","name":{"kind":"Name","value":"anonymous"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Preboarding"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Preboarding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Preboarding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"predecessorId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"fontSize"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"useContentColors"}},{"kind":"Field","name":{"kind":"Name","value":"contentBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"contentTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"logoWidth"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"nextButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"prevButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"logoType"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"smsBody"}},{"kind":"Field","name":{"kind":"Name","value":"linkButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"useCustomLinkButtonColor"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackText"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}},{"kind":"Field","name":{"kind":"Name","value":"confirmResults"}},{"kind":"Field","name":{"kind":"Name","value":"useLeader"}},{"kind":"Field","name":{"kind":"Name","value":"useWorkEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"closeAccess"}},{"kind":"Field","name":{"kind":"Name","value":"reminderDays"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipientCustomEmployeeFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerEmployeeFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontStorage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fontType"}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}}]}}]} as unknown as DocumentNode<UpdatePreboardingMutation, UpdatePreboardingMutationVariables>;
export const UpdatePreboardingEmployeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePreboardingEmployee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"managerIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conclusion"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"completed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"published"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"archived"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingResults"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingResultPreboardingEmployeeIdForeignInverseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePreboardingEmployeeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"managerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"managerIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"conclusion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conclusion"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"completed"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"Variable","name":{"kind":"Name","value":"published"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"Variable","name":{"kind":"Name","value":"archived"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingResults"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingResults"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingEmployee"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Preboarding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Preboarding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"predecessorId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"fontSize"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"useContentColors"}},{"kind":"Field","name":{"kind":"Name","value":"contentBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"contentTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"logoWidth"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"nextButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"prevButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"logoType"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"smsBody"}},{"kind":"Field","name":{"kind":"Name","value":"linkButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"useCustomLinkButtonColor"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackText"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}},{"kind":"Field","name":{"kind":"Name","value":"confirmResults"}},{"kind":"Field","name":{"kind":"Name","value":"useLeader"}},{"kind":"Field","name":{"kind":"Name","value":"useWorkEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"closeAccess"}},{"kind":"Field","name":{"kind":"Name","value":"reminderDays"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipientCustomEmployeeFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerEmployeeFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontStorage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fontType"}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingEmployee"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingEmployee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"conclusion"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completedReminded"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Preboarding"}}]}}]}}]} as unknown as DocumentNode<UpdatePreboardingEmployeeMutation, UpdatePreboardingEmployeeMutationVariables>;
export const CreatePreboardingSlideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPreboardingSlide"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPreboardingSlide"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingSlide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}}]} as unknown as DocumentNode<CreatePreboardingSlideMutation, CreatePreboardingSlideMutationVariables>;
export const UpdatePreboardingSlideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePreboardingSlide"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageDescription"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingSlideFormFields"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormFieldPreboardingSlideIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addReviewNote"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reviewNote"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePreboardingSlideById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pageTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageTitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pageDescription"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageDescription"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingSlideFormFields"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"addReviewNote"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addReviewNote"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"reviewNote"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reviewNote"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingSlide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePreboardingSlideMutation, UpdatePreboardingSlideMutationVariables>;
export const CreatePreboardingSlideFormFieldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPreboardingSlideFormField"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departments"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingSlideId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingSlideFormFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"required"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldOptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldOptionFormFieldIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"engagementTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPreboardingSlideFormField"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingSlideId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingSlideFormFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"required"},"value":{"kind":"Variable","name":{"kind":"Name","value":"required"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departments"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"required"},"value":{"kind":"Variable","name":{"kind":"Name","value":"required"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"metadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldOptions"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"StringValue","value":"preboarding","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"engagementTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"engagementTypeId"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}}]} as unknown as DocumentNode<CreatePreboardingSlideFormFieldMutation, CreatePreboardingSlideFormFieldMutationVariables>;
export const UpdatePreboardingSlideFormFieldByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePreboardingSlideFormFieldById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"required"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldOptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldOptionFormFieldIdForeignInverseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePreboardingSlideFormFieldById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"required"},"value":{"kind":"Variable","name":{"kind":"Name","value":"required"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updateById"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"required"},"value":{"kind":"Variable","name":{"kind":"Name","value":"required"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"metadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldOptions"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingSlide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePreboardingSlideFormFieldByIdMutation, UpdatePreboardingSlideFormFieldByIdMutationVariables>;
export const UpdatePreboardingSlideFormFieldByIdBasic1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePreboardingSlideFormFieldByIdBasic1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"required"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePreboardingSlideFormFieldById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"required"},"value":{"kind":"Variable","name":{"kind":"Name","value":"required"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingSlide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePreboardingSlideFormFieldByIdBasic1Mutation, UpdatePreboardingSlideFormFieldByIdBasic1MutationVariables>;
export const DeletePreboardingSlideFormFieldByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePreboardingSlideFormFieldById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePreboardingSlideFormFieldById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingSlide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}}]} as unknown as DocumentNode<DeletePreboardingSlideFormFieldByIdMutation, DeletePreboardingSlideFormFieldByIdMutationVariables>;
export const CreatePreboardingSlideFormFieldNoCreateFormFieldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPreboardingSlideFormFieldNoCreateFormField"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingSlideFormField"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormFieldInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPreboardingSlideFormField"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormField"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingSlideFormField"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreatePreboardingSlideFormFieldNoCreateFormFieldMutation, CreatePreboardingSlideFormFieldNoCreateFormFieldMutationVariables>;
export const UpdatePreboardingSlideFormFieldByIdNoCreateFormFieldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePreboardingSlideFormFieldByIdNoCreateFormField"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingSlideFormField"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormFieldPatch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePreboardingSlideFormFieldById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingSlideFormField"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePreboardingSlideFormFieldByIdNoCreateFormFieldMutation, UpdatePreboardingSlideFormFieldByIdNoCreateFormFieldMutationVariables>;
export const SendPreboardingLinksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendPreboardingLinks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailSubject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailBody"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"smsBody"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linkButtonText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useWorkEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingChannel"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SendPreboardingLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailSubject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailSubject"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailBody"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailBody"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"smsBody"},"value":{"kind":"Variable","name":{"kind":"Name","value":"smsBody"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"linkButtonText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linkButtonText"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useWorkEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useWorkEmail"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sendTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendTime"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"links"}}]}}]}}]} as unknown as DocumentNode<SendPreboardingLinksMutation, SendPreboardingLinksMutationVariables>;
export const CreatePreboardingCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPreboardingComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingResultId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingSlideId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPreboardingResultSlideComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingResultSlideComment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingResultId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingResultId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingSlideId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingResultSlideComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingResultSlideComment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingResultSlideComment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingResultSlideComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideId"}},{"kind":"Field","name":{"kind":"Name","value":"edited"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<CreatePreboardingCommentMutation, CreatePreboardingCommentMutationVariables>;
export const UpdatePreboardingCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePreboardingComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"public"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"edited"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePreboardingResultSlideCommentById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"public"},"value":{"kind":"Variable","name":{"kind":"Name","value":"public"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"edited"},"value":{"kind":"Variable","name":{"kind":"Name","value":"edited"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingResultSlideComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingResultSlideComment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingResultSlideComment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingResultSlideComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideId"}},{"kind":"Field","name":{"kind":"Name","value":"edited"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<UpdatePreboardingCommentMutation, UpdatePreboardingCommentMutationVariables>;
export const DeletePreboardingCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePreboardingComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePreboardingResultSlideCommentById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingResultSlideComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeletePreboardingCommentMutation, DeletePreboardingCommentMutationVariables>;
export const CreatePreboardingResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPreboardingResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingEmployeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"result"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPreboardingResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingResult"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingEmployeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingEmployeeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"result"},"value":{"kind":"Variable","name":{"kind":"Name","value":"result"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<CreatePreboardingResultMutation, CreatePreboardingResultMutationVariables>;
export const UpdatePreboardingResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePreboardingResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"result"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePreboardingResultById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"result"},"value":{"kind":"Variable","name":{"kind":"Name","value":"result"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdatePreboardingResultMutation, UpdatePreboardingResultMutationVariables>;
export const CreatePreboardingProcessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPreboardingProcess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDay"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"duration"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deadlineReminder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deadlineReminderDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPreboardingProcess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingProcess"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"processId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sendTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sendDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDay"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDay"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"duration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duration"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deadlineReminder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deadlineReminder"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deadlineReminderDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deadlineReminderDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<CreatePreboardingProcessMutation, CreatePreboardingProcessMutationVariables>;
export const UpdatePreboardingProcessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePreboardingProcess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDay"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"duration"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deadlineReminder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deadlineReminderDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deadline"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipientId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailSubject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailBody"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linkButtonText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePreboardingProcessByPreboardingIdAndProcessId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"processId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sendDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sendTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDay"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDay"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"duration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duration"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deadlineReminder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deadlineReminder"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deadlineReminderDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deadlineReminderDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboarding"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updateById"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deadline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deadline"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"recipientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipientId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailSubject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailSubject"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailBody"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailBody"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"linkButtonText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linkButtonText"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdatePreboardingProcessMutation, UpdatePreboardingProcessMutationVariables>;
export const DeletePreboardingProcessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePreboardingProcess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePreboardingProcessByPreboardingIdAndProcessId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"processId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeletePreboardingProcessMutation, DeletePreboardingProcessMutationVariables>;
export const CreatePreboardingFormCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPreboardingFormCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formValues"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPreboardingFormCache"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingFormCache"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formValues"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formValues"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<CreatePreboardingFormCacheMutation, CreatePreboardingFormCacheMutationVariables>;
export const UpdatePreboardingFormCacheByPreboardingIdAndUserIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePreboardingFormCacheByPreboardingIdAndUserId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formValues"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePreboardingFormCacheByPreboardingIdAndUserId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formValues"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formValues"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdatePreboardingFormCacheByPreboardingIdAndUserIdMutation, UpdatePreboardingFormCacheByPreboardingIdAndUserIdMutationVariables>;
export const CreateProcessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createProcess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cutoffDay"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignedUserDepartments"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"template"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processResponsibles"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProcessResponsibleProcessIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projects"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectProcessIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tasks"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskProcessIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessages"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageProcessIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectTemplates"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectTemplateProcessIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskTemplates"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskTemplateProcessIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageTemplates"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageTemplateProcessIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingProcesses"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingProcessProcessIdForeignInverseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProcess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"process"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cutoffDay"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cutoffDay"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"assignedUserDepartments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignedUserDepartments"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"processTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"template"},"value":{"kind":"Variable","name":{"kind":"Name","value":"template"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"processResponsibles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processResponsibles"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projects"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tasks"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tasks"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"scheduledMessages"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessages"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectTemplates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectTemplates"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"taskTemplates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskTemplates"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"scheduledMessageTemplates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageTemplates"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingProcesses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingProcesses"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProcessMutation, CreateProcessMutationVariables>;
export const UpdateProcessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProcess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cutoffDay"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"template"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"completed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employee"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProcessEmployeeIdForeignInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProcessById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"processTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cutoffDay"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cutoffDay"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"template"},"value":{"kind":"Variable","name":{"kind":"Name","value":"template"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"completed"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employee"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"processTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProcessMutation, UpdateProcessMutationVariables>;
export const CloneProcessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cloneProcess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cloneProcess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"processId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CloneProcessMutation, CloneProcessMutationVariables>;
export const ProcessTypeDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"processTypeDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProcessTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ProcessTypeDeleteMutation, ProcessTypeDeleteMutationVariables>;
export const ProcessTypeCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"processTypeCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProcessType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"processType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<ProcessTypeCreateMutation, ProcessTypeCreateMutationVariables>;
export const ProcessTypeUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"processTypeUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProcessTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<ProcessTypeUpdateMutation, ProcessTypeUpdateMutationVariables>;
export const CreateProjectTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createProjectTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProjectTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectTemplate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"processId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<CreateProjectTemplateMutation, CreateProjectTemplateMutationVariables>;
export const UpdateProjectTemplateByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProjectTemplateById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectTemplatePatch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectTemplateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patch"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateProjectTemplateByIdMutation, UpdateProjectTemplateByIdMutationVariables>;
export const CreateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departments"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tasks"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskProjectIdForeignInverseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"processId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departments"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tasks"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tasks"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<CreateProjectMutation, CreateProjectMutationVariables>;
export const UpdateProjectByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProjectById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectPatch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patch"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateProjectByIdMutation, UpdateProjectByIdMutationVariables>;
export const CreatePulseSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPulseSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"question"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PulseSurveyQuestionType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lowestRatingLabel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lowestRatingLabelLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highestRatingLabel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highestRatingLabelLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lowestRating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highestRating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"anonymous"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pulseTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDraft"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"horizontal"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratingType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RatingType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pulseSurveyChoices"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePulseSurveyChoiceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recurrenceRule"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecurrenceRuleInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitedUserIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitedDepartmentIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitedAll"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reminders"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntervalInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timezoneName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPulseSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"question"},"value":{"kind":"Variable","name":{"kind":"Name","value":"question"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"questionLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"questionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lowestRatingLabel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lowestRatingLabel"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lowestRatingLabelLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lowestRatingLabelLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"highestRatingLabel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highestRatingLabel"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"highestRatingLabelLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highestRatingLabelLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lowestRating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lowestRating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"highestRating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highestRating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"anonymous"},"value":{"kind":"Variable","name":{"kind":"Name","value":"anonymous"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pulseTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pulseTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"surveyTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isDraft"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDraft"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"horizontal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horizontal"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ratingType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratingType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pulseSurveyChoices"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pulseSurveyChoices"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"recurrenceRule"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recurrenceRule"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"invitedUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitedUserIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"invitedDepartmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitedDepartmentIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"invitedAll"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitedAll"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"reminders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reminders"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"timezoneName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timezoneName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PulseSurveyListItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PulseSurveyListItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PulseSurvey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"questionType"}},{"kind":"Field","name":{"kind":"Name","value":"localizedQuestion"}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"surveyTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"isDraft"}},{"kind":"Field","name":{"kind":"Name","value":"highestRating"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingAllTime"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingThisMonth"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingThisMonthLastYear"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingAllTimeLastYear"}},{"kind":"Field","name":{"kind":"Name","value":"invitedAll"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pulseType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pulseSurveyChoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ORDER_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}}]}}]}}]} as unknown as DocumentNode<CreatePulseSurveyMutation, CreatePulseSurveyMutationVariables>;
export const UpdatePulseSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePulseSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"question"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pulseTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PulseSurveyQuestionType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"anonymous"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lowestRating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highestRating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lowestRatingLabel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lowestRatingLabelLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highestRatingLabel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"highestRatingLabelLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDraft"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"horizontal"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratingType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RatingType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recurrenceRule"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RecurrenceRulePulseSurveyIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitedUserIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitedDepartmentIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitedAll"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reminders"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntervalInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pulseSurveyChoiceLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PulseSurveyChoiceLocalization"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePulseSurveyById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"question"},"value":{"kind":"Variable","name":{"kind":"Name","value":"question"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"questionLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pulseTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pulseTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"questionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"anonymous"},"value":{"kind":"Variable","name":{"kind":"Name","value":"anonymous"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"surveyTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lowestRating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lowestRating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"highestRating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highestRating"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lowestRatingLabel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lowestRatingLabel"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lowestRatingLabelLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lowestRatingLabelLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"highestRatingLabel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highestRatingLabel"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"highestRatingLabelLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"highestRatingLabelLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isDraft"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDraft"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"horizontal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horizontal"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ratingType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratingType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"recurrenceRule"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recurrenceRule"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"invitedUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitedUserIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"invitedDepartmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitedDepartmentIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"invitedAll"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitedAll"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"reminders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reminders"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pulseSurveyChoiceLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pulseSurveyChoiceLocalizations"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pulseSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PulseSurveyListItem"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PulseSurveyListItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PulseSurvey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"questionType"}},{"kind":"Field","name":{"kind":"Name","value":"localizedQuestion"}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"surveyTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"isDraft"}},{"kind":"Field","name":{"kind":"Name","value":"highestRating"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingAllTime"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingThisMonth"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingThisMonthLastYear"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingAllTimeLastYear"}},{"kind":"Field","name":{"kind":"Name","value":"invitedAll"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pulseType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pulseSurveyChoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ORDER_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePulseSurveyMutation, UpdatePulseSurveyMutationVariables>;
export const DeletePulseSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePulseSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePulseSurveyById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeletePulseSurveyMutation, DeletePulseSurveyMutationVariables>;
export const SubmitPulseSurveyAnswerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"submitPulseSurveyAnswer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pulseSurveyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"answer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitPulseSurveyAnswer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pulseSurveyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pulseSurveyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"answer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"answer"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SubmitPulseSurveyAnswerMutation, SubmitPulseSurveyAnswerMutationVariables>;
export const PulseTypeDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"pulseTypeDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePulseTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pulseType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<PulseTypeDeleteMutation, PulseTypeDeleteMutationVariables>;
export const PulseTypeCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"pulseTypeCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPulseType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pulseType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pulseType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<PulseTypeCreateMutation, PulseTypeCreateMutationVariables>;
export const PulseTypeUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"pulseTypeUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePulseTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pulseType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<PulseTypeUpdateMutation, PulseTypeUpdateMutationVariables>;
export const CreateRoadmapItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRoadmapItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapStage"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roadmapItemLocalization"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItemLocalizationRoadmapItemIdForeignConnectionRoadmapItemLocalizationCreateInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRoadmapItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roadmapItem"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stage"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roadmapItemLocalizations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roadmapItemLocalization"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roadmapItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoadmapItem"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}}]}}]} as unknown as DocumentNode<CreateRoadmapItemMutation, CreateRoadmapItemMutationVariables>;
export const UpdateRoadmapItemByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRoadmapItemById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapStage"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roadmapItemLocalization"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItemLocalizationOnRoadmapItemLocalizationForRoadmapItemLocalizationRoadmapItemIdForeignUsingRoadmapItemLocalizationRoadmapItemIdLocaleUniqueUpdate"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRoadmapItemById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roadmapItemLocalizations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updateByRoadmapItemIdAndLocale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roadmapItemLocalization"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"stage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stage"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roadmapItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoadmapItem"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}}]}}]} as unknown as DocumentNode<UpdateRoadmapItemByIdMutation, UpdateRoadmapItemByIdMutationVariables>;
export const CreateRoadmapItemVoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRoadmapItemVote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roadmapItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"voteType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItemVoteType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRoadmapItemVote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roadmapItemVote"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roadmapItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roadmapItemId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"voteType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"voteType"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roadmapItemVote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoadmapItemVote"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItemVote"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItemVote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roadmapItemId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"voteType"}}]}}]} as unknown as DocumentNode<CreateRoadmapItemVoteMutation, CreateRoadmapItemVoteMutationVariables>;
export const DeleteRoadmapItemVoteByUserIdAndRoadmapItemIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteRoadmapItemVoteByUserIdAndRoadmapItemId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roadmapItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRoadmapItemVoteByUserIdAndRoadmapItemId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roadmapItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roadmapItemId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roadmapItemVote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoadmapItemVote"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItemVote"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItemVote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roadmapItemId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"voteType"}}]}}]} as unknown as DocumentNode<DeleteRoadmapItemVoteByUserIdAndRoadmapItemIdMutation, DeleteRoadmapItemVoteByUserIdAndRoadmapItemIdMutationVariables>;
export const DeleteRoadMapItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteRoadMapItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRoadmapItemById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roadmapItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoadmapItem"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}}]}}]} as unknown as DocumentNode<DeleteRoadMapItemMutation, DeleteRoadMapItemMutationVariables>;
export const CreateRoadmapItemCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRoadmapItemComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roadmapItemId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRoadmapItemComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roadmapItemComment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roadmapItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roadmapItemId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roadmapItemComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roadmapItemId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}}]}}]}}]}}]} as unknown as DocumentNode<CreateRoadmapItemCommentMutation, CreateRoadmapItemCommentMutationVariables>;
export const UpdateRoadmapItemCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRoadmapItemComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRoadmapItemCommentById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roadmapItemComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRoadmapItemCommentMutation, UpdateRoadmapItemCommentMutationVariables>;
export const DeleteRoadmapItemCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteRoadmapItemComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRoadmapItemCommentById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roadmapItemComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteRoadmapItemCommentMutation, DeleteRoadmapItemCommentMutationVariables>;
export const AddRoleToUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addRoleToUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addRoleToUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}}]}}]}}]}}]} as unknown as DocumentNode<AddRoleToUserMutation, AddRoleToUserMutationVariables>;
export const AddDepartmentRoleToUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addDepartmentRoleToUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addDepartmentRoleToUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userDepartmentRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}}]}}]}}]}}]} as unknown as DocumentNode<AddDepartmentRoleToUserMutation, AddDepartmentRoleToUserMutationVariables>;
export const AddCompanyRoleToUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addCompanyRoleToUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addCompanyRoleToUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompanyRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}}]}}]}}]}}]} as unknown as DocumentNode<AddCompanyRoleToUserMutation, AddCompanyRoleToUserMutationVariables>;
export const RemoveRoleFromUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeRoleFromUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeRoleFromUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<RemoveRoleFromUserMutation, RemoveRoleFromUserMutationVariables>;
export const RemoveDepartmentRoleFromUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeDepartmentRoleFromUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeDepartmentRoleFromUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<RemoveDepartmentRoleFromUserMutation, RemoveDepartmentRoleFromUserMutationVariables>;
export const RemoveCompanyRoleFromUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeCompanyRoleFromUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCompanyRoleFromUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<RemoveCompanyRoleFromUserMutation, RemoveCompanyRoleFromUserMutationVariables>;
export const UserDepartmentRoleToggleInheritanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userDepartmentRoleToggleInheritance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inheritToDescendants"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyIncludeInDescendants"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserDepartmentRoleByUserIdAndDepartmentIdAndRoleId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"inheritToDescendants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inheritToDescendants"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"onlyIncludeInDescendants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyIncludeInDescendants"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userDepartmentRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"inheritToDescendants"}},{"kind":"Field","name":{"kind":"Name","value":"onlyIncludeInDescendants"}}]}}]}}]}}]} as unknown as DocumentNode<UserDepartmentRoleToggleInheritanceMutation, UserDepartmentRoleToggleInheritanceMutationVariables>;
export const UserRoleToggleExclusionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userRoleToggleExclusion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeRole"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserRoleByUserIdAndRoleId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"excludeRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeRole"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"excludeRole"}}]}}]}}]}}]} as unknown as DocumentNode<UserRoleToggleExclusionMutation, UserRoleToggleExclusionMutationVariables>;
export const UserDepartmentRoleToggleExclusionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userDepartmentRoleToggleExclusion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeRole"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserDepartmentRoleByUserIdAndDepartmentIdAndRoleId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"excludeRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeRole"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userDepartmentRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"excludeRole"}}]}}]}}]}}]} as unknown as DocumentNode<UserDepartmentRoleToggleExclusionMutation, UserDepartmentRoleToggleExclusionMutationVariables>;
export const UserCompanyRoleToggleExclusionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userCompanyRoleToggleExclusion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeRole"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserCompanyRoleByUserIdAndRoleIdAndCompanyId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"excludeRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeRole"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompanyRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"excludeRole"}}]}}]}}]}}]} as unknown as DocumentNode<UserCompanyRoleToggleExclusionMutation, UserCompanyRoleToggleExclusionMutationVariables>;
export const CreateScheduledMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createScheduledMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"body"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageRecipients"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageRecipientScheduledMessageIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageExternalRecipients"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createScheduledMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scheduledMessage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"body"},"value":{"kind":"Variable","name":{"kind":"Name","value":"body"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sendDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"processId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"scheduledMessageRecipients"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageRecipients"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"scheduledMessageExternalRecipients"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageExternalRecipients"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateScheduledMessageMutation, CreateScheduledMessageMutationVariables>;
export const CreateScheduledMessageTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createScheduledMessageTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"body"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDay"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeEmployee"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDirectManager"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeGroups"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeCustomEmployeeFields"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageTemplateRecipients"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageTemplateExternalRecipients"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createScheduledMessageTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scheduledMessageTemplate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"body"},"value":{"kind":"Variable","name":{"kind":"Name","value":"body"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDay"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDay"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sendTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeEmployee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeEmployee"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeDirectManager"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDirectManager"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeGroups"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeCustomEmployeeFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeCustomEmployeeFields"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"processId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"scheduledMessageTemplateRecipients"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageTemplateRecipients"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"scheduledMessageTemplateExternalRecipients"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageTemplateExternalRecipients"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateScheduledMessageTemplateMutation, CreateScheduledMessageTemplateMutationVariables>;
export const UpdateScheduledMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateScheduledMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"body"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageRecipients"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageRecipientScheduledMessageIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageExternalRecipients"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageExternalRecipientScheduledMessageIdForeiInverseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScheduledMessageById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"body"},"value":{"kind":"Variable","name":{"kind":"Name","value":"body"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sendDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"processId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"scheduledMessageRecipients"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageRecipients"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"scheduledMessageExternalRecipients"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageExternalRecipients"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateScheduledMessageMutation, UpdateScheduledMessageMutationVariables>;
export const UpdateScheduledMessageTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateScheduledMessageTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"body"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDay"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeEmployee"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDirectManager"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeGroups"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeCustomEmployeeFields"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageTemplateRecipients"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageTemplateRecipientScheduledMessageTemplateInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageTemplateExternalRecipients"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageTemplateExternalRecipientScheduledMessageInverseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScheduledMessageTemplateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"body"},"value":{"kind":"Variable","name":{"kind":"Name","value":"body"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDay"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDay"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sendTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeEmployee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeEmployee"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeDirectManager"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDirectManager"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeGroups"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeCustomEmployeeFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeCustomEmployeeFields"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"processId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"scheduledMessageTemplateRecipients"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageTemplateRecipients"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"scheduledMessageTemplateExternalRecipients"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageTemplateExternalRecipients"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateScheduledMessageTemplateMutation, UpdateScheduledMessageTemplateMutationVariables>;
export const DeleteScheduledMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteScheduledMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScheduledMessageById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteScheduledMessageMutation, DeleteScheduledMessageMutationVariables>;
export const DeleteScheduledMessageTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteScheduledMessageTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateScheduledMessageTemplateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteScheduledMessageTemplateMutation, DeleteScheduledMessageTemplateMutationVariables>;
export const DeleteScheduledMessageRecipientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteScheduledMessageRecipient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteScheduledMessageRecipientByScheduledMessageIdAndEmployeeId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scheduledMessageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteScheduledMessageRecipientMutation, DeleteScheduledMessageRecipientMutationVariables>;
export const DeleteScheduledMessageTemplateRecipientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteScheduledMessageTemplateRecipient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteScheduledMessageTemplateRecipientByScheduledMessageTemplateIdAndEmployeeId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scheduledMessageTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteScheduledMessageTemplateRecipientMutation, DeleteScheduledMessageTemplateRecipientMutationVariables>;
export const DeleteScheduledMessageExternalRecipientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteScheduledMessageExternalRecipient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteScheduledMessageExternalRecipientByScheduledMessageIdAndEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scheduledMessageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteScheduledMessageExternalRecipientMutation, DeleteScheduledMessageExternalRecipientMutationVariables>;
export const DeleteScheduledMessageTemplateExternalRecipientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteScheduledMessageTemplateExternalRecipient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteScheduledMessageTemplateExternalRecipientByScheduledMessageTemplateIdAndEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scheduledMessageTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledMessageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteScheduledMessageTemplateExternalRecipientMutation, DeleteScheduledMessageTemplateExternalRecipientMutationVariables>;
export const CreateCompanySystemFieldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCompanySystemField"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sensitive"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changesMustBeApproved"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverUserIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverSystemFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverFormFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supportsFutureData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"required"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uniqueValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"defaultValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCompanySystemField"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companySystemField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sensitive"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"changesMustBeApproved"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changesMustBeApproved"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverUserIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverGroupIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverSystemFieldIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverSystemFieldIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverFormFieldIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverFormFieldIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"supportsFutureData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supportsFutureData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"required"},"value":{"kind":"Variable","name":{"kind":"Name","value":"required"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"uniqueValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uniqueValue"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"defaultValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"defaultValue"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"metadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateCompanySystemFieldMutation, CreateCompanySystemFieldMutationVariables>;
export const UpdateCompanySystemFieldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCompanySystemField"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sensitive"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changesMustBeApproved"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverUserIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverSystemFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverFormFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supportsFutureData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"required"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uniqueValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"defaultValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupCardColumnId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companySystemFieldOptions"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySystemFieldOptionCompanySystemFieldIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alias"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aliasLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"helpText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"helpTextLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludedRoleIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompanySystemFieldById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sensitive"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"changesMustBeApproved"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changesMustBeApproved"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverUserIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverGroupIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverSystemFieldIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverSystemFieldIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverFormFieldIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverFormFieldIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"supportsFutureData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supportsFutureData"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"required"},"value":{"kind":"Variable","name":{"kind":"Name","value":"required"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"uniqueValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uniqueValue"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"defaultValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"defaultValue"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"metadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldGroupCardColumnId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupCardColumnId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companySystemFieldOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companySystemFieldOptions"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"alias"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alias"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"aliasLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aliasLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"helpText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"helpText"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"helpTextLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"helpTextLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"excludedRoleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludedRoleIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAlias"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCompanySystemFieldMutation, UpdateCompanySystemFieldMutationVariables>;
export const CreateTaskTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTaskTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"duration"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDay"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deadlineReminder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useCalendarEvent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calendarEventFrom"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calendarEventTo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calendarEventOrganizerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeEmployee"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDirectManager"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeEmployeeResponsible"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDirectManagerResponsible"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeCustomEmployeeFields"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeCustomEmployeeFieldsResponsibles"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeGroups"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeGroupsResponsibles"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskTemplateEmployees"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskTemplateEmployeeTaskTemplateIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskTemplateResponsibles"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskTemplateResponsibleTaskTemplateIdForeignInverseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTaskTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"taskTemplate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"processId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"duration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duration"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDay"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDay"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deadlineReminder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deadlineReminder"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useCalendarEvent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useCalendarEvent"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"calendarEventFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calendarEventFrom"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"calendarEventTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calendarEventTo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"calendarEventOrganizerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calendarEventOrganizerId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeEmployee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeEmployee"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeDirectManager"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDirectManager"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeEmployeeResponsible"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeEmployeeResponsible"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeDirectManagerResponsible"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDirectManagerResponsible"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeCustomEmployeeFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeCustomEmployeeFields"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeCustomEmployeeFieldsResponsibles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeCustomEmployeeFieldsResponsibles"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeGroups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeGroups"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeGroupsResponsibles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeGroupsResponsibles"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"taskTemplateEmployees"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskTemplateEmployees"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"taskTemplateResponsibles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskTemplateResponsibles"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taskTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTaskTemplateMutation, CreateTaskTemplateMutationVariables>;
export const UpdateTaskTemplateByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTaskTemplateById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskTemplatePatch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTaskTemplateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patch"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateTaskTemplateByIdMutation, UpdateTaskTemplateByIdMutationVariables>;
export const CreateTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departments"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deadlineReminderDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskEmployees"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskEmployeeTaskIdForeignInverseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskResponsibles"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskResponsibleTaskIdForeignInverseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"processId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departments"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deadlineReminderDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deadlineReminderDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"taskEmployees"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskEmployees"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"taskResponsibles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskResponsibles"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTaskMutation, CreateTaskMutationVariables>;
export const UpdateTaskByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTaskById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskPatch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTaskById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patch"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Task"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Task"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminderDate"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"parentTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventFrom"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventTo"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventOrganizerId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"parentTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"processTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleResponsibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskResponsibles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTaskByIdMutation, UpdateTaskByIdMutationVariables>;
export const CompleteTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"completeTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"argTaskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Task"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Task"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminderDate"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"parentTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventFrom"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventTo"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventOrganizerId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"parentTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"processTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleResponsibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskResponsibles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}}]} as unknown as DocumentNode<CompleteTaskMutation, CompleteTaskMutationVariables>;
export const DeleteTaskEmployeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTaskEmployee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTaskEmployeeByTaskIdAndEmployeeId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"taskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteTaskEmployeeMutation, DeleteTaskEmployeeMutationVariables>;
export const DeleteTaskTemplateEmployeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTaskTemplateEmployee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTaskTemplateEmployeeByTaskTemplateIdAndEmployeeId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"taskTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteTaskTemplateEmployeeMutation, DeleteTaskTemplateEmployeeMutationVariables>;
export const DeleteTaskResponsibleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTaskResponsible"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responsibleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTaskResponsibleByTaskIdAndResponsibleId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"taskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"responsibleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responsibleId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteTaskResponsibleMutation, DeleteTaskResponsibleMutationVariables>;
export const DeleteTaskTemplateResponsibleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTaskTemplateResponsible"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responsibleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTaskTemplateResponsibleByTaskTemplateIdAndResponsibleId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"taskTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"responsibleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responsibleId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteTaskTemplateResponsibleMutation, DeleteTaskTemplateResponsibleMutationVariables>;
export const ClockInDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"clockInDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"presenceTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clockIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationPresenceTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"presenceTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationProjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}}]} as unknown as DocumentNode<ClockInDashboardMutation, ClockInDashboardMutationVariables>;
export const ClockOutDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"clockOutDashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clockOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationBreakType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ClockOutDashboardMutation, ClockOutDashboardMutationVariables>;
export const StartBreakDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"startBreak"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breakTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startBreak"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationBreakTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breakTypeId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<StartBreakMutation, StartBreakMutationVariables>;
export const EndBreakDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"endBreak"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resumeTimeRegistrationProjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endBreak"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resumeTimeRegistrationProjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resumeTimeRegistrationProjectId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<EndBreakMutation, EndBreakMutationVariables>;
export const ChangeTimeRegistrationProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeTimeRegistrationProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeTimeRegistrationProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationProjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ChangeTimeRegistrationProjectMutation, ChangeTimeRegistrationProjectMutationVariables>;
export const ChangeTimeRegistrationPresenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeTimeRegistrationPresence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"presenceTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeTimeRegistrationPresence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationPresenceTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"presenceTypeId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ChangeTimeRegistrationPresenceMutation, ChangeTimeRegistrationPresenceMutationVariables>;
export const AddTimeRegistrationPresenceNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addTimeRegistrationPresenceNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"presenceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimeRegistrationPresenceById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"presenceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AddTimeRegistrationPresenceNoteMutation, AddTimeRegistrationPresenceNoteMutationVariables>;
export const TimeRegistrationBreakTypeDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"timeRegistrationBreakTypeDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimeRegistrationBreakTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationBreakType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationBreakTypeDeleteMutation, TimeRegistrationBreakTypeDeleteMutationVariables>;
export const TimeRegistrationBreakTypeCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"timeRegistrationBreakTypeCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emoji"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paidTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IntervalInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTimeRegistrationBreakType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationBreakType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emoji"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emoji"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"paidTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paidTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationBreakType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationBreakTypeCreateMutation, TimeRegistrationBreakTypeCreateMutationVariables>;
export const TimeRegistrationBreakTypeUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"timeRegistrationBreakTypeUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emoji"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paidTime"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IntervalInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimeRegistrationBreakTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emoji"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emoji"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"paidTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paidTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationBreakType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationBreakTypeUpdateMutation, TimeRegistrationBreakTypeUpdateMutationVariables>;
export const CreateTimeRegistrationEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTimeRegistrationEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationEntryType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationEntryType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationBreakTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationProjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationPresenceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTimeRegistrationEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationEntry"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationEntryType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationEntryType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationBreakTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationBreakTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationProjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationProjectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationPresenceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationPresenceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceId"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTimeRegistrationEntryMutation, CreateTimeRegistrationEntryMutationVariables>;
export const UpdateTimeRegistrationEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTimeRegistrationEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationBreakTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationProjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimeRegistrationEntryById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationBreakTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationBreakTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationProjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationProjectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTimeRegistrationEntryMutation, UpdateTimeRegistrationEntryMutationVariables>;
export const DeleteTimeRegistrationEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTimeRegistrationEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimeRegistrationEntryById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteTimeRegistrationEntryMutation, DeleteTimeRegistrationEntryMutationVariables>;
export const CreateTimeRegistrationPresenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTimeRegistrationPresence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationPresenceTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTimeRegistrationPresence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationPresence"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationPresenceTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationPresenceTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeRegistrationProfileItem"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeRegistrationProfileItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationPresence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntryType"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationBreakType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateTimeRegistrationPresenceMutation, CreateTimeRegistrationPresenceMutationVariables>;
export const UpdateTimeRegistrationPresenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTimeRegistrationPresence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationPresenceTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimeRegistrationPresenceById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationPresenceTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationPresenceTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeRegistrationProfileItem"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeRegistrationProfileItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationPresence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntryType"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationBreakType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTimeRegistrationPresenceMutation, UpdateTimeRegistrationPresenceMutationVariables>;
export const DeleteTimeRegistrationPresenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTimeRegistrationPresence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimeRegistrationPresenceById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteTimeRegistrationPresenceMutation, DeleteTimeRegistrationPresenceMutationVariables>;
export const ApproveTimeRegistrationsByDeadlineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"approveTimeRegistrationsByDeadline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deadline"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approveTimeRegistrationsByDeadline"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deadline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deadline"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<ApproveTimeRegistrationsByDeadlineMutation, ApproveTimeRegistrationsByDeadlineMutationVariables>;
export const TimeRegistrationPresenceTypeDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"timeRegistrationPresenceTypeDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimeRegistrationPresenceTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationPresenceTypeDeleteMutation, TimeRegistrationPresenceTypeDeleteMutationVariables>;
export const TimeRegistrationPresenceTypeCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"timeRegistrationPresenceTypeCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emoji"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTimeRegistrationPresenceType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationPresenceType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emoji"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emoji"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationPresenceTypeCreateMutation, TimeRegistrationPresenceTypeCreateMutationVariables>;
export const TimeRegistrationPresenceTypeUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"timeRegistrationPresenceTypeUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emoji"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimeRegistrationPresenceTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emoji"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emoji"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationPresenceTypeUpdateMutation, TimeRegistrationPresenceTypeUpdateMutationVariables>;
export const TimeRegistrationProjectDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"timeRegistrationProjectDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimeRegistrationProjectById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationProjectDeleteMutation, TimeRegistrationProjectDeleteMutationVariables>;
export const TimeRegistrationProjectCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"timeRegistrationProjectCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"color"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descriptionLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTimeRegistrationProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationProject"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"color"},"value":{"kind":"Variable","name":{"kind":"Name","value":"color"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"descriptionLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descriptionLocalizations"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"localizedDescription"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationProjectCreateMutation, TimeRegistrationProjectCreateMutationVariables>;
export const TimeRegistrationProjectUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"timeRegistrationProjectUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"color"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"descriptionLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimeRegistrationProjectById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"color"},"value":{"kind":"Variable","name":{"kind":"Name","value":"color"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"descriptionLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"descriptionLocalizations"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"localizedDescription"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationProjectUpdateMutation, TimeRegistrationProjectUpdateMutationVariables>;
export const TimeRegistrationTemplateDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"timeRegistrationTemplateDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimeRegistrationTemplateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationTemplateDeleteMutation, TimeRegistrationTemplateDeleteMutationVariables>;
export const TimeRegistrationTemplateCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"timeRegistrationTemplateCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTimeRegistrationTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationTemplate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationTemplateCreateMutation, TimeRegistrationTemplateCreateMutationVariables>;
export const TimeRegistrationTemplateUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"timeRegistrationTemplateUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocaleWithTranslation"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useMultiWeek"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimeRegistrationTemplateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nameLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameLocalizations"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useMultiWeek"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useMultiWeek"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationTemplateUpdateMutation, TimeRegistrationTemplateUpdateMutationVariables>;
export const SubmitTimeRegistrationTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"submitTimeRegistrationTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationTemplateId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weeks"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationWeekTemplateInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"days"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationDayTemplateInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitTimeRegistrationTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationTemplateId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"weeks"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weeks"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SubmitTimeRegistrationTemplateMutation, SubmitTimeRegistrationTemplateMutationVariables>;
export const BulkApplyTimeRegistrationTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bulkApplyTimeRegistrationTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkApplyTimeRegistrationTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationTemplateId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BulkApplyTimeRegistrationTemplateMutation, BulkApplyTimeRegistrationTemplateMutationVariables>;
export const TranslationCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"translationCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TranslationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTranslation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"translation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translation"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<TranslationCreateMutation, TranslationCreateMutationVariables>;
export const TranslationUpdateByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"translationUpdateById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TranslationPatch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTranslationById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translation"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<TranslationUpdateByIdMutation, TranslationUpdateByIdMutationVariables>;
export const TranslationDeleteByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"translationDeleteById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTranslationById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<TranslationDeleteByIdMutation, TranslationDeleteByIdMutationVariables>;
export const ClearTranslationsCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"clearTranslationsCache"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clearTranslationsCache"}}]}}]} as unknown as DocumentNode<ClearTranslationsCacheMutation, ClearTranslationsCacheMutationVariables>;
export const UpdateCredentialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCredential"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCredential"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"newPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateCredentialMutation, UpdateCredentialMutationVariables>;
export const UserUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailPassword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyAdmin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isSystemUser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canSignOnBehalfOf"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canLogin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canLoginApp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canLoginSso"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailPassword"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyAdmin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyAdmin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isSystemUser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isSystemUser"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"canSignOnBehalfOf"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canSignOnBehalfOf"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"canLogin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canLogin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"canLoginApp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canLoginApp"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"canLoginSso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canLoginSso"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UserUpdateMutation, UserUpdateMutationVariables>;
export const CreateSuperUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createSuperUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyWhitelist"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyBlacklist"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createSuperUserAllowedUsers"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SuperUserAllowedUsersSuperUserIdForeignConnectionSuperUserAllowedUsersCreateInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSuperUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"superUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyWhitelist"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyWhitelist"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyBlacklist"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyBlacklist"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"superUserAllowedUsers"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createSuperUserAllowedUsers"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"superUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSuperUserMutation, CreateSuperUserMutationVariables>;
export const UpdateSuperUserByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSuperUserById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyWhitelist"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyBlacklist"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSuperUserById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyWhitelist"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyWhitelist"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyBlacklist"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyBlacklist"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateSuperUserByIdMutation, UpdateSuperUserByIdMutationVariables>;
export const DeleteSuperUserByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteSuperUserById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSuperUserById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<DeleteSuperUserByIdMutation, DeleteSuperUserByIdMutationVariables>;
export const UpdateUserLocaleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserLocale"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserLocale"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateUserLocaleMutation, UpdateUserLocaleMutationVariables>;
export const SetUserSettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setUserSetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setUserSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"argKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"argValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<SetUserSettingMutation, SetUserSettingMutationVariables>;
export const ChangeGodModeStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeGodModeStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enable"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeGodModeStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"enable"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enable"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"godmode"}}]}}]}}]}}]} as unknown as DocumentNode<ChangeGodModeStatusMutation, ChangeGodModeStatusMutationVariables>;
export const CreateSuperUserAllowedUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createSuperUserAllowedUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"superUserId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allowedUserIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"disallowedUserIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSuperUserAllowedUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"superUserAllowedUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"superUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"superUserId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowedUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allowedUserIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"disallowedUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"disallowedUserIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"superUserAllowedUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"allowedUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"disallowedUserIds"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSuperUserAllowedUsersMutation, CreateSuperUserAllowedUsersMutationVariables>;
export const UpdateSuperUserAllowedUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSuperUserAllowedUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"superUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allowedUserIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"disallowedUserIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSuperUserAllowedUserBySuperUserIdAndCompanyId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"superUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"superUserId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowedUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allowedUserIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"disallowedUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"disallowedUserIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"superUserAllowedUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"allowedUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"disallowedUserIds"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSuperUserAllowedUsersMutation, UpdateSuperUserAllowedUsersMutationVariables>;
export const SetUserDepartmentParentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setUserDepartmentParentUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentUserDepartmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserDepartmentById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parentUserDepartmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentUserDepartmentId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userDepartment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"parentUserDepartmentId"}}]}}]}}]}}]} as unknown as DocumentNode<SetUserDepartmentParentUserMutation, SetUserDepartmentParentUserMutationVariables>;
export const UserGroupCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userGroupCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGroup"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UserGroupCreateMutation, UserGroupCreateMutationVariables>;
export const UserGroupDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userGroupDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUserGroupByUserIdAndGroupId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UserGroupDeleteMutation, UserGroupDeleteMutationVariables>;
export const UserDepartmentGroupCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userDepartmentGroupCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserDepartmentGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userDepartmentGroup"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UserDepartmentGroupCreateMutation, UserDepartmentGroupCreateMutationVariables>;
export const UserDepartmentGroupDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userDepartmentGroupDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUserDepartmentGroupByUserIdAndDepartmentIdAndGroupId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UserDepartmentGroupDeleteMutation, UserDepartmentGroupDeleteMutationVariables>;
export const UserDepartmentGroupToggleInheritanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userDepartmentGroupToggleInheritance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inheritToDescendants"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyIncludeInDescendants"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserDepartmentGroupByUserIdAndDepartmentIdAndGroupId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"inheritToDescendants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inheritToDescendants"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"onlyIncludeInDescendants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyIncludeInDescendants"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UserDepartmentGroupToggleInheritanceMutation, UserDepartmentGroupToggleInheritanceMutationVariables>;
export const UserCompanyGroupCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userCompanyGroupCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserCompanyGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userCompanyGroup"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UserCompanyGroupCreateMutation, UserCompanyGroupCreateMutationVariables>;
export const UserCompanyGroupDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userCompanyGroupDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUserCompanyGroupByUserIdAndGroupIdAndCompanyId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UserCompanyGroupDeleteMutation, UserCompanyGroupDeleteMutationVariables>;
export const CreateUserOnBehalfPermissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUserOnBehalfPermission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onBehalfOfUserId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserOnBehalfPermission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userOnBehalfPermission"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"onBehalfOfUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onBehalfOfUserId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userOnBehalfPermission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserOnBehalfPermission"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserOnBehalfPermission"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserOnBehalfPermission"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUserId"}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]} as unknown as DocumentNode<CreateUserOnBehalfPermissionMutation, CreateUserOnBehalfPermissionMutationVariables>;
export const DeleteUserOnBehalfPermissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteUserOnBehalfPermission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUserOnBehalfPermissionById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userOnBehalfPermission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserOnBehalfPermission"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserOnBehalfPermission"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserOnBehalfPermission"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUserId"}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]} as unknown as DocumentNode<DeleteUserOnBehalfPermissionMutation, DeleteUserOnBehalfPermissionMutationVariables>;
export const CreateVacationTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createVacationType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"color"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"absenceCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quickAction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emoji"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mustBeApproved"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverUserIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverSystemFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverFormFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendCalendarInvite"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createVacationType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"vacationType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"color"},"value":{"kind":"Variable","name":{"kind":"Name","value":"color"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"absenceCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"absenceCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"quickAction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quickAction"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emoji"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emoji"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mustBeApproved"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mustBeApproved"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverUserIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverGroupIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverSystemFieldIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverSystemFieldIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverFormFieldIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverFormFieldIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sendCalendarInvite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendCalendarInvite"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vacationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"absenceCode"}},{"kind":"Field","name":{"kind":"Name","value":"quickAction"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"sendCalendarInvite"}}]}}]} as unknown as DocumentNode<CreateVacationTypeMutation, CreateVacationTypeMutationVariables>;
export const UpdateVacationTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateVacationType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"color"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"absenceCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quickAction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emoji"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mustBeApproved"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverUserIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverSystemFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approverFormFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendCalendarInvite"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVacationTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"color"},"value":{"kind":"Variable","name":{"kind":"Name","value":"color"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"absenceCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"absenceCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"quickAction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quickAction"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emoji"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emoji"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mustBeApproved"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mustBeApproved"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverUserIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverUserIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverGroupIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverSystemFieldIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverSystemFieldIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"approverFormFieldIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approverFormFieldIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sendCalendarInvite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendCalendarInvite"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vacationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"absenceCode"}},{"kind":"Field","name":{"kind":"Name","value":"quickAction"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"sendCalendarInvite"}}]}}]} as unknown as DocumentNode<UpdateVacationTypeMutation, UpdateVacationTypeMutationVariables>;
export const DeleteVacationTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteVacationType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVacationTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vacationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"absenceCode"}},{"kind":"Field","name":{"kind":"Name","value":"quickAction"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"sendCalendarInvite"}}]}}]} as unknown as DocumentNode<DeleteVacationTypeMutation, DeleteVacationTypeMutationVariables>;
export const CreateVacationUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createVacationUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vacationTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allDay"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createVacationUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"vacationUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"vacationTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vacationTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allDay"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allDay"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vacationUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationUser"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"absenceCode"}},{"kind":"Field","name":{"kind":"Name","value":"quickAction"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"sendCalendarInvite"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vacationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"vacationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allDay"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"durationDays"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creatorUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalId"}}]}}]} as unknown as DocumentNode<CreateVacationUserMutation, CreateVacationUserMutationVariables>;
export const UpdateVacationUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateVacationUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vacationTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allDay"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVacationUserById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"vacationTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vacationTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allDay"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allDay"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vacationUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationUser"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"absenceCode"}},{"kind":"Field","name":{"kind":"Name","value":"quickAction"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"sendCalendarInvite"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vacationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"vacationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allDay"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"durationDays"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creatorUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalId"}}]}}]} as unknown as DocumentNode<UpdateVacationUserMutation, UpdateVacationUserMutationVariables>;
export const DeleteVacationUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteVacationUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVacationUserById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vacationUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationUser"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"absenceCode"}},{"kind":"Field","name":{"kind":"Name","value":"quickAction"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"sendCalendarInvite"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vacationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"vacationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allDay"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"durationDays"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creatorUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalId"}}]}}]} as unknown as DocumentNode<DeleteVacationUserMutation, DeleteVacationUserMutationVariables>;
export const GetAllAnnouncementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllAnnouncements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnnouncementFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Announcement"}},{"kind":"Field","name":{"kind":"Name","value":"read"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Announcement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Announcement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"systemAnnouncement"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"teaser"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"addPlayIcon"}},{"kind":"Field","name":{"kind":"Name","value":"popup"}},{"kind":"Field","name":{"kind":"Name","value":"locales"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"publishAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<GetAllAnnouncementsQuery, GetAllAnnouncementsQueryVariables>;
export const GetAnnouncementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAnnouncements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnnouncementsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnnouncementFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Announcement"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Announcement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Announcement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"systemAnnouncement"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"teaser"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"addPlayIcon"}},{"kind":"Field","name":{"kind":"Name","value":"popup"}},{"kind":"Field","name":{"kind":"Name","value":"locales"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"publishAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<GetAnnouncementsQuery, GetAnnouncementsQueryVariables>;
export const GetAnnouncementDepartmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAnnouncementDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAnnouncementDepartmentsQuery, GetAnnouncementDepartmentsQueryVariables>;
export const GetAnnouncementByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAnnouncementById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcementById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Announcement"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Announcement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Announcement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"systemAnnouncement"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"teaser"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"addPlayIcon"}},{"kind":"Field","name":{"kind":"Name","value":"popup"}},{"kind":"Field","name":{"kind":"Name","value":"locales"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"publishAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<GetAnnouncementByIdQuery, GetAnnouncementByIdQueryVariables>;
export const AllAnnouncementsCheckboxDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allAnnouncementsCheckbox"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnnouncementFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllAnnouncementsCheckboxQuery, AllAnnouncementsCheckboxQueryVariables>;
export const LatestPopupAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"latestPopupAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"popup"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"locales"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"anyEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publishAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"publishAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expireAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expireAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}}}]}}]}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"userAnnouncements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LatestPopupAnnouncementQuery, LatestPopupAnnouncementQueryVariables>;
export const UnreadAnnouncementsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"unreadAnnouncementsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnnouncementFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UnreadAnnouncementsCountQuery, UnreadAnnouncementsCountQueryVariables>;
export const ApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"application"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"application"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailWork"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePrivate"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionType"}},{"kind":"Field","name":{"kind":"Name","value":"mappedFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFieldValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"customField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hashid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cache"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caseFileIds"}}]}}]}}]} as unknown as DocumentNode<ApplicationQuery, ApplicationQueryVariables>;
export const ApplicationsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"applicationsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allApplications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePrivate"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"customFieldValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"customField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ApplicationsQueryQuery, ApplicationsQueryQueryVariables>;
export const ApprovalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"approvals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ApprovalFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApprovalsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approvals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deniedAt"}},{"kind":"Field","name":{"kind":"Name","value":"affectedUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDeletionRequest"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"requestingUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"futureDatumByApprovalId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vacationUserByApprovalId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vacationUserByDeletionApprovalId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationUser"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"absenceCode"}},{"kind":"Field","name":{"kind":"Name","value":"quickAction"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"sendCalendarInvite"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FutureDatum"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntryId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"updateValueAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"previousHumanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"approvalIsRequired"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"creatorUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"readableName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalId"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vacationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"vacationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allDay"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"durationDays"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creatorUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalId"}}]}}]} as unknown as DocumentNode<ApprovalsQuery, ApprovalsQueryVariables>;
export const AsyncJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"asyncJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AsyncJobsOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asyncJobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"}},{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AsyncJobsQuery, AsyncJobsQueryVariables>;
export const AsyncJobByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"asyncJobById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asyncJobById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"}},{"kind":"Field","name":{"kind":"Name","value":"asyncJobItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"COMPLETION_DATE_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"messageVariables"}},{"kind":"Field","name":{"kind":"Name","value":"tabulation"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AsyncJobByIdQuery, AsyncJobByIdQueryVariables>;
export const GetAuthAppDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAuthApp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAuthApp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"response"}}]}}]}}]} as unknown as DocumentNode<GetAuthAppQuery, GetAuthAppQueryVariables>;
export const GetAuthAppsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAuthApps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAuthApps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"response"}}]}}]}}]} as unknown as DocumentNode<GetAuthAppsQuery, GetAuthAppsQueryVariables>;
export const GetAuthAppsPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAuthAppsPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAuthApps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"searchString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"response"}}]}}]}}]} as unknown as DocumentNode<GetAuthAppsPaginatedQuery, GetAuthAppsPaginatedQueryVariables>;
export const GetIntegrationFieldMarkingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIntegrationFieldMarkings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrationFieldMarkings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"authAppId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authAppId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"storageId"}},{"kind":"Field","name":{"kind":"Name","value":"sendsData"}},{"kind":"Field","name":{"kind":"Name","value":"receivesData"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"readableName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetIntegrationFieldMarkingsQuery, GetIntegrationFieldMarkingsQueryVariables>;
export const ChangelogByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"changelogById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changelogById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Changelog"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Changelog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Changelog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"system"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"major"}},{"kind":"Field","name":{"kind":"Name","value":"minor"}},{"kind":"Field","name":{"kind":"Name","value":"guides"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAppNotes"}}]}}]} as unknown as DocumentNode<ChangelogByIdQuery, ChangelogByIdQueryVariables>;
export const AllChangeLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allChangeLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangelogsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangelogFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangelogCondition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changelogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Changelog"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Changelog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Changelog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"system"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"major"}},{"kind":"Field","name":{"kind":"Name","value":"minor"}},{"kind":"Field","name":{"kind":"Name","value":"guides"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"isAppNotes"}}]}}]} as unknown as DocumentNode<AllChangeLogsQuery, AllChangeLogsQueryVariables>;
export const GetChosenColumnsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getChosenColumns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getFormFields"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldObjectType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupCardColumnExists"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chosenColumnByUserIdAndTableName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"tableName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"tableName"}},{"kind":"Field","name":{"kind":"Name","value":"chosenColumns"}},{"kind":"Field","name":{"kind":"Name","value":"filters"}},{"kind":"Field","name":{"kind":"Name","value":"miscellaneousFilters"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldObjectType"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notIn"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"table","block":false}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldGroupCardColumnExists"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldGroupCardColumnExists"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"equipment","block":false},{"kind":"StringValue","value":"department","block":false}]}}]}}]}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getFormFields"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetChosenColumnsQuery, GetChosenColumnsQueryVariables>;
export const EmployeeListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmployeeList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includesInsensitive"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUIDListFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fullName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includesInsensitive"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includesInsensitive"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"departments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentsFilter"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FIRST_NAME_ASC"},{"kind":"EnumValue","value":"LAST_NAME_ASC"},{"kind":"EnumValue","value":"ID_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"thumbnail"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<EmployeeListQuery, EmployeeListQueryVariables>;
export const EmailLogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"emailLog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"receiverId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchSubject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CommunicationLogOrderBy"}},"defaultValue":{"kind":"EnumValue","value":"CREATED_AT_ASC"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CommunicationLogStatusType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"communicationLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"receiverId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"receiverId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"8"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchSubject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchSubject"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailText"}},{"kind":"Field","name":{"kind":"Name","value":"emailTo"}},{"kind":"Field","name":{"kind":"Name","value":"emailCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"emailFrom"}},{"kind":"Field","name":{"kind":"Name","value":"emailHtml"}},{"kind":"Field","name":{"kind":"Name","value":"emailReplyTo"}},{"kind":"Field","name":{"kind":"Name","value":"emailCc"}},{"kind":"Field","name":{"kind":"Name","value":"emailBcc"}},{"kind":"Field","name":{"kind":"Name","value":"system"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<EmailLogQuery, EmailLogQueryVariables>;
export const CompaniesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"companies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompaniesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nativeAppAccess"}},{"kind":"Field","alias":{"kind":"Name","value":"users"},"name":{"kind":"Name","value":"superadminUserList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastLogin"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"numberOfCurrentlyEmployedEmployees"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CompaniesQuery, CompaniesQueryVariables>;
export const CompaniesInputFieldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"companiesInputField"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selected"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allCompanies"},"name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"selectedUsers"},"name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selected"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CompaniesInputFieldQuery, CompaniesInputFieldQueryVariables>;
export const GetCompanySsoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCompanySso"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCompanyPublicSso"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<GetCompanySsoQuery, GetCompanySsoQueryVariables>;
export const CompanyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"company"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeUsers"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"sso"}},{"kind":"Field","name":{"kind":"Name","value":"copyInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"masterForCompanyId"}},{"kind":"Field","name":{"kind":"Name","value":"masterTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"availableLocales"}},{"kind":"Field","name":{"kind":"Name","value":"nativeAppAccess"}},{"kind":"Field","name":{"kind":"Name","value":"mainDepartment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentBasic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyCompanyTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyBindings"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeUsers"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"legacyCompanyId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"users"},"name":{"kind":"Name","value":"superadminUserList"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeUsers"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastLogin"}},{"kind":"Field","name":{"kind":"Name","value":"companyAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"superUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyWhitelist"}},{"kind":"Field","name":{"kind":"Name","value":"companyBlacklist"}},{"kind":"Field","name":{"kind":"Name","value":"superUserAllowedUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"allowedUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"disallowedUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mainDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartmentId"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"pNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<CompanyQuery, CompanyQueryVariables>;
export const CompanyBindingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"companyBinding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyBindings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"legacyCompanyId"}}]}}]}}]}}]} as unknown as DocumentNode<CompanyBindingQuery, CompanyBindingQueryVariables>;
export const CompanyCopyInProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"companyCopyInProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyInProgress"}}]}}]}}]} as unknown as DocumentNode<CompanyCopyInProgressQuery, CompanyCopyInProgressQueryVariables>;
export const RecruitCompaniesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"recruitCompanies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recruitCompanies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyid"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}}]}}]}}]} as unknown as DocumentNode<RecruitCompaniesQuery, RecruitCompaniesQueryVariables>;
export const CompanySearchSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"companySearchSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CompanySearchSuggestionsQuery, CompanySearchSuggestionsQueryVariables>;
export const CompaniesWithAdminUserListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"companiesWithAdminUserList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"superadminUserList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CompaniesWithAdminUserListQuery, CompaniesWithAdminUserListQueryVariables>;
export const ResetFormCompaniesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"resetFormCompanies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetFormCompanies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ResetFormCompaniesQuery, ResetFormCompaniesQueryVariables>;
export const AllCompanySettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allCompanySettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySettingFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companySettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"valueBoolean"}},{"kind":"Field","name":{"kind":"Name","value":"valueStorage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllCompanySettingsQuery, AllCompanySettingsQueryVariables>;
export const CompanySettingByKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"companySettingByKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySettingKey"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companySettingByCompanyIdAndKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"valueBoolean"}},{"kind":"Field","name":{"kind":"Name","value":"valueStorage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<CompanySettingByKeyQuery, CompanySettingByKeyQueryVariables>;
export const CompanyTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"companyType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}}]}}]}}]} as unknown as DocumentNode<CompanyTypeQuery, CompanyTypeQueryVariables>;
export const CompanyCompanyTypeByCompanyIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"companyCompanyTypeByCompanyId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyCompanyTypeByCompanyId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"companyTypeId"}}]}}]}}]} as unknown as DocumentNode<CompanyCompanyTypeByCompanyIdQuery, CompanyCompanyTypeByCompanyIdQueryVariables>;
export const CompanyTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"companyTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyTypesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyTypeFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CompanyTypesQuery, CompanyTypesQueryVariables>;
export const CompetenceGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"competenceGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompetenceGroupsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompetenceGroupFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"competencesFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompetenceFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competenceGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"competences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"LOCALIZED_NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"competencesFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedDescription"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"useRating"}},{"kind":"Field","name":{"kind":"Name","value":"outdateCompetence"}},{"kind":"Field","name":{"kind":"Name","value":"ratingFormField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"outdateInterval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assigneeCount"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<CompetenceGroupsQuery, CompetenceGroupsQueryVariables>;
export const CompetencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"competences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompetenceFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedDescription"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"useRating"}},{"kind":"Field","name":{"kind":"Name","value":"outdateCompetence"}},{"kind":"Field","name":{"kind":"Name","value":"outdateInterval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratingFormField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}}]} as unknown as DocumentNode<CompetencesQuery, CompetencesQueryVariables>;
export const CompetenceByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"competenceById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competenceById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"competenceGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"useRating"}},{"kind":"Field","name":{"kind":"Name","value":"onlyManagerShouldEvaluate"}},{"kind":"Field","name":{"kind":"Name","value":"updateReminder"}},{"kind":"Field","name":{"kind":"Name","value":"ratingFormField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reminderInterval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outdateInterval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userCompetences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"outdateCompetence"}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwner"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deleteAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"remindAt"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}}]} as unknown as DocumentNode<CompetenceByIdQuery, CompetenceByIdQueryVariables>;
export const CompetenceGroupByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"competenceGroupById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competenceGroupById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CompetenceGroupByIdQuery, CompetenceGroupByIdQueryVariables>;
export const UserCompetenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userCompetence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetenceById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addedDate"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"courseRequested"}},{"kind":"Field","name":{"kind":"Name","value":"competence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ratingFormField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"useRating"}},{"kind":"Field","name":{"kind":"Name","value":"onlyManagerShouldEvaluate"}},{"kind":"Field","name":{"kind":"Name","value":"outdateCompetence"}},{"kind":"Field","name":{"kind":"Name","value":"outdateInterval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCompetenceEvaluations"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCompetenceEvaluations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserCompetence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetenceEvaluations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"evaluatingUserId"}},{"kind":"Field","name":{"kind":"Name","value":"nextUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"evaluatingUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"evaluationDate"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserCompetenceQuery, UserCompetenceQueryVariables>;
export const UserCompetencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userCompetences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCompetencesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCompetenceFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeUser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addedDate"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"courseRequested"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCompetenceEvaluations"}},{"kind":"Field","name":{"kind":"Name","value":"competence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"outdateCompetence"}},{"kind":"Field","name":{"kind":"Name","value":"onlyManagerShouldEvaluate"}},{"kind":"Field","name":{"kind":"Name","value":"competenceGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"ratingFormField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"competenceGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeUser"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCompetenceEvaluations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserCompetence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetenceEvaluations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"evaluatingUserId"}},{"kind":"Field","name":{"kind":"Name","value":"nextUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"evaluatingUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"evaluationDate"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserCompetencesQuery, UserCompetencesQueryVariables>;
export const UserEvaluationCommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userEvaluationComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCompetenceEvaluationCommentFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCompetenceEvaluationCommentsOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetenceEvaluationComments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserEvaluationCommentsQuery, UserEvaluationCommentsQueryVariables>;
export const CompetencesSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"competencesSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competencesSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"searchQuery"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}}]}}]}}]} as unknown as DocumentNode<CompetencesSearchQuery, CompetencesSearchQueryVariables>;
export const ExportCompetencesToExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"exportCompetencesToExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userCompetenceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"columnNames"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportCompetencesToExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userCompetenceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userCompetenceIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"columnNames"},"value":{"kind":"Variable","name":{"kind":"Name","value":"columnNames"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]} as unknown as DocumentNode<ExportCompetencesToExcelQuery, ExportCompetencesToExcelQueryVariables>;
export const UserCompetencesTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userCompetencesTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCompetencesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCompetenceFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"addedDate"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"cpr"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"competence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"outdateCompetence"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"competenceGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratingFormField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"managerEvaluation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"evaluationDate"}},{"kind":"Field","name":{"kind":"Name","value":"nextUpdate"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCompetenceEvaluations"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCompetenceEvaluations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserCompetence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetenceEvaluations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"evaluatingUserId"}},{"kind":"Field","name":{"kind":"Name","value":"nextUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"evaluatingUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"evaluationDate"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserCompetencesTableQuery, UserCompetencesTableQueryVariables>;
export const UserCompetencesTableCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userCompetencesTableCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCompetencesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCompetenceFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UserCompetencesTableCountQuery, UserCompetencesTableCountQueryVariables>;
export const UserCompetencesTableIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userCompetencesTableIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCompetenceFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserCompetencesTableIdsQuery, UserCompetencesTableIdsQueryVariables>;
export const CompetenceGroupOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"competenceGroupOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competenceGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"LOCALIZED_NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CompetenceGroupOptionsQuery, CompetenceGroupOptionsQueryVariables>;
export const CompetenceNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"competenceNames"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"competenceGroup"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"LOCALIZED_NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CompetenceNamesQuery, CompetenceNamesQueryVariables>;
export const CompetenceAssigneesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"competenceAssignees"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"competenceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompetences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"USER_BY_USER_ID__FULL_NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"competenceId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"competenceId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fullName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<CompetenceAssigneesQuery, CompetenceAssigneesQueryVariables>;
export const ContractSignPendingsByEmployeeIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contractSignPendingsByEmployeeId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"casefileFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmployeeCasefileFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingsOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSignPendings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ORDER_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractSignPendingDocument"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingSigners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"SIGN_ORDER_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractSignPendingSignerWithUser"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeCasefiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"casefileFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"casefileId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"signers"}},{"kind":"Field","name":{"kind":"Name","value":"documents"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeSigners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingSigner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingSigner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingId"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"signDate"}},{"kind":"Field","name":{"kind":"Name","value":"signatureFileId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"refused"}},{"kind":"Field","name":{"kind":"Name","value":"refusalReason"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingDocument"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingDocument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderValues"}},{"kind":"Field","name":{"kind":"Name","value":"contractName"}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"existingStorageId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMappings"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingSignerWithUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingSigner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractSignPendingSigner"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signatureImage"}},{"kind":"Field","name":{"kind":"Name","value":"useSecondaryEmail"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailWork"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUserId"}},{"kind":"Field","name":{"kind":"Name","value":"signOrder"}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<ContractSignPendingsByEmployeeIdQuery, ContractSignPendingsByEmployeeIdQueryVariables>;
export const ContractSignPendingByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contractSignPendingById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"signingUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"signedUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ORDER_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractSignPendingDocument"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingSigners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"SIGN_ORDER_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUserId"}},{"kind":"Field","name":{"kind":"Name","value":"signOrder"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"refused"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingDocument"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingDocument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderValues"}},{"kind":"Field","name":{"kind":"Name","value":"contractName"}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"existingStorageId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMappings"}}]}}]} as unknown as DocumentNode<ContractSignPendingByIdQuery, ContractSignPendingByIdQueryVariables>;
export const ContractSignPendingDocumentByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contractSignPendingDocumentById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocumentById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractSignPendingDocument"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingDocument"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingDocument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderValues"}},{"kind":"Field","name":{"kind":"Name","value":"contractName"}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"existingStorageId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMappings"}}]}}]} as unknown as DocumentNode<ContractSignPendingDocumentByIdQuery, ContractSignPendingDocumentByIdQueryVariables>;
export const SavedSignaturesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"savedSignatures"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedSignatures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SavedSignaturesQuery, SavedSignaturesQueryVariables>;
export const GetContractsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getContracts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeUserData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSignPendings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"refused"}},{"kind":"Field","name":{"kind":"Name","value":"enforceSignOrder"}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeUserData"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ORDER_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractSignPendingDocument"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingSigners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"SIGN_ORDER_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractSignPendingSignerWithUser"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingSigner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingSigner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingId"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"signDate"}},{"kind":"Field","name":{"kind":"Name","value":"signatureFileId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"refused"}},{"kind":"Field","name":{"kind":"Name","value":"refusalReason"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingDocument"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingDocument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderValues"}},{"kind":"Field","name":{"kind":"Name","value":"contractName"}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"existingStorageId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMappings"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingSignerWithUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingSigner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractSignPendingSigner"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signatureImage"}},{"kind":"Field","name":{"kind":"Name","value":"useSecondaryEmail"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailWork"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUserId"}},{"kind":"Field","name":{"kind":"Name","value":"signOrder"}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<GetContractsQuery, GetContractsQueryVariables>;
export const UnsignedDocumentsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"unsignedDocumentsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unsignedDocumentsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"argUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]} as unknown as DocumentNode<UnsignedDocumentsCountQuery, UnsignedDocumentsCountQueryVariables>;
export const SpecificUnsignedDocumentsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"specificUnsignedDocumentsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unsignedContractSignPendingCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"argUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]},{"kind":"Field","name":{"kind":"Name","value":"unsignedEmployeeCasefileCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"argUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]} as unknown as DocumentNode<SpecificUnsignedDocumentsCountQuery, SpecificUnsignedDocumentsCountQueryVariables>;
export const ContractTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contractTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplateFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplatesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"signable"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractTemplate"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Departments"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Users"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTypes"}},{"kind":"Field","name":{"kind":"Name","value":"placeholders"}},{"kind":"Field","name":{"kind":"Name","value":"htmlPlaceholders"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"topMargin"}},{"kind":"Field","name":{"kind":"Name","value":"bottomMargin"}},{"kind":"Field","name":{"kind":"Name","value":"leftMargin"}},{"kind":"Field","name":{"kind":"Name","value":"rightMargin"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"lifetime"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Departments"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractTemplateDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Users"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractTemplateUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractTemplatesQuery, ContractTemplatesQueryVariables>;
export const ContractTemplateByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contractTemplateById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractTemplateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractTemplate"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Departments"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Users"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTypes"}},{"kind":"Field","name":{"kind":"Name","value":"placeholders"}},{"kind":"Field","name":{"kind":"Name","value":"htmlPlaceholders"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"topMargin"}},{"kind":"Field","name":{"kind":"Name","value":"bottomMargin"}},{"kind":"Field","name":{"kind":"Name","value":"leftMargin"}},{"kind":"Field","name":{"kind":"Name","value":"rightMargin"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"lifetime"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Departments"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractTemplateDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Users"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractTemplateUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractTemplateByIdQuery, ContractTemplateByIdQueryVariables>;
export const CustomWidgetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"customWidgets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomWidgetsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomWidgetFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customWidgets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"useImage"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customWidgetContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CustomWidgetsQuery, CustomWidgetsQueryVariables>;
export const CustomWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"customWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customWidgetById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"useImage"}},{"kind":"Field","name":{"kind":"Name","value":"widgetSize"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"widgetTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"buttonTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"buttonBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"buttonBorder"}},{"kind":"Field","name":{"kind":"Name","value":"imageLayout"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customWidgetContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"addButton"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"buttonLink"}},{"kind":"Field","name":{"kind":"Name","value":"isInternalButtonLink"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CustomWidgetQuery, CustomWidgetQueryVariables>;
export const InternalLinkOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"internalLinkOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"parentDocumentFolderBlueprintExists"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"LOCALIZED_NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<InternalLinkOptionsQuery, InternalLinkOptionsQueryVariables>;
export const CvTemplateFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"cvTemplateFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cvTemplateFields"}}]}}]} as unknown as DocumentNode<CvTemplateFieldsQuery, CvTemplateFieldsQueryVariables>;
export const CvTemplateFieldMappingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"cvTemplateFieldMappings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cvTemplateFieldMappings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cvTemplateField"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}}]}}]}}]}}]} as unknown as DocumentNode<CvTemplateFieldMappingsQuery, CvTemplateFieldMappingsQueryVariables>;
export const AllStaffFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allStaffFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"systemFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"employee","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<AllStaffFieldsQuery, AllStaffFieldsQueryVariables>;
export const StaffFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"staffFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autoMappedFields"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"systemFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autoMappedFields"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"employee","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"text","block":false},{"kind":"StringValue","value":"textarea","block":false},{"kind":"StringValue","value":"number","block":false},{"kind":"StringValue","value":"select","block":false},{"kind":"StringValue","value":"multiselect","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<StaffFieldsQuery, StaffFieldsQueryVariables>;
export const DashboardViewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboardViews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardViewFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardViews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DashboardViewsQuery, DashboardViewsQueryVariables>;
export const CalendarBirthdayAnniversaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"calendarBirthdayAnniversary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeArchived"},"value":{"kind":"EnumValue","value":"NO"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"birthdate"}},{"kind":"Field","name":{"kind":"Name","value":"seniority"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}}]}}]} as unknown as DocumentNode<CalendarBirthdayAnniversaryQuery, CalendarBirthdayAnniversaryQueryVariables>;
export const CalendarEmploymentStartEndDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"calendarEmploymentStartEnd"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"birthdate"}},{"kind":"Field","name":{"kind":"Name","value":"employmentStart"}},{"kind":"Field","name":{"kind":"Name","value":"employmentEnd"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}}]}}]} as unknown as DocumentNode<CalendarEmploymentStartEndQuery, CalendarEmploymentStartEndQueryVariables>;
export const DashboardCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboardCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dashboardViewId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dashboardViewId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dashboardViewId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"EnumValue","value":"CUSTOM_WIDGET"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"customWidgetId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"CUSTOM_WIDGET"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"customWidget"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"customWidget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"useImage"}},{"kind":"Field","name":{"kind":"Name","value":"widgetSize"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"widgetTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"buttonTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"buttonBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"buttonBorder"}},{"kind":"Field","name":{"kind":"Name","value":"imageLayout"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customWidgetContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"addButton"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"buttonLink"}},{"kind":"Field","name":{"kind":"Name","value":"isInternalButtonLink"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dashboardCardStatistics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chartType"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DashboardCardsQuery, DashboardCardsQueryVariables>;
export const DashboardViewByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboardViewById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardViewById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DashboardViewByIdQuery, DashboardViewByIdQueryVariables>;
export const DashboardCardByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboardCardById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardCardById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"dashboardCardStatistics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chartType"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DashboardCardByIdQuery, DashboardCardByIdQueryVariables>;
export const AverageAgeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"averageAge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"averageAge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"argDepartmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}}]}]}}]} as unknown as DocumentNode<AverageAgeQuery, AverageAgeQueryVariables>;
export const AverageSeniorityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"averageSeniority"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionTypeIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"averageSeniority"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"argDepartmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"argJobPositionTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobPositionTypeIds"}}}]}]}}]} as unknown as DocumentNode<AverageSeniorityQuery, AverageSeniorityQueryVariables>;
export const DashboardViewCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboardViewCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardViews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<DashboardViewCountQuery, DashboardViewCountQueryVariables>;
export const DashboardConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboardConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardConfigByCompanyId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"localizedPageTitle"}}]}}]}}]} as unknown as DocumentNode<DashboardConfigQuery, DashboardConfigQueryVariables>;
export const ExportDashboardCardToExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"exportDashboardCardToExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dashboardCardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportDashboardCardToExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dashboardCardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dashboardCardId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]} as unknown as DocumentNode<ExportDashboardCardToExcelQuery, ExportDashboardCardToExcelQueryVariables>;
export const DashboardCardChartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboardCardChart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dashboardCardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dashboardCardStatisticId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardCardChart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dashboardCardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dashboardCardId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dashboardCardStatisticId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dashboardCardStatisticId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]} as unknown as DocumentNode<DashboardCardChartQuery, DashboardCardChartQueryVariables>;
export const DepartmentTypeByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"departmentTypeById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<DepartmentTypeByIdQuery, DepartmentTypeByIdQueryVariables>;
export const DepartmentTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"departmentTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentTypesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentTypeFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<DepartmentTypesQuery, DepartmentTypesQueryVariables>;
export const DepartmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"departments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Department"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mainDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartmentId"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"pNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Department"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentBasic"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isSystemUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userDepartmentGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employeeByUserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}}]}}]} as unknown as DocumentNode<DepartmentsQuery, DepartmentsQueryVariables>;
export const CompanyDepartmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"companyDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CompanyDepartmentsQuery, CompanyDepartmentsQueryVariables>;
export const GraphileDepartmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"graphileDepartments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeFieldEntries"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentBasicWithFieldEntries"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mainDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartmentId"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"pNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentBasicWithFieldEntries"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentBasic"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rankId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeFieldEntries"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}}]}}]}}]}}]} as unknown as DocumentNode<GraphileDepartmentsQuery, GraphileDepartmentsQueryVariables>;
export const GetDepartmentsFormFieldSortDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDepartmentsFormFieldSort"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeFieldEntries"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"argFormFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"argOrderDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentsSortByFormField"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"argFormFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"argFormFieldId"}}},{"kind":"Argument","name":{"kind":"Name","value":"argOrderDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"argOrderDirection"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentBasicWithFieldEntries"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mainDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartmentId"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"pNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentBasicWithFieldEntries"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentBasic"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rankId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeFieldEntries"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}}]}}]}}]}}]} as unknown as DocumentNode<GetDepartmentsFormFieldSortQuery, GetDepartmentsFormFieldSortQueryVariables>;
export const DepartmentsInputFieldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"departmentsInputField"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selected"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allDepartments"},"name":{"kind":"Name","value":"departments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentBasic"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"selectedDepartments"},"name":{"kind":"Name","value":"departments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"2000000"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selected"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentBasic"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mainDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartmentId"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"pNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<DepartmentsInputFieldQuery, DepartmentsInputFieldQueryVariables>;
export const DepartmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"department"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Department"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mainDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartmentId"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"pNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Department"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentBasic"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isSystemUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userDepartmentGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employeeByUserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}}]}}]} as unknown as DocumentNode<DepartmentQuery, DepartmentQueryVariables>;
export const DepartmentBasicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"departmentBasic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentBasic"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mainDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartmentId"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"pNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<DepartmentBasicQuery, DepartmentBasicQueryVariables>;
export const DepartmentsBasicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"departmentsBasic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<DepartmentsBasicQuery, DepartmentsBasicQueryVariables>;
export const MainDepartmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"mainDepartment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"mainDepartment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentBasic"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mainDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartmentId"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"pNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<MainDepartmentQuery, MainDepartmentQueryVariables>;
export const DepartmentDescendantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"departmentDescendants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDepartmentDescendants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<DepartmentDescendantsQuery, DepartmentDescendantsQueryVariables>;
export const DepartmentWithChildrenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"departmentWithChildren"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentBasic"}},{"kind":"Field","name":{"kind":"Name","value":"departmentsByParentDepartmentId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentBasic"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Department"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mainDepartment"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartmentId"}},{"kind":"Field","name":{"kind":"Name","value":"parentDepartment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"pNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<DepartmentWithChildrenQuery, DepartmentWithChildrenQueryVariables>;
export const ExportDepartmentsToExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"exportDepartmentsToExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fields"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportDepartmentsToExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fields"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]} as unknown as DocumentNode<ExportDepartmentsToExcelQuery, ExportDepartmentsToExcelQueryVariables>;
export const OrganizationDiagramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"organizationDiagram"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationDiagram"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"}}]}}]}}]} as unknown as DocumentNode<OrganizationDiagramQuery, OrganizationDiagramQueryVariables>;
export const DepartmentTimeRegistrationRuleBreachesSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"departmentTimeRegistrationRuleBreachesSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleBreachesSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DepartmentTimeRegistrationRuleBreachesSummaryQuery, DepartmentTimeRegistrationRuleBreachesSummaryQueryVariables>;
export const AllDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StoragesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StorageFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Storage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Storage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Storage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwner"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deleteAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"remindAt"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMappings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"documentTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderValues"}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentUserResponsiblesByFileId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeCasefileId"}}]}}]} as unknown as DocumentNode<AllDocumentsQuery, AllDocumentsQueryVariables>;
export const AllDocumentsTotalCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allDocumentsTotalCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StorageFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AllDocumentsTotalCountQuery, AllDocumentsTotalCountQueryVariables>;
export const AllDocumentTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allDocumentTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentTypesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentTypeFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"lifetime"}},{"kind":"Field","name":{"kind":"Name","value":"autoDeleteDays"}},{"kind":"Field","name":{"kind":"Name","value":"groupsWithAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"SCOPE_ASC"},{"kind":"EnumValue","value":"LOCALIZED_NAME_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AllDocumentTypesQuery, AllDocumentTypesQueryVariables>;
export const DocumentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"documentType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"lifetime"}},{"kind":"Field","name":{"kind":"Name","value":"autoDeleteDays"}}]}}]}}]} as unknown as DocumentNode<DocumentTypeQuery, DocumentTypeQueryVariables>;
export const DocumentOwnerNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"documentOwnerNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StoragesOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fileOwner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"USER"},{"kind":"EnumValue","value":"COMPANY"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DocumentOwnerNamesQuery, DocumentOwnerNamesQueryVariables>;
export const DocumentCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"documentCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StorageFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"999999"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<DocumentCardsQuery, DocumentCardsQueryVariables>;
export const DocumentsResponsibleQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"documentsResponsibleQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentUserResponsibleByUserId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<DocumentsResponsibleQueryQuery, DocumentsResponsibleQueryQueryVariables>;
export const StorageByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"storageById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storageById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Storage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Storage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Storage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwner"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deleteAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"remindAt"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMappings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"documentTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderValues"}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentUserResponsiblesByFileId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeCasefileId"}}]}}]} as unknown as DocumentNode<StorageByIdQuery, StorageByIdQueryVariables>;
export const GetSignedStorageByContractSignPendingDocumentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSignedStorageByContractSignPendingDocumentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractSignPendingDocumentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSignedStorageByContractSignPendingDocumentId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contractSignPendingDocumentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractSignPendingDocumentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]} as unknown as DocumentNode<GetSignedStorageByContractSignPendingDocumentIdQuery, GetSignedStorageByContractSignPendingDocumentIdQueryVariables>;
export const EmployeeDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeeDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StorageFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StoragesOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwner"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerName"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deleteAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"templatingServiceId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMappings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usersSharedWith"}},{"kind":"Field","name":{"kind":"Name","value":"usersSharedWithComputedColumn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usersResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"usersResponsibleComputedColumn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"departmentsSharedWith"}},{"kind":"Field","name":{"kind":"Name","value":"departmentsSharedWithComputedColumn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderValues"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EmployeeDocumentsQuery, EmployeeDocumentsQueryVariables>;
export const EmployeeResponsibleDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeeResponsibleDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StorageFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StoragesOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeResponsibleDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwner"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerName"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deleteAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usersSharedWith"}},{"kind":"Field","name":{"kind":"Name","value":"usersSharedWithComputedColumn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usersResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"usersResponsibleComputedColumn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"departmentsSharedWith"}},{"kind":"Field","name":{"kind":"Name","value":"departmentsSharedWithComputedColumn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EmployeeResponsibleDocumentsQuery, EmployeeResponsibleDocumentsQueryVariables>;
export const DocumentsSearchSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"documentsSearchSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fileType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"document","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"filename"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DocumentsSearchSuggestionsQuery, DocumentsSearchSuggestionsQueryVariables>;
export const DocumentHandSignatoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"documentHandSignatories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storageById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signDate"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingSigners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"SIGN_ORDER_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractSignPendingSignerWithUser"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingSigner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingSigner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingId"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"signDate"}},{"kind":"Field","name":{"kind":"Name","value":"signatureFileId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"refused"}},{"kind":"Field","name":{"kind":"Name","value":"refusalReason"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingSignerWithUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingSigner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractSignPendingSigner"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signatureImage"}},{"kind":"Field","name":{"kind":"Name","value":"useSecondaryEmail"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailWork"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUserId"}},{"kind":"Field","name":{"kind":"Name","value":"signOrder"}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<DocumentHandSignatoriesQuery, DocumentHandSignatoriesQueryVariables>;
export const StorageByContractSignPendingDocumentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"storageByContractSignPendingDocumentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contractSignPendingDocumentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}}]}}]} as unknown as DocumentNode<StorageByContractSignPendingDocumentIdQuery, StorageByContractSignPendingDocumentIdQueryVariables>;
export const GetUserFilesInFolderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserFilesInFolder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentFolderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileOwnerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"documentFolderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentFolderId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileType"},"value":{"kind":"StringValue","value":"document","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserFilesInFolderQuery, GetUserFilesInFolderQueryVariables>;
export const ExpiringDocumentsWidgetQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"expiringDocumentsWidgetQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StoragesOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expireAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"document","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileOwner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"COMPANY_FOLDER_DOCUMENT"},{"kind":"EnumValue","value":"DEPARTMENT"},{"kind":"EnumValue","value":"COMPANY"},{"kind":"EnumValue","value":"USER"},{"kind":"EnumValue","value":"USER_FOLDER_DOCUMENT"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwner"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"ownerName"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<ExpiringDocumentsWidgetQueryQuery, ExpiringDocumentsWidgetQueryQueryVariables>;
export const ExportDocumentsToExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"exportDocumentsToExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportDocumentsToExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]} as unknown as DocumentNode<ExportDocumentsToExcelQuery, ExportDocumentsToExcelQueryVariables>;
export const StorageHtmlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"storageHtml"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storageById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"html"}}]}}]}}]} as unknown as DocumentNode<StorageHtmlQuery, StorageHtmlQueryVariables>;
export const UserDocumentFoldersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userDocumentFolders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"ownerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"NAME_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFolder"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentFolder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentFolder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentDocumentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerType"}},{"kind":"Field","name":{"kind":"Name","value":"lastEdited"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"rootDocumentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserDocumentFoldersQuery, UserDocumentFoldersQueryVariables>;
export const DocumentFoldersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"documentFolders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentFoldersOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentFolderFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includePersonalFolders"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storageFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StorageFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootStorageFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StorageFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"casefileFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmployeeCasefileFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signPendingFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingDocumentFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFolder"}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storageFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileType"},"value":{"kind":"StringValue","value":"document","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Storage"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootStorageFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileType"},"value":{"kind":"StringValue","value":"document","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Storage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"BooleanValue","value":false}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includePersonalFolders"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingSigners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"refused"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signPendingFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingId"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderValues"}},{"kind":"Field","name":{"kind":"Name","value":"existingStorageId"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderValues"}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Storage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"existingStorage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Storage"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeCasefiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"casefileFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includePersonalFolders"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signers"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentFolder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentFolder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentDocumentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerType"}},{"kind":"Field","name":{"kind":"Name","value":"lastEdited"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"rootDocumentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Storage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Storage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwner"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deleteAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"remindAt"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMappings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"documentTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderValues"}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentUserResponsiblesByFileId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeCasefileId"}}]}}]} as unknown as DocumentNode<DocumentFoldersQuery, DocumentFoldersQueryVariables>;
export const DocumentFoldersSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"documentFoldersSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentFoldersOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentFolderFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeSharedFolders"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storageFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StorageFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFolder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storageFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileType"},"value":{"kind":"StringValue","value":"document","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Storage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentsFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"NAME_ASC"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeSharedFolders"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentFolder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentFolder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentDocumentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerType"}},{"kind":"Field","name":{"kind":"Name","value":"lastEdited"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"rootDocumentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Storage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Storage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwner"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deleteAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"remindAt"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMappings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"documentTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderValues"}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentUserResponsiblesByFileId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeCasefileId"}}]}}]} as unknown as DocumentNode<DocumentFoldersSearchQuery, DocumentFoldersSearchQueryVariables>;
export const DocumentFolderBlueprintsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"documentFolderBlueprints"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentFolderBlueprintFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentDocumentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfFiles"}}]}}]}}]}}]} as unknown as DocumentNode<DocumentFolderBlueprintsQuery, DocumentFolderBlueprintsQueryVariables>;
export const DocumentFolderByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"documentFolderById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storageFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StorageFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentFolder"}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storageFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Storage"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentFolder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentFolder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentDocumentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerType"}},{"kind":"Field","name":{"kind":"Name","value":"lastEdited"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"rootDocumentFolderBlueprintId"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Storage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Storage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwner"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deleteAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"remindAt"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMappings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"documentTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderValues"}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentUserResponsiblesByFileId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeCasefileId"}}]}}]} as unknown as DocumentNode<DocumentFolderByIdQuery, DocumentFolderByIdQueryVariables>;
export const StoragesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fileOwner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"COMPANY_FOLDER_DOCUMENT"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"documentFolderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Storage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Storage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Storage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwner"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deleteAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"remindAt"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMappings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderId"}},{"kind":"Field","name":{"kind":"Name","value":"documentTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderValues"}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentUserResponsiblesByFileId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeCasefileId"}}]}}]} as unknown as DocumentNode<StoragesQuery, StoragesQueryVariables>;
export const DocumentFolderBlueprintAffectedFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"documentFolderBlueprintAffectedFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprintAffectedFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"documentFolderBlueprintId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfEmployees"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfFiles"}}]}}]}}]} as unknown as DocumentNode<DocumentFolderBlueprintAffectedFilesQuery, DocumentFolderBlueprintAffectedFilesQueryVariables>;
export const GetFolderByBlueprintAndEmployeeIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFolderByBlueprintAndEmployeeId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"blueprintId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentFolderBlueprintId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blueprintId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ownerId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetFolderByBlueprintAndEmployeeIdQuery, GetFolderByBlueprintAndEmployeeIdQueryVariables>;
export const GetEmployeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEmployee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"graphileIdRequired"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"graphileIdRequired"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmployeeProfile"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployeeBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"leaderDepartments"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"alternateFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"alternateLastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"birthdate"}},{"kind":"Field","name":{"kind":"Name","value":"employmentStart"}},{"kind":"Field","name":{"kind":"Name","value":"employmentEnd"}},{"kind":"Field","name":{"kind":"Name","value":"companyAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemUser"}},{"kind":"Field","name":{"kind":"Name","value":"canSignOnBehalfOf"}},{"kind":"Field","name":{"kind":"Name","value":"cpr"}},{"kind":"Field","name":{"kind":"Name","value":"bankRegistrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionType"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionWorkingHours"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionDescription"}},{"kind":"Field","name":{"kind":"Name","value":"initialsLogo"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"thumbnail"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"Field","name":{"kind":"Name","value":"hasLogo"}},{"kind":"Field","name":{"kind":"Name","value":"isFuture"}},{"kind":"Field","name":{"kind":"Name","value":"isResigned"}},{"kind":"Field","name":{"kind":"Name","value":"directManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canLogin"}},{"kind":"Field","name":{"kind":"Name","value":"canLoginApp"}},{"kind":"Field","name":{"kind":"Name","value":"canLoginSso"}},{"kind":"Field","name":{"kind":"Name","value":"godmode"}},{"kind":"Field","name":{"kind":"Name","value":"employeeNumber"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployeeContact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailWork"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePrivate"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployeeLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployeeProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"rankId"}},{"kind":"Field","name":{"kind":"Name","value":"rank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cvr"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentType"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmployeeBasic"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmployeeContact"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmployeeLocation"}}]}}]} as unknown as DocumentNode<GetEmployeeQuery, GetEmployeeQueryVariables>;
export const EmployeeQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeeQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormFieldEntry"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"initials"}},{"kind":"Field","name":{"kind":"Name","value":"alternateFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"alternateLastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailWork"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"employmentStart"}},{"kind":"Field","name":{"kind":"Name","value":"employmentEnd"}},{"kind":"Field","name":{"kind":"Name","value":"seniority"}},{"kind":"Field","name":{"kind":"Name","value":"employeeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"employmentJurisdiction"}},{"kind":"Field","name":{"kind":"Name","value":"birthdate"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePrivate"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"cpr"}},{"kind":"Field","name":{"kind":"Name","value":"bankRegistrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"hasLogo"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionType"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionWorkingHours"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionDescription"}},{"kind":"Field","name":{"kind":"Name","value":"directManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormFieldEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]} as unknown as DocumentNode<EmployeeQueryQuery, EmployeeQueryQueryVariables>;
export const GetEmployeeEquipmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEmployeeEquipment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"equipments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"serial"}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEmployeeEquipmentQuery, GetEmployeeEquipmentQueryVariables>;
export const EmployeeTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeeTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeRelations"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Task"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeRelations"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeRelations"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Task"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminderDate"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"parentTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventFrom"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventTo"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventOrganizerId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"parentTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"processTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleResponsibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskResponsibles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}}]} as unknown as DocumentNode<EmployeeTasksQuery, EmployeeTasksQueryVariables>;
export const GetBulkEditEmployeeValuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBulkEditEmployeeValues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldNames"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldNames"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}}]} as unknown as DocumentNode<GetBulkEditEmployeeValuesQuery, GetBulkEditEmployeeValuesQueryVariables>;
export const TryGetEmployeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tryGetEmployee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<TryGetEmployeeQuery, TryGetEmployeeQueryVariables>;
export const LoggedInEmployeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loggedInEmployee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"birthdate"}},{"kind":"Field","name":{"kind":"Name","value":"cpr"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bankRegistrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"companyAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionType"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"sso"}},{"kind":"Field","name":{"kind":"Name","value":"availableLocales"}},{"kind":"Field","name":{"kind":"Name","value":"nativeAppAccess"}}]}}]}}]}}]} as unknown as DocumentNode<LoggedInEmployeeQuery, LoggedInEmployeeQueryVariables>;
export const EmployeeCaseFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeeCaseFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmployeeCasefilesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmployeeCasefileFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeCasefiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmployeeCasefile"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployeeCasefile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmployeeCasefile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"casefileId"}},{"kind":"Field","name":{"kind":"Name","value":"casefileId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"signers"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"}},{"kind":"Field","name":{"kind":"Name","value":"documents"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeSigners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<EmployeeCaseFilesQuery, EmployeeCaseFilesQueryVariables>;
export const EmployeeCaseFilesSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeeCaseFilesSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmployeeCasefilesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmployeeCasefileFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"argSearchString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeCasefilesSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"argSearchString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"argSearchString"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmployeeCasefile"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployeeCasefile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmployeeCasefile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"casefileId"}},{"kind":"Field","name":{"kind":"Name","value":"casefileId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"signers"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"}},{"kind":"Field","name":{"kind":"Name","value":"documents"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeSigners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<EmployeeCaseFilesSearchQuery, EmployeeCaseFilesSearchQueryVariables>;
export const EmployeeCasefileByEmployeeIdAndCasefileIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeeCasefileByEmployeeIdAndCasefileId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"casefileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeCasefileByEmployeeIdAndCasefileId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"casefileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"casefileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"}}]}}]}}]} as unknown as DocumentNode<EmployeeCasefileByEmployeeIdAndCasefileIdQuery, EmployeeCasefileByEmployeeIdAndCasefileIdQueryVariables>;
export const UnsignedCasefilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"unsignedCasefiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unsignedCasefiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"employee"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"casefileId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"signers"}},{"kind":"Field","name":{"kind":"Name","value":"documents"}},{"kind":"Field","name":{"kind":"Name","value":"employeeSigners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"employee"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"contractSignPendingSigners"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"refused"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enforceSignOrder"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ORDER_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractSignPendingDocument"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingSigners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"SIGN_ORDER_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractSignPendingSignerWithUser"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingSigner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingSigner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPendingId"}},{"kind":"Field","name":{"kind":"Name","value":"signed"}},{"kind":"Field","name":{"kind":"Name","value":"signDate"}},{"kind":"Field","name":{"kind":"Name","value":"signatureFileId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"refused"}},{"kind":"Field","name":{"kind":"Name","value":"refusalReason"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingDocument"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingDocument"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderValues"}},{"kind":"Field","name":{"kind":"Name","value":"contractName"}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"existingStorageId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMappings"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractSignPendingSignerWithUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSignPendingSigner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractSignPendingSigner"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignPending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signatureImage"}},{"kind":"Field","name":{"kind":"Name","value":"useSecondaryEmail"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailWork"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUserId"}},{"kind":"Field","name":{"kind":"Name","value":"signOrder"}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<UnsignedCasefilesQuery, UnsignedCasefilesQueryVariables>;
export const EmployeesSearchSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeesSearchSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"and"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilter"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"users"},"name":{"kind":"Name","value":"usersSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"argSearchString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FIRST_NAME_ASC"},{"kind":"EnumValue","value":"LAST_NAME_ASC"},{"kind":"EnumValue","value":"ID_ASC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"Variable","name":{"kind":"Name","value":"and"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<EmployeesSearchSuggestionsQuery, EmployeesSearchSuggestionsQueryVariables>;
export const AllEployeesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allEployees"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmployeeFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmployeesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailWork"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"rankId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AllEployeesQuery, AllEployeesQueryVariables>;
export const EmployeesPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeesPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldColumnNames"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldColumnIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeArchived"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IncludeArchivedOption"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeOngoingProcesses"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeFinishedProcesses"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeOngoingPreboardings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeFinishedPreboardings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDepartments"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeGroups"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeCompetences"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeLatestTimeRegistrationTemplate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"includeArchived"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeArchived"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"leaderDepartments"}},{"kind":"Field","name":{"kind":"Name","value":"latestTimeRegistrationTemplate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeLatestTimeRegistrationTemplate"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"userSystemFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldColumnNames"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldColumnIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"StringValue","value":"employee","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormFieldEntryEmployeesPage"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"futureData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"UPDATE_VALUE_AT_ASC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldColumnIds"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldColumnNames"}}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureDataEmployeesPage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"alternateFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"alternateLastName"}},{"kind":"Field","name":{"kind":"Name","value":"employeeByUserId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"ongoingProcesses"},"name":{"kind":"Name","value":"processes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"2"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeOngoingProcesses"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"finishedProcesses"},"name":{"kind":"Name","value":"processes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"2"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeFinishedProcesses"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"ongoingPreboardings"},"name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"2"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboarding"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"anonymous"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeOngoingPreboardings"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"finishedPreboardings"},"name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"2"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboarding"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"anonymous"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeFinishedPreboardings"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDepartments"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"rankId"}},{"kind":"Field","name":{"kind":"Name","value":"rank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentTypeEmployeesPage"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeGroups"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userDepartmentGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeGroups"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userCompanyGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeGroups"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userCompetences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"competence"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"competenceGroup"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeCompetences"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"userCompetenceEvaluations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nextUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"evaluatingUserId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"competence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"outdateCompetence"}},{"kind":"Field","name":{"kind":"Name","value":"ratingFormField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"competenceGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reminderInterval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormFieldEntryEmployeesPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureDataEmployeesPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FutureDatum"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntryId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"updateValueAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"previousHumanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"approvalIsRequired"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"creatorUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"readableName"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalId"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentTypeEmployeesPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]} as unknown as DocumentNode<EmployeesPageQuery, EmployeesPageQueryVariables>;
export const UsersPageTotalCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"usersPageTotalCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeArchived"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IncludeArchivedOption"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeArchived"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeArchived"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UsersPageTotalCountQuery, UsersPageTotalCountQueryVariables>;
export const UsersSearchTotalCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"usersSearchTotalCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"argSearchString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"argSearchString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"argSearchString"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UsersSearchTotalCountQuery, UsersSearchTotalCountQueryVariables>;
export const EmployeesPageOldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeesPageOld"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmployeesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmployeeFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeArchived"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IncludeArchivedOption"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldColumnIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"includeArchived"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeArchived"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"leaderDepartments"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldColumnIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"StringValue","value":"employee","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormFieldEntryEmployeesPage"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"rankId"}},{"kind":"Field","name":{"kind":"Name","value":"rank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentTypeEmployeesPage"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userDepartmentGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userCompanyGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userCompetences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"competence"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"competenceGroup"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"competenceGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"localizedValue"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormFieldEntryEmployeesPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentTypeEmployeesPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]} as unknown as DocumentNode<EmployeesPageOldQuery, EmployeesPageOldQueryVariables>;
export const EmployeesSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeesSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"argSearchString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"argFormFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"argOrderDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldColumnNames"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldColumnIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeOngoingProcesses"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeFinishedProcesses"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeOngoingPreboardings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeFinishedPreboardings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDepartments"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeGroups"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeCompetences"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeLatestTimeRegistrationTemplate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"argSearchString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"argSearchString"}}},{"kind":"Argument","name":{"kind":"Name","value":"argFormFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"argFormFieldId"}}},{"kind":"Argument","name":{"kind":"Name","value":"argOrderDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"argOrderDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"latestTimeRegistrationTemplate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeLatestTimeRegistrationTemplate"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"userSystemFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldColumnNames"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldColumnIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"StringValue","value":"employee","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormFieldEntryEmployeesPage"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"futureData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"UPDATE_VALUE_AT_ASC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldColumnIds"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldColumnNames"}}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureDataEmployeesPage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"alternateFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"alternateLastName"}},{"kind":"Field","name":{"kind":"Name","value":"employeeByUserId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"ongoingProcesses"},"name":{"kind":"Name","value":"processes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"2"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeOngoingProcesses"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"finishedProcesses"},"name":{"kind":"Name","value":"processes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"2"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeFinishedProcesses"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"ongoingPreboardings"},"name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"2"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboarding"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeOngoingPreboardings"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"finishedPreboardings"},"name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"2"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboarding"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeFinishedPreboardings"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDepartments"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"rankId"}},{"kind":"Field","name":{"kind":"Name","value":"rank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DepartmentTypeEmployeesPage"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeGroups"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userDepartmentGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeGroups"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userCompanyGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeGroups"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userCompetences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"competence"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"competenceGroup"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeCompetences"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"userCompetenceEvaluations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nextUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"evaluatingUserId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"competence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"outdateCompetence"}},{"kind":"Field","name":{"kind":"Name","value":"ratingFormField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"competenceGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reminderInterval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"seconds"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormFieldEntryEmployeesPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureDataEmployeesPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FutureDatum"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntryId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"updateValueAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"previousHumanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"approvalIsRequired"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"creatorUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"readableName"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalId"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DepartmentTypeEmployeesPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DepartmentType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]} as unknown as DocumentNode<EmployeesSearchQuery, EmployeesSearchQueryVariables>;
export const DirectManagerBasicInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"directManagerBasicInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDirectManagerBasicInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}}]} as unknown as DocumentNode<DirectManagerBasicInfoQuery, DirectManagerBasicInfoQueryVariables>;
export const UserDirectManagerBasicInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userDirectManagerBasicInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserDirectManagerBasicInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]} as unknown as DocumentNode<UserDirectManagerBasicInfoQuery, UserDirectManagerBasicInfoQueryVariables>;
export const EmployeeBasicInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeeBasicInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEmployeesBasicInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employeeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}}]} as unknown as DocumentNode<EmployeeBasicInfoQuery, EmployeeBasicInfoQueryVariables>;
export const EmployeesByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeesByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUIDListFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmployeesOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"departments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentsFilter"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"includeArchived"},"value":{"kind":"EnumValue","value":"YES"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePrivate"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"leaderDepartments"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<EmployeesByIdsQuery, EmployeesByIdsQueryVariables>;
export const EmployeeByUserIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeeByUserId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"USER_BY_USER_ID__FIRST_NAME_ASC"},{"kind":"EnumValue","value":"USER_BY_USER_ID__LAST_NAME_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePrivate"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<EmployeeByUserIdQuery, EmployeeByUserIdQueryVariables>;
export const EmployeesFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeesFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"USER_BY_USER_ID__FIRST_NAME_ASC"},{"kind":"EnumValue","value":"USER_BY_USER_ID__LAST_NAME_ASC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EmployeesFilterQuery, EmployeesFilterQueryVariables>;
export const EmployeesDownloadImportFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmployeesDownloadImportFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"delimiter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyIncludeRequiredFields"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DownloadEmployeesFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"delimiter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"delimiter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"onlyIncludeRequiredFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyIncludeRequiredFields"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}}]}}]}}]} as unknown as DocumentNode<EmployeesDownloadImportFileQuery, EmployeesDownloadImportFileQueryVariables>;
export const EmployeesAnalyseImportFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmployeesAnalyseImportFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mappings"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CsvMappingInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useDefaultCustomFieldValues"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"delimiter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AnalyseImportEmployeesFromFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mappings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mappings"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useDefaultCustomFieldValues"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useDefaultCustomFieldValues"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"delimiter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"delimiter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"messageCode"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<EmployeesAnalyseImportFileQuery, EmployeesAnalyseImportFileQueryVariables>;
export const EmployeeDepartmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeeDepartments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EmployeeDepartmentsQuery, EmployeeDepartmentsQueryVariables>;
export const GetEmployeeCsvFieldMappingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEmployeeCsvFieldMapping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"csvFile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"delimiter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEmployeeCsvFieldMapping"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"csvFile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"csvFile"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"delimiter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"delimiter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mappings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"columnName"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEmployeeCsvFieldMappingQuery, GetEmployeeCsvFieldMappingQueryVariables>;
export const AnalyseCsvEmployeeUpdateFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"analyseCsvEmployeeUpdateFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"csvFile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mappings"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CsvMappingInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clearFieldValuesWhenEmpty"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"delimiter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analyseCsvEmployeeUpdateFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"csvFile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"csvFile"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mappings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mappings"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"clearFieldValuesWhenEmpty"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clearFieldValuesWhenEmpty"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"delimiter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"delimiter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"messageCode"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<AnalyseCsvEmployeeUpdateFileQuery, AnalyseCsvEmployeeUpdateFileQueryVariables>;
export const DownloadEmployeeRecordUpdateTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"downloadEmployeeRecordUpdateTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeRecordFieldId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"delimiter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadEmployeeRecordUpdateTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employeeRecordFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeRecordFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"delimiter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"delimiter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]} as unknown as DocumentNode<DownloadEmployeeRecordUpdateTemplateQuery, DownloadEmployeeRecordUpdateTemplateQueryVariables>;
export const AnalyseCsvEmployeeRecordUpdateFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"analyseCsvEmployeeRecordUpdateFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"csvFile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeRecordFieldId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"delimiter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analyseCsvEmployeeRecordUpdateFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"csvFile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"csvFile"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeRecordFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeRecordFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"delimiter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"delimiter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"messageCode"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<AnalyseCsvEmployeeRecordUpdateFileQuery, AnalyseCsvEmployeeRecordUpdateFileQueryVariables>;
export const EmployeesByIdsWithDateFieldEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeesByIdsWithDateFieldEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUIDListFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmployeesOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"departments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentsFilter"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePrivate"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"employmentEnd"}},{"kind":"Field","name":{"kind":"Name","value":"employmentStart"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"employee","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"date","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<EmployeesByIdsWithDateFieldEntriesQuery, EmployeesByIdsWithDateFieldEntriesQueryVariables>;
export const AllUserIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allUserIds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isFuture"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isSystemUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AllUserIdsQuery, AllUserIdsQueryVariables>;
export const UsersTotalCountByGroupIdsAndDepartmentIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"usersTotalCountByGroupIdsAndDepartmentIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"groupIds"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"overlaps"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupIds"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departments"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"overlaps"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isFuture"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isSystemUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UsersTotalCountByGroupIdsAndDepartmentIdsQuery, UsersTotalCountByGroupIdsAndDepartmentIdsQueryVariables>;
export const AllEngagementTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allEngagementTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EngagementTypesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EngagementTypeFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagementTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<AllEngagementTypesQuery, AllEngagementTypesQueryVariables>;
export const EngagementTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"engagementType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagementTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<EngagementTypeQuery, EngagementTypeQueryVariables>;
export const GetProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Product"}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwner"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deleteAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"remindAt"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Equipment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Equipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"serial"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"acquisitionDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserDepartments"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserId"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedByEmployeeId"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedByDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Equipment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProductsQuery, GetProductsQueryVariables>;
export const ProductDropdownQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"productDropdownQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserId"}},{"kind":"Field","name":{"kind":"Name","value":"serial"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductDropdownQueryQuery, ProductDropdownQueryQueryVariables>;
export const GetProductsFormFieldSortDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProductsFormFieldSort"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"argFormFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"argOrderDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productsSortByFormField"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"argFormFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"argFormFieldId"}}},{"kind":"Argument","name":{"kind":"Name","value":"argOrderDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"argOrderDirection"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Product"}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwner"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deleteAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"remindAt"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Equipment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Equipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"serial"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"acquisitionDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserDepartments"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserId"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedByEmployeeId"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedByDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Equipment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProductsFormFieldSortQuery, GetProductsFormFieldSortQueryVariables>;
export const GetEquipmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEquipment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Product"}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwner"}},{"kind":"Field","name":{"kind":"Name","value":"fileOwnerId"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deleteAt"}},{"kind":"Field","name":{"kind":"Name","value":"expireAt"}},{"kind":"Field","name":{"kind":"Name","value":"remindAt"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Equipment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Equipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"serial"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"acquisitionDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserDepartments"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserId"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedByEmployeeId"}},{"kind":"Field","name":{"kind":"Name","value":"occupiedByDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Equipment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEquipmentQuery, GetEquipmentQueryVariables>;
export const EquipmentCustomFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"equipmentCustomFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntryCondition"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeEntry"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"StringValue","value":"equipment","block":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormFieldWithEntry"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormFieldEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormFieldWithEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeEntry"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormFieldEntry"}}]}}]}}]}}]} as unknown as DocumentNode<EquipmentCustomFieldsQuery, EquipmentCustomFieldsQueryVariables>;
export const GetEquipmentOwnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEquipmentOwners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEquipmentOwners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FIRST_NAME_ASC"},{"kind":"EnumValue","value":"LAST_NAME_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEquipmentOwnersQuery, GetEquipmentOwnersQueryVariables>;
export const AllProductTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allProductTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTypesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTypeFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<AllProductTypesQuery, AllProductTypesQueryVariables>;
export const ProductTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"productType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProductTypeQuery, ProductTypeQueryVariables>;
export const EquipmentListAsExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"equipmentListAsExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fields"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExportEquipmentToExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fields"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"excelFile"}}]}}]}}]} as unknown as DocumentNode<EquipmentListAsExcelQuery, EquipmentListAsExcelQueryVariables>;
export const GetEquipmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEquipments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Equipment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Equipment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Equipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<GetEquipmentsQuery, GetEquipmentsQueryVariables>;
export const EquipmentDownloadImportFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EquipmentDownloadImportFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"delimiter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DownloadEquipmentFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"delimiter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"delimiter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}}]}}]}}]} as unknown as DocumentNode<EquipmentDownloadImportFileQuery, EquipmentDownloadImportFileQueryVariables>;
export const EquipmentAnalyseImportFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EquipmentAnalyseImportFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AnalyseImportEquipmentFromFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"messageCode"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<EquipmentAnalyseImportFileQuery, EquipmentAnalyseImportFileQueryVariables>;
export const EquipmentHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"equipmentHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EquipmentOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"history"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"addedBy"}},{"kind":"Field","name":{"kind":"Name","value":"removedBy"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<EquipmentHistoryQuery, EquipmentHistoryQueryVariables>;
export const EventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"events"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EventFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attendees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attending"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<EventsQuery, EventsQueryVariables>;
export const EventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"event"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"organizerIds"}},{"kind":"Field","name":{"kind":"Name","value":"contactPersonIds"}},{"kind":"Field","name":{"kind":"Name","value":"invitedAll"}},{"kind":"Field","name":{"kind":"Name","value":"invitedUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"invitedDepartmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EventQuery, EventQueryVariables>;
export const EventWithAnswersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"eventWithAnswers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"organizerIds"}},{"kind":"Field","name":{"kind":"Name","value":"contactPersonIds"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attendees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attending"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EventWithAnswersQuery, EventWithAnswersQueryVariables>;
export const AttendeesByEventIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"attendeesByEventId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"or"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AttendeeFilter"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attendeesByEventId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fullName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"Variable","name":{"kind":"Name","value":"or"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"attending"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<AttendeesByEventIdQuery, AttendeesByEventIdQueryVariables>;
export const ExternalIntegrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"externalIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalIntegrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalIntegrationBasic"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalIntegrationBasic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalIntegration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"systemId"}},{"kind":"Field","name":{"kind":"Name","value":"externalCompanyId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMappings"}},{"kind":"Field","name":{"kind":"Name","value":"blacklistedFields"}},{"kind":"Field","name":{"kind":"Name","value":"whitelistedFields"}},{"kind":"Field","name":{"kind":"Name","value":"continuousSync"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentInheritance"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"system"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integrableSystem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"homepageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUrl"}}]}}]}}]} as unknown as DocumentNode<ExternalIntegrationsQuery, ExternalIntegrationsQueryVariables>;
export const GetZenegyTokensDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetZenegyTokens"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetZenegyTokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"externalCompanyId"}}]}}]}}]} as unknown as DocumentNode<GetZenegyTokensQuery, GetZenegyTokensQueryVariables>;
export const ValidateZenegyFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"validateZenegyFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateZenegyFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ValidateZenegyFieldsQuery, ValidateZenegyFieldsQueryVariables>;
export const IntegrationDepartmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"integrationDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalIntegrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"system"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"IntValue","value":"1"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}}]}}]}}]}}]} as unknown as DocumentNode<IntegrationDepartmentsQuery, IntegrationDepartmentsQueryVariables>;
export const IntegrationDocumentOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"integrationDocumentOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<IntegrationDocumentOptionsQuery, IntegrationDocumentOptionsQueryVariables>;
export const ZenegyIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"zenegyIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalIntegrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"system"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"Zenegy","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalCompanyId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMappings"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentInheritance"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"config"}},{"kind":"Field","name":{"kind":"Name","value":"blacklistedFields"}},{"kind":"Field","name":{"kind":"Name","value":"whitelistedFields"}},{"kind":"Field","name":{"kind":"Name","value":"continuousSync"}},{"kind":"Field","name":{"kind":"Name","value":"payslipDocumentBlueprintFolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payslipDocumentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeExternalIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"absenceSync"}},{"kind":"Field","name":{"kind":"Name","value":"absenceMappings"}}]}}]}}]}}]} as unknown as DocumentNode<ZenegyIntegrationQuery, ZenegyIntegrationQueryVariables>;
export const FieldGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fieldGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FieldGroupFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldGroup"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","alias":{"kind":"Name","value":"recordFields"},"name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"StringValue","value":"table","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCardColumns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FieldGroupsQuery, FieldGroupsQueryVariables>;
export const FieldGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fieldGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldGroupById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","alias":{"kind":"Name","value":"recordFields"},"name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"StringValue","value":"table","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCardColumns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FieldGroupQuery, FieldGroupQueryVariables>;
export const FieldGroupQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fieldGroupQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getUserData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldGroupById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldGroupCard"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"employee","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"table","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldGroupId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"integrationFieldMarkings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendsData"}},{"kind":"Field","name":{"kind":"Name","value":"receivesData"}},{"kind":"Field","name":{"kind":"Name","value":"authAppId"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"integrationName"}},{"kind":"Field","name":{"kind":"Name","value":"externalIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"systemId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getUserData"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldGroupCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldGroupCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"localizedDescription"}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCardColumns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"employee","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"StringValue","value":"table","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"integrationFieldMarkings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendsData"}},{"kind":"Field","name":{"kind":"Name","value":"receivesData"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"integrationName"}},{"kind":"Field","name":{"kind":"Name","value":"externalIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"systemId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authAppId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getUserData"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"integrationFieldMarkings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendsData"}},{"kind":"Field","name":{"kind":"Name","value":"receivesData"}},{"kind":"Field","name":{"kind":"Name","value":"authAppId"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"integrationName"}},{"kind":"Field","name":{"kind":"Name","value":"externalIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"systemId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userSystemFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getUserData"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FieldGroupQueryQuery, FieldGroupQueryQueryVariables>;
export const FieldGroupCardQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fieldGroupCardQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCardById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<FieldGroupCardQueryQuery, FieldGroupCardQueryQueryVariables>;
export const AllFieldsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allFieldsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getUserData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldGroupCard"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldGroupCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldGroupCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"localizedDescription"}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCardColumns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"employee","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"StringValue","value":"table","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"integrationFieldMarkings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendsData"}},{"kind":"Field","name":{"kind":"Name","value":"receivesData"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"integrationName"}},{"kind":"Field","name":{"kind":"Name","value":"externalIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"systemId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authAppId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getUserData"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"integrationFieldMarkings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendsData"}},{"kind":"Field","name":{"kind":"Name","value":"receivesData"}},{"kind":"Field","name":{"kind":"Name","value":"authAppId"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"integrationName"}},{"kind":"Field","name":{"kind":"Name","value":"externalIntegration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"systemId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userSystemFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getUserData"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllFieldsQueryQuery, AllFieldsQueryQueryVariables>;
export const RequiredFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"requiredFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formFields"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"required"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companySystemFields"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"required"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"departments","block":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"alwaysRequired"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"systemField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notIn"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"departments","block":false},{"kind":"StringValue","value":"postal_code","block":false},{"kind":"StringValue","value":"city","block":false},{"kind":"StringValue","value":"country","block":false},{"kind":"StringValue","value":"first_name","block":false},{"kind":"StringValue","value":"last_name","block":false},{"kind":"StringValue","value":"email","block":false}]}}]}}]}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"required"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"departments","block":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"alwaysRequired"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"systemField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notIn"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"departments","block":false},{"kind":"StringValue","value":"postal_code","block":false},{"kind":"StringValue","value":"city","block":false},{"kind":"StringValue","value":"country","block":false},{"kind":"StringValue","value":"first_name","block":false},{"kind":"StringValue","value":"last_name","block":false},{"kind":"StringValue","value":"email","block":false}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"cardOrder"}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alwaysRequired"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"required"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"StringValue","value":"table","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"cardOrder"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RequiredFieldsQuery, RequiredFieldsQueryVariables>;
export const FieldGroupsAddEmployeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fieldGroupsAddEmployee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FieldGroupFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"table","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"cardOrder"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedDescription"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCardColumns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companySystemFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"readOnly"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"cardOrder"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"alwaysRequired"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"cardOrder"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FieldGroupsAddEmployeeQuery, FieldGroupsAddEmployeeQueryVariables>;
export const FieldGroupCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fieldGroupCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldGroupCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FieldGroupCardsQuery, FieldGroupCardsQueryVariables>;
export const AddFieldGroupQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"addFieldGroupQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"table","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddFieldGroupQueryQuery, AddFieldGroupQueryQueryVariables>;
export const UnassignedFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"unassignedFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"unassignedFormFields"},"name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldGroupCardColumnId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldGroupCardColumn"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"employee","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"StringValue","value":"table","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unassignedSystemFields"},"name":{"kind":"Name","value":"systemFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companySystemFields"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldGroupCardColumnId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldGroupCardColumn"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UnassignedFieldsQuery, UnassignedFieldsQueryVariables>;
export const FilterPresetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"filterPresets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tableName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filterPresets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tableName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tableName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"NAME_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FilterPreset"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FilterPreset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FilterPreset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tableName"}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"filters"}},{"kind":"Field","name":{"kind":"Name","value":"miscellaneousFilters"}}]}}]} as unknown as DocumentNode<FilterPresetsQuery, FilterPresetsQueryVariables>;
export const AllFormFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allFormFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectTypes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeFields"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"table","block":false}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldsOrderBy"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ORDER_ASC"}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"or"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldFilter"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectTypes"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeFields"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"Variable","name":{"kind":"Name","value":"or"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}}]} as unknown as DocumentNode<AllFormFieldsQuery, AllFormFieldsQueryVariables>;
export const AllEmployeeFormFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allEmployeeFormFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"employee","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"employee","block":false}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}}]} as unknown as DocumentNode<AllEmployeeFormFieldsQuery, AllEmployeeFormFieldsQueryVariables>;
export const AllFormFieldsWithEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allFormFieldsWithEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectTypes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectTypes"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ORDER_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllFormFieldsWithEntriesQuery, AllFormFieldsWithEntriesQueryVariables>;
export const EmployeeFieldFormFieldEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeeFieldFormFieldEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<EmployeeFieldFormFieldEntriesQuery, EmployeeFieldFormFieldEntriesQueryVariables>;
export const GetFormFieldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFormField"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFieldById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}}]} as unknown as DocumentNode<GetFormFieldQuery, GetFormFieldQueryVariables>;
export const ValidateFormFieldEntryUniquenessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"validateFormFieldEntryUniqueness"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateFormFieldEntryUniqueness"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"formFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}}},{"kind":"Argument","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}]}]}}]} as unknown as DocumentNode<ValidateFormFieldEntryUniquenessQuery, ValidateFormFieldEntryUniquenessQueryVariables>;
export const FormFieldEntryCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"formFieldEntryCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFieldEntryCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"argEmployeeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<FormFieldEntryCountQuery, FormFieldEntryCountQueryVariables>;
export const FormFieldEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"formFieldEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFieldById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormFieldEntry"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormFieldEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]} as unknown as DocumentNode<FormFieldEntriesQuery, FormFieldEntriesQueryVariables>;
export const AllFormFields2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allFormFields2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}}]} as unknown as DocumentNode<AllFormFields2Query, AllFormFields2QueryVariables>;
export const FormFieldsNameOnlyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"formFieldsNameOnly"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]} as unknown as DocumentNode<FormFieldsNameOnlyQuery, FormFieldsNameOnlyQueryVariables>;
export const FormFieldExistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"formFieldExists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"employee","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<FormFieldExistsQuery, FormFieldExistsQueryVariables>;
export const FormFieldSearchSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"formFieldSearchSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"StringValue","value":"employee","block":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"localizedName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}}]}}]}}]}}]} as unknown as DocumentNode<FormFieldSearchSuggestionsQuery, FormFieldSearchSuggestionsQueryVariables>;
export const FormFieldContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"formFieldContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFieldById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailWork"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePrivate"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FormFieldContactsQuery, FormFieldContactsQueryVariables>;
export const UseFormFieldsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"useFormFieldsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getFieldEntries"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldEntriesFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FormFieldEntryFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseFormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldEntriesFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getFieldEntries"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<UseFormFieldsQueryQuery, UseFormFieldsQueryQueryVariables>;
export const FroalaStyleByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"froalaStyleById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"froalaStyleById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FroalaStyle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FroalaStyle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FroalaStyle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}},{"kind":"Field","name":{"kind":"Name","value":"css"}}]}}]} as unknown as DocumentNode<FroalaStyleByIdQuery, FroalaStyleByIdQueryVariables>;
export const FroalaStylesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"froalaStyles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FroalaStylesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FroalaStyleFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"froalaStyles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FroalaStyle"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FroalaStyle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FroalaStyle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}},{"kind":"Field","name":{"kind":"Name","value":"css"}}]}}]} as unknown as DocumentNode<FroalaStylesQuery, FroalaStylesQueryVariables>;
export const FutureDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"futureData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FutureDatumFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FutureDataOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"futureData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FutureData"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FutureData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FutureDatum"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldEntryId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"updateValueAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"previousHumanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"approvalIsRequired"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"creatorUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"readableName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalId"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]} as unknown as DocumentNode<FutureDataQuery, FutureDataQueryVariables>;
export const FutureDataFieldsInUseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"futureDataFieldsInUse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"futureDataFieldsInUse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FutureDataFieldsInUseQuery, FutureDataFieldsInUseQueryVariables>;
export const GroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"groups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupsOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Group"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Role"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Role"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}},{"kind":"Field","name":{"kind":"Name","value":"usesItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Group"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"autoAdd"}},{"kind":"Field","name":{"kind":"Name","value":"autoAddNewPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"autoInherit"}},{"kind":"Field","name":{"kind":"Name","value":"groupRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"itemIds"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Role"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GroupsQuery, GroupsQueryVariables>;
export const GroupsTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"groupsTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupsOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Group"}},{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userDepartmentGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userCompanyGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Role"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}},{"kind":"Field","name":{"kind":"Name","value":"usesItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Group"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"autoAdd"}},{"kind":"Field","name":{"kind":"Name","value":"autoAddNewPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"autoInherit"}},{"kind":"Field","name":{"kind":"Name","value":"groupRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"itemIds"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Role"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GroupsTableQuery, GroupsTableQueryVariables>;
export const RoleByInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"roleByInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"info"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"info"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"info"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<RoleByInfoQuery, RoleByInfoQueryVariables>;
export const RolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"roles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RoleFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"localizedName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dashboardViews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"processTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"localizedName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"localizedName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vacationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"localizedName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pulseTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"LOCALIZED_NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"localizedName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"postTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"LOCALIZED_NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"localizedName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"LOCALIZED_NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"localizedName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentFolderBlueprints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parentDocumentFolderBlueprintId"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Role"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Role"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}},{"kind":"Field","name":{"kind":"Name","value":"usesItemIds"}}]}}]} as unknown as DocumentNode<RolesQuery, RolesQueryVariables>;
export const GroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"group"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Group"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Role"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}},{"kind":"Field","name":{"kind":"Name","value":"usesItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Group"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"autoAdd"}},{"kind":"Field","name":{"kind":"Name","value":"autoAddNewPermissions"}},{"kind":"Field","name":{"kind":"Name","value":"autoInherit"}},{"kind":"Field","name":{"kind":"Name","value":"groupRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"itemIds"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Role"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GroupQuery, GroupQueryVariables>;
export const GroupRoleByGroupIdAndRoleIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"groupRoleByGroupIdAndRoleId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupRoleByGroupIdAndRoleId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"itemIds"}}]}}]}}]} as unknown as DocumentNode<GroupRoleByGroupIdAndRoleIdQuery, GroupRoleByGroupIdAndRoleIdQueryVariables>;
export const MissingGroupRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"missingGroupRoles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMissingGroupRoles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Role"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Role"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}},{"kind":"Field","name":{"kind":"Name","value":"usesItemIds"}}]}}]} as unknown as DocumentNode<MissingGroupRolesQuery, MissingGroupRolesQueryVariables>;
export const GroupUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"groupUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIdFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUIDFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userDepartmentGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIdFilter"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userCompanyGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GroupUsersQuery, GroupUsersQueryVariables>;
export const AllGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<AllGroupsQuery, AllGroupsQueryVariables>;
export const ActiveAllScopeGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"activeAllScopeGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scope"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"ALL"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ActiveAllScopeGroupsQuery, ActiveAllScopeGroupsQueryVariables>;
export const ActiveDepartmentAboveScopeGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"activeDepartmentAboveScopeGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scope"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ALL"},{"kind":"EnumValue","value":"DEPARTMENT"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}}]}}]}}]}}]} as unknown as DocumentNode<ActiveDepartmentAboveScopeGroupsQuery, ActiveDepartmentAboveScopeGroupsQueryVariables>;
export const UserGroupListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userGroupList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeUserGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeUserDepartmentGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeUserCompanyGroups"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"USER_BY_USER_ID__FIRST_NAME_ASC"},{"kind":"EnumValue","value":"USER_BY_USER_ID__LAST_NAME_ASC"},{"kind":"EnumValue","value":"USER_BY_USER_ID__ID_ASC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fullName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeUserGroups"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userDepartmentGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"USER_BY_USER_ID__FIRST_NAME_ASC"},{"kind":"EnumValue","value":"USER_BY_USER_ID__LAST_NAME_ASC"},{"kind":"EnumValue","value":"USER_BY_USER_ID__ID_ASC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fullName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeUserDepartmentGroups"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userCompanyGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"USER_BY_USER_ID__FIRST_NAME_ASC"},{"kind":"EnumValue","value":"USER_BY_USER_ID__LAST_NAME_ASC"},{"kind":"EnumValue","value":"USER_BY_USER_ID__ID_ASC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"groupId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fullName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeUserCompanyGroups"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<UserGroupListQuery, UserGroupListQueryVariables>;
export const FieldsByExcludedRoleIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fieldsByExcludedRoleIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeExcludedFields"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"autoAddGroups"},"name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"autoAdd"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"scope"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"SELF"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"employee","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"excludedRoleIds"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"overlaps"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeExcludedFields"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"excludedRoleIds"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"overlaps"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeExcludedFields"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FieldsByExcludedRoleIdsQuery, FieldsByExcludedRoleIdsQueryVariables>;
export const IntegrableSystemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"integrableSystems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isBeta"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrableSystems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isBeta"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isBeta"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"homepageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"authUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deleteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"loginUrl"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"legalDescription"}}]}}]}}]}}]} as unknown as DocumentNode<IntegrableSystemsQuery, IntegrableSystemsQueryVariables>;
export const IntegrableSystemByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"integrableSystemById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrableSystemById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"settingsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"loginUrl"}},{"kind":"Field","name":{"kind":"Name","value":"legalDescription"}},{"kind":"Field","name":{"kind":"Name","value":"homepageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"authUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createUrl"}}]}}]}}]} as unknown as DocumentNode<IntegrableSystemByIdQuery, IntegrableSystemByIdQueryVariables>;
export const GetFieldLogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFieldLog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FieldLogType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFieldLog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldEntryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntryId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"creator"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"context"}}]}}]}}]}}]} as unknown as DocumentNode<GetFieldLogQuery, GetFieldLogQueryVariables>;
export const LoggedActionNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loggedActionNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loggedActionNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loggedActionEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"creator"}}]}}]}}]}}]} as unknown as DocumentNode<LoggedActionNotesQuery, LoggedActionNotesQueryVariables>;
export const ExportFieldLogToExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"exportFieldLogToExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FieldLogType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportFieldLogToExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldEntryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldEntryId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]} as unknown as DocumentNode<ExportFieldLogToExcelQuery, ExportFieldLogToExcelQueryVariables>;
export const GetSingleProcessLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSingleProcessLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"argSearchString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LogEntryFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSingleProcessLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"argProcessId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processId"}}},{"kind":"Argument","name":{"kind":"Name","value":"argOrderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"argSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"argSearchString"}}},{"kind":"Argument","name":{"kind":"Name","value":"argFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"argTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LogEntry"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LogEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LogEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowData"}},{"kind":"Field","name":{"kind":"Name","value":"changedFields"}},{"kind":"Field","name":{"kind":"Name","value":"loggedAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"schemaName"}},{"kind":"Field","name":{"kind":"Name","value":"tableName"}},{"kind":"Field","name":{"kind":"Name","value":"actionTstampTx"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"selectedFields"}},{"kind":"Field","name":{"kind":"Name","value":"affectedId"}},{"kind":"Field","name":{"kind":"Name","value":"loggedActionContext"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<GetSingleProcessLogsQuery, GetSingleProcessLogsQueryVariables>;
export const GetDeletionLogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDeletionLog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LogFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDeletionLog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loggedAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"affectedId"}},{"kind":"Field","name":{"kind":"Name","value":"affectedItem"}},{"kind":"Field","name":{"kind":"Name","value":"actionTstampTx"}},{"kind":"Field","name":{"kind":"Name","value":"loggedActionContext"}},{"kind":"Field","name":{"kind":"Name","value":"creator"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<GetDeletionLogQuery, GetDeletionLogQueryVariables>;
export const GetLoginLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLoginLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginLogFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginLogsOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ip"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"superUser"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetLoginLogsQuery, GetLoginLogsQueryVariables>;
export const GetEmployeeCasefileLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEmployeeCasefileLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"casefileId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"argSearchString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LogEntryFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEmployeeCasefileLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"argCasefileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"casefileId"}}},{"kind":"Argument","name":{"kind":"Name","value":"argOrderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"argSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"argSearchString"}}},{"kind":"Argument","name":{"kind":"Name","value":"argFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"argTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LogEntry"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LogEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LogEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowData"}},{"kind":"Field","name":{"kind":"Name","value":"changedFields"}},{"kind":"Field","name":{"kind":"Name","value":"loggedAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"schemaName"}},{"kind":"Field","name":{"kind":"Name","value":"tableName"}},{"kind":"Field","name":{"kind":"Name","value":"actionTstampTx"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"selectedFields"}},{"kind":"Field","name":{"kind":"Name","value":"affectedId"}},{"kind":"Field","name":{"kind":"Name","value":"loggedActionContext"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<GetEmployeeCasefileLogsQuery, GetEmployeeCasefileLogsQueryVariables>;
export const GetEmployeeLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEmployeeLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"argSearchString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LogEntryFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEmployeeLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"argEmployeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"argOrderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"argSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"argSearchString"}}},{"kind":"Argument","name":{"kind":"Name","value":"argFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"argTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LogEntry"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LogEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LogEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowData"}},{"kind":"Field","name":{"kind":"Name","value":"changedFields"}},{"kind":"Field","name":{"kind":"Name","value":"loggedAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"schemaName"}},{"kind":"Field","name":{"kind":"Name","value":"tableName"}},{"kind":"Field","name":{"kind":"Name","value":"actionTstampTx"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"selectedFields"}},{"kind":"Field","name":{"kind":"Name","value":"affectedId"}},{"kind":"Field","name":{"kind":"Name","value":"loggedActionContext"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<GetEmployeeLogsQuery, GetEmployeeLogsQueryVariables>;
export const GetStorageLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStorageLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"argSearchString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LogEntryFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getStorageLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"argStorageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"argOrderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"argSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"argSearchString"}}},{"kind":"Argument","name":{"kind":"Name","value":"argFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"argTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LogEntry"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LogEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LogEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowData"}},{"kind":"Field","name":{"kind":"Name","value":"changedFields"}},{"kind":"Field","name":{"kind":"Name","value":"loggedAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"schemaName"}},{"kind":"Field","name":{"kind":"Name","value":"tableName"}},{"kind":"Field","name":{"kind":"Name","value":"actionTstampTx"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"selectedFields"}},{"kind":"Field","name":{"kind":"Name","value":"affectedId"}},{"kind":"Field","name":{"kind":"Name","value":"loggedActionContext"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<GetStorageLogsQuery, GetStorageLogsQueryVariables>;
export const GetPreboardingEmployeeLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPreboardingEmployeeLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingEmployeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"argSearchString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LogEntryFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPreboardingEmployeeLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"argPreboardingEmployeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingEmployeeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"argOrderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"argSearch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"argSearchString"}}},{"kind":"Argument","name":{"kind":"Name","value":"argFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"argTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LogEntry"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LogEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LogEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowData"}},{"kind":"Field","name":{"kind":"Name","value":"changedFields"}},{"kind":"Field","name":{"kind":"Name","value":"loggedAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"schemaName"}},{"kind":"Field","name":{"kind":"Name","value":"tableName"}},{"kind":"Field","name":{"kind":"Name","value":"actionTstampTx"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"selectedFields"}},{"kind":"Field","name":{"kind":"Name","value":"affectedId"}},{"kind":"Field","name":{"kind":"Name","value":"loggedActionContext"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<GetPreboardingEmployeeLogsQuery, GetPreboardingEmployeeLogsQueryVariables>;
export const GetWorkHoursLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWorkHoursLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWorkHoursLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"argUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"argOrderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"argFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"argTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"loggedActionContext"}},{"kind":"Field","name":{"kind":"Name","value":"actionTstampTx"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetWorkHoursLogsQuery, GetWorkHoursLogsQueryVariables>;
export const MainMenuBadgesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"mainMenuBadges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangelogFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changelogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"RELEASE_DATE_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"changelogUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"FIELD_UPDATE"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"futureDatumByApprovalId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"approvalIsRequired"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"hasBeenApproved"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"hasBeenDenied"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"VACATION"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"vacationUserByApprovalId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"vacationType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mustBeApproved"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"hasBeenApproved"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"hasBeenDenied"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<MainMenuBadgesQuery, MainMenuBadgesQueryVariables>;
export const NotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"notification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Notification"}},{"kind":"Field","name":{"kind":"Name","value":"notificationCustomRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notificationGroupRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notificationCustomEmployeeFieldRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Notification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Notification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notificationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"hookId"}},{"kind":"Field","name":{"kind":"Name","value":"hookName"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"localizedText"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastTime"}},{"kind":"Field","name":{"kind":"Name","value":"channelTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NotificationQuery, NotificationQueryVariables>;
export const AllNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationsOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Notification"}},{"kind":"Field","name":{"kind":"Name","value":"notificationCustomRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notificationGroupRecipients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"scopeName"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Notification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Notification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notificationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"hookId"}},{"kind":"Field","name":{"kind":"Name","value":"hookName"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"localizedText"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastTime"}},{"kind":"Field","name":{"kind":"Name","value":"channelTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllNotificationsQuery, AllNotificationsQueryVariables>;
export const AllNotificationTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allNotificationTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationTypesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationTypeFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"avoidBundling"}},{"kind":"Field","name":{"kind":"Name","value":"channelTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AllNotificationTypesQuery, AllNotificationTypesQueryVariables>;
export const NotificationTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"notificationType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationType"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"avoidBundling"}},{"kind":"Field","name":{"kind":"Name","value":"channelTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<NotificationTypeQuery, NotificationTypeQueryVariables>;
export const NotificationTypesInputFieldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"notificationTypesInputField"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationTypeFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"NAME_ASC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<NotificationTypesInputFieldQuery, NotificationTypesInputFieldQueryVariables>;
export const AllEmployeeNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allEmployeeNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationEmployeeFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CREATED_AT_DESC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationEmployee"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationEmployee"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationEmployee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"placeholderValues"}},{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"localizedText"}},{"kind":"Field","name":{"kind":"Name","value":"hook"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"references"},"name":{"kind":"Name","value":"notificationEmployeeReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"object"}},{"kind":"Field","name":{"kind":"Name","value":"editedFields"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<AllEmployeeNotificationsQuery, AllEmployeeNotificationsQueryVariables>;
export const UnreadNotificationsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"unreadNotificationsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"read"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>;
export const AllChannelTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allChannelTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllChannelTypesQuery, AllChannelTypesQueryVariables>;
export const ContractPredefinedPlaceholderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contractPredefinedPlaceholder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractPredefinedPlaceholdersOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractPredefinedPlaceholderFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractPredefinedPlaceholders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"argLocale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}]},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ContractPredefinedPlaceholderQuery, ContractPredefinedPlaceholderQueryVariables>;
export const PostTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"postTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostTypesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PostTypeFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<PostTypesQuery, PostTypesQueryVariables>;
export const PostTypeByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"postTypeById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sharedUsers"}},{"kind":"Field","name":{"kind":"Name","value":"sharedDepartments"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}}]} as unknown as DocumentNode<PostTypeByIdQuery, PostTypeByIdQueryVariables>;
export const AffectedPostsCountOnPostTypeDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"affectedPostsCountOnPostTypeDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedPostsCountOnPostTypeDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"postTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postTypeId"}}}]}]}}]} as unknown as DocumentNode<AffectedPostsCountOnPostTypeDeleteQuery, AffectedPostsCountOnPostTypeDeleteQueryVariables>;
export const PreboardingsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingEmployeesFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingEmployeeFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"predecessorId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"useWorkEmail"}},{"kind":"Field","name":{"kind":"Name","value":"linkButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"hasHandSignatureField"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}},{"kind":"Field","name":{"kind":"Name","value":"closeAccess"}},{"kind":"Field","name":{"kind":"Name","value":"reminderDays"}},{"kind":"Field","name":{"kind":"Name","value":"assigneeCount"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientCustomEmployeeFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerEmployeeFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"smsBody"}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"isUncategorized"}},{"kind":"Field","name":{"kind":"Name","value":"predecessor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingProcesses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingEmployeesFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"USER_BY_USER_ID__FIRST_NAME_ASC"},{"kind":"EnumValue","value":"USER_BY_USER_ID__LAST_NAME_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"DEPARTMENT_BY_DEPARTMENT_ID__NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<PreboardingsQueryQuery, PreboardingsQueryQueryVariables>;
export const PreboardingQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Preboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Preboarding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Preboarding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"predecessorId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"fontSize"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"useContentColors"}},{"kind":"Field","name":{"kind":"Name","value":"contentBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"contentTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"logoWidth"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"nextButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"prevButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"logoType"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"smsBody"}},{"kind":"Field","name":{"kind":"Name","value":"linkButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"useCustomLinkButtonColor"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackText"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}},{"kind":"Field","name":{"kind":"Name","value":"confirmResults"}},{"kind":"Field","name":{"kind":"Name","value":"useLeader"}},{"kind":"Field","name":{"kind":"Name","value":"useWorkEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"closeAccess"}},{"kind":"Field","name":{"kind":"Name","value":"reminderDays"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipientCustomEmployeeFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerEmployeeFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontStorage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fontType"}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}}]}}]} as unknown as DocumentNode<PreboardingQueryQuery, PreboardingQueryQueryVariables>;
export const PreboardingEmployeeQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingEmployeeQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployeeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingEmployee"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Preboarding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Preboarding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"predecessorId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"fontSize"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"useContentColors"}},{"kind":"Field","name":{"kind":"Name","value":"contentBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"contentTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"logoWidth"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"nextButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"prevButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"logoType"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"smsBody"}},{"kind":"Field","name":{"kind":"Name","value":"linkButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"useCustomLinkButtonColor"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackText"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}},{"kind":"Field","name":{"kind":"Name","value":"confirmResults"}},{"kind":"Field","name":{"kind":"Name","value":"useLeader"}},{"kind":"Field","name":{"kind":"Name","value":"useWorkEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"closeAccess"}},{"kind":"Field","name":{"kind":"Name","value":"reminderDays"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipientCustomEmployeeFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerEmployeeFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontStorage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fontType"}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingEmployee"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingEmployee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"conclusion"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completedReminded"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"isLeader"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Preboarding"}}]}}]}}]} as unknown as DocumentNode<PreboardingEmployeeQueryQuery, PreboardingEmployeeQueryQueryVariables>;
export const PreboardingEmployeesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingEmployeesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingEmployeesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingEmployeeFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeUser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"conclusion"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completedReminded"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingProcesses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeUser"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<PreboardingEmployeesQueryQuery, PreboardingEmployeesQueryQueryVariables>;
export const PreboardingStatisticsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingStatisticsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingResultFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"leaderDepartments"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PreboardingStatisticsQueryQuery, PreboardingStatisticsQueryQueryVariables>;
export const PreboardingResultQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingResultQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingResultFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PreboardingResultQueryQuery, PreboardingResultQueryQueryVariables>;
export const PreboardingEmailLogQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingEmailLogQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingEmailLogsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingEmailLogFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingEmailLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"fromEmployee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PreboardingEmailLogQueryQuery, PreboardingEmailLogQueryQueryVariables>;
export const PreboardingSlideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingSlide"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}}]}}]}}]} as unknown as DocumentNode<PreboardingSlideQuery, PreboardingSlideQueryVariables>;
export const PreboardingCommentsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingCommentsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingResultSlideCommentFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingResultSlideComments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingResultSlideComment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingResultSlideComment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingResultSlideComment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideId"}},{"kind":"Field","name":{"kind":"Name","value":"edited"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<PreboardingCommentsQueryQuery, PreboardingCommentsQueryQueryVariables>;
export const PreboardingSlideCommentCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingSlideCommentCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingSlideId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingResultId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingResultSlideComments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingSlideId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingResultId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingResultId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<PreboardingSlideCommentCountQuery, PreboardingSlideCommentCountQueryVariables>;
export const PreboardingStatusQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingStatusQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assigneeCount"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAssigneeCount"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<PreboardingStatusQueryQuery, PreboardingStatusQueryQueryVariables>;
export const GoogleFontsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GoogleFonts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GoogleFonts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fontFamilies"}}]}}]}}]} as unknown as DocumentNode<GoogleFontsQuery, GoogleFontsQueryVariables>;
export const PageDescriptionVariablesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pageDescriptionVariablesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"objectType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"employee","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<PageDescriptionVariablesQueryQuery, PageDescriptionVariablesQueryQueryVariables>;
export const PreboardingProcessesByProcessIdAndPreboardingIdQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingProcessesByProcessIdAndPreboardingIdQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingProcessByPreboardingIdAndProcessId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"processId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processId"}}},{"kind":"Argument","name":{"kind":"Name","value":"preboardingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingProcess"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Preboarding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Preboarding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"predecessorId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"fontSize"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"useContentColors"}},{"kind":"Field","name":{"kind":"Name","value":"contentBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"contentTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"logoWidth"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"nextButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"prevButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"logoType"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"smsBody"}},{"kind":"Field","name":{"kind":"Name","value":"linkButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"useCustomLinkButtonColor"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackText"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}},{"kind":"Field","name":{"kind":"Name","value":"confirmResults"}},{"kind":"Field","name":{"kind":"Name","value":"useLeader"}},{"kind":"Field","name":{"kind":"Name","value":"useWorkEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"closeAccess"}},{"kind":"Field","name":{"kind":"Name","value":"reminderDays"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipientCustomEmployeeFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerEmployeeFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontStorage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fontType"}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingProcess"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingProcess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Preboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"sendDate"}},{"kind":"Field","name":{"kind":"Name","value":"sendTime"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminder"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminderDate"}}]}}]} as unknown as DocumentNode<PreboardingProcessesByProcessIdAndPreboardingIdQueryQuery, PreboardingProcessesByProcessIdAndPreboardingIdQueryQueryVariables>;
export const PreboardingProcessesByProcessIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingProcessesByProcessId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingProcesses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"processId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingProcess"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Preboarding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Preboarding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"predecessorId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"fontSize"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"useContentColors"}},{"kind":"Field","name":{"kind":"Name","value":"contentBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"contentTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"logoWidth"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"nextButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"prevButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"logoType"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"smsBody"}},{"kind":"Field","name":{"kind":"Name","value":"linkButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"useCustomLinkButtonColor"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackText"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}},{"kind":"Field","name":{"kind":"Name","value":"confirmResults"}},{"kind":"Field","name":{"kind":"Name","value":"useLeader"}},{"kind":"Field","name":{"kind":"Name","value":"useWorkEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"closeAccess"}},{"kind":"Field","name":{"kind":"Name","value":"reminderDays"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipientCustomEmployeeFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerEmployeeFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontStorage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fontType"}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingProcess"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingProcess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Preboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"sendDate"}},{"kind":"Field","name":{"kind":"Name","value":"sendTime"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminder"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminderDate"}}]}}]} as unknown as DocumentNode<PreboardingProcessesByProcessIdQuery, PreboardingProcessesByProcessIdQueryVariables>;
export const PreboardingProcessesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingProcessesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingProcessFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeRelations"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingProcesses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingProcess"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeRelations"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Preboarding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Preboarding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"predecessorId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"fontSize"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"useContentColors"}},{"kind":"Field","name":{"kind":"Name","value":"contentBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"contentTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"logoWidth"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"nextButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"prevButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"logoType"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"smsBody"}},{"kind":"Field","name":{"kind":"Name","value":"linkButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"useCustomLinkButtonColor"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackText"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}},{"kind":"Field","name":{"kind":"Name","value":"confirmResults"}},{"kind":"Field","name":{"kind":"Name","value":"useLeader"}},{"kind":"Field","name":{"kind":"Name","value":"useWorkEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"closeAccess"}},{"kind":"Field","name":{"kind":"Name","value":"reminderDays"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipientCustomEmployeeFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerEmployeeFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontStorage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fontType"}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingProcess"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingProcess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Preboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"sendDate"}},{"kind":"Field","name":{"kind":"Name","value":"sendTime"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminder"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminderDate"}}]}}]} as unknown as DocumentNode<PreboardingProcessesQueryQuery, PreboardingProcessesQueryQueryVariables>;
export const OngoingPreboardingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ongoingPreboardings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboarding"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"anonymous"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OngoingPreboardingsQuery, OngoingPreboardingsQueryVariables>;
export const FinishedPreboardingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"finishedPreboardings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboarding"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"anonymous"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FinishedPreboardingsQuery, FinishedPreboardingsQueryVariables>;
export const PreboardingFormCacheByPreboardingIdAndUserIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingFormCacheByPreboardingIdAndUserId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingFormCacheByPreboardingIdAndUserId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preboardingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formValues"}},{"kind":"Field","name":{"kind":"Name","value":"page"}}]}}]}}]} as unknown as DocumentNode<PreboardingFormCacheByPreboardingIdAndUserIdQuery, PreboardingFormCacheByPreboardingIdAndUserIdQueryVariables>;
export const ExportPreboardingResultsToExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"exportPreboardingResultsToExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDepartments"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportPreboardingResultsToExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeDepartments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDepartments"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]} as unknown as DocumentNode<ExportPreboardingResultsToExcelQuery, ExportPreboardingResultsToExcelQueryVariables>;
export const EmployeePreboardingCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeePreboardingCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagementTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","alias":{"kind":"Name","value":"ongoingCount"},"name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboarding"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"anonymous"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"finishedCount"},"name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboarding"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"anonymous"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"uncategorizedOngoingCount"},"name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboarding"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isUncategorized"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"anonymous"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"uncategorizedFinishedCount"},"name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboarding"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isUncategorized"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"anonymous"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<EmployeePreboardingCountsQuery, EmployeePreboardingCountsQueryVariables>;
export const PreboardingsFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingsFilter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"template"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingEmployees"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PreboardingsFilterQuery, PreboardingsFilterQueryVariables>;
export const PreboardingBasicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingBasic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypeId"}}]}}]}}]} as unknown as DocumentNode<PreboardingBasicQuery, PreboardingBasicQueryVariables>;
export const PreboardingEmployeeByPreboardingIdAndEmployeeIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingEmployeeByPreboardingIdAndEmployeeId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<PreboardingEmployeeByPreboardingIdAndEmployeeIdQuery, PreboardingEmployeeByPreboardingIdAndEmployeeIdQueryVariables>;
export const PreboardingWidgetQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingWidgetQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingEmployeesOrderBy"}}}},"defaultValue":{"kind":"EnumValue","value":"DEADLINE_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboarding"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deadline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deadline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"recipientId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"recipientId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PreboardingWidgetQueryQuery, PreboardingWidgetQueryQueryVariables>;
export const PreboardingFormQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingFormQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingEmployeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployeeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingEmployeeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"conclusion"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"hasLogo"}},{"kind":"Field","name":{"kind":"Name","value":"initialsLogo"}}]}}]}}]}}]} as unknown as DocumentNode<PreboardingFormQueryQuery, PreboardingFormQueryQueryVariables>;
export const PreboardingLocaleByPreboardingEmployeeIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingLocaleByPreboardingEmployeeId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingEmployeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployeeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingEmployeeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}}]}}]} as unknown as DocumentNode<PreboardingLocaleByPreboardingEmployeeIdQuery, PreboardingLocaleByPreboardingEmployeeIdQueryVariables>;
export const PreboardingFormFormFieldsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingFormFormFieldsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFields"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preboardingId"}}}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}}]} as unknown as DocumentNode<PreboardingFormFormFieldsQueryQuery, PreboardingFormFormFieldsQueryQueryVariables>;
export const PreboardingFormSubmitCheckApprovalFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"preboardingFormSubmitCheckApprovalFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFieldIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldNames"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"changesMustBeApproved"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFieldIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"changesMustBeApproved"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"systemField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemFieldNames"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PreboardingFormSubmitCheckApprovalFieldsQuery, PreboardingFormSubmitCheckApprovalFieldsQueryVariables>;
export const AllProcessTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allProcessTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProcessTypesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProcessTypeFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<AllProcessTypesQuery, AllProcessTypesQueryVariables>;
export const ProcessTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"processType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProcessTypeQuery, ProcessTypeQueryVariables>;
export const ProcessesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"processesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProcessFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"template"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cutoffDay"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"taskCount"}},{"kind":"Field","name":{"kind":"Name","value":"projectCount"}},{"kind":"Field","name":{"kind":"Name","value":"messageCount"}},{"kind":"Field","name":{"kind":"Name","value":"appCount"}},{"kind":"Field","name":{"kind":"Name","value":"processType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProcessesQueryQuery, ProcessesQueryQueryVariables>;
export const ProcessesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"processes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProcessFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"template"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"processTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"processType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Project"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Task"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduledMessage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingProcesses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingProcess"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Task"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminderDate"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"parentTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventFrom"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventTo"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventOrganizerId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"parentTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"processTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleResponsibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskResponsibles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduledMessage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"senderEmployeeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"sendDate"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageExternalRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Preboarding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Preboarding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"predecessorId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"fontSize"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"useContentColors"}},{"kind":"Field","name":{"kind":"Name","value":"contentBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"contentTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"logoWidth"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"nextButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"prevButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"logoType"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"smsBody"}},{"kind":"Field","name":{"kind":"Name","value":"linkButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"useCustomLinkButtonColor"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackText"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}},{"kind":"Field","name":{"kind":"Name","value":"confirmResults"}},{"kind":"Field","name":{"kind":"Name","value":"useLeader"}},{"kind":"Field","name":{"kind":"Name","value":"useWorkEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"closeAccess"}},{"kind":"Field","name":{"kind":"Name","value":"reminderDays"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipientCustomEmployeeFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerEmployeeFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontStorage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fontType"}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Task"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduledMessage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingProcess"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingProcess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Preboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"sendDate"}},{"kind":"Field","name":{"kind":"Name","value":"sendTime"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminder"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminderDate"}}]}}]} as unknown as DocumentNode<ProcessesQuery, ProcessesQueryVariables>;
export const EmployeeProcessesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"employeeProcesses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProcessesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProcessFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"template"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserDepartments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"processType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<EmployeeProcessesQuery, EmployeeProcessesQueryVariables>;
export const ProcessesOrderedByProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"processesOrderedByProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"direction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProcessFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processesOrderedByProgress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"direction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"direction"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserDepartments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"processType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ProcessesOrderedByProgressQuery, ProcessesOrderedByProgressQueryVariables>;
export const GetProcessGraphileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProcessGraphile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Process"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Task"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminderDate"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"parentTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventFrom"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventTo"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventOrganizerId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"parentTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"processTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleResponsibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskResponsibles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduledMessage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"senderEmployeeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"sendDate"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageExternalRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Task"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduledMessage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"customId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"agreementText"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAgreementText"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"multiple"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"departmentTypeIds"}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldsByParentFormFieldId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"predefined"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formFieldAgreementByFormFieldId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlideFormField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlideFormField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"systemField"},"name":{"kind":"Name","value":"systemFieldName"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingSlide"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingSlide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addReviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlideFormFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"formField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preboardingSlideFormFieldIdParent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlideFormField"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Preboarding"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Preboarding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"managerIds"}},{"kind":"Field","name":{"kind":"Name","value":"predecessorId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"fontSize"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"textColor"}},{"kind":"Field","name":{"kind":"Name","value":"useContentColors"}},{"kind":"Field","name":{"kind":"Name","value":"contentBackgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"contentTextColor"}},{"kind":"Field","name":{"kind":"Name","value":"logoWidth"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"firstSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"lastSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideName"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideDescription"}},{"kind":"Field","name":{"kind":"Name","value":"overviewSlideEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"nextButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"prevButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"logoType"}},{"kind":"Field","name":{"kind":"Name","value":"emailSubject"}},{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"smsBody"}},{"kind":"Field","name":{"kind":"Name","value":"linkButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"useCustomLinkButtonColor"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackText"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"disable2Fa"}},{"kind":"Field","name":{"kind":"Name","value":"confirmResults"}},{"kind":"Field","name":{"kind":"Name","value":"useLeader"}},{"kind":"Field","name":{"kind":"Name","value":"useWorkEmail"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"closeAccess"}},{"kind":"Field","name":{"kind":"Name","value":"reminderDays"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipientCustomEmployeeFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerEmployeeFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"defaultManagerDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontStorage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fontType"}},{"kind":"Field","name":{"kind":"Name","value":"departments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingSlides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingSlide"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagementTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PreboardingProcess"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreboardingProcess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preboardingId"}},{"kind":"Field","name":{"kind":"Name","value":"preboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Preboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"sendDate"}},{"kind":"Field","name":{"kind":"Name","value":"sendTime"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminder"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminderDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminder"}},{"kind":"Field","name":{"kind":"Name","value":"useCalendarEvent"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventFrom"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventTo"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventOrganizerId"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployee"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployeeResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManagerResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFields"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFieldsResponsibles"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroups"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroupsResponsibles"}},{"kind":"Field","name":{"kind":"Name","value":"parentTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"parentTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleResponsibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplateResponsibles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"responsible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplateEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employee"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduledMessageTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployee"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroups"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFields"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"sendTime"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateExternalRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplatesByProjectId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskTemplate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplatesByProjectId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduledMessageTemplate"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Process"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Process"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"processTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"cutoffDay"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"taskCount"}},{"kind":"Field","name":{"kind":"Name","value":"projectCount"}},{"kind":"Field","name":{"kind":"Name","value":"messageCount"}},{"kind":"Field","name":{"kind":"Name","value":"appCount"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUserDepartments"}},{"kind":"Field","name":{"kind":"Name","value":"processType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Project"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Task"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduledMessage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preboardingProcesses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreboardingProcess"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTemplate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskTemplate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduledMessageTemplate"}}]}}]}}]}}]} as unknown as DocumentNode<GetProcessGraphileQuery, GetProcessGraphileQueryVariables>;
export const OngoingProcessesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ongoingProcesses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OngoingProcessesQuery, OngoingProcessesQueryVariables>;
export const FinishedProcessesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"finishedProcesses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FinishedProcessesQuery, FinishedProcessesQueryVariables>;
export const ProjectByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"projectById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Project"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Task"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminderDate"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"parentTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventFrom"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventTo"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventOrganizerId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"parentTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"processTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleResponsibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskResponsibles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduledMessage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"senderEmployeeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"sendDate"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageExternalRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Task"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduledMessage"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectByIdQuery, ProjectByIdQueryVariables>;
export const ProjectTemplateByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"projectTemplateById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectTemplateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectTemplate"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminder"}},{"kind":"Field","name":{"kind":"Name","value":"useCalendarEvent"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventFrom"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventTo"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventOrganizerId"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployee"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployeeResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManagerResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFields"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFieldsResponsibles"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroups"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroupsResponsibles"}},{"kind":"Field","name":{"kind":"Name","value":"parentTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"parentTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleResponsibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplateResponsibles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"responsible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplateEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employee"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduledMessageTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployee"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroups"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFields"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"sendTime"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateExternalRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProjectTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplatesByProjectId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskTemplate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplatesByProjectId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduledMessageTemplate"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectTemplateByIdQuery, ProjectTemplateByIdQueryVariables>;
export const PulseSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pulseSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pulseSurveyById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"questionType"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"questionTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"localizedQuestion"}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"surveyTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"isDraft"}},{"kind":"Field","name":{"kind":"Name","value":"horizontal"}},{"kind":"Field","name":{"kind":"Name","value":"ratingType"}},{"kind":"Field","name":{"kind":"Name","value":"invitedAll"}},{"kind":"Field","name":{"kind":"Name","value":"invitedUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"invitedDepartmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfRecipients"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfRecipientsLastYear"}},{"kind":"Field","name":{"kind":"Name","value":"lowestRating"}},{"kind":"Field","name":{"kind":"Name","value":"highestRating"}},{"kind":"Field","name":{"kind":"Name","value":"lowestRatingLabel"}},{"kind":"Field","name":{"kind":"Name","value":"lowestRatingLabelTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"highestRatingLabel"}},{"kind":"Field","name":{"kind":"Name","value":"highestRatingLabelTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingThisMonth"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingThisMonthLastYear"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingAllTime"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingAllTimeLastYear"}},{"kind":"Field","name":{"kind":"Name","value":"reminders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minutes"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pulseTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"pulseType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recurrenceRuleByPulseSurveyId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfMonth"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pulseSurveyChoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}}]} as unknown as DocumentNode<PulseSurveyQuery, PulseSurveyQueryVariables>;
export const PulseSurveySidebarDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pulseSurveySidebarData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pulseSurveyById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedQuestion"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"surveyTime"}},{"kind":"Field","name":{"kind":"Name","value":"isDraft"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfRecipients"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfAnswersCollected"}},{"kind":"Field","name":{"kind":"Name","value":"readableQuestionType"}},{"kind":"Field","name":{"kind":"Name","value":"pulseType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deadline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reminders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recurrenceRuleByPulseSurveyId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfMonth"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfYear"}}]}}]}}]}}]} as unknown as DocumentNode<PulseSurveySidebarDataQuery, PulseSurveySidebarDataQueryVariables>;
export const PulseSurveyAnswerPageDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pulseSurveyAnswerPageData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pulseSurveyById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questionType"}},{"kind":"Field","name":{"kind":"Name","value":"localizedQuestion"}},{"kind":"Field","name":{"kind":"Name","value":"horizontal"}},{"kind":"Field","name":{"kind":"Name","value":"ratingType"}},{"kind":"Field","name":{"kind":"Name","value":"localizedLowestRatingLabel"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHighestRatingLabel"}},{"kind":"Field","name":{"kind":"Name","value":"highestRating"}},{"kind":"Field","name":{"kind":"Name","value":"ratingType"}},{"kind":"Field","name":{"kind":"Name","value":"isOpenForAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"pulseSurveyChoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PulseSurveyAnswerPageDataQuery, PulseSurveyAnswerPageDataQueryVariables>;
export const PulseSurveyCompletionPercentageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pulseSurveyCompletionPercentage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pulseSurveyById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completionPercentage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}]}}]}}]} as unknown as DocumentNode<PulseSurveyCompletionPercentageQuery, PulseSurveyCompletionPercentageQueryVariables>;
export const GetPulseSurveyChartDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPulseSurveyChartData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"truncTo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPulseSurveyChartData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pulseSurveyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"truncTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"truncTo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"average"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfAnswers"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pulseSurveyById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questionType"}},{"kind":"Field","name":{"kind":"Name","value":"lowestRating"}},{"kind":"Field","name":{"kind":"Name","value":"highestRating"}},{"kind":"Field","name":{"kind":"Name","value":"pulseSurveyChoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ORDER_DESC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"localizedText"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPulseSurveyChartDataQuery, GetPulseSurveyChartDataQueryVariables>;
export const PulseSurveysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pulseSurveys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PulseSurveyFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pulseSurveys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PulseSurveyListItem"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PulseSurveyListItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PulseSurvey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"questionType"}},{"kind":"Field","name":{"kind":"Name","value":"localizedQuestion"}},{"kind":"Field","name":{"kind":"Name","value":"anonymous"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"surveyTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"isDraft"}},{"kind":"Field","name":{"kind":"Name","value":"highestRating"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingAllTime"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingThisMonth"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingThisMonthLastYear"}},{"kind":"Field","name":{"kind":"Name","value":"averageRatingAllTimeLastYear"}},{"kind":"Field","name":{"kind":"Name","value":"invitedAll"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pulseType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pulseSurveyChoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ORDER_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}}]}}]}}]} as unknown as DocumentNode<PulseSurveysQuery, PulseSurveysQueryVariables>;
export const PulseTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pulseTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PulseTypesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PulseTypeFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pulseTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<PulseTypesQuery, PulseTypesQueryVariables>;
export const PulseTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pulseType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pulseTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}}]} as unknown as DocumentNode<PulseTypeQuery, PulseTypeQueryVariables>;
export const RoadmapItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"roadmapItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItemsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItemFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roadmapItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoadmapItemWithVotes"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItemWithVotes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoadmapItem"}},{"kind":"Field","name":{"kind":"Name","value":"needToHaveVoteCount"}},{"kind":"Field","name":{"kind":"Name","value":"niceToHaveVoteCount"}},{"kind":"Field","name":{"kind":"Name","value":"commentCount"}}]}}]} as unknown as DocumentNode<RoadmapItemsQuery, RoadmapItemsQueryVariables>;
export const RoadmapItemsByStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"roadmapItemsByStage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapStage"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItemsOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roadmapItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"stage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stage"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoadmapItem"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}}]}}]} as unknown as DocumentNode<RoadmapItemsByStageQuery, RoadmapItemsByStageQueryVariables>;
export const RoadmapItemByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"roadmapItemById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roadmapItemById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoadmapItemWithVotes"}},{"kind":"Field","name":{"kind":"Name","value":"roadmapItemLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItemWithVotes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoadmapItem"}},{"kind":"Field","name":{"kind":"Name","value":"needToHaveVoteCount"}},{"kind":"Field","name":{"kind":"Name","value":"niceToHaveVoteCount"}},{"kind":"Field","name":{"kind":"Name","value":"commentCount"}}]}}]} as unknown as DocumentNode<RoadmapItemByIdQuery, RoadmapItemByIdQueryVariables>;
export const RoadmapItemVoteByUserIdAndRoadmapItemIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"roadmapItemVoteByUserIdAndRoadmapItemId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roadmapItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roadmapItemVoteByUserIdAndRoadmapItemId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"roadmapItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roadmapItemId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoadmapItemVote"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItemVote"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItemVote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roadmapItemId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"voteType"}}]}}]} as unknown as DocumentNode<RoadmapItemVoteByUserIdAndRoadmapItemIdQuery, RoadmapItemVoteByUserIdAndRoadmapItemIdQueryVariables>;
export const GetVotersForItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getVotersForItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roadmapItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roadmapItemVotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roadmapItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roadmapItemId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoadmapItemVoteWithUserInfo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItemVote"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItemVote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roadmapItemId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"voteType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoadmapItemVoteWithUserInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItemVote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoadmapItemVote"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetVotersForItemQuery, GetVotersForItemQueryVariables>;
export const GetRoadmapItemCommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRoadmapItemComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roadmapItemId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roadmapItemComments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roadmapItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roadmapItemId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CREATED_AT_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roadmapItemId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRoadmapItemCommentsQuery, GetRoadmapItemCommentsQueryVariables>;
export const AllRoadmapCommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allRoadmapComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItemCommentsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RoadmapItemCommentFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roadmapItemComments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"roadmapItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<AllRoadmapCommentsQuery, AllRoadmapCommentsQueryVariables>;
export const UserRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userRoles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserRoleFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"excludeRole"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Role"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Role"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}},{"kind":"Field","name":{"kind":"Name","value":"usesItemIds"}}]}}]} as unknown as DocumentNode<UserRolesQuery, UserRolesQueryVariables>;
export const UserDepartmentRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userDepartmentRoles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserDepartmentRoleFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userDepartmentRoles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"excludeRole"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inheritToDescendants"}},{"kind":"Field","name":{"kind":"Name","value":"onlyIncludeInDescendants"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Role"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}},{"kind":"Field","name":{"kind":"Name","value":"usesItemIds"}}]}}]} as unknown as DocumentNode<UserDepartmentRolesQuery, UserDepartmentRolesQueryVariables>;
export const UserCompanyRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userCompanyRoles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCompanyRoleFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompanyRoles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"excludeRole"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Role"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Role"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"scopes"}},{"kind":"Field","name":{"kind":"Name","value":"usesItemIds"}}]}}]} as unknown as DocumentNode<UserCompanyRolesQuery, UserCompanyRolesQueryVariables>;
export const ScheduledMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"scheduledMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeRelations"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduledMessage"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeRelations"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeRelations"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduledMessage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"senderEmployeeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"sendDate"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageExternalRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}}]} as unknown as DocumentNode<ScheduledMessagesQuery, ScheduledMessagesQueryVariables>;
export const ScheduledMessageTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"scheduledMessageTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageTemplateFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeRelations"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduledMessageTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeRelations"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeRelations"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduledMessageTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployee"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroups"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFields"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"sendTime"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateExternalRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}}]} as unknown as DocumentNode<ScheduledMessageTemplatesQuery, ScheduledMessageTemplatesQueryVariables>;
export const ScheduledMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"scheduledMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduledMessage"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduledMessage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"senderEmployeeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"sendDate"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageExternalRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}}]} as unknown as DocumentNode<ScheduledMessageQuery, ScheduledMessageQueryVariables>;
export const ScheduledMessageTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"scheduledMessageTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduledMessageTemplate"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduledMessageTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduledMessageTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployee"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroups"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFields"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"sendTime"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateExternalRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledMessageTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}}]} as unknown as DocumentNode<ScheduledMessageTemplateQuery, ScheduledMessageTemplateQueryVariables>;
export const FileIdToUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fileIdToUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storageIdToDirectUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<FileIdToUrlQuery, FileIdToUrlQueryVariables>;
export const SystemFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"systemFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SystemFieldFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getUserData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"systemFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"readableName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"readOnly"}},{"kind":"Field","name":{"kind":"Name","value":"documentTemplatePlaceholderName"}},{"kind":"Field","name":{"kind":"Name","value":"excludeFromPlaceholderForm"}},{"kind":"Field","name":{"kind":"Name","value":"alwaysRequired"}},{"kind":"Field","name":{"kind":"Name","value":"userSystemFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getUserData"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"humanReadableValue"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companySystemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"localizedAlias"}},{"kind":"Field","name":{"kind":"Name","value":"localizedHelpText"}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"localizedValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}]}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SystemFieldsQuery, SystemFieldsQueryVariables>;
export const CompanySystemFieldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"companySystemField"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companySystemFieldById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sensitive"}},{"kind":"Field","name":{"kind":"Name","value":"changesMustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"supportsFutureData"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueValue"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"fieldGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"aliasTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"helpTextTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"excludedRoleIds"}},{"kind":"Field","name":{"kind":"Name","value":"systemField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"readableName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companySystemFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ORDER_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}}]} as unknown as DocumentNode<CompanySystemFieldQuery, CompanySystemFieldQueryVariables>;
export const CompanySystemFieldOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"companySystemFieldOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companySystemFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CompanySystemFieldOptionsQuery, CompanySystemFieldOptionsQueryVariables>;
export const JobPositionTypeOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"jobPositionTypeOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companySystemFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companySystemField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"job_position_type","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"localizedValue"}}]}}]}}]}}]}}]} as unknown as DocumentNode<JobPositionTypeOptionsQuery, JobPositionTypeOptionsQueryVariables>;
export const JobPositionWorkingHoursOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"jobPositionWorkingHoursOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companySystemFieldOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companySystemField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"systemField"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"job_position_working_hours","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"localizedValue"}}]}}]}}]}}]}}]} as unknown as DocumentNode<JobPositionWorkingHoursOptionsQuery, JobPositionWorkingHoursOptionsQueryVariables>;
export const UserSystemFieldCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userSystemFieldCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSystemFieldCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"argEmployeeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userDepartmentCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"argEmployeeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}}}]}]}}]} as unknown as DocumentNode<UserSystemFieldCountQuery, UserSystemFieldCountQueryVariables>;
export const UserSystemFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userSystemFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSystemFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"systemFieldId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"NullValue"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeByUserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"systemFieldId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]}}]} as unknown as DocumentNode<UserSystemFieldsQuery, UserSystemFieldsQueryVariables>;
export const TaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"task"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taskById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Task"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Task"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminderDate"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"parentTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventFrom"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventTo"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventOrganizerId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"parentTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"processTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleResponsibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskResponsibles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}}]} as unknown as DocumentNode<TaskQuery, TaskQueryVariables>;
export const TaskTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"taskTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taskTemplateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskTemplate"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TaskTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminder"}},{"kind":"Field","name":{"kind":"Name","value":"useCalendarEvent"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventFrom"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventTo"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventOrganizerId"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployee"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManager"}},{"kind":"Field","name":{"kind":"Name","value":"includeEmployeeResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"includeDirectManagerResponsible"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFields"}},{"kind":"Field","name":{"kind":"Name","value":"includeCustomEmployeeFieldsResponsibles"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroups"}},{"kind":"Field","name":{"kind":"Name","value":"includeGroupsResponsibles"}},{"kind":"Field","name":{"kind":"Name","value":"parentTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"parentTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"startDay"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleResponsibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplateResponsibles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"responsible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskTemplateEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employee"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}}]} as unknown as DocumentNode<TaskTemplateQuery, TaskTemplateQueryVariables>;
export const TaskNotesMappingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"taskNotesMappings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignedToIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responsibleIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"assignedTo"},"name":{"kind":"Name","value":"employees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignedToIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"responsibles"},"name":{"kind":"Name","value":"employees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responsibleIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TaskNotesMappingsQuery, TaskNotesMappingsQueryVariables>;
export const TasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeRelations"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TasksOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Task"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeRelations"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"simpleUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeRelations"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Task"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineReminderDate"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"parentTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventFrom"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventTo"}},{"kind":"Field","name":{"kind":"Name","value":"calendarEventOrganizerId"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"userIds"}},{"kind":"Field","name":{"kind":"Name","value":"parentTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"processId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"process"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"processTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"simpleResponsibles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskResponsibles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taskEmployees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]}}]} as unknown as DocumentNode<TasksQuery, TasksQueryVariables>;
export const TaskCompletedByDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"taskCompletedBy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taskById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userByCompletedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<TaskCompletedByQuery, TaskCompletedByQueryVariables>;
export const UpcomingTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"upcomingTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"taskEmployees"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeId"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UpcomingTasksQuery, UpcomingTasksQueryVariables>;
export const CurrentPresenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"currentPresence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationBreakType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CurrentPresenceQuery, CurrentPresenceQueryVariables>;
export const TimeRegistrationPresenceTypesAndProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationPresenceTypesAndProjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentTimeRegistrationPresenceTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentTimeRegistrationProjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationPresenceTypesAndProjectsQuery, TimeRegistrationPresenceTypesAndProjectsQueryVariables>;
export const TimeRegistrationSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProjectId"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationBreakTypeId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationSummaryQuery, TimeRegistrationSummaryQueryVariables>;
export const TimeRegistrationBreakTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationBreakTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationBreakTypesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationBreakTypeFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationBreakTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"paidTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationBreakTypesQuery, TimeRegistrationBreakTypesQueryVariables>;
export const TimeRegistrationBreakTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationBreakType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationBreakTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"nameTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"paidTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationBreakTypeQuery, TimeRegistrationBreakTypeQueryVariables>;
export const TimeRegistrationEntryByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationEntryById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntryById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntryType"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationBreakTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProjectId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationEntryByIdQuery, TimeRegistrationEntryByIdQueryVariables>;
export const TimeRegistrationWeekOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationWeekOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationWeekOverview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weekStart"}},{"kind":"Field","name":{"kind":"Name","value":"totalWorkTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalBreakTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationWeekOverviewQuery, TimeRegistrationWeekOverviewQueryVariables>;
export const TimeRegistrationDepartmentOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationDepartmentOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationDepartmentOverview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hoursThisWeek"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"numberOfEmployees"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfWarnings"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationDepartmentOverviewQuery, TimeRegistrationDepartmentOverviewQueryVariables>;
export const TimeRegistrationUserOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationUserOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationUserOverview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeRegistrationUserOverviewItem"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeRegistrationUserOverviewItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationUserOverviewRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"averageWeeklyHoursLastFourMonths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hoursThisWeek"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breaksThisWeek"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationUserOverviewQuery, TimeRegistrationUserOverviewQueryVariables>;
export const GetTimeRegistrationsInRangeForUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTimeRegistrationsInRangeForUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"START_DATE_DESC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeRegistrationTimesheetWeekItem"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeRegistrationTimesheetWeekItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationPresence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weekNumber"}},{"kind":"Field","name":{"kind":"Name","value":"weekStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"elapsedTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"restTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"compliesWithElevenHourRule"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"projects"},"name":{"kind":"Name","value":"timeRegistrationEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationEntryType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"PROJECT"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTimeRegistrationsInRangeForUserQuery, GetTimeRegistrationsInRangeForUserQueryVariables>;
export const GetTimeRegistrationEntriesForPresenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTimeRegistrationEntriesForPresence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationPresenceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationPresenceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationPresenceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"START_DATE_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeRegistrationTimesheetEntry"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeRegistrationTimesheetEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntryType"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"elapsedTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationBreakType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}}]}}]} as unknown as DocumentNode<GetTimeRegistrationEntriesForPresenceQuery, GetTimeRegistrationEntriesForPresenceQueryVariables>;
export const TimeRegistrationPresenceProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationPresenceProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationPresencesOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}]}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeRegistrationProfileItem"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"weeklyRegisteredTime"},"name":{"kind":"Name","value":"timeRegistrationRegisteredTime"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"truncTo"},"value":{"kind":"StringValue","value":"week","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"registeredTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"dailyRegisteredTime"},"name":{"kind":"Name","value":"timeRegistrationRegisteredTime"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}},{"kind":"Argument","name":{"kind":"Name","value":"truncTo"},"value":{"kind":"StringValue","value":"day","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"registeredTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"minutes"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeRegistrationProfileItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationPresence"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntryType"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationBreakType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationPresenceProfileQuery, TimeRegistrationPresenceProfileQueryVariables>;
export const TimeRegistrationsPendingApprovalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationsPendingApproval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationsPendingApproval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationsPendingApprovalQuery, TimeRegistrationsPendingApprovalQueryVariables>;
export const TimeRegistrationPresenceByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationPresenceById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationPresenceByIdQuery, TimeRegistrationPresenceByIdQueryVariables>;
export const TimeRegistrationPresenceTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationPresenceTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationTemplateWeekId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"DAY_OF_WEEK_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeRegistrationPresenceTemplate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationTemplateWeeks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"WEEK_INDEX_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weekIndex"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"DAY_OF_WEEK_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeRegistrationPresenceTemplate"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeRegistrationPresenceTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationPresenceTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntryTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntryType"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProjectId"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationBreakTypeId"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationPresenceTemplatesQuery, TimeRegistrationPresenceTemplatesQueryVariables>;
export const TimeRegistrationTemplatePresenceTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationTemplatePresenceTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationTemplateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeRegistrationTemplateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"useMultiWeek"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeRegistrationTemplateWeekId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"DAY_OF_WEEK_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeRegistrationPresenceTemplate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationTemplateWeeks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"WEEK_INDEX_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weekIndex"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"DAY_OF_WEEK_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimeRegistrationPresenceTemplate"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeRegistrationPresenceTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationPresenceTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntryTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationEntryType"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProjectId"}},{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationBreakTypeId"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationTemplatePresenceTemplatesQuery, TimeRegistrationTemplatePresenceTemplatesQueryVariables>;
export const TimeRegistrationPresenceTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationPresenceTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationPresenceTypesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationPresenceTypeFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationPresenceTypesQuery, TimeRegistrationPresenceTypesQueryVariables>;
export const TimeRegistrationPresenceTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationPresenceType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationPresenceTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationPresenceTypeQuery, TimeRegistrationPresenceTypeQueryVariables>;
export const TimeRegistrationProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationProjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationProjectsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationProjectFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"localizedDescription"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationProjectsQuery, TimeRegistrationProjectsQueryVariables>;
export const TimeRegistrationProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationProjectById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"nameTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationProjectQuery, TimeRegistrationProjectQueryVariables>;
export const TimeRegistrationTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationTemplatesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TimeRegistrationTemplateFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationTemplatesQuery, TimeRegistrationTemplatesQueryVariables>;
export const TimeRegistrationTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"timeRegistrationTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationTemplateById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameTranslatedEntity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranslatedEntityLocalizations"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranslatedEntityLocalizations"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranslatedEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedEntityLocalizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}}]}}]}}]}}]} as unknown as DocumentNode<TimeRegistrationTemplateQuery, TimeRegistrationTemplateQueryVariables>;
export const AllTranslationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allTranslations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TranslationFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"translation"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllTranslationsQuery, AllTranslationsQueryVariables>;
export const I18onDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"i18on"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"strings"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"i18on"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"strings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"strings"}}}]}}]}]}}]} as unknown as DocumentNode<I18onQuery, I18onQueryVariables>;
export const UserDepartmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userDepartments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserDepartmentsQuery, UserDepartmentsQueryVariables>;
export const UsersDepartmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"usersDepartments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UsersDepartmentsQuery, UsersDepartmentsQueryVariables>;
export const UserDepartmentHierarchyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userDepartmentHierarchy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentEmployeeHierarchy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"}}]}}]}}]} as unknown as DocumentNode<UserDepartmentHierarchyQuery, UserDepartmentHierarchyQueryVariables>;
export const UserDepartmentInheritedGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userDepartmentInheritedGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inheritedDepartmentGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserDepartmentInheritedGroupsQuery, UserDepartmentInheritedGroupsQueryVariables>;
export const UserGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserGroup"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeByUserId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<UserGroupsQuery, UserGroupsQueryVariables>;
export const UserDepartmentGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userDepartmentGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userDepartmentGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDepartmentGroup"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDepartmentGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserDepartmentGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"inheritToDescendants"}},{"kind":"Field","name":{"kind":"Name","value":"onlyIncludeInDescendants"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeByUserId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<UserDepartmentGroupsQuery, UserDepartmentGroupsQueryVariables>;
export const UserCompanyGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userCompanyGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCompanyGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCompanyGroup"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCompanyGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserCompanyGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employeeByUserId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<UserCompanyGroupsQuery, UserCompanyGroupsQueryVariables>;
export const UserOnBehalfPermissionsByUserIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userOnBehalfPermissionsByUserId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userOnBehalfPermissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserOnBehalfPermission"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserOnBehalfPermission"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserOnBehalfPermission"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUserId"}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"jobPositionTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}}]}}]} as unknown as DocumentNode<UserOnBehalfPermissionsByUserIdQuery, UserOnBehalfPermissionsByUserIdQueryVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const UserNamesByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userNamesByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<UserNamesByIdsQuery, UserNamesByIdsQueryVariables>;
export const GetUserByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"canSignOnBehalfOf"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userOnBehalfPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUserId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const UsersByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"usersByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailWork"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}},{"kind":"Field","name":{"kind":"Name","value":"canSignOnBehalfOf"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userOnBehalfPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"onBehalfOfUserId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UsersByIdsQuery, UsersByIdsQueryVariables>;
export const UsersInputFieldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"usersInputField"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selected"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orFilter"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilter"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withEmployeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUIDListFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterByIds"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUIDFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allUsers"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FIRST_NAME_ASC"},{"kind":"EnumValue","value":"LAST_NAME_ASC"},{"kind":"EnumValue","value":"ID_ASC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fullName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterByIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentsFilter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orFilter"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withEmployeeId"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"canSignOnBehalfOf"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"selectedUsers"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FIRST_NAME_ASC"},{"kind":"EnumValue","value":"LAST_NAME_ASC"},{"kind":"EnumValue","value":"ID_ASC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selected"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employeeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selected"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withEmployeeId"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<UsersInputFieldQuery, UsersInputFieldQueryVariables>;
export const UsersInputFieldSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"usersInputFieldSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selected"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orFilter"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilter"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withEmployeeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUIDListFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterByIds"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUIDFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allUsers"},"name":{"kind":"Name","value":"usersSearchName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"argSearchString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FIRST_NAME_ASC"},{"kind":"EnumValue","value":"LAST_NAME_ASC"},{"kind":"EnumValue","value":"ID_ASC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterByIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orFilter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentsFilter"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withEmployeeId"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"canSignOnBehalfOf"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"selectedUsers"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FIRST_NAME_ASC"},{"kind":"EnumValue","value":"LAST_NAME_ASC"},{"kind":"EnumValue","value":"ID_ASC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selected"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employeeId"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withEmployeeId"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<UsersInputFieldSearchQuery, UsersInputFieldSearchQueryVariables>;
export const DirectManagersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"directManagers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directManagers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<DirectManagersQuery, DirectManagersQueryVariables>;
export const AllDepartmentLeadersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allDepartmentLeaders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsersOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"isResigned"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"isLeader"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AllDepartmentLeadersQuery, AllDepartmentLeadersQueryVariables>;
export const GetDepartmentLeadersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDepartmentLeaders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDepartmentLeaders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<GetDepartmentLeadersQuery, GetDepartmentLeadersQueryVariables>;
export const GetDepartmentLeadersCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDepartmentLeadersCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDepartmentLeadersCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}]}}]} as unknown as DocumentNode<GetDepartmentLeadersCountQuery, GetDepartmentLeadersCountQueryVariables>;
export const AllUsersDepartmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allUsersDepartments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userDepartments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"department"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"employeeByUserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeIds"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"rankId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllUsersDepartmentsQuery, AllUsersDepartmentsQueryVariables>;
export const UserSettingByKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userSettingByKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSettingKey"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSettingByUserIdAndKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<UserSettingByKeyQuery, UserSettingByKeyQueryVariables>;
export const ValidateEmailAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"validateEmailAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateEmailAvailability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<ValidateEmailAvailabilityQuery, ValidateEmailAvailabilityQueryVariables>;
export const UsersBasicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"usersBasic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FIRST_NAME_ASC"},{"kind":"EnumValue","value":"LAST_NAME_ASC"},{"kind":"EnumValue","value":"ID_ASC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<UsersBasicQuery, UsersBasicQueryVariables>;
export const UsersFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"usersFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FIRST_NAME_ASC"},{"kind":"EnumValue","value":"LAST_NAME_ASC"},{"kind":"EnumValue","value":"ID_ASC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UsersFilterQuery, UsersFilterQueryVariables>;
export const SuperUserLoginNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"superUserLoginNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SuperUserLoginNotesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"superUserLoginNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"superUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<SuperUserLoginNotesQuery, SuperUserLoginNotesQueryVariables>;
export const VacationTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"vacationTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VacationTypesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"VacationTypeFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vacationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"absenceCode"}},{"kind":"Field","name":{"kind":"Name","value":"quickAction"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"sendCalendarInvite"}}]}}]} as unknown as DocumentNode<VacationTypesQuery, VacationTypesQueryVariables>;
export const VacationTypeByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"vacationTypeById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vacationTypeById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationType"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"absenceCode"}},{"kind":"Field","name":{"kind":"Name","value":"quickAction"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"sendCalendarInvite"}}]}}]} as unknown as DocumentNode<VacationTypeByIdQuery, VacationTypeByIdQueryVariables>;
export const VacationUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"vacationUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VacationUsersOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"VacationUserFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vacationUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationUser"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"absenceCode"}},{"kind":"Field","name":{"kind":"Name","value":"quickAction"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"sendCalendarInvite"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vacationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"vacationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allDay"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"durationDays"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creatorUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalId"}}]}}]} as unknown as DocumentNode<VacationUsersQuery, VacationUsersQueryVariables>;
export const VacationUserByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"vacationUserById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vacationUserById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationUser"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"departments"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"localizedName"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"absenceCode"}},{"kind":"Field","name":{"kind":"Name","value":"quickAction"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mustBeApproved"}},{"kind":"Field","name":{"kind":"Name","value":"approverUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverSystemFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"approverFormFieldIds"}},{"kind":"Field","name":{"kind":"Name","value":"sendCalendarInvite"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VacationUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VacationUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vacationTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"vacationType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VacationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allDay"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"durationDays"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"departmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenApproved"}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenDenied"}},{"kind":"Field","name":{"kind":"Name","value":"lastProcessedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creatorUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalId"}}]}}]} as unknown as DocumentNode<VacationUserByIdQuery, VacationUserByIdQueryVariables>;
export const ExportVacationToExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"exportVacationToExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vacationTypeIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeWeekends"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeHolidays"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"holidayCountry"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeApprovedAbsence"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeUnapprovedAbsence"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeRejectedAbsence"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupedByEmployee"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"systemFields"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formFields"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportVacationToExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"vacationTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vacationTypeIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeWeekends"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeWeekends"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeHolidays"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeHolidays"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"holidayCountry"},"value":{"kind":"Variable","name":{"kind":"Name","value":"holidayCountry"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeApprovedAbsence"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeApprovedAbsence"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeUnapprovedAbsence"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeUnapprovedAbsence"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeRejectedAbsence"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeRejectedAbsence"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"groupedByEmployee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupedByEmployee"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"systemFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"systemFields"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"formFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formFields"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]} as unknown as DocumentNode<ExportVacationToExcelQuery, ExportVacationToExcelQueryVariables>;
export const GetSupportedHolidayCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSupportedHolidayCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSupportedHolidayCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"}}]}}]}}]} as unknown as DocumentNode<GetSupportedHolidayCountriesQuery, GetSupportedHolidayCountriesQueryVariables>;
export const GetGeneralHolidaysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getGeneralHolidays"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getGeneralHolidays"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"holidays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetGeneralHolidaysQuery, GetGeneralHolidaysQueryVariables>;
export const OnAsyncJobUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnAsyncJobUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asyncJobId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asyncJobUpdated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asyncJobId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asyncJobId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asyncJobItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"messageVariables"}},{"kind":"Field","name":{"kind":"Name","value":"tabulation"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]} as unknown as DocumentNode<OnAsyncJobUpdateSubscription, OnAsyncJobUpdateSubscriptionVariables>;
export const OnTimeRegistrationUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnTimeRegistrationUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistrationUpdated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRegistration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<OnTimeRegistrationUpdateSubscription, OnTimeRegistrationUpdateSubscriptionVariables>;